[
  {
    "id": "127",
    "name": "127",
    "x": -18.661,
    "y": -3.29,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0019722,
      "w": 1.0
    },
    "layers": []
  },
  {
    "id": "128",
    "name": "128",
    "x": -12.201,
    "y": 2.772,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": 5.236E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 45,
      "shelfCategory": "PASTA"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d599",
        "height": 0.22631,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d835a",
            "leftCorner": {
              "x": -12.201,
              "y": 2.878,
              "z": 0.185
            },
            "rightCorner": {
              "x": -12.271,
              "y": 2.878,
              "z": 0.185
            },
            "gtin": "7613037683660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d835b",
            "leftCorner": {
              "x": -12.271,
              "y": 2.878,
              "z": 0.185
            },
            "rightCorner": {
              "x": -12.341,
              "y": 2.878,
              "z": 0.185
            },
            "gtin": "7613037683660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d835c",
            "leftCorner": {
              "x": -12.341,
              "y": 2.878,
              "z": 0.185
            },
            "rightCorner": {
              "x": -12.411,
              "y": 2.878,
              "z": 0.185
            },
            "gtin": "7613037683660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d835e",
            "leftCorner": {
              "x": -12.412,
              "y": 2.842,
              "z": 0.185
            },
            "rightCorner": {
              "x": -12.592,
              "y": 2.843,
              "z": 0.185
            },
            "gtin": "7613036683371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d835f",
            "leftCorner": {
              "x": -12.592,
              "y": 2.843,
              "z": 0.185
            },
            "rightCorner": {
              "x": -12.798,
              "y": 2.843,
              "z": 0.185
            },
            "gtin": "7613036679978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8360",
            "leftCorner": {
              "x": -12.798,
              "y": 2.839,
              "z": 0.185
            },
            "rightCorner": {
              "x": -12.988,
              "y": 2.84,
              "z": 0.185
            },
            "gtin": "7613035897427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8361",
            "leftCorner": {
              "x": -12.988,
              "y": 2.834,
              "z": 0.185
            },
            "rightCorner": {
              "x": -13.142,
              "y": 2.834,
              "z": 0.185
            },
            "gtin": "7613035890008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8362",
            "leftCorner": {
              "x": -13.142,
              "y": 2.839,
              "z": 0.185
            },
            "rightCorner": {
              "x": -13.311,
              "y": 2.839,
              "z": 0.185
            },
            "gtin": "7613030700067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d835d",
            "leftCorner": {
              "x": -13.311,
              "y": 2.83,
              "z": 0.185
            },
            "rightCorner": {
              "x": -13.452,
              "y": 2.83,
              "z": 0.185
            },
            "gtin": "7613035890909",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d596",
        "height": 0.50181,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8341",
            "leftCorner": {
              "x": -12.201,
              "y": 2.824,
              "z": 0.411
            },
            "rightCorner": {
              "x": -12.35,
              "y": 2.824,
              "z": 0.411
            },
            "gtin": "8445291293250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8343",
            "leftCorner": {
              "x": -12.35,
              "y": 2.796,
              "z": 0.411
            },
            "rightCorner": {
              "x": -12.488,
              "y": 2.796,
              "z": 0.411
            },
            "gtin": "8445291292970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8344",
            "leftCorner": {
              "x": -12.488,
              "y": 2.794,
              "z": 0.411
            },
            "rightCorner": {
              "x": -12.621,
              "y": 2.794,
              "z": 0.411
            },
            "gtin": "8445291293229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8345",
            "leftCorner": {
              "x": -12.62,
              "y": 2.787,
              "z": 0.411
            },
            "rightCorner": {
              "x": -12.814,
              "y": 2.787,
              "z": 0.411
            },
            "gtin": "4820179258523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8346",
            "leftCorner": {
              "x": -12.814,
              "y": 2.778,
              "z": 0.411
            },
            "rightCorner": {
              "x": -13.039,
              "y": 2.778,
              "z": 0.411
            },
            "gtin": "4820179257496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8347",
            "leftCorner": {
              "x": -13.039,
              "y": 2.783,
              "z": 0.411
            },
            "rightCorner": {
              "x": -13.257,
              "y": 2.783,
              "z": 0.411
            },
            "gtin": "4820179257502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8342",
            "leftCorner": {
              "x": -13.258,
              "y": 2.778,
              "z": 0.411
            },
            "rightCorner": {
              "x": -13.451,
              "y": 2.778,
              "z": 0.411
            },
            "gtin": "4820179257519",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d59a",
        "height": 0.80171,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8363",
            "leftCorner": {
              "x": -12.201,
              "y": 2.819,
              "z": 0.656
            },
            "rightCorner": {
              "x": -12.432,
              "y": 2.819,
              "z": 0.656
            },
            "gtin": "5997523313159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8365",
            "leftCorner": {
              "x": -12.433,
              "y": 2.794,
              "z": 0.656
            },
            "rightCorner": {
              "x": -12.624,
              "y": 2.794,
              "z": 0.656
            },
            "gtin": "5997523313111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8366",
            "leftCorner": {
              "x": -12.624,
              "y": 2.788,
              "z": 0.656
            },
            "rightCorner": {
              "x": -12.727,
              "y": 2.788,
              "z": 0.656
            },
            "gtin": "5997523313135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8367",
            "leftCorner": {
              "x": -12.727,
              "y": 2.788,
              "z": 0.656
            },
            "rightCorner": {
              "x": -12.832,
              "y": 2.789,
              "z": 0.656
            },
            "gtin": "5997523313135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8368",
            "leftCorner": {
              "x": -12.831,
              "y": 2.78,
              "z": 0.656
            },
            "rightCorner": {
              "x": -12.941,
              "y": 2.78,
              "z": 0.656
            },
            "gtin": "5997523313234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8369",
            "leftCorner": {
              "x": -12.941,
              "y": 2.78,
              "z": 0.656
            },
            "rightCorner": {
              "x": -13.051,
              "y": 2.78,
              "z": 0.656
            },
            "gtin": "5997523313234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d836a",
            "leftCorner": {
              "x": -13.051,
              "y": 2.78,
              "z": 0.656
            },
            "rightCorner": {
              "x": -13.263,
              "y": 2.78,
              "z": 0.656
            },
            "gtin": "5997523317072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8364",
            "leftCorner": {
              "x": -13.263,
              "y": 2.779,
              "z": 0.656
            },
            "rightCorner": {
              "x": -13.451,
              "y": 2.779,
              "z": 0.656
            },
            "gtin": "5997523313005",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d598",
        "height": 1.1059,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8352",
            "leftCorner": {
              "x": -12.201,
              "y": 2.82,
              "z": 0.905
            },
            "rightCorner": {
              "x": -12.426,
              "y": 2.821,
              "z": 0.905
            },
            "gtin": "8710522627518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8354",
            "leftCorner": {
              "x": -12.426,
              "y": 2.796,
              "z": 0.905
            },
            "rightCorner": {
              "x": -12.63,
              "y": 2.796,
              "z": 0.905
            },
            "gtin": "8720182528780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8355",
            "leftCorner": {
              "x": -12.629,
              "y": 2.79,
              "z": 0.905
            },
            "rightCorner": {
              "x": -12.84,
              "y": 2.79,
              "z": 0.905
            },
            "gtin": "8710522627433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8356",
            "leftCorner": {
              "x": -12.839,
              "y": 2.782,
              "z": 0.905
            },
            "rightCorner": {
              "x": -13.053,
              "y": 2.782,
              "z": 0.905
            },
            "gtin": "8710522627594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8357",
            "leftCorner": {
              "x": -13.053,
              "y": 2.781,
              "z": 0.905
            },
            "rightCorner": {
              "x": -13.148,
              "y": 2.781,
              "z": 0.905
            },
            "gtin": "8720182777386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8358",
            "leftCorner": {
              "x": -13.148,
              "y": 2.778,
              "z": 0.905
            },
            "rightCorner": {
              "x": -13.244,
              "y": 2.778,
              "z": 0.905
            },
            "gtin": "7613036480505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8359",
            "leftCorner": {
              "x": -13.244,
              "y": 2.781,
              "z": 0.905
            },
            "rightCorner": {
              "x": -13.346,
              "y": 2.781,
              "z": 0.905
            },
            "gtin": "7613036480468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8353",
            "leftCorner": {
              "x": -13.346,
              "y": 2.776,
              "z": 0.905
            },
            "rightCorner": {
              "x": -13.451,
              "y": 2.776,
              "z": 0.905
            },
            "gtin": "5997523324278",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d59b",
        "height": 1.4092,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d836b",
            "leftCorner": {
              "x": -12.201,
              "y": 2.831,
              "z": 1.153
            },
            "rightCorner": {
              "x": -12.536,
              "y": 2.831,
              "z": 1.153
            },
            "gtin": "5901384503635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d836c",
            "leftCorner": {
              "x": -12.536,
              "y": 2.831,
              "z": 1.153
            },
            "rightCorner": {
              "x": -12.872,
              "y": 2.831,
              "z": 1.153
            },
            "gtin": "5901384503635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d836d",
            "leftCorner": {
              "x": -12.872,
              "y": 2.791,
              "z": 1.153
            },
            "rightCorner": {
              "x": -13.162,
              "y": 2.792,
              "z": 1.153
            },
            "gtin": "5901384503642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d836e",
            "leftCorner": {
              "x": -13.162,
              "y": 2.792,
              "z": 1.153
            },
            "rightCorner": {
              "x": -13.452,
              "y": 2.792,
              "z": 1.153
            },
            "gtin": "5901384503642",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d597",
        "height": 1.7062,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8348",
            "leftCorner": {
              "x": -12.201,
              "y": 2.825,
              "z": 1.396
            },
            "rightCorner": {
              "x": -12.343,
              "y": 2.825,
              "z": 1.396
            },
            "gtin": "8852018101017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d834a",
            "leftCorner": {
              "x": -12.344,
              "y": 2.798,
              "z": 1.396
            },
            "rightCorner": {
              "x": -12.462,
              "y": 2.798,
              "z": 1.396
            },
            "gtin": "8852018101055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d834b",
            "leftCorner": {
              "x": -12.462,
              "y": 2.796,
              "z": 1.396
            },
            "rightCorner": {
              "x": -12.56,
              "y": 2.796,
              "z": 1.396
            },
            "gtin": "8852018101062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d834c",
            "leftCorner": {
              "x": -12.56,
              "y": 2.795,
              "z": 1.396
            },
            "rightCorner": {
              "x": -12.677,
              "y": 2.795,
              "z": 1.396
            },
            "gtin": "8852018101154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d834d",
            "leftCorner": {
              "x": -12.676,
              "y": 2.789,
              "z": 1.396
            },
            "rightCorner": {
              "x": -12.794,
              "y": 2.79,
              "z": 1.396
            },
            "gtin": "8852018101031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d834e",
            "leftCorner": {
              "x": -12.793,
              "y": 2.786,
              "z": 1.396
            },
            "rightCorner": {
              "x": -12.91,
              "y": 2.786,
              "z": 1.396
            },
            "gtin": "8852018101024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d834f",
            "leftCorner": {
              "x": -12.91,
              "y": 2.785,
              "z": 1.396
            },
            "rightCorner": {
              "x": -13.035,
              "y": 2.785,
              "z": 1.396
            },
            "gtin": "8852018201052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8350",
            "leftCorner": {
              "x": -13.035,
              "y": 2.782,
              "z": 1.396
            },
            "rightCorner": {
              "x": -13.123,
              "y": 2.782,
              "z": 1.396
            },
            "gtin": "8852018201144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8351",
            "leftCorner": {
              "x": -13.123,
              "y": 2.783,
              "z": 1.396
            },
            "rightCorner": {
              "x": -13.308,
              "y": 2.783,
              "z": 1.396
            },
            "gtin": "8801073116467",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d8349",
            "leftCorner": {
              "x": -13.308,
              "y": 2.778,
              "z": 1.396
            },
            "rightCorner": {
              "x": -13.451,
              "y": 2.779,
              "z": 1.396
            },
            "gtin": "8801073211254",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d59c",
        "height": 1.9628,
        "facings": []
      }
    ]
  },
  {
    "id": "2d5",
    "name": "2d5",
    "x": -14.854,
    "y": 0.987,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71147,
      "w": 0.70272
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5cd",
        "height": 0.17072,
        "facings": [
          {
            "id": "a8af7c177134d8b33cf2bc65",
            "leftCorner": {
              "x": -14.787,
              "y": 0.988,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.788,
              "y": 1.079,
              "z": 0.14
            },
            "gtin": "41002407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "128f224b6d440717828012cb",
            "leftCorner": {
              "x": -14.788,
              "y": 1.079,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.789,
              "y": 1.176,
              "z": 0.14
            },
            "gtin": "8710236091056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b5589e1acb996d1af8ee5277",
            "leftCorner": {
              "x": -14.789,
              "y": 1.176,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.791,
              "y": 1.285,
              "z": 0.14
            },
            "gtin": "4000186035809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6d03b1651c48a01ad127439d",
            "leftCorner": {
              "x": -14.791,
              "y": 1.285,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.792,
              "y": 1.397,
              "z": 0.14
            },
            "gtin": "40354064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1d897537069a80ea5592fce5",
            "leftCorner": {
              "x": -14.792,
              "y": 1.397,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.794,
              "y": 1.524,
              "z": 0.14
            },
            "gtin": "41002445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "384f2621f7e799531a5d28f8",
            "leftCorner": {
              "x": -14.794,
              "y": 1.524,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.796,
              "y": 1.68,
              "z": 0.14
            },
            "gtin": "4013200465322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "557a981f22a21ee021af6254",
            "leftCorner": {
              "x": -14.796,
              "y": 1.68,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.798,
              "y": 1.838,
              "z": 0.14
            },
            "gtin": "4013200465315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f1a8ba899b8d5ab07cee4be0",
            "leftCorner": {
              "x": -14.798,
              "y": 1.838,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.8,
              "y": 2.001,
              "z": 0.14
            },
            "gtin": "41002469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d6fb5a3e5edfa2b6122b9a82",
            "leftCorner": {
              "x": -14.8,
              "y": 2.001,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.802,
              "y": 2.222,
              "z": 0.14
            },
            "gtin": "4003473020502",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5ca",
        "height": 0.42861,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8498",
            "leftCorner": {
              "x": -14.871,
              "y": 0.987,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.871,
              "y": 1.015,
              "z": 0.351
            },
            "gtin": "4002834229202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8499",
            "leftCorner": {
              "x": -14.86,
              "y": 1.015,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.862,
              "y": 1.189,
              "z": 0.351
            },
            "gtin": "4002834229202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d849a",
            "leftCorner": {
              "x": -14.868,
              "y": 1.188,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.87,
              "y": 1.423,
              "z": 0.351
            },
            "gtin": "4002757010567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d849b",
            "leftCorner": {
              "x": -14.887,
              "y": 1.422,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.89,
              "y": 1.618,
              "z": 0.351
            },
            "gtin": "5762385061438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d849c",
            "leftCorner": {
              "x": -14.888,
              "y": 1.618,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.891,
              "y": 1.898,
              "z": 0.351
            },
            "gtin": "4002442200341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d849d",
            "leftCorner": {
              "x": -14.888,
              "y": 1.898,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.891,
              "y": 2.088,
              "z": 0.351
            },
            "gtin": "4003473020502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8492",
            "leftCorner": {
              "x": -14.885,
              "y": 2.089,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.887,
              "y": 2.237,
              "z": 0.351
            },
            "gtin": "4003473020601",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5cb",
        "height": 0.73019,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d84a5",
            "leftCorner": {
              "x": -14.863,
              "y": 0.987,
              "z": 0.597
            },
            "rightCorner": {
              "x": -14.863,
              "y": 1.021,
              "z": 0.597
            },
            "gtin": "4000186032204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84a6",
            "leftCorner": {
              "x": -14.852,
              "y": 1.021,
              "z": 0.597
            },
            "rightCorner": {
              "x": -14.856,
              "y": 1.302,
              "z": 0.597
            },
            "gtin": "4000186032204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84a7",
            "leftCorner": {
              "x": -14.872,
              "y": 1.302,
              "z": 0.597
            },
            "rightCorner": {
              "x": -14.875,
              "y": 1.579,
              "z": 0.597
            },
            "gtin": "4021600150106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84a8",
            "leftCorner": {
              "x": -14.879,
              "y": 1.579,
              "z": 0.597
            },
            "rightCorner": {
              "x": -14.882,
              "y": 1.845,
              "z": 0.597
            },
            "gtin": "4048952572097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d849f",
            "leftCorner": {
              "x": -14.88,
              "y": 1.845,
              "z": 0.597
            },
            "rightCorner": {
              "x": -14.885,
              "y": 2.237,
              "z": 0.597
            },
            "gtin": "4009176243132",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5cc",
        "height": 0.95705,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d84c0",
            "leftCorner": {
              "x": -14.874,
              "y": 1.254,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.876,
              "y": 1.443,
              "z": 0.783
            },
            "gtin": "41002445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84c1",
            "leftCorner": {
              "x": -14.885,
              "y": 1.443,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.888,
              "y": 1.664,
              "z": 0.783
            },
            "gtin": "41002414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84c2",
            "leftCorner": {
              "x": -14.891,
              "y": 1.664,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.892,
              "y": 1.748,
              "z": 0.783
            },
            "gtin": "41002407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84c3",
            "leftCorner": {
              "x": -14.878,
              "y": 1.748,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.879,
              "y": 1.808,
              "z": 0.783
            },
            "gtin": "41002476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84c4",
            "leftCorner": {
              "x": -14.879,
              "y": 1.808,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.88,
              "y": 1.867,
              "z": 0.783
            },
            "gtin": "41002476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84c5",
            "leftCorner": {
              "x": -14.879,
              "y": 1.867,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.881,
              "y": 1.957,
              "z": 0.783
            },
            "gtin": "4000186035809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84c6",
            "leftCorner": {
              "x": -14.884,
              "y": 1.957,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.887,
              "y": 2.13,
              "z": 0.783
            },
            "gtin": "41002469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84ba",
            "leftCorner": {
              "x": -14.877,
              "y": 2.13,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.878,
              "y": 2.237,
              "z": 0.783
            },
            "gtin": "4000186035618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4802605db1f1b30d183db22f",
            "leftCorner": {
              "x": -14.831,
              "y": 0.987,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.834,
              "y": 1.214,
              "z": 0.783
            },
            "gtin": "4003473017502",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5c9",
        "height": 1.2354,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d84b1",
            "leftCorner": {
              "x": -14.858,
              "y": 1.023,
              "z": 1.011
            },
            "rightCorner": {
              "x": -14.861,
              "y": 1.191,
              "z": 1.011
            },
            "gtin": "40354002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84b2",
            "leftCorner": {
              "x": -14.866,
              "y": 1.191,
              "z": 1.011
            },
            "rightCorner": {
              "x": -14.868,
              "y": 1.395,
              "z": 1.011
            },
            "gtin": "40354064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84b3",
            "leftCorner": {
              "x": -14.883,
              "y": 1.395,
              "z": 1.011
            },
            "rightCorner": {
              "x": -14.884,
              "y": 1.449,
              "z": 1.011
            },
            "gtin": "40354026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84b5",
            "leftCorner": {
              "x": -14.88,
              "y": 1.586,
              "z": 1.011
            },
            "rightCorner": {
              "x": -14.882,
              "y": 1.763,
              "z": 1.011
            },
            "gtin": "40354811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84b6",
            "leftCorner": {
              "x": -14.885,
              "y": 1.763,
              "z": 1.011
            },
            "rightCorner": {
              "x": -14.886,
              "y": 1.852,
              "z": 1.011
            },
            "gtin": "4000404113760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84b7",
            "leftCorner": {
              "x": -14.886,
              "y": 1.852,
              "z": 1.011
            },
            "rightCorner": {
              "x": -14.887,
              "y": 1.941,
              "z": 1.011
            },
            "gtin": "4000404113760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84b8",
            "leftCorner": {
              "x": -14.887,
              "y": 1.941,
              "z": 1.011
            },
            "rightCorner": {
              "x": -14.888,
              "y": 2.031,
              "z": 1.011
            },
            "gtin": "4000404113760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84aa",
            "leftCorner": {
              "x": -14.88,
              "y": 2.031,
              "z": 1.011
            },
            "rightCorner": {
              "x": -14.883,
              "y": 2.237,
              "z": 1.011
            },
            "gtin": "4000404113975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1fa9716f0f06ae93c1bf3114",
            "leftCorner": {
              "x": -14.839,
              "y": 1.45,
              "z": 1.011
            },
            "rightCorner": {
              "x": -14.84,
              "y": 1.561,
              "z": 1.011
            },
            "gtin": "40354064",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5c8",
        "height": 1.5376,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d848a",
            "leftCorner": {
              "x": -14.85,
              "y": 0.995,
              "z": 1.258
            },
            "rightCorner": {
              "x": -14.851,
              "y": 1.139,
              "z": 1.258
            },
            "gtin": "4013200465315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ca46568720135db7f99b17d5",
            "leftCorner": {
              "x": -14.829,
              "y": 1.368,
              "z": 1.258
            },
            "rightCorner": {
              "x": -14.831,
              "y": 1.533,
              "z": 1.258
            },
            "gtin": "8710236091131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d848b",
            "leftCorner": {
              "x": -14.855,
              "y": 1.139,
              "z": 1.258
            },
            "rightCorner": {
              "x": -14.857,
              "y": 1.308,
              "z": 1.258
            },
            "gtin": "4013200465322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d848c",
            "leftCorner": {
              "x": -14.869,
              "y": 1.308,
              "z": 1.258
            },
            "rightCorner": {
              "x": -14.87,
              "y": 1.367,
              "z": 1.258
            },
            "gtin": "8710236091063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d848e",
            "leftCorner": {
              "x": -14.877,
              "y": 1.535,
              "z": 1.258
            },
            "rightCorner": {
              "x": -14.881,
              "y": 1.87,
              "z": 1.258
            },
            "gtin": "8710236091049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d848f",
            "leftCorner": {
              "x": -14.874,
              "y": 1.877,
              "z": 1.258
            },
            "rightCorner": {
              "x": -14.877,
              "y": 2.076,
              "z": 1.258
            },
            "gtin": "8710236091056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8490",
            "leftCorner": {
              "x": -14.871,
              "y": 2.076,
              "z": 1.258
            },
            "rightCorner": {
              "x": -14.872,
              "y": 2.176,
              "z": 1.258
            },
            "gtin": "8710236091131",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "789"
  },
  {
    "id": "361",
    "name": "361",
    "x": -16.788,
    "y": -15.003,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70662,
      "w": 0.70759
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cef8",
        "height": 0.15179,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54c1",
            "leftCorner": {
              "x": -16.894,
              "y": -15.004,
              "z": 0.124
            },
            "rightCorner": {
              "x": -16.893,
              "y": -15.327,
              "z": 0.124
            },
            "gtin": "4251032608078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54c2",
            "leftCorner": {
              "x": -16.853,
              "y": -15.327,
              "z": 0.124
            },
            "rightCorner": {
              "x": -16.853,
              "y": -15.633,
              "z": 0.124
            },
            "gtin": "4032549041639",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cef7",
        "height": 0.75804,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54bd",
            "leftCorner": {
              "x": -16.864,
              "y": -15.004,
              "z": 0.62
            },
            "rightCorner": {
              "x": -16.863,
              "y": -15.31,
              "z": 0.62
            },
            "gtin": "8690804406614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0209ecdfb12560e2bb278257",
            "leftCorner": {
              "x": -16.864,
              "y": -15.31,
              "z": 0.62
            },
            "rightCorner": {
              "x": -16.863,
              "y": -15.478,
              "z": 0.62
            },
            "gtin": "8690804406515",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cef4",
        "height": 1.0188,
        "facings": [
          {
            "id": "68d8e508e1820c81800d549e",
            "leftCorner": {
              "x": -16.857,
              "y": -15.004,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.856,
              "y": -15.081,
              "z": 0.834
            },
            "gtin": "8690804028519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d549f",
            "leftCorner": {
              "x": -16.856,
              "y": -15.081,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.857,
              "y": -15.16,
              "z": 0.834
            },
            "gtin": "8690804028519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54a0",
            "leftCorner": {
              "x": -16.857,
              "y": -15.16,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.857,
              "y": -15.239,
              "z": 0.834
            },
            "gtin": "8690804028519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54a2",
            "leftCorner": {
              "x": -16.817,
              "y": -15.238,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.816,
              "y": -15.337,
              "z": 0.834
            },
            "gtin": "8690804407314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54a3",
            "leftCorner": {
              "x": -16.816,
              "y": -15.337,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.817,
              "y": -15.435,
              "z": 0.834
            },
            "gtin": "8690804407314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54a4",
            "leftCorner": {
              "x": -16.817,
              "y": -15.435,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.816,
              "y": -15.737,
              "z": 0.834
            },
            "gtin": "8690804407321",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cef5",
        "height": 1.3213,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54aa",
            "leftCorner": {
              "x": -16.856,
              "y": -15.004,
              "z": 1.081
            },
            "rightCorner": {
              "x": -16.855,
              "y": -15.249,
              "z": 1.081
            },
            "gtin": "5900397734401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54ac",
            "leftCorner": {
              "x": -16.815,
              "y": -15.249,
              "z": 1.081
            },
            "rightCorner": {
              "x": -16.815,
              "y": -15.68,
              "z": 1.081
            },
            "gtin": "5900397734357",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cef6",
        "height": 1.6231,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54b2",
            "leftCorner": {
              "x": -16.862,
              "y": -15.004,
              "z": 1.328
            },
            "rightCorner": {
              "x": -16.861,
              "y": -15.259,
              "z": 1.328
            },
            "gtin": "8690804410802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54b4",
            "leftCorner": {
              "x": -16.819,
              "y": -15.258,
              "z": 1.328
            },
            "rightCorner": {
              "x": -16.819,
              "y": -15.447,
              "z": 1.328
            },
            "gtin": "8690804413001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54b5",
            "leftCorner": {
              "x": -16.823,
              "y": -15.447,
              "z": 1.328
            },
            "rightCorner": {
              "x": -16.823,
              "y": -15.688,
              "z": 1.328
            },
            "gtin": "8690804411007",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "7ea"
  },
  {
    "id": "367",
    "name": "367",
    "x": -21.17,
    "y": -28.298,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7099,
      "w": 0.7043
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d259",
        "height": 0.22369,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b8a",
            "leftCorner": {
              "x": -21.305,
              "y": -28.299,
              "z": 0.183
            },
            "rightCorner": {
              "x": -21.31,
              "y": -27.525,
              "z": 0.183
            },
            "gtin": "4306188051695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b8b",
            "leftCorner": {
              "x": -21.35,
              "y": -27.525,
              "z": 0.183
            },
            "rightCorner": {
              "x": -21.354,
              "y": -27.05,
              "z": 0.183
            },
            "gtin": "4306188051732",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d258",
        "height": 0.65577,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b87",
            "leftCorner": {
              "x": -21.134,
              "y": -28.299,
              "z": 0.537
            },
            "rightCorner": {
              "x": -21.137,
              "y": -27.931,
              "z": 0.537
            },
            "gtin": "7322540788709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b88",
            "leftCorner": {
              "x": -21.137,
              "y": -27.931,
              "z": 0.537
            },
            "rightCorner": {
              "x": -21.14,
              "y": -27.564,
              "z": 0.537
            },
            "gtin": "7322540788709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b89",
            "leftCorner": {
              "x": -21.18,
              "y": -27.565,
              "z": 0.537
            },
            "rightCorner": {
              "x": -21.184,
              "y": -27.049,
              "z": 0.537
            },
            "gtin": "8004260450560",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d254",
        "height": 0.9576,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b7e",
            "leftCorner": {
              "x": -21.129,
              "y": -28.298,
              "z": 0.783
            },
            "rightCorner": {
              "x": -21.135,
              "y": -27.562,
              "z": 0.783
            },
            "gtin": "7322540786514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b7f",
            "leftCorner": {
              "x": -21.182,
              "y": -27.563,
              "z": 0.783
            },
            "rightCorner": {
              "x": -21.185,
              "y": -27.049,
              "z": 0.783
            },
            "gtin": "8004260450515",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d257",
        "height": 1.286,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b84",
            "leftCorner": {
              "x": -21.309,
              "y": -28.299,
              "z": 1.052
            },
            "rightCorner": {
              "x": -21.312,
              "y": -27.936,
              "z": 1.052
            },
            "gtin": "8053685271380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b86",
            "leftCorner": {
              "x": -21.177,
              "y": -27.935,
              "z": 1.052
            },
            "rightCorner": {
              "x": -21.179,
              "y": -27.577,
              "z": 1.052
            },
            "gtin": "8053853182333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b85",
            "leftCorner": {
              "x": -21.354,
              "y": -27.578,
              "z": 1.052
            },
            "rightCorner": {
              "x": -21.358,
              "y": -27.05,
              "z": 1.052
            },
            "gtin": "5029053001142",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d256",
        "height": 1.5619,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b80",
            "leftCorner": {
              "x": -21.127,
              "y": -28.298,
              "z": 1.278
            },
            "rightCorner": {
              "x": -21.129,
              "y": -28.092,
              "z": 1.278
            },
            "gtin": "7322541402826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b81",
            "leftCorner": {
              "x": -21.129,
              "y": -28.092,
              "z": 1.278
            },
            "rightCorner": {
              "x": -21.131,
              "y": -27.887,
              "z": 1.278
            },
            "gtin": "7322541402826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b83",
            "leftCorner": {
              "x": -21.167,
              "y": -27.887,
              "z": 1.278
            },
            "rightCorner": {
              "x": -21.17,
              "y": -27.5,
              "z": 1.278
            },
            "gtin": "4262419330482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b82",
            "leftCorner": {
              "x": -21.177,
              "y": -27.501,
              "z": 1.278
            },
            "rightCorner": {
              "x": -21.181,
              "y": -27.049,
              "z": 1.278
            },
            "gtin": "4306188051633",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "368",
    "name": "368",
    "x": -25.565,
    "y": -27.142,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.71015,
      "w": 0.70405
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d29d",
        "height": 0.24333,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d93",
            "leftCorner": {
              "x": -25.659,
              "y": -27.142,
              "z": 0.199
            },
            "rightCorner": {
              "x": -25.661,
              "y": -27.432,
              "z": 0.199
            },
            "gtin": "4003790011740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d95",
            "leftCorner": {
              "x": -25.63,
              "y": -27.432,
              "z": 0.199
            },
            "rightCorner": {
              "x": -25.633,
              "y": -27.712,
              "z": 0.199
            },
            "gtin": "4003790014468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d96",
            "leftCorner": {
              "x": -25.576,
              "y": -27.712,
              "z": 0.199
            },
            "rightCorner": {
              "x": -25.58,
              "y": -28.125,
              "z": 0.199
            },
            "gtin": "4306188029519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d94",
            "leftCorner": {
              "x": -25.628,
              "y": -28.125,
              "z": 0.199
            },
            "rightCorner": {
              "x": -25.63,
              "y": -28.392,
              "z": 0.199
            },
            "gtin": "4306188031932",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d29a",
        "height": 0.63244,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d81",
            "leftCorner": {
              "x": -25.605,
              "y": -27.142,
              "z": 0.517
            },
            "rightCorner": {
              "x": -25.609,
              "y": -27.642,
              "z": 0.517
            },
            "gtin": "4306188048961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d83",
            "leftCorner": {
              "x": -25.571,
              "y": -27.642,
              "z": 0.517
            },
            "rightCorner": {
              "x": -25.574,
              "y": -27.904,
              "z": 0.517
            },
            "gtin": "8720573214384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d84",
            "leftCorner": {
              "x": -25.57,
              "y": -27.904,
              "z": 0.517
            },
            "rightCorner": {
              "x": -25.572,
              "y": -28.261,
              "z": 0.517
            },
            "gtin": "4306188029472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d82",
            "leftCorner": {
              "x": -25.573,
              "y": -28.261,
              "z": 0.517
            },
            "rightCorner": {
              "x": -25.574,
              "y": -28.392,
              "z": 0.517
            },
            "gtin": "4003790104718",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d29c",
        "height": 0.98438,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d8c",
            "leftCorner": {
              "x": -25.61,
              "y": -27.142,
              "z": 0.805
            },
            "rightCorner": {
              "x": -25.612,
              "y": -27.292,
              "z": 0.805
            },
            "gtin": "4306188003977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d8d",
            "leftCorner": {
              "x": -25.612,
              "y": -27.292,
              "z": 0.805
            },
            "rightCorner": {
              "x": -25.613,
              "y": -27.443,
              "z": 0.805
            },
            "gtin": "4306188003977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d8f",
            "leftCorner": {
              "x": -25.573,
              "y": -27.443,
              "z": 0.805
            },
            "rightCorner": {
              "x": -25.575,
              "y": -27.729,
              "z": 0.805
            },
            "gtin": "8720573690416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d90",
            "leftCorner": {
              "x": -25.567,
              "y": -27.729,
              "z": 0.805
            },
            "rightCorner": {
              "x": -25.568,
              "y": -27.885,
              "z": 0.805
            },
            "gtin": "4008600090984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d91",
            "leftCorner": {
              "x": -25.577,
              "y": -27.885,
              "z": 0.805
            },
            "rightCorner": {
              "x": -25.578,
              "y": -28.004,
              "z": 0.805
            },
            "gtin": "4008600071082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d92",
            "leftCorner": {
              "x": -25.572,
              "y": -28.004,
              "z": 0.805
            },
            "rightCorner": {
              "x": -25.574,
              "y": -28.199,
              "z": 0.805
            },
            "gtin": "4008508463002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d8e",
            "leftCorner": {
              "x": -25.586,
              "y": -28.199,
              "z": 0.805
            },
            "rightCorner": {
              "x": -25.588,
              "y": -28.392,
              "z": 0.805
            },
            "gtin": "4003790001444",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d29b",
        "height": 1.313,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d85",
            "leftCorner": {
              "x": -25.61,
              "y": -27.142,
              "z": 1.074
            },
            "rightCorner": {
              "x": -25.611,
              "y": -27.19,
              "z": 1.074
            },
            "gtin": "2000439122135",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6d87",
            "leftCorner": {
              "x": -25.569,
              "y": -27.19,
              "z": 1.074
            },
            "rightCorner": {
              "x": -25.57,
              "y": -27.283,
              "z": 1.074
            },
            "gtin": "4012677133772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d88",
            "leftCorner": {
              "x": -25.573,
              "y": -27.283,
              "z": 1.074
            },
            "rightCorner": {
              "x": -25.576,
              "y": -27.561,
              "z": 1.074
            },
            "gtin": "4012677136247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d89",
            "leftCorner": {
              "x": -25.574,
              "y": -27.561,
              "z": 1.074
            },
            "rightCorner": {
              "x": -25.575,
              "y": -27.809,
              "z": 1.074
            },
            "gtin": "4051642010236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d8a",
            "leftCorner": {
              "x": -25.313,
              "y": -27.812,
              "z": 1.074
            },
            "rightCorner": {
              "x": -25.315,
              "y": -28.0,
              "z": 1.074
            },
            "gtin": "4051642010267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d8b",
            "leftCorner": {
              "x": -25.571,
              "y": -27.997,
              "z": 1.074
            },
            "rightCorner": {
              "x": -25.573,
              "y": -28.2,
              "z": 1.074
            },
            "gtin": "4044941002095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d86",
            "leftCorner": {
              "x": -25.586,
              "y": -28.2,
              "z": 1.074
            },
            "rightCorner": {
              "x": -25.588,
              "y": -28.392,
              "z": 1.074
            },
            "gtin": "4044941002101",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d29e",
        "height": 1.8857,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d97",
            "leftCorner": {
              "x": -25.478,
              "y": -27.142,
              "z": 1.543
            },
            "rightCorner": {
              "x": -25.483,
              "y": -27.678,
              "z": 1.543
            },
            "gtin": "4051642150321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d99",
            "leftCorner": {
              "x": -25.37,
              "y": -27.68,
              "z": 1.543
            },
            "rightCorner": {
              "x": -25.371,
              "y": -27.827,
              "z": 1.543
            },
            "gtin": "8001940003337",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6d9a",
            "leftCorner": {
              "x": -25.321,
              "y": -27.828,
              "z": 1.543
            },
            "rightCorner": {
              "x": -25.323,
              "y": -27.975,
              "z": 1.543
            },
            "gtin": "8001940003351",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6d9b",
            "leftCorner": {
              "x": -25.27,
              "y": -27.975,
              "z": 1.543
            },
            "rightCorner": {
              "x": -25.272,
              "y": -28.134,
              "z": 1.543
            },
            "gtin": "8001940003368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d9c",
            "leftCorner": {
              "x": -25.448,
              "y": -28.132,
              "z": 1.543
            },
            "rightCorner": {
              "x": -25.448,
              "y": -28.267,
              "z": 1.543
            },
            "gtin": "4003790006821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d98",
            "leftCorner": {
              "x": -25.453,
              "y": -28.267,
              "z": 1.543
            },
            "rightCorner": {
              "x": -25.455,
              "y": -28.393,
              "z": 1.543
            },
            "gtin": "4003790006838",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "369",
    "name": "369",
    "x": -23.731,
    "y": -27.114,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99986,
      "w": 0.016685
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 41,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d748",
        "height": 0.16042,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d37",
            "leftCorner": {
              "x": -23.733,
              "y": -27.051,
              "z": 0.131
            },
            "rightCorner": {
              "x": -23.793,
              "y": -27.052,
              "z": 0.131
            },
            "gtin": "4251758407054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d38",
            "leftCorner": {
              "x": -23.793,
              "y": -27.05,
              "z": 0.131
            },
            "rightCorner": {
              "x": -23.925,
              "y": -27.055,
              "z": 0.131
            },
            "gtin": "4251758407054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d39",
            "leftCorner": {
              "x": -23.925,
              "y": -27.056,
              "z": 0.131
            },
            "rightCorner": {
              "x": -24.046,
              "y": -27.061,
              "z": 0.131
            },
            "gtin": "4002448077640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d3a",
            "leftCorner": {
              "x": -24.046,
              "y": -27.062,
              "z": 0.131
            },
            "rightCorner": {
              "x": -24.202,
              "y": -27.066,
              "z": 0.131
            },
            "gtin": "4306188008651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d3b",
            "leftCorner": {
              "x": -24.202,
              "y": -27.067,
              "z": 0.131
            },
            "rightCorner": {
              "x": -24.387,
              "y": -27.074,
              "z": 0.131
            },
            "gtin": "4306188038023",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6d3c",
            "leftCorner": {
              "x": -24.387,
              "y": -27.075,
              "z": 0.131
            },
            "rightCorner": {
              "x": -24.579,
              "y": -27.082,
              "z": 0.131
            },
            "gtin": "4306188029045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d3d",
            "leftCorner": {
              "x": -24.579,
              "y": -27.086,
              "z": 0.131
            },
            "rightCorner": {
              "x": -24.723,
              "y": -27.091,
              "z": 0.131
            },
            "gtin": "4306188047117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d3e",
            "leftCorner": {
              "x": -24.723,
              "y": -27.091,
              "z": 0.131
            },
            "rightCorner": {
              "x": -24.865,
              "y": -27.096,
              "z": 0.131
            },
            "gtin": "4306188047117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d28",
            "leftCorner": {
              "x": -24.866,
              "y": -27.087,
              "z": 0.131
            },
            "rightCorner": {
              "x": -24.983,
              "y": -27.091,
              "z": 0.131
            },
            "gtin": "4306188049579",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d746",
        "height": 0.59352,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d1f",
            "leftCorner": {
              "x": -23.734,
              "y": -27.035,
              "z": 0.486
            },
            "rightCorner": {
              "x": -23.795,
              "y": -27.036,
              "z": 0.486
            },
            "gtin": "4001499944710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d20",
            "leftCorner": {
              "x": -23.795,
              "y": -27.044,
              "z": 0.486
            },
            "rightCorner": {
              "x": -23.95,
              "y": -27.049,
              "z": 0.486
            },
            "gtin": "4001499944710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d21",
            "leftCorner": {
              "x": -23.95,
              "y": -27.047,
              "z": 0.486
            },
            "rightCorner": {
              "x": -24.078,
              "y": -27.051,
              "z": 0.486
            },
            "gtin": "4001499944734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d22",
            "leftCorner": {
              "x": -24.078,
              "y": -27.047,
              "z": 0.486
            },
            "rightCorner": {
              "x": -24.184,
              "y": -27.051,
              "z": 0.486
            },
            "gtin": "4001499181085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d23",
            "leftCorner": {
              "x": -24.184,
              "y": -27.05,
              "z": 0.486
            },
            "rightCorner": {
              "x": -24.382,
              "y": -27.056,
              "z": 0.486
            },
            "gtin": "4016100621515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d24",
            "leftCorner": {
              "x": -24.375,
              "y": -27.243,
              "z": 0.486
            },
            "rightCorner": {
              "x": -24.541,
              "y": -27.248,
              "z": 0.486
            },
            "gtin": "4011200662901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d25",
            "leftCorner": {
              "x": -24.54,
              "y": -27.256,
              "z": 0.486
            },
            "rightCorner": {
              "x": -24.676,
              "y": -27.26,
              "z": 0.486
            },
            "gtin": "4011200652902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d26",
            "leftCorner": {
              "x": -24.676,
              "y": -27.26,
              "z": 0.486
            },
            "rightCorner": {
              "x": -24.813,
              "y": -27.265,
              "z": 0.486
            },
            "gtin": "4011200652902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d10",
            "leftCorner": {
              "x": -24.82,
              "y": -27.064,
              "z": 0.486
            },
            "rightCorner": {
              "x": -24.983,
              "y": -27.07,
              "z": 0.486
            },
            "gtin": "8710908175824",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d747",
        "height": 0.93359,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d51",
            "leftCorner": {
              "x": -23.733,
              "y": -27.055,
              "z": 0.764
            },
            "rightCorner": {
              "x": -23.793,
              "y": -27.057,
              "z": 0.764
            },
            "gtin": "4001499961465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d52",
            "leftCorner": {
              "x": -23.793,
              "y": -27.053,
              "z": 0.764
            },
            "rightCorner": {
              "x": -23.924,
              "y": -27.058,
              "z": 0.764
            },
            "gtin": "4001499961465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d53",
            "leftCorner": {
              "x": -23.924,
              "y": -27.064,
              "z": 0.764
            },
            "rightCorner": {
              "x": -24.105,
              "y": -27.07,
              "z": 0.764
            },
            "gtin": "4001499960161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d54",
            "leftCorner": {
              "x": -24.105,
              "y": -27.067,
              "z": 0.764
            },
            "rightCorner": {
              "x": -24.312,
              "y": -27.074,
              "z": 0.764
            },
            "gtin": "4001499960178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d55",
            "leftCorner": {
              "x": -24.312,
              "y": -27.073,
              "z": 0.764
            },
            "rightCorner": {
              "x": -24.578,
              "y": -27.082,
              "z": 0.764
            },
            "gtin": "8714789952543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d56",
            "leftCorner": {
              "x": -24.578,
              "y": -27.09,
              "z": 0.764
            },
            "rightCorner": {
              "x": -24.648,
              "y": -27.093,
              "z": 0.764
            },
            "gtin": "4251758404183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d57",
            "leftCorner": {
              "x": -24.648,
              "y": -27.093,
              "z": 0.764
            },
            "rightCorner": {
              "x": -24.718,
              "y": -27.095,
              "z": 0.764
            },
            "gtin": "4251758404183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d58",
            "leftCorner": {
              "x": -24.718,
              "y": -27.095,
              "z": 0.764
            },
            "rightCorner": {
              "x": -24.789,
              "y": -27.098,
              "z": 0.764
            },
            "gtin": "4251758404183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d41",
            "leftCorner": {
              "x": -24.79,
              "y": -27.087,
              "z": 0.764
            },
            "rightCorner": {
              "x": -24.983,
              "y": -27.093,
              "z": 0.764
            },
            "gtin": "4015200035437",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d744",
        "height": 1.2863,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8876",
            "leftCorner": {
              "x": -23.734,
              "y": -27.014,
              "z": 1.052
            },
            "rightCorner": {
              "x": -23.983,
              "y": -27.023,
              "z": 1.052
            },
            "gtin": "4016100494812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8878",
            "leftCorner": {
              "x": -23.981,
              "y": -27.061,
              "z": 1.052
            },
            "rightCorner": {
              "x": -24.175,
              "y": -27.067,
              "z": 1.052
            },
            "gtin": "4001499961502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8879",
            "leftCorner": {
              "x": -24.175,
              "y": -27.072,
              "z": 1.052
            },
            "rightCorner": {
              "x": -24.288,
              "y": -27.075,
              "z": 1.052
            },
            "gtin": "4001499926143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d887a",
            "leftCorner": {
              "x": -24.288,
              "y": -27.072,
              "z": 1.052
            },
            "rightCorner": {
              "x": -24.405,
              "y": -27.077,
              "z": 1.052
            },
            "gtin": "8700216663854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d887b",
            "leftCorner": {
              "x": -24.405,
              "y": -27.077,
              "z": 1.052
            },
            "rightCorner": {
              "x": -24.634,
              "y": -27.084,
              "z": 1.052
            },
            "gtin": "8700216663823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d887c",
            "leftCorner": {
              "x": -24.634,
              "y": -27.088,
              "z": 1.052
            },
            "rightCorner": {
              "x": -24.823,
              "y": -27.094,
              "z": 1.052
            },
            "gtin": "8700216661584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8877",
            "leftCorner": {
              "x": -24.824,
              "y": -27.087,
              "z": 1.052
            },
            "rightCorner": {
              "x": -24.983,
              "y": -27.092,
              "z": 1.052
            },
            "gtin": "8700216624688",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d745",
        "height": 1.7358,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d75",
            "leftCorner": {
              "x": -23.845,
              "y": -27.056,
              "z": 1.42
            },
            "rightCorner": {
              "x": -23.955,
              "y": -27.06,
              "z": 1.42
            },
            "gtin": "4306188421450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d76",
            "leftCorner": {
              "x": -23.955,
              "y": -27.064,
              "z": 1.42
            },
            "rightCorner": {
              "x": -24.117,
              "y": -27.069,
              "z": 1.42
            },
            "gtin": "4015000019040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d77",
            "leftCorner": {
              "x": -24.117,
              "y": -27.068,
              "z": 1.42
            },
            "rightCorner": {
              "x": -24.365,
              "y": -27.076,
              "z": 1.42
            },
            "gtin": "4251758404060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d78",
            "leftCorner": {
              "x": -24.365,
              "y": -27.074,
              "z": 1.42
            },
            "rightCorner": {
              "x": -24.553,
              "y": -27.08,
              "z": 1.42
            },
            "gtin": "4015000970921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d79",
            "leftCorner": {
              "x": -24.553,
              "y": -27.082,
              "z": 1.42
            },
            "rightCorner": {
              "x": -24.68,
              "y": -27.087,
              "z": 1.42
            },
            "gtin": "4008455029719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d7a",
            "leftCorner": {
              "x": -24.68,
              "y": -27.086,
              "z": 1.42
            },
            "rightCorner": {
              "x": -24.934,
              "y": -27.094,
              "z": 1.42
            },
            "gtin": "4003364281807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d62",
            "leftCorner": {
              "x": -24.934,
              "y": -27.083,
              "z": 1.42
            },
            "rightCorner": {
              "x": -24.983,
              "y": -27.085,
              "z": 1.42
            },
            "gtin": "5413149135611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a98fd176bfad9a90b77380ad",
            "leftCorner": {
              "x": -23.734,
              "y": -27.015,
              "z": 1.42
            },
            "rightCorner": {
              "x": -23.818,
              "y": -27.018,
              "z": 1.42
            },
            "gtin": "4002448006473",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "36a"
  },
  {
    "id": "36a",
    "name": "36a",
    "x": -22.735,
    "y": -27.072,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99975,
      "w": 0.022452
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 41,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d295",
        "height": 0.15995,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d30",
            "leftCorner": {
              "x": -22.885,
              "y": -27.016,
              "z": 0.131
            },
            "rightCorner": {
              "x": -22.974,
              "y": -27.02,
              "z": 0.131
            },
            "gtin": "4306188050414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "960e6758fccbf9a239b40ff3",
            "leftCorner": {
              "x": -22.74,
              "y": -26.972,
              "z": 0.131
            },
            "rightCorner": {
              "x": -22.878,
              "y": -26.978,
              "z": 0.131
            },
            "gtin": "4015000010320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d31",
            "leftCorner": {
              "x": -22.974,
              "y": -27.02,
              "z": 0.131
            },
            "rightCorner": {
              "x": -23.064,
              "y": -27.024,
              "z": 0.131
            },
            "gtin": "4306188050414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d32",
            "leftCorner": {
              "x": -23.064,
              "y": -27.026,
              "z": 0.131
            },
            "rightCorner": {
              "x": -23.2,
              "y": -27.033,
              "z": 0.131
            },
            "gtin": "4015000010320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d33",
            "leftCorner": {
              "x": -23.2,
              "y": -27.035,
              "z": 0.131
            },
            "rightCorner": {
              "x": -23.375,
              "y": -27.043,
              "z": 0.131
            },
            "gtin": "8700216717779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d34",
            "leftCorner": {
              "x": -23.375,
              "y": -27.041,
              "z": 0.131
            },
            "rightCorner": {
              "x": -23.49,
              "y": -27.047,
              "z": 0.131
            },
            "gtin": "8700216717748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d35",
            "leftCorner": {
              "x": -23.49,
              "y": -27.046,
              "z": 0.131
            },
            "rightCorner": {
              "x": -23.617,
              "y": -27.051,
              "z": 0.131
            },
            "gtin": "8001841276113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d36",
            "leftCorner": {
              "x": -23.617,
              "y": -27.05,
              "z": 0.131
            },
            "rightCorner": {
              "x": -23.737,
              "y": -27.056,
              "z": 0.131
            },
            "gtin": "5410076545353",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d292",
        "height": 0.59179,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d17",
            "leftCorner": {
              "x": -22.804,
              "y": -26.993,
              "z": 0.484
            },
            "rightCorner": {
              "x": -22.919,
              "y": -26.998,
              "z": 0.484
            },
            "gtin": "5000204096927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "64583a8d07d6ec6e24a0d477",
            "leftCorner": {
              "x": -22.741,
              "y": -26.951,
              "z": 0.484
            },
            "rightCorner": {
              "x": -22.805,
              "y": -26.954,
              "z": 0.484
            },
            "gtin": "4306188047797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d18",
            "leftCorner": {
              "x": -22.919,
              "y": -26.996,
              "z": 0.484
            },
            "rightCorner": {
              "x": -23.099,
              "y": -27.005,
              "z": 0.484
            },
            "gtin": "4306188031550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d19",
            "leftCorner": {
              "x": -23.099,
              "y": -27.009,
              "z": 0.484
            },
            "rightCorner": {
              "x": -23.199,
              "y": -27.013,
              "z": 0.484
            },
            "gtin": "4306188047797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d1a",
            "leftCorner": {
              "x": -23.199,
              "y": -27.013,
              "z": 0.484
            },
            "rightCorner": {
              "x": -23.299,
              "y": -27.018,
              "z": 0.484
            },
            "gtin": "4306188047797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d1b",
            "leftCorner": {
              "x": -23.299,
              "y": -27.02,
              "z": 0.484
            },
            "rightCorner": {
              "x": -23.446,
              "y": -27.026,
              "z": 0.484
            },
            "gtin": "5000204147018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d1c",
            "leftCorner": {
              "x": -23.446,
              "y": -27.023,
              "z": 0.484
            },
            "rightCorner": {
              "x": -23.529,
              "y": -27.027,
              "z": 0.484
            },
            "gtin": "5000204150735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d1d",
            "leftCorner": {
              "x": -23.529,
              "y": -27.027,
              "z": 0.484
            },
            "rightCorner": {
              "x": -23.612,
              "y": -27.031,
              "z": 0.484
            },
            "gtin": "5000204150735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d1e",
            "leftCorner": {
              "x": -23.612,
              "y": -27.028,
              "z": 0.484
            },
            "rightCorner": {
              "x": -23.738,
              "y": -27.034,
              "z": 0.484
            },
            "gtin": "4001499969270",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d296",
        "height": 0.93137,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d4b",
            "leftCorner": {
              "x": -22.823,
              "y": -27.011,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.013,
              "y": -27.02,
              "z": 0.762
            },
            "gtin": "8720182302526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "04487a82dfb23b54c94be2ee",
            "leftCorner": {
              "x": -22.739,
              "y": -26.977,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.817,
              "y": -26.981,
              "z": 0.762
            },
            "gtin": "4306188031529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d4c",
            "leftCorner": {
              "x": -23.013,
              "y": -27.025,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.215,
              "y": -27.035,
              "z": 0.762
            },
            "gtin": "8720182315182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d4d",
            "leftCorner": {
              "x": -23.203,
              "y": -27.287,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.323,
              "y": -27.293,
              "z": 0.762
            },
            "gtin": "4306188031529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d4e",
            "leftCorner": {
              "x": -23.323,
              "y": -27.293,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.443,
              "y": -27.298,
              "z": 0.762
            },
            "gtin": "4306188031529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d4f",
            "leftCorner": {
              "x": -23.455,
              "y": -27.049,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.626,
              "y": -27.057,
              "z": 0.762
            },
            "gtin": "8720182777171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d50",
            "leftCorner": {
              "x": -23.626,
              "y": -27.058,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.736,
              "y": -27.063,
              "z": 0.762
            },
            "gtin": "4001499959592",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d299",
        "height": 1.2996,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d7b",
            "leftCorner": {
              "x": -22.736,
              "y": -27.059,
              "z": 1.063
            },
            "rightCorner": {
              "x": -22.898,
              "y": -27.066,
              "z": 1.063
            },
            "gtin": "4015000971157",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6d7d",
            "leftCorner": {
              "x": -22.886,
              "y": -27.316,
              "z": 1.063
            },
            "rightCorner": {
              "x": -22.977,
              "y": -27.32,
              "z": 1.063
            },
            "gtin": "4015000314886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d7e",
            "leftCorner": {
              "x": -22.99,
              "y": -27.025,
              "z": 1.063
            },
            "rightCorner": {
              "x": -23.201,
              "y": -27.034,
              "z": 1.063
            },
            "gtin": "4015000314886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d7f",
            "leftCorner": {
              "x": -23.193,
              "y": -27.232,
              "z": 1.063
            },
            "rightCorner": {
              "x": -23.403,
              "y": -27.241,
              "z": 1.063
            },
            "gtin": "4015200035390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d80",
            "leftCorner": {
              "x": -23.403,
              "y": -27.242,
              "z": 1.063
            },
            "rightCorner": {
              "x": -23.623,
              "y": -27.252,
              "z": 1.063
            },
            "gtin": "4015200035383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d7c",
            "leftCorner": {
              "x": -23.628,
              "y": -27.139,
              "z": 1.063
            },
            "rightCorner": {
              "x": -23.733,
              "y": -27.144,
              "z": 1.063
            },
            "gtin": "4015200035406",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d291",
        "height": 1.7342,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d6a",
            "leftCorner": {
              "x": -22.79,
              "y": -27.007,
              "z": 1.419
            },
            "rightCorner": {
              "x": -22.876,
              "y": -27.011,
              "z": 1.419
            },
            "gtin": "4062196082884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2be2007f785f557472366d64",
            "leftCorner": {
              "x": -22.74,
              "y": -26.975,
              "z": 1.419
            },
            "rightCorner": {
              "x": -22.78,
              "y": -26.977,
              "z": 1.419
            },
            "gtin": "4052400033634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d6b",
            "leftCorner": {
              "x": -22.876,
              "y": -27.012,
              "z": 1.419
            },
            "rightCorner": {
              "x": -22.932,
              "y": -27.015,
              "z": 1.419
            },
            "gtin": "4052400033634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d6c",
            "leftCorner": {
              "x": -22.932,
              "y": -27.015,
              "z": 1.419
            },
            "rightCorner": {
              "x": -22.987,
              "y": -27.017,
              "z": 1.419
            },
            "gtin": "4052400033634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d6d",
            "leftCorner": {
              "x": -22.986,
              "y": -27.02,
              "z": 1.419
            },
            "rightCorner": {
              "x": -23.076,
              "y": -27.024,
              "z": 1.419
            },
            "gtin": "4062196125598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d6e",
            "leftCorner": {
              "x": -23.077,
              "y": -27.027,
              "z": 1.419
            },
            "rightCorner": {
              "x": -23.185,
              "y": -27.032,
              "z": 1.419
            },
            "gtin": "7610243002667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d6f",
            "leftCorner": {
              "x": -23.185,
              "y": -27.035,
              "z": 1.419
            },
            "rightCorner": {
              "x": -23.279,
              "y": -27.039,
              "z": 1.419
            },
            "gtin": "4052400033641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d70",
            "leftCorner": {
              "x": -23.279,
              "y": -27.04,
              "z": 1.419
            },
            "rightCorner": {
              "x": -23.428,
              "y": -27.048,
              "z": 1.419
            },
            "gtin": "4052400033610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d71",
            "leftCorner": {
              "x": -23.428,
              "y": -27.047,
              "z": 1.419
            },
            "rightCorner": {
              "x": -23.536,
              "y": -27.052,
              "z": 1.419
            },
            "gtin": "4306188419686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d72",
            "leftCorner": {
              "x": -23.536,
              "y": -27.052,
              "z": 1.419
            },
            "rightCorner": {
              "x": -23.654,
              "y": -27.058,
              "z": 1.419
            },
            "gtin": "4015000306812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d73",
            "leftCorner": {
              "x": -23.654,
              "y": -27.056,
              "z": 1.419
            },
            "rightCorner": {
              "x": -23.746,
              "y": -27.06,
              "z": 1.419
            },
            "gtin": "4016100810117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d74",
            "leftCorner": {
              "x": -23.715,
              "y": -27.07,
              "z": 1.42
            },
            "rightCorner": {
              "x": -23.827,
              "y": -27.074,
              "z": 1.42
            },
            "gtin": "4002448006473",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "36b",
    "rightNeighborShelfId": "369"
  },
  {
    "id": "36b",
    "name": "36b",
    "x": -21.736,
    "y": -27.028,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99975,
      "w": 0.022452
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 44,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d28d",
        "height": 0.16762,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d27",
            "leftCorner": {
              "x": -21.741,
              "y": -26.93,
              "z": 0.137
            },
            "rightCorner": {
              "x": -21.931,
              "y": -26.939,
              "z": 0.137
            },
            "gtin": "4306188024460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d29",
            "leftCorner": {
              "x": -21.929,
              "y": -26.982,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.02,
              "y": -26.987,
              "z": 0.137
            },
            "gtin": "4306188047780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d2a",
            "leftCorner": {
              "x": -22.02,
              "y": -26.987,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.111,
              "y": -26.99,
              "z": 0.137
            },
            "gtin": "4306188047780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d2b",
            "leftCorner": {
              "x": -22.108,
              "y": -27.068,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.302,
              "y": -27.077,
              "z": 0.137
            },
            "gtin": "4306188047872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d2c",
            "leftCorner": {
              "x": -22.306,
              "y": -26.993,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.473,
              "y": -27.0,
              "z": 0.137
            },
            "gtin": "4306188047834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d2d",
            "leftCorner": {
              "x": -22.473,
              "y": -26.999,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.59,
              "y": -27.004,
              "z": 0.137
            },
            "gtin": "4001499139796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d2e",
            "leftCorner": {
              "x": -22.59,
              "y": -26.997,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.738,
              "y": -27.004,
              "z": 0.137
            },
            "gtin": "8720181239878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d2f",
            "leftCorner": {
              "x": -22.738,
              "y": -27.004,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.884,
              "y": -27.011,
              "z": 0.137
            },
            "gtin": "8720181239878",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d28c",
        "height": 0.59047,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d0d",
            "leftCorner": {
              "x": -21.741,
              "y": -26.914,
              "z": 0.483
            },
            "rightCorner": {
              "x": -21.806,
              "y": -26.917,
              "z": 0.483
            },
            "gtin": "5000204096705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d0e",
            "leftCorner": {
              "x": -21.806,
              "y": -26.917,
              "z": 0.483
            },
            "rightCorner": {
              "x": -21.87,
              "y": -26.92,
              "z": 0.483
            },
            "gtin": "5000204096705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d0f",
            "leftCorner": {
              "x": -21.87,
              "y": -26.92,
              "z": 0.483
            },
            "rightCorner": {
              "x": -21.935,
              "y": -26.922,
              "z": 0.483
            },
            "gtin": "5000204096705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d11",
            "leftCorner": {
              "x": -21.934,
              "y": -26.96,
              "z": 0.483
            },
            "rightCorner": {
              "x": -22.114,
              "y": -26.968,
              "z": 0.483
            },
            "gtin": "5000204096675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d12",
            "leftCorner": {
              "x": -22.113,
              "y": -26.97,
              "z": 0.483
            },
            "rightCorner": {
              "x": -22.258,
              "y": -26.977,
              "z": 0.483
            },
            "gtin": "8720182432377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d13",
            "leftCorner": {
              "x": -22.258,
              "y": -26.974,
              "z": 0.483
            },
            "rightCorner": {
              "x": -22.338,
              "y": -26.977,
              "z": 0.483
            },
            "gtin": "8720182432360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d14",
            "leftCorner": {
              "x": -22.338,
              "y": -26.977,
              "z": 0.483
            },
            "rightCorner": {
              "x": -22.418,
              "y": -26.981,
              "z": 0.483
            },
            "gtin": "8720182432360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d15",
            "leftCorner": {
              "x": -22.418,
              "y": -26.984,
              "z": 0.483
            },
            "rightCorner": {
              "x": -22.524,
              "y": -26.989,
              "z": 0.483
            },
            "gtin": "5000204549256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d16",
            "leftCorner": {
              "x": -22.524,
              "y": -26.99,
              "z": 0.483
            },
            "rightCorner": {
              "x": -22.804,
              "y": -27.002,
              "z": 0.483
            },
            "gtin": "5000204592320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d28e",
        "height": 0.93139,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d3f",
            "leftCorner": {
              "x": -21.741,
              "y": -26.93,
              "z": 0.762
            },
            "rightCorner": {
              "x": -21.833,
              "y": -26.935,
              "z": 0.762
            },
            "gtin": "4015000973885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d40",
            "leftCorner": {
              "x": -21.833,
              "y": -26.935,
              "z": 0.762
            },
            "rightCorner": {
              "x": -21.926,
              "y": -26.938,
              "z": 0.762
            },
            "gtin": "4015000973885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d42",
            "leftCorner": {
              "x": -21.923,
              "y": -26.982,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.028,
              "y": -26.987,
              "z": 0.762
            },
            "gtin": "4015000973892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d43",
            "leftCorner": {
              "x": -22.028,
              "y": -26.987,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.132,
              "y": -26.992,
              "z": 0.762
            },
            "gtin": "4015000973892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d44",
            "leftCorner": {
              "x": -22.132,
              "y": -26.99,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.214,
              "y": -26.994,
              "z": 0.762
            },
            "gtin": "4015200033129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d45",
            "leftCorner": {
              "x": -22.214,
              "y": -26.994,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.295,
              "y": -26.997,
              "z": 0.762
            },
            "gtin": "4015200033129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d46",
            "leftCorner": {
              "x": -22.295,
              "y": -26.993,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.422,
              "y": -26.999,
              "z": 0.762
            },
            "gtin": "4251758404121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d47",
            "leftCorner": {
              "x": -22.422,
              "y": -27.0,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.491,
              "y": -27.004,
              "z": 0.762
            },
            "gtin": "4251758404107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d48",
            "leftCorner": {
              "x": -22.491,
              "y": -27.004,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.561,
              "y": -27.006,
              "z": 0.762
            },
            "gtin": "4251758404107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d49",
            "leftCorner": {
              "x": -22.561,
              "y": -27.006,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.631,
              "y": -27.01,
              "z": 0.762
            },
            "gtin": "4251758404107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d4a",
            "leftCorner": {
              "x": -22.632,
              "y": -27.004,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.823,
              "y": -27.012,
              "z": 0.762
            },
            "gtin": "4002448033943",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d28f",
        "height": 1.2861,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d59",
            "leftCorner": {
              "x": -21.741,
              "y": -26.929,
              "z": 1.052
            },
            "rightCorner": {
              "x": -21.934,
              "y": -26.938,
              "z": 1.052
            },
            "gtin": "4001499960963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d5b",
            "leftCorner": {
              "x": -21.931,
              "y": -26.983,
              "z": 1.052
            },
            "rightCorner": {
              "x": -21.989,
              "y": -26.986,
              "z": 1.052
            },
            "gtin": "4001499185267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d5c",
            "leftCorner": {
              "x": -21.989,
              "y": -26.986,
              "z": 1.052
            },
            "rightCorner": {
              "x": -22.047,
              "y": -26.989,
              "z": 1.052
            },
            "gtin": "4001499185267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d5d",
            "leftCorner": {
              "x": -22.047,
              "y": -26.989,
              "z": 1.052
            },
            "rightCorner": {
              "x": -22.105,
              "y": -26.991,
              "z": 1.052
            },
            "gtin": "4001499185267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d5e",
            "leftCorner": {
              "x": -22.106,
              "y": -26.987,
              "z": 1.052
            },
            "rightCorner": {
              "x": -22.28,
              "y": -26.995,
              "z": 1.052
            },
            "gtin": "4001499954986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d5f",
            "leftCorner": {
              "x": -22.28,
              "y": -26.993,
              "z": 1.052
            },
            "rightCorner": {
              "x": -22.489,
              "y": -27.003,
              "z": 1.052
            },
            "gtin": "4001499961472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d60",
            "leftCorner": {
              "x": -22.489,
              "y": -27.001,
              "z": 1.052
            },
            "rightCorner": {
              "x": -22.603,
              "y": -27.006,
              "z": 1.052
            },
            "gtin": "8700216710671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d5a",
            "leftCorner": {
              "x": -22.604,
              "y": -26.998,
              "z": 1.052
            },
            "rightCorner": {
              "x": -22.739,
              "y": -27.004,
              "z": 1.052
            },
            "gtin": "8700216663892",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d290",
        "height": 1.7353,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d61",
            "leftCorner": {
              "x": -21.741,
              "y": -26.927,
              "z": 1.42
            },
            "rightCorner": {
              "x": -21.983,
              "y": -26.937,
              "z": 1.42
            },
            "gtin": "4002448047834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d63",
            "leftCorner": {
              "x": -21.98,
              "y": -26.982,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.118,
              "y": -26.988,
              "z": 1.42
            },
            "gtin": "4010054004875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d64",
            "leftCorner": {
              "x": -22.118,
              "y": -26.987,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.239,
              "y": -26.993,
              "z": 1.42
            },
            "gtin": "4010054004882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d65",
            "leftCorner": {
              "x": -22.239,
              "y": -26.989,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.341,
              "y": -26.993,
              "z": 1.42
            },
            "gtin": "4010054006961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d66",
            "leftCorner": {
              "x": -22.341,
              "y": -26.994,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.428,
              "y": -26.997,
              "z": 1.42
            },
            "gtin": "4008377000728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d67",
            "leftCorner": {
              "x": -22.428,
              "y": -26.995,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.507,
              "y": -26.999,
              "z": 1.42
            },
            "gtin": "4062196310529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d68",
            "leftCorner": {
              "x": -22.507,
              "y": -26.997,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.614,
              "y": -27.002,
              "z": 1.42
            },
            "gtin": "4062196082839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d69",
            "leftCorner": {
              "x": -22.614,
              "y": -26.999,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.791,
              "y": -27.007,
              "z": 1.42
            },
            "gtin": "4062196082235",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "36a"
  },
  {
    "id": "36c",
    "name": "36c",
    "x": -22.699,
    "y": -28.36,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.027424,
      "w": 0.99962
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d2bf",
        "height": 0.16569,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6dc2",
            "leftCorner": {
              "x": -22.414,
              "y": -28.419,
              "z": 0.136
            },
            "rightCorner": {
              "x": -22.257,
              "y": -28.411,
              "z": 0.136
            },
            "gtin": "4006501830463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dc3",
            "leftCorner": {
              "x": -22.258,
              "y": -28.409,
              "z": 0.136
            },
            "rightCorner": {
              "x": -22.116,
              "y": -28.401,
              "z": 0.136
            },
            "gtin": "4023103251564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6db6",
            "leftCorner": {
              "x": -22.116,
              "y": -28.398,
              "z": 0.136
            },
            "rightCorner": {
              "x": -21.696,
              "y": -28.375,
              "z": 0.136
            },
            "gtin": "4023103251540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "762e0271beac0ff5dc302a31",
            "leftCorner": {
              "x": -22.692,
              "y": -28.472,
              "z": 0.136
            },
            "rightCorner": {
              "x": -22.551,
              "y": -28.464,
              "z": 0.136
            },
            "gtin": "4023103251564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0e8eabf63e5da746eaf0d530",
            "leftCorner": {
              "x": -22.551,
              "y": -28.464,
              "z": 0.136
            },
            "rightCorner": {
              "x": -22.413,
              "y": -28.456,
              "z": 0.136
            },
            "gtin": "4023103251564",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2c5",
        "height": 0.60568,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d2c3",
        "height": 0.92888,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6de9",
            "leftCorner": {
              "x": -22.702,
              "y": -28.301,
              "z": 0.76
            },
            "rightCorner": {
              "x": -21.943,
              "y": -28.26,
              "z": 0.76
            },
            "gtin": "4006501416506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dea",
            "leftCorner": {
              "x": -21.944,
              "y": -28.22,
              "z": 0.76
            },
            "rightCorner": {
              "x": -21.706,
              "y": -28.207,
              "z": 0.76
            },
            "gtin": "4006501551177",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2c1",
        "height": 1.1983,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6de2",
            "leftCorner": {
              "x": -22.699,
              "y": -28.354,
              "z": 0.98
            },
            "rightCorner": {
              "x": -22.357,
              "y": -28.336,
              "z": 0.98
            },
            "gtin": "4006501514257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6de4",
            "leftCorner": {
              "x": -22.357,
              "y": -28.321,
              "z": 0.98
            },
            "rightCorner": {
              "x": -22.052,
              "y": -28.304,
              "z": 0.98
            },
            "gtin": "8719987749544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6de3",
            "leftCorner": {
              "x": -22.053,
              "y": -28.279,
              "z": 0.98
            },
            "rightCorner": {
              "x": -21.702,
              "y": -28.259,
              "z": 0.98
            },
            "gtin": "4022551251942",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2bb",
        "height": 1.3954,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6dde",
            "leftCorner": {
              "x": -22.701,
              "y": -28.315,
              "z": 1.142
            },
            "rightCorner": {
              "x": -22.436,
              "y": -28.301,
              "z": 1.142
            },
            "gtin": "4006501417022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ddf",
            "leftCorner": {
              "x": -22.438,
              "y": -28.261,
              "z": 1.142
            },
            "rightCorner": {
              "x": -21.705,
              "y": -28.22,
              "z": 1.142
            },
            "gtin": "4006501417022",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2bc",
        "height": 1.628,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6de0",
            "leftCorner": {
              "x": -22.699,
              "y": -28.351,
              "z": 1.332
            },
            "rightCorner": {
              "x": -22.266,
              "y": -28.328,
              "z": 1.332
            },
            "gtin": "4006501513250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6de1",
            "leftCorner": {
              "x": -22.267,
              "y": -28.314,
              "z": 1.332
            },
            "rightCorner": {
              "x": -21.701,
              "y": -28.283,
              "z": 1.332
            },
            "gtin": "4014529281907",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2c2",
        "height": 1.7759,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6de5",
            "leftCorner": {
              "x": -22.7,
              "y": -28.348,
              "z": 1.453
            },
            "rightCorner": {
              "x": -22.157,
              "y": -28.318,
              "z": 1.453
            },
            "gtin": "4006501513205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6de7",
            "leftCorner": {
              "x": -22.161,
              "y": -28.257,
              "z": 1.453
            },
            "rightCorner": {
              "x": -21.995,
              "y": -28.248,
              "z": 1.453
            },
            "gtin": "4022551251935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6de8",
            "leftCorner": {
              "x": -21.993,
              "y": -28.269,
              "z": 1.453
            },
            "rightCorner": {
              "x": -21.849,
              "y": -28.261,
              "z": 1.453
            },
            "gtin": "4006501552105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6de6",
            "leftCorner": {
              "x": -21.848,
              "y": -28.3,
              "z": 1.453
            },
            "rightCorner": {
              "x": -21.701,
              "y": -28.292,
              "z": 1.453
            },
            "gtin": "4006501550491",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "36d"
  },
  {
    "id": "36d",
    "name": "36d",
    "x": -23.709,
    "y": -28.395,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.018491,
      "w": 0.99983
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 5,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d2b0",
        "height": 0.16643,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6dbd",
            "leftCorner": {
              "x": -23.601,
              "y": -28.319,
              "z": 0.136
            },
            "rightCorner": {
              "x": -23.421,
              "y": -28.313,
              "z": 0.136
            },
            "gtin": "4022551117125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2722a06e1f9c27668297a54b",
            "leftCorner": {
              "x": -23.705,
              "y": -28.492,
              "z": 0.136
            },
            "rightCorner": {
              "x": -23.61,
              "y": -28.488,
              "z": 0.136
            },
            "gtin": "4022551327678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7430c7e4eb88af3a1620349c",
            "leftCorner": {
              "x": -22.868,
              "y": -28.461,
              "z": 0.136
            },
            "rightCorner": {
              "x": -22.743,
              "y": -28.456,
              "z": 0.136
            },
            "gtin": "4022551329665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dbe",
            "leftCorner": {
              "x": -23.416,
              "y": -28.446,
              "z": 0.136
            },
            "rightCorner": {
              "x": -23.283,
              "y": -28.441,
              "z": 0.136
            },
            "gtin": "4022551252673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dbf",
            "leftCorner": {
              "x": -23.289,
              "y": -28.292,
              "z": 0.136
            },
            "rightCorner": {
              "x": -23.155,
              "y": -28.287,
              "z": 0.136
            },
            "gtin": "4022551329665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dc0",
            "leftCorner": {
              "x": -23.15,
              "y": -28.431,
              "z": 0.136
            },
            "rightCorner": {
              "x": -22.87,
              "y": -28.421,
              "z": 0.136
            },
            "gtin": "4022551327678",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2a8",
        "height": 0.86613,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6dce",
            "leftCorner": {
              "x": -23.575,
              "y": -28.207,
              "z": 0.709
            },
            "rightCorner": {
              "x": -22.717,
              "y": -28.175,
              "z": 0.709
            },
            "gtin": "8719202845044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "63033bf6027eb69971e64f7b",
            "leftCorner": {
              "x": -23.714,
              "y": -28.252,
              "z": 0.709
            },
            "rightCorner": {
              "x": -23.675,
              "y": -28.251,
              "z": 0.709
            },
            "gtin": "4006501566737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2a08bb3b29ac743dc881c189",
            "leftCorner": {
              "x": -23.675,
              "y": -28.251,
              "z": 0.709
            },
            "rightCorner": {
              "x": -23.575,
              "y": -28.247,
              "z": 0.709
            },
            "gtin": "4022551161241",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2b4",
        "height": 0.98774,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6da4",
            "leftCorner": {
              "x": -23.684,
              "y": -28.387,
              "z": 0.808
            },
            "rightCorner": {
              "x": -23.192,
              "y": -28.369,
              "z": 0.808
            },
            "gtin": "4022551202517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6da5",
            "leftCorner": {
              "x": -23.195,
              "y": -28.262,
              "z": 0.808
            },
            "rightCorner": {
              "x": -22.986,
              "y": -28.255,
              "z": 0.808
            },
            "gtin": "8719987749407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d9e",
            "leftCorner": {
              "x": -22.985,
              "y": -28.269,
              "z": 0.808
            },
            "rightCorner": {
              "x": -22.714,
              "y": -28.259,
              "z": 0.808
            },
            "gtin": "4022551129807",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2b2",
        "height": 1.0999,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6dcf",
            "leftCorner": {
              "x": -23.711,
              "y": -28.356,
              "z": 0.9
            },
            "rightCorner": {
              "x": -23.296,
              "y": -28.341,
              "z": 0.9
            },
            "gtin": "4022551332313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dd0",
            "leftCorner": {
              "x": -23.298,
              "y": -28.301,
              "z": 0.9
            },
            "rightCorner": {
              "x": -22.713,
              "y": -28.28,
              "z": 0.9
            },
            "gtin": "4022551327708",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2a7",
        "height": 1.2593,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6dca",
            "leftCorner": {
              "x": -23.713,
              "y": -28.307,
              "z": 1.03
            },
            "rightCorner": {
              "x": -23.509,
              "y": -28.299,
              "z": 1.03
            },
            "gtin": "8719202845044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dcc",
            "leftCorner": {
              "x": -23.507,
              "y": -28.362,
              "z": 1.03
            },
            "rightCorner": {
              "x": -23.435,
              "y": -28.359,
              "z": 1.03
            },
            "gtin": "4022551131558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dcb",
            "leftCorner": {
              "x": -23.436,
              "y": -28.322,
              "z": 1.03
            },
            "rightCorner": {
              "x": -22.712,
              "y": -28.296,
              "z": 1.03
            },
            "gtin": "4022551329610",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2a6",
        "height": 1.5252,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6dc4",
            "leftCorner": {
              "x": -23.712,
              "y": -28.342,
              "z": 1.248
            },
            "rightCorner": {
              "x": -23.494,
              "y": -28.334,
              "z": 1.248
            },
            "gtin": "4022551329689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dc6",
            "leftCorner": {
              "x": -23.493,
              "y": -28.356,
              "z": 1.248
            },
            "rightCorner": {
              "x": -23.382,
              "y": -28.351,
              "z": 1.248
            },
            "gtin": "4022551112410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dc7",
            "leftCorner": {
              "x": -23.383,
              "y": -28.333,
              "z": 1.248
            },
            "rightCorner": {
              "x": -23.277,
              "y": -28.329,
              "z": 1.248
            },
            "gtin": "4022551186404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dc8",
            "leftCorner": {
              "x": -23.278,
              "y": -28.293,
              "z": 1.248
            },
            "rightCorner": {
              "x": -22.931,
              "y": -28.28,
              "z": 1.248
            },
            "gtin": "4022551051740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dc9",
            "leftCorner": {
              "x": -22.928,
              "y": -28.342,
              "z": 1.248
            },
            "rightCorner": {
              "x": -22.627,
              "y": -28.331,
              "z": 1.248
            },
            "gtin": "4022551105467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dc5",
            "leftCorner": {
              "x": -22.628,
              "y": -28.307,
              "z": 1.248
            },
            "rightCorner": {
              "x": -22.545,
              "y": -28.303,
              "z": 1.248
            },
            "gtin": "4006501417015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2b3",
        "height": 1.8424,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6dd1",
            "leftCorner": {
              "x": -23.717,
              "y": -28.187,
              "z": 1.507
            },
            "rightCorner": {
              "x": -23.631,
              "y": -28.184,
              "z": 1.507
            },
            "gtin": "4022551132111",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6dd3",
            "leftCorner": {
              "x": -23.632,
              "y": -28.147,
              "z": 1.507
            },
            "rightCorner": {
              "x": -23.521,
              "y": -28.142,
              "z": 1.507
            },
            "gtin": "4022551329702",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6dd4",
            "leftCorner": {
              "x": -23.522,
              "y": -28.134,
              "z": 1.507
            },
            "rightCorner": {
              "x": -23.418,
              "y": -28.13,
              "z": 1.507
            },
            "gtin": "4022551122891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dd5",
            "leftCorner": {
              "x": -23.418,
              "y": -28.129,
              "z": 1.507
            },
            "rightCorner": {
              "x": -23.381,
              "y": -28.128,
              "z": 1.507
            },
            "gtin": "4022551121290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dd6",
            "leftCorner": {
              "x": -23.377,
              "y": -28.23,
              "z": 1.507
            },
            "rightCorner": {
              "x": -23.319,
              "y": -28.228,
              "z": 1.507
            },
            "gtin": "4022551256022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dd7",
            "leftCorner": {
              "x": -23.321,
              "y": -28.136,
              "z": 1.507
            },
            "rightCorner": {
              "x": -23.224,
              "y": -28.132,
              "z": 1.507
            },
            "gtin": "4022551310267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dd8",
            "leftCorner": {
              "x": -23.225,
              "y": -28.117,
              "z": 1.507
            },
            "rightCorner": {
              "x": -23.114,
              "y": -28.113,
              "z": 1.507
            },
            "gtin": "4022551329764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dd9",
            "leftCorner": {
              "x": -23.114,
              "y": -28.114,
              "z": 1.507
            },
            "rightCorner": {
              "x": -23.037,
              "y": -28.11,
              "z": 1.507
            },
            "gtin": "4022551336847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dda",
            "leftCorner": {
              "x": -23.035,
              "y": -28.133,
              "z": 1.507
            },
            "rightCorner": {
              "x": -22.942,
              "y": -28.13,
              "z": 1.507
            },
            "gtin": "4022551161241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ddb",
            "leftCorner": {
              "x": -22.937,
              "y": -28.266,
              "z": 1.507
            },
            "rightCorner": {
              "x": -22.911,
              "y": -28.265,
              "z": 1.507
            },
            "gtin": "4022551336892",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6ddc",
            "leftCorner": {
              "x": -22.91,
              "y": -28.33,
              "z": 1.507
            },
            "rightCorner": {
              "x": -22.823,
              "y": -28.326,
              "z": 1.507
            },
            "gtin": "4022551336892",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6ddd",
            "leftCorner": {
              "x": -22.823,
              "y": -28.316,
              "z": 1.507
            },
            "rightCorner": {
              "x": -22.748,
              "y": -28.314,
              "z": 1.507
            },
            "gtin": "4022551131954",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "36e",
    "rightNeighborShelfId": "36c"
  },
  {
    "id": "36e",
    "name": "36e",
    "x": -24.959,
    "y": -28.424,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.011205,
      "w": 0.99994
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 29
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d2a5",
        "height": 0.17406,
        "facings": [
          {
            "id": "d76379fdadbd71823636124d",
            "leftCorner": {
              "x": -24.957,
              "y": -28.509,
              "z": 0.142
            },
            "rightCorner": {
              "x": -24.779,
              "y": -28.505,
              "z": 0.142
            },
            "gtin": "4306188058151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9ccd1d8f16db59d8d774f64d",
            "leftCorner": {
              "x": -24.779,
              "y": -28.505,
              "z": 0.142
            },
            "rightCorner": {
              "x": -24.651,
              "y": -28.502,
              "z": 0.142
            },
            "gtin": "4306188420590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "198c508e1e556af57e626b5e",
            "leftCorner": {
              "x": -24.651,
              "y": -28.502,
              "z": 0.142
            },
            "rightCorner": {
              "x": -24.52,
              "y": -28.499,
              "z": 0.142
            },
            "gtin": "3384122300178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b1499b456d6449ea6cebb55b",
            "leftCorner": {
              "x": -24.52,
              "y": -28.499,
              "z": 0.142
            },
            "rightCorner": {
              "x": -24.372,
              "y": -28.496,
              "z": 0.142
            },
            "gtin": "4306188420439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aef7841b2f65a8cc6fe2b09d",
            "leftCorner": {
              "x": -24.372,
              "y": -28.496,
              "z": 0.142
            },
            "rightCorner": {
              "x": -24.213,
              "y": -28.492,
              "z": 0.142
            },
            "gtin": "8001940001432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f2ea6b7202849853de6f0c9f",
            "leftCorner": {
              "x": -24.213,
              "y": -28.492,
              "z": 0.142
            },
            "rightCorner": {
              "x": -24.039,
              "y": -28.488,
              "z": 0.142
            },
            "gtin": "4003790006296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aec8407789fae9391621e3b6",
            "leftCorner": {
              "x": -24.039,
              "y": -28.488,
              "z": 0.142
            },
            "rightCorner": {
              "x": -23.861,
              "y": -28.484,
              "z": 0.142
            },
            "gtin": "4306188058151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d1ff639da5a40dd29502586c",
            "leftCorner": {
              "x": -23.861,
              "y": -28.484,
              "z": 0.142
            },
            "rightCorner": {
              "x": -23.713,
              "y": -28.481,
              "z": 0.142
            },
            "gtin": "4306188420439",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2a3",
        "height": 0.60128,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6dac",
            "leftCorner": {
              "x": -24.958,
              "y": -28.471,
              "z": 0.492
            },
            "rightCorner": {
              "x": -24.698,
              "y": -28.464,
              "z": 0.492
            },
            "gtin": "4008600081876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dae",
            "leftCorner": {
              "x": -24.698,
              "y": -28.42,
              "z": 0.492
            },
            "rightCorner": {
              "x": -24.334,
              "y": -28.412,
              "z": 0.492
            },
            "gtin": "4014529052415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6daf",
            "leftCorner": {
              "x": -24.334,
              "y": -28.417,
              "z": 0.492
            },
            "rightCorner": {
              "x": -24.13,
              "y": -28.412,
              "z": 0.492
            },
            "gtin": "4306188420408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6db0",
            "leftCorner": {
              "x": -24.13,
              "y": -28.416,
              "z": 0.492
            },
            "rightCorner": {
              "x": -23.979,
              "y": -28.413,
              "z": 0.492
            },
            "gtin": "4306188420439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dad",
            "leftCorner": {
              "x": -23.979,
              "y": -28.409,
              "z": 0.492
            },
            "rightCorner": {
              "x": -23.709,
              "y": -28.403,
              "z": 0.492
            },
            "gtin": "4306188031888",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2a1",
        "height": 0.97899,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d9d",
            "leftCorner": {
              "x": -24.958,
              "y": -28.47,
              "z": 0.801
            },
            "rightCorner": {
              "x": -24.75,
              "y": -28.465,
              "z": 0.801
            },
            "gtin": "4306188032205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d9f",
            "leftCorner": {
              "x": -24.751,
              "y": -28.42,
              "z": 0.801
            },
            "rightCorner": {
              "x": -24.508,
              "y": -28.414,
              "z": 0.801
            },
            "gtin": "4306188420569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6da0",
            "leftCorner": {
              "x": -24.508,
              "y": -28.42,
              "z": 0.801
            },
            "rightCorner": {
              "x": -24.382,
              "y": -28.417,
              "z": 0.801
            },
            "gtin": "4306188420590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6da1",
            "leftCorner": {
              "x": -24.382,
              "y": -28.415,
              "z": 0.801
            },
            "rightCorner": {
              "x": -24.123,
              "y": -28.409,
              "z": 0.801
            },
            "gtin": "4023103110724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6da2",
            "leftCorner": {
              "x": -24.123,
              "y": -28.418,
              "z": 0.801
            },
            "rightCorner": {
              "x": -23.911,
              "y": -28.413,
              "z": 0.801
            },
            "gtin": "4306188420484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6da3",
            "leftCorner": {
              "x": -23.911,
              "y": -28.408,
              "z": 0.801
            },
            "rightCorner": {
              "x": -23.684,
              "y": -28.403,
              "z": 0.801
            },
            "gtin": "4023103110755",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2a4",
        "height": 1.3356,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6db1",
            "leftCorner": {
              "x": -24.958,
              "y": -28.48,
              "z": 1.093
            },
            "rightCorner": {
              "x": -24.576,
              "y": -28.471,
              "z": 1.093
            },
            "gtin": "4306188058168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6db3",
            "leftCorner": {
              "x": -24.577,
              "y": -28.43,
              "z": 1.093
            },
            "rightCorner": {
              "x": -24.264,
              "y": -28.424,
              "z": 1.093
            },
            "gtin": "8721037027052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6db4",
            "leftCorner": {
              "x": -24.263,
              "y": -28.43,
              "z": 1.093
            },
            "rightCorner": {
              "x": -23.845,
              "y": -28.421,
              "z": 1.093
            },
            "gtin": "4023103238992",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6db2",
            "leftCorner": {
              "x": -23.846,
              "y": -28.417,
              "z": 1.093
            },
            "rightCorner": {
              "x": -23.709,
              "y": -28.414,
              "z": 1.093
            },
            "gtin": "3384122300178",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2a2",
        "height": 1.6841,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6da6",
            "leftCorner": {
              "x": -24.958,
              "y": -28.475,
              "z": 1.378
            },
            "rightCorner": {
              "x": -24.716,
              "y": -28.47,
              "z": 1.378
            },
            "gtin": "4306188048022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6da8",
            "leftCorner": {
              "x": -24.717,
              "y": -28.426,
              "z": 1.378
            },
            "rightCorner": {
              "x": -24.495,
              "y": -28.422,
              "z": 1.378
            },
            "gtin": "3384122002164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6da9",
            "leftCorner": {
              "x": -24.495,
              "y": -28.424,
              "z": 1.378
            },
            "rightCorner": {
              "x": -24.353,
              "y": -28.421,
              "z": 1.378
            },
            "gtin": "8001940001432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6daa",
            "leftCorner": {
              "x": -24.353,
              "y": -28.422,
              "z": 1.378
            },
            "rightCorner": {
              "x": -24.138,
              "y": -28.417,
              "z": 1.378
            },
            "gtin": "4306188420538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dab",
            "leftCorner": {
              "x": -24.137,
              "y": -28.427,
              "z": 1.378
            },
            "rightCorner": {
              "x": -23.898,
              "y": -28.421,
              "z": 1.378
            },
            "gtin": "4008600119128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6da7",
            "leftCorner": {
              "x": -23.898,
              "y": -28.416,
              "z": 1.378
            },
            "rightCorner": {
              "x": -23.709,
              "y": -28.411,
              "z": 1.378
            },
            "gtin": "4003790006296",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "36d"
  },
  {
    "id": "36f",
    "name": "36f",
    "x": -20.917,
    "y": -34.121,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71365,
      "w": 0.7005
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 60
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d750",
        "height": 0.24071,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88b8",
            "leftCorner": {
              "x": -20.968,
              "y": -33.755,
              "z": 0.197
            },
            "rightCorner": {
              "x": -20.972,
              "y": -33.549,
              "z": 0.197
            },
            "gtin": "4008153345210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88b9",
            "leftCorner": {
              "x": -21.009,
              "y": -33.551,
              "z": 0.197
            },
            "rightCorner": {
              "x": -21.015,
              "y": -33.237,
              "z": 0.197
            },
            "gtin": "4008153349218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88b7",
            "leftCorner": {
              "x": -20.964,
              "y": -33.235,
              "z": 0.197
            },
            "rightCorner": {
              "x": -20.971,
              "y": -32.871,
              "z": 0.197
            },
            "gtin": "4008153445422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0d4df70c6c3fc131d49ae21b",
            "leftCorner": {
              "x": -20.921,
              "y": -34.121,
              "z": 0.197
            },
            "rightCorner": {
              "x": -20.928,
              "y": -33.76,
              "z": 0.197
            },
            "gtin": "4008153348013",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d74a",
        "height": 0.50258,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d887d",
            "leftCorner": {
              "x": -20.977,
              "y": -34.122,
              "z": 0.411
            },
            "rightCorner": {
              "x": -20.979,
              "y": -33.997,
              "z": 0.411
            },
            "gtin": "4306188013976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d887e",
            "leftCorner": {
              "x": -20.979,
              "y": -33.997,
              "z": 0.411
            },
            "rightCorner": {
              "x": -20.981,
              "y": -33.873,
              "z": 0.411
            },
            "gtin": "4306188013976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d887f",
            "leftCorner": {
              "x": -20.981,
              "y": -33.873,
              "z": 0.411
            },
            "rightCorner": {
              "x": -20.983,
              "y": -33.748,
              "z": 0.411
            },
            "gtin": "4306188013976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8881",
            "leftCorner": {
              "x": -21.03,
              "y": -33.749,
              "z": 0.411
            },
            "rightCorner": {
              "x": -21.033,
              "y": -33.591,
              "z": 0.411
            },
            "gtin": "4306188013914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8882",
            "leftCorner": {
              "x": -21.028,
              "y": -33.591,
              "z": 0.411
            },
            "rightCorner": {
              "x": -21.03,
              "y": -33.443,
              "z": 0.411
            },
            "gtin": "4306188013945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8883",
            "leftCorner": {
              "x": -21.028,
              "y": -33.443,
              "z": 0.411
            },
            "rightCorner": {
              "x": -21.032,
              "y": -33.27,
              "z": 0.411
            },
            "gtin": "4306188014003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8884",
            "leftCorner": {
              "x": -21.026,
              "y": -33.27,
              "z": 0.411
            },
            "rightCorner": {
              "x": -21.028,
              "y": -33.117,
              "z": 0.411
            },
            "gtin": "4306188014034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8880",
            "leftCorner": {
              "x": -21.021,
              "y": -33.117,
              "z": 0.411
            },
            "rightCorner": {
              "x": -21.025,
              "y": -32.872,
              "z": 0.411
            },
            "gtin": "4306188014065",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d74f",
        "height": 0.82771,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88ad",
            "leftCorner": {
              "x": -20.974,
              "y": -34.122,
              "z": 0.677
            },
            "rightCorner": {
              "x": -20.98,
              "y": -33.841,
              "z": 0.677
            },
            "gtin": "4058075112469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88af",
            "leftCorner": {
              "x": -21.031,
              "y": -33.842,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.033,
              "y": -33.691,
              "z": 0.677
            },
            "gtin": "4058075112506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88b0",
            "leftCorner": {
              "x": -21.028,
              "y": -33.691,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.03,
              "y": -33.58,
              "z": 0.677
            },
            "gtin": "4058075112261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88b1",
            "leftCorner": {
              "x": -21.026,
              "y": -33.58,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.028,
              "y": -33.475,
              "z": 0.677
            },
            "gtin": "4058075115910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88b2",
            "leftCorner": {
              "x": -21.026,
              "y": -33.475,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.028,
              "y": -33.354,
              "z": 0.677
            },
            "gtin": "4058075112360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88b3",
            "leftCorner": {
              "x": -21.027,
              "y": -33.354,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.029,
              "y": -33.256,
              "z": 0.677
            },
            "gtin": "4058075436664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88b4",
            "leftCorner": {
              "x": -21.029,
              "y": -33.256,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.031,
              "y": -33.156,
              "z": 0.677
            },
            "gtin": "4058075436688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88b5",
            "leftCorner": {
              "x": -21.028,
              "y": -33.156,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.03,
              "y": -33.034,
              "z": 0.677
            },
            "gtin": "4058075436503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88ae",
            "leftCorner": {
              "x": -21.019,
              "y": -33.034,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.022,
              "y": -32.872,
              "z": 0.677
            },
            "gtin": "4058075436589",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d74d",
        "height": 1.0542,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8895",
            "leftCorner": {
              "x": -20.975,
              "y": -34.122,
              "z": 0.863
            },
            "rightCorner": {
              "x": -20.979,
              "y": -33.921,
              "z": 0.863
            },
            "gtin": "4099854468773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8897",
            "leftCorner": {
              "x": -21.029,
              "y": -33.922,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.031,
              "y": -33.824,
              "z": 0.863
            },
            "gtin": "4058075436602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8898",
            "leftCorner": {
              "x": -21.026,
              "y": -33.824,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.028,
              "y": -33.734,
              "z": 0.863
            },
            "gtin": "4058075435162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8899",
            "leftCorner": {
              "x": -21.026,
              "y": -33.734,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.026,
              "y": -33.648,
              "z": 0.863
            },
            "gtin": "4058075436527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d889a",
            "leftCorner": {
              "x": -21.023,
              "y": -33.648,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.025,
              "y": -33.561,
              "z": 0.863
            },
            "gtin": "4058075436480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d889b",
            "leftCorner": {
              "x": -21.028,
              "y": -33.561,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.028,
              "y": -33.516,
              "z": 0.863
            },
            "gtin": "4058075233263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d889c",
            "leftCorner": {
              "x": -21.029,
              "y": -33.516,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.031,
              "y": -33.467,
              "z": 0.863
            },
            "gtin": "4058075432758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d889d",
            "leftCorner": {
              "x": -21.03,
              "y": -33.467,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.032,
              "y": -33.381,
              "z": 0.863
            },
            "gtin": "4058075112568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d889e",
            "leftCorner": {
              "x": -21.028,
              "y": -33.381,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.03,
              "y": -33.283,
              "z": 0.863
            },
            "gtin": "4058075125902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d889f",
            "leftCorner": {
              "x": -21.028,
              "y": -33.283,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.029,
              "y": -33.189,
              "z": 0.863
            },
            "gtin": "4058075125964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88a0",
            "leftCorner": {
              "x": -21.029,
              "y": -33.189,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.031,
              "y": -33.13,
              "z": 0.863
            },
            "gtin": "4050300003108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88a1",
            "leftCorner": {
              "x": -21.022,
              "y": -33.13,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.024,
              "y": -33.066,
              "z": 0.863
            },
            "gtin": "4050300003085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88a2",
            "leftCorner": {
              "x": -21.021,
              "y": -33.066,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.022,
              "y": -33.012,
              "z": 0.863
            },
            "gtin": "4050300309637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8896",
            "leftCorner": {
              "x": -21.009,
              "y": -33.012,
              "z": 0.863
            },
            "rightCorner": {
              "x": -21.011,
              "y": -32.872,
              "z": 0.863
            },
            "gtin": "4050300323596",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d74e",
        "height": 1.3033,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88a3",
            "leftCorner": {
              "x": -20.972,
              "y": -34.121,
              "z": 1.066
            },
            "rightCorner": {
              "x": -20.976,
              "y": -33.912,
              "z": 1.066
            },
            "gtin": "4306188416685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88a5",
            "leftCorner": {
              "x": -21.029,
              "y": -33.913,
              "z": 1.066
            },
            "rightCorner": {
              "x": -21.031,
              "y": -33.82,
              "z": 1.066
            },
            "gtin": "4306188417026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88a6",
            "leftCorner": {
              "x": -21.025,
              "y": -33.82,
              "z": 1.066
            },
            "rightCorner": {
              "x": -21.027,
              "y": -33.726,
              "z": 1.066
            },
            "gtin": "4306188416845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88a7",
            "leftCorner": {
              "x": -21.025,
              "y": -33.726,
              "z": 1.066
            },
            "rightCorner": {
              "x": -21.026,
              "y": -33.638,
              "z": 1.066
            },
            "gtin": "4306188416807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88a8",
            "leftCorner": {
              "x": -21.021,
              "y": -33.638,
              "z": 1.066
            },
            "rightCorner": {
              "x": -21.022,
              "y": -33.558,
              "z": 1.066
            },
            "gtin": "4306188020806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88a9",
            "leftCorner": {
              "x": -21.022,
              "y": -33.558,
              "z": 1.066
            },
            "rightCorner": {
              "x": -21.026,
              "y": -33.392,
              "z": 1.066
            },
            "gtin": "4306188020448",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d88aa",
            "leftCorner": {
              "x": -21.027,
              "y": -33.392,
              "z": 1.066
            },
            "rightCorner": {
              "x": -21.028,
              "y": -33.307,
              "z": 1.066
            },
            "gtin": "7638900435849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88ab",
            "leftCorner": {
              "x": -21.023,
              "y": -33.307,
              "z": 1.066
            },
            "rightCorner": {
              "x": -21.025,
              "y": -33.202,
              "z": 1.066
            },
            "gtin": "7638900435832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88ac",
            "leftCorner": {
              "x": -21.025,
              "y": -33.202,
              "z": 1.066
            },
            "rightCorner": {
              "x": -21.029,
              "y": -33.067,
              "z": 1.066
            },
            "gtin": "7638900275001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88a4",
            "leftCorner": {
              "x": -21.018,
              "y": -33.067,
              "z": 1.066
            },
            "rightCorner": {
              "x": -21.021,
              "y": -32.872,
              "z": 1.066
            },
            "gtin": "7638900300666",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d74c",
        "height": 1.7331,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d888b",
            "leftCorner": {
              "x": -21.17,
              "y": -34.125,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.172,
              "y": -34.004,
              "z": 1.418
            },
            "gtin": "7638900246599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d888d",
            "leftCorner": {
              "x": -21.238,
              "y": -34.005,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.24,
              "y": -33.914,
              "z": 1.418
            },
            "gtin": "7638900437645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d888e",
            "leftCorner": {
              "x": -21.187,
              "y": -33.912,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.189,
              "y": -33.814,
              "z": 1.418
            },
            "gtin": "7638900247893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d888f",
            "leftCorner": {
              "x": -21.233,
              "y": -33.815,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.235,
              "y": -33.729,
              "z": 1.418
            },
            "gtin": "4306188416982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8890",
            "leftCorner": {
              "x": -21.222,
              "y": -33.729,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.223,
              "y": -33.639,
              "z": 1.418
            },
            "gtin": "4306188416944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8891",
            "leftCorner": {
              "x": -21.19,
              "y": -33.638,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.192,
              "y": -33.556,
              "z": 1.418
            },
            "gtin": "4306188416883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8892",
            "leftCorner": {
              "x": -21.22,
              "y": -33.558,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.224,
              "y": -33.393,
              "z": 1.418
            },
            "gtin": "7638900379914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8893",
            "leftCorner": {
              "x": -21.236,
              "y": -33.393,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.237,
              "y": -33.304,
              "z": 1.418
            },
            "gtin": "7638900411164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8894",
            "leftCorner": {
              "x": -21.217,
              "y": -33.304,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.219,
              "y": -33.202,
              "z": 1.418
            },
            "gtin": "7638900083071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d888c",
            "leftCorner": {
              "x": -21.164,
              "y": -33.201,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.17,
              "y": -32.875,
              "z": 1.418
            },
            "gtin": "4008153016196",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d74b",
        "height": 1.8824,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8885",
            "leftCorner": {
              "x": -21.119,
              "y": -34.124,
              "z": 1.54
            },
            "rightCorner": {
              "x": -21.125,
              "y": -33.81,
              "z": 1.54
            },
            "gtin": "7638900438147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8887",
            "leftCorner": {
              "x": -21.154,
              "y": -33.81,
              "z": 1.54
            },
            "rightCorner": {
              "x": -21.156,
              "y": -33.725,
              "z": 1.54
            },
            "gtin": "7638900297409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8888",
            "leftCorner": {
              "x": -21.178,
              "y": -33.726,
              "z": 1.54
            },
            "rightCorner": {
              "x": -21.179,
              "y": -33.634,
              "z": 1.54
            },
            "gtin": "7638900426663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8889",
            "leftCorner": {
              "x": -21.151,
              "y": -33.634,
              "z": 1.54
            },
            "rightCorner": {
              "x": -21.153,
              "y": -33.557,
              "z": 1.54
            },
            "gtin": "7638900248333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d888a",
            "leftCorner": {
              "x": -21.216,
              "y": -33.559,
              "z": 1.54
            },
            "rightCorner": {
              "x": -21.226,
              "y": -33.055,
              "z": 1.54
            },
            "gtin": "7638900248357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8886",
            "leftCorner": {
              "x": -21.148,
              "y": -33.053,
              "z": 1.54
            },
            "rightCorner": {
              "x": -21.15,
              "y": -32.875,
              "z": 1.54
            },
            "gtin": "7638900368215",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "370",
    "name": "370",
    "x": -21.488,
    "y": -32.905,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99989,
      "w": 0.014686
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d253",
        "height": 0.16353,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b6f",
            "leftCorner": {
              "x": -21.492,
              "y": -32.814,
              "z": 0.134
            },
            "rightCorner": {
              "x": -21.619,
              "y": -32.819,
              "z": 0.134
            },
            "gtin": "4006160010923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b71",
            "leftCorner": {
              "x": -21.617,
              "y": -32.86,
              "z": 0.134
            },
            "rightCorner": {
              "x": -22.004,
              "y": -32.871,
              "z": 0.134
            },
            "gtin": "3045380026384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b72",
            "leftCorner": {
              "x": -22.004,
              "y": -32.868,
              "z": 0.134
            },
            "rightCorner": {
              "x": -22.237,
              "y": -32.876,
              "z": 0.134
            },
            "gtin": "4067522083078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b73",
            "leftCorner": {
              "x": -22.237,
              "y": -32.867,
              "z": 0.134
            },
            "rightCorner": {
              "x": -22.49,
              "y": -32.874,
              "z": 0.134
            },
            "gtin": "8710103822646",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d251",
        "height": 0.60576,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b63",
            "leftCorner": {
              "x": -21.492,
              "y": -32.813,
              "z": 0.496
            },
            "rightCorner": {
              "x": -21.683,
              "y": -32.818,
              "z": 0.496
            },
            "gtin": "4242002420134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b65",
            "leftCorner": {
              "x": -21.682,
              "y": -32.857,
              "z": 0.496
            },
            "rightCorner": {
              "x": -21.766,
              "y": -32.86,
              "z": 0.496
            },
            "gtin": "4006160639704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b66",
            "leftCorner": {
              "x": -21.766,
              "y": -32.859,
              "z": 0.496
            },
            "rightCorner": {
              "x": -21.855,
              "y": -32.861,
              "z": 0.496
            },
            "gtin": "4006160616804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b67",
            "leftCorner": {
              "x": -21.855,
              "y": -32.867,
              "z": 0.496
            },
            "rightCorner": {
              "x": -22.041,
              "y": -32.872,
              "z": 0.496
            },
            "gtin": "4052926310035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b68",
            "leftCorner": {
              "x": -22.041,
              "y": -32.869,
              "z": 0.496
            },
            "rightCorner": {
              "x": -22.225,
              "y": -32.875,
              "z": 0.496
            },
            "gtin": "4006160635911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b64",
            "leftCorner": {
              "x": -22.225,
              "y": -32.866,
              "z": 0.496
            },
            "rightCorner": {
              "x": -22.49,
              "y": -32.874,
              "z": 0.496
            },
            "gtin": "3045386362707",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d252",
        "height": 1.0373,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b69",
            "leftCorner": {
              "x": -21.492,
              "y": -32.814,
              "z": 0.849
            },
            "rightCorner": {
              "x": -21.674,
              "y": -32.819,
              "z": 0.849
            },
            "gtin": "4067522046936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b6b",
            "leftCorner": {
              "x": -21.673,
              "y": -32.857,
              "z": 0.849
            },
            "rightCorner": {
              "x": -21.802,
              "y": -32.861,
              "z": 0.849
            },
            "gtin": "4067522079156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b6c",
            "leftCorner": {
              "x": -21.802,
              "y": -32.862,
              "z": 0.849
            },
            "rightCorner": {
              "x": -21.983,
              "y": -32.868,
              "z": 0.849
            },
            "gtin": "4067522073598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b6d",
            "leftCorner": {
              "x": -21.983,
              "y": -32.868,
              "z": 0.849
            },
            "rightCorner": {
              "x": -22.147,
              "y": -32.872,
              "z": 0.849
            },
            "gtin": "4067522046653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b6e",
            "leftCorner": {
              "x": -22.147,
              "y": -32.873,
              "z": 0.849
            },
            "rightCorner": {
              "x": -22.402,
              "y": -32.88,
              "z": 0.849
            },
            "gtin": "4006160639971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b6a",
            "leftCorner": {
              "x": -22.403,
              "y": -32.863,
              "z": 0.849
            },
            "rightCorner": {
              "x": -22.49,
              "y": -32.866,
              "z": 0.849
            },
            "gtin": "4006160616866",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d24f",
        "height": 1.3892,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b52",
            "leftCorner": {
              "x": -21.492,
              "y": -32.812,
              "z": 1.137
            },
            "rightCorner": {
              "x": -21.588,
              "y": -32.816,
              "z": 1.137
            },
            "gtin": "4004470637304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b54",
            "leftCorner": {
              "x": -21.587,
              "y": -32.852,
              "z": 1.137
            },
            "rightCorner": {
              "x": -21.666,
              "y": -32.854,
              "z": 1.137
            },
            "gtin": "4006160112733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b55",
            "leftCorner": {
              "x": -21.666,
              "y": -32.857,
              "z": 1.137
            },
            "rightCorner": {
              "x": -21.776,
              "y": -32.86,
              "z": 1.137
            },
            "gtin": "4006160102925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b56",
            "leftCorner": {
              "x": -21.776,
              "y": -32.864,
              "z": 1.137
            },
            "rightCorner": {
              "x": -21.986,
              "y": -32.871,
              "z": 1.137
            },
            "gtin": "4006160011067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b57",
            "leftCorner": {
              "x": -21.986,
              "y": -32.868,
              "z": 1.137
            },
            "rightCorner": {
              "x": -22.187,
              "y": -32.873,
              "z": 1.137
            },
            "gtin": "4006160119008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b58",
            "leftCorner": {
              "x": -22.187,
              "y": -32.869,
              "z": 1.137
            },
            "rightCorner": {
              "x": -22.419,
              "y": -32.876,
              "z": 1.137
            },
            "gtin": "4006160012798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b53",
            "leftCorner": {
              "x": -22.42,
              "y": -32.86,
              "z": 1.137
            },
            "rightCorner": {
              "x": -22.491,
              "y": -32.862,
              "z": 1.137
            },
            "gtin": "4006160632972",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d250",
        "height": 1.689,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b59",
            "leftCorner": {
              "x": -21.492,
              "y": -32.813,
              "z": 1.382
            },
            "rightCorner": {
              "x": -21.574,
              "y": -32.815,
              "z": 1.382
            },
            "gtin": "4006160715514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b5b",
            "leftCorner": {
              "x": -21.573,
              "y": -32.85,
              "z": 1.382
            },
            "rightCorner": {
              "x": -21.651,
              "y": -32.852,
              "z": 1.382
            },
            "gtin": "4006160645583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b5c",
            "leftCorner": {
              "x": -21.65,
              "y": -32.854,
              "z": 1.382
            },
            "rightCorner": {
              "x": -21.734,
              "y": -32.857,
              "z": 1.382
            },
            "gtin": "4006160635713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b5d",
            "leftCorner": {
              "x": -21.734,
              "y": -32.861,
              "z": 1.382
            },
            "rightCorner": {
              "x": -21.788,
              "y": -32.862,
              "z": 1.382
            },
            "gtin": "4006160305005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b5e",
            "leftCorner": {
              "x": -21.788,
              "y": -32.861,
              "z": 1.382
            },
            "rightCorner": {
              "x": -21.872,
              "y": -32.864,
              "z": 1.382
            },
            "gtin": "4013833067504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b5f",
            "leftCorner": {
              "x": -21.872,
              "y": -32.866,
              "z": 1.382
            },
            "rightCorner": {
              "x": -21.954,
              "y": -32.868,
              "z": 1.382
            },
            "gtin": "4006160639476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b60",
            "leftCorner": {
              "x": -21.954,
              "y": -32.866,
              "z": 1.382
            },
            "rightCorner": {
              "x": -22.117,
              "y": -32.87,
              "z": 1.382
            },
            "gtin": "4067522060147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b61",
            "leftCorner": {
              "x": -22.117,
              "y": -32.875,
              "z": 1.382
            },
            "rightCorner": {
              "x": -22.223,
              "y": -32.879,
              "z": 1.382
            },
            "gtin": "4067522025214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b62",
            "leftCorner": {
              "x": -22.223,
              "y": -32.87,
              "z": 1.382
            },
            "rightCorner": {
              "x": -22.344,
              "y": -32.874,
              "z": 1.382
            },
            "gtin": "7333282003258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b5a",
            "leftCorner": {
              "x": -22.344,
              "y": -32.864,
              "z": 1.382
            },
            "rightCorner": {
              "x": -22.49,
              "y": -32.868,
              "z": 1.382
            },
            "gtin": "3121040092767",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "371"
  },
  {
    "id": "371",
    "name": "371",
    "x": -22.487,
    "y": -32.934,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99989,
      "w": 0.014686
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d755",
        "height": 0.16761,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b74",
            "leftCorner": {
              "x": -22.489,
              "y": -32.854,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.535,
              "y": -32.854,
              "z": 0.137
            },
            "gtin": "4306188000587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b975794ee26054c5f1a3dcc8",
            "leftCorner": {
              "x": -23.38,
              "y": -32.85,
              "z": 0.137
            },
            "rightCorner": {
              "x": -23.464,
              "y": -32.853,
              "z": 0.137
            },
            "gtin": "4007519031552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b75",
            "leftCorner": {
              "x": -22.535,
              "y": -32.876,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.846,
              "y": -32.885,
              "z": 0.137
            },
            "gtin": "4306188000587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b76",
            "leftCorner": {
              "x": -22.847,
              "y": -32.874,
              "z": 0.137
            },
            "rightCorner": {
              "x": -23.171,
              "y": -32.883,
              "z": 0.137
            },
            "gtin": "4306188423126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b77",
            "leftCorner": {
              "x": -23.171,
              "y": -32.883,
              "z": 0.137
            },
            "rightCorner": {
              "x": -23.292,
              "y": -32.887,
              "z": 0.137
            },
            "gtin": "4306188034926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b78",
            "leftCorner": {
              "x": -23.292,
              "y": -32.888,
              "z": 0.137
            },
            "rightCorner": {
              "x": -23.379,
              "y": -32.89,
              "z": 0.137
            },
            "gtin": "4306188042174",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d754",
        "height": 0.43194,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88d2",
            "leftCorner": {
              "x": -22.489,
              "y": -32.859,
              "z": 0.353
            },
            "rightCorner": {
              "x": -22.879,
              "y": -32.87,
              "z": 0.353
            },
            "gtin": "4008284320506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4f3bd659ca8d2d17c0d8b990",
            "leftCorner": {
              "x": -23.174,
              "y": -32.879,
              "z": 0.353
            },
            "rightCorner": {
              "x": -23.469,
              "y": -32.888,
              "z": 0.353
            },
            "gtin": "8721037108324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88d4",
            "leftCorner": {
              "x": -22.878,
              "y": -32.909,
              "z": 0.353
            },
            "rightCorner": {
              "x": -23.173,
              "y": -32.917,
              "z": 0.353
            },
            "gtin": "4008284120601",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d753",
        "height": 0.70495,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88ca",
            "leftCorner": {
              "x": -22.489,
              "y": -32.869,
              "z": 0.577
            },
            "rightCorner": {
              "x": -22.87,
              "y": -32.88,
              "z": 0.577
            },
            "gtin": "4008871200846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "03388f3791199b92be119faa",
            "leftCorner": {
              "x": -23.409,
              "y": -32.896,
              "z": 0.577
            },
            "rightCorner": {
              "x": -23.467,
              "y": -32.898,
              "z": 0.577
            },
            "gtin": "8720573141871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88cb",
            "leftCorner": {
              "x": -22.869,
              "y": -32.922,
              "z": 0.577
            },
            "rightCorner": {
              "x": -23.148,
              "y": -32.93,
              "z": 0.577
            },
            "gtin": "4306188365488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88cc",
            "leftCorner": {
              "x": -23.148,
              "y": -32.926,
              "z": 0.577
            },
            "rightCorner": {
              "x": -23.408,
              "y": -32.934,
              "z": 0.577
            },
            "gtin": "4306188365518",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d757",
        "height": 0.97882,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88de",
            "leftCorner": {
              "x": -22.489,
              "y": -32.866,
              "z": 0.801
            },
            "rightCorner": {
              "x": -22.909,
              "y": -32.879,
              "z": 0.801
            },
            "gtin": "4306188379089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88e0",
            "leftCorner": {
              "x": -22.908,
              "y": -32.916,
              "z": 0.801
            },
            "rightCorner": {
              "x": -23.344,
              "y": -32.929,
              "z": 0.801
            },
            "gtin": "4306188379140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88df",
            "leftCorner": {
              "x": -23.344,
              "y": -32.933,
              "z": 0.801
            },
            "rightCorner": {
              "x": -23.488,
              "y": -32.938,
              "z": 0.801
            },
            "gtin": "4008284070517",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d756",
        "height": 1.2577,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88da",
            "leftCorner": {
              "x": -22.489,
              "y": -32.863,
              "z": 1.029
            },
            "rightCorner": {
              "x": -22.919,
              "y": -32.876,
              "z": 1.029
            },
            "gtin": "4007519052120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88dc",
            "leftCorner": {
              "x": -22.918,
              "y": -32.915,
              "z": 1.029
            },
            "rightCorner": {
              "x": -23.071,
              "y": -32.92,
              "z": 1.029
            },
            "gtin": "4306188365396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88dd",
            "leftCorner": {
              "x": -23.071,
              "y": -32.918,
              "z": 1.029
            },
            "rightCorner": {
              "x": -23.333,
              "y": -32.926,
              "z": 1.029
            },
            "gtin": "9009473002413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88db",
            "leftCorner": {
              "x": -23.333,
              "y": -32.936,
              "z": 1.029
            },
            "rightCorner": {
              "x": -23.488,
              "y": -32.941,
              "z": 1.029
            },
            "gtin": "4306188365426",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d758",
        "height": 1.5206,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88e1",
            "leftCorner": {
              "x": -22.489,
              "y": -32.851,
              "z": 1.244
            },
            "rightCorner": {
              "x": -22.976,
              "y": -32.865,
              "z": 1.244
            },
            "gtin": "4008871200372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88e3",
            "leftCorner": {
              "x": -22.976,
              "y": -32.901,
              "z": 1.244
            },
            "rightCorner": {
              "x": -23.338,
              "y": -32.912,
              "z": 1.244
            },
            "gtin": "4008871200365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88e2",
            "leftCorner": {
              "x": -23.338,
              "y": -32.92,
              "z": 1.244
            },
            "rightCorner": {
              "x": -23.488,
              "y": -32.924,
              "z": 1.244
            },
            "gtin": "4007519035703",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d752",
        "height": 1.7575,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88ba",
            "leftCorner": {
              "x": -22.489,
              "y": -32.863,
              "z": 1.438
            },
            "rightCorner": {
              "x": -22.645,
              "y": -32.868,
              "z": 1.438
            },
            "gtin": "4008284065469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "641d5b8bde2dd2f40d727575",
            "leftCorner": {
              "x": -23.32,
              "y": -32.887,
              "z": 1.438
            },
            "rightCorner": {
              "x": -23.465,
              "y": -32.892,
              "z": 1.438
            },
            "gtin": "4007519051314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88bb",
            "leftCorner": {
              "x": -22.644,
              "y": -32.914,
              "z": 1.438
            },
            "rightCorner": {
              "x": -22.699,
              "y": -32.915,
              "z": 1.438
            },
            "gtin": "4306188378938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88bc",
            "leftCorner": {
              "x": -22.699,
              "y": -32.91,
              "z": 1.438
            },
            "rightCorner": {
              "x": -22.812,
              "y": -32.914,
              "z": 1.438
            },
            "gtin": "4306188378938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88bd",
            "leftCorner": {
              "x": -22.812,
              "y": -32.912,
              "z": 1.438
            },
            "rightCorner": {
              "x": -22.933,
              "y": -32.915,
              "z": 1.438
            },
            "gtin": "4306188378877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88be",
            "leftCorner": {
              "x": -22.933,
              "y": -32.91,
              "z": 1.438
            },
            "rightCorner": {
              "x": -23.041,
              "y": -32.913,
              "z": 1.438
            },
            "gtin": "4306188041108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88bf",
            "leftCorner": {
              "x": -23.041,
              "y": -32.916,
              "z": 1.438
            },
            "rightCorner": {
              "x": -23.13,
              "y": -32.918,
              "z": 1.438
            },
            "gtin": "4008871213129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88c0",
            "leftCorner": {
              "x": -23.13,
              "y": -32.921,
              "z": 1.438
            },
            "rightCorner": {
              "x": -23.216,
              "y": -32.924,
              "z": 1.438
            },
            "gtin": "4306188365631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88c1",
            "leftCorner": {
              "x": -23.216,
              "y": -32.925,
              "z": 1.438
            },
            "rightCorner": {
              "x": -23.319,
              "y": -32.927,
              "z": 1.438
            },
            "gtin": "4007519051468",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "370",
    "rightNeighborShelfId": "372"
  },
  {
    "id": "372",
    "name": "372",
    "x": -23.489,
    "y": -32.983,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99998,
      "w": 0.005873
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 46
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d75f",
        "height": 0.17166,
        "facings": [
          {
            "id": "765c4eb11f56cf2b10e2fa66",
            "leftCorner": {
              "x": -23.49,
              "y": -33.079,
              "z": 0.14
            },
            "rightCorner": {
              "x": -23.571,
              "y": -33.078,
              "z": 0.14
            },
            "gtin": "4007519018287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ea1e43f2915024fd973bcd56",
            "leftCorner": {
              "x": -23.571,
              "y": -33.078,
              "z": 0.14
            },
            "rightCorner": {
              "x": -23.672,
              "y": -33.077,
              "z": 0.14
            },
            "gtin": "4007519027524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "de529adfa5271af43e798aaf",
            "leftCorner": {
              "x": -23.672,
              "y": -33.077,
              "z": 0.14
            },
            "rightCorner": {
              "x": -23.788,
              "y": -33.076,
              "z": 0.14
            },
            "gtin": "4007519032344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1986a393f1e5993dd8d2d9ae",
            "leftCorner": {
              "x": -23.788,
              "y": -33.076,
              "z": 0.14
            },
            "rightCorner": {
              "x": -23.911,
              "y": -33.074,
              "z": 0.14
            },
            "gtin": "4007519035086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "96fa11d27089757d43ee6d74",
            "leftCorner": {
              "x": -23.911,
              "y": -33.074,
              "z": 0.14
            },
            "rightCorner": {
              "x": -24.04,
              "y": -33.073,
              "z": 0.14
            },
            "gtin": "4007519023458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0100cab1dd2a9e6cb3ce537c",
            "leftCorner": {
              "x": -24.04,
              "y": -33.073,
              "z": 0.14
            },
            "rightCorner": {
              "x": -24.186,
              "y": -33.071,
              "z": 0.14
            },
            "gtin": "4007519034720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "446586b9897984e07d690de9",
            "leftCorner": {
              "x": -24.186,
              "y": -33.071,
              "z": 0.14
            },
            "rightCorner": {
              "x": -24.505,
              "y": -33.067,
              "z": 0.14
            },
            "gtin": "4306188365426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8b8b816d8bc6be2d7c0b2f23",
            "leftCorner": {
              "x": -24.505,
              "y": -33.067,
              "z": 0.14
            },
            "rightCorner": {
              "x": -24.738,
              "y": -33.064,
              "z": 0.14
            },
            "gtin": "4008284042224",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d75c",
        "height": 0.4276,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88d5",
            "leftCorner": {
              "x": -23.267,
              "y": -33.11,
              "z": 0.353
            },
            "rightCorner": {
              "x": -23.793,
              "y": -33.128,
              "z": 0.353
            },
            "gtin": "4306188041092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88d6",
            "leftCorner": {
              "x": -23.703,
              "y": -33.135,
              "z": 0.35
            },
            "rightCorner": {
              "x": -23.926,
              "y": -33.132,
              "z": 0.35
            },
            "gtin": "4306188041092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88d7",
            "leftCorner": {
              "x": -23.926,
              "y": -33.134,
              "z": 0.35
            },
            "rightCorner": {
              "x": -24.177,
              "y": -33.131,
              "z": 0.35
            },
            "gtin": "4306188402206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88d8",
            "leftCorner": {
              "x": -24.177,
              "y": -33.136,
              "z": 0.35
            },
            "rightCorner": {
              "x": -24.463,
              "y": -33.132,
              "z": 0.35
            },
            "gtin": "4008284042309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88d9",
            "leftCorner": {
              "x": -24.463,
              "y": -33.133,
              "z": 0.35
            },
            "rightCorner": {
              "x": -24.692,
              "y": -33.13,
              "z": 0.35
            },
            "gtin": "4007519087368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88d3",
            "leftCorner": {
              "x": -24.692,
              "y": -33.123,
              "z": 0.35
            },
            "rightCorner": {
              "x": -24.741,
              "y": -33.123,
              "z": 0.35
            },
            "gtin": "4007519085548",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d75d",
        "height": 0.70204,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88cd",
            "leftCorner": {
              "x": -23.502,
              "y": -33.131,
              "z": 0.577
            },
            "rightCorner": {
              "x": -23.91,
              "y": -33.145,
              "z": 0.577
            },
            "gtin": "4306188041085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88ce",
            "leftCorner": {
              "x": -23.82,
              "y": -33.132,
              "z": 0.574
            },
            "rightCorner": {
              "x": -24.045,
              "y": -33.129,
              "z": 0.574
            },
            "gtin": "4306188041085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88cf",
            "leftCorner": {
              "x": -24.045,
              "y": -33.129,
              "z": 0.574
            },
            "rightCorner": {
              "x": -24.285,
              "y": -33.126,
              "z": 0.574
            },
            "gtin": "4306188432814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88d0",
            "leftCorner": {
              "x": -24.285,
              "y": -33.131,
              "z": 0.574
            },
            "rightCorner": {
              "x": -24.52,
              "y": -33.129,
              "z": 0.574
            },
            "gtin": "4008284042224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88d1",
            "leftCorner": {
              "x": -24.52,
              "y": -33.125,
              "z": 0.574
            },
            "rightCorner": {
              "x": -24.707,
              "y": -33.123,
              "z": 0.574
            },
            "gtin": "4007519027579",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d75b",
        "height": 0.98994,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88eb",
            "leftCorner": {
              "x": -23.491,
              "y": -33.081,
              "z": 0.81
            },
            "rightCorner": {
              "x": -23.795,
              "y": -33.078,
              "z": 0.81
            },
            "gtin": "4008284071088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88ec",
            "leftCorner": {
              "x": -23.795,
              "y": -33.114,
              "z": 0.81
            },
            "rightCorner": {
              "x": -23.957,
              "y": -33.112,
              "z": 0.81
            },
            "gtin": "4007519027715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88ed",
            "leftCorner": {
              "x": -23.957,
              "y": -33.114,
              "z": 0.81
            },
            "rightCorner": {
              "x": -24.287,
              "y": -33.11,
              "z": 0.81
            },
            "gtin": "4306188378303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88ee",
            "leftCorner": {
              "x": -24.287,
              "y": -33.114,
              "z": 0.81
            },
            "rightCorner": {
              "x": -24.425,
              "y": -33.112,
              "z": 0.81
            },
            "gtin": "4007519027937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88ef",
            "leftCorner": {
              "x": -24.425,
              "y": -33.112,
              "z": 0.81
            },
            "rightCorner": {
              "x": -24.576,
              "y": -33.11,
              "z": 0.81
            },
            "gtin": "4007519018645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88f0",
            "leftCorner": {
              "x": -24.576,
              "y": -33.113,
              "z": 0.81
            },
            "rightCorner": {
              "x": -24.737,
              "y": -33.111,
              "z": 0.81
            },
            "gtin": "4007519018683",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d75e",
        "height": 1.2723,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88f1",
            "leftCorner": {
              "x": -23.491,
              "y": -33.086,
              "z": 1.041
            },
            "rightCorner": {
              "x": -24.005,
              "y": -33.08,
              "z": 1.041
            },
            "gtin": "4008871200730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88f2",
            "leftCorner": {
              "x": -24.006,
              "y": -33.116,
              "z": 1.041
            },
            "rightCorner": {
              "x": -24.192,
              "y": -33.114,
              "z": 1.041
            },
            "gtin": "4008284042156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88f3",
            "leftCorner": {
              "x": -24.192,
              "y": -33.12,
              "z": 1.041
            },
            "rightCorner": {
              "x": -24.321,
              "y": -33.118,
              "z": 1.041
            },
            "gtin": "4007519035024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88f4",
            "leftCorner": {
              "x": -24.32,
              "y": -33.113,
              "z": 1.041
            },
            "rightCorner": {
              "x": -24.447,
              "y": -33.112,
              "z": 1.041
            },
            "gtin": "4007519034966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88f5",
            "leftCorner": {
              "x": -24.447,
              "y": -33.116,
              "z": 1.041
            },
            "rightCorner": {
              "x": -24.598,
              "y": -33.115,
              "z": 1.041
            },
            "gtin": "4007519028248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88f6",
            "leftCorner": {
              "x": -24.598,
              "y": -33.115,
              "z": 1.041
            },
            "rightCorner": {
              "x": -24.727,
              "y": -33.113,
              "z": 1.041
            },
            "gtin": "4007519018447",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d75a",
        "height": 1.5073,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88e4",
            "leftCorner": {
              "x": -23.491,
              "y": -33.087,
              "z": 1.233
            },
            "rightCorner": {
              "x": -23.819,
              "y": -33.084,
              "z": 1.233
            },
            "gtin": "4007519035727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88e6",
            "leftCorner": {
              "x": -23.818,
              "y": -33.061,
              "z": 1.233
            },
            "rightCorner": {
              "x": -24.017,
              "y": -33.059,
              "z": 1.233
            },
            "gtin": "4007519035741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88e7",
            "leftCorner": {
              "x": -24.018,
              "y": -33.122,
              "z": 1.233
            },
            "rightCorner": {
              "x": -24.179,
              "y": -33.12,
              "z": 1.233
            },
            "gtin": "4007519035789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88e8",
            "leftCorner": {
              "x": -24.179,
              "y": -33.125,
              "z": 1.233
            },
            "rightCorner": {
              "x": -24.379,
              "y": -33.123,
              "z": 1.233
            },
            "gtin": "4007519054995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88e9",
            "leftCorner": {
              "x": -24.379,
              "y": -33.114,
              "z": 1.233
            },
            "rightCorner": {
              "x": -24.513,
              "y": -33.112,
              "z": 1.233
            },
            "gtin": "4007519018607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88ea",
            "leftCorner": {
              "x": -24.513,
              "y": -33.117,
              "z": 1.233
            },
            "rightCorner": {
              "x": -24.643,
              "y": -33.115,
              "z": 1.233
            },
            "gtin": "4007519023670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88e5",
            "leftCorner": {
              "x": -24.643,
              "y": -33.112,
              "z": 1.233
            },
            "rightCorner": {
              "x": -24.741,
              "y": -33.111,
              "z": 1.233
            },
            "gtin": "4007519028194",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d759",
        "height": 1.7564,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88c2",
            "leftCorner": {
              "x": -23.413,
              "y": -33.121,
              "z": 1.438
            },
            "rightCorner": {
              "x": -23.713,
              "y": -33.132,
              "z": 1.438
            },
            "gtin": "4007519051338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88c3",
            "leftCorner": {
              "x": -23.623,
              "y": -33.125,
              "z": 1.437
            },
            "rightCorner": {
              "x": -23.821,
              "y": -33.122,
              "z": 1.437
            },
            "gtin": "4007519051338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88c4",
            "leftCorner": {
              "x": -23.821,
              "y": -33.129,
              "z": 1.437
            },
            "rightCorner": {
              "x": -24.015,
              "y": -33.127,
              "z": 1.437
            },
            "gtin": "4008284071064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88c5",
            "leftCorner": {
              "x": -24.015,
              "y": -33.124,
              "z": 1.437
            },
            "rightCorner": {
              "x": -24.118,
              "y": -33.122,
              "z": 1.437
            },
            "gtin": "4007519027661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88c6",
            "leftCorner": {
              "x": -24.118,
              "y": -33.124,
              "z": 1.437
            },
            "rightCorner": {
              "x": -24.24,
              "y": -33.123,
              "z": 1.437
            },
            "gtin": "4306188379027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88c7",
            "leftCorner": {
              "x": -24.24,
              "y": -33.129,
              "z": 1.437
            },
            "rightCorner": {
              "x": -24.358,
              "y": -33.128,
              "z": 1.437
            },
            "gtin": "4008284071071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88c8",
            "leftCorner": {
              "x": -24.358,
              "y": -33.121,
              "z": 1.437
            },
            "rightCorner": {
              "x": -24.511,
              "y": -33.119,
              "z": 1.437
            },
            "gtin": "4007519032306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88c9",
            "leftCorner": {
              "x": -24.511,
              "y": -33.122,
              "z": 1.437
            },
            "rightCorner": {
              "x": -24.754,
              "y": -33.119,
              "z": 1.437
            },
            "gtin": "4306188378518",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "371"
  },
  {
    "id": "373",
    "name": "373",
    "x": -24.797,
    "y": -34.205,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0096777,
      "w": 0.99995
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 65
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d23a",
        "height": 0.16962,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6afe",
            "leftCorner": {
              "x": -24.416,
              "y": -34.275,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.25,
              "y": -34.272,
              "z": 0.139
            },
            "gtin": "8720573272568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "022ac46e048e15d5ea302596",
            "leftCorner": {
              "x": -24.796,
              "y": -34.283,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.741,
              "y": -34.282,
              "z": 0.139
            },
            "gtin": "4012677090181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7efddcd7f62df0dcf98d3f42",
            "leftCorner": {
              "x": -24.741,
              "y": -34.282,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.56,
              "y": -34.278,
              "z": 0.139
            },
            "gtin": "4012677090204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "154b7ff7685a503468f8c61c",
            "leftCorner": {
              "x": -24.56,
              "y": -34.278,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.505,
              "y": -34.277,
              "z": 0.139
            },
            "gtin": "4012677090181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3eae6b57e346e42762b5fcf8",
            "leftCorner": {
              "x": -24.505,
              "y": -34.277,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.45,
              "y": -34.276,
              "z": 0.139
            },
            "gtin": "4012677090181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1e5bb03060a42fdc87168b8f",
            "leftCorner": {
              "x": -24.25,
              "y": -34.272,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.195,
              "y": -34.271,
              "z": 0.139
            },
            "gtin": "4012677090181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4a92c6c41f59185446e83a33",
            "leftCorner": {
              "x": -24.195,
              "y": -34.271,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.14,
              "y": -34.27,
              "z": 0.139
            },
            "gtin": "4012677090181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c01e85fde4284379c10e0547",
            "leftCorner": {
              "x": -23.664,
              "y": -34.261,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.609,
              "y": -34.26,
              "z": 0.139
            },
            "gtin": "4012677090181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "80c8085835a3dbb54e13d727",
            "leftCorner": {
              "x": -23.609,
              "y": -34.26,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.554,
              "y": -34.259,
              "z": 0.139
            },
            "gtin": "4012677090181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b01",
            "leftCorner": {
              "x": -24.097,
              "y": -34.261,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.894,
              "y": -34.258,
              "z": 0.139
            },
            "gtin": "4012677090204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b02",
            "leftCorner": {
              "x": -23.895,
              "y": -34.243,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.665,
              "y": -34.239,
              "z": 0.139
            },
            "gtin": "4012677090181",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d238",
        "height": 0.47287,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6adf",
            "leftCorner": {
              "x": -24.797,
              "y": -34.25,
              "z": 0.387
            },
            "rightCorner": {
              "x": -24.679,
              "y": -34.248,
              "z": 0.387
            },
            "gtin": "8711295929717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ae1",
            "leftCorner": {
              "x": -24.679,
              "y": -34.183,
              "z": 0.387
            },
            "rightCorner": {
              "x": -24.59,
              "y": -34.182,
              "z": 0.387
            },
            "gtin": "8711295717505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ae2",
            "leftCorner": {
              "x": -24.59,
              "y": -34.207,
              "z": 0.387
            },
            "rightCorner": {
              "x": -24.512,
              "y": -34.205,
              "z": 0.387
            },
            "gtin": "8711295167188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ae3",
            "leftCorner": {
              "x": -24.512,
              "y": -34.203,
              "z": 0.387
            },
            "rightCorner": {
              "x": -24.422,
              "y": -34.202,
              "z": 0.387
            },
            "gtin": "8711295727047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ae4",
            "leftCorner": {
              "x": -24.422,
              "y": -34.211,
              "z": 0.387
            },
            "rightCorner": {
              "x": -24.331,
              "y": -34.21,
              "z": 0.387
            },
            "gtin": "4260460140012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ae5",
            "leftCorner": {
              "x": -24.331,
              "y": -34.194,
              "z": 0.387
            },
            "rightCorner": {
              "x": -24.238,
              "y": -34.192,
              "z": 0.387
            },
            "gtin": "8711295774829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ae6",
            "leftCorner": {
              "x": -24.238,
              "y": -34.207,
              "z": 0.387
            },
            "rightCorner": {
              "x": -24.071,
              "y": -34.204,
              "z": 0.387
            },
            "gtin": "8711295015953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ae7",
            "leftCorner": {
              "x": -24.071,
              "y": -34.199,
              "z": 0.387
            },
            "rightCorner": {
              "x": -23.948,
              "y": -34.197,
              "z": 0.387
            },
            "gtin": "4000270932335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ae8",
            "leftCorner": {
              "x": -23.949,
              "y": -34.16,
              "z": 0.387
            },
            "rightCorner": {
              "x": -23.837,
              "y": -34.158,
              "z": 0.387
            },
            "gtin": "8719987199837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ae9",
            "leftCorner": {
              "x": -23.837,
              "y": -34.187,
              "z": 0.387
            },
            "rightCorner": {
              "x": -23.736,
              "y": -34.184,
              "z": 0.387
            },
            "gtin": "8720573973656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aea",
            "leftCorner": {
              "x": -23.736,
              "y": -34.2,
              "z": 0.387
            },
            "rightCorner": {
              "x": -23.636,
              "y": -34.198,
              "z": 0.387
            },
            "gtin": "4260460139948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ae0",
            "leftCorner": {
              "x": -23.636,
              "y": -34.2,
              "z": 0.387
            },
            "rightCorner": {
              "x": -23.547,
              "y": -34.199,
              "z": 0.387
            },
            "gtin": "8711295881091",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d236",
        "height": 1.0911,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6ac4",
            "leftCorner": {
              "x": -24.799,
              "y": -34.082,
              "z": 0.893
            },
            "rightCorner": {
              "x": -24.614,
              "y": -34.079,
              "z": 0.893
            },
            "gtin": "8720573875097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ac6",
            "leftCorner": {
              "x": -24.615,
              "y": -34.05,
              "z": 0.893
            },
            "rightCorner": {
              "x": -24.533,
              "y": -34.048,
              "z": 0.893
            },
            "gtin": "8711295929083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ac7",
            "leftCorner": {
              "x": -24.533,
              "y": -34.046,
              "z": 0.893
            },
            "rightCorner": {
              "x": -24.449,
              "y": -34.044,
              "z": 0.893
            },
            "gtin": "8720573209953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ac8",
            "leftCorner": {
              "x": -24.451,
              "y": -33.936,
              "z": 0.893
            },
            "rightCorner": {
              "x": -24.334,
              "y": -33.934,
              "z": 0.893
            },
            "gtin": "8719987470349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ac9",
            "leftCorner": {
              "x": -24.332,
              "y": -34.015,
              "z": 0.893
            },
            "rightCorner": {
              "x": -24.179,
              "y": -34.011,
              "z": 0.893
            },
            "gtin": "8720573272643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aca",
            "leftCorner": {
              "x": -24.179,
              "y": -34.036,
              "z": 0.893
            },
            "rightCorner": {
              "x": -24.079,
              "y": -34.035,
              "z": 0.893
            },
            "gtin": "8719202112634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6acb",
            "leftCorner": {
              "x": -24.079,
              "y": -34.032,
              "z": 0.893
            },
            "rightCorner": {
              "x": -23.941,
              "y": -34.03,
              "z": 0.893
            },
            "gtin": "8720573209939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6acc",
            "leftCorner": {
              "x": -23.941,
              "y": -34.017,
              "z": 0.893
            },
            "rightCorner": {
              "x": -23.727,
              "y": -34.012,
              "z": 0.893
            },
            "gtin": "4000270932366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6acd",
            "leftCorner": {
              "x": -23.727,
              "y": -34.018,
              "z": 0.893
            },
            "rightCorner": {
              "x": -23.604,
              "y": -34.016,
              "z": 0.893
            },
            "gtin": "4000270932397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ace",
            "leftCorner": {
              "x": -23.606,
              "y": -33.92,
              "z": 0.893
            },
            "rightCorner": {
              "x": -23.51,
              "y": -33.918,
              "z": 0.893
            },
            "gtin": "8719202024630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ac5",
            "leftCorner": {
              "x": -23.511,
              "y": -33.903,
              "z": 0.893
            },
            "rightCorner": {
              "x": -23.469,
              "y": -33.902,
              "z": 0.893
            },
            "gtin": "4250426226270",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d239",
        "height": 1.4257,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6aeb",
            "leftCorner": {
              "x": -24.799,
              "y": -34.094,
              "z": 1.166
            },
            "rightCorner": {
              "x": -24.598,
              "y": -34.091,
              "z": 1.166
            },
            "gtin": "4260460139917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aed",
            "leftCorner": {
              "x": -24.602,
              "y": -33.932,
              "z": 1.166
            },
            "rightCorner": {
              "x": -24.502,
              "y": -33.93,
              "z": 1.166
            },
            "gtin": "4260460139993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aee",
            "leftCorner": {
              "x": -24.501,
              "y": -34.006,
              "z": 1.166
            },
            "rightCorner": {
              "x": -24.374,
              "y": -34.002,
              "z": 1.166
            },
            "gtin": "4260460139962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aef",
            "leftCorner": {
              "x": -24.373,
              "y": -34.051,
              "z": 1.166
            },
            "rightCorner": {
              "x": -24.282,
              "y": -34.049,
              "z": 1.166
            },
            "gtin": "4260460139986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6af0",
            "leftCorner": {
              "x": -24.282,
              "y": -34.052,
              "z": 1.166
            },
            "rightCorner": {
              "x": -24.218,
              "y": -34.052,
              "z": 1.166
            },
            "gtin": "4260460140081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6af1",
            "leftCorner": {
              "x": -24.218,
              "y": -34.051,
              "z": 1.166
            },
            "rightCorner": {
              "x": -24.13,
              "y": -34.049,
              "z": 1.166
            },
            "gtin": "4260460140098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6af2",
            "leftCorner": {
              "x": -24.13,
              "y": -34.042,
              "z": 1.166
            },
            "rightCorner": {
              "x": -24.057,
              "y": -34.04,
              "z": 1.166
            },
            "gtin": "4260460140074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6af3",
            "leftCorner": {
              "x": -24.057,
              "y": -34.051,
              "z": 1.166
            },
            "rightCorner": {
              "x": -23.991,
              "y": -34.049,
              "z": 1.166
            },
            "gtin": "4260460140043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6af4",
            "leftCorner": {
              "x": -23.992,
              "y": -34.036,
              "z": 1.166
            },
            "rightCorner": {
              "x": -23.921,
              "y": -34.034,
              "z": 1.166
            },
            "gtin": "4260460140067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6af5",
            "leftCorner": {
              "x": -23.921,
              "y": -34.047,
              "z": 1.166
            },
            "rightCorner": {
              "x": -23.848,
              "y": -34.046,
              "z": 1.166
            },
            "gtin": "4250426228199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6af6",
            "leftCorner": {
              "x": -23.848,
              "y": -34.025,
              "z": 1.166
            },
            "rightCorner": {
              "x": -23.775,
              "y": -34.023,
              "z": 1.166
            },
            "gtin": "4260460139979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6af7",
            "leftCorner": {
              "x": -23.775,
              "y": -34.025,
              "z": 1.166
            },
            "rightCorner": {
              "x": -23.706,
              "y": -34.023,
              "z": 1.166
            },
            "gtin": "4260460140173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6af8",
            "leftCorner": {
              "x": -23.708,
              "y": -33.946,
              "z": 1.166
            },
            "rightCorner": {
              "x": -23.612,
              "y": -33.944,
              "z": 1.166
            },
            "gtin": "4009977470003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6af9",
            "leftCorner": {
              "x": -23.61,
              "y": -34.055,
              "z": 1.166
            },
            "rightCorner": {
              "x": -23.509,
              "y": -34.054,
              "z": 1.166
            },
            "gtin": "4250426230536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aec",
            "leftCorner": {
              "x": -23.509,
              "y": -34.033,
              "z": 1.166
            },
            "rightCorner": {
              "x": -23.468,
              "y": -34.033,
              "z": 1.166
            },
            "gtin": "4000270932076",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d237",
        "height": 1.8644,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6acf",
            "leftCorner": {
              "x": -24.799,
              "y": -34.087,
              "z": 1.525
            },
            "rightCorner": {
              "x": -24.64,
              "y": -34.084,
              "z": 1.525
            },
            "gtin": "4260460140197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ad1",
            "leftCorner": {
              "x": -24.641,
              "y": -34.044,
              "z": 1.525
            },
            "rightCorner": {
              "x": -24.553,
              "y": -34.042,
              "z": 1.525
            },
            "gtin": "4260460140180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ad2",
            "leftCorner": {
              "x": -24.553,
              "y": -34.044,
              "z": 1.525
            },
            "rightCorner": {
              "x": -24.495,
              "y": -34.043,
              "z": 1.525
            },
            "gtin": "4260460140234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ad3",
            "leftCorner": {
              "x": -24.495,
              "y": -34.003,
              "z": 1.525
            },
            "rightCorner": {
              "x": -24.404,
              "y": -34.001,
              "z": 1.525
            },
            "gtin": "4260460140227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ad4",
            "leftCorner": {
              "x": -24.406,
              "y": -33.917,
              "z": 1.525
            },
            "rightCorner": {
              "x": -24.32,
              "y": -33.915,
              "z": 1.525
            },
            "gtin": "4260460140210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ad5",
            "leftCorner": {
              "x": -24.319,
              "y": -33.997,
              "z": 1.525
            },
            "rightCorner": {
              "x": -24.232,
              "y": -33.995,
              "z": 1.525
            },
            "gtin": "4260460140203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ad6",
            "leftCorner": {
              "x": -24.231,
              "y": -34.059,
              "z": 1.525
            },
            "rightCorner": {
              "x": -24.154,
              "y": -34.057,
              "z": 1.525
            },
            "gtin": "4260460140258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ad7",
            "leftCorner": {
              "x": -24.154,
              "y": -34.045,
              "z": 1.525
            },
            "rightCorner": {
              "x": -24.084,
              "y": -34.044,
              "z": 1.525
            },
            "gtin": "4260460140050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ad8",
            "leftCorner": {
              "x": -24.084,
              "y": -34.044,
              "z": 1.525
            },
            "rightCorner": {
              "x": -24.005,
              "y": -34.043,
              "z": 1.525
            },
            "gtin": "4260460140241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ad9",
            "leftCorner": {
              "x": -24.005,
              "y": -34.049,
              "z": 1.525
            },
            "rightCorner": {
              "x": -23.944,
              "y": -34.048,
              "z": 1.525
            },
            "gtin": "4260460140005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ada",
            "leftCorner": {
              "x": -23.944,
              "y": -34.049,
              "z": 1.525
            },
            "rightCorner": {
              "x": -23.87,
              "y": -34.047,
              "z": 1.525
            },
            "gtin": "4260460139955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6adb",
            "leftCorner": {
              "x": -23.872,
              "y": -33.946,
              "z": 1.525
            },
            "rightCorner": {
              "x": -23.805,
              "y": -33.945,
              "z": 1.525
            },
            "gtin": "4260460140265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6adc",
            "leftCorner": {
              "x": -23.804,
              "y": -34.027,
              "z": 1.525
            },
            "rightCorner": {
              "x": -23.752,
              "y": -34.027,
              "z": 1.525
            },
            "gtin": "4260460140289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6add",
            "leftCorner": {
              "x": -23.752,
              "y": -33.989,
              "z": 1.525
            },
            "rightCorner": {
              "x": -23.697,
              "y": -33.988,
              "z": 1.525
            },
            "gtin": "4260460140272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ade",
            "leftCorner": {
              "x": -23.697,
              "y": -34.05,
              "z": 1.525
            },
            "rightCorner": {
              "x": -23.601,
              "y": -34.048,
              "z": 1.525
            },
            "gtin": "4260460140302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ad0",
            "leftCorner": {
              "x": -23.601,
              "y": -34.047,
              "z": 1.525
            },
            "rightCorner": {
              "x": -23.55,
              "y": -34.046,
              "z": 1.525
            },
            "gtin": "4260460140296",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "374"
  },
  {
    "id": "374",
    "name": "374",
    "x": -23.547,
    "y": -34.181,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0096777,
      "w": 0.99995
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 8,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d23f",
        "height": 0.16483,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b04",
            "leftCorner": {
              "x": -23.394,
              "y": -34.254,
              "z": 0.135
            },
            "rightCorner": {
              "x": -23.022,
              "y": -34.246,
              "z": 0.135
            },
            "gtin": "4052396080780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b05",
            "leftCorner": {
              "x": -23.022,
              "y": -34.242,
              "z": 0.135
            },
            "rightCorner": {
              "x": -22.856,
              "y": -34.239,
              "z": 0.135
            },
            "gtin": "4052396081947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b06",
            "leftCorner": {
              "x": -22.856,
              "y": -34.236,
              "z": 0.135
            },
            "rightCorner": {
              "x": -22.693,
              "y": -34.233,
              "z": 0.135
            },
            "gtin": "4052396091250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b07",
            "leftCorner": {
              "x": -22.693,
              "y": -34.227,
              "z": 0.135
            },
            "rightCorner": {
              "x": -22.546,
              "y": -34.225,
              "z": 0.135
            },
            "gtin": "4000270931574",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d240",
        "height": 0.51591,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b1f",
            "leftCorner": {
              "x": -23.546,
              "y": -34.248,
              "z": 0.422
            },
            "rightCorner": {
              "x": -23.252,
              "y": -34.242,
              "z": 0.422
            },
            "gtin": "8720573678834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b21",
            "leftCorner": {
              "x": -23.253,
              "y": -34.207,
              "z": 0.422
            },
            "rightCorner": {
              "x": -23.025,
              "y": -34.202,
              "z": 0.422
            },
            "gtin": "4052396080919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b22",
            "leftCorner": {
              "x": -23.025,
              "y": -34.197,
              "z": 0.422
            },
            "rightCorner": {
              "x": -22.81,
              "y": -34.193,
              "z": 0.422
            },
            "gtin": "4000871050728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b23",
            "leftCorner": {
              "x": -22.81,
              "y": -34.192,
              "z": 0.422
            },
            "rightCorner": {
              "x": -22.625,
              "y": -34.189,
              "z": 0.422
            },
            "gtin": "4052396105049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b20",
            "leftCorner": {
              "x": -22.625,
              "y": -34.184,
              "z": 0.422
            },
            "rightCorner": {
              "x": -22.547,
              "y": -34.182,
              "z": 0.422
            },
            "gtin": "4000270931635",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d241",
        "height": 0.79684,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b24",
            "leftCorner": {
              "x": -23.546,
              "y": -34.247,
              "z": 0.652
            },
            "rightCorner": {
              "x": -23.359,
              "y": -34.243,
              "z": 0.652
            },
            "gtin": "4044935077085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b26",
            "leftCorner": {
              "x": -23.361,
              "y": -34.205,
              "z": 0.652
            },
            "rightCorner": {
              "x": -23.23,
              "y": -34.202,
              "z": 0.652
            },
            "gtin": "4000270932052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b27",
            "leftCorner": {
              "x": -23.23,
              "y": -34.202,
              "z": 0.652
            },
            "rightCorner": {
              "x": -23.072,
              "y": -34.2,
              "z": 0.652
            },
            "gtin": "4001515482912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b28",
            "leftCorner": {
              "x": -23.072,
              "y": -34.198,
              "z": 0.652
            },
            "rightCorner": {
              "x": -22.935,
              "y": -34.196,
              "z": 0.652
            },
            "gtin": "4005437305489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b29",
            "leftCorner": {
              "x": -22.935,
              "y": -34.195,
              "z": 0.652
            },
            "rightCorner": {
              "x": -22.812,
              "y": -34.193,
              "z": 0.652
            },
            "gtin": "4250426226614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b2a",
            "leftCorner": {
              "x": -22.812,
              "y": -34.189,
              "z": 0.652
            },
            "rightCorner": {
              "x": -22.722,
              "y": -34.188,
              "z": 0.652
            },
            "gtin": "4052396028669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b2b",
            "leftCorner": {
              "x": -22.722,
              "y": -34.186,
              "z": 0.652
            },
            "rightCorner": {
              "x": -22.612,
              "y": -34.184,
              "z": 0.652
            },
            "gtin": "4052396083491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b25",
            "leftCorner": {
              "x": -22.612,
              "y": -34.183,
              "z": 0.652
            },
            "rightCorner": {
              "x": -22.547,
              "y": -34.181,
              "z": 0.652
            },
            "gtin": "4052396084016",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d23e",
        "height": 1.2328,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b1b",
            "leftCorner": {
              "x": -23.55,
              "y": -34.075,
              "z": 1.009
            },
            "rightCorner": {
              "x": -23.322,
              "y": -34.071,
              "z": 1.009
            },
            "gtin": "4250426226256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b1d",
            "leftCorner": {
              "x": -23.322,
              "y": -34.052,
              "z": 1.009
            },
            "rightCorner": {
              "x": -23.214,
              "y": -34.05,
              "z": 1.009
            },
            "gtin": "4250426226232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b1e",
            "leftCorner": {
              "x": -23.216,
              "y": -34.003,
              "z": 1.009
            },
            "rightCorner": {
              "x": -23.082,
              "y": -34.0,
              "z": 1.009
            },
            "gtin": "4250426226218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b1c",
            "leftCorner": {
              "x": -23.081,
              "y": -34.005,
              "z": 1.009
            },
            "rightCorner": {
              "x": -22.551,
              "y": -33.996,
              "z": 1.009
            },
            "gtin": "4250426226195",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d243",
        "height": 1.5059,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b2c",
            "leftCorner": {
              "x": -23.55,
              "y": -34.037,
              "z": 1.232
            },
            "rightCorner": {
              "x": -22.883,
              "y": -34.024,
              "z": 1.232
            },
            "gtin": "4250426226294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b2e",
            "leftCorner": {
              "x": -22.884,
              "y": -33.984,
              "z": 1.232
            },
            "rightCorner": {
              "x": -22.687,
              "y": -33.981,
              "z": 1.232
            },
            "gtin": "4260460139931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b2d",
            "leftCorner": {
              "x": -22.685,
              "y": -34.04,
              "z": 1.232
            },
            "rightCorner": {
              "x": -22.55,
              "y": -34.037,
              "z": 1.232
            },
            "gtin": "4000270932038",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d23d",
        "height": 1.8756,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b0d",
            "leftCorner": {
              "x": -23.549,
              "y": -34.09,
              "z": 1.535
            },
            "rightCorner": {
              "x": -23.451,
              "y": -34.089,
              "z": 1.535
            },
            "gtin": "4260460139894",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b0f",
            "leftCorner": {
              "x": -23.455,
              "y": -33.875,
              "z": 1.535
            },
            "rightCorner": {
              "x": -23.352,
              "y": -33.872,
              "z": 1.535
            },
            "gtin": "4260460139870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b10",
            "leftCorner": {
              "x": -23.35,
              "y": -34.007,
              "z": 1.535
            },
            "rightCorner": {
              "x": -23.272,
              "y": -34.006,
              "z": 1.535
            },
            "gtin": "4260460139863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b11",
            "leftCorner": {
              "x": -23.272,
              "y": -34.03,
              "z": 1.535
            },
            "rightCorner": {
              "x": -23.183,
              "y": -34.029,
              "z": 1.535
            },
            "gtin": "4260460139900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b12",
            "leftCorner": {
              "x": -23.186,
              "y": -33.906,
              "z": 1.535
            },
            "rightCorner": {
              "x": -23.127,
              "y": -33.904,
              "z": 1.535
            },
            "gtin": "4260460139887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b13",
            "leftCorner": {
              "x": -23.125,
              "y": -34.059,
              "z": 1.535
            },
            "rightCorner": {
              "x": -23.072,
              "y": -34.058,
              "z": 1.535
            },
            "gtin": "4260460140104",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b14",
            "leftCorner": {
              "x": -23.072,
              "y": -34.059,
              "z": 1.535
            },
            "rightCorner": {
              "x": -23.002,
              "y": -34.058,
              "z": 1.535
            },
            "gtin": "4260460140104",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b15",
            "leftCorner": {
              "x": -23.004,
              "y": -33.993,
              "z": 1.535
            },
            "rightCorner": {
              "x": -22.944,
              "y": -33.992,
              "z": 1.535
            },
            "gtin": "4260460140166",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b16",
            "leftCorner": {
              "x": -22.943,
              "y": -34.057,
              "z": 1.535
            },
            "rightCorner": {
              "x": -22.894,
              "y": -34.056,
              "z": 1.535
            },
            "gtin": "4260460140111",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b17",
            "leftCorner": {
              "x": -22.894,
              "y": -34.051,
              "z": 1.535
            },
            "rightCorner": {
              "x": -22.839,
              "y": -34.05,
              "z": 1.535
            },
            "gtin": "4260460140128",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b18",
            "leftCorner": {
              "x": -22.839,
              "y": -34.049,
              "z": 1.535
            },
            "rightCorner": {
              "x": -22.774,
              "y": -34.047,
              "z": 1.535
            },
            "gtin": "4260460140135",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b19",
            "leftCorner": {
              "x": -22.777,
              "y": -33.9,
              "z": 1.535
            },
            "rightCorner": {
              "x": -22.708,
              "y": -33.898,
              "z": 1.535
            },
            "gtin": "4000270932243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b1a",
            "leftCorner": {
              "x": -22.705,
              "y": -34.034,
              "z": 1.535
            },
            "rightCorner": {
              "x": -22.624,
              "y": -34.033,
              "z": 1.535
            },
            "gtin": "4000270932304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b0e",
            "leftCorner": {
              "x": -22.624,
              "y": -34.03,
              "z": 1.535
            },
            "rightCorner": {
              "x": -22.55,
              "y": -34.029,
              "z": 1.535
            },
            "gtin": "4000270932274",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "373",
    "rightNeighborShelfId": "375"
  },
  {
    "id": "375",
    "name": "375",
    "x": -22.547,
    "y": -34.162,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0096777,
      "w": 0.99995
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 8,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d249",
        "height": 0.15801,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b08",
            "leftCorner": {
              "x": -22.545,
              "y": -34.211,
              "z": 0.129
            },
            "rightCorner": {
              "x": -22.458,
              "y": -34.209,
              "z": 0.129
            },
            "gtin": "4250426227390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b09",
            "leftCorner": {
              "x": -22.457,
              "y": -34.22,
              "z": 0.129
            },
            "rightCorner": {
              "x": -22.371,
              "y": -34.217,
              "z": 0.129
            },
            "gtin": "4250426227390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b0a",
            "leftCorner": {
              "x": -22.371,
              "y": -34.216,
              "z": 0.129
            },
            "rightCorner": {
              "x": -22.094,
              "y": -34.21,
              "z": 0.129
            },
            "gtin": "4001515469012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b0b",
            "leftCorner": {
              "x": -22.094,
              "y": -34.207,
              "z": 0.129
            },
            "rightCorner": {
              "x": -21.847,
              "y": -34.203,
              "z": 0.129
            },
            "gtin": "4006925222240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b0c",
            "leftCorner": {
              "x": -21.847,
              "y": -34.209,
              "z": 0.129
            },
            "rightCorner": {
              "x": -21.673,
              "y": -34.205,
              "z": 0.129
            },
            "gtin": "4006925222202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6afb",
            "leftCorner": {
              "x": -21.673,
              "y": -34.196,
              "z": 0.129
            },
            "rightCorner": {
              "x": -21.545,
              "y": -34.194,
              "z": 0.129
            },
            "gtin": "4006925222165",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d246",
        "height": 0.46891,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b2f",
            "leftCorner": {
              "x": -22.545,
              "y": -34.227,
              "z": 0.384
            },
            "rightCorner": {
              "x": -22.338,
              "y": -34.223,
              "z": 0.384
            },
            "gtin": "4000270932427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "87a2002027f4c17dba0dfe36",
            "leftCorner": {
              "x": -21.885,
              "y": -34.214,
              "z": 0.384
            },
            "rightCorner": {
              "x": -21.791,
              "y": -34.212,
              "z": 0.384
            },
            "gtin": "4000270931857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b31",
            "leftCorner": {
              "x": -22.339,
              "y": -34.183,
              "z": 0.384
            },
            "rightCorner": {
              "x": -22.235,
              "y": -34.181,
              "z": 0.384
            },
            "gtin": "4000270931710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b32",
            "leftCorner": {
              "x": -22.235,
              "y": -34.179,
              "z": 0.384
            },
            "rightCorner": {
              "x": -22.143,
              "y": -34.177,
              "z": 0.384
            },
            "gtin": "4000270931697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b33",
            "leftCorner": {
              "x": -22.143,
              "y": -34.18,
              "z": 0.384
            },
            "rightCorner": {
              "x": -22.058,
              "y": -34.178,
              "z": 0.384
            },
            "gtin": "4000270931765",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b34",
            "leftCorner": {
              "x": -22.058,
              "y": -34.176,
              "z": 0.384
            },
            "rightCorner": {
              "x": -21.967,
              "y": -34.174,
              "z": 0.384
            },
            "gtin": "4000270931734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b35",
            "leftCorner": {
              "x": -21.967,
              "y": -34.175,
              "z": 0.384
            },
            "rightCorner": {
              "x": -21.886,
              "y": -34.173,
              "z": 0.384
            },
            "gtin": "4000270931888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b39",
            "leftCorner": {
              "x": -21.753,
              "y": -33.944,
              "z": 0.384
            },
            "rightCorner": {
              "x": -21.71,
              "y": -33.944,
              "z": 0.384
            },
            "gtin": "4000270931826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b3a",
            "leftCorner": {
              "x": -21.706,
              "y": -34.17,
              "z": 0.384
            },
            "rightCorner": {
              "x": -21.616,
              "y": -34.168,
              "z": 0.384
            },
            "gtin": "4000270931796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b30",
            "leftCorner": {
              "x": -21.615,
              "y": -34.172,
              "z": 0.384
            },
            "rightCorner": {
              "x": -21.546,
              "y": -34.171,
              "z": 0.384
            },
            "gtin": "4000270932212",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d24b",
        "height": 0.82048,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b4b",
            "leftCorner": {
              "x": -22.545,
              "y": -34.227,
              "z": 0.671
            },
            "rightCorner": {
              "x": -22.056,
              "y": -34.218,
              "z": 0.671
            },
            "gtin": "4250426227390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4a4b0fe5290427b0d1d12538",
            "leftCorner": {
              "x": -21.783,
              "y": -34.212,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.688,
              "y": -34.21,
              "z": 0.671
            },
            "gtin": "4026883979529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b4d",
            "leftCorner": {
              "x": -22.057,
              "y": -34.174,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.784,
              "y": -34.168,
              "z": 0.671
            },
            "gtin": "4026883979505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b4c",
            "leftCorner": {
              "x": -21.637,
              "y": -34.171,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.546,
              "y": -34.168,
              "z": 0.671
            },
            "gtin": "4026883979529",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d247",
        "height": 1.0114,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b3b",
            "leftCorner": {
              "x": -22.545,
              "y": -34.213,
              "z": 0.828
            },
            "rightCorner": {
              "x": -22.475,
              "y": -34.212,
              "z": 0.828
            },
            "gtin": "8720573210126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b3c",
            "leftCorner": {
              "x": -22.475,
              "y": -34.212,
              "z": 0.828
            },
            "rightCorner": {
              "x": -22.404,
              "y": -34.211,
              "z": 0.828
            },
            "gtin": "8720573210126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b3d",
            "leftCorner": {
              "x": -22.404,
              "y": -34.211,
              "z": 0.828
            },
            "rightCorner": {
              "x": -22.334,
              "y": -34.21,
              "z": 0.828
            },
            "gtin": "8720573210126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b3f",
            "leftCorner": {
              "x": -22.335,
              "y": -34.174,
              "z": 0.828
            },
            "rightCorner": {
              "x": -22.186,
              "y": -34.171,
              "z": 0.828
            },
            "gtin": "8720573137058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b40",
            "leftCorner": {
              "x": -22.186,
              "y": -34.167,
              "z": 0.828
            },
            "rightCorner": {
              "x": -22.08,
              "y": -34.165,
              "z": 0.828
            },
            "gtin": "4270000856709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b41",
            "leftCorner": {
              "x": -22.08,
              "y": -34.164,
              "z": 0.828
            },
            "rightCorner": {
              "x": -21.906,
              "y": -34.161,
              "z": 0.828
            },
            "gtin": "9002377007027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b42",
            "leftCorner": {
              "x": -21.906,
              "y": -34.161,
              "z": 0.828
            },
            "rightCorner": {
              "x": -21.709,
              "y": -34.157,
              "z": 0.828
            },
            "gtin": "4250426226638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b3e",
            "leftCorner": {
              "x": -21.709,
              "y": -34.162,
              "z": 0.828
            },
            "rightCorner": {
              "x": -21.546,
              "y": -34.159,
              "z": 0.828
            },
            "gtin": "4026883979536",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d24c",
        "height": 1.6807,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b50",
            "leftCorner": {
              "x": -22.547,
              "y": -34.139,
              "z": 1.375
            },
            "rightCorner": {
              "x": -21.72,
              "y": -34.124,
              "z": 1.375
            },
            "gtin": "4250426227376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b51",
            "leftCorner": {
              "x": -21.721,
              "y": -34.084,
              "z": 1.375
            },
            "rightCorner": {
              "x": -21.548,
              "y": -34.08,
              "z": 1.375
            },
            "gtin": "4250426227376",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d24a",
        "height": 1.8127,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b43",
            "leftCorner": {
              "x": -22.548,
              "y": -34.111,
              "z": 1.483
            },
            "rightCorner": {
              "x": -22.476,
              "y": -34.11,
              "z": 1.483
            },
            "gtin": "4250426227635",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b45",
            "leftCorner": {
              "x": -22.478,
              "y": -34.043,
              "z": 1.483
            },
            "rightCorner": {
              "x": -22.427,
              "y": -34.042,
              "z": 1.483
            },
            "gtin": "4250426227642",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b46",
            "leftCorner": {
              "x": -22.426,
              "y": -34.091,
              "z": 1.483
            },
            "rightCorner": {
              "x": -22.291,
              "y": -34.089,
              "z": 1.483
            },
            "gtin": "4250426227659",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b47",
            "leftCorner": {
              "x": -22.292,
              "y": -34.007,
              "z": 1.483
            },
            "rightCorner": {
              "x": -22.119,
              "y": -34.004,
              "z": 1.483
            },
            "gtin": "4250426229493",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b48",
            "leftCorner": {
              "x": -22.117,
              "y": -34.064,
              "z": 1.483
            },
            "rightCorner": {
              "x": -22.036,
              "y": -34.062,
              "z": 1.483
            },
            "gtin": "4006925553009",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b49",
            "leftCorner": {
              "x": -22.037,
              "y": -33.99,
              "z": 1.483
            },
            "rightCorner": {
              "x": -21.996,
              "y": -33.99,
              "z": 1.483
            },
            "gtin": "3168430325302",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b4a",
            "leftCorner": {
              "x": -21.996,
              "y": -34.044,
              "z": 1.483
            },
            "rightCorner": {
              "x": -21.937,
              "y": -34.043,
              "z": 1.483
            },
            "gtin": "3168430325302",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6b44",
            "leftCorner": {
              "x": -21.937,
              "y": -34.024,
              "z": 1.483
            },
            "rightCorner": {
              "x": -21.549,
              "y": -34.016,
              "z": 1.483
            },
            "gtin": "3168430325296",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "374"
  },
  {
    "id": "376",
    "name": "376",
    "x": -25.425,
    "y": -32.978,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70383,
      "w": 0.71037
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d2c7",
        "height": 0.24153,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6df4",
            "leftCorner": {
              "x": -25.516,
              "y": -32.979,
              "z": 0.198
            },
            "rightCorner": {
              "x": -25.514,
              "y": -33.191,
              "z": 0.198
            },
            "gtin": "9010041039120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6df6",
            "leftCorner": {
              "x": -25.474,
              "y": -33.191,
              "z": 0.198
            },
            "rightCorner": {
              "x": -25.47,
              "y": -33.575,
              "z": 0.198
            },
            "gtin": "4067522031079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6df7",
            "leftCorner": {
              "x": -25.492,
              "y": -33.575,
              "z": 0.198
            },
            "rightCorner": {
              "x": -25.489,
              "y": -33.858,
              "z": 0.198
            },
            "gtin": "4067522001607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6df5",
            "leftCorner": {
              "x": -25.403,
              "y": -33.857,
              "z": 0.198
            },
            "rightCorner": {
              "x": -25.4,
              "y": -34.228,
              "z": 0.198
            },
            "gtin": "4052926078393",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2c8",
        "height": 0.52959,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6df8",
            "leftCorner": {
              "x": -25.477,
              "y": -32.978,
              "z": 0.433
            },
            "rightCorner": {
              "x": -25.474,
              "y": -33.331,
              "z": 0.433
            },
            "gtin": "4036812183002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dfa",
            "leftCorner": {
              "x": -25.437,
              "y": -33.331,
              "z": 0.433
            },
            "rightCorner": {
              "x": -25.435,
              "y": -33.458,
              "z": 0.433
            },
            "gtin": "8720573224260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dfb",
            "leftCorner": {
              "x": -25.433,
              "y": -33.458,
              "z": 0.433
            },
            "rightCorner": {
              "x": -25.43,
              "y": -33.678,
              "z": 0.433
            },
            "gtin": "4015671574572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dfc",
            "leftCorner": {
              "x": -25.428,
              "y": -33.678,
              "z": 0.433
            },
            "rightCorner": {
              "x": -25.427,
              "y": -33.805,
              "z": 0.433
            }
          },
          {
            "id": "68d8e50be1820c81800d6dfd",
            "leftCorner": {
              "x": -25.427,
              "y": -33.805,
              "z": 0.433
            },
            "rightCorner": {
              "x": -25.425,
              "y": -34.079,
              "z": 0.433
            },
            "gtin": "4036812127822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6df9",
            "leftCorner": {
              "x": -25.435,
              "y": -34.08,
              "z": 0.433
            },
            "rightCorner": {
              "x": -25.434,
              "y": -34.228,
              "z": 0.433
            },
            "gtin": "8720573120876",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2c9",
        "height": 0.88276,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6dfe",
            "leftCorner": {
              "x": -25.479,
              "y": -32.978,
              "z": 0.722
            },
            "rightCorner": {
              "x": -25.474,
              "y": -33.573,
              "z": 0.722
            },
            "gtin": "8721037394666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e00",
            "leftCorner": {
              "x": -25.438,
              "y": -33.572,
              "z": 0.722
            },
            "rightCorner": {
              "x": -25.434,
              "y": -33.932,
              "z": 0.722
            },
            "gtin": "8721037303712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dff",
            "leftCorner": {
              "x": -25.426,
              "y": -33.932,
              "z": 0.722
            },
            "rightCorner": {
              "x": -25.424,
              "y": -34.228,
              "z": 0.722
            },
            "gtin": "8721037547970",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2c6",
        "height": 1.3104,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6ded",
            "leftCorner": {
              "x": -25.474,
              "y": -32.978,
              "z": 1.072
            },
            "rightCorner": {
              "x": -25.473,
              "y": -33.208,
              "z": 1.072
            },
            "gtin": "40785318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6def",
            "leftCorner": {
              "x": -25.435,
              "y": -33.208,
              "z": 1.072
            },
            "rightCorner": {
              "x": -25.432,
              "y": -33.458,
              "z": 1.072
            },
            "gtin": "8719202890860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6df0",
            "leftCorner": {
              "x": -25.43,
              "y": -33.458,
              "z": 1.072
            },
            "rightCorner": {
              "x": -25.429,
              "y": -33.597,
              "z": 1.072
            },
            "gtin": "8719202890921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6df1",
            "leftCorner": {
              "x": -25.427,
              "y": -33.597,
              "z": 1.072
            },
            "rightCorner": {
              "x": -25.425,
              "y": -33.812,
              "z": 1.072
            },
            "gtin": "8721037310840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6df2",
            "leftCorner": {
              "x": -25.423,
              "y": -33.812,
              "z": 1.072
            },
            "rightCorner": {
              "x": -25.421,
              "y": -33.983,
              "z": 1.072
            },
            "gtin": "8721037299374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6df3",
            "leftCorner": {
              "x": -25.428,
              "y": -33.983,
              "z": 1.072
            },
            "rightCorner": {
              "x": -25.427,
              "y": -34.126,
              "z": 1.072
            },
            "gtin": "8719202157468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6dee",
            "leftCorner": {
              "x": -25.418,
              "y": -34.126,
              "z": 1.072
            },
            "rightCorner": {
              "x": -25.418,
              "y": -34.228,
              "z": 1.072
            },
            "gtin": "8721037383929",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2ca",
        "height": 1.6376,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e01",
            "leftCorner": {
              "x": -25.478,
              "y": -32.978,
              "z": 1.34
            },
            "rightCorner": {
              "x": -25.471,
              "y": -33.624,
              "z": 1.34
            },
            "gtin": "9010041053973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e02",
            "leftCorner": {
              "x": -25.431,
              "y": -33.623,
              "z": 1.34
            },
            "rightCorner": {
              "x": -25.426,
              "y": -34.227,
              "z": 1.34
            },
            "gtin": "4260552544490",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "377",
    "name": "377",
    "x": -25.325,
    "y": -35.804,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69853,
      "w": 0.71558
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 31
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d2cd",
        "height": 0.26994,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e13",
            "leftCorner": {
              "x": -25.453,
              "y": -35.807,
              "z": 0.221
            },
            "rightCorner": {
              "x": -25.448,
              "y": -35.973,
              "z": 0.221
            },
            "gtin": "4260460141224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e15",
            "leftCorner": {
              "x": -25.413,
              "y": -35.972,
              "z": 0.221
            },
            "rightCorner": {
              "x": -25.409,
              "y": -36.123,
              "z": 0.221
            },
            "gtin": "4260460141231",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6e16",
            "leftCorner": {
              "x": -25.406,
              "y": -36.123,
              "z": 0.221
            },
            "rightCorner": {
              "x": -25.404,
              "y": -36.243,
              "z": 0.221
            },
            "gtin": "4260460141248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e17",
            "leftCorner": {
              "x": -25.405,
              "y": -36.243,
              "z": 0.221
            },
            "rightCorner": {
              "x": -25.401,
              "y": -36.404,
              "z": 0.221
            },
            "gtin": "4260460141262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e18",
            "leftCorner": {
              "x": -25.399,
              "y": -36.404,
              "z": 0.221
            },
            "rightCorner": {
              "x": -25.395,
              "y": -36.544,
              "z": 0.221
            },
            "gtin": "4260460141255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e19",
            "leftCorner": {
              "x": -25.342,
              "y": -36.542,
              "z": 0.221
            },
            "rightCorner": {
              "x": -25.339,
              "y": -36.686,
              "z": 0.221
            },
            "gtin": "4260460141279",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6e1a",
            "leftCorner": {
              "x": -25.383,
              "y": -36.687,
              "z": 0.221
            },
            "rightCorner": {
              "x": -25.378,
              "y": -36.876,
              "z": 0.221
            },
            "gtin": "4260460141392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e14",
            "leftCorner": {
              "x": -25.387,
              "y": -36.877,
              "z": 0.221
            },
            "rightCorner": {
              "x": -25.382,
              "y": -37.056,
              "z": 0.221
            },
            "gtin": "4250237394038",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2ce",
        "height": 0.60691,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e1b",
            "leftCorner": {
              "x": -25.388,
              "y": -35.805,
              "z": 0.497
            },
            "rightCorner": {
              "x": -25.38,
              "y": -36.179,
              "z": 0.497
            },
            "gtin": "8720006787515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e1d",
            "leftCorner": {
              "x": -25.343,
              "y": -36.178,
              "z": 0.497
            },
            "rightCorner": {
              "x": -25.336,
              "y": -36.459,
              "z": 0.497
            },
            "gtin": "8720573624671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e1e",
            "leftCorner": {
              "x": -25.333,
              "y": -36.459,
              "z": 0.497
            },
            "rightCorner": {
              "x": -25.329,
              "y": -36.662,
              "z": 0.497
            },
            "gtin": "5709386712471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e1f",
            "leftCorner": {
              "x": -25.324,
              "y": -36.661,
              "z": 0.497
            },
            "rightCorner": {
              "x": -25.32,
              "y": -36.802,
              "z": 0.497
            },
            "gtin": "4062829018488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e20",
            "leftCorner": {
              "x": -25.323,
              "y": -36.802,
              "z": 0.497
            },
            "rightCorner": {
              "x": -25.32,
              "y": -36.956,
              "z": 0.497
            },
            "gtin": "4062829018587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e1c",
            "leftCorner": {
              "x": -25.32,
              "y": -36.956,
              "z": 0.497
            },
            "rightCorner": {
              "x": -25.317,
              "y": -37.054,
              "z": 0.497
            },
            "gtin": "8720573637053",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2cf",
        "height": 1.035,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e21",
            "leftCorner": {
              "x": -25.394,
              "y": -35.805,
              "z": 0.847
            },
            "rightCorner": {
              "x": -25.383,
              "y": -36.254,
              "z": 0.847
            },
            "gtin": "4007698302771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d230c7323dc5e4b8c784a7e9",
            "leftCorner": {
              "x": -25.383,
              "y": -36.254,
              "z": 0.847
            },
            "rightCorner": {
              "x": -25.38,
              "y": -36.391,
              "z": 0.847
            },
            "gtin": "8720573968966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "61a30d3fce77b0915f75c6dd",
            "leftCorner": {
              "x": -25.38,
              "y": -36.391,
              "z": 0.847
            },
            "rightCorner": {
              "x": -25.369,
              "y": -36.838,
              "z": 0.847
            },
            "gtin": "4007698302771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e22",
            "leftCorner": {
              "x": -25.331,
              "y": -36.923,
              "z": 0.847
            },
            "rightCorner": {
              "x": -25.328,
              "y": -37.055,
              "z": 0.847
            },
            "gtin": "8720573968966",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2cc",
        "height": 1.3935,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e0a",
            "leftCorner": {
              "x": -25.391,
              "y": -35.805,
              "z": 1.14
            },
            "rightCorner": {
              "x": -25.388,
              "y": -35.906,
              "z": 1.14
            },
            "gtin": "4031052358661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e0c",
            "leftCorner": {
              "x": -25.356,
              "y": -35.905,
              "z": 1.14
            },
            "rightCorner": {
              "x": -25.353,
              "y": -36.028,
              "z": 1.14
            },
            "gtin": "4031052467820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e0d",
            "leftCorner": {
              "x": -25.361,
              "y": -36.028,
              "z": 1.14
            },
            "rightCorner": {
              "x": -25.349,
              "y": -36.495,
              "z": 1.14
            },
            "gtin": "8719987474262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e0e",
            "leftCorner": {
              "x": -25.332,
              "y": -36.496,
              "z": 1.14
            },
            "rightCorner": {
              "x": -25.331,
              "y": -36.561,
              "z": 1.14
            },
            "gtin": "4031052589843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e0f",
            "leftCorner": {
              "x": -25.329,
              "y": -36.561,
              "z": 1.14
            },
            "rightCorner": {
              "x": -25.327,
              "y": -36.641,
              "z": 1.14
            },
            "gtin": "4031052086823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e10",
            "leftCorner": {
              "x": -25.328,
              "y": -36.641,
              "z": 1.14
            },
            "rightCorner": {
              "x": -25.325,
              "y": -36.756,
              "z": 1.14
            },
            "gtin": "4067522083757",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6e11",
            "leftCorner": {
              "x": -25.327,
              "y": -36.756,
              "z": 1.14
            },
            "rightCorner": {
              "x": -25.325,
              "y": -36.871,
              "z": 1.14
            },
            "gtin": "4062828207388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e12",
            "leftCorner": {
              "x": -25.335,
              "y": -36.871,
              "z": 1.14
            },
            "rightCorner": {
              "x": -25.332,
              "y": -36.974,
              "z": 1.14
            },
            "gtin": "4062828207524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e0b",
            "leftCorner": {
              "x": -25.329,
              "y": -36.974,
              "z": 1.14
            },
            "rightCorner": {
              "x": -25.327,
              "y": -37.055,
              "z": 1.14
            },
            "gtin": "4062828207548",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2cb",
        "height": 1.7379,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e03",
            "leftCorner": {
              "x": -25.388,
              "y": -35.805,
              "z": 1.422
            },
            "rightCorner": {
              "x": -25.38,
              "y": -36.149,
              "z": 1.422
            },
            "gtin": "4099886046901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e05",
            "leftCorner": {
              "x": -25.345,
              "y": -36.148,
              "z": 1.422
            },
            "rightCorner": {
              "x": -25.34,
              "y": -36.357,
              "z": 1.422
            },
            "gtin": "8720006787515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e06",
            "leftCorner": {
              "x": -25.335,
              "y": -36.357,
              "z": 1.422
            },
            "rightCorner": {
              "x": -25.33,
              "y": -36.541,
              "z": 1.422
            },
            "gtin": "4099886055446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e07",
            "leftCorner": {
              "x": -25.325,
              "y": -36.54,
              "z": 1.422
            },
            "rightCorner": {
              "x": -25.322,
              "y": -36.635,
              "z": 1.422
            },
            "gtin": "8720006787515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e08",
            "leftCorner": {
              "x": -25.322,
              "y": -36.635,
              "z": 1.422
            },
            "rightCorner": {
              "x": -25.32,
              "y": -36.729,
              "z": 1.422
            },
            "gtin": "8720006787515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e09",
            "leftCorner": {
              "x": -25.316,
              "y": -36.729,
              "z": 1.422
            },
            "rightCorner": {
              "x": -25.311,
              "y": -36.982,
              "z": 1.422
            },
            "gtin": "4035625435957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e04",
            "leftCorner": {
              "x": -25.324,
              "y": -36.983,
              "z": 1.422
            },
            "rightCorner": {
              "x": -25.322,
              "y": -37.055,
              "z": 1.422
            },
            "gtin": "4035625435964",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "378",
    "name": "378",
    "x": -21.553,
    "y": -35.741,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99982,
      "w": 0.018866
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 51
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d22f",
        "height": 0.16498,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a78",
            "leftCorner": {
              "x": -21.557,
              "y": -35.627,
              "z": 0.135
            },
            "rightCorner": {
              "x": -21.753,
              "y": -35.634,
              "z": 0.135
            },
            "gtin": "4009049222110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a7a",
            "leftCorner": {
              "x": -21.752,
              "y": -35.674,
              "z": 0.135
            },
            "rightCorner": {
              "x": -21.905,
              "y": -35.679,
              "z": 0.135
            },
            "gtin": "4009049222042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a7b",
            "leftCorner": {
              "x": -21.905,
              "y": -35.676,
              "z": 0.135
            },
            "rightCorner": {
              "x": -22.288,
              "y": -35.691,
              "z": 0.135
            },
            "gtin": "4005437826052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a7c",
            "leftCorner": {
              "x": -22.288,
              "y": -35.694,
              "z": 0.135
            },
            "rightCorner": {
              "x": -22.633,
              "y": -35.706,
              "z": 0.135
            },
            "gtin": "4052396088588",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d22a",
        "height": 0.51562,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a3f",
            "leftCorner": {
              "x": -21.556,
              "y": -35.666,
              "z": 0.422
            },
            "rightCorner": {
              "x": -21.68,
              "y": -35.671,
              "z": 0.422
            },
            "gtin": "4250426230383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a41",
            "leftCorner": {
              "x": -21.679,
              "y": -35.708,
              "z": 0.422
            },
            "rightCorner": {
              "x": -21.777,
              "y": -35.711,
              "z": 0.422
            },
            "gtin": "4250426230406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a42",
            "leftCorner": {
              "x": -21.777,
              "y": -35.678,
              "z": 0.422
            },
            "rightCorner": {
              "x": -21.872,
              "y": -35.682,
              "z": 0.422
            },
            "gtin": "4250426230307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a43",
            "leftCorner": {
              "x": -21.871,
              "y": -35.713,
              "z": 0.422
            },
            "rightCorner": {
              "x": -21.97,
              "y": -35.716,
              "z": 0.422
            },
            "gtin": "4250426230260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a44",
            "leftCorner": {
              "x": -21.969,
              "y": -35.72,
              "z": 0.422
            },
            "rightCorner": {
              "x": -22.065,
              "y": -35.724,
              "z": 0.422
            },
            "gtin": "4250426230345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a45",
            "leftCorner": {
              "x": -22.065,
              "y": -35.727,
              "z": 0.422
            },
            "rightCorner": {
              "x": -22.179,
              "y": -35.731,
              "z": 0.422
            },
            "gtin": "4250426230598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a46",
            "leftCorner": {
              "x": -22.179,
              "y": -35.734,
              "z": 0.422
            },
            "rightCorner": {
              "x": -22.27,
              "y": -35.738,
              "z": 0.422
            },
            "gtin": "4250426230574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a47",
            "leftCorner": {
              "x": -22.27,
              "y": -35.741,
              "z": 0.422
            },
            "rightCorner": {
              "x": -22.367,
              "y": -35.744,
              "z": 0.422
            },
            "gtin": "4250426230611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a48",
            "leftCorner": {
              "x": -22.367,
              "y": -35.743,
              "z": 0.422
            },
            "rightCorner": {
              "x": -22.47,
              "y": -35.747,
              "z": 0.422
            },
            "gtin": "4250426230321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a40",
            "leftCorner": {
              "x": -22.47,
              "y": -35.743,
              "z": 0.422
            },
            "rightCorner": {
              "x": -22.553,
              "y": -35.747,
              "z": 0.422
            },
            "gtin": "4250426230284",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d22d",
        "height": 0.82869,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a67",
            "leftCorner": {
              "x": -21.555,
              "y": -35.677,
              "z": 0.678
            },
            "rightCorner": {
              "x": -21.719,
              "y": -35.683,
              "z": 0.678
            },
            "gtin": "4000871040415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a69",
            "leftCorner": {
              "x": -21.718,
              "y": -35.723,
              "z": 0.678
            },
            "rightCorner": {
              "x": -21.856,
              "y": -35.728,
              "z": 0.678
            },
            "gtin": "4052396083101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a6a",
            "leftCorner": {
              "x": -21.856,
              "y": -35.728,
              "z": 0.678
            },
            "rightCorner": {
              "x": -21.981,
              "y": -35.733,
              "z": 0.678
            },
            "gtin": "4052396083040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a6b",
            "leftCorner": {
              "x": -21.981,
              "y": -35.732,
              "z": 0.678
            },
            "rightCorner": {
              "x": -22.068,
              "y": -35.735,
              "z": 0.678
            },
            "gtin": "4052396083026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a6c",
            "leftCorner": {
              "x": -22.068,
              "y": -35.736,
              "z": 0.678
            },
            "rightCorner": {
              "x": -22.176,
              "y": -35.74,
              "z": 0.678
            },
            "gtin": "8719987414541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a6d",
            "leftCorner": {
              "x": -22.175,
              "y": -35.745,
              "z": 0.678
            },
            "rightCorner": {
              "x": -22.311,
              "y": -35.751,
              "z": 0.678
            },
            "gtin": "4005437289475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a6e",
            "leftCorner": {
              "x": -22.311,
              "y": -35.752,
              "z": 0.678
            },
            "rightCorner": {
              "x": -22.399,
              "y": -35.756,
              "z": 0.678
            },
            "gtin": "4009049544809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a6f",
            "leftCorner": {
              "x": -22.399,
              "y": -35.753,
              "z": 0.678
            },
            "rightCorner": {
              "x": -22.482,
              "y": -35.756,
              "z": 0.678
            },
            "gtin": "4009049544823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a68",
            "leftCorner": {
              "x": -22.482,
              "y": -35.755,
              "z": 0.678
            },
            "rightCorner": {
              "x": -22.553,
              "y": -35.757,
              "z": 0.678
            },
            "gtin": "4250426230369",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d22c",
        "height": 1.1308,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a5d",
            "leftCorner": {
              "x": -21.555,
              "y": -35.678,
              "z": 0.925
            },
            "rightCorner": {
              "x": -21.795,
              "y": -35.686,
              "z": 0.925
            },
            "gtin": "4009049303079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a5f",
            "leftCorner": {
              "x": -21.793,
              "y": -35.722,
              "z": 0.925
            },
            "rightCorner": {
              "x": -21.932,
              "y": -35.728,
              "z": 0.925
            },
            "gtin": "4009049303123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a60",
            "leftCorner": {
              "x": -21.932,
              "y": -35.727,
              "z": 0.925
            },
            "rightCorner": {
              "x": -22.056,
              "y": -35.731,
              "z": 0.925
            },
            "gtin": "4009049303086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a61",
            "leftCorner": {
              "x": -22.056,
              "y": -35.734,
              "z": 0.925
            },
            "rightCorner": {
              "x": -22.165,
              "y": -35.738,
              "z": 0.925
            },
            "gtin": "4009049303055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a62",
            "leftCorner": {
              "x": -22.165,
              "y": -35.741,
              "z": 0.925
            },
            "rightCorner": {
              "x": -22.27,
              "y": -35.745,
              "z": 0.925
            },
            "gtin": "4000871040903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a63",
            "leftCorner": {
              "x": -22.269,
              "y": -35.751,
              "z": 0.925
            },
            "rightCorner": {
              "x": -22.307,
              "y": -35.752,
              "z": 0.925
            },
            "gtin": "4052396081336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a64",
            "leftCorner": {
              "x": -22.307,
              "y": -35.75,
              "z": 0.925
            },
            "rightCorner": {
              "x": -22.38,
              "y": -35.753,
              "z": 0.925
            },
            "gtin": "4052396081350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a65",
            "leftCorner": {
              "x": -22.38,
              "y": -35.753,
              "z": 0.925
            },
            "rightCorner": {
              "x": -22.417,
              "y": -35.754,
              "z": 0.925
            },
            "gtin": "4052396081329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a66",
            "leftCorner": {
              "x": -22.418,
              "y": -35.749,
              "z": 0.925
            },
            "rightCorner": {
              "x": -22.478,
              "y": -35.751,
              "z": 0.925
            },
            "gtin": "4052396081305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a5e",
            "leftCorner": {
              "x": -22.478,
              "y": -35.751,
              "z": 0.925
            },
            "rightCorner": {
              "x": -22.553,
              "y": -35.754,
              "z": 0.925
            },
            "gtin": "4052396091267",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d22e",
        "height": 1.4101,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a70",
            "leftCorner": {
              "x": -21.556,
              "y": -35.666,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.78,
              "y": -35.675,
              "z": 1.154
            },
            "gtin": "4009049303147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a72",
            "leftCorner": {
              "x": -21.78,
              "y": -35.712,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.937,
              "y": -35.717,
              "z": 1.154
            },
            "gtin": "4009049359717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a73",
            "leftCorner": {
              "x": -21.937,
              "y": -35.716,
              "z": 1.154
            },
            "rightCorner": {
              "x": -22.031,
              "y": -35.719,
              "z": 1.154
            },
            "gtin": "4009049540580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a74",
            "leftCorner": {
              "x": -22.03,
              "y": -35.722,
              "z": 1.154
            },
            "rightCorner": {
              "x": -22.145,
              "y": -35.727,
              "z": 1.154
            },
            "gtin": "4009049540559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a75",
            "leftCorner": {
              "x": -22.145,
              "y": -35.731,
              "z": 1.154
            },
            "rightCorner": {
              "x": -22.257,
              "y": -35.735,
              "z": 1.154
            },
            "gtin": "4009049540566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a76",
            "leftCorner": {
              "x": -22.257,
              "y": -35.74,
              "z": 1.154
            },
            "rightCorner": {
              "x": -22.368,
              "y": -35.744,
              "z": 1.154
            },
            "gtin": "8711269947112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a77",
            "leftCorner": {
              "x": -22.368,
              "y": -35.74,
              "z": 1.154
            },
            "rightCorner": {
              "x": -22.463,
              "y": -35.744,
              "z": 1.154
            },
            "gtin": "8711269947099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a71",
            "leftCorner": {
              "x": -22.463,
              "y": -35.743,
              "z": 1.154
            },
            "rightCorner": {
              "x": -22.553,
              "y": -35.747,
              "z": 1.154
            },
            "gtin": "8720294019275",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d22b",
        "height": 1.6577,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a49",
            "leftCorner": {
              "x": -21.555,
              "y": -35.671,
              "z": 1.356
            },
            "rightCorner": {
              "x": -21.689,
              "y": -35.676,
              "z": 1.356
            },
            "gtin": "8720294022497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a4b",
            "leftCorner": {
              "x": -21.687,
              "y": -35.715,
              "z": 1.356
            },
            "rightCorner": {
              "x": -21.789,
              "y": -35.719,
              "z": 1.356
            },
            "gtin": "8720294022848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a4c",
            "leftCorner": {
              "x": -21.789,
              "y": -35.719,
              "z": 1.356
            },
            "rightCorner": {
              "x": -21.884,
              "y": -35.722,
              "z": 1.356
            },
            "gtin": "8720294023241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a4d",
            "leftCorner": {
              "x": -21.884,
              "y": -35.719,
              "z": 1.356
            },
            "rightCorner": {
              "x": -21.994,
              "y": -35.724,
              "z": 1.356
            },
            "gtin": "8720294022503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a4e",
            "leftCorner": {
              "x": -21.994,
              "y": -35.728,
              "z": 1.356
            },
            "rightCorner": {
              "x": -22.086,
              "y": -35.731,
              "z": 1.356
            },
            "gtin": "8720294022855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a4f",
            "leftCorner": {
              "x": -22.086,
              "y": -35.732,
              "z": 1.356
            },
            "rightCorner": {
              "x": -22.189,
              "y": -35.736,
              "z": 1.356
            },
            "gtin": "8720294023203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a50",
            "leftCorner": {
              "x": -22.189,
              "y": -35.741,
              "z": 1.356
            },
            "rightCorner": {
              "x": -22.302,
              "y": -35.745,
              "z": 1.356
            },
            "gtin": "8720294022473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a51",
            "leftCorner": {
              "x": -22.302,
              "y": -35.747,
              "z": 1.356
            },
            "rightCorner": {
              "x": -22.393,
              "y": -35.75,
              "z": 1.356
            },
            "gtin": "8720294022824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a52",
            "leftCorner": {
              "x": -22.393,
              "y": -35.751,
              "z": 1.356
            },
            "rightCorner": {
              "x": -22.476,
              "y": -35.754,
              "z": 1.356
            },
            "gtin": "8720294023173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a53",
            "leftCorner": {
              "x": -22.477,
              "y": -35.751,
              "z": 1.356
            },
            "rightCorner": {
              "x": -22.596,
              "y": -35.756,
              "z": 1.356
            },
            "gtin": "8720294019152",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "379"
  },
  {
    "id": "379",
    "name": "379",
    "x": -22.552,
    "y": -35.778,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99982,
      "w": 0.018866
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d235",
        "height": 0.16954,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a7d",
            "leftCorner": {
              "x": -22.632,
              "y": -35.711,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.034,
              "y": -35.726,
              "z": 0.139
            },
            "gtin": "4052396091281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a692c0b92828b9477ee83038",
            "leftCorner": {
              "x": -23.322,
              "y": -35.715,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.416,
              "y": -35.719,
              "z": 0.139
            },
            "gtin": "4014114118656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "366f963a1687f690a6a8e1ed",
            "leftCorner": {
              "x": -23.416,
              "y": -35.719,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.51,
              "y": -35.722,
              "z": 0.139
            },
            "gtin": "4014114118656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a7e",
            "leftCorner": {
              "x": -23.034,
              "y": -35.732,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.106,
              "y": -35.735,
              "z": 0.139
            },
            "gtin": "4014114118656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a7f",
            "leftCorner": {
              "x": -23.106,
              "y": -35.735,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.178,
              "y": -35.738,
              "z": 0.139
            },
            "gtin": "4014114118656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a80",
            "leftCorner": {
              "x": -23.178,
              "y": -35.738,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.249,
              "y": -35.74,
              "z": 0.139
            },
            "gtin": "4014114118656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a81",
            "leftCorner": {
              "x": -23.249,
              "y": -35.74,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.321,
              "y": -35.742,
              "z": 0.139
            },
            "gtin": "4014114118656",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d232",
        "height": 0.4535,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a9c",
            "leftCorner": {
              "x": -22.554,
              "y": -35.723,
              "z": 0.371
            },
            "rightCorner": {
              "x": -22.759,
              "y": -35.731,
              "z": 0.371
            },
            "gtin": "8711295028724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a9e",
            "leftCorner": {
              "x": -22.757,
              "y": -35.77,
              "z": 0.371
            },
            "rightCorner": {
              "x": -22.945,
              "y": -35.777,
              "z": 0.371
            },
            "gtin": "8720573089784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a9f",
            "leftCorner": {
              "x": -22.945,
              "y": -35.774,
              "z": 0.371
            },
            "rightCorner": {
              "x": -23.1,
              "y": -35.78,
              "z": 0.371
            },
            "gtin": "8720573089920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aa0",
            "leftCorner": {
              "x": -23.1,
              "y": -35.785,
              "z": 0.371
            },
            "rightCorner": {
              "x": -23.269,
              "y": -35.792,
              "z": 0.371
            },
            "gtin": "8004360020885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aa1",
            "leftCorner": {
              "x": -23.269,
              "y": -35.792,
              "z": 0.371
            },
            "rightCorner": {
              "x": -23.354,
              "y": -35.794,
              "z": 0.371
            },
            "gtin": "4009290179539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aa2",
            "leftCorner": {
              "x": -23.354,
              "y": -35.792,
              "z": 0.371
            },
            "rightCorner": {
              "x": -23.443,
              "y": -35.795,
              "z": 0.371
            },
            "gtin": "4009290190268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aa3",
            "leftCorner": {
              "x": -23.443,
              "y": -35.797,
              "z": 0.371
            },
            "rightCorner": {
              "x": -23.579,
              "y": -35.803,
              "z": 0.371
            },
            "gtin": "4000753145771",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d234",
        "height": 0.80293,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6abc",
            "leftCorner": {
              "x": -22.554,
              "y": -35.721,
              "z": 0.657
            },
            "rightCorner": {
              "x": -22.685,
              "y": -35.726,
              "z": 0.657
            },
            "gtin": "8411712086428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6abd",
            "leftCorner": {
              "x": -22.685,
              "y": -35.726,
              "z": 0.657
            },
            "rightCorner": {
              "x": -22.817,
              "y": -35.731,
              "z": 0.657
            },
            "gtin": "8411712086428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6abf",
            "leftCorner": {
              "x": -22.814,
              "y": -35.768,
              "z": 0.657
            },
            "rightCorner": {
              "x": -22.905,
              "y": -35.772,
              "z": 0.657
            },
            "gtin": "8411712086442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ac0",
            "leftCorner": {
              "x": -22.905,
              "y": -35.772,
              "z": 0.657
            },
            "rightCorner": {
              "x": -22.996,
              "y": -35.775,
              "z": 0.657
            },
            "gtin": "8411712086442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ac1",
            "leftCorner": {
              "x": -22.996,
              "y": -35.778,
              "z": 0.657
            },
            "rightCorner": {
              "x": -23.173,
              "y": -35.785,
              "z": 0.657
            },
            "gtin": "8411712086459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ac2",
            "leftCorner": {
              "x": -23.173,
              "y": -35.787,
              "z": 0.657
            },
            "rightCorner": {
              "x": -23.282,
              "y": -35.791,
              "z": 0.657
            },
            "gtin": "4000753162549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ac3",
            "leftCorner": {
              "x": -23.282,
              "y": -35.794,
              "z": 0.657
            },
            "rightCorner": {
              "x": -23.478,
              "y": -35.802,
              "z": 0.657
            },
            "gtin": "8008903702450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6abe",
            "leftCorner": {
              "x": -23.478,
              "y": -35.801,
              "z": 0.657
            },
            "rightCorner": {
              "x": -23.552,
              "y": -35.804,
              "z": 0.657
            },
            "gtin": "8004360074567",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d231",
        "height": 1.1559,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a89",
            "leftCorner": {
              "x": -22.554,
              "y": -35.72,
              "z": 0.946
            },
            "rightCorner": {
              "x": -22.755,
              "y": -35.727,
              "z": 0.946
            },
            "gtin": "4045486233241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a8b",
            "leftCorner": {
              "x": -22.753,
              "y": -35.767,
              "z": 0.946
            },
            "rightCorner": {
              "x": -22.838,
              "y": -35.771,
              "z": 0.946
            },
            "gtin": "4045486233234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a8c",
            "leftCorner": {
              "x": -22.839,
              "y": -35.766,
              "z": 0.946
            },
            "rightCorner": {
              "x": -22.925,
              "y": -35.769,
              "z": 0.946
            },
            "gtin": "4045486233173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a8d",
            "leftCorner": {
              "x": -22.925,
              "y": -35.771,
              "z": 0.946
            },
            "rightCorner": {
              "x": -23.015,
              "y": -35.775,
              "z": 0.946
            },
            "gtin": "4045486233227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a8e",
            "leftCorner": {
              "x": -23.015,
              "y": -35.775,
              "z": 0.946
            },
            "rightCorner": {
              "x": -23.108,
              "y": -35.779,
              "z": 0.946
            },
            "gtin": "4045486233166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a8f",
            "leftCorner": {
              "x": -23.108,
              "y": -35.782,
              "z": 0.946
            },
            "rightCorner": {
              "x": -23.196,
              "y": -35.785,
              "z": 0.946
            },
            "gtin": "4045486233210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a90",
            "leftCorner": {
              "x": -23.196,
              "y": -35.786,
              "z": 0.946
            },
            "rightCorner": {
              "x": -23.38,
              "y": -35.793,
              "z": 0.946
            },
            "gtin": "4045486233159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a91",
            "leftCorner": {
              "x": -23.38,
              "y": -35.795,
              "z": 0.946
            },
            "rightCorner": {
              "x": -23.467,
              "y": -35.798,
              "z": 0.946
            },
            "gtin": "4045486233203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a92",
            "leftCorner": {
              "x": -23.467,
              "y": -35.795,
              "z": 0.946
            },
            "rightCorner": {
              "x": -23.582,
              "y": -35.799,
              "z": 0.946
            },
            "gtin": "4045486233142",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d233",
        "height": 1.434,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6aad",
            "leftCorner": {
              "x": -22.554,
              "y": -35.713,
              "z": 1.173
            },
            "rightCorner": {
              "x": -22.78,
              "y": -35.722,
              "z": 1.173
            },
            "gtin": "4045486233067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aaf",
            "leftCorner": {
              "x": -22.779,
              "y": -35.76,
              "z": 1.173
            },
            "rightCorner": {
              "x": -22.965,
              "y": -35.767,
              "z": 1.173
            },
            "gtin": "4045486233050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ab0",
            "leftCorner": {
              "x": -22.965,
              "y": -35.767,
              "z": 1.173
            },
            "rightCorner": {
              "x": -23.152,
              "y": -35.774,
              "z": 1.173
            },
            "gtin": "4045486233043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ab1",
            "leftCorner": {
              "x": -23.152,
              "y": -35.777,
              "z": 1.173
            },
            "rightCorner": {
              "x": -23.343,
              "y": -35.785,
              "z": 1.173
            },
            "gtin": "4045486233036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ab2",
            "leftCorner": {
              "x": -23.343,
              "y": -35.785,
              "z": 1.173
            },
            "rightCorner": {
              "x": -23.601,
              "y": -35.794,
              "z": 1.173
            },
            "gtin": "4045486233029",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d230",
        "height": 1.658,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a54",
            "leftCorner": {
              "x": -22.596,
              "y": -35.757,
              "z": 1.357
            },
            "rightCorner": {
              "x": -22.684,
              "y": -35.761,
              "z": 1.357
            },
            "gtin": "4005437193161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a55",
            "leftCorner": {
              "x": -22.684,
              "y": -35.753,
              "z": 1.357
            },
            "rightCorner": {
              "x": -22.768,
              "y": -35.757,
              "z": 1.357
            },
            "gtin": "4005437193185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a56",
            "leftCorner": {
              "x": -22.768,
              "y": -35.759,
              "z": 1.357
            },
            "rightCorner": {
              "x": -22.851,
              "y": -35.762,
              "z": 1.357
            },
            "gtin": "4005437193208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a57",
            "leftCorner": {
              "x": -22.851,
              "y": -35.763,
              "z": 1.357
            },
            "rightCorner": {
              "x": -22.954,
              "y": -35.768,
              "z": 1.357
            },
            "gtin": "8004360061208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a58",
            "leftCorner": {
              "x": -22.953,
              "y": -35.772,
              "z": 1.357
            },
            "rightCorner": {
              "x": -23.06,
              "y": -35.775,
              "z": 1.357
            },
            "gtin": "8004360007961",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6a59",
            "leftCorner": {
              "x": -23.06,
              "y": -35.778,
              "z": 1.357
            },
            "rightCorner": {
              "x": -23.163,
              "y": -35.782,
              "z": 1.357
            },
            "gtin": "8004360007985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a5a",
            "leftCorner": {
              "x": -23.163,
              "y": -35.783,
              "z": 1.357
            },
            "rightCorner": {
              "x": -23.275,
              "y": -35.788,
              "z": 1.357
            },
            "gtin": "8004360008029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a5b",
            "leftCorner": {
              "x": -23.275,
              "y": -35.79,
              "z": 1.357
            },
            "rightCorner": {
              "x": -23.366,
              "y": -35.793,
              "z": 1.357
            },
            "gtin": "4005437243057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a5c",
            "leftCorner": {
              "x": -23.366,
              "y": -35.791,
              "z": 1.357
            },
            "rightCorner": {
              "x": -23.476,
              "y": -35.795,
              "z": 1.357
            },
            "gtin": "4005437243071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a4a",
            "leftCorner": {
              "x": -23.476,
              "y": -35.796,
              "z": 1.357
            },
            "rightCorner": {
              "x": -23.552,
              "y": -35.799,
              "z": 1.357
            },
            "gtin": "4005437243095",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "378",
    "rightNeighborShelfId": "37a"
  },
  {
    "id": "37a",
    "name": "37a",
    "x": -23.552,
    "y": -35.816,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99982,
      "w": 0.018866
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 46
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d766",
        "height": 0.17283,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a84",
            "leftCorner": {
              "x": -24.154,
              "y": -35.765,
              "z": 0.141
            },
            "rightCorner": {
              "x": -24.36,
              "y": -35.773,
              "z": 0.141
            },
            "gtin": "4009290175203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b58bd7366e635be2d1be67f5",
            "leftCorner": {
              "x": -23.556,
              "y": -35.712,
              "z": 0.141
            },
            "rightCorner": {
              "x": -23.751,
              "y": -35.719,
              "z": 0.141
            },
            "gtin": "4009290175203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "efd8fa7bf734d9dc6d186538",
            "leftCorner": {
              "x": -23.751,
              "y": -35.719,
              "z": 0.141
            },
            "rightCorner": {
              "x": -23.946,
              "y": -35.727,
              "z": 0.141
            },
            "gtin": "4009290175203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c49c626d8e5fa04fbd7f6867",
            "leftCorner": {
              "x": -23.946,
              "y": -35.727,
              "z": 0.141
            },
            "rightCorner": {
              "x": -24.141,
              "y": -35.734,
              "z": 0.141
            },
            "gtin": "4009290175203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0fc6c6a848e197552e1ea9e9",
            "leftCorner": {
              "x": -24.361,
              "y": -35.742,
              "z": 0.141
            },
            "rightCorner": {
              "x": -24.556,
              "y": -35.75,
              "z": 0.141
            },
            "gtin": "4009290175203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7bbfdca831e887596a525035",
            "leftCorner": {
              "x": -24.556,
              "y": -35.75,
              "z": 0.141
            },
            "rightCorner": {
              "x": -24.751,
              "y": -35.757,
              "z": 0.141
            },
            "gtin": "4009290175203",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d761",
        "height": 0.45571,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6aa4",
            "leftCorner": {
              "x": -23.579,
              "y": -35.808,
              "z": 0.373
            },
            "rightCorner": {
              "x": -23.722,
              "y": -35.814,
              "z": 0.373
            },
            "gtin": "4009290028066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aa5",
            "leftCorner": {
              "x": -23.722,
              "y": -35.815,
              "z": 0.373
            },
            "rightCorner": {
              "x": -23.784,
              "y": -35.817,
              "z": 0.373
            },
            "gtin": "4000270932090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aa6",
            "leftCorner": {
              "x": -23.784,
              "y": -35.817,
              "z": 0.373
            },
            "rightCorner": {
              "x": -23.846,
              "y": -35.818,
              "z": 0.373
            },
            "gtin": "4000270932090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aa7",
            "leftCorner": {
              "x": -23.846,
              "y": -35.818,
              "z": 0.373
            },
            "rightCorner": {
              "x": -23.908,
              "y": -35.821,
              "z": 0.373
            },
            "gtin": "4000270932090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aa8",
            "leftCorner": {
              "x": -23.908,
              "y": -35.822,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.135,
              "y": -35.83,
              "z": 0.373
            },
            "gtin": "4000270932120",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6aa9",
            "leftCorner": {
              "x": -24.135,
              "y": -35.831,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.355,
              "y": -35.84,
              "z": 0.373
            },
            "gtin": "4000270931918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aaa",
            "leftCorner": {
              "x": -24.355,
              "y": -35.837,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.523,
              "y": -35.843,
              "z": 0.373
            },
            "gtin": "4000270931666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aab",
            "leftCorner": {
              "x": -24.523,
              "y": -35.842,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.622,
              "y": -35.846,
              "z": 0.373
            },
            "gtin": "4000270931949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aac",
            "leftCorner": {
              "x": -24.622,
              "y": -35.844,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.715,
              "y": -35.847,
              "z": 0.373
            },
            "gtin": "4000270931970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a9d",
            "leftCorner": {
              "x": -24.715,
              "y": -35.847,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.802,
              "y": -35.851,
              "z": 0.373
            },
            "gtin": "4000270932007",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d763",
        "height": 0.81931,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88f7",
            "leftCorner": {
              "x": -23.554,
              "y": -35.752,
              "z": 0.67
            },
            "rightCorner": {
              "x": -23.761,
              "y": -35.759,
              "z": 0.67
            },
            "gtin": "8008903702542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88f9",
            "leftCorner": {
              "x": -23.76,
              "y": -35.797,
              "z": 0.67
            },
            "rightCorner": {
              "x": -23.856,
              "y": -35.801,
              "z": 0.67
            },
            "gtin": "8711295645853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88fa",
            "leftCorner": {
              "x": -23.856,
              "y": -35.802,
              "z": 0.67
            },
            "rightCorner": {
              "x": -24.002,
              "y": -35.807,
              "z": 0.67
            },
            "gtin": "8711295780158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88fb",
            "leftCorner": {
              "x": -24.002,
              "y": -35.81,
              "z": 0.67
            },
            "rightCorner": {
              "x": -24.178,
              "y": -35.817,
              "z": 0.67
            },
            "gtin": "8693357061941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88fc",
            "leftCorner": {
              "x": -24.178,
              "y": -35.817,
              "z": 0.67
            },
            "rightCorner": {
              "x": -24.407,
              "y": -35.826,
              "z": 0.67
            },
            "gtin": "4000270931611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88fd",
            "leftCorner": {
              "x": -24.407,
              "y": -35.822,
              "z": 0.67
            },
            "rightCorner": {
              "x": -24.57,
              "y": -35.828,
              "z": 0.67
            },
            "gtin": "4000848831022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88fe",
            "leftCorner": {
              "x": -24.57,
              "y": -35.829,
              "z": 0.67
            },
            "rightCorner": {
              "x": -24.718,
              "y": -35.834,
              "z": 0.67
            },
            "gtin": "8711295388651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d88f8",
            "leftCorner": {
              "x": -24.718,
              "y": -35.834,
              "z": 0.67
            },
            "rightCorner": {
              "x": -24.802,
              "y": -35.837,
              "z": 0.67
            },
            "gtin": "8719202117950",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d760",
        "height": 1.1585,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a93",
            "leftCorner": {
              "x": -23.582,
              "y": -35.804,
              "z": 0.948
            },
            "rightCorner": {
              "x": -23.69,
              "y": -35.808,
              "z": 0.948
            },
            "gtin": "4045486233180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a94",
            "leftCorner": {
              "x": -23.69,
              "y": -35.807,
              "z": 0.948
            },
            "rightCorner": {
              "x": -23.787,
              "y": -35.811,
              "z": 0.948
            },
            "gtin": "8720573580250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a95",
            "leftCorner": {
              "x": -23.787,
              "y": -35.813,
              "z": 0.948
            },
            "rightCorner": {
              "x": -23.881,
              "y": -35.817,
              "z": 0.948
            },
            "gtin": "4005437820760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a96",
            "leftCorner": {
              "x": -23.881,
              "y": -35.817,
              "z": 0.948
            },
            "rightCorner": {
              "x": -23.964,
              "y": -35.82,
              "z": 0.948
            },
            "gtin": "4000270932151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a97",
            "leftCorner": {
              "x": -23.964,
              "y": -35.821,
              "z": 0.948
            },
            "rightCorner": {
              "x": -24.051,
              "y": -35.824,
              "z": 0.948
            },
            "gtin": "8004360060010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a98",
            "leftCorner": {
              "x": -24.051,
              "y": -35.822,
              "z": 0.948
            },
            "rightCorner": {
              "x": -24.136,
              "y": -35.825,
              "z": 0.948
            },
            "gtin": "4009290164412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a99",
            "leftCorner": {
              "x": -24.136,
              "y": -35.826,
              "z": 0.948
            },
            "rightCorner": {
              "x": -24.229,
              "y": -35.83,
              "z": 0.948
            },
            "gtin": "4009290115513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a9a",
            "leftCorner": {
              "x": -24.229,
              "y": -35.83,
              "z": 0.948
            },
            "rightCorner": {
              "x": -24.45,
              "y": -35.838,
              "z": 0.948
            },
            "gtin": "4000848511733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a9b",
            "leftCorner": {
              "x": -24.45,
              "y": -35.835,
              "z": 0.948
            },
            "rightCorner": {
              "x": -24.651,
              "y": -35.843,
              "z": 0.948
            },
            "gtin": "4000848511719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a8a",
            "leftCorner": {
              "x": -24.651,
              "y": -35.847,
              "z": 0.948
            },
            "rightCorner": {
              "x": -24.802,
              "y": -35.853,
              "z": 0.948
            },
            "gtin": "4000848511726",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d764",
        "height": 1.4366,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6ab3",
            "leftCorner": {
              "x": -23.602,
              "y": -35.792,
              "z": 1.175
            },
            "rightCorner": {
              "x": -23.768,
              "y": -35.798,
              "z": 1.175
            },
            "gtin": "4250426227178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ab4",
            "leftCorner": {
              "x": -23.768,
              "y": -35.802,
              "z": 1.175
            },
            "rightCorner": {
              "x": -23.859,
              "y": -35.806,
              "z": 1.175
            },
            "gtin": "4250426227192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ab5",
            "leftCorner": {
              "x": -23.859,
              "y": -35.806,
              "z": 1.175
            },
            "rightCorner": {
              "x": -23.948,
              "y": -35.809,
              "z": 1.175
            },
            "gtin": "8721037347778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ab6",
            "leftCorner": {
              "x": -23.947,
              "y": -35.811,
              "z": 1.175
            },
            "rightCorner": {
              "x": -24.058,
              "y": -35.815,
              "z": 1.175
            },
            "gtin": "4007698529024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ab7",
            "leftCorner": {
              "x": -24.058,
              "y": -35.813,
              "z": 1.175
            },
            "rightCorner": {
              "x": -24.159,
              "y": -35.817,
              "z": 1.175
            },
            "gtin": "8721037347655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ab8",
            "leftCorner": {
              "x": -24.159,
              "y": -35.816,
              "z": 1.175
            },
            "rightCorner": {
              "x": -24.383,
              "y": -35.825,
              "z": 1.175
            },
            "gtin": "8721037352628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ab9",
            "leftCorner": {
              "x": -24.383,
              "y": -35.822,
              "z": 1.175
            },
            "rightCorner": {
              "x": -24.581,
              "y": -35.829,
              "z": 1.175
            },
            "gtin": "8721037353267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6aba",
            "leftCorner": {
              "x": -24.581,
              "y": -35.833,
              "z": 1.175
            },
            "rightCorner": {
              "x": -24.68,
              "y": -35.837,
              "z": 1.175
            },
            "gtin": "8721037113212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6abb",
            "leftCorner": {
              "x": -24.68,
              "y": -35.837,
              "z": 1.175
            },
            "rightCorner": {
              "x": -24.765,
              "y": -35.84,
              "z": 1.175
            },
            "gtin": "4007698047047",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d765",
        "height": 1.8989,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d88ff",
            "leftCorner": {
              "x": -23.545,
              "y": -36.001,
              "z": 1.554
            },
            "rightCorner": {
              "x": -23.639,
              "y": -36.004,
              "z": 1.554
            },
            "gtin": "4250426226652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8900",
            "leftCorner": {
              "x": -23.646,
              "y": -35.824,
              "z": 1.554
            },
            "rightCorner": {
              "x": -23.74,
              "y": -35.827,
              "z": 1.554
            },
            "gtin": "4260663674215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8901",
            "leftCorner": {
              "x": -23.741,
              "y": -35.795,
              "z": 1.554
            },
            "rightCorner": {
              "x": -23.997,
              "y": -35.805,
              "z": 1.554
            },
            "gtin": "8720573479165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8902",
            "leftCorner": {
              "x": -23.995,
              "y": -35.839,
              "z": 1.554
            },
            "rightCorner": {
              "x": -24.235,
              "y": -35.848,
              "z": 1.554
            },
            "gtin": "8721037353069",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d8903",
            "leftCorner": {
              "x": -24.227,
              "y": -36.067,
              "z": 1.554
            },
            "rightCorner": {
              "x": -24.562,
              "y": -36.08,
              "z": 1.554
            },
            "gtin": "4007698386276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8904",
            "leftCorner": {
              "x": -24.571,
              "y": -35.836,
              "z": 1.554
            },
            "rightCorner": {
              "x": -24.783,
              "y": -35.844,
              "z": 1.554
            },
            "gtin": "4007698066833",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "379"
  },
  {
    "id": "37b",
    "name": "37b",
    "x": -24.751,
    "y": -36.961,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0068504,
      "w": 0.99998
    },
    "layers": [],

    "rightNeighborShelfId": "37c"
  },
  {
    "id": "37c",
    "name": "37c",
    "x": -23.501,
    "y": -36.943,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0068504,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 58
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d227",
        "height": 0.16424,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a32",
            "leftCorner": {
              "x": -23.5,
              "y": -37.055,
              "z": 0.134
            },
            "rightCorner": {
              "x": -23.184,
              "y": -37.051,
              "z": 0.134
            },
            "gtin": "4002372103910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a34",
            "leftCorner": {
              "x": -23.185,
              "y": -37.013,
              "z": 0.134
            },
            "rightCorner": {
              "x": -22.753,
              "y": -37.007,
              "z": 0.134
            },
            "gtin": "4002372103927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a35",
            "leftCorner": {
              "x": -22.753,
              "y": -37.003,
              "z": 0.134
            },
            "rightCorner": {
              "x": -22.493,
              "y": -37.0,
              "z": 0.134
            },
            "gtin": "4002372103934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a36",
            "leftCorner": {
              "x": -22.493,
              "y": -36.994,
              "z": 0.134
            },
            "rightCorner": {
              "x": -22.342,
              "y": -36.991,
              "z": 0.134
            },
            "gtin": "4014481115012",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d226",
        "height": 0.37897,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a2f",
            "leftCorner": {
              "x": -23.304,
              "y": -36.752,
              "z": 0.31
            },
            "rightCorner": {
              "x": -23.148,
              "y": -36.751,
              "z": 0.31
            },
            "gtin": "4008110306421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a30",
            "leftCorner": {
              "x": -23.145,
              "y": -36.96,
              "z": 0.31
            },
            "rightCorner": {
              "x": -22.94,
              "y": -36.957,
              "z": 0.31
            },
            "gtin": "4008110306452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a31",
            "leftCorner": {
              "x": -22.94,
              "y": -36.958,
              "z": 0.31
            },
            "rightCorner": {
              "x": -22.739,
              "y": -36.955,
              "z": 0.31
            },
            "gtin": "4008110216270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a2e",
            "leftCorner": {
              "x": -22.739,
              "y": -36.955,
              "z": 0.31
            },
            "rightCorner": {
              "x": -22.501,
              "y": -36.952,
              "z": 0.31
            },
            "gtin": "4008110216287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "79b04ef935831563b165cacf",
            "leftCorner": {
              "x": -23.5,
              "y": -37.005,
              "z": 0.31
            },
            "rightCorner": {
              "x": -23.303,
              "y": -37.002,
              "z": 0.31
            },
            "gtin": "4008110216287",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d21f",
        "height": 0.61141,
        "facings": [
          {
            "id": "68d8e50be1820c81800d69fb",
            "leftCorner": {
              "x": -23.5,
              "y": -37.014,
              "z": 0.5
            },
            "rightCorner": {
              "x": -23.357,
              "y": -37.012,
              "z": 0.5
            },
            "gtin": "4008110110738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69fd",
            "leftCorner": {
              "x": -23.358,
              "y": -36.971,
              "z": 0.5
            },
            "rightCorner": {
              "x": -23.269,
              "y": -36.97,
              "z": 0.5
            },
            "gtin": "4008110110639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69fe",
            "leftCorner": {
              "x": -23.269,
              "y": -36.975,
              "z": 0.5
            },
            "rightCorner": {
              "x": -23.115,
              "y": -36.972,
              "z": 0.5
            },
            "gtin": "4008110368818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69ff",
            "leftCorner": {
              "x": -23.115,
              "y": -36.973,
              "z": 0.5
            },
            "rightCorner": {
              "x": -22.97,
              "y": -36.972,
              "z": 0.5
            },
            "gtin": "4008110291345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a00",
            "leftCorner": {
              "x": -22.97,
              "y": -36.967,
              "z": 0.5
            },
            "rightCorner": {
              "x": -22.774,
              "y": -36.964,
              "z": 0.5
            },
            "gtin": "4008110413044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a01",
            "leftCorner": {
              "x": -22.774,
              "y": -36.964,
              "z": 0.5
            },
            "rightCorner": {
              "x": -22.628,
              "y": -36.962,
              "z": 0.5
            },
            "gtin": "4002372101473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69fc",
            "leftCorner": {
              "x": -22.628,
              "y": -36.961,
              "z": 0.5
            },
            "rightCorner": {
              "x": -22.501,
              "y": -36.959,
              "z": 0.5
            },
            "gtin": "4002372101480",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d223",
        "height": 0.85316,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a27",
            "leftCorner": {
              "x": -23.5,
              "y": -36.999,
              "z": 0.698
            },
            "rightCorner": {
              "x": -23.216,
              "y": -36.995,
              "z": 0.698
            },
            "gtin": "4008110222196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a29",
            "leftCorner": {
              "x": -23.217,
              "y": -36.961,
              "z": 0.698
            },
            "rightCorner": {
              "x": -23.054,
              "y": -36.959,
              "z": 0.698
            },
            "gtin": "4008110163918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a2a",
            "leftCorner": {
              "x": -23.054,
              "y": -36.955,
              "z": 0.698
            },
            "rightCorner": {
              "x": -22.828,
              "y": -36.952,
              "z": 0.698
            },
            "gtin": "4008117000629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a2b",
            "leftCorner": {
              "x": -22.828,
              "y": -36.949,
              "z": 0.698
            },
            "rightCorner": {
              "x": -22.684,
              "y": -36.946,
              "z": 0.698
            },
            "gtin": "4064997201648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a2c",
            "leftCorner": {
              "x": -22.684,
              "y": -36.947,
              "z": 0.698
            },
            "rightCorner": {
              "x": -22.596,
              "y": -36.946,
              "z": 0.698
            },
            "gtin": "4008110790282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a28",
            "leftCorner": {
              "x": -22.596,
              "y": -36.948,
              "z": 0.698
            },
            "rightCorner": {
              "x": -22.501,
              "y": -36.947,
              "z": 0.698
            },
            "gtin": "4008110790640",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d220",
        "height": 1.1066,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a02",
            "leftCorner": {
              "x": -23.5,
              "y": -37.001,
              "z": 0.905
            },
            "rightCorner": {
              "x": -23.38,
              "y": -36.999,
              "z": 0.905
            },
            "gtin": "4006381217842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a04",
            "leftCorner": {
              "x": -23.381,
              "y": -36.956,
              "z": 0.905
            },
            "rightCorner": {
              "x": -23.286,
              "y": -36.954,
              "z": 0.905
            },
            "gtin": "4064997110964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a05",
            "leftCorner": {
              "x": -23.271,
              "y": -36.965,
              "z": 0.905
            },
            "rightCorner": {
              "x": -23.188,
              "y": -36.963,
              "z": 0.905
            },
            "gtin": "4004675007988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a06",
            "leftCorner": {
              "x": -23.188,
              "y": -36.962,
              "z": 0.905
            },
            "rightCorner": {
              "x": -23.103,
              "y": -36.961,
              "z": 0.905
            },
            "gtin": "3131910212140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a07",
            "leftCorner": {
              "x": -23.103,
              "y": -36.959,
              "z": 0.905
            },
            "rightCorner": {
              "x": -23.016,
              "y": -36.958,
              "z": 0.905
            },
            "gtin": "4002372200657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a08",
            "leftCorner": {
              "x": -23.016,
              "y": -36.956,
              "z": 0.905
            },
            "rightCorner": {
              "x": -22.928,
              "y": -36.956,
              "z": 0.905
            },
            "gtin": "4008110398426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a09",
            "leftCorner": {
              "x": -22.928,
              "y": -36.955,
              "z": 0.905
            },
            "rightCorner": {
              "x": -22.844,
              "y": -36.954,
              "z": 0.905
            },
            "gtin": "4009729048597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a0a",
            "leftCorner": {
              "x": -22.844,
              "y": -36.952,
              "z": 0.905
            },
            "rightCorner": {
              "x": -22.784,
              "y": -36.951,
              "z": 0.905
            },
            "gtin": "4009729048672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a0b",
            "leftCorner": {
              "x": -22.784,
              "y": -36.946,
              "z": 0.905
            },
            "rightCorner": {
              "x": -22.738,
              "y": -36.946,
              "z": 0.905
            },
            "gtin": "4064997110940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a0c",
            "leftCorner": {
              "x": -22.738,
              "y": -36.95,
              "z": 0.905
            },
            "rightCorner": {
              "x": -22.652,
              "y": -36.949,
              "z": 0.905
            },
            "gtin": "4064997110940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a0d",
            "leftCorner": {
              "x": -22.652,
              "y": -36.948,
              "z": 0.905
            },
            "rightCorner": {
              "x": -22.562,
              "y": -36.947,
              "z": 0.905
            },
            "gtin": "3243480107037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a03",
            "leftCorner": {
              "x": -22.562,
              "y": -36.94,
              "z": 0.905
            },
            "rightCorner": {
              "x": -22.501,
              "y": -36.939,
              "z": 0.905
            },
            "gtin": "4008118770002",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d229",
        "height": 1.4151,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a3b",
            "leftCorner": {
              "x": -23.504,
              "y": -36.734,
              "z": 1.158
            },
            "rightCorner": {
              "x": -22.717,
              "y": -36.724,
              "z": 1.158
            },
            "gtin": "4004764949717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a3d",
            "leftCorner": {
              "x": -22.718,
              "y": -36.672,
              "z": 1.158
            },
            "rightCorner": {
              "x": -22.663,
              "y": -36.67,
              "z": 1.158
            },
            "gtin": "4008118770101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a3e",
            "leftCorner": {
              "x": -22.661,
              "y": -36.694,
              "z": 1.158
            },
            "rightCorner": {
              "x": -22.599,
              "y": -36.694,
              "z": 1.158
            },
            "gtin": "4008118770101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a3c",
            "leftCorner": {
              "x": -22.599,
              "y": -36.689,
              "z": 1.158
            },
            "rightCorner": {
              "x": -22.504,
              "y": -36.688,
              "z": 1.158
            },
            "gtin": "4008118770408",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d221",
        "height": 1.6029,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a0e",
            "leftCorner": {
              "x": -23.504,
              "y": -36.745,
              "z": 1.311
            },
            "rightCorner": {
              "x": -23.447,
              "y": -36.744,
              "z": 1.311
            },
            "gtin": "4008118608909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a10",
            "leftCorner": {
              "x": -23.447,
              "y": -36.728,
              "z": 1.311
            },
            "rightCorner": {
              "x": -23.384,
              "y": -36.728,
              "z": 1.311
            },
            "gtin": "4008118608909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a11",
            "leftCorner": {
              "x": -23.385,
              "y": -36.719,
              "z": 1.311
            },
            "rightCorner": {
              "x": -23.336,
              "y": -36.717,
              "z": 1.311
            },
            "gtin": "4008118608008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a12",
            "leftCorner": {
              "x": -23.336,
              "y": -36.726,
              "z": 1.311
            },
            "rightCorner": {
              "x": -23.279,
              "y": -36.726,
              "z": 1.311
            },
            "gtin": "4008118608107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a13",
            "leftCorner": {
              "x": -23.267,
              "y": -36.702,
              "z": 1.311
            },
            "rightCorner": {
              "x": -23.208,
              "y": -36.701,
              "z": 1.311
            },
            "gtin": "4008110166063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a14",
            "leftCorner": {
              "x": -23.208,
              "y": -36.683,
              "z": 1.311
            },
            "rightCorner": {
              "x": -23.134,
              "y": -36.683,
              "z": 1.311
            },
            "gtin": "4007817316115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a15",
            "leftCorner": {
              "x": -23.133,
              "y": -36.686,
              "z": 1.311
            },
            "rightCorner": {
              "x": -23.063,
              "y": -36.684,
              "z": 1.311
            },
            "gtin": "4004764894703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a16",
            "leftCorner": {
              "x": -23.063,
              "y": -36.708,
              "z": 1.311
            },
            "rightCorner": {
              "x": -22.904,
              "y": -36.705,
              "z": 1.311
            },
            "gtin": "4004764100828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a17",
            "leftCorner": {
              "x": -22.904,
              "y": -36.679,
              "z": 1.311
            },
            "rightCorner": {
              "x": -22.799,
              "y": -36.678,
              "z": 1.311
            },
            "gtin": "4008110499536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a18",
            "leftCorner": {
              "x": -22.799,
              "y": -36.684,
              "z": 1.311
            },
            "rightCorner": {
              "x": -22.722,
              "y": -36.684,
              "z": 1.311
            },
            "gtin": "4008110499598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a19",
            "leftCorner": {
              "x": -22.722,
              "y": -36.72,
              "z": 1.311
            },
            "rightCorner": {
              "x": -22.656,
              "y": -36.718,
              "z": 1.311
            },
            "gtin": "4008118760805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a1a",
            "leftCorner": {
              "x": -22.656,
              "y": -36.686,
              "z": 1.311
            },
            "rightCorner": {
              "x": -22.589,
              "y": -36.685,
              "z": 1.311
            },
            "gtin": "4008118770156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a0f",
            "leftCorner": {
              "x": -22.589,
              "y": -36.72,
              "z": 1.311
            },
            "rightCorner": {
              "x": -22.504,
              "y": -36.719,
              "z": 1.311
            },
            "gtin": "4008118770255",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d222",
        "height": 1.8704,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a1b",
            "leftCorner": {
              "x": -23.504,
              "y": -36.716,
              "z": 1.53
            },
            "rightCorner": {
              "x": -23.384,
              "y": -36.714,
              "z": 1.53
            },
            "gtin": "4004675079336",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6a1d",
            "leftCorner": {
              "x": -23.384,
              "y": -36.729,
              "z": 1.53
            },
            "rightCorner": {
              "x": -23.326,
              "y": -36.728,
              "z": 1.53
            },
            "gtin": "4006381101295",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6a1e",
            "leftCorner": {
              "x": -23.325,
              "y": -36.704,
              "z": 1.53
            },
            "rightCorner": {
              "x": -23.263,
              "y": -36.704,
              "z": 1.53
            },
            "gtin": "4006381148283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a1f",
            "leftCorner": {
              "x": -23.265,
              "y": -36.667,
              "z": 1.53
            },
            "rightCorner": {
              "x": -23.208,
              "y": -36.666,
              "z": 1.53
            },
            "gtin": "4006381102131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a20",
            "leftCorner": {
              "x": -23.208,
              "y": -36.667,
              "z": 1.53
            },
            "rightCorner": {
              "x": -23.067,
              "y": -36.665,
              "z": 1.53
            },
            "gtin": "4006381102131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a21",
            "leftCorner": {
              "x": -23.067,
              "y": -36.661,
              "z": 1.53
            },
            "rightCorner": {
              "x": -22.982,
              "y": -36.66,
              "z": 1.53
            },
            "gtin": "4004764894529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a22",
            "leftCorner": {
              "x": -22.982,
              "y": -36.662,
              "z": 1.53
            },
            "rightCorner": {
              "x": -22.905,
              "y": -36.661,
              "z": 1.53
            },
            "gtin": "4008110499574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a23",
            "leftCorner": {
              "x": -22.905,
              "y": -36.668,
              "z": 1.53
            },
            "rightCorner": {
              "x": -22.844,
              "y": -36.667,
              "z": 1.53
            },
            "gtin": "4008110499567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a24",
            "leftCorner": {
              "x": -22.844,
              "y": -36.657,
              "z": 1.53
            },
            "rightCorner": {
              "x": -22.754,
              "y": -36.655,
              "z": 1.53
            }
          },
          {
            "id": "68d8e50be1820c81800d6a25",
            "leftCorner": {
              "x": -22.754,
              "y": -36.666,
              "z": 1.53
            },
            "rightCorner": {
              "x": -22.673,
              "y": -36.664,
              "z": 1.53
            },
            "gtin": "3086126100272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a26",
            "leftCorner": {
              "x": -22.672,
              "y": -36.681,
              "z": 1.53
            },
            "rightCorner": {
              "x": -22.598,
              "y": -36.68,
              "z": 1.53
            },
            "gtin": "4008118740104",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6a1c",
            "leftCorner": {
              "x": -22.598,
              "y": -36.708,
              "z": 1.53
            },
            "rightCorner": {
              "x": -22.504,
              "y": -36.707,
              "z": 1.53
            },
            "gtin": "4008110299532",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "37b",
    "rightNeighborShelfId": "37d"
  },
  {
    "id": "37d",
    "name": "37d",
    "x": -22.501,
    "y": -36.93,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0068504,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 53
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d76d",
        "height": 0.16757,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6a37",
            "leftCorner": {
              "x": -22.341,
              "y": -37.039,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.1,
              "y": -37.035,
              "z": 0.137
            },
            "gtin": "4014481118013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a38",
            "leftCorner": {
              "x": -22.1,
              "y": -37.034,
              "z": 0.137
            },
            "rightCorner": {
              "x": -21.94,
              "y": -37.032,
              "z": 0.137
            },
            "gtin": "4014481198213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a39",
            "leftCorner": {
              "x": -21.94,
              "y": -37.074,
              "z": 0.137
            },
            "rightCorner": {
              "x": -21.757,
              "y": -37.071,
              "z": 0.137
            },
            "gtin": "4014481198015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a3a",
            "leftCorner": {
              "x": -21.758,
              "y": -37.028,
              "z": 0.137
            },
            "rightCorner": {
              "x": -21.614,
              "y": -37.026,
              "z": 0.137
            },
            "gtin": "4014481195014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6a33",
            "leftCorner": {
              "x": -21.614,
              "y": -37.019,
              "z": 0.137
            },
            "rightCorner": {
              "x": -21.5,
              "y": -37.018,
              "z": 0.137
            },
            "gtin": "4014481195212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d8e7c39c4f044a6aaefd3b4a",
            "leftCorner": {
              "x": -22.499,
              "y": -37.079,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.356,
              "y": -37.077,
              "z": 0.137
            },
            "gtin": "4014481195014",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d76c",
        "height": 0.53708,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d892d",
            "leftCorner": {
              "x": -22.499,
              "y": -37.041,
              "z": 0.439
            },
            "rightCorner": {
              "x": -22.256,
              "y": -37.038,
              "z": 0.439
            },
            "gtin": "4002372103941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d892f",
            "leftCorner": {
              "x": -22.256,
              "y": -36.996,
              "z": 0.439
            },
            "rightCorner": {
              "x": -22.034,
              "y": -36.992,
              "z": 0.439
            },
            "gtin": "4002372103958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d892e",
            "leftCorner": {
              "x": -22.034,
              "y": -36.997,
              "z": 0.439
            },
            "rightCorner": {
              "x": -21.5,
              "y": -36.99,
              "z": 0.439
            },
            "gtin": "4002372402419",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d769",
        "height": 0.7375,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d891b",
            "leftCorner": {
              "x": -22.499,
              "y": -37.04,
              "z": 0.603
            },
            "rightCorner": {
              "x": -22.371,
              "y": -37.038,
              "z": 0.603
            },
            "gtin": "4008110561219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d891d",
            "leftCorner": {
              "x": -22.372,
              "y": -37.001,
              "z": 0.603
            },
            "rightCorner": {
              "x": -22.148,
              "y": -36.998,
              "z": 0.603
            },
            "gtin": "4008110737492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d891e",
            "leftCorner": {
              "x": -22.148,
              "y": -36.996,
              "z": 0.603
            },
            "rightCorner": {
              "x": -21.883,
              "y": -36.992,
              "z": 0.603
            },
            "gtin": "4008110797519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d891f",
            "leftCorner": {
              "x": -21.883,
              "y": -36.991,
              "z": 0.603
            },
            "rightCorner": {
              "x": -21.698,
              "y": -36.989,
              "z": 0.603
            },
            "gtin": "4008117935044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d891c",
            "leftCorner": {
              "x": -21.698,
              "y": -36.99,
              "z": 0.603
            },
            "rightCorner": {
              "x": -21.5,
              "y": -36.987,
              "z": 0.603
            },
            "gtin": "4008117934030",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d76e",
        "height": 0.95308,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8930",
            "leftCorner": {
              "x": -22.5,
              "y": -37.024,
              "z": 0.78
            },
            "rightCorner": {
              "x": -22.45,
              "y": -37.023,
              "z": 0.78
            },
            "gtin": "4008110886626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8932",
            "leftCorner": {
              "x": -22.45,
              "y": -36.989,
              "z": 0.78
            },
            "rightCorner": {
              "x": -22.266,
              "y": -36.987,
              "z": 0.78
            },
            "gtin": "4002372402167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8933",
            "leftCorner": {
              "x": -22.266,
              "y": -36.98,
              "z": 0.78
            },
            "rightCorner": {
              "x": -22.147,
              "y": -36.978,
              "z": 0.78
            },
            "gtin": "4002372302207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8934",
            "leftCorner": {
              "x": -22.147,
              "y": -36.981,
              "z": 0.78
            },
            "rightCorner": {
              "x": -21.949,
              "y": -36.978,
              "z": 0.78
            },
            "gtin": "4002372402259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8935",
            "leftCorner": {
              "x": -21.949,
              "y": -36.978,
              "z": 0.78
            },
            "rightCorner": {
              "x": -21.761,
              "y": -36.976,
              "z": 0.78
            },
            "gtin": "4002372102340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8931",
            "leftCorner": {
              "x": -21.761,
              "y": -36.975,
              "z": 0.78
            },
            "rightCorner": {
              "x": -21.5,
              "y": -36.971,
              "z": 0.78
            },
            "gtin": "4002372760182",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d76b",
        "height": 1.1686,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8927",
            "leftCorner": {
              "x": -22.5,
              "y": -37.034,
              "z": 0.956
            },
            "rightCorner": {
              "x": -22.43,
              "y": -37.033,
              "z": 0.956
            },
            "gtin": "4008111150702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8929",
            "leftCorner": {
              "x": -22.43,
              "y": -36.994,
              "z": 0.956
            },
            "rightCorner": {
              "x": -22.296,
              "y": -36.992,
              "z": 0.956
            },
            "gtin": "4008111150603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d892a",
            "leftCorner": {
              "x": -22.296,
              "y": -36.99,
              "z": 0.956
            },
            "rightCorner": {
              "x": -22.121,
              "y": -36.988,
              "z": 0.956
            },
            "gtin": "4008115825255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d892b",
            "leftCorner": {
              "x": -22.121,
              "y": -36.989,
              "z": 0.956
            },
            "rightCorner": {
              "x": -21.935,
              "y": -36.986,
              "z": 0.956
            },
            "gtin": "4008115850103",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d892c",
            "leftCorner": {
              "x": -21.935,
              "y": -36.988,
              "z": 0.956
            },
            "rightCorner": {
              "x": -21.694,
              "y": -36.985,
              "z": 0.956
            },
            "gtin": "4002372760793",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d8928",
            "leftCorner": {
              "x": -21.694,
              "y": -36.984,
              "z": 0.956
            },
            "rightCorner": {
              "x": -21.5,
              "y": -36.981,
              "z": 0.956
            },
            "gtin": "4002372760380",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d76a",
        "height": 1.3716,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8921",
            "leftCorner": {
              "x": -22.477,
              "y": -37.0,
              "z": 1.122
            },
            "rightCorner": {
              "x": -22.363,
              "y": -36.998,
              "z": 1.122
            },
            "gtin": "4008111150887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8922",
            "leftCorner": {
              "x": -22.363,
              "y": -36.997,
              "z": 1.122
            },
            "rightCorner": {
              "x": -22.237,
              "y": -36.995,
              "z": 1.122
            },
            "gtin": "4008118767507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8923",
            "leftCorner": {
              "x": -22.237,
              "y": -36.991,
              "z": 1.122
            },
            "rightCorner": {
              "x": -22.174,
              "y": -36.99,
              "z": 1.122
            },
            "gtin": "4008110396842",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d8926",
            "leftCorner": {
              "x": -21.995,
              "y": -36.989,
              "z": 1.122
            },
            "rightCorner": {
              "x": -21.732,
              "y": -36.985,
              "z": 1.122
            },
            "gtin": "4008115971501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8920",
            "leftCorner": {
              "x": -21.732,
              "y": -36.991,
              "z": 1.122
            },
            "rightCorner": {
              "x": -21.5,
              "y": -36.988,
              "z": 1.122
            },
            "gtin": "4002372070076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "895452d6e7a2ce08ff008cc6",
            "leftCorner": {
              "x": -22.174,
              "y": -37.035,
              "z": 1.122
            },
            "rightCorner": {
              "x": -22.084,
              "y": -37.033,
              "z": 1.122
            },
            "gtin": "4002372634155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8269e6488d6e3d49dc36d91e",
            "leftCorner": {
              "x": -22.084,
              "y": -37.033,
              "z": 1.122
            },
            "rightCorner": {
              "x": -21.995,
              "y": -37.032,
              "z": 1.122
            },
            "gtin": "4002372634155",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d768",
        "height": 1.57,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8906",
            "leftCorner": {
              "x": -22.467,
              "y": -36.838,
              "z": 1.285
            },
            "rightCorner": {
              "x": -22.402,
              "y": -36.837,
              "z": 1.285
            },
            "gtin": "4008110164946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8907",
            "leftCorner": {
              "x": -22.402,
              "y": -36.833,
              "z": 1.285
            },
            "rightCorner": {
              "x": -22.365,
              "y": -36.832,
              "z": 1.285
            },
            "gtin": "4008110975443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8908",
            "leftCorner": {
              "x": -22.365,
              "y": -36.836,
              "z": 1.285
            },
            "rightCorner": {
              "x": -22.329,
              "y": -36.836,
              "z": 1.285
            },
            "gtin": "4008110975436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8909",
            "leftCorner": {
              "x": -22.329,
              "y": -36.837,
              "z": 1.285
            },
            "rightCorner": {
              "x": -22.289,
              "y": -36.836,
              "z": 1.285
            },
            "gtin": "4008110975443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d890a",
            "leftCorner": {
              "x": -22.289,
              "y": -36.833,
              "z": 1.285
            },
            "rightCorner": {
              "x": -22.238,
              "y": -36.832,
              "z": 1.285
            },
            "gtin": "4008110975412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d890b",
            "leftCorner": {
              "x": -22.238,
              "y": -36.833,
              "z": 1.285
            },
            "rightCorner": {
              "x": -22.206,
              "y": -36.833,
              "z": 1.285
            },
            "gtin": "4008110975474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d890c",
            "leftCorner": {
              "x": -22.206,
              "y": -36.833,
              "z": 1.285
            },
            "rightCorner": {
              "x": -22.168,
              "y": -36.832,
              "z": 1.285
            },
            "gtin": "4008110976488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d890d",
            "leftCorner": {
              "x": -22.168,
              "y": -36.831,
              "z": 1.285
            },
            "rightCorner": {
              "x": -22.133,
              "y": -36.831,
              "z": 1.285
            },
            "gtin": "4008110975450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d890e",
            "leftCorner": {
              "x": -22.133,
              "y": -36.829,
              "z": 1.285
            },
            "rightCorner": {
              "x": -22.075,
              "y": -36.828,
              "z": 1.285
            },
            "gtin": "4008110976471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d890f",
            "leftCorner": {
              "x": -22.075,
              "y": -36.828,
              "z": 1.285
            },
            "rightCorner": {
              "x": -22.025,
              "y": -36.827,
              "z": 1.285
            },
            "gtin": "4008110385808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8910",
            "leftCorner": {
              "x": -22.025,
              "y": -36.826,
              "z": 1.285
            },
            "rightCorner": {
              "x": -21.984,
              "y": -36.826,
              "z": 1.285
            },
            "gtin": "4008110385921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8911",
            "leftCorner": {
              "x": -21.984,
              "y": -36.834,
              "z": 1.285
            },
            "rightCorner": {
              "x": -21.94,
              "y": -36.833,
              "z": 1.285
            },
            "gtin": "4008110385808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8912",
            "leftCorner": {
              "x": -21.94,
              "y": -36.833,
              "z": 1.285
            },
            "rightCorner": {
              "x": -21.903,
              "y": -36.833,
              "z": 1.285
            },
            "gtin": "4008110385679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8913",
            "leftCorner": {
              "x": -21.903,
              "y": -36.835,
              "z": 1.285
            },
            "rightCorner": {
              "x": -21.859,
              "y": -36.834,
              "z": 1.285
            },
            "gtin": "4008110398921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8914",
            "leftCorner": {
              "x": -21.859,
              "y": -36.829,
              "z": 1.285
            },
            "rightCorner": {
              "x": -21.823,
              "y": -36.828,
              "z": 1.285
            },
            "gtin": "4008110385952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8915",
            "leftCorner": {
              "x": -21.823,
              "y": -36.827,
              "z": 1.285
            },
            "rightCorner": {
              "x": -21.764,
              "y": -36.827,
              "z": 1.285
            },
            "gtin": "4008110385952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8916",
            "leftCorner": {
              "x": -21.764,
              "y": -36.83,
              "z": 1.285
            },
            "rightCorner": {
              "x": -21.729,
              "y": -36.829,
              "z": 1.285
            },
            "gtin": "4008110337470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8917",
            "leftCorner": {
              "x": -21.729,
              "y": -36.829,
              "z": 1.285
            },
            "rightCorner": {
              "x": -21.679,
              "y": -36.828,
              "z": 1.285
            },
            "gtin": "4008110337470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8918",
            "leftCorner": {
              "x": -21.679,
              "y": -36.827,
              "z": 1.285
            },
            "rightCorner": {
              "x": -21.642,
              "y": -36.827,
              "z": 1.285
            },
            "gtin": "4008110972435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8919",
            "leftCorner": {
              "x": -21.642,
              "y": -36.828,
              "z": 1.285
            },
            "rightCorner": {
              "x": -21.603,
              "y": -36.827,
              "z": 1.285
            },
            "gtin": "4008110972473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d891a",
            "leftCorner": {
              "x": -21.603,
              "y": -36.825,
              "z": 1.285
            },
            "rightCorner": {
              "x": -21.569,
              "y": -36.825,
              "z": 1.285
            },
            "gtin": "4002372078522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8905",
            "leftCorner": {
              "x": -21.569,
              "y": -36.827,
              "z": 1.285
            },
            "rightCorner": {
              "x": -21.502,
              "y": -36.826,
              "z": 1.285
            },
            "gtin": "4002372078522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6d830049678afededc25f8cc",
            "leftCorner": {
              "x": -22.502,
              "y": -36.876,
              "z": 1.285
            },
            "rightCorner": {
              "x": -22.468,
              "y": -36.876,
              "z": 1.285
            },
            "gtin": "4008110975474",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "37c"
  },
  {
    "id": "37e",
    "name": "37e",
    "x": -20.904,
    "y": -36.922,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7168,
      "w": 0.69728
    },
    "layers": []
  },
  {
    "id": "42d",
    "name": "42d",
    "x": -28.169,
    "y": -30.96,
    "width": 0.3125,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -4.2067E-4,
      "y": -5.1156E-4,
      "z": 0.71357,
      "w": 0.70059
    },
    "layers": []
  },
  {
    "id": "42e",
    "name": "42e",
    "x": -28.181,
    "y": -30.336,
    "width": 0.3125,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -4.2067E-4,
      "y": -5.1156E-4,
      "z": 0.71357,
      "w": 0.70059
    },
    "layers": []
  },
  {
    "id": "42f",
    "name": "42f",
    "x": -28.192,
    "y": -29.711,
    "width": 0.3125,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -4.2067E-4,
      "y": -5.1156E-4,
      "z": 0.71357,
      "w": 0.70059
    },
    "layers": []
  },
  {
    "id": "431",
    "name": "431",
    "x": -28.254,
    "y": -27.243,
    "width": 0.3125,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.3657E-4,
      "y": -1.7814E-4,
      "z": 0.70929,
      "w": 0.70492
    },
    "layers": []
  },
  {
    "id": "432",
    "name": "432",
    "x": -28.258,
    "y": -26.618,
    "width": 0.3125,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.3657E-4,
      "y": -1.7814E-4,
      "z": 0.70929,
      "w": 0.70492
    },
    "layers": []
  },
  {
    "id": "433",
    "name": "433",
    "x": -28.261,
    "y": -25.993,
    "width": 0.3125,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.3657E-4,
      "y": -1.7814E-4,
      "z": 0.70929,
      "w": 0.70492
    },
    "layers": []
  },
  {
    "id": "43c",
    "name": "43c",
    "x": -35.83,
    "y": -17.632,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71049,
      "w": 0.70371
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 27
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3bd",
        "height": 0.1752,
        "facings": [
          {
            "id": "96a46aef26fefc53ad09e3c3",
            "leftCorner": {
              "x": -35.731,
              "y": -17.63,
              "z": 0.143
            },
            "rightCorner": {
              "x": -35.732,
              "y": -17.487,
              "z": 0.143
            },
            "gtin": "4306188418320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "383147c4b0de2cb5e77b5597",
            "leftCorner": {
              "x": -35.732,
              "y": -17.487,
              "z": 0.143
            },
            "rightCorner": {
              "x": -35.734,
              "y": -17.327,
              "z": 0.143
            },
            "gtin": "4062300445543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c9798020e30b5f27b425db73",
            "leftCorner": {
              "x": -35.734,
              "y": -17.327,
              "z": 0.143
            },
            "rightCorner": {
              "x": -35.735,
              "y": -17.164,
              "z": 0.143
            },
            "gtin": "4062300445475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f1bd65413bada123582c5f14",
            "leftCorner": {
              "x": -35.735,
              "y": -17.164,
              "z": 0.143
            },
            "rightCorner": {
              "x": -35.737,
              "y": -16.997,
              "z": 0.143
            },
            "gtin": "4306188001836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e7ed2678714adc34520c4dce",
            "leftCorner": {
              "x": -35.737,
              "y": -16.997,
              "z": 0.143
            },
            "rightCorner": {
              "x": -35.739,
              "y": -16.822,
              "z": 0.143
            },
            "gtin": "8700216664431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "19398ecc4eca51dd8e254efc",
            "leftCorner": {
              "x": -35.739,
              "y": -16.822,
              "z": 0.143
            },
            "rightCorner": {
              "x": -35.74,
              "y": -16.641,
              "z": 0.143
            },
            "gtin": "8001841078137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "31d0e3e1da658a4fe2319357",
            "leftCorner": {
              "x": -35.74,
              "y": -16.641,
              "z": 0.143
            },
            "rightCorner": {
              "x": -35.743,
              "y": -16.387,
              "z": 0.143
            },
            "gtin": "4062300470088",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3b9",
        "height": 0.6431,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7268",
            "leftCorner": {
              "x": -35.804,
              "y": -17.334,
              "z": 0.526
            },
            "rightCorner": {
              "x": -35.806,
              "y": -17.085,
              "z": 0.526
            },
            "gtin": "4306188001805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "37479a758d656b120621238e",
            "leftCorner": {
              "x": -35.76,
              "y": -17.631,
              "z": 0.526
            },
            "rightCorner": {
              "x": -35.763,
              "y": -17.354,
              "z": 0.526
            },
            "gtin": "4306188001744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7269",
            "leftCorner": {
              "x": -35.806,
              "y": -17.085,
              "z": 0.526
            },
            "rightCorner": {
              "x": -35.808,
              "y": -16.837,
              "z": 0.526
            },
            "gtin": "4306188001805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d726a",
            "leftCorner": {
              "x": -35.802,
              "y": -16.837,
              "z": 0.526
            },
            "rightCorner": {
              "x": -35.805,
              "y": -16.55,
              "z": 0.526
            },
            "gtin": "4306188001744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d726b",
            "leftCorner": {
              "x": -35.813,
              "y": -16.55,
              "z": 0.526
            },
            "rightCorner": {
              "x": -35.815,
              "y": -16.338,
              "z": 0.526
            },
            "gtin": "8700216664431",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3bb",
        "height": 0.95614,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d726f",
            "leftCorner": {
              "x": -35.776,
              "y": -17.631,
              "z": 0.782
            },
            "rightCorner": {
              "x": -35.778,
              "y": -17.433,
              "z": 0.782
            },
            "gtin": "4306188001713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7271",
            "leftCorner": {
              "x": -35.809,
              "y": -17.434,
              "z": 0.782
            },
            "rightCorner": {
              "x": -35.811,
              "y": -17.256,
              "z": 0.782
            },
            "gtin": "4306188001836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7272",
            "leftCorner": {
              "x": -35.819,
              "y": -17.256,
              "z": 0.782
            },
            "rightCorner": {
              "x": -35.822,
              "y": -17.004,
              "z": 0.782
            },
            "gtin": "4062300470088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7273",
            "leftCorner": {
              "x": -35.825,
              "y": -17.004,
              "z": 0.782
            },
            "rightCorner": {
              "x": -35.826,
              "y": -16.816,
              "z": 0.782
            },
            "gtin": "4062300470033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7274",
            "leftCorner": {
              "x": -35.818,
              "y": -16.815,
              "z": 0.782
            },
            "rightCorner": {
              "x": -35.821,
              "y": -16.587,
              "z": 0.782
            },
            "gtin": "4062300469938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7270",
            "leftCorner": {
              "x": -35.826,
              "y": -16.587,
              "z": 0.782
            },
            "rightCorner": {
              "x": -35.828,
              "y": -16.382,
              "z": 0.782
            },
            "gtin": "8700216713085",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3bc",
        "height": 1.4056,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7275",
            "leftCorner": {
              "x": -35.765,
              "y": -17.631,
              "z": 1.15
            },
            "rightCorner": {
              "x": -35.771,
              "y": -17.095,
              "z": 1.15
            },
            "gtin": "4306188418351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7277",
            "leftCorner": {
              "x": -35.81,
              "y": -17.096,
              "z": 1.15
            },
            "rightCorner": {
              "x": -35.814,
              "y": -16.599,
              "z": 1.15
            },
            "gtin": "4062300432499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7276",
            "leftCorner": {
              "x": -35.816,
              "y": -16.599,
              "z": 1.15
            },
            "rightCorner": {
              "x": -35.818,
              "y": -16.381,
              "z": 1.15
            },
            "gtin": "4062300432482",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3ba",
        "height": 1.7086,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d722d",
            "leftCorner": {
              "x": -35.825,
              "y": -17.582,
              "z": 1.398
            },
            "rightCorner": {
              "x": -35.828,
              "y": -17.351,
              "z": 1.398
            },
            "gtin": "4306188418320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d722e",
            "leftCorner": {
              "x": -35.819,
              "y": -17.351,
              "z": 1.398
            },
            "rightCorner": {
              "x": -35.821,
              "y": -17.162,
              "z": 1.398
            },
            "gtin": "8001841078137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d722f",
            "leftCorner": {
              "x": -35.824,
              "y": -17.162,
              "z": 1.398
            },
            "rightCorner": {
              "x": -35.826,
              "y": -16.947,
              "z": 1.398
            },
            "gtin": "8006540458525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7230",
            "leftCorner": {
              "x": -35.82,
              "y": -16.947,
              "z": 1.398
            },
            "rightCorner": {
              "x": -35.822,
              "y": -16.688,
              "z": 1.398
            },
            "gtin": "8001841062792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7231",
            "leftCorner": {
              "x": -35.825,
              "y": -16.688,
              "z": 1.398
            },
            "rightCorner": {
              "x": -35.826,
              "y": -16.509,
              "z": 1.398
            },
            "gtin": "4062300445475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7228",
            "leftCorner": {
              "x": -35.83,
              "y": -16.509,
              "z": 1.398
            },
            "rightCorner": {
              "x": -35.831,
              "y": -16.382,
              "z": 1.398
            },
            "gtin": "4062300445543",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c1f",
    "rightNeighborShelfId": "43d"
  },
  {
    "id": "43d",
    "name": "43d",
    "x": -35.841,
    "y": -16.382,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71049,
      "w": 0.70371
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3bf",
        "height": 0.17103,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7243",
            "leftCorner": {
              "x": -35.726,
              "y": -16.381,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.728,
              "y": -16.255,
              "z": 0.14
            },
            "gtin": "8700216812474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c8de320065bfdd677739df70",
            "leftCorner": {
              "x": -35.741,
              "y": -15.685,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.744,
              "y": -15.382,
              "z": 0.14
            },
            "gtin": "8700216793438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7244",
            "leftCorner": {
              "x": -35.776,
              "y": -16.256,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.778,
              "y": -16.021,
              "z": 0.14
            },
            "gtin": "8700216812474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7245",
            "leftCorner": {
              "x": -35.777,
              "y": -16.021,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.78,
              "y": -15.685,
              "z": 0.14
            },
            "gtin": "8700216754323",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3c0",
        "height": 0.64329,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d726c",
            "leftCorner": {
              "x": -35.807,
              "y": -16.338,
              "z": 0.526
            },
            "rightCorner": {
              "x": -35.809,
              "y": -16.109,
              "z": 0.526
            },
            "gtin": "8700216665056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d726d",
            "leftCorner": {
              "x": -35.816,
              "y": -16.109,
              "z": 0.526
            },
            "rightCorner": {
              "x": -35.818,
              "y": -15.895,
              "z": 0.526
            },
            "gtin": "8700216207386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d726e",
            "leftCorner": {
              "x": -36.069,
              "y": -15.898,
              "z": 0.526
            },
            "rightCorner": {
              "x": -36.071,
              "y": -15.654,
              "z": 0.526
            },
            "gtin": "8700216664721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7267",
            "leftCorner": {
              "x": -35.811,
              "y": -15.651,
              "z": 0.526
            },
            "rightCorner": {
              "x": -35.814,
              "y": -15.382,
              "z": 0.526
            },
            "gtin": "8700216664776",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3be",
        "height": 1.108,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7278",
            "leftCorner": {
              "x": -35.784,
              "y": -16.382,
              "z": 0.907
            },
            "rightCorner": {
              "x": -35.786,
              "y": -16.274,
              "z": 0.907
            },
            "gtin": "8700216664752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7279",
            "leftCorner": {
              "x": -35.786,
              "y": -16.274,
              "z": 0.907
            },
            "rightCorner": {
              "x": -35.787,
              "y": -16.167,
              "z": 0.907
            },
            "gtin": "8700216664752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d727b",
            "leftCorner": {
              "x": -35.83,
              "y": -16.167,
              "z": 0.907
            },
            "rightCorner": {
              "x": -35.832,
              "y": -15.968,
              "z": 0.907
            },
            "gtin": "8700216207485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d727c",
            "leftCorner": {
              "x": -35.83,
              "y": -15.968,
              "z": 0.907
            },
            "rightCorner": {
              "x": -35.831,
              "y": -15.79,
              "z": 0.907
            },
            "gtin": "8700216713160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d727d",
            "leftCorner": {
              "x": -35.829,
              "y": -15.79,
              "z": 0.907
            },
            "rightCorner": {
              "x": -35.831,
              "y": -15.596,
              "z": 0.907
            },
            "gtin": "8700216713139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d727a",
            "leftCorner": {
              "x": -35.83,
              "y": -15.596,
              "z": 0.907
            },
            "rightCorner": {
              "x": -35.833,
              "y": -15.382,
              "z": 0.907
            },
            "gtin": "8700216713085",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3c1",
        "height": 1.5095,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d727e",
            "leftCorner": {
              "x": -35.779,
              "y": -16.381,
              "z": 1.235
            },
            "rightCorner": {
              "x": -35.782,
              "y": -16.103,
              "z": 1.235
            },
            "gtin": "8700216664509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7280",
            "leftCorner": {
              "x": -35.826,
              "y": -16.104,
              "z": 1.235
            },
            "rightCorner": {
              "x": -35.827,
              "y": -15.919,
              "z": 1.235
            },
            "gtin": "8700216664448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7281",
            "leftCorner": {
              "x": -35.823,
              "y": -15.919,
              "z": 1.235
            },
            "rightCorner": {
              "x": -35.825,
              "y": -15.755,
              "z": 1.235
            },
            "gtin": "8700216713436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7282",
            "leftCorner": {
              "x": -35.824,
              "y": -15.755,
              "z": 1.235
            },
            "rightCorner": {
              "x": -35.826,
              "y": -15.566,
              "z": 1.235
            },
            "gtin": "8700216754088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d727f",
            "leftCorner": {
              "x": -35.823,
              "y": -15.566,
              "z": 1.235
            },
            "rightCorner": {
              "x": -35.825,
              "y": -15.382,
              "z": 1.235
            },
            "gtin": "8700216227285",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "43c",
    "rightNeighborShelfId": "43e"
  },
  {
    "id": "43e",
    "name": "43e",
    "x": -35.851,
    "y": -15.382,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71049,
      "w": 0.70371
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 36,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7f7",
        "height": 0.17056,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7246",
            "leftCorner": {
              "x": -35.759,
              "y": -15.591,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.768,
              "y": -15.161,
              "z": 0.14
            },
            "gtin": "4018852036593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7247",
            "leftCorner": {
              "x": -35.776,
              "y": -15.254,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.778,
              "y": -15.126,
              "z": 0.14
            },
            "gtin": "4018852036593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7248",
            "leftCorner": {
              "x": -35.778,
              "y": -15.126,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.779,
              "y": -14.992,
              "z": 0.14
            },
            "gtin": "4018852036760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7249",
            "leftCorner": {
              "x": -35.782,
              "y": -14.992,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.783,
              "y": -14.855,
              "z": 0.14
            },
            "gtin": "4018852036845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d724a",
            "leftCorner": {
              "x": -35.785,
              "y": -14.855,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.787,
              "y": -14.716,
              "z": 0.14
            },
            "gtin": "4062300369269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d724b",
            "leftCorner": {
              "x": -35.789,
              "y": -14.716,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.79,
              "y": -14.589,
              "z": 0.14
            },
            "gtin": "9120111881518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d724c",
            "leftCorner": {
              "x": -35.794,
              "y": -14.589,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.794,
              "y": -14.48,
              "z": 0.14
            },
            "gtin": "4260133233324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d724d",
            "leftCorner": {
              "x": -35.795,
              "y": -14.48,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.796,
              "y": -14.358,
              "z": 0.14
            },
            "gtin": "4104420182967",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d724e",
            "leftCorner": {
              "x": -35.805,
              "y": -14.358,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.808,
              "y": -14.095,
              "z": 0.14
            },
            "gtin": "4104420238282",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7f2",
        "height": 0.50904,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c4b",
            "leftCorner": {
              "x": -35.789,
              "y": -15.381,
              "z": 0.416
            },
            "rightCorner": {
              "x": -35.792,
              "y": -15.103,
              "z": 0.416
            },
            "gtin": "4008976032892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c4d",
            "leftCorner": {
              "x": -35.833,
              "y": -14.997,
              "z": 0.416
            },
            "rightCorner": {
              "x": -35.836,
              "y": -14.734,
              "z": 0.416
            },
            "gtin": "4056631001790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c4e",
            "leftCorner": {
              "x": -35.836,
              "y": -14.734,
              "z": 0.416
            },
            "rightCorner": {
              "x": -35.837,
              "y": -14.563,
              "z": 0.416
            },
            "gtin": "4056631002834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c4f",
            "leftCorner": {
              "x": -35.842,
              "y": -14.563,
              "z": 0.416
            },
            "rightCorner": {
              "x": -35.844,
              "y": -14.404,
              "z": 0.416
            },
            "gtin": "4062300343108",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7f5",
        "height": 0.83399,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c5e",
            "leftCorner": {
              "x": -35.788,
              "y": -15.381,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.79,
              "y": -15.143,
              "z": 0.682
            },
            "gtin": "4018852029762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c60",
            "leftCorner": {
              "x": -35.83,
              "y": -15.144,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.832,
              "y": -14.999,
              "z": 0.682
            },
            "gtin": "4018852031796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c61",
            "leftCorner": {
              "x": -35.831,
              "y": -14.999,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.832,
              "y": -14.868,
              "z": 0.682
            },
            "gtin": "4062300437159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c62",
            "leftCorner": {
              "x": -35.835,
              "y": -14.868,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.837,
              "y": -14.718,
              "z": 0.682
            },
            "gtin": "4018852021063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c63",
            "leftCorner": {
              "x": -35.836,
              "y": -14.718,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.838,
              "y": -14.447,
              "z": 0.682
            },
            "gtin": "4018852021117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c64",
            "leftCorner": {
              "x": -35.841,
              "y": -14.447,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.843,
              "y": -14.319,
              "z": 0.682
            },
            "gtin": "4018852033462",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7f3",
        "height": 1.1368,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7283",
            "leftCorner": {
              "x": -35.788,
              "y": -15.381,
              "z": 0.93
            },
            "rightCorner": {
              "x": -35.79,
              "y": -15.14,
              "z": 0.93
            },
            "gtin": "4062300402782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "029fc53c906dfe1950f6df15",
            "leftCorner": {
              "x": -35.797,
              "y": -14.486,
              "z": 0.93
            },
            "rightCorner": {
              "x": -35.797,
              "y": -14.406,
              "z": 0.93
            },
            "gtin": "4062300355446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7285",
            "leftCorner": {
              "x": -35.828,
              "y": -15.141,
              "z": 0.93
            },
            "rightCorner": {
              "x": -35.83,
              "y": -15.01,
              "z": 0.93
            },
            "gtin": "4062300398894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7286",
            "leftCorner": {
              "x": -35.829,
              "y": -15.01,
              "z": 0.93
            },
            "rightCorner": {
              "x": -35.83,
              "y": -14.87,
              "z": 0.93
            },
            "gtin": "4062300398900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7287",
            "leftCorner": {
              "x": -35.834,
              "y": -14.87,
              "z": 0.93
            },
            "rightCorner": {
              "x": -35.837,
              "y": -14.624,
              "z": 0.93
            },
            "gtin": "4062300398917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7288",
            "leftCorner": {
              "x": -35.841,
              "y": -14.624,
              "z": 0.93
            },
            "rightCorner": {
              "x": -35.842,
              "y": -14.487,
              "z": 0.93
            },
            "gtin": "4062300398924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d728a",
            "leftCorner": {
              "x": -35.701,
              "y": -14.381,
              "z": 0.93
            },
            "rightCorner": {
              "x": -35.702,
              "y": -14.256,
              "z": 0.93
            },
            "gtin": "4062300355446",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7f4",
        "height": 1.4405,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c50",
            "leftCorner": {
              "x": -35.78,
              "y": -15.381,
              "z": 1.179
            },
            "rightCorner": {
              "x": -35.784,
              "y": -15.006,
              "z": 1.179
            },
            "gtin": "4062300414310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c52",
            "leftCorner": {
              "x": -35.823,
              "y": -15.007,
              "z": 1.179
            },
            "rightCorner": {
              "x": -35.825,
              "y": -14.746,
              "z": 1.179
            },
            "gtin": "4062300414327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c53",
            "leftCorner": {
              "x": -35.826,
              "y": -14.746,
              "z": 1.179
            },
            "rightCorner": {
              "x": -35.829,
              "y": -14.48,
              "z": 1.179
            },
            "gtin": "4062300355422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c54",
            "leftCorner": {
              "x": -35.829,
              "y": -14.48,
              "z": 1.179
            },
            "rightCorner": {
              "x": -35.832,
              "y": -14.164,
              "z": 1.179
            },
            "gtin": "4062300355439",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7f6",
        "height": 1.7373,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d72e8",
            "leftCorner": {
              "x": -35.783,
              "y": -15.381,
              "z": 1.421
            },
            "rightCorner": {
              "x": -35.785,
              "y": -15.073,
              "z": 1.421
            },
            "gtin": "7613038463582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ea",
            "leftCorner": {
              "x": -35.825,
              "y": -15.074,
              "z": 1.421
            },
            "rightCorner": {
              "x": -35.827,
              "y": -14.911,
              "z": 1.421
            },
            "gtin": "7613038463070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72eb",
            "leftCorner": {
              "x": -35.823,
              "y": -14.911,
              "z": 1.421
            },
            "rightCorner": {
              "x": -35.823,
              "y": -14.785,
              "z": 1.421
            },
            "gtin": "4056631001226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ec",
            "leftCorner": {
              "x": -35.829,
              "y": -14.785,
              "z": 1.421
            },
            "rightCorner": {
              "x": -35.831,
              "y": -14.636,
              "z": 1.421
            },
            "gtin": "4056631000472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ed",
            "leftCorner": {
              "x": -35.833,
              "y": -14.636,
              "z": 1.421
            },
            "rightCorner": {
              "x": -35.834,
              "y": -14.498,
              "z": 1.421
            },
            "gtin": "4056631001202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ee",
            "leftCorner": {
              "x": -35.835,
              "y": -14.498,
              "z": 1.421
            },
            "rightCorner": {
              "x": -35.836,
              "y": -14.374,
              "z": 1.421
            },
            "gtin": "4056631001240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ef",
            "leftCorner": {
              "x": -35.835,
              "y": -14.374,
              "z": 1.421
            },
            "rightCorner": {
              "x": -35.836,
              "y": -14.255,
              "z": 1.421
            },
            "gtin": "4056631003770",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "43d",
    "rightNeighborShelfId": "43f"
  },
  {
    "id": "43f",
    "name": "43f",
    "x": -35.861,
    "y": -14.382,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71049,
      "w": 0.70371
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 52,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7fd",
        "height": 0.16934,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d724f",
            "leftCorner": {
              "x": -35.813,
              "y": -14.095,
              "z": 0.139
            },
            "rightCorner": {
              "x": -35.814,
              "y": -14.004,
              "z": 0.139
            },
            "gtin": "4018852033943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f798b61d6b177e0587912c35",
            "leftCorner": {
              "x": -35.774,
              "y": -14.381,
              "z": 0.139
            },
            "rightCorner": {
              "x": -35.775,
              "y": -14.298,
              "z": 0.139
            },
            "gtin": "4251099707219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d6a35f1c92f6cb52baa5a315",
            "leftCorner": {
              "x": -35.775,
              "y": -14.298,
              "z": 0.139
            },
            "rightCorner": {
              "x": -35.776,
              "y": -14.215,
              "z": 0.139
            },
            "gtin": "4251099603900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "36fea5a70fe49d54d02ab50a",
            "leftCorner": {
              "x": -35.776,
              "y": -14.215,
              "z": 0.139
            },
            "rightCorner": {
              "x": -35.777,
              "y": -14.095,
              "z": 0.139
            },
            "gtin": "4251099707158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7250",
            "leftCorner": {
              "x": -35.812,
              "y": -14.003,
              "z": 0.139
            },
            "rightCorner": {
              "x": -35.815,
              "y": -13.707,
              "z": 0.139
            },
            "gtin": "4260208910976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7251",
            "leftCorner": {
              "x": -35.828,
              "y": -13.707,
              "z": 0.139
            },
            "rightCorner": {
              "x": -35.831,
              "y": -13.396,
              "z": 0.139
            },
            "gtin": "4260208910983",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d7252",
            "leftCorner": {
              "x": -35.825,
              "y": -13.396,
              "z": 0.139
            },
            "rightCorner": {
              "x": -35.825,
              "y": -13.34,
              "z": 0.139
            },
            "gtin": "4251099707158",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7f8",
        "height": 0.52197,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d72af",
            "leftCorner": {
              "x": -35.803,
              "y": -14.381,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.805,
              "y": -14.186,
              "z": 0.427
            },
            "gtin": "4260133236127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fe2aa52322262027725a9166",
            "leftCorner": {
              "x": -35.806,
              "y": -14.042,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.808,
              "y": -13.883,
              "z": 0.427
            },
            "gtin": "4260133232259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72b1",
            "leftCorner": {
              "x": -35.836,
              "y": -14.187,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.837,
              "y": -14.043,
              "z": 0.427
            },
            "gtin": "4260133236387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72b3",
            "leftCorner": {
              "x": -35.848,
              "y": -13.876,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.85,
              "y": -13.734,
              "z": 0.427
            },
            "gtin": "4062300376182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72b4",
            "leftCorner": {
              "x": -35.858,
              "y": -13.734,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.859,
              "y": -13.602,
              "z": 0.427
            },
            "gtin": "4062300376199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72b5",
            "leftCorner": {
              "x": -35.841,
              "y": -13.602,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.843,
              "y": -13.403,
              "z": 0.427
            },
            "gtin": "4062300399518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72b6",
            "leftCorner": {
              "x": -35.858,
              "y": -13.403,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.858,
              "y": -13.351,
              "z": 0.427
            },
            "gtin": "4018852032946",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7fb",
        "height": 0.83379,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c65",
            "leftCorner": {
              "x": -35.858,
              "y": -14.319,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.859,
              "y": -14.184,
              "z": 0.682
            },
            "gtin": "4260133233409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c66",
            "leftCorner": {
              "x": -35.856,
              "y": -14.184,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.857,
              "y": -14.06,
              "z": 0.682
            },
            "gtin": "4260133230781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c67",
            "leftCorner": {
              "x": -35.854,
              "y": -14.06,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.855,
              "y": -13.942,
              "z": 0.682
            },
            "gtin": "4260208911454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c68",
            "leftCorner": {
              "x": -35.861,
              "y": -13.942,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.863,
              "y": -13.832,
              "z": 0.682
            },
            "gtin": "42369653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c69",
            "leftCorner": {
              "x": -35.861,
              "y": -13.832,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.862,
              "y": -13.651,
              "z": 0.682
            },
            "gtin": "8719325866476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c6a",
            "leftCorner": {
              "x": -35.873,
              "y": -13.651,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.875,
              "y": -13.501,
              "z": 0.682
            },
            "gtin": "8719325866469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c5f",
            "leftCorner": {
              "x": -35.864,
              "y": -13.501,
              "z": 0.682
            },
            "rightCorner": {
              "x": -35.865,
              "y": -13.382,
              "z": 0.682
            },
            "gtin": "4018852036609",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7fa",
        "height": 1.1378,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d728b",
            "leftCorner": {
              "x": -35.857,
              "y": -14.259,
              "z": 0.931
            },
            "rightCorner": {
              "x": -35.858,
              "y": -14.166,
              "z": 0.931
            },
            "gtin": "4260133232662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bb6270b44a9d22234d9f9eb2",
            "leftCorner": {
              "x": -35.82,
              "y": -14.382,
              "z": 0.931
            },
            "rightCorner": {
              "x": -35.821,
              "y": -14.29,
              "z": 0.931
            },
            "gtin": "4018852029175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d728c",
            "leftCorner": {
              "x": -35.858,
              "y": -14.166,
              "z": 0.931
            },
            "rightCorner": {
              "x": -35.859,
              "y": -14.087,
              "z": 0.931
            },
            "gtin": "4260133232709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d728d",
            "leftCorner": {
              "x": -35.859,
              "y": -14.087,
              "z": 0.931
            },
            "rightCorner": {
              "x": -35.86,
              "y": -13.993,
              "z": 0.931
            },
            "gtin": "4260133232624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d728e",
            "leftCorner": {
              "x": -35.861,
              "y": -13.993,
              "z": 0.931
            },
            "rightCorner": {
              "x": -35.862,
              "y": -13.923,
              "z": 0.931
            },
            "gtin": "4260133232549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d728f",
            "leftCorner": {
              "x": -35.865,
              "y": -13.923,
              "z": 0.931
            },
            "rightCorner": {
              "x": -35.866,
              "y": -13.749,
              "z": 0.931
            },
            "gtin": "4260133235199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7290",
            "leftCorner": {
              "x": -35.869,
              "y": -13.749,
              "z": 0.931
            },
            "rightCorner": {
              "x": -35.87,
              "y": -13.656,
              "z": 0.931
            },
            "gtin": "4018852026969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7291",
            "leftCorner": {
              "x": -35.865,
              "y": -13.656,
              "z": 0.931
            },
            "rightCorner": {
              "x": -35.866,
              "y": -13.578,
              "z": 0.931
            },
            "gtin": "4062300362215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7292",
            "leftCorner": {
              "x": -35.861,
              "y": -13.578,
              "z": 0.931
            },
            "rightCorner": {
              "x": -35.862,
              "y": -13.524,
              "z": 0.931
            },
            "gtin": "4062300446069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7293",
            "leftCorner": {
              "x": -35.868,
              "y": -13.524,
              "z": 0.931
            },
            "rightCorner": {
              "x": -35.869,
              "y": -13.356,
              "z": 0.931
            },
            "gtin": "4062300362239",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7fc",
        "height": 1.4418,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c55",
            "leftCorner": {
              "x": -35.847,
              "y": -14.165,
              "z": 1.18
            },
            "rightCorner": {
              "x": -35.848,
              "y": -14.091,
              "z": 1.18
            },
            "gtin": "4260133231818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c56",
            "leftCorner": {
              "x": -35.852,
              "y": -14.091,
              "z": 1.18
            },
            "rightCorner": {
              "x": -35.853,
              "y": -14.013,
              "z": 1.18
            },
            "gtin": "4260133232563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c57",
            "leftCorner": {
              "x": -35.851,
              "y": -14.013,
              "z": 1.18
            },
            "rightCorner": {
              "x": -35.852,
              "y": -13.924,
              "z": 1.18
            },
            "gtin": "4260133232464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c58",
            "leftCorner": {
              "x": -35.855,
              "y": -13.924,
              "z": 1.18
            },
            "rightCorner": {
              "x": -35.855,
              "y": -13.839,
              "z": 1.18
            },
            "gtin": "4260133231924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c59",
            "leftCorner": {
              "x": -35.858,
              "y": -13.839,
              "z": 1.18
            },
            "rightCorner": {
              "x": -35.859,
              "y": -13.746,
              "z": 1.18
            },
            "gtin": "9120111880450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c5a",
            "leftCorner": {
              "x": -35.862,
              "y": -13.746,
              "z": 1.18
            },
            "rightCorner": {
              "x": -35.863,
              "y": -13.684,
              "z": 1.18
            },
            "gtin": "9120111880443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c5b",
            "leftCorner": {
              "x": -35.867,
              "y": -13.684,
              "z": 1.18
            },
            "rightCorner": {
              "x": -35.868,
              "y": -13.619,
              "z": 1.18
            },
            "gtin": "9120111881235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c5c",
            "leftCorner": {
              "x": -35.852,
              "y": -13.619,
              "z": 1.18
            },
            "rightCorner": {
              "x": -35.853,
              "y": -13.534,
              "z": 1.18
            },
            "gtin": "4062300325050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c5d",
            "leftCorner": {
              "x": -35.858,
              "y": -13.534,
              "z": 1.18
            },
            "rightCorner": {
              "x": -35.859,
              "y": -13.425,
              "z": 1.18
            },
            "gtin": "4062300278547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c51",
            "leftCorner": {
              "x": -35.864,
              "y": -13.425,
              "z": 1.18
            },
            "rightCorner": {
              "x": -35.864,
              "y": -13.382,
              "z": 1.18
            },
            "gtin": "4062300278530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0bc62a4a964ee16e72a69be7",
            "leftCorner": {
              "x": -35.812,
              "y": -14.382,
              "z": 1.18
            },
            "rightCorner": {
              "x": -35.813,
              "y": -14.309,
              "z": 1.18
            },
            "gtin": "4062300342811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "05fce2bbe3da09bdc356c285",
            "leftCorner": {
              "x": -35.813,
              "y": -14.309,
              "z": 1.18
            },
            "rightCorner": {
              "x": -35.814,
              "y": -14.212,
              "z": 1.18
            },
            "gtin": "9120111880450",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7f9",
        "height": 1.7393,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d72f0",
            "leftCorner": {
              "x": -35.854,
              "y": -14.256,
              "z": 1.423
            },
            "rightCorner": {
              "x": -35.855,
              "y": -14.15,
              "z": 1.423
            },
            "gtin": "4018852034667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ae63f8fa4dea6a140390e275",
            "leftCorner": {
              "x": -35.815,
              "y": -14.382,
              "z": 1.423
            },
            "rightCorner": {
              "x": -35.816,
              "y": -14.305,
              "z": 1.423
            },
            "gtin": "8720618786814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72f1",
            "leftCorner": {
              "x": -35.848,
              "y": -14.15,
              "z": 1.423
            },
            "rightCorner": {
              "x": -35.849,
              "y": -14.068,
              "z": 1.423
            },
            "gtin": "4018852034513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72f2",
            "leftCorner": {
              "x": -35.853,
              "y": -14.068,
              "z": 1.423
            },
            "rightCorner": {
              "x": -35.855,
              "y": -13.918,
              "z": 1.423
            },
            "gtin": "4018852034452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72f3",
            "leftCorner": {
              "x": -35.86,
              "y": -13.918,
              "z": 1.423
            },
            "rightCorner": {
              "x": -35.861,
              "y": -13.798,
              "z": 1.423
            },
            "gtin": "4018852034575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72f4",
            "leftCorner": {
              "x": -35.862,
              "y": -13.798,
              "z": 1.423
            },
            "rightCorner": {
              "x": -35.863,
              "y": -13.706,
              "z": 1.423
            },
            "gtin": "4018852034391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72f5",
            "leftCorner": {
              "x": -35.868,
              "y": -13.706,
              "z": 1.423
            },
            "rightCorner": {
              "x": -35.869,
              "y": -13.613,
              "z": 1.423
            },
            "gtin": "4018852034407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72f6",
            "leftCorner": {
              "x": -35.868,
              "y": -13.613,
              "z": 1.423
            },
            "rightCorner": {
              "x": -35.868,
              "y": -13.543,
              "z": 1.423
            },
            "gtin": "4104060031922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72f7",
            "leftCorner": {
              "x": -35.859,
              "y": -13.543,
              "z": 1.423
            },
            "rightCorner": {
              "x": -35.861,
              "y": -13.435,
              "z": 1.423
            },
            "gtin": "4104060031908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72f8",
            "leftCorner": {
              "x": -35.868,
              "y": -13.435,
              "z": 1.423
            },
            "rightCorner": {
              "x": -35.868,
              "y": -13.36,
              "z": 1.423
            },
            "gtin": "8720618786791",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "43e",
    "rightNeighborShelfId": "440"
  },
  {
    "id": "440",
    "name": "440",
    "x": -35.87,
    "y": -13.382,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71049,
      "w": 0.70371
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 59,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3ca",
        "height": 0.16871,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7253",
            "leftCorner": {
              "x": -35.806,
              "y": -13.339,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.808,
              "y": -13.169,
              "z": 0.138
            },
            "gtin": "4251099603139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7254",
            "leftCorner": {
              "x": -35.808,
              "y": -13.169,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.808,
              "y": -13.093,
              "z": 0.138
            },
            "gtin": "4062300375215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7255",
            "leftCorner": {
              "x": -35.809,
              "y": -13.093,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.811,
              "y": -12.872,
              "z": 0.138
            },
            "gtin": "4062300375260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7256",
            "leftCorner": {
              "x": -35.812,
              "y": -12.872,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.814,
              "y": -12.732,
              "z": 0.138
            },
            "gtin": "4062300375307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7257",
            "leftCorner": {
              "x": -35.809,
              "y": -12.732,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.812,
              "y": -12.524,
              "z": 0.138
            },
            "gtin": "4062300375284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7258",
            "leftCorner": {
              "x": -35.814,
              "y": -12.524,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.815,
              "y": -12.423,
              "z": 0.138
            },
            "gtin": "4062300375178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7259",
            "leftCorner": {
              "x": -35.817,
              "y": -12.423,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.818,
              "y": -12.353,
              "z": 0.138
            },
            "gtin": "4018852032786",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3c5",
        "height": 0.51754,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d72b7",
            "leftCorner": {
              "x": -35.841,
              "y": -13.351,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.842,
              "y": -13.229,
              "z": 0.423
            },
            "gtin": "4062300266179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72b8",
            "leftCorner": {
              "x": -35.84,
              "y": -13.229,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.841,
              "y": -13.129,
              "z": 0.423
            },
            "gtin": "4062300261303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72b9",
            "leftCorner": {
              "x": -35.844,
              "y": -13.129,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.845,
              "y": -13.036,
              "z": 0.423
            },
            "gtin": "4062300439481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ba",
            "leftCorner": {
              "x": -35.844,
              "y": -13.036,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.845,
              "y": -12.897,
              "z": 0.423
            },
            "gtin": "4062300463059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72bb",
            "leftCorner": {
              "x": -35.845,
              "y": -12.897,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.847,
              "y": -12.764,
              "z": 0.423
            },
            "gtin": "4062300253735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72bc",
            "leftCorner": {
              "x": -35.843,
              "y": -12.764,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.844,
              "y": -12.645,
              "z": 0.423
            },
            "gtin": "4062300261846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72bd",
            "leftCorner": {
              "x": -35.846,
              "y": -12.645,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.848,
              "y": -12.502,
              "z": 0.423
            },
            "gtin": "4062300262515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72be",
            "leftCorner": {
              "x": -35.847,
              "y": -12.502,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.848,
              "y": -12.35,
              "z": 0.423
            },
            "gtin": "4062300198838",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3c6",
        "height": 0.75464,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d72d7",
            "leftCorner": {
              "x": -35.815,
              "y": -13.382,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.816,
              "y": -13.224,
              "z": 0.617
            },
            "gtin": "4062300266148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72d9",
            "leftCorner": {
              "x": -35.856,
              "y": -13.224,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.857,
              "y": -13.098,
              "z": 0.617
            },
            "gtin": "4062300266087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72da",
            "leftCorner": {
              "x": -35.858,
              "y": -13.098,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.859,
              "y": -12.971,
              "z": 0.617
            },
            "gtin": "4062300265967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72db",
            "leftCorner": {
              "x": -35.86,
              "y": -12.971,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.861,
              "y": -12.848,
              "z": 0.617
            },
            "gtin": "4062300036710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72dc",
            "leftCorner": {
              "x": -35.861,
              "y": -12.848,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.862,
              "y": -12.716,
              "z": 0.617
            },
            "gtin": "4062300261303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72dd",
            "leftCorner": {
              "x": -35.855,
              "y": -12.716,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.856,
              "y": -12.595,
              "z": 0.617
            },
            "gtin": "4062300208254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72de",
            "leftCorner": {
              "x": -35.858,
              "y": -12.595,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.862,
              "y": -12.354,
              "z": 0.617
            },
            "gtin": "4062300265998",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3c9",
        "height": 0.93302,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d731a",
            "leftCorner": {
              "x": -35.814,
              "y": -13.382,
              "z": 0.763
            },
            "rightCorner": {
              "x": -35.815,
              "y": -13.229,
              "z": 0.763
            },
            "gtin": "4062300266353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d731c",
            "leftCorner": {
              "x": -35.852,
              "y": -13.229,
              "z": 0.763
            },
            "rightCorner": {
              "x": -35.853,
              "y": -13.095,
              "z": 0.763
            },
            "gtin": "4062300266346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d731d",
            "leftCorner": {
              "x": -35.856,
              "y": -13.095,
              "z": 0.763
            },
            "rightCorner": {
              "x": -35.858,
              "y": -12.959,
              "z": 0.763
            },
            "gtin": "4062300266230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d731e",
            "leftCorner": {
              "x": -35.858,
              "y": -12.959,
              "z": 0.763
            },
            "rightCorner": {
              "x": -35.858,
              "y": -12.916,
              "z": 0.763
            },
            "gtin": "4062300266247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d731f",
            "leftCorner": {
              "x": -36.031,
              "y": -12.918,
              "z": 0.763
            },
            "rightCorner": {
              "x": -36.031,
              "y": -12.871,
              "z": 0.763
            },
            "gtin": "4062300266247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7320",
            "leftCorner": {
              "x": -35.858,
              "y": -12.87,
              "z": 0.763
            },
            "rightCorner": {
              "x": -35.86,
              "y": -12.613,
              "z": 0.763
            },
            "gtin": "4062300025318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7321",
            "leftCorner": {
              "x": -35.861,
              "y": -12.613,
              "z": 0.763
            },
            "rightCorner": {
              "x": -35.863,
              "y": -12.465,
              "z": 0.763
            },
            "gtin": "4062300260795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7322",
            "leftCorner": {
              "x": -35.861,
              "y": -12.465,
              "z": 0.763
            },
            "rightCorner": {
              "x": -35.862,
              "y": -12.345,
              "z": 0.763
            },
            "gtin": "4062300261563",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3c3",
        "height": 1.1352,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7294",
            "leftCorner": {
              "x": -35.853,
              "y": -13.355,
              "z": 0.929
            },
            "rightCorner": {
              "x": -35.854,
              "y": -13.25,
              "z": 0.929
            },
            "gtin": "4062300020719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "788145571212de7987eabc25",
            "leftCorner": {
              "x": -35.815,
              "y": -13.12,
              "z": 0.929
            },
            "rightCorner": {
              "x": -35.816,
              "y": -13.011,
              "z": 0.929
            },
            "gtin": "4062300020719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7295",
            "leftCorner": {
              "x": -35.852,
              "y": -13.25,
              "z": 0.929
            },
            "rightCorner": {
              "x": -35.853,
              "y": -13.12,
              "z": 0.929
            },
            "gtin": "4062300381971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7297",
            "leftCorner": {
              "x": -35.858,
              "y": -13.011,
              "z": 0.929
            },
            "rightCorner": {
              "x": -35.859,
              "y": -12.881,
              "z": 0.929
            },
            "gtin": "4062300257689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7298",
            "leftCorner": {
              "x": -35.857,
              "y": -12.881,
              "z": 0.929
            },
            "rightCorner": {
              "x": -35.858,
              "y": -12.752,
              "z": 0.929
            },
            "gtin": "4062300021112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7299",
            "leftCorner": {
              "x": -35.855,
              "y": -12.752,
              "z": 0.929
            },
            "rightCorner": {
              "x": -35.856,
              "y": -12.648,
              "z": 0.929
            },
            "gtin": "4062300350403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d729a",
            "leftCorner": {
              "x": -35.858,
              "y": -12.648,
              "z": 0.929
            },
            "rightCorner": {
              "x": -35.86,
              "y": -12.481,
              "z": 0.929
            },
            "gtin": "4062300020313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d729b",
            "leftCorner": {
              "x": -35.859,
              "y": -12.481,
              "z": 0.929
            },
            "rightCorner": {
              "x": -35.86,
              "y": -12.35,
              "z": 0.929
            },
            "gtin": "4062300129443",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3c4",
        "height": 1.3111,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d72a2",
            "leftCorner": {
              "x": -35.812,
              "y": -13.382,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.814,
              "y": -13.244,
              "z": 1.073
            },
            "gtin": "4062300349445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72a4",
            "leftCorner": {
              "x": -35.855,
              "y": -13.244,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.858,
              "y": -12.993,
              "z": 1.073
            },
            "gtin": "4062300409064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72a5",
            "leftCorner": {
              "x": -35.86,
              "y": -12.993,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.861,
              "y": -12.778,
              "z": 1.073
            },
            "gtin": "4062300262652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72a6",
            "leftCorner": {
              "x": -35.856,
              "y": -12.778,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.857,
              "y": -12.646,
              "z": 1.073
            },
            "gtin": "4062300265295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72a7",
            "leftCorner": {
              "x": -35.857,
              "y": -12.646,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.859,
              "y": -12.483,
              "z": 1.073
            },
            "gtin": "4104420084063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72a8",
            "leftCorner": {
              "x": -35.862,
              "y": -12.483,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.864,
              "y": -12.224,
              "z": 1.073
            },
            "gtin": "4104420080201",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3c8",
        "height": 1.4869,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7309",
            "leftCorner": {
              "x": -35.804,
              "y": -13.381,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.805,
              "y": -13.224,
              "z": 1.217
            },
            "gtin": "4062300269804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d730b",
            "leftCorner": {
              "x": -35.845,
              "y": -13.224,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.847,
              "y": -13.1,
              "z": 1.217
            },
            "gtin": "4062300441576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d730c",
            "leftCorner": {
              "x": -35.849,
              "y": -13.1,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.85,
              "y": -12.978,
              "z": 1.217
            },
            "gtin": "4062300441170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d730d",
            "leftCorner": {
              "x": -35.85,
              "y": -12.978,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.851,
              "y": -12.856,
              "z": 1.217
            },
            "gtin": "4062300441316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d730e",
            "leftCorner": {
              "x": -35.852,
              "y": -12.856,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.853,
              "y": -12.744,
              "z": 1.217
            },
            "gtin": "4062300123175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d730f",
            "leftCorner": {
              "x": -35.848,
              "y": -12.744,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.849,
              "y": -12.619,
              "z": 1.217
            },
            "gtin": "4062300321335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7310",
            "leftCorner": {
              "x": -35.85,
              "y": -12.619,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.852,
              "y": -12.496,
              "z": 1.217
            },
            "gtin": "4018852029878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7311",
            "leftCorner": {
              "x": -35.851,
              "y": -12.496,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.853,
              "y": -12.356,
              "z": 1.217
            },
            "gtin": "4062300265813",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3c7",
        "height": 1.7354,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d72f9",
            "leftCorner": {
              "x": -35.847,
              "y": -13.359,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.848,
              "y": -13.228,
              "z": 1.42
            },
            "gtin": "4062300297043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72fa",
            "leftCorner": {
              "x": -35.847,
              "y": -13.228,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.848,
              "y": -13.133,
              "z": 1.42
            },
            "gtin": "4062300297036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72fb",
            "leftCorner": {
              "x": -35.85,
              "y": -13.133,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.852,
              "y": -12.98,
              "z": 1.42
            },
            "gtin": "4062300290082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72fc",
            "leftCorner": {
              "x": -35.851,
              "y": -12.98,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.852,
              "y": -12.878,
              "z": 1.42
            },
            "gtin": "4062300379381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72fd",
            "leftCorner": {
              "x": -35.854,
              "y": -12.878,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.855,
              "y": -12.737,
              "z": 1.42
            },
            "gtin": "4062300406483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72fe",
            "leftCorner": {
              "x": -35.851,
              "y": -12.737,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.852,
              "y": -12.615,
              "z": 1.42
            },
            "gtin": "4062300406476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ff",
            "leftCorner": {
              "x": -35.854,
              "y": -12.615,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.857,
              "y": -12.349,
              "z": 1.42
            },
            "gtin": "4062300406490",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "43f",
    "rightNeighborShelfId": "c26"
  },
  {
    "id": "4d6",
    "name": "4d6",
    "x": -6.593,
    "y": -7.475,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69989,
      "w": 0.71425
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 58
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d514",
        "height": 0.63321,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8044",
            "leftCorner": {
              "x": -6.472,
              "y": -7.549,
              "z": 0.518
            },
            "rightCorner": {
              "x": -6.469,
              "y": -7.728,
              "z": 0.518
            },
            "gtin": "4036300142368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8045",
            "leftCorner": {
              "x": -6.549,
              "y": -7.729,
              "z": 0.518
            },
            "rightCorner": {
              "x": -6.547,
              "y": -7.807,
              "z": 0.518
            },
            "gtin": "40466446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8046",
            "leftCorner": {
              "x": -6.35,
              "y": -7.803,
              "z": 0.518
            },
            "rightCorner": {
              "x": -6.348,
              "y": -7.92,
              "z": 0.518
            },
            "gtin": "4036300157638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8047",
            "leftCorner": {
              "x": -6.463,
              "y": -7.922,
              "z": 0.518
            },
            "rightCorner": {
              "x": -6.462,
              "y": -7.986,
              "z": 0.518
            },
            "gtin": "4260611590277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8048",
            "leftCorner": {
              "x": -6.495,
              "y": -7.986,
              "z": 0.518
            },
            "rightCorner": {
              "x": -6.493,
              "y": -8.105,
              "z": 0.518
            },
            "gtin": "4260611590000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8049",
            "leftCorner": {
              "x": -6.465,
              "y": -8.104,
              "z": 0.518
            },
            "rightCorner": {
              "x": -6.463,
              "y": -8.185,
              "z": 0.518
            },
            "gtin": "40145143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d804a",
            "leftCorner": {
              "x": -6.54,
              "y": -8.187,
              "z": 0.518
            },
            "rightCorner": {
              "x": -6.539,
              "y": -8.269,
              "z": 0.518
            },
            "gtin": "4014500514468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d804b",
            "leftCorner": {
              "x": -6.539,
              "y": -8.269,
              "z": 0.518
            },
            "rightCorner": {
              "x": -6.537,
              "y": -8.351,
              "z": 0.518
            },
            "gtin": "4014500514468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d804c",
            "leftCorner": {
              "x": -6.538,
              "y": -8.351,
              "z": 0.518
            },
            "rightCorner": {
              "x": -6.535,
              "y": -8.484,
              "z": 0.518
            },
            "gtin": "4014500520551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d804d",
            "leftCorner": {
              "x": -6.464,
              "y": -8.483,
              "z": 0.518
            },
            "rightCorner": {
              "x": -6.461,
              "y": -8.653,
              "z": 0.518
            },
            "gtin": "4014500516141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d802e",
            "leftCorner": {
              "x": -6.459,
              "y": -8.653,
              "z": 0.518
            },
            "rightCorner": {
              "x": -6.458,
              "y": -8.723,
              "z": 0.518
            },
            "gtin": "4014500518565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fdd983909790996cc19deac6",
            "leftCorner": {
              "x": -6.545,
              "y": -7.474,
              "z": 0.518
            },
            "rightCorner": {
              "x": -6.544,
              "y": -7.541,
              "z": 0.518
            },
            "gtin": "4014500518565",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d512",
        "height": 0.91398,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8069",
            "leftCorner": {
              "x": -6.517,
              "y": -7.473,
              "z": 0.748
            },
            "rightCorner": {
              "x": -6.511,
              "y": -7.762,
              "z": 0.748
            },
            "gtin": "2000433497277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d806b",
            "leftCorner": {
              "x": -6.537,
              "y": -7.763,
              "z": 0.748
            },
            "rightCorner": {
              "x": -6.535,
              "y": -7.853,
              "z": 0.748
            },
            "gtin": "4025500194888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d806c",
            "leftCorner": {
              "x": -6.463,
              "y": -7.852,
              "z": 0.748
            },
            "rightCorner": {
              "x": -6.462,
              "y": -7.935,
              "z": 0.748
            },
            "gtin": "4067517001735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d806d",
            "leftCorner": {
              "x": -6.462,
              "y": -7.935,
              "z": 0.748
            },
            "rightCorner": {
              "x": -6.46,
              "y": -8.049,
              "z": 0.748
            },
            "gtin": "4067517001308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d806e",
            "leftCorner": {
              "x": -6.461,
              "y": -8.049,
              "z": 0.748
            },
            "rightCorner": {
              "x": -6.458,
              "y": -8.192,
              "z": 0.748
            },
            "gtin": "4067517001315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d806f",
            "leftCorner": {
              "x": -6.539,
              "y": -8.193,
              "z": 0.748
            },
            "rightCorner": {
              "x": -6.536,
              "y": -8.319,
              "z": 0.748
            },
            "gtin": "4023600015539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8070",
            "leftCorner": {
              "x": -6.538,
              "y": -8.319,
              "z": 0.748
            },
            "rightCorner": {
              "x": -6.535,
              "y": -8.439,
              "z": 0.748
            },
            "gtin": "4023600015515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8071",
            "leftCorner": {
              "x": -6.54,
              "y": -8.439,
              "z": 0.748
            },
            "rightCorner": {
              "x": -6.536,
              "y": -8.621,
              "z": 0.748
            },
            "gtin": "4023600015553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d806a",
            "leftCorner": {
              "x": -6.454,
              "y": -8.619,
              "z": 0.748
            },
            "rightCorner": {
              "x": -6.452,
              "y": -8.722,
              "z": 0.748
            },
            "gtin": "42488682",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d510",
        "height": 1.1602,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f15",
            "leftCorner": {
              "x": -6.461,
              "y": -7.516,
              "z": 0.949
            },
            "rightCorner": {
              "x": -6.46,
              "y": -7.599,
              "z": 0.949
            },
            "gtin": "4023600014952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f16",
            "leftCorner": {
              "x": -6.46,
              "y": -7.599,
              "z": 0.949
            },
            "rightCorner": {
              "x": -6.458,
              "y": -7.693,
              "z": 0.949
            },
            "gtin": "4023600014938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f17",
            "leftCorner": {
              "x": -6.456,
              "y": -7.693,
              "z": 0.949
            },
            "rightCorner": {
              "x": -6.454,
              "y": -7.786,
              "z": 0.949
            },
            "gtin": "40236650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f18",
            "leftCorner": {
              "x": -6.454,
              "y": -7.786,
              "z": 0.949
            },
            "rightCorner": {
              "x": -6.449,
              "y": -8.048,
              "z": 0.949
            },
            "gtin": "4000521593704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f19",
            "leftCorner": {
              "x": -6.449,
              "y": -8.048,
              "z": 0.949
            },
            "rightCorner": {
              "x": -6.446,
              "y": -8.219,
              "z": 0.949
            },
            "gtin": "4002971398809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f1a",
            "leftCorner": {
              "x": -6.445,
              "y": -8.219,
              "z": 0.949
            },
            "rightCorner": {
              "x": -6.441,
              "y": -8.455,
              "z": 0.949
            },
            "gtin": "40236476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f1b",
            "leftCorner": {
              "x": -6.533,
              "y": -8.457,
              "z": 0.949
            },
            "rightCorner": {
              "x": -6.529,
              "y": -8.636,
              "z": 0.949
            },
            "gtin": "4023600015447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f1c",
            "leftCorner": {
              "x": -6.526,
              "y": -8.636,
              "z": 0.949
            },
            "rightCorner": {
              "x": -6.523,
              "y": -8.794,
              "z": 0.949
            },
            "gtin": "4023600015423",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d511",
        "height": 1.3846,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7eba",
            "leftCorner": {
              "x": -6.47,
              "y": -7.554,
              "z": 1.133
            },
            "rightCorner": {
              "x": -6.468,
              "y": -7.664,
              "z": 1.133
            },
            "gtin": "4250950119147",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "dc86e5b9ed8f0073c296c3cc",
            "leftCorner": {
              "x": -6.511,
              "y": -7.473,
              "z": 1.133
            },
            "rightCorner": {
              "x": -6.51,
              "y": -7.53,
              "z": 1.133
            },
            "gtin": "4000521561208",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7ebb",
            "leftCorner": {
              "x": -6.46,
              "y": -7.664,
              "z": 1.133
            },
            "rightCorner": {
              "x": -6.458,
              "y": -7.787,
              "z": 1.133
            },
            "gtin": "4023600007428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ebc",
            "leftCorner": {
              "x": -6.463,
              "y": -7.787,
              "z": 1.133
            },
            "rightCorner": {
              "x": -6.459,
              "y": -7.947,
              "z": 1.133
            },
            "gtin": "4023600014235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ebd",
            "leftCorner": {
              "x": -6.463,
              "y": -7.947,
              "z": 1.133
            },
            "rightCorner": {
              "x": -6.461,
              "y": -8.051,
              "z": 1.133
            },
            "gtin": "4023600014211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ebe",
            "leftCorner": {
              "x": -6.449,
              "y": -8.05,
              "z": 1.133
            },
            "rightCorner": {
              "x": -6.446,
              "y": -8.188,
              "z": 1.133
            },
            "gtin": "4000521561307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ebf",
            "leftCorner": {
              "x": -6.453,
              "y": -8.188,
              "z": 1.133
            },
            "rightCorner": {
              "x": -6.452,
              "y": -8.248,
              "z": 1.133
            },
            "gtin": "4000521561208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ec0",
            "leftCorner": {
              "x": -6.527,
              "y": -8.25,
              "z": 1.133
            },
            "rightCorner": {
              "x": -6.525,
              "y": -8.371,
              "z": 1.133
            },
            "gtin": "4005500027430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ec1",
            "leftCorner": {
              "x": -6.463,
              "y": -8.37,
              "z": 1.133
            },
            "rightCorner": {
              "x": -6.46,
              "y": -8.516,
              "z": 1.133
            },
            "gtin": "4025500127596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ec2",
            "leftCorner": {
              "x": -6.46,
              "y": -8.516,
              "z": 1.133
            },
            "rightCorner": {
              "x": -6.456,
              "y": -8.722,
              "z": 1.133
            },
            "gtin": "8595588204107",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d513",
        "height": 1.6143,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7fea",
            "leftCorner": {
              "x": -6.462,
              "y": -7.673,
              "z": 1.321
            },
            "rightCorner": {
              "x": -6.46,
              "y": -7.773,
              "z": 1.321
            },
            "gtin": "4000521580902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e64cfe1f4a06061c03959c6e",
            "leftCorner": {
              "x": -6.504,
              "y": -7.473,
              "z": 1.321
            },
            "rightCorner": {
              "x": -6.501,
              "y": -7.638,
              "z": 1.321
            },
            "gtin": "4002334117252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1ec3ea0b0b11713b8a4a53d6",
            "leftCorner": {
              "x": -6.501,
              "y": -7.638,
              "z": 1.321
            },
            "rightCorner": {
              "x": -6.5,
              "y": -7.668,
              "z": 1.321
            },
            "gtin": "40455068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7feb",
            "leftCorner": {
              "x": -6.456,
              "y": -7.773,
              "z": 1.321
            },
            "rightCorner": {
              "x": -6.454,
              "y": -7.862,
              "z": 1.321
            },
            "gtin": "4000521586102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fec",
            "leftCorner": {
              "x": -6.456,
              "y": -7.862,
              "z": 1.321
            },
            "rightCorner": {
              "x": -6.454,
              "y": -7.966,
              "z": 1.321
            },
            "gtin": "4260054650491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fed",
            "leftCorner": {
              "x": -6.454,
              "y": -7.966,
              "z": 1.321
            },
            "rightCorner": {
              "x": -6.452,
              "y": -8.052,
              "z": 1.321
            },
            "gtin": "4260054653201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fee",
            "leftCorner": {
              "x": -6.452,
              "y": -8.052,
              "z": 1.321
            },
            "rightCorner": {
              "x": -6.449,
              "y": -8.203,
              "z": 1.321
            },
            "gtin": "4260054653218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fef",
            "leftCorner": {
              "x": -6.451,
              "y": -8.203,
              "z": 1.321
            },
            "rightCorner": {
              "x": -6.445,
              "y": -8.513,
              "z": 1.321
            },
            "gtin": "4002334117214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ff0",
            "leftCorner": {
              "x": -6.454,
              "y": -8.513,
              "z": 1.321
            },
            "rightCorner": {
              "x": -6.451,
              "y": -8.659,
              "z": 1.321
            },
            "gtin": "4002334117252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ff1",
            "leftCorner": {
              "x": -6.452,
              "y": -8.659,
              "z": 1.321
            },
            "rightCorner": {
              "x": -6.449,
              "y": -8.81,
              "z": 1.321
            },
            "gtin": "40455068",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d516",
        "height": 1.832,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f70",
            "leftCorner": {
              "x": -6.463,
              "y": -7.549,
              "z": 1.499
            },
            "rightCorner": {
              "x": -6.458,
              "y": -7.788,
              "z": 1.499
            },
            "gtin": "4023600017762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "336401ed28e9ed05479069c9",
            "leftCorner": {
              "x": -6.504,
              "y": -7.473,
              "z": 1.499
            },
            "rightCorner": {
              "x": -6.503,
              "y": -7.526,
              "z": 1.499
            },
            "gtin": "4019300004614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "40e530ac31480b0f8f6b2f51",
            "leftCorner": {
              "x": -6.503,
              "y": -7.526,
              "z": 1.499
            },
            "rightCorner": {
              "x": -6.503,
              "y": -7.544,
              "z": 1.499
            },
            "gtin": "4019300004614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f71",
            "leftCorner": {
              "x": -6.455,
              "y": -7.789,
              "z": 1.499
            },
            "rightCorner": {
              "x": -6.453,
              "y": -7.911,
              "z": 1.499
            },
            "gtin": "4023600017786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f72",
            "leftCorner": {
              "x": -6.456,
              "y": -7.911,
              "z": 1.499
            },
            "rightCorner": {
              "x": -6.453,
              "y": -8.042,
              "z": 1.499
            },
            "gtin": "4000521586805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f73",
            "leftCorner": {
              "x": -6.453,
              "y": -8.042,
              "z": 1.499
            },
            "rightCorner": {
              "x": -6.45,
              "y": -8.186,
              "z": 1.499
            },
            "gtin": "4008452044227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f74",
            "leftCorner": {
              "x": -6.45,
              "y": -8.186,
              "z": 1.499
            },
            "rightCorner": {
              "x": -6.448,
              "y": -8.287,
              "z": 1.499
            },
            "gtin": "4008452044326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f75",
            "leftCorner": {
              "x": -6.451,
              "y": -8.288,
              "z": 1.499
            },
            "rightCorner": {
              "x": -6.448,
              "y": -8.4,
              "z": 1.499
            },
            "gtin": "4008452044111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f76",
            "leftCorner": {
              "x": -6.453,
              "y": -8.4,
              "z": 1.499
            },
            "rightCorner": {
              "x": -6.451,
              "y": -8.524,
              "z": 1.499
            },
            "gtin": "4019300162963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f77",
            "leftCorner": {
              "x": -6.455,
              "y": -8.524,
              "z": 1.499
            },
            "rightCorner": {
              "x": -6.452,
              "y": -8.646,
              "z": 1.499
            },
            "gtin": "4019300173624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f78",
            "leftCorner": {
              "x": -6.453,
              "y": -8.646,
              "z": 1.499
            },
            "rightCorner": {
              "x": -6.45,
              "y": -8.797,
              "z": 1.499
            },
            "gtin": "4019300004614",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ae7",
    "rightNeighborShelfId": "4d7"
  },
  {
    "id": "4d7",
    "name": "4d7",
    "x": -6.567,
    "y": -8.724,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69989,
      "w": 0.71425
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 53
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d51a",
        "height": 0.62261,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8072",
            "leftCorner": {
              "x": -6.487,
              "y": -8.722,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.482,
              "y": -8.934,
              "z": 0.509
            },
            "gtin": "8000500385395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8074",
            "leftCorner": {
              "x": -6.432,
              "y": -8.933,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.429,
              "y": -9.095,
              "z": 0.509
            },
            "gtin": "4008400290423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8075",
            "leftCorner": {
              "x": -6.435,
              "y": -9.095,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.432,
              "y": -9.225,
              "z": 0.509
            },
            "gtin": "8000500446430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8076",
            "leftCorner": {
              "x": -6.428,
              "y": -9.225,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.425,
              "y": -9.374,
              "z": 0.509
            },
            "gtin": "40084794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8077",
            "leftCorner": {
              "x": -6.511,
              "y": -9.376,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.507,
              "y": -9.571,
              "z": 0.509
            },
            "gtin": "80051237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8078",
            "leftCorner": {
              "x": -6.505,
              "y": -9.57,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.503,
              "y": -9.667,
              "z": 0.509
            },
            "gtin": "4260071794451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8079",
            "leftCorner": {
              "x": -6.503,
              "y": -9.667,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.501,
              "y": -9.764,
              "z": 0.509
            },
            "gtin": "4260071794451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d807a",
            "leftCorner": {
              "x": -6.501,
              "y": -9.764,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.499,
              "y": -9.861,
              "z": 0.509
            },
            "gtin": "4260071794451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d807b",
            "leftCorner": {
              "x": -6.428,
              "y": -9.86,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.424,
              "y": -10.049,
              "z": 0.509
            },
            "gtin": "42439844",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d51c",
        "height": 0.9021,
        "facings": [
          {
            "id": "68d8e50de1820c81800d80b5",
            "leftCorner": {
              "x": -6.499,
              "y": -8.723,
              "z": 0.738
            },
            "rightCorner": {
              "x": -6.495,
              "y": -8.946,
              "z": 0.738
            },
            "gtin": "8033629400588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80b6",
            "leftCorner": {
              "x": -6.514,
              "y": -8.946,
              "z": 0.738
            },
            "rightCorner": {
              "x": -6.509,
              "y": -9.188,
              "z": 0.738
            },
            "gtin": "9120025830077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80b7",
            "leftCorner": {
              "x": -6.508,
              "y": -9.188,
              "z": 0.738
            },
            "rightCorner": {
              "x": -6.505,
              "y": -9.335,
              "z": 0.738
            },
            "gtin": "9120025834723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80b8",
            "leftCorner": {
              "x": -6.467,
              "y": -9.334,
              "z": 0.738
            },
            "rightCorner": {
              "x": -6.463,
              "y": -9.541,
              "z": 0.738
            },
            "gtin": "40193762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80b9",
            "leftCorner": {
              "x": -6.42,
              "y": -9.54,
              "z": 0.738
            },
            "rightCorner": {
              "x": -6.417,
              "y": -9.689,
              "z": 0.738
            },
            "gtin": "40255231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80ba",
            "leftCorner": {
              "x": -6.42,
              "y": -9.689,
              "z": 0.738
            },
            "rightCorner": {
              "x": -6.416,
              "y": -9.854,
              "z": 0.738
            },
            "gtin": "4025500025588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80bb",
            "leftCorner": {
              "x": -6.415,
              "y": -9.854,
              "z": 0.738
            },
            "rightCorner": {
              "x": -6.411,
              "y": -10.038,
              "z": 0.738
            },
            "gtin": "40255514",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d519",
        "height": 1.1559,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f1d",
            "leftCorner": {
              "x": -6.43,
              "y": -8.791,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.428,
              "y": -8.9,
              "z": 0.946
            },
            "gtin": "4023600017496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f1e",
            "leftCorner": {
              "x": -6.426,
              "y": -8.9,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.424,
              "y": -9.015,
              "z": 0.946
            },
            "gtin": "4023600017472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f1f",
            "leftCorner": {
              "x": -6.423,
              "y": -9.015,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.42,
              "y": -9.174,
              "z": 0.946
            },
            "gtin": "4002971246209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f20",
            "leftCorner": {
              "x": -6.419,
              "y": -9.174,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.415,
              "y": -9.333,
              "z": 0.946
            },
            "gtin": "2000433657442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f21",
            "leftCorner": {
              "x": -6.506,
              "y": -9.335,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.504,
              "y": -9.472,
              "z": 0.946
            },
            "gtin": "4002971246506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f22",
            "leftCorner": {
              "x": -6.5,
              "y": -9.472,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.495,
              "y": -9.698,
              "z": 0.946
            },
            "gtin": "4045500023827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f23",
            "leftCorner": {
              "x": -6.412,
              "y": -9.696,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.409,
              "y": -9.833,
              "z": 0.946
            },
            "gtin": "40255101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f24",
            "leftCorner": {
              "x": -6.405,
              "y": -9.833,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.4,
              "y": -10.099,
              "z": 0.946
            },
            "gtin": "40255521",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d517",
        "height": 1.381,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ec3",
            "leftCorner": {
              "x": -6.449,
              "y": -8.722,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.446,
              "y": -8.83,
              "z": 1.13
            },
            "gtin": "4009700077998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ec4",
            "leftCorner": {
              "x": -6.437,
              "y": -8.83,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.436,
              "y": -8.919,
              "z": 1.13
            },
            "gtin": "4009700077998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ec5",
            "leftCorner": {
              "x": -6.434,
              "y": -8.919,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.431,
              "y": -9.036,
              "z": 1.13
            },
            "gtin": "4009700036100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ec6",
            "leftCorner": {
              "x": -6.435,
              "y": -9.036,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.432,
              "y": -9.187,
              "z": 1.13
            },
            "gtin": "4009700035745",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7ec7",
            "leftCorner": {
              "x": -6.426,
              "y": -9.187,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.425,
              "y": -9.279,
              "z": 1.13
            },
            "gtin": "4009700036797",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7ec8",
            "leftCorner": {
              "x": -6.428,
              "y": -9.279,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.424,
              "y": -9.45,
              "z": 1.13
            },
            "gtin": "4009700035684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ec9",
            "leftCorner": {
              "x": -6.425,
              "y": -9.45,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.421,
              "y": -9.633,
              "z": 1.13
            },
            "gtin": "4009700035707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eca",
            "leftCorner": {
              "x": -6.416,
              "y": -9.633,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.414,
              "y": -9.716,
              "z": 1.13
            },
            "gtin": "4002971180602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ecb",
            "leftCorner": {
              "x": -6.424,
              "y": -9.716,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.421,
              "y": -9.872,
              "z": 1.13
            },
            "gtin": "4002971180503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ecc",
            "leftCorner": {
              "x": -6.414,
              "y": -9.872,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.41,
              "y": -10.076,
              "z": 1.13
            },
            "gtin": "2000434746565",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d51b",
        "height": 1.6071,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ff2",
            "leftCorner": {
              "x": -6.437,
              "y": -8.809,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.434,
              "y": -8.995,
              "z": 1.315
            },
            "gtin": "4002971667301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "86bd16cdac973eaecb2ccf72",
            "leftCorner": {
              "x": -6.479,
              "y": -8.722,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.478,
              "y": -8.765,
              "z": 1.315
            },
            "gtin": "4002334112080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c98ea04fff10b69111c7bdbd",
            "leftCorner": {
              "x": -6.478,
              "y": -8.765,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.477,
              "y": -8.809,
              "z": 1.315
            },
            "gtin": "4002334112080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ff3",
            "leftCorner": {
              "x": -6.437,
              "y": -8.995,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.434,
              "y": -9.133,
              "z": 1.315
            },
            "gtin": "4002971665208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ff4",
            "leftCorner": {
              "x": -6.434,
              "y": -9.133,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.431,
              "y": -9.271,
              "z": 1.315
            },
            "gtin": "4002971665208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ff5",
            "leftCorner": {
              "x": -6.428,
              "y": -9.271,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.425,
              "y": -9.433,
              "z": 1.315
            },
            "gtin": "2000437373959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ff6",
            "leftCorner": {
              "x": -6.422,
              "y": -9.433,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.418,
              "y": -9.607,
              "z": 1.315
            },
            "gtin": "4002971398403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ff7",
            "leftCorner": {
              "x": -6.421,
              "y": -9.607,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.419,
              "y": -9.718,
              "z": 1.315
            },
            "gtin": "4002971396409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ff8",
            "leftCorner": {
              "x": -6.419,
              "y": -9.718,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.416,
              "y": -9.829,
              "z": 1.315
            },
            "gtin": "4002971396409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ff9",
            "leftCorner": {
              "x": -6.286,
              "y": -9.826,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.282,
              "y": -10.0,
              "z": 1.315
            },
            "gtin": "2000430962839",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d518",
        "height": 1.8292,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f79",
            "leftCorner": {
              "x": -6.521,
              "y": -8.798,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.519,
              "y": -8.883,
              "z": 1.497
            },
            "gtin": "4019300171521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7beb5562d68bc8f26764fa77",
            "leftCorner": {
              "x": -6.475,
              "y": -8.722,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.473,
              "y": -8.777,
              "z": 1.497
            },
            "gtin": "4016241051004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f7a",
            "leftCorner": {
              "x": -6.431,
              "y": -8.881,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.429,
              "y": -8.969,
              "z": 1.497
            },
            "gtin": "4019300171132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f7b",
            "leftCorner": {
              "x": -6.429,
              "y": -8.969,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.427,
              "y": -9.06,
              "z": 1.497
            },
            "gtin": "4019300163809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f7c",
            "leftCorner": {
              "x": -6.427,
              "y": -9.06,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.425,
              "y": -9.16,
              "z": 1.497
            },
            "gtin": "4019300163786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f7d",
            "leftCorner": {
              "x": -6.425,
              "y": -9.16,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.423,
              "y": -9.244,
              "z": 1.497
            },
            "gtin": "4019300168507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f7e",
            "leftCorner": {
              "x": -6.423,
              "y": -9.244,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.422,
              "y": -9.332,
              "z": 1.497
            },
            "gtin": "4016241050502",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7f7f",
            "leftCorner": {
              "x": -6.426,
              "y": -9.332,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.424,
              "y": -9.432,
              "z": 1.497
            },
            "gtin": "4016241030917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f80",
            "leftCorner": {
              "x": -6.422,
              "y": -9.432,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.42,
              "y": -9.525,
              "z": 1.497
            },
            "gtin": "4016241040534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f81",
            "leftCorner": {
              "x": -6.42,
              "y": -9.525,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.418,
              "y": -9.627,
              "z": 1.497
            },
            "gtin": "4016241051004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f82",
            "leftCorner": {
              "x": -6.417,
              "y": -9.627,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.414,
              "y": -9.736,
              "z": 1.497
            },
            "gtin": "4016241040619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f83",
            "leftCorner": {
              "x": -6.415,
              "y": -9.736,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.412,
              "y": -9.892,
              "z": 1.497
            },
            "gtin": "4062800018292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f84",
            "leftCorner": {
              "x": -6.504,
              "y": -9.894,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.501,
              "y": -10.033,
              "z": 1.497
            },
            "gtin": "2000432950445",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4d6",
    "rightNeighborShelfId": "4d8"
  },
  {
    "id": "4d8",
    "name": "4d8",
    "x": -6.542,
    "y": -9.974,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69989,
      "w": 0.71425
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 36
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d522",
        "height": 0.6247,
        "facings": [
          {
            "id": "68d8e50de1820c81800d807c",
            "leftCorner": {
              "x": -6.418,
              "y": -10.05,
              "z": 0.511
            },
            "rightCorner": {
              "x": -6.413,
              "y": -10.301,
              "z": 0.511
            },
            "gtin": "42103684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d807d",
            "leftCorner": {
              "x": -6.476,
              "y": -10.303,
              "z": 0.511
            },
            "rightCorner": {
              "x": -6.472,
              "y": -10.479,
              "z": 0.511
            },
            "gtin": "4025500297947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d807e",
            "leftCorner": {
              "x": -6.4,
              "y": -10.478,
              "z": 0.511
            },
            "rightCorner": {
              "x": -6.388,
              "y": -11.051,
              "z": 0.511
            },
            "gtin": "40858388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d807f",
            "leftCorner": {
              "x": -6.409,
              "y": -11.051,
              "z": 0.511
            },
            "rightCorner": {
              "x": -6.404,
              "y": -11.306,
              "z": 0.511
            },
            "gtin": "2000444791708",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d523",
        "height": 0.90363,
        "facings": [
          {
            "id": "68d8e50de1820c81800d80bc",
            "leftCorner": {
              "x": -6.504,
              "y": -10.04,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.499,
              "y": -10.29,
              "z": 0.739
            },
            "gtin": "42375814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80bd",
            "leftCorner": {
              "x": -6.444,
              "y": -10.289,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.439,
              "y": -10.49,
              "z": 0.739
            },
            "gtin": "40255729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80be",
            "leftCorner": {
              "x": -6.479,
              "y": -10.491,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.475,
              "y": -10.713,
              "z": 0.739
            },
            "gtin": "42334309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80bf",
            "leftCorner": {
              "x": -6.482,
              "y": -10.713,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.476,
              "y": -11.012,
              "z": 0.739
            },
            "gtin": "2000434020115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80c0",
            "leftCorner": {
              "x": -6.41,
              "y": -11.011,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.405,
              "y": -11.294,
              "z": 0.739
            },
            "gtin": "2000433872036",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d520",
        "height": 1.1563,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f25",
            "leftCorner": {
              "x": -6.411,
              "y": -10.1,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.408,
              "y": -10.261,
              "z": 0.946
            },
            "gtin": "42109860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a8393594d62bc517f05f2458",
            "leftCorner": {
              "x": -6.453,
              "y": -9.972,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.451,
              "y": -10.093,
              "z": 0.946
            },
            "gtin": "4014500520162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f26",
            "leftCorner": {
              "x": -6.404,
              "y": -10.261,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.398,
              "y": -10.525,
              "z": 0.946
            },
            "gtin": "4025500297961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f27",
            "leftCorner": {
              "x": -6.388,
              "y": -10.525,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.381,
              "y": -10.851,
              "z": 0.946
            },
            "gtin": "4063516011256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f28",
            "leftCorner": {
              "x": -6.409,
              "y": -10.852,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.404,
              "y": -11.071,
              "z": 0.946
            },
            "gtin": "4014500521237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f29",
            "leftCorner": {
              "x": -6.406,
              "y": -11.071,
              "z": 0.946
            },
            "rightCorner": {
              "x": -6.402,
              "y": -11.268,
              "z": 0.946
            },
            "gtin": "4014500520155",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d51e",
        "height": 1.3819,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ecd",
            "leftCorner": {
              "x": -6.487,
              "y": -10.078,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.48,
              "y": -10.457,
              "z": 1.131
            },
            "gtin": "4002334117542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ece",
            "leftCorner": {
              "x": -6.402,
              "y": -10.455,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.396,
              "y": -10.726,
              "z": 1.131
            },
            "gtin": "4002334118297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ecf",
            "leftCorner": {
              "x": -6.411,
              "y": -10.726,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.407,
              "y": -10.945,
              "z": 1.131
            },
            "gtin": "4063516011744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ed0",
            "leftCorner": {
              "x": -6.416,
              "y": -10.945,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.409,
              "y": -11.274,
              "z": 1.131
            },
            "gtin": "4002334116828",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d51f",
        "height": 1.6104,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ffa",
            "leftCorner": {
              "x": -6.423,
              "y": -10.003,
              "z": 1.318
            },
            "rightCorner": {
              "x": -6.421,
              "y": -10.091,
              "z": 1.318
            },
            "gtin": "4002334112080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ffc",
            "leftCorner": {
              "x": -6.428,
              "y": -10.12,
              "z": 1.318
            },
            "rightCorner": {
              "x": -6.427,
              "y": -10.179,
              "z": 1.318
            },
            "gtin": "4002334107635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ffd",
            "leftCorner": {
              "x": -6.418,
              "y": -10.179,
              "z": 1.318
            },
            "rightCorner": {
              "x": -6.414,
              "y": -10.37,
              "z": 1.318
            },
            "gtin": "4002334117900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ffe",
            "leftCorner": {
              "x": -6.407,
              "y": -10.37,
              "z": 1.318
            },
            "rightCorner": {
              "x": -6.405,
              "y": -10.456,
              "z": 1.318
            },
            "gtin": "4008452035591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fff",
            "leftCorner": {
              "x": -6.405,
              "y": -10.456,
              "z": 1.318
            },
            "rightCorner": {
              "x": -6.403,
              "y": -10.542,
              "z": 1.318
            },
            "gtin": "4008452035591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8000",
            "leftCorner": {
              "x": -6.397,
              "y": -10.542,
              "z": 1.318
            },
            "rightCorner": {
              "x": -6.393,
              "y": -10.742,
              "z": 1.318
            },
            "gtin": "4008452039728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8001",
            "leftCorner": {
              "x": -6.401,
              "y": -10.742,
              "z": 1.318
            },
            "rightCorner": {
              "x": -6.398,
              "y": -10.875,
              "z": 1.318
            },
            "gtin": "4008452037731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8002",
            "leftCorner": {
              "x": -6.418,
              "y": -10.875,
              "z": 1.318
            },
            "rightCorner": {
              "x": -6.414,
              "y": -11.087,
              "z": 1.318
            },
            "gtin": "4003490323693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8003",
            "leftCorner": {
              "x": -6.247,
              "y": -11.084,
              "z": 1.318
            },
            "rightCorner": {
              "x": -6.244,
              "y": -11.265,
              "z": 1.318
            },
            "gtin": "4003490323747",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d521",
        "height": 1.8292,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f85",
            "leftCorner": {
              "x": -6.42,
              "y": -10.032,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.418,
              "y": -10.16,
              "z": 1.497
            },
            "gtin": "4028900007413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f86",
            "leftCorner": {
              "x": -6.416,
              "y": -10.159,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.414,
              "y": -10.282,
              "z": 1.497
            },
            "gtin": "4028900007277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f87",
            "leftCorner": {
              "x": -6.407,
              "y": -10.281,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.405,
              "y": -10.416,
              "z": 1.497
            },
            "gtin": "4028900007307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f88",
            "leftCorner": {
              "x": -6.398,
              "y": -10.416,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.395,
              "y": -10.558,
              "z": 1.497
            },
            "gtin": "4028900007901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f89",
            "leftCorner": {
              "x": -6.392,
              "y": -10.558,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.389,
              "y": -10.72,
              "z": 1.497
            },
            "gtin": "4067517001124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f8a",
            "leftCorner": {
              "x": -6.401,
              "y": -10.72,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.398,
              "y": -10.898,
              "z": 1.497
            },
            "gtin": "4067517001155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f8b",
            "leftCorner": {
              "x": -6.418,
              "y": -10.898,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.415,
              "y": -11.063,
              "z": 1.497
            },
            "gtin": "4003490323709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f8c",
            "leftCorner": {
              "x": -6.411,
              "y": -11.063,
              "z": 1.497
            },
            "rightCorner": {
              "x": -6.406,
              "y": -11.275,
              "z": 1.497
            },
            "gtin": "4003490323617",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4d7",
    "rightNeighborShelfId": "4d9"
  },
  {
    "id": "4d9",
    "name": "4d9",
    "x": -6.517,
    "y": -11.224,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69989,
      "w": 0.71425
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 52
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d529",
        "height": 0.61749,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8080",
            "leftCorner": {
              "x": -6.398,
              "y": -11.306,
              "z": 0.505
            },
            "rightCorner": {
              "x": -6.391,
              "y": -11.626,
              "z": 0.505
            },
            "gtin": "4306188249955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a3193fdfe7e7524e8a26cf35",
            "leftCorner": {
              "x": -6.509,
              "y": -11.224,
              "z": 0.505
            },
            "rightCorner": {
              "x": -6.508,
              "y": -11.299,
              "z": 0.505
            },
            "gtin": "4002334115838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8081",
            "leftCorner": {
              "x": -6.468,
              "y": -11.628,
              "z": 0.505
            },
            "rightCorner": {
              "x": -6.463,
              "y": -11.889,
              "z": 0.505
            },
            "gtin": "4306188252153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8082",
            "leftCorner": {
              "x": -6.456,
              "y": -11.889,
              "z": 0.505
            },
            "rightCorner": {
              "x": -6.448,
              "y": -12.249,
              "z": 0.505
            },
            "gtin": "4002334113353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8083",
            "leftCorner": {
              "x": -6.439,
              "y": -12.248,
              "z": 0.505
            },
            "rightCorner": {
              "x": -6.435,
              "y": -12.472,
              "z": 0.505
            },
            "gtin": "4002334115838",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d52a",
        "height": 0.90189,
        "facings": [
          {
            "id": "68d8e50de1820c81800d80c1",
            "leftCorner": {
              "x": -6.396,
              "y": -11.295,
              "z": 0.738
            },
            "rightCorner": {
              "x": -6.39,
              "y": -11.589,
              "z": 0.738
            },
            "gtin": "4025839033858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7cf2ebdaafd5d7caee01e243",
            "leftCorner": {
              "x": -6.406,
              "y": -12.345,
              "z": 0.738
            },
            "rightCorner": {
              "x": -6.403,
              "y": -12.472,
              "z": 0.738
            },
            "gtin": "4002334112189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80c2",
            "leftCorner": {
              "x": -6.385,
              "y": -11.589,
              "z": 0.738
            },
            "rightCorner": {
              "x": -6.381,
              "y": -11.783,
              "z": 0.738
            },
            "gtin": "4025839049637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80c3",
            "leftCorner": {
              "x": -6.381,
              "y": -11.783,
              "z": 0.738
            },
            "rightCorner": {
              "x": -6.377,
              "y": -11.976,
              "z": 0.738
            },
            "gtin": "4025839049637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80c4",
            "leftCorner": {
              "x": -6.37,
              "y": -11.976,
              "z": 0.738
            },
            "rightCorner": {
              "x": -6.362,
              "y": -12.344,
              "z": 0.738
            },
            "gtin": "4002334116859",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d528",
        "height": 1.153,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f2a",
            "leftCorner": {
              "x": -6.431,
              "y": -11.268,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.427,
              "y": -11.497,
              "z": 0.943
            },
            "gtin": "4067517001612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f2b",
            "leftCorner": {
              "x": -6.382,
              "y": -11.496,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.38,
              "y": -11.618,
              "z": 0.943
            },
            "gtin": "4067517001773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f2c",
            "leftCorner": {
              "x": -6.38,
              "y": -11.618,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.377,
              "y": -11.777,
              "z": 0.943
            },
            "gtin": "4067517001728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f2d",
            "leftCorner": {
              "x": -6.376,
              "y": -11.777,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.369,
              "y": -12.123,
              "z": 0.943
            },
            "gtin": "4002334112950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f2e",
            "leftCorner": {
              "x": -6.407,
              "y": -12.124,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.402,
              "y": -12.381,
              "z": 0.943
            },
            "gtin": "4002334112981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f2f",
            "leftCorner": {
              "x": -6.367,
              "y": -12.38,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.362,
              "y": -12.591,
              "z": 0.943
            },
            "gtin": "4002334112936",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d526",
        "height": 1.3793,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ed2",
            "leftCorner": {
              "x": -6.399,
              "y": -11.412,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.396,
              "y": -11.532,
              "z": 1.129
            },
            "gtin": "4067517001643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aaef86f63ce13ca13aa9fcf9",
            "leftCorner": {
              "x": -6.434,
              "y": -11.222,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.432,
              "y": -11.315,
              "z": 1.129
            },
            "gtin": "4067517001551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7d4cdd255fcfc370a6de42e5",
            "leftCorner": {
              "x": -6.432,
              "y": -11.315,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.43,
              "y": -11.407,
              "z": 1.129
            },
            "gtin": "4067517001551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ed3",
            "leftCorner": {
              "x": -6.395,
              "y": -11.532,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.392,
              "y": -11.687,
              "z": 1.129
            },
            "gtin": "4067517001339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ed4",
            "leftCorner": {
              "x": -6.387,
              "y": -11.687,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.385,
              "y": -11.768,
              "z": 1.129
            },
            "gtin": "4067517001650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ed5",
            "leftCorner": {
              "x": -6.38,
              "y": -11.768,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.378,
              "y": -11.904,
              "z": 1.129
            },
            "gtin": "4067517001605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ed6",
            "leftCorner": {
              "x": -6.375,
              "y": -11.904,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.372,
              "y": -12.059,
              "z": 1.129
            },
            "gtin": "4067517001636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ed7",
            "leftCorner": {
              "x": -6.367,
              "y": -12.058,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.365,
              "y": -12.17,
              "z": 1.129
            },
            "gtin": "4008471491040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ed8",
            "leftCorner": {
              "x": -6.365,
              "y": -12.17,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.362,
              "y": -12.338,
              "z": 1.129
            },
            "gtin": "4008471491057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ed9",
            "leftCorner": {
              "x": -6.377,
              "y": -12.338,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.373,
              "y": -12.546,
              "z": 1.129
            },
            "gtin": "4306188251477",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d525",
        "height": 1.6046,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8004",
            "leftCorner": {
              "x": -6.482,
              "y": -11.271,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.48,
              "y": -11.339,
              "z": 1.313
            },
            "gtin": "4002971840209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8005",
            "leftCorner": {
              "x": -6.4,
              "y": -11.337,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.399,
              "y": -11.423,
              "z": 1.313
            },
            "gtin": "4002971842609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8006",
            "leftCorner": {
              "x": -6.396,
              "y": -11.423,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.394,
              "y": -11.518,
              "z": 1.313
            },
            "gtin": "4002971840100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8007",
            "leftCorner": {
              "x": -6.393,
              "y": -11.518,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.391,
              "y": -11.602,
              "z": 1.313
            },
            "gtin": "4002971841404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8008",
            "leftCorner": {
              "x": -6.39,
              "y": -11.602,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.389,
              "y": -11.687,
              "z": 1.313
            },
            "gtin": "4002971840407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8009",
            "leftCorner": {
              "x": -6.386,
              "y": -11.687,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.385,
              "y": -11.766,
              "z": 1.313
            },
            "gtin": "4002971842708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d800a",
            "leftCorner": {
              "x": -6.383,
              "y": -11.766,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.381,
              "y": -11.854,
              "z": 1.313
            },
            "gtin": "4002971845006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d800b",
            "leftCorner": {
              "x": -6.38,
              "y": -11.854,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.379,
              "y": -11.946,
              "z": 1.313
            },
            "gtin": "4002971845808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d800c",
            "leftCorner": {
              "x": -6.375,
              "y": -11.946,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.374,
              "y": -12.017,
              "z": 1.313
            },
            "gtin": "4002971840704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d800d",
            "leftCorner": {
              "x": -6.372,
              "y": -12.017,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.369,
              "y": -12.165,
              "z": 1.313
            },
            "gtin": "4002971841305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d800e",
            "leftCorner": {
              "x": -6.363,
              "y": -12.164,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.36,
              "y": -12.307,
              "z": 1.313
            },
            "gtin": "4002970000260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d800f",
            "leftCorner": {
              "x": -6.368,
              "y": -12.307,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.366,
              "y": -12.403,
              "z": 1.313
            },
            "gtin": "4002970000482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8010",
            "leftCorner": {
              "x": -6.366,
              "y": -12.403,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.362,
              "y": -12.558,
              "z": 1.313
            },
            "gtin": "4002970000499",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d527",
        "height": 1.8277,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f8d",
            "leftCorner": {
              "x": -6.485,
              "y": -11.277,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.484,
              "y": -11.339,
              "z": 1.495
            },
            "gtin": "4002971847109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9058a4db8e3a73014f83447f",
            "leftCorner": {
              "x": -6.443,
              "y": -11.222,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.442,
              "y": -11.276,
              "z": 1.495
            },
            "gtin": "5411188128601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f8e",
            "leftCorner": {
              "x": -6.483,
              "y": -11.339,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.481,
              "y": -11.427,
              "z": 1.495
            },
            "gtin": "4008471503996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f8f",
            "leftCorner": {
              "x": -6.399,
              "y": -11.425,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.397,
              "y": -11.51,
              "z": 1.495
            },
            "gtin": "4008471497042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f90",
            "leftCorner": {
              "x": -6.478,
              "y": -11.512,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.477,
              "y": -11.6,
              "z": 1.495
            },
            "gtin": "4008471493587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f91",
            "leftCorner": {
              "x": -6.391,
              "y": -11.598,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.39,
              "y": -11.67,
              "z": 1.495
            },
            "gtin": "4008471486510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f92",
            "leftCorner": {
              "x": -6.459,
              "y": -11.672,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.457,
              "y": -11.759,
              "z": 1.495
            },
            "gtin": "4008471507932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f93",
            "leftCorner": {
              "x": -6.381,
              "y": -11.757,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.379,
              "y": -11.859,
              "z": 1.495
            },
            "gtin": "4008471486503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f94",
            "leftCorner": {
              "x": -6.377,
              "y": -11.859,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.375,
              "y": -11.952,
              "z": 1.495
            },
            "gtin": "4002970001236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f95",
            "leftCorner": {
              "x": -6.373,
              "y": -11.952,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.37,
              "y": -12.09,
              "z": 1.495
            },
            "gtin": "4002970001212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f96",
            "leftCorner": {
              "x": -6.37,
              "y": -12.09,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.368,
              "y": -12.196,
              "z": 1.495
            },
            "gtin": "5411188141488",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7f97",
            "leftCorner": {
              "x": -6.447,
              "y": -12.198,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.446,
              "y": -12.259,
              "z": 1.495
            },
            "gtin": "5411188128601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f98",
            "leftCorner": {
              "x": -6.457,
              "y": -12.259,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.454,
              "y": -12.376,
              "z": 1.495
            },
            "gtin": "5411188138334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f99",
            "leftCorner": {
              "x": -6.455,
              "y": -12.376,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.451,
              "y": -12.599,
              "z": 1.495
            },
            "gtin": "5411188130741",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4d8",
    "rightNeighborShelfId": "4da"
  },
  {
    "id": "4da",
    "name": "4da",
    "x": -6.491,
    "y": -12.474,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69989,
      "w": 0.71425
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 72
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d52d",
        "height": 0.62315,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8084",
            "leftCorner": {
              "x": -6.409,
              "y": -12.472,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.408,
              "y": -12.533,
              "z": 0.51
            },
            "gtin": "4002971043501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8085",
            "leftCorner": {
              "x": -6.46,
              "y": -12.534,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.457,
              "y": -12.673,
              "z": 0.51
            },
            "gtin": "4002971043501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8086",
            "leftCorner": {
              "x": -6.375,
              "y": -12.672,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.372,
              "y": -12.824,
              "z": 0.51
            },
            "gtin": "4002971083606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8087",
            "leftCorner": {
              "x": -6.449,
              "y": -12.826,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.448,
              "y": -12.87,
              "z": 0.51
            },
            "gtin": "4002971013801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8088",
            "leftCorner": {
              "x": -6.448,
              "y": -12.87,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.447,
              "y": -12.915,
              "z": 0.51
            },
            "gtin": "4002971013801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8089",
            "leftCorner": {
              "x": -6.447,
              "y": -12.915,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.446,
              "y": -12.959,
              "z": 0.51
            },
            "gtin": "4002971013801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d808a",
            "leftCorner": {
              "x": -6.443,
              "y": -12.959,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.442,
              "y": -13.014,
              "z": 0.51
            },
            "gtin": "4002971037302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d808b",
            "leftCorner": {
              "x": -6.442,
              "y": -13.014,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.441,
              "y": -13.068,
              "z": 0.51
            },
            "gtin": "4002971037302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d808c",
            "leftCorner": {
              "x": -6.442,
              "y": -13.068,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.44,
              "y": -13.175,
              "z": 0.51
            },
            "gtin": "4046700005484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d808d",
            "leftCorner": {
              "x": -6.403,
              "y": -13.175,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.401,
              "y": -13.271,
              "z": 0.51
            },
            "gtin": "4046700236390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d808e",
            "leftCorner": {
              "x": -6.359,
              "y": -13.27,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.357,
              "y": -13.392,
              "z": 0.51
            },
            "gtin": "4046700236413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d808f",
            "leftCorner": {
              "x": -6.359,
              "y": -13.392,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.357,
              "y": -13.491,
              "z": 0.51
            },
            "gtin": "4046700004234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8090",
            "leftCorner": {
              "x": -6.44,
              "y": -13.492,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.437,
              "y": -13.596,
              "z": 0.51
            },
            "gtin": "4046700003756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8091",
            "leftCorner": {
              "x": -6.354,
              "y": -13.594,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.353,
              "y": -13.668,
              "z": 0.51
            },
            "gtin": "4046700014523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8092",
            "leftCorner": {
              "x": -6.352,
              "y": -13.668,
              "z": 0.51
            },
            "rightCorner": {
              "x": -6.349,
              "y": -13.8,
              "z": 0.51
            },
            "gtin": "4046700014691",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d52e",
        "height": 0.90138,
        "facings": [
          {
            "id": "68d8e50de1820c81800d80c9",
            "leftCorner": {
              "x": -6.368,
              "y": -12.661,
              "z": 0.737
            },
            "rightCorner": {
              "x": -6.365,
              "y": -12.819,
              "z": 0.737
            },
            "gtin": "4002971045000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c91ee89f39a1f6575d29cff9",
            "leftCorner": {
              "x": -6.413,
              "y": -12.472,
              "z": 0.737
            },
            "rightCorner": {
              "x": -6.41,
              "y": -12.605,
              "z": 0.737
            },
            "gtin": "4002971030204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e4fec5318bb379b7084d720d",
            "leftCorner": {
              "x": -6.41,
              "y": -12.605,
              "z": 0.737
            },
            "rightCorner": {
              "x": -6.409,
              "y": -12.645,
              "z": 0.737
            },
            "gtin": "4046700015933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80ca",
            "leftCorner": {
              "x": -6.358,
              "y": -12.819,
              "z": 0.737
            },
            "rightCorner": {
              "x": -6.356,
              "y": -12.898,
              "z": 0.737
            },
            "gtin": "4002971021103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80cb",
            "leftCorner": {
              "x": -6.356,
              "y": -12.898,
              "z": 0.737
            },
            "rightCorner": {
              "x": -6.354,
              "y": -12.977,
              "z": 0.737
            },
            "gtin": "4002971021103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80cc",
            "leftCorner": {
              "x": -6.4,
              "y": -12.978,
              "z": 0.737
            },
            "rightCorner": {
              "x": -6.398,
              "y": -13.097,
              "z": 0.737
            },
            "gtin": "4002971029307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80cd",
            "leftCorner": {
              "x": -6.358,
              "y": -13.096,
              "z": 0.737
            },
            "rightCorner": {
              "x": -6.356,
              "y": -13.2,
              "z": 0.737
            },
            "gtin": "4062800014829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80ce",
            "leftCorner": {
              "x": -6.364,
              "y": -13.201,
              "z": 0.737
            },
            "rightCorner": {
              "x": -6.362,
              "y": -13.288,
              "z": 0.737
            },
            "gtin": "4062800014836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80cf",
            "leftCorner": {
              "x": -6.358,
              "y": -13.288,
              "z": 0.737
            },
            "rightCorner": {
              "x": -6.356,
              "y": -13.384,
              "z": 0.737
            },
            "gtin": "4062800007838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80d0",
            "leftCorner": {
              "x": -6.355,
              "y": -13.384,
              "z": 0.737
            },
            "rightCorner": {
              "x": -6.353,
              "y": -13.487,
              "z": 0.737
            },
            "gtin": "4046700105504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80d1",
            "leftCorner": {
              "x": -6.352,
              "y": -13.487,
              "z": 0.737
            },
            "rightCorner": {
              "x": -6.35,
              "y": -13.615,
              "z": 0.737
            },
            "gtin": "4046700015933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80d2",
            "leftCorner": {
              "x": -6.348,
              "y": -13.614,
              "z": 0.737
            },
            "rightCorner": {
              "x": -6.345,
              "y": -13.784,
              "z": 0.737
            },
            "gtin": "4046700057124",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d52b",
        "height": 1.1545,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f30",
            "leftCorner": {
              "x": -6.371,
              "y": -12.591,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.369,
              "y": -12.696,
              "z": 0.945
            },
            "gtin": "4002971013306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "53b8e807a2e2a0132877f11f",
            "leftCorner": {
              "x": -6.413,
              "y": -12.472,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.411,
              "y": -12.576,
              "z": 0.945
            },
            "gtin": "4280001939554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f31",
            "leftCorner": {
              "x": -6.369,
              "y": -12.696,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.367,
              "y": -12.801,
              "z": 0.945
            },
            "gtin": "4002971013306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f32",
            "leftCorner": {
              "x": -6.36,
              "y": -12.801,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.357,
              "y": -12.959,
              "z": 0.945
            },
            "gtin": "2000435128681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f33",
            "leftCorner": {
              "x": -6.354,
              "y": -12.959,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.351,
              "y": -13.092,
              "z": 0.945
            },
            "gtin": "4002971020304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f34",
            "leftCorner": {
              "x": -6.404,
              "y": -13.093,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.402,
              "y": -13.193,
              "z": 0.945
            },
            "gtin": "4262426520258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f35",
            "leftCorner": {
              "x": -6.359,
              "y": -13.192,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.356,
              "y": -13.307,
              "z": 0.945
            },
            "gtin": "4280001939547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f36",
            "leftCorner": {
              "x": -6.356,
              "y": -13.307,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.354,
              "y": -13.408,
              "z": 0.945
            },
            "gtin": "4280001939554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f37",
            "leftCorner": {
              "x": -6.349,
              "y": -13.408,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.348,
              "y": -13.485,
              "z": 0.945
            },
            "gtin": "4023600011371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f38",
            "leftCorner": {
              "x": -6.347,
              "y": -13.485,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.346,
              "y": -13.533,
              "z": 0.945
            },
            "gtin": "4023600015799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f39",
            "leftCorner": {
              "x": -6.353,
              "y": -13.533,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.351,
              "y": -13.614,
              "z": 0.945
            },
            "gtin": "4036300225375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f3a",
            "leftCorner": {
              "x": -6.351,
              "y": -13.614,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.349,
              "y": -13.698,
              "z": 0.945
            },
            "gtin": "8719200207172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f3b",
            "leftCorner": {
              "x": -6.348,
              "y": -13.697,
              "z": 0.945
            },
            "rightCorner": {
              "x": -6.346,
              "y": -13.81,
              "z": 0.945
            },
            "gtin": "8719200207301",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d52f",
        "height": 1.3827,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7eda",
            "leftCorner": {
              "x": -6.38,
              "y": -12.547,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.379,
              "y": -12.627,
              "z": 1.131
            },
            "gtin": "4009700068927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "66244cf3b6b6bfe5eddb734f",
            "leftCorner": {
              "x": -6.417,
              "y": -12.472,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.416,
              "y": -12.514,
              "z": 1.131
            },
            "gtin": "4104420215610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d04f802a8c3311be6d86f4af",
            "leftCorner": {
              "x": -6.416,
              "y": -12.514,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.415,
              "y": -12.528,
              "z": 1.131
            },
            "gtin": "4104420215610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e6d9a041c5e5a6c76377776e",
            "leftCorner": {
              "x": -6.415,
              "y": -12.528,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.415,
              "y": -12.541,
              "z": 1.131
            },
            "gtin": "4104420215610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7edb",
            "leftCorner": {
              "x": -6.379,
              "y": -12.627,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.377,
              "y": -12.707,
              "z": 1.131
            },
            "gtin": "4009700068927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7edc",
            "leftCorner": {
              "x": -6.377,
              "y": -12.707,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.376,
              "y": -12.787,
              "z": 1.131
            },
            "gtin": "4009700068927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7edd",
            "leftCorner": {
              "x": -6.368,
              "y": -12.786,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.364,
              "y": -12.978,
              "z": 1.131
            },
            "gtin": "4009700036995",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7ede",
            "leftCorner": {
              "x": -6.357,
              "y": -12.978,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.354,
              "y": -13.146,
              "z": 1.131
            },
            "gtin": "4009700071231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7edf",
            "leftCorner": {
              "x": -6.366,
              "y": -13.146,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.364,
              "y": -13.249,
              "z": 1.131
            },
            "gtin": "5411188137887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ee0",
            "leftCorner": {
              "x": -6.361,
              "y": -13.248,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.359,
              "y": -13.327,
              "z": 1.131
            },
            "gtin": "5411188137863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ee1",
            "leftCorner": {
              "x": -6.359,
              "y": -13.327,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.356,
              "y": -13.492,
              "z": 1.131
            },
            "gtin": "4025500275211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ee2",
            "leftCorner": {
              "x": -6.36,
              "y": -13.492,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.358,
              "y": -13.589,
              "z": 1.131
            },
            "gtin": "4104420172869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ee3",
            "leftCorner": {
              "x": -6.352,
              "y": -13.589,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.351,
              "y": -13.678,
              "z": 1.131
            },
            "gtin": "4104420207448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ee4",
            "leftCorner": {
              "x": -6.348,
              "y": -13.678,
              "z": 1.131
            },
            "rightCorner": {
              "x": -6.346,
              "y": -13.797,
              "z": 1.131
            },
            "gtin": "4104420215610",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d530",
        "height": 1.6087,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8011",
            "leftCorner": {
              "x": -6.383,
              "y": -12.558,
              "z": 1.316
            },
            "rightCorner": {
              "x": -6.378,
              "y": -12.788,
              "z": 1.316
            },
            "gtin": "4009700076243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "374ff3987861695e735da423",
            "leftCorner": {
              "x": -6.415,
              "y": -12.472,
              "z": 1.316
            },
            "rightCorner": {
              "x": -6.413,
              "y": -12.546,
              "z": 1.316
            },
            "gtin": "5411188139584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8012",
            "leftCorner": {
              "x": -6.365,
              "y": -12.788,
              "z": 1.316
            },
            "rightCorner": {
              "x": -6.362,
              "y": -12.961,
              "z": 1.316
            },
            "gtin": "4009700037152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8013",
            "leftCorner": {
              "x": -6.361,
              "y": -12.961,
              "z": 1.316
            },
            "rightCorner": {
              "x": -6.358,
              "y": -13.079,
              "z": 1.316
            },
            "gtin": "4009700069016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8014",
            "leftCorner": {
              "x": -6.328,
              "y": -13.079,
              "z": 1.316
            },
            "rightCorner": {
              "x": -6.324,
              "y": -13.287,
              "z": 1.316
            },
            "gtin": "4009700071798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8015",
            "leftCorner": {
              "x": -6.36,
              "y": -13.287,
              "z": 1.316
            },
            "rightCorner": {
              "x": -6.357,
              "y": -13.447,
              "z": 1.316
            },
            "gtin": "4009700044693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8016",
            "leftCorner": {
              "x": -6.36,
              "y": -13.447,
              "z": 1.316
            },
            "rightCorner": {
              "x": -6.356,
              "y": -13.614,
              "z": 1.316
            },
            "gtin": "4025500288440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8017",
            "leftCorner": {
              "x": -6.355,
              "y": -13.614,
              "z": 1.316
            },
            "rightCorner": {
              "x": -6.352,
              "y": -13.774,
              "z": 1.316
            },
            "gtin": "5411188139584",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d52c",
        "height": 1.8306,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f9a",
            "leftCorner": {
              "x": -6.464,
              "y": -12.599,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.462,
              "y": -12.701,
              "z": 1.498
            },
            "gtin": "5411188128625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6565366475e110848970982e",
            "leftCorner": {
              "x": -6.497,
              "y": -12.474,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.495,
              "y": -12.591,
              "z": 1.498
            },
            "gtin": "5411188137979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f9b",
            "leftCorner": {
              "x": -6.454,
              "y": -12.701,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.452,
              "y": -12.794,
              "z": 1.498
            },
            "gtin": "5411188139034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f9c",
            "leftCorner": {
              "x": -6.447,
              "y": -12.794,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.445,
              "y": -12.899,
              "z": 1.498
            },
            "gtin": "5411188137979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f9d",
            "leftCorner": {
              "x": -6.362,
              "y": -12.897,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.36,
              "y": -12.978,
              "z": 1.498
            },
            "gtin": "5411188125808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f9e",
            "leftCorner": {
              "x": -6.367,
              "y": -12.978,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.365,
              "y": -13.063,
              "z": 1.498
            },
            "gtin": "5411188137993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f9f",
            "leftCorner": {
              "x": -6.444,
              "y": -13.064,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.441,
              "y": -13.196,
              "z": 1.498
            },
            "gtin": "5411188138051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fa0",
            "leftCorner": {
              "x": -6.445,
              "y": -13.196,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.443,
              "y": -13.316,
              "z": 1.498
            },
            "gtin": "5411188138099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fa1",
            "leftCorner": {
              "x": -6.444,
              "y": -13.316,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.443,
              "y": -13.395,
              "z": 1.498
            },
            "gtin": "5411188137917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fa2",
            "leftCorner": {
              "x": -6.36,
              "y": -13.393,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.357,
              "y": -13.538,
              "z": 1.498
            },
            "gtin": "5411188138037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fa3",
            "leftCorner": {
              "x": -6.441,
              "y": -13.539,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.438,
              "y": -13.662,
              "z": 1.498
            },
            "gtin": "5411188137955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fa4",
            "leftCorner": {
              "x": -6.434,
              "y": -13.662,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.431,
              "y": -13.789,
              "z": 1.498
            },
            "gtin": "5411188136347",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4d9",
    "rightNeighborShelfId": "4db"
  },
  {
    "id": "4db",
    "name": "4db",
    "x": -6.466,
    "y": -13.723,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69989,
      "w": 0.71425
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 58
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d535",
        "height": 0.62125,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8093",
            "leftCorner": {
              "x": -6.437,
              "y": -13.802,
              "z": 0.508
            },
            "rightCorner": {
              "x": -6.434,
              "y": -13.909,
              "z": 0.508
            },
            "gtin": "4028900004641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8094",
            "leftCorner": {
              "x": -6.347,
              "y": -13.907,
              "z": 0.508
            },
            "rightCorner": {
              "x": -6.345,
              "y": -14.035,
              "z": 0.508
            },
            "gtin": "4028900004351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8095",
            "leftCorner": {
              "x": -6.346,
              "y": -14.035,
              "z": 0.508
            },
            "rightCorner": {
              "x": -6.343,
              "y": -14.164,
              "z": 0.508
            },
            "gtin": "4028900004665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8096",
            "leftCorner": {
              "x": -6.343,
              "y": -14.164,
              "z": 0.508
            },
            "rightCorner": {
              "x": -6.34,
              "y": -14.301,
              "z": 0.508
            },
            "gtin": "4028900004702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8097",
            "leftCorner": {
              "x": -6.334,
              "y": -14.301,
              "z": 0.508
            },
            "rightCorner": {
              "x": -6.331,
              "y": -14.45,
              "z": 0.508
            },
            "gtin": "4028900004719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8098",
            "leftCorner": {
              "x": -6.329,
              "y": -14.45,
              "z": 0.508
            },
            "rightCorner": {
              "x": -6.326,
              "y": -14.585,
              "z": 0.508
            },
            "gtin": "4028900004726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8099",
            "leftCorner": {
              "x": -6.33,
              "y": -14.585,
              "z": 0.508
            },
            "rightCorner": {
              "x": -6.329,
              "y": -14.639,
              "z": 0.508
            },
            "gtin": "4306188362685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d809a",
            "leftCorner": {
              "x": -6.329,
              "y": -14.639,
              "z": 0.508
            },
            "rightCorner": {
              "x": -6.328,
              "y": -14.692,
              "z": 0.508
            },
            "gtin": "4306188362685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d809b",
            "leftCorner": {
              "x": -6.328,
              "y": -14.692,
              "z": 0.508
            },
            "rightCorner": {
              "x": -6.327,
              "y": -14.746,
              "z": 0.508
            },
            "gtin": "4306188362685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d809c",
            "leftCorner": {
              "x": -6.327,
              "y": -14.746,
              "z": 0.508
            },
            "rightCorner": {
              "x": -6.326,
              "y": -14.8,
              "z": 0.508
            },
            "gtin": "4306188362685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d809d",
            "leftCorner": {
              "x": -6.4,
              "y": -14.802,
              "z": 0.508
            },
            "rightCorner": {
              "x": -6.399,
              "y": -14.887,
              "z": 0.508
            },
            "gtin": "4306188362746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d809e",
            "leftCorner": {
              "x": -6.399,
              "y": -14.887,
              "z": 0.508
            },
            "rightCorner": {
              "x": -6.397,
              "y": -14.973,
              "z": 0.508
            },
            "gtin": "4306188362746",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d536",
        "height": 0.89903,
        "facings": [
          {
            "id": "68d8e50de1820c81800d80d3",
            "leftCorner": {
              "x": -6.347,
              "y": -13.784,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.344,
              "y": -13.93,
              "z": 0.736
            },
            "gtin": "4099936000358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80d4",
            "leftCorner": {
              "x": -6.338,
              "y": -13.93,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.336,
              "y": -14.064,
              "z": 0.736
            },
            "gtin": "3023290082324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80d5",
            "leftCorner": {
              "x": -6.342,
              "y": -14.064,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.337,
              "y": -14.303,
              "z": 0.736
            },
            "gtin": "4104420179899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80d6",
            "leftCorner": {
              "x": -6.332,
              "y": -14.303,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.329,
              "y": -14.45,
              "z": 0.736
            },
            "gtin": "4250426224269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80d7",
            "leftCorner": {
              "x": -6.325,
              "y": -14.45,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.323,
              "y": -14.57,
              "z": 0.736
            },
            "gtin": "40193502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80d8",
            "leftCorner": {
              "x": -6.323,
              "y": -14.57,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.321,
              "y": -14.678,
              "z": 0.736
            },
            "gtin": "4062800014409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80d9",
            "leftCorner": {
              "x": -6.325,
              "y": -14.679,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.322,
              "y": -14.846,
              "z": 0.736
            },
            "gtin": "4036303138498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80da",
            "leftCorner": {
              "x": -6.322,
              "y": -14.846,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.319,
              "y": -14.971,
              "z": 0.736
            },
            "gtin": "40363622",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d533",
        "height": 1.1529,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f3c",
            "leftCorner": {
              "x": -6.346,
              "y": -13.81,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.343,
              "y": -13.921,
              "z": 0.943
            },
            "gtin": "4104060025716",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "1dfe57d7e4785a4756ee2e96",
            "leftCorner": {
              "x": -6.383,
              "y": -13.721,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.382,
              "y": -13.778,
              "z": 0.943
            },
            "gtin": "4002970000901",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7f3d",
            "leftCorner": {
              "x": -6.34,
              "y": -13.921,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.338,
              "y": -14.016,
              "z": 0.943
            },
            "gtin": "4250780325459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f3e",
            "leftCorner": {
              "x": -6.341,
              "y": -14.016,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.338,
              "y": -14.144,
              "z": 0.943
            },
            "gtin": "4250780325435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f3f",
            "leftCorner": {
              "x": -6.339,
              "y": -14.144,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.334,
              "y": -14.354,
              "z": 0.943
            },
            "gtin": "4250780325411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f40",
            "leftCorner": {
              "x": -6.329,
              "y": -14.354,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.326,
              "y": -14.485,
              "z": 0.943
            },
            "gtin": "4250780325398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f41",
            "leftCorner": {
              "x": -6.325,
              "y": -14.485,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.322,
              "y": -14.598,
              "z": 0.943
            },
            "gtin": "4104060024757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f42",
            "leftCorner": {
              "x": -6.323,
              "y": -14.598,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.32,
              "y": -14.718,
              "z": 0.943
            },
            "gtin": "4104060024740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f43",
            "leftCorner": {
              "x": -6.323,
              "y": -14.718,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.321,
              "y": -14.809,
              "z": 0.943
            },
            "gtin": "4002970000673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f44",
            "leftCorner": {
              "x": -6.321,
              "y": -14.809,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.319,
              "y": -14.909,
              "z": 0.943
            },
            "gtin": "4002970001748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f45",
            "leftCorner": {
              "x": -6.314,
              "y": -14.909,
              "z": 0.943
            },
            "rightCorner": {
              "x": -6.313,
              "y": -14.97,
              "z": 0.943
            },
            "gtin": "4002970000901",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d532",
        "height": 1.3804,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ee5",
            "leftCorner": {
              "x": -6.351,
              "y": -13.797,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.349,
              "y": -13.908,
              "z": 1.129
            },
            "gtin": "4067517001711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "950893351834997d842636a2",
            "leftCorner": {
              "x": -6.39,
              "y": -13.722,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.389,
              "y": -13.764,
              "z": 1.129
            },
            "gtin": "4008452031067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ee6",
            "leftCorner": {
              "x": -6.349,
              "y": -13.908,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.346,
              "y": -14.051,
              "z": 1.129
            },
            "gtin": "4002334110802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ee7",
            "leftCorner": {
              "x": -6.344,
              "y": -14.051,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.341,
              "y": -14.182,
              "z": 1.129
            },
            "gtin": "4008471505006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ee8",
            "leftCorner": {
              "x": -6.341,
              "y": -14.182,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.337,
              "y": -14.373,
              "z": 1.129
            },
            "gtin": "4008452011960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ee9",
            "leftCorner": {
              "x": -6.334,
              "y": -14.373,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.33,
              "y": -14.56,
              "z": 1.129
            },
            "gtin": "4008452031067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eea",
            "leftCorner": {
              "x": -6.333,
              "y": -14.56,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.329,
              "y": -14.803,
              "z": 1.129
            },
            "gtin": "4008452011007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eeb",
            "leftCorner": {
              "x": -6.325,
              "y": -14.803,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.322,
              "y": -14.971,
              "z": 1.129
            },
            "gtin": "4104420224001",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d531",
        "height": 1.6034,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8018",
            "leftCorner": {
              "x": -6.354,
              "y": -13.773,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.352,
              "y": -13.857,
              "z": 1.312
            },
            "gtin": "4104420134867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8019",
            "leftCorner": {
              "x": -6.353,
              "y": -13.857,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.351,
              "y": -13.947,
              "z": 1.312
            },
            "gtin": "4104420074101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d801a",
            "leftCorner": {
              "x": -6.349,
              "y": -13.947,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.347,
              "y": -14.047,
              "z": 1.312
            },
            "gtin": "4008471500193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d801b",
            "leftCorner": {
              "x": -6.345,
              "y": -14.047,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.344,
              "y": -14.123,
              "z": 1.312
            },
            "gtin": "4008471492870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d801c",
            "leftCorner": {
              "x": -6.347,
              "y": -14.123,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.345,
              "y": -14.208,
              "z": 1.312
            },
            "gtin": "4046700006184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d801d",
            "leftCorner": {
              "x": -6.344,
              "y": -14.208,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.342,
              "y": -14.301,
              "z": 1.312
            },
            "gtin": "4104060011245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d801e",
            "leftCorner": {
              "x": -6.338,
              "y": -14.301,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.337,
              "y": -14.374,
              "z": 1.312
            },
            "gtin": "4067517003708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d801f",
            "leftCorner": {
              "x": -6.333,
              "y": -14.374,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.331,
              "y": -14.46,
              "z": 1.312
            },
            "gtin": "4067517001629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8020",
            "leftCorner": {
              "x": -6.331,
              "y": -14.46,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.329,
              "y": -14.54,
              "z": 1.312
            },
            "gtin": "4002971006308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8021",
            "leftCorner": {
              "x": -6.327,
              "y": -14.54,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.325,
              "y": -14.639,
              "z": 1.312
            },
            "gtin": "4002971006407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8022",
            "leftCorner": {
              "x": -6.326,
              "y": -14.639,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.325,
              "y": -14.712,
              "z": 1.312
            },
            "gtin": "4016241050496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8023",
            "leftCorner": {
              "x": -6.326,
              "y": -14.712,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.322,
              "y": -14.891,
              "z": 1.312
            },
            "gtin": "4016241030603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8024",
            "leftCorner": {
              "x": -6.311,
              "y": -14.891,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.31,
              "y": -14.97,
              "z": 1.312
            },
            "gtin": "4016241050236",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d534",
        "height": 1.8278,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7fa5",
            "leftCorner": {
              "x": -6.436,
              "y": -13.789,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.435,
              "y": -13.859,
              "z": 1.495
            },
            "gtin": "4003490032076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fa6",
            "leftCorner": {
              "x": -6.35,
              "y": -13.857,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.347,
              "y": -14.005,
              "z": 1.495
            },
            "gtin": "4104420257832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fa7",
            "leftCorner": {
              "x": -6.348,
              "y": -14.005,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.344,
              "y": -14.211,
              "z": 1.495
            },
            "gtin": "4003490323600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fa8",
            "leftCorner": {
              "x": -6.341,
              "y": -14.211,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.338,
              "y": -14.361,
              "z": 1.495
            },
            "gtin": "4250950121416",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7fa9",
            "leftCorner": {
              "x": -6.33,
              "y": -14.361,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.328,
              "y": -14.469,
              "z": 1.495
            },
            "gtin": "5202258025513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7faa",
            "leftCorner": {
              "x": -6.326,
              "y": -14.469,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.324,
              "y": -14.566,
              "z": 1.495
            },
            "gtin": "5201054015636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fab",
            "leftCorner": {
              "x": -6.328,
              "y": -14.566,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.325,
              "y": -14.683,
              "z": 1.495
            },
            "gtin": "5201054015872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fac",
            "leftCorner": {
              "x": -6.325,
              "y": -14.683,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.322,
              "y": -14.845,
              "z": 1.495
            },
            "gtin": "4019300168095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fad",
            "leftCorner": {
              "x": -6.324,
              "y": -14.845,
              "z": 1.495
            },
            "rightCorner": {
              "x": -6.322,
              "y": -14.971,
              "z": 1.495
            },
            "gtin": "4306188434054",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4da",
    "rightNeighborShelfId": "4dc"
  },
  {
    "id": "4dc",
    "name": "4dc",
    "x": -6.44,
    "y": -14.973,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69989,
      "w": 0.71425
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 61
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d538",
        "height": 0.62162,
        "facings": [
          {
            "id": "68d8e50de1820c81800d809f",
            "leftCorner": {
              "x": -6.392,
              "y": -14.973,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.39,
              "y": -15.052,
              "z": 0.509
            },
            "gtin": "4260071790057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80a0",
            "leftCorner": {
              "x": -6.397,
              "y": -15.052,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.395,
              "y": -15.134,
              "z": 0.509
            },
            "gtin": "4260071790057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80a1",
            "leftCorner": {
              "x": -6.315,
              "y": -15.133,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.313,
              "y": -15.239,
              "z": 0.509
            },
            "gtin": "4250780324452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80a2",
            "leftCorner": {
              "x": -6.314,
              "y": -15.239,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.311,
              "y": -15.387,
              "z": 0.509
            },
            "gtin": "4008452029118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80a3",
            "leftCorner": {
              "x": -6.312,
              "y": -15.387,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.31,
              "y": -15.479,
              "z": 0.509
            },
            "gtin": "4045317058203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80a4",
            "leftCorner": {
              "x": -6.31,
              "y": -15.479,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.308,
              "y": -15.57,
              "z": 0.509
            },
            "gtin": "4045317058203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80a5",
            "leftCorner": {
              "x": -6.388,
              "y": -15.572,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.386,
              "y": -15.666,
              "z": 0.509
            },
            "gtin": "4046700014202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80a6",
            "leftCorner": {
              "x": -6.386,
              "y": -15.666,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.384,
              "y": -15.761,
              "z": 0.509
            },
            "gtin": "4046700014202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80a7",
            "leftCorner": {
              "x": -6.384,
              "y": -15.761,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.382,
              "y": -15.855,
              "z": 0.509
            },
            "gtin": "4046700014202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80a8",
            "leftCorner": {
              "x": -6.308,
              "y": -15.854,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.306,
              "y": -15.947,
              "z": 0.509
            },
            "gtin": "4036300006097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80a9",
            "leftCorner": {
              "x": -6.306,
              "y": -15.947,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.305,
              "y": -16.04,
              "z": 0.509
            },
            "gtin": "4036300006097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80aa",
            "leftCorner": {
              "x": -6.305,
              "y": -16.04,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.303,
              "y": -16.134,
              "z": 0.509
            },
            "gtin": "4036300006097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80ab",
            "leftCorner": {
              "x": -6.302,
              "y": -16.134,
              "z": 0.509
            },
            "rightCorner": {
              "x": -6.298,
              "y": -16.33,
              "z": 0.509
            },
            "gtin": "4260071790903",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d53b",
        "height": 0.89742,
        "facings": [
          {
            "id": "68d8e50de1820c81800d80db",
            "leftCorner": {
              "x": -6.317,
              "y": -14.971,
              "z": 0.734
            },
            "rightCorner": {
              "x": -6.316,
              "y": -15.011,
              "z": 0.734
            },
            "gtin": "4008452023413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80dc",
            "leftCorner": {
              "x": -6.316,
              "y": -15.011,
              "z": 0.734
            },
            "rightCorner": {
              "x": -6.312,
              "y": -15.182,
              "z": 0.734
            },
            "gtin": "4008452023413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80dd",
            "leftCorner": {
              "x": -6.313,
              "y": -15.182,
              "z": 0.734
            },
            "rightCorner": {
              "x": -6.308,
              "y": -15.405,
              "z": 0.734
            },
            "gtin": "4008452044449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80de",
            "leftCorner": {
              "x": -6.307,
              "y": -15.405,
              "z": 0.734
            },
            "rightCorner": {
              "x": -6.304,
              "y": -15.562,
              "z": 0.734
            },
            "gtin": "4008452025530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80df",
            "leftCorner": {
              "x": -6.3,
              "y": -15.562,
              "z": 0.734
            },
            "rightCorner": {
              "x": -6.298,
              "y": -15.679,
              "z": 0.734
            },
            "gtin": "4062800008170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80e0",
            "leftCorner": {
              "x": -6.301,
              "y": -15.679,
              "z": 0.734
            },
            "rightCorner": {
              "x": -6.299,
              "y": -15.802,
              "z": 0.734
            },
            "gtin": "4250780302474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80e1",
            "leftCorner": {
              "x": -6.297,
              "y": -15.802,
              "z": 0.734
            },
            "rightCorner": {
              "x": -6.292,
              "y": -16.055,
              "z": 0.734
            },
            "gtin": "4002970000932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80e2",
            "leftCorner": {
              "x": -6.293,
              "y": -16.055,
              "z": 0.734
            },
            "rightCorner": {
              "x": -6.288,
              "y": -16.298,
              "z": 0.734
            },
            "gtin": "4306188412502",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d537",
        "height": 1.1507,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f46",
            "leftCorner": {
              "x": -6.307,
              "y": -14.971,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.307,
              "y": -15.021,
              "z": 0.941
            },
            "gtin": "4306188414834",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7f47",
            "leftCorner": {
              "x": -6.313,
              "y": -15.021,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.311,
              "y": -15.104,
              "z": 0.941
            },
            "gtin": "4306188414834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f48",
            "leftCorner": {
              "x": -6.311,
              "y": -15.104,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.308,
              "y": -15.223,
              "z": 0.941
            },
            "gtin": "40466057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f49",
            "leftCorner": {
              "x": -6.346,
              "y": -15.224,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.344,
              "y": -15.338,
              "z": 0.941
            },
            "gtin": "40466644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f4a",
            "leftCorner": {
              "x": -6.305,
              "y": -15.338,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.301,
              "y": -15.502,
              "z": 0.941
            },
            "gtin": "4260079145149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f4b",
            "leftCorner": {
              "x": -6.302,
              "y": -15.502,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.299,
              "y": -15.638,
              "z": 0.941
            },
            "gtin": "4036303121889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f4c",
            "leftCorner": {
              "x": -6.301,
              "y": -15.638,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.297,
              "y": -15.788,
              "z": 0.941
            },
            "gtin": "4104420073760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f4d",
            "leftCorner": {
              "x": -6.295,
              "y": -15.788,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.291,
              "y": -15.979,
              "z": 0.941
            },
            "gtin": "4104420073081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f4e",
            "leftCorner": {
              "x": -6.291,
              "y": -15.978,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.289,
              "y": -16.052,
              "z": 0.941
            },
            "gtin": "4002970000628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f4f",
            "leftCorner": {
              "x": -6.289,
              "y": -16.052,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.288,
              "y": -16.127,
              "z": 0.941
            },
            "gtin": "4002970000628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f50",
            "leftCorner": {
              "x": -6.294,
              "y": -16.128,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.291,
              "y": -16.274,
              "z": 0.941
            },
            "gtin": "4002970000918",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d53a",
        "height": 1.3799,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7eec",
            "leftCorner": {
              "x": -6.317,
              "y": -14.971,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.316,
              "y": -15.032,
              "z": 1.129
            },
            "gtin": "40466101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3da942ded0298d148718b660",
            "leftCorner": {
              "x": -6.339,
              "y": -15.998,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.337,
              "y": -16.117,
              "z": 1.129
            },
            "gtin": "4306188376989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eed",
            "leftCorner": {
              "x": -6.321,
              "y": -15.032,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.318,
              "y": -15.139,
              "z": 1.129
            },
            "gtin": "40466101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eee",
            "leftCorner": {
              "x": -6.313,
              "y": -15.139,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.311,
              "y": -15.241,
              "z": 1.129
            },
            "gtin": "40466002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eef",
            "leftCorner": {
              "x": -6.314,
              "y": -15.241,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.312,
              "y": -15.351,
              "z": 1.129
            },
            "gtin": "40466538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ef0",
            "leftCorner": {
              "x": -6.312,
              "y": -15.351,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.31,
              "y": -15.46,
              "z": 1.129
            },
            "gtin": "40466538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ef1",
            "leftCorner": {
              "x": -6.313,
              "y": -15.46,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.308,
              "y": -15.718,
              "z": 1.129
            },
            "gtin": "40455303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ef2",
            "leftCorner": {
              "x": -6.308,
              "y": -15.718,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.303,
              "y": -15.968,
              "z": 1.129
            },
            "gtin": "4306188376989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ef3",
            "leftCorner": {
              "x": -6.3,
              "y": -15.968,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.299,
              "y": -15.998,
              "z": 1.129
            },
            "gtin": "4104420077980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ef5",
            "leftCorner": {
              "x": -6.296,
              "y": -16.134,
              "z": 1.129
            },
            "rightCorner": {
              "x": -6.293,
              "y": -16.299,
              "z": 1.129
            },
            "gtin": "4002970000925",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d539",
        "height": 1.6031,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8025",
            "leftCorner": {
              "x": -6.303,
              "y": -14.971,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.303,
              "y": -15.011,
              "z": 1.312
            },
            "gtin": "40466095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8026",
            "leftCorner": {
              "x": -6.318,
              "y": -15.012,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.316,
              "y": -15.119,
              "z": 1.312
            },
            "gtin": "40466095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8027",
            "leftCorner": {
              "x": -6.315,
              "y": -15.119,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.313,
              "y": -15.246,
              "z": 1.312
            },
            "gtin": "40466071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8028",
            "leftCorner": {
              "x": -6.313,
              "y": -15.246,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.308,
              "y": -15.451,
              "z": 1.312
            },
            "gtin": "40466064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8029",
            "leftCorner": {
              "x": -6.307,
              "y": -15.451,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.303,
              "y": -15.64,
              "z": 1.312
            },
            "gtin": "40455310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d802a",
            "leftCorner": {
              "x": -6.305,
              "y": -15.64,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.302,
              "y": -15.787,
              "z": 1.312
            },
            "gtin": "4000521579302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d802b",
            "leftCorner": {
              "x": -6.301,
              "y": -15.787,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.297,
              "y": -15.973,
              "z": 1.312
            },
            "gtin": "4000521577100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d802c",
            "leftCorner": {
              "x": -6.298,
              "y": -15.973,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.295,
              "y": -16.132,
              "z": 1.312
            },
            "gtin": "4000521579005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fcd",
            "leftCorner": {
              "x": -6.299,
              "y": -16.132,
              "z": 1.312
            },
            "rightCorner": {
              "x": -6.297,
              "y": -16.221,
              "z": 1.312
            },
            "gtin": "4016241020475",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d53c",
        "height": 1.8249,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7fae",
            "leftCorner": {
              "x": -6.318,
              "y": -14.971,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.316,
              "y": -15.066,
              "z": 1.493
            },
            "gtin": "8585002520838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7faf",
            "leftCorner": {
              "x": -6.313,
              "y": -15.066,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.312,
              "y": -15.135,
              "z": 1.493
            },
            "gtin": "8585002520838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fb0",
            "leftCorner": {
              "x": -6.312,
              "y": -15.135,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.31,
              "y": -15.204,
              "z": 1.493
            },
            "gtin": "8585002520838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fb1",
            "leftCorner": {
              "x": -6.31,
              "y": -15.204,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.309,
              "y": -15.273,
              "z": 1.493
            },
            "gtin": "8585002520838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fb2",
            "leftCorner": {
              "x": -6.31,
              "y": -15.273,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.308,
              "y": -15.393,
              "z": 1.493
            },
            "gtin": "8719200278844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fb3",
            "leftCorner": {
              "x": -6.308,
              "y": -15.393,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.306,
              "y": -15.501,
              "z": 1.493
            },
            "gtin": "8719200040557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fb4",
            "leftCorner": {
              "x": -6.306,
              "y": -15.501,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.303,
              "y": -15.634,
              "z": 1.493
            },
            "gtin": "8719200041219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fb5",
            "leftCorner": {
              "x": -6.303,
              "y": -15.634,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.299,
              "y": -15.837,
              "z": 1.493
            },
            "gtin": "8719200040595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fb6",
            "leftCorner": {
              "x": -6.295,
              "y": -15.837,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.292,
              "y": -15.993,
              "z": 1.493
            },
            "gtin": "4009700074928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fb7",
            "leftCorner": {
              "x": -6.299,
              "y": -15.993,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.296,
              "y": -16.133,
              "z": 1.493
            },
            "gtin": "4009700075055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fb8",
            "leftCorner": {
              "x": -6.298,
              "y": -16.133,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.295,
              "y": -16.267,
              "z": 1.493
            },
            "gtin": "4009700074744",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4db",
    "rightNeighborShelfId": "4dd"
  },
  {
    "id": "4dd",
    "name": "4dd",
    "x": -6.415,
    "y": -16.223,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69989,
      "w": 0.71425
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 54,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d53e",
        "height": 0.6165,
        "facings": [
          {
            "id": "68d8e50de1820c81800d80ac",
            "leftCorner": {
              "x": -6.299,
              "y": -16.329,
              "z": 0.504
            },
            "rightCorner": {
              "x": -6.295,
              "y": -16.509,
              "z": 0.504
            },
            "gtin": "42448853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80ad",
            "leftCorner": {
              "x": -6.379,
              "y": -16.511,
              "z": 0.504
            },
            "rightCorner": {
              "x": -6.378,
              "y": -16.577,
              "z": 0.504
            },
            "gtin": "42448877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80ae",
            "leftCorner": {
              "x": -6.378,
              "y": -16.577,
              "z": 0.504
            },
            "rightCorner": {
              "x": -6.376,
              "y": -16.644,
              "z": 0.504
            },
            "gtin": "42448877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80af",
            "leftCorner": {
              "x": -6.376,
              "y": -16.644,
              "z": 0.504
            },
            "rightCorner": {
              "x": -6.375,
              "y": -16.711,
              "z": 0.504
            },
            "gtin": "42448877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80b0",
            "leftCorner": {
              "x": -6.288,
              "y": -16.709,
              "z": 0.504
            },
            "rightCorner": {
              "x": -6.286,
              "y": -16.813,
              "z": 0.504
            },
            "gtin": "4104060031960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80b1",
            "leftCorner": {
              "x": -6.23,
              "y": -16.813,
              "z": 0.504
            },
            "rightCorner": {
              "x": -6.228,
              "y": -16.9,
              "z": 0.504
            },
            "gtin": "4008534022204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80b2",
            "leftCorner": {
              "x": -6.364,
              "y": -16.903,
              "z": 0.504
            },
            "rightCorner": {
              "x": -6.361,
              "y": -17.071,
              "z": 0.504
            },
            "gtin": "4036300228598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80b3",
            "leftCorner": {
              "x": -6.362,
              "y": -17.071,
              "z": 0.504
            },
            "rightCorner": {
              "x": -6.36,
              "y": -17.172,
              "z": 0.504
            },
            "gtin": "4036300059413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80b4",
            "leftCorner": {
              "x": -6.272,
              "y": -17.17,
              "z": 0.504
            },
            "rightCorner": {
              "x": -6.269,
              "y": -17.326,
              "z": 0.504
            },
            "gtin": "4036300059406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8073",
            "leftCorner": {
              "x": -6.268,
              "y": -17.326,
              "z": 0.504
            },
            "rightCorner": {
              "x": -6.265,
              "y": -17.47,
              "z": 0.504
            },
            "gtin": "4036300068262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0b0d07ec05c8f60cb6b34917",
            "leftCorner": {
              "x": -6.339,
              "y": -16.221,
              "z": 0.504
            },
            "rightCorner": {
              "x": -6.338,
              "y": -16.3,
              "z": 0.504
            },
            "gtin": "4104060031960",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d542",
        "height": 0.89561,
        "facings": [
          {
            "id": "68d8e50de1820c81800d80e3",
            "leftCorner": {
              "x": -6.384,
              "y": -16.3,
              "z": 0.733
            },
            "rightCorner": {
              "x": -6.383,
              "y": -16.35,
              "z": 0.733
            },
            "gtin": "2000435148061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b146c5a57d462926daee95c3",
            "leftCorner": {
              "x": -6.334,
              "y": -16.221,
              "z": 0.733
            },
            "rightCorner": {
              "x": -6.333,
              "y": -16.283,
              "z": 0.733
            },
            "gtin": "5711953179723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80e4",
            "leftCorner": {
              "x": -6.383,
              "y": -16.35,
              "z": 0.733
            },
            "rightCorner": {
              "x": -6.382,
              "y": -16.401,
              "z": 0.733
            },
            "gtin": "2000435148061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80e5",
            "leftCorner": {
              "x": -6.382,
              "y": -16.401,
              "z": 0.733
            },
            "rightCorner": {
              "x": -6.381,
              "y": -16.451,
              "z": 0.733
            },
            "gtin": "2000435148061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80e6",
            "leftCorner": {
              "x": -6.297,
              "y": -16.449,
              "z": 0.733
            },
            "rightCorner": {
              "x": -6.294,
              "y": -16.605,
              "z": 0.733
            },
            "gtin": "42485926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80e7",
            "leftCorner": {
              "x": -6.291,
              "y": -16.605,
              "z": 0.733
            },
            "rightCorner": {
              "x": -6.288,
              "y": -16.741,
              "z": 0.733
            },
            "gtin": "42457077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80e8",
            "leftCorner": {
              "x": -6.285,
              "y": -16.741,
              "z": 0.733
            },
            "rightCorner": {
              "x": -6.282,
              "y": -16.863,
              "z": 0.733
            },
            "gtin": "5711953179723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80e9",
            "leftCorner": {
              "x": -6.281,
              "y": -16.863,
              "z": 0.733
            },
            "rightCorner": {
              "x": -6.278,
              "y": -16.998,
              "z": 0.733
            },
            "gtin": "5711953179716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80ea",
            "leftCorner": {
              "x": -6.277,
              "y": -16.998,
              "z": 0.733
            },
            "rightCorner": {
              "x": -6.273,
              "y": -17.198,
              "z": 0.733
            },
            "gtin": "4036300140340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80eb",
            "leftCorner": {
              "x": -6.27,
              "y": -17.198,
              "z": 0.733
            },
            "rightCorner": {
              "x": -6.267,
              "y": -17.365,
              "z": 0.733
            },
            "gtin": "4036300095244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80ec",
            "leftCorner": {
              "x": -6.266,
              "y": -17.365,
              "z": 0.733
            },
            "rightCorner": {
              "x": -6.262,
              "y": -17.581,
              "z": 0.733
            },
            "gtin": "4104420140844",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d540",
        "height": 1.1484,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f51",
            "leftCorner": {
              "x": -6.302,
              "y": -16.274,
              "z": 0.94
            },
            "rightCorner": {
              "x": -6.298,
              "y": -16.443,
              "z": 0.94
            },
            "gtin": "42488781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f52",
            "leftCorner": {
              "x": -6.296,
              "y": -16.443,
              "z": 0.94
            },
            "rightCorner": {
              "x": -6.292,
              "y": -16.647,
              "z": 0.94
            },
            "gtin": "42448860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f53",
            "leftCorner": {
              "x": -6.286,
              "y": -16.647,
              "z": 0.94
            },
            "rightCorner": {
              "x": -6.283,
              "y": -16.762,
              "z": 0.94
            },
            "gtin": "2000445044438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f54",
            "leftCorner": {
              "x": -6.276,
              "y": -16.762,
              "z": 0.94
            },
            "rightCorner": {
              "x": -6.274,
              "y": -16.85,
              "z": 0.94
            },
            "gtin": "4009700071637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f55",
            "leftCorner": {
              "x": -6.284,
              "y": -16.85,
              "z": 0.94
            },
            "rightCorner": {
              "x": -6.281,
              "y": -16.959,
              "z": 0.94
            },
            "gtin": "4009700050533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f56",
            "leftCorner": {
              "x": -6.279,
              "y": -16.959,
              "z": 0.94
            },
            "rightCorner": {
              "x": -6.277,
              "y": -17.055,
              "z": 0.94
            },
            "gtin": "4023600017823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f57",
            "leftCorner": {
              "x": -6.273,
              "y": -17.055,
              "z": 0.94
            },
            "rightCorner": {
              "x": -6.271,
              "y": -17.129,
              "z": 0.94
            },
            "gtin": "4023600017809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f58",
            "leftCorner": {
              "x": -6.274,
              "y": -17.129,
              "z": 0.94
            },
            "rightCorner": {
              "x": -6.272,
              "y": -17.258,
              "z": 0.94
            },
            "gtin": "4025500286811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f59",
            "leftCorner": {
              "x": -6.272,
              "y": -17.258,
              "z": 0.94
            },
            "rightCorner": {
              "x": -6.269,
              "y": -17.386,
              "z": 0.94
            },
            "gtin": "4025500286811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7efe",
            "leftCorner": {
              "x": -6.271,
              "y": -17.386,
              "z": 0.94
            },
            "rightCorner": {
              "x": -6.269,
              "y": -17.47,
              "z": 0.94
            },
            "gtin": "2000433878243",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d53f",
        "height": 1.3777,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ef6",
            "leftCorner": {
              "x": -6.308,
              "y": -16.298,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.305,
              "y": -16.441,
              "z": 1.127
            },
            "gtin": "2000439377269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ef7",
            "leftCorner": {
              "x": -6.305,
              "y": -16.441,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.303,
              "y": -16.584,
              "z": 1.127
            },
            "gtin": "42470441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ef8",
            "leftCorner": {
              "x": -6.295,
              "y": -16.584,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.292,
              "y": -16.74,
              "z": 1.127
            },
            "gtin": "2000444011912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ef9",
            "leftCorner": {
              "x": -6.29,
              "y": -16.74,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.287,
              "y": -16.898,
              "z": 1.127
            },
            "gtin": "42448976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7efa",
            "leftCorner": {
              "x": -6.284,
              "y": -16.898,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.277,
              "y": -17.246,
              "z": 1.127
            },
            "gtin": "2000431967932",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7efb",
            "leftCorner": {
              "x": -6.275,
              "y": -17.246,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.273,
              "y": -17.382,
              "z": 1.127
            },
            "gtin": "4025500288037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e9f",
            "leftCorner": {
              "x": -6.274,
              "y": -17.382,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.272,
              "y": -17.47,
              "z": 1.127
            },
            "gtin": "4025500288013",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d545",
        "height": 1.5891,
        "facings": [
          {
            "id": "68d8e50de1820c81800d80f8",
            "leftCorner": {
              "x": -6.424,
              "y": -16.223,
              "z": 1.3
            },
            "rightCorner": {
              "x": -6.418,
              "y": -16.487,
              "z": 1.3
            },
            "gtin": "4009700074867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80fa",
            "leftCorner": {
              "x": -6.162,
              "y": -16.481,
              "z": 1.3
            },
            "rightCorner": {
              "x": -6.158,
              "y": -16.638,
              "z": 1.3
            },
            "gtin": "4009700074768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80fb",
            "leftCorner": {
              "x": -6.293,
              "y": -16.641,
              "z": 1.3
            },
            "rightCorner": {
              "x": -6.29,
              "y": -16.781,
              "z": 1.3
            },
            "gtin": "4009700074782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80fc",
            "leftCorner": {
              "x": -6.287,
              "y": -16.781,
              "z": 1.3
            },
            "rightCorner": {
              "x": -6.284,
              "y": -16.92,
              "z": 1.3
            },
            "gtin": "8713108000644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80fd",
            "leftCorner": {
              "x": -6.363,
              "y": -16.922,
              "z": 1.3
            },
            "rightCorner": {
              "x": -6.36,
              "y": -17.076,
              "z": 1.3
            },
            "gtin": "8713108020642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80fe",
            "leftCorner": {
              "x": -6.367,
              "y": -17.076,
              "z": 1.3
            },
            "rightCorner": {
              "x": -6.364,
              "y": -17.241,
              "z": 1.3
            },
            "gtin": "4025500286750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80ff",
            "leftCorner": {
              "x": -6.363,
              "y": -17.241,
              "z": 1.3
            },
            "rightCorner": {
              "x": -6.36,
              "y": -17.394,
              "z": 1.3
            },
            "gtin": "4008534040024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80f9",
            "leftCorner": {
              "x": -6.274,
              "y": -17.392,
              "z": 1.3
            },
            "rightCorner": {
              "x": -6.273,
              "y": -17.47,
              "z": 1.3
            },
            "gtin": "4008534040000",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d543",
        "height": 1.8227,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7fb9",
            "leftCorner": {
              "x": -6.304,
              "y": -16.266,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.3,
              "y": -16.485,
              "z": 1.491
            },
            "gtin": "4009700074720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8f243bf16a5f6ee853935eb8",
            "leftCorner": {
              "x": -6.338,
              "y": -16.221,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.337,
              "y": -16.265,
              "z": 1.491
            },
            "gtin": "7610900138906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fba",
            "leftCorner": {
              "x": -6.298,
              "y": -16.485,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.291,
              "y": -16.842,
              "z": 1.491
            },
            "gtin": "9019100556202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fbb",
            "leftCorner": {
              "x": -6.283,
              "y": -16.842,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.28,
              "y": -17.007,
              "z": 1.491
            },
            "gtin": "9019100560605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fbc",
            "leftCorner": {
              "x": -6.283,
              "y": -17.007,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.28,
              "y": -17.151,
              "z": 1.491
            },
            "gtin": "4023600016482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fbd",
            "leftCorner": {
              "x": -6.279,
              "y": -17.151,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.275,
              "y": -17.34,
              "z": 1.491
            },
            "gtin": "4023600016468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fbe",
            "leftCorner": {
              "x": -6.275,
              "y": -17.34,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.273,
              "y": -17.422,
              "z": 1.491
            },
            "gtin": "7610900042562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fbf",
            "leftCorner": {
              "x": -6.268,
              "y": -17.422,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.266,
              "y": -17.553,
              "z": 1.491
            },
            "gtin": "7610900138906",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4dc",
    "rightNeighborShelfId": "4de"
  },
  {
    "id": "4de",
    "name": "4de",
    "x": -6.39,
    "y": -17.473,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69989,
      "w": 0.71425
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 58,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7f1",
        "height": 0.37962,
        "facings": [
          {
            "id": "d63fbc242180cacdd9f59ac5",
            "leftCorner": {
              "x": -6.405,
              "y": -17.474,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.404,
              "y": -17.528,
              "z": 0.311
            },
            "gtin": "4008452033115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "184e3c3b8ddad853e413d4a2",
            "leftCorner": {
              "x": -6.404,
              "y": -17.528,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.402,
              "y": -17.612,
              "z": 0.311
            },
            "gtin": "4045317056582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f50c6087603a2ec8ea02309f",
            "leftCorner": {
              "x": -6.402,
              "y": -17.612,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.4,
              "y": -17.728,
              "z": 0.311
            },
            "gtin": "4002970000888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3d0d6942ffed198344f89671",
            "leftCorner": {
              "x": -6.4,
              "y": -17.728,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.399,
              "y": -17.781,
              "z": 0.311
            },
            "gtin": "4008452033115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "602181841be5f3c0803504d2",
            "leftCorner": {
              "x": -6.399,
              "y": -17.781,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.398,
              "y": -17.846,
              "z": 0.311
            },
            "gtin": "5711953179792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "508037e4ccc35ae1d7d020e1",
            "leftCorner": {
              "x": -6.398,
              "y": -17.846,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.396,
              "y": -17.914,
              "z": 0.311
            },
            "gtin": "4045317056575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8a3c5d5aa184831f0eefcbb1",
            "leftCorner": {
              "x": -6.396,
              "y": -17.914,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.395,
              "y": -17.986,
              "z": 0.311
            },
            "gtin": "5760466920490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0c2f7b6ee454d66475528162",
            "leftCorner": {
              "x": -6.395,
              "y": -17.986,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.393,
              "y": -18.058,
              "z": 0.311
            },
            "gtin": "7610900138913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "86c79cc0cc8d94af05c3c2cc",
            "leftCorner": {
              "x": -6.393,
              "y": -18.058,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.392,
              "y": -18.132,
              "z": 0.311
            },
            "gtin": "5760466920537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dfd78bd1cecd792e1a7a1abb",
            "leftCorner": {
              "x": -6.392,
              "y": -18.132,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.39,
              "y": -18.211,
              "z": 0.311
            },
            "gtin": "5760466995856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "48dce0b91d38f1d64d68c86b",
            "leftCorner": {
              "x": -6.39,
              "y": -18.211,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.388,
              "y": -18.295,
              "z": 0.311
            },
            "gtin": "7610900237654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "398f1fd5b7b3cda41d88aeb8",
            "leftCorner": {
              "x": -6.388,
              "y": -18.295,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.387,
              "y": -18.379,
              "z": 0.311
            },
            "gtin": "5711953192920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9b97555ce1061efd72a16e05",
            "leftCorner": {
              "x": -6.387,
              "y": -18.379,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.385,
              "y": -18.463,
              "z": 0.311
            },
            "gtin": "4045317056582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e9e8a39cac98a91f27d5da78",
            "leftCorner": {
              "x": -6.385,
              "y": -18.463,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.381,
              "y": -18.669,
              "z": 0.311
            },
            "gtin": "42454168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4bada8c75183a48540401804",
            "leftCorner": {
              "x": -6.381,
              "y": -18.669,
              "z": 0.311
            },
            "rightCorner": {
              "x": -6.38,
              "y": -18.722,
              "z": 0.311
            },
            "gtin": "4008452033115",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7ef",
        "height": 0.89121,
        "facings": [
          {
            "id": "68d8e50de1820c81800d80ed",
            "leftCorner": {
              "x": -6.267,
              "y": -17.582,
              "z": 0.729
            },
            "rightCorner": {
              "x": -6.266,
              "y": -17.647,
              "z": 0.729
            },
            "gtin": "4000436107133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "add13665ed333f3954f53d99",
            "leftCorner": {
              "x": -6.31,
              "y": -17.472,
              "z": 0.729
            },
            "rightCorner": {
              "x": -6.307,
              "y": -17.578,
              "z": 0.729
            },
            "gtin": "4046700026519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0e9be1d9acbb47f2bac0ac3f",
            "leftCorner": {
              "x": -6.297,
              "y": -18.101,
              "z": 0.729
            },
            "rightCorner": {
              "x": -6.294,
              "y": -18.243,
              "z": 0.729
            },
            "gtin": "4046700500965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80ee",
            "leftCorner": {
              "x": -6.266,
              "y": -17.647,
              "z": 0.729
            },
            "rightCorner": {
              "x": -6.265,
              "y": -17.713,
              "z": 0.729
            },
            "gtin": "4000436107133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80ef",
            "leftCorner": {
              "x": -6.344,
              "y": -17.715,
              "z": 0.729
            },
            "rightCorner": {
              "x": -6.34,
              "y": -17.925,
              "z": 0.729
            },
            "gtin": "4000436106136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80f0",
            "leftCorner": {
              "x": -6.247,
              "y": -17.923,
              "z": 0.729
            },
            "rightCorner": {
              "x": -6.243,
              "y": -18.099,
              "z": 0.729
            },
            "gtin": "4002970000710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80f3",
            "leftCorner": {
              "x": -6.329,
              "y": -18.243,
              "z": 0.729
            },
            "rightCorner": {
              "x": -6.327,
              "y": -18.326,
              "z": 0.729
            },
            "gtin": "4046700500972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80f4",
            "leftCorner": {
              "x": -6.243,
              "y": -18.325,
              "z": 0.729
            },
            "rightCorner": {
              "x": -6.241,
              "y": -18.439,
              "z": 0.729
            },
            "gtin": "4046700500965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80f5",
            "leftCorner": {
              "x": -6.254,
              "y": -18.44,
              "z": 0.729
            },
            "rightCorner": {
              "x": -6.253,
              "y": -18.529,
              "z": 0.729
            },
            "gtin": "4046700026502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80f6",
            "leftCorner": {
              "x": -6.251,
              "y": -18.529,
              "z": 0.729
            },
            "rightCorner": {
              "x": -6.249,
              "y": -18.636,
              "z": 0.729
            },
            "gtin": "4046700026519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d80f7",
            "leftCorner": {
              "x": -6.247,
              "y": -18.636,
              "z": 0.729
            },
            "rightCorner": {
              "x": -6.245,
              "y": -18.742,
              "z": 0.729
            },
            "gtin": "4000980526916",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7ee",
        "height": 1.2209,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c40",
            "leftCorner": {
              "x": -6.299,
              "y": -17.472,
              "z": 0.999
            },
            "rightCorner": {
              "x": -6.293,
              "y": -17.777,
              "z": 0.999
            },
            "gtin": "4016241015228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c41",
            "leftCorner": {
              "x": -6.076,
              "y": -17.773,
              "z": 0.999
            },
            "rightCorner": {
              "x": -6.074,
              "y": -17.915,
              "z": 0.999
            },
            "gtin": "4045317058050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c42",
            "leftCorner": {
              "x": -6.248,
              "y": -17.918,
              "z": 0.999
            },
            "rightCorner": {
              "x": -6.244,
              "y": -18.127,
              "z": 0.999
            },
            "gtin": "4045317058067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c43",
            "leftCorner": {
              "x": -6.248,
              "y": -18.128,
              "z": 0.999
            },
            "rightCorner": {
              "x": -6.242,
              "y": -18.451,
              "z": 0.999
            },
            "gtin": "4008452027039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c44",
            "leftCorner": {
              "x": -6.055,
              "y": -18.447,
              "z": 0.999
            },
            "rightCorner": {
              "x": -6.053,
              "y": -18.517,
              "z": 0.999
            },
            "gtin": "4008452010017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c45",
            "leftCorner": {
              "x": -6.246,
              "y": -18.522,
              "z": 0.999
            },
            "rightCorner": {
              "x": -6.244,
              "y": -18.621,
              "z": 0.999
            },
            "gtin": "4002334110321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c46",
            "leftCorner": {
              "x": -6.245,
              "y": -18.622,
              "z": 0.999
            },
            "rightCorner": {
              "x": -6.243,
              "y": -18.69,
              "z": 0.999
            },
            "gtin": "4045317056575",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7f0",
        "height": 1.4013,
        "facings": []
      },
      {
        "id": "68d8d40255f889d41539d7ed",
        "height": 1.5229,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c35",
            "leftCorner": {
              "x": -6.315,
              "y": -17.472,
              "z": 1.246
            },
            "rightCorner": {
              "x": -6.313,
              "y": -17.584,
              "z": 1.246
            },
            "gtin": "4045317058371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c36",
            "leftCorner": {
              "x": -6.313,
              "y": -17.584,
              "z": 1.246
            },
            "rightCorner": {
              "x": -6.31,
              "y": -17.696,
              "z": 1.246
            },
            "gtin": "4045317058371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c37",
            "leftCorner": {
              "x": -6.272,
              "y": -17.695,
              "z": 1.246
            },
            "rightCorner": {
              "x": -6.27,
              "y": -17.804,
              "z": 1.246
            },
            "gtin": "4045317058364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c38",
            "leftCorner": {
              "x": -6.254,
              "y": -17.804,
              "z": 1.246
            },
            "rightCorner": {
              "x": -6.252,
              "y": -17.891,
              "z": 1.246
            },
            "gtin": "4045317058074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c39",
            "leftCorner": {
              "x": -6.264,
              "y": -17.891,
              "z": 1.246
            },
            "rightCorner": {
              "x": -6.262,
              "y": -17.966,
              "z": 1.246
            },
            "gtin": "5711953179778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c3a",
            "leftCorner": {
              "x": -6.261,
              "y": -17.966,
              "z": 1.246
            },
            "rightCorner": {
              "x": -6.26,
              "y": -18.018,
              "z": 1.246
            },
            "gtin": "5711953179792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c3b",
            "leftCorner": {
              "x": -6.262,
              "y": -18.018,
              "z": 1.246
            },
            "rightCorner": {
              "x": -6.258,
              "y": -18.232,
              "z": 1.246
            },
            "gtin": "42454168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c3c",
            "leftCorner": {
              "x": -6.335,
              "y": -18.233,
              "z": 1.246
            },
            "rightCorner": {
              "x": -6.334,
              "y": -18.296,
              "z": 1.246
            },
            "gtin": "4000980231414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c3d",
            "leftCorner": {
              "x": -6.334,
              "y": -18.296,
              "z": 1.246
            },
            "rightCorner": {
              "x": -6.332,
              "y": -18.359,
              "z": 1.246
            },
            "gtin": "4000980231414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c3e",
            "leftCorner": {
              "x": -6.27,
              "y": -18.358,
              "z": 1.246
            },
            "rightCorner": {
              "x": -6.266,
              "y": -18.545,
              "z": 1.246
            },
            "gtin": "4046700003459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c3f",
            "leftCorner": {
              "x": -6.261,
              "y": -18.545,
              "z": 1.246
            },
            "rightCorner": {
              "x": -6.258,
              "y": -18.693,
              "z": 1.246
            },
            "gtin": "4008452033511",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7ec",
        "height": 1.8229,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7fc0",
            "leftCorner": {
              "x": -6.276,
              "y": -17.555,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.275,
              "y": -17.625,
              "z": 1.491
            },
            "gtin": "7610900237654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fc1",
            "leftCorner": {
              "x": -6.271,
              "y": -17.625,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.27,
              "y": -17.7,
              "z": 1.491
            },
            "gtin": "7610900138913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fc2",
            "leftCorner": {
              "x": -6.267,
              "y": -17.7,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.265,
              "y": -17.788,
              "z": 1.491
            },
            "gtin": "5711953194627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fc3",
            "leftCorner": {
              "x": -6.266,
              "y": -17.788,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.264,
              "y": -17.876,
              "z": 1.491
            },
            "gtin": "5711953194658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fc4",
            "leftCorner": {
              "x": -6.26,
              "y": -17.876,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.259,
              "y": -17.943,
              "z": 1.491
            },
            "gtin": "5760466920537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fc5",
            "leftCorner": {
              "x": -6.254,
              "y": -17.943,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.253,
              "y": -18.019,
              "z": 1.491
            },
            "gtin": "5711953192920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fc6",
            "leftCorner": {
              "x": -6.257,
              "y": -18.019,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.255,
              "y": -18.106,
              "z": 1.491
            },
            "gtin": "5760466995856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fc7",
            "leftCorner": {
              "x": -6.258,
              "y": -18.106,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.256,
              "y": -18.177,
              "z": 1.491
            },
            "gtin": "5760466920490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fc8",
            "leftCorner": {
              "x": -6.253,
              "y": -18.177,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.251,
              "y": -18.271,
              "z": 1.491
            },
            "gtin": "5711953051258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fc9",
            "leftCorner": {
              "x": -6.251,
              "y": -18.271,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.249,
              "y": -18.393,
              "z": 1.491
            },
            "gtin": "5711953023972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fca",
            "leftCorner": {
              "x": -6.259,
              "y": -18.393,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.256,
              "y": -18.546,
              "z": 1.491
            },
            "gtin": "4306188377610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fcb",
            "leftCorner": {
              "x": -6.262,
              "y": -18.546,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.26,
              "y": -18.645,
              "z": 1.491
            },
            "gtin": "4306188339847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f5b",
            "leftCorner": {
              "x": -6.263,
              "y": -18.646,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.261,
              "y": -18.721,
              "z": 1.491
            },
            "gtin": "4306188377641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e57c563de9ae0bef9f364c32",
            "leftCorner": {
              "x": -6.311,
              "y": -17.472,
              "z": 1.491
            },
            "rightCorner": {
              "x": -6.309,
              "y": -17.555,
              "z": 1.491
            },
            "gtin": "5711953194658",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4dd"
  },
  {
    "id": "4df",
    "name": "4df",
    "x": -35.069,
    "y": -37.497,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7102,
      "w": 0.704
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 44,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d2d1",
        "height": 0.63038,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e24",
            "leftCorner": {
              "x": -35.142,
              "y": -37.498,
              "z": 0.516
            },
            "rightCorner": {
              "x": -35.143,
              "y": -37.365,
              "z": 0.516
            },
            "gtin": "4250616671057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e26",
            "leftCorner": {
              "x": -35.154,
              "y": -37.365,
              "z": 0.516
            },
            "rightCorner": {
              "x": -35.156,
              "y": -37.265,
              "z": 0.516
            },
            "gtin": "4250616671118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e27",
            "leftCorner": {
              "x": -35.156,
              "y": -37.265,
              "z": 0.516
            },
            "rightCorner": {
              "x": -35.156,
              "y": -37.164,
              "z": 0.516
            },
            "gtin": "4250616671118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e28",
            "leftCorner": {
              "x": -35.111,
              "y": -37.163,
              "z": 0.516
            },
            "rightCorner": {
              "x": -35.112,
              "y": -37.073,
              "z": 0.516
            },
            "gtin": "4250616671040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e29",
            "leftCorner": {
              "x": -35.186,
              "y": -37.074,
              "z": 0.516
            },
            "rightCorner": {
              "x": -35.187,
              "y": -36.943,
              "z": 0.516
            },
            "gtin": "4270002305205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e2a",
            "leftCorner": {
              "x": -35.19,
              "y": -36.943,
              "z": 0.516
            },
            "rightCorner": {
              "x": -35.191,
              "y": -36.746,
              "z": 0.516
            },
            "gtin": "8722200966291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e2b",
            "leftCorner": {
              "x": -35.193,
              "y": -36.746,
              "z": 0.516
            },
            "rightCorner": {
              "x": -35.193,
              "y": -36.645,
              "z": 0.516
            },
            "gtin": "87365405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e2c",
            "leftCorner": {
              "x": -35.193,
              "y": -36.645,
              "z": 0.516
            },
            "rightCorner": {
              "x": -35.194,
              "y": -36.544,
              "z": 0.516
            },
            "gtin": "87365405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e2d",
            "leftCorner": {
              "x": -35.197,
              "y": -36.544,
              "z": 0.516
            },
            "rightCorner": {
              "x": -35.198,
              "y": -36.454,
              "z": 0.516
            },
            "gtin": "42116455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e2e",
            "leftCorner": {
              "x": -35.198,
              "y": -36.454,
              "z": 0.516
            },
            "rightCorner": {
              "x": -35.198,
              "y": -36.364,
              "z": 0.516
            },
            "gtin": "42116455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e25",
            "leftCorner": {
              "x": -35.159,
              "y": -36.364,
              "z": 0.516
            },
            "rightCorner": {
              "x": -35.161,
              "y": -36.249,
              "z": 0.516
            },
            "gtin": "5000112667417",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2d5",
        "height": 0.9397,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e59",
            "leftCorner": {
              "x": -35.139,
              "y": -37.498,
              "z": 0.769
            },
            "rightCorner": {
              "x": -35.14,
              "y": -37.367,
              "z": 0.769
            },
            "gtin": "8057192007104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e5a",
            "leftCorner": {
              "x": -35.14,
              "y": -37.367,
              "z": 0.769
            },
            "rightCorner": {
              "x": -35.141,
              "y": -37.236,
              "z": 0.769
            },
            "gtin": "8057192007104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e5c",
            "leftCorner": {
              "x": -35.183,
              "y": -37.235,
              "z": 0.769
            },
            "rightCorner": {
              "x": -35.185,
              "y": -36.977,
              "z": 0.769
            },
            "gtin": "5000112604740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e5d",
            "leftCorner": {
              "x": -35.182,
              "y": -36.977,
              "z": 0.769
            },
            "rightCorner": {
              "x": -35.183,
              "y": -36.811,
              "z": 0.769
            },
            "gtin": "5000112604726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e5e",
            "leftCorner": {
              "x": -35.105,
              "y": -36.81,
              "z": 0.769
            },
            "rightCorner": {
              "x": -35.107,
              "y": -36.592,
              "z": 0.769
            },
            "gtin": "5449000247872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e5f",
            "leftCorner": {
              "x": -35.191,
              "y": -36.593,
              "z": 0.769
            },
            "rightCorner": {
              "x": -35.194,
              "y": -36.248,
              "z": 0.769
            },
            "gtin": "5000112604696",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2d3",
        "height": 1.1694,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e3f",
            "leftCorner": {
              "x": -35.144,
              "y": -37.498,
              "z": 0.957
            },
            "rightCorner": {
              "x": -35.146,
              "y": -37.231,
              "z": 0.957
            },
            "gtin": "5000112602029",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6e41",
            "leftCorner": {
              "x": -35.186,
              "y": -37.231,
              "z": 0.957
            },
            "rightCorner": {
              "x": -35.189,
              "y": -37.003,
              "z": 0.957
            },
            "gtin": "5000112604450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e42",
            "leftCorner": {
              "x": -35.106,
              "y": -37.002,
              "z": 0.957
            },
            "rightCorner": {
              "x": -35.108,
              "y": -36.741,
              "z": 0.957
            },
            "gtin": "5000112684667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e43",
            "leftCorner": {
              "x": -35.193,
              "y": -36.742,
              "z": 0.957
            },
            "rightCorner": {
              "x": -35.195,
              "y": -36.473,
              "z": 0.957
            },
            "gtin": "4008287959192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e44",
            "leftCorner": {
              "x": -35.196,
              "y": -36.473,
              "z": 0.957
            },
            "rightCorner": {
              "x": -35.197,
              "y": -36.362,
              "z": 0.957
            },
            "gtin": "4000177171912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e45",
            "leftCorner": {
              "x": -35.193,
              "y": -36.362,
              "z": 0.957
            },
            "rightCorner": {
              "x": -35.195,
              "y": -36.248,
              "z": 0.957
            },
            "gtin": "4260705333605",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2d4",
        "height": 1.3889,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e4b",
            "leftCorner": {
              "x": -35.139,
              "y": -37.498,
              "z": 1.136
            },
            "rightCorner": {
              "x": -35.144,
              "y": -36.991,
              "z": 1.136
            },
            "gtin": "5000112592153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e4d",
            "leftCorner": {
              "x": -35.177,
              "y": -36.991,
              "z": 1.136
            },
            "rightCorner": {
              "x": -35.179,
              "y": -36.72,
              "z": 1.136
            },
            "gtin": "4066600300458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e4e",
            "leftCorner": {
              "x": -35.186,
              "y": -36.721,
              "z": 1.136
            },
            "rightCorner": {
              "x": -35.187,
              "y": -36.525,
              "z": 1.136
            },
            "gtin": "4066600103448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e4f",
            "leftCorner": {
              "x": -35.189,
              "y": -36.525,
              "z": 1.136
            },
            "rightCorner": {
              "x": -35.192,
              "y": -36.248,
              "z": 1.136
            },
            "gtin": "4001568702050",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2d6",
        "height": 1.6134,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e66",
            "leftCorner": {
              "x": -35.141,
              "y": -37.498,
              "z": 1.32
            },
            "rightCorner": {
              "x": -35.143,
              "y": -37.349,
              "z": 1.32
            },
            "gtin": "4005249001296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a200a9440fcd8488c92d4065",
            "leftCorner": {
              "x": -35.148,
              "y": -36.744,
              "z": 1.32
            },
            "rightCorner": {
              "x": -35.148,
              "y": -36.677,
              "z": 1.32
            },
            "gtin": "4005249063324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8365b91ba59973c428848763",
            "leftCorner": {
              "x": -35.148,
              "y": -36.677,
              "z": 1.32
            },
            "rightCorner": {
              "x": -35.149,
              "y": -36.588,
              "z": 1.32
            },
            "gtin": "4005249001272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7752713ca47dd280810bdd18",
            "leftCorner": {
              "x": -35.149,
              "y": -36.588,
              "z": 1.32
            },
            "rightCorner": {
              "x": -35.15,
              "y": -36.521,
              "z": 1.32
            },
            "gtin": "4005249063324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e67",
            "leftCorner": {
              "x": -35.143,
              "y": -37.349,
              "z": 1.32
            },
            "rightCorner": {
              "x": -35.144,
              "y": -37.199,
              "z": 1.32
            },
            "gtin": "4005249001296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e68",
            "leftCorner": {
              "x": -35.144,
              "y": -37.199,
              "z": 1.32
            },
            "rightCorner": {
              "x": -35.145,
              "y": -37.049,
              "z": 1.32
            },
            "gtin": "4005249001296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e6a",
            "leftCorner": {
              "x": -35.185,
              "y": -37.049,
              "z": 1.32
            },
            "rightCorner": {
              "x": -35.186,
              "y": -36.914,
              "z": 1.32
            },
            "gtin": "4005249001272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e6b",
            "leftCorner": {
              "x": -35.186,
              "y": -36.914,
              "z": 1.32
            },
            "rightCorner": {
              "x": -35.187,
              "y": -36.779,
              "z": 1.32
            },
            "gtin": "4005249001272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e6c",
            "leftCorner": {
              "x": -35.184,
              "y": -36.779,
              "z": 1.32
            },
            "rightCorner": {
              "x": -35.185,
              "y": -36.744,
              "z": 1.32
            },
            "gtin": "4005249063324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e6e",
            "leftCorner": {
              "x": -35.19,
              "y": -36.503,
              "z": 1.32
            },
            "rightCorner": {
              "x": -35.192,
              "y": -36.376,
              "z": 1.32
            },
            "gtin": "4008287949544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e6f",
            "leftCorner": {
              "x": -35.192,
              "y": -36.376,
              "z": 1.32
            },
            "rightCorner": {
              "x": -35.193,
              "y": -36.248,
              "z": 1.32
            },
            "gtin": "4008287949544",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2d2",
        "height": 1.8338,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e2f",
            "leftCorner": {
              "x": -35.14,
              "y": -37.498,
              "z": 1.5
            },
            "rightCorner": {
              "x": -35.141,
              "y": -37.323,
              "z": 1.5
            },
            "gtin": "9028800638590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e31",
            "leftCorner": {
              "x": -35.184,
              "y": -37.323,
              "z": 1.5
            },
            "rightCorner": {
              "x": -35.186,
              "y": -37.11,
              "z": 1.5
            },
            "gtin": "5740600511036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e32",
            "leftCorner": {
              "x": -35.182,
              "y": -37.11,
              "z": 1.5
            },
            "rightCorner": {
              "x": -35.184,
              "y": -36.917,
              "z": 1.5
            },
            "gtin": "4014086093364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e33",
            "leftCorner": {
              "x": -35.179,
              "y": -36.917,
              "z": 1.5
            },
            "rightCorner": {
              "x": -35.181,
              "y": -36.738,
              "z": 1.5
            },
            "gtin": "4014086093227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e34",
            "leftCorner": {
              "x": -35.187,
              "y": -36.738,
              "z": 1.5
            },
            "rightCorner": {
              "x": -35.188,
              "y": -36.621,
              "z": 1.5
            },
            "gtin": "5000213029381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e35",
            "leftCorner": {
              "x": -35.189,
              "y": -36.621,
              "z": 1.5
            },
            "rightCorner": {
              "x": -35.19,
              "y": -36.484,
              "z": 1.5
            },
            "gtin": "4000856008294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e36",
            "leftCorner": {
              "x": -35.189,
              "y": -36.483,
              "z": 1.5
            },
            "rightCorner": {
              "x": -35.191,
              "y": -36.326,
              "z": 1.5
            },
            "gtin": "4100130020162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e37",
            "leftCorner": {
              "x": -35.19,
              "y": -36.326,
              "z": 1.5
            },
            "rightCorner": {
              "x": -35.191,
              "y": -36.248,
              "z": 1.5
            },
            "gtin": "4014086093654",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "acc"
  },
  {
    "id": "4ea",
    "name": "4ea",
    "x": -24.049,
    "y": -18.098,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99999,
      "w": 0.0044942
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 64,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6f3",
        "height": 0.15852,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8727",
            "leftCorner": {
              "x": -24.048,
              "y": -18.005,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.216,
              "y": -18.004,
              "z": 0.13
            },
            "gtin": "4000539104824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8728",
            "leftCorner": {
              "x": -24.216,
              "y": -18.033,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.315,
              "y": -18.032,
              "z": 0.13
            },
            "gtin": "3046920013345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8729",
            "leftCorner": {
              "x": -24.315,
              "y": -18.037,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.46,
              "y": -18.036,
              "z": 0.13
            },
            "gtin": "4000539106385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d872a",
            "leftCorner": {
              "x": -24.46,
              "y": -18.041,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.543,
              "y": -18.041,
              "z": 0.13
            },
            "gtin": "4000539150944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d872b",
            "leftCorner": {
              "x": -24.543,
              "y": -18.035,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.67,
              "y": -18.033,
              "z": 0.13
            },
            "gtin": "4000539320002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d872c",
            "leftCorner": {
              "x": -24.669,
              "y": -18.03,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.754,
              "y": -18.029,
              "z": 0.13
            },
            "gtin": "4000539204500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d872d",
            "leftCorner": {
              "x": -24.754,
              "y": -18.039,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.856,
              "y": -18.038,
              "z": 0.13
            },
            "gtin": "4000539002007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d872e",
            "leftCorner": {
              "x": -24.856,
              "y": -18.038,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.951,
              "y": -18.037,
              "z": 0.13
            },
            "gtin": "4000539002809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d872f",
            "leftCorner": {
              "x": -24.951,
              "y": -18.038,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.99,
              "y": -18.038,
              "z": 0.13
            },
            "gtin": "7610400110785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8730",
            "leftCorner": {
              "x": -24.99,
              "y": -18.038,
              "z": 0.13
            },
            "rightCorner": {
              "x": -25.126,
              "y": -18.037,
              "z": 0.13
            },
            "gtin": "7610400110785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8731",
            "leftCorner": {
              "x": -25.126,
              "y": -18.033,
              "z": 0.13
            },
            "rightCorner": {
              "x": -25.186,
              "y": -18.032,
              "z": 0.13
            },
            "gtin": "7610400110761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8732",
            "leftCorner": {
              "x": -25.186,
              "y": -18.033,
              "z": 0.13
            },
            "rightCorner": {
              "x": -25.255,
              "y": -18.033,
              "z": 0.13
            },
            "gtin": "4000539147166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8733",
            "leftCorner": {
              "x": -25.255,
              "y": -18.036,
              "z": 0.13
            },
            "rightCorner": {
              "x": -25.29,
              "y": -18.035,
              "z": 0.13
            },
            "gtin": "2000439121954",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6f0",
        "height": 0.45621,
        "facings": [
          {
            "id": "68d8e50be1820c81800d674f",
            "leftCorner": {
              "x": -24.102,
              "y": -18.077,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.18,
              "y": -18.077,
              "z": 0.373
            },
            "gtin": "3046920024082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6750",
            "leftCorner": {
              "x": -24.181,
              "y": -18.081,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.296,
              "y": -18.079,
              "z": 0.373
            },
            "gtin": "7610400110631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6751",
            "leftCorner": {
              "x": -24.296,
              "y": -18.084,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.378,
              "y": -18.084,
              "z": 0.373
            },
            "gtin": "3046920022279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6752",
            "leftCorner": {
              "x": -24.378,
              "y": -18.084,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.451,
              "y": -18.083,
              "z": 0.373
            },
            "gtin": "7610400110655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6753",
            "leftCorner": {
              "x": -24.451,
              "y": -18.086,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.554,
              "y": -18.085,
              "z": 0.373
            },
            "gtin": "4000539118708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6754",
            "leftCorner": {
              "x": -24.554,
              "y": -18.086,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.656,
              "y": -18.084,
              "z": 0.373
            },
            "gtin": "3046920022262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6755",
            "leftCorner": {
              "x": -24.656,
              "y": -18.085,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.752,
              "y": -18.085,
              "z": 0.373
            },
            "gtin": "4000539014000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6756",
            "leftCorner": {
              "x": -24.752,
              "y": -18.088,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.854,
              "y": -18.086,
              "z": 0.373
            },
            "gtin": "4000539014307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6757",
            "leftCorner": {
              "x": -24.854,
              "y": -18.086,
              "z": 0.373
            },
            "rightCorner": {
              "x": -24.946,
              "y": -18.086,
              "z": 0.373
            },
            "gtin": "4000539014109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6758",
            "leftCorner": {
              "x": -24.946,
              "y": -18.087,
              "z": 0.373
            },
            "rightCorner": {
              "x": -25.034,
              "y": -18.086,
              "z": 0.373
            },
            "gtin": "7610400110860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6759",
            "leftCorner": {
              "x": -25.034,
              "y": -18.088,
              "z": 0.373
            },
            "rightCorner": {
              "x": -25.144,
              "y": -18.087,
              "z": 0.373
            },
            "gtin": "7610400110839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6744",
            "leftCorner": {
              "x": -25.144,
              "y": -18.082,
              "z": 0.373
            },
            "rightCorner": {
              "x": -25.298,
              "y": -18.081,
              "z": 0.373
            },
            "gtin": "3046920022415",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6f4",
        "height": 0.75417,
        "facings": [
          {
            "id": "68d8e50be1820c81800d673f",
            "leftCorner": {
              "x": -24.568,
              "y": -18.081,
              "z": 0.617
            },
            "rightCorner": {
              "x": -24.666,
              "y": -18.079,
              "z": 0.617
            },
            "gtin": "3046920022156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6740",
            "leftCorner": {
              "x": -24.666,
              "y": -18.079,
              "z": 0.617
            },
            "rightCorner": {
              "x": -24.861,
              "y": -18.078,
              "z": 0.617
            },
            "gtin": "4000539113185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6741",
            "leftCorner": {
              "x": -24.861,
              "y": -18.084,
              "z": 0.617
            },
            "rightCorner": {
              "x": -24.939,
              "y": -18.083,
              "z": 0.617
            },
            "gtin": "3046920022132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6742",
            "leftCorner": {
              "x": -24.939,
              "y": -18.085,
              "z": 0.617
            },
            "rightCorner": {
              "x": -25.152,
              "y": -18.083,
              "z": 0.617
            },
            "gtin": "4003573089058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6736",
            "leftCorner": {
              "x": -25.152,
              "y": -18.077,
              "z": 0.617
            },
            "rightCorner": {
              "x": -25.298,
              "y": -18.076,
              "z": 0.617
            },
            "gtin": "3046920020558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cb90241c44406e8c13d09e5e",
            "leftCorner": {
              "x": -24.048,
              "y": -18.048,
              "z": 0.617
            },
            "rightCorner": {
              "x": -24.14,
              "y": -18.047,
              "z": 0.617
            },
            "gtin": "3046920022132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3e0d6ecf3e16331c53513395",
            "leftCorner": {
              "x": -24.14,
              "y": -18.047,
              "z": 0.617
            },
            "rightCorner": {
              "x": -24.243,
              "y": -18.046,
              "z": 0.617
            },
            "gtin": "3046920022156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9b87215f23176b12fe275ed7",
            "leftCorner": {
              "x": -24.243,
              "y": -18.046,
              "z": 0.617
            },
            "rightCorner": {
              "x": -24.395,
              "y": -18.045,
              "z": 0.617
            },
            "gtin": "3046920020558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8f421550cecb6299791da265",
            "leftCorner": {
              "x": -24.395,
              "y": -18.045,
              "z": 0.617
            },
            "rightCorner": {
              "x": -24.546,
              "y": -18.044,
              "z": 0.617
            },
            "gtin": "3046920020558",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6ef",
        "height": 1.0576,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6720",
            "leftCorner": {
              "x": -24.112,
              "y": -18.074,
              "z": 0.865
            },
            "rightCorner": {
              "x": -24.171,
              "y": -18.074,
              "z": 0.865
            },
            "gtin": "4000539112348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6721",
            "leftCorner": {
              "x": -24.171,
              "y": -18.075,
              "z": 0.865
            },
            "rightCorner": {
              "x": -24.252,
              "y": -18.074,
              "z": 0.865
            },
            "gtin": "4000539048708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6722",
            "leftCorner": {
              "x": -24.252,
              "y": -18.078,
              "z": 0.865
            },
            "rightCorner": {
              "x": -24.34,
              "y": -18.077,
              "z": 0.865
            },
            "gtin": "4000539138409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6723",
            "leftCorner": {
              "x": -24.34,
              "y": -18.084,
              "z": 0.865
            },
            "rightCorner": {
              "x": -24.467,
              "y": -18.082,
              "z": 0.865
            },
            "gtin": "4000539120022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6724",
            "leftCorner": {
              "x": -24.467,
              "y": -18.083,
              "z": 0.865
            },
            "rightCorner": {
              "x": -24.555,
              "y": -18.083,
              "z": 0.865
            },
            "gtin": "4000539043802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6725",
            "leftCorner": {
              "x": -24.555,
              "y": -18.081,
              "z": 0.865
            },
            "rightCorner": {
              "x": -24.649,
              "y": -18.08,
              "z": 0.865
            },
            "gtin": "4000539147081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6726",
            "leftCorner": {
              "x": -24.649,
              "y": -18.079,
              "z": 0.865
            },
            "rightCorner": {
              "x": -24.741,
              "y": -18.079,
              "z": 0.865
            },
            "gtin": "4000539105302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6727",
            "leftCorner": {
              "x": -24.741,
              "y": -18.078,
              "z": 0.865
            },
            "rightCorner": {
              "x": -24.825,
              "y": -18.077,
              "z": 0.865
            },
            "gtin": "4000539113383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6728",
            "leftCorner": {
              "x": -24.825,
              "y": -18.082,
              "z": 0.865
            },
            "rightCorner": {
              "x": -24.949,
              "y": -18.081,
              "z": 0.865
            },
            "gtin": "4000539142987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6729",
            "leftCorner": {
              "x": -24.949,
              "y": -18.082,
              "z": 0.865
            },
            "rightCorner": {
              "x": -25.033,
              "y": -18.081,
              "z": 0.865
            },
            "gtin": "4000539106880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d672a",
            "leftCorner": {
              "x": -25.033,
              "y": -18.082,
              "z": 0.865
            },
            "rightCorner": {
              "x": -25.123,
              "y": -18.082,
              "z": 0.865
            },
            "gtin": "4000539094804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d672b",
            "leftCorner": {
              "x": -25.123,
              "y": -18.079,
              "z": 0.865
            },
            "rightCorner": {
              "x": -25.18,
              "y": -18.078,
              "z": 0.865
            },
            "gtin": "4000539144127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d672c",
            "leftCorner": {
              "x": -25.18,
              "y": -18.076,
              "z": 0.865
            },
            "rightCorner": {
              "x": -25.237,
              "y": -18.076,
              "z": 0.865
            },
            "gtin": "4000539119941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d670f",
            "leftCorner": {
              "x": -25.237,
              "y": -18.079,
              "z": 0.865
            },
            "rightCorner": {
              "x": -25.298,
              "y": -18.078,
              "z": 0.865
            },
            "gtin": "4000539365201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "df10658bf4c95a806ca48f41",
            "leftCorner": {
              "x": -24.048,
              "y": -18.047,
              "z": 0.865
            },
            "rightCorner": {
              "x": -24.106,
              "y": -18.046,
              "z": 0.865
            },
            "gtin": "4000539119941",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6f1",
        "height": 1.3622,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6708",
            "leftCorner": {
              "x": -24.078,
              "y": -18.066,
              "z": 1.115
            },
            "rightCorner": {
              "x": -24.243,
              "y": -18.065,
              "z": 1.115
            },
            "gtin": "4000539097805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6709",
            "leftCorner": {
              "x": -24.243,
              "y": -18.074,
              "z": 1.115
            },
            "rightCorner": {
              "x": -24.4,
              "y": -18.073,
              "z": 1.115
            },
            "gtin": "4000539097706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d670a",
            "leftCorner": {
              "x": -24.4,
              "y": -18.072,
              "z": 1.115
            },
            "rightCorner": {
              "x": -24.599,
              "y": -18.07,
              "z": 1.115
            },
            "gtin": "4000539113987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d670b",
            "leftCorner": {
              "x": -24.599,
              "y": -18.073,
              "z": 1.115
            },
            "rightCorner": {
              "x": -24.771,
              "y": -18.071,
              "z": 1.115
            },
            "gtin": "4000539103780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d670c",
            "leftCorner": {
              "x": -24.771,
              "y": -18.075,
              "z": 1.115
            },
            "rightCorner": {
              "x": -25.076,
              "y": -18.072,
              "z": 1.115
            },
            "gtin": "4000539103766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d670d",
            "leftCorner": {
              "x": -25.077,
              "y": -18.08,
              "z": 1.115
            },
            "rightCorner": {
              "x": -25.168,
              "y": -18.079,
              "z": 1.115
            },
            "gtin": "4000539110887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66fb",
            "leftCorner": {
              "x": -25.167,
              "y": -18.074,
              "z": 1.115
            },
            "rightCorner": {
              "x": -25.298,
              "y": -18.073,
              "z": 1.115
            },
            "gtin": "4000539144189",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6f2",
        "height": 1.6573,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66da",
            "leftCorner": {
              "x": -24.109,
              "y": -18.052,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.264,
              "y": -18.051,
              "z": 1.356
            },
            "gtin": "4000539103889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66db",
            "leftCorner": {
              "x": -24.264,
              "y": -18.059,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.471,
              "y": -18.057,
              "z": 1.356
            },
            "gtin": "4000539148064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66dc",
            "leftCorner": {
              "x": -24.471,
              "y": -18.062,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.641,
              "y": -18.061,
              "z": 1.356
            },
            "gtin": "4000539148040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66dd",
            "leftCorner": {
              "x": -24.641,
              "y": -18.066,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.767,
              "y": -18.066,
              "z": 1.356
            },
            "gtin": "4000539124303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66de",
            "leftCorner": {
              "x": -24.767,
              "y": -18.068,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.892,
              "y": -18.067,
              "z": 1.356
            },
            "gtin": "4000539147784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66df",
            "leftCorner": {
              "x": -24.892,
              "y": -18.075,
              "z": 1.356
            },
            "rightCorner": {
              "x": -25.028,
              "y": -18.073,
              "z": 1.356
            },
            "gtin": "4000539148248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66e0",
            "leftCorner": {
              "x": -25.028,
              "y": -18.077,
              "z": 1.356
            },
            "rightCorner": {
              "x": -25.203,
              "y": -18.076,
              "z": 1.356
            },
            "gtin": "4000539147821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66c7",
            "leftCorner": {
              "x": -25.203,
              "y": -18.074,
              "z": 1.356
            },
            "rightCorner": {
              "x": -25.298,
              "y": -18.074,
              "z": 1.356
            },
            "gtin": "4000539147982",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4eb"
  },
  {
    "id": "4eb",
    "name": "4eb",
    "x": -22.799,
    "y": -18.109,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99999,
      "w": 0.0044942
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 60,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1cf",
        "height": 0.17465,
        "facings": [
          {
            "id": "868074b9ecbe0bdbd394a56a",
            "leftCorner": {
              "x": -22.798,
              "y": -18.013,
              "z": 0.143
            },
            "rightCorner": {
              "x": -22.85,
              "y": -18.013,
              "z": 0.143
            },
            "gtin": "4000539102127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "30815d6640872b53e5056454",
            "leftCorner": {
              "x": -22.85,
              "y": -18.013,
              "z": 0.143
            },
            "rightCorner": {
              "x": -22.91,
              "y": -18.012,
              "z": 0.143
            },
            "gtin": "4000161060116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cbb3e2faa527d1261c55b5dd",
            "leftCorner": {
              "x": -22.91,
              "y": -18.012,
              "z": 0.143
            },
            "rightCorner": {
              "x": -22.972,
              "y": -18.011,
              "z": 0.143
            },
            "gtin": "4000161170624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4f8e1025f369572db8a44083",
            "leftCorner": {
              "x": -22.972,
              "y": -18.011,
              "z": 0.143
            },
            "rightCorner": {
              "x": -23.037,
              "y": -18.011,
              "z": 0.143
            },
            "gtin": "4000161210337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4946b399f570d2f02ea717f1",
            "leftCorner": {
              "x": -23.037,
              "y": -18.011,
              "z": 0.143
            },
            "rightCorner": {
              "x": -23.105,
              "y": -18.01,
              "z": 0.143
            },
            "gtin": "4006446005940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b243cd7141b6ee6409912743",
            "leftCorner": {
              "x": -23.105,
              "y": -18.01,
              "z": 0.143
            },
            "rightCorner": {
              "x": -23.185,
              "y": -18.01,
              "z": 0.143
            },
            "gtin": "4006446008088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d3f0775b3d30766f95245d19",
            "leftCorner": {
              "x": -23.185,
              "y": -18.01,
              "z": 0.143
            },
            "rightCorner": {
              "x": -23.265,
              "y": -18.009,
              "z": 0.143
            },
            "gtin": "4000161100072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bddad685819a23688fe1528f",
            "leftCorner": {
              "x": -23.265,
              "y": -18.009,
              "z": 0.143
            },
            "rightCorner": {
              "x": -23.346,
              "y": -18.008,
              "z": 0.143
            },
            "gtin": "4000161100157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ce5d2ed10869ce891143150d",
            "leftCorner": {
              "x": -23.346,
              "y": -18.008,
              "z": 0.143
            },
            "rightCorner": {
              "x": -23.428,
              "y": -18.007,
              "z": 0.143
            },
            "gtin": "4000161060147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f1237554cb263e4c1e04e5c7",
            "leftCorner": {
              "x": -23.428,
              "y": -18.007,
              "z": 0.143
            },
            "rightCorner": {
              "x": -23.51,
              "y": -18.007,
              "z": 0.143
            },
            "gtin": "4000161060932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c2f87f52cc4e0e8f278d74ed",
            "leftCorner": {
              "x": -23.51,
              "y": -18.007,
              "z": 0.143
            },
            "rightCorner": {
              "x": -23.593,
              "y": -18.006,
              "z": 0.143
            },
            "gtin": "4000161060925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "883952b3948ea1d0135f0c95",
            "leftCorner": {
              "x": -23.593,
              "y": -18.006,
              "z": 0.143
            },
            "rightCorner": {
              "x": -23.678,
              "y": -18.005,
              "z": 0.143
            },
            "gtin": "4006446005056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1337fb3bff29b61b884cf7ef",
            "leftCorner": {
              "x": -23.678,
              "y": -18.005,
              "z": 0.143
            },
            "rightCorner": {
              "x": -23.765,
              "y": -18.004,
              "z": 0.143
            },
            "gtin": "4000161110095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "df1d74d14852b17e4d371402",
            "leftCorner": {
              "x": -23.765,
              "y": -18.004,
              "z": 0.143
            },
            "rightCorner": {
              "x": -24.018,
              "y": -18.002,
              "z": 0.143
            },
            "gtin": "4006446007265",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1cb",
        "height": 0.45429,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6743",
            "leftCorner": {
              "x": -22.799,
              "y": -18.062,
              "z": 0.372
            },
            "rightCorner": {
              "x": -22.935,
              "y": -18.061,
              "z": 0.372
            },
            "gtin": "4006446005674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6745",
            "leftCorner": {
              "x": -22.935,
              "y": -18.106,
              "z": 0.372
            },
            "rightCorner": {
              "x": -23.021,
              "y": -18.104,
              "z": 0.372
            },
            "gtin": "4006446005056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6746",
            "leftCorner": {
              "x": -23.021,
              "y": -18.104,
              "z": 0.372
            },
            "rightCorner": {
              "x": -23.088,
              "y": -18.103,
              "z": 0.372
            },
            "gtin": "4006446005940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6747",
            "leftCorner": {
              "x": -23.088,
              "y": -18.1,
              "z": 0.372
            },
            "rightCorner": {
              "x": -23.215,
              "y": -18.1,
              "z": 0.372
            },
            "gtin": "4006446005445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6748",
            "leftCorner": {
              "x": -23.215,
              "y": -18.099,
              "z": 0.372
            },
            "rightCorner": {
              "x": -23.368,
              "y": -18.097,
              "z": 0.372
            },
            "gtin": "4006446007456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6749",
            "leftCorner": {
              "x": -23.368,
              "y": -18.094,
              "z": 0.372
            },
            "rightCorner": {
              "x": -23.506,
              "y": -18.092,
              "z": 0.372
            },
            "gtin": "4006446010043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d674a",
            "leftCorner": {
              "x": -23.506,
              "y": -18.093,
              "z": 0.372
            },
            "rightCorner": {
              "x": -23.7,
              "y": -18.091,
              "z": 0.372
            },
            "gtin": "4006446007821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d674b",
            "leftCorner": {
              "x": -23.7,
              "y": -18.09,
              "z": 0.372
            },
            "rightCorner": {
              "x": -23.795,
              "y": -18.089,
              "z": 0.372
            },
            "gtin": "4006446008002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d674c",
            "leftCorner": {
              "x": -23.795,
              "y": -18.09,
              "z": 0.372
            },
            "rightCorner": {
              "x": -23.872,
              "y": -18.089,
              "z": 0.372
            },
            "gtin": "4006446008088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d674d",
            "leftCorner": {
              "x": -23.872,
              "y": -18.093,
              "z": 0.372
            },
            "rightCorner": {
              "x": -23.987,
              "y": -18.093,
              "z": 0.372
            },
            "gtin": "4006446006411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d674e",
            "leftCorner": {
              "x": -23.987,
              "y": -18.1,
              "z": 0.372
            },
            "rightCorner": {
              "x": -24.102,
              "y": -18.099,
              "z": 0.372
            },
            "gtin": "4000539102127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1ca",
        "height": 0.75252,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6735",
            "leftCorner": {
              "x": -22.799,
              "y": -18.062,
              "z": 0.616
            },
            "rightCorner": {
              "x": -22.922,
              "y": -18.06,
              "z": 0.616
            },
            "gtin": "4006446006657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6737",
            "leftCorner": {
              "x": -22.922,
              "y": -18.101,
              "z": 0.616
            },
            "rightCorner": {
              "x": -23.055,
              "y": -18.1,
              "z": 0.616
            },
            "gtin": "4006446007449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6738",
            "leftCorner": {
              "x": -23.055,
              "y": -18.099,
              "z": 0.616
            },
            "rightCorner": {
              "x": -23.256,
              "y": -18.097,
              "z": 0.616
            },
            "gtin": "4006446006756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6739",
            "leftCorner": {
              "x": -23.256,
              "y": -18.097,
              "z": 0.616
            },
            "rightCorner": {
              "x": -23.518,
              "y": -18.096,
              "z": 0.616
            },
            "gtin": "4006446007265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d673a",
            "leftCorner": {
              "x": -23.518,
              "y": -18.093,
              "z": 0.616
            },
            "rightCorner": {
              "x": -23.715,
              "y": -18.092,
              "z": 0.616
            },
            "gtin": "4006446005391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d673b",
            "leftCorner": {
              "x": -23.715,
              "y": -18.09,
              "z": 0.616
            },
            "rightCorner": {
              "x": -23.878,
              "y": -18.089,
              "z": 0.616
            },
            "gtin": "4006446007067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d673c",
            "leftCorner": {
              "x": -23.877,
              "y": -18.091,
              "z": 0.616
            },
            "rightCorner": {
              "x": -23.969,
              "y": -18.09,
              "z": 0.616
            },
            "gtin": "4006446006961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d673d",
            "leftCorner": {
              "x": -23.969,
              "y": -18.093,
              "z": 0.616
            },
            "rightCorner": {
              "x": -24.268,
              "y": -18.09,
              "z": 0.616
            },
            "gtin": "4006446005445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d673e",
            "leftCorner": {
              "x": -24.268,
              "y": -18.09,
              "z": 0.616
            },
            "rightCorner": {
              "x": -24.568,
              "y": -18.089,
              "z": 0.616
            },
            "gtin": "4006446005445",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1cc",
        "height": 1.0573,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6714",
            "leftCorner": {
              "x": -22.82,
              "y": -18.097,
              "z": 0.865
            },
            "rightCorner": {
              "x": -22.929,
              "y": -18.096,
              "z": 0.865
            },
            "gtin": "4000161050353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6715",
            "leftCorner": {
              "x": -22.929,
              "y": -18.098,
              "z": 0.865
            },
            "rightCorner": {
              "x": -23.13,
              "y": -18.096,
              "z": 0.865
            },
            "gtin": "4000161050308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6716",
            "leftCorner": {
              "x": -23.13,
              "y": -18.099,
              "z": 0.865
            },
            "rightCorner": {
              "x": -23.311,
              "y": -18.097,
              "z": 0.865
            },
            "gtin": "4000161030300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6717",
            "leftCorner": {
              "x": -23.311,
              "y": -18.096,
              "z": 0.865
            },
            "rightCorner": {
              "x": -23.395,
              "y": -18.095,
              "z": 0.865
            },
            "gtin": "4000161100072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6718",
            "leftCorner": {
              "x": -23.395,
              "y": -18.095,
              "z": 0.865
            },
            "rightCorner": {
              "x": -23.485,
              "y": -18.094,
              "z": 0.865
            },
            "gtin": "4000161110095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6719",
            "leftCorner": {
              "x": -23.485,
              "y": -18.095,
              "z": 0.865
            },
            "rightCorner": {
              "x": -23.574,
              "y": -18.094,
              "z": 0.865
            },
            "gtin": "4000161210191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d671a",
            "leftCorner": {
              "x": -23.573,
              "y": -18.096,
              "z": 0.865
            },
            "rightCorner": {
              "x": -23.633,
              "y": -18.096,
              "z": 0.865
            },
            "gtin": "4000161060116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d671b",
            "leftCorner": {
              "x": -23.633,
              "y": -18.094,
              "z": 0.865
            },
            "rightCorner": {
              "x": -23.713,
              "y": -18.094,
              "z": 0.865
            },
            "gtin": "4000161060147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d671c",
            "leftCorner": {
              "x": -23.713,
              "y": -18.093,
              "z": 0.865
            },
            "rightCorner": {
              "x": -23.812,
              "y": -18.093,
              "z": 0.865
            },
            "gtin": "4000161060178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d671d",
            "leftCorner": {
              "x": -23.812,
              "y": -18.091,
              "z": 0.865
            },
            "rightCorner": {
              "x": -23.889,
              "y": -18.09,
              "z": 0.865
            },
            "gtin": "4000161060932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d671e",
            "leftCorner": {
              "x": -23.889,
              "y": -18.093,
              "z": 0.865
            },
            "rightCorner": {
              "x": -23.981,
              "y": -18.091,
              "z": 0.865
            },
            "gtin": "4000161060925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d671f",
            "leftCorner": {
              "x": -23.981,
              "y": -18.093,
              "z": 0.865
            },
            "rightCorner": {
              "x": -24.113,
              "y": -18.092,
              "z": 0.865
            },
            "gtin": "4000161170624",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1cd",
        "height": 1.3618,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66ff",
            "leftCorner": {
              "x": -22.815,
              "y": -18.1,
              "z": 1.114
            },
            "rightCorner": {
              "x": -22.952,
              "y": -18.097,
              "z": 1.114
            },
            "gtin": "4000161100195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6700",
            "leftCorner": {
              "x": -22.952,
              "y": -18.096,
              "z": 1.114
            },
            "rightCorner": {
              "x": -23.108,
              "y": -18.095,
              "z": 1.114
            },
            "gtin": "4000161100379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6701",
            "leftCorner": {
              "x": -23.108,
              "y": -18.098,
              "z": 1.114
            },
            "rightCorner": {
              "x": -23.252,
              "y": -18.097,
              "z": 1.114
            },
            "gtin": "4000161100171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6702",
            "leftCorner": {
              "x": -23.252,
              "y": -18.094,
              "z": 1.114
            },
            "rightCorner": {
              "x": -23.383,
              "y": -18.093,
              "z": 1.114
            },
            "gtin": "4000161110170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6703",
            "leftCorner": {
              "x": -23.383,
              "y": -18.098,
              "z": 1.114
            },
            "rightCorner": {
              "x": -23.444,
              "y": -18.097,
              "z": 1.114
            },
            "gtin": "4000161110156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6704",
            "leftCorner": {
              "x": -23.444,
              "y": -18.091,
              "z": 1.114
            },
            "rightCorner": {
              "x": -23.647,
              "y": -18.089,
              "z": 1.114
            },
            "gtin": "4000161100157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6705",
            "leftCorner": {
              "x": -23.647,
              "y": -18.095,
              "z": 1.114
            },
            "rightCorner": {
              "x": -23.84,
              "y": -18.093,
              "z": 1.114
            },
            "gtin": "4000161100904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6706",
            "leftCorner": {
              "x": -23.84,
              "y": -18.096,
              "z": 1.114
            },
            "rightCorner": {
              "x": -23.908,
              "y": -18.096,
              "z": 1.114
            },
            "gtin": "4000161210337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6707",
            "leftCorner": {
              "x": -23.908,
              "y": -18.095,
              "z": 1.114
            },
            "rightCorner": {
              "x": -24.079,
              "y": -18.093,
              "z": 1.114
            },
            "gtin": "4000161210320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1ce",
        "height": 1.6605,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66d5",
            "leftCorner": {
              "x": -22.823,
              "y": -18.099,
              "z": 1.359
            },
            "rightCorner": {
              "x": -23.028,
              "y": -18.097,
              "z": 1.359
            },
            "gtin": "4000161360254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66d6",
            "leftCorner": {
              "x": -23.028,
              "y": -18.099,
              "z": 1.359
            },
            "rightCorner": {
              "x": -23.2,
              "y": -18.097,
              "z": 1.359
            },
            "gtin": "4000161360155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66d7",
            "leftCorner": {
              "x": -23.2,
              "y": -18.098,
              "z": 1.359
            },
            "rightCorner": {
              "x": -23.826,
              "y": -18.093,
              "z": 1.359
            },
            "gtin": "4000161470625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66d8",
            "leftCorner": {
              "x": -23.826,
              "y": -18.092,
              "z": 1.359
            },
            "rightCorner": {
              "x": -23.948,
              "y": -18.09,
              "z": 1.359
            },
            "gtin": "4000161090052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66d9",
            "leftCorner": {
              "x": -23.948,
              "y": -18.095,
              "z": 1.359
            },
            "rightCorner": {
              "x": -24.11,
              "y": -18.094,
              "z": 1.359
            },
            "gtin": "4000161090021",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4ec",
    "rightNeighborShelfId": "4ea"
  },
  {
    "id": "4ec",
    "name": "4ec",
    "x": -21.802,
    "y": -18.086,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.005393
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 26,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1c9",
        "height": 0.16906,
        "facings": [
          {
            "id": "2ba98838f065056902d0af68",
            "leftCorner": {
              "x": -21.803,
              "y": -18.026,
              "z": 0.138
            },
            "rightCorner": {
              "x": -21.958,
              "y": -18.028,
              "z": 0.138
            },
            "gtin": "8000500387221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ed2adc82293910936f350b18",
            "leftCorner": {
              "x": -21.958,
              "y": -18.028,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.153,
              "y": -18.03,
              "z": 0.138
            },
            "gtin": "4008400183022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "550b53efaf44926660289ba2",
            "leftCorner": {
              "x": -22.153,
              "y": -18.03,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.219,
              "y": -18.03,
              "z": 0.138
            },
            "gtin": "4006446010081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "32be9eaa083c709d8b8b488b",
            "leftCorner": {
              "x": -22.219,
              "y": -18.03,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.374,
              "y": -18.032,
              "z": 0.138
            },
            "gtin": "8000500387221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "91ce33fa03f2f5e1dd7b4340",
            "leftCorner": {
              "x": -22.374,
              "y": -18.032,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.563,
              "y": -18.034,
              "z": 0.138
            },
            "gtin": "8000500408162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2ec6d19c87d474d21ac75b16",
            "leftCorner": {
              "x": -22.563,
              "y": -18.034,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.791,
              "y": -18.037,
              "z": 0.138
            },
            "gtin": "4000607000539",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1c7",
        "height": 0.46662,
        "facings": [
          {
            "id": "68d8e50be1820c81800d672d",
            "leftCorner": {
              "x": -21.802,
              "y": -18.028,
              "z": 0.382
            },
            "rightCorner": {
              "x": -22.054,
              "y": -18.031,
              "z": 0.382
            },
            "gtin": "5701912066997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e91196896ff59afde367fe69",
            "leftCorner": {
              "x": -22.317,
              "y": -18.034,
              "z": 0.382
            },
            "rightCorner": {
              "x": -22.545,
              "y": -18.036,
              "z": 0.382
            },
            "gtin": "4000607000539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d672f",
            "leftCorner": {
              "x": -22.054,
              "y": -18.071,
              "z": 0.382
            },
            "rightCorner": {
              "x": -22.317,
              "y": -18.075,
              "z": 0.382
            },
            "gtin": "4000607790706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d672e",
            "leftCorner": {
              "x": -22.56,
              "y": -18.071,
              "z": 0.382
            },
            "rightCorner": {
              "x": -22.803,
              "y": -18.074,
              "z": 0.382
            },
            "gtin": "4000607000539",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1c8",
        "height": 0.76502,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6731",
            "leftCorner": {
              "x": -21.802,
              "y": -18.028,
              "z": 0.626
            },
            "rightCorner": {
              "x": -22.105,
              "y": -18.031,
              "z": 0.626
            },
            "gtin": "8000500400821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6733",
            "leftCorner": {
              "x": -22.104,
              "y": -18.072,
              "z": 0.626
            },
            "rightCorner": {
              "x": -22.382,
              "y": -18.075,
              "z": 0.626
            },
            "gtin": "8000500345047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6734",
            "leftCorner": {
              "x": -22.382,
              "y": -18.073,
              "z": 0.626
            },
            "rightCorner": {
              "x": -22.73,
              "y": -18.077,
              "z": 0.626
            },
            "gtin": "4008400122625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6732",
            "leftCorner": {
              "x": -22.73,
              "y": -18.075,
              "z": 0.626
            },
            "rightCorner": {
              "x": -22.802,
              "y": -18.076,
              "z": 0.626
            },
            "gtin": "4006446010081",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1c6",
        "height": 1.0553,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d670e",
            "leftCorner": {
              "x": -21.803,
              "y": -18.036,
              "z": 0.863
            },
            "rightCorner": {
              "x": -22.045,
              "y": -18.039,
              "z": 0.863
            },
            "gtin": "8000500430453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6710",
            "leftCorner": {
              "x": -22.044,
              "y": -18.081,
              "z": 0.863
            },
            "rightCorner": {
              "x": -22.194,
              "y": -18.083,
              "z": 0.863
            },
            "gtin": "8000500399712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6711",
            "leftCorner": {
              "x": -22.194,
              "y": -18.08,
              "z": 0.863
            },
            "rightCorner": {
              "x": -22.36,
              "y": -18.081,
              "z": 0.863
            },
            "gtin": "4008400159027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6712",
            "leftCorner": {
              "x": -22.36,
              "y": -18.081,
              "z": 0.863
            },
            "rightCorner": {
              "x": -22.526,
              "y": -18.083,
              "z": 0.863
            },
            "gtin": "4008400159027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6713",
            "leftCorner": {
              "x": -22.527,
              "y": -18.078,
              "z": 0.863
            },
            "rightCorner": {
              "x": -22.822,
              "y": -18.081,
              "z": 0.863
            },
            "gtin": "4008400121321",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1c4",
        "height": 1.3587,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66fa",
            "leftCorner": {
              "x": -21.803,
              "y": -18.033,
              "z": 1.112
            },
            "rightCorner": {
              "x": -22.045,
              "y": -18.035,
              "z": 1.112
            },
            "gtin": "8000500448687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66fc",
            "leftCorner": {
              "x": -22.044,
              "y": -18.076,
              "z": 1.112
            },
            "rightCorner": {
              "x": -22.362,
              "y": -18.078,
              "z": 1.112
            },
            "gtin": "4008400163826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66fd",
            "leftCorner": {
              "x": -22.362,
              "y": -18.078,
              "z": 1.112
            },
            "rightCorner": {
              "x": -22.604,
              "y": -18.081,
              "z": 1.112
            },
            "gtin": "4008400102528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66fe",
            "leftCorner": {
              "x": -22.604,
              "y": -18.076,
              "z": 1.112
            },
            "rightCorner": {
              "x": -22.818,
              "y": -18.079,
              "z": 1.112
            },
            "gtin": "8000500408162",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1c5",
        "height": 1.6588,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66d2",
            "leftCorner": {
              "x": -21.954,
              "y": -18.074,
              "z": 1.357
            },
            "rightCorner": {
              "x": -22.208,
              "y": -18.077,
              "z": 1.357
            },
            "gtin": "4014400917956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66d3",
            "leftCorner": {
              "x": -22.207,
              "y": -18.078,
              "z": 1.357
            },
            "rightCorner": {
              "x": -22.598,
              "y": -18.083,
              "z": 1.357
            },
            "gtin": "4008400182827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66d4",
            "leftCorner": {
              "x": -22.598,
              "y": -18.081,
              "z": 1.357
            },
            "rightCorner": {
              "x": -22.826,
              "y": -18.083,
              "z": 1.357
            },
            "gtin": "4008400181523",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4ed",
    "rightNeighborShelfId": "4eb"
  },
  {
    "id": "4ed",
    "name": "4ed",
    "x": -20.531,
    "y": -18.068,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 5.7596E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 43,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1c3",
        "height": 0.17207,
        "facings": [
          {
            "id": "881e3ad663645957d75a1eca",
            "leftCorner": {
              "x": -20.53,
              "y": -17.972,
              "z": 0.141
            },
            "rightCorner": {
              "x": -20.692,
              "y": -17.972,
              "z": 0.141
            },
            "gtin": "92961708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "35af13ce002cedaa63efa25e",
            "leftCorner": {
              "x": -20.692,
              "y": -17.972,
              "z": 0.141
            },
            "rightCorner": {
              "x": -20.892,
              "y": -17.972,
              "z": 0.141
            },
            "gtin": "7622201141776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "83d86962739cb3b78e93a4a9",
            "leftCorner": {
              "x": -20.892,
              "y": -17.972,
              "z": 0.141
            },
            "rightCorner": {
              "x": -20.976,
              "y": -17.973,
              "z": 0.141
            },
            "gtin": "4014400923735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "75a3798ad0a554447b7809b6",
            "leftCorner": {
              "x": -20.976,
              "y": -17.973,
              "z": 0.141
            },
            "rightCorner": {
              "x": -21.083,
              "y": -17.973,
              "z": 0.141
            },
            "gtin": "6411401072680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d493afb28a2e15e5cc4ca965",
            "leftCorner": {
              "x": -21.083,
              "y": -17.973,
              "z": 0.141
            },
            "rightCorner": {
              "x": -21.219,
              "y": -17.973,
              "z": 0.141
            },
            "gtin": "4001743761384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "28bf77598a87bc8da8cbf3e6",
            "leftCorner": {
              "x": -21.219,
              "y": -17.973,
              "z": 0.141
            },
            "rightCorner": {
              "x": -21.368,
              "y": -17.973,
              "z": 0.141
            },
            "gtin": "9002859044694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fe63c53e45a6fbf3d23fa248",
            "leftCorner": {
              "x": -21.368,
              "y": -17.973,
              "z": 0.141
            },
            "rightCorner": {
              "x": -21.522,
              "y": -17.973,
              "z": 0.141
            },
            "gtin": "4000417101426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "29eeeb0177cfeaac71f1e1a4",
            "leftCorner": {
              "x": -21.522,
              "y": -17.973,
              "z": 0.141
            },
            "rightCorner": {
              "x": -21.776,
              "y": -17.973,
              "z": 0.141
            },
            "gtin": "4001518102459",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1be",
        "height": 0.42806,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66ac",
            "leftCorner": {
              "x": -20.706,
              "y": -18.068,
              "z": 0.35
            },
            "rightCorner": {
              "x": -20.863,
              "y": -18.068,
              "z": 0.35
            },
            "gtin": "4001743759985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66ad",
            "leftCorner": {
              "x": -20.863,
              "y": -18.068,
              "z": 0.35
            },
            "rightCorner": {
              "x": -20.998,
              "y": -18.068,
              "z": 0.35
            },
            "gtin": "4001743761384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66ae",
            "leftCorner": {
              "x": -20.998,
              "y": -18.069,
              "z": 0.35
            },
            "rightCorner": {
              "x": -21.144,
              "y": -18.07,
              "z": 0.35
            },
            "gtin": "4030387040203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66af",
            "leftCorner": {
              "x": -21.144,
              "y": -18.071,
              "z": 0.35
            },
            "rightCorner": {
              "x": -21.476,
              "y": -18.071,
              "z": 0.35
            },
            "gtin": "4001743758506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66a6",
            "leftCorner": {
              "x": -21.476,
              "y": -18.066,
              "z": 0.35
            },
            "rightCorner": {
              "x": -21.78,
              "y": -18.066,
              "z": 0.35
            },
            "gtin": "4000281589511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f84394b3e627e7565a223ee1",
            "leftCorner": {
              "x": -20.53,
              "y": -18.028,
              "z": 0.35
            },
            "rightCorner": {
              "x": -20.701,
              "y": -18.028,
              "z": 0.35
            },
            "gtin": "4030387040203",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1bd",
        "height": 0.67641,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66a0",
            "leftCorner": {
              "x": -20.662,
              "y": -18.064,
              "z": 0.553
            },
            "rightCorner": {
              "x": -20.799,
              "y": -18.063,
              "z": 0.553
            },
            "gtin": "4030387003741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66a1",
            "leftCorner": {
              "x": -20.799,
              "y": -18.063,
              "z": 0.553
            },
            "rightCorner": {
              "x": -20.968,
              "y": -18.064,
              "z": 0.553
            },
            "gtin": "4030387003727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66a2",
            "leftCorner": {
              "x": -20.968,
              "y": -18.066,
              "z": 0.553
            },
            "rightCorner": {
              "x": -21.151,
              "y": -18.065,
              "z": 0.553
            },
            "gtin": "4030387904635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66a3",
            "leftCorner": {
              "x": -21.151,
              "y": -18.063,
              "z": 0.553
            },
            "rightCorner": {
              "x": -21.315,
              "y": -18.064,
              "z": 0.553
            },
            "gtin": "4030387760347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66a4",
            "leftCorner": {
              "x": -21.315,
              "y": -18.055,
              "z": 0.553
            },
            "rightCorner": {
              "x": -21.541,
              "y": -18.055,
              "z": 0.553
            },
            "gtin": "4030387760354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6699",
            "leftCorner": {
              "x": -21.541,
              "y": -18.058,
              "z": 0.553
            },
            "rightCorner": {
              "x": -21.781,
              "y": -18.059,
              "z": 0.553
            },
            "gtin": "4030387758146",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1c2",
        "height": 0.92709,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6694",
            "leftCorner": {
              "x": -20.608,
              "y": -18.057,
              "z": 0.759
            },
            "rightCorner": {
              "x": -20.787,
              "y": -18.058,
              "z": 0.759
            },
            "gtin": "4014400932959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6695",
            "leftCorner": {
              "x": -20.787,
              "y": -18.058,
              "z": 0.759
            },
            "rightCorner": {
              "x": -20.967,
              "y": -18.058,
              "z": 0.759
            },
            "gtin": "4014400932959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6696",
            "leftCorner": {
              "x": -20.967,
              "y": -18.061,
              "z": 0.759
            },
            "rightCorner": {
              "x": -21.283,
              "y": -18.061,
              "z": 0.759
            },
            "gtin": "4014400400007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6697",
            "leftCorner": {
              "x": -21.283,
              "y": -18.064,
              "z": 0.759
            },
            "rightCorner": {
              "x": -21.567,
              "y": -18.064,
              "z": 0.759
            },
            "gtin": "4014400900576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d668f",
            "leftCorner": {
              "x": -21.567,
              "y": -18.059,
              "z": 0.759
            },
            "rightCorner": {
              "x": -21.78,
              "y": -18.06,
              "z": 0.759
            },
            "gtin": "4030387760545",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1c0",
        "height": 1.1796,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66f5",
            "leftCorner": {
              "x": -20.53,
              "y": -18.02,
              "z": 0.965
            },
            "rightCorner": {
              "x": -20.694,
              "y": -18.02,
              "z": 0.965
            },
            "gtin": "7622210597915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66f7",
            "leftCorner": {
              "x": -20.694,
              "y": -18.058,
              "z": 0.965
            },
            "rightCorner": {
              "x": -20.899,
              "y": -18.059,
              "z": 0.965
            },
            "gtin": "7622210598011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66f8",
            "leftCorner": {
              "x": -20.899,
              "y": -18.062,
              "z": 0.965
            },
            "rightCorner": {
              "x": -21.091,
              "y": -18.061,
              "z": 0.965
            },
            "gtin": "7622010002442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66f9",
            "leftCorner": {
              "x": -21.091,
              "y": -18.062,
              "z": 0.965
            },
            "rightCorner": {
              "x": -21.511,
              "y": -18.063,
              "z": 0.965
            },
            "gtin": "7622210598080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66f6",
            "leftCorner": {
              "x": -21.511,
              "y": -18.054,
              "z": 0.965
            },
            "rightCorner": {
              "x": -21.781,
              "y": -18.055,
              "z": 0.965
            },
            "gtin": "7622400779756",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1bf",
        "height": 1.406,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66c1",
            "leftCorner": {
              "x": -20.696,
              "y": -18.052,
              "z": 1.15
            },
            "rightCorner": {
              "x": -20.857,
              "y": -18.052,
              "z": 1.15
            },
            "gtin": "5000189363069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66c2",
            "leftCorner": {
              "x": -20.857,
              "y": -18.055,
              "z": 1.15
            },
            "rightCorner": {
              "x": -21.006,
              "y": -18.056,
              "z": 1.15
            },
            "gtin": "9002859044694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66c3",
            "leftCorner": {
              "x": -21.006,
              "y": -18.051,
              "z": 1.15
            },
            "rightCorner": {
              "x": -21.113,
              "y": -18.051,
              "z": 1.15
            },
            "gtin": "6411401072680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66c4",
            "leftCorner": {
              "x": -21.113,
              "y": -18.056,
              "z": 1.15
            },
            "rightCorner": {
              "x": -21.37,
              "y": -18.056,
              "z": 1.15
            },
            "gtin": "4001518102459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66c5",
            "leftCorner": {
              "x": -21.37,
              "y": -18.056,
              "z": 1.15
            },
            "rightCorner": {
              "x": -21.526,
              "y": -18.056,
              "z": 1.15
            },
            "gtin": "4000417101426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66b9",
            "leftCorner": {
              "x": -21.526,
              "y": -18.054,
              "z": 1.15
            },
            "rightCorner": {
              "x": -21.781,
              "y": -18.054,
              "z": 1.15
            },
            "gtin": "4000417101228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c41c31a29dd066a3de3e2a3e",
            "leftCorner": {
              "x": -20.53,
              "y": -18.014,
              "z": 1.15
            },
            "rightCorner": {
              "x": -20.692,
              "y": -18.014,
              "z": 1.15
            },
            "gtin": "5000189363069",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1c1",
        "height": 1.6569,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66cc",
            "leftCorner": {
              "x": -20.554,
              "y": -18.052,
              "z": 1.356
            },
            "rightCorner": {
              "x": -20.768,
              "y": -18.051,
              "z": 1.356
            },
            "gtin": "7622210928719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66cd",
            "leftCorner": {
              "x": -20.768,
              "y": -18.055,
              "z": 1.356
            },
            "rightCorner": {
              "x": -21.054,
              "y": -18.055,
              "z": 1.356
            },
            "gtin": "4014400900217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66ce",
            "leftCorner": {
              "x": -21.054,
              "y": -18.056,
              "z": 1.356
            },
            "rightCorner": {
              "x": -21.271,
              "y": -18.056,
              "z": 1.356
            },
            "gtin": "4014400901191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66cf",
            "leftCorner": {
              "x": -21.271,
              "y": -18.057,
              "z": 1.356
            },
            "rightCorner": {
              "x": -21.528,
              "y": -18.057,
              "z": 1.356
            },
            "gtin": "4014400901405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66d0",
            "leftCorner": {
              "x": -21.528,
              "y": -18.05,
              "z": 1.356
            },
            "rightCorner": {
              "x": -21.691,
              "y": -18.05,
              "z": 1.356
            },
            "gtin": "4014400901412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66d1",
            "leftCorner": {
              "x": -21.691,
              "y": -18.051,
              "z": 1.356
            },
            "rightCorner": {
              "x": -21.932,
              "y": -18.052,
              "z": 1.356
            },
            "gtin": "4014400923735",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4ef",
    "rightNeighborShelfId": "4ec"
  },
  {
    "id": "4ef",
    "name": "4ef",
    "x": -19.281,
    "y": -18.067,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 5.7596E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 49,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1bc",
        "height": 0.17606,
        "facings": [
          {
            "id": "3ae8e28838e3fe0261624be3",
            "leftCorner": {
              "x": -19.282,
              "y": -17.981,
              "z": 0.144
            },
            "rightCorner": {
              "x": -19.299,
              "y": -17.981,
              "z": 0.144
            },
            "gtin": "4001743761384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "57670a028afb8905602ffc4c",
            "leftCorner": {
              "x": -19.299,
              "y": -17.981,
              "z": 0.144
            },
            "rightCorner": {
              "x": -19.499,
              "y": -17.981,
              "z": 0.144
            },
            "gtin": "4001743759985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a51e1d2fefa126a58ed3edee",
            "leftCorner": {
              "x": -19.499,
              "y": -17.981,
              "z": 0.144
            },
            "rightCorner": {
              "x": -19.716,
              "y": -17.981,
              "z": 0.144
            },
            "gtin": "4023800051344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "31cd1dd754c7fd848f0bc558",
            "leftCorner": {
              "x": -19.716,
              "y": -17.981,
              "z": 0.144
            },
            "rightCorner": {
              "x": -19.733,
              "y": -17.981,
              "z": 0.144
            },
            "gtin": "4001743761384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "da2a95b5653afaae5c99147a",
            "leftCorner": {
              "x": -19.733,
              "y": -17.981,
              "z": 0.144
            },
            "rightCorner": {
              "x": -19.76,
              "y": -17.982,
              "z": 0.144
            },
            "gtin": "7622400928604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "71f0775f1f19c7009783b302",
            "leftCorner": {
              "x": -19.76,
              "y": -17.982,
              "z": 0.144
            },
            "rightCorner": {
              "x": -19.867,
              "y": -17.982,
              "z": 0.144
            },
            "gtin": "4000417652607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f451fdfd7af79b1a9134acf6",
            "leftCorner": {
              "x": -19.867,
              "y": -17.982,
              "z": 0.144
            },
            "rightCorner": {
              "x": -19.976,
              "y": -17.982,
              "z": 0.144
            },
            "gtin": "4000417652508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d6db59c312545e67bf50b92a",
            "leftCorner": {
              "x": -19.976,
              "y": -17.982,
              "z": 0.144
            },
            "rightCorner": {
              "x": -20.092,
              "y": -17.982,
              "z": 0.144
            },
            "gtin": "4014400914993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "24cb0bc7f360e3bba8371487",
            "leftCorner": {
              "x": -20.092,
              "y": -17.982,
              "z": 0.144
            },
            "rightCorner": {
              "x": -20.209,
              "y": -17.982,
              "z": 0.144
            },
            "gtin": "4014400927597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fad961921e62955ff0487b4e",
            "leftCorner": {
              "x": -20.209,
              "y": -17.982,
              "z": 0.144
            },
            "rightCorner": {
              "x": -20.326,
              "y": -17.982,
              "z": 0.144
            },
            "gtin": "4000417652409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "90201abec76b5aa84f993218",
            "leftCorner": {
              "x": -20.326,
              "y": -17.982,
              "z": 0.144
            },
            "rightCorner": {
              "x": -20.526,
              "y": -17.982,
              "z": 0.144
            },
            "gtin": "4001743759985",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1b8",
        "height": 0.4316,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66a5",
            "leftCorner": {
              "x": -19.282,
              "y": -18.024,
              "z": 0.353
            },
            "rightCorner": {
              "x": -19.473,
              "y": -18.024,
              "z": 0.353
            },
            "gtin": "7613035499652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66a7",
            "leftCorner": {
              "x": -19.473,
              "y": -18.061,
              "z": 0.353
            },
            "rightCorner": {
              "x": -19.666,
              "y": -18.061,
              "z": 0.353
            },
            "gtin": "7613035499478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66a8",
            "leftCorner": {
              "x": -19.666,
              "y": -18.064,
              "z": 0.353
            },
            "rightCorner": {
              "x": -19.89,
              "y": -18.064,
              "z": 0.353
            },
            "gtin": "4306188020868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66a9",
            "leftCorner": {
              "x": -19.89,
              "y": -18.064,
              "z": 0.353
            },
            "rightCorner": {
              "x": -20.114,
              "y": -18.065,
              "z": 0.353
            },
            "gtin": "4306188020868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66aa",
            "leftCorner": {
              "x": -20.114,
              "y": -18.068,
              "z": 0.353
            },
            "rightCorner": {
              "x": -20.376,
              "y": -18.069,
              "z": 0.353
            },
            "gtin": "4012362080503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66ab",
            "leftCorner": {
              "x": -20.376,
              "y": -18.065,
              "z": 0.353
            },
            "rightCorner": {
              "x": -20.706,
              "y": -18.065,
              "z": 0.353
            },
            "gtin": "7622202038587",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1b7",
        "height": 0.68017,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6698",
            "leftCorner": {
              "x": -19.282,
              "y": -18.024,
              "z": 0.557
            },
            "rightCorner": {
              "x": -19.586,
              "y": -18.024,
              "z": 0.557
            },
            "gtin": "5000159500258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d669a",
            "leftCorner": {
              "x": -19.586,
              "y": -18.061,
              "z": 0.557
            },
            "rightCorner": {
              "x": -19.763,
              "y": -18.061,
              "z": 0.557
            },
            "gtin": "5000159500296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d669b",
            "leftCorner": {
              "x": -19.763,
              "y": -18.065,
              "z": 0.557
            },
            "rightCorner": {
              "x": -19.947,
              "y": -18.065,
              "z": 0.557
            },
            "gtin": "7622201755218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d669c",
            "leftCorner": {
              "x": -19.947,
              "y": -18.066,
              "z": 0.557
            },
            "rightCorner": {
              "x": -20.105,
              "y": -18.066,
              "z": 0.557
            },
            "gtin": "7622201765033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d669d",
            "leftCorner": {
              "x": -20.105,
              "y": -18.064,
              "z": 0.557
            },
            "rightCorner": {
              "x": -20.418,
              "y": -18.065,
              "z": 0.557
            },
            "gtin": "4000417067203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d669e",
            "leftCorner": {
              "x": -20.418,
              "y": -18.061,
              "z": 0.557
            },
            "rightCorner": {
              "x": -20.558,
              "y": -18.061,
              "z": 0.557
            },
            "gtin": "4030387761115",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1b6",
        "height": 0.93052,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d668e",
            "leftCorner": {
              "x": -19.282,
              "y": -18.02,
              "z": 0.761
            },
            "rightCorner": {
              "x": -19.717,
              "y": -18.02,
              "z": 0.761
            },
            "gtin": "4014400928624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6690",
            "leftCorner": {
              "x": -19.717,
              "y": -18.063,
              "z": 0.761
            },
            "rightCorner": {
              "x": -20.015,
              "y": -18.064,
              "z": 0.761
            },
            "gtin": "4014400933055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6691",
            "leftCorner": {
              "x": -20.015,
              "y": -18.063,
              "z": 0.761
            },
            "rightCorner": {
              "x": -20.192,
              "y": -18.063,
              "z": 0.761
            },
            "gtin": "4014400933079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6692",
            "leftCorner": {
              "x": -20.192,
              "y": -18.058,
              "z": 0.761
            },
            "rightCorner": {
              "x": -20.326,
              "y": -18.058,
              "z": 0.761
            },
            "gtin": "4014400933062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6693",
            "leftCorner": {
              "x": -20.326,
              "y": -18.057,
              "z": 0.761
            },
            "rightCorner": {
              "x": -20.608,
              "y": -18.058,
              "z": 0.761
            },
            "gtin": "4030387004366",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1b9",
        "height": 1.1573,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66b0",
            "leftCorner": {
              "x": -19.282,
              "y": -18.018,
              "z": 0.947
            },
            "rightCorner": {
              "x": -19.48,
              "y": -18.019,
              "z": 0.947
            },
            "gtin": "4014400925395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66b2",
            "leftCorner": {
              "x": -19.48,
              "y": -18.059,
              "z": 0.947
            },
            "rightCorner": {
              "x": -19.649,
              "y": -18.058,
              "z": 0.947
            },
            "gtin": "4014400927375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66b3",
            "leftCorner": {
              "x": -19.649,
              "y": -18.058,
              "z": 0.947
            },
            "rightCorner": {
              "x": -19.831,
              "y": -18.059,
              "z": 0.947
            },
            "gtin": "4014400927443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66b4",
            "leftCorner": {
              "x": -19.83,
              "y": -18.06,
              "z": 0.947
            },
            "rightCorner": {
              "x": -20.0,
              "y": -18.06,
              "z": 0.947
            },
            "gtin": "4014400927436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66b5",
            "leftCorner": {
              "x": -20.0,
              "y": -18.061,
              "z": 0.947
            },
            "rightCorner": {
              "x": -20.177,
              "y": -18.061,
              "z": 0.947
            },
            "gtin": "4014400927429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66b6",
            "leftCorner": {
              "x": -20.177,
              "y": -18.056,
              "z": 0.947
            },
            "rightCorner": {
              "x": -20.295,
              "y": -18.057,
              "z": 0.947
            },
            "gtin": "4014400914993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66b7",
            "leftCorner": {
              "x": -20.295,
              "y": -18.054,
              "z": 0.947
            },
            "rightCorner": {
              "x": -20.413,
              "y": -18.055,
              "z": 0.947
            },
            "gtin": "4014400927597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66b1",
            "leftCorner": {
              "x": -20.413,
              "y": -18.043,
              "z": 0.947
            },
            "rightCorner": {
              "x": -20.532,
              "y": -18.043,
              "z": 0.947
            },
            "gtin": "4014400927573",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1ba",
        "height": 1.4094,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66b8",
            "leftCorner": {
              "x": -19.282,
              "y": -18.014,
              "z": 1.153
            },
            "rightCorner": {
              "x": -19.493,
              "y": -18.014,
              "z": 1.153
            },
            "gtin": "8000500389652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66ba",
            "leftCorner": {
              "x": -19.493,
              "y": -18.054,
              "z": 1.153
            },
            "rightCorner": {
              "x": -19.793,
              "y": -18.054,
              "z": 1.153
            },
            "gtin": "8000500256213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66bb",
            "leftCorner": {
              "x": -19.793,
              "y": -18.058,
              "z": 1.153
            },
            "rightCorner": {
              "x": -20.057,
              "y": -18.058,
              "z": 1.153
            },
            "gtin": "8000500253687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66bc",
            "leftCorner": {
              "x": -20.057,
              "y": -18.056,
              "z": 1.153
            },
            "rightCorner": {
              "x": -20.207,
              "y": -18.056,
              "z": 1.153
            },
            "gtin": "4000417652706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66bd",
            "leftCorner": {
              "x": -20.207,
              "y": -18.056,
              "z": 1.153
            },
            "rightCorner": {
              "x": -20.317,
              "y": -18.056,
              "z": 1.153
            },
            "gtin": "4000417652607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66be",
            "leftCorner": {
              "x": -20.317,
              "y": -18.05,
              "z": 1.153
            },
            "rightCorner": {
              "x": -20.428,
              "y": -18.049,
              "z": 1.153
            },
            "gtin": "4000417652508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66bf",
            "leftCorner": {
              "x": -20.428,
              "y": -18.047,
              "z": 1.153
            },
            "rightCorner": {
              "x": -20.539,
              "y": -18.047,
              "z": 1.153
            },
            "gtin": "4000417652409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66c0",
            "leftCorner": {
              "x": -20.539,
              "y": -18.045,
              "z": 1.153
            },
            "rightCorner": {
              "x": -20.696,
              "y": -18.046,
              "z": 1.153
            },
            "gtin": "7622400928604",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1bb",
        "height": 1.6588,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d66c6",
            "leftCorner": {
              "x": -19.282,
              "y": -18.013,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.835,
              "y": -18.014,
              "z": 1.357
            },
            "gtin": "4023800321485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66c8",
            "leftCorner": {
              "x": -19.835,
              "y": -18.057,
              "z": 1.357
            },
            "rightCorner": {
              "x": -20.024,
              "y": -18.057,
              "z": 1.357
            },
            "gtin": "4013900501269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66c9",
            "leftCorner": {
              "x": -20.024,
              "y": -18.057,
              "z": 1.357
            },
            "rightCorner": {
              "x": -20.2,
              "y": -18.057,
              "z": 1.357
            },
            "gtin": "4013900501245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66ca",
            "leftCorner": {
              "x": -20.2,
              "y": -18.055,
              "z": 1.357
            },
            "rightCorner": {
              "x": -20.376,
              "y": -18.055,
              "z": 1.357
            },
            "gtin": "4013900501252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d66cb",
            "leftCorner": {
              "x": -20.376,
              "y": -18.051,
              "z": 1.357
            },
            "rightCorner": {
              "x": -20.555,
              "y": -18.052,
              "z": 1.357
            },
            "gtin": "4003754092006",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "4ed"
  },
  {
    "id": "4f0",
    "name": "4f0",
    "x": -25.305,
    "y": -19.359,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.005297,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 54,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1d5",
        "height": 0.15899,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67e0",
            "leftCorner": {
              "x": -25.304,
              "y": -19.466,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.681,
              "y": -19.459,
              "z": 0.13
            },
            "gtin": "4306188039167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67e2",
            "leftCorner": {
              "x": -24.681,
              "y": -19.419,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.251,
              "y": -19.415,
              "z": 0.13
            },
            "gtin": "4306188039174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67e3",
            "leftCorner": {
              "x": -24.251,
              "y": -19.418,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.054,
              "y": -19.416,
              "z": 0.13
            },
            "gtin": "8683655072213",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1d4",
        "height": 0.62764,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67d7",
            "leftCorner": {
              "x": -25.304,
              "y": -19.472,
              "z": 0.514
            },
            "rightCorner": {
              "x": -25.2,
              "y": -19.471,
              "z": 0.514
            },
            "gtin": "4770608255626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67d8",
            "leftCorner": {
              "x": -25.2,
              "y": -19.471,
              "z": 0.514
            },
            "rightCorner": {
              "x": -25.096,
              "y": -19.47,
              "z": 0.514
            },
            "gtin": "4770608255626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67da",
            "leftCorner": {
              "x": -25.096,
              "y": -19.428,
              "z": 0.514
            },
            "rightCorner": {
              "x": -24.907,
              "y": -19.426,
              "z": 0.514
            },
            "gtin": "4770608255640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67db",
            "leftCorner": {
              "x": -24.907,
              "y": -19.427,
              "z": 0.514
            },
            "rightCorner": {
              "x": -24.73,
              "y": -19.426,
              "z": 0.514
            },
            "gtin": "4770608255664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67dc",
            "leftCorner": {
              "x": -24.73,
              "y": -19.429,
              "z": 0.514
            },
            "rightCorner": {
              "x": -24.636,
              "y": -19.428,
              "z": 0.514
            },
            "gtin": "42263883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67dd",
            "leftCorner": {
              "x": -24.636,
              "y": -19.426,
              "z": 0.514
            },
            "rightCorner": {
              "x": -24.486,
              "y": -19.423,
              "z": 0.514
            },
            "gtin": "42263876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67de",
            "leftCorner": {
              "x": -24.486,
              "y": -19.415,
              "z": 0.514
            },
            "rightCorner": {
              "x": -24.306,
              "y": -19.414,
              "z": 0.514
            },
            "gtin": "42263906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67df",
            "leftCorner": {
              "x": -24.306,
              "y": -19.426,
              "z": 0.514
            },
            "rightCorner": {
              "x": -24.201,
              "y": -19.425,
              "z": 0.514
            },
            "gtin": "42263937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67d9",
            "leftCorner": {
              "x": -24.201,
              "y": -19.428,
              "z": 0.514
            },
            "rightCorner": {
              "x": -24.054,
              "y": -19.426,
              "z": 0.514
            },
            "gtin": "42263920",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1d3",
        "height": 0.9044,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67b5",
            "leftCorner": {
              "x": -25.304,
              "y": -19.468,
              "z": 0.74
            },
            "rightCorner": {
              "x": -25.229,
              "y": -19.467,
              "z": 0.74
            },
            "gtin": "4770608247409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67b6",
            "leftCorner": {
              "x": -25.229,
              "y": -19.467,
              "z": 0.74
            },
            "rightCorner": {
              "x": -25.153,
              "y": -19.467,
              "z": 0.74
            },
            "gtin": "4770608247409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67b8",
            "leftCorner": {
              "x": -25.153,
              "y": -19.426,
              "z": 0.74
            },
            "rightCorner": {
              "x": -25.103,
              "y": -19.425,
              "z": 0.74
            },
            "gtin": "3065890104440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67b9",
            "leftCorner": {
              "x": -25.103,
              "y": -19.425,
              "z": 0.74
            },
            "rightCorner": {
              "x": -25.019,
              "y": -19.424,
              "z": 0.74
            },
            "gtin": "4770608247386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67ba",
            "leftCorner": {
              "x": -25.019,
              "y": -19.424,
              "z": 0.74
            },
            "rightCorner": {
              "x": -24.925,
              "y": -19.423,
              "z": 0.74
            },
            "gtin": "4770608264376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67bb",
            "leftCorner": {
              "x": -24.925,
              "y": -19.421,
              "z": 0.74
            },
            "rightCorner": {
              "x": -24.818,
              "y": -19.42,
              "z": 0.74
            },
            "gtin": "4008429070013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67bc",
            "leftCorner": {
              "x": -24.818,
              "y": -19.428,
              "z": 0.74
            },
            "rightCorner": {
              "x": -24.727,
              "y": -19.428,
              "z": 0.74
            },
            "gtin": "4008429164408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67bd",
            "leftCorner": {
              "x": -24.727,
              "y": -19.424,
              "z": 0.74
            },
            "rightCorner": {
              "x": -24.623,
              "y": -19.423,
              "z": 0.74
            },
            "gtin": "4008429164415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67be",
            "leftCorner": {
              "x": -24.623,
              "y": -19.42,
              "z": 0.74
            },
            "rightCorner": {
              "x": -24.525,
              "y": -19.419,
              "z": 0.74
            },
            "gtin": "4008429164392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67bf",
            "leftCorner": {
              "x": -24.525,
              "y": -19.419,
              "z": 0.74
            },
            "rightCorner": {
              "x": -24.442,
              "y": -19.418,
              "z": 0.74
            },
            "gtin": "4008429164361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67c0",
            "leftCorner": {
              "x": -24.442,
              "y": -19.42,
              "z": 0.74
            },
            "rightCorner": {
              "x": -24.354,
              "y": -19.418,
              "z": 0.74
            },
            "gtin": "4008429164354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67c1",
            "leftCorner": {
              "x": -24.354,
              "y": -19.422,
              "z": 0.74
            },
            "rightCorner": {
              "x": -24.268,
              "y": -19.421,
              "z": 0.74
            },
            "gtin": "4008429164439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67c2",
            "leftCorner": {
              "x": -24.268,
              "y": -19.42,
              "z": 0.74
            },
            "rightCorner": {
              "x": -24.173,
              "y": -19.419,
              "z": 0.74
            },
            "gtin": "4008429069734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67c3",
            "leftCorner": {
              "x": -24.173,
              "y": -19.423,
              "z": 0.74
            },
            "rightCorner": {
              "x": -24.062,
              "y": -19.422,
              "z": 0.74
            },
            "gtin": "3065890131880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67c4",
            "leftCorner": {
              "x": -24.108,
              "y": -19.444,
              "z": 0.741
            },
            "rightCorner": {
              "x": -23.96,
              "y": -19.442,
              "z": 0.741
            },
            "gtin": "4008429069758",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1d1",
        "height": 1.1818,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6775",
            "leftCorner": {
              "x": -25.304,
              "y": -19.468,
              "z": 0.967
            },
            "rightCorner": {
              "x": -25.153,
              "y": -19.467,
              "z": 0.967
            },
            "gtin": "4770608264628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6777",
            "leftCorner": {
              "x": -25.153,
              "y": -19.427,
              "z": 0.967
            },
            "rightCorner": {
              "x": -25.017,
              "y": -19.425,
              "z": 0.967
            },
            "gtin": "4770608264529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6778",
            "leftCorner": {
              "x": -25.017,
              "y": -19.422,
              "z": 0.967
            },
            "rightCorner": {
              "x": -24.908,
              "y": -19.421,
              "z": 0.967
            },
            "gtin": "4770608249854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6779",
            "leftCorner": {
              "x": -24.908,
              "y": -19.422,
              "z": 0.967
            },
            "rightCorner": {
              "x": -24.805,
              "y": -19.421,
              "z": 0.967
            },
            "gtin": "4770608251758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d677a",
            "leftCorner": {
              "x": -24.805,
              "y": -19.429,
              "z": 0.967
            },
            "rightCorner": {
              "x": -24.712,
              "y": -19.428,
              "z": 0.967
            },
            "gtin": "3065890096820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d677b",
            "leftCorner": {
              "x": -24.712,
              "y": -19.424,
              "z": 0.967
            },
            "rightCorner": {
              "x": -24.618,
              "y": -19.424,
              "z": 0.967
            },
            "gtin": "3065890096806",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d677c",
            "leftCorner": {
              "x": -24.618,
              "y": -19.422,
              "z": 0.967
            },
            "rightCorner": {
              "x": -24.536,
              "y": -19.421,
              "z": 0.967
            },
            "gtin": "4008429069895",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d677d",
            "leftCorner": {
              "x": -24.536,
              "y": -19.418,
              "z": 0.967
            },
            "rightCorner": {
              "x": -24.443,
              "y": -19.417,
              "z": 0.967
            },
            "gtin": "4008429164026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d677e",
            "leftCorner": {
              "x": -24.443,
              "y": -19.417,
              "z": 0.967
            },
            "rightCorner": {
              "x": -24.357,
              "y": -19.416,
              "z": 0.967
            },
            "gtin": "4008429164057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d677f",
            "leftCorner": {
              "x": -24.357,
              "y": -19.422,
              "z": 0.967
            },
            "rightCorner": {
              "x": -24.266,
              "y": -19.421,
              "z": 0.967
            },
            "gtin": "4008429164002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6780",
            "leftCorner": {
              "x": -24.266,
              "y": -19.421,
              "z": 0.967
            },
            "rightCorner": {
              "x": -24.054,
              "y": -19.419,
              "z": 0.967
            },
            "gtin": "4008429083433",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1d2",
        "height": 1.4592,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6795",
            "leftCorner": {
              "x": -25.304,
              "y": -19.476,
              "z": 1.194
            },
            "rightCorner": {
              "x": -25.145,
              "y": -19.475,
              "z": 1.194
            },
            "gtin": "4770608263065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "02e16d1621539ebb6178bf7d",
            "leftCorner": {
              "x": -24.138,
              "y": -19.464,
              "z": 1.194
            },
            "rightCorner": {
              "x": -24.094,
              "y": -19.463,
              "z": 1.194
            },
            "gtin": "4770608266097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1767e71a485fba6e4baed389",
            "leftCorner": {
              "x": -24.094,
              "y": -19.463,
              "z": 1.194
            },
            "rightCorner": {
              "x": -24.055,
              "y": -19.463,
              "z": 1.194
            },
            "gtin": "4770608266097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6797",
            "leftCorner": {
              "x": -25.145,
              "y": -19.435,
              "z": 1.194
            },
            "rightCorner": {
              "x": -25.097,
              "y": -19.434,
              "z": 1.194
            },
            "gtin": "4770608263027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6798",
            "leftCorner": {
              "x": -25.097,
              "y": -19.433,
              "z": 1.194
            },
            "rightCorner": {
              "x": -25.015,
              "y": -19.432,
              "z": 1.194
            },
            "gtin": "4770608264352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6799",
            "leftCorner": {
              "x": -25.015,
              "y": -19.433,
              "z": 1.194
            },
            "rightCorner": {
              "x": -24.936,
              "y": -19.433,
              "z": 1.194
            },
            "gtin": "4008429134197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d679a",
            "leftCorner": {
              "x": -24.936,
              "y": -19.433,
              "z": 1.194
            },
            "rightCorner": {
              "x": -24.85,
              "y": -19.431,
              "z": 1.194
            },
            "gtin": "4008429134715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d679b",
            "leftCorner": {
              "x": -24.85,
              "y": -19.437,
              "z": 1.194
            },
            "rightCorner": {
              "x": -24.77,
              "y": -19.436,
              "z": 1.194
            },
            "gtin": "8853301003506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d679c",
            "leftCorner": {
              "x": -24.77,
              "y": -19.435,
              "z": 1.194
            },
            "rightCorner": {
              "x": -24.686,
              "y": -19.434,
              "z": 1.194
            },
            "gtin": "8853301003629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d679d",
            "leftCorner": {
              "x": -24.686,
              "y": -19.429,
              "z": 1.194
            },
            "rightCorner": {
              "x": -24.524,
              "y": -19.428,
              "z": 1.194
            },
            "gtin": "4008429140723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d679e",
            "leftCorner": {
              "x": -24.524,
              "y": -19.426,
              "z": 1.194
            },
            "rightCorner": {
              "x": -24.32,
              "y": -19.424,
              "z": 1.194
            },
            "gtin": "4770608264116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d679f",
            "leftCorner": {
              "x": -24.32,
              "y": -19.425,
              "z": 1.194
            },
            "rightCorner": {
              "x": -24.138,
              "y": -19.423,
              "z": 1.194
            },
            "gtin": "4770608264109",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1d0",
        "height": 1.7321,
        "facings": [
          {
            "id": "68d8e50be1820c81800d675a",
            "leftCorner": {
              "x": -25.304,
              "y": -19.471,
              "z": 1.417
            },
            "rightCorner": {
              "x": -25.204,
              "y": -19.47,
              "z": 1.417
            },
            "gtin": "2000439122012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d675c",
            "leftCorner": {
              "x": -25.204,
              "y": -19.431,
              "z": 1.417
            },
            "rightCorner": {
              "x": -25.12,
              "y": -19.43,
              "z": 1.417
            },
            "gtin": "5900951307546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d675d",
            "leftCorner": {
              "x": -25.12,
              "y": -19.429,
              "z": 1.417
            },
            "rightCorner": {
              "x": -24.941,
              "y": -19.427,
              "z": 1.417
            },
            "gtin": "4008429136030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d675e",
            "leftCorner": {
              "x": -24.941,
              "y": -19.423,
              "z": 1.417
            },
            "rightCorner": {
              "x": -24.74,
              "y": -19.421,
              "z": 1.417
            },
            "gtin": "8445290024060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d675f",
            "leftCorner": {
              "x": -24.74,
              "y": -19.428,
              "z": 1.417
            },
            "rightCorner": {
              "x": -24.33,
              "y": -19.423,
              "z": 1.417
            },
            "gtin": "8445290062239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6760",
            "leftCorner": {
              "x": -24.33,
              "y": -19.421,
              "z": 1.417
            },
            "rightCorner": {
              "x": -24.054,
              "y": -19.418,
              "z": 1.417
            },
            "gtin": "8445290062826",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "4f1"
  },
  {
    "id": "4f1",
    "name": "4f1",
    "x": -24.055,
    "y": -19.346,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.005297,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 59,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1db",
        "height": 0.16134,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67e4",
            "leftCorner": {
              "x": -24.055,
              "y": -19.399,
              "z": 0.132
            },
            "rightCorner": {
              "x": -23.971,
              "y": -19.4,
              "z": 0.132
            },
            "gtin": "4306188385059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67e5",
            "leftCorner": {
              "x": -23.971,
              "y": -19.387,
              "z": 0.132
            },
            "rightCorner": {
              "x": -23.862,
              "y": -19.387,
              "z": 0.132
            },
            "gtin": "4306188385059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67e6",
            "leftCorner": {
              "x": -23.861,
              "y": -19.389,
              "z": 0.132
            },
            "rightCorner": {
              "x": -23.757,
              "y": -19.387,
              "z": 0.132
            },
            "gtin": "4306188385028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67e7",
            "leftCorner": {
              "x": -23.757,
              "y": -19.389,
              "z": 0.132
            },
            "rightCorner": {
              "x": -23.658,
              "y": -19.388,
              "z": 0.132
            },
            "gtin": "4306188384960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67e8",
            "leftCorner": {
              "x": -23.658,
              "y": -19.391,
              "z": 0.132
            },
            "rightCorner": {
              "x": -23.553,
              "y": -19.39,
              "z": 0.132
            },
            "gtin": "4306188384991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67e9",
            "leftCorner": {
              "x": -23.553,
              "y": -19.391,
              "z": 0.132
            },
            "rightCorner": {
              "x": -23.158,
              "y": -19.388,
              "z": 0.132
            },
            "gtin": "4306188038436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67ea",
            "leftCorner": {
              "x": -23.157,
              "y": -19.398,
              "z": 0.132
            },
            "rightCorner": {
              "x": -22.952,
              "y": -19.395,
              "z": 0.132
            },
            "gtin": "4306188038405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67eb",
            "leftCorner": {
              "x": -22.951,
              "y": -19.398,
              "z": 0.132
            },
            "rightCorner": {
              "x": -22.749,
              "y": -19.397,
              "z": 0.132
            },
            "gtin": "4306188038375",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1d6",
        "height": 0.63981,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67f3",
            "leftCorner": {
              "x": -24.054,
              "y": -19.462,
              "z": 0.523
            },
            "rightCorner": {
              "x": -23.73,
              "y": -19.459,
              "z": 0.523
            },
            "gtin": "42263852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67f5",
            "leftCorner": {
              "x": -23.731,
              "y": -19.409,
              "z": 0.523
            },
            "rightCorner": {
              "x": -23.555,
              "y": -19.407,
              "z": 0.523
            },
            "gtin": "42263869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67f6",
            "leftCorner": {
              "x": -23.555,
              "y": -19.412,
              "z": 0.523
            },
            "rightCorner": {
              "x": -23.358,
              "y": -19.41,
              "z": 0.523
            },
            "gtin": "42263913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67f7",
            "leftCorner": {
              "x": -23.358,
              "y": -19.415,
              "z": 0.523
            },
            "rightCorner": {
              "x": -23.265,
              "y": -19.414,
              "z": 0.523
            },
            "gtin": "4260688851394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67f8",
            "leftCorner": {
              "x": -23.265,
              "y": -19.415,
              "z": 0.523
            },
            "rightCorner": {
              "x": -23.153,
              "y": -19.414,
              "z": 0.523
            },
            "gtin": "4260688851400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67f9",
            "leftCorner": {
              "x": -23.153,
              "y": -19.418,
              "z": 0.523
            },
            "rightCorner": {
              "x": -23.05,
              "y": -19.417,
              "z": 0.523
            },
            "gtin": "4260688851387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67fa",
            "leftCorner": {
              "x": -23.05,
              "y": -19.417,
              "z": 0.523
            },
            "rightCorner": {
              "x": -22.959,
              "y": -19.416,
              "z": 0.523
            },
            "gtin": "4260688851448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67fb",
            "leftCorner": {
              "x": -22.959,
              "y": -19.415,
              "z": 0.523
            },
            "rightCorner": {
              "x": -22.866,
              "y": -19.415,
              "z": 0.523
            },
            "gtin": "4260688851370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67fc",
            "leftCorner": {
              "x": -22.866,
              "y": -19.418,
              "z": 0.523
            },
            "rightCorner": {
              "x": -22.764,
              "y": -19.417,
              "z": 0.523
            },
            "gtin": "4260688851509",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1da",
        "height": 0.90577,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67c5",
            "leftCorner": {
              "x": -23.907,
              "y": -19.396,
              "z": 0.741
            },
            "rightCorner": {
              "x": -23.808,
              "y": -19.395,
              "z": 0.741
            },
            "gtin": "4008429069772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4cbaa8bd912e5f6e95cd8d19",
            "leftCorner": {
              "x": -24.055,
              "y": -19.446,
              "z": 0.741
            },
            "rightCorner": {
              "x": -23.949,
              "y": -19.445,
              "z": 0.741
            },
            "gtin": "4008429069758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67c6",
            "leftCorner": {
              "x": -23.808,
              "y": -19.395,
              "z": 0.741
            },
            "rightCorner": {
              "x": -23.723,
              "y": -19.394,
              "z": 0.741
            },
            "gtin": "4008429164309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67c7",
            "leftCorner": {
              "x": -23.723,
              "y": -19.396,
              "z": 0.741
            },
            "rightCorner": {
              "x": -23.578,
              "y": -19.396,
              "z": 0.741
            },
            "gtin": "7613287071125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67c8",
            "leftCorner": {
              "x": -23.578,
              "y": -19.398,
              "z": 0.741
            },
            "rightCorner": {
              "x": -23.453,
              "y": -19.396,
              "z": 0.741
            },
            "gtin": "7613287070067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67c9",
            "leftCorner": {
              "x": -23.453,
              "y": -19.397,
              "z": 0.741
            },
            "rightCorner": {
              "x": -23.365,
              "y": -19.396,
              "z": 0.741
            },
            "gtin": "40056500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67ca",
            "leftCorner": {
              "x": -23.365,
              "y": -19.401,
              "z": 0.741
            },
            "rightCorner": {
              "x": -23.27,
              "y": -19.4,
              "z": 0.741
            },
            "gtin": "7613033047428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67cb",
            "leftCorner": {
              "x": -23.27,
              "y": -19.4,
              "z": 0.741
            },
            "rightCorner": {
              "x": -23.161,
              "y": -19.398,
              "z": 0.741
            },
            "gtin": "8445290502438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67cc",
            "leftCorner": {
              "x": -23.161,
              "y": -19.4,
              "z": 0.741
            },
            "rightCorner": {
              "x": -23.027,
              "y": -19.399,
              "z": 0.741
            },
            "gtin": "3222270493871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67cd",
            "leftCorner": {
              "x": -23.027,
              "y": -19.401,
              "z": 0.741
            },
            "rightCorner": {
              "x": -22.906,
              "y": -19.4,
              "z": 0.741
            },
            "gtin": "3222270493864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67ce",
            "leftCorner": {
              "x": -22.906,
              "y": -19.402,
              "z": 0.741
            },
            "rightCorner": {
              "x": -22.776,
              "y": -19.4,
              "z": 0.741
            },
            "gtin": "7613032977085",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1d7",
        "height": 1.1832,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6781",
            "leftCorner": {
              "x": -24.055,
              "y": -19.408,
              "z": 0.968
            },
            "rightCorner": {
              "x": -23.991,
              "y": -19.41,
              "z": 0.968
            },
            "gtin": "4008429164422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6782",
            "leftCorner": {
              "x": -23.99,
              "y": -19.391,
              "z": 0.968
            },
            "rightCorner": {
              "x": -23.898,
              "y": -19.389,
              "z": 0.968
            },
            "gtin": "4008429164422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6783",
            "leftCorner": {
              "x": -23.898,
              "y": -19.391,
              "z": 0.968
            },
            "rightCorner": {
              "x": -23.799,
              "y": -19.39,
              "z": 0.968
            },
            "gtin": "4008429145421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6784",
            "leftCorner": {
              "x": -23.799,
              "y": -19.392,
              "z": 0.968
            },
            "rightCorner": {
              "x": -23.669,
              "y": -19.391,
              "z": 0.968
            },
            "gtin": "4008429070075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6785",
            "leftCorner": {
              "x": -23.669,
              "y": -19.393,
              "z": 0.968
            },
            "rightCorner": {
              "x": -23.537,
              "y": -19.392,
              "z": 0.968
            },
            "gtin": "7613035439726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6786",
            "leftCorner": {
              "x": -23.537,
              "y": -19.394,
              "z": 0.968
            },
            "rightCorner": {
              "x": -23.401,
              "y": -19.393,
              "z": 0.968
            },
            "gtin": "7613035439696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6787",
            "leftCorner": {
              "x": -23.401,
              "y": -19.398,
              "z": 0.968
            },
            "rightCorner": {
              "x": -23.259,
              "y": -19.396,
              "z": 0.968
            },
            "gtin": "7613035439856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6788",
            "leftCorner": {
              "x": -23.259,
              "y": -19.398,
              "z": 0.968
            },
            "rightCorner": {
              "x": -23.128,
              "y": -19.396,
              "z": 0.968
            },
            "gtin": "7613037939941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6789",
            "leftCorner": {
              "x": -23.127,
              "y": -19.4,
              "z": 0.968
            },
            "rightCorner": {
              "x": -22.999,
              "y": -19.399,
              "z": 0.968
            },
            "gtin": "7613037933994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d678a",
            "leftCorner": {
              "x": -22.999,
              "y": -19.4,
              "z": 0.968
            },
            "rightCorner": {
              "x": -22.903,
              "y": -19.4,
              "z": 0.968
            },
            "gtin": "7613032335816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d678b",
            "leftCorner": {
              "x": -22.903,
              "y": -19.402,
              "z": 0.968
            },
            "rightCorner": {
              "x": -22.772,
              "y": -19.4,
              "z": 0.968
            },
            "gtin": "40053974",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1d8",
        "height": 1.4605,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67a1",
            "leftCorner": {
              "x": -23.941,
              "y": -19.392,
              "z": 1.195
            },
            "rightCorner": {
              "x": -23.892,
              "y": -19.392,
              "z": 1.195
            },
            "gtin": "4770608266097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "91d32fe31ad7346bdb12b808",
            "leftCorner": {
              "x": -24.054,
              "y": -19.452,
              "z": 1.195
            },
            "rightCorner": {
              "x": -23.947,
              "y": -19.451,
              "z": 1.195
            },
            "gtin": "4032254780359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67a2",
            "leftCorner": {
              "x": -23.892,
              "y": -19.4,
              "z": 1.195
            },
            "rightCorner": {
              "x": -23.713,
              "y": -19.398,
              "z": 1.195
            },
            "gtin": "4770608259846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67a3",
            "leftCorner": {
              "x": -23.713,
              "y": -19.4,
              "z": 1.195
            },
            "rightCorner": {
              "x": -23.591,
              "y": -19.398,
              "z": 1.195
            },
            "gtin": "8445291527355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67a4",
            "leftCorner": {
              "x": -23.591,
              "y": -19.402,
              "z": 1.195
            },
            "rightCorner": {
              "x": -23.499,
              "y": -19.401,
              "z": 1.195
            },
            "gtin": "8445291537880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67a5",
            "leftCorner": {
              "x": -23.499,
              "y": -19.403,
              "z": 1.195
            },
            "rightCorner": {
              "x": -23.412,
              "y": -19.401,
              "z": 1.195
            },
            "gtin": "7613034580801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67a6",
            "leftCorner": {
              "x": -23.412,
              "y": -19.405,
              "z": 1.195
            },
            "rightCorner": {
              "x": -23.28,
              "y": -19.404,
              "z": 1.195
            },
            "gtin": "4262437742465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67a7",
            "leftCorner": {
              "x": -23.28,
              "y": -19.406,
              "z": 1.195
            },
            "rightCorner": {
              "x": -23.152,
              "y": -19.405,
              "z": 1.195
            },
            "gtin": "8005852750150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67a8",
            "leftCorner": {
              "x": -23.152,
              "y": -19.407,
              "z": 1.195
            },
            "rightCorner": {
              "x": -23.051,
              "y": -19.406,
              "z": 1.195
            },
            "gtin": "4032254780373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67a9",
            "leftCorner": {
              "x": -23.051,
              "y": -19.408,
              "z": 1.195
            },
            "rightCorner": {
              "x": -22.945,
              "y": -19.407,
              "z": 1.195
            },
            "gtin": "4032254780359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67aa",
            "leftCorner": {
              "x": -22.945,
              "y": -19.408,
              "z": 1.195
            },
            "rightCorner": {
              "x": -22.853,
              "y": -19.406,
              "z": 1.195
            },
            "gtin": "4032254780304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67ab",
            "leftCorner": {
              "x": -22.853,
              "y": -19.408,
              "z": 1.195
            },
            "rightCorner": {
              "x": -22.667,
              "y": -19.407,
              "z": 1.195
            },
            "gtin": "4260198529707",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1d9",
        "height": 1.7335,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6761",
            "leftCorner": {
              "x": -24.055,
              "y": -19.407,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.981,
              "y": -19.409,
              "z": 1.418
            },
            "gtin": "8445290062307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6762",
            "leftCorner": {
              "x": -23.981,
              "y": -19.394,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.844,
              "y": -19.393,
              "z": 1.418
            },
            "gtin": "8445290062307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6763",
            "leftCorner": {
              "x": -23.844,
              "y": -19.394,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.633,
              "y": -19.392,
              "z": 1.418
            },
            "gtin": "8445290014146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6764",
            "leftCorner": {
              "x": -23.633,
              "y": -19.398,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.445,
              "y": -19.396,
              "z": 1.418
            },
            "gtin": "8445290067227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6765",
            "leftCorner": {
              "x": -23.445,
              "y": -19.4,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.282,
              "y": -19.399,
              "z": 1.418
            },
            "gtin": "8445290023988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6766",
            "leftCorner": {
              "x": -23.282,
              "y": -19.403,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.035,
              "y": -19.4,
              "z": 1.418
            },
            "gtin": "8445290024015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6767",
            "leftCorner": {
              "x": -23.034,
              "y": -19.404,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.857,
              "y": -19.402,
              "z": 1.418
            },
            "gtin": "4008429114663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6768",
            "leftCorner": {
              "x": -22.857,
              "y": -19.406,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.745,
              "y": -19.404,
              "z": 1.418
            },
            "gtin": "4057767553368",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4f0",
    "rightNeighborShelfId": "4f2"
  },
  {
    "id": "4f2",
    "name": "4f2",
    "x": -22.802,
    "y": -19.34,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.012679,
      "w": 0.99992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 44,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1e1",
        "height": 0.16082,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67ec",
            "leftCorner": {
              "x": -22.744,
              "y": -19.408,
              "z": 0.132
            },
            "rightCorner": {
              "x": -22.469,
              "y": -19.401,
              "z": 0.132
            },
            "gtin": "4306188028819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67ed",
            "leftCorner": {
              "x": -22.469,
              "y": -19.395,
              "z": 0.132
            },
            "rightCorner": {
              "x": -22.264,
              "y": -19.39,
              "z": 0.132
            },
            "gtin": "4306188028758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67ee",
            "leftCorner": {
              "x": -22.264,
              "y": -19.388,
              "z": 0.132
            },
            "rightCorner": {
              "x": -21.72,
              "y": -19.374,
              "z": 0.132
            },
            "gtin": "4306188028789",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1dc",
        "height": 0.64024,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67fd",
            "leftCorner": {
              "x": -22.759,
              "y": -19.428,
              "z": 0.524
            },
            "rightCorner": {
              "x": -22.67,
              "y": -19.425,
              "z": 0.524
            },
            "gtin": "4036897211003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67fe",
            "leftCorner": {
              "x": -22.67,
              "y": -19.426,
              "z": 0.524
            },
            "rightCorner": {
              "x": -22.569,
              "y": -19.424,
              "z": 0.524
            },
            "gtin": "4036897221484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67ff",
            "leftCorner": {
              "x": -22.569,
              "y": -19.42,
              "z": 0.524
            },
            "rightCorner": {
              "x": -22.484,
              "y": -19.417,
              "z": 0.524
            },
            "gtin": "4036897210983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6800",
            "leftCorner": {
              "x": -22.483,
              "y": -19.416,
              "z": 0.524
            },
            "rightCorner": {
              "x": -22.398,
              "y": -19.413,
              "z": 0.524
            },
            "gtin": "4036897210976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6801",
            "leftCorner": {
              "x": -22.398,
              "y": -19.413,
              "z": 0.524
            },
            "rightCorner": {
              "x": -22.281,
              "y": -19.41,
              "z": 0.524
            },
            "gtin": "4036897215124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6802",
            "leftCorner": {
              "x": -22.281,
              "y": -19.41,
              "z": 0.524
            },
            "rightCorner": {
              "x": -22.146,
              "y": -19.405,
              "z": 0.524
            },
            "gtin": "4036897237652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6803",
            "leftCorner": {
              "x": -22.146,
              "y": -19.406,
              "z": 0.524
            },
            "rightCorner": {
              "x": -22.02,
              "y": -19.403,
              "z": 0.524
            },
            "gtin": "4036897237645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67f4",
            "leftCorner": {
              "x": -22.02,
              "y": -19.401,
              "z": 0.524
            },
            "rightCorner": {
              "x": -21.801,
              "y": -19.395,
              "z": 0.524
            },
            "gtin": "4036897213717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d332c0ce81edefc309777e32",
            "leftCorner": {
              "x": -22.798,
              "y": -19.463,
              "z": 0.524
            },
            "rightCorner": {
              "x": -22.764,
              "y": -19.462,
              "z": 0.524
            },
            "gtin": "4036897210983",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1e0",
        "height": 0.90539,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67cf",
            "leftCorner": {
              "x": -22.771,
              "y": -19.412,
              "z": 0.741
            },
            "rightCorner": {
              "x": -22.631,
              "y": -19.408,
              "z": 0.741
            },
            "gtin": "7613033045417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67d0",
            "leftCorner": {
              "x": -22.631,
              "y": -19.404,
              "z": 0.741
            },
            "rightCorner": {
              "x": -22.506,
              "y": -19.401,
              "z": 0.741
            },
            "gtin": "40053981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67d1",
            "leftCorner": {
              "x": -22.506,
              "y": -19.398,
              "z": 0.741
            },
            "rightCorner": {
              "x": -22.398,
              "y": -19.395,
              "z": 0.741
            },
            "gtin": "4000487225923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67d2",
            "leftCorner": {
              "x": -22.398,
              "y": -19.395,
              "z": 0.741
            },
            "rightCorner": {
              "x": -22.304,
              "y": -19.393,
              "z": 0.741
            },
            "gtin": "7613036136662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67d3",
            "leftCorner": {
              "x": -22.304,
              "y": -19.393,
              "z": 0.741
            },
            "rightCorner": {
              "x": -22.215,
              "y": -19.391,
              "z": 0.741
            },
            "gtin": "7613036136129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67d4",
            "leftCorner": {
              "x": -22.215,
              "y": -19.386,
              "z": 0.741
            },
            "rightCorner": {
              "x": -22.113,
              "y": -19.383,
              "z": 0.741
            },
            "gtin": "7613036136105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67d5",
            "leftCorner": {
              "x": -22.113,
              "y": -19.383,
              "z": 0.741
            },
            "rightCorner": {
              "x": -22.009,
              "y": -19.38,
              "z": 0.741
            },
            "gtin": "7613287920720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67d6",
            "leftCorner": {
              "x": -22.009,
              "y": -19.38,
              "z": 0.741
            },
            "rightCorner": {
              "x": -21.906,
              "y": -19.378,
              "z": 0.741
            },
            "gtin": "7613033578137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67b7",
            "leftCorner": {
              "x": -21.907,
              "y": -19.373,
              "z": 0.741
            },
            "rightCorner": {
              "x": -21.801,
              "y": -19.37,
              "z": 0.741
            },
            "gtin": "7613033058103",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1de",
        "height": 1.1831,
        "facings": [
          {
            "id": "68d8e50be1820c81800d678c",
            "leftCorner": {
              "x": -22.767,
              "y": -19.411,
              "z": 0.968
            },
            "rightCorner": {
              "x": -22.63,
              "y": -19.408,
              "z": 0.968
            },
            "gtin": "8445290986344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d678d",
            "leftCorner": {
              "x": -22.63,
              "y": -19.403,
              "z": 0.968
            },
            "rightCorner": {
              "x": -22.499,
              "y": -19.4,
              "z": 0.968
            },
            "gtin": "8445290986269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d678e",
            "leftCorner": {
              "x": -22.499,
              "y": -19.398,
              "z": 0.968
            },
            "rightCorner": {
              "x": -22.41,
              "y": -19.396,
              "z": 0.968
            },
            "gtin": "7613034451804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d678f",
            "leftCorner": {
              "x": -22.41,
              "y": -19.393,
              "z": 0.968
            },
            "rightCorner": {
              "x": -22.318,
              "y": -19.391,
              "z": 0.968
            },
            "gtin": "7613034452634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6790",
            "leftCorner": {
              "x": -22.318,
              "y": -19.388,
              "z": 0.968
            },
            "rightCorner": {
              "x": -22.234,
              "y": -19.386,
              "z": 0.968
            },
            "gtin": "7613034460981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6791",
            "leftCorner": {
              "x": -22.234,
              "y": -19.386,
              "z": 0.968
            },
            "rightCorner": {
              "x": -22.146,
              "y": -19.384,
              "z": 0.968
            },
            "gtin": "7613034452672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6792",
            "leftCorner": {
              "x": -22.146,
              "y": -19.383,
              "z": 0.968
            },
            "rightCorner": {
              "x": -22.055,
              "y": -19.381,
              "z": 0.968
            },
            "gtin": "7613035926363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6793",
            "leftCorner": {
              "x": -22.056,
              "y": -19.378,
              "z": 0.968
            },
            "rightCorner": {
              "x": -21.961,
              "y": -19.376,
              "z": 0.968
            },
            "gtin": "7613033579158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6794",
            "leftCorner": {
              "x": -21.961,
              "y": -19.374,
              "z": 0.968
            },
            "rightCorner": {
              "x": -21.863,
              "y": -19.372,
              "z": 0.968
            },
            "gtin": "7613033057991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6776",
            "leftCorner": {
              "x": -21.863,
              "y": -19.366,
              "z": 0.968
            },
            "rightCorner": {
              "x": -21.801,
              "y": -19.364,
              "z": 0.968
            },
            "gtin": "7613033058059",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1dd",
        "height": 1.4612,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67ac",
            "leftCorner": {
              "x": -22.663,
              "y": -19.413,
              "z": 1.196
            },
            "rightCorner": {
              "x": -22.541,
              "y": -19.41,
              "z": 1.196
            },
            "gtin": "8445290298003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67ad",
            "leftCorner": {
              "x": -22.541,
              "y": -19.406,
              "z": 1.196
            },
            "rightCorner": {
              "x": -22.454,
              "y": -19.404,
              "z": 1.196
            },
            "gtin": "4032254750543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67ae",
            "leftCorner": {
              "x": -22.454,
              "y": -19.402,
              "z": 1.196
            },
            "rightCorner": {
              "x": -22.357,
              "y": -19.4,
              "z": 1.196
            },
            "gtin": "8410136010163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67b1",
            "leftCorner": {
              "x": -22.246,
              "y": -19.397,
              "z": 1.196
            },
            "rightCorner": {
              "x": -22.151,
              "y": -19.395,
              "z": 1.196
            },
            "gtin": "8710255200545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67b2",
            "leftCorner": {
              "x": -22.151,
              "y": -19.394,
              "z": 1.196
            },
            "rightCorner": {
              "x": -22.057,
              "y": -19.391,
              "z": 1.196
            },
            "gtin": "8710255100098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67b3",
            "leftCorner": {
              "x": -22.057,
              "y": -19.386,
              "z": 1.196
            },
            "rightCorner": {
              "x": -21.961,
              "y": -19.383,
              "z": 1.196
            },
            "gtin": "8710255200521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67b4",
            "leftCorner": {
              "x": -21.961,
              "y": -19.382,
              "z": 1.196
            },
            "rightCorner": {
              "x": -21.867,
              "y": -19.38,
              "z": 1.196
            },
            "gtin": "8710255100029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6796",
            "leftCorner": {
              "x": -21.867,
              "y": -19.373,
              "z": 1.196
            },
            "rightCorner": {
              "x": -21.801,
              "y": -19.371,
              "z": 1.196
            },
            "gtin": "8710255167121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f2a8fdebfec0b43ef9966939",
            "leftCorner": {
              "x": -22.799,
              "y": -19.449,
              "z": 1.196
            },
            "rightCorner": {
              "x": -22.696,
              "y": -19.446,
              "z": 1.196
            },
            "gtin": "8410136010149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d5b9f026dce336cab3cafaa7",
            "leftCorner": {
              "x": -22.356,
              "y": -19.438,
              "z": 1.196
            },
            "rightCorner": {
              "x": -22.246,
              "y": -19.435,
              "z": 1.196
            },
            "gtin": "8445290298003",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1df",
        "height": 1.7329,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6769",
            "leftCorner": {
              "x": -22.74,
              "y": -19.409,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.546,
              "y": -19.405,
              "z": 1.418
            },
            "gtin": "4057767553405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d676a",
            "leftCorner": {
              "x": -22.546,
              "y": -19.4,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.884,
              "y": -19.383,
              "z": 1.418
            },
            "gtin": "4306188049968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d676b",
            "leftCorner": {
              "x": -21.885,
              "y": -19.373,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.581,
              "y": -19.365,
              "z": 1.418
            },
            "gtin": "4024109942722",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4f1",
    "rightNeighborShelfId": "4f4"
  },
  {
    "id": "4f4",
    "name": "4f4",
    "x": -21.802,
    "y": -19.315,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.012679,
      "w": 0.99992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 31,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1e6",
        "height": 0.15899,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67ef",
            "leftCorner": {
              "x": -21.721,
              "y": -19.363,
              "z": 0.13
            },
            "rightCorner": {
              "x": -21.137,
              "y": -19.349,
              "z": 0.13
            },
            "gtin": "4024109001849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "390011add9dc1e9b84ee84bd",
            "leftCorner": {
              "x": -21.799,
              "y": -19.418,
              "z": 0.13
            },
            "rightCorner": {
              "x": -21.723,
              "y": -19.416,
              "z": 0.13
            },
            "gtin": "4036897227363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67f0",
            "leftCorner": {
              "x": -21.137,
              "y": -19.346,
              "z": 0.13
            },
            "rightCorner": {
              "x": -21.046,
              "y": -19.343,
              "z": 0.13
            },
            "gtin": "4036897227363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67f1",
            "leftCorner": {
              "x": -21.046,
              "y": -19.377,
              "z": 0.13
            },
            "rightCorner": {
              "x": -20.637,
              "y": -19.367,
              "z": 0.13
            },
            "gtin": "4024109950321",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1e5",
        "height": 0.75353,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6822",
            "leftCorner": {
              "x": -21.8,
              "y": -19.405,
              "z": 0.617
            },
            "rightCorner": {
              "x": -21.45,
              "y": -19.396,
              "z": 0.617
            },
            "gtin": "4024109939234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6824",
            "leftCorner": {
              "x": -21.452,
              "y": -19.352,
              "z": 0.617
            },
            "rightCorner": {
              "x": -21.231,
              "y": -19.346,
              "z": 0.617
            },
            "gtin": "4024109939227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6825",
            "leftCorner": {
              "x": -21.232,
              "y": -19.35,
              "z": 0.617
            },
            "rightCorner": {
              "x": -21.106,
              "y": -19.346,
              "z": 0.617
            },
            "gtin": "4024109938824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6826",
            "leftCorner": {
              "x": -21.107,
              "y": -19.35,
              "z": 0.617
            },
            "rightCorner": {
              "x": -20.919,
              "y": -19.346,
              "z": 0.617
            },
            "gtin": "4024109938121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6827",
            "leftCorner": {
              "x": -20.919,
              "y": -19.349,
              "z": 0.617
            },
            "rightCorner": {
              "x": -20.662,
              "y": -19.342,
              "z": 0.617
            },
            "gtin": "4036897213434",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1e3",
        "height": 1.0574,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6812",
            "leftCorner": {
              "x": -21.8,
              "y": -19.401,
              "z": 0.865
            },
            "rightCorner": {
              "x": -21.581,
              "y": -19.395,
              "z": 0.865
            },
            "gtin": "4008239255808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6814",
            "leftCorner": {
              "x": -21.582,
              "y": -19.355,
              "z": 0.865
            },
            "rightCorner": {
              "x": -21.472,
              "y": -19.353,
              "z": 0.865
            },
            "gtin": "4008239255983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6815",
            "leftCorner": {
              "x": -21.472,
              "y": -19.348,
              "z": 0.865
            },
            "rightCorner": {
              "x": -21.338,
              "y": -19.344,
              "z": 0.865
            },
            "gtin": "4008239258854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6816",
            "leftCorner": {
              "x": -21.338,
              "y": -19.346,
              "z": 0.865
            },
            "rightCorner": {
              "x": -21.239,
              "y": -19.344,
              "z": 0.865
            },
            "gtin": "4008239252265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6817",
            "leftCorner": {
              "x": -21.239,
              "y": -19.347,
              "z": 0.865
            },
            "rightCorner": {
              "x": -21.153,
              "y": -19.344,
              "z": 0.865
            },
            "gtin": "4008239250155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6818",
            "leftCorner": {
              "x": -21.154,
              "y": -19.35,
              "z": 0.865
            },
            "rightCorner": {
              "x": -21.063,
              "y": -19.348,
              "z": 0.865
            },
            "gtin": "4008239250186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6819",
            "leftCorner": {
              "x": -21.064,
              "y": -19.35,
              "z": 0.865
            },
            "rightCorner": {
              "x": -20.924,
              "y": -19.347,
              "z": 0.865
            },
            "gtin": "4008239252272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d681a",
            "leftCorner": {
              "x": -20.924,
              "y": -19.347,
              "z": 0.865
            },
            "rightCorner": {
              "x": -20.756,
              "y": -19.343,
              "z": 0.865
            },
            "gtin": "4008239255822",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1e2",
        "height": 1.3625,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6804",
            "leftCorner": {
              "x": -21.8,
              "y": -19.407,
              "z": 1.115
            },
            "rightCorner": {
              "x": -21.64,
              "y": -19.403,
              "z": 1.115
            },
            "gtin": "4008239214430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6806",
            "leftCorner": {
              "x": -21.64,
              "y": -19.367,
              "z": 1.115
            },
            "rightCorner": {
              "x": -21.565,
              "y": -19.365,
              "z": 1.115
            },
            "gtin": "4008239212313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6807",
            "leftCorner": {
              "x": -21.565,
              "y": -19.365,
              "z": 1.115
            },
            "rightCorner": {
              "x": -21.479,
              "y": -19.363,
              "z": 1.115
            },
            "gtin": "4008239212634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6808",
            "leftCorner": {
              "x": -21.479,
              "y": -19.353,
              "z": 1.115
            },
            "rightCorner": {
              "x": -21.393,
              "y": -19.35,
              "z": 1.115
            },
            "gtin": "4008239212375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6809",
            "leftCorner": {
              "x": -21.393,
              "y": -19.349,
              "z": 1.115
            },
            "rightCorner": {
              "x": -21.308,
              "y": -19.348,
              "z": 1.115
            },
            "gtin": "4008239212894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d680a",
            "leftCorner": {
              "x": -21.308,
              "y": -19.354,
              "z": 1.115
            },
            "rightCorner": {
              "x": -21.166,
              "y": -19.35,
              "z": 1.115
            },
            "gtin": "4024109000811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d680b",
            "leftCorner": {
              "x": -21.166,
              "y": -19.352,
              "z": 1.115
            },
            "rightCorner": {
              "x": -21.02,
              "y": -19.349,
              "z": 1.115
            },
            "gtin": "4024109932426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d680c",
            "leftCorner": {
              "x": -21.021,
              "y": -19.353,
              "z": 1.115
            },
            "rightCorner": {
              "x": -20.905,
              "y": -19.35,
              "z": 1.115
            },
            "gtin": "4024109931627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d680d",
            "leftCorner": {
              "x": -20.905,
              "y": -19.35,
              "z": 1.115
            },
            "rightCorner": {
              "x": -20.746,
              "y": -19.346,
              "z": 1.115
            },
            "gtin": "4024109931429",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1e4",
        "height": 1.7349,
        "facings": [
          {
            "id": "68d8e50be1820c81800d676c",
            "leftCorner": {
              "x": -21.581,
              "y": -19.355,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.429,
              "y": -19.351,
              "z": 1.419
            },
            "gtin": "4024109003942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9d595b7e54de13b6eeb0da05",
            "leftCorner": {
              "x": -21.8,
              "y": -19.4,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.598,
              "y": -19.395,
              "z": 1.419
            },
            "gtin": "4024109000439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d676d",
            "leftCorner": {
              "x": -21.43,
              "y": -19.348,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.241,
              "y": -19.343,
              "z": 1.419
            },
            "gtin": "4024109000439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d676e",
            "leftCorner": {
              "x": -21.241,
              "y": -19.347,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.092,
              "y": -19.344,
              "z": 1.419
            },
            "gtin": "4024109942227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d676f",
            "leftCorner": {
              "x": -21.092,
              "y": -19.348,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.746,
              "y": -19.339,
              "z": 1.419
            },
            "gtin": "4024109000743",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4f2",
    "rightNeighborShelfId": "4f5"
  },
  {
    "id": "4f5",
    "name": "4f5",
    "x": -20.803,
    "y": -19.289,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.012679,
      "w": 0.99992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 30,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6f8",
        "height": 0.16749,
        "facings": [
          {
            "id": "68d8e50be1820c81800d67f2",
            "leftCorner": {
              "x": -20.639,
              "y": -19.349,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.374,
              "y": -19.343,
              "z": 0.137
            },
            "gtin": "4024109950239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d67e1",
            "leftCorner": {
              "x": -20.374,
              "y": -19.339,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.802,
              "y": -19.324,
              "z": 0.137
            },
            "gtin": "4036897311635",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6f5",
        "height": 0.75312,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6828",
            "leftCorner": {
              "x": -20.664,
              "y": -19.346,
              "z": 0.616
            },
            "rightCorner": {
              "x": -20.568,
              "y": -19.343,
              "z": 0.616
            },
            "gtin": "4036897227288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6829",
            "leftCorner": {
              "x": -20.568,
              "y": -19.347,
              "z": 0.616
            },
            "rightCorner": {
              "x": -20.41,
              "y": -19.343,
              "z": 0.616
            },
            "gtin": "4036897208751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d682a",
            "leftCorner": {
              "x": -20.41,
              "y": -19.34,
              "z": 0.616
            },
            "rightCorner": {
              "x": -20.261,
              "y": -19.337,
              "z": 0.616
            },
            "gtin": "4036897227387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d682b",
            "leftCorner": {
              "x": -20.261,
              "y": -19.332,
              "z": 0.616
            },
            "rightCorner": {
              "x": -20.113,
              "y": -19.327,
              "z": 0.616
            },
            "gtin": "4036897205736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d682c",
            "leftCorner": {
              "x": -20.114,
              "y": -19.32,
              "z": 0.616
            },
            "rightCorner": {
              "x": -20.057,
              "y": -19.32,
              "z": 0.616
            },
            "gtin": "42149170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d682d",
            "leftCorner": {
              "x": -20.056,
              "y": -19.321,
              "z": 0.616
            },
            "rightCorner": {
              "x": -19.961,
              "y": -19.318,
              "z": 0.616
            },
            "gtin": "4036897233241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d682e",
            "leftCorner": {
              "x": -19.961,
              "y": -19.318,
              "z": 0.616
            },
            "rightCorner": {
              "x": -19.868,
              "y": -19.316,
              "z": 0.616
            },
            "gtin": "4036897227226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6823",
            "leftCorner": {
              "x": -19.868,
              "y": -19.321,
              "z": 0.616
            },
            "rightCorner": {
              "x": -19.802,
              "y": -19.319,
              "z": 0.616
            },
            "gtin": "4036897233180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e03ba3e42a1ce3a0b52e0c4b",
            "leftCorner": {
              "x": -20.801,
              "y": -19.385,
              "z": 0.616
            },
            "rightCorner": {
              "x": -20.7,
              "y": -19.382,
              "z": 0.616
            },
            "gtin": "4036897227288",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6f7",
        "height": 1.0575,
        "facings": [
          {
            "id": "68d8e50be1820c81800d681b",
            "leftCorner": {
              "x": -20.758,
              "y": -19.349,
              "z": 0.865
            },
            "rightCorner": {
              "x": -20.675,
              "y": -19.347,
              "z": 0.865
            },
            "gtin": "4008239251244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d681c",
            "leftCorner": {
              "x": -20.675,
              "y": -19.344,
              "z": 0.865
            },
            "rightCorner": {
              "x": -20.588,
              "y": -19.341,
              "z": 0.865
            },
            "gtin": "4008239256690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d681d",
            "leftCorner": {
              "x": -20.588,
              "y": -19.343,
              "z": 0.865
            },
            "rightCorner": {
              "x": -20.442,
              "y": -19.339,
              "z": 0.865
            },
            "gtin": "4008239252470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d681e",
            "leftCorner": {
              "x": -20.442,
              "y": -19.337,
              "z": 0.865
            },
            "rightCorner": {
              "x": -20.35,
              "y": -19.334,
              "z": 0.865
            },
            "gtin": "4008239256737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d681f",
            "leftCorner": {
              "x": -20.35,
              "y": -19.334,
              "z": 0.865
            },
            "rightCorner": {
              "x": -20.176,
              "y": -19.33,
              "z": 0.865
            },
            "gtin": "4008239250636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6820",
            "leftCorner": {
              "x": -20.176,
              "y": -19.325,
              "z": 0.865
            },
            "rightCorner": {
              "x": -20.05,
              "y": -19.321,
              "z": 0.865
            },
            "gtin": "4008239384393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6821",
            "leftCorner": {
              "x": -20.051,
              "y": -19.317,
              "z": 0.865
            },
            "rightCorner": {
              "x": -19.899,
              "y": -19.314,
              "z": 0.865
            },
            "gtin": "4008239224699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6813",
            "leftCorner": {
              "x": -19.898,
              "y": -19.317,
              "z": 0.865
            },
            "rightCorner": {
              "x": -19.802,
              "y": -19.314,
              "z": 0.865
            },
            "gtin": "4024109000019",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6f6",
        "height": 1.3622,
        "facings": [
          {
            "id": "68d8e50be1820c81800d680e",
            "leftCorner": {
              "x": -20.748,
              "y": -19.353,
              "z": 1.115
            },
            "rightCorner": {
              "x": -20.648,
              "y": -19.35,
              "z": 1.115
            },
            "gtin": "4036897233302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d680f",
            "leftCorner": {
              "x": -20.648,
              "y": -19.346,
              "z": 1.115
            },
            "rightCorner": {
              "x": -20.559,
              "y": -19.344,
              "z": 1.115
            },
            "gtin": "4036897233364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6810",
            "leftCorner": {
              "x": -20.559,
              "y": -19.349,
              "z": 1.115
            },
            "rightCorner": {
              "x": -20.126,
              "y": -19.338,
              "z": 1.115
            },
            "gtin": "4024109004826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6811",
            "leftCorner": {
              "x": -20.125,
              "y": -19.327,
              "z": 1.115
            },
            "rightCorner": {
              "x": -19.977,
              "y": -19.324,
              "z": 1.115
            },
            "gtin": "4024109004307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6805",
            "leftCorner": {
              "x": -19.977,
              "y": -19.327,
              "z": 1.115
            },
            "rightCorner": {
              "x": -19.802,
              "y": -19.322,
              "z": 1.115
            },
            "gtin": "4024109943521",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6f9",
        "height": 1.7332,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6770",
            "leftCorner": {
              "x": -20.747,
              "y": -19.346,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.45,
              "y": -19.338,
              "z": 1.418
            },
            "gtin": "4024109000361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6771",
            "leftCorner": {
              "x": -20.45,
              "y": -19.339,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.323,
              "y": -19.337,
              "z": 1.418
            },
            "gtin": "4251292864351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6772",
            "leftCorner": {
              "x": -20.323,
              "y": -19.333,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.175,
              "y": -19.33,
              "z": 1.418
            },
            "gtin": "4251292864115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6773",
            "leftCorner": {
              "x": -20.175,
              "y": -19.322,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.023,
              "y": -19.317,
              "z": 1.418
            },
            "gtin": "4251292864108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6774",
            "leftCorner": {
              "x": -20.023,
              "y": -19.317,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.902,
              "y": -19.314,
              "z": 1.418
            },
            "gtin": "4251292880344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d675b",
            "leftCorner": {
              "x": -19.901,
              "y": -19.318,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.802,
              "y": -19.315,
              "z": 1.418
            },
            "gtin": "4251292880139",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4f4"
  },
  {
    "id": "4f6",
    "name": "4f6",
    "x": -19.685,
    "y": -19.284,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70471,
      "w": 0.7095
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 41,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6fe",
        "height": 0.15755,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68e7",
            "leftCorner": {
              "x": -19.79,
              "y": -19.284,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.787,
              "y": -19.775,
              "z": 0.129
            },
            "gtin": "3065890152885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68e9",
            "leftCorner": {
              "x": -19.745,
              "y": -19.775,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.741,
              "y": -20.294,
              "z": 0.129
            },
            "gtin": "3065890134966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68ea",
            "leftCorner": {
              "x": -19.746,
              "y": -20.294,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.743,
              "y": -20.823,
              "z": 0.129
            },
            "gtin": "4008429161926",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6ff",
        "height": 0.50405,
        "facings": [
          {
            "id": "68d8e50be1820c81800d682f",
            "leftCorner": {
              "x": -19.8,
              "y": -19.284,
              "z": 0.412
            },
            "rightCorner": {
              "x": -19.798,
              "y": -19.619,
              "z": 0.412
            },
            "gtin": "4008429055973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6830",
            "leftCorner": {
              "x": -19.798,
              "y": -19.619,
              "z": 0.412
            },
            "rightCorner": {
              "x": -19.796,
              "y": -19.953,
              "z": 0.412
            },
            "gtin": "4008429055973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6832",
            "leftCorner": {
              "x": -19.752,
              "y": -19.953,
              "z": 0.412
            },
            "rightCorner": {
              "x": -19.752,
              "y": -19.986,
              "z": 0.412
            },
            "gtin": "4008429056109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6833",
            "leftCorner": {
              "x": -19.437,
              "y": -19.983,
              "z": 0.412
            },
            "rightCorner": {
              "x": -19.436,
              "y": -20.079,
              "z": 0.412
            },
            "gtin": "4032254780397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6834",
            "leftCorner": {
              "x": -19.752,
              "y": -20.081,
              "z": 0.412
            },
            "rightCorner": {
              "x": -19.752,
              "y": -20.197,
              "z": 0.412
            },
            "gtin": "4032254780397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6835",
            "leftCorner": {
              "x": -19.755,
              "y": -20.197,
              "z": 0.412
            },
            "rightCorner": {
              "x": -19.753,
              "y": -20.327,
              "z": 0.412
            },
            "gtin": "4032254780434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6836",
            "leftCorner": {
              "x": -19.753,
              "y": -20.327,
              "z": 0.412
            },
            "rightCorner": {
              "x": -19.753,
              "y": -20.413,
              "z": 0.412
            },
            "gtin": "4032254780410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6837",
            "leftCorner": {
              "x": -19.754,
              "y": -20.413,
              "z": 0.412
            },
            "rightCorner": {
              "x": -19.752,
              "y": -20.638,
              "z": 0.412
            },
            "gtin": "4032254745570",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6fd",
        "height": 0.80373,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6895",
            "leftCorner": {
              "x": -19.791,
              "y": -19.284,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.79,
              "y": -19.472,
              "z": 0.658
            },
            "gtin": "3065890133471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6897",
            "leftCorner": {
              "x": -19.756,
              "y": -19.472,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.755,
              "y": -19.691,
              "z": 0.658
            },
            "gtin": "5900951320415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6898",
            "leftCorner": {
              "x": -19.746,
              "y": -19.691,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.744,
              "y": -19.949,
              "z": 0.658
            },
            "gtin": "3065890159815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6899",
            "leftCorner": {
              "x": -19.747,
              "y": -19.949,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.745,
              "y": -20.325,
              "z": 0.658
            },
            "gtin": "4008429001451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d689a",
            "leftCorner": {
              "x": -19.748,
              "y": -20.325,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.746,
              "y": -20.565,
              "z": 0.658
            },
            "gtin": "4008429813702",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6fc",
        "height": 1.1082,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6872",
            "leftCorner": {
              "x": -19.791,
              "y": -19.284,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.79,
              "y": -19.438,
              "z": 0.907
            },
            "gtin": "5998749139639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6874",
            "leftCorner": {
              "x": -19.755,
              "y": -19.437,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.755,
              "y": -19.611,
              "z": 0.907
            },
            "gtin": "5998749139851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6875",
            "leftCorner": {
              "x": -19.75,
              "y": -19.611,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.748,
              "y": -19.776,
              "z": 0.907
            },
            "gtin": "5998749139950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6876",
            "leftCorner": {
              "x": -19.743,
              "y": -19.776,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.742,
              "y": -19.914,
              "z": 0.907
            },
            "gtin": "5010394003599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6877",
            "leftCorner": {
              "x": -19.747,
              "y": -19.914,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.745,
              "y": -20.102,
              "z": 0.907
            },
            "gtin": "5998749140512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6878",
            "leftCorner": {
              "x": -19.445,
              "y": -20.108,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.444,
              "y": -20.267,
              "z": 0.907
            },
            "gtin": "5998749139400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6879",
            "leftCorner": {
              "x": -19.748,
              "y": -20.269,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.747,
              "y": -20.381,
              "z": 0.907
            },
            "gtin": "5998749139325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d687a",
            "leftCorner": {
              "x": -19.746,
              "y": -20.381,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.744,
              "y": -20.65,
              "z": 0.907
            },
            "gtin": "5998749125588",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6fa",
        "height": 1.3875,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6849",
            "leftCorner": {
              "x": -19.795,
              "y": -19.284,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.794,
              "y": -19.365,
              "z": 1.135
            },
            "gtin": "4036897214127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d684b",
            "leftCorner": {
              "x": -19.763,
              "y": -19.365,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.762,
              "y": -19.525,
              "z": 1.135
            },
            "gtin": "4048422144632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d684c",
            "leftCorner": {
              "x": -19.757,
              "y": -19.524,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.756,
              "y": -19.682,
              "z": 1.135
            },
            "gtin": "4048422144663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d684d",
            "leftCorner": {
              "x": -19.748,
              "y": -19.682,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.747,
              "y": -19.824,
              "z": 1.135
            },
            "gtin": "4251276205255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d684e",
            "leftCorner": {
              "x": -19.742,
              "y": -19.824,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.742,
              "y": -19.923,
              "z": 1.135
            },
            "gtin": "4251276204265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d684f",
            "leftCorner": {
              "x": -19.749,
              "y": -19.923,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.748,
              "y": -20.025,
              "z": 1.135
            },
            "gtin": "4251276204357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6850",
            "leftCorner": {
              "x": -19.751,
              "y": -20.025,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.75,
              "y": -20.128,
              "z": 1.135
            },
            "gtin": "4251276205521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6851",
            "leftCorner": {
              "x": -19.751,
              "y": -20.128,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.751,
              "y": -20.259,
              "z": 1.135
            },
            "gtin": "5998749147290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6852",
            "leftCorner": {
              "x": -19.751,
              "y": -20.259,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.75,
              "y": -20.4,
              "z": 1.135
            },
            "gtin": "4008429131868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6853",
            "leftCorner": {
              "x": -19.752,
              "y": -20.4,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.75,
              "y": -20.664,
              "z": 1.135
            },
            "gtin": "5010394984577",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6fb",
        "height": 1.7333,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68bb",
            "leftCorner": {
              "x": -19.787,
              "y": -19.284,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.786,
              "y": -19.391,
              "z": 1.418
            },
            "gtin": "4048422102472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68bd",
            "leftCorner": {
              "x": -19.755,
              "y": -19.391,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.754,
              "y": -19.497,
              "z": 1.418
            },
            "gtin": "4048422110668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68be",
            "leftCorner": {
              "x": -19.75,
              "y": -19.497,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.75,
              "y": -19.664,
              "z": 1.418
            },
            "gtin": "4251276203725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68bf",
            "leftCorner": {
              "x": -19.744,
              "y": -19.664,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.742,
              "y": -19.904,
              "z": 1.418
            },
            "gtin": "4251276202735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68c0",
            "leftCorner": {
              "x": -19.741,
              "y": -19.904,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.74,
              "y": -20.096,
              "z": 1.418
            },
            "gtin": "4251276200540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68c1",
            "leftCorner": {
              "x": -19.745,
              "y": -20.096,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.744,
              "y": -20.335,
              "z": 1.418
            },
            "gtin": "4251276205132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68c2",
            "leftCorner": {
              "x": -19.743,
              "y": -20.335,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.741,
              "y": -20.627,
              "z": 1.418
            },
            "gtin": "4251276201264",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "4f8"
  },
  {
    "id": "4f7",
    "name": "4f7",
    "x": -25.976,
    "y": -18.066,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70396,
      "w": 0.71024
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 4,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d702",
        "height": 1.3089,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8734",
            "leftCorner": {
              "x": -25.738,
              "y": -18.065,
              "z": 1.071
            },
            "rightCorner": {
              "x": -25.732,
              "y": -18.775,
              "z": 1.071
            },
            "gtin": "7622201765033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8735",
            "leftCorner": {
              "x": -25.689,
              "y": -18.774,
              "z": 1.071
            },
            "rightCorner": {
              "x": -25.684,
              "y": -19.314,
              "z": 1.071
            },
            "gtin": "4008400159027",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d703",
        "height": 1.6355,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8736",
            "leftCorner": {
              "x": -25.745,
              "y": -18.065,
              "z": 1.338
            },
            "rightCorner": {
              "x": -25.738,
              "y": -18.789,
              "z": 1.338
            },
            "gtin": "4014400900217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8737",
            "leftCorner": {
              "x": -25.693,
              "y": -18.788,
              "z": 1.338
            },
            "rightCorner": {
              "x": -25.688,
              "y": -19.314,
              "z": 1.338
            },
            "gtin": "4008400102528",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "4f8",
    "name": "4f8",
    "x": -19.677,
    "y": -20.534,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70471,
      "w": 0.7095
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 48,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1ec",
        "height": 0.15931,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68eb",
            "leftCorner": {
              "x": -19.747,
              "y": -20.824,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.746,
              "y": -20.982,
              "z": 0.13
            },
            "gtin": "4008429161889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3fe4a2d7298eca7439fa5ce7",
            "leftCorner": {
              "x": -19.788,
              "y": -20.535,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.786,
              "y": -20.775,
              "z": 0.13
            },
            "gtin": "4008429114564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "acd9428b4b31e6e56bd0f56a",
            "leftCorner": {
              "x": -19.786,
              "y": -20.775,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.786,
              "y": -20.823,
              "z": 0.13
            },
            "gtin": "4008429136177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68ec",
            "leftCorner": {
              "x": -19.745,
              "y": -20.982,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.744,
              "y": -21.266,
              "z": 0.13
            },
            "gtin": "7613036526845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68ed",
            "leftCorner": {
              "x": -19.739,
              "y": -21.266,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.738,
              "y": -21.45,
              "z": 0.13
            },
            "gtin": "4008429114588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68ee",
            "leftCorner": {
              "x": -19.743,
              "y": -21.45,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.741,
              "y": -21.687,
              "z": 0.13
            },
            "gtin": "4008429114564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68ef",
            "leftCorner": {
              "x": -19.71,
              "y": -21.686,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.708,
              "y": -21.894,
              "z": 0.13
            },
            "gtin": "4008429136177",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1e7",
        "height": 0.50485,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6838",
            "leftCorner": {
              "x": -19.751,
              "y": -20.639,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.75,
              "y": -20.809,
              "z": 0.413
            },
            "gtin": "4032254745594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6839",
            "leftCorner": {
              "x": -19.748,
              "y": -20.809,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.746,
              "y": -21.057,
              "z": 0.413
            },
            "gtin": "4032254745617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d683a",
            "leftCorner": {
              "x": -19.748,
              "y": -21.057,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.744,
              "y": -21.528,
              "z": 0.413
            },
            "gtin": "4032254745518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d683b",
            "leftCorner": {
              "x": -19.748,
              "y": -21.528,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.746,
              "y": -21.94,
              "z": 0.413
            },
            "gtin": "7613287844828",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1ea",
        "height": 0.80431,
        "facings": [
          {
            "id": "68d8e50be1820c81800d689b",
            "leftCorner": {
              "x": -19.746,
              "y": -20.566,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.745,
              "y": -20.652,
              "z": 0.658
            },
            "gtin": "4032254774051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d689c",
            "leftCorner": {
              "x": -19.745,
              "y": -20.652,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.744,
              "y": -20.832,
              "z": 0.658
            },
            "gtin": "4032254774075",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d689d",
            "leftCorner": {
              "x": -19.743,
              "y": -20.832,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.743,
              "y": -20.937,
              "z": 0.658
            },
            "gtin": "4032254774037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d689e",
            "leftCorner": {
              "x": -19.744,
              "y": -20.937,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.743,
              "y": -21.066,
              "z": 0.658
            },
            "gtin": "4250231598906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d689f",
            "leftCorner": {
              "x": -19.742,
              "y": -21.066,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.741,
              "y": -21.157,
              "z": 0.658
            },
            "gtin": "4250231598876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68a0",
            "leftCorner": {
              "x": -19.74,
              "y": -21.157,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.74,
              "y": -21.247,
              "z": 0.658
            },
            "gtin": "4250231598845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68a1",
            "leftCorner": {
              "x": -19.739,
              "y": -21.247,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.738,
              "y": -21.337,
              "z": 0.658
            },
            "gtin": "4250231535079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68a2",
            "leftCorner": {
              "x": -19.739,
              "y": -21.337,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.738,
              "y": -21.444,
              "z": 0.658
            },
            "gtin": "3065890149168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68a3",
            "leftCorner": {
              "x": -19.742,
              "y": -21.444,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.74,
              "y": -21.555,
              "z": 0.658
            },
            "gtin": "3065890149175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68a4",
            "leftCorner": {
              "x": -19.743,
              "y": -21.555,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.742,
              "y": -21.659,
              "z": 0.658
            },
            "gtin": "4008429130854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68a5",
            "leftCorner": {
              "x": -19.742,
              "y": -21.659,
              "z": 0.658
            },
            "rightCorner": {
              "x": -19.741,
              "y": -21.838,
              "z": 0.658
            },
            "gtin": "4008429130830",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1e9",
        "height": 1.1084,
        "facings": [
          {
            "id": "68d8e50be1820c81800d687b",
            "leftCorner": {
              "x": -19.743,
              "y": -20.65,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.743,
              "y": -20.733,
              "z": 0.907
            },
            "gtin": "4008429167638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "907149e543fb05b2e788f4a4",
            "leftCorner": {
              "x": -19.785,
              "y": -20.535,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.784,
              "y": -20.648,
              "z": 0.907
            },
            "gtin": "4008429169120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d687c",
            "leftCorner": {
              "x": -19.744,
              "y": -20.733,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.744,
              "y": -20.817,
              "z": 0.907
            },
            "gtin": "4008429167591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d687d",
            "leftCorner": {
              "x": -19.743,
              "y": -20.817,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.742,
              "y": -20.982,
              "z": 0.907
            },
            "gtin": "4008429105098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d687e",
            "leftCorner": {
              "x": -19.743,
              "y": -20.982,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.742,
              "y": -21.155,
              "z": 0.907
            },
            "gtin": "4008429167782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d687f",
            "leftCorner": {
              "x": -19.738,
              "y": -21.155,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.737,
              "y": -21.31,
              "z": 0.907
            },
            "gtin": "4008429167744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6880",
            "leftCorner": {
              "x": -19.735,
              "y": -21.31,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.734,
              "y": -21.429,
              "z": 0.907
            },
            "gtin": "4008429169120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6881",
            "leftCorner": {
              "x": -19.739,
              "y": -21.429,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.737,
              "y": -21.555,
              "z": 0.907
            },
            "gtin": "4008429111228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6882",
            "leftCorner": {
              "x": -19.741,
              "y": -21.555,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.739,
              "y": -21.832,
              "z": 0.907
            },
            "gtin": "5998749146248",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1e8",
        "height": 1.3879,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6854",
            "leftCorner": {
              "x": -19.746,
              "y": -20.665,
              "z": 1.136
            },
            "rightCorner": {
              "x": -19.746,
              "y": -20.722,
              "z": 1.136
            },
            "gtin": "5998749141922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4c61cb2d85a704575e951aad",
            "leftCorner": {
              "x": -19.788,
              "y": -20.535,
              "z": 1.136
            },
            "rightCorner": {
              "x": -19.787,
              "y": -20.665,
              "z": 1.136
            },
            "gtin": "5998749142165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6855",
            "leftCorner": {
              "x": -19.746,
              "y": -20.722,
              "z": 1.136
            },
            "rightCorner": {
              "x": -19.746,
              "y": -20.78,
              "z": 1.136
            },
            "gtin": "5998749141922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6856",
            "leftCorner": {
              "x": -19.746,
              "y": -20.78,
              "z": 1.136
            },
            "rightCorner": {
              "x": -19.745,
              "y": -20.838,
              "z": 1.136
            },
            "gtin": "5998749141922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6857",
            "leftCorner": {
              "x": -19.746,
              "y": -20.838,
              "z": 1.136
            },
            "rightCorner": {
              "x": -19.745,
              "y": -20.985,
              "z": 1.136
            },
            "gtin": "5998749142004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6858",
            "leftCorner": {
              "x": -19.745,
              "y": -20.985,
              "z": 1.136
            },
            "rightCorner": {
              "x": -19.744,
              "y": -21.194,
              "z": 1.136
            },
            "gtin": "5998749142172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6859",
            "leftCorner": {
              "x": -19.741,
              "y": -21.194,
              "z": 1.136
            },
            "rightCorner": {
              "x": -19.74,
              "y": -21.344,
              "z": 1.136
            },
            "gtin": "5998749105214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d685a",
            "leftCorner": {
              "x": -19.74,
              "y": -21.344,
              "z": 1.136
            },
            "rightCorner": {
              "x": -19.738,
              "y": -21.481,
              "z": 1.136
            },
            "gtin": "5998749142165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d685b",
            "leftCorner": {
              "x": -19.74,
              "y": -21.481,
              "z": 1.136
            },
            "rightCorner": {
              "x": -19.74,
              "y": -21.621,
              "z": 1.136
            },
            "gtin": "7613035378780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d685c",
            "leftCorner": {
              "x": -19.744,
              "y": -21.621,
              "z": 1.136
            },
            "rightCorner": {
              "x": -19.742,
              "y": -21.835,
              "z": 1.136
            },
            "gtin": "7613035378667",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1eb",
        "height": 1.7339,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68c3",
            "leftCorner": {
              "x": -19.739,
              "y": -20.628,
              "z": 1.419
            },
            "rightCorner": {
              "x": -19.738,
              "y": -20.8,
              "z": 1.419
            },
            "gtin": "4251276201233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d83c883258901e5358cf9d65",
            "leftCorner": {
              "x": -19.78,
              "y": -20.535,
              "z": 1.419
            },
            "rightCorner": {
              "x": -19.78,
              "y": -20.609,
              "z": 1.419
            },
            "gtin": "4037901106018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68c4",
            "leftCorner": {
              "x": -19.739,
              "y": -20.8,
              "z": 1.419
            },
            "rightCorner": {
              "x": -19.737,
              "y": -20.988,
              "z": 1.419
            },
            "gtin": "4251276201356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68c5",
            "leftCorner": {
              "x": -19.738,
              "y": -20.988,
              "z": 1.419
            },
            "rightCorner": {
              "x": -19.737,
              "y": -21.141,
              "z": 1.419
            },
            "gtin": "4251276200571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68c6",
            "leftCorner": {
              "x": -19.734,
              "y": -21.141,
              "z": 1.419
            },
            "rightCorner": {
              "x": -19.733,
              "y": -21.297,
              "z": 1.419
            },
            "gtin": "4251276200519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68c7",
            "leftCorner": {
              "x": -19.73,
              "y": -21.297,
              "z": 1.419
            },
            "rightCorner": {
              "x": -19.728,
              "y": -21.515,
              "z": 1.419
            },
            "gtin": "4037901105998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68c8",
            "leftCorner": {
              "x": -19.736,
              "y": -21.515,
              "z": 1.419
            },
            "rightCorner": {
              "x": -19.735,
              "y": -21.719,
              "z": 1.419
            },
            "gtin": "4037901105967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68c9",
            "leftCorner": {
              "x": -19.736,
              "y": -21.719,
              "z": 1.419
            },
            "rightCorner": {
              "x": -19.734,
              "y": -21.921,
              "z": 1.419
            },
            "gtin": "4037901106018",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4f6",
    "rightNeighborShelfId": "4f9"
  },
  {
    "id": "4f9",
    "name": "4f9",
    "x": -19.668,
    "y": -21.784,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70471,
      "w": 0.7095
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 58,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1f1",
        "height": 0.1574,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68f0",
            "leftCorner": {
              "x": -19.736,
              "y": -21.894,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.736,
              "y": -22.092,
              "z": 0.129
            },
            "gtin": "4008429104060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68f1",
            "leftCorner": {
              "x": -19.736,
              "y": -22.092,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.734,
              "y": -22.293,
              "z": 0.129
            },
            "gtin": "4008429092336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68f2",
            "leftCorner": {
              "x": -19.732,
              "y": -22.293,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.729,
              "y": -22.596,
              "z": 0.129
            },
            "gtin": "5900951315268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68f3",
            "leftCorner": {
              "x": -19.734,
              "y": -22.596,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.733,
              "y": -22.769,
              "z": 0.129
            },
            "gtin": "5900951315251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68f4",
            "leftCorner": {
              "x": -19.73,
              "y": -22.769,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.728,
              "y": -23.035,
              "z": 0.129
            },
            "gtin": "4306188424772",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1f0",
        "height": 0.50462,
        "facings": [
          {
            "id": "68d8e50be1820c81800d683c",
            "leftCorner": {
              "x": -19.743,
              "y": -21.94,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.739,
              "y": -22.428,
              "z": 0.413
            },
            "gtin": "7613287844644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "79c6c828aa5bfdf67ebcec41",
            "leftCorner": {
              "x": -19.785,
              "y": -21.785,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.784,
              "y": -21.936,
              "z": 0.413
            },
            "gtin": "7613287869739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d683d",
            "leftCorner": {
              "x": -19.741,
              "y": -22.428,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.74,
              "y": -22.663,
              "z": 0.413
            },
            "gtin": "7613287171382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d683e",
            "leftCorner": {
              "x": -19.74,
              "y": -22.663,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.738,
              "y": -22.882,
              "z": 0.413
            },
            "gtin": "7613287844446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d683f",
            "leftCorner": {
              "x": -19.738,
              "y": -22.882,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.737,
              "y": -23.014,
              "z": 0.413
            },
            "gtin": "7613287869739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6840",
            "leftCorner": {
              "x": -19.737,
              "y": -23.014,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.736,
              "y": -23.146,
              "z": 0.413
            },
            "gtin": "7613287869739",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1f2",
        "height": 0.80502,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68a6",
            "leftCorner": {
              "x": -19.738,
              "y": -21.838,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.736,
              "y": -21.977,
              "z": 0.659
            },
            "gtin": "4057767553221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68a7",
            "leftCorner": {
              "x": -19.738,
              "y": -21.978,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.738,
              "y": -22.1,
              "z": 0.659
            },
            "gtin": "4057767553177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68a8",
            "leftCorner": {
              "x": -19.738,
              "y": -22.1,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.736,
              "y": -22.29,
              "z": 0.659
            },
            "gtin": "4057767553238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68a9",
            "leftCorner": {
              "x": -19.736,
              "y": -22.29,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.735,
              "y": -22.373,
              "z": 0.659
            },
            "gtin": "4008429121609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68aa",
            "leftCorner": {
              "x": -19.736,
              "y": -22.373,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.735,
              "y": -22.479,
              "z": 0.659
            },
            "gtin": "4008429061868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68ab",
            "leftCorner": {
              "x": -19.738,
              "y": -22.479,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.737,
              "y": -22.567,
              "z": 0.659
            },
            "gtin": "4008429511110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68ac",
            "leftCorner": {
              "x": -19.739,
              "y": -22.567,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.739,
              "y": -22.67,
              "z": 0.659
            },
            "gtin": "4008429012617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68ad",
            "leftCorner": {
              "x": -19.737,
              "y": -22.67,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.736,
              "y": -22.767,
              "z": 0.659
            },
            "gtin": "4008429511219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68ae",
            "leftCorner": {
              "x": -19.735,
              "y": -22.767,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.734,
              "y": -22.863,
              "z": 0.659
            },
            "gtin": "4008429041105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68af",
            "leftCorner": {
              "x": -19.735,
              "y": -22.863,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.734,
              "y": -22.953,
              "z": 0.659
            },
            "gtin": "4008429052187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68b0",
            "leftCorner": {
              "x": -19.734,
              "y": -22.953,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.733,
              "y": -23.098,
              "z": 0.659
            },
            "gtin": "3065890120754",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1ee",
        "height": 1.1081,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6883",
            "leftCorner": {
              "x": -19.739,
              "y": -21.833,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.739,
              "y": -21.927,
              "z": 0.907
            },
            "gtin": "5998749146255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9c6dd281e5ffc238bcb762fb",
            "leftCorner": {
              "x": -19.785,
              "y": -21.785,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.785,
              "y": -21.829,
              "z": 0.907
            },
            "gtin": "4260198529202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6884",
            "leftCorner": {
              "x": -19.738,
              "y": -21.927,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.738,
              "y": -22.088,
              "z": 0.907
            },
            "gtin": "5998749120538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6885",
            "leftCorner": {
              "x": -19.431,
              "y": -22.099,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.431,
              "y": -22.179,
              "z": 0.907
            },
            "gtin": "5998749120552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6886",
            "leftCorner": {
              "x": -19.738,
              "y": -22.181,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.736,
              "y": -22.406,
              "z": 0.907
            },
            "gtin": "4048422177869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6887",
            "leftCorner": {
              "x": -19.742,
              "y": -22.406,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.741,
              "y": -22.553,
              "z": 0.907
            },
            "gtin": "4048422159001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6888",
            "leftCorner": {
              "x": -19.74,
              "y": -22.553,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.739,
              "y": -22.635,
              "z": 0.907
            },
            "gtin": "4048422159032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6889",
            "leftCorner": {
              "x": -19.742,
              "y": -22.635,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.741,
              "y": -22.85,
              "z": 0.907
            },
            "gtin": "4036897206153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d688a",
            "leftCorner": {
              "x": -19.739,
              "y": -22.85,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.738,
              "y": -22.941,
              "z": 0.907
            },
            "gtin": "4260198529400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d688b",
            "leftCorner": {
              "x": -19.742,
              "y": -22.941,
              "z": 0.907
            },
            "rightCorner": {
              "x": -19.741,
              "y": -23.067,
              "z": 0.907
            },
            "gtin": "4260198529202",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1ed",
        "height": 1.3862,
        "facings": [
          {
            "id": "68d8e50be1820c81800d685d",
            "leftCorner": {
              "x": -19.738,
              "y": -21.835,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.737,
              "y": -21.921,
              "z": 1.134
            },
            "gtin": "4008239288080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "011013a892a0ce1a45f77e01",
            "leftCorner": {
              "x": -19.782,
              "y": -21.785,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.782,
              "y": -21.824,
              "z": 1.134
            },
            "gtin": "4008239231093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d685e",
            "leftCorner": {
              "x": -19.739,
              "y": -21.921,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.738,
              "y": -22.008,
              "z": 1.134
            },
            "gtin": "4008239369192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d685f",
            "leftCorner": {
              "x": -19.739,
              "y": -22.008,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.739,
              "y": -22.102,
              "z": 1.134
            },
            "gtin": "4008239591234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6860",
            "leftCorner": {
              "x": -19.739,
              "y": -22.102,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.738,
              "y": -22.216,
              "z": 1.134
            },
            "gtin": "4008239343222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6861",
            "leftCorner": {
              "x": -19.732,
              "y": -22.216,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.731,
              "y": -22.282,
              "z": 1.134
            },
            "gtin": "4008239234162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6862",
            "leftCorner": {
              "x": -19.731,
              "y": -22.282,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.73,
              "y": -22.367,
              "z": 1.134
            },
            "gtin": "4008239234155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6863",
            "leftCorner": {
              "x": -19.734,
              "y": -22.367,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.733,
              "y": -22.434,
              "z": 1.134
            },
            "gtin": "4008239413604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6864",
            "leftCorner": {
              "x": -19.733,
              "y": -22.434,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.732,
              "y": -22.5,
              "z": 1.134
            },
            "gtin": "4008239413604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6865",
            "leftCorner": {
              "x": -19.738,
              "y": -22.5,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.737,
              "y": -22.571,
              "z": 1.134
            },
            "gtin": "4008239340511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6866",
            "leftCorner": {
              "x": -19.739,
              "y": -22.571,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.738,
              "y": -22.649,
              "z": 1.134
            },
            "gtin": "4008239231475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6867",
            "leftCorner": {
              "x": -19.736,
              "y": -22.649,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.736,
              "y": -22.708,
              "z": 1.134
            },
            "gtin": "4008239230294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6868",
            "leftCorner": {
              "x": -19.737,
              "y": -22.708,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.736,
              "y": -22.834,
              "z": 1.134
            },
            "gtin": "4008239230096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6869",
            "leftCorner": {
              "x": -19.737,
              "y": -22.834,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.736,
              "y": -22.902,
              "z": 1.134
            },
            "gtin": "4008239231451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d686a",
            "leftCorner": {
              "x": -19.738,
              "y": -22.902,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.737,
              "y": -22.995,
              "z": 1.134
            },
            "gtin": "4008239231109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d686b",
            "leftCorner": {
              "x": -19.74,
              "y": -22.995,
              "z": 1.134
            },
            "rightCorner": {
              "x": -19.739,
              "y": -23.063,
              "z": 1.134
            },
            "gtin": "4008239231093",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1ef",
        "height": 1.7331,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68ca",
            "leftCorner": {
              "x": -19.734,
              "y": -21.921,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.733,
              "y": -22.036,
              "z": 1.418
            },
            "gtin": "4008239586025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6e076f9e1044d81350eeb190",
            "leftCorner": {
              "x": -19.779,
              "y": -21.785,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.778,
              "y": -21.909,
              "z": 1.418
            },
            "gtin": "4008239585882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68cb",
            "leftCorner": {
              "x": -19.734,
              "y": -22.036,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.734,
              "y": -22.145,
              "z": 1.418
            },
            "gtin": "4008239585943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68cc",
            "leftCorner": {
              "x": -19.734,
              "y": -22.145,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.733,
              "y": -22.236,
              "z": 1.418
            },
            "gtin": "4008239585998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68cd",
            "leftCorner": {
              "x": -19.735,
              "y": -22.236,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.733,
              "y": -22.455,
              "z": 1.418
            },
            "gtin": "4008239288073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68ce",
            "leftCorner": {
              "x": -19.737,
              "y": -22.455,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.736,
              "y": -22.544,
              "z": 1.418
            },
            "gtin": "4008239585950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68cf",
            "leftCorner": {
              "x": -19.739,
              "y": -22.544,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.739,
              "y": -22.665,
              "z": 1.418
            },
            "gtin": "4008239585882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68d0",
            "leftCorner": {
              "x": -19.736,
              "y": -22.665,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.735,
              "y": -22.778,
              "z": 1.418
            },
            "gtin": "4008239585974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68d1",
            "leftCorner": {
              "x": -19.735,
              "y": -22.778,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.733,
              "y": -22.957,
              "z": 1.418
            },
            "gtin": "4008239585851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68d2",
            "leftCorner": {
              "x": -19.737,
              "y": -22.957,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.736,
              "y": -23.162,
              "z": 1.418
            },
            "gtin": "4008239585868",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4f8",
    "rightNeighborShelfId": "4fa"
  },
  {
    "id": "4fa",
    "name": "4fa",
    "x": -19.66,
    "y": -23.034,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70471,
      "w": 0.7095
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 53,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1f9",
        "height": 0.15889,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68f5",
            "leftCorner": {
              "x": -19.734,
              "y": -23.035,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.732,
              "y": -23.367,
              "z": 0.13
            },
            "gtin": "4306188028697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68f6",
            "leftCorner": {
              "x": -19.732,
              "y": -23.367,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.731,
              "y": -23.665,
              "z": 0.13
            },
            "gtin": "4306188028697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68f7",
            "leftCorner": {
              "x": -19.73,
              "y": -23.665,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.727,
              "y": -24.015,
              "z": 0.13
            },
            "gtin": "4306188028727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68f8",
            "leftCorner": {
              "x": -19.734,
              "y": -24.015,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.734,
              "y": -24.115,
              "z": 0.13
            },
            "gtin": "4306188028666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68f9",
            "leftCorner": {
              "x": -19.734,
              "y": -24.115,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.732,
              "y": -24.215,
              "z": 0.13
            },
            "gtin": "4306188028666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68fa",
            "leftCorner": {
              "x": -19.732,
              "y": -24.215,
              "z": 0.13
            },
            "rightCorner": {
              "x": -19.731,
              "y": -24.462,
              "z": 0.13
            },
            "gtin": "2000439122050",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1f4",
        "height": 0.50422,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6841",
            "leftCorner": {
              "x": -19.735,
              "y": -23.146,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.734,
              "y": -23.289,
              "z": 0.413
            },
            "gtin": "7613287844606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6842",
            "leftCorner": {
              "x": -19.738,
              "y": -23.289,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.738,
              "y": -23.439,
              "z": 0.413
            },
            "gtin": "4306188426677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6843",
            "leftCorner": {
              "x": -19.737,
              "y": -23.439,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.736,
              "y": -23.553,
              "z": 0.413
            },
            "gtin": "4306188426516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6844",
            "leftCorner": {
              "x": -19.735,
              "y": -23.553,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.735,
              "y": -23.677,
              "z": 0.413
            },
            "gtin": "4306188426554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6845",
            "leftCorner": {
              "x": -19.736,
              "y": -23.677,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.735,
              "y": -23.809,
              "z": 0.413
            },
            "gtin": "4306188426424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6846",
            "leftCorner": {
              "x": -19.735,
              "y": -23.809,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.734,
              "y": -23.932,
              "z": 0.413
            },
            "gtin": "4306188426608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6847",
            "leftCorner": {
              "x": -19.737,
              "y": -23.932,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.735,
              "y": -24.084,
              "z": 0.413
            },
            "gtin": "4306188426486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6848",
            "leftCorner": {
              "x": -19.737,
              "y": -24.084,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.737,
              "y": -24.184,
              "z": 0.413
            },
            "gtin": "4306188426646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6831",
            "leftCorner": {
              "x": -19.739,
              "y": -24.184,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.738,
              "y": -24.285,
              "z": 0.413
            },
            "gtin": "8445290298003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "46fb825ce9e334c5ab6e846f",
            "leftCorner": {
              "x": -19.78,
              "y": -23.034,
              "z": 0.413
            },
            "rightCorner": {
              "x": -19.779,
              "y": -23.136,
              "z": 0.413
            },
            "gtin": "8445290298003",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1f8",
        "height": 0.80491,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68b1",
            "leftCorner": {
              "x": -19.732,
              "y": -23.098,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.732,
              "y": -23.187,
              "z": 0.659
            },
            "gtin": "4008429041013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68b2",
            "leftCorner": {
              "x": -19.733,
              "y": -23.187,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.732,
              "y": -23.279,
              "z": 0.659
            },
            "gtin": "4008429048289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68b3",
            "leftCorner": {
              "x": -19.734,
              "y": -23.279,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.732,
              "y": -23.384,
              "z": 0.659
            },
            "gtin": "3065890114104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68b4",
            "leftCorner": {
              "x": -19.733,
              "y": -23.384,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.733,
              "y": -23.508,
              "z": 0.659
            },
            "gtin": "4008429009747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68b5",
            "leftCorner": {
              "x": -19.732,
              "y": -23.508,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.731,
              "y": -23.594,
              "z": 0.659
            },
            "gtin": "4008429006296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68b6",
            "leftCorner": {
              "x": -19.733,
              "y": -23.594,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.733,
              "y": -23.677,
              "z": 0.659
            },
            "gtin": "4008429141492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68b7",
            "leftCorner": {
              "x": -19.733,
              "y": -23.677,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.733,
              "y": -23.76,
              "z": 0.659
            },
            "gtin": "3065890156029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68b8",
            "leftCorner": {
              "x": -19.733,
              "y": -23.76,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.732,
              "y": -23.95,
              "z": 0.659
            },
            "gtin": "8410136024184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68b9",
            "leftCorner": {
              "x": -19.734,
              "y": -23.95,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.733,
              "y": -24.053,
              "z": 0.659
            },
            "gtin": "4008429165160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68ba",
            "leftCorner": {
              "x": -19.734,
              "y": -24.053,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.733,
              "y": -24.175,
              "z": 0.659
            },
            "gtin": "4008429165030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6896",
            "leftCorner": {
              "x": -19.738,
              "y": -24.175,
              "z": 0.659
            },
            "rightCorner": {
              "x": -19.736,
              "y": -24.285,
              "z": 0.659
            },
            "gtin": "7613036527477",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1f7",
        "height": 1.1077,
        "facings": [
          {
            "id": "68d8e50be1820c81800d688c",
            "leftCorner": {
              "x": -19.734,
              "y": -23.067,
              "z": 0.906
            },
            "rightCorner": {
              "x": -19.734,
              "y": -23.174,
              "z": 0.906
            },
            "gtin": "4260198528700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d688d",
            "leftCorner": {
              "x": -19.734,
              "y": -23.174,
              "z": 0.906
            },
            "rightCorner": {
              "x": -19.733,
              "y": -23.28,
              "z": 0.906
            },
            "gtin": "4306188030089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d688e",
            "leftCorner": {
              "x": -19.735,
              "y": -23.28,
              "z": 0.906
            },
            "rightCorner": {
              "x": -19.734,
              "y": -23.42,
              "z": 0.906
            },
            "gtin": "4306188031383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d688f",
            "leftCorner": {
              "x": -19.736,
              "y": -23.42,
              "z": 0.906
            },
            "rightCorner": {
              "x": -19.734,
              "y": -23.556,
              "z": 0.906
            },
            "gtin": "4306188027621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6890",
            "leftCorner": {
              "x": -19.734,
              "y": -23.556,
              "z": 0.906
            },
            "rightCorner": {
              "x": -19.734,
              "y": -23.678,
              "z": 0.906
            },
            "gtin": "4306188027676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6891",
            "leftCorner": {
              "x": -19.734,
              "y": -23.678,
              "z": 0.906
            },
            "rightCorner": {
              "x": -19.733,
              "y": -23.793,
              "z": 0.906
            },
            "gtin": "4306188027744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6892",
            "leftCorner": {
              "x": -19.734,
              "y": -23.793,
              "z": 0.906
            },
            "rightCorner": {
              "x": -19.733,
              "y": -23.947,
              "z": 0.906
            },
            "gtin": "4306188027805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6893",
            "leftCorner": {
              "x": -19.74,
              "y": -23.947,
              "z": 0.906
            },
            "rightCorner": {
              "x": -19.739,
              "y": -24.043,
              "z": 0.906
            },
            "gtin": "4306188030119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6894",
            "leftCorner": {
              "x": -19.736,
              "y": -24.043,
              "z": 0.906
            },
            "rightCorner": {
              "x": -19.736,
              "y": -24.153,
              "z": 0.906
            },
            "gtin": "4306188027775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6873",
            "leftCorner": {
              "x": -19.739,
              "y": -24.153,
              "z": 0.906
            },
            "rightCorner": {
              "x": -19.738,
              "y": -24.285,
              "z": 0.906
            },
            "gtin": "4306188027706",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1f5",
        "height": 1.3871,
        "facings": [
          {
            "id": "68d8e50be1820c81800d686c",
            "leftCorner": {
              "x": -19.736,
              "y": -23.063,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.735,
              "y": -23.141,
              "z": 1.135
            },
            "gtin": "4008239231468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d686d",
            "leftCorner": {
              "x": -19.738,
              "y": -23.141,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.737,
              "y": -23.453,
              "z": 1.135
            },
            "gtin": "4057767490625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d686e",
            "leftCorner": {
              "x": -19.74,
              "y": -23.453,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.739,
              "y": -23.591,
              "z": 1.135
            },
            "gtin": "7613036726696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d686f",
            "leftCorner": {
              "x": -19.74,
              "y": -23.591,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.738,
              "y": -23.913,
              "z": 1.135
            },
            "gtin": "7613034994769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6870",
            "leftCorner": {
              "x": -19.741,
              "y": -23.913,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.739,
              "y": -24.086,
              "z": 1.135
            },
            "gtin": "7613034998064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6871",
            "leftCorner": {
              "x": -19.74,
              "y": -24.086,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.74,
              "y": -24.217,
              "z": 1.135
            },
            "gtin": "7613034995759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d684a",
            "leftCorner": {
              "x": -19.744,
              "y": -24.217,
              "z": 1.135
            },
            "rightCorner": {
              "x": -19.743,
              "y": -24.285,
              "z": 1.135
            },
            "gtin": "4045612003977",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1f6",
        "height": 1.7326,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68d3",
            "leftCorner": {
              "x": -19.737,
              "y": -23.162,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.735,
              "y": -23.295,
              "z": 1.418
            },
            "gtin": "4057767300924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f25eb15fbc6fd25a9d36e5bc",
            "leftCorner": {
              "x": -19.78,
              "y": -23.034,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.779,
              "y": -23.144,
              "z": 1.418
            },
            "gtin": "4057767300931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68d4",
            "leftCorner": {
              "x": -19.737,
              "y": -23.295,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.737,
              "y": -23.403,
              "z": 1.418
            },
            "gtin": "4057767300931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68d5",
            "leftCorner": {
              "x": -19.738,
              "y": -23.403,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.736,
              "y": -23.548,
              "z": 1.418
            },
            "gtin": "4030879021802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68d6",
            "leftCorner": {
              "x": -19.737,
              "y": -23.548,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.737,
              "y": -23.695,
              "z": 1.418
            },
            "gtin": "4030879021505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68d7",
            "leftCorner": {
              "x": -19.737,
              "y": -23.695,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.736,
              "y": -23.831,
              "z": 1.418
            },
            "gtin": "4030879021109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68d8",
            "leftCorner": {
              "x": -19.734,
              "y": -23.831,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.734,
              "y": -23.978,
              "z": 1.418
            },
            "gtin": "4030879029952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68d9",
            "leftCorner": {
              "x": -19.738,
              "y": -23.978,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.737,
              "y": -24.205,
              "z": 1.418
            },
            "gtin": "4030879024926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68da",
            "leftCorner": {
              "x": -19.744,
              "y": -24.205,
              "z": 1.418
            },
            "rightCorner": {
              "x": -19.742,
              "y": -24.465,
              "z": 1.418
            },
            "gtin": "4030879022205",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4f9",
    "rightNeighborShelfId": "4fb"
  },
  {
    "id": "4fb",
    "name": "4fb",
    "x": -19.651,
    "y": -24.284,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70471,
      "w": 0.7095
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 9,
      "shelfCategory": "TOILET_PAPER"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1fb",
        "height": 0.15654,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68fb",
            "leftCorner": {
              "x": -19.723,
              "y": -24.462,
              "z": 0.128
            },
            "rightCorner": {
              "x": -19.715,
              "y": -25.609,
              "z": 0.128
            },
            "gtin": "4306188051978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68e8",
            "leftCorner": {
              "x": -19.716,
              "y": -25.609,
              "z": 0.128
            },
            "rightCorner": {
              "x": -19.716,
              "y": -25.684,
              "z": 0.128
            },
            "gtin": "4306188051916",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1fc",
        "height": 1.2872,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68fc",
            "leftCorner": {
              "x": -19.758,
              "y": -24.285,
              "z": 1.053
            },
            "rightCorner": {
              "x": -19.752,
              "y": -25.258,
              "z": 1.053
            },
            "gtin": "7322541459691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68fe",
            "leftCorner": {
              "x": -19.712,
              "y": -25.258,
              "z": 1.053
            },
            "rightCorner": {
              "x": -19.708,
              "y": -25.701,
              "z": 1.053
            },
            "gtin": "7322541460109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68ff",
            "leftCorner": {
              "x": -19.708,
              "y": -25.701,
              "z": 1.053
            },
            "rightCorner": {
              "x": -19.706,
              "y": -26.144,
              "z": 1.053
            },
            "gtin": "7322541460109",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1fa",
        "height": 1.7346,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68db",
            "leftCorner": {
              "x": -19.727,
              "y": -24.465,
              "z": 1.419
            },
            "rightCorner": {
              "x": -19.724,
              "y": -24.752,
              "z": 1.419
            },
            "gtin": "7322541147741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4329b2ecbf980bfef42a03f3",
            "leftCorner": {
              "x": -19.763,
              "y": -24.285,
              "z": 1.419
            },
            "rightCorner": {
              "x": -19.762,
              "y": -24.43,
              "z": 1.419
            },
            "gtin": "7322541147741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68dc",
            "leftCorner": {
              "x": -19.724,
              "y": -24.752,
              "z": 1.419
            },
            "rightCorner": {
              "x": -19.723,
              "y": -25.039,
              "z": 1.419
            },
            "gtin": "7322541147741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68dd",
            "leftCorner": {
              "x": -19.714,
              "y": -25.039,
              "z": 1.419
            },
            "rightCorner": {
              "x": -19.707,
              "y": -25.957,
              "z": 1.419
            },
            "gtin": "8004260007788",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4fa",
    "rightNeighborShelfId": "500"
  },
  {
    "id": "4ff",
    "name": "4ff",
    "x": -19.515,
    "y": -27.545,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7069,
      "w": 0.70731
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 6
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d203",
        "height": 0.15823,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6908",
            "leftCorner": {
              "x": -19.587,
              "y": -27.698,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.587,
              "y": -28.116,
              "z": 0.129
            },
            "gtin": "4262419330741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6907",
            "leftCorner": {
              "x": -19.577,
              "y": -28.116,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.576,
              "y": -28.546,
              "z": 0.129
            },
            "gtin": "4262419330949",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d204",
        "height": 1.2895,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68fd",
            "leftCorner": {
              "x": -19.575,
              "y": -28.046,
              "z": 1.055
            },
            "rightCorner": {
              "x": -19.575,
              "y": -28.546,
              "z": 1.055
            },
            "gtin": "4262419330253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9936d186afa647bf56d4a7d6",
            "leftCorner": {
              "x": -19.615,
              "y": -27.545,
              "z": 1.055
            },
            "rightCorner": {
              "x": -19.615,
              "y": -27.919,
              "z": 1.055
            },
            "gtin": "4262419330253",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d202",
        "height": 1.7358,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68e2",
            "leftCorner": {
              "x": -19.585,
              "y": -27.786,
              "z": 1.42
            },
            "rightCorner": {
              "x": -19.584,
              "y": -28.692,
              "z": 1.42
            },
            "gtin": "4262419331601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e88164d241aec4ad22ea6b35",
            "leftCorner": {
              "x": -19.625,
              "y": -27.545,
              "z": 1.42
            },
            "rightCorner": {
              "x": -19.625,
              "y": -27.782,
              "z": 1.42
            },
            "gtin": "4262419331601",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "501",
    "rightNeighborShelfId": "502"
  },
  {
    "id": "500",
    "name": "500",
    "x": -19.62,
    "y": -25.541,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.68976,
      "w": 0.72404
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 6,
      "shelfCategory": "TOILET_PAPER"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1fe",
        "height": 1.2868,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6900",
            "leftCorner": {
              "x": -19.647,
              "y": -26.152,
              "z": 1.053
            },
            "rightCorner": {
              "x": -19.637,
              "y": -26.348,
              "z": 1.053
            },
            "gtin": "7322542035917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "87e0bae9c65f8aef130689ec",
            "leftCorner": {
              "x": -19.716,
              "y": -25.546,
              "z": 1.053
            },
            "rightCorner": {
              "x": -19.697,
              "y": -25.927,
              "z": 1.053
            },
            "gtin": "7322542035917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6901",
            "leftCorner": {
              "x": -19.637,
              "y": -26.348,
              "z": 1.053
            },
            "rightCorner": {
              "x": -19.629,
              "y": -26.543,
              "z": 1.053
            },
            "gtin": "7322542035917",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1fd",
        "height": 1.7361,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68de",
            "leftCorner": {
              "x": -19.659,
              "y": -25.966,
              "z": 1.42
            },
            "rightCorner": {
              "x": -19.643,
              "y": -26.278,
              "z": 1.42
            },
            "gtin": "7322542037232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f6bb413965d7809d0936ea0d",
            "leftCorner": {
              "x": -19.72,
              "y": -25.546,
              "z": 1.42
            },
            "rightCorner": {
              "x": -19.708,
              "y": -25.8,
              "z": 1.42
            },
            "gtin": "7322541442488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68df",
            "leftCorner": {
              "x": -19.646,
              "y": -26.278,
              "z": 1.42
            },
            "rightCorner": {
              "x": -19.634,
              "y": -26.543,
              "z": 1.42
            },
            "gtin": "7322541442488",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4fb",
    "rightNeighborShelfId": "501"
  },
  {
    "id": "501",
    "name": "501",
    "x": -19.571,
    "y": -26.539,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.68976,
      "w": 0.72404
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 11,
      "shelfCategory": "TOILET_PAPER"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d201",
        "height": 0.15981,
        "facings": [
          {
            "id": "3c5eb689f083076fafe8a867",
            "leftCorner": {
              "x": -19.674,
              "y": -26.543,
              "z": 0.131
            },
            "rightCorner": {
              "x": -19.662,
              "y": -26.792,
              "z": 0.131
            },
            "gtin": "7322541460437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "57b8e40e6d5b3f08b47ce52b",
            "leftCorner": {
              "x": -19.662,
              "y": -26.792,
              "z": 0.131
            },
            "rightCorner": {
              "x": -19.65,
              "y": -27.04,
              "z": 0.131
            },
            "gtin": "7322541460437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "75ac6c3a58b79abcd01b3009",
            "leftCorner": {
              "x": -19.65,
              "y": -27.04,
              "z": 0.131
            },
            "rightCorner": {
              "x": -19.637,
              "y": -27.305,
              "z": 0.131
            },
            "gtin": "8004260414494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ed242c770fc2af465e626780",
            "leftCorner": {
              "x": -19.637,
              "y": -27.305,
              "z": 0.131
            },
            "rightCorner": {
              "x": -19.626,
              "y": -27.533,
              "z": 0.131
            },
            "gtin": "4260344220106",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1ff",
        "height": 1.2852,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6902",
            "leftCorner": {
              "x": -19.64,
              "y": -26.542,
              "z": 1.052
            },
            "rightCorner": {
              "x": -19.632,
              "y": -26.682,
              "z": 1.052
            },
            "gtin": "4262419332370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6903",
            "leftCorner": {
              "x": -19.632,
              "y": -26.682,
              "z": 1.052
            },
            "rightCorner": {
              "x": -19.626,
              "y": -26.823,
              "z": 1.052
            },
            "gtin": "4262419332370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6904",
            "leftCorner": {
              "x": -19.632,
              "y": -26.823,
              "z": 1.052
            },
            "rightCorner": {
              "x": -19.621,
              "y": -27.046,
              "z": 1.052
            },
            "gtin": "4262419332370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6905",
            "leftCorner": {
              "x": -19.621,
              "y": -27.046,
              "z": 1.052
            },
            "rightCorner": {
              "x": -19.61,
              "y": -27.268,
              "z": 1.052
            },
            "gtin": "4262419332370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6906",
            "leftCorner": {
              "x": -19.598,
              "y": -27.269,
              "z": 1.052
            },
            "rightCorner": {
              "x": -19.566,
              "y": -27.941,
              "z": 1.052
            },
            "gtin": "8004260414494",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d200",
        "height": 1.7357,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68e0",
            "leftCorner": {
              "x": -19.651,
              "y": -26.542,
              "z": 1.42
            },
            "rightCorner": {
              "x": -19.624,
              "y": -27.075,
              "z": 1.42
            },
            "gtin": "4260344220106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68e1",
            "leftCorner": {
              "x": -19.624,
              "y": -27.075,
              "z": 1.42
            },
            "rightCorner": {
              "x": -19.592,
              "y": -27.734,
              "z": 1.42
            },
            "gtin": "4260344220106",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "500",
    "rightNeighborShelfId": "4ff"
  },
  {
    "id": "502",
    "name": "502",
    "x": -19.378,
    "y": -28.733,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70006,
      "w": 0.71408
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 23,
      "shelfCategory": "TOILET_PAPER"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d707",
        "height": 0.17053,
        "facings": [
          {
            "id": "68d8e50be1820c81800d692f",
            "leftCorner": {
              "x": -19.49,
              "y": -28.735,
              "z": 0.14
            },
            "rightCorner": {
              "x": -19.48,
              "y": -29.211,
              "z": 0.14
            },
            "gtin": "4262419330260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6931",
            "leftCorner": {
              "x": -19.441,
              "y": -29.21,
              "z": 0.14
            },
            "rightCorner": {
              "x": -19.43,
              "y": -29.734,
              "z": 0.14
            },
            "gtin": "4306188031499",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d709",
        "height": 0.74588,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d873d",
            "leftCorner": {
              "x": -19.478,
              "y": -28.735,
              "z": 0.61
            },
            "rightCorner": {
              "x": -19.472,
              "y": -29.004,
              "z": 0.61
            },
            "gtin": "4306188052067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c1a6faddc2aaafb320190752",
            "leftCorner": {
              "x": -19.463,
              "y": -29.491,
              "z": 0.61
            },
            "rightCorner": {
              "x": -19.458,
              "y": -29.729,
              "z": 0.61
            },
            "gtin": "4000883101302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d873e",
            "leftCorner": {
              "x": -19.472,
              "y": -29.004,
              "z": 0.61
            },
            "rightCorner": {
              "x": -19.468,
              "y": -29.272,
              "z": 0.61
            },
            "gtin": "4306188052067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8742",
            "leftCorner": {
              "x": -19.438,
              "y": -29.271,
              "z": 0.61
            },
            "rightCorner": {
              "x": -19.433,
              "y": -29.49,
              "z": 0.61
            },
            "gtin": "7322541459639",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d706",
        "height": 1.1369,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8738",
            "leftCorner": {
              "x": -19.49,
              "y": -28.735,
              "z": 0.93
            },
            "rightCorner": {
              "x": -19.484,
              "y": -29.078,
              "z": 0.93
            },
            "gtin": "7322540907582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d873a",
            "leftCorner": {
              "x": -19.44,
              "y": -29.077,
              "z": 0.93
            },
            "rightCorner": {
              "x": -19.437,
              "y": -29.229,
              "z": 0.93
            },
            "gtin": "4260344220502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d873b",
            "leftCorner": {
              "x": -19.441,
              "y": -29.229,
              "z": 0.93
            },
            "rightCorner": {
              "x": -19.436,
              "y": -29.431,
              "z": 0.93
            },
            "gtin": "4260344220588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d873c",
            "leftCorner": {
              "x": -19.437,
              "y": -29.431,
              "z": 0.93
            },
            "rightCorner": {
              "x": -19.434,
              "y": -29.584,
              "z": 0.93
            },
            "gtin": "4260344220496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8739",
            "leftCorner": {
              "x": -19.437,
              "y": -29.584,
              "z": 0.93
            },
            "rightCorner": {
              "x": -19.434,
              "y": -29.734,
              "z": 0.93
            },
            "gtin": "4260344220717",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d704",
        "height": 1.4399,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6918",
            "leftCorner": {
              "x": -19.497,
              "y": -28.735,
              "z": 1.178
            },
            "rightCorner": {
              "x": -19.493,
              "y": -28.946,
              "z": 1.178
            },
            "gtin": "7322541102092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6919",
            "leftCorner": {
              "x": -19.451,
              "y": -28.946,
              "z": 1.178
            },
            "rightCorner": {
              "x": -19.448,
              "y": -29.081,
              "z": 1.178
            },
            "gtin": "7322540907520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d691a",
            "leftCorner": {
              "x": -19.449,
              "y": -29.081,
              "z": 1.178
            },
            "rightCorner": {
              "x": -19.446,
              "y": -29.224,
              "z": 1.178
            },
            "gtin": "7322541208381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d691b",
            "leftCorner": {
              "x": -19.449,
              "y": -29.224,
              "z": 1.178
            },
            "rightCorner": {
              "x": -19.446,
              "y": -29.378,
              "z": 1.178
            },
            "gtin": "5029053583969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d691c",
            "leftCorner": {
              "x": -19.445,
              "y": -29.378,
              "z": 1.178
            },
            "rightCorner": {
              "x": -19.442,
              "y": -29.506,
              "z": 1.178
            },
            "gtin": "5029053583976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d691d",
            "leftCorner": {
              "x": -19.442,
              "y": -29.506,
              "z": 1.178
            },
            "rightCorner": {
              "x": -19.437,
              "y": -29.734,
              "z": 1.178
            },
            "gtin": "4306188418115",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d705",
        "height": 1.7374,
        "facings": [
          {
            "id": "68d8e50be1820c81800d68e3",
            "leftCorner": {
              "x": -19.445,
              "y": -28.881,
              "z": 1.421
            },
            "rightCorner": {
              "x": -19.443,
              "y": -29.007,
              "z": 1.421
            },
            "gtin": "7322540907551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68e4",
            "leftCorner": {
              "x": -19.443,
              "y": -29.007,
              "z": 1.421
            },
            "rightCorner": {
              "x": -19.44,
              "y": -29.179,
              "z": 1.421
            },
            "gtin": "5029053583990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68e5",
            "leftCorner": {
              "x": -19.444,
              "y": -29.179,
              "z": 1.421
            },
            "rightCorner": {
              "x": -19.44,
              "y": -29.379,
              "z": 1.421
            },
            "gtin": "5029053584331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68e6",
            "leftCorner": {
              "x": -19.441,
              "y": -29.379,
              "z": 1.421
            },
            "rightCorner": {
              "x": -19.438,
              "y": -29.516,
              "z": 1.421
            },
            "gtin": "5029053583938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d68bc",
            "leftCorner": {
              "x": -19.438,
              "y": -29.516,
              "z": 1.421
            },
            "rightCorner": {
              "x": -19.434,
              "y": -29.734,
              "z": 1.421
            },
            "gtin": "4306188418177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "de630bde2c8981568d132268",
            "leftCorner": {
              "x": -19.492,
              "y": -28.735,
              "z": 1.421
            },
            "rightCorner": {
              "x": -19.489,
              "y": -28.863,
              "z": 1.421
            },
            "gtin": "7322540907551",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4ff",
    "rightNeighborShelfId": "504"
  },
  {
    "id": "504",
    "name": "504",
    "x": -19.358,
    "y": -29.732,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70006,
      "w": 0.71408
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 6,
      "unknownStockCount": 36
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d20a",
        "height": 0.17453,
        "facings": [
          {
            "id": "6b4f3bbb1b6472a99af6fa90",
            "leftCorner": {
              "x": -19.407,
              "y": -29.733,
              "z": 0.143
            },
            "rightCorner": {
              "x": -19.406,
              "y": -29.772,
              "z": 0.143
            },
            "gtin": "8718824912370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "33037bcb983dafeda3b34dca",
            "leftCorner": {
              "x": -19.406,
              "y": -29.772,
              "z": 0.143
            },
            "rightCorner": {
              "x": -19.403,
              "y": -29.92,
              "z": 0.143
            },
            "gtin": "4052171025340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2a0d1809164abcddab6243c3",
            "leftCorner": {
              "x": -19.403,
              "y": -29.92,
              "z": 0.143
            },
            "rightCorner": {
              "x": -19.403,
              "y": -29.959,
              "z": 0.143
            },
            "gtin": "8718824912370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ba64a789b2fad596390da223",
            "leftCorner": {
              "x": -19.403,
              "y": -29.959,
              "z": 0.143
            },
            "rightCorner": {
              "x": -19.4,
              "y": -30.075,
              "z": 0.143
            },
            "gtin": "4052171360502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b7b5cd9397162273bf4f6b10",
            "leftCorner": {
              "x": -19.4,
              "y": -30.075,
              "z": 0.143
            },
            "rightCorner": {
              "x": -19.398,
              "y": -30.192,
              "z": 0.143
            },
            "gtin": "8718824912127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "733fd3e7e0dc53fe2e21d86d",
            "leftCorner": {
              "x": -19.398,
              "y": -30.192,
              "z": 0.143
            },
            "rightCorner": {
              "x": -19.396,
              "y": -30.311,
              "z": 0.143
            },
            "gtin": "4052171034885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "780020ca4ec76ac0634889d0",
            "leftCorner": {
              "x": -19.396,
              "y": -30.311,
              "z": 0.143
            },
            "rightCorner": {
              "x": -19.393,
              "y": -30.431,
              "z": 0.143
            },
            "gtin": "8718824270753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "759b8f4892f2857b04b4aa9e",
            "leftCorner": {
              "x": -19.393,
              "y": -30.431,
              "z": 0.143
            },
            "rightCorner": {
              "x": -19.391,
              "y": -30.552,
              "z": 0.143
            },
            "gtin": "4052171651617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "393e68dbc3831b6a5ccd1382",
            "leftCorner": {
              "x": -19.391,
              "y": -30.552,
              "z": 0.143
            },
            "rightCorner": {
              "x": -19.388,
              "y": -30.673,
              "z": 0.143
            },
            "gtin": "4052171655752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f963e46820fbc3e163f5a99c",
            "leftCorner": {
              "x": -19.388,
              "y": -30.673,
              "z": 0.143
            },
            "rightCorner": {
              "x": -19.383,
              "y": -30.963,
              "z": 0.143
            },
            "gtin": "8718824115375",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d205",
        "height": 0.65826,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6909",
            "leftCorner": {
              "x": -19.235,
              "y": -29.73,
              "z": 0.539
            },
            "rightCorner": {
              "x": -19.229,
              "y": -29.992,
              "z": 0.539
            },
            "gtin": "8720245031400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2cabd4d799886eb305fd03f5",
            "leftCorner": {
              "x": -19.227,
              "y": -30.114,
              "z": 0.539
            },
            "rightCorner": {
              "x": -19.224,
              "y": -30.254,
              "z": 0.539
            },
            "gtin": "4036329020784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d690a",
            "leftCorner": {
              "x": -19.196,
              "y": -29.991,
              "z": 0.539
            },
            "rightCorner": {
              "x": -19.193,
              "y": -30.114,
              "z": 0.539
            },
            "gtin": "4052171360502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d690c",
            "leftCorner": {
              "x": -19.164,
              "y": -30.255,
              "z": 0.539
            },
            "rightCorner": {
              "x": -19.162,
              "y": -30.38,
              "z": 0.539
            },
            "gtin": "4052171034885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d690d",
            "leftCorner": {
              "x": -19.169,
              "y": -30.38,
              "z": 0.539
            },
            "rightCorner": {
              "x": -19.166,
              "y": -30.53,
              "z": 0.539
            },
            "gtin": "4036329020821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d690e",
            "leftCorner": {
              "x": -19.172,
              "y": -30.53,
              "z": 0.539
            },
            "rightCorner": {
              "x": -19.17,
              "y": -30.671,
              "z": 0.539
            },
            "gtin": "4036329020784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d690f",
            "leftCorner": {
              "x": -19.163,
              "y": -30.67,
              "z": 0.539
            },
            "rightCorner": {
              "x": -19.16,
              "y": -30.804,
              "z": 0.539
            },
            "gtin": "4036329364635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6910",
            "leftCorner": {
              "x": -19.216,
              "y": -30.806,
              "z": 0.539
            },
            "rightCorner": {
              "x": -19.213,
              "y": -30.963,
              "z": 0.539
            },
            "gtin": "4036329364833",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d208",
        "height": 1.0355,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6927",
            "leftCorner": {
              "x": -19.224,
              "y": -29.729,
              "z": 0.847
            },
            "rightCorner": {
              "x": -19.219,
              "y": -30.0,
              "z": 0.847
            },
            "gtin": "4052171651587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6928",
            "leftCorner": {
              "x": -19.164,
              "y": -30.0,
              "z": 0.847
            },
            "rightCorner": {
              "x": -19.161,
              "y": -30.149,
              "z": 0.847
            },
            "gtin": "4052171651709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6929",
            "leftCorner": {
              "x": -19.199,
              "y": -30.149,
              "z": 0.847
            },
            "rightCorner": {
              "x": -19.196,
              "y": -30.275,
              "z": 0.847
            },
            "gtin": "4052171651617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d692a",
            "leftCorner": {
              "x": -19.152,
              "y": -30.274,
              "z": 0.847
            },
            "rightCorner": {
              "x": -19.15,
              "y": -30.406,
              "z": 0.847
            },
            "gtin": "4052171651730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d692b",
            "leftCorner": {
              "x": -19.156,
              "y": -30.407,
              "z": 0.847
            },
            "rightCorner": {
              "x": -19.152,
              "y": -30.549,
              "z": 0.847
            },
            "gtin": "4052171651679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d692c",
            "leftCorner": {
              "x": -19.156,
              "y": -30.55,
              "z": 0.847
            },
            "rightCorner": {
              "x": -19.153,
              "y": -30.683,
              "z": 0.847
            },
            "gtin": "4052171651648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d692d",
            "leftCorner": {
              "x": -19.165,
              "y": -30.684,
              "z": 0.847
            },
            "rightCorner": {
              "x": -19.163,
              "y": -30.805,
              "z": 0.847
            },
            "gtin": "4052171655752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d692e",
            "leftCorner": {
              "x": -19.22,
              "y": -30.806,
              "z": 0.847
            },
            "rightCorner": {
              "x": -19.217,
              "y": -30.953,
              "z": 0.847
            },
            "gtin": "4052171652287",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d207",
        "height": 1.4313,
        "facings": [
          {
            "id": "68d8e50be1820c81800d691e",
            "leftCorner": {
              "x": -19.195,
              "y": -29.728,
              "z": 1.171
            },
            "rightCorner": {
              "x": -19.2,
              "y": -29.857,
              "z": 1.171
            },
            "gtin": "8718824270838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d691f",
            "leftCorner": {
              "x": -19.189,
              "y": -29.858,
              "z": 1.171
            },
            "rightCorner": {
              "x": -19.186,
              "y": -29.983,
              "z": 1.171
            },
            "gtin": "8718824270838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6920",
            "leftCorner": {
              "x": -19.146,
              "y": -29.982,
              "z": 1.171
            },
            "rightCorner": {
              "x": -19.144,
              "y": -30.106,
              "z": 1.171
            },
            "gtin": "8718824270753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6921",
            "leftCorner": {
              "x": -19.194,
              "y": -30.107,
              "z": 1.171
            },
            "rightCorner": {
              "x": -19.191,
              "y": -30.245,
              "z": 1.171
            },
            "gtin": "8713537391924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6922",
            "leftCorner": {
              "x": -19.173,
              "y": -30.244,
              "z": 1.171
            },
            "rightCorner": {
              "x": -19.17,
              "y": -30.4,
              "z": 1.171
            },
            "gtin": "8718824394602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6923",
            "leftCorner": {
              "x": -19.213,
              "y": -30.4,
              "z": 1.171
            },
            "rightCorner": {
              "x": -19.21,
              "y": -30.557,
              "z": 1.171
            },
            "gtin": "8718824394565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6924",
            "leftCorner": {
              "x": -19.179,
              "y": -30.556,
              "z": 1.171
            },
            "rightCorner": {
              "x": -19.177,
              "y": -30.685,
              "z": 1.171
            },
            "gtin": "8718824385051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6925",
            "leftCorner": {
              "x": -19.173,
              "y": -30.684,
              "z": 1.171
            },
            "rightCorner": {
              "x": -19.171,
              "y": -30.818,
              "z": 1.171
            },
            "gtin": "8720245030762",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6926",
            "leftCorner": {
              "x": -19.176,
              "y": -30.819,
              "z": 1.171
            },
            "rightCorner": {
              "x": -19.174,
              "y": -30.951,
              "z": 1.171
            },
            "gtin": "8720245030731",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d206",
        "height": 1.7767,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6911",
            "leftCorner": {
              "x": -19.224,
              "y": -29.729,
              "z": 1.454
            },
            "rightCorner": {
              "x": -19.218,
              "y": -30.022,
              "z": 1.454
            },
            "gtin": "8718824115375",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6912",
            "leftCorner": {
              "x": -19.155,
              "y": -30.021,
              "z": 1.454
            },
            "rightCorner": {
              "x": -19.151,
              "y": -30.21,
              "z": 1.454
            },
            "gtin": "8718824609782",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6913",
            "leftCorner": {
              "x": -19.207,
              "y": -30.211,
              "z": 1.454
            },
            "rightCorner": {
              "x": -19.204,
              "y": -30.383,
              "z": 1.454
            },
            "gtin": "8720245019477",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6914",
            "leftCorner": {
              "x": -19.124,
              "y": -30.382,
              "z": 1.454
            },
            "rightCorner": {
              "x": -19.121,
              "y": -30.543,
              "z": 1.454
            },
            "gtin": "8718824338774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6915",
            "leftCorner": {
              "x": -19.204,
              "y": -30.544,
              "z": 1.454
            },
            "rightCorner": {
              "x": -19.2,
              "y": -30.686,
              "z": 1.454
            },
            "gtin": "8718824115290",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6916",
            "leftCorner": {
              "x": -19.169,
              "y": -30.686,
              "z": 1.454
            },
            "rightCorner": {
              "x": -19.167,
              "y": -30.831,
              "z": 1.454
            },
            "gtin": "8718824912622",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6917",
            "leftCorner": {
              "x": -19.159,
              "y": -30.83,
              "z": 1.454
            },
            "rightCorner": {
              "x": -19.156,
              "y": -30.953,
              "z": 1.454
            },
            "gtin": "8718824912127",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "502",
    "rightNeighborShelfId": "505"
  },
  {
    "id": "505",
    "name": "505",
    "x": -19.333,
    "y": -30.982,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70006,
      "w": 0.71408
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d70f",
        "height": 0.20746,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d877a",
            "leftCorner": {
              "x": -19.34,
              "y": -30.982,
              "z": 0.17
            },
            "rightCorner": {
              "x": -19.334,
              "y": -31.247,
              "z": 0.17
            },
            "gtin": "4003015000269",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d877c",
            "leftCorner": {
              "x": -19.295,
              "y": -31.246,
              "z": 0.17
            },
            "rightCorner": {
              "x": -19.275,
              "y": -32.251,
              "z": 0.17
            },
            "gtin": "4003015000351",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d710",
        "height": 0.46932,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8780",
            "leftCorner": {
              "x": -19.27,
              "y": -30.981,
              "z": 0.384
            },
            "rightCorner": {
              "x": -19.265,
              "y": -31.272,
              "z": 0.384
            },
            "gtin": "4003015022148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8781",
            "leftCorner": {
              "x": -19.222,
              "y": -31.271,
              "z": 0.384
            },
            "rightCorner": {
              "x": -19.208,
              "y": -31.973,
              "z": 0.384
            },
            "gtin": "4003015022193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8782",
            "leftCorner": {
              "x": -19.21,
              "y": -31.973,
              "z": 0.384
            },
            "rightCorner": {
              "x": -19.207,
              "y": -32.112,
              "z": 0.384
            },
            "gtin": "4003015062595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8783",
            "leftCorner": {
              "x": -19.21,
              "y": -32.112,
              "z": 0.384
            },
            "rightCorner": {
              "x": -19.205,
              "y": -32.362,
              "z": 0.384
            },
            "gtin": "4003015062656",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d70e",
        "height": 0.71521,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d876d",
            "leftCorner": {
              "x": -19.19,
              "y": -30.98,
              "z": 0.585
            },
            "rightCorner": {
              "x": -19.185,
              "y": -31.275,
              "z": 0.585
            },
            "gtin": "4003015046403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d876f",
            "leftCorner": {
              "x": -19.143,
              "y": -31.274,
              "z": 0.585
            },
            "rightCorner": {
              "x": -19.137,
              "y": -31.545,
              "z": 0.585
            },
            "gtin": "4003015046489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8770",
            "leftCorner": {
              "x": -19.14,
              "y": -31.545,
              "z": 0.585
            },
            "rightCorner": {
              "x": -19.137,
              "y": -31.678,
              "z": 0.585
            },
            "gtin": "4003015007473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8771",
            "leftCorner": {
              "x": -19.137,
              "y": -31.678,
              "z": 0.585
            },
            "rightCorner": {
              "x": -19.131,
              "y": -31.971,
              "z": 0.585
            },
            "gtin": "4058401379498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8772",
            "leftCorner": {
              "x": -19.135,
              "y": -31.971,
              "z": 0.585
            },
            "rightCorner": {
              "x": -19.132,
              "y": -32.128,
              "z": 0.585
            },
            "gtin": "4058401068675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8773",
            "leftCorner": {
              "x": -19.139,
              "y": -32.128,
              "z": 0.585
            },
            "rightCorner": {
              "x": -19.137,
              "y": -32.229,
              "z": 0.585
            },
            "gtin": "4058401068798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8774",
            "leftCorner": {
              "x": -19.139,
              "y": -32.229,
              "z": 0.585
            },
            "rightCorner": {
              "x": -19.137,
              "y": -32.363,
              "z": 0.585
            },
            "gtin": "4058401068736",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d70d",
        "height": 0.96257,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8761",
            "leftCorner": {
              "x": -19.14,
              "y": -30.978,
              "z": 0.788
            },
            "rightCorner": {
              "x": -19.134,
              "y": -31.278,
              "z": 0.788
            },
            "gtin": "4003015042702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8762",
            "leftCorner": {
              "x": -19.134,
              "y": -31.278,
              "z": 0.788
            },
            "rightCorner": {
              "x": -19.128,
              "y": -31.577,
              "z": 0.788
            },
            "gtin": "4003015042702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8764",
            "leftCorner": {
              "x": -19.088,
              "y": -31.577,
              "z": 0.788
            },
            "rightCorner": {
              "x": -19.086,
              "y": -31.695,
              "z": 0.788
            },
            "gtin": "4003015042726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8765",
            "leftCorner": {
              "x": -19.086,
              "y": -31.695,
              "z": 0.788
            },
            "rightCorner": {
              "x": -19.083,
              "y": -31.848,
              "z": 0.788
            },
            "gtin": "4003015001952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8766",
            "leftCorner": {
              "x": -19.087,
              "y": -31.849,
              "z": 0.788
            },
            "rightCorner": {
              "x": -19.084,
              "y": -32.027,
              "z": 0.788
            },
            "gtin": "4058401106797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8767",
            "leftCorner": {
              "x": -19.086,
              "y": -32.028,
              "z": 0.788
            },
            "rightCorner": {
              "x": -19.08,
              "y": -32.366,
              "z": 0.788
            },
            "gtin": "4058401106698",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d70c",
        "height": 1.313,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8758",
            "leftCorner": {
              "x": -19.097,
              "y": -30.978,
              "z": 1.074
            },
            "rightCorner": {
              "x": -19.087,
              "y": -31.492,
              "z": 1.074
            },
            "gtin": "4058401019639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8759",
            "leftCorner": {
              "x": -19.047,
              "y": -31.491,
              "z": 1.074
            },
            "rightCorner": {
              "x": -19.042,
              "y": -31.754,
              "z": 1.074
            },
            "gtin": "4058401349224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d875a",
            "leftCorner": {
              "x": -19.047,
              "y": -31.754,
              "z": 1.074
            },
            "rightCorner": {
              "x": -19.041,
              "y": -32.039,
              "z": 1.074
            },
            "gtin": "4058401134844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d875b",
            "leftCorner": {
              "x": -19.027,
              "y": -32.039,
              "z": 1.074
            },
            "rightCorner": {
              "x": -19.022,
              "y": -32.294,
              "z": 1.074
            },
            "gtin": "4058401660251",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d70b",
        "height": 1.551,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d874e",
            "leftCorner": {
              "x": -19.097,
              "y": -30.978,
              "z": 1.269
            },
            "rightCorner": {
              "x": -19.091,
              "y": -31.278,
              "z": 1.269
            },
            "gtin": "4058401397225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8750",
            "leftCorner": {
              "x": -19.038,
              "y": -31.277,
              "z": 1.269
            },
            "rightCorner": {
              "x": -19.032,
              "y": -31.557,
              "z": 1.269
            },
            "gtin": "4058401599025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8751",
            "leftCorner": {
              "x": -19.049,
              "y": -31.557,
              "z": 1.269
            },
            "rightCorner": {
              "x": -19.037,
              "y": -32.139,
              "z": 1.269
            },
            "gtin": "4058401391544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8752",
            "leftCorner": {
              "x": -19.034,
              "y": -32.139,
              "z": 1.269
            },
            "rightCorner": {
              "x": -19.032,
              "y": -32.274,
              "z": 1.269
            },
            "gtin": "4058401579713",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d70a",
        "height": 1.8049,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8743",
            "leftCorner": {
              "x": -19.095,
              "y": -30.978,
              "z": 1.477
            },
            "rightCorner": {
              "x": -19.085,
              "y": -31.497,
              "z": 1.477
            },
            "gtin": "4058401025005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8745",
            "leftCorner": {
              "x": -19.043,
              "y": -31.497,
              "z": 1.477
            },
            "rightCorner": {
              "x": -19.037,
              "y": -31.794,
              "z": 1.477
            },
            "gtin": "4058401322876",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d8746",
            "leftCorner": {
              "x": -19.043,
              "y": -31.795,
              "z": 1.477
            },
            "rightCorner": {
              "x": -19.04,
              "y": -31.904,
              "z": 1.477
            },
            "gtin": "4058401349026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8747",
            "leftCorner": {
              "x": -19.039,
              "y": -31.904,
              "z": 1.477
            },
            "rightCorner": {
              "x": -19.037,
              "y": -32.018,
              "z": 1.477
            },
            "gtin": "4058401437686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8748",
            "leftCorner": {
              "x": -19.034,
              "y": -32.018,
              "z": 1.477
            },
            "rightCorner": {
              "x": -19.032,
              "y": -32.136,
              "z": 1.477
            },
            "gtin": "4058401534460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8749",
            "leftCorner": {
              "x": -19.045,
              "y": -32.136,
              "z": 1.477
            },
            "rightCorner": {
              "x": -19.039,
              "y": -32.407,
              "z": 1.477
            },
            "gtin": "4058401395627",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "504",
    "rightNeighborShelfId": "506"
  },
  {
    "id": "506",
    "name": "506",
    "x": -19.308,
    "y": -32.232,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70006,
      "w": 0.71408
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d719",
        "height": 0.21292,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d877d",
            "leftCorner": {
              "x": -19.287,
              "y": -32.252,
              "z": 0.174
            },
            "rightCorner": {
              "x": -19.283,
              "y": -32.415,
              "z": 0.174
            },
            "gtin": "4058401405623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d877e",
            "leftCorner": {
              "x": -19.284,
              "y": -32.415,
              "z": 0.174
            },
            "rightCorner": {
              "x": -19.28,
              "y": -32.603,
              "z": 0.174
            },
            "gtin": "4003015003260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d877f",
            "leftCorner": {
              "x": -19.277,
              "y": -32.603,
              "z": 0.174
            },
            "rightCorner": {
              "x": -19.276,
              "y": -32.688,
              "z": 0.174
            },
            "gtin": "4003015003604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d877b",
            "leftCorner": {
              "x": -19.279,
              "y": -32.688,
              "z": 0.174
            },
            "rightCorner": {
              "x": -19.264,
              "y": -33.481,
              "z": 0.174
            },
            "gtin": "4003015003352",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d713",
        "height": 0.46994,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8784",
            "leftCorner": {
              "x": -19.207,
              "y": -32.362,
              "z": 0.384
            },
            "rightCorner": {
              "x": -19.192,
              "y": -33.104,
              "z": 0.384
            },
            "gtin": "4003015007886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a03243bb16a284f89095e0db",
            "leftCorner": {
              "x": -19.245,
              "y": -32.23,
              "z": 0.384
            },
            "rightCorner": {
              "x": -19.243,
              "y": -32.308,
              "z": 0.384
            },
            "gtin": "4003015060980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8785",
            "leftCorner": {
              "x": -19.183,
              "y": -33.104,
              "z": 0.384
            },
            "rightCorner": {
              "x": -19.175,
              "y": -33.499,
              "z": 0.384
            },
            "gtin": "4003015060980",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d714",
        "height": 0.71326,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8775",
            "leftCorner": {
              "x": -19.135,
              "y": -32.363,
              "z": 0.584
            },
            "rightCorner": {
              "x": -19.131,
              "y": -32.523,
              "z": 0.584
            },
            "gtin": "4003015548495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9234afbf9c1e040e8fb16ec3",
            "leftCorner": {
              "x": -19.184,
              "y": -32.229,
              "z": 0.584
            },
            "rightCorner": {
              "x": -19.182,
              "y": -32.353,
              "z": 0.584
            },
            "gtin": "4003015007558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8776",
            "leftCorner": {
              "x": -19.135,
              "y": -32.523,
              "z": 0.584
            },
            "rightCorner": {
              "x": -19.13,
              "y": -32.795,
              "z": 0.584
            },
            "gtin": "4003015002188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8777",
            "leftCorner": {
              "x": -19.133,
              "y": -32.795,
              "z": 0.584
            },
            "rightCorner": {
              "x": -19.13,
              "y": -32.946,
              "z": 0.584
            },
            "gtin": "4003015648645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8778",
            "leftCorner": {
              "x": -19.132,
              "y": -32.946,
              "z": 0.584
            },
            "rightCorner": {
              "x": -19.125,
              "y": -33.276,
              "z": 0.584
            },
            "gtin": "4003015007572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8779",
            "leftCorner": {
              "x": -19.127,
              "y": -33.276,
              "z": 0.584
            },
            "rightCorner": {
              "x": -19.125,
              "y": -33.399,
              "z": 0.584
            },
            "gtin": "4003015007558",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d718",
        "height": 0.96159,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8768",
            "leftCorner": {
              "x": -19.084,
              "y": -32.366,
              "z": 0.787
            },
            "rightCorner": {
              "x": -19.08,
              "y": -32.538,
              "z": 0.787
            },
            "gtin": "4003015548624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8769",
            "leftCorner": {
              "x": -19.084,
              "y": -32.538,
              "z": 0.787
            },
            "rightCorner": {
              "x": -19.079,
              "y": -32.789,
              "z": 0.787
            },
            "gtin": "4003015009743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d876a",
            "leftCorner": {
              "x": -19.082,
              "y": -32.79,
              "z": 0.787
            },
            "rightCorner": {
              "x": -19.078,
              "y": -32.96,
              "z": 0.787
            },
            "gtin": "4003015002683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d876b",
            "leftCorner": {
              "x": -19.081,
              "y": -32.96,
              "z": 0.787
            },
            "rightCorner": {
              "x": -19.078,
              "y": -33.144,
              "z": 0.787
            },
            "gtin": "4003015648621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d876c",
            "leftCorner": {
              "x": -19.079,
              "y": -33.144,
              "z": 0.787
            },
            "rightCorner": {
              "x": -19.074,
              "y": -33.395,
              "z": 0.787
            },
            "gtin": "4003015022056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8763",
            "leftCorner": {
              "x": -19.078,
              "y": -33.395,
              "z": 0.787
            },
            "rightCorner": {
              "x": -19.076,
              "y": -33.478,
              "z": 0.787
            },
            "gtin": "4058401399762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d0b08b40105b860ba1108c24",
            "leftCorner": {
              "x": -19.132,
              "y": -32.228,
              "z": 0.787
            },
            "rightCorner": {
              "x": -19.131,
              "y": -32.302,
              "z": 0.787
            },
            "gtin": "4058401399762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a8e2a0b6b14bcb35193dabb6",
            "leftCorner": {
              "x": -19.131,
              "y": -32.302,
              "z": 0.787
            },
            "rightCorner": {
              "x": -19.13,
              "y": -32.354,
              "z": 0.787
            },
            "gtin": "4058401399762",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d716",
        "height": 1.3089,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d875c",
            "leftCorner": {
              "x": -19.028,
              "y": -32.293,
              "z": 1.071
            },
            "rightCorner": {
              "x": -19.025,
              "y": -32.419,
              "z": 1.071
            },
            "gtin": "4058401198891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6df96aa1ae599aba1cfff588",
            "leftCorner": {
              "x": -19.092,
              "y": -32.228,
              "z": 1.071
            },
            "rightCorner": {
              "x": -19.091,
              "y": -32.293,
              "z": 1.071
            },
            "gtin": "4058401109699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d875d",
            "leftCorner": {
              "x": -19.043,
              "y": -32.419,
              "z": 1.071
            },
            "rightCorner": {
              "x": -19.035,
              "y": -32.852,
              "z": 1.071
            },
            "gtin": "4003015047004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d875e",
            "leftCorner": {
              "x": -19.045,
              "y": -32.852,
              "z": 1.071
            },
            "rightCorner": {
              "x": -19.042,
              "y": -32.974,
              "z": 1.071
            },
            "gtin": "4003015010053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d875f",
            "leftCorner": {
              "x": -19.041,
              "y": -32.974,
              "z": 1.071
            },
            "rightCorner": {
              "x": -19.037,
              "y": -33.218,
              "z": 1.071
            },
            "gtin": "4003015044157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8760",
            "leftCorner": {
              "x": -19.029,
              "y": -33.218,
              "z": 1.071
            },
            "rightCorner": {
              "x": -19.024,
              "y": -33.464,
              "z": 1.071
            },
            "gtin": "4058401342928",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d715",
        "height": 1.5557,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8753",
            "leftCorner": {
              "x": -19.021,
              "y": -32.273,
              "z": 1.273
            },
            "rightCorner": {
              "x": -19.018,
              "y": -32.409,
              "z": 1.273
            },
            "gtin": "4058401202499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8754",
            "leftCorner": {
              "x": -19.029,
              "y": -32.409,
              "z": 1.273
            },
            "rightCorner": {
              "x": -19.025,
              "y": -32.618,
              "z": 1.273
            },
            "gtin": "4058401296856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8755",
            "leftCorner": {
              "x": -19.038,
              "y": -32.618,
              "z": 1.273
            },
            "rightCorner": {
              "x": -19.037,
              "y": -32.709,
              "z": 1.273
            },
            "gtin": "4058401691477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8756",
            "leftCorner": {
              "x": -19.039,
              "y": -32.709,
              "z": 1.273
            },
            "rightCorner": {
              "x": -19.035,
              "y": -32.955,
              "z": 1.273
            },
            "gtin": "4058401397836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8757",
            "leftCorner": {
              "x": -19.032,
              "y": -32.955,
              "z": 1.273
            },
            "rightCorner": {
              "x": -19.023,
              "y": -33.437,
              "z": 1.273
            },
            "gtin": "4058401070258",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d717",
        "height": 1.8098,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d874a",
            "leftCorner": {
              "x": -19.035,
              "y": -32.406,
              "z": 1.481
            },
            "rightCorner": {
              "x": -19.028,
              "y": -32.786,
              "z": 1.481
            },
            "gtin": "4003015023787",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "42e2c6d25fcde7ade1d2ca22",
            "leftCorner": {
              "x": -19.079,
              "y": -32.227,
              "z": 1.481
            },
            "rightCorner": {
              "x": -19.076,
              "y": -32.37,
              "z": 1.481
            },
            "gtin": "4058401506801",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d874b",
            "leftCorner": {
              "x": -19.008,
              "y": -32.786,
              "z": 1.481
            },
            "rightCorner": {
              "x": -19.004,
              "y": -33.027,
              "z": 1.481
            },
            "gtin": "4058401071347",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d874c",
            "leftCorner": {
              "x": -19.024,
              "y": -33.027,
              "z": 1.481
            },
            "rightCorner": {
              "x": -19.018,
              "y": -33.344,
              "z": 1.481
            },
            "gtin": "4058401381859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d874d",
            "leftCorner": {
              "x": -19.041,
              "y": -33.344,
              "z": 1.481
            },
            "rightCorner": {
              "x": -19.039,
              "y": -33.434,
              "z": 1.481
            },
            "gtin": "4058401341440",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "505"
  },
  {
    "id": "507",
    "name": "507",
    "x": -19.155,
    "y": -35.836,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70091,
      "w": 0.71325
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 97
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d211",
        "height": 0.17287,
        "facings": [
          {
            "id": "68d8e50be1820c81800d69ba",
            "leftCorner": {
              "x": -19.212,
              "y": -36.418,
              "z": 0.141
            },
            "rightCorner": {
              "x": -19.211,
              "y": -36.524,
              "z": 0.141
            },
            "gtin": "4062829033665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b5baf1de31bb457426d1fa96",
            "leftCorner": {
              "x": -19.262,
              "y": -35.838,
              "z": 0.141
            },
            "rightCorner": {
              "x": -19.26,
              "y": -35.943,
              "z": 0.141
            },
            "gtin": "4062829033665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "66848e19e5271229875757c9",
            "leftCorner": {
              "x": -19.26,
              "y": -35.943,
              "z": 0.141
            },
            "rightCorner": {
              "x": -19.258,
              "y": -36.048,
              "z": 0.141
            },
            "gtin": "4062829033665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "320ff428d52a5d6a69378db3",
            "leftCorner": {
              "x": -19.258,
              "y": -36.048,
              "z": 0.141
            },
            "rightCorner": {
              "x": -19.257,
              "y": -36.153,
              "z": 0.141
            },
            "gtin": "4062829033665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "535230298fc1dbbb7ee34c08",
            "leftCorner": {
              "x": -19.257,
              "y": -36.153,
              "z": 0.141
            },
            "rightCorner": {
              "x": -19.255,
              "y": -36.258,
              "z": 0.141
            },
            "gtin": "4062829033665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3d499560751bcc57010d18cc",
            "leftCorner": {
              "x": -19.255,
              "y": -36.258,
              "z": 0.141
            },
            "rightCorner": {
              "x": -19.253,
              "y": -36.363,
              "z": 0.141
            },
            "gtin": "4062829033665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "80b6d06a38622e4d41370734",
            "leftCorner": {
              "x": -19.248,
              "y": -36.665,
              "z": 0.141
            },
            "rightCorner": {
              "x": -19.246,
              "y": -36.77,
              "z": 0.141
            },
            "gtin": "4062829033665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "218202277a2a5560d0d46bda",
            "leftCorner": {
              "x": -19.246,
              "y": -36.77,
              "z": 0.141
            },
            "rightCorner": {
              "x": -19.244,
              "y": -36.875,
              "z": 0.141
            },
            "gtin": "4062829033665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e51d425f54bffd619968fce8",
            "leftCorner": {
              "x": -19.244,
              "y": -36.875,
              "z": 0.141
            },
            "rightCorner": {
              "x": -19.242,
              "y": -36.98,
              "z": 0.141
            },
            "gtin": "4062829033665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "701e1fcc65881910d07b1b48",
            "leftCorner": {
              "x": -19.242,
              "y": -36.98,
              "z": 0.141
            },
            "rightCorner": {
              "x": -19.24,
              "y": -37.085,
              "z": 0.141
            },
            "gtin": "4062829033665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69bb",
            "leftCorner": {
              "x": -19.213,
              "y": -36.524,
              "z": 0.141
            },
            "rightCorner": {
              "x": -19.21,
              "y": -36.664,
              "z": 0.141
            },
            "gtin": "4031052837005",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d20f",
        "height": 0.49387,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6982",
            "leftCorner": {
              "x": -19.214,
              "y": -35.837,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.212,
              "y": -35.939,
              "z": 0.404
            },
            "gtin": "4031052028298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6984",
            "leftCorner": {
              "x": -19.17,
              "y": -35.939,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.169,
              "y": -36.011,
              "z": 0.404
            },
            "gtin": "4031052093197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6985",
            "leftCorner": {
              "x": -19.169,
              "y": -36.011,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.168,
              "y": -36.071,
              "z": 0.404
            },
            "gtin": "4031052086533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6986",
            "leftCorner": {
              "x": -19.17,
              "y": -36.071,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.169,
              "y": -36.139,
              "z": 0.404
            },
            "gtin": "4031052086397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6987",
            "leftCorner": {
              "x": -19.173,
              "y": -36.139,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.172,
              "y": -36.196,
              "z": 0.404
            },
            "gtin": "4031052223846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6988",
            "leftCorner": {
              "x": -19.171,
              "y": -36.196,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.17,
              "y": -36.27,
              "z": 0.404
            },
            "gtin": "4031052223846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6989",
            "leftCorner": {
              "x": -19.169,
              "y": -36.27,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.168,
              "y": -36.333,
              "z": 0.404
            },
            "gtin": "4031052466991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d698a",
            "leftCorner": {
              "x": -19.165,
              "y": -36.333,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.164,
              "y": -36.396,
              "z": 0.404
            },
            "gtin": "4031052147807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d698b",
            "leftCorner": {
              "x": -19.164,
              "y": -36.396,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.163,
              "y": -36.463,
              "z": 0.404
            },
            "gtin": "4062828283641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d698c",
            "leftCorner": {
              "x": -19.163,
              "y": -36.463,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.161,
              "y": -36.547,
              "z": 0.404
            },
            "gtin": "4062828283467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d698d",
            "leftCorner": {
              "x": -19.165,
              "y": -36.547,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.164,
              "y": -36.609,
              "z": 0.404
            },
            "gtin": "4031052658013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d698e",
            "leftCorner": {
              "x": -19.163,
              "y": -36.609,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.162,
              "y": -36.678,
              "z": 0.404
            },
            "gtin": "4031052467653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d698f",
            "leftCorner": {
              "x": -19.16,
              "y": -36.678,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.158,
              "y": -36.743,
              "z": 0.404
            },
            "gtin": "4031052509650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6990",
            "leftCorner": {
              "x": -19.157,
              "y": -36.743,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.156,
              "y": -36.804,
              "z": 0.404
            },
            "gtin": "4031052514968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6991",
            "leftCorner": {
              "x": -19.155,
              "y": -36.804,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.153,
              "y": -36.875,
              "z": 0.404
            },
            "gtin": "4031052351198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6992",
            "leftCorner": {
              "x": -19.155,
              "y": -36.875,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.154,
              "y": -36.939,
              "z": 0.404
            },
            "gtin": "4031052707452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6993",
            "leftCorner": {
              "x": -19.155,
              "y": -36.939,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.153,
              "y": -37.002,
              "z": 0.404
            },
            "gtin": "4031052477386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6994",
            "leftCorner": {
              "x": -19.153,
              "y": -37.002,
              "z": 0.404
            },
            "rightCorner": {
              "x": -19.151,
              "y": -37.102,
              "z": 0.404
            },
            "gtin": "4031052338991",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d210",
        "height": 0.76705,
        "facings": [
          {
            "id": "68d8e50be1820c81800d699d",
            "leftCorner": {
              "x": -19.215,
              "y": -35.837,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.212,
              "y": -35.958,
              "z": 0.628
            },
            "gtin": "4035625535879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d699f",
            "leftCorner": {
              "x": -19.169,
              "y": -35.957,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.167,
              "y": -36.056,
              "z": 0.628
            },
            "gtin": "4007698470937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69a0",
            "leftCorner": {
              "x": -19.171,
              "y": -36.056,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.17,
              "y": -36.14,
              "z": 0.628
            },
            "gtin": "4007698470999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69a1",
            "leftCorner": {
              "x": -19.174,
              "y": -36.14,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.172,
              "y": -36.207,
              "z": 0.628
            },
            "gtin": "8721037175661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69a2",
            "leftCorner": {
              "x": -19.172,
              "y": -36.207,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.17,
              "y": -36.287,
              "z": 0.628
            },
            "gtin": "8711711156017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69a3",
            "leftCorner": {
              "x": -19.168,
              "y": -36.287,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.166,
              "y": -36.379,
              "z": 0.628
            },
            "gtin": "8711711156024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69a4",
            "leftCorner": {
              "x": -19.165,
              "y": -36.379,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.163,
              "y": -36.485,
              "z": 0.628
            },
            "gtin": "4031052168260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69a5",
            "leftCorner": {
              "x": -19.163,
              "y": -36.485,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.162,
              "y": -36.583,
              "z": 0.628
            },
            "gtin": "4306188342571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69a6",
            "leftCorner": {
              "x": -19.162,
              "y": -36.583,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.16,
              "y": -36.707,
              "z": 0.628
            },
            "gtin": "4306188342335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69a7",
            "leftCorner": {
              "x": -19.158,
              "y": -36.707,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.157,
              "y": -36.807,
              "z": 0.628
            },
            "gtin": "4306188342366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69a8",
            "leftCorner": {
              "x": -19.153,
              "y": -36.807,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.152,
              "y": -36.878,
              "z": 0.628
            },
            "gtin": "4306188342397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69a9",
            "leftCorner": {
              "x": -19.15,
              "y": -36.878,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.149,
              "y": -36.954,
              "z": 0.628
            },
            "gtin": "4306188342427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69aa",
            "leftCorner": {
              "x": -19.154,
              "y": -36.954,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.153,
              "y": -37.032,
              "z": 0.628
            },
            "gtin": "4306188342458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69ab",
            "leftCorner": {
              "x": -19.155,
              "y": -37.032,
              "z": 0.628
            },
            "rightCorner": {
              "x": -19.154,
              "y": -37.103,
              "z": 0.628
            },
            "gtin": "4306188342489",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d20d",
        "height": 1.0774,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6950",
            "leftCorner": {
              "x": -19.211,
              "y": -35.837,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.209,
              "y": -35.949,
              "z": 0.882
            },
            "gtin": "4062829027534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6951",
            "leftCorner": {
              "x": -19.169,
              "y": -35.949,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.167,
              "y": -36.015,
              "z": 0.882
            },
            "gtin": "4062829027572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6952",
            "leftCorner": {
              "x": -19.168,
              "y": -36.015,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.167,
              "y": -36.084,
              "z": 0.882
            },
            "gtin": "4062828285461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6953",
            "leftCorner": {
              "x": -19.173,
              "y": -36.084,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.171,
              "y": -36.161,
              "z": 0.882
            },
            "gtin": "4062828285232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6954",
            "leftCorner": {
              "x": -19.17,
              "y": -36.161,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.169,
              "y": -36.23,
              "z": 0.882
            },
            "gtin": "4062828285553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6955",
            "leftCorner": {
              "x": -19.167,
              "y": -36.23,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.165,
              "y": -36.294,
              "z": 0.882
            },
            "gtin": "4062828286048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6956",
            "leftCorner": {
              "x": -19.164,
              "y": -36.294,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.162,
              "y": -36.38,
              "z": 0.882
            },
            "gtin": "4031052276279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6957",
            "leftCorner": {
              "x": -19.163,
              "y": -36.38,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.161,
              "y": -36.444,
              "z": 0.882
            },
            "gtin": "4031052276293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6958",
            "leftCorner": {
              "x": -19.16,
              "y": -36.444,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.159,
              "y": -36.516,
              "z": 0.882
            },
            "gtin": "4031052014024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6959",
            "leftCorner": {
              "x": -19.16,
              "y": -36.516,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.159,
              "y": -36.592,
              "z": 0.882
            },
            "gtin": "4031052014086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d695a",
            "leftCorner": {
              "x": -19.158,
              "y": -36.592,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.157,
              "y": -36.662,
              "z": 0.882
            },
            "gtin": "4031052648168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d695b",
            "leftCorner": {
              "x": -19.155,
              "y": -36.662,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.154,
              "y": -36.737,
              "z": 0.882
            },
            "gtin": "4031052790393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d695c",
            "leftCorner": {
              "x": -19.152,
              "y": -36.737,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.151,
              "y": -36.809,
              "z": 0.882
            },
            "gtin": "4031052276286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d695d",
            "leftCorner": {
              "x": -19.149,
              "y": -36.808,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.148,
              "y": -36.876,
              "z": 0.882
            },
            "gtin": "4031052276309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d695e",
            "leftCorner": {
              "x": -19.147,
              "y": -36.876,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.145,
              "y": -36.972,
              "z": 0.882
            },
            "gtin": "4031052764417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d695f",
            "leftCorner": {
              "x": -19.151,
              "y": -36.972,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.15,
              "y": -37.024,
              "z": 0.882
            },
            "gtin": "8711295311499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6960",
            "leftCorner": {
              "x": -19.152,
              "y": -37.024,
              "z": 0.882
            },
            "rightCorner": {
              "x": -19.151,
              "y": -37.06,
              "z": 0.882
            },
            "gtin": "4019581910345",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d20c",
        "height": 1.3842,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6936",
            "leftCorner": {
              "x": -19.214,
              "y": -35.837,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.212,
              "y": -35.951,
              "z": 1.133
            },
            "gtin": "4031052013980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6938",
            "leftCorner": {
              "x": -19.165,
              "y": -35.95,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.164,
              "y": -36.009,
              "z": 1.133
            },
            "gtin": "4031052014031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6939",
            "leftCorner": {
              "x": -19.167,
              "y": -36.009,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.166,
              "y": -36.082,
              "z": 1.133
            },
            "gtin": "4031052022142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d693a",
            "leftCorner": {
              "x": -19.17,
              "y": -36.082,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.169,
              "y": -36.131,
              "z": 1.133
            },
            "gtin": "4062828285355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d693b",
            "leftCorner": {
              "x": -19.17,
              "y": -36.131,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.169,
              "y": -36.21,
              "z": 1.133
            },
            "gtin": "4062828285355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d693c",
            "leftCorner": {
              "x": -19.167,
              "y": -36.209,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.166,
              "y": -36.282,
              "z": 1.133
            },
            "gtin": "4062828285256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d693d",
            "leftCorner": {
              "x": -19.167,
              "y": -36.282,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.165,
              "y": -36.357,
              "z": 1.133
            },
            "gtin": "4031052022210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d693e",
            "leftCorner": {
              "x": -19.165,
              "y": -36.357,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.164,
              "y": -36.427,
              "z": 1.133
            },
            "gtin": "4031052022289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d693f",
            "leftCorner": {
              "x": -19.165,
              "y": -36.427,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.163,
              "y": -36.494,
              "z": 1.133
            },
            "gtin": "4031052327605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6940",
            "leftCorner": {
              "x": -19.163,
              "y": -36.494,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.162,
              "y": -36.573,
              "z": 1.133
            },
            "gtin": "4031052327612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6941",
            "leftCorner": {
              "x": -19.161,
              "y": -36.573,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.16,
              "y": -36.652,
              "z": 1.133
            },
            "gtin": "4062828299871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6942",
            "leftCorner": {
              "x": -19.16,
              "y": -36.652,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.158,
              "y": -36.715,
              "z": 1.133
            },
            "gtin": "4062828285522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6943",
            "leftCorner": {
              "x": -19.154,
              "y": -36.715,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.153,
              "y": -36.791,
              "z": 1.133
            },
            "gtin": "4031052979231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6944",
            "leftCorner": {
              "x": -19.155,
              "y": -36.791,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.153,
              "y": -36.858,
              "z": 1.133
            },
            "gtin": "4031052966484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6945",
            "leftCorner": {
              "x": -19.153,
              "y": -36.858,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.152,
              "y": -36.937,
              "z": 1.133
            },
            "gtin": "4031052536649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6946",
            "leftCorner": {
              "x": -19.152,
              "y": -36.937,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.151,
              "y": -37.008,
              "z": 1.133
            },
            "gtin": "4031052535765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6947",
            "leftCorner": {
              "x": -19.154,
              "y": -37.008,
              "z": 1.133
            },
            "rightCorner": {
              "x": -19.152,
              "y": -37.104,
              "z": 1.133
            },
            "gtin": "8721071196387",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d20e",
        "height": 1.6585,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6961",
            "leftCorner": {
              "x": -19.212,
              "y": -35.837,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.211,
              "y": -35.886,
              "z": 1.357
            },
            "gtin": "4031052869648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "12e3478cada0392a68897c1a",
            "leftCorner": {
              "x": -19.201,
              "y": -36.445,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.2,
              "y": -36.501,
              "z": 1.357
            },
            "gtin": "4031052730627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6962",
            "leftCorner": {
              "x": -19.211,
              "y": -35.886,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.21,
              "y": -35.936,
              "z": 1.357
            },
            "gtin": "4031052869648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6964",
            "leftCorner": {
              "x": -19.165,
              "y": -35.935,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.164,
              "y": -35.994,
              "z": 1.357
            },
            "gtin": "4031052912696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6965",
            "leftCorner": {
              "x": -19.163,
              "y": -35.994,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.162,
              "y": -36.056,
              "z": 1.357
            },
            "gtin": "4031052317231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6966",
            "leftCorner": {
              "x": -19.167,
              "y": -36.056,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.166,
              "y": -36.108,
              "z": 1.357
            },
            "gtin": "4031052713378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6967",
            "leftCorner": {
              "x": -19.17,
              "y": -36.108,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.169,
              "y": -36.194,
              "z": 1.357
            },
            "gtin": "4031052713378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6968",
            "leftCorner": {
              "x": -19.168,
              "y": -36.194,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.167,
              "y": -36.252,
              "z": 1.357
            },
            "gtin": "4031052487590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6969",
            "leftCorner": {
              "x": -19.165,
              "y": -36.252,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.164,
              "y": -36.312,
              "z": 1.357
            },
            "gtin": "4031052091018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d696a",
            "leftCorner": {
              "x": -19.165,
              "y": -36.312,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.163,
              "y": -36.374,
              "z": 1.357
            },
            "gtin": "4031052091018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d696b",
            "leftCorner": {
              "x": -19.162,
              "y": -36.374,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.16,
              "y": -36.444,
              "z": 1.357
            },
            "gtin": "4031052236785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d696d",
            "leftCorner": {
              "x": -19.159,
              "y": -36.5,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.158,
              "y": -36.564,
              "z": 1.357
            },
            "gtin": "4031052887338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d696e",
            "leftCorner": {
              "x": -19.159,
              "y": -36.564,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.158,
              "y": -36.625,
              "z": 1.357
            },
            "gtin": "4031052535673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d696f",
            "leftCorner": {
              "x": -19.158,
              "y": -36.625,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.157,
              "y": -36.685,
              "z": 1.357
            },
            "gtin": "4031052542626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6970",
            "leftCorner": {
              "x": -19.156,
              "y": -36.685,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.155,
              "y": -36.753,
              "z": 1.357
            },
            "gtin": "4031052384622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6971",
            "leftCorner": {
              "x": -19.155,
              "y": -36.753,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.154,
              "y": -36.808,
              "z": 1.357
            },
            "gtin": "4031052384639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6972",
            "leftCorner": {
              "x": -19.153,
              "y": -36.808,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.152,
              "y": -36.869,
              "z": 1.357
            },
            "gtin": "4031052730627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6973",
            "leftCorner": {
              "x": -19.149,
              "y": -36.869,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.148,
              "y": -36.935,
              "z": 1.357
            },
            "gtin": "4031052325373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6974",
            "leftCorner": {
              "x": -19.153,
              "y": -36.935,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.15,
              "y": -37.055,
              "z": 1.357
            },
            "gtin": "4035625435957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6975",
            "leftCorner": {
              "x": -19.154,
              "y": -37.055,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.152,
              "y": -37.148,
              "z": 1.357
            },
            "gtin": "4035625435964",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "508"
  },
  {
    "id": "508",
    "name": "508",
    "x": -19.133,
    "y": -37.086,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70091,
      "w": 0.71325
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 60
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d218",
        "height": 0.16687,
        "facings": [
          {
            "id": "68d8e50be1820c81800d69bf",
            "leftCorner": {
              "x": -19.194,
              "y": -37.119,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.192,
              "y": -37.231,
              "z": 0.137
            },
            "gtin": "4006822212504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69c0",
            "leftCorner": {
              "x": -19.189,
              "y": -37.231,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.189,
              "y": -37.291,
              "z": 0.137
            },
            "gtin": "4006822318251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69c1",
            "leftCorner": {
              "x": -19.189,
              "y": -37.291,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.188,
              "y": -37.352,
              "z": 0.137
            },
            "gtin": "4006822318251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69c2",
            "leftCorner": {
              "x": -19.188,
              "y": -37.352,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.186,
              "y": -37.412,
              "z": 0.137
            },
            "gtin": "4006822318251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69c3",
            "leftCorner": {
              "x": -19.187,
              "y": -37.412,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.186,
              "y": -37.483,
              "z": 0.137
            },
            "gtin": "4002832001350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69c4",
            "leftCorner": {
              "x": -19.182,
              "y": -37.483,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.181,
              "y": -37.553,
              "z": 0.137
            },
            "gtin": "4006822312600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69c5",
            "leftCorner": {
              "x": -19.185,
              "y": -37.553,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.184,
              "y": -37.632,
              "z": 0.137
            },
            "gtin": "4006822318022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69c6",
            "leftCorner": {
              "x": -19.184,
              "y": -37.632,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.183,
              "y": -37.7,
              "z": 0.137
            },
            "gtin": "4006822312709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69c7",
            "leftCorner": {
              "x": -19.184,
              "y": -37.7,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.183,
              "y": -37.772,
              "z": 0.137
            },
            "gtin": "4006822120205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69c8",
            "leftCorner": {
              "x": -19.183,
              "y": -37.772,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.182,
              "y": -37.857,
              "z": 0.137
            },
            "gtin": "8717847142146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69c9",
            "leftCorner": {
              "x": -19.185,
              "y": -37.857,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.183,
              "y": -37.951,
              "z": 0.137
            },
            "gtin": "8717847158055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69ca",
            "leftCorner": {
              "x": -19.181,
              "y": -37.951,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.18,
              "y": -37.996,
              "z": 0.137
            },
            "gtin": "8717847089632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69cb",
            "leftCorner": {
              "x": -19.184,
              "y": -37.996,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.182,
              "y": -38.086,
              "z": 0.137
            },
            "gtin": "8717847089861",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d213",
        "height": 0.49068,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6995",
            "leftCorner": {
              "x": -19.155,
              "y": -37.102,
              "z": 0.401
            },
            "rightCorner": {
              "x": -19.153,
              "y": -37.22,
              "z": 0.401
            },
            "gtin": "8717847186010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6996",
            "leftCorner": {
              "x": -19.152,
              "y": -37.22,
              "z": 0.401
            },
            "rightCorner": {
              "x": -19.151,
              "y": -37.334,
              "z": 0.401
            },
            "gtin": "8717847186027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6997",
            "leftCorner": {
              "x": -19.149,
              "y": -37.333,
              "z": 0.401
            },
            "rightCorner": {
              "x": -19.147,
              "y": -37.405,
              "z": 0.401
            },
            "gtin": "8717847079381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6998",
            "leftCorner": {
              "x": -19.147,
              "y": -37.405,
              "z": 0.401
            },
            "rightCorner": {
              "x": -19.146,
              "y": -37.477,
              "z": 0.401
            },
            "gtin": "8717847079381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6999",
            "leftCorner": {
              "x": -19.146,
              "y": -37.477,
              "z": 0.401
            },
            "rightCorner": {
              "x": -19.145,
              "y": -37.54,
              "z": 0.401
            },
            "gtin": "8717847079404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d699a",
            "leftCorner": {
              "x": -19.145,
              "y": -37.54,
              "z": 0.401
            },
            "rightCorner": {
              "x": -19.144,
              "y": -37.603,
              "z": 0.401
            },
            "gtin": "8717847079404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d699b",
            "leftCorner": {
              "x": -19.143,
              "y": -37.603,
              "z": 0.401
            },
            "rightCorner": {
              "x": -19.142,
              "y": -37.71,
              "z": 0.401
            },
            "gtin": "8717847084545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d699c",
            "leftCorner": {
              "x": -19.144,
              "y": -37.71,
              "z": 0.401
            },
            "rightCorner": {
              "x": -19.142,
              "y": -37.831,
              "z": 0.401
            },
            "gtin": "8717847084538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6983",
            "leftCorner": {
              "x": -19.145,
              "y": -37.831,
              "z": 0.401
            },
            "rightCorner": {
              "x": -19.14,
              "y": -38.086,
              "z": 0.401
            },
            "gtin": "8717847185624",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d217",
        "height": 0.76493,
        "facings": [
          {
            "id": "68d8e50be1820c81800d69ac",
            "leftCorner": {
              "x": -19.156,
              "y": -37.103,
              "z": 0.626
            },
            "rightCorner": {
              "x": -19.154,
              "y": -37.232,
              "z": 0.626
            },
            "gtin": "4007698561369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69ad",
            "leftCorner": {
              "x": -19.15,
              "y": -37.232,
              "z": 0.626
            },
            "rightCorner": {
              "x": -19.146,
              "y": -37.42,
              "z": 0.626
            },
            "gtin": "4035625346727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69ae",
            "leftCorner": {
              "x": -19.144,
              "y": -37.42,
              "z": 0.626
            },
            "rightCorner": {
              "x": -19.143,
              "y": -37.517,
              "z": 0.626
            },
            "gtin": "8720573919685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69af",
            "leftCorner": {
              "x": -19.144,
              "y": -37.517,
              "z": 0.626
            },
            "rightCorner": {
              "x": -19.143,
              "y": -37.598,
              "z": 0.626
            },
            "gtin": "4007698480738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69b0",
            "leftCorner": {
              "x": -19.143,
              "y": -37.598,
              "z": 0.626
            },
            "rightCorner": {
              "x": -19.142,
              "y": -37.666,
              "z": 0.626
            },
            "gtin": "4007698480769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69b1",
            "leftCorner": {
              "x": -19.142,
              "y": -37.666,
              "z": 0.626
            },
            "rightCorner": {
              "x": -19.14,
              "y": -37.742,
              "z": 0.626
            },
            "gtin": "4007698537364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69b2",
            "leftCorner": {
              "x": -19.14,
              "y": -37.742,
              "z": 0.626
            },
            "rightCorner": {
              "x": -19.139,
              "y": -37.822,
              "z": 0.626
            },
            "gtin": "4007698466251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69b3",
            "leftCorner": {
              "x": -19.148,
              "y": -37.823,
              "z": 0.626
            },
            "rightCorner": {
              "x": -19.147,
              "y": -37.909,
              "z": 0.626
            },
            "gtin": "4007698537418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69b4",
            "leftCorner": {
              "x": -19.145,
              "y": -37.909,
              "z": 0.626
            },
            "rightCorner": {
              "x": -19.143,
              "y": -38.024,
              "z": 0.626
            },
            "gtin": "4007698466657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d699e",
            "leftCorner": {
              "x": -19.144,
              "y": -38.024,
              "z": 0.626
            },
            "rightCorner": {
              "x": -19.142,
              "y": -38.086,
              "z": 0.626
            },
            "gtin": "4030758648540",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d215",
        "height": 1.0561,
        "facings": [
          {
            "id": "68d8e50be1820c81800d69d3",
            "leftCorner": {
              "x": -19.187,
              "y": -37.086,
              "z": 0.864
            },
            "rightCorner": {
              "x": -19.186,
              "y": -37.159,
              "z": 0.864
            },
            "gtin": "4057824922717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69d5",
            "leftCorner": {
              "x": -19.146,
              "y": -37.159,
              "z": 0.864
            },
            "rightCorner": {
              "x": -19.145,
              "y": -37.209,
              "z": 0.864
            },
            "gtin": "4057824912343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69d6",
            "leftCorner": {
              "x": -19.141,
              "y": -37.209,
              "z": 0.864
            },
            "rightCorner": {
              "x": -19.14,
              "y": -37.272,
              "z": 0.864
            },
            "gtin": "4019581912011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69d7",
            "leftCorner": {
              "x": -19.142,
              "y": -37.272,
              "z": 0.864
            },
            "rightCorner": {
              "x": -19.141,
              "y": -37.35,
              "z": 0.864
            },
            "gtin": "4007698462420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69d8",
            "leftCorner": {
              "x": -19.143,
              "y": -37.35,
              "z": 0.864
            },
            "rightCorner": {
              "x": -19.141,
              "y": -37.459,
              "z": 0.864
            },
            "gtin": "4007698549299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69d9",
            "leftCorner": {
              "x": -19.136,
              "y": -37.459,
              "z": 0.864
            },
            "rightCorner": {
              "x": -19.135,
              "y": -37.582,
              "z": 0.864
            },
            "gtin": "4007698549343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69da",
            "leftCorner": {
              "x": -19.135,
              "y": -37.582,
              "z": 0.864
            },
            "rightCorner": {
              "x": -19.132,
              "y": -37.73,
              "z": 0.864
            },
            "gtin": "4007698004248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69db",
            "leftCorner": {
              "x": -19.136,
              "y": -37.73,
              "z": 0.864
            },
            "rightCorner": {
              "x": -19.135,
              "y": -37.809,
              "z": 0.864
            },
            "gtin": "4057824916105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69dc",
            "leftCorner": {
              "x": -19.136,
              "y": -37.809,
              "z": 0.864
            },
            "rightCorner": {
              "x": -19.135,
              "y": -37.881,
              "z": 0.864
            },
            "gtin": "4057824916044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69dd",
            "leftCorner": {
              "x": -19.137,
              "y": -37.881,
              "z": 0.864
            },
            "rightCorner": {
              "x": -19.136,
              "y": -37.954,
              "z": 0.864
            },
            "gtin": "4057824914415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69de",
            "leftCorner": {
              "x": -19.136,
              "y": -37.954,
              "z": 0.864
            },
            "rightCorner": {
              "x": -19.135,
              "y": -38.028,
              "z": 0.864
            },
            "gtin": "4057824916013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69d4",
            "leftCorner": {
              "x": -19.136,
              "y": -38.028,
              "z": 0.864
            },
            "rightCorner": {
              "x": -19.135,
              "y": -38.086,
              "z": 0.864
            },
            "gtin": "4057824916037",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d214",
        "height": 1.3831,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6948",
            "leftCorner": {
              "x": -19.155,
              "y": -37.104,
              "z": 1.132
            },
            "rightCorner": {
              "x": -19.154,
              "y": -37.153,
              "z": 1.132
            },
            "gtin": "8721071196370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6949",
            "leftCorner": {
              "x": -19.152,
              "y": -37.153,
              "z": 1.132
            },
            "rightCorner": {
              "x": -19.15,
              "y": -37.245,
              "z": 1.132
            },
            "gtin": "4062829012165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d694a",
            "leftCorner": {
              "x": -19.149,
              "y": -37.245,
              "z": 1.132
            },
            "rightCorner": {
              "x": -19.148,
              "y": -37.317,
              "z": 1.132
            },
            "gtin": "8720573667234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d694b",
            "leftCorner": {
              "x": -19.149,
              "y": -37.317,
              "z": 1.132
            },
            "rightCorner": {
              "x": -19.148,
              "y": -37.386,
              "z": 1.132
            },
            "gtin": "8720573667265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d694c",
            "leftCorner": {
              "x": -19.147,
              "y": -37.386,
              "z": 1.132
            },
            "rightCorner": {
              "x": -19.144,
              "y": -37.525,
              "z": 1.132
            },
            "gtin": "4260460141385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d694d",
            "leftCorner": {
              "x": -19.139,
              "y": -37.525,
              "z": 1.132
            },
            "rightCorner": {
              "x": -19.137,
              "y": -37.653,
              "z": 1.132
            },
            "gtin": "4260460141309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d694e",
            "leftCorner": {
              "x": -19.139,
              "y": -37.653,
              "z": 1.132
            },
            "rightCorner": {
              "x": -19.137,
              "y": -37.816,
              "z": 1.132
            },
            "gtin": "4260460141316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d694f",
            "leftCorner": {
              "x": -19.142,
              "y": -37.816,
              "z": 1.132
            },
            "rightCorner": {
              "x": -19.14,
              "y": -37.981,
              "z": 1.132
            },
            "gtin": "4260460141330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6937",
            "leftCorner": {
              "x": -19.141,
              "y": -37.981,
              "z": 1.132
            },
            "rightCorner": {
              "x": -19.139,
              "y": -38.086,
              "z": 1.132
            },
            "gtin": "4260460141347",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d216",
        "height": 1.6585,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6976",
            "leftCorner": {
              "x": -19.152,
              "y": -37.148,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.15,
              "y": -37.29,
              "z": 1.357
            },
            "gtin": "4064997501236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6977",
            "leftCorner": {
              "x": -19.146,
              "y": -37.29,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.143,
              "y": -37.418,
              "z": 1.357
            },
            "gtin": "4035625386167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6978",
            "leftCorner": {
              "x": -19.141,
              "y": -37.417,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.139,
              "y": -37.533,
              "z": 1.357
            },
            "gtin": "4035625386181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6979",
            "leftCorner": {
              "x": -19.137,
              "y": -37.533,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.135,
              "y": -37.661,
              "z": 1.357
            },
            "gtin": "8720573837255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d697a",
            "leftCorner": {
              "x": -19.136,
              "y": -37.661,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.134,
              "y": -37.737,
              "z": 1.357
            },
            "gtin": "8720573688239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d697b",
            "leftCorner": {
              "x": -19.136,
              "y": -37.737,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.135,
              "y": -37.822,
              "z": 1.357
            },
            "gtin": "8720573688260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d697c",
            "leftCorner": {
              "x": -19.143,
              "y": -37.823,
              "z": 1.357
            },
            "rightCorner": {
              "x": -19.138,
              "y": -38.086,
              "z": 1.357
            },
            "gtin": "8721037234948",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "507",
    "rightNeighborShelfId": "509"
  },
  {
    "id": "509",
    "name": "509",
    "x": -19.115,
    "y": -38.086,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70091,
      "w": 0.71325
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d21c",
        "height": 0.15822,
        "facings": [
          {
            "id": "68d8e50be1820c81800d69cc",
            "leftCorner": {
              "x": -19.191,
              "y": -38.087,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.191,
              "y": -38.135,
              "z": 0.129
            },
            "gtin": "4306188374664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69cd",
            "leftCorner": {
              "x": -19.181,
              "y": -38.135,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.178,
              "y": -38.254,
              "z": 0.129
            },
            "gtin": "4306188374664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69ce",
            "leftCorner": {
              "x": -19.182,
              "y": -38.254,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.178,
              "y": -38.439,
              "z": 0.129
            },
            "gtin": "4306188374633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69cf",
            "leftCorner": {
              "x": -19.18,
              "y": -38.439,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.176,
              "y": -38.665,
              "z": 0.129
            },
            "gtin": "4306188027577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69d0",
            "leftCorner": {
              "x": -19.174,
              "y": -38.665,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.173,
              "y": -38.746,
              "z": 0.129
            },
            "gtin": "4306188374602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69d1",
            "leftCorner": {
              "x": -19.177,
              "y": -38.746,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.174,
              "y": -38.948,
              "z": 0.129
            },
            "gtin": "4306188374541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69d2",
            "leftCorner": {
              "x": -19.169,
              "y": -38.947,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.167,
              "y": -39.027,
              "z": 0.129
            },
            "gtin": "4306188374695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69b8",
            "leftCorner": {
              "x": -19.167,
              "y": -39.027,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.165,
              "y": -39.087,
              "z": 0.129
            },
            "gtin": "2000439122173",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d21d",
        "height": 0.40717,
        "facings": [
          {
            "id": "68d8e50be1820c81800d69ed",
            "leftCorner": {
              "x": -19.177,
              "y": -38.087,
              "z": 0.333
            },
            "rightCorner": {
              "x": -19.173,
              "y": -38.297,
              "z": 0.333
            },
            "gtin": "4306188027546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "20e03e6c13808f207404984b",
            "leftCorner": {
              "x": -19.173,
              "y": -38.297,
              "z": 0.333
            },
            "rightCorner": {
              "x": -19.171,
              "y": -38.427,
              "z": 0.333
            },
            "gtin": "4306188422433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1cc1330395113b9678b9533f",
            "leftCorner": {
              "x": -19.171,
              "y": -38.427,
              "z": 0.333
            },
            "rightCorner": {
              "x": -19.168,
              "y": -38.587,
              "z": 0.333
            },
            "gtin": "4306188422556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69f4",
            "leftCorner": {
              "x": -19.127,
              "y": -38.631,
              "z": 0.333
            },
            "rightCorner": {
              "x": -19.124,
              "y": -38.758,
              "z": 0.333
            },
            "gtin": "4306188422433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69f5",
            "leftCorner": {
              "x": -19.125,
              "y": -38.758,
              "z": 0.333
            },
            "rightCorner": {
              "x": -19.122,
              "y": -38.913,
              "z": 0.333
            },
            "gtin": "4306188422358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69ee",
            "leftCorner": {
              "x": -19.123,
              "y": -38.913,
              "z": 0.333
            },
            "rightCorner": {
              "x": -19.12,
              "y": -39.086,
              "z": 0.333
            },
            "gtin": "4306188422556",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d21e",
        "height": 0.70432,
        "facings": [
          {
            "id": "68d8e50be1820c81800d69f6",
            "leftCorner": {
              "x": -19.18,
              "y": -38.087,
              "z": 0.576
            },
            "rightCorner": {
              "x": -19.171,
              "y": -38.581,
              "z": 0.576
            },
            "gtin": "7321011920631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69f8",
            "leftCorner": {
              "x": -19.131,
              "y": -38.581,
              "z": 0.576
            },
            "rightCorner": {
              "x": -19.13,
              "y": -38.701,
              "z": 0.576
            },
            "gtin": "7321011924059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69f9",
            "leftCorner": {
              "x": -19.127,
              "y": -38.7,
              "z": 0.576
            },
            "rightCorner": {
              "x": -19.125,
              "y": -38.802,
              "z": 0.576
            },
            "gtin": "7321012088538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69fa",
            "leftCorner": {
              "x": -19.13,
              "y": -38.802,
              "z": 0.576
            },
            "rightCorner": {
              "x": -19.127,
              "y": -38.924,
              "z": 0.576
            },
            "gtin": "7321011876754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69f7",
            "leftCorner": {
              "x": -19.125,
              "y": -38.924,
              "z": 0.576
            },
            "rightCorner": {
              "x": -19.122,
              "y": -39.086,
              "z": 0.576
            },
            "gtin": "7321011876761",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d21b",
        "height": 1.0058,
        "facings": [
          {
            "id": "68d8e50be1820c81800d69e5",
            "leftCorner": {
              "x": -19.183,
              "y": -38.087,
              "z": 0.823
            },
            "rightCorner": {
              "x": -19.18,
              "y": -38.261,
              "z": 0.823
            },
            "gtin": "7321011912810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69e7",
            "leftCorner": {
              "x": -19.14,
              "y": -38.261,
              "z": 0.823
            },
            "rightCorner": {
              "x": -19.139,
              "y": -38.334,
              "z": 0.823
            },
            "gtin": "7321011912803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69e8",
            "leftCorner": {
              "x": -19.139,
              "y": -38.334,
              "z": 0.823
            },
            "rightCorner": {
              "x": -19.138,
              "y": -38.407,
              "z": 0.823
            },
            "gtin": "7321011912803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69e9",
            "leftCorner": {
              "x": -19.138,
              "y": -38.407,
              "z": 0.823
            },
            "rightCorner": {
              "x": -19.136,
              "y": -38.48,
              "z": 0.823
            },
            "gtin": "7321011912803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69ea",
            "leftCorner": {
              "x": -19.135,
              "y": -38.48,
              "z": 0.823
            },
            "rightCorner": {
              "x": -19.132,
              "y": -38.658,
              "z": 0.823
            },
            "gtin": "7321011912780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69eb",
            "leftCorner": {
              "x": -19.132,
              "y": -38.658,
              "z": 0.823
            },
            "rightCorner": {
              "x": -19.13,
              "y": -38.783,
              "z": 0.823
            },
            "gtin": "7321011912773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69ec",
            "leftCorner": {
              "x": -19.134,
              "y": -38.783,
              "z": 0.823
            },
            "rightCorner": {
              "x": -19.13,
              "y": -38.934,
              "z": 0.823
            },
            "gtin": "7321012012304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69e6",
            "leftCorner": {
              "x": -19.129,
              "y": -38.934,
              "z": 0.823
            },
            "rightCorner": {
              "x": -19.126,
              "y": -39.087,
              "z": 0.823
            },
            "gtin": "7321011975280",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d219",
        "height": 1.3592,
        "facings": [
          {
            "id": "68d8e50be1820c81800d69df",
            "leftCorner": {
              "x": -19.187,
              "y": -38.087,
              "z": 1.112
            },
            "rightCorner": {
              "x": -19.184,
              "y": -38.267,
              "z": 1.112
            },
            "gtin": "7321011913558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69e1",
            "leftCorner": {
              "x": -19.136,
              "y": -38.266,
              "z": 1.112
            },
            "rightCorner": {
              "x": -19.133,
              "y": -38.484,
              "z": 1.112
            },
            "gtin": "7321012051969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69e2",
            "leftCorner": {
              "x": -19.138,
              "y": -38.484,
              "z": 1.112
            },
            "rightCorner": {
              "x": -19.134,
              "y": -38.66,
              "z": 1.112
            },
            "gtin": "7321011912667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69e3",
            "leftCorner": {
              "x": -19.138,
              "y": -38.66,
              "z": 1.112
            },
            "rightCorner": {
              "x": -19.136,
              "y": -38.783,
              "z": 1.112
            },
            "gtin": "7321011912650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69e4",
            "leftCorner": {
              "x": -19.137,
              "y": -38.783,
              "z": 1.112
            },
            "rightCorner": {
              "x": -19.134,
              "y": -38.96,
              "z": 1.112
            },
            "gtin": "7321012051907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d69e0",
            "leftCorner": {
              "x": -19.133,
              "y": -38.96,
              "z": 1.112
            },
            "rightCorner": {
              "x": -19.131,
              "y": -39.087,
              "z": 1.112
            },
            "gtin": "7321012012083",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d21a",
        "height": 1.6596,
        "facings": [
          {
            "id": "68d8e50be1820c81800d697d",
            "leftCorner": {
              "x": -19.143,
              "y": -38.105,
              "z": 1.358
            },
            "rightCorner": {
              "x": -19.14,
              "y": -38.276,
              "z": 1.358
            },
            "gtin": "7321011975372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d697e",
            "leftCorner": {
              "x": -19.141,
              "y": -38.276,
              "z": 1.358
            },
            "rightCorner": {
              "x": -19.137,
              "y": -38.493,
              "z": 1.358
            },
            "gtin": "7321011820740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d697f",
            "leftCorner": {
              "x": -19.138,
              "y": -38.493,
              "z": 1.358
            },
            "rightCorner": {
              "x": -19.135,
              "y": -38.667,
              "z": 1.358
            },
            "gtin": "7321011975341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6980",
            "leftCorner": {
              "x": -19.136,
              "y": -38.667,
              "z": 1.358
            },
            "rightCorner": {
              "x": -19.134,
              "y": -38.792,
              "z": 1.358
            },
            "gtin": "7321011820726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6981",
            "leftCorner": {
              "x": -19.137,
              "y": -38.792,
              "z": 1.358
            },
            "rightCorner": {
              "x": -19.134,
              "y": -38.951,
              "z": 1.358
            },
            "gtin": "7321012012137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6963",
            "leftCorner": {
              "x": -19.132,
              "y": -38.951,
              "z": 1.358
            },
            "rightCorner": {
              "x": -19.129,
              "y": -39.087,
              "z": 1.358
            },
            "gtin": "7321012051358",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "508",
    "rightNeighborShelfId": "50a"
  },
  {
    "id": "50a",
    "name": "50a",
    "x": -19.098,
    "y": -39.086,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70091,
      "w": 0.71325
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 34
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d720",
        "height": 0.1655,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87a6",
            "leftCorner": {
              "x": -19.197,
              "y": -39.088,
              "z": 0.135
            },
            "rightCorner": {
              "x": -19.191,
              "y": -39.443,
              "z": 0.135
            },
            "gtin": "4306188374510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87a7",
            "leftCorner": {
              "x": -19.149,
              "y": -39.441,
              "z": 0.135
            },
            "rightCorner": {
              "x": -19.133,
              "y": -40.337,
              "z": 0.135
            },
            "gtin": "7321013533976",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d71d",
        "height": 0.46297,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8794",
            "leftCorner": {
              "x": -19.16,
              "y": -39.087,
              "z": 0.379
            },
            "rightCorner": {
              "x": -19.156,
              "y": -39.308,
              "z": 0.379
            },
            "gtin": "7321011986361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8795",
            "leftCorner": {
              "x": -19.116,
              "y": -39.308,
              "z": 0.379
            },
            "rightCorner": {
              "x": -19.098,
              "y": -40.336,
              "z": 0.379
            },
            "gtin": "7321011986361",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d71e",
        "height": 0.75008,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8796",
            "leftCorner": {
              "x": -19.141,
              "y": -39.087,
              "z": 0.614
            },
            "rightCorner": {
              "x": -19.135,
              "y": -39.418,
              "z": 0.614
            },
            "gtin": "7321012011895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8798",
            "leftCorner": {
              "x": -19.1,
              "y": -39.418,
              "z": 0.614
            },
            "rightCorner": {
              "x": -19.099,
              "y": -39.52,
              "z": 0.614
            },
            "gtin": "7321011975396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8799",
            "leftCorner": {
              "x": -19.094,
              "y": -39.52,
              "z": 0.614
            },
            "rightCorner": {
              "x": -19.092,
              "y": -39.621,
              "z": 0.614
            },
            "gtin": "7321011857487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d879a",
            "leftCorner": {
              "x": -19.088,
              "y": -39.62,
              "z": 0.614
            },
            "rightCorner": {
              "x": -19.086,
              "y": -39.712,
              "z": 0.614
            },
            "gtin": "7321011857043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d879b",
            "leftCorner": {
              "x": -19.088,
              "y": -39.712,
              "z": 0.614
            },
            "rightCorner": {
              "x": -19.086,
              "y": -39.8,
              "z": 0.614
            },
            "gtin": "7321011857005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d879c",
            "leftCorner": {
              "x": -19.084,
              "y": -39.8,
              "z": 0.614
            },
            "rightCorner": {
              "x": -19.084,
              "y": -39.889,
              "z": 0.614
            },
            "gtin": "7321011857203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d879d",
            "leftCorner": {
              "x": -19.086,
              "y": -39.889,
              "z": 0.614
            },
            "rightCorner": {
              "x": -19.084,
              "y": -39.978,
              "z": 0.614
            },
            "gtin": "7321011857128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d879e",
            "leftCorner": {
              "x": -19.086,
              "y": -39.978,
              "z": 0.614
            },
            "rightCorner": {
              "x": -19.084,
              "y": -40.087,
              "z": 0.614
            },
            "gtin": "7321011986354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d879f",
            "leftCorner": {
              "x": -19.085,
              "y": -40.087,
              "z": 0.614
            },
            "rightCorner": {
              "x": -19.082,
              "y": -40.232,
              "z": 0.614
            },
            "gtin": "7321011277001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8797",
            "leftCorner": {
              "x": -19.084,
              "y": -40.233,
              "z": 0.614
            },
            "rightCorner": {
              "x": -19.082,
              "y": -40.336,
              "z": 0.614
            },
            "gtin": "7321013518126",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d71f",
        "height": 1.0547,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87a0",
            "leftCorner": {
              "x": -19.142,
              "y": -39.087,
              "z": 0.863
            },
            "rightCorner": {
              "x": -19.136,
              "y": -39.484,
              "z": 0.863
            },
            "gtin": "7321011857708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87a2",
            "leftCorner": {
              "x": -19.099,
              "y": -39.484,
              "z": 0.863
            },
            "rightCorner": {
              "x": -19.096,
              "y": -39.625,
              "z": 0.863
            },
            "gtin": "7321011857753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87a3",
            "leftCorner": {
              "x": -19.09,
              "y": -39.624,
              "z": 0.863
            },
            "rightCorner": {
              "x": -19.086,
              "y": -39.828,
              "z": 0.863
            },
            "gtin": "7321011857746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87a4",
            "leftCorner": {
              "x": -19.085,
              "y": -39.828,
              "z": 0.863
            },
            "rightCorner": {
              "x": -19.083,
              "y": -40.009,
              "z": 0.863
            },
            "gtin": "7321011857760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87a5",
            "leftCorner": {
              "x": -19.084,
              "y": -40.009,
              "z": 0.863
            },
            "rightCorner": {
              "x": -19.08,
              "y": -40.172,
              "z": 0.863
            },
            "gtin": "7321011857692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87a1",
            "leftCorner": {
              "x": -19.087,
              "y": -40.172,
              "z": 0.863
            },
            "rightCorner": {
              "x": -19.085,
              "y": -40.336,
              "z": 0.863
            },
            "gtin": "7321011857715",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d71b",
        "height": 1.3575,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8786",
            "leftCorner": {
              "x": -19.148,
              "y": -39.087,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.146,
              "y": -39.209,
              "z": 1.111
            },
            "gtin": "7321011040292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8787",
            "leftCorner": {
              "x": -19.146,
              "y": -39.209,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.144,
              "y": -39.331,
              "z": 1.111
            },
            "gtin": "7321011040292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8788",
            "leftCorner": {
              "x": -19.144,
              "y": -39.331,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.142,
              "y": -39.453,
              "z": 1.111
            },
            "gtin": "7321011040292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8789",
            "leftCorner": {
              "x": -19.104,
              "y": -39.453,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.102,
              "y": -39.611,
              "z": 1.111
            },
            "gtin": "7321011040308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d878a",
            "leftCorner": {
              "x": -19.099,
              "y": -39.611,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.097,
              "y": -39.743,
              "z": 1.111
            },
            "gtin": "7321011487356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d878b",
            "leftCorner": {
              "x": -19.094,
              "y": -39.743,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.091,
              "y": -39.906,
              "z": 1.111
            },
            "gtin": "7321011487332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d878c",
            "leftCorner": {
              "x": -19.088,
              "y": -39.906,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.085,
              "y": -40.049,
              "z": 1.111
            },
            "gtin": "7321011040612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d878d",
            "leftCorner": {
              "x": -19.088,
              "y": -40.049,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.086,
              "y": -40.212,
              "z": 1.111
            },
            "gtin": "7321011040629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d878e",
            "leftCorner": {
              "x": -19.093,
              "y": -40.212,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.09,
              "y": -40.344,
              "z": 1.111
            },
            "gtin": "7321011040513",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d71c",
        "height": 1.654,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d878f",
            "leftCorner": {
              "x": -19.144,
              "y": -39.087,
              "z": 1.353
            },
            "rightCorner": {
              "x": -19.137,
              "y": -39.505,
              "z": 1.353
            },
            "gtin": "7321011947263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8790",
            "leftCorner": {
              "x": -19.096,
              "y": -39.505,
              "z": 1.353
            },
            "rightCorner": {
              "x": -19.093,
              "y": -39.679,
              "z": 1.353
            },
            "gtin": "7321011947256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8791",
            "leftCorner": {
              "x": -19.089,
              "y": -39.679,
              "z": 1.353
            },
            "rightCorner": {
              "x": -19.086,
              "y": -39.895,
              "z": 1.353
            },
            "gtin": "7321012015466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8792",
            "leftCorner": {
              "x": -19.086,
              "y": -39.895,
              "z": 1.353
            },
            "rightCorner": {
              "x": -19.082,
              "y": -40.099,
              "z": 1.353
            },
            "gtin": "7321012015336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8793",
            "leftCorner": {
              "x": -19.087,
              "y": -40.099,
              "z": 1.353
            },
            "rightCorner": {
              "x": -19.083,
              "y": -40.308,
              "z": 1.353
            },
            "gtin": "7321012015329",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "509"
  },
  {
    "id": "50c",
    "name": "50c",
    "x": -19.054,
    "y": -41.586,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70091,
      "w": 0.71325
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d724",
        "height": 0.15601,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87c5",
            "leftCorner": {
              "x": -19.161,
              "y": -41.589,
              "z": 0.128
            },
            "rightCorner": {
              "x": -19.157,
              "y": -41.805,
              "z": 0.128
            },
            "gtin": "7321011804283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87c7",
            "leftCorner": {
              "x": -19.119,
              "y": -41.804,
              "z": 0.128
            },
            "rightCorner": {
              "x": -19.117,
              "y": -41.925,
              "z": 0.128
            },
            "gtin": "7321011497362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87c6",
            "leftCorner": {
              "x": -19.114,
              "y": -41.925,
              "z": 0.128
            },
            "rightCorner": {
              "x": -19.102,
              "y": -42.588,
              "z": 0.128
            },
            "gtin": "7321011607976",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d723",
        "height": 0.41831,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87bb",
            "leftCorner": {
              "x": -19.119,
              "y": -41.588,
              "z": 0.342
            },
            "rightCorner": {
              "x": -19.117,
              "y": -41.745,
              "z": 0.342
            },
            "gtin": "7321011487776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "91e56e94a8fe33942757221e",
            "leftCorner": {
              "x": -19.102,
              "y": -42.539,
              "z": 0.342
            },
            "rightCorner": {
              "x": -19.102,
              "y": -42.587,
              "z": 0.342
            },
            "gtin": "7321011637300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87bd",
            "leftCorner": {
              "x": -19.079,
              "y": -41.744,
              "z": 0.342
            },
            "rightCorner": {
              "x": -19.077,
              "y": -41.864,
              "z": 0.342
            },
            "gtin": "7321011637416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87be",
            "leftCorner": {
              "x": -19.074,
              "y": -41.864,
              "z": 0.342
            },
            "rightCorner": {
              "x": -19.072,
              "y": -41.984,
              "z": 0.342
            },
            "gtin": "4058653100208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87bf",
            "leftCorner": {
              "x": -19.072,
              "y": -41.984,
              "z": 0.342
            },
            "rightCorner": {
              "x": -19.071,
              "y": -42.08,
              "z": 0.342
            },
            "gtin": "7321011637393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87c0",
            "leftCorner": {
              "x": -19.061,
              "y": -42.08,
              "z": 0.342
            },
            "rightCorner": {
              "x": -19.059,
              "y": -42.17,
              "z": 0.342
            },
            "gtin": "7321011637379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87c1",
            "leftCorner": {
              "x": -19.071,
              "y": -42.17,
              "z": 0.342
            },
            "rightCorner": {
              "x": -19.07,
              "y": -42.264,
              "z": 0.342
            },
            "gtin": "7321011637355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87c2",
            "leftCorner": {
              "x": -19.067,
              "y": -42.264,
              "z": 0.342
            },
            "rightCorner": {
              "x": -19.065,
              "y": -42.379,
              "z": 0.342
            },
            "gtin": "7321011637348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87c3",
            "leftCorner": {
              "x": -19.069,
              "y": -42.379,
              "z": 0.342
            },
            "rightCorner": {
              "x": -19.067,
              "y": -42.494,
              "z": 0.342
            },
            "gtin": "7321011637362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87c4",
            "leftCorner": {
              "x": -19.071,
              "y": -42.494,
              "z": 0.342
            },
            "rightCorner": {
              "x": -19.07,
              "y": -42.538,
              "z": 0.342
            },
            "gtin": "7321011637300",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d721",
        "height": 1.2216,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87a8",
            "leftCorner": {
              "x": -19.122,
              "y": -41.588,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.12,
              "y": -41.69,
              "z": 1.0
            },
            "gtin": "7321011142415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87aa",
            "leftCorner": {
              "x": -19.086,
              "y": -41.689,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.085,
              "y": -41.765,
              "z": 1.0
            },
            "gtin": "7321011142439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87ab",
            "leftCorner": {
              "x": -19.081,
              "y": -41.765,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.081,
              "y": -41.816,
              "z": 1.0
            },
            "gtin": "7321013525124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87ac",
            "leftCorner": {
              "x": -19.08,
              "y": -41.816,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.077,
              "y": -41.898,
              "z": 1.0
            },
            "gtin": "7321013525124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87ad",
            "leftCorner": {
              "x": -19.075,
              "y": -41.898,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.074,
              "y": -41.936,
              "z": 1.0
            },
            "gtin": "7321011619313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87ae",
            "leftCorner": {
              "x": -19.077,
              "y": -41.936,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.076,
              "y": -42.002,
              "z": 1.0
            },
            "gtin": "7321011619313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87af",
            "leftCorner": {
              "x": -19.075,
              "y": -42.002,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.073,
              "y": -42.095,
              "z": 1.0
            },
            "gtin": "7321011365869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87b0",
            "leftCorner": {
              "x": -19.068,
              "y": -42.095,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.068,
              "y": -42.155,
              "z": 1.0
            },
            "gtin": "7321011365814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87b1",
            "leftCorner": {
              "x": -19.075,
              "y": -42.155,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.073,
              "y": -42.251,
              "z": 1.0
            },
            "gtin": "7321011365715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87b2",
            "leftCorner": {
              "x": -19.071,
              "y": -42.251,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.07,
              "y": -42.317,
              "z": 1.0
            },
            "gtin": "7321011365722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87b3",
            "leftCorner": {
              "x": -19.071,
              "y": -42.317,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.069,
              "y": -42.415,
              "z": 1.0
            },
            "gtin": "7321011365692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87b4",
            "leftCorner": {
              "x": -19.067,
              "y": -42.415,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.066,
              "y": -42.477,
              "z": 1.0
            },
            "gtin": "7321011365708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87b5",
            "leftCorner": {
              "x": -19.068,
              "y": -42.477,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.067,
              "y": -42.525,
              "z": 1.0
            },
            "gtin": "7321011708222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87a9",
            "leftCorner": {
              "x": -19.067,
              "y": -42.525,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.066,
              "y": -42.586,
              "z": 1.0
            },
            "gtin": "7321011578863",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d725",
        "height": 1.5423,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87c8",
            "leftCorner": {
              "x": -19.012,
              "y": -41.585,
              "z": 1.262
            },
            "rightCorner": {
              "x": -19.002,
              "y": -42.144,
              "z": 1.262
            },
            "gtin": "7321011708260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87c9",
            "leftCorner": {
              "x": -18.961,
              "y": -42.143,
              "z": 1.262
            },
            "rightCorner": {
              "x": -18.953,
              "y": -42.585,
              "z": 1.262
            },
            "gtin": "7321011708284",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d722",
        "height": 1.8846,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87b6",
            "leftCorner": {
              "x": -18.981,
              "y": -41.585,
              "z": 1.542
            },
            "rightCorner": {
              "x": -18.978,
              "y": -41.801,
              "z": 1.542
            },
            "gtin": "7321011689170",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d87b8",
            "leftCorner": {
              "x": -18.876,
              "y": -41.798,
              "z": 1.542
            },
            "rightCorner": {
              "x": -18.873,
              "y": -41.961,
              "z": 1.542
            },
            "gtin": "7321011689187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87b9",
            "leftCorner": {
              "x": -18.929,
              "y": -41.962,
              "z": 1.542
            },
            "rightCorner": {
              "x": -18.926,
              "y": -42.109,
              "z": 1.542
            },
            "gtin": "7321011689118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87ba",
            "leftCorner": {
              "x": -18.955,
              "y": -42.11,
              "z": 1.542
            },
            "rightCorner": {
              "x": -18.95,
              "y": -42.406,
              "z": 1.542
            },
            "gtin": "7321011689231",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d87b7",
            "leftCorner": {
              "x": -18.935,
              "y": -42.405,
              "z": 1.542
            },
            "rightCorner": {
              "x": -18.932,
              "y": -42.584,
              "z": 1.542
            },
            "gtin": "7321011689217",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "510",
    "name": "510",
    "x": -25.119,
    "y": -22.447,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.012714,
      "w": 0.99992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d268",
        "height": 0.15904,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bea",
            "leftCorner": {
              "x": -25.116,
              "y": -22.548,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.699,
              "y": -22.538,
              "z": 0.13
            },
            "gtin": "4015200034942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bec",
            "leftCorner": {
              "x": -24.7,
              "y": -22.498,
              "z": 0.13
            },
            "rightCorner": {
              "x": -24.177,
              "y": -22.485,
              "z": 0.13
            },
            "gtin": "4015200034959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bed",
            "leftCorner": {
              "x": -24.176,
              "y": -22.497,
              "z": 0.13
            },
            "rightCorner": {
              "x": -23.796,
              "y": -22.487,
              "z": 0.13
            },
            "gtin": "8700216088572",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d269",
        "height": 0.64077,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bf7",
            "leftCorner": {
              "x": -25.116,
              "y": -22.568,
              "z": 0.524
            },
            "rightCorner": {
              "x": -24.911,
              "y": -22.563,
              "z": 0.524
            },
            "gtin": "8700216651110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bf9",
            "leftCorner": {
              "x": -24.912,
              "y": -22.515,
              "z": 0.524
            },
            "rightCorner": {
              "x": -24.779,
              "y": -22.512,
              "z": 0.524
            },
            "gtin": "8700216651042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bfa",
            "leftCorner": {
              "x": -24.779,
              "y": -22.509,
              "z": 0.524
            },
            "rightCorner": {
              "x": -24.626,
              "y": -22.505,
              "z": 0.524
            },
            "gtin": "8700216678582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bfb",
            "leftCorner": {
              "x": -24.626,
              "y": -22.519,
              "z": 0.524
            },
            "rightCorner": {
              "x": -24.381,
              "y": -22.513,
              "z": 0.524
            },
            "gtin": "8700216651097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bfc",
            "leftCorner": {
              "x": -24.381,
              "y": -22.507,
              "z": 0.524
            },
            "rightCorner": {
              "x": -24.122,
              "y": -22.5,
              "z": 0.524
            },
            "gtin": "8700216678605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bfd",
            "leftCorner": {
              "x": -24.122,
              "y": -22.516,
              "z": 0.524
            },
            "rightCorner": {
              "x": -23.995,
              "y": -22.513,
              "z": 0.524
            },
            "gtin": "4015200035321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bf8",
            "leftCorner": {
              "x": -23.995,
              "y": -22.509,
              "z": 0.524
            },
            "rightCorner": {
              "x": -23.867,
              "y": -22.505,
              "z": 0.524
            },
            "gtin": "4015200035314",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d26b",
        "height": 0.98107,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c14",
            "leftCorner": {
              "x": -25.116,
              "y": -22.554,
              "z": 0.803
            },
            "rightCorner": {
              "x": -24.849,
              "y": -22.548,
              "z": 0.803
            },
            "gtin": "4015200035062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c16",
            "leftCorner": {
              "x": -24.85,
              "y": -22.494,
              "z": 0.803
            },
            "rightCorner": {
              "x": -24.658,
              "y": -22.49,
              "z": 0.803
            },
            "gtin": "4015200035017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c17",
            "leftCorner": {
              "x": -24.658,
              "y": -22.496,
              "z": 0.803
            },
            "rightCorner": {
              "x": -24.462,
              "y": -22.49,
              "z": 0.803
            },
            "gtin": "4015200035826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c18",
            "leftCorner": {
              "x": -24.461,
              "y": -22.497,
              "z": 0.803
            },
            "rightCorner": {
              "x": -24.298,
              "y": -22.494,
              "z": 0.803
            },
            "gtin": "4015200035895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c19",
            "leftCorner": {
              "x": -24.298,
              "y": -22.494,
              "z": 0.803
            },
            "rightCorner": {
              "x": -24.122,
              "y": -22.489,
              "z": 0.803
            },
            "gtin": "8700216708029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c1a",
            "leftCorner": {
              "x": -24.122,
              "y": -22.506,
              "z": 0.803
            },
            "rightCorner": {
              "x": -24.023,
              "y": -22.503,
              "z": 0.803
            },
            "gtin": "4008455105611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c15",
            "leftCorner": {
              "x": -24.023,
              "y": -22.497,
              "z": 0.803
            },
            "rightCorner": {
              "x": -23.867,
              "y": -22.494,
              "z": 0.803
            },
            "gtin": "4008455105819",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d26c",
        "height": 1.3338,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c1b",
            "leftCorner": {
              "x": -25.116,
              "y": -22.556,
              "z": 1.091
            },
            "rightCorner": {
              "x": -24.908,
              "y": -22.551,
              "z": 1.091
            },
            "gtin": "4015200031514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c1c",
            "leftCorner": {
              "x": -24.908,
              "y": -22.551,
              "z": 1.091
            },
            "rightCorner": {
              "x": -24.7,
              "y": -22.546,
              "z": 1.091
            },
            "gtin": "4015200031514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c1e",
            "leftCorner": {
              "x": -24.702,
              "y": -22.495,
              "z": 1.091
            },
            "rightCorner": {
              "x": -24.551,
              "y": -22.491,
              "z": 1.091
            },
            "gtin": "8700216823982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c1f",
            "leftCorner": {
              "x": -24.55,
              "y": -22.503,
              "z": 1.091
            },
            "rightCorner": {
              "x": -24.374,
              "y": -22.498,
              "z": 1.091
            },
            "gtin": "8700216823906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c20",
            "leftCorner": {
              "x": -24.374,
              "y": -22.496,
              "z": 1.091
            },
            "rightCorner": {
              "x": -24.217,
              "y": -22.492,
              "z": 1.091
            },
            "gtin": "8700216823951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c21",
            "leftCorner": {
              "x": -24.217,
              "y": -22.497,
              "z": 1.091
            },
            "rightCorner": {
              "x": -24.073,
              "y": -22.494,
              "z": 1.091
            },
            "gtin": "8700216823852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c1d",
            "leftCorner": {
              "x": -24.073,
              "y": -22.503,
              "z": 1.091
            },
            "rightCorner": {
              "x": -23.867,
              "y": -22.497,
              "z": 1.091
            },
            "gtin": "8700216823869",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d26a",
        "height": 1.7337,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bfe",
            "leftCorner": {
              "x": -25.116,
              "y": -22.555,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.868,
              "y": -22.548,
              "z": 1.418
            },
            "gtin": "4015200034928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c00",
            "leftCorner": {
              "x": -24.87,
              "y": -22.497,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.715,
              "y": -22.493,
              "z": 1.418
            },
            "gtin": "4015200035000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c01",
            "leftCorner": {
              "x": -24.715,
              "y": -22.492,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.592,
              "y": -22.489,
              "z": 1.418
            },
            "gtin": "4015200035024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c02",
            "leftCorner": {
              "x": -24.591,
              "y": -22.502,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.434,
              "y": -22.498,
              "z": 1.418
            },
            "gtin": "4015200035178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c03",
            "leftCorner": {
              "x": -24.434,
              "y": -22.497,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.286,
              "y": -22.493,
              "z": 1.418
            },
            "gtin": "4001499969522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c04",
            "leftCorner": {
              "x": -24.286,
              "y": -22.498,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.119,
              "y": -22.493,
              "z": 1.418
            },
            "gtin": "4001499969508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c05",
            "leftCorner": {
              "x": -24.119,
              "y": -22.502,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.021,
              "y": -22.499,
              "z": 1.418
            },
            "gtin": "4015200035857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c06",
            "leftCorner": {
              "x": -24.021,
              "y": -22.499,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.81,
              "y": -22.494,
              "z": 1.418
            },
            "gtin": "4015200035864",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "512"
  },
  {
    "id": "512",
    "name": "512",
    "x": -23.87,
    "y": -22.415,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.012714,
      "w": 0.99992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 33,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d26d",
        "height": 0.16796,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bee",
            "leftCorner": {
              "x": -23.798,
              "y": -22.483,
              "z": 0.137
            },
            "rightCorner": {
              "x": -23.638,
              "y": -22.479,
              "z": 0.137
            },
            "gtin": "8700216197502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bef",
            "leftCorner": {
              "x": -23.638,
              "y": -22.481,
              "z": 0.137
            },
            "rightCorner": {
              "x": -23.485,
              "y": -22.477,
              "z": 0.137
            },
            "gtin": "8700216196949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bf0",
            "leftCorner": {
              "x": -23.485,
              "y": -22.474,
              "z": 0.137
            },
            "rightCorner": {
              "x": -23.31,
              "y": -22.47,
              "z": 0.137
            },
            "gtin": "4015200031798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bf1",
            "leftCorner": {
              "x": -23.31,
              "y": -22.445,
              "z": 0.137
            },
            "rightCorner": {
              "x": -23.154,
              "y": -22.441,
              "z": 0.137
            },
            "gtin": "4015200031774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bf2",
            "leftCorner": {
              "x": -23.154,
              "y": -22.461,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.793,
              "y": -22.452,
              "z": 0.137
            },
            "gtin": "4306188347682",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d26f",
        "height": 0.58848,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c22",
            "leftCorner": {
              "x": -23.867,
              "y": -22.538,
              "z": 0.481
            },
            "rightCorner": {
              "x": -23.599,
              "y": -22.531,
              "z": 0.481
            },
            "gtin": "8700216678339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c24",
            "leftCorner": {
              "x": -23.599,
              "y": -22.496,
              "z": 0.481
            },
            "rightCorner": {
              "x": -23.291,
              "y": -22.488,
              "z": 0.481
            },
            "gtin": "4012400528066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c25",
            "leftCorner": {
              "x": -23.292,
              "y": -22.484,
              "z": 0.481
            },
            "rightCorner": {
              "x": -23.151,
              "y": -22.48,
              "z": 0.481
            },
            "gtin": "4012400501656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c26",
            "leftCorner": {
              "x": -23.151,
              "y": -22.478,
              "z": 0.481
            },
            "rightCorner": {
              "x": -22.99,
              "y": -22.474,
              "z": 0.481
            },
            "gtin": "8435495839361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c27",
            "leftCorner": {
              "x": -22.99,
              "y": -22.475,
              "z": 0.481
            },
            "rightCorner": {
              "x": -22.817,
              "y": -22.47,
              "z": 0.481
            },
            "gtin": "8435495837633",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d271",
        "height": 0.92818,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c39",
            "leftCorner": {
              "x": -23.868,
              "y": -22.521,
              "z": 0.759
            },
            "rightCorner": {
              "x": -23.698,
              "y": -22.517,
              "z": 0.759
            },
            "gtin": "4015200035154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c3a",
            "leftCorner": {
              "x": -23.698,
              "y": -22.517,
              "z": 0.759
            },
            "rightCorner": {
              "x": -23.529,
              "y": -22.512,
              "z": 0.759
            },
            "gtin": "4015200035154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c3c",
            "leftCorner": {
              "x": -23.53,
              "y": -22.475,
              "z": 0.759
            },
            "rightCorner": {
              "x": -23.371,
              "y": -22.471,
              "z": 0.759
            },
            "gtin": "4015200035338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c3d",
            "leftCorner": {
              "x": -23.371,
              "y": -22.469,
              "z": 0.759
            },
            "rightCorner": {
              "x": -23.238,
              "y": -22.466,
              "z": 0.759
            },
            "gtin": "8435495837855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c3e",
            "leftCorner": {
              "x": -23.238,
              "y": -22.465,
              "z": 0.759
            },
            "rightCorner": {
              "x": -23.112,
              "y": -22.462,
              "z": 0.759
            },
            "gtin": "8435495818687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c3f",
            "leftCorner": {
              "x": -23.112,
              "y": -22.459,
              "z": 0.759
            },
            "rightCorner": {
              "x": -22.976,
              "y": -22.456,
              "z": 0.759
            },
            "gtin": "8700216665452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c40",
            "leftCorner": {
              "x": -22.976,
              "y": -22.456,
              "z": 0.759
            },
            "rightCorner": {
              "x": -22.805,
              "y": -22.452,
              "z": 0.759
            },
            "gtin": "8700216665612",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d270",
        "height": 1.281,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c2d",
            "leftCorner": {
              "x": -23.868,
              "y": -22.518,
              "z": 1.048
            },
            "rightCorner": {
              "x": -23.711,
              "y": -22.514,
              "z": 1.048
            },
            "gtin": "4015200035161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c2e",
            "leftCorner": {
              "x": -23.711,
              "y": -22.514,
              "z": 1.048
            },
            "rightCorner": {
              "x": -23.555,
              "y": -22.51,
              "z": 1.048
            },
            "gtin": "4015200035161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c30",
            "leftCorner": {
              "x": -23.564,
              "y": -22.156,
              "z": 1.048
            },
            "rightCorner": {
              "x": -23.537,
              "y": -22.155,
              "z": 1.048
            },
            "gtin": "8700216570152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c31",
            "leftCorner": {
              "x": -23.529,
              "y": -22.473,
              "z": 1.048
            },
            "rightCorner": {
              "x": -23.232,
              "y": -22.466,
              "z": 1.048
            },
            "gtin": "8700216570152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c32",
            "leftCorner": {
              "x": -23.232,
              "y": -22.46,
              "z": 1.048
            },
            "rightCorner": {
              "x": -23.083,
              "y": -22.457,
              "z": 1.048
            },
            "gtin": "8700216569934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c33",
            "leftCorner": {
              "x": -23.083,
              "y": -22.457,
              "z": 1.048
            },
            "rightCorner": {
              "x": -22.961,
              "y": -22.455,
              "z": 1.048
            },
            "gtin": "8700216570084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c34",
            "leftCorner": {
              "x": -22.961,
              "y": -22.455,
              "z": 1.048
            },
            "rightCorner": {
              "x": -22.86,
              "y": -22.453,
              "z": 1.048
            },
            "gtin": "4015200036090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c35",
            "leftCorner": {
              "x": -22.86,
              "y": -22.453,
              "z": 1.048
            },
            "rightCorner": {
              "x": -22.759,
              "y": -22.45,
              "z": 1.048
            },
            "gtin": "4015200036090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c36",
            "leftCorner": {
              "x": -22.759,
              "y": -22.45,
              "z": 1.048
            },
            "rightCorner": {
              "x": -22.658,
              "y": -22.448,
              "z": 1.048
            },
            "gtin": "4015200036090",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d26e",
        "height": 1.7311,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c07",
            "leftCorner": {
              "x": -23.812,
              "y": -22.489,
              "z": 1.416
            },
            "rightCorner": {
              "x": -23.667,
              "y": -22.485,
              "z": 1.416
            },
            "gtin": "4015200035871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c08",
            "leftCorner": {
              "x": -23.667,
              "y": -22.486,
              "z": 1.416
            },
            "rightCorner": {
              "x": -23.491,
              "y": -22.481,
              "z": 1.416
            },
            "gtin": "4012400524105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c09",
            "leftCorner": {
              "x": -23.491,
              "y": -22.477,
              "z": 1.416
            },
            "rightCorner": {
              "x": -23.379,
              "y": -22.474,
              "z": 1.416
            },
            "gtin": "4012400524242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c0a",
            "leftCorner": {
              "x": -23.379,
              "y": -22.472,
              "z": 1.416
            },
            "rightCorner": {
              "x": -23.225,
              "y": -22.468,
              "z": 1.416
            },
            "gtin": "4012400524044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c0b",
            "leftCorner": {
              "x": -23.225,
              "y": -22.465,
              "z": 1.416
            },
            "rightCorner": {
              "x": -23.086,
              "y": -22.462,
              "z": 1.416
            },
            "gtin": "4012400524396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c0c",
            "leftCorner": {
              "x": -23.086,
              "y": -22.459,
              "z": 1.416
            },
            "rightCorner": {
              "x": -22.954,
              "y": -22.456,
              "z": 1.416
            },
            "gtin": "4012400500925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c0d",
            "leftCorner": {
              "x": -22.954,
              "y": -22.457,
              "z": 1.416
            },
            "rightCorner": {
              "x": -22.798,
              "y": -22.453,
              "z": 1.416
            },
            "gtin": "4012400500987",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "510",
    "rightNeighborShelfId": "513"
  },
  {
    "id": "513",
    "name": "513",
    "x": -22.87,
    "y": -22.39,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.012714,
      "w": 0.99992
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 31,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d276",
        "height": 0.16894,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bf3",
            "leftCorner": {
              "x": -22.793,
              "y": -22.458,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.651,
              "y": -22.454,
              "z": 0.138
            },
            "gtin": "4000196120892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bf4",
            "leftCorner": {
              "x": -22.651,
              "y": -22.46,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.492,
              "y": -22.456,
              "z": 0.138
            },
            "gtin": "4306188360469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bf5",
            "leftCorner": {
              "x": -22.492,
              "y": -22.46,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.234,
              "y": -22.454,
              "z": 0.138
            },
            "gtin": "4306188370215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bf6",
            "leftCorner": {
              "x": -22.234,
              "y": -22.456,
              "z": 0.138
            },
            "rightCorner": {
              "x": -21.961,
              "y": -22.448,
              "z": 0.138
            },
            "gtin": "4306188001522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6beb",
            "leftCorner": {
              "x": -21.961,
              "y": -22.451,
              "z": 0.138
            },
            "rightCorner": {
              "x": -21.869,
              "y": -22.45,
              "z": 0.138
            },
            "gtin": "4306188360438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f46a3f9475c5b3acd52223c0",
            "leftCorner": {
              "x": -22.867,
              "y": -22.51,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.801,
              "y": -22.508,
              "z": 0.138
            },
            "gtin": "4306188370215",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d275",
        "height": 0.58677,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c28",
            "leftCorner": {
              "x": -22.817,
              "y": -22.476,
              "z": 0.48
            },
            "rightCorner": {
              "x": -22.656,
              "y": -22.472,
              "z": 0.48
            },
            "gtin": "4001499966613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c29",
            "leftCorner": {
              "x": -22.656,
              "y": -22.477,
              "z": 0.48
            },
            "rightCorner": {
              "x": -22.495,
              "y": -22.473,
              "z": 0.48
            },
            "gtin": "4001499966637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c2a",
            "leftCorner": {
              "x": -22.495,
              "y": -22.478,
              "z": 0.48
            },
            "rightCorner": {
              "x": -22.361,
              "y": -22.474,
              "z": 0.48
            },
            "gtin": "4306188025412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c2b",
            "leftCorner": {
              "x": -22.361,
              "y": -22.474,
              "z": 0.48
            },
            "rightCorner": {
              "x": -22.228,
              "y": -22.471,
              "z": 0.48
            },
            "gtin": "4306188025412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c2c",
            "leftCorner": {
              "x": -22.228,
              "y": -22.475,
              "z": 0.48
            },
            "rightCorner": {
              "x": -21.981,
              "y": -22.469,
              "z": 0.48
            },
            "gtin": "4306188025443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c23",
            "leftCorner": {
              "x": -21.981,
              "y": -22.473,
              "z": 0.48
            },
            "rightCorner": {
              "x": -21.868,
              "y": -22.471,
              "z": 0.48
            },
            "gtin": "4306188370185",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d273",
        "height": 0.92817,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c41",
            "leftCorner": {
              "x": -22.805,
              "y": -22.454,
              "z": 0.759
            },
            "rightCorner": {
              "x": -22.706,
              "y": -22.451,
              "z": 0.759
            },
            "gtin": "4015200031941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9d311b3913f169d679d22d90",
            "leftCorner": {
              "x": -22.072,
              "y": -22.491,
              "z": 0.759
            },
            "rightCorner": {
              "x": -21.913,
              "y": -22.487,
              "z": 0.759
            },
            "gtin": "4015200035819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c42",
            "leftCorner": {
              "x": -22.706,
              "y": -22.457,
              "z": 0.759
            },
            "rightCorner": {
              "x": -22.557,
              "y": -22.453,
              "z": 0.759
            },
            "gtin": "4015200035802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c43",
            "leftCorner": {
              "x": -22.557,
              "y": -22.453,
              "z": 0.759
            },
            "rightCorner": {
              "x": -22.408,
              "y": -22.449,
              "z": 0.759
            },
            "gtin": "4015200035802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c44",
            "leftCorner": {
              "x": -22.408,
              "y": -22.456,
              "z": 0.759
            },
            "rightCorner": {
              "x": -22.268,
              "y": -22.454,
              "z": 0.759
            },
            "gtin": "4015200035819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c45",
            "leftCorner": {
              "x": -22.268,
              "y": -22.458,
              "z": 0.759
            },
            "rightCorner": {
              "x": -22.17,
              "y": -22.455,
              "z": 0.759
            },
            "gtin": "4015200033778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c46",
            "leftCorner": {
              "x": -22.17,
              "y": -22.455,
              "z": 0.759
            },
            "rightCorner": {
              "x": -22.073,
              "y": -22.453,
              "z": 0.759
            },
            "gtin": "4015200033778",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d274",
        "height": 1.2793,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c37",
            "leftCorner": {
              "x": -22.658,
              "y": -22.456,
              "z": 1.047
            },
            "rightCorner": {
              "x": -22.468,
              "y": -22.451,
              "z": 1.047
            },
            "gtin": "4015200036113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c38",
            "leftCorner": {
              "x": -22.468,
              "y": -22.459,
              "z": 1.047
            },
            "rightCorner": {
              "x": -22.25,
              "y": -22.453,
              "z": 1.047
            },
            "gtin": "4015200036106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c2f",
            "leftCorner": {
              "x": -22.256,
              "y": -22.182,
              "z": 1.047
            },
            "rightCorner": {
              "x": -21.875,
              "y": -22.173,
              "z": 1.047
            },
            "gtin": "4015200033662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7141220a3fd0d5f5d2dd6168",
            "leftCorner": {
              "x": -22.867,
              "y": -22.505,
              "z": 1.047
            },
            "rightCorner": {
              "x": -22.714,
              "y": -22.501,
              "z": 1.047
            },
            "gtin": "4015200036113",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d277",
        "height": 1.7299,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c0e",
            "leftCorner": {
              "x": -22.798,
              "y": -22.466,
              "z": 1.415
            },
            "rightCorner": {
              "x": -22.592,
              "y": -22.46,
              "z": 1.415
            },
            "gtin": "4013162033867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c0f",
            "leftCorner": {
              "x": -22.592,
              "y": -22.465,
              "z": 1.415
            },
            "rightCorner": {
              "x": -22.453,
              "y": -22.462,
              "z": 1.415
            },
            "gtin": "8720181327056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c10",
            "leftCorner": {
              "x": -22.453,
              "y": -22.462,
              "z": 1.415
            },
            "rightCorner": {
              "x": -22.328,
              "y": -22.459,
              "z": 1.415
            },
            "gtin": "8720181327117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c11",
            "leftCorner": {
              "x": -22.328,
              "y": -22.46,
              "z": 1.415
            },
            "rightCorner": {
              "x": -22.192,
              "y": -22.456,
              "z": 1.415
            },
            "gtin": "8720181688454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c12",
            "leftCorner": {
              "x": -22.192,
              "y": -22.46,
              "z": 1.415
            },
            "rightCorner": {
              "x": -22.061,
              "y": -22.457,
              "z": 1.415
            },
            "gtin": "8720181688478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c13",
            "leftCorner": {
              "x": -22.06,
              "y": -22.461,
              "z": 1.415
            },
            "rightCorner": {
              "x": -21.945,
              "y": -22.458,
              "z": 1.415
            },
            "gtin": "4000196110329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bff",
            "leftCorner": {
              "x": -21.945,
              "y": -22.458,
              "z": 1.415
            },
            "rightCorner": {
              "x": -21.869,
              "y": -22.457,
              "z": 1.415
            },
            "gtin": "4000196110381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9839c2b95b9db1ccc908f90e",
            "leftCorner": {
              "x": -22.867,
              "y": -22.514,
              "z": 1.415
            },
            "rightCorner": {
              "x": -22.798,
              "y": -22.512,
              "z": 1.415
            },
            "gtin": "4000196110381",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "512"
  },
  {
    "id": "515",
    "name": "515",
    "x": -21.879,
    "y": -20.96,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99993,
      "w": 0.012226
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 35,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d72a",
        "height": 0.16689,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87e4",
            "leftCorner": {
              "x": -21.876,
              "y": -21.07,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.149,
              "y": -21.077,
              "z": 0.137
            },
            "gtin": "4008429157172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87e6",
            "leftCorner": {
              "x": -22.148,
              "y": -21.115,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.353,
              "y": -21.12,
              "z": 0.137
            },
            "gtin": "4008429157165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87e7",
            "leftCorner": {
              "x": -22.353,
              "y": -21.121,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.532,
              "y": -21.125,
              "z": 0.137
            },
            "gtin": "4008429157226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87e8",
            "leftCorner": {
              "x": -22.532,
              "y": -21.128,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.617,
              "y": -21.129,
              "z": 0.137
            },
            "gtin": "4008429155888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87e5",
            "leftCorner": {
              "x": -22.617,
              "y": -21.127,
              "z": 0.137
            },
            "rightCorner": {
              "x": -22.876,
              "y": -21.133,
              "z": 0.137
            },
            "gtin": "3065890155916",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d72b",
        "height": 0.59114,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87e9",
            "leftCorner": {
              "x": -21.877,
              "y": -21.06,
              "z": 0.484
            },
            "rightCorner": {
              "x": -22.149,
              "y": -21.067,
              "z": 0.484
            },
            "gtin": "4008239589781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87eb",
            "leftCorner": {
              "x": -22.149,
              "y": -21.1,
              "z": 0.484
            },
            "rightCorner": {
              "x": -22.349,
              "y": -21.105,
              "z": 0.484
            },
            "gtin": "4008429155796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87ec",
            "leftCorner": {
              "x": -22.349,
              "y": -21.111,
              "z": 0.484
            },
            "rightCorner": {
              "x": -22.558,
              "y": -21.116,
              "z": 0.484
            },
            "gtin": "3065890154971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87ea",
            "leftCorner": {
              "x": -22.558,
              "y": -21.118,
              "z": 0.484
            },
            "rightCorner": {
              "x": -22.876,
              "y": -21.126,
              "z": 0.484
            },
            "gtin": "4008429156205",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d729",
        "height": 0.93132,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87de",
            "leftCorner": {
              "x": -21.876,
              "y": -21.076,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.042,
              "y": -21.08,
              "z": 0.762
            },
            "gtin": "4008239313201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87e1",
            "leftCorner": {
              "x": -22.042,
              "y": -21.118,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.153,
              "y": -21.121,
              "z": 0.762
            },
            "gtin": "4008239313218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87e2",
            "leftCorner": {
              "x": -22.153,
              "y": -21.12,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.253,
              "y": -21.122,
              "z": 0.762
            },
            "gtin": "4008239313232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87e3",
            "leftCorner": {
              "x": -22.253,
              "y": -21.126,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.543,
              "y": -21.133,
              "z": 0.762
            },
            "gtin": "4008429011856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87df",
            "leftCorner": {
              "x": -22.543,
              "y": -21.133,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.708,
              "y": -21.137,
              "z": 0.762
            },
            "gtin": "4036897205705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87e0",
            "leftCorner": {
              "x": -22.708,
              "y": -21.137,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.875,
              "y": -21.141,
              "z": 0.762
            },
            "gtin": "4036897205705",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d728",
        "height": 1.2341,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87d6",
            "leftCorner": {
              "x": -21.876,
              "y": -21.079,
              "z": 1.01
            },
            "rightCorner": {
              "x": -21.976,
              "y": -21.081,
              "z": 1.01
            },
            "gtin": "4008239352859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87d8",
            "leftCorner": {
              "x": -21.976,
              "y": -21.117,
              "z": 1.01
            },
            "rightCorner": {
              "x": -22.145,
              "y": -21.121,
              "z": 1.01
            },
            "gtin": "4008239352866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87d9",
            "leftCorner": {
              "x": -22.145,
              "y": -21.12,
              "z": 1.01
            },
            "rightCorner": {
              "x": -22.243,
              "y": -21.122,
              "z": 1.01
            },
            "gtin": "4008239352842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87da",
            "leftCorner": {
              "x": -22.243,
              "y": -21.125,
              "z": 1.01
            },
            "rightCorner": {
              "x": -22.331,
              "y": -21.127,
              "z": 1.01
            },
            "gtin": "4008239352903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87db",
            "leftCorner": {
              "x": -22.33,
              "y": -21.132,
              "z": 1.01
            },
            "rightCorner": {
              "x": -22.423,
              "y": -21.134,
              "z": 1.01
            },
            "gtin": "4008239352873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87dc",
            "leftCorner": {
              "x": -22.424,
              "y": -21.131,
              "z": 1.01
            },
            "rightCorner": {
              "x": -22.528,
              "y": -21.134,
              "z": 1.01
            },
            "gtin": "4008239108692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87dd",
            "leftCorner": {
              "x": -22.528,
              "y": -21.138,
              "z": 1.01
            },
            "rightCorner": {
              "x": -22.653,
              "y": -21.142,
              "z": 1.01
            },
            "gtin": "4008239241924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87d7",
            "leftCorner": {
              "x": -22.653,
              "y": -21.14,
              "z": 1.01
            },
            "rightCorner": {
              "x": -22.875,
              "y": -21.145,
              "z": 1.01
            },
            "gtin": "4008239393142",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d727",
        "height": 1.4861,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87ce",
            "leftCorner": {
              "x": -21.876,
              "y": -21.072,
              "z": 1.216
            },
            "rightCorner": {
              "x": -22.002,
              "y": -21.075,
              "z": 1.216
            },
            "gtin": "4008239288226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87d0",
            "leftCorner": {
              "x": -22.002,
              "y": -21.109,
              "z": 1.216
            },
            "rightCorner": {
              "x": -22.114,
              "y": -21.112,
              "z": 1.216
            },
            "gtin": "4008239288233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87d1",
            "leftCorner": {
              "x": -22.114,
              "y": -21.112,
              "z": 1.216
            },
            "rightCorner": {
              "x": -22.213,
              "y": -21.114,
              "z": 1.216
            },
            "gtin": "4008239288219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87d2",
            "leftCorner": {
              "x": -22.213,
              "y": -21.117,
              "z": 1.216
            },
            "rightCorner": {
              "x": -22.3,
              "y": -21.119,
              "z": 1.216
            },
            "gtin": "4008239343574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87d3",
            "leftCorner": {
              "x": -22.3,
              "y": -21.122,
              "z": 1.216
            },
            "rightCorner": {
              "x": -22.437,
              "y": -21.125,
              "z": 1.216
            },
            "gtin": "7610376164232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87d4",
            "leftCorner": {
              "x": -22.437,
              "y": -21.124,
              "z": 1.216
            },
            "rightCorner": {
              "x": -22.52,
              "y": -21.127,
              "z": 1.216
            },
            "gtin": "4008239580665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87d5",
            "leftCorner": {
              "x": -22.52,
              "y": -21.13,
              "z": 1.216
            },
            "rightCorner": {
              "x": -22.683,
              "y": -21.133,
              "z": 1.216
            },
            "gtin": "7610376164249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87cf",
            "leftCorner": {
              "x": -22.682,
              "y": -21.137,
              "z": 1.216
            },
            "rightCorner": {
              "x": -22.875,
              "y": -21.142,
              "z": 1.216
            },
            "gtin": "4008239235213",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d726",
        "height": 1.7341,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87ca",
            "leftCorner": {
              "x": -21.876,
              "y": -21.073,
              "z": 1.419
            },
            "rightCorner": {
              "x": -22.153,
              "y": -21.079,
              "z": 1.419
            },
            "gtin": "4008429159640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87cc",
            "leftCorner": {
              "x": -22.153,
              "y": -21.115,
              "z": 1.419
            },
            "rightCorner": {
              "x": -22.338,
              "y": -21.12,
              "z": 1.419
            },
            "gtin": "5900951307775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87cd",
            "leftCorner": {
              "x": -22.338,
              "y": -21.127,
              "z": 1.419
            },
            "rightCorner": {
              "x": -22.589,
              "y": -21.134,
              "z": 1.419
            },
            "gtin": "5900951307492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87cb",
            "leftCorner": {
              "x": -22.59,
              "y": -21.131,
              "z": 1.419
            },
            "rightCorner": {
              "x": -22.875,
              "y": -21.138,
              "z": 1.419
            },
            "gtin": "4008429159435",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "516"
  },
  {
    "id": "516",
    "name": "516",
    "x": -22.878,
    "y": -20.984,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99993,
      "w": 0.012226
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 31,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d25f",
        "height": 0.15706,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bcb",
            "leftCorner": {
              "x": -22.88,
              "y": -20.9,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.069,
              "y": -20.905,
              "z": 0.129
            },
            "gtin": "7613036898577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6410b97897030f059247ec21",
            "leftCorner": {
              "x": -23.643,
              "y": -20.919,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.811,
              "y": -20.923,
              "z": 0.129
            },
            "gtin": "7613036898577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bcd",
            "leftCorner": {
              "x": -23.068,
              "y": -20.941,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.303,
              "y": -20.946,
              "z": 0.129
            },
            "gtin": "7613036898638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bce",
            "leftCorner": {
              "x": -23.302,
              "y": -20.951,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.587,
              "y": -20.958,
              "z": 0.129
            },
            "gtin": "4008429130359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bcf",
            "leftCorner": {
              "x": -23.587,
              "y": -20.957,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.642,
              "y": -20.958,
              "z": 0.129
            },
            "gtin": "4008429022227",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d25c",
        "height": 0.58014,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bac",
            "leftCorner": {
              "x": -22.88,
              "y": -20.896,
              "z": 0.475
            },
            "rightCorner": {
              "x": -23.135,
              "y": -20.902,
              "z": 0.475
            },
            "gtin": "3065890155008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bae",
            "leftCorner": {
              "x": -23.135,
              "y": -20.939,
              "z": 0.475
            },
            "rightCorner": {
              "x": -23.326,
              "y": -20.944,
              "z": 0.475
            },
            "gtin": "4008429171321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6baf",
            "leftCorner": {
              "x": -23.326,
              "y": -20.943,
              "z": 0.475
            },
            "rightCorner": {
              "x": -23.524,
              "y": -20.948,
              "z": 0.475
            },
            "gtin": "4008429156168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bb0",
            "leftCorner": {
              "x": -23.524,
              "y": -20.953,
              "z": 0.475
            },
            "rightCorner": {
              "x": -23.702,
              "y": -20.957,
              "z": 0.475
            },
            "gtin": "5900951302541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bb1",
            "leftCorner": {
              "x": -23.702,
              "y": -20.962,
              "z": 0.475
            },
            "rightCorner": {
              "x": -23.938,
              "y": -20.968,
              "z": 0.475
            },
            "gtin": "7613036893619",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d25e",
        "height": 0.93198,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bc1",
            "leftCorner": {
              "x": -22.88,
              "y": -20.899,
              "z": 0.763
            },
            "rightCorner": {
              "x": -23.173,
              "y": -20.906,
              "z": 0.763
            },
            "gtin": "3065890154797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bc3",
            "leftCorner": {
              "x": -23.172,
              "y": -20.942,
              "z": 0.763
            },
            "rightCorner": {
              "x": -23.31,
              "y": -20.946,
              "z": 0.763
            },
            "gtin": "4008429156021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bc4",
            "leftCorner": {
              "x": -23.31,
              "y": -20.948,
              "z": 0.763
            },
            "rightCorner": {
              "x": -23.587,
              "y": -20.955,
              "z": 0.763
            },
            "gtin": "8410136025792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bc5",
            "leftCorner": {
              "x": -23.587,
              "y": -20.959,
              "z": 0.763
            },
            "rightCorner": {
              "x": -23.991,
              "y": -20.969,
              "z": 0.763
            },
            "gtin": "4008429157066",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d25b",
        "height": 1.2356,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b9b",
            "leftCorner": {
              "x": -22.88,
              "y": -20.9,
              "z": 1.011
            },
            "rightCorner": {
              "x": -23.035,
              "y": -20.903,
              "z": 1.011
            },
            "gtin": "5998749146842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b9c",
            "leftCorner": {
              "x": -23.034,
              "y": -20.941,
              "z": 1.011
            },
            "rightCorner": {
              "x": -23.15,
              "y": -20.945,
              "z": 1.011
            },
            "gtin": "5998749146576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b9d",
            "leftCorner": {
              "x": -23.15,
              "y": -20.944,
              "z": 1.011
            },
            "rightCorner": {
              "x": -23.272,
              "y": -20.946,
              "z": 1.011
            },
            "gtin": "5998749146477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b9e",
            "leftCorner": {
              "x": -23.272,
              "y": -20.948,
              "z": 1.011
            },
            "rightCorner": {
              "x": -23.406,
              "y": -20.952,
              "z": 1.011
            },
            "gtin": "5998749146804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b9f",
            "leftCorner": {
              "x": -23.406,
              "y": -20.952,
              "z": 1.011
            },
            "rightCorner": {
              "x": -23.533,
              "y": -20.955,
              "z": 1.011
            },
            "gtin": "5998749146637",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6ba0",
            "leftCorner": {
              "x": -23.534,
              "y": -20.96,
              "z": 1.011
            },
            "rightCorner": {
              "x": -23.733,
              "y": -20.965,
              "z": 1.011
            },
            "gtin": "4008429037962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ba1",
            "leftCorner": {
              "x": -23.733,
              "y": -20.969,
              "z": 1.011
            },
            "rightCorner": {
              "x": -23.914,
              "y": -20.973,
              "z": 1.011
            },
            "gtin": "4008429055249",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d25a",
        "height": 1.4874,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b8c",
            "leftCorner": {
              "x": -22.88,
              "y": -20.893,
              "z": 1.217
            },
            "rightCorner": {
              "x": -23.111,
              "y": -20.899,
              "z": 1.217
            },
            "gtin": "4008239589248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b8e",
            "leftCorner": {
              "x": -23.111,
              "y": -20.937,
              "z": 1.217
            },
            "rightCorner": {
              "x": -23.248,
              "y": -20.941,
              "z": 1.217
            },
            "gtin": "5998749139714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b8f",
            "leftCorner": {
              "x": -23.248,
              "y": -20.941,
              "z": 1.217
            },
            "rightCorner": {
              "x": -23.404,
              "y": -20.944,
              "z": 1.217
            },
            "gtin": "5998749139677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b90",
            "leftCorner": {
              "x": -23.404,
              "y": -20.943,
              "z": 1.217
            },
            "rightCorner": {
              "x": -23.51,
              "y": -20.945,
              "z": 1.217
            },
            "gtin": "5998749146590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b91",
            "leftCorner": {
              "x": -23.51,
              "y": -20.948,
              "z": 1.217
            },
            "rightCorner": {
              "x": -23.613,
              "y": -20.951,
              "z": 1.217
            },
            "gtin": "5998749146712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b92",
            "leftCorner": {
              "x": -23.612,
              "y": -20.956,
              "z": 1.217
            },
            "rightCorner": {
              "x": -23.925,
              "y": -20.963,
              "z": 1.217
            },
            "gtin": "4008429081767",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d25d",
        "height": 1.7349,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bb6",
            "leftCorner": {
              "x": -22.88,
              "y": -20.901,
              "z": 1.419
            },
            "rightCorner": {
              "x": -23.109,
              "y": -20.906,
              "z": 1.419
            },
            "gtin": "5900951296550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bb8",
            "leftCorner": {
              "x": -23.108,
              "y": -20.944,
              "z": 1.419
            },
            "rightCorner": {
              "x": -23.3,
              "y": -20.948,
              "z": 1.419
            },
            "gtin": "5900951296536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bb9",
            "leftCorner": {
              "x": -23.3,
              "y": -20.949,
              "z": 1.419
            },
            "rightCorner": {
              "x": -23.513,
              "y": -20.954,
              "z": 1.419
            },
            "gtin": "5900951296499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bba",
            "leftCorner": {
              "x": -23.513,
              "y": -20.957,
              "z": 1.419
            },
            "rightCorner": {
              "x": -23.684,
              "y": -20.961,
              "z": 1.419
            },
            "gtin": "5900951296512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bbb",
            "leftCorner": {
              "x": -23.684,
              "y": -20.964,
              "z": 1.419
            },
            "rightCorner": {
              "x": -23.971,
              "y": -20.971,
              "z": 1.419
            },
            "gtin": "5900951296451",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "515",
    "rightNeighborShelfId": "517"
  },
  {
    "id": "517",
    "name": "517",
    "x": -23.878,
    "y": -21.009,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99993,
      "w": 0.012226
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 39,
      "shelfCategory": "PET"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d731",
        "height": 0.15549,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bd1",
            "leftCorner": {
              "x": -23.953,
              "y": -20.975,
              "z": 0.127
            },
            "rightCorner": {
              "x": -24.637,
              "y": -20.992,
              "z": 0.127
            },
            "gtin": "4008429130434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bd2",
            "leftCorner": {
              "x": -24.637,
              "y": -20.98,
              "z": 0.127
            },
            "rightCorner": {
              "x": -24.941,
              "y": -20.987,
              "z": 0.127
            },
            "gtin": "9120004635976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bcc",
            "leftCorner": {
              "x": -24.941,
              "y": -20.995,
              "z": 0.127
            },
            "rightCorner": {
              "x": -25.128,
              "y": -21.001,
              "z": 0.127
            },
            "gtin": "4002973000168",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d72f",
        "height": 0.57747,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bb2",
            "leftCorner": {
              "x": -23.938,
              "y": -20.973,
              "z": 0.472
            },
            "rightCorner": {
              "x": -24.163,
              "y": -20.978,
              "z": 0.472
            },
            "gtin": "7613036893633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bb3",
            "leftCorner": {
              "x": -24.163,
              "y": -20.982,
              "z": 0.472
            },
            "rightCorner": {
              "x": -24.551,
              "y": -20.992,
              "z": 0.472
            },
            "gtin": "7613036894586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bb4",
            "leftCorner": {
              "x": -24.551,
              "y": -20.991,
              "z": 0.472
            },
            "rightCorner": {
              "x": -24.811,
              "y": -20.997,
              "z": 0.472
            },
            "gtin": "7613036893596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bb5",
            "leftCorner": {
              "x": -24.811,
              "y": -20.983,
              "z": 0.472
            },
            "rightCorner": {
              "x": -24.998,
              "y": -20.988,
              "z": 0.472
            },
            "gtin": "7613036893848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bad",
            "leftCorner": {
              "x": -24.998,
              "y": -20.989,
              "z": 0.472
            },
            "rightCorner": {
              "x": -25.128,
              "y": -20.993,
              "z": 0.472
            },
            "gtin": "7613036894562",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d72e",
        "height": 0.92997,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bc6",
            "leftCorner": {
              "x": -23.99,
              "y": -20.973,
              "z": 0.761
            },
            "rightCorner": {
              "x": -24.219,
              "y": -20.979,
              "z": 0.761
            },
            "gtin": "7613036894005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bc7",
            "leftCorner": {
              "x": -24.219,
              "y": -20.987,
              "z": 0.761
            },
            "rightCorner": {
              "x": -24.42,
              "y": -20.992,
              "z": 0.761
            },
            "gtin": "7613036894609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bc8",
            "leftCorner": {
              "x": -24.42,
              "y": -20.991,
              "z": 0.761
            },
            "rightCorner": {
              "x": -24.624,
              "y": -20.997,
              "z": 0.761
            },
            "gtin": "7613287749802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bc9",
            "leftCorner": {
              "x": -24.624,
              "y": -20.993,
              "z": 0.761
            },
            "rightCorner": {
              "x": -24.824,
              "y": -20.998,
              "z": 0.761
            },
            "gtin": "7613037379716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bca",
            "leftCorner": {
              "x": -24.824,
              "y": -20.985,
              "z": 0.761
            },
            "rightCorner": {
              "x": -25.027,
              "y": -20.989,
              "z": 0.761
            },
            "gtin": "8445290142085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bc2",
            "leftCorner": {
              "x": -25.027,
              "y": -20.986,
              "z": 0.761
            },
            "rightCorner": {
              "x": -25.128,
              "y": -20.99,
              "z": 0.761
            },
            "gtin": "7613287745880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a8769b5ffb93582534cb504d",
            "leftCorner": {
              "x": -23.88,
              "y": -20.933,
              "z": 0.761
            },
            "rightCorner": {
              "x": -23.991,
              "y": -20.936,
              "z": 0.761
            },
            "gtin": "7613287745880",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d72c",
        "height": 1.2341,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6ba2",
            "leftCorner": {
              "x": -23.913,
              "y": -20.979,
              "z": 1.01
            },
            "rightCorner": {
              "x": -24.032,
              "y": -20.983,
              "z": 1.01
            },
            "gtin": "4008429037894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ba3",
            "leftCorner": {
              "x": -24.032,
              "y": -20.982,
              "z": 1.01
            },
            "rightCorner": {
              "x": -24.219,
              "y": -20.987,
              "z": 1.01
            },
            "gtin": "7613036631976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ba4",
            "leftCorner": {
              "x": -24.219,
              "y": -20.994,
              "z": 1.01
            },
            "rightCorner": {
              "x": -24.32,
              "y": -20.996,
              "z": 1.01
            },
            "gtin": "7613036632416",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6ba5",
            "leftCorner": {
              "x": -24.32,
              "y": -20.996,
              "z": 1.01
            },
            "rightCorner": {
              "x": -24.41,
              "y": -20.998,
              "z": 1.01
            },
            "gtin": "7613036631952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ba6",
            "leftCorner": {
              "x": -24.41,
              "y": -20.992,
              "z": 1.01
            },
            "rightCorner": {
              "x": -24.522,
              "y": -20.996,
              "z": 1.01
            },
            "gtin": "7613287611864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ba7",
            "leftCorner": {
              "x": -24.522,
              "y": -20.998,
              "z": 1.01
            },
            "rightCorner": {
              "x": -24.616,
              "y": -21.0,
              "z": 1.01
            },
            "gtin": "7613036064859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ba8",
            "leftCorner": {
              "x": -24.616,
              "y": -20.999,
              "z": 1.01
            },
            "rightCorner": {
              "x": -24.727,
              "y": -21.001,
              "z": 1.01
            },
            "gtin": "7613034290557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ba9",
            "leftCorner": {
              "x": -24.727,
              "y": -20.998,
              "z": 1.01
            },
            "rightCorner": {
              "x": -24.819,
              "y": -21.0,
              "z": 1.01
            },
            "gtin": "7613034290571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6baa",
            "leftCorner": {
              "x": -24.819,
              "y": -20.991,
              "z": 1.01
            },
            "rightCorner": {
              "x": -24.912,
              "y": -20.993,
              "z": 1.01
            },
            "gtin": "7613038169408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bab",
            "leftCorner": {
              "x": -24.912,
              "y": -20.993,
              "z": 1.01
            },
            "rightCorner": {
              "x": -25.103,
              "y": -20.997,
              "z": 1.01
            },
            "gtin": "7613287348074",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d72d",
        "height": 1.4854,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6b93",
            "leftCorner": {
              "x": -23.925,
              "y": -20.971,
              "z": 1.215
            },
            "rightCorner": {
              "x": -24.017,
              "y": -20.974,
              "z": 1.215
            },
            "gtin": "5998749144633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b94",
            "leftCorner": {
              "x": -24.017,
              "y": -20.97,
              "z": 1.215
            },
            "rightCorner": {
              "x": -24.157,
              "y": -20.972,
              "z": 1.215
            },
            "gtin": "5998749142363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b95",
            "leftCorner": {
              "x": -24.157,
              "y": -20.979,
              "z": 1.215
            },
            "rightCorner": {
              "x": -24.299,
              "y": -20.982,
              "z": 1.215
            },
            "gtin": "4008429037948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b96",
            "leftCorner": {
              "x": -24.299,
              "y": -20.985,
              "z": 1.215
            },
            "rightCorner": {
              "x": -24.42,
              "y": -20.987,
              "z": 1.215
            },
            "gtin": "4008429037986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b97",
            "leftCorner": {
              "x": -24.42,
              "y": -20.982,
              "z": 1.215
            },
            "rightCorner": {
              "x": -24.644,
              "y": -20.988,
              "z": 1.215
            },
            "gtin": "7613033743771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b98",
            "leftCorner": {
              "x": -24.644,
              "y": -20.987,
              "z": 1.215
            },
            "rightCorner": {
              "x": -24.84,
              "y": -20.991,
              "z": 1.215
            },
            "gtin": "7613034274953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b99",
            "leftCorner": {
              "x": -24.84,
              "y": -20.983,
              "z": 1.215
            },
            "rightCorner": {
              "x": -24.926,
              "y": -20.985,
              "z": 1.215
            },
            "gtin": "7613033742484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b9a",
            "leftCorner": {
              "x": -24.926,
              "y": -20.982,
              "z": 1.215
            },
            "rightCorner": {
              "x": -25.013,
              "y": -20.984,
              "z": 1.215
            },
            "gtin": "7613033742507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6b8d",
            "leftCorner": {
              "x": -25.013,
              "y": -20.984,
              "z": 1.215
            },
            "rightCorner": {
              "x": -25.128,
              "y": -20.987,
              "z": 1.215
            },
            "gtin": "7613034096838",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d730",
        "height": 1.7328,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bbc",
            "leftCorner": {
              "x": -23.971,
              "y": -20.978,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.168,
              "y": -20.983,
              "z": 1.418
            },
            "gtin": "5900951258626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bbd",
            "leftCorner": {
              "x": -24.168,
              "y": -20.987,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.4,
              "y": -20.993,
              "z": 1.418
            },
            "gtin": "5900951267758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bbe",
            "leftCorner": {
              "x": -24.4,
              "y": -20.989,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.612,
              "y": -20.995,
              "z": 1.418
            },
            "gtin": "5900951258589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bbf",
            "leftCorner": {
              "x": -24.612,
              "y": -20.995,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.847,
              "y": -21.0,
              "z": 1.418
            },
            "gtin": "3222270189644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bc0",
            "leftCorner": {
              "x": -24.848,
              "y": -20.984,
              "z": 1.418
            },
            "rightCorner": {
              "x": -25.005,
              "y": -20.988,
              "z": 1.418
            },
            "gtin": "7613032728748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bb7",
            "leftCorner": {
              "x": -25.005,
              "y": -20.985,
              "z": 1.418
            },
            "rightCorner": {
              "x": -25.128,
              "y": -20.988,
              "z": 1.418
            },
            "gtin": "7613032727826",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "516"
  },
  {
    "id": "518",
    "name": "518",
    "x": -25.646,
    "y": -21.119,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70178,
      "w": 0.71239
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 21,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d266",
        "height": 0.22375,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6be8",
            "leftCorner": {
              "x": -25.757,
              "y": -21.121,
              "z": 0.183
            },
            "rightCorner": {
              "x": -25.755,
              "y": -21.336,
              "z": 0.183
            },
            "gtin": "4015200031774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6be9",
            "leftCorner": {
              "x": -25.715,
              "y": -21.335,
              "z": 0.183
            },
            "rightCorner": {
              "x": -25.699,
              "y": -22.37,
              "z": 0.183
            },
            "gtin": "4015200031774",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d264",
        "height": 0.6738,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bdc",
            "leftCorner": {
              "x": -25.72,
              "y": -21.12,
              "z": 0.551
            },
            "rightCorner": {
              "x": -25.719,
              "y": -21.161,
              "z": 0.551
            },
            "gtin": "4012400501953",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "98eb6966fab953106576b364",
            "leftCorner": {
              "x": -25.719,
              "y": -21.161,
              "z": 0.551
            },
            "rightCorner": {
              "x": -25.717,
              "y": -21.287,
              "z": 0.551
            },
            "gtin": "4019181777652",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6bdf",
            "leftCorner": {
              "x": -25.43,
              "y": -21.285,
              "z": 0.551
            },
            "rightCorner": {
              "x": -25.426,
              "y": -21.55,
              "z": 0.551
            },
            "gtin": "4012400502905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6be0",
            "leftCorner": {
              "x": -25.673,
              "y": -21.554,
              "z": 0.551
            },
            "rightCorner": {
              "x": -25.668,
              "y": -21.852,
              "z": 0.551
            },
            "gtin": "4013162033836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6be1",
            "leftCorner": {
              "x": -25.669,
              "y": -21.852,
              "z": 0.551
            },
            "rightCorner": {
              "x": -25.664,
              "y": -22.243,
              "z": 0.551
            },
            "gtin": "4015200033112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bdd",
            "leftCorner": {
              "x": -25.659,
              "y": -22.243,
              "z": 0.551
            },
            "rightCorner": {
              "x": -25.657,
              "y": -22.37,
              "z": 0.551
            },
            "gtin": "4019181777652",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d263",
        "height": 1.0801,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bd6",
            "leftCorner": {
              "x": -25.719,
              "y": -21.12,
              "z": 0.884
            },
            "rightCorner": {
              "x": -25.716,
              "y": -21.318,
              "z": 0.884
            },
            "gtin": "5000204592320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bd8",
            "leftCorner": {
              "x": -25.675,
              "y": -21.318,
              "z": 0.884
            },
            "rightCorner": {
              "x": -25.67,
              "y": -21.656,
              "z": 0.884
            },
            "gtin": "5000204096927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bd9",
            "leftCorner": {
              "x": -25.673,
              "y": -21.656,
              "z": 0.884
            },
            "rightCorner": {
              "x": -25.671,
              "y": -21.825,
              "z": 0.884
            },
            "gtin": "8700216731294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bda",
            "leftCorner": {
              "x": -25.672,
              "y": -21.825,
              "z": 0.884
            },
            "rightCorner": {
              "x": -25.667,
              "y": -22.123,
              "z": 0.884
            },
            "gtin": "8700216657174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bdb",
            "leftCorner": {
              "x": -25.66,
              "y": -22.123,
              "z": 0.884
            },
            "rightCorner": {
              "x": -25.658,
              "y": -22.268,
              "z": 0.884
            },
            "gtin": "4016100534815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bd7",
            "leftCorner": {
              "x": -25.659,
              "y": -22.268,
              "z": 0.884
            },
            "rightCorner": {
              "x": -25.657,
              "y": -22.37,
              "z": 0.884
            },
            "gtin": "662834504811",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d265",
        "height": 1.3825,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6be2",
            "leftCorner": {
              "x": -25.728,
              "y": -21.121,
              "z": 1.131
            },
            "rightCorner": {
              "x": -25.724,
              "y": -21.357,
              "z": 1.131
            },
            "gtin": "4015200033679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0348ac5022e2714368aa3a58",
            "leftCorner": {
              "x": -25.714,
              "y": -22.065,
              "z": 1.131
            },
            "rightCorner": {
              "x": -25.71,
              "y": -22.311,
              "z": 1.131
            },
            "gtin": "4015200033525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6be3",
            "leftCorner": {
              "x": -25.724,
              "y": -21.357,
              "z": 1.131
            },
            "rightCorner": {
              "x": -25.721,
              "y": -21.592,
              "z": 1.131
            },
            "gtin": "4015200033679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6be5",
            "leftCorner": {
              "x": -25.679,
              "y": -21.592,
              "z": 1.131
            },
            "rightCorner": {
              "x": -25.676,
              "y": -21.759,
              "z": 1.131
            },
            "gtin": "4015200033778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6be6",
            "leftCorner": {
              "x": -25.68,
              "y": -21.759,
              "z": 1.131
            },
            "rightCorner": {
              "x": -25.677,
              "y": -21.912,
              "z": 1.131
            },
            "gtin": "4015200033556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6be7",
            "leftCorner": {
              "x": -25.677,
              "y": -21.912,
              "z": 1.131
            },
            "rightCorner": {
              "x": -25.675,
              "y": -22.064,
              "z": 1.131
            },
            "gtin": "4015200033556",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d261",
        "height": 1.7507,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6bd3",
            "leftCorner": {
              "x": -25.725,
              "y": -21.121,
              "z": 1.432
            },
            "rightCorner": {
              "x": -25.725,
              "y": -21.189,
              "z": 1.432
            },
            "gtin": "2000439122098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bd5",
            "leftCorner": {
              "x": -25.689,
              "y": -21.189,
              "z": 1.432
            },
            "rightCorner": {
              "x": -25.68,
              "y": -21.781,
              "z": 1.432
            },
            "gtin": "8700216197502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6bd4",
            "leftCorner": {
              "x": -25.676,
              "y": -21.781,
              "z": 1.432
            },
            "rightCorner": {
              "x": -25.667,
              "y": -22.37,
              "z": 1.432
            },
            "gtin": "8700216197502",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "519",
    "name": "519",
    "x": -21.224,
    "y": -22.291,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71039,
      "w": 0.70381
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 52,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d735",
        "height": 0.23833,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8807",
            "leftCorner": {
              "x": -21.13,
              "y": -22.29,
              "z": 0.195
            },
            "rightCorner": {
              "x": -21.131,
              "y": -22.158,
              "z": 0.195
            },
            "gtin": "4015000310048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8808",
            "leftCorner": {
              "x": -21.131,
              "y": -22.158,
              "z": 0.195
            },
            "rightCorner": {
              "x": -21.133,
              "y": -22.026,
              "z": 0.195
            },
            "gtin": "4015000310048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d880a",
            "leftCorner": {
              "x": -21.24,
              "y": -22.026,
              "z": 0.195
            },
            "rightCorner": {
              "x": -21.241,
              "y": -21.83,
              "z": 0.195
            },
            "gtin": "4251758419781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d880b",
            "leftCorner": {
              "x": -21.276,
              "y": -21.831,
              "z": 0.195
            },
            "rightCorner": {
              "x": -21.277,
              "y": -21.639,
              "z": 0.195
            },
            "gtin": "4306188003205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d880c",
            "leftCorner": {
              "x": -21.174,
              "y": -21.638,
              "z": 0.195
            },
            "rightCorner": {
              "x": -21.174,
              "y": -21.517,
              "z": 0.195
            },
            "gtin": "4015200035765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d880d",
            "leftCorner": {
              "x": -21.179,
              "y": -21.517,
              "z": 0.195
            },
            "rightCorner": {
              "x": -21.18,
              "y": -21.366,
              "z": 0.195
            },
            "gtin": "4002448046424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d880e",
            "leftCorner": {
              "x": -21.175,
              "y": -21.366,
              "z": 0.195
            },
            "rightCorner": {
              "x": -21.176,
              "y": -21.238,
              "z": 0.195
            },
            "gtin": "9005835309756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8809",
            "leftCorner": {
              "x": -21.174,
              "y": -21.238,
              "z": 0.195
            },
            "rightCorner": {
              "x": -21.175,
              "y": -21.04,
              "z": 0.195
            },
            "gtin": "4306188012689",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d736",
        "height": 0.54134,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d880f",
            "leftCorner": {
              "x": -21.169,
              "y": -22.29,
              "z": 0.443
            },
            "rightCorner": {
              "x": -21.17,
              "y": -22.181,
              "z": 0.443
            },
            "gtin": "4306188059080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8810",
            "leftCorner": {
              "x": -21.17,
              "y": -22.181,
              "z": 0.443
            },
            "rightCorner": {
              "x": -21.171,
              "y": -22.073,
              "z": 0.443
            },
            "gtin": "4306188059080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8811",
            "leftCorner": {
              "x": -21.171,
              "y": -22.073,
              "z": 0.443
            },
            "rightCorner": {
              "x": -21.172,
              "y": -21.964,
              "z": 0.443
            },
            "gtin": "4306188059080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8812",
            "leftCorner": {
              "x": -21.172,
              "y": -21.964,
              "z": 0.443
            },
            "rightCorner": {
              "x": -21.173,
              "y": -21.855,
              "z": 0.443
            },
            "gtin": "4306188059080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8814",
            "leftCorner": {
              "x": -21.211,
              "y": -21.855,
              "z": 0.443
            },
            "rightCorner": {
              "x": -21.213,
              "y": -21.577,
              "z": 0.443
            },
            "gtin": "4306188046936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8815",
            "leftCorner": {
              "x": -21.222,
              "y": -21.576,
              "z": 0.443
            },
            "rightCorner": {
              "x": -21.223,
              "y": -21.402,
              "z": 0.443
            },
            "gtin": "4306188046929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8816",
            "leftCorner": {
              "x": -21.216,
              "y": -21.402,
              "z": 0.443
            },
            "rightCorner": {
              "x": -21.218,
              "y": -21.265,
              "z": 0.443
            },
            "gtin": "4306188047285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8813",
            "leftCorner": {
              "x": -21.219,
              "y": -21.265,
              "z": 0.443
            },
            "rightCorner": {
              "x": -21.221,
              "y": -21.041,
              "z": 0.443
            },
            "gtin": "4306188046905",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d737",
        "height": 0.83035,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8817",
            "leftCorner": {
              "x": -21.18,
              "y": -22.29,
              "z": 0.679
            },
            "rightCorner": {
              "x": -21.183,
              "y": -21.892,
              "z": 0.679
            },
            "gtin": "4013162028856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d881a",
            "leftCorner": {
              "x": -21.221,
              "y": -21.893,
              "z": 0.679
            },
            "rightCorner": {
              "x": -21.222,
              "y": -21.792,
              "z": 0.679
            },
            "gtin": "4013162028979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d881b",
            "leftCorner": {
              "x": -21.222,
              "y": -21.792,
              "z": 0.679
            },
            "rightCorner": {
              "x": -21.224,
              "y": -21.691,
              "z": 0.679
            },
            "gtin": "4013162028979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d881c",
            "leftCorner": {
              "x": -21.224,
              "y": -21.691,
              "z": 0.679
            },
            "rightCorner": {
              "x": -21.224,
              "y": -21.59,
              "z": 0.679
            },
            "gtin": "4013162028979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d881d",
            "leftCorner": {
              "x": -21.233,
              "y": -21.59,
              "z": 0.679
            },
            "rightCorner": {
              "x": -21.234,
              "y": -21.517,
              "z": 0.679
            },
            "gtin": "4013162033027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d881e",
            "leftCorner": {
              "x": -21.234,
              "y": -21.517,
              "z": 0.679
            },
            "rightCorner": {
              "x": -21.235,
              "y": -21.445,
              "z": 0.679
            },
            "gtin": "4013162033027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d881f",
            "leftCorner": {
              "x": -21.235,
              "y": -21.445,
              "z": 0.679
            },
            "rightCorner": {
              "x": -21.235,
              "y": -21.373,
              "z": 0.679
            },
            "gtin": "4013162033027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8820",
            "leftCorner": {
              "x": -21.235,
              "y": -21.373,
              "z": 0.679
            },
            "rightCorner": {
              "x": -21.236,
              "y": -21.301,
              "z": 0.679
            },
            "gtin": "4013162033027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8818",
            "leftCorner": {
              "x": -21.229,
              "y": -21.301,
              "z": 0.679
            },
            "rightCorner": {
              "x": -21.23,
              "y": -21.17,
              "z": 0.679
            },
            "gtin": "4000401418011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8819",
            "leftCorner": {
              "x": -21.23,
              "y": -21.17,
              "z": 0.679
            },
            "rightCorner": {
              "x": -21.231,
              "y": -21.04,
              "z": 0.679
            },
            "gtin": "4000401418011",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d732",
        "height": 1.1335,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87ed",
            "leftCorner": {
              "x": -21.182,
              "y": -22.29,
              "z": 0.927
            },
            "rightCorner": {
              "x": -21.183,
              "y": -22.118,
              "z": 0.927
            },
            "gtin": "4001499970313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87ef",
            "leftCorner": {
              "x": -21.214,
              "y": -22.119,
              "z": 0.927
            },
            "rightCorner": {
              "x": -21.215,
              "y": -22.033,
              "z": 0.927
            },
            "gtin": "4001499970320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87f0",
            "leftCorner": {
              "x": -21.217,
              "y": -22.033,
              "z": 0.927
            },
            "rightCorner": {
              "x": -21.219,
              "y": -21.84,
              "z": 0.927
            },
            "gtin": "4001499964510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87f1",
            "leftCorner": {
              "x": -21.225,
              "y": -21.84,
              "z": 0.927
            },
            "rightCorner": {
              "x": -21.227,
              "y": -21.661,
              "z": 0.927
            },
            "gtin": "4001499964428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87f2",
            "leftCorner": {
              "x": -21.232,
              "y": -21.661,
              "z": 0.927
            },
            "rightCorner": {
              "x": -21.233,
              "y": -21.537,
              "z": 0.927
            },
            "gtin": "4001499964558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87f3",
            "leftCorner": {
              "x": -21.232,
              "y": -21.537,
              "z": 0.927
            },
            "rightCorner": {
              "x": -21.234,
              "y": -21.418,
              "z": 0.927
            },
            "gtin": "8001090510358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87f4",
            "leftCorner": {
              "x": -21.234,
              "y": -21.418,
              "z": 0.927
            },
            "rightCorner": {
              "x": -21.235,
              "y": -21.3,
              "z": 0.927
            },
            "gtin": "8001090510358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87ee",
            "leftCorner": {
              "x": -21.231,
              "y": -21.3,
              "z": 0.927
            },
            "rightCorner": {
              "x": -21.233,
              "y": -21.041,
              "z": 0.927
            },
            "gtin": "8001090510327",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d733",
        "height": 1.438,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87f5",
            "leftCorner": {
              "x": -21.169,
              "y": -22.29,
              "z": 1.177
            },
            "rightCorner": {
              "x": -21.17,
              "y": -22.182,
              "z": 1.177
            },
            "gtin": "4015200035710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87f6",
            "leftCorner": {
              "x": -21.17,
              "y": -22.182,
              "z": 1.177
            },
            "rightCorner": {
              "x": -21.171,
              "y": -22.074,
              "z": 1.177
            },
            "gtin": "4015200035710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87f7",
            "leftCorner": {
              "x": -21.171,
              "y": -22.074,
              "z": 1.177
            },
            "rightCorner": {
              "x": -21.172,
              "y": -21.966,
              "z": 1.177
            },
            "gtin": "4015200035710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87f8",
            "leftCorner": {
              "x": -21.172,
              "y": -21.966,
              "z": 1.177
            },
            "rightCorner": {
              "x": -21.173,
              "y": -21.858,
              "z": 1.177
            },
            "gtin": "4015200035710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87fa",
            "leftCorner": {
              "x": -21.213,
              "y": -21.858,
              "z": 1.177
            },
            "rightCorner": {
              "x": -21.213,
              "y": -21.768,
              "z": 1.177
            },
            "gtin": "4015200035550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87fb",
            "leftCorner": {
              "x": -21.213,
              "y": -21.768,
              "z": 1.177
            },
            "rightCorner": {
              "x": -21.214,
              "y": -21.678,
              "z": 1.177
            },
            "gtin": "4015200035550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87fc",
            "leftCorner": {
              "x": -21.214,
              "y": -21.678,
              "z": 1.177
            },
            "rightCorner": {
              "x": -21.215,
              "y": -21.587,
              "z": 1.177
            },
            "gtin": "4015200035550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87fd",
            "leftCorner": {
              "x": -21.221,
              "y": -21.587,
              "z": 1.177
            },
            "rightCorner": {
              "x": -21.222,
              "y": -21.453,
              "z": 1.177
            },
            "gtin": "4015200035734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87fe",
            "leftCorner": {
              "x": -21.222,
              "y": -21.453,
              "z": 1.177
            },
            "rightCorner": {
              "x": -21.223,
              "y": -21.318,
              "z": 1.177
            },
            "gtin": "4015200035734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d87f9",
            "leftCorner": {
              "x": -21.218,
              "y": -21.318,
              "z": 1.177
            },
            "rightCorner": {
              "x": -21.22,
              "y": -21.041,
              "z": 1.177
            },
            "gtin": "8001090502094",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d734",
        "height": 1.7341,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d87ff",
            "leftCorner": {
              "x": -21.18,
              "y": -22.29,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.181,
              "y": -22.192,
              "z": 1.419
            },
            "gtin": "4015200035567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8800",
            "leftCorner": {
              "x": -21.181,
              "y": -22.192,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.182,
              "y": -22.095,
              "z": 1.419
            },
            "gtin": "4015200035567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8801",
            "leftCorner": {
              "x": -21.182,
              "y": -22.095,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.183,
              "y": -21.997,
              "z": 1.419
            },
            "gtin": "4015200035567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8802",
            "leftCorner": {
              "x": -21.183,
              "y": -21.997,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.184,
              "y": -21.9,
              "z": 1.419
            },
            "gtin": "4015200035567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8804",
            "leftCorner": {
              "x": -21.223,
              "y": -21.901,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.225,
              "y": -21.651,
              "z": 1.419
            },
            "gtin": "4015200035574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8805",
            "leftCorner": {
              "x": -21.227,
              "y": -21.651,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.228,
              "y": -21.455,
              "z": 1.419
            },
            "gtin": "4001499964534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8806",
            "leftCorner": {
              "x": -21.229,
              "y": -21.455,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.231,
              "y": -21.296,
              "z": 1.419
            },
            "gtin": "4001499964541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8803",
            "leftCorner": {
              "x": -21.226,
              "y": -21.295,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.228,
              "y": -21.04,
              "z": 1.419
            },
            "gtin": "4012400503346",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "51a",
    "name": "51a",
    "x": -21.876,
    "y": -24.048,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99991,
      "w": 0.013098
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 68,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d73d",
        "height": 0.16868,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c79",
            "leftCorner": {
              "x": -21.878,
              "y": -23.941,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.033,
              "y": -23.944,
              "z": 0.138
            },
            "gtin": "4002832001053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "77dfd680a02218ca35b19a44",
            "leftCorner": {
              "x": -22.033,
              "y": -23.945,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.249,
              "y": -23.951,
              "z": 0.138
            },
            "gtin": "4002448034506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c7c",
            "leftCorner": {
              "x": -22.295,
              "y": -23.988,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.43,
              "y": -23.992,
              "z": 0.138
            },
            "gtin": "4002448034506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c7d",
            "leftCorner": {
              "x": -22.43,
              "y": -23.992,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.64,
              "y": -23.998,
              "z": 0.138
            },
            "gtin": "4002448034544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c7e",
            "leftCorner": {
              "x": -22.64,
              "y": -23.998,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.777,
              "y": -24.002,
              "z": 0.138
            },
            "gtin": "4251758410467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c7f",
            "leftCorner": {
              "x": -22.777,
              "y": -24.004,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.966,
              "y": -24.009,
              "z": 0.138
            },
            "gtin": "4251758410849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c80",
            "leftCorner": {
              "x": -22.966,
              "y": -24.012,
              "z": 0.138
            },
            "rightCorner": {
              "x": -23.249,
              "y": -24.019,
              "z": 0.138
            },
            "gtin": "4306188024439",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d739",
        "height": 0.57698,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d882a",
            "leftCorner": {
              "x": -21.878,
              "y": -23.937,
              "z": 0.472
            },
            "rightCorner": {
              "x": -21.973,
              "y": -23.94,
              "z": 0.472
            },
            "gtin": "4052400025127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d882c",
            "leftCorner": {
              "x": -21.972,
              "y": -23.985,
              "z": 0.472
            },
            "rightCorner": {
              "x": -22.065,
              "y": -23.987,
              "z": 0.472
            },
            "gtin": "4052400018167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d882d",
            "leftCorner": {
              "x": -22.065,
              "y": -23.991,
              "z": 0.472
            },
            "rightCorner": {
              "x": -22.156,
              "y": -23.993,
              "z": 0.472
            },
            "gtin": "4052400018174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d882e",
            "leftCorner": {
              "x": -22.156,
              "y": -23.99,
              "z": 0.472
            },
            "rightCorner": {
              "x": -22.246,
              "y": -23.992,
              "z": 0.472
            },
            "gtin": "4052400018082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d882f",
            "leftCorner": {
              "x": -22.246,
              "y": -23.987,
              "z": 0.472
            },
            "rightCorner": {
              "x": -22.337,
              "y": -23.989,
              "z": 0.472
            },
            "gtin": "4052400018181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8830",
            "leftCorner": {
              "x": -22.337,
              "y": -23.987,
              "z": 0.472
            },
            "rightCorner": {
              "x": -22.424,
              "y": -23.989,
              "z": 0.472
            },
            "gtin": "4052400018099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8831",
            "leftCorner": {
              "x": -22.424,
              "y": -23.991,
              "z": 0.472
            },
            "rightCorner": {
              "x": -22.478,
              "y": -23.993,
              "z": 0.472
            },
            "gtin": "4052400017085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8832",
            "leftCorner": {
              "x": -22.478,
              "y": -23.993,
              "z": 0.472
            },
            "rightCorner": {
              "x": -22.536,
              "y": -23.994,
              "z": 0.472
            },
            "gtin": "4052400017184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8833",
            "leftCorner": {
              "x": -22.536,
              "y": -23.995,
              "z": 0.472
            },
            "rightCorner": {
              "x": -22.582,
              "y": -23.997,
              "z": 0.472
            },
            "gtin": "4052400017139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8834",
            "leftCorner": {
              "x": -22.582,
              "y": -23.991,
              "z": 0.472
            },
            "rightCorner": {
              "x": -22.667,
              "y": -23.994,
              "z": 0.472
            },
            "gtin": "4052400017306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8835",
            "leftCorner": {
              "x": -22.667,
              "y": -23.997,
              "z": 0.472
            },
            "rightCorner": {
              "x": -22.756,
              "y": -23.999,
              "z": 0.472
            },
            "gtin": "4052400029422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8836",
            "leftCorner": {
              "x": -22.756,
              "y": -24.0,
              "z": 0.472
            },
            "rightCorner": {
              "x": -22.818,
              "y": -24.002,
              "z": 0.472
            },
            "gtin": "4002448084945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8837",
            "leftCorner": {
              "x": -22.818,
              "y": -24.002,
              "z": 0.472
            },
            "rightCorner": {
              "x": -22.879,
              "y": -24.003,
              "z": 0.472
            },
            "gtin": "4002448084945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8838",
            "leftCorner": {
              "x": -22.879,
              "y": -24.007,
              "z": 0.472
            },
            "rightCorner": {
              "x": -23.01,
              "y": -24.011,
              "z": 0.472
            },
            "gtin": "4306188038566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d882b",
            "leftCorner": {
              "x": -23.01,
              "y": -24.01,
              "z": 0.472
            },
            "rightCorner": {
              "x": -23.127,
              "y": -24.013,
              "z": 0.472
            },
            "gtin": "4013162004027",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d73c",
        "height": 0.8311,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8845",
            "leftCorner": {
              "x": -21.878,
              "y": -23.941,
              "z": 0.68
            },
            "rightCorner": {
              "x": -21.948,
              "y": -23.943,
              "z": 0.68
            },
            "gtin": "4008455004099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8847",
            "leftCorner": {
              "x": -21.947,
              "y": -23.99,
              "z": 0.68
            },
            "rightCorner": {
              "x": -21.98,
              "y": -23.99,
              "z": 0.68
            },
            "gtin": "4008455004099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8848",
            "leftCorner": {
              "x": -21.98,
              "y": -23.988,
              "z": 0.68
            },
            "rightCorner": {
              "x": -22.021,
              "y": -23.989,
              "z": 0.68
            },
            "gtin": "4008455004266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8849",
            "leftCorner": {
              "x": -22.021,
              "y": -23.992,
              "z": 0.68
            },
            "rightCorner": {
              "x": -22.091,
              "y": -23.995,
              "z": 0.68
            },
            "gtin": "4008455004075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d884a",
            "leftCorner": {
              "x": -22.091,
              "y": -23.995,
              "z": 0.68
            },
            "rightCorner": {
              "x": -22.161,
              "y": -23.996,
              "z": 0.68
            },
            "gtin": "4008455004075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d884b",
            "leftCorner": {
              "x": -22.161,
              "y": -23.998,
              "z": 0.68
            },
            "rightCorner": {
              "x": -22.206,
              "y": -23.999,
              "z": 0.68
            },
            "gtin": "4008455004129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d884c",
            "leftCorner": {
              "x": -22.206,
              "y": -23.993,
              "z": 0.68
            },
            "rightCorner": {
              "x": -22.265,
              "y": -23.994,
              "z": 0.68
            },
            "gtin": "4008455004037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d884d",
            "leftCorner": {
              "x": -22.265,
              "y": -23.988,
              "z": 0.68
            },
            "rightCorner": {
              "x": -22.307,
              "y": -23.99,
              "z": 0.68
            },
            "gtin": "4008455004082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d884e",
            "leftCorner": {
              "x": -22.307,
              "y": -23.989,
              "z": 0.68
            },
            "rightCorner": {
              "x": -22.37,
              "y": -23.991,
              "z": 0.68
            },
            "gtin": "4008455004013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d884f",
            "leftCorner": {
              "x": -22.37,
              "y": -23.992,
              "z": 0.68
            },
            "rightCorner": {
              "x": -22.457,
              "y": -23.994,
              "z": 0.68
            },
            "gtin": "4052400031050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8850",
            "leftCorner": {
              "x": -22.457,
              "y": -23.992,
              "z": 0.68
            },
            "rightCorner": {
              "x": -22.542,
              "y": -23.995,
              "z": 0.68
            },
            "gtin": "4062196082686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8851",
            "leftCorner": {
              "x": -22.542,
              "y": -23.997,
              "z": 0.68
            },
            "rightCorner": {
              "x": -22.661,
              "y": -23.999,
              "z": 0.68
            },
            "gtin": "4008455004174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8852",
            "leftCorner": {
              "x": -22.661,
              "y": -24.002,
              "z": 0.68
            },
            "rightCorner": {
              "x": -22.758,
              "y": -24.004,
              "z": 0.68
            },
            "gtin": "4306188363415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8853",
            "leftCorner": {
              "x": -22.758,
              "y": -24.004,
              "z": 0.68
            },
            "rightCorner": {
              "x": -22.969,
              "y": -24.01,
              "z": 0.68
            },
            "gtin": "4062196346924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8846",
            "leftCorner": {
              "x": -22.969,
              "y": -24.016,
              "z": 0.68
            },
            "rightCorner": {
              "x": -23.127,
              "y": -24.019,
              "z": 0.68
            },
            "gtin": "4008455063614",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d73a",
        "height": 1.0839,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8839",
            "leftCorner": {
              "x": -21.878,
              "y": -23.936,
              "z": 0.887
            },
            "rightCorner": {
              "x": -21.973,
              "y": -23.938,
              "z": 0.887
            },
            "gtin": "4008455096216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d883a",
            "leftCorner": {
              "x": -21.973,
              "y": -23.938,
              "z": 0.887
            },
            "rightCorner": {
              "x": -22.069,
              "y": -23.941,
              "z": 0.887
            },
            "gtin": "4008455096216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d883c",
            "leftCorner": {
              "x": -22.067,
              "y": -23.988,
              "z": 0.887
            },
            "rightCorner": {
              "x": -22.17,
              "y": -23.991,
              "z": 0.887
            },
            "gtin": "4008455002149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d883d",
            "leftCorner": {
              "x": -22.17,
              "y": -23.993,
              "z": 0.887
            },
            "rightCorner": {
              "x": -22.258,
              "y": -23.995,
              "z": 0.887
            },
            "gtin": "4008455021515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d883e",
            "leftCorner": {
              "x": -22.258,
              "y": -23.984,
              "z": 0.887
            },
            "rightCorner": {
              "x": -22.377,
              "y": -23.988,
              "z": 0.887
            },
            "gtin": "4008455095912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d883f",
            "leftCorner": {
              "x": -22.377,
              "y": -23.988,
              "z": 0.887
            },
            "rightCorner": {
              "x": -22.462,
              "y": -23.99,
              "z": 0.887
            },
            "gtin": "4062196265690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8840",
            "leftCorner": {
              "x": -22.462,
              "y": -23.987,
              "z": 0.887
            },
            "rightCorner": {
              "x": -22.546,
              "y": -23.99,
              "z": 0.887
            },
            "gtin": "4052400035126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8841",
            "leftCorner": {
              "x": -22.546,
              "y": -23.991,
              "z": 0.887
            },
            "rightCorner": {
              "x": -22.628,
              "y": -23.993,
              "z": 0.887
            },
            "gtin": "4062196101394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8842",
            "leftCorner": {
              "x": -22.628,
              "y": -23.994,
              "z": 0.887
            },
            "rightCorner": {
              "x": -22.714,
              "y": -23.996,
              "z": 0.887
            },
            "gtin": "4001499923739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8843",
            "leftCorner": {
              "x": -22.714,
              "y": -23.998,
              "z": 0.887
            },
            "rightCorner": {
              "x": -22.847,
              "y": -24.002,
              "z": 0.887
            },
            "gtin": "8006540728437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8844",
            "leftCorner": {
              "x": -22.847,
              "y": -24.004,
              "z": 0.887
            },
            "rightCorner": {
              "x": -22.985,
              "y": -24.008,
              "z": 0.887
            },
            "gtin": "4251758404220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d883b",
            "leftCorner": {
              "x": -22.985,
              "y": -24.01,
              "z": 0.887
            },
            "rightCorner": {
              "x": -23.127,
              "y": -24.013,
              "z": 0.887
            },
            "gtin": "8001090747723",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d738",
        "height": 1.3868,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8821",
            "leftCorner": {
              "x": -21.878,
              "y": -23.936,
              "z": 1.135
            },
            "rightCorner": {
              "x": -22.054,
              "y": -23.941,
              "z": 1.135
            },
            "gtin": "4015000971904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8822",
            "leftCorner": {
              "x": -22.054,
              "y": -23.941,
              "z": 1.135
            },
            "rightCorner": {
              "x": -22.231,
              "y": -23.945,
              "z": 1.135
            },
            "gtin": "4015000971904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8824",
            "leftCorner": {
              "x": -22.23,
              "y": -23.982,
              "z": 1.135
            },
            "rightCorner": {
              "x": -22.4,
              "y": -23.986,
              "z": 1.135
            },
            "gtin": "4015000972062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8825",
            "leftCorner": {
              "x": -22.4,
              "y": -23.986,
              "z": 1.135
            },
            "rightCorner": {
              "x": -22.571,
              "y": -23.991,
              "z": 1.135
            },
            "gtin": "4015000972062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8826",
            "leftCorner": {
              "x": -22.571,
              "y": -23.99,
              "z": 1.135
            },
            "rightCorner": {
              "x": -22.681,
              "y": -23.994,
              "z": 1.135
            },
            "gtin": "8435495819301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8827",
            "leftCorner": {
              "x": -22.681,
              "y": -23.997,
              "z": 1.135
            },
            "rightCorner": {
              "x": -22.782,
              "y": -24.0,
              "z": 1.135
            },
            "gtin": "8435495819332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8828",
            "leftCorner": {
              "x": -22.782,
              "y": -24.0,
              "z": 1.135
            },
            "rightCorner": {
              "x": -22.867,
              "y": -24.002,
              "z": 1.135
            },
            "gtin": "4251758428172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8829",
            "leftCorner": {
              "x": -22.867,
              "y": -24.005,
              "z": 1.135
            },
            "rightCorner": {
              "x": -22.957,
              "y": -24.007,
              "z": 1.135
            },
            "gtin": "4251758406811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8823",
            "leftCorner": {
              "x": -22.957,
              "y": -24.011,
              "z": 1.135
            },
            "rightCorner": {
              "x": -23.127,
              "y": -24.014,
              "z": 1.135
            },
            "gtin": "9006186000934",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d73b",
        "height": 1.7329,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c47",
            "leftCorner": {
              "x": -21.878,
              "y": -23.944,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.951,
              "y": -23.946,
              "z": 1.418
            },
            "gtin": "4002448027102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c48",
            "leftCorner": {
              "x": -21.951,
              "y": -23.946,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.025,
              "y": -23.948,
              "z": 1.418
            },
            "gtin": "4002448027102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c49",
            "leftCorner": {
              "x": -22.025,
              "y": -23.948,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.098,
              "y": -23.95,
              "z": 1.418
            },
            "gtin": "4002448027102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c4b",
            "leftCorner": {
              "x": -22.097,
              "y": -23.993,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.215,
              "y": -23.996,
              "z": 1.418
            },
            "gtin": "4002448034605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c4c",
            "leftCorner": {
              "x": -22.215,
              "y": -23.992,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.406,
              "y": -23.998,
              "z": 1.418
            },
            "gtin": "4250445600709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c4d",
            "leftCorner": {
              "x": -22.406,
              "y": -23.993,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.607,
              "y": -23.998,
              "z": 1.418
            },
            "gtin": "8435495819615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c4e",
            "leftCorner": {
              "x": -22.607,
              "y": -23.998,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.806,
              "y": -24.003,
              "z": 1.418
            },
            "gtin": "4251758407139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c4f",
            "leftCorner": {
              "x": -22.806,
              "y": -24.008,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.872,
              "y": -24.01,
              "z": 1.418
            },
            "gtin": "4008455076317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c50",
            "leftCorner": {
              "x": -22.872,
              "y": -24.012,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.948,
              "y": -24.013,
              "z": 1.418
            },
            "gtin": "4008455076416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c51",
            "leftCorner": {
              "x": -22.948,
              "y": -24.014,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.126,
              "y": -24.018,
              "z": 1.418
            },
            "gtin": "8700216633727",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "51b"
  },
  {
    "id": "51b",
    "name": "51b",
    "x": -23.125,
    "y": -24.081,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99991,
      "w": 0.013098
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 5,
      "unknownStockCount": 42,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d27d",
        "height": 0.16083,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c82",
            "leftCorner": {
              "x": -23.409,
              "y": -24.032,
              "z": 0.132
            },
            "rightCorner": {
              "x": -23.554,
              "y": -24.036,
              "z": 0.132
            },
            "gtin": "4306188061038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c83",
            "leftCorner": {
              "x": -23.554,
              "y": -24.036,
              "z": 0.132
            },
            "rightCorner": {
              "x": -23.699,
              "y": -24.04,
              "z": 0.132
            },
            "gtin": "4306188061038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c84",
            "leftCorner": {
              "x": -23.699,
              "y": -24.039,
              "z": 0.132
            },
            "rightCorner": {
              "x": -23.85,
              "y": -24.042,
              "z": 0.132
            },
            "gtin": "4306188061045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c85",
            "leftCorner": {
              "x": -23.85,
              "y": -24.045,
              "z": 0.132
            },
            "rightCorner": {
              "x": -24.17,
              "y": -24.054,
              "z": 0.132
            },
            "gtin": "8718951580329",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6c7a",
            "leftCorner": {
              "x": -24.17,
              "y": -24.051,
              "z": 0.132
            },
            "rightCorner": {
              "x": -24.376,
              "y": -24.055,
              "z": 0.132
            },
            "gtin": "8718951581715",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "2ef49e66b4977ca3b3d09ee7",
            "leftCorner": {
              "x": -23.128,
              "y": -23.985,
              "z": 0.132
            },
            "rightCorner": {
              "x": -23.241,
              "y": -23.988,
              "z": 0.132
            },
            "gtin": "8718951580329",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "9dea46253a07dc87910d36e7",
            "leftCorner": {
              "x": -23.241,
              "y": -23.988,
              "z": 0.132
            },
            "rightCorner": {
              "x": -23.399,
              "y": -23.992,
              "z": 0.132
            },
            "gtin": "4001499957536",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d27a",
        "height": 0.59063,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c58",
            "leftCorner": {
              "x": -23.128,
              "y": -23.966,
              "z": 0.483
            },
            "rightCorner": {
              "x": -23.184,
              "y": -23.967,
              "z": 0.483
            },
            "gtin": "4015200033556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c59",
            "leftCorner": {
              "x": -23.184,
              "y": -23.967,
              "z": 0.483
            },
            "rightCorner": {
              "x": -23.24,
              "y": -23.969,
              "z": 0.483
            },
            "gtin": "4015200033556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c5a",
            "leftCorner": {
              "x": -23.24,
              "y": -23.969,
              "z": 0.483
            },
            "rightCorner": {
              "x": -23.295,
              "y": -23.97,
              "z": 0.483
            },
            "gtin": "4015200033556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c5b",
            "leftCorner": {
              "x": -23.295,
              "y": -23.97,
              "z": 0.483
            },
            "rightCorner": {
              "x": -23.351,
              "y": -23.972,
              "z": 0.483
            },
            "gtin": "4015200033556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c5e",
            "leftCorner": {
              "x": -23.351,
              "y": -24.008,
              "z": 0.483
            },
            "rightCorner": {
              "x": -23.487,
              "y": -24.011,
              "z": 0.483
            },
            "gtin": "4015200033563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c5f",
            "leftCorner": {
              "x": -23.487,
              "y": -24.011,
              "z": 0.483
            },
            "rightCorner": {
              "x": -23.623,
              "y": -24.014,
              "z": 0.483
            },
            "gtin": "4015200033563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c60",
            "leftCorner": {
              "x": -23.623,
              "y": -24.021,
              "z": 0.483
            },
            "rightCorner": {
              "x": -23.923,
              "y": -24.028,
              "z": 0.483
            },
            "gtin": "4015200033587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c61",
            "leftCorner": {
              "x": -23.923,
              "y": -24.029,
              "z": 0.483
            },
            "rightCorner": {
              "x": -23.997,
              "y": -24.031,
              "z": 0.483
            },
            "gtin": "4015200033624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c62",
            "leftCorner": {
              "x": -23.997,
              "y": -24.031,
              "z": 0.483
            },
            "rightCorner": {
              "x": -24.07,
              "y": -24.034,
              "z": 0.483
            },
            "gtin": "4015200033624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c63",
            "leftCorner": {
              "x": -24.07,
              "y": -24.034,
              "z": 0.483
            },
            "rightCorner": {
              "x": -24.144,
              "y": -24.036,
              "z": 0.483
            },
            "gtin": "4015200033624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c5c",
            "leftCorner": {
              "x": -24.145,
              "y": -24.031,
              "z": 0.483
            },
            "rightCorner": {
              "x": -24.261,
              "y": -24.034,
              "z": 0.483
            },
            "gtin": "4015200033525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c5d",
            "leftCorner": {
              "x": -24.261,
              "y": -24.034,
              "z": 0.483
            },
            "rightCorner": {
              "x": -24.377,
              "y": -24.036,
              "z": 0.483
            },
            "gtin": "4015200033525",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d27c",
        "height": 0.9308,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c6d",
            "leftCorner": {
              "x": -23.128,
              "y": -23.979,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.203,
              "y": -23.981,
              "z": 0.762
            },
            "gtin": "4013162031313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c6e",
            "leftCorner": {
              "x": -23.203,
              "y": -23.981,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.277,
              "y": -23.983,
              "z": 0.762
            },
            "gtin": "4013162031313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c6f",
            "leftCorner": {
              "x": -23.277,
              "y": -23.983,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.352,
              "y": -23.985,
              "z": 0.762
            },
            "gtin": "4013162031313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c71",
            "leftCorner": {
              "x": -23.35,
              "y": -24.02,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.451,
              "y": -24.021,
              "z": 0.762
            },
            "gtin": "4013162031337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c72",
            "leftCorner": {
              "x": -23.451,
              "y": -24.021,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.551,
              "y": -24.024,
              "z": 0.762
            },
            "gtin": "4013162031337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c73",
            "leftCorner": {
              "x": -23.551,
              "y": -24.024,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.652,
              "y": -24.027,
              "z": 0.762
            },
            "gtin": "4013162031337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c74",
            "leftCorner": {
              "x": -23.652,
              "y": -24.033,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.741,
              "y": -24.035,
              "z": 0.762
            },
            "gtin": "8700216694667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c75",
            "leftCorner": {
              "x": -23.741,
              "y": -24.033,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.837,
              "y": -24.036,
              "z": 0.762
            },
            "gtin": "8700216694308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c76",
            "leftCorner": {
              "x": -23.837,
              "y": -24.039,
              "z": 0.762
            },
            "rightCorner": {
              "x": -23.932,
              "y": -24.042,
              "z": 0.762
            },
            "gtin": "8700216695145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c77",
            "leftCorner": {
              "x": -23.932,
              "y": -24.043,
              "z": 0.762
            },
            "rightCorner": {
              "x": -24.072,
              "y": -24.047,
              "z": 0.762
            },
            "gtin": "8700216695077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c78",
            "leftCorner": {
              "x": -24.072,
              "y": -24.047,
              "z": 0.762
            },
            "rightCorner": {
              "x": -24.211,
              "y": -24.05,
              "z": 0.762
            },
            "gtin": "8700216695077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c70",
            "leftCorner": {
              "x": -24.211,
              "y": -24.042,
              "z": 0.762
            },
            "rightCorner": {
              "x": -24.376,
              "y": -24.046,
              "z": 0.762
            },
            "gtin": "8700216694407",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d27b",
        "height": 1.2842,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c64",
            "leftCorner": {
              "x": -23.128,
              "y": -23.979,
              "z": 1.051
            },
            "rightCorner": {
              "x": -23.185,
              "y": -23.981,
              "z": 1.051
            },
            "gtin": "8700216694490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c65",
            "leftCorner": {
              "x": -23.185,
              "y": -23.981,
              "z": 1.051
            },
            "rightCorner": {
              "x": -23.242,
              "y": -23.982,
              "z": 1.051
            },
            "gtin": "8700216694490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c66",
            "leftCorner": {
              "x": -23.242,
              "y": -23.982,
              "z": 1.051
            },
            "rightCorner": {
              "x": -23.299,
              "y": -23.984,
              "z": 1.051
            },
            "gtin": "8700216694490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c67",
            "leftCorner": {
              "x": -23.299,
              "y": -23.984,
              "z": 1.051
            },
            "rightCorner": {
              "x": -23.356,
              "y": -23.986,
              "z": 1.051
            },
            "gtin": "8700216694490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c69",
            "leftCorner": {
              "x": -23.354,
              "y": -24.021,
              "z": 1.051
            },
            "rightCorner": {
              "x": -23.516,
              "y": -24.025,
              "z": 1.051
            },
            "gtin": "8700216694612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c6a",
            "leftCorner": {
              "x": -23.508,
              "y": -24.34,
              "z": 1.051
            },
            "rightCorner": {
              "x": -23.569,
              "y": -24.341,
              "z": 1.051
            },
            "gtin": "8700216695176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c6b",
            "leftCorner": {
              "x": -23.577,
              "y": -24.035,
              "z": 1.051
            },
            "rightCorner": {
              "x": -23.781,
              "y": -24.041,
              "z": 1.051
            },
            "gtin": "8700216695176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c6c",
            "leftCorner": {
              "x": -23.774,
              "y": -24.31,
              "z": 1.051
            },
            "rightCorner": {
              "x": -24.167,
              "y": -24.321,
              "z": 1.051
            },
            "gtin": "8700216694285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c68",
            "leftCorner": {
              "x": -24.174,
              "y": -24.047,
              "z": 1.051
            },
            "rightCorner": {
              "x": -24.376,
              "y": -24.051,
              "z": 1.051
            },
            "gtin": "8700216694223",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d279",
        "height": 1.7337,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c52",
            "leftCorner": {
              "x": -23.127,
              "y": -24.01,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.243,
              "y": -24.012,
              "z": 1.418
            },
            "gtin": "8700216633581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c53",
            "leftCorner": {
              "x": -23.243,
              "y": -24.012,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.389,
              "y": -24.016,
              "z": 1.418
            },
            "gtin": "8700216633994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c54",
            "leftCorner": {
              "x": -23.389,
              "y": -24.025,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.533,
              "y": -24.028,
              "z": 1.418
            },
            "gtin": "8700216700764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c55",
            "leftCorner": {
              "x": -23.533,
              "y": -24.034,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.648,
              "y": -24.038,
              "z": 1.418
            },
            "gtin": "4062196284943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c56",
            "leftCorner": {
              "x": -23.648,
              "y": -24.038,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.764,
              "y": -24.04,
              "z": 1.418
            },
            "gtin": "4062196284943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c57",
            "leftCorner": {
              "x": -23.764,
              "y": -24.038,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.95,
              "y": -24.043,
              "z": 1.418
            },
            "gtin": "4062196284936",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6c4a",
            "leftCorner": {
              "x": -23.95,
              "y": -24.045,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.376,
              "y": -24.056,
              "z": 1.418
            },
            "gtin": "4002448112488",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "51a"
  },
  {
    "id": "51c",
    "name": "51c",
    "x": -23.079,
    "y": -25.391,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.01959,
      "w": 0.99981
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 63,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d28b",
        "height": 0.16924,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6d03",
            "leftCorner": {
              "x": -23.074,
              "y": -25.503,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.938,
              "y": -25.498,
              "z": 0.138
            },
            "gtin": "8700216238977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d05",
            "leftCorner": {
              "x": -22.939,
              "y": -25.459,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.82,
              "y": -25.454,
              "z": 0.138
            },
            "gtin": "8700216239011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d06",
            "leftCorner": {
              "x": -22.82,
              "y": -25.457,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.701,
              "y": -25.452,
              "z": 0.138
            },
            "gtin": "8700216239035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d07",
            "leftCorner": {
              "x": -22.701,
              "y": -25.453,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.58,
              "y": -25.448,
              "z": 0.138
            },
            "gtin": "8700216239080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d08",
            "leftCorner": {
              "x": -22.58,
              "y": -25.445,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.507,
              "y": -25.443,
              "z": 0.138
            },
            "gtin": "5000204539349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d09",
            "leftCorner": {
              "x": -22.507,
              "y": -25.438,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.416,
              "y": -25.434,
              "z": 0.138
            },
            "gtin": "5000204249408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d0a",
            "leftCorner": {
              "x": -22.416,
              "y": -25.438,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.352,
              "y": -25.435,
              "z": 0.138
            },
            "gtin": "5000204771893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d0b",
            "leftCorner": {
              "x": -22.352,
              "y": -25.433,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.302,
              "y": -25.431,
              "z": 0.138
            },
            "gtin": "5000204070194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d0c",
            "leftCorner": {
              "x": -22.302,
              "y": -25.431,
              "z": 0.138
            },
            "rightCorner": {
              "x": -22.219,
              "y": -25.428,
              "z": 0.138
            },
            "gtin": "4001499943782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d04",
            "leftCorner": {
              "x": -22.22,
              "y": -25.395,
              "z": 0.138
            },
            "rightCorner": {
              "x": -21.828,
              "y": -25.379,
              "z": 0.138
            },
            "gtin": "4001499943652",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d286",
        "height": 0.51736,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6cf4",
            "leftCorner": {
              "x": -23.074,
              "y": -25.51,
              "z": 0.423
            },
            "rightCorner": {
              "x": -22.937,
              "y": -25.505,
              "z": 0.423
            },
            "gtin": "8700216483162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "938d65f5b8ef4be2ed1d0fbd",
            "leftCorner": {
              "x": -22.902,
              "y": -25.503,
              "z": 0.423
            },
            "rightCorner": {
              "x": -22.83,
              "y": -25.5,
              "z": 0.423
            },
            "gtin": "8700216656788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cf6",
            "leftCorner": {
              "x": -22.94,
              "y": -25.465,
              "z": 0.423
            },
            "rightCorner": {
              "x": -22.904,
              "y": -25.463,
              "z": 0.423
            },
            "gtin": "8001090839305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cf8",
            "leftCorner": {
              "x": -22.829,
              "y": -25.461,
              "z": 0.423
            },
            "rightCorner": {
              "x": -22.787,
              "y": -25.46,
              "z": 0.423
            },
            "gtin": "5000204356656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cf9",
            "leftCorner": {
              "x": -22.787,
              "y": -25.462,
              "z": 0.423
            },
            "rightCorner": {
              "x": -22.661,
              "y": -25.457,
              "z": 0.423
            },
            "gtin": "5000204357103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cfa",
            "leftCorner": {
              "x": -22.661,
              "y": -25.454,
              "z": 0.423
            },
            "rightCorner": {
              "x": -22.578,
              "y": -25.45,
              "z": 0.423
            },
            "gtin": "5000204356502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cfb",
            "leftCorner": {
              "x": -22.578,
              "y": -25.452,
              "z": 0.423
            },
            "rightCorner": {
              "x": -22.496,
              "y": -25.449,
              "z": 0.423
            },
            "gtin": "5000204356380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cfc",
            "leftCorner": {
              "x": -22.496,
              "y": -25.448,
              "z": 0.423
            },
            "rightCorner": {
              "x": -22.415,
              "y": -25.444,
              "z": 0.423
            },
            "gtin": "5000204105551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cfd",
            "leftCorner": {
              "x": -22.415,
              "y": -25.442,
              "z": 0.423
            },
            "rightCorner": {
              "x": -22.332,
              "y": -25.439,
              "z": 0.423
            },
            "gtin": "5000204960686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cfe",
            "leftCorner": {
              "x": -22.332,
              "y": -25.44,
              "z": 0.423
            },
            "rightCorner": {
              "x": -22.222,
              "y": -25.436,
              "z": 0.423
            },
            "gtin": "5000204349818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cff",
            "leftCorner": {
              "x": -22.222,
              "y": -25.433,
              "z": 0.423
            },
            "rightCorner": {
              "x": -22.138,
              "y": -25.43,
              "z": 0.423
            },
            "gtin": "8700216834018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d00",
            "leftCorner": {
              "x": -22.138,
              "y": -25.43,
              "z": 0.423
            },
            "rightCorner": {
              "x": -22.064,
              "y": -25.427,
              "z": 0.423
            },
            "gtin": "8006540019368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d01",
            "leftCorner": {
              "x": -22.064,
              "y": -25.431,
              "z": 0.423
            },
            "rightCorner": {
              "x": -21.992,
              "y": -25.428,
              "z": 0.423
            },
            "gtin": "8700216833875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6d02",
            "leftCorner": {
              "x": -21.993,
              "y": -25.423,
              "z": 0.423
            },
            "rightCorner": {
              "x": -21.949,
              "y": -25.421,
              "z": 0.423
            },
            "gtin": "8001090576781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cf5",
            "leftCorner": {
              "x": -21.949,
              "y": -25.429,
              "z": 0.423
            },
            "rightCorner": {
              "x": -21.826,
              "y": -25.424,
              "z": 0.423
            },
            "gtin": "8700216656788",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d28a",
        "height": 0.80655,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6ca9",
            "leftCorner": {
              "x": -23.039,
              "y": -25.458,
              "z": 0.66
            },
            "rightCorner": {
              "x": -22.93,
              "y": -25.453,
              "z": 0.66
            },
            "gtin": "5000204075892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6caa",
            "leftCorner": {
              "x": -22.93,
              "y": -25.455,
              "z": 0.66
            },
            "rightCorner": {
              "x": -22.861,
              "y": -25.452,
              "z": 0.66
            },
            "gtin": "5000204078473",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6cab",
            "leftCorner": {
              "x": -22.861,
              "y": -25.455,
              "z": 0.66
            },
            "rightCorner": {
              "x": -22.778,
              "y": -25.451,
              "z": 0.66
            },
            "gtin": "5000204157734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cac",
            "leftCorner": {
              "x": -22.778,
              "y": -25.45,
              "z": 0.66
            },
            "rightCorner": {
              "x": -22.686,
              "y": -25.447,
              "z": 0.66
            },
            "gtin": "5000204076844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cad",
            "leftCorner": {
              "x": -22.686,
              "y": -25.45,
              "z": 0.66
            },
            "rightCorner": {
              "x": -22.594,
              "y": -25.446,
              "z": 0.66
            },
            "gtin": "5000204078329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cae",
            "leftCorner": {
              "x": -22.594,
              "y": -25.445,
              "z": 0.66
            },
            "rightCorner": {
              "x": -22.507,
              "y": -25.441,
              "z": 0.66
            },
            "gtin": "5000204078565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6caf",
            "leftCorner": {
              "x": -22.507,
              "y": -25.44,
              "z": 0.66
            },
            "rightCorner": {
              "x": -22.416,
              "y": -25.437,
              "z": 0.66
            },
            "gtin": "5000204078251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cb0",
            "leftCorner": {
              "x": -22.416,
              "y": -25.435,
              "z": 0.66
            },
            "rightCorner": {
              "x": -22.322,
              "y": -25.431,
              "z": 0.66
            },
            "gtin": "4002448027225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cb1",
            "leftCorner": {
              "x": -22.322,
              "y": -25.429,
              "z": 0.66
            },
            "rightCorner": {
              "x": -22.238,
              "y": -25.426,
              "z": 0.66
            },
            "gtin": "4002448026167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cb2",
            "leftCorner": {
              "x": -22.238,
              "y": -25.426,
              "z": 0.66
            },
            "rightCorner": {
              "x": -22.135,
              "y": -25.423,
              "z": 0.66
            },
            "gtin": "8700216657075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cb3",
            "leftCorner": {
              "x": -22.135,
              "y": -25.42,
              "z": 0.66
            },
            "rightCorner": {
              "x": -22.027,
              "y": -25.417,
              "z": 0.66
            },
            "gtin": "8700216657020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cb4",
            "leftCorner": {
              "x": -22.027,
              "y": -25.415,
              "z": 0.66
            },
            "rightCorner": {
              "x": -21.934,
              "y": -25.411,
              "z": 0.66
            },
            "gtin": "8700216657143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c9b",
            "leftCorner": {
              "x": -21.934,
              "y": -25.414,
              "z": 0.66
            },
            "rightCorner": {
              "x": -21.827,
              "y": -25.409,
              "z": 0.66
            },
            "gtin": "8001090735386",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d287",
        "height": 1.1094,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6cd3",
            "leftCorner": {
              "x": -23.015,
              "y": -25.458,
              "z": 0.908
            },
            "rightCorner": {
              "x": -22.927,
              "y": -25.454,
              "z": 0.908
            },
            "gtin": "8435495838562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cd4",
            "leftCorner": {
              "x": -22.927,
              "y": -25.457,
              "z": 0.908
            },
            "rightCorner": {
              "x": -22.78,
              "y": -25.452,
              "z": 0.908
            },
            "gtin": "8720182894830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cd5",
            "leftCorner": {
              "x": -22.78,
              "y": -25.453,
              "z": 0.908
            },
            "rightCorner": {
              "x": -22.629,
              "y": -25.447,
              "z": 0.908
            },
            "gtin": "8720182894823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cd6",
            "leftCorner": {
              "x": -22.629,
              "y": -25.447,
              "z": 0.908
            },
            "rightCorner": {
              "x": -22.508,
              "y": -25.442,
              "z": 0.908
            },
            "gtin": "5000204339888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cd7",
            "leftCorner": {
              "x": -22.508,
              "y": -25.439,
              "z": 0.908
            },
            "rightCorner": {
              "x": -22.375,
              "y": -25.434,
              "z": 0.908
            },
            "gtin": "5000204199550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cd8",
            "leftCorner": {
              "x": -22.375,
              "y": -25.433,
              "z": 0.908
            },
            "rightCorner": {
              "x": -22.239,
              "y": -25.427,
              "z": 0.908
            },
            "gtin": "5000204668995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cd9",
            "leftCorner": {
              "x": -22.239,
              "y": -25.425,
              "z": 0.908
            },
            "rightCorner": {
              "x": -22.096,
              "y": -25.419,
              "z": 0.908
            },
            "gtin": "5000204669022",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6cda",
            "leftCorner": {
              "x": -22.096,
              "y": -25.419,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.989,
              "y": -25.414,
              "z": 0.908
            },
            "gtin": "5000204184891",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50be1820c81800d6cc8",
            "leftCorner": {
              "x": -21.989,
              "y": -25.415,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.827,
              "y": -25.409,
              "z": 0.908
            },
            "gtin": "5000204185041",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d289",
        "height": 1.4123,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6cbf",
            "leftCorner": {
              "x": -23.031,
              "y": -25.462,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.898,
              "y": -25.456,
              "z": 1.156
            },
            "gtin": "8435495838531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cc0",
            "leftCorner": {
              "x": -22.898,
              "y": -25.461,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.781,
              "y": -25.457,
              "z": 1.156
            },
            "gtin": "4015200030852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cc1",
            "leftCorner": {
              "x": -22.781,
              "y": -25.458,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.631,
              "y": -25.452,
              "z": 1.156
            },
            "gtin": "4015000972390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cc2",
            "leftCorner": {
              "x": -22.631,
              "y": -25.453,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.48,
              "y": -25.447,
              "z": 1.156
            },
            "gtin": "4015200032801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cc3",
            "leftCorner": {
              "x": -22.48,
              "y": -25.442,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.364,
              "y": -25.438,
              "z": 1.156
            },
            "gtin": "4015200032825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cc4",
            "leftCorner": {
              "x": -22.364,
              "y": -25.435,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.223,
              "y": -25.43,
              "z": 1.156
            },
            "gtin": "4015000969628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cc5",
            "leftCorner": {
              "x": -22.223,
              "y": -25.429,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.139,
              "y": -25.426,
              "z": 1.156
            },
            "gtin": "4015000969550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cc6",
            "leftCorner": {
              "x": -22.139,
              "y": -25.426,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.961,
              "y": -25.419,
              "z": 1.156
            },
            "gtin": "4021155191074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cb6",
            "leftCorner": {
              "x": -21.96,
              "y": -25.421,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.827,
              "y": -25.416,
              "z": 1.156
            },
            "gtin": "4021155191241",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d288",
        "height": 1.735,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c91",
            "leftCorner": {
              "x": -23.014,
              "y": -25.455,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.923,
              "y": -25.451,
              "z": 1.42
            },
            "gtin": "4015000969505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c92",
            "leftCorner": {
              "x": -22.923,
              "y": -25.452,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.788,
              "y": -25.447,
              "z": 1.42
            },
            "gtin": "4015000969475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c93",
            "leftCorner": {
              "x": -22.788,
              "y": -25.45,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.624,
              "y": -25.444,
              "z": 1.42
            },
            "gtin": "4015000969529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c94",
            "leftCorner": {
              "x": -22.624,
              "y": -25.449,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.583,
              "y": -25.447,
              "z": 1.42
            },
            "gtin": "4015000969567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c96",
            "leftCorner": {
              "x": -22.485,
              "y": -25.437,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.346,
              "y": -25.432,
              "z": 1.42
            },
            "gtin": "4015000969512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c97",
            "leftCorner": {
              "x": -22.346,
              "y": -25.429,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.209,
              "y": -25.423,
              "z": 1.42
            },
            "gtin": "4015000969635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c98",
            "leftCorner": {
              "x": -22.209,
              "y": -25.421,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.075,
              "y": -25.416,
              "z": 1.42
            },
            "gtin": "4015000969444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c99",
            "leftCorner": {
              "x": -22.075,
              "y": -25.416,
              "z": 1.42
            },
            "rightCorner": {
              "x": -21.95,
              "y": -25.411,
              "z": 1.42
            },
            "gtin": "4015000969536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c87",
            "leftCorner": {
              "x": -21.95,
              "y": -25.411,
              "z": 1.42
            },
            "rightCorner": {
              "x": -21.827,
              "y": -25.406,
              "z": 1.42
            },
            "gtin": "4015000969468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "41600bd9679147da94eada25",
            "leftCorner": {
              "x": -22.582,
              "y": -25.479,
              "z": 1.42
            },
            "rightCorner": {
              "x": -22.49,
              "y": -25.475,
              "z": 1.42
            },
            "gtin": "4015000969468",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "51e"
  },
  {
    "id": "51e",
    "name": "51e",
    "x": -24.328,
    "y": -25.44,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.01959,
      "w": 0.99981
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 69,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d284",
        "height": 0.15726,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6cdb",
            "leftCorner": {
              "x": -24.325,
              "y": -25.533,
              "z": 0.129
            },
            "rightCorner": {
              "x": -24.186,
              "y": -25.528,
              "z": 0.129
            },
            "gtin": "4016100771012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cdd",
            "leftCorner": {
              "x": -24.188,
              "y": -25.489,
              "z": 0.129
            },
            "rightCorner": {
              "x": -24.073,
              "y": -25.484,
              "z": 0.129
            },
            "gtin": "40161747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cde",
            "leftCorner": {
              "x": -24.073,
              "y": -25.476,
              "z": 0.129
            },
            "rightCorner": {
              "x": -24.015,
              "y": -25.473,
              "z": 0.129
            },
            "gtin": "40161754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cdf",
            "leftCorner": {
              "x": -24.015,
              "y": -25.475,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.895,
              "y": -25.471,
              "z": 0.129
            },
            "gtin": "40161334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ce0",
            "leftCorner": {
              "x": -23.895,
              "y": -25.47,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.762,
              "y": -25.465,
              "z": 0.129
            },
            "gtin": "40161310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ce1",
            "leftCorner": {
              "x": -23.762,
              "y": -25.467,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.679,
              "y": -25.463,
              "z": 0.129
            },
            "gtin": "40161181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ce2",
            "leftCorner": {
              "x": -23.679,
              "y": -25.469,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.536,
              "y": -25.463,
              "z": 0.129
            },
            "gtin": "4016100242413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ce3",
            "leftCorner": {
              "x": -23.536,
              "y": -25.464,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.415,
              "y": -25.459,
              "z": 0.129
            },
            "gtin": "8700216677004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ce4",
            "leftCorner": {
              "x": -23.415,
              "y": -25.459,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.276,
              "y": -25.454,
              "z": 0.129
            },
            "gtin": "8700216710992",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ce5",
            "leftCorner": {
              "x": -23.276,
              "y": -25.457,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.162,
              "y": -25.453,
              "z": 0.129
            },
            "gtin": "8700216676717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cdc",
            "leftCorner": {
              "x": -23.162,
              "y": -25.454,
              "z": 0.129
            },
            "rightCorner": {
              "x": -23.076,
              "y": -25.451,
              "z": 0.129
            },
            "gtin": "4000290001004",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d285",
        "height": 0.50418,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6ce6",
            "leftCorner": {
              "x": -24.325,
              "y": -25.531,
              "z": 0.413
            },
            "rightCorner": {
              "x": -24.158,
              "y": -25.525,
              "z": 0.413
            },
            "gtin": "4052400033054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ce8",
            "leftCorner": {
              "x": -24.16,
              "y": -25.489,
              "z": 0.413
            },
            "rightCorner": {
              "x": -24.057,
              "y": -25.485,
              "z": 0.413
            },
            "gtin": "4001499011665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ce9",
            "leftCorner": {
              "x": -24.057,
              "y": -25.476,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.974,
              "y": -25.473,
              "z": 0.413
            },
            "gtin": "4001499947667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cea",
            "leftCorner": {
              "x": -23.974,
              "y": -25.474,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.905,
              "y": -25.472,
              "z": 0.413
            },
            "gtin": "4001499947681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ceb",
            "leftCorner": {
              "x": -23.906,
              "y": -25.468,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.841,
              "y": -25.465,
              "z": 0.413
            },
            "gtin": "4001499014260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cec",
            "leftCorner": {
              "x": -23.841,
              "y": -25.468,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.785,
              "y": -25.466,
              "z": 0.413
            },
            "gtin": "4001499143694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ced",
            "leftCorner": {
              "x": -23.785,
              "y": -25.468,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.679,
              "y": -25.463,
              "z": 0.413
            },
            "gtin": "4001499946714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cee",
            "leftCorner": {
              "x": -23.679,
              "y": -25.464,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.592,
              "y": -25.46,
              "z": 0.413
            },
            "gtin": "4001499946561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cef",
            "leftCorner": {
              "x": -23.592,
              "y": -25.47,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.523,
              "y": -25.467,
              "z": 0.413
            },
            "gtin": "4001499946721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cf0",
            "leftCorner": {
              "x": -23.523,
              "y": -25.462,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.471,
              "y": -25.46,
              "z": 0.413
            },
            "gtin": "4001499946776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cf1",
            "leftCorner": {
              "x": -23.471,
              "y": -25.46,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.402,
              "y": -25.457,
              "z": 0.413
            },
            "gtin": "4001499946752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cf2",
            "leftCorner": {
              "x": -23.402,
              "y": -25.46,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.286,
              "y": -25.455,
              "z": 0.413
            },
            "gtin": "8700216483193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cf3",
            "leftCorner": {
              "x": -23.286,
              "y": -25.458,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.178,
              "y": -25.454,
              "z": 0.413
            },
            "gtin": "8700216483230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ce7",
            "leftCorner": {
              "x": -23.178,
              "y": -25.461,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.076,
              "y": -25.457,
              "z": 0.413
            },
            "gtin": "8700216483216",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d281",
        "height": 0.80495,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c9a",
            "leftCorner": {
              "x": -24.325,
              "y": -25.533,
              "z": 0.659
            },
            "rightCorner": {
              "x": -24.18,
              "y": -25.527,
              "z": 0.659
            },
            "gtin": "4251758433725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c9c",
            "leftCorner": {
              "x": -24.182,
              "y": -25.489,
              "z": 0.659
            },
            "rightCorner": {
              "x": -24.087,
              "y": -25.485,
              "z": 0.659
            },
            "gtin": "4002448146254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c9d",
            "leftCorner": {
              "x": -24.087,
              "y": -25.484,
              "z": 0.659
            },
            "rightCorner": {
              "x": -24.0,
              "y": -25.481,
              "z": 0.659
            },
            "gtin": "4251758433411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c9e",
            "leftCorner": {
              "x": -24.0,
              "y": -25.479,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.909,
              "y": -25.476,
              "z": 0.659
            },
            "gtin": "4251758433435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c9f",
            "leftCorner": {
              "x": -23.909,
              "y": -25.471,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.809,
              "y": -25.466,
              "z": 0.659
            },
            "gtin": "4002448062288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ca0",
            "leftCorner": {
              "x": -23.809,
              "y": -25.467,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.721,
              "y": -25.464,
              "z": 0.659
            },
            "gtin": "4251758433510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ca1",
            "leftCorner": {
              "x": -23.721,
              "y": -25.466,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.628,
              "y": -25.462,
              "z": 0.659
            },
            "gtin": "5000204073461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ca2",
            "leftCorner": {
              "x": -23.628,
              "y": -25.471,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.544,
              "y": -25.467,
              "z": 0.659
            },
            "gtin": "5000204731651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ca3",
            "leftCorner": {
              "x": -23.544,
              "y": -25.463,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.466,
              "y": -25.46,
              "z": 0.659
            },
            "gtin": "5000204732368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ca4",
            "leftCorner": {
              "x": -23.466,
              "y": -25.46,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.4,
              "y": -25.457,
              "z": 0.659
            },
            "gtin": "5000204256260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ca5",
            "leftCorner": {
              "x": -23.4,
              "y": -25.456,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.326,
              "y": -25.453,
              "z": 0.659
            },
            "gtin": "5000204073010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ca6",
            "leftCorner": {
              "x": -23.326,
              "y": -25.456,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.21,
              "y": -25.451,
              "z": 0.659
            },
            "gtin": "5000204332322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ca7",
            "leftCorner": {
              "x": -23.21,
              "y": -25.457,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.145,
              "y": -25.455,
              "z": 0.659
            },
            "gtin": "5000204333015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ca8",
            "leftCorner": {
              "x": -23.145,
              "y": -25.458,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.04,
              "y": -25.453,
              "z": 0.659
            },
            "gtin": "5000204333107",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d283",
        "height": 1.1074,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6cc7",
            "leftCorner": {
              "x": -24.325,
              "y": -25.536,
              "z": 0.906
            },
            "rightCorner": {
              "x": -24.207,
              "y": -25.531,
              "z": 0.906
            },
            "gtin": "4251758415455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cc9",
            "leftCorner": {
              "x": -24.208,
              "y": -25.494,
              "z": 0.906
            },
            "rightCorner": {
              "x": -24.096,
              "y": -25.49,
              "z": 0.906
            },
            "gtin": "4251758415479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cca",
            "leftCorner": {
              "x": -24.096,
              "y": -25.487,
              "z": 0.906
            },
            "rightCorner": {
              "x": -23.956,
              "y": -25.482,
              "z": 0.906
            },
            "gtin": "4251758415707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ccb",
            "leftCorner": {
              "x": -23.956,
              "y": -25.478,
              "z": 0.906
            },
            "rightCorner": {
              "x": -23.826,
              "y": -25.473,
              "z": 0.906
            },
            "gtin": "4251758415660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ccc",
            "leftCorner": {
              "x": -23.826,
              "y": -25.467,
              "z": 0.906
            },
            "rightCorner": {
              "x": -23.695,
              "y": -25.461,
              "z": 0.906
            },
            "gtin": "4251758423962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ccd",
            "leftCorner": {
              "x": -23.695,
              "y": -25.465,
              "z": 0.906
            },
            "rightCorner": {
              "x": -23.588,
              "y": -25.461,
              "z": 0.906
            },
            "gtin": "4251758422088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cce",
            "leftCorner": {
              "x": -23.588,
              "y": -25.468,
              "z": 0.906
            },
            "rightCorner": {
              "x": -23.415,
              "y": -25.461,
              "z": 0.906
            },
            "gtin": "4251758433787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6ccf",
            "leftCorner": {
              "x": -23.415,
              "y": -25.458,
              "z": 0.906
            },
            "rightCorner": {
              "x": -23.31,
              "y": -25.455,
              "z": 0.906
            },
            "gtin": "4251758422026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cd0",
            "leftCorner": {
              "x": -23.31,
              "y": -25.458,
              "z": 0.906
            },
            "rightCorner": {
              "x": -23.189,
              "y": -25.453,
              "z": 0.906
            },
            "gtin": "5000204219890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cd1",
            "leftCorner": {
              "x": -23.189,
              "y": -25.456,
              "z": 0.906
            },
            "rightCorner": {
              "x": -23.14,
              "y": -25.455,
              "z": 0.906
            },
            "gtin": "5000204219418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cd2",
            "leftCorner": {
              "x": -23.14,
              "y": -25.457,
              "z": 0.906
            },
            "rightCorner": {
              "x": -23.016,
              "y": -25.452,
              "z": 0.906
            },
            "gtin": "5000204219388",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d282",
        "height": 1.4114,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6cb5",
            "leftCorner": {
              "x": -24.325,
              "y": -25.541,
              "z": 1.155
            },
            "rightCorner": {
              "x": -24.178,
              "y": -25.535,
              "z": 1.155
            },
            "gtin": "4000290001608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cb7",
            "leftCorner": {
              "x": -24.178,
              "y": -25.502,
              "z": 1.155
            },
            "rightCorner": {
              "x": -24.073,
              "y": -25.498,
              "z": 1.155
            },
            "gtin": "5000204206180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cb8",
            "leftCorner": {
              "x": -24.074,
              "y": -25.485,
              "z": 1.155
            },
            "rightCorner": {
              "x": -23.932,
              "y": -25.479,
              "z": 1.155
            },
            "gtin": "5000204206210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cb9",
            "leftCorner": {
              "x": -23.932,
              "y": -25.478,
              "z": 1.155
            },
            "rightCorner": {
              "x": -23.715,
              "y": -25.47,
              "z": 1.155
            },
            "gtin": "5000204331967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cba",
            "leftCorner": {
              "x": -23.715,
              "y": -25.475,
              "z": 1.155
            },
            "rightCorner": {
              "x": -23.554,
              "y": -25.468,
              "z": 1.155
            },
            "gtin": "5000204331998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cbb",
            "leftCorner": {
              "x": -23.554,
              "y": -25.471,
              "z": 1.155
            },
            "rightCorner": {
              "x": -23.43,
              "y": -25.466,
              "z": 1.155
            },
            "gtin": "5000204343519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cbc",
            "leftCorner": {
              "x": -23.43,
              "y": -25.467,
              "z": 1.155
            },
            "rightCorner": {
              "x": -23.324,
              "y": -25.463,
              "z": 1.155
            },
            "gtin": "8711577263874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cbd",
            "leftCorner": {
              "x": -23.324,
              "y": -25.464,
              "z": 1.155
            },
            "rightCorner": {
              "x": -23.179,
              "y": -25.459,
              "z": 1.155
            },
            "gtin": "5000204090109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6cbe",
            "leftCorner": {
              "x": -23.178,
              "y": -25.465,
              "z": 1.155
            },
            "rightCorner": {
              "x": -23.031,
              "y": -25.459,
              "z": 1.155
            },
            "gtin": "8711295090271",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d280",
        "height": 1.7335,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6c86",
            "leftCorner": {
              "x": -24.325,
              "y": -25.535,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.176,
              "y": -25.529,
              "z": 1.418
            },
            "gtin": "4027600500903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c88",
            "leftCorner": {
              "x": -24.178,
              "y": -25.493,
              "z": 1.418
            },
            "rightCorner": {
              "x": -24.046,
              "y": -25.488,
              "z": 1.418
            },
            "gtin": "4019181777652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c89",
            "leftCorner": {
              "x": -24.046,
              "y": -25.484,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.96,
              "y": -25.481,
              "z": 1.418
            },
            "gtin": "4019181777829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c8a",
            "leftCorner": {
              "x": -23.96,
              "y": -25.48,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.877,
              "y": -25.477,
              "z": 1.418
            },
            "gtin": "4019181777058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c8b",
            "leftCorner": {
              "x": -23.877,
              "y": -25.479,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.695,
              "y": -25.472,
              "z": 1.418
            },
            "gtin": "5000204343540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c8c",
            "leftCorner": {
              "x": -23.695,
              "y": -25.467,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.608,
              "y": -25.463,
              "z": 1.418
            },
            "gtin": "5000204305203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c8d",
            "leftCorner": {
              "x": -23.608,
              "y": -25.474,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.483,
              "y": -25.469,
              "z": 1.418
            },
            "gtin": "4019181777843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c8e",
            "leftCorner": {
              "x": -23.483,
              "y": -25.462,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.366,
              "y": -25.458,
              "z": 1.418
            },
            "gtin": "5000204343571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c8f",
            "leftCorner": {
              "x": -23.366,
              "y": -25.456,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.157,
              "y": -25.448,
              "z": 1.418
            },
            "gtin": "4008398188382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6c90",
            "leftCorner": {
              "x": -23.156,
              "y": -25.456,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.014,
              "y": -25.451,
              "z": 1.418
            },
            "gtin": "5000204752939",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "51c"
  },
  {
    "id": "51f",
    "name": "51f",
    "x": -21.276,
    "y": -25.291,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.72128,
      "w": 0.69264
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 33,
      "shelfCategory": "HOUSEKEEPING"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d743",
        "height": 0.22684,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8870",
            "leftCorner": {
              "x": -21.066,
              "y": -25.283,
              "z": 0.186
            },
            "rightCorner": {
              "x": -21.08,
              "y": -24.961,
              "z": 0.186
            },
            "gtin": "4306188024354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8872",
            "leftCorner": {
              "x": -21.13,
              "y": -24.963,
              "z": 0.186
            },
            "rightCorner": {
              "x": -21.137,
              "y": -24.783,
              "z": 0.186
            },
            "gtin": "4015200036328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8873",
            "leftCorner": {
              "x": -21.129,
              "y": -24.783,
              "z": 0.186
            },
            "rightCorner": {
              "x": -21.134,
              "y": -24.616,
              "z": 0.186
            },
            "gtin": "4015200036335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8874",
            "leftCorner": {
              "x": -21.124,
              "y": -24.616,
              "z": 0.186
            },
            "rightCorner": {
              "x": -21.131,
              "y": -24.447,
              "z": 0.186
            },
            "gtin": "4002448144717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8875",
            "leftCorner": {
              "x": -21.121,
              "y": -24.447,
              "z": 0.186
            },
            "rightCorner": {
              "x": -21.126,
              "y": -24.338,
              "z": 0.186
            },
            "gtin": "9005835312442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8871",
            "leftCorner": {
              "x": -21.139,
              "y": -24.339,
              "z": 0.186
            },
            "rightCorner": {
              "x": -21.152,
              "y": -24.036,
              "z": 0.186
            },
            "gtin": "4306188044352",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d741",
        "height": 0.52675,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8866",
            "leftCorner": {
              "x": -21.107,
              "y": -25.284,
              "z": 0.431
            },
            "rightCorner": {
              "x": -21.12,
              "y": -24.958,
              "z": 0.431
            },
            "gtin": "9005835311490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8868",
            "leftCorner": {
              "x": -21.168,
              "y": -24.96,
              "z": 0.431
            },
            "rightCorner": {
              "x": -21.174,
              "y": -24.801,
              "z": 0.431
            },
            "gtin": "9005835310776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8869",
            "leftCorner": {
              "x": -21.169,
              "y": -24.801,
              "z": 0.431
            },
            "rightCorner": {
              "x": -21.175,
              "y": -24.656,
              "z": 0.431
            },
            "gtin": "4001499958694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d886a",
            "leftCorner": {
              "x": -21.166,
              "y": -24.656,
              "z": 0.431
            },
            "rightCorner": {
              "x": -21.174,
              "y": -24.474,
              "z": 0.431
            },
            "gtin": "4001499947315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8867",
            "leftCorner": {
              "x": -21.166,
              "y": -24.474,
              "z": 0.431
            },
            "rightCorner": {
              "x": -21.184,
              "y": -24.037,
              "z": 0.431
            },
            "gtin": "4013162035649",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d742",
        "height": 0.82758,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d886b",
            "leftCorner": {
              "x": -21.104,
              "y": -25.284,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.116,
              "y": -24.988,
              "z": 0.677
            },
            "gtin": "4251758436610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d886d",
            "leftCorner": {
              "x": -21.17,
              "y": -24.99,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.181,
              "y": -24.737,
              "z": 0.677
            },
            "gtin": "4251758437792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d886e",
            "leftCorner": {
              "x": -21.166,
              "y": -24.737,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.173,
              "y": -24.563,
              "z": 0.677
            },
            "gtin": "4251758437358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d886f",
            "leftCorner": {
              "x": -21.167,
              "y": -24.563,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.175,
              "y": -24.359,
              "z": 0.677
            },
            "gtin": "4250445601157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d886c",
            "leftCorner": {
              "x": -21.175,
              "y": -24.359,
              "z": 0.677
            },
            "rightCorner": {
              "x": -21.189,
              "y": -24.037,
              "z": 0.677
            },
            "gtin": "4250445601164",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d73f",
        "height": 1.1318,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8859",
            "leftCorner": {
              "x": -21.106,
              "y": -25.284,
              "z": 0.926
            },
            "rightCorner": {
              "x": -21.123,
              "y": -24.879,
              "z": 0.926
            },
            "gtin": "4015200035505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d885b",
            "leftCorner": {
              "x": -21.167,
              "y": -24.882,
              "z": 0.926
            },
            "rightCorner": {
              "x": -21.174,
              "y": -24.708,
              "z": 0.926
            },
            "gtin": "4015200033952",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d885c",
            "leftCorner": {
              "x": -21.167,
              "y": -24.708,
              "z": 0.926
            },
            "rightCorner": {
              "x": -21.176,
              "y": -24.511,
              "z": 0.926
            },
            "gtin": "4015200036472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d885d",
            "leftCorner": {
              "x": -21.167,
              "y": -24.511,
              "z": 0.926
            },
            "rightCorner": {
              "x": -21.174,
              "y": -24.325,
              "z": 0.926
            },
            "gtin": "4015200036304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d885a",
            "leftCorner": {
              "x": -21.179,
              "y": -24.325,
              "z": 0.926
            },
            "rightCorner": {
              "x": -21.191,
              "y": -24.037,
              "z": 0.926
            },
            "gtin": "4012400502981",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d73e",
        "height": 1.4351,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8854",
            "leftCorner": {
              "x": -21.101,
              "y": -25.284,
              "z": 1.174
            },
            "rightCorner": {
              "x": -21.114,
              "y": -24.958,
              "z": 1.174
            },
            "gtin": "4015200033921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8856",
            "leftCorner": {
              "x": -21.161,
              "y": -24.961,
              "z": 1.174
            },
            "rightCorner": {
              "x": -21.167,
              "y": -24.802,
              "z": 1.174
            },
            "gtin": "4015200036540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8857",
            "leftCorner": {
              "x": -21.16,
              "y": -24.802,
              "z": 1.174
            },
            "rightCorner": {
              "x": -21.165,
              "y": -24.687,
              "z": 1.174
            },
            "gtin": "4015200036717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8858",
            "leftCorner": {
              "x": -21.159,
              "y": -24.687,
              "z": 1.174
            },
            "rightCorner": {
              "x": -21.172,
              "y": -24.358,
              "z": 1.174
            },
            "gtin": "4015200036465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8855",
            "leftCorner": {
              "x": -21.169,
              "y": -24.358,
              "z": 1.174
            },
            "rightCorner": {
              "x": -21.183,
              "y": -24.036,
              "z": 1.174
            },
            "gtin": "4015200036359",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d740",
        "height": 1.7346,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d885e",
            "leftCorner": {
              "x": -21.097,
              "y": -25.284,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.107,
              "y": -25.042,
              "z": 1.419
            },
            "gtin": "4015200035925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8860",
            "leftCorner": {
              "x": -21.168,
              "y": -25.045,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.175,
              "y": -24.87,
              "z": 1.419
            },
            "gtin": "4251758400475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8861",
            "leftCorner": {
              "x": -21.17,
              "y": -24.87,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.175,
              "y": -24.719,
              "z": 1.419
            },
            "gtin": "4251758427908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8862",
            "leftCorner": {
              "x": -21.164,
              "y": -24.718,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.17,
              "y": -24.586,
              "z": 1.419
            },
            "gtin": "4250445600983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8863",
            "leftCorner": {
              "x": -21.163,
              "y": -24.586,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.168,
              "y": -24.441,
              "z": 1.419
            },
            "gtin": "4052400032804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8864",
            "leftCorner": {
              "x": -21.158,
              "y": -24.441,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.161,
              "y": -24.377,
              "z": 1.419
            },
            "gtin": "4306188038573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8865",
            "leftCorner": {
              "x": -21.167,
              "y": -24.377,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.17,
              "y": -24.291,
              "z": 1.419
            },
            "gtin": "4015200035727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d885f",
            "leftCorner": {
              "x": -21.164,
              "y": -24.29,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.174,
              "y": -24.036,
              "z": 1.419
            },
            "gtin": "4002448046486",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "734",
    "name": "734",
    "x": -32.508,
    "y": -31.467,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 2.1806E-4,
      "y": 1.3649E-5,
      "z": 0.0014787,
      "w": 1.0
    },
    "layers": []
  },
  {
    "id": "735",
    "name": "735",
    "x": -31.476,
    "y": -31.463,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 6.9011E-5,
      "y": -7.5641E-4,
      "z": 0.0077258,
      "w": 0.99997
    },
    "layers": []
  },
  {
    "id": "736",
    "name": "736",
    "x": -30.461,
    "y": -31.422,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 1.1876E-4,
      "y": -7.4084E-4,
      "z": 0.0093729,
      "w": 0.99996
    },
    "layers": []
  },
  {
    "id": "737",
    "name": "737",
    "x": -29.437,
    "y": -31.36,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 1.2767E-4,
      "y": -9.0065E-4,
      "z": 0.01352,
      "w": 0.99991
    },
    "layers": []
  },
  {
    "id": "738",
    "name": "738",
    "x": -31.489,
    "y": -29.54,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -7.6044E-4,
      "y": -7.8839E-6,
      "z": 0.99999,
      "w": -0.0048629
    },
    "layers": []
  },
  {
    "id": "739",
    "name": "739",
    "x": -32.526,
    "y": -29.544,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -7.3662E-4,
      "y": -6.1235E-5,
      "z": 1.0,
      "w": -0.0023479
    },
    "layers": []
  },
  {
    "id": "73a",
    "name": "73a",
    "x": -30.487,
    "y": -29.499,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -7.9213E-4,
      "y": -8.5349E-6,
      "z": 0.99992,
      "w": -0.012868
    },
    "layers": []
  },
  {
    "id": "73b",
    "name": "73b",
    "x": -29.495,
    "y": -29.454,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -7.6346E-4,
      "y": -1.8116E-5,
      "z": 0.99979,
      "w": -0.020294
    },
    "layers": []
  },
  {
    "id": "73d",
    "name": "73d",
    "x": -32.446,
    "y": -27.645,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 1.7976E-4,
      "y": -6.1822E-4,
      "z": 0.010675,
      "w": 0.99994
    },
    "layers": []
  },
  {
    "id": "73e",
    "name": "73e",
    "x": -31.446,
    "y": -27.622,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 1.811E-4,
      "y": -6.1825E-4,
      "z": -2.5664E-4,
      "w": 1.0
    },
    "layers": []
  },
  {
    "id": "73f",
    "name": "73f",
    "x": -30.447,
    "y": -27.579,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 1.9568E-4,
      "y": -6.1729E-4,
      "z": 0.0020165,
      "w": 1.0
    },
    "layers": []
  },
  {
    "id": "740",
    "name": "740",
    "x": -29.447,
    "y": -27.575,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 1.9568E-4,
      "y": -6.1729E-4,
      "z": 0.0020165,
      "w": 1.0
    },
    "layers": []
  },
  {
    "id": "741",
    "name": "741",
    "x": -32.484,
    "y": -25.864,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.2005E-4,
      "y": -8.9112E-5,
      "z": 0.99999,
      "w": -0.0052865
    },
    "layers": []
  },
  {
    "id": "742",
    "name": "742",
    "x": -31.484,
    "y": -25.853,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.2005E-4,
      "y": -8.9112E-5,
      "z": 0.99999,
      "w": -0.0052865
    },
    "layers": []
  },
  {
    "id": "743",
    "name": "743",
    "x": -30.484,
    "y": -25.843,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.2005E-4,
      "y": -8.9112E-5,
      "z": 0.99999,
      "w": -0.0052865
    },
    "layers": []
  },
  {
    "id": "744",
    "name": "744",
    "x": -29.503,
    "y": -25.719,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.2632E-4,
      "y": -4.0129E-5,
      "z": 0.99987,
      "w": -0.01619
    },
    "layers": []
  },
  {
    "id": "767",
    "name": "767",
    "x": -10.774,
    "y": 2.85,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70682,
      "w": 0.70739
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d565",
        "height": 0.17249,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8282",
            "leftCorner": {
              "x": -10.848,
              "y": 2.684,
              "z": 0.141
            },
            "rightCorner": {
              "x": -10.848,
              "y": 2.515,
              "z": 0.141
            },
            "gtin": "4100240100259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b4c9bf774b2ca260829b643e",
            "leftCorner": {
              "x": -10.88,
              "y": 2.85,
              "z": 0.141
            },
            "rightCorner": {
              "x": -10.88,
              "y": 2.711,
              "z": 0.141
            },
            "gtin": "4100240100143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8283",
            "leftCorner": {
              "x": -10.838,
              "y": 2.515,
              "z": 0.141
            },
            "rightCorner": {
              "x": -10.838,
              "y": 2.35,
              "z": 0.141
            },
            "gtin": "4100240110036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8284",
            "leftCorner": {
              "x": -10.839,
              "y": 2.35,
              "z": 0.141
            },
            "rightCorner": {
              "x": -10.84,
              "y": 2.214,
              "z": 0.141
            },
            "gtin": "4100240530032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8285",
            "leftCorner": {
              "x": -10.84,
              "y": 2.214,
              "z": 0.141
            },
            "rightCorner": {
              "x": -10.84,
              "y": 1.933,
              "z": 0.141
            },
            "gtin": "40804583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8286",
            "leftCorner": {
              "x": -10.848,
              "y": 1.933,
              "z": 0.141
            },
            "rightCorner": {
              "x": -10.848,
              "y": 1.566,
              "z": 0.141
            },
            "gtin": "40804606",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d564",
        "height": 0.40392,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d825f",
            "leftCorner": {
              "x": -10.814,
              "y": 2.85,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.814,
              "y": 2.638,
              "z": 0.33
            },
            "gtin": "4250426215366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8260",
            "leftCorner": {
              "x": -10.814,
              "y": 2.638,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.813,
              "y": 2.427,
              "z": 0.33
            },
            "gtin": "4250426215366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8261",
            "leftCorner": {
              "x": -10.813,
              "y": 2.427,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.814,
              "y": 2.215,
              "z": 0.33
            },
            "gtin": "4250426215366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8262",
            "leftCorner": {
              "x": -10.814,
              "y": 2.215,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.813,
              "y": 2.003,
              "z": 0.33
            },
            "gtin": "4250426215366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8264",
            "leftCorner": {
              "x": -10.773,
              "y": 2.003,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.773,
              "y": 1.737,
              "z": 0.33
            },
            "gtin": "4250426221725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8265",
            "leftCorner": {
              "x": -10.786,
              "y": 1.737,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.786,
              "y": 1.6,
              "z": 0.33
            },
            "gtin": "40081588",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d560",
        "height": 0.70053,
        "facings": [
          {
            "id": "68d8e50de1820c81800d81f1",
            "leftCorner": {
              "x": -10.824,
              "y": 2.85,
              "z": 0.573
            },
            "rightCorner": {
              "x": -10.824,
              "y": 2.557,
              "z": 0.573
            },
            "gtin": "8710609412082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d81f3",
            "leftCorner": {
              "x": -10.789,
              "y": 2.557,
              "z": 0.573
            },
            "rightCorner": {
              "x": -10.788,
              "y": 2.314,
              "z": 0.573
            },
            "gtin": "4306188011989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d81f4",
            "leftCorner": {
              "x": -10.784,
              "y": 2.314,
              "z": 0.573
            },
            "rightCorner": {
              "x": -10.783,
              "y": 2.114,
              "z": 0.573
            },
            "gtin": "4306188418665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d81f5",
            "leftCorner": {
              "x": -10.783,
              "y": 2.114,
              "z": 0.573
            },
            "rightCorner": {
              "x": -10.783,
              "y": 1.519,
              "z": 0.573
            },
            "gtin": "4306188011958",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d563",
        "height": 1.0024,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8246",
            "leftCorner": {
              "x": -10.831,
              "y": 2.85,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.831,
              "y": 2.551,
              "z": 0.82
            },
            "gtin": "4250426200386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8248",
            "leftCorner": {
              "x": -10.794,
              "y": 2.551,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.795,
              "y": 2.281,
              "z": 0.82
            },
            "gtin": "4250426200393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8249",
            "leftCorner": {
              "x": -10.788,
              "y": 2.281,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.787,
              "y": 2.011,
              "z": 0.82
            },
            "gtin": "4250426200379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d824a",
            "leftCorner": {
              "x": -10.784,
              "y": 2.011,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.784,
              "y": 1.76,
              "z": 0.82
            },
            "gtin": "4002442816085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d824b",
            "leftCorner": {
              "x": -10.798,
              "y": 1.76,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.799,
              "y": 1.499,
              "z": 0.82
            },
            "gtin": "4002442820914",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d562",
        "height": 1.3052,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d822a",
            "leftCorner": {
              "x": -10.833,
              "y": 2.85,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.832,
              "y": 2.591,
              "z": 1.068
            },
            "gtin": "4250426200416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d822c",
            "leftCorner": {
              "x": -10.794,
              "y": 2.591,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.794,
              "y": 2.241,
              "z": 1.068
            },
            "gtin": "4250426200409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d822d",
            "leftCorner": {
              "x": -10.785,
              "y": 2.241,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.786,
              "y": 2.044,
              "z": 1.068
            },
            "gtin": "4104420034181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d822e",
            "leftCorner": {
              "x": -10.791,
              "y": 2.044,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.791,
              "y": 1.804,
              "z": 1.068
            },
            "gtin": "4250426200331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d822f",
            "leftCorner": {
              "x": -10.804,
              "y": 1.804,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.803,
              "y": 1.488,
              "z": 1.068
            },
            "gtin": "4250426200348",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d561",
        "height": 1.6072,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d820b",
            "leftCorner": {
              "x": -10.841,
              "y": 2.85,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.841,
              "y": 2.398,
              "z": 1.315
            },
            "gtin": "4250426200461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d820d",
            "leftCorner": {
              "x": -10.8,
              "y": 2.398,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.8,
              "y": 2.099,
              "z": 1.315
            },
            "gtin": "4250426200317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d820e",
            "leftCorner": {
              "x": -10.798,
              "y": 2.099,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.797,
              "y": 1.905,
              "z": 1.315
            },
            "gtin": "4250426200478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d820f",
            "leftCorner": {
              "x": -10.805,
              "y": 1.905,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.804,
              "y": 1.574,
              "z": 1.315
            },
            "gtin": "4250426200324",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "768"
  },
  {
    "id": "768",
    "name": "768",
    "x": -10.773,
    "y": 1.6,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70682,
      "w": 0.70739
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 34
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d566",
        "height": 0.40447,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8266",
            "leftCorner": {
              "x": -10.789,
              "y": 1.6,
              "z": 0.331
            },
            "rightCorner": {
              "x": -10.789,
              "y": 1.416,
              "z": 0.331
            },
            "gtin": "40804552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8267",
            "leftCorner": {
              "x": -10.773,
              "y": 1.416,
              "z": 0.331
            },
            "rightCorner": {
              "x": -10.772,
              "y": 1.129,
              "z": 0.331
            },
            "gtin": "40804552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8268",
            "leftCorner": {
              "x": -10.779,
              "y": 1.129,
              "z": 0.331
            },
            "rightCorner": {
              "x": -10.779,
              "y": 0.831,
              "z": 0.331
            },
            "gtin": "40804965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8269",
            "leftCorner": {
              "x": -10.773,
              "y": 0.831,
              "z": 0.331
            },
            "rightCorner": {
              "x": -10.773,
              "y": 0.616,
              "z": 0.331
            },
            "gtin": "4009309142417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d826a",
            "leftCorner": {
              "x": -10.777,
              "y": 0.616,
              "z": 0.331
            },
            "rightCorner": {
              "x": -10.777,
              "y": 0.35,
              "z": 0.331
            },
            "gtin": "4250426221473",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d569",
        "height": 0.69922,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d81f6",
            "leftCorner": {
              "x": -10.796,
              "y": 1.519,
              "z": 0.572
            },
            "rightCorner": {
              "x": -10.796,
              "y": 1.246,
              "z": 0.572
            },
            "gtin": "4306188017936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d81f7",
            "leftCorner": {
              "x": -10.792,
              "y": 1.246,
              "z": 0.572
            },
            "rightCorner": {
              "x": -10.792,
              "y": 0.963,
              "z": 0.572
            },
            "gtin": "4250426227116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d81f8",
            "leftCorner": {
              "x": -10.794,
              "y": 0.963,
              "z": 0.572
            },
            "rightCorner": {
              "x": -10.794,
              "y": 0.832,
              "z": 0.572
            },
            "gtin": "40804644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d81f9",
            "leftCorner": {
              "x": -10.789,
              "y": 0.832,
              "z": 0.572
            },
            "rightCorner": {
              "x": -10.789,
              "y": 0.55,
              "z": 0.572
            },
            "gtin": "40804651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d81fa",
            "leftCorner": {
              "x": -10.788,
              "y": 0.55,
              "z": 0.572
            },
            "rightCorner": {
              "x": -10.788,
              "y": 0.237,
              "z": 0.572
            },
            "gtin": "40081410",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d567",
        "height": 1.0021,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d824c",
            "leftCorner": {
              "x": -10.795,
              "y": 1.499,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.795,
              "y": 1.26,
              "z": 0.82
            },
            "gtin": "4306188047568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e93fbd6e22e3b0fecda84682",
            "leftCorner": {
              "x": -10.835,
              "y": 1.6,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.835,
              "y": 1.501,
              "z": 0.82
            },
            "gtin": "4104420257603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d824d",
            "leftCorner": {
              "x": -10.798,
              "y": 1.26,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.798,
              "y": 1.119,
              "z": 0.82
            },
            "gtin": "4012200401057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d824e",
            "leftCorner": {
              "x": -10.806,
              "y": 1.119,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.806,
              "y": 1.05,
              "z": 0.82
            },
            "gtin": "40198682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d824f",
            "leftCorner": {
              "x": -10.806,
              "y": 1.05,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.805,
              "y": 0.98,
              "z": 0.82
            },
            "gtin": "40198682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8250",
            "leftCorner": {
              "x": -10.798,
              "y": 0.98,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.798,
              "y": 0.831,
              "z": 0.82
            },
            "gtin": "4012200430804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8251",
            "leftCorner": {
              "x": -10.792,
              "y": 0.831,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.792,
              "y": 0.691,
              "z": 0.82
            },
            "gtin": "4008100140547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8252",
            "leftCorner": {
              "x": -10.793,
              "y": 0.691,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.792,
              "y": 0.521,
              "z": 0.82
            },
            "gtin": "4104420257603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8253",
            "leftCorner": {
              "x": -10.793,
              "y": 0.521,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.794,
              "y": 0.161,
              "z": 0.82
            },
            "gtin": "4012712001745",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d568",
        "height": 1.3048,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8230",
            "leftCorner": {
              "x": -10.797,
              "y": 1.488,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.797,
              "y": 1.225,
              "z": 1.068
            },
            "gtin": "40804019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8231",
            "leftCorner": {
              "x": -10.796,
              "y": 1.225,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.796,
              "y": 0.986,
              "z": 1.068
            },
            "gtin": "4009309622612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8232",
            "leftCorner": {
              "x": -10.803,
              "y": 0.986,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.804,
              "y": 0.717,
              "z": 1.068
            },
            "gtin": "4009309622513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8233",
            "leftCorner": {
              "x": -10.8,
              "y": 0.717,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.799,
              "y": 0.496,
              "z": 1.068
            },
            "gtin": "4009309622315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8234",
            "leftCorner": {
              "x": -10.805,
              "y": 0.496,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.805,
              "y": 0.202,
              "z": 1.068
            },
            "gtin": "4250426221251",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d56a",
        "height": 1.605,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8210",
            "leftCorner": {
              "x": -10.81,
              "y": 1.574,
              "z": 1.313
            },
            "rightCorner": {
              "x": -10.809,
              "y": 1.268,
              "z": 1.313
            },
            "gtin": "4250426200355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8211",
            "leftCorner": {
              "x": -10.796,
              "y": 1.268,
              "z": 1.313
            },
            "rightCorner": {
              "x": -10.795,
              "y": 1.157,
              "z": 1.313
            },
            "gtin": "4306188411475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8212",
            "leftCorner": {
              "x": -10.795,
              "y": 1.157,
              "z": 1.313
            },
            "rightCorner": {
              "x": -10.795,
              "y": 1.046,
              "z": 1.313
            },
            "gtin": "4306188411475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8213",
            "leftCorner": {
              "x": -10.812,
              "y": 1.046,
              "z": 1.313
            },
            "rightCorner": {
              "x": -10.812,
              "y": 0.865,
              "z": 1.313
            },
            "gtin": "4002442699374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8214",
            "leftCorner": {
              "x": -10.812,
              "y": 0.865,
              "z": 1.313
            },
            "rightCorner": {
              "x": -10.812,
              "y": 0.684,
              "z": 1.313
            },
            "gtin": "4002442699374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8215",
            "leftCorner": {
              "x": -10.806,
              "y": 0.684,
              "z": 1.313
            },
            "rightCorner": {
              "x": -10.806,
              "y": 0.613,
              "z": 1.313
            },
            "gtin": "4250426221190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8216",
            "leftCorner": {
              "x": -10.806,
              "y": 0.613,
              "z": 1.313
            },
            "rightCorner": {
              "x": -10.806,
              "y": 0.542,
              "z": 1.313
            },
            "gtin": "4250426221190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8217",
            "leftCorner": {
              "x": -10.806,
              "y": 0.542,
              "z": 1.313
            },
            "rightCorner": {
              "x": -10.805,
              "y": 0.47,
              "z": 1.313
            },
            "gtin": "4250426221190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8218",
            "leftCorner": {
              "x": -10.809,
              "y": 0.47,
              "z": 1.313
            },
            "rightCorner": {
              "x": -10.809,
              "y": 0.373,
              "z": 1.313
            },
            "gtin": "4002442699213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8219",
            "leftCorner": {
              "x": -10.809,
              "y": 0.373,
              "z": 1.313
            },
            "rightCorner": {
              "x": -10.809,
              "y": 0.276,
              "z": 1.313
            },
            "gtin": "4002442699213",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "767",
    "rightNeighborShelfId": "769"
  },
  {
    "id": "769",
    "name": "769",
    "x": -10.772,
    "y": 0.35,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70682,
      "w": 0.70739
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d570",
        "height": 0.17877,
        "facings": [
          {
            "id": "126690ee8e39f5fac6786642",
            "leftCorner": {
              "x": -10.854,
              "y": 0.35,
              "z": 0.146
            },
            "rightCorner": {
              "x": -10.854,
              "y": 0.134,
              "z": 0.146
            },
            "gtin": "40081410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d8c2d660737747213369e9fb",
            "leftCorner": {
              "x": -10.854,
              "y": 0.134,
              "z": 0.146
            },
            "rightCorner": {
              "x": -10.854,
              "y": -0.096,
              "z": 0.146
            },
            "gtin": "4250426221459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "223ba9306e0cc111a1e3393e",
            "leftCorner": {
              "x": -10.854,
              "y": -0.096,
              "z": 0.146
            },
            "rightCorner": {
              "x": -10.854,
              "y": -0.162,
              "z": 0.146
            },
            "gtin": "40804385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "54a018a199684df62d6b3964",
            "leftCorner": {
              "x": -10.854,
              "y": -0.162,
              "z": 0.146
            },
            "rightCorner": {
              "x": -10.854,
              "y": -0.302,
              "z": 0.146
            },
            "gtin": "40804613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0e9a03491d7f7c12c2025fed",
            "leftCorner": {
              "x": -10.854,
              "y": -0.302,
              "z": 0.146
            },
            "rightCorner": {
              "x": -10.853,
              "y": -0.448,
              "z": 0.146
            },
            "gtin": "4012712001547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7d84a264c91c590163ad4e03",
            "leftCorner": {
              "x": -10.853,
              "y": -0.448,
              "z": 0.146
            },
            "rightCorner": {
              "x": -10.853,
              "y": -0.623,
              "z": 0.146
            },
            "gtin": "4260483535062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3015f02ffbc5fbd6796b9126",
            "leftCorner": {
              "x": -10.853,
              "y": -0.623,
              "z": 0.146
            },
            "rightCorner": {
              "x": -10.853,
              "y": -0.898,
              "z": 0.146
            },
            "gtin": "4250426221510",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d56f",
        "height": 0.4029,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d826b",
            "leftCorner": {
              "x": -10.785,
              "y": 0.35,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.787,
              "y": 0.254,
              "z": 0.33
            },
            "gtin": "4306188409588",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d826c",
            "leftCorner": {
              "x": -10.779,
              "y": 0.254,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.779,
              "y": -0.023,
              "z": 0.33
            },
            "gtin": "4306188409588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d826d",
            "leftCorner": {
              "x": -10.783,
              "y": -0.023,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.783,
              "y": -0.292,
              "z": 0.33
            },
            "gtin": "4306188433491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d826e",
            "leftCorner": {
              "x": -10.78,
              "y": -0.292,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.78,
              "y": -0.457,
              "z": 0.33
            },
            "gtin": "40081496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d826f",
            "leftCorner": {
              "x": -10.78,
              "y": -0.457,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.779,
              "y": -0.622,
              "z": 0.33
            },
            "gtin": "40081496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8270",
            "leftCorner": {
              "x": -10.783,
              "y": -0.622,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.783,
              "y": -0.851,
              "z": 0.33
            },
            "gtin": "4025891054372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8271",
            "leftCorner": {
              "x": -10.783,
              "y": -0.851,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.783,
              "y": -0.965,
              "z": 0.33
            },
            "gtin": "40804385",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d56c",
        "height": 0.6984,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d81fb",
            "leftCorner": {
              "x": -10.791,
              "y": 0.237,
              "z": 0.571
            },
            "rightCorner": {
              "x": -10.791,
              "y": -0.355,
              "z": 0.571
            },
            "gtin": "40081427",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d81fc",
            "leftCorner": {
              "x": -10.791,
              "y": -0.355,
              "z": 0.571
            },
            "rightCorner": {
              "x": -10.79,
              "y": -0.643,
              "z": 0.571
            },
            "gtin": "4012712001547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d81fd",
            "leftCorner": {
              "x": -10.797,
              "y": -0.643,
              "z": 0.571
            },
            "rightCorner": {
              "x": -10.797,
              "y": -0.904,
              "z": 0.571
            },
            "gtin": "4306188036586",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d56e",
        "height": 0.99872,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8254",
            "leftCorner": {
              "x": -10.805,
              "y": 0.161,
              "z": 0.817
            },
            "rightCorner": {
              "x": -10.806,
              "y": -0.1,
              "z": 0.817
            },
            "gtin": "4250426221558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8255",
            "leftCorner": {
              "x": -10.808,
              "y": -0.1,
              "z": 0.817
            },
            "rightCorner": {
              "x": -10.807,
              "y": -0.637,
              "z": 0.817
            },
            "gtin": "4250426221435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8256",
            "leftCorner": {
              "x": -10.808,
              "y": -0.637,
              "z": 0.817
            },
            "rightCorner": {
              "x": -10.808,
              "y": -1.175,
              "z": 0.817
            },
            "gtin": "4250426221510",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d56d",
        "height": 1.303,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8235",
            "leftCorner": {
              "x": -10.803,
              "y": 0.202,
              "z": 1.066
            },
            "rightCorner": {
              "x": -10.803,
              "y": -0.065,
              "z": 1.066
            },
            "gtin": "4260483530043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ff2539513723d4ed77e70080",
            "leftCorner": {
              "x": -10.847,
              "y": 0.35,
              "z": 1.066
            },
            "rightCorner": {
              "x": -10.847,
              "y": 0.211,
              "z": 1.066
            },
            "gtin": "40198552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8236",
            "leftCorner": {
              "x": -10.809,
              "y": -0.065,
              "z": 1.066
            },
            "rightCorner": {
              "x": -10.81,
              "y": -0.169,
              "z": 1.066
            },
            "gtin": "4260483530012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8237",
            "leftCorner": {
              "x": -10.81,
              "y": -0.169,
              "z": 1.066
            },
            "rightCorner": {
              "x": -10.809,
              "y": -0.273,
              "z": 1.066
            },
            "gtin": "4260483530012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8238",
            "leftCorner": {
              "x": -10.806,
              "y": -0.273,
              "z": 1.066
            },
            "rightCorner": {
              "x": -10.805,
              "y": -0.364,
              "z": 1.066
            },
            "gtin": "4260483530074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8239",
            "leftCorner": {
              "x": -10.805,
              "y": -0.364,
              "z": 1.066
            },
            "rightCorner": {
              "x": -10.805,
              "y": -0.455,
              "z": 1.066
            },
            "gtin": "4260483530074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d823a",
            "leftCorner": {
              "x": -10.797,
              "y": -0.455,
              "z": 1.066
            },
            "rightCorner": {
              "x": -10.797,
              "y": -0.635,
              "z": 1.066
            },
            "gtin": "4260483535062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d823b",
            "leftCorner": {
              "x": -10.808,
              "y": -0.636,
              "z": 1.066
            },
            "rightCorner": {
              "x": -10.808,
              "y": -0.778,
              "z": 1.066
            },
            "gtin": "40198552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d823c",
            "leftCorner": {
              "x": -10.809,
              "y": -0.778,
              "z": 1.066
            },
            "rightCorner": {
              "x": -10.809,
              "y": -0.934,
              "z": 1.066
            },
            "gtin": "40804613",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d56b",
        "height": 1.6025,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d821a",
            "leftCorner": {
              "x": -10.814,
              "y": 0.276,
              "z": 1.311
            },
            "rightCorner": {
              "x": -10.815,
              "y": 0.061,
              "z": 1.311
            },
            "gtin": "4250426221176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9d50c5b3a10173786e7e964e",
            "leftCorner": {
              "x": -10.858,
              "y": 0.35,
              "z": 1.311
            },
            "rightCorner": {
              "x": -10.858,
              "y": 0.305,
              "z": 1.311
            },
            "gtin": "4012200417607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d821b",
            "leftCorner": {
              "x": -10.818,
              "y": 0.061,
              "z": 1.311
            },
            "rightCorner": {
              "x": -10.818,
              "y": -0.262,
              "z": 1.311
            },
            "gtin": "4012200046654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d821c",
            "leftCorner": {
              "x": -10.815,
              "y": -0.262,
              "z": 1.311
            },
            "rightCorner": {
              "x": -10.815,
              "y": -0.586,
              "z": 1.311
            },
            "gtin": "4012200417409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d821d",
            "leftCorner": {
              "x": -10.822,
              "y": -0.586,
              "z": 1.311
            },
            "rightCorner": {
              "x": -10.822,
              "y": -0.863,
              "z": 1.311
            },
            "gtin": "4012200417300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d821e",
            "leftCorner": {
              "x": -10.823,
              "y": -0.863,
              "z": 1.311
            },
            "rightCorner": {
              "x": -10.823,
              "y": -1.023,
              "z": 1.311
            },
            "gtin": "4012200417607",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "768",
    "rightNeighborShelfId": "76a"
  },
  {
    "id": "76a",
    "name": "76a",
    "x": -10.771,
    "y": -0.9,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70682,
      "w": 0.70739
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d574",
        "height": 0.16518,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d828a",
            "leftCorner": {
              "x": -10.878,
              "y": -0.9,
              "z": 0.135
            },
            "rightCorner": {
              "x": -10.877,
              "y": -1.082,
              "z": 0.135
            },
            "gtin": "4306188017967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d828c",
            "leftCorner": {
              "x": -10.841,
              "y": -1.082,
              "z": 0.135
            },
            "rightCorner": {
              "x": -10.842,
              "y": -1.223,
              "z": 0.135
            },
            "gtin": "8720600617416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d828d",
            "leftCorner": {
              "x": -10.837,
              "y": -1.223,
              "z": 0.135
            },
            "rightCorner": {
              "x": -10.837,
              "y": -1.383,
              "z": 0.135
            },
            "gtin": "40804255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d828e",
            "leftCorner": {
              "x": -10.844,
              "y": -1.383,
              "z": 0.135
            },
            "rightCorner": {
              "x": -10.845,
              "y": -1.603,
              "z": 0.135
            },
            "gtin": "4250426221336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d828f",
            "leftCorner": {
              "x": -10.834,
              "y": -1.603,
              "z": 0.135
            },
            "rightCorner": {
              "x": -10.834,
              "y": -1.823,
              "z": 0.135
            },
            "gtin": "4250426221411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8290",
            "leftCorner": {
              "x": -10.826,
              "y": -1.823,
              "z": 0.135
            },
            "rightCorner": {
              "x": -10.826,
              "y": -1.983,
              "z": 0.135
            },
            "gtin": "40804439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d828b",
            "leftCorner": {
              "x": -10.838,
              "y": -1.983,
              "z": 0.135
            },
            "rightCorner": {
              "x": -10.837,
              "y": -2.15,
              "z": 0.135
            },
            "gtin": "4250426221312",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d575",
        "height": 0.40625,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8272",
            "leftCorner": {
              "x": -10.8,
              "y": -0.965,
              "z": 0.332
            },
            "rightCorner": {
              "x": -10.8,
              "y": -1.145,
              "z": 0.332
            },
            "gtin": "4250426227611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e9ddb90fb7bf6c80bf6e3055",
            "leftCorner": {
              "x": -10.832,
              "y": -0.9,
              "z": 0.332
            },
            "rightCorner": {
              "x": -10.832,
              "y": -0.955,
              "z": 0.332
            },
            "gtin": "40804477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8273",
            "leftCorner": {
              "x": -10.798,
              "y": -1.145,
              "z": 0.332
            },
            "rightCorner": {
              "x": -10.798,
              "y": -1.297,
              "z": 0.332
            },
            "gtin": "40122816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8274",
            "leftCorner": {
              "x": -10.792,
              "y": -1.297,
              "z": 0.332
            },
            "rightCorner": {
              "x": -10.791,
              "y": -1.461,
              "z": 0.332
            },
            "gtin": "40804415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8275",
            "leftCorner": {
              "x": -10.797,
              "y": -1.461,
              "z": 0.332
            },
            "rightCorner": {
              "x": -10.797,
              "y": -1.666,
              "z": 0.332
            },
            "gtin": "4250426221374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8276",
            "leftCorner": {
              "x": -10.791,
              "y": -1.666,
              "z": 0.332
            },
            "rightCorner": {
              "x": -10.792,
              "y": -1.811,
              "z": 0.332
            },
            "gtin": "40804187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8277",
            "leftCorner": {
              "x": -10.785,
              "y": -1.811,
              "z": 0.332
            },
            "rightCorner": {
              "x": -10.784,
              "y": -2.038,
              "z": 0.332
            },
            "gtin": "4250426221350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8278",
            "leftCorner": {
              "x": -10.781,
              "y": -2.037,
              "z": 0.332
            },
            "rightCorner": {
              "x": -10.781,
              "y": -2.15,
              "z": 0.332
            },
            "gtin": "40804477",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d572",
        "height": 0.70335,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d81fe",
            "leftCorner": {
              "x": -10.812,
              "y": -0.904,
              "z": 0.575
            },
            "rightCorner": {
              "x": -10.812,
              "y": -1.055,
              "z": 0.575
            },
            "gtin": "4012712001509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d81ff",
            "leftCorner": {
              "x": -10.808,
              "y": -1.055,
              "z": 0.575
            },
            "rightCorner": {
              "x": -10.808,
              "y": -1.563,
              "z": 0.575
            },
            "gtin": "4250426221596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8200",
            "leftCorner": {
              "x": -10.808,
              "y": -1.563,
              "z": 0.575
            },
            "rightCorner": {
              "x": -10.808,
              "y": -1.718,
              "z": 0.575
            },
            "gtin": "40122915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8201",
            "leftCorner": {
              "x": -10.795,
              "y": -1.718,
              "z": 0.575
            },
            "rightCorner": {
              "x": -10.794,
              "y": -1.847,
              "z": 0.575
            },
            "gtin": "40804378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8202",
            "leftCorner": {
              "x": -10.786,
              "y": -1.847,
              "z": 0.575
            },
            "rightCorner": {
              "x": -10.786,
              "y": -2.049,
              "z": 0.575
            },
            "gtin": "40804149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8203",
            "leftCorner": {
              "x": -10.8,
              "y": -2.049,
              "z": 0.575
            },
            "rightCorner": {
              "x": -10.8,
              "y": -2.15,
              "z": 0.575
            },
            "gtin": "40804361",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d576",
        "height": 1.0007,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8257",
            "leftCorner": {
              "x": -10.816,
              "y": -1.175,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.816,
              "y": -1.274,
              "z": 0.819
            },
            "gtin": "4250426221534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f3c62414ac7f680f006043a4",
            "leftCorner": {
              "x": -10.851,
              "y": -0.9,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.851,
              "y": -1.165,
              "z": 0.819
            },
            "gtin": "4250426221497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8258",
            "leftCorner": {
              "x": -10.816,
              "y": -1.274,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.816,
              "y": -1.373,
              "z": 0.819
            },
            "gtin": "4250426221534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8259",
            "leftCorner": {
              "x": -10.816,
              "y": -1.373,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.816,
              "y": -1.472,
              "z": 0.819
            },
            "gtin": "4250426221534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d825a",
            "leftCorner": {
              "x": -10.814,
              "y": -1.472,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.814,
              "y": -1.639,
              "z": 0.819
            },
            "gtin": "4012200505359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d825b",
            "leftCorner": {
              "x": -10.808,
              "y": -1.639,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.807,
              "y": -1.872,
              "z": 0.819
            },
            "gtin": "4012200505335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d825c",
            "leftCorner": {
              "x": -10.793,
              "y": -1.872,
              "z": 0.819
            },
            "rightCorner": {
              "x": -10.793,
              "y": -2.282,
              "z": 0.819
            },
            "gtin": "8720600099106",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d573",
        "height": 1.3038,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d823d",
            "leftCorner": {
              "x": -10.829,
              "y": -0.934,
              "z": 1.067
            },
            "rightCorner": {
              "x": -10.828,
              "y": -1.105,
              "z": 1.067
            },
            "gtin": "4012712003343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d823e",
            "leftCorner": {
              "x": -10.826,
              "y": -1.105,
              "z": 1.067
            },
            "rightCorner": {
              "x": -10.826,
              "y": -1.276,
              "z": 1.067
            },
            "gtin": "4104420033962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d823f",
            "leftCorner": {
              "x": -10.815,
              "y": -1.276,
              "z": 1.067
            },
            "rightCorner": {
              "x": -10.815,
              "y": -1.523,
              "z": 1.067
            },
            "gtin": "40081922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8240",
            "leftCorner": {
              "x": -10.823,
              "y": -1.523,
              "z": 1.067
            },
            "rightCorner": {
              "x": -10.823,
              "y": -1.819,
              "z": 1.067
            },
            "gtin": "40081915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8241",
            "leftCorner": {
              "x": -10.806,
              "y": -1.819,
              "z": 1.067
            },
            "rightCorner": {
              "x": -10.805,
              "y": -2.332,
              "z": 1.067
            },
            "gtin": "40081908",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d571",
        "height": 1.6041,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d821f",
            "leftCorner": {
              "x": -10.835,
              "y": -1.023,
              "z": 1.312
            },
            "rightCorner": {
              "x": -10.834,
              "y": -1.163,
              "z": 1.312
            },
            "gtin": "4008100154537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f95628d7c7851a26caebe086",
            "leftCorner": {
              "x": -10.865,
              "y": -0.9,
              "z": 1.312
            },
            "rightCorner": {
              "x": -10.865,
              "y": -1.023,
              "z": 1.312
            },
            "gtin": "4008100154636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8220",
            "leftCorner": {
              "x": -10.829,
              "y": -1.163,
              "z": 1.312
            },
            "rightCorner": {
              "x": -10.829,
              "y": -1.286,
              "z": 1.312
            },
            "gtin": "4008100154544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8221",
            "leftCorner": {
              "x": -10.826,
              "y": -1.286,
              "z": 1.312
            },
            "rightCorner": {
              "x": -10.826,
              "y": -1.435,
              "z": 1.312
            },
            "gtin": "4008100154551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8222",
            "leftCorner": {
              "x": -10.823,
              "y": -1.435,
              "z": 1.312
            },
            "rightCorner": {
              "x": -10.822,
              "y": -1.556,
              "z": 1.312
            },
            "gtin": "4008100154636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8223",
            "leftCorner": {
              "x": -10.827,
              "y": -1.556,
              "z": 1.312
            },
            "rightCorner": {
              "x": -10.827,
              "y": -1.693,
              "z": 1.312
            },
            "gtin": "4008100151529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8224",
            "leftCorner": {
              "x": -10.817,
              "y": -1.693,
              "z": 1.312
            },
            "rightCorner": {
              "x": -10.817,
              "y": -1.877,
              "z": 1.312
            },
            "gtin": "4012712002995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8225",
            "leftCorner": {
              "x": -10.808,
              "y": -1.877,
              "z": 1.312
            },
            "rightCorner": {
              "x": -10.808,
              "y": -2.013,
              "z": 1.312
            },
            "gtin": "4104420033849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8226",
            "leftCorner": {
              "x": -10.819,
              "y": -2.013,
              "z": 1.312
            },
            "rightCorner": {
              "x": -10.819,
              "y": -2.614,
              "z": 1.312
            },
            "gtin": "4306188035527",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "769",
    "rightNeighborShelfId": "76b"
  },
  {
    "id": "76b",
    "name": "76b",
    "x": -10.77,
    "y": -2.15,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70682,
      "w": 0.70739
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 36
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d57a",
        "height": 0.17906,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8291",
            "leftCorner": {
              "x": -10.873,
              "y": -2.15,
              "z": 0.147
            },
            "rightCorner": {
              "x": -10.873,
              "y": -2.551,
              "z": 0.147
            },
            "gtin": "4012712004821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8293",
            "leftCorner": {
              "x": -10.844,
              "y": -2.551,
              "z": 0.147
            },
            "rightCorner": {
              "x": -10.843,
              "y": -2.879,
              "z": 0.147
            },
            "gtin": "40804033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8292",
            "leftCorner": {
              "x": -10.826,
              "y": -3.126,
              "z": 0.147
            },
            "rightCorner": {
              "x": -10.826,
              "y": -3.4,
              "z": 0.147
            },
            "gtin": "4250426222784",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d57b",
        "height": 0.41461,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8279",
            "leftCorner": {
              "x": -10.779,
              "y": -2.15,
              "z": 0.339
            },
            "rightCorner": {
              "x": -10.782,
              "y": -2.245,
              "z": 0.339
            },
            "gtin": "4250426221398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d827a",
            "leftCorner": {
              "x": -10.782,
              "y": -2.245,
              "z": 0.339
            },
            "rightCorner": {
              "x": -10.781,
              "y": -2.398,
              "z": 0.339
            },
            "gtin": "4250426221398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d827b",
            "leftCorner": {
              "x": -10.792,
              "y": -2.398,
              "z": 0.339
            },
            "rightCorner": {
              "x": -10.792,
              "y": -2.633,
              "z": 0.339
            },
            "gtin": "40804330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d827c",
            "leftCorner": {
              "x": -10.789,
              "y": -2.633,
              "z": 0.339
            },
            "rightCorner": {
              "x": -10.788,
              "y": -2.818,
              "z": 0.339
            },
            "gtin": "4250426218527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d827d",
            "leftCorner": {
              "x": -10.735,
              "y": -2.818,
              "z": 0.339
            },
            "rightCorner": {
              "x": -10.735,
              "y": -2.89,
              "z": 0.339
            },
            "gtin": "4250426222760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d827e",
            "leftCorner": {
              "x": -10.735,
              "y": -2.89,
              "z": 0.339
            },
            "rightCorner": {
              "x": -10.735,
              "y": -2.961,
              "z": 0.339
            },
            "gtin": "4250426222760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d827f",
            "leftCorner": {
              "x": -10.735,
              "y": -2.961,
              "z": 0.339
            },
            "rightCorner": {
              "x": -10.735,
              "y": -3.033,
              "z": 0.339
            },
            "gtin": "4250426222760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8280",
            "leftCorner": {
              "x": -10.735,
              "y": -3.033,
              "z": 0.339
            },
            "rightCorner": {
              "x": -10.735,
              "y": -3.104,
              "z": 0.339
            },
            "gtin": "4250426222760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8263",
            "leftCorner": {
              "x": -10.78,
              "y": -3.104,
              "z": 0.339
            },
            "rightCorner": {
              "x": -10.779,
              "y": -3.4,
              "z": 0.339
            },
            "gtin": "4250426222807",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d577",
        "height": 0.7107,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8204",
            "leftCorner": {
              "x": -10.794,
              "y": -2.15,
              "z": 0.581
            },
            "rightCorner": {
              "x": -10.796,
              "y": -2.189,
              "z": 0.581
            },
            "gtin": "40122861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8205",
            "leftCorner": {
              "x": -10.788,
              "y": -2.189,
              "z": 0.581
            },
            "rightCorner": {
              "x": -10.788,
              "y": -2.349,
              "z": 0.581
            },
            "gtin": "40122861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8206",
            "leftCorner": {
              "x": -10.798,
              "y": -2.349,
              "z": 0.581
            },
            "rightCorner": {
              "x": -10.799,
              "y": -2.601,
              "z": 0.581
            },
            "gtin": "4306188037354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8207",
            "leftCorner": {
              "x": -10.8,
              "y": -2.601,
              "z": 0.581
            },
            "rightCorner": {
              "x": -10.799,
              "y": -2.746,
              "z": 0.581
            },
            "gtin": "4008100173019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8208",
            "leftCorner": {
              "x": -10.796,
              "y": -2.746,
              "z": 0.581
            },
            "rightCorner": {
              "x": -10.796,
              "y": -2.862,
              "z": 0.581
            },
            "gtin": "4008100173026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8209",
            "leftCorner": {
              "x": -10.792,
              "y": -2.862,
              "z": 0.581
            },
            "rightCorner": {
              "x": -10.791,
              "y": -2.997,
              "z": 0.581
            },
            "gtin": "4008100173224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d820a",
            "leftCorner": {
              "x": -10.786,
              "y": -2.997,
              "z": 0.581
            },
            "rightCorner": {
              "x": -10.787,
              "y": -3.146,
              "z": 0.581
            },
            "gtin": "40081977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81f2",
            "leftCorner": {
              "x": -10.784,
              "y": -3.147,
              "z": 0.581
            },
            "rightCorner": {
              "x": -10.784,
              "y": -3.4,
              "z": 0.581
            },
            "gtin": "4306188407874",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d579",
        "height": 1.0103,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d825d",
            "leftCorner": {
              "x": -10.801,
              "y": -2.282,
              "z": 0.827
            },
            "rightCorner": {
              "x": -10.801,
              "y": -2.839,
              "z": 0.827
            },
            "gtin": "8720600096105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d825e",
            "leftCorner": {
              "x": -10.8,
              "y": -2.839,
              "z": 0.827
            },
            "rightCorner": {
              "x": -10.799,
              "y": -3.107,
              "z": 0.827
            },
            "gtin": "8720600094101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8247",
            "leftCorner": {
              "x": -10.792,
              "y": -3.107,
              "z": 0.827
            },
            "rightCorner": {
              "x": -10.792,
              "y": -3.4,
              "z": 0.827
            },
            "gtin": "8720600091100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c5214822fa26415a17871b80",
            "leftCorner": {
              "x": -10.84,
              "y": -2.15,
              "z": 0.827
            },
            "rightCorner": {
              "x": -10.84,
              "y": -2.254,
              "z": 0.827
            },
            "gtin": "8720600091100",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d578",
        "height": 1.3133,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8242",
            "leftCorner": {
              "x": -10.805,
              "y": -2.332,
              "z": 1.075
            },
            "rightCorner": {
              "x": -10.805,
              "y": -2.558,
              "z": 1.075
            },
            "gtin": "4250426221275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8243",
            "leftCorner": {
              "x": -10.808,
              "y": -2.558,
              "z": 1.075
            },
            "rightCorner": {
              "x": -10.808,
              "y": -2.713,
              "z": 1.075
            },
            "gtin": "40122762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8244",
            "leftCorner": {
              "x": -10.806,
              "y": -2.713,
              "z": 1.075
            },
            "rightCorner": {
              "x": -10.805,
              "y": -2.886,
              "z": 1.075
            },
            "gtin": "40122991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8245",
            "leftCorner": {
              "x": -10.799,
              "y": -2.886,
              "z": 1.075
            },
            "rightCorner": {
              "x": -10.798,
              "y": -3.133,
              "z": 1.075
            },
            "gtin": "40804743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d822b",
            "leftCorner": {
              "x": -10.789,
              "y": -3.133,
              "z": 1.075
            },
            "rightCorner": {
              "x": -10.789,
              "y": -3.4,
              "z": 1.075
            },
            "gtin": "40804002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7909dfa38dfd806f4406a89a",
            "leftCorner": {
              "x": -10.845,
              "y": -2.15,
              "z": 1.075
            },
            "rightCorner": {
              "x": -10.845,
              "y": -2.319,
              "z": 1.075
            },
            "gtin": "40122991",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d57c",
        "height": 1.6141,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8227",
            "leftCorner": {
              "x": -10.818,
              "y": -2.614,
              "z": 1.321
            },
            "rightCorner": {
              "x": -10.818,
              "y": -2.728,
              "z": 1.321
            },
            "gtin": "4012200463505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8228",
            "leftCorner": {
              "x": -10.815,
              "y": -2.728,
              "z": 1.321
            },
            "rightCorner": {
              "x": -10.814,
              "y": -2.883,
              "z": 1.321
            },
            "gtin": "40804453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8229",
            "leftCorner": {
              "x": -10.807,
              "y": -2.883,
              "z": 1.321
            },
            "rightCorner": {
              "x": -10.807,
              "y": -3.196,
              "z": 1.321
            },
            "gtin": "40198859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d820c",
            "leftCorner": {
              "x": -10.796,
              "y": -3.196,
              "z": 1.321
            },
            "rightCorner": {
              "x": -10.797,
              "y": -3.4,
              "z": 1.321
            },
            "gtin": "40804781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ae163039fdf6444acb3f2076",
            "leftCorner": {
              "x": -10.852,
              "y": -2.15,
              "z": 1.321
            },
            "rightCorner": {
              "x": -10.852,
              "y": -2.305,
              "z": 1.321
            },
            "gtin": "40804453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "16ef0be977b29631fae8c388",
            "leftCorner": {
              "x": -10.852,
              "y": -2.305,
              "z": 1.321
            },
            "rightCorner": {
              "x": -10.852,
              "y": -2.517,
              "z": 1.321
            },
            "gtin": "40804781",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "76a"
  },
  {
    "id": "76c",
    "name": "76c",
    "x": -9.175,
    "y": -3.371,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71166,
      "w": 0.70253
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 48
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d54b",
        "height": 0.38704,
        "facings": [
          {
            "id": "68d8e50de1820c81800d81c6",
            "leftCorner": {
              "x": -9.182,
              "y": -2.984,
              "z": 0.317
            },
            "rightCorner": {
              "x": -9.194,
              "y": -2.121,
              "z": 0.317
            },
            "gtin": "4004994800017",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d548",
        "height": 0.63318,
        "facings": [
          {
            "id": "68d8e50de1820c81800d815c",
            "leftCorner": {
              "x": -9.249,
              "y": -3.372,
              "z": 0.518
            },
            "rightCorner": {
              "x": -9.252,
              "y": -3.108,
              "z": 0.518
            },
            "gtin": "4021900008770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d815e",
            "leftCorner": {
              "x": -9.309,
              "y": -3.109,
              "z": 0.518
            },
            "rightCorner": {
              "x": -9.311,
              "y": -2.963,
              "z": 0.518
            },
            "gtin": "4021900008633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d815f",
            "leftCorner": {
              "x": -9.305,
              "y": -2.963,
              "z": 0.518
            },
            "rightCorner": {
              "x": -9.305,
              "y": -2.897,
              "z": 0.518
            },
            "gtin": "4021900008619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8160",
            "leftCorner": {
              "x": -9.305,
              "y": -2.897,
              "z": 0.518
            },
            "rightCorner": {
              "x": -9.306,
              "y": -2.831,
              "z": 0.518
            },
            "gtin": "4021900008619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8161",
            "leftCorner": {
              "x": -9.295,
              "y": -2.831,
              "z": 0.518
            },
            "rightCorner": {
              "x": -9.297,
              "y": -2.733,
              "z": 0.518
            },
            "gtin": "4030800511044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8162",
            "leftCorner": {
              "x": -9.297,
              "y": -2.733,
              "z": 0.518
            },
            "rightCorner": {
              "x": -9.298,
              "y": -2.651,
              "z": 0.518
            },
            "gtin": "4030800068494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8163",
            "leftCorner": {
              "x": -9.3,
              "y": -2.651,
              "z": 0.518
            },
            "rightCorner": {
              "x": -9.301,
              "y": -2.535,
              "z": 0.518
            },
            "gtin": "4021900006752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8164",
            "leftCorner": {
              "x": -9.299,
              "y": -2.535,
              "z": 0.518
            },
            "rightCorner": {
              "x": -9.301,
              "y": -2.426,
              "z": 0.518
            },
            "gtin": "4250426224429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8165",
            "leftCorner": {
              "x": -9.299,
              "y": -2.426,
              "z": 0.518
            },
            "rightCorner": {
              "x": -9.301,
              "y": -2.328,
              "z": 0.518
            },
            "gtin": "4250426224368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8166",
            "leftCorner": {
              "x": -9.301,
              "y": -2.328,
              "z": 0.518
            },
            "rightCorner": {
              "x": -9.302,
              "y": -2.194,
              "z": 0.518
            },
            "gtin": "4250426228496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d815d",
            "leftCorner": {
              "x": -9.305,
              "y": -2.194,
              "z": 0.518
            },
            "rightCorner": {
              "x": -9.306,
              "y": -2.123,
              "z": 0.518
            },
            "gtin": "4250426224382",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d549",
        "height": 0.93485,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8167",
            "leftCorner": {
              "x": -9.258,
              "y": -3.372,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.259,
              "y": -3.258,
              "z": 0.765
            },
            "gtin": "4306188039600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8168",
            "leftCorner": {
              "x": -9.259,
              "y": -3.258,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.261,
              "y": -3.143,
              "z": 0.765
            },
            "gtin": "4306188039600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d816a",
            "leftCorner": {
              "x": -9.307,
              "y": -3.144,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.308,
              "y": -3.055,
              "z": 0.765
            },
            "gtin": "4306188039426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d816b",
            "leftCorner": {
              "x": -9.316,
              "y": -3.055,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.317,
              "y": -2.929,
              "z": 0.765
            },
            "gtin": "4306188039396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d816c",
            "leftCorner": {
              "x": -9.306,
              "y": -2.928,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.307,
              "y": -2.891,
              "z": 0.765
            },
            "gtin": "4306188039518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d816d",
            "leftCorner": {
              "x": -9.306,
              "y": -2.891,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.307,
              "y": -2.788,
              "z": 0.765
            },
            "gtin": "4306188039464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d816e",
            "leftCorner": {
              "x": -9.266,
              "y": -2.787,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.268,
              "y": -2.637,
              "z": 0.765
            },
            "gtin": "4250426214642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d816f",
            "leftCorner": {
              "x": -9.304,
              "y": -2.638,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.306,
              "y": -2.511,
              "z": 0.765
            },
            "gtin": "3276170012762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8170",
            "leftCorner": {
              "x": -9.307,
              "y": -2.511,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.308,
              "y": -2.416,
              "z": 0.765
            },
            "gtin": "3276170016500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8171",
            "leftCorner": {
              "x": -9.307,
              "y": -2.416,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.308,
              "y": -2.353,
              "z": 0.765
            },
            "gtin": "4051009038408",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d8172",
            "leftCorner": {
              "x": -9.305,
              "y": -2.352,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.306,
              "y": -2.292,
              "z": 0.765
            },
            "gtin": "4057109001007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8173",
            "leftCorner": {
              "x": -9.311,
              "y": -2.292,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.312,
              "y": -2.214,
              "z": 0.765
            },
            "gtin": "4044491054810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8174",
            "leftCorner": {
              "x": -9.307,
              "y": -2.214,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.308,
              "y": -2.164,
              "z": 0.765
            },
            "gtin": "4044491054469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8175",
            "leftCorner": {
              "x": -9.319,
              "y": -2.164,
              "z": 0.765
            },
            "rightCorner": {
              "x": -9.321,
              "y": -2.021,
              "z": 0.765
            },
            "gtin": "4044491054414",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d546",
        "height": 1.2319,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8100",
            "leftCorner": {
              "x": -9.266,
              "y": -3.372,
              "z": 1.008
            },
            "rightCorner": {
              "x": -9.268,
              "y": -3.203,
              "z": 1.008
            },
            "gtin": "4250426219753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8102",
            "leftCorner": {
              "x": -9.309,
              "y": -3.203,
              "z": 1.008
            },
            "rightCorner": {
              "x": -9.311,
              "y": -3.046,
              "z": 1.008
            },
            "gtin": "4021900006332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8103",
            "leftCorner": {
              "x": -9.311,
              "y": -3.046,
              "z": 1.008
            },
            "rightCorner": {
              "x": -9.313,
              "y": -2.907,
              "z": 1.008
            },
            "gtin": "4030800069835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8104",
            "leftCorner": {
              "x": -9.313,
              "y": -2.907,
              "z": 1.008
            },
            "rightCorner": {
              "x": -9.314,
              "y": -2.791,
              "z": 1.008
            },
            "gtin": "4021900010698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8105",
            "leftCorner": {
              "x": -9.23,
              "y": -2.79,
              "z": 1.008
            },
            "rightCorner": {
              "x": -9.232,
              "y": -2.596,
              "z": 1.008
            },
            "gtin": "4030800069811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8106",
            "leftCorner": {
              "x": -9.234,
              "y": -2.596,
              "z": 1.008
            },
            "rightCorner": {
              "x": -9.235,
              "y": -2.495,
              "z": 1.008
            },
            "gtin": "4030800078943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8107",
            "leftCorner": {
              "x": -9.318,
              "y": -2.496,
              "z": 1.008
            },
            "rightCorner": {
              "x": -9.32,
              "y": -2.402,
              "z": 1.008
            },
            "gtin": "3276170012663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8108",
            "leftCorner": {
              "x": -9.317,
              "y": -2.402,
              "z": 1.008
            },
            "rightCorner": {
              "x": -9.318,
              "y": -2.327,
              "z": 1.008
            },
            "gtin": "4002239115506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8109",
            "leftCorner": {
              "x": -9.314,
              "y": -2.327,
              "z": 1.008
            },
            "rightCorner": {
              "x": -9.316,
              "y": -2.186,
              "z": 1.008
            },
            "gtin": "4100970018794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d810a",
            "leftCorner": {
              "x": -9.31,
              "y": -2.186,
              "z": 1.008
            },
            "rightCorner": {
              "x": -9.312,
              "y": -2.018,
              "z": 1.008
            },
            "gtin": "4100970018763",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d547",
        "height": 1.5327,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8130",
            "leftCorner": {
              "x": -9.258,
              "y": -3.372,
              "z": 1.254
            },
            "rightCorner": {
              "x": -9.261,
              "y": -3.19,
              "z": 1.254
            },
            "gtin": "4250426222708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6245d1e169038b50c229c281",
            "leftCorner": {
              "x": -9.269,
              "y": -2.507,
              "z": 1.254
            },
            "rightCorner": {
              "x": -9.272,
              "y": -2.297,
              "z": 1.254
            },
            "gtin": "4057295280903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "65a390da4f966074f16c8d63",
            "leftCorner": {
              "x": -9.272,
              "y": -2.297,
              "z": 1.254
            },
            "rightCorner": {
              "x": -9.274,
              "y": -2.13,
              "z": 1.254
            },
            "gtin": "4260046742906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8132",
            "leftCorner": {
              "x": -9.301,
              "y": -3.191,
              "z": 1.254
            },
            "rightCorner": {
              "x": -9.303,
              "y": -3.018,
              "z": 1.254
            },
            "gtin": "4057295222132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8133",
            "leftCorner": {
              "x": -9.303,
              "y": -3.018,
              "z": 1.254
            },
            "rightCorner": {
              "x": -9.305,
              "y": -2.873,
              "z": 1.254
            },
            "gtin": "4057295222125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8134",
            "leftCorner": {
              "x": -9.305,
              "y": -2.873,
              "z": 1.254
            },
            "rightCorner": {
              "x": -9.308,
              "y": -2.666,
              "z": 1.254
            },
            "gtin": "4260046748908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8135",
            "leftCorner": {
              "x": -9.304,
              "y": -2.666,
              "z": 1.254
            },
            "rightCorner": {
              "x": -9.306,
              "y": -2.508,
              "z": 1.254
            },
            "gtin": "4260046742906",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d54a",
        "height": 1.8316,
        "facings": [
          {
            "id": "68d8e50de1820c81800d819c",
            "leftCorner": {
              "x": -9.261,
              "y": -3.372,
              "z": 1.499
            },
            "rightCorner": {
              "x": -9.265,
              "y": -3.099,
              "z": 1.499
            },
            "gtin": "4250426219449",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d819e",
            "leftCorner": {
              "x": -9.305,
              "y": -3.099,
              "z": 1.499
            },
            "rightCorner": {
              "x": -9.307,
              "y": -2.943,
              "z": 1.499
            },
            "gtin": "4250426219463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d819f",
            "leftCorner": {
              "x": -9.302,
              "y": -2.943,
              "z": 1.499
            },
            "rightCorner": {
              "x": -9.304,
              "y": -2.783,
              "z": 1.499
            },
            "gtin": "4003908091008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81a0",
            "leftCorner": {
              "x": -9.226,
              "y": -2.782,
              "z": 1.499
            },
            "rightCorner": {
              "x": -9.228,
              "y": -2.631,
              "z": 1.499
            },
            "gtin": "4260046740629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81a1",
            "leftCorner": {
              "x": -9.312,
              "y": -2.632,
              "z": 1.499
            },
            "rightCorner": {
              "x": -9.314,
              "y": -2.485,
              "z": 1.499
            },
            "gtin": "4260046740353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81a2",
            "leftCorner": {
              "x": -9.313,
              "y": -2.485,
              "z": 1.499
            },
            "rightCorner": {
              "x": -9.316,
              "y": -2.276,
              "z": 1.499
            },
            "gtin": "4057295250227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81a3",
            "leftCorner": {
              "x": -9.314,
              "y": -2.276,
              "z": 1.499
            },
            "rightCorner": {
              "x": -9.316,
              "y": -2.123,
              "z": 1.499
            },
            "gtin": "4057295251170",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "970"
  },
  {
    "id": "776",
    "name": "776",
    "x": -13.438,
    "y": 2.3,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70431,
      "w": 0.70989
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5a3",
        "height": 0.15782,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8410",
            "leftCorner": {
              "x": -13.537,
              "y": 2.299,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.535,
              "y": 2.125,
              "z": 0.129
            },
            "gtin": "8721201920561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8412",
            "leftCorner": {
              "x": -13.502,
              "y": 2.125,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.502,
              "y": 1.968,
              "z": 0.129
            },
            "gtin": "8721201919916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8413",
            "leftCorner": {
              "x": -13.504,
              "y": 1.968,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.502,
              "y": 1.79,
              "z": 0.129
            },
            "gtin": "8721201919732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8414",
            "leftCorner": {
              "x": -13.484,
              "y": 1.79,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.483,
              "y": 1.637,
              "z": 0.129
            },
            "gtin": "8721201921599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8415",
            "leftCorner": {
              "x": -13.492,
              "y": 1.637,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.49,
              "y": 1.445,
              "z": 0.129
            },
            "gtin": "8720182408815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8416",
            "leftCorner": {
              "x": -13.491,
              "y": 1.445,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.49,
              "y": 1.277,
              "z": 0.129
            },
            "gtin": "8721201919855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8411",
            "leftCorner": {
              "x": -13.482,
              "y": 1.277,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.48,
              "y": 1.05,
              "z": 0.129
            },
            "gtin": "4003082008243",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d59f",
        "height": 0.40689,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8395",
            "leftCorner": {
              "x": -13.47,
              "y": 2.3,
              "z": 0.333
            },
            "rightCorner": {
              "x": -13.468,
              "y": 2.095,
              "z": 0.333
            },
            "gtin": "8711327414921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8397",
            "leftCorner": {
              "x": -13.437,
              "y": 2.095,
              "z": 0.333
            },
            "rightCorner": {
              "x": -13.435,
              "y": 1.895,
              "z": 0.333
            },
            "gtin": "8714100697108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8398",
            "leftCorner": {
              "x": -13.431,
              "y": 1.895,
              "z": 0.333
            },
            "rightCorner": {
              "x": -13.43,
              "y": 1.688,
              "z": 0.333
            },
            "gtin": "8720182839268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8399",
            "leftCorner": {
              "x": -13.424,
              "y": 1.689,
              "z": 0.333
            },
            "rightCorner": {
              "x": -13.424,
              "y": 1.519,
              "z": 0.333
            },
            "gtin": "8711327416208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d839a",
            "leftCorner": {
              "x": -13.422,
              "y": 1.519,
              "z": 0.333
            },
            "rightCorner": {
              "x": -13.421,
              "y": 1.312,
              "z": 0.333
            },
            "gtin": "8714100697368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d839b",
            "leftCorner": {
              "x": -13.422,
              "y": 1.312,
              "z": 0.333
            },
            "rightCorner": {
              "x": -13.419,
              "y": 1.006,
              "z": 0.333
            },
            "gtin": "8720182838889",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5a0",
        "height": 0.70595,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83ad",
            "leftCorner": {
              "x": -13.474,
              "y": 2.3,
              "z": 0.578
            },
            "rightCorner": {
              "x": -13.472,
              "y": 2.086,
              "z": 0.578
            },
            "gtin": "7613035509092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83af",
            "leftCorner": {
              "x": -13.439,
              "y": 2.087,
              "z": 0.578
            },
            "rightCorner": {
              "x": -13.438,
              "y": 1.837,
              "z": 0.578
            },
            "gtin": "7613037639780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83b0",
            "leftCorner": {
              "x": -13.431,
              "y": 1.837,
              "z": 0.578
            },
            "rightCorner": {
              "x": -13.429,
              "y": 1.514,
              "z": 0.578
            },
            "gtin": "7613031437870",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d83b1",
            "leftCorner": {
              "x": -13.426,
              "y": 1.514,
              "z": 0.578
            },
            "rightCorner": {
              "x": -13.425,
              "y": 1.326,
              "z": 0.578
            },
            "gtin": "7613037804263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83b2",
            "leftCorner": {
              "x": -13.423,
              "y": 1.326,
              "z": 0.578
            },
            "rightCorner": {
              "x": -13.422,
              "y": 1.136,
              "z": 0.578
            },
            "gtin": "7613035587427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83b3",
            "leftCorner": {
              "x": -13.434,
              "y": 1.136,
              "z": 0.578
            },
            "rightCorner": {
              "x": -13.432,
              "y": 0.931,
              "z": 0.578
            },
            "gtin": "7613287129703",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5a1",
        "height": 1.0099,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83ca",
            "leftCorner": {
              "x": -13.469,
              "y": 2.3,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.468,
              "y": 2.106,
              "z": 0.826
            },
            "gtin": "7613037639568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83cc",
            "leftCorner": {
              "x": -13.435,
              "y": 2.107,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.435,
              "y": 1.917,
              "z": 0.826
            },
            "gtin": "4005500339458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83cd",
            "leftCorner": {
              "x": -13.437,
              "y": 1.917,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.434,
              "y": 1.665,
              "z": 0.826
            },
            "gtin": "7613037870046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83ce",
            "leftCorner": {
              "x": -13.422,
              "y": 1.665,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.422,
              "y": 1.539,
              "z": 0.826
            },
            "gtin": "7613037639858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83cf",
            "leftCorner": {
              "x": -13.421,
              "y": 1.539,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.42,
              "y": 1.436,
              "z": 0.826
            },
            "gtin": "7613035587359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83d0",
            "leftCorner": {
              "x": -13.42,
              "y": 1.436,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.419,
              "y": 1.334,
              "z": 0.826
            },
            "gtin": "7613035587359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83d1",
            "leftCorner": {
              "x": -13.422,
              "y": 1.334,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.421,
              "y": 1.138,
              "z": 0.826
            },
            "gtin": "7613035758940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83d2",
            "leftCorner": {
              "x": -13.428,
              "y": 1.138,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.426,
              "y": 0.933,
              "z": 0.826
            },
            "gtin": "7613287129741",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d59e",
        "height": 1.3119,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8371",
            "leftCorner": {
              "x": -13.467,
              "y": 2.3,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.466,
              "y": 2.195,
              "z": 1.073
            },
            "gtin": "4002676626030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8372",
            "leftCorner": {
              "x": -13.466,
              "y": 2.195,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.465,
              "y": 2.091,
              "z": 1.073
            },
            "gtin": "4002676626030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8374",
            "leftCorner": {
              "x": -13.434,
              "y": 2.091,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.433,
              "y": 1.891,
              "z": 1.073
            },
            "gtin": "4002676626078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8375",
            "leftCorner": {
              "x": -13.43,
              "y": 1.891,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.429,
              "y": 1.711,
              "z": 1.073
            },
            "gtin": "4002676626023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8376",
            "leftCorner": {
              "x": -13.42,
              "y": 1.711,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.419,
              "y": 1.506,
              "z": 1.073
            },
            "gtin": "4002676626085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8377",
            "leftCorner": {
              "x": -13.418,
              "y": 1.506,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.416,
              "y": 1.351,
              "z": 1.073
            },
            "gtin": "3487400007216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8378",
            "leftCorner": {
              "x": -13.416,
              "y": 1.351,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.415,
              "y": 1.163,
              "z": 1.073
            },
            "gtin": "4008100153318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8379",
            "leftCorner": {
              "x": -13.421,
              "y": 1.163,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.419,
              "y": 0.985,
              "z": 1.073
            },
            "gtin": "4008100153325",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5a2",
        "height": 1.6141,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83ec",
            "leftCorner": {
              "x": -13.467,
              "y": 2.3,
              "z": 1.321
            },
            "rightCorner": {
              "x": -13.466,
              "y": 2.177,
              "z": 1.321
            },
            "gtin": "8710908957673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83ee",
            "leftCorner": {
              "x": -13.18,
              "y": 2.179,
              "z": 1.321
            },
            "rightCorner": {
              "x": -13.179,
              "y": 2.1,
              "z": 1.321
            },
            "gtin": "8710908957635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83ef",
            "leftCorner": {
              "x": -13.182,
              "y": 2.1,
              "z": 1.321
            },
            "rightCorner": {
              "x": -13.181,
              "y": 2.001,
              "z": 1.321
            },
            "gtin": "8710908958151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83f0",
            "leftCorner": {
              "x": -13.433,
              "y": 1.999,
              "z": 1.321
            },
            "rightCorner": {
              "x": -13.432,
              "y": 1.888,
              "z": 1.321
            },
            "gtin": "8710908958175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83f1",
            "leftCorner": {
              "x": -13.431,
              "y": 1.888,
              "z": 1.321
            },
            "rightCorner": {
              "x": -13.43,
              "y": 1.792,
              "z": 1.321
            },
            "gtin": "4037300134803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83f2",
            "leftCorner": {
              "x": -13.426,
              "y": 1.792,
              "z": 1.321
            },
            "rightCorner": {
              "x": -13.426,
              "y": 1.692,
              "z": 1.321
            },
            "gtin": "4037300134988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83f3",
            "leftCorner": {
              "x": -13.421,
              "y": 1.692,
              "z": 1.321
            },
            "rightCorner": {
              "x": -13.42,
              "y": 1.6,
              "z": 1.321
            },
            "gtin": "4037300134742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83f4",
            "leftCorner": {
              "x": -13.417,
              "y": 1.6,
              "z": 1.321
            },
            "rightCorner": {
              "x": -13.416,
              "y": 1.481,
              "z": 1.321
            },
            "gtin": "4037300134605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83f5",
            "leftCorner": {
              "x": -13.42,
              "y": 1.481,
              "z": 1.321
            },
            "rightCorner": {
              "x": -13.418,
              "y": 1.292,
              "z": 1.321
            },
            "gtin": "4002359018626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83f6",
            "leftCorner": {
              "x": -13.417,
              "y": 1.292,
              "z": 1.321
            },
            "rightCorner": {
              "x": -13.415,
              "y": 1.124,
              "z": 1.321
            },
            "gtin": "4306188047629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83f7",
            "leftCorner": {
              "x": -13.423,
              "y": 1.124,
              "z": 1.321
            },
            "rightCorner": {
              "x": -13.422,
              "y": 0.927,
              "z": 1.321
            },
            "gtin": "4002359018633",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "777"
  },
  {
    "id": "777",
    "name": "777",
    "x": -13.429,
    "y": 1.05,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70431,
      "w": 0.70989
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 46
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5a9",
        "height": 0.17861,
        "facings": [
          {
            "id": "d87bf881c3dc520432b96137",
            "leftCorner": {
              "x": -13.521,
              "y": 1.049,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.521,
              "y": 1.021,
              "z": 0.146
            },
            "gtin": "4044983005207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "52feea0fb2de767f72a46368",
            "leftCorner": {
              "x": -13.521,
              "y": 1.021,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.52,
              "y": 0.951,
              "z": 0.146
            },
            "gtin": "8720182893000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f403c95ff19a59c4a6c67941",
            "leftCorner": {
              "x": -13.52,
              "y": 0.951,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.52,
              "y": 0.864,
              "z": 0.146
            },
            "gtin": "4820179253320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1f9deff06b5745c9e304b997",
            "leftCorner": {
              "x": -13.52,
              "y": 0.864,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.519,
              "y": 0.745,
              "z": 0.146
            },
            "gtin": "4008585102535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "86e7c498bbcd0d8413e55437",
            "leftCorner": {
              "x": -13.519,
              "y": 0.745,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.518,
              "y": 0.615,
              "z": 0.146
            },
            "gtin": "7613037683561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2a1e4729736427edb603cb9e",
            "leftCorner": {
              "x": -13.518,
              "y": 0.615,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.516,
              "y": 0.46,
              "z": 0.146
            },
            "gtin": "4016900418025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "04518c6c92e463bb246fd7a0",
            "leftCorner": {
              "x": -13.516,
              "y": 0.46,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.515,
              "y": 0.301,
              "z": 0.146
            },
            "gtin": "4008585103228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "52103ca54e6b66e62f3b6935",
            "leftCorner": {
              "x": -13.515,
              "y": 0.301,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.514,
              "y": 0.137,
              "z": 0.146
            },
            "gtin": "4820179256581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "833e7c43548da8f171c7c6d9",
            "leftCorner": {
              "x": -13.514,
              "y": 0.137,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.512,
              "y": -0.029,
              "z": 0.146
            },
            "gtin": "4044983005184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "454913d5af9638ba9b7efd18",
            "leftCorner": {
              "x": -13.512,
              "y": -0.029,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.511,
              "y": -0.2,
              "z": 0.146
            },
            "gtin": "4002359018671",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5a7",
        "height": 0.40631,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d839c",
            "leftCorner": {
              "x": -13.431,
              "y": 1.005,
              "z": 0.332
            },
            "rightCorner": {
              "x": -13.431,
              "y": 0.905,
              "z": 0.332
            },
            "gtin": "8720182893000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d839d",
            "leftCorner": {
              "x": -13.423,
              "y": 0.905,
              "z": 0.332
            },
            "rightCorner": {
              "x": -13.422,
              "y": 0.709,
              "z": 0.332
            },
            "gtin": "4005500339205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d839e",
            "leftCorner": {
              "x": -13.422,
              "y": 0.709,
              "z": 0.332
            },
            "rightCorner": {
              "x": -13.42,
              "y": 0.512,
              "z": 0.332
            },
            "gtin": "4005500339205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d839f",
            "leftCorner": {
              "x": -13.425,
              "y": 0.512,
              "z": 0.332
            },
            "rightCorner": {
              "x": -13.423,
              "y": 0.334,
              "z": 0.332
            },
            "gtin": "4005500339403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83a0",
            "leftCorner": {
              "x": -13.423,
              "y": 0.334,
              "z": 0.332
            },
            "rightCorner": {
              "x": -13.423,
              "y": 0.156,
              "z": 0.332
            },
            "gtin": "4005500339403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83a1",
            "leftCorner": {
              "x": -13.423,
              "y": 0.156,
              "z": 0.332
            },
            "rightCorner": {
              "x": -13.421,
              "y": -0.023,
              "z": 0.332
            },
            "gtin": "4005500339403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83a2",
            "leftCorner": {
              "x": -13.417,
              "y": -0.023,
              "z": 0.332
            },
            "rightCorner": {
              "x": -13.414,
              "y": -0.422,
              "z": 0.332
            },
            "gtin": "4005500330318",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5a4",
        "height": 0.70781,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83b4",
            "leftCorner": {
              "x": -13.427,
              "y": 0.931,
              "z": 0.579
            },
            "rightCorner": {
              "x": -13.426,
              "y": 0.703,
              "z": 0.579
            },
            "gtin": "7613037639513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4dc17d7c976fc214cb54579b",
            "leftCorner": {
              "x": -13.467,
              "y": 1.05,
              "z": 0.579
            },
            "rightCorner": {
              "x": -13.466,
              "y": 0.962,
              "z": 0.579
            },
            "gtin": "4820179253320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83b5",
            "leftCorner": {
              "x": -13.425,
              "y": 0.703,
              "z": 0.579
            },
            "rightCorner": {
              "x": -13.423,
              "y": 0.428,
              "z": 0.579
            },
            "gtin": "4820179253320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83b6",
            "leftCorner": {
              "x": -13.425,
              "y": 0.428,
              "z": 0.579
            },
            "rightCorner": {
              "x": -13.422,
              "y": 0.13,
              "z": 0.579
            },
            "gtin": "4820179253313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83b7",
            "leftCorner": {
              "x": -13.419,
              "y": 0.13,
              "z": 0.579
            },
            "rightCorner": {
              "x": -13.417,
              "y": -0.031,
              "z": 0.579
            },
            "gtin": "4820179256581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83b8",
            "leftCorner": {
              "x": -13.416,
              "y": -0.031,
              "z": 0.579
            },
            "rightCorner": {
              "x": -13.415,
              "y": -0.2,
              "z": 0.579
            },
            "gtin": "4820179256574",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5a6",
        "height": 1.0095,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83d3",
            "leftCorner": {
              "x": -13.426,
              "y": 0.933,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.425,
              "y": 0.806,
              "z": 0.826
            },
            "gtin": "7613037683561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a184abad9b7ad469d676623e",
            "leftCorner": {
              "x": -13.466,
              "y": 1.05,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.466,
              "y": 1.022,
              "z": 0.826
            },
            "gtin": "4044983005207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b5925194a39060df0524a209",
            "leftCorner": {
              "x": -13.466,
              "y": 1.022,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.466,
              "y": 0.993,
              "z": 0.826
            },
            "gtin": "4044983005207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "222e66a8cdafa73a91fca855",
            "leftCorner": {
              "x": -13.466,
              "y": 0.993,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.465,
              "y": 0.965,
              "z": 0.826
            },
            "gtin": "4044983005207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b6bc00ee9de4220e82697c01",
            "leftCorner": {
              "x": -13.465,
              "y": 0.965,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.465,
              "y": 0.937,
              "z": 0.826
            },
            "gtin": "4044983005207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83d4",
            "leftCorner": {
              "x": -13.431,
              "y": 0.806,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.429,
              "y": 0.564,
              "z": 0.826
            },
            "gtin": "4820179257212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83d5",
            "leftCorner": {
              "x": -13.423,
              "y": 0.564,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.421,
              "y": 0.357,
              "z": 0.826
            },
            "gtin": "4820179257236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83d6",
            "leftCorner": {
              "x": -13.421,
              "y": 0.357,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.419,
              "y": 0.143,
              "z": 0.826
            },
            "gtin": "4044983005207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83d7",
            "leftCorner": {
              "x": -13.418,
              "y": 0.143,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.416,
              "y": -0.043,
              "z": 0.826
            },
            "gtin": "4044983005542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83d8",
            "leftCorner": {
              "x": -13.413,
              "y": -0.043,
              "z": 0.826
            },
            "rightCorner": {
              "x": -13.411,
              "y": -0.2,
              "z": 0.826
            },
            "gtin": "4044983005184",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5a8",
        "height": 1.3124,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d837a",
            "leftCorner": {
              "x": -13.427,
              "y": 0.984,
              "z": 1.074
            },
            "rightCorner": {
              "x": -13.426,
              "y": 0.78,
              "z": 1.074
            },
            "gtin": "4008100153301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d837b",
            "leftCorner": {
              "x": -13.424,
              "y": 0.78,
              "z": 1.074
            },
            "rightCorner": {
              "x": -13.422,
              "y": 0.501,
              "z": 1.074
            },
            "gtin": "4008100153516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d837c",
            "leftCorner": {
              "x": -13.422,
              "y": 0.501,
              "z": 1.074
            },
            "rightCorner": {
              "x": -13.42,
              "y": 0.322,
              "z": 1.074
            },
            "gtin": "4008100153509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d837d",
            "leftCorner": {
              "x": -13.418,
              "y": 0.322,
              "z": 1.074
            },
            "rightCorner": {
              "x": -13.417,
              "y": 0.116,
              "z": 1.074
            },
            "gtin": "4003399017044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d837e",
            "leftCorner": {
              "x": -13.417,
              "y": 0.116,
              "z": 1.074
            },
            "rightCorner": {
              "x": -13.415,
              "y": -0.09,
              "z": 1.074
            },
            "gtin": "4003399017044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d837f",
            "leftCorner": {
              "x": -13.415,
              "y": -0.09,
              "z": 1.074
            },
            "rightCorner": {
              "x": -13.415,
              "y": -0.267,
              "z": 1.074
            },
            "gtin": "4008585102535",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5a5",
        "height": 1.6125,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83f8",
            "leftCorner": {
              "x": -13.424,
              "y": 0.927,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.421,
              "y": 0.727,
              "z": 1.319
            },
            "gtin": "4002359018671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9915f4266c40bc81c56d636a",
            "leftCorner": {
              "x": -13.464,
              "y": 1.05,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.463,
              "y": 0.973,
              "z": 1.319
            },
            "gtin": "4008585103204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83f9",
            "leftCorner": {
              "x": -13.419,
              "y": 0.727,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.418,
              "y": 0.513,
              "z": 1.319
            },
            "gtin": "4016900416090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83fa",
            "leftCorner": {
              "x": -13.421,
              "y": 0.513,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.42,
              "y": 0.361,
              "z": 1.319
            },
            "gtin": "4016900418087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83fb",
            "leftCorner": {
              "x": -13.419,
              "y": 0.361,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.417,
              "y": 0.196,
              "z": 1.319
            },
            "gtin": "4016900418025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83fc",
            "leftCorner": {
              "x": -13.417,
              "y": 0.196,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.417,
              "y": 0.02,
              "z": 1.319
            },
            "gtin": "4016900416083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83fd",
            "leftCorner": {
              "x": -13.41,
              "y": 0.02,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.409,
              "y": -0.132,
              "z": 1.319
            },
            "gtin": "4008585103228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83fe",
            "leftCorner": {
              "x": -13.408,
              "y": -0.132,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.407,
              "y": -0.271,
              "z": 1.319
            },
            "gtin": "4008585103204",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "776",
    "rightNeighborShelfId": "778"
  },
  {
    "id": "778",
    "name": "778",
    "x": -13.419,
    "y": -0.2,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70431,
      "w": 0.70989
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 49
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5af",
        "height": 0.1772,
        "facings": [
          {
            "id": "cec75d3047355e8e21662392",
            "leftCorner": {
              "x": -13.494,
              "y": -0.201,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.493,
              "y": -0.295,
              "z": 0.145
            },
            "gtin": "4008585103464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "91d031e10d4c6da9b9b744bd",
            "leftCorner": {
              "x": -13.493,
              "y": -0.295,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.493,
              "y": -0.321,
              "z": 0.145
            },
            "gtin": "4006276028843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e16ac43e361c369d77817a4c",
            "leftCorner": {
              "x": -13.493,
              "y": -0.321,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.492,
              "y": -0.411,
              "z": 0.145
            },
            "gtin": "4006276094664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1e8faab18e38d7870550f9db",
            "leftCorner": {
              "x": -13.492,
              "y": -0.411,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.492,
              "y": -0.505,
              "z": 0.145
            },
            "gtin": "4008585103464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9da77849699e647d3816f625",
            "leftCorner": {
              "x": -13.492,
              "y": -0.505,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.491,
              "y": -0.626,
              "z": 0.145
            },
            "gtin": "4006276094466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7d156965511d9365a01596a8",
            "leftCorner": {
              "x": -13.491,
              "y": -0.626,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.49,
              "y": -0.749,
              "z": 0.145
            },
            "gtin": "4006276022049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "afff4888040ff00f1ea4dfb0",
            "leftCorner": {
              "x": -13.49,
              "y": -0.749,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.489,
              "y": -0.886,
              "z": 0.145
            },
            "gtin": "4012860008399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7d9238fba2127133e036dfbd",
            "leftCorner": {
              "x": -13.489,
              "y": -0.886,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.488,
              "y": -1.024,
              "z": 0.145
            },
            "gtin": "3083681165371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d24ddeea0b7c38321a2c66e6",
            "leftCorner": {
              "x": -13.488,
              "y": -1.024,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.486,
              "y": -1.171,
              "z": 0.145
            },
            "gtin": "4008585103211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9c058427309ce8bbcc1134e0",
            "leftCorner": {
              "x": -13.486,
              "y": -1.171,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.484,
              "y": -1.434,
              "z": 0.145
            },
            "gtin": "4000503410401",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5ae",
        "height": 0.40168,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83a3",
            "leftCorner": {
              "x": -13.397,
              "y": -0.422,
              "z": 0.329
            },
            "rightCorner": {
              "x": -13.395,
              "y": -0.737,
              "z": 0.329
            },
            "gtin": "4000503410401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d22b1500128db91bd032056c",
            "leftCorner": {
              "x": -13.448,
              "y": -0.2,
              "z": 0.329
            },
            "rightCorner": {
              "x": -13.446,
              "y": -0.401,
              "z": 0.329
            },
            "gtin": "4003339000013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83a4",
            "leftCorner": {
              "x": -13.398,
              "y": -0.737,
              "z": 0.329
            },
            "rightCorner": {
              "x": -13.395,
              "y": -1.081,
              "z": 0.329
            },
            "gtin": "4003339000020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83a5",
            "leftCorner": {
              "x": -13.408,
              "y": -1.081,
              "z": 0.329
            },
            "rightCorner": {
              "x": -13.407,
              "y": -1.292,
              "z": 0.329
            },
            "gtin": "4003339000013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83a6",
            "leftCorner": {
              "x": -13.411,
              "y": -1.292,
              "z": 0.329
            },
            "rightCorner": {
              "x": -13.409,
              "y": -1.45,
              "z": 0.329
            },
            "gtin": "4306188036210",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5aa",
        "height": 0.69943,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83bb",
            "leftCorner": {
              "x": -13.403,
              "y": -0.414,
              "z": 0.572
            },
            "rightCorner": {
              "x": -13.402,
              "y": -0.543,
              "z": 0.572
            },
            "gtin": "4012860008399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "afe834e788e6a09e5d43f6d6",
            "leftCorner": {
              "x": -13.448,
              "y": -0.2,
              "z": 0.572
            },
            "rightCorner": {
              "x": -13.447,
              "y": -0.361,
              "z": 0.572
            },
            "gtin": "4006276029000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fb35c7210cd5f4ec4cd9fd93",
            "leftCorner": {
              "x": -13.447,
              "y": -0.361,
              "z": 0.572
            },
            "rightCorner": {
              "x": -13.447,
              "y": -0.388,
              "z": 0.572
            },
            "gtin": "4006276028843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "80b32dcec6e69d1dd004f5f2",
            "leftCorner": {
              "x": -13.447,
              "y": -0.388,
              "z": 0.572
            },
            "rightCorner": {
              "x": -13.446,
              "y": -0.414,
              "z": 0.572
            },
            "gtin": "4006276028843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83bc",
            "leftCorner": {
              "x": -13.404,
              "y": -0.543,
              "z": 0.572
            },
            "rightCorner": {
              "x": -13.404,
              "y": -0.704,
              "z": 0.572
            },
            "gtin": "4006276022360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83bd",
            "leftCorner": {
              "x": -13.405,
              "y": -0.704,
              "z": 0.572
            },
            "rightCorner": {
              "x": -13.404,
              "y": -0.812,
              "z": 0.572
            },
            "gtin": "4006276022049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83be",
            "leftCorner": {
              "x": -13.402,
              "y": -0.812,
              "z": 0.572
            },
            "rightCorner": {
              "x": -13.4,
              "y": -1.037,
              "z": 0.572
            },
            "gtin": "4006276088168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83bf",
            "leftCorner": {
              "x": -13.405,
              "y": -1.037,
              "z": 0.572
            },
            "rightCorner": {
              "x": -13.404,
              "y": -1.206,
              "z": 0.572
            },
            "gtin": "4006276029000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83c0",
            "leftCorner": {
              "x": -13.416,
              "y": -1.206,
              "z": 0.572
            },
            "rightCorner": {
              "x": -13.414,
              "y": -1.338,
              "z": 0.572
            },
            "gtin": "4006276094466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83c1",
            "leftCorner": {
              "x": -13.417,
              "y": -1.338,
              "z": 0.572
            },
            "rightCorner": {
              "x": -13.417,
              "y": -1.431,
              "z": 0.572
            },
            "gtin": "4006276094664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83c2",
            "leftCorner": {
              "x": -13.421,
              "y": -1.431,
              "z": 0.572
            },
            "rightCorner": {
              "x": -13.42,
              "y": -1.541,
              "z": 0.572
            },
            "gtin": "4006276028843",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5ac",
        "height": 1.0052,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83d9",
            "leftCorner": {
              "x": -13.401,
              "y": -0.2,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.401,
              "y": -0.228,
              "z": 0.822
            },
            "gtin": "4044983005221",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d83da",
            "leftCorner": {
              "x": -13.406,
              "y": -0.228,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.404,
              "y": -0.425,
              "z": 0.822
            },
            "gtin": "4044983005221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83db",
            "leftCorner": {
              "x": -13.402,
              "y": -0.425,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.401,
              "y": -0.597,
              "z": 0.822
            },
            "gtin": "4044983005030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83dc",
            "leftCorner": {
              "x": -13.402,
              "y": -0.597,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.4,
              "y": -0.792,
              "z": 0.822
            },
            "gtin": "4044983005016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83dd",
            "leftCorner": {
              "x": -13.4,
              "y": -0.792,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.4,
              "y": -0.982,
              "z": 0.822
            },
            "gtin": "4044983005061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83de",
            "leftCorner": {
              "x": -13.406,
              "y": -0.982,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.403,
              "y": -1.195,
              "z": 0.822
            },
            "gtin": "4044983005702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83df",
            "leftCorner": {
              "x": -13.417,
              "y": -1.195,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.415,
              "y": -1.465,
              "z": 0.822
            },
            "gtin": "4002473962355",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5ad",
        "height": 1.3094,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8380",
            "leftCorner": {
              "x": -13.407,
              "y": -0.267,
              "z": 1.071
            },
            "rightCorner": {
              "x": -13.406,
              "y": -0.455,
              "z": 1.071
            },
            "gtin": "4008585102474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "675d7e75b2678195fabb5888",
            "leftCorner": {
              "x": -13.452,
              "y": -0.2,
              "z": 1.071
            },
            "rightCorner": {
              "x": -13.452,
              "y": -0.259,
              "z": 1.071
            },
            "gtin": "3083681040517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e92bc9212cbd82e47487f50d",
            "leftCorner": {
              "x": -13.444,
              "y": -1.167,
              "z": 1.071
            },
            "rightCorner": {
              "x": -13.444,
              "y": -1.238,
              "z": 1.071
            },
            "gtin": "3083681040517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8381",
            "leftCorner": {
              "x": -13.41,
              "y": -0.455,
              "z": 1.071
            },
            "rightCorner": {
              "x": -13.409,
              "y": -0.657,
              "z": 1.071
            },
            "gtin": "4008585102375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8382",
            "leftCorner": {
              "x": -13.409,
              "y": -0.657,
              "z": 1.071
            },
            "rightCorner": {
              "x": -13.407,
              "y": -0.819,
              "z": 1.071
            },
            "gtin": "4008585102511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8383",
            "leftCorner": {
              "x": -13.4,
              "y": -0.819,
              "z": 1.071
            },
            "rightCorner": {
              "x": -13.399,
              "y": -1.019,
              "z": 1.071
            },
            "gtin": "4044983005726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8384",
            "leftCorner": {
              "x": -13.403,
              "y": -1.019,
              "z": 1.071
            },
            "rightCorner": {
              "x": -13.402,
              "y": -1.167,
              "z": 1.071
            },
            "gtin": "4044983005573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8386",
            "leftCorner": {
              "x": -13.413,
              "y": -1.243,
              "z": 1.071
            },
            "rightCorner": {
              "x": -13.412,
              "y": -1.4,
              "z": 1.071
            },
            "gtin": "3083681165371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8387",
            "leftCorner": {
              "x": -13.413,
              "y": -1.4,
              "z": 1.071
            },
            "rightCorner": {
              "x": -13.412,
              "y": -1.45,
              "z": 1.071
            },
            "gtin": "3083681040517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8388",
            "leftCorner": {
              "x": -13.422,
              "y": -1.458,
              "z": 1.065
            },
            "rightCorner": {
              "x": -13.421,
              "y": -1.602,
              "z": 1.065
            },
            "gtin": "3083681040517",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5ab",
        "height": 1.6037,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83ff",
            "leftCorner": {
              "x": -13.403,
              "y": -0.271,
              "z": 1.312
            },
            "rightCorner": {
              "x": -13.401,
              "y": -0.424,
              "z": 1.312
            },
            "gtin": "4008585103211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8400",
            "leftCorner": {
              "x": -13.402,
              "y": -0.424,
              "z": 1.312
            },
            "rightCorner": {
              "x": -13.401,
              "y": -0.572,
              "z": 1.312
            },
            "gtin": "4002473807458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8401",
            "leftCorner": {
              "x": -13.404,
              "y": -0.572,
              "z": 1.312
            },
            "rightCorner": {
              "x": -13.403,
              "y": -0.739,
              "z": 1.312
            },
            "gtin": "4002473863454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8402",
            "leftCorner": {
              "x": -13.405,
              "y": -0.739,
              "z": 1.312
            },
            "rightCorner": {
              "x": -13.404,
              "y": -0.883,
              "z": 1.312
            },
            "gtin": "4002473808455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8403",
            "leftCorner": {
              "x": -13.406,
              "y": -0.883,
              "z": 1.312
            },
            "rightCorner": {
              "x": -13.405,
              "y": -1.041,
              "z": 1.312
            },
            "gtin": "4002473832450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8404",
            "leftCorner": {
              "x": -13.407,
              "y": -1.041,
              "z": 1.312
            },
            "rightCorner": {
              "x": -13.406,
              "y": -1.206,
              "z": 1.312
            },
            "gtin": "4002473860453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8405",
            "leftCorner": {
              "x": -13.419,
              "y": -1.206,
              "z": 1.312
            },
            "rightCorner": {
              "x": -13.416,
              "y": -1.523,
              "z": 1.312
            },
            "gtin": "4002473859457",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "777",
    "rightNeighborShelfId": "77b"
  },
  {
    "id": "77b",
    "name": "77b",
    "x": -13.409,
    "y": -1.45,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70431,
      "w": 0.70989
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 50
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5b6",
        "height": 0.16502,
        "facings": [
          {
            "id": "80aa0037b58943ad4fb26302",
            "leftCorner": {
              "x": -13.487,
              "y": -1.451,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.486,
              "y": -1.517,
              "z": 0.135
            },
            "gtin": "4104420205444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "05d80c7e3aa89c65336de1ae",
            "leftCorner": {
              "x": -13.486,
              "y": -1.517,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.486,
              "y": -1.583,
              "z": 0.135
            },
            "gtin": "4104420205444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7c4d8f31b6b08b1cdc6e02d1",
            "leftCorner": {
              "x": -13.486,
              "y": -1.583,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.485,
              "y": -1.658,
              "z": 0.135
            },
            "gtin": "4037300108491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "35e7b27527b0754635a2190e",
            "leftCorner": {
              "x": -13.485,
              "y": -1.658,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.485,
              "y": -1.764,
              "z": 0.135
            },
            "gtin": "4002473961457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "968bd7517dae1cc60c7db683",
            "leftCorner": {
              "x": -13.485,
              "y": -1.764,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.484,
              "y": -1.886,
              "z": 0.135
            },
            "gtin": "4104420129702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4e729a72b10b8c2e97906c5f",
            "leftCorner": {
              "x": -13.484,
              "y": -1.886,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.483,
              "y": -2.017,
              "z": 0.135
            },
            "gtin": "4002473960351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "035ffda17ea1f8e35b67087e",
            "leftCorner": {
              "x": -13.483,
              "y": -2.017,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.481,
              "y": -2.169,
              "z": 0.135
            },
            "gtin": "4002473967459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b346bf3cfb71ec3d7950619d",
            "leftCorner": {
              "x": -13.481,
              "y": -2.169,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.48,
              "y": -2.338,
              "z": 0.135
            },
            "gtin": "4002473964359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8c100da3b21ccfbf693af36e",
            "leftCorner": {
              "x": -13.48,
              "y": -2.338,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.479,
              "y": -2.511,
              "z": 0.135
            },
            "gtin": "4306188020691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d7af6a79c066cbefdc16408f",
            "leftCorner": {
              "x": -13.479,
              "y": -2.511,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.477,
              "y": -2.691,
              "z": 0.135
            },
            "gtin": "4037300104462",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5b4",
        "height": 0.39674,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83a7",
            "leftCorner": {
              "x": -13.422,
              "y": -1.45,
              "z": 0.325
            },
            "rightCorner": {
              "x": -13.418,
              "y": -1.563,
              "z": 0.325
            },
            "gtin": "4306188020660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83a8",
            "leftCorner": {
              "x": -13.418,
              "y": -1.563,
              "z": 0.325
            },
            "rightCorner": {
              "x": -13.413,
              "y": -1.675,
              "z": 0.325
            },
            "gtin": "4306188020660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83a9",
            "leftCorner": {
              "x": -13.413,
              "y": -1.675,
              "z": 0.325
            },
            "rightCorner": {
              "x": -13.409,
              "y": -1.788,
              "z": 0.325
            },
            "gtin": "4306188020660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83aa",
            "leftCorner": {
              "x": -13.408,
              "y": -1.788,
              "z": 0.325
            },
            "rightCorner": {
              "x": -13.405,
              "y": -2.13,
              "z": 0.325
            },
            "gtin": "4306188020660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83ab",
            "leftCorner": {
              "x": -13.403,
              "y": -2.13,
              "z": 0.325
            },
            "rightCorner": {
              "x": -13.402,
              "y": -2.303,
              "z": 0.325
            },
            "gtin": "4306188020691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83ac",
            "leftCorner": {
              "x": -13.403,
              "y": -2.303,
              "z": 0.325
            },
            "rightCorner": {
              "x": -13.402,
              "y": -2.501,
              "z": 0.325
            },
            "gtin": "4306188020721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8396",
            "leftCorner": {
              "x": -13.405,
              "y": -2.501,
              "z": 0.325
            },
            "rightCorner": {
              "x": -13.403,
              "y": -2.7,
              "z": 0.325
            },
            "gtin": "4306188040194",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5b2",
        "height": 0.69509,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83c4",
            "leftCorner": {
              "x": -13.413,
              "y": -1.745,
              "z": 0.569
            },
            "rightCorner": {
              "x": -13.412,
              "y": -1.938,
              "z": 0.569
            },
            "gtin": "4002473943354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8f677413a0d5c61c95bba7fe",
            "leftCorner": {
              "x": -13.456,
              "y": -1.45,
              "z": 0.569
            },
            "rightCorner": {
              "x": -13.454,
              "y": -1.664,
              "z": 0.569
            },
            "gtin": "4002473961358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1bebf3d9f7cdde5267f8972c",
            "leftCorner": {
              "x": -13.454,
              "y": -1.664,
              "z": 0.569
            },
            "rightCorner": {
              "x": -13.454,
              "y": -1.731,
              "z": 0.569
            },
            "gtin": "4104420205444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83c5",
            "leftCorner": {
              "x": -13.411,
              "y": -1.938,
              "z": 0.569
            },
            "rightCorner": {
              "x": -13.408,
              "y": -2.161,
              "z": 0.569
            },
            "gtin": "4002473961358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83c6",
            "leftCorner": {
              "x": -13.407,
              "y": -2.161,
              "z": 0.569
            },
            "rightCorner": {
              "x": -13.406,
              "y": -2.328,
              "z": 0.569
            },
            "gtin": "4002473964359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83c7",
            "leftCorner": {
              "x": -13.41,
              "y": -2.329,
              "z": 0.569
            },
            "rightCorner": {
              "x": -13.41,
              "y": -2.425,
              "z": 0.569
            },
            "gtin": "5000157062673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83c8",
            "leftCorner": {
              "x": -13.41,
              "y": -2.425,
              "z": 0.569
            },
            "rightCorner": {
              "x": -13.409,
              "y": -2.522,
              "z": 0.569
            },
            "gtin": "5000157062673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83c9",
            "leftCorner": {
              "x": -13.409,
              "y": -2.522,
              "z": 0.569
            },
            "rightCorner": {
              "x": -13.407,
              "y": -2.65,
              "z": 0.569
            },
            "gtin": "4104420129702",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5b5",
        "height": 0.9978,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83e0",
            "leftCorner": {
              "x": -13.419,
              "y": -1.465,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.416,
              "y": -1.853,
              "z": 0.816
            },
            "gtin": "4002473960351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d9959daea28b797ba3230d83",
            "leftCorner": {
              "x": -13.458,
              "y": -1.45,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.458,
              "y": -1.453,
              "z": 0.816
            },
            "gtin": "4037300104370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "11f4c4721a3c234d7f74bdf7",
            "leftCorner": {
              "x": -13.458,
              "y": -1.453,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.458,
              "y": -1.455,
              "z": 0.816
            },
            "gtin": "4037300104370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e53b7c4d3f53a97c5aada7ea",
            "leftCorner": {
              "x": -13.458,
              "y": -1.455,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.458,
              "y": -1.458,
              "z": 0.816
            },
            "gtin": "4037300104370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a12b78d44ee5f69de661cae9",
            "leftCorner": {
              "x": -13.458,
              "y": -1.458,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.458,
              "y": -1.46,
              "z": 0.816
            },
            "gtin": "4037300104370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "efde9d1cc21d6f4534ec1159",
            "leftCorner": {
              "x": -13.458,
              "y": -1.46,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.458,
              "y": -1.462,
              "z": 0.816
            },
            "gtin": "4037300104370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83e1",
            "leftCorner": {
              "x": -13.417,
              "y": -1.853,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.416,
              "y": -1.961,
              "z": 0.816
            },
            "gtin": "4002473991355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83e2",
            "leftCorner": {
              "x": -13.416,
              "y": -1.961,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.416,
              "y": -2.068,
              "z": 0.816
            },
            "gtin": "4002473991355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83e3",
            "leftCorner": {
              "x": -13.409,
              "y": -2.068,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.408,
              "y": -2.172,
              "z": 0.816
            },
            "gtin": "4037300104455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83e4",
            "leftCorner": {
              "x": -13.408,
              "y": -2.172,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.407,
              "y": -2.277,
              "z": 0.816
            },
            "gtin": "4037300104455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83e5",
            "leftCorner": {
              "x": -13.409,
              "y": -2.277,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.408,
              "y": -2.453,
              "z": 0.816
            },
            "gtin": "4037300104462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83e6",
            "leftCorner": {
              "x": -13.413,
              "y": -2.453,
              "z": 0.816
            },
            "rightCorner": {
              "x": -13.41,
              "y": -2.722,
              "z": 0.816
            },
            "gtin": "4037300108293",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5b1",
        "height": 1.3012,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8389",
            "leftCorner": {
              "x": -13.413,
              "y": -1.594,
              "z": 1.065
            },
            "rightCorner": {
              "x": -13.41,
              "y": -1.811,
              "z": 1.065
            },
            "gtin": "4002473942357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f5aa4d7d035e6a8f343267ee",
            "leftCorner": {
              "x": -13.453,
              "y": -1.45,
              "z": 1.065
            },
            "rightCorner": {
              "x": -13.452,
              "y": -1.525,
              "z": 1.065
            },
            "gtin": "4037300108491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d838a",
            "leftCorner": {
              "x": -13.411,
              "y": -1.811,
              "z": 1.065
            },
            "rightCorner": {
              "x": -13.409,
              "y": -2.031,
              "z": 1.065
            },
            "gtin": "4002473967350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d838b",
            "leftCorner": {
              "x": -13.408,
              "y": -2.03,
              "z": 1.065
            },
            "rightCorner": {
              "x": -13.406,
              "y": -2.142,
              "z": 1.065
            },
            "gtin": "4002473966353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d838c",
            "leftCorner": {
              "x": -13.406,
              "y": -2.142,
              "z": 1.065
            },
            "rightCorner": {
              "x": -13.405,
              "y": -2.254,
              "z": 1.065
            },
            "gtin": "4002473966353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d838d",
            "leftCorner": {
              "x": -13.405,
              "y": -2.254,
              "z": 1.065
            },
            "rightCorner": {
              "x": -13.405,
              "y": -2.366,
              "z": 1.065
            },
            "gtin": "4002473966353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d838e",
            "leftCorner": {
              "x": -13.405,
              "y": -2.366,
              "z": 1.065
            },
            "rightCorner": {
              "x": -13.404,
              "y": -2.478,
              "z": 1.065
            },
            "gtin": "4002473966353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d838f",
            "leftCorner": {
              "x": -13.409,
              "y": -2.478,
              "z": 1.065
            },
            "rightCorner": {
              "x": -13.407,
              "y": -2.733,
              "z": 1.065
            },
            "gtin": "4037300108491",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5b3",
        "height": 1.6012,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8406",
            "leftCorner": {
              "x": -13.422,
              "y": -1.523,
              "z": 1.31
            },
            "rightCorner": {
              "x": -13.42,
              "y": -1.803,
              "z": 1.31
            },
            "gtin": "4002473960450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8407",
            "leftCorner": {
              "x": -13.417,
              "y": -1.803,
              "z": 1.31
            },
            "rightCorner": {
              "x": -13.414,
              "y": -2.14,
              "z": 1.31
            },
            "gtin": "4002473804457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8408",
            "leftCorner": {
              "x": -13.411,
              "y": -2.14,
              "z": 1.31
            },
            "rightCorner": {
              "x": -13.409,
              "y": -2.449,
              "z": 1.31
            },
            "gtin": "4002473966452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8409",
            "leftCorner": {
              "x": -13.417,
              "y": -2.449,
              "z": 1.31
            },
            "rightCorner": {
              "x": -13.415,
              "y": -2.611,
              "z": 1.31
            },
            "gtin": "4002473967459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d840a",
            "leftCorner": {
              "x": -13.413,
              "y": -2.611,
              "z": 1.31
            },
            "rightCorner": {
              "x": -13.413,
              "y": -2.754,
              "z": 1.31
            },
            "gtin": "4002473961457",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "778",
    "rightNeighborShelfId": "77c"
  },
  {
    "id": "77c",
    "name": "77c",
    "x": -13.399,
    "y": -2.7,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70431,
      "w": 0.70989
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5d6",
        "height": 0.1149,
        "facings": [
          {
            "id": "8e867487a52a119fc3880dbf",
            "leftCorner": {
              "x": -13.222,
              "y": -2.699,
              "z": 0.094
            },
            "rightCorner": {
              "x": -13.221,
              "y": -2.79,
              "z": 0.094
            },
            "gtin": "4104420256910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2e43b91a8df3b68a4058af5c",
            "leftCorner": {
              "x": -13.221,
              "y": -2.79,
              "z": 0.094
            },
            "rightCorner": {
              "x": -13.221,
              "y": -2.884,
              "z": 0.094
            },
            "gtin": "4037300103328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "70e06f42a4870d23ab59e081",
            "leftCorner": {
              "x": -13.221,
              "y": -2.884,
              "z": 0.094
            },
            "rightCorner": {
              "x": -13.22,
              "y": -2.993,
              "z": 0.094
            },
            "gtin": "4104420139749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "60172440d18a2e13cfc29a05",
            "leftCorner": {
              "x": -13.22,
              "y": -2.993,
              "z": 0.094
            },
            "rightCorner": {
              "x": -13.219,
              "y": -3.106,
              "z": 0.094
            },
            "gtin": "4104420020504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2ab205ac85b3b5d70d4f355b",
            "leftCorner": {
              "x": -13.219,
              "y": -3.106,
              "z": 0.094
            },
            "rightCorner": {
              "x": -13.218,
              "y": -3.247,
              "z": 0.094
            },
            "gtin": "4037300104356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "34b91ec8b4cb98eda3b19c56",
            "leftCorner": {
              "x": -13.218,
              "y": -3.247,
              "z": 0.094
            },
            "rightCorner": {
              "x": -13.216,
              "y": -3.395,
              "z": 0.094
            },
            "gtin": "4037300103243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "872921e416f9b3701008d2f0",
            "leftCorner": {
              "x": -13.216,
              "y": -3.395,
              "z": 0.094
            },
            "rightCorner": {
              "x": -13.215,
              "y": -3.548,
              "z": 0.094
            },
            "gtin": "4037300103236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b3c582f5bf6c31c98cc55ca0",
            "leftCorner": {
              "x": -13.215,
              "y": -3.548,
              "z": 0.094
            },
            "rightCorner": {
              "x": -13.214,
              "y": -3.696,
              "z": 0.094
            },
            "gtin": "4037300103243",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5d4",
        "height": 0.41386,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d84d2",
            "leftCorner": {
              "x": -13.458,
              "y": -2.7,
              "z": 0.339
            },
            "rightCorner": {
              "x": -13.457,
              "y": -2.814,
              "z": 0.339
            },
            "gtin": "4306188036678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84d3",
            "leftCorner": {
              "x": -13.457,
              "y": -2.814,
              "z": 0.339
            },
            "rightCorner": {
              "x": -13.457,
              "y": -2.927,
              "z": 0.339
            },
            "gtin": "4306188036678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84d4",
            "leftCorner": {
              "x": -13.457,
              "y": -2.927,
              "z": 0.339
            },
            "rightCorner": {
              "x": -13.456,
              "y": -3.04,
              "z": 0.339
            },
            "gtin": "4306188036678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84d7",
            "leftCorner": {
              "x": -13.416,
              "y": -3.039,
              "z": 0.339
            },
            "rightCorner": {
              "x": -13.414,
              "y": -3.225,
              "z": 0.339
            },
            "gtin": "4306188040217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84d5",
            "leftCorner": {
              "x": -13.414,
              "y": -3.225,
              "z": 0.339
            },
            "rightCorner": {
              "x": -13.412,
              "y": -3.462,
              "z": 0.339
            },
            "gtin": "4250426226997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84d6",
            "leftCorner": {
              "x": -13.412,
              "y": -3.462,
              "z": 0.339
            },
            "rightCorner": {
              "x": -13.41,
              "y": -3.7,
              "z": 0.339
            },
            "gtin": "4250426226997",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5d0",
        "height": 0.7123,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d84cb",
            "leftCorner": {
              "x": -13.456,
              "y": -2.7,
              "z": 0.583
            },
            "rightCorner": {
              "x": -13.454,
              "y": -2.961,
              "z": 0.583
            },
            "gtin": "4104420205482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84cd",
            "leftCorner": {
              "x": -13.418,
              "y": -2.961,
              "z": 0.583
            },
            "rightCorner": {
              "x": -13.417,
              "y": -3.056,
              "z": 0.583
            },
            "gtin": "4104420256910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84ce",
            "leftCorner": {
              "x": -13.419,
              "y": -3.056,
              "z": 0.583
            },
            "rightCorner": {
              "x": -13.418,
              "y": -3.174,
              "z": 0.583
            },
            "gtin": "4104420142282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84cf",
            "leftCorner": {
              "x": -13.418,
              "y": -3.174,
              "z": 0.583
            },
            "rightCorner": {
              "x": -13.416,
              "y": -3.292,
              "z": 0.583
            },
            "gtin": "4104420142282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84d0",
            "leftCorner": {
              "x": -13.404,
              "y": -3.292,
              "z": 0.583
            },
            "rightCorner": {
              "x": -13.404,
              "y": -3.412,
              "z": 0.583
            },
            "gtin": "4104420020504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84d1",
            "leftCorner": {
              "x": -13.407,
              "y": -3.412,
              "z": 0.583
            },
            "rightCorner": {
              "x": -13.405,
              "y": -3.579,
              "z": 0.583
            },
            "gtin": "4104420020429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84cc",
            "leftCorner": {
              "x": -13.395,
              "y": -3.579,
              "z": 0.583
            },
            "rightCorner": {
              "x": -13.393,
              "y": -3.7,
              "z": 0.583
            },
            "gtin": "4104420139749",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5d2",
        "height": 1.0041,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d83e7",
            "leftCorner": {
              "x": -13.413,
              "y": -2.722,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.412,
              "y": -2.877,
              "z": 0.822
            },
            "gtin": "4037300104370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83e8",
            "leftCorner": {
              "x": -13.413,
              "y": -2.877,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.412,
              "y": -3.091,
              "z": 0.822
            },
            "gtin": "4037300108231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83e9",
            "leftCorner": {
              "x": -13.406,
              "y": -3.091,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.405,
              "y": -3.28,
              "z": 0.822
            },
            "gtin": "4037300108460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83ea",
            "leftCorner": {
              "x": -13.398,
              "y": -3.28,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.397,
              "y": -3.398,
              "z": 0.822
            },
            "gtin": "4037300108255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83eb",
            "leftCorner": {
              "x": -13.397,
              "y": -3.398,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.396,
              "y": -3.516,
              "z": 0.822
            },
            "gtin": "4037300108255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83cb",
            "leftCorner": {
              "x": -13.385,
              "y": -3.516,
              "z": 0.822
            },
            "rightCorner": {
              "x": -13.383,
              "y": -3.7,
              "z": 0.822
            },
            "gtin": "4037300104523",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5d1",
        "height": 1.3071,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8390",
            "leftCorner": {
              "x": -13.413,
              "y": -2.733,
              "z": 1.069
            },
            "rightCorner": {
              "x": -13.411,
              "y": -2.878,
              "z": 1.069
            },
            "gtin": "4037300108217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8391",
            "leftCorner": {
              "x": -13.411,
              "y": -2.878,
              "z": 1.069
            },
            "rightCorner": {
              "x": -13.41,
              "y": -3.096,
              "z": 1.069
            },
            "gtin": "4037300108248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8392",
            "leftCorner": {
              "x": -13.405,
              "y": -3.096,
              "z": 1.069
            },
            "rightCorner": {
              "x": -13.403,
              "y": -3.273,
              "z": 1.069
            },
            "gtin": "4037300108309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8393",
            "leftCorner": {
              "x": -13.396,
              "y": -3.273,
              "z": 1.069
            },
            "rightCorner": {
              "x": -13.396,
              "y": -3.405,
              "z": 1.069
            },
            "gtin": "4037300104387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8394",
            "leftCorner": {
              "x": -13.396,
              "y": -3.405,
              "z": 1.069
            },
            "rightCorner": {
              "x": -13.395,
              "y": -3.536,
              "z": 1.069
            },
            "gtin": "4037300104387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8373",
            "leftCorner": {
              "x": -13.388,
              "y": -3.536,
              "z": 1.069
            },
            "rightCorner": {
              "x": -13.387,
              "y": -3.7,
              "z": 1.069
            },
            "gtin": "4037300104356",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5d3",
        "height": 1.6095,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d840b",
            "leftCorner": {
              "x": -13.42,
              "y": -2.754,
              "z": 1.317
            },
            "rightCorner": {
              "x": -13.419,
              "y": -2.957,
              "z": 1.317
            },
            "gtin": "4037300107340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d840c",
            "leftCorner": {
              "x": -13.415,
              "y": -2.957,
              "z": 1.317
            },
            "rightCorner": {
              "x": -13.413,
              "y": -3.117,
              "z": 1.317
            },
            "gtin": "4037300103243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d840d",
            "leftCorner": {
              "x": -13.41,
              "y": -3.117,
              "z": 1.317
            },
            "rightCorner": {
              "x": -13.408,
              "y": -3.266,
              "z": 1.317
            },
            "gtin": "4037300103236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d840e",
            "leftCorner": {
              "x": -13.401,
              "y": -3.266,
              "z": 1.317
            },
            "rightCorner": {
              "x": -13.4,
              "y": -3.414,
              "z": 1.317
            },
            "gtin": "4037300103373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d840f",
            "leftCorner": {
              "x": -13.384,
              "y": -3.414,
              "z": 1.317
            },
            "rightCorner": {
              "x": -13.382,
              "y": -3.591,
              "z": 1.317
            },
            "gtin": "4037300103496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d83ed",
            "leftCorner": {
              "x": -13.388,
              "y": -3.591,
              "z": 1.317
            },
            "rightCorner": {
              "x": -13.387,
              "y": -3.7,
              "z": 1.317
            },
            "gtin": "4037300103328",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "77b"
  },
  {
    "id": "77d",
    "name": "77d",
    "x": -12.144,
    "y": -3.735,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71001,
      "w": 0.70419
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5dc",
        "height": 0.16926,
        "facings": [
          {
            "id": "47dece1d366c7aab927e4c83",
            "leftCorner": {
              "x": -12.187,
              "y": -3.735,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.188,
              "y": -3.623,
              "z": 0.138
            },
            "gtin": "9001458110946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6a61a9ef7e6f1752d88d8ab7",
            "leftCorner": {
              "x": -12.188,
              "y": -3.623,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.189,
              "y": -3.509,
              "z": 0.138
            }
          },
          {
            "id": "ef33d56b6b6b73a7b6937668",
            "leftCorner": {
              "x": -12.189,
              "y": -3.509,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.19,
              "y": -3.393,
              "z": 0.138
            },
            "gtin": "4004899004077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c9c7b5fc9c43e915a3a197c0",
            "leftCorner": {
              "x": -12.19,
              "y": -3.393,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.191,
              "y": -3.275,
              "z": 0.138
            },
            "gtin": "4002442815668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7561e2f53592a0b1683632c1",
            "leftCorner": {
              "x": -12.191,
              "y": -3.275,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.192,
              "y": -3.149,
              "z": 0.138
            },
            "gtin": "4260176720461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ab2cfb60dba1b44db00239ff",
            "leftCorner": {
              "x": -12.192,
              "y": -3.149,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.193,
              "y": -3.021,
              "z": 0.138
            },
            "gtin": "9001458110984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "67be274911dfa9a655378218",
            "leftCorner": {
              "x": -12.193,
              "y": -3.021,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.194,
              "y": -2.891,
              "z": 0.138
            },
            "gtin": "4306188381907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0c4846837be3f2c9f9ce611c",
            "leftCorner": {
              "x": -12.194,
              "y": -2.891,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.195,
              "y": -2.739,
              "z": 0.138
            }
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5d7",
        "height": 0.41496,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d84da",
            "leftCorner": {
              "x": -12.214,
              "y": -3.736,
              "z": 0.34
            },
            "rightCorner": {
              "x": -12.216,
              "y": -3.416,
              "z": 0.34
            }
          },
          {
            "id": "68d8e50ee1820c81800d84dc",
            "leftCorner": {
              "x": -12.255,
              "y": -3.417,
              "z": 0.34
            },
            "rightCorner": {
              "x": -12.256,
              "y": -3.24,
              "z": 0.34
            }
          },
          {
            "id": "68d8e50ee1820c81800d84dd",
            "leftCorner": {
              "x": -12.265,
              "y": -3.24,
              "z": 0.34
            },
            "rightCorner": {
              "x": -12.267,
              "y": -3.041,
              "z": 0.34
            },
            "gtin": "9001458100947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84db",
            "leftCorner": {
              "x": -12.258,
              "y": -3.041,
              "z": 0.34
            },
            "rightCorner": {
              "x": -12.261,
              "y": -2.736,
              "z": 0.34
            },
            "gtin": "4002442812452",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5da",
        "height": 0.70106,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82b1",
            "leftCorner": {
              "x": -12.219,
              "y": -3.736,
              "z": 0.574
            },
            "rightCorner": {
              "x": -12.222,
              "y": -3.447,
              "z": 0.574
            },
            "gtin": "4250426224511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82b3",
            "leftCorner": {
              "x": -12.261,
              "y": -3.447,
              "z": 0.574
            },
            "rightCorner": {
              "x": -12.262,
              "y": -3.273,
              "z": 0.574
            },
            "gtin": "9001458111448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82b4",
            "leftCorner": {
              "x": -12.268,
              "y": -3.273,
              "z": 0.574
            },
            "rightCorner": {
              "x": -12.27,
              "y": -3.015,
              "z": 0.574
            },
            "gtin": "4250426227536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82b5",
            "leftCorner": {
              "x": -12.26,
              "y": -3.015,
              "z": 0.574
            },
            "rightCorner": {
              "x": -12.261,
              "y": -2.91,
              "z": 0.574
            },
            "gtin": "4250426225815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82b6",
            "leftCorner": {
              "x": -12.261,
              "y": -2.91,
              "z": 0.574
            },
            "rightCorner": {
              "x": -12.262,
              "y": -2.806,
              "z": 0.574
            },
            "gtin": "4250426225815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82b7",
            "leftCorner": {
              "x": -12.26,
              "y": -2.806,
              "z": 0.574
            },
            "rightCorner": {
              "x": -12.262,
              "y": -2.621,
              "z": 0.574
            },
            "gtin": "4004899004077",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5db",
        "height": 1.0042,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d830c",
            "leftCorner": {
              "x": -12.22,
              "y": -3.736,
              "z": 0.822
            },
            "rightCorner": {
              "x": -12.221,
              "y": -3.576,
              "z": 0.822
            }
          },
          {
            "id": "68d8e50ee1820c81800d830d",
            "leftCorner": {
              "x": -12.221,
              "y": -3.576,
              "z": 0.822
            },
            "rightCorner": {
              "x": -12.223,
              "y": -3.417,
              "z": 0.822
            }
          },
          {
            "id": "68d8e50ee1820c81800d830f",
            "leftCorner": {
              "x": -12.262,
              "y": -3.417,
              "z": 0.822
            },
            "rightCorner": {
              "x": -12.263,
              "y": -3.228,
              "z": 0.822
            }
          },
          {
            "id": "68d8e50ee1820c81800d8310",
            "leftCorner": {
              "x": -12.272,
              "y": -3.228,
              "z": 0.822
            },
            "rightCorner": {
              "x": -12.275,
              "y": -2.922,
              "z": 0.822
            },
            "gtin": "4250426227956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8311",
            "leftCorner": {
              "x": -12.263,
              "y": -2.922,
              "z": 0.822
            },
            "rightCorner": {
              "x": -12.265,
              "y": -2.651,
              "z": 0.822
            },
            "gtin": "4306188381907",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5d8",
        "height": 1.3106,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82ed",
            "leftCorner": {
              "x": -12.216,
              "y": -3.736,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.217,
              "y": -3.616,
              "z": 1.072
            }
          },
          {
            "id": "68d8e50ee1820c81800d82ee",
            "leftCorner": {
              "x": -12.217,
              "y": -3.616,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.218,
              "y": -3.496,
              "z": 1.072
            }
          },
          {
            "id": "68d8e50ee1820c81800d82f0",
            "leftCorner": {
              "x": -12.258,
              "y": -3.496,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.258,
              "y": -3.335,
              "z": 1.072
            },
            "gtin": "9001458110984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82f1",
            "leftCorner": {
              "x": -12.255,
              "y": -3.335,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.257,
              "y": -3.207,
              "z": 1.072
            },
            "gtin": "9001458110946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82f2",
            "leftCorner": {
              "x": -12.264,
              "y": -3.207,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.266,
              "y": -2.967,
              "z": 1.072
            }
          },
          {
            "id": "68d8e50ee1820c81800d82f3",
            "leftCorner": {
              "x": -12.26,
              "y": -2.967,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.261,
              "y": -2.781,
              "z": 1.072
            }
          },
          {
            "id": "68d8e50ee1820c81800d82f4",
            "leftCorner": {
              "x": -12.263,
              "y": -2.782,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.264,
              "y": -2.667,
              "z": 1.072
            },
            "gtin": "4002442815668",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5d9",
        "height": 1.6079,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82d1",
            "leftCorner": {
              "x": -12.217,
              "y": -3.736,
              "z": 1.316
            },
            "rightCorner": {
              "x": -12.219,
              "y": -3.462,
              "z": 1.316
            }
          },
          {
            "id": "68d8e50ee1820c81800d82d3",
            "leftCorner": {
              "x": -12.258,
              "y": -3.463,
              "z": 1.316
            },
            "rightCorner": {
              "x": -12.26,
              "y": -3.239,
              "z": 1.316
            }
          },
          {
            "id": "68d8e50ee1820c81800d82d4",
            "leftCorner": {
              "x": -12.267,
              "y": -3.239,
              "z": 1.316
            },
            "rightCorner": {
              "x": -12.269,
              "y": -3.079,
              "z": 1.316
            },
            "gtin": "9001458111233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82d5",
            "leftCorner": {
              "x": -12.262,
              "y": -3.079,
              "z": 1.316
            },
            "rightCorner": {
              "x": -12.263,
              "y": -2.95,
              "z": 1.316
            },
            "gtin": "4260176720461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82d6",
            "leftCorner": {
              "x": -12.263,
              "y": -2.95,
              "z": 1.316
            },
            "rightCorner": {
              "x": -12.265,
              "y": -2.699,
              "z": 1.316
            },
            "gtin": "4260176720447",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "77e"
  },
  {
    "id": "77e",
    "name": "77e",
    "x": -12.153,
    "y": -2.735,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71001,
      "w": 0.70419
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d583",
        "height": 0.17167,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d832e",
            "leftCorner": {
              "x": -12.083,
              "y": -2.671,
              "z": 0.14
            },
            "rightCorner": {
              "x": -12.085,
              "y": -2.292,
              "z": 0.14
            },
            "gtin": "4104420137042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7b7596d2b85d501cd0c38bb7",
            "leftCorner": {
              "x": -12.07,
              "y": -2.292,
              "z": 0.14
            },
            "rightCorner": {
              "x": -12.073,
              "y": -1.908,
              "z": 0.14
            },
            "gtin": "4104420137042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "75e8984f4f23bc81db49863c",
            "leftCorner": {
              "x": -12.073,
              "y": -1.908,
              "z": 0.14
            },
            "rightCorner": {
              "x": -12.076,
              "y": -1.523,
              "z": 0.14
            },
            "gtin": "4104420137042",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d57e",
        "height": 0.40304,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8295",
            "leftCorner": {
              "x": -12.111,
              "y": -2.735,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.112,
              "y": -2.627,
              "z": 0.33
            },
            "gtin": "4250426227574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8296",
            "leftCorner": {
              "x": -12.112,
              "y": -2.627,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.113,
              "y": -2.519,
              "z": 0.33
            },
            "gtin": "4250426227574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8298",
            "leftCorner": {
              "x": -12.153,
              "y": -2.519,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.154,
              "y": -2.362,
              "z": 0.33
            },
            "gtin": "4250426203219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8299",
            "leftCorner": {
              "x": -12.148,
              "y": -2.362,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.149,
              "y": -2.19,
              "z": 0.33
            },
            "gtin": "4250426223347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d829a",
            "leftCorner": {
              "x": -12.149,
              "y": -2.19,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.151,
              "y": -1.951,
              "z": 0.33
            },
            "gtin": "4306188039303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d829b",
            "leftCorner": {
              "x": -12.158,
              "y": -1.951,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.159,
              "y": -1.789,
              "z": 0.33
            },
            "gtin": "4104420034341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d829c",
            "leftCorner": {
              "x": -12.161,
              "y": -1.789,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.162,
              "y": -1.619,
              "z": 0.33
            },
            "gtin": "4008122021169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d829d",
            "leftCorner": {
              "x": -12.161,
              "y": -1.619,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.162,
              "y": -1.44,
              "z": 0.33
            },
            "gtin": "4002442804259",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d57f",
        "height": 0.70006,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82b8",
            "leftCorner": {
              "x": -12.143,
              "y": -2.62,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.145,
              "y": -2.39,
              "z": 0.573
            },
            "gtin": "4250426218565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "099d9aeddf6a5060a072211b",
            "leftCorner": {
              "x": -12.102,
              "y": -2.735,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.103,
              "y": -2.635,
              "z": 0.573
            },
            "gtin": "4250426223484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82b9",
            "leftCorner": {
              "x": -12.142,
              "y": -2.39,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.142,
              "y": -2.238,
              "z": 0.573
            },
            "gtin": "4250426203134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82ba",
            "leftCorner": {
              "x": -12.145,
              "y": -2.238,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.147,
              "y": -2.05,
              "z": 0.573
            },
            "gtin": "4250426223484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82bb",
            "leftCorner": {
              "x": -12.147,
              "y": -2.05,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.148,
              "y": -1.97,
              "z": 0.573
            },
            "gtin": "4250426218480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82bc",
            "leftCorner": {
              "x": -12.148,
              "y": -1.97,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.149,
              "y": -1.89,
              "z": 0.573
            },
            "gtin": "4250426218480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82bd",
            "leftCorner": {
              "x": -12.154,
              "y": -1.89,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.156,
              "y": -1.658,
              "z": 0.573
            },
            "gtin": "4012712000687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82be",
            "leftCorner": {
              "x": -12.158,
              "y": -1.658,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.159,
              "y": -1.449,
              "z": 0.573
            },
            "gtin": "4012712000885",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d582",
        "height": 1.0028,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8312",
            "leftCorner": {
              "x": -12.141,
              "y": -2.65,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.142,
              "y": -2.563,
              "z": 0.82
            },
            "gtin": "4306188381938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a90b501f49c71baab0da2972",
            "leftCorner": {
              "x": -12.106,
              "y": -2.735,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.107,
              "y": -2.665,
              "z": 0.82
            },
            "gtin": "4008122021190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8313",
            "leftCorner": {
              "x": -12.142,
              "y": -2.563,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.143,
              "y": -2.475,
              "z": 0.82
            },
            "gtin": "4306188381938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8314",
            "leftCorner": {
              "x": -12.143,
              "y": -2.475,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.143,
              "y": -2.387,
              "z": 0.82
            },
            "gtin": "4306188381938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8315",
            "leftCorner": {
              "x": -12.153,
              "y": -2.387,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.154,
              "y": -2.235,
              "z": 0.82
            },
            "gtin": "4008122023477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8316",
            "leftCorner": {
              "x": -12.146,
              "y": -2.235,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.147,
              "y": -2.083,
              "z": 0.82
            },
            "gtin": "4008122023361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8317",
            "leftCorner": {
              "x": -12.148,
              "y": -2.083,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.15,
              "y": -1.896,
              "z": 0.82
            },
            "gtin": "4008122018442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8318",
            "leftCorner": {
              "x": -12.156,
              "y": -1.896,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.158,
              "y": -1.708,
              "z": 0.82
            },
            "gtin": "4008122020971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8319",
            "leftCorner": {
              "x": -12.154,
              "y": -1.708,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.155,
              "y": -1.565,
              "z": 0.82
            },
            "gtin": "4008122017926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d831a",
            "leftCorner": {
              "x": -12.154,
              "y": -1.565,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.156,
              "y": -1.339,
              "z": 0.82
            },
            "gtin": "4008122021190",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d581",
        "height": 1.3062,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82f5",
            "leftCorner": {
              "x": -12.143,
              "y": -2.666,
              "z": 1.069
            },
            "rightCorner": {
              "x": -12.144,
              "y": -2.508,
              "z": 1.069
            }
          },
          {
            "id": "68d8e50ee1820c81800d82f6",
            "leftCorner": {
              "x": -12.149,
              "y": -2.508,
              "z": 1.069
            },
            "rightCorner": {
              "x": -12.15,
              "y": -2.322,
              "z": 1.069
            },
            "gtin": "4002442804105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82f7",
            "leftCorner": {
              "x": -12.145,
              "y": -2.322,
              "z": 1.069
            },
            "rightCorner": {
              "x": -12.147,
              "y": -2.108,
              "z": 1.069
            },
            "gtin": "4250426225389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82f8",
            "leftCorner": {
              "x": -12.149,
              "y": -2.108,
              "z": 1.069
            },
            "rightCorner": {
              "x": -12.152,
              "y": -1.771,
              "z": 1.069
            },
            "gtin": "4306188053149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82f9",
            "leftCorner": {
              "x": -12.161,
              "y": -1.771,
              "z": 1.069
            },
            "rightCorner": {
              "x": -12.162,
              "y": -1.618,
              "z": 1.069
            },
            "gtin": "4260176724124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82fa",
            "leftCorner": {
              "x": -12.16,
              "y": -1.618,
              "z": 1.069
            },
            "rightCorner": {
              "x": -12.161,
              "y": -1.426,
              "z": 1.069
            },
            "gtin": "4002442820907",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d580",
        "height": 1.6066,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82d7",
            "leftCorner": {
              "x": -12.142,
              "y": -2.698,
              "z": 1.314
            },
            "rightCorner": {
              "x": -12.143,
              "y": -2.571,
              "z": 1.314
            }
          },
          {
            "id": "68d8e50ee1820c81800d82d8",
            "leftCorner": {
              "x": -12.14,
              "y": -2.571,
              "z": 1.314
            },
            "rightCorner": {
              "x": -12.141,
              "y": -2.331,
              "z": 1.314
            },
            "gtin": "4250426227598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82d9",
            "leftCorner": {
              "x": -12.146,
              "y": -2.331,
              "z": 1.314
            },
            "rightCorner": {
              "x": -12.148,
              "y": -2.124,
              "z": 1.314
            },
            "gtin": "4306188050452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82da",
            "leftCorner": {
              "x": -12.144,
              "y": -2.124,
              "z": 1.314
            },
            "rightCorner": {
              "x": -12.148,
              "y": -1.784,
              "z": 1.314
            },
            "gtin": "4306188050384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82db",
            "leftCorner": {
              "x": -12.154,
              "y": -1.784,
              "z": 1.314
            },
            "rightCorner": {
              "x": -12.155,
              "y": -1.651,
              "z": 1.314
            },
            "gtin": "4008122011894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82dc",
            "leftCorner": {
              "x": -12.155,
              "y": -1.651,
              "z": 1.314
            },
            "rightCorner": {
              "x": -12.156,
              "y": -1.478,
              "z": 1.314
            },
            "gtin": "4008122011870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82dd",
            "leftCorner": {
              "x": -12.151,
              "y": -1.478,
              "z": 1.314
            },
            "rightCorner": {
              "x": -12.153,
              "y": -1.249,
              "z": 1.314
            },
            "gtin": "4306188031147",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "77d",
    "rightNeighborShelfId": "77f"
  },
  {
    "id": "77f",
    "name": "77f",
    "x": -12.163,
    "y": -1.485,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71001,
      "w": 0.70419
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 35
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d589",
        "height": 0.16879,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8332",
            "leftCorner": {
              "x": -12.1,
              "y": -1.26,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.103,
              "y": -0.944,
              "z": 0.138
            },
            "gtin": "8715700131139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "17222814c663bece27f4d730",
            "leftCorner": {
              "x": -12.056,
              "y": -1.484,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.057,
              "y": -1.305,
              "z": 0.138
            },
            "gtin": "4104420187894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8334",
            "leftCorner": {
              "x": -12.101,
              "y": -0.863,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.102,
              "y": -0.691,
              "z": 0.138
            },
            "gtin": "4104420187894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8335",
            "leftCorner": {
              "x": -12.101,
              "y": -0.691,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.103,
              "y": -0.549,
              "z": 0.138
            },
            "gtin": "4104420187979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8336",
            "leftCorner": {
              "x": -12.098,
              "y": -0.549,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.1,
              "y": -0.317,
              "z": 0.138
            },
            "gtin": "4306188023036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8337",
            "leftCorner": {
              "x": -12.105,
              "y": -0.317,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.107,
              "y": -0.039,
              "z": 0.138
            },
            "gtin": "4306188053019",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d586",
        "height": 0.40317,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d829e",
            "leftCorner": {
              "x": -12.164,
              "y": -1.44,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.164,
              "y": -1.281,
              "z": 0.33
            },
            "gtin": "3017800251669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a84131fed24ef3728287a501",
            "leftCorner": {
              "x": -12.132,
              "y": -0.586,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.133,
              "y": -0.464,
              "z": 0.33
            },
            "gtin": "3017800251669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d829f",
            "leftCorner": {
              "x": -12.167,
              "y": -1.281,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.168,
              "y": -1.111,
              "z": 0.33
            },
            "gtin": "3017800253809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82a0",
            "leftCorner": {
              "x": -12.168,
              "y": -1.111,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.17,
              "y": -0.937,
              "z": 0.33
            },
            "gtin": "3017800251720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82a1",
            "leftCorner": {
              "x": -12.174,
              "y": -0.937,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.176,
              "y": -0.587,
              "z": 0.33
            },
            "gtin": "3017800251690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82a3",
            "leftCorner": {
              "x": -12.174,
              "y": -0.44,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.175,
              "y": -0.208,
              "z": 0.33
            },
            "gtin": "3017800265697",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d585",
        "height": 0.69973,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82bf",
            "leftCorner": {
              "x": -12.159,
              "y": -1.449,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.16,
              "y": -1.365,
              "z": 0.573
            },
            "gtin": "3017800251652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82c0",
            "leftCorner": {
              "x": -12.16,
              "y": -1.365,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.16,
              "y": -1.28,
              "z": 0.573
            },
            "gtin": "3017800251652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82c1",
            "leftCorner": {
              "x": -12.159,
              "y": -1.28,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.161,
              "y": -1.132,
              "z": 0.573
            },
            "gtin": "3017800251621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82c2",
            "leftCorner": {
              "x": -12.164,
              "y": -1.132,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.166,
              "y": -0.896,
              "z": 0.573
            },
            "gtin": "3083681025590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82c3",
            "leftCorner": {
              "x": -12.169,
              "y": -0.896,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.171,
              "y": -0.747,
              "z": 0.573
            },
            "gtin": "3083681133172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82c4",
            "leftCorner": {
              "x": -12.164,
              "y": -0.747,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.165,
              "y": -0.527,
              "z": 0.573
            },
            "gtin": "3083680001717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82c5",
            "leftCorner": {
              "x": -12.165,
              "y": -0.527,
              "z": 0.573
            },
            "rightCorner": {
              "x": -12.167,
              "y": -0.213,
              "z": 0.573
            },
            "gtin": "3083680001663",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d584",
        "height": 1.0026,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d831b",
            "leftCorner": {
              "x": -12.157,
              "y": -1.339,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.158,
              "y": -1.094,
              "z": 0.82
            },
            "gtin": "4306188004899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d32ba0e0d3b42d55843df446",
            "leftCorner": {
              "x": -12.117,
              "y": -1.485,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.118,
              "y": -1.402,
              "z": 0.82
            },
            "gtin": "4250426224498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d831c",
            "leftCorner": {
              "x": -12.162,
              "y": -1.094,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.165,
              "y": -0.84,
              "z": 0.82
            },
            "gtin": "4306188047445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d831d",
            "leftCorner": {
              "x": -12.168,
              "y": -0.84,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.17,
              "y": -0.568,
              "z": 0.82
            },
            "gtin": "4306188034308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d831e",
            "leftCorner": {
              "x": -12.161,
              "y": -0.568,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.162,
              "y": -0.308,
              "z": 0.82
            },
            "gtin": "4306188035534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d831f",
            "leftCorner": {
              "x": -12.16,
              "y": -0.308,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.162,
              "y": -0.069,
              "z": 0.82
            },
            "gtin": "4250426224498",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d588",
        "height": 1.3052,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82fb",
            "leftCorner": {
              "x": -12.16,
              "y": -1.426,
              "z": 1.068
            },
            "rightCorner": {
              "x": -12.162,
              "y": -1.236,
              "z": 1.068
            },
            "gtin": "4104420227408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82fc",
            "leftCorner": {
              "x": -12.161,
              "y": -1.236,
              "z": 1.068
            },
            "rightCorner": {
              "x": -12.163,
              "y": -0.996,
              "z": 1.068
            },
            "gtin": "4012712000335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82fd",
            "leftCorner": {
              "x": -12.16,
              "y": -0.996,
              "z": 1.068
            },
            "rightCorner": {
              "x": -12.165,
              "y": -0.477,
              "z": 1.068
            },
            "gtin": "4250426215090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82fe",
            "leftCorner": {
              "x": -12.159,
              "y": -0.477,
              "z": 1.068
            },
            "rightCorner": {
              "x": -12.16,
              "y": -0.34,
              "z": 1.068
            },
            "gtin": "4250426224764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82ff",
            "leftCorner": {
              "x": -12.163,
              "y": -0.34,
              "z": 1.068
            },
            "rightCorner": {
              "x": -12.164,
              "y": -0.189,
              "z": 1.068
            },
            "gtin": "8720600613722",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d587",
        "height": 1.6057,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82de",
            "leftCorner": {
              "x": -12.155,
              "y": -1.249,
              "z": 1.314
            },
            "rightCorner": {
              "x": -12.157,
              "y": -1.058,
              "z": 1.314
            },
            "gtin": "8720600030109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f49a2901aa0b3904ff594fac",
            "leftCorner": {
              "x": -12.111,
              "y": -1.485,
              "z": 1.314
            },
            "rightCorner": {
              "x": -12.113,
              "y": -1.292,
              "z": 1.314
            },
            "gtin": "4306188031147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82df",
            "leftCorner": {
              "x": -12.161,
              "y": -1.058,
              "z": 1.314
            },
            "rightCorner": {
              "x": -12.165,
              "y": -0.595,
              "z": 1.314
            },
            "gtin": "8720600027109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82e0",
            "leftCorner": {
              "x": -12.156,
              "y": -0.595,
              "z": 1.314
            },
            "rightCorner": {
              "x": -12.158,
              "y": -0.43,
              "z": 1.314
            },
            "gtin": "8720600612503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82e1",
            "leftCorner": {
              "x": -12.157,
              "y": -0.43,
              "z": 1.314
            },
            "rightCorner": {
              "x": -12.158,
              "y": -0.184,
              "z": 1.314
            },
            "gtin": "4104420034365",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "77e",
    "rightNeighborShelfId": "780"
  },
  {
    "id": "780",
    "name": "780",
    "x": -12.173,
    "y": -0.235,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71001,
      "w": 0.70419
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 44
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d58f",
        "height": 0.16954,
        "facings": [
          {
            "id": "3772a20535c86f18c504a014",
            "leftCorner": {
              "x": -12.081,
              "y": -0.234,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.082,
              "y": -0.139,
              "z": 0.139
            },
            "gtin": "3083681133196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f702ff7ebd9b70316fc26fa6",
            "leftCorner": {
              "x": -12.082,
              "y": -0.139,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.083,
              "y": -0.034,
              "z": 0.139
            },
            "gtin": "4250426200430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0d8c32af7947bed909aafc97",
            "leftCorner": {
              "x": -12.083,
              "y": -0.034,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.084,
              "y": 0.099,
              "z": 0.139
            },
            "gtin": "4104420230224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "29fbceeb3f757131f296dcf6",
            "leftCorner": {
              "x": -12.084,
              "y": 0.099,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.085,
              "y": 0.234,
              "z": 0.139
            },
            "gtin": "3083681151183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3b90a3939d76931a7fce387c",
            "leftCorner": {
              "x": -12.085,
              "y": 0.234,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.086,
              "y": 0.37,
              "z": 0.139
            },
            "gtin": "3017800265673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "09c15b7f42c7091b15c9772f",
            "leftCorner": {
              "x": -12.086,
              "y": 0.37,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.087,
              "y": 0.514,
              "z": 0.139
            },
            "gtin": "3083680577472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ed95a927de09860c94773bbb",
            "leftCorner": {
              "x": -12.087,
              "y": 0.514,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.088,
              "y": 0.668,
              "z": 0.139
            },
            "gtin": "4104420034143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "16ee8ce67c4b99bc42fd1b06",
            "leftCorner": {
              "x": -12.088,
              "y": 0.668,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.09,
              "y": 0.832,
              "z": 0.139
            },
            "gtin": "3017800265680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4be40a6e1ed6b8c1841390ab",
            "leftCorner": {
              "x": -12.09,
              "y": 0.832,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.091,
              "y": 1.008,
              "z": 0.139
            },
            "gtin": "3083680685542",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d58b",
        "height": 0.4,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82a4",
            "leftCorner": {
              "x": -12.172,
              "y": -0.208,
              "z": 0.327
            },
            "rightCorner": {
              "x": -12.173,
              "y": -0.077,
              "z": 0.327
            },
            "gtin": "3017800265673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82a5",
            "leftCorner": {
              "x": -12.172,
              "y": -0.077,
              "z": 0.327
            },
            "rightCorner": {
              "x": -12.173,
              "y": 0.086,
              "z": 0.327
            },
            "gtin": "3017800265680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82a6",
            "leftCorner": {
              "x": -12.169,
              "y": 0.086,
              "z": 0.327
            },
            "rightCorner": {
              "x": -12.171,
              "y": 0.294,
              "z": 0.327
            },
            "gtin": "4250426219869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82a7",
            "leftCorner": {
              "x": -12.166,
              "y": 0.294,
              "z": 0.327
            },
            "rightCorner": {
              "x": -12.167,
              "y": 0.507,
              "z": 0.327
            },
            "gtin": "4250426226799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82a8",
            "leftCorner": {
              "x": -12.183,
              "y": 0.507,
              "z": 0.327
            },
            "rightCorner": {
              "x": -12.184,
              "y": 0.716,
              "z": 0.327
            },
            "gtin": "4250426222104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82a9",
            "leftCorner": {
              "x": -12.177,
              "y": 0.716,
              "z": 0.327
            },
            "rightCorner": {
              "x": -12.178,
              "y": 0.899,
              "z": 0.327
            },
            "gtin": "4250426227550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82aa",
            "leftCorner": {
              "x": -12.184,
              "y": 0.899,
              "z": 0.327
            },
            "rightCorner": {
              "x": -12.185,
              "y": 1.015,
              "z": 0.327
            },
            "gtin": "4250426200430",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d58a",
        "height": 0.69621,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82c6",
            "leftCorner": {
              "x": -12.164,
              "y": -0.213,
              "z": 0.57
            },
            "rightCorner": {
              "x": -12.164,
              "y": -0.118,
              "z": 0.57
            },
            "gtin": "3083681133196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82c7",
            "leftCorner": {
              "x": -12.165,
              "y": -0.118,
              "z": 0.57
            },
            "rightCorner": {
              "x": -12.166,
              "y": 0.017,
              "z": 0.57
            },
            "gtin": "3083681003949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82c8",
            "leftCorner": {
              "x": -12.166,
              "y": 0.017,
              "z": 0.57
            },
            "rightCorner": {
              "x": -12.168,
              "y": 0.152,
              "z": 0.57
            },
            "gtin": "3083681003949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82c9",
            "leftCorner": {
              "x": -12.168,
              "y": 0.152,
              "z": 0.57
            },
            "rightCorner": {
              "x": -12.169,
              "y": 0.283,
              "z": 0.57
            },
            "gtin": "4104420230224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82ca",
            "leftCorner": {
              "x": -12.166,
              "y": 0.283,
              "z": 0.57
            },
            "rightCorner": {
              "x": -12.168,
              "y": 0.438,
              "z": 0.57
            },
            "gtin": "4104420034143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82cb",
            "leftCorner": {
              "x": -12.169,
              "y": 0.438,
              "z": 0.57
            },
            "rightCorner": {
              "x": -12.17,
              "y": 0.684,
              "z": 0.57
            },
            "gtin": "4306188027027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82cc",
            "leftCorner": {
              "x": -12.174,
              "y": 0.683,
              "z": 0.57
            },
            "rightCorner": {
              "x": -12.177,
              "y": 1.047,
              "z": 0.57
            },
            "gtin": "4306188027034",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d58c",
        "height": 0.99968,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8320",
            "leftCorner": {
              "x": -12.164,
              "y": -0.069,
              "z": 0.818
            },
            "rightCorner": {
              "x": -12.165,
              "y": 0.164,
              "z": 0.818
            },
            "gtin": "3083680002752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "13e27598a6f5e896c3ca886d",
            "leftCorner": {
              "x": -12.125,
              "y": -0.235,
              "z": 0.818
            },
            "rightCorner": {
              "x": -12.126,
              "y": -0.072,
              "z": 0.818
            },
            "gtin": "3083681160833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8321",
            "leftCorner": {
              "x": -12.17,
              "y": 0.164,
              "z": 0.818
            },
            "rightCorner": {
              "x": -12.172,
              "y": 0.383,
              "z": 0.818
            },
            "gtin": "3083681153668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8322",
            "leftCorner": {
              "x": -12.167,
              "y": 0.383,
              "z": 0.818
            },
            "rightCorner": {
              "x": -12.17,
              "y": 0.635,
              "z": 0.818
            },
            "gtin": "3083680009508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8323",
            "leftCorner": {
              "x": -12.173,
              "y": 0.635,
              "z": 0.818
            },
            "rightCorner": {
              "x": -12.174,
              "y": 0.846,
              "z": 0.818
            },
            "gtin": "3083680019972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8324",
            "leftCorner": {
              "x": -12.176,
              "y": 0.846,
              "z": 0.818
            },
            "rightCorner": {
              "x": -12.178,
              "y": 1.128,
              "z": 0.818
            },
            "gtin": "3083681160833",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d58e",
        "height": 1.3037,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8300",
            "leftCorner": {
              "x": -12.165,
              "y": -0.189,
              "z": 1.067
            },
            "rightCorner": {
              "x": -12.167,
              "y": 0.072,
              "z": 1.067
            },
            "gtin": "3083681151183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3507088cd2fcdf7a64f9d0d4",
            "leftCorner": {
              "x": -12.125,
              "y": -0.235,
              "z": 1.067
            },
            "rightCorner": {
              "x": -12.125,
              "y": -0.195,
              "z": 1.067
            },
            "gtin": "3083681133158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8301",
            "leftCorner": {
              "x": -12.167,
              "y": 0.072,
              "z": 1.067
            },
            "rightCorner": {
              "x": -12.168,
              "y": 0.243,
              "z": 1.067
            },
            "gtin": "3083680685542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8302",
            "leftCorner": {
              "x": -12.164,
              "y": 0.243,
              "z": 1.067
            },
            "rightCorner": {
              "x": -12.166,
              "y": 0.413,
              "z": 1.067
            },
            "gtin": "3083680685535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8303",
            "leftCorner": {
              "x": -12.17,
              "y": 0.412,
              "z": 1.067
            },
            "rightCorner": {
              "x": -12.172,
              "y": 0.558,
              "z": 1.067
            },
            "gtin": "3083680577472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8304",
            "leftCorner": {
              "x": -12.172,
              "y": 0.558,
              "z": 1.067
            },
            "rightCorner": {
              "x": -12.174,
              "y": 0.786,
              "z": 1.067
            },
            "gtin": "3083681117516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8305",
            "leftCorner": {
              "x": -12.175,
              "y": 0.786,
              "z": 1.067
            },
            "rightCorner": {
              "x": -12.176,
              "y": 0.981,
              "z": 1.067
            },
            "gtin": "3083680539500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8306",
            "leftCorner": {
              "x": -12.177,
              "y": 0.981,
              "z": 1.067
            },
            "rightCorner": {
              "x": -12.179,
              "y": 1.133,
              "z": 1.067
            },
            "gtin": "3083681133158",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d58d",
        "height": 1.6041,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82e2",
            "leftCorner": {
              "x": -12.156,
              "y": -0.184,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.158,
              "y": 0.056,
              "z": 1.312
            },
            "gtin": "3083681117769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ad3a978037e848d0b5bffee6",
            "leftCorner": {
              "x": -12.117,
              "y": -0.235,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.117,
              "y": -0.208,
              "z": 1.312
            },
            "gtin": "3083681106947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82e3",
            "leftCorner": {
              "x": -12.159,
              "y": 0.056,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.16,
              "y": 0.269,
              "z": 1.312
            },
            "gtin": "3083681117271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82e4",
            "leftCorner": {
              "x": -12.161,
              "y": 0.269,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.163,
              "y": 0.535,
              "z": 1.312
            },
            "gtin": "3083681185171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82e5",
            "leftCorner": {
              "x": -12.164,
              "y": 0.535,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.166,
              "y": 0.749,
              "z": 1.312
            },
            "gtin": "3083681102499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82e6",
            "leftCorner": {
              "x": -12.167,
              "y": 0.749,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.169,
              "y": 0.982,
              "z": 1.312
            },
            "gtin": "3083681065947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82e7",
            "leftCorner": {
              "x": -12.17,
              "y": 0.981,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.171,
              "y": 1.111,
              "z": 1.312
            },
            "gtin": "3083681106947",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "77f",
    "rightNeighborShelfId": "781"
  },
  {
    "id": "781",
    "name": "781",
    "x": -12.183,
    "y": 1.015,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71001,
      "w": 0.70419
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 37
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d595",
        "height": 0.15974,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d833d",
            "leftCorner": {
              "x": -12.123,
              "y": 1.058,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.124,
              "y": 1.363,
              "z": 0.131
            },
            "gtin": "4306188018544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d833e",
            "leftCorner": {
              "x": -12.132,
              "y": 1.363,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.135,
              "y": 1.726,
              "z": 0.131
            },
            "gtin": "4306188018568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d833f",
            "leftCorner": {
              "x": -12.122,
              "y": 1.726,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.123,
              "y": 1.947,
              "z": 0.131
            },
            "gtin": "4250426200423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8340",
            "leftCorner": {
              "x": -12.113,
              "y": 1.947,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.115,
              "y": 2.104,
              "z": 0.131
            },
            "gtin": "8720600604188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d832c",
            "leftCorner": {
              "x": -12.146,
              "y": 2.104,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.147,
              "y": 2.265,
              "z": 0.131
            },
            "gtin": "4250426224696",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d594",
        "height": 0.40221,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82ab",
            "leftCorner": {
              "x": -12.194,
              "y": 1.015,
              "z": 0.329
            },
            "rightCorner": {
              "x": -12.197,
              "y": 1.21,
              "z": 0.329
            },
            "gtin": "4250426200454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82ac",
            "leftCorner": {
              "x": -12.184,
              "y": 1.21,
              "z": 0.329
            },
            "rightCorner": {
              "x": -12.186,
              "y": 1.449,
              "z": 0.329
            },
            "gtin": "4250426200454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82ad",
            "leftCorner": {
              "x": -12.191,
              "y": 1.449,
              "z": 0.329
            },
            "rightCorner": {
              "x": -12.193,
              "y": 1.702,
              "z": 0.329
            },
            "gtin": "4250426200447",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d82ae",
            "leftCorner": {
              "x": -12.195,
              "y": 1.702,
              "z": 0.329
            },
            "rightCorner": {
              "x": -12.195,
              "y": 1.784,
              "z": 0.329
            },
            "gtin": "4104420170179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82af",
            "leftCorner": {
              "x": -12.194,
              "y": 1.784,
              "z": 0.329
            },
            "rightCorner": {
              "x": -12.196,
              "y": 1.898,
              "z": 0.329
            },
            "gtin": "8720600141102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82b0",
            "leftCorner": {
              "x": -12.204,
              "y": 1.898,
              "z": 0.329
            },
            "rightCorner": {
              "x": -12.206,
              "y": 2.145,
              "z": 0.329
            },
            "gtin": "4104420141162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8297",
            "leftCorner": {
              "x": -12.21,
              "y": 2.145,
              "z": 0.329
            },
            "rightCorner": {
              "x": -12.21,
              "y": 2.265,
              "z": 0.329
            },
            "gtin": "8720600136108",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d590",
        "height": 0.6978,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82cd",
            "leftCorner": {
              "x": -12.175,
              "y": 1.047,
              "z": 0.571
            },
            "rightCorner": {
              "x": -12.177,
              "y": 1.302,
              "z": 0.571
            },
            "gtin": "4306188036333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82ce",
            "leftCorner": {
              "x": -12.179,
              "y": 1.302,
              "z": 0.571
            },
            "rightCorner": {
              "x": -12.18,
              "y": 1.537,
              "z": 0.571
            },
            "gtin": "4306188027010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82cf",
            "leftCorner": {
              "x": -12.186,
              "y": 1.537,
              "z": 0.571
            },
            "rightCorner": {
              "x": -12.189,
              "y": 1.814,
              "z": 0.571
            },
            "gtin": "4306188027003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82d0",
            "leftCorner": {
              "x": -12.191,
              "y": 1.814,
              "z": 0.571
            },
            "rightCorner": {
              "x": -12.193,
              "y": 2.029,
              "z": 0.571
            },
            "gtin": "4306188027362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82b2",
            "leftCorner": {
              "x": -12.196,
              "y": 2.029,
              "z": 0.571
            },
            "rightCorner": {
              "x": -12.198,
              "y": 2.265,
              "z": 0.571
            },
            "gtin": "4306188046578",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d591",
        "height": 1.0017,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8325",
            "leftCorner": {
              "x": -12.178,
              "y": 1.128,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.18,
              "y": 1.295,
              "z": 0.82
            },
            "gtin": "3083681160901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8326",
            "leftCorner": {
              "x": -12.176,
              "y": 1.296,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.178,
              "y": 1.53,
              "z": 0.82
            },
            "gtin": "3083681131864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8327",
            "leftCorner": {
              "x": -12.184,
              "y": 1.53,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.185,
              "y": 1.657,
              "z": 0.82
            },
            "gtin": "3083680912730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8328",
            "leftCorner": {
              "x": -12.18,
              "y": 1.657,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.181,
              "y": 1.803,
              "z": 0.82
            },
            "gtin": "3083681163155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8329",
            "leftCorner": {
              "x": -12.189,
              "y": 1.803,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.19,
              "y": 1.967,
              "z": 0.82
            },
            "gtin": "3083681139716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d832a",
            "leftCorner": {
              "x": -12.197,
              "y": 1.967,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.199,
              "y": 2.133,
              "z": 0.82
            },
            "gtin": "3083681139709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d830e",
            "leftCorner": {
              "x": -12.194,
              "y": 2.133,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.195,
              "y": 2.265,
              "z": 0.82
            },
            "gtin": "3083681139723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "990585fd24261e98399b6e12",
            "leftCorner": {
              "x": -12.14,
              "y": 1.015,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.141,
              "y": 1.126,
              "z": 0.82
            },
            "gtin": "3083681139723",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d592",
        "height": 1.3053,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8307",
            "leftCorner": {
              "x": -12.177,
              "y": 1.133,
              "z": 1.068
            },
            "rightCorner": {
              "x": -12.18,
              "y": 1.308,
              "z": 1.068
            },
            "gtin": "3083680000345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8308",
            "leftCorner": {
              "x": -12.177,
              "y": 1.308,
              "z": 1.068
            },
            "rightCorner": {
              "x": -12.177,
              "y": 1.452,
              "z": 1.068
            },
            "gtin": "3083681172430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8309",
            "leftCorner": {
              "x": -12.182,
              "y": 1.452,
              "z": 1.068
            },
            "rightCorner": {
              "x": -12.183,
              "y": 1.61,
              "z": 1.068
            },
            "gtin": "3083681160383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d830a",
            "leftCorner": {
              "x": -12.18,
              "y": 1.61,
              "z": 1.068
            },
            "rightCorner": {
              "x": -12.181,
              "y": 1.81,
              "z": 1.068
            },
            "gtin": "3083681130904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d830b",
            "leftCorner": {
              "x": -12.18,
              "y": 1.81,
              "z": 1.068
            },
            "rightCorner": {
              "x": -12.183,
              "y": 2.073,
              "z": 1.068
            },
            "gtin": "3083681157888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82ef",
            "leftCorner": {
              "x": -12.189,
              "y": 2.073,
              "z": 1.068
            },
            "rightCorner": {
              "x": -12.191,
              "y": 2.265,
              "z": 1.068
            },
            "gtin": "3083681158106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ab6eaaed8e64868ad1e3b50d",
            "leftCorner": {
              "x": -12.136,
              "y": 1.015,
              "z": 1.068
            },
            "rightCorner": {
              "x": -12.137,
              "y": 1.113,
              "z": 1.068
            },
            "gtin": "3083680000345",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d593",
        "height": 1.605,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d82e8",
            "leftCorner": {
              "x": -12.172,
              "y": 1.111,
              "z": 1.313
            },
            "rightCorner": {
              "x": -12.173,
              "y": 1.242,
              "z": 1.313
            },
            "gtin": "3083681157703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82e9",
            "leftCorner": {
              "x": -12.169,
              "y": 1.242,
              "z": 1.313
            },
            "rightCorner": {
              "x": -12.17,
              "y": 1.418,
              "z": 1.313
            },
            "gtin": "3083681172409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82ea",
            "leftCorner": {
              "x": -12.173,
              "y": 1.418,
              "z": 1.313
            },
            "rightCorner": {
              "x": -12.174,
              "y": 1.613,
              "z": 1.313
            },
            "gtin": "3083681157604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82eb",
            "leftCorner": {
              "x": -12.172,
              "y": 1.613,
              "z": 1.313
            },
            "rightCorner": {
              "x": -12.174,
              "y": 1.815,
              "z": 1.313
            },
            "gtin": "3083681157789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82ec",
            "leftCorner": {
              "x": -12.185,
              "y": 1.815,
              "z": 1.313
            },
            "rightCorner": {
              "x": -12.186,
              "y": 2.022,
              "z": 1.313
            },
            "gtin": "3083681130751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d82d2",
            "leftCorner": {
              "x": -12.193,
              "y": 2.022,
              "z": 1.313
            },
            "rightCorner": {
              "x": -12.196,
              "y": 2.265,
              "z": 1.313
            },
            "gtin": "3083681130720",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "780"
  },
  {
    "id": "783",
    "name": "783",
    "x": -16.043,
    "y": 2.249,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70304,
      "w": 0.71115
    },
    "layers": [],

    "rightNeighborShelfId": "784"
  },
  {
    "id": "784",
    "name": "784",
    "x": -16.029,
    "y": 0.999,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70304,
      "w": 0.71115
    },
    "layers": [],
    "leftNeighborShelfId": "783",
    "rightNeighborShelfId": "785"
  },
  {
    "id": "785",
    "name": "785",
    "x": -16.015,
    "y": -0.251,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70304,
      "w": 0.71115
    },
    "layers": [],
    "leftNeighborShelfId": "784",
    "rightNeighborShelfId": "786"
  },
  {
    "id": "786",
    "name": "786",
    "x": -16.0,
    "y": -1.501,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70304,
      "w": 0.71115
    },
    "layers": [],
    "leftNeighborShelfId": "785"
  },
  {
    "id": "787",
    "name": "787",
    "x": -14.808,
    "y": -2.763,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71147,
      "w": 0.70272
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 49
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5bc",
        "height": 0.17115,
        "facings": [
          {
            "id": "246571761500c9472a105ac6",
            "leftCorner": {
              "x": -14.738,
              "y": -2.762,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.739,
              "y": -2.689,
              "z": 0.14
            },
            "gtin": "4000503103006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5a3bfd428738b7699d326499",
            "leftCorner": {
              "x": -14.739,
              "y": -2.689,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.74,
              "y": -2.58,
              "z": 0.14
            },
            "gtin": "4000404121956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bd079163be4d51ffcf8e1d06",
            "leftCorner": {
              "x": -14.74,
              "y": -2.58,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.742,
              "y": -2.437,
              "z": 0.14
            },
            "gtin": "4250426219982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "93faecee24136c0b95fe95a4",
            "leftCorner": {
              "x": -14.742,
              "y": -2.437,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.744,
              "y": -2.262,
              "z": 0.14
            },
            "gtin": "4048952504098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "71a22af67f74b17ad4c116a1",
            "leftCorner": {
              "x": -14.744,
              "y": -2.262,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.746,
              "y": -2.086,
              "z": 0.14
            },
            "gtin": "4000503148502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b57fa589fe9693096fca926f",
            "leftCorner": {
              "x": -14.746,
              "y": -2.086,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.749,
              "y": -1.9,
              "z": 0.14
            },
            "gtin": "4000503119601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e709600fc8199c8cbe461bb3",
            "leftCorner": {
              "x": -14.749,
              "y": -1.9,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.751,
              "y": -1.705,
              "z": 0.14
            },
            "gtin": "4048952050175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ff64de8b9814cd192af6bec2",
            "leftCorner": {
              "x": -14.751,
              "y": -1.705,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.753,
              "y": -1.519,
              "z": 0.14
            },
            "gtin": "4000503119601",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5b7",
        "height": 0.4989,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8424",
            "leftCorner": {
              "x": -14.768,
              "y": -2.763,
              "z": 0.408
            },
            "rightCorner": {
              "x": -14.769,
              "y": -2.672,
              "z": 0.408
            },
            "gtin": "4250426219920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8425",
            "leftCorner": {
              "x": -14.769,
              "y": -2.672,
              "z": 0.408
            },
            "rightCorner": {
              "x": -14.77,
              "y": -2.582,
              "z": 0.408
            },
            "gtin": "4250426219920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8427",
            "leftCorner": {
              "x": -14.814,
              "y": -2.582,
              "z": 0.408
            },
            "rightCorner": {
              "x": -14.816,
              "y": -2.384,
              "z": 0.408
            },
            "gtin": "4250426219982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8428",
            "leftCorner": {
              "x": -14.813,
              "y": -2.384,
              "z": 0.408
            },
            "rightCorner": {
              "x": -14.815,
              "y": -2.152,
              "z": 0.408
            },
            "gtin": "4250426219944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8429",
            "leftCorner": {
              "x": -14.815,
              "y": -2.152,
              "z": 0.408
            },
            "rightCorner": {
              "x": -14.817,
              "y": -2.05,
              "z": 0.408
            },
            "gtin": "4250426224795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d842a",
            "leftCorner": {
              "x": -14.817,
              "y": -2.05,
              "z": 0.408
            },
            "rightCorner": {
              "x": -14.817,
              "y": -1.948,
              "z": 0.408
            },
            "gtin": "4250426224795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d842b",
            "leftCorner": {
              "x": -14.818,
              "y": -1.948,
              "z": 0.408
            },
            "rightCorner": {
              "x": -14.819,
              "y": -1.867,
              "z": 0.408
            },
            "gtin": "4250426227017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d842c",
            "leftCorner": {
              "x": -14.819,
              "y": -1.867,
              "z": 0.408
            },
            "rightCorner": {
              "x": -14.82,
              "y": -1.786,
              "z": 0.408
            },
            "gtin": "4250426227017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d842d",
            "leftCorner": {
              "x": -14.82,
              "y": -1.786,
              "z": 0.408
            },
            "rightCorner": {
              "x": -14.821,
              "y": -1.705,
              "z": 0.408
            },
            "gtin": "4250426227017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d842e",
            "leftCorner": {
              "x": -14.814,
              "y": -1.705,
              "z": 0.408
            },
            "rightCorner": {
              "x": -14.815,
              "y": -1.617,
              "z": 0.408
            },
            "gtin": "4250426227031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d842f",
            "leftCorner": {
              "x": -14.815,
              "y": -1.617,
              "z": 0.408
            },
            "rightCorner": {
              "x": -14.816,
              "y": -1.529,
              "z": 0.408
            },
            "gtin": "4250426227031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8430",
            "leftCorner": {
              "x": -14.816,
              "y": -1.529,
              "z": 0.408
            },
            "rightCorner": {
              "x": -14.817,
              "y": -1.441,
              "z": 0.408
            },
            "gtin": "4250426227031",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5ba",
        "height": 0.87556,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8456",
            "leftCorner": {
              "x": -14.77,
              "y": -2.763,
              "z": 0.716
            },
            "rightCorner": {
              "x": -14.772,
              "y": -2.652,
              "z": 0.716
            },
            "gtin": "4000503148601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8457",
            "leftCorner": {
              "x": -14.772,
              "y": -2.652,
              "z": 0.716
            },
            "rightCorner": {
              "x": -14.773,
              "y": -2.542,
              "z": 0.716
            },
            "gtin": "4000503148601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8459",
            "leftCorner": {
              "x": -14.811,
              "y": -2.542,
              "z": 0.716
            },
            "rightCorner": {
              "x": -14.814,
              "y": -2.362,
              "z": 0.716
            },
            "gtin": "4000503148502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d845a",
            "leftCorner": {
              "x": -14.816,
              "y": -2.363,
              "z": 0.716
            },
            "rightCorner": {
              "x": -14.819,
              "y": -2.164,
              "z": 0.716
            },
            "gtin": "4000503120102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d845b",
            "leftCorner": {
              "x": -14.819,
              "y": -2.164,
              "z": 0.716
            },
            "rightCorner": {
              "x": -14.822,
              "y": -1.966,
              "z": 0.716
            },
            "gtin": "4000503120102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d845c",
            "leftCorner": {
              "x": -14.824,
              "y": -1.966,
              "z": 0.716
            },
            "rightCorner": {
              "x": -14.825,
              "y": -1.89,
              "z": 0.716
            },
            "gtin": "4000503120508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d845d",
            "leftCorner": {
              "x": -14.825,
              "y": -1.89,
              "z": 0.716
            },
            "rightCorner": {
              "x": -14.826,
              "y": -1.814,
              "z": 0.716
            },
            "gtin": "4000503120508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d845e",
            "leftCorner": {
              "x": -14.826,
              "y": -1.814,
              "z": 0.716
            },
            "rightCorner": {
              "x": -14.827,
              "y": -1.739,
              "z": 0.716
            },
            "gtin": "4000503120508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d845f",
            "leftCorner": {
              "x": -14.817,
              "y": -1.738,
              "z": 0.716
            },
            "rightCorner": {
              "x": -14.82,
              "y": -1.517,
              "z": 0.716
            },
            "gtin": "4000404121956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8460",
            "leftCorner": {
              "x": -14.811,
              "y": -1.531,
              "z": 0.719
            },
            "rightCorner": {
              "x": -14.814,
              "y": -1.285,
              "z": 0.719
            },
            "gtin": "4000404126258",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5b8",
        "height": 1.2039,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8437",
            "leftCorner": {
              "x": -14.768,
              "y": -2.763,
              "z": 0.985
            },
            "rightCorner": {
              "x": -14.771,
              "y": -2.558,
              "z": 0.985
            },
            "gtin": "4000503103006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8439",
            "leftCorner": {
              "x": -14.81,
              "y": -2.558,
              "z": 0.985
            },
            "rightCorner": {
              "x": -14.81,
              "y": -2.467,
              "z": 0.985
            },
            "gtin": "4000503102306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d843a",
            "leftCorner": {
              "x": -14.81,
              "y": -2.467,
              "z": 0.985
            },
            "rightCorner": {
              "x": -14.811,
              "y": -2.376,
              "z": 0.985
            },
            "gtin": "4000503102306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d843b",
            "leftCorner": {
              "x": -14.812,
              "y": -2.376,
              "z": 0.985
            },
            "rightCorner": {
              "x": -14.814,
              "y": -2.263,
              "z": 0.985
            },
            "gtin": "4000503141305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d843c",
            "leftCorner": {
              "x": -14.814,
              "y": -2.263,
              "z": 0.985
            },
            "rightCorner": {
              "x": -14.816,
              "y": -2.15,
              "z": 0.985
            },
            "gtin": "4000503141305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d843d",
            "leftCorner": {
              "x": -14.822,
              "y": -2.15,
              "z": 0.985
            },
            "rightCorner": {
              "x": -14.823,
              "y": -2.063,
              "z": 0.985
            },
            "gtin": "4000503148205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d843e",
            "leftCorner": {
              "x": -14.823,
              "y": -2.063,
              "z": 0.985
            },
            "rightCorner": {
              "x": -14.824,
              "y": -1.976,
              "z": 0.985
            },
            "gtin": "4000503148205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d843f",
            "leftCorner": {
              "x": -14.825,
              "y": -1.976,
              "z": 0.985
            },
            "rightCorner": {
              "x": -14.825,
              "y": -1.877,
              "z": 0.985
            },
            "gtin": "4000404121857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8440",
            "leftCorner": {
              "x": -14.825,
              "y": -1.877,
              "z": 0.985
            },
            "rightCorner": {
              "x": -14.827,
              "y": -1.777,
              "z": 0.985
            },
            "gtin": "4000404121857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8441",
            "leftCorner": {
              "x": -14.819,
              "y": -1.777,
              "z": 0.985
            },
            "rightCorner": {
              "x": -14.822,
              "y": -1.513,
              "z": 0.985
            },
            "gtin": "4003171035716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8442",
            "leftCorner": {
              "x": -14.82,
              "y": -1.513,
              "z": 0.985
            },
            "rightCorner": {
              "x": -14.822,
              "y": -1.285,
              "z": 0.985
            },
            "gtin": "4000404035758",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5b9",
        "height": 1.4798,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8449",
            "leftCorner": {
              "x": -14.759,
              "y": -2.762,
              "z": 1.211
            },
            "rightCorner": {
              "x": -14.761,
              "y": -2.654,
              "z": 1.211
            },
            "gtin": "4000503119205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d844a",
            "leftCorner": {
              "x": -14.761,
              "y": -2.654,
              "z": 1.211
            },
            "rightCorner": {
              "x": -14.761,
              "y": -2.546,
              "z": 1.211
            },
            "gtin": "4000503119205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d844c",
            "leftCorner": {
              "x": -14.801,
              "y": -2.546,
              "z": 1.211
            },
            "rightCorner": {
              "x": -14.804,
              "y": -2.358,
              "z": 1.211
            },
            "gtin": "4000503119601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d844d",
            "leftCorner": {
              "x": -14.803,
              "y": -2.358,
              "z": 1.211
            },
            "rightCorner": {
              "x": -14.806,
              "y": -2.118,
              "z": 1.211
            },
            "gtin": "4000503122403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d844e",
            "leftCorner": {
              "x": -14.809,
              "y": -2.118,
              "z": 1.211
            },
            "rightCorner": {
              "x": -14.813,
              "y": -1.885,
              "z": 1.211
            },
            "gtin": "4000503106304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d844f",
            "leftCorner": {
              "x": -14.814,
              "y": -1.885,
              "z": 1.211
            },
            "rightCorner": {
              "x": -14.816,
              "y": -1.717,
              "z": 1.211
            },
            "gtin": "4048952504098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8450",
            "leftCorner": {
              "x": -14.809,
              "y": -1.717,
              "z": 1.211
            },
            "rightCorner": {
              "x": -14.811,
              "y": -1.508,
              "z": 1.211
            },
            "gtin": "4048952050175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8451",
            "leftCorner": {
              "x": -14.806,
              "y": -1.531,
              "z": 1.214
            },
            "rightCorner": {
              "x": -14.81,
              "y": -1.288,
              "z": 1.214
            },
            "gtin": "4048952502902",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "788"
  },
  {
    "id": "788",
    "name": "788",
    "x": -14.823,
    "y": -1.513,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71147,
      "w": 0.70272
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 41
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5c0",
        "height": 0.15747,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8470",
            "leftCorner": {
              "x": -14.715,
              "y": -1.512,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.717,
              "y": -1.304,
              "z": 0.129
            },
            "gtin": "4306188041726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8471",
            "leftCorner": {
              "x": -14.717,
              "y": -1.304,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.719,
              "y": -1.097,
              "z": 0.129
            },
            "gtin": "4306188041726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8473",
            "leftCorner": {
              "x": -14.758,
              "y": -1.097,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.761,
              "y": -0.934,
              "z": 0.129
            },
            "gtin": "4306188377764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8474",
            "leftCorner": {
              "x": -14.76,
              "y": -0.934,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.762,
              "y": -0.741,
              "z": 0.129
            },
            "gtin": "4306188026624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8475",
            "leftCorner": {
              "x": -14.764,
              "y": -0.741,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.765,
              "y": -0.661,
              "z": 0.129
            },
            "gtin": "4306188026655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8476",
            "leftCorner": {
              "x": -14.765,
              "y": -0.661,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.766,
              "y": -0.581,
              "z": 0.129
            },
            "gtin": "4306188026655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8477",
            "leftCorner": {
              "x": -14.766,
              "y": -0.581,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.767,
              "y": -0.501,
              "z": 0.129
            },
            "gtin": "4306188026655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8478",
            "leftCorner": {
              "x": -14.79,
              "y": -0.501,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.794,
              "y": -0.219,
              "z": 0.129
            },
            "gtin": "4306188031581",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5bf",
        "height": 0.50258,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8431",
            "leftCorner": {
              "x": -14.817,
              "y": -1.441,
              "z": 0.411
            },
            "rightCorner": {
              "x": -14.82,
              "y": -1.235,
              "z": 0.411
            },
            "gtin": "4012682011256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8432",
            "leftCorner": {
              "x": -14.815,
              "y": -1.235,
              "z": 0.411
            },
            "rightCorner": {
              "x": -14.816,
              "y": -1.122,
              "z": 0.411
            },
            "gtin": "4008401610152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8433",
            "leftCorner": {
              "x": -14.816,
              "y": -1.122,
              "z": 0.411
            },
            "rightCorner": {
              "x": -14.818,
              "y": -1.009,
              "z": 0.411
            },
            "gtin": "4008401610152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8434",
            "leftCorner": {
              "x": -14.815,
              "y": -1.009,
              "z": 0.411
            },
            "rightCorner": {
              "x": -14.817,
              "y": -0.817,
              "z": 0.411
            },
            "gtin": "4015518601003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8435",
            "leftCorner": {
              "x": -14.823,
              "y": -0.817,
              "z": 0.411
            },
            "rightCorner": {
              "x": -14.825,
              "y": -0.684,
              "z": 0.411
            },
            "gtin": "4104420237537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8436",
            "leftCorner": {
              "x": -14.824,
              "y": -0.684,
              "z": 0.411
            },
            "rightCorner": {
              "x": -14.828,
              "y": -0.365,
              "z": 0.411
            },
            "gtin": "4006153756005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8426",
            "leftCorner": {
              "x": -14.84,
              "y": -0.365,
              "z": 0.411
            },
            "rightCorner": {
              "x": -14.841,
              "y": -0.263,
              "z": 0.411
            },
            "gtin": "4004577000131",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5c1",
        "height": 0.87888,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8461",
            "leftCorner": {
              "x": -14.819,
              "y": -1.267,
              "z": 0.719
            },
            "rightCorner": {
              "x": -14.821,
              "y": -1.083,
              "z": 0.719
            },
            "gtin": "4000404243559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8462",
            "leftCorner": {
              "x": -14.815,
              "y": -1.083,
              "z": 0.719
            },
            "rightCorner": {
              "x": -14.816,
              "y": -0.966,
              "z": 0.719
            },
            "gtin": "4003505152508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8463",
            "leftCorner": {
              "x": -14.818,
              "y": -0.966,
              "z": 0.719
            },
            "rightCorner": {
              "x": -14.82,
              "y": -0.834,
              "z": 0.719
            },
            "gtin": "4003505152553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8464",
            "leftCorner": {
              "x": -14.822,
              "y": -0.834,
              "z": 0.719
            },
            "rightCorner": {
              "x": -14.823,
              "y": -0.77,
              "z": 0.719
            },
            "gtin": "4000404122915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8465",
            "leftCorner": {
              "x": -14.823,
              "y": -0.77,
              "z": 0.719
            },
            "rightCorner": {
              "x": -14.823,
              "y": -0.706,
              "z": 0.719
            },
            "gtin": "4000404122915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8466",
            "leftCorner": {
              "x": -14.825,
              "y": -0.706,
              "z": 0.719
            },
            "rightCorner": {
              "x": -14.826,
              "y": -0.654,
              "z": 0.719
            },
            "gtin": "4000404943213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8467",
            "leftCorner": {
              "x": -14.826,
              "y": -0.654,
              "z": 0.719
            },
            "rightCorner": {
              "x": -14.827,
              "y": -0.602,
              "z": 0.719
            },
            "gtin": "4000404943213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8468",
            "leftCorner": {
              "x": -14.827,
              "y": -0.602,
              "z": 0.719
            },
            "rightCorner": {
              "x": -14.828,
              "y": -0.55,
              "z": 0.719
            },
            "gtin": "4000404943213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8469",
            "leftCorner": {
              "x": -14.838,
              "y": -0.55,
              "z": 0.719
            },
            "rightCorner": {
              "x": -14.839,
              "y": -0.418,
              "z": 0.719
            },
            "gtin": "4000404009018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8458",
            "leftCorner": {
              "x": -14.841,
              "y": -0.418,
              "z": 0.719
            },
            "rightCorner": {
              "x": -14.842,
              "y": -0.263,
              "z": 0.719
            },
            "gtin": "4000404016559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "242d74222ec2cea1bf8a00d9",
            "leftCorner": {
              "x": -14.776,
              "y": -1.512,
              "z": 0.719
            },
            "rightCorner": {
              "x": -14.779,
              "y": -1.286,
              "z": 0.719
            },
            "gtin": "4000404126258",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5bd",
        "height": 1.2076,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8443",
            "leftCorner": {
              "x": -14.819,
              "y": -1.284,
              "z": 0.988
            },
            "rightCorner": {
              "x": -14.822,
              "y": -1.003,
              "z": 0.988
            },
            "gtin": "4000404257457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8444",
            "leftCorner": {
              "x": -14.819,
              "y": -1.003,
              "z": 0.988
            },
            "rightCorner": {
              "x": -14.822,
              "y": -0.822,
              "z": 0.988
            },
            "gtin": "4000404935355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8445",
            "leftCorner": {
              "x": -14.824,
              "y": -0.822,
              "z": 0.988
            },
            "rightCorner": {
              "x": -14.826,
              "y": -0.593,
              "z": 0.988
            },
            "gtin": "4000404943152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8446",
            "leftCorner": {
              "x": -14.833,
              "y": -0.593,
              "z": 0.988
            },
            "rightCorner": {
              "x": -14.834,
              "y": -0.549,
              "z": 0.988
            },
            "gtin": "4000404026053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8447",
            "leftCorner": {
              "x": -14.834,
              "y": -0.549,
              "z": 0.988
            },
            "rightCorner": {
              "x": -14.834,
              "y": -0.504,
              "z": 0.988
            },
            "gtin": "4000404026053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8448",
            "leftCorner": {
              "x": -14.834,
              "y": -0.504,
              "z": 0.988
            },
            "rightCorner": {
              "x": -14.835,
              "y": -0.46,
              "z": 0.988
            },
            "gtin": "4000404026053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8438",
            "leftCorner": {
              "x": -14.842,
              "y": -0.46,
              "z": 0.988
            },
            "rightCorner": {
              "x": -14.844,
              "y": -0.263,
              "z": 0.988
            },
            "gtin": "4000404055350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "436e0692fbce5f16d1d3e9ff",
            "leftCorner": {
              "x": -14.776,
              "y": -1.512,
              "z": 0.988
            },
            "rightCorner": {
              "x": -14.777,
              "y": -1.411,
              "z": 0.988
            },
            "gtin": "4000404035758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c832ec1bf5b53e06531a2216",
            "leftCorner": {
              "x": -14.777,
              "y": -1.411,
              "z": 0.988
            },
            "rightCorner": {
              "x": -14.778,
              "y": -1.309,
              "z": 0.988
            },
            "gtin": "4000404035758",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5be",
        "height": 1.4841,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8452",
            "leftCorner": {
              "x": -14.813,
              "y": -1.271,
              "z": 1.214
            },
            "rightCorner": {
              "x": -14.815,
              "y": -1.073,
              "z": 1.214
            },
            "gtin": "4048952502803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8453",
            "leftCorner": {
              "x": -14.811,
              "y": -1.073,
              "z": 1.214
            },
            "rightCorner": {
              "x": -14.813,
              "y": -0.875,
              "z": 1.214
            },
            "gtin": "4048952050267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8454",
            "leftCorner": {
              "x": -14.816,
              "y": -0.875,
              "z": 1.214
            },
            "rightCorner": {
              "x": -14.82,
              "y": -0.659,
              "z": 1.214
            },
            "gtin": "4048952500090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8455",
            "leftCorner": {
              "x": -14.825,
              "y": -0.659,
              "z": 1.214
            },
            "rightCorner": {
              "x": -14.826,
              "y": -0.485,
              "z": 1.214
            },
            "gtin": "4048952502100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d844b",
            "leftCorner": {
              "x": -14.836,
              "y": -0.485,
              "z": 1.214
            },
            "rightCorner": {
              "x": -14.839,
              "y": -0.263,
              "z": 1.214
            },
            "gtin": "4048952050205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ea417b8cd38d906cbc9d208d",
            "leftCorner": {
              "x": -14.769,
              "y": -1.512,
              "z": 1.214
            },
            "rightCorner": {
              "x": -14.772,
              "y": -1.295,
              "z": 1.214
            },
            "gtin": "4048952502902",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "787",
    "rightNeighborShelfId": "789"
  },
  {
    "id": "789",
    "name": "789",
    "x": -14.839,
    "y": -0.263,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71147,
      "w": 0.70272
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 41
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5c7",
        "height": 0.15878,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8479",
            "leftCorner": {
              "x": -14.775,
              "y": -0.219,
              "z": 0.13
            },
            "rightCorner": {
              "x": -14.777,
              "y": -0.005,
              "z": 0.13
            },
            "gtin": "4048952050144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d847a",
            "leftCorner": {
              "x": -14.773,
              "y": -0.005,
              "z": 0.13
            },
            "rightCorner": {
              "x": -14.776,
              "y": 0.15,
              "z": 0.13
            },
            "gtin": "4048952050953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d847b",
            "leftCorner": {
              "x": -14.782,
              "y": 0.15,
              "z": 0.13
            },
            "rightCorner": {
              "x": -14.783,
              "y": 0.231,
              "z": 0.13
            },
            "gtin": "4048952050946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d847c",
            "leftCorner": {
              "x": -14.783,
              "y": 0.231,
              "z": 0.13
            },
            "rightCorner": {
              "x": -14.783,
              "y": 0.313,
              "z": 0.13
            },
            "gtin": "4048952050946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d847d",
            "leftCorner": {
              "x": -14.783,
              "y": 0.313,
              "z": 0.13
            },
            "rightCorner": {
              "x": -14.785,
              "y": 0.395,
              "z": 0.13
            },
            "gtin": "4048952050946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8472",
            "leftCorner": {
              "x": -14.79,
              "y": 0.395,
              "z": 0.13
            },
            "rightCorner": {
              "x": -14.797,
              "y": 0.988,
              "z": 0.13
            },
            "gtin": "4002757010086",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5c3",
        "height": 0.43109,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8491",
            "leftCorner": {
              "x": -14.799,
              "y": -0.263,
              "z": 0.353
            },
            "rightCorner": {
              "x": -14.801,
              "y": -0.071,
              "z": 0.353
            },
            "gtin": "4003171124168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8493",
            "leftCorner": {
              "x": -14.839,
              "y": -0.071,
              "z": 0.353
            },
            "rightCorner": {
              "x": -14.842,
              "y": 0.161,
              "z": 0.353
            },
            "gtin": "4002834229103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8494",
            "leftCorner": {
              "x": -14.846,
              "y": 0.161,
              "z": 0.353
            },
            "rightCorner": {
              "x": -14.849,
              "y": 0.395,
              "z": 0.353
            },
            "gtin": "4002834229301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8495",
            "leftCorner": {
              "x": -14.856,
              "y": 0.395,
              "z": 0.353
            },
            "rightCorner": {
              "x": -14.858,
              "y": 0.586,
              "z": 0.353
            },
            "gtin": "4006276001235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8496",
            "leftCorner": {
              "x": -14.858,
              "y": 0.586,
              "z": 0.353
            },
            "rightCorner": {
              "x": -14.861,
              "y": 0.776,
              "z": 0.353
            },
            "gtin": "4006276001235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8497",
            "leftCorner": {
              "x": -14.845,
              "y": 0.776,
              "z": 0.353
            },
            "rightCorner": {
              "x": -14.848,
              "y": 0.987,
              "z": 0.353
            },
            "gtin": "4006276011180",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5c4",
        "height": 0.72945,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d849e",
            "leftCorner": {
              "x": -14.795,
              "y": -0.262,
              "z": 0.597
            },
            "rightCorner": {
              "x": -14.797,
              "y": -0.073,
              "z": 0.597
            },
            "gtin": "4104420205314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84a0",
            "leftCorner": {
              "x": -14.832,
              "y": -0.074,
              "z": 0.597
            },
            "rightCorner": {
              "x": -14.834,
              "y": 0.076,
              "z": 0.597
            },
            "gtin": "4104420205253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84a1",
            "leftCorner": {
              "x": -14.839,
              "y": 0.075,
              "z": 0.597
            },
            "rightCorner": {
              "x": -14.841,
              "y": 0.277,
              "z": 0.597
            },
            "gtin": "4104420205345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84a2",
            "leftCorner": {
              "x": -14.85,
              "y": 0.276,
              "z": 0.597
            },
            "rightCorner": {
              "x": -14.853,
              "y": 0.466,
              "z": 0.597
            },
            "gtin": "40354361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84a3",
            "leftCorner": {
              "x": -14.849,
              "y": 0.466,
              "z": 0.597
            },
            "rightCorner": {
              "x": -14.852,
              "y": 0.766,
              "z": 0.597
            },
            "gtin": "4000404003139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84a4",
            "leftCorner": {
              "x": -14.841,
              "y": 0.766,
              "z": 0.597
            },
            "rightCorner": {
              "x": -14.843,
              "y": 0.987,
              "z": 0.597
            },
            "gtin": "4000503212005",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5c6",
        "height": 0.95748,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d84b9",
            "leftCorner": {
              "x": -14.8,
              "y": -0.263,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.806,
              "y": 0.145,
              "z": 0.783
            },
            "gtin": "4003473001303",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d84bb",
            "leftCorner": {
              "x": -14.846,
              "y": 0.145,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.847,
              "y": 0.311,
              "z": 0.783
            },
            "gtin": "4003473001709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84bc",
            "leftCorner": {
              "x": -14.853,
              "y": 0.311,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.855,
              "y": 0.493,
              "z": 0.783
            },
            "gtin": "4003473001402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84bd",
            "leftCorner": {
              "x": -14.859,
              "y": 0.493,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.861,
              "y": 0.737,
              "z": 0.783
            },
            "gtin": "4003473017601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84be",
            "leftCorner": {
              "x": -14.841,
              "y": 0.737,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.845,
              "y": 0.996,
              "z": 0.783
            },
            "gtin": "4003473017304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84bf",
            "leftCorner": {
              "x": -14.855,
              "y": 0.995,
              "z": 0.783
            },
            "rightCorner": {
              "x": -14.858,
              "y": 1.262,
              "z": 0.783
            },
            "gtin": "4003473017502",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5c5",
        "height": 1.2349,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d84a9",
            "leftCorner": {
              "x": -14.798,
              "y": -0.262,
              "z": 1.01
            },
            "rightCorner": {
              "x": -14.801,
              "y": -0.047,
              "z": 1.01
            },
            "gtin": "4037500867419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84ab",
            "leftCorner": {
              "x": -14.837,
              "y": -0.048,
              "z": 1.01
            },
            "rightCorner": {
              "x": -14.839,
              "y": 0.154,
              "z": 1.01
            },
            "gtin": "4037500867433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84ac",
            "leftCorner": {
              "x": -14.847,
              "y": 0.154,
              "z": 1.01
            },
            "rightCorner": {
              "x": -14.849,
              "y": 0.329,
              "z": 1.01
            },
            "gtin": "4037500867402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84ad",
            "leftCorner": {
              "x": -14.854,
              "y": 0.329,
              "z": 1.01
            },
            "rightCorner": {
              "x": -14.856,
              "y": 0.499,
              "z": 1.01
            },
            "gtin": "4037500867426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84ae",
            "leftCorner": {
              "x": -14.854,
              "y": 0.499,
              "z": 1.01
            },
            "rightCorner": {
              "x": -14.856,
              "y": 0.684,
              "z": 1.01
            },
            "gtin": "4037500867341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84af",
            "leftCorner": {
              "x": -14.846,
              "y": 0.685,
              "z": 1.01
            },
            "rightCorner": {
              "x": -14.847,
              "y": 0.852,
              "z": 1.01
            },
            "gtin": "40354033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84b0",
            "leftCorner": {
              "x": -14.846,
              "y": 0.852,
              "z": 1.01
            },
            "rightCorner": {
              "x": -14.849,
              "y": 1.023,
              "z": 1.01
            },
            "gtin": "40354057",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5c2",
        "height": 1.5363,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d847e",
            "leftCorner": {
              "x": -14.789,
              "y": -0.262,
              "z": 1.257
            },
            "rightCorner": {
              "x": -14.791,
              "y": -0.139,
              "z": 1.257
            },
            "gtin": "4058700734707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8480",
            "leftCorner": {
              "x": -14.83,
              "y": -0.14,
              "z": 1.257
            },
            "rightCorner": {
              "x": -14.831,
              "y": -0.056,
              "z": 1.257
            },
            "gtin": "4058700734820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8481",
            "leftCorner": {
              "x": -14.831,
              "y": -0.056,
              "z": 1.257
            },
            "rightCorner": {
              "x": -14.832,
              "y": 0.046,
              "z": 1.257
            },
            "gtin": "4007680107636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8482",
            "leftCorner": {
              "x": -14.838,
              "y": 0.046,
              "z": 1.257
            },
            "rightCorner": {
              "x": -14.839,
              "y": 0.115,
              "z": 1.257
            },
            "gtin": "4007680107629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8483",
            "leftCorner": {
              "x": -14.839,
              "y": 0.115,
              "z": 1.257
            },
            "rightCorner": {
              "x": -14.839,
              "y": 0.184,
              "z": 1.257
            },
            "gtin": "4007680107629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8484",
            "leftCorner": {
              "x": -14.839,
              "y": 0.184,
              "z": 1.257
            },
            "rightCorner": {
              "x": -14.841,
              "y": 0.254,
              "z": 1.257
            },
            "gtin": "4007680107629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8485",
            "leftCorner": {
              "x": -14.847,
              "y": 0.254,
              "z": 1.257
            },
            "rightCorner": {
              "x": -14.849,
              "y": 0.396,
              "z": 1.257
            },
            "gtin": "4009062800029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8486",
            "leftCorner": {
              "x": -14.85,
              "y": 0.396,
              "z": 1.257
            },
            "rightCorner": {
              "x": -14.851,
              "y": 0.53,
              "z": 1.257
            },
            "gtin": "4009062800395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8487",
            "leftCorner": {
              "x": -14.84,
              "y": 0.53,
              "z": 1.257
            },
            "rightCorner": {
              "x": -14.842,
              "y": 0.669,
              "z": 1.257
            },
            "gtin": "4009062800845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8488",
            "leftCorner": {
              "x": -14.839,
              "y": 0.669,
              "z": 1.257
            },
            "rightCorner": {
              "x": -14.84,
              "y": 0.849,
              "z": 1.257
            },
            "gtin": "4013200465353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8489",
            "leftCorner": {
              "x": -14.841,
              "y": 0.849,
              "z": 1.257
            },
            "rightCorner": {
              "x": -14.843,
              "y": 0.995,
              "z": 1.257
            },
            "gtin": "4013200465339",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "788",
    "rightNeighborShelfId": "2d5"
  },
  {
    "id": "78c",
    "name": "78c",
    "x": -18.695,
    "y": 2.174,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70349,
      "w": 0.7107
    },
    "layers": [],

    "rightNeighborShelfId": "78d"
  },
  {
    "id": "78d",
    "name": "78d",
    "x": -18.682,
    "y": 0.924,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70349,
      "w": 0.7107
    },
    "layers": [],
    "leftNeighborShelfId": "78c",
    "rightNeighborShelfId": "78e"
  },
  {
    "id": "78e",
    "name": "78e",
    "x": -18.669,
    "y": -0.326,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70349,
      "w": 0.7107
    },
    "layers": [],
    "leftNeighborShelfId": "78d",
    "rightNeighborShelfId": "78f"
  },
  {
    "id": "78f",
    "name": "78f",
    "x": -18.656,
    "y": -1.576,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70349,
      "w": 0.7107
    },
    "layers": [],
    "leftNeighborShelfId": "78e"
  },
  {
    "id": "790",
    "name": "790",
    "x": -17.424,
    "y": -2.807,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70648,
      "w": 0.70774
    },
    "layers": [],

    "rightNeighborShelfId": "791"
  },
  {
    "id": "791",
    "name": "791",
    "x": -17.422,
    "y": -1.557,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70648,
      "w": 0.70774
    },
    "layers": [],
    "leftNeighborShelfId": "790",
    "rightNeighborShelfId": "792"
  },
  {
    "id": "792",
    "name": "792",
    "x": -17.42,
    "y": -0.307,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70648,
      "w": 0.70774
    },
    "layers": [],
    "leftNeighborShelfId": "791",
    "rightNeighborShelfId": "793"
  },
  {
    "id": "793",
    "name": "793",
    "x": -17.417,
    "y": 0.943,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70648,
      "w": 0.70774
    },
    "layers": [],
    "leftNeighborShelfId": "792"
  },
  {
    "id": "794",
    "name": "794",
    "x": -20.385,
    "y": -4.051,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70742,
      "w": 0.70679
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 49,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5df",
        "height": 0.17148,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7bea",
            "leftCorner": {
              "x": -20.299,
              "y": -4.051,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.299,
              "y": -3.903,
              "z": 0.14
            },
            "gtin": "4101040001487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bec",
            "leftCorner": {
              "x": -20.338,
              "y": -3.903,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.338,
              "y": -3.734,
              "z": 0.14
            },
            "gtin": "4101040001319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bed",
            "leftCorner": {
              "x": -20.342,
              "y": -3.734,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.342,
              "y": -3.589,
              "z": 0.14
            },
            "gtin": "4006940220023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bee",
            "leftCorner": {
              "x": -20.341,
              "y": -3.589,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.341,
              "y": -3.427,
              "z": 0.14
            },
            "gtin": "4006940440025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bef",
            "leftCorner": {
              "x": -20.339,
              "y": -3.427,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.339,
              "y": -3.268,
              "z": 0.14
            },
            "gtin": "4006940450321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bf0",
            "leftCorner": {
              "x": -20.334,
              "y": -3.268,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.334,
              "y": -3.124,
              "z": 0.14
            },
            "gtin": "4006940450949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bf1",
            "leftCorner": {
              "x": -20.336,
              "y": -3.125,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.336,
              "y": -3.012,
              "z": 0.14
            },
            "gtin": "4006940440353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bf2",
            "leftCorner": {
              "x": -20.339,
              "y": -3.012,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.339,
              "y": -2.921,
              "z": 0.14
            },
            "gtin": "4006940440322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bf3",
            "leftCorner": {
              "x": -20.341,
              "y": -2.921,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.34,
              "y": -2.74,
              "z": 0.14
            },
            "gtin": "4006940451526",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5dd",
        "height": 0.56462,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b32",
            "leftCorner": {
              "x": -20.287,
              "y": -4.051,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.287,
              "y": -3.925,
              "z": 0.462
            },
            "gtin": "4101040050430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b34",
            "leftCorner": {
              "x": -20.335,
              "y": -3.925,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.335,
              "y": -3.842,
              "z": 0.462
            },
            "gtin": "4101040050379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b35",
            "leftCorner": {
              "x": -20.328,
              "y": -3.842,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.327,
              "y": -3.762,
              "z": 0.462
            },
            "gtin": "4000486017826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b36",
            "leftCorner": {
              "x": -20.327,
              "y": -3.762,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.327,
              "y": -3.658,
              "z": 0.462
            },
            "gtin": "4101040036502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b37",
            "leftCorner": {
              "x": -20.328,
              "y": -3.658,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.328,
              "y": -3.555,
              "z": 0.462
            },
            "gtin": "4101040025582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b38",
            "leftCorner": {
              "x": -20.327,
              "y": -3.555,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.327,
              "y": -3.464,
              "z": 0.462
            },
            "gtin": "4101040045733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b39",
            "leftCorner": {
              "x": -20.324,
              "y": -3.464,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.324,
              "y": -3.374,
              "z": 0.462
            },
            "gtin": "4101040045771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b3a",
            "leftCorner": {
              "x": -20.326,
              "y": -3.374,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.326,
              "y": -3.225,
              "z": 0.462
            },
            "gtin": "4006940440476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b3b",
            "leftCorner": {
              "x": -20.32,
              "y": -3.225,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.32,
              "y": -3.056,
              "z": 0.462
            },
            "gtin": "4006940441237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b3c",
            "leftCorner": {
              "x": -20.328,
              "y": -3.056,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.329,
              "y": -3.005,
              "z": 0.462
            },
            "gtin": "4006940441121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b3d",
            "leftCorner": {
              "x": -20.327,
              "y": -3.005,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.327,
              "y": -2.916,
              "z": 0.462
            },
            "gtin": "4006940447222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b3e",
            "leftCorner": {
              "x": -20.325,
              "y": -2.916,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.325,
              "y": -2.83,
              "z": 0.462
            },
            "gtin": "4006940447215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b3f",
            "leftCorner": {
              "x": -20.325,
              "y": -2.83,
              "z": 0.462
            },
            "rightCorner": {
              "x": -20.325,
              "y": -2.744,
              "z": 0.462
            },
            "gtin": "4006940447215",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5e0",
        "height": 0.95609,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b71",
            "leftCorner": {
              "x": -20.296,
              "y": -4.051,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.296,
              "y": -3.941,
              "z": 0.782
            },
            "gtin": "4101040001128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b72",
            "leftCorner": {
              "x": -20.296,
              "y": -3.941,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.296,
              "y": -3.832,
              "z": 0.782
            },
            "gtin": "4101040001128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b74",
            "leftCorner": {
              "x": -20.341,
              "y": -3.832,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.341,
              "y": -3.64,
              "z": 0.782
            },
            "gtin": "4101040046327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b75",
            "leftCorner": {
              "x": -20.339,
              "y": -3.64,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.339,
              "y": -3.563,
              "z": 0.782
            },
            "gtin": "4101040047225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b76",
            "leftCorner": {
              "x": -20.339,
              "y": -3.563,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.338,
              "y": -3.485,
              "z": 0.782
            },
            "gtin": "4101040047225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b77",
            "leftCorner": {
              "x": -20.338,
              "y": -3.485,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.339,
              "y": -3.408,
              "z": 0.782
            },
            "gtin": "4101040047225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b78",
            "leftCorner": {
              "x": -20.336,
              "y": -3.408,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.337,
              "y": -3.252,
              "z": 0.782
            },
            "gtin": "4101040045900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b79",
            "leftCorner": {
              "x": -20.331,
              "y": -3.252,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.331,
              "y": -3.152,
              "z": 0.782
            },
            "gtin": "4006940442654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b7a",
            "leftCorner": {
              "x": -20.334,
              "y": -3.152,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.334,
              "y": -3.064,
              "z": 0.782
            },
            "gtin": "4006940442852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b7b",
            "leftCorner": {
              "x": -20.334,
              "y": -3.064,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.333,
              "y": -2.98,
              "z": 0.782
            },
            "gtin": "4006940441442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b7c",
            "leftCorner": {
              "x": -20.337,
              "y": -2.98,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.337,
              "y": -2.892,
              "z": 0.782
            },
            "gtin": "4006940449295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b7d",
            "leftCorner": {
              "x": -20.336,
              "y": -2.892,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.337,
              "y": -2.751,
              "z": 0.782
            },
            "gtin": "4006940443019",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5de",
        "height": 1.3613,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7aea",
            "leftCorner": {
              "x": -20.292,
              "y": -4.051,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.292,
              "y": -3.872,
              "z": 1.114
            },
            "gtin": "4101040018003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aeb",
            "leftCorner": {
              "x": -20.336,
              "y": -3.873,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.337,
              "y": -3.76,
              "z": 1.114
            },
            "gtin": "4101040001012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aec",
            "leftCorner": {
              "x": -20.335,
              "y": -3.76,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.336,
              "y": -3.639,
              "z": 1.114
            },
            "gtin": "4101040001074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aed",
            "leftCorner": {
              "x": -20.336,
              "y": -3.639,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.336,
              "y": -3.469,
              "z": 1.114
            },
            "gtin": "4101040001180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aee",
            "leftCorner": {
              "x": -20.333,
              "y": -3.469,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.334,
              "y": -3.302,
              "z": 1.114
            },
            "gtin": "4101040001944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aef",
            "leftCorner": {
              "x": -20.33,
              "y": -3.302,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.33,
              "y": -3.207,
              "z": 1.114
            },
            "gtin": "4101040048925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7af0",
            "leftCorner": {
              "x": -20.329,
              "y": -3.207,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.329,
              "y": -3.107,
              "z": 1.114
            },
            "gtin": "4101040048918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7af1",
            "leftCorner": {
              "x": -20.332,
              "y": -3.107,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.332,
              "y": -3.021,
              "z": 1.114
            },
            "gtin": "4006940440506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7af2",
            "leftCorner": {
              "x": -20.332,
              "y": -3.022,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.333,
              "y": -2.804,
              "z": 1.114
            },
            "gtin": "4006940441756",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5e1",
        "height": 1.7344,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7bb1",
            "leftCorner": {
              "x": -20.295,
              "y": -4.051,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.296,
              "y": -3.788,
              "z": 1.419
            },
            "gtin": "4006940456453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bb3",
            "leftCorner": {
              "x": -20.339,
              "y": -3.788,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.339,
              "y": -3.516,
              "z": 1.419
            },
            "gtin": "4006940456477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bb4",
            "leftCorner": {
              "x": -20.335,
              "y": -3.516,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.336,
              "y": -3.249,
              "z": 1.419
            },
            "gtin": "4006940456491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bb5",
            "leftCorner": {
              "x": -20.33,
              "y": -3.249,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.331,
              "y": -3.096,
              "z": 1.419
            },
            "gtin": "4006940440360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bb6",
            "leftCorner": {
              "x": -20.334,
              "y": -3.096,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.333,
              "y": -2.931,
              "z": 1.419
            },
            "gtin": "4006940443903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bb7",
            "leftCorner": {
              "x": -20.339,
              "y": -2.931,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.339,
              "y": -2.743,
              "z": 1.419
            },
            "gtin": "4006940441480",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "796"
  },
  {
    "id": "796",
    "name": "796",
    "x": -20.386,
    "y": -2.801,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70742,
      "w": 0.70679
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 52,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d49a",
        "height": 0.17,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7bf4",
            "leftCorner": {
              "x": -20.341,
              "y": -2.74,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.341,
              "y": -2.665,
              "z": 0.139
            },
            "gtin": "4006940449257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bdca167bd5d93a89b04cfec8",
            "leftCorner": {
              "x": -20.307,
              "y": -2.801,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.307,
              "y": -2.75,
              "z": 0.139
            },
            "gtin": "4006940449257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bf5",
            "leftCorner": {
              "x": -20.341,
              "y": -2.665,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.342,
              "y": -2.591,
              "z": 0.139
            },
            "gtin": "4006940449257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bf6",
            "leftCorner": {
              "x": -20.345,
              "y": -2.591,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.345,
              "y": -2.512,
              "z": 0.139
            },
            "gtin": "4006940330821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bf7",
            "leftCorner": {
              "x": -20.345,
              "y": -2.512,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.345,
              "y": -2.433,
              "z": 0.139
            },
            "gtin": "4006940330821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bf8",
            "leftCorner": {
              "x": -20.346,
              "y": -2.433,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.346,
              "y": -2.348,
              "z": 0.139
            },
            "gtin": "4006940448731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bf9",
            "leftCorner": {
              "x": -20.346,
              "y": -2.348,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.346,
              "y": -2.263,
              "z": 0.139
            },
            "gtin": "4006940448731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bfa",
            "leftCorner": {
              "x": -20.347,
              "y": -2.263,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.347,
              "y": -2.178,
              "z": 0.139
            },
            "gtin": "4006940449301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bfb",
            "leftCorner": {
              "x": -20.347,
              "y": -2.178,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.347,
              "y": -2.093,
              "z": 0.139
            },
            "gtin": "4006940449301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bfc",
            "leftCorner": {
              "x": -20.35,
              "y": -2.093,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.35,
              "y": -2.011,
              "z": 0.139
            },
            "gtin": "4006940110126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bfd",
            "leftCorner": {
              "x": -20.35,
              "y": -2.011,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.35,
              "y": -1.929,
              "z": 0.139
            },
            "gtin": "4006940110126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bfe",
            "leftCorner": {
              "x": -20.35,
              "y": -1.929,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.35,
              "y": -1.815,
              "z": 0.139
            },
            "gtin": "4006940110027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bff",
            "leftCorner": {
              "x": -20.348,
              "y": -1.815,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.347,
              "y": -1.728,
              "z": 0.139
            },
            "gtin": "4009415202210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c00",
            "leftCorner": {
              "x": -20.347,
              "y": -1.728,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.348,
              "y": -1.64,
              "z": 0.139
            },
            "gtin": "4009415202210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c01",
            "leftCorner": {
              "x": -20.385,
              "y": -1.64,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.385,
              "y": -1.492,
              "z": 0.139
            },
            "gtin": "4009887401708",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d497",
        "height": 0.56625,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b40",
            "leftCorner": {
              "x": -20.329,
              "y": -2.744,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.329,
              "y": -2.599,
              "z": 0.463
            },
            "gtin": "4006940449158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d547811b98ec5c4cbf536395",
            "leftCorner": {
              "x": -20.294,
              "y": -2.801,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.294,
              "y": -2.749,
              "z": 0.463
            },
            "gtin": "4006940440575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b41",
            "leftCorner": {
              "x": -20.333,
              "y": -2.599,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.333,
              "y": -2.52,
              "z": 0.463
            },
            "gtin": "4006940441824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b42",
            "leftCorner": {
              "x": -20.333,
              "y": -2.52,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.334,
              "y": -2.441,
              "z": 0.463
            },
            "gtin": "4006940441824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b43",
            "leftCorner": {
              "x": -20.335,
              "y": -2.441,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.334,
              "y": -2.293,
              "z": 0.463
            },
            "gtin": "4006940446928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b44",
            "leftCorner": {
              "x": -20.333,
              "y": -2.294,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.333,
              "y": -2.135,
              "z": 0.463
            },
            "gtin": "4006940440575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b45",
            "leftCorner": {
              "x": -20.335,
              "y": -2.135,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.335,
              "y": -1.937,
              "z": 0.463
            },
            "gtin": "4061800081206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b46",
            "leftCorner": {
              "x": -20.336,
              "y": -1.937,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.336,
              "y": -1.724,
              "z": 0.463
            },
            "gtin": "4001731200796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b47",
            "leftCorner": {
              "x": -20.603,
              "y": -1.724,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.604,
              "y": -1.385,
              "z": 0.463
            },
            "gtin": "4001254139122",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d498",
        "height": 0.95629,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b7e",
            "leftCorner": {
              "x": -20.341,
              "y": -2.751,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.34,
              "y": -2.621,
              "z": 0.782
            },
            "gtin": "4006940641507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "17222595609b028a9afb98cc",
            "leftCorner": {
              "x": -20.305,
              "y": -2.801,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.305,
              "y": -2.751,
              "z": 0.782
            },
            "gtin": "4006940641408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b7f",
            "leftCorner": {
              "x": -20.343,
              "y": -2.621,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.343,
              "y": -2.484,
              "z": 0.782
            },
            "gtin": "4006940678305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b80",
            "leftCorner": {
              "x": -20.346,
              "y": -2.484,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.346,
              "y": -2.338,
              "z": 0.782
            },
            "gtin": "4006940641408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b81",
            "leftCorner": {
              "x": -20.345,
              "y": -2.338,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.344,
              "y": -2.237,
              "z": 0.782
            },
            "gtin": "4006940681503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b82",
            "leftCorner": {
              "x": -20.344,
              "y": -2.237,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.345,
              "y": -2.136,
              "z": 0.782
            },
            "gtin": "4006940681503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b83",
            "leftCorner": {
              "x": -20.58,
              "y": -2.136,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.58,
              "y": -1.97,
              "z": 0.782
            }
          },
          {
            "id": "68d8e50de1820c81800d7b84",
            "leftCorner": {
              "x": -20.349,
              "y": -1.97,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.349,
              "y": -1.842,
              "z": 0.782
            },
            "gtin": "5010278103209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b85",
            "leftCorner": {
              "x": -20.345,
              "y": -1.842,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.345,
              "y": -1.688,
              "z": 0.782
            }
          },
          {
            "id": "68d8e50de1820c81800d7b86",
            "leftCorner": {
              "x": -20.343,
              "y": -1.688,
              "z": 0.782
            },
            "rightCorner": {
              "x": -20.344,
              "y": -1.508,
              "z": 0.782
            }
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d496",
        "height": 1.3613,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7af3",
            "leftCorner": {
              "x": -20.341,
              "y": -2.804,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.341,
              "y": -2.647,
              "z": 1.114
            },
            "gtin": "4006940449325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7af4",
            "leftCorner": {
              "x": -20.34,
              "y": -2.647,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.34,
              "y": -2.563,
              "z": 1.114
            },
            "gtin": "4006940455999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7af5",
            "leftCorner": {
              "x": -20.341,
              "y": -2.563,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.341,
              "y": -2.456,
              "z": 1.114
            },
            "gtin": "4006940441336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7af6",
            "leftCorner": {
              "x": -20.343,
              "y": -2.456,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.343,
              "y": -2.392,
              "z": 1.114
            },
            "gtin": "5010106113127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7af7",
            "leftCorner": {
              "x": -20.343,
              "y": -2.392,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.344,
              "y": -2.328,
              "z": 1.114
            },
            "gtin": "5010106113127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7af8",
            "leftCorner": {
              "x": -20.344,
              "y": -2.328,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.344,
              "y": -2.264,
              "z": 1.114
            },
            "gtin": "5010106113127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7afa",
            "leftCorner": {
              "x": -20.283,
              "y": -2.233,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.284,
              "y": -2.068,
              "z": 1.114
            },
            "gtin": "5011026108033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7afb",
            "leftCorner": {
              "x": -20.343,
              "y": -2.068,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.343,
              "y": -1.843,
              "z": 1.114
            },
            "gtin": "5011026108033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7afc",
            "leftCorner": {
              "x": -20.342,
              "y": -1.843,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.342,
              "y": -1.788,
              "z": 1.114
            },
            "gtin": "4007675206290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7afd",
            "leftCorner": {
              "x": -20.342,
              "y": -1.788,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.341,
              "y": -1.734,
              "z": 1.114
            },
            "gtin": "4007675206290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7afe",
            "leftCorner": {
              "x": -20.342,
              "y": -1.734,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.343,
              "y": -1.511,
              "z": 1.114
            },
            "gtin": "4016500018205",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d499",
        "height": 1.7328,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7bb8",
            "leftCorner": {
              "x": -20.341,
              "y": -2.743,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.342,
              "y": -2.542,
              "z": 1.418
            },
            "gtin": "4006940441602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dd5087fe49539b6b155e0212",
            "leftCorner": {
              "x": -20.305,
              "y": -2.801,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.305,
              "y": -2.743,
              "z": 1.418
            },
            "gtin": "5013967004016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bb9",
            "leftCorner": {
              "x": -20.349,
              "y": -2.542,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.349,
              "y": -2.483,
              "z": 1.418
            },
            "gtin": "4251562900079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bba",
            "leftCorner": {
              "x": -20.343,
              "y": -2.483,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.343,
              "y": -2.351,
              "z": 1.418
            },
            "gtin": "4006940443057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bbb",
            "leftCorner": {
              "x": -20.344,
              "y": -2.351,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.345,
              "y": -2.23,
              "z": 1.418
            },
            "gtin": "5202795120054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bbc",
            "leftCorner": {
              "x": -20.345,
              "y": -2.23,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.345,
              "y": -2.109,
              "z": 1.418
            },
            "gtin": "5202795120054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bbd",
            "leftCorner": {
              "x": -20.348,
              "y": -2.108,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.348,
              "y": -1.971,
              "z": 1.418
            },
            "gtin": "5202795130022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bbe",
            "leftCorner": {
              "x": -20.349,
              "y": -1.971,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.348,
              "y": -1.85,
              "z": 1.418
            },
            "gtin": "3147690051107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bbf",
            "leftCorner": {
              "x": -20.345,
              "y": -1.85,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.346,
              "y": -1.729,
              "z": 1.418
            },
            "gtin": "5010327000497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bc0",
            "leftCorner": {
              "x": -20.345,
              "y": -1.729,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.345,
              "y": -1.609,
              "z": 1.418
            },
            "gtin": "5010327000404",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7bc1",
            "leftCorner": {
              "x": -20.337,
              "y": -1.609,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.337,
              "y": -1.459,
              "z": 1.418
            },
            "gtin": "5013967004016",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "794",
    "rightNeighborShelfId": "797"
  },
  {
    "id": "797",
    "name": "797",
    "x": -20.387,
    "y": -1.551,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70742,
      "w": 0.70679
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 46,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4a4",
        "height": 0.16263,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c02",
            "leftCorner": {
              "x": -20.343,
              "y": -1.492,
              "z": 0.133
            },
            "rightCorner": {
              "x": -20.343,
              "y": -1.33,
              "z": 0.133
            },
            "gtin": "4045144710701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c03",
            "leftCorner": {
              "x": -20.468,
              "y": -1.331,
              "z": 0.133
            },
            "rightCorner": {
              "x": -20.468,
              "y": -0.953,
              "z": 0.133
            },
            "gtin": "4045144700702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c04",
            "leftCorner": {
              "x": -20.349,
              "y": -0.953,
              "z": 0.133
            },
            "rightCorner": {
              "x": -20.349,
              "y": -0.796,
              "z": 0.133
            },
            "gtin": "4306188410195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c05",
            "leftCorner": {
              "x": -20.347,
              "y": -0.796,
              "z": 0.133
            },
            "rightCorner": {
              "x": -20.347,
              "y": -0.703,
              "z": 0.133
            },
            "gtin": "4002137101175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c06",
            "leftCorner": {
              "x": -20.347,
              "y": -0.703,
              "z": 0.133
            },
            "rightCorner": {
              "x": -20.348,
              "y": -0.61,
              "z": 0.133
            },
            "gtin": "4002137101175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c07",
            "leftCorner": {
              "x": -20.347,
              "y": -0.61,
              "z": 0.133
            },
            "rightCorner": {
              "x": -20.347,
              "y": -0.513,
              "z": 0.133
            },
            "gtin": "4306188410126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c08",
            "leftCorner": {
              "x": -20.348,
              "y": -0.513,
              "z": 0.133
            },
            "rightCorner": {
              "x": -20.348,
              "y": -0.379,
              "z": 0.133
            },
            "gtin": "4306188410089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c09",
            "leftCorner": {
              "x": -20.338,
              "y": -0.379,
              "z": 0.133
            },
            "rightCorner": {
              "x": -20.338,
              "y": -0.221,
              "z": 0.133
            },
            "gtin": "4062400521109",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d49f",
        "height": 0.56245,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b48",
            "leftCorner": {
              "x": -20.337,
              "y": -1.384,
              "z": 0.46
            },
            "rightCorner": {
              "x": -20.337,
              "y": -1.295,
              "z": 0.46
            },
            "gtin": "4260099736273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "75c51b4bac2439d527ffb7aa",
            "leftCorner": {
              "x": -20.294,
              "y": -1.551,
              "z": 0.46
            },
            "rightCorner": {
              "x": -20.294,
              "y": -1.388,
              "z": 0.46
            },
            "gtin": "4034200010053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b49",
            "leftCorner": {
              "x": -20.337,
              "y": -1.295,
              "z": 0.46
            },
            "rightCorner": {
              "x": -20.337,
              "y": -1.206,
              "z": 0.46
            },
            "gtin": "4260099736273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b4a",
            "leftCorner": {
              "x": -20.348,
              "y": -1.206,
              "z": 0.46
            },
            "rightCorner": {
              "x": -20.348,
              "y": -1.128,
              "z": 0.46
            },
            "gtin": "4001255019225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b4b",
            "leftCorner": {
              "x": -20.348,
              "y": -1.128,
              "z": 0.46
            },
            "rightCorner": {
              "x": -20.349,
              "y": -1.049,
              "z": 0.46
            },
            "gtin": "4001255019225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b4c",
            "leftCorner": {
              "x": -20.339,
              "y": -1.049,
              "z": 0.46
            },
            "rightCorner": {
              "x": -20.339,
              "y": -0.891,
              "z": 0.46
            },
            "gtin": "4034200010053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b4d",
            "leftCorner": {
              "x": -20.334,
              "y": -0.891,
              "z": 0.46
            },
            "rightCorner": {
              "x": -20.335,
              "y": -0.765,
              "z": 0.46
            },
            "gtin": "4003310014244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b4e",
            "leftCorner": {
              "x": -20.334,
              "y": -0.765,
              "z": 0.46
            },
            "rightCorner": {
              "x": -20.333,
              "y": -0.573,
              "z": 0.46
            },
            "gtin": "4003310014190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b4f",
            "leftCorner": {
              "x": -20.335,
              "y": -0.573,
              "z": 0.46
            },
            "rightCorner": {
              "x": -20.334,
              "y": -0.427,
              "z": 0.46
            },
            "gtin": "4062400172004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b50",
            "leftCorner": {
              "x": -20.332,
              "y": -0.427,
              "z": 0.46
            },
            "rightCorner": {
              "x": -20.333,
              "y": -0.241,
              "z": 0.46
            },
            "gtin": "4000269003428",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4a1",
        "height": 0.95352,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b87",
            "leftCorner": {
              "x": -20.337,
              "y": -1.508,
              "z": 0.78
            },
            "rightCorner": {
              "x": -20.337,
              "y": -1.357,
              "z": 0.78
            },
            "gtin": "5010494508307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b88",
            "leftCorner": {
              "x": -20.36,
              "y": -1.357,
              "z": 0.78
            },
            "rightCorner": {
              "x": -20.361,
              "y": -1.262,
              "z": 0.78
            },
            "gtin": "8410337055086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b89",
            "leftCorner": {
              "x": -20.361,
              "y": -1.262,
              "z": 0.78
            },
            "rightCorner": {
              "x": -20.361,
              "y": -1.168,
              "z": 0.78
            },
            "gtin": "8410337055086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b8a",
            "leftCorner": {
              "x": -20.615,
              "y": -1.168,
              "z": 0.78
            },
            "rightCorner": {
              "x": -20.615,
              "y": -0.856,
              "z": 0.78
            },
            "gtin": "8410337031080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b8b",
            "leftCorner": {
              "x": -20.346,
              "y": -0.856,
              "z": 0.78
            },
            "rightCorner": {
              "x": -20.346,
              "y": -0.698,
              "z": 0.78
            },
            "gtin": "5000299223017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b8c",
            "leftCorner": {
              "x": -20.343,
              "y": -0.698,
              "z": 0.78
            },
            "rightCorner": {
              "x": -20.343,
              "y": -0.511,
              "z": 0.78
            },
            "gtin": "4006714001100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b8d",
            "leftCorner": {
              "x": -20.346,
              "y": -0.511,
              "z": 0.78
            },
            "rightCorner": {
              "x": -20.346,
              "y": -0.395,
              "z": 0.78
            },
            "gtin": "4061800083200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b8e",
            "leftCorner": {
              "x": -20.344,
              "y": -0.395,
              "z": 0.78
            },
            "rightCorner": {
              "x": -20.344,
              "y": -0.165,
              "z": 0.78
            },
            "gtin": "9001700090361",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d49e",
        "height": 1.3579,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7aff",
            "leftCorner": {
              "x": -20.33,
              "y": -1.511,
              "z": 1.111
            },
            "rightCorner": {
              "x": -20.33,
              "y": -1.41,
              "z": 1.111
            },
            "gtin": "4062400123525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b00",
            "leftCorner": {
              "x": -20.339,
              "y": -1.41,
              "z": 1.111
            },
            "rightCorner": {
              "x": -20.34,
              "y": -1.336,
              "z": 1.111
            },
            "gtin": "7610113004470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b01",
            "leftCorner": {
              "x": -20.34,
              "y": -1.336,
              "z": 1.111
            },
            "rightCorner": {
              "x": -20.34,
              "y": -1.263,
              "z": 1.111
            },
            "gtin": "7610113004470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b02",
            "leftCorner": {
              "x": -20.354,
              "y": -1.263,
              "z": 1.111
            },
            "rightCorner": {
              "x": -20.354,
              "y": -1.104,
              "z": 1.111
            },
            "gtin": "7610113007518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b03",
            "leftCorner": {
              "x": -20.357,
              "y": -1.104,
              "z": 1.111
            },
            "rightCorner": {
              "x": -20.357,
              "y": -0.945,
              "z": 1.111
            },
            "gtin": "7610113028124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b04",
            "leftCorner": {
              "x": -20.345,
              "y": -0.945,
              "z": 1.111
            },
            "rightCorner": {
              "x": -20.345,
              "y": -0.791,
              "z": 1.111
            },
            "gtin": "7610113030455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b05",
            "leftCorner": {
              "x": -20.341,
              "y": -0.791,
              "z": 1.111
            },
            "rightCorner": {
              "x": -20.341,
              "y": -0.627,
              "z": 1.111
            },
            "gtin": "5010677012638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b06",
            "leftCorner": {
              "x": -20.341,
              "y": -0.627,
              "z": 1.111
            },
            "rightCorner": {
              "x": -20.341,
              "y": -0.472,
              "z": 1.111
            },
            "gtin": "7610113004159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b07",
            "leftCorner": {
              "x": -20.418,
              "y": -0.472,
              "z": 1.111
            },
            "rightCorner": {
              "x": -20.417,
              "y": -0.37,
              "z": 1.111
            },
            "gtin": "8501110088831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b08",
            "leftCorner": {
              "x": -20.346,
              "y": -0.37,
              "z": 1.111
            },
            "rightCorner": {
              "x": -20.347,
              "y": -0.28,
              "z": 1.111
            },
            "gtin": "8501110083249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b09",
            "leftCorner": {
              "x": -20.347,
              "y": -0.28,
              "z": 1.111
            },
            "rightCorner": {
              "x": -20.347,
              "y": -0.189,
              "z": 1.111
            },
            "gtin": "8501110083249",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4a0",
        "height": 1.7301,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7bc2",
            "leftCorner": {
              "x": -20.334,
              "y": -1.459,
              "z": 1.416
            },
            "rightCorner": {
              "x": -20.334,
              "y": -1.356,
              "z": 1.416
            },
            "gtin": "5010314700003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "19c97299dfb7af5584b1a3cf",
            "leftCorner": {
              "x": -20.306,
              "y": -1.551,
              "z": 1.416
            },
            "rightCorner": {
              "x": -20.306,
              "y": -1.484,
              "z": 1.416
            },
            "gtin": "8501110086196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bc3",
            "leftCorner": {
              "x": -20.352,
              "y": -1.356,
              "z": 1.416
            },
            "rightCorner": {
              "x": -20.353,
              "y": -1.112,
              "z": 1.416
            },
            "gtin": "8000060100247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bc4",
            "leftCorner": {
              "x": -20.359,
              "y": -1.112,
              "z": 1.416
            },
            "rightCorner": {
              "x": -20.359,
              "y": -0.945,
              "z": 1.416
            },
            "gtin": "5099357003609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bc5",
            "leftCorner": {
              "x": -20.348,
              "y": -0.945,
              "z": 1.416
            },
            "rightCorner": {
              "x": -20.347,
              "y": -0.804,
              "z": 1.416
            },
            "gtin": "5011007003005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bc6",
            "leftCorner": {
              "x": -20.346,
              "y": -0.804,
              "z": 1.416
            },
            "rightCorner": {
              "x": -20.347,
              "y": -0.657,
              "z": 1.416
            },
            "gtin": "5000267024202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bc7",
            "leftCorner": {
              "x": -20.344,
              "y": -0.657,
              "z": 1.416
            },
            "rightCorner": {
              "x": -20.343,
              "y": -0.515,
              "z": 1.416
            },
            "gtin": "5000267014203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bc8",
            "leftCorner": {
              "x": -20.345,
              "y": -0.515,
              "z": 1.416
            },
            "rightCorner": {
              "x": -20.345,
              "y": -0.359,
              "z": 1.416
            },
            "gtin": "8501110083348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bc9",
            "leftCorner": {
              "x": -20.34,
              "y": -0.359,
              "z": 1.416
            },
            "rightCorner": {
              "x": -20.341,
              "y": -0.216,
              "z": 1.416
            },
            "gtin": "8501110086196",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "796",
    "rightNeighborShelfId": "798"
  },
  {
    "id": "798",
    "name": "798",
    "x": -20.388,
    "y": -0.301,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70742,
      "w": 0.70679
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 49,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4aa",
        "height": 0.16592,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c0a",
            "leftCorner": {
              "x": -20.341,
              "y": -0.221,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.341,
              "y": -0.037,
              "z": 0.136
            },
            "gtin": "4306188410058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c48f387550c87a9898a9b324",
            "leftCorner": {
              "x": -20.302,
              "y": -0.301,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.302,
              "y": -0.236,
              "z": 0.136
            },
            "gtin": "4006714006884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c0b",
            "leftCorner": {
              "x": -20.347,
              "y": -0.037,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.347,
              "y": 0.113,
              "z": 0.136
            },
            "gtin": "4306188409960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c0c",
            "leftCorner": {
              "x": -20.347,
              "y": 0.113,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.347,
              "y": 0.262,
              "z": 0.136
            },
            "gtin": "4306188409960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c0d",
            "leftCorner": {
              "x": -20.344,
              "y": 0.262,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.344,
              "y": 0.41,
              "z": 0.136
            },
            "gtin": "4306188409991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c0e",
            "leftCorner": {
              "x": -20.341,
              "y": 0.41,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.341,
              "y": 0.559,
              "z": 0.136
            },
            "gtin": "4061900310282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c0f",
            "leftCorner": {
              "x": -20.337,
              "y": 0.559,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.337,
              "y": 0.648,
              "z": 0.136
            },
            "gtin": "4053500002414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c10",
            "leftCorner": {
              "x": -20.337,
              "y": 0.648,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.337,
              "y": 0.744,
              "z": 0.136
            },
            "gtin": "4006714006884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c11",
            "leftCorner": {
              "x": -20.337,
              "y": 0.744,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.337,
              "y": 0.841,
              "z": 0.136
            },
            "gtin": "4006714006884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c12",
            "leftCorner": {
              "x": -20.344,
              "y": 0.841,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.344,
              "y": 0.943,
              "z": 0.136
            },
            "gtin": "5900595004672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c13",
            "leftCorner": {
              "x": -20.344,
              "y": 0.943,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.344,
              "y": 1.045,
              "z": 0.136
            },
            "gtin": "5900595004672",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4a8",
        "height": 0.56594,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b51",
            "leftCorner": {
              "x": -20.324,
              "y": -0.241,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.325,
              "y": -0.072,
              "z": 0.463
            },
            "gtin": "4008669144024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9394cc3d589e96bd6b2f11a5",
            "leftCorner": {
              "x": -20.286,
              "y": -0.301,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.286,
              "y": -0.241,
              "z": 0.463
            },
            "gtin": "5202795160814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b52",
            "leftCorner": {
              "x": -20.332,
              "y": -0.072,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.331,
              "y": 0.1,
              "z": 0.463
            },
            "gtin": "4008669141023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b53",
            "leftCorner": {
              "x": -20.329,
              "y": 0.1,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.329,
              "y": 0.221,
              "z": 0.463
            },
            "gtin": "4008669016024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b54",
            "leftCorner": {
              "x": -20.329,
              "y": 0.221,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.329,
              "y": 0.342,
              "z": 0.463
            },
            "gtin": "4008669016024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b55",
            "leftCorner": {
              "x": -20.328,
              "y": 0.342,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.327,
              "y": 0.525,
              "z": 0.463
            },
            "gtin": "4008669013009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b56",
            "leftCorner": {
              "x": -20.321,
              "y": 0.525,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.321,
              "y": 0.688,
              "z": 0.463
            },
            "gtin": "4008669145021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b57",
            "leftCorner": {
              "x": -20.321,
              "y": 0.688,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.321,
              "y": 0.827,
              "z": 0.463
            },
            "gtin": "5201003110702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b58",
            "leftCorner": {
              "x": -20.327,
              "y": 0.827,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.327,
              "y": 1.003,
              "z": 0.463
            },
            "gtin": "5202795160814",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4a7",
        "height": 0.95652,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b8f",
            "leftCorner": {
              "x": -20.343,
              "y": -0.165,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.343,
              "y": -0.016,
              "z": 0.783
            },
            "gtin": "5902738887876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "43bd5e007a57efa229d43ffa",
            "leftCorner": {
              "x": -20.302,
              "y": -0.301,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.302,
              "y": -0.178,
              "z": 0.783
            },
            "gtin": "8002095704001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b90",
            "leftCorner": {
              "x": -20.346,
              "y": -0.016,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.346,
              "y": 0.167,
              "z": 0.783
            },
            "gtin": "3263280123938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b91",
            "leftCorner": {
              "x": -20.348,
              "y": 0.167,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.348,
              "y": 0.277,
              "z": 0.783
            },
            "gtin": "4003310013759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b92",
            "leftCorner": {
              "x": -20.348,
              "y": 0.277,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.348,
              "y": 0.386,
              "z": 0.783
            },
            "gtin": "4003310013759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b93",
            "leftCorner": {
              "x": -20.343,
              "y": 0.386,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.343,
              "y": 0.53,
              "z": 0.783
            },
            "gtin": "4003310013803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b94",
            "leftCorner": {
              "x": -20.336,
              "y": 0.53,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.336,
              "y": 0.642,
              "z": 0.783
            },
            "gtin": "8004499050029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b95",
            "leftCorner": {
              "x": -20.336,
              "y": 0.642,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.336,
              "y": 0.765,
              "z": 0.783
            },
            "gtin": "8002095704001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b96",
            "leftCorner": {
              "x": -20.339,
              "y": 0.765,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.338,
              "y": 0.874,
              "z": 0.783
            },
            "gtin": "4009415012192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b97",
            "leftCorner": {
              "x": -20.338,
              "y": 0.874,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.339,
              "y": 0.983,
              "z": 0.783
            },
            "gtin": "4009415012192",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4a6",
        "height": 1.3606,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b0a",
            "leftCorner": {
              "x": -20.335,
              "y": -0.189,
              "z": 1.113
            },
            "rightCorner": {
              "x": -20.336,
              "y": 0.018,
              "z": 1.113
            },
            "gtin": "4008893636623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8cff791eafeb497ac3ee131f",
            "leftCorner": {
              "x": -20.295,
              "y": -0.301,
              "z": 1.113
            },
            "rightCorner": {
              "x": -20.295,
              "y": -0.193,
              "z": 1.113
            },
            "gtin": "7312040090709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b0b",
            "leftCorner": {
              "x": -20.339,
              "y": 0.018,
              "z": 1.113
            },
            "rightCorner": {
              "x": -20.339,
              "y": 0.204,
              "z": 1.113
            },
            "gtin": "7312040350308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b0c",
            "leftCorner": {
              "x": -20.428,
              "y": 0.204,
              "z": 1.113
            },
            "rightCorner": {
              "x": -20.428,
              "y": 0.338,
              "z": 1.113
            },
            "gtin": "7312040017683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b0d",
            "leftCorner": {
              "x": -20.341,
              "y": 0.338,
              "z": 1.113
            },
            "rightCorner": {
              "x": -20.341,
              "y": 0.485,
              "z": 1.113
            },
            "gtin": "7312040090709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b0e",
            "leftCorner": {
              "x": -20.328,
              "y": 0.485,
              "z": 1.113
            },
            "rightCorner": {
              "x": -20.328,
              "y": 0.694,
              "z": 1.113
            },
            "gtin": "4770033224709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b0f",
            "leftCorner": {
              "x": -20.332,
              "y": 0.694,
              "z": 1.113
            },
            "rightCorner": {
              "x": -20.332,
              "y": 0.869,
              "z": 1.113
            },
            "gtin": "4820080720584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b10",
            "leftCorner": {
              "x": -20.338,
              "y": 0.869,
              "z": 1.113
            },
            "rightCorner": {
              "x": -20.338,
              "y": 0.972,
              "z": 1.113
            },
            "gtin": "8000040007009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b11",
            "leftCorner": {
              "x": -20.338,
              "y": 0.972,
              "z": 1.113
            },
            "rightCorner": {
              "x": -20.338,
              "y": 1.076,
              "z": 1.113
            },
            "gtin": "8000040007009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b12",
            "leftCorner": {
              "x": -20.338,
              "y": 1.076,
              "z": 1.113
            },
            "rightCorner": {
              "x": -20.338,
              "y": 1.179,
              "z": 1.113
            },
            "gtin": "8000040007009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4a9",
        "height": 1.7333,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7bca",
            "leftCorner": {
              "x": -20.332,
              "y": -0.216,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.332,
              "y": -0.023,
              "z": 1.418
            },
            "gtin": "4008893636425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "82f90c387a26383d0e050980",
            "leftCorner": {
              "x": -20.291,
              "y": -0.301,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.291,
              "y": -0.22,
              "z": 1.418
            },
            "gtin": "6412700014739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bcb",
            "leftCorner": {
              "x": -20.339,
              "y": -0.023,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.339,
              "y": 0.128,
              "z": 1.418
            },
            "gtin": "5788686123545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bcc",
            "leftCorner": {
              "x": -20.342,
              "y": 0.128,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.342,
              "y": 0.294,
              "z": 1.418
            },
            "gtin": "5410316671118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bcd",
            "leftCorner": {
              "x": -20.341,
              "y": 0.294,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.341,
              "y": 0.462,
              "z": 1.418
            },
            "gtin": "4004726005017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bce",
            "leftCorner": {
              "x": -20.33,
              "y": 0.462,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.33,
              "y": 0.6,
              "z": 1.418
            },
            "gtin": "4062400327008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bcf",
            "leftCorner": {
              "x": -20.328,
              "y": 0.6,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.329,
              "y": 0.682,
              "z": 1.418
            },
            "gtin": "6412700014739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bd0",
            "leftCorner": {
              "x": -20.327,
              "y": 0.682,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.328,
              "y": 0.772,
              "z": 1.418
            },
            "gtin": "6412700148007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bd1",
            "leftCorner": {
              "x": -20.332,
              "y": 0.772,
              "z": 1.418
            },
            "rightCorner": {
              "x": -20.332,
              "y": 1.002,
              "z": 1.418
            },
            "gtin": "4032549042421",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "797",
    "rightNeighborShelfId": "799"
  },
  {
    "id": "799",
    "name": "799",
    "x": -20.39,
    "y": 0.949,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70742,
      "w": 0.70679
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 49,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4b0",
        "height": 0.16757,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c14",
            "leftCorner": {
              "x": -20.35,
              "y": 1.045,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.35,
              "y": 1.102,
              "z": 0.137
            },
            "gtin": "4041500061012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a385798346e7b4599420049e",
            "leftCorner": {
              "x": -20.31,
              "y": 0.949,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.31,
              "y": 1.039,
              "z": 0.137
            },
            "gtin": "4041500061012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c15",
            "leftCorner": {
              "x": -20.35,
              "y": 1.102,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.35,
              "y": 1.159,
              "z": 0.137
            },
            "gtin": "4041500061012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c16",
            "leftCorner": {
              "x": -20.35,
              "y": 1.159,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.35,
              "y": 1.216,
              "z": 0.137
            },
            "gtin": "4041500061012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c17",
            "leftCorner": {
              "x": -20.356,
              "y": 1.216,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.356,
              "y": 1.323,
              "z": 0.137
            },
            "gtin": "4041500061029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c18",
            "leftCorner": {
              "x": -20.356,
              "y": 1.323,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.357,
              "y": 1.43,
              "z": 0.137
            },
            "gtin": "4041500061029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c19",
            "leftCorner": {
              "x": -20.357,
              "y": 1.43,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.357,
              "y": 1.537,
              "z": 0.137
            },
            "gtin": "4041500061029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c1a",
            "leftCorner": {
              "x": -20.357,
              "y": 1.537,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.357,
              "y": 1.645,
              "z": 0.137
            },
            "gtin": "4041500061029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c1b",
            "leftCorner": {
              "x": -20.352,
              "y": 1.645,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.352,
              "y": 1.777,
              "z": 0.137
            },
            "gtin": "4000486001634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c1c",
            "leftCorner": {
              "x": -20.349,
              "y": 1.777,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.349,
              "y": 1.93,
              "z": 0.137
            },
            "gtin": "4002524130085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c1d",
            "leftCorner": {
              "x": -20.351,
              "y": 1.93,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.351,
              "y": 2.083,
              "z": 0.137
            },
            "gtin": "4306188410430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c1e",
            "leftCorner": {
              "x": -20.347,
              "y": 2.083,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.348,
              "y": 2.256,
              "z": 0.137
            },
            "gtin": "4306188410348",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4af",
        "height": 0.56671,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b59",
            "leftCorner": {
              "x": -20.328,
              "y": 1.003,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.328,
              "y": 1.201,
              "z": 0.464
            },
            "gtin": "4306188413356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b5a",
            "leftCorner": {
              "x": -20.343,
              "y": 1.201,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.343,
              "y": 1.293,
              "z": 0.464
            },
            "gtin": "8697530200103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b5b",
            "leftCorner": {
              "x": -20.34,
              "y": 1.293,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.341,
              "y": 1.426,
              "z": 0.464
            },
            "gtin": "4004752211208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b5c",
            "leftCorner": {
              "x": -20.34,
              "y": 1.426,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.34,
              "y": 1.536,
              "z": 0.464
            },
            "gtin": "5201003210709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b5d",
            "leftCorner": {
              "x": -20.34,
              "y": 1.536,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.34,
              "y": 1.645,
              "z": 0.464
            },
            "gtin": "5201003210709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b5e",
            "leftCorner": {
              "x": -20.337,
              "y": 1.645,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.337,
              "y": 1.789,
              "z": 0.464
            },
            "gtin": "5202413007019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b5f",
            "leftCorner": {
              "x": -20.335,
              "y": 1.789,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.335,
              "y": 1.917,
              "z": 0.464
            },
            "gtin": "4000486001023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b60",
            "leftCorner": {
              "x": -20.338,
              "y": 1.917,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.338,
              "y": 2.08,
              "z": 0.464
            },
            "gtin": "4000811590208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b61",
            "leftCorner": {
              "x": -20.334,
              "y": 2.08,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.335,
              "y": 2.245,
              "z": 0.464
            },
            "gtin": "4002442804259",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4ad",
        "height": 0.95656,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b98",
            "leftCorner": {
              "x": -20.339,
              "y": 0.983,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.339,
              "y": 1.106,
              "z": 0.783
            },
            "gtin": "3047100090316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b99",
            "leftCorner": {
              "x": -20.345,
              "y": 1.106,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.345,
              "y": 1.302,
              "z": 0.783
            },
            "gtin": "4062400309103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b9a",
            "leftCorner": {
              "x": -20.352,
              "y": 1.302,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.353,
              "y": 1.426,
              "z": 0.783
            },
            "gtin": "4306188410461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b9b",
            "leftCorner": {
              "x": -20.349,
              "y": 1.426,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.349,
              "y": 1.609,
              "z": 0.783
            },
            "gtin": "8411144101249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b9c",
            "leftCorner": {
              "x": -20.347,
              "y": 1.609,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.347,
              "y": 1.748,
              "z": 0.783
            },
            "gtin": "5000289933605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b9d",
            "leftCorner": {
              "x": -20.348,
              "y": 1.748,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.348,
              "y": 1.921,
              "z": 0.783
            },
            "gtin": "5000289925440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b9e",
            "leftCorner": {
              "x": -20.349,
              "y": 1.921,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.348,
              "y": 2.08,
              "z": 0.783
            },
            "gtin": "5000289932479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b9f",
            "leftCorner": {
              "x": -20.349,
              "y": 2.08,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.35,
              "y": 2.25,
              "z": 0.783
            },
            "gtin": "5000289929417",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4ae",
        "height": 1.3621,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b13",
            "leftCorner": {
              "x": -20.344,
              "y": 1.179,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.344,
              "y": 1.27,
              "z": 1.114
            },
            "gtin": "4870017005086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "41a1f46686fbf57d0f9ffe9d",
            "leftCorner": {
              "x": -20.303,
              "y": 0.949,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.303,
              "y": 1.047,
              "z": 1.114
            },
            "gtin": "8000420094759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4cb015cfb6049e353ccd4541",
            "leftCorner": {
              "x": -20.303,
              "y": 1.047,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.303,
              "y": 1.172,
              "z": 1.114
            },
            "gtin": "5010677714006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b14",
            "leftCorner": {
              "x": -20.344,
              "y": 1.27,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.345,
              "y": 1.418,
              "z": 1.114
            },
            "gtin": "5010677710497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b15",
            "leftCorner": {
              "x": -20.344,
              "y": 1.418,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.344,
              "y": 1.498,
              "z": 1.114
            },
            "gtin": "7640175742522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b16",
            "leftCorner": {
              "x": -20.344,
              "y": 1.498,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.344,
              "y": 1.579,
              "z": 1.114
            },
            "gtin": "7640175742522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b17",
            "leftCorner": {
              "x": -20.342,
              "y": 1.579,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.342,
              "y": 1.72,
              "z": 1.114
            },
            "gtin": "7640175744168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b18",
            "leftCorner": {
              "x": -20.341,
              "y": 1.72,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.341,
              "y": 1.884,
              "z": 1.114
            },
            "gtin": "5010677714006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b19",
            "leftCorner": {
              "x": -20.344,
              "y": 1.884,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.344,
              "y": 1.979,
              "z": 1.114
            },
            "gtin": "5000281015248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b1a",
            "leftCorner": {
              "x": -20.344,
              "y": 1.979,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.344,
              "y": 2.075,
              "z": 1.114
            },
            "gtin": "5000281015248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b1b",
            "leftCorner": {
              "x": -20.342,
              "y": 2.075,
              "z": 1.114
            },
            "rightCorner": {
              "x": -20.343,
              "y": 2.242,
              "z": 1.114
            },
            "gtin": "5000291023462",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4ac",
        "height": 1.7342,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7bd2",
            "leftCorner": {
              "x": -20.336,
              "y": 1.002,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.336,
              "y": 1.126,
              "z": 1.419
            },
            "gtin": "4032549039124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bd3",
            "leftCorner": {
              "x": -20.343,
              "y": 1.126,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.343,
              "y": 1.283,
              "z": 1.419
            },
            "gtin": "5900343010146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bd4",
            "leftCorner": {
              "x": -20.348,
              "y": 1.283,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.349,
              "y": 1.439,
              "z": 1.419
            },
            "gtin": "4007675080005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bd5",
            "leftCorner": {
              "x": -20.346,
              "y": 1.439,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.346,
              "y": 1.59,
              "z": 1.419
            },
            "gtin": "4007675400001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bd6",
            "leftCorner": {
              "x": -20.346,
              "y": 1.59,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.346,
              "y": 1.736,
              "z": 1.419
            },
            "gtin": "4007675050008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bd7",
            "leftCorner": {
              "x": -20.344,
              "y": 1.736,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.344,
              "y": 1.883,
              "z": 1.419
            },
            "gtin": "4004752006309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bd8",
            "leftCorner": {
              "x": -20.344,
              "y": 1.883,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.344,
              "y": 2.079,
              "z": 1.419
            },
            "gtin": "4008893636128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bd9",
            "leftCorner": {
              "x": -20.343,
              "y": 2.079,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.344,
              "y": 2.165,
              "z": 1.419
            },
            "gtin": "7048352041510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bda",
            "leftCorner": {
              "x": -20.344,
              "y": 2.165,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.344,
              "y": 2.251,
              "z": 1.419
            },
            "gtin": "7048352041510",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "798",
    "rightNeighborShelfId": "79a"
  },
  {
    "id": "79a",
    "name": "79a",
    "x": -20.391,
    "y": 2.199,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70742,
      "w": 0.70679
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 44,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4b5",
        "height": 0.1714,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c1f",
            "leftCorner": {
              "x": -20.351,
              "y": 2.256,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.351,
              "y": 2.377,
              "z": 0.14
            },
            "gtin": "4306188410287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c20",
            "leftCorner": {
              "x": -20.35,
              "y": 2.377,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.349,
              "y": 2.559,
              "z": 0.14
            },
            "gtin": "4306188119227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c21",
            "leftCorner": {
              "x": -20.349,
              "y": 2.559,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.35,
              "y": 2.741,
              "z": 0.14
            },
            "gtin": "4306188119227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c22",
            "leftCorner": {
              "x": -20.357,
              "y": 2.741,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.357,
              "y": 2.949,
              "z": 0.14
            },
            "gtin": "4306188410164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c23",
            "leftCorner": {
              "x": -20.355,
              "y": 2.949,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.356,
              "y": 3.084,
              "z": 0.14
            },
            "gtin": "4038500129705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c24",
            "leftCorner": {
              "x": -20.356,
              "y": 3.084,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.356,
              "y": 3.328,
              "z": 0.14
            },
            "gtin": "4038500129552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c25",
            "leftCorner": {
              "x": -20.355,
              "y": 3.328,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.356,
              "y": 3.757,
              "z": 0.14
            },
            "gtin": "4038500001162",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4b1",
        "height": 0.56757,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b62",
            "leftCorner": {
              "x": -20.329,
              "y": 2.245,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.329,
              "y": 2.3,
              "z": 0.464
            },
            "gtin": "4306188424680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b63",
            "leftCorner": {
              "x": -20.329,
              "y": 2.3,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.329,
              "y": 2.354,
              "z": 0.464
            },
            "gtin": "4306188424680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b64",
            "leftCorner": {
              "x": -20.332,
              "y": 2.354,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.332,
              "y": 2.471,
              "z": 0.464
            },
            "gtin": "40157818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b65",
            "leftCorner": {
              "x": -20.334,
              "y": 2.471,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.334,
              "y": 2.624,
              "z": 0.464
            },
            "gtin": "40157214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b66",
            "leftCorner": {
              "x": -20.334,
              "y": 2.624,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.334,
              "y": 2.732,
              "z": 0.464
            },
            "gtin": "4015720010761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b67",
            "leftCorner": {
              "x": -20.334,
              "y": 2.732,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.335,
              "y": 2.839,
              "z": 0.464
            },
            "gtin": "4015720010761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b68",
            "leftCorner": {
              "x": -20.336,
              "y": 2.839,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.337,
              "y": 3.006,
              "z": 0.464
            },
            "gtin": "4015717010644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b69",
            "leftCorner": {
              "x": -20.338,
              "y": 3.006,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.339,
              "y": 3.153,
              "z": 0.464
            },
            "gtin": "4003310018341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b6a",
            "leftCorner": {
              "x": -20.335,
              "y": 3.153,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.336,
              "y": 3.369,
              "z": 0.464
            },
            "gtin": "4260359840047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b6b",
            "leftCorner": {
              "x": -20.339,
              "y": 3.369,
              "z": 0.464
            },
            "rightCorner": {
              "x": -20.339,
              "y": 3.536,
              "z": 0.464
            },
            "gtin": "4007843212122",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4b4",
        "height": 0.95722,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ba0",
            "leftCorner": {
              "x": -20.34,
              "y": 2.25,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.341,
              "y": 2.415,
              "z": 0.783
            },
            "gtin": "4002689007475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ba1",
            "leftCorner": {
              "x": -20.344,
              "y": 2.415,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.344,
              "y": 2.578,
              "z": 0.783
            },
            "gtin": "4002689007178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ba2",
            "leftCorner": {
              "x": -20.346,
              "y": 2.578,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.346,
              "y": 2.7,
              "z": 0.783
            },
            "gtin": "4002689007574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ba3",
            "leftCorner": {
              "x": -20.344,
              "y": 2.701,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.343,
              "y": 2.784,
              "z": 0.783
            },
            "gtin": "9009889001314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ba4",
            "leftCorner": {
              "x": -20.346,
              "y": 2.784,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.346,
              "y": 2.88,
              "z": 0.783
            },
            "gtin": "9009889001321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ba5",
            "leftCorner": {
              "x": -20.346,
              "y": 2.88,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.346,
              "y": 2.976,
              "z": 0.783
            },
            "gtin": "9009889001321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ba6",
            "leftCorner": {
              "x": -20.35,
              "y": 2.976,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.35,
              "y": 3.093,
              "z": 0.783
            },
            "gtin": "9009889001345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ba7",
            "leftCorner": {
              "x": -20.35,
              "y": 3.093,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.35,
              "y": 3.268,
              "z": 0.783
            },
            "gtin": "4000526002584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ba8",
            "leftCorner": {
              "x": -20.35,
              "y": 3.268,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.35,
              "y": 3.373,
              "z": 0.783
            },
            "gtin": "80120643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ba9",
            "leftCorner": {
              "x": -20.35,
              "y": 3.373,
              "z": 0.783
            },
            "rightCorner": {
              "x": -20.35,
              "y": 3.466,
              "z": 0.783
            },
            "gtin": "8009375051220",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4b2",
        "height": 1.3642,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b1c",
            "leftCorner": {
              "x": -20.335,
              "y": 2.241,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.336,
              "y": 2.378,
              "z": 1.116
            },
            "gtin": "4400065463202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b1d",
            "leftCorner": {
              "x": -20.342,
              "y": 2.378,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.343,
              "y": 2.492,
              "z": 1.116
            },
            "gtin": "4400065458000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b1e",
            "leftCorner": {
              "x": -20.343,
              "y": 2.492,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.342,
              "y": 2.634,
              "z": 1.116
            },
            "gtin": "4400065455009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b1f",
            "leftCorner": {
              "x": -20.346,
              "y": 2.634,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.346,
              "y": 2.783,
              "z": 1.116
            },
            "gtin": "9005400005175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b20",
            "leftCorner": {
              "x": -20.346,
              "y": 2.783,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.347,
              "y": 2.919,
              "z": 1.116
            },
            "gtin": "9005400005274",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7b21",
            "leftCorner": {
              "x": -20.345,
              "y": 2.919,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.345,
              "y": 3.063,
              "z": 1.116
            },
            "gtin": "9005400005267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b22",
            "leftCorner": {
              "x": -20.347,
              "y": 3.063,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.348,
              "y": 3.129,
              "z": 1.116
            },
            "gtin": "4262355280056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b23",
            "leftCorner": {
              "x": -20.347,
              "y": 3.129,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.348,
              "y": 3.204,
              "z": 1.116
            },
            "gtin": "4262355280049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b24",
            "leftCorner": {
              "x": -20.349,
              "y": 3.204,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.348,
              "y": 3.281,
              "z": 1.116
            },
            "gtin": "4262355280063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b25",
            "leftCorner": {
              "x": -20.348,
              "y": 3.281,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.349,
              "y": 3.361,
              "z": 1.116
            },
            "gtin": "4262355280148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b26",
            "leftCorner": {
              "x": -20.346,
              "y": 3.361,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.346,
              "y": 3.512,
              "z": 1.116
            },
            "gtin": "4002689001374",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4b3",
        "height": 1.7349,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7bdb",
            "leftCorner": {
              "x": -20.34,
              "y": 2.251,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.34,
              "y": 2.451,
              "z": 1.419
            },
            "gtin": "5700359304907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bdc",
            "leftCorner": {
              "x": -20.342,
              "y": 2.451,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.343,
              "y": 2.599,
              "z": 1.419
            },
            "gtin": "4038600001017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bdd",
            "leftCorner": {
              "x": -20.347,
              "y": 2.599,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.346,
              "y": 2.797,
              "z": 1.419
            },
            "gtin": "4062400542104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bde",
            "leftCorner": {
              "x": -20.348,
              "y": 2.797,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.348,
              "y": 2.972,
              "z": 1.419
            },
            "gtin": "4062400543101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bdf",
            "leftCorner": {
              "x": -20.348,
              "y": 2.972,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.348,
              "y": 3.122,
              "z": 1.419
            },
            "gtin": "4062400156301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7be0",
            "leftCorner": {
              "x": -20.348,
              "y": 3.122,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.349,
              "y": 3.318,
              "z": 1.419
            },
            "gtin": "8005829000080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7be1",
            "leftCorner": {
              "x": -20.35,
              "y": 3.318,
              "z": 1.419
            },
            "rightCorner": {
              "x": -20.349,
              "y": 3.458,
              "z": 1.419
            },
            "gtin": "8000672000768",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "799",
    "rightNeighborShelfId": "79b"
  },
  {
    "id": "79b",
    "name": "79b",
    "x": -20.392,
    "y": 3.449,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70742,
      "w": 0.70679
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 40,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5e6",
        "height": 0.17098,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c26",
            "leftCorner": {
              "x": -20.624,
              "y": 3.757,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.623,
              "y": 4.004,
              "z": 0.14
            },
            "gtin": "4002645000137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c27",
            "leftCorner": {
              "x": -20.624,
              "y": 4.004,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.624,
              "y": 4.196,
              "z": 0.14
            },
            "gtin": "4000486043085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c28",
            "leftCorner": {
              "x": -20.627,
              "y": 4.196,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.628,
              "y": 4.449,
              "z": 0.14
            },
            "gtin": "4306188048800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c29",
            "leftCorner": {
              "x": -20.633,
              "y": 4.449,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.634,
              "y": 4.565,
              "z": 0.14
            },
            "gtin": "4306188048831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7beb",
            "leftCorner": {
              "x": -20.635,
              "y": 4.565,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.635,
              "y": 4.699,
              "z": 0.14
            },
            "gtin": "4002645000168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4e0981bb453e5986a1d5c6ef",
            "leftCorner": {
              "x": -20.587,
              "y": 3.449,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.587,
              "y": 3.616,
              "z": 0.14
            },
            "gtin": "4000486043085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e151f16e00d9aa5f9f2e56ab",
            "leftCorner": {
              "x": -20.587,
              "y": 3.616,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.587,
              "y": 3.744,
              "z": 0.14
            },
            "gtin": "4002645000168",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5e4",
        "height": 0.56627,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b6c",
            "leftCorner": {
              "x": -20.606,
              "y": 3.536,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.606,
              "y": 3.697,
              "z": 0.463
            },
            "gtin": "4002524131327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b6d",
            "leftCorner": {
              "x": -20.61,
              "y": 3.697,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.611,
              "y": 3.847,
              "z": 0.463
            },
            "gtin": "4010100010409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b6e",
            "leftCorner": {
              "x": -20.613,
              "y": 3.847,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.613,
              "y": 3.995,
              "z": 0.463
            },
            "gtin": "4002645000182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b6f",
            "leftCorner": {
              "x": -20.615,
              "y": 3.995,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.615,
              "y": 4.249,
              "z": 0.463
            },
            "gtin": "4067700091208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b70",
            "leftCorner": {
              "x": -20.617,
              "y": 4.249,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.617,
              "y": 4.491,
              "z": 0.463
            },
            "gtin": "4034100000918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b33",
            "leftCorner": {
              "x": -20.617,
              "y": 4.491,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.617,
              "y": 4.699,
              "z": 0.463
            },
            "gtin": "40341248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e9c78ada08f5d9d7ff840e99",
            "leftCorner": {
              "x": -20.575,
              "y": 3.449,
              "z": 0.463
            },
            "rightCorner": {
              "x": -20.575,
              "y": 3.524,
              "z": 0.463
            },
            "gtin": "4002524131327",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5e5",
        "height": 0.95826,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7baa",
            "leftCorner": {
              "x": -20.616,
              "y": 3.466,
              "z": 0.784
            },
            "rightCorner": {
              "x": -20.617,
              "y": 3.6,
              "z": 0.784
            },
            "gtin": "8004499170017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bab",
            "leftCorner": {
              "x": -20.616,
              "y": 3.6,
              "z": 0.784
            },
            "rightCorner": {
              "x": -20.615,
              "y": 3.747,
              "z": 0.784
            },
            "gtin": "4000486003027",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7bac",
            "leftCorner": {
              "x": -20.619,
              "y": 3.747,
              "z": 0.784
            },
            "rightCorner": {
              "x": -20.62,
              "y": 3.934,
              "z": 0.784
            },
            "gtin": "9005701001289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bad",
            "leftCorner": {
              "x": -20.623,
              "y": 3.934,
              "z": 0.784
            },
            "rightCorner": {
              "x": -20.622,
              "y": 4.083,
              "z": 0.784
            },
            "gtin": "4000245034309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bae",
            "leftCorner": {
              "x": -20.623,
              "y": 4.083,
              "z": 0.784
            },
            "rightCorner": {
              "x": -20.623,
              "y": 4.155,
              "z": 0.784
            },
            "gtin": "4008300063028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bb0",
            "leftCorner": {
              "x": -20.622,
              "y": 4.309,
              "z": 0.784
            },
            "rightCorner": {
              "x": -20.622,
              "y": 4.549,
              "z": 0.784
            },
            "gtin": "4002137101045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b73",
            "leftCorner": {
              "x": -20.627,
              "y": 4.549,
              "z": 0.784
            },
            "rightCorner": {
              "x": -20.627,
              "y": 4.699,
              "z": 0.784
            },
            "gtin": "4067700011077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0811861a5c01006eeeb85a49",
            "leftCorner": {
              "x": -20.582,
              "y": 4.155,
              "z": 0.784
            },
            "rightCorner": {
              "x": -20.582,
              "y": 4.304,
              "z": 0.784
            },
            "gtin": "4000486003027",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5e3",
        "height": 1.3642,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7b27",
            "leftCorner": {
              "x": -20.606,
              "y": 3.512,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.607,
              "y": 3.591,
              "z": 1.116
            },
            "gtin": "8006550301040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f63ad3b0a5fa91635cda2486",
            "leftCorner": {
              "x": -20.575,
              "y": 4.462,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.575,
              "y": 4.594,
              "z": 1.116
            },
            "gtin": "4067700011008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "326946291e67610faa8cd01c",
            "leftCorner": {
              "x": -20.575,
              "y": 4.594,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.575,
              "y": 4.698,
              "z": 1.116
            },
            "gtin": "8006550301040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b28",
            "leftCorner": {
              "x": -20.607,
              "y": 3.591,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.607,
              "y": 3.67,
              "z": 1.116
            },
            "gtin": "8006550301040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b29",
            "leftCorner": {
              "x": -20.612,
              "y": 3.67,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.611,
              "y": 3.831,
              "z": 1.116
            },
            "gtin": "8000400203782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b2a",
            "leftCorner": {
              "x": -20.613,
              "y": 3.831,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.614,
              "y": 3.94,
              "z": 1.116
            },
            "gtin": "4009889198705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b2b",
            "leftCorner": {
              "x": -20.613,
              "y": 3.94,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.613,
              "y": 4.041,
              "z": 1.116
            },
            "gtin": "4009415452196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b2c",
            "leftCorner": {
              "x": -20.613,
              "y": 4.041,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.613,
              "y": 4.141,
              "z": 1.116
            },
            "gtin": "4009415452196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b2d",
            "leftCorner": {
              "x": -20.616,
              "y": 4.141,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.616,
              "y": 4.345,
              "z": 1.116
            },
            "gtin": "4067700034588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7b2e",
            "leftCorner": {
              "x": -20.619,
              "y": 4.345,
              "z": 1.116
            },
            "rightCorner": {
              "x": -20.62,
              "y": 4.462,
              "z": 1.116
            },
            "gtin": "4067700011015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5e2",
        "height": 1.7358,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7be2",
            "leftCorner": {
              "x": -20.608,
              "y": 3.457,
              "z": 1.42
            },
            "rightCorner": {
              "x": -20.609,
              "y": 3.59,
              "z": 1.42
            },
            "gtin": "4306188053996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7be3",
            "leftCorner": {
              "x": -20.61,
              "y": 3.59,
              "z": 1.42
            },
            "rightCorner": {
              "x": -20.61,
              "y": 3.791,
              "z": 1.42
            },
            "gtin": "40624006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7be4",
            "leftCorner": {
              "x": -20.617,
              "y": 3.791,
              "z": 1.42
            },
            "rightCorner": {
              "x": -20.617,
              "y": 3.924,
              "z": 1.42
            },
            "gtin": "41001127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7be5",
            "leftCorner": {
              "x": -20.619,
              "y": 3.924,
              "z": 1.42
            },
            "rightCorner": {
              "x": -20.619,
              "y": 4.078,
              "z": 1.42
            },
            "gtin": "8004400001317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7be6",
            "leftCorner": {
              "x": -20.62,
              "y": 4.078,
              "z": 1.42
            },
            "rightCorner": {
              "x": -20.62,
              "y": 4.151,
              "z": 1.42
            },
            "gtin": "8594405101049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7be8",
            "leftCorner": {
              "x": -20.621,
              "y": 4.29,
              "z": 1.42
            },
            "rightCorner": {
              "x": -20.62,
              "y": 4.425,
              "z": 1.42
            },
            "gtin": "4022269172164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7be9",
            "leftCorner": {
              "x": -20.622,
              "y": 4.425,
              "z": 1.42
            },
            "rightCorner": {
              "x": -20.622,
              "y": 4.581,
              "z": 1.42
            },
            "gtin": "4260034560017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7bb2",
            "leftCorner": {
              "x": -20.626,
              "y": 4.582,
              "z": 1.42
            },
            "rightCorner": {
              "x": -20.626,
              "y": 4.699,
              "z": 1.42
            },
            "gtin": "4067700011022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "65fa0ec89f3fb409c2046cce",
            "leftCorner": {
              "x": -20.58,
              "y": 4.151,
              "z": 1.42
            },
            "rightCorner": {
              "x": -20.58,
              "y": 4.288,
              "z": 1.42
            },
            "gtin": "8004400001317",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "79a"
  },
  {
    "id": "79c",
    "name": "79c",
    "x": -20.34,
    "y": 4.819,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0093025,
      "w": 0.99996
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5ec",
        "height": 0.16735,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d84de",
            "leftCorner": {
              "x": -20.34,
              "y": 4.855,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.097,
              "y": 4.86,
              "z": 0.137
            },
            "gtin": "4022229300385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84e0",
            "leftCorner": {
              "x": -20.099,
              "y": 4.892,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.971,
              "y": 4.895,
              "z": 0.137
            },
            "gtin": "4022229301238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84e1",
            "leftCorner": {
              "x": -19.971,
              "y": 4.901,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.825,
              "y": 4.903,
              "z": 0.137
            },
            "gtin": "4049366000404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84e2",
            "leftCorner": {
              "x": -19.825,
              "y": 4.904,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.685,
              "y": 4.907,
              "z": 0.137
            },
            "gtin": "4306188005247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84e3",
            "leftCorner": {
              "x": -19.685,
              "y": 4.907,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.495,
              "y": 4.911,
              "z": 0.137
            },
            "gtin": "4008005031049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84e4",
            "leftCorner": {
              "x": -19.495,
              "y": 4.912,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.328,
              "y": 4.915,
              "z": 0.137
            },
            "gtin": "4306188131137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84df",
            "leftCorner": {
              "x": -19.328,
              "y": 4.92,
              "z": 0.137
            },
            "rightCorner": {
              "x": -19.092,
              "y": 4.924,
              "z": 0.137
            },
            "gtin": "4008005042090",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5ea",
        "height": 0.56404,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c8f",
            "leftCorner": {
              "x": -20.34,
              "y": 4.846,
              "z": 0.461
            },
            "rightCorner": {
              "x": -20.263,
              "y": 4.848,
              "z": 0.461
            },
            "gtin": "4005670062217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c90",
            "leftCorner": {
              "x": -20.263,
              "y": 4.848,
              "z": 0.461
            },
            "rightCorner": {
              "x": -20.185,
              "y": 4.849,
              "z": 0.461
            },
            "gtin": "4005670062217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c91",
            "leftCorner": {
              "x": -20.185,
              "y": 4.849,
              "z": 0.461
            },
            "rightCorner": {
              "x": -20.108,
              "y": 4.851,
              "z": 0.461
            },
            "gtin": "4005670062217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c93",
            "leftCorner": {
              "x": -20.109,
              "y": 4.883,
              "z": 0.461
            },
            "rightCorner": {
              "x": -19.929,
              "y": 4.887,
              "z": 0.461
            },
            "gtin": "4005670002282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c94",
            "leftCorner": {
              "x": -19.929,
              "y": 4.891,
              "z": 0.461
            },
            "rightCorner": {
              "x": -19.762,
              "y": 4.894,
              "z": 0.461
            },
            "gtin": "4005670032081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c95",
            "leftCorner": {
              "x": -19.762,
              "y": 4.898,
              "z": 0.461
            },
            "rightCorner": {
              "x": -19.582,
              "y": 4.901,
              "z": 0.461
            },
            "gtin": "4005670302085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c96",
            "leftCorner": {
              "x": -19.582,
              "y": 4.901,
              "z": 0.461
            },
            "rightCorner": {
              "x": -19.414,
              "y": 4.904,
              "z": 0.461
            },
            "gtin": "4005670022020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c97",
            "leftCorner": {
              "x": -19.414,
              "y": 4.904,
              "z": 0.461
            },
            "rightCorner": {
              "x": -19.231,
              "y": 4.907,
              "z": 0.461
            },
            "gtin": "4007245000341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c98",
            "leftCorner": {
              "x": -19.231,
              "y": 4.907,
              "z": 0.461
            },
            "rightCorner": {
              "x": -19.049,
              "y": 4.91,
              "z": 0.461
            },
            "gtin": "4007245000341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c99",
            "leftCorner": {
              "x": -19.049,
              "y": 4.91,
              "z": 0.461
            },
            "rightCorner": {
              "x": -18.866,
              "y": 4.914,
              "z": 0.461
            },
            "gtin": "4007245000341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c9a",
            "leftCorner": {
              "x": -18.866,
              "y": 4.914,
              "z": 0.461
            },
            "rightCorner": {
              "x": -18.683,
              "y": 4.917,
              "z": 0.461
            },
            "gtin": "4007245000341",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5eb",
        "height": 0.95412,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c6c",
            "leftCorner": {
              "x": -20.34,
              "y": 4.858,
              "z": 0.781
            },
            "rightCorner": {
              "x": -20.118,
              "y": 4.862,
              "z": 0.781
            },
            "gtin": "4011441503766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c6e",
            "leftCorner": {
              "x": -20.119,
              "y": 4.897,
              "z": 0.781
            },
            "rightCorner": {
              "x": -19.922,
              "y": 4.901,
              "z": 0.781
            },
            "gtin": "4006861804203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c6f",
            "leftCorner": {
              "x": -19.922,
              "y": 4.904,
              "z": 0.781
            },
            "rightCorner": {
              "x": -19.796,
              "y": 4.906,
              "z": 0.781
            },
            "gtin": "4006861800205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c70",
            "leftCorner": {
              "x": -19.796,
              "y": 4.907,
              "z": 0.781
            },
            "rightCorner": {
              "x": -19.722,
              "y": 4.908,
              "z": 0.781
            },
            "gtin": "4006310623010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c71",
            "leftCorner": {
              "x": -19.722,
              "y": 4.908,
              "z": 0.781
            },
            "rightCorner": {
              "x": -19.648,
              "y": 4.909,
              "z": 0.781
            },
            "gtin": "4006310623010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c72",
            "leftCorner": {
              "x": -19.648,
              "y": 4.912,
              "z": 0.781
            },
            "rightCorner": {
              "x": -19.483,
              "y": 4.915,
              "z": 0.781
            },
            "gtin": "4001744024532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c73",
            "leftCorner": {
              "x": -19.483,
              "y": 4.916,
              "z": 0.781
            },
            "rightCorner": {
              "x": -19.326,
              "y": 4.919,
              "z": 0.781
            },
            "gtin": "4006975023163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c74",
            "leftCorner": {
              "x": -19.326,
              "y": 4.922,
              "z": 0.781
            },
            "rightCorner": {
              "x": -19.04,
              "y": 4.927,
              "z": 0.781
            },
            "gtin": "4006975020834",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5e9",
        "height": 1.3605,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c4a",
            "leftCorner": {
              "x": -20.34,
              "y": 4.857,
              "z": 1.113
            },
            "rightCorner": {
              "x": -20.1,
              "y": 4.862,
              "z": 1.113
            },
            "gtin": "4001432063034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c4c",
            "leftCorner": {
              "x": -20.101,
              "y": 4.895,
              "z": 1.113
            },
            "rightCorner": {
              "x": -19.96,
              "y": 4.897,
              "z": 1.113
            },
            "gtin": "4003301027468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c4d",
            "leftCorner": {
              "x": -19.96,
              "y": 4.902,
              "z": 1.113
            },
            "rightCorner": {
              "x": -19.799,
              "y": 4.905,
              "z": 1.113
            },
            "gtin": "4003301027482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c4e",
            "leftCorner": {
              "x": -19.799,
              "y": 4.907,
              "z": 1.113
            },
            "rightCorner": {
              "x": -19.629,
              "y": 4.91,
              "z": 1.113
            },
            "gtin": "4003301027505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c4f",
            "leftCorner": {
              "x": -19.629,
              "y": 4.911,
              "z": 1.113
            },
            "rightCorner": {
              "x": -19.528,
              "y": 4.913,
              "z": 1.113
            },
            "gtin": "4014741380228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c51",
            "leftCorner": {
              "x": -19.47,
              "y": 4.916,
              "z": 1.113
            },
            "rightCorner": {
              "x": -19.324,
              "y": 4.919,
              "z": 1.113
            },
            "gtin": "4006187900061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c52",
            "leftCorner": {
              "x": -19.324,
              "y": 4.92,
              "z": 1.113
            },
            "rightCorner": {
              "x": -19.191,
              "y": 4.922,
              "z": 1.113
            },
            "gtin": "4006187900788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c53",
            "leftCorner": {
              "x": -19.191,
              "y": 4.922,
              "z": 1.113
            },
            "rightCorner": {
              "x": -19.058,
              "y": 4.924,
              "z": 1.113
            },
            "gtin": "4006187900788",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5e8",
        "height": 1.7312,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c2a",
            "leftCorner": {
              "x": -20.34,
              "y": 4.857,
              "z": 1.416
            },
            "rightCorner": {
              "x": -20.104,
              "y": 4.861,
              "z": 1.416
            },
            "gtin": "4006542062595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c2c",
            "leftCorner": {
              "x": -20.106,
              "y": 4.897,
              "z": 1.416
            },
            "rightCorner": {
              "x": -19.954,
              "y": 4.9,
              "z": 1.416
            },
            "gtin": "4006542065954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c2d",
            "leftCorner": {
              "x": -19.954,
              "y": 4.904,
              "z": 1.416
            },
            "rightCorner": {
              "x": -19.889,
              "y": 4.905,
              "z": 1.416
            },
            "gtin": "4006542055948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c2e",
            "leftCorner": {
              "x": -19.889,
              "y": 4.905,
              "z": 1.416
            },
            "rightCorner": {
              "x": -19.823,
              "y": 4.906,
              "z": 1.416
            },
            "gtin": "4006542055948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c2f",
            "leftCorner": {
              "x": -19.823,
              "y": 4.907,
              "z": 1.416
            },
            "rightCorner": {
              "x": -19.66,
              "y": 4.91,
              "z": 1.416
            },
            "gtin": "4007649707402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c30",
            "leftCorner": {
              "x": -19.66,
              "y": 4.908,
              "z": 1.416
            },
            "rightCorner": {
              "x": -19.496,
              "y": 4.911,
              "z": 1.416
            },
            "gtin": "4007649708409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c31",
            "leftCorner": {
              "x": -19.496,
              "y": 4.913,
              "z": 1.416
            },
            "rightCorner": {
              "x": -19.335,
              "y": 4.916,
              "z": 1.416
            },
            "gtin": "4260247849329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c32",
            "leftCorner": {
              "x": -19.335,
              "y": 4.919,
              "z": 1.416
            },
            "rightCorner": {
              "x": -19.061,
              "y": 4.924,
              "z": 1.416
            },
            "gtin": "9005511084571",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "79e"
  },
  {
    "id": "79e",
    "name": "79e",
    "x": -19.091,
    "y": 4.842,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0093025,
      "w": 0.99996
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4bb",
        "height": 0.15662,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7cad",
            "leftCorner": {
              "x": -19.09,
              "y": 4.771,
              "z": 0.128
            },
            "rightCorner": {
              "x": -18.796,
              "y": 4.777,
              "z": 0.128
            },
            "gtin": "3500610032738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7caf",
            "leftCorner": {
              "x": -18.801,
              "y": 5.04,
              "z": 0.128
            },
            "rightCorner": {
              "x": -18.682,
              "y": 5.042,
              "z": 0.128
            },
            "gtin": "3263286354114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cb0",
            "leftCorner": {
              "x": -18.677,
              "y": 4.819,
              "z": 0.128
            },
            "rightCorner": {
              "x": -18.499,
              "y": 4.822,
              "z": 0.128
            },
            "gtin": "4001731763994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cb1",
            "leftCorner": {
              "x": -18.499,
              "y": 4.823,
              "z": 0.128
            },
            "rightCorner": {
              "x": -18.36,
              "y": 4.826,
              "z": 0.128
            },
            "gtin": "3263280119023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cb2",
            "leftCorner": {
              "x": -18.36,
              "y": 4.825,
              "z": 0.128
            },
            "rightCorner": {
              "x": -18.216,
              "y": 4.827,
              "z": 0.128
            },
            "gtin": "8008530008987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cb3",
            "leftCorner": {
              "x": -18.216,
              "y": 4.825,
              "z": 0.128
            },
            "rightCorner": {
              "x": -18.03,
              "y": 4.829,
              "z": 0.128
            },
            "gtin": "8001592000388",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4ba",
        "height": 0.56055,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c9b",
            "leftCorner": {
              "x": -18.682,
              "y": 4.808,
              "z": 0.459
            },
            "rightCorner": {
              "x": -18.506,
              "y": 4.811,
              "z": 0.459
            },
            "gtin": "4001432048239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "09fc903d30c03f3b39df1fee",
            "leftCorner": {
              "x": -19.09,
              "y": 4.761,
              "z": 0.459
            },
            "rightCorner": {
              "x": -18.993,
              "y": 4.763,
              "z": 0.459
            },
            "gtin": "4001432019239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "04acd0b7ae0270f5bb007e5f",
            "leftCorner": {
              "x": -18.993,
              "y": 4.763,
              "z": 0.459
            },
            "rightCorner": {
              "x": -18.897,
              "y": 4.765,
              "z": 0.459
            },
            "gtin": "4001432019239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fcfe07470fcbcacc25bc5da2",
            "leftCorner": {
              "x": -18.897,
              "y": 4.765,
              "z": 0.459
            },
            "rightCorner": {
              "x": -18.727,
              "y": 4.768,
              "z": 0.459
            },
            "gtin": "4001432048239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c9c",
            "leftCorner": {
              "x": -18.506,
              "y": 4.813,
              "z": 0.459
            },
            "rightCorner": {
              "x": -18.356,
              "y": 4.816,
              "z": 0.459
            },
            "gtin": "8594045653137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c9d",
            "leftCorner": {
              "x": -18.356,
              "y": 4.817,
              "z": 0.459
            },
            "rightCorner": {
              "x": -18.202,
              "y": 4.82,
              "z": 0.459
            },
            "gtin": "8028752000378",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c9e",
            "leftCorner": {
              "x": -18.202,
              "y": 4.816,
              "z": 0.459
            },
            "rightCorner": {
              "x": -18.064,
              "y": 4.819,
              "z": 0.459
            },
            "gtin": "4001432679037",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4b8",
        "height": 0.95111,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c75",
            "leftCorner": {
              "x": -19.04,
              "y": 4.812,
              "z": 0.778
            },
            "rightCorner": {
              "x": -18.952,
              "y": 4.814,
              "z": 0.778
            },
            "gtin": "3263286350185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c76",
            "leftCorner": {
              "x": -18.952,
              "y": 4.814,
              "z": 0.778
            },
            "rightCorner": {
              "x": -18.863,
              "y": 4.815,
              "z": 0.778
            },
            "gtin": "3263286350185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c77",
            "leftCorner": {
              "x": -18.863,
              "y": 4.815,
              "z": 0.778
            },
            "rightCorner": {
              "x": -18.787,
              "y": 4.816,
              "z": 0.778
            },
            "gtin": "3263286345518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c78",
            "leftCorner": {
              "x": -18.787,
              "y": 4.816,
              "z": 0.778
            },
            "rightCorner": {
              "x": -18.71,
              "y": 4.817,
              "z": 0.778
            },
            "gtin": "3263286345518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c79",
            "leftCorner": {
              "x": -18.71,
              "y": 4.82,
              "z": 0.778
            },
            "rightCorner": {
              "x": -18.599,
              "y": 4.822,
              "z": 0.778
            },
            "gtin": "3263280104975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c7a",
            "leftCorner": {
              "x": -18.599,
              "y": 4.822,
              "z": 0.778
            },
            "rightCorner": {
              "x": -18.488,
              "y": 4.824,
              "z": 0.778
            },
            "gtin": "3263280104975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c7b",
            "leftCorner": {
              "x": -18.488,
              "y": 4.826,
              "z": 0.778
            },
            "rightCorner": {
              "x": -18.337,
              "y": 4.829,
              "z": 0.778
            },
            "gtin": "8004305002099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c7c",
            "leftCorner": {
              "x": -18.337,
              "y": 4.828,
              "z": 0.778
            },
            "rightCorner": {
              "x": -18.195,
              "y": 4.83,
              "z": 0.778
            },
            "gtin": "8004305000064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c7d",
            "leftCorner": {
              "x": -18.195,
              "y": 4.827,
              "z": 0.778
            },
            "rightCorner": {
              "x": -18.063,
              "y": 4.83,
              "z": 0.778
            },
            "gtin": "8004305000026",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4b7",
        "height": 1.3565,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c54",
            "leftCorner": {
              "x": -19.058,
              "y": 4.809,
              "z": 1.11
            },
            "rightCorner": {
              "x": -18.969,
              "y": 4.811,
              "z": 1.11
            },
            "gtin": "4002958642406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c55",
            "leftCorner": {
              "x": -18.969,
              "y": 4.811,
              "z": 1.11
            },
            "rightCorner": {
              "x": -18.881,
              "y": 4.812,
              "z": 1.11
            },
            "gtin": "4002958642406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c56",
            "leftCorner": {
              "x": -18.881,
              "y": 4.811,
              "z": 1.11
            },
            "rightCorner": {
              "x": -18.732,
              "y": 4.814,
              "z": 1.11
            },
            "gtin": "4002958655161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c57",
            "leftCorner": {
              "x": -18.732,
              "y": 4.818,
              "z": 1.11
            },
            "rightCorner": {
              "x": -18.61,
              "y": 4.821,
              "z": 1.11
            },
            "gtin": "4002958655130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c58",
            "leftCorner": {
              "x": -18.61,
              "y": 4.822,
              "z": 1.11
            },
            "rightCorner": {
              "x": -18.446,
              "y": 4.825,
              "z": 1.11
            },
            "gtin": "4003301037207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c59",
            "leftCorner": {
              "x": -18.446,
              "y": 4.822,
              "z": 1.11
            },
            "rightCorner": {
              "x": -18.309,
              "y": 4.824,
              "z": 1.11
            },
            "gtin": "4003301087073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c5a",
            "leftCorner": {
              "x": -18.309,
              "y": 4.824,
              "z": 1.11
            },
            "rightCorner": {
              "x": -18.191,
              "y": 4.826,
              "z": 1.11
            },
            "gtin": "3365300012038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c5b",
            "leftCorner": {
              "x": -18.191,
              "y": 4.822,
              "z": 1.11
            },
            "rightCorner": {
              "x": -18.099,
              "y": 4.824,
              "z": 1.11
            },
            "gtin": "3500610007736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c5c",
            "leftCorner": {
              "x": -18.099,
              "y": 4.824,
              "z": 1.11
            },
            "rightCorner": {
              "x": -18.008,
              "y": 4.826,
              "z": 1.11
            },
            "gtin": "3500610007736",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4b6",
        "height": 1.7302,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c33",
            "leftCorner": {
              "x": -19.06,
              "y": 4.8,
              "z": 1.416
            },
            "rightCorner": {
              "x": -18.9,
              "y": 4.803,
              "z": 1.416
            },
            "gtin": "4006310992291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c34",
            "leftCorner": {
              "x": -18.9,
              "y": 4.803,
              "z": 1.416
            },
            "rightCorner": {
              "x": -18.786,
              "y": 4.805,
              "z": 1.416
            },
            "gtin": "8005228095014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c36",
            "leftCorner": {
              "x": -18.755,
              "y": 4.808,
              "z": 1.416
            },
            "rightCorner": {
              "x": -18.647,
              "y": 4.81,
              "z": 1.416
            },
            "gtin": "3262151001757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c37",
            "leftCorner": {
              "x": -18.647,
              "y": 4.81,
              "z": 1.416
            },
            "rightCorner": {
              "x": -18.529,
              "y": 4.812,
              "z": 1.416
            },
            "gtin": "3262156083758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c38",
            "leftCorner": {
              "x": -18.529,
              "y": 4.814,
              "z": 1.416
            },
            "rightCorner": {
              "x": -18.404,
              "y": 4.816,
              "z": 1.416
            },
            "gtin": "3500610103513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c39",
            "leftCorner": {
              "x": -18.404,
              "y": 4.815,
              "z": 1.416
            },
            "rightCorner": {
              "x": -18.248,
              "y": 4.818,
              "z": 1.416
            },
            "gtin": "8051566562466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c3a",
            "leftCorner": {
              "x": -18.248,
              "y": 4.816,
              "z": 1.416
            },
            "rightCorner": {
              "x": -18.065,
              "y": 4.819,
              "z": 1.416
            },
            "gtin": "8023354066012",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "79c",
    "rightNeighborShelfId": "79f"
  },
  {
    "id": "79f",
    "name": "79f",
    "x": -18.091,
    "y": 4.861,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0093025,
      "w": 0.99996
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4c0",
        "height": 0.16304,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7cb4",
            "leftCorner": {
              "x": -18.028,
              "y": 4.817,
              "z": 0.133
            },
            "rightCorner": {
              "x": -17.84,
              "y": 4.82,
              "z": 0.133
            },
            "gtin": "4306188008194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cb5",
            "leftCorner": {
              "x": -17.84,
              "y": 4.82,
              "z": 0.133
            },
            "rightCorner": {
              "x": -17.691,
              "y": 4.823,
              "z": 0.133
            },
            "gtin": "8410702067485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cb6",
            "leftCorner": {
              "x": -17.69,
              "y": 4.817,
              "z": 0.133
            },
            "rightCorner": {
              "x": -17.547,
              "y": 4.82,
              "z": 0.133
            },
            "gtin": "4001432869032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cb7",
            "leftCorner": {
              "x": -17.547,
              "y": 4.82,
              "z": 0.133
            },
            "rightCorner": {
              "x": -17.413,
              "y": 4.823,
              "z": 0.133
            },
            "gtin": "4022229301641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cb8",
            "leftCorner": {
              "x": -17.413,
              "y": 4.823,
              "z": 0.133
            },
            "rightCorner": {
              "x": -17.279,
              "y": 4.825,
              "z": 0.133
            },
            "gtin": "4022229301641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cb9",
            "leftCorner": {
              "x": -17.282,
              "y": 5.019,
              "z": 0.133
            },
            "rightCorner": {
              "x": -17.039,
              "y": 5.024,
              "z": 0.133
            },
            "gtin": "4006452005897",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4bd",
        "height": 0.5599,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c9f",
            "leftCorner": {
              "x": -18.063,
              "y": 4.808,
              "z": 0.458
            },
            "rightCorner": {
              "x": -17.95,
              "y": 4.81,
              "z": 0.458
            },
            "gtin": "8002793000504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ca0",
            "leftCorner": {
              "x": -17.95,
              "y": 4.809,
              "z": 0.458
            },
            "rightCorner": {
              "x": -17.841,
              "y": 4.811,
              "z": 0.458
            },
            "gtin": "4002547855002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ca1",
            "leftCorner": {
              "x": -17.841,
              "y": 4.81,
              "z": 0.458
            },
            "rightCorner": {
              "x": -17.729,
              "y": 4.812,
              "z": 0.458
            },
            "gtin": "8003625021018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ca2",
            "leftCorner": {
              "x": -17.729,
              "y": 4.814,
              "z": 0.458
            },
            "rightCorner": {
              "x": -17.618,
              "y": 4.816,
              "z": 0.458
            },
            "gtin": "3262151254757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ca3",
            "leftCorner": {
              "x": -17.618,
              "y": 4.812,
              "z": 0.458
            },
            "rightCorner": {
              "x": -17.47,
              "y": 4.815,
              "z": 0.458
            },
            "gtin": "4022229300194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ca4",
            "leftCorner": {
              "x": -17.47,
              "y": 4.819,
              "z": 0.458
            },
            "rightCorner": {
              "x": -17.298,
              "y": 4.822,
              "z": 0.458
            },
            "gtin": "5604135020039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ca5",
            "leftCorner": {
              "x": -17.298,
              "y": 4.824,
              "z": 0.458
            },
            "rightCorner": {
              "x": -17.167,
              "y": 4.827,
              "z": 0.458
            },
            "gtin": "6001108098320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ca6",
            "leftCorner": {
              "x": -17.167,
              "y": 4.827,
              "z": 0.458
            },
            "rightCorner": {
              "x": -17.034,
              "y": 4.829,
              "z": 0.458
            },
            "gtin": "6001108098320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4bf",
        "height": 0.95024,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c7e",
            "leftCorner": {
              "x": -18.062,
              "y": 4.818,
              "z": 0.777
            },
            "rightCorner": {
              "x": -17.991,
              "y": 4.82,
              "z": 0.777
            },
            "gtin": "8004305005199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c7f",
            "leftCorner": {
              "x": -17.991,
              "y": 4.82,
              "z": 0.777
            },
            "rightCorner": {
              "x": -17.921,
              "y": 4.821,
              "z": 0.777
            },
            "gtin": "8004305005199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c80",
            "leftCorner": {
              "x": -17.921,
              "y": 4.822,
              "z": 0.777
            },
            "rightCorner": {
              "x": -17.808,
              "y": 4.824,
              "z": 0.777
            },
            "gtin": "8410337803038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c81",
            "leftCorner": {
              "x": -17.807,
              "y": 4.821,
              "z": 0.777
            },
            "rightCorner": {
              "x": -17.695,
              "y": 4.823,
              "z": 0.777
            },
            "gtin": "8410337847032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c82",
            "leftCorner": {
              "x": -17.694,
              "y": 4.821,
              "z": 0.777
            },
            "rightCorner": {
              "x": -17.562,
              "y": 4.824,
              "z": 0.777
            },
            "gtin": "8410302106300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c83",
            "leftCorner": {
              "x": -17.562,
              "y": 4.828,
              "z": 0.777
            },
            "rightCorner": {
              "x": -17.419,
              "y": 4.83,
              "z": 0.777
            },
            "gtin": "4008005041833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c84",
            "leftCorner": {
              "x": -17.419,
              "y": 4.828,
              "z": 0.777
            },
            "rightCorner": {
              "x": -17.255,
              "y": 4.831,
              "z": 0.777
            },
            "gtin": "4022229300750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c85",
            "leftCorner": {
              "x": -17.255,
              "y": 4.836,
              "z": 0.777
            },
            "rightCorner": {
              "x": -17.144,
              "y": 4.839,
              "z": 0.777
            },
            "gtin": "9322214006229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c86",
            "leftCorner": {
              "x": -17.144,
              "y": 4.839,
              "z": 0.777
            },
            "rightCorner": {
              "x": -17.032,
              "y": 4.841,
              "z": 0.777
            },
            "gtin": "9322214006229",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4be",
        "height": 1.355,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c5d",
            "leftCorner": {
              "x": -18.006,
              "y": 4.819,
              "z": 1.109
            },
            "rightCorner": {
              "x": -17.857,
              "y": 4.822,
              "z": 1.109
            },
            "gtin": "4003301032363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3f06d0ef31c2e637a49a9238",
            "leftCorner": {
              "x": -18.089,
              "y": 4.772,
              "z": 1.109
            },
            "rightCorner": {
              "x": -18.009,
              "y": 4.774,
              "z": 1.109
            },
            "gtin": "8410537200422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c5e",
            "leftCorner": {
              "x": -17.856,
              "y": 4.816,
              "z": 1.109
            },
            "rightCorner": {
              "x": -17.712,
              "y": 4.819,
              "z": 1.109
            },
            "gtin": "8410702017329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c5f",
            "leftCorner": {
              "x": -17.712,
              "y": 4.818,
              "z": 1.109
            },
            "rightCorner": {
              "x": -17.572,
              "y": 4.82,
              "z": 1.109
            },
            "gtin": "8410384008387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c60",
            "leftCorner": {
              "x": -17.572,
              "y": 4.82,
              "z": 1.109
            },
            "rightCorner": {
              "x": -17.376,
              "y": 4.824,
              "z": 1.109
            },
            "gtin": "8410384004631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c61",
            "leftCorner": {
              "x": -17.377,
              "y": 4.828,
              "z": 1.109
            },
            "rightCorner": {
              "x": -17.227,
              "y": 4.83,
              "z": 1.109
            },
            "gtin": "8410384901275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c62",
            "leftCorner": {
              "x": -17.227,
              "y": 4.832,
              "z": 1.109
            },
            "rightCorner": {
              "x": -17.124,
              "y": 4.834,
              "z": 1.109
            },
            "gtin": "8410537200422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c63",
            "leftCorner": {
              "x": -17.124,
              "y": 4.834,
              "z": 1.109
            },
            "rightCorner": {
              "x": -17.021,
              "y": 4.836,
              "z": 1.109
            },
            "gtin": "8410537200422",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4bc",
        "height": 1.7267,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c3b",
            "leftCorner": {
              "x": -18.064,
              "y": 4.814,
              "z": 1.413
            },
            "rightCorner": {
              "x": -17.942,
              "y": 4.816,
              "z": 1.413
            },
            "gtin": "4002859120799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c3c",
            "leftCorner": {
              "x": -17.942,
              "y": 4.818,
              "z": 1.413
            },
            "rightCorner": {
              "x": -17.829,
              "y": 4.82,
              "z": 1.413
            },
            "gtin": "4002859121116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c3d",
            "leftCorner": {
              "x": -17.829,
              "y": 4.818,
              "z": 1.413
            },
            "rightCorner": {
              "x": -17.721,
              "y": 4.82,
              "z": 1.413
            },
            "gtin": "4002859121062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c3e",
            "leftCorner": {
              "x": -17.721,
              "y": 4.817,
              "z": 1.413
            },
            "rightCorner": {
              "x": -17.61,
              "y": 4.819,
              "z": 1.413
            },
            "gtin": "4002859125800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c3f",
            "leftCorner": {
              "x": -17.61,
              "y": 4.819,
              "z": 1.413
            },
            "rightCorner": {
              "x": -17.485,
              "y": 4.821,
              "z": 1.413
            },
            "gtin": "8023354060119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c40",
            "leftCorner": {
              "x": -17.485,
              "y": 4.822,
              "z": 1.413
            },
            "rightCorner": {
              "x": -17.344,
              "y": 4.825,
              "z": 1.413
            },
            "gtin": "8002793960464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c41",
            "leftCorner": {
              "x": -17.344,
              "y": 4.827,
              "z": 1.413
            },
            "rightCorner": {
              "x": -17.194,
              "y": 4.83,
              "z": 1.413
            },
            "gtin": "8052783850169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c42",
            "leftCorner": {
              "x": -17.194,
              "y": 4.835,
              "z": 1.413
            },
            "rightCorner": {
              "x": -16.98,
              "y": 4.839,
              "z": 1.413
            }
          }
        ]
      }
    ],
    "leftNeighborShelfId": "79e",
    "rightNeighborShelfId": "978"
  },
  {
    "id": "7a8",
    "name": "7a8",
    "x": -7.022,
    "y": 5.098,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69417,
      "w": 0.71981
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 67
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5f3",
        "height": 0.38521,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d851a",
            "leftCorner": {
              "x": -7.018,
              "y": 5.098,
              "z": 0.315
            },
            "rightCorner": {
              "x": -6.987,
              "y": 4.229,
              "z": 0.315
            },
            "gtin": "4306188050124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d851c",
            "leftCorner": {
              "x": -6.945,
              "y": 4.231,
              "z": 0.315
            },
            "rightCorner": {
              "x": -6.942,
              "y": 4.142,
              "z": 0.315
            },
            "gtin": "4002671157751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d851d",
            "leftCorner": {
              "x": -6.943,
              "y": 4.142,
              "z": 0.315
            },
            "rightCorner": {
              "x": -6.94,
              "y": 4.059,
              "z": 0.315
            },
            "gtin": "4306188364054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d851e",
            "leftCorner": {
              "x": -6.94,
              "y": 4.059,
              "z": 0.315
            },
            "rightCorner": {
              "x": -6.937,
              "y": 3.973,
              "z": 0.315
            },
            "gtin": "4306188417217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d851b",
            "leftCorner": {
              "x": -6.937,
              "y": 3.973,
              "z": 0.315
            },
            "rightCorner": {
              "x": -6.933,
              "y": 3.85,
              "z": 0.315
            },
            "gtin": "4104420076945",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5ed",
        "height": 0.72751,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d84e5",
            "leftCorner": {
              "x": -6.969,
              "y": 5.1,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.966,
              "y": 5.011,
              "z": 0.595
            },
            "gtin": "7622300318147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84e7",
            "leftCorner": {
              "x": -6.888,
              "y": 5.014,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.884,
              "y": 4.893,
              "z": 0.595
            },
            "gtin": "7622300318116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84e8",
            "leftCorner": {
              "x": -6.88,
              "y": 4.894,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.877,
              "y": 4.803,
              "z": 0.595
            },
            "gtin": "7622300318178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84e9",
            "leftCorner": {
              "x": -6.878,
              "y": 4.802,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.874,
              "y": 4.711,
              "z": 0.595
            },
            "gtin": "7622202289750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84ea",
            "leftCorner": {
              "x": -6.876,
              "y": 4.711,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.872,
              "y": 4.615,
              "z": 0.595
            },
            "gtin": "7622300315719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84eb",
            "leftCorner": {
              "x": -6.946,
              "y": 4.612,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.942,
              "y": 4.501,
              "z": 0.595
            },
            "gtin": "7622300315733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84ec",
            "leftCorner": {
              "x": -6.952,
              "y": 4.5,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.949,
              "y": 4.426,
              "z": 0.595
            },
            "gtin": "7622300318154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84ed",
            "leftCorner": {
              "x": -6.957,
              "y": 4.425,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.954,
              "y": 4.327,
              "z": 0.595
            },
            "gtin": "4000339335626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84ee",
            "leftCorner": {
              "x": -6.949,
              "y": 4.327,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.946,
              "y": 4.238,
              "z": 0.595
            },
            "gtin": "40508429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84ef",
            "leftCorner": {
              "x": -6.943,
              "y": 4.238,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.939,
              "y": 4.136,
              "z": 0.595
            },
            "gtin": "40508214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84f0",
            "leftCorner": {
              "x": -6.933,
              "y": 4.136,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.929,
              "y": 4.017,
              "z": 0.595
            },
            "gtin": "4306188415060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84f1",
            "leftCorner": {
              "x": -6.857,
              "y": 4.02,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.853,
              "y": 3.918,
              "z": 0.595
            },
            "gtin": "4306188414520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84e6",
            "leftCorner": {
              "x": -6.851,
              "y": 3.918,
              "z": 0.595
            },
            "rightCorner": {
              "x": -6.849,
              "y": 3.853,
              "z": 0.595
            },
            "gtin": "4306188400929",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5f1",
        "height": 0.92681,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8507",
            "leftCorner": {
              "x": -6.926,
              "y": 5.101,
              "z": 0.758
            },
            "rightCorner": {
              "x": -6.92,
              "y": 4.94,
              "z": 0.758
            },
            "gtin": "5711953106200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8509",
            "leftCorner": {
              "x": -6.878,
              "y": 4.941,
              "z": 0.758
            },
            "rightCorner": {
              "x": -6.873,
              "y": 4.808,
              "z": 0.758
            },
            "gtin": "5711953103766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d850a",
            "leftCorner": {
              "x": -6.872,
              "y": 4.809,
              "z": 0.758
            },
            "rightCorner": {
              "x": -6.866,
              "y": 4.636,
              "z": 0.758
            },
            "gtin": "5711953103780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d850b",
            "leftCorner": {
              "x": -6.868,
              "y": 4.636,
              "z": 0.758
            },
            "rightCorner": {
              "x": -6.864,
              "y": 4.527,
              "z": 0.758
            },
            "gtin": "5711953106408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d850c",
            "leftCorner": {
              "x": -6.865,
              "y": 4.527,
              "z": 0.758
            },
            "rightCorner": {
              "x": -6.86,
              "y": 4.403,
              "z": 0.758
            },
            "gtin": "5711953103797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d850d",
            "leftCorner": {
              "x": -6.863,
              "y": 4.403,
              "z": 0.758
            },
            "rightCorner": {
              "x": -6.858,
              "y": 4.272,
              "z": 0.758
            },
            "gtin": "5760466986205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d850e",
            "leftCorner": {
              "x": -6.864,
              "y": 4.272,
              "z": 0.758
            },
            "rightCorner": {
              "x": -6.858,
              "y": 4.119,
              "z": 0.758
            },
            "gtin": "5760466776349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d850f",
            "leftCorner": {
              "x": -6.854,
              "y": 4.12,
              "z": 0.758
            },
            "rightCorner": {
              "x": -6.849,
              "y": 4.006,
              "z": 0.758
            },
            "gtin": "4101430004104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8510",
            "leftCorner": {
              "x": -6.847,
              "y": 4.006,
              "z": 0.758
            },
            "rightCorner": {
              "x": -6.844,
              "y": 3.926,
              "z": 0.758
            },
            "gtin": "4101430004296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8508",
            "leftCorner": {
              "x": -6.848,
              "y": 3.925,
              "z": 0.758
            },
            "rightCorner": {
              "x": -6.845,
              "y": 3.854,
              "z": 0.758
            },
            "gtin": "8058151620389",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5f0",
        "height": 1.127,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7dd5",
            "leftCorner": {
              "x": -6.926,
              "y": 5.101,
              "z": 0.922
            },
            "rightCorner": {
              "x": -6.919,
              "y": 4.914,
              "z": 0.922
            },
            "gtin": "5760466848510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dd7",
            "leftCorner": {
              "x": -6.873,
              "y": 4.915,
              "z": 0.922
            },
            "rightCorner": {
              "x": -6.869,
              "y": 4.794,
              "z": 0.922
            },
            "gtin": "5711953103810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dd8",
            "leftCorner": {
              "x": -6.869,
              "y": 4.794,
              "z": 0.922
            },
            "rightCorner": {
              "x": -6.863,
              "y": 4.632,
              "z": 0.922
            },
            "gtin": "5711953099465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dd9",
            "leftCorner": {
              "x": -6.869,
              "y": 4.632,
              "z": 0.922
            },
            "rightCorner": {
              "x": -6.864,
              "y": 4.51,
              "z": 0.922
            },
            "gtin": "5711953106309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dda",
            "leftCorner": {
              "x": -6.861,
              "y": 4.51,
              "z": 0.922
            },
            "rightCorner": {
              "x": -6.859,
              "y": 4.452,
              "z": 0.922
            },
            "gtin": "4101430003817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ddb",
            "leftCorner": {
              "x": -6.868,
              "y": 4.452,
              "z": 0.922
            },
            "rightCorner": {
              "x": -6.864,
              "y": 4.346,
              "z": 0.922
            },
            "gtin": "4104420226586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ddc",
            "leftCorner": {
              "x": -6.863,
              "y": 4.346,
              "z": 0.922
            },
            "rightCorner": {
              "x": -6.859,
              "y": 4.244,
              "z": 0.922
            },
            "gtin": "4306188411031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ddd",
            "leftCorner": {
              "x": -6.857,
              "y": 4.244,
              "z": 0.922
            },
            "rightCorner": {
              "x": -6.852,
              "y": 4.106,
              "z": 0.922
            },
            "gtin": "4306188411062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dde",
            "leftCorner": {
              "x": -6.85,
              "y": 4.106,
              "z": 0.922
            },
            "rightCorner": {
              "x": -6.846,
              "y": 4.02,
              "z": 0.922
            },
            "gtin": "40508016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ddf",
            "leftCorner": {
              "x": -6.852,
              "y": 4.02,
              "z": 0.922
            },
            "rightCorner": {
              "x": -6.845,
              "y": 3.811,
              "z": 0.922
            },
            "gtin": "3155250346327",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5ef",
        "height": 1.3348,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d84fd",
            "leftCorner": {
              "x": -6.93,
              "y": 5.101,
              "z": 1.092
            },
            "rightCorner": {
              "x": -6.927,
              "y": 5.01,
              "z": 1.092
            },
            "gtin": "4306188038283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84ff",
            "leftCorner": {
              "x": -6.881,
              "y": 5.012,
              "z": 1.092
            },
            "rightCorner": {
              "x": -6.876,
              "y": 4.865,
              "z": 1.092
            },
            "gtin": "4306188400530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8500",
            "leftCorner": {
              "x": -6.874,
              "y": 4.865,
              "z": 1.092
            },
            "rightCorner": {
              "x": -6.87,
              "y": 4.754,
              "z": 1.092
            },
            "gtin": "3161716740011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8501",
            "leftCorner": {
              "x": -6.872,
              "y": 4.754,
              "z": 1.092
            },
            "rightCorner": {
              "x": -6.868,
              "y": 4.646,
              "z": 1.092
            },
            "gtin": "3161710000678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8502",
            "leftCorner": {
              "x": -6.878,
              "y": 4.645,
              "z": 1.092
            },
            "rightCorner": {
              "x": -6.873,
              "y": 4.506,
              "z": 1.092
            },
            "gtin": "3161710000623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8503",
            "leftCorner": {
              "x": -6.868,
              "y": 4.507,
              "z": 1.092
            },
            "rightCorner": {
              "x": -6.864,
              "y": 4.412,
              "z": 1.092
            },
            "gtin": "3161710000593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8504",
            "leftCorner": {
              "x": -6.867,
              "y": 4.412,
              "z": 1.092
            },
            "rightCorner": {
              "x": -6.859,
              "y": 4.198,
              "z": 1.092
            },
            "gtin": "3161712911699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8505",
            "leftCorner": {
              "x": -6.862,
              "y": 4.198,
              "z": 1.092
            },
            "rightCorner": {
              "x": -6.856,
              "y": 4.034,
              "z": 1.092
            },
            "gtin": "3161716092004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8506",
            "leftCorner": {
              "x": -6.86,
              "y": 4.034,
              "z": 1.092
            },
            "rightCorner": {
              "x": -6.856,
              "y": 3.926,
              "z": 1.092
            },
            "gtin": "3250550020707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84fe",
            "leftCorner": {
              "x": -6.857,
              "y": 3.926,
              "z": 1.092
            },
            "rightCorner": {
              "x": -6.855,
              "y": 3.853,
              "z": 1.092
            },
            "gtin": "8000430194012",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5ee",
        "height": 1.5375,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d84f2",
            "leftCorner": {
              "x": -6.936,
              "y": 5.101,
              "z": 1.258
            },
            "rightCorner": {
              "x": -6.932,
              "y": 4.996,
              "z": 1.258
            },
            "gtin": "4020300119451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84f4",
            "leftCorner": {
              "x": -6.888,
              "y": 4.998,
              "z": 1.258
            },
            "rightCorner": {
              "x": -6.883,
              "y": 4.866,
              "z": 1.258
            },
            "gtin": "4020300119413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84f5",
            "leftCorner": {
              "x": -6.884,
              "y": 4.865,
              "z": 1.258
            },
            "rightCorner": {
              "x": -6.877,
              "y": 4.689,
              "z": 1.258
            },
            "gtin": "4020300118515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84f6",
            "leftCorner": {
              "x": -6.878,
              "y": 4.689,
              "z": 1.258
            },
            "rightCorner": {
              "x": -6.873,
              "y": 4.547,
              "z": 1.258
            },
            "gtin": "3614070059348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84f7",
            "leftCorner": {
              "x": -6.872,
              "y": 4.547,
              "z": 1.258
            },
            "rightCorner": {
              "x": -6.869,
              "y": 4.464,
              "z": 1.258
            },
            "gtin": "4306188041542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84f8",
            "leftCorner": {
              "x": -6.872,
              "y": 4.463,
              "z": 1.258
            },
            "rightCorner": {
              "x": -6.869,
              "y": 4.368,
              "z": 1.258
            },
            "gtin": "3272770003148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84f9",
            "leftCorner": {
              "x": -6.877,
              "y": 4.368,
              "z": 1.258
            },
            "rightCorner": {
              "x": -6.873,
              "y": 4.257,
              "z": 1.258
            },
            "gtin": "4042089001246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84fa",
            "leftCorner": {
              "x": -6.869,
              "y": 4.257,
              "z": 1.258
            },
            "rightCorner": {
              "x": -6.865,
              "y": 4.146,
              "z": 1.258
            },
            "gtin": "3222110029994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84fb",
            "leftCorner": {
              "x": -6.864,
              "y": 4.146,
              "z": 1.258
            },
            "rightCorner": {
              "x": -6.859,
              "y": 4.034,
              "z": 1.258
            },
            "gtin": "3222110010695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84fc",
            "leftCorner": {
              "x": -6.862,
              "y": 4.034,
              "z": 1.258
            },
            "rightCorner": {
              "x": -6.857,
              "y": 3.917,
              "z": 1.258
            },
            "gtin": "3153126826003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d84f3",
            "leftCorner": {
              "x": -6.856,
              "y": 3.917,
              "z": 1.258
            },
            "rightCorner": {
              "x": -6.853,
              "y": 3.853,
              "z": 1.258
            },
            "gtin": "3176580107297",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5f2",
        "height": 1.7303,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8511",
            "leftCorner": {
              "x": -6.932,
              "y": 5.101,
              "z": 1.416
            },
            "rightCorner": {
              "x": -6.925,
              "y": 4.935,
              "z": 1.416
            },
            "gtin": "4306188422617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8513",
            "leftCorner": {
              "x": -6.88,
              "y": 4.937,
              "z": 1.416
            },
            "rightCorner": {
              "x": -6.874,
              "y": 4.781,
              "z": 1.416
            },
            "gtin": "4006402100832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8514",
            "leftCorner": {
              "x": -6.874,
              "y": 4.781,
              "z": 1.416
            },
            "rightCorner": {
              "x": -6.868,
              "y": 4.633,
              "z": 1.416
            },
            "gtin": "5740200001012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8515",
            "leftCorner": {
              "x": -6.868,
              "y": 4.633,
              "z": 1.416
            },
            "rightCorner": {
              "x": -6.865,
              "y": 4.556,
              "z": 1.416
            },
            "gtin": "5711953097430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8516",
            "leftCorner": {
              "x": -6.872,
              "y": 4.556,
              "z": 1.416
            },
            "rightCorner": {
              "x": -6.868,
              "y": 4.448,
              "z": 1.416
            },
            "gtin": "4006402025128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8517",
            "leftCorner": {
              "x": -6.872,
              "y": 4.448,
              "z": 1.416
            },
            "rightCorner": {
              "x": -6.867,
              "y": 4.308,
              "z": 1.416
            },
            "gtin": "4006402030511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8518",
            "leftCorner": {
              "x": -6.867,
              "y": 4.308,
              "z": 1.416
            },
            "rightCorner": {
              "x": -6.862,
              "y": 4.173,
              "z": 1.416
            },
            "gtin": "4006402071514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8519",
            "leftCorner": {
              "x": -6.858,
              "y": 4.173,
              "z": 1.416
            },
            "rightCorner": {
              "x": -6.853,
              "y": 4.029,
              "z": 1.416
            },
            "gtin": "4006402020413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8512",
            "leftCorner": {
              "x": -6.854,
              "y": 4.029,
              "z": 1.416
            },
            "rightCorner": {
              "x": -6.848,
              "y": 3.853,
              "z": 1.416
            },
            "gtin": "4006402025418",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "974"
  },
  {
    "id": "7ae",
    "name": "7ae",
    "x": -10.129,
    "y": -6.269,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.0037699
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 63
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d5fb",
        "height": 0.17334,
        "facings": [
          {
            "id": "4a092c191d1453c5883336e8",
            "leftCorner": {
              "x": -10.129,
              "y": -6.187,
              "z": 0.142
            },
            "rightCorner": {
              "x": -10.214,
              "y": -6.188,
              "z": 0.142
            },
            "gtin": "42394846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "06fcf87ad7401d105a5b8f4f",
            "leftCorner": {
              "x": -10.214,
              "y": -6.188,
              "z": 0.142
            },
            "rightCorner": {
              "x": -10.299,
              "y": -6.189,
              "z": 0.142
            },
            "gtin": "42421009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1afbdb2d181bfb321a8dc003",
            "leftCorner": {
              "x": -10.299,
              "y": -6.189,
              "z": 0.142
            },
            "rightCorner": {
              "x": -10.386,
              "y": -6.189,
              "z": 0.142
            },
            "gtin": "42421320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b5b9ec758253e89b2c203596",
            "leftCorner": {
              "x": -10.386,
              "y": -6.189,
              "z": 0.142
            },
            "rightCorner": {
              "x": -10.475,
              "y": -6.19,
              "z": 0.142
            },
            "gtin": "42394808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c1994756db2977b34dff135c",
            "leftCorner": {
              "x": -10.475,
              "y": -6.19,
              "z": 0.142
            },
            "rightCorner": {
              "x": -10.57,
              "y": -6.191,
              "z": 0.142
            },
            "gtin": "42421337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6bd8d3dbb661a672d8749e3b",
            "leftCorner": {
              "x": -10.57,
              "y": -6.191,
              "z": 0.142
            },
            "rightCorner": {
              "x": -10.665,
              "y": -6.191,
              "z": 0.142
            },
            "gtin": "42421344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "22fdbc1a0f0e761e552a23a9",
            "leftCorner": {
              "x": -10.665,
              "y": -6.191,
              "z": 0.142
            },
            "rightCorner": {
              "x": -10.761,
              "y": -6.192,
              "z": 0.142
            },
            "gtin": "7613037056822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0a3a4f356a340a97d2c3c21d",
            "leftCorner": {
              "x": -10.761,
              "y": -6.192,
              "z": 0.142
            },
            "rightCorner": {
              "x": -10.871,
              "y": -6.193,
              "z": 0.142
            },
            "gtin": "40055480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee25ee13e77faf5e4e4e7462",
            "leftCorner": {
              "x": -10.871,
              "y": -6.193,
              "z": 0.142
            },
            "rightCorner": {
              "x": -10.984,
              "y": -6.194,
              "z": 0.142
            },
            "gtin": "42420996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d670e78e07c204f93132fa8d",
            "leftCorner": {
              "x": -10.984,
              "y": -6.194,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.1,
              "y": -6.195,
              "z": 0.142
            },
            "gtin": "7613287054357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "493dad8f86f463f6d5be0a09",
            "leftCorner": {
              "x": -11.1,
              "y": -6.195,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.378,
              "y": -6.197,
              "z": 0.142
            },
            "gtin": "7613035084421",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5f6",
        "height": 0.4783,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f49",
            "leftCorner": {
              "x": -10.129,
              "y": -6.239,
              "z": 0.391
            },
            "rightCorner": {
              "x": -10.26,
              "y": -6.24,
              "z": 0.391
            },
            "gtin": "40056531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f4b",
            "leftCorner": {
              "x": -10.26,
              "y": -6.279,
              "z": 0.391
            },
            "rightCorner": {
              "x": -10.396,
              "y": -6.28,
              "z": 0.391
            },
            "gtin": "42403050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f4c",
            "leftCorner": {
              "x": -10.396,
              "y": -6.284,
              "z": 0.391
            },
            "rightCorner": {
              "x": -10.521,
              "y": -6.285,
              "z": 0.391
            },
            "gtin": "42403067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f4d",
            "leftCorner": {
              "x": -10.521,
              "y": -6.284,
              "z": 0.391
            },
            "rightCorner": {
              "x": -10.64,
              "y": -6.284,
              "z": 0.391
            },
            "gtin": "42403074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f4e",
            "leftCorner": {
              "x": -10.64,
              "y": -6.283,
              "z": 0.391
            },
            "rightCorner": {
              "x": -10.791,
              "y": -6.284,
              "z": 0.391
            },
            "gtin": "4005500306504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f4f",
            "leftCorner": {
              "x": -10.791,
              "y": -6.283,
              "z": 0.391
            },
            "rightCorner": {
              "x": -10.899,
              "y": -6.284,
              "z": 0.391
            },
            "gtin": "40055480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f50",
            "leftCorner": {
              "x": -10.9,
              "y": -6.275,
              "z": 0.391
            },
            "rightCorner": {
              "x": -11.04,
              "y": -6.276,
              "z": 0.391
            },
            "gtin": "7613287093394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f51",
            "leftCorner": {
              "x": -11.04,
              "y": -6.276,
              "z": 0.391
            },
            "rightCorner": {
              "x": -11.204,
              "y": -6.277,
              "z": 0.391
            },
            "gtin": "7613287094285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f52",
            "leftCorner": {
              "x": -11.204,
              "y": -6.275,
              "z": 0.391
            },
            "rightCorner": {
              "x": -11.436,
              "y": -6.276,
              "z": 0.391
            },
            "gtin": "7613287094261",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5f7",
        "height": 0.69985,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f2a",
            "leftCorner": {
              "x": -10.129,
              "y": -6.231,
              "z": 0.573
            },
            "rightCorner": {
              "x": -10.273,
              "y": -6.232,
              "z": 0.573
            },
            "gtin": "7613036343640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f2c",
            "leftCorner": {
              "x": -10.273,
              "y": -6.28,
              "z": 0.573
            },
            "rightCorner": {
              "x": -10.418,
              "y": -6.281,
              "z": 0.573
            },
            "gtin": "7613287373618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f2d",
            "leftCorner": {
              "x": -10.418,
              "y": -6.279,
              "z": 0.573
            },
            "rightCorner": {
              "x": -10.551,
              "y": -6.28,
              "z": 0.573
            },
            "gtin": "7613287238788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f2e",
            "leftCorner": {
              "x": -10.551,
              "y": -6.278,
              "z": 0.573
            },
            "rightCorner": {
              "x": -10.689,
              "y": -6.279,
              "z": 0.573
            },
            "gtin": "7613287254689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f2f",
            "leftCorner": {
              "x": -10.689,
              "y": -6.277,
              "z": 0.573
            },
            "rightCorner": {
              "x": -10.837,
              "y": -6.278,
              "z": 0.573
            },
            "gtin": "7613035367586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f30",
            "leftCorner": {
              "x": -10.837,
              "y": -6.274,
              "z": 0.573
            },
            "rightCorner": {
              "x": -10.981,
              "y": -6.275,
              "z": 0.573
            },
            "gtin": "8445290056542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f31",
            "leftCorner": {
              "x": -10.981,
              "y": -6.276,
              "z": 0.573
            },
            "rightCorner": {
              "x": -11.114,
              "y": -6.277,
              "z": 0.573
            },
            "gtin": "7613035419131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f32",
            "leftCorner": {
              "x": -11.114,
              "y": -6.273,
              "z": 0.573
            },
            "rightCorner": {
              "x": -11.255,
              "y": -6.274,
              "z": 0.573
            },
            "gtin": "7613035410497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f33",
            "leftCorner": {
              "x": -11.255,
              "y": -6.272,
              "z": 0.573
            },
            "rightCorner": {
              "x": -11.402,
              "y": -6.273,
              "z": 0.573
            },
            "gtin": "7613035084629",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5fa",
        "height": 0.92712,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4fe1",
            "leftCorner": {
              "x": -10.129,
              "y": -6.229,
              "z": 0.759
            },
            "rightCorner": {
              "x": -10.283,
              "y": -6.23,
              "z": 0.759
            },
            "gtin": "7613035414259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fe3",
            "leftCorner": {
              "x": -10.282,
              "y": -6.277,
              "z": 0.759
            },
            "rightCorner": {
              "x": -10.562,
              "y": -6.28,
              "z": 0.759
            },
            "gtin": "7613036028547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fe4",
            "leftCorner": {
              "x": -10.562,
              "y": -6.278,
              "z": 0.759
            },
            "rightCorner": {
              "x": -10.837,
              "y": -6.28,
              "z": 0.759
            },
            "gtin": "8445291800076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fe5",
            "leftCorner": {
              "x": -10.837,
              "y": -6.275,
              "z": 0.759
            },
            "rightCorner": {
              "x": -10.969,
              "y": -6.276,
              "z": 0.759
            },
            "gtin": "7613287353870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fe6",
            "leftCorner": {
              "x": -10.969,
              "y": -6.275,
              "z": 0.759
            },
            "rightCorner": {
              "x": -11.128,
              "y": -6.276,
              "z": 0.759
            },
            "gtin": "8445290056405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fe7",
            "leftCorner": {
              "x": -11.128,
              "y": -6.276,
              "z": 0.759
            },
            "rightCorner": {
              "x": -11.263,
              "y": -6.277,
              "z": 0.759
            },
            "gtin": "7613287238672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fe8",
            "leftCorner": {
              "x": -11.263,
              "y": -6.275,
              "z": 0.759
            },
            "rightCorner": {
              "x": -11.406,
              "y": -6.276,
              "z": 0.759
            },
            "gtin": "7613287238757",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5f9",
        "height": 1.1544,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f65",
            "leftCorner": {
              "x": -10.129,
              "y": -6.231,
              "z": 0.944
            },
            "rightCorner": {
              "x": -10.273,
              "y": -6.232,
              "z": 0.944
            },
            "gtin": "7613287329271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f67",
            "leftCorner": {
              "x": -10.272,
              "y": -6.28,
              "z": 0.944
            },
            "rightCorner": {
              "x": -10.42,
              "y": -6.281,
              "z": 0.944
            },
            "gtin": "7613036028523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f68",
            "leftCorner": {
              "x": -10.42,
              "y": -6.28,
              "z": 0.944
            },
            "rightCorner": {
              "x": -10.701,
              "y": -6.282,
              "z": 0.944
            },
            "gtin": "7613035084421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f69",
            "leftCorner": {
              "x": -10.701,
              "y": -6.277,
              "z": 0.944
            },
            "rightCorner": {
              "x": -10.841,
              "y": -6.278,
              "z": 0.944
            },
            "gtin": "7613035761889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f6a",
            "leftCorner": {
              "x": -10.841,
              "y": -6.275,
              "z": 0.944
            },
            "rightCorner": {
              "x": -10.996,
              "y": -6.276,
              "z": 0.944
            },
            "gtin": "8445290056764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f6b",
            "leftCorner": {
              "x": -10.996,
              "y": -6.277,
              "z": 0.944
            },
            "rightCorner": {
              "x": -11.133,
              "y": -6.278,
              "z": 0.944
            },
            "gtin": "7613036324724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f6c",
            "leftCorner": {
              "x": -11.133,
              "y": -6.276,
              "z": 0.944
            },
            "rightCorner": {
              "x": -11.26,
              "y": -6.277,
              "z": 0.944
            },
            "gtin": "7613036028462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f6d",
            "leftCorner": {
              "x": -11.26,
              "y": -6.274,
              "z": 0.944
            },
            "rightCorner": {
              "x": -11.411,
              "y": -6.275,
              "z": 0.944
            },
            "gtin": "7613287238320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5f8",
        "height": 1.3835,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4fb6",
            "leftCorner": {
              "x": -10.129,
              "y": -6.229,
              "z": 1.132
            },
            "rightCorner": {
              "x": -10.218,
              "y": -6.23,
              "z": 1.132
            },
            "gtin": "42394846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fb8",
            "leftCorner": {
              "x": -10.218,
              "y": -6.269,
              "z": 1.132
            },
            "rightCorner": {
              "x": -10.391,
              "y": -6.27,
              "z": 1.132
            },
            "gtin": "42394839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fb9",
            "leftCorner": {
              "x": -10.391,
              "y": -6.271,
              "z": 1.132
            },
            "rightCorner": {
              "x": -10.572,
              "y": -6.273,
              "z": 1.132
            },
            "gtin": "42403081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fba",
            "leftCorner": {
              "x": -10.572,
              "y": -6.273,
              "z": 1.132
            },
            "rightCorner": {
              "x": -10.675,
              "y": -6.274,
              "z": 1.132
            },
            "gtin": "7613037056822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fbb",
            "leftCorner": {
              "x": -10.675,
              "y": -6.274,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.008,
              "y": -6.276,
              "z": 1.132
            },
            "gtin": "7613287054333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fbc",
            "leftCorner": {
              "x": -11.008,
              "y": -6.272,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.149,
              "y": -6.273,
              "z": 1.132
            },
            "gtin": "7613036039093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fbd",
            "leftCorner": {
              "x": -11.149,
              "y": -6.272,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.274,
              "y": -6.273,
              "z": 1.132
            },
            "gtin": "7613035110878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fbe",
            "leftCorner": {
              "x": -11.274,
              "y": -6.269,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.433,
              "y": -6.27,
              "z": 1.132
            },
            "gtin": "7613287054357",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5f5",
        "height": 1.6072,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f8e",
            "leftCorner": {
              "x": -10.129,
              "y": -6.231,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.227,
              "y": -6.232,
              "z": 1.315
            },
            "gtin": "42421337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f90",
            "leftCorner": {
              "x": -10.227,
              "y": -6.276,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.316,
              "y": -6.277,
              "z": 1.315
            },
            "gtin": "42421320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f91",
            "leftCorner": {
              "x": -10.316,
              "y": -6.277,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.404,
              "y": -6.277,
              "z": 1.315
            },
            "gtin": "42394808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f92",
            "leftCorner": {
              "x": -10.404,
              "y": -6.276,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.487,
              "y": -6.277,
              "z": 1.315
            },
            "gtin": "42421009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f93",
            "leftCorner": {
              "x": -10.487,
              "y": -6.274,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.593,
              "y": -6.275,
              "z": 1.315
            },
            "gtin": "42420996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f94",
            "leftCorner": {
              "x": -10.593,
              "y": -6.275,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.69,
              "y": -6.275,
              "z": 1.315
            },
            "gtin": "42421344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f95",
            "leftCorner": {
              "x": -10.69,
              "y": -6.275,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.844,
              "y": -6.277,
              "z": 1.315
            },
            "gtin": "7613287054401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f96",
            "leftCorner": {
              "x": -10.844,
              "y": -6.274,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.979,
              "y": -6.275,
              "z": 1.315
            },
            "gtin": "7613034330444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f97",
            "leftCorner": {
              "x": -10.979,
              "y": -6.274,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.114,
              "y": -6.275,
              "z": 1.315
            },
            "gtin": "7613035414013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f98",
            "leftCorner": {
              "x": -11.114,
              "y": -6.274,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.247,
              "y": -6.275,
              "z": 1.315
            },
            "gtin": "7613287054197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f99",
            "leftCorner": {
              "x": -11.248,
              "y": -6.27,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.409,
              "y": -6.272,
              "z": 1.315
            },
            "gtin": "7613035410473",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "7af"
  },
  {
    "id": "7af",
    "name": "7af",
    "x": -11.379,
    "y": -6.278,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.0037699
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 66
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce4e",
        "height": 0.16936,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5012",
            "leftCorner": {
              "x": -12.235,
              "y": -6.208,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.37,
              "y": -6.21,
              "z": 0.139
            },
            "gtin": "7613035448759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7319221b38ca983f420549f7",
            "leftCorner": {
              "x": -11.379,
              "y": -6.173,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.451,
              "y": -6.173,
              "z": 0.139
            },
            "gtin": "7613035441927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3da8eb1ea48443b897aed1a7",
            "leftCorner": {
              "x": -11.451,
              "y": -6.173,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.539,
              "y": -6.174,
              "z": 0.139
            },
            "gtin": "7613035442368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9ccf47851c62ef3dfd93c9d2",
            "leftCorner": {
              "x": -11.539,
              "y": -6.174,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.637,
              "y": -6.175,
              "z": 0.139
            },
            "gtin": "7613035442689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2a5d3ac2f9566f779368eb77",
            "leftCorner": {
              "x": -11.637,
              "y": -6.175,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.761,
              "y": -6.176,
              "z": 0.139
            },
            "gtin": "7613035448759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dfa7e8c99a8627e769fdd9d2",
            "leftCorner": {
              "x": -11.761,
              "y": -6.176,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.833,
              "y": -6.176,
              "z": 0.139
            },
            "gtin": "7613035441927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8dd014b98f27a92e7fb78c89",
            "leftCorner": {
              "x": -11.833,
              "y": -6.176,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.921,
              "y": -6.177,
              "z": 0.139
            },
            "gtin": "7613035442368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8ad1cb1d7dfc683a235272da",
            "leftCorner": {
              "x": -11.921,
              "y": -6.177,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.019,
              "y": -6.178,
              "z": 0.139
            },
            "gtin": "7613035442689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c501437767490c01e663b5d9",
            "leftCorner": {
              "x": -12.019,
              "y": -6.178,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.143,
              "y": -6.178,
              "z": 0.139
            },
            "gtin": "7613035448759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fdd5c5c377007464183c0cf5",
            "leftCorner": {
              "x": -12.143,
              "y": -6.178,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.232,
              "y": -6.179,
              "z": 0.139
            },
            "gtin": "7613035442368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5013",
            "leftCorner": {
              "x": -12.37,
              "y": -6.214,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.473,
              "y": -6.214,
              "z": 0.139
            },
            "gtin": "7613035442689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5014",
            "leftCorner": {
              "x": -12.473,
              "y": -6.22,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.557,
              "y": -6.22,
              "z": 0.139
            },
            "gtin": "7613035442368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5015",
            "leftCorner": {
              "x": -12.557,
              "y": -6.218,
              "z": 0.139
            },
            "rightCorner": {
              "x": -12.678,
              "y": -6.219,
              "z": 0.139
            },
            "gtin": "7613035441927",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce49",
        "height": 0.48054,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f53",
            "leftCorner": {
              "x": -11.436,
              "y": -6.268,
              "z": 0.393
            },
            "rightCorner": {
              "x": -11.531,
              "y": -6.269,
              "z": 0.393
            },
            "gtin": "4005500027843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a5622213bccd129fc8594f30",
            "leftCorner": {
              "x": -11.379,
              "y": -6.226,
              "z": 0.393
            },
            "rightCorner": {
              "x": -11.429,
              "y": -6.226,
              "z": 0.393
            },
            "gtin": "4005500027874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f54",
            "leftCorner": {
              "x": -11.531,
              "y": -6.268,
              "z": 0.393
            },
            "rightCorner": {
              "x": -11.608,
              "y": -6.269,
              "z": 0.393
            },
            "gtin": "4005500027850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f55",
            "leftCorner": {
              "x": -11.608,
              "y": -6.267,
              "z": 0.393
            },
            "rightCorner": {
              "x": -11.707,
              "y": -6.268,
              "z": 0.393
            },
            "gtin": "4005500027874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f56",
            "leftCorner": {
              "x": -11.707,
              "y": -6.271,
              "z": 0.393
            },
            "rightCorner": {
              "x": -11.81,
              "y": -6.271,
              "z": 0.393
            },
            "gtin": "4005500027898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f57",
            "leftCorner": {
              "x": -11.81,
              "y": -6.273,
              "z": 0.393
            },
            "rightCorner": {
              "x": -11.911,
              "y": -6.274,
              "z": 0.393
            },
            "gtin": "4005500027911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f58",
            "leftCorner": {
              "x": -11.911,
              "y": -6.273,
              "z": 0.393
            },
            "rightCorner": {
              "x": -12.013,
              "y": -6.273,
              "z": 0.393
            },
            "gtin": "4005500021629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f59",
            "leftCorner": {
              "x": -12.013,
              "y": -6.27,
              "z": 0.393
            },
            "rightCorner": {
              "x": -12.122,
              "y": -6.271,
              "z": 0.393
            },
            "gtin": "7613035442085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f5a",
            "leftCorner": {
              "x": -12.122,
              "y": -6.27,
              "z": 0.393
            },
            "rightCorner": {
              "x": -12.211,
              "y": -6.27,
              "z": 0.393
            },
            "gtin": "7613035458840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f5b",
            "leftCorner": {
              "x": -12.211,
              "y": -6.266,
              "z": 0.393
            },
            "rightCorner": {
              "x": -12.431,
              "y": -6.268,
              "z": 0.393
            },
            "gtin": "4005500331407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f5c",
            "leftCorner": {
              "x": -12.431,
              "y": -6.272,
              "z": 0.393
            },
            "rightCorner": {
              "x": -12.521,
              "y": -6.273,
              "z": 0.393
            },
            "gtin": "7613035442047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f5d",
            "leftCorner": {
              "x": -12.521,
              "y": -6.272,
              "z": 0.393
            },
            "rightCorner": {
              "x": -12.675,
              "y": -6.273,
              "z": 0.393
            },
            "gtin": "8445290181084",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce48",
        "height": 0.70232,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f34",
            "leftCorner": {
              "x": -11.402,
              "y": -6.27,
              "z": 0.575
            },
            "rightCorner": {
              "x": -11.511,
              "y": -6.271,
              "z": 0.575
            },
            "gtin": "7613287238382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f35",
            "leftCorner": {
              "x": -11.511,
              "y": -6.27,
              "z": 0.575
            },
            "rightCorner": {
              "x": -11.649,
              "y": -6.271,
              "z": 0.575
            },
            "gtin": "7613033804588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f36",
            "leftCorner": {
              "x": -11.649,
              "y": -6.271,
              "z": 0.575
            },
            "rightCorner": {
              "x": -11.926,
              "y": -6.273,
              "z": 0.575
            },
            "gtin": "7613287054166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f37",
            "leftCorner": {
              "x": -11.926,
              "y": -6.274,
              "z": 0.575
            },
            "rightCorner": {
              "x": -12.211,
              "y": -6.276,
              "z": 0.575
            },
            "gtin": "7613036028301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f38",
            "leftCorner": {
              "x": -12.211,
              "y": -6.269,
              "z": 0.575
            },
            "rightCorner": {
              "x": -12.374,
              "y": -6.27,
              "z": 0.575
            },
            "gtin": "7613036028608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f39",
            "leftCorner": {
              "x": -12.374,
              "y": -6.271,
              "z": 0.575
            },
            "rightCorner": {
              "x": -12.504,
              "y": -6.272,
              "z": 0.575
            },
            "gtin": "7613036072489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f3a",
            "leftCorner": {
              "x": -12.504,
              "y": -6.273,
              "z": 0.575
            },
            "rightCorner": {
              "x": -12.666,
              "y": -6.274,
              "z": 0.575
            },
            "gtin": "7613036072441",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce4d",
        "height": 0.93054,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4fe9",
            "leftCorner": {
              "x": -11.407,
              "y": -6.271,
              "z": 0.761
            },
            "rightCorner": {
              "x": -11.566,
              "y": -6.273,
              "z": 0.761
            },
            "gtin": "7613287053893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fea",
            "leftCorner": {
              "x": -11.567,
              "y": -6.269,
              "z": 0.761
            },
            "rightCorner": {
              "x": -11.696,
              "y": -6.27,
              "z": 0.761
            },
            "gtin": "7613035084582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4feb",
            "leftCorner": {
              "x": -11.696,
              "y": -6.271,
              "z": 0.761
            },
            "rightCorner": {
              "x": -11.846,
              "y": -6.272,
              "z": 0.761
            },
            "gtin": "8445290056603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fec",
            "leftCorner": {
              "x": -11.846,
              "y": -6.275,
              "z": 0.761
            },
            "rightCorner": {
              "x": -11.959,
              "y": -6.276,
              "z": 0.761
            },
            "gtin": "7613287053879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fed",
            "leftCorner": {
              "x": -11.959,
              "y": -6.273,
              "z": 0.761
            },
            "rightCorner": {
              "x": -12.099,
              "y": -6.274,
              "z": 0.761
            },
            "gtin": "7613036028585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fee",
            "leftCorner": {
              "x": -12.099,
              "y": -6.274,
              "z": 0.761
            },
            "rightCorner": {
              "x": -12.212,
              "y": -6.274,
              "z": 0.761
            },
            "gtin": "8445290066091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fef",
            "leftCorner": {
              "x": -12.212,
              "y": -6.27,
              "z": 0.761
            },
            "rightCorner": {
              "x": -12.355,
              "y": -6.271,
              "z": 0.761
            },
            "gtin": "7613036041980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4ff0",
            "leftCorner": {
              "x": -12.355,
              "y": -6.271,
              "z": 0.761
            },
            "rightCorner": {
              "x": -12.5,
              "y": -6.272,
              "z": 0.761
            },
            "gtin": "7613035185876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4ff1",
            "leftCorner": {
              "x": -12.5,
              "y": -6.275,
              "z": 0.761
            },
            "rightCorner": {
              "x": -12.669,
              "y": -6.276,
              "z": 0.761
            },
            "gtin": "8445290187604",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce4a",
        "height": 1.1582,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f6e",
            "leftCorner": {
              "x": -11.412,
              "y": -6.271,
              "z": 0.948
            },
            "rightCorner": {
              "x": -11.536,
              "y": -6.272,
              "z": 0.948
            },
            "gtin": "7613287238627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f6f",
            "leftCorner": {
              "x": -11.536,
              "y": -6.271,
              "z": 0.948
            },
            "rightCorner": {
              "x": -11.673,
              "y": -6.273,
              "z": 0.948
            },
            "gtin": "7613287238603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f70",
            "leftCorner": {
              "x": -11.673,
              "y": -6.273,
              "z": 0.948
            },
            "rightCorner": {
              "x": -11.952,
              "y": -6.275,
              "z": 0.948
            },
            "gtin": "7613036027168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f71",
            "leftCorner": {
              "x": -11.952,
              "y": -6.276,
              "z": 0.948
            },
            "rightCorner": {
              "x": -12.105,
              "y": -6.277,
              "z": 0.948
            },
            "gtin": "8445290056740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f72",
            "leftCorner": {
              "x": -12.105,
              "y": -6.273,
              "z": 0.948
            },
            "rightCorner": {
              "x": -12.215,
              "y": -6.274,
              "z": 0.948
            },
            "gtin": "8445290058249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f73",
            "leftCorner": {
              "x": -12.215,
              "y": -6.271,
              "z": 0.948
            },
            "rightCorner": {
              "x": -12.508,
              "y": -6.273,
              "z": 0.948
            },
            "gtin": "7613035161399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f74",
            "leftCorner": {
              "x": -12.508,
              "y": -6.276,
              "z": 0.948
            },
            "rightCorner": {
              "x": -12.659,
              "y": -6.277,
              "z": 0.948
            },
            "gtin": "7613035154339",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce4c",
        "height": 1.3859,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4fbf",
            "leftCorner": {
              "x": -11.434,
              "y": -6.264,
              "z": 1.134
            },
            "rightCorner": {
              "x": -11.561,
              "y": -6.265,
              "z": 1.134
            },
            "gtin": "7613036028349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fc0",
            "leftCorner": {
              "x": -11.561,
              "y": -6.265,
              "z": 1.134
            },
            "rightCorner": {
              "x": -11.665,
              "y": -6.266,
              "z": 1.134
            },
            "gtin": "8445290063380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fc1",
            "leftCorner": {
              "x": -11.665,
              "y": -6.267,
              "z": 1.134
            },
            "rightCorner": {
              "x": -11.799,
              "y": -6.268,
              "z": 1.134
            },
            "gtin": "7613035110359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fc2",
            "leftCorner": {
              "x": -11.799,
              "y": -6.269,
              "z": 1.134
            },
            "rightCorner": {
              "x": -11.943,
              "y": -6.27,
              "z": 1.134
            },
            "gtin": "7613036612180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fc3",
            "leftCorner": {
              "x": -11.943,
              "y": -6.269,
              "z": 1.134
            },
            "rightCorner": {
              "x": -12.075,
              "y": -6.27,
              "z": 1.134
            },
            "gtin": "7613035110335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fc4",
            "leftCorner": {
              "x": -12.075,
              "y": -6.268,
              "z": 1.134
            },
            "rightCorner": {
              "x": -12.227,
              "y": -6.269,
              "z": 1.134
            },
            "gtin": "7613035084643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fc5",
            "leftCorner": {
              "x": -12.227,
              "y": -6.267,
              "z": 1.134
            },
            "rightCorner": {
              "x": -12.36,
              "y": -6.268,
              "z": 1.134
            },
            "gtin": "7613036041423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fc6",
            "leftCorner": {
              "x": -12.36,
              "y": -6.269,
              "z": 1.134
            },
            "rightCorner": {
              "x": -12.507,
              "y": -6.27,
              "z": 1.134
            },
            "gtin": "7613036053600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fc7",
            "leftCorner": {
              "x": -12.507,
              "y": -6.273,
              "z": 1.134
            },
            "rightCorner": {
              "x": -12.629,
              "y": -6.274,
              "z": 1.134
            },
            "gtin": "7613035290921",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce4b",
        "height": 1.6105,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f9a",
            "leftCorner": {
              "x": -11.409,
              "y": -6.268,
              "z": 1.318
            },
            "rightCorner": {
              "x": -11.542,
              "y": -6.269,
              "z": 1.318
            },
            "gtin": "7613031698417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f9b",
            "leftCorner": {
              "x": -11.542,
              "y": -6.266,
              "z": 1.318
            },
            "rightCorner": {
              "x": -11.697,
              "y": -6.268,
              "z": 1.318
            },
            "gtin": "7613287238368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f9c",
            "leftCorner": {
              "x": -11.697,
              "y": -6.268,
              "z": 1.318
            },
            "rightCorner": {
              "x": -11.838,
              "y": -6.269,
              "z": 1.318
            },
            "gtin": "7613030718697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f9d",
            "leftCorner": {
              "x": -11.838,
              "y": -6.27,
              "z": 1.318
            },
            "rightCorner": {
              "x": -11.946,
              "y": -6.271,
              "z": 1.318
            },
            "gtin": "7613031218004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f9e",
            "leftCorner": {
              "x": -11.946,
              "y": -6.269,
              "z": 1.318
            },
            "rightCorner": {
              "x": -12.078,
              "y": -6.27,
              "z": 1.318
            },
            "gtin": "8445291085855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f9f",
            "leftCorner": {
              "x": -12.079,
              "y": -6.266,
              "z": 1.318
            },
            "rightCorner": {
              "x": -12.212,
              "y": -6.267,
              "z": 1.318
            },
            "gtin": "7613036027182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fa0",
            "leftCorner": {
              "x": -12.212,
              "y": -6.265,
              "z": 1.318
            },
            "rightCorner": {
              "x": -12.36,
              "y": -6.266,
              "z": 1.318
            },
            "gtin": "7613039470343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fa1",
            "leftCorner": {
              "x": -12.36,
              "y": -6.267,
              "z": 1.318
            },
            "rightCorner": {
              "x": -12.494,
              "y": -6.268,
              "z": 1.318
            },
            "gtin": "7613039470275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fa2",
            "leftCorner": {
              "x": -12.494,
              "y": -6.269,
              "z": 1.318
            },
            "rightCorner": {
              "x": -12.667,
              "y": -6.271,
              "z": 1.318
            },
            "gtin": "7613039470404",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7ae",
    "rightNeighborShelfId": "7b0"
  },
  {
    "id": "7b0",
    "name": "7b0",
    "x": -12.629,
    "y": -6.288,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.0037699
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 56
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce54",
        "height": 0.16041,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5016",
            "leftCorner": {
              "x": -12.678,
              "y": -6.22,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.798,
              "y": -6.221,
              "z": 0.131
            },
            "gtin": "4005500316534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5017",
            "leftCorner": {
              "x": -12.798,
              "y": -6.221,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.926,
              "y": -6.222,
              "z": 0.131
            },
            "gtin": "7613035449893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5018",
            "leftCorner": {
              "x": -12.926,
              "y": -6.22,
              "z": 0.131
            },
            "rightCorner": {
              "x": -13.097,
              "y": -6.221,
              "z": 0.131
            },
            "gtin": "7613035458628",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d5019",
            "leftCorner": {
              "x": -13.096,
              "y": -6.218,
              "z": 0.131
            },
            "rightCorner": {
              "x": -13.203,
              "y": -6.219,
              "z": 0.131
            },
            "gtin": "7613035442108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d501a",
            "leftCorner": {
              "x": -13.204,
              "y": -6.221,
              "z": 0.131
            },
            "rightCorner": {
              "x": -13.333,
              "y": -6.222,
              "z": 0.131
            },
            "gtin": "4005500037675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d501b",
            "leftCorner": {
              "x": -13.333,
              "y": -6.221,
              "z": 0.131
            },
            "rightCorner": {
              "x": -13.468,
              "y": -6.222,
              "z": 0.131
            },
            "gtin": "4005500037927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d501c",
            "leftCorner": {
              "x": -13.468,
              "y": -6.224,
              "z": 0.131
            },
            "rightCorner": {
              "x": -13.646,
              "y": -6.225,
              "z": 0.131
            },
            "gtin": "40387994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d501d",
            "leftCorner": {
              "x": -13.646,
              "y": -6.223,
              "z": 0.131
            },
            "rightCorner": {
              "x": -13.793,
              "y": -6.224,
              "z": 0.131
            },
            "gtin": "8711200414352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d501e",
            "leftCorner": {
              "x": -13.793,
              "y": -6.224,
              "z": 0.131
            },
            "rightCorner": {
              "x": -13.954,
              "y": -6.225,
              "z": 0.131
            },
            "gtin": "4000400117151",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce4f",
        "height": 0.48764,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f5e",
            "leftCorner": {
              "x": -12.676,
              "y": -6.279,
              "z": 0.399
            },
            "rightCorner": {
              "x": -12.763,
              "y": -6.28,
              "z": 0.399
            },
            "gtin": "4005500316336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f5f",
            "leftCorner": {
              "x": -12.763,
              "y": -6.273,
              "z": 0.399
            },
            "rightCorner": {
              "x": -12.856,
              "y": -6.273,
              "z": 0.399
            },
            "gtin": "7613035442122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f60",
            "leftCorner": {
              "x": -12.856,
              "y": -6.271,
              "z": 0.399
            },
            "rightCorner": {
              "x": -13.05,
              "y": -6.272,
              "z": 0.399
            },
            "gtin": "7613035442344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f61",
            "leftCorner": {
              "x": -13.05,
              "y": -6.267,
              "z": 0.399
            },
            "rightCorner": {
              "x": -13.172,
              "y": -6.268,
              "z": 0.399
            },
            "gtin": "4005500319207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f62",
            "leftCorner": {
              "x": -13.172,
              "y": -6.265,
              "z": 0.399
            },
            "rightCorner": {
              "x": -13.325,
              "y": -6.266,
              "z": 0.399
            },
            "gtin": "4005500335450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f63",
            "leftCorner": {
              "x": -13.325,
              "y": -6.267,
              "z": 0.399
            },
            "rightCorner": {
              "x": -13.473,
              "y": -6.268,
              "z": 0.399
            },
            "gtin": "8718114824703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f64",
            "leftCorner": {
              "x": -13.473,
              "y": -6.268,
              "z": 0.399
            },
            "rightCorner": {
              "x": -13.632,
              "y": -6.269,
              "z": 0.399
            },
            "gtin": "8718114823515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f4a",
            "leftCorner": {
              "x": -13.632,
              "y": -6.27,
              "z": 0.399
            },
            "rightCorner": {
              "x": -13.88,
              "y": -6.271,
              "z": 0.399
            },
            "gtin": "8717163861806",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce50",
        "height": 0.70798,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f3b",
            "leftCorner": {
              "x": -12.666,
              "y": -6.284,
              "z": 0.579
            },
            "rightCorner": {
              "x": -12.778,
              "y": -6.285,
              "z": 0.579
            },
            "gtin": "7613036072526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f3c",
            "leftCorner": {
              "x": -12.778,
              "y": -6.283,
              "z": 0.579
            },
            "rightCorner": {
              "x": -12.982,
              "y": -6.284,
              "z": 0.579
            },
            "gtin": "7613036072465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f3d",
            "leftCorner": {
              "x": -12.982,
              "y": -6.279,
              "z": 0.579
            },
            "rightCorner": {
              "x": -13.072,
              "y": -6.28,
              "z": 0.579
            },
            "gtin": "7613036072878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f3e",
            "leftCorner": {
              "x": -13.072,
              "y": -6.276,
              "z": 0.579
            },
            "rightCorner": {
              "x": -13.22,
              "y": -6.277,
              "z": 0.579
            },
            "gtin": "7613036072502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f3f",
            "leftCorner": {
              "x": -13.22,
              "y": -6.276,
              "z": 0.579
            },
            "rightCorner": {
              "x": -13.332,
              "y": -6.277,
              "z": 0.579
            },
            "gtin": "7613036072403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f40",
            "leftCorner": {
              "x": -13.332,
              "y": -6.275,
              "z": 0.579
            },
            "rightCorner": {
              "x": -13.58,
              "y": -6.277,
              "z": 0.579
            },
            "gtin": "8717163861790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f41",
            "leftCorner": {
              "x": -13.58,
              "y": -6.272,
              "z": 0.579
            },
            "rightCorner": {
              "x": -13.924,
              "y": -6.275,
              "z": 0.579
            },
            "gtin": "8718114823621",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce55",
        "height": 0.93116,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4ff2",
            "leftCorner": {
              "x": -12.67,
              "y": -6.286,
              "z": 0.762
            },
            "rightCorner": {
              "x": -12.928,
              "y": -6.288,
              "z": 0.762
            },
            "gtin": "7613036041966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4ff3",
            "leftCorner": {
              "x": -12.928,
              "y": -6.287,
              "z": 0.762
            },
            "rightCorner": {
              "x": -13.072,
              "y": -6.288,
              "z": 0.762
            },
            "gtin": "7613035157958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4ff4",
            "leftCorner": {
              "x": -13.072,
              "y": -6.283,
              "z": 0.762
            },
            "rightCorner": {
              "x": -13.204,
              "y": -6.284,
              "z": 0.762
            },
            "gtin": "7613035151383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4ff5",
            "leftCorner": {
              "x": -13.204,
              "y": -6.285,
              "z": 0.762
            },
            "rightCorner": {
              "x": -13.403,
              "y": -6.287,
              "z": 0.762
            },
            "gtin": "7613036041942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4ff6",
            "leftCorner": {
              "x": -13.403,
              "y": -6.289,
              "z": 0.762
            },
            "rightCorner": {
              "x": -13.623,
              "y": -6.291,
              "z": 0.762
            },
            "gtin": "8718114824758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4ff7",
            "leftCorner": {
              "x": -13.623,
              "y": -6.29,
              "z": 0.762
            },
            "rightCorner": {
              "x": -13.913,
              "y": -6.292,
              "z": 0.762
            },
            "gtin": "8720182426826",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce53",
        "height": 1.1585,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f75",
            "leftCorner": {
              "x": -12.66,
              "y": -6.283,
              "z": 0.948
            },
            "rightCorner": {
              "x": -12.794,
              "y": -6.284,
              "z": 0.948
            },
            "gtin": "7613039537299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f76",
            "leftCorner": {
              "x": -12.794,
              "y": -6.283,
              "z": 0.948
            },
            "rightCorner": {
              "x": -12.933,
              "y": -6.284,
              "z": 0.948
            },
            "gtin": "7613035151697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f77",
            "leftCorner": {
              "x": -12.933,
              "y": -6.285,
              "z": 0.948
            },
            "rightCorner": {
              "x": -13.063,
              "y": -6.286,
              "z": 0.948
            },
            "gtin": "7613035151727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f78",
            "leftCorner": {
              "x": -13.063,
              "y": -6.282,
              "z": 0.948
            },
            "rightCorner": {
              "x": -13.201,
              "y": -6.283,
              "z": 0.948
            },
            "gtin": "7613036053532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f79",
            "leftCorner": {
              "x": -13.201,
              "y": -6.282,
              "z": 0.948
            },
            "rightCorner": {
              "x": -13.341,
              "y": -6.283,
              "z": 0.948
            },
            "gtin": "7613036042000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f7a",
            "leftCorner": {
              "x": -13.341,
              "y": -6.286,
              "z": 0.948
            },
            "rightCorner": {
              "x": -13.499,
              "y": -6.287,
              "z": 0.948
            },
            "gtin": "8710522970133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f7b",
            "leftCorner": {
              "x": -13.499,
              "y": -6.288,
              "z": 0.948
            },
            "rightCorner": {
              "x": -13.645,
              "y": -6.289,
              "z": 0.948
            },
            "gtin": "8720182876836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f7c",
            "leftCorner": {
              "x": -13.645,
              "y": -6.291,
              "z": 0.948
            },
            "rightCorner": {
              "x": -13.928,
              "y": -6.293,
              "z": 0.948
            },
            "gtin": "8717163935187",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce51",
        "height": 1.3836,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4fc8",
            "leftCorner": {
              "x": -12.63,
              "y": -6.276,
              "z": 1.132
            },
            "rightCorner": {
              "x": -12.792,
              "y": -6.276,
              "z": 1.132
            },
            "gtin": "7613032316815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fc9",
            "leftCorner": {
              "x": -12.792,
              "y": -6.282,
              "z": 1.132
            },
            "rightCorner": {
              "x": -12.881,
              "y": -6.283,
              "z": 1.132
            },
            "gtin": "7613032316815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fca",
            "leftCorner": {
              "x": -12.881,
              "y": -6.283,
              "z": 1.132
            },
            "rightCorner": {
              "x": -12.97,
              "y": -6.284,
              "z": 1.132
            },
            "gtin": "7613032316815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fcb",
            "leftCorner": {
              "x": -12.97,
              "y": -6.284,
              "z": 1.132
            },
            "rightCorner": {
              "x": -13.059,
              "y": -6.284,
              "z": 1.132
            },
            "gtin": "7613032316815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fcc",
            "leftCorner": {
              "x": -13.06,
              "y": -6.279,
              "z": 1.132
            },
            "rightCorner": {
              "x": -13.192,
              "y": -6.28,
              "z": 1.132
            },
            "gtin": "7613039471401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fcd",
            "leftCorner": {
              "x": -13.192,
              "y": -6.277,
              "z": 1.132
            },
            "rightCorner": {
              "x": -13.339,
              "y": -6.278,
              "z": 1.132
            },
            "gtin": "8445291202351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fce",
            "leftCorner": {
              "x": -13.339,
              "y": -6.282,
              "z": 1.132
            },
            "rightCorner": {
              "x": -13.467,
              "y": -6.283,
              "z": 1.132
            },
            "gtin": "7613039471142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fcf",
            "leftCorner": {
              "x": -13.467,
              "y": -6.283,
              "z": 1.132
            },
            "rightCorner": {
              "x": -13.591,
              "y": -6.284,
              "z": 1.132
            },
            "gtin": "8585002440617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fd0",
            "leftCorner": {
              "x": -13.591,
              "y": -6.283,
              "z": 1.132
            },
            "rightCorner": {
              "x": -13.755,
              "y": -6.285,
              "z": 1.132
            },
            "gtin": "8445291211124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fd1",
            "leftCorner": {
              "x": -13.755,
              "y": -6.277,
              "z": 1.132
            },
            "rightCorner": {
              "x": -13.919,
              "y": -6.278,
              "z": 1.132
            },
            "gtin": "8717163865620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fd2",
            "leftCorner": {
              "x": -13.919,
              "y": -6.278,
              "z": 1.132
            },
            "rightCorner": {
              "x": -14.083,
              "y": -6.28,
              "z": 1.132
            },
            "gtin": "8717163865620",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce52",
        "height": 1.6108,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4fa4",
            "leftCorner": {
              "x": -12.787,
              "y": -6.282,
              "z": 1.318
            },
            "rightCorner": {
              "x": -12.91,
              "y": -6.283,
              "z": 1.318
            },
            "gtin": "8445291336155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8520d617f70e0fa115515da6",
            "leftCorner": {
              "x": -12.63,
              "y": -6.235,
              "z": 1.318
            },
            "rightCorner": {
              "x": -12.779,
              "y": -6.236,
              "z": 1.318
            },
            "gtin": "8445291211100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fa5",
            "leftCorner": {
              "x": -12.91,
              "y": -6.28,
              "z": 1.318
            },
            "rightCorner": {
              "x": -13.058,
              "y": -6.281,
              "z": 1.318
            },
            "gtin": "7613036053624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fa6",
            "leftCorner": {
              "x": -13.058,
              "y": -6.278,
              "z": 1.318
            },
            "rightCorner": {
              "x": -13.197,
              "y": -6.279,
              "z": 1.318
            },
            "gtin": "7613039471791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fa7",
            "leftCorner": {
              "x": -13.197,
              "y": -6.278,
              "z": 1.318
            },
            "rightCorner": {
              "x": -13.337,
              "y": -6.279,
              "z": 1.318
            },
            "gtin": "7613035185210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fa8",
            "leftCorner": {
              "x": -13.337,
              "y": -6.28,
              "z": 1.318
            },
            "rightCorner": {
              "x": -13.488,
              "y": -6.281,
              "z": 1.318
            },
            "gtin": "8445291211100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fa9",
            "leftCorner": {
              "x": -13.488,
              "y": -6.282,
              "z": 1.318
            },
            "rightCorner": {
              "x": -13.779,
              "y": -6.284,
              "z": 1.318
            },
            "gtin": "8717163935163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4faa",
            "leftCorner": {
              "x": -13.78,
              "y": -6.283,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.062,
              "y": -6.285,
              "z": 1.318
            },
            "gtin": "8718114827773",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7af",
    "rightNeighborShelfId": "7b1"
  },
  {
    "id": "7b1",
    "name": "7b1",
    "x": -13.879,
    "y": -6.297,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.0037699
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 46
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce5c",
        "height": 0.15712,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5021",
            "leftCorner": {
              "x": -14.36,
              "y": -6.235,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.471,
              "y": -6.235,
              "z": 0.129
            },
            "gtin": "8720182055293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5022",
            "leftCorner": {
              "x": -14.471,
              "y": -6.238,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.572,
              "y": -6.239,
              "z": 0.129
            },
            "gtin": "8720182052070",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d5023",
            "leftCorner": {
              "x": -14.572,
              "y": -6.239,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.853,
              "y": -6.241,
              "z": 0.129
            },
            "gtin": "8720182052773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5024",
            "leftCorner": {
              "x": -14.853,
              "y": -6.237,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.938,
              "y": -6.238,
              "z": 0.129
            },
            "gtin": "8720182067319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5005",
            "leftCorner": {
              "x": -14.938,
              "y": -6.237,
              "z": 0.129
            },
            "rightCorner": {
              "x": -15.129,
              "y": -6.238,
              "z": 0.129
            },
            "gtin": "8714100790281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "22371fc9568054d88982388f",
            "leftCorner": {
              "x": -13.879,
              "y": -6.192,
              "z": 0.129
            },
            "rightCorner": {
              "x": -13.963,
              "y": -6.193,
              "z": 0.129
            },
            "gtin": "8720182067319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6fa69d82ddc364726a3ff48e",
            "leftCorner": {
              "x": -13.963,
              "y": -6.193,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.065,
              "y": -6.194,
              "z": 0.129
            },
            "gtin": "8720182052070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b8d407016bbfd3867f825d99",
            "leftCorner": {
              "x": -14.065,
              "y": -6.194,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.353,
              "y": -6.196,
              "z": 0.129
            },
            "gtin": "8720182052773",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce5b",
        "height": 0.4769,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5025",
            "leftCorner": {
              "x": -13.879,
              "y": -6.248,
              "z": 0.39
            },
            "rightCorner": {
              "x": -14.217,
              "y": -6.251,
              "z": 0.39
            },
            "gtin": "8720182483645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5027",
            "leftCorner": {
              "x": -14.217,
              "y": -6.288,
              "z": 0.39
            },
            "rightCorner": {
              "x": -14.46,
              "y": -6.29,
              "z": 0.39
            },
            "gtin": "8717163865613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5028",
            "leftCorner": {
              "x": -14.46,
              "y": -6.295,
              "z": 0.39
            },
            "rightCorner": {
              "x": -14.739,
              "y": -6.297,
              "z": 0.39
            },
            "gtin": "8720182427564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5029",
            "leftCorner": {
              "x": -14.739,
              "y": -6.296,
              "z": 0.39
            },
            "rightCorner": {
              "x": -14.859,
              "y": -6.296,
              "z": 0.39
            },
            "gtin": "8718114824222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5026",
            "leftCorner": {
              "x": -14.859,
              "y": -6.294,
              "z": 0.39
            },
            "rightCorner": {
              "x": -15.129,
              "y": -6.297,
              "z": 0.39
            },
            "gtin": "8717163861783",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce56",
        "height": 0.71318,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f42",
            "leftCorner": {
              "x": -13.924,
              "y": -6.273,
              "z": 0.584
            },
            "rightCorner": {
              "x": -14.033,
              "y": -6.274,
              "z": 0.584
            },
            "gtin": "8718114823485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f43",
            "leftCorner": {
              "x": -14.033,
              "y": -6.275,
              "z": 0.584
            },
            "rightCorner": {
              "x": -14.314,
              "y": -6.277,
              "z": 0.584
            },
            "gtin": "8718114823416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f44",
            "leftCorner": {
              "x": -14.314,
              "y": -6.282,
              "z": 0.584
            },
            "rightCorner": {
              "x": -14.473,
              "y": -6.283,
              "z": 0.584
            },
            "gtin": "8720182328502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f45",
            "leftCorner": {
              "x": -14.473,
              "y": -6.285,
              "z": 0.584
            },
            "rightCorner": {
              "x": -14.603,
              "y": -6.286,
              "z": 0.584
            },
            "gtin": "8721201921216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f46",
            "leftCorner": {
              "x": -14.603,
              "y": -6.285,
              "z": 0.584
            },
            "rightCorner": {
              "x": -14.737,
              "y": -6.286,
              "z": 0.584
            },
            "gtin": "8718114824185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f47",
            "leftCorner": {
              "x": -14.737,
              "y": -6.286,
              "z": 0.584
            },
            "rightCorner": {
              "x": -14.87,
              "y": -6.288,
              "z": 0.584
            },
            "gtin": "8718114824185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f48",
            "leftCorner": {
              "x": -14.87,
              "y": -6.284,
              "z": 0.584
            },
            "rightCorner": {
              "x": -15.015,
              "y": -6.285,
              "z": 0.584
            },
            "gtin": "8717163861769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f2b",
            "leftCorner": {
              "x": -15.015,
              "y": -6.277,
              "z": 0.584
            },
            "rightCorner": {
              "x": -15.129,
              "y": -6.278,
              "z": 0.584
            },
            "gtin": "8712100671135",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce5a",
        "height": 0.92941,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4ff8",
            "leftCorner": {
              "x": -13.913,
              "y": -6.289,
              "z": 0.76
            },
            "rightCorner": {
              "x": -14.057,
              "y": -6.29,
              "z": 0.76
            },
            "gtin": "8720182876829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4ff9",
            "leftCorner": {
              "x": -14.057,
              "y": -6.288,
              "z": 0.76
            },
            "rightCorner": {
              "x": -14.334,
              "y": -6.29,
              "z": 0.76
            },
            "gtin": "8718114824307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4ffa",
            "leftCorner": {
              "x": -14.334,
              "y": -6.293,
              "z": 0.76
            },
            "rightCorner": {
              "x": -14.606,
              "y": -6.295,
              "z": 0.76
            },
            "gtin": "8717163865606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4ffb",
            "leftCorner": {
              "x": -14.606,
              "y": -6.298,
              "z": 0.76
            },
            "rightCorner": {
              "x": -14.866,
              "y": -6.3,
              "z": 0.76
            },
            "gtin": "8718114825069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4ffc",
            "leftCorner": {
              "x": -14.866,
              "y": -6.298,
              "z": 0.76
            },
            "rightCorner": {
              "x": -15.011,
              "y": -6.299,
              "z": 0.76
            },
            "gtin": "8718114837208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4ffd",
            "leftCorner": {
              "x": -15.011,
              "y": -6.3,
              "z": 0.76
            },
            "rightCorner": {
              "x": -15.159,
              "y": -6.301,
              "z": 0.76
            },
            "gtin": "8717163861837",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce58",
        "height": 1.1571,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f7d",
            "leftCorner": {
              "x": -13.928,
              "y": -6.288,
              "z": 0.947
            },
            "rightCorner": {
              "x": -14.055,
              "y": -6.289,
              "z": 0.947
            },
            "gtin": "8718114824468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f7e",
            "leftCorner": {
              "x": -14.055,
              "y": -6.288,
              "z": 0.947
            },
            "rightCorner": {
              "x": -14.192,
              "y": -6.289,
              "z": 0.947
            },
            "gtin": "8720182654564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f7f",
            "leftCorner": {
              "x": -14.192,
              "y": -6.29,
              "z": 0.947
            },
            "rightCorner": {
              "x": -14.341,
              "y": -6.291,
              "z": 0.947
            },
            "gtin": "8718114827827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f80",
            "leftCorner": {
              "x": -14.341,
              "y": -6.295,
              "z": 0.947
            },
            "rightCorner": {
              "x": -14.475,
              "y": -6.296,
              "z": 0.947
            },
            "gtin": "8720182654878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f81",
            "leftCorner": {
              "x": -14.475,
              "y": -6.299,
              "z": 0.947
            },
            "rightCorner": {
              "x": -14.753,
              "y": -6.301,
              "z": 0.947
            },
            "gtin": "8720182653468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f82",
            "leftCorner": {
              "x": -14.754,
              "y": -6.299,
              "z": 0.947
            },
            "rightCorner": {
              "x": -14.876,
              "y": -6.3,
              "z": 0.947
            },
            "gtin": "8720182494450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f83",
            "leftCorner": {
              "x": -14.876,
              "y": -6.298,
              "z": 0.947
            },
            "rightCorner": {
              "x": -15.01,
              "y": -6.299,
              "z": 0.947
            },
            "gtin": "8721201921063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f84",
            "leftCorner": {
              "x": -15.01,
              "y": -6.304,
              "z": 0.947
            },
            "rightCorner": {
              "x": -15.129,
              "y": -6.305,
              "z": 0.947
            },
            "gtin": "8718114841175",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce59",
        "height": 1.3856,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4fd3",
            "leftCorner": {
              "x": -14.083,
              "y": -6.285,
              "z": 1.134
            },
            "rightCorner": {
              "x": -14.339,
              "y": -6.287,
              "z": 1.134
            },
            "gtin": "8720182480866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7019bdeabe0eb8efef936c52",
            "leftCorner": {
              "x": -13.879,
              "y": -6.248,
              "z": 1.134
            },
            "rightCorner": {
              "x": -14.028,
              "y": -6.249,
              "z": 1.134
            },
            "gtin": "8717163861820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fd4",
            "leftCorner": {
              "x": -14.339,
              "y": -6.291,
              "z": 1.134
            },
            "rightCorner": {
              "x": -14.491,
              "y": -6.292,
              "z": 1.134
            },
            "gtin": "8717163861820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fd5",
            "leftCorner": {
              "x": -14.491,
              "y": -6.293,
              "z": 1.134
            },
            "rightCorner": {
              "x": -14.763,
              "y": -6.295,
              "z": 1.134
            },
            "gtin": "8717163865590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fd6",
            "leftCorner": {
              "x": -14.763,
              "y": -6.295,
              "z": 1.134
            },
            "rightCorner": {
              "x": -15.023,
              "y": -6.296,
              "z": 1.134
            },
            "gtin": "8717163861776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fd7",
            "leftCorner": {
              "x": -15.023,
              "y": -6.296,
              "z": 1.134
            },
            "rightCorner": {
              "x": -15.129,
              "y": -6.297,
              "z": 1.134
            },
            "gtin": "8710604724739",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce57",
        "height": 1.6111,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4fab",
            "leftCorner": {
              "x": -14.062,
              "y": -6.288,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.302,
              "y": -6.289,
              "z": 1.318
            },
            "gtin": "8720182481740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2b647c38975549db53bfadec",
            "leftCorner": {
              "x": -13.879,
              "y": -6.248,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.028,
              "y": -6.249,
              "z": 1.318
            },
            "gtin": "8718114824970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fac",
            "leftCorner": {
              "x": -14.302,
              "y": -6.29,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.451,
              "y": -6.292,
              "z": 1.318
            },
            "gtin": "8718114824932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fad",
            "leftCorner": {
              "x": -14.451,
              "y": -6.295,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.598,
              "y": -6.296,
              "z": 1.318
            },
            "gtin": "8718114824970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fae",
            "leftCorner": {
              "x": -14.598,
              "y": -6.298,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.878,
              "y": -6.3,
              "z": 1.318
            },
            "gtin": "8717163861844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4faf",
            "leftCorner": {
              "x": -14.878,
              "y": -6.295,
              "z": 1.318
            },
            "rightCorner": {
              "x": -15.129,
              "y": -6.297,
              "z": 1.318
            },
            "gtin": "8712423037632",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7b0",
    "rightNeighborShelfId": "7b2"
  },
  {
    "id": "7b2",
    "name": "7b2",
    "x": -15.129,
    "y": -6.306,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.0037699
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 64
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce62",
        "height": 0.1682,
        "facings": [
          {
            "id": "68d8e508e1820c81800d503d",
            "leftCorner": {
              "x": -15.415,
              "y": -6.236,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.52,
              "y": -6.236,
              "z": 0.138
            },
            "gtin": "4038700101105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d503e",
            "leftCorner": {
              "x": -15.52,
              "y": -6.237,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.641,
              "y": -6.238,
              "z": 0.138
            },
            "gtin": "4000400118035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d503f",
            "leftCorner": {
              "x": -15.641,
              "y": -6.235,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.755,
              "y": -6.236,
              "z": 0.138
            },
            "gtin": "8711200414369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5040",
            "leftCorner": {
              "x": -15.755,
              "y": -6.238,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.87,
              "y": -6.239,
              "z": 0.138
            },
            "gtin": "8720182922700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5041",
            "leftCorner": {
              "x": -15.87,
              "y": -6.244,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.98,
              "y": -6.245,
              "z": 0.138
            },
            "gtin": "8720182921222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5042",
            "leftCorner": {
              "x": -15.98,
              "y": -6.25,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.065,
              "y": -6.25,
              "z": 0.138
            },
            "gtin": "4104420137264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5043",
            "leftCorner": {
              "x": -16.065,
              "y": -6.251,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.182,
              "y": -6.252,
              "z": 0.138
            },
            "gtin": "4104420031746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5044",
            "leftCorner": {
              "x": -16.182,
              "y": -6.267,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.253,
              "y": -6.267,
              "z": 0.138
            },
            "gtin": "4104420028586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5045",
            "leftCorner": {
              "x": -16.253,
              "y": -6.262,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.299,
              "y": -6.263,
              "z": 0.138
            },
            "gtin": "4104420032927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5046",
            "leftCorner": {
              "x": -16.299,
              "y": -6.259,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.34,
              "y": -6.259,
              "z": 0.138
            },
            "gtin": "2000439121572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d503b",
            "leftCorner": {
              "x": -16.34,
              "y": -6.277,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.379,
              "y": -6.277,
              "z": 0.138
            },
            "gtin": "4104420032927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "992232c457e1557eb75c4bea",
            "leftCorner": {
              "x": -15.13,
              "y": -6.2,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.254,
              "y": -6.2,
              "z": 0.138
            },
            "gtin": "8720182921222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "92c738cb3adce855f07d9cea",
            "leftCorner": {
              "x": -15.254,
              "y": -6.2,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.372,
              "y": -6.201,
              "z": 0.138
            },
            "gtin": "4000400118035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7089188cd718c9b079a3623a",
            "leftCorner": {
              "x": -15.372,
              "y": -6.201,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.406,
              "y": -6.202,
              "z": 0.138
            },
            "gtin": "2000439121572",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce60",
        "height": 0.4902,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5032",
            "leftCorner": {
              "x": -15.129,
              "y": -6.244,
              "z": 0.401
            },
            "rightCorner": {
              "x": -15.445,
              "y": -6.246,
              "z": 0.401
            },
            "gtin": "8712566332090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5034",
            "leftCorner": {
              "x": -15.445,
              "y": -6.282,
              "z": 0.401
            },
            "rightCorner": {
              "x": -15.566,
              "y": -6.283,
              "z": 0.401
            },
            "gtin": "8720182229243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5035",
            "leftCorner": {
              "x": -15.566,
              "y": -6.284,
              "z": 0.401
            },
            "rightCorner": {
              "x": -15.695,
              "y": -6.285,
              "z": 0.401
            },
            "gtin": "8720182705815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5036",
            "leftCorner": {
              "x": -15.695,
              "y": -6.288,
              "z": 0.401
            },
            "rightCorner": {
              "x": -15.822,
              "y": -6.289,
              "z": 0.401
            },
            "gtin": "8720182422392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5037",
            "leftCorner": {
              "x": -15.822,
              "y": -6.287,
              "z": 0.401
            },
            "rightCorner": {
              "x": -15.964,
              "y": -6.288,
              "z": 0.401
            },
            "gtin": "40387444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5038",
            "leftCorner": {
              "x": -15.964,
              "y": -6.301,
              "z": 0.401
            },
            "rightCorner": {
              "x": -16.097,
              "y": -6.302,
              "z": 0.401
            },
            "gtin": "8720182744661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5039",
            "leftCorner": {
              "x": -16.097,
              "y": -6.332,
              "z": 0.401
            },
            "rightCorner": {
              "x": -16.248,
              "y": -6.333,
              "z": 0.401
            },
            "gtin": "8720182744043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5033",
            "leftCorner": {
              "x": -16.248,
              "y": -6.305,
              "z": 0.401
            },
            "rightCorner": {
              "x": -16.379,
              "y": -6.306,
              "z": 0.401
            },
            "gtin": "4104420025905",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce5f",
        "height": 0.70036,
        "facings": [
          {
            "id": "68d8e508e1820c81800d502a",
            "leftCorner": {
              "x": -15.129,
              "y": -6.257,
              "z": 0.573
            },
            "rightCorner": {
              "x": -15.409,
              "y": -6.259,
              "z": 0.573
            },
            "gtin": "8712566332137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d502c",
            "leftCorner": {
              "x": -15.409,
              "y": -6.299,
              "z": 0.573
            },
            "rightCorner": {
              "x": -15.549,
              "y": -6.3,
              "z": 0.573
            },
            "gtin": "8711327406391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d502d",
            "leftCorner": {
              "x": -15.549,
              "y": -6.3,
              "z": 0.573
            },
            "rightCorner": {
              "x": -15.674,
              "y": -6.301,
              "z": 0.573
            },
            "gtin": "8720182909763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d502e",
            "leftCorner": {
              "x": -15.674,
              "y": -6.3,
              "z": 0.573
            },
            "rightCorner": {
              "x": -15.81,
              "y": -6.301,
              "z": 0.573
            },
            "gtin": "8720182867421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d502f",
            "leftCorner": {
              "x": -15.81,
              "y": -6.302,
              "z": 0.573
            },
            "rightCorner": {
              "x": -15.963,
              "y": -6.303,
              "z": 0.573
            },
            "gtin": "8712566361564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5030",
            "leftCorner": {
              "x": -15.963,
              "y": -6.312,
              "z": 0.573
            },
            "rightCorner": {
              "x": -16.113,
              "y": -6.313,
              "z": 0.573
            },
            "gtin": "8712566361472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5031",
            "leftCorner": {
              "x": -16.113,
              "y": -6.315,
              "z": 0.573
            },
            "rightCorner": {
              "x": -16.275,
              "y": -6.316,
              "z": 0.573
            },
            "gtin": "8712566361496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d502b",
            "leftCorner": {
              "x": -16.275,
              "y": -6.318,
              "z": 0.573
            },
            "rightCorner": {
              "x": -16.379,
              "y": -6.319,
              "z": 0.573
            },
            "gtin": "8712566361458",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce63",
        "height": 0.92784,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4ffe",
            "leftCorner": {
              "x": -15.159,
              "y": -6.287,
              "z": 0.759
            },
            "rightCorner": {
              "x": -15.414,
              "y": -6.289,
              "z": 0.759
            },
            "gtin": "8712566410330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fff",
            "leftCorner": {
              "x": -15.414,
              "y": -6.299,
              "z": 0.759
            },
            "rightCorner": {
              "x": -15.699,
              "y": -6.301,
              "z": 0.759
            },
            "gtin": "8712566332175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5000",
            "leftCorner": {
              "x": -15.699,
              "y": -6.301,
              "z": 0.759
            },
            "rightCorner": {
              "x": -15.849,
              "y": -6.302,
              "z": 0.759
            },
            "gtin": "8712566410231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5001",
            "leftCorner": {
              "x": -15.849,
              "y": -6.306,
              "z": 0.759
            },
            "rightCorner": {
              "x": -15.995,
              "y": -6.307,
              "z": 0.759
            },
            "gtin": "4038700114075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5002",
            "leftCorner": {
              "x": -15.995,
              "y": -6.313,
              "z": 0.759
            },
            "rightCorner": {
              "x": -16.143,
              "y": -6.314,
              "z": 0.759
            },
            "gtin": "8720182932044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5003",
            "leftCorner": {
              "x": -16.143,
              "y": -6.319,
              "z": 0.759
            },
            "rightCorner": {
              "x": -16.273,
              "y": -6.32,
              "z": 0.759
            },
            "gtin": "8720182932075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fe2",
            "leftCorner": {
              "x": -16.273,
              "y": -6.32,
              "z": 0.759
            },
            "rightCorner": {
              "x": -16.379,
              "y": -6.321,
              "z": 0.759
            },
            "gtin": "8720182932051",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce5e",
        "height": 1.157,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4f85",
            "leftCorner": {
              "x": -15.129,
              "y": -6.302,
              "z": 0.947
            },
            "rightCorner": {
              "x": -15.166,
              "y": -6.302,
              "z": 0.947
            },
            "gtin": "8711200339938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f86",
            "leftCorner": {
              "x": -15.166,
              "y": -6.291,
              "z": 0.947
            },
            "rightCorner": {
              "x": -15.301,
              "y": -6.292,
              "z": 0.947
            },
            "gtin": "8711200339938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f87",
            "leftCorner": {
              "x": -15.301,
              "y": -6.295,
              "z": 0.947
            },
            "rightCorner": {
              "x": -15.441,
              "y": -6.296,
              "z": 0.947
            },
            "gtin": "8711200339907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f88",
            "leftCorner": {
              "x": -15.441,
              "y": -6.298,
              "z": 0.947
            },
            "rightCorner": {
              "x": -15.58,
              "y": -6.299,
              "z": 0.947
            },
            "gtin": "8711200339853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f89",
            "leftCorner": {
              "x": -15.58,
              "y": -6.303,
              "z": 0.947
            },
            "rightCorner": {
              "x": -15.714,
              "y": -6.304,
              "z": 0.947
            },
            "gtin": "8711200339921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f8a",
            "leftCorner": {
              "x": -15.714,
              "y": -6.301,
              "z": 0.947
            },
            "rightCorner": {
              "x": -15.85,
              "y": -6.302,
              "z": 0.947
            },
            "gtin": "8720182909886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f8b",
            "leftCorner": {
              "x": -15.851,
              "y": -6.292,
              "z": 0.947
            },
            "rightCorner": {
              "x": -15.996,
              "y": -6.294,
              "z": 0.947
            },
            "gtin": "8721201900150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f8c",
            "leftCorner": {
              "x": -15.996,
              "y": -6.318,
              "z": 0.947
            },
            "rightCorner": {
              "x": -16.133,
              "y": -6.319,
              "z": 0.947
            },
            "gtin": "8720182139559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f8d",
            "leftCorner": {
              "x": -16.133,
              "y": -6.325,
              "z": 0.947
            },
            "rightCorner": {
              "x": -16.274,
              "y": -6.326,
              "z": 0.947
            },
            "gtin": "8720182444905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f66",
            "leftCorner": {
              "x": -16.274,
              "y": -6.323,
              "z": 0.947
            },
            "rightCorner": {
              "x": -16.379,
              "y": -6.323,
              "z": 0.947
            },
            "gtin": "8720182932068",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce5d",
        "height": 1.3842,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4fd8",
            "leftCorner": {
              "x": -15.129,
              "y": -6.294,
              "z": 1.133
            },
            "rightCorner": {
              "x": -15.169,
              "y": -6.294,
              "z": 1.133
            },
            "gtin": "8720182911391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fd9",
            "leftCorner": {
              "x": -15.169,
              "y": -6.291,
              "z": 1.133
            },
            "rightCorner": {
              "x": -15.307,
              "y": -6.292,
              "z": 1.133
            },
            "gtin": "8720182911391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fda",
            "leftCorner": {
              "x": -15.307,
              "y": -6.292,
              "z": 1.133
            },
            "rightCorner": {
              "x": -15.444,
              "y": -6.293,
              "z": 1.133
            },
            "gtin": "8720182860798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fdb",
            "leftCorner": {
              "x": -15.444,
              "y": -6.296,
              "z": 1.133
            },
            "rightCorner": {
              "x": -15.576,
              "y": -6.297,
              "z": 1.133
            },
            "gtin": "8711200339860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fdc",
            "leftCorner": {
              "x": -15.576,
              "y": -6.297,
              "z": 1.133
            },
            "rightCorner": {
              "x": -15.708,
              "y": -6.298,
              "z": 1.133
            },
            "gtin": "8712423045163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fdd",
            "leftCorner": {
              "x": -15.708,
              "y": -6.298,
              "z": 1.133
            },
            "rightCorner": {
              "x": -15.844,
              "y": -6.299,
              "z": 1.133
            },
            "gtin": "8712423044821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fde",
            "leftCorner": {
              "x": -15.844,
              "y": -6.297,
              "z": 1.133
            },
            "rightCorner": {
              "x": -15.98,
              "y": -6.298,
              "z": 1.133
            },
            "gtin": "8711200384150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fdf",
            "leftCorner": {
              "x": -15.98,
              "y": -6.312,
              "z": 1.133
            },
            "rightCorner": {
              "x": -16.109,
              "y": -6.313,
              "z": 1.133
            },
            "gtin": "4038700114044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fe0",
            "leftCorner": {
              "x": -16.109,
              "y": -6.31,
              "z": 1.133
            },
            "rightCorner": {
              "x": -16.263,
              "y": -6.311,
              "z": 1.133
            },
            "gtin": "8720182964557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fb7",
            "leftCorner": {
              "x": -16.263,
              "y": -6.32,
              "z": 1.133
            },
            "rightCorner": {
              "x": -16.379,
              "y": -6.32,
              "z": 1.133
            },
            "gtin": "4038700114136",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce61",
        "height": 1.61,
        "facings": [
          {
            "id": "68d8e508e1820c81800d4fb0",
            "leftCorner": {
              "x": -15.129,
              "y": -6.3,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.176,
              "y": -6.3,
              "z": 1.317
            },
            "gtin": "8711200339891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fb1",
            "leftCorner": {
              "x": -15.176,
              "y": -6.288,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.447,
              "y": -6.29,
              "z": 1.317
            },
            "gtin": "8711200339891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fb2",
            "leftCorner": {
              "x": -15.447,
              "y": -6.296,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.566,
              "y": -6.296,
              "z": 1.317
            },
            "gtin": "8720182863560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fb3",
            "leftCorner": {
              "x": -15.566,
              "y": -6.298,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.708,
              "y": -6.299,
              "z": 1.317
            },
            "gtin": "4000400149329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fb4",
            "leftCorner": {
              "x": -15.708,
              "y": -6.304,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.976,
              "y": -6.306,
              "z": 1.317
            },
            "gtin": "4038700128188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4fb5",
            "leftCorner": {
              "x": -15.976,
              "y": -6.314,
              "z": 1.317
            },
            "rightCorner": {
              "x": -16.274,
              "y": -6.316,
              "z": 1.317
            },
            "gtin": "4038700114082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d4f8f",
            "leftCorner": {
              "x": -16.274,
              "y": -6.32,
              "z": 1.317
            },
            "rightCorner": {
              "x": -16.379,
              "y": -6.321,
              "z": 1.317
            },
            "gtin": "4000400123282",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7b1"
  },
  {
    "id": "7b4",
    "name": "7b4",
    "x": -16.301,
    "y": -7.559,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -8.6394E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 25,
      "shelfCategory": "PASTA"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d601",
        "height": 0.16962,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d851f",
            "leftCorner": {
              "x": -16.302,
              "y": -7.493,
              "z": 0.139
            },
            "rightCorner": {
              "x": -15.216,
              "y": -7.495,
              "z": 0.139
            },
            "gtin": "4306188007531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c6a0fbdba0ad1ef901536f42",
            "leftCorner": {
              "x": -15.216,
              "y": -7.495,
              "z": 0.139
            },
            "rightCorner": {
              "x": -15.063,
              "y": -7.495,
              "z": 0.139
            },
            "gtin": "4000398254005",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5fc",
        "height": 0.42677,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50bd",
            "leftCorner": {
              "x": -16.301,
              "y": -7.436,
              "z": 0.349
            },
            "rightCorner": {
              "x": -16.083,
              "y": -7.436,
              "z": 0.349
            },
            "gtin": "4000398255040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50bf",
            "leftCorner": {
              "x": -16.083,
              "y": -7.403,
              "z": 0.349
            },
            "rightCorner": {
              "x": -15.723,
              "y": -7.403,
              "z": 0.349
            },
            "gtin": "4000398255132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50c0",
            "leftCorner": {
              "x": -15.723,
              "y": -7.399,
              "z": 0.349
            },
            "rightCorner": {
              "x": -15.357,
              "y": -7.399,
              "z": 0.349
            },
            "gtin": "4000398255101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50c1",
            "leftCorner": {
              "x": -15.357,
              "y": -7.382,
              "z": 0.349
            },
            "rightCorner": {
              "x": -15.051,
              "y": -7.383,
              "z": 0.349
            },
            "gtin": "4000398255071",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d600",
        "height": 0.74814,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5064",
            "leftCorner": {
              "x": -16.301,
              "y": -7.438,
              "z": 0.612
            },
            "rightCorner": {
              "x": -16.08,
              "y": -7.439,
              "z": 0.612
            },
            "gtin": "4000398254043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5066",
            "leftCorner": {
              "x": -16.08,
              "y": -7.41,
              "z": 0.612
            },
            "rightCorner": {
              "x": -15.902,
              "y": -7.41,
              "z": 0.612
            },
            "gtin": "4000398254258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5067",
            "leftCorner": {
              "x": -15.902,
              "y": -7.41,
              "z": 0.612
            },
            "rightCorner": {
              "x": -15.723,
              "y": -7.411,
              "z": 0.612
            },
            "gtin": "4000398254258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5068",
            "leftCorner": {
              "x": -15.723,
              "y": -7.401,
              "z": 0.612
            },
            "rightCorner": {
              "x": -15.545,
              "y": -7.401,
              "z": 0.612
            },
            "gtin": "4000398254111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5069",
            "leftCorner": {
              "x": -15.545,
              "y": -7.401,
              "z": 0.612
            },
            "rightCorner": {
              "x": -15.368,
              "y": -7.401,
              "z": 0.612
            },
            "gtin": "4000398254111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d506a",
            "leftCorner": {
              "x": -15.368,
              "y": -7.383,
              "z": 0.612
            },
            "rightCorner": {
              "x": -15.051,
              "y": -7.384,
              "z": 0.612
            },
            "gtin": "4000398254128",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5fe",
        "height": 1.0524,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50a9",
            "leftCorner": {
              "x": -16.301,
              "y": -7.433,
              "z": 0.861
            },
            "rightCorner": {
              "x": -15.624,
              "y": -7.434,
              "z": 0.861
            },
            "gtin": "4000398254142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50ab",
            "leftCorner": {
              "x": -15.624,
              "y": -7.396,
              "z": 0.861
            },
            "rightCorner": {
              "x": -15.29,
              "y": -7.396,
              "z": 0.861
            },
            "gtin": "4000398254104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50ac",
            "leftCorner": {
              "x": -15.29,
              "y": -7.382,
              "z": 0.861
            },
            "rightCorner": {
              "x": -15.051,
              "y": -7.383,
              "z": 0.861
            },
            "gtin": "4000398254005",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5fd",
        "height": 1.3555,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5095",
            "leftCorner": {
              "x": -16.073,
              "y": -7.41,
              "z": 1.109
            },
            "rightCorner": {
              "x": -15.797,
              "y": -7.411,
              "z": 1.109
            },
            "gtin": "4002861654176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "620aa6588060ed9ed3c130da",
            "leftCorner": {
              "x": -16.301,
              "y": -7.435,
              "z": 1.109
            },
            "rightCorner": {
              "x": -16.078,
              "y": -7.436,
              "z": 1.109
            },
            "gtin": "4002676212004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5096",
            "leftCorner": {
              "x": -15.797,
              "y": -7.409,
              "z": 1.109
            },
            "rightCorner": {
              "x": -15.385,
              "y": -7.41,
              "z": 1.109
            },
            "gtin": "4002861654169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5097",
            "leftCorner": {
              "x": -15.385,
              "y": -7.387,
              "z": 1.109
            },
            "rightCorner": {
              "x": -15.292,
              "y": -7.387,
              "z": 1.109
            },
            "gtin": "4002861654121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5098",
            "leftCorner": {
              "x": -15.292,
              "y": -7.387,
              "z": 1.109
            },
            "rightCorner": {
              "x": -15.051,
              "y": -7.388,
              "z": 1.109
            },
            "gtin": "4002676212004",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d5ff",
        "height": 1.6564,
        "facings": [
          {
            "id": "68d8e508e1820c81800d507c",
            "leftCorner": {
              "x": -16.301,
              "y": -7.436,
              "z": 1.355
            },
            "rightCorner": {
              "x": -16.015,
              "y": -7.437,
              "z": 1.355
            },
            "gtin": "4001762030454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d507e",
            "leftCorner": {
              "x": -16.015,
              "y": -7.406,
              "z": 1.355
            },
            "rightCorner": {
              "x": -15.717,
              "y": -7.407,
              "z": 1.355
            },
            "gtin": "4001762030577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d507f",
            "leftCorner": {
              "x": -15.717,
              "y": -7.404,
              "z": 1.355
            },
            "rightCorner": {
              "x": -15.558,
              "y": -7.405,
              "z": 1.355
            },
            "gtin": "4001762060215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5080",
            "leftCorner": {
              "x": -15.558,
              "y": -7.394,
              "z": 1.355
            },
            "rightCorner": {
              "x": -15.275,
              "y": -7.395,
              "z": 1.355
            },
            "gtin": "4001762060222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5081",
            "leftCorner": {
              "x": -15.276,
              "y": -7.382,
              "z": 1.355
            },
            "rightCorner": {
              "x": -15.051,
              "y": -7.382,
              "z": 1.355
            },
            "gtin": "4001762060277",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "7b5"
  },
  {
    "id": "7b5",
    "name": "7b5",
    "x": -15.051,
    "y": -7.561,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -8.6394E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 31,
      "shelfCategory": "PASTA"
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce70",
        "height": 0.15872,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50c8",
            "leftCorner": {
              "x": -15.052,
              "y": -7.671,
              "z": 0.13
            },
            "rightCorner": {
              "x": -14.371,
              "y": -7.672,
              "z": 0.13
            },
            "gtin": "4002676332115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50ca",
            "leftCorner": {
              "x": -14.371,
              "y": -7.63,
              "z": 0.13
            },
            "rightCorner": {
              "x": -14.091,
              "y": -7.63,
              "z": 0.13
            },
            "gtin": "4002676332160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50cb",
            "leftCorner": {
              "x": -14.091,
              "y": -7.557,
              "z": 0.13
            },
            "rightCorner": {
              "x": -13.463,
              "y": -7.558,
              "z": 0.13
            },
            "gtin": "4306188421719",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce6f",
        "height": 0.42566,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50c2",
            "leftCorner": {
              "x": -15.051,
              "y": -7.552,
              "z": 0.348
            },
            "rightCorner": {
              "x": -14.972,
              "y": -7.555,
              "z": 0.348
            },
            "gtin": "4000398254395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50c3",
            "leftCorner": {
              "x": -14.972,
              "y": -7.567,
              "z": 0.348
            },
            "rightCorner": {
              "x": -14.649,
              "y": -7.568,
              "z": 0.348
            },
            "gtin": "4000398254395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50c4",
            "leftCorner": {
              "x": -14.649,
              "y": -7.568,
              "z": 0.348
            },
            "rightCorner": {
              "x": -14.448,
              "y": -7.568,
              "z": 0.348
            },
            "gtin": "4002676252550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50c5",
            "leftCorner": {
              "x": -14.447,
              "y": -7.57,
              "z": 0.348
            },
            "rightCorner": {
              "x": -14.167,
              "y": -7.571,
              "z": 0.348
            },
            "gtin": "4002676252505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50c6",
            "leftCorner": {
              "x": -14.167,
              "y": -7.568,
              "z": 0.348
            },
            "rightCorner": {
              "x": -14.039,
              "y": -7.569,
              "z": 0.348
            },
            "gtin": "4002676252529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50c7",
            "leftCorner": {
              "x": -14.039,
              "y": -7.568,
              "z": 0.348
            },
            "rightCorner": {
              "x": -13.905,
              "y": -7.569,
              "z": 0.348
            },
            "gtin": "4002676252512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50be",
            "leftCorner": {
              "x": -13.905,
              "y": -7.574,
              "z": 0.348
            },
            "rightCorner": {
              "x": -13.801,
              "y": -7.574,
              "z": 0.348
            },
            "gtin": "4250426224245",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce6b",
        "height": 0.74729,
        "facings": [
          {
            "id": "68d8e508e1820c81800d506b",
            "leftCorner": {
              "x": -15.051,
              "y": -7.558,
              "z": 0.611
            },
            "rightCorner": {
              "x": -14.95,
              "y": -7.563,
              "z": 0.611
            },
            "gtin": "4000398254098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d506c",
            "leftCorner": {
              "x": -14.949,
              "y": -7.569,
              "z": 0.611
            },
            "rightCorner": {
              "x": -14.757,
              "y": -7.569,
              "z": 0.611
            },
            "gtin": "4000398254098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d506d",
            "leftCorner": {
              "x": -14.757,
              "y": -7.569,
              "z": 0.611
            },
            "rightCorner": {
              "x": -14.565,
              "y": -7.569,
              "z": 0.611
            },
            "gtin": "4000398254098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d506e",
            "leftCorner": {
              "x": -14.565,
              "y": -7.577,
              "z": 0.611
            },
            "rightCorner": {
              "x": -14.277,
              "y": -7.577,
              "z": 0.611
            },
            "gtin": "4250426223729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d506f",
            "leftCorner": {
              "x": -14.277,
              "y": -7.576,
              "z": 0.611
            },
            "rightCorner": {
              "x": -13.894,
              "y": -7.577,
              "z": 0.611
            },
            "gtin": "4250426223705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5070",
            "leftCorner": {
              "x": -13.893,
              "y": -7.586,
              "z": 0.611
            },
            "rightCorner": {
              "x": -13.356,
              "y": -7.587,
              "z": 0.611
            },
            "gtin": "4250426223682",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce6e",
        "height": 1.0525,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50ad",
            "leftCorner": {
              "x": -15.051,
              "y": -7.56,
              "z": 0.861
            },
            "rightCorner": {
              "x": -14.895,
              "y": -7.566,
              "z": 0.861
            },
            "gtin": "4002861774393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50ae",
            "leftCorner": {
              "x": -14.895,
              "y": -7.57,
              "z": 0.861
            },
            "rightCorner": {
              "x": -14.55,
              "y": -7.571,
              "z": 0.861
            },
            "gtin": "4002861774393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50af",
            "leftCorner": {
              "x": -14.55,
              "y": -7.575,
              "z": 0.861
            },
            "rightCorner": {
              "x": -14.363,
              "y": -7.575,
              "z": 0.861
            },
            "gtin": "5201193218554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50b0",
            "leftCorner": {
              "x": -14.363,
              "y": -7.572,
              "z": 0.861
            },
            "rightCorner": {
              "x": -14.004,
              "y": -7.572,
              "z": 0.861
            },
            "gtin": "5201193204021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50b1",
            "leftCorner": {
              "x": -14.004,
              "y": -7.577,
              "z": 0.861
            },
            "rightCorner": {
              "x": -13.861,
              "y": -7.577,
              "z": 0.861
            },
            "gtin": "5201193203536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50b2",
            "leftCorner": {
              "x": -13.861,
              "y": -7.576,
              "z": 0.861
            },
            "rightCorner": {
              "x": -13.645,
              "y": -7.576,
              "z": 0.861
            },
            "gtin": "5201193218547",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce6d",
        "height": 1.3536,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5099",
            "leftCorner": {
              "x": -15.051,
              "y": -7.564,
              "z": 1.107
            },
            "rightCorner": {
              "x": -14.909,
              "y": -7.57,
              "z": 1.107
            },
            "gtin": "4002676212042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d509a",
            "leftCorner": {
              "x": -14.909,
              "y": -7.568,
              "z": 1.107
            },
            "rightCorner": {
              "x": -14.634,
              "y": -7.569,
              "z": 1.107
            },
            "gtin": "4002676212042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d509b",
            "leftCorner": {
              "x": -14.634,
              "y": -7.575,
              "z": 1.107
            },
            "rightCorner": {
              "x": -14.339,
              "y": -7.576,
              "z": 1.107
            },
            "gtin": "4002676212035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d509c",
            "leftCorner": {
              "x": -14.339,
              "y": -7.574,
              "z": 1.107
            },
            "rightCorner": {
              "x": -14.055,
              "y": -7.575,
              "z": 1.107
            },
            "gtin": "4002676212165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d509d",
            "leftCorner": {
              "x": -14.055,
              "y": -7.58,
              "z": 1.107
            },
            "rightCorner": {
              "x": -13.784,
              "y": -7.58,
              "z": 1.107
            },
            "gtin": "4002676212073",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce6c",
        "height": 1.6526,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5082",
            "leftCorner": {
              "x": -15.051,
              "y": -7.56,
              "z": 1.352
            },
            "rightCorner": {
              "x": -14.922,
              "y": -7.566,
              "z": 1.352
            },
            "gtin": "4002676232002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5083",
            "leftCorner": {
              "x": -14.922,
              "y": -7.592,
              "z": 1.352
            },
            "rightCorner": {
              "x": -14.623,
              "y": -7.592,
              "z": 1.352
            },
            "gtin": "4002676232002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5084",
            "leftCorner": {
              "x": -14.623,
              "y": -7.577,
              "z": 1.352
            },
            "rightCorner": {
              "x": -14.052,
              "y": -7.578,
              "z": 1.352
            },
            "gtin": "4002676212189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5085",
            "leftCorner": {
              "x": -14.052,
              "y": -7.578,
              "z": 1.352
            },
            "rightCorner": {
              "x": -13.773,
              "y": -7.579,
              "z": 1.352
            },
            "gtin": "4002676212172",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7b4",
    "rightNeighborShelfId": "7b6"
  },
  {
    "id": "7b6",
    "name": "7b6",
    "x": -13.801,
    "y": -7.564,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -8.6394E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32,
      "shelfCategory": "PASTA"
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce77",
        "height": 0.16809,
        "facings": [
          {
            "id": "24bc7855bb84dcfc1c356823",
            "leftCorner": {
              "x": -13.801,
              "y": -7.674,
              "z": 0.138
            },
            "rightCorner": {
              "x": -13.666,
              "y": -7.674,
              "z": 0.138
            },
            "gtin": "8001250120236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e9b3e9614e4178569703fc65",
            "leftCorner": {
              "x": -13.666,
              "y": -7.674,
              "z": 0.138
            },
            "rightCorner": {
              "x": -13.498,
              "y": -7.674,
              "z": 0.138
            },
            "gtin": "8001250120502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b2a5a40c67cecaa6ec65429c",
            "leftCorner": {
              "x": -13.498,
              "y": -7.674,
              "z": 0.138
            },
            "rightCorner": {
              "x": -13.317,
              "y": -7.675,
              "z": 0.138
            },
            "gtin": "4250426224221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6559ec08ecb998f61f241070",
            "leftCorner": {
              "x": -13.317,
              "y": -7.675,
              "z": 0.138
            },
            "rightCorner": {
              "x": -13.095,
              "y": -7.675,
              "z": 0.138
            },
            "gtin": "5201193218738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "daeda14f9f59e5f53efd1c22",
            "leftCorner": {
              "x": -13.095,
              "y": -7.675,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.864,
              "y": -7.676,
              "z": 0.138
            },
            "gtin": "8001250120342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d4046bdea9f2932f0f77b39c",
            "leftCorner": {
              "x": -12.864,
              "y": -7.676,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.624,
              "y": -7.676,
              "z": 0.138
            },
            "gtin": "5201193218905",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce73",
        "height": 0.4389,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50d4",
            "leftCorner": {
              "x": -13.801,
              "y": -7.62,
              "z": 0.359
            },
            "rightCorner": {
              "x": -13.567,
              "y": -7.62,
              "z": 0.359
            },
            "gtin": "4250426224160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50d5",
            "leftCorner": {
              "x": -13.567,
              "y": -7.62,
              "z": 0.359
            },
            "rightCorner": {
              "x": -13.333,
              "y": -7.62,
              "z": 0.359
            },
            "gtin": "4250426224160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50d7",
            "leftCorner": {
              "x": -13.333,
              "y": -7.587,
              "z": 0.359
            },
            "rightCorner": {
              "x": -13.034,
              "y": -7.588,
              "z": 0.359
            },
            "gtin": "4250426224207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50d8",
            "leftCorner": {
              "x": -13.034,
              "y": -7.584,
              "z": 0.359
            },
            "rightCorner": {
              "x": -12.728,
              "y": -7.585,
              "z": 0.359
            },
            "gtin": "4250426224184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50d6",
            "leftCorner": {
              "x": -12.728,
              "y": -7.577,
              "z": 0.359
            },
            "rightCorner": {
              "x": -12.551,
              "y": -7.577,
              "z": 0.359
            },
            "gtin": "4250426224221",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce76",
        "height": 0.74467,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5071",
            "leftCorner": {
              "x": -13.356,
              "y": -7.595,
              "z": 0.609
            },
            "rightCorner": {
              "x": -13.244,
              "y": -7.595,
              "z": 0.609
            },
            "gtin": "4250426223644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "83b5a549c08799fc95c72ba5",
            "leftCorner": {
              "x": -13.801,
              "y": -7.632,
              "z": 0.609
            },
            "rightCorner": {
              "x": -13.579,
              "y": -7.632,
              "z": 0.609
            },
            "gtin": "4250426223668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "028cbc747d5b96fbf94d3bb5",
            "leftCorner": {
              "x": -13.579,
              "y": -7.632,
              "z": 0.609
            },
            "rightCorner": {
              "x": -13.358,
              "y": -7.633,
              "z": 0.609
            },
            "gtin": "4250426223668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5072",
            "leftCorner": {
              "x": -13.244,
              "y": -7.595,
              "z": 0.609
            },
            "rightCorner": {
              "x": -13.133,
              "y": -7.596,
              "z": 0.609
            },
            "gtin": "4250426223644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5073",
            "leftCorner": {
              "x": -13.133,
              "y": -7.593,
              "z": 0.609
            },
            "rightCorner": {
              "x": -12.831,
              "y": -7.594,
              "z": 0.609
            },
            "gtin": "4250426224146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5074",
            "leftCorner": {
              "x": -12.831,
              "y": -7.589,
              "z": 0.609
            },
            "rightCorner": {
              "x": -12.551,
              "y": -7.59,
              "z": 0.609
            },
            "gtin": "4250426224122",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce72",
        "height": 1.0534,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50b3",
            "leftCorner": {
              "x": -13.644,
              "y": -7.577,
              "z": 0.862
            },
            "rightCorner": {
              "x": -13.417,
              "y": -7.578,
              "z": 0.862
            },
            "gtin": "5201193218738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5a213e8f8f7cff64c69753cf",
            "leftCorner": {
              "x": -13.801,
              "y": -7.624,
              "z": 0.862
            },
            "rightCorner": {
              "x": -13.703,
              "y": -7.624,
              "z": 0.862
            },
            "gtin": "4006196086275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50b4",
            "leftCorner": {
              "x": -13.417,
              "y": -7.588,
              "z": 0.862
            },
            "rightCorner": {
              "x": -13.184,
              "y": -7.588,
              "z": 0.862
            },
            "gtin": "5201193218905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50b5",
            "leftCorner": {
              "x": -13.184,
              "y": -7.589,
              "z": 0.862
            },
            "rightCorner": {
              "x": -12.902,
              "y": -7.59,
              "z": 0.862
            },
            "gtin": "4306188432104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50b6",
            "leftCorner": {
              "x": -12.902,
              "y": -7.583,
              "z": 0.862
            },
            "rightCorner": {
              "x": -12.641,
              "y": -7.583,
              "z": 0.862
            },
            "gtin": "4006196086282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50b7",
            "leftCorner": {
              "x": -12.641,
              "y": -7.583,
              "z": 0.862
            },
            "rightCorner": {
              "x": -12.324,
              "y": -7.584,
              "z": 0.862
            },
            "gtin": "4006196086275",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce75",
        "height": 1.3562,
        "facings": [
          {
            "id": "68d8e508e1820c81800d509e",
            "leftCorner": {
              "x": -13.784,
              "y": -7.58,
              "z": 1.11
            },
            "rightCorner": {
              "x": -13.492,
              "y": -7.581,
              "z": 1.11
            },
            "gtin": "8001250120113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d509f",
            "leftCorner": {
              "x": -13.492,
              "y": -7.591,
              "z": 1.11
            },
            "rightCorner": {
              "x": -13.184,
              "y": -7.591,
              "z": 1.11
            },
            "gtin": "8001250120076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50a0",
            "leftCorner": {
              "x": -13.184,
              "y": -7.593,
              "z": 1.11
            },
            "rightCorner": {
              "x": -12.883,
              "y": -7.593,
              "z": 1.11
            },
            "gtin": "8001250120120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50a1",
            "leftCorner": {
              "x": -12.883,
              "y": -7.587,
              "z": 1.11
            },
            "rightCorner": {
              "x": -12.367,
              "y": -7.588,
              "z": 1.11
            },
            "gtin": "8001250145413",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce74",
        "height": 1.6565,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5086",
            "leftCorner": {
              "x": -13.772,
              "y": -7.57,
              "z": 1.355
            },
            "rightCorner": {
              "x": -13.517,
              "y": -7.571,
              "z": 1.355
            },
            "gtin": "8001250120342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5087",
            "leftCorner": {
              "x": -13.517,
              "y": -7.588,
              "z": 1.355
            },
            "rightCorner": {
              "x": -13.365,
              "y": -7.588,
              "z": 1.355
            },
            "gtin": "8001250120502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5088",
            "leftCorner": {
              "x": -13.365,
              "y": -7.59,
              "z": 1.355
            },
            "rightCorner": {
              "x": -13.227,
              "y": -7.59,
              "z": 1.355
            },
            "gtin": "8001250120236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5089",
            "leftCorner": {
              "x": -13.227,
              "y": -7.591,
              "z": 1.355
            },
            "rightCorner": {
              "x": -12.915,
              "y": -7.591,
              "z": 1.355
            },
            "gtin": "8001250121264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d508a",
            "leftCorner": {
              "x": -12.915,
              "y": -7.585,
              "z": 1.355
            },
            "rightCorner": {
              "x": -12.551,
              "y": -7.586,
              "z": 1.355
            },
            "gtin": "8001250121257",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7b5",
    "rightNeighborShelfId": "7b7"
  },
  {
    "id": "7b7",
    "name": "7b7",
    "x": -12.551,
    "y": -7.566,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -8.6394E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 33,
      "shelfCategory": "PASTA"
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce7d",
        "height": 0.17065,
        "facings": [
          {
            "id": "59afc666f08e6fb078bc8e4d",
            "leftCorner": {
              "x": -12.551,
              "y": -7.656,
              "z": 0.14
            },
            "rightCorner": {
              "x": -12.347,
              "y": -7.657,
              "z": 0.14
            },
            "gtin": "8076809523738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b39468b986f1eb0391d429e4",
            "leftCorner": {
              "x": -12.347,
              "y": -7.657,
              "z": 0.14
            },
            "rightCorner": {
              "x": -12.079,
              "y": -7.657,
              "z": 0.14
            },
            "gtin": "8076809529419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "41d919f000b3b3d87cbb8d3d",
            "leftCorner": {
              "x": -12.079,
              "y": -7.657,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.784,
              "y": -7.658,
              "z": 0.14
            },
            "gtin": "4002966004135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "76be9cfcae1c38ee9b294799",
            "leftCorner": {
              "x": -11.784,
              "y": -7.658,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.485,
              "y": -7.658,
              "z": 0.14
            },
            "gtin": "8076809585415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "01e86c82d3165e3e0be67f30",
            "leftCorner": {
              "x": -11.485,
              "y": -7.658,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.304,
              "y": -7.658,
              "z": 0.14
            },
            "gtin": "8076809585224",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce7c",
        "height": 0.45235,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50d9",
            "leftCorner": {
              "x": -12.551,
              "y": -7.613,
              "z": 0.37
            },
            "rightCorner": {
              "x": -12.059,
              "y": -7.614,
              "z": 0.37
            },
            "gtin": "8000270013085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50dc",
            "leftCorner": {
              "x": -12.059,
              "y": -7.575,
              "z": 0.37
            },
            "rightCorner": {
              "x": -11.61,
              "y": -7.576,
              "z": 0.37
            },
            "gtin": "8000270706505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50dd",
            "leftCorner": {
              "x": -11.611,
              "y": -7.573,
              "z": 0.37
            },
            "rightCorner": {
              "x": -11.281,
              "y": -7.573,
              "z": 0.37
            },
            "gtin": "8000270704518",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce7b",
        "height": 0.75023,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5075",
            "leftCorner": {
              "x": -12.551,
              "y": -7.568,
              "z": 0.614
            },
            "rightCorner": {
              "x": -12.501,
              "y": -7.569,
              "z": 0.614
            },
            "gtin": "8000270706352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5076",
            "leftCorner": {
              "x": -12.501,
              "y": -7.576,
              "z": 0.614
            },
            "rightCorner": {
              "x": -12.117,
              "y": -7.576,
              "z": 0.614
            },
            "gtin": "8000270706352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5077",
            "leftCorner": {
              "x": -12.117,
              "y": -7.575,
              "z": 0.614
            },
            "rightCorner": {
              "x": -11.719,
              "y": -7.576,
              "z": 0.614
            },
            "gtin": "8000270706468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5078",
            "leftCorner": {
              "x": -11.719,
              "y": -7.573,
              "z": 0.614
            },
            "rightCorner": {
              "x": -11.362,
              "y": -7.574,
              "z": 0.614
            },
            "gtin": "8000270011319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5079",
            "leftCorner": {
              "x": -11.362,
              "y": -7.579,
              "z": 0.614
            },
            "rightCorner": {
              "x": -10.898,
              "y": -7.579,
              "z": 0.614
            },
            "gtin": "8000270013115",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce7a",
        "height": 1.0543,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50b8",
            "leftCorner": {
              "x": -12.324,
              "y": -7.576,
              "z": 0.863
            },
            "rightCorner": {
              "x": -12.027,
              "y": -7.576,
              "z": 0.863
            },
            "gtin": "8076809585415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2938c743d8b5175268b1ce63",
            "leftCorner": {
              "x": -12.551,
              "y": -7.616,
              "z": 0.863
            },
            "rightCorner": {
              "x": -12.372,
              "y": -7.616,
              "z": 0.863
            },
            "gtin": "8076809585224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50b9",
            "leftCorner": {
              "x": -12.027,
              "y": -7.577,
              "z": 0.863
            },
            "rightCorner": {
              "x": -11.472,
              "y": -7.577,
              "z": 0.863
            },
            "gtin": "8076809585217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50ba",
            "leftCorner": {
              "x": -11.472,
              "y": -7.581,
              "z": 0.863
            },
            "rightCorner": {
              "x": -10.872,
              "y": -7.582,
              "z": 0.863
            },
            "gtin": "8076809585224",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce79",
        "height": 1.3583,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50a2",
            "leftCorner": {
              "x": -12.367,
              "y": -7.581,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.071,
              "y": -7.581,
              "z": 1.111
            },
            "gtin": "4002966004135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ba6d29da47a331b7920edcec",
            "leftCorner": {
              "x": -12.551,
              "y": -7.618,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.391,
              "y": -7.618,
              "z": 1.111
            },
            "gtin": "8076809529457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ba73afc7f3e90281d22873ad",
            "leftCorner": {
              "x": -12.391,
              "y": -7.618,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.387,
              "y": -7.618,
              "z": 1.111
            },
            "gtin": "4002861963650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dc9cd02c008be2f89fc78fdc",
            "leftCorner": {
              "x": -12.387,
              "y": -7.618,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.384,
              "y": -7.618,
              "z": 1.111
            },
            "gtin": "4002861963650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d34fd2f5c79ce09dbb1bdc58",
            "leftCorner": {
              "x": -12.384,
              "y": -7.618,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.38,
              "y": -7.618,
              "z": 1.111
            },
            "gtin": "4002861963650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "729cddf24d12e61ac25cd0ce",
            "leftCorner": {
              "x": -12.38,
              "y": -7.618,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.376,
              "y": -7.618,
              "z": 1.111
            },
            "gtin": "4002861963650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6310d57b74b91fbb0c98647d",
            "leftCorner": {
              "x": -12.376,
              "y": -7.618,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.373,
              "y": -7.618,
              "z": 1.111
            },
            "gtin": "4002861963650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b4c4dc412c01505fcbe3c3c2",
            "leftCorner": {
              "x": -12.373,
              "y": -7.618,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.369,
              "y": -7.618,
              "z": 1.111
            },
            "gtin": "4002861963650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50a3",
            "leftCorner": {
              "x": -12.071,
              "y": -7.578,
              "z": 1.111
            },
            "rightCorner": {
              "x": -11.732,
              "y": -7.579,
              "z": 1.111
            },
            "gtin": "4002966004067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50a4",
            "leftCorner": {
              "x": -11.732,
              "y": -7.577,
              "z": 1.111
            },
            "rightCorner": {
              "x": -11.456,
              "y": -7.577,
              "z": 1.111
            },
            "gtin": "8076809529419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50a5",
            "leftCorner": {
              "x": -11.456,
              "y": -7.58,
              "z": 1.111
            },
            "rightCorner": {
              "x": -11.311,
              "y": -7.581,
              "z": 1.111
            },
            "gtin": "8076809529457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50a6",
            "leftCorner": {
              "x": -11.311,
              "y": -7.58,
              "z": 1.111
            },
            "rightCorner": {
              "x": -11.024,
              "y": -7.58,
              "z": 1.111
            },
            "gtin": "4002861963650",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce78",
        "height": 1.6582,
        "facings": [
          {
            "id": "68d8e508e1820c81800d508b",
            "leftCorner": {
              "x": -12.551,
              "y": -7.567,
              "z": 1.357
            },
            "rightCorner": {
              "x": -12.519,
              "y": -7.568,
              "z": 1.357
            },
            "gtin": "8001250211125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d508c",
            "leftCorner": {
              "x": -12.519,
              "y": -7.579,
              "z": 1.357
            },
            "rightCorner": {
              "x": -12.351,
              "y": -7.58,
              "z": 1.357
            },
            "gtin": "8001250211125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d508d",
            "leftCorner": {
              "x": -12.351,
              "y": -7.576,
              "z": 1.357
            },
            "rightCorner": {
              "x": -11.907,
              "y": -7.577,
              "z": 1.357
            },
            "gtin": "4306188422105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d508e",
            "leftCorner": {
              "x": -11.907,
              "y": -7.574,
              "z": 1.357
            },
            "rightCorner": {
              "x": -11.498,
              "y": -7.574,
              "z": 1.357
            },
            "gtin": "4306188422044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d508f",
            "leftCorner": {
              "x": -11.498,
              "y": -7.571,
              "z": 1.357
            },
            "rightCorner": {
              "x": -11.209,
              "y": -7.571,
              "z": 1.357
            },
            "gtin": "8076809523738",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7b6",
    "rightNeighborShelfId": "7b8"
  },
  {
    "id": "7b8",
    "name": "7b8",
    "x": -11.301,
    "y": -7.568,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -8.6394E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 23,
      "shelfCategory": "PASTA"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d608",
        "height": 0.16887,
        "facings": [
          {
            "id": "3504d5f7dd837d596e17a228",
            "leftCorner": {
              "x": -11.302,
              "y": -7.645,
              "z": 0.138
            },
            "rightCorner": {
              "x": -11.085,
              "y": -7.645,
              "z": 0.138
            },
            "gtin": "8076808070882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c152dbd6e03c70af485e0ff7",
            "leftCorner": {
              "x": -11.085,
              "y": -7.645,
              "z": 0.138
            },
            "rightCorner": {
              "x": -10.827,
              "y": -7.646,
              "z": 0.138
            },
            "gtin": "8076809580144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1670c3a24f12c2385317a429",
            "leftCorner": {
              "x": -10.827,
              "y": -7.646,
              "z": 0.138
            },
            "rightCorner": {
              "x": -10.534,
              "y": -7.646,
              "z": 0.138
            },
            "gtin": "8076808050440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7d369faceb7b8e239d34b069",
            "leftCorner": {
              "x": -10.534,
              "y": -7.646,
              "z": 0.138
            },
            "rightCorner": {
              "x": -10.236,
              "y": -7.647,
              "z": 0.138
            },
            "gtin": "8076809585194",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d604",
        "height": 0.45145,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50de",
            "leftCorner": {
              "x": -11.282,
              "y": -7.579,
              "z": 0.369
            },
            "rightCorner": {
              "x": -10.92,
              "y": -7.579,
              "z": 0.369
            },
            "gtin": "8000270016284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50df",
            "leftCorner": {
              "x": -10.92,
              "y": -7.558,
              "z": 0.369
            },
            "rightCorner": {
              "x": -10.611,
              "y": -7.558,
              "z": 0.369
            },
            "gtin": "8076802085738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50da",
            "leftCorner": {
              "x": -10.611,
              "y": -7.553,
              "z": 0.369
            },
            "rightCorner": {
              "x": -10.331,
              "y": -7.554,
              "z": 0.369
            },
            "gtin": "8076802085981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50db",
            "leftCorner": {
              "x": -10.331,
              "y": -7.554,
              "z": 0.369
            },
            "rightCorner": {
              "x": -10.051,
              "y": -7.554,
              "z": 0.369
            },
            "gtin": "8076802085981",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d606",
        "height": 0.74706,
        "facings": [
          {
            "id": "68d8e508e1820c81800d507a",
            "leftCorner": {
              "x": -10.898,
              "y": -7.56,
              "z": 0.611
            },
            "rightCorner": {
              "x": -10.618,
              "y": -7.56,
              "z": 0.611
            },
            "gtin": "8076808050440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d507b",
            "leftCorner": {
              "x": -10.618,
              "y": -7.557,
              "z": 0.611
            },
            "rightCorner": {
              "x": -10.29,
              "y": -7.557,
              "z": 0.611
            },
            "gtin": "8076809521628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5065",
            "leftCorner": {
              "x": -10.29,
              "y": -7.557,
              "z": 0.611
            },
            "rightCorner": {
              "x": -10.051,
              "y": -7.558,
              "z": 0.611
            },
            "gtin": "8076809512268",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "c169eeac7f7c8478f71230bb",
            "leftCorner": {
              "x": -11.301,
              "y": -7.596,
              "z": 0.611
            },
            "rightCorner": {
              "x": -11.058,
              "y": -7.596,
              "z": 0.611
            },
            "gtin": "8076809512268",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d605",
        "height": 1.0518,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50bb",
            "leftCorner": {
              "x": -10.873,
              "y": -7.561,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.578,
              "y": -7.561,
              "z": 0.861
            },
            "gtin": "8076809585194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50bc",
            "leftCorner": {
              "x": -10.578,
              "y": -7.557,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.271,
              "y": -7.557,
              "z": 0.861
            },
            "gtin": "8076809523509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50aa",
            "leftCorner": {
              "x": -10.271,
              "y": -7.559,
              "z": 0.861
            },
            "rightCorner": {
              "x": -10.051,
              "y": -7.559,
              "z": 0.861
            },
            "gtin": "8076809584920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "88a944410c6d41aa074787e9",
            "leftCorner": {
              "x": -11.301,
              "y": -7.596,
              "z": 0.861
            },
            "rightCorner": {
              "x": -11.075,
              "y": -7.597,
              "z": 0.861
            },
            "gtin": "8076809584920",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d602",
        "height": 1.359,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50a7",
            "leftCorner": {
              "x": -11.025,
              "y": -7.566,
              "z": 1.112
            },
            "rightCorner": {
              "x": -10.725,
              "y": -7.566,
              "z": 1.112
            },
            "gtin": "4002861963643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50a8",
            "leftCorner": {
              "x": -10.725,
              "y": -7.56,
              "z": 1.112
            },
            "rightCorner": {
              "x": -10.314,
              "y": -7.561,
              "z": 1.112
            },
            "gtin": "8076809583503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5094",
            "leftCorner": {
              "x": -10.314,
              "y": -7.618,
              "z": 1.112
            },
            "rightCorner": {
              "x": -10.051,
              "y": -7.618,
              "z": 1.112
            },
            "gtin": "8076809580144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7009568ecbe58c44c02ec1fa",
            "leftCorner": {
              "x": -11.301,
              "y": -7.602,
              "z": 1.112
            },
            "rightCorner": {
              "x": -11.163,
              "y": -7.603,
              "z": 1.112
            },
            "gtin": "4002861963650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "98c781f4b6117ed0586da9bb",
            "leftCorner": {
              "x": -11.163,
              "y": -7.603,
              "z": 1.112
            },
            "rightCorner": {
              "x": -11.025,
              "y": -7.603,
              "z": 1.112
            },
            "gtin": "4002861963650",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d603",
        "height": 1.6571,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5090",
            "leftCorner": {
              "x": -11.209,
              "y": -7.572,
              "z": 1.356
            },
            "rightCorner": {
              "x": -10.98,
              "y": -7.572,
              "z": 1.356
            },
            "gtin": "8076808070882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5091",
            "leftCorner": {
              "x": -10.98,
              "y": -7.558,
              "z": 1.356
            },
            "rightCorner": {
              "x": -10.681,
              "y": -7.559,
              "z": 1.356
            },
            "gtin": "8076809523707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5092",
            "leftCorner": {
              "x": -10.681,
              "y": -7.555,
              "z": 1.356
            },
            "rightCorner": {
              "x": -10.376,
              "y": -7.556,
              "z": 1.356
            },
            "gtin": "8076809519977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d507d",
            "leftCorner": {
              "x": -10.376,
              "y": -7.553,
              "z": 1.356
            },
            "rightCorner": {
              "x": -10.051,
              "y": -7.553,
              "z": 1.356
            },
            "gtin": "8076809523714",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7b7"
  },
  {
    "id": "7b9",
    "name": "7b9",
    "x": -9.953,
    "y": -9.125,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0056636
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 49
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce83",
        "height": 0.17087,
        "facings": [
          {
            "id": "a00475840bb465e0f6a23c71",
            "leftCorner": {
              "x": -9.954,
              "y": -9.041,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.045,
              "y": -9.042,
              "z": 0.14
            },
            "gtin": "8005110001550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "44e14a163f4df30a112ed51d",
            "leftCorner": {
              "x": -10.045,
              "y": -9.042,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.138,
              "y": -9.043,
              "z": 0.14
            },
            "gtin": "4250426223743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d7cb3e0290482c4c9523d660",
            "leftCorner": {
              "x": -10.138,
              "y": -9.043,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.235,
              "y": -9.045,
              "z": 0.14
            },
            "gtin": "4104420213517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "821c1557947b92f44fdda16b",
            "leftCorner": {
              "x": -10.235,
              "y": -9.045,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.335,
              "y": -9.046,
              "z": 0.14
            },
            "gtin": "4104420249189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e5797e2211963482e0481fb0",
            "leftCorner": {
              "x": -10.335,
              "y": -9.046,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.441,
              "y": -9.047,
              "z": 0.14
            },
            "gtin": "4104420031326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "10d41f35c9aecee7bf3a8da4",
            "leftCorner": {
              "x": -10.441,
              "y": -9.047,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.547,
              "y": -9.048,
              "z": 0.14
            },
            "gtin": "4104420213555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fc3961f318d751d8cee2ab25",
            "leftCorner": {
              "x": -10.547,
              "y": -9.048,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.665,
              "y": -9.049,
              "z": 0.14
            },
            "gtin": "4104420257344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7afb6381c52e27bf84ddd501",
            "leftCorner": {
              "x": -10.665,
              "y": -9.049,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.789,
              "y": -9.051,
              "z": 0.14
            },
            "gtin": "8076809578264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "30a1021f496b93f91507888e",
            "leftCorner": {
              "x": -10.789,
              "y": -9.051,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.913,
              "y": -9.052,
              "z": 0.14
            },
            "gtin": "8076809513692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d2f24639011bf3289266b2bc",
            "leftCorner": {
              "x": -10.913,
              "y": -9.052,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.164,
              "y": -9.055,
              "z": 0.14
            },
            "gtin": "4306188021513",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce82",
        "height": 0.42779,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5171",
            "leftCorner": {
              "x": -9.954,
              "y": -9.083,
              "z": 0.35
            },
            "rightCorner": {
              "x": -10.446,
              "y": -9.089,
              "z": 0.35
            },
            "gtin": "4306188021513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5173",
            "leftCorner": {
              "x": -10.445,
              "y": -9.129,
              "z": 0.35
            },
            "rightCorner": {
              "x": -10.679,
              "y": -9.132,
              "z": 0.35
            },
            "gtin": "4306188021490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5174",
            "leftCorner": {
              "x": -10.679,
              "y": -9.131,
              "z": 0.35
            },
            "rightCorner": {
              "x": -10.882,
              "y": -9.133,
              "z": 0.35
            },
            "gtin": "4306188046059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5175",
            "leftCorner": {
              "x": -10.882,
              "y": -9.134,
              "z": 0.35
            },
            "rightCorner": {
              "x": -11.062,
              "y": -9.136,
              "z": 0.35
            },
            "gtin": "8710604725569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5176",
            "leftCorner": {
              "x": -11.062,
              "y": -9.135,
              "z": 0.35
            },
            "rightCorner": {
              "x": -11.253,
              "y": -9.137,
              "z": 0.35
            },
            "gtin": "4038700117595",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce7f",
        "height": 0.69972,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5108",
            "leftCorner": {
              "x": -9.954,
              "y": -9.08,
              "z": 0.572
            },
            "rightCorner": {
              "x": -10.14,
              "y": -9.082,
              "z": 0.572
            },
            "gtin": "4104420249189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d510a",
            "leftCorner": {
              "x": -10.14,
              "y": -9.126,
              "z": 0.572
            },
            "rightCorner": {
              "x": -10.245,
              "y": -9.127,
              "z": 0.572
            },
            "gtin": "4104420213555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d510b",
            "leftCorner": {
              "x": -10.246,
              "y": -9.122,
              "z": 0.572
            },
            "rightCorner": {
              "x": -10.413,
              "y": -9.124,
              "z": 0.572
            },
            "gtin": "4104420213593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d510c",
            "leftCorner": {
              "x": -10.413,
              "y": -9.125,
              "z": 0.572
            },
            "rightCorner": {
              "x": -10.513,
              "y": -9.126,
              "z": 0.572
            },
            "gtin": "4104420213517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d510d",
            "leftCorner": {
              "x": -10.513,
              "y": -9.127,
              "z": 0.572
            },
            "rightCorner": {
              "x": -10.666,
              "y": -9.129,
              "z": 0.572
            },
            "gtin": "4104420031081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d510e",
            "leftCorner": {
              "x": -10.666,
              "y": -9.127,
              "z": 0.572
            },
            "rightCorner": {
              "x": -10.82,
              "y": -9.129,
              "z": 0.572
            },
            "gtin": "4002359006067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d510f",
            "leftCorner": {
              "x": -10.82,
              "y": -9.13,
              "z": 0.572
            },
            "rightCorner": {
              "x": -10.966,
              "y": -9.131,
              "z": 0.572
            },
            "gtin": "4002359006029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5110",
            "leftCorner": {
              "x": -10.966,
              "y": -9.129,
              "z": 0.572
            },
            "rightCorner": {
              "x": -11.101,
              "y": -9.131,
              "z": 0.572
            },
            "gtin": "4002359006005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5111",
            "leftCorner": {
              "x": -11.101,
              "y": -9.131,
              "z": 0.572
            },
            "rightCorner": {
              "x": -11.236,
              "y": -9.133,
              "z": 0.572
            },
            "gtin": "4002359006005",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce81",
        "height": 1.0022,
        "facings": [
          {
            "id": "68d8e508e1820c81800d514e",
            "leftCorner": {
              "x": -9.954,
              "y": -9.076,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.135,
              "y": -9.078,
              "z": 0.82
            },
            "gtin": "8076809513678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5150",
            "leftCorner": {
              "x": -10.135,
              "y": -9.122,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.3,
              "y": -9.124,
              "z": 0.82
            },
            "gtin": "8076809521543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5151",
            "leftCorner": {
              "x": -10.3,
              "y": -9.12,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.46,
              "y": -9.122,
              "z": 0.82
            },
            "gtin": "8076809513654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5152",
            "leftCorner": {
              "x": -10.46,
              "y": -9.118,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.582,
              "y": -9.12,
              "z": 0.82
            },
            "gtin": "8076809513692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5153",
            "leftCorner": {
              "x": -10.582,
              "y": -9.124,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.746,
              "y": -9.126,
              "z": 0.82
            },
            "gtin": "8076809513722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5154",
            "leftCorner": {
              "x": -10.746,
              "y": -9.127,
              "z": 0.82
            },
            "rightCorner": {
              "x": -10.901,
              "y": -9.129,
              "z": 0.82
            },
            "gtin": "8076809513388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5155",
            "leftCorner": {
              "x": -10.901,
              "y": -9.121,
              "z": 0.82
            },
            "rightCorner": {
              "x": -11.054,
              "y": -9.123,
              "z": 0.82
            },
            "gtin": "8076809523561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5156",
            "leftCorner": {
              "x": -11.054,
              "y": -9.122,
              "z": 0.82
            },
            "rightCorner": {
              "x": -11.217,
              "y": -9.123,
              "z": 0.82
            },
            "gtin": "4008100169319",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce80",
        "height": 1.3053,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5124",
            "leftCorner": {
              "x": -9.954,
              "y": -9.079,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.152,
              "y": -9.081,
              "z": 1.068
            },
            "gtin": "8076809541091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5126",
            "leftCorner": {
              "x": -10.151,
              "y": -9.124,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.333,
              "y": -9.127,
              "z": 1.068
            },
            "gtin": "8076809523547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5127",
            "leftCorner": {
              "x": -10.333,
              "y": -9.126,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.461,
              "y": -9.128,
              "z": 1.068
            },
            "gtin": "8076809576581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5128",
            "leftCorner": {
              "x": -10.461,
              "y": -9.125,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.605,
              "y": -9.126,
              "z": 1.068
            },
            "gtin": "8076809576598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5129",
            "leftCorner": {
              "x": -10.605,
              "y": -9.126,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.738,
              "y": -9.127,
              "z": 1.068
            },
            "gtin": "8076809517881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d512a",
            "leftCorner": {
              "x": -10.738,
              "y": -9.128,
              "z": 1.068
            },
            "rightCorner": {
              "x": -10.864,
              "y": -9.129,
              "z": 1.068
            },
            "gtin": "8076809578264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d512b",
            "leftCorner": {
              "x": -10.864,
              "y": -9.126,
              "z": 1.068
            },
            "rightCorner": {
              "x": -11.065,
              "y": -9.128,
              "z": 1.068
            },
            "gtin": "8076809517751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d512c",
            "leftCorner": {
              "x": -11.065,
              "y": -9.125,
              "z": 1.068
            },
            "rightCorner": {
              "x": -11.217,
              "y": -9.127,
              "z": 1.068
            },
            "gtin": "8076809572569",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce7e",
        "height": 1.6067,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50e0",
            "leftCorner": {
              "x": -9.954,
              "y": -9.074,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.127,
              "y": -9.076,
              "z": 1.315
            },
            "gtin": "4306188000952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50e2",
            "leftCorner": {
              "x": -10.126,
              "y": -9.119,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.311,
              "y": -9.121,
              "z": 1.315
            },
            "gtin": "4306188000921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50e3",
            "leftCorner": {
              "x": -10.31,
              "y": -9.124,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.497,
              "y": -9.126,
              "z": 1.315
            },
            "gtin": "4306188017035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50e4",
            "leftCorner": {
              "x": -10.497,
              "y": -9.119,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.613,
              "y": -9.121,
              "z": 1.315
            },
            "gtin": "4104420257344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50e5",
            "leftCorner": {
              "x": -10.613,
              "y": -9.122,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.723,
              "y": -9.123,
              "z": 1.315
            },
            "gtin": "4104420031326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50e6",
            "leftCorner": {
              "x": -10.723,
              "y": -9.122,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.849,
              "y": -9.123,
              "z": 1.315
            },
            "gtin": "4250426223767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50e7",
            "leftCorner": {
              "x": -10.849,
              "y": -9.125,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.944,
              "y": -9.127,
              "z": 1.315
            },
            "gtin": "4250426223743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50e8",
            "leftCorner": {
              "x": -10.944,
              "y": -9.124,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.119,
              "y": -9.126,
              "z": 1.315
            },
            "gtin": "8005110001574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50e9",
            "leftCorner": {
              "x": -11.119,
              "y": -9.122,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.3,
              "y": -9.124,
              "z": 1.315
            },
            "gtin": "8005110001550",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "7cb"
  },
  {
    "id": "7bd",
    "name": "7bd",
    "x": -14.839,
    "y": 2.694,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99997,
      "w": 0.0078452
    },
    "layers": []
  },
  {
    "id": "7bf",
    "name": "7bf",
    "x": -17.482,
    "y": 2.662,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99999,
      "w": 0.0036826
    },
    "layers": []
  },
  {
    "id": "7c0",
    "name": "7c0",
    "x": -15.988,
    "y": -3.363,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0026442,
      "w": 1.0
    },
    "layers": []
  },
  {
    "id": "7c1",
    "name": "7c1",
    "x": -13.34,
    "y": -4.331,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 8.7266E-6,
      "w": 1.0
    },
    "layers": []
  },
  {
    "id": "7c2",
    "name": "7c2",
    "x": -10.468,
    "y": -3.856,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.013613,
      "w": 0.99991
    },
    "layers": []
  },
  {
    "id": "7cb",
    "name": "7cb",
    "x": -11.203,
    "y": -9.139,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0056636
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 51
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce89",
        "height": 0.17262,
        "facings": [
          {
            "id": "68d8e508e1820c81800d518d",
            "leftCorner": {
              "x": -12.459,
              "y": -9.075,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.995,
              "y": -9.081,
              "z": 0.141
            },
            "gtin": "4306188056171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c56557040852f0ac7f738a65",
            "leftCorner": {
              "x": -11.204,
              "y": -9.056,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.278,
              "y": -9.057,
              "z": 0.141
            },
            "gtin": "8076809582643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a5e56af752b68624c1028dd1",
            "leftCorner": {
              "x": -11.278,
              "y": -9.057,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.365,
              "y": -9.058,
              "z": 0.141
            },
            "gtin": "4008100168220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "59b1c785e976973b5783b3f8",
            "leftCorner": {
              "x": -11.365,
              "y": -9.058,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.454,
              "y": -9.059,
              "z": 0.141
            },
            "gtin": "8076809586177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f04e1c4e390f499cda603dcb",
            "leftCorner": {
              "x": -11.454,
              "y": -9.059,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.544,
              "y": -9.06,
              "z": 0.141
            },
            "gtin": "8076809545396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "caeacbf73a153509db1177a5",
            "leftCorner": {
              "x": -11.544,
              "y": -9.06,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.636,
              "y": -9.061,
              "z": 0.141
            },
            "gtin": "8076809581868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3309f540fd6074251f2cffb9",
            "leftCorner": {
              "x": -11.636,
              "y": -9.061,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.728,
              "y": -9.062,
              "z": 0.141
            },
            "gtin": "8076809580724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f6d5355e62038f0edbdd43f8",
            "leftCorner": {
              "x": -11.728,
              "y": -9.062,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.825,
              "y": -9.063,
              "z": 0.141
            },
            "gtin": "8076809513746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2e2f19f61b00a46527beb94f",
            "leftCorner": {
              "x": -11.825,
              "y": -9.063,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.927,
              "y": -9.064,
              "z": 0.141
            },
            "gtin": "4008100168688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7b42ac4b4b5d27924ef8f87e",
            "leftCorner": {
              "x": -11.927,
              "y": -9.064,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.03,
              "y": -9.066,
              "z": 0.141
            },
            "gtin": "8076809576574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fe7f7a061825aab3789f6f7f",
            "leftCorner": {
              "x": -12.03,
              "y": -9.066,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.153,
              "y": -9.067,
              "z": 0.141
            },
            "gtin": "8032793343424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cee8c52948dd46d0f9e873b6",
            "leftCorner": {
              "x": -12.153,
              "y": -9.067,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.406,
              "y": -9.07,
              "z": 0.141
            },
            "gtin": "4104420234857",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce85",
        "height": 0.4278,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5177",
            "leftCorner": {
              "x": -11.254,
              "y": -9.132,
              "z": 0.35
            },
            "rightCorner": {
              "x": -11.41,
              "y": -9.133,
              "z": 0.35
            },
            "gtin": "4038700117373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5178",
            "leftCorner": {
              "x": -11.41,
              "y": -9.14,
              "z": 0.35
            },
            "rightCorner": {
              "x": -11.665,
              "y": -9.143,
              "z": 0.35
            },
            "gtin": "4104420234857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5179",
            "leftCorner": {
              "x": -11.665,
              "y": -9.143,
              "z": 0.35
            },
            "rightCorner": {
              "x": -11.887,
              "y": -9.145,
              "z": 0.35
            },
            "gtin": "4104420244665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d517a",
            "leftCorner": {
              "x": -11.887,
              "y": -9.151,
              "z": 0.35
            },
            "rightCorner": {
              "x": -12.228,
              "y": -9.155,
              "z": 0.35
            },
            "gtin": "4104420244627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d517b",
            "leftCorner": {
              "x": -12.228,
              "y": -9.155,
              "z": 0.35
            },
            "rightCorner": {
              "x": -12.515,
              "y": -9.159,
              "z": 0.35
            },
            "gtin": "4250780324223",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce86",
        "height": 0.70103,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5112",
            "leftCorner": {
              "x": -11.236,
              "y": -9.128,
              "z": 0.574
            },
            "rightCorner": {
              "x": -11.412,
              "y": -9.13,
              "z": 0.574
            },
            "gtin": "4008100168046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5113",
            "leftCorner": {
              "x": -11.412,
              "y": -9.135,
              "z": 0.574
            },
            "rightCorner": {
              "x": -11.581,
              "y": -9.136,
              "z": 0.574
            },
            "gtin": "4008100168039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5114",
            "leftCorner": {
              "x": -11.581,
              "y": -9.139,
              "z": 0.574
            },
            "rightCorner": {
              "x": -11.819,
              "y": -9.141,
              "z": 0.574
            },
            "gtin": "40081243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5115",
            "leftCorner": {
              "x": -11.819,
              "y": -9.146,
              "z": 0.574
            },
            "rightCorner": {
              "x": -11.972,
              "y": -9.147,
              "z": 0.574
            },
            "gtin": "4008100168497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5116",
            "leftCorner": {
              "x": -11.972,
              "y": -9.15,
              "z": 0.574
            },
            "rightCorner": {
              "x": -12.155,
              "y": -9.152,
              "z": 0.574
            },
            "gtin": "8032793343462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5117",
            "leftCorner": {
              "x": -12.155,
              "y": -9.15,
              "z": 0.574
            },
            "rightCorner": {
              "x": -12.302,
              "y": -9.152,
              "z": 0.574
            },
            "gtin": "8005110060007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5118",
            "leftCorner": {
              "x": -12.302,
              "y": -9.149,
              "z": 0.574
            },
            "rightCorner": {
              "x": -12.489,
              "y": -9.151,
              "z": 0.574
            },
            "gtin": "80042556",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce87",
        "height": 1.0018,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5157",
            "leftCorner": {
              "x": -11.217,
              "y": -9.125,
              "z": 0.82
            },
            "rightCorner": {
              "x": -11.365,
              "y": -9.127,
              "z": 0.82
            },
            "gtin": "4008100168466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5158",
            "leftCorner": {
              "x": -11.365,
              "y": -9.132,
              "z": 0.82
            },
            "rightCorner": {
              "x": -11.475,
              "y": -9.134,
              "z": 0.82
            },
            "gtin": "40081236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5159",
            "leftCorner": {
              "x": -11.475,
              "y": -9.134,
              "z": 0.82
            },
            "rightCorner": {
              "x": -11.586,
              "y": -9.135,
              "z": 0.82
            },
            "gtin": "40081236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d515a",
            "leftCorner": {
              "x": -11.586,
              "y": -9.138,
              "z": 0.82
            },
            "rightCorner": {
              "x": -11.741,
              "y": -9.139,
              "z": 0.82
            },
            "gtin": "4008100168244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d515b",
            "leftCorner": {
              "x": -11.741,
              "y": -9.139,
              "z": 0.82
            },
            "rightCorner": {
              "x": -11.903,
              "y": -9.141,
              "z": 0.82
            },
            "gtin": "4008100168473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d515c",
            "leftCorner": {
              "x": -11.903,
              "y": -9.147,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.055,
              "y": -9.149,
              "z": 0.82
            },
            "gtin": "4008100168480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d515d",
            "leftCorner": {
              "x": -12.055,
              "y": -9.149,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.21,
              "y": -9.15,
              "z": 0.82
            },
            "gtin": "4008100169234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d515e",
            "leftCorner": {
              "x": -12.21,
              "y": -9.149,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.367,
              "y": -9.151,
              "z": 0.82
            },
            "gtin": "4008100168237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d515f",
            "leftCorner": {
              "x": -12.367,
              "y": -9.148,
              "z": 0.82
            },
            "rightCorner": {
              "x": -12.618,
              "y": -9.151,
              "z": 0.82
            },
            "gtin": "4008100168220",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce84",
        "height": 1.3073,
        "facings": [
          {
            "id": "68d8e508e1820c81800d512d",
            "leftCorner": {
              "x": -11.217,
              "y": -9.126,
              "z": 1.07
            },
            "rightCorner": {
              "x": -11.318,
              "y": -9.127,
              "z": 1.07
            },
            "gtin": "8076809576574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d512e",
            "leftCorner": {
              "x": -11.318,
              "y": -9.132,
              "z": 1.07
            },
            "rightCorner": {
              "x": -11.41,
              "y": -9.133,
              "z": 1.07
            },
            "gtin": "8076809580724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d512f",
            "leftCorner": {
              "x": -11.41,
              "y": -9.133,
              "z": 1.07
            },
            "rightCorner": {
              "x": -11.502,
              "y": -9.134,
              "z": 1.07
            },
            "gtin": "8076809586177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5130",
            "leftCorner": {
              "x": -11.502,
              "y": -9.135,
              "z": 1.07
            },
            "rightCorner": {
              "x": -11.648,
              "y": -9.137,
              "z": 1.07
            },
            "gtin": "8076809582643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5131",
            "leftCorner": {
              "x": -11.648,
              "y": -9.141,
              "z": 1.07
            },
            "rightCorner": {
              "x": -11.845,
              "y": -9.144,
              "z": 1.07
            },
            "gtin": "8076809513746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5132",
            "leftCorner": {
              "x": -11.845,
              "y": -9.147,
              "z": 1.07
            },
            "rightCorner": {
              "x": -11.935,
              "y": -9.148,
              "z": 1.07
            },
            "gtin": "8076809545396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5133",
            "leftCorner": {
              "x": -11.935,
              "y": -9.147,
              "z": 1.07
            },
            "rightCorner": {
              "x": -12.026,
              "y": -9.148,
              "z": 1.07
            },
            "gtin": "8076809581868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5134",
            "leftCorner": {
              "x": -12.026,
              "y": -9.15,
              "z": 1.07
            },
            "rightCorner": {
              "x": -12.168,
              "y": -9.152,
              "z": 1.07
            },
            "gtin": "4008100169371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5135",
            "leftCorner": {
              "x": -12.168,
              "y": -9.153,
              "z": 1.07
            },
            "rightCorner": {
              "x": -12.326,
              "y": -9.155,
              "z": 1.07
            },
            "gtin": "4008100169401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5136",
            "leftCorner": {
              "x": -12.326,
              "y": -9.153,
              "z": 1.07
            },
            "rightCorner": {
              "x": -12.503,
              "y": -9.155,
              "z": 1.07
            },
            "gtin": "4008100169395",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce88",
        "height": 1.6076,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50ea",
            "leftCorner": {
              "x": -11.3,
              "y": -9.124,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.441,
              "y": -9.126,
              "z": 1.315
            },
            "gtin": "40081076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50eb",
            "leftCorner": {
              "x": -11.441,
              "y": -9.13,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.578,
              "y": -9.131,
              "z": 1.315
            },
            "gtin": "4008100168763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50ec",
            "leftCorner": {
              "x": -11.578,
              "y": -9.13,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.68,
              "y": -9.131,
              "z": 1.315
            },
            "gtin": "4008100168688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50ed",
            "leftCorner": {
              "x": -11.68,
              "y": -9.133,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.829,
              "y": -9.135,
              "z": 1.315
            },
            "gtin": "4008100169333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50ee",
            "leftCorner": {
              "x": -11.829,
              "y": -9.129,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.954,
              "y": -9.13,
              "z": 1.315
            },
            "gtin": "8032793343424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50ef",
            "leftCorner": {
              "x": -11.954,
              "y": -9.148,
              "z": 1.315
            },
            "rightCorner": {
              "x": -12.13,
              "y": -9.15,
              "z": 1.315
            },
            "gtin": "4008100164635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50f0",
            "leftCorner": {
              "x": -12.13,
              "y": -9.151,
              "z": 1.315
            },
            "rightCorner": {
              "x": -12.318,
              "y": -9.153,
              "z": 1.315
            },
            "gtin": "4306188032533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50f1",
            "leftCorner": {
              "x": -12.318,
              "y": -9.149,
              "z": 1.315
            },
            "rightCorner": {
              "x": -12.512,
              "y": -9.151,
              "z": 1.315
            },
            "gtin": "4104420180918",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7b9",
    "rightNeighborShelfId": "7cc"
  },
  {
    "id": "7cc",
    "name": "7cc",
    "x": -12.453,
    "y": -9.153,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0056636
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce8f",
        "height": 0.17717,
        "facings": [
          {
            "id": "b548f3535d2bd1d74ebd8683",
            "leftCorner": {
              "x": -12.453,
              "y": -9.058,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.566,
              "y": -9.059,
              "z": 0.145
            },
            "gtin": "3487400006387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fe824c669a79141cf0f7d0d0",
            "leftCorner": {
              "x": -12.566,
              "y": -9.059,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.682,
              "y": -9.061,
              "z": 0.145
            },
            "gtin": "3487400006400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8c102318a16b7e00fb880abe",
            "leftCorner": {
              "x": -12.682,
              "y": -9.061,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.8,
              "y": -9.062,
              "z": 0.145
            },
            "gtin": "40045122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a10f1e10e26715e1c0a384e6",
            "leftCorner": {
              "x": -12.8,
              "y": -9.062,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.926,
              "y": -9.064,
              "z": 0.145
            },
            "gtin": "3487400006394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fd00f1534c67883026cb41e0",
            "leftCorner": {
              "x": -12.926,
              "y": -9.064,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.054,
              "y": -9.065,
              "z": 0.145
            },
            "gtin": "5010034011946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "88e48bc5cfaefa7fd009539a",
            "leftCorner": {
              "x": -13.054,
              "y": -9.065,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.182,
              "y": -9.066,
              "z": 0.145
            },
            "gtin": "8005110551215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6e61b3d90942e00f1dd4b52b",
            "leftCorner": {
              "x": -13.182,
              "y": -9.066,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.316,
              "y": -9.068,
              "z": 0.145
            },
            "gtin": "5010034014756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7a3478ab186fb7fce4dd26e5",
            "leftCorner": {
              "x": -13.316,
              "y": -9.068,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.454,
              "y": -9.07,
              "z": 0.145
            },
            "gtin": "3487400006318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2b17af2a1ace0f36473f0b21",
            "leftCorner": {
              "x": -13.454,
              "y": -9.07,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.692,
              "y": -9.072,
              "z": 0.145
            },
            "gtin": "4306188347910",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce8e",
        "height": 0.43337,
        "facings": [
          {
            "id": "68d8e508e1820c81800d517c",
            "leftCorner": {
              "x": -12.515,
              "y": -9.147,
              "z": 0.355
            },
            "rightCorner": {
              "x": -13.23,
              "y": -9.155,
              "z": 0.355
            },
            "gtin": "5410673004444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d517d",
            "leftCorner": {
              "x": -13.23,
              "y": -9.155,
              "z": 0.355
            },
            "rightCorner": {
              "x": -13.501,
              "y": -9.158,
              "z": 0.355
            },
            "gtin": "5410673004437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d517e",
            "leftCorner": {
              "x": -13.501,
              "y": -9.168,
              "z": 0.355
            },
            "rightCorner": {
              "x": -13.725,
              "y": -9.17,
              "z": 0.355
            },
            "gtin": "4000286004668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d517f",
            "leftCorner": {
              "x": -13.725,
              "y": -9.17,
              "z": 0.355
            },
            "rightCorner": {
              "x": -13.95,
              "y": -9.173,
              "z": 0.355
            },
            "gtin": "4000286004668",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce8a",
        "height": 0.7049,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5119",
            "leftCorner": {
              "x": -12.489,
              "y": -9.146,
              "z": 0.577
            },
            "rightCorner": {
              "x": -12.616,
              "y": -9.148,
              "z": 0.577
            },
            "gtin": "8005110551215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d511a",
            "leftCorner": {
              "x": -12.616,
              "y": -9.144,
              "z": 0.577
            },
            "rightCorner": {
              "x": -12.893,
              "y": -9.147,
              "z": 0.577
            },
            "gtin": "4306188056720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d511b",
            "leftCorner": {
              "x": -12.893,
              "y": -9.147,
              "z": 0.577
            },
            "rightCorner": {
              "x": -13.225,
              "y": -9.151,
              "z": 0.577
            },
            "gtin": "5410673004307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d511c",
            "leftCorner": {
              "x": -13.225,
              "y": -9.155,
              "z": 0.577
            },
            "rightCorner": {
              "x": -13.503,
              "y": -9.158,
              "z": 0.577
            },
            "gtin": "5410673004314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d511d",
            "leftCorner": {
              "x": -13.503,
              "y": -9.162,
              "z": 0.577
            },
            "rightCorner": {
              "x": -14.133,
              "y": -9.169,
              "z": 0.577
            },
            "gtin": "4006237090117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce8c",
        "height": 1.0085,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5160",
            "leftCorner": {
              "x": -12.617,
              "y": -9.145,
              "z": 0.825
            },
            "rightCorner": {
              "x": -12.767,
              "y": -9.147,
              "z": 0.825
            },
            "gtin": "3487400006325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "87b16f53ad8c1ccf35a3147a",
            "leftCorner": {
              "x": -12.454,
              "y": -9.104,
              "z": 0.825
            },
            "rightCorner": {
              "x": -12.599,
              "y": -9.105,
              "z": 0.825
            },
            "gtin": "3487400006325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5161",
            "leftCorner": {
              "x": -12.768,
              "y": -9.138,
              "z": 0.825
            },
            "rightCorner": {
              "x": -12.912,
              "y": -9.139,
              "z": 0.825
            },
            "gtin": "3487400006318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5162",
            "leftCorner": {
              "x": -12.912,
              "y": -9.141,
              "z": 0.825
            },
            "rightCorner": {
              "x": -13.208,
              "y": -9.144,
              "z": 0.825
            },
            "gtin": "3487400006332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5163",
            "leftCorner": {
              "x": -13.208,
              "y": -9.154,
              "z": 0.825
            },
            "rightCorner": {
              "x": -13.425,
              "y": -9.156,
              "z": 0.825
            },
            "gtin": "3487400006370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5164",
            "leftCorner": {
              "x": -13.425,
              "y": -9.16,
              "z": 0.825
            },
            "rightCorner": {
              "x": -13.73,
              "y": -9.164,
              "z": 0.825
            },
            "gtin": "3487400006356",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce8b",
        "height": 1.3117,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5137",
            "leftCorner": {
              "x": -12.502,
              "y": -9.146,
              "z": 1.073
            },
            "rightCorner": {
              "x": -12.614,
              "y": -9.148,
              "z": 1.073
            },
            "gtin": "40045122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5138",
            "leftCorner": {
              "x": -12.614,
              "y": -9.147,
              "z": 1.073
            },
            "rightCorner": {
              "x": -12.723,
              "y": -9.148,
              "z": 1.073
            },
            "gtin": "3487400006400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5139",
            "leftCorner": {
              "x": -12.723,
              "y": -9.148,
              "z": 1.073
            },
            "rightCorner": {
              "x": -12.852,
              "y": -9.15,
              "z": 1.073
            },
            "gtin": "3487400006394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d513a",
            "leftCorner": {
              "x": -12.852,
              "y": -9.143,
              "z": 1.073
            },
            "rightCorner": {
              "x": -12.99,
              "y": -9.145,
              "z": 1.073
            },
            "gtin": "5010034014756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d513b",
            "leftCorner": {
              "x": -12.99,
              "y": -9.15,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.124,
              "y": -9.151,
              "z": 1.073
            },
            "gtin": "5010034011946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d513c",
            "leftCorner": {
              "x": -13.124,
              "y": -9.153,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.276,
              "y": -9.155,
              "z": 1.073
            },
            "gtin": "5010034014749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d513d",
            "leftCorner": {
              "x": -13.276,
              "y": -9.155,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.425,
              "y": -9.156,
              "z": 1.073
            },
            "gtin": "5010034015180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d513e",
            "leftCorner": {
              "x": -13.425,
              "y": -9.148,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.586,
              "y": -9.15,
              "z": 1.073
            },
            "gtin": "3487400006349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d513f",
            "leftCorner": {
              "x": -13.586,
              "y": -9.163,
              "z": 1.073
            },
            "rightCorner": {
              "x": -13.729,
              "y": -9.165,
              "z": 1.073
            },
            "gtin": "3487400006387",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce8d",
        "height": 1.6124,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50f2",
            "leftCorner": {
              "x": -12.511,
              "y": -9.14,
              "z": 1.319
            },
            "rightCorner": {
              "x": -12.771,
              "y": -9.143,
              "z": 1.319
            },
            "gtin": "4306188347910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50f3",
            "leftCorner": {
              "x": -12.771,
              "y": -9.143,
              "z": 1.319
            },
            "rightCorner": {
              "x": -12.928,
              "y": -9.145,
              "z": 1.319
            },
            "gtin": "4002359015229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50f4",
            "leftCorner": {
              "x": -12.928,
              "y": -9.12,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.076,
              "y": -9.122,
              "z": 1.319
            },
            "gtin": "4002359015250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50f5",
            "leftCorner": {
              "x": -13.075,
              "y": -9.146,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.232,
              "y": -9.148,
              "z": 1.319
            },
            "gtin": "4002359015267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50f6",
            "leftCorner": {
              "x": -13.232,
              "y": -9.149,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.393,
              "y": -9.151,
              "z": 1.319
            },
            "gtin": "4002359015168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50f7",
            "leftCorner": {
              "x": -13.393,
              "y": -9.157,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.535,
              "y": -9.158,
              "z": 1.319
            },
            "gtin": "4008585103143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50f8",
            "leftCorner": {
              "x": -13.535,
              "y": -9.161,
              "z": 1.319
            },
            "rightCorner": {
              "x": -13.715,
              "y": -9.163,
              "z": 1.319
            },
            "gtin": "4008585103150",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7cb",
    "rightNeighborShelfId": "7cd"
  },
  {
    "id": "7cd",
    "name": "7cd",
    "x": -13.703,
    "y": -9.167,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0056636
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 53
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce95",
        "height": 0.16805,
        "facings": [
          {
            "id": "6e7470072932960576d2c9f9",
            "leftCorner": {
              "x": -13.704,
              "y": -9.099,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.739,
              "y": -9.099,
              "z": 0.137
            },
            "gtin": "4250780321802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fb641e5fbd542d70b96b2ba2",
            "leftCorner": {
              "x": -13.739,
              "y": -9.099,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.786,
              "y": -9.1,
              "z": 0.137
            },
            "gtin": "5902609000472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d5b4a484a7a42698e20ea9b0",
            "leftCorner": {
              "x": -13.786,
              "y": -9.1,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.871,
              "y": -9.101,
              "z": 0.137
            },
            "gtin": "4000286004729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0b77da44783496ab74227e62",
            "leftCorner": {
              "x": -13.871,
              "y": -9.101,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.956,
              "y": -9.102,
              "z": 0.137
            },
            "gtin": "4000286004682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9ebeff9fb87856c65261cb2d",
            "leftCorner": {
              "x": -13.956,
              "y": -9.102,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.051,
              "y": -9.103,
              "z": 0.137
            },
            "gtin": "4000286004705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9e64181fbff45386b20061a4",
            "leftCorner": {
              "x": -14.051,
              "y": -9.103,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.149,
              "y": -9.104,
              "z": 0.137
            },
            "gtin": "4250780321840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "40d41074fffaa46939801779",
            "leftCorner": {
              "x": -14.149,
              "y": -9.104,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.249,
              "y": -9.105,
              "z": 0.137
            },
            "gtin": "4250426221947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1440a6a5f36ec5dc1a120e1f",
            "leftCorner": {
              "x": -14.249,
              "y": -9.105,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.352,
              "y": -9.106,
              "z": 0.137
            },
            "gtin": "4104420241275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dbfc99a8e68fe32361499784",
            "leftCorner": {
              "x": -14.352,
              "y": -9.106,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.456,
              "y": -9.108,
              "z": 0.137
            },
            "gtin": "4104420115804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3db4b7ad07ad78b5697c33d6",
            "leftCorner": {
              "x": -14.456,
              "y": -9.108,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.563,
              "y": -9.109,
              "z": 0.137
            },
            "gtin": "4104420241565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e2100565a8b0e528a5fe91a0",
            "leftCorner": {
              "x": -14.563,
              "y": -9.109,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.67,
              "y": -9.11,
              "z": 0.137
            },
            "gtin": "4104420241596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2368b1b2a8c48d57de26f2b1",
            "leftCorner": {
              "x": -14.67,
              "y": -9.11,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.95,
              "y": -9.113,
              "z": 0.137
            },
            "gtin": "8693374257273",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce93",
        "height": 0.42955,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5180",
            "leftCorner": {
              "x": -13.951,
              "y": -9.166,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.263,
              "y": -9.17,
              "z": 0.351
            },
            "gtin": "4000286004620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5181",
            "leftCorner": {
              "x": -14.263,
              "y": -9.167,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.41,
              "y": -9.169,
              "z": 0.351
            },
            "gtin": "4250426221909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5182",
            "leftCorner": {
              "x": -14.41,
              "y": -9.168,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.54,
              "y": -9.17,
              "z": 0.351
            },
            "gtin": "4250426221923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5183",
            "leftCorner": {
              "x": -14.54,
              "y": -9.17,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.736,
              "y": -9.173,
              "z": 0.351
            },
            "gtin": "4250426221961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5184",
            "leftCorner": {
              "x": -14.736,
              "y": -9.174,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.841,
              "y": -9.175,
              "z": 0.351
            },
            "gtin": "4250426221947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5172",
            "leftCorner": {
              "x": -14.841,
              "y": -9.179,
              "z": 0.351
            },
            "rightCorner": {
              "x": -14.953,
              "y": -9.18,
              "z": 0.351
            },
            "gtin": "4306188056218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "160c88c8b36b450b4627b839",
            "leftCorner": {
              "x": -13.704,
              "y": -9.122,
              "z": 0.351
            },
            "rightCorner": {
              "x": -13.901,
              "y": -9.124,
              "z": 0.351
            },
            "gtin": "4250426221961",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce94",
        "height": 0.70305,
        "facings": [
          {
            "id": "68d8e508e1820c81800d511e",
            "leftCorner": {
              "x": -14.134,
              "y": -9.165,
              "z": 0.575
            },
            "rightCorner": {
              "x": -14.407,
              "y": -9.168,
              "z": 0.575
            },
            "gtin": "4006237090025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d6a68ed0a33c4e46e0768365",
            "leftCorner": {
              "x": -13.704,
              "y": -9.124,
              "z": 0.575
            },
            "rightCorner": {
              "x": -13.971,
              "y": -9.127,
              "z": 0.575
            },
            "gtin": "4006237090025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d511f",
            "leftCorner": {
              "x": -14.407,
              "y": -9.172,
              "z": 0.575
            },
            "rightCorner": {
              "x": -14.685,
              "y": -9.175,
              "z": 0.575
            },
            "gtin": "8693374257273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5120",
            "leftCorner": {
              "x": -14.685,
              "y": -9.176,
              "z": 0.575
            },
            "rightCorner": {
              "x": -14.992,
              "y": -9.18,
              "z": 0.575
            },
            "gtin": "8693374257235",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce92",
        "height": 1.0058,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5165",
            "leftCorner": {
              "x": -13.731,
              "y": -9.161,
              "z": 0.823
            },
            "rightCorner": {
              "x": -13.923,
              "y": -9.163,
              "z": 0.823
            },
            "gtin": "4002359021664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5166",
            "leftCorner": {
              "x": -13.923,
              "y": -9.163,
              "z": 0.823
            },
            "rightCorner": {
              "x": -14.055,
              "y": -9.164,
              "z": 0.823
            },
            "gtin": "4006237620017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5167",
            "leftCorner": {
              "x": -14.055,
              "y": -9.168,
              "z": 0.823
            },
            "rightCorner": {
              "x": -14.188,
              "y": -9.169,
              "z": 0.823
            },
            "gtin": "4006237630016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5168",
            "leftCorner": {
              "x": -14.188,
              "y": -9.167,
              "z": 0.823
            },
            "rightCorner": {
              "x": -14.352,
              "y": -9.169,
              "z": 0.823
            },
            "gtin": "4006237642767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5169",
            "leftCorner": {
              "x": -14.352,
              "y": -9.17,
              "z": 0.823
            },
            "rightCorner": {
              "x": -14.554,
              "y": -9.172,
              "z": 0.823
            },
            "gtin": "4000286004705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d516a",
            "leftCorner": {
              "x": -14.554,
              "y": -9.172,
              "z": 0.823
            },
            "rightCorner": {
              "x": -14.638,
              "y": -9.172,
              "z": 0.823
            },
            "gtin": "4000286004682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d516b",
            "leftCorner": {
              "x": -14.638,
              "y": -9.171,
              "z": 0.823
            },
            "rightCorner": {
              "x": -14.749,
              "y": -9.173,
              "z": 0.823
            },
            "gtin": "4000286004644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d516c",
            "leftCorner": {
              "x": -14.748,
              "y": -9.175,
              "z": 0.823
            },
            "rightCorner": {
              "x": -14.839,
              "y": -9.175,
              "z": 0.823
            },
            "gtin": "4000286004729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d516d",
            "leftCorner": {
              "x": -14.839,
              "y": -9.172,
              "z": 0.823
            },
            "rightCorner": {
              "x": -14.975,
              "y": -9.174,
              "z": 0.823
            },
            "gtin": "4000286004743",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce91",
        "height": 1.3106,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5140",
            "leftCorner": {
              "x": -13.73,
              "y": -9.157,
              "z": 1.072
            },
            "rightCorner": {
              "x": -13.906,
              "y": -9.159,
              "z": 1.072
            },
            "gtin": "4002359021640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5141",
            "leftCorner": {
              "x": -13.906,
              "y": -9.162,
              "z": 1.072
            },
            "rightCorner": {
              "x": -14.041,
              "y": -9.163,
              "z": 1.072
            },
            "gtin": "4006237640312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5142",
            "leftCorner": {
              "x": -14.041,
              "y": -9.161,
              "z": 1.072
            },
            "rightCorner": {
              "x": -14.179,
              "y": -9.163,
              "z": 1.072
            },
            "gtin": "4006237640404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5143",
            "leftCorner": {
              "x": -14.179,
              "y": -9.166,
              "z": 1.072
            },
            "rightCorner": {
              "x": -14.335,
              "y": -9.168,
              "z": 1.072
            },
            "gtin": "4006237640336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5144",
            "leftCorner": {
              "x": -14.335,
              "y": -9.169,
              "z": 1.072
            },
            "rightCorner": {
              "x": -14.485,
              "y": -9.171,
              "z": 1.072
            },
            "gtin": "4104420247659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5145",
            "leftCorner": {
              "x": -14.485,
              "y": -9.17,
              "z": 1.072
            },
            "rightCorner": {
              "x": -14.595,
              "y": -9.171,
              "z": 1.072
            },
            "gtin": "4104420029569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5146",
            "leftCorner": {
              "x": -14.595,
              "y": -9.172,
              "z": 1.072
            },
            "rightCorner": {
              "x": -14.697,
              "y": -9.173,
              "z": 1.072
            },
            "gtin": "4104420115804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5147",
            "leftCorner": {
              "x": -14.697,
              "y": -9.172,
              "z": 1.072
            },
            "rightCorner": {
              "x": -14.799,
              "y": -9.173,
              "z": 1.072
            },
            "gtin": "4250780321826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5148",
            "leftCorner": {
              "x": -14.799,
              "y": -9.172,
              "z": 1.072
            },
            "rightCorner": {
              "x": -14.908,
              "y": -9.174,
              "z": 1.072
            },
            "gtin": "4250780321840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5149",
            "leftCorner": {
              "x": -14.908,
              "y": -9.176,
              "z": 1.072
            },
            "rightCorner": {
              "x": -15.006,
              "y": -9.177,
              "z": 1.072
            },
            "gtin": "5902609000472",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce90",
        "height": 1.6115,
        "facings": [
          {
            "id": "68d8e508e1820c81800d50f9",
            "leftCorner": {
              "x": -13.717,
              "y": -9.156,
              "z": 1.318
            },
            "rightCorner": {
              "x": -13.805,
              "y": -9.157,
              "z": 1.318
            },
            "gtin": "4008585103136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50fa",
            "leftCorner": {
              "x": -13.805,
              "y": -9.157,
              "z": 1.318
            },
            "rightCorner": {
              "x": -13.894,
              "y": -9.158,
              "z": 1.318
            },
            "gtin": "4008585103136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50fb",
            "leftCorner": {
              "x": -13.894,
              "y": -9.157,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.061,
              "y": -9.159,
              "z": 1.318
            },
            "gtin": "3487400000415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50fc",
            "leftCorner": {
              "x": -14.061,
              "y": -9.163,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.186,
              "y": -9.164,
              "z": 1.318
            },
            "gtin": "3487400000019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50fd",
            "leftCorner": {
              "x": -14.186,
              "y": -9.163,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.328,
              "y": -9.165,
              "z": 1.318
            },
            "gtin": "4000950576026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50fe",
            "leftCorner": {
              "x": -14.328,
              "y": -9.166,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.449,
              "y": -9.168,
              "z": 1.318
            },
            "gtin": "4104420016460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50ff",
            "leftCorner": {
              "x": -14.449,
              "y": -9.166,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.553,
              "y": -9.168,
              "z": 1.318
            },
            "gtin": "4104420241275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5100",
            "leftCorner": {
              "x": -14.553,
              "y": -9.168,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.658,
              "y": -9.169,
              "z": 1.318
            },
            "gtin": "4104420241565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5101",
            "leftCorner": {
              "x": -14.658,
              "y": -9.17,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.764,
              "y": -9.171,
              "z": 1.318
            },
            "gtin": "4104420241596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5102",
            "leftCorner": {
              "x": -14.764,
              "y": -9.172,
              "z": 1.318
            },
            "rightCorner": {
              "x": -14.922,
              "y": -9.174,
              "z": 1.318
            },
            "gtin": "4104420241244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5103",
            "leftCorner": {
              "x": -14.922,
              "y": -9.17,
              "z": 1.318
            },
            "rightCorner": {
              "x": -15.039,
              "y": -9.172,
              "z": 1.318
            },
            "gtin": "4250780321802",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7cc",
    "rightNeighborShelfId": "7ce"
  },
  {
    "id": "7ce",
    "name": "7ce",
    "x": -14.953,
    "y": -9.182,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0056636
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce9b",
        "height": 0.16634,
        "facings": [
          {
            "id": "9643ed20951f81e41daeddab",
            "leftCorner": {
              "x": -14.954,
              "y": -9.115,
              "z": 0.136
            },
            "rightCorner": {
              "x": -15.069,
              "y": -9.116,
              "z": 0.136
            },
            "gtin": "4000400130655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6bfd3d741f9326f95aa94579",
            "leftCorner": {
              "x": -15.069,
              "y": -9.116,
              "z": 0.136
            },
            "rightCorner": {
              "x": -15.187,
              "y": -9.118,
              "z": 0.136
            },
            "gtin": "4000400130815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "48554b994acdc803ee87f2bf",
            "leftCorner": {
              "x": -15.187,
              "y": -9.118,
              "z": 0.136
            },
            "rightCorner": {
              "x": -15.343,
              "y": -9.119,
              "z": 0.136
            },
            "gtin": "4000400121868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "41da36bad1aa1b4ae173f2c6",
            "leftCorner": {
              "x": -15.343,
              "y": -9.119,
              "z": 0.136
            },
            "rightCorner": {
              "x": -15.502,
              "y": -9.121,
              "z": 0.136
            },
            "gtin": "4032600122086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "881df0d20ddb164842d39c5f",
            "leftCorner": {
              "x": -15.502,
              "y": -9.121,
              "z": 0.136
            },
            "rightCorner": {
              "x": -15.701,
              "y": -9.123,
              "z": 0.136
            },
            "gtin": "4032600123014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "16c42110561bf43739cebeeb",
            "leftCorner": {
              "x": -15.701,
              "y": -9.123,
              "z": 0.136
            },
            "rightCorner": {
              "x": -15.907,
              "y": -9.126,
              "z": 0.136
            },
            "gtin": "4306188047056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6e52945b02e2c6fac64aa466",
            "leftCorner": {
              "x": -15.907,
              "y": -9.126,
              "z": 0.136
            },
            "rightCorner": {
              "x": -16.199,
              "y": -9.129,
              "z": 0.136
            },
            "gtin": "8712566434084",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce9a",
        "height": 0.41696,
        "facings": [
          {
            "id": "68d8e508e1820c81800d519d",
            "leftCorner": {
              "x": -14.954,
              "y": -9.144,
              "z": 0.341
            },
            "rightCorner": {
              "x": -15.333,
              "y": -9.149,
              "z": 0.341
            },
            "gtin": "4032600122185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d519f",
            "leftCorner": {
              "x": -15.333,
              "y": -9.185,
              "z": 0.341
            },
            "rightCorner": {
              "x": -15.64,
              "y": -9.188,
              "z": 0.341
            },
            "gtin": "4000400124968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d519e",
            "leftCorner": {
              "x": -15.64,
              "y": -9.196,
              "z": 0.341
            },
            "rightCorner": {
              "x": -16.203,
              "y": -9.202,
              "z": 0.341
            },
            "gtin": "4306188300533",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce99",
        "height": 0.70061,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5121",
            "leftCorner": {
              "x": -14.992,
              "y": -9.176,
              "z": 0.573
            },
            "rightCorner": {
              "x": -15.279,
              "y": -9.18,
              "z": 0.573
            },
            "gtin": "8712566434084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5122",
            "leftCorner": {
              "x": -15.279,
              "y": -9.182,
              "z": 0.573
            },
            "rightCorner": {
              "x": -15.434,
              "y": -9.183,
              "z": 0.573
            },
            "gtin": "4032600122086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5123",
            "leftCorner": {
              "x": -15.434,
              "y": -9.189,
              "z": 0.573
            },
            "rightCorner": {
              "x": -15.817,
              "y": -9.193,
              "z": 0.573
            },
            "gtin": "4000400130693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5109",
            "leftCorner": {
              "x": -15.817,
              "y": -9.194,
              "z": 0.573
            },
            "rightCorner": {
              "x": -16.203,
              "y": -9.199,
              "z": 0.573
            },
            "gtin": "4032600122055",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce97",
        "height": 1.0042,
        "facings": [
          {
            "id": "68d8e508e1820c81800d516e",
            "leftCorner": {
              "x": -14.976,
              "y": -9.168,
              "z": 0.822
            },
            "rightCorner": {
              "x": -15.099,
              "y": -9.169,
              "z": 0.822
            },
            "gtin": "4000400130655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d516f",
            "leftCorner": {
              "x": -15.099,
              "y": -9.174,
              "z": 0.822
            },
            "rightCorner": {
              "x": -15.512,
              "y": -9.178,
              "z": 0.822
            },
            "gtin": "4000400130570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5170",
            "leftCorner": {
              "x": -15.512,
              "y": -9.188,
              "z": 0.822
            },
            "rightCorner": {
              "x": -15.813,
              "y": -9.192,
              "z": 0.822
            },
            "gtin": "4306188002192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d514f",
            "leftCorner": {
              "x": -15.813,
              "y": -9.194,
              "z": 0.822
            },
            "rightCorner": {
              "x": -16.203,
              "y": -9.198,
              "z": 0.822
            },
            "gtin": "4306188002161",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce96",
        "height": 1.3082,
        "facings": [
          {
            "id": "68d8e508e1820c81800d514a",
            "leftCorner": {
              "x": -15.007,
              "y": -9.175,
              "z": 1.07
            },
            "rightCorner": {
              "x": -15.119,
              "y": -9.176,
              "z": 1.07
            },
            "gtin": "4000400130815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d514b",
            "leftCorner": {
              "x": -15.119,
              "y": -9.174,
              "z": 1.07
            },
            "rightCorner": {
              "x": -15.398,
              "y": -9.177,
              "z": 1.07
            },
            "gtin": "4000400130495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d514c",
            "leftCorner": {
              "x": -15.398,
              "y": -9.188,
              "z": 1.07
            },
            "rightCorner": {
              "x": -15.699,
              "y": -9.191,
              "z": 1.07
            },
            "gtin": "4032600004337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d514d",
            "leftCorner": {
              "x": -15.699,
              "y": -9.197,
              "z": 1.07
            },
            "rightCorner": {
              "x": -15.938,
              "y": -9.2,
              "z": 1.07
            },
            "gtin": "4005500325352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5125",
            "leftCorner": {
              "x": -15.938,
              "y": -9.199,
              "z": 1.07
            },
            "rightCorner": {
              "x": -16.203,
              "y": -9.202,
              "z": 1.07
            },
            "gtin": "4005500325154",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce98",
        "height": 1.6091,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5104",
            "leftCorner": {
              "x": -15.039,
              "y": -9.174,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.236,
              "y": -9.176,
              "z": 1.317
            },
            "gtin": "4032600123014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5105",
            "leftCorner": {
              "x": -15.236,
              "y": -9.176,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.391,
              "y": -9.178,
              "z": 1.317
            },
            "gtin": "4000400121868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5106",
            "leftCorner": {
              "x": -15.39,
              "y": -9.186,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.759,
              "y": -9.19,
              "z": 1.317
            },
            "gtin": "4306188047063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5107",
            "leftCorner": {
              "x": -15.759,
              "y": -9.195,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.961,
              "y": -9.197,
              "z": 1.317
            },
            "gtin": "4306188047056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d50e1",
            "leftCorner": {
              "x": -15.961,
              "y": -9.193,
              "z": 1.317
            },
            "rightCorner": {
              "x": -16.203,
              "y": -9.195,
              "z": 1.317
            },
            "gtin": "4306188377375",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7cd"
  },
  {
    "id": "7cf",
    "name": "7cf",
    "x": -16.224,
    "y": -10.465,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0029496,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 43
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d60e",
        "height": 0.17061,
        "facings": [
          {
            "id": "06c0a8a8258053f1f6c66899",
            "leftCorner": {
              "x": -16.225,
              "y": -10.3,
              "z": 0.14
            },
            "rightCorner": {
              "x": -16.124,
              "y": -10.299,
              "z": 0.14
            },
            "gtin": "4000339457724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9af42513c000db249b111df5",
            "leftCorner": {
              "x": -16.124,
              "y": -10.299,
              "z": 0.14
            },
            "rightCorner": {
              "x": -16.065,
              "y": -10.299,
              "z": 0.14
            },
            "gtin": "40052373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "faf6cfa1e34339128da1d3d4",
            "leftCorner": {
              "x": -16.065,
              "y": -10.299,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.982,
              "y": -10.299,
              "z": 0.14
            },
            "gtin": "8413412220133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b6926c6bfb84e770045091cc",
            "leftCorner": {
              "x": -15.982,
              "y": -10.299,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.888,
              "y": -10.298,
              "z": 0.14
            },
            "gtin": "4030800082032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "288acf8f9b5e3b3b97758bb0",
            "leftCorner": {
              "x": -15.888,
              "y": -10.298,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.792,
              "y": -10.297,
              "z": 0.14
            },
            "gtin": "40122137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5355b38b110ab0d44a6fd9e8",
            "leftCorner": {
              "x": -15.792,
              "y": -10.297,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.692,
              "y": -10.297,
              "z": 0.14
            },
            "gtin": "4000515905155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d9a8127ddefa30bd59db375a",
            "leftCorner": {
              "x": -15.692,
              "y": -10.297,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.591,
              "y": -10.296,
              "z": 0.14
            },
            "gtin": "8413412220065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0a55c95c306c06fe139d83d1",
            "leftCorner": {
              "x": -15.591,
              "y": -10.296,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.49,
              "y": -10.296,
              "z": 0.14
            },
            "gtin": "4000339457724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "eed55741c9e25b47b2a46a5f",
            "leftCorner": {
              "x": -15.49,
              "y": -10.296,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.383,
              "y": -10.295,
              "z": 0.14
            },
            "gtin": "4000515007026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "16b909c2f429f7e405e35242",
            "leftCorner": {
              "x": -15.383,
              "y": -10.295,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.274,
              "y": -10.294,
              "z": 0.14
            },
            "gtin": "40056029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "87d16e875bd173a0f2ab1f12",
            "leftCorner": {
              "x": -15.274,
              "y": -10.294,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.986,
              "y": -10.293,
              "z": 0.14
            },
            "gtin": "4306188031239",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d60c",
        "height": 0.5026,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5202",
            "leftCorner": {
              "x": -16.225,
              "y": -10.259,
              "z": 0.411
            },
            "rightCorner": {
              "x": -15.385,
              "y": -10.254,
              "z": 0.411
            },
            "gtin": "4306188046615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5204",
            "leftCorner": {
              "x": -15.386,
              "y": -10.214,
              "z": 0.411
            },
            "rightCorner": {
              "x": -15.161,
              "y": -10.212,
              "z": 0.411
            },
            "gtin": "4306188031239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5205",
            "leftCorner": {
              "x": -15.161,
              "y": -10.213,
              "z": 0.411
            },
            "rightCorner": {
              "x": -14.93,
              "y": -10.212,
              "z": 0.411
            },
            "gtin": "4000339057726",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d60d",
        "height": 0.77823,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51ee",
            "leftCorner": {
              "x": -16.225,
              "y": -10.262,
              "z": 0.637
            },
            "rightCorner": {
              "x": -15.363,
              "y": -10.258,
              "z": 0.637
            },
            "gtin": "4306188046639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51f0",
            "leftCorner": {
              "x": -15.364,
              "y": -10.218,
              "z": 0.637
            },
            "rightCorner": {
              "x": -14.877,
              "y": -10.214,
              "z": 0.637
            },
            "gtin": "4000339057825",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d609",
        "height": 1.0805,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51d4",
            "leftCorner": {
              "x": -16.225,
              "y": -10.259,
              "z": 0.884
            },
            "rightCorner": {
              "x": -16.091,
              "y": -10.258,
              "z": 0.884
            },
            "gtin": "40737744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51d6",
            "leftCorner": {
              "x": -16.091,
              "y": -10.234,
              "z": 0.884
            },
            "rightCorner": {
              "x": -15.941,
              "y": -10.233,
              "z": 0.884
            },
            "gtin": "4012200030899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51d7",
            "leftCorner": {
              "x": -15.941,
              "y": -10.233,
              "z": 0.884
            },
            "rightCorner": {
              "x": -15.79,
              "y": -10.232,
              "z": 0.884
            },
            "gtin": "4012200030899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51d8",
            "leftCorner": {
              "x": -15.791,
              "y": -10.226,
              "z": 0.884
            },
            "rightCorner": {
              "x": -15.655,
              "y": -10.225,
              "z": 0.884
            },
            "gtin": "5900783010881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51d9",
            "leftCorner": {
              "x": -15.655,
              "y": -10.22,
              "z": 0.884
            },
            "rightCorner": {
              "x": -15.51,
              "y": -10.219,
              "z": 0.884
            },
            "gtin": "87157857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51da",
            "leftCorner": {
              "x": -15.51,
              "y": -10.214,
              "z": 0.884
            },
            "rightCorner": {
              "x": -15.352,
              "y": -10.213,
              "z": 0.884
            },
            "gtin": "8710522633830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51db",
            "leftCorner": {
              "x": -15.352,
              "y": -10.21,
              "z": 0.884
            },
            "rightCorner": {
              "x": -15.195,
              "y": -10.209,
              "z": 0.884
            },
            "gtin": "8720182580160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51dc",
            "leftCorner": {
              "x": -15.195,
              "y": -10.21,
              "z": 0.884
            },
            "rightCorner": {
              "x": -15.112,
              "y": -10.21,
              "z": 0.884
            },
            "gtin": "8413412220133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51dd",
            "leftCorner": {
              "x": -15.112,
              "y": -10.212,
              "z": 0.884
            },
            "rightCorner": {
              "x": -14.955,
              "y": -10.211,
              "z": 0.884
            },
            "gtin": "8413412220065",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d60a",
        "height": 1.3857,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5210",
            "leftCorner": {
              "x": -16.225,
              "y": -10.262,
              "z": 1.134
            },
            "rightCorner": {
              "x": -16.101,
              "y": -10.261,
              "z": 1.134
            },
            "gtin": "41007518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5212",
            "leftCorner": {
              "x": -16.101,
              "y": -10.234,
              "z": 1.134
            },
            "rightCorner": {
              "x": -16.003,
              "y": -10.234,
              "z": 1.134
            },
            "gtin": "40122137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5213",
            "leftCorner": {
              "x": -16.003,
              "y": -10.231,
              "z": 1.134
            },
            "rightCorner": {
              "x": -15.814,
              "y": -10.229,
              "z": 1.134
            },
            "gtin": "4000515007057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5214",
            "leftCorner": {
              "x": -15.815,
              "y": -10.225,
              "z": 1.134
            },
            "rightCorner": {
              "x": -15.704,
              "y": -10.225,
              "z": 1.134
            },
            "gtin": "4000515007026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5215",
            "leftCorner": {
              "x": -15.704,
              "y": -10.223,
              "z": 1.134
            },
            "rightCorner": {
              "x": -15.565,
              "y": -10.222,
              "z": 1.134
            },
            "gtin": "4000515007019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5216",
            "leftCorner": {
              "x": -15.565,
              "y": -10.215,
              "z": 1.134
            },
            "rightCorner": {
              "x": -15.382,
              "y": -10.214,
              "z": 1.134
            },
            "gtin": "4000515001024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5217",
            "leftCorner": {
              "x": -15.382,
              "y": -10.213,
              "z": 1.134
            },
            "rightCorner": {
              "x": -15.282,
              "y": -10.212,
              "z": 1.134
            },
            "gtin": "4000515905056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5218",
            "leftCorner": {
              "x": -15.282,
              "y": -10.21,
              "z": 1.134
            },
            "rightCorner": {
              "x": -15.182,
              "y": -10.209,
              "z": 1.134
            },
            "gtin": "4000515905155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5219",
            "leftCorner": {
              "x": -15.182,
              "y": -10.21,
              "z": 1.134
            },
            "rightCorner": {
              "x": -14.968,
              "y": -10.209,
              "z": 1.134
            },
            "gtin": "4306188413080",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d60b",
        "height": 1.6865,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51b1",
            "leftCorner": {
              "x": -16.225,
              "y": -10.259,
              "z": 1.38
            },
            "rightCorner": {
              "x": -16.067,
              "y": -10.259,
              "z": 1.38
            },
            "gtin": "40056142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3b53a7bdd71e6af4c0074d23",
            "leftCorner": {
              "x": -15.185,
              "y": -10.253,
              "z": 1.38
            },
            "rightCorner": {
              "x": -15.075,
              "y": -10.252,
              "z": 1.38
            },
            "gtin": "4030800427055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51b2",
            "leftCorner": {
              "x": -16.067,
              "y": -10.259,
              "z": 1.38
            },
            "rightCorner": {
              "x": -15.91,
              "y": -10.258,
              "z": 1.38
            },
            "gtin": "40056142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51b4",
            "leftCorner": {
              "x": -15.911,
              "y": -10.224,
              "z": 1.38
            },
            "rightCorner": {
              "x": -15.802,
              "y": -10.223,
              "z": 1.38
            },
            "gtin": "40056029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51b5",
            "leftCorner": {
              "x": -15.802,
              "y": -10.226,
              "z": 1.38
            },
            "rightCorner": {
              "x": -15.633,
              "y": -10.225,
              "z": 1.38
            },
            "gtin": "4250426226959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51b6",
            "leftCorner": {
              "x": -15.633,
              "y": -10.218,
              "z": 1.38
            },
            "rightCorner": {
              "x": -15.452,
              "y": -10.217,
              "z": 1.38
            },
            "gtin": "4030800082032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51b7",
            "leftCorner": {
              "x": -15.452,
              "y": -10.212,
              "z": 1.38
            },
            "rightCorner": {
              "x": -15.35,
              "y": -10.211,
              "z": 1.38
            },
            "gtin": "4030800427055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51b8",
            "leftCorner": {
              "x": -15.35,
              "y": -10.211,
              "z": 1.38
            },
            "rightCorner": {
              "x": -15.186,
              "y": -10.21,
              "z": 1.38
            },
            "gtin": "40056012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51ba",
            "leftCorner": {
              "x": -15.061,
              "y": -10.213,
              "z": 1.38
            },
            "rightCorner": {
              "x": -14.951,
              "y": -10.212,
              "z": 1.38
            },
            "gtin": "40052373",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "7d2"
  },
  {
    "id": "7d2",
    "name": "7d2",
    "x": -14.974,
    "y": -10.458,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0029496,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 68
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539cea5",
        "height": 0.17247,
        "facings": [
          {
            "id": "8a61badb68efd7cd14160753",
            "leftCorner": {
              "x": -14.973,
              "y": -10.545,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.913,
              "y": -10.545,
              "z": 0.141
            },
            "gtin": "4250231433337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b629f31e1132f05a0267ee8a",
            "leftCorner": {
              "x": -14.913,
              "y": -10.545,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.852,
              "y": -10.544,
              "z": 0.141
            },
            "gtin": "4250231304330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cdb8103230a4c6a4517d92d2",
            "leftCorner": {
              "x": -14.852,
              "y": -10.544,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.792,
              "y": -10.544,
              "z": 0.141
            },
            "gtin": "4250231433337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d7f83a44063482ef6209ae0d",
            "leftCorner": {
              "x": -14.792,
              "y": -10.544,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.731,
              "y": -10.544,
              "z": 0.141
            },
            "gtin": "4250231304330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "705c68dde20e148ede9dc793",
            "leftCorner": {
              "x": -14.731,
              "y": -10.544,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.664,
              "y": -10.543,
              "z": 0.141
            },
            "gtin": "4250231304309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6a0dc5cd9ebeb6a4c5f8d656",
            "leftCorner": {
              "x": -14.664,
              "y": -10.543,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.596,
              "y": -10.543,
              "z": 0.141
            },
            "gtin": "8413412220096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "561ffd1e8c8dd7cc6e27b967",
            "leftCorner": {
              "x": -14.596,
              "y": -10.543,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.522,
              "y": -10.542,
              "z": 0.141
            },
            "gtin": "4250231304637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4c7ae9a930e7455fb814cddb",
            "leftCorner": {
              "x": -14.522,
              "y": -10.542,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.445,
              "y": -10.542,
              "z": 0.141
            },
            "gtin": "4250231304552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5a8da28769a25a146e4dadda",
            "leftCorner": {
              "x": -14.445,
              "y": -10.542,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.36,
              "y": -10.541,
              "z": 0.141
            },
            "gtin": "4006824000246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d00b3d4d8dfaad7f9842afb5",
            "leftCorner": {
              "x": -14.36,
              "y": -10.541,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.273,
              "y": -10.541,
              "z": 0.141
            },
            "gtin": "4006824004404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4b54c357ebe170b387918cff",
            "leftCorner": {
              "x": -14.273,
              "y": -10.541,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.186,
              "y": -10.54,
              "z": 0.141
            },
            "gtin": "4006824000970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68da711e7b0241001034af99",
            "leftCorner": {
              "x": -14.186,
              "y": -10.54,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.099,
              "y": -10.54,
              "z": 0.141
            },
            "gtin": "4006824991032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d3cfaf490bf485534fc6b89f",
            "leftCorner": {
              "x": -14.099,
              "y": -10.54,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.006,
              "y": -10.539,
              "z": 0.141
            },
            "gtin": "8720182301727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fdd7ae7299a0d83948004ff4",
            "leftCorner": {
              "x": -14.006,
              "y": -10.539,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.745,
              "y": -10.538,
              "z": 0.141
            },
            "gtin": "4005500087052",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cea3",
        "height": 0.50388,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5206",
            "leftCorner": {
              "x": -14.928,
              "y": -10.472,
              "z": 0.412
            },
            "rightCorner": {
              "x": -14.718,
              "y": -10.471,
              "z": 0.412
            },
            "gtin": "4000339457724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5207",
            "leftCorner": {
              "x": -14.718,
              "y": -10.465,
              "z": 0.412
            },
            "rightCorner": {
              "x": -14.601,
              "y": -10.464,
              "z": 0.412
            },
            "gtin": "7622300103538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5208",
            "leftCorner": {
              "x": -14.601,
              "y": -10.463,
              "z": 0.412
            },
            "rightCorner": {
              "x": -14.427,
              "y": -10.462,
              "z": 0.412
            },
            "gtin": "4030800079643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5209",
            "leftCorner": {
              "x": -14.427,
              "y": -10.464,
              "z": 0.412
            },
            "rightCorner": {
              "x": -14.363,
              "y": -10.463,
              "z": 0.412
            },
            "gtin": "4030800074419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d520a",
            "leftCorner": {
              "x": -14.363,
              "y": -10.463,
              "z": 0.412
            },
            "rightCorner": {
              "x": -14.299,
              "y": -10.463,
              "z": 0.412
            },
            "gtin": "4030800074419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d520b",
            "leftCorner": {
              "x": -14.299,
              "y": -10.463,
              "z": 0.412
            },
            "rightCorner": {
              "x": -14.235,
              "y": -10.463,
              "z": 0.412
            },
            "gtin": "4030800074419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d520c",
            "leftCorner": {
              "x": -14.235,
              "y": -10.462,
              "z": 0.412
            },
            "rightCorner": {
              "x": -14.103,
              "y": -10.461,
              "z": 0.412
            },
            "gtin": "8715700121277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d520d",
            "leftCorner": {
              "x": -14.103,
              "y": -10.457,
              "z": 0.412
            },
            "rightCorner": {
              "x": -14.045,
              "y": -10.456,
              "z": 0.412
            },
            "gtin": "8410066142149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d520e",
            "leftCorner": {
              "x": -14.045,
              "y": -10.456,
              "z": 0.412
            },
            "rightCorner": {
              "x": -13.987,
              "y": -10.456,
              "z": 0.412
            },
            "gtin": "8410066142149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d520f",
            "leftCorner": {
              "x": -13.987,
              "y": -10.458,
              "z": 0.412
            },
            "rightCorner": {
              "x": -13.858,
              "y": -10.457,
              "z": 0.412
            },
            "gtin": "4012200383421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5203",
            "leftCorner": {
              "x": -13.858,
              "y": -10.46,
              "z": 0.412
            },
            "rightCorner": {
              "x": -13.724,
              "y": -10.459,
              "z": 0.412
            },
            "gtin": "40122717",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cea2",
        "height": 0.78057,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51f1",
            "leftCorner": {
              "x": -14.875,
              "y": -10.471,
              "z": 0.639
            },
            "rightCorner": {
              "x": -14.635,
              "y": -10.47,
              "z": 0.639
            },
            "gtin": "4000339457823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8f24da4255c8d3a49a0dcece",
            "leftCorner": {
              "x": -14.973,
              "y": -10.509,
              "z": 0.639
            },
            "rightCorner": {
              "x": -14.924,
              "y": -10.509,
              "z": 0.639
            },
            "gtin": "4250426229905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a9825bca501b37281c4530e8",
            "leftCorner": {
              "x": -14.924,
              "y": -10.509,
              "z": 0.639
            },
            "rightCorner": {
              "x": -14.88,
              "y": -10.508,
              "z": 0.639
            },
            "gtin": "4250426229905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51f2",
            "leftCorner": {
              "x": -14.635,
              "y": -10.467,
              "z": 0.639
            },
            "rightCorner": {
              "x": -14.43,
              "y": -10.465,
              "z": 0.639
            },
            "gtin": "4005500087076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51f3",
            "leftCorner": {
              "x": -14.43,
              "y": -10.467,
              "z": 0.639
            },
            "rightCorner": {
              "x": -14.312,
              "y": -10.467,
              "z": 0.639
            },
            "gtin": "4250426229868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51f4",
            "leftCorner": {
              "x": -14.312,
              "y": -10.467,
              "z": 0.639
            },
            "rightCorner": {
              "x": -14.2,
              "y": -10.466,
              "z": 0.639
            },
            "gtin": "4250426229929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51f5",
            "leftCorner": {
              "x": -14.2,
              "y": -10.465,
              "z": 0.639
            },
            "rightCorner": {
              "x": -14.06,
              "y": -10.464,
              "z": 0.639
            },
            "gtin": "4250426229943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51f6",
            "leftCorner": {
              "x": -14.06,
              "y": -10.462,
              "z": 0.639
            },
            "rightCorner": {
              "x": -13.931,
              "y": -10.46,
              "z": 0.639
            },
            "gtin": "4250426229882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51f7",
            "leftCorner": {
              "x": -13.931,
              "y": -10.46,
              "z": 0.639
            },
            "rightCorner": {
              "x": -13.781,
              "y": -10.46,
              "z": 0.639
            },
            "gtin": "4250426229844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51f8",
            "leftCorner": {
              "x": -13.781,
              "y": -10.461,
              "z": 0.639
            },
            "rightCorner": {
              "x": -13.7,
              "y": -10.46,
              "z": 0.639
            },
            "gtin": "4250426229905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51f9",
            "leftCorner": {
              "x": -13.7,
              "y": -10.46,
              "z": 0.639
            },
            "rightCorner": {
              "x": -13.617,
              "y": -10.46,
              "z": 0.639
            },
            "gtin": "4250426229905",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cea1",
        "height": 1.0829,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51de",
            "leftCorner": {
              "x": -14.953,
              "y": -10.469,
              "z": 0.886
            },
            "rightCorner": {
              "x": -14.828,
              "y": -10.468,
              "z": 0.886
            },
            "gtin": "4030800364596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51df",
            "leftCorner": {
              "x": -14.828,
              "y": -10.47,
              "z": 0.886
            },
            "rightCorner": {
              "x": -14.603,
              "y": -10.468,
              "z": 0.886
            },
            "gtin": "4005500087083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51e0",
            "leftCorner": {
              "x": -14.603,
              "y": -10.464,
              "z": 0.886
            },
            "rightCorner": {
              "x": -14.458,
              "y": -10.464,
              "z": 0.886
            },
            "gtin": "4005500087038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51e1",
            "leftCorner": {
              "x": -14.458,
              "y": -10.464,
              "z": 0.886
            },
            "rightCorner": {
              "x": -14.313,
              "y": -10.463,
              "z": 0.886
            },
            "gtin": "4005500087038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51e2",
            "leftCorner": {
              "x": -14.313,
              "y": -10.463,
              "z": 0.886
            },
            "rightCorner": {
              "x": -14.063,
              "y": -10.461,
              "z": 0.886
            },
            "gtin": "4005500087052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51e3",
            "leftCorner": {
              "x": -14.063,
              "y": -10.458,
              "z": 0.886
            },
            "rightCorner": {
              "x": -13.858,
              "y": -10.456,
              "z": 0.886
            },
            "gtin": "4400050310009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51e4",
            "leftCorner": {
              "x": -13.859,
              "y": -10.457,
              "z": 0.886
            },
            "rightCorner": {
              "x": -13.647,
              "y": -10.456,
              "z": 0.886
            },
            "gtin": "4400050311006",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cea4",
        "height": 1.3852,
        "facings": [
          {
            "id": "68d8e508e1820c81800d521a",
            "leftCorner": {
              "x": -14.966,
              "y": -10.472,
              "z": 1.133
            },
            "rightCorner": {
              "x": -14.833,
              "y": -10.471,
              "z": 1.133
            },
            "gtin": "4306188413059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d521b",
            "leftCorner": {
              "x": -14.833,
              "y": -10.476,
              "z": 1.133
            },
            "rightCorner": {
              "x": -14.714,
              "y": -10.475,
              "z": 1.133
            },
            "gtin": "4005500087120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d521c",
            "leftCorner": {
              "x": -14.714,
              "y": -10.469,
              "z": 1.133
            },
            "rightCorner": {
              "x": -14.564,
              "y": -10.469,
              "z": 1.133
            },
            "gtin": "4005500087113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d521d",
            "leftCorner": {
              "x": -14.565,
              "y": -10.464,
              "z": 1.133
            },
            "rightCorner": {
              "x": -14.425,
              "y": -10.463,
              "z": 1.133
            },
            "gtin": "8721201922350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d521e",
            "leftCorner": {
              "x": -14.425,
              "y": -10.466,
              "z": 1.133
            },
            "rightCorner": {
              "x": -14.276,
              "y": -10.466,
              "z": 1.133
            },
            "gtin": "4104420028166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d521f",
            "leftCorner": {
              "x": -14.276,
              "y": -10.465,
              "z": 1.133
            },
            "rightCorner": {
              "x": -14.089,
              "y": -10.463,
              "z": 1.133
            },
            "gtin": "42402947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5220",
            "leftCorner": {
              "x": -14.089,
              "y": -10.46,
              "z": 1.133
            },
            "rightCorner": {
              "x": -14.004,
              "y": -10.459,
              "z": 1.133
            },
            "gtin": "8720182301710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5221",
            "leftCorner": {
              "x": -14.004,
              "y": -10.459,
              "z": 1.133
            },
            "rightCorner": {
              "x": -13.918,
              "y": -10.459,
              "z": 1.133
            },
            "gtin": "8720182301710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5222",
            "leftCorner": {
              "x": -13.918,
              "y": -10.46,
              "z": 1.133
            },
            "rightCorner": {
              "x": -13.796,
              "y": -10.458,
              "z": 1.133
            },
            "gtin": "8720182301734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5223",
            "leftCorner": {
              "x": -13.796,
              "y": -10.459,
              "z": 1.133
            },
            "rightCorner": {
              "x": -13.657,
              "y": -10.458,
              "z": 1.133
            },
            "gtin": "8413412220096",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cea0",
        "height": 1.6861,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51bb",
            "leftCorner": {
              "x": -14.949,
              "y": -10.471,
              "z": 1.38
            },
            "rightCorner": {
              "x": -14.824,
              "y": -10.469,
              "z": 1.38
            },
            "gtin": "4104720015217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51bc",
            "leftCorner": {
              "x": -14.824,
              "y": -10.469,
              "z": 1.38
            },
            "rightCorner": {
              "x": -14.733,
              "y": -10.469,
              "z": 1.38
            },
            "gtin": "8720182301727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51bd",
            "leftCorner": {
              "x": -14.733,
              "y": -10.469,
              "z": 1.38
            },
            "rightCorner": {
              "x": -14.636,
              "y": -10.469,
              "z": 1.38
            },
            "gtin": "4006824008723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51be",
            "leftCorner": {
              "x": -14.636,
              "y": -10.467,
              "z": 1.38
            },
            "rightCorner": {
              "x": -14.544,
              "y": -10.466,
              "z": 1.38
            },
            "gtin": "4006824004404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51bf",
            "leftCorner": {
              "x": -14.544,
              "y": -10.466,
              "z": 1.38
            },
            "rightCorner": {
              "x": -14.457,
              "y": -10.466,
              "z": 1.38
            },
            "gtin": "4006824000246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51c0",
            "leftCorner": {
              "x": -14.457,
              "y": -10.467,
              "z": 1.38
            },
            "rightCorner": {
              "x": -14.352,
              "y": -10.465,
              "z": 1.38
            },
            "gtin": "4006824008884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51c1",
            "leftCorner": {
              "x": -14.352,
              "y": -10.466,
              "z": 1.38
            },
            "rightCorner": {
              "x": -14.272,
              "y": -10.466,
              "z": 1.38
            },
            "gtin": "4006824991032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51c2",
            "leftCorner": {
              "x": -14.272,
              "y": -10.467,
              "z": 1.38
            },
            "rightCorner": {
              "x": -14.192,
              "y": -10.466,
              "z": 1.38
            },
            "gtin": "4006824000970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51c3",
            "leftCorner": {
              "x": -14.193,
              "y": -10.457,
              "z": 1.38
            },
            "rightCorner": {
              "x": -14.134,
              "y": -10.457,
              "z": 1.38
            },
            "gtin": "4250231433139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51c4",
            "leftCorner": {
              "x": -14.134,
              "y": -10.455,
              "z": 1.38
            },
            "rightCorner": {
              "x": -14.052,
              "y": -10.454,
              "z": 1.38
            },
            "gtin": "4250231433139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51c5",
            "leftCorner": {
              "x": -14.051,
              "y": -10.452,
              "z": 1.38
            },
            "rightCorner": {
              "x": -13.967,
              "y": -10.452,
              "z": 1.38
            },
            "gtin": "4250231304552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51c6",
            "leftCorner": {
              "x": -13.967,
              "y": -10.453,
              "z": 1.38
            },
            "rightCorner": {
              "x": -13.896,
              "y": -10.452,
              "z": 1.38
            },
            "gtin": "4250231304637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51c7",
            "leftCorner": {
              "x": -13.896,
              "y": -10.452,
              "z": 1.38
            },
            "rightCorner": {
              "x": -13.831,
              "y": -10.452,
              "z": 1.38
            },
            "gtin": "4250231304309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51c8",
            "leftCorner": {
              "x": -13.831,
              "y": -10.453,
              "z": 1.38
            },
            "rightCorner": {
              "x": -13.772,
              "y": -10.453,
              "z": 1.38
            },
            "gtin": "4250231304606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51c9",
            "leftCorner": {
              "x": -13.772,
              "y": -10.453,
              "z": 1.38
            },
            "rightCorner": {
              "x": -13.707,
              "y": -10.453,
              "z": 1.38
            },
            "gtin": "4250231304606",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7cf",
    "rightNeighborShelfId": "7d3"
  },
  {
    "id": "7d3",
    "name": "7d3",
    "x": -13.724,
    "y": -10.45,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0029496,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 61
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ceab",
        "height": 0.17127,
        "facings": [
          {
            "id": "68d8e508e1820c81800d523a",
            "leftCorner": {
              "x": -13.095,
              "y": -10.522,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.0,
              "y": -10.521,
              "z": 0.14
            },
            "gtin": "4030800065813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b8ffb27d72aca79c05589b0b",
            "leftCorner": {
              "x": -13.724,
              "y": -10.554,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.633,
              "y": -10.553,
              "z": 0.14
            },
            "gtin": "4030800065813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "15c8a12e0f0f43cca7116ae8",
            "leftCorner": {
              "x": -13.633,
              "y": -10.553,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.373,
              "y": -10.552,
              "z": 0.14
            },
            "gtin": "4030800064397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a24b693cd0737617dd97f85f",
            "leftCorner": {
              "x": -13.373,
              "y": -10.552,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.113,
              "y": -10.55,
              "z": 0.14
            },
            "gtin": "4030800064397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "237a0431e78add3afbf27cb8",
            "leftCorner": {
              "x": -12.73,
              "y": -10.548,
              "z": 0.14
            },
            "rightCorner": {
              "x": -12.639,
              "y": -10.548,
              "z": 0.14
            },
            "gtin": "4030800065813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "711c252674c8156b2413de87",
            "leftCorner": {
              "x": -12.639,
              "y": -10.548,
              "z": 0.14
            },
            "rightCorner": {
              "x": -12.548,
              "y": -10.547,
              "z": 0.14
            },
            "gtin": "4030800065813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d523b",
            "leftCorner": {
              "x": -13.0,
              "y": -10.524,
              "z": 0.14
            },
            "rightCorner": {
              "x": -12.73,
              "y": -10.523,
              "z": 0.14
            },
            "gtin": "4030800064397",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceaa",
        "height": 0.51644,
        "facings": [
          {
            "id": "68d8e508e1820c81800d523d",
            "leftCorner": {
              "x": -13.724,
              "y": -10.505,
              "z": 0.423
            },
            "rightCorner": {
              "x": -13.636,
              "y": -10.505,
              "z": 0.423
            },
            "gtin": "40804972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d523e",
            "leftCorner": {
              "x": -13.636,
              "y": -10.505,
              "z": 0.423
            },
            "rightCorner": {
              "x": -13.547,
              "y": -10.504,
              "z": 0.423
            },
            "gtin": "40804972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d523f",
            "leftCorner": {
              "x": -13.547,
              "y": -10.504,
              "z": 0.423
            },
            "rightCorner": {
              "x": -13.459,
              "y": -10.504,
              "z": 0.423
            },
            "gtin": "40804972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5241",
            "leftCorner": {
              "x": -13.459,
              "y": -10.461,
              "z": 0.423
            },
            "rightCorner": {
              "x": -13.347,
              "y": -10.459,
              "z": 0.423
            },
            "gtin": "40804941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5242",
            "leftCorner": {
              "x": -13.347,
              "y": -10.459,
              "z": 0.423
            },
            "rightCorner": {
              "x": -13.241,
              "y": -10.459,
              "z": 0.423
            },
            "gtin": "40122694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5243",
            "leftCorner": {
              "x": -13.241,
              "y": -10.459,
              "z": 0.423
            },
            "rightCorner": {
              "x": -13.136,
              "y": -10.458,
              "z": 0.423
            },
            "gtin": "40122694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5244",
            "leftCorner": {
              "x": -13.136,
              "y": -10.46,
              "z": 0.423
            },
            "rightCorner": {
              "x": -12.945,
              "y": -10.459,
              "z": 0.423
            },
            "gtin": "40804835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5245",
            "leftCorner": {
              "x": -12.945,
              "y": -10.46,
              "z": 0.423
            },
            "rightCorner": {
              "x": -12.807,
              "y": -10.46,
              "z": 0.423
            },
            "gtin": "40804927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5246",
            "leftCorner": {
              "x": -12.807,
              "y": -10.461,
              "z": 0.423
            },
            "rightCorner": {
              "x": -12.686,
              "y": -10.46,
              "z": 0.423
            },
            "gtin": "40804996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5247",
            "leftCorner": {
              "x": -12.686,
              "y": -10.459,
              "z": 0.423
            },
            "rightCorner": {
              "x": -12.593,
              "y": -10.458,
              "z": 0.423
            },
            "gtin": "40804934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5248",
            "leftCorner": {
              "x": -12.593,
              "y": -10.459,
              "z": 0.423
            },
            "rightCorner": {
              "x": -12.497,
              "y": -10.459,
              "z": 0.423
            },
            "gtin": "40122724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5249",
            "leftCorner": {
              "x": -12.497,
              "y": -10.459,
              "z": 0.423
            },
            "rightCorner": {
              "x": -12.401,
              "y": -10.459,
              "z": 0.423
            },
            "gtin": "40122724",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cea9",
        "height": 0.78061,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51fa",
            "leftCorner": {
              "x": -13.617,
              "y": -10.462,
              "z": 0.639
            },
            "rightCorner": {
              "x": -13.473,
              "y": -10.461,
              "z": 0.639
            },
            "gtin": "4250426229981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51fb",
            "leftCorner": {
              "x": -13.473,
              "y": -10.463,
              "z": 0.639
            },
            "rightCorner": {
              "x": -13.381,
              "y": -10.463,
              "z": 0.639
            },
            "gtin": "4250426229967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51fc",
            "leftCorner": {
              "x": -13.381,
              "y": -10.459,
              "z": 0.639
            },
            "rightCorner": {
              "x": -13.24,
              "y": -10.457,
              "z": 0.639
            },
            "gtin": "4013300031281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51fd",
            "leftCorner": {
              "x": -13.24,
              "y": -10.474,
              "z": 0.639
            },
            "rightCorner": {
              "x": -13.099,
              "y": -10.474,
              "z": 0.639
            },
            "gtin": "4013300031328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51fe",
            "leftCorner": {
              "x": -13.1,
              "y": -10.461,
              "z": 0.639
            },
            "rightCorner": {
              "x": -12.968,
              "y": -10.46,
              "z": 0.639
            },
            "gtin": "8710522890943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51ff",
            "leftCorner": {
              "x": -12.967,
              "y": -10.465,
              "z": 0.639
            },
            "rightCorner": {
              "x": -12.813,
              "y": -10.464,
              "z": 0.639
            },
            "gtin": "4013300031250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5200",
            "leftCorner": {
              "x": -12.813,
              "y": -10.462,
              "z": 0.639
            },
            "rightCorner": {
              "x": -12.7,
              "y": -10.462,
              "z": 0.639
            },
            "gtin": "4013300031298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5201",
            "leftCorner": {
              "x": -12.7,
              "y": -10.459,
              "z": 0.639
            },
            "rightCorner": {
              "x": -12.563,
              "y": -10.458,
              "z": 0.639
            },
            "gtin": "4013300031380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51ef",
            "leftCorner": {
              "x": -12.563,
              "y": -10.46,
              "z": 0.639
            },
            "rightCorner": {
              "x": -12.474,
              "y": -10.459,
              "z": 0.639
            },
            "gtin": "4013300031236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4a428952b0c3691072492e09",
            "leftCorner": {
              "x": -13.724,
              "y": -10.505,
              "z": 0.639
            },
            "rightCorner": {
              "x": -13.63,
              "y": -10.504,
              "z": 0.639
            },
            "gtin": "4250426229967",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cea7",
        "height": 1.082,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51e5",
            "leftCorner": {
              "x": -13.648,
              "y": -10.457,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.56,
              "y": -10.457,
              "z": 0.885
            },
            "gtin": "4012860005473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51e6",
            "leftCorner": {
              "x": -13.559,
              "y": -10.461,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.482,
              "y": -10.461,
              "z": 0.885
            },
            "gtin": "4012860005480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51e7",
            "leftCorner": {
              "x": -13.482,
              "y": -10.462,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.387,
              "y": -10.462,
              "z": 0.885
            },
            "gtin": "4012860005466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51e8",
            "leftCorner": {
              "x": -13.387,
              "y": -10.461,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.225,
              "y": -10.46,
              "z": 0.885
            },
            "gtin": "8710448537076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51e9",
            "leftCorner": {
              "x": -13.225,
              "y": -10.459,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.127,
              "y": -10.458,
              "z": 0.885
            },
            "gtin": "8710448537045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51ea",
            "leftCorner": {
              "x": -13.127,
              "y": -10.458,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.029,
              "y": -10.458,
              "z": 0.885
            },
            "gtin": "8710448537045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51eb",
            "leftCorner": {
              "x": -13.029,
              "y": -10.456,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.868,
              "y": -10.455,
              "z": 0.885
            },
            "gtin": "4009286151259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51ec",
            "leftCorner": {
              "x": -12.868,
              "y": -10.458,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.735,
              "y": -10.457,
              "z": 0.885
            },
            "gtin": "4009286151334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51ed",
            "leftCorner": {
              "x": -12.734,
              "y": -10.459,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.604,
              "y": -10.459,
              "z": 0.885
            },
            "gtin": "4009286151280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51d5",
            "leftCorner": {
              "x": -12.604,
              "y": -10.458,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.474,
              "y": -10.457,
              "z": 0.885
            },
            "gtin": "4009286151273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "24d381ba8b4b4a532b616e42",
            "leftCorner": {
              "x": -13.724,
              "y": -10.503,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.649,
              "y": -10.503,
              "z": 0.885
            },
            "gtin": "4012860005473",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cea8",
        "height": 1.3843,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5224",
            "leftCorner": {
              "x": -13.657,
              "y": -10.462,
              "z": 1.133
            },
            "rightCorner": {
              "x": -13.564,
              "y": -10.462,
              "z": 1.133
            },
            "gtin": "8710448534044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5225",
            "leftCorner": {
              "x": -13.564,
              "y": -10.464,
              "z": 1.133
            },
            "rightCorner": {
              "x": -13.402,
              "y": -10.463,
              "z": 1.133
            },
            "gtin": "8715700115832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5226",
            "leftCorner": {
              "x": -13.402,
              "y": -10.464,
              "z": 1.133
            },
            "rightCorner": {
              "x": -13.272,
              "y": -10.463,
              "z": 1.133
            },
            "gtin": "8715700411194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5227",
            "leftCorner": {
              "x": -13.271,
              "y": -10.471,
              "z": 1.133
            },
            "rightCorner": {
              "x": -13.139,
              "y": -10.47,
              "z": 1.133
            },
            "gtin": "8715700115801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5228",
            "leftCorner": {
              "x": -13.138,
              "y": -10.474,
              "z": 1.133
            },
            "rightCorner": {
              "x": -12.993,
              "y": -10.473,
              "z": 1.133
            },
            "gtin": "8715700411224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5229",
            "leftCorner": {
              "x": -12.993,
              "y": -10.47,
              "z": 1.133
            },
            "rightCorner": {
              "x": -12.836,
              "y": -10.468,
              "z": 1.133
            },
            "gtin": "5900783007966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d522a",
            "leftCorner": {
              "x": -12.836,
              "y": -10.465,
              "z": 1.133
            },
            "rightCorner": {
              "x": -12.703,
              "y": -10.465,
              "z": 1.133
            },
            "gtin": "8715700411231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d522b",
            "leftCorner": {
              "x": -12.703,
              "y": -10.464,
              "z": 1.133
            },
            "rightCorner": {
              "x": -12.608,
              "y": -10.463,
              "z": 1.133
            },
            "gtin": "8715700122205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5211",
            "leftCorner": {
              "x": -12.608,
              "y": -10.463,
              "z": 1.133
            },
            "rightCorner": {
              "x": -12.474,
              "y": -10.462,
              "z": 1.133
            },
            "gtin": "87157833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ebfed1482e1cd8bbb49bcc3d",
            "leftCorner": {
              "x": -13.724,
              "y": -10.51,
              "z": 1.133
            },
            "rightCorner": {
              "x": -13.674,
              "y": -10.51,
              "z": 1.133
            },
            "gtin": "5900783007966",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cea6",
        "height": 1.6842,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51ca",
            "leftCorner": {
              "x": -13.707,
              "y": -10.458,
              "z": 1.378
            },
            "rightCorner": {
              "x": -13.615,
              "y": -10.458,
              "z": 1.378
            },
            "gtin": "40122212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51cb",
            "leftCorner": {
              "x": -13.615,
              "y": -10.461,
              "z": 1.378
            },
            "rightCorner": {
              "x": -13.532,
              "y": -10.461,
              "z": 1.378
            },
            "gtin": "40122885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51cc",
            "leftCorner": {
              "x": -13.532,
              "y": -10.461,
              "z": 1.378
            },
            "rightCorner": {
              "x": -13.412,
              "y": -10.461,
              "z": 1.378
            },
            "gtin": "40122700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51cd",
            "leftCorner": {
              "x": -13.412,
              "y": -10.461,
              "z": 1.378
            },
            "rightCorner": {
              "x": -13.295,
              "y": -10.461,
              "z": 1.378
            },
            "gtin": "42470137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51ce",
            "leftCorner": {
              "x": -13.295,
              "y": -10.461,
              "z": 1.378
            },
            "rightCorner": {
              "x": -13.183,
              "y": -10.46,
              "z": 1.378
            },
            "gtin": "40198873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51cf",
            "leftCorner": {
              "x": -13.183,
              "y": -10.46,
              "z": 1.378
            },
            "rightCorner": {
              "x": -13.09,
              "y": -10.459,
              "z": 1.378
            },
            "gtin": "8710448595168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51d0",
            "leftCorner": {
              "x": -13.089,
              "y": -10.465,
              "z": 1.378
            },
            "rightCorner": {
              "x": -13.004,
              "y": -10.464,
              "z": 1.378
            },
            "gtin": "8710448595182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51d1",
            "leftCorner": {
              "x": -13.004,
              "y": -10.464,
              "z": 1.378
            },
            "rightCorner": {
              "x": -12.899,
              "y": -10.464,
              "z": 1.378
            },
            "gtin": "8715700208626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51d2",
            "leftCorner": {
              "x": -12.899,
              "y": -10.461,
              "z": 1.378
            },
            "rightCorner": {
              "x": -12.722,
              "y": -10.46,
              "z": 1.378
            },
            "gtin": "8715700208602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51d3",
            "leftCorner": {
              "x": -12.722,
              "y": -10.461,
              "z": 1.378
            },
            "rightCorner": {
              "x": -12.577,
              "y": -10.461,
              "z": 1.378
            },
            "gtin": "5000111047364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51b3",
            "leftCorner": {
              "x": -12.577,
              "y": -10.459,
              "z": 1.378
            },
            "rightCorner": {
              "x": -12.474,
              "y": -10.458,
              "z": 1.378
            },
            "gtin": "5000111047371",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7d2",
    "rightNeighborShelfId": "7d4"
  },
  {
    "id": "7d4",
    "name": "7d4",
    "x": -12.474,
    "y": -10.443,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0029496,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ceaf",
        "height": 0.15958,
        "facings": [
          {
            "id": "68d8e508e1820c81800d526b",
            "leftCorner": {
              "x": -12.473,
              "y": -10.558,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.139,
              "y": -10.556,
              "z": 0.131
            },
            "gtin": "4400139017164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d526d",
            "leftCorner": {
              "x": -12.14,
              "y": -10.518,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.0,
              "y": -10.518,
              "z": 0.131
            },
            "gtin": "4027400148121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d526e",
            "leftCorner": {
              "x": -12.0,
              "y": -10.518,
              "z": 0.131
            },
            "rightCorner": {
              "x": -11.861,
              "y": -10.516,
              "z": 0.131
            },
            "gtin": "4027400148121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d526f",
            "leftCorner": {
              "x": -11.861,
              "y": -10.516,
              "z": 0.131
            },
            "rightCorner": {
              "x": -11.721,
              "y": -10.516,
              "z": 0.131
            },
            "gtin": "4027400148121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5270",
            "leftCorner": {
              "x": -11.721,
              "y": -10.516,
              "z": 0.131
            },
            "rightCorner": {
              "x": -11.581,
              "y": -10.514,
              "z": 0.131
            },
            "gtin": "4027400148121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d526c",
            "leftCorner": {
              "x": -11.581,
              "y": -10.511,
              "z": 0.131
            },
            "rightCorner": {
              "x": -11.224,
              "y": -10.509,
              "z": 0.131
            },
            "gtin": "4027400148039",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceb0",
        "height": 0.5253,
        "facings": [
          {
            "id": "68d8e508e1820c81800d524a",
            "leftCorner": {
              "x": -12.401,
              "y": -10.456,
              "z": 0.43
            },
            "rightCorner": {
              "x": -12.104,
              "y": -10.454,
              "z": 0.43
            },
            "gtin": "4306188000884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d524b",
            "leftCorner": {
              "x": -12.104,
              "y": -10.454,
              "z": 0.43
            },
            "rightCorner": {
              "x": -11.806,
              "y": -10.452,
              "z": 0.43
            },
            "gtin": "4306188000884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d524c",
            "leftCorner": {
              "x": -11.806,
              "y": -10.456,
              "z": 0.43
            },
            "rightCorner": {
              "x": -11.536,
              "y": -10.455,
              "z": 0.43
            },
            "gtin": "4306188059974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d524d",
            "leftCorner": {
              "x": -11.536,
              "y": -10.453,
              "z": 0.43
            },
            "rightCorner": {
              "x": -11.304,
              "y": -10.451,
              "z": 0.43
            },
            "gtin": "4027400148275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5240",
            "leftCorner": {
              "x": -11.304,
              "y": -10.447,
              "z": 0.43
            },
            "rightCorner": {
              "x": -11.224,
              "y": -10.447,
              "z": 0.43
            },
            "gtin": "4027400148343",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceae",
        "height": 0.8519,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5262",
            "leftCorner": {
              "x": -12.474,
              "y": -10.497,
              "z": 0.697
            },
            "rightCorner": {
              "x": -12.379,
              "y": -10.496,
              "z": 0.697
            },
            "gtin": "4104420028142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5263",
            "leftCorner": {
              "x": -12.379,
              "y": -10.496,
              "z": 0.697
            },
            "rightCorner": {
              "x": -12.285,
              "y": -10.495,
              "z": 0.697
            },
            "gtin": "4104420028142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5266",
            "leftCorner": {
              "x": -12.284,
              "y": -10.463,
              "z": 0.697
            },
            "rightCorner": {
              "x": -12.134,
              "y": -10.462,
              "z": 0.697
            },
            "gtin": "4104420031500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5267",
            "leftCorner": {
              "x": -12.134,
              "y": -10.457,
              "z": 0.697
            },
            "rightCorner": {
              "x": -12.024,
              "y": -10.456,
              "z": 0.697
            },
            "gtin": "7613032747350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5268",
            "leftCorner": {
              "x": -12.024,
              "y": -10.456,
              "z": 0.697
            },
            "rightCorner": {
              "x": -11.914,
              "y": -10.455,
              "z": 0.697
            },
            "gtin": "7613032747350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5269",
            "leftCorner": {
              "x": -11.914,
              "y": -10.454,
              "z": 0.697
            },
            "rightCorner": {
              "x": -11.698,
              "y": -10.453,
              "z": 0.697
            },
            "gtin": "4005500333630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d526a",
            "leftCorner": {
              "x": -11.698,
              "y": -10.452,
              "z": 0.697
            },
            "rightCorner": {
              "x": -11.48,
              "y": -10.451,
              "z": 0.697
            },
            "gtin": "4005500023531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5264",
            "leftCorner": {
              "x": -11.48,
              "y": -10.449,
              "z": 0.697
            },
            "rightCorner": {
              "x": -11.352,
              "y": -10.448,
              "z": 0.697
            },
            "gtin": "7613035037076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5265",
            "leftCorner": {
              "x": -11.352,
              "y": -10.448,
              "z": 0.697
            },
            "rightCorner": {
              "x": -11.224,
              "y": -10.447,
              "z": 0.697
            },
            "gtin": "7613035037076",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cead",
        "height": 1.1546,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5258",
            "leftCorner": {
              "x": -12.474,
              "y": -10.496,
              "z": 0.945
            },
            "rightCorner": {
              "x": -12.371,
              "y": -10.496,
              "z": 0.945
            },
            "gtin": "4400191065493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5259",
            "leftCorner": {
              "x": -12.371,
              "y": -10.496,
              "z": 0.945
            },
            "rightCorner": {
              "x": -12.268,
              "y": -10.496,
              "z": 0.945
            },
            "gtin": "4400191065493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d525a",
            "leftCorner": {
              "x": -12.268,
              "y": -10.496,
              "z": 0.945
            },
            "rightCorner": {
              "x": -12.165,
              "y": -10.495,
              "z": 0.945
            },
            "gtin": "4400191065493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d525c",
            "leftCorner": {
              "x": -12.164,
              "y": -10.458,
              "z": 0.945
            },
            "rightCorner": {
              "x": -11.949,
              "y": -10.456,
              "z": 0.945
            },
            "gtin": "4400191064298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d525d",
            "leftCorner": {
              "x": -11.949,
              "y": -10.452,
              "z": 0.945
            },
            "rightCorner": {
              "x": -11.746,
              "y": -10.451,
              "z": 0.945
            },
            "gtin": "4400191050017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d525e",
            "leftCorner": {
              "x": -11.746,
              "y": -10.454,
              "z": 0.945
            },
            "rightCorner": {
              "x": -11.643,
              "y": -10.453,
              "z": 0.945
            },
            "gtin": "4400191070824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d525f",
            "leftCorner": {
              "x": -11.643,
              "y": -10.453,
              "z": 0.945
            },
            "rightCorner": {
              "x": -11.539,
              "y": -10.453,
              "z": 0.945
            },
            "gtin": "4400191070824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5260",
            "leftCorner": {
              "x": -11.539,
              "y": -10.453,
              "z": 0.945
            },
            "rightCorner": {
              "x": -11.436,
              "y": -10.452,
              "z": 0.945
            },
            "gtin": "4400191070824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5261",
            "leftCorner": {
              "x": -11.436,
              "y": -10.452,
              "z": 0.945
            },
            "rightCorner": {
              "x": -11.333,
              "y": -10.451,
              "z": 0.945
            },
            "gtin": "4400191070824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d525b",
            "leftCorner": {
              "x": -11.333,
              "y": -10.442,
              "z": 0.945
            },
            "rightCorner": {
              "x": -11.224,
              "y": -10.441,
              "z": 0.945
            },
            "gtin": "4400191061129",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceac",
        "height": 1.5078,
        "facings": [
          {
            "id": "68d8e508e1820c81800d524e",
            "leftCorner": {
              "x": -12.474,
              "y": -10.502,
              "z": 1.234
            },
            "rightCorner": {
              "x": -12.244,
              "y": -10.501,
              "z": 1.234
            },
            "gtin": "4003879160017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d524f",
            "leftCorner": {
              "x": -12.243,
              "y": -10.467,
              "z": 1.234
            },
            "rightCorner": {
              "x": -12.114,
              "y": -10.466,
              "z": 1.234
            },
            "gtin": "4003879100013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5250",
            "leftCorner": {
              "x": -12.114,
              "y": -10.466,
              "z": 1.234
            },
            "rightCorner": {
              "x": -11.984,
              "y": -10.465,
              "z": 1.234
            },
            "gtin": "4003879100013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5251",
            "leftCorner": {
              "x": -11.984,
              "y": -10.459,
              "z": 1.234
            },
            "rightCorner": {
              "x": -11.921,
              "y": -10.459,
              "z": 1.234
            },
            "gtin": "4003879110012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5252",
            "leftCorner": {
              "x": -11.921,
              "y": -10.459,
              "z": 1.234
            },
            "rightCorner": {
              "x": -11.858,
              "y": -10.458,
              "z": 1.234
            },
            "gtin": "4003879110012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5253",
            "leftCorner": {
              "x": -11.858,
              "y": -10.458,
              "z": 1.234
            },
            "rightCorner": {
              "x": -11.795,
              "y": -10.458,
              "z": 1.234
            },
            "gtin": "4003879110012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5254",
            "leftCorner": {
              "x": -11.795,
              "y": -10.46,
              "z": 1.234
            },
            "rightCorner": {
              "x": -11.651,
              "y": -10.459,
              "z": 1.234
            },
            "gtin": "4003879130010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5255",
            "leftCorner": {
              "x": -11.651,
              "y": -10.458,
              "z": 1.234
            },
            "rightCorner": {
              "x": -11.481,
              "y": -10.457,
              "z": 1.234
            },
            "gtin": "8720182797544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5256",
            "leftCorner": {
              "x": -11.481,
              "y": -10.455,
              "z": 1.234
            },
            "rightCorner": {
              "x": -11.336,
              "y": -10.454,
              "z": 1.234
            },
            "gtin": "4030800079629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5257",
            "leftCorner": {
              "x": -11.336,
              "y": -10.45,
              "z": 1.234
            },
            "rightCorner": {
              "x": -11.228,
              "y": -10.45,
              "z": 1.234
            },
            "gtin": "4030800079667",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7d3",
    "rightNeighborShelfId": "7d5"
  },
  {
    "id": "7d5",
    "name": "7d5",
    "x": -11.224,
    "y": -10.436,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0029496,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 4
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d60f",
        "height": 0.15784,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8521",
            "leftCorner": {
              "x": -11.226,
              "y": -10.168,
              "z": 0.129
            },
            "rightCorner": {
              "x": -10.817,
              "y": -10.166,
              "z": 0.129
            },
            "gtin": "4027400148244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8523",
            "leftCorner": {
              "x": -10.817,
              "y": -10.126,
              "z": 0.129
            },
            "rightCorner": {
              "x": -10.523,
              "y": -10.125,
              "z": 0.129
            },
            "gtin": "4027400148091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8524",
            "leftCorner": {
              "x": -10.523,
              "y": -10.124,
              "z": 0.129
            },
            "rightCorner": {
              "x": -10.047,
              "y": -10.12,
              "z": 0.129
            },
            "gtin": "4027400148008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8522",
            "leftCorner": {
              "x": -10.047,
              "y": -10.115,
              "z": 0.129
            },
            "rightCorner": {
              "x": -9.976,
              "y": -10.115,
              "z": 0.129
            },
            "gtin": "2000439121510",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7d4"
  },
  {
    "id": "7d6",
    "name": "7d6",
    "x": -16.846,
    "y": -6.369,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70774,
      "w": 0.70648
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 29,
      "shelfCategory": "PASTA"
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce6a",
        "height": 0.23925,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5063",
            "leftCorner": {
              "x": -16.929,
              "y": -6.874,
              "z": 0.196
            },
            "rightCorner": {
              "x": -16.929,
              "y": -7.239,
              "z": 0.196
            },
            "gtin": "4306188421948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5062",
            "leftCorner": {
              "x": -16.913,
              "y": -7.239,
              "z": 0.196
            },
            "rightCorner": {
              "x": -16.914,
              "y": -7.619,
              "z": 0.196
            },
            "gtin": "4306188421917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "33c88c1087cde6fe41d41e3d",
            "leftCorner": {
              "x": -16.959,
              "y": -6.369,
              "z": 0.196
            },
            "rightCorner": {
              "x": -16.96,
              "y": -6.84,
              "z": 0.196
            },
            "gtin": "4306188421917",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce66",
        "height": 0.47788,
        "facings": [
          {
            "id": "68d8e508e1820c81800d504d",
            "leftCorner": {
              "x": -16.898,
              "y": -6.369,
              "z": 0.391
            },
            "rightCorner": {
              "x": -16.898,
              "y": -6.522,
              "z": 0.391
            },
            "gtin": "4002861654145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d504e",
            "leftCorner": {
              "x": -16.898,
              "y": -6.522,
              "z": 0.391
            },
            "rightCorner": {
              "x": -16.898,
              "y": -6.674,
              "z": 0.391
            },
            "gtin": "4002861654145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5050",
            "leftCorner": {
              "x": -16.857,
              "y": -6.675,
              "z": 0.391
            },
            "rightCorner": {
              "x": -16.858,
              "y": -7.016,
              "z": 0.391
            },
            "gtin": "4002966000267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5051",
            "leftCorner": {
              "x": -16.863,
              "y": -7.016,
              "z": 0.391
            },
            "rightCorner": {
              "x": -16.864,
              "y": -7.22,
              "z": 0.391
            },
            "gtin": "4002676210611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5052",
            "leftCorner": {
              "x": -16.852,
              "y": -7.22,
              "z": 0.391
            },
            "rightCorner": {
              "x": -16.853,
              "y": -7.423,
              "z": 0.391
            },
            "gtin": "4002676210628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d504f",
            "leftCorner": {
              "x": -16.861,
              "y": -7.423,
              "z": 0.391
            },
            "rightCorner": {
              "x": -16.861,
              "y": -7.619,
              "z": 0.391
            },
            "gtin": "4002676210598",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce68",
        "height": 0.77658,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5058",
            "leftCorner": {
              "x": -16.9,
              "y": -6.369,
              "z": 0.635
            },
            "rightCorner": {
              "x": -16.902,
              "y": -6.741,
              "z": 0.635
            },
            "gtin": "4306188432012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d505a",
            "leftCorner": {
              "x": -16.862,
              "y": -6.741,
              "z": 0.635
            },
            "rightCorner": {
              "x": -16.862,
              "y": -7.036,
              "z": 0.635
            },
            "gtin": "4306188431978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d505b",
            "leftCorner": {
              "x": -16.862,
              "y": -7.036,
              "z": 0.635
            },
            "rightCorner": {
              "x": -16.862,
              "y": -7.374,
              "z": 0.635
            },
            "gtin": "4306188432043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5059",
            "leftCorner": {
              "x": -16.855,
              "y": -7.374,
              "z": 0.635
            },
            "rightCorner": {
              "x": -16.856,
              "y": -7.619,
              "z": 0.635
            },
            "gtin": "4104420237001",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce67",
        "height": 1.081,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5053",
            "leftCorner": {
              "x": -16.902,
              "y": -6.369,
              "z": 0.884
            },
            "rightCorner": {
              "x": -16.903,
              "y": -6.616,
              "z": 0.884
            },
            "gtin": "4104420137202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5055",
            "leftCorner": {
              "x": -16.899,
              "y": -6.616,
              "z": 0.884
            },
            "rightCorner": {
              "x": -16.899,
              "y": -6.855,
              "z": 0.884
            },
            "gtin": "4104420207516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5056",
            "leftCorner": {
              "x": -16.865,
              "y": -6.855,
              "z": 0.884
            },
            "rightCorner": {
              "x": -16.865,
              "y": -7.138,
              "z": 0.884
            },
            "gtin": "4104420238466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5057",
            "leftCorner": {
              "x": -16.857,
              "y": -7.138,
              "z": 0.884
            },
            "rightCorner": {
              "x": -16.858,
              "y": -7.467,
              "z": 0.884
            },
            "gtin": "4104420236974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5054",
            "leftCorner": {
              "x": -16.863,
              "y": -7.467,
              "z": 0.884
            },
            "rightCorner": {
              "x": -16.863,
              "y": -7.619,
              "z": 0.884
            },
            "gtin": "4104420240469",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce69",
        "height": 1.3569,
        "facings": [
          {
            "id": "68d8e508e1820c81800d505c",
            "leftCorner": {
              "x": -16.902,
              "y": -6.369,
              "z": 1.11
            },
            "rightCorner": {
              "x": -16.902,
              "y": -6.839,
              "z": 1.11
            },
            "gtin": "4104420240407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d505f",
            "leftCorner": {
              "x": -16.863,
              "y": -6.839,
              "z": 1.11
            },
            "rightCorner": {
              "x": -16.864,
              "y": -6.98,
              "z": 1.11
            },
            "gtin": "4104420236943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5060",
            "leftCorner": {
              "x": -16.867,
              "y": -6.98,
              "z": 1.11
            },
            "rightCorner": {
              "x": -16.868,
              "y": -7.254,
              "z": 1.11
            },
            "gtin": "4104420240438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d505d",
            "leftCorner": {
              "x": -16.853,
              "y": -7.254,
              "z": 1.11
            },
            "rightCorner": {
              "x": -16.853,
              "y": -7.436,
              "z": 1.11
            },
            "gtin": "4104420240124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d505e",
            "leftCorner": {
              "x": -16.853,
              "y": -7.436,
              "z": 1.11
            },
            "rightCorner": {
              "x": -16.853,
              "y": -7.619,
              "z": 1.11
            },
            "gtin": "4104420240124",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce65",
        "height": 1.6805,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5047",
            "leftCorner": {
              "x": -16.897,
              "y": -6.369,
              "z": 1.375
            },
            "rightCorner": {
              "x": -16.897,
              "y": -6.616,
              "z": 1.375
            },
            "gtin": "4250780309350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5049",
            "leftCorner": {
              "x": -16.857,
              "y": -6.616,
              "z": 1.375
            },
            "rightCorner": {
              "x": -16.857,
              "y": -6.806,
              "z": 1.375
            },
            "gtin": "4250780309374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d504a",
            "leftCorner": {
              "x": -16.862,
              "y": -6.806,
              "z": 1.375
            },
            "rightCorner": {
              "x": -16.863,
              "y": -7.02,
              "z": 1.375
            },
            "gtin": "4250780309398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d504b",
            "leftCorner": {
              "x": -16.863,
              "y": -7.02,
              "z": 1.375
            },
            "rightCorner": {
              "x": -16.862,
              "y": -7.195,
              "z": 1.375
            },
            "gtin": "4001762060338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d504c",
            "leftCorner": {
              "x": -16.851,
              "y": -7.195,
              "z": 1.375
            },
            "rightCorner": {
              "x": -16.851,
              "y": -7.426,
              "z": 1.375
            },
            "gtin": "4001762060321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5048",
            "leftCorner": {
              "x": -16.857,
              "y": -7.426,
              "z": 1.375
            },
            "rightCorner": {
              "x": -16.858,
              "y": -7.619,
              "z": 1.375
            },
            "gtin": "4001762060420",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "7d7",
    "name": "7d7",
    "x": -16.768,
    "y": -9.263,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70862,
      "w": 0.70559
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ce9f",
        "height": 0.5487,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51ae",
            "leftCorner": {
              "x": -16.842,
              "y": -9.263,
              "z": 0.449
            },
            "rightCorner": {
              "x": -16.842,
              "y": -9.375,
              "z": 0.449
            },
            "gtin": "4400139017164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51af",
            "leftCorner": {
              "x": -16.803,
              "y": -9.375,
              "z": 0.449
            },
            "rightCorner": {
              "x": -16.804,
              "y": -9.944,
              "z": 0.449
            },
            "gtin": "4400139017164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51b0",
            "leftCorner": {
              "x": -16.804,
              "y": -9.944,
              "z": 0.449
            },
            "rightCorner": {
              "x": -16.807,
              "y": -10.513,
              "z": 0.449
            },
            "gtin": "4400139017164",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce9e",
        "height": 0.93343,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51ab",
            "leftCorner": {
              "x": -16.833,
              "y": -9.263,
              "z": 0.764
            },
            "rightCorner": {
              "x": -16.835,
              "y": -9.79,
              "z": 0.764
            },
            "gtin": "5410673004437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51ac",
            "leftCorner": {
              "x": -16.835,
              "y": -9.79,
              "z": 0.764
            },
            "rightCorner": {
              "x": -16.837,
              "y": -10.317,
              "z": 0.764
            },
            "gtin": "5410673004437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51ad",
            "leftCorner": {
              "x": -16.798,
              "y": -10.318,
              "z": 0.764
            },
            "rightCorner": {
              "x": -16.798,
              "y": -10.513,
              "z": 0.764
            },
            "gtin": "5410673004437",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce9d",
        "height": 1.3089,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51a7",
            "leftCorner": {
              "x": -16.836,
              "y": -9.263,
              "z": 1.071
            },
            "rightCorner": {
              "x": -16.837,
              "y": -9.448,
              "z": 1.071
            },
            "gtin": "5410673004437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51a9",
            "leftCorner": {
              "x": -16.797,
              "y": -9.448,
              "z": 1.071
            },
            "rightCorner": {
              "x": -16.799,
              "y": -10.011,
              "z": 1.071
            },
            "gtin": "5410673004406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51aa",
            "leftCorner": {
              "x": -16.801,
              "y": -10.011,
              "z": 1.071
            },
            "rightCorner": {
              "x": -16.803,
              "y": -10.307,
              "z": 1.071
            },
            "gtin": "5410673004406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51a8",
            "leftCorner": {
              "x": -16.799,
              "y": -10.307,
              "z": 1.071
            },
            "rightCorner": {
              "x": -16.8,
              "y": -10.513,
              "z": 1.071
            },
            "gtin": "5410673004437",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ce9c",
        "height": 1.6619,
        "facings": [
          {
            "id": "68d8e508e1820c81800d51a0",
            "leftCorner": {
              "x": -16.836,
              "y": -9.263,
              "z": 1.36
            },
            "rightCorner": {
              "x": -16.836,
              "y": -9.393,
              "z": 1.36
            },
            "gtin": "4000286217037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51a2",
            "leftCorner": {
              "x": -16.801,
              "y": -9.393,
              "z": 1.36
            },
            "rightCorner": {
              "x": -16.802,
              "y": -9.591,
              "z": 1.36
            },
            "gtin": "4000286217075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51a3",
            "leftCorner": {
              "x": -16.796,
              "y": -9.591,
              "z": 1.36
            },
            "rightCorner": {
              "x": -16.797,
              "y": -9.833,
              "z": 1.36
            },
            "gtin": "7613287054197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51a4",
            "leftCorner": {
              "x": -16.794,
              "y": -9.833,
              "z": 1.36
            },
            "rightCorner": {
              "x": -16.794,
              "y": -9.964,
              "z": 1.36
            },
            "gtin": "7613036028349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51a5",
            "leftCorner": {
              "x": -16.8,
              "y": -9.964,
              "z": 1.36
            },
            "rightCorner": {
              "x": -16.8,
              "y": -10.107,
              "z": 1.36
            },
            "gtin": "7613287054333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51a6",
            "leftCorner": {
              "x": -16.8,
              "y": -10.107,
              "z": 1.36
            },
            "rightCorner": {
              "x": -16.801,
              "y": -10.283,
              "z": 1.36
            },
            "gtin": "4000286217006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d51a1",
            "leftCorner": {
              "x": -16.795,
              "y": -10.283,
              "z": 1.36
            },
            "rightCorner": {
              "x": -16.796,
              "y": -10.513,
              "z": 1.36
            },
            "gtin": "4000286216993",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "7d8",
    "name": "7d8",
    "x": -9.492,
    "y": -7.467,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70724,
      "w": 0.70697
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 6,
      "unknownStockCount": 38
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d613",
        "height": 0.23161,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d853a",
            "leftCorner": {
              "x": -9.466,
              "y": -7.467,
              "z": 0.189
            },
            "rightCorner": {
              "x": -9.466,
              "y": -7.07,
              "z": 0.189
            },
            "gtin": "4104420218284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d853c",
            "leftCorner": {
              "x": -9.506,
              "y": -7.071,
              "z": 0.189
            },
            "rightCorner": {
              "x": -9.506,
              "y": -6.908,
              "z": 0.189
            },
            "gtin": "9001745011451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d853d",
            "leftCorner": {
              "x": -9.506,
              "y": -6.908,
              "z": 0.189
            },
            "rightCorner": {
              "x": -9.506,
              "y": -6.692,
              "z": 0.189
            },
            "gtin": "9001745011475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d853e",
            "leftCorner": {
              "x": -9.512,
              "y": -6.692,
              "z": 0.189
            },
            "rightCorner": {
              "x": -9.512,
              "y": -6.537,
              "z": 0.189
            },
            "gtin": "5908230534652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d853f",
            "leftCorner": {
              "x": -9.515,
              "y": -6.537,
              "z": 0.189
            },
            "rightCorner": {
              "x": -9.516,
              "y": -6.296,
              "z": 0.189
            },
            "gtin": "5908230534713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d853b",
            "leftCorner": {
              "x": -9.519,
              "y": -6.296,
              "z": 0.189
            },
            "rightCorner": {
              "x": -9.519,
              "y": -6.217,
              "z": 0.189
            },
            "gtin": "3449865384769",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d614",
        "height": 0.59027,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8540",
            "leftCorner": {
              "x": -9.457,
              "y": -7.467,
              "z": 0.483
            },
            "rightCorner": {
              "x": -9.457,
              "y": -6.883,
              "z": 0.483
            },
            "gtin": "4306188371274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8542",
            "leftCorner": {
              "x": -9.49,
              "y": -6.884,
              "z": 0.483
            },
            "rightCorner": {
              "x": -9.49,
              "y": -6.763,
              "z": 0.483
            },
            "gtin": "2000440424228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8543",
            "leftCorner": {
              "x": -9.497,
              "y": -6.763,
              "z": 0.483
            },
            "rightCorner": {
              "x": -9.497,
              "y": -6.693,
              "z": 0.483
            },
            "gtin": "4008128076859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8544",
            "leftCorner": {
              "x": -9.446,
              "y": -6.693,
              "z": 0.483
            },
            "rightCorner": {
              "x": -9.446,
              "y": -6.646,
              "z": 0.483
            },
            "gtin": "4005855460135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8545",
            "leftCorner": {
              "x": -9.497,
              "y": -6.646,
              "z": 0.483
            },
            "rightCorner": {
              "x": -9.497,
              "y": -6.568,
              "z": 0.483
            },
            "gtin": "4005855460135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8546",
            "leftCorner": {
              "x": -9.499,
              "y": -6.568,
              "z": 0.483
            },
            "rightCorner": {
              "x": -9.499,
              "y": -6.386,
              "z": 0.483
            },
            "gtin": "5908230515804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8547",
            "leftCorner": {
              "x": -9.504,
              "y": -6.386,
              "z": 0.483
            },
            "rightCorner": {
              "x": -9.504,
              "y": -6.265,
              "z": 0.483
            },
            "gtin": "5060079654929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8541",
            "leftCorner": {
              "x": -9.511,
              "y": -6.265,
              "z": 0.483
            },
            "rightCorner": {
              "x": -9.511,
              "y": -6.217,
              "z": 0.483
            },
            "gtin": "4251097420035",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d612",
        "height": 0.90661,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8530",
            "leftCorner": {
              "x": -9.462,
              "y": -7.467,
              "z": 0.742
            },
            "rightCorner": {
              "x": -9.462,
              "y": -7.133,
              "z": 0.742
            },
            "gtin": "4025374119994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8531",
            "leftCorner": {
              "x": -9.488,
              "y": -7.133,
              "z": 0.742
            },
            "rightCorner": {
              "x": -9.488,
              "y": -7.044,
              "z": 0.742
            },
            "gtin": "8725800007456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8532",
            "leftCorner": {
              "x": -9.493,
              "y": -7.044,
              "z": 0.742
            },
            "rightCorner": {
              "x": -9.493,
              "y": -6.959,
              "z": 0.742
            },
            "gtin": "4306188046868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8533",
            "leftCorner": {
              "x": -9.494,
              "y": -6.959,
              "z": 0.742
            },
            "rightCorner": {
              "x": -9.494,
              "y": -6.872,
              "z": 0.742
            },
            "gtin": "4008460293211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8534",
            "leftCorner": {
              "x": -9.502,
              "y": -6.872,
              "z": 0.742
            },
            "rightCorner": {
              "x": -9.502,
              "y": -6.79,
              "z": 0.742
            },
            "gtin": "4306188006367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8535",
            "leftCorner": {
              "x": -9.504,
              "y": -6.79,
              "z": 0.742
            },
            "rightCorner": {
              "x": -9.504,
              "y": -6.667,
              "z": 0.742
            },
            "gtin": "4004786010525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8536",
            "leftCorner": {
              "x": -9.503,
              "y": -6.667,
              "z": 0.742
            },
            "rightCorner": {
              "x": -9.503,
              "y": -6.565,
              "z": 0.742
            },
            "gtin": "8004225055649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8537",
            "leftCorner": {
              "x": -9.505,
              "y": -6.565,
              "z": 0.742
            },
            "rightCorner": {
              "x": -9.505,
              "y": -6.417,
              "z": 0.742
            },
            "gtin": "4004787055044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8538",
            "leftCorner": {
              "x": -9.511,
              "y": -6.417,
              "z": 0.742
            },
            "rightCorner": {
              "x": -9.511,
              "y": -6.3,
              "z": 0.742
            },
            "gtin": "4104690832654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8539",
            "leftCorner": {
              "x": -9.511,
              "y": -6.3,
              "z": 0.742
            },
            "rightCorner": {
              "x": -9.511,
              "y": -6.21,
              "z": 0.742
            },
            "gtin": "4104690833620",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d615",
        "height": 1.3907,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8548",
            "leftCorner": {
              "x": -9.5,
              "y": -7.467,
              "z": 1.138
            },
            "rightCorner": {
              "x": -9.5,
              "y": -7.017,
              "z": 1.138
            },
            "gtin": "8725800001546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8549",
            "leftCorner": {
              "x": -9.578,
              "y": -7.017,
              "z": 1.138
            },
            "rightCorner": {
              "x": -9.578,
              "y": -6.926,
              "z": 1.138
            },
            "gtin": "4250426224801",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d854a",
            "leftCorner": {
              "x": -9.555,
              "y": -6.926,
              "z": 1.138
            },
            "rightCorner": {
              "x": -9.555,
              "y": -6.839,
              "z": 1.138
            },
            "gtin": "4250426221787",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d854b",
            "leftCorner": {
              "x": -9.675,
              "y": -6.839,
              "z": 1.138
            },
            "rightCorner": {
              "x": -9.675,
              "y": -6.715,
              "z": 1.138
            },
            "gtin": "4250426224320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d854c",
            "leftCorner": {
              "x": -9.527,
              "y": -6.715,
              "z": 1.138
            },
            "rightCorner": {
              "x": -9.527,
              "y": -6.644,
              "z": 1.138
            },
            "gtin": "4250426224344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d854d",
            "leftCorner": {
              "x": -9.658,
              "y": -6.644,
              "z": 1.138
            },
            "rightCorner": {
              "x": -9.658,
              "y": -6.55,
              "z": 1.138
            },
            "gtin": "4004786013403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d854e",
            "leftCorner": {
              "x": -9.515,
              "y": -6.55,
              "z": 1.138
            },
            "rightCorner": {
              "x": -9.515,
              "y": -6.429,
              "z": 1.138
            },
            "gtin": "4004786011522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d854f",
            "leftCorner": {
              "x": -9.539,
              "y": -6.429,
              "z": 1.138
            },
            "rightCorner": {
              "x": -9.539,
              "y": -6.321,
              "z": 1.138
            },
            "gtin": "4004786017623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8550",
            "leftCorner": {
              "x": -9.538,
              "y": -6.321,
              "z": 1.138
            },
            "rightCorner": {
              "x": -9.538,
              "y": -6.236,
              "z": 1.138
            },
            "gtin": "9001745084554",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d610",
        "height": 1.8254,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8525",
            "leftCorner": {
              "x": -9.54,
              "y": -7.467,
              "z": 1.494
            },
            "rightCorner": {
              "x": -9.54,
              "y": -7.225,
              "z": 1.494
            },
            "gtin": "4005790243114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8526",
            "leftCorner": {
              "x": -9.532,
              "y": -7.225,
              "z": 1.494
            },
            "rightCorner": {
              "x": -9.532,
              "y": -7.117,
              "z": 1.494
            },
            "gtin": "4005790245644",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d8527",
            "leftCorner": {
              "x": -9.575,
              "y": -7.117,
              "z": 1.494
            },
            "rightCorner": {
              "x": -9.575,
              "y": -7.023,
              "z": 1.494
            },
            "gtin": "4005790246368",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d8528",
            "leftCorner": {
              "x": -9.693,
              "y": -7.023,
              "z": 1.494
            },
            "rightCorner": {
              "x": -9.693,
              "y": -6.959,
              "z": 1.494
            },
            "gtin": "4006229017214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8529",
            "leftCorner": {
              "x": -9.593,
              "y": -6.959,
              "z": 1.494
            },
            "rightCorner": {
              "x": -9.593,
              "y": -6.853,
              "z": 1.494
            },
            "gtin": "3449860000374",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d852a",
            "leftCorner": {
              "x": -9.584,
              "y": -6.853,
              "z": 1.494
            },
            "rightCorner": {
              "x": -9.584,
              "y": -6.754,
              "z": 1.494
            },
            "gtin": "8411814206878",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d852b",
            "leftCorner": {
              "x": -9.598,
              "y": -6.755,
              "z": 1.494
            },
            "rightCorner": {
              "x": -9.598,
              "y": -6.652,
              "z": 1.494
            },
            "gtin": "4003399024080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d852c",
            "leftCorner": {
              "x": -9.528,
              "y": -6.652,
              "z": 1.494
            },
            "rightCorner": {
              "x": -9.528,
              "y": -6.562,
              "z": 1.494
            },
            "gtin": "3071500414748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d852d",
            "leftCorner": {
              "x": -9.527,
              "y": -6.562,
              "z": 1.494
            },
            "rightCorner": {
              "x": -9.527,
              "y": -6.416,
              "z": 1.494
            },
            "gtin": "4008262015738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d852e",
            "leftCorner": {
              "x": -9.533,
              "y": -6.415,
              "z": 1.494
            },
            "rightCorner": {
              "x": -9.533,
              "y": -6.302,
              "z": 1.494
            },
            "gtin": "4005790246153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d852f",
            "leftCorner": {
              "x": -9.55,
              "y": -6.302,
              "z": 1.494
            },
            "rightCorner": {
              "x": -9.55,
              "y": -6.193,
              "z": 1.494
            },
            "gtin": "8725800007074",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "7d9",
    "name": "7d9",
    "x": -9.219,
    "y": -10.336,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70999,
      "w": 0.70421
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 6
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d616",
        "height": 1.3054,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8551",
            "leftCorner": {
              "x": -9.428,
              "y": -10.338,
              "z": 1.068
            },
            "rightCorner": {
              "x": -9.438,
              "y": -9.128,
              "z": 1.068
            },
            "gtin": "4005500087151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8552",
            "leftCorner": {
              "x": -9.471,
              "y": -9.128,
              "z": 1.068
            },
            "rightCorner": {
              "x": -9.471,
              "y": -9.088,
              "z": 1.068
            },
            "gtin": "4005500087151",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d617",
        "height": 1.6297,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8553",
            "leftCorner": {
              "x": -9.429,
              "y": -10.338,
              "z": 1.333
            },
            "rightCorner": {
              "x": -9.431,
              "y": -10.118,
              "z": 1.333
            },
            "gtin": "2000439121558",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d8555",
            "leftCorner": {
              "x": -9.468,
              "y": -10.118,
              "z": 1.333
            },
            "rightCorner": {
              "x": -9.47,
              "y": -9.865,
              "z": 1.333
            },
            "gtin": "8002470033313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8556",
            "leftCorner": {
              "x": -9.47,
              "y": -9.865,
              "z": 1.333
            },
            "rightCorner": {
              "x": -9.472,
              "y": -9.61,
              "z": 1.333
            },
            "gtin": "8002470033313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8557",
            "leftCorner": {
              "x": -9.472,
              "y": -9.61,
              "z": 1.333
            },
            "rightCorner": {
              "x": -9.474,
              "y": -9.356,
              "z": 1.333
            },
            "gtin": "8002470033313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8554",
            "leftCorner": {
              "x": -9.485,
              "y": -9.356,
              "z": 1.333
            },
            "rightCorner": {
              "x": -9.487,
              "y": -9.088,
              "z": 1.333
            },
            "gtin": "8002470021372",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "7da",
    "name": "7da",
    "x": -9.882,
    "y": -12.037,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.0047036
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 61
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ceb5",
        "height": 0.1696,
        "facings": [
          {
            "id": "5e301d46d871bced5fcd97ce",
            "leftCorner": {
              "x": -9.883,
              "y": -11.965,
              "z": 0.139
            },
            "rightCorner": {
              "x": -9.886,
              "y": -11.965,
              "z": 0.139
            },
            "gtin": "4250780324599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aaf8fb109912c4ff21608606",
            "leftCorner": {
              "x": -9.886,
              "y": -11.965,
              "z": 0.139
            },
            "rightCorner": {
              "x": -9.932,
              "y": -11.965,
              "z": 0.139
            },
            "gtin": "4250780324957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8accfe7ed7a10c42f2953af5",
            "leftCorner": {
              "x": -9.932,
              "y": -11.965,
              "z": 0.139
            },
            "rightCorner": {
              "x": -9.999,
              "y": -11.966,
              "z": 0.139
            },
            "gtin": "4250780324933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f31f8832cc30a2936c2c8c49",
            "leftCorner": {
              "x": -9.999,
              "y": -11.966,
              "z": 0.139
            },
            "rightCorner": {
              "x": -10.079,
              "y": -11.967,
              "z": 0.139
            },
            "gtin": "8053264991562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a31f56fdea7dd0b1768e128a",
            "leftCorner": {
              "x": -10.079,
              "y": -11.967,
              "z": 0.139
            },
            "rightCorner": {
              "x": -10.162,
              "y": -11.968,
              "z": 0.139
            },
            "gtin": "4250780325138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "56d1161e3be019d95d0591af",
            "leftCorner": {
              "x": -10.162,
              "y": -11.968,
              "z": 0.139
            },
            "rightCorner": {
              "x": -10.251,
              "y": -11.968,
              "z": 0.139
            },
            "gtin": "5200107490901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8bd52580c21112248a9c9fb8",
            "leftCorner": {
              "x": -10.251,
              "y": -11.968,
              "z": 0.139
            },
            "rightCorner": {
              "x": -10.344,
              "y": -11.969,
              "z": 0.139
            },
            "gtin": "4000540000528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c4e5df48e258151466490244",
            "leftCorner": {
              "x": -10.344,
              "y": -11.969,
              "z": 0.139
            },
            "rightCorner": {
              "x": -10.443,
              "y": -11.97,
              "z": 0.139
            },
            "gtin": "9120004950055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ddcb8c4e7e80121f9cbf09fd",
            "leftCorner": {
              "x": -10.443,
              "y": -11.97,
              "z": 0.139
            },
            "rightCorner": {
              "x": -10.545,
              "y": -11.971,
              "z": 0.139
            },
            "gtin": "5213003184683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "825d21ee468697377ee9eac1",
            "leftCorner": {
              "x": -10.545,
              "y": -11.971,
              "z": 0.139
            },
            "rightCorner": {
              "x": -10.65,
              "y": -11.972,
              "z": 0.139
            },
            "gtin": "5200118475904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9efd5f794d45cf8edf790f6f",
            "leftCorner": {
              "x": -10.65,
              "y": -11.972,
              "z": 0.139
            },
            "rightCorner": {
              "x": -10.759,
              "y": -11.973,
              "z": 0.139
            },
            "gtin": "4260106710340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0e53b736d3f0728017fc3eb8",
            "leftCorner": {
              "x": -10.759,
              "y": -11.973,
              "z": 0.139
            },
            "rightCorner": {
              "x": -10.868,
              "y": -11.974,
              "z": 0.139
            },
            "gtin": "5213003182320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "558582cc3a271ab88cfdf124",
            "leftCorner": {
              "x": -10.868,
              "y": -11.974,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.045,
              "y": -11.976,
              "z": 0.139
            },
            "gtin": "4104420030220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4f51c5613e279fdabf827d4f",
            "leftCorner": {
              "x": -11.045,
              "y": -11.976,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.131,
              "y": -11.977,
              "z": 0.139
            },
            "gtin": "4250780324605",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceb4",
        "height": 0.50007,
        "facings": [
          {
            "id": "68d8e508e1820c81800d52d5",
            "leftCorner": {
              "x": -9.883,
              "y": -11.987,
              "z": 0.409
            },
            "rightCorner": {
              "x": -9.975,
              "y": -11.987,
              "z": 0.409
            },
            "gtin": "4250426220896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52d6",
            "leftCorner": {
              "x": -9.975,
              "y": -11.987,
              "z": 0.409
            },
            "rightCorner": {
              "x": -10.067,
              "y": -11.988,
              "z": 0.409
            },
            "gtin": "4250426220896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52d7",
            "leftCorner": {
              "x": -10.067,
              "y": -11.988,
              "z": 0.409
            },
            "rightCorner": {
              "x": -10.16,
              "y": -11.989,
              "z": 0.409
            },
            "gtin": "4250426220896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52d8",
            "leftCorner": {
              "x": -10.16,
              "y": -11.989,
              "z": 0.409
            },
            "rightCorner": {
              "x": -10.252,
              "y": -11.99,
              "z": 0.409
            },
            "gtin": "4250426220896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52da",
            "leftCorner": {
              "x": -10.251,
              "y": -12.025,
              "z": 0.409
            },
            "rightCorner": {
              "x": -10.504,
              "y": -12.027,
              "z": 0.409
            },
            "gtin": "4260106719527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52db",
            "leftCorner": {
              "x": -10.504,
              "y": -12.029,
              "z": 0.409
            },
            "rightCorner": {
              "x": -10.643,
              "y": -12.031,
              "z": 0.409
            },
            "gtin": "4000540040302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52dc",
            "leftCorner": {
              "x": -10.643,
              "y": -12.031,
              "z": 0.409
            },
            "rightCorner": {
              "x": -10.782,
              "y": -12.032,
              "z": 0.409
            },
            "gtin": "4000540040302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52dd",
            "leftCorner": {
              "x": -10.782,
              "y": -12.035,
              "z": 0.409
            },
            "rightCorner": {
              "x": -10.903,
              "y": -12.036,
              "z": 0.409
            },
            "gtin": "4250780324582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52de",
            "leftCorner": {
              "x": -10.903,
              "y": -12.037,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.016,
              "y": -12.038,
              "z": 0.409
            },
            "gtin": "4260106710340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52df",
            "leftCorner": {
              "x": -11.016,
              "y": -12.037,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.086,
              "y": -12.038,
              "z": 0.409
            },
            "gtin": "8002470031937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52e0",
            "leftCorner": {
              "x": -11.086,
              "y": -12.038,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.155,
              "y": -12.039,
              "z": 0.409
            },
            "gtin": "8002470031937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52e1",
            "leftCorner": {
              "x": -11.155,
              "y": -12.039,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.225,
              "y": -12.039,
              "z": 0.409
            },
            "gtin": "8002470031937",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceb3",
        "height": 0.85052,
        "facings": [
          {
            "id": "68d8e508e1820c81800d52b5",
            "leftCorner": {
              "x": -9.883,
              "y": -11.986,
              "z": 0.696
            },
            "rightCorner": {
              "x": -9.966,
              "y": -11.987,
              "z": 0.696
            },
            "gtin": "4250780324605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52b6",
            "leftCorner": {
              "x": -9.966,
              "y": -11.987,
              "z": 0.696
            },
            "rightCorner": {
              "x": -10.049,
              "y": -11.988,
              "z": 0.696
            },
            "gtin": "4250780324605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52b8",
            "leftCorner": {
              "x": -10.048,
              "y": -12.034,
              "z": 0.696
            },
            "rightCorner": {
              "x": -10.176,
              "y": -12.034,
              "z": 0.696
            },
            "gtin": "4104420237490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52b9",
            "leftCorner": {
              "x": -10.176,
              "y": -12.025,
              "z": 0.696
            },
            "rightCorner": {
              "x": -10.323,
              "y": -12.026,
              "z": 0.696
            },
            "gtin": "4000540010312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52ba",
            "leftCorner": {
              "x": -10.323,
              "y": -12.026,
              "z": 0.696
            },
            "rightCorner": {
              "x": -10.569,
              "y": -12.029,
              "z": 0.696
            },
            "gtin": "4000540040135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52bb",
            "leftCorner": {
              "x": -10.569,
              "y": -12.031,
              "z": 0.696
            },
            "rightCorner": {
              "x": -10.695,
              "y": -12.032,
              "z": 0.696
            },
            "gtin": "4306188014607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52bc",
            "leftCorner": {
              "x": -10.695,
              "y": -12.037,
              "z": 0.696
            },
            "rightCorner": {
              "x": -10.827,
              "y": -12.039,
              "z": 0.696
            },
            "gtin": "7313844194310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52bd",
            "leftCorner": {
              "x": -10.827,
              "y": -12.04,
              "z": 0.696
            },
            "rightCorner": {
              "x": -10.98,
              "y": -12.042,
              "z": 0.696
            },
            "gtin": "4260106710364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52be",
            "leftCorner": {
              "x": -10.98,
              "y": -12.037,
              "z": 0.696
            },
            "rightCorner": {
              "x": -11.131,
              "y": -12.038,
              "z": 0.696
            },
            "gtin": "4104420235922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52bf",
            "leftCorner": {
              "x": -11.131,
              "y": -12.036,
              "z": 0.696
            },
            "rightCorner": {
              "x": -11.25,
              "y": -12.037,
              "z": 0.696
            },
            "gtin": "4250780324599",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceb2",
        "height": 1.1785,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5298",
            "leftCorner": {
              "x": -9.883,
              "y": -11.986,
              "z": 0.964
            },
            "rightCorner": {
              "x": -10.022,
              "y": -11.988,
              "z": 0.964
            },
            "gtin": "5200107490918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d529a",
            "leftCorner": {
              "x": -10.021,
              "y": -12.034,
              "z": 0.964
            },
            "rightCorner": {
              "x": -10.113,
              "y": -12.036,
              "z": 0.964
            },
            "gtin": "5200107490901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d529b",
            "leftCorner": {
              "x": -10.113,
              "y": -12.028,
              "z": 0.964
            },
            "rightCorner": {
              "x": -10.225,
              "y": -12.029,
              "z": 0.964
            },
            "gtin": "5213003182320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d529c",
            "leftCorner": {
              "x": -10.225,
              "y": -12.029,
              "z": 0.964
            },
            "rightCorner": {
              "x": -10.327,
              "y": -12.029,
              "z": 0.964
            },
            "gtin": "5213003184683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d529d",
            "leftCorner": {
              "x": -10.327,
              "y": -12.025,
              "z": 0.964
            },
            "rightCorner": {
              "x": -10.459,
              "y": -12.027,
              "z": 0.964
            },
            "gtin": "5200107495975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d529e",
            "leftCorner": {
              "x": -10.458,
              "y": -12.029,
              "z": 0.964
            },
            "rightCorner": {
              "x": -10.565,
              "y": -12.03,
              "z": 0.964
            },
            "gtin": "5203282998446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d529f",
            "leftCorner": {
              "x": -10.565,
              "y": -12.033,
              "z": 0.964
            },
            "rightCorner": {
              "x": -10.685,
              "y": -12.033,
              "z": 0.964
            },
            "gtin": "4104420248823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52a0",
            "leftCorner": {
              "x": -10.685,
              "y": -12.037,
              "z": 0.964
            },
            "rightCorner": {
              "x": -10.793,
              "y": -12.038,
              "z": 0.964
            },
            "gtin": "4104420235960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52a1",
            "leftCorner": {
              "x": -10.793,
              "y": -12.04,
              "z": 0.964
            },
            "rightCorner": {
              "x": -10.973,
              "y": -12.042,
              "z": 0.964
            },
            "gtin": "4104420030220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52a2",
            "leftCorner": {
              "x": -10.973,
              "y": -12.039,
              "z": 0.964
            },
            "rightCorner": {
              "x": -11.157,
              "y": -12.041,
              "z": 0.964
            },
            "gtin": "8053264991562",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceb1",
        "height": 1.5319,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5271",
            "leftCorner": {
              "x": -9.883,
              "y": -11.982,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.929,
              "y": -11.982,
              "z": 1.253
            },
            "gtin": "5200118475911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5272",
            "leftCorner": {
              "x": -9.929,
              "y": -11.982,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.974,
              "y": -11.982,
              "z": 1.253
            },
            "gtin": "5200118475911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5273",
            "leftCorner": {
              "x": -9.974,
              "y": -11.982,
              "z": 1.253
            },
            "rightCorner": {
              "x": -10.02,
              "y": -11.983,
              "z": 1.253
            },
            "gtin": "5200118475911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5275",
            "leftCorner": {
              "x": -10.019,
              "y": -12.026,
              "z": 1.253
            },
            "rightCorner": {
              "x": -10.125,
              "y": -12.027,
              "z": 1.253
            },
            "gtin": "5200118475904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5276",
            "leftCorner": {
              "x": -10.125,
              "y": -12.022,
              "z": 1.253
            },
            "rightCorner": {
              "x": -10.232,
              "y": -12.022,
              "z": 1.253
            },
            "gtin": "7313840049263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5277",
            "leftCorner": {
              "x": -10.232,
              "y": -12.022,
              "z": 1.253
            },
            "rightCorner": {
              "x": -10.338,
              "y": -12.023,
              "z": 1.253
            },
            "gtin": "7313840049263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5278",
            "leftCorner": {
              "x": -10.338,
              "y": -12.02,
              "z": 1.253
            },
            "rightCorner": {
              "x": -10.483,
              "y": -12.022,
              "z": 1.253
            },
            "gtin": "80053828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5279",
            "leftCorner": {
              "x": -10.483,
              "y": -12.025,
              "z": 1.253
            },
            "rightCorner": {
              "x": -10.605,
              "y": -12.026,
              "z": 1.253
            },
            "gtin": "8005510005080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d527a",
            "leftCorner": {
              "x": -10.605,
              "y": -12.028,
              "z": 1.253
            },
            "rightCorner": {
              "x": -10.699,
              "y": -12.028,
              "z": 1.253
            },
            "gtin": "4000540000528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d527b",
            "leftCorner": {
              "x": -10.699,
              "y": -12.03,
              "z": 1.253
            },
            "rightCorner": {
              "x": -10.8,
              "y": -12.032,
              "z": 1.253
            },
            "gtin": "9120004950055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d527c",
            "leftCorner": {
              "x": -10.8,
              "y": -12.031,
              "z": 1.253
            },
            "rightCorner": {
              "x": -10.881,
              "y": -12.031,
              "z": 1.253
            },
            "gtin": "4250780325138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d527d",
            "leftCorner": {
              "x": -10.881,
              "y": -12.035,
              "z": 1.253
            },
            "rightCorner": {
              "x": -10.948,
              "y": -12.036,
              "z": 1.253
            },
            "gtin": "4250780324919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d527e",
            "leftCorner": {
              "x": -10.948,
              "y": -12.036,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.016,
              "y": -12.036,
              "z": 1.253
            },
            "gtin": "4250780324919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d527f",
            "leftCorner": {
              "x": -11.016,
              "y": -12.032,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.065,
              "y": -12.033,
              "z": 1.253
            },
            "gtin": "4250780324957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5280",
            "leftCorner": {
              "x": -11.065,
              "y": -12.034,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.166,
              "y": -12.036,
              "z": 1.253
            },
            "gtin": "4250780324933",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "7dd"
  },
  {
    "id": "7dd",
    "name": "7dd",
    "x": -11.132,
    "y": -12.049,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.0047036
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 52
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ceba",
        "height": 0.17066,
        "facings": [
          {
            "id": "68d8e508e1820c81800d52fb",
            "leftCorner": {
              "x": -11.833,
              "y": -11.986,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.923,
              "y": -11.986,
              "z": 0.14
            },
            "gtin": "4104420031012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a242e3adf1333cb899a5f3ae",
            "leftCorner": {
              "x": -11.133,
              "y": -11.945,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.223,
              "y": -11.946,
              "z": 0.14
            },
            "gtin": "4104420031012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e8199e5493aa833fc860b425",
            "leftCorner": {
              "x": -11.223,
              "y": -11.946,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.455,
              "y": -11.948,
              "z": 0.14
            },
            "gtin": "40122083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f9ce9c0e276b43928d832f63",
            "leftCorner": {
              "x": -11.455,
              "y": -11.948,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.688,
              "y": -11.95,
              "z": 0.14
            },
            "gtin": "4012200019108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9f7f89a634945d58f1d59465",
            "leftCorner": {
              "x": -11.688,
              "y": -11.95,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.778,
              "y": -11.951,
              "z": 0.14
            },
            "gtin": "4104420031012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52fc",
            "leftCorner": {
              "x": -11.923,
              "y": -11.984,
              "z": 0.14
            },
            "rightCorner": {
              "x": -12.149,
              "y": -11.986,
              "z": 0.14
            },
            "gtin": "40122083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52fd",
            "leftCorner": {
              "x": -12.149,
              "y": -11.988,
              "z": 0.14
            },
            "rightCorner": {
              "x": -12.423,
              "y": -11.99,
              "z": 0.14
            },
            "gtin": "4012200019108",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceb8",
        "height": 0.49984,
        "facings": [
          {
            "id": "68d8e508e1820c81800d52e2",
            "leftCorner": {
              "x": -11.226,
              "y": -12.034,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.391,
              "y": -12.036,
              "z": 0.409
            },
            "gtin": "8002470031944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7c78d7842a4c00ade82b4684",
            "leftCorner": {
              "x": -11.133,
              "y": -11.999,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.226,
              "y": -12.0,
              "z": 0.409
            },
            "gtin": "8002470031616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52e3",
            "leftCorner": {
              "x": -11.391,
              "y": -12.037,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.498,
              "y": -12.038,
              "z": 0.409
            },
            "gtin": "8002470024595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52e4",
            "leftCorner": {
              "x": -11.498,
              "y": -12.044,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.591,
              "y": -12.045,
              "z": 0.409
            },
            "gtin": "8002470031616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52e5",
            "leftCorner": {
              "x": -11.591,
              "y": -12.045,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.685,
              "y": -12.046,
              "z": 0.409
            },
            "gtin": "8002470031616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52e6",
            "leftCorner": {
              "x": -11.685,
              "y": -12.047,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.811,
              "y": -12.048,
              "z": 0.409
            },
            "gtin": "4000540100419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52e7",
            "leftCorner": {
              "x": -11.811,
              "y": -12.048,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.962,
              "y": -12.049,
              "z": 0.409
            },
            "gtin": "40737584",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d52e8",
            "leftCorner": {
              "x": -11.962,
              "y": -12.046,
              "z": 0.409
            },
            "rightCorner": {
              "x": -12.13,
              "y": -12.047,
              "z": 0.409
            },
            "gtin": "4003387005008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52e9",
            "leftCorner": {
              "x": -12.13,
              "y": -12.047,
              "z": 0.409
            },
            "rightCorner": {
              "x": -12.449,
              "y": -12.051,
              "z": 0.409
            },
            "gtin": "4306188019442",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceb7",
        "height": 0.85045,
        "facings": [
          {
            "id": "68d8e508e1820c81800d52c0",
            "leftCorner": {
              "x": -11.25,
              "y": -12.036,
              "z": 0.696
            },
            "rightCorner": {
              "x": -11.403,
              "y": -12.038,
              "z": 0.696
            },
            "gtin": "8002470021372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fe5e05731fbd51ec534cfb36",
            "leftCorner": {
              "x": -11.133,
              "y": -11.999,
              "z": 0.696
            },
            "rightCorner": {
              "x": -11.233,
              "y": -12.0,
              "z": 0.696
            },
            "gtin": "4250780324599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52c1",
            "leftCorner": {
              "x": -11.403,
              "y": -12.042,
              "z": 0.696
            },
            "rightCorner": {
              "x": -11.494,
              "y": -12.043,
              "z": 0.696
            },
            "gtin": "8002470032798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52c2",
            "leftCorner": {
              "x": -11.494,
              "y": -12.043,
              "z": 0.696
            },
            "rightCorner": {
              "x": -11.588,
              "y": -12.044,
              "z": 0.696
            },
            "gtin": "4104420178656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52c3",
            "leftCorner": {
              "x": -11.588,
              "y": -12.048,
              "z": 0.696
            },
            "rightCorner": {
              "x": -11.689,
              "y": -12.049,
              "z": 0.696
            },
            "gtin": "4104420204508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52c4",
            "leftCorner": {
              "x": -11.689,
              "y": -12.048,
              "z": 0.696
            },
            "rightCorner": {
              "x": -11.775,
              "y": -12.048,
              "z": 0.696
            },
            "gtin": "4104420025929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52c5",
            "leftCorner": {
              "x": -11.775,
              "y": -12.044,
              "z": 0.696
            },
            "rightCorner": {
              "x": -11.857,
              "y": -12.045,
              "z": 0.696
            },
            "gtin": "5713355003064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52c6",
            "leftCorner": {
              "x": -11.857,
              "y": -12.043,
              "z": 0.696
            },
            "rightCorner": {
              "x": -11.963,
              "y": -12.045,
              "z": 0.696
            },
            "gtin": "5200428301016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52c7",
            "leftCorner": {
              "x": -11.963,
              "y": -12.047,
              "z": 0.696
            },
            "rightCorner": {
              "x": -12.074,
              "y": -12.048,
              "z": 0.696
            },
            "gtin": "5200428301023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52c8",
            "leftCorner": {
              "x": -12.074,
              "y": -12.046,
              "z": 0.696
            },
            "rightCorner": {
              "x": -12.177,
              "y": -12.047,
              "z": 0.696
            },
            "gtin": "5200428300996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52c9",
            "leftCorner": {
              "x": -12.178,
              "y": -12.044,
              "z": 0.696
            },
            "rightCorner": {
              "x": -12.289,
              "y": -12.045,
              "z": 0.696
            },
            "gtin": "5200120445087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52ca",
            "leftCorner": {
              "x": -12.289,
              "y": -12.048,
              "z": 0.696
            },
            "rightCorner": {
              "x": -12.364,
              "y": -12.048,
              "z": 0.696
            },
            "gtin": "5200120445124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52cb",
            "leftCorner": {
              "x": -12.364,
              "y": -12.048,
              "z": 0.696
            },
            "rightCorner": {
              "x": -12.439,
              "y": -12.05,
              "z": 0.696
            },
            "gtin": "5200120445124",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceb9",
        "height": 1.1788,
        "facings": [
          {
            "id": "68d8e508e1820c81800d52a3",
            "leftCorner": {
              "x": -11.157,
              "y": -12.036,
              "z": 0.964
            },
            "rightCorner": {
              "x": -11.392,
              "y": -12.038,
              "z": 0.964
            },
            "gtin": "4005500087151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52a4",
            "leftCorner": {
              "x": -11.391,
              "y": -12.043,
              "z": 0.964
            },
            "rightCorner": {
              "x": -11.536,
              "y": -12.045,
              "z": 0.964
            },
            "gtin": "4000540030136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52a5",
            "leftCorner": {
              "x": -11.536,
              "y": -12.047,
              "z": 0.964
            },
            "rightCorner": {
              "x": -11.674,
              "y": -12.048,
              "z": 0.964
            },
            "gtin": "8719200034259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52a6",
            "leftCorner": {
              "x": -11.674,
              "y": -12.049,
              "z": 0.964
            },
            "rightCorner": {
              "x": -11.78,
              "y": -12.05,
              "z": 0.964
            },
            "gtin": "5028905028498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52a7",
            "leftCorner": {
              "x": -11.78,
              "y": -12.048,
              "z": 0.964
            },
            "rightCorner": {
              "x": -11.873,
              "y": -12.049,
              "z": 0.964
            },
            "gtin": "4260644043894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52a8",
            "leftCorner": {
              "x": -11.873,
              "y": -12.047,
              "z": 0.964
            },
            "rightCorner": {
              "x": -11.971,
              "y": -12.048,
              "z": 0.964
            },
            "gtin": "8002470033214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52a9",
            "leftCorner": {
              "x": -11.971,
              "y": -12.047,
              "z": 0.964
            },
            "rightCorner": {
              "x": -12.022,
              "y": -12.048,
              "z": 0.964
            },
            "gtin": "8002470033375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52aa",
            "leftCorner": {
              "x": -12.022,
              "y": -12.048,
              "z": 0.964
            },
            "rightCorner": {
              "x": -12.074,
              "y": -12.049,
              "z": 0.964
            },
            "gtin": "8002470033375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52ab",
            "leftCorner": {
              "x": -12.074,
              "y": -12.05,
              "z": 0.964
            },
            "rightCorner": {
              "x": -12.157,
              "y": -12.05,
              "z": 0.964
            },
            "gtin": "4000540030112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52ac",
            "leftCorner": {
              "x": -12.157,
              "y": -12.046,
              "z": 0.964
            },
            "rightCorner": {
              "x": -12.431,
              "y": -12.048,
              "z": 0.964
            },
            "gtin": "4000540010138",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceb6",
        "height": 1.5307,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5281",
            "leftCorner": {
              "x": -11.167,
              "y": -12.028,
              "z": 1.252
            },
            "rightCorner": {
              "x": -11.257,
              "y": -12.029,
              "z": 1.252
            },
            "gtin": "4008314186171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f980bdf8396ac9a8e4818bef",
            "leftCorner": {
              "x": -11.133,
              "y": -11.993,
              "z": 1.252
            },
            "rightCorner": {
              "x": -11.144,
              "y": -11.993,
              "z": 1.252
            },
            "gtin": "4306188372387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "473104a4e5837a8dbc71bfa4",
            "leftCorner": {
              "x": -11.144,
              "y": -11.993,
              "z": 1.252
            },
            "rightCorner": {
              "x": -11.155,
              "y": -11.993,
              "z": 1.252
            },
            "gtin": "4306188372387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fc615568d62eb6ed4c6e3f3a",
            "leftCorner": {
              "x": -11.155,
              "y": -11.993,
              "z": 1.252
            },
            "rightCorner": {
              "x": -11.166,
              "y": -11.993,
              "z": 1.252
            },
            "gtin": "4306188372387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5282",
            "leftCorner": {
              "x": -11.257,
              "y": -12.029,
              "z": 1.252
            },
            "rightCorner": {
              "x": -11.365,
              "y": -12.03,
              "z": 1.252
            },
            "gtin": "4013200381790",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d5283",
            "leftCorner": {
              "x": -11.365,
              "y": -12.035,
              "z": 1.252
            },
            "rightCorner": {
              "x": -11.486,
              "y": -12.036,
              "z": 1.252
            },
            "gtin": "4013200381783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5284",
            "leftCorner": {
              "x": -11.486,
              "y": -12.039,
              "z": 1.252
            },
            "rightCorner": {
              "x": -11.612,
              "y": -12.04,
              "z": 1.252
            },
            "gtin": "4008722010129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5285",
            "leftCorner": {
              "x": -11.612,
              "y": -12.04,
              "z": 1.252
            },
            "rightCorner": {
              "x": -11.717,
              "y": -12.04,
              "z": 1.252
            },
            "gtin": "4400050320046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5286",
            "leftCorner": {
              "x": -11.717,
              "y": -12.039,
              "z": 1.252
            },
            "rightCorner": {
              "x": -11.813,
              "y": -12.041,
              "z": 1.252
            },
            "gtin": "4400050320053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5287",
            "leftCorner": {
              "x": -11.813,
              "y": -12.042,
              "z": 1.252
            },
            "rightCorner": {
              "x": -11.895,
              "y": -12.043,
              "z": 1.252
            },
            "gtin": "4400050320282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5288",
            "leftCorner": {
              "x": -11.895,
              "y": -12.041,
              "z": 1.252
            },
            "rightCorner": {
              "x": -11.977,
              "y": -12.041,
              "z": 1.252
            },
            "gtin": "4400050320275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5289",
            "leftCorner": {
              "x": -11.977,
              "y": -12.04,
              "z": 1.252
            },
            "rightCorner": {
              "x": -12.162,
              "y": -12.042,
              "z": 1.252
            },
            "gtin": "4400050320428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d528a",
            "leftCorner": {
              "x": -12.162,
              "y": -12.043,
              "z": 1.252
            },
            "rightCorner": {
              "x": -12.259,
              "y": -12.043,
              "z": 1.252
            },
            "gtin": "8002470032781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d528b",
            "leftCorner": {
              "x": -12.259,
              "y": -12.042,
              "z": 1.252
            },
            "rightCorner": {
              "x": -12.369,
              "y": -12.043,
              "z": 1.252
            },
            "gtin": "4306188372417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d528c",
            "leftCorner": {
              "x": -12.369,
              "y": -12.019,
              "z": 1.252
            },
            "rightCorner": {
              "x": -12.477,
              "y": -12.021,
              "z": 1.252
            },
            "gtin": "4306188372387",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7da",
    "rightNeighborShelfId": "7de"
  },
  {
    "id": "7de",
    "name": "7de",
    "x": -12.382,
    "y": -12.061,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.0047036
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 57
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539cebf",
        "height": 0.17415,
        "facings": [
          {
            "id": "abfd5b60d32df95819c42df7",
            "leftCorner": {
              "x": -12.383,
              "y": -11.963,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.426,
              "y": -11.963,
              "z": 0.142
            },
            "gtin": "4104420183384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3faad3038422cffbe127f95d",
            "leftCorner": {
              "x": -12.426,
              "y": -11.963,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.463,
              "y": -11.964,
              "z": 0.142
            },
            "gtin": "4008100120167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "29e2a8c1234d4866ad085060",
            "leftCorner": {
              "x": -12.463,
              "y": -11.964,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.506,
              "y": -11.964,
              "z": 0.142
            },
            "gtin": "4104420183384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "05e243f31c3d9f336fbb3667",
            "leftCorner": {
              "x": -12.506,
              "y": -11.964,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.557,
              "y": -11.965,
              "z": 0.142
            },
            "gtin": "4306188026150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1708047094d293277c8aa91d",
            "leftCorner": {
              "x": -12.557,
              "y": -11.965,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.64,
              "y": -11.965,
              "z": 0.142
            },
            "gtin": "4018462416501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "69cf29033073d9e48fc7d8bc",
            "leftCorner": {
              "x": -12.64,
              "y": -11.965,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.726,
              "y": -11.966,
              "z": 0.142
            },
            "gtin": "4104420214422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9cd2598b156e8f6a0c9d60fe",
            "leftCorner": {
              "x": -12.726,
              "y": -11.966,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.812,
              "y": -11.967,
              "z": 0.142
            },
            "gtin": "4013200331535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7a15749e57b0cc10f11001c5",
            "leftCorner": {
              "x": -12.812,
              "y": -11.967,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.899,
              "y": -11.968,
              "z": 0.142
            },
            "gtin": "5203817706898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee3b4a82dde192dff5f6e29c",
            "leftCorner": {
              "x": -12.899,
              "y": -11.968,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.986,
              "y": -11.969,
              "z": 0.142
            },
            "gtin": "5203817706881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "10eead3f565b554f53c0de14",
            "leftCorner": {
              "x": -12.986,
              "y": -11.969,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.075,
              "y": -11.969,
              "z": 0.142
            },
            "gtin": "40804040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5ebae0bab781ce873659813d",
            "leftCorner": {
              "x": -13.075,
              "y": -11.969,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.17,
              "y": -11.97,
              "z": 0.142
            },
            "gtin": "4260742566530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cd8f8d8351554509cd0ec808",
            "leftCorner": {
              "x": -13.17,
              "y": -11.97,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.266,
              "y": -11.971,
              "z": 0.142
            },
            "gtin": "5203817706089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ceec186734cab0ae12365318",
            "leftCorner": {
              "x": -13.266,
              "y": -11.971,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.377,
              "y": -11.972,
              "z": 0.142
            },
            "gtin": "4260742566554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "58120d1d3618a77967f9cbb1",
            "leftCorner": {
              "x": -13.377,
              "y": -11.972,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.589,
              "y": -11.974,
              "z": 0.142
            },
            "gtin": "4306188403791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7440e9f21c164d351bdda841",
            "leftCorner": {
              "x": -13.589,
              "y": -11.974,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.632,
              "y": -11.975,
              "z": 0.142
            },
            "gtin": "4104420183384",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cebb",
        "height": 0.50275,
        "facings": [
          {
            "id": "68d8e508e1820c81800d52ea",
            "leftCorner": {
              "x": -12.449,
              "y": -12.05,
              "z": 0.411
            },
            "rightCorner": {
              "x": -12.604,
              "y": -12.052,
              "z": 0.411
            },
            "gtin": "40122038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52eb",
            "leftCorner": {
              "x": -12.604,
              "y": -12.052,
              "z": 0.411
            },
            "rightCorner": {
              "x": -12.731,
              "y": -12.052,
              "z": 0.411
            },
            "gtin": "4012200019207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52ec",
            "leftCorner": {
              "x": -12.731,
              "y": -12.052,
              "z": 0.411
            },
            "rightCorner": {
              "x": -12.857,
              "y": -12.054,
              "z": 0.411
            },
            "gtin": "4012200019207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52ed",
            "leftCorner": {
              "x": -12.857,
              "y": -12.056,
              "z": 0.411
            },
            "rightCorner": {
              "x": -13.004,
              "y": -12.057,
              "z": 0.411
            },
            "gtin": "4306188403913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52ee",
            "leftCorner": {
              "x": -13.004,
              "y": -12.06,
              "z": 0.411
            },
            "rightCorner": {
              "x": -13.141,
              "y": -12.062,
              "z": 0.411
            },
            "gtin": "4306188403883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52ef",
            "leftCorner": {
              "x": -13.141,
              "y": -12.055,
              "z": 0.411
            },
            "rightCorner": {
              "x": -13.297,
              "y": -12.056,
              "z": 0.411
            },
            "gtin": "4306188026150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52f0",
            "leftCorner": {
              "x": -13.297,
              "y": -12.062,
              "z": 0.411
            },
            "rightCorner": {
              "x": -13.417,
              "y": -12.063,
              "z": 0.411
            },
            "gtin": "4306188026143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52d9",
            "leftCorner": {
              "x": -13.417,
              "y": -12.057,
              "z": 0.411
            },
            "rightCorner": {
              "x": -13.632,
              "y": -12.059,
              "z": 0.411
            },
            "gtin": "4306188403791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d514a3f170a0e1a067b19a27",
            "leftCorner": {
              "x": -12.382,
              "y": -12.01,
              "z": 0.411
            },
            "rightCorner": {
              "x": -12.434,
              "y": -12.01,
              "z": 0.411
            },
            "gtin": "4306188026150",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cebe",
        "height": 0.85135,
        "facings": [
          {
            "id": "68d8e508e1820c81800d52cc",
            "leftCorner": {
              "x": -12.439,
              "y": -12.055,
              "z": 0.697
            },
            "rightCorner": {
              "x": -12.568,
              "y": -12.057,
              "z": 0.697
            },
            "gtin": "40198132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52cd",
            "leftCorner": {
              "x": -12.568,
              "y": -12.056,
              "z": 0.697
            },
            "rightCorner": {
              "x": -12.698,
              "y": -12.057,
              "z": 0.697
            },
            "gtin": "40198095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52ce",
            "leftCorner": {
              "x": -12.698,
              "y": -12.056,
              "z": 0.697
            },
            "rightCorner": {
              "x": -12.83,
              "y": -12.056,
              "z": 0.697
            },
            "gtin": "40122281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52cf",
            "leftCorner": {
              "x": -12.83,
              "y": -12.058,
              "z": 0.697
            },
            "rightCorner": {
              "x": -12.958,
              "y": -12.06,
              "z": 0.697
            },
            "gtin": "40804248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52d0",
            "leftCorner": {
              "x": -12.958,
              "y": -12.063,
              "z": 0.697
            },
            "rightCorner": {
              "x": -13.084,
              "y": -12.064,
              "z": 0.697
            },
            "gtin": "40737393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52d1",
            "leftCorner": {
              "x": -13.084,
              "y": -12.068,
              "z": 0.697
            },
            "rightCorner": {
              "x": -13.139,
              "y": -12.068,
              "z": 0.697
            },
            "gtin": "4104420231542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52d2",
            "leftCorner": {
              "x": -13.139,
              "y": -12.068,
              "z": 0.697
            },
            "rightCorner": {
              "x": -13.193,
              "y": -12.068,
              "z": 0.697
            },
            "gtin": "4104420231542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52d3",
            "leftCorner": {
              "x": -13.193,
              "y": -12.07,
              "z": 0.697
            },
            "rightCorner": {
              "x": -13.351,
              "y": -12.072,
              "z": 0.697
            },
            "gtin": "40122199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52d4",
            "leftCorner": {
              "x": -13.351,
              "y": -12.067,
              "z": 0.697
            },
            "rightCorner": {
              "x": -13.484,
              "y": -12.068,
              "z": 0.697
            },
            "gtin": "4012200168608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52b7",
            "leftCorner": {
              "x": -13.485,
              "y": -12.062,
              "z": 0.697
            },
            "rightCorner": {
              "x": -13.632,
              "y": -12.064,
              "z": 0.697
            },
            "gtin": "4012200016084",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cebc",
        "height": 1.1794,
        "facings": [
          {
            "id": "68d8e508e1820c81800d52ad",
            "leftCorner": {
              "x": -12.43,
              "y": -12.051,
              "z": 0.965
            },
            "rightCorner": {
              "x": -12.595,
              "y": -12.054,
              "z": 0.965
            },
            "gtin": "4018462416501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52ae",
            "leftCorner": {
              "x": -12.595,
              "y": -12.053,
              "z": 0.965
            },
            "rightCorner": {
              "x": -12.728,
              "y": -12.054,
              "z": 0.965
            },
            "gtin": "4104420030961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52af",
            "leftCorner": {
              "x": -12.728,
              "y": -12.054,
              "z": 0.965
            },
            "rightCorner": {
              "x": -12.851,
              "y": -12.055,
              "z": 0.965
            },
            "gtin": "4104420030923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52b0",
            "leftCorner": {
              "x": -12.851,
              "y": -12.058,
              "z": 0.965
            },
            "rightCorner": {
              "x": -12.936,
              "y": -12.059,
              "z": 0.965
            },
            "gtin": "4104420214422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52b1",
            "leftCorner": {
              "x": -12.936,
              "y": -12.059,
              "z": 0.965
            },
            "rightCorner": {
              "x": -13.028,
              "y": -12.06,
              "z": 0.965
            },
            "gtin": "4260742566530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52b2",
            "leftCorner": {
              "x": -13.028,
              "y": -12.065,
              "z": 0.965
            },
            "rightCorner": {
              "x": -13.138,
              "y": -12.066,
              "z": 0.965
            },
            "gtin": "4260742566554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52b3",
            "leftCorner": {
              "x": -13.138,
              "y": -12.069,
              "z": 0.965
            },
            "rightCorner": {
              "x": -13.31,
              "y": -12.071,
              "z": 0.965
            },
            "gtin": "4008100120662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d52b4",
            "leftCorner": {
              "x": -13.31,
              "y": -12.072,
              "z": 0.965
            },
            "rightCorner": {
              "x": -13.484,
              "y": -12.073,
              "z": 0.965
            },
            "gtin": "4008100120068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5299",
            "leftCorner": {
              "x": -13.484,
              "y": -12.063,
              "z": 0.965
            },
            "rightCorner": {
              "x": -13.632,
              "y": -12.065,
              "z": 0.965
            },
            "gtin": "4008100120167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "73150b91d23d3cb38827eb0b",
            "leftCorner": {
              "x": -12.383,
              "y": -12.014,
              "z": 0.965
            },
            "rightCorner": {
              "x": -12.42,
              "y": -12.014,
              "z": 0.965
            },
            "gtin": "4008100120167",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cebd",
        "height": 1.5318,
        "facings": [
          {
            "id": "68d8e508e1820c81800d528d",
            "leftCorner": {
              "x": -12.477,
              "y": -12.039,
              "z": 1.253
            },
            "rightCorner": {
              "x": -12.612,
              "y": -12.04,
              "z": 1.253
            },
            "gtin": "5203817706874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8528d9099766d91891152b73",
            "leftCorner": {
              "x": -12.382,
              "y": -12.006,
              "z": 1.253
            },
            "rightCorner": {
              "x": -12.475,
              "y": -12.007,
              "z": 1.253
            },
            "gtin": "4013200331566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b98fc37ac55fc9209ecde753",
            "leftCorner": {
              "x": -13.586,
              "y": -12.017,
              "z": 1.253
            },
            "rightCorner": {
              "x": -13.629,
              "y": -12.018,
              "z": 1.253
            },
            "gtin": "4104420183384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d528e",
            "leftCorner": {
              "x": -12.612,
              "y": -12.043,
              "z": 1.253
            },
            "rightCorner": {
              "x": -12.801,
              "y": -12.045,
              "z": 1.253
            },
            "gtin": "5203817706850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d528f",
            "leftCorner": {
              "x": -12.801,
              "y": -12.048,
              "z": 1.253
            },
            "rightCorner": {
              "x": -12.888,
              "y": -12.049,
              "z": 1.253
            },
            "gtin": "5203817706898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5290",
            "leftCorner": {
              "x": -12.888,
              "y": -12.047,
              "z": 1.253
            },
            "rightCorner": {
              "x": -12.973,
              "y": -12.048,
              "z": 1.253
            },
            "gtin": "5203817706881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5291",
            "leftCorner": {
              "x": -12.973,
              "y": -12.053,
              "z": 1.253
            },
            "rightCorner": {
              "x": -13.058,
              "y": -12.054,
              "z": 1.253
            },
            "gtin": "5203817706065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5292",
            "leftCorner": {
              "x": -13.058,
              "y": -12.054,
              "z": 1.253
            },
            "rightCorner": {
              "x": -13.143,
              "y": -12.055,
              "z": 1.253
            },
            "gtin": "5203817706065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5293",
            "leftCorner": {
              "x": -13.143,
              "y": -12.061,
              "z": 1.253
            },
            "rightCorner": {
              "x": -13.237,
              "y": -12.062,
              "z": 1.253
            },
            "gtin": "5203817706089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5294",
            "leftCorner": {
              "x": -13.237,
              "y": -12.061,
              "z": 1.253
            },
            "rightCorner": {
              "x": -13.328,
              "y": -12.062,
              "z": 1.253
            },
            "gtin": "40804040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5295",
            "leftCorner": {
              "x": -13.328,
              "y": -12.057,
              "z": 1.253
            },
            "rightCorner": {
              "x": -13.41,
              "y": -12.058,
              "z": 1.253
            },
            "gtin": "4013200331535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5296",
            "leftCorner": {
              "x": -13.41,
              "y": -12.054,
              "z": 1.253
            },
            "rightCorner": {
              "x": -13.498,
              "y": -12.055,
              "z": 1.253
            },
            "gtin": "4013200331566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5297",
            "leftCorner": {
              "x": -13.498,
              "y": -12.055,
              "z": 1.253
            },
            "rightCorner": {
              "x": -13.586,
              "y": -12.056,
              "z": 1.253
            },
            "gtin": "4013200331566",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7dd",
    "rightNeighborShelfId": "7df"
  },
  {
    "id": "7df",
    "name": "7df",
    "x": -13.632,
    "y": -12.073,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.0047036
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 55
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539cec5",
        "height": 0.17228,
        "facings": [
          {
            "id": "aa70d9abfa87eb7023987a22",
            "leftCorner": {
              "x": -13.632,
              "y": -11.989,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.71,
              "y": -11.99,
              "z": 0.141
            },
            "gtin": "8714100823606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2630fb3650878f47945eaca9",
            "leftCorner": {
              "x": -13.71,
              "y": -11.99,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.789,
              "y": -11.99,
              "z": 0.141
            },
            "gtin": "40122953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d9da971eca3039539a5c2e0b",
            "leftCorner": {
              "x": -13.789,
              "y": -11.99,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.868,
              "y": -11.991,
              "z": 0.141
            },
            "gtin": "8714100823637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b229de39562249b9d0568a4a",
            "leftCorner": {
              "x": -13.868,
              "y": -11.991,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.948,
              "y": -11.992,
              "z": 0.141
            },
            "gtin": "8714100823620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "db2dd1aab08435b0a302d574",
            "leftCorner": {
              "x": -13.948,
              "y": -11.992,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.028,
              "y": -11.993,
              "z": 0.141
            },
            "gtin": "4006824008013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ba89e477ebb5fc8d5d6cbb11",
            "leftCorner": {
              "x": -14.028,
              "y": -11.993,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.112,
              "y": -11.994,
              "z": 0.141
            },
            "gtin": "4006824028219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1e173f36aca33a350b6826c0",
            "leftCorner": {
              "x": -14.112,
              "y": -11.994,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.197,
              "y": -11.994,
              "z": 0.141
            },
            "gtin": "8714100823576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fa2c0afc531e8f58ab9e58c7",
            "leftCorner": {
              "x": -14.197,
              "y": -11.994,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.288,
              "y": -11.995,
              "z": 0.141
            },
            "gtin": "4400139020010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "74439bbcbbfc60a88da712af",
            "leftCorner": {
              "x": -14.288,
              "y": -11.995,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.382,
              "y": -11.996,
              "z": 0.141
            },
            "gtin": "8714100823705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fbc2edfa7b7488323082e941",
            "leftCorner": {
              "x": -14.382,
              "y": -11.996,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.477,
              "y": -11.997,
              "z": 0.141
            },
            "gtin": "9120090282436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aea1d3858502edf84b835f44",
            "leftCorner": {
              "x": -14.477,
              "y": -11.997,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.573,
              "y": -11.998,
              "z": 0.141
            },
            "gtin": "4000186038107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7a5ff1a0c8633bedfd2a817f",
            "leftCorner": {
              "x": -14.573,
              "y": -11.998,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.809,
              "y": -12.0,
              "z": 0.141
            },
            "gtin": "8720182757739",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cec0",
        "height": 0.47824,
        "facings": [
          {
            "id": "68d8e508e1820c81800d530b",
            "leftCorner": {
              "x": -13.633,
              "y": -12.021,
              "z": 0.391
            },
            "rightCorner": {
              "x": -13.765,
              "y": -12.022,
              "z": 0.391
            },
            "gtin": "4006824018111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d530d",
            "leftCorner": {
              "x": -13.764,
              "y": -12.064,
              "z": 0.391
            },
            "rightCorner": {
              "x": -13.849,
              "y": -12.065,
              "z": 0.391
            },
            "gtin": "4006824008013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d530e",
            "leftCorner": {
              "x": -13.849,
              "y": -12.064,
              "z": 0.391
            },
            "rightCorner": {
              "x": -13.932,
              "y": -12.065,
              "z": 0.391
            },
            "gtin": "4006824028219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d530f",
            "leftCorner": {
              "x": -13.932,
              "y": -12.063,
              "z": 0.391
            },
            "rightCorner": {
              "x": -14.064,
              "y": -12.064,
              "z": 0.391
            },
            "gtin": "4009286151402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5310",
            "leftCorner": {
              "x": -14.064,
              "y": -12.068,
              "z": 0.391
            },
            "rightCorner": {
              "x": -14.203,
              "y": -12.069,
              "z": 0.391
            },
            "gtin": "4009286151419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5311",
            "leftCorner": {
              "x": -14.204,
              "y": -12.066,
              "z": 0.391
            },
            "rightCorner": {
              "x": -14.329,
              "y": -12.068,
              "z": 0.391
            },
            "gtin": "40122601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5312",
            "leftCorner": {
              "x": -14.329,
              "y": -12.068,
              "z": 0.391
            },
            "rightCorner": {
              "x": -14.447,
              "y": -12.069,
              "z": 0.391
            },
            "gtin": "40122625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5313",
            "leftCorner": {
              "x": -14.447,
              "y": -12.066,
              "z": 0.391
            },
            "rightCorner": {
              "x": -14.541,
              "y": -12.067,
              "z": 0.391
            },
            "gtin": "40122595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5314",
            "leftCorner": {
              "x": -14.541,
              "y": -12.067,
              "z": 0.391
            },
            "rightCorner": {
              "x": -14.635,
              "y": -12.068,
              "z": 0.391
            },
            "gtin": "40122595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5315",
            "leftCorner": {
              "x": -14.635,
              "y": -12.07,
              "z": 0.391
            },
            "rightCorner": {
              "x": -14.775,
              "y": -12.071,
              "z": 0.391
            },
            "gtin": "40122953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5316",
            "leftCorner": {
              "x": -14.775,
              "y": -12.071,
              "z": 0.391
            },
            "rightCorner": {
              "x": -14.89,
              "y": -12.072,
              "z": 0.391
            },
            "gtin": "40122441",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cec1",
        "height": 0.7273,
        "facings": [
          {
            "id": "68d8e508e1820c81800d531d",
            "leftCorner": {
              "x": -13.633,
              "y": -12.022,
              "z": 0.595
            },
            "rightCorner": {
              "x": -13.742,
              "y": -12.022,
              "z": 0.595
            },
            "gtin": "8714100823644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d531f",
            "leftCorner": {
              "x": -13.741,
              "y": -12.062,
              "z": 0.595
            },
            "rightCorner": {
              "x": -13.834,
              "y": -12.064,
              "z": 0.595
            },
            "gtin": "8714100823705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5320",
            "leftCorner": {
              "x": -13.834,
              "y": -12.071,
              "z": 0.595
            },
            "rightCorner": {
              "x": -14.027,
              "y": -12.072,
              "z": 0.595
            },
            "gtin": "8714100823682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5321",
            "leftCorner": {
              "x": -14.027,
              "y": -12.069,
              "z": 0.595
            },
            "rightCorner": {
              "x": -14.107,
              "y": -12.07,
              "z": 0.595
            },
            "gtin": "8714100823606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5322",
            "leftCorner": {
              "x": -14.107,
              "y": -12.06,
              "z": 0.595
            },
            "rightCorner": {
              "x": -14.186,
              "y": -12.06,
              "z": 0.595
            },
            "gtin": "8714100823637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5323",
            "leftCorner": {
              "x": -14.186,
              "y": -12.066,
              "z": 0.595
            },
            "rightCorner": {
              "x": -14.285,
              "y": -12.067,
              "z": 0.595
            },
            "gtin": "8714100823590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5324",
            "leftCorner": {
              "x": -14.285,
              "y": -12.056,
              "z": 0.595
            },
            "rightCorner": {
              "x": -14.368,
              "y": -12.057,
              "z": 0.595
            },
            "gtin": "8714100823620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5325",
            "leftCorner": {
              "x": -14.368,
              "y": -12.071,
              "z": 0.595
            },
            "rightCorner": {
              "x": -14.452,
              "y": -12.072,
              "z": 0.595
            },
            "gtin": "8714100823576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5326",
            "leftCorner": {
              "x": -14.452,
              "y": -12.072,
              "z": 0.595
            },
            "rightCorner": {
              "x": -14.569,
              "y": -12.073,
              "z": 0.595
            },
            "gtin": "8720182487865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5327",
            "leftCorner": {
              "x": -14.569,
              "y": -12.07,
              "z": 0.595
            },
            "rightCorner": {
              "x": -14.674,
              "y": -12.071,
              "z": 0.595
            },
            "gtin": "9120090282443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5328",
            "leftCorner": {
              "x": -14.674,
              "y": -12.07,
              "z": 0.595
            },
            "rightCorner": {
              "x": -14.774,
              "y": -12.071,
              "z": 0.595
            },
            "gtin": "9120090282436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5329",
            "leftCorner": {
              "x": -14.774,
              "y": -12.069,
              "z": 0.595
            },
            "rightCorner": {
              "x": -14.907,
              "y": -12.07,
              "z": 0.595
            },
            "gtin": "9120090282450",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cec2",
        "height": 1.0302,
        "facings": [
          {
            "id": "68d8e508e1820c81800d532c",
            "leftCorner": {
              "x": -13.633,
              "y": -12.019,
              "z": 0.843
            },
            "rightCorner": {
              "x": -13.845,
              "y": -12.022,
              "z": 0.843
            },
            "gtin": "4038700102508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d532e",
            "leftCorner": {
              "x": -13.844,
              "y": -12.063,
              "z": 0.843
            },
            "rightCorner": {
              "x": -14.082,
              "y": -12.065,
              "z": 0.843
            },
            "gtin": "8720182757739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d532f",
            "leftCorner": {
              "x": -14.082,
              "y": -12.066,
              "z": 0.843
            },
            "rightCorner": {
              "x": -14.209,
              "y": -12.067,
              "z": 0.843
            },
            "gtin": "4038700119704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5330",
            "leftCorner": {
              "x": -14.209,
              "y": -12.065,
              "z": 0.843
            },
            "rightCorner": {
              "x": -14.303,
              "y": -12.067,
              "z": 0.843
            },
            "gtin": "4000186038107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5331",
            "leftCorner": {
              "x": -14.303,
              "y": -12.065,
              "z": 0.843
            },
            "rightCorner": {
              "x": -14.444,
              "y": -12.066,
              "z": 0.843
            },
            "gtin": "4000186039104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5332",
            "leftCorner": {
              "x": -14.444,
              "y": -12.066,
              "z": 0.843
            },
            "rightCorner": {
              "x": -14.602,
              "y": -12.067,
              "z": 0.843
            },
            "gtin": "4008585103174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5333",
            "leftCorner": {
              "x": -14.602,
              "y": -12.066,
              "z": 0.843
            },
            "rightCorner": {
              "x": -14.78,
              "y": -12.068,
              "z": 0.843
            },
            "gtin": "4008585103198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5334",
            "leftCorner": {
              "x": -14.78,
              "y": -12.066,
              "z": 0.843
            },
            "rightCorner": {
              "x": -14.89,
              "y": -12.067,
              "z": 0.843
            },
            "gtin": "4008585103181",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cec3",
        "height": 1.3338,
        "facings": [
          {
            "id": "68d8e508e1820c81800d533e",
            "leftCorner": {
              "x": -13.633,
              "y": -12.013,
              "z": 1.091
            },
            "rightCorner": {
              "x": -13.978,
              "y": -12.017,
              "z": 1.091
            },
            "gtin": "8714100890363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5340",
            "leftCorner": {
              "x": -13.977,
              "y": -12.06,
              "z": 1.091
            },
            "rightCorner": {
              "x": -14.144,
              "y": -12.062,
              "z": 1.091
            },
            "gtin": "8711200457274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5341",
            "leftCorner": {
              "x": -14.144,
              "y": -12.059,
              "z": 1.091
            },
            "rightCorner": {
              "x": -14.312,
              "y": -12.061,
              "z": 1.091
            },
            "gtin": "8711200457298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5342",
            "leftCorner": {
              "x": -14.312,
              "y": -12.057,
              "z": 1.091
            },
            "rightCorner": {
              "x": -14.405,
              "y": -12.058,
              "z": 1.091
            },
            "gtin": "4400139020010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5343",
            "leftCorner": {
              "x": -14.405,
              "y": -12.06,
              "z": 1.091
            },
            "rightCorner": {
              "x": -14.547,
              "y": -12.062,
              "z": 1.091
            },
            "gtin": "42353430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5344",
            "leftCorner": {
              "x": -14.547,
              "y": -12.061,
              "z": 1.091
            },
            "rightCorner": {
              "x": -14.682,
              "y": -12.062,
              "z": 1.091
            },
            "gtin": "42421832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5345",
            "leftCorner": {
              "x": -14.682,
              "y": -12.065,
              "z": 1.091
            },
            "rightCorner": {
              "x": -14.937,
              "y": -12.068,
              "z": 1.091
            },
            "gtin": "42421801",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cec4",
        "height": 1.6317,
        "facings": [
          {
            "id": "68d8e508e1820c81800d534d",
            "leftCorner": {
              "x": -13.633,
              "y": -12.01,
              "z": 1.335
            },
            "rightCorner": {
              "x": -13.923,
              "y": -12.012,
              "z": 1.335
            },
            "gtin": "40056265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d534e",
            "leftCorner": {
              "x": -13.923,
              "y": -12.012,
              "z": 1.335
            },
            "rightCorner": {
              "x": -14.213,
              "y": -12.015,
              "z": 1.335
            },
            "gtin": "40056265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5351",
            "leftCorner": {
              "x": -14.212,
              "y": -12.06,
              "z": 1.335
            },
            "rightCorner": {
              "x": -14.534,
              "y": -12.063,
              "z": 1.335
            },
            "gtin": "40057705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5352",
            "leftCorner": {
              "x": -14.534,
              "y": -12.058,
              "z": 1.335
            },
            "rightCorner": {
              "x": -14.678,
              "y": -12.059,
              "z": 1.335
            },
            "gtin": "40056289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5353",
            "leftCorner": {
              "x": -14.678,
              "y": -12.057,
              "z": 1.335
            },
            "rightCorner": {
              "x": -14.944,
              "y": -12.06,
              "z": 1.335
            },
            "gtin": "40052472",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7de",
    "rightNeighborShelfId": "7e0"
  },
  {
    "id": "7e0",
    "name": "7e0",
    "x": -14.882,
    "y": -12.084,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.0047036
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539cecb",
        "height": 0.17164,
        "facings": [
          {
            "id": "c417c970e9beaf8aa5699005",
            "leftCorner": {
              "x": -14.884,
              "y": -11.986,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.108,
              "y": -11.988,
              "z": 0.14
            },
            "gtin": "4250426221862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ca4c0f5cd7d8d0807837c07e",
            "leftCorner": {
              "x": -15.108,
              "y": -11.988,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.201,
              "y": -11.989,
              "z": 0.14
            },
            "gtin": "40122960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f0f26ff3d16178bdde95b736",
            "leftCorner": {
              "x": -15.201,
              "y": -11.989,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.307,
              "y": -11.99,
              "z": 0.14
            },
            "gtin": "4000515003325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "209c34b64cc3d89da40ce223",
            "leftCorner": {
              "x": -15.307,
              "y": -11.99,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.414,
              "y": -11.991,
              "z": 0.14
            },
            "gtin": "4012200222102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "83a93f8b053de6ccb21890e6",
            "leftCorner": {
              "x": -15.414,
              "y": -11.991,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.534,
              "y": -11.992,
              "z": 0.14
            },
            "gtin": "4013200381523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "778d623a93e4ac44fbfd35e2",
            "leftCorner": {
              "x": -15.534,
              "y": -11.992,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.655,
              "y": -11.993,
              "z": 0.14
            },
            "gtin": "4104720014128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b71d47fcacbf4cd2c68b2d9b",
            "leftCorner": {
              "x": -15.655,
              "y": -11.993,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.781,
              "y": -11.994,
              "z": 0.14
            },
            "gtin": "4104720014111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1277c178cef364ef2ccc6a4d",
            "leftCorner": {
              "x": -15.781,
              "y": -11.994,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.922,
              "y": -11.996,
              "z": 0.14
            },
            "gtin": "4013200381554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "11d961b0ff0ecb6f6e0e6a62",
            "leftCorner": {
              "x": -15.922,
              "y": -11.996,
              "z": 0.14
            },
            "rightCorner": {
              "x": -16.133,
              "y": -11.998,
              "z": 0.14
            },
            "gtin": "4104720022697",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cec6",
        "height": 0.4774,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5317",
            "leftCorner": {
              "x": -14.891,
              "y": -12.069,
              "z": 0.391
            },
            "rightCorner": {
              "x": -14.986,
              "y": -12.07,
              "z": 0.391
            },
            "gtin": "40122960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5318",
            "leftCorner": {
              "x": -14.986,
              "y": -12.07,
              "z": 0.391
            },
            "rightCorner": {
              "x": -15.075,
              "y": -12.071,
              "z": 0.391
            },
            "gtin": "40122571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5319",
            "leftCorner": {
              "x": -15.075,
              "y": -12.071,
              "z": 0.391
            },
            "rightCorner": {
              "x": -15.222,
              "y": -12.072,
              "z": 0.391
            },
            "gtin": "4012860005664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d531a",
            "leftCorner": {
              "x": -15.222,
              "y": -12.076,
              "z": 0.391
            },
            "rightCorner": {
              "x": -15.421,
              "y": -12.078,
              "z": 0.391
            },
            "gtin": "4012860003110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d531b",
            "leftCorner": {
              "x": -15.421,
              "y": -12.079,
              "z": 0.391
            },
            "rightCorner": {
              "x": -15.786,
              "y": -12.083,
              "z": 0.391
            },
            "gtin": "40122342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d531c",
            "leftCorner": {
              "x": -15.786,
              "y": -12.083,
              "z": 0.391
            },
            "rightCorner": {
              "x": -15.892,
              "y": -12.084,
              "z": 0.391
            },
            "gtin": "4012200222102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d530c",
            "leftCorner": {
              "x": -15.892,
              "y": -12.084,
              "z": 0.391
            },
            "rightCorner": {
              "x": -16.132,
              "y": -12.086,
              "z": 0.391
            },
            "gtin": "4400191060542",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cec8",
        "height": 0.72863,
        "facings": [
          {
            "id": "68d8e508e1820c81800d532a",
            "leftCorner": {
              "x": -14.908,
              "y": -12.07,
              "z": 0.596
            },
            "rightCorner": {
              "x": -15.059,
              "y": -12.071,
              "z": 0.596
            },
            "gtin": "4104420209152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d532b",
            "leftCorner": {
              "x": -15.059,
              "y": -12.075,
              "z": 0.596
            },
            "rightCorner": {
              "x": -15.911,
              "y": -12.084,
              "z": 0.596
            },
            "gtin": "4005500087762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d531e",
            "leftCorner": {
              "x": -15.911,
              "y": -12.084,
              "z": 0.596
            },
            "rightCorner": {
              "x": -16.132,
              "y": -12.086,
              "z": 0.596
            },
            "gtin": "4250426221886",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cec9",
        "height": 1.029,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5335",
            "leftCorner": {
              "x": -14.891,
              "y": -12.067,
              "z": 0.842
            },
            "rightCorner": {
              "x": -15.077,
              "y": -12.069,
              "z": 0.842
            },
            "gtin": "4013200228910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5336",
            "leftCorner": {
              "x": -15.077,
              "y": -12.074,
              "z": 0.842
            },
            "rightCorner": {
              "x": -15.192,
              "y": -12.076,
              "z": 0.842
            },
            "gtin": "4013200381523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5337",
            "leftCorner": {
              "x": -15.192,
              "y": -12.078,
              "z": 0.842
            },
            "rightCorner": {
              "x": -15.34,
              "y": -12.079,
              "z": 0.842
            },
            "gtin": "4013200381554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5338",
            "leftCorner": {
              "x": -15.34,
              "y": -12.076,
              "z": 0.842
            },
            "rightCorner": {
              "x": -15.54,
              "y": -12.078,
              "z": 0.842
            },
            "gtin": "4041131004686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5339",
            "leftCorner": {
              "x": -15.54,
              "y": -12.081,
              "z": 0.842
            },
            "rightCorner": {
              "x": -15.643,
              "y": -12.082,
              "z": 0.842
            },
            "gtin": "4041131004778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d533a",
            "leftCorner": {
              "x": -15.643,
              "y": -12.082,
              "z": 0.842
            },
            "rightCorner": {
              "x": -15.747,
              "y": -12.084,
              "z": 0.842
            },
            "gtin": "4041131004778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d533b",
            "leftCorner": {
              "x": -15.747,
              "y": -12.081,
              "z": 0.842
            },
            "rightCorner": {
              "x": -15.815,
              "y": -12.081,
              "z": 0.842
            },
            "gtin": "42094692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d533c",
            "leftCorner": {
              "x": -15.815,
              "y": -12.081,
              "z": 0.842
            },
            "rightCorner": {
              "x": -15.883,
              "y": -12.081,
              "z": 0.842
            },
            "gtin": "42094692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d533d",
            "leftCorner": {
              "x": -15.883,
              "y": -12.081,
              "z": 0.842
            },
            "rightCorner": {
              "x": -15.951,
              "y": -12.082,
              "z": 0.842
            },
            "gtin": "42094692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d532d",
            "leftCorner": {
              "x": -15.951,
              "y": -12.082,
              "z": 0.842
            },
            "rightCorner": {
              "x": -16.132,
              "y": -12.084,
              "z": 0.842
            },
            "gtin": "42094722",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ceca",
        "height": 1.3327,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5346",
            "leftCorner": {
              "x": -14.938,
              "y": -12.065,
              "z": 1.09
            },
            "rightCorner": {
              "x": -15.1,
              "y": -12.066,
              "z": 1.09
            },
            "gtin": "40056296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5348",
            "leftCorner": {
              "x": -15.217,
              "y": -12.079,
              "z": 1.09
            },
            "rightCorner": {
              "x": -15.372,
              "y": -12.08,
              "z": 1.09
            },
            "gtin": "4003185016671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5349",
            "leftCorner": {
              "x": -15.372,
              "y": -12.08,
              "z": 1.09
            },
            "rightCorner": {
              "x": -15.589,
              "y": -12.082,
              "z": 1.09
            },
            "gtin": "41047231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d534a",
            "leftCorner": {
              "x": -15.589,
              "y": -12.085,
              "z": 1.09
            },
            "rightCorner": {
              "x": -15.711,
              "y": -12.086,
              "z": 1.09
            },
            "gtin": "4104720014128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d534b",
            "leftCorner": {
              "x": -15.711,
              "y": -12.082,
              "z": 1.09
            },
            "rightCorner": {
              "x": -15.922,
              "y": -12.085,
              "z": 1.09
            },
            "gtin": "4104720022697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d534c",
            "leftCorner": {
              "x": -15.922,
              "y": -12.084,
              "z": 1.09
            },
            "rightCorner": {
              "x": -16.067,
              "y": -12.086,
              "z": 1.09
            },
            "gtin": "4104720014111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d533f",
            "leftCorner": {
              "x": -16.067,
              "y": -12.09,
              "z": 1.09
            },
            "rightCorner": {
              "x": -16.132,
              "y": -12.09,
              "z": 1.09
            },
            "gtin": "4000515003325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "64fc94c2be0d24ef2c09dff0",
            "leftCorner": {
              "x": -15.1,
              "y": -12.037,
              "z": 1.09
            },
            "rightCorner": {
              "x": -15.206,
              "y": -12.038,
              "z": 1.09
            },
            "gtin": "4000515003325",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cec7",
        "height": 1.6336,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5354",
            "leftCorner": {
              "x": -14.945,
              "y": -12.045,
              "z": 1.337
            },
            "rightCorner": {
              "x": -15.09,
              "y": -12.047,
              "z": 1.337
            },
            "gtin": "40057842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5355",
            "leftCorner": {
              "x": -15.09,
              "y": -12.066,
              "z": 1.337
            },
            "rightCorner": {
              "x": -15.193,
              "y": -12.068,
              "z": 1.337
            },
            "gtin": "4012860003134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5356",
            "leftCorner": {
              "x": -15.193,
              "y": -12.068,
              "z": 1.337
            },
            "rightCorner": {
              "x": -15.296,
              "y": -12.069,
              "z": 1.337
            },
            "gtin": "4012860003134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5357",
            "leftCorner": {
              "x": -15.296,
              "y": -12.077,
              "z": 1.337
            },
            "rightCorner": {
              "x": -15.559,
              "y": -12.079,
              "z": 1.337
            },
            "gtin": "40056050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5358",
            "leftCorner": {
              "x": -15.559,
              "y": -12.08,
              "z": 1.337
            },
            "rightCorner": {
              "x": -15.679,
              "y": -12.081,
              "z": 1.337
            },
            "gtin": "40056043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5359",
            "leftCorner": {
              "x": -15.679,
              "y": -12.081,
              "z": 1.337
            },
            "rightCorner": {
              "x": -15.799,
              "y": -12.083,
              "z": 1.337
            },
            "gtin": "40056043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d534f",
            "leftCorner": {
              "x": -15.799,
              "y": -12.079,
              "z": 1.337
            },
            "rightCorner": {
              "x": -15.966,
              "y": -12.08,
              "z": 1.337
            },
            "gtin": "4306188051084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5350",
            "leftCorner": {
              "x": -15.966,
              "y": -12.08,
              "z": 1.337
            },
            "rightCorner": {
              "x": -16.132,
              "y": -12.082,
              "z": 1.337
            },
            "gtin": "4306188051084",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7df"
  },
  {
    "id": "7e1",
    "name": "7e1",
    "x": -16.212,
    "y": -13.347,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0038484,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 62
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d61e",
        "height": 0.17412,
        "facings": [
          {
            "id": "624647221f87f750433b25c0",
            "leftCorner": {
              "x": -16.213,
              "y": -13.171,
              "z": 0.142
            },
            "rightCorner": {
              "x": -16.208,
              "y": -13.171,
              "z": 0.142
            },
            "gtin": "4002239429603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f3761d18efb9c977c93c80f2",
            "leftCorner": {
              "x": -16.208,
              "y": -13.171,
              "z": 0.142
            },
            "rightCorner": {
              "x": -16.159,
              "y": -13.171,
              "z": 0.142
            },
            "gtin": "4002239392006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4d93e5b0500fcdb912416057",
            "leftCorner": {
              "x": -16.159,
              "y": -13.171,
              "z": 0.142
            },
            "rightCorner": {
              "x": -16.087,
              "y": -13.17,
              "z": 0.142
            },
            "gtin": "8858135040017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "696062fa68d95d49e501a1df",
            "leftCorner": {
              "x": -16.087,
              "y": -13.17,
              "z": 0.142
            },
            "rightCorner": {
              "x": -16.011,
              "y": -13.169,
              "z": 0.142
            },
            "gtin": "8858135012021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7e242135a541982b5c8ee5c9",
            "leftCorner": {
              "x": -16.011,
              "y": -13.169,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.934,
              "y": -13.169,
              "z": 0.142
            },
            "gtin": "4002239681001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "604b2a69386cb4bdd9fc52b5",
            "leftCorner": {
              "x": -15.934,
              "y": -13.169,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.836,
              "y": -13.168,
              "z": 0.142
            },
            "gtin": "4002239990608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "776d856a0598c08809c50b88",
            "leftCorner": {
              "x": -15.836,
              "y": -13.168,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.737,
              "y": -13.167,
              "z": 0.142
            },
            "gtin": "4002239991308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3df4f16eeb71130c41507bb8",
            "leftCorner": {
              "x": -15.737,
              "y": -13.167,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.636,
              "y": -13.167,
              "z": 0.142
            },
            "gtin": "4002239402835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "da9c9706d8a8236988dd92a0",
            "leftCorner": {
              "x": -15.636,
              "y": -13.167,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.534,
              "y": -13.166,
              "z": 0.142
            },
            "gtin": "8858135040086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0e996aee7703b082399ce69d",
            "leftCorner": {
              "x": -15.534,
              "y": -13.166,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.432,
              "y": -13.165,
              "z": 0.142
            },
            "gtin": "4002239604505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b7c6d343156a08ddfaa06800",
            "leftCorner": {
              "x": -15.432,
              "y": -13.165,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.329,
              "y": -13.164,
              "z": 0.142
            },
            "gtin": "4002239604604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "96869f87a92a343b4f7cb4e0",
            "leftCorner": {
              "x": -15.329,
              "y": -13.164,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.22,
              "y": -13.163,
              "z": 0.142
            },
            "gtin": "8858135040116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "342934c2243f89f8eee0c020",
            "leftCorner": {
              "x": -15.22,
              "y": -13.163,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.982,
              "y": -13.162,
              "z": 0.142
            },
            "gtin": "5201119002359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "036fb515b719b55617f7c8b5",
            "leftCorner": {
              "x": -14.982,
              "y": -13.162,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.976,
              "y": -13.161,
              "z": 0.142
            },
            "gtin": "4002239429603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0c781cef4765f683c5404afa",
            "leftCorner": {
              "x": -14.976,
              "y": -13.161,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.97,
              "y": -13.161,
              "z": 0.142
            },
            "gtin": "4002239429603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cc65c84935b7fd73756a3314",
            "leftCorner": {
              "x": -14.97,
              "y": -13.161,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.964,
              "y": -13.161,
              "z": 0.142
            },
            "gtin": "4002239429603",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d61a",
        "height": 0.45485,
        "facings": [
          {
            "id": "68d8e508e1820c81800d53a8",
            "leftCorner": {
              "x": -16.214,
              "y": -13.141,
              "z": 0.372
            },
            "rightCorner": {
              "x": -16.037,
              "y": -13.14,
              "z": 0.372
            },
            "gtin": "4002239604703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53aa",
            "leftCorner": {
              "x": -16.037,
              "y": -13.118,
              "z": 0.372
            },
            "rightCorner": {
              "x": -15.912,
              "y": -13.117,
              "z": 0.372
            },
            "gtin": "4002239604406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53ab",
            "leftCorner": {
              "x": -15.912,
              "y": -13.11,
              "z": 0.372
            },
            "rightCorner": {
              "x": -15.77,
              "y": -13.108,
              "z": 0.372
            },
            "gtin": "4002239604307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53ac",
            "leftCorner": {
              "x": -15.77,
              "y": -13.1,
              "z": 0.372
            },
            "rightCorner": {
              "x": -15.673,
              "y": -13.1,
              "z": 0.372
            },
            "gtin": "4002239604505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53ad",
            "leftCorner": {
              "x": -15.673,
              "y": -13.095,
              "z": 0.372
            },
            "rightCorner": {
              "x": -15.555,
              "y": -13.095,
              "z": 0.372
            },
            "gtin": "4002239604802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53ae",
            "leftCorner": {
              "x": -15.555,
              "y": -13.097,
              "z": 0.372
            },
            "rightCorner": {
              "x": -15.455,
              "y": -13.096,
              "z": 0.372
            },
            "gtin": "4002239604604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53af",
            "leftCorner": {
              "x": -15.455,
              "y": -13.094,
              "z": 0.372
            },
            "rightCorner": {
              "x": -15.316,
              "y": -13.093,
              "z": 0.372
            },
            "gtin": "4002239687706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53b0",
            "leftCorner": {
              "x": -15.316,
              "y": -13.094,
              "z": 0.372
            },
            "rightCorner": {
              "x": -15.159,
              "y": -13.092,
              "z": 0.372
            },
            "gtin": "4002239770101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53b1",
            "leftCorner": {
              "x": -15.159,
              "y": -13.09,
              "z": 0.372
            },
            "rightCorner": {
              "x": -15.023,
              "y": -13.089,
              "z": 0.372
            },
            "gtin": "4002239687805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53b2",
            "leftCorner": {
              "x": -15.023,
              "y": -13.089,
              "z": 0.372
            },
            "rightCorner": {
              "x": -14.887,
              "y": -13.089,
              "z": 0.372
            },
            "gtin": "4002239687805",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d61b",
        "height": 0.70689,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8558",
            "leftCorner": {
              "x": -16.214,
              "y": -13.146,
              "z": 0.578
            },
            "rightCorner": {
              "x": -15.901,
              "y": -13.144,
              "z": 0.578
            },
            "gtin": "8858135000035",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d855a",
            "leftCorner": {
              "x": -15.901,
              "y": -13.117,
              "z": 0.578
            },
            "rightCorner": {
              "x": -15.789,
              "y": -13.117,
              "z": 0.578
            },
            "gtin": "8858135000028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d855b",
            "leftCorner": {
              "x": -15.789,
              "y": -13.11,
              "z": 0.578
            },
            "rightCorner": {
              "x": -15.691,
              "y": -13.11,
              "z": 0.578
            },
            "gtin": "8858135040086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d855c",
            "leftCorner": {
              "x": -15.691,
              "y": -13.106,
              "z": 0.578
            },
            "rightCorner": {
              "x": -15.585,
              "y": -13.105,
              "z": 0.578
            },
            "gtin": "8858135040116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d855d",
            "leftCorner": {
              "x": -15.585,
              "y": -13.1,
              "z": 0.578
            },
            "rightCorner": {
              "x": -15.506,
              "y": -13.099,
              "z": 0.578
            },
            "gtin": "8858135040017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d855e",
            "leftCorner": {
              "x": -15.506,
              "y": -13.102,
              "z": 0.578
            },
            "rightCorner": {
              "x": -15.356,
              "y": -13.101,
              "z": 0.578
            },
            "gtin": "8858135012014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d855f",
            "leftCorner": {
              "x": -15.356,
              "y": -13.097,
              "z": 0.578
            },
            "rightCorner": {
              "x": -15.212,
              "y": -13.096,
              "z": 0.578
            },
            "gtin": "8858135040079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8560",
            "leftCorner": {
              "x": -15.212,
              "y": -13.095,
              "z": 0.578
            },
            "rightCorner": {
              "x": -15.138,
              "y": -13.094,
              "z": 0.578
            },
            "gtin": "8858135012021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8559",
            "leftCorner": {
              "x": -15.138,
              "y": -13.093,
              "z": 0.578
            },
            "rightCorner": {
              "x": -14.964,
              "y": -13.092,
              "z": 0.578
            },
            "gtin": "4002239401302",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d61c",
        "height": 0.93141,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5396",
            "leftCorner": {
              "x": -16.214,
              "y": -13.141,
              "z": 0.762
            },
            "rightCorner": {
              "x": -15.904,
              "y": -13.138,
              "z": 0.762
            },
            "gtin": "5201119008962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5398",
            "leftCorner": {
              "x": -15.904,
              "y": -13.11,
              "z": 0.762
            },
            "rightCorner": {
              "x": -15.79,
              "y": -13.11,
              "z": 0.762
            },
            "gtin": "5201119009150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5399",
            "leftCorner": {
              "x": -15.79,
              "y": -13.11,
              "z": 0.762
            },
            "rightCorner": {
              "x": -15.676,
              "y": -13.109,
              "z": 0.762
            },
            "gtin": "5201119009150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d539a",
            "leftCorner": {
              "x": -15.676,
              "y": -13.095,
              "z": 0.762
            },
            "rightCorner": {
              "x": -15.457,
              "y": -13.093,
              "z": 0.762
            },
            "gtin": "5201119009068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d539b",
            "leftCorner": {
              "x": -15.457,
              "y": -13.097,
              "z": 0.762
            },
            "rightCorner": {
              "x": -15.221,
              "y": -13.095,
              "z": 0.762
            },
            "gtin": "5201119002359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d539c",
            "leftCorner": {
              "x": -15.221,
              "y": -13.093,
              "z": 0.762
            },
            "rightCorner": {
              "x": -15.108,
              "y": -13.092,
              "z": 0.762
            },
            "gtin": "5201119000225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d539d",
            "leftCorner": {
              "x": -15.108,
              "y": -13.089,
              "z": 0.762
            },
            "rightCorner": {
              "x": -14.985,
              "y": -13.088,
              "z": 0.762
            },
            "gtin": "4002239414906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d539e",
            "leftCorner": {
              "x": -14.985,
              "y": -13.086,
              "z": 0.762
            },
            "rightCorner": {
              "x": -14.817,
              "y": -13.085,
              "z": 0.762
            },
            "gtin": "4002239429603",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d618",
        "height": 1.1852,
        "facings": [
          {
            "id": "68d8e508e1820c81800d535a",
            "leftCorner": {
              "x": -16.214,
              "y": -13.138,
              "z": 0.97
            },
            "rightCorner": {
              "x": -16.032,
              "y": -13.138,
              "z": 0.97
            },
            "gtin": "4002239849609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d535c",
            "leftCorner": {
              "x": -16.032,
              "y": -13.115,
              "z": 0.97
            },
            "rightCorner": {
              "x": -15.921,
              "y": -13.114,
              "z": 0.97
            },
            "gtin": "4002239848800",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d535d",
            "leftCorner": {
              "x": -15.921,
              "y": -13.105,
              "z": 0.97
            },
            "rightCorner": {
              "x": -15.665,
              "y": -13.103,
              "z": 0.97
            },
            "gtin": "4002239847902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d535e",
            "leftCorner": {
              "x": -15.665,
              "y": -13.092,
              "z": 0.97
            },
            "rightCorner": {
              "x": -15.569,
              "y": -13.091,
              "z": 0.97
            },
            "gtin": "4002239847100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d535f",
            "leftCorner": {
              "x": -15.569,
              "y": -13.094,
              "z": 0.97
            },
            "rightCorner": {
              "x": -15.431,
              "y": -13.093,
              "z": 0.97
            },
            "gtin": "4002239847209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5360",
            "leftCorner": {
              "x": -15.431,
              "y": -13.088,
              "z": 0.97
            },
            "rightCorner": {
              "x": -15.218,
              "y": -13.086,
              "z": 0.97
            },
            "gtin": "4002239849302",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d5361",
            "leftCorner": {
              "x": -15.218,
              "y": -13.092,
              "z": 0.97
            },
            "rightCorner": {
              "x": -15.051,
              "y": -13.091,
              "z": 0.97
            },
            "gtin": "4002239646109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5362",
            "leftCorner": {
              "x": -15.051,
              "y": -13.084,
              "z": 0.97
            },
            "rightCorner": {
              "x": -14.883,
              "y": -13.082,
              "z": 0.97
            },
            "gtin": "4002239681001",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d61d",
        "height": 1.4144,
        "facings": [
          {
            "id": "68d8e508e1820c81800d53d9",
            "leftCorner": {
              "x": -16.214,
              "y": -13.148,
              "z": 1.157
            },
            "rightCorner": {
              "x": -15.76,
              "y": -13.144,
              "z": 1.157
            },
            "gtin": "4002239846509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53db",
            "leftCorner": {
              "x": -15.76,
              "y": -13.107,
              "z": 1.157
            },
            "rightCorner": {
              "x": -15.599,
              "y": -13.106,
              "z": 1.157
            },
            "gtin": "4002239847605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53dc",
            "leftCorner": {
              "x": -15.599,
              "y": -13.104,
              "z": 1.157
            },
            "rightCorner": {
              "x": -15.216,
              "y": -13.101,
              "z": 1.157
            },
            "gtin": "4002239847704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53dd",
            "leftCorner": {
              "x": -15.216,
              "y": -13.1,
              "z": 1.157
            },
            "rightCorner": {
              "x": -15.075,
              "y": -13.099,
              "z": 1.157
            },
            "gtin": "4002239693905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53de",
            "leftCorner": {
              "x": -15.075,
              "y": -13.093,
              "z": 1.157
            },
            "rightCorner": {
              "x": -14.939,
              "y": -13.092,
              "z": 1.157
            },
            "gtin": "4002239402835",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d619",
        "height": 1.6396,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5369",
            "leftCorner": {
              "x": -16.214,
              "y": -13.137,
              "z": 1.341
            },
            "rightCorner": {
              "x": -16.002,
              "y": -13.135,
              "z": 1.341
            },
            "gtin": "4002239990202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d536b",
            "leftCorner": {
              "x": -16.002,
              "y": -13.111,
              "z": 1.341
            },
            "rightCorner": {
              "x": -15.857,
              "y": -13.111,
              "z": 1.341
            },
            "gtin": "4002239990301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d536c",
            "leftCorner": {
              "x": -15.857,
              "y": -13.106,
              "z": 1.341
            },
            "rightCorner": {
              "x": -15.709,
              "y": -13.106,
              "z": 1.341
            },
            "gtin": "4002239990103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d536d",
            "leftCorner": {
              "x": -15.709,
              "y": -13.09,
              "z": 1.341
            },
            "rightCorner": {
              "x": -15.566,
              "y": -13.089,
              "z": 1.341
            },
            "gtin": "4002239993807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d536e",
            "leftCorner": {
              "x": -15.566,
              "y": -13.095,
              "z": 1.341
            },
            "rightCorner": {
              "x": -15.449,
              "y": -13.094,
              "z": 1.341
            },
            "gtin": "4002239990608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d536f",
            "leftCorner": {
              "x": -15.449,
              "y": -13.087,
              "z": 1.341
            },
            "rightCorner": {
              "x": -15.283,
              "y": -13.085,
              "z": 1.341
            },
            "gtin": "4002239995207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5370",
            "leftCorner": {
              "x": -15.283,
              "y": -13.086,
              "z": 1.341
            },
            "rightCorner": {
              "x": -15.125,
              "y": -13.085,
              "z": 1.341
            },
            "gtin": "4002239995108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5371",
            "leftCorner": {
              "x": -15.125,
              "y": -13.088,
              "z": 1.341
            },
            "rightCorner": {
              "x": -15.023,
              "y": -13.088,
              "z": 1.341
            },
            "gtin": "4002239991308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5372",
            "leftCorner": {
              "x": -15.023,
              "y": -13.084,
              "z": 1.341
            },
            "rightCorner": {
              "x": -14.906,
              "y": -13.083,
              "z": 1.341
            },
            "gtin": "4002239392006",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "7e3"
  },
  {
    "id": "7e3",
    "name": "7e3",
    "x": -14.963,
    "y": -13.338,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0038484,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 6,
      "unknownStockCount": 52
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ced3",
        "height": 0.17219,
        "facings": [
          {
            "id": "0990f20e271b8fe1d8c4374d",
            "leftCorner": {
              "x": -14.962,
              "y": -13.431,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.774,
              "y": -13.43,
              "z": 0.141
            },
            "gtin": "4260176721086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "95d58a233b5ab07636420623",
            "leftCorner": {
              "x": -14.774,
              "y": -13.43,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.715,
              "y": -13.429,
              "z": 0.141
            },
            "gtin": "4002239639705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9b8657221a3c0273feb8ac48",
            "leftCorner": {
              "x": -14.715,
              "y": -13.429,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.636,
              "y": -13.429,
              "z": 0.141
            },
            "gtin": "4002239418300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "de6ebf3e99fbc722e3af4130",
            "leftCorner": {
              "x": -14.636,
              "y": -13.429,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.556,
              "y": -13.428,
              "z": 0.141
            },
            "gtin": "4002239695909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "578fdcbfbd069141b2aad743",
            "leftCorner": {
              "x": -14.556,
              "y": -13.428,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.473,
              "y": -13.427,
              "z": 0.141
            },
            "gtin": "4002239640503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b8b3cfe0ce2ce508af919f10",
            "leftCorner": {
              "x": -14.473,
              "y": -13.427,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.379,
              "y": -13.427,
              "z": 0.141
            },
            "gtin": "4002239594608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "02cd2e92a17c048f9a7cf2f3",
            "leftCorner": {
              "x": -14.379,
              "y": -13.427,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.276,
              "y": -13.426,
              "z": 0.141
            },
            "gtin": "42298601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a8ac4f3291075a063dfbe185",
            "leftCorner": {
              "x": -14.276,
              "y": -13.426,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.163,
              "y": -13.425,
              "z": 0.141
            },
            "gtin": "4002239360005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9555cd05e7cb575c2cea8fe7",
            "leftCorner": {
              "x": -14.163,
              "y": -13.425,
              "z": 0.141
            },
            "rightCorner": {
              "x": -14.043,
              "y": -13.424,
              "z": 0.141
            },
            "gtin": "4002239610100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9e60bfe65da8761a5b12f30b",
            "leftCorner": {
              "x": -14.043,
              "y": -13.424,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.908,
              "y": -13.423,
              "z": 0.141
            },
            "gtin": "4002239443203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "98e4f346bc253d1df85fec26",
            "leftCorner": {
              "x": -13.908,
              "y": -13.423,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.72,
              "y": -13.421,
              "z": 0.141
            },
            "gtin": "4260176721086",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cecf",
        "height": 0.45571,
        "facings": [
          {
            "id": "68d8e508e1820c81800d53b3",
            "leftCorner": {
              "x": -14.886,
              "y": -13.348,
              "z": 0.373
            },
            "rightCorner": {
              "x": -14.714,
              "y": -13.347,
              "z": 0.373
            },
            "gtin": "4002239639705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d87fecdea02eb508df2652a7",
            "leftCorner": {
              "x": -14.963,
              "y": -13.386,
              "z": 0.373
            },
            "rightCorner": {
              "x": -14.903,
              "y": -13.386,
              "z": 0.373
            },
            "gtin": "4002239639705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53b4",
            "leftCorner": {
              "x": -14.714,
              "y": -13.345,
              "z": 0.373
            },
            "rightCorner": {
              "x": -14.603,
              "y": -13.344,
              "z": 0.373
            },
            "gtin": "4002239640800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53b5",
            "leftCorner": {
              "x": -14.603,
              "y": -13.344,
              "z": 0.373
            },
            "rightCorner": {
              "x": -14.493,
              "y": -13.343,
              "z": 0.373
            },
            "gtin": "4002239640800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53b6",
            "leftCorner": {
              "x": -14.493,
              "y": -13.343,
              "z": 0.373
            },
            "rightCorner": {
              "x": -14.383,
              "y": -13.343,
              "z": 0.373
            },
            "gtin": "4002239640800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53b7",
            "leftCorner": {
              "x": -14.383,
              "y": -13.342,
              "z": 0.373
            },
            "rightCorner": {
              "x": -14.154,
              "y": -13.34,
              "z": 0.373
            },
            "gtin": "4002239640503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53b8",
            "leftCorner": {
              "x": -14.154,
              "y": -13.339,
              "z": 0.373
            },
            "rightCorner": {
              "x": -14.103,
              "y": -13.339,
              "z": 0.373
            },
            "gtin": "4002239641005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53b9",
            "leftCorner": {
              "x": -14.103,
              "y": -13.339,
              "z": 0.373
            },
            "rightCorner": {
              "x": -14.052,
              "y": -13.338,
              "z": 0.373
            },
            "gtin": "4002239641005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53ba",
            "leftCorner": {
              "x": -14.052,
              "y": -13.338,
              "z": 0.373
            },
            "rightCorner": {
              "x": -14.002,
              "y": -13.338,
              "z": 0.373
            },
            "gtin": "4002239641005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53bb",
            "leftCorner": {
              "x": -14.002,
              "y": -13.339,
              "z": 0.373
            },
            "rightCorner": {
              "x": -13.713,
              "y": -13.336,
              "z": 0.373
            },
            "gtin": "4002239643009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ced0",
        "height": 0.72221,
        "facings": [
          {
            "id": "68d8e508e1820c81800d53d3",
            "leftCorner": {
              "x": -14.963,
              "y": -13.396,
              "z": 0.591
            },
            "rightCorner": {
              "x": -14.874,
              "y": -13.395,
              "z": 0.591
            },
            "gtin": "4002239420907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "eaf18866d10b8f32bf08db94",
            "leftCorner": {
              "x": -14.785,
              "y": -13.395,
              "z": 0.591
            },
            "rightCorner": {
              "x": -14.526,
              "y": -13.393,
              "z": 0.591
            },
            "gtin": "4002239407304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e1c3a22f051c56022cab10e4",
            "leftCorner": {
              "x": -14.526,
              "y": -13.393,
              "z": 0.591
            },
            "rightCorner": {
              "x": -14.3,
              "y": -13.391,
              "z": 0.591
            },
            "gtin": "4002239420907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aa328497f90722f86c1eff22",
            "leftCorner": {
              "x": -14.3,
              "y": -13.391,
              "z": 0.591
            },
            "rightCorner": {
              "x": -14.041,
              "y": -13.389,
              "z": 0.591
            },
            "gtin": "4002239407304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53d4",
            "leftCorner": {
              "x": -14.874,
              "y": -13.395,
              "z": 0.591
            },
            "rightCorner": {
              "x": -14.785,
              "y": -13.394,
              "z": 0.591
            },
            "gtin": "4002239420907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53d5",
            "leftCorner": {
              "x": -13.963,
              "y": -13.345,
              "z": 0.591
            },
            "rightCorner": {
              "x": -13.713,
              "y": -13.343,
              "z": 0.591
            },
            "gtin": "4002239407304",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cece",
        "height": 0.93171,
        "facings": [
          {
            "id": "68d8e508e1820c81800d539f",
            "leftCorner": {
              "x": -14.816,
              "y": -13.349,
              "z": 0.762
            },
            "rightCorner": {
              "x": -14.671,
              "y": -13.347,
              "z": 0.762
            },
            "gtin": "4002239403009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53a0",
            "leftCorner": {
              "x": -14.671,
              "y": -13.347,
              "z": 0.762
            },
            "rightCorner": {
              "x": -14.525,
              "y": -13.346,
              "z": 0.762
            },
            "gtin": "4002239403009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53a1",
            "leftCorner": {
              "x": -14.525,
              "y": -13.342,
              "z": 0.762
            },
            "rightCorner": {
              "x": -14.457,
              "y": -13.342,
              "z": 0.762
            },
            "gtin": "4002239418300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53a4",
            "leftCorner": {
              "x": -14.362,
              "y": -13.342,
              "z": 0.762
            },
            "rightCorner": {
              "x": -14.3,
              "y": -13.341,
              "z": 0.762
            },
            "gtin": "4002239493000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53a5",
            "leftCorner": {
              "x": -14.3,
              "y": -13.341,
              "z": 0.762
            },
            "rightCorner": {
              "x": -14.238,
              "y": -13.341,
              "z": 0.762
            },
            "gtin": "4002239493000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53a6",
            "leftCorner": {
              "x": -14.238,
              "y": -13.34,
              "z": 0.762
            },
            "rightCorner": {
              "x": -14.105,
              "y": -13.34,
              "z": 0.762
            },
            "gtin": "4002239443203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53a7",
            "leftCorner": {
              "x": -14.105,
              "y": -13.338,
              "z": 0.762
            },
            "rightCorner": {
              "x": -13.936,
              "y": -13.337,
              "z": 0.762
            },
            "gtin": "4002239422604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5397",
            "leftCorner": {
              "x": -13.936,
              "y": -13.338,
              "z": 0.762
            },
            "rightCorner": {
              "x": -13.713,
              "y": -13.336,
              "z": 0.762
            },
            "gtin": "4002239423007",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "280e13c31eb0f41db476e225",
            "leftCorner": {
              "x": -14.963,
              "y": -13.386,
              "z": 0.762
            },
            "rightCorner": {
              "x": -14.84,
              "y": -13.385,
              "z": 0.762
            },
            "gtin": "4002239443609",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "792a3fc94049a2761b69c3d5",
            "leftCorner": {
              "x": -14.457,
              "y": -13.382,
              "z": 0.762
            },
            "rightCorner": {
              "x": -14.378,
              "y": -13.382,
              "z": 0.762
            },
            "gtin": "4002239418300",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cecc",
        "height": 1.1851,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5363",
            "leftCorner": {
              "x": -14.882,
              "y": -13.341,
              "z": 0.97
            },
            "rightCorner": {
              "x": -14.793,
              "y": -13.341,
              "z": 0.97
            },
            "gtin": "4002239695909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5364",
            "leftCorner": {
              "x": -14.793,
              "y": -13.342,
              "z": 0.97
            },
            "rightCorner": {
              "x": -14.623,
              "y": -13.341,
              "z": 0.97
            },
            "gtin": "4002239634007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5365",
            "leftCorner": {
              "x": -14.623,
              "y": -13.344,
              "z": 0.97
            },
            "rightCorner": {
              "x": -14.451,
              "y": -13.343,
              "z": 0.97
            },
            "gtin": "4002239632508",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d5366",
            "leftCorner": {
              "x": -14.451,
              "y": -13.337,
              "z": 0.97
            },
            "rightCorner": {
              "x": -14.281,
              "y": -13.335,
              "z": 0.97
            },
            "gtin": "4002239634106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5367",
            "leftCorner": {
              "x": -14.281,
              "y": -13.341,
              "z": 0.97
            },
            "rightCorner": {
              "x": -14.121,
              "y": -13.34,
              "z": 0.97
            },
            "gtin": "4002239634205",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d5368",
            "leftCorner": {
              "x": -14.121,
              "y": -13.339,
              "z": 0.97
            },
            "rightCorner": {
              "x": -13.901,
              "y": -13.337,
              "z": 0.97
            },
            "gtin": "4250426228151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d535b",
            "leftCorner": {
              "x": -13.901,
              "y": -13.331,
              "z": 0.97
            },
            "rightCorner": {
              "x": -13.713,
              "y": -13.33,
              "z": 0.97
            },
            "gtin": "4250426228175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4ab1cf6875f93584077a7bbc",
            "leftCorner": {
              "x": -14.963,
              "y": -13.384,
              "z": 0.97
            },
            "rightCorner": {
              "x": -14.883,
              "y": -13.383,
              "z": 0.97
            },
            "gtin": "4002239695909",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ced1",
        "height": 1.4141,
        "facings": [
          {
            "id": "68d8e508e1820c81800d53df",
            "leftCorner": {
              "x": -14.939,
              "y": -13.347,
              "z": 1.157
            },
            "rightCorner": {
              "x": -14.648,
              "y": -13.346,
              "z": 1.157
            },
            "gtin": "4002239696104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53e0",
            "leftCorner": {
              "x": -14.648,
              "y": -13.349,
              "z": 1.157
            },
            "rightCorner": {
              "x": -14.542,
              "y": -13.348,
              "z": 1.157
            },
            "gtin": "4002239594608",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d53e1",
            "leftCorner": {
              "x": -14.542,
              "y": -13.346,
              "z": 1.157
            },
            "rightCorner": {
              "x": -14.417,
              "y": -13.345,
              "z": 1.157
            },
            "gtin": "4002239610100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53e2",
            "leftCorner": {
              "x": -14.417,
              "y": -13.345,
              "z": 1.157
            },
            "rightCorner": {
              "x": -14.249,
              "y": -13.344,
              "z": 1.157
            },
            "gtin": "4002239614801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53e3",
            "leftCorner": {
              "x": -14.249,
              "y": -13.348,
              "z": 1.157
            },
            "rightCorner": {
              "x": -14.121,
              "y": -13.347,
              "z": 1.157
            },
            "gtin": "5200120444899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53da",
            "leftCorner": {
              "x": -14.121,
              "y": -13.347,
              "z": 1.157
            },
            "rightCorner": {
              "x": -13.713,
              "y": -13.343,
              "z": 1.157
            },
            "gtin": "4260176721093",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cecd",
        "height": 1.6391,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5373",
            "leftCorner": {
              "x": -14.905,
              "y": -13.345,
              "z": 1.341
            },
            "rightCorner": {
              "x": -14.789,
              "y": -13.344,
              "z": 1.341
            },
            "gtin": "4002239402910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5374",
            "leftCorner": {
              "x": -14.789,
              "y": -13.343,
              "z": 1.341
            },
            "rightCorner": {
              "x": -14.643,
              "y": -13.342,
              "z": 1.341
            },
            "gtin": "4002239390002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5375",
            "leftCorner": {
              "x": -14.643,
              "y": -13.343,
              "z": 1.341
            },
            "rightCorner": {
              "x": -14.344,
              "y": -13.34,
              "z": 1.341
            },
            "gtin": "4002239390705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5376",
            "leftCorner": {
              "x": -14.344,
              "y": -13.341,
              "z": 1.341
            },
            "rightCorner": {
              "x": -14.203,
              "y": -13.34,
              "z": 1.341
            },
            "gtin": "4002239360005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5377",
            "leftCorner": {
              "x": -14.203,
              "y": -13.342,
              "z": 1.341
            },
            "rightCorner": {
              "x": -14.01,
              "y": -13.34,
              "z": 1.341
            },
            "gtin": "4002239385008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5378",
            "leftCorner": {
              "x": -14.01,
              "y": -13.34,
              "z": 1.341
            },
            "rightCorner": {
              "x": -13.91,
              "y": -13.339,
              "z": 1.341
            },
            "gtin": "42298601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5379",
            "leftCorner": {
              "x": -13.91,
              "y": -13.337,
              "z": 1.341
            },
            "rightCorner": {
              "x": -13.807,
              "y": -13.336,
              "z": 1.341
            },
            "gtin": "4002442803047",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7e1",
    "rightNeighborShelfId": "7e4"
  },
  {
    "id": "7e4",
    "name": "7e4",
    "x": -13.713,
    "y": -13.328,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0038484,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 51
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539ceda",
        "height": 0.17247,
        "facings": [
          {
            "id": "bbce1890e7030926e1549a78",
            "leftCorner": {
              "x": -13.713,
              "y": -13.418,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.589,
              "y": -13.417,
              "z": 0.141
            },
            "gtin": "5200120446671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f106922414db7c814a2d7c22",
            "leftCorner": {
              "x": -13.589,
              "y": -13.417,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.422,
              "y": -13.416,
              "z": 0.141
            },
            "gtin": "5200120446688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1cb9280c9078d4dc3aa62c0c",
            "leftCorner": {
              "x": -13.422,
              "y": -13.416,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.375,
              "y": -13.415,
              "z": 0.141
            },
            "gtin": "4058700507080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "70c33734442f307495b055cf",
            "leftCorner": {
              "x": -13.375,
              "y": -13.415,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.295,
              "y": -13.415,
              "z": 0.141
            },
            "gtin": "5203817706010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8b00be46b237e20908e90862",
            "leftCorner": {
              "x": -13.295,
              "y": -13.415,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.21,
              "y": -13.414,
              "z": 0.141
            }
          },
          {
            "id": "78fe4582928806247dc8135d",
            "leftCorner": {
              "x": -13.21,
              "y": -13.414,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.11,
              "y": -13.413,
              "z": 0.141
            }
          },
          {
            "id": "2c13fe7f39fb68625a664b0f",
            "leftCorner": {
              "x": -13.11,
              "y": -13.413,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.008,
              "y": -13.413,
              "z": 0.141
            },
            "gtin": "4260176723615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a91535f685d3a023f2247c1f",
            "leftCorner": {
              "x": -13.008,
              "y": -13.413,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.893,
              "y": -13.412,
              "z": 0.141
            },
            "gtin": "4104420031722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "082f8f54cccc364c92fb5541",
            "leftCorner": {
              "x": -12.893,
              "y": -13.412,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.776,
              "y": -13.411,
              "z": 0.141
            },
            "gtin": "4316734083988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee3c2ddfb8b65b868bfb2bfa",
            "leftCorner": {
              "x": -12.776,
              "y": -13.411,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.655,
              "y": -13.41,
              "z": 0.141
            },
            "gtin": "4260737780071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "38b6b7514f954a9e5dedef31",
            "leftCorner": {
              "x": -12.655,
              "y": -13.41,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.474,
              "y": -13.408,
              "z": 0.141
            }
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ced8",
        "height": 0.45462,
        "facings": [
          {
            "id": "68d8e508e1820c81800d53bc",
            "leftCorner": {
              "x": -13.713,
              "y": -13.329,
              "z": 0.372
            },
            "rightCorner": {
              "x": -13.651,
              "y": -13.328,
              "z": 0.372
            },
            "gtin": "5203817706775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53bd",
            "leftCorner": {
              "x": -13.651,
              "y": -13.335,
              "z": 0.372
            },
            "rightCorner": {
              "x": -13.455,
              "y": -13.334,
              "z": 0.372
            },
            "gtin": "5203817706775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53be",
            "leftCorner": {
              "x": -13.455,
              "y": -13.336,
              "z": 0.372
            },
            "rightCorner": {
              "x": -13.258,
              "y": -13.334,
              "z": 0.372
            },
            "gtin": "5203817706782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53bf",
            "leftCorner": {
              "x": -13.258,
              "y": -13.321,
              "z": 0.372
            },
            "rightCorner": {
              "x": -13.039,
              "y": -13.319,
              "z": 0.372
            },
            "gtin": "5203817706799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53c0",
            "leftCorner": {
              "x": -13.039,
              "y": -13.319,
              "z": 0.372
            },
            "rightCorner": {
              "x": -12.819,
              "y": -13.318,
              "z": 0.372
            },
            "gtin": "5203817706799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53c1",
            "leftCorner": {
              "x": -12.819,
              "y": -13.323,
              "z": 0.372
            },
            "rightCorner": {
              "x": -12.753,
              "y": -13.322,
              "z": 0.372
            },
            "gtin": "5203817706812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53c2",
            "leftCorner": {
              "x": -12.753,
              "y": -13.322,
              "z": 0.372
            },
            "rightCorner": {
              "x": -12.688,
              "y": -13.322,
              "z": 0.372
            },
            "gtin": "5203817706812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53c3",
            "leftCorner": {
              "x": -12.688,
              "y": -13.322,
              "z": 0.372
            },
            "rightCorner": {
              "x": -12.622,
              "y": -13.321,
              "z": 0.372
            },
            "gtin": "5203817706812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53c4",
            "leftCorner": {
              "x": -12.622,
              "y": -13.32,
              "z": 0.372
            },
            "rightCorner": {
              "x": -12.463,
              "y": -13.319,
              "z": 0.372
            },
            "gtin": "5203817706010",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ced7",
        "height": 0.75385,
        "facings": [
          {
            "id": "68d8e508e1820c81800d540b",
            "leftCorner": {
              "x": -13.713,
              "y": -13.372,
              "z": 0.617
            },
            "rightCorner": {
              "x": -13.396,
              "y": -13.37,
              "z": 0.617
            },
            "gtin": "42271017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d540d",
            "leftCorner": {
              "x": -13.397,
              "y": -13.333,
              "z": 0.617
            },
            "rightCorner": {
              "x": -13.237,
              "y": -13.332,
              "z": 0.617
            },
            "gtin": "4260176722755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d540e",
            "leftCorner": {
              "x": -13.237,
              "y": -13.321,
              "z": 0.617
            },
            "rightCorner": {
              "x": -13.095,
              "y": -13.32,
              "z": 0.617
            },
            "gtin": "4104420211827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d540f",
            "leftCorner": {
              "x": -13.095,
              "y": -13.322,
              "z": 0.617
            },
            "rightCorner": {
              "x": -12.947,
              "y": -13.321,
              "z": 0.617
            },
            "gtin": "4104420132085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5410",
            "leftCorner": {
              "x": -12.947,
              "y": -13.327,
              "z": 0.617
            },
            "rightCorner": {
              "x": -12.783,
              "y": -13.326,
              "z": 0.617
            },
            "gtin": "42400660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5411",
            "leftCorner": {
              "x": -12.783,
              "y": -13.324,
              "z": 0.617
            },
            "rightCorner": {
              "x": -12.661,
              "y": -13.324,
              "z": 0.617
            },
            "gtin": "4104420140288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5412",
            "leftCorner": {
              "x": -12.661,
              "y": -13.324,
              "z": 0.617
            },
            "rightCorner": {
              "x": -12.538,
              "y": -13.323,
              "z": 0.617
            },
            "gtin": "4104420140288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5413",
            "leftCorner": {
              "x": -12.538,
              "y": -13.33,
              "z": 0.617
            },
            "rightCorner": {
              "x": -12.439,
              "y": -13.329,
              "z": 0.617
            },
            "gtin": "4260176720874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5414",
            "leftCorner": {
              "x": -12.439,
              "y": -13.329,
              "z": 0.617
            },
            "rightCorner": {
              "x": -12.339,
              "y": -13.329,
              "z": 0.617
            },
            "gtin": "4260176720874",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ced9",
        "height": 1.0336,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5425",
            "leftCorner": {
              "x": -13.713,
              "y": -13.363,
              "z": 0.846
            },
            "rightCorner": {
              "x": -13.638,
              "y": -13.362,
              "z": 0.846
            },
            "gtin": "4316734049960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5426",
            "leftCorner": {
              "x": -13.638,
              "y": -13.362,
              "z": 0.846
            },
            "rightCorner": {
              "x": -13.562,
              "y": -13.362,
              "z": 0.846
            },
            "gtin": "4316734049960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5427",
            "leftCorner": {
              "x": -13.562,
              "y": -13.362,
              "z": 0.846
            },
            "rightCorner": {
              "x": -13.487,
              "y": -13.362,
              "z": 0.846
            },
            "gtin": "4316734049960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5428",
            "leftCorner": {
              "x": -13.487,
              "y": -13.362,
              "z": 0.846
            },
            "rightCorner": {
              "x": -13.412,
              "y": -13.361,
              "z": 0.846
            },
            "gtin": "4316734049960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5429",
            "leftCorner": {
              "x": -13.412,
              "y": -13.361,
              "z": 0.846
            },
            "rightCorner": {
              "x": -13.337,
              "y": -13.361,
              "z": 0.846
            },
            "gtin": "4316734049960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d542b",
            "leftCorner": {
              "x": -13.338,
              "y": -13.319,
              "z": 0.846
            },
            "rightCorner": {
              "x": -13.202,
              "y": -13.318,
              "z": 0.846
            },
            "gtin": "4316734049946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d542c",
            "leftCorner": {
              "x": -13.202,
              "y": -13.318,
              "z": 0.846
            },
            "rightCorner": {
              "x": -13.101,
              "y": -13.317,
              "z": 0.846
            },
            "gtin": "4260176723615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d542d",
            "leftCorner": {
              "x": -13.101,
              "y": -13.318,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.865,
              "y": -13.317,
              "z": 0.846
            },
            "gtin": "4100240100259",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d542e",
            "leftCorner": {
              "x": -12.865,
              "y": -13.323,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.598,
              "y": -13.32,
              "z": 0.846
            },
            "gtin": "4104420237339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d542f",
            "leftCorner": {
              "x": -12.598,
              "y": -13.322,
              "z": 0.846
            },
            "rightCorner": {
              "x": -12.34,
              "y": -13.32,
              "z": 0.846
            },
            "gtin": "4306188390626",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ced5",
        "height": 1.3365,
        "facings": [
          {
            "id": "68d8e508e1820c81800d53f2",
            "leftCorner": {
              "x": -13.713,
              "y": -13.369,
              "z": 1.093
            },
            "rightCorner": {
              "x": -13.644,
              "y": -13.368,
              "z": 1.093
            }
          },
          {
            "id": "68d8e508e1820c81800d53f3",
            "leftCorner": {
              "x": -13.644,
              "y": -13.368,
              "z": 1.093
            },
            "rightCorner": {
              "x": -13.576,
              "y": -13.368,
              "z": 1.093
            }
          },
          {
            "id": "68d8e508e1820c81800d53f5",
            "leftCorner": {
              "x": -13.576,
              "y": -13.335,
              "z": 1.093
            },
            "rightCorner": {
              "x": -13.355,
              "y": -13.333,
              "z": 1.093
            },
            "gtin": "8715035110205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53f6",
            "leftCorner": {
              "x": -13.355,
              "y": -13.326,
              "z": 1.093
            },
            "rightCorner": {
              "x": -13.236,
              "y": -13.325,
              "z": 1.093
            },
            "gtin": "4104420031722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53f7",
            "leftCorner": {
              "x": -13.236,
              "y": -13.318,
              "z": 1.093
            },
            "rightCorner": {
              "x": -13.117,
              "y": -13.317,
              "z": 1.093
            },
            "gtin": "4260737780071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53f8",
            "leftCorner": {
              "x": -13.117,
              "y": -13.313,
              "z": 1.093
            },
            "rightCorner": {
              "x": -12.992,
              "y": -13.312,
              "z": 1.093
            },
            "gtin": "4316734063454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53f9",
            "leftCorner": {
              "x": -12.992,
              "y": -13.325,
              "z": 1.093
            },
            "rightCorner": {
              "x": -12.805,
              "y": -13.323,
              "z": 1.093
            },
            "gtin": "4058700621076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53fa",
            "leftCorner": {
              "x": -12.806,
              "y": -13.319,
              "z": 1.093
            },
            "rightCorner": {
              "x": -12.755,
              "y": -13.319,
              "z": 1.093
            },
            "gtin": "4058700507080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53fb",
            "leftCorner": {
              "x": -12.755,
              "y": -13.326,
              "z": 1.093
            },
            "rightCorner": {
              "x": -12.685,
              "y": -13.326,
              "z": 1.093
            },
            "gtin": "8715035270305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53fc",
            "leftCorner": {
              "x": -12.685,
              "y": -13.326,
              "z": 1.093
            },
            "rightCorner": {
              "x": -12.616,
              "y": -13.325,
              "z": 1.093
            },
            "gtin": "8715035270305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53fd",
            "leftCorner": {
              "x": -12.616,
              "y": -13.325,
              "z": 1.093
            },
            "rightCorner": {
              "x": -12.546,
              "y": -13.325,
              "z": 1.093
            },
            "gtin": "8715035270305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53fe",
            "leftCorner": {
              "x": -12.546,
              "y": -13.325,
              "z": 1.093
            },
            "rightCorner": {
              "x": -12.286,
              "y": -13.323,
              "z": 1.093
            },
            "gtin": "4316734083988",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539ced6",
        "height": 1.6386,
        "facings": [
          {
            "id": "68d8e508e1820c81800d537b",
            "leftCorner": {
              "x": -13.666,
              "y": -13.336,
              "z": 1.341
            },
            "rightCorner": {
              "x": -13.521,
              "y": -13.335,
              "z": 1.341
            }
          },
          {
            "id": "40df0a8430db2aa0aa5714c0",
            "leftCorner": {
              "x": -13.713,
              "y": -13.369,
              "z": 1.341
            },
            "rightCorner": {
              "x": -13.673,
              "y": -13.369,
              "z": 1.341
            },
            "gtin": "8853662056661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1817a6331c081c127faf8e72",
            "leftCorner": {
              "x": -13.284,
              "y": -13.366,
              "z": 1.341
            },
            "rightCorner": {
              "x": -13.184,
              "y": -13.365,
              "z": 1.341
            }
          },
          {
            "id": "68d8e508e1820c81800d537c",
            "leftCorner": {
              "x": -13.521,
              "y": -13.361,
              "z": 1.341
            },
            "rightCorner": {
              "x": -13.426,
              "y": -13.36,
              "z": 1.341
            }
          },
          {
            "id": "68d8e508e1820c81800d537d",
            "leftCorner": {
              "x": -13.427,
              "y": -13.336,
              "z": 1.341
            },
            "rightCorner": {
              "x": -13.344,
              "y": -13.335,
              "z": 1.341
            }
          },
          {
            "id": "68d8e508e1820c81800d537e",
            "leftCorner": {
              "x": -13.344,
              "y": -13.333,
              "z": 1.341
            },
            "rightCorner": {
              "x": -13.284,
              "y": -13.333,
              "z": 1.341
            }
          },
          {
            "id": "68d8e508e1820c81800d5380",
            "leftCorner": {
              "x": -13.177,
              "y": -13.319,
              "z": 1.341
            },
            "rightCorner": {
              "x": -13.109,
              "y": -13.318,
              "z": 1.341
            },
            "gtin": "8853662056005",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d5381",
            "leftCorner": {
              "x": -13.109,
              "y": -13.317,
              "z": 1.341
            },
            "rightCorner": {
              "x": -12.829,
              "y": -13.315,
              "z": 1.341
            },
            "gtin": "8853662056654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5382",
            "leftCorner": {
              "x": -12.829,
              "y": -13.324,
              "z": 1.341
            },
            "rightCorner": {
              "x": -12.693,
              "y": -13.323,
              "z": 1.341
            },
            "gtin": "8853662060613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5383",
            "leftCorner": {
              "x": -12.693,
              "y": -13.319,
              "z": 1.341
            },
            "rightCorner": {
              "x": -12.586,
              "y": -13.319,
              "z": 1.341
            },
            "gtin": "8853662056012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5384",
            "leftCorner": {
              "x": -12.586,
              "y": -13.319,
              "z": 1.341
            },
            "rightCorner": {
              "x": -12.479,
              "y": -13.317,
              "z": 1.341
            },
            "gtin": "8853662056012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5385",
            "leftCorner": {
              "x": -12.479,
              "y": -13.328,
              "z": 1.341
            },
            "rightCorner": {
              "x": -12.415,
              "y": -13.328,
              "z": 1.341
            },
            "gtin": "8853662056661",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7e3",
    "rightNeighborShelfId": "7e5"
  },
  {
    "id": "7e5",
    "name": "7e5",
    "x": -12.463,
    "y": -13.318,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0038484,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 35
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539cee0",
        "height": 0.14464,
        "facings": []
      },
      {
        "id": "68d8d3fe55f889d41539cedd",
        "height": 0.45471,
        "facings": [
          {
            "id": "68d8e508e1820c81800d53c5",
            "leftCorner": {
              "x": -12.463,
              "y": -13.321,
              "z": 0.372
            },
            "rightCorner": {
              "x": -12.424,
              "y": -13.322,
              "z": 0.372
            },
            "gtin": "5203817706034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53c6",
            "leftCorner": {
              "x": -12.424,
              "y": -13.317,
              "z": 0.372
            },
            "rightCorner": {
              "x": -12.304,
              "y": -13.317,
              "z": 0.372
            },
            "gtin": "5203817706034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53c7",
            "leftCorner": {
              "x": -12.304,
              "y": -13.316,
              "z": 0.372
            },
            "rightCorner": {
              "x": -11.901,
              "y": -13.313,
              "z": 0.372
            },
            "gtin": "4260176723219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53c8",
            "leftCorner": {
              "x": -11.9,
              "y": -13.322,
              "z": 0.372
            },
            "rightCorner": {
              "x": -11.719,
              "y": -13.321,
              "z": 0.372
            },
            "gtin": "4260176723189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53c9",
            "leftCorner": {
              "x": -11.719,
              "y": -13.318,
              "z": 0.372
            },
            "rightCorner": {
              "x": -11.579,
              "y": -13.316,
              "z": 0.372
            },
            "gtin": "4260176723103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53ca",
            "leftCorner": {
              "x": -11.579,
              "y": -13.315,
              "z": 0.372
            },
            "rightCorner": {
              "x": -11.404,
              "y": -13.314,
              "z": 0.372
            },
            "gtin": "4306188040101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53cb",
            "leftCorner": {
              "x": -11.404,
              "y": -13.312,
              "z": 0.372
            },
            "rightCorner": {
              "x": -11.149,
              "y": -13.31,
              "z": 0.372
            },
            "gtin": "5900385012528",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cedc",
        "height": 0.75418,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5415",
            "leftCorner": {
              "x": -12.339,
              "y": -13.324,
              "z": 0.617
            },
            "rightCorner": {
              "x": -12.109,
              "y": -13.322,
              "z": 0.617
            },
            "gtin": "4260176720522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "115d5c1209a78dfe02f22bb5",
            "leftCorner": {
              "x": -12.463,
              "y": -13.364,
              "z": 0.617
            },
            "rightCorner": {
              "x": -12.345,
              "y": -13.363,
              "z": 0.617
            },
            "gtin": "4260176720522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5416",
            "leftCorner": {
              "x": -12.109,
              "y": -13.325,
              "z": 0.617
            },
            "rightCorner": {
              "x": -11.892,
              "y": -13.323,
              "z": 0.617
            },
            "gtin": "4306188040132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5417",
            "leftCorner": {
              "x": -11.892,
              "y": -13.323,
              "z": 0.617
            },
            "rightCorner": {
              "x": -11.699,
              "y": -13.321,
              "z": 0.617
            },
            "gtin": "4306188040163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5418",
            "leftCorner": {
              "x": -11.699,
              "y": -13.321,
              "z": 0.617
            },
            "rightCorner": {
              "x": -11.506,
              "y": -13.319,
              "z": 0.617
            },
            "gtin": "4306188040163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5419",
            "leftCorner": {
              "x": -11.506,
              "y": -13.316,
              "z": 0.617
            },
            "rightCorner": {
              "x": -11.372,
              "y": -13.315,
              "z": 0.617
            },
            "gtin": "8901552025065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d541a",
            "leftCorner": {
              "x": -11.372,
              "y": -13.315,
              "z": 0.617
            },
            "rightCorner": {
              "x": -11.242,
              "y": -13.314,
              "z": 0.617
            },
            "gtin": "8901552025164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d541b",
            "leftCorner": {
              "x": -11.242,
              "y": -13.314,
              "z": 0.617
            },
            "rightCorner": {
              "x": -11.112,
              "y": -13.313,
              "z": 0.617
            },
            "gtin": "8901552025164",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cedb",
        "height": 1.033,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5430",
            "leftCorner": {
              "x": -12.34,
              "y": -13.32,
              "z": 0.845
            },
            "rightCorner": {
              "x": -12.256,
              "y": -13.319,
              "z": 0.845
            },
            "gtin": "4104420034327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2dd0c53c6d365867d1f5dfe5",
            "leftCorner": {
              "x": -12.463,
              "y": -13.365,
              "z": 0.845
            },
            "rightCorner": {
              "x": -12.355,
              "y": -13.364,
              "z": 0.845
            },
            "gtin": "4007552310843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5431",
            "leftCorner": {
              "x": -12.256,
              "y": -13.319,
              "z": 0.845
            },
            "rightCorner": {
              "x": -12.172,
              "y": -13.319,
              "z": 0.845
            },
            "gtin": "4104420034327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5432",
            "leftCorner": {
              "x": -12.172,
              "y": -13.319,
              "z": 0.845
            },
            "rightCorner": {
              "x": -12.088,
              "y": -13.318,
              "z": 0.845
            },
            "gtin": "4104420034327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5433",
            "leftCorner": {
              "x": -12.088,
              "y": -13.324,
              "z": 0.845
            },
            "rightCorner": {
              "x": -11.804,
              "y": -13.321,
              "z": 0.845
            },
            "gtin": "4024398191139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5434",
            "leftCorner": {
              "x": -11.804,
              "y": -13.32,
              "z": 0.845
            },
            "rightCorner": {
              "x": -11.525,
              "y": -13.319,
              "z": 0.845
            },
            "gtin": "4007552304507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5435",
            "leftCorner": {
              "x": -11.525,
              "y": -13.319,
              "z": 0.845
            },
            "rightCorner": {
              "x": -11.425,
              "y": -13.317,
              "z": 0.845
            },
            "gtin": "4007552310867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5436",
            "leftCorner": {
              "x": -11.425,
              "y": -13.316,
              "z": 0.845
            },
            "rightCorner": {
              "x": -11.214,
              "y": -13.315,
              "z": 0.845
            },
            "gtin": "4007552310843",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cede",
        "height": 1.3372,
        "facings": [
          {
            "id": "68d8e508e1820c81800d53ff",
            "leftCorner": {
              "x": -12.286,
              "y": -13.323,
              "z": 1.094
            },
            "rightCorner": {
              "x": -12.06,
              "y": -13.321,
              "z": 1.094
            },
            "gtin": "4316734049908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a8845df8a114d62bad024d2f",
            "leftCorner": {
              "x": -12.463,
              "y": -13.365,
              "z": 1.094
            },
            "rightCorner": {
              "x": -12.292,
              "y": -13.364,
              "z": 1.094
            },
            "gtin": "4316734083964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5400",
            "leftCorner": {
              "x": -12.059,
              "y": -13.327,
              "z": 1.094
            },
            "rightCorner": {
              "x": -11.892,
              "y": -13.326,
              "z": 1.094
            },
            "gtin": "4316734083964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5401",
            "leftCorner": {
              "x": -11.892,
              "y": -13.325,
              "z": 1.094
            },
            "rightCorner": {
              "x": -11.701,
              "y": -13.324,
              "z": 1.094
            },
            "gtin": "4316734069005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5402",
            "leftCorner": {
              "x": -11.701,
              "y": -13.319,
              "z": 1.094
            },
            "rightCorner": {
              "x": -11.492,
              "y": -13.317,
              "z": 1.094
            },
            "gtin": "4104420243781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5403",
            "leftCorner": {
              "x": -11.492,
              "y": -13.315,
              "z": 1.094
            },
            "rightCorner": {
              "x": -11.288,
              "y": -13.314,
              "z": 1.094
            },
            "gtin": "4260122510405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5404",
            "leftCorner": {
              "x": -11.288,
              "y": -13.313,
              "z": 1.094
            },
            "rightCorner": {
              "x": -11.214,
              "y": -13.313,
              "z": 1.094
            },
            "gtin": "4260122512805",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cedf",
        "height": 1.6374,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5386",
            "leftCorner": {
              "x": -12.415,
              "y": -13.325,
              "z": 1.34
            },
            "rightCorner": {
              "x": -12.299,
              "y": -13.324,
              "z": 1.34
            },
            "gtin": "4316734049892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5387",
            "leftCorner": {
              "x": -12.299,
              "y": -13.323,
              "z": 1.34
            },
            "rightCorner": {
              "x": -12.028,
              "y": -13.32,
              "z": 1.34
            },
            "gtin": "4031446500515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5388",
            "leftCorner": {
              "x": -12.028,
              "y": -13.323,
              "z": 1.34
            },
            "rightCorner": {
              "x": -11.736,
              "y": -13.32,
              "z": 1.34
            },
            "gtin": "4031446820453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5389",
            "leftCorner": {
              "x": -11.736,
              "y": -13.319,
              "z": 1.34
            },
            "rightCorner": {
              "x": -11.431,
              "y": -13.317,
              "z": 1.34
            },
            "gtin": "4031446500539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d538a",
            "leftCorner": {
              "x": -11.431,
              "y": -13.312,
              "z": 1.34
            },
            "rightCorner": {
              "x": -11.214,
              "y": -13.311,
              "z": 1.34
            },
            "gtin": "4031446806273",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7e4",
    "rightNeighborShelfId": "7e6"
  },
  {
    "id": "7e6",
    "name": "7e6",
    "x": -11.213,
    "y": -13.309,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0038484,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 55
    },
    "layers": [
      {
        "id": "68d8d3fe55f889d41539cee6",
        "height": 0.17498,
        "facings": [
          {
            "id": "74ffd2c6017ad3adc9dc07e9",
            "leftCorner": {
              "x": -11.212,
              "y": -13.398,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.156,
              "y": -13.398,
              "z": 0.143
            },
            "gtin": "8853662004068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e42a4dcd8b380ec9b457832a",
            "leftCorner": {
              "x": -11.156,
              "y": -13.398,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.086,
              "y": -13.397,
              "z": 0.143
            },
            "gtin": "8901552021760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a9cfa4b42f8231b0a57cfdd7",
            "leftCorner": {
              "x": -11.086,
              "y": -13.397,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.002,
              "y": -13.396,
              "z": 0.143
            },
            "gtin": "886518000974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "96f0461d5afb0225220a02c3",
            "leftCorner": {
              "x": -11.002,
              "y": -13.396,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.916,
              "y": -13.396,
              "z": 0.143
            },
            "gtin": "4967825561023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "61ce06f83d9896484295fdcc",
            "leftCorner": {
              "x": -10.916,
              "y": -13.396,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.828,
              "y": -13.395,
              "z": 0.143
            }
          },
          {
            "id": "7eacd80980b03f93f6d4f081",
            "leftCorner": {
              "x": -10.828,
              "y": -13.395,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.74,
              "y": -13.394,
              "z": 0.143
            },
            "gtin": "4316734180946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6049c3df4ae0ce4c6a654c2c",
            "leftCorner": {
              "x": -10.74,
              "y": -13.394,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.638,
              "y": -13.394,
              "z": 0.143
            },
            "gtin": "4969673007913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "95a4961a4a4d7e521336b64c",
            "leftCorner": {
              "x": -10.638,
              "y": -13.394,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.533,
              "y": -13.393,
              "z": 0.143
            }
          },
          {
            "id": "3ccd400d959cd8bc674480d0",
            "leftCorner": {
              "x": -10.533,
              "y": -13.393,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.427,
              "y": -13.392,
              "z": 0.143
            },
            "gtin": "4316734091549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "702b0374ed11fd440ead0ea4",
            "leftCorner": {
              "x": -10.427,
              "y": -13.392,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.316,
              "y": -13.391,
              "z": 0.143
            },
            "gtin": "8853662040240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a4bafaeede34ae49b93b87ee",
            "leftCorner": {
              "x": -10.316,
              "y": -13.391,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.204,
              "y": -13.39,
              "z": 0.143
            },
            "gtin": "8853662001340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "922e8c0ba7abbcf1d2dde6f7",
            "leftCorner": {
              "x": -10.204,
              "y": -13.39,
              "z": 0.143
            },
            "rightCorner": {
              "x": -9.972,
              "y": -13.388,
              "z": 0.143
            },
            "gtin": "8853662002002",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cee5",
        "height": 0.45589,
        "facings": [
          {
            "id": "68d8e508e1820c81800d53cc",
            "leftCorner": {
              "x": -11.148,
              "y": -13.313,
              "z": 0.373
            },
            "rightCorner": {
              "x": -11.042,
              "y": -13.312,
              "z": 0.373
            },
            "gtin": "4316734091549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53cd",
            "leftCorner": {
              "x": -11.042,
              "y": -13.312,
              "z": 0.373
            },
            "rightCorner": {
              "x": -10.912,
              "y": -13.312,
              "z": 0.373
            },
            "gtin": "4316734091556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53ce",
            "leftCorner": {
              "x": -10.912,
              "y": -13.306,
              "z": 0.373
            },
            "rightCorner": {
              "x": -10.732,
              "y": -13.304,
              "z": 0.373
            },
            "gtin": "4316734091617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53cf",
            "leftCorner": {
              "x": -10.732,
              "y": -13.298,
              "z": 0.373
            },
            "rightCorner": {
              "x": -10.653,
              "y": -13.298,
              "z": 0.373
            }
          },
          {
            "id": "68d8e508e1820c81800d53d0",
            "leftCorner": {
              "x": -10.653,
              "y": -13.3,
              "z": 0.373
            },
            "rightCorner": {
              "x": -10.558,
              "y": -13.3,
              "z": 0.373
            }
          },
          {
            "id": "68d8e508e1820c81800d53d1",
            "leftCorner": {
              "x": -10.558,
              "y": -13.295,
              "z": 0.373
            },
            "rightCorner": {
              "x": -10.433,
              "y": -13.294,
              "z": 0.373
            },
            "gtin": "4316734091662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53d2",
            "leftCorner": {
              "x": -10.434,
              "y": -13.286,
              "z": 0.373
            },
            "rightCorner": {
              "x": -10.314,
              "y": -13.286,
              "z": 0.373
            },
            "gtin": "4316734091655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53a9",
            "leftCorner": {
              "x": -10.314,
              "y": -13.294,
              "z": 0.373
            },
            "rightCorner": {
              "x": -9.963,
              "y": -13.291,
              "z": 0.373
            },
            "gtin": "4316734073903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2cd9f8d110508ea16bcdcb30",
            "leftCorner": {
              "x": -11.212,
              "y": -13.342,
              "z": 0.373
            },
            "rightCorner": {
              "x": -11.149,
              "y": -13.342,
              "z": 0.373
            },
            "gtin": "4316734091655",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cee1",
        "height": 0.75396,
        "facings": [
          {
            "id": "68d8e508e1820c81800d541c",
            "leftCorner": {
              "x": -11.111,
              "y": -13.311,
              "z": 0.617
            },
            "rightCorner": {
              "x": -11.039,
              "y": -13.31,
              "z": 0.617
            },
            "gtin": "8901552021791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d541d",
            "leftCorner": {
              "x": -11.039,
              "y": -13.31,
              "z": 0.617
            },
            "rightCorner": {
              "x": -10.967,
              "y": -13.31,
              "z": 0.617
            },
            "gtin": "8901552021791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d541e",
            "leftCorner": {
              "x": -10.967,
              "y": -13.31,
              "z": 0.617
            },
            "rightCorner": {
              "x": -10.833,
              "y": -13.309,
              "z": 0.617
            },
            "gtin": "8901552021760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d541f",
            "leftCorner": {
              "x": -10.833,
              "y": -13.308,
              "z": 0.617
            },
            "rightCorner": {
              "x": -10.771,
              "y": -13.308,
              "z": 0.617
            },
            "gtin": "8901552021708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5420",
            "leftCorner": {
              "x": -10.771,
              "y": -13.308,
              "z": 0.617
            },
            "rightCorner": {
              "x": -10.708,
              "y": -13.307,
              "z": 0.617
            },
            "gtin": "8901552021708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5421",
            "leftCorner": {
              "x": -10.708,
              "y": -13.3,
              "z": 0.617
            },
            "rightCorner": {
              "x": -10.552,
              "y": -13.3,
              "z": 0.617
            },
            "gtin": "8901552025430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5422",
            "leftCorner": {
              "x": -10.552,
              "y": -13.305,
              "z": 0.617
            },
            "rightCorner": {
              "x": -10.353,
              "y": -13.303,
              "z": 0.617
            },
            "gtin": "8901552015530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5423",
            "leftCorner": {
              "x": -10.353,
              "y": -13.3,
              "z": 0.617
            },
            "rightCorner": {
              "x": -10.272,
              "y": -13.3,
              "z": 0.617
            },
            "gtin": "8901552019316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d540c",
            "leftCorner": {
              "x": -10.169,
              "y": -13.295,
              "z": 0.617
            },
            "rightCorner": {
              "x": -9.963,
              "y": -13.294,
              "z": 0.617
            },
            "gtin": "690225301244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5261242e47d49656c8349763",
            "leftCorner": {
              "x": -11.212,
              "y": -13.348,
              "z": 0.617
            },
            "rightCorner": {
              "x": -11.149,
              "y": -13.348,
              "z": 0.617
            },
            "gtin": "8901552021708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "28b25ca14631b66ae70863c6",
            "leftCorner": {
              "x": -10.272,
              "y": -13.341,
              "z": 0.617
            },
            "rightCorner": {
              "x": -10.201,
              "y": -13.34,
              "z": 0.617
            },
            "gtin": "8901552021791",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cee2",
        "height": 1.0331,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5437",
            "leftCorner": {
              "x": -11.213,
              "y": -13.306,
              "z": 0.845
            },
            "rightCorner": {
              "x": -11.112,
              "y": -13.304,
              "z": 0.845
            },
            "gtin": "4316734081076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5438",
            "leftCorner": {
              "x": -11.112,
              "y": -13.312,
              "z": 0.845
            },
            "rightCorner": {
              "x": -10.887,
              "y": -13.31,
              "z": 0.845
            },
            "gtin": "4316734081076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5439",
            "leftCorner": {
              "x": -10.887,
              "y": -13.306,
              "z": 0.845
            },
            "rightCorner": {
              "x": -10.799,
              "y": -13.305,
              "z": 0.845
            },
            "gtin": "4967825561023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d543a",
            "leftCorner": {
              "x": -10.799,
              "y": -13.306,
              "z": 0.845
            },
            "rightCorner": {
              "x": -10.716,
              "y": -13.304,
              "z": 0.845
            },
            "gtin": "4316734180946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d543b",
            "leftCorner": {
              "x": -10.716,
              "y": -13.308,
              "z": 0.845
            },
            "rightCorner": {
              "x": -10.631,
              "y": -13.307,
              "z": 0.845
            },
            "gtin": "4969673007913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d543c",
            "leftCorner": {
              "x": -10.631,
              "y": -13.302,
              "z": 0.845
            },
            "rightCorner": {
              "x": -10.558,
              "y": -13.302,
              "z": 0.845
            },
            "gtin": "4969673007906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d543d",
            "leftCorner": {
              "x": -10.558,
              "y": -13.302,
              "z": 0.845
            },
            "rightCorner": {
              "x": -10.484,
              "y": -13.302,
              "z": 0.845
            },
            "gtin": "4969673007906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d543e",
            "leftCorner": {
              "x": -10.484,
              "y": -13.3,
              "z": 0.845
            },
            "rightCorner": {
              "x": -10.364,
              "y": -13.298,
              "z": 0.845
            },
            "gtin": "4965249200382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d543f",
            "leftCorner": {
              "x": -10.364,
              "y": -13.298,
              "z": 0.845
            },
            "rightCorner": {
              "x": -10.09,
              "y": -13.296,
              "z": 0.845
            },
            "gtin": "4316734081281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d542a",
            "leftCorner": {
              "x": -10.09,
              "y": -13.294,
              "z": 0.845
            },
            "rightCorner": {
              "x": -9.963,
              "y": -13.293,
              "z": 0.845
            },
            "gtin": "4316734060453",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cee3",
        "height": 1.3386,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5405",
            "leftCorner": {
              "x": -11.213,
              "y": -13.306,
              "z": 1.095
            },
            "rightCorner": {
              "x": -11.096,
              "y": -13.303,
              "z": 1.095
            },
            "gtin": "4316734083926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5406",
            "leftCorner": {
              "x": -11.096,
              "y": -13.306,
              "z": 1.095
            },
            "rightCorner": {
              "x": -10.932,
              "y": -13.304,
              "z": 1.095
            },
            "gtin": "4316734083926",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d5407",
            "leftCorner": {
              "x": -10.932,
              "y": -13.309,
              "z": 1.095
            },
            "rightCorner": {
              "x": -10.847,
              "y": -13.308,
              "z": 1.095
            },
            "gtin": "886518000974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5408",
            "leftCorner": {
              "x": -10.847,
              "y": -13.313,
              "z": 1.095
            },
            "rightCorner": {
              "x": -10.634,
              "y": -13.311,
              "z": 1.095
            },
            "gtin": "8853662005027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5409",
            "leftCorner": {
              "x": -10.634,
              "y": -13.309,
              "z": 1.095
            },
            "rightCorner": {
              "x": -10.399,
              "y": -13.307,
              "z": 1.095
            },
            "gtin": "8853662002002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d540a",
            "leftCorner": {
              "x": -10.399,
              "y": -13.298,
              "z": 1.095
            },
            "rightCorner": {
              "x": -10.173,
              "y": -13.296,
              "z": 1.095
            },
            "gtin": "8853662002088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d53f4",
            "leftCorner": {
              "x": -10.173,
              "y": -13.294,
              "z": 1.095
            },
            "rightCorner": {
              "x": -9.963,
              "y": -13.293,
              "z": 1.095
            },
            "gtin": "8853662002125",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cee4",
        "height": 1.639,
        "facings": [
          {
            "id": "68d8e508e1820c81800d538b",
            "leftCorner": {
              "x": -11.213,
              "y": -13.298,
              "z": 1.341
            },
            "rightCorner": {
              "x": -11.062,
              "y": -13.293,
              "z": 1.341
            },
            "gtin": "8853662004020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d538c",
            "leftCorner": {
              "x": -11.062,
              "y": -13.312,
              "z": 1.341
            },
            "rightCorner": {
              "x": -10.953,
              "y": -13.312,
              "z": 1.341
            },
            "gtin": "8853662004020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d538f",
            "leftCorner": {
              "x": -10.82,
              "y": -13.299,
              "z": 1.341
            },
            "rightCorner": {
              "x": -10.655,
              "y": -13.297,
              "z": 1.341
            },
            "gtin": "8853662040103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5390",
            "leftCorner": {
              "x": -10.655,
              "y": -13.3,
              "z": 1.341
            },
            "rightCorner": {
              "x": -10.545,
              "y": -13.3,
              "z": 1.341
            },
            "gtin": "8853662040240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5391",
            "leftCorner": {
              "x": -10.545,
              "y": -13.296,
              "z": 1.341
            },
            "rightCorner": {
              "x": -10.43,
              "y": -13.294,
              "z": 1.341
            },
            "gtin": "8853662001340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5392",
            "leftCorner": {
              "x": -10.43,
              "y": -13.292,
              "z": 1.341
            },
            "rightCorner": {
              "x": -10.308,
              "y": -13.291,
              "z": 1.341
            },
            "gtin": "8853662001357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5393",
            "leftCorner": {
              "x": -10.308,
              "y": -13.294,
              "z": 1.341
            },
            "rightCorner": {
              "x": -10.228,
              "y": -13.294,
              "z": 1.341
            },
            "gtin": "8853662001364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5394",
            "leftCorner": {
              "x": -10.228,
              "y": -13.294,
              "z": 1.341
            },
            "rightCorner": {
              "x": -10.149,
              "y": -13.293,
              "z": 1.341
            },
            "gtin": "8853662001364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5395",
            "leftCorner": {
              "x": -10.149,
              "y": -13.291,
              "z": 1.341
            },
            "rightCorner": {
              "x": -10.019,
              "y": -13.291,
              "z": 1.341
            },
            "gtin": "8853662041308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d536a",
            "leftCorner": {
              "x": -10.019,
              "y": -13.294,
              "z": 1.341
            },
            "rightCorner": {
              "x": -9.963,
              "y": -13.294,
              "z": 1.341
            },
            "gtin": "8853662004068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "db611c215b0f7d73a05f02d3",
            "leftCorner": {
              "x": -10.953,
              "y": -13.339,
              "z": 1.341
            },
            "rightCorner": {
              "x": -10.821,
              "y": -13.338,
              "z": 1.341
            },
            "gtin": "8853662041308",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7e5"
  },
  {
    "id": "7e7",
    "name": "7e7",
    "x": -9.127,
    "y": -13.23,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71577,
      "w": 0.69834
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d61f",
        "height": 1.1277,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8561",
            "leftCorner": {
              "x": -9.343,
              "y": -13.235,
              "z": 0.923
            },
            "rightCorner": {
              "x": -9.356,
              "y": -12.702,
              "z": 0.923
            },
            "gtin": "40804927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8567",
            "leftCorner": {
              "x": -9.396,
              "y": -12.703,
              "z": 0.923
            },
            "rightCorner": {
              "x": -9.397,
              "y": -12.624,
              "z": 0.923
            },
            "gtin": "40804941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8568",
            "leftCorner": {
              "x": -9.397,
              "y": -12.624,
              "z": 0.923
            },
            "rightCorner": {
              "x": -9.399,
              "y": -12.545,
              "z": 0.923
            },
            "gtin": "40804941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8569",
            "leftCorner": {
              "x": -9.399,
              "y": -12.545,
              "z": 0.923
            },
            "rightCorner": {
              "x": -9.401,
              "y": -12.466,
              "z": 0.923
            },
            "gtin": "40804941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d856a",
            "leftCorner": {
              "x": -9.401,
              "y": -12.466,
              "z": 0.923
            },
            "rightCorner": {
              "x": -9.403,
              "y": -12.387,
              "z": 0.923
            },
            "gtin": "40804941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d856b",
            "leftCorner": {
              "x": -9.403,
              "y": -12.387,
              "z": 0.923
            },
            "rightCorner": {
              "x": -9.405,
              "y": -12.308,
              "z": 0.923
            },
            "gtin": "40804941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8562",
            "leftCorner": {
              "x": -9.41,
              "y": -12.308,
              "z": 0.923
            },
            "rightCorner": {
              "x": -9.412,
              "y": -12.244,
              "z": 0.923
            },
            "gtin": "40804996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8563",
            "leftCorner": {
              "x": -9.412,
              "y": -12.244,
              "z": 0.923
            },
            "rightCorner": {
              "x": -9.413,
              "y": -12.179,
              "z": 0.923
            },
            "gtin": "40804996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8564",
            "leftCorner": {
              "x": -9.413,
              "y": -12.179,
              "z": 0.923
            },
            "rightCorner": {
              "x": -9.415,
              "y": -12.115,
              "z": 0.923
            },
            "gtin": "40804996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8565",
            "leftCorner": {
              "x": -9.415,
              "y": -12.115,
              "z": 0.923
            },
            "rightCorner": {
              "x": -9.416,
              "y": -12.051,
              "z": 0.923
            },
            "gtin": "40804996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8566",
            "leftCorner": {
              "x": -9.416,
              "y": -12.051,
              "z": 0.923
            },
            "rightCorner": {
              "x": -9.418,
              "y": -11.986,
              "z": 0.923
            },
            "gtin": "40804996",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d621",
        "height": 1.6573,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d856e",
            "leftCorner": {
              "x": -9.342,
              "y": -13.235,
              "z": 1.356
            },
            "rightCorner": {
              "x": -9.356,
              "y": -12.691,
              "z": 1.356
            },
            "gtin": "4012200417409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8570",
            "leftCorner": {
              "x": -9.394,
              "y": -12.692,
              "z": 1.356
            },
            "rightCorner": {
              "x": -9.399,
              "y": -12.492,
              "z": 1.356
            },
            "gtin": "4260334689128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8571",
            "leftCorner": {
              "x": -9.402,
              "y": -12.492,
              "z": 1.356
            },
            "rightCorner": {
              "x": -9.408,
              "y": -12.248,
              "z": 1.356
            },
            "gtin": "4260334680057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8572",
            "leftCorner": {
              "x": -9.408,
              "y": -12.248,
              "z": 1.356
            },
            "rightCorner": {
              "x": -9.412,
              "y": -12.077,
              "z": 1.356
            },
            "gtin": "4260334680019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d856f",
            "leftCorner": {
              "x": -9.412,
              "y": -12.077,
              "z": 1.356
            },
            "rightCorner": {
              "x": -9.414,
              "y": -11.986,
              "z": 1.356
            },
            "gtin": "4009309142417",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d620",
        "height": 1.8029,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d856d",
            "leftCorner": {
              "x": -9.412,
              "y": -13.105,
              "z": 1.475
            },
            "rightCorner": {
              "x": -9.44,
              "y": -11.988,
              "z": 1.475
            },
            "gtin": "4008033598620",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "7e8",
    "name": "7e8",
    "x": -16.73,
    "y": -12.215,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70465,
      "w": 0.70956
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 6
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d623",
        "height": 0.64378,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8575",
            "leftCorner": {
              "x": -16.749,
              "y": -12.215,
              "z": 0.527
            },
            "rightCorner": {
              "x": -16.748,
              "y": -12.536,
              "z": 0.527
            },
            "gtin": "4306188022916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8576",
            "leftCorner": {
              "x": -16.748,
              "y": -12.536,
              "z": 0.527
            },
            "rightCorner": {
              "x": -16.745,
              "y": -12.857,
              "z": 0.527
            },
            "gtin": "4306188022916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8577",
            "leftCorner": {
              "x": -16.7,
              "y": -12.857,
              "z": 0.527
            },
            "rightCorner": {
              "x": -16.699,
              "y": -13.161,
              "z": 0.527
            },
            "gtin": "4306188424086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8578",
            "leftCorner": {
              "x": -16.699,
              "y": -13.161,
              "z": 0.527
            },
            "rightCorner": {
              "x": -16.697,
              "y": -13.465,
              "z": 0.527
            },
            "gtin": "4306188424086",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d622",
        "height": 0.97688,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8573",
            "leftCorner": {
              "x": -16.755,
              "y": -12.215,
              "z": 0.799
            },
            "rightCorner": {
              "x": -16.751,
              "y": -12.877,
              "z": 0.799
            },
            "gtin": "4306188047445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8574",
            "leftCorner": {
              "x": -16.705,
              "y": -12.877,
              "z": 0.799
            },
            "rightCorner": {
              "x": -16.701,
              "y": -13.465,
              "z": 0.799
            },
            "gtin": "4306188027362",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "7e9",
    "name": "7e9",
    "x": -15.247,
    "y": -15.01,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 0.0010123
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 35,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cef1",
        "height": 0.16468,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5491",
            "leftCorner": {
              "x": -15.247,
              "y": -14.94,
              "z": 0.135
            },
            "rightCorner": {
              "x": -15.372,
              "y": -14.941,
              "z": 0.135
            },
            "gtin": "4032549012394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5492",
            "leftCorner": {
              "x": -15.372,
              "y": -14.941,
              "z": 0.135
            },
            "rightCorner": {
              "x": -15.498,
              "y": -14.941,
              "z": 0.135
            },
            "gtin": "4032549012394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5495",
            "leftCorner": {
              "x": -15.498,
              "y": -14.979,
              "z": 0.135
            },
            "rightCorner": {
              "x": -15.62,
              "y": -14.98,
              "z": 0.135
            },
            "gtin": "4032549023079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5496",
            "leftCorner": {
              "x": -15.62,
              "y": -14.981,
              "z": 0.135
            },
            "rightCorner": {
              "x": -15.708,
              "y": -14.981,
              "z": 0.135
            },
            "gtin": "4260117090004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5497",
            "leftCorner": {
              "x": -15.708,
              "y": -14.981,
              "z": 0.135
            },
            "rightCorner": {
              "x": -15.965,
              "y": -14.982,
              "z": 0.135
            },
            "gtin": "4032549032552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5493",
            "leftCorner": {
              "x": -15.965,
              "y": -14.983,
              "z": 0.135
            },
            "rightCorner": {
              "x": -16.106,
              "y": -14.983,
              "z": 0.135
            },
            "gtin": "4032549003736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5494",
            "leftCorner": {
              "x": -16.106,
              "y": -14.983,
              "z": 0.135
            },
            "rightCorner": {
              "x": -16.247,
              "y": -14.983,
              "z": 0.135
            },
            "gtin": "4032549003736",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539ceee",
        "height": 0.53666,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5480",
            "leftCorner": {
              "x": -15.247,
              "y": -14.968,
              "z": 0.439
            },
            "rightCorner": {
              "x": -15.803,
              "y": -14.969,
              "z": 0.439
            },
            "gtin": "4032549014084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5481",
            "leftCorner": {
              "x": -15.803,
              "y": -15.012,
              "z": 0.439
            },
            "rightCorner": {
              "x": -16.247,
              "y": -15.012,
              "z": 0.439
            },
            "gtin": "4032549023352",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cef2",
        "height": 0.75837,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5498",
            "leftCorner": {
              "x": -15.247,
              "y": -14.976,
              "z": 0.62
            },
            "rightCorner": {
              "x": -15.499,
              "y": -14.977,
              "z": 0.62
            },
            "gtin": "5900334000781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "044df000e0381d57b28c13b9",
            "leftCorner": {
              "x": -15.71,
              "y": -14.977,
              "z": 0.62
            },
            "rightCorner": {
              "x": -15.886,
              "y": -14.977,
              "z": 0.62
            },
            "gtin": "5900334000149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b43bcd87e333b621f1b7cab9",
            "leftCorner": {
              "x": -16.113,
              "y": -14.978,
              "z": 0.62
            },
            "rightCorner": {
              "x": -16.202,
              "y": -14.978,
              "z": 0.62
            },
            "gtin": "4032549049598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d549a",
            "leftCorner": {
              "x": -15.499,
              "y": -15.012,
              "z": 0.62
            },
            "rightCorner": {
              "x": -15.71,
              "y": -15.012,
              "z": 0.62
            },
            "gtin": "5900334000323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d549c",
            "leftCorner": {
              "x": -15.887,
              "y": -15.019,
              "z": 0.62
            },
            "rightCorner": {
              "x": -16.0,
              "y": -15.019,
              "z": 0.62
            },
            "gtin": "4032549049598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d549d",
            "leftCorner": {
              "x": -16.0,
              "y": -15.019,
              "z": 0.62
            },
            "rightCorner": {
              "x": -16.113,
              "y": -15.02,
              "z": 0.62
            },
            "gtin": "4032549049598",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cef0",
        "height": 1.0475,
        "facings": [
          {
            "id": "68d8e508e1820c81800d548a",
            "leftCorner": {
              "x": -15.247,
              "y": -14.979,
              "z": 0.857
            },
            "rightCorner": {
              "x": -15.515,
              "y": -14.98,
              "z": 0.857
            },
            "gtin": "4260653550208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d548c",
            "leftCorner": {
              "x": -15.514,
              "y": -15.017,
              "z": 0.857
            },
            "rightCorner": {
              "x": -15.61,
              "y": -15.017,
              "z": 0.857
            },
            "gtin": "5900552077572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d548d",
            "leftCorner": {
              "x": -15.61,
              "y": -15.017,
              "z": 0.857
            },
            "rightCorner": {
              "x": -15.706,
              "y": -15.017,
              "z": 0.857
            },
            "gtin": "5900552077572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d548e",
            "leftCorner": {
              "x": -15.705,
              "y": -15.02,
              "z": 0.857
            },
            "rightCorner": {
              "x": -15.948,
              "y": -15.021,
              "z": 0.857
            },
            "gtin": "4032549021181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d548f",
            "leftCorner": {
              "x": -15.948,
              "y": -15.02,
              "z": 0.857
            },
            "rightCorner": {
              "x": -16.055,
              "y": -15.021,
              "z": 0.857
            },
            "gtin": "5900397737693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5490",
            "leftCorner": {
              "x": -16.055,
              "y": -15.021,
              "z": 0.857
            },
            "rightCorner": {
              "x": -16.162,
              "y": -15.021,
              "z": 0.857
            },
            "gtin": "5900397737693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d548b",
            "leftCorner": {
              "x": -16.162,
              "y": -15.017,
              "z": 0.857
            },
            "rightCorner": {
              "x": -16.247,
              "y": -15.017,
              "z": 0.857
            },
            "gtin": "5900397737594",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539ceed",
        "height": 1.3516,
        "facings": [
          {
            "id": "68d8e508e1820c81800d547a",
            "leftCorner": {
              "x": -15.247,
              "y": -14.974,
              "z": 1.106
            },
            "rightCorner": {
              "x": -15.351,
              "y": -14.974,
              "z": 1.106
            },
            "gtin": "5902573001857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d547b",
            "leftCorner": {
              "x": -15.351,
              "y": -14.974,
              "z": 1.106
            },
            "rightCorner": {
              "x": -15.454,
              "y": -14.974,
              "z": 1.106
            },
            "gtin": "5902573001857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d547c",
            "leftCorner": {
              "x": -15.454,
              "y": -14.974,
              "z": 1.106
            },
            "rightCorner": {
              "x": -15.558,
              "y": -14.974,
              "z": 1.106
            },
            "gtin": "5902573001857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d547e",
            "leftCorner": {
              "x": -15.558,
              "y": -15.012,
              "z": 1.106
            },
            "rightCorner": {
              "x": -15.691,
              "y": -15.012,
              "z": 1.106
            },
            "gtin": "5902573008320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d547f",
            "leftCorner": {
              "x": -15.69,
              "y": -15.017,
              "z": 1.106
            },
            "rightCorner": {
              "x": -16.074,
              "y": -15.019,
              "z": 1.106
            },
            "gtin": "4032549014626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d547d",
            "leftCorner": {
              "x": -16.074,
              "y": -15.019,
              "z": 1.106
            },
            "rightCorner": {
              "x": -16.247,
              "y": -15.019,
              "z": 1.106
            },
            "gtin": "4032549048515",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539ceef",
        "height": 1.6229,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5482",
            "leftCorner": {
              "x": -15.247,
              "y": -14.97,
              "z": 1.328
            },
            "rightCorner": {
              "x": -15.35,
              "y": -14.97,
              "z": 1.328
            },
            "gtin": "5900471013279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5483",
            "leftCorner": {
              "x": -15.35,
              "y": -14.97,
              "z": 1.328
            },
            "rightCorner": {
              "x": -15.453,
              "y": -14.971,
              "z": 1.328
            },
            "gtin": "5900471013279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5485",
            "leftCorner": {
              "x": -15.453,
              "y": -15.009,
              "z": 1.328
            },
            "rightCorner": {
              "x": -15.581,
              "y": -15.009,
              "z": 1.328
            },
            "gtin": "5900471012715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5486",
            "leftCorner": {
              "x": -15.581,
              "y": -15.009,
              "z": 1.328
            },
            "rightCorner": {
              "x": -15.724,
              "y": -15.01,
              "z": 1.328
            },
            "gtin": "5902573008306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5487",
            "leftCorner": {
              "x": -15.724,
              "y": -15.013,
              "z": 1.328
            },
            "rightCorner": {
              "x": -15.949,
              "y": -15.014,
              "z": 1.328
            },
            "gtin": "5902573009860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5488",
            "leftCorner": {
              "x": -15.949,
              "y": -15.015,
              "z": 1.328
            },
            "rightCorner": {
              "x": -16.065,
              "y": -15.016,
              "z": 1.328
            },
            "gtin": "5298001500055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5489",
            "leftCorner": {
              "x": -16.065,
              "y": -15.012,
              "z": 1.328
            },
            "rightCorner": {
              "x": -16.158,
              "y": -15.012,
              "z": 1.328
            },
            "gtin": "4032549004580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5484",
            "leftCorner": {
              "x": -16.158,
              "y": -15.013,
              "z": 1.328
            },
            "rightCorner": {
              "x": -16.247,
              "y": -15.013,
              "z": 1.328
            },
            "gtin": "4032549000346",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "7ea",
    "name": "7ea",
    "x": -16.764,
    "y": -15.651,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70872,
      "w": 0.70549
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539ceff",
        "height": 0.16782,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54c6",
            "leftCorner": {
              "x": -16.876,
              "y": -15.65,
              "z": 0.137
            },
            "rightCorner": {
              "x": -16.877,
              "y": -15.866,
              "z": 0.137
            },
            "gtin": "4032549041677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54c7",
            "leftCorner": {
              "x": -16.837,
              "y": -15.867,
              "z": 0.137
            },
            "rightCorner": {
              "x": -16.841,
              "y": -16.651,
              "z": 0.137
            },
            "gtin": "4770266187260",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cef9",
        "height": 0.4581,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54c3",
            "leftCorner": {
              "x": -16.83,
              "y": -15.651,
              "z": 0.375
            },
            "rightCorner": {
              "x": -16.831,
              "y": -16.051,
              "z": 0.375
            },
            "gtin": "8690804406508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54c4",
            "leftCorner": {
              "x": -16.831,
              "y": -16.051,
              "z": 0.375
            },
            "rightCorner": {
              "x": -16.833,
              "y": -16.451,
              "z": 0.375
            },
            "gtin": "8690804406508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54c5",
            "leftCorner": {
              "x": -16.793,
              "y": -16.45,
              "z": 0.375
            },
            "rightCorner": {
              "x": -16.795,
              "y": -16.65,
              "z": 0.375
            },
            "gtin": "8690804406607",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cefe",
        "height": 0.75708,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54bf",
            "leftCorner": {
              "x": -16.807,
              "y": -16.18,
              "z": 0.619
            },
            "rightCorner": {
              "x": -16.809,
              "y": -16.547,
              "z": 0.619
            },
            "gtin": "8690804406416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7b0a99dfec3792f7ab625103",
            "leftCorner": {
              "x": -16.84,
              "y": -15.651,
              "z": 0.619
            },
            "rightCorner": {
              "x": -16.84,
              "y": -15.753,
              "z": 0.619
            },
            "gtin": "8690804006159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "02a3e2175f0cbc84fa82952c",
            "leftCorner": {
              "x": -16.84,
              "y": -15.753,
              "z": 0.619
            },
            "rightCorner": {
              "x": -16.842,
              "y": -16.113,
              "z": 0.619
            },
            "gtin": "8690804406416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54c0",
            "leftCorner": {
              "x": -16.801,
              "y": -16.547,
              "z": 0.619
            },
            "rightCorner": {
              "x": -16.801,
              "y": -16.777,
              "z": 0.619
            },
            "gtin": "8690804006159",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cefa",
        "height": 1.0196,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54a5",
            "leftCorner": {
              "x": -16.786,
              "y": -15.753,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.787,
              "y": -16.017,
              "z": 0.834
            },
            "gtin": "8690804402319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "67c6191c4ab74e59c06d7ae2",
            "leftCorner": {
              "x": -16.829,
              "y": -15.651,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.829,
              "y": -15.716,
              "z": 0.834
            },
            "gtin": "8690804362408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54a6",
            "leftCorner": {
              "x": -16.791,
              "y": -16.017,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.792,
              "y": -16.311,
              "z": 0.834
            },
            "gtin": "8690804682902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54a7",
            "leftCorner": {
              "x": -16.797,
              "y": -16.311,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.799,
              "y": -16.593,
              "z": 0.834
            },
            "gtin": "8690804014567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54a8",
            "leftCorner": {
              "x": -16.796,
              "y": -16.593,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.796,
              "y": -16.732,
              "z": 0.834
            },
            "gtin": "8690804362408",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cefb",
        "height": 1.3218,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54ad",
            "leftCorner": {
              "x": -16.79,
              "y": -15.697,
              "z": 1.081
            },
            "rightCorner": {
              "x": -16.791,
              "y": -15.815,
              "z": 1.081
            },
            "gtin": "5901135017510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54ae",
            "leftCorner": {
              "x": -16.794,
              "y": -15.815,
              "z": 1.081
            },
            "rightCorner": {
              "x": -16.796,
              "y": -16.016,
              "z": 1.081
            },
            "gtin": "5901135035149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54af",
            "leftCorner": {
              "x": -16.794,
              "y": -16.016,
              "z": 1.081
            },
            "rightCorner": {
              "x": -16.795,
              "y": -16.155,
              "z": 1.081
            },
            "gtin": "5901135015769",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d54b0",
            "leftCorner": {
              "x": -16.546,
              "y": -16.156,
              "z": 1.081
            },
            "rightCorner": {
              "x": -16.547,
              "y": -16.322,
              "z": 1.081
            },
            "gtin": "8690804001925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54b1",
            "leftCorner": {
              "x": -16.803,
              "y": -16.321,
              "z": 1.081
            },
            "rightCorner": {
              "x": -16.804,
              "y": -16.484,
              "z": 1.081
            },
            "gtin": "8690804005947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54ab",
            "leftCorner": {
              "x": -16.798,
              "y": -16.483,
              "z": 1.081
            },
            "rightCorner": {
              "x": -16.799,
              "y": -16.65,
              "z": 1.081
            },
            "gtin": "8690804301308",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cefc",
        "height": 1.6225,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54b6",
            "leftCorner": {
              "x": -16.794,
              "y": -15.706,
              "z": 1.327
            },
            "rightCorner": {
              "x": -16.795,
              "y": -15.823,
              "z": 1.327
            },
            "gtin": "8690804410505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a776edac3313160fa61cd1a5",
            "leftCorner": {
              "x": -16.843,
              "y": -15.651,
              "z": 1.327
            },
            "rightCorner": {
              "x": -16.843,
              "y": -15.701,
              "z": 1.327
            },
            "gtin": "8690804413667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54b7",
            "leftCorner": {
              "x": -16.8,
              "y": -15.823,
              "z": 1.327
            },
            "rightCorner": {
              "x": -16.801,
              "y": -16.017,
              "z": 1.327
            },
            "gtin": "8690804412509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54b8",
            "leftCorner": {
              "x": -16.8,
              "y": -16.017,
              "z": 1.327
            },
            "rightCorner": {
              "x": -16.801,
              "y": -16.375,
              "z": 1.327
            },
            "gtin": "8690804412004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54b9",
            "leftCorner": {
              "x": -16.812,
              "y": -16.375,
              "z": 1.327
            },
            "rightCorner": {
              "x": -16.812,
              "y": -16.457,
              "z": 1.327
            },
            "gtin": "8690804412608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54ba",
            "leftCorner": {
              "x": -16.811,
              "y": -16.458,
              "z": 1.327
            },
            "rightCorner": {
              "x": -16.812,
              "y": -16.599,
              "z": 1.327
            },
            "gtin": "8690804413100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54bb",
            "leftCorner": {
              "x": -16.808,
              "y": -16.599,
              "z": 1.327
            },
            "rightCorner": {
              "x": -16.809,
              "y": -16.845,
              "z": 1.327
            },
            "gtin": "8690804413667",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "361",
    "rightNeighborShelfId": "7ee"
  },
  {
    "id": "7eb",
    "name": "7eb",
    "x": -14.677,
    "y": -15.627,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70997,
      "w": 0.70423
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf18",
        "height": 0.16764,
        "facings": [
          {
            "id": "6ad10ddc0e419865903b53ce",
            "leftCorner": {
              "x": -14.574,
              "y": -15.625,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.575,
              "y": -15.564,
              "z": 0.137
            },
            "gtin": "4032549033559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "30d2c26c53f02fefc00c33b1",
            "leftCorner": {
              "x": -14.575,
              "y": -15.564,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.575,
              "y": -15.443,
              "z": 0.137
            },
            "gtin": "4032549001145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aa34b304e79e9b509edb31f2",
            "leftCorner": {
              "x": -14.575,
              "y": -15.443,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.577,
              "y": -15.285,
              "z": 0.137
            },
            "gtin": "4032549033573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f1f26a0ae5f146ff1e327904",
            "leftCorner": {
              "x": -14.577,
              "y": -15.285,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.578,
              "y": -15.128,
              "z": 0.137
            },
            "gtin": "4032549008571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "036dc29d5734ae6062bf74f5",
            "leftCorner": {
              "x": -14.578,
              "y": -15.128,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.579,
              "y": -15.007,
              "z": 0.137
            },
            "gtin": "4032549001145",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf14",
        "height": 0.46199,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54e2",
            "leftCorner": {
              "x": -14.662,
              "y": -15.313,
              "z": 0.378
            },
            "rightCorner": {
              "x": -14.664,
              "y": -14.996,
              "z": 0.378
            },
            "gtin": "4032549008571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "72e15fc0b1cff4c13eae8833",
            "leftCorner": {
              "x": -14.619,
              "y": -15.627,
              "z": 0.378
            },
            "rightCorner": {
              "x": -14.62,
              "y": -15.469,
              "z": 0.378
            },
            "gtin": "4032549008571",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf15",
        "height": 0.7464,
        "facings": [
          {
            "id": "68d8e508e1820c81800d550f",
            "leftCorner": {
              "x": -14.665,
              "y": -15.227,
              "z": 0.611
            },
            "rightCorner": {
              "x": -14.667,
              "y": -14.997,
              "z": 0.611
            },
            "gtin": "4032549001145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a71181df673101d632aa0ed5",
            "leftCorner": {
              "x": -14.622,
              "y": -15.627,
              "z": 0.611
            },
            "rightCorner": {
              "x": -14.623,
              "y": -15.505,
              "z": 0.611
            },
            "gtin": "4032549001145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f0b73c604a5dd5bc35585e42",
            "leftCorner": {
              "x": -14.623,
              "y": -15.505,
              "z": 0.611
            },
            "rightCorner": {
              "x": -14.624,
              "y": -15.384,
              "z": 0.611
            },
            "gtin": "4032549001145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c582b9272ae69064f5d589ce",
            "leftCorner": {
              "x": -14.624,
              "y": -15.384,
              "z": 0.611
            },
            "rightCorner": {
              "x": -14.625,
              "y": -15.262,
              "z": 0.611
            },
            "gtin": "4032549001145",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf12",
        "height": 1.0494,
        "facings": [
          {
            "id": "68d8e508e1820c81800d550b",
            "leftCorner": {
              "x": -14.624,
              "y": -15.627,
              "z": 0.859
            },
            "rightCorner": {
              "x": -14.627,
              "y": -15.35,
              "z": 0.859
            },
            "gtin": "4032549037380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d550d",
            "leftCorner": {
              "x": -14.667,
              "y": -15.35,
              "z": 0.859
            },
            "rightCorner": {
              "x": -14.668,
              "y": -15.172,
              "z": 0.859
            },
            "gtin": "4032549037427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d550c",
            "leftCorner": {
              "x": -14.667,
              "y": -15.172,
              "z": 0.859
            },
            "rightCorner": {
              "x": -14.668,
              "y": -14.997,
              "z": 0.859
            },
            "gtin": "4032549037328",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf13",
        "height": 1.3495,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54f9",
            "leftCorner": {
              "x": -14.659,
              "y": -15.494,
              "z": 1.104
            },
            "rightCorner": {
              "x": -14.66,
              "y": -15.327,
              "z": 1.104
            },
            "gtin": "4032549006256",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54fa",
            "leftCorner": {
              "x": -14.664,
              "y": -15.327,
              "z": 1.104
            },
            "rightCorner": {
              "x": -14.666,
              "y": -15.153,
              "z": 1.104
            },
            "gtin": "4032549002333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54f2",
            "leftCorner": {
              "x": -14.666,
              "y": -15.153,
              "z": 1.104
            },
            "rightCorner": {
              "x": -14.666,
              "y": -14.997,
              "z": 1.104
            },
            "gtin": "4032549010963",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf17",
        "height": 1.659,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5510",
            "leftCorner": {
              "x": -14.728,
              "y": -15.627,
              "z": 1.357
            },
            "rightCorner": {
              "x": -14.731,
              "y": -15.217,
              "z": 1.357
            },
            "gtin": "4032549002975",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d5512",
            "leftCorner": {
              "x": -14.657,
              "y": -15.216,
              "z": 1.357
            },
            "rightCorner": {
              "x": -14.658,
              "y": -15.143,
              "z": 1.357
            },
            "gtin": "4032549033559",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d5511",
            "leftCorner": {
              "x": -14.772,
              "y": -15.144,
              "z": 1.357
            },
            "rightCorner": {
              "x": -14.773,
              "y": -14.997,
              "z": 1.357
            },
            "gtin": "4032549033573",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7ed"
  },
  {
    "id": "7ec",
    "name": "7ec",
    "x": -16.207,
    "y": -17.316,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 5.4978E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf04",
        "height": 0.16721,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54d9",
            "leftCorner": {
              "x": -16.207,
              "y": -17.396,
              "z": 0.137
            },
            "rightCorner": {
              "x": -15.311,
              "y": -17.395,
              "z": 0.137
            },
            "gtin": "8690804000423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54da",
            "leftCorner": {
              "x": -15.31,
              "y": -17.352,
              "z": 0.137
            },
            "rightCorner": {
              "x": -15.207,
              "y": -17.351,
              "z": 0.137
            },
            "gtin": "4032549028036",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf02",
        "height": 0.46666,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54d2",
            "leftCorner": {
              "x": -16.207,
              "y": -17.356,
              "z": 0.382
            },
            "rightCorner": {
              "x": -15.856,
              "y": -17.355,
              "z": 0.382
            },
            "gtin": "5900352002361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54d4",
            "leftCorner": {
              "x": -15.856,
              "y": -17.315,
              "z": 0.382
            },
            "rightCorner": {
              "x": -15.595,
              "y": -17.315,
              "z": 0.382
            },
            "gtin": "5900352004044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54d5",
            "leftCorner": {
              "x": -15.595,
              "y": -17.321,
              "z": 0.382
            },
            "rightCorner": {
              "x": -15.393,
              "y": -17.321,
              "z": 0.382
            },
            "gtin": "4032549022775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54d3",
            "leftCorner": {
              "x": -15.393,
              "y": -17.316,
              "z": 0.382
            },
            "rightCorner": {
              "x": -15.207,
              "y": -17.315,
              "z": 0.382
            },
            "gtin": "4032549000575",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf05",
        "height": 0.75354,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54db",
            "leftCorner": {
              "x": -16.207,
              "y": -17.35,
              "z": 0.617
            },
            "rightCorner": {
              "x": -15.737,
              "y": -17.349,
              "z": 0.617
            },
            "gtin": "4032549000568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54dd",
            "leftCorner": {
              "x": -15.737,
              "y": -17.314,
              "z": 0.617
            },
            "rightCorner": {
              "x": -15.593,
              "y": -17.315,
              "z": 0.617
            },
            "gtin": "5901356071001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54de",
            "leftCorner": {
              "x": -15.593,
              "y": -17.31,
              "z": 0.617
            },
            "rightCorner": {
              "x": -15.387,
              "y": -17.309,
              "z": 0.617
            },
            "gtin": "8690804360565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54dc",
            "leftCorner": {
              "x": -15.387,
              "y": -17.307,
              "z": 0.617
            },
            "rightCorner": {
              "x": -15.207,
              "y": -17.307,
              "z": 0.617
            },
            "gtin": "8681334011317",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf01",
        "height": 1.0541,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54cd",
            "leftCorner": {
              "x": -16.207,
              "y": -17.349,
              "z": 0.862
            },
            "rightCorner": {
              "x": -15.897,
              "y": -17.349,
              "z": 0.862
            },
            "gtin": "4032549003712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54cf",
            "leftCorner": {
              "x": -15.898,
              "y": -17.309,
              "z": 0.862
            },
            "rightCorner": {
              "x": -15.614,
              "y": -17.309,
              "z": 0.862
            },
            "gtin": "5900102025688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54d0",
            "leftCorner": {
              "x": -15.614,
              "y": -17.312,
              "z": 0.862
            },
            "rightCorner": {
              "x": -15.502,
              "y": -17.312,
              "z": 0.862
            },
            "gtin": "5902097150956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54d1",
            "leftCorner": {
              "x": -15.502,
              "y": -17.308,
              "z": 0.862
            },
            "rightCorner": {
              "x": -15.304,
              "y": -17.308,
              "z": 0.862
            },
            "gtin": "5906948879072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54ce",
            "leftCorner": {
              "x": -15.304,
              "y": -17.306,
              "z": 0.862
            },
            "rightCorner": {
              "x": -15.207,
              "y": -17.305,
              "z": 0.862
            },
            "gtin": "4032549003378",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf00",
        "height": 1.3563,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54c8",
            "leftCorner": {
              "x": -16.207,
              "y": -17.351,
              "z": 1.11
            },
            "rightCorner": {
              "x": -16.004,
              "y": -17.351,
              "z": 1.11
            },
            "gtin": "4032549016828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54ca",
            "leftCorner": {
              "x": -16.004,
              "y": -17.311,
              "z": 1.11
            },
            "rightCorner": {
              "x": -15.793,
              "y": -17.311,
              "z": 1.11
            },
            "gtin": "4032549016842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54cb",
            "leftCorner": {
              "x": -15.793,
              "y": -17.308,
              "z": 1.11
            },
            "rightCorner": {
              "x": -15.633,
              "y": -17.308,
              "z": 1.11
            },
            "gtin": "4032549038691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54cc",
            "leftCorner": {
              "x": -15.633,
              "y": -17.312,
              "z": 1.11
            },
            "rightCorner": {
              "x": -15.464,
              "y": -17.312,
              "z": 1.11
            },
            "gtin": "5901588400655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54c9",
            "leftCorner": {
              "x": -15.464,
              "y": -17.31,
              "z": 1.11
            },
            "rightCorner": {
              "x": -15.207,
              "y": -17.309,
              "z": 1.11
            },
            "gtin": "5900102025602",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf03",
        "height": 1.6333,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54d6",
            "leftCorner": {
              "x": -16.207,
              "y": -17.354,
              "z": 1.336
            },
            "rightCorner": {
              "x": -15.701,
              "y": -17.354,
              "z": 1.336
            },
            "gtin": "4750127300632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54d8",
            "leftCorner": {
              "x": -15.702,
              "y": -17.315,
              "z": 1.336
            },
            "rightCorner": {
              "x": -15.558,
              "y": -17.314,
              "z": 1.336
            },
            "gtin": "4750127300601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54d7",
            "leftCorner": {
              "x": -15.558,
              "y": -17.313,
              "z": 1.336
            },
            "rightCorner": {
              "x": -15.207,
              "y": -17.312,
              "z": 1.336
            },
            "gtin": "4750127300694",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "7ed",
    "name": "7ed",
    "x": -14.67,
    "y": -16.655,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70862,
      "w": 0.70559
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 36
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf11",
        "height": 0.16553,
        "facings": [
          {
            "id": "be94687734fd7712ac87e1ea",
            "leftCorner": {
              "x": -14.644,
              "y": -16.655,
              "z": 0.135
            },
            "rightCorner": {
              "x": -14.644,
              "y": -16.605,
              "z": 0.135
            },
            "gtin": "4032549001855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0f599f6a7ad7367b49876468",
            "leftCorner": {
              "x": -14.644,
              "y": -16.605,
              "z": 0.135
            },
            "rightCorner": {
              "x": -14.645,
              "y": -16.403,
              "z": 0.135
            },
            "gtin": "4032549037366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "667d1234530de7195e184aad",
            "leftCorner": {
              "x": -14.645,
              "y": -16.403,
              "z": 0.135
            },
            "rightCorner": {
              "x": -14.645,
              "y": -16.353,
              "z": 0.135
            },
            "gtin": "4032549001855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d1905cf11aede878691f8a3f",
            "leftCorner": {
              "x": -14.645,
              "y": -16.353,
              "z": 0.135
            },
            "rightCorner": {
              "x": -14.646,
              "y": -16.259,
              "z": 0.135
            },
            "gtin": "5902256001006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "20fe165af623e05d73d65bcc",
            "leftCorner": {
              "x": -14.646,
              "y": -16.259,
              "z": 0.135
            },
            "rightCorner": {
              "x": -14.646,
              "y": -16.155,
              "z": 0.135
            },
            "gtin": "4032549037342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "09c3f073ab4347db7d5ab045",
            "leftCorner": {
              "x": -14.646,
              "y": -16.155,
              "z": 0.135
            },
            "rightCorner": {
              "x": -14.647,
              "y": -16.051,
              "z": 0.135
            },
            "gtin": "4032549000490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3904b6eb8c35ce2140d6b69f",
            "leftCorner": {
              "x": -14.647,
              "y": -16.051,
              "z": 0.135
            },
            "rightCorner": {
              "x": -14.647,
              "y": -15.927,
              "z": 0.135
            },
            "gtin": "4032549048591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "31aa9823a5a05b36f886d9bf",
            "leftCorner": {
              "x": -14.647,
              "y": -15.927,
              "z": 0.135
            },
            "rightCorner": {
              "x": -14.648,
              "y": -15.777,
              "z": 0.135
            },
            "gtin": "5901871008292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "692415e8daa798668dcd3365",
            "leftCorner": {
              "x": -14.648,
              "y": -15.777,
              "z": 0.135
            },
            "rightCorner": {
              "x": -14.648,
              "y": -15.672,
              "z": 0.135
            },
            "gtin": "4032549000490",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf0c",
        "height": 0.46297,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54e6",
            "leftCorner": {
              "x": -14.646,
              "y": -16.464,
              "z": 0.379
            },
            "rightCorner": {
              "x": -14.648,
              "y": -16.066,
              "z": 0.379
            },
            "gtin": "4032549002371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "665ffdbd7df38d1184e4b575",
            "leftCorner": {
              "x": -14.606,
              "y": -16.655,
              "z": 0.379
            },
            "rightCorner": {
              "x": -14.607,
              "y": -16.53,
              "z": 0.379
            },
            "gtin": "5900919000045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54e7",
            "leftCorner": {
              "x": -14.649,
              "y": -16.066,
              "z": 0.379
            },
            "rightCorner": {
              "x": -14.651,
              "y": -15.745,
              "z": 0.379
            },
            "gtin": "4032549003460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54e8",
            "leftCorner": {
              "x": -14.653,
              "y": -15.745,
              "z": 0.379
            },
            "rightCorner": {
              "x": -14.654,
              "y": -15.344,
              "z": 0.379
            },
            "gtin": "4032549000490",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf0e",
        "height": 0.76032,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54ed",
            "leftCorner": {
              "x": -14.648,
              "y": -16.374,
              "z": 0.622
            },
            "rightCorner": {
              "x": -14.648,
              "y": -16.148,
              "z": 0.622
            },
            "gtin": "5907501002128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a29cce08e2a594d39e15d57f",
            "leftCorner": {
              "x": -14.607,
              "y": -16.655,
              "z": 0.622
            },
            "rightCorner": {
              "x": -14.608,
              "y": -16.493,
              "z": 0.622
            },
            "gtin": "5907501002258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "97a668bf3356aec3a7506c94",
            "leftCorner": {
              "x": -14.608,
              "y": -16.493,
              "z": 0.622
            },
            "rightCorner": {
              "x": -14.608,
              "y": -16.443,
              "z": 0.622
            },
            "gtin": "4032549001855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c030b0e2777e06f83cd9d70e",
            "leftCorner": {
              "x": -14.608,
              "y": -16.443,
              "z": 0.622
            },
            "rightCorner": {
              "x": -14.608,
              "y": -16.393,
              "z": 0.622
            },
            "gtin": "4032549001855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f35895ae4c5f9e5e012c46ce",
            "leftCorner": {
              "x": -14.611,
              "y": -15.706,
              "z": 0.622
            },
            "rightCorner": {
              "x": -14.611,
              "y": -15.656,
              "z": 0.622
            },
            "gtin": "4032549001855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54ee",
            "leftCorner": {
              "x": -14.648,
              "y": -16.148,
              "z": 0.622
            },
            "rightCorner": {
              "x": -14.649,
              "y": -15.989,
              "z": 0.622
            },
            "gtin": "5907501002258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54ef",
            "leftCorner": {
              "x": -14.65,
              "y": -15.989,
              "z": 0.622
            },
            "rightCorner": {
              "x": -14.651,
              "y": -15.706,
              "z": 0.622
            },
            "gtin": "5907501002012",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf10",
        "height": 1.0606,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5506",
            "leftCorner": {
              "x": -14.655,
              "y": -15.933,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.656,
              "y": -15.75,
              "z": 0.868
            },
            "gtin": "4032549037441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5504",
            "leftCorner": {
              "x": -14.656,
              "y": -15.75,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.656,
              "y": -15.655,
              "z": 0.868
            },
            "gtin": "4032549037342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "511fa13579297fb0b0ee79a0",
            "leftCorner": {
              "x": -14.616,
              "y": -16.655,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.617,
              "y": -16.478,
              "z": 0.868
            },
            "gtin": "4032549037441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4a48f447cbcebc4a11e42b1e",
            "leftCorner": {
              "x": -14.617,
              "y": -16.478,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.618,
              "y": -16.276,
              "z": 0.868
            },
            "gtin": "4032549037366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "46db1be0ccdc540cceb440ae",
            "leftCorner": {
              "x": -14.618,
              "y": -16.276,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.618,
              "y": -16.172,
              "z": 0.868
            },
            "gtin": "4032549037342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ad03fa472416e25b31099291",
            "leftCorner": {
              "x": -14.618,
              "y": -16.172,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.619,
              "y": -15.97,
              "z": 0.868
            },
            "gtin": "4032549037366",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf0b",
        "height": 1.3479,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54f4",
            "leftCorner": {
              "x": -14.649,
              "y": -16.62,
              "z": 1.103
            },
            "rightCorner": {
              "x": -14.65,
              "y": -16.24,
              "z": 1.103
            },
            "gtin": "5901044003611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54f5",
            "leftCorner": {
              "x": -14.649,
              "y": -16.24,
              "z": 1.103
            },
            "rightCorner": {
              "x": -14.65,
              "y": -16.068,
              "z": 1.103
            },
            "gtin": "5900385012528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54f6",
            "leftCorner": {
              "x": -14.65,
              "y": -16.068,
              "z": 1.103
            },
            "rightCorner": {
              "x": -14.651,
              "y": -15.897,
              "z": 1.103
            },
            "gtin": "5900385012528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54f7",
            "leftCorner": {
              "x": -14.65,
              "y": -15.897,
              "z": 1.103
            },
            "rightCorner": {
              "x": -14.652,
              "y": -15.744,
              "z": 1.103
            },
            "gtin": "5901871008292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54f8",
            "leftCorner": {
              "x": -14.653,
              "y": -15.744,
              "z": 1.103
            },
            "rightCorner": {
              "x": -14.653,
              "y": -15.524,
              "z": 1.103
            },
            "gtin": "5902256001006",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf0d",
        "height": 1.6263,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54ff",
            "leftCorner": {
              "x": -14.643,
              "y": -16.619,
              "z": 1.331
            },
            "rightCorner": {
              "x": -14.643,
              "y": -16.433,
              "z": 1.331
            },
            "gtin": "5904075001717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5500",
            "leftCorner": {
              "x": -14.643,
              "y": -16.433,
              "z": 1.331
            },
            "rightCorner": {
              "x": -14.645,
              "y": -16.133,
              "z": 1.331
            },
            "gtin": "5904075008631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5501",
            "leftCorner": {
              "x": -14.646,
              "y": -16.133,
              "z": 1.331
            },
            "rightCorner": {
              "x": -14.646,
              "y": -15.953,
              "z": 1.331
            },
            "gtin": "5904075001939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5502",
            "leftCorner": {
              "x": -14.644,
              "y": -15.953,
              "z": 1.331
            },
            "rightCorner": {
              "x": -14.646,
              "y": -15.766,
              "z": 1.331
            },
            "gtin": "4032549048553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54fc",
            "leftCorner": {
              "x": -14.647,
              "y": -15.766,
              "z": 1.331
            },
            "rightCorner": {
              "x": -14.647,
              "y": -15.655,
              "z": 1.331
            },
            "gtin": "4032549048591",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7f0",
    "rightNeighborShelfId": "7eb"
  },
  {
    "id": "7ee",
    "name": "7ee",
    "x": -16.769,
    "y": -16.651,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70872,
      "w": 0.70549
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 10
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d627",
        "height": 0.48774,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d857e",
            "leftCorner": {
              "x": -16.597,
              "y": -16.938,
              "z": 0.399
            },
            "rightCorner": {
              "x": -16.599,
              "y": -17.282,
              "z": 0.399
            },
            "gtin": "4260147890513",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d626",
        "height": 0.75632,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54be",
            "leftCorner": {
              "x": -16.627,
              "y": -16.779,
              "z": 0.619
            },
            "rightCorner": {
              "x": -16.629,
              "y": -17.282,
              "z": 0.619
            },
            "gtin": "8690804006166",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d628",
        "height": 1.0191,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54a9",
            "leftCorner": {
              "x": -16.623,
              "y": -16.735,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.624,
              "y": -16.944,
              "z": 0.834
            },
            "gtin": "3870545000271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54a1",
            "leftCorner": {
              "x": -16.621,
              "y": -16.944,
              "z": 0.834
            },
            "rightCorner": {
              "x": -16.623,
              "y": -17.282,
              "z": 0.834
            },
            "gtin": "3870545000240",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d624",
        "height": 1.3353,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8579",
            "leftCorner": {
              "x": -16.669,
              "y": -16.652,
              "z": 1.093
            },
            "rightCorner": {
              "x": -16.67,
              "y": -16.789,
              "z": 1.093
            },
            "gtin": "8690804025402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "de6fe2cb8f45983ea14daf85",
            "leftCorner": {
              "x": -16.67,
              "y": -16.789,
              "z": 1.093
            },
            "rightCorner": {
              "x": -16.67,
              "y": -16.904,
              "z": 1.093
            },
            "gtin": "8690804025402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "489b67f26b87afe34a24af95",
            "leftCorner": {
              "x": -16.67,
              "y": -16.979,
              "z": 1.093
            },
            "rightCorner": {
              "x": -16.671,
              "y": -17.094,
              "z": 1.093
            },
            "gtin": "8690804025402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6b110cb4bb71a62af9bcc181",
            "leftCorner": {
              "x": -16.671,
              "y": -17.094,
              "z": 1.093
            },
            "rightCorner": {
              "x": -16.672,
              "y": -17.209,
              "z": 1.093
            },
            "gtin": "8690804025402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d857c",
            "leftCorner": {
              "x": -16.633,
              "y": -16.947,
              "z": 1.093
            },
            "rightCorner": {
              "x": -16.633,
              "y": -16.979,
              "z": 1.093
            },
            "gtin": "8690804321009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d625",
        "height": 1.6219,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54bc",
            "leftCorner": {
              "x": -16.63,
              "y": -16.847,
              "z": 1.327
            },
            "rightCorner": {
              "x": -16.631,
              "y": -17.034,
              "z": 1.327
            },
            "gtin": "4032549013964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54b3",
            "leftCorner": {
              "x": -16.624,
              "y": -17.034,
              "z": 1.327
            },
            "rightCorner": {
              "x": -16.624,
              "y": -17.282,
              "z": 1.327
            },
            "gtin": "4032549013988",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "015352b148d1e3a6cf81df18",
            "leftCorner": {
              "x": -16.665,
              "y": -16.652,
              "z": 1.327
            },
            "rightCorner": {
              "x": -16.666,
              "y": -16.783,
              "z": 1.327
            },
            "gtin": "4032549013964",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7ea"
  },
  {
    "id": "7f0",
    "name": "7f0",
    "x": -14.693,
    "y": -17.32,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.6996,
      "w": 0.71453
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf06",
        "height": 0.46109,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54df",
            "leftCorner": {
              "x": -14.638,
              "y": -17.321,
              "z": 0.377
            },
            "rightCorner": {
              "x": -14.637,
              "y": -17.244,
              "z": 0.377
            },
            "gtin": "5902256000757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54e0",
            "leftCorner": {
              "x": -14.637,
              "y": -17.244,
              "z": 0.377
            },
            "rightCorner": {
              "x": -14.635,
              "y": -17.167,
              "z": 0.377
            },
            "gtin": "5902256000757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54e1",
            "leftCorner": {
              "x": -14.635,
              "y": -17.167,
              "z": 0.377
            },
            "rightCorner": {
              "x": -14.633,
              "y": -17.089,
              "z": 0.377
            },
            "gtin": "5902256000757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54e3",
            "leftCorner": {
              "x": -14.669,
              "y": -17.088,
              "z": 0.377
            },
            "rightCorner": {
              "x": -14.665,
              "y": -16.894,
              "z": 0.377
            },
            "gtin": "5900919003329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54e4",
            "leftCorner": {
              "x": -14.673,
              "y": -16.895,
              "z": 0.377
            },
            "rightCorner": {
              "x": -14.668,
              "y": -16.68,
              "z": 0.377
            },
            "gtin": "5900397737235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54e5",
            "leftCorner": {
              "x": -14.654,
              "y": -16.68,
              "z": 0.377
            },
            "rightCorner": {
              "x": -14.65,
              "y": -16.498,
              "z": 0.377
            },
            "gtin": "5900919000045",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf08",
        "height": 0.75804,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54e9",
            "leftCorner": {
              "x": -14.631,
              "y": -17.322,
              "z": 0.62
            },
            "rightCorner": {
              "x": -14.626,
              "y": -17.062,
              "z": 0.62
            },
            "gtin": "5901874902085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54eb",
            "leftCorner": {
              "x": -14.665,
              "y": -17.061,
              "z": 0.62
            },
            "rightCorner": {
              "x": -14.659,
              "y": -16.763,
              "z": 0.62
            },
            "gtin": "5907501002029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54ec",
            "leftCorner": {
              "x": -14.655,
              "y": -16.763,
              "z": 0.62
            },
            "rightCorner": {
              "x": -14.647,
              "y": -16.408,
              "z": 0.62
            },
            "gtin": "5901874900227",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf09",
        "height": 1.3468,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54f0",
            "leftCorner": {
              "x": -14.645,
              "y": -17.322,
              "z": 1.102
            },
            "rightCorner": {
              "x": -14.641,
              "y": -17.143,
              "z": 1.102
            },
            "gtin": "5900085011012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54f1",
            "leftCorner": {
              "x": -14.641,
              "y": -17.143,
              "z": 1.102
            },
            "rightCorner": {
              "x": -14.637,
              "y": -16.965,
              "z": 1.102
            },
            "gtin": "5900085011012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54f3",
            "leftCorner": {
              "x": -14.677,
              "y": -16.964,
              "z": 1.102
            },
            "rightCorner": {
              "x": -14.67,
              "y": -16.656,
              "z": 1.102
            },
            "gtin": "4032549035355",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf0a",
        "height": 1.6238,
        "facings": [
          {
            "id": "68d8e508e1820c81800d54fb",
            "leftCorner": {
              "x": -14.626,
              "y": -17.322,
              "z": 1.329
            },
            "rightCorner": {
              "x": -14.619,
              "y": -16.968,
              "z": 1.329
            },
            "gtin": "5904075001137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54fd",
            "leftCorner": {
              "x": -14.928,
              "y": -16.962,
              "z": 1.329
            },
            "rightCorner": {
              "x": -14.925,
              "y": -16.802,
              "z": 1.329
            },
            "gtin": "5904075001694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d54fe",
            "leftCorner": {
              "x": -14.656,
              "y": -16.807,
              "z": 1.329
            },
            "rightCorner": {
              "x": -14.652,
              "y": -16.655,
              "z": 1.329
            },
            "gtin": "5904075001755",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "7ed"
  },
  {
    "id": "7f1",
    "name": "7f1",
    "x": -13.534,
    "y": -14.95,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7053,
      "w": 0.70891
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 37
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf1d",
        "height": 0.17054,
        "facings": [
          {
            "id": "173c4bbb1fcc2030a3d1820b",
            "leftCorner": {
              "x": -13.623,
              "y": -14.95,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.623,
              "y": -14.982,
              "z": 0.14
            },
            "gtin": "4013200105532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2374e92f74c631f143494348",
            "leftCorner": {
              "x": -13.623,
              "y": -14.982,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.623,
              "y": -15.035,
              "z": 0.14
            },
            "gtin": "4013200552251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7e181a5a9c4c2e1ea1fa66af",
            "leftCorner": {
              "x": -13.623,
              "y": -15.035,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.622,
              "y": -15.103,
              "z": 0.14
            },
            "gtin": "4013200555405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b3fc6bb84399c008c9283799",
            "leftCorner": {
              "x": -13.622,
              "y": -15.103,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.622,
              "y": -15.173,
              "z": 0.14
            },
            "gtin": "4013200555535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7fdaef28b29b604f9bfcf4a0",
            "leftCorner": {
              "x": -13.622,
              "y": -15.173,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.621,
              "y": -15.248,
              "z": 0.14
            },
            "gtin": "4013200105488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "212695746ec0479700b2a2ad",
            "leftCorner": {
              "x": -13.621,
              "y": -15.248,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.621,
              "y": -15.323,
              "z": 0.14
            },
            "gtin": "4013200555559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8405004f517c81ed4aa8151a",
            "leftCorner": {
              "x": -13.621,
              "y": -15.323,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.621,
              "y": -15.4,
              "z": 0.14
            },
            "gtin": "4013200334246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7ed4deebe80feda48bc1a838",
            "leftCorner": {
              "x": -13.621,
              "y": -15.4,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.62,
              "y": -15.476,
              "z": 0.14
            },
            "gtin": "4013200555504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ba4d092959e90dacf1eb1e7d",
            "leftCorner": {
              "x": -13.62,
              "y": -15.476,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.62,
              "y": -15.577,
              "z": 0.14
            },
            "gtin": "4013200552220",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf1b",
        "height": 0.58785,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5533",
            "leftCorner": {
              "x": -13.595,
              "y": -14.95,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.595,
              "y": -15.043,
              "z": 0.481
            },
            "gtin": "4013200105440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5535",
            "leftCorner": {
              "x": -13.563,
              "y": -15.043,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.563,
              "y": -15.161,
              "z": 0.481
            },
            "gtin": "4013200105457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5536",
            "leftCorner": {
              "x": -13.557,
              "y": -15.161,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.556,
              "y": -15.25,
              "z": 0.481
            },
            "gtin": "4013200105433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5537",
            "leftCorner": {
              "x": -13.56,
              "y": -15.249,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.559,
              "y": -15.376,
              "z": 0.481
            },
            "gtin": "4013200105464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5538",
            "leftCorner": {
              "x": -13.551,
              "y": -15.376,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.55,
              "y": -15.453,
              "z": 0.481
            },
            "gtin": "4013200105488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5539",
            "leftCorner": {
              "x": -13.548,
              "y": -15.453,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.548,
              "y": -15.537,
              "z": 0.481
            },
            "gtin": "4013200105471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d553a",
            "leftCorner": {
              "x": -13.55,
              "y": -15.537,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.549,
              "y": -15.726,
              "z": 0.481
            },
            "gtin": "4013200105532",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf1c",
        "height": 0.91331,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5546",
            "leftCorner": {
              "x": -13.6,
              "y": -14.95,
              "z": 0.747
            },
            "rightCorner": {
              "x": -13.599,
              "y": -15.092,
              "z": 0.747
            },
            "gtin": "4013200334246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5548",
            "leftCorner": {
              "x": -13.565,
              "y": -15.092,
              "z": 0.747
            },
            "rightCorner": {
              "x": -13.565,
              "y": -15.159,
              "z": 0.747
            },
            "gtin": "4013200552046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5549",
            "leftCorner": {
              "x": -13.565,
              "y": -15.159,
              "z": 0.747
            },
            "rightCorner": {
              "x": -13.564,
              "y": -15.227,
              "z": 0.747
            },
            "gtin": "4013200552046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d554a",
            "leftCorner": {
              "x": -13.555,
              "y": -15.227,
              "z": 0.747
            },
            "rightCorner": {
              "x": -13.554,
              "y": -15.304,
              "z": 0.747
            },
            "gtin": "4013200555504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d554b",
            "leftCorner": {
              "x": -13.561,
              "y": -15.304,
              "z": 0.747
            },
            "rightCorner": {
              "x": -13.561,
              "y": -15.429,
              "z": 0.747
            },
            "gtin": "4013200555511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d554c",
            "leftCorner": {
              "x": -13.554,
              "y": -15.429,
              "z": 0.747
            },
            "rightCorner": {
              "x": -13.553,
              "y": -15.499,
              "z": 0.747
            },
            "gtin": "4013200555535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d554d",
            "leftCorner": {
              "x": -13.549,
              "y": -15.499,
              "z": 0.747
            },
            "rightCorner": {
              "x": -13.549,
              "y": -15.577,
              "z": 0.747
            },
            "gtin": "4013200555559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d554e",
            "leftCorner": {
              "x": -13.547,
              "y": -15.578,
              "z": 0.747
            },
            "rightCorner": {
              "x": -13.546,
              "y": -15.679,
              "z": 0.747
            },
            "gtin": "4013200555528",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf1a",
        "height": 1.2032,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5521",
            "leftCorner": {
              "x": -13.585,
              "y": -14.95,
              "z": 0.984
            },
            "rightCorner": {
              "x": -13.584,
              "y": -15.041,
              "z": 0.984
            },
            "gtin": "4013200552206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5525",
            "leftCorner": {
              "x": -13.554,
              "y": -15.041,
              "z": 0.984
            },
            "rightCorner": {
              "x": -13.554,
              "y": -15.125,
              "z": 0.984
            },
            "gtin": "4013200552237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5526",
            "leftCorner": {
              "x": -13.553,
              "y": -15.125,
              "z": 0.984
            },
            "rightCorner": {
              "x": -13.552,
              "y": -15.21,
              "z": 0.984
            },
            "gtin": "4013200552213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5527",
            "leftCorner": {
              "x": -13.549,
              "y": -15.21,
              "z": 0.984
            },
            "rightCorner": {
              "x": -13.548,
              "y": -15.307,
              "z": 0.984
            },
            "gtin": "4013200552220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5528",
            "leftCorner": {
              "x": -13.541,
              "y": -15.307,
              "z": 0.984
            },
            "rightCorner": {
              "x": -13.541,
              "y": -15.358,
              "z": 0.984
            },
            "gtin": "4013200552251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5529",
            "leftCorner": {
              "x": -13.542,
              "y": -15.358,
              "z": 0.984
            },
            "rightCorner": {
              "x": -13.542,
              "y": -15.428,
              "z": 0.984
            },
            "gtin": "4013200555405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d552a",
            "leftCorner": {
              "x": -13.543,
              "y": -15.428,
              "z": 0.984
            },
            "rightCorner": {
              "x": -13.542,
              "y": -15.583,
              "z": 0.984
            },
            "gtin": "4013200552244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d552b",
            "leftCorner": {
              "x": -13.535,
              "y": -15.583,
              "z": 0.984
            },
            "rightCorner": {
              "x": -13.534,
              "y": -15.705,
              "z": 0.984
            },
            "gtin": "4013200555900",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf19",
        "height": 1.5041,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5513",
            "leftCorner": {
              "x": -13.596,
              "y": -14.95,
              "z": 1.231
            },
            "rightCorner": {
              "x": -13.595,
              "y": -15.097,
              "z": 1.231
            },
            "gtin": "4013200334055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5515",
            "leftCorner": {
              "x": -13.559,
              "y": -15.098,
              "z": 1.231
            },
            "rightCorner": {
              "x": -13.559,
              "y": -15.258,
              "z": 1.231
            },
            "gtin": "4013200334048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5516",
            "leftCorner": {
              "x": -13.554,
              "y": -15.258,
              "z": 1.231
            },
            "rightCorner": {
              "x": -13.554,
              "y": -15.429,
              "z": 1.231
            },
            "gtin": "4013200334062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5517",
            "leftCorner": {
              "x": -13.55,
              "y": -15.429,
              "z": 1.231
            },
            "rightCorner": {
              "x": -13.549,
              "y": -15.58,
              "z": 1.231
            },
            "gtin": "4013200334345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5518",
            "leftCorner": {
              "x": -13.545,
              "y": -15.58,
              "z": 1.231
            },
            "rightCorner": {
              "x": -13.543,
              "y": -15.771,
              "z": 1.231
            },
            "gtin": "4013200334437",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "7f2"
  },
  {
    "id": "7f2",
    "name": "7f2",
    "x": -13.531,
    "y": -15.575,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7053,
      "w": 0.70891
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 58
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf22",
        "height": 0.17397,
        "facings": [
          {
            "id": "84af531f335ec4f10e8aa8a3",
            "leftCorner": {
              "x": -13.615,
              "y": -15.576,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.615,
              "y": -15.652,
              "z": 0.142
            },
            "gtin": "4013200555900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "51a5fa94c122eff135690f77",
            "leftCorner": {
              "x": -13.615,
              "y": -15.652,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.614,
              "y": -15.683,
              "z": 0.142
            },
            "gtin": "4013200555184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7d6f9bdca426fcb4bde0eedc",
            "leftCorner": {
              "x": -13.614,
              "y": -15.683,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.614,
              "y": -15.724,
              "z": 0.142
            },
            "gtin": "4013200334338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6bd882ca9176612bd9bbd028",
            "leftCorner": {
              "x": -13.614,
              "y": -15.724,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.614,
              "y": -15.771,
              "z": 0.142
            },
            "gtin": "4013200334437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6e3ecb4578b23a3aec3d68d3",
            "leftCorner": {
              "x": -13.614,
              "y": -15.771,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.614,
              "y": -15.824,
              "z": 0.142
            },
            "gtin": "4013200106096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "69a490d3d25542902593cfd7",
            "leftCorner": {
              "x": -13.614,
              "y": -15.824,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.613,
              "y": -15.882,
              "z": 0.142
            },
            "gtin": "4013200555528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "acb2c9d482a28427965e99d0",
            "leftCorner": {
              "x": -13.613,
              "y": -15.882,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.613,
              "y": -15.946,
              "z": 0.142
            },
            "gtin": "4013200555337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "09e57fbf3006984cc658b4ba",
            "leftCorner": {
              "x": -13.613,
              "y": -15.946,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.613,
              "y": -16.01,
              "z": 0.142
            },
            "gtin": "4013200106003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f1a0d540a70f4dfe038538ab",
            "leftCorner": {
              "x": -13.613,
              "y": -16.01,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.612,
              "y": -16.075,
              "z": 0.142
            },
            "gtin": "4013200106089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "050cbb51a8bc544f7e65ce22",
            "leftCorner": {
              "x": -13.612,
              "y": -16.075,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.612,
              "y": -16.14,
              "z": 0.142
            },
            "gtin": "4013200106102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a35e08e35d642d3e104766e4",
            "leftCorner": {
              "x": -13.612,
              "y": -16.14,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.612,
              "y": -16.205,
              "z": 0.142
            },
            "gtin": "4013200555542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f9a9a980365fdd1f74409490",
            "leftCorner": {
              "x": -13.612,
              "y": -16.205,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.611,
              "y": -16.271,
              "z": 0.142
            },
            "gtin": "4013200555566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cac0a31b76192a6db531dd69",
            "leftCorner": {
              "x": -13.611,
              "y": -16.271,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.611,
              "y": -16.338,
              "z": 0.142
            },
            "gtin": "4013200106140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "313f81b872451aa336eb81aa",
            "leftCorner": {
              "x": -13.611,
              "y": -16.338,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.61,
              "y": -16.528,
              "z": 0.142
            },
            "gtin": "4013200555344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "112833243ea604de917ef5cb",
            "leftCorner": {
              "x": -13.61,
              "y": -16.528,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.61,
              "y": -16.575,
              "z": 0.142
            },
            "gtin": "4013200334437",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf1f",
        "height": 0.58773,
        "facings": [
          {
            "id": "68d8e508e1820c81800d553b",
            "leftCorner": {
              "x": -13.549,
              "y": -15.72,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.549,
              "y": -15.839,
              "z": 0.481
            },
            "gtin": "4013200105501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d553c",
            "leftCorner": {
              "x": -13.541,
              "y": -15.84,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.541,
              "y": -15.911,
              "z": 0.481
            },
            "gtin": "4013200106010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d553d",
            "leftCorner": {
              "x": -13.536,
              "y": -15.911,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.535,
              "y": -15.983,
              "z": 0.481
            },
            "gtin": "4013200105983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d553e",
            "leftCorner": {
              "x": -13.533,
              "y": -15.983,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.532,
              "y": -16.048,
              "z": 0.481
            },
            "gtin": "4013200106003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d553f",
            "leftCorner": {
              "x": -13.531,
              "y": -16.048,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.531,
              "y": -16.121,
              "z": 0.481
            },
            "gtin": "4013200106041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5540",
            "leftCorner": {
              "x": -13.529,
              "y": -16.121,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.529,
              "y": -16.191,
              "z": 0.481
            },
            "gtin": "4013200106065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5541",
            "leftCorner": {
              "x": -13.528,
              "y": -16.191,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.528,
              "y": -16.253,
              "z": 0.481
            },
            "gtin": "4013200106102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5542",
            "leftCorner": {
              "x": -13.528,
              "y": -16.253,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.528,
              "y": -16.323,
              "z": 0.481
            },
            "gtin": "4013200106126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5543",
            "leftCorner": {
              "x": -13.526,
              "y": -16.323,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.525,
              "y": -16.398,
              "z": 0.481
            },
            "gtin": "4013200106140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5544",
            "leftCorner": {
              "x": -13.524,
              "y": -16.398,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.524,
              "y": -16.472,
              "z": 0.481
            },
            "gtin": "4013200106157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5545",
            "leftCorner": {
              "x": -13.536,
              "y": -16.471,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.535,
              "y": -16.519,
              "z": 0.481
            },
            "gtin": "4013200106089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5534",
            "leftCorner": {
              "x": -13.541,
              "y": -16.519,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.541,
              "y": -16.575,
              "z": 0.481
            },
            "gtin": "4013200106096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "00cfa00f966b0be9b29699c3",
            "leftCorner": {
              "x": -13.574,
              "y": -15.576,
              "z": 0.481
            },
            "rightCorner": {
              "x": -13.573,
              "y": -15.7,
              "z": 0.481
            },
            "gtin": "4013200105501",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf20",
        "height": 0.91237,
        "facings": [
          {
            "id": "68d8e508e1820c81800d554f",
            "leftCorner": {
              "x": -13.549,
              "y": -15.674,
              "z": 0.746
            },
            "rightCorner": {
              "x": -13.549,
              "y": -15.744,
              "z": 0.746
            },
            "gtin": "4013200555566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5550",
            "leftCorner": {
              "x": -13.547,
              "y": -15.744,
              "z": 0.746
            },
            "rightCorner": {
              "x": -13.547,
              "y": -15.809,
              "z": 0.746
            },
            "gtin": "4013200555542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5551",
            "leftCorner": {
              "x": -13.546,
              "y": -15.809,
              "z": 0.746
            },
            "rightCorner": {
              "x": -13.545,
              "y": -15.997,
              "z": 0.746
            },
            "gtin": "4013200555344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5552",
            "leftCorner": {
              "x": -13.537,
              "y": -15.997,
              "z": 0.746
            },
            "rightCorner": {
              "x": -13.536,
              "y": -16.163,
              "z": 0.746
            },
            "gtin": "4013200555221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5553",
            "leftCorner": {
              "x": -13.533,
              "y": -16.163,
              "z": 0.746
            },
            "rightCorner": {
              "x": -13.533,
              "y": -16.348,
              "z": 0.746
            },
            "gtin": "4013200555245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5554",
            "leftCorner": {
              "x": -13.53,
              "y": -16.348,
              "z": 0.746
            },
            "rightCorner": {
              "x": -13.529,
              "y": -16.515,
              "z": 0.746
            },
            "gtin": "4013200555320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5547",
            "leftCorner": {
              "x": -13.547,
              "y": -16.514,
              "z": 0.746
            },
            "rightCorner": {
              "x": -13.546,
              "y": -16.575,
              "z": 0.746
            },
            "gtin": "4013200555337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8be9cfae817d5853e4bb99cb",
            "leftCorner": {
              "x": -13.583,
              "y": -15.576,
              "z": 0.746
            },
            "rightCorner": {
              "x": -13.583,
              "y": -15.634,
              "z": 0.746
            },
            "gtin": "4013200555528",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf1e",
        "height": 1.2018,
        "facings": [
          {
            "id": "68d8e508e1820c81800d552c",
            "leftCorner": {
              "x": -13.541,
              "y": -15.699,
              "z": 0.983
            },
            "rightCorner": {
              "x": -13.54,
              "y": -15.843,
              "z": 0.983
            },
            "gtin": "4013200555849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d552d",
            "leftCorner": {
              "x": -13.531,
              "y": -15.843,
              "z": 0.983
            },
            "rightCorner": {
              "x": -13.531,
              "y": -15.985,
              "z": 0.983
            },
            "gtin": "4013200555832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d552e",
            "leftCorner": {
              "x": -13.527,
              "y": -15.985,
              "z": 0.983
            },
            "rightCorner": {
              "x": -13.526,
              "y": -16.125,
              "z": 0.983
            },
            "gtin": "4013200555856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d552f",
            "leftCorner": {
              "x": -13.521,
              "y": -16.125,
              "z": 0.983
            },
            "rightCorner": {
              "x": -13.52,
              "y": -16.214,
              "z": 0.983
            },
            "gtin": "4013200555887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5530",
            "leftCorner": {
              "x": -13.52,
              "y": -16.214,
              "z": 0.983
            },
            "rightCorner": {
              "x": -13.52,
              "y": -16.286,
              "z": 0.983
            },
            "gtin": "4013200555870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5531",
            "leftCorner": {
              "x": -13.521,
              "y": -16.286,
              "z": 0.983
            },
            "rightCorner": {
              "x": -13.52,
              "y": -16.381,
              "z": 0.983
            },
            "gtin": "4013200555191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5532",
            "leftCorner": {
              "x": -13.522,
              "y": -16.381,
              "z": 0.983
            },
            "rightCorner": {
              "x": -13.522,
              "y": -16.468,
              "z": 0.983
            },
            "gtin": "4013200555184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5522",
            "leftCorner": {
              "x": -13.532,
              "y": -16.468,
              "z": 0.983
            },
            "rightCorner": {
              "x": -13.532,
              "y": -16.504,
              "z": 0.983
            },
            "gtin": "4013200555207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9329733d8184a013e0f87927",
            "leftCorner": {
              "x": -13.567,
              "y": -15.576,
              "z": 0.983
            },
            "rightCorner": {
              "x": -13.567,
              "y": -15.667,
              "z": 0.983
            },
            "gtin": "4013200555887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a463bf8223df0badda8c249d",
            "leftCorner": {
              "x": -13.567,
              "y": -15.667,
              "z": 0.983
            },
            "rightCorner": {
              "x": -13.566,
              "y": -15.698,
              "z": 0.983
            },
            "gtin": "4013200555184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5523",
            "leftCorner": {
              "x": -13.532,
              "y": -16.504,
              "z": 0.983
            },
            "rightCorner": {
              "x": -13.532,
              "y": -16.54,
              "z": 0.983
            },
            "gtin": "4013200555207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5524",
            "leftCorner": {
              "x": -13.532,
              "y": -16.54,
              "z": 0.983
            },
            "rightCorner": {
              "x": -13.532,
              "y": -16.575,
              "z": 0.983
            },
            "gtin": "4013200555207",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf21",
        "height": 1.503,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5519",
            "leftCorner": {
              "x": -13.545,
              "y": -15.765,
              "z": 1.23
            },
            "rightCorner": {
              "x": -13.544,
              "y": -15.899,
              "z": 1.23
            },
            "gtin": "4013200334314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d551a",
            "leftCorner": {
              "x": -13.537,
              "y": -15.899,
              "z": 1.23
            },
            "rightCorner": {
              "x": -13.537,
              "y": -16.029,
              "z": 1.23
            },
            "gtin": "4013200334420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d551b",
            "leftCorner": {
              "x": -13.532,
              "y": -16.029,
              "z": 1.23
            },
            "rightCorner": {
              "x": -13.531,
              "y": -16.174,
              "z": 1.23
            },
            "gtin": "4013200334352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d551c",
            "leftCorner": {
              "x": -13.527,
              "y": -16.174,
              "z": 1.23
            },
            "rightCorner": {
              "x": -13.527,
              "y": -16.241,
              "z": 1.23
            },
            "gtin": "4013200334611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d551d",
            "leftCorner": {
              "x": -13.527,
              "y": -16.241,
              "z": 1.23
            },
            "rightCorner": {
              "x": -13.527,
              "y": -16.321,
              "z": 1.23
            },
            "gtin": "4013200334321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d551e",
            "leftCorner": {
              "x": -13.525,
              "y": -16.321,
              "z": 1.23
            },
            "rightCorner": {
              "x": -13.524,
              "y": -16.389,
              "z": 1.23
            },
            "gtin": "4013200334444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d551f",
            "leftCorner": {
              "x": -13.522,
              "y": -16.389,
              "z": 1.23
            },
            "rightCorner": {
              "x": -13.522,
              "y": -16.462,
              "z": 1.23
            },
            "gtin": "4013200334482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5520",
            "leftCorner": {
              "x": -13.535,
              "y": -16.462,
              "z": 1.23
            },
            "rightCorner": {
              "x": -13.535,
              "y": -16.526,
              "z": 1.23
            },
            "gtin": "4013200334451",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d5514",
            "leftCorner": {
              "x": -13.541,
              "y": -16.526,
              "z": 1.23
            },
            "rightCorner": {
              "x": -13.541,
              "y": -16.575,
              "z": 1.23
            },
            "gtin": "4013200334338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fe32ae62b0e9a371dc4815ee",
            "leftCorner": {
              "x": -13.573,
              "y": -15.576,
              "z": 1.23
            },
            "rightCorner": {
              "x": -13.573,
              "y": -15.672,
              "z": 1.23
            },
            "gtin": "4013200334437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f4fdaea71bc0119b5204cf1f",
            "leftCorner": {
              "x": -13.573,
              "y": -15.672,
              "z": 1.23
            },
            "rightCorner": {
              "x": -13.572,
              "y": -15.748,
              "z": 1.23
            },
            "gtin": "4013200334482",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7f1",
    "rightNeighborShelfId": "7f3"
  },
  {
    "id": "7f3",
    "name": "7f3",
    "x": -13.526,
    "y": -16.575,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7053,
      "w": 0.70891
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 27
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d62d",
        "height": 0.16569,
        "facings": [
          {
            "id": "882cbc7e88a7b91984e4d7d4",
            "leftCorner": {
              "x": -13.396,
              "y": -16.574,
              "z": 0.136
            },
            "rightCorner": {
              "x": -13.396,
              "y": -16.646,
              "z": 0.136
            },
            "gtin": "4013200118938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "84fb7328862b8c8533507b82",
            "leftCorner": {
              "x": -13.396,
              "y": -16.646,
              "z": 0.136
            },
            "rightCorner": {
              "x": -13.395,
              "y": -16.811,
              "z": 0.136
            },
            "gtin": "4013200555375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1e3d026e4cfe44f99b6b2007",
            "leftCorner": {
              "x": -13.395,
              "y": -16.811,
              "z": 0.136
            },
            "rightCorner": {
              "x": -13.395,
              "y": -16.85,
              "z": 0.136
            },
            "gtin": "4013200382162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2418ba69ec16c53e678fde2c",
            "leftCorner": {
              "x": -13.395,
              "y": -16.85,
              "z": 0.136
            },
            "rightCorner": {
              "x": -13.394,
              "y": -16.892,
              "z": 0.136
            },
            "gtin": "4013200382148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4a9f96d6608749c6f84cb3fa",
            "leftCorner": {
              "x": -13.394,
              "y": -16.892,
              "z": 0.136
            },
            "rightCorner": {
              "x": -13.394,
              "y": -16.935,
              "z": 0.136
            },
            "gtin": "4013200555436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5a63165c5928bd650e59dd66",
            "leftCorner": {
              "x": -13.394,
              "y": -16.935,
              "z": 0.136
            },
            "rightCorner": {
              "x": -13.394,
              "y": -16.981,
              "z": 0.136
            },
            "gtin": "4013200382100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1a1571d75ce0a11762fd078d",
            "leftCorner": {
              "x": -13.394,
              "y": -16.981,
              "z": 0.136
            },
            "rightCorner": {
              "x": -13.394,
              "y": -17.043,
              "z": 0.136
            },
            "gtin": "4013200381059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cddbea85ed4aca1bf263a11f",
            "leftCorner": {
              "x": -13.394,
              "y": -17.043,
              "z": 0.136
            },
            "rightCorner": {
              "x": -13.393,
              "y": -17.114,
              "z": 0.136
            },
            "gtin": "4013200118938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c91623df15d4969d93973c68",
            "leftCorner": {
              "x": -13.393,
              "y": -17.114,
              "z": 0.136
            },
            "rightCorner": {
              "x": -13.393,
              "y": -17.202,
              "z": 0.136
            },
            "gtin": "4013200880682",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d62c",
        "height": 0.58389,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d858f",
            "leftCorner": {
              "x": -13.371,
              "y": -16.574,
              "z": 0.478
            },
            "rightCorner": {
              "x": -13.371,
              "y": -16.659,
              "z": 0.478
            },
            "gtin": "4013200105921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8591",
            "leftCorner": {
              "x": -13.338,
              "y": -16.659,
              "z": 0.478
            },
            "rightCorner": {
              "x": -13.337,
              "y": -16.825,
              "z": 0.478
            },
            "gtin": "4013200662011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8592",
            "leftCorner": {
              "x": -13.331,
              "y": -16.825,
              "z": 0.478
            },
            "rightCorner": {
              "x": -13.33,
              "y": -16.969,
              "z": 0.478
            },
            "gtin": "4013200661984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8590",
            "leftCorner": {
              "x": -13.328,
              "y": -16.969,
              "z": 0.478
            },
            "rightCorner": {
              "x": -13.326,
              "y": -17.204,
              "z": 0.478
            },
            "gtin": "4013200662035",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d62b",
        "height": 0.9088,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d858b",
            "leftCorner": {
              "x": -13.373,
              "y": -16.574,
              "z": 0.744
            },
            "rightCorner": {
              "x": -13.372,
              "y": -16.738,
              "z": 0.744
            },
            "gtin": "4013200555733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d858c",
            "leftCorner": {
              "x": -13.372,
              "y": -16.738,
              "z": 0.744
            },
            "rightCorner": {
              "x": -13.371,
              "y": -16.903,
              "z": 0.744
            },
            "gtin": "4013200555733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d858d",
            "leftCorner": {
              "x": -13.328,
              "y": -16.903,
              "z": 0.744
            },
            "rightCorner": {
              "x": -13.327,
              "y": -17.054,
              "z": 0.744
            },
            "gtin": "4013200555726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d858e",
            "leftCorner": {
              "x": -13.327,
              "y": -17.054,
              "z": 0.744
            },
            "rightCorner": {
              "x": -13.326,
              "y": -17.204,
              "z": 0.744
            },
            "gtin": "4013200555726",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d62a",
        "height": 1.1997,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8586",
            "leftCorner": {
              "x": -13.358,
              "y": -16.574,
              "z": 0.982
            },
            "rightCorner": {
              "x": -13.357,
              "y": -16.666,
              "z": 0.982
            },
            "gtin": "4013200555351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8587",
            "leftCorner": {
              "x": -13.357,
              "y": -16.666,
              "z": 0.982
            },
            "rightCorner": {
              "x": -13.357,
              "y": -16.757,
              "z": 0.982
            },
            "gtin": "4013200555351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8589",
            "leftCorner": {
              "x": -13.321,
              "y": -16.756,
              "z": 0.982
            },
            "rightCorner": {
              "x": -13.32,
              "y": -16.886,
              "z": 0.982
            },
            "gtin": "4013200555412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d858a",
            "leftCorner": {
              "x": -13.316,
              "y": -16.886,
              "z": 0.982
            },
            "rightCorner": {
              "x": -13.316,
              "y": -16.969,
              "z": 0.982
            },
            "gtin": "4013200555436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8588",
            "leftCorner": {
              "x": -13.316,
              "y": -16.969,
              "z": 0.982
            },
            "rightCorner": {
              "x": -13.314,
              "y": -17.204,
              "z": 0.982
            },
            "gtin": "4013200555283",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d629",
        "height": 1.5008,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d857f",
            "leftCorner": {
              "x": -13.369,
              "y": -16.574,
              "z": 1.228
            },
            "rightCorner": {
              "x": -13.368,
              "y": -16.675,
              "z": 1.228
            },
            "gtin": "4013200381059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8581",
            "leftCorner": {
              "x": -13.331,
              "y": -16.675,
              "z": 1.228
            },
            "rightCorner": {
              "x": -13.331,
              "y": -16.753,
              "z": 1.228
            },
            "gtin": "4013200880682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8582",
            "leftCorner": {
              "x": -13.327,
              "y": -16.753,
              "z": 1.228
            },
            "rightCorner": {
              "x": -13.327,
              "y": -16.794,
              "z": 1.228
            },
            "gtin": "4013200382148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8583",
            "leftCorner": {
              "x": -13.328,
              "y": -16.794,
              "z": 1.228
            },
            "rightCorner": {
              "x": -13.328,
              "y": -16.83,
              "z": 1.228
            },
            "gtin": "4013200382162",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d8584",
            "leftCorner": {
              "x": -13.33,
              "y": -16.83,
              "z": 1.228
            },
            "rightCorner": {
              "x": -13.329,
              "y": -16.88,
              "z": 1.228
            },
            "gtin": "4013200382100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8585",
            "leftCorner": {
              "x": -13.329,
              "y": -16.88,
              "z": 1.228
            },
            "rightCorner": {
              "x": -13.329,
              "y": -16.976,
              "z": 1.228
            },
            "gtin": "4013200381103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8580",
            "leftCorner": {
              "x": -13.325,
              "y": -16.976,
              "z": 1.228
            },
            "rightCorner": {
              "x": -13.324,
              "y": -17.204,
              "z": 1.228
            },
            "gtin": "4013200228989",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7f2"
  },
  {
    "id": "7f4",
    "name": "7f4",
    "x": -11.261,
    "y": -17.178,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70205,
      "w": 0.71213
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf31",
        "height": 0.17106,
        "facings": [
          {
            "id": "4819066e951bc8ad7a626657",
            "leftCorner": {
              "x": -11.165,
              "y": -17.18,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.164,
              "y": -17.124,
              "z": 0.14
            },
            "gtin": "4013200882044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "de354f4caade8be3db7ed873",
            "leftCorner": {
              "x": -11.164,
              "y": -17.124,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.163,
              "y": -17.066,
              "z": 0.14
            },
            "gtin": "4013200882167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5ea21959d0b1ae00195916d6",
            "leftCorner": {
              "x": -11.163,
              "y": -17.066,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.163,
              "y": -17.061,
              "z": 0.14
            },
            "gtin": "4013200881672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ded97b9b40b3f2953a530cac",
            "leftCorner": {
              "x": -11.163,
              "y": -17.061,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.163,
              "y": -17.028,
              "z": 0.14
            },
            "gtin": "4013200881122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a455ad6a030c176f87526668",
            "leftCorner": {
              "x": -11.163,
              "y": -17.028,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.162,
              "y": -16.977,
              "z": 0.14
            },
            "gtin": "4013200882105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f8ef6fe496d3d022e037fbe2",
            "leftCorner": {
              "x": -11.162,
              "y": -16.977,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.161,
              "y": -16.922,
              "z": 0.14
            },
            "gtin": "4013200882044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "df26c9315c833c0f07fc5b56",
            "leftCorner": {
              "x": -11.161,
              "y": -16.922,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.161,
              "y": -16.863,
              "z": 0.14
            },
            "gtin": "4013200882167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "eb71fb77aa41091f6d85105a",
            "leftCorner": {
              "x": -11.161,
              "y": -16.863,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.16,
              "y": -16.798,
              "z": 0.14
            },
            "gtin": "4013200881153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "337854aa51dc2923746dca47",
            "leftCorner": {
              "x": -11.16,
              "y": -16.798,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.159,
              "y": -16.726,
              "z": 0.14
            },
            "gtin": "4013200881184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7c0b792e7f1968d4b7617f70",
            "leftCorner": {
              "x": -11.159,
              "y": -16.726,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.157,
              "y": -16.643,
              "z": 0.14
            },
            "gtin": "4013200882822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "59d3f7ccf0d221adf83e64d6",
            "leftCorner": {
              "x": -11.157,
              "y": -16.643,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.156,
              "y": -16.559,
              "z": 0.14
            },
            "gtin": "4013200885052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f58c9ddafe8ec6a44d9ee2e0",
            "leftCorner": {
              "x": -11.156,
              "y": -16.559,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.156,
              "y": -16.555,
              "z": 0.14
            },
            "gtin": "4013200881672",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf2d",
        "height": 0.50009,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55bc",
            "leftCorner": {
              "x": -11.222,
              "y": -17.179,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.221,
              "y": -17.11,
              "z": 0.409
            },
            "gtin": "4013200880095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55bd",
            "leftCorner": {
              "x": -11.221,
              "y": -17.11,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.22,
              "y": -17.041,
              "z": 0.409
            },
            "gtin": "4013200880095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55bf",
            "leftCorner": {
              "x": -11.271,
              "y": -17.04,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.268,
              "y": -16.902,
              "z": 0.409
            },
            "gtin": "4013200880149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55c0",
            "leftCorner": {
              "x": -11.259,
              "y": -16.902,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.257,
              "y": -16.762,
              "z": 0.409
            },
            "gtin": "4013200880156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55c1",
            "leftCorner": {
              "x": -11.255,
              "y": -16.762,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.253,
              "y": -16.696,
              "z": 0.409
            },
            "gtin": "4013200881153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55c2",
            "leftCorner": {
              "x": -11.254,
              "y": -16.696,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.253,
              "y": -16.605,
              "z": 0.409
            },
            "gtin": "4013200888978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55c3",
            "leftCorner": {
              "x": -11.246,
              "y": -16.605,
              "z": 0.409
            },
            "rightCorner": {
              "x": -11.243,
              "y": -16.44,
              "z": 0.409
            },
            "gtin": "4013200881122",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf30",
        "height": 0.81223,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55f6",
            "leftCorner": {
              "x": -11.207,
              "y": -17.179,
              "z": 0.665
            },
            "rightCorner": {
              "x": -11.206,
              "y": -17.069,
              "z": 0.665
            },
            "gtin": "4013200880804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55f7",
            "leftCorner": {
              "x": -11.257,
              "y": -17.068,
              "z": 0.665
            },
            "rightCorner": {
              "x": -11.254,
              "y": -16.823,
              "z": 0.665
            },
            "gtin": "4013200880811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55f8",
            "leftCorner": {
              "x": -11.242,
              "y": -16.823,
              "z": 0.665
            },
            "rightCorner": {
              "x": -11.24,
              "y": -16.689,
              "z": 0.665
            },
            "gtin": "4013200880828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55f9",
            "leftCorner": {
              "x": -11.237,
              "y": -16.689,
              "z": 0.665
            },
            "rightCorner": {
              "x": -11.236,
              "y": -16.554,
              "z": 0.665
            },
            "gtin": "4013200880026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55fa",
            "leftCorner": {
              "x": -11.23,
              "y": -16.554,
              "z": 0.665
            },
            "rightCorner": {
              "x": -11.228,
              "y": -16.378,
              "z": 0.665
            },
            "gtin": "4013200880033",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf2e",
        "height": 1.0875,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55d1",
            "leftCorner": {
              "x": -11.206,
              "y": -17.179,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.204,
              "y": -17.029,
              "z": 0.89
            },
            "gtin": "4013200882822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55d3",
            "leftCorner": {
              "x": -11.25,
              "y": -17.028,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.248,
              "y": -16.915,
              "z": 0.89
            },
            "gtin": "4013200882846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55d4",
            "leftCorner": {
              "x": -11.244,
              "y": -16.915,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.242,
              "y": -16.797,
              "z": 0.89
            },
            "gtin": "4013200882808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55d5",
            "leftCorner": {
              "x": -11.239,
              "y": -16.797,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.237,
              "y": -16.682,
              "z": 0.89
            },
            "gtin": "4013200882839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55d6",
            "leftCorner": {
              "x": -11.236,
              "y": -16.682,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.235,
              "y": -16.578,
              "z": 0.89
            },
            "gtin": "4013200882815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55d7",
            "leftCorner": {
              "x": -11.233,
              "y": -16.578,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.232,
              "y": -16.428,
              "z": 0.89
            },
            "gtin": "4013200882853",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf2c",
        "height": 1.3508,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55a2",
            "leftCorner": {
              "x": -11.213,
              "y": -17.179,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.211,
              "y": -17.063,
              "z": 1.105
            },
            "gtin": "4013200880200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55a4",
            "leftCorner": {
              "x": -11.252,
              "y": -17.062,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.251,
              "y": -16.952,
              "z": 1.105
            },
            "gtin": "4013200881177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55a5",
            "leftCorner": {
              "x": -11.251,
              "y": -16.952,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.25,
              "y": -16.881,
              "z": 1.105
            },
            "gtin": "4013200881184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55a6",
            "leftCorner": {
              "x": -11.243,
              "y": -16.881,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.242,
              "y": -16.797,
              "z": 1.105
            },
            "gtin": "4013200885052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55a7",
            "leftCorner": {
              "x": -11.246,
              "y": -16.797,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.245,
              "y": -16.744,
              "z": 1.105
            },
            "gtin": "4013200882068",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d55a8",
            "leftCorner": {
              "x": -11.245,
              "y": -16.744,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.245,
              "y": -16.695,
              "z": 1.105
            },
            "gtin": "4013200882105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55a9",
            "leftCorner": {
              "x": -11.246,
              "y": -16.695,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.245,
              "y": -16.639,
              "z": 1.105
            },
            "gtin": "4013200882068",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d55aa",
            "leftCorner": {
              "x": -11.246,
              "y": -16.639,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.246,
              "y": -16.585,
              "z": 1.105
            },
            "gtin": "4013200882174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55ab",
            "leftCorner": {
              "x": -11.236,
              "y": -16.586,
              "z": 1.105
            },
            "rightCorner": {
              "x": -11.234,
              "y": -16.472,
              "z": 1.105
            },
            "gtin": "4013200882174",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf2f",
        "height": 1.6011,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55e5",
            "leftCorner": {
              "x": -11.204,
              "y": -17.179,
              "z": 1.31
            },
            "rightCorner": {
              "x": -11.202,
              "y": -16.989,
              "z": 1.31
            },
            "gtin": "4013200881641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55e6",
            "leftCorner": {
              "x": -11.245,
              "y": -16.988,
              "z": 1.31
            },
            "rightCorner": {
              "x": -11.243,
              "y": -16.827,
              "z": 1.31
            },
            "gtin": "4013200881597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55e7",
            "leftCorner": {
              "x": -11.237,
              "y": -16.828,
              "z": 1.31
            },
            "rightCorner": {
              "x": -11.234,
              "y": -16.678,
              "z": 1.31
            },
            "gtin": "4013200881573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55e8",
            "leftCorner": {
              "x": -11.237,
              "y": -16.678,
              "z": 1.31
            },
            "rightCorner": {
              "x": -11.236,
              "y": -16.577,
              "z": 1.31
            },
            "gtin": "4013200881719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55e9",
            "leftCorner": {
              "x": -11.231,
              "y": -16.577,
              "z": 1.31
            },
            "rightCorner": {
              "x": -11.229,
              "y": -16.468,
              "z": 1.31
            },
            "gtin": "4013200881672",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "7f5"
  },
  {
    "id": "7f5",
    "name": "7f5",
    "x": -11.252,
    "y": -16.553,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70205,
      "w": 0.71213
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 55
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf37",
        "height": 0.17381,
        "facings": [
          {
            "id": "e7623fe71bbc8d52dbfadd01",
            "leftCorner": {
              "x": -11.156,
              "y": -16.555,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.155,
              "y": -16.501,
              "z": 0.142
            },
            "gtin": "4013200888466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "603b43c2b2256f8f38e3a96f",
            "leftCorner": {
              "x": -11.155,
              "y": -16.501,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.155,
              "y": -16.458,
              "z": 0.142
            },
            "gtin": "4013200881566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0854cbff3c78aa85363fd6d7",
            "leftCorner": {
              "x": -11.155,
              "y": -16.458,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.154,
              "y": -16.407,
              "z": 0.142
            },
            "gtin": "4013200881405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7ffdab18a8f82e58ee245733",
            "leftCorner": {
              "x": -11.154,
              "y": -16.407,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.153,
              "y": -16.356,
              "z": 0.142
            },
            "gtin": "4013200888602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d9ff689ef908e5affa5ccda7",
            "leftCorner": {
              "x": -11.153,
              "y": -16.356,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.152,
              "y": -16.302,
              "z": 0.142
            },
            "gtin": "4013200888466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e2d0bfa9f310a95fa7d30702",
            "leftCorner": {
              "x": -11.152,
              "y": -16.302,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.152,
              "y": -16.246,
              "z": 0.142
            },
            "gtin": "4013200888619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b23085df8062ace8d0716a83",
            "leftCorner": {
              "x": -11.152,
              "y": -16.246,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.151,
              "y": -16.189,
              "z": 0.142
            },
            "gtin": "4013200880606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c25de05a995e92384cefed35",
            "leftCorner": {
              "x": -11.151,
              "y": -16.189,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.15,
              "y": -16.13,
              "z": 0.142
            },
            "gtin": "4013200880644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0f6988937141a24f8887de7f",
            "leftCorner": {
              "x": -11.15,
              "y": -16.13,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.149,
              "y": -16.071,
              "z": 0.142
            },
            "gtin": "4013200881580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fe26fb12d2dac7f46e55a57b",
            "leftCorner": {
              "x": -11.149,
              "y": -16.071,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.148,
              "y": -16.008,
              "z": 0.142
            },
            "gtin": "4013200882853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "be9b14115f137bf948cfd3f1",
            "leftCorner": {
              "x": -11.148,
              "y": -16.008,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.147,
              "y": -15.94,
              "z": 0.142
            },
            "gtin": "4013200880590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f78527a03f6bf23897206055",
            "leftCorner": {
              "x": -11.147,
              "y": -15.94,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.146,
              "y": -15.866,
              "z": 0.142
            },
            "gtin": "4013200881603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "daf0cb6d874f90ffb954df2e",
            "leftCorner": {
              "x": -11.146,
              "y": -15.866,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.145,
              "y": -15.791,
              "z": 0.142
            },
            "gtin": "4013200880170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b145e5374aecb0dad87f20b9",
            "leftCorner": {
              "x": -11.145,
              "y": -15.791,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.142,
              "y": -15.569,
              "z": 0.142
            },
            "gtin": "4013200880002",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf32",
        "height": 0.50138,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55c4",
            "leftCorner": {
              "x": -11.236,
              "y": -16.446,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.234,
              "y": -16.35,
              "z": 0.41
            },
            "gtin": "4013200880132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c933142c8e1e13f5a1054c89",
            "leftCorner": {
              "x": -11.198,
              "y": -16.555,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.197,
              "y": -16.469,
              "z": 0.41
            },
            "gtin": "4013200880132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55c5",
            "leftCorner": {
              "x": -11.235,
              "y": -16.35,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.234,
              "y": -16.268,
              "z": 0.41
            },
            "gtin": "4013200880170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55c6",
            "leftCorner": {
              "x": -11.234,
              "y": -16.268,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.233,
              "y": -16.181,
              "z": 0.41
            },
            "gtin": "4013200880101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55c7",
            "leftCorner": {
              "x": -11.231,
              "y": -16.181,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.229,
              "y": -16.056,
              "z": 0.41
            },
            "gtin": "4013200883355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55c8",
            "leftCorner": {
              "x": -11.231,
              "y": -16.056,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.228,
              "y": -15.834,
              "z": 0.41
            },
            "gtin": "4013200883331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55c9",
            "leftCorner": {
              "x": -11.229,
              "y": -15.834,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.227,
              "y": -15.681,
              "z": 0.41
            },
            "gtin": "4013200883409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55ca",
            "leftCorner": {
              "x": -11.233,
              "y": -15.681,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.23,
              "y": -15.536,
              "z": 0.41
            },
            "gtin": "4013200883393",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf35",
        "height": 0.81189,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55fb",
            "leftCorner": {
              "x": -11.221,
              "y": -16.384,
              "z": 0.664
            },
            "rightCorner": {
              "x": -11.217,
              "y": -16.11,
              "z": 0.664
            },
            "gtin": "4013200880002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "32aa7da6622e1e5fff97e5d0",
            "leftCorner": {
              "x": -11.191,
              "y": -16.555,
              "z": 0.664
            },
            "rightCorner": {
              "x": -11.189,
              "y": -16.415,
              "z": 0.664
            },
            "gtin": "4013200880033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55fc",
            "leftCorner": {
              "x": -11.223,
              "y": -16.11,
              "z": 0.664
            },
            "rightCorner": {
              "x": -11.22,
              "y": -15.878,
              "z": 0.664
            },
            "gtin": "4013200880040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55fd",
            "leftCorner": {
              "x": -11.223,
              "y": -15.878,
              "z": 0.664
            },
            "rightCorner": {
              "x": -11.22,
              "y": -15.678,
              "z": 0.664
            },
            "gtin": "4013200885106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55fe",
            "leftCorner": {
              "x": -11.224,
              "y": -15.678,
              "z": 0.664
            },
            "rightCorner": {
              "x": -11.223,
              "y": -15.582,
              "z": 0.664
            },
            "gtin": "4013200885168",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf33",
        "height": 1.089,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55d8",
            "leftCorner": {
              "x": -11.224,
              "y": -16.434,
              "z": 0.891
            },
            "rightCorner": {
              "x": -11.222,
              "y": -16.357,
              "z": 0.891
            },
            "gtin": "4013200880590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2e70225d1812831610c10a17",
            "leftCorner": {
              "x": -11.187,
              "y": -16.555,
              "z": 0.891
            },
            "rightCorner": {
              "x": -11.186,
              "y": -16.47,
              "z": 0.891
            },
            "gtin": "4013200882853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fa2793eb7048d2f20dae8379",
            "leftCorner": {
              "x": -11.186,
              "y": -16.47,
              "z": 0.891
            },
            "rightCorner": {
              "x": -11.185,
              "y": -16.437,
              "z": 0.891
            },
            "gtin": "4013200881863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55d9",
            "leftCorner": {
              "x": -11.223,
              "y": -16.357,
              "z": 0.891
            },
            "rightCorner": {
              "x": -11.223,
              "y": -16.293,
              "z": 0.891
            },
            "gtin": "4013200880606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55da",
            "leftCorner": {
              "x": -11.225,
              "y": -16.293,
              "z": 0.891
            },
            "rightCorner": {
              "x": -11.224,
              "y": -16.238,
              "z": 0.891
            },
            "gtin": "4013200881542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55db",
            "leftCorner": {
              "x": -11.22,
              "y": -16.238,
              "z": 0.891
            },
            "rightCorner": {
              "x": -11.218,
              "y": -16.146,
              "z": 0.891
            },
            "gtin": "4013200881542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55dc",
            "leftCorner": {
              "x": -11.22,
              "y": -16.146,
              "z": 0.891
            },
            "rightCorner": {
              "x": -11.217,
              "y": -15.954,
              "z": 0.891
            },
            "gtin": "4013200881825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55dd",
            "leftCorner": {
              "x": -11.221,
              "y": -15.954,
              "z": 0.891
            },
            "rightCorner": {
              "x": -11.218,
              "y": -15.758,
              "z": 0.891
            },
            "gtin": "4013200881559",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d55de",
            "leftCorner": {
              "x": -11.221,
              "y": -15.758,
              "z": 0.891
            },
            "rightCorner": {
              "x": -11.219,
              "y": -15.574,
              "z": 0.891
            },
            "gtin": "4013200881832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55df",
            "leftCorner": {
              "x": -11.221,
              "y": -15.574,
              "z": 0.891
            },
            "rightCorner": {
              "x": -11.22,
              "y": -15.471,
              "z": 0.891
            },
            "gtin": "4013200881863",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf34",
        "height": 1.352,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55ac",
            "leftCorner": {
              "x": -11.234,
              "y": -16.477,
              "z": 1.106
            },
            "rightCorner": {
              "x": -11.234,
              "y": -16.403,
              "z": 1.106
            },
            "gtin": "4013200880644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "43cdefc09d998dc98bdf2afd",
            "leftCorner": {
              "x": -11.199,
              "y": -16.555,
              "z": 1.106
            },
            "rightCorner": {
              "x": -11.198,
              "y": -16.498,
              "z": 1.106
            },
            "gtin": "4013200888619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55ad",
            "leftCorner": {
              "x": -11.226,
              "y": -16.403,
              "z": 1.106
            },
            "rightCorner": {
              "x": -11.225,
              "y": -16.301,
              "z": 1.106
            },
            "gtin": "4013200881399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55ae",
            "leftCorner": {
              "x": -11.233,
              "y": -16.301,
              "z": 1.106
            },
            "rightCorner": {
              "x": -11.232,
              "y": -16.249,
              "z": 1.106
            },
            "gtin": "4013200881412",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d55af",
            "leftCorner": {
              "x": -11.229,
              "y": -16.249,
              "z": 1.106
            },
            "rightCorner": {
              "x": -11.227,
              "y": -16.147,
              "z": 1.106
            },
            "gtin": "4013200881412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55b0",
            "leftCorner": {
              "x": -11.232,
              "y": -16.147,
              "z": 1.106
            },
            "rightCorner": {
              "x": -11.232,
              "y": -16.098,
              "z": 1.106
            },
            "gtin": "4013200881405",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d55b1",
            "leftCorner": {
              "x": -11.234,
              "y": -16.098,
              "z": 1.106
            },
            "rightCorner": {
              "x": -11.233,
              "y": -16.044,
              "z": 1.106
            },
            "gtin": "4013200888602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55b2",
            "leftCorner": {
              "x": -11.233,
              "y": -16.044,
              "z": 1.106
            },
            "rightCorner": {
              "x": -11.233,
              "y": -15.995,
              "z": 1.106
            },
            "gtin": "4013200882129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55b3",
            "leftCorner": {
              "x": -11.231,
              "y": -15.995,
              "z": 1.106
            },
            "rightCorner": {
              "x": -11.23,
              "y": -15.91,
              "z": 1.106
            },
            "gtin": "4013200882129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55b4",
            "leftCorner": {
              "x": -11.228,
              "y": -15.91,
              "z": 1.106
            },
            "rightCorner": {
              "x": -11.226,
              "y": -15.782,
              "z": 1.106
            },
            "gtin": "4013200882112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55b5",
            "leftCorner": {
              "x": -11.23,
              "y": -15.782,
              "z": 1.106
            },
            "rightCorner": {
              "x": -11.228,
              "y": -15.669,
              "z": 1.106
            },
            "gtin": "4013200881764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55b6",
            "leftCorner": {
              "x": -11.231,
              "y": -15.669,
              "z": 1.106
            },
            "rightCorner": {
              "x": -11.228,
              "y": -15.511,
              "z": 1.106
            },
            "gtin": "4013200881818",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf36",
        "height": 1.6024,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55ea",
            "leftCorner": {
              "x": -11.226,
              "y": -16.473,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.224,
              "y": -16.296,
              "z": 1.311
            },
            "gtin": "4013200881634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7cf13ab8f4205ca85f597e04",
            "leftCorner": {
              "x": -11.192,
              "y": -16.555,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.191,
              "y": -16.479,
              "z": 1.311
            },
            "gtin": "4013200881627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55eb",
            "leftCorner": {
              "x": -11.222,
              "y": -16.296,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.22,
              "y": -16.191,
              "z": 1.311
            },
            "gtin": "4013200881689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55ec",
            "leftCorner": {
              "x": -11.224,
              "y": -16.191,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.221,
              "y": -16.026,
              "z": 1.311
            },
            "gtin": "4013200882686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55ed",
            "leftCorner": {
              "x": -11.225,
              "y": -16.026,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.222,
              "y": -15.867,
              "z": 1.311
            },
            "gtin": "4013200881610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55ee",
            "leftCorner": {
              "x": -11.222,
              "y": -15.867,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.22,
              "y": -15.725,
              "z": 1.311
            },
            "gtin": "4013200881603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55ef",
            "leftCorner": {
              "x": -11.231,
              "y": -15.725,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.23,
              "y": -15.667,
              "z": 1.311
            },
            "gtin": "4013200881580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55f0",
            "leftCorner": {
              "x": -11.232,
              "y": -15.667,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.23,
              "y": -15.622,
              "z": 1.311
            },
            "gtin": "4013200881566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55f1",
            "leftCorner": {
              "x": -11.223,
              "y": -15.622,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.222,
              "y": -15.534,
              "z": 1.311
            },
            "gtin": "4013200881627",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7f4",
    "rightNeighborShelfId": "7f6"
  },
  {
    "id": "7f6",
    "name": "7f6",
    "x": -11.237,
    "y": -15.554,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70205,
      "w": 0.71213
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf3e",
        "height": 0.16694,
        "facings": [
          {
            "id": "3d191e4b942e94a2e3265f29",
            "leftCorner": {
              "x": -11.138,
              "y": -15.556,
              "z": 0.137
            },
            "rightCorner": {
              "x": -11.137,
              "y": -15.498,
              "z": 0.137
            },
            "gtin": "4013200881856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8fc669008af650379eb1bdd0",
            "leftCorner": {
              "x": -11.137,
              "y": -15.498,
              "z": 0.137
            },
            "rightCorner": {
              "x": -11.136,
              "y": -15.427,
              "z": 0.137
            },
            "gtin": "4013200881443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6ad6b303924a786f433837f2",
            "leftCorner": {
              "x": -11.136,
              "y": -15.427,
              "z": 0.137
            },
            "rightCorner": {
              "x": -11.135,
              "y": -15.355,
              "z": 0.137
            },
            "gtin": "4013200881498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d554ebc124a72a5fe477fe0a",
            "leftCorner": {
              "x": -11.135,
              "y": -15.355,
              "z": 0.137
            },
            "rightCorner": {
              "x": -11.134,
              "y": -15.283,
              "z": 0.137
            },
            "gtin": "4013200882860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "004a9a8e58635681942e20e3",
            "leftCorner": {
              "x": -11.134,
              "y": -15.283,
              "z": 0.137
            },
            "rightCorner": {
              "x": -11.133,
              "y": -15.209,
              "z": 0.137
            },
            "gtin": "4013200882723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c308056f67ff153e763336ea",
            "leftCorner": {
              "x": -11.133,
              "y": -15.209,
              "z": 0.137
            },
            "rightCorner": {
              "x": -11.132,
              "y": -15.118,
              "z": 0.137
            },
            "gtin": "4013200884048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4f4cc6d39c05a95cfff71402",
            "leftCorner": {
              "x": -11.132,
              "y": -15.118,
              "z": 0.137
            },
            "rightCorner": {
              "x": -11.13,
              "y": -15.018,
              "z": 0.137
            },
            "gtin": "4013200883362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0a839cd0f2c3bd248e52b895",
            "leftCorner": {
              "x": -11.13,
              "y": -15.018,
              "z": 0.137
            },
            "rightCorner": {
              "x": -11.129,
              "y": -14.928,
              "z": 0.137
            },
            "gtin": "4013200884048",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf3c",
        "height": 0.50101,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55cb",
            "leftCorner": {
              "x": -11.223,
              "y": -15.537,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.221,
              "y": -15.424,
              "z": 0.41
            },
            "gtin": "4013200883348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55cc",
            "leftCorner": {
              "x": -11.221,
              "y": -15.424,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.22,
              "y": -15.311,
              "z": 0.41
            },
            "gtin": "4013200883348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55cd",
            "leftCorner": {
              "x": -11.221,
              "y": -15.311,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.219,
              "y": -15.258,
              "z": 0.41
            },
            "gtin": "4013200883300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55ce",
            "leftCorner": {
              "x": -11.219,
              "y": -15.258,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.219,
              "y": -15.204,
              "z": 0.41
            },
            "gtin": "4013200883300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55cf",
            "leftCorner": {
              "x": -11.219,
              "y": -15.204,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.218,
              "y": -15.151,
              "z": 0.41
            },
            "gtin": "4013200883300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55d0",
            "leftCorner": {
              "x": -11.222,
              "y": -15.151,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.221,
              "y": -15.046,
              "z": 0.41
            },
            "gtin": "4013200883362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55be",
            "leftCorner": {
              "x": -11.218,
              "y": -15.046,
              "z": 0.41
            },
            "rightCorner": {
              "x": -11.217,
              "y": -14.924,
              "z": 0.41
            },
            "gtin": "4013200883324",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf3b",
        "height": 0.79994,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5609",
            "leftCorner": {
              "x": -11.187,
              "y": -15.555,
              "z": 0.655
            },
            "rightCorner": {
              "x": -11.184,
              "y": -15.376,
              "z": 0.655
            },
            "gtin": "4013200885212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d560b",
            "leftCorner": {
              "x": -11.219,
              "y": -15.375,
              "z": 0.655
            },
            "rightCorner": {
              "x": -11.217,
              "y": -15.267,
              "z": 0.655
            },
            "gtin": "4013200885229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d560c",
            "leftCorner": {
              "x": -11.223,
              "y": -15.266,
              "z": 0.655
            },
            "rightCorner": {
              "x": -11.221,
              "y": -15.077,
              "z": 0.655
            },
            "gtin": "4013200881009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d560a",
            "leftCorner": {
              "x": -11.224,
              "y": -15.077,
              "z": 0.655
            },
            "rightCorner": {
              "x": -11.221,
              "y": -14.924,
              "z": 0.655
            },
            "gtin": "4013200881016",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf38",
        "height": 1.0873,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55e0",
            "leftCorner": {
              "x": -11.216,
              "y": -15.472,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.216,
              "y": -15.411,
              "z": 0.89
            },
            "gtin": "4013200881856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55e1",
            "leftCorner": {
              "x": -11.214,
              "y": -15.411,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.212,
              "y": -15.343,
              "z": 0.89
            },
            "gtin": "4013200881443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55e2",
            "leftCorner": {
              "x": -11.209,
              "y": -15.343,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.207,
              "y": -15.227,
              "z": 0.89
            },
            "gtin": "4013200881436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55e3",
            "leftCorner": {
              "x": -11.213,
              "y": -15.227,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.211,
              "y": -15.114,
              "z": 0.89
            },
            "gtin": "4013200881429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55e4",
            "leftCorner": {
              "x": -11.214,
              "y": -15.114,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.213,
              "y": -14.993,
              "z": 0.89
            },
            "gtin": "4013200881665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55d2",
            "leftCorner": {
              "x": -11.211,
              "y": -14.993,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.21,
              "y": -14.924,
              "z": 0.89
            },
            "gtin": "4013200881467",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "d16190d2b1749d6ef4be6461",
            "leftCorner": {
              "x": -11.177,
              "y": -15.556,
              "z": 0.89
            },
            "rightCorner": {
              "x": -11.176,
              "y": -15.484,
              "z": 0.89
            },
            "gtin": "4013200881467",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf3a",
        "height": 1.3535,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55b7",
            "leftCorner": {
              "x": -11.22,
              "y": -15.512,
              "z": 1.107
            },
            "rightCorner": {
              "x": -11.217,
              "y": -15.377,
              "z": 1.107
            },
            "gtin": "4013200881504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55b8",
            "leftCorner": {
              "x": -11.215,
              "y": -15.377,
              "z": 1.107
            },
            "rightCorner": {
              "x": -11.213,
              "y": -15.259,
              "z": 1.107
            },
            "gtin": "4013200881528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55b9",
            "leftCorner": {
              "x": -11.22,
              "y": -15.259,
              "z": 1.107
            },
            "rightCorner": {
              "x": -11.219,
              "y": -15.14,
              "z": 1.107
            },
            "gtin": "4013200881535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55ba",
            "leftCorner": {
              "x": -11.221,
              "y": -15.14,
              "z": 1.107
            },
            "rightCorner": {
              "x": -11.221,
              "y": -15.063,
              "z": 1.107
            },
            "gtin": "4013200882860",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55bb",
            "leftCorner": {
              "x": -11.222,
              "y": -15.063,
              "z": 1.107
            },
            "rightCorner": {
              "x": -11.22,
              "y": -14.995,
              "z": 1.107
            },
            "gtin": "4013200881498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55a3",
            "leftCorner": {
              "x": -11.217,
              "y": -14.995,
              "z": 1.107
            },
            "rightCorner": {
              "x": -11.215,
              "y": -14.924,
              "z": 1.107
            },
            "gtin": "4013200882723",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf39",
        "height": 1.6029,
        "facings": [
          {
            "id": "68d8e509e1820c81800d55f2",
            "leftCorner": {
              "x": -11.218,
              "y": -15.535,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.216,
              "y": -15.401,
              "z": 1.311
            },
            "gtin": "4013200882693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55f3",
            "leftCorner": {
              "x": -11.218,
              "y": -15.401,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.216,
              "y": -15.261,
              "z": 1.311
            },
            "gtin": "4013200884055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55f4",
            "leftCorner": {
              "x": -11.224,
              "y": -15.261,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.222,
              "y": -15.064,
              "z": 1.311
            },
            "gtin": "4013200884031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55f5",
            "leftCorner": {
              "x": -11.433,
              "y": -15.061,
              "z": 1.311
            },
            "rightCorner": {
              "x": -11.431,
              "y": -14.956,
              "z": 1.311
            },
            "gtin": "4013200884048",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7f5"
  },
  {
    "id": "7f7",
    "name": "7f7",
    "x": -11.93,
    "y": -14.92,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.0043808
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 47
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539ceeb",
        "height": 0.16605,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5467",
            "leftCorner": {
              "x": -11.931,
              "y": -14.857,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.065,
              "y": -14.858,
              "z": 0.136
            },
            "gtin": "4013200781606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5469",
            "leftCorner": {
              "x": -12.064,
              "y": -14.897,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.157,
              "y": -14.898,
              "z": 0.136
            },
            "gtin": "4013200781521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d546a",
            "leftCorner": {
              "x": -12.157,
              "y": -14.9,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.256,
              "y": -14.901,
              "z": 0.136
            },
            "gtin": "4013200781507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d546b",
            "leftCorner": {
              "x": -12.256,
              "y": -14.902,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.368,
              "y": -14.904,
              "z": 0.136
            },
            "gtin": "4013200781514",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e508e1820c81800d546c",
            "leftCorner": {
              "x": -12.368,
              "y": -14.901,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.477,
              "y": -14.902,
              "z": 0.136
            },
            "gtin": "4013200781590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d546d",
            "leftCorner": {
              "x": -12.477,
              "y": -14.901,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.72,
              "y": -14.903,
              "z": 0.136
            },
            "gtin": "4013200780364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5468",
            "leftCorner": {
              "x": -12.72,
              "y": -14.901,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.93,
              "y": -14.903,
              "z": 0.136
            },
            "gtin": "4013200780005",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cee7",
        "height": 0.56148,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5448",
            "leftCorner": {
              "x": -11.93,
              "y": -14.899,
              "z": 0.459
            },
            "rightCorner": {
              "x": -12.002,
              "y": -14.9,
              "z": 0.459
            },
            "gtin": "4013200782634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d544a",
            "leftCorner": {
              "x": -12.002,
              "y": -14.942,
              "z": 0.459
            },
            "rightCorner": {
              "x": -12.058,
              "y": -14.942,
              "z": 0.459
            },
            "gtin": "4013200108557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d544b",
            "leftCorner": {
              "x": -12.058,
              "y": -14.94,
              "z": 0.459
            },
            "rightCorner": {
              "x": -12.5,
              "y": -14.945,
              "z": 0.459
            },
            "gtin": "4013200108601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d544c",
            "leftCorner": {
              "x": -12.5,
              "y": -14.946,
              "z": 0.459
            },
            "rightCorner": {
              "x": -12.71,
              "y": -14.947,
              "z": 0.459
            },
            "gtin": "4013200780197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5449",
            "leftCorner": {
              "x": -12.71,
              "y": -14.945,
              "z": 0.459
            },
            "rightCorner": {
              "x": -12.93,
              "y": -14.947,
              "z": 0.459
            },
            "gtin": "4013200780234",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539ceec",
        "height": 0.90003,
        "facings": [
          {
            "id": "68d8e508e1820c81800d546e",
            "leftCorner": {
              "x": -11.93,
              "y": -14.89,
              "z": 0.736
            },
            "rightCorner": {
              "x": -12.077,
              "y": -14.891,
              "z": 0.736
            },
            "gtin": "4013200782511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5470",
            "leftCorner": {
              "x": -12.077,
              "y": -14.925,
              "z": 0.736
            },
            "rightCorner": {
              "x": -12.16,
              "y": -14.926,
              "z": 0.736
            },
            "gtin": "4013200782597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5471",
            "leftCorner": {
              "x": -12.16,
              "y": -14.925,
              "z": 0.736
            },
            "rightCorner": {
              "x": -12.252,
              "y": -14.926,
              "z": 0.736
            },
            "gtin": "4013200782542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5472",
            "leftCorner": {
              "x": -12.252,
              "y": -14.929,
              "z": 0.736
            },
            "rightCorner": {
              "x": -12.353,
              "y": -14.929,
              "z": 0.736
            },
            "gtin": "4013200782535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5473",
            "leftCorner": {
              "x": -12.353,
              "y": -14.933,
              "z": 0.736
            },
            "rightCorner": {
              "x": -12.447,
              "y": -14.934,
              "z": 0.736
            },
            "gtin": "4013200782573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5474",
            "leftCorner": {
              "x": -12.447,
              "y": -14.939,
              "z": 0.736
            },
            "rightCorner": {
              "x": -12.502,
              "y": -14.94,
              "z": 0.736
            },
            "gtin": "4013200781026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5475",
            "leftCorner": {
              "x": -12.502,
              "y": -14.938,
              "z": 0.736
            },
            "rightCorner": {
              "x": -12.562,
              "y": -14.938,
              "z": 0.736
            },
            "gtin": "4013200781019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5476",
            "leftCorner": {
              "x": -12.562,
              "y": -14.939,
              "z": 0.736
            },
            "rightCorner": {
              "x": -12.632,
              "y": -14.94,
              "z": 0.736
            },
            "gtin": "4013200781064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5477",
            "leftCorner": {
              "x": -12.632,
              "y": -14.939,
              "z": 0.736
            },
            "rightCorner": {
              "x": -12.694,
              "y": -14.939,
              "z": 0.736
            },
            "gtin": "4013200781040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5478",
            "leftCorner": {
              "x": -12.694,
              "y": -14.938,
              "z": 0.736
            },
            "rightCorner": {
              "x": -12.759,
              "y": -14.939,
              "z": 0.736
            },
            "gtin": "4013200781088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5479",
            "leftCorner": {
              "x": -12.759,
              "y": -14.935,
              "z": 0.736
            },
            "rightCorner": {
              "x": -12.806,
              "y": -14.935,
              "z": 0.736
            },
            "gtin": "4013200781033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d546f",
            "leftCorner": {
              "x": -12.806,
              "y": -14.931,
              "z": 0.736
            },
            "rightCorner": {
              "x": -12.93,
              "y": -14.932,
              "z": 0.736
            },
            "gtin": "4013200754631",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cee9",
        "height": 1.2016,
        "facings": [
          {
            "id": "68d8e508e1820c81800d545c",
            "leftCorner": {
              "x": -12.064,
              "y": -14.938,
              "z": 0.983
            },
            "rightCorner": {
              "x": -12.208,
              "y": -14.939,
              "z": 0.983
            },
            "gtin": "4013200387716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d545d",
            "leftCorner": {
              "x": -12.208,
              "y": -14.939,
              "z": 0.983
            },
            "rightCorner": {
              "x": -12.318,
              "y": -14.94,
              "z": 0.983
            },
            "gtin": "4013200381196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d545e",
            "leftCorner": {
              "x": -12.318,
              "y": -14.946,
              "z": 0.983
            },
            "rightCorner": {
              "x": -12.374,
              "y": -14.947,
              "z": 0.983
            },
            "gtin": "4013200388102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d545f",
            "leftCorner": {
              "x": -12.374,
              "y": -14.949,
              "z": 0.983
            },
            "rightCorner": {
              "x": -12.448,
              "y": -14.949,
              "z": 0.983
            },
            "gtin": "4013200387730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5460",
            "leftCorner": {
              "x": -12.448,
              "y": -14.949,
              "z": 0.983
            },
            "rightCorner": {
              "x": -12.547,
              "y": -14.95,
              "z": 0.983
            },
            "gtin": "4013200387723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5461",
            "leftCorner": {
              "x": -12.547,
              "y": -14.952,
              "z": 0.983
            },
            "rightCorner": {
              "x": -12.616,
              "y": -14.953,
              "z": 0.983
            },
            "gtin": "4013200387501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5462",
            "leftCorner": {
              "x": -12.616,
              "y": -14.952,
              "z": 0.983
            },
            "rightCorner": {
              "x": -12.703,
              "y": -14.952,
              "z": 0.983
            },
            "gtin": "4013200388706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5463",
            "leftCorner": {
              "x": -12.703,
              "y": -14.945,
              "z": 0.983
            },
            "rightCorner": {
              "x": -12.797,
              "y": -14.946,
              "z": 0.983
            },
            "gtin": "4013200382001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d545b",
            "leftCorner": {
              "x": -12.797,
              "y": -14.942,
              "z": 0.983
            },
            "rightCorner": {
              "x": -12.93,
              "y": -14.943,
              "z": 0.983
            },
            "gtin": "4013200387013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0d6bcdae31a3bc531a5f4307",
            "leftCorner": {
              "x": -11.93,
              "y": -14.903,
              "z": 0.983
            },
            "rightCorner": {
              "x": -12.046,
              "y": -14.904,
              "z": 0.983
            },
            "gtin": "4013200387013",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3fe55f889d41539cee8",
        "height": 1.5038,
        "facings": [
          {
            "id": "68d8e508e1820c81800d544d",
            "leftCorner": {
              "x": -11.93,
              "y": -14.887,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.013,
              "y": -14.888,
              "z": 1.23
            },
            "gtin": "4013200389680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d544f",
            "leftCorner": {
              "x": -12.013,
              "y": -14.928,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.047,
              "y": -14.928,
              "z": 1.23
            },
            "gtin": "4013200389697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5450",
            "leftCorner": {
              "x": -12.047,
              "y": -14.923,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.089,
              "y": -14.923,
              "z": 1.23
            },
            "gtin": "4013200389505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5451",
            "leftCorner": {
              "x": -12.089,
              "y": -14.925,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.13,
              "y": -14.926,
              "z": 1.23
            },
            "gtin": "4013200882181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5452",
            "leftCorner": {
              "x": -12.13,
              "y": -14.928,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.197,
              "y": -14.928,
              "z": 1.23
            },
            "gtin": "4013200862442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5453",
            "leftCorner": {
              "x": -12.197,
              "y": -14.929,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.387,
              "y": -14.931,
              "z": 1.23
            },
            "gtin": "4013200860615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5454",
            "leftCorner": {
              "x": -12.387,
              "y": -14.938,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.469,
              "y": -14.938,
              "z": 1.23
            },
            "gtin": "4013200864026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5455",
            "leftCorner": {
              "x": -12.469,
              "y": -14.934,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.644,
              "y": -14.936,
              "z": 1.23
            },
            "gtin": "4013200862145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5456",
            "leftCorner": {
              "x": -12.644,
              "y": -14.939,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.701,
              "y": -14.939,
              "z": 1.23
            },
            "gtin": "4013200862015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5457",
            "leftCorner": {
              "x": -12.701,
              "y": -14.938,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.757,
              "y": -14.939,
              "z": 1.23
            },
            "gtin": "4013200862022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5458",
            "leftCorner": {
              "x": -12.757,
              "y": -14.935,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.805,
              "y": -14.935,
              "z": 1.23
            },
            "gtin": "4013200862053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5459",
            "leftCorner": {
              "x": -12.805,
              "y": -14.935,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.87,
              "y": -14.936,
              "z": 1.23
            },
            "gtin": "4013200862039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d544e",
            "leftCorner": {
              "x": -12.87,
              "y": -14.937,
              "z": 1.23
            },
            "rightCorner": {
              "x": -12.93,
              "y": -14.937,
              "z": 1.23
            },
            "gtin": "4013200862305",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539ceea",
        "height": 1.6578,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5464",
            "leftCorner": {
              "x": -11.93,
              "y": -14.949,
              "z": 1.356
            },
            "rightCorner": {
              "x": -12.014,
              "y": -14.95,
              "z": 1.356
            },
            "gtin": "4013200389703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5466",
            "leftCorner": {
              "x": -12.013,
              "y": -14.989,
              "z": 1.356
            },
            "rightCorner": {
              "x": -12.098,
              "y": -14.989,
              "z": 1.356
            },
            "gtin": "4013200389710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e508e1820c81800d5465",
            "leftCorner": {
              "x": -12.098,
              "y": -14.991,
              "z": 1.356
            },
            "rightCorner": {
              "x": -12.929,
              "y": -14.998,
              "z": 1.356
            },
            "gtin": "4013200862404",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "7f8",
    "name": "7f8",
    "x": -12.861,
    "y": -17.177,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0037175,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 66
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf2b",
        "height": 0.16644,
        "facings": [
          {
            "id": "68d8e509e1820c81800d559b",
            "leftCorner": {
              "x": -12.862,
              "y": -17.255,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.726,
              "y": -17.256,
              "z": 0.136
            },
            "gtin": "4007680105304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d559d",
            "leftCorner": {
              "x": -12.725,
              "y": -17.078,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.568,
              "y": -17.079,
              "z": 0.136
            },
            "gtin": "4007680105311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d559e",
            "leftCorner": {
              "x": -12.569,
              "y": -17.216,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.476,
              "y": -17.217,
              "z": 0.136
            },
            "gtin": "4007680105328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d559f",
            "leftCorner": {
              "x": -12.477,
              "y": -17.226,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.296,
              "y": -17.228,
              "z": 0.136
            },
            "gtin": "4007680105496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55a0",
            "leftCorner": {
              "x": -12.296,
              "y": -17.224,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.122,
              "y": -17.225,
              "z": 0.136
            },
            "gtin": "4007680105335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d55a1",
            "leftCorner": {
              "x": -12.121,
              "y": -17.219,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.014,
              "y": -17.219,
              "z": 0.136
            },
            "gtin": "4007680105342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d559c",
            "leftCorner": {
              "x": -12.014,
              "y": -17.221,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.861,
              "y": -17.223,
              "z": 0.136
            },
            "gtin": "4007680105359",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf25",
        "height": 0.51183,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5576",
            "leftCorner": {
              "x": -12.861,
              "y": -17.219,
              "z": 0.419
            },
            "rightCorner": {
              "x": -12.749,
              "y": -17.22,
              "z": 0.419
            },
            "gtin": "4007680107629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b96c7884e0ab0131d2950ed8",
            "leftCorner": {
              "x": -11.906,
              "y": -17.226,
              "z": 0.419
            },
            "rightCorner": {
              "x": -11.87,
              "y": -17.226,
              "z": 0.419
            },
            "gtin": "4007680106721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5578",
            "leftCorner": {
              "x": -12.749,
              "y": -17.181,
              "z": 0.419
            },
            "rightCorner": {
              "x": -12.676,
              "y": -17.182,
              "z": 0.419
            },
            "gtin": "4007680106707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5579",
            "leftCorner": {
              "x": -12.676,
              "y": -17.185,
              "z": 0.419
            },
            "rightCorner": {
              "x": -12.522,
              "y": -17.186,
              "z": 0.419
            },
            "gtin": "4007680106783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d557a",
            "leftCorner": {
              "x": -12.522,
              "y": -17.186,
              "z": 0.419
            },
            "rightCorner": {
              "x": -12.386,
              "y": -17.187,
              "z": 0.419
            },
            "gtin": "4007680106745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d557b",
            "leftCorner": {
              "x": -12.386,
              "y": -17.188,
              "z": 0.419
            },
            "rightCorner": {
              "x": -12.231,
              "y": -17.189,
              "z": 0.419
            },
            "gtin": "4007680106721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d557c",
            "leftCorner": {
              "x": -12.231,
              "y": -17.181,
              "z": 0.419
            },
            "rightCorner": {
              "x": -12.177,
              "y": -17.182,
              "z": 0.419
            },
            "gtin": "4007680105274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d557d",
            "leftCorner": {
              "x": -12.177,
              "y": -17.183,
              "z": 0.419
            },
            "rightCorner": {
              "x": -12.083,
              "y": -17.184,
              "z": 0.419
            },
            "gtin": "4007680105274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d557e",
            "leftCorner": {
              "x": -12.083,
              "y": -17.181,
              "z": 0.419
            },
            "rightCorner": {
              "x": -12.007,
              "y": -17.182,
              "z": 0.419
            },
            "gtin": "4007680105267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d557f",
            "leftCorner": {
              "x": -12.007,
              "y": -17.18,
              "z": 0.419
            },
            "rightCorner": {
              "x": -11.906,
              "y": -17.181,
              "z": 0.419
            },
            "gtin": "4007680104307",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf28",
        "height": 0.83628,
        "facings": [
          {
            "id": "68d8e509e1820c81800d558e",
            "leftCorner": {
              "x": -12.862,
              "y": -17.225,
              "z": 0.684
            },
            "rightCorner": {
              "x": -12.754,
              "y": -17.226,
              "z": 0.684
            },
            "gtin": "4007680103201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5590",
            "leftCorner": {
              "x": -12.753,
              "y": -17.187,
              "z": 0.684
            },
            "rightCorner": {
              "x": -12.675,
              "y": -17.187,
              "z": 0.684
            },
            "gtin": "4007680103270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5591",
            "leftCorner": {
              "x": -12.675,
              "y": -17.187,
              "z": 0.684
            },
            "rightCorner": {
              "x": -12.611,
              "y": -17.188,
              "z": 0.684
            },
            "gtin": "4007680103980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5592",
            "leftCorner": {
              "x": -12.611,
              "y": -17.19,
              "z": 0.684
            },
            "rightCorner": {
              "x": -12.529,
              "y": -17.191,
              "z": 0.684
            },
            "gtin": "4007680103928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5593",
            "leftCorner": {
              "x": -12.529,
              "y": -17.192,
              "z": 0.684
            },
            "rightCorner": {
              "x": -12.448,
              "y": -17.192,
              "z": 0.684
            },
            "gtin": "4007680103423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5594",
            "leftCorner": {
              "x": -12.448,
              "y": -17.19,
              "z": 0.684
            },
            "rightCorner": {
              "x": -12.376,
              "y": -17.191,
              "z": 0.684
            },
            "gtin": "4007680103447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5595",
            "leftCorner": {
              "x": -12.376,
              "y": -17.19,
              "z": 0.684
            },
            "rightCorner": {
              "x": -12.286,
              "y": -17.19,
              "z": 0.684
            },
            "gtin": "4007680103416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5596",
            "leftCorner": {
              "x": -12.286,
              "y": -17.189,
              "z": 0.684
            },
            "rightCorner": {
              "x": -12.209,
              "y": -17.19,
              "z": 0.684
            },
            "gtin": "4007680103591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5597",
            "leftCorner": {
              "x": -12.209,
              "y": -17.189,
              "z": 0.684
            },
            "rightCorner": {
              "x": -12.131,
              "y": -17.189,
              "z": 0.684
            },
            "gtin": "4007680106462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5598",
            "leftCorner": {
              "x": -12.131,
              "y": -17.187,
              "z": 0.684
            },
            "rightCorner": {
              "x": -12.059,
              "y": -17.187,
              "z": 0.684
            },
            "gtin": "4007680104574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5599",
            "leftCorner": {
              "x": -12.059,
              "y": -17.186,
              "z": 0.684
            },
            "rightCorner": {
              "x": -11.979,
              "y": -17.187,
              "z": 0.684
            },
            "gtin": "4007680103003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d559a",
            "leftCorner": {
              "x": -11.979,
              "y": -17.184,
              "z": 0.684
            },
            "rightCorner": {
              "x": -11.903,
              "y": -17.185,
              "z": 0.684
            },
            "gtin": "4007680103041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d558f",
            "leftCorner": {
              "x": -11.903,
              "y": -17.186,
              "z": 0.684
            },
            "rightCorner": {
              "x": -11.861,
              "y": -17.186,
              "z": 0.684
            },
            "gtin": "4007680103041",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf24",
        "height": 1.1009,
        "facings": [
          {
            "id": "68d8e509e1820c81800d556b",
            "leftCorner": {
              "x": -12.861,
              "y": -17.219,
              "z": 0.901
            },
            "rightCorner": {
              "x": -12.755,
              "y": -17.219,
              "z": 0.901
            },
            "gtin": "4013200884161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d556d",
            "leftCorner": {
              "x": -12.755,
              "y": -17.179,
              "z": 0.901
            },
            "rightCorner": {
              "x": -12.699,
              "y": -17.18,
              "z": 0.901
            },
            "gtin": "4013200884147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d556e",
            "leftCorner": {
              "x": -12.699,
              "y": -17.18,
              "z": 0.901
            },
            "rightCorner": {
              "x": -12.64,
              "y": -17.181,
              "z": 0.901
            },
            "gtin": "4013200884154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d556f",
            "leftCorner": {
              "x": -12.64,
              "y": -17.182,
              "z": 0.901
            },
            "rightCorner": {
              "x": -12.571,
              "y": -17.182,
              "z": 0.901
            },
            "gtin": "4013200882907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5570",
            "leftCorner": {
              "x": -12.571,
              "y": -17.183,
              "z": 0.901
            },
            "rightCorner": {
              "x": -12.448,
              "y": -17.184,
              "z": 0.901
            },
            "gtin": "4013200882938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5571",
            "leftCorner": {
              "x": -12.448,
              "y": -17.188,
              "z": 0.901
            },
            "rightCorner": {
              "x": -12.328,
              "y": -17.189,
              "z": 0.901
            },
            "gtin": "4013200882914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5572",
            "leftCorner": {
              "x": -12.328,
              "y": -17.184,
              "z": 0.901
            },
            "rightCorner": {
              "x": -12.194,
              "y": -17.186,
              "z": 0.901
            },
            "gtin": "4013200882921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5573",
            "leftCorner": {
              "x": -12.194,
              "y": -17.182,
              "z": 0.901
            },
            "rightCorner": {
              "x": -12.069,
              "y": -17.182,
              "z": 0.901
            },
            "gtin": "4013200885113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5574",
            "leftCorner": {
              "x": -12.069,
              "y": -17.177,
              "z": 0.901
            },
            "rightCorner": {
              "x": -11.991,
              "y": -17.177,
              "z": 0.901
            },
            "gtin": "4013200888510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5575",
            "leftCorner": {
              "x": -11.991,
              "y": -17.175,
              "z": 0.901
            },
            "rightCorner": {
              "x": -11.91,
              "y": -17.176,
              "z": 0.901
            },
            "gtin": "4013200888503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d556c",
            "leftCorner": {
              "x": -11.91,
              "y": -17.176,
              "z": 0.901
            },
            "rightCorner": {
              "x": -11.861,
              "y": -17.177,
              "z": 0.901
            },
            "gtin": "4013200888503",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf27",
        "height": 1.3779,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5585",
            "leftCorner": {
              "x": -12.862,
              "y": -17.223,
              "z": 1.127
            },
            "rightCorner": {
              "x": -12.69,
              "y": -17.224,
              "z": 1.127
            },
            "gtin": "4013200882563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5587",
            "leftCorner": {
              "x": -12.689,
              "y": -17.189,
              "z": 1.127
            },
            "rightCorner": {
              "x": -12.58,
              "y": -17.19,
              "z": 1.127
            },
            "gtin": "4013200882525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5588",
            "leftCorner": {
              "x": -12.58,
              "y": -17.19,
              "z": 1.127
            },
            "rightCorner": {
              "x": -12.458,
              "y": -17.191,
              "z": 1.127
            },
            "gtin": "4013200882594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5589",
            "leftCorner": {
              "x": -12.458,
              "y": -17.191,
              "z": 1.127
            },
            "rightCorner": {
              "x": -12.331,
              "y": -17.192,
              "z": 1.127
            },
            "gtin": "4013200882617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d558a",
            "leftCorner": {
              "x": -12.331,
              "y": -17.187,
              "z": 1.127
            },
            "rightCorner": {
              "x": -12.217,
              "y": -17.187,
              "z": 1.127
            },
            "gtin": "4013200882624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d558b",
            "leftCorner": {
              "x": -12.217,
              "y": -17.186,
              "z": 1.127
            },
            "rightCorner": {
              "x": -12.128,
              "y": -17.187,
              "z": 1.127
            },
            "gtin": "4013200882648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d558c",
            "leftCorner": {
              "x": -12.128,
              "y": -17.188,
              "z": 1.127
            },
            "rightCorner": {
              "x": -12.029,
              "y": -17.189,
              "z": 1.127
            },
            "gtin": "4013200882655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d558d",
            "leftCorner": {
              "x": -12.029,
              "y": -17.184,
              "z": 1.127
            },
            "rightCorner": {
              "x": -11.938,
              "y": -17.185,
              "z": 1.127
            },
            "gtin": "4013200882679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5586",
            "leftCorner": {
              "x": -11.938,
              "y": -17.185,
              "z": 1.127
            },
            "rightCorner": {
              "x": -11.861,
              "y": -17.186,
              "z": 1.127
            },
            "gtin": "4013200882662",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf23",
        "height": 1.6031,
        "facings": [
          {
            "id": "68d8e508e1820c81800d5560",
            "leftCorner": {
              "x": -12.862,
              "y": -17.227,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.791,
              "y": -17.228,
              "z": 1.312
            },
            "gtin": "4013200881900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5562",
            "leftCorner": {
              "x": -12.79,
              "y": -17.192,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.756,
              "y": -17.192,
              "z": 1.312
            },
            "gtin": "4013200881894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5563",
            "leftCorner": {
              "x": -12.756,
              "y": -17.192,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.716,
              "y": -17.192,
              "z": 1.312
            },
            "gtin": "4013200881962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5564",
            "leftCorner": {
              "x": -12.716,
              "y": -17.188,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.678,
              "y": -17.188,
              "z": 1.312
            },
            "gtin": "4013200881955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5565",
            "leftCorner": {
              "x": -12.678,
              "y": -17.191,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.601,
              "y": -17.192,
              "z": 1.312
            },
            "gtin": "4013200881887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5566",
            "leftCorner": {
              "x": -12.599,
              "y": -16.991,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.528,
              "y": -16.992,
              "z": 1.312
            },
            "gtin": "4013200885038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5567",
            "leftCorner": {
              "x": -12.529,
              "y": -17.196,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.299,
              "y": -17.198,
              "z": 1.312
            },
            "gtin": "4013200880613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5568",
            "leftCorner": {
              "x": -12.299,
              "y": -17.187,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.161,
              "y": -17.187,
              "z": 1.312
            },
            "gtin": "4013200882204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5569",
            "leftCorner": {
              "x": -12.161,
              "y": -17.189,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.068,
              "y": -17.189,
              "z": 1.312
            },
            "gtin": "4013200882266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d556a",
            "leftCorner": {
              "x": -12.068,
              "y": -17.188,
              "z": 1.312
            },
            "rightCorner": {
              "x": -11.946,
              "y": -17.19,
              "z": 1.312
            },
            "gtin": "4013200881979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5561",
            "leftCorner": {
              "x": -11.944,
              "y": -16.941,
              "z": 1.312
            },
            "rightCorner": {
              "x": -11.859,
              "y": -16.942,
              "z": 1.312
            },
            "gtin": "4013200882228",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf26",
        "height": 1.7562,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5580",
            "leftCorner": {
              "x": -12.861,
              "y": -17.192,
              "z": 1.437
            },
            "rightCorner": {
              "x": -12.771,
              "y": -17.193,
              "z": 1.437
            },
            "gtin": "4013200882198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5582",
            "leftCorner": {
              "x": -12.771,
              "y": -17.148,
              "z": 1.437
            },
            "rightCorner": {
              "x": -12.737,
              "y": -17.148,
              "z": 1.437
            },
            "gtin": "4013200881115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5583",
            "leftCorner": {
              "x": -12.737,
              "y": -17.153,
              "z": 1.437
            },
            "rightCorner": {
              "x": -12.704,
              "y": -17.153,
              "z": 1.437
            },
            "gtin": "4013200882013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5584",
            "leftCorner": {
              "x": -12.704,
              "y": -17.154,
              "z": 1.437
            },
            "rightCorner": {
              "x": -12.665,
              "y": -17.153,
              "z": 1.437
            },
            "gtin": "4013200882006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5581",
            "leftCorner": {
              "x": -12.665,
              "y": -17.148,
              "z": 1.437
            },
            "rightCorner": {
              "x": -11.861,
              "y": -17.155,
              "z": 1.437
            },
            "gtin": "4013200881795",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "7f9",
    "name": "7f9",
    "x": -11.033,
    "y": -18.903,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 7.854E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 105
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf44",
        "height": 0.16649,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5657",
            "leftCorner": {
              "x": -11.034,
              "y": -18.843,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.082,
              "y": -18.843,
              "z": 0.136
            },
            "gtin": "4002674045550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5659",
            "leftCorner": {
              "x": -11.083,
              "y": -18.892,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.154,
              "y": -18.892,
              "z": 0.136
            },
            "gtin": "4002674045802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d565a",
            "leftCorner": {
              "x": -11.154,
              "y": -18.89,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.21,
              "y": -18.89,
              "z": 0.136
            },
            "gtin": "4002674046465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d565b",
            "leftCorner": {
              "x": -11.209,
              "y": -18.882,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.253,
              "y": -18.882,
              "z": 0.136
            },
            "gtin": "4002674045864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d565c",
            "leftCorner": {
              "x": -11.253,
              "y": -18.887,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.312,
              "y": -18.887,
              "z": 0.136
            },
            "gtin": "4002674045888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d565d",
            "leftCorner": {
              "x": -11.312,
              "y": -18.887,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.344,
              "y": -18.887,
              "z": 0.136
            },
            "gtin": "4002674045932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d565e",
            "leftCorner": {
              "x": -11.344,
              "y": -18.882,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.394,
              "y": -18.882,
              "z": 0.136
            },
            "gtin": "4002674046007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d565f",
            "leftCorner": {
              "x": -11.394,
              "y": -18.864,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.473,
              "y": -18.864,
              "z": 0.136
            },
            "gtin": "4002674046151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5660",
            "leftCorner": {
              "x": -11.473,
              "y": -18.852,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.533,
              "y": -18.852,
              "z": 0.136
            },
            "gtin": "4002674046182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5661",
            "leftCorner": {
              "x": -11.533,
              "y": -18.852,
              "z": 0.136
            },
            "rightCorner": {
              "x": -11.727,
              "y": -18.852,
              "z": 0.136
            },
            "gtin": "4002674046359",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf45",
        "height": 0.37195,
        "facings": [
          {
            "id": "68d8e509e1820c81800d566d",
            "leftCorner": {
              "x": -11.033,
              "y": -18.895,
              "z": 0.304
            },
            "rightCorner": {
              "x": -11.124,
              "y": -18.895,
              "z": 0.304
            },
            "gtin": "4002674044713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d566f",
            "leftCorner": {
              "x": -11.124,
              "y": -18.925,
              "z": 0.304
            },
            "rightCorner": {
              "x": -11.182,
              "y": -18.925,
              "z": 0.304
            },
            "gtin": "4002674044744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5670",
            "leftCorner": {
              "x": -11.182,
              "y": -18.922,
              "z": 0.304
            },
            "rightCorner": {
              "x": -11.23,
              "y": -18.922,
              "z": 0.304
            },
            "gtin": "4002674044935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5671",
            "leftCorner": {
              "x": -11.23,
              "y": -18.953,
              "z": 0.304
            },
            "rightCorner": {
              "x": -11.282,
              "y": -18.952,
              "z": 0.304
            },
            "gtin": "4002674044959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5672",
            "leftCorner": {
              "x": -11.282,
              "y": -18.948,
              "z": 0.304
            },
            "rightCorner": {
              "x": -11.329,
              "y": -18.948,
              "z": 0.304
            },
            "gtin": "4002674044966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5673",
            "leftCorner": {
              "x": -11.329,
              "y": -18.92,
              "z": 0.304
            },
            "rightCorner": {
              "x": -11.367,
              "y": -18.92,
              "z": 0.304
            },
            "gtin": "4002674045000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5674",
            "leftCorner": {
              "x": -11.367,
              "y": -18.919,
              "z": 0.304
            },
            "rightCorner": {
              "x": -11.407,
              "y": -18.92,
              "z": 0.304
            },
            "gtin": "4002674045154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5675",
            "leftCorner": {
              "x": -11.42,
              "y": -18.937,
              "z": 0.304
            },
            "rightCorner": {
              "x": -11.48,
              "y": -18.937,
              "z": 0.304
            },
            "gtin": "4002674043501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5676",
            "leftCorner": {
              "x": -11.48,
              "y": -18.937,
              "z": 0.304
            },
            "rightCorner": {
              "x": -11.541,
              "y": -18.937,
              "z": 0.304
            },
            "gtin": "4002674045307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5677",
            "leftCorner": {
              "x": -11.541,
              "y": -18.935,
              "z": 0.304
            },
            "rightCorner": {
              "x": -11.585,
              "y": -18.935,
              "z": 0.304
            },
            "gtin": "4002674045321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d566e",
            "leftCorner": {
              "x": -11.585,
              "y": -18.934,
              "z": 0.304
            },
            "rightCorner": {
              "x": -11.664,
              "y": -18.934,
              "z": 0.304
            },
            "gtin": "4002674045451",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf48",
        "height": 0.52455,
        "facings": [
          {
            "id": "68d8e509e1820c81800d568f",
            "leftCorner": {
              "x": -11.033,
              "y": -18.888,
              "z": 0.429
            },
            "rightCorner": {
              "x": -11.1,
              "y": -18.887,
              "z": 0.429
            },
            "gtin": "4002674044379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5691",
            "leftCorner": {
              "x": -11.099,
              "y": -18.933,
              "z": 0.429
            },
            "rightCorner": {
              "x": -11.17,
              "y": -18.933,
              "z": 0.429
            },
            "gtin": "4002674044676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5692",
            "leftCorner": {
              "x": -11.17,
              "y": -18.912,
              "z": 0.429
            },
            "rightCorner": {
              "x": -11.225,
              "y": -18.912,
              "z": 0.429
            },
            "gtin": "4002674044775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5693",
            "leftCorner": {
              "x": -11.225,
              "y": -18.931,
              "z": 0.429
            },
            "rightCorner": {
              "x": -11.273,
              "y": -18.932,
              "z": 0.429
            },
            "gtin": "4002674044720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5694",
            "leftCorner": {
              "x": -11.273,
              "y": -18.928,
              "z": 0.429
            },
            "rightCorner": {
              "x": -11.332,
              "y": -18.928,
              "z": 0.429
            },
            "gtin": "4002674044621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5695",
            "leftCorner": {
              "x": -11.332,
              "y": -18.93,
              "z": 0.429
            },
            "rightCorner": {
              "x": -11.413,
              "y": -18.929,
              "z": 0.429
            },
            "gtin": "4002674044607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5696",
            "leftCorner": {
              "x": -11.413,
              "y": -18.928,
              "z": 0.429
            },
            "rightCorner": {
              "x": -11.439,
              "y": -18.929,
              "z": 0.429
            },
            "gtin": "4002674045512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5697",
            "leftCorner": {
              "x": -11.439,
              "y": -18.894,
              "z": 0.429
            },
            "rightCorner": {
              "x": -11.487,
              "y": -18.894,
              "z": 0.429
            },
            "gtin": "4002674044799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5698",
            "leftCorner": {
              "x": -11.487,
              "y": -18.897,
              "z": 0.429
            },
            "rightCorner": {
              "x": -11.558,
              "y": -18.897,
              "z": 0.429
            },
            "gtin": "4002674044850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5690",
            "leftCorner": {
              "x": -11.557,
              "y": -18.9,
              "z": 0.429
            },
            "rightCorner": {
              "x": -11.663,
              "y": -18.9,
              "z": 0.429
            },
            "gtin": "4002674044874",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf43",
        "height": 0.69973,
        "facings": [
          {
            "id": "68d8e509e1820c81800d564e",
            "leftCorner": {
              "x": -11.034,
              "y": -18.883,
              "z": 0.573
            },
            "rightCorner": {
              "x": -11.077,
              "y": -18.883,
              "z": 0.573
            },
            "gtin": "4002674043709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5650",
            "leftCorner": {
              "x": -11.077,
              "y": -18.927,
              "z": 0.573
            },
            "rightCorner": {
              "x": -11.167,
              "y": -18.927,
              "z": 0.573
            },
            "gtin": "4002674043822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5651",
            "leftCorner": {
              "x": -11.167,
              "y": -18.929,
              "z": 0.573
            },
            "rightCorner": {
              "x": -11.205,
              "y": -18.929,
              "z": 0.573
            },
            "gtin": "4002674043907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5652",
            "leftCorner": {
              "x": -11.205,
              "y": -18.924,
              "z": 0.573
            },
            "rightCorner": {
              "x": -11.277,
              "y": -18.925,
              "z": 0.573
            },
            "gtin": "4002674043952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5653",
            "leftCorner": {
              "x": -11.277,
              "y": -18.925,
              "z": 0.573
            },
            "rightCorner": {
              "x": -11.349,
              "y": -18.925,
              "z": 0.573
            },
            "gtin": "4002674043952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5654",
            "leftCorner": {
              "x": -11.349,
              "y": -18.923,
              "z": 0.573
            },
            "rightCorner": {
              "x": -11.409,
              "y": -18.924,
              "z": 0.573
            },
            "gtin": "4002674044072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5655",
            "leftCorner": {
              "x": -11.409,
              "y": -18.924,
              "z": 0.573
            },
            "rightCorner": {
              "x": -11.471,
              "y": -18.923,
              "z": 0.573
            },
            "gtin": "4002674044072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5656",
            "leftCorner": {
              "x": -11.471,
              "y": -18.896,
              "z": 0.573
            },
            "rightCorner": {
              "x": -11.518,
              "y": -18.897,
              "z": 0.573
            },
            "gtin": "4002674044157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d564f",
            "leftCorner": {
              "x": -11.518,
              "y": -18.897,
              "z": 0.573
            },
            "rightCorner": {
              "x": -11.663,
              "y": -18.897,
              "z": 0.573
            },
            "gtin": "4002674044119",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf47",
        "height": 0.87601,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5684",
            "leftCorner": {
              "x": -11.034,
              "y": -18.887,
              "z": 0.717
            },
            "rightCorner": {
              "x": -11.118,
              "y": -18.886,
              "z": 0.717
            },
            "gtin": "4002674043181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5688",
            "leftCorner": {
              "x": -11.117,
              "y": -18.933,
              "z": 0.717
            },
            "rightCorner": {
              "x": -11.166,
              "y": -18.934,
              "z": 0.717
            },
            "gtin": "4002674043174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5689",
            "leftCorner": {
              "x": -11.166,
              "y": -18.933,
              "z": 0.717
            },
            "rightCorner": {
              "x": -11.213,
              "y": -18.933,
              "z": 0.717
            },
            "gtin": "4002674043228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d568a",
            "leftCorner": {
              "x": -11.212,
              "y": -18.926,
              "z": 0.717
            },
            "rightCorner": {
              "x": -11.298,
              "y": -18.926,
              "z": 0.717
            },
            "gtin": "4002674041910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d568b",
            "leftCorner": {
              "x": -11.298,
              "y": -18.928,
              "z": 0.717
            },
            "rightCorner": {
              "x": -11.339,
              "y": -18.928,
              "z": 0.717
            },
            "gtin": "4002674043259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d568c",
            "leftCorner": {
              "x": -11.339,
              "y": -18.927,
              "z": 0.717
            },
            "rightCorner": {
              "x": -11.387,
              "y": -18.927,
              "z": 0.717
            },
            "gtin": "4002674043273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d568d",
            "leftCorner": {
              "x": -11.388,
              "y": -18.92,
              "z": 0.717
            },
            "rightCorner": {
              "x": -11.458,
              "y": -18.92,
              "z": 0.717
            },
            "gtin": "4002674041927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d568e",
            "leftCorner": {
              "x": -11.457,
              "y": -18.896,
              "z": 0.717
            },
            "rightCorner": {
              "x": -11.523,
              "y": -18.896,
              "z": 0.717
            },
            "gtin": "4002674043440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5685",
            "leftCorner": {
              "x": -11.523,
              "y": -18.896,
              "z": 0.717
            },
            "rightCorner": {
              "x": -11.57,
              "y": -18.896,
              "z": 0.717
            },
            "gtin": "4002674043600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5686",
            "leftCorner": {
              "x": -11.57,
              "y": -18.896,
              "z": 0.717
            },
            "rightCorner": {
              "x": -11.616,
              "y": -18.895,
              "z": 0.717
            },
            "gtin": "4002674043600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5687",
            "leftCorner": {
              "x": -11.616,
              "y": -18.895,
              "z": 0.717
            },
            "rightCorner": {
              "x": -11.663,
              "y": -18.896,
              "z": 0.717
            },
            "gtin": "4002674043600",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf46",
        "height": 1.0532,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5678",
            "leftCorner": {
              "x": -11.034,
              "y": -18.883,
              "z": 0.862
            },
            "rightCorner": {
              "x": -11.081,
              "y": -18.883,
              "z": 0.862
            },
            "gtin": "4002674042702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d567a",
            "leftCorner": {
              "x": -11.081,
              "y": -18.931,
              "z": 0.862
            },
            "rightCorner": {
              "x": -11.122,
              "y": -18.93,
              "z": 0.862
            },
            "gtin": "4002674042764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d567b",
            "leftCorner": {
              "x": -11.122,
              "y": -18.93,
              "z": 0.862
            },
            "rightCorner": {
              "x": -11.155,
              "y": -18.931,
              "z": 0.862
            },
            "gtin": "4002674042764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d567c",
            "leftCorner": {
              "x": -11.155,
              "y": -18.914,
              "z": 0.862
            },
            "rightCorner": {
              "x": -11.213,
              "y": -18.914,
              "z": 0.862
            },
            "gtin": "4002674288438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d567d",
            "leftCorner": {
              "x": -11.212,
              "y": -18.924,
              "z": 0.862
            },
            "rightCorner": {
              "x": -11.255,
              "y": -18.924,
              "z": 0.862
            },
            "gtin": "4002674043075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d567e",
            "leftCorner": {
              "x": -11.255,
              "y": -18.923,
              "z": 0.862
            },
            "rightCorner": {
              "x": -11.329,
              "y": -18.923,
              "z": 0.862
            },
            "gtin": "4002674043082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d567f",
            "leftCorner": {
              "x": -11.329,
              "y": -18.924,
              "z": 0.862
            },
            "rightCorner": {
              "x": -11.39,
              "y": -18.924,
              "z": 0.862
            },
            "gtin": "4002674043136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5680",
            "leftCorner": {
              "x": -11.39,
              "y": -18.923,
              "z": 0.862
            },
            "rightCorner": {
              "x": -11.437,
              "y": -18.923,
              "z": 0.862
            },
            "gtin": "4002674043112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5681",
            "leftCorner": {
              "x": -11.438,
              "y": -18.909,
              "z": 0.862
            },
            "rightCorner": {
              "x": -11.512,
              "y": -18.909,
              "z": 0.862
            },
            "gtin": "4002674041774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5682",
            "leftCorner": {
              "x": -11.512,
              "y": -18.894,
              "z": 0.862
            },
            "rightCorner": {
              "x": -11.555,
              "y": -18.895,
              "z": 0.862
            },
            "gtin": "4002674043167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5683",
            "leftCorner": {
              "x": -11.555,
              "y": -18.895,
              "z": 0.862
            },
            "rightCorner": {
              "x": -11.598,
              "y": -18.895,
              "z": 0.862
            },
            "gtin": "4002674043167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5679",
            "leftCorner": {
              "x": -11.598,
              "y": -18.901,
              "z": 0.862
            },
            "rightCorner": {
              "x": -11.663,
              "y": -18.901,
              "z": 0.862
            },
            "gtin": "4002674043150",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf40",
        "height": 1.2332,
        "facings": [
          {
            "id": "68d8e509e1820c81800d561b",
            "leftCorner": {
              "x": -11.034,
              "y": -18.882,
              "z": 1.009
            },
            "rightCorner": {
              "x": -11.081,
              "y": -18.882,
              "z": 1.009
            },
            "gtin": "4002674041484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d561d",
            "leftCorner": {
              "x": -11.081,
              "y": -18.937,
              "z": 1.009
            },
            "rightCorner": {
              "x": -11.128,
              "y": -18.937,
              "z": 1.009
            },
            "gtin": "4002674041637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d561e",
            "leftCorner": {
              "x": -11.128,
              "y": -18.936,
              "z": 1.009
            },
            "rightCorner": {
              "x": -11.211,
              "y": -18.936,
              "z": 1.009
            },
            "gtin": "4002674042047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d561f",
            "leftCorner": {
              "x": -11.212,
              "y": -18.933,
              "z": 1.009
            },
            "rightCorner": {
              "x": -11.245,
              "y": -18.933,
              "z": 1.009
            },
            "gtin": "4002674045789",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5620",
            "leftCorner": {
              "x": -11.245,
              "y": -18.92,
              "z": 1.009
            },
            "rightCorner": {
              "x": -11.306,
              "y": -18.92,
              "z": 1.009
            },
            "gtin": "4002674042108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5621",
            "leftCorner": {
              "x": -11.307,
              "y": -18.932,
              "z": 1.009
            },
            "rightCorner": {
              "x": -11.355,
              "y": -18.932,
              "z": 1.009
            },
            "gtin": "4002674042252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5622",
            "leftCorner": {
              "x": -11.356,
              "y": -18.929,
              "z": 1.009
            },
            "rightCorner": {
              "x": -11.381,
              "y": -18.929,
              "z": 1.009
            },
            "gtin": "4002674042382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5623",
            "leftCorner": {
              "x": -11.381,
              "y": -18.892,
              "z": 1.009
            },
            "rightCorner": {
              "x": -11.433,
              "y": -18.893,
              "z": 1.009
            },
            "gtin": "4002674042375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5624",
            "leftCorner": {
              "x": -11.434,
              "y": -18.895,
              "z": 1.009
            },
            "rightCorner": {
              "x": -11.471,
              "y": -18.895,
              "z": 1.009
            },
            "gtin": "4002674042450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5625",
            "leftCorner": {
              "x": -11.471,
              "y": -18.894,
              "z": 1.009
            },
            "rightCorner": {
              "x": -11.521,
              "y": -18.895,
              "z": 1.009
            },
            "gtin": "4002674042559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5626",
            "leftCorner": {
              "x": -11.521,
              "y": -18.895,
              "z": 1.009
            },
            "rightCorner": {
              "x": -11.599,
              "y": -18.895,
              "z": 1.009
            },
            "gtin": "4002674042658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d561c",
            "leftCorner": {
              "x": -11.6,
              "y": -18.9,
              "z": 1.009
            },
            "rightCorner": {
              "x": -11.663,
              "y": -18.899,
              "z": 1.009
            },
            "gtin": "4002674042665",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf3f",
        "height": 1.3833,
        "facings": [
          {
            "id": "68d8e509e1820c81800d560d",
            "leftCorner": {
              "x": -11.033,
              "y": -18.876,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.085,
              "y": -18.876,
              "z": 1.132
            },
            "gtin": "4002674041071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d560f",
            "leftCorner": {
              "x": -11.084,
              "y": -18.927,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.133,
              "y": -18.926,
              "z": 1.132
            },
            "gtin": "4002674041095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5610",
            "leftCorner": {
              "x": -11.132,
              "y": -18.923,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.178,
              "y": -18.923,
              "z": 1.132
            },
            "gtin": "4002674041156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5611",
            "leftCorner": {
              "x": -11.178,
              "y": -18.921,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.217,
              "y": -18.922,
              "z": 1.132
            },
            "gtin": "4002674041200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5612",
            "leftCorner": {
              "x": -11.217,
              "y": -18.921,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.265,
              "y": -18.92,
              "z": 1.132
            },
            "gtin": "4002674041309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5613",
            "leftCorner": {
              "x": -11.264,
              "y": -18.919,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.31,
              "y": -18.919,
              "z": 1.132
            },
            "gtin": "4002674041323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5614",
            "leftCorner": {
              "x": -11.31,
              "y": -18.916,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.348,
              "y": -18.917,
              "z": 1.132
            },
            "gtin": "4002674041347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5615",
            "leftCorner": {
              "x": -11.348,
              "y": -18.916,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.378,
              "y": -18.916,
              "z": 1.132
            },
            "gtin": "4002674041347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5616",
            "leftCorner": {
              "x": -11.378,
              "y": -18.892,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.434,
              "y": -18.891,
              "z": 1.132
            },
            "gtin": "4002674041361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5617",
            "leftCorner": {
              "x": -11.435,
              "y": -18.909,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.468,
              "y": -18.909,
              "z": 1.132
            },
            "gtin": "4002674041491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5618",
            "leftCorner": {
              "x": -11.469,
              "y": -18.891,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.513,
              "y": -18.891,
              "z": 1.132
            },
            "gtin": "4002674041446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5619",
            "leftCorner": {
              "x": -11.513,
              "y": -18.893,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.553,
              "y": -18.894,
              "z": 1.132
            },
            "gtin": "4002674041507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d561a",
            "leftCorner": {
              "x": -11.553,
              "y": -18.894,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.592,
              "y": -18.894,
              "z": 1.132
            },
            "gtin": "4002674041507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d560e",
            "leftCorner": {
              "x": -11.591,
              "y": -18.899,
              "z": 1.132
            },
            "rightCorner": {
              "x": -11.663,
              "y": -18.899,
              "z": 1.132
            },
            "gtin": "4002674041453",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf41",
        "height": 1.5317,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5627",
            "leftCorner": {
              "x": -11.033,
              "y": -18.88,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.11,
              "y": -18.88,
              "z": 1.253
            },
            "gtin": "4002674184334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5629",
            "leftCorner": {
              "x": -11.11,
              "y": -18.924,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.164,
              "y": -18.924,
              "z": 1.253
            },
            "gtin": "4002674184341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d562a",
            "leftCorner": {
              "x": -11.164,
              "y": -18.923,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.219,
              "y": -18.923,
              "z": 1.253
            },
            "gtin": "4002674184358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d562b",
            "leftCorner": {
              "x": -11.219,
              "y": -18.92,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.288,
              "y": -18.921,
              "z": 1.253
            },
            "gtin": "4002674184372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d562c",
            "leftCorner": {
              "x": -11.288,
              "y": -18.922,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.337,
              "y": -18.922,
              "z": 1.253
            },
            "gtin": "4002674184402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d562d",
            "leftCorner": {
              "x": -11.337,
              "y": -18.92,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.391,
              "y": -18.92,
              "z": 1.253
            },
            "gtin": "4002674184396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d562e",
            "leftCorner": {
              "x": -11.391,
              "y": -18.919,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.445,
              "y": -18.918,
              "z": 1.253
            },
            "gtin": "4002674184419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d562f",
            "leftCorner": {
              "x": -11.445,
              "y": -18.904,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.497,
              "y": -18.905,
              "z": 1.253
            },
            "gtin": "4002674184426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5630",
            "leftCorner": {
              "x": -11.497,
              "y": -18.893,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.594,
              "y": -18.893,
              "z": 1.253
            },
            "gtin": "4002674184433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5631",
            "leftCorner": {
              "x": -11.593,
              "y": -18.899,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.725,
              "y": -18.899,
              "z": 1.253
            },
            "gtin": "4002674184440",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf42",
        "height": 1.7057,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5644",
            "leftCorner": {
              "x": -11.034,
              "y": -18.883,
              "z": 1.396
            },
            "rightCorner": {
              "x": -11.114,
              "y": -18.883,
              "z": 1.396
            },
            "gtin": "4002674184204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fae3a06455288718f6da5dcf",
            "leftCorner": {
              "x": -11.579,
              "y": -18.884,
              "z": 1.396
            },
            "rightCorner": {
              "x": -11.65,
              "y": -18.884,
              "z": 1.396
            },
            "gtin": "4002674184297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5646",
            "leftCorner": {
              "x": -11.115,
              "y": -18.931,
              "z": 1.396
            },
            "rightCorner": {
              "x": -11.169,
              "y": -18.931,
              "z": 1.396
            },
            "gtin": "4002674184211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5647",
            "leftCorner": {
              "x": -11.169,
              "y": -18.929,
              "z": 1.396
            },
            "rightCorner": {
              "x": -11.219,
              "y": -18.928,
              "z": 1.396
            },
            "gtin": "4002674184228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5648",
            "leftCorner": {
              "x": -11.218,
              "y": -18.925,
              "z": 1.396
            },
            "rightCorner": {
              "x": -11.277,
              "y": -18.926,
              "z": 1.396
            },
            "gtin": "4002674184235",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d5649",
            "leftCorner": {
              "x": -11.277,
              "y": -18.923,
              "z": 1.396
            },
            "rightCorner": {
              "x": -11.339,
              "y": -18.922,
              "z": 1.396
            },
            "gtin": "4002674184242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d564a",
            "leftCorner": {
              "x": -11.34,
              "y": -18.924,
              "z": 1.396
            },
            "rightCorner": {
              "x": -11.389,
              "y": -18.924,
              "z": 1.396
            },
            "gtin": "4002674184259",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d564b",
            "leftCorner": {
              "x": -11.389,
              "y": -18.919,
              "z": 1.396
            },
            "rightCorner": {
              "x": -11.441,
              "y": -18.918,
              "z": 1.396
            },
            "gtin": "4002674184273",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d564c",
            "leftCorner": {
              "x": -11.441,
              "y": -18.896,
              "z": 1.396
            },
            "rightCorner": {
              "x": -11.495,
              "y": -18.896,
              "z": 1.396
            },
            "gtin": "4002674184280",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d564d",
            "leftCorner": {
              "x": -11.495,
              "y": -18.897,
              "z": 1.396
            },
            "rightCorner": {
              "x": -11.579,
              "y": -18.896,
              "z": 1.396
            },
            "gtin": "4002674184297",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "7fa"
  },
  {
    "id": "7fa",
    "name": "7fa",
    "x": -11.658,
    "y": -18.904,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 7.854E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 63
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf4e",
        "height": 0.16468,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5662",
            "leftCorner": {
              "x": -11.721,
              "y": -18.864,
              "z": 0.135
            },
            "rightCorner": {
              "x": -11.763,
              "y": -18.864,
              "z": 0.135
            },
            "gtin": "4002674074956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "59ae3a82a779035f71e107d7",
            "leftCorner": {
              "x": -11.658,
              "y": -18.826,
              "z": 0.135
            },
            "rightCorner": {
              "x": -11.719,
              "y": -18.826,
              "z": 0.135
            },
            "gtin": "4002674076004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5663",
            "leftCorner": {
              "x": -11.763,
              "y": -18.864,
              "z": 0.135
            },
            "rightCorner": {
              "x": -11.819,
              "y": -18.864,
              "z": 0.135
            },
            "gtin": "4002674079135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5664",
            "leftCorner": {
              "x": -11.819,
              "y": -18.868,
              "z": 0.135
            },
            "rightCorner": {
              "x": -11.876,
              "y": -18.868,
              "z": 0.135
            },
            "gtin": "4002674075458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5665",
            "leftCorner": {
              "x": -11.876,
              "y": -18.868,
              "z": 0.135
            },
            "rightCorner": {
              "x": -11.904,
              "y": -18.868,
              "z": 0.135
            },
            "gtin": "4002674075809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5666",
            "leftCorner": {
              "x": -11.904,
              "y": -18.867,
              "z": 0.135
            },
            "rightCorner": {
              "x": -11.956,
              "y": -18.867,
              "z": 0.135
            },
            "gtin": "4002674075519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5667",
            "leftCorner": {
              "x": -11.956,
              "y": -18.864,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.016,
              "y": -18.864,
              "z": 0.135
            },
            "gtin": "4002674076158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5668",
            "leftCorner": {
              "x": -12.016,
              "y": -18.866,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.116,
              "y": -18.866,
              "z": 0.135
            },
            "gtin": "4002674076158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5669",
            "leftCorner": {
              "x": -12.116,
              "y": -18.863,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.21,
              "y": -18.864,
              "z": 0.135
            },
            "gtin": "4002674071559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d566a",
            "leftCorner": {
              "x": -12.21,
              "y": -18.858,
              "z": 0.135
            },
            "rightCorner": {
              "x": -12.36,
              "y": -18.858,
              "z": 0.135
            },
            "gtin": "4002674076356",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf4a",
        "height": 0.41854,
        "facings": [
          {
            "id": "68d8e509e1820c81800d56b4",
            "leftCorner": {
              "x": -11.658,
              "y": -18.862,
              "z": 0.342
            },
            "rightCorner": {
              "x": -11.747,
              "y": -18.862,
              "z": 0.342
            },
            "gtin": "4002674074116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1f893b28e4614696493f8e0f",
            "leftCorner": {
              "x": -11.888,
              "y": -18.862,
              "z": 0.342
            },
            "rightCorner": {
              "x": -11.993,
              "y": -18.863,
              "z": 0.342
            },
            "gtin": "4002674074901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56b6",
            "leftCorner": {
              "x": -11.747,
              "y": -18.917,
              "z": 0.342
            },
            "rightCorner": {
              "x": -11.8,
              "y": -18.917,
              "z": 0.342
            },
            "gtin": "4002674074376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56b7",
            "leftCorner": {
              "x": -11.8,
              "y": -18.9,
              "z": 0.342
            },
            "rightCorner": {
              "x": -11.888,
              "y": -18.9,
              "z": 0.342
            },
            "gtin": "4002674074666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56b9",
            "leftCorner": {
              "x": -11.998,
              "y": -18.906,
              "z": 0.342
            },
            "rightCorner": {
              "x": -12.066,
              "y": -18.906,
              "z": 0.342
            },
            "gtin": "4002674054729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ba",
            "leftCorner": {
              "x": -12.066,
              "y": -18.899,
              "z": 0.342
            },
            "rightCorner": {
              "x": -12.15,
              "y": -18.9,
              "z": 0.342
            },
            "gtin": "4002674074482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56bb",
            "leftCorner": {
              "x": -12.15,
              "y": -18.906,
              "z": 0.342
            },
            "rightCorner": {
              "x": -12.217,
              "y": -18.906,
              "z": 0.342
            },
            "gtin": "4002674074901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56bc",
            "leftCorner": {
              "x": -12.217,
              "y": -18.907,
              "z": 0.342
            },
            "rightCorner": {
              "x": -12.316,
              "y": -18.907,
              "z": 0.342
            },
            "gtin": "4002674074987",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf49",
        "height": 0.63964,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5699",
            "leftCorner": {
              "x": -11.658,
              "y": -18.854,
              "z": 0.523
            },
            "rightCorner": {
              "x": -11.762,
              "y": -18.854,
              "z": 0.523
            },
            "gtin": "4002674073133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d569b",
            "leftCorner": {
              "x": -11.762,
              "y": -18.896,
              "z": 0.523
            },
            "rightCorner": {
              "x": -11.897,
              "y": -18.896,
              "z": 0.523
            },
            "gtin": "4002674073188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d569c",
            "leftCorner": {
              "x": -11.897,
              "y": -18.893,
              "z": 0.523
            },
            "rightCorner": {
              "x": -11.994,
              "y": -18.893,
              "z": 0.523
            },
            "gtin": "4002674073249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d569d",
            "leftCorner": {
              "x": -11.994,
              "y": -18.896,
              "z": 0.523
            },
            "rightCorner": {
              "x": -12.075,
              "y": -18.896,
              "z": 0.523
            },
            "gtin": "4002674073607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d569e",
            "leftCorner": {
              "x": -12.075,
              "y": -18.896,
              "z": 0.523
            },
            "rightCorner": {
              "x": -12.156,
              "y": -18.897,
              "z": 0.523
            },
            "gtin": "4002674073607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d569f",
            "leftCorner": {
              "x": -12.156,
              "y": -18.891,
              "z": 0.523
            },
            "rightCorner": {
              "x": -12.324,
              "y": -18.891,
              "z": 0.523
            },
            "gtin": "4002674074079",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf4f",
        "height": 0.85337,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5717",
            "leftCorner": {
              "x": -11.658,
              "y": -18.87,
              "z": 0.698
            },
            "rightCorner": {
              "x": -11.749,
              "y": -18.87,
              "z": 0.698
            },
            "gtin": "4002674071153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5719",
            "leftCorner": {
              "x": -11.749,
              "y": -18.907,
              "z": 0.698
            },
            "rightCorner": {
              "x": -11.806,
              "y": -18.907,
              "z": 0.698
            },
            "gtin": "4002674071306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d571a",
            "leftCorner": {
              "x": -11.806,
              "y": -18.908,
              "z": 0.698
            },
            "rightCorner": {
              "x": -11.903,
              "y": -18.908,
              "z": 0.698
            },
            "gtin": "4002674072693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d571b",
            "leftCorner": {
              "x": -11.903,
              "y": -18.911,
              "z": 0.698
            },
            "rightCorner": {
              "x": -11.952,
              "y": -18.911,
              "z": 0.698
            },
            "gtin": "4002674072044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d571c",
            "leftCorner": {
              "x": -11.952,
              "y": -18.91,
              "z": 0.698
            },
            "rightCorner": {
              "x": -12.008,
              "y": -18.91,
              "z": 0.698
            },
            "gtin": "4002674071450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d571d",
            "leftCorner": {
              "x": -12.008,
              "y": -18.91,
              "z": 0.698
            },
            "rightCorner": {
              "x": -12.058,
              "y": -18.91,
              "z": 0.698
            },
            "gtin": "4002674072259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d571e",
            "leftCorner": {
              "x": -12.058,
              "y": -18.912,
              "z": 0.698
            },
            "rightCorner": {
              "x": -12.116,
              "y": -18.912,
              "z": 0.698
            },
            "gtin": "4002674072105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d571f",
            "leftCorner": {
              "x": -12.116,
              "y": -18.91,
              "z": 0.698
            },
            "rightCorner": {
              "x": -12.173,
              "y": -18.911,
              "z": 0.698
            },
            "gtin": "4002674072600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5720",
            "leftCorner": {
              "x": -12.173,
              "y": -18.911,
              "z": 0.698
            },
            "rightCorner": {
              "x": -12.224,
              "y": -18.911,
              "z": 0.698
            },
            "gtin": "4002674072808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5721",
            "leftCorner": {
              "x": -12.224,
              "y": -18.912,
              "z": 0.698
            },
            "rightCorner": {
              "x": -12.318,
              "y": -18.912,
              "z": 0.698
            },
            "gtin": "4002674072808",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf4c",
        "height": 1.0801,
        "facings": [
          {
            "id": "68d8e509e1820c81800d56cf",
            "leftCorner": {
              "x": -11.658,
              "y": -18.869,
              "z": 0.884
            },
            "rightCorner": {
              "x": -11.807,
              "y": -18.869,
              "z": 0.884
            },
            "gtin": "4002674054651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56d1",
            "leftCorner": {
              "x": -11.807,
              "y": -18.912,
              "z": 0.884
            },
            "rightCorner": {
              "x": -11.857,
              "y": -18.912,
              "z": 0.884
            },
            "gtin": "4002674054675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56d2",
            "leftCorner": {
              "x": -11.857,
              "y": -18.912,
              "z": 0.884
            },
            "rightCorner": {
              "x": -11.954,
              "y": -18.912,
              "z": 0.884
            },
            "gtin": "4002674054699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56d3",
            "leftCorner": {
              "x": -11.954,
              "y": -18.905,
              "z": 0.884
            },
            "rightCorner": {
              "x": -12.008,
              "y": -18.905,
              "z": 0.884
            },
            "gtin": "4002674054859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56d4",
            "leftCorner": {
              "x": -12.008,
              "y": -18.91,
              "z": 0.884
            },
            "rightCorner": {
              "x": -12.057,
              "y": -18.91,
              "z": 0.884
            },
            "gtin": "4002674053746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56d5",
            "leftCorner": {
              "x": -12.057,
              "y": -18.908,
              "z": 0.884
            },
            "rightCorner": {
              "x": -12.111,
              "y": -18.908,
              "z": 0.884
            },
            "gtin": "4002674054859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56d6",
            "leftCorner": {
              "x": -12.111,
              "y": -18.909,
              "z": 0.884
            },
            "rightCorner": {
              "x": -12.16,
              "y": -18.91,
              "z": 0.884
            },
            "gtin": "4002674054989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56d7",
            "leftCorner": {
              "x": -12.16,
              "y": -18.909,
              "z": 0.884
            },
            "rightCorner": {
              "x": -12.203,
              "y": -18.909,
              "z": 0.884
            },
            "gtin": "4002674055863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56d8",
            "leftCorner": {
              "x": -12.203,
              "y": -18.908,
              "z": 0.884
            },
            "rightCorner": {
              "x": -12.317,
              "y": -18.908,
              "z": 0.884
            },
            "gtin": "4002674056150",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf4d",
        "height": 1.3088,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5707",
            "leftCorner": {
              "x": -11.658,
              "y": -18.872,
              "z": 1.071
            },
            "rightCorner": {
              "x": -11.793,
              "y": -18.872,
              "z": 1.071
            },
            "gtin": "4002674053159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5709",
            "leftCorner": {
              "x": -11.793,
              "y": -18.913,
              "z": 1.071
            },
            "rightCorner": {
              "x": -11.832,
              "y": -18.913,
              "z": 1.071
            },
            "gtin": "4002674053227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d570a",
            "leftCorner": {
              "x": -11.832,
              "y": -18.914,
              "z": 1.071
            },
            "rightCorner": {
              "x": -11.9,
              "y": -18.914,
              "z": 1.071
            },
            "gtin": "4002674053463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d570b",
            "leftCorner": {
              "x": -11.9,
              "y": -18.911,
              "z": 1.071
            },
            "rightCorner": {
              "x": -11.944,
              "y": -18.911,
              "z": 1.071
            },
            "gtin": "4002674053258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d570c",
            "leftCorner": {
              "x": -11.944,
              "y": -18.914,
              "z": 1.071
            },
            "rightCorner": {
              "x": -11.994,
              "y": -18.914,
              "z": 1.071
            },
            "gtin": "4002674053258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d570d",
            "leftCorner": {
              "x": -11.994,
              "y": -18.913,
              "z": 1.071
            },
            "rightCorner": {
              "x": -12.041,
              "y": -18.913,
              "z": 1.071
            },
            "gtin": "4002674053197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d570e",
            "leftCorner": {
              "x": -12.041,
              "y": -18.91,
              "z": 1.071
            },
            "rightCorner": {
              "x": -12.092,
              "y": -18.91,
              "z": 1.071
            },
            "gtin": "4002674053821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d570f",
            "leftCorner": {
              "x": -12.092,
              "y": -18.911,
              "z": 1.071
            },
            "rightCorner": {
              "x": -12.151,
              "y": -18.912,
              "z": 1.071
            },
            "gtin": "4002674053906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5710",
            "leftCorner": {
              "x": -12.151,
              "y": -18.909,
              "z": 1.071
            },
            "rightCorner": {
              "x": -12.444,
              "y": -18.91,
              "z": 1.071
            },
            "gtin": "4002674054057",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf4b",
        "height": 1.5332,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5632",
            "leftCorner": {
              "x": -11.719,
              "y": -18.904,
              "z": 1.254
            },
            "rightCorner": {
              "x": -11.792,
              "y": -18.904,
              "z": 1.254
            },
            "gtin": "4002674051407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7af86eaeeefc347c28b2b203",
            "leftCorner": {
              "x": -11.658,
              "y": -18.864,
              "z": 1.254
            },
            "rightCorner": {
              "x": -11.712,
              "y": -18.864,
              "z": 1.254
            },
            "gtin": "4002674052046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5633",
            "leftCorner": {
              "x": -11.792,
              "y": -18.905,
              "z": 1.254
            },
            "rightCorner": {
              "x": -11.83,
              "y": -18.905,
              "z": 1.254
            },
            "gtin": "4002674051506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5634",
            "leftCorner": {
              "x": -11.83,
              "y": -18.905,
              "z": 1.254
            },
            "rightCorner": {
              "x": -11.889,
              "y": -18.905,
              "z": 1.254
            },
            "gtin": "4002674051483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5635",
            "leftCorner": {
              "x": -11.889,
              "y": -18.906,
              "z": 1.254
            },
            "rightCorner": {
              "x": -11.935,
              "y": -18.906,
              "z": 1.254
            },
            "gtin": "4002674051636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5636",
            "leftCorner": {
              "x": -11.935,
              "y": -18.904,
              "z": 1.254
            },
            "rightCorner": {
              "x": -11.993,
              "y": -18.904,
              "z": 1.254
            },
            "gtin": "4002674052114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5637",
            "leftCorner": {
              "x": -11.993,
              "y": -18.904,
              "z": 1.254
            },
            "rightCorner": {
              "x": -12.044,
              "y": -18.904,
              "z": 1.254
            },
            "gtin": "4002674052558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5638",
            "leftCorner": {
              "x": -12.044,
              "y": -18.902,
              "z": 1.254
            },
            "rightCorner": {
              "x": -12.101,
              "y": -18.902,
              "z": 1.254
            },
            "gtin": "4002674052657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5639",
            "leftCorner": {
              "x": -12.101,
              "y": -18.904,
              "z": 1.254
            },
            "rightCorner": {
              "x": -12.154,
              "y": -18.905,
              "z": 1.254
            },
            "gtin": "4002674052763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d563a",
            "leftCorner": {
              "x": -12.154,
              "y": -18.904,
              "z": 1.254
            },
            "rightCorner": {
              "x": -12.198,
              "y": -18.904,
              "z": 1.254
            },
            "gtin": "4002674053135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d563b",
            "leftCorner": {
              "x": -12.198,
              "y": -18.908,
              "z": 1.254
            },
            "rightCorner": {
              "x": -12.325,
              "y": -18.908,
              "z": 1.254
            },
            "gtin": "4002674053135",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7f9",
    "rightNeighborShelfId": "7fb"
  },
  {
    "id": "7fb",
    "name": "7fb",
    "x": -12.283,
    "y": -18.905,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 7.854E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 59
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf57",
        "height": 0.16247,
        "facings": [
          {
            "id": "68d8e509e1820c81800d566b",
            "leftCorner": {
              "x": -12.354,
              "y": -18.863,
              "z": 0.133
            },
            "rightCorner": {
              "x": -12.704,
              "y": -18.863,
              "z": 0.133
            },
            "gtin": "4002674102215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d566c",
            "leftCorner": {
              "x": -12.704,
              "y": -18.868,
              "z": 0.133
            },
            "rightCorner": {
              "x": -12.835,
              "y": -18.869,
              "z": 0.133
            },
            "gtin": "4002674122237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5658",
            "leftCorner": {
              "x": -12.835,
              "y": -18.869,
              "z": 0.133
            },
            "rightCorner": {
              "x": -12.913,
              "y": -18.869,
              "z": 0.133
            },
            "gtin": "4027900287856",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf51",
        "height": 0.42132,
        "facings": [
          {
            "id": "68d8e509e1820c81800d56bd",
            "leftCorner": {
              "x": -12.311,
              "y": -18.891,
              "z": 0.345
            },
            "rightCorner": {
              "x": -12.403,
              "y": -18.892,
              "z": 0.345
            },
            "gtin": "4002674123845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "de164e1b9bf89d4ef22327e6",
            "leftCorner": {
              "x": -12.538,
              "y": -18.863,
              "z": 0.345
            },
            "rightCorner": {
              "x": -12.648,
              "y": -18.864,
              "z": 0.345
            },
            "gtin": "4002674105834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56be",
            "leftCorner": {
              "x": -12.403,
              "y": -18.903,
              "z": 0.345
            },
            "rightCorner": {
              "x": -12.474,
              "y": -18.903,
              "z": 0.345
            },
            "gtin": "4002674105131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56bf",
            "leftCorner": {
              "x": -12.474,
              "y": -18.914,
              "z": 0.345
            },
            "rightCorner": {
              "x": -12.538,
              "y": -18.914,
              "z": 0.345
            },
            "gtin": "4002674105032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56c1",
            "leftCorner": {
              "x": -12.659,
              "y": -18.903,
              "z": 0.345
            },
            "rightCorner": {
              "x": -12.762,
              "y": -18.903,
              "z": 0.345
            },
            "gtin": "4002674121575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56c2",
            "leftCorner": {
              "x": -12.762,
              "y": -18.91,
              "z": 0.345
            },
            "rightCorner": {
              "x": -12.819,
              "y": -18.91,
              "z": 0.345
            },
            "gtin": "4002674286427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56c3",
            "leftCorner": {
              "x": -12.819,
              "y": -18.913,
              "z": 0.345
            },
            "rightCorner": {
              "x": -12.913,
              "y": -18.913,
              "z": 0.345
            },
            "gtin": "4002674316025",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf55",
        "height": 0.64134,
        "facings": [
          {
            "id": "68d8e509e1820c81800d56a0",
            "leftCorner": {
              "x": -12.319,
              "y": -18.896,
              "z": 0.525
            },
            "rightCorner": {
              "x": -12.378,
              "y": -18.896,
              "z": 0.525
            },
            "gtin": "4002674193312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7e99f6a98866fd33b0b0755a",
            "leftCorner": {
              "x": -12.283,
              "y": -18.86,
              "z": 0.525
            },
            "rightCorner": {
              "x": -12.317,
              "y": -18.86,
              "z": 0.525
            },
            "gtin": "4002674193480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56a1",
            "leftCorner": {
              "x": -12.378,
              "y": -18.899,
              "z": 0.525
            },
            "rightCorner": {
              "x": -12.44,
              "y": -18.899,
              "z": 0.525
            },
            "gtin": "4002674193329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56a2",
            "leftCorner": {
              "x": -12.44,
              "y": -18.9,
              "z": 0.525
            },
            "rightCorner": {
              "x": -12.507,
              "y": -18.9,
              "z": 0.525
            },
            "gtin": "4002674193350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56a3",
            "leftCorner": {
              "x": -12.507,
              "y": -18.9,
              "z": 0.525
            },
            "rightCorner": {
              "x": -12.573,
              "y": -18.901,
              "z": 0.525
            },
            "gtin": "4002674193367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56a4",
            "leftCorner": {
              "x": -12.573,
              "y": -18.901,
              "z": 0.525
            },
            "rightCorner": {
              "x": -12.642,
              "y": -18.901,
              "z": 0.525
            },
            "gtin": "4002674193374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56a5",
            "leftCorner": {
              "x": -12.642,
              "y": -18.902,
              "z": 0.525
            },
            "rightCorner": {
              "x": -12.703,
              "y": -18.902,
              "z": 0.525
            },
            "gtin": "4002674193459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56a6",
            "leftCorner": {
              "x": -12.703,
              "y": -18.905,
              "z": 0.525
            },
            "rightCorner": {
              "x": -12.77,
              "y": -18.905,
              "z": 0.525
            },
            "gtin": "4002674193473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56a7",
            "leftCorner": {
              "x": -12.77,
              "y": -18.901,
              "z": 0.525
            },
            "rightCorner": {
              "x": -12.839,
              "y": -18.901,
              "z": 0.525
            },
            "gtin": "4002674193480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56a8",
            "leftCorner": {
              "x": -12.839,
              "y": -18.901,
              "z": 0.525
            },
            "rightCorner": {
              "x": -12.913,
              "y": -18.901,
              "z": 0.525
            },
            "gtin": "4002674193497",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf56",
        "height": 0.85537,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5722",
            "leftCorner": {
              "x": -12.313,
              "y": -18.906,
              "z": 0.7
            },
            "rightCorner": {
              "x": -12.368,
              "y": -18.906,
              "z": 0.7
            },
            "gtin": "4002674121063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5723",
            "leftCorner": {
              "x": -12.368,
              "y": -18.91,
              "z": 0.7
            },
            "rightCorner": {
              "x": -12.433,
              "y": -18.91,
              "z": 0.7
            },
            "gtin": "4002674121063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5724",
            "leftCorner": {
              "x": -12.433,
              "y": -18.909,
              "z": 0.7
            },
            "rightCorner": {
              "x": -12.494,
              "y": -18.909,
              "z": 0.7
            },
            "gtin": "4002674122275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5725",
            "leftCorner": {
              "x": -12.494,
              "y": -18.909,
              "z": 0.7
            },
            "rightCorner": {
              "x": -12.581,
              "y": -18.91,
              "z": 0.7
            },
            "gtin": "4002674122275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5726",
            "leftCorner": {
              "x": -12.581,
              "y": -18.912,
              "z": 0.7
            },
            "rightCorner": {
              "x": -12.643,
              "y": -18.911,
              "z": 0.7
            },
            "gtin": "4002674121704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5727",
            "leftCorner": {
              "x": -12.643,
              "y": -18.912,
              "z": 0.7
            },
            "rightCorner": {
              "x": -12.709,
              "y": -18.912,
              "z": 0.7
            },
            "gtin": "4002674125276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5728",
            "leftCorner": {
              "x": -12.709,
              "y": -18.916,
              "z": 0.7
            },
            "rightCorner": {
              "x": -12.781,
              "y": -18.916,
              "z": 0.7
            },
            "gtin": "4002674126136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5729",
            "leftCorner": {
              "x": -12.781,
              "y": -18.915,
              "z": 0.7
            },
            "rightCorner": {
              "x": -12.849,
              "y": -18.916,
              "z": 0.7
            },
            "gtin": "4002674126143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d572a",
            "leftCorner": {
              "x": -12.849,
              "y": -18.916,
              "z": 0.7
            },
            "rightCorner": {
              "x": -12.913,
              "y": -18.916,
              "z": 0.7
            },
            "gtin": "4002674126174",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf53",
        "height": 1.0811,
        "facings": [
          {
            "id": "68d8e509e1820c81800d56d9",
            "leftCorner": {
              "x": -12.313,
              "y": -18.895,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.363,
              "y": -18.895,
              "z": 0.885
            },
            "gtin": "4002674126211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "10bdb332a4340d06fe40f4cd",
            "leftCorner": {
              "x": -12.283,
              "y": -18.871,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.313,
              "y": -18.871,
              "z": 0.885
            },
            "gtin": "4002674126303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56da",
            "leftCorner": {
              "x": -12.363,
              "y": -18.904,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.422,
              "y": -18.905,
              "z": 0.885
            },
            "gtin": "4002674126303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56db",
            "leftCorner": {
              "x": -12.422,
              "y": -18.909,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.493,
              "y": -18.909,
              "z": 0.885
            },
            "gtin": "4002674126310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56dc",
            "leftCorner": {
              "x": -12.493,
              "y": -18.909,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.566,
              "y": -18.909,
              "z": 0.885
            },
            "gtin": "4002674126242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56dd",
            "leftCorner": {
              "x": -12.566,
              "y": -18.912,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.631,
              "y": -18.911,
              "z": 0.885
            },
            "gtin": "4002674126259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56de",
            "leftCorner": {
              "x": -12.631,
              "y": -18.912,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.698,
              "y": -18.912,
              "z": 0.885
            },
            "gtin": "4002674126235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56df",
            "leftCorner": {
              "x": -12.698,
              "y": -18.914,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.77,
              "y": -18.914,
              "z": 0.885
            },
            "gtin": "4002674126266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56e0",
            "leftCorner": {
              "x": -12.77,
              "y": -18.913,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.843,
              "y": -18.913,
              "z": 0.885
            },
            "gtin": "4002674126273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56e1",
            "leftCorner": {
              "x": -12.843,
              "y": -18.913,
              "z": 0.885
            },
            "rightCorner": {
              "x": -12.913,
              "y": -18.913,
              "z": 0.885
            },
            "gtin": "4002674126297",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf54",
        "height": 1.3101,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5711",
            "leftCorner": {
              "x": -12.439,
              "y": -18.91,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.537,
              "y": -18.911,
              "z": 1.072
            },
            "gtin": "4002674242645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5712",
            "leftCorner": {
              "x": -12.537,
              "y": -18.911,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.635,
              "y": -18.91,
              "z": 1.072
            },
            "gtin": "4002674242645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5713",
            "leftCorner": {
              "x": -12.635,
              "y": -18.914,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.696,
              "y": -18.915,
              "z": 1.072
            },
            "gtin": "4002674242560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5714",
            "leftCorner": {
              "x": -12.696,
              "y": -18.917,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.742,
              "y": -18.917,
              "z": 1.072
            },
            "gtin": "4002674286199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5715",
            "leftCorner": {
              "x": -12.742,
              "y": -18.914,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.799,
              "y": -18.914,
              "z": 1.072
            },
            "gtin": "4002674286120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5716",
            "leftCorner": {
              "x": -12.799,
              "y": -18.919,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.851,
              "y": -18.919,
              "z": 1.072
            },
            "gtin": "4002674286168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5708",
            "leftCorner": {
              "x": -12.851,
              "y": -18.913,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.913,
              "y": -18.913,
              "z": 1.072
            },
            "gtin": "4002674286182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d164838badbc822eb3acf451",
            "leftCorner": {
              "x": -12.283,
              "y": -18.874,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.349,
              "y": -18.874,
              "z": 1.072
            },
            "gtin": "4002674242546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ad08a2bb5ef998c167033707",
            "leftCorner": {
              "x": -12.349,
              "y": -18.874,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.379,
              "y": -18.874,
              "z": 1.072
            },
            "gtin": "4002674242652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a1aa2673b7245be702265557",
            "leftCorner": {
              "x": -12.379,
              "y": -18.874,
              "z": 1.072
            },
            "rightCorner": {
              "x": -12.431,
              "y": -18.874,
              "z": 1.072
            },
            "gtin": "4002674286199",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf52",
        "height": 1.5341,
        "facings": [
          {
            "id": "68d8e509e1820c81800d563c",
            "leftCorner": {
              "x": -12.32,
              "y": -18.9,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.373,
              "y": -18.9,
              "z": 1.255
            },
            "gtin": "4002674152128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d563d",
            "leftCorner": {
              "x": -12.373,
              "y": -18.903,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.426,
              "y": -18.903,
              "z": 1.255
            },
            "gtin": "4002674152166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d563e",
            "leftCorner": {
              "x": -12.426,
              "y": -18.903,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.596,
              "y": -18.902,
              "z": 1.255
            },
            "gtin": "4002674152166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d563f",
            "leftCorner": {
              "x": -12.596,
              "y": -18.908,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.658,
              "y": -18.908,
              "z": 1.255
            },
            "gtin": "4002674152036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5640",
            "leftCorner": {
              "x": -12.658,
              "y": -18.905,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.712,
              "y": -18.905,
              "z": 1.255
            },
            "gtin": "4002674152012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5641",
            "leftCorner": {
              "x": -12.712,
              "y": -18.905,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.767,
              "y": -18.906,
              "z": 1.255
            },
            "gtin": "4002674152012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5642",
            "leftCorner": {
              "x": -12.767,
              "y": -18.907,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.817,
              "y": -18.907,
              "z": 1.255
            },
            "gtin": "4002674152050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5643",
            "leftCorner": {
              "x": -12.817,
              "y": -18.907,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.869,
              "y": -18.908,
              "z": 1.255
            },
            "gtin": "4002674152050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5628",
            "leftCorner": {
              "x": -12.869,
              "y": -18.911,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.913,
              "y": -18.911,
              "z": 1.255
            },
            "gtin": "4002674152074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d0a88231613650530366285c",
            "leftCorner": {
              "x": -12.283,
              "y": -18.866,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.317,
              "y": -18.866,
              "z": 1.255
            },
            "gtin": "4002674152111",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7fa",
    "rightNeighborShelfId": "7fc"
  },
  {
    "id": "7fc",
    "name": "7fc",
    "x": -12.908,
    "y": -18.906,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 7.854E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 80
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf60",
        "height": 0.17414,
        "facings": [
          {
            "id": "68d8e509e1820c81800d576f",
            "leftCorner": {
              "x": -12.909,
              "y": -18.824,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.05,
              "y": -18.824,
              "z": 0.142
            },
            "gtin": "4027900287702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5771",
            "leftCorner": {
              "x": -13.05,
              "y": -18.863,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.147,
              "y": -18.863,
              "z": 0.142
            },
            "gtin": "4027900283803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5772",
            "leftCorner": {
              "x": -13.147,
              "y": -18.868,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.213,
              "y": -18.869,
              "z": 0.142
            },
            "gtin": "4027900287962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5773",
            "leftCorner": {
              "x": -13.212,
              "y": -18.865,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.296,
              "y": -18.864,
              "z": 0.142
            },
            "gtin": "4027900287900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5774",
            "leftCorner": {
              "x": -13.296,
              "y": -18.863,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.375,
              "y": -18.864,
              "z": 0.142
            },
            "gtin": "4027900289751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5775",
            "leftCorner": {
              "x": -13.375,
              "y": -18.863,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.417,
              "y": -18.863,
              "z": 0.142
            },
            "gtin": "4027900115937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5776",
            "leftCorner": {
              "x": -13.417,
              "y": -18.867,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.48,
              "y": -18.867,
              "z": 0.142
            },
            "gtin": "4027900115937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5770",
            "leftCorner": {
              "x": -13.48,
              "y": -18.867,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.538,
              "y": -18.867,
              "z": 0.142
            },
            "gtin": "4027900117993",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf59",
        "height": 0.42412,
        "facings": [
          {
            "id": "68d8e509e1820c81800d56c4",
            "leftCorner": {
              "x": -12.908,
              "y": -18.916,
              "z": 0.347
            },
            "rightCorner": {
              "x": -12.95,
              "y": -18.915,
              "z": 0.347
            },
            "gtin": "4027900247638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56c5",
            "leftCorner": {
              "x": -12.949,
              "y": -18.902,
              "z": 0.347
            },
            "rightCorner": {
              "x": -13.011,
              "y": -18.902,
              "z": 0.347
            },
            "gtin": "4027900247638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56c6",
            "leftCorner": {
              "x": -13.011,
              "y": -18.903,
              "z": 0.347
            },
            "rightCorner": {
              "x": -13.065,
              "y": -18.904,
              "z": 0.347
            },
            "gtin": "4027900247690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56c7",
            "leftCorner": {
              "x": -13.065,
              "y": -18.92,
              "z": 0.347
            },
            "rightCorner": {
              "x": -13.116,
              "y": -18.919,
              "z": 0.347
            },
            "gtin": "4027900247621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56c8",
            "leftCorner": {
              "x": -13.116,
              "y": -18.906,
              "z": 0.347
            },
            "rightCorner": {
              "x": -13.177,
              "y": -18.907,
              "z": 0.347
            },
            "gtin": "4027900244965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56c9",
            "leftCorner": {
              "x": -13.177,
              "y": -18.907,
              "z": 0.347
            },
            "rightCorner": {
              "x": -13.225,
              "y": -18.907,
              "z": 0.347
            },
            "gtin": "4027900245061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ca",
            "leftCorner": {
              "x": -13.225,
              "y": -18.917,
              "z": 0.347
            },
            "rightCorner": {
              "x": -13.289,
              "y": -18.918,
              "z": 0.347
            },
            "gtin": "4027900245061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56cb",
            "leftCorner": {
              "x": -13.289,
              "y": -18.911,
              "z": 0.347
            },
            "rightCorner": {
              "x": -13.336,
              "y": -18.91,
              "z": 0.347
            },
            "gtin": "4027900247850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56cc",
            "leftCorner": {
              "x": -13.336,
              "y": -18.906,
              "z": 0.347
            },
            "rightCorner": {
              "x": -13.388,
              "y": -18.906,
              "z": 0.347
            },
            "gtin": "4027900247485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56cd",
            "leftCorner": {
              "x": -13.388,
              "y": -18.907,
              "z": 0.347
            },
            "rightCorner": {
              "x": -13.439,
              "y": -18.907,
              "z": 0.347
            },
            "gtin": "4027900247850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ce",
            "leftCorner": {
              "x": -13.439,
              "y": -18.923,
              "z": 0.347
            },
            "rightCorner": {
              "x": -13.487,
              "y": -18.923,
              "z": 0.347
            },
            "gtin": "4027900245832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56b5",
            "leftCorner": {
              "x": -13.487,
              "y": -18.911,
              "z": 0.347
            },
            "rightCorner": {
              "x": -13.538,
              "y": -18.912,
              "z": 0.347
            },
            "gtin": "4027900247966",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf5d",
        "height": 0.64266,
        "facings": [
          {
            "id": "68d8e509e1820c81800d56a9",
            "leftCorner": {
              "x": -12.908,
              "y": -18.902,
              "z": 0.526
            },
            "rightCorner": {
              "x": -12.94,
              "y": -18.901,
              "z": 0.526
            },
            "gtin": "4027900247324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56aa",
            "leftCorner": {
              "x": -12.941,
              "y": -18.893,
              "z": 0.526
            },
            "rightCorner": {
              "x": -12.99,
              "y": -18.894,
              "z": 0.526
            },
            "gtin": "4027900247379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ab",
            "leftCorner": {
              "x": -12.991,
              "y": -18.9,
              "z": 0.526
            },
            "rightCorner": {
              "x": -13.053,
              "y": -18.9,
              "z": 0.526
            },
            "gtin": "4027900247379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ac",
            "leftCorner": {
              "x": -13.053,
              "y": -18.902,
              "z": 0.526
            },
            "rightCorner": {
              "x": -13.1,
              "y": -18.903,
              "z": 0.526
            },
            "gtin": "4027900247447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ad",
            "leftCorner": {
              "x": -13.1,
              "y": -18.903,
              "z": 0.526
            },
            "rightCorner": {
              "x": -13.164,
              "y": -18.903,
              "z": 0.526
            },
            "gtin": "4027900247447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ae",
            "leftCorner": {
              "x": -13.164,
              "y": -18.905,
              "z": 0.526
            },
            "rightCorner": {
              "x": -13.209,
              "y": -18.905,
              "z": 0.526
            },
            "gtin": "4027900247478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56af",
            "leftCorner": {
              "x": -13.209,
              "y": -18.901,
              "z": 0.526
            },
            "rightCorner": {
              "x": -13.264,
              "y": -18.9,
              "z": 0.526
            },
            "gtin": "4027900247454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56b0",
            "leftCorner": {
              "x": -13.264,
              "y": -18.905,
              "z": 0.526
            },
            "rightCorner": {
              "x": -13.322,
              "y": -18.905,
              "z": 0.526
            },
            "gtin": "4027900247478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56b1",
            "leftCorner": {
              "x": -13.323,
              "y": -18.904,
              "z": 0.526
            },
            "rightCorner": {
              "x": -13.374,
              "y": -18.904,
              "z": 0.526
            },
            "gtin": "4027900247614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56b2",
            "leftCorner": {
              "x": -13.375,
              "y": -18.899,
              "z": 0.526
            },
            "rightCorner": {
              "x": -13.421,
              "y": -18.9,
              "z": 0.526
            },
            "gtin": "4027900247546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56b3",
            "leftCorner": {
              "x": -13.421,
              "y": -18.899,
              "z": 0.526
            },
            "rightCorner": {
              "x": -13.48,
              "y": -18.899,
              "z": 0.526
            },
            "gtin": "4027900247614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d569a",
            "leftCorner": {
              "x": -13.48,
              "y": -18.903,
              "z": 0.526
            },
            "rightCorner": {
              "x": -13.538,
              "y": -18.904,
              "z": 0.526
            },
            "gtin": "4027900244651",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf61",
        "height": 0.8567,
        "facings": [
          {
            "id": "68d8e509e1820c81800d572b",
            "leftCorner": {
              "x": -12.908,
              "y": -18.92,
              "z": 0.701
            },
            "rightCorner": {
              "x": -12.996,
              "y": -18.918,
              "z": 0.701
            },
            "gtin": "4027900247096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d572c",
            "leftCorner": {
              "x": -12.996,
              "y": -18.915,
              "z": 0.701
            },
            "rightCorner": {
              "x": -13.099,
              "y": -18.915,
              "z": 0.701
            },
            "gtin": "4027900247096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d572d",
            "leftCorner": {
              "x": -13.099,
              "y": -18.917,
              "z": 0.701
            },
            "rightCorner": {
              "x": -13.159,
              "y": -18.917,
              "z": 0.701
            },
            "gtin": "4027900241339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d572e",
            "leftCorner": {
              "x": -13.159,
              "y": -18.916,
              "z": 0.701
            },
            "rightCorner": {
              "x": -13.216,
              "y": -18.917,
              "z": 0.701
            },
            "gtin": "4027900242367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d572f",
            "leftCorner": {
              "x": -13.216,
              "y": -18.917,
              "z": 0.701
            },
            "rightCorner": {
              "x": -13.32,
              "y": -18.917,
              "z": 0.701
            },
            "gtin": "4027900242367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5730",
            "leftCorner": {
              "x": -13.32,
              "y": -18.917,
              "z": 0.701
            },
            "rightCorner": {
              "x": -13.369,
              "y": -18.916,
              "z": 0.701
            },
            "gtin": "4027900242633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5731",
            "leftCorner": {
              "x": -13.369,
              "y": -18.912,
              "z": 0.701
            },
            "rightCorner": {
              "x": -13.414,
              "y": -18.913,
              "z": 0.701
            },
            "gtin": "4027900242541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5732",
            "leftCorner": {
              "x": -13.414,
              "y": -18.914,
              "z": 0.701
            },
            "rightCorner": {
              "x": -13.581,
              "y": -18.915,
              "z": 0.701
            },
            "gtin": "4027900242626",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf5a",
        "height": 1.0826,
        "facings": [
          {
            "id": "68d8e509e1820c81800d56e2",
            "leftCorner": {
              "x": -12.908,
              "y": -18.915,
              "z": 0.886
            },
            "rightCorner": {
              "x": -12.94,
              "y": -18.914,
              "z": 0.886
            },
            "gtin": "4027900257217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56e3",
            "leftCorner": {
              "x": -12.94,
              "y": -18.907,
              "z": 0.886
            },
            "rightCorner": {
              "x": -13.012,
              "y": -18.907,
              "z": 0.886
            },
            "gtin": "4027900257217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56e4",
            "leftCorner": {
              "x": -13.012,
              "y": -18.914,
              "z": 0.886
            },
            "rightCorner": {
              "x": -13.128,
              "y": -18.914,
              "z": 0.886
            },
            "gtin": "4027900257248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56e5",
            "leftCorner": {
              "x": -13.128,
              "y": -18.916,
              "z": 0.886
            },
            "rightCorner": {
              "x": -13.192,
              "y": -18.916,
              "z": 0.886
            },
            "gtin": "4027900257118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56e6",
            "leftCorner": {
              "x": -13.192,
              "y": -18.917,
              "z": 0.886
            },
            "rightCorner": {
              "x": -13.26,
              "y": -18.917,
              "z": 0.886
            },
            "gtin": "4027900257125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56e7",
            "leftCorner": {
              "x": -13.26,
              "y": -18.914,
              "z": 0.886
            },
            "rightCorner": {
              "x": -13.325,
              "y": -18.915,
              "z": 0.886
            },
            "gtin": "4027900257149",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d56e8",
            "leftCorner": {
              "x": -13.325,
              "y": -18.915,
              "z": 0.886
            },
            "rightCorner": {
              "x": -13.388,
              "y": -18.915,
              "z": 0.886
            },
            "gtin": "4027900257606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56e9",
            "leftCorner": {
              "x": -13.388,
              "y": -18.913,
              "z": 0.886
            },
            "rightCorner": {
              "x": -13.459,
              "y": -18.913,
              "z": 0.886
            },
            "gtin": "4027900257316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ea",
            "leftCorner": {
              "x": -13.459,
              "y": -18.914,
              "z": 0.886
            },
            "rightCorner": {
              "x": -13.582,
              "y": -18.914,
              "z": 0.886
            },
            "gtin": "4027900257415",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf5c",
        "height": 1.261,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5757",
            "leftCorner": {
              "x": -12.908,
              "y": -18.877,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.07,
              "y": -18.877,
              "z": 1.032
            },
            "gtin": "4027900213213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5759",
            "leftCorner": {
              "x": -13.07,
              "y": -18.917,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.149,
              "y": -18.917,
              "z": 1.032
            },
            "gtin": "4027900213237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d575a",
            "leftCorner": {
              "x": -13.149,
              "y": -18.917,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.203,
              "y": -18.918,
              "z": 1.032
            },
            "gtin": "4027900213244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d575b",
            "leftCorner": {
              "x": -13.203,
              "y": -18.92,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.355,
              "y": -18.92,
              "z": 1.032
            },
            "gtin": "4027900213244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d575c",
            "leftCorner": {
              "x": -13.355,
              "y": -18.916,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.417,
              "y": -18.916,
              "z": 1.032
            },
            "gtin": "4027900213275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5758",
            "leftCorner": {
              "x": -13.416,
              "y": -18.914,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.538,
              "y": -18.914,
              "z": 1.032
            },
            "gtin": "4027900213282",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf5e",
        "height": 1.4103,
        "facings": [
          {
            "id": "68d8e509e1820c81800d575d",
            "leftCorner": {
              "x": -12.908,
              "y": -18.871,
              "z": 1.154
            },
            "rightCorner": {
              "x": -13.062,
              "y": -18.871,
              "z": 1.154
            },
            "gtin": "4027900117559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d575f",
            "leftCorner": {
              "x": -13.062,
              "y": -18.911,
              "z": 1.154
            },
            "rightCorner": {
              "x": -13.126,
              "y": -18.911,
              "z": 1.154
            },
            "gtin": "4027900117566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5760",
            "leftCorner": {
              "x": -13.126,
              "y": -18.911,
              "z": 1.154
            },
            "rightCorner": {
              "x": -13.181,
              "y": -18.912,
              "z": 1.154
            },
            "gtin": "4027900117665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5761",
            "leftCorner": {
              "x": -13.181,
              "y": -18.912,
              "z": 1.154
            },
            "rightCorner": {
              "x": -13.249,
              "y": -18.912,
              "z": 1.154
            },
            "gtin": "4027900117665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5762",
            "leftCorner": {
              "x": -13.249,
              "y": -18.913,
              "z": 1.154
            },
            "rightCorner": {
              "x": -13.305,
              "y": -18.912,
              "z": 1.154
            },
            "gtin": "4027900117689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5763",
            "leftCorner": {
              "x": -13.305,
              "y": -18.91,
              "z": 1.154
            },
            "rightCorner": {
              "x": -13.368,
              "y": -18.91,
              "z": 1.154
            },
            "gtin": "4027900117689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5764",
            "leftCorner": {
              "x": -13.368,
              "y": -18.908,
              "z": 1.154
            },
            "rightCorner": {
              "x": -13.423,
              "y": -18.909,
              "z": 1.154
            },
            "gtin": "4027900117900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5765",
            "leftCorner": {
              "x": -13.423,
              "y": -18.91,
              "z": 1.154
            },
            "rightCorner": {
              "x": -13.48,
              "y": -18.91,
              "z": 1.154
            },
            "gtin": "4027900117948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d575e",
            "leftCorner": {
              "x": -13.48,
              "y": -18.911,
              "z": 1.154
            },
            "rightCorner": {
              "x": -13.538,
              "y": -18.911,
              "z": 1.154
            },
            "gtin": "4027900117900",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf5f",
        "height": 1.5614,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5766",
            "leftCorner": {
              "x": -12.908,
              "y": -18.871,
              "z": 1.277
            },
            "rightCorner": {
              "x": -13.055,
              "y": -18.872,
              "z": 1.277
            },
            "gtin": "4027900117139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5768",
            "leftCorner": {
              "x": -13.055,
              "y": -18.91,
              "z": 1.277
            },
            "rightCorner": {
              "x": -13.12,
              "y": -18.91,
              "z": 1.277
            },
            "gtin": "4027900117146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5769",
            "leftCorner": {
              "x": -13.12,
              "y": -18.912,
              "z": 1.277
            },
            "rightCorner": {
              "x": -13.189,
              "y": -18.912,
              "z": 1.277
            },
            "gtin": "4027900117177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d576a",
            "leftCorner": {
              "x": -13.188,
              "y": -18.911,
              "z": 1.277
            },
            "rightCorner": {
              "x": -13.254,
              "y": -18.912,
              "z": 1.277
            },
            "gtin": "4027900117283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d576b",
            "leftCorner": {
              "x": -13.254,
              "y": -18.914,
              "z": 1.277
            },
            "rightCorner": {
              "x": -13.315,
              "y": -18.914,
              "z": 1.277
            },
            "gtin": "4027900117337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d576c",
            "leftCorner": {
              "x": -13.315,
              "y": -18.912,
              "z": 1.277
            },
            "rightCorner": {
              "x": -13.375,
              "y": -18.912,
              "z": 1.277
            },
            "gtin": "4027900117382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d576d",
            "leftCorner": {
              "x": -13.375,
              "y": -18.909,
              "z": 1.277
            },
            "rightCorner": {
              "x": -13.432,
              "y": -18.91,
              "z": 1.277
            },
            "gtin": "4027900117467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d576e",
            "leftCorner": {
              "x": -13.433,
              "y": -18.913,
              "z": 1.277
            },
            "rightCorner": {
              "x": -13.483,
              "y": -18.912,
              "z": 1.277
            },
            "gtin": "4027900117528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5767",
            "leftCorner": {
              "x": -13.484,
              "y": -18.91,
              "z": 1.277
            },
            "rightCorner": {
              "x": -13.538,
              "y": -18.911,
              "z": 1.277
            },
            "gtin": "4027900117467",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf5b",
        "height": 1.7103,
        "facings": [
          {
            "id": "68d8e509e1820c81800d574d",
            "leftCorner": {
              "x": -12.908,
              "y": -18.871,
              "z": 1.399
            },
            "rightCorner": {
              "x": -13.011,
              "y": -18.871,
              "z": 1.399
            },
            "gtin": "4027900111458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d574f",
            "leftCorner": {
              "x": -13.011,
              "y": -18.909,
              "z": 1.399
            },
            "rightCorner": {
              "x": -13.073,
              "y": -18.909,
              "z": 1.399
            },
            "gtin": "4027900115982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5750",
            "leftCorner": {
              "x": -13.073,
              "y": -18.91,
              "z": 1.399
            },
            "rightCorner": {
              "x": -13.134,
              "y": -18.911,
              "z": 1.399
            },
            "gtin": "4027900111335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5751",
            "leftCorner": {
              "x": -13.134,
              "y": -18.912,
              "z": 1.399
            },
            "rightCorner": {
              "x": -13.191,
              "y": -18.912,
              "z": 1.399
            },
            "gtin": "4027900112332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5752",
            "leftCorner": {
              "x": -13.191,
              "y": -18.913,
              "z": 1.399
            },
            "rightCorner": {
              "x": -13.25,
              "y": -18.914,
              "z": 1.399
            },
            "gtin": "4027900112332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5753",
            "leftCorner": {
              "x": -13.25,
              "y": -18.913,
              "z": 1.399
            },
            "rightCorner": {
              "x": -13.311,
              "y": -18.913,
              "z": 1.399
            },
            "gtin": "4027900112066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5754",
            "leftCorner": {
              "x": -13.311,
              "y": -18.912,
              "z": 1.399
            },
            "rightCorner": {
              "x": -13.37,
              "y": -18.912,
              "z": 1.399
            },
            "gtin": "4027900111472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5755",
            "leftCorner": {
              "x": -13.37,
              "y": -18.907,
              "z": 1.399
            },
            "rightCorner": {
              "x": -13.428,
              "y": -18.908,
              "z": 1.399
            },
            "gtin": "4027900112578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5756",
            "leftCorner": {
              "x": -13.428,
              "y": -18.909,
              "z": 1.399
            },
            "rightCorner": {
              "x": -13.485,
              "y": -18.908,
              "z": 1.399
            },
            "gtin": "4027900112561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d574e",
            "leftCorner": {
              "x": -13.485,
              "y": -18.91,
              "z": 1.399
            },
            "rightCorner": {
              "x": -13.538,
              "y": -18.911,
              "z": 1.399
            },
            "gtin": "4027900112578",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7fb",
    "rightNeighborShelfId": "7fd"
  },
  {
    "id": "7fd",
    "name": "7fd",
    "x": -13.533,
    "y": -18.907,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 7.854E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 54
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf68",
        "height": 0.19037,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57b1",
            "leftCorner": {
              "x": -13.534,
              "y": -18.833,
              "z": 0.156
            },
            "rightCorner": {
              "x": -13.722,
              "y": -18.833,
              "z": 0.156
            },
            "gtin": "4021155163767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57b3",
            "leftCorner": {
              "x": -13.722,
              "y": -18.875,
              "z": 0.156
            },
            "rightCorner": {
              "x": -13.751,
              "y": -18.875,
              "z": 0.156
            },
            "gtin": "4021155088466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57b4",
            "leftCorner": {
              "x": -13.751,
              "y": -18.868,
              "z": 0.156
            },
            "rightCorner": {
              "x": -13.958,
              "y": -18.868,
              "z": 0.156
            },
            "gtin": "4021155088466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57b5",
            "leftCorner": {
              "x": -13.957,
              "y": -18.872,
              "z": 0.156
            },
            "rightCorner": {
              "x": -14.062,
              "y": -18.872,
              "z": 0.156
            },
            "gtin": "4021155163880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57b6",
            "leftCorner": {
              "x": -14.062,
              "y": -18.904,
              "z": 0.156
            },
            "rightCorner": {
              "x": -14.194,
              "y": -18.904,
              "z": 0.156
            },
            "gtin": "4021155193184",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf65",
        "height": 0.40619,
        "facings": [
          {
            "id": "68d8e509e1820c81800d578b",
            "leftCorner": {
              "x": -13.533,
              "y": -18.879,
              "z": 0.332
            },
            "rightCorner": {
              "x": -13.669,
              "y": -18.88,
              "z": 0.332
            },
            "gtin": "4021155088428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d578d",
            "leftCorner": {
              "x": -13.67,
              "y": -18.92,
              "z": 0.332
            },
            "rightCorner": {
              "x": -13.781,
              "y": -18.92,
              "z": 0.332
            },
            "gtin": "4021155088411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d578e",
            "leftCorner": {
              "x": -13.78,
              "y": -18.921,
              "z": 0.332
            },
            "rightCorner": {
              "x": -13.876,
              "y": -18.921,
              "z": 0.332
            },
            "gtin": "4021155193269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d578f",
            "leftCorner": {
              "x": -13.876,
              "y": -18.92,
              "z": 0.332
            },
            "rightCorner": {
              "x": -13.964,
              "y": -18.92,
              "z": 0.332
            },
            "gtin": "4021155193207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5790",
            "leftCorner": {
              "x": -13.964,
              "y": -18.918,
              "z": 0.332
            },
            "rightCorner": {
              "x": -14.078,
              "y": -18.918,
              "z": 0.332
            },
            "gtin": "4021155082181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5791",
            "leftCorner": {
              "x": -14.078,
              "y": -18.916,
              "z": 0.332
            },
            "rightCorner": {
              "x": -14.191,
              "y": -18.917,
              "z": 0.332
            },
            "gtin": "4021155193245",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf64",
        "height": 0.62982,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5786",
            "leftCorner": {
              "x": -13.533,
              "y": -18.874,
              "z": 0.515
            },
            "rightCorner": {
              "x": -13.703,
              "y": -18.873,
              "z": 0.515
            },
            "gtin": "4027900111403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5788",
            "leftCorner": {
              "x": -13.704,
              "y": -18.913,
              "z": 0.515
            },
            "rightCorner": {
              "x": -13.756,
              "y": -18.914,
              "z": 0.515
            },
            "gtin": "4027900111366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5789",
            "leftCorner": {
              "x": -13.756,
              "y": -18.916,
              "z": 0.515
            },
            "rightCorner": {
              "x": -13.82,
              "y": -18.916,
              "z": 0.515
            },
            "gtin": "4027900111366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d578a",
            "leftCorner": {
              "x": -13.821,
              "y": -18.914,
              "z": 0.515
            },
            "rightCorner": {
              "x": -14.018,
              "y": -18.914,
              "z": 0.515
            },
            "gtin": "4027900111083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5787",
            "leftCorner": {
              "x": -14.018,
              "y": -18.91,
              "z": 0.515
            },
            "rightCorner": {
              "x": -14.163,
              "y": -18.911,
              "z": 0.515
            },
            "gtin": "4027900117023",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf63",
        "height": 0.85544,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5733",
            "leftCorner": {
              "x": -13.576,
              "y": -18.913,
              "z": 0.7
            },
            "rightCorner": {
              "x": -13.637,
              "y": -18.913,
              "z": 0.7
            },
            "gtin": "4027900112073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5734",
            "leftCorner": {
              "x": -13.637,
              "y": -18.913,
              "z": 0.7
            },
            "rightCorner": {
              "x": -13.689,
              "y": -18.913,
              "z": 0.7
            },
            "gtin": "4027900115180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5735",
            "leftCorner": {
              "x": -13.689,
              "y": -18.913,
              "z": 0.7
            },
            "rightCorner": {
              "x": -13.739,
              "y": -18.913,
              "z": 0.7
            },
            "gtin": "4027900111533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5736",
            "leftCorner": {
              "x": -13.739,
              "y": -18.912,
              "z": 0.7
            },
            "rightCorner": {
              "x": -13.793,
              "y": -18.913,
              "z": 0.7
            },
            "gtin": "4027900115180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5737",
            "leftCorner": {
              "x": -13.793,
              "y": -18.914,
              "z": 0.7
            },
            "rightCorner": {
              "x": -13.854,
              "y": -18.914,
              "z": 0.7
            },
            "gtin": "4027900111571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5738",
            "leftCorner": {
              "x": -13.854,
              "y": -18.913,
              "z": 0.7
            },
            "rightCorner": {
              "x": -13.913,
              "y": -18.913,
              "z": 0.7
            },
            "gtin": "4027900111120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5739",
            "leftCorner": {
              "x": -13.913,
              "y": -18.913,
              "z": 0.7
            },
            "rightCorner": {
              "x": -13.968,
              "y": -18.913,
              "z": 0.7
            },
            "gtin": "4027900112721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d573a",
            "leftCorner": {
              "x": -13.968,
              "y": -18.912,
              "z": 0.7
            },
            "rightCorner": {
              "x": -14.031,
              "y": -18.912,
              "z": 0.7
            },
            "gtin": "4027900112721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d573b",
            "leftCorner": {
              "x": -14.031,
              "y": -18.91,
              "z": 0.7
            },
            "rightCorner": {
              "x": -14.087,
              "y": -18.91,
              "z": 0.7
            },
            "gtin": "4027900112110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d573c",
            "leftCorner": {
              "x": -14.087,
              "y": -18.91,
              "z": 0.7
            },
            "rightCorner": {
              "x": -14.194,
              "y": -18.91,
              "z": 0.7
            },
            "gtin": "4027900112110",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf66",
        "height": 1.082,
        "facings": [
          {
            "id": "68d8e509e1820c81800d56eb",
            "leftCorner": {
              "x": -13.576,
              "y": -18.911,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.631,
              "y": -18.911,
              "z": 0.885
            },
            "gtin": "4027900247287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "195629f55b44fccb1894f50e",
            "leftCorner": {
              "x": -13.533,
              "y": -18.871,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.576,
              "y": -18.871,
              "z": 0.885
            },
            "gtin": "4027900111656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ec",
            "leftCorner": {
              "x": -13.631,
              "y": -18.912,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.681,
              "y": -18.912,
              "z": 0.885
            },
            "gtin": "4027900247331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ed",
            "leftCorner": {
              "x": -13.681,
              "y": -18.913,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.732,
              "y": -18.914,
              "z": 0.885
            },
            "gtin": "4027900247287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ee",
            "leftCorner": {
              "x": -13.732,
              "y": -18.913,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.787,
              "y": -18.913,
              "z": 0.885
            },
            "gtin": "4027900242602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ef",
            "leftCorner": {
              "x": -13.787,
              "y": -18.913,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.845,
              "y": -18.913,
              "z": 0.885
            },
            "gtin": "4027900244941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56f0",
            "leftCorner": {
              "x": -13.845,
              "y": -18.911,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.906,
              "y": -18.912,
              "z": 0.885
            },
            "gtin": "4027900241537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56f1",
            "leftCorner": {
              "x": -13.906,
              "y": -18.911,
              "z": 0.885
            },
            "rightCorner": {
              "x": -13.961,
              "y": -18.911,
              "z": 0.885
            },
            "gtin": "4027900242442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56f2",
            "leftCorner": {
              "x": -13.961,
              "y": -18.911,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.019,
              "y": -18.911,
              "z": 0.885
            },
            "gtin": "4027900241506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56f3",
            "leftCorner": {
              "x": -14.019,
              "y": -18.91,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.079,
              "y": -18.91,
              "z": 0.885
            },
            "gtin": "4027900112158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56f4",
            "leftCorner": {
              "x": -14.079,
              "y": -18.906,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.122,
              "y": -18.907,
              "z": 0.885
            },
            "gtin": "4027900111656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56f5",
            "leftCorner": {
              "x": -14.122,
              "y": -18.911,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.192,
              "y": -18.911,
              "z": 0.885
            },
            "gtin": "4027900111656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56f6",
            "leftCorner": {
              "x": -14.192,
              "y": -18.911,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.261,
              "y": -18.911,
              "z": 0.885
            },
            "gtin": "4027900111656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56f7",
            "leftCorner": {
              "x": -14.261,
              "y": -18.911,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.331,
              "y": -18.911,
              "z": 0.885
            },
            "gtin": "4027900111656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56f8",
            "leftCorner": {
              "x": -14.331,
              "y": -18.911,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.401,
              "y": -18.911,
              "z": 0.885
            },
            "gtin": "4027900111656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56f9",
            "leftCorner": {
              "x": -14.401,
              "y": -18.911,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.471,
              "y": -18.912,
              "z": 0.885
            },
            "gtin": "4027900111656",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf67",
        "height": 1.3108,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5795",
            "leftCorner": {
              "x": -13.533,
              "y": -18.874,
              "z": 1.072
            },
            "rightCorner": {
              "x": -13.646,
              "y": -18.874,
              "z": 1.072
            },
            "gtin": "4027900287764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5797",
            "leftCorner": {
              "x": -13.645,
              "y": -18.916,
              "z": 1.072
            },
            "rightCorner": {
              "x": -13.695,
              "y": -18.917,
              "z": 1.072
            },
            "gtin": "4027900247904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5798",
            "leftCorner": {
              "x": -13.695,
              "y": -18.915,
              "z": 1.072
            },
            "rightCorner": {
              "x": -13.753,
              "y": -18.915,
              "z": 1.072
            },
            "gtin": "4027900247942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5799",
            "leftCorner": {
              "x": -13.753,
              "y": -18.917,
              "z": 1.072
            },
            "rightCorner": {
              "x": -13.806,
              "y": -18.917,
              "z": 1.072
            },
            "gtin": "4027900247683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d579a",
            "leftCorner": {
              "x": -13.806,
              "y": -18.915,
              "z": 1.072
            },
            "rightCorner": {
              "x": -13.859,
              "y": -18.915,
              "z": 1.072
            },
            "gtin": "4027900244927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d579b",
            "leftCorner": {
              "x": -13.859,
              "y": -18.913,
              "z": 1.072
            },
            "rightCorner": {
              "x": -13.91,
              "y": -18.914,
              "z": 1.072
            },
            "gtin": "4027900247553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d579c",
            "leftCorner": {
              "x": -13.91,
              "y": -18.913,
              "z": 1.072
            },
            "rightCorner": {
              "x": -13.96,
              "y": -18.913,
              "z": 1.072
            },
            "gtin": "4027900247669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d579d",
            "leftCorner": {
              "x": -13.96,
              "y": -18.911,
              "z": 1.072
            },
            "rightCorner": {
              "x": -14.022,
              "y": -18.911,
              "z": 1.072
            },
            "gtin": "4027900244118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d579e",
            "leftCorner": {
              "x": -14.022,
              "y": -18.91,
              "z": 1.072
            },
            "rightCorner": {
              "x": -14.08,
              "y": -18.91,
              "z": 1.072
            },
            "gtin": "4027900247461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d579f",
            "leftCorner": {
              "x": -14.08,
              "y": -18.912,
              "z": 1.072
            },
            "rightCorner": {
              "x": -14.185,
              "y": -18.912,
              "z": 1.072
            },
            "gtin": "4027900247461",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf62",
        "height": 1.5377,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5777",
            "leftCorner": {
              "x": -13.533,
              "y": -18.87,
              "z": 1.258
            },
            "rightCorner": {
              "x": -13.831,
              "y": -18.87,
              "z": 1.258
            },
            "gtin": "4002674121063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d577b",
            "leftCorner": {
              "x": -13.832,
              "y": -18.909,
              "z": 1.258
            },
            "rightCorner": {
              "x": -14.203,
              "y": -18.909,
              "z": 1.258
            },
            "gtin": "4002674121070",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7fc",
    "rightNeighborShelfId": "7fe"
  },
  {
    "id": "7fe",
    "name": "7fe",
    "x": -14.158,
    "y": -18.908,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 7.854E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf6d",
        "height": 0.18825,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57b7",
            "leftCorner": {
              "x": -14.19,
              "y": -18.865,
              "z": 0.154
            },
            "rightCorner": {
              "x": -14.311,
              "y": -18.865,
              "z": 0.154
            },
            "gtin": "4021155086318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57b8",
            "leftCorner": {
              "x": -14.311,
              "y": -18.867,
              "z": 0.154
            },
            "rightCorner": {
              "x": -14.417,
              "y": -18.867,
              "z": 0.154
            },
            "gtin": "4021155082228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57b9",
            "leftCorner": {
              "x": -14.417,
              "y": -18.867,
              "z": 0.154
            },
            "rightCorner": {
              "x": -14.538,
              "y": -18.866,
              "z": 0.154
            },
            "gtin": "4021155181525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57ba",
            "leftCorner": {
              "x": -14.538,
              "y": -18.871,
              "z": 0.154
            },
            "rightCorner": {
              "x": -14.67,
              "y": -18.872,
              "z": 0.154
            },
            "gtin": "4021155193283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57b2",
            "leftCorner": {
              "x": -14.67,
              "y": -18.873,
              "z": 0.154
            },
            "rightCorner": {
              "x": -14.788,
              "y": -18.873,
              "z": 0.154
            },
            "gtin": "4021155082136",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf6c",
        "height": 0.40581,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5792",
            "leftCorner": {
              "x": -14.185,
              "y": -18.915,
              "z": 0.332
            },
            "rightCorner": {
              "x": -14.226,
              "y": -18.915,
              "z": 0.332
            },
            "gtin": "4021155082242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5793",
            "leftCorner": {
              "x": -14.226,
              "y": -18.917,
              "z": 0.332
            },
            "rightCorner": {
              "x": -14.404,
              "y": -18.918,
              "z": 0.332
            },
            "gtin": "4021155082242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5794",
            "leftCorner": {
              "x": -14.404,
              "y": -18.92,
              "z": 0.332
            },
            "rightCorner": {
              "x": -14.61,
              "y": -18.919,
              "z": 0.332
            },
            "gtin": "4021155088435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d578c",
            "leftCorner": {
              "x": -14.61,
              "y": -18.921,
              "z": 0.332
            },
            "rightCorner": {
              "x": -14.787,
              "y": -18.922,
              "z": 0.332
            },
            "gtin": "4021155193221",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf6b",
        "height": 0.85633,
        "facings": [
          {
            "id": "68d8e509e1820c81800d573d",
            "leftCorner": {
              "x": -14.187,
              "y": -18.906,
              "z": 0.701
            },
            "rightCorner": {
              "x": -14.295,
              "y": -18.906,
              "z": 0.701
            },
            "gtin": "4002674184396",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d573e",
            "leftCorner": {
              "x": -14.295,
              "y": -18.91,
              "z": 0.701
            },
            "rightCorner": {
              "x": -14.34,
              "y": -18.911,
              "z": 0.701
            },
            "gtin": "40279404",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d573f",
            "leftCorner": {
              "x": -14.34,
              "y": -18.91,
              "z": 0.701
            },
            "rightCorner": {
              "x": -14.404,
              "y": -18.91,
              "z": 0.701
            },
            "gtin": "40279404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5740",
            "leftCorner": {
              "x": -14.404,
              "y": -18.911,
              "z": 0.701
            },
            "rightCorner": {
              "x": -14.472,
              "y": -18.911,
              "z": 0.701
            },
            "gtin": "40279732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5741",
            "leftCorner": {
              "x": -14.472,
              "y": -18.91,
              "z": 0.701
            },
            "rightCorner": {
              "x": -14.524,
              "y": -18.911,
              "z": 0.701
            },
            "gtin": "4027900241520",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d5742",
            "leftCorner": {
              "x": -14.524,
              "y": -18.913,
              "z": 0.701
            },
            "rightCorner": {
              "x": -14.617,
              "y": -18.912,
              "z": 0.701
            },
            "gtin": "4027900241520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5743",
            "leftCorner": {
              "x": -14.617,
              "y": -18.912,
              "z": 0.701
            },
            "rightCorner": {
              "x": -14.672,
              "y": -18.913,
              "z": 0.701
            },
            "gtin": "40279701",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d5744",
            "leftCorner": {
              "x": -14.672,
              "y": -18.915,
              "z": 0.701
            },
            "rightCorner": {
              "x": -14.731,
              "y": -18.915,
              "z": 0.701
            },
            "gtin": "40279695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5745",
            "leftCorner": {
              "x": -14.731,
              "y": -18.916,
              "z": 0.701
            },
            "rightCorner": {
              "x": -14.868,
              "y": -18.916,
              "z": 0.701
            },
            "gtin": "40279695",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf6e",
        "height": 1.0817,
        "facings": [
          {
            "id": "68d8e509e1820c81800d56fa",
            "leftCorner": {
              "x": -14.465,
              "y": -18.913,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.531,
              "y": -18.913,
              "z": 0.885
            },
            "gtin": "4002674129182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a38d00ef8a18a0a6658f6e5e",
            "leftCorner": {
              "x": -14.158,
              "y": -18.873,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.217,
              "y": -18.873,
              "z": 0.885
            },
            "gtin": "4260347898890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a59fcdb37c93deaa2a17787c",
            "leftCorner": {
              "x": -14.217,
              "y": -18.873,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.276,
              "y": -18.873,
              "z": 0.885
            },
            "gtin": "4260347898890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "91f26c6c3a50032a8fe03922",
            "leftCorner": {
              "x": -14.276,
              "y": -18.873,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.341,
              "y": -18.873,
              "z": 0.885
            },
            "gtin": "4002674129182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f421f8bac48312afedb332be",
            "leftCorner": {
              "x": -14.341,
              "y": -18.873,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.406,
              "y": -18.873,
              "z": 0.885
            },
            "gtin": "4002674129182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56fb",
            "leftCorner": {
              "x": -14.531,
              "y": -18.914,
              "z": 0.885
            },
            "rightCorner": {
              "x": -14.827,
              "y": -18.915,
              "z": 0.885
            },
            "gtin": "4002674129168",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf6a",
        "height": 1.3094,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57a0",
            "leftCorner": {
              "x": -14.179,
              "y": -18.908,
              "z": 1.071
            },
            "rightCorner": {
              "x": -14.236,
              "y": -18.908,
              "z": 1.071
            },
            "gtin": "4002674242652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57a1",
            "leftCorner": {
              "x": -14.236,
              "y": -18.914,
              "z": 1.071
            },
            "rightCorner": {
              "x": -14.289,
              "y": -18.914,
              "z": 1.071
            },
            "gtin": "4002674242744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57a2",
            "leftCorner": {
              "x": -14.289,
              "y": -18.915,
              "z": 1.071
            },
            "rightCorner": {
              "x": -14.343,
              "y": -18.916,
              "z": 1.071
            },
            "gtin": "4002674242645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57a3",
            "leftCorner": {
              "x": -14.343,
              "y": -18.916,
              "z": 1.071
            },
            "rightCorner": {
              "x": -14.41,
              "y": -18.916,
              "z": 1.071
            },
            "gtin": "4002674242645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57a4",
            "leftCorner": {
              "x": -14.41,
              "y": -18.916,
              "z": 1.071
            },
            "rightCorner": {
              "x": -14.479,
              "y": -18.916,
              "z": 1.071
            },
            "gtin": "4002674242645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57a5",
            "leftCorner": {
              "x": -14.479,
              "y": -18.916,
              "z": 1.071
            },
            "rightCorner": {
              "x": -14.547,
              "y": -18.916,
              "z": 1.071
            },
            "gtin": "4002674242645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57a6",
            "leftCorner": {
              "x": -14.547,
              "y": -18.916,
              "z": 1.071
            },
            "rightCorner": {
              "x": -14.923,
              "y": -18.917,
              "z": 1.071
            },
            "gtin": "4049164124296",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf69",
        "height": 1.5346,
        "facings": [
          {
            "id": "68d8e509e1820c81800d577c",
            "leftCorner": {
              "x": -14.197,
              "y": -18.887,
              "z": 1.256
            },
            "rightCorner": {
              "x": -14.605,
              "y": -18.888,
              "z": 1.256
            },
            "gtin": "4002674122275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b6ec1d5edc7535a83c810af7",
            "leftCorner": {
              "x": -14.157,
              "y": -18.865,
              "z": 1.256
            },
            "rightCorner": {
              "x": -14.196,
              "y": -18.865,
              "z": 1.256
            },
            "gtin": "4260347890610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d577d",
            "leftCorner": {
              "x": -14.606,
              "y": -18.906,
              "z": 1.256
            },
            "rightCorner": {
              "x": -14.683,
              "y": -18.906,
              "z": 1.256
            },
            "gtin": "4002674122237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d577e",
            "leftCorner": {
              "x": -14.683,
              "y": -18.906,
              "z": 1.256
            },
            "rightCorner": {
              "x": -14.784,
              "y": -18.905,
              "z": 1.256
            },
            "gtin": "4002674044713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d577f",
            "leftCorner": {
              "x": -14.784,
              "y": -18.908,
              "z": 1.256
            },
            "rightCorner": {
              "x": -14.94,
              "y": -18.908,
              "z": 1.256
            },
            "gtin": "4260347890610",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7fd",
    "rightNeighborShelfId": "7ff"
  },
  {
    "id": "7ff",
    "name": "7ff",
    "x": -14.783,
    "y": -18.909,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 7.854E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 59
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf76",
        "height": 0.16397,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57da",
            "leftCorner": {
              "x": -14.782,
              "y": -18.847,
              "z": 0.134
            },
            "rightCorner": {
              "x": -14.967,
              "y": -18.847,
              "z": 0.134
            },
            "gtin": "4260347894649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cc9081af44820328ef50fbc8",
            "leftCorner": {
              "x": -15.066,
              "y": -18.847,
              "z": 0.134
            },
            "rightCorner": {
              "x": -15.132,
              "y": -18.848,
              "z": 0.134
            },
            "gtin": "4260347899057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "59b78454926213ba4dab0698",
            "leftCorner": {
              "x": -15.132,
              "y": -18.848,
              "z": 0.134
            },
            "rightCorner": {
              "x": -15.199,
              "y": -18.848,
              "z": 0.134
            },
            "gtin": "4260347899057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "67f85cedcee4b4f61447e68a",
            "leftCorner": {
              "x": -15.27,
              "y": -18.848,
              "z": 0.134
            },
            "rightCorner": {
              "x": -15.336,
              "y": -18.848,
              "z": 0.134
            },
            "gtin": "4260347899057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f09a9a171d088266f97960f6",
            "leftCorner": {
              "x": -15.336,
              "y": -18.848,
              "z": 0.134
            },
            "rightCorner": {
              "x": -15.403,
              "y": -18.848,
              "z": 0.134
            },
            "gtin": "4260347899057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57dc",
            "leftCorner": {
              "x": -14.967,
              "y": -18.871,
              "z": 0.134
            },
            "rightCorner": {
              "x": -15.066,
              "y": -18.871,
              "z": 0.134
            },
            "gtin": "4260347894656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57df",
            "leftCorner": {
              "x": -15.204,
              "y": -18.875,
              "z": 0.134
            },
            "rightCorner": {
              "x": -15.27,
              "y": -18.874,
              "z": 0.134
            },
            "gtin": "4260347899057",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf6f",
        "height": 0.41765,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57bb",
            "leftCorner": {
              "x": -14.783,
              "y": -18.871,
              "z": 0.342
            },
            "rightCorner": {
              "x": -14.894,
              "y": -18.871,
              "z": 0.342
            },
            "gtin": "4260347890368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57bd",
            "leftCorner": {
              "x": -14.894,
              "y": -18.909,
              "z": 0.342
            },
            "rightCorner": {
              "x": -14.949,
              "y": -18.908,
              "z": 0.342
            },
            "gtin": "4260347890399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57be",
            "leftCorner": {
              "x": -14.949,
              "y": -18.908,
              "z": 0.342
            },
            "rightCorner": {
              "x": -15.014,
              "y": -18.908,
              "z": 0.342
            },
            "gtin": "4260347890399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57bf",
            "leftCorner": {
              "x": -15.014,
              "y": -18.91,
              "z": 0.342
            },
            "rightCorner": {
              "x": -15.072,
              "y": -18.909,
              "z": 0.342
            },
            "gtin": "4260347892287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57c0",
            "leftCorner": {
              "x": -15.072,
              "y": -18.911,
              "z": 0.342
            },
            "rightCorner": {
              "x": -15.133,
              "y": -18.911,
              "z": 0.342
            },
            "gtin": "4260347892287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57c1",
            "leftCorner": {
              "x": -15.133,
              "y": -18.911,
              "z": 0.342
            },
            "rightCorner": {
              "x": -15.205,
              "y": -18.912,
              "z": 0.342
            },
            "gtin": "4260347894090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57c2",
            "leftCorner": {
              "x": -15.205,
              "y": -18.912,
              "z": 0.342
            },
            "rightCorner": {
              "x": -15.274,
              "y": -18.911,
              "z": 0.342
            },
            "gtin": "4260347893574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57c3",
            "leftCorner": {
              "x": -15.274,
              "y": -18.925,
              "z": 0.342
            },
            "rightCorner": {
              "x": -15.345,
              "y": -18.925,
              "z": 0.342
            },
            "gtin": "4260347892348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57c4",
            "leftCorner": {
              "x": -15.345,
              "y": -18.912,
              "z": 0.342
            },
            "rightCorner": {
              "x": -15.441,
              "y": -18.912,
              "z": 0.342
            },
            "gtin": "4260347896308",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf70",
        "height": 0.62691,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57c7",
            "leftCorner": {
              "x": -14.783,
              "y": -18.876,
              "z": 0.513
            },
            "rightCorner": {
              "x": -14.909,
              "y": -18.876,
              "z": 0.513
            },
            "gtin": "4260347891402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57c9",
            "leftCorner": {
              "x": -14.908,
              "y": -18.916,
              "z": 0.513
            },
            "rightCorner": {
              "x": -14.972,
              "y": -18.916,
              "z": 0.513
            },
            "gtin": "4260347890337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57ca",
            "leftCorner": {
              "x": -14.972,
              "y": -18.911,
              "z": 0.513
            },
            "rightCorner": {
              "x": -15.087,
              "y": -18.912,
              "z": 0.513
            },
            "gtin": "4260347890245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57cb",
            "leftCorner": {
              "x": -15.088,
              "y": -18.916,
              "z": 0.513
            },
            "rightCorner": {
              "x": -15.217,
              "y": -18.916,
              "z": 0.513
            },
            "gtin": "4062988840098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57cc",
            "leftCorner": {
              "x": -15.217,
              "y": -18.914,
              "z": 0.513
            },
            "rightCorner": {
              "x": -15.281,
              "y": -18.915,
              "z": 0.513
            },
            "gtin": "4260347890344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57cd",
            "leftCorner": {
              "x": -15.281,
              "y": -18.919,
              "z": 0.513
            },
            "rightCorner": {
              "x": -15.348,
              "y": -18.919,
              "z": 0.513
            },
            "gtin": "4260347893826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57ce",
            "leftCorner": {
              "x": -15.348,
              "y": -18.914,
              "z": 0.513
            },
            "rightCorner": {
              "x": -15.538,
              "y": -18.914,
              "z": 0.513
            },
            "gtin": "4260347890351",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf75",
        "height": 0.85339,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5746",
            "leftCorner": {
              "x": -14.863,
              "y": -18.915,
              "z": 0.698
            },
            "rightCorner": {
              "x": -14.932,
              "y": -18.915,
              "z": 0.698
            },
            "gtin": "4260347892393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5747",
            "leftCorner": {
              "x": -14.932,
              "y": -18.916,
              "z": 0.698
            },
            "rightCorner": {
              "x": -15.0,
              "y": -18.917,
              "z": 0.698
            },
            "gtin": "4260347896322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5748",
            "leftCorner": {
              "x": -15.0,
              "y": -18.919,
              "z": 0.698
            },
            "rightCorner": {
              "x": -15.07,
              "y": -18.919,
              "z": 0.698
            },
            "gtin": "4260347890221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5749",
            "leftCorner": {
              "x": -15.07,
              "y": -18.919,
              "z": 0.698
            },
            "rightCorner": {
              "x": -15.137,
              "y": -18.918,
              "z": 0.698
            },
            "gtin": "4260347899040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d574a",
            "leftCorner": {
              "x": -15.137,
              "y": -18.918,
              "z": 0.698
            },
            "rightCorner": {
              "x": -15.213,
              "y": -18.919,
              "z": 0.698
            },
            "gtin": "4260347894137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d574b",
            "leftCorner": {
              "x": -15.213,
              "y": -18.916,
              "z": 0.698
            },
            "rightCorner": {
              "x": -15.35,
              "y": -18.916,
              "z": 0.698
            },
            "gtin": "4260347894083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d574c",
            "leftCorner": {
              "x": -15.35,
              "y": -18.916,
              "z": 0.698
            },
            "rightCorner": {
              "x": -15.496,
              "y": -18.916,
              "z": 0.698
            },
            "gtin": "4260347890313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5718",
            "leftCorner": {
              "x": -15.496,
              "y": -18.914,
              "z": 0.698
            },
            "rightCorner": {
              "x": -15.578,
              "y": -18.914,
              "z": 0.698
            },
            "gtin": "4260431672467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cd8a667a08cc84f339df7704",
            "leftCorner": {
              "x": -14.783,
              "y": -18.878,
              "z": 0.698
            },
            "rightCorner": {
              "x": -14.858,
              "y": -18.878,
              "z": 0.698
            },
            "gtin": "4260347894137",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf71",
        "height": 1.0791,
        "facings": [
          {
            "id": "68d8e509e1820c81800d56fc",
            "leftCorner": {
              "x": -14.822,
              "y": -18.912,
              "z": 0.883
            },
            "rightCorner": {
              "x": -14.891,
              "y": -18.912,
              "z": 0.883
            },
            "gtin": "4260347898890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56fd",
            "leftCorner": {
              "x": -14.891,
              "y": -18.915,
              "z": 0.883
            },
            "rightCorner": {
              "x": -14.957,
              "y": -18.915,
              "z": 0.883
            },
            "gtin": "4260347890382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56fe",
            "leftCorner": {
              "x": -14.957,
              "y": -18.914,
              "z": 0.883
            },
            "rightCorner": {
              "x": -15.027,
              "y": -18.914,
              "z": 0.883
            },
            "gtin": "4260347893383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56ff",
            "leftCorner": {
              "x": -15.027,
              "y": -18.911,
              "z": 0.883
            },
            "rightCorner": {
              "x": -15.157,
              "y": -18.912,
              "z": 0.883
            },
            "gtin": "4260347894120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5700",
            "leftCorner": {
              "x": -15.157,
              "y": -18.912,
              "z": 0.883
            },
            "rightCorner": {
              "x": -15.28,
              "y": -18.913,
              "z": 0.883
            },
            "gtin": "4260347894014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5701",
            "leftCorner": {
              "x": -15.28,
              "y": -18.915,
              "z": 0.883
            },
            "rightCorner": {
              "x": -15.343,
              "y": -18.915,
              "z": 0.883
            },
            "gtin": "4260347890269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5702",
            "leftCorner": {
              "x": -15.343,
              "y": -18.914,
              "z": 0.883
            },
            "rightCorner": {
              "x": -15.442,
              "y": -18.914,
              "z": 0.883
            },
            "gtin": "4260347894472",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf72",
        "height": 1.307,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57a7",
            "leftCorner": {
              "x": -14.918,
              "y": -18.918,
              "z": 1.069
            },
            "rightCorner": {
              "x": -14.995,
              "y": -18.918,
              "z": 1.069
            },
            "gtin": "4260347894250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fe04a0a9f4fe7a6a5ae18fa8",
            "leftCorner": {
              "x": -14.783,
              "y": -18.877,
              "z": 1.069
            },
            "rightCorner": {
              "x": -14.837,
              "y": -18.877,
              "z": 1.069
            },
            "gtin": "4260347890443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "66cafedb89c00c3d5e689451",
            "leftCorner": {
              "x": -14.837,
              "y": -18.877,
              "z": 1.069
            },
            "rightCorner": {
              "x": -14.916,
              "y": -18.877,
              "z": 1.069
            },
            "gtin": "4260347894250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57a8",
            "leftCorner": {
              "x": -14.995,
              "y": -18.915,
              "z": 1.069
            },
            "rightCorner": {
              "x": -15.114,
              "y": -18.916,
              "z": 1.069
            },
            "gtin": "4260347890092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57a9",
            "leftCorner": {
              "x": -15.114,
              "y": -18.916,
              "z": 1.069
            },
            "rightCorner": {
              "x": -15.236,
              "y": -18.916,
              "z": 1.069
            },
            "gtin": "4260347892867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57aa",
            "leftCorner": {
              "x": -15.236,
              "y": -18.919,
              "z": 1.069
            },
            "rightCorner": {
              "x": -15.298,
              "y": -18.92,
              "z": 1.069
            },
            "gtin": "4260347890184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57ab",
            "leftCorner": {
              "x": -15.298,
              "y": -18.92,
              "z": 1.069
            },
            "rightCorner": {
              "x": -15.354,
              "y": -18.92,
              "z": 1.069
            },
            "gtin": "4260347894991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57ac",
            "leftCorner": {
              "x": -15.354,
              "y": -18.917,
              "z": 1.069
            },
            "rightCorner": {
              "x": -15.455,
              "y": -18.917,
              "z": 1.069
            },
            "gtin": "4260347894991",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf73",
        "height": 1.5329,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5780",
            "leftCorner": {
              "x": -14.935,
              "y": -18.906,
              "z": 1.254
            },
            "rightCorner": {
              "x": -15.058,
              "y": -18.906,
              "z": 1.254
            },
            "gtin": "4260347890634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee1d734fa5fd444e18e9593d",
            "leftCorner": {
              "x": -14.783,
              "y": -18.866,
              "z": 1.254
            },
            "rightCorner": {
              "x": -14.907,
              "y": -18.866,
              "z": 1.254
            },
            "gtin": "4260347890634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5781",
            "leftCorner": {
              "x": -15.058,
              "y": -18.907,
              "z": 1.254
            },
            "rightCorner": {
              "x": -15.181,
              "y": -18.907,
              "z": 1.254
            },
            "gtin": "4260347890153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5782",
            "leftCorner": {
              "x": -15.181,
              "y": -18.907,
              "z": 1.254
            },
            "rightCorner": {
              "x": -15.297,
              "y": -18.908,
              "z": 1.254
            },
            "gtin": "4260347899033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5783",
            "leftCorner": {
              "x": -15.297,
              "y": -18.905,
              "z": 1.254
            },
            "rightCorner": {
              "x": -15.459,
              "y": -18.905,
              "z": 1.254
            },
            "gtin": "4260347894021",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf74",
        "height": 1.7084,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57d3",
            "leftCorner": {
              "x": -14.783,
              "y": -18.871,
              "z": 1.398
            },
            "rightCorner": {
              "x": -14.994,
              "y": -18.872,
              "z": 1.398
            },
            "gtin": "4260347890887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57d5",
            "leftCorner": {
              "x": -14.994,
              "y": -18.912,
              "z": 1.398
            },
            "rightCorner": {
              "x": -15.058,
              "y": -18.912,
              "z": 1.398
            },
            "gtin": "4260347890856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57d6",
            "leftCorner": {
              "x": -15.058,
              "y": -18.912,
              "z": 1.398
            },
            "rightCorner": {
              "x": -15.129,
              "y": -18.912,
              "z": 1.398
            },
            "gtin": "4260347890870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57d7",
            "leftCorner": {
              "x": -15.129,
              "y": -18.909,
              "z": 1.398
            },
            "rightCorner": {
              "x": -15.245,
              "y": -18.909,
              "z": 1.398
            },
            "gtin": "4260347890894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57d8",
            "leftCorner": {
              "x": -15.245,
              "y": -18.912,
              "z": 1.398
            },
            "rightCorner": {
              "x": -15.313,
              "y": -18.911,
              "z": 1.398
            },
            "gtin": "4062988840104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57d9",
            "leftCorner": {
              "x": -15.313,
              "y": -18.908,
              "z": 1.398
            },
            "rightCorner": {
              "x": -15.365,
              "y": -18.909,
              "z": 1.398
            },
            "gtin": "4062988840043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57d4",
            "leftCorner": {
              "x": -15.365,
              "y": -18.908,
              "z": 1.398
            },
            "rightCorner": {
              "x": -15.412,
              "y": -18.908,
              "z": 1.398
            },
            "gtin": "4260347890900",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7fe",
    "rightNeighborShelfId": "800"
  },
  {
    "id": "800",
    "name": "800",
    "x": -15.408,
    "y": -18.91,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 7.854E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 23
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf7a",
        "height": 0.42099,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57c5",
            "leftCorner": {
              "x": -15.438,
              "y": -18.895,
              "z": 0.344
            },
            "rightCorner": {
              "x": -15.627,
              "y": -18.896,
              "z": 0.344
            },
            "gtin": "4260401174762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57c6",
            "leftCorner": {
              "x": -15.627,
              "y": -18.913,
              "z": 0.344
            },
            "rightCorner": {
              "x": -15.844,
              "y": -18.913,
              "z": 0.344
            },
            "gtin": "4260431678483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57bc",
            "leftCorner": {
              "x": -15.843,
              "y": -18.9,
              "z": 0.344
            },
            "rightCorner": {
              "x": -16.038,
              "y": -18.9,
              "z": 0.344
            },
            "gtin": "4260401174946",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf77",
        "height": 0.62898,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57cf",
            "leftCorner": {
              "x": -15.534,
              "y": -18.915,
              "z": 0.515
            },
            "rightCorner": {
              "x": -15.618,
              "y": -18.916,
              "z": 0.515
            },
            "gtin": "4260431671996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57d0",
            "leftCorner": {
              "x": -15.618,
              "y": -18.916,
              "z": 0.515
            },
            "rightCorner": {
              "x": -15.702,
              "y": -18.916,
              "z": 0.515
            },
            "gtin": "4260431671996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57d1",
            "leftCorner": {
              "x": -15.702,
              "y": -18.916,
              "z": 0.515
            },
            "rightCorner": {
              "x": -15.786,
              "y": -18.916,
              "z": 0.515
            },
            "gtin": "4260431671996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57d2",
            "leftCorner": {
              "x": -15.786,
              "y": -18.91,
              "z": 0.515
            },
            "rightCorner": {
              "x": -15.942,
              "y": -18.91,
              "z": 0.515
            },
            "gtin": "4260431678469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57c8",
            "leftCorner": {
              "x": -15.941,
              "y": -18.921,
              "z": 0.515
            },
            "rightCorner": {
              "x": -16.038,
              "y": -18.921,
              "z": 0.515
            },
            "gtin": "4260431671088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6e1e39dd11ef9b224b78639f",
            "leftCorner": {
              "x": -15.409,
              "y": -18.873,
              "z": 0.515
            },
            "rightCorner": {
              "x": -15.495,
              "y": -18.873,
              "z": 0.515
            },
            "gtin": "4260431671088",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf78",
        "height": 1.0812,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5703",
            "leftCorner": {
              "x": -15.439,
              "y": -18.903,
              "z": 0.885
            },
            "rightCorner": {
              "x": -15.548,
              "y": -18.904,
              "z": 0.885
            },
            "gtin": "4260431678278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5704",
            "leftCorner": {
              "x": -15.547,
              "y": -18.914,
              "z": 0.885
            },
            "rightCorner": {
              "x": -15.673,
              "y": -18.914,
              "z": 0.885
            },
            "gtin": "4260431673938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5705",
            "leftCorner": {
              "x": -15.673,
              "y": -18.922,
              "z": 0.885
            },
            "rightCorner": {
              "x": -15.783,
              "y": -18.922,
              "z": 0.885
            },
            "gtin": "4260401174465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5706",
            "leftCorner": {
              "x": -15.783,
              "y": -18.922,
              "z": 0.885
            },
            "rightCorner": {
              "x": -15.893,
              "y": -18.922,
              "z": 0.885
            },
            "gtin": "4260401174465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d56d0",
            "leftCorner": {
              "x": -15.893,
              "y": -18.91,
              "z": 0.885
            },
            "rightCorner": {
              "x": -16.039,
              "y": -18.91,
              "z": 0.885
            },
            "gtin": "4260401175004",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf79",
        "height": 1.3101,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57ad",
            "leftCorner": {
              "x": -15.451,
              "y": -18.906,
              "z": 1.072
            },
            "rightCorner": {
              "x": -15.553,
              "y": -18.906,
              "z": 1.072
            },
            "gtin": "4260401175301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57ae",
            "leftCorner": {
              "x": -15.554,
              "y": -18.917,
              "z": 1.072
            },
            "rightCorner": {
              "x": -15.687,
              "y": -18.917,
              "z": 1.072
            },
            "gtin": "4260401174403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5796",
            "leftCorner": {
              "x": -15.835,
              "y": -18.908,
              "z": 1.072
            },
            "rightCorner": {
              "x": -16.039,
              "y": -18.908,
              "z": 1.072
            },
            "gtin": "4260446098276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "66631ba424b3a84e5ba39997",
            "leftCorner": {
              "x": -15.687,
              "y": -18.872,
              "z": 1.072
            },
            "rightCorner": {
              "x": -15.833,
              "y": -18.873,
              "z": 1.072
            },
            "gtin": "4260401175301",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf7b",
        "height": 1.5358,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5784",
            "leftCorner": {
              "x": -15.455,
              "y": -18.898,
              "z": 1.257
            },
            "rightCorner": {
              "x": -15.626,
              "y": -18.898,
              "z": 1.257
            },
            "gtin": "4260401174168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5785",
            "leftCorner": {
              "x": -15.627,
              "y": -18.913,
              "z": 1.257
            },
            "rightCorner": {
              "x": -15.808,
              "y": -18.912,
              "z": 1.257
            },
            "gtin": "4260431673730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5778",
            "leftCorner": {
              "x": -15.808,
              "y": -18.899,
              "z": 1.257
            },
            "rightCorner": {
              "x": -15.885,
              "y": -18.9,
              "z": 1.257
            },
            "gtin": "4260401174496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5779",
            "leftCorner": {
              "x": -15.885,
              "y": -18.9,
              "z": 1.257
            },
            "rightCorner": {
              "x": -15.961,
              "y": -18.9,
              "z": 1.257
            },
            "gtin": "4260401174496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d577a",
            "leftCorner": {
              "x": -15.961,
              "y": -18.9,
              "z": 1.257
            },
            "rightCorner": {
              "x": -16.038,
              "y": -18.899,
              "z": 1.257
            },
            "gtin": "4260401174496",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7ff"
  },
  {
    "id": "801",
    "name": "801",
    "x": -15.983,
    "y": -20.272,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0033772,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 35
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf86",
        "height": 0.15787,
        "facings": [
          {
            "id": "68d8e509e1820c81800d587d",
            "leftCorner": {
              "x": -15.982,
              "y": -20.378,
              "z": 0.129
            },
            "rightCorner": {
              "x": -15.725,
              "y": -20.376,
              "z": 0.129
            },
            "gtin": "4045317058265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d587e",
            "leftCorner": {
              "x": -15.725,
              "y": -20.376,
              "z": 0.129
            },
            "rightCorner": {
              "x": -15.468,
              "y": -20.375,
              "z": 0.129
            },
            "gtin": "4045317058265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5880",
            "leftCorner": {
              "x": -15.468,
              "y": -20.327,
              "z": 0.129
            },
            "rightCorner": {
              "x": -15.241,
              "y": -20.326,
              "z": 0.129
            },
            "gtin": "4045317058258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5881",
            "leftCorner": {
              "x": -15.241,
              "y": -20.326,
              "z": 0.129
            },
            "rightCorner": {
              "x": -15.015,
              "y": -20.324,
              "z": 0.129
            },
            "gtin": "4045317058258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5882",
            "leftCorner": {
              "x": -15.014,
              "y": -20.338,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.873,
              "y": -20.337,
              "z": 0.129
            },
            "gtin": "4306188038771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5883",
            "leftCorner": {
              "x": -14.873,
              "y": -20.337,
              "z": 0.129
            },
            "rightCorner": {
              "x": -14.732,
              "y": -20.336,
              "z": 0.129
            },
            "gtin": "4306188038771",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf81",
        "height": 0.45956,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57ed",
            "leftCorner": {
              "x": -15.982,
              "y": -20.377,
              "z": 0.376
            },
            "rightCorner": {
              "x": -15.75,
              "y": -20.376,
              "z": 0.376
            },
            "gtin": "4016241070227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57ef",
            "leftCorner": {
              "x": -15.751,
              "y": -20.336,
              "z": 0.376
            },
            "rightCorner": {
              "x": -15.587,
              "y": -20.334,
              "z": 0.376
            },
            "gtin": "4016241070234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57f0",
            "leftCorner": {
              "x": -15.587,
              "y": -20.326,
              "z": 0.376
            },
            "rightCorner": {
              "x": -15.405,
              "y": -20.324,
              "z": 0.376
            },
            "gtin": "4067517000103",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d57f1",
            "leftCorner": {
              "x": -15.404,
              "y": -20.328,
              "z": 0.376
            },
            "rightCorner": {
              "x": -15.196,
              "y": -20.326,
              "z": 0.376
            },
            "gtin": "4104420078024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57f2",
            "leftCorner": {
              "x": -15.196,
              "y": -20.332,
              "z": 0.376
            },
            "rightCorner": {
              "x": -15.005,
              "y": -20.33,
              "z": 0.376
            },
            "gtin": "4062800000990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57f3",
            "leftCorner": {
              "x": -15.005,
              "y": -20.347,
              "z": 0.376
            },
            "rightCorner": {
              "x": -14.881,
              "y": -20.345,
              "z": 0.376
            },
            "gtin": "4062800001959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57f4",
            "leftCorner": {
              "x": -14.881,
              "y": -20.339,
              "z": 0.376
            },
            "rightCorner": {
              "x": -14.717,
              "y": -20.339,
              "z": 0.376
            },
            "gtin": "4062800016779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57f5",
            "leftCorner": {
              "x": -14.717,
              "y": -20.339,
              "z": 0.376
            },
            "rightCorner": {
              "x": -14.553,
              "y": -20.337,
              "z": 0.376
            },
            "gtin": "4062800016779",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf84",
        "height": 0.76012,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5847",
            "leftCorner": {
              "x": -15.982,
              "y": -20.378,
              "z": 0.622
            },
            "rightCorner": {
              "x": -15.641,
              "y": -20.376,
              "z": 0.622
            },
            "gtin": "4000436117248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5849",
            "leftCorner": {
              "x": -15.642,
              "y": -20.332,
              "z": 0.622
            },
            "rightCorner": {
              "x": -15.52,
              "y": -20.331,
              "z": 0.622
            },
            "gtin": "4000436115145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d584a",
            "leftCorner": {
              "x": -15.52,
              "y": -20.331,
              "z": 0.622
            },
            "rightCorner": {
              "x": -15.399,
              "y": -20.329,
              "z": 0.622
            },
            "gtin": "4000436115145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d584b",
            "leftCorner": {
              "x": -15.399,
              "y": -20.329,
              "z": 0.622
            },
            "rightCorner": {
              "x": -15.278,
              "y": -20.329,
              "z": 0.622
            },
            "gtin": "4000436115145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d584c",
            "leftCorner": {
              "x": -15.278,
              "y": -20.329,
              "z": 0.622
            },
            "rightCorner": {
              "x": -15.157,
              "y": -20.328,
              "z": 0.622
            },
            "gtin": "4000436115145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d584d",
            "leftCorner": {
              "x": -15.157,
              "y": -20.332,
              "z": 0.622
            },
            "rightCorner": {
              "x": -14.942,
              "y": -20.33,
              "z": 0.622
            },
            "gtin": "4000436115220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d584e",
            "leftCorner": {
              "x": -14.943,
              "y": -20.34,
              "z": 0.622
            },
            "rightCorner": {
              "x": -14.811,
              "y": -20.34,
              "z": 0.622
            },
            "gtin": "4000436117323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d584f",
            "leftCorner": {
              "x": -14.811,
              "y": -20.34,
              "z": 0.622
            },
            "rightCorner": {
              "x": -14.68,
              "y": -20.339,
              "z": 0.622
            },
            "gtin": "4000436117323",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf82",
        "height": 1.0626,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5813",
            "leftCorner": {
              "x": -15.982,
              "y": -20.371,
              "z": 0.869
            },
            "rightCorner": {
              "x": -15.849,
              "y": -20.371,
              "z": 0.869
            },
            "gtin": "4104060026553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5814",
            "leftCorner": {
              "x": -15.849,
              "y": -20.371,
              "z": 0.869
            },
            "rightCorner": {
              "x": -15.716,
              "y": -20.37,
              "z": 0.869
            },
            "gtin": "4104060026553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5816",
            "leftCorner": {
              "x": -15.717,
              "y": -20.33,
              "z": 0.869
            },
            "rightCorner": {
              "x": -15.561,
              "y": -20.329,
              "z": 0.869
            },
            "gtin": "4002970001878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5817",
            "leftCorner": {
              "x": -15.561,
              "y": -20.326,
              "z": 0.869
            },
            "rightCorner": {
              "x": -15.404,
              "y": -20.325,
              "z": 0.869
            },
            "gtin": "4002970001861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5818",
            "leftCorner": {
              "x": -15.404,
              "y": -20.328,
              "z": 0.869
            },
            "rightCorner": {
              "x": -14.887,
              "y": -20.325,
              "z": 0.869
            },
            "gtin": "4008452027602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5819",
            "leftCorner": {
              "x": -14.887,
              "y": -20.339,
              "z": 0.869
            },
            "rightCorner": {
              "x": -14.732,
              "y": -20.338,
              "z": 0.869
            },
            "gtin": "4008452027589",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf83",
        "height": 1.3618,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5829",
            "leftCorner": {
              "x": -15.982,
              "y": -20.375,
              "z": 1.114
            },
            "rightCorner": {
              "x": -15.661,
              "y": -20.373,
              "z": 1.114
            },
            "gtin": "4306188049616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d582b",
            "leftCorner": {
              "x": -15.661,
              "y": -20.326,
              "z": 1.114
            },
            "rightCorner": {
              "x": -15.45,
              "y": -20.325,
              "z": 1.114
            },
            "gtin": "4306188038337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d582c",
            "leftCorner": {
              "x": -15.45,
              "y": -20.329,
              "z": 1.114
            },
            "rightCorner": {
              "x": -15.066,
              "y": -20.327,
              "z": 1.114
            },
            "gtin": "4306188398783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d582d",
            "leftCorner": {
              "x": -15.066,
              "y": -20.333,
              "z": 1.114
            },
            "rightCorner": {
              "x": -14.861,
              "y": -20.332,
              "z": 1.114
            },
            "gtin": "4036300104236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d582e",
            "leftCorner": {
              "x": -14.861,
              "y": -20.339,
              "z": 1.114
            },
            "rightCorner": {
              "x": -14.732,
              "y": -20.337,
              "z": 1.114
            },
            "gtin": "4260024180089",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf85",
        "height": 1.7376,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5863",
            "leftCorner": {
              "x": -15.982,
              "y": -20.373,
              "z": 1.422
            },
            "rightCorner": {
              "x": -15.516,
              "y": -20.37,
              "z": 1.422
            },
            "gtin": "5410488140054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5865",
            "leftCorner": {
              "x": -15.516,
              "y": -20.328,
              "z": 1.422
            },
            "rightCorner": {
              "x": -15.076,
              "y": -20.325,
              "z": 1.422
            },
            "gtin": "4306188027072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5866",
            "leftCorner": {
              "x": -15.075,
              "y": -20.331,
              "z": 1.422
            },
            "rightCorner": {
              "x": -14.702,
              "y": -20.328,
              "z": 1.422
            },
            "gtin": "4045317053604",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "810"
  },
  {
    "id": "802",
    "name": "802",
    "x": -10.891,
    "y": -21.915,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0056723
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 44
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf9e",
        "height": 0.17523,
        "facings": [
          {
            "id": "7e2be4fb8bf4c25301659dce",
            "leftCorner": {
              "x": -10.892,
              "y": -21.83,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.987,
              "y": -21.831,
              "z": 0.143
            },
            "gtin": "4000521855802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2b968911835fb284753d3300",
            "leftCorner": {
              "x": -10.987,
              "y": -21.831,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.11,
              "y": -21.832,
              "z": 0.143
            },
            "gtin": "4000521034627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d9bfac89cd9ecdf3d25e929b",
            "leftCorner": {
              "x": -11.11,
              "y": -21.832,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.238,
              "y": -21.834,
              "z": 0.143
            },
            "gtin": "4000521029982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3c023eeb892a437b5c25b66c",
            "leftCorner": {
              "x": -11.238,
              "y": -21.834,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.375,
              "y": -21.835,
              "z": 0.143
            },
            "gtin": "4000521030063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cb4cdbfba4e284d89e56e732",
            "leftCorner": {
              "x": -11.375,
              "y": -21.835,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.516,
              "y": -21.837,
              "z": 0.143
            },
            "gtin": "4000521030193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d3c7ed9c3e72c6cbd04045e9",
            "leftCorner": {
              "x": -11.516,
              "y": -21.837,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.662,
              "y": -21.839,
              "z": 0.143
            },
            "gtin": "4000521029944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "06575805321defb802811952",
            "leftCorner": {
              "x": -11.662,
              "y": -21.839,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.808,
              "y": -21.84,
              "z": 0.143
            },
            "gtin": "4000521030025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "89aba6a2b4dff45ef5a81a10",
            "leftCorner": {
              "x": -11.808,
              "y": -21.84,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.954,
              "y": -21.842,
              "z": 0.143
            },
            "gtin": "4000521037581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ccc0d037c20c39f76cb3ef40",
            "leftCorner": {
              "x": -11.954,
              "y": -21.842,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.137,
              "y": -21.844,
              "z": 0.143
            },
            "gtin": "4002809028298",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf9d",
        "height": 0.42118,
        "facings": [
          {
            "id": "68d8e509e1820c81800d58d9",
            "leftCorner": {
              "x": -10.891,
              "y": -21.884,
              "z": 0.345
            },
            "rightCorner": {
              "x": -11.25,
              "y": -21.888,
              "z": 0.345
            },
            "gtin": "4306188052203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58db",
            "leftCorner": {
              "x": -11.25,
              "y": -21.927,
              "z": 0.345
            },
            "rightCorner": {
              "x": -11.593,
              "y": -21.93,
              "z": 0.345
            },
            "gtin": "4306188046356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58dc",
            "leftCorner": {
              "x": -11.593,
              "y": -21.932,
              "z": 0.345
            },
            "rightCorner": {
              "x": -11.775,
              "y": -21.934,
              "z": 0.345
            },
            "gtin": "4306188052265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58da",
            "leftCorner": {
              "x": -11.775,
              "y": -21.933,
              "z": 0.345
            },
            "rightCorner": {
              "x": -12.141,
              "y": -21.938,
              "z": 0.345
            },
            "gtin": "4306188046325",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf9a",
        "height": 0.62865,
        "facings": [
          {
            "id": "68d8e509e1820c81800d58aa",
            "leftCorner": {
              "x": -10.891,
              "y": -21.877,
              "z": 0.514
            },
            "rightCorner": {
              "x": -11.073,
              "y": -21.879,
              "z": 0.514
            },
            "gtin": "4000521029968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58ac",
            "leftCorner": {
              "x": -11.073,
              "y": -21.916,
              "z": 0.514
            },
            "rightCorner": {
              "x": -11.174,
              "y": -21.917,
              "z": 0.514
            },
            "gtin": "4000521029982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58ad",
            "leftCorner": {
              "x": -11.174,
              "y": -21.91,
              "z": 0.514
            },
            "rightCorner": {
              "x": -11.323,
              "y": -21.911,
              "z": 0.514
            },
            "gtin": "4000521030025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58ae",
            "leftCorner": {
              "x": -11.322,
              "y": -21.926,
              "z": 0.514
            },
            "rightCorner": {
              "x": -11.465,
              "y": -21.928,
              "z": 0.514
            },
            "gtin": "4000521029944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58af",
            "leftCorner": {
              "x": -11.465,
              "y": -21.926,
              "z": 0.514
            },
            "rightCorner": {
              "x": -11.614,
              "y": -21.927,
              "z": 0.514
            },
            "gtin": "4000521030001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58b0",
            "leftCorner": {
              "x": -11.614,
              "y": -21.927,
              "z": 0.514
            },
            "rightCorner": {
              "x": -11.967,
              "y": -21.932,
              "z": 0.514
            },
            "gtin": "4000521034337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58b1",
            "leftCorner": {
              "x": -11.967,
              "y": -21.921,
              "z": 0.514
            },
            "rightCorner": {
              "x": -12.184,
              "y": -21.923,
              "z": 0.514
            },
            "gtin": "4002809028298",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf9c",
        "height": 0.95733,
        "facings": [
          {
            "id": "68d8e509e1820c81800d58ca",
            "leftCorner": {
              "x": -10.891,
              "y": -21.881,
              "z": 0.783
            },
            "rightCorner": {
              "x": -11.066,
              "y": -21.883,
              "z": 0.783
            },
            "gtin": "4000521029920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58cc",
            "leftCorner": {
              "x": -11.066,
              "y": -21.917,
              "z": 0.783
            },
            "rightCorner": {
              "x": -11.188,
              "y": -21.918,
              "z": 0.783
            },
            "gtin": "4000521030063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58cd",
            "leftCorner": {
              "x": -11.188,
              "y": -21.924,
              "z": 0.783
            },
            "rightCorner": {
              "x": -11.429,
              "y": -21.927,
              "z": 0.783
            },
            "gtin": "4000521037192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58ce",
            "leftCorner": {
              "x": -11.429,
              "y": -21.927,
              "z": 0.783
            },
            "rightCorner": {
              "x": -11.735,
              "y": -21.93,
              "z": 0.783
            },
            "gtin": "4000521030230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58cf",
            "leftCorner": {
              "x": -11.735,
              "y": -21.931,
              "z": 0.783
            },
            "rightCorner": {
              "x": -11.943,
              "y": -21.933,
              "z": 0.783
            },
            "gtin": "4000521030216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58d0",
            "leftCorner": {
              "x": -11.943,
              "y": -21.918,
              "z": 0.783
            },
            "rightCorner": {
              "x": -12.161,
              "y": -21.921,
              "z": 0.783
            },
            "gtin": "4000521030131",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf9b",
        "height": 1.2616,
        "facings": [
          {
            "id": "68d8e509e1820c81800d58b9",
            "leftCorner": {
              "x": -10.891,
              "y": -21.884,
              "z": 1.032
            },
            "rightCorner": {
              "x": -11.068,
              "y": -21.886,
              "z": 1.032
            },
            "gtin": "4000521030155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58bb",
            "leftCorner": {
              "x": -11.068,
              "y": -21.933,
              "z": 1.032
            },
            "rightCorner": {
              "x": -11.16,
              "y": -21.934,
              "z": 1.032
            },
            "gtin": "4000521034627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58bc",
            "leftCorner": {
              "x": -11.16,
              "y": -21.918,
              "z": 1.032
            },
            "rightCorner": {
              "x": -11.301,
              "y": -21.919,
              "z": 1.032
            },
            "gtin": "4000521030179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58bd",
            "leftCorner": {
              "x": -11.301,
              "y": -21.93,
              "z": 1.032
            },
            "rightCorner": {
              "x": -11.44,
              "y": -21.932,
              "z": 1.032
            },
            "gtin": "4000521030193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58be",
            "leftCorner": {
              "x": -11.44,
              "y": -21.928,
              "z": 1.032
            },
            "rightCorner": {
              "x": -11.593,
              "y": -21.93,
              "z": 1.032
            },
            "gtin": "4000521030117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58bf",
            "leftCorner": {
              "x": -11.593,
              "y": -21.931,
              "z": 1.032
            },
            "rightCorner": {
              "x": -11.789,
              "y": -21.934,
              "z": 1.032
            },
            "gtin": "4000521037932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58c0",
            "leftCorner": {
              "x": -11.789,
              "y": -21.933,
              "z": 1.032
            },
            "rightCorner": {
              "x": -11.968,
              "y": -21.935,
              "z": 1.032
            },
            "gtin": "4000521037581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58c1",
            "leftCorner": {
              "x": -11.968,
              "y": -21.924,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.122,
              "y": -21.927,
              "z": 1.032
            },
            "gtin": "4002809035692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58c2",
            "leftCorner": {
              "x": -12.122,
              "y": -21.925,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.265,
              "y": -21.926,
              "z": 1.032
            },
            "gtin": "4002809037702",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf99",
        "height": 1.5621,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5898",
            "leftCorner": {
              "x": -10.891,
              "y": -21.877,
              "z": 1.278
            },
            "rightCorner": {
              "x": -11.056,
              "y": -21.879,
              "z": 1.278
            },
            "gtin": "4000521043650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d589b",
            "leftCorner": {
              "x": -11.056,
              "y": -21.924,
              "z": 1.278
            },
            "rightCorner": {
              "x": -11.201,
              "y": -21.925,
              "z": 1.278
            },
            "gtin": "4000521885007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d589c",
            "leftCorner": {
              "x": -11.201,
              "y": -21.919,
              "z": 1.278
            },
            "rightCorner": {
              "x": -11.295,
              "y": -21.921,
              "z": 1.278
            },
            "gtin": "4000521855802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d589d",
            "leftCorner": {
              "x": -11.295,
              "y": -21.922,
              "z": 1.278
            },
            "rightCorner": {
              "x": -11.439,
              "y": -21.924,
              "z": 1.278
            },
            "gtin": "4000521854102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d589e",
            "leftCorner": {
              "x": -11.439,
              "y": -21.925,
              "z": 1.278
            },
            "rightCorner": {
              "x": -11.613,
              "y": -21.926,
              "z": 1.278
            },
            "gtin": "4000521005986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d589f",
            "leftCorner": {
              "x": -11.613,
              "y": -21.924,
              "z": 1.278
            },
            "rightCorner": {
              "x": -11.768,
              "y": -21.926,
              "z": 1.278
            },
            "gtin": "4000521880002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58a0",
            "leftCorner": {
              "x": -11.768,
              "y": -21.927,
              "z": 1.278
            },
            "rightCorner": {
              "x": -11.97,
              "y": -21.929,
              "z": 1.278
            },
            "gtin": "4000521035211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58a1",
            "leftCorner": {
              "x": -11.97,
              "y": -21.922,
              "z": 1.278
            },
            "rightCorner": {
              "x": -12.125,
              "y": -21.924,
              "z": 1.278
            },
            "gtin": "4000521500207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58a2",
            "leftCorner": {
              "x": -12.134,
              "y": -21.929,
              "z": 1.278
            },
            "rightCorner": {
              "x": -12.277,
              "y": -21.93,
              "z": 1.278
            },
            "gtin": "4000521004828",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "803",
    "name": "803",
    "x": -12.141,
    "y": -21.929,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0056723
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 49
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfa4",
        "height": 0.17448,
        "facings": [
          {
            "id": "0ec1c54e31ad2fb75941b21c",
            "leftCorner": {
              "x": -12.142,
              "y": -21.839,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.227,
              "y": -21.84,
              "z": 0.143
            },
            "gtin": "4000521013103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4675ef9ce802c48dfb19f0a3",
            "leftCorner": {
              "x": -12.227,
              "y": -21.84,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.336,
              "y": -21.841,
              "z": 0.143
            },
            "gtin": "4000521031015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e60edf72bbf3ba95d58f2da5",
            "leftCorner": {
              "x": -12.336,
              "y": -21.841,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.454,
              "y": -21.843,
              "z": 0.143
            },
            "gtin": "4000521017163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b5b3b3fa309f21da7af819eb",
            "leftCorner": {
              "x": -12.454,
              "y": -21.843,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.573,
              "y": -21.844,
              "z": 0.143
            },
            "gtin": "4002809027956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8fd380fa0a43cb21bdd56ba3",
            "leftCorner": {
              "x": -12.573,
              "y": -21.844,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.694,
              "y": -21.845,
              "z": 0.143
            },
            "gtin": "4002809035715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bd4a093688fb11a2fb72f951",
            "leftCorner": {
              "x": -12.694,
              "y": -21.845,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.816,
              "y": -21.847,
              "z": 0.143
            },
            "gtin": "4000521030995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c4acc0729df36f459a5336fb",
            "leftCorner": {
              "x": -12.816,
              "y": -21.847,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.941,
              "y": -21.848,
              "z": 0.143
            },
            "gtin": "4002809034398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aa9d756d960b944c0eb93abc",
            "leftCorner": {
              "x": -12.941,
              "y": -21.848,
              "z": 0.143
            },
            "rightCorner": {
              "x": -13.072,
              "y": -21.85,
              "z": 0.143
            },
            "gtin": "4002809004018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9c22938978ffce1ddaee8f6a",
            "leftCorner": {
              "x": -13.072,
              "y": -21.85,
              "z": 0.143
            },
            "rightCorner": {
              "x": -13.203,
              "y": -21.851,
              "z": 0.143
            },
            "gtin": "4000521849108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dce6745220de11d6709cb734",
            "leftCorner": {
              "x": -13.203,
              "y": -21.851,
              "z": 0.143
            },
            "rightCorner": {
              "x": -13.387,
              "y": -21.853,
              "z": 0.143
            },
            "gtin": "4002676650066",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfa3",
        "height": 0.40782,
        "facings": [
          {
            "id": "68d8e509e1820c81800d58f5",
            "leftCorner": {
              "x": -12.142,
              "y": -21.903,
              "z": 0.334
            },
            "rightCorner": {
              "x": -12.7,
              "y": -21.909,
              "z": 0.334
            },
            "gtin": "4306188045595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58f7",
            "leftCorner": {
              "x": -12.7,
              "y": -21.949,
              "z": 0.334
            },
            "rightCorner": {
              "x": -12.967,
              "y": -21.952,
              "z": 0.334
            },
            "gtin": "4306188045625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58f8",
            "leftCorner": {
              "x": -12.967,
              "y": -21.952,
              "z": 0.334
            },
            "rightCorner": {
              "x": -13.183,
              "y": -21.954,
              "z": 0.334
            },
            "gtin": "4306188051381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58f6",
            "leftCorner": {
              "x": -13.182,
              "y": -21.938,
              "z": 0.334
            },
            "rightCorner": {
              "x": -13.391,
              "y": -21.941,
              "z": 0.334
            },
            "gtin": "4104420022782",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfa0",
        "height": 0.62877,
        "facings": [
          {
            "id": "68d8e509e1820c81800d58b2",
            "leftCorner": {
              "x": -12.184,
              "y": -21.919,
              "z": 0.514
            },
            "rightCorner": {
              "x": -12.316,
              "y": -21.921,
              "z": 0.514
            },
            "gtin": "4002809018657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58b3",
            "leftCorner": {
              "x": -12.316,
              "y": -21.93,
              "z": 0.514
            },
            "rightCorner": {
              "x": -12.449,
              "y": -21.931,
              "z": 0.514
            },
            "gtin": "4002676650080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58b4",
            "leftCorner": {
              "x": -12.449,
              "y": -21.935,
              "z": 0.514
            },
            "rightCorner": {
              "x": -12.632,
              "y": -21.938,
              "z": 0.514
            },
            "gtin": "4002676650066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58b5",
            "leftCorner": {
              "x": -12.632,
              "y": -21.947,
              "z": 0.514
            },
            "rightCorner": {
              "x": -12.817,
              "y": -21.949,
              "z": 0.514
            },
            "gtin": "4002809021725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58b6",
            "leftCorner": {
              "x": -12.817,
              "y": -21.945,
              "z": 0.514
            },
            "rightCorner": {
              "x": -12.973,
              "y": -21.947,
              "z": 0.514
            },
            "gtin": "4000406003168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58b7",
            "leftCorner": {
              "x": -12.972,
              "y": -21.942,
              "z": 0.514
            },
            "rightCorner": {
              "x": -13.085,
              "y": -21.943,
              "z": 0.514
            },
            "gtin": "4002809030260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58b8",
            "leftCorner": {
              "x": -13.085,
              "y": -21.937,
              "z": 0.514
            },
            "rightCorner": {
              "x": -13.216,
              "y": -21.938,
              "z": 0.514
            },
            "gtin": "4000521849108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58ab",
            "leftCorner": {
              "x": -13.216,
              "y": -21.936,
              "z": 0.514
            },
            "rightCorner": {
              "x": -13.391,
              "y": -21.938,
              "z": 0.514
            },
            "gtin": "4002809037849",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfa2",
        "height": 0.95595,
        "facings": [
          {
            "id": "68d8e509e1820c81800d58d1",
            "leftCorner": {
              "x": -12.162,
              "y": -21.928,
              "z": 0.782
            },
            "rightCorner": {
              "x": -12.275,
              "y": -21.929,
              "z": 0.782
            },
            "gtin": "4002809027666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58d2",
            "leftCorner": {
              "x": -12.275,
              "y": -21.927,
              "z": 0.782
            },
            "rightCorner": {
              "x": -12.442,
              "y": -21.928,
              "z": 0.782
            },
            "gtin": "4002809030277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58d3",
            "leftCorner": {
              "x": -12.442,
              "y": -21.933,
              "z": 0.782
            },
            "rightCorner": {
              "x": -12.559,
              "y": -21.935,
              "z": 0.782
            },
            "gtin": "4002809027956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58d4",
            "leftCorner": {
              "x": -12.559,
              "y": -21.941,
              "z": 0.782
            },
            "rightCorner": {
              "x": -12.705,
              "y": -21.943,
              "z": 0.782
            },
            "gtin": "4002809035739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58d5",
            "leftCorner": {
              "x": -12.705,
              "y": -21.948,
              "z": 0.782
            },
            "rightCorner": {
              "x": -12.832,
              "y": -21.95,
              "z": 0.782
            },
            "gtin": "4002809004018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58d6",
            "leftCorner": {
              "x": -12.831,
              "y": -21.928,
              "z": 0.782
            },
            "rightCorner": {
              "x": -12.946,
              "y": -21.929,
              "z": 0.782
            },
            "gtin": "4002809035715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58d7",
            "leftCorner": {
              "x": -12.946,
              "y": -21.941,
              "z": 0.782
            },
            "rightCorner": {
              "x": -13.079,
              "y": -21.942,
              "z": 0.782
            },
            "gtin": "4002809035722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58d8",
            "leftCorner": {
              "x": -13.078,
              "y": -21.937,
              "z": 0.782
            },
            "rightCorner": {
              "x": -13.217,
              "y": -21.938,
              "z": 0.782
            },
            "gtin": "4002809037160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58cb",
            "leftCorner": {
              "x": -13.217,
              "y": -21.937,
              "z": 0.782
            },
            "rightCorner": {
              "x": -13.391,
              "y": -21.939,
              "z": 0.782
            },
            "gtin": "4002809035708",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfa1",
        "height": 1.2611,
        "facings": [
          {
            "id": "68d8e509e1820c81800d58c4",
            "leftCorner": {
              "x": -12.398,
              "y": -21.936,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.556,
              "y": -21.938,
              "z": 1.032
            },
            "gtin": "4002809034473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58c5",
            "leftCorner": {
              "x": -12.557,
              "y": -21.946,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.693,
              "y": -21.947,
              "z": 1.032
            },
            "gtin": "4002809034480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58c6",
            "leftCorner": {
              "x": -12.693,
              "y": -21.951,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.825,
              "y": -21.953,
              "z": 1.032
            },
            "gtin": "4002809037795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58c7",
            "leftCorner": {
              "x": -12.825,
              "y": -21.947,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.966,
              "y": -21.948,
              "z": 1.032
            },
            "gtin": "4002809037696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58c8",
            "leftCorner": {
              "x": -12.966,
              "y": -21.948,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.082,
              "y": -21.949,
              "z": 1.032
            },
            "gtin": "4002809034398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58c9",
            "leftCorner": {
              "x": -13.082,
              "y": -21.94,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.216,
              "y": -21.942,
              "z": 1.032
            },
            "gtin": "4002809037351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58ba",
            "leftCorner": {
              "x": -13.216,
              "y": -21.938,
              "z": 1.032
            },
            "rightCorner": {
              "x": -13.391,
              "y": -21.941,
              "z": 1.032
            },
            "gtin": "4002809037283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "112928b3b0760e9f0666f287",
            "leftCorner": {
              "x": -12.142,
              "y": -21.896,
              "z": 1.032
            },
            "rightCorner": {
              "x": -12.309,
              "y": -21.898,
              "z": 1.032
            },
            "gtin": "4002809037283",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf9f",
        "height": 1.5616,
        "facings": [
          {
            "id": "68d8e509e1820c81800d58a3",
            "leftCorner": {
              "x": -12.284,
              "y": -21.929,
              "z": 1.278
            },
            "rightCorner": {
              "x": -12.443,
              "y": -21.93,
              "z": 1.278
            },
            "gtin": "4000521009113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58a4",
            "leftCorner": {
              "x": -12.443,
              "y": -21.935,
              "z": 1.278
            },
            "rightCorner": {
              "x": -12.582,
              "y": -21.937,
              "z": 1.278
            },
            "gtin": "4000521004842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58a5",
            "leftCorner": {
              "x": -12.582,
              "y": -21.945,
              "z": 1.278
            },
            "rightCorner": {
              "x": -12.734,
              "y": -21.946,
              "z": 1.278
            },
            "gtin": "4000521004804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58a6",
            "leftCorner": {
              "x": -12.734,
              "y": -21.949,
              "z": 1.278
            },
            "rightCorner": {
              "x": -12.842,
              "y": -21.95,
              "z": 1.278
            },
            "gtin": "4000521031015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58a7",
            "leftCorner": {
              "x": -12.842,
              "y": -21.947,
              "z": 1.278
            },
            "rightCorner": {
              "x": -12.956,
              "y": -21.948,
              "z": 1.278
            },
            "gtin": "4000521030995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58a8",
            "leftCorner": {
              "x": -12.956,
              "y": -21.943,
              "z": 1.278
            },
            "rightCorner": {
              "x": -13.039,
              "y": -21.944,
              "z": 1.278
            },
            "gtin": "4000521013103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58a9",
            "leftCorner": {
              "x": -13.039,
              "y": -21.943,
              "z": 1.278
            },
            "rightCorner": {
              "x": -13.143,
              "y": -21.944,
              "z": 1.278
            },
            "gtin": "4000521017163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5899",
            "leftCorner": {
              "x": -13.143,
              "y": -21.939,
              "z": 1.278
            },
            "rightCorner": {
              "x": -13.267,
              "y": -21.941,
              "z": 1.278
            },
            "gtin": "4260583930156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e569c031214bd2efa4e90ded",
            "leftCorner": {
              "x": -12.142,
              "y": -21.893,
              "z": 1.278
            },
            "rightCorner": {
              "x": -12.281,
              "y": -21.895,
              "z": 1.278
            },
            "gtin": "4000521004842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d589a",
            "leftCorner": {
              "x": -13.267,
              "y": -21.941,
              "z": 1.278
            },
            "rightCorner": {
              "x": -13.391,
              "y": -21.942,
              "z": 1.278
            },
            "gtin": "4260583930156",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "804"
  },
  {
    "id": "804",
    "name": "804",
    "x": -13.391,
    "y": -21.943,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0056723
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 80
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfab",
        "height": 0.17641,
        "facings": [
          {
            "id": "04a12951aba335a8bbb87516",
            "leftCorner": {
              "x": -13.392,
              "y": -21.87,
              "z": 0.144
            },
            "rightCorner": {
              "x": -13.431,
              "y": -21.87,
              "z": 0.144
            },
            "gtin": "40045252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cd6d4a5f8d791e67035fd3f4",
            "leftCorner": {
              "x": -13.431,
              "y": -21.87,
              "z": 0.144
            },
            "rightCorner": {
              "x": -13.477,
              "y": -21.871,
              "z": 0.144
            },
            "gtin": "4000521030872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1789e156af4d0460c6b2f36b",
            "leftCorner": {
              "x": -13.477,
              "y": -21.871,
              "z": 0.144
            },
            "rightCorner": {
              "x": -13.544,
              "y": -21.872,
              "z": 0.144
            },
            "gtin": "4002809024283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "90de9d419ca5d195f84ae0ef",
            "leftCorner": {
              "x": -13.544,
              "y": -21.872,
              "z": 0.144
            },
            "rightCorner": {
              "x": -13.612,
              "y": -21.872,
              "z": 0.144
            },
            "gtin": "4000521006426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "436281f2b4914a9e8121971e",
            "leftCorner": {
              "x": -13.612,
              "y": -21.872,
              "z": 0.144
            },
            "rightCorner": {
              "x": -13.683,
              "y": -21.873,
              "z": 0.144
            },
            "gtin": "4000521025397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2a9e8c07b8ceb0bf46d8ed98",
            "leftCorner": {
              "x": -13.683,
              "y": -21.873,
              "z": 0.144
            },
            "rightCorner": {
              "x": -13.756,
              "y": -21.874,
              "z": 0.144
            },
            "gtin": "4000521031077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0e805a01af424d7122477b69",
            "leftCorner": {
              "x": -13.756,
              "y": -21.874,
              "z": 0.144
            },
            "rightCorner": {
              "x": -13.83,
              "y": -21.875,
              "z": 0.144
            },
            "gtin": "4000521006822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "773ac7ea58c282d79b5dd9a3",
            "leftCorner": {
              "x": -13.83,
              "y": -21.875,
              "z": 0.144
            },
            "rightCorner": {
              "x": -13.908,
              "y": -21.876,
              "z": 0.144
            },
            "gtin": "4002809024276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5195904ea71bba101a187946",
            "leftCorner": {
              "x": -13.908,
              "y": -21.876,
              "z": 0.144
            },
            "rightCorner": {
              "x": -13.99,
              "y": -21.877,
              "z": 0.144
            },
            "gtin": "4002809024771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "678d794261b47ccc8787d837",
            "leftCorner": {
              "x": -13.99,
              "y": -21.877,
              "z": 0.144
            },
            "rightCorner": {
              "x": -14.072,
              "y": -21.878,
              "z": 0.144
            },
            "gtin": "4000521027001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8c396acf9497336850b44292",
            "leftCorner": {
              "x": -14.072,
              "y": -21.878,
              "z": 0.144
            },
            "rightCorner": {
              "x": -14.155,
              "y": -21.879,
              "z": 0.144
            },
            "gtin": "4000521033828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3e4915150c5b6fb3a85f75cb",
            "leftCorner": {
              "x": -14.155,
              "y": -21.879,
              "z": 0.144
            },
            "rightCorner": {
              "x": -14.24,
              "y": -21.88,
              "z": 0.144
            },
            "gtin": "4000521025458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0cf044268b2a918267b4c915",
            "leftCorner": {
              "x": -14.24,
              "y": -21.88,
              "z": 0.144
            },
            "rightCorner": {
              "x": -14.325,
              "y": -21.881,
              "z": 0.144
            },
            "gtin": "4000521037116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1c7e3490bbd277b0df2ed796",
            "leftCorner": {
              "x": -14.325,
              "y": -21.881,
              "z": 0.144
            },
            "rightCorner": {
              "x": -14.41,
              "y": -21.882,
              "z": 0.144
            },
            "gtin": "4002809024825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1f8fdc88260b499899899ccb",
            "leftCorner": {
              "x": -14.41,
              "y": -21.882,
              "z": 0.144
            },
            "rightCorner": {
              "x": -14.641,
              "y": -21.884,
              "z": 0.144
            },
            "gtin": "4006814001796",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfa8",
        "height": 0.35912,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5938",
            "leftCorner": {
              "x": -13.392,
              "y": -21.908,
              "z": 0.294
            },
            "rightCorner": {
              "x": -13.534,
              "y": -21.909,
              "z": 0.294
            },
            "gtin": "4000521037031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d593a",
            "leftCorner": {
              "x": -13.533,
              "y": -21.956,
              "z": 0.294
            },
            "rightCorner": {
              "x": -13.65,
              "y": -21.958,
              "z": 0.294
            },
            "gtin": "4000521005450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d593b",
            "leftCorner": {
              "x": -13.65,
              "y": -21.95,
              "z": 0.294
            },
            "rightCorner": {
              "x": -13.839,
              "y": -21.953,
              "z": 0.294
            },
            "gtin": "4001743754539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d593c",
            "leftCorner": {
              "x": -13.839,
              "y": -21.957,
              "z": 0.294
            },
            "rightCorner": {
              "x": -14.021,
              "y": -21.959,
              "z": 0.294
            },
            "gtin": "4002309001517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d593d",
            "leftCorner": {
              "x": -14.021,
              "y": -21.959,
              "z": 0.294
            },
            "rightCorner": {
              "x": -14.202,
              "y": -21.961,
              "z": 0.294
            },
            "gtin": "4002309001517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d593e",
            "leftCorner": {
              "x": -14.202,
              "y": -21.952,
              "z": 0.294
            },
            "rightCorner": {
              "x": -14.383,
              "y": -21.954,
              "z": 0.294
            },
            "gtin": "4000521122010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d593f",
            "leftCorner": {
              "x": -14.383,
              "y": -21.955,
              "z": 0.294
            },
            "rightCorner": {
              "x": -14.563,
              "y": -21.957,
              "z": 0.294
            },
            "gtin": "4000521123017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5940",
            "leftCorner": {
              "x": -14.563,
              "y": -21.957,
              "z": 0.294
            },
            "rightCorner": {
              "x": -14.792,
              "y": -21.959,
              "z": 0.294
            },
            "gtin": "40352817",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfa6",
        "height": 0.58195,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5913",
            "leftCorner": {
              "x": -13.391,
              "y": -21.899,
              "z": 0.476
            },
            "rightCorner": {
              "x": -13.527,
              "y": -21.9,
              "z": 0.476
            },
            "gtin": "4000521041946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5915",
            "leftCorner": {
              "x": -13.526,
              "y": -21.947,
              "z": 0.476
            },
            "rightCorner": {
              "x": -13.644,
              "y": -21.948,
              "z": 0.476
            },
            "gtin": "4000521026417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5916",
            "leftCorner": {
              "x": -13.644,
              "y": -21.951,
              "z": 0.476
            },
            "rightCorner": {
              "x": -13.743,
              "y": -21.952,
              "z": 0.476
            },
            "gtin": "4000521026448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5917",
            "leftCorner": {
              "x": -13.743,
              "y": -21.952,
              "z": 0.476
            },
            "rightCorner": {
              "x": -13.961,
              "y": -21.954,
              "z": 0.476
            },
            "gtin": "4000521024581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5918",
            "leftCorner": {
              "x": -13.961,
              "y": -21.943,
              "z": 0.476
            },
            "rightCorner": {
              "x": -14.086,
              "y": -21.945,
              "z": 0.476
            },
            "gtin": "4000521037130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5919",
            "leftCorner": {
              "x": -14.086,
              "y": -21.947,
              "z": 0.476
            },
            "rightCorner": {
              "x": -14.319,
              "y": -21.949,
              "z": 0.476
            },
            "gtin": "4002809024207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d591a",
            "leftCorner": {
              "x": -14.319,
              "y": -21.946,
              "z": 0.476
            },
            "rightCorner": {
              "x": -14.423,
              "y": -21.947,
              "z": 0.476
            },
            "gtin": "4002809028106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d591b",
            "leftCorner": {
              "x": -14.423,
              "y": -21.944,
              "z": 0.476
            },
            "rightCorner": {
              "x": -14.684,
              "y": -21.947,
              "z": 0.476
            },
            "gtin": "4006814001796",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfaa",
        "height": 0.80874,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5960",
            "leftCorner": {
              "x": -13.392,
              "y": -21.901,
              "z": 0.662
            },
            "rightCorner": {
              "x": -13.582,
              "y": -21.903,
              "z": 0.662
            },
            "gtin": "4000521022273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5962",
            "leftCorner": {
              "x": -13.581,
              "y": -21.957,
              "z": 0.662
            },
            "rightCorner": {
              "x": -13.674,
              "y": -21.958,
              "z": 0.662
            },
            "gtin": "4000521026066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5963",
            "leftCorner": {
              "x": -13.674,
              "y": -21.957,
              "z": 0.662
            },
            "rightCorner": {
              "x": -13.74,
              "y": -21.957,
              "z": 0.662
            },
            "gtin": "4000521025397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5964",
            "leftCorner": {
              "x": -13.74,
              "y": -21.957,
              "z": 0.662
            },
            "rightCorner": {
              "x": -13.844,
              "y": -21.958,
              "z": 0.662
            },
            "gtin": "4000521025373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5965",
            "leftCorner": {
              "x": -13.844,
              "y": -21.952,
              "z": 0.662
            },
            "rightCorner": {
              "x": -13.931,
              "y": -21.953,
              "z": 0.662
            },
            "gtin": "4000521033804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5966",
            "leftCorner": {
              "x": -13.931,
              "y": -21.947,
              "z": 0.662
            },
            "rightCorner": {
              "x": -14.011,
              "y": -21.948,
              "z": 0.662
            },
            "gtin": "4000521033828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5967",
            "leftCorner": {
              "x": -14.011,
              "y": -21.946,
              "z": 0.662
            },
            "rightCorner": {
              "x": -14.103,
              "y": -21.947,
              "z": 0.662
            },
            "gtin": "4002809057700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5968",
            "leftCorner": {
              "x": -14.103,
              "y": -21.947,
              "z": 0.662
            },
            "rightCorner": {
              "x": -14.195,
              "y": -21.948,
              "z": 0.662
            },
            "gtin": "4002809057700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5969",
            "leftCorner": {
              "x": -14.195,
              "y": -21.949,
              "z": 0.662
            },
            "rightCorner": {
              "x": -14.348,
              "y": -21.95,
              "z": 0.662
            },
            "gtin": "4000521007263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d596a",
            "leftCorner": {
              "x": -14.348,
              "y": -21.947,
              "z": 0.662
            },
            "rightCorner": {
              "x": -14.458,
              "y": -21.948,
              "z": 0.662
            },
            "gtin": "4002809028472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d596b",
            "leftCorner": {
              "x": -14.458,
              "y": -21.946,
              "z": 0.662
            },
            "rightCorner": {
              "x": -14.626,
              "y": -21.948,
              "z": 0.662
            },
            "gtin": "4104420212572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d596c",
            "leftCorner": {
              "x": -14.626,
              "y": -21.952,
              "z": 0.662
            },
            "rightCorner": {
              "x": -14.745,
              "y": -21.953,
              "z": 0.662
            },
            "gtin": "40045252",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfa7",
        "height": 1.0615,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5924",
            "leftCorner": {
              "x": -13.392,
              "y": -21.901,
              "z": 0.868
            },
            "rightCorner": {
              "x": -13.528,
              "y": -21.902,
              "z": 0.868
            },
            "gtin": "4000521035532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5926",
            "leftCorner": {
              "x": -13.527,
              "y": -21.947,
              "z": 0.868
            },
            "rightCorner": {
              "x": -13.652,
              "y": -21.949,
              "z": 0.868
            },
            "gtin": "4000521019099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5927",
            "leftCorner": {
              "x": -13.652,
              "y": -21.955,
              "z": 0.868
            },
            "rightCorner": {
              "x": -13.756,
              "y": -21.956,
              "z": 0.868
            },
            "gtin": "4000521021450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5928",
            "leftCorner": {
              "x": -13.756,
              "y": -21.953,
              "z": 0.868
            },
            "rightCorner": {
              "x": -13.871,
              "y": -21.954,
              "z": 0.868
            },
            "gtin": "4000521018573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5929",
            "leftCorner": {
              "x": -13.871,
              "y": -21.943,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.022,
              "y": -21.946,
              "z": 0.868
            },
            "gtin": "4000521031671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d592a",
            "leftCorner": {
              "x": -14.022,
              "y": -21.946,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.155,
              "y": -21.947,
              "z": 0.868
            },
            "gtin": "4000521038021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d592b",
            "leftCorner": {
              "x": -14.154,
              "y": -21.949,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.225,
              "y": -21.95,
              "z": 0.868
            },
            "gtin": "4000521006426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d592c",
            "leftCorner": {
              "x": -14.225,
              "y": -21.95,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.331,
              "y": -21.951,
              "z": 0.868
            },
            "gtin": "4000521026509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d592d",
            "leftCorner": {
              "x": -14.331,
              "y": -21.949,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.507,
              "y": -21.951,
              "z": 0.868
            },
            "gtin": "4000521037987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d592e",
            "leftCorner": {
              "x": -14.507,
              "y": -21.949,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.682,
              "y": -21.951,
              "z": 0.868
            },
            "gtin": "4000521022297",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfa9",
        "height": 1.3155,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5947",
            "leftCorner": {
              "x": -13.392,
              "y": -21.905,
              "z": 1.076
            },
            "rightCorner": {
              "x": -13.61,
              "y": -21.907,
              "z": 1.076
            },
            "gtin": "4002809024405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5949",
            "leftCorner": {
              "x": -13.609,
              "y": -21.96,
              "z": 1.076
            },
            "rightCorner": {
              "x": -13.715,
              "y": -21.961,
              "z": 1.076
            },
            "gtin": "4002809026157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d594a",
            "leftCorner": {
              "x": -13.715,
              "y": -21.957,
              "z": 1.076
            },
            "rightCorner": {
              "x": -13.834,
              "y": -21.959,
              "z": 1.076
            },
            "gtin": "4000521030919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d594b",
            "leftCorner": {
              "x": -13.834,
              "y": -21.955,
              "z": 1.076
            },
            "rightCorner": {
              "x": -13.935,
              "y": -21.956,
              "z": 1.076
            },
            "gtin": "4000521030896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d594c",
            "leftCorner": {
              "x": -13.935,
              "y": -21.951,
              "z": 1.076
            },
            "rightCorner": {
              "x": -14.042,
              "y": -21.952,
              "z": 1.076
            },
            "gtin": "4000521006563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d594d",
            "leftCorner": {
              "x": -14.042,
              "y": -21.95,
              "z": 1.076
            },
            "rightCorner": {
              "x": -14.143,
              "y": -21.95,
              "z": 1.076
            },
            "gtin": "4000521006549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d594e",
            "leftCorner": {
              "x": -14.143,
              "y": -21.954,
              "z": 1.076
            },
            "rightCorner": {
              "x": -14.234,
              "y": -21.955,
              "z": 1.076
            },
            "gtin": "4000521007225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d594f",
            "leftCorner": {
              "x": -14.234,
              "y": -21.955,
              "z": 1.076
            },
            "rightCorner": {
              "x": -14.311,
              "y": -21.956,
              "z": 1.076
            },
            "gtin": "4000521031077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5950",
            "leftCorner": {
              "x": -14.311,
              "y": -21.955,
              "z": 1.076
            },
            "rightCorner": {
              "x": -14.406,
              "y": -21.956,
              "z": 1.076
            },
            "gtin": "4000521006686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5951",
            "leftCorner": {
              "x": -14.406,
              "y": -21.954,
              "z": 1.076
            },
            "rightCorner": {
              "x": -14.492,
              "y": -21.955,
              "z": 1.076
            },
            "gtin": "4000521006587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5952",
            "leftCorner": {
              "x": -14.492,
              "y": -21.954,
              "z": 1.076
            },
            "rightCorner": {
              "x": -14.579,
              "y": -21.955,
              "z": 1.076
            },
            "gtin": "4000521042240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5953",
            "leftCorner": {
              "x": -14.579,
              "y": -21.953,
              "z": 1.076
            },
            "rightCorner": {
              "x": -14.682,
              "y": -21.954,
              "z": 1.076
            },
            "gtin": "4000521025458",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfa5",
        "height": 1.5897,
        "facings": [
          {
            "id": "68d8e509e1820c81800d58f9",
            "leftCorner": {
              "x": -13.392,
              "y": -21.9,
              "z": 1.301
            },
            "rightCorner": {
              "x": -13.511,
              "y": -21.902,
              "z": 1.301
            },
            "gtin": "4002809024795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58fb",
            "leftCorner": {
              "x": -13.51,
              "y": -21.947,
              "z": 1.301
            },
            "rightCorner": {
              "x": -13.6,
              "y": -21.948,
              "z": 1.301
            },
            "gtin": "4002809024771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58fc",
            "leftCorner": {
              "x": -13.6,
              "y": -21.951,
              "z": 1.301
            },
            "rightCorner": {
              "x": -13.717,
              "y": -21.952,
              "z": 1.301
            },
            "gtin": "4002809026119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58fd",
            "leftCorner": {
              "x": -13.717,
              "y": -21.959,
              "z": 1.301
            },
            "rightCorner": {
              "x": -13.793,
              "y": -21.96,
              "z": 1.301
            },
            "gtin": "4002809024276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58fe",
            "leftCorner": {
              "x": -13.793,
              "y": -21.941,
              "z": 1.301
            },
            "rightCorner": {
              "x": -13.854,
              "y": -21.942,
              "z": 1.301
            },
            "gtin": "4002809024283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58ff",
            "leftCorner": {
              "x": -13.854,
              "y": -21.919,
              "z": 1.301
            },
            "rightCorner": {
              "x": -13.957,
              "y": -21.92,
              "z": 1.301
            },
            "gtin": "4002809024337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5900",
            "leftCorner": {
              "x": -13.957,
              "y": -21.945,
              "z": 1.301
            },
            "rightCorner": {
              "x": -14.058,
              "y": -21.946,
              "z": 1.301
            },
            "gtin": "4002809024399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5901",
            "leftCorner": {
              "x": -14.058,
              "y": -21.949,
              "z": 1.301
            },
            "rightCorner": {
              "x": -14.11,
              "y": -21.951,
              "z": 1.301
            },
            "gtin": "4002809004346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5902",
            "leftCorner": {
              "x": -14.11,
              "y": -21.945,
              "z": 1.301
            },
            "rightCorner": {
              "x": -14.205,
              "y": -21.947,
              "z": 1.301
            },
            "gtin": "4002809004346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5903",
            "leftCorner": {
              "x": -14.205,
              "y": -21.951,
              "z": 1.301
            },
            "rightCorner": {
              "x": -14.287,
              "y": -21.952,
              "z": 1.301
            },
            "gtin": "4002809024825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5904",
            "leftCorner": {
              "x": -14.287,
              "y": -21.952,
              "z": 1.301
            },
            "rightCorner": {
              "x": -14.374,
              "y": -21.953,
              "z": 1.301
            },
            "gtin": "4000521027001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5905",
            "leftCorner": {
              "x": -14.374,
              "y": -21.952,
              "z": 1.301
            },
            "rightCorner": {
              "x": -14.446,
              "y": -21.952,
              "z": 1.301
            },
            "gtin": "4000521006822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5906",
            "leftCorner": {
              "x": -14.446,
              "y": -21.948,
              "z": 1.301
            },
            "rightCorner": {
              "x": -14.529,
              "y": -21.949,
              "z": 1.301
            },
            "gtin": "4000521034245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5907",
            "leftCorner": {
              "x": -14.529,
              "y": -21.947,
              "z": 1.301
            },
            "rightCorner": {
              "x": -14.606,
              "y": -21.948,
              "z": 1.301
            },
            "gtin": "4000521037116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5908",
            "leftCorner": {
              "x": -14.606,
              "y": -21.948,
              "z": 1.301
            },
            "rightCorner": {
              "x": -14.764,
              "y": -21.95,
              "z": 1.301
            },
            "gtin": "4000521030872",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "803",
    "rightNeighborShelfId": "805"
  },
  {
    "id": "805",
    "name": "805",
    "x": -14.641,
    "y": -21.957,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0056723
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 75
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfb2",
        "height": 0.16937,
        "facings": [
          {
            "id": "68d8e509e1820c81800d58f0",
            "leftCorner": {
              "x": -15.11,
              "y": -21.888,
              "z": 0.139
            },
            "rightCorner": {
              "x": -15.209,
              "y": -21.89,
              "z": 0.139
            },
            "gtin": "4000521007065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58f1",
            "leftCorner": {
              "x": -15.208,
              "y": -21.914,
              "z": 0.139
            },
            "rightCorner": {
              "x": -15.306,
              "y": -21.915,
              "z": 0.139
            },
            "gtin": "40352732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58f2",
            "leftCorner": {
              "x": -15.306,
              "y": -21.877,
              "z": 0.139
            },
            "rightCorner": {
              "x": -15.435,
              "y": -21.879,
              "z": 0.139
            },
            "gtin": "4000521007201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58f3",
            "leftCorner": {
              "x": -15.435,
              "y": -21.877,
              "z": 0.139
            },
            "rightCorner": {
              "x": -15.651,
              "y": -21.879,
              "z": 0.139
            },
            "gtin": "4306188037200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58f4",
            "leftCorner": {
              "x": -15.651,
              "y": -21.88,
              "z": 0.139
            },
            "rightCorner": {
              "x": -15.792,
              "y": -21.881,
              "z": 0.139
            },
            "gtin": "4306188037170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58de",
            "leftCorner": {
              "x": -15.792,
              "y": -21.904,
              "z": 0.139
            },
            "rightCorner": {
              "x": -15.892,
              "y": -21.905,
              "z": 0.139
            },
            "gtin": "42327783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "21c7d584548a16d91cd861ec",
            "leftCorner": {
              "x": -14.642,
              "y": -21.848,
              "z": 0.139
            },
            "rightCorner": {
              "x": -14.768,
              "y": -21.849,
              "z": 0.139
            },
            "gtin": "4000521007201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3970e315d12b35aa95e690d6",
            "leftCorner": {
              "x": -14.768,
              "y": -21.849,
              "z": 0.139
            },
            "rightCorner": {
              "x": -14.867,
              "y": -21.85,
              "z": 0.139
            },
            "gtin": "40352732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a282d8af88d7e97ecb608283",
            "leftCorner": {
              "x": -14.867,
              "y": -21.85,
              "z": 0.139
            },
            "rightCorner": {
              "x": -15.081,
              "y": -21.853,
              "z": 0.139
            },
            "gtin": "4306188037200",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfb0",
        "height": 0.35559,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5941",
            "leftCorner": {
              "x": -14.792,
              "y": -21.961,
              "z": 0.291
            },
            "rightCorner": {
              "x": -14.919,
              "y": -21.962,
              "z": 0.291
            },
            "gtin": "4000521043360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5942",
            "leftCorner": {
              "x": -14.919,
              "y": -21.961,
              "z": 0.291
            },
            "rightCorner": {
              "x": -15.134,
              "y": -21.964,
              "z": 0.291
            },
            "gtin": "4000521102517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5943",
            "leftCorner": {
              "x": -15.134,
              "y": -21.957,
              "z": 0.291
            },
            "rightCorner": {
              "x": -15.316,
              "y": -21.959,
              "z": 0.291
            },
            "gtin": "4000521103019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5944",
            "leftCorner": {
              "x": -15.317,
              "y": -21.949,
              "z": 0.291
            },
            "rightCorner": {
              "x": -15.525,
              "y": -21.952,
              "z": 0.291
            },
            "gtin": "40352831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5945",
            "leftCorner": {
              "x": -15.526,
              "y": -21.949,
              "z": 0.291
            },
            "rightCorner": {
              "x": -15.648,
              "y": -21.95,
              "z": 0.291
            },
            "gtin": "4000521761516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5946",
            "leftCorner": {
              "x": -15.648,
              "y": -21.952,
              "z": 0.291
            },
            "rightCorner": {
              "x": -15.773,
              "y": -21.953,
              "z": 0.291
            },
            "gtin": "4002809021602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5939",
            "leftCorner": {
              "x": -15.773,
              "y": -21.971,
              "z": 0.291
            },
            "rightCorner": {
              "x": -15.891,
              "y": -21.973,
              "z": 0.291
            },
            "gtin": "4000521020224",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "5609121286a1f6f39e416fbf",
            "leftCorner": {
              "x": -14.642,
              "y": -21.912,
              "z": 0.291
            },
            "rightCorner": {
              "x": -14.778,
              "y": -21.914,
              "z": 0.291
            },
            "gtin": "4000521020224",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfb1",
        "height": 0.57873,
        "facings": [
          {
            "id": "68d8e509e1820c81800d591c",
            "leftCorner": {
              "x": -14.684,
              "y": -21.952,
              "z": 0.474
            },
            "rightCorner": {
              "x": -14.929,
              "y": -21.955,
              "z": 0.474
            },
            "gtin": "4000521122706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d591d",
            "leftCorner": {
              "x": -14.928,
              "y": -21.956,
              "z": 0.474
            },
            "rightCorner": {
              "x": -14.985,
              "y": -21.956,
              "z": 0.474
            },
            "gtin": "40352497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d591e",
            "leftCorner": {
              "x": -14.985,
              "y": -21.957,
              "z": 0.474
            },
            "rightCorner": {
              "x": -15.085,
              "y": -21.958,
              "z": 0.474
            },
            "gtin": "40352497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d591f",
            "leftCorner": {
              "x": -15.085,
              "y": -21.95,
              "z": 0.474
            },
            "rightCorner": {
              "x": -15.218,
              "y": -21.952,
              "z": 0.474
            },
            "gtin": "4000521110314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5920",
            "leftCorner": {
              "x": -15.218,
              "y": -21.935,
              "z": 0.474
            },
            "rightCorner": {
              "x": -15.323,
              "y": -21.936,
              "z": 0.474
            },
            "gtin": "4000521117009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5921",
            "leftCorner": {
              "x": -15.322,
              "y": -21.944,
              "z": 0.474
            },
            "rightCorner": {
              "x": -15.403,
              "y": -21.945,
              "z": 0.474
            },
            "gtin": "42244707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5922",
            "leftCorner": {
              "x": -15.403,
              "y": -21.94,
              "z": 0.474
            },
            "rightCorner": {
              "x": -15.641,
              "y": -21.942,
              "z": 0.474
            },
            "gtin": "40352961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5923",
            "leftCorner": {
              "x": -15.641,
              "y": -21.949,
              "z": 0.474
            },
            "rightCorner": {
              "x": -15.74,
              "y": -21.951,
              "z": 0.474
            },
            "gtin": "40045399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5914",
            "leftCorner": {
              "x": -15.739,
              "y": -21.958,
              "z": 0.474
            },
            "rightCorner": {
              "x": -15.891,
              "y": -21.96,
              "z": 0.474
            }
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfaf",
        "height": 0.80537,
        "facings": [
          {
            "id": "68d8e509e1820c81800d596d",
            "leftCorner": {
              "x": -14.745,
              "y": -21.956,
              "z": 0.659
            },
            "rightCorner": {
              "x": -14.822,
              "y": -21.958,
              "z": 0.659
            },
            "gtin": "42256205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d596e",
            "leftCorner": {
              "x": -14.822,
              "y": -21.956,
              "z": 0.659
            },
            "rightCorner": {
              "x": -14.888,
              "y": -21.956,
              "z": 0.659
            },
            "gtin": "42256199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d596f",
            "leftCorner": {
              "x": -14.888,
              "y": -21.958,
              "z": 0.659
            },
            "rightCorner": {
              "x": -14.97,
              "y": -21.959,
              "z": 0.659
            },
            "gtin": "4000521026134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5970",
            "leftCorner": {
              "x": -14.97,
              "y": -21.955,
              "z": 0.659
            },
            "rightCorner": {
              "x": -15.114,
              "y": -21.957,
              "z": 0.659
            },
            "gtin": "4000521026110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5971",
            "leftCorner": {
              "x": -15.114,
              "y": -21.954,
              "z": 0.659
            },
            "rightCorner": {
              "x": -15.221,
              "y": -21.956,
              "z": 0.659
            },
            "gtin": "4000521026158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5972",
            "leftCorner": {
              "x": -15.222,
              "y": -21.953,
              "z": 0.659
            },
            "rightCorner": {
              "x": -15.295,
              "y": -21.954,
              "z": 0.659
            },
            "gtin": "4000521141813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5973",
            "leftCorner": {
              "x": -15.295,
              "y": -21.95,
              "z": 0.659
            },
            "rightCorner": {
              "x": -15.381,
              "y": -21.951,
              "z": 0.659
            },
            "gtin": "4000521140816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5974",
            "leftCorner": {
              "x": -15.381,
              "y": -21.944,
              "z": 0.659
            },
            "rightCorner": {
              "x": -15.451,
              "y": -21.945,
              "z": 0.659
            },
            "gtin": "4000521144814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5975",
            "leftCorner": {
              "x": -15.451,
              "y": -21.946,
              "z": 0.659
            },
            "rightCorner": {
              "x": -15.526,
              "y": -21.947,
              "z": 0.659
            },
            "gtin": "4000521142810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5976",
            "leftCorner": {
              "x": -15.526,
              "y": -21.946,
              "z": 0.659
            },
            "rightCorner": {
              "x": -15.582,
              "y": -21.947,
              "z": 0.659
            },
            "gtin": "4002809021749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5977",
            "leftCorner": {
              "x": -15.582,
              "y": -21.944,
              "z": 0.659
            },
            "rightCorner": {
              "x": -15.661,
              "y": -21.945,
              "z": 0.659
            },
            "gtin": "4002809021749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5978",
            "leftCorner": {
              "x": -15.661,
              "y": -21.952,
              "z": 0.659
            },
            "rightCorner": {
              "x": -15.714,
              "y": -21.952,
              "z": 0.659
            },
            "gtin": "4000521030551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5979",
            "leftCorner": {
              "x": -15.714,
              "y": -21.961,
              "z": 0.659
            },
            "rightCorner": {
              "x": -15.747,
              "y": -21.962,
              "z": 0.659
            },
            "gtin": "4000521020323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d597a",
            "leftCorner": {
              "x": -15.772,
              "y": -21.968,
              "z": 0.659
            },
            "rightCorner": {
              "x": -15.835,
              "y": -21.968,
              "z": 0.659
            },
            "gtin": "4000521021795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5961",
            "leftCorner": {
              "x": -15.834,
              "y": -21.97,
              "z": 0.659
            },
            "rightCorner": {
              "x": -15.891,
              "y": -21.971,
              "z": 0.659
            },
            "gtin": "4000521020323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "059ba26ad5683edfe194c2fe",
            "leftCorner": {
              "x": -14.642,
              "y": -21.909,
              "z": 0.659
            },
            "rightCorner": {
              "x": -14.705,
              "y": -21.91,
              "z": 0.659
            },
            "gtin": "4000521027537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "665e542d51ff4c6a90c32b41",
            "leftCorner": {
              "x": -14.705,
              "y": -21.91,
              "z": 0.659
            },
            "rightCorner": {
              "x": -14.737,
              "y": -21.91,
              "z": 0.659
            },
            "gtin": "4002809021442",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfae",
        "height": 1.0576,
        "facings": [
          {
            "id": "68d8e509e1820c81800d592f",
            "leftCorner": {
              "x": -14.682,
              "y": -21.952,
              "z": 0.865
            },
            "rightCorner": {
              "x": -14.8,
              "y": -21.953,
              "z": 0.865
            },
            "gtin": "4000521007041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5930",
            "leftCorner": {
              "x": -14.8,
              "y": -21.957,
              "z": 0.865
            },
            "rightCorner": {
              "x": -14.894,
              "y": -21.958,
              "z": 0.865
            },
            "gtin": "4002575043297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5931",
            "leftCorner": {
              "x": -14.894,
              "y": -21.957,
              "z": 0.865
            },
            "rightCorner": {
              "x": -15.035,
              "y": -21.958,
              "z": 0.865
            },
            "gtin": "4000521160418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5932",
            "leftCorner": {
              "x": -15.035,
              "y": -21.94,
              "z": 0.865
            },
            "rightCorner": {
              "x": -15.156,
              "y": -21.941,
              "z": 0.865
            },
            "gtin": "4000521164317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5933",
            "leftCorner": {
              "x": -15.156,
              "y": -21.95,
              "z": 0.865
            },
            "rightCorner": {
              "x": -15.278,
              "y": -21.952,
              "z": 0.865
            },
            "gtin": "4000521021603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5934",
            "leftCorner": {
              "x": -15.279,
              "y": -21.935,
              "z": 0.865
            },
            "rightCorner": {
              "x": -15.412,
              "y": -21.937,
              "z": 0.865
            },
            "gtin": "40352848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5935",
            "leftCorner": {
              "x": -15.412,
              "y": -21.941,
              "z": 0.865
            },
            "rightCorner": {
              "x": -15.542,
              "y": -21.943,
              "z": 0.865
            },
            "gtin": "40352855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5936",
            "leftCorner": {
              "x": -15.542,
              "y": -21.946,
              "z": 0.865
            },
            "rightCorner": {
              "x": -15.67,
              "y": -21.948,
              "z": 0.865
            },
            "gtin": "4000521170516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5937",
            "leftCorner": {
              "x": -15.67,
              "y": -21.961,
              "z": 0.865
            },
            "rightCorner": {
              "x": -15.753,
              "y": -21.962,
              "z": 0.865
            },
            "gtin": "42255475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5925",
            "leftCorner": {
              "x": -15.753,
              "y": -21.963,
              "z": 0.865
            },
            "rightCorner": {
              "x": -15.891,
              "y": -21.965,
              "z": 0.865
            },
            "gtin": "40352862",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfad",
        "height": 1.3117,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5954",
            "leftCorner": {
              "x": -14.682,
              "y": -21.961,
              "z": 1.073
            },
            "rightCorner": {
              "x": -14.771,
              "y": -21.962,
              "z": 1.073
            },
            "gtin": "4000521026530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5955",
            "leftCorner": {
              "x": -14.771,
              "y": -21.959,
              "z": 1.073
            },
            "rightCorner": {
              "x": -14.863,
              "y": -21.96,
              "z": 1.073
            },
            "gtin": "4052400021204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5956",
            "leftCorner": {
              "x": -14.863,
              "y": -21.962,
              "z": 1.073
            },
            "rightCorner": {
              "x": -14.929,
              "y": -21.963,
              "z": 1.073
            },
            "gtin": "4002809025853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5957",
            "leftCorner": {
              "x": -14.929,
              "y": -21.96,
              "z": 1.073
            },
            "rightCorner": {
              "x": -15.009,
              "y": -21.961,
              "z": 1.073
            },
            "gtin": "4000521034450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5958",
            "leftCorner": {
              "x": -15.009,
              "y": -21.957,
              "z": 1.073
            },
            "rightCorner": {
              "x": -15.103,
              "y": -21.958,
              "z": 1.073
            },
            "gtin": "4000521721619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5959",
            "leftCorner": {
              "x": -15.103,
              "y": -21.954,
              "z": 1.073
            },
            "rightCorner": {
              "x": -15.185,
              "y": -21.955,
              "z": 1.073
            },
            "gtin": "4000521722609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d595a",
            "leftCorner": {
              "x": -15.185,
              "y": -21.956,
              "z": 1.073
            },
            "rightCorner": {
              "x": -15.288,
              "y": -21.957,
              "z": 1.073
            },
            "gtin": "4000521741006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d595b",
            "leftCorner": {
              "x": -15.289,
              "y": -21.951,
              "z": 1.073
            },
            "rightCorner": {
              "x": -15.396,
              "y": -21.952,
              "z": 1.073
            },
            "gtin": "40352916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d595c",
            "leftCorner": {
              "x": -15.396,
              "y": -21.947,
              "z": 1.073
            },
            "rightCorner": {
              "x": -15.502,
              "y": -21.949,
              "z": 1.073
            },
            "gtin": "4002809050039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d595d",
            "leftCorner": {
              "x": -15.502,
              "y": -21.95,
              "z": 1.073
            },
            "rightCorner": {
              "x": -15.613,
              "y": -21.951,
              "z": 1.073
            },
            "gtin": "40352909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d595e",
            "leftCorner": {
              "x": -15.613,
              "y": -21.951,
              "z": 1.073
            },
            "rightCorner": {
              "x": -15.73,
              "y": -21.952,
              "z": 1.073
            },
            "gtin": "40352886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d595f",
            "leftCorner": {
              "x": -15.73,
              "y": -21.961,
              "z": 1.073
            },
            "rightCorner": {
              "x": -15.811,
              "y": -21.962,
              "z": 1.073
            },
            "gtin": "4002809050107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5948",
            "leftCorner": {
              "x": -15.812,
              "y": -21.97,
              "z": 1.073
            },
            "rightCorner": {
              "x": -15.891,
              "y": -21.971,
              "z": 1.073
            },
            "gtin": "40356709",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfac",
        "height": 1.5866,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5909",
            "leftCorner": {
              "x": -14.764,
              "y": -21.956,
              "z": 1.298
            },
            "rightCorner": {
              "x": -14.848,
              "y": -21.957,
              "z": 1.298
            },
            "gtin": "4000521035099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d590a",
            "leftCorner": {
              "x": -14.848,
              "y": -21.955,
              "z": 1.298
            },
            "rightCorner": {
              "x": -14.973,
              "y": -21.956,
              "z": 1.298
            },
            "gtin": "4000521034436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d590b",
            "leftCorner": {
              "x": -14.974,
              "y": -21.935,
              "z": 1.298
            },
            "rightCorner": {
              "x": -15.113,
              "y": -21.936,
              "z": 1.298
            },
            "gtin": "4000521130107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d590c",
            "leftCorner": {
              "x": -15.113,
              "y": -21.952,
              "z": 1.298
            },
            "rightCorner": {
              "x": -15.208,
              "y": -21.953,
              "z": 1.298
            },
            "gtin": "4000521034412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d590d",
            "leftCorner": {
              "x": -15.209,
              "y": -21.95,
              "z": 1.298
            },
            "rightCorner": {
              "x": -15.293,
              "y": -21.951,
              "z": 1.298
            },
            "gtin": "4000521034351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d590e",
            "leftCorner": {
              "x": -15.294,
              "y": -21.944,
              "z": 1.298
            },
            "rightCorner": {
              "x": -15.394,
              "y": -21.945,
              "z": 1.298
            },
            "gtin": "4002809001253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d590f",
            "leftCorner": {
              "x": -15.394,
              "y": -21.943,
              "z": 1.298
            },
            "rightCorner": {
              "x": -15.483,
              "y": -21.944,
              "z": 1.298
            },
            "gtin": "4002809021756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5910",
            "leftCorner": {
              "x": -15.483,
              "y": -21.946,
              "z": 1.298
            },
            "rightCorner": {
              "x": -15.557,
              "y": -21.947,
              "z": 1.298
            },
            "gtin": "4104420026780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5911",
            "leftCorner": {
              "x": -15.558,
              "y": -21.943,
              "z": 1.298
            },
            "rightCorner": {
              "x": -15.65,
              "y": -21.944,
              "z": 1.298
            },
            "gtin": "4021155133067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5912",
            "leftCorner": {
              "x": -15.65,
              "y": -21.954,
              "z": 1.298
            },
            "rightCorner": {
              "x": -15.769,
              "y": -21.956,
              "z": 1.298
            },
            "gtin": "4002689007147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d58fa",
            "leftCorner": {
              "x": -15.769,
              "y": -21.973,
              "z": 1.298
            },
            "rightCorner": {
              "x": -15.891,
              "y": -21.975,
              "z": 1.298
            },
            "gtin": "4003310014183",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5a63dbd3a65645e2570b8b66",
            "leftCorner": {
              "x": -14.642,
              "y": -21.903,
              "z": 1.298
            },
            "rightCorner": {
              "x": -14.744,
              "y": -21.904,
              "z": 1.298
            },
            "gtin": "4000521034412",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "804"
  },
  {
    "id": "806",
    "name": "806",
    "x": -15.903,
    "y": -23.175,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0017017,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfb8",
        "height": 0.17337,
        "facings": [
          {
            "id": "c6c9a8dead0a796448a9cc49",
            "leftCorner": {
              "x": -15.903,
              "y": -23.268,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.688,
              "y": -23.267,
              "z": 0.142
            },
            "gtin": "4006363100100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "03276ef6371433e581c9ec2a",
            "leftCorner": {
              "x": -15.688,
              "y": -23.267,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.564,
              "y": -23.267,
              "z": 0.142
            },
            "gtin": "4006363114312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b47fd53e71df03aa69615485",
            "leftCorner": {
              "x": -15.564,
              "y": -23.267,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.437,
              "y": -23.266,
              "z": 0.142
            },
            "gtin": "4000406004363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2b96e9bddd70cf8472fb7f05",
            "leftCorner": {
              "x": -15.437,
              "y": -23.266,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.309,
              "y": -23.266,
              "z": 0.142
            },
            "gtin": "4104420181427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "38cba1d170e48452f9f61070",
            "leftCorner": {
              "x": -15.309,
              "y": -23.266,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.159,
              "y": -23.265,
              "z": 0.142
            },
            "gtin": "4260175671306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b0d500e6cf8ad25c4de1ecbb",
            "leftCorner": {
              "x": -15.159,
              "y": -23.265,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.006,
              "y": -23.265,
              "z": 0.142
            },
            "gtin": "4104420181489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5d28cdeb81982d8f1d252068",
            "leftCorner": {
              "x": -15.006,
              "y": -23.265,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.843,
              "y": -23.264,
              "z": 0.142
            },
            "gtin": "4260175670774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "69462c71cd13df850ea8cc7f",
            "leftCorner": {
              "x": -14.843,
              "y": -23.264,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.659,
              "y": -23.264,
              "z": 0.142
            },
            "gtin": "4104420021884",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfb7",
        "height": 0.4042,
        "facings": [
          {
            "id": "68d8e509e1820c81800d59c2",
            "leftCorner": {
              "x": -15.903,
              "y": -23.217,
              "z": 0.331
            },
            "rightCorner": {
              "x": -15.713,
              "y": -23.216,
              "z": 0.331
            },
            "gtin": "4006363109554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59c3",
            "leftCorner": {
              "x": -15.713,
              "y": -23.216,
              "z": 0.331
            },
            "rightCorner": {
              "x": -15.523,
              "y": -23.216,
              "z": 0.331
            },
            "gtin": "4006363109554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59c5",
            "leftCorner": {
              "x": -15.524,
              "y": -23.172,
              "z": 0.331
            },
            "rightCorner": {
              "x": -15.28,
              "y": -23.171,
              "z": 0.331
            },
            "gtin": "4006363112738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59c6",
            "leftCorner": {
              "x": -15.28,
              "y": -23.168,
              "z": 0.331
            },
            "rightCorner": {
              "x": -15.097,
              "y": -23.167,
              "z": 0.331
            },
            "gtin": "4006363112394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59c7",
            "leftCorner": {
              "x": -15.097,
              "y": -23.183,
              "z": 0.331
            },
            "rightCorner": {
              "x": -14.981,
              "y": -23.183,
              "z": 0.331
            },
            "gtin": "4006363114312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59c8",
            "leftCorner": {
              "x": -14.981,
              "y": -23.18,
              "z": 0.331
            },
            "rightCorner": {
              "x": -14.78,
              "y": -23.179,
              "z": 0.331
            },
            "gtin": "4006363114251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59c9",
            "leftCorner": {
              "x": -14.78,
              "y": -23.173,
              "z": 0.331
            },
            "rightCorner": {
              "x": -14.529,
              "y": -23.173,
              "z": 0.331
            },
            "gtin": "4000406004363",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfb5",
        "height": 0.65087,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5997",
            "leftCorner": {
              "x": -15.903,
              "y": -23.222,
              "z": 0.533
            },
            "rightCorner": {
              "x": -15.665,
              "y": -23.221,
              "z": 0.533
            },
            "gtin": "4000950100740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5999",
            "leftCorner": {
              "x": -15.665,
              "y": -23.182,
              "z": 0.533
            },
            "rightCorner": {
              "x": -15.381,
              "y": -23.181,
              "z": 0.533
            },
            "gtin": "4250426223620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d599a",
            "leftCorner": {
              "x": -15.382,
              "y": -23.173,
              "z": 0.533
            },
            "rightCorner": {
              "x": -15.268,
              "y": -23.173,
              "z": 0.533
            },
            "gtin": "4000950440549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d599b",
            "leftCorner": {
              "x": -15.268,
              "y": -23.173,
              "z": 0.533
            },
            "rightCorner": {
              "x": -15.154,
              "y": -23.173,
              "z": 0.533
            },
            "gtin": "4000950440549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d599c",
            "leftCorner": {
              "x": -15.154,
              "y": -23.173,
              "z": 0.533
            },
            "rightCorner": {
              "x": -15.041,
              "y": -23.172,
              "z": 0.533
            },
            "gtin": "4000950440549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d599d",
            "leftCorner": {
              "x": -15.041,
              "y": -23.19,
              "z": 0.533
            },
            "rightCorner": {
              "x": -14.807,
              "y": -23.19,
              "z": 0.533
            },
            "gtin": "4000950006035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d599e",
            "leftCorner": {
              "x": -14.807,
              "y": -23.178,
              "z": 0.533
            },
            "rightCorner": {
              "x": -14.653,
              "y": -23.177,
              "z": 0.533
            },
            "gtin": "4000950006127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfb6",
        "height": 0.95354,
        "facings": [
          {
            "id": "68d8e509e1820c81800d59b5",
            "leftCorner": {
              "x": -15.903,
              "y": -23.218,
              "z": 0.78
            },
            "rightCorner": {
              "x": -15.475,
              "y": -23.217,
              "z": 0.78
            },
            "gtin": "4006363100001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59b7",
            "leftCorner": {
              "x": -15.475,
              "y": -23.173,
              "z": 0.78
            },
            "rightCorner": {
              "x": -15.303,
              "y": -23.173,
              "z": 0.78
            },
            "gtin": "4000950562401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59b8",
            "leftCorner": {
              "x": -15.303,
              "y": -23.169,
              "z": 0.78
            },
            "rightCorner": {
              "x": -15.073,
              "y": -23.169,
              "z": 0.78
            },
            "gtin": "4000950672971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59b9",
            "leftCorner": {
              "x": -15.073,
              "y": -23.186,
              "z": 0.78
            },
            "rightCorner": {
              "x": -14.889,
              "y": -23.185,
              "z": 0.78
            },
            "gtin": "4000950072108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59ba",
            "leftCorner": {
              "x": -14.889,
              "y": -23.18,
              "z": 0.78
            },
            "rightCorner": {
              "x": -14.511,
              "y": -23.178,
              "z": 0.78
            },
            "gtin": "4000950072207",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfb4",
        "height": 1.2552,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5989",
            "leftCorner": {
              "x": -15.903,
              "y": -23.217,
              "z": 1.027
            },
            "rightCorner": {
              "x": -15.68,
              "y": -23.217,
              "z": 1.027
            },
            "gtin": "4104420241497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d598a",
            "leftCorner": {
              "x": -15.68,
              "y": -23.217,
              "z": 1.027
            },
            "rightCorner": {
              "x": -15.457,
              "y": -23.216,
              "z": 1.027
            },
            "gtin": "4104420241497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d598c",
            "leftCorner": {
              "x": -15.457,
              "y": -23.173,
              "z": 1.027
            },
            "rightCorner": {
              "x": -15.25,
              "y": -23.172,
              "z": 1.027
            },
            "gtin": "4104420256637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d598d",
            "leftCorner": {
              "x": -15.25,
              "y": -23.171,
              "z": 1.027
            },
            "rightCorner": {
              "x": -15.044,
              "y": -23.17,
              "z": 1.027
            },
            "gtin": "4104420241527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d598e",
            "leftCorner": {
              "x": -15.043,
              "y": -23.189,
              "z": 1.027
            },
            "rightCorner": {
              "x": -14.842,
              "y": -23.189,
              "z": 1.027
            },
            "gtin": "4104420230903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d598f",
            "leftCorner": {
              "x": -14.842,
              "y": -23.184,
              "z": 1.027
            },
            "rightCorner": {
              "x": -14.608,
              "y": -23.184,
              "z": 1.027
            },
            "gtin": "4104420021884",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfb3",
        "height": 1.5589,
        "facings": [
          {
            "id": "68d8e509e1820c81800d597b",
            "leftCorner": {
              "x": -15.903,
              "y": -23.223,
              "z": 1.275
            },
            "rightCorner": {
              "x": -15.628,
              "y": -23.222,
              "z": 1.275
            },
            "gtin": "4104420181458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d597d",
            "leftCorner": {
              "x": -15.628,
              "y": -23.179,
              "z": 1.275
            },
            "rightCorner": {
              "x": -15.506,
              "y": -23.178,
              "z": 1.275
            },
            "gtin": "4104420181427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d597e",
            "leftCorner": {
              "x": -15.506,
              "y": -23.18,
              "z": 1.275
            },
            "rightCorner": {
              "x": -15.436,
              "y": -23.179,
              "z": 1.275
            },
            "gtin": "4104420016767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d597f",
            "leftCorner": {
              "x": -15.436,
              "y": -23.179,
              "z": 1.275
            },
            "rightCorner": {
              "x": -15.366,
              "y": -23.179,
              "z": 1.275
            },
            "gtin": "4104420016767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5980",
            "leftCorner": {
              "x": -15.366,
              "y": -23.179,
              "z": 1.275
            },
            "rightCorner": {
              "x": -15.297,
              "y": -23.179,
              "z": 1.275
            },
            "gtin": "4104420016767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5981",
            "leftCorner": {
              "x": -15.297,
              "y": -23.176,
              "z": 1.275
            },
            "rightCorner": {
              "x": -15.137,
              "y": -23.176,
              "z": 1.275
            },
            "gtin": "4104420181489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5982",
            "leftCorner": {
              "x": -15.137,
              "y": -23.199,
              "z": 1.275
            },
            "rightCorner": {
              "x": -14.954,
              "y": -23.198,
              "z": 1.275
            },
            "gtin": "4260175671153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5983",
            "leftCorner": {
              "x": -14.954,
              "y": -23.19,
              "z": 1.275
            },
            "rightCorner": {
              "x": -14.798,
              "y": -23.19,
              "z": 1.275
            },
            "gtin": "4260175671306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5984",
            "leftCorner": {
              "x": -14.798,
              "y": -23.218,
              "z": 1.275
            },
            "rightCorner": {
              "x": -14.612,
              "y": -23.218,
              "z": 1.275
            },
            "gtin": "4260175670774",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "807"
  },
  {
    "id": "807",
    "name": "807",
    "x": -14.653,
    "y": -23.171,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0017017,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 31
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfb9",
        "height": 0.40253,
        "facings": [
          {
            "id": "68d8e509e1820c81800d59ca",
            "leftCorner": {
              "x": -14.528,
              "y": -23.178,
              "z": 0.329
            },
            "rightCorner": {
              "x": -14.21,
              "y": -23.177,
              "z": 0.329
            },
            "gtin": "4250426223606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59cb",
            "leftCorner": {
              "x": -14.21,
              "y": -23.167,
              "z": 0.329
            },
            "rightCorner": {
              "x": -13.915,
              "y": -23.166,
              "z": 0.329
            },
            "gtin": "4000950103574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59cc",
            "leftCorner": {
              "x": -13.915,
              "y": -23.171,
              "z": 0.329
            },
            "rightCorner": {
              "x": -13.645,
              "y": -23.169,
              "z": 0.329
            },
            "gtin": "4000950103567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59cd",
            "leftCorner": {
              "x": -13.645,
              "y": -23.166,
              "z": 0.329
            },
            "rightCorner": {
              "x": -13.362,
              "y": -23.166,
              "z": 0.329
            },
            "gtin": "4000286200169",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfbd",
        "height": 0.65039,
        "facings": [
          {
            "id": "68d8e509e1820c81800d599f",
            "leftCorner": {
              "x": -14.652,
              "y": -23.179,
              "z": 0.532
            },
            "rightCorner": {
              "x": -14.403,
              "y": -23.18,
              "z": 0.532
            },
            "gtin": "4000950670359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59a0",
            "leftCorner": {
              "x": -14.403,
              "y": -23.177,
              "z": 0.532
            },
            "rightCorner": {
              "x": -14.105,
              "y": -23.176,
              "z": 0.532
            },
            "gtin": "4000950670359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59a1",
            "leftCorner": {
              "x": -14.105,
              "y": -23.174,
              "z": 0.532
            },
            "rightCorner": {
              "x": -13.854,
              "y": -23.173,
              "z": 0.532
            },
            "gtin": "4000950571977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59a2",
            "leftCorner": {
              "x": -13.854,
              "y": -23.179,
              "z": 0.532
            },
            "rightCorner": {
              "x": -13.733,
              "y": -23.178,
              "z": 0.532
            },
            "gtin": "4000950072016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59a3",
            "leftCorner": {
              "x": -13.733,
              "y": -23.182,
              "z": 0.532
            },
            "rightCorner": {
              "x": -13.375,
              "y": -23.181,
              "z": 0.532
            },
            "gtin": "4250780302535",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfbc",
        "height": 0.95256,
        "facings": [
          {
            "id": "68d8e509e1820c81800d59bb",
            "leftCorner": {
              "x": -14.51,
              "y": -23.183,
              "z": 0.779
            },
            "rightCorner": {
              "x": -14.413,
              "y": -23.183,
              "z": 0.779
            },
            "gtin": "4250780320867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59bc",
            "leftCorner": {
              "x": -14.413,
              "y": -23.176,
              "z": 0.779
            },
            "rightCorner": {
              "x": -14.329,
              "y": -23.175,
              "z": 0.779
            },
            "gtin": "40045078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59bd",
            "leftCorner": {
              "x": -14.329,
              "y": -23.172,
              "z": 0.779
            },
            "rightCorner": {
              "x": -14.229,
              "y": -23.172,
              "z": 0.779
            },
            "gtin": "4000521028152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59be",
            "leftCorner": {
              "x": -14.229,
              "y": -23.171,
              "z": 0.779
            },
            "rightCorner": {
              "x": -14.058,
              "y": -23.169,
              "z": 0.779
            },
            "gtin": "4002809021626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59bf",
            "leftCorner": {
              "x": -14.058,
              "y": -23.196,
              "z": 0.779
            },
            "rightCorner": {
              "x": -13.88,
              "y": -23.196,
              "z": 0.779
            },
            "gtin": "4008391085169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59c0",
            "leftCorner": {
              "x": -13.88,
              "y": -23.177,
              "z": 0.779
            },
            "rightCorner": {
              "x": -13.716,
              "y": -23.176,
              "z": 0.779
            },
            "gtin": "4008391085077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59c1",
            "leftCorner": {
              "x": -13.716,
              "y": -23.175,
              "z": 0.779
            },
            "rightCorner": {
              "x": -13.535,
              "y": -23.175,
              "z": 0.779
            },
            "gtin": "4008391024014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59b6",
            "leftCorner": {
              "x": -13.535,
              "y": -23.172,
              "z": 0.779
            },
            "rightCorner": {
              "x": -13.403,
              "y": -23.172,
              "z": 0.779
            },
            "gtin": "4008391023000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "234a27a60e8bc96d658a080a",
            "leftCorner": {
              "x": -14.652,
              "y": -23.217,
              "z": 0.779
            },
            "rightCorner": {
              "x": -14.519,
              "y": -23.217,
              "z": 0.779
            },
            "gtin": "4008391023000",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfba",
        "height": 1.2551,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5990",
            "leftCorner": {
              "x": -14.607,
              "y": -23.182,
              "z": 1.027
            },
            "rightCorner": {
              "x": -14.441,
              "y": -23.182,
              "z": 1.027
            },
            "gtin": "4104420140684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5991",
            "leftCorner": {
              "x": -14.441,
              "y": -23.178,
              "z": 1.027
            },
            "rightCorner": {
              "x": -14.266,
              "y": -23.176,
              "z": 1.027
            },
            "gtin": "4104420016569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5992",
            "leftCorner": {
              "x": -14.266,
              "y": -23.173,
              "z": 1.027
            },
            "rightCorner": {
              "x": -14.1,
              "y": -23.173,
              "z": 1.027
            },
            "gtin": "4104420016545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5993",
            "leftCorner": {
              "x": -14.1,
              "y": -23.173,
              "z": 1.027
            },
            "rightCorner": {
              "x": -13.99,
              "y": -23.173,
              "z": 1.027
            },
            "gtin": "4104420016521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5994",
            "leftCorner": {
              "x": -13.99,
              "y": -23.176,
              "z": 1.027
            },
            "rightCorner": {
              "x": -13.829,
              "y": -23.175,
              "z": 1.027
            },
            "gtin": "4006363101435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5995",
            "leftCorner": {
              "x": -13.829,
              "y": -23.176,
              "z": 1.027
            },
            "rightCorner": {
              "x": -13.667,
              "y": -23.176,
              "z": 1.027
            },
            "gtin": "4006363103309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5996",
            "leftCorner": {
              "x": -13.667,
              "y": -23.172,
              "z": 1.027
            },
            "rightCorner": {
              "x": -13.506,
              "y": -23.171,
              "z": 1.027
            },
            "gtin": "4006363101442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d598b",
            "leftCorner": {
              "x": -13.506,
              "y": -23.174,
              "z": 1.027
            },
            "rightCorner": {
              "x": -13.403,
              "y": -23.173,
              "z": 1.027
            },
            "gtin": "4006363101428",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfbb",
        "height": 1.5551,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5985",
            "leftCorner": {
              "x": -14.611,
              "y": -23.188,
              "z": 1.272
            },
            "rightCorner": {
              "x": -14.358,
              "y": -23.188,
              "z": 1.272
            },
            "gtin": "4006363113209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5986",
            "leftCorner": {
              "x": -14.358,
              "y": -23.18,
              "z": 1.272
            },
            "rightCorner": {
              "x": -14.12,
              "y": -23.18,
              "z": 1.272
            },
            "gtin": "4006363101107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5987",
            "leftCorner": {
              "x": -14.12,
              "y": -23.177,
              "z": 1.272
            },
            "rightCorner": {
              "x": -13.767,
              "y": -23.176,
              "z": 1.272
            },
            "gtin": "4006363101077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5988",
            "leftCorner": {
              "x": -13.767,
              "y": -23.182,
              "z": 1.272
            },
            "rightCorner": {
              "x": -13.541,
              "y": -23.181,
              "z": 1.272
            },
            "gtin": "4006363101138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d597c",
            "leftCorner": {
              "x": -13.541,
              "y": -23.177,
              "z": 1.272
            },
            "rightCorner": {
              "x": -13.402,
              "y": -23.176,
              "z": 1.272
            },
            "gtin": "4046800110750",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "806",
    "rightNeighborShelfId": "808"
  },
  {
    "id": "808",
    "name": "808",
    "x": -13.403,
    "y": -23.166,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0017017,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 67
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfc4",
        "height": 0.16031,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a1d",
            "leftCorner": {
              "x": -13.402,
              "y": -23.276,
              "z": 0.131
            },
            "rightCorner": {
              "x": -13.005,
              "y": -23.275,
              "z": 0.131
            },
            "gtin": "4002809001062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a1f",
            "leftCorner": {
              "x": -13.006,
              "y": -23.226,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.772,
              "y": -23.225,
              "z": 0.131
            },
            "gtin": "4002809001093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a20",
            "leftCorner": {
              "x": -12.772,
              "y": -23.231,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.663,
              "y": -23.232,
              "z": 0.131
            },
            "gtin": "4002809001086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a21",
            "leftCorner": {
              "x": -12.663,
              "y": -23.233,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.49,
              "y": -23.232,
              "z": 0.131
            },
            "gtin": "4000521364700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a22",
            "leftCorner": {
              "x": -12.49,
              "y": -23.233,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.401,
              "y": -23.233,
              "z": 0.131
            },
            "gtin": "4000521364205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a23",
            "leftCorner": {
              "x": -12.401,
              "y": -23.233,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.301,
              "y": -23.232,
              "z": 0.131
            },
            "gtin": "40352046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a1e",
            "leftCorner": {
              "x": -12.301,
              "y": -23.233,
              "z": 0.131
            },
            "rightCorner": {
              "x": -12.152,
              "y": -23.233,
              "z": 0.131
            },
            "gtin": "40352145",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfbe",
        "height": 0.40508,
        "facings": [
          {
            "id": "68d8e509e1820c81800d59ce",
            "leftCorner": {
              "x": -13.362,
              "y": -23.163,
              "z": 0.331
            },
            "rightCorner": {
              "x": -13.286,
              "y": -23.163,
              "z": 0.331
            },
            "gtin": "40352398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59cf",
            "leftCorner": {
              "x": -13.286,
              "y": -23.16,
              "z": 0.331
            },
            "rightCorner": {
              "x": -13.187,
              "y": -23.161,
              "z": 0.331
            },
            "gtin": "40352404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59d0",
            "leftCorner": {
              "x": -13.187,
              "y": -23.16,
              "z": 0.331
            },
            "rightCorner": {
              "x": -13.105,
              "y": -23.16,
              "z": 0.331
            },
            "gtin": "40352329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59d1",
            "leftCorner": {
              "x": -13.105,
              "y": -23.162,
              "z": 0.331
            },
            "rightCorner": {
              "x": -13.007,
              "y": -23.161,
              "z": 0.331
            },
            "gtin": "40352312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59d2",
            "leftCorner": {
              "x": -13.007,
              "y": -23.159,
              "z": 0.331
            },
            "rightCorner": {
              "x": -12.91,
              "y": -23.159,
              "z": 0.331
            },
            "gtin": "40352336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59d3",
            "leftCorner": {
              "x": -12.91,
              "y": -23.158,
              "z": 0.331
            },
            "rightCorner": {
              "x": -12.724,
              "y": -23.158,
              "z": 0.331
            },
            "gtin": "4000521026721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59d4",
            "leftCorner": {
              "x": -12.724,
              "y": -23.161,
              "z": 0.331
            },
            "rightCorner": {
              "x": -12.645,
              "y": -23.16,
              "z": 0.331
            },
            "gtin": "4000521026769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59d5",
            "leftCorner": {
              "x": -12.645,
              "y": -23.165,
              "z": 0.331
            },
            "rightCorner": {
              "x": -12.503,
              "y": -23.164,
              "z": 0.331
            },
            "gtin": "4000521026745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59d6",
            "leftCorner": {
              "x": -12.503,
              "y": -23.165,
              "z": 0.331
            },
            "rightCorner": {
              "x": -12.337,
              "y": -23.164,
              "z": 0.331
            },
            "gtin": "4000521003159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59d7",
            "leftCorner": {
              "x": -12.337,
              "y": -23.167,
              "z": 0.331
            },
            "rightCorner": {
              "x": -12.251,
              "y": -23.166,
              "z": 0.331
            },
            "gtin": "4000521003173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59d8",
            "leftCorner": {
              "x": -12.251,
              "y": -23.171,
              "z": 0.331
            },
            "rightCorner": {
              "x": -12.032,
              "y": -23.171,
              "z": 0.331
            },
            "gtin": "4000521222406",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfbf",
        "height": 0.65248,
        "facings": [
          {
            "id": "68d8e509e1820c81800d59a4",
            "leftCorner": {
              "x": -13.375,
              "y": -23.178,
              "z": 0.534
            },
            "rightCorner": {
              "x": -13.263,
              "y": -23.178,
              "z": 0.534
            },
            "gtin": "5701116201095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59a5",
            "leftCorner": {
              "x": -13.264,
              "y": -23.169,
              "z": 0.534
            },
            "rightCorner": {
              "x": -13.055,
              "y": -23.168,
              "z": 0.534
            },
            "gtin": "4012200387900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59a6",
            "leftCorner": {
              "x": -13.055,
              "y": -23.167,
              "z": 0.534
            },
            "rightCorner": {
              "x": -12.78,
              "y": -23.166,
              "z": 0.534
            },
            "gtin": "4012200387801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59a7",
            "leftCorner": {
              "x": -12.78,
              "y": -23.167,
              "z": 0.534
            },
            "rightCorner": {
              "x": -12.671,
              "y": -23.167,
              "z": 0.534
            },
            "gtin": "40352282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59a8",
            "leftCorner": {
              "x": -12.671,
              "y": -23.172,
              "z": 0.534
            },
            "rightCorner": {
              "x": -12.444,
              "y": -23.171,
              "z": 0.534
            },
            "gtin": "4000521301712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59a9",
            "leftCorner": {
              "x": -12.444,
              "y": -23.174,
              "z": 0.534
            },
            "rightCorner": {
              "x": -12.337,
              "y": -23.173,
              "z": 0.534
            },
            "gtin": "4002809018862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59aa",
            "leftCorner": {
              "x": -12.337,
              "y": -23.168,
              "z": 0.534
            },
            "rightCorner": {
              "x": -12.267,
              "y": -23.168,
              "z": 0.534
            },
            "gtin": "4002809018985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59ab",
            "leftCorner": {
              "x": -12.267,
              "y": -23.176,
              "z": 0.534
            },
            "rightCorner": {
              "x": -12.149,
              "y": -23.176,
              "z": 0.534
            },
            "gtin": "4002809018879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59ac",
            "leftCorner": {
              "x": -12.149,
              "y": -23.183,
              "z": 0.534
            },
            "rightCorner": {
              "x": -12.063,
              "y": -23.182,
              "z": 0.534
            },
            "gtin": "4002809018893",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfc5",
        "height": 0.90481,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a24",
            "leftCorner": {
              "x": -13.403,
              "y": -23.212,
              "z": 0.74
            },
            "rightCorner": {
              "x": -13.155,
              "y": -23.211,
              "z": 0.74
            },
            "gtin": "4002809019098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a26",
            "leftCorner": {
              "x": -13.155,
              "y": -23.17,
              "z": 0.74
            },
            "rightCorner": {
              "x": -13.023,
              "y": -23.169,
              "z": 0.74
            },
            "gtin": "4002809019050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a27",
            "leftCorner": {
              "x": -13.023,
              "y": -23.166,
              "z": 0.74
            },
            "rightCorner": {
              "x": -12.863,
              "y": -23.166,
              "z": 0.74
            },
            "gtin": "40352039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a28",
            "leftCorner": {
              "x": -12.863,
              "y": -23.168,
              "z": 0.74
            },
            "rightCorner": {
              "x": -12.751,
              "y": -23.167,
              "z": 0.74
            },
            "gtin": "4000521009441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a29",
            "leftCorner": {
              "x": -12.751,
              "y": -23.169,
              "z": 0.74
            },
            "rightCorner": {
              "x": -12.642,
              "y": -23.169,
              "z": 0.74
            },
            "gtin": "4000521607500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a2a",
            "leftCorner": {
              "x": -12.642,
              "y": -23.17,
              "z": 0.74
            },
            "rightCorner": {
              "x": -12.513,
              "y": -23.169,
              "z": 0.74
            },
            "gtin": "4000521005177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a2b",
            "leftCorner": {
              "x": -12.513,
              "y": -23.176,
              "z": 0.74
            },
            "rightCorner": {
              "x": -12.412,
              "y": -23.177,
              "z": 0.74
            },
            "gtin": "4000521820206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a2c",
            "leftCorner": {
              "x": -12.412,
              "y": -23.172,
              "z": 0.74
            },
            "rightCorner": {
              "x": -12.293,
              "y": -23.171,
              "z": 0.74
            },
            "gtin": "4000521821203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a2d",
            "leftCorner": {
              "x": -12.293,
              "y": -23.173,
              "z": 0.74
            },
            "rightCorner": {
              "x": -12.179,
              "y": -23.173,
              "z": 0.74
            },
            "gtin": "4000521823207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a2e",
            "leftCorner": {
              "x": -12.179,
              "y": -23.176,
              "z": 0.74
            },
            "rightCorner": {
              "x": -12.08,
              "y": -23.175,
              "z": 0.74
            },
            "gtin": "4000521453602",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfc0",
        "height": 1.1568,
        "facings": [
          {
            "id": "68d8e509e1820c81800d59e4",
            "leftCorner": {
              "x": -13.403,
              "y": -23.212,
              "z": 0.946
            },
            "rightCorner": {
              "x": -13.265,
              "y": -23.212,
              "z": 0.946
            },
            "gtin": "4000521027421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59e6",
            "leftCorner": {
              "x": -13.265,
              "y": -23.172,
              "z": 0.946
            },
            "rightCorner": {
              "x": -13.156,
              "y": -23.171,
              "z": 0.946
            },
            "gtin": "4000521027384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59e7",
            "leftCorner": {
              "x": -13.156,
              "y": -23.173,
              "z": 0.946
            },
            "rightCorner": {
              "x": -13.041,
              "y": -23.172,
              "z": 0.946
            },
            "gtin": "4000521027407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59e8",
            "leftCorner": {
              "x": -13.042,
              "y": -23.165,
              "z": 0.946
            },
            "rightCorner": {
              "x": -12.935,
              "y": -23.165,
              "z": 0.946
            },
            "gtin": "4000521007997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59e9",
            "leftCorner": {
              "x": -12.935,
              "y": -23.165,
              "z": 0.946
            },
            "rightCorner": {
              "x": -12.816,
              "y": -23.164,
              "z": 0.946
            },
            "gtin": "4000521008031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59ea",
            "leftCorner": {
              "x": -12.815,
              "y": -23.168,
              "z": 0.946
            },
            "rightCorner": {
              "x": -12.708,
              "y": -23.168,
              "z": 0.946
            },
            "gtin": "4000521012670",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59eb",
            "leftCorner": {
              "x": -12.708,
              "y": -23.17,
              "z": 0.946
            },
            "rightCorner": {
              "x": -12.58,
              "y": -23.169,
              "z": 0.946
            },
            "gtin": "4000521033545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59ec",
            "leftCorner": {
              "x": -12.58,
              "y": -23.17,
              "z": 0.946
            },
            "rightCorner": {
              "x": -12.465,
              "y": -23.17,
              "z": 0.946
            },
            "gtin": "4000521467401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59ed",
            "leftCorner": {
              "x": -12.465,
              "y": -23.174,
              "z": 0.946
            },
            "rightCorner": {
              "x": -12.369,
              "y": -23.174,
              "z": 0.946
            },
            "gtin": "4000521466503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59ee",
            "leftCorner": {
              "x": -12.369,
              "y": -23.17,
              "z": 0.946
            },
            "rightCorner": {
              "x": -12.271,
              "y": -23.17,
              "z": 0.946
            },
            "gtin": "4000521463502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59ef",
            "leftCorner": {
              "x": -12.271,
              "y": -23.175,
              "z": 0.946
            },
            "rightCorner": {
              "x": -12.125,
              "y": -23.175,
              "z": 0.946
            },
            "gtin": "4000521002930",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfc1",
        "height": 1.41,
        "facings": [
          {
            "id": "68d8e509e1820c81800d59f7",
            "leftCorner": {
              "x": -13.403,
              "y": -23.219,
              "z": 1.154
            },
            "rightCorner": {
              "x": -13.234,
              "y": -23.219,
              "z": 1.154
            },
            "gtin": "4002676650004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59f9",
            "leftCorner": {
              "x": -13.234,
              "y": -23.179,
              "z": 1.154
            },
            "rightCorner": {
              "x": -13.118,
              "y": -23.178,
              "z": 1.154
            },
            "gtin": "4002676651155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59fa",
            "leftCorner": {
              "x": -13.118,
              "y": -23.176,
              "z": 1.154
            },
            "rightCorner": {
              "x": -12.924,
              "y": -23.175,
              "z": 1.154
            },
            "gtin": "4002676651179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59fb",
            "leftCorner": {
              "x": -12.924,
              "y": -23.172,
              "z": 1.154
            },
            "rightCorner": {
              "x": -12.794,
              "y": -23.172,
              "z": 1.154
            },
            "gtin": "4002809021220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59fc",
            "leftCorner": {
              "x": -12.794,
              "y": -23.177,
              "z": 1.154
            },
            "rightCorner": {
              "x": -12.661,
              "y": -23.177,
              "z": 1.154
            },
            "gtin": "4002809021206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59fd",
            "leftCorner": {
              "x": -12.661,
              "y": -23.177,
              "z": 1.154
            },
            "rightCorner": {
              "x": -12.529,
              "y": -23.176,
              "z": 1.154
            },
            "gtin": "4002809018855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59fe",
            "leftCorner": {
              "x": -12.529,
              "y": -23.18,
              "z": 1.154
            },
            "rightCorner": {
              "x": -12.35,
              "y": -23.179,
              "z": 1.154
            },
            "gtin": "4000521029487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59ff",
            "leftCorner": {
              "x": -12.35,
              "y": -23.182,
              "z": 1.154
            },
            "rightCorner": {
              "x": -12.212,
              "y": -23.182,
              "z": 1.154
            },
            "gtin": "4000521029500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a00",
            "leftCorner": {
              "x": -12.212,
              "y": -23.181,
              "z": 1.154
            },
            "rightCorner": {
              "x": -12.132,
              "y": -23.181,
              "z": 1.154
            },
            "gtin": "4002676650400",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfc3",
        "height": 1.6586,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a0a",
            "leftCorner": {
              "x": -13.403,
              "y": -23.218,
              "z": 1.357
            },
            "rightCorner": {
              "x": -13.269,
              "y": -23.218,
              "z": 1.357
            },
            "gtin": "4046800110767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a0c",
            "leftCorner": {
              "x": -13.27,
              "y": -23.201,
              "z": 1.357
            },
            "rightCorner": {
              "x": -13.185,
              "y": -23.2,
              "z": 1.357
            },
            "gtin": "4046800110811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a0d",
            "leftCorner": {
              "x": -13.185,
              "y": -23.18,
              "z": 1.357
            },
            "rightCorner": {
              "x": -12.977,
              "y": -23.179,
              "z": 1.357
            },
            "gtin": "4046800110743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a0e",
            "leftCorner": {
              "x": -12.977,
              "y": -23.168,
              "z": 1.357
            },
            "rightCorner": {
              "x": -12.84,
              "y": -23.167,
              "z": 1.357
            },
            "gtin": "4000521771102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a0f",
            "leftCorner": {
              "x": -12.84,
              "y": -23.173,
              "z": 1.357
            },
            "rightCorner": {
              "x": -12.722,
              "y": -23.173,
              "z": 1.357
            },
            "gtin": "4000521771003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a10",
            "leftCorner": {
              "x": -12.722,
              "y": -23.174,
              "z": 1.357
            },
            "rightCorner": {
              "x": -12.591,
              "y": -23.173,
              "z": 1.357
            },
            "gtin": "4000521770808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a11",
            "leftCorner": {
              "x": -12.591,
              "y": -23.175,
              "z": 1.357
            },
            "rightCorner": {
              "x": -12.458,
              "y": -23.175,
              "z": 1.357
            },
            "gtin": "4000521770006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a12",
            "leftCorner": {
              "x": -12.458,
              "y": -23.175,
              "z": 1.357
            },
            "rightCorner": {
              "x": -12.322,
              "y": -23.174,
              "z": 1.357
            },
            "gtin": "4000521774004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a13",
            "leftCorner": {
              "x": -12.322,
              "y": -23.176,
              "z": 1.357
            },
            "rightCorner": {
              "x": -12.18,
              "y": -23.176,
              "z": 1.357
            },
            "gtin": "4000521775001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a14",
            "leftCorner": {
              "x": -12.18,
              "y": -23.18,
              "z": 1.357
            },
            "rightCorner": {
              "x": -12.041,
              "y": -23.179,
              "z": 1.357
            },
            "gtin": "4000521008956",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "807",
    "rightNeighborShelfId": "809"
  },
  {
    "id": "809",
    "name": "809",
    "x": -12.153,
    "y": -23.162,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0017017,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 67
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d634",
        "height": 0.17349,
        "facings": [
          {
            "id": "cf2c535d87ba69cd0b8513a5",
            "leftCorner": {
              "x": -12.153,
              "y": -23.163,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.931,
              "y": -23.162,
              "z": 0.142
            },
            "gtin": "4000521221010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "669152879560b5243a0ab0ee",
            "leftCorner": {
              "x": -11.931,
              "y": -23.162,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.855,
              "y": -23.162,
              "z": 0.142
            },
            "gtin": "4000521024970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6e45ba358eea77903cc920ef",
            "leftCorner": {
              "x": -11.855,
              "y": -23.162,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.777,
              "y": -23.162,
              "z": 0.142
            },
            "gtin": "4000521042820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a1cfcd7edb6b916e3b32d3aa",
            "leftCorner": {
              "x": -11.777,
              "y": -23.162,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.696,
              "y": -23.161,
              "z": 0.142
            },
            "gtin": "4000521005009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "743561a9901b2c56baf56c9d",
            "leftCorner": {
              "x": -11.696,
              "y": -23.161,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.614,
              "y": -23.161,
              "z": 0.142
            },
            "gtin": "4000521458607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7a446a011a9ab8b76d1c6358",
            "leftCorner": {
              "x": -11.614,
              "y": -23.161,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.522,
              "y": -23.161,
              "z": 0.142
            },
            "gtin": "4000521021344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "eaad59fd4f3eeba49333fa00",
            "leftCorner": {
              "x": -11.522,
              "y": -23.161,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.429,
              "y": -23.161,
              "z": 0.142
            },
            "gtin": "4000521038830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6b18debb291d14a2ea7e596c",
            "leftCorner": {
              "x": -11.429,
              "y": -23.161,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.336,
              "y": -23.16,
              "z": 0.142
            },
            "gtin": "4000521037864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0d1440efd38736bc3b6ac9ff",
            "leftCorner": {
              "x": -11.336,
              "y": -23.16,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.242,
              "y": -23.16,
              "z": 0.142
            },
            "gtin": "4000521021320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "27e11351fbded53d957bdba3",
            "leftCorner": {
              "x": -11.242,
              "y": -23.16,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.148,
              "y": -23.16,
              "z": 0.142
            },
            "gtin": "4011800041052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a533dcb765a941024c103b22",
            "leftCorner": {
              "x": -11.148,
              "y": -23.16,
              "z": 0.142
            },
            "rightCorner": {
              "x": -10.919,
              "y": -23.159,
              "z": 0.142
            },
            "gtin": "4000521201319",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d62f",
        "height": 0.4039,
        "facings": [
          {
            "id": "68d8e509e1820c81800d59d9",
            "leftCorner": {
              "x": -12.031,
              "y": -23.069,
              "z": 0.33
            },
            "rightCorner": {
              "x": -11.904,
              "y": -23.069,
              "z": 0.33
            },
            "gtin": "4000521225407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59da",
            "leftCorner": {
              "x": -11.904,
              "y": -23.061,
              "z": 0.33
            },
            "rightCorner": {
              "x": -11.799,
              "y": -23.06,
              "z": 0.33
            },
            "gtin": "4000521224011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59dc",
            "leftCorner": {
              "x": -11.569,
              "y": -22.903,
              "z": 0.33
            },
            "rightCorner": {
              "x": -11.373,
              "y": -22.902,
              "z": 0.33
            },
            "gtin": "4000521223014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59dd",
            "leftCorner": {
              "x": -11.372,
              "y": -23.071,
              "z": 0.33
            },
            "rightCorner": {
              "x": -11.246,
              "y": -23.07,
              "z": 0.33
            },
            "gtin": "4000521202118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59de",
            "leftCorner": {
              "x": -11.246,
              "y": -23.112,
              "z": 0.33
            },
            "rightCorner": {
              "x": -11.005,
              "y": -23.111,
              "z": 0.33
            },
            "gtin": "4000521201319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59c4",
            "leftCorner": {
              "x": -11.004,
              "y": -23.072,
              "z": 0.33
            },
            "rightCorner": {
              "x": -10.903,
              "y": -23.072,
              "z": 0.33
            },
            "gtin": "4000521005009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "903c24f0d8672ad3c2865cb6",
            "leftCorner": {
              "x": -12.153,
              "y": -23.106,
              "z": 0.33
            },
            "rightCorner": {
              "x": -12.037,
              "y": -23.106,
              "z": 0.33
            },
            "gtin": "4000521225407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6b428835e984720f66352800",
            "leftCorner": {
              "x": -11.799,
              "y": -23.105,
              "z": 0.33
            },
            "rightCorner": {
              "x": -11.577,
              "y": -23.104,
              "z": 0.33
            },
            "gtin": "4000521221010",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d632",
        "height": 0.6518,
        "facings": [
          {
            "id": "68d8e509e1820c81800d59ad",
            "leftCorner": {
              "x": -12.063,
              "y": -23.076,
              "z": 0.533
            },
            "rightCorner": {
              "x": -11.952,
              "y": -23.075,
              "z": 0.533
            },
            "gtin": "40352244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59ae",
            "leftCorner": {
              "x": -11.952,
              "y": -23.07,
              "z": 0.533
            },
            "rightCorner": {
              "x": -11.818,
              "y": -23.069,
              "z": 0.533
            },
            "gtin": "4104420140622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59af",
            "leftCorner": {
              "x": -11.818,
              "y": -23.063,
              "z": 0.533
            },
            "rightCorner": {
              "x": -11.722,
              "y": -23.063,
              "z": 0.533
            },
            "gtin": "4104420140608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59b0",
            "leftCorner": {
              "x": -11.722,
              "y": -23.067,
              "z": 0.533
            },
            "rightCorner": {
              "x": -11.472,
              "y": -23.066,
              "z": 0.533
            },
            "gtin": "4000521401603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59b1",
            "leftCorner": {
              "x": -11.472,
              "y": -23.075,
              "z": 0.533
            },
            "rightCorner": {
              "x": -11.339,
              "y": -23.075,
              "z": 0.533
            },
            "gtin": "4000521402600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59b2",
            "leftCorner": {
              "x": -11.339,
              "y": -23.076,
              "z": 0.533
            },
            "rightCorner": {
              "x": -11.212,
              "y": -23.075,
              "z": 0.533
            },
            "gtin": "4000521025014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59b3",
            "leftCorner": {
              "x": -11.212,
              "y": -23.077,
              "z": 0.533
            },
            "rightCorner": {
              "x": -11.1,
              "y": -23.076,
              "z": 0.533
            },
            "gtin": "4000521037840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59b4",
            "leftCorner": {
              "x": -11.1,
              "y": -23.077,
              "z": 0.533
            },
            "rightCorner": {
              "x": -10.99,
              "y": -23.077,
              "z": 0.533
            },
            "gtin": "4000521037864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5998",
            "leftCorner": {
              "x": -10.99,
              "y": -23.069,
              "z": 0.533
            },
            "rightCorner": {
              "x": -10.903,
              "y": -23.069,
              "z": 0.533
            },
            "gtin": "4000521037888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e6782d22ae49be585f999122",
            "leftCorner": {
              "x": -12.153,
              "y": -23.113,
              "z": 0.533
            },
            "rightCorner": {
              "x": -12.084,
              "y": -23.113,
              "z": 0.533
            },
            "gtin": "4000521037888",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d633",
        "height": 0.90421,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a2f",
            "leftCorner": {
              "x": -12.08,
              "y": -23.077,
              "z": 0.74
            },
            "rightCorner": {
              "x": -11.99,
              "y": -23.077,
              "z": 0.74
            },
            "gtin": "4000521458607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a30",
            "leftCorner": {
              "x": -11.99,
              "y": -23.073,
              "z": 0.74
            },
            "rightCorner": {
              "x": -11.883,
              "y": -23.072,
              "z": 0.74
            },
            "gtin": "4000521041878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a31",
            "leftCorner": {
              "x": -11.882,
              "y": -23.063,
              "z": 0.74
            },
            "rightCorner": {
              "x": -11.777,
              "y": -23.063,
              "z": 0.74
            },
            "gtin": "4000521042769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a32",
            "leftCorner": {
              "x": -11.777,
              "y": -23.062,
              "z": 0.74
            },
            "rightCorner": {
              "x": -11.673,
              "y": -23.061,
              "z": 0.74
            },
            "gtin": "4000521042783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a33",
            "leftCorner": {
              "x": -11.673,
              "y": -23.061,
              "z": 0.74
            },
            "rightCorner": {
              "x": -11.566,
              "y": -23.061,
              "z": 0.74
            },
            "gtin": "4000521023881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a34",
            "leftCorner": {
              "x": -11.566,
              "y": -23.065,
              "z": 0.74
            },
            "rightCorner": {
              "x": -11.472,
              "y": -23.065,
              "z": 0.74
            },
            "gtin": "4000521038830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a35",
            "leftCorner": {
              "x": -11.472,
              "y": -23.07,
              "z": 0.74
            },
            "rightCorner": {
              "x": -11.384,
              "y": -23.069,
              "z": 0.74
            },
            "gtin": "4000521021344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a36",
            "leftCorner": {
              "x": -11.384,
              "y": -23.069,
              "z": 0.74
            },
            "rightCorner": {
              "x": -11.289,
              "y": -23.069,
              "z": 0.74
            },
            "gtin": "4000521021320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a37",
            "leftCorner": {
              "x": -11.289,
              "y": -23.07,
              "z": 0.74
            },
            "rightCorner": {
              "x": -11.169,
              "y": -23.07,
              "z": 0.74
            },
            "gtin": "4000521021306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a38",
            "leftCorner": {
              "x": -11.169,
              "y": -23.072,
              "z": 0.74
            },
            "rightCorner": {
              "x": -11.092,
              "y": -23.072,
              "z": 0.74
            },
            "gtin": "4000521042820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a39",
            "leftCorner": {
              "x": -11.092,
              "y": -23.073,
              "z": 0.74
            },
            "rightCorner": {
              "x": -10.992,
              "y": -23.073,
              "z": 0.74
            },
            "gtin": "4000521024970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a25",
            "leftCorner": {
              "x": -10.992,
              "y": -23.066,
              "z": 0.74
            },
            "rightCorner": {
              "x": -10.903,
              "y": -23.066,
              "z": 0.74
            },
            "gtin": "4000521024956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8918083b342dfac47b3a893c",
            "leftCorner": {
              "x": -12.153,
              "y": -23.11,
              "z": 0.74
            },
            "rightCorner": {
              "x": -12.084,
              "y": -23.11,
              "z": 0.74
            },
            "gtin": "4000521024956",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d631",
        "height": 1.1566,
        "facings": [
          {
            "id": "68d8e509e1820c81800d59f0",
            "leftCorner": {
              "x": -12.124,
              "y": -23.074,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.929,
              "y": -23.073,
              "z": 0.946
            },
            "gtin": "4000521035990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59f1",
            "leftCorner": {
              "x": -11.929,
              "y": -23.065,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.679,
              "y": -23.064,
              "z": 0.946
            },
            "gtin": "4000521465407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59f2",
            "leftCorner": {
              "x": -11.679,
              "y": -23.062,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.581,
              "y": -23.062,
              "z": 0.946
            },
            "gtin": "4000521464400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59f3",
            "leftCorner": {
              "x": -11.582,
              "y": -23.089,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.472,
              "y": -23.089,
              "z": 0.946
            },
            "gtin": "80596295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59f4",
            "leftCorner": {
              "x": -11.472,
              "y": -23.072,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.356,
              "y": -23.071,
              "z": 0.946
            },
            "gtin": "4306188045465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59f5",
            "leftCorner": {
              "x": -11.356,
              "y": -23.07,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.161,
              "y": -23.069,
              "z": 0.946
            },
            "gtin": "4306188045489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59f6",
            "leftCorner": {
              "x": -11.161,
              "y": -23.07,
              "z": 0.946
            },
            "rightCorner": {
              "x": -11.02,
              "y": -23.07,
              "z": 0.946
            },
            "gtin": "4306188045427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59e5",
            "leftCorner": {
              "x": -11.02,
              "y": -23.056,
              "z": 0.946
            },
            "rightCorner": {
              "x": -10.903,
              "y": -23.056,
              "z": 0.946
            },
            "gtin": "4306188045441",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d630",
        "height": 1.4099,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a01",
            "leftCorner": {
              "x": -12.132,
              "y": -23.084,
              "z": 1.154
            },
            "rightCorner": {
              "x": -12.019,
              "y": -23.083,
              "z": 1.154
            },
            "gtin": "4002676650387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a02",
            "leftCorner": {
              "x": -12.019,
              "y": -23.079,
              "z": 1.154
            },
            "rightCorner": {
              "x": -11.907,
              "y": -23.079,
              "z": 1.154
            },
            "gtin": "4000521005412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a03",
            "leftCorner": {
              "x": -11.907,
              "y": -23.069,
              "z": 1.154
            },
            "rightCorner": {
              "x": -11.774,
              "y": -23.068,
              "z": 1.154
            },
            "gtin": "4000521476007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a04",
            "leftCorner": {
              "x": -11.774,
              "y": -23.065,
              "z": 1.154
            },
            "rightCorner": {
              "x": -11.651,
              "y": -23.064,
              "z": 1.154
            },
            "gtin": "4000521475505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a05",
            "leftCorner": {
              "x": -11.651,
              "y": -23.066,
              "z": 1.154
            },
            "rightCorner": {
              "x": -11.527,
              "y": -23.065,
              "z": 1.154
            },
            "gtin": "4000521022648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a06",
            "leftCorner": {
              "x": -11.527,
              "y": -23.077,
              "z": 1.154
            },
            "rightCorner": {
              "x": -11.4,
              "y": -23.077,
              "z": 1.154
            },
            "gtin": "4000521475000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a07",
            "leftCorner": {
              "x": -11.4,
              "y": -23.08,
              "z": 1.154
            },
            "rightCorner": {
              "x": -11.272,
              "y": -23.079,
              "z": 1.154
            },
            "gtin": "4000521474102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a08",
            "leftCorner": {
              "x": -11.272,
              "y": -23.08,
              "z": 1.154
            },
            "rightCorner": {
              "x": -11.14,
              "y": -23.08,
              "z": 1.154
            },
            "gtin": "4000521005641",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a09",
            "leftCorner": {
              "x": -11.14,
              "y": -23.081,
              "z": 1.154
            },
            "rightCorner": {
              "x": -11.006,
              "y": -23.08,
              "z": 1.154
            },
            "gtin": "4000521035075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d59f8",
            "leftCorner": {
              "x": -11.006,
              "y": -23.068,
              "z": 1.154
            },
            "rightCorner": {
              "x": -10.903,
              "y": -23.068,
              "z": 1.154
            },
            "gtin": "4011800419004",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d62e",
        "height": 1.6588,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a15",
            "leftCorner": {
              "x": -12.041,
              "y": -23.074,
              "z": 1.357
            },
            "rightCorner": {
              "x": -11.899,
              "y": -23.073,
              "z": 1.357
            },
            "gtin": "4000521774400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a16",
            "leftCorner": {
              "x": -11.899,
              "y": -23.066,
              "z": 1.357
            },
            "rightCorner": {
              "x": -11.731,
              "y": -23.066,
              "z": 1.357
            },
            "gtin": "4000521036775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a18",
            "leftCorner": {
              "x": -11.625,
              "y": -23.067,
              "z": 1.357
            },
            "rightCorner": {
              "x": -11.537,
              "y": -23.066,
              "z": 1.357
            },
            "gtin": "4011800041052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a19",
            "leftCorner": {
              "x": -11.537,
              "y": -23.073,
              "z": 1.357
            },
            "rightCorner": {
              "x": -11.444,
              "y": -23.073,
              "z": 1.357
            },
            "gtin": "4011800049010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a1a",
            "leftCorner": {
              "x": -11.444,
              "y": -23.077,
              "z": 1.357
            },
            "rightCorner": {
              "x": -11.332,
              "y": -23.077,
              "z": 1.357
            },
            "gtin": "4011800045005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a1b",
            "leftCorner": {
              "x": -11.332,
              "y": -23.077,
              "z": 1.357
            },
            "rightCorner": {
              "x": -11.147,
              "y": -23.076,
              "z": 1.357
            },
            "gtin": "4011800040000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a1c",
            "leftCorner": {
              "x": -11.147,
              "y": -23.084,
              "z": 1.357
            },
            "rightCorner": {
              "x": -11.011,
              "y": -23.083,
              "z": 1.357
            },
            "gtin": "4011800049805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a0b",
            "leftCorner": {
              "x": -11.011,
              "y": -23.076,
              "z": 1.357
            },
            "rightCorner": {
              "x": -10.903,
              "y": -23.076,
              "z": 1.357
            },
            "gtin": "4011800043001",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "59ecc3f6060567e0612f3662",
            "leftCorner": {
              "x": -12.153,
              "y": -23.114,
              "z": 1.357
            },
            "rightCorner": {
              "x": -12.058,
              "y": -23.114,
              "z": 1.357
            },
            "gtin": "4011800043001",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "88ed3708bd5cf5deb8e7ef44",
            "leftCorner": {
              "x": -11.731,
              "y": -23.113,
              "z": 1.357
            },
            "rightCorner": {
              "x": -11.637,
              "y": -23.112,
              "z": 1.357
            },
            "gtin": "4011800049010",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "808"
  },
  {
    "id": "810",
    "name": "810",
    "x": -14.733,
    "y": -20.263,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0033772,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf8b",
        "height": 0.15494,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5884",
            "leftCorner": {
              "x": -14.732,
              "y": -20.338,
              "z": 0.127
            },
            "rightCorner": {
              "x": -14.402,
              "y": -20.325,
              "z": 0.127
            },
            "gtin": "4306188038740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5885",
            "leftCorner": {
              "x": -14.402,
              "y": -20.324,
              "z": 0.127
            },
            "rightCorner": {
              "x": -13.809,
              "y": -20.32,
              "z": 0.127
            },
            "gtin": "4306188038740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5886",
            "leftCorner": {
              "x": -13.809,
              "y": -20.326,
              "z": 0.127
            },
            "rightCorner": {
              "x": -13.6,
              "y": -20.324,
              "z": 0.127
            },
            "gtin": "40273976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5887",
            "leftCorner": {
              "x": -13.6,
              "y": -20.323,
              "z": 0.127
            },
            "rightCorner": {
              "x": -13.38,
              "y": -20.322,
              "z": 0.127
            },
            "gtin": "40273594",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf88",
        "height": 0.45758,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57f6",
            "leftCorner": {
              "x": -14.554,
              "y": -20.328,
              "z": 0.374
            },
            "rightCorner": {
              "x": -14.501,
              "y": -20.327,
              "z": 0.374
            },
            "gtin": "4062800016854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0d3076e2e4385501462a0c4a",
            "leftCorner": {
              "x": -14.732,
              "y": -20.37,
              "z": 0.374
            },
            "rightCorner": {
              "x": -14.557,
              "y": -20.369,
              "z": 0.374
            },
            "gtin": "4045317054564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57f7",
            "leftCorner": {
              "x": -14.501,
              "y": -20.327,
              "z": 0.374
            },
            "rightCorner": {
              "x": -14.448,
              "y": -20.327,
              "z": 0.374
            },
            "gtin": "4062800016854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57f8",
            "leftCorner": {
              "x": -14.448,
              "y": -20.327,
              "z": 0.374
            },
            "rightCorner": {
              "x": -14.395,
              "y": -20.327,
              "z": 0.374
            },
            "gtin": "4062800016854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57f9",
            "leftCorner": {
              "x": -14.395,
              "y": -20.323,
              "z": 0.374
            },
            "rightCorner": {
              "x": -14.163,
              "y": -20.322,
              "z": 0.374
            },
            "gtin": "4046700001332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57fa",
            "leftCorner": {
              "x": -14.163,
              "y": -20.325,
              "z": 0.374
            },
            "rightCorner": {
              "x": -14.082,
              "y": -20.324,
              "z": 0.374
            },
            "gtin": "4045317053185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57fb",
            "leftCorner": {
              "x": -14.082,
              "y": -20.324,
              "z": 0.374
            },
            "rightCorner": {
              "x": -14.001,
              "y": -20.323,
              "z": 0.374
            },
            "gtin": "4045317053185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57fc",
            "leftCorner": {
              "x": -14.001,
              "y": -20.326,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.822,
              "y": -20.325,
              "z": 0.374
            },
            "gtin": "4045317054564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57fd",
            "leftCorner": {
              "x": -13.822,
              "y": -20.325,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.651,
              "y": -20.323,
              "z": 0.374
            },
            "gtin": "4007929053878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57fe",
            "leftCorner": {
              "x": -13.651,
              "y": -20.329,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.45,
              "y": -20.328,
              "z": 0.374
            },
            "gtin": "4045317054557",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf8c",
        "height": 0.75673,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5850",
            "leftCorner": {
              "x": -14.681,
              "y": -20.325,
              "z": 0.619
            },
            "rightCorner": {
              "x": -14.535,
              "y": -20.324,
              "z": 0.619
            },
            "gtin": "4306188049098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5851",
            "leftCorner": {
              "x": -14.535,
              "y": -20.324,
              "z": 0.619
            },
            "rightCorner": {
              "x": -14.39,
              "y": -20.323,
              "z": 0.619
            },
            "gtin": "4306188049098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5852",
            "leftCorner": {
              "x": -14.39,
              "y": -20.322,
              "z": 0.619
            },
            "rightCorner": {
              "x": -14.075,
              "y": -20.319,
              "z": 0.619
            },
            "gtin": "4306188049159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5853",
            "leftCorner": {
              "x": -14.075,
              "y": -20.327,
              "z": 0.619
            },
            "rightCorner": {
              "x": -13.842,
              "y": -20.326,
              "z": 0.619
            },
            "gtin": "4008452040748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5854",
            "leftCorner": {
              "x": -13.842,
              "y": -20.325,
              "z": 0.619
            },
            "rightCorner": {
              "x": -13.586,
              "y": -20.323,
              "z": 0.619
            },
            "gtin": "4008452036710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5855",
            "leftCorner": {
              "x": -13.586,
              "y": -20.323,
              "z": 0.619
            },
            "rightCorner": {
              "x": -13.383,
              "y": -20.322,
              "z": 0.619
            },
            "gtin": "4306188049609",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf8a",
        "height": 1.0604,
        "facings": [
          {
            "id": "68d8e509e1820c81800d581a",
            "leftCorner": {
              "x": -14.732,
              "y": -20.344,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.416,
              "y": -20.332,
              "z": 0.868
            },
            "gtin": "4008452033986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d581b",
            "leftCorner": {
              "x": -14.416,
              "y": -20.32,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.166,
              "y": -20.319,
              "z": 0.868
            },
            "gtin": "4008452033986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d581c",
            "leftCorner": {
              "x": -14.166,
              "y": -20.326,
              "z": 0.868
            },
            "rightCorner": {
              "x": -13.927,
              "y": -20.324,
              "z": 0.868
            },
            "gtin": "4008452033962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d581d",
            "leftCorner": {
              "x": -13.927,
              "y": -20.324,
              "z": 0.868
            },
            "rightCorner": {
              "x": -13.414,
              "y": -20.321,
              "z": 0.868
            },
            "gtin": "40363455",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf89",
        "height": 1.3605,
        "facings": [
          {
            "id": "68d8e509e1820c81800d582f",
            "leftCorner": {
              "x": -14.732,
              "y": -20.34,
              "z": 1.113
            },
            "rightCorner": {
              "x": -14.534,
              "y": -20.333,
              "z": 1.113
            },
            "gtin": "4000349762139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5830",
            "leftCorner": {
              "x": -14.534,
              "y": -20.324,
              "z": 1.113
            },
            "rightCorner": {
              "x": -14.336,
              "y": -20.322,
              "z": 1.113
            },
            "gtin": "4000349762139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5831",
            "leftCorner": {
              "x": -14.336,
              "y": -20.32,
              "z": 1.113
            },
            "rightCorner": {
              "x": -14.15,
              "y": -20.32,
              "z": 1.113
            },
            "gtin": "4045317054007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5832",
            "leftCorner": {
              "x": -14.15,
              "y": -20.327,
              "z": 1.113
            },
            "rightCorner": {
              "x": -13.934,
              "y": -20.325,
              "z": 1.113
            },
            "gtin": "4045317054069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5833",
            "leftCorner": {
              "x": -13.934,
              "y": -20.324,
              "z": 1.113
            },
            "rightCorner": {
              "x": -13.806,
              "y": -20.324,
              "z": 1.113
            },
            "gtin": "9180017300209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5834",
            "leftCorner": {
              "x": -13.806,
              "y": -20.323,
              "z": 1.113
            },
            "rightCorner": {
              "x": -13.718,
              "y": -20.321,
              "z": 1.113
            },
            "gtin": "9180017300216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5835",
            "leftCorner": {
              "x": -13.718,
              "y": -20.326,
              "z": 1.113
            },
            "rightCorner": {
              "x": -13.557,
              "y": -20.325,
              "z": 1.113
            },
            "gtin": "9180017300223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5836",
            "leftCorner": {
              "x": -13.557,
              "y": -20.321,
              "z": 1.113
            },
            "rightCorner": {
              "x": -13.447,
              "y": -20.32,
              "z": 1.113
            },
            "gtin": "4104420135321",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf87",
        "height": 1.736,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5867",
            "leftCorner": {
              "x": -14.703,
              "y": -20.33,
              "z": 1.42
            },
            "rightCorner": {
              "x": -14.579,
              "y": -20.33,
              "z": 1.42
            },
            "gtin": "4260024180270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aea4e668e41bb9ddfe8624a1",
            "leftCorner": {
              "x": -14.339,
              "y": -20.362,
              "z": 1.42
            },
            "rightCorner": {
              "x": -14.289,
              "y": -20.362,
              "z": 1.42
            },
            "gtin": "4260024180270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "53463e85490023bcd5811422",
            "leftCorner": {
              "x": -14.289,
              "y": -20.362,
              "z": 1.42
            },
            "rightCorner": {
              "x": -14.239,
              "y": -20.362,
              "z": 1.42
            },
            "gtin": "4260024180270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5868",
            "leftCorner": {
              "x": -14.579,
              "y": -20.325,
              "z": 1.42
            },
            "rightCorner": {
              "x": -14.339,
              "y": -20.323,
              "z": 1.42
            },
            "gtin": "4062800005827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d586a",
            "leftCorner": {
              "x": -14.23,
              "y": -20.322,
              "z": 1.42
            },
            "rightCorner": {
              "x": -14.083,
              "y": -20.32,
              "z": 1.42
            },
            "gtin": "4062800014911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d586b",
            "leftCorner": {
              "x": -14.083,
              "y": -20.326,
              "z": 1.42
            },
            "rightCorner": {
              "x": -13.677,
              "y": -20.323,
              "z": 1.42
            },
            "gtin": "4008435300807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d586c",
            "leftCorner": {
              "x": -13.677,
              "y": -20.323,
              "z": 1.42
            },
            "rightCorner": {
              "x": -13.429,
              "y": -20.322,
              "z": 1.42
            },
            "gtin": "4008435300500",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "801",
    "rightNeighborShelfId": "811"
  },
  {
    "id": "811",
    "name": "811",
    "x": -13.483,
    "y": -20.255,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0033772,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 44,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf8e",
        "height": 0.15635,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5888",
            "leftCorner": {
              "x": -13.38,
              "y": -20.321,
              "z": 0.128
            },
            "rightCorner": {
              "x": -13.222,
              "y": -20.32,
              "z": 0.128
            },
            "gtin": "40273419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5889",
            "leftCorner": {
              "x": -13.222,
              "y": -20.32,
              "z": 0.128
            },
            "rightCorner": {
              "x": -12.866,
              "y": -20.318,
              "z": 0.128
            },
            "gtin": "4004790046503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d588a",
            "leftCorner": {
              "x": -12.866,
              "y": -20.321,
              "z": 0.128
            },
            "rightCorner": {
              "x": -12.745,
              "y": -20.321,
              "z": 0.128
            },
            "gtin": "4004790046527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d588b",
            "leftCorner": {
              "x": -12.745,
              "y": -20.323,
              "z": 0.128
            },
            "rightCorner": {
              "x": -12.587,
              "y": -20.321,
              "z": 0.128
            },
            "gtin": "4004790110303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d588c",
            "leftCorner": {
              "x": -12.587,
              "y": -20.324,
              "z": 0.128
            },
            "rightCorner": {
              "x": -12.433,
              "y": -20.323,
              "z": 0.128
            },
            "gtin": "4004790026949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d588d",
            "leftCorner": {
              "x": -12.433,
              "y": -20.323,
              "z": 0.128
            },
            "rightCorner": {
              "x": -12.304,
              "y": -20.322,
              "z": 0.128
            },
            "gtin": "4004790023795",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d588e",
            "leftCorner": {
              "x": -12.304,
              "y": -20.322,
              "z": 0.128
            },
            "rightCorner": {
              "x": -12.176,
              "y": -20.321,
              "z": 0.128
            },
            "gtin": "4004790023795",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf91",
        "height": 0.45961,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57ff",
            "leftCorner": {
              "x": -13.45,
              "y": -20.322,
              "z": 0.376
            },
            "rightCorner": {
              "x": -13.154,
              "y": -20.319,
              "z": 0.376
            },
            "gtin": "4003490071686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5800",
            "leftCorner": {
              "x": -13.154,
              "y": -20.323,
              "z": 0.376
            },
            "rightCorner": {
              "x": -13.003,
              "y": -20.322,
              "z": 0.376
            },
            "gtin": "4250780325152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5801",
            "leftCorner": {
              "x": -13.003,
              "y": -20.322,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.851,
              "y": -20.321,
              "z": 0.376
            },
            "gtin": "4250780325152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5802",
            "leftCorner": {
              "x": -12.851,
              "y": -20.321,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.699,
              "y": -20.319,
              "z": 0.376
            },
            "gtin": "4250780325152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5803",
            "leftCorner": {
              "x": -12.699,
              "y": -20.322,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.544,
              "y": -20.322,
              "z": 0.376
            },
            "gtin": "8423352400403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5804",
            "leftCorner": {
              "x": -12.544,
              "y": -20.322,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.373,
              "y": -20.32,
              "z": 0.376
            },
            "gtin": "8423352410303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5805",
            "leftCorner": {
              "x": -12.373,
              "y": -20.321,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.283,
              "y": -20.321,
              "z": 0.376
            },
            "gtin": "8423352400557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5806",
            "leftCorner": {
              "x": -12.283,
              "y": -20.321,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.192,
              "y": -20.32,
              "z": 0.376
            },
            "gtin": "8423352400557",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf90",
        "height": 0.75828,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5856",
            "leftCorner": {
              "x": -13.382,
              "y": -20.321,
              "z": 0.62
            },
            "rightCorner": {
              "x": -13.205,
              "y": -20.319,
              "z": 0.62
            },
            "gtin": "4045500011213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5857",
            "leftCorner": {
              "x": -13.205,
              "y": -20.32,
              "z": 0.62
            },
            "rightCorner": {
              "x": -13.044,
              "y": -20.319,
              "z": 0.62
            },
            "gtin": "4045317354473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5858",
            "leftCorner": {
              "x": -13.044,
              "y": -20.318,
              "z": 0.62
            },
            "rightCorner": {
              "x": -12.876,
              "y": -20.317,
              "z": 0.62
            },
            "gtin": "4003490366478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5859",
            "leftCorner": {
              "x": -12.876,
              "y": -20.319,
              "z": 0.62
            },
            "rightCorner": {
              "x": -12.72,
              "y": -20.318,
              "z": 0.62
            },
            "gtin": "4003490366485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d585a",
            "leftCorner": {
              "x": -12.72,
              "y": -20.321,
              "z": 0.62
            },
            "rightCorner": {
              "x": -12.365,
              "y": -20.319,
              "z": 0.62
            },
            "gtin": "4003490366461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d585b",
            "leftCorner": {
              "x": -12.364,
              "y": -20.321,
              "z": 0.62
            },
            "rightCorner": {
              "x": -12.203,
              "y": -20.319,
              "z": 0.62
            },
            "gtin": "4260701410942",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf92",
        "height": 1.0613,
        "facings": [
          {
            "id": "68d8e509e1820c81800d581e",
            "leftCorner": {
              "x": -13.413,
              "y": -20.321,
              "z": 0.868
            },
            "rightCorner": {
              "x": -13.13,
              "y": -20.32,
              "z": 0.868
            },
            "gtin": "40363462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d581f",
            "leftCorner": {
              "x": -13.13,
              "y": -20.319,
              "z": 0.868
            },
            "rightCorner": {
              "x": -12.734,
              "y": -20.316,
              "z": 0.868
            },
            "gtin": "4036300044792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5820",
            "leftCorner": {
              "x": -12.734,
              "y": -20.322,
              "z": 0.868
            },
            "rightCorner": {
              "x": -12.332,
              "y": -20.319,
              "z": 0.868
            },
            "gtin": "4036300044785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5821",
            "leftCorner": {
              "x": -12.332,
              "y": -20.319,
              "z": 0.868
            },
            "rightCorner": {
              "x": -12.154,
              "y": -20.318,
              "z": 0.868
            },
            "gtin": "8423352411331",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf8d",
        "height": 1.3632,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5837",
            "leftCorner": {
              "x": -13.446,
              "y": -20.313,
              "z": 1.115
            },
            "rightCorner": {
              "x": -13.401,
              "y": -20.312,
              "z": 1.115
            },
            "gtin": "5411188140306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5838",
            "leftCorner": {
              "x": -13.401,
              "y": -20.312,
              "z": 1.115
            },
            "rightCorner": {
              "x": -13.356,
              "y": -20.312,
              "z": 1.115
            },
            "gtin": "5411188140306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5839",
            "leftCorner": {
              "x": -13.356,
              "y": -20.312,
              "z": 1.115
            },
            "rightCorner": {
              "x": -13.31,
              "y": -20.312,
              "z": 1.115
            },
            "gtin": "5411188140306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d583a",
            "leftCorner": {
              "x": -13.31,
              "y": -20.319,
              "z": 1.115
            },
            "rightCorner": {
              "x": -13.186,
              "y": -20.318,
              "z": 1.115
            },
            "gtin": "40273662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d583b",
            "leftCorner": {
              "x": -13.186,
              "y": -20.318,
              "z": 1.115
            },
            "rightCorner": {
              "x": -13.062,
              "y": -20.318,
              "z": 1.115
            },
            "gtin": "40273662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d583c",
            "leftCorner": {
              "x": -13.062,
              "y": -20.317,
              "z": 1.115
            },
            "rightCorner": {
              "x": -12.791,
              "y": -20.315,
              "z": 1.115
            },
            "gtin": "4004790042192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d583d",
            "leftCorner": {
              "x": -12.791,
              "y": -20.323,
              "z": 1.115
            },
            "rightCorner": {
              "x": -12.612,
              "y": -20.322,
              "z": 1.115
            },
            "gtin": "5411188134985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d583e",
            "leftCorner": {
              "x": -12.612,
              "y": -20.325,
              "z": 1.115
            },
            "rightCorner": {
              "x": -12.48,
              "y": -20.324,
              "z": 1.115
            },
            "gtin": "5411188135005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d583f",
            "leftCorner": {
              "x": -12.48,
              "y": -20.324,
              "z": 1.115
            },
            "rightCorner": {
              "x": -12.348,
              "y": -20.323,
              "z": 1.115
            },
            "gtin": "5411188135005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5840",
            "leftCorner": {
              "x": -12.348,
              "y": -20.32,
              "z": 1.115
            },
            "rightCorner": {
              "x": -12.204,
              "y": -20.319,
              "z": 1.115
            },
            "gtin": "5411188140726",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf8f",
        "height": 1.7359,
        "facings": [
          {
            "id": "68d8e509e1820c81800d586d",
            "leftCorner": {
              "x": -13.429,
              "y": -20.32,
              "z": 1.42
            },
            "rightCorner": {
              "x": -13.277,
              "y": -20.318,
              "z": 1.42
            },
            "gtin": "4036300117830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d586e",
            "leftCorner": {
              "x": -13.278,
              "y": -20.317,
              "z": 1.42
            },
            "rightCorner": {
              "x": -13.133,
              "y": -20.315,
              "z": 1.42
            },
            "gtin": "4100290025533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d586f",
            "leftCorner": {
              "x": -13.133,
              "y": -20.317,
              "z": 1.42
            },
            "rightCorner": {
              "x": -12.985,
              "y": -20.316,
              "z": 1.42
            },
            "gtin": "4100290025564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5870",
            "leftCorner": {
              "x": -12.985,
              "y": -20.316,
              "z": 1.42
            },
            "rightCorner": {
              "x": -12.859,
              "y": -20.315,
              "z": 1.42
            },
            "gtin": "5711953148538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5871",
            "leftCorner": {
              "x": -12.859,
              "y": -20.322,
              "z": 1.42
            },
            "rightCorner": {
              "x": -12.727,
              "y": -20.321,
              "z": 1.42
            },
            "gtin": "5760466997225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5872",
            "leftCorner": {
              "x": -12.727,
              "y": -20.321,
              "z": 1.42
            },
            "rightCorner": {
              "x": -12.578,
              "y": -20.32,
              "z": 1.42
            },
            "gtin": "5711953117985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5873",
            "leftCorner": {
              "x": -12.578,
              "y": -20.323,
              "z": 1.42
            },
            "rightCorner": {
              "x": -12.393,
              "y": -20.322,
              "z": 1.42
            },
            "gtin": "5411188133476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5874",
            "leftCorner": {
              "x": -12.393,
              "y": -20.321,
              "z": 1.42
            },
            "rightCorner": {
              "x": -12.298,
              "y": -20.321,
              "z": 1.42
            },
            "gtin": "5411188130055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5875",
            "leftCorner": {
              "x": -12.298,
              "y": -20.321,
              "z": 1.42
            },
            "rightCorner": {
              "x": -12.202,
              "y": -20.32,
              "z": 1.42
            },
            "gtin": "5411188130055",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "810"
  },
  {
    "id": "812",
    "name": "812",
    "x": -12.233,
    "y": -20.246,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0033772,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 55
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf96",
        "height": 0.16184,
        "facings": [
          {
            "id": "68d8e509e1820c81800d588f",
            "leftCorner": {
              "x": -12.176,
              "y": -20.316,
              "z": 0.132
            },
            "rightCorner": {
              "x": -12.084,
              "y": -20.316,
              "z": 0.132
            },
            "gtin": "4004790037358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5890",
            "leftCorner": {
              "x": -12.084,
              "y": -20.312,
              "z": 0.132
            },
            "rightCorner": {
              "x": -12.016,
              "y": -20.312,
              "z": 0.132
            },
            "gtin": "4004790017565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5891",
            "leftCorner": {
              "x": -12.016,
              "y": -20.312,
              "z": 0.132
            },
            "rightCorner": {
              "x": -11.947,
              "y": -20.311,
              "z": 0.132
            },
            "gtin": "4004790017565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5892",
            "leftCorner": {
              "x": -11.947,
              "y": -20.305,
              "z": 0.132
            },
            "rightCorner": {
              "x": -11.788,
              "y": -20.304,
              "z": 0.132
            },
            "gtin": "4004790035866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5893",
            "leftCorner": {
              "x": -11.788,
              "y": -20.3,
              "z": 0.132
            },
            "rightCorner": {
              "x": -11.612,
              "y": -20.299,
              "z": 0.132
            },
            "gtin": "4004790023764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5894",
            "leftCorner": {
              "x": -11.611,
              "y": -20.29,
              "z": 0.132
            },
            "rightCorner": {
              "x": -11.456,
              "y": -20.29,
              "z": 0.132
            },
            "gtin": "4004790043281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5895",
            "leftCorner": {
              "x": -11.456,
              "y": -20.286,
              "z": 0.132
            },
            "rightCorner": {
              "x": -11.298,
              "y": -20.285,
              "z": 0.132
            },
            "gtin": "7394376621680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5896",
            "leftCorner": {
              "x": -11.298,
              "y": -20.283,
              "z": 0.132
            },
            "rightCorner": {
              "x": -11.148,
              "y": -20.281,
              "z": 0.132
            },
            "gtin": "7394376615894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5897",
            "leftCorner": {
              "x": -11.148,
              "y": -20.279,
              "z": 0.132
            },
            "rightCorner": {
              "x": -11.042,
              "y": -20.278,
              "z": 0.132
            },
            "gtin": "7394376620744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d587f",
            "leftCorner": {
              "x": -11.042,
              "y": -20.277,
              "z": 0.132
            },
            "rightCorner": {
              "x": -10.982,
              "y": -20.276,
              "z": 0.132
            },
            "gtin": "2000439121435",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf98",
        "height": 0.45989,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5807",
            "leftCorner": {
              "x": -12.192,
              "y": -20.316,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.124,
              "y": -20.315,
              "z": 0.376
            },
            "gtin": "8423352400571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5808",
            "leftCorner": {
              "x": -12.124,
              "y": -20.315,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.056,
              "y": -20.314,
              "z": 0.376
            },
            "gtin": "8423352400571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5809",
            "leftCorner": {
              "x": -12.056,
              "y": -20.314,
              "z": 0.376
            },
            "rightCorner": {
              "x": -11.988,
              "y": -20.314,
              "z": 0.376
            },
            "gtin": "8423352400571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d580a",
            "leftCorner": {
              "x": -11.988,
              "y": -20.314,
              "z": 0.376
            },
            "rightCorner": {
              "x": -11.919,
              "y": -20.313,
              "z": 0.376
            },
            "gtin": "8423352400571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d580b",
            "leftCorner": {
              "x": -11.919,
              "y": -20.302,
              "z": 0.376
            },
            "rightCorner": {
              "x": -11.755,
              "y": -20.301,
              "z": 0.376
            },
            "gtin": "4104420260337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d580c",
            "leftCorner": {
              "x": -11.755,
              "y": -20.296,
              "z": 0.376
            },
            "rightCorner": {
              "x": -11.611,
              "y": -20.295,
              "z": 0.376
            },
            "gtin": "4104420095045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d580d",
            "leftCorner": {
              "x": -11.611,
              "y": -20.289,
              "z": 0.376
            },
            "rightCorner": {
              "x": -11.534,
              "y": -20.289,
              "z": 0.376
            },
            "gtin": "4104420186279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d580e",
            "leftCorner": {
              "x": -11.534,
              "y": -20.289,
              "z": 0.376
            },
            "rightCorner": {
              "x": -11.457,
              "y": -20.289,
              "z": 0.376
            },
            "gtin": "4104420186279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d580f",
            "leftCorner": {
              "x": -11.457,
              "y": -20.284,
              "z": 0.376
            },
            "rightCorner": {
              "x": -11.381,
              "y": -20.283,
              "z": 0.376
            },
            "gtin": "4104420244504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5810",
            "leftCorner": {
              "x": -11.381,
              "y": -20.283,
              "z": 0.376
            },
            "rightCorner": {
              "x": -11.304,
              "y": -20.283,
              "z": 0.376
            },
            "gtin": "4104420244504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5811",
            "leftCorner": {
              "x": -11.304,
              "y": -20.282,
              "z": 0.376
            },
            "rightCorner": {
              "x": -11.213,
              "y": -20.281,
              "z": 0.376
            },
            "gtin": "7394376621703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5812",
            "leftCorner": {
              "x": -11.213,
              "y": -20.281,
              "z": 0.376
            },
            "rightCorner": {
              "x": -11.121,
              "y": -20.281,
              "z": 0.376
            },
            "gtin": "7394376621703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57ee",
            "leftCorner": {
              "x": -11.121,
              "y": -20.28,
              "z": 0.376
            },
            "rightCorner": {
              "x": -10.982,
              "y": -20.279,
              "z": 0.376
            },
            "gtin": "7394376623042",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf95",
        "height": 0.75972,
        "facings": [
          {
            "id": "68d8e509e1820c81800d585c",
            "leftCorner": {
              "x": -12.203,
              "y": -20.321,
              "z": 0.622
            },
            "rightCorner": {
              "x": -12.065,
              "y": -20.32,
              "z": 0.622
            },
            "gtin": "4260701410010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d585d",
            "leftCorner": {
              "x": -12.065,
              "y": -20.31,
              "z": 0.622
            },
            "rightCorner": {
              "x": -11.966,
              "y": -20.309,
              "z": 0.622
            },
            "gtin": "4260701410904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d585e",
            "leftCorner": {
              "x": -11.966,
              "y": -20.309,
              "z": 0.622
            },
            "rightCorner": {
              "x": -11.868,
              "y": -20.308,
              "z": 0.622
            },
            "gtin": "4260701410904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d585f",
            "leftCorner": {
              "x": -11.867,
              "y": -20.3,
              "z": 0.622
            },
            "rightCorner": {
              "x": -11.717,
              "y": -20.3,
              "z": 0.622
            },
            "gtin": "4104420224889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5860",
            "leftCorner": {
              "x": -11.717,
              "y": -20.294,
              "z": 0.622
            },
            "rightCorner": {
              "x": -11.548,
              "y": -20.292,
              "z": 0.622
            },
            "gtin": "4104420236196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5861",
            "leftCorner": {
              "x": -11.548,
              "y": -20.284,
              "z": 0.622
            },
            "rightCorner": {
              "x": -11.382,
              "y": -20.283,
              "z": 0.622
            },
            "gtin": "4104420246690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5862",
            "leftCorner": {
              "x": -11.383,
              "y": -20.279,
              "z": 0.622
            },
            "rightCorner": {
              "x": -11.139,
              "y": -20.278,
              "z": 0.622
            },
            "gtin": "4104420094987",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5848",
            "leftCorner": {
              "x": -11.139,
              "y": -20.278,
              "z": 0.622
            },
            "rightCorner": {
              "x": -10.982,
              "y": -20.276,
              "z": 0.622
            },
            "gtin": "4280001939066",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf97",
        "height": 1.0608,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5822",
            "leftCorner": {
              "x": -12.154,
              "y": -20.311,
              "z": 0.868
            },
            "rightCorner": {
              "x": -12.004,
              "y": -20.31,
              "z": 0.868
            },
            "gtin": "8423352400076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5823",
            "leftCorner": {
              "x": -12.004,
              "y": -20.305,
              "z": 0.868
            },
            "rightCorner": {
              "x": -11.847,
              "y": -20.304,
              "z": 0.868
            },
            "gtin": "5411188115533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5824",
            "leftCorner": {
              "x": -11.846,
              "y": -20.298,
              "z": 0.868
            },
            "rightCorner": {
              "x": -11.688,
              "y": -20.297,
              "z": 0.868
            },
            "gtin": "5411188115496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5825",
            "leftCorner": {
              "x": -11.688,
              "y": -20.29,
              "z": 0.868
            },
            "rightCorner": {
              "x": -11.575,
              "y": -20.289,
              "z": 0.868
            },
            "gtin": "5411188115472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5826",
            "leftCorner": {
              "x": -11.575,
              "y": -20.289,
              "z": 0.868
            },
            "rightCorner": {
              "x": -11.462,
              "y": -20.289,
              "z": 0.868
            },
            "gtin": "5411188115472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5827",
            "leftCorner": {
              "x": -11.462,
              "y": -20.284,
              "z": 0.868
            },
            "rightCorner": {
              "x": -11.298,
              "y": -20.283,
              "z": 0.868
            },
            "gtin": "5411188140900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5828",
            "leftCorner": {
              "x": -11.298,
              "y": -20.28,
              "z": 0.868
            },
            "rightCorner": {
              "x": -11.144,
              "y": -20.278,
              "z": 0.868
            },
            "gtin": "5411188140740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5815",
            "leftCorner": {
              "x": -11.145,
              "y": -20.276,
              "z": 0.868
            },
            "rightCorner": {
              "x": -10.982,
              "y": -20.275,
              "z": 0.868
            },
            "gtin": "5411188127697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ead023f7e0f53a9b3cb17597",
            "leftCorner": {
              "x": -12.232,
              "y": -20.331,
              "z": 0.868
            },
            "rightCorner": {
              "x": -12.176,
              "y": -20.331,
              "z": 0.868
            },
            "gtin": "5411188115496",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf94",
        "height": 1.3666,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5841",
            "leftCorner": {
              "x": -12.204,
              "y": -20.318,
              "z": 1.118
            },
            "rightCorner": {
              "x": -12.054,
              "y": -20.316,
              "z": 1.118
            },
            "gtin": "5411188138464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5842",
            "leftCorner": {
              "x": -12.053,
              "y": -20.307,
              "z": 1.118
            },
            "rightCorner": {
              "x": -11.883,
              "y": -20.306,
              "z": 1.118
            },
            "gtin": "5411188140146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5843",
            "leftCorner": {
              "x": -11.883,
              "y": -20.304,
              "z": 1.118
            },
            "rightCorner": {
              "x": -11.714,
              "y": -20.303,
              "z": 1.118
            },
            "gtin": "5411188116028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5844",
            "leftCorner": {
              "x": -11.714,
              "y": -20.294,
              "z": 1.118
            },
            "rightCorner": {
              "x": -11.568,
              "y": -20.293,
              "z": 1.118
            },
            "gtin": "5411188124689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5845",
            "leftCorner": {
              "x": -11.568,
              "y": -20.288,
              "z": 1.118
            },
            "rightCorner": {
              "x": -11.423,
              "y": -20.288,
              "z": 1.118
            },
            "gtin": "5411188112709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5846",
            "leftCorner": {
              "x": -11.423,
              "y": -20.284,
              "z": 1.118
            },
            "rightCorner": {
              "x": -11.131,
              "y": -20.281,
              "z": 1.118
            },
            "gtin": "5411188110835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d582a",
            "leftCorner": {
              "x": -11.131,
              "y": -20.279,
              "z": 1.118
            },
            "rightCorner": {
              "x": -10.982,
              "y": -20.279,
              "z": 1.118
            },
            "gtin": "5411188116592",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf93",
        "height": 1.7385,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5876",
            "leftCorner": {
              "x": -12.202,
              "y": -20.315,
              "z": 1.422
            },
            "rightCorner": {
              "x": -12.098,
              "y": -20.314,
              "z": 1.422
            },
            "gtin": "4280001939400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5877",
            "leftCorner": {
              "x": -12.098,
              "y": -20.307,
              "z": 1.422
            },
            "rightCorner": {
              "x": -11.885,
              "y": -20.305,
              "z": 1.422
            },
            "gtin": "4046700001806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5878",
            "leftCorner": {
              "x": -11.884,
              "y": -20.296,
              "z": 1.422
            },
            "rightCorner": {
              "x": -11.731,
              "y": -20.295,
              "z": 1.422
            },
            "gtin": "4104420241176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5879",
            "leftCorner": {
              "x": -11.731,
              "y": -20.293,
              "z": 1.422
            },
            "rightCorner": {
              "x": -11.588,
              "y": -20.293,
              "z": 1.422
            },
            "gtin": "4104420095205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d587a",
            "leftCorner": {
              "x": -11.587,
              "y": -20.287,
              "z": 1.422
            },
            "rightCorner": {
              "x": -11.435,
              "y": -20.286,
              "z": 1.422
            },
            "gtin": "5411188121329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d587b",
            "leftCorner": {
              "x": -11.435,
              "y": -20.282,
              "z": 1.422
            },
            "rightCorner": {
              "x": -11.272,
              "y": -20.281,
              "z": 1.422
            },
            "gtin": "5411188120575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d587c",
            "leftCorner": {
              "x": -11.272,
              "y": -20.281,
              "z": 1.422
            },
            "rightCorner": {
              "x": -11.112,
              "y": -20.28,
              "z": 1.422
            },
            "gtin": "5411188128113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5864",
            "leftCorner": {
              "x": -11.112,
              "y": -20.283,
              "z": 1.422
            },
            "rightCorner": {
              "x": -10.982,
              "y": -20.282,
              "z": 1.422
            },
            "gtin": "5411188091622",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "813",
    "name": "813",
    "x": -16.607,
    "y": -18.974,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69754,
      "w": 0.71655
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 14,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cf7f",
        "height": 0.23984,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57e9",
            "leftCorner": {
              "x": -16.698,
              "y": -18.977,
              "z": 0.196
            },
            "rightCorner": {
              "x": -16.679,
              "y": -19.659,
              "z": 0.196
            },
            "gtin": "7613287138651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57ea",
            "leftCorner": {
              "x": -16.639,
              "y": -19.659,
              "z": 0.196
            },
            "rightCorner": {
              "x": -16.625,
              "y": -20.226,
              "z": 0.196
            },
            "gtin": "7613287138651",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf7e",
        "height": 0.57755,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57e5",
            "leftCorner": {
              "x": -16.656,
              "y": -18.976,
              "z": 0.473
            },
            "rightCorner": {
              "x": -16.647,
              "y": -19.277,
              "z": 0.473
            },
            "gtin": "7613287110688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57e6",
            "leftCorner": {
              "x": -16.647,
              "y": -19.277,
              "z": 0.473
            },
            "rightCorner": {
              "x": -16.64,
              "y": -19.578,
              "z": 0.473
            },
            "gtin": "7613287110688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57e7",
            "leftCorner": {
              "x": -16.6,
              "y": -19.576,
              "z": 0.473
            },
            "rightCorner": {
              "x": -16.591,
              "y": -19.9,
              "z": 0.473
            },
            "gtin": "7613287110688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57e8",
            "leftCorner": {
              "x": -16.591,
              "y": -19.9,
              "z": 0.473
            },
            "rightCorner": {
              "x": -16.583,
              "y": -20.224,
              "z": 0.473
            },
            "gtin": "7613287110688",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf7d",
        "height": 1.2607,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57e2",
            "leftCorner": {
              "x": -16.663,
              "y": -18.976,
              "z": 1.031
            },
            "rightCorner": {
              "x": -16.649,
              "y": -19.501,
              "z": 1.031
            },
            "gtin": "4014400933062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57e3",
            "leftCorner": {
              "x": -16.649,
              "y": -19.501,
              "z": 1.031
            },
            "rightCorner": {
              "x": -16.635,
              "y": -20.025,
              "z": 1.031
            },
            "gtin": "4014400933062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d57e4",
            "leftCorner": {
              "x": -16.59,
              "y": -20.024,
              "z": 1.031
            },
            "rightCorner": {
              "x": -16.585,
              "y": -20.224,
              "z": 1.031
            },
            "gtin": "4014400933079",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cf80",
        "height": 1.584,
        "facings": [
          {
            "id": "68d8e509e1820c81800d57ec",
            "leftCorner": {
              "x": -16.594,
              "y": -19.988,
              "z": 1.296
            },
            "rightCorner": {
              "x": -16.588,
              "y": -20.224,
              "z": 1.296
            },
            "gtin": "5000159500296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b2daa8b607c408c84346e345",
            "leftCorner": {
              "x": -16.661,
              "y": -18.976,
              "z": 1.296
            },
            "rightCorner": {
              "x": -16.656,
              "y": -19.171,
              "z": 1.296
            },
            "gtin": "4014400933079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "725b721f8ae16c1c3e97de39",
            "leftCorner": {
              "x": -16.656,
              "y": -19.171,
              "z": 1.296
            },
            "rightCorner": {
              "x": -16.649,
              "y": -19.414,
              "z": 1.296
            },
            "gtin": "5000159500296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bc77d048a6870d195a3cbe66",
            "leftCorner": {
              "x": -16.649,
              "y": -19.414,
              "z": 1.296
            },
            "rightCorner": {
              "x": -16.644,
              "y": -19.609,
              "z": 1.296
            },
            "gtin": "4014400933079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7a7090a611d83ce554b259fb",
            "leftCorner": {
              "x": -16.644,
              "y": -19.609,
              "z": 1.296
            },
            "rightCorner": {
              "x": -16.637,
              "y": -19.852,
              "z": 1.296
            },
            "gtin": "5000159500296",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "814",
    "name": "814",
    "x": -16.451,
    "y": -21.952,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70001,
      "w": 0.71414
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 79
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d63b",
        "height": 0.23884,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d85e5",
            "leftCorner": {
              "x": -16.554,
              "y": -21.954,
              "z": 0.195
            },
            "rightCorner": {
              "x": -16.537,
              "y": -22.854,
              "z": 0.195
            },
            "gtin": "4064285106440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85e6",
            "leftCorner": {
              "x": -16.499,
              "y": -22.853,
              "z": 0.195
            },
            "rightCorner": {
              "x": -16.497,
              "y": -22.921,
              "z": 0.195
            },
            "gtin": "4064285105207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85e7",
            "leftCorner": {
              "x": -16.488,
              "y": -22.92,
              "z": 0.195
            },
            "rightCorner": {
              "x": -16.486,
              "y": -22.981,
              "z": 0.195
            },
            "gtin": "4064285106235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85e8",
            "leftCorner": {
              "x": -16.493,
              "y": -22.982,
              "z": 0.195
            },
            "rightCorner": {
              "x": -16.493,
              "y": -23.028,
              "z": 0.195
            },
            "gtin": "4064285106211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85e9",
            "leftCorner": {
              "x": -16.494,
              "y": -23.028,
              "z": 0.195
            },
            "rightCorner": {
              "x": -16.493,
              "y": -23.063,
              "z": 0.195
            },
            "gtin": "4064285109076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85ea",
            "leftCorner": {
              "x": -16.492,
              "y": -23.063,
              "z": 0.195
            },
            "rightCorner": {
              "x": -16.491,
              "y": -23.109,
              "z": 0.195
            },
            "gtin": "4064285106211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85eb",
            "leftCorner": {
              "x": -16.498,
              "y": -23.133,
              "z": 0.195
            },
            "rightCorner": {
              "x": -16.496,
              "y": -23.194,
              "z": 0.195
            },
            "gtin": "4064285106174",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d636",
        "height": 0.50295,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d859c",
            "leftCorner": {
              "x": -16.498,
              "y": -21.953,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.496,
              "y": -22.026,
              "z": 0.412
            },
            "gtin": "4009853114106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d859d",
            "leftCorner": {
              "x": -16.496,
              "y": -22.026,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.495,
              "y": -22.099,
              "z": 0.412
            },
            "gtin": "4009853114106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d859f",
            "leftCorner": {
              "x": -16.447,
              "y": -22.099,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.446,
              "y": -22.141,
              "z": 0.412
            },
            "gtin": "4009853114120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85a0",
            "leftCorner": {
              "x": -16.448,
              "y": -22.141,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.448,
              "y": -22.175,
              "z": 0.412
            },
            "gtin": "4009853114137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85a1",
            "leftCorner": {
              "x": -16.448,
              "y": -22.175,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.447,
              "y": -22.219,
              "z": 0.412
            },
            "gtin": "4009853114120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85a2",
            "leftCorner": {
              "x": -16.442,
              "y": -22.219,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.442,
              "y": -22.276,
              "z": 0.412
            },
            "gtin": "4009853114144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85a3",
            "leftCorner": {
              "x": -16.444,
              "y": -22.276,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.442,
              "y": -22.326,
              "z": 0.412
            },
            "gtin": "4009853114168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85a4",
            "leftCorner": {
              "x": -16.446,
              "y": -22.326,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.446,
              "y": -22.379,
              "z": 0.412
            },
            "gtin": "4009853114175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85a5",
            "leftCorner": {
              "x": -16.445,
              "y": -22.379,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.444,
              "y": -22.428,
              "z": 0.412
            },
            "gtin": "4009853114182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85a6",
            "leftCorner": {
              "x": -16.448,
              "y": -22.428,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.447,
              "y": -22.467,
              "z": 0.412
            },
            "gtin": "4009853114175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85a7",
            "leftCorner": {
              "x": -16.449,
              "y": -22.467,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.448,
              "y": -22.511,
              "z": 0.412
            },
            "gtin": "4009853114182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85a8",
            "leftCorner": {
              "x": -16.454,
              "y": -22.511,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.453,
              "y": -22.592,
              "z": 0.412
            },
            "gtin": "4049583110849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85a9",
            "leftCorner": {
              "x": -16.454,
              "y": -22.592,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.452,
              "y": -22.677,
              "z": 0.412
            },
            "gtin": "4049583110870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85aa",
            "leftCorner": {
              "x": -16.451,
              "y": -22.677,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.45,
              "y": -22.766,
              "z": 0.412
            },
            "gtin": "4049583110825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85ab",
            "leftCorner": {
              "x": -16.449,
              "y": -22.766,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.448,
              "y": -22.849,
              "z": 0.412
            },
            "gtin": "4049583110856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85ac",
            "leftCorner": {
              "x": -16.448,
              "y": -22.849,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.446,
              "y": -22.931,
              "z": 0.412
            },
            "gtin": "4049583110818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85ad",
            "leftCorner": {
              "x": -16.445,
              "y": -22.931,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.443,
              "y": -23.018,
              "z": 0.412
            },
            "gtin": "4049583110887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85ae",
            "leftCorner": {
              "x": -16.442,
              "y": -23.018,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.439,
              "y": -23.135,
              "z": 0.412
            },
            "gtin": "4064285106563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d859e",
            "leftCorner": {
              "x": -16.441,
              "y": -23.135,
              "z": 0.412
            },
            "rightCorner": {
              "x": -16.44,
              "y": -23.202,
              "z": 0.412
            },
            "gtin": "4049583110894",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d637",
        "height": 0.82896,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d85af",
            "leftCorner": {
              "x": -16.503,
              "y": -21.954,
              "z": 0.678
            },
            "rightCorner": {
              "x": -16.501,
              "y": -22.054,
              "z": 0.678
            },
            "gtin": "4064285103685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85b0",
            "leftCorner": {
              "x": -16.501,
              "y": -22.054,
              "z": 0.678
            },
            "rightCorner": {
              "x": -16.499,
              "y": -22.155,
              "z": 0.678
            },
            "gtin": "4064285103685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85b3",
            "leftCorner": {
              "x": -16.449,
              "y": -22.154,
              "z": 0.678
            },
            "rightCorner": {
              "x": -16.447,
              "y": -22.247,
              "z": 0.678
            },
            "gtin": "4064285106471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85b4",
            "leftCorner": {
              "x": -16.445,
              "y": -22.247,
              "z": 0.678
            },
            "rightCorner": {
              "x": -16.443,
              "y": -22.368,
              "z": 0.678
            },
            "gtin": "4064285109236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85b5",
            "leftCorner": {
              "x": -16.45,
              "y": -22.368,
              "z": 0.678
            },
            "rightCorner": {
              "x": -16.447,
              "y": -22.486,
              "z": 0.678
            },
            "gtin": "4064285106464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85b6",
            "leftCorner": {
              "x": -16.45,
              "y": -22.486,
              "z": 0.678
            },
            "rightCorner": {
              "x": -16.449,
              "y": -22.571,
              "z": 0.678
            },
            "gtin": "4064285103449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85b7",
            "leftCorner": {
              "x": -16.455,
              "y": -22.571,
              "z": 0.678
            },
            "rightCorner": {
              "x": -16.452,
              "y": -22.678,
              "z": 0.678
            },
            "gtin": "4064285106495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85b8",
            "leftCorner": {
              "x": -16.451,
              "y": -22.678,
              "z": 0.678
            },
            "rightCorner": {
              "x": -16.449,
              "y": -22.774,
              "z": 0.678
            },
            "gtin": "4064285103432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85b9",
            "leftCorner": {
              "x": -16.448,
              "y": -22.774,
              "z": 0.678
            },
            "rightCorner": {
              "x": -16.446,
              "y": -22.905,
              "z": 0.678
            },
            "gtin": "4064285106464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85ba",
            "leftCorner": {
              "x": -16.444,
              "y": -22.905,
              "z": 0.678
            },
            "rightCorner": {
              "x": -16.442,
              "y": -23.005,
              "z": 0.678
            },
            "gtin": "4049583117145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85b1",
            "leftCorner": {
              "x": -16.442,
              "y": -23.005,
              "z": 0.678
            },
            "rightCorner": {
              "x": -16.44,
              "y": -23.104,
              "z": 0.678
            },
            "gtin": "4064285106570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85b2",
            "leftCorner": {
              "x": -16.44,
              "y": -23.104,
              "z": 0.678
            },
            "rightCorner": {
              "x": -16.438,
              "y": -23.202,
              "z": 0.678
            },
            "gtin": "4064285106570",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d638",
        "height": 1.1069,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d85bb",
            "leftCorner": {
              "x": -16.503,
              "y": -21.954,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.501,
              "y": -22.015,
              "z": 0.906
            },
            "gtin": "4064285103449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85bc",
            "leftCorner": {
              "x": -16.501,
              "y": -22.015,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.501,
              "y": -22.075,
              "z": 0.906
            },
            "gtin": "4064285103449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85bd",
            "leftCorner": {
              "x": -16.501,
              "y": -22.075,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.499,
              "y": -22.136,
              "z": 0.906
            },
            "gtin": "4064285103449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85bf",
            "leftCorner": {
              "x": -16.449,
              "y": -22.135,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.447,
              "y": -22.239,
              "z": 0.906
            },
            "gtin": "4049583111730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85c0",
            "leftCorner": {
              "x": -16.442,
              "y": -22.239,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.44,
              "y": -22.346,
              "z": 0.906
            },
            "gtin": "4064285111826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85c1",
            "leftCorner": {
              "x": -16.449,
              "y": -22.346,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.447,
              "y": -22.463,
              "z": 0.906
            },
            "gtin": "4049583111754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85c2",
            "leftCorner": {
              "x": -16.454,
              "y": -22.463,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.452,
              "y": -22.563,
              "z": 0.906
            },
            "gtin": "4049583116315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85c3",
            "leftCorner": {
              "x": -16.456,
              "y": -22.563,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.454,
              "y": -22.646,
              "z": 0.906
            },
            "gtin": "4064285108406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85c4",
            "leftCorner": {
              "x": -16.454,
              "y": -22.646,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.452,
              "y": -22.752,
              "z": 0.906
            },
            "gtin": "4049583117442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85c5",
            "leftCorner": {
              "x": -16.449,
              "y": -22.752,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.446,
              "y": -22.863,
              "z": 0.906
            },
            "gtin": "4049583117107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85c6",
            "leftCorner": {
              "x": -16.446,
              "y": -22.863,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.446,
              "y": -22.954,
              "z": 0.906
            },
            "gtin": "4049583116117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85c7",
            "leftCorner": {
              "x": -16.443,
              "y": -22.954,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.44,
              "y": -23.059,
              "z": 0.906
            },
            "gtin": "4049583117015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85c8",
            "leftCorner": {
              "x": -16.439,
              "y": -23.059,
              "z": 0.906
            },
            "rightCorner": {
              "x": -16.437,
              "y": -23.165,
              "z": 0.906
            },
            "gtin": "4049583117343",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d63a",
        "height": 1.4091,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d85db",
            "leftCorner": {
              "x": -16.506,
              "y": -21.954,
              "z": 1.153
            },
            "rightCorner": {
              "x": -16.5,
              "y": -22.25,
              "z": 1.153
            },
            "gtin": "4009853116025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85dc",
            "leftCorner": {
              "x": -16.449,
              "y": -22.248,
              "z": 1.153
            },
            "rightCorner": {
              "x": -16.447,
              "y": -22.355,
              "z": 1.153
            },
            "gtin": "4049583115462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85dd",
            "leftCorner": {
              "x": -16.453,
              "y": -22.356,
              "z": 1.153
            },
            "rightCorner": {
              "x": -16.451,
              "y": -22.465,
              "z": 1.153
            },
            "gtin": "4049583115479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85de",
            "leftCorner": {
              "x": -16.455,
              "y": -22.465,
              "z": 1.153
            },
            "rightCorner": {
              "x": -16.452,
              "y": -22.577,
              "z": 1.153
            },
            "gtin": "4049583117534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85df",
            "leftCorner": {
              "x": -16.456,
              "y": -22.577,
              "z": 1.153
            },
            "rightCorner": {
              "x": -16.454,
              "y": -22.677,
              "z": 1.153
            },
            "gtin": "4049583117091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85e0",
            "leftCorner": {
              "x": -16.456,
              "y": -22.677,
              "z": 1.153
            },
            "rightCorner": {
              "x": -16.454,
              "y": -22.785,
              "z": 1.153
            },
            "gtin": "4049583116230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85e1",
            "leftCorner": {
              "x": -16.451,
              "y": -22.785,
              "z": 1.153
            },
            "rightCorner": {
              "x": -16.449,
              "y": -22.886,
              "z": 1.153
            },
            "gtin": "4049583112164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85e2",
            "leftCorner": {
              "x": -16.449,
              "y": -22.886,
              "z": 1.153
            },
            "rightCorner": {
              "x": -16.447,
              "y": -22.975,
              "z": 1.153
            },
            "gtin": "4049583116520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85e3",
            "leftCorner": {
              "x": -16.446,
              "y": -22.975,
              "z": 1.153
            },
            "rightCorner": {
              "x": -16.444,
              "y": -23.083,
              "z": 1.153
            },
            "gtin": "4064285106723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85e4",
            "leftCorner": {
              "x": -16.442,
              "y": -23.083,
              "z": 1.153
            },
            "rightCorner": {
              "x": -16.44,
              "y": -23.178,
              "z": 1.153
            },
            "gtin": "4049583115349",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d639",
        "height": 1.7089,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d85c9",
            "leftCorner": {
              "x": -16.5,
              "y": -21.954,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.496,
              "y": -22.156,
              "z": 1.398
            },
            "gtin": "4049583113086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85cb",
            "leftCorner": {
              "x": -16.443,
              "y": -22.156,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.441,
              "y": -22.262,
              "z": 1.398
            },
            "gtin": "4049583116179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85cc",
            "leftCorner": {
              "x": -16.444,
              "y": -22.262,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.442,
              "y": -22.354,
              "z": 1.398
            },
            "gtin": "4049583116162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85cd",
            "leftCorner": {
              "x": -16.443,
              "y": -22.354,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.442,
              "y": -22.398,
              "z": 1.398
            },
            "gtin": "4064285105979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85ce",
            "leftCorner": {
              "x": -16.448,
              "y": -22.398,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.448,
              "y": -22.443,
              "z": 1.398
            },
            "gtin": "4064285105986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85cf",
            "leftCorner": {
              "x": -16.451,
              "y": -22.443,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.45,
              "y": -22.48,
              "z": 1.398
            },
            "gtin": "4064285105979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85d0",
            "leftCorner": {
              "x": -16.447,
              "y": -22.48,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.446,
              "y": -22.57,
              "z": 1.398
            },
            "gtin": "4064285106013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85d1",
            "leftCorner": {
              "x": -16.452,
              "y": -22.57,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.45,
              "y": -22.648,
              "z": 1.398
            },
            "gtin": "4064285105962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85d2",
            "leftCorner": {
              "x": -16.449,
              "y": -22.648,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.448,
              "y": -22.687,
              "z": 1.398
            },
            "gtin": "4064285103678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85d3",
            "leftCorner": {
              "x": -16.451,
              "y": -22.687,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.45,
              "y": -22.735,
              "z": 1.398
            },
            "gtin": "4064285103647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85d4",
            "leftCorner": {
              "x": -16.446,
              "y": -22.735,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.444,
              "y": -22.774,
              "z": 1.398
            },
            "gtin": "4064285103678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85d5",
            "leftCorner": {
              "x": -16.445,
              "y": -22.774,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.445,
              "y": -22.818,
              "z": 1.398
            },
            "gtin": "4064285103623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85d6",
            "leftCorner": {
              "x": -16.442,
              "y": -22.818,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.441,
              "y": -22.862,
              "z": 1.398
            },
            "gtin": "4064285103630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85d7",
            "leftCorner": {
              "x": -16.441,
              "y": -22.862,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.44,
              "y": -22.905,
              "z": 1.398
            },
            "gtin": "4064285103661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85d8",
            "leftCorner": {
              "x": -16.439,
              "y": -22.905,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.438,
              "y": -22.96,
              "z": 1.398
            },
            "gtin": "4064285103616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85d9",
            "leftCorner": {
              "x": -16.44,
              "y": -22.961,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.439,
              "y": -23.046,
              "z": 1.398
            },
            "gtin": "4009853116728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85da",
            "leftCorner": {
              "x": -16.44,
              "y": -23.046,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.438,
              "y": -23.134,
              "z": 1.398
            },
            "gtin": "4049583111327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85ca",
            "leftCorner": {
              "x": -16.442,
              "y": -23.134,
              "z": 1.398
            },
            "rightCorner": {
              "x": -16.44,
              "y": -23.202,
              "z": 1.398
            },
            "gtin": "4064285103593",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "815",
    "name": "815",
    "x": -10.326,
    "y": -23.101,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70445,
      "w": 0.70975
    },
    "layers": []
  },
  {
    "id": "816",
    "name": "816",
    "x": -14.618,
    "y": -24.787,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 0.0012828
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 27
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfda",
        "height": 0.16927,
        "facings": [
          {
            "id": "cd5b689f9146fec9c89d258c",
            "leftCorner": {
              "x": -14.618,
              "y": -24.7,
              "z": 0.138
            },
            "rightCorner": {
              "x": -14.738,
              "y": -24.7,
              "z": 0.138
            },
            "gtin": "4000286233426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8078ae621423e03c637f7221",
            "leftCorner": {
              "x": -14.738,
              "y": -24.7,
              "z": 0.138
            },
            "rightCorner": {
              "x": -14.861,
              "y": -24.701,
              "z": 0.138
            },
            "gtin": "4000186011032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8e638539e3148f40c2680818",
            "leftCorner": {
              "x": -14.861,
              "y": -24.701,
              "z": 0.138
            },
            "rightCorner": {
              "x": -14.991,
              "y": -24.701,
              "z": 0.138
            },
            "gtin": "4000186036240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b9587f418d1dcbcb56e60ed2",
            "leftCorner": {
              "x": -14.991,
              "y": -24.701,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.165,
              "y": -24.701,
              "z": 0.138
            },
            "gtin": "4000186016204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5ea48424eaa3fb6ccc05702a",
            "leftCorner": {
              "x": -15.165,
              "y": -24.701,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.359,
              "y": -24.702,
              "z": 0.138
            },
            "gtin": "4000186020201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "118687f16cce24e2961084ab",
            "leftCorner": {
              "x": -15.359,
              "y": -24.702,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.577,
              "y": -24.702,
              "z": 0.138
            },
            "gtin": "4000186037544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "590afb94465d752cd7c01dda",
            "leftCorner": {
              "x": -15.577,
              "y": -24.702,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.847,
              "y": -24.703,
              "z": 0.138
            },
            "gtin": "4000186014408",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfd9",
        "height": 1.0044,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a98",
            "leftCorner": {
              "x": -14.678,
              "y": -24.774,
              "z": 0.822
            },
            "rightCorner": {
              "x": -14.758,
              "y": -24.774,
              "z": 0.822
            },
            "gtin": "4001726153007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a99",
            "leftCorner": {
              "x": -14.758,
              "y": -24.774,
              "z": 0.822
            },
            "rightCorner": {
              "x": -14.839,
              "y": -24.775,
              "z": 0.822
            },
            "gtin": "4001726153007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a9a",
            "leftCorner": {
              "x": -14.839,
              "y": -24.775,
              "z": 0.822
            },
            "rightCorner": {
              "x": -14.919,
              "y": -24.775,
              "z": 0.822
            },
            "gtin": "4001726153007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a9b",
            "leftCorner": {
              "x": -14.919,
              "y": -24.775,
              "z": 0.822
            },
            "rightCorner": {
              "x": -14.999,
              "y": -24.775,
              "z": 0.822
            },
            "gtin": "4001726153007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a7e",
            "leftCorner": {
              "x": -14.999,
              "y": -24.783,
              "z": 0.822
            },
            "rightCorner": {
              "x": -15.217,
              "y": -24.784,
              "z": 0.822
            },
            "gtin": "4001726008031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a7f",
            "leftCorner": {
              "x": -15.217,
              "y": -24.784,
              "z": 0.822
            },
            "rightCorner": {
              "x": -15.434,
              "y": -24.785,
              "z": 0.822
            },
            "gtin": "4001726008031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a80",
            "leftCorner": {
              "x": -15.434,
              "y": -24.785,
              "z": 0.822
            },
            "rightCorner": {
              "x": -15.651,
              "y": -24.786,
              "z": 0.822
            },
            "gtin": "4001726008031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a81",
            "leftCorner": {
              "x": -15.651,
              "y": -24.786,
              "z": 0.822
            },
            "rightCorner": {
              "x": -15.868,
              "y": -24.786,
              "z": 0.822
            },
            "gtin": "4001726008031",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfd8",
        "height": 1.3619,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5aab",
            "leftCorner": {
              "x": -14.664,
              "y": -24.77,
              "z": 1.114
            },
            "rightCorner": {
              "x": -14.917,
              "y": -24.771,
              "z": 1.114
            },
            "gtin": "4000186037919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aac",
            "leftCorner": {
              "x": -14.917,
              "y": -24.777,
              "z": 1.114
            },
            "rightCorner": {
              "x": -15.104,
              "y": -24.778,
              "z": 1.114
            },
            "gtin": "4000186020201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aad",
            "leftCorner": {
              "x": -15.104,
              "y": -24.78,
              "z": 1.114
            },
            "rightCorner": {
              "x": -15.281,
              "y": -24.78,
              "z": 1.114
            },
            "gtin": "4000186016204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aae",
            "leftCorner": {
              "x": -15.281,
              "y": -24.781,
              "z": 1.114
            },
            "rightCorner": {
              "x": -15.405,
              "y": -24.782,
              "z": 1.114
            },
            "gtin": "4000186011032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aaf",
            "leftCorner": {
              "x": -15.405,
              "y": -24.781,
              "z": 1.114
            },
            "rightCorner": {
              "x": -15.658,
              "y": -24.782,
              "z": 1.114
            },
            "gtin": "4000186011407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aa5",
            "leftCorner": {
              "x": -15.658,
              "y": -24.781,
              "z": 1.114
            },
            "rightCorner": {
              "x": -15.868,
              "y": -24.781,
              "z": 1.114
            },
            "gtin": "4000186037544",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfd7",
        "height": 1.6093,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a5c",
            "leftCorner": {
              "x": -14.635,
              "y": -24.77,
              "z": 1.317
            },
            "rightCorner": {
              "x": -14.745,
              "y": -24.77,
              "z": 1.317
            },
            "gtin": "4000286233426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a5d",
            "leftCorner": {
              "x": -14.745,
              "y": -24.771,
              "z": 1.317
            },
            "rightCorner": {
              "x": -14.981,
              "y": -24.772,
              "z": 1.317
            },
            "gtin": "4000186010400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a5e",
            "leftCorner": {
              "x": -14.981,
              "y": -24.774,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.11,
              "y": -24.775,
              "z": 1.317
            },
            "gtin": "4000186036240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a5f",
            "leftCorner": {
              "x": -15.11,
              "y": -24.778,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.382,
              "y": -24.779,
              "z": 1.317
            },
            "gtin": "4000186014408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a60",
            "leftCorner": {
              "x": -15.382,
              "y": -24.778,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.632,
              "y": -24.779,
              "z": 1.317
            },
            "gtin": "4000186114504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a48",
            "leftCorner": {
              "x": -15.632,
              "y": -24.784,
              "z": 1.317
            },
            "rightCorner": {
              "x": -15.868,
              "y": -24.784,
              "z": 1.317
            },
            "gtin": "4306188047759",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "817"
  },
  {
    "id": "817",
    "name": "817",
    "x": -13.368,
    "y": -24.783,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 0.0012828
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfd6",
        "height": 0.16755,
        "facings": [
          {
            "id": "82302a041aab7ce08ce25ee6",
            "leftCorner": {
              "x": -13.368,
              "y": -24.697,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.451,
              "y": -24.697,
              "z": 0.137
            },
            "gtin": "4104420136946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0baff702614f7842dfc14df8",
            "leftCorner": {
              "x": -13.451,
              "y": -24.697,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.559,
              "y": -24.697,
              "z": 0.137
            },
            "gtin": "4000521712006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7655c0d453d2a411bc02d002",
            "leftCorner": {
              "x": -13.559,
              "y": -24.697,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.698,
              "y": -24.698,
              "z": 0.137
            },
            "gtin": "4006363101886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0a9fc9c35a03e62df3fc002b",
            "leftCorner": {
              "x": -13.698,
              "y": -24.698,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.862,
              "y": -24.698,
              "z": 0.137
            },
            "gtin": "4046800110903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e3487ed1000cb4bec762e6fe",
            "leftCorner": {
              "x": -13.862,
              "y": -24.698,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.049,
              "y": -24.699,
              "z": 0.137
            },
            "gtin": "4006363100131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2955a5e8707bfa438b051ad9",
            "leftCorner": {
              "x": -14.049,
              "y": -24.699,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.239,
              "y": -24.699,
              "z": 0.137
            },
            "gtin": "4006363100148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1c791f3e3e2df98ecb949fc7",
            "leftCorner": {
              "x": -14.239,
              "y": -24.699,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.433,
              "y": -24.7,
              "z": 0.137
            },
            "gtin": "4046800110132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "32302999b7f928209c188e2b",
            "leftCorner": {
              "x": -14.433,
              "y": -24.7,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.597,
              "y": -24.7,
              "z": 0.137
            },
            "gtin": "4046800110903",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfd5",
        "height": 1.0013,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a92",
            "leftCorner": {
              "x": -13.782,
              "y": -24.764,
              "z": 0.819
            },
            "rightCorner": {
              "x": -14.002,
              "y": -24.765,
              "z": 0.819
            },
            "gtin": "4001726344009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "34a28ea42e84c6a69c6bd358",
            "leftCorner": {
              "x": -13.368,
              "y": -24.735,
              "z": 0.819
            },
            "rightCorner": {
              "x": -13.415,
              "y": -24.735,
              "z": 0.819
            },
            "gtin": "4001726327002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "53b63910fab16cc06a6818e0",
            "leftCorner": {
              "x": -13.415,
              "y": -24.735,
              "z": 0.819
            },
            "rightCorner": {
              "x": -13.613,
              "y": -24.736,
              "z": 0.819
            },
            "gtin": "4001726329006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "72d20f4092ee3edee2ad3c13",
            "leftCorner": {
              "x": -13.613,
              "y": -24.736,
              "z": 0.819
            },
            "rightCorner": {
              "x": -13.765,
              "y": -24.736,
              "z": 0.819
            },
            "gtin": "4001726346003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a93",
            "leftCorner": {
              "x": -14.002,
              "y": -24.765,
              "z": 0.819
            },
            "rightCorner": {
              "x": -14.222,
              "y": -24.765,
              "z": 0.819
            },
            "gtin": "4001726344009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a94",
            "leftCorner": {
              "x": -14.222,
              "y": -24.777,
              "z": 0.819
            },
            "rightCorner": {
              "x": -14.3,
              "y": -24.778,
              "z": 0.819
            },
            "gtin": "4001726346003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a95",
            "leftCorner": {
              "x": -14.3,
              "y": -24.778,
              "z": 0.819
            },
            "rightCorner": {
              "x": -14.378,
              "y": -24.778,
              "z": 0.819
            },
            "gtin": "4001726346003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a96",
            "leftCorner": {
              "x": -14.378,
              "y": -24.778,
              "z": 0.819
            },
            "rightCorner": {
              "x": -14.58,
              "y": -24.778,
              "z": 0.819
            },
            "gtin": "4001726329006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a97",
            "leftCorner": {
              "x": -14.58,
              "y": -24.773,
              "z": 0.819
            },
            "rightCorner": {
              "x": -14.678,
              "y": -24.773,
              "z": 0.819
            },
            "gtin": "4001726327002",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfd4",
        "height": 1.3569,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5aa4",
            "leftCorner": {
              "x": -13.368,
              "y": -24.726,
              "z": 1.11
            },
            "rightCorner": {
              "x": -13.557,
              "y": -24.727,
              "z": 1.11
            },
            "gtin": "4046800110125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aa6",
            "leftCorner": {
              "x": -13.558,
              "y": -24.755,
              "z": 1.11
            },
            "rightCorner": {
              "x": -13.77,
              "y": -24.755,
              "z": 1.11
            },
            "gtin": "4046800110132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aa7",
            "leftCorner": {
              "x": -13.769,
              "y": -24.759,
              "z": 1.11
            },
            "rightCorner": {
              "x": -14.02,
              "y": -24.759,
              "z": 1.11
            },
            "gtin": "4046800111047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aa8",
            "leftCorner": {
              "x": -14.02,
              "y": -24.768,
              "z": 1.11
            },
            "rightCorner": {
              "x": -14.227,
              "y": -24.768,
              "z": 1.11
            },
            "gtin": "4000521191009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aa9",
            "leftCorner": {
              "x": -14.227,
              "y": -24.771,
              "z": 1.11
            },
            "rightCorner": {
              "x": -14.436,
              "y": -24.772,
              "z": 1.11
            },
            "gtin": "4104420226647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aaa",
            "leftCorner": {
              "x": -14.436,
              "y": -24.769,
              "z": 1.11
            },
            "rightCorner": {
              "x": -14.664,
              "y": -24.769,
              "z": 1.11
            },
            "gtin": "4006363100148",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfd3",
        "height": 1.6053,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a55",
            "leftCorner": {
              "x": -13.383,
              "y": -24.752,
              "z": 1.313
            },
            "rightCorner": {
              "x": -13.475,
              "y": -24.752,
              "z": 1.313
            },
            "gtin": "4000521712006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a56",
            "leftCorner": {
              "x": -13.475,
              "y": -24.752,
              "z": 1.313
            },
            "rightCorner": {
              "x": -13.562,
              "y": -24.752,
              "z": 1.313
            },
            "gtin": "4104420136946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a57",
            "leftCorner": {
              "x": -13.562,
              "y": -24.75,
              "z": 1.313
            },
            "rightCorner": {
              "x": -13.747,
              "y": -24.75,
              "z": 1.313
            },
            "gtin": "4046800110903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a58",
            "leftCorner": {
              "x": -13.747,
              "y": -24.754,
              "z": 1.313
            },
            "rightCorner": {
              "x": -14.076,
              "y": -24.754,
              "z": 1.313
            },
            "gtin": "4046800110927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a59",
            "leftCorner": {
              "x": -14.076,
              "y": -24.766,
              "z": 1.313
            },
            "rightCorner": {
              "x": -14.219,
              "y": -24.767,
              "z": 1.313
            },
            "gtin": "4006363101886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a5a",
            "leftCorner": {
              "x": -14.219,
              "y": -24.767,
              "z": 1.313
            },
            "rightCorner": {
              "x": -14.44,
              "y": -24.767,
              "z": 1.313
            },
            "gtin": "4006363101893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a5b",
            "leftCorner": {
              "x": -14.44,
              "y": -24.77,
              "z": 1.313
            },
            "rightCorner": {
              "x": -14.635,
              "y": -24.769,
              "z": 1.313
            },
            "gtin": "4006363100131",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "818",
    "rightNeighborShelfId": "816"
  },
  {
    "id": "818",
    "name": "818",
    "x": -12.118,
    "y": -24.78,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 0.0012828
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 37
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfd1",
        "height": 0.16867,
        "facings": [
          {
            "id": "86c0b59b3862d1674d8fda18",
            "leftCorner": {
              "x": -12.118,
              "y": -24.691,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.276,
              "y": -24.691,
              "z": 0.138
            },
            "gtin": "4001726221003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b2f6642ff01b4f8540dd955f",
            "leftCorner": {
              "x": -12.276,
              "y": -24.691,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.369,
              "y": -24.692,
              "z": 0.138
            },
            "gtin": "40352619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7575208fcb7c29e6882868f6",
            "leftCorner": {
              "x": -12.369,
              "y": -24.692,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.477,
              "y": -24.692,
              "z": 0.138
            },
            "gtin": "4000521700713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c81d7b5f3dfb551876df4ff4",
            "leftCorner": {
              "x": -12.477,
              "y": -24.692,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.592,
              "y": -24.692,
              "z": 0.138
            },
            "gtin": "4000521701215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "67e292aad515f6a7b25d100d",
            "leftCorner": {
              "x": -12.592,
              "y": -24.692,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.749,
              "y": -24.693,
              "z": 0.138
            },
            "gtin": "4001726221003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5b4f3321df4ed3413ccd9842",
            "leftCorner": {
              "x": -12.749,
              "y": -24.693,
              "z": 0.138
            },
            "rightCorner": {
              "x": -12.915,
              "y": -24.693,
              "z": 0.138
            },
            "gtin": "4250780324438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d0ddb6941f46564455d04532",
            "leftCorner": {
              "x": -12.915,
              "y": -24.693,
              "z": 0.138
            },
            "rightCorner": {
              "x": -13.082,
              "y": -24.693,
              "z": 0.138
            },
            "gtin": "4001726151003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4df700fa77b1c426578b6c24",
            "leftCorner": {
              "x": -13.082,
              "y": -24.693,
              "z": 0.138
            },
            "rightCorner": {
              "x": -13.363,
              "y": -24.694,
              "z": 0.138
            },
            "gtin": "4001726011918",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfce",
        "height": 0.40168,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a79",
            "leftCorner": {
              "x": -12.345,
              "y": -24.784,
              "z": 0.329
            },
            "rightCorner": {
              "x": -12.554,
              "y": -24.784,
              "z": 0.329
            },
            "gtin": "4001726899035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a7a",
            "leftCorner": {
              "x": -12.554,
              "y": -24.786,
              "z": 0.329
            },
            "rightCorner": {
              "x": -12.753,
              "y": -24.787,
              "z": 0.329
            },
            "gtin": "4001726828004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a7b",
            "leftCorner": {
              "x": -12.753,
              "y": -24.787,
              "z": 0.329
            },
            "rightCorner": {
              "x": -12.999,
              "y": -24.788,
              "z": 0.329
            },
            "gtin": "4008258571019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a7c",
            "leftCorner": {
              "x": -12.999,
              "y": -24.779,
              "z": 0.329
            },
            "rightCorner": {
              "x": -13.198,
              "y": -24.779,
              "z": 0.329
            },
            "gtin": "4104420021785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a71",
            "leftCorner": {
              "x": -13.198,
              "y": -24.774,
              "z": 0.329
            },
            "rightCorner": {
              "x": -13.368,
              "y": -24.774,
              "z": 0.329
            },
            "gtin": "4250780324438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "297f5fc0aa96a8f75ac170bd",
            "leftCorner": {
              "x": -12.118,
              "y": -24.744,
              "z": 0.329
            },
            "rightCorner": {
              "x": -12.33,
              "y": -24.745,
              "z": 0.329
            },
            "gtin": "4001726899035",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfcf",
        "height": 0.69813,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a6c",
            "leftCorner": {
              "x": -12.201,
              "y": -24.767,
              "z": 0.571
            },
            "rightCorner": {
              "x": -12.233,
              "y": -24.767,
              "z": 0.571
            },
            "gtin": "4008381145002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a6e",
            "leftCorner": {
              "x": -12.476,
              "y": -24.775,
              "z": 0.571
            },
            "rightCorner": {
              "x": -12.644,
              "y": -24.776,
              "z": 0.571
            },
            "gtin": "4001726151003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a6f",
            "leftCorner": {
              "x": -12.644,
              "y": -24.777,
              "z": 0.571
            },
            "rightCorner": {
              "x": -13.15,
              "y": -24.778,
              "z": 0.571
            },
            "gtin": "4008381178000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a62",
            "leftCorner": {
              "x": -13.15,
              "y": -24.764,
              "z": 0.571
            },
            "rightCorner": {
              "x": -13.368,
              "y": -24.765,
              "z": 0.571
            },
            "gtin": "4001726294007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b6f97bee9fb3004c8ee104bf",
            "leftCorner": {
              "x": -12.233,
              "y": -24.728,
              "z": 0.571
            },
            "rightCorner": {
              "x": -12.457,
              "y": -24.729,
              "z": 0.571
            },
            "gtin": "4001726294007",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfcd",
        "height": 1.0006,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a8c",
            "leftCorner": {
              "x": -12.148,
              "y": -24.765,
              "z": 0.819
            },
            "rightCorner": {
              "x": -12.216,
              "y": -24.765,
              "z": 0.819
            },
            "gtin": "4001726005306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a8d",
            "leftCorner": {
              "x": -12.216,
              "y": -24.765,
              "z": 0.819
            },
            "rightCorner": {
              "x": -12.283,
              "y": -24.765,
              "z": 0.819
            },
            "gtin": "4001726005306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a8e",
            "leftCorner": {
              "x": -12.283,
              "y": -24.765,
              "z": 0.819
            },
            "rightCorner": {
              "x": -12.351,
              "y": -24.766,
              "z": 0.819
            },
            "gtin": "4001726005306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a8f",
            "leftCorner": {
              "x": -12.351,
              "y": -24.77,
              "z": 0.819
            },
            "rightCorner": {
              "x": -12.558,
              "y": -24.77,
              "z": 0.819
            },
            "gtin": "4001726189006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a90",
            "leftCorner": {
              "x": -12.558,
              "y": -24.773,
              "z": 0.819
            },
            "rightCorner": {
              "x": -12.846,
              "y": -24.774,
              "z": 0.819
            },
            "gtin": "4001726011918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a91",
            "leftCorner": {
              "x": -12.847,
              "y": -24.768,
              "z": 0.819
            },
            "rightCorner": {
              "x": -13.782,
              "y": -24.771,
              "z": 0.819
            },
            "gtin": "4008381148003",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfd0",
        "height": 1.3023,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a42",
            "leftCorner": {
              "x": -12.118,
              "y": -24.753,
              "z": 1.066
            },
            "rightCorner": {
              "x": -12.353,
              "y": -24.75,
              "z": 1.066
            },
            "gtin": "4001726009496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a43",
            "leftCorner": {
              "x": -12.353,
              "y": -24.75,
              "z": 1.066
            },
            "rightCorner": {
              "x": -12.587,
              "y": -24.747,
              "z": 1.066
            },
            "gtin": "4001726009496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a44",
            "leftCorner": {
              "x": -12.587,
              "y": -24.77,
              "z": 1.066
            },
            "rightCorner": {
              "x": -13.065,
              "y": -24.771,
              "z": 1.066
            },
            "gtin": "4001726009496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a45",
            "leftCorner": {
              "x": -13.065,
              "y": -24.757,
              "z": 1.066
            },
            "rightCorner": {
              "x": -13.156,
              "y": -24.757,
              "z": 1.066
            },
            "gtin": "40352619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a46",
            "leftCorner": {
              "x": -13.156,
              "y": -24.757,
              "z": 1.066
            },
            "rightCorner": {
              "x": -13.256,
              "y": -24.757,
              "z": 1.066
            },
            "gtin": "4000521700713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a3b",
            "leftCorner": {
              "x": -13.256,
              "y": -24.756,
              "z": 1.066
            },
            "rightCorner": {
              "x": -13.368,
              "y": -24.756,
              "z": 1.066
            },
            "gtin": "4000521701215",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfcc",
        "height": 1.6038,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a50",
            "leftCorner": {
              "x": -12.285,
              "y": -24.76,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.532,
              "y": -24.761,
              "z": 1.312
            },
            "gtin": "4000521003371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0cccfe322f28e58352489a8f",
            "leftCorner": {
              "x": -12.118,
              "y": -24.719,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.225,
              "y": -24.719,
              "z": 1.312
            },
            "gtin": "4000521711603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a51",
            "leftCorner": {
              "x": -12.532,
              "y": -24.767,
              "z": 1.312
            },
            "rightCorner": {
              "x": -12.806,
              "y": -24.767,
              "z": 1.312
            },
            "gtin": "4000521005474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a52",
            "leftCorner": {
              "x": -12.806,
              "y": -24.762,
              "z": 1.312
            },
            "rightCorner": {
              "x": -13.077,
              "y": -24.762,
              "z": 1.312
            },
            "gtin": "4000521730307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a53",
            "leftCorner": {
              "x": -13.077,
              "y": -24.749,
              "z": 1.312
            },
            "rightCorner": {
              "x": -13.181,
              "y": -24.75,
              "z": 1.312
            },
            "gtin": "4000521711603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a54",
            "leftCorner": {
              "x": -13.181,
              "y": -24.751,
              "z": 1.312
            },
            "rightCorner": {
              "x": -13.382,
              "y": -24.751,
              "z": 1.312
            },
            "gtin": "4000521711801",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "819",
    "rightNeighborShelfId": "817"
  },
  {
    "id": "819",
    "name": "819",
    "x": -10.868,
    "y": -24.777,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 0.0012828
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 54
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfcb",
        "height": 0.17072,
        "facings": [
          {
            "id": "e48e4d84aeafd4422f76326c",
            "leftCorner": {
              "x": -10.868,
              "y": -24.69,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.922,
              "y": -24.69,
              "z": 0.14
            },
            "gtin": "4001475215667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "18516b773f1c6668b1e4fd8a",
            "leftCorner": {
              "x": -10.922,
              "y": -24.69,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.98,
              "y": -24.69,
              "z": 0.14
            },
            "gtin": "4260175670491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "eb0b8fd86c3c1e39e19e16c2",
            "leftCorner": {
              "x": -10.98,
              "y": -24.69,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.059,
              "y": -24.69,
              "z": 0.14
            },
            "gtin": "8711000476246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0e8e6e57a73fd09eb0c0b1c0",
            "leftCorner": {
              "x": -11.059,
              "y": -24.69,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.144,
              "y": -24.691,
              "z": 0.14
            },
            "gtin": "4001475105708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9d6d2a59662d81da9cb8b831",
            "leftCorner": {
              "x": -11.144,
              "y": -24.691,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.229,
              "y": -24.691,
              "z": 0.14
            },
            "gtin": "4001475119743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a2906eab656b1bb92566035d",
            "leftCorner": {
              "x": -11.229,
              "y": -24.691,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.322,
              "y": -24.691,
              "z": 0.14
            },
            "gtin": "8711000476208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f0066fa33207d297b6b961ce",
            "leftCorner": {
              "x": -11.322,
              "y": -24.691,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.417,
              "y": -24.691,
              "z": 0.14
            },
            "gtin": "4001475116742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3e0b7d2f67b5da7be41fc0f0",
            "leftCorner": {
              "x": -11.417,
              "y": -24.691,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.52,
              "y": -24.692,
              "z": 0.14
            },
            "gtin": "4260175670507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "06f8c88924f95c02f2957d19",
            "leftCorner": {
              "x": -11.52,
              "y": -24.692,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.625,
              "y": -24.692,
              "z": 0.14
            },
            "gtin": "4260175671689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7b410b5a4bafbe36ed557e4f",
            "leftCorner": {
              "x": -11.625,
              "y": -24.692,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.732,
              "y": -24.692,
              "z": 0.14
            },
            "gtin": "4008381146009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6fb4b9efd248a4c7edbeb4e9",
            "leftCorner": {
              "x": -11.732,
              "y": -24.692,
              "z": 0.14
            },
            "rightCorner": {
              "x": -11.84,
              "y": -24.692,
              "z": 0.14
            },
            "gtin": "4021155023047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8cf832e9b25c04979221a334",
            "leftCorner": {
              "x": -11.84,
              "y": -24.692,
              "z": 0.14
            },
            "rightCorner": {
              "x": -12.108,
              "y": -24.693,
              "z": 0.14
            },
            "gtin": "4306188036371",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfc9",
        "height": 0.40247,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a70",
            "leftCorner": {
              "x": -10.868,
              "y": -24.745,
              "z": 0.329
            },
            "rightCorner": {
              "x": -11.092,
              "y": -24.746,
              "z": 0.329
            },
            "gtin": "4001475105609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a72",
            "leftCorner": {
              "x": -11.092,
              "y": -24.779,
              "z": 0.329
            },
            "rightCorner": {
              "x": -11.28,
              "y": -24.78,
              "z": 0.329
            },
            "gtin": "4001475104602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a73",
            "leftCorner": {
              "x": -11.28,
              "y": -24.784,
              "z": 0.329
            },
            "rightCorner": {
              "x": -11.474,
              "y": -24.784,
              "z": 0.329
            },
            "gtin": "4001475107627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a74",
            "leftCorner": {
              "x": -11.474,
              "y": -24.79,
              "z": 0.329
            },
            "rightCorner": {
              "x": -11.597,
              "y": -24.791,
              "z": 0.329
            },
            "gtin": "4001475107610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a75",
            "leftCorner": {
              "x": -11.597,
              "y": -24.79,
              "z": 0.329
            },
            "rightCorner": {
              "x": -11.787,
              "y": -24.791,
              "z": 0.329
            },
            "gtin": "4001475112607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a76",
            "leftCorner": {
              "x": -11.787,
              "y": -24.785,
              "z": 0.329
            },
            "rightCorner": {
              "x": -11.987,
              "y": -24.786,
              "z": 0.329
            },
            "gtin": "4001475112638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a77",
            "leftCorner": {
              "x": -11.987,
              "y": -24.789,
              "z": 0.329
            },
            "rightCorner": {
              "x": -12.202,
              "y": -24.789,
              "z": 0.329
            },
            "gtin": "4001475211638",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfc8",
        "height": 0.7011,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a61",
            "leftCorner": {
              "x": -10.868,
              "y": -24.742,
              "z": 0.574
            },
            "rightCorner": {
              "x": -11.012,
              "y": -24.743,
              "z": 0.574
            },
            "gtin": "4001475104671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a63",
            "leftCorner": {
              "x": -11.012,
              "y": -24.783,
              "z": 0.574
            },
            "rightCorner": {
              "x": -11.19,
              "y": -24.784,
              "z": 0.574
            },
            "gtin": "4001475105708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a64",
            "leftCorner": {
              "x": -11.19,
              "y": -24.779,
              "z": 0.574
            },
            "rightCorner": {
              "x": -11.307,
              "y": -24.779,
              "z": 0.574
            },
            "gtin": "4001475215667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a65",
            "leftCorner": {
              "x": -11.307,
              "y": -24.78,
              "z": 0.574
            },
            "rightCorner": {
              "x": -11.43,
              "y": -24.78,
              "z": 0.574
            },
            "gtin": "4001475116773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a66",
            "leftCorner": {
              "x": -11.43,
              "y": -24.786,
              "z": 0.574
            },
            "rightCorner": {
              "x": -11.521,
              "y": -24.786,
              "z": 0.574
            },
            "gtin": "4001475116742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a67",
            "leftCorner": {
              "x": -11.521,
              "y": -24.789,
              "z": 0.574
            },
            "rightCorner": {
              "x": -11.605,
              "y": -24.79,
              "z": 0.574
            },
            "gtin": "4001475119743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a68",
            "leftCorner": {
              "x": -11.605,
              "y": -24.788,
              "z": 0.574
            },
            "rightCorner": {
              "x": -11.648,
              "y": -24.788,
              "z": 0.574
            },
            "gtin": "4001475118739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a69",
            "leftCorner": {
              "x": -11.648,
              "y": -24.788,
              "z": 0.574
            },
            "rightCorner": {
              "x": -11.692,
              "y": -24.788,
              "z": 0.574
            },
            "gtin": "4001475118739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a6a",
            "leftCorner": {
              "x": -11.692,
              "y": -24.783,
              "z": 0.574
            },
            "rightCorner": {
              "x": -12.032,
              "y": -24.784,
              "z": 0.574
            },
            "gtin": "5901135023245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a6b",
            "leftCorner": {
              "x": -12.032,
              "y": -24.777,
              "z": 0.574
            },
            "rightCorner": {
              "x": -12.201,
              "y": -24.777,
              "z": 0.574
            },
            "gtin": "4008381146009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfca",
        "height": 1.0044,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a7d",
            "leftCorner": {
              "x": -10.868,
              "y": -24.745,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.159,
              "y": -24.746,
              "z": 0.822
            },
            "gtin": "4306188036371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a82",
            "leftCorner": {
              "x": -11.159,
              "y": -24.78,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.304,
              "y": -24.78,
              "z": 0.822
            },
            "gtin": "4306188036401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a83",
            "leftCorner": {
              "x": -11.304,
              "y": -24.779,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.358,
              "y": -24.779,
              "z": 0.822
            },
            "gtin": "8711000476291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a84",
            "leftCorner": {
              "x": -11.358,
              "y": -24.779,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.412,
              "y": -24.78,
              "z": 0.822
            },
            "gtin": "8711000476291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a85",
            "leftCorner": {
              "x": -11.412,
              "y": -24.787,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.51,
              "y": -24.788,
              "z": 0.822
            },
            "gtin": "8711000476208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a86",
            "leftCorner": {
              "x": -11.51,
              "y": -24.792,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.588,
              "y": -24.792,
              "z": 0.822
            },
            "gtin": "8711000476246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a87",
            "leftCorner": {
              "x": -11.588,
              "y": -24.792,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.706,
              "y": -24.793,
              "z": 0.822
            },
            "gtin": "8711000476222",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d5a88",
            "leftCorner": {
              "x": -11.706,
              "y": -24.79,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.833,
              "y": -24.79,
              "z": 0.822
            },
            "gtin": "4260175670514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a89",
            "leftCorner": {
              "x": -11.833,
              "y": -24.781,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.949,
              "y": -24.782,
              "z": 0.822
            },
            "gtin": "4260175671740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a8a",
            "leftCorner": {
              "x": -11.949,
              "y": -24.786,
              "z": 0.822
            },
            "rightCorner": {
              "x": -12.062,
              "y": -24.787,
              "z": 0.822
            },
            "gtin": "4260175670507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a8b",
            "leftCorner": {
              "x": -12.062,
              "y": -24.777,
              "z": 0.822
            },
            "rightCorner": {
              "x": -12.148,
              "y": -24.776,
              "z": 0.822
            },
            "gtin": "4260175670491",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfc6",
        "height": 1.3076,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a3a",
            "leftCorner": {
              "x": -10.868,
              "y": -24.737,
              "z": 1.07
            },
            "rightCorner": {
              "x": -11.141,
              "y": -24.738,
              "z": 1.07
            },
            "gtin": "4260175670996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a3c",
            "leftCorner": {
              "x": -11.141,
              "y": -24.777,
              "z": 1.07
            },
            "rightCorner": {
              "x": -11.263,
              "y": -24.778,
              "z": 1.07
            },
            "gtin": "4260175671689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a3d",
            "leftCorner": {
              "x": -11.263,
              "y": -24.778,
              "z": 1.07
            },
            "rightCorner": {
              "x": -11.501,
              "y": -24.778,
              "z": 1.07
            },
            "gtin": "4260175670729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a3e",
            "leftCorner": {
              "x": -11.501,
              "y": -24.787,
              "z": 1.07
            },
            "rightCorner": {
              "x": -11.625,
              "y": -24.788,
              "z": 1.07
            },
            "gtin": "4260175671849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a3f",
            "leftCorner": {
              "x": -11.625,
              "y": -24.79,
              "z": 1.07
            },
            "rightCorner": {
              "x": -11.757,
              "y": -24.79,
              "z": 1.07
            },
            "gtin": "4260175671115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a40",
            "leftCorner": {
              "x": -11.757,
              "y": -24.778,
              "z": 1.07
            },
            "rightCorner": {
              "x": -11.937,
              "y": -24.779,
              "z": 1.07
            },
            "gtin": "4001726360009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a41",
            "leftCorner": {
              "x": -11.937,
              "y": -24.779,
              "z": 1.07
            },
            "rightCorner": {
              "x": -12.118,
              "y": -24.779,
              "z": 1.07
            },
            "gtin": "4001726360009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfc7",
        "height": 1.6073,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5a47",
            "leftCorner": {
              "x": -10.868,
              "y": -24.736,
              "z": 1.315
            },
            "rightCorner": {
              "x": -10.975,
              "y": -24.736,
              "z": 1.315
            },
            "gtin": "4104420024564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a49",
            "leftCorner": {
              "x": -10.975,
              "y": -24.777,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.14,
              "y": -24.777,
              "z": 1.315
            },
            "gtin": "4104420182844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a4a",
            "leftCorner": {
              "x": -11.141,
              "y": -24.773,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.32,
              "y": -24.773,
              "z": 1.315
            },
            "gtin": "4306188431541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a4b",
            "leftCorner": {
              "x": -11.32,
              "y": -24.775,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.469,
              "y": -24.775,
              "z": 1.315
            },
            "gtin": "4006363103859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a4c",
            "leftCorner": {
              "x": -11.469,
              "y": -24.783,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.59,
              "y": -24.784,
              "z": 1.315
            },
            "gtin": "4021155023047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a4d",
            "leftCorner": {
              "x": -11.59,
              "y": -24.783,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.725,
              "y": -24.784,
              "z": 1.315
            },
            "gtin": "4000521731106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a4e",
            "leftCorner": {
              "x": -11.725,
              "y": -24.779,
              "z": 1.315
            },
            "rightCorner": {
              "x": -11.999,
              "y": -24.781,
              "z": 1.315
            },
            "gtin": "4000521011314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5a4f",
            "leftCorner": {
              "x": -11.999,
              "y": -24.776,
              "z": 1.315
            },
            "rightCorner": {
              "x": -12.285,
              "y": -24.776,
              "z": 1.315
            },
            "gtin": "4000521730000",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "818"
  },
  {
    "id": "81a",
    "name": "81a",
    "x": -12.105,
    "y": -25.97,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0015621,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 58,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d641",
        "height": 0.17285,
        "facings": [
          {
            "id": "639d8c7ded1307f9366ac86f",
            "leftCorner": {
              "x": -12.105,
              "y": -26.071,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.015,
              "y": -26.071,
              "z": 0.141
            },
            "gtin": "4002221049673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0f1f022fc147e5c9166a37f1",
            "leftCorner": {
              "x": -12.015,
              "y": -26.071,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.899,
              "y": -26.07,
              "z": 0.141
            },
            "gtin": "4008837204086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0e45ddb0bc7c39d753b93219",
            "leftCorner": {
              "x": -11.899,
              "y": -26.07,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.817,
              "y": -26.07,
              "z": 0.141
            },
            "gtin": "4008837203027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "05afcf65b1f0d8bc3d4a98a1",
            "leftCorner": {
              "x": -11.817,
              "y": -26.07,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.733,
              "y": -26.07,
              "z": 0.141
            },
            "gtin": "4008837226545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "007bb609e7403019af50228b",
            "leftCorner": {
              "x": -11.733,
              "y": -26.07,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.645,
              "y": -26.07,
              "z": 0.141
            },
            "gtin": "4008837226019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d7851d68b28eee623b55d17c",
            "leftCorner": {
              "x": -11.645,
              "y": -26.07,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.557,
              "y": -26.069,
              "z": 0.141
            },
            "gtin": "4008837226002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1a79394d5c235930478aeb93",
            "leftCorner": {
              "x": -11.557,
              "y": -26.069,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.468,
              "y": -26.069,
              "z": 0.141
            },
            "gtin": "4008837226606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "af4ae50866d68bae83492f76",
            "leftCorner": {
              "x": -11.468,
              "y": -26.069,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.378,
              "y": -26.069,
              "z": 0.141
            },
            "gtin": "4002221049673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ab1f3c6938823a889a3bc66e",
            "leftCorner": {
              "x": -11.378,
              "y": -26.069,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.287,
              "y": -26.068,
              "z": 0.141
            },
            "gtin": "4008837227122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7bb9e80c1368f10bbbba99d5",
            "leftCorner": {
              "x": -11.287,
              "y": -26.068,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.195,
              "y": -26.068,
              "z": 0.141
            },
            "gtin": "4008837226583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2bb173c6b91f0cb529e02c91",
            "leftCorner": {
              "x": -11.195,
              "y": -26.068,
              "z": 0.141
            },
            "rightCorner": {
              "x": -11.101,
              "y": -26.068,
              "z": 0.141
            },
            "gtin": "4008837226538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b3eef1ae25105be3fdc8a36e",
            "leftCorner": {
              "x": -11.101,
              "y": -26.068,
              "z": 0.141
            },
            "rightCorner": {
              "x": -10.889,
              "y": -26.067,
              "z": 0.141
            },
            "gtin": "4008837204031",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d63f",
        "height": 0.422,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b03",
            "leftCorner": {
              "x": -12.046,
              "y": -25.977,
              "z": 0.345
            },
            "rightCorner": {
              "x": -11.794,
              "y": -25.976,
              "z": 0.345
            },
            "gtin": "4009452000886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b04",
            "leftCorner": {
              "x": -11.794,
              "y": -25.979,
              "z": 0.345
            },
            "rightCorner": {
              "x": -11.659,
              "y": -25.979,
              "z": 0.345
            },
            "gtin": "4008837204093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b07",
            "leftCorner": {
              "x": -11.521,
              "y": -25.989,
              "z": 0.345
            },
            "rightCorner": {
              "x": -11.374,
              "y": -25.988,
              "z": 0.345
            },
            "gtin": "4250426211344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b08",
            "leftCorner": {
              "x": -11.374,
              "y": -25.987,
              "z": 0.345
            },
            "rightCorner": {
              "x": -11.232,
              "y": -25.988,
              "z": 0.345
            },
            "gtin": "4002221049611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b09",
            "leftCorner": {
              "x": -11.232,
              "y": -25.989,
              "z": 0.345
            },
            "rightCorner": {
              "x": -11.097,
              "y": -25.988,
              "z": 0.345
            },
            "gtin": "4002221049659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aee",
            "leftCorner": {
              "x": -11.006,
              "y": -25.999,
              "z": 0.345
            },
            "rightCorner": {
              "x": -10.854,
              "y": -25.998,
              "z": 0.345
            },
            "gtin": "4250426220537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e60247621e0285934ea84772",
            "leftCorner": {
              "x": -11.659,
              "y": -26.029,
              "z": 0.345
            },
            "rightCorner": {
              "x": -11.523,
              "y": -26.028,
              "z": 0.345
            },
            "gtin": "4002221049659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d602107dd75d12c06021b50f",
            "leftCorner": {
              "x": -11.097,
              "y": -26.027,
              "z": 0.345
            },
            "rightCorner": {
              "x": -11.007,
              "y": -26.027,
              "z": 0.345
            },
            "gtin": "4002221049673",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d640",
        "height": 0.70412,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5aea",
            "leftCorner": {
              "x": -11.498,
              "y": -25.976,
              "z": 0.576
            },
            "rightCorner": {
              "x": -11.36,
              "y": -25.977,
              "z": 0.576
            },
            "gtin": "4009452000046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aeb",
            "leftCorner": {
              "x": -11.36,
              "y": -25.982,
              "z": 0.576
            },
            "rightCorner": {
              "x": -11.155,
              "y": -25.981,
              "z": 0.576
            },
            "gtin": "4009452000039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aec",
            "leftCorner": {
              "x": -11.155,
              "y": -25.981,
              "z": 0.576
            },
            "rightCorner": {
              "x": -10.96,
              "y": -25.98,
              "z": 0.576
            },
            "gtin": "4009452000077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5acf",
            "leftCorner": {
              "x": -10.96,
              "y": -25.987,
              "z": 0.576
            },
            "rightCorner": {
              "x": -10.855,
              "y": -25.987,
              "z": 0.576
            },
            "gtin": "4009452000060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c9a3a3629205a50874c2d310",
            "leftCorner": {
              "x": -12.105,
              "y": -26.023,
              "z": 0.576
            },
            "rightCorner": {
              "x": -11.994,
              "y": -26.023,
              "z": 0.576
            },
            "gtin": "4009452000060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "910a814a9983eb9f847f554e",
            "leftCorner": {
              "x": -11.994,
              "y": -26.023,
              "z": 0.576
            },
            "rightCorner": {
              "x": -11.857,
              "y": -26.022,
              "z": 0.576
            },
            "gtin": "4009452000046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cc5abd472f58b33bbf3dc984",
            "leftCorner": {
              "x": -11.857,
              "y": -26.022,
              "z": 0.576
            },
            "rightCorner": {
              "x": -11.665,
              "y": -26.022,
              "z": 0.576
            },
            "gtin": "4009452000077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a0cc3f60ff69a19abede0082",
            "leftCorner": {
              "x": -11.665,
              "y": -26.022,
              "z": 0.576
            },
            "rightCorner": {
              "x": -11.529,
              "y": -26.021,
              "z": 0.576
            },
            "gtin": "4009452000046",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d63e",
        "height": 1.0049,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b49",
            "leftCorner": {
              "x": -12.051,
              "y": -25.97,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.908,
              "y": -25.969,
              "z": 0.822
            },
            "gtin": "4008837201047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b4a",
            "leftCorner": {
              "x": -11.908,
              "y": -25.966,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.773,
              "y": -25.966,
              "z": 0.822
            },
            "gtin": "4008837201054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b4b",
            "leftCorner": {
              "x": -11.773,
              "y": -25.966,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.639,
              "y": -25.965,
              "z": 0.822
            },
            "gtin": "4008837201054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b4c",
            "leftCorner": {
              "x": -11.639,
              "y": -25.965,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.504,
              "y": -25.965,
              "z": 0.822
            },
            "gtin": "4008837201054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b4d",
            "leftCorner": {
              "x": -11.504,
              "y": -25.965,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.369,
              "y": -25.964,
              "z": 0.822
            },
            "gtin": "4008837201054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b4e",
            "leftCorner": {
              "x": -11.369,
              "y": -25.982,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.247,
              "y": -25.983,
              "z": 0.822
            },
            "gtin": "4008837204017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b4f",
            "leftCorner": {
              "x": -11.248,
              "y": -26.03,
              "z": 0.822
            },
            "rightCorner": {
              "x": -11.023,
              "y": -26.028,
              "z": 0.822
            },
            "gtin": "4008837204031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b32",
            "leftCorner": {
              "x": -11.023,
              "y": -25.984,
              "z": 0.822
            },
            "rightCorner": {
              "x": -10.855,
              "y": -25.984,
              "z": 0.822
            },
            "gtin": "4008837202112",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d63c",
        "height": 1.3122,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5ac5",
            "leftCorner": {
              "x": -12.052,
              "y": -25.966,
              "z": 1.074
            },
            "rightCorner": {
              "x": -11.879,
              "y": -25.965,
              "z": 1.074
            },
            "gtin": "4008837214177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ac6",
            "leftCorner": {
              "x": -11.88,
              "y": -25.961,
              "z": 1.074
            },
            "rightCorner": {
              "x": -11.737,
              "y": -25.96,
              "z": 1.074
            },
            "gtin": "4008837214160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ac7",
            "leftCorner": {
              "x": -11.737,
              "y": -25.969,
              "z": 1.074
            },
            "rightCorner": {
              "x": -11.597,
              "y": -25.969,
              "z": 1.074
            },
            "gtin": "4008837214191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ac8",
            "leftCorner": {
              "x": -11.597,
              "y": -25.97,
              "z": 1.074
            },
            "rightCorner": {
              "x": -11.462,
              "y": -25.97,
              "z": 1.074
            },
            "gtin": "4008837214108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ac9",
            "leftCorner": {
              "x": -11.461,
              "y": -25.976,
              "z": 1.074
            },
            "rightCorner": {
              "x": -11.345,
              "y": -25.976,
              "z": 1.074
            },
            "gtin": "4008837214184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aca",
            "leftCorner": {
              "x": -11.345,
              "y": -25.977,
              "z": 1.074
            },
            "rightCorner": {
              "x": -11.252,
              "y": -25.976,
              "z": 1.074
            },
            "gtin": "4008837203003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5acb",
            "leftCorner": {
              "x": -11.252,
              "y": -25.977,
              "z": 1.074
            },
            "rightCorner": {
              "x": -11.161,
              "y": -25.977,
              "z": 1.074
            },
            "gtin": "4008837203027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5acc",
            "leftCorner": {
              "x": -11.161,
              "y": -25.979,
              "z": 1.074
            },
            "rightCorner": {
              "x": -11.059,
              "y": -25.979,
              "z": 1.074
            },
            "gtin": "4008837202181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5acd",
            "leftCorner": {
              "x": -11.059,
              "y": -25.981,
              "z": 1.074
            },
            "rightCorner": {
              "x": -10.955,
              "y": -25.979,
              "z": 1.074
            },
            "gtin": "4008837204109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ab1",
            "leftCorner": {
              "x": -10.955,
              "y": -25.983,
              "z": 1.074
            },
            "rightCorner": {
              "x": -10.855,
              "y": -25.983,
              "z": 1.074
            },
            "gtin": "4008837201047",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d63d",
        "height": 1.6128,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b26",
            "leftCorner": {
              "x": -12.068,
              "y": -25.968,
              "z": 1.32
            },
            "rightCorner": {
              "x": -11.952,
              "y": -25.968,
              "z": 1.32
            },
            "gtin": "4008837226583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b27",
            "leftCorner": {
              "x": -11.952,
              "y": -25.964,
              "z": 1.32
            },
            "rightCorner": {
              "x": -11.871,
              "y": -25.963,
              "z": 1.32
            },
            "gtin": "4008837226606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b28",
            "leftCorner": {
              "x": -11.871,
              "y": -25.969,
              "z": 1.32
            },
            "rightCorner": {
              "x": -11.79,
              "y": -25.968,
              "z": 1.32
            },
            "gtin": "4008837227122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b29",
            "leftCorner": {
              "x": -11.79,
              "y": -25.976,
              "z": 1.32
            },
            "rightCorner": {
              "x": -11.703,
              "y": -25.976,
              "z": 1.32
            },
            "gtin": "4008837226521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b2a",
            "leftCorner": {
              "x": -11.703,
              "y": -25.974,
              "z": 1.32
            },
            "rightCorner": {
              "x": -11.604,
              "y": -25.973,
              "z": 1.32
            },
            "gtin": "4008837226538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b2b",
            "leftCorner": {
              "x": -11.604,
              "y": -25.972,
              "z": 1.32
            },
            "rightCorner": {
              "x": -11.514,
              "y": -25.972,
              "z": 1.32
            },
            "gtin": "4008837226545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b2c",
            "leftCorner": {
              "x": -11.514,
              "y": -25.978,
              "z": 1.32
            },
            "rightCorner": {
              "x": -11.426,
              "y": -25.977,
              "z": 1.32
            },
            "gtin": "4008837226002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b2d",
            "leftCorner": {
              "x": -11.426,
              "y": -25.98,
              "z": 1.32
            },
            "rightCorner": {
              "x": -11.334,
              "y": -25.981,
              "z": 1.32
            },
            "gtin": "4008837226019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b2e",
            "leftCorner": {
              "x": -11.334,
              "y": -25.982,
              "z": 1.32
            },
            "rightCorner": {
              "x": -11.239,
              "y": -25.982,
              "z": 1.32
            },
            "gtin": "4009452000008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b2f",
            "leftCorner": {
              "x": -11.239,
              "y": -25.983,
              "z": 1.32
            },
            "rightCorner": {
              "x": -11.083,
              "y": -25.982,
              "z": 1.32
            },
            "gtin": "4009452000015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b30",
            "leftCorner": {
              "x": -11.083,
              "y": -25.983,
              "z": 1.32
            },
            "rightCorner": {
              "x": -10.952,
              "y": -25.983,
              "z": 1.32
            },
            "gtin": "4009452001111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b0c",
            "leftCorner": {
              "x": -10.952,
              "y": -25.99,
              "z": 1.32
            },
            "rightCorner": {
              "x": -10.855,
              "y": -25.99,
              "z": 1.32
            },
            "gtin": "4009452007786",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "81b"
  },
  {
    "id": "81b",
    "name": "81b",
    "x": -13.355,
    "y": -25.974,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0015621,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 47,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfe7",
        "height": 0.1773,
        "facings": [
          {
            "id": "a598cfbcc3fff5a78a60a97b",
            "leftCorner": {
              "x": -13.354,
              "y": -26.059,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.303,
              "y": -26.059,
              "z": 0.145
            },
            "gtin": "4008837226590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5c44a1a87e0748488e5f7c59",
            "leftCorner": {
              "x": -13.303,
              "y": -26.059,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.182,
              "y": -26.058,
              "z": 0.145
            },
            "gtin": "4008837234557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "97e86852f9d4b14196d205b1",
            "leftCorner": {
              "x": -13.182,
              "y": -26.058,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.06,
              "y": -26.058,
              "z": 0.145
            },
            "gtin": "4009452002118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7b79965a8a6131d4cc8354dc",
            "leftCorner": {
              "x": -13.06,
              "y": -26.058,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.934,
              "y": -26.058,
              "z": 0.145
            },
            "gtin": "4009452002262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "74b5f22cd0dbbe52812fec5b",
            "leftCorner": {
              "x": -12.934,
              "y": -26.058,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.808,
              "y": -26.057,
              "z": 0.145
            },
            "gtin": "4008837234502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ddce72c48257bfeb66980371",
            "leftCorner": {
              "x": -12.808,
              "y": -26.057,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.681,
              "y": -26.057,
              "z": 0.145
            },
            "gtin": "4009300001065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "14161e23ecb95743bf7a6dec",
            "leftCorner": {
              "x": -12.681,
              "y": -26.057,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.545,
              "y": -26.056,
              "z": 0.145
            },
            "gtin": "4009300016854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6292741e00ccb073efac6dc9",
            "leftCorner": {
              "x": -12.545,
              "y": -26.056,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.404,
              "y": -26.056,
              "z": 0.145
            },
            "gtin": "4009452002033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5803621d9c228db1e44b083b",
            "leftCorner": {
              "x": -12.404,
              "y": -26.056,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.124,
              "y": -26.055,
              "z": 0.145
            },
            "gtin": "4008837210025",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfe4",
        "height": 0.41291,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5afd",
            "leftCorner": {
              "x": -13.287,
              "y": -25.98,
              "z": 0.338
            },
            "rightCorner": {
              "x": -13.021,
              "y": -25.98,
              "z": 0.338
            },
            "gtin": "4009452000916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5afe",
            "leftCorner": {
              "x": -13.021,
              "y": -25.977,
              "z": 0.338
            },
            "rightCorner": {
              "x": -12.895,
              "y": -25.976,
              "z": 0.338
            },
            "gtin": "4009452002262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aff",
            "leftCorner": {
              "x": -12.896,
              "y": -25.972,
              "z": 0.338
            },
            "rightCorner": {
              "x": -12.588,
              "y": -25.972,
              "z": 0.338
            },
            "gtin": "4009452000091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b00",
            "leftCorner": {
              "x": -12.588,
              "y": -25.969,
              "z": 0.338
            },
            "rightCorner": {
              "x": -12.468,
              "y": -25.968,
              "z": 0.338
            },
            "gtin": "4009452002118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b01",
            "leftCorner": {
              "x": -12.468,
              "y": -25.969,
              "z": 0.338
            },
            "rightCorner": {
              "x": -12.329,
              "y": -25.97,
              "z": 0.338
            },
            "gtin": "4009452002033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b02",
            "leftCorner": {
              "x": -12.329,
              "y": -25.969,
              "z": 0.338
            },
            "rightCorner": {
              "x": -12.045,
              "y": -25.968,
              "z": 0.338
            },
            "gtin": "4009452000084",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfe2",
        "height": 0.71066,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5ae0",
            "leftCorner": {
              "x": -13.18,
              "y": -25.982,
              "z": 0.581
            },
            "rightCorner": {
              "x": -13.006,
              "y": -25.982,
              "z": 0.581
            },
            "gtin": "4008837236636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fd2bbcafc587782dcd776006",
            "leftCorner": {
              "x": -13.354,
              "y": -26.014,
              "z": 0.581
            },
            "rightCorner": {
              "x": -13.202,
              "y": -26.014,
              "z": 0.581
            },
            "gtin": "4008837236629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ae1",
            "leftCorner": {
              "x": -13.006,
              "y": -25.977,
              "z": 0.581
            },
            "rightCorner": {
              "x": -12.868,
              "y": -25.976,
              "z": 0.581
            },
            "gtin": "4009300016854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ae2",
            "leftCorner": {
              "x": -12.868,
              "y": -25.973,
              "z": 0.581
            },
            "rightCorner": {
              "x": -12.725,
              "y": -25.973,
              "z": 0.581
            },
            "gtin": "4009300016861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ae3",
            "leftCorner": {
              "x": -12.725,
              "y": -25.971,
              "z": 0.581
            },
            "rightCorner": {
              "x": -12.534,
              "y": -25.97,
              "z": 0.581
            },
            "gtin": "4009300001089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ae4",
            "leftCorner": {
              "x": -12.534,
              "y": -25.97,
              "z": 0.581
            },
            "rightCorner": {
              "x": -12.324,
              "y": -25.969,
              "z": 0.581
            },
            "gtin": "4009300001072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ae5",
            "leftCorner": {
              "x": -12.324,
              "y": -25.97,
              "z": 0.581
            },
            "rightCorner": {
              "x": -12.195,
              "y": -25.969,
              "z": 0.581
            },
            "gtin": "4009300001065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ae6",
            "leftCorner": {
              "x": -12.195,
              "y": -25.975,
              "z": 0.581
            },
            "rightCorner": {
              "x": -12.021,
              "y": -25.974,
              "z": 0.581
            },
            "gtin": "4009452000053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ae7",
            "leftCorner": {
              "x": -12.021,
              "y": -25.974,
              "z": 0.581
            },
            "rightCorner": {
              "x": -11.846,
              "y": -25.974,
              "z": 0.581
            },
            "gtin": "4009452000053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ae8",
            "leftCorner": {
              "x": -11.846,
              "y": -25.974,
              "z": 0.581
            },
            "rightCorner": {
              "x": -11.672,
              "y": -25.973,
              "z": 0.581
            },
            "gtin": "4009452000053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ae9",
            "leftCorner": {
              "x": -11.672,
              "y": -25.973,
              "z": 0.581
            },
            "rightCorner": {
              "x": -11.497,
              "y": -25.973,
              "z": 0.581
            },
            "gtin": "4009452000053",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfe6",
        "height": 1.0133,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b46",
            "leftCorner": {
              "x": -12.791,
              "y": -25.973,
              "z": 0.829
            },
            "rightCorner": {
              "x": -12.561,
              "y": -25.973,
              "z": 0.829
            },
            "gtin": "4008837210049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5f6be0aec78f3c0b7d6f0b4e",
            "leftCorner": {
              "x": -13.354,
              "y": -26.015,
              "z": 0.829
            },
            "rightCorner": {
              "x": -13.223,
              "y": -26.015,
              "z": 0.829
            },
            "gtin": "4008837210032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dc60f4d03761f7e95b7c7474",
            "leftCorner": {
              "x": -13.223,
              "y": -26.015,
              "z": 0.829
            },
            "rightCorner": {
              "x": -12.987,
              "y": -26.014,
              "z": 0.829
            },
            "gtin": "4008837210049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "14e44bd42bb9c6db84fd61c7",
            "leftCorner": {
              "x": -12.987,
              "y": -26.014,
              "z": 0.829
            },
            "rightCorner": {
              "x": -12.856,
              "y": -26.013,
              "z": 0.829
            },
            "gtin": "4008837210032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b47",
            "leftCorner": {
              "x": -12.561,
              "y": -25.973,
              "z": 0.829
            },
            "rightCorner": {
              "x": -12.237,
              "y": -25.972,
              "z": 0.829
            },
            "gtin": "4008837210063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b48",
            "leftCorner": {
              "x": -12.237,
              "y": -25.976,
              "z": 0.829
            },
            "rightCorner": {
              "x": -12.051,
              "y": -25.975,
              "z": 0.829
            },
            "gtin": "4008837210032",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfe5",
        "height": 1.3181,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5ac2",
            "leftCorner": {
              "x": -12.866,
              "y": -25.968,
              "z": 1.078
            },
            "rightCorner": {
              "x": -12.589,
              "y": -25.968,
              "z": 1.078
            },
            "gtin": "4008837210025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0ed4d56c4be795ff6fb41c71",
            "leftCorner": {
              "x": -13.354,
              "y": -26.008,
              "z": 1.078
            },
            "rightCorner": {
              "x": -13.13,
              "y": -26.007,
              "z": 1.078
            },
            "gtin": "4008837210001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ef965c007e1aa6df7845441e",
            "leftCorner": {
              "x": -13.13,
              "y": -26.007,
              "z": 1.078
            },
            "rightCorner": {
              "x": -12.868,
              "y": -26.006,
              "z": 1.078
            },
            "gtin": "4008837210124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ac3",
            "leftCorner": {
              "x": -12.589,
              "y": -25.966,
              "z": 1.078
            },
            "rightCorner": {
              "x": -12.328,
              "y": -25.965,
              "z": 1.078
            },
            "gtin": "4008837210124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ac4",
            "leftCorner": {
              "x": -12.328,
              "y": -25.965,
              "z": 1.078
            },
            "rightCorner": {
              "x": -12.051,
              "y": -25.964,
              "z": 1.078
            },
            "gtin": "4008837210001",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfe3",
        "height": 1.6205,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b1d",
            "leftCorner": {
              "x": -13.308,
              "y": -25.97,
              "z": 1.326
            },
            "rightCorner": {
              "x": -13.155,
              "y": -25.97,
              "z": 1.326
            },
            "gtin": "4008837234571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a71d941cabbf17c50240f8b3",
            "leftCorner": {
              "x": -12.675,
              "y": -26.004,
              "z": 1.326
            },
            "rightCorner": {
              "x": -12.623,
              "y": -26.004,
              "z": 1.326
            },
            "gtin": "4008837226590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "17e1884d1ffbb1c3162a2e60",
            "leftCorner": {
              "x": -12.623,
              "y": -26.004,
              "z": 1.326
            },
            "rightCorner": {
              "x": -12.572,
              "y": -26.004,
              "z": 1.326
            },
            "gtin": "4008837226590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b1e",
            "leftCorner": {
              "x": -13.155,
              "y": -25.973,
              "z": 1.326
            },
            "rightCorner": {
              "x": -12.998,
              "y": -25.972,
              "z": 1.326
            },
            "gtin": "4008837234540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b1f",
            "leftCorner": {
              "x": -12.998,
              "y": -25.97,
              "z": 1.326
            },
            "rightCorner": {
              "x": -12.849,
              "y": -25.969,
              "z": 1.326
            },
            "gtin": "4008837234588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b20",
            "leftCorner": {
              "x": -12.849,
              "y": -25.965,
              "z": 1.326
            },
            "rightCorner": {
              "x": -12.675,
              "y": -25.965,
              "z": 1.326
            },
            "gtin": "4008837234564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b22",
            "leftCorner": {
              "x": -12.569,
              "y": -25.961,
              "z": 1.326
            },
            "rightCorner": {
              "x": -12.451,
              "y": -25.96,
              "z": 1.326
            },
            "gtin": "4008837234557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b23",
            "leftCorner": {
              "x": -12.451,
              "y": -25.963,
              "z": 1.326
            },
            "rightCorner": {
              "x": -12.326,
              "y": -25.963,
              "z": 1.326
            },
            "gtin": "4008837234502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b24",
            "leftCorner": {
              "x": -12.326,
              "y": -25.963,
              "z": 1.326
            },
            "rightCorner": {
              "x": -12.168,
              "y": -25.962,
              "z": 1.326
            },
            "gtin": "4008837234533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b25",
            "leftCorner": {
              "x": -12.168,
              "y": -25.967,
              "z": 1.326
            },
            "rightCorner": {
              "x": -12.068,
              "y": -25.966,
              "z": 1.326
            },
            "gtin": "4008837226590",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "81c",
    "rightNeighborShelfId": "81a"
  },
  {
    "id": "81c",
    "name": "81c",
    "x": -14.605,
    "y": -25.978,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0015621,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 52,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfe1",
        "height": 0.17835,
        "facings": [
          {
            "id": "458f4350607d7ce0c65c94be",
            "leftCorner": {
              "x": -14.605,
              "y": -26.072,
              "z": 0.146
            },
            "rightCorner": {
              "x": -14.51,
              "y": -26.072,
              "z": 0.146
            },
            "gtin": "4008837210070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "483b909e0317864078b4ffbb",
            "leftCorner": {
              "x": -14.51,
              "y": -26.072,
              "z": 0.146
            },
            "rightCorner": {
              "x": -14.398,
              "y": -26.071,
              "z": 0.146
            },
            "gtin": "4008837223117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "de9104849fcd5a09ebb5dc1e",
            "leftCorner": {
              "x": -14.398,
              "y": -26.071,
              "z": 0.146
            },
            "rightCorner": {
              "x": -14.281,
              "y": -26.071,
              "z": 0.146
            },
            "gtin": "4008837225401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "811e4e3cb01ee4f273bf418b",
            "leftCorner": {
              "x": -14.281,
              "y": -26.071,
              "z": 0.146
            },
            "rightCorner": {
              "x": -14.162,
              "y": -26.071,
              "z": 0.146
            },
            "gtin": "4008837223100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8d7ef76abfb242aab9923c76",
            "leftCorner": {
              "x": -14.162,
              "y": -26.071,
              "z": 0.146
            },
            "rightCorner": {
              "x": -14.042,
              "y": -26.07,
              "z": 0.146
            },
            "gtin": "4008837223087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "485f323053dad130de5bb48f",
            "leftCorner": {
              "x": -14.042,
              "y": -26.07,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.92,
              "y": -26.07,
              "z": 0.146
            },
            "gtin": "4008837219844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "045a76058c6e632ce3b17cfe",
            "leftCorner": {
              "x": -13.92,
              "y": -26.07,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.797,
              "y": -26.069,
              "z": 0.146
            },
            "gtin": "4008837236612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c67d9a6e783627c235fe4e04",
            "leftCorner": {
              "x": -13.797,
              "y": -26.069,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.672,
              "y": -26.069,
              "z": 0.146
            },
            "gtin": "4008837223032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "255be77031c7701c973aa69f",
            "leftCorner": {
              "x": -13.672,
              "y": -26.069,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.547,
              "y": -26.069,
              "z": 0.146
            },
            "gtin": "4008837218212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fd7d5b21463eb9dc9add86b4",
            "leftCorner": {
              "x": -13.547,
              "y": -26.069,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.36,
              "y": -26.068,
              "z": 0.146
            },
            "gtin": "4009452002422",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfdd",
        "height": 0.41279,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5af6",
            "leftCorner": {
              "x": -14.525,
              "y": -25.973,
              "z": 0.338
            },
            "rightCorner": {
              "x": -14.396,
              "y": -25.973,
              "z": 0.338
            },
            "gtin": "4008837219813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5af7",
            "leftCorner": {
              "x": -14.396,
              "y": -25.975,
              "z": 0.338
            },
            "rightCorner": {
              "x": -14.264,
              "y": -25.974,
              "z": 0.338
            },
            "gtin": "4008837219806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5af8",
            "leftCorner": {
              "x": -14.264,
              "y": -25.973,
              "z": 0.338
            },
            "rightCorner": {
              "x": -14.14,
              "y": -25.973,
              "z": 0.338
            },
            "gtin": "4008837219844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5af9",
            "leftCorner": {
              "x": -14.14,
              "y": -25.973,
              "z": 0.338
            },
            "rightCorner": {
              "x": -13.964,
              "y": -25.973,
              "z": 0.338
            },
            "gtin": "4009452002415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5afa",
            "leftCorner": {
              "x": -13.964,
              "y": -25.972,
              "z": 0.338
            },
            "rightCorner": {
              "x": -13.802,
              "y": -25.971,
              "z": 0.338
            },
            "gtin": "4009452002408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5afb",
            "leftCorner": {
              "x": -13.802,
              "y": -25.971,
              "z": 0.338
            },
            "rightCorner": {
              "x": -13.629,
              "y": -25.971,
              "z": 0.338
            },
            "gtin": "4009452002422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5afc",
            "leftCorner": {
              "x": -13.629,
              "y": -25.973,
              "z": 0.338
            },
            "rightCorner": {
              "x": -13.287,
              "y": -25.971,
              "z": 0.338
            },
            "gtin": "4009452002439",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfdc",
        "height": 0.71065,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5ad8",
            "leftCorner": {
              "x": -14.556,
              "y": -25.98,
              "z": 0.581
            },
            "rightCorner": {
              "x": -14.413,
              "y": -25.98,
              "z": 0.581
            },
            "gtin": "4008837222219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ad9",
            "leftCorner": {
              "x": -14.413,
              "y": -25.979,
              "z": 0.581
            },
            "rightCorner": {
              "x": -14.282,
              "y": -25.977,
              "z": 0.581
            },
            "gtin": "4008837218274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ada",
            "leftCorner": {
              "x": -14.282,
              "y": -25.978,
              "z": 0.581
            },
            "rightCorner": {
              "x": -14.149,
              "y": -25.977,
              "z": 0.581
            },
            "gtin": "4008837218304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5adb",
            "leftCorner": {
              "x": -14.149,
              "y": -25.979,
              "z": 0.581
            },
            "rightCorner": {
              "x": -14.012,
              "y": -25.978,
              "z": 0.581
            },
            "gtin": "4008837218267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5adc",
            "leftCorner": {
              "x": -14.012,
              "y": -25.977,
              "z": 0.581
            },
            "rightCorner": {
              "x": -13.882,
              "y": -25.977,
              "z": 0.581
            },
            "gtin": "4008837218243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5add",
            "leftCorner": {
              "x": -13.882,
              "y": -25.975,
              "z": 0.581
            },
            "rightCorner": {
              "x": -13.75,
              "y": -25.974,
              "z": 0.581
            },
            "gtin": "4008837218212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ade",
            "leftCorner": {
              "x": -13.75,
              "y": -25.973,
              "z": 0.581
            },
            "rightCorner": {
              "x": -13.594,
              "y": -25.973,
              "z": 0.581
            },
            "gtin": "4008837218236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5adf",
            "leftCorner": {
              "x": -13.594,
              "y": -25.976,
              "z": 0.581
            },
            "rightCorner": {
              "x": -13.18,
              "y": -25.974,
              "z": 0.581
            },
            "gtin": "4008837236605",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfe0",
        "height": 1.0155,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b3c",
            "leftCorner": {
              "x": -14.529,
              "y": -25.979,
              "z": 0.831
            },
            "rightCorner": {
              "x": -14.385,
              "y": -25.978,
              "z": 0.831
            },
            "gtin": "4008837223063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b3d",
            "leftCorner": {
              "x": -14.385,
              "y": -26.033,
              "z": 0.831
            },
            "rightCorner": {
              "x": -14.24,
              "y": -26.032,
              "z": 0.831
            },
            "gtin": "4008837223179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b3e",
            "leftCorner": {
              "x": -14.24,
              "y": -25.971,
              "z": 0.831
            },
            "rightCorner": {
              "x": -14.124,
              "y": -25.971,
              "z": 0.831
            },
            "gtin": "4008837223100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b3f",
            "leftCorner": {
              "x": -14.124,
              "y": -25.978,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.987,
              "y": -25.978,
              "z": 0.831
            },
            "gtin": "4008837223131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b40",
            "leftCorner": {
              "x": -13.987,
              "y": -25.975,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.861,
              "y": -25.975,
              "z": 0.831
            },
            "gtin": "4008837223087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b41",
            "leftCorner": {
              "x": -13.861,
              "y": -25.972,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.728,
              "y": -25.971,
              "z": 0.831
            },
            "gtin": "4008837223148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b42",
            "leftCorner": {
              "x": -13.728,
              "y": -25.973,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.587,
              "y": -25.973,
              "z": 0.831
            },
            "gtin": "4008837223056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b43",
            "leftCorner": {
              "x": -13.587,
              "y": -25.978,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.472,
              "y": -25.978,
              "z": 0.831
            },
            "gtin": "4008837223155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b44",
            "leftCorner": {
              "x": -13.472,
              "y": -25.978,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.132,
              "y": -25.976,
              "z": 0.831
            },
            "gtin": "4008837210056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b45",
            "leftCorner": {
              "x": -13.132,
              "y": -25.976,
              "z": 0.831
            },
            "rightCorner": {
              "x": -12.792,
              "y": -25.975,
              "z": 0.831
            },
            "gtin": "4008837210056",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfdb",
        "height": 1.3189,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5ab9",
            "leftCorner": {
              "x": -14.567,
              "y": -25.97,
              "z": 1.079
            },
            "rightCorner": {
              "x": -14.435,
              "y": -25.97,
              "z": 1.079
            },
            "gtin": "4008837223162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aba",
            "leftCorner": {
              "x": -14.435,
              "y": -25.973,
              "z": 1.079
            },
            "rightCorner": {
              "x": -14.309,
              "y": -25.972,
              "z": 1.079
            },
            "gtin": "4008837223025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5abb",
            "leftCorner": {
              "x": -14.309,
              "y": -25.97,
              "z": 1.079
            },
            "rightCorner": {
              "x": -14.175,
              "y": -25.97,
              "z": 1.079
            },
            "gtin": "4008837223001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5abc",
            "leftCorner": {
              "x": -14.175,
              "y": -25.967,
              "z": 1.079
            },
            "rightCorner": {
              "x": -14.027,
              "y": -25.967,
              "z": 1.079
            },
            "gtin": "4008837223049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5abd",
            "leftCorner": {
              "x": -14.027,
              "y": -25.97,
              "z": 1.079
            },
            "rightCorner": {
              "x": -13.9,
              "y": -25.969,
              "z": 1.079
            },
            "gtin": "4008837223032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5abe",
            "leftCorner": {
              "x": -13.9,
              "y": -25.968,
              "z": 1.079
            },
            "rightCorner": {
              "x": -13.802,
              "y": -25.967,
              "z": 1.079
            },
            "gtin": "4008837223117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5abf",
            "leftCorner": {
              "x": -13.802,
              "y": -25.963,
              "z": 1.079
            },
            "rightCorner": {
              "x": -13.602,
              "y": -25.963,
              "z": 1.079
            },
            "gtin": "4008837223216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ac0",
            "leftCorner": {
              "x": -13.601,
              "y": -25.973,
              "z": 1.079
            },
            "rightCorner": {
              "x": -13.461,
              "y": -25.972,
              "z": 1.079
            },
            "gtin": "4008837223094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ac1",
            "leftCorner": {
              "x": -13.461,
              "y": -25.971,
              "z": 1.079
            },
            "rightCorner": {
              "x": -12.867,
              "y": -25.969,
              "z": 1.079
            },
            "gtin": "4008837210070",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfde",
        "height": 1.6177,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b15",
            "leftCorner": {
              "x": -14.538,
              "y": -25.977,
              "z": 1.324
            },
            "rightCorner": {
              "x": -14.42,
              "y": -25.977,
              "z": 1.324
            },
            "gtin": "4008837225401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b16",
            "leftCorner": {
              "x": -14.42,
              "y": -25.973,
              "z": 1.324
            },
            "rightCorner": {
              "x": -14.278,
              "y": -25.972,
              "z": 1.324
            },
            "gtin": "4008837225449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b17",
            "leftCorner": {
              "x": -14.278,
              "y": -25.969,
              "z": 1.324
            },
            "rightCorner": {
              "x": -14.015,
              "y": -25.969,
              "z": 1.324
            },
            "gtin": "4008837225432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b18",
            "leftCorner": {
              "x": -14.015,
              "y": -25.969,
              "z": 1.324
            },
            "rightCorner": {
              "x": -13.881,
              "y": -25.969,
              "z": 1.324
            },
            "gtin": "4008837220604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b19",
            "leftCorner": {
              "x": -13.881,
              "y": -26.034,
              "z": 1.324
            },
            "rightCorner": {
              "x": -13.731,
              "y": -26.033,
              "z": 1.324
            },
            "gtin": "4008837236629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b1a",
            "leftCorner": {
              "x": -13.731,
              "y": -25.966,
              "z": 1.324
            },
            "rightCorner": {
              "x": -13.598,
              "y": -25.965,
              "z": 1.324
            },
            "gtin": "4008837236612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b1b",
            "leftCorner": {
              "x": -13.598,
              "y": -25.968,
              "z": 1.324
            },
            "rightCorner": {
              "x": -13.439,
              "y": -25.968,
              "z": 1.324
            },
            "gtin": "4008837236636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b1c",
            "leftCorner": {
              "x": -13.439,
              "y": -25.975,
              "z": 1.324
            },
            "rightCorner": {
              "x": -13.308,
              "y": -25.974,
              "z": 1.324
            },
            "gtin": "4008837236605",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "81d",
    "rightNeighborShelfId": "81b"
  },
  {
    "id": "81d",
    "name": "81d",
    "x": -15.855,
    "y": -25.982,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0015621,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 54,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d649",
        "height": 0.17404,
        "facings": [
          {
            "id": "a4a1b7523e8cccc547e75656",
            "leftCorner": {
              "x": -15.854,
              "y": -26.036,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.782,
              "y": -26.036,
              "z": 0.142
            },
            "gtin": "4009300014171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f7e1889561f8a07b836584e2",
            "leftCorner": {
              "x": -15.782,
              "y": -26.036,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.677,
              "y": -26.035,
              "z": 0.142
            },
            "gtin": "4008837222202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b434477a4ea4b45b1039a9fe",
            "leftCorner": {
              "x": -15.677,
              "y": -26.035,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.572,
              "y": -26.035,
              "z": 0.142
            },
            "gtin": "4008837223209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "880fd966b90289e8d6e72ddc",
            "leftCorner": {
              "x": -15.572,
              "y": -26.035,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.467,
              "y": -26.035,
              "z": 0.142
            },
            "gtin": "4009300020783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8b51c16535bef05cbf81eaa6",
            "leftCorner": {
              "x": -15.467,
              "y": -26.035,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.354,
              "y": -26.034,
              "z": 0.142
            },
            "gtin": "4008837223193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "42e761a7c5012f9bba9e05c9",
            "leftCorner": {
              "x": -15.354,
              "y": -26.034,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.241,
              "y": -26.034,
              "z": 0.142
            },
            "gtin": "4009300012726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "599cf0cb74665233619e5014",
            "leftCorner": {
              "x": -15.241,
              "y": -26.034,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.125,
              "y": -26.034,
              "z": 0.142
            },
            "gtin": "4009300009894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8f0e5a0aa429f02f531f1526",
            "leftCorner": {
              "x": -15.125,
              "y": -26.034,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.003,
              "y": -26.033,
              "z": 0.142
            },
            "gtin": "4009300014492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3a102b15110715fc8a26adee",
            "leftCorner": {
              "x": -15.003,
              "y": -26.033,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.873,
              "y": -26.033,
              "z": 0.142
            },
            "gtin": "4009300020776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0bf36ee647d7527910715d07",
            "leftCorner": {
              "x": -14.873,
              "y": -26.033,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.655,
              "y": -26.032,
              "z": 0.142
            },
            "gtin": "4009300019121",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d645",
        "height": 0.41251,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5aed",
            "leftCorner": {
              "x": -15.855,
              "y": -25.986,
              "z": 0.338
            },
            "rightCorner": {
              "x": -15.673,
              "y": -25.986,
              "z": 0.338
            },
            "gtin": "4009300014980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5aef",
            "leftCorner": {
              "x": -15.672,
              "y": -25.957,
              "z": 0.338
            },
            "rightCorner": {
              "x": -15.533,
              "y": -25.956,
              "z": 0.338
            },
            "gtin": "4009300014973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5af0",
            "leftCorner": {
              "x": -15.533,
              "y": -25.953,
              "z": 0.338
            },
            "rightCorner": {
              "x": -15.38,
              "y": -25.953,
              "z": 0.338
            },
            "gtin": "4009300014966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5af1",
            "leftCorner": {
              "x": -15.38,
              "y": -25.946,
              "z": 0.338
            },
            "rightCorner": {
              "x": -15.251,
              "y": -25.945,
              "z": 0.338
            },
            "gtin": "4009300005834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5af2",
            "leftCorner": {
              "x": -15.251,
              "y": -25.942,
              "z": 0.338
            },
            "rightCorner": {
              "x": -15.093,
              "y": -25.941,
              "z": 0.338
            },
            "gtin": "4009300005926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5af3",
            "leftCorner": {
              "x": -15.093,
              "y": -25.949,
              "z": 0.338
            },
            "rightCorner": {
              "x": -14.947,
              "y": -25.948,
              "z": 0.338
            },
            "gtin": "4009300008170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5af4",
            "leftCorner": {
              "x": -14.947,
              "y": -25.941,
              "z": 0.338
            },
            "rightCorner": {
              "x": -14.794,
              "y": -25.94,
              "z": 0.338
            },
            "gtin": "4009300012559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5af5",
            "leftCorner": {
              "x": -14.794,
              "y": -25.939,
              "z": 0.338
            },
            "rightCorner": {
              "x": -14.524,
              "y": -25.938,
              "z": 0.338
            },
            "gtin": "4009300019121",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d646",
        "height": 0.71025,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5ace",
            "leftCorner": {
              "x": -15.855,
              "y": -25.988,
              "z": 0.581
            },
            "rightCorner": {
              "x": -15.668,
              "y": -25.987,
              "z": 0.581
            },
            "gtin": "4009300014720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ad0",
            "leftCorner": {
              "x": -15.667,
              "y": -25.958,
              "z": 0.581
            },
            "rightCorner": {
              "x": -15.534,
              "y": -25.959,
              "z": 0.581
            },
            "gtin": "4009300008965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ad1",
            "leftCorner": {
              "x": -15.534,
              "y": -25.956,
              "z": 0.581
            },
            "rightCorner": {
              "x": -15.382,
              "y": -25.955,
              "z": 0.581
            },
            "gtin": "4009300014737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ad2",
            "leftCorner": {
              "x": -15.382,
              "y": -25.948,
              "z": 0.581
            },
            "rightCorner": {
              "x": -15.226,
              "y": -25.947,
              "z": 0.581
            },
            "gtin": "4009300004813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ad3",
            "leftCorner": {
              "x": -15.226,
              "y": -25.946,
              "z": 0.581
            },
            "rightCorner": {
              "x": -15.07,
              "y": -25.945,
              "z": 0.581
            },
            "gtin": "4009300019367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ad4",
            "leftCorner": {
              "x": -15.07,
              "y": -25.944,
              "z": 0.581
            },
            "rightCorner": {
              "x": -14.922,
              "y": -25.944,
              "z": 0.581
            },
            "gtin": "4009300019374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ad5",
            "leftCorner": {
              "x": -14.922,
              "y": -25.943,
              "z": 0.581
            },
            "rightCorner": {
              "x": -14.807,
              "y": -25.943,
              "z": 0.581
            },
            "gtin": "4009300009894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ad6",
            "leftCorner": {
              "x": -14.807,
              "y": -25.943,
              "z": 0.581
            },
            "rightCorner": {
              "x": -14.666,
              "y": -25.942,
              "z": 0.581
            },
            "gtin": "4009300019343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ad7",
            "leftCorner": {
              "x": -14.666,
              "y": -25.951,
              "z": 0.581
            },
            "rightCorner": {
              "x": -14.555,
              "y": -25.95,
              "z": 0.581
            },
            "gtin": "4008837222202",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d647",
        "height": 1.0151,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b31",
            "leftCorner": {
              "x": -15.855,
              "y": -25.99,
              "z": 0.831
            },
            "rightCorner": {
              "x": -15.662,
              "y": -25.989,
              "z": 0.831
            },
            "gtin": "4009300020318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b33",
            "leftCorner": {
              "x": -15.661,
              "y": -25.958,
              "z": 0.831
            },
            "rightCorner": {
              "x": -15.518,
              "y": -25.958,
              "z": 0.831
            },
            "gtin": "4009300007401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b34",
            "leftCorner": {
              "x": -15.518,
              "y": -25.955,
              "z": 0.831
            },
            "rightCorner": {
              "x": -15.366,
              "y": -25.954,
              "z": 0.831
            },
            "gtin": "4009300011941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b35",
            "leftCorner": {
              "x": -15.366,
              "y": -25.951,
              "z": 0.831
            },
            "rightCorner": {
              "x": -15.23,
              "y": -25.952,
              "z": 0.831
            },
            "gtin": "4009300008033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b36",
            "leftCorner": {
              "x": -15.23,
              "y": -25.949,
              "z": 0.831
            },
            "rightCorner": {
              "x": -15.085,
              "y": -25.948,
              "z": 0.831
            },
            "gtin": "4009300016946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b37",
            "leftCorner": {
              "x": -15.085,
              "y": -25.946,
              "z": 0.831
            },
            "rightCorner": {
              "x": -14.927,
              "y": -25.944,
              "z": 0.831
            },
            "gtin": "4009300009863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b38",
            "leftCorner": {
              "x": -14.927,
              "y": -25.942,
              "z": 0.831
            },
            "rightCorner": {
              "x": -14.805,
              "y": -25.942,
              "z": 0.831
            },
            "gtin": "4009300014492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b39",
            "leftCorner": {
              "x": -14.805,
              "y": -25.942,
              "z": 0.831
            },
            "rightCorner": {
              "x": -14.735,
              "y": -25.942,
              "z": 0.831
            },
            "gtin": "4009300019701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b3a",
            "leftCorner": {
              "x": -14.735,
              "y": -25.942,
              "z": 0.831
            },
            "rightCorner": {
              "x": -14.666,
              "y": -25.941,
              "z": 0.831
            },
            "gtin": "4009300019701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b3b",
            "leftCorner": {
              "x": -14.666,
              "y": -25.943,
              "z": 0.831
            },
            "rightCorner": {
              "x": -14.528,
              "y": -25.942,
              "z": 0.831
            },
            "gtin": "4008837223209",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d648",
        "height": 1.3176,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5ab0",
            "leftCorner": {
              "x": -15.855,
              "y": -25.987,
              "z": 1.078
            },
            "rightCorner": {
              "x": -15.567,
              "y": -25.986,
              "z": 1.078
            },
            "gtin": "4009300019404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ab2",
            "leftCorner": {
              "x": -15.567,
              "y": -25.955,
              "z": 1.078
            },
            "rightCorner": {
              "x": -15.393,
              "y": -25.955,
              "z": 1.078
            },
            "gtin": "4009300020783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ab3",
            "leftCorner": {
              "x": -15.393,
              "y": -25.946,
              "z": 1.078
            },
            "rightCorner": {
              "x": -15.285,
              "y": -25.945,
              "z": 1.078
            },
            "gtin": "4009300020776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ab4",
            "leftCorner": {
              "x": -15.285,
              "y": -25.945,
              "z": 1.078
            },
            "rightCorner": {
              "x": -15.136,
              "y": -25.945,
              "z": 1.078
            },
            "gtin": "4009300020974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ab5",
            "leftCorner": {
              "x": -15.136,
              "y": -25.944,
              "z": 1.078
            },
            "rightCorner": {
              "x": -14.971,
              "y": -25.944,
              "z": 1.078
            },
            "gtin": "4009300018629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ab6",
            "leftCorner": {
              "x": -14.971,
              "y": -25.941,
              "z": 1.078
            },
            "rightCorner": {
              "x": -14.824,
              "y": -25.941,
              "z": 1.078
            },
            "gtin": "4009300014164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ab7",
            "leftCorner": {
              "x": -14.824,
              "y": -25.939,
              "z": 1.078
            },
            "rightCorner": {
              "x": -14.683,
              "y": -25.939,
              "z": 1.078
            },
            "gtin": "4008837223124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ab8",
            "leftCorner": {
              "x": -14.683,
              "y": -25.944,
              "z": 1.078
            },
            "rightCorner": {
              "x": -14.566,
              "y": -25.943,
              "z": 1.078
            },
            "gtin": "4008837223193",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d644",
        "height": 1.6199,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b0b",
            "leftCorner": {
              "x": -15.855,
              "y": -25.99,
              "z": 1.325
            },
            "rightCorner": {
              "x": -15.63,
              "y": -25.989,
              "z": 1.325
            },
            "gtin": "9001475049304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b0d",
            "leftCorner": {
              "x": -15.63,
              "y": -25.954,
              "z": 1.325
            },
            "rightCorner": {
              "x": -15.501,
              "y": -25.953,
              "z": 1.325
            },
            "gtin": "9001475049205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b0e",
            "leftCorner": {
              "x": -15.501,
              "y": -25.953,
              "z": 1.325
            },
            "rightCorner": {
              "x": -15.366,
              "y": -25.952,
              "z": 1.325
            },
            "gtin": "4009300020912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b0f",
            "leftCorner": {
              "x": -15.366,
              "y": -25.953,
              "z": 1.325
            },
            "rightCorner": {
              "x": -15.201,
              "y": -25.953,
              "z": 1.325
            },
            "gtin": "4009300020905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b10",
            "leftCorner": {
              "x": -15.201,
              "y": -25.944,
              "z": 1.325
            },
            "rightCorner": {
              "x": -15.08,
              "y": -25.944,
              "z": 1.325
            },
            "gtin": "4009300012726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b11",
            "leftCorner": {
              "x": -15.08,
              "y": -25.944,
              "z": 1.325
            },
            "rightCorner": {
              "x": -14.928,
              "y": -25.944,
              "z": 1.325
            },
            "gtin": "4009300012719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b12",
            "leftCorner": {
              "x": -14.928,
              "y": -25.943,
              "z": 1.325
            },
            "rightCorner": {
              "x": -14.786,
              "y": -25.942,
              "z": 1.325
            },
            "gtin": "4009300011958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b13",
            "leftCorner": {
              "x": -14.786,
              "y": -25.939,
              "z": 1.325
            },
            "rightCorner": {
              "x": -14.633,
              "y": -25.939,
              "z": 1.325
            },
            "gtin": "4009300008040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b14",
            "leftCorner": {
              "x": -14.633,
              "y": -25.943,
              "z": 1.325
            },
            "rightCorner": {
              "x": -14.538,
              "y": -25.943,
              "z": 1.325
            },
            "gtin": "4009300014171",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "81c"
  },
  {
    "id": "81e",
    "name": "81e",
    "x": -16.396,
    "y": -24.831,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70611,
      "w": 0.70811
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 4,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d64b",
        "height": 1.258,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d85ee",
            "leftCorner": {
              "x": -16.433,
              "y": -24.831,
              "z": 1.029
            },
            "rightCorner": {
              "x": -16.43,
              "y": -25.844,
              "z": 1.029
            },
            "gtin": "8713800111464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85ef",
            "leftCorner": {
              "x": -16.373,
              "y": -25.844,
              "z": 1.029
            },
            "rightCorner": {
              "x": -16.372,
              "y": -26.081,
              "z": 1.029
            },
            "gtin": "8713800102813",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d64a",
        "height": 1.6619,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d85ec",
            "leftCorner": {
              "x": -16.435,
              "y": -24.831,
              "z": 1.36
            },
            "rightCorner": {
              "x": -16.433,
              "y": -25.502,
              "z": 1.36
            },
            "gtin": "4250426224160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85ed",
            "leftCorner": {
              "x": -16.378,
              "y": -25.502,
              "z": 1.36
            },
            "rightCorner": {
              "x": -16.377,
              "y": -26.081,
              "z": 1.36
            },
            "gtin": "4250426224245",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "81f",
    "name": "81f",
    "x": -10.382,
    "y": -25.979,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7088,
      "w": 0.70541
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cfed",
        "height": 0.2278,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b80",
            "leftCorner": {
              "x": -10.309,
              "y": -25.088,
              "z": 0.186
            },
            "rightCorner": {
              "x": -10.31,
              "y": -24.729,
              "z": 0.186
            },
            "gtin": "4260747250151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3bbc102d7dcd2163361312a2",
            "leftCorner": {
              "x": -10.272,
              "y": -25.978,
              "z": 0.186
            },
            "rightCorner": {
              "x": -10.274,
              "y": -25.553,
              "z": 0.186
            },
            "gtin": "4260747250144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7fb784753b4204077a50032a",
            "leftCorner": {
              "x": -10.274,
              "y": -25.553,
              "z": 0.186
            },
            "rightCorner": {
              "x": -10.276,
              "y": -25.092,
              "z": 0.186
            },
            "gtin": "4260747250236",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfe8",
        "height": 0.51397,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b69",
            "leftCorner": {
              "x": -10.296,
              "y": -25.979,
              "z": 0.421
            },
            "rightCorner": {
              "x": -10.297,
              "y": -25.746,
              "z": 0.421
            },
            "gtin": "4038269001649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b6b",
            "leftCorner": {
              "x": -10.33,
              "y": -25.746,
              "z": 0.421
            },
            "rightCorner": {
              "x": -10.332,
              "y": -25.5,
              "z": 0.421
            },
            "gtin": "4038269001700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b6c",
            "leftCorner": {
              "x": -10.335,
              "y": -25.5,
              "z": 0.421
            },
            "rightCorner": {
              "x": -10.336,
              "y": -25.22,
              "z": 0.421
            },
            "gtin": "4038269001045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b6d",
            "leftCorner": {
              "x": -10.343,
              "y": -25.22,
              "z": 0.421
            },
            "rightCorner": {
              "x": -10.344,
              "y": -24.962,
              "z": 0.421
            },
            "gtin": "4038269001342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b6a",
            "leftCorner": {
              "x": -10.343,
              "y": -24.962,
              "z": 0.421
            },
            "rightCorner": {
              "x": -10.343,
              "y": -24.729,
              "z": 0.421
            },
            "gtin": "4038269001403",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfea",
        "height": 0.77503,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b75",
            "leftCorner": {
              "x": -10.341,
              "y": -25.716,
              "z": 0.634
            },
            "rightCorner": {
              "x": -10.343,
              "y": -25.379,
              "z": 0.634
            },
            "gtin": "4038269000109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b76",
            "leftCorner": {
              "x": -10.348,
              "y": -25.379,
              "z": 0.634
            },
            "rightCorner": {
              "x": -10.349,
              "y": -25.232,
              "z": 0.634
            },
            "gtin": "4038269000048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b77",
            "leftCorner": {
              "x": -10.351,
              "y": -25.232,
              "z": 0.634
            },
            "rightCorner": {
              "x": -10.352,
              "y": -25.006,
              "z": 0.634
            },
            "gtin": "4038269001465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b74",
            "leftCorner": {
              "x": -10.351,
              "y": -25.006,
              "z": 0.634
            },
            "rightCorner": {
              "x": -10.352,
              "y": -24.729,
              "z": 0.634
            },
            "gtin": "4038269002110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7c65ea748ce4880702fb1145",
            "leftCorner": {
              "x": -10.306,
              "y": -25.979,
              "z": 0.634
            },
            "rightCorner": {
              "x": -10.307,
              "y": -25.734,
              "z": 0.634
            },
            "gtin": "4038269000109",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfeb",
        "height": 1.103,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b78",
            "leftCorner": {
              "x": -10.305,
              "y": -25.979,
              "z": 0.902
            },
            "rightCorner": {
              "x": -10.306,
              "y": -25.664,
              "z": 0.902
            },
            "gtin": "4038269000116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b7a",
            "leftCorner": {
              "x": -10.34,
              "y": -25.664,
              "z": 0.902
            },
            "rightCorner": {
              "x": -10.342,
              "y": -25.411,
              "z": 0.902
            },
            "gtin": "4038269000178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b7b",
            "leftCorner": {
              "x": -10.349,
              "y": -25.411,
              "z": 0.902
            },
            "rightCorner": {
              "x": -10.35,
              "y": -25.212,
              "z": 0.902
            },
            "gtin": "4038269000055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b7c",
            "leftCorner": {
              "x": -10.348,
              "y": -25.212,
              "z": 0.902
            },
            "rightCorner": {
              "x": -10.348,
              "y": -24.948,
              "z": 0.902
            },
            "gtin": "4038269001106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b79",
            "leftCorner": {
              "x": -10.349,
              "y": -24.948,
              "z": 0.902
            },
            "rightCorner": {
              "x": -10.35,
              "y": -24.729,
              "z": 0.902
            },
            "gtin": "4038269001168",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfec",
        "height": 1.3873,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b7d",
            "leftCorner": {
              "x": -10.303,
              "y": -25.979,
              "z": 1.135
            },
            "rightCorner": {
              "x": -10.308,
              "y": -24.947,
              "z": 1.135
            },
            "gtin": "4038269002554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b7e",
            "leftCorner": {
              "x": -10.343,
              "y": -24.947,
              "z": 1.135
            },
            "rightCorner": {
              "x": -10.344,
              "y": -24.729,
              "z": 1.135
            },
            "gtin": "4038269002615",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfe9",
        "height": 1.6802,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b6e",
            "leftCorner": {
              "x": -10.298,
              "y": -25.979,
              "z": 1.375
            },
            "rightCorner": {
              "x": -10.299,
              "y": -25.713,
              "z": 1.375
            },
            "gtin": "4038269002004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b70",
            "leftCorner": {
              "x": -10.336,
              "y": -25.713,
              "z": 1.375
            },
            "rightCorner": {
              "x": -10.338,
              "y": -25.495,
              "z": 1.375
            },
            "gtin": "4038269002103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b71",
            "leftCorner": {
              "x": -10.341,
              "y": -25.495,
              "z": 1.375
            },
            "rightCorner": {
              "x": -10.342,
              "y": -25.271,
              "z": 1.375
            },
            "gtin": "4038269002172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b72",
            "leftCorner": {
              "x": -10.341,
              "y": -25.271,
              "z": 1.375
            },
            "rightCorner": {
              "x": -10.342,
              "y": -24.991,
              "z": 1.375
            },
            "gtin": "4038269004633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b6f",
            "leftCorner": {
              "x": -10.347,
              "y": -24.991,
              "z": 1.375
            },
            "rightCorner": {
              "x": -10.348,
              "y": -24.729,
              "z": 1.375
            },
            "gtin": "4038269004480",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "820",
    "name": "820",
    "x": -10.825,
    "y": -27.6,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": 5.8469E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 45,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cff2",
        "height": 0.17661,
        "facings": [
          {
            "id": "840369a326fbcbc7f9615619",
            "leftCorner": {
              "x": -10.825,
              "y": -27.501,
              "z": 0.145
            },
            "rightCorner": {
              "x": -10.887,
              "y": -27.501,
              "z": 0.145
            },
            "gtin": "4002221014015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9e2e109e3b01de2bc1bd989e",
            "leftCorner": {
              "x": -10.887,
              "y": -27.501,
              "z": 0.145
            },
            "rightCorner": {
              "x": -10.957,
              "y": -27.501,
              "z": 0.145
            },
            "gtin": "4012824401921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "359ca2e166fc9060536f6130",
            "leftCorner": {
              "x": -10.957,
              "y": -27.501,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.03,
              "y": -27.501,
              "z": 0.145
            },
            "gtin": "4012824406285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0f3dac9fd1db40033f8cea89",
            "leftCorner": {
              "x": -11.03,
              "y": -27.501,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.104,
              "y": -27.501,
              "z": 0.145
            },
            "gtin": "4012824401464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bcfbac1fff239062845328f6",
            "leftCorner": {
              "x": -11.104,
              "y": -27.501,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.179,
              "y": -27.501,
              "z": 0.145
            },
            "gtin": "4012824401648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f2b8adbc57e7698b67e259d0",
            "leftCorner": {
              "x": -11.179,
              "y": -27.501,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.256,
              "y": -27.5,
              "z": 0.145
            },
            "gtin": "4012824404120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e358678a105c5cee7c8b2074",
            "leftCorner": {
              "x": -11.256,
              "y": -27.5,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.335,
              "y": -27.5,
              "z": 0.145
            },
            "gtin": "4012824401396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "207fb907d6af86120fd1aa09",
            "leftCorner": {
              "x": -11.335,
              "y": -27.5,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.419,
              "y": -27.5,
              "z": 0.145
            },
            "gtin": "4012824401730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "26df0fb25c20b7a15205d981",
            "leftCorner": {
              "x": -11.419,
              "y": -27.5,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.503,
              "y": -27.5,
              "z": 0.145
            },
            "gtin": "4012824400665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5b4797600b6d3aa5e5473fc4",
            "leftCorner": {
              "x": -11.503,
              "y": -27.5,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.597,
              "y": -27.5,
              "z": 0.145
            },
            "gtin": "4012824405349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a0ea4c4ba2a16ec7a2a9e5a4",
            "leftCorner": {
              "x": -11.597,
              "y": -27.5,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.694,
              "y": -27.5,
              "z": 0.145
            },
            "gtin": "4012824404243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c286f60d971330cefbfd21ef",
            "leftCorner": {
              "x": -11.694,
              "y": -27.5,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.792,
              "y": -27.5,
              "z": 0.145
            },
            "gtin": "4250780320362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9fda2769d1cea1df656e8cfe",
            "leftCorner": {
              "x": -11.792,
              "y": -27.5,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.07,
              "y": -27.5,
              "z": 0.145
            },
            "gtin": "4021155120784",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cff0",
        "height": 0.46355,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5bc1",
            "leftCorner": {
              "x": -10.825,
              "y": -27.555,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.059,
              "y": -27.555,
              "z": 0.379
            },
            "gtin": "4021155040853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bc3",
            "leftCorner": {
              "x": -11.059,
              "y": -27.592,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.239,
              "y": -27.593,
              "z": 0.379
            },
            "gtin": "4021155040839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bc4",
            "leftCorner": {
              "x": -11.239,
              "y": -27.588,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.486,
              "y": -27.588,
              "z": 0.379
            },
            "gtin": "4021155131582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bc5",
            "leftCorner": {
              "x": -11.486,
              "y": -27.597,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.612,
              "y": -27.596,
              "z": 0.379
            },
            "gtin": "4021155120791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bc6",
            "leftCorner": {
              "x": -11.612,
              "y": -27.596,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.738,
              "y": -27.596,
              "z": 0.379
            },
            "gtin": "4021155120791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bc7",
            "leftCorner": {
              "x": -11.738,
              "y": -27.597,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.996,
              "y": -27.597,
              "z": 0.379
            },
            "gtin": "4021155120784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bc8",
            "leftCorner": {
              "x": -11.996,
              "y": -27.587,
              "z": 0.379
            },
            "rightCorner": {
              "x": -12.161,
              "y": -27.586,
              "z": 0.379
            },
            "gtin": "4002221014015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cff1",
        "height": 0.76148,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5bda",
            "leftCorner": {
              "x": -10.825,
              "y": -27.548,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.138,
              "y": -27.547,
              "z": 0.623
            },
            "gtin": "4306188358855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bdc",
            "leftCorner": {
              "x": -11.138,
              "y": -27.585,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.417,
              "y": -27.585,
              "z": 0.623
            },
            "gtin": "4052700088853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bdd",
            "leftCorner": {
              "x": -11.417,
              "y": -27.587,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.637,
              "y": -27.587,
              "z": 0.623
            },
            "gtin": "4052700083421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bde",
            "leftCorner": {
              "x": -11.637,
              "y": -27.596,
              "z": 0.623
            },
            "rightCorner": {
              "x": -12.108,
              "y": -27.594,
              "z": 0.623
            },
            "gtin": "4052700079097",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfee",
        "height": 1.0661,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b81",
            "leftCorner": {
              "x": -10.825,
              "y": -27.551,
              "z": 0.872
            },
            "rightCorner": {
              "x": -10.926,
              "y": -27.551,
              "z": 0.872
            },
            "gtin": "4012824400665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b83",
            "leftCorner": {
              "x": -10.926,
              "y": -27.59,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.007,
              "y": -27.59,
              "z": 0.872
            },
            "gtin": "4012824404120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b84",
            "leftCorner": {
              "x": -11.007,
              "y": -27.585,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.106,
              "y": -27.585,
              "z": 0.872
            },
            "gtin": "4012824405349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b85",
            "leftCorner": {
              "x": -11.106,
              "y": -27.585,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.253,
              "y": -27.585,
              "z": 0.872
            },
            "gtin": "4012824401303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b86",
            "leftCorner": {
              "x": -11.253,
              "y": -27.585,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.33,
              "y": -27.585,
              "z": 0.872
            },
            "gtin": "4012824401730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b87",
            "leftCorner": {
              "x": -11.33,
              "y": -27.587,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.405,
              "y": -27.586,
              "z": 0.872
            },
            "gtin": "4012824401396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b88",
            "leftCorner": {
              "x": -11.404,
              "y": -27.588,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.474,
              "y": -27.588,
              "z": 0.872
            },
            "gtin": "4012824406285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b89",
            "leftCorner": {
              "x": -11.474,
              "y": -27.59,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.567,
              "y": -27.59,
              "z": 0.872
            },
            "gtin": "4012824404243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b8a",
            "leftCorner": {
              "x": -11.567,
              "y": -27.595,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.64,
              "y": -27.595,
              "z": 0.872
            },
            "gtin": "4012824401648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b8b",
            "leftCorner": {
              "x": -11.64,
              "y": -27.598,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.712,
              "y": -27.597,
              "z": 0.872
            },
            "gtin": "4012824401921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b8c",
            "leftCorner": {
              "x": -11.712,
              "y": -27.598,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.785,
              "y": -27.598,
              "z": 0.872
            },
            "gtin": "4012824401464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b8d",
            "leftCorner": {
              "x": -11.785,
              "y": -27.6,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.934,
              "y": -27.6,
              "z": 0.872
            },
            "gtin": "4012824401211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b8e",
            "leftCorner": {
              "x": -11.934,
              "y": -27.593,
              "z": 0.872
            },
            "rightCorner": {
              "x": -12.103,
              "y": -27.592,
              "z": 0.872
            },
            "gtin": "4012824400016",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfef",
        "height": 1.3717,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5ba3",
            "leftCorner": {
              "x": -10.825,
              "y": -27.544,
              "z": 1.122
            },
            "rightCorner": {
              "x": -10.983,
              "y": -27.544,
              "z": 1.122
            },
            "gtin": "4000161850069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ba5",
            "leftCorner": {
              "x": -10.983,
              "y": -27.583,
              "z": 1.122
            },
            "rightCorner": {
              "x": -11.172,
              "y": -27.583,
              "z": 1.122
            },
            "gtin": "4000161850052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ba6",
            "leftCorner": {
              "x": -11.172,
              "y": -27.585,
              "z": 1.122
            },
            "rightCorner": {
              "x": -11.317,
              "y": -27.584,
              "z": 1.122
            },
            "gtin": "4250780320348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ba7",
            "leftCorner": {
              "x": -11.317,
              "y": -27.583,
              "z": 1.122
            },
            "rightCorner": {
              "x": -11.456,
              "y": -27.583,
              "z": 1.122
            },
            "gtin": "4250780320249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ba8",
            "leftCorner": {
              "x": -11.456,
              "y": -27.58,
              "z": 1.122
            },
            "rightCorner": {
              "x": -11.603,
              "y": -27.58,
              "z": 1.122
            },
            "gtin": "4250780320324",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d5ba9",
            "leftCorner": {
              "x": -11.603,
              "y": -27.586,
              "z": 1.122
            },
            "rightCorner": {
              "x": -11.723,
              "y": -27.587,
              "z": 1.122
            },
            "gtin": "4250780320447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5baa",
            "leftCorner": {
              "x": -11.723,
              "y": -27.592,
              "z": 1.122
            },
            "rightCorner": {
              "x": -11.814,
              "y": -27.591,
              "z": 1.122
            },
            "gtin": "4250780320362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bab",
            "leftCorner": {
              "x": -11.814,
              "y": -27.588,
              "z": 1.122
            },
            "rightCorner": {
              "x": -11.906,
              "y": -27.588,
              "z": 1.122
            },
            "gtin": "4250780320386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bac",
            "leftCorner": {
              "x": -11.906,
              "y": -27.581,
              "z": 1.122
            },
            "rightCorner": {
              "x": -12.107,
              "y": -27.581,
              "z": 1.122
            },
            "gtin": "4052700202334",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "821"
  },
  {
    "id": "821",
    "name": "821",
    "x": -12.075,
    "y": -27.598,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": 5.8469E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 43,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cff8",
        "height": 0.17606,
        "facings": [
          {
            "id": "e0c3b2dbbe1bf8ed47c0c345",
            "leftCorner": {
              "x": -12.074,
              "y": -27.494,
              "z": 0.144
            },
            "rightCorner": {
              "x": -12.139,
              "y": -27.494,
              "z": 0.144
            },
            "gtin": "4005500081128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "872712294b02c266658f8735",
            "leftCorner": {
              "x": -12.139,
              "y": -27.494,
              "z": 0.144
            },
            "rightCorner": {
              "x": -12.217,
              "y": -27.494,
              "z": 0.144
            },
            "gtin": "4009300017608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "36fb60a7f78c08e727783091",
            "leftCorner": {
              "x": -12.217,
              "y": -27.494,
              "z": 0.144
            },
            "rightCorner": {
              "x": -12.309,
              "y": -27.494,
              "z": 0.144
            },
            "gtin": "4009300019060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9ea4f1c1811f76dd7f0fee45",
            "leftCorner": {
              "x": -12.309,
              "y": -27.494,
              "z": 0.144
            },
            "rightCorner": {
              "x": -12.407,
              "y": -27.494,
              "z": 0.144
            },
            "gtin": "4009300017530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "18d57f38df2c69ef9c8a663f",
            "leftCorner": {
              "x": -12.407,
              "y": -27.494,
              "z": 0.144
            },
            "rightCorner": {
              "x": -12.507,
              "y": -27.493,
              "z": 0.144
            },
            "gtin": "4009300012078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e6ff2f74e2a66edd9321300f",
            "leftCorner": {
              "x": -12.507,
              "y": -27.493,
              "z": 0.144
            },
            "rightCorner": {
              "x": -12.623,
              "y": -27.493,
              "z": 0.144
            },
            "gtin": "4008837235905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a3926254ae32e34bfc52d4ce",
            "leftCorner": {
              "x": -12.623,
              "y": -27.493,
              "z": 0.144
            },
            "rightCorner": {
              "x": -12.75,
              "y": -27.493,
              "z": 0.144
            },
            "gtin": "4008837235929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "818c682cf0013e800b149969",
            "leftCorner": {
              "x": -12.75,
              "y": -27.493,
              "z": 0.144
            },
            "rightCorner": {
              "x": -12.878,
              "y": -27.493,
              "z": 0.144
            },
            "gtin": "4001257218404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c20b4ee98655a515ab2c1f57",
            "leftCorner": {
              "x": -12.878,
              "y": -27.493,
              "z": 0.144
            },
            "rightCorner": {
              "x": -13.008,
              "y": -27.493,
              "z": 0.144
            },
            "gtin": "4036300047304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e133fd4c61730ea2ff798872",
            "leftCorner": {
              "x": -13.008,
              "y": -27.493,
              "z": 0.144
            },
            "rightCorner": {
              "x": -13.138,
              "y": -27.493,
              "z": 0.144
            },
            "gtin": "4008837235936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c16fd2da5ee4888deb596d94",
            "leftCorner": {
              "x": -13.138,
              "y": -27.493,
              "z": 0.144
            },
            "rightCorner": {
              "x": -13.316,
              "y": -27.493,
              "z": 0.144
            },
            "gtin": "4001257218206",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cff5",
        "height": 0.46377,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5bc9",
            "leftCorner": {
              "x": -12.161,
              "y": -27.583,
              "z": 0.379
            },
            "rightCorner": {
              "x": -12.347,
              "y": -27.583,
              "z": 0.379
            },
            "gtin": "4002221011311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bca",
            "leftCorner": {
              "x": -12.347,
              "y": -27.582,
              "z": 0.379
            },
            "rightCorner": {
              "x": -12.515,
              "y": -27.581,
              "z": 0.379
            },
            "gtin": "4001257160000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bcb",
            "leftCorner": {
              "x": -12.515,
              "y": -27.583,
              "z": 0.379
            },
            "rightCorner": {
              "x": -12.69,
              "y": -27.583,
              "z": 0.379
            },
            "gtin": "4001257156003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bcc",
            "leftCorner": {
              "x": -12.69,
              "y": -27.586,
              "z": 0.379
            },
            "rightCorner": {
              "x": -12.879,
              "y": -27.586,
              "z": 0.379
            },
            "gtin": "4001257152005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bcd",
            "leftCorner": {
              "x": -12.879,
              "y": -27.534,
              "z": 0.379
            },
            "rightCorner": {
              "x": -13.144,
              "y": -27.533,
              "z": 0.379
            },
            "gtin": "4006508206827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bce",
            "leftCorner": {
              "x": -13.144,
              "y": -27.533,
              "z": 0.379
            },
            "rightCorner": {
              "x": -13.408,
              "y": -27.533,
              "z": 0.379
            },
            "gtin": "4006508206827",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cff6",
        "height": 0.76302,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5bdf",
            "leftCorner": {
              "x": -12.107,
              "y": -27.588,
              "z": 0.624
            },
            "rightCorner": {
              "x": -12.235,
              "y": -27.587,
              "z": 0.624
            },
            "gtin": "4001257218404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5be0",
            "leftCorner": {
              "x": -12.235,
              "y": -27.586,
              "z": 0.624
            },
            "rightCorner": {
              "x": -12.41,
              "y": -27.586,
              "z": 0.624
            },
            "gtin": "4001257218206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5be1",
            "leftCorner": {
              "x": -12.41,
              "y": -27.587,
              "z": 0.624
            },
            "rightCorner": {
              "x": -12.564,
              "y": -27.586,
              "z": 0.624
            },
            "gtin": "4001257218503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5be2",
            "leftCorner": {
              "x": -12.564,
              "y": -27.58,
              "z": 0.624
            },
            "rightCorner": {
              "x": -12.715,
              "y": -27.581,
              "z": 0.624
            },
            "gtin": "4001257001723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5be3",
            "leftCorner": {
              "x": -12.715,
              "y": -27.59,
              "z": 0.624
            },
            "rightCorner": {
              "x": -12.918,
              "y": -27.59,
              "z": 0.624
            },
            "gtin": "4001257214109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5be4",
            "leftCorner": {
              "x": -12.918,
              "y": -27.587,
              "z": 0.624
            },
            "rightCorner": {
              "x": -13.049,
              "y": -27.587,
              "z": 0.624
            },
            "gtin": "4002221003330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5be5",
            "leftCorner": {
              "x": -13.049,
              "y": -27.59,
              "z": 0.624
            },
            "rightCorner": {
              "x": -13.195,
              "y": -27.589,
              "z": 0.624
            },
            "gtin": "4002221007130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5be6",
            "leftCorner": {
              "x": -13.195,
              "y": -27.589,
              "z": 0.624
            },
            "rightCorner": {
              "x": -13.389,
              "y": -27.589,
              "z": 0.624
            },
            "gtin": "4036300047304",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cff4",
        "height": 1.065,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b8f",
            "leftCorner": {
              "x": -12.102,
              "y": -27.581,
              "z": 0.871
            },
            "rightCorner": {
              "x": -12.268,
              "y": -27.581,
              "z": 0.871
            },
            "gtin": "4002221048546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b90",
            "leftCorner": {
              "x": -12.268,
              "y": -27.585,
              "z": 0.871
            },
            "rightCorner": {
              "x": -12.428,
              "y": -27.585,
              "z": 0.871
            },
            "gtin": "4002221015128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b91",
            "leftCorner": {
              "x": -12.428,
              "y": -27.585,
              "z": 0.871
            },
            "rightCorner": {
              "x": -12.586,
              "y": -27.584,
              "z": 0.871
            },
            "gtin": "4001257283501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b92",
            "leftCorner": {
              "x": -12.586,
              "y": -27.583,
              "z": 0.871
            },
            "rightCorner": {
              "x": -12.72,
              "y": -27.584,
              "z": 0.871
            },
            "gtin": "4002221030015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b93",
            "leftCorner": {
              "x": -12.72,
              "y": -27.587,
              "z": 0.871
            },
            "rightCorner": {
              "x": -12.852,
              "y": -27.587,
              "z": 0.871
            },
            "gtin": "4002221030053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b94",
            "leftCorner": {
              "x": -12.852,
              "y": -27.583,
              "z": 0.871
            },
            "rightCorner": {
              "x": -13.122,
              "y": -27.582,
              "z": 0.871
            },
            "gtin": "4002221030275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b95",
            "leftCorner": {
              "x": -13.122,
              "y": -27.587,
              "z": 0.871
            },
            "rightCorner": {
              "x": -13.262,
              "y": -27.588,
              "z": 0.871
            },
            "gtin": "4002221030152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b96",
            "leftCorner": {
              "x": -13.262,
              "y": -27.585,
              "z": 0.871
            },
            "rightCorner": {
              "x": -13.485,
              "y": -27.585,
              "z": 0.871
            },
            "gtin": "4005500081128",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cff3",
        "height": 1.3699,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5bad",
            "leftCorner": {
              "x": -12.106,
              "y": -27.581,
              "z": 1.121
            },
            "rightCorner": {
              "x": -12.263,
              "y": -27.581,
              "z": 1.121
            },
            "gtin": "4009300019053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bae",
            "leftCorner": {
              "x": -12.263,
              "y": -27.584,
              "z": 1.121
            },
            "rightCorner": {
              "x": -12.338,
              "y": -27.584,
              "z": 1.121
            },
            "gtin": "4009300017608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5baf",
            "leftCorner": {
              "x": -12.338,
              "y": -27.583,
              "z": 1.121
            },
            "rightCorner": {
              "x": -12.433,
              "y": -27.583,
              "z": 1.121
            },
            "gtin": "4009300012078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bb0",
            "leftCorner": {
              "x": -12.433,
              "y": -27.585,
              "z": 1.121
            },
            "rightCorner": {
              "x": -12.543,
              "y": -27.585,
              "z": 1.121
            },
            "gtin": "4009300017530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bb1",
            "leftCorner": {
              "x": -12.543,
              "y": -27.584,
              "z": 1.121
            },
            "rightCorner": {
              "x": -12.703,
              "y": -27.584,
              "z": 1.121
            },
            "gtin": "4009300021070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bb2",
            "leftCorner": {
              "x": -12.703,
              "y": -27.586,
              "z": 1.121
            },
            "rightCorner": {
              "x": -12.788,
              "y": -27.585,
              "z": 1.121
            },
            "gtin": "4009300019060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bb3",
            "leftCorner": {
              "x": -12.788,
              "y": -27.585,
              "z": 1.121
            },
            "rightCorner": {
              "x": -12.952,
              "y": -27.584,
              "z": 1.121
            },
            "gtin": "4009300021049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bb4",
            "leftCorner": {
              "x": -12.952,
              "y": -27.582,
              "z": 1.121
            },
            "rightCorner": {
              "x": -13.085,
              "y": -27.583,
              "z": 1.121
            },
            "gtin": "4008837235936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bb5",
            "leftCorner": {
              "x": -13.085,
              "y": -27.586,
              "z": 1.121
            },
            "rightCorner": {
              "x": -13.214,
              "y": -27.586,
              "z": 1.121
            },
            "gtin": "4008837235929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bb6",
            "leftCorner": {
              "x": -13.214,
              "y": -27.583,
              "z": 1.121
            },
            "rightCorner": {
              "x": -13.364,
              "y": -27.583,
              "z": 1.121
            },
            "gtin": "4008837235905",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "820",
    "rightNeighborShelfId": "822"
  },
  {
    "id": "822",
    "name": "822",
    "x": -13.325,
    "y": -27.597,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": 5.8469E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 43
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539cffd",
        "height": 0.17859,
        "facings": [
          {
            "id": "4fbe929e33318602e440068f",
            "leftCorner": {
              "x": -13.325,
              "y": -27.493,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.41,
              "y": -27.493,
              "z": 0.146
            },
            "gtin": "4006508204335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "49397058225c15af3598e210",
            "leftCorner": {
              "x": -13.41,
              "y": -27.493,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.526,
              "y": -27.493,
              "z": 0.146
            },
            "gtin": "4011800330118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7b9e2fbb1fd8b50d0e74df7f",
            "leftCorner": {
              "x": -13.526,
              "y": -27.493,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.647,
              "y": -27.493,
              "z": 0.146
            },
            "gtin": "4006508178087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c077b7606b44b25ce975f19d",
            "leftCorner": {
              "x": -13.647,
              "y": -27.493,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.786,
              "y": -27.492,
              "z": 0.146
            },
            "gtin": "4006508208814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "176e6e359864bd356415c673",
            "leftCorner": {
              "x": -13.786,
              "y": -27.492,
              "z": 0.146
            },
            "rightCorner": {
              "x": -13.935,
              "y": -27.492,
              "z": 0.146
            },
            "gtin": "4011800330217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a33049ebd59b34c701b207a5",
            "leftCorner": {
              "x": -13.935,
              "y": -27.492,
              "z": 0.146
            },
            "rightCorner": {
              "x": -14.095,
              "y": -27.492,
              "z": 0.146
            },
            "gtin": "4045317050474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "13cb1abe4192379b986d1269",
            "leftCorner": {
              "x": -14.095,
              "y": -27.492,
              "z": 0.146
            },
            "rightCorner": {
              "x": -14.257,
              "y": -27.492,
              "z": 0.146
            },
            "gtin": "4006508123834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee027710c587d178e05ac394",
            "leftCorner": {
              "x": -14.257,
              "y": -27.492,
              "z": 0.146
            },
            "rightCorner": {
              "x": -14.43,
              "y": -27.492,
              "z": 0.146
            },
            "gtin": "4036300220950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a4f1701b62f9937bf2627a2f",
            "leftCorner": {
              "x": -14.43,
              "y": -27.492,
              "z": 0.146
            },
            "rightCorner": {
              "x": -14.573,
              "y": -27.492,
              "z": 0.146
            },
            "gtin": "4032549024120",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cffa",
        "height": 0.46158,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5bcf",
            "leftCorner": {
              "x": -13.408,
              "y": -27.584,
              "z": 0.378
            },
            "rightCorner": {
              "x": -13.545,
              "y": -27.584,
              "z": 0.378
            },
            "gtin": "4006508208814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bd0",
            "leftCorner": {
              "x": -13.545,
              "y": -27.586,
              "z": 0.378
            },
            "rightCorner": {
              "x": -13.715,
              "y": -27.586,
              "z": 0.378
            },
            "gtin": "4006508123834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bd1",
            "leftCorner": {
              "x": -13.715,
              "y": -27.581,
              "z": 0.378
            },
            "rightCorner": {
              "x": -13.833,
              "y": -27.58,
              "z": 0.378
            },
            "gtin": "4006508178087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bd2",
            "leftCorner": {
              "x": -13.833,
              "y": -27.584,
              "z": 0.378
            },
            "rightCorner": {
              "x": -13.917,
              "y": -27.584,
              "z": 0.378
            },
            "gtin": "4006508204335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bd3",
            "leftCorner": {
              "x": -13.917,
              "y": -27.58,
              "z": 0.378
            },
            "rightCorner": {
              "x": -14.108,
              "y": -27.58,
              "z": 0.378
            },
            "gtin": "4027300003643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bd4",
            "leftCorner": {
              "x": -14.108,
              "y": -27.584,
              "z": 0.378
            },
            "rightCorner": {
              "x": -14.271,
              "y": -27.584,
              "z": 0.378
            },
            "gtin": "4045317050474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bd5",
            "leftCorner": {
              "x": -14.271,
              "y": -27.584,
              "z": 0.378
            },
            "rightCorner": {
              "x": -14.372,
              "y": -27.584,
              "z": 0.378
            },
            "gtin": "4045317050276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bd6",
            "leftCorner": {
              "x": -14.372,
              "y": -27.584,
              "z": 0.378
            },
            "rightCorner": {
              "x": -14.472,
              "y": -27.584,
              "z": 0.378
            },
            "gtin": "4045317050276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bd7",
            "leftCorner": {
              "x": -14.472,
              "y": -27.584,
              "z": 0.378
            },
            "rightCorner": {
              "x": -14.573,
              "y": -27.583,
              "z": 0.378
            },
            "gtin": "4045317050276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bd8",
            "leftCorner": {
              "x": -14.573,
              "y": -27.583,
              "z": 0.378
            },
            "rightCorner": {
              "x": -14.673,
              "y": -27.583,
              "z": 0.378
            },
            "gtin": "4045317050276",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cffb",
        "height": 0.76129,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5be7",
            "leftCorner": {
              "x": -13.389,
              "y": -27.59,
              "z": 0.623
            },
            "rightCorner": {
              "x": -13.566,
              "y": -27.59,
              "z": 0.623
            },
            "gtin": "4036300220950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5be8",
            "leftCorner": {
              "x": -13.566,
              "y": -27.587,
              "z": 0.623
            },
            "rightCorner": {
              "x": -13.775,
              "y": -27.586,
              "z": 0.623
            },
            "gtin": "4045317053024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5be9",
            "leftCorner": {
              "x": -13.775,
              "y": -27.585,
              "z": 0.623
            },
            "rightCorner": {
              "x": -13.976,
              "y": -27.585,
              "z": 0.623
            },
            "gtin": "4045317053017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bea",
            "leftCorner": {
              "x": -13.976,
              "y": -27.583,
              "z": 0.623
            },
            "rightCorner": {
              "x": -14.293,
              "y": -27.583,
              "z": 0.623
            },
            "gtin": "4045317050283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5beb",
            "leftCorner": {
              "x": -14.293,
              "y": -27.587,
              "z": 0.623
            },
            "rightCorner": {
              "x": -14.356,
              "y": -27.587,
              "z": 0.623
            },
            "gtin": "4045317050290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bec",
            "leftCorner": {
              "x": -14.356,
              "y": -27.587,
              "z": 0.623
            },
            "rightCorner": {
              "x": -14.42,
              "y": -27.587,
              "z": 0.623
            },
            "gtin": "4045317050290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bed",
            "leftCorner": {
              "x": -14.42,
              "y": -27.587,
              "z": 0.623
            },
            "rightCorner": {
              "x": -14.483,
              "y": -27.587,
              "z": 0.623
            },
            "gtin": "4045317050290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bee",
            "leftCorner": {
              "x": -14.483,
              "y": -27.587,
              "z": 0.623
            },
            "rightCorner": {
              "x": -14.546,
              "y": -27.587,
              "z": 0.623
            },
            "gtin": "4045317050290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bef",
            "leftCorner": {
              "x": -14.546,
              "y": -27.587,
              "z": 0.623
            },
            "rightCorner": {
              "x": -14.61,
              "y": -27.586,
              "z": 0.623
            },
            "gtin": "4045317050290",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cff9",
        "height": 1.0637,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b97",
            "leftCorner": {
              "x": -13.485,
              "y": -27.587,
              "z": 0.87
            },
            "rightCorner": {
              "x": -13.596,
              "y": -27.587,
              "z": 0.87
            },
            "gtin": "4032549031678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2c801c450f0f54f099b6fb22",
            "leftCorner": {
              "x": -13.325,
              "y": -27.543,
              "z": 0.87
            },
            "rightCorner": {
              "x": -13.464,
              "y": -27.543,
              "z": 0.87
            },
            "gtin": "4032549024120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b98",
            "leftCorner": {
              "x": -13.596,
              "y": -27.587,
              "z": 0.87
            },
            "rightCorner": {
              "x": -13.707,
              "y": -27.587,
              "z": 0.87
            },
            "gtin": "4032549031678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b99",
            "leftCorner": {
              "x": -13.707,
              "y": -27.582,
              "z": 0.87
            },
            "rightCorner": {
              "x": -13.845,
              "y": -27.581,
              "z": 0.87
            },
            "gtin": "4032549024120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b9a",
            "leftCorner": {
              "x": -13.845,
              "y": -27.582,
              "z": 0.87
            },
            "rightCorner": {
              "x": -13.902,
              "y": -27.582,
              "z": 0.87
            },
            "gtin": "4032549038240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b9b",
            "leftCorner": {
              "x": -13.902,
              "y": -27.582,
              "z": 0.87
            },
            "rightCorner": {
              "x": -13.958,
              "y": -27.582,
              "z": 0.87
            },
            "gtin": "4032549038240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b9c",
            "leftCorner": {
              "x": -13.958,
              "y": -27.584,
              "z": 0.87
            },
            "rightCorner": {
              "x": -14.421,
              "y": -27.584,
              "z": 0.87
            },
            "gtin": "4306188399179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b9d",
            "leftCorner": {
              "x": -14.421,
              "y": -27.581,
              "z": 0.87
            },
            "rightCorner": {
              "x": -14.616,
              "y": -27.58,
              "z": 0.87
            },
            "gtin": "4250426206272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b9e",
            "leftCorner": {
              "x": -14.616,
              "y": -27.58,
              "z": 0.87
            },
            "rightCorner": {
              "x": -14.811,
              "y": -27.58,
              "z": 0.87
            },
            "gtin": "4250426206272",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cffc",
        "height": 1.3685,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5bb7",
            "leftCorner": {
              "x": -13.365,
              "y": -27.583,
              "z": 1.12
            },
            "rightCorner": {
              "x": -13.629,
              "y": -27.584,
              "z": 1.12
            },
            "gtin": "4052700265032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bb8",
            "leftCorner": {
              "x": -13.629,
              "y": -27.58,
              "z": 1.12
            },
            "rightCorner": {
              "x": -13.886,
              "y": -27.579,
              "z": 1.12
            },
            "gtin": "4306188041511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bb9",
            "leftCorner": {
              "x": -13.886,
              "y": -27.581,
              "z": 1.12
            },
            "rightCorner": {
              "x": -14.138,
              "y": -27.581,
              "z": 1.12
            },
            "gtin": "4021155023078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bba",
            "leftCorner": {
              "x": -14.138,
              "y": -27.582,
              "z": 1.12
            },
            "rightCorner": {
              "x": -14.246,
              "y": -27.582,
              "z": 1.12
            },
            "gtin": "4011800330118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bbb",
            "leftCorner": {
              "x": -14.246,
              "y": -27.581,
              "z": 1.12
            },
            "rightCorner": {
              "x": -14.401,
              "y": -27.581,
              "z": 1.12
            },
            "gtin": "4011800330217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bbc",
            "leftCorner": {
              "x": -14.401,
              "y": -27.58,
              "z": 1.12
            },
            "rightCorner": {
              "x": -14.62,
              "y": -27.579,
              "z": 1.12
            },
            "gtin": "4250780307073",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "821",
    "rightNeighborShelfId": "823"
  },
  {
    "id": "823",
    "name": "823",
    "x": -14.575,
    "y": -27.595,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": 5.8469E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 23
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d002",
        "height": 0.17561,
        "facings": [
          {
            "id": "87c2637faeff27707f49bb1c",
            "leftCorner": {
              "x": -14.575,
              "y": -27.515,
              "z": 0.144
            },
            "rightCorner": {
              "x": -14.742,
              "y": -27.515,
              "z": 0.144
            },
            "gtin": "4045317052522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0c533ca2646dc9ac7f01dd72",
            "leftCorner": {
              "x": -14.742,
              "y": -27.515,
              "z": 0.144
            },
            "rightCorner": {
              "x": -14.92,
              "y": -27.515,
              "z": 0.144
            },
            "gtin": "4002970002110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c0aea3a8342b2220d3b57f81",
            "leftCorner": {
              "x": -14.92,
              "y": -27.515,
              "z": 0.144
            },
            "rightCorner": {
              "x": -15.112,
              "y": -27.514,
              "z": 0.144
            },
            "gtin": "4045317052584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "28908ba03896f7e85462ac5a",
            "leftCorner": {
              "x": -15.112,
              "y": -27.514,
              "z": 0.144
            },
            "rightCorner": {
              "x": -15.312,
              "y": -27.514,
              "z": 0.144
            },
            "gtin": "4045317052676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d91d48ca6d707b3e5ea9fa81",
            "leftCorner": {
              "x": -15.312,
              "y": -27.514,
              "z": 0.144
            },
            "rightCorner": {
              "x": -15.512,
              "y": -27.514,
              "z": 0.144
            },
            "gtin": "4260024180102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7a0a4af134c3d6b7e4771b3b",
            "leftCorner": {
              "x": -15.512,
              "y": -27.514,
              "z": 0.144
            },
            "rightCorner": {
              "x": -15.713,
              "y": -27.514,
              "z": 0.144
            },
            "gtin": "4045317052577",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d001",
        "height": 0.4591,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5bd9",
            "leftCorner": {
              "x": -14.674,
              "y": -27.588,
              "z": 0.376
            },
            "rightCorner": {
              "x": -15.292,
              "y": -27.587,
              "z": 0.376
            },
            "gtin": "4306188400103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bc2",
            "leftCorner": {
              "x": -15.292,
              "y": -27.599,
              "z": 0.376
            },
            "rightCorner": {
              "x": -15.825,
              "y": -27.598,
              "z": 0.376
            },
            "gtin": "4306188400134",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cfff",
        "height": 0.75581,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5bf0",
            "leftCorner": {
              "x": -14.61,
              "y": -27.587,
              "z": 0.618
            },
            "rightCorner": {
              "x": -14.924,
              "y": -27.587,
              "z": 0.618
            },
            "gtin": "4045317052522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bf1",
            "leftCorner": {
              "x": -14.924,
              "y": -27.598,
              "z": 0.618
            },
            "rightCorner": {
              "x": -15.125,
              "y": -27.598,
              "z": 0.618
            },
            "gtin": "4045317052577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bf2",
            "leftCorner": {
              "x": -15.126,
              "y": -27.602,
              "z": 0.618
            },
            "rightCorner": {
              "x": -15.421,
              "y": -27.601,
              "z": 0.618
            },
            "gtin": "4045317052539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bf3",
            "leftCorner": {
              "x": -15.421,
              "y": -27.605,
              "z": 0.618
            },
            "rightCorner": {
              "x": -15.615,
              "y": -27.604,
              "z": 0.618
            },
            "gtin": "4045317052676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bdb",
            "leftCorner": {
              "x": -15.615,
              "y": -27.606,
              "z": 0.618
            },
            "rightCorner": {
              "x": -15.825,
              "y": -27.605,
              "z": 0.618
            },
            "gtin": "4045317052584",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539cffe",
        "height": 1.0611,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5b9f",
            "leftCorner": {
              "x": -14.811,
              "y": -27.592,
              "z": 0.868
            },
            "rightCorner": {
              "x": -15.008,
              "y": -27.592,
              "z": 0.868
            },
            "gtin": "4260024180102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ba0",
            "leftCorner": {
              "x": -15.009,
              "y": -27.6,
              "z": 0.868
            },
            "rightCorner": {
              "x": -15.11,
              "y": -27.6,
              "z": 0.868
            },
            "gtin": "4062800006206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ba1",
            "leftCorner": {
              "x": -15.11,
              "y": -27.6,
              "z": 0.868
            },
            "rightCorner": {
              "x": -15.212,
              "y": -27.6,
              "z": 0.868
            },
            "gtin": "4062800006206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ba2",
            "leftCorner": {
              "x": -15.212,
              "y": -27.602,
              "z": 0.868
            },
            "rightCorner": {
              "x": -15.469,
              "y": -27.601,
              "z": 0.868
            },
            "gtin": "4250426200607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5b82",
            "leftCorner": {
              "x": -15.469,
              "y": -27.602,
              "z": 0.868
            },
            "rightCorner": {
              "x": -15.825,
              "y": -27.602,
              "z": 0.868
            },
            "gtin": "4250426200591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7f7beefd3b3a6a6e2c478b6d",
            "leftCorner": {
              "x": -14.576,
              "y": -27.562,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.807,
              "y": -27.562,
              "z": 0.868
            },
            "gtin": "4250426200607",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d000",
        "height": 1.3671,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5bbd",
            "leftCorner": {
              "x": -14.62,
              "y": -27.58,
              "z": 1.119
            },
            "rightCorner": {
              "x": -14.798,
              "y": -27.581,
              "z": 1.119
            },
            "gtin": "4002970002110",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d5bbf",
            "leftCorner": {
              "x": -15.009,
              "y": -27.595,
              "z": 1.119
            },
            "rightCorner": {
              "x": -15.295,
              "y": -27.595,
              "z": 1.119
            },
            "gtin": "40273907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5bc0",
            "leftCorner": {
              "x": -15.295,
              "y": -27.596,
              "z": 1.119
            },
            "rightCorner": {
              "x": -15.562,
              "y": -27.595,
              "z": 1.119
            },
            "gtin": "40273433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ba4",
            "leftCorner": {
              "x": -15.562,
              "y": -27.601,
              "z": 1.119
            },
            "rightCorner": {
              "x": -15.825,
              "y": -27.601,
              "z": 1.119
            },
            "gtin": "40273488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "78735ebcd4216776be696e51",
            "leftCorner": {
              "x": -14.798,
              "y": -27.556,
              "z": 1.119
            },
            "rightCorner": {
              "x": -14.976,
              "y": -27.556,
              "z": 1.119
            },
            "gtin": "4002970002110",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "822"
  },
  {
    "id": "824",
    "name": "824",
    "x": -15.809,
    "y": -28.799,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0047473,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 45,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d650",
        "height": 0.1792,
        "facings": [
          {
            "id": "819e16f381a1103a44afd803",
            "leftCorner": {
              "x": -15.808,
              "y": -28.877,
              "z": 0.147
            },
            "rightCorner": {
              "x": -15.661,
              "y": -28.876,
              "z": 0.147
            },
            "gtin": "8711000500286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8baf7b022ee3110d1367a96b",
            "leftCorner": {
              "x": -15.661,
              "y": -28.876,
              "z": 0.147
            },
            "rightCorner": {
              "x": -15.581,
              "y": -28.875,
              "z": 0.147
            },
            "gtin": "4008167010500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d0ffc1833b1cff2457dd4d98",
            "leftCorner": {
              "x": -15.581,
              "y": -28.875,
              "z": 0.147
            },
            "rightCorner": {
              "x": -15.493,
              "y": -28.874,
              "z": 0.147
            },
            "gtin": "4006581061030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "442104a5f61d10d38e976ae5",
            "leftCorner": {
              "x": -15.493,
              "y": -28.874,
              "z": 0.147
            },
            "rightCorner": {
              "x": -15.398,
              "y": -28.873,
              "z": 0.147
            },
            "gtin": "8445291149168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "13c87fc5c853bce725ab5ca5",
            "leftCorner": {
              "x": -15.398,
              "y": -28.873,
              "z": 0.147
            },
            "rightCorner": {
              "x": -15.299,
              "y": -28.872,
              "z": 0.147
            },
            "gtin": "4006581061054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "66ab0f22780229962184efa8",
            "leftCorner": {
              "x": -15.299,
              "y": -28.872,
              "z": 0.147
            },
            "rightCorner": {
              "x": -15.192,
              "y": -28.871,
              "z": 0.147
            },
            "gtin": "7613036961806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "00e1c8d38264c951c2a715c9",
            "leftCorner": {
              "x": -15.192,
              "y": -28.871,
              "z": 0.147
            },
            "rightCorner": {
              "x": -15.084,
              "y": -28.87,
              "z": 0.147
            },
            "gtin": "8445291179301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6d524efe5fa25653cdaed52b",
            "leftCorner": {
              "x": -15.084,
              "y": -28.87,
              "z": 0.147
            },
            "rightCorner": {
              "x": -14.975,
              "y": -28.869,
              "z": 0.147
            },
            "gtin": "8445291146655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4cb060f92101cca4b0e1b5cd",
            "leftCorner": {
              "x": -14.975,
              "y": -28.869,
              "z": 0.147
            },
            "rightCorner": {
              "x": -14.865,
              "y": -28.868,
              "z": 0.147
            },
            "gtin": "7613036306294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0d36fe6be331d898fd814220",
            "leftCorner": {
              "x": -14.865,
              "y": -28.868,
              "z": 0.147
            },
            "rightCorner": {
              "x": -14.658,
              "y": -28.866,
              "z": 0.147
            },
            "gtin": "8711000500552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "34771af872c47d33a906e18a",
            "leftCorner": {
              "x": -14.658,
              "y": -28.866,
              "z": 0.147
            },
            "rightCorner": {
              "x": -14.559,
              "y": -28.865,
              "z": 0.147
            },
            "gtin": "4006581061054",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d64d",
        "height": 0.46104,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c55",
            "leftCorner": {
              "x": -15.809,
              "y": -28.821,
              "z": 0.377
            },
            "rightCorner": {
              "x": -15.597,
              "y": -28.819,
              "z": 0.377
            },
            "gtin": "8711000500583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c59",
            "leftCorner": {
              "x": -15.597,
              "y": -28.777,
              "z": 0.377
            },
            "rightCorner": {
              "x": -15.444,
              "y": -28.775,
              "z": 0.377
            },
            "gtin": "8711000500224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c5a",
            "leftCorner": {
              "x": -15.444,
              "y": -28.775,
              "z": 0.377
            },
            "rightCorner": {
              "x": -15.291,
              "y": -28.774,
              "z": 0.377
            },
            "gtin": "8711000504833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c5b",
            "leftCorner": {
              "x": -15.291,
              "y": -28.774,
              "z": 0.377
            },
            "rightCorner": {
              "x": -15.122,
              "y": -28.772,
              "z": 0.377
            },
            "gtin": "8711000500033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c5c",
            "leftCorner": {
              "x": -15.122,
              "y": -28.778,
              "z": 0.377
            },
            "rightCorner": {
              "x": -14.865,
              "y": -28.776,
              "z": 0.377
            },
            "gtin": "8711000500774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c5d",
            "leftCorner": {
              "x": -14.865,
              "y": -28.779,
              "z": 0.377
            },
            "rightCorner": {
              "x": -14.722,
              "y": -28.777,
              "z": 0.377
            },
            "gtin": "8711000500408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c5e",
            "leftCorner": {
              "x": -14.722,
              "y": -28.774,
              "z": 0.377
            },
            "rightCorner": {
              "x": -14.502,
              "y": -28.772,
              "z": 0.377
            },
            "gtin": "8711000500552",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d64e",
        "height": 0.76248,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c70",
            "leftCorner": {
              "x": -15.809,
              "y": -28.822,
              "z": 0.624
            },
            "rightCorner": {
              "x": -15.611,
              "y": -28.82,
              "z": 0.624
            },
            "gtin": "7613035690660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c72",
            "leftCorner": {
              "x": -15.611,
              "y": -28.784,
              "z": 0.624
            },
            "rightCorner": {
              "x": -15.5,
              "y": -28.783,
              "z": 0.624
            },
            "gtin": "7613037788884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c73",
            "leftCorner": {
              "x": -15.5,
              "y": -28.781,
              "z": 0.624
            },
            "rightCorner": {
              "x": -15.357,
              "y": -28.779,
              "z": 0.624
            },
            "gtin": "7613037491173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c74",
            "leftCorner": {
              "x": -15.357,
              "y": -28.777,
              "z": 0.624
            },
            "rightCorner": {
              "x": -15.271,
              "y": -28.777,
              "z": 0.624
            },
            "gtin": "8445290456410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c75",
            "leftCorner": {
              "x": -15.271,
              "y": -28.777,
              "z": 0.624
            },
            "rightCorner": {
              "x": -15.16,
              "y": -28.776,
              "z": 0.624
            },
            "gtin": "7613036306294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c76",
            "leftCorner": {
              "x": -15.16,
              "y": -28.777,
              "z": 0.624
            },
            "rightCorner": {
              "x": -14.972,
              "y": -28.775,
              "z": 0.624
            },
            "gtin": "4006581002606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c77",
            "leftCorner": {
              "x": -14.972,
              "y": -28.782,
              "z": 0.624
            },
            "rightCorner": {
              "x": -14.774,
              "y": -28.78,
              "z": 0.624
            },
            "gtin": "8711000669969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c78",
            "leftCorner": {
              "x": -14.774,
              "y": -28.776,
              "z": 0.624
            },
            "rightCorner": {
              "x": -14.461,
              "y": -28.774,
              "z": 0.624
            },
            "gtin": "8711000669990",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d64f",
        "height": 1.0647,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c39",
            "leftCorner": {
              "x": -15.809,
              "y": -28.818,
              "z": 0.871
            },
            "rightCorner": {
              "x": -15.645,
              "y": -28.816,
              "z": 0.871
            },
            "gtin": "7613033174704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c3b",
            "leftCorner": {
              "x": -15.645,
              "y": -28.776,
              "z": 0.871
            },
            "rightCorner": {
              "x": -15.511,
              "y": -28.775,
              "z": 0.871
            },
            "gtin": "7613033659782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c3c",
            "leftCorner": {
              "x": -15.511,
              "y": -28.772,
              "z": 0.871
            },
            "rightCorner": {
              "x": -15.356,
              "y": -28.77,
              "z": 0.871
            },
            "gtin": "7613037929485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c3d",
            "leftCorner": {
              "x": -15.356,
              "y": -28.77,
              "z": 0.871
            },
            "rightCorner": {
              "x": -15.279,
              "y": -28.77,
              "z": 0.871
            },
            "gtin": "8002730140874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c3e",
            "leftCorner": {
              "x": -15.279,
              "y": -28.772,
              "z": 0.871
            },
            "rightCorner": {
              "x": -15.143,
              "y": -28.77,
              "z": 0.871
            },
            "gtin": "8445291179301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c3f",
            "leftCorner": {
              "x": -15.143,
              "y": -28.771,
              "z": 0.871
            },
            "rightCorner": {
              "x": -15.043,
              "y": -28.77,
              "z": 0.871
            },
            "gtin": "4006581061054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c40",
            "leftCorner": {
              "x": -15.043,
              "y": -28.772,
              "z": 0.871
            },
            "rightCorner": {
              "x": -14.951,
              "y": -28.771,
              "z": 0.871
            },
            "gtin": "4006581061030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c41",
            "leftCorner": {
              "x": -14.951,
              "y": -28.78,
              "z": 0.871
            },
            "rightCorner": {
              "x": -14.84,
              "y": -28.779,
              "z": 0.871
            },
            "gtin": "7613036961608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c42",
            "leftCorner": {
              "x": -14.84,
              "y": -28.775,
              "z": 0.871
            },
            "rightCorner": {
              "x": -14.733,
              "y": -28.774,
              "z": 0.871
            },
            "gtin": "7613036961806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c43",
            "leftCorner": {
              "x": -14.733,
              "y": -28.772,
              "z": 0.871
            },
            "rightCorner": {
              "x": -14.623,
              "y": -28.771,
              "z": 0.871
            },
            "gtin": "8445291146655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c44",
            "leftCorner": {
              "x": -14.623,
              "y": -28.772,
              "z": 0.871
            },
            "rightCorner": {
              "x": -14.516,
              "y": -28.771,
              "z": 0.871
            },
            "gtin": "8445291149168",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d64c",
        "height": 1.3665,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c17",
            "leftCorner": {
              "x": -15.809,
              "y": -28.818,
              "z": 1.118
            },
            "rightCorner": {
              "x": -15.613,
              "y": -28.816,
              "z": 1.118
            },
            "gtin": "8711000485798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c19",
            "leftCorner": {
              "x": -15.613,
              "y": -28.778,
              "z": 1.118
            },
            "rightCorner": {
              "x": -15.475,
              "y": -28.777,
              "z": 1.118
            },
            "gtin": "8711000477571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c1a",
            "leftCorner": {
              "x": -15.475,
              "y": -28.775,
              "z": 1.118
            },
            "rightCorner": {
              "x": -15.307,
              "y": -28.774,
              "z": 1.118
            },
            "gtin": "8711000371190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c1b",
            "leftCorner": {
              "x": -15.307,
              "y": -28.773,
              "z": 1.118
            },
            "rightCorner": {
              "x": -15.12,
              "y": -28.772,
              "z": 1.118
            },
            "gtin": "8711000377505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c1c",
            "leftCorner": {
              "x": -15.12,
              "y": -28.77,
              "z": 1.118
            },
            "rightCorner": {
              "x": -14.945,
              "y": -28.768,
              "z": 1.118
            },
            "gtin": "8711000371237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c1d",
            "leftCorner": {
              "x": -14.945,
              "y": -28.779,
              "z": 1.118
            },
            "rightCorner": {
              "x": -14.73,
              "y": -28.777,
              "z": 1.118
            },
            "gtin": "8711000371251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c1e",
            "leftCorner": {
              "x": -14.73,
              "y": -28.772,
              "z": 1.118
            },
            "rightCorner": {
              "x": -14.653,
              "y": -28.771,
              "z": 1.118
            },
            "gtin": "4008167010500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c1f",
            "leftCorner": {
              "x": -14.653,
              "y": -28.769,
              "z": 1.118
            },
            "rightCorner": {
              "x": -14.546,
              "y": -28.768,
              "z": 1.118
            },
            "gtin": "4008167010609",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "826"
  },
  {
    "id": "826",
    "name": "826",
    "x": -14.559,
    "y": -28.787,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0047473,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 37,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d00b",
        "height": 0.17523,
        "facings": [
          {
            "id": "67b0ad6a8854af9c8fe7ff29",
            "leftCorner": {
              "x": -14.557,
              "y": -28.88,
              "z": 0.143
            },
            "rightCorner": {
              "x": -14.495,
              "y": -28.879,
              "z": 0.143
            },
            "gtin": "4008167011903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "55bda960d8a1a68dbc559338",
            "leftCorner": {
              "x": -14.495,
              "y": -28.879,
              "z": 0.143
            },
            "rightCorner": {
              "x": -14.433,
              "y": -28.879,
              "z": 0.143
            },
            "gtin": "4008167011903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6a75efa3a536ccaa7374534b",
            "leftCorner": {
              "x": -14.433,
              "y": -28.879,
              "z": 0.143
            },
            "rightCorner": {
              "x": -14.351,
              "y": -28.878,
              "z": 0.143
            },
            "gtin": "4008167011101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8ff280c1f910f5064ac6e0e4",
            "leftCorner": {
              "x": -14.351,
              "y": -28.878,
              "z": 0.143
            },
            "rightCorner": {
              "x": -14.25,
              "y": -28.877,
              "z": 0.143
            },
            "gtin": "8000070012783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "70c02bdf6b171ccea3f1c473",
            "leftCorner": {
              "x": -14.25,
              "y": -28.877,
              "z": 0.143
            },
            "rightCorner": {
              "x": -14.11,
              "y": -28.876,
              "z": 0.143
            },
            "gtin": "8711000504741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5adf9aaf81ac73eb59e0d3ab",
            "leftCorner": {
              "x": -14.11,
              "y": -28.876,
              "z": 0.143
            },
            "rightCorner": {
              "x": -13.96,
              "y": -28.874,
              "z": 0.143
            },
            "gtin": "8445291144811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "314a0d6cb9d5d2e75a0d29a9",
            "leftCorner": {
              "x": -13.96,
              "y": -28.874,
              "z": 0.143
            },
            "rightCorner": {
              "x": -13.809,
              "y": -28.873,
              "z": 0.143
            },
            "gtin": "8000070035980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3728d065bb93564bc5b99187",
            "leftCorner": {
              "x": -13.809,
              "y": -28.873,
              "z": 0.143
            },
            "rightCorner": {
              "x": -13.648,
              "y": -28.871,
              "z": 0.143
            },
            "gtin": "8711000708682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "14a14be7fec72de6a18b7a9b",
            "leftCorner": {
              "x": -13.648,
              "y": -28.871,
              "z": 0.143
            },
            "rightCorner": {
              "x": -13.485,
              "y": -28.87,
              "z": 0.143
            },
            "gtin": "4000161850120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a505090b4fd37e1380b73f56",
            "leftCorner": {
              "x": -13.485,
              "y": -28.87,
              "z": 0.143
            },
            "rightCorner": {
              "x": -13.322,
              "y": -28.868,
              "z": 0.143
            },
            "gtin": "4000161850120",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d009",
        "height": 0.45739,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c5f",
            "leftCorner": {
              "x": -14.502,
              "y": -28.797,
              "z": 0.374
            },
            "rightCorner": {
              "x": -14.355,
              "y": -28.795,
              "z": 0.374
            },
            "gtin": "8711000504741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c60",
            "leftCorner": {
              "x": -14.355,
              "y": -28.791,
              "z": 0.374
            },
            "rightCorner": {
              "x": -14.154,
              "y": -28.79,
              "z": 0.374
            },
            "gtin": "4006581020006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c61",
            "leftCorner": {
              "x": -14.154,
              "y": -28.791,
              "z": 0.374
            },
            "rightCorner": {
              "x": -14.036,
              "y": -28.79,
              "z": 0.374
            },
            "gtin": "4006581071466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c62",
            "leftCorner": {
              "x": -14.036,
              "y": -28.79,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.918,
              "y": -28.788,
              "z": 0.374
            },
            "gtin": "4006581071466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c63",
            "leftCorner": {
              "x": -13.918,
              "y": -28.787,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.701,
              "y": -28.785,
              "z": 0.374
            },
            "gtin": "4006581001753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c64",
            "leftCorner": {
              "x": -13.701,
              "y": -28.784,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.511,
              "y": -28.781,
              "z": 0.374
            },
            "gtin": "4006581017303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c65",
            "leftCorner": {
              "x": -13.511,
              "y": -28.783,
              "z": 0.374
            },
            "rightCorner": {
              "x": -13.225,
              "y": -28.781,
              "z": 0.374
            },
            "gtin": "4006581001777",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d00a",
        "height": 0.75753,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c7a",
            "leftCorner": {
              "x": -14.335,
              "y": -28.79,
              "z": 0.62
            },
            "rightCorner": {
              "x": -14.173,
              "y": -28.788,
              "z": 0.62
            },
            "gtin": "8711000708682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7cdef3e95586a110ed9423d7",
            "leftCorner": {
              "x": -14.558,
              "y": -28.832,
              "z": 0.62
            },
            "rightCorner": {
              "x": -14.337,
              "y": -28.83,
              "z": 0.62
            },
            "gtin": "8711000708712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c7b",
            "leftCorner": {
              "x": -14.173,
              "y": -28.788,
              "z": 0.62
            },
            "rightCorner": {
              "x": -13.969,
              "y": -28.787,
              "z": 0.62
            },
            "gtin": "8711000708651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c7c",
            "leftCorner": {
              "x": -13.969,
              "y": -28.786,
              "z": 0.62
            },
            "rightCorner": {
              "x": -13.746,
              "y": -28.784,
              "z": 0.62
            },
            "gtin": "8711000708712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c7d",
            "leftCorner": {
              "x": -13.746,
              "y": -28.783,
              "z": 0.62
            },
            "rightCorner": {
              "x": -13.494,
              "y": -28.781,
              "z": 0.62
            },
            "gtin": "4000508059087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c7e",
            "leftCorner": {
              "x": -13.494,
              "y": -28.78,
              "z": 0.62
            },
            "rightCorner": {
              "x": -13.145,
              "y": -28.777,
              "z": 0.62
            },
            "gtin": "4002720008096",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d008",
        "height": 1.0616,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c45",
            "leftCorner": {
              "x": -14.516,
              "y": -28.795,
              "z": 0.869
            },
            "rightCorner": {
              "x": -14.392,
              "y": -28.794,
              "z": 0.869
            },
            "gtin": "8445291144811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c46",
            "leftCorner": {
              "x": -14.392,
              "y": -28.792,
              "z": 0.869
            },
            "rightCorner": {
              "x": -14.174,
              "y": -28.789,
              "z": 0.869
            },
            "gtin": "4008167113713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c47",
            "leftCorner": {
              "x": -14.174,
              "y": -28.793,
              "z": 0.869
            },
            "rightCorner": {
              "x": -13.81,
              "y": -28.789,
              "z": 0.869
            },
            "gtin": "4008167103905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c48",
            "leftCorner": {
              "x": -13.81,
              "y": -28.784,
              "z": 0.869
            },
            "rightCorner": {
              "x": -13.59,
              "y": -28.783,
              "z": 0.869
            },
            "gtin": "4008167103714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c49",
            "leftCorner": {
              "x": -13.59,
              "y": -28.784,
              "z": 0.869
            },
            "rightCorner": {
              "x": -13.227,
              "y": -28.78,
              "z": 0.869
            },
            "gtin": "8000070069886",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d007",
        "height": 1.3627,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c20",
            "leftCorner": {
              "x": -14.546,
              "y": -28.789,
              "z": 1.115
            },
            "rightCorner": {
              "x": -14.491,
              "y": -28.788,
              "z": 1.115
            },
            "gtin": "4008167010807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c21",
            "leftCorner": {
              "x": -14.491,
              "y": -28.787,
              "z": 1.115
            },
            "rightCorner": {
              "x": -14.409,
              "y": -28.787,
              "z": 1.115
            },
            "gtin": "4008167010807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c22",
            "leftCorner": {
              "x": -14.409,
              "y": -28.787,
              "z": 1.115
            },
            "rightCorner": {
              "x": -14.325,
              "y": -28.785,
              "z": 1.115
            },
            "gtin": "4008167011101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c23",
            "leftCorner": {
              "x": -14.325,
              "y": -28.789,
              "z": 1.115
            },
            "rightCorner": {
              "x": -14.172,
              "y": -28.788,
              "z": 1.115
            },
            "gtin": "8000070035980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c24",
            "leftCorner": {
              "x": -14.172,
              "y": -28.791,
              "z": 1.115
            },
            "rightCorner": {
              "x": -13.926,
              "y": -28.788,
              "z": 1.115
            },
            "gtin": "8000070038868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c25",
            "leftCorner": {
              "x": -13.926,
              "y": -28.789,
              "z": 1.115
            },
            "rightCorner": {
              "x": -13.827,
              "y": -28.788,
              "z": 1.115
            },
            "gtin": "8000070012783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c26",
            "leftCorner": {
              "x": -13.827,
              "y": -28.788,
              "z": 1.115
            },
            "rightCorner": {
              "x": -13.647,
              "y": -28.786,
              "z": 1.115
            },
            "gtin": "8000070012837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c27",
            "leftCorner": {
              "x": -13.647,
              "y": -28.786,
              "z": 1.115
            },
            "rightCorner": {
              "x": -13.487,
              "y": -28.785,
              "z": 1.115
            },
            "gtin": "4000161850120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c28",
            "leftCorner": {
              "x": -13.487,
              "y": -28.788,
              "z": 1.115
            },
            "rightCorner": {
              "x": -13.281,
              "y": -28.786,
              "z": 1.115
            },
            "gtin": "4000161850137",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "824",
    "rightNeighborShelfId": "827"
  },
  {
    "id": "827",
    "name": "827",
    "x": -13.309,
    "y": -28.775,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0047473,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d010",
        "height": 0.17287,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c98",
            "leftCorner": {
              "x": -12.324,
              "y": -28.829,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.187,
              "y": -28.827,
              "z": 0.141
            },
            "gtin": "4008167152729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9dc3320cde64ea719d592b79",
            "leftCorner": {
              "x": -13.308,
              "y": -28.868,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.201,
              "y": -28.867,
              "z": 0.141
            },
            "gtin": "4002720001233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1e24ea05f92c8e291909ec7d",
            "leftCorner": {
              "x": -13.201,
              "y": -28.867,
              "z": 0.141
            },
            "rightCorner": {
              "x": -13.087,
              "y": -28.866,
              "z": 0.141
            },
            "gtin": "8000070075160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "84e5e2bf379779c60469e932",
            "leftCorner": {
              "x": -13.087,
              "y": -28.866,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.953,
              "y": -28.865,
              "z": 0.141
            },
            "gtin": "8000070038370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bd205c0d7c3906a3ebe1cbd1",
            "leftCorner": {
              "x": -12.953,
              "y": -28.865,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.812,
              "y": -28.863,
              "z": 0.141
            },
            "gtin": "8000070009745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "539cbac29faea490cfbc37b4",
            "leftCorner": {
              "x": -12.812,
              "y": -28.863,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.665,
              "y": -28.862,
              "z": 0.141
            },
            "gtin": "8000070051003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "793f95ededa88c673fa5dcc1",
            "leftCorner": {
              "x": -12.665,
              "y": -28.862,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.515,
              "y": -28.86,
              "z": 0.141
            },
            "gtin": "4006581020686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8bd453276ec385c22951b38b",
            "leftCorner": {
              "x": -12.515,
              "y": -28.86,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.329,
              "y": -28.859,
              "z": 0.141
            },
            "gtin": "8000070038271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c99",
            "leftCorner": {
              "x": -12.186,
              "y": -28.831,
              "z": 0.141
            },
            "rightCorner": {
              "x": -12.058,
              "y": -28.83,
              "z": 0.141
            },
            "gtin": "4006581170060",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d00f",
        "height": 0.4596,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c66",
            "leftCorner": {
              "x": -13.226,
              "y": -28.781,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.901,
              "y": -28.778,
              "z": 0.376
            },
            "gtin": "4002720002117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c67",
            "leftCorner": {
              "x": -12.9,
              "y": -28.774,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.702,
              "y": -28.772,
              "z": 0.376
            },
            "gtin": "4002720002100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c68",
            "leftCorner": {
              "x": -12.702,
              "y": -28.765,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.531,
              "y": -28.763,
              "z": 0.376
            },
            "gtin": "4002720000496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c69",
            "leftCorner": {
              "x": -12.531,
              "y": -28.763,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.33,
              "y": -28.762,
              "z": 0.376
            },
            "gtin": "4002720002353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c6a",
            "leftCorner": {
              "x": -12.33,
              "y": -28.76,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.165,
              "y": -28.758,
              "z": 0.376
            },
            "gtin": "4002720001226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c6b",
            "leftCorner": {
              "x": -12.166,
              "y": -28.772,
              "z": 0.376
            },
            "rightCorner": {
              "x": -12.002,
              "y": -28.77,
              "z": 0.376
            },
            "gtin": "4002720001233",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d00d",
        "height": 0.76073,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c7f",
            "leftCorner": {
              "x": -13.145,
              "y": -28.783,
              "z": 0.622
            },
            "rightCorner": {
              "x": -12.839,
              "y": -28.78,
              "z": 0.622
            },
            "gtin": "4002720008102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "eb00d8edd282fcf63bbb2441",
            "leftCorner": {
              "x": -13.308,
              "y": -28.819,
              "z": 0.622
            },
            "rightCorner": {
              "x": -13.151,
              "y": -28.817,
              "z": 0.622
            },
            "gtin": "4002720008096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c80",
            "leftCorner": {
              "x": -12.839,
              "y": -28.772,
              "z": 0.622
            },
            "rightCorner": {
              "x": -12.468,
              "y": -28.769,
              "z": 0.622
            },
            "gtin": "4002720008027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c81",
            "leftCorner": {
              "x": -12.468,
              "y": -28.767,
              "z": 0.622
            },
            "rightCorner": {
              "x": -12.228,
              "y": -28.765,
              "z": 0.622
            },
            "gtin": "4002720008164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c82",
            "leftCorner": {
              "x": -12.228,
              "y": -28.771,
              "z": 0.622
            },
            "rightCorner": {
              "x": -12.059,
              "y": -28.769,
              "z": 0.622
            },
            "gtin": "4002720008508",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d00e",
        "height": 1.0613,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c4a",
            "leftCorner": {
              "x": -13.228,
              "y": -28.785,
              "z": 0.868
            },
            "rightCorner": {
              "x": -12.995,
              "y": -28.783,
              "z": 0.868
            },
            "gtin": "8000070027336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c4b",
            "leftCorner": {
              "x": -12.995,
              "y": -28.78,
              "z": 0.868
            },
            "rightCorner": {
              "x": -12.572,
              "y": -28.776,
              "z": 0.868
            },
            "gtin": "8000070025400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c4c",
            "leftCorner": {
              "x": -12.572,
              "y": -28.77,
              "z": 0.868
            },
            "rightCorner": {
              "x": -12.282,
              "y": -28.768,
              "z": 0.868
            },
            "gtin": "8000070027701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c4d",
            "leftCorner": {
              "x": -12.282,
              "y": -28.772,
              "z": 0.868
            },
            "rightCorner": {
              "x": -12.032,
              "y": -28.769,
              "z": 0.868
            },
            "gtin": "8000070027411",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d00c",
        "height": 1.3642,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c29",
            "leftCorner": {
              "x": -13.281,
              "y": -28.788,
              "z": 1.116
            },
            "rightCorner": {
              "x": -13.116,
              "y": -28.787,
              "z": 1.116
            },
            "gtin": "4006581020686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c2a",
            "leftCorner": {
              "x": -13.116,
              "y": -28.787,
              "z": 1.116
            },
            "rightCorner": {
              "x": -12.974,
              "y": -28.784,
              "z": 1.116
            },
            "gtin": "8000070009745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c2b",
            "leftCorner": {
              "x": -12.974,
              "y": -28.781,
              "z": 1.116
            },
            "rightCorner": {
              "x": -12.842,
              "y": -28.78,
              "z": 1.116
            },
            "gtin": "8000070038370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c2c",
            "leftCorner": {
              "x": -12.842,
              "y": -28.778,
              "z": 1.116
            },
            "rightCorner": {
              "x": -12.686,
              "y": -28.777,
              "z": 1.116
            },
            "gtin": "8000070027350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c2d",
            "leftCorner": {
              "x": -12.686,
              "y": -28.775,
              "z": 1.116
            },
            "rightCorner": {
              "x": -12.5,
              "y": -28.772,
              "z": 1.116
            },
            "gtin": "8000070035898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c2e",
            "leftCorner": {
              "x": -12.5,
              "y": -28.771,
              "z": 1.116
            },
            "rightCorner": {
              "x": -12.351,
              "y": -28.77,
              "z": 1.116
            },
            "gtin": "8000070051003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c2f",
            "leftCorner": {
              "x": -12.351,
              "y": -28.77,
              "z": 1.116
            },
            "rightCorner": {
              "x": -12.165,
              "y": -28.768,
              "z": 1.116
            },
            "gtin": "8000070038271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c30",
            "leftCorner": {
              "x": -12.165,
              "y": -28.782,
              "z": 1.116
            },
            "rightCorner": {
              "x": -11.991,
              "y": -28.78,
              "z": 1.116
            },
            "gtin": "8000070075160",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "826",
    "rightNeighborShelfId": "828"
  },
  {
    "id": "828",
    "name": "828",
    "x": -12.059,
    "y": -28.763,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0047473,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 37,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d016",
        "height": 0.18057,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c9e",
            "leftCorner": {
              "x": -11.335,
              "y": -28.652,
              "z": 0.148
            },
            "rightCorner": {
              "x": -11.009,
              "y": -28.649,
              "z": 0.148
            },
            "gtin": "21427721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "18567e81107202338388705c",
            "leftCorner": {
              "x": -12.059,
              "y": -28.839,
              "z": 0.148
            },
            "rightCorner": {
              "x": -11.804,
              "y": -28.837,
              "z": 0.148
            },
            "gtin": "8711000509470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5dd2b3b77f0ca67b4cb88e27",
            "leftCorner": {
              "x": -11.804,
              "y": -28.837,
              "z": 0.148
            },
            "rightCorner": {
              "x": -11.722,
              "y": -28.836,
              "z": 0.148
            },
            "gtin": "4260415491398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a5e31debf159dbdd02cd3a7b",
            "leftCorner": {
              "x": -11.722,
              "y": -28.836,
              "z": 0.148
            },
            "rightCorner": {
              "x": -11.637,
              "y": -28.835,
              "z": 0.148
            },
            "gtin": "4260415491206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ba0583140fe0f15d22913edb",
            "leftCorner": {
              "x": -11.637,
              "y": -28.835,
              "z": 0.148
            },
            "rightCorner": {
              "x": -11.366,
              "y": -28.832,
              "z": 0.148
            },
            "gtin": "8711000683453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e6b44a2af359caafb6db165a",
            "leftCorner": {
              "x": -11.008,
              "y": -28.829,
              "z": 0.148
            },
            "rightCorner": {
              "x": -10.828,
              "y": -28.827,
              "z": 0.148
            },
            "gtin": "4260415491312",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d014",
        "height": 0.46283,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c6c",
            "leftCorner": {
              "x": -12.002,
              "y": -28.776,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.887,
              "y": -28.775,
              "z": 0.379
            },
            "gtin": "8711000683453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c6e",
            "leftCorner": {
              "x": -11.738,
              "y": -28.77,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.413,
              "y": -28.766,
              "z": 0.379
            },
            "gtin": "8711000891704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c6f",
            "leftCorner": {
              "x": -11.413,
              "y": -28.765,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.259,
              "y": -28.764,
              "z": 0.379
            },
            "gtin": "8711000891735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c56",
            "leftCorner": {
              "x": -11.259,
              "y": -28.773,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.109,
              "y": -28.771,
              "z": 0.379
            },
            "gtin": "8711000685761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8ebe2096da30e4c23d948f2d",
            "leftCorner": {
              "x": -11.887,
              "y": -28.811,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.742,
              "y": -28.81,
              "z": 0.379
            },
            "gtin": "8711000891735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c57",
            "leftCorner": {
              "x": -11.109,
              "y": -28.771,
              "z": 0.379
            },
            "rightCorner": {
              "x": -10.959,
              "y": -28.77,
              "z": 0.379
            },
            "gtin": "8711000685761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c58",
            "leftCorner": {
              "x": -10.959,
              "y": -28.77,
              "z": 0.379
            },
            "rightCorner": {
              "x": -10.809,
              "y": -28.768,
              "z": 0.379
            },
            "gtin": "8711000685761",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d011",
        "height": 0.76129,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c83",
            "leftCorner": {
              "x": -12.059,
              "y": -28.773,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.912,
              "y": -28.775,
              "z": 0.623
            },
            "gtin": "4002720009741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c84",
            "leftCorner": {
              "x": -11.911,
              "y": -28.774,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.738,
              "y": -28.771,
              "z": 0.623
            },
            "gtin": "4002720009741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c85",
            "leftCorner": {
              "x": -11.738,
              "y": -28.769,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.521,
              "y": -28.767,
              "z": 0.623
            },
            "gtin": "4002720009727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c86",
            "leftCorner": {
              "x": -11.521,
              "y": -28.769,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.369,
              "y": -28.768,
              "z": 0.623
            },
            "gtin": "4002720001219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c87",
            "leftCorner": {
              "x": -11.369,
              "y": -28.768,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.199,
              "y": -28.767,
              "z": 0.623
            },
            "gtin": "4260457111124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c88",
            "leftCorner": {
              "x": -11.199,
              "y": -28.762,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.076,
              "y": -28.76,
              "z": 0.623
            },
            "gtin": "4260457111117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c71",
            "leftCorner": {
              "x": -11.076,
              "y": -28.759,
              "z": 0.623
            },
            "rightCorner": {
              "x": -10.809,
              "y": -28.756,
              "z": 0.623
            },
            "gtin": "4260457111056",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d012",
        "height": 1.0644,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c4e",
            "leftCorner": {
              "x": -12.032,
              "y": -28.78,
              "z": 0.871
            },
            "rightCorner": {
              "x": -11.761,
              "y": -28.777,
              "z": 0.871
            },
            "gtin": "8000070027435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c4f",
            "leftCorner": {
              "x": -11.755,
              "y": -28.771,
              "z": 0.871
            },
            "rightCorner": {
              "x": -11.551,
              "y": -28.77,
              "z": 0.871
            },
            "gtin": "4260415491329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c50",
            "leftCorner": {
              "x": -11.551,
              "y": -28.769,
              "z": 0.871
            },
            "rightCorner": {
              "x": -11.368,
              "y": -28.767,
              "z": 0.871
            },
            "gtin": "4260415491312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c51",
            "leftCorner": {
              "x": -11.368,
              "y": -28.766,
              "z": 0.871
            },
            "rightCorner": {
              "x": -11.26,
              "y": -28.765,
              "z": 0.871
            },
            "gtin": "4260415491381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c52",
            "leftCorner": {
              "x": -11.26,
              "y": -28.761,
              "z": 0.871
            },
            "rightCorner": {
              "x": -11.132,
              "y": -28.76,
              "z": 0.871
            },
            "gtin": "4260415491251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c53",
            "leftCorner": {
              "x": -11.132,
              "y": -28.757,
              "z": 0.871
            },
            "rightCorner": {
              "x": -11.022,
              "y": -28.756,
              "z": 0.871
            },
            "gtin": "4260415491374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c54",
            "leftCorner": {
              "x": -11.022,
              "y": -28.755,
              "z": 0.871
            },
            "rightCorner": {
              "x": -10.91,
              "y": -28.754,
              "z": 0.871
            },
            "gtin": "4260415491282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c3a",
            "leftCorner": {
              "x": -10.91,
              "y": -28.751,
              "z": 0.871
            },
            "rightCorner": {
              "x": -10.809,
              "y": -28.749,
              "z": 0.871
            },
            "gtin": "4260415491206",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d013",
        "height": 1.369,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c31",
            "leftCorner": {
              "x": -11.991,
              "y": -28.777,
              "z": 1.12
            },
            "rightCorner": {
              "x": -11.889,
              "y": -28.776,
              "z": 1.12
            },
            "gtin": "8000070027442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c33",
            "leftCorner": {
              "x": -11.767,
              "y": -28.773,
              "z": 1.12
            },
            "rightCorner": {
              "x": -11.619,
              "y": -28.772,
              "z": 1.12
            },
            "gtin": "4260415491602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c34",
            "leftCorner": {
              "x": -11.619,
              "y": -28.77,
              "z": 1.12
            },
            "rightCorner": {
              "x": -11.5,
              "y": -28.768,
              "z": 1.12
            },
            "gtin": "4260415491503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c35",
            "leftCorner": {
              "x": -11.5,
              "y": -28.773,
              "z": 1.12
            },
            "rightCorner": {
              "x": -11.341,
              "y": -28.772,
              "z": 1.12
            },
            "gtin": "4260415491510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c36",
            "leftCorner": {
              "x": -11.341,
              "y": -28.767,
              "z": 1.12
            },
            "rightCorner": {
              "x": -11.203,
              "y": -28.766,
              "z": 1.12
            },
            "gtin": "4260415491558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c37",
            "leftCorner": {
              "x": -11.203,
              "y": -28.762,
              "z": 1.12
            },
            "rightCorner": {
              "x": -11.057,
              "y": -28.76,
              "z": 1.12
            },
            "gtin": "4260415491619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c38",
            "leftCorner": {
              "x": -11.057,
              "y": -28.759,
              "z": 1.12
            },
            "rightCorner": {
              "x": -10.901,
              "y": -28.758,
              "z": 1.12
            },
            "gtin": "4260415491589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c18",
            "leftCorner": {
              "x": -10.901,
              "y": -28.755,
              "z": 1.12
            },
            "rightCorner": {
              "x": -10.809,
              "y": -28.753,
              "z": 1.12
            },
            "gtin": "4260415491398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "64202d51a523ba9ada2b416a",
            "leftCorner": {
              "x": -11.889,
              "y": -28.81,
              "z": 1.12
            },
            "rightCorner": {
              "x": -11.807,
              "y": -28.81,
              "z": 1.12
            },
            "gtin": "4260415491398",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "827"
  },
  {
    "id": "829",
    "name": "829",
    "x": -10.206,
    "y": -28.761,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70817,
      "w": 0.70604
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 15
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d655",
        "height": 0.17154,
        "facings": [
          {
            "id": "0486f6a31c63201df61aeb6f",
            "leftCorner": {
              "x": -10.115,
              "y": -28.761,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.115,
              "y": -28.628,
              "z": 0.14
            },
            "gtin": "4260499772994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cef8328df164bc6b37462f37",
            "leftCorner": {
              "x": -10.115,
              "y": -28.628,
              "z": 0.14
            },
            "rightCorner": {
              "x": -10.117,
              "y": -28.148,
              "z": 0.14
            },
            "gtin": "4260499772987",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d654",
        "height": 0.50625,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d85fa",
            "leftCorner": {
              "x": -10.146,
              "y": -28.761,
              "z": 0.414
            },
            "rightCorner": {
              "x": -10.146,
              "y": -28.507,
              "z": 0.414
            },
            "gtin": "4260499770976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85fc",
            "leftCorner": {
              "x": -10.188,
              "y": -28.507,
              "z": 0.414
            },
            "rightCorner": {
              "x": -10.19,
              "y": -28.335,
              "z": 0.414
            },
            "gtin": "4260499771980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85fb",
            "leftCorner": {
              "x": -10.186,
              "y": -28.335,
              "z": 0.414
            },
            "rightCorner": {
              "x": -10.186,
              "y": -28.131,
              "z": 0.414
            },
            "gtin": "4260499771997",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d653",
        "height": 0.83171,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d85f6",
            "leftCorner": {
              "x": -10.157,
              "y": -28.761,
              "z": 0.68
            },
            "rightCorner": {
              "x": -10.157,
              "y": -28.605,
              "z": 0.68
            },
            "gtin": "4260499770945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85f7",
            "leftCorner": {
              "x": -10.207,
              "y": -28.605,
              "z": 0.68
            },
            "rightCorner": {
              "x": -10.207,
              "y": -28.449,
              "z": 0.68
            },
            "gtin": "4260499770952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85f8",
            "leftCorner": {
              "x": -10.197,
              "y": -28.449,
              "z": 0.68
            },
            "rightCorner": {
              "x": -10.198,
              "y": -28.303,
              "z": 0.68
            },
            "gtin": "4260499770259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85f9",
            "leftCorner": {
              "x": -10.198,
              "y": -28.303,
              "z": 0.68
            },
            "rightCorner": {
              "x": -10.198,
              "y": -28.128,
              "z": 0.68
            },
            "gtin": "4260499770266",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d652",
        "height": 1.1571,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d85f3",
            "leftCorner": {
              "x": -10.161,
              "y": -28.761,
              "z": 0.947
            },
            "rightCorner": {
              "x": -10.161,
              "y": -28.47,
              "z": 0.947
            },
            "gtin": "4260499771898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85f5",
            "leftCorner": {
              "x": -10.201,
              "y": -28.47,
              "z": 0.947
            },
            "rightCorner": {
              "x": -10.202,
              "y": -28.282,
              "z": 0.947
            },
            "gtin": "4260499771904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85f4",
            "leftCorner": {
              "x": -10.2,
              "y": -28.282,
              "z": 0.947
            },
            "rightCorner": {
              "x": -10.2,
              "y": -28.131,
              "z": 0.947
            },
            "gtin": "4260499772550",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d651",
        "height": 1.4845,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d85f0",
            "leftCorner": {
              "x": -10.155,
              "y": -28.761,
              "z": 1.215
            },
            "rightCorner": {
              "x": -10.155,
              "y": -28.468,
              "z": 1.215
            },
            "gtin": "4260499772918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85f2",
            "leftCorner": {
              "x": -10.196,
              "y": -28.468,
              "z": 1.215
            },
            "rightCorner": {
              "x": -10.197,
              "y": -28.304,
              "z": 1.215
            },
            "gtin": "4260499772925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d85f1",
            "leftCorner": {
              "x": -10.196,
              "y": -28.304,
              "z": 1.215
            },
            "rightCorner": {
              "x": -10.197,
              "y": -28.131,
              "z": 1.215
            },
            "gtin": "4260499772932",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "82a"
  },
  {
    "id": "82a",
    "name": "82a",
    "x": -10.208,
    "y": -28.136,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70817,
      "w": 0.70604
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d65a",
        "height": 0.17181,
        "facings": [
          {
            "id": "8b81afeb44fdff238b450315",
            "leftCorner": {
              "x": -10.17,
              "y": -28.135,
              "z": 0.141
            },
            "rightCorner": {
              "x": -10.171,
              "y": -27.821,
              "z": 0.141
            },
            "gtin": "4260499773014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6c99d1c3cbfcf4c93ea7ce43",
            "leftCorner": {
              "x": -10.171,
              "y": -27.821,
              "z": 0.141
            },
            "rightCorner": {
              "x": -10.172,
              "y": -27.506,
              "z": 0.141
            },
            "gtin": "4260499773014",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d657",
        "height": 0.51369,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8601",
            "leftCorner": {
              "x": -10.192,
              "y": -28.136,
              "z": 0.42
            },
            "rightCorner": {
              "x": -10.193,
              "y": -27.736,
              "z": 0.42
            },
            "gtin": "4260499773632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8602",
            "leftCorner": {
              "x": -10.234,
              "y": -27.736,
              "z": 0.42
            },
            "rightCorner": {
              "x": -10.234,
              "y": -27.505,
              "z": 0.42
            },
            "gtin": "4260499773649",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d65b",
        "height": 0.70236,
        "facings": [
          {
            "id": "716aef3546ab0bc915c25b28",
            "leftCorner": {
              "x": -10.291,
              "y": -28.136,
              "z": 0.575
            },
            "rightCorner": {
              "x": -10.292,
              "y": -27.781,
              "z": 0.575
            },
            "gtin": "4260499770228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4da59b91ebf96fa70e2bc1d7",
            "leftCorner": {
              "x": -10.292,
              "y": -27.781,
              "z": 0.575
            },
            "rightCorner": {
              "x": -10.293,
              "y": -27.535,
              "z": 0.575
            },
            "gtin": "4260499772314",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d659",
        "height": 0.83006,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8606",
            "leftCorner": {
              "x": -10.207,
              "y": -28.136,
              "z": 0.679
            },
            "rightCorner": {
              "x": -10.208,
              "y": -27.729,
              "z": 0.679
            },
            "gtin": "4260499770235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8607",
            "leftCorner": {
              "x": -10.248,
              "y": -27.728,
              "z": 0.679
            },
            "rightCorner": {
              "x": -10.249,
              "y": -27.505,
              "z": 0.679
            },
            "gtin": "4260499770235",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d656",
        "height": 1.1567,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d85ff",
            "leftCorner": {
              "x": -10.204,
              "y": -28.136,
              "z": 0.946
            },
            "rightCorner": {
              "x": -10.206,
              "y": -27.7,
              "z": 0.946
            },
            "gtin": "4260499772567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8600",
            "leftCorner": {
              "x": -10.246,
              "y": -27.701,
              "z": 0.946
            },
            "rightCorner": {
              "x": -10.246,
              "y": -27.505,
              "z": 0.946
            },
            "gtin": "4260499770136",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d658",
        "height": 1.4867,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8603",
            "leftCorner": {
              "x": -10.205,
              "y": -28.136,
              "z": 1.216
            },
            "rightCorner": {
              "x": -10.206,
              "y": -27.7,
              "z": 1.216
            },
            "gtin": "4260499772949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8605",
            "leftCorner": {
              "x": -10.246,
              "y": -27.7,
              "z": 1.216
            },
            "rightCorner": {
              "x": -10.247,
              "y": -27.629,
              "z": 1.216
            },
            "gtin": "4260499772314",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "829"
  },
  {
    "id": "82c",
    "name": "82c",
    "x": -16.339,
    "y": -27.621,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.7092,
      "w": 0.70501
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 17,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d005",
        "height": 0.24513,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c12",
            "leftCorner": {
              "x": -16.596,
              "y": -27.619,
              "z": 0.201
            },
            "rightCorner": {
              "x": -16.599,
              "y": -28.209,
              "z": 0.201
            },
            "gtin": "4002720008300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c13",
            "leftCorner": {
              "x": -16.559,
              "y": -28.21,
              "z": 0.201
            },
            "rightCorner": {
              "x": -16.563,
              "y": -28.87,
              "z": 0.201
            },
            "gtin": "4002720008300",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d004",
        "height": 0.5791,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c0d",
            "leftCorner": {
              "x": -16.408,
              "y": -27.62,
              "z": 0.474
            },
            "rightCorner": {
              "x": -16.41,
              "y": -27.905,
              "z": 0.474
            },
            "gtin": "4052700072951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c0e",
            "leftCorner": {
              "x": -16.41,
              "y": -27.905,
              "z": 0.474
            },
            "rightCorner": {
              "x": -16.411,
              "y": -28.19,
              "z": 0.474
            },
            "gtin": "4052700072951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c10",
            "leftCorner": {
              "x": -16.374,
              "y": -28.191,
              "z": 0.474
            },
            "rightCorner": {
              "x": -16.376,
              "y": -28.376,
              "z": 0.474
            },
            "gtin": "4052700069746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c11",
            "leftCorner": {
              "x": -16.376,
              "y": -28.376,
              "z": 0.474
            },
            "rightCorner": {
              "x": -16.377,
              "y": -28.561,
              "z": 0.474
            },
            "gtin": "4052700069746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c0f",
            "leftCorner": {
              "x": -16.371,
              "y": -28.561,
              "z": 0.474
            },
            "rightCorner": {
              "x": -16.373,
              "y": -28.871,
              "z": 0.474
            },
            "gtin": "4052700068398",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d003",
        "height": 0.85541,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c06",
            "leftCorner": {
              "x": -16.408,
              "y": -27.62,
              "z": 0.7
            },
            "rightCorner": {
              "x": -16.41,
              "y": -28.003,
              "z": 0.7
            },
            "gtin": "8711000578261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c0c",
            "leftCorner": {
              "x": -16.37,
              "y": -28.004,
              "z": 0.7
            },
            "rightCorner": {
              "x": -16.371,
              "y": -28.242,
              "z": 0.7
            },
            "gtin": "8711000578384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c07",
            "leftCorner": {
              "x": -16.372,
              "y": -28.242,
              "z": 0.7
            },
            "rightCorner": {
              "x": -16.374,
              "y": -28.368,
              "z": 0.7
            },
            "gtin": "4000508040306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c08",
            "leftCorner": {
              "x": -16.374,
              "y": -28.368,
              "z": 0.7
            },
            "rightCorner": {
              "x": -16.374,
              "y": -28.494,
              "z": 0.7
            },
            "gtin": "4000508040306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c09",
            "leftCorner": {
              "x": -16.374,
              "y": -28.494,
              "z": 0.7
            },
            "rightCorner": {
              "x": -16.375,
              "y": -28.62,
              "z": 0.7
            },
            "gtin": "4000508040306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c0a",
            "leftCorner": {
              "x": -16.375,
              "y": -28.62,
              "z": 0.7
            },
            "rightCorner": {
              "x": -16.376,
              "y": -28.745,
              "z": 0.7
            },
            "gtin": "4000508040306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c0b",
            "leftCorner": {
              "x": -16.376,
              "y": -28.745,
              "z": 0.7
            },
            "rightCorner": {
              "x": -16.377,
              "y": -28.871,
              "z": 0.7
            },
            "gtin": "4000508040306",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d006",
        "height": 1.5667,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c14",
            "leftCorner": {
              "x": -16.406,
              "y": -27.62,
              "z": 1.282
            },
            "rightCorner": {
              "x": -16.408,
              "y": -27.955,
              "z": 1.282
            },
            "gtin": "4021155170932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "27ed4901d9642e3aa7a4c48d",
            "leftCorner": {
              "x": -16.41,
              "y": -28.29,
              "z": 1.282
            },
            "rightCorner": {
              "x": -16.412,
              "y": -28.639,
              "z": 1.282
            },
            "gtin": "4021155170932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5c15",
            "leftCorner": {
              "x": -16.408,
              "y": -27.955,
              "z": 1.282
            },
            "rightCorner": {
              "x": -16.41,
              "y": -28.29,
              "z": 1.282
            },
            "gtin": "4021155170932",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "82d",
    "name": "82d",
    "x": -14.499,
    "y": -30.494,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0068678
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 37,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d02b",
        "height": 0.17399,
        "facings": [
          {
            "id": "0fc8d84f665b738c54316031",
            "leftCorner": {
              "x": -14.501,
              "y": -30.395,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.565,
              "y": -30.396,
              "z": 0.142
            },
            "gtin": "8000070053526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5e0d02c57d45d5fa18e76832",
            "leftCorner": {
              "x": -14.565,
              "y": -30.396,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.648,
              "y": -30.397,
              "z": 0.142
            },
            "gtin": "8711000851937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3efa316db1b55d4908e3858c",
            "leftCorner": {
              "x": -14.648,
              "y": -30.397,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.738,
              "y": -30.398,
              "z": 0.142
            },
            "gtin": "8711000452530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "abd1ecc25be5bb7567674013",
            "leftCorner": {
              "x": -14.738,
              "y": -30.398,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.839,
              "y": -30.4,
              "z": 0.142
            },
            "gtin": "8000070053571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7c2e670229eb1e5c8d6e6973",
            "leftCorner": {
              "x": -14.839,
              "y": -30.4,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.944,
              "y": -30.401,
              "z": 0.142
            },
            "gtin": "4002720001752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ea40142e323f8584c06f6651",
            "leftCorner": {
              "x": -14.944,
              "y": -30.401,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.063,
              "y": -30.403,
              "z": 0.142
            },
            "gtin": "8711000452509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fa0f1336ff043c589fea0d37",
            "leftCorner": {
              "x": -15.063,
              "y": -30.403,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.189,
              "y": -30.404,
              "z": 0.142
            },
            "gtin": "4047046008436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9cfb866e7b440721358d7b8a",
            "leftCorner": {
              "x": -15.189,
              "y": -30.404,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.316,
              "y": -30.406,
              "z": 0.142
            },
            "gtin": "8711000452745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "33c96898b150c4dbe68d4a71",
            "leftCorner": {
              "x": -15.316,
              "y": -30.406,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.453,
              "y": -30.408,
              "z": 0.142
            },
            "gtin": "7613036600996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "45f0694d3e03b38571fbdf04",
            "leftCorner": {
              "x": -15.453,
              "y": -30.408,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.673,
              "y": -30.411,
              "z": 0.142
            },
            "gtin": "8032872605016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3088328d0277092c7cf12174",
            "leftCorner": {
              "x": -15.673,
              "y": -30.411,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.737,
              "y": -30.412,
              "z": 0.142
            },
            "gtin": "8000070053526",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d02a",
        "height": 0.45879,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d07",
            "leftCorner": {
              "x": -14.576,
              "y": -30.488,
              "z": 0.375
            },
            "rightCorner": {
              "x": -14.773,
              "y": -30.49,
              "z": 0.375
            },
            "gtin": "8711000452653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d08",
            "leftCorner": {
              "x": -14.773,
              "y": -30.492,
              "z": 0.375
            },
            "rightCorner": {
              "x": -14.87,
              "y": -30.494,
              "z": 0.375
            },
            "gtin": "8711000452530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d09",
            "leftCorner": {
              "x": -14.87,
              "y": -30.492,
              "z": 0.375
            },
            "rightCorner": {
              "x": -15.168,
              "y": -30.496,
              "z": 0.375
            },
            "gtin": "8711000452479",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d5d0a",
            "leftCorner": {
              "x": -15.168,
              "y": -30.496,
              "z": 0.375
            },
            "rightCorner": {
              "x": -15.638,
              "y": -30.503,
              "z": 0.375
            },
            "gtin": "8711000452448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cf8",
            "leftCorner": {
              "x": -15.638,
              "y": -30.516,
              "z": 0.375
            },
            "rightCorner": {
              "x": -15.749,
              "y": -30.516,
              "z": 0.375
            },
            "gtin": "8711000452509",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d029",
        "height": 0.75723,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d1c",
            "leftCorner": {
              "x": -14.577,
              "y": -30.492,
              "z": 0.62
            },
            "rightCorner": {
              "x": -14.728,
              "y": -30.495,
              "z": 0.62
            },
            "gtin": "8711000468128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d1d",
            "leftCorner": {
              "x": -14.728,
              "y": -30.494,
              "z": 0.62
            },
            "rightCorner": {
              "x": -14.89,
              "y": -30.496,
              "z": 0.62
            },
            "gtin": "4047046005008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d1e",
            "leftCorner": {
              "x": -14.89,
              "y": -30.497,
              "z": 0.62
            },
            "rightCorner": {
              "x": -15.052,
              "y": -30.5,
              "z": 0.62
            },
            "gtin": "8711000688021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d1f",
            "leftCorner": {
              "x": -15.052,
              "y": -30.496,
              "z": 0.62
            },
            "rightCorner": {
              "x": -15.177,
              "y": -30.497,
              "z": 0.62
            },
            "gtin": "8711000452745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d20",
            "leftCorner": {
              "x": -15.177,
              "y": -30.495,
              "z": 0.62
            },
            "rightCorner": {
              "x": -15.471,
              "y": -30.499,
              "z": 0.62
            },
            "gtin": "4047046006098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d21",
            "leftCorner": {
              "x": -15.471,
              "y": -30.499,
              "z": 0.62
            },
            "rightCorner": {
              "x": -15.632,
              "y": -30.501,
              "z": 0.62
            },
            "gtin": "8711000300008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d0e",
            "leftCorner": {
              "x": -15.632,
              "y": -30.504,
              "z": 0.62
            },
            "rightCorner": {
              "x": -15.749,
              "y": -30.505,
              "z": 0.62
            },
            "gtin": "4047046008436",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d027",
        "height": 1.0613,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5cb7",
            "leftCorner": {
              "x": -14.608,
              "y": -30.492,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.817,
              "y": -30.495,
              "z": 0.868
            },
            "gtin": "8711000506448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cb8",
            "leftCorner": {
              "x": -14.817,
              "y": -30.496,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.986,
              "y": -30.499,
              "z": 0.868
            },
            "gtin": "8711000509159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cb9",
            "leftCorner": {
              "x": -14.986,
              "y": -30.498,
              "z": 0.868
            },
            "rightCorner": {
              "x": -15.12,
              "y": -30.5,
              "z": 0.868
            },
            "gtin": "7613036600996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cba",
            "leftCorner": {
              "x": -15.12,
              "y": -30.497,
              "z": 0.868
            },
            "rightCorner": {
              "x": -15.339,
              "y": -30.5,
              "z": 0.868
            },
            "gtin": "8032872605016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cbb",
            "leftCorner": {
              "x": -15.339,
              "y": -30.5,
              "z": 0.868
            },
            "rightCorner": {
              "x": -15.639,
              "y": -30.504,
              "z": 0.868
            },
            "gtin": "4002720001738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ca0",
            "leftCorner": {
              "x": -15.639,
              "y": -30.505,
              "z": 0.868
            },
            "rightCorner": {
              "x": -15.749,
              "y": -30.506,
              "z": 0.868
            },
            "gtin": "4002720001752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "663419183bcee3252bb39636",
            "leftCorner": {
              "x": -14.5,
              "y": -30.45,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.605,
              "y": -30.451,
              "z": 0.868
            },
            "gtin": "4002720001752",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d028",
        "height": 1.3654,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5cd2",
            "leftCorner": {
              "x": -14.654,
              "y": -30.489,
              "z": 1.117
            },
            "rightCorner": {
              "x": -14.819,
              "y": -30.492,
              "z": 1.117
            },
            "gtin": "4306188403470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3b3c058943f58ea23379ab00",
            "leftCorner": {
              "x": -14.5,
              "y": -30.447,
              "z": 1.117
            },
            "rightCorner": {
              "x": -14.601,
              "y": -30.448,
              "z": 1.117
            },
            "gtin": "8000070053540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cd3",
            "leftCorner": {
              "x": -14.819,
              "y": -30.492,
              "z": 1.117
            },
            "rightCorner": {
              "x": -14.989,
              "y": -30.495,
              "z": 1.117
            },
            "gtin": "4306188403449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cd4",
            "leftCorner": {
              "x": -14.989,
              "y": -30.494,
              "z": 1.117
            },
            "rightCorner": {
              "x": -15.071,
              "y": -30.495,
              "z": 1.117
            },
            "gtin": "8711000851937",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d5cd5",
            "leftCorner": {
              "x": -15.071,
              "y": -30.497,
              "z": 1.117
            },
            "rightCorner": {
              "x": -15.252,
              "y": -30.499,
              "z": 1.117
            },
            "gtin": "8711000851906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cd6",
            "leftCorner": {
              "x": -15.252,
              "y": -30.495,
              "z": 1.117
            },
            "rightCorner": {
              "x": -15.439,
              "y": -30.497,
              "z": 1.117
            },
            "gtin": "4006581020631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cd7",
            "leftCorner": {
              "x": -15.439,
              "y": -30.501,
              "z": 1.117
            },
            "rightCorner": {
              "x": -15.54,
              "y": -30.502,
              "z": 1.117
            },
            "gtin": "8000070053540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cd8",
            "leftCorner": {
              "x": -15.54,
              "y": -30.5,
              "z": 1.117
            },
            "rightCorner": {
              "x": -15.62,
              "y": -30.501,
              "z": 1.117
            },
            "gtin": "8000070053526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cd9",
            "leftCorner": {
              "x": -15.62,
              "y": -30.502,
              "z": 1.117
            },
            "rightCorner": {
              "x": -15.715,
              "y": -30.504,
              "z": 1.117
            },
            "gtin": "8000070053571",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "82e"
  },
  {
    "id": "82e",
    "name": "82e",
    "x": -13.249,
    "y": -30.477,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0068678
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 42,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d026",
        "height": 0.17413,
        "facings": [
          {
            "id": "39d1a23264e15cde94bc723b",
            "leftCorner": {
              "x": -13.25,
              "y": -30.39,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.337,
              "y": -30.391,
              "z": 0.142
            },
            "gtin": "8711000509005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "adff1cc12f14cad16f3ae5b1",
            "leftCorner": {
              "x": -13.337,
              "y": -30.391,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.425,
              "y": -30.392,
              "z": 0.142
            },
            "gtin": "8711000454145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "91df5c07558b2ef2f82bd369",
            "leftCorner": {
              "x": -13.425,
              "y": -30.392,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.516,
              "y": -30.394,
              "z": 0.142
            },
            "gtin": "8711000454114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c9e2ab51f55c8abd6d50d390",
            "leftCorner": {
              "x": -13.516,
              "y": -30.394,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.614,
              "y": -30.395,
              "z": 0.142
            },
            "gtin": "7613036900072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6250ec466f253b13f71bfaf7",
            "leftCorner": {
              "x": -13.614,
              "y": -30.395,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.723,
              "y": -30.397,
              "z": 0.142
            },
            "gtin": "8711000433270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "34c62fdc61329914b969b376",
            "leftCorner": {
              "x": -13.723,
              "y": -30.397,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.855,
              "y": -30.398,
              "z": 0.142
            },
            "gtin": "7613036310116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0aee2917b44a956eb560c90b",
            "leftCorner": {
              "x": -13.855,
              "y": -30.398,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.99,
              "y": -30.4,
              "z": 0.142
            },
            "gtin": "8711000496435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "584f02b8a1d01f9a9984e76a",
            "leftCorner": {
              "x": -13.99,
              "y": -30.4,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.128,
              "y": -30.402,
              "z": 0.142
            },
            "gtin": "4000508050008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4ff5ef658b8b91eac3598769",
            "leftCorner": {
              "x": -14.128,
              "y": -30.402,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.267,
              "y": -30.404,
              "z": 0.142
            },
            "gtin": "8711000452684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5c862b88fb9efe9d411c7fac",
            "leftCorner": {
              "x": -14.267,
              "y": -30.404,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.475,
              "y": -30.407,
              "z": 0.142
            },
            "gtin": "4021155117319",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d022",
        "height": 0.45838,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5cff",
            "leftCorner": {
              "x": -13.36,
              "y": -30.466,
              "z": 0.375
            },
            "rightCorner": {
              "x": -13.457,
              "y": -30.468,
              "z": 0.375
            },
            "gtin": "7613036457712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0898c62439828e0e111cc074",
            "leftCorner": {
              "x": -13.249,
              "y": -30.425,
              "z": 0.375
            },
            "rightCorner": {
              "x": -13.356,
              "y": -30.426,
              "z": 0.375
            },
            "gtin": "8711000675823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d00",
            "leftCorner": {
              "x": -13.457,
              "y": -30.468,
              "z": 0.375
            },
            "rightCorner": {
              "x": -13.554,
              "y": -30.468,
              "z": 0.375
            },
            "gtin": "7613036457712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d01",
            "leftCorner": {
              "x": -13.554,
              "y": -30.467,
              "z": 0.375
            },
            "rightCorner": {
              "x": -13.736,
              "y": -30.47,
              "z": 0.375
            },
            "gtin": "4005500005827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d02",
            "leftCorner": {
              "x": -13.736,
              "y": -30.471,
              "z": 0.375
            },
            "rightCorner": {
              "x": -13.929,
              "y": -30.473,
              "z": 0.375
            },
            "gtin": "4306188395843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d03",
            "leftCorner": {
              "x": -13.929,
              "y": -30.474,
              "z": 0.375
            },
            "rightCorner": {
              "x": -14.086,
              "y": -30.476,
              "z": 0.375
            },
            "gtin": "4306188414490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d04",
            "leftCorner": {
              "x": -14.086,
              "y": -30.475,
              "z": 0.375
            },
            "rightCorner": {
              "x": -14.251,
              "y": -30.478,
              "z": 0.375
            },
            "gtin": "4306188395812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d05",
            "leftCorner": {
              "x": -14.251,
              "y": -30.483,
              "z": 0.375
            },
            "rightCorner": {
              "x": -14.392,
              "y": -30.484,
              "z": 0.375
            },
            "gtin": "8711000452684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d06",
            "leftCorner": {
              "x": -14.392,
              "y": -30.481,
              "z": 0.375
            },
            "rightCorner": {
              "x": -14.576,
              "y": -30.483,
              "z": 0.375
            },
            "gtin": "8711000675823",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d025",
        "height": 0.75591,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d14",
            "leftCorner": {
              "x": -13.296,
              "y": -30.467,
              "z": 0.618
            },
            "rightCorner": {
              "x": -13.432,
              "y": -30.468,
              "z": 0.618
            },
            "gtin": "4000508050008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d15",
            "leftCorner": {
              "x": -13.432,
              "y": -30.467,
              "z": 0.618
            },
            "rightCorner": {
              "x": -13.605,
              "y": -30.47,
              "z": 0.618
            },
            "gtin": "4000508040221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d16",
            "leftCorner": {
              "x": -13.605,
              "y": -30.471,
              "z": 0.618
            },
            "rightCorner": {
              "x": -13.773,
              "y": -30.473,
              "z": 0.618
            },
            "gtin": "7613036347310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d17",
            "leftCorner": {
              "x": -13.773,
              "y": -30.474,
              "z": 0.618
            },
            "rightCorner": {
              "x": -13.958,
              "y": -30.477,
              "z": 0.618
            },
            "gtin": "7613036305846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d18",
            "leftCorner": {
              "x": -13.958,
              "y": -30.478,
              "z": 0.618
            },
            "rightCorner": {
              "x": -14.124,
              "y": -30.479,
              "z": 0.618
            },
            "gtin": "7613036303910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d19",
            "leftCorner": {
              "x": -14.124,
              "y": -30.482,
              "z": 0.618
            },
            "rightCorner": {
              "x": -14.273,
              "y": -30.485,
              "z": 0.618
            },
            "gtin": "7613036246675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d1a",
            "leftCorner": {
              "x": -14.273,
              "y": -30.484,
              "z": 0.618
            },
            "rightCorner": {
              "x": -14.408,
              "y": -30.485,
              "z": 0.618
            },
            "gtin": "7613036310116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d1b",
            "leftCorner": {
              "x": -14.408,
              "y": -30.483,
              "z": 0.618
            },
            "rightCorner": {
              "x": -14.577,
              "y": -30.486,
              "z": 0.618
            },
            "gtin": "8711000509005",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d023",
        "height": 1.0615,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5cb0",
            "leftCorner": {
              "x": -13.372,
              "y": -30.468,
              "z": 0.869
            },
            "rightCorner": {
              "x": -13.578,
              "y": -30.471,
              "z": 0.869
            },
            "gtin": "4021155117319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ebfc988233d672005abc164d",
            "leftCorner": {
              "x": -13.249,
              "y": -30.428,
              "z": 0.869
            },
            "rightCorner": {
              "x": -13.364,
              "y": -30.43,
              "z": 0.869
            },
            "gtin": "8711000396780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cb1",
            "leftCorner": {
              "x": -13.578,
              "y": -30.472,
              "z": 0.869
            },
            "rightCorner": {
              "x": -13.817,
              "y": -30.475,
              "z": 0.869
            },
            "gtin": "4306188393818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cb2",
            "leftCorner": {
              "x": -13.817,
              "y": -30.475,
              "z": 0.869
            },
            "rightCorner": {
              "x": -14.087,
              "y": -30.479,
              "z": 0.869
            },
            "gtin": "4306188393849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cb3",
            "leftCorner": {
              "x": -14.087,
              "y": -30.483,
              "z": 0.869
            },
            "rightCorner": {
              "x": -14.18,
              "y": -30.483,
              "z": 0.869
            },
            "gtin": "8711000454145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cb4",
            "leftCorner": {
              "x": -14.18,
              "y": -30.48,
              "z": 0.869
            },
            "rightCorner": {
              "x": -14.27,
              "y": -30.482,
              "z": 0.869
            },
            "gtin": "8711000454114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cb5",
            "leftCorner": {
              "x": -14.27,
              "y": -30.483,
              "z": 0.869
            },
            "rightCorner": {
              "x": -14.383,
              "y": -30.484,
              "z": 0.869
            },
            "gtin": "8711000433270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cb6",
            "leftCorner": {
              "x": -14.383,
              "y": -30.483,
              "z": 0.869
            },
            "rightCorner": {
              "x": -14.608,
              "y": -30.486,
              "z": 0.869
            },
            "gtin": "8711000396780",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d024",
        "height": 1.3665,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5ccb",
            "leftCorner": {
              "x": -13.31,
              "y": -30.468,
              "z": 1.118
            },
            "rightCorner": {
              "x": -13.423,
              "y": -30.47,
              "z": 1.118
            },
            "gtin": "7613036900072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aa287317bc819388e01b08ca",
            "leftCorner": {
              "x": -13.249,
              "y": -30.429,
              "z": 1.118
            },
            "rightCorner": {
              "x": -13.287,
              "y": -30.43,
              "z": 1.118
            },
            "gtin": "8711000496282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ccc",
            "leftCorner": {
              "x": -13.423,
              "y": -30.47,
              "z": 1.118
            },
            "rightCorner": {
              "x": -13.571,
              "y": -30.472,
              "z": 1.118
            },
            "gtin": "8711000496343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ccd",
            "leftCorner": {
              "x": -13.571,
              "y": -30.472,
              "z": 1.118
            },
            "rightCorner": {
              "x": -13.833,
              "y": -30.475,
              "z": 1.118
            },
            "gtin": "8711000496251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cce",
            "leftCorner": {
              "x": -13.833,
              "y": -30.476,
              "z": 1.118
            },
            "rightCorner": {
              "x": -14.161,
              "y": -30.481,
              "z": 1.118
            },
            "gtin": "8711000496312",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d5ccf",
            "leftCorner": {
              "x": -14.161,
              "y": -30.484,
              "z": 1.118
            },
            "rightCorner": {
              "x": -14.312,
              "y": -30.486,
              "z": 1.118
            },
            "gtin": "8711000701386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cd0",
            "leftCorner": {
              "x": -14.312,
              "y": -30.486,
              "z": 1.118
            },
            "rightCorner": {
              "x": -14.446,
              "y": -30.488,
              "z": 1.118
            },
            "gtin": "8711000496435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cd1",
            "leftCorner": {
              "x": -14.446,
              "y": -30.484,
              "z": 1.118
            },
            "rightCorner": {
              "x": -14.654,
              "y": -30.487,
              "z": 1.118
            },
            "gtin": "8711000496282",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "82f",
    "rightNeighborShelfId": "82d"
  },
  {
    "id": "82f",
    "name": "82f",
    "x": -11.999,
    "y": -30.46,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0068678
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 43,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d021",
        "height": 0.17669,
        "facings": [
          {
            "id": "1008d2ddc212eef47ed07bd5",
            "leftCorner": {
              "x": -12.0,
              "y": -30.376,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.065,
              "y": -30.377,
              "z": 0.145
            },
            "gtin": "7613036960298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "149703b0a2048fd33032595c",
            "leftCorner": {
              "x": -12.065,
              "y": -30.377,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.144,
              "y": -30.378,
              "z": 0.145
            },
            "gtin": "4021155117326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f9889f0d4ce6521eb37201c6",
            "leftCorner": {
              "x": -12.144,
              "y": -30.378,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.237,
              "y": -30.379,
              "z": 0.145
            },
            "gtin": "4000161850328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2bd8efb4759bacec9437d282",
            "leftCorner": {
              "x": -12.237,
              "y": -30.379,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.331,
              "y": -30.381,
              "z": 0.145
            },
            "gtin": "4000161850434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "18335651c94f65a26fc8b21f",
            "leftCorner": {
              "x": -12.331,
              "y": -30.381,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.43,
              "y": -30.382,
              "z": 0.145
            },
            "gtin": "8445290914200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1d919639ba373d513c66141f",
            "leftCorner": {
              "x": -12.43,
              "y": -30.382,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.531,
              "y": -30.383,
              "z": 0.145
            },
            "gtin": "4000161850236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "02d07788c990bf11275d9f03",
            "leftCorner": {
              "x": -12.531,
              "y": -30.383,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.645,
              "y": -30.385,
              "z": 0.145
            },
            "gtin": "5011546460451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9aad0e1d499b2d220af85e5a",
            "leftCorner": {
              "x": -12.645,
              "y": -30.385,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.795,
              "y": -30.387,
              "z": 0.145
            },
            "gtin": "4005500274995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee19c03298e5b78b5732c126",
            "leftCorner": {
              "x": -12.795,
              "y": -30.387,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.946,
              "y": -30.389,
              "z": 0.145
            },
            "gtin": "8445291766983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "654518b395deaff90e9678b5",
            "leftCorner": {
              "x": -12.946,
              "y": -30.389,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.186,
              "y": -30.392,
              "z": 0.145
            },
            "gtin": "8711000578292",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d01d",
        "height": 0.46103,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5cf7",
            "leftCorner": {
              "x": -12.0,
              "y": -30.414,
              "z": 0.377
            },
            "rightCorner": {
              "x": -12.31,
              "y": -30.418,
              "z": 0.377
            },
            "gtin": "8711000578384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cf9",
            "leftCorner": {
              "x": -12.31,
              "y": -30.455,
              "z": 0.377
            },
            "rightCorner": {
              "x": -12.544,
              "y": -30.459,
              "z": 0.377
            },
            "gtin": "8711000578261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cfa",
            "leftCorner": {
              "x": -12.544,
              "y": -30.461,
              "z": 0.377
            },
            "rightCorner": {
              "x": -12.739,
              "y": -30.464,
              "z": 0.377
            },
            "gtin": "8711000582527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cfb",
            "leftCorner": {
              "x": -12.739,
              "y": -30.465,
              "z": 0.377
            },
            "rightCorner": {
              "x": -12.977,
              "y": -30.468,
              "z": 0.377
            },
            "gtin": "8711000578292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cfc",
            "leftCorner": {
              "x": -12.977,
              "y": -30.471,
              "z": 0.377
            },
            "rightCorner": {
              "x": -13.168,
              "y": -30.473,
              "z": 0.377
            },
            "gtin": "4008167037002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cfd",
            "leftCorner": {
              "x": -13.168,
              "y": -30.47,
              "z": 0.377
            },
            "rightCorner": {
              "x": -13.264,
              "y": -30.472,
              "z": 0.377
            },
            "gtin": "7613031514793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cfe",
            "leftCorner": {
              "x": -13.264,
              "y": -30.472,
              "z": 0.377
            },
            "rightCorner": {
              "x": -13.361,
              "y": -30.473,
              "z": 0.377
            },
            "gtin": "7613031514793",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d01e",
        "height": 0.75897,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d0b",
            "leftCorner": {
              "x": -12.0,
              "y": -30.416,
              "z": 0.621
            },
            "rightCorner": {
              "x": -12.117,
              "y": -30.417,
              "z": 0.621
            },
            "gtin": "7613034831712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d0c",
            "leftCorner": {
              "x": -12.117,
              "y": -30.417,
              "z": 0.621
            },
            "rightCorner": {
              "x": -12.235,
              "y": -30.419,
              "z": 0.621
            },
            "gtin": "7613034831712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d0d",
            "leftCorner": {
              "x": -12.235,
              "y": -30.419,
              "z": 0.621
            },
            "rightCorner": {
              "x": -12.352,
              "y": -30.42,
              "z": 0.621
            },
            "gtin": "7613034831712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d0f",
            "leftCorner": {
              "x": -12.352,
              "y": -30.458,
              "z": 0.621
            },
            "rightCorner": {
              "x": -12.553,
              "y": -30.461,
              "z": 0.621
            },
            "gtin": "4260457112558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d10",
            "leftCorner": {
              "x": -12.553,
              "y": -30.463,
              "z": 0.621
            },
            "rightCorner": {
              "x": -12.718,
              "y": -30.465,
              "z": 0.621
            },
            "gtin": "4260457112534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d11",
            "leftCorner": {
              "x": -12.718,
              "y": -30.466,
              "z": 0.621
            },
            "rightCorner": {
              "x": -12.887,
              "y": -30.467,
              "z": 0.621
            },
            "gtin": "4000508040306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d12",
            "leftCorner": {
              "x": -12.887,
              "y": -30.47,
              "z": 0.621
            },
            "rightCorner": {
              "x": -13.094,
              "y": -30.473,
              "z": 0.621
            },
            "gtin": "8711000551998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d13",
            "leftCorner": {
              "x": -13.094,
              "y": -30.472,
              "z": 0.621
            },
            "rightCorner": {
              "x": -13.297,
              "y": -30.475,
              "z": 0.621
            },
            "gtin": "8711000509388",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d01f",
        "height": 1.0644,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5ca8",
            "leftCorner": {
              "x": -12.099,
              "y": -30.451,
              "z": 0.871
            },
            "rightCorner": {
              "x": -12.269,
              "y": -30.454,
              "z": 0.871
            },
            "gtin": "8445291343023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "42d2af346e107471a7639801",
            "leftCorner": {
              "x": -12.0,
              "y": -30.417,
              "z": 0.871
            },
            "rightCorner": {
              "x": -12.096,
              "y": -30.418,
              "z": 0.871
            },
            "gtin": "5011546460444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ca9",
            "leftCorner": {
              "x": -12.269,
              "y": -30.459,
              "z": 0.871
            },
            "rightCorner": {
              "x": -12.436,
              "y": -30.461,
              "z": 0.871
            },
            "gtin": "8445291342989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5caa",
            "leftCorner": {
              "x": -12.435,
              "y": -30.463,
              "z": 0.871
            },
            "rightCorner": {
              "x": -12.587,
              "y": -30.465,
              "z": 0.871
            },
            "gtin": "8445291766983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cab",
            "leftCorner": {
              "x": -12.587,
              "y": -30.464,
              "z": 0.871
            },
            "rightCorner": {
              "x": -12.684,
              "y": -30.466,
              "z": 0.871
            },
            "gtin": "5011546460444",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cac",
            "leftCorner": {
              "x": -12.684,
              "y": -30.467,
              "z": 0.871
            },
            "rightCorner": {
              "x": -12.796,
              "y": -30.468,
              "z": 0.871
            },
            "gtin": "5011546460451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cad",
            "leftCorner": {
              "x": -12.796,
              "y": -30.469,
              "z": 0.871
            },
            "rightCorner": {
              "x": -13.006,
              "y": -30.472,
              "z": 0.871
            },
            "gtin": "5011546460437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cae",
            "leftCorner": {
              "x": -13.006,
              "y": -30.473,
              "z": 0.871
            },
            "rightCorner": {
              "x": -13.172,
              "y": -30.474,
              "z": 0.871
            },
            "gtin": "4021155117333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5caf",
            "leftCorner": {
              "x": -13.172,
              "y": -30.473,
              "z": 0.871
            },
            "rightCorner": {
              "x": -13.373,
              "y": -30.476,
              "z": 0.871
            },
            "gtin": "4021155117326",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d020",
        "height": 1.3688,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5cc2",
            "leftCorner": {
              "x": -12.026,
              "y": -30.448,
              "z": 1.12
            },
            "rightCorner": {
              "x": -12.112,
              "y": -30.449,
              "z": 1.12
            },
            "gtin": "4000161850328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cc3",
            "leftCorner": {
              "x": -12.112,
              "y": -30.448,
              "z": 1.12
            },
            "rightCorner": {
              "x": -12.208,
              "y": -30.45,
              "z": 1.12
            },
            "gtin": "4000161850434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cc4",
            "leftCorner": {
              "x": -12.208,
              "y": -30.457,
              "z": 1.12
            },
            "rightCorner": {
              "x": -12.31,
              "y": -30.458,
              "z": 1.12
            },
            "gtin": "4000161850236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cc5",
            "leftCorner": {
              "x": -12.31,
              "y": -30.461,
              "z": 1.12
            },
            "rightCorner": {
              "x": -12.52,
              "y": -30.464,
              "z": 1.12
            },
            "gtin": "8711000578230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cc6",
            "leftCorner": {
              "x": -12.52,
              "y": -30.462,
              "z": 1.12
            },
            "rightCorner": {
              "x": -12.729,
              "y": -30.465,
              "z": 1.12
            },
            "gtin": "8711000578209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cc7",
            "leftCorner": {
              "x": -12.729,
              "y": -30.465,
              "z": 1.12
            },
            "rightCorner": {
              "x": -12.931,
              "y": -30.468,
              "z": 1.12
            },
            "gtin": "4052700069203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cc8",
            "leftCorner": {
              "x": -12.931,
              "y": -30.472,
              "z": 1.12
            },
            "rightCorner": {
              "x": -13.084,
              "y": -30.474,
              "z": 1.12
            },
            "gtin": "4005500274995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cc9",
            "leftCorner": {
              "x": -13.084,
              "y": -30.472,
              "z": 1.12
            },
            "rightCorner": {
              "x": -13.185,
              "y": -30.473,
              "z": 1.12
            },
            "gtin": "8445290914200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cca",
            "leftCorner": {
              "x": -13.185,
              "y": -30.473,
              "z": 1.12
            },
            "rightCorner": {
              "x": -13.311,
              "y": -30.475,
              "z": 1.12
            },
            "gtin": "7613036960298",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "830",
    "rightNeighborShelfId": "82e"
  },
  {
    "id": "830",
    "name": "830",
    "x": -10.989,
    "y": -30.442,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99992,
      "w": 0.012697
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 33,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d01c",
        "height": 0.17712,
        "facings": [
          {
            "id": "0aa81b8ef874259c66d99d01",
            "leftCorner": {
              "x": -10.992,
              "y": -30.344,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.066,
              "y": -30.346,
              "z": 0.145
            },
            "gtin": "7613032569532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bda9433a4db19c6bfea4d291",
            "leftCorner": {
              "x": -11.066,
              "y": -30.346,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.143,
              "y": -30.348,
              "z": 0.145
            },
            "gtin": "5996071691832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "08e11a09303400cc4b460efa",
            "leftCorner": {
              "x": -11.143,
              "y": -30.348,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.226,
              "y": -30.35,
              "z": 0.145
            },
            "gtin": "4000161850335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "39d6ed8c095101b5590f70fb",
            "leftCorner": {
              "x": -11.226,
              "y": -30.35,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.313,
              "y": -30.352,
              "z": 0.145
            },
            "gtin": "5996071691955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dae6de908e5140f207b50276",
            "leftCorner": {
              "x": -11.313,
              "y": -30.352,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.413,
              "y": -30.355,
              "z": 0.145
            },
            "gtin": "5996071691863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f04feeeb02dd87bec18d2784",
            "leftCorner": {
              "x": -11.413,
              "y": -30.355,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.555,
              "y": -30.358,
              "z": 0.145
            },
            "gtin": "8445290603708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e190298f396642b585359bca",
            "leftCorner": {
              "x": -11.555,
              "y": -30.358,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.708,
              "y": -30.362,
              "z": 0.145
            },
            "gtin": "4052700022956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3918653a466918042b0e0d99",
            "leftCorner": {
              "x": -11.708,
              "y": -30.362,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.862,
              "y": -30.366,
              "z": 0.145
            },
            "gtin": "8445291233126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "71c9205773842f39b093ae21",
            "leftCorner": {
              "x": -11.862,
              "y": -30.366,
              "z": 0.145
            },
            "rightCorner": {
              "x": -11.962,
              "y": -30.369,
              "z": 0.145
            },
            "gtin": "5996071691863",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d01a",
        "height": 0.47324,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5cda",
            "leftCorner": {
              "x": -10.991,
              "y": -30.387,
              "z": 0.387
            },
            "rightCorner": {
              "x": -11.254,
              "y": -30.394,
              "z": 0.387
            },
            "gtin": "4306188133797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cdc",
            "leftCorner": {
              "x": -11.254,
              "y": -30.431,
              "z": 0.387
            },
            "rightCorner": {
              "x": -11.55,
              "y": -30.439,
              "z": 0.387
            },
            "gtin": "4052700022970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cdd",
            "leftCorner": {
              "x": -11.549,
              "y": -30.445,
              "z": 0.387
            },
            "rightCorner": {
              "x": -11.838,
              "y": -30.453,
              "z": 0.387
            },
            "gtin": "8445291232891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cdb",
            "leftCorner": {
              "x": -11.838,
              "y": -30.449,
              "z": 0.387
            },
            "rightCorner": {
              "x": -11.989,
              "y": -30.453,
              "z": 0.387
            },
            "gtin": "8445291233126",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d01b",
        "height": 0.77476,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5cde",
            "leftCorner": {
              "x": -10.991,
              "y": -30.391,
              "z": 0.634
            },
            "rightCorner": {
              "x": -11.296,
              "y": -30.399,
              "z": 0.634
            },
            "gtin": "4052700022932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ce0",
            "leftCorner": {
              "x": -11.294,
              "y": -30.436,
              "z": 0.634
            },
            "rightCorner": {
              "x": -11.456,
              "y": -30.44,
              "z": 0.634
            },
            "gtin": "4052700022918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ce1",
            "leftCorner": {
              "x": -11.456,
              "y": -30.443,
              "z": 0.634
            },
            "rightCorner": {
              "x": -11.607,
              "y": -30.446,
              "z": 0.634
            },
            "gtin": "4052700022956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ce2",
            "leftCorner": {
              "x": -11.607,
              "y": -30.446,
              "z": 0.634
            },
            "rightCorner": {
              "x": -11.694,
              "y": -30.449,
              "z": 0.634
            },
            "gtin": "4104420038462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ce3",
            "leftCorner": {
              "x": -11.694,
              "y": -30.449,
              "z": 0.634
            },
            "rightCorner": {
              "x": -11.781,
              "y": -30.451,
              "z": 0.634
            },
            "gtin": "4104420038462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cdf",
            "leftCorner": {
              "x": -11.781,
              "y": -30.452,
              "z": 0.634
            },
            "rightCorner": {
              "x": -11.989,
              "y": -30.458,
              "z": 0.634
            },
            "gtin": "7612100909911",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d018",
        "height": 1.0668,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5c9f",
            "leftCorner": {
              "x": -10.991,
              "y": -30.4,
              "z": 0.873
            },
            "rightCorner": {
              "x": -11.075,
              "y": -30.402,
              "z": 0.873
            },
            "gtin": "5996071691832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ca1",
            "leftCorner": {
              "x": -11.074,
              "y": -30.439,
              "z": 0.873
            },
            "rightCorner": {
              "x": -11.14,
              "y": -30.441,
              "z": 0.873
            },
            "gtin": "5996071691863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ca2",
            "leftCorner": {
              "x": -11.14,
              "y": -30.444,
              "z": 0.873
            },
            "rightCorner": {
              "x": -11.223,
              "y": -30.446,
              "z": 0.873
            },
            "gtin": "5996071691955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ca3",
            "leftCorner": {
              "x": -11.223,
              "y": -30.441,
              "z": 0.873
            },
            "rightCorner": {
              "x": -11.422,
              "y": -30.446,
              "z": 0.873
            },
            "gtin": "7612100917640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ca4",
            "leftCorner": {
              "x": -11.422,
              "y": -30.45,
              "z": 0.873
            },
            "rightCorner": {
              "x": -11.603,
              "y": -30.455,
              "z": 0.873
            },
            "gtin": "40093345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ca5",
            "leftCorner": {
              "x": -11.603,
              "y": -30.458,
              "z": 0.873
            },
            "rightCorner": {
              "x": -11.78,
              "y": -30.463,
              "z": 0.873
            },
            "gtin": "8445290603876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ca6",
            "leftCorner": {
              "x": -11.78,
              "y": -30.465,
              "z": 0.873
            },
            "rightCorner": {
              "x": -11.918,
              "y": -30.469,
              "z": 0.873
            },
            "gtin": "8445290603708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ca7",
            "leftCorner": {
              "x": -11.918,
              "y": -30.462,
              "z": 0.873
            },
            "rightCorner": {
              "x": -12.088,
              "y": -30.467,
              "z": 0.873
            },
            "gtin": "7613032569532",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d019",
        "height": 1.3708,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5cbc",
            "leftCorner": {
              "x": -10.991,
              "y": -30.397,
              "z": 1.122
            },
            "rightCorner": {
              "x": -11.193,
              "y": -30.402,
              "z": 1.122
            },
            "gtin": "4052700080611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cbd",
            "leftCorner": {
              "x": -11.191,
              "y": -30.436,
              "z": 1.122
            },
            "rightCorner": {
              "x": -11.383,
              "y": -30.441,
              "z": 1.122
            },
            "gtin": "7613036300261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cbe",
            "leftCorner": {
              "x": -11.383,
              "y": -30.444,
              "z": 1.122
            },
            "rightCorner": {
              "x": -11.565,
              "y": -30.448,
              "z": 1.122
            },
            "gtin": "7613037001297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cbf",
            "leftCorner": {
              "x": -11.565,
              "y": -30.455,
              "z": 1.122
            },
            "rightCorner": {
              "x": -11.733,
              "y": -30.459,
              "z": 1.122
            },
            "gtin": "4021155159456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cc0",
            "leftCorner": {
              "x": -11.733,
              "y": -30.459,
              "z": 1.122
            },
            "rightCorner": {
              "x": -11.913,
              "y": -30.464,
              "z": 1.122
            },
            "gtin": "4021155104326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5cc1",
            "leftCorner": {
              "x": -11.913,
              "y": -30.461,
              "z": 1.122
            },
            "rightCorner": {
              "x": -12.016,
              "y": -30.463,
              "z": 1.122
            },
            "gtin": "4000161850335",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "82f"
  },
  {
    "id": "831",
    "name": "831",
    "x": -15.74,
    "y": -31.658,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 7.5922E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 43
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d661",
        "height": 0.17334,
        "facings": [
          {
            "id": "60c69d6f5488aaefc99aa5b2",
            "leftCorner": {
              "x": -15.74,
              "y": -31.744,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.643,
              "y": -31.744,
              "z": 0.142
            },
            "gtin": "4250780320508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6447a2a1c00143e1fad7decb",
            "leftCorner": {
              "x": -15.643,
              "y": -31.744,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.535,
              "y": -31.744,
              "z": 0.142
            },
            "gtin": "4011800521219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6a61c86dc9f85db87bcbc17c",
            "leftCorner": {
              "x": -15.535,
              "y": -31.744,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.417,
              "y": -31.744,
              "z": 0.142
            },
            "gtin": "4011800571214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "93e6f188bb5eb0282dcf182d",
            "leftCorner": {
              "x": -15.417,
              "y": -31.744,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.296,
              "y": -31.743,
              "z": 0.142
            },
            "gtin": "4000540000405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ad97fb76335cc9bc4049c554",
            "leftCorner": {
              "x": -15.296,
              "y": -31.743,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.171,
              "y": -31.743,
              "z": 0.142
            },
            "gtin": "4306188017387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "99f9b76367c6f90698456122",
            "leftCorner": {
              "x": -15.171,
              "y": -31.743,
              "z": 0.142
            },
            "rightCorner": {
              "x": -15.044,
              "y": -31.743,
              "z": 0.142
            },
            "gtin": "4104420225534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "169183951d9d21173f72dfaf",
            "leftCorner": {
              "x": -15.044,
              "y": -31.743,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.913,
              "y": -31.743,
              "z": 0.142
            },
            "gtin": "4000540002409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6fdf35005dc69c7e0dced8eb",
            "leftCorner": {
              "x": -14.913,
              "y": -31.743,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.781,
              "y": -31.743,
              "z": 0.142
            },
            "gtin": "4000950210289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "77440971c38d7be1eb55ddb5",
            "leftCorner": {
              "x": -14.781,
              "y": -31.743,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.501,
              "y": -31.742,
              "z": 0.142
            },
            "gtin": "4104420013308",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d65f",
        "height": 0.43305,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d861b",
            "leftCorner": {
              "x": -15.739,
              "y": -31.683,
              "z": 0.354
            },
            "rightCorner": {
              "x": -15.381,
              "y": -31.682,
              "z": 0.354
            },
            "gtin": "4000540000177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d861d",
            "leftCorner": {
              "x": -15.382,
              "y": -31.639,
              "z": 0.354
            },
            "rightCorner": {
              "x": -15.228,
              "y": -31.639,
              "z": 0.354
            },
            "gtin": "4000540000375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d861e",
            "leftCorner": {
              "x": -15.228,
              "y": -31.641,
              "z": 0.354
            },
            "rightCorner": {
              "x": -15.071,
              "y": -31.641,
              "z": 0.354
            },
            "gtin": "4250780320508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d861f",
            "leftCorner": {
              "x": -15.071,
              "y": -31.642,
              "z": 0.354
            },
            "rightCorner": {
              "x": -14.641,
              "y": -31.642,
              "z": 0.354
            },
            "gtin": "4250780307196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d861c",
            "leftCorner": {
              "x": -14.642,
              "y": -31.649,
              "z": 0.354
            },
            "rightCorner": {
              "x": -14.49,
              "y": -31.649,
              "z": 0.354
            },
            "gtin": "4250780307172",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d660",
        "height": 0.68087,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8620",
            "leftCorner": {
              "x": -15.74,
              "y": -31.692,
              "z": 0.557
            },
            "rightCorner": {
              "x": -15.18,
              "y": -31.691,
              "z": 0.557
            },
            "gtin": "4104420013308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8622",
            "leftCorner": {
              "x": -15.18,
              "y": -31.651,
              "z": 0.557
            },
            "rightCorner": {
              "x": -15.045,
              "y": -31.651,
              "z": 0.557
            },
            "gtin": "4104420016484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8623",
            "leftCorner": {
              "x": -15.045,
              "y": -31.65,
              "z": 0.557
            },
            "rightCorner": {
              "x": -14.843,
              "y": -31.65,
              "z": 0.557
            },
            "gtin": "4104420225534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8624",
            "leftCorner": {
              "x": -14.843,
              "y": -31.656,
              "z": 0.557
            },
            "rightCorner": {
              "x": -14.699,
              "y": -31.655,
              "z": 0.557
            },
            "gtin": "4104420115743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8621",
            "leftCorner": {
              "x": -14.699,
              "y": -31.656,
              "z": 0.557
            },
            "rightCorner": {
              "x": -14.49,
              "y": -31.656,
              "z": 0.557
            },
            "gtin": "4104420115767",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d65e",
        "height": 0.98412,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8613",
            "leftCorner": {
              "x": -15.74,
              "y": -31.692,
              "z": 0.805
            },
            "rightCorner": {
              "x": -15.476,
              "y": -31.692,
              "z": 0.805
            },
            "gtin": "4000950210289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8616",
            "leftCorner": {
              "x": -15.476,
              "y": -31.647,
              "z": 0.805
            },
            "rightCorner": {
              "x": -15.223,
              "y": -31.647,
              "z": 0.805
            },
            "gtin": "4000950210258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8617",
            "leftCorner": {
              "x": -15.223,
              "y": -31.648,
              "z": 0.805
            },
            "rightCorner": {
              "x": -15.098,
              "y": -31.649,
              "z": 0.805
            },
            "gtin": "4000540000405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8618",
            "leftCorner": {
              "x": -15.098,
              "y": -31.65,
              "z": 0.805
            },
            "rightCorner": {
              "x": -14.971,
              "y": -31.65,
              "z": 0.805
            },
            "gtin": "4000540002409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8619",
            "leftCorner": {
              "x": -14.971,
              "y": -31.653,
              "z": 0.805
            },
            "rightCorner": {
              "x": -14.839,
              "y": -31.653,
              "z": 0.805
            },
            "gtin": "4000540002508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d861a",
            "leftCorner": {
              "x": -14.839,
              "y": -31.657,
              "z": 0.805
            },
            "rightCorner": {
              "x": -14.692,
              "y": -31.657,
              "z": 0.805
            },
            "gtin": "4000540002546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8614",
            "leftCorner": {
              "x": -14.691,
              "y": -31.658,
              "z": 0.805
            },
            "rightCorner": {
              "x": -14.591,
              "y": -31.658,
              "z": 0.805
            },
            "gtin": "4000950670373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8615",
            "leftCorner": {
              "x": -14.591,
              "y": -31.658,
              "z": 0.805
            },
            "rightCorner": {
              "x": -14.49,
              "y": -31.658,
              "z": 0.805
            },
            "gtin": "4000950670373",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d65c",
        "height": 1.2648,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d860c",
            "leftCorner": {
              "x": -15.74,
              "y": -31.69,
              "z": 1.035
            },
            "rightCorner": {
              "x": -15.497,
              "y": -31.69,
              "z": 1.035
            },
            "gtin": "4011800000103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d860e",
            "leftCorner": {
              "x": -15.497,
              "y": -31.643,
              "z": 1.035
            },
            "rightCorner": {
              "x": -15.342,
              "y": -31.642,
              "z": 1.035
            },
            "gtin": "4306188047254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d860f",
            "leftCorner": {
              "x": -15.341,
              "y": -31.649,
              "z": 1.035
            },
            "rightCorner": {
              "x": -15.228,
              "y": -31.648,
              "z": 1.035
            },
            "gtin": "4306188017387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8610",
            "leftCorner": {
              "x": -15.228,
              "y": -31.647,
              "z": 1.035
            },
            "rightCorner": {
              "x": -14.983,
              "y": -31.647,
              "z": 1.035
            },
            "gtin": "4306188017448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8611",
            "leftCorner": {
              "x": -14.983,
              "y": -31.649,
              "z": 1.035
            },
            "rightCorner": {
              "x": -14.799,
              "y": -31.649,
              "z": 1.035
            },
            "gtin": "5900020028495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8612",
            "leftCorner": {
              "x": -14.799,
              "y": -31.654,
              "z": 1.035
            },
            "rightCorner": {
              "x": -14.643,
              "y": -31.653,
              "z": 1.035
            },
            "gtin": "5900020028464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d860d",
            "leftCorner": {
              "x": -14.643,
              "y": -31.655,
              "z": 1.035
            },
            "rightCorner": {
              "x": -14.49,
              "y": -31.654,
              "z": 1.035
            },
            "gtin": "5900020030443",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d65d",
        "height": 1.5147,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d22",
            "leftCorner": {
              "x": -15.74,
              "y": -31.696,
              "z": 1.239
            },
            "rightCorner": {
              "x": -15.578,
              "y": -31.695,
              "z": 1.239
            },
            "gtin": "4011800549213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d24",
            "leftCorner": {
              "x": -15.578,
              "y": -31.649,
              "z": 1.239
            },
            "rightCorner": {
              "x": -15.437,
              "y": -31.649,
              "z": 1.239
            },
            "gtin": "4011800562212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d25",
            "leftCorner": {
              "x": -15.437,
              "y": -31.649,
              "z": 1.239
            },
            "rightCorner": {
              "x": -15.298,
              "y": -31.649,
              "z": 1.239
            },
            "gtin": "4011800562816",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d26",
            "leftCorner": {
              "x": -15.298,
              "y": -31.652,
              "z": 1.239
            },
            "rightCorner": {
              "x": -15.168,
              "y": -31.651,
              "z": 1.239
            },
            "gtin": "4011800571214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d27",
            "leftCorner": {
              "x": -15.168,
              "y": -31.654,
              "z": 1.239
            },
            "rightCorner": {
              "x": -15.009,
              "y": -31.655,
              "z": 1.239
            },
            "gtin": "4011800572211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d28",
            "leftCorner": {
              "x": -15.009,
              "y": -31.657,
              "z": 1.239
            },
            "rightCorner": {
              "x": -14.872,
              "y": -31.656,
              "z": 1.239
            },
            "gtin": "4011800575212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d29",
            "leftCorner": {
              "x": -14.872,
              "y": -31.673,
              "z": 1.239
            },
            "rightCorner": {
              "x": -14.733,
              "y": -31.673,
              "z": 1.239
            },
            "gtin": "4011800571719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d2a",
            "leftCorner": {
              "x": -14.733,
              "y": -31.662,
              "z": 1.239
            },
            "rightCorner": {
              "x": -14.59,
              "y": -31.662,
              "z": 1.239
            },
            "gtin": "4011800523213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d2b",
            "leftCorner": {
              "x": -14.59,
              "y": -31.662,
              "z": 1.239
            },
            "rightCorner": {
              "x": -14.414,
              "y": -31.662,
              "z": 1.239
            },
            "gtin": "4011800521219",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "832"
  },
  {
    "id": "832",
    "name": "832",
    "x": -14.49,
    "y": -31.656,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 7.5922E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d030",
        "height": 0.173,
        "facings": [
          {
            "id": "af2a08bdd85557484fae105c",
            "leftCorner": {
              "x": -14.49,
              "y": -31.754,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.409,
              "y": -31.754,
              "z": 0.142
            },
            "gtin": "4000521031152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "49326bbbd91fe7babdc26f98",
            "leftCorner": {
              "x": -14.409,
              "y": -31.754,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.324,
              "y": -31.754,
              "z": 0.142
            },
            "gtin": "4000521033750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6b1719e2b86a55c8e0e42376",
            "leftCorner": {
              "x": -14.324,
              "y": -31.754,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.237,
              "y": -31.754,
              "z": 0.142
            },
            "gtin": "4000521033699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f78725b46b3c65835ecb2a9d",
            "leftCorner": {
              "x": -14.237,
              "y": -31.754,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.146,
              "y": -31.753,
              "z": 0.142
            },
            "gtin": "4000521033675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ab5cc374372b3f073d3e7dee",
            "leftCorner": {
              "x": -14.146,
              "y": -31.753,
              "z": 0.142
            },
            "rightCorner": {
              "x": -14.054,
              "y": -31.753,
              "z": 0.142
            },
            "gtin": "4000540000719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4fcb51f6272e4ec3e2457d05",
            "leftCorner": {
              "x": -14.054,
              "y": -31.753,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.96,
              "y": -31.753,
              "z": 0.142
            },
            "gtin": "4000521033712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4836a5e6a520b6b3b52c803b",
            "leftCorner": {
              "x": -13.96,
              "y": -31.753,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.86,
              "y": -31.753,
              "z": 0.142
            },
            "gtin": "4011800000578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a8b06ffb18e1c2bb0f38238c",
            "leftCorner": {
              "x": -13.86,
              "y": -31.753,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.723,
              "y": -31.753,
              "z": 0.142
            },
            "gtin": "4011800593810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "410cd2c0052fa604d4270808",
            "leftCorner": {
              "x": -13.723,
              "y": -31.753,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.584,
              "y": -31.753,
              "z": 0.142
            },
            "gtin": "4011800582319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "74156f19a2f0b3dccc39a4ff",
            "leftCorner": {
              "x": -13.584,
              "y": -31.753,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.445,
              "y": -31.752,
              "z": 0.142
            },
            "gtin": "4011800530013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cc31c32b035bc45e1ef1dab2",
            "leftCorner": {
              "x": -13.445,
              "y": -31.752,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.249,
              "y": -31.752,
              "z": 0.142
            },
            "gtin": "4000540010763",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d02e",
        "height": 0.50613,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d54",
            "leftCorner": {
              "x": -14.489,
              "y": -31.702,
              "z": 0.414
            },
            "rightCorner": {
              "x": -14.163,
              "y": -31.701,
              "z": 0.414
            },
            "gtin": "4306188017264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d56",
            "leftCorner": {
              "x": -14.164,
              "y": -31.661,
              "z": 0.414
            },
            "rightCorner": {
              "x": -13.893,
              "y": -31.661,
              "z": 0.414
            },
            "gtin": "4306188017295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d57",
            "leftCorner": {
              "x": -13.893,
              "y": -31.66,
              "z": 0.414
            },
            "rightCorner": {
              "x": -13.619,
              "y": -31.66,
              "z": 0.414
            },
            "gtin": "4306188432609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d58",
            "leftCorner": {
              "x": -13.619,
              "y": -31.662,
              "z": 0.414
            },
            "rightCorner": {
              "x": -13.172,
              "y": -31.661,
              "z": 0.414
            },
            "gtin": "4306188374107",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d02f",
        "height": 0.88359,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d5f",
            "leftCorner": {
              "x": -14.489,
              "y": -31.707,
              "z": 0.723
            },
            "rightCorner": {
              "x": -14.185,
              "y": -31.706,
              "z": 0.723
            },
            "gtin": "4250780321147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d61",
            "leftCorner": {
              "x": -14.185,
              "y": -31.668,
              "z": 0.723
            },
            "rightCorner": {
              "x": -14.086,
              "y": -31.668,
              "z": 0.723
            },
            "gtin": "4250780321161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d62",
            "leftCorner": {
              "x": -14.086,
              "y": -31.668,
              "z": 0.723
            },
            "rightCorner": {
              "x": -13.986,
              "y": -31.667,
              "z": 0.723
            },
            "gtin": "4250780321161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d63",
            "leftCorner": {
              "x": -13.986,
              "y": -31.667,
              "z": 0.723
            },
            "rightCorner": {
              "x": -13.887,
              "y": -31.667,
              "z": 0.723
            },
            "gtin": "4250780321161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d64",
            "leftCorner": {
              "x": -13.887,
              "y": -31.663,
              "z": 0.723
            },
            "rightCorner": {
              "x": -13.685,
              "y": -31.662,
              "z": 0.723
            },
            "gtin": "4000540010763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d65",
            "leftCorner": {
              "x": -13.685,
              "y": -31.664,
              "z": 0.723
            },
            "rightCorner": {
              "x": -13.588,
              "y": -31.665,
              "z": 0.723
            },
            "gtin": "4000540000719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d66",
            "leftCorner": {
              "x": -13.588,
              "y": -31.666,
              "z": 0.723
            },
            "rightCorner": {
              "x": -13.502,
              "y": -31.667,
              "z": 0.723
            },
            "gtin": "4000521033699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d67",
            "leftCorner": {
              "x": -13.502,
              "y": -31.666,
              "z": 0.723
            },
            "rightCorner": {
              "x": -13.416,
              "y": -31.665,
              "z": 0.723
            },
            "gtin": "4000521033750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d68",
            "leftCorner": {
              "x": -13.416,
              "y": -31.665,
              "z": 0.723
            },
            "rightCorner": {
              "x": -13.33,
              "y": -31.665,
              "z": 0.723
            },
            "gtin": "4000521033675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d69",
            "leftCorner": {
              "x": -13.33,
              "y": -31.664,
              "z": 0.723
            },
            "rightCorner": {
              "x": -13.207,
              "y": -31.664,
              "z": 0.723
            },
            "gtin": "4000521033712",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d02d",
        "height": 1.1848,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d41",
            "leftCorner": {
              "x": -14.489,
              "y": -31.707,
              "z": 0.969
            },
            "rightCorner": {
              "x": -14.352,
              "y": -31.706,
              "z": 0.969
            },
            "gtin": "4250780321185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d42",
            "leftCorner": {
              "x": -14.352,
              "y": -31.706,
              "z": 0.969
            },
            "rightCorner": {
              "x": -14.214,
              "y": -31.706,
              "z": 0.969
            },
            "gtin": "4250780321185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d44",
            "leftCorner": {
              "x": -14.215,
              "y": -31.666,
              "z": 0.969
            },
            "rightCorner": {
              "x": -14.042,
              "y": -31.665,
              "z": 0.969
            },
            "gtin": "4250780321208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d45",
            "leftCorner": {
              "x": -14.042,
              "y": -31.666,
              "z": 0.969
            },
            "rightCorner": {
              "x": -13.799,
              "y": -31.666,
              "z": 0.969
            },
            "gtin": "4250780321086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d46",
            "leftCorner": {
              "x": -13.799,
              "y": -31.667,
              "z": 0.969
            },
            "rightCorner": {
              "x": -13.554,
              "y": -31.666,
              "z": 0.969
            },
            "gtin": "4250780321109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d47",
            "leftCorner": {
              "x": -13.554,
              "y": -31.665,
              "z": 0.969
            },
            "rightCorner": {
              "x": -13.318,
              "y": -31.665,
              "z": 0.969
            },
            "gtin": "4250780321062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d48",
            "leftCorner": {
              "x": -13.318,
              "y": -31.664,
              "z": 0.969
            },
            "rightCorner": {
              "x": -13.192,
              "y": -31.664,
              "z": 0.969
            },
            "gtin": "4000521031152",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d02c",
        "height": 1.5119,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d2c",
            "leftCorner": {
              "x": -14.414,
              "y": -31.67,
              "z": 1.237
            },
            "rightCorner": {
              "x": -14.247,
              "y": -31.669,
              "z": 1.237
            },
            "gtin": "4011800524210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d2d",
            "leftCorner": {
              "x": -14.247,
              "y": -31.665,
              "z": 1.237
            },
            "rightCorner": {
              "x": -14.096,
              "y": -31.665,
              "z": 1.237
            },
            "gtin": "4011800530013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d2e",
            "leftCorner": {
              "x": -14.096,
              "y": -31.668,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.933,
              "y": -31.668,
              "z": 1.237
            },
            "gtin": "4011800523817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d2f",
            "leftCorner": {
              "x": -13.933,
              "y": -31.667,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.769,
              "y": -31.667,
              "z": 1.237
            },
            "gtin": "4011800523916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d30",
            "leftCorner": {
              "x": -13.769,
              "y": -31.668,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.626,
              "y": -31.668,
              "z": 1.237
            },
            "gtin": "4011800582319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d31",
            "leftCorner": {
              "x": -13.626,
              "y": -31.667,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.465,
              "y": -31.667,
              "z": 1.237
            },
            "gtin": "4011800525316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d32",
            "leftCorner": {
              "x": -13.465,
              "y": -31.667,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.335,
              "y": -31.667,
              "z": 1.237
            },
            "gtin": "4011800593810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d33",
            "leftCorner": {
              "x": -13.335,
              "y": -31.67,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.158,
              "y": -31.67,
              "z": 1.237
            },
            "gtin": "4011800000578",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "831",
    "rightNeighborShelfId": "833"
  },
  {
    "id": "833",
    "name": "833",
    "x": -13.24,
    "y": -31.654,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 7.5922E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 41
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d035",
        "height": 0.17664,
        "facings": [
          {
            "id": "1207809245ecf5d95415e189",
            "leftCorner": {
              "x": -13.241,
              "y": -31.755,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.152,
              "y": -31.755,
              "z": 0.145
            },
            "gtin": "4000521021894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "95b6f5d7a04b262a76883843",
            "leftCorner": {
              "x": -13.152,
              "y": -31.755,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.042,
              "y": -31.755,
              "z": 0.145
            },
            "gtin": "4000540003468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "63811e95b0e8947fc92f082b",
            "leftCorner": {
              "x": -13.042,
              "y": -31.755,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.923,
              "y": -31.755,
              "z": 0.145
            },
            "gtin": "4000521041991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cf8a3c1ac04de312999f2017",
            "leftCorner": {
              "x": -12.923,
              "y": -31.755,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.799,
              "y": -31.754,
              "z": 0.145
            },
            "gtin": "4000521041977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2c899b865169f7754edfdc7a",
            "leftCorner": {
              "x": -12.799,
              "y": -31.754,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.674,
              "y": -31.754,
              "z": 0.145
            },
            "gtin": "4000521035662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "08fac270fec5b2789e814a22",
            "leftCorner": {
              "x": -12.674,
              "y": -31.754,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.548,
              "y": -31.754,
              "z": 0.145
            },
            "gtin": "4000521040253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8f02d098c6c8f3c3682acd74",
            "leftCorner": {
              "x": -12.548,
              "y": -31.754,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.414,
              "y": -31.754,
              "z": 0.145
            },
            "gtin": "4000521035709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee8bee8dc6dc48ce39d6989e",
            "leftCorner": {
              "x": -12.414,
              "y": -31.754,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.279,
              "y": -31.754,
              "z": 0.145
            },
            "gtin": "4000540001341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cf2f9aef9ae1061f9aa25b33",
            "leftCorner": {
              "x": -12.279,
              "y": -31.754,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.097,
              "y": -31.753,
              "z": 0.145
            },
            "gtin": "4000540023169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a189685c8c9522ecb79d898f",
            "leftCorner": {
              "x": -12.097,
              "y": -31.753,
              "z": 0.145
            },
            "rightCorner": {
              "x": -12.008,
              "y": -31.753,
              "z": 0.145
            },
            "gtin": "4000521021894",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d034",
        "height": 0.50821,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d59",
            "leftCorner": {
              "x": -13.172,
              "y": -31.667,
              "z": 0.416
            },
            "rightCorner": {
              "x": -13.074,
              "y": -31.667,
              "z": 0.416
            },
            "gtin": "4000540003468",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d5a",
            "leftCorner": {
              "x": -13.074,
              "y": -31.67,
              "z": 0.416
            },
            "rightCorner": {
              "x": -12.933,
              "y": -31.671,
              "z": 0.416
            },
            "gtin": "4000540003260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d5b",
            "leftCorner": {
              "x": -12.933,
              "y": -31.666,
              "z": 0.416
            },
            "rightCorner": {
              "x": -12.801,
              "y": -31.665,
              "z": 0.416
            },
            "gtin": "4000540001341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d5c",
            "leftCorner": {
              "x": -12.801,
              "y": -31.663,
              "z": 0.416
            },
            "rightCorner": {
              "x": -12.481,
              "y": -31.662,
              "z": 0.416
            },
            "gtin": "4000540063868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d5d",
            "leftCorner": {
              "x": -12.481,
              "y": -31.664,
              "z": 0.416
            },
            "rightCorner": {
              "x": -12.328,
              "y": -31.663,
              "z": 0.416
            },
            "gtin": "4000540011517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d5e",
            "leftCorner": {
              "x": -12.328,
              "y": -31.663,
              "z": 0.416
            },
            "rightCorner": {
              "x": -12.174,
              "y": -31.663,
              "z": 0.416
            },
            "gtin": "4000540011517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d55",
            "leftCorner": {
              "x": -12.174,
              "y": -31.661,
              "z": 0.416
            },
            "rightCorner": {
              "x": -11.99,
              "y": -31.661,
              "z": 0.416
            },
            "gtin": "4000540023169",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d033",
        "height": 0.88483,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d6a",
            "leftCorner": {
              "x": -13.207,
              "y": -31.663,
              "z": 0.724
            },
            "rightCorner": {
              "x": -13.069,
              "y": -31.662,
              "z": 0.724
            },
            "gtin": "4000521035723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f888da5e5cc8617c63dfa0bd",
            "leftCorner": {
              "x": -12.885,
              "y": -31.706,
              "z": 0.724
            },
            "rightCorner": {
              "x": -12.796,
              "y": -31.706,
              "z": 0.724
            },
            "gtin": "4000521021894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d6b",
            "leftCorner": {
              "x": -13.069,
              "y": -31.666,
              "z": 0.724
            },
            "rightCorner": {
              "x": -12.885,
              "y": -31.667,
              "z": 0.724
            },
            "gtin": "4000521040864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d6d",
            "leftCorner": {
              "x": -12.784,
              "y": -31.667,
              "z": 0.724
            },
            "rightCorner": {
              "x": -12.636,
              "y": -31.667,
              "z": 0.724
            },
            "gtin": "4000521008871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d6e",
            "leftCorner": {
              "x": -12.636,
              "y": -31.661,
              "z": 0.724
            },
            "rightCorner": {
              "x": -12.49,
              "y": -31.66,
              "z": 0.724
            },
            "gtin": "4000521040680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d6f",
            "leftCorner": {
              "x": -12.49,
              "y": -31.668,
              "z": 0.724
            },
            "rightCorner": {
              "x": -12.348,
              "y": -31.668,
              "z": 0.724
            },
            "gtin": "4000521021917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d70",
            "leftCorner": {
              "x": -12.348,
              "y": -31.661,
              "z": 0.724
            },
            "rightCorner": {
              "x": -12.2,
              "y": -31.661,
              "z": 0.724
            },
            "gtin": "4000521012861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d71",
            "leftCorner": {
              "x": -12.2,
              "y": -31.663,
              "z": 0.724
            },
            "rightCorner": {
              "x": -11.943,
              "y": -31.663,
              "z": 0.724
            },
            "gtin": "4000521021894",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d032",
        "height": 1.1875,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d49",
            "leftCorner": {
              "x": -13.193,
              "y": -31.677,
              "z": 0.972
            },
            "rightCorner": {
              "x": -13.031,
              "y": -31.676,
              "z": 0.972
            },
            "gtin": "4000521039103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d4a",
            "leftCorner": {
              "x": -13.031,
              "y": -31.675,
              "z": 0.972
            },
            "rightCorner": {
              "x": -12.889,
              "y": -31.675,
              "z": 0.972
            },
            "gtin": "4000521021870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d4b",
            "leftCorner": {
              "x": -12.889,
              "y": -31.676,
              "z": 0.972
            },
            "rightCorner": {
              "x": -12.735,
              "y": -31.675,
              "z": 0.972
            },
            "gtin": "4000521663407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d4c",
            "leftCorner": {
              "x": -12.735,
              "y": -31.668,
              "z": 0.972
            },
            "rightCorner": {
              "x": -12.611,
              "y": -31.668,
              "z": 0.972
            },
            "gtin": "4000521041991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d4d",
            "leftCorner": {
              "x": -12.611,
              "y": -31.667,
              "z": 0.972
            },
            "rightCorner": {
              "x": -12.464,
              "y": -31.668,
              "z": 0.972
            },
            "gtin": "4000521035853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d4e",
            "leftCorner": {
              "x": -12.464,
              "y": -31.666,
              "z": 0.972
            },
            "rightCorner": {
              "x": -12.316,
              "y": -31.666,
              "z": 0.972
            },
            "gtin": "4000521661304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d4f",
            "leftCorner": {
              "x": -12.316,
              "y": -31.665,
              "z": 0.972
            },
            "rightCorner": {
              "x": -12.153,
              "y": -31.666,
              "z": 0.972
            },
            "gtin": "4000521661205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d50",
            "leftCorner": {
              "x": -12.153,
              "y": -31.664,
              "z": 0.972
            },
            "rightCorner": {
              "x": -11.925,
              "y": -31.663,
              "z": 0.972
            },
            "gtin": "4000521004644",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d031",
        "height": 1.5122,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d34",
            "leftCorner": {
              "x": -13.159,
              "y": -31.672,
              "z": 1.237
            },
            "rightCorner": {
              "x": -13.035,
              "y": -31.672,
              "z": 1.237
            },
            "gtin": "4000521040253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d35",
            "leftCorner": {
              "x": -13.035,
              "y": -31.67,
              "z": 1.237
            },
            "rightCorner": {
              "x": -12.912,
              "y": -31.67,
              "z": 1.237
            },
            "gtin": "4000521035662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d36",
            "leftCorner": {
              "x": -12.912,
              "y": -31.67,
              "z": 1.237
            },
            "rightCorner": {
              "x": -12.735,
              "y": -31.669,
              "z": 1.237
            },
            "gtin": "4000521035686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d37",
            "leftCorner": {
              "x": -12.735,
              "y": -31.666,
              "z": 1.237
            },
            "rightCorner": {
              "x": -12.598,
              "y": -31.665,
              "z": 1.237
            },
            "gtin": "4000521035709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d38",
            "leftCorner": {
              "x": -12.598,
              "y": -31.666,
              "z": 1.237
            },
            "rightCorner": {
              "x": -12.474,
              "y": -31.666,
              "z": 1.237
            },
            "gtin": "4000521041977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d39",
            "leftCorner": {
              "x": -12.474,
              "y": -31.671,
              "z": 1.237
            },
            "rightCorner": {
              "x": -12.309,
              "y": -31.671,
              "z": 1.237
            },
            "gtin": "4000521040628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d3a",
            "leftCorner": {
              "x": -12.309,
              "y": -31.665,
              "z": 1.237
            },
            "rightCorner": {
              "x": -12.151,
              "y": -31.665,
              "z": 1.237
            },
            "gtin": "4000521010423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d3b",
            "leftCorner": {
              "x": -12.151,
              "y": -31.667,
              "z": 1.237
            },
            "rightCorner": {
              "x": -11.956,
              "y": -31.667,
              "z": 1.237
            },
            "gtin": "4000521662103",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "832",
    "rightNeighborShelfId": "834"
  },
  {
    "id": "834",
    "name": "834",
    "x": -11.99,
    "y": -31.652,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 7.5922E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d666",
        "height": 0.17502,
        "facings": [
          {
            "id": "50aa0f5c1536e54390635022",
            "leftCorner": {
              "x": -11.99,
              "y": -31.746,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.868,
              "y": -31.746,
              "z": 0.143
            },
            "gtin": "4008391027060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "404450643470a56feaeb8914",
            "leftCorner": {
              "x": -11.868,
              "y": -31.746,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.742,
              "y": -31.746,
              "z": 0.143
            },
            "gtin": "4008391050846",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "67c546a1aac118c44b2751cb",
            "leftCorner": {
              "x": -11.742,
              "y": -31.746,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.603,
              "y": -31.745,
              "z": 0.143
            },
            "gtin": "4008391213807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "833f2f7b88fd12f442769760",
            "leftCorner": {
              "x": -11.603,
              "y": -31.745,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.457,
              "y": -31.745,
              "z": 0.143
            },
            "gtin": "4008391213869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "01de5504b48c020ddf04b22d",
            "leftCorner": {
              "x": -11.457,
              "y": -31.745,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.295,
              "y": -31.745,
              "z": 0.143
            },
            "gtin": "4008391213890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "29adbbd14a9a0184a6ce3a27",
            "leftCorner": {
              "x": -11.295,
              "y": -31.745,
              "z": 0.143
            },
            "rightCorner": {
              "x": -11.129,
              "y": -31.745,
              "z": 0.143
            },
            "gtin": "4008391212695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "489cc709e18155c27090f69d",
            "leftCorner": {
              "x": -11.129,
              "y": -31.745,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.99,
              "y": -31.744,
              "z": 0.143
            },
            "gtin": "4008391213807",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d663",
        "height": 0.52249,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8625",
            "leftCorner": {
              "x": -11.99,
              "y": -31.709,
              "z": 0.427
            },
            "rightCorner": {
              "x": -11.82,
              "y": -31.709,
              "z": 0.427
            },
            "gtin": "4008391212695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8627",
            "leftCorner": {
              "x": -11.82,
              "y": -31.671,
              "z": 0.427
            },
            "rightCorner": {
              "x": -11.672,
              "y": -31.671,
              "z": 0.427
            },
            "gtin": "4008391213890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8628",
            "leftCorner": {
              "x": -11.672,
              "y": -31.671,
              "z": 0.427
            },
            "rightCorner": {
              "x": -11.53,
              "y": -31.671,
              "z": 0.427
            },
            "gtin": "4008391213869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8629",
            "leftCorner": {
              "x": -11.53,
              "y": -31.668,
              "z": 0.427
            },
            "rightCorner": {
              "x": -11.365,
              "y": -31.668,
              "z": 0.427
            },
            "gtin": "4008391213876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d862a",
            "leftCorner": {
              "x": -11.365,
              "y": -31.665,
              "z": 0.427
            },
            "rightCorner": {
              "x": -11.22,
              "y": -31.665,
              "z": 0.427
            },
            "gtin": "4008391213807",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d8626",
            "leftCorner": {
              "x": -11.22,
              "y": -31.663,
              "z": 0.427
            },
            "rightCorner": {
              "x": -10.99,
              "y": -31.662,
              "z": 0.427
            },
            "gtin": "4008391042179",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d664",
        "height": 0.88708,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d72",
            "leftCorner": {
              "x": -11.942,
              "y": -31.666,
              "z": 0.726
            },
            "rightCorner": {
              "x": -11.781,
              "y": -31.666,
              "z": 0.726
            },
            "gtin": "4008391050907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d73",
            "leftCorner": {
              "x": -11.781,
              "y": -31.66,
              "z": 0.726
            },
            "rightCorner": {
              "x": -11.604,
              "y": -31.66,
              "z": 0.726
            },
            "gtin": "4008391008656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d74",
            "leftCorner": {
              "x": -11.604,
              "y": -31.66,
              "z": 0.726
            },
            "rightCorner": {
              "x": -11.426,
              "y": -31.66,
              "z": 0.726
            },
            "gtin": "4008391008656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d75",
            "leftCorner": {
              "x": -11.426,
              "y": -31.658,
              "z": 0.726
            },
            "rightCorner": {
              "x": -11.172,
              "y": -31.657,
              "z": 0.726
            },
            "gtin": "4008391051508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d60",
            "leftCorner": {
              "x": -11.172,
              "y": -31.653,
              "z": 0.726
            },
            "rightCorner": {
              "x": -10.99,
              "y": -31.653,
              "z": 0.726
            },
            "gtin": "4008391005693",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d665",
        "height": 1.1889,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d51",
            "leftCorner": {
              "x": -11.925,
              "y": -31.661,
              "z": 0.973
            },
            "rightCorner": {
              "x": -11.706,
              "y": -31.661,
              "z": 0.973
            },
            "gtin": "4008391041721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d52",
            "leftCorner": {
              "x": -11.706,
              "y": -31.656,
              "z": 0.973
            },
            "rightCorner": {
              "x": -11.475,
              "y": -31.656,
              "z": 0.973
            },
            "gtin": "4008391050419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d53",
            "leftCorner": {
              "x": -11.475,
              "y": -31.655,
              "z": 0.973
            },
            "rightCorner": {
              "x": -11.187,
              "y": -31.655,
              "z": 0.973
            },
            "gtin": "4008391008205",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d5d43",
            "leftCorner": {
              "x": -11.187,
              "y": -31.65,
              "z": 0.973
            },
            "rightCorner": {
              "x": -10.99,
              "y": -31.65,
              "z": 0.973
            },
            "gtin": "4008391041479",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d662",
        "height": 1.5161,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d3c",
            "leftCorner": {
              "x": -11.956,
              "y": -31.665,
              "z": 1.24
            },
            "rightCorner": {
              "x": -11.826,
              "y": -31.665,
              "z": 1.24
            },
            "gtin": "4008391027060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d3d",
            "leftCorner": {
              "x": -11.826,
              "y": -31.665,
              "z": 1.24
            },
            "rightCorner": {
              "x": -11.61,
              "y": -31.664,
              "z": 1.24
            },
            "gtin": "4008391040052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d3e",
            "leftCorner": {
              "x": -11.61,
              "y": -31.668,
              "z": 1.24
            },
            "rightCorner": {
              "x": -11.356,
              "y": -31.668,
              "z": 1.24
            },
            "gtin": "4008391040229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d3f",
            "leftCorner": {
              "x": -11.356,
              "y": -31.659,
              "z": 1.24
            },
            "rightCorner": {
              "x": -11.229,
              "y": -31.659,
              "z": 1.24
            },
            "gtin": "4008391041615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d40",
            "leftCorner": {
              "x": -11.229,
              "y": -31.659,
              "z": 1.24
            },
            "rightCorner": {
              "x": -11.102,
              "y": -31.658,
              "z": 1.24
            },
            "gtin": "4008391041615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d23",
            "leftCorner": {
              "x": -11.102,
              "y": -31.656,
              "z": 1.24
            },
            "rightCorner": {
              "x": -10.99,
              "y": -31.656,
              "z": 1.24
            },
            "gtin": "4008391050846",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "833"
  },
  {
    "id": "835",
    "name": "835",
    "x": -10.34,
    "y": -31.664,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70688,
      "w": 0.70734
    },
    "layers": []
  },
  {
    "id": "837",
    "name": "837",
    "x": -10.382,
    "y": -34.45,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70595,
      "w": 0.70827
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 14,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d054",
        "height": 0.2188,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5e5f",
            "leftCorner": {
              "x": -10.289,
              "y": -34.451,
              "z": 0.179
            },
            "rightCorner": {
              "x": -10.287,
              "y": -33.963,
              "z": 0.179
            },
            "gtin": "4306188400011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e61",
            "leftCorner": {
              "x": -10.325,
              "y": -33.962,
              "z": 0.179
            },
            "rightCorner": {
              "x": -10.324,
              "y": -33.616,
              "z": 0.179
            },
            "gtin": "4306188400073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e60",
            "leftCorner": {
              "x": -10.327,
              "y": -33.616,
              "z": 0.179
            },
            "rightCorner": {
              "x": -10.325,
              "y": -33.2,
              "z": 0.179
            },
            "gtin": "4306188400042",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d055",
        "height": 0.61878,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5e62",
            "leftCorner": {
              "x": -10.332,
              "y": -34.45,
              "z": 0.506
            },
            "rightCorner": {
              "x": -10.329,
              "y": -33.698,
              "z": 0.506
            },
            "gtin": "4002720002261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e63",
            "leftCorner": {
              "x": -10.369,
              "y": -33.699,
              "z": 0.506
            },
            "rightCorner": {
              "x": -10.369,
              "y": -33.449,
              "z": 0.506
            },
            "gtin": "4002720002285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e64",
            "leftCorner": {
              "x": -10.369,
              "y": -33.449,
              "z": 0.506
            },
            "rightCorner": {
              "x": -10.367,
              "y": -33.2,
              "z": 0.506
            },
            "gtin": "4002720002285",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d052",
        "height": 1.0472,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5e57",
            "leftCorner": {
              "x": -10.329,
              "y": -34.45,
              "z": 0.857
            },
            "rightCorner": {
              "x": -10.327,
              "y": -33.919,
              "z": 0.857
            },
            "gtin": "8711000504895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e59",
            "leftCorner": {
              "x": -10.363,
              "y": -33.919,
              "z": 0.857
            },
            "rightCorner": {
              "x": -10.362,
              "y": -33.546,
              "z": 0.857
            },
            "gtin": "4002720002117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e5a",
            "leftCorner": {
              "x": -10.368,
              "y": -33.546,
              "z": 0.857
            },
            "rightCorner": {
              "x": -10.368,
              "y": -33.339,
              "z": 0.857
            },
            "gtin": "4002720000496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e58",
            "leftCorner": {
              "x": -10.372,
              "y": -33.339,
              "z": 0.857
            },
            "rightCorner": {
              "x": -10.372,
              "y": -33.2,
              "z": 0.857
            },
            "gtin": "4002720002100",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d053",
        "height": 1.453,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5e5b",
            "leftCorner": {
              "x": -10.318,
              "y": -34.45,
              "z": 1.189
            },
            "rightCorner": {
              "x": -10.317,
              "y": -33.915,
              "z": 1.189
            },
            "gtin": "8711000500002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e5d",
            "leftCorner": {
              "x": -10.354,
              "y": -33.916,
              "z": 1.189
            },
            "rightCorner": {
              "x": -10.353,
              "y": -33.569,
              "z": 1.189
            },
            "gtin": "8711000501153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e5e",
            "leftCorner": {
              "x": -10.358,
              "y": -33.57,
              "z": 1.189
            },
            "rightCorner": {
              "x": -10.357,
              "y": -33.455,
              "z": 1.189
            },
            "gtin": "8711000390757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e5c",
            "leftCorner": {
              "x": -10.361,
              "y": -33.455,
              "z": 1.189
            },
            "rightCorner": {
              "x": -10.361,
              "y": -33.201,
              "z": 1.189
            },
            "gtin": "8711000584453",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "838",
    "name": "838",
    "x": -16.322,
    "y": -33.292,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70867,
      "w": 0.70554
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 23
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d046",
        "height": 0.23035,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5dc8",
            "leftCorner": {
              "x": -16.43,
              "y": -33.292,
              "z": 0.188
            },
            "rightCorner": {
              "x": -16.431,
              "y": -33.584,
              "z": 0.188
            },
            "gtin": "4005720000862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dc9",
            "leftCorner": {
              "x": -16.431,
              "y": -33.584,
              "z": 0.188
            },
            "rightCorner": {
              "x": -16.433,
              "y": -33.876,
              "z": 0.188
            },
            "gtin": "4005720000862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dca",
            "leftCorner": {
              "x": -16.393,
              "y": -33.876,
              "z": 0.188
            },
            "rightCorner": {
              "x": -16.394,
              "y": -34.098,
              "z": 0.188
            },
            "gtin": "3057640376498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dcb",
            "leftCorner": {
              "x": -16.394,
              "y": -34.098,
              "z": 0.188
            },
            "rightCorner": {
              "x": -16.395,
              "y": -34.32,
              "z": 0.188
            },
            "gtin": "3057640376498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dcc",
            "leftCorner": {
              "x": -16.395,
              "y": -34.32,
              "z": 0.188
            },
            "rightCorner": {
              "x": -16.396,
              "y": -34.542,
              "z": 0.188
            },
            "gtin": "3057640376498",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d044",
        "height": 0.65523,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5dbb",
            "leftCorner": {
              "x": -16.397,
              "y": -33.292,
              "z": 0.536
            },
            "rightCorner": {
              "x": -16.398,
              "y": -33.483,
              "z": 0.536
            },
            "gtin": "4260456730395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dbc",
            "leftCorner": {
              "x": -16.398,
              "y": -33.483,
              "z": 0.536
            },
            "rightCorner": {
              "x": -16.398,
              "y": -33.674,
              "z": 0.536
            },
            "gtin": "4260456730395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dc1",
            "leftCorner": {
              "x": -16.359,
              "y": -33.675,
              "z": 0.536
            },
            "rightCorner": {
              "x": -16.361,
              "y": -33.786,
              "z": 0.536
            },
            "gtin": "4260456730388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dc2",
            "leftCorner": {
              "x": -16.361,
              "y": -33.786,
              "z": 0.536
            },
            "rightCorner": {
              "x": -16.361,
              "y": -33.896,
              "z": 0.536
            },
            "gtin": "4260456730388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dc3",
            "leftCorner": {
              "x": -16.361,
              "y": -33.896,
              "z": 0.536
            },
            "rightCorner": {
              "x": -16.361,
              "y": -34.007,
              "z": 0.536
            },
            "gtin": "4260456730388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dbd",
            "leftCorner": {
              "x": -16.359,
              "y": -34.007,
              "z": 0.536
            },
            "rightCorner": {
              "x": -16.36,
              "y": -34.141,
              "z": 0.536
            },
            "gtin": "4025127014866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dbe",
            "leftCorner": {
              "x": -16.36,
              "y": -34.141,
              "z": 0.536
            },
            "rightCorner": {
              "x": -16.36,
              "y": -34.275,
              "z": 0.536
            },
            "gtin": "4025127014866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dbf",
            "leftCorner": {
              "x": -16.36,
              "y": -34.275,
              "z": 0.536
            },
            "rightCorner": {
              "x": -16.361,
              "y": -34.409,
              "z": 0.536
            },
            "gtin": "4025127014866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dc0",
            "leftCorner": {
              "x": -16.361,
              "y": -34.409,
              "z": 0.536
            },
            "rightCorner": {
              "x": -16.362,
              "y": -34.543,
              "z": 0.536
            },
            "gtin": "4025127014866",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d047",
        "height": 1.0108,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5dcd",
            "leftCorner": {
              "x": -16.395,
              "y": -33.292,
              "z": 0.827
            },
            "rightCorner": {
              "x": -16.398,
              "y": -33.977,
              "z": 0.827
            },
            "gtin": "5998749146712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dce",
            "leftCorner": {
              "x": -16.358,
              "y": -33.977,
              "z": 0.827
            },
            "rightCorner": {
              "x": -16.361,
              "y": -34.543,
              "z": 0.827
            },
            "gtin": "4008429037894",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d045",
        "height": 1.3149,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5dc4",
            "leftCorner": {
              "x": -16.396,
              "y": -33.292,
              "z": 1.076
            },
            "rightCorner": {
              "x": -16.398,
              "y": -33.721,
              "z": 1.076
            },
            "gtin": "4062139025015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "61f52daf09b210af0b6a3297",
            "leftCorner": {
              "x": -16.398,
              "y": -33.721,
              "z": 1.076
            },
            "rightCorner": {
              "x": -16.401,
              "y": -34.319,
              "z": 1.076
            },
            "gtin": "4062139025039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dc5",
            "leftCorner": {
              "x": -16.362,
              "y": -34.322,
              "z": 1.076
            },
            "rightCorner": {
              "x": -16.364,
              "y": -34.543,
              "z": 1.076
            },
            "gtin": "4062139025077",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d043",
        "height": 1.5627,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5db7",
            "leftCorner": {
              "x": -16.4,
              "y": -33.292,
              "z": 1.279
            },
            "rightCorner": {
              "x": -16.401,
              "y": -33.651,
              "z": 1.279
            },
            "gtin": "4009077026018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5db9",
            "leftCorner": {
              "x": -16.366,
              "y": -33.652,
              "z": 1.279
            },
            "rightCorner": {
              "x": -16.368,
              "y": -33.952,
              "z": 1.279
            },
            "gtin": "4009077024151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dba",
            "leftCorner": {
              "x": -16.363,
              "y": -33.952,
              "z": 1.279
            },
            "rightCorner": {
              "x": -16.364,
              "y": -34.249,
              "z": 1.279
            },
            "gtin": "4009077024106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5db8",
            "leftCorner": {
              "x": -16.364,
              "y": -34.249,
              "z": 1.279
            },
            "rightCorner": {
              "x": -16.366,
              "y": -34.543,
              "z": 1.279
            },
            "gtin": "4009077024601",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "839",
    "name": "839",
    "x": -15.744,
    "y": -34.539,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0082728,
      "w": 0.99997
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 44
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d66d",
        "height": 0.15403,
        "facings": [
          {
            "id": "34e413d52d73b276aa5cdb58",
            "leftCorner": {
              "x": -15.745,
              "y": -34.51,
              "z": 0.126
            },
            "rightCorner": {
              "x": -15.655,
              "y": -34.509,
              "z": 0.126
            },
            "gtin": "4011800189129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7de5f3a2de309eb21357c01e",
            "leftCorner": {
              "x": -15.655,
              "y": -34.509,
              "z": 0.126
            },
            "rightCorner": {
              "x": -15.533,
              "y": -34.506,
              "z": 0.126
            },
            "gtin": "4002575475180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "37588a2833105a5b139113f1",
            "leftCorner": {
              "x": -15.533,
              "y": -34.506,
              "z": 0.126
            },
            "rightCorner": {
              "x": -15.41,
              "y": -34.504,
              "z": 0.126
            },
            "gtin": "4002575311105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2f8015be19bdc1d8169672d5",
            "leftCorner": {
              "x": -15.41,
              "y": -34.504,
              "z": 0.126
            },
            "rightCorner": {
              "x": -15.285,
              "y": -34.502,
              "z": 0.126
            },
            "gtin": "4002575475104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "69078532f1a069b01860cfd3",
            "leftCorner": {
              "x": -15.285,
              "y": -34.502,
              "z": 0.126
            },
            "rightCorner": {
              "x": -15.158,
              "y": -34.5,
              "z": 0.126
            },
            "gtin": "4002575475142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c16367d8ce6467c93bf11067",
            "leftCorner": {
              "x": -15.158,
              "y": -34.5,
              "z": 0.126
            },
            "rightCorner": {
              "x": -15.03,
              "y": -34.498,
              "z": 0.126
            },
            "gtin": "4002575631401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "facbb562630127bfa4bc87d8",
            "leftCorner": {
              "x": -15.03,
              "y": -34.498,
              "z": 0.126
            },
            "rightCorner": {
              "x": -14.901,
              "y": -34.496,
              "z": 0.126
            },
            "gtin": "4002575311129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f9fa93203fa3cea4bb15d68b",
            "leftCorner": {
              "x": -14.901,
              "y": -34.496,
              "z": 0.126
            },
            "rightCorner": {
              "x": -14.771,
              "y": -34.494,
              "z": 0.126
            },
            "gtin": "4002575311143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "45584522f2a9e8d013557644",
            "leftCorner": {
              "x": -14.771,
              "y": -34.494,
              "z": 0.126
            },
            "rightCorner": {
              "x": -14.512,
              "y": -34.49,
              "z": 0.126
            },
            "gtin": "4026701034003",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d669",
        "height": 0.45892,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5df2",
            "leftCorner": {
              "x": -15.743,
              "y": -34.576,
              "z": 0.375
            },
            "rightCorner": {
              "x": -15.629,
              "y": -34.574,
              "z": 0.375
            },
            "gtin": "4002575475180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5df4",
            "leftCorner": {
              "x": -15.63,
              "y": -34.521,
              "z": 0.375
            },
            "rightCorner": {
              "x": -15.584,
              "y": -34.52,
              "z": 0.375
            },
            "gtin": "4002575475166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5df5",
            "leftCorner": {
              "x": -15.584,
              "y": -34.52,
              "z": 0.375
            },
            "rightCorner": {
              "x": -15.538,
              "y": -34.52,
              "z": 0.375
            },
            "gtin": "4002575475166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5df6",
            "leftCorner": {
              "x": -15.538,
              "y": -34.52,
              "z": 0.375
            },
            "rightCorner": {
              "x": -15.492,
              "y": -34.519,
              "z": 0.375
            },
            "gtin": "4002575475166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5df7",
            "leftCorner": {
              "x": -15.492,
              "y": -34.526,
              "z": 0.375
            },
            "rightCorner": {
              "x": -15.332,
              "y": -34.524,
              "z": 0.375
            },
            "gtin": "4002575475142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5df8",
            "leftCorner": {
              "x": -15.332,
              "y": -34.522,
              "z": 0.375
            },
            "rightCorner": {
              "x": -15.196,
              "y": -34.52,
              "z": 0.375
            },
            "gtin": "4002575311129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5df9",
            "leftCorner": {
              "x": -15.196,
              "y": -34.524,
              "z": 0.375
            },
            "rightCorner": {
              "x": -15.101,
              "y": -34.522,
              "z": 0.375
            },
            "gtin": "4002575311143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dfa",
            "leftCorner": {
              "x": -15.101,
              "y": -34.53,
              "z": 0.375
            },
            "rightCorner": {
              "x": -14.981,
              "y": -34.528,
              "z": 0.375
            },
            "gtin": "4002575475104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dfb",
            "leftCorner": {
              "x": -14.981,
              "y": -34.528,
              "z": 0.375
            },
            "rightCorner": {
              "x": -14.834,
              "y": -34.525,
              "z": 0.375
            },
            "gtin": "4002575342109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dfc",
            "leftCorner": {
              "x": -14.834,
              "y": -34.526,
              "z": 0.375
            },
            "rightCorner": {
              "x": -14.66,
              "y": -34.524,
              "z": 0.375
            },
            "gtin": "4002575475227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dfd",
            "leftCorner": {
              "x": -14.66,
              "y": -34.523,
              "z": 0.375
            },
            "rightCorner": {
              "x": -14.445,
              "y": -34.52,
              "z": 0.375
            },
            "gtin": "4026701000800",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d66a",
        "height": 0.75537,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5e2c",
            "leftCorner": {
              "x": -15.743,
              "y": -34.576,
              "z": 0.618
            },
            "rightCorner": {
              "x": -15.583,
              "y": -34.573,
              "z": 0.618
            },
            "gtin": "4002575629071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e2e",
            "leftCorner": {
              "x": -15.584,
              "y": -34.527,
              "z": 0.618
            },
            "rightCorner": {
              "x": -15.423,
              "y": -34.525,
              "z": 0.618
            },
            "gtin": "4002575629156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e2f",
            "leftCorner": {
              "x": -15.423,
              "y": -34.526,
              "z": 0.618
            },
            "rightCorner": {
              "x": -15.231,
              "y": -34.523,
              "z": 0.618
            },
            "gtin": "4002575629057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e30",
            "leftCorner": {
              "x": -15.231,
              "y": -34.523,
              "z": 0.618
            },
            "rightCorner": {
              "x": -15.143,
              "y": -34.521,
              "z": 0.618
            },
            "gtin": "4002575629132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e32",
            "leftCorner": {
              "x": -15.088,
              "y": -34.53,
              "z": 0.618
            },
            "rightCorner": {
              "x": -14.969,
              "y": -34.528,
              "z": 0.618
            },
            "gtin": "4002575311105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e33",
            "leftCorner": {
              "x": -14.969,
              "y": -34.53,
              "z": 0.618
            },
            "rightCorner": {
              "x": -14.853,
              "y": -34.528,
              "z": 0.618
            },
            "gtin": "4002575631401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e34",
            "leftCorner": {
              "x": -14.853,
              "y": -34.526,
              "z": 0.618
            },
            "rightCorner": {
              "x": -14.686,
              "y": -34.523,
              "z": 0.618
            },
            "gtin": "4002575631371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e35",
            "leftCorner": {
              "x": -14.686,
              "y": -34.526,
              "z": 0.618
            },
            "rightCorner": {
              "x": -14.459,
              "y": -34.522,
              "z": 0.618
            },
            "gtin": "4002575631425",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d66b",
        "height": 0.86478,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d862c",
            "leftCorner": {
              "x": -14.682,
              "y": -34.238,
              "z": 0.708
            },
            "rightCorner": {
              "x": -14.499,
              "y": -34.235,
              "z": 0.708
            },
            "gtin": "4002575631425",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d668",
        "height": 1.0602,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5e0d",
            "leftCorner": {
              "x": -15.743,
              "y": -34.579,
              "z": 0.867
            },
            "rightCorner": {
              "x": -15.565,
              "y": -34.576,
              "z": 0.867
            },
            "gtin": "4002575643701",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d5e0f",
            "leftCorner": {
              "x": -15.566,
              "y": -34.525,
              "z": 0.867
            },
            "rightCorner": {
              "x": -15.389,
              "y": -34.522,
              "z": 0.867
            },
            "gtin": "4002575643688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e10",
            "leftCorner": {
              "x": -15.389,
              "y": -34.523,
              "z": 0.867
            },
            "rightCorner": {
              "x": -15.205,
              "y": -34.521,
              "z": 0.867
            },
            "gtin": "4002575643725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e11",
            "leftCorner": {
              "x": -15.204,
              "y": -34.529,
              "z": 0.867
            },
            "rightCorner": {
              "x": -15.128,
              "y": -34.528,
              "z": 0.867
            },
            "gtin": "4002575629231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e12",
            "leftCorner": {
              "x": -15.128,
              "y": -34.528,
              "z": 0.867
            },
            "rightCorner": {
              "x": -15.052,
              "y": -34.527,
              "z": 0.867
            },
            "gtin": "4002575629231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e13",
            "leftCorner": {
              "x": -15.052,
              "y": -34.529,
              "z": 0.867
            },
            "rightCorner": {
              "x": -14.899,
              "y": -34.526,
              "z": 0.867
            },
            "gtin": "4002575629217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e14",
            "leftCorner": {
              "x": -14.899,
              "y": -34.531,
              "z": 0.867
            },
            "rightCorner": {
              "x": -14.724,
              "y": -34.528,
              "z": 0.867
            },
            "gtin": "4002575629170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e15",
            "leftCorner": {
              "x": -14.724,
              "y": -34.529,
              "z": 0.867
            },
            "rightCorner": {
              "x": -14.58,
              "y": -34.526,
              "z": 0.867
            },
            "gtin": "4002575629118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e16",
            "leftCorner": {
              "x": -14.58,
              "y": -34.527,
              "z": 0.867
            },
            "rightCorner": {
              "x": -14.437,
              "y": -34.525,
              "z": 0.867
            },
            "gtin": "4011800189129",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d667",
        "height": 1.3632,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5dcf",
            "leftCorner": {
              "x": -15.743,
              "y": -34.583,
              "z": 1.115
            },
            "rightCorner": {
              "x": -15.553,
              "y": -34.581,
              "z": 1.115
            },
            "gtin": "80298380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dd1",
            "leftCorner": {
              "x": -15.554,
              "y": -34.528,
              "z": 1.115
            },
            "rightCorner": {
              "x": -15.454,
              "y": -34.526,
              "z": 1.115
            },
            "gtin": "80298311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dd2",
            "leftCorner": {
              "x": -15.454,
              "y": -34.526,
              "z": 1.115
            },
            "rightCorner": {
              "x": -15.353,
              "y": -34.523,
              "z": 1.115
            },
            "gtin": "80298311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dd3",
            "leftCorner": {
              "x": -15.353,
              "y": -34.53,
              "z": 1.115
            },
            "rightCorner": {
              "x": -15.18,
              "y": -34.527,
              "z": 1.115
            },
            "gtin": "80298403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dd4",
            "leftCorner": {
              "x": -15.18,
              "y": -34.532,
              "z": 1.115
            },
            "rightCorner": {
              "x": -15.041,
              "y": -34.529,
              "z": 1.115
            },
            "gtin": "80298441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dd5",
            "leftCorner": {
              "x": -15.041,
              "y": -34.534,
              "z": 1.115
            },
            "rightCorner": {
              "x": -14.774,
              "y": -34.53,
              "z": 1.115
            },
            "gtin": "4026701034003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dd6",
            "leftCorner": {
              "x": -14.774,
              "y": -34.531,
              "z": 1.115
            },
            "rightCorner": {
              "x": -14.638,
              "y": -34.528,
              "z": 1.115
            },
            "gtin": "4011800000530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dd7",
            "leftCorner": {
              "x": -14.638,
              "y": -34.531,
              "z": 1.115
            },
            "rightCorner": {
              "x": -14.461,
              "y": -34.527,
              "z": 1.115
            },
            "gtin": "4011800200022",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "83a"
  },
  {
    "id": "83a",
    "name": "83a",
    "x": -14.494,
    "y": -34.518,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0082728,
      "w": 0.99997
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d04c",
        "height": 0.16466,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5e44",
            "leftCorner": {
              "x": -14.492,
              "y": -34.626,
              "z": 0.135
            },
            "rightCorner": {
              "x": -14.097,
              "y": -34.62,
              "z": 0.135
            },
            "gtin": "5701116215009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e45",
            "leftCorner": {
              "x": -14.097,
              "y": -34.58,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.944,
              "y": -34.577,
              "z": 0.135
            },
            "gtin": "5701116215030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e46",
            "leftCorner": {
              "x": -13.944,
              "y": -34.577,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.657,
              "y": -34.573,
              "z": 0.135
            },
            "gtin": "4306188393108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e47",
            "leftCorner": {
              "x": -13.657,
              "y": -34.573,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.523,
              "y": -34.57,
              "z": 0.135
            },
            "gtin": "4002575602838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e48",
            "leftCorner": {
              "x": -13.523,
              "y": -34.571,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.309,
              "y": -34.567,
              "z": 0.135
            },
            "gtin": "4002575604603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e49",
            "leftCorner": {
              "x": -13.309,
              "y": -34.571,
              "z": 0.135
            },
            "rightCorner": {
              "x": -13.146,
              "y": -34.568,
              "z": 0.135
            },
            "gtin": "4104420045668",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d049",
        "height": 0.45514,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5dfe",
            "leftCorner": {
              "x": -14.444,
              "y": -34.527,
              "z": 0.372
            },
            "rightCorner": {
              "x": -14.328,
              "y": -34.525,
              "z": 0.372
            },
            "gtin": "4026701000305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dff",
            "leftCorner": {
              "x": -14.328,
              "y": -34.522,
              "z": 0.372
            },
            "rightCorner": {
              "x": -14.149,
              "y": -34.519,
              "z": 0.372
            },
            "gtin": "4026701006536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e00",
            "leftCorner": {
              "x": -14.149,
              "y": -34.516,
              "z": 0.372
            },
            "rightCorner": {
              "x": -13.962,
              "y": -34.512,
              "z": 0.372
            },
            "gtin": "4026701000107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e01",
            "leftCorner": {
              "x": -13.962,
              "y": -34.51,
              "z": 0.372
            },
            "rightCorner": {
              "x": -13.787,
              "y": -34.508,
              "z": 0.372
            },
            "gtin": "4026701001272",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e509e1820c81800d5e02",
            "leftCorner": {
              "x": -13.787,
              "y": -34.51,
              "z": 0.372
            },
            "rightCorner": {
              "x": -13.619,
              "y": -34.508,
              "z": 0.372
            },
            "gtin": "4026701000404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e03",
            "leftCorner": {
              "x": -13.619,
              "y": -34.508,
              "z": 0.372
            },
            "rightCorner": {
              "x": -13.441,
              "y": -34.505,
              "z": 0.372
            },
            "gtin": "4054600821219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e04",
            "leftCorner": {
              "x": -13.441,
              "y": -34.509,
              "z": 0.372
            },
            "rightCorner": {
              "x": -13.323,
              "y": -34.506,
              "z": 0.372
            },
            "gtin": "4054600821318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e05",
            "leftCorner": {
              "x": -13.323,
              "y": -34.506,
              "z": 0.372
            },
            "rightCorner": {
              "x": -13.205,
              "y": -34.505,
              "z": 0.372
            },
            "gtin": "4054600821318",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d04b",
        "height": 0.75245,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5e36",
            "leftCorner": {
              "x": -14.458,
              "y": -34.525,
              "z": 0.616
            },
            "rightCorner": {
              "x": -14.28,
              "y": -34.521,
              "z": 0.616
            },
            "gtin": "4054600880612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e37",
            "leftCorner": {
              "x": -14.28,
              "y": -34.519,
              "z": 0.616
            },
            "rightCorner": {
              "x": -14.104,
              "y": -34.516,
              "z": 0.616
            },
            "gtin": "4054600880216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e38",
            "leftCorner": {
              "x": -14.104,
              "y": -34.516,
              "z": 0.616
            },
            "rightCorner": {
              "x": -13.927,
              "y": -34.513,
              "z": 0.616
            },
            "gtin": "4054600880117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e39",
            "leftCorner": {
              "x": -13.927,
              "y": -34.512,
              "z": 0.616
            },
            "rightCorner": {
              "x": -13.839,
              "y": -34.511,
              "z": 0.616
            },
            "gtin": "4054600880414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e3a",
            "leftCorner": {
              "x": -13.839,
              "y": -34.511,
              "z": 0.616
            },
            "rightCorner": {
              "x": -13.751,
              "y": -34.509,
              "z": 0.616
            },
            "gtin": "4054600880414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e3b",
            "leftCorner": {
              "x": -13.751,
              "y": -34.51,
              "z": 0.616
            },
            "rightCorner": {
              "x": -13.559,
              "y": -34.506,
              "z": 0.616
            },
            "gtin": "4054600880018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e3c",
            "leftCorner": {
              "x": -13.559,
              "y": -34.511,
              "z": 0.616
            },
            "rightCorner": {
              "x": -13.41,
              "y": -34.51,
              "z": 0.616
            },
            "gtin": "4054600072819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e3d",
            "leftCorner": {
              "x": -13.41,
              "y": -34.511,
              "z": 0.616
            },
            "rightCorner": {
              "x": -13.035,
              "y": -34.504,
              "z": 0.616
            },
            "gtin": "4054600079313",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d04a",
        "height": 1.0547,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5e17",
            "leftCorner": {
              "x": -14.436,
              "y": -34.531,
              "z": 0.863
            },
            "rightCorner": {
              "x": -14.259,
              "y": -34.528,
              "z": 0.863
            },
            "gtin": "4011800189426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e18",
            "leftCorner": {
              "x": -14.259,
              "y": -34.525,
              "z": 0.863
            },
            "rightCorner": {
              "x": -14.082,
              "y": -34.522,
              "z": 0.863
            },
            "gtin": "5701211014071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e19",
            "leftCorner": {
              "x": -14.082,
              "y": -34.52,
              "z": 0.863
            },
            "rightCorner": {
              "x": -13.897,
              "y": -34.517,
              "z": 0.863
            },
            "gtin": "5701211014156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e1a",
            "leftCorner": {
              "x": -13.897,
              "y": -34.515,
              "z": 0.863
            },
            "rightCorner": {
              "x": -13.729,
              "y": -34.512,
              "z": 0.863
            },
            "gtin": "5701211014019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e1b",
            "leftCorner": {
              "x": -13.729,
              "y": -34.513,
              "z": 0.863
            },
            "rightCorner": {
              "x": -13.54,
              "y": -34.509,
              "z": 0.863
            },
            "gtin": "5701211014033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e1c",
            "leftCorner": {
              "x": -13.54,
              "y": -34.51,
              "z": 0.863
            },
            "rightCorner": {
              "x": -13.371,
              "y": -34.507,
              "z": 0.863
            },
            "gtin": "5701211013937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e1d",
            "leftCorner": {
              "x": -13.371,
              "y": -34.513,
              "z": 0.863
            },
            "rightCorner": {
              "x": -13.205,
              "y": -34.51,
              "z": 0.863
            },
            "gtin": "4011800844813",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d048",
        "height": 1.3569,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5dd8",
            "leftCorner": {
              "x": -14.46,
              "y": -34.533,
              "z": 1.11
            },
            "rightCorner": {
              "x": -14.361,
              "y": -34.531,
              "z": 1.11
            },
            "gtin": "4011800203023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dd9",
            "leftCorner": {
              "x": -14.361,
              "y": -34.53,
              "z": 1.11
            },
            "rightCorner": {
              "x": -14.271,
              "y": -34.528,
              "z": 1.11
            },
            "gtin": "4011800210021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dda",
            "leftCorner": {
              "x": -14.271,
              "y": -34.528,
              "z": 1.11
            },
            "rightCorner": {
              "x": -14.174,
              "y": -34.526,
              "z": 1.11
            },
            "gtin": "4011800000516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ddb",
            "leftCorner": {
              "x": -14.174,
              "y": -34.526,
              "z": 1.11
            },
            "rightCorner": {
              "x": -14.083,
              "y": -34.524,
              "z": 1.11
            },
            "gtin": "4011800200220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ddc",
            "leftCorner": {
              "x": -14.083,
              "y": -34.524,
              "z": 1.11
            },
            "rightCorner": {
              "x": -13.981,
              "y": -34.522,
              "z": 1.11
            },
            "gtin": "4011800207014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ddd",
            "leftCorner": {
              "x": -13.981,
              "y": -34.522,
              "z": 1.11
            },
            "rightCorner": {
              "x": -13.859,
              "y": -34.52,
              "z": 1.11
            },
            "gtin": "4011800212018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dde",
            "leftCorner": {
              "x": -13.859,
              "y": -34.52,
              "z": 1.11
            },
            "rightCorner": {
              "x": -13.737,
              "y": -34.518,
              "z": 1.11
            },
            "gtin": "4011800201029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ddf",
            "leftCorner": {
              "x": -13.737,
              "y": -34.518,
              "z": 1.11
            },
            "rightCorner": {
              "x": -13.599,
              "y": -34.516,
              "z": 1.11
            },
            "gtin": "4011800216221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5de0",
            "leftCorner": {
              "x": -13.599,
              "y": -34.519,
              "z": 1.11
            },
            "rightCorner": {
              "x": -13.473,
              "y": -34.517,
              "z": 1.11
            },
            "gtin": "4011800202026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5de1",
            "leftCorner": {
              "x": -13.473,
              "y": -34.517,
              "z": 1.11
            },
            "rightCorner": {
              "x": -13.332,
              "y": -34.516,
              "z": 1.11
            },
            "gtin": "4011800224028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5de2",
            "leftCorner": {
              "x": -13.332,
              "y": -34.518,
              "z": 1.11
            },
            "rightCorner": {
              "x": -13.2,
              "y": -34.515,
              "z": 1.11
            },
            "gtin": "4011800001445",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "839",
    "rightNeighborShelfId": "83b"
  },
  {
    "id": "83b",
    "name": "83b",
    "x": -13.244,
    "y": -34.497,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0082728,
      "w": 0.99997
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d051",
        "height": 0.17438,
        "facings": [
          {
            "id": "3b504d5a95f7b8ad04c4b1de",
            "leftCorner": {
              "x": -13.243,
              "y": -34.588,
              "z": 0.143
            },
            "rightCorner": {
              "x": -13.133,
              "y": -34.586,
              "z": 0.143
            },
            "gtin": "4054600821516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5d9c5c41db3a2aff2c858b90",
            "leftCorner": {
              "x": -13.133,
              "y": -34.586,
              "z": 0.143
            },
            "rightCorner": {
              "x": -13.017,
              "y": -34.584,
              "z": 0.143
            },
            "gtin": "4011800840310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "02eaf4144de79f051f381fbe",
            "leftCorner": {
              "x": -13.017,
              "y": -34.584,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.899,
              "y": -34.582,
              "z": 0.143
            },
            "gtin": "40118017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c86e914b31ab33eef2ebf2ae",
            "leftCorner": {
              "x": -12.899,
              "y": -34.582,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.78,
              "y": -34.58,
              "z": 0.143
            },
            "gtin": "4011800841119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9257c4126e8798204a68bc05",
            "leftCorner": {
              "x": -12.78,
              "y": -34.58,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.659,
              "y": -34.578,
              "z": 0.143
            },
            "gtin": "40118048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b99bf6f2159da61da84f0679",
            "leftCorner": {
              "x": -12.659,
              "y": -34.578,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.533,
              "y": -34.576,
              "z": 0.143
            },
            "gtin": "4011800840617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "34896126850f3c4e1162b6ed",
            "leftCorner": {
              "x": -12.533,
              "y": -34.576,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.406,
              "y": -34.574,
              "z": 0.143
            },
            "gtin": "40118031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5f87bbaed5dc125b5602a6fb",
            "leftCorner": {
              "x": -12.406,
              "y": -34.574,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.276,
              "y": -34.572,
              "z": 0.143
            },
            "gtin": "40118024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9127d6368ec53c22f2c9882d",
            "leftCorner": {
              "x": -12.276,
              "y": -34.572,
              "z": 0.143
            },
            "rightCorner": {
              "x": -12.083,
              "y": -34.569,
              "z": 0.143
            },
            "gtin": "4054600079610",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d04d",
        "height": 0.4529,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5e06",
            "leftCorner": {
              "x": -13.206,
              "y": -34.507,
              "z": 0.371
            },
            "rightCorner": {
              "x": -13.106,
              "y": -34.506,
              "z": 0.371
            },
            "gtin": "4054600821516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e07",
            "leftCorner": {
              "x": -13.106,
              "y": -34.504,
              "z": 0.371
            },
            "rightCorner": {
              "x": -12.932,
              "y": -34.501,
              "z": 0.371
            },
            "gtin": "4054600820915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e08",
            "leftCorner": {
              "x": -12.932,
              "y": -34.501,
              "z": 0.371
            },
            "rightCorner": {
              "x": -12.744,
              "y": -34.499,
              "z": 0.371
            },
            "gtin": "4054600821110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e09",
            "leftCorner": {
              "x": -12.744,
              "y": -34.498,
              "z": 0.371
            },
            "rightCorner": {
              "x": -12.568,
              "y": -34.494,
              "z": 0.371
            },
            "gtin": "4054600821011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e0a",
            "leftCorner": {
              "x": -12.568,
              "y": -34.492,
              "z": 0.371
            },
            "rightCorner": {
              "x": -12.401,
              "y": -34.489,
              "z": 0.371
            },
            "gtin": "4011800840914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e0b",
            "leftCorner": {
              "x": -12.401,
              "y": -34.484,
              "z": 0.371
            },
            "rightCorner": {
              "x": -12.242,
              "y": -34.482,
              "z": 0.371
            },
            "gtin": "4011800841416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e0c",
            "leftCorner": {
              "x": -12.242,
              "y": -34.483,
              "z": 0.371
            },
            "rightCorner": {
              "x": -12.108,
              "y": -34.481,
              "z": 0.371
            },
            "gtin": "4011800841218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5df3",
            "leftCorner": {
              "x": -12.108,
              "y": -34.481,
              "z": 0.371
            },
            "rightCorner": {
              "x": -11.994,
              "y": -34.48,
              "z": 0.371
            },
            "gtin": "4011800840617",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d050",
        "height": 0.74992,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5e3e",
            "leftCorner": {
              "x": -13.036,
              "y": -34.506,
              "z": 0.614
            },
            "rightCorner": {
              "x": -12.852,
              "y": -34.503,
              "z": 0.614
            },
            "gtin": "4054600081415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e3f",
            "leftCorner": {
              "x": -12.852,
              "y": -34.502,
              "z": 0.614
            },
            "rightCorner": {
              "x": -12.652,
              "y": -34.499,
              "z": 0.614
            },
            "gtin": "4054600079610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e40",
            "leftCorner": {
              "x": -12.652,
              "y": -34.498,
              "z": 0.614
            },
            "rightCorner": {
              "x": -12.522,
              "y": -34.495,
              "z": 0.614
            },
            "gtin": "4011800840518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e41",
            "leftCorner": {
              "x": -12.522,
              "y": -34.493,
              "z": 0.614
            },
            "rightCorner": {
              "x": -12.398,
              "y": -34.491,
              "z": 0.614
            },
            "gtin": "4011800841119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e42",
            "leftCorner": {
              "x": -12.398,
              "y": -34.489,
              "z": 0.614
            },
            "rightCorner": {
              "x": -12.253,
              "y": -34.487,
              "z": 0.614
            },
            "gtin": "4011800841812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e43",
            "leftCorner": {
              "x": -12.253,
              "y": -34.49,
              "z": 0.614
            },
            "rightCorner": {
              "x": -12.093,
              "y": -34.488,
              "z": 0.614
            },
            "gtin": "4011800840112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e2d",
            "leftCorner": {
              "x": -12.093,
              "y": -34.488,
              "z": 0.614
            },
            "rightCorner": {
              "x": -11.994,
              "y": -34.486,
              "z": 0.614
            },
            "gtin": "4011800840310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f3c2a88b889277da77b24fba",
            "leftCorner": {
              "x": -13.243,
              "y": -34.547,
              "z": 0.614
            },
            "rightCorner": {
              "x": -13.08,
              "y": -34.544,
              "z": 0.614
            },
            "gtin": "4054600081286",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d04f",
        "height": 1.0551,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5e1e",
            "leftCorner": {
              "x": -13.206,
              "y": -34.509,
              "z": 0.863
            },
            "rightCorner": {
              "x": -13.058,
              "y": -34.507,
              "z": 0.863
            },
            "gtin": "4011800844714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e1f",
            "leftCorner": {
              "x": -13.058,
              "y": -34.508,
              "z": 0.863
            },
            "rightCorner": {
              "x": -12.917,
              "y": -34.506,
              "z": 0.863
            },
            "gtin": "4011800844110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e20",
            "leftCorner": {
              "x": -12.917,
              "y": -34.505,
              "z": 0.863
            },
            "rightCorner": {
              "x": -12.759,
              "y": -34.502,
              "z": 0.863
            },
            "gtin": "4011800844615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e21",
            "leftCorner": {
              "x": -12.759,
              "y": -34.502,
              "z": 0.863
            },
            "rightCorner": {
              "x": -12.605,
              "y": -34.5,
              "z": 0.863
            },
            "gtin": "4011800845513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e22",
            "leftCorner": {
              "x": -12.605,
              "y": -34.5,
              "z": 0.863
            },
            "rightCorner": {
              "x": -12.451,
              "y": -34.497,
              "z": 0.863
            },
            "gtin": "4011800844011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e23",
            "leftCorner": {
              "x": -12.451,
              "y": -34.492,
              "z": 0.863
            },
            "rightCorner": {
              "x": -12.297,
              "y": -34.489,
              "z": 0.863
            },
            "gtin": "4011800174316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e24",
            "leftCorner": {
              "x": -12.297,
              "y": -34.489,
              "z": 0.863
            },
            "rightCorner": {
              "x": -12.12,
              "y": -34.487,
              "z": 0.863
            },
            "gtin": "4011800844417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e25",
            "leftCorner": {
              "x": -12.12,
              "y": -34.49,
              "z": 0.863
            },
            "rightCorner": {
              "x": -11.951,
              "y": -34.486,
              "z": 0.863
            },
            "gtin": "4011800843113",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d04e",
        "height": 1.3594,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5de3",
            "leftCorner": {
              "x": -13.201,
              "y": -34.516,
              "z": 1.112
            },
            "rightCorner": {
              "x": -13.072,
              "y": -34.513,
              "z": 1.112
            },
            "gtin": "40118017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5de4",
            "leftCorner": {
              "x": -13.072,
              "y": -34.512,
              "z": 1.112
            },
            "rightCorner": {
              "x": -12.947,
              "y": -34.51,
              "z": 1.112
            },
            "gtin": "40118048",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5de5",
            "leftCorner": {
              "x": -12.947,
              "y": -34.512,
              "z": 1.112
            },
            "rightCorner": {
              "x": -12.822,
              "y": -34.509,
              "z": 1.112
            },
            "gtin": "40118024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5de6",
            "leftCorner": {
              "x": -12.822,
              "y": -34.508,
              "z": 1.112
            },
            "rightCorner": {
              "x": -12.691,
              "y": -34.506,
              "z": 1.112
            },
            "gtin": "40118031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5de7",
            "leftCorner": {
              "x": -12.691,
              "y": -34.505,
              "z": 1.112
            },
            "rightCorner": {
              "x": -12.557,
              "y": -34.503,
              "z": 1.112
            },
            "gtin": "40118055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5de8",
            "leftCorner": {
              "x": -12.557,
              "y": -34.502,
              "z": 1.112
            },
            "rightCorner": {
              "x": -12.424,
              "y": -34.5,
              "z": 1.112
            },
            "gtin": "4104420045828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5de9",
            "leftCorner": {
              "x": -12.424,
              "y": -34.498,
              "z": 1.112
            },
            "rightCorner": {
              "x": -12.266,
              "y": -34.495,
              "z": 1.112
            },
            "gtin": "4104420045804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dea",
            "leftCorner": {
              "x": -12.266,
              "y": -34.494,
              "z": 1.112
            },
            "rightCorner": {
              "x": -12.115,
              "y": -34.491,
              "z": 1.112
            },
            "gtin": "4104420037465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5deb",
            "leftCorner": {
              "x": -12.115,
              "y": -34.492,
              "z": 1.112
            },
            "rightCorner": {
              "x": -11.938,
              "y": -34.49,
              "z": 1.112
            },
            "gtin": "4104420247079",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "83a",
    "rightNeighborShelfId": "83c"
  },
  {
    "id": "83c",
    "name": "83c",
    "x": -11.995,
    "y": -34.477,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0082728,
      "w": 0.99997
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d672",
        "height": 0.17042,
        "facings": [
          {
            "id": "a9f039906742acbb646dd903",
            "leftCorner": {
              "x": -11.994,
              "y": -34.576,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.944,
              "y": -34.575,
              "z": 0.139
            },
            "gtin": "4011800176310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "877e9e26475264d85b485395",
            "leftCorner": {
              "x": -11.944,
              "y": -34.575,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.893,
              "y": -34.574,
              "z": 0.139
            },
            "gtin": "4011800177218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "40a571241e1ec48b3db4a5be",
            "leftCorner": {
              "x": -11.893,
              "y": -34.574,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.827,
              "y": -34.573,
              "z": 0.139
            },
            "gtin": "4011800174415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1470c01773a56cfe01a4ef0e",
            "leftCorner": {
              "x": -11.827,
              "y": -34.573,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.751,
              "y": -34.572,
              "z": 0.139
            },
            "gtin": "4011800177911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a74ddfa6be972dc849f558fa",
            "leftCorner": {
              "x": -11.751,
              "y": -34.572,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.661,
              "y": -34.57,
              "z": 0.139
            },
            "gtin": "4011800176518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "67b61124a207a50ab6e70a7a",
            "leftCorner": {
              "x": -11.661,
              "y": -34.57,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.532,
              "y": -34.568,
              "z": 0.139
            },
            "gtin": "4011800000240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "31d57e657232f3c102de0a36",
            "leftCorner": {
              "x": -11.532,
              "y": -34.568,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.4,
              "y": -34.566,
              "z": 0.139
            },
            "gtin": "4011800176716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7403591f804856ee827874ab",
            "leftCorner": {
              "x": -11.4,
              "y": -34.566,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.267,
              "y": -34.564,
              "z": 0.139
            },
            "gtin": "4011800176211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9b827f4693cf5e74bd832f89",
            "leftCorner": {
              "x": -11.267,
              "y": -34.564,
              "z": 0.139
            },
            "rightCorner": {
              "x": -11.134,
              "y": -34.562,
              "z": 0.139
            },
            "gtin": "4011800176419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4f77f45bb37c7ec0bd4fbdd8",
            "leftCorner": {
              "x": -11.134,
              "y": -34.562,
              "z": 0.139
            },
            "rightCorner": {
              "x": -10.998,
              "y": -34.56,
              "z": 0.139
            },
            "gtin": "4011800176112",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d66f",
        "height": 0.46418,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8633",
            "leftCorner": {
              "x": -11.994,
              "y": -34.546,
              "z": 0.38
            },
            "rightCorner": {
              "x": -11.789,
              "y": -34.543,
              "z": 0.38
            },
            "gtin": "4011800841713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8635",
            "leftCorner": {
              "x": -11.79,
              "y": -34.496,
              "z": 0.38
            },
            "rightCorner": {
              "x": -11.633,
              "y": -34.493,
              "z": 0.38
            },
            "gtin": "4011800840419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8636",
            "leftCorner": {
              "x": -11.633,
              "y": -34.5,
              "z": 0.38
            },
            "rightCorner": {
              "x": -11.493,
              "y": -34.497,
              "z": 0.38
            },
            "gtin": "4011800176310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8637",
            "leftCorner": {
              "x": -11.492,
              "y": -34.5,
              "z": 0.38
            },
            "rightCorner": {
              "x": -11.358,
              "y": -34.498,
              "z": 0.38
            },
            "gtin": "4011800177010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8638",
            "leftCorner": {
              "x": -11.358,
              "y": -34.496,
              "z": 0.38
            },
            "rightCorner": {
              "x": -11.22,
              "y": -34.494,
              "z": 0.38
            },
            "gtin": "4011800176419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8639",
            "leftCorner": {
              "x": -11.22,
              "y": -34.494,
              "z": 0.38
            },
            "rightCorner": {
              "x": -11.091,
              "y": -34.492,
              "z": 0.38
            },
            "gtin": "4011800176716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8634",
            "leftCorner": {
              "x": -11.091,
              "y": -34.496,
              "z": 0.38
            },
            "rightCorner": {
              "x": -10.995,
              "y": -34.493,
              "z": 0.38
            },
            "gtin": "4011800176518",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d671",
        "height": 0.76505,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d863a",
            "leftCorner": {
              "x": -11.994,
              "y": -34.546,
              "z": 0.626
            },
            "rightCorner": {
              "x": -11.782,
              "y": -34.542,
              "z": 0.626
            },
            "gtin": "4011800840815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d863c",
            "leftCorner": {
              "x": -11.783,
              "y": -34.497,
              "z": 0.626
            },
            "rightCorner": {
              "x": -11.624,
              "y": -34.494,
              "z": 0.626
            },
            "gtin": "4011800176914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d863d",
            "leftCorner": {
              "x": -11.624,
              "y": -34.5,
              "z": 0.626
            },
            "rightCorner": {
              "x": -11.496,
              "y": -34.498,
              "z": 0.626
            },
            "gtin": "4011800176211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d863e",
            "leftCorner": {
              "x": -11.496,
              "y": -34.499,
              "z": 0.626
            },
            "rightCorner": {
              "x": -11.339,
              "y": -34.497,
              "z": 0.626
            },
            "gtin": "4011800176617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d863f",
            "leftCorner": {
              "x": -11.339,
              "y": -34.495,
              "z": 0.626
            },
            "rightCorner": {
              "x": -11.184,
              "y": -34.493,
              "z": 0.626
            },
            "gtin": "4011800178819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8640",
            "leftCorner": {
              "x": -11.184,
              "y": -34.493,
              "z": 0.626
            },
            "rightCorner": {
              "x": -11.051,
              "y": -34.491,
              "z": 0.626
            },
            "gtin": "4011800176112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d863b",
            "leftCorner": {
              "x": -11.051,
              "y": -34.492,
              "z": 0.626
            },
            "rightCorner": {
              "x": -10.995,
              "y": -34.491,
              "z": 0.626
            },
            "gtin": "4011800177218",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d670",
        "height": 1.0544,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5e26",
            "leftCorner": {
              "x": -11.952,
              "y": -34.486,
              "z": 0.863
            },
            "rightCorner": {
              "x": -11.792,
              "y": -34.483,
              "z": 0.863
            },
            "gtin": "4011800843014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e27",
            "leftCorner": {
              "x": -11.792,
              "y": -34.489,
              "z": 0.863
            },
            "rightCorner": {
              "x": -11.635,
              "y": -34.486,
              "z": 0.863
            },
            "gtin": "4011800843212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e28",
            "leftCorner": {
              "x": -11.635,
              "y": -34.494,
              "z": 0.863
            },
            "rightCorner": {
              "x": -11.474,
              "y": -34.492,
              "z": 0.863
            },
            "gtin": "4011800843311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e29",
            "leftCorner": {
              "x": -11.474,
              "y": -34.491,
              "z": 0.863
            },
            "rightCorner": {
              "x": -11.345,
              "y": -34.489,
              "z": 0.863
            },
            "gtin": "4011800000240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e2a",
            "leftCorner": {
              "x": -11.345,
              "y": -34.488,
              "z": 0.863
            },
            "rightCorner": {
              "x": -11.21,
              "y": -34.486,
              "z": 0.863
            },
            "gtin": "4011800177317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e2b",
            "leftCorner": {
              "x": -11.21,
              "y": -34.487,
              "z": 0.863
            },
            "rightCorner": {
              "x": -11.074,
              "y": -34.485,
              "z": 0.863
            },
            "gtin": "4011800176815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5e0e",
            "leftCorner": {
              "x": -11.074,
              "y": -34.486,
              "z": 0.863
            },
            "rightCorner": {
              "x": -10.995,
              "y": -34.484,
              "z": 0.863
            },
            "gtin": "4011800177911",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d66e",
        "height": 1.359,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5dec",
            "leftCorner": {
              "x": -11.939,
              "y": -34.493,
              "z": 1.112
            },
            "rightCorner": {
              "x": -11.802,
              "y": -34.491,
              "z": 1.112
            },
            "gtin": "4104420037441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5ded",
            "leftCorner": {
              "x": -11.802,
              "y": -34.49,
              "z": 1.112
            },
            "rightCorner": {
              "x": -11.634,
              "y": -34.487,
              "z": 1.112
            },
            "gtin": "4000243108194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dee",
            "leftCorner": {
              "x": -11.634,
              "y": -34.496,
              "z": 1.112
            },
            "rightCorner": {
              "x": -11.499,
              "y": -34.494,
              "z": 1.112
            },
            "gtin": "4011800845414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5def",
            "leftCorner": {
              "x": -11.499,
              "y": -34.494,
              "z": 1.112
            },
            "rightCorner": {
              "x": -11.348,
              "y": -34.492,
              "z": 1.112
            },
            "gtin": "4011800174514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5df0",
            "leftCorner": {
              "x": -11.348,
              "y": -34.489,
              "z": 1.112
            },
            "rightCorner": {
              "x": -11.199,
              "y": -34.487,
              "z": 1.112
            },
            "gtin": "4011800174217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5df1",
            "leftCorner": {
              "x": -11.199,
              "y": -34.489,
              "z": 1.112
            },
            "rightCorner": {
              "x": -11.063,
              "y": -34.487,
              "z": 1.112
            },
            "gtin": "4011800174118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5dd0",
            "leftCorner": {
              "x": -11.063,
              "y": -34.488,
              "z": 1.112
            },
            "rightCorner": {
              "x": -10.995,
              "y": -34.486,
              "z": 1.112
            },
            "gtin": "4011800174415",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "83b"
  },
  {
    "id": "83d",
    "name": "83d",
    "x": -10.957,
    "y": -33.255,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0055327
    },
    "layers": [],

    "rightNeighborShelfId": "83e"
  },
  {
    "id": "83e",
    "name": "83e",
    "x": -11.957,
    "y": -33.266,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0055327
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 21
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d039",
        "height": 0.17359,
        "facings": [
          {
            "id": "1138c5fc36d1087a2d889f23",
            "leftCorner": {
              "x": -11.957,
              "y": -33.188,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.118,
              "y": -33.19,
              "z": 0.142
            },
            "gtin": "4104420018747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7ce99588d8652e4224ee6c20",
            "leftCorner": {
              "x": -12.118,
              "y": -33.19,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.342,
              "y": -33.192,
              "z": 0.142
            },
            "gtin": "5059319030821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "840bd94c4b41eeca369adb4c",
            "leftCorner": {
              "x": -12.342,
              "y": -33.192,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.584,
              "y": -33.195,
              "z": 0.142
            },
            "gtin": "4104420019683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9ede171fe2aa1fde7748e09c",
            "leftCorner": {
              "x": -12.584,
              "y": -33.195,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.852,
              "y": -33.198,
              "z": 0.142
            },
            "gtin": "4104420139640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9273da1843be23d504673589",
            "leftCorner": {
              "x": -12.852,
              "y": -33.198,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.012,
              "y": -33.2,
              "z": 0.142
            },
            "gtin": "4104420018747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6d1c5b078090bf788395d34b",
            "leftCorner": {
              "x": -13.012,
              "y": -33.2,
              "z": 0.142
            },
            "rightCorner": {
              "x": -13.172,
              "y": -33.201,
              "z": 0.142
            },
            "gtin": "4104420018747",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d038",
        "height": 0.58615,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5da2",
            "leftCorner": {
              "x": -11.957,
              "y": -33.235,
              "z": 0.48
            },
            "rightCorner": {
              "x": -12.175,
              "y": -33.237,
              "z": 0.48
            },
            "gtin": "5059319035543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5da3",
            "leftCorner": {
              "x": -12.175,
              "y": -33.237,
              "z": 0.48
            },
            "rightCorner": {
              "x": -12.392,
              "y": -33.24,
              "z": 0.48
            },
            "gtin": "5059319035543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5da5",
            "leftCorner": {
              "x": -12.392,
              "y": -33.278,
              "z": 0.48
            },
            "rightCorner": {
              "x": -12.778,
              "y": -33.281,
              "z": 0.48
            },
            "gtin": "5059319023960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5da6",
            "leftCorner": {
              "x": -12.778,
              "y": -33.287,
              "z": 0.48
            },
            "rightCorner": {
              "x": -13.463,
              "y": -33.295,
              "z": 0.48
            },
            "gtin": "5059319023670",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d037",
        "height": 1.0156,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d95",
            "leftCorner": {
              "x": -11.957,
              "y": -33.239,
              "z": 0.831
            },
            "rightCorner": {
              "x": -12.139,
              "y": -33.241,
              "z": 0.831
            },
            "gtin": "8445290292056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d96",
            "leftCorner": {
              "x": -12.139,
              "y": -33.241,
              "z": 0.831
            },
            "rightCorner": {
              "x": -12.321,
              "y": -33.243,
              "z": 0.831
            },
            "gtin": "8445290292056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d98",
            "leftCorner": {
              "x": -12.321,
              "y": -33.282,
              "z": 0.831
            },
            "rightCorner": {
              "x": -12.705,
              "y": -33.287,
              "z": 0.831
            },
            "gtin": "5053827199667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d99",
            "leftCorner": {
              "x": -12.705,
              "y": -33.288,
              "z": 0.831
            },
            "rightCorner": {
              "x": -12.906,
              "y": -33.29,
              "z": 0.831
            },
            "gtin": "5053827199568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d9a",
            "leftCorner": {
              "x": -12.906,
              "y": -33.29,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.108,
              "y": -33.292,
              "z": 0.831
            },
            "gtin": "5053827199568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d9b",
            "leftCorner": {
              "x": -13.108,
              "y": -33.292,
              "z": 0.831
            },
            "rightCorner": {
              "x": -13.309,
              "y": -33.295,
              "z": 0.831
            },
            "gtin": "5053827199568",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d036",
        "height": 1.3697,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d86",
            "leftCorner": {
              "x": -11.957,
              "y": -33.238,
              "z": 1.121
            },
            "rightCorner": {
              "x": -12.237,
              "y": -33.241,
              "z": 1.121
            },
            "gtin": "4104420139640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d88",
            "leftCorner": {
              "x": -12.237,
              "y": -33.282,
              "z": 1.121
            },
            "rightCorner": {
              "x": -12.48,
              "y": -33.284,
              "z": 1.121
            },
            "gtin": "4104420019683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d89",
            "leftCorner": {
              "x": -12.48,
              "y": -33.285,
              "z": 1.121
            },
            "rightCorner": {
              "x": -12.638,
              "y": -33.286,
              "z": 1.121
            },
            "gtin": "4104420018747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d8a",
            "leftCorner": {
              "x": -12.638,
              "y": -33.284,
              "z": 1.121
            },
            "rightCorner": {
              "x": -12.99,
              "y": -33.288,
              "z": 1.121
            },
            "gtin": "5059319030883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d8b",
            "leftCorner": {
              "x": -12.99,
              "y": -33.288,
              "z": 1.121
            },
            "rightCorner": {
              "x": -13.359,
              "y": -33.292,
              "z": 1.121
            },
            "gtin": "5059319030821",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "83d",
    "rightNeighborShelfId": "83f"
  },
  {
    "id": "83f",
    "name": "83f",
    "x": -13.207,
    "y": -33.28,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0055327
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d03e",
        "height": 0.17743,
        "facings": [
          {
            "id": "8632b1e67341d7da81d3b6a5",
            "leftCorner": {
              "x": -13.209,
              "y": -33.182,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.33,
              "y": -33.183,
              "z": 0.145
            },
            "gtin": "4104420019546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "be722ad58885473870b64177",
            "leftCorner": {
              "x": -13.33,
              "y": -33.183,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.491,
              "y": -33.185,
              "z": 0.145
            },
            "gtin": "5011546457277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d343b9caf4e6d30305d6a2a4",
            "leftCorner": {
              "x": -13.491,
              "y": -33.185,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.686,
              "y": -33.187,
              "z": 0.145
            },
            "gtin": "8445290728791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f56c169dcced403a0a8c1cad",
            "leftCorner": {
              "x": -13.686,
              "y": -33.187,
              "z": 0.145
            },
            "rightCorner": {
              "x": -13.893,
              "y": -33.19,
              "z": 0.145
            },
            "gtin": "7613038529929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "842886d26602db0174acf6bd",
            "leftCorner": {
              "x": -13.893,
              "y": -33.19,
              "z": 0.145
            },
            "rightCorner": {
              "x": -14.108,
              "y": -33.192,
              "z": 0.145
            },
            "gtin": "4104420018709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "29f721120fcfdf594cedfef6",
            "leftCorner": {
              "x": -14.108,
              "y": -33.192,
              "z": 0.145
            },
            "rightCorner": {
              "x": -14.362,
              "y": -33.195,
              "z": 0.145
            },
            "gtin": "5059319030760",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d03c",
        "height": 0.58954,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5da7",
            "leftCorner": {
              "x": -13.463,
              "y": -33.279,
              "z": 0.482
            },
            "rightCorner": {
              "x": -14.022,
              "y": -33.285,
              "z": 0.482
            },
            "gtin": "5059319030760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e9ed3c82bb814504d8d3f4b7",
            "leftCorner": {
              "x": -13.207,
              "y": -33.234,
              "z": 0.482
            },
            "rightCorner": {
              "x": -13.461,
              "y": -33.237,
              "z": 0.482
            },
            "gtin": "5059319030760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5da8",
            "leftCorner": {
              "x": -14.022,
              "y": -33.281,
              "z": 0.482
            },
            "rightCorner": {
              "x": -14.642,
              "y": -33.288,
              "z": 0.482
            },
            "gtin": "5059319030791",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d03d",
        "height": 0.78549,
        "facings": [
          {
            "id": "57986feca68e8bfb27513363",
            "leftCorner": {
              "x": -13.207,
              "y": -33.281,
              "z": 0.643
            },
            "rightCorner": {
              "x": -13.471,
              "y": -33.284,
              "z": 0.643
            },
            "gtin": "4000540011050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3b84efc40439b55609661575",
            "leftCorner": {
              "x": -13.471,
              "y": -33.284,
              "z": 0.643
            },
            "rightCorner": {
              "x": -13.844,
              "y": -33.288,
              "z": 0.643
            },
            "gtin": "5010029227062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b3e61c5822d40461bc10244f",
            "leftCorner": {
              "x": -13.844,
              "y": -33.288,
              "z": 0.643
            },
            "rightCorner": {
              "x": -14.343,
              "y": -33.294,
              "z": 0.643
            },
            "gtin": "5059319030791",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d03a",
        "height": 1.0194,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d9c",
            "leftCorner": {
              "x": -13.309,
              "y": -33.282,
              "z": 0.834
            },
            "rightCorner": {
              "x": -13.682,
              "y": -33.286,
              "z": 0.834
            },
            "gtin": "3387390321067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d9d",
            "leftCorner": {
              "x": -13.682,
              "y": -33.291,
              "z": 0.834
            },
            "rightCorner": {
              "x": -14.1,
              "y": -33.295,
              "z": 0.834
            },
            "gtin": "8445290728791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d9e",
            "leftCorner": {
              "x": -14.1,
              "y": -33.291,
              "z": 0.834
            },
            "rightCorner": {
              "x": -14.309,
              "y": -33.294,
              "z": 0.834
            },
            "gtin": "7613038529929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d9f",
            "leftCorner": {
              "x": -14.309,
              "y": -33.29,
              "z": 0.834
            },
            "rightCorner": {
              "x": -14.714,
              "y": -33.294,
              "z": 0.834
            },
            "gtin": "5011546457277",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d03b",
        "height": 1.3746,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d8c",
            "leftCorner": {
              "x": -13.359,
              "y": -33.281,
              "z": 1.125
            },
            "rightCorner": {
              "x": -13.721,
              "y": -33.285,
              "z": 1.125
            },
            "gtin": "5010029227062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "80a54b9c22ba7ff7f87d3854",
            "leftCorner": {
              "x": -13.207,
              "y": -33.239,
              "z": 1.125
            },
            "rightCorner": {
              "x": -13.351,
              "y": -33.241,
              "z": 1.125
            },
            "gtin": "4250780322601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d8d",
            "leftCorner": {
              "x": -13.721,
              "y": -33.285,
              "z": 1.125
            },
            "rightCorner": {
              "x": -13.867,
              "y": -33.286,
              "z": 1.125
            },
            "gtin": "4250780322601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d8e",
            "leftCorner": {
              "x": -13.867,
              "y": -33.291,
              "z": 1.125
            },
            "rightCorner": {
              "x": -14.081,
              "y": -33.293,
              "z": 1.125
            },
            "gtin": "4104420018709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d8f",
            "leftCorner": {
              "x": -14.081,
              "y": -33.289,
              "z": 1.125
            },
            "rightCorner": {
              "x": -14.199,
              "y": -33.29,
              "z": 1.125
            },
            "gtin": "4104420019546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d90",
            "leftCorner": {
              "x": -14.199,
              "y": -33.291,
              "z": 1.125
            },
            "rightCorner": {
              "x": -14.515,
              "y": -33.295,
              "z": 1.125
            },
            "gtin": "4000540011050",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "83e",
    "rightNeighborShelfId": "840"
  },
  {
    "id": "840",
    "name": "840",
    "x": -14.457,
    "y": -33.294,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0055327
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d042",
        "height": 0.17934,
        "facings": [
          {
            "id": "0113811fab1cf963c6186a27",
            "leftCorner": {
              "x": -14.459,
              "y": -33.198,
              "z": 0.147
            },
            "rightCorner": {
              "x": -14.637,
              "y": -33.2,
              "z": 0.147
            },
            "gtin": "4000281315516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a7822df912fce54c1cf08532",
            "leftCorner": {
              "x": -14.637,
              "y": -33.2,
              "z": 0.147
            },
            "rightCorner": {
              "x": -14.822,
              "y": -33.202,
              "z": 0.147
            },
            "gtin": "3387390339499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8c4b43459601dca5cf39d9ac",
            "leftCorner": {
              "x": -14.822,
              "y": -33.202,
              "z": 0.147
            },
            "rightCorner": {
              "x": -15.01,
              "y": -33.204,
              "z": 0.147
            },
            "gtin": "5010029000023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e6d0589c9d59119e48796274",
            "leftCorner": {
              "x": -15.01,
              "y": -33.204,
              "z": 0.147
            },
            "rightCorner": {
              "x": -15.228,
              "y": -33.207,
              "z": 0.147
            },
            "gtin": "7613031570126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5cf3d176050f3cdce82cb310",
            "leftCorner": {
              "x": -15.228,
              "y": -33.207,
              "z": 0.147
            },
            "rightCorner": {
              "x": -15.582,
              "y": -33.21,
              "z": 0.147
            },
            "gtin": "5059319030616",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d03f",
        "height": 0.58872,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5da9",
            "leftCorner": {
              "x": -14.642,
              "y": -33.291,
              "z": 0.482
            },
            "rightCorner": {
              "x": -14.995,
              "y": -33.294,
              "z": 0.482
            },
            "gtin": "5059319030616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5daa",
            "leftCorner": {
              "x": -14.995,
              "y": -33.295,
              "z": 0.482
            },
            "rightCorner": {
              "x": -15.345,
              "y": -33.299,
              "z": 0.482
            },
            "gtin": "5060318665273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5da4",
            "leftCorner": {
              "x": -15.345,
              "y": -33.298,
              "z": 0.482
            },
            "rightCorner": {
              "x": -15.707,
              "y": -33.302,
              "z": 0.482
            },
            "gtin": "5060318662982",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d040",
        "height": 1.0173,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5da0",
            "leftCorner": {
              "x": -14.714,
              "y": -33.295,
              "z": 0.832
            },
            "rightCorner": {
              "x": -15.151,
              "y": -33.3,
              "z": 0.832
            },
            "gtin": "3387390333008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5da1",
            "leftCorner": {
              "x": -15.151,
              "y": -33.301,
              "z": 0.832
            },
            "rightCorner": {
              "x": -15.535,
              "y": -33.305,
              "z": 0.832
            },
            "gtin": "7613287476678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d97",
            "leftCorner": {
              "x": -15.535,
              "y": -33.297,
              "z": 0.832
            },
            "rightCorner": {
              "x": -15.707,
              "y": -33.298,
              "z": 0.832
            },
            "gtin": "4003840007099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bfb9d1a20d35369dc12edc22",
            "leftCorner": {
              "x": -14.457,
              "y": -33.252,
              "z": 0.832
            },
            "rightCorner": {
              "x": -14.629,
              "y": -33.254,
              "z": 0.832
            },
            "gtin": "4003840007099",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d041",
        "height": 1.371,
        "facings": [
          {
            "id": "68d8e509e1820c81800d5d91",
            "leftCorner": {
              "x": -14.515,
              "y": -33.295,
              "z": 1.122
            },
            "rightCorner": {
              "x": -14.951,
              "y": -33.3,
              "z": 1.122
            },
            "gtin": "5010029000023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d92",
            "leftCorner": {
              "x": -14.951,
              "y": -33.297,
              "z": 1.122
            },
            "rightCorner": {
              "x": -15.137,
              "y": -33.3,
              "z": 1.122
            },
            "gtin": "3387390339499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d93",
            "leftCorner": {
              "x": -15.137,
              "y": -33.298,
              "z": 1.122
            },
            "rightCorner": {
              "x": -15.3,
              "y": -33.3,
              "z": 1.122
            },
            "gtin": "4000281315516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d94",
            "leftCorner": {
              "x": -15.3,
              "y": -33.301,
              "z": 1.122
            },
            "rightCorner": {
              "x": -15.505,
              "y": -33.303,
              "z": 1.122
            },
            "gtin": "7613031570126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e509e1820c81800d5d87",
            "leftCorner": {
              "x": -15.505,
              "y": -33.301,
              "z": 1.122
            },
            "rightCorner": {
              "x": -15.707,
              "y": -33.303,
              "z": 1.122
            },
            "gtin": "7613033212949",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "83f"
  },
  {
    "id": "841",
    "name": "841",
    "x": -10.55,
    "y": -37.281,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70833,
      "w": 0.70588
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 20,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d677",
        "height": 0.17475,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8653",
            "leftCorner": {
              "x": -10.496,
              "y": -36.945,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.497,
              "y": -36.651,
              "z": 0.143
            },
            "gtin": "4270000814655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "383986f7c951d2857a835308",
            "leftCorner": {
              "x": -10.455,
              "y": -37.28,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.456,
              "y": -37.122,
              "z": 0.143
            },
            "gtin": "4270000814655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7338320483db4641d56098b5",
            "leftCorner": {
              "x": -10.456,
              "y": -37.122,
              "z": 0.143
            },
            "rightCorner": {
              "x": -10.456,
              "y": -36.964,
              "z": 0.143
            },
            "gtin": "4270000814655",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d674",
        "height": 0.47323,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8642",
            "leftCorner": {
              "x": -10.48,
              "y": -37.281,
              "z": 0.387
            },
            "rightCorner": {
              "x": -10.48,
              "y": -37.191,
              "z": 0.387
            },
            "gtin": "4270000814754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8643",
            "leftCorner": {
              "x": -10.48,
              "y": -37.191,
              "z": 0.387
            },
            "rightCorner": {
              "x": -10.48,
              "y": -37.101,
              "z": 0.387
            },
            "gtin": "4270000814754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8644",
            "leftCorner": {
              "x": -10.48,
              "y": -37.101,
              "z": 0.387
            },
            "rightCorner": {
              "x": -10.481,
              "y": -37.012,
              "z": 0.387
            },
            "gtin": "4270000814754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8645",
            "leftCorner": {
              "x": -10.481,
              "y": -37.012,
              "z": 0.387
            },
            "rightCorner": {
              "x": -10.481,
              "y": -36.923,
              "z": 0.387
            },
            "gtin": "4270000814754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8646",
            "leftCorner": {
              "x": -10.481,
              "y": -36.923,
              "z": 0.387
            },
            "rightCorner": {
              "x": -10.481,
              "y": -36.833,
              "z": 0.387
            },
            "gtin": "4270000814754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8647",
            "leftCorner": {
              "x": -10.481,
              "y": -36.833,
              "z": 0.387
            },
            "rightCorner": {
              "x": -10.481,
              "y": -36.743,
              "z": 0.387
            },
            "gtin": "4270000814754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8648",
            "leftCorner": {
              "x": -10.481,
              "y": -36.743,
              "z": 0.387
            },
            "rightCorner": {
              "x": -10.482,
              "y": -36.655,
              "z": 0.387
            },
            "gtin": "4270000814754",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d676",
        "height": 0.75757,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d864d",
            "leftCorner": {
              "x": -10.502,
              "y": -37.281,
              "z": 0.62
            },
            "rightCorner": {
              "x": -10.503,
              "y": -37.171,
              "z": 0.62
            },
            "gtin": "4002184053618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d864e",
            "leftCorner": {
              "x": -10.503,
              "y": -37.171,
              "z": 0.62
            },
            "rightCorner": {
              "x": -10.503,
              "y": -37.06,
              "z": 0.62
            },
            "gtin": "4002184053618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d864f",
            "leftCorner": {
              "x": -10.503,
              "y": -37.06,
              "z": 0.62
            },
            "rightCorner": {
              "x": -10.503,
              "y": -36.95,
              "z": 0.62
            },
            "gtin": "4002184053618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8651",
            "leftCorner": {
              "x": -10.542,
              "y": -36.95,
              "z": 0.62
            },
            "rightCorner": {
              "x": -10.543,
              "y": -36.772,
              "z": 0.62
            },
            "gtin": "4002184530355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8650",
            "leftCorner": {
              "x": -10.544,
              "y": -36.772,
              "z": 0.62
            },
            "rightCorner": {
              "x": -10.545,
              "y": -36.651,
              "z": 0.62
            },
            "gtin": "4002184530348",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d675",
        "height": 1.0746,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d864b",
            "leftCorner": {
              "x": -10.526,
              "y": -37.025,
              "z": 0.879
            },
            "rightCorner": {
              "x": -10.527,
              "y": -36.838,
              "z": 0.879
            },
            "gtin": "4280001856516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e641ca7dcef06af23c64c367",
            "leftCorner": {
              "x": -10.486,
              "y": -37.281,
              "z": 0.879
            },
            "rightCorner": {
              "x": -10.486,
              "y": -37.158,
              "z": 0.879
            },
            "gtin": "4280001856516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3248a104929229dee9640ff8",
            "leftCorner": {
              "x": -10.486,
              "y": -37.158,
              "z": 0.879
            },
            "rightCorner": {
              "x": -10.487,
              "y": -37.034,
              "z": 0.879
            },
            "gtin": "4280001856516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d864c",
            "leftCorner": {
              "x": -10.527,
              "y": -36.838,
              "z": 0.879
            },
            "rightCorner": {
              "x": -10.527,
              "y": -36.651,
              "z": 0.879
            },
            "gtin": "4280001856516",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d673",
        "height": 1.3637,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8641",
            "leftCorner": {
              "x": -10.489,
              "y": -37.281,
              "z": 1.116
            },
            "rightCorner": {
              "x": -10.492,
              "y": -36.68,
              "z": 1.116
            },
            "gtin": "4280001856059",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "842"
  },
  {
    "id": "842",
    "name": "842",
    "x": -10.552,
    "y": -36.656,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70833,
      "w": 0.70588
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 6,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d679",
        "height": 0.17586,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8659",
            "leftCorner": {
              "x": -10.562,
              "y": -36.359,
              "z": 0.144
            },
            "rightCorner": {
              "x": -10.563,
              "y": -36.026,
              "z": 0.144
            },
            "gtin": "4270000814631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4cb8fdf864a076296e98cc05",
            "leftCorner": {
              "x": -10.523,
              "y": -36.656,
              "z": 0.144
            },
            "rightCorner": {
              "x": -10.524,
              "y": -36.461,
              "z": 0.144
            },
            "gtin": "4270000814631",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d678",
        "height": 1.0589,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8654",
            "leftCorner": {
              "x": -10.572,
              "y": -36.656,
              "z": 0.866
            },
            "rightCorner": {
              "x": -10.573,
              "y": -36.515,
              "z": 0.866
            },
            "gtin": "4280001856332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8655",
            "leftCorner": {
              "x": -10.573,
              "y": -36.515,
              "z": 0.866
            },
            "rightCorner": {
              "x": -10.573,
              "y": -36.375,
              "z": 0.866
            },
            "gtin": "4280001856332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8656",
            "leftCorner": {
              "x": -10.573,
              "y": -36.375,
              "z": 0.866
            },
            "rightCorner": {
              "x": -10.574,
              "y": -36.234,
              "z": 0.866
            },
            "gtin": "4280001856332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8657",
            "leftCorner": {
              "x": -10.615,
              "y": -36.234,
              "z": 0.866
            },
            "rightCorner": {
              "x": -10.615,
              "y": -36.026,
              "z": 0.866
            },
            "gtin": "4270002015968",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "841"
  },
  {
    "id": "844",
    "name": "844",
    "x": -16.25,
    "y": -36.101,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70367,
      "w": 0.71053
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d06e",
        "height": 0.22768,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f05",
            "leftCorner": {
              "x": -16.342,
              "y": -36.103,
              "z": 0.186
            },
            "rightCorner": {
              "x": -16.338,
              "y": -36.389,
              "z": 0.186
            },
            "gtin": "4306188051138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2657560a7be6610ce026738c",
            "leftCorner": {
              "x": -16.339,
              "y": -36.389,
              "z": 0.186
            },
            "rightCorner": {
              "x": -16.337,
              "y": -36.566,
              "z": 0.186
            },
            "gtin": "4306188031321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f08",
            "leftCorner": {
              "x": -16.309,
              "y": -36.662,
              "z": 0.186
            },
            "rightCorner": {
              "x": -16.307,
              "y": -36.825,
              "z": 0.186
            },
            "gtin": "4306188031291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f09",
            "leftCorner": {
              "x": -16.307,
              "y": -36.825,
              "z": 0.186
            },
            "rightCorner": {
              "x": -16.305,
              "y": -36.987,
              "z": 0.186
            },
            "gtin": "4306188031291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f06",
            "leftCorner": {
              "x": -16.167,
              "y": -36.986,
              "z": 0.186
            },
            "rightCorner": {
              "x": -16.163,
              "y": -37.351,
              "z": 0.186
            },
            "gtin": "4306188031260",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d06a",
        "height": 0.52853,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5ee9",
            "leftCorner": {
              "x": -16.296,
              "y": -36.102,
              "z": 0.432
            },
            "rightCorner": {
              "x": -16.294,
              "y": -36.352,
              "z": 0.432
            },
            "gtin": "4306188031352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eeb",
            "leftCorner": {
              "x": -16.257,
              "y": -36.351,
              "z": 0.432
            },
            "rightCorner": {
              "x": -16.254,
              "y": -36.638,
              "z": 0.432
            },
            "gtin": "4009249005544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eec",
            "leftCorner": {
              "x": -16.248,
              "y": -36.638,
              "z": 0.432
            },
            "rightCorner": {
              "x": -16.245,
              "y": -36.861,
              "z": 0.432
            },
            "gtin": "4008891000020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eed",
            "leftCorner": {
              "x": -16.246,
              "y": -36.861,
              "z": 0.432
            },
            "rightCorner": {
              "x": -16.245,
              "y": -36.992,
              "z": 0.432
            },
            "gtin": "4008891000013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eee",
            "leftCorner": {
              "x": -16.245,
              "y": -36.992,
              "z": 0.432
            },
            "rightCorner": {
              "x": -16.244,
              "y": -37.122,
              "z": 0.432
            },
            "gtin": "4008891000013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eea",
            "leftCorner": {
              "x": -16.25,
              "y": -37.122,
              "z": 0.432
            },
            "rightCorner": {
              "x": -16.248,
              "y": -37.351,
              "z": 0.432
            },
            "gtin": "4001214000004",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d06c",
        "height": 0.82931,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5ef7",
            "leftCorner": {
              "x": -16.3,
              "y": -36.102,
              "z": 0.679
            },
            "rightCorner": {
              "x": -16.298,
              "y": -36.32,
              "z": 0.679
            },
            "gtin": "4000446011116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ef9",
            "leftCorner": {
              "x": -16.264,
              "y": -36.32,
              "z": 0.679
            },
            "rightCorner": {
              "x": -16.262,
              "y": -36.501,
              "z": 0.679
            },
            "gtin": "4250426219821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5efa",
            "leftCorner": {
              "x": -16.255,
              "y": -36.501,
              "z": 0.679
            },
            "rightCorner": {
              "x": -16.253,
              "y": -36.75,
              "z": 0.679
            },
            "gtin": "4250426210767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5efb",
            "leftCorner": {
              "x": -16.247,
              "y": -36.75,
              "z": 0.679
            },
            "rightCorner": {
              "x": -16.245,
              "y": -36.987,
              "z": 0.679
            },
            "gtin": "4008891000044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ef8",
            "leftCorner": {
              "x": -16.252,
              "y": -36.987,
              "z": 0.679
            },
            "rightCorner": {
              "x": -16.249,
              "y": -37.351,
              "z": 0.679
            },
            "gtin": "4008891000051",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d06d",
        "height": 1.1297,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5efc",
            "leftCorner": {
              "x": -16.295,
              "y": -36.102,
              "z": 0.924
            },
            "rightCorner": {
              "x": -16.293,
              "y": -36.257,
              "z": 0.924
            },
            "gtin": "4000446001315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5efd",
            "leftCorner": {
              "x": -16.293,
              "y": -36.257,
              "z": 0.924
            },
            "rightCorner": {
              "x": -16.292,
              "y": -36.413,
              "z": 0.924
            },
            "gtin": "4000446001315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eff",
            "leftCorner": {
              "x": -16.256,
              "y": -36.412,
              "z": 0.924
            },
            "rightCorner": {
              "x": -16.255,
              "y": -36.554,
              "z": 0.924
            },
            "gtin": "4000446011376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f00",
            "leftCorner": {
              "x": -16.252,
              "y": -36.554,
              "z": 0.924
            },
            "rightCorner": {
              "x": -16.25,
              "y": -36.707,
              "z": 0.924
            },
            "gtin": "4000446011420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f01",
            "leftCorner": {
              "x": -16.248,
              "y": -36.707,
              "z": 0.924
            },
            "rightCorner": {
              "x": -16.247,
              "y": -36.824,
              "z": 0.924
            },
            "gtin": "4000446011628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f02",
            "leftCorner": {
              "x": -16.248,
              "y": -36.824,
              "z": 0.924
            },
            "rightCorner": {
              "x": -16.248,
              "y": -36.978,
              "z": 0.924
            },
            "gtin": "4000446001841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f03",
            "leftCorner": {
              "x": -16.247,
              "y": -36.978,
              "z": 0.924
            },
            "rightCorner": {
              "x": -16.245,
              "y": -37.106,
              "z": 0.924
            },
            "gtin": "4104420224728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f04",
            "leftCorner": {
              "x": -16.25,
              "y": -37.106,
              "z": 0.924
            },
            "rightCorner": {
              "x": -16.249,
              "y": -37.253,
              "z": 0.924
            },
            "gtin": "4104420225602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5efe",
            "leftCorner": {
              "x": -16.254,
              "y": -37.252,
              "z": 0.924
            },
            "rightCorner": {
              "x": -16.253,
              "y": -37.351,
              "z": 0.924
            },
            "gtin": "4031655002329",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d06b",
        "height": 1.4329,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5eef",
            "leftCorner": {
              "x": -16.304,
              "y": -36.102,
              "z": 1.172
            },
            "rightCorner": {
              "x": -16.301,
              "y": -36.377,
              "z": 1.172
            },
            "gtin": "4000446001124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ef1",
            "leftCorner": {
              "x": -16.264,
              "y": -36.376,
              "z": 1.172
            },
            "rightCorner": {
              "x": -16.262,
              "y": -36.498,
              "z": 1.172
            },
            "gtin": "4000446001025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ef2",
            "leftCorner": {
              "x": -16.259,
              "y": -36.498,
              "z": 1.172
            },
            "rightCorner": {
              "x": -16.258,
              "y": -36.641,
              "z": 1.172
            },
            "gtin": "4000446001018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ef3",
            "leftCorner": {
              "x": -16.257,
              "y": -36.641,
              "z": 1.172
            },
            "rightCorner": {
              "x": -16.255,
              "y": -36.741,
              "z": 1.172
            },
            "gtin": "4000446001216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ef4",
            "leftCorner": {
              "x": -16.255,
              "y": -36.741,
              "z": 1.172
            },
            "rightCorner": {
              "x": -16.256,
              "y": -36.796,
              "z": 1.172
            },
            "gtin": "4000446001094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ef5",
            "leftCorner": {
              "x": -16.256,
              "y": -36.796,
              "z": 1.172
            },
            "rightCorner": {
              "x": -16.255,
              "y": -36.852,
              "z": 1.172
            },
            "gtin": "4000446001094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ef6",
            "leftCorner": {
              "x": -16.257,
              "y": -36.852,
              "z": 1.172
            },
            "rightCorner": {
              "x": -16.255,
              "y": -36.983,
              "z": 1.172
            },
            "gtin": "4003488000254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ef0",
            "leftCorner": {
              "x": -16.258,
              "y": -36.983,
              "z": 1.172
            },
            "rightCorner": {
              "x": -16.254,
              "y": -37.351,
              "z": 1.172
            },
            "gtin": "4003488000100",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "845",
    "name": "845",
    "x": -15.611,
    "y": -37.326,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 4.0143E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 25
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d67c",
        "height": 0.14751,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d865a",
            "leftCorner": {
              "x": -15.611,
              "y": -37.422,
              "z": 0.121
            },
            "rightCorner": {
              "x": -15.056,
              "y": -37.421,
              "z": 0.121
            },
            "gtin": "4009249001171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d865c",
            "leftCorner": {
              "x": -15.057,
              "y": -37.381,
              "z": 0.121
            },
            "rightCorner": {
              "x": -14.772,
              "y": -37.382,
              "z": 0.121
            },
            "gtin": "4052300009357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d865b",
            "leftCorner": {
              "x": -14.772,
              "y": -37.385,
              "z": 0.121
            },
            "rightCorner": {
              "x": -14.361,
              "y": -37.384,
              "z": 0.121
            },
            "gtin": "4306188051060",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d67e",
        "height": 0.46438,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f0a",
            "leftCorner": {
              "x": -15.611,
              "y": -37.363,
              "z": 0.38
            },
            "rightCorner": {
              "x": -15.092,
              "y": -37.362,
              "z": 0.38
            },
            "gtin": "4015174000257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f0c",
            "leftCorner": {
              "x": -15.092,
              "y": -37.324,
              "z": 0.38
            },
            "rightCorner": {
              "x": -14.733,
              "y": -37.324,
              "z": 0.38
            },
            "gtin": "4009249046387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f0d",
            "leftCorner": {
              "x": -14.733,
              "y": -37.321,
              "z": 0.38
            },
            "rightCorner": {
              "x": -14.483,
              "y": -37.321,
              "z": 0.38
            },
            "gtin": "4009249050070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f0e",
            "leftCorner": {
              "x": -14.483,
              "y": -37.321,
              "z": 0.38
            },
            "rightCorner": {
              "x": -14.233,
              "y": -37.32,
              "z": 0.38
            },
            "gtin": "4009249050070",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d67b",
        "height": 0.76397,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f4a",
            "leftCorner": {
              "x": -15.611,
              "y": -37.359,
              "z": 0.625
            },
            "rightCorner": {
              "x": -15.513,
              "y": -37.359,
              "z": 0.625
            },
            "gtin": "4015174003579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f4c",
            "leftCorner": {
              "x": -15.513,
              "y": -37.321,
              "z": 0.625
            },
            "rightCorner": {
              "x": -15.386,
              "y": -37.321,
              "z": 0.625
            },
            "gtin": "4015174004040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f4d",
            "leftCorner": {
              "x": -15.386,
              "y": -37.321,
              "z": 0.625
            },
            "rightCorner": {
              "x": -15.248,
              "y": -37.321,
              "z": 0.625
            },
            "gtin": "4015174003678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f4e",
            "leftCorner": {
              "x": -15.248,
              "y": -37.317,
              "z": 0.625
            },
            "rightCorner": {
              "x": -15.102,
              "y": -37.316,
              "z": 0.625
            },
            "gtin": "4015174003609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f4f",
            "leftCorner": {
              "x": -15.102,
              "y": -37.319,
              "z": 0.625
            },
            "rightCorner": {
              "x": -14.972,
              "y": -37.319,
              "z": 0.625
            },
            "gtin": "4015174010126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f50",
            "leftCorner": {
              "x": -14.972,
              "y": -37.319,
              "z": 0.625
            },
            "rightCorner": {
              "x": -14.652,
              "y": -37.319,
              "z": 0.625
            },
            "gtin": "4009249002550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f51",
            "leftCorner": {
              "x": -14.652,
              "y": -37.325,
              "z": 0.625
            },
            "rightCorner": {
              "x": -14.306,
              "y": -37.325,
              "z": 0.625
            },
            "gtin": "4009249012511",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d67d",
        "height": 1.0679,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f2f",
            "leftCorner": {
              "x": -15.611,
              "y": -37.36,
              "z": 0.874
            },
            "rightCorner": {
              "x": -15.302,
              "y": -37.36,
              "z": 0.874
            },
            "gtin": "4015174019013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f33c65278ab66759976b5889",
            "leftCorner": {
              "x": -14.889,
              "y": -37.359,
              "z": 0.874
            },
            "rightCorner": {
              "x": -14.77,
              "y": -37.359,
              "z": 0.874
            },
            "gtin": "4015174020071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f31",
            "leftCorner": {
              "x": -15.302,
              "y": -37.315,
              "z": 0.874
            },
            "rightCorner": {
              "x": -15.206,
              "y": -37.315,
              "z": 0.874
            },
            "gtin": "4015174020071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f32",
            "leftCorner": {
              "x": -15.206,
              "y": -37.32,
              "z": 0.874
            },
            "rightCorner": {
              "x": -14.889,
              "y": -37.32,
              "z": 0.874
            },
            "gtin": "4015174000332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f34",
            "leftCorner": {
              "x": -14.737,
              "y": -37.323,
              "z": 0.874
            },
            "rightCorner": {
              "x": -14.471,
              "y": -37.322,
              "z": 0.874
            },
            "gtin": "4009249042143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f35",
            "leftCorner": {
              "x": -14.471,
              "y": -37.324,
              "z": 0.874
            },
            "rightCorner": {
              "x": -14.297,
              "y": -37.324,
              "z": 0.874
            },
            "gtin": "4009249042549",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d67a",
        "height": 1.3723,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f1a",
            "leftCorner": {
              "x": -15.611,
              "y": -37.358,
              "z": 1.123
            },
            "rightCorner": {
              "x": -15.391,
              "y": -37.358,
              "z": 1.123
            },
            "gtin": "4015174018993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f1c",
            "leftCorner": {
              "x": -15.391,
              "y": -37.32,
              "z": 1.123
            },
            "rightCorner": {
              "x": -15.138,
              "y": -37.319,
              "z": 1.123
            },
            "gtin": "4015174018986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f1d",
            "leftCorner": {
              "x": -15.138,
              "y": -37.315,
              "z": 1.123
            },
            "rightCorner": {
              "x": -14.904,
              "y": -37.315,
              "z": 1.123
            },
            "gtin": "4009249032410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f1e",
            "leftCorner": {
              "x": -14.904,
              "y": -37.317,
              "z": 1.123
            },
            "rightCorner": {
              "x": -14.57,
              "y": -37.317,
              "z": 1.123
            },
            "gtin": "4009249001102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f1f",
            "leftCorner": {
              "x": -14.57,
              "y": -37.321,
              "z": 1.123
            },
            "rightCorner": {
              "x": -14.299,
              "y": -37.321,
              "z": 1.123
            },
            "gtin": "4009249019954",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "846"
  },
  {
    "id": "846",
    "name": "846",
    "x": -14.361,
    "y": -37.325,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 4.0143E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d073",
        "height": 0.16084,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f5e",
            "leftCorner": {
              "x": -14.36,
              "y": -37.43,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.832,
              "y": -37.429,
              "z": 0.132
            },
            "gtin": "4306188051169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f60",
            "leftCorner": {
              "x": -13.832,
              "y": -37.39,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.406,
              "y": -37.389,
              "z": 0.132
            },
            "gtin": "4306188046400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f5f",
            "leftCorner": {
              "x": -13.406,
              "y": -37.393,
              "z": 0.132
            },
            "rightCorner": {
              "x": -13.11,
              "y": -37.393,
              "z": 0.132
            },
            "gtin": "4306188046424",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d06f",
        "height": 0.46135,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f0f",
            "leftCorner": {
              "x": -14.232,
              "y": -37.33,
              "z": 0.377
            },
            "rightCorner": {
              "x": -13.895,
              "y": -37.33,
              "z": 0.377
            },
            "gtin": "4009249002420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f10",
            "leftCorner": {
              "x": -13.895,
              "y": -37.325,
              "z": 0.377
            },
            "rightCorner": {
              "x": -13.728,
              "y": -37.325,
              "z": 0.377
            },
            "gtin": "4009249001843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f11",
            "leftCorner": {
              "x": -13.728,
              "y": -37.325,
              "z": 0.377
            },
            "rightCorner": {
              "x": -13.562,
              "y": -37.325,
              "z": 0.377
            },
            "gtin": "4009249001843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f12",
            "leftCorner": {
              "x": -13.562,
              "y": -37.331,
              "z": 0.377
            },
            "rightCorner": {
              "x": -13.052,
              "y": -37.331,
              "z": 0.377
            },
            "gtin": "4009249002437",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d072",
        "height": 0.75859,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f52",
            "leftCorner": {
              "x": -14.305,
              "y": -37.329,
              "z": 0.621
            },
            "rightCorner": {
              "x": -13.96,
              "y": -37.329,
              "z": 0.621
            },
            "gtin": "4009249002277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f53",
            "leftCorner": {
              "x": -13.96,
              "y": -37.323,
              "z": 0.621
            },
            "rightCorner": {
              "x": -13.804,
              "y": -37.323,
              "z": 0.621
            },
            "gtin": "4009249002338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f54",
            "leftCorner": {
              "x": -13.804,
              "y": -37.324,
              "z": 0.621
            },
            "rightCorner": {
              "x": -13.453,
              "y": -37.324,
              "z": 0.621
            },
            "gtin": "4006170001430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f55",
            "leftCorner": {
              "x": -13.453,
              "y": -37.329,
              "z": 0.621
            },
            "rightCorner": {
              "x": -13.037,
              "y": -37.328,
              "z": 0.621
            },
            "gtin": "4009249038184",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d071",
        "height": 1.064,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f36",
            "leftCorner": {
              "x": -14.297,
              "y": -37.327,
              "z": 0.871
            },
            "rightCorner": {
              "x": -14.036,
              "y": -37.327,
              "z": 0.871
            },
            "gtin": "4006170001676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f37",
            "leftCorner": {
              "x": -14.036,
              "y": -37.32,
              "z": 0.871
            },
            "rightCorner": {
              "x": -13.794,
              "y": -37.319,
              "z": 0.871
            },
            "gtin": "4009249048855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f38",
            "leftCorner": {
              "x": -13.794,
              "y": -37.321,
              "z": 0.871
            },
            "rightCorner": {
              "x": -13.575,
              "y": -37.322,
              "z": 0.871
            },
            "gtin": "4009249007128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f39",
            "leftCorner": {
              "x": -13.575,
              "y": -37.326,
              "z": 0.871
            },
            "rightCorner": {
              "x": -13.327,
              "y": -37.326,
              "z": 0.871
            },
            "gtin": "4009249047032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f3a",
            "leftCorner": {
              "x": -13.327,
              "y": -37.327,
              "z": 0.871
            },
            "rightCorner": {
              "x": -13.054,
              "y": -37.327,
              "z": 0.871
            },
            "gtin": "4009249007135",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d070",
        "height": 1.371,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f20",
            "leftCorner": {
              "x": -14.298,
              "y": -37.323,
              "z": 1.122
            },
            "rightCorner": {
              "x": -14.05,
              "y": -37.323,
              "z": 1.122
            },
            "gtin": "4009249047919",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "1769f5b28a2d7e2a605746df",
            "leftCorner": {
              "x": -14.05,
              "y": -37.367,
              "z": 1.122
            },
            "rightCorner": {
              "x": -13.742,
              "y": -37.367,
              "z": 1.122
            },
            "gtin": "4009249019923",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "d3af160f2d5c2131253c4e27",
            "leftCorner": {
              "x": -13.742,
              "y": -37.367,
              "z": 1.122
            },
            "rightCorner": {
              "x": -13.583,
              "y": -37.366,
              "z": 1.122
            },
            "gtin": "4009249022565",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d5f23",
            "leftCorner": {
              "x": -13.535,
              "y": -37.327,
              "z": 1.122
            },
            "rightCorner": {
              "x": -13.37,
              "y": -37.326,
              "z": 1.122
            },
            "gtin": "4009249022565",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d5f24",
            "leftCorner": {
              "x": -13.37,
              "y": -37.326,
              "z": 1.122
            },
            "rightCorner": {
              "x": -13.069,
              "y": -37.326,
              "z": 1.122
            },
            "gtin": "4009249022503",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "845",
    "rightNeighborShelfId": "847"
  },
  {
    "id": "847",
    "name": "847",
    "x": -13.111,
    "y": -37.324,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 4.0143E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 22
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d079",
        "height": 0.089465,
        "facings": []
      },
      {
        "id": "68d8d3ff55f889d41539d077",
        "height": 0.45789,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f13",
            "leftCorner": {
              "x": -13.052,
              "y": -37.32,
              "z": 0.375
            },
            "rightCorner": {
              "x": -12.801,
              "y": -37.32,
              "z": 0.375
            },
            "gtin": "4071800038810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f14",
            "leftCorner": {
              "x": -12.801,
              "y": -37.322,
              "z": 0.375
            },
            "rightCorner": {
              "x": -12.549,
              "y": -37.322,
              "z": 0.375
            },
            "gtin": "4071800056784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f15",
            "leftCorner": {
              "x": -12.548,
              "y": -37.332,
              "z": 0.375
            },
            "rightCorner": {
              "x": -12.19,
              "y": -37.333,
              "z": 0.375
            },
            "gtin": "4071800001371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f16",
            "leftCorner": {
              "x": -12.19,
              "y": -37.333,
              "z": 0.375
            },
            "rightCorner": {
              "x": -12.059,
              "y": -37.333,
              "z": 0.375
            },
            "gtin": "4071800003702",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d076",
        "height": 0.75764,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f56",
            "leftCorner": {
              "x": -13.037,
              "y": -37.324,
              "z": 0.62
            },
            "rightCorner": {
              "x": -12.878,
              "y": -37.324,
              "z": 0.62
            },
            "gtin": "4071800048673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f57",
            "leftCorner": {
              "x": -12.878,
              "y": -37.322,
              "z": 0.62
            },
            "rightCorner": {
              "x": -12.713,
              "y": -37.321,
              "z": 0.62
            },
            "gtin": "4071800001012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f58",
            "leftCorner": {
              "x": -12.712,
              "y": -37.331,
              "z": 0.62
            },
            "rightCorner": {
              "x": -12.531,
              "y": -37.331,
              "z": 0.62
            },
            "gtin": "4071800049533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f59",
            "leftCorner": {
              "x": -12.531,
              "y": -37.333,
              "z": 0.62
            },
            "rightCorner": {
              "x": -12.341,
              "y": -37.332,
              "z": 0.62
            },
            "gtin": "4071800000992",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f5a",
            "leftCorner": {
              "x": -12.341,
              "y": -37.331,
              "z": 0.62
            },
            "rightCorner": {
              "x": -12.084,
              "y": -37.331,
              "z": 0.62
            },
            "gtin": "4071800058849",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d075",
        "height": 1.0629,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f3b",
            "leftCorner": {
              "x": -13.054,
              "y": -37.317,
              "z": 0.87
            },
            "rightCorner": {
              "x": -12.944,
              "y": -37.318,
              "z": 0.87
            },
            "gtin": "4071800001241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f3c",
            "leftCorner": {
              "x": -12.943,
              "y": -37.319,
              "z": 0.87
            },
            "rightCorner": {
              "x": -12.796,
              "y": -37.319,
              "z": 0.87
            },
            "gtin": "4071800058818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f3d",
            "leftCorner": {
              "x": -12.796,
              "y": -37.319,
              "z": 0.87
            },
            "rightCorner": {
              "x": -12.666,
              "y": -37.319,
              "z": 0.87
            },
            "gtin": "4071800038803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f3e",
            "leftCorner": {
              "x": -12.666,
              "y": -37.33,
              "z": 0.87
            },
            "rightCorner": {
              "x": -12.545,
              "y": -37.329,
              "z": 0.87
            },
            "gtin": "4071800058801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f3f",
            "leftCorner": {
              "x": -12.545,
              "y": -37.33,
              "z": 0.87
            },
            "rightCorner": {
              "x": -12.433,
              "y": -37.33,
              "z": 0.87
            },
            "gtin": "4071800047812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f40",
            "leftCorner": {
              "x": -12.433,
              "y": -37.329,
              "z": 0.87
            },
            "rightCorner": {
              "x": -12.349,
              "y": -37.329,
              "z": 0.87
            },
            "gtin": "4071800038568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f41",
            "leftCorner": {
              "x": -12.349,
              "y": -37.33,
              "z": 0.87
            },
            "rightCorner": {
              "x": -12.259,
              "y": -37.33,
              "z": 0.87
            },
            "gtin": "4071800038551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f42",
            "leftCorner": {
              "x": -12.259,
              "y": -37.332,
              "z": 0.87
            },
            "rightCorner": {
              "x": -12.079,
              "y": -37.331,
              "z": 0.87
            },
            "gtin": "4071800048611",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d078",
        "height": 1.3671,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f25",
            "leftCorner": {
              "x": -13.069,
              "y": -37.318,
              "z": 1.119
            },
            "rightCorner": {
              "x": -12.807,
              "y": -37.318,
              "z": 1.119
            },
            "gtin": "4071800000633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f26",
            "leftCorner": {
              "x": -12.807,
              "y": -37.323,
              "z": 1.119
            },
            "rightCorner": {
              "x": -12.524,
              "y": -37.324,
              "z": 1.119
            },
            "gtin": "4071800000558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f27",
            "leftCorner": {
              "x": -12.524,
              "y": -37.327,
              "z": 1.119
            },
            "rightCorner": {
              "x": -12.31,
              "y": -37.327,
              "z": 1.119
            },
            "gtin": "4071800038797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f28",
            "leftCorner": {
              "x": -12.309,
              "y": -37.332,
              "z": 1.119
            },
            "rightCorner": {
              "x": -12.216,
              "y": -37.332,
              "z": 1.119
            },
            "gtin": "4071800000565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f29",
            "leftCorner": {
              "x": -12.216,
              "y": -37.333,
              "z": 1.119
            },
            "rightCorner": {
              "x": -12.104,
              "y": -37.333,
              "z": 1.119
            },
            "gtin": "4071800000640",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "846",
    "rightNeighborShelfId": "848"
  },
  {
    "id": "848",
    "name": "848",
    "x": -12.112,
    "y": -37.323,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 4.0143E-4,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d07e",
        "height": 0.18361,
        "facings": [
          {
            "id": "c2301add60b072788e6ef8cc",
            "leftCorner": {
              "x": -12.112,
              "y": -37.401,
              "z": 0.15
            },
            "rightCorner": {
              "x": -12.042,
              "y": -37.401,
              "z": 0.15
            },
            "gtin": "4071800053479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "91e78118ff6beb4e6e6f92b0",
            "leftCorner": {
              "x": -12.042,
              "y": -37.401,
              "z": 0.15
            },
            "rightCorner": {
              "x": -11.948,
              "y": -37.401,
              "z": 0.15
            },
            "gtin": "4071800053462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "94ce05c213aa006d42672f90",
            "leftCorner": {
              "x": -11.948,
              "y": -37.401,
              "z": 0.15
            },
            "rightCorner": {
              "x": -11.834,
              "y": -37.401,
              "z": 0.15
            },
            "gtin": "4071800034874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "de53d69d54eb9c99f245b2cd",
            "leftCorner": {
              "x": -11.834,
              "y": -37.401,
              "z": 0.15
            },
            "rightCorner": {
              "x": -11.717,
              "y": -37.401,
              "z": 0.15
            },
            "gtin": "4071800038780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a025dafa849368288c9b6194",
            "leftCorner": {
              "x": -11.717,
              "y": -37.401,
              "z": 0.15
            },
            "rightCorner": {
              "x": -11.593,
              "y": -37.401,
              "z": 0.15
            },
            "gtin": "4071800054087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "02e23ae10ed1c509b5347e83",
            "leftCorner": {
              "x": -11.593,
              "y": -37.401,
              "z": 0.15
            },
            "rightCorner": {
              "x": -11.466,
              "y": -37.401,
              "z": 0.15
            },
            "gtin": "4071800054469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f8d9a690f990ffe6e45905f1",
            "leftCorner": {
              "x": -11.466,
              "y": -37.401,
              "z": 0.15
            },
            "rightCorner": {
              "x": -11.338,
              "y": -37.4,
              "z": 0.15
            },
            "gtin": "4071800041766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7b9a274862e4f21e77071ca1",
            "leftCorner": {
              "x": -11.338,
              "y": -37.4,
              "z": 0.15
            },
            "rightCorner": {
              "x": -11.138,
              "y": -37.4,
              "z": 0.15
            },
            "gtin": "4071800000763",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d07c",
        "height": 0.4628,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f17",
            "leftCorner": {
              "x": -12.061,
              "y": -37.329,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.879,
              "y": -37.329,
              "z": 0.379
            },
            "gtin": "4071800001166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f18",
            "leftCorner": {
              "x": -11.879,
              "y": -37.316,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.724,
              "y": -37.316,
              "z": 0.379
            },
            "gtin": "4071800003870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f19",
            "leftCorner": {
              "x": -11.724,
              "y": -37.318,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.554,
              "y": -37.318,
              "z": 0.379
            },
            "gtin": "4071800004372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f0b",
            "leftCorner": {
              "x": -11.554,
              "y": -37.311,
              "z": 0.379
            },
            "rightCorner": {
              "x": -11.112,
              "y": -37.311,
              "z": 0.379
            },
            "gtin": "4071800034874",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d07d",
        "height": 0.76198,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f5b",
            "leftCorner": {
              "x": -12.086,
              "y": -37.328,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.778,
              "y": -37.329,
              "z": 0.623
            },
            "gtin": "4071800000855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f5c",
            "leftCorner": {
              "x": -11.777,
              "y": -37.32,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.632,
              "y": -37.32,
              "z": 0.623
            },
            "gtin": "4071800000862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f5d",
            "leftCorner": {
              "x": -11.632,
              "y": -37.319,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.391,
              "y": -37.319,
              "z": 0.623
            },
            "gtin": "4071800000886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f4b",
            "leftCorner": {
              "x": -11.391,
              "y": -37.311,
              "z": 0.623
            },
            "rightCorner": {
              "x": -11.112,
              "y": -37.311,
              "z": 0.623
            },
            "gtin": "4071800000879",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d07b",
        "height": 1.0659,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f43",
            "leftCorner": {
              "x": -12.081,
              "y": -37.329,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.953,
              "y": -37.329,
              "z": 0.872
            },
            "gtin": "4071800054087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f44",
            "leftCorner": {
              "x": -11.953,
              "y": -37.325,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.811,
              "y": -37.325,
              "z": 0.872
            },
            "gtin": "4071800058825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f45",
            "leftCorner": {
              "x": -11.811,
              "y": -37.32,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.671,
              "y": -37.319,
              "z": 0.872
            },
            "gtin": "4071800052618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f46",
            "leftCorner": {
              "x": -11.671,
              "y": -37.321,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.53,
              "y": -37.321,
              "z": 0.872
            },
            "gtin": "4071800051314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f47",
            "leftCorner": {
              "x": -11.53,
              "y": -37.316,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.399,
              "y": -37.315,
              "z": 0.872
            },
            "gtin": "4071800058832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f48",
            "leftCorner": {
              "x": -11.399,
              "y": -37.312,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.294,
              "y": -37.312,
              "z": 0.872
            },
            "gtin": "4071800054469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f49",
            "leftCorner": {
              "x": -11.294,
              "y": -37.309,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.186,
              "y": -37.308,
              "z": 0.872
            },
            "gtin": "4071800053462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f30",
            "leftCorner": {
              "x": -11.186,
              "y": -37.305,
              "z": 0.872
            },
            "rightCorner": {
              "x": -11.112,
              "y": -37.306,
              "z": 0.872
            },
            "gtin": "4071800053479",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d07a",
        "height": 1.3705,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f2a",
            "leftCorner": {
              "x": -12.106,
              "y": -37.33,
              "z": 1.121
            },
            "rightCorner": {
              "x": -12.005,
              "y": -37.33,
              "z": 1.121
            },
            "gtin": "4071800038780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f2b",
            "leftCorner": {
              "x": -12.005,
              "y": -37.327,
              "z": 1.121
            },
            "rightCorner": {
              "x": -11.866,
              "y": -37.327,
              "z": 1.121
            },
            "gtin": "4071800041766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f2c",
            "leftCorner": {
              "x": -11.866,
              "y": -37.324,
              "z": 1.121
            },
            "rightCorner": {
              "x": -11.708,
              "y": -37.324,
              "z": 1.121
            },
            "gtin": "4071800034508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f2d",
            "leftCorner": {
              "x": -11.708,
              "y": -37.322,
              "z": 1.121
            },
            "rightCorner": {
              "x": -11.509,
              "y": -37.322,
              "z": 1.121
            },
            "gtin": "4071800000909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f2e",
            "leftCorner": {
              "x": -11.509,
              "y": -37.318,
              "z": 1.121
            },
            "rightCorner": {
              "x": -11.312,
              "y": -37.318,
              "z": 1.121
            },
            "gtin": "4071800000763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f1b",
            "leftCorner": {
              "x": -11.312,
              "y": -37.314,
              "z": 1.121
            },
            "rightCorner": {
              "x": -11.112,
              "y": -37.314,
              "z": 1.121
            },
            "gtin": "4071800000824",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "847"
  },
  {
    "id": "849",
    "name": "849",
    "x": -11.08,
    "y": -36.121,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 0.0029234
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 31
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d05a",
        "height": 0.17331,
        "facings": [
          {
            "id": "14c7b98d8817a150ed22bf62",
            "leftCorner": {
              "x": -11.081,
              "y": -36.023,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.131,
              "y": -36.023,
              "z": 0.142
            },
            "gtin": "9001432002205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1101fe0cfb2922d40c648306",
            "leftCorner": {
              "x": -11.131,
              "y": -36.023,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.213,
              "y": -36.024,
              "z": 0.142
            },
            "gtin": "40555232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ca61dc5dac345660b288b7e6",
            "leftCorner": {
              "x": -11.213,
              "y": -36.024,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.301,
              "y": -36.024,
              "z": 0.142
            },
            "gtin": "5098732012656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0e74d863eeaba68af73ba5f6",
            "leftCorner": {
              "x": -11.301,
              "y": -36.024,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.407,
              "y": -36.025,
              "z": 0.142
            },
            "gtin": "4000412047002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1e782af6146a4b2bb1f85082",
            "leftCorner": {
              "x": -11.407,
              "y": -36.025,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.53,
              "y": -36.026,
              "z": 0.142
            },
            "gtin": "5098732004842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c5e15b74cc7f630b48894898",
            "leftCorner": {
              "x": -11.53,
              "y": -36.026,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.665,
              "y": -36.026,
              "z": 0.142
            },
            "gtin": "9001432002229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bf697facfbf43f2399740290",
            "leftCorner": {
              "x": -11.665,
              "y": -36.026,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.801,
              "y": -36.027,
              "z": 0.142
            },
            "gtin": "9001432029424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "635755b5b964f98fa749c35c",
            "leftCorner": {
              "x": -11.801,
              "y": -36.027,
              "z": 0.142
            },
            "rightCorner": {
              "x": -11.944,
              "y": -36.028,
              "z": 0.142
            },
            "gtin": "9001432029387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "71a4f3c0e296b03a016f97ee",
            "leftCorner": {
              "x": -11.944,
              "y": -36.028,
              "z": 0.142
            },
            "rightCorner": {
              "x": -12.08,
              "y": -36.029,
              "z": 0.142
            },
            "gtin": "9001432029424",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d056",
        "height": 0.47045,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5e65",
            "leftCorner": {
              "x": -11.08,
              "y": -36.064,
              "z": 0.385
            },
            "rightCorner": {
              "x": -11.248,
              "y": -36.066,
              "z": 0.385
            },
            "gtin": "9001432035111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e67",
            "leftCorner": {
              "x": -11.248,
              "y": -36.107,
              "z": 0.385
            },
            "rightCorner": {
              "x": -11.47,
              "y": -36.108,
              "z": 0.385
            },
            "gtin": "9001432048364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e68",
            "leftCorner": {
              "x": -11.47,
              "y": -36.105,
              "z": 0.385
            },
            "rightCorner": {
              "x": -11.608,
              "y": -36.106,
              "z": 0.385
            },
            "gtin": "9001432029424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e69",
            "leftCorner": {
              "x": -11.608,
              "y": -36.107,
              "z": 0.385
            },
            "rightCorner": {
              "x": -11.751,
              "y": -36.108,
              "z": 0.385
            },
            "gtin": "9001432029387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e6a",
            "leftCorner": {
              "x": -11.751,
              "y": -36.108,
              "z": 0.385
            },
            "rightCorner": {
              "x": -12.003,
              "y": -36.11,
              "z": 0.385
            },
            "gtin": "9001432025099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e6b",
            "leftCorner": {
              "x": -12.003,
              "y": -36.108,
              "z": 0.385
            },
            "rightCorner": {
              "x": -12.173,
              "y": -36.108,
              "z": 0.385
            },
            "gtin": "40555232",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d058",
        "height": 0.76952,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5e7e",
            "leftCorner": {
              "x": -11.08,
              "y": -36.065,
              "z": 0.63
            },
            "rightCorner": {
              "x": -11.258,
              "y": -36.066,
              "z": 0.63
            },
            "gtin": "9001432002236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e80",
            "leftCorner": {
              "x": -11.258,
              "y": -36.106,
              "z": 0.63
            },
            "rightCorner": {
              "x": -11.41,
              "y": -36.107,
              "z": 0.63
            },
            "gtin": "9001432002366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e81",
            "leftCorner": {
              "x": -11.41,
              "y": -36.105,
              "z": 0.63
            },
            "rightCorner": {
              "x": -11.589,
              "y": -36.106,
              "z": 0.63
            },
            "gtin": "9001432002335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e82",
            "leftCorner": {
              "x": -11.589,
              "y": -36.107,
              "z": 0.63
            },
            "rightCorner": {
              "x": -11.719,
              "y": -36.108,
              "z": 0.63
            },
            "gtin": "9001432002229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e83",
            "leftCorner": {
              "x": -11.719,
              "y": -36.11,
              "z": 0.63
            },
            "rightCorner": {
              "x": -11.867,
              "y": -36.111,
              "z": 0.63
            },
            "gtin": "9001432002281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e84",
            "leftCorner": {
              "x": -11.867,
              "y": -36.107,
              "z": 0.63
            },
            "rightCorner": {
              "x": -12.036,
              "y": -36.108,
              "z": 0.63
            },
            "gtin": "9001432031540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e85",
            "leftCorner": {
              "x": -12.036,
              "y": -36.109,
              "z": 0.63
            },
            "rightCorner": {
              "x": -12.153,
              "y": -36.109,
              "z": 0.63
            },
            "gtin": "9001432002205",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d057",
        "height": 1.0591,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5e71",
            "leftCorner": {
              "x": -11.08,
              "y": -36.07,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.249,
              "y": -36.072,
              "z": 0.867
            },
            "gtin": "9001432031656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e73",
            "leftCorner": {
              "x": -11.249,
              "y": -36.111,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.39,
              "y": -36.112,
              "z": 0.867
            },
            "gtin": "9001432001918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e74",
            "leftCorner": {
              "x": -11.39,
              "y": -36.111,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.558,
              "y": -36.112,
              "z": 0.867
            },
            "gtin": "9001432039058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e75",
            "leftCorner": {
              "x": -11.558,
              "y": -36.113,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.709,
              "y": -36.114,
              "z": 0.867
            },
            "gtin": "9001432038297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e76",
            "leftCorner": {
              "x": -11.709,
              "y": -36.115,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.863,
              "y": -36.117,
              "z": 0.867
            },
            "gtin": "5098732000660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e77",
            "leftCorner": {
              "x": -11.863,
              "y": -36.115,
              "z": 0.867
            },
            "rightCorner": {
              "x": -11.989,
              "y": -36.116,
              "z": 0.867
            },
            "gtin": "5098732004842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e78",
            "leftCorner": {
              "x": -11.989,
              "y": -36.117,
              "z": 0.867
            },
            "rightCorner": {
              "x": -12.125,
              "y": -36.117,
              "z": 0.867
            },
            "gtin": "5098732012656",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d059",
        "height": 1.3632,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5e8b",
            "leftCorner": {
              "x": -11.08,
              "y": -36.065,
              "z": 1.115
            },
            "rightCorner": {
              "x": -11.687,
              "y": -36.069,
              "z": 1.115
            },
            "gtin": "4000412010266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e8d",
            "leftCorner": {
              "x": -11.687,
              "y": -36.109,
              "z": 1.115
            },
            "rightCorner": {
              "x": -11.984,
              "y": -36.111,
              "z": 1.115
            },
            "gtin": "4000412050200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e8e",
            "leftCorner": {
              "x": -11.984,
              "y": -36.111,
              "z": 1.115
            },
            "rightCorner": {
              "x": -12.218,
              "y": -36.111,
              "z": 1.115
            },
            "gtin": "4000412047002",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "84a"
  },
  {
    "id": "84a",
    "name": "84a",
    "x": -12.08,
    "y": -36.127,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 0.0029234
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d05f",
        "height": 0.16633,
        "facings": [
          {
            "id": "59278b9fb441c7d73ad6eef0",
            "leftCorner": {
              "x": -12.08,
              "y": -36.033,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.168,
              "y": -36.034,
              "z": 0.136
            },
            "gtin": "4009265003609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aa43ca8566d71bd6067d4414",
            "leftCorner": {
              "x": -12.168,
              "y": -36.034,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.272,
              "y": -36.034,
              "z": 0.136
            },
            "gtin": "4009265002206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b10bc22d57567393d4ac0405",
            "leftCorner": {
              "x": -12.272,
              "y": -36.034,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.412,
              "y": -36.035,
              "z": 0.136
            },
            "gtin": "4055500012882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "256b74893569109dfb17f381",
            "leftCorner": {
              "x": -12.412,
              "y": -36.035,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.555,
              "y": -36.036,
              "z": 0.136
            },
            "gtin": "4009265001100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8ce400c71bfdf71b9530c341",
            "leftCorner": {
              "x": -12.555,
              "y": -36.036,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.701,
              "y": -36.037,
              "z": 0.136
            },
            "gtin": "4028712300405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7e30e200be3dd1296fbfd6e6",
            "leftCorner": {
              "x": -12.701,
              "y": -36.037,
              "z": 0.136
            },
            "rightCorner": {
              "x": -12.848,
              "y": -36.037,
              "z": 0.136
            },
            "gtin": "40555584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3e6c4e2fefa8395db9708193",
            "leftCorner": {
              "x": -12.848,
              "y": -36.037,
              "z": 0.136
            },
            "rightCorner": {
              "x": -13.071,
              "y": -36.039,
              "z": 0.136
            },
            "gtin": "4000412045244",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d05d",
        "height": 0.46467,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5e6c",
            "leftCorner": {
              "x": -12.173,
              "y": -36.109,
              "z": 0.38
            },
            "rightCorner": {
              "x": -12.332,
              "y": -36.11,
              "z": 0.38
            },
            "gtin": "4009265001407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e6d",
            "leftCorner": {
              "x": -12.332,
              "y": -36.113,
              "z": 0.38
            },
            "rightCorner": {
              "x": -12.504,
              "y": -36.113,
              "z": 0.38
            },
            "gtin": "4009265003609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e6e",
            "leftCorner": {
              "x": -12.504,
              "y": -36.116,
              "z": 0.38
            },
            "rightCorner": {
              "x": -12.667,
              "y": -36.117,
              "z": 0.38
            },
            "gtin": "4009265001308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e6f",
            "leftCorner": {
              "x": -12.667,
              "y": -36.116,
              "z": 0.38
            },
            "rightCorner": {
              "x": -12.767,
              "y": -36.116,
              "z": 0.38
            },
            "gtin": "4009265002206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e70",
            "leftCorner": {
              "x": -12.767,
              "y": -36.116,
              "z": 0.38
            },
            "rightCorner": {
              "x": -12.931,
              "y": -36.118,
              "z": 0.38
            },
            "gtin": "4009265002404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e66",
            "leftCorner": {
              "x": -12.931,
              "y": -36.117,
              "z": 0.38
            },
            "rightCorner": {
              "x": -13.08,
              "y": -36.118,
              "z": 0.38
            },
            "gtin": "4009265001704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "560d28b2e8fca7e730133966",
            "leftCorner": {
              "x": -12.08,
              "y": -36.072,
              "z": 0.38
            },
            "rightCorner": {
              "x": -12.168,
              "y": -36.073,
              "z": 0.38
            },
            "gtin": "4009265003609",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d05e",
        "height": 0.76238,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5e86",
            "leftCorner": {
              "x": -12.153,
              "y": -36.107,
              "z": 0.624
            },
            "rightCorner": {
              "x": -12.237,
              "y": -36.108,
              "z": 0.624
            },
            "gtin": "4055500012882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e87",
            "leftCorner": {
              "x": -12.237,
              "y": -36.106,
              "z": 0.624
            },
            "rightCorner": {
              "x": -12.444,
              "y": -36.108,
              "z": 0.624
            },
            "gtin": "4028712300382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e88",
            "leftCorner": {
              "x": -12.444,
              "y": -36.115,
              "z": 0.624
            },
            "rightCorner": {
              "x": -12.619,
              "y": -36.115,
              "z": 0.624
            },
            "gtin": "4028712300368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e89",
            "leftCorner": {
              "x": -12.619,
              "y": -36.116,
              "z": 0.624
            },
            "rightCorner": {
              "x": -12.77,
              "y": -36.117,
              "z": 0.624
            },
            "gtin": "4028712300405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e8a",
            "leftCorner": {
              "x": -12.77,
              "y": -36.116,
              "z": 0.624
            },
            "rightCorner": {
              "x": -12.948,
              "y": -36.118,
              "z": 0.624
            },
            "gtin": "4028712300320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e7f",
            "leftCorner": {
              "x": -12.948,
              "y": -36.116,
              "z": 0.624
            },
            "rightCorner": {
              "x": -13.08,
              "y": -36.117,
              "z": 0.624
            },
            "gtin": "40555584",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d05c",
        "height": 1.0522,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5e79",
            "leftCorner": {
              "x": -12.125,
              "y": -36.114,
              "z": 0.861
            },
            "rightCorner": {
              "x": -12.239,
              "y": -36.114,
              "z": 0.861
            },
            "gtin": "4009265001100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e7a",
            "leftCorner": {
              "x": -12.239,
              "y": -36.117,
              "z": 0.861
            },
            "rightCorner": {
              "x": -12.412,
              "y": -36.118,
              "z": 0.861
            },
            "gtin": "40555430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e7b",
            "leftCorner": {
              "x": -12.412,
              "y": -36.119,
              "z": 0.861
            },
            "rightCorner": {
              "x": -12.593,
              "y": -36.119,
              "z": 0.861
            },
            "gtin": "4104420024489",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e7c",
            "leftCorner": {
              "x": -12.593,
              "y": -36.119,
              "z": 0.861
            },
            "rightCorner": {
              "x": -12.753,
              "y": -36.12,
              "z": 0.861
            },
            "gtin": "4104420024441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e7d",
            "leftCorner": {
              "x": -12.753,
              "y": -36.121,
              "z": 0.861
            },
            "rightCorner": {
              "x": -12.918,
              "y": -36.122,
              "z": 0.861
            },
            "gtin": "4104420024526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e72",
            "leftCorner": {
              "x": -12.918,
              "y": -36.121,
              "z": 0.861
            },
            "rightCorner": {
              "x": -13.08,
              "y": -36.122,
              "z": 0.861
            },
            "gtin": "4104420024588",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d05b",
        "height": 1.358,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5e8f",
            "leftCorner": {
              "x": -12.217,
              "y": -36.112,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.442,
              "y": -36.114,
              "z": 1.111
            },
            "gtin": "4000412045244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e90",
            "leftCorner": {
              "x": -12.442,
              "y": -36.114,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.614,
              "y": -36.114,
              "z": 1.111
            },
            "gtin": "4000412010907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e91",
            "leftCorner": {
              "x": -12.614,
              "y": -36.115,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.741,
              "y": -36.116,
              "z": 1.111
            },
            "gtin": "4000412050606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e92",
            "leftCorner": {
              "x": -12.741,
              "y": -36.113,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.903,
              "y": -36.115,
              "z": 1.111
            },
            "gtin": "4104420021013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5e8c",
            "leftCorner": {
              "x": -12.903,
              "y": -36.115,
              "z": 1.111
            },
            "rightCorner": {
              "x": -13.08,
              "y": -36.116,
              "z": 1.111
            },
            "gtin": "4104420021037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6d92785642590022be946243",
            "leftCorner": {
              "x": -12.08,
              "y": -36.071,
              "z": 1.111
            },
            "rightCorner": {
              "x": -12.207,
              "y": -36.072,
              "z": 1.111
            },
            "gtin": "4000412050606",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "849",
    "rightNeighborShelfId": "84b"
  },
  {
    "id": "84b",
    "name": "84b",
    "x": -13.08,
    "y": -36.133,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 0.0029234
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 52
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d065",
        "height": 0.16714,
        "facings": [
          {
            "id": "58a12fe82b1b94af5ffc6c22",
            "leftCorner": {
              "x": -13.081,
              "y": -36.041,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.144,
              "y": -36.041,
              "z": 0.137
            },
            "gtin": "4306188051428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d8d73d95b570eeca331d60f6",
            "leftCorner": {
              "x": -13.144,
              "y": -36.041,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.216,
              "y": -36.042,
              "z": 0.137
            },
            "gtin": "4023300910509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2c78a5af676badc50d0a0361",
            "leftCorner": {
              "x": -13.216,
              "y": -36.042,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.288,
              "y": -36.042,
              "z": 0.137
            },
            "gtin": "4023300919908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "eb26c9112c1cd694ef51df38",
            "leftCorner": {
              "x": -13.288,
              "y": -36.042,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.363,
              "y": -36.043,
              "z": 0.137
            },
            "gtin": "4104420024403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0ccafcc3076045578a131a62",
            "leftCorner": {
              "x": -13.363,
              "y": -36.043,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.438,
              "y": -36.043,
              "z": 0.137
            },
            "gtin": "4023300901507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d9acac99ee63af4994f0be1e",
            "leftCorner": {
              "x": -13.438,
              "y": -36.043,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.513,
              "y": -36.044,
              "z": 0.137
            },
            "gtin": "4028712301327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "84dd8994db39f48696513381",
            "leftCorner": {
              "x": -13.513,
              "y": -36.044,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.59,
              "y": -36.044,
              "z": 0.137
            },
            "gtin": "4104420093201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "754ec27837c20711763a1e40",
            "leftCorner": {
              "x": -13.59,
              "y": -36.044,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.669,
              "y": -36.044,
              "z": 0.137
            },
            "gtin": "4023300910301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4697f813869de8a11297cdc1",
            "leftCorner": {
              "x": -13.669,
              "y": -36.044,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.749,
              "y": -36.045,
              "z": 0.137
            },
            "gtin": "4023300910400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2fb00251b2ea7fd510a7d423",
            "leftCorner": {
              "x": -13.749,
              "y": -36.045,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.83,
              "y": -36.045,
              "z": 0.137
            },
            "gtin": "4023300901705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8f5a6859ff889c2dd50edd50",
            "leftCorner": {
              "x": -13.83,
              "y": -36.045,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.912,
              "y": -36.046,
              "z": 0.137
            },
            "gtin": "4023300901002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e12a7d27eef38d59c7d95862",
            "leftCorner": {
              "x": -13.912,
              "y": -36.046,
              "z": 0.137
            },
            "rightCorner": {
              "x": -13.994,
              "y": -36.046,
              "z": 0.137
            },
            "gtin": "4023300900906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cf892a1d059c9972e182ed04",
            "leftCorner": {
              "x": -13.994,
              "y": -36.046,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.083,
              "y": -36.047,
              "z": 0.137
            },
            "gtin": "4023300901101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5148d313cbda5e9ccd44c2fe",
            "leftCorner": {
              "x": -14.083,
              "y": -36.047,
              "z": 0.137
            },
            "rightCorner": {
              "x": -14.283,
              "y": -36.048,
              "z": 0.137
            },
            "gtin": "40555133",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d060",
        "height": 0.45325,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5ea3",
            "leftCorner": {
              "x": -13.08,
              "y": -36.086,
              "z": 0.371
            },
            "rightCorner": {
              "x": -13.446,
              "y": -36.088,
              "z": 0.371
            },
            "gtin": "4306188047964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ea4",
            "leftCorner": {
              "x": -13.446,
              "y": -36.088,
              "z": 0.371
            },
            "rightCorner": {
              "x": -13.813,
              "y": -36.089,
              "z": 0.371
            },
            "gtin": "4306188047964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ea5",
            "leftCorner": {
              "x": -13.812,
              "y": -36.129,
              "z": 0.371
            },
            "rightCorner": {
              "x": -14.33,
              "y": -36.133,
              "z": 0.371
            },
            "gtin": "4306188047124",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d062",
        "height": 0.67385,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5ebc",
            "leftCorner": {
              "x": -13.08,
              "y": -36.08,
              "z": 0.551
            },
            "rightCorner": {
              "x": -13.718,
              "y": -36.084,
              "z": 0.551
            },
            "gtin": "40555027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ebe",
            "leftCorner": {
              "x": -13.717,
              "y": -36.126,
              "z": 0.551
            },
            "rightCorner": {
              "x": -13.866,
              "y": -36.126,
              "z": 0.551
            },
            "gtin": "8013108003981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ebf",
            "leftCorner": {
              "x": -13.866,
              "y": -36.123,
              "z": 0.551
            },
            "rightCorner": {
              "x": -14.147,
              "y": -36.125,
              "z": 0.551
            },
            "gtin": "4250426228533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ebd",
            "leftCorner": {
              "x": -14.147,
              "y": -36.132,
              "z": 0.551
            },
            "rightCorner": {
              "x": -14.33,
              "y": -36.134,
              "z": 0.551
            },
            "gtin": "4250426228519",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d064",
        "height": 0.90115,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5ed2",
            "leftCorner": {
              "x": -13.08,
              "y": -36.081,
              "z": 0.737
            },
            "rightCorner": {
              "x": -13.277,
              "y": -36.082,
              "z": 0.737
            },
            "gtin": "40555133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ed4",
            "leftCorner": {
              "x": -13.277,
              "y": -36.123,
              "z": 0.737
            },
            "rightCorner": {
              "x": -13.453,
              "y": -36.125,
              "z": 0.737
            },
            "gtin": "40555126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ed5",
            "leftCorner": {
              "x": -13.453,
              "y": -36.123,
              "z": 0.737
            },
            "rightCorner": {
              "x": -13.62,
              "y": -36.123,
              "z": 0.737
            },
            "gtin": "4055500012578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ed6",
            "leftCorner": {
              "x": -13.62,
              "y": -36.127,
              "z": 0.737
            },
            "rightCorner": {
              "x": -13.805,
              "y": -36.128,
              "z": 0.737
            },
            "gtin": "40555157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ed7",
            "leftCorner": {
              "x": -13.806,
              "y": -36.124,
              "z": 0.737
            },
            "rightCorner": {
              "x": -13.982,
              "y": -36.125,
              "z": 0.737
            },
            "gtin": "4055500012240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ed8",
            "leftCorner": {
              "x": -13.982,
              "y": -36.125,
              "z": 0.737
            },
            "rightCorner": {
              "x": -14.132,
              "y": -36.126,
              "z": 0.737
            },
            "gtin": "4055500012530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ed9",
            "leftCorner": {
              "x": -14.132,
              "y": -36.127,
              "z": 0.737
            },
            "rightCorner": {
              "x": -14.258,
              "y": -36.129,
              "z": 0.737
            },
            "gtin": "4306188032922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ed3",
            "leftCorner": {
              "x": -14.258,
              "y": -36.126,
              "z": 0.737
            },
            "rightCorner": {
              "x": -14.33,
              "y": -36.127,
              "z": 0.737
            },
            "gtin": "4306188382720",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d063",
        "height": 1.1529,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5ec0",
            "leftCorner": {
              "x": -13.08,
              "y": -36.077,
              "z": 0.943
            },
            "rightCorner": {
              "x": -13.281,
              "y": -36.078,
              "z": 0.943
            },
            "gtin": "40555867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ec2",
            "leftCorner": {
              "x": -13.281,
              "y": -36.118,
              "z": 0.943
            },
            "rightCorner": {
              "x": -13.593,
              "y": -36.12,
              "z": 0.943
            },
            "gtin": "4023300492135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ec3",
            "leftCorner": {
              "x": -13.593,
              "y": -36.12,
              "z": 0.943
            },
            "rightCorner": {
              "x": -13.771,
              "y": -36.121,
              "z": 0.943
            },
            "gtin": "4023300921307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ec4",
            "leftCorner": {
              "x": -13.771,
              "y": -36.12,
              "z": 0.943
            },
            "rightCorner": {
              "x": -13.94,
              "y": -36.121,
              "z": 0.943
            },
            "gtin": "4023300490117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ec5",
            "leftCorner": {
              "x": -13.94,
              "y": -36.122,
              "z": 0.943
            },
            "rightCorner": {
              "x": -14.069,
              "y": -36.123,
              "z": 0.943
            },
            "gtin": "4023300490056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ec6",
            "leftCorner": {
              "x": -14.069,
              "y": -36.128,
              "z": 0.943
            },
            "rightCorner": {
              "x": -14.178,
              "y": -36.128,
              "z": 0.943
            },
            "gtin": "4023300937704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ec7",
            "leftCorner": {
              "x": -14.178,
              "y": -36.123,
              "z": 0.943
            },
            "rightCorner": {
              "x": -14.269,
              "y": -36.124,
              "z": 0.943
            },
            "gtin": "4306188051459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ec8",
            "leftCorner": {
              "x": -14.269,
              "y": -36.122,
              "z": 0.943
            },
            "rightCorner": {
              "x": -14.358,
              "y": -36.122,
              "z": 0.943
            },
            "gtin": "4306188051428",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d061",
        "height": 1.4066,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5ea6",
            "leftCorner": {
              "x": -13.08,
              "y": -36.07,
              "z": 1.151
            },
            "rightCorner": {
              "x": -13.153,
              "y": -36.071,
              "z": 1.151
            },
            "gtin": "4104420024403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ea8",
            "leftCorner": {
              "x": -13.153,
              "y": -36.11,
              "z": 1.151
            },
            "rightCorner": {
              "x": -13.228,
              "y": -36.11,
              "z": 1.151
            },
            "gtin": "4104420093201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ea9",
            "leftCorner": {
              "x": -13.228,
              "y": -36.111,
              "z": 1.151
            },
            "rightCorner": {
              "x": -13.399,
              "y": -36.113,
              "z": 1.151
            },
            "gtin": "4023300900906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eaa",
            "leftCorner": {
              "x": -13.399,
              "y": -36.11,
              "z": 1.151
            },
            "rightCorner": {
              "x": -13.486,
              "y": -36.11,
              "z": 1.151
            },
            "gtin": "4023300901101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eab",
            "leftCorner": {
              "x": -13.486,
              "y": -36.091,
              "z": 1.151
            },
            "rightCorner": {
              "x": -13.557,
              "y": -36.091,
              "z": 1.151
            },
            "gtin": "4023300919908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eac",
            "leftCorner": {
              "x": -13.557,
              "y": -36.112,
              "z": 1.151
            },
            "rightCorner": {
              "x": -13.628,
              "y": -36.113,
              "z": 1.151
            },
            "gtin": "4023300901507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ead",
            "leftCorner": {
              "x": -13.628,
              "y": -36.114,
              "z": 1.151
            },
            "rightCorner": {
              "x": -13.71,
              "y": -36.115,
              "z": 1.151
            },
            "gtin": "4023300910400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eae",
            "leftCorner": {
              "x": -13.71,
              "y": -36.117,
              "z": 1.151
            },
            "rightCorner": {
              "x": -13.796,
              "y": -36.117,
              "z": 1.151
            },
            "gtin": "4023300901705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eaf",
            "leftCorner": {
              "x": -13.796,
              "y": -36.116,
              "z": 1.151
            },
            "rightCorner": {
              "x": -13.876,
              "y": -36.116,
              "z": 1.151
            },
            "gtin": "4023300901002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eb0",
            "leftCorner": {
              "x": -13.876,
              "y": -36.114,
              "z": 1.151
            },
            "rightCorner": {
              "x": -13.953,
              "y": -36.115,
              "z": 1.151
            },
            "gtin": "4023300910509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eb1",
            "leftCorner": {
              "x": -13.953,
              "y": -36.11,
              "z": 1.151
            },
            "rightCorner": {
              "x": -14.031,
              "y": -36.11,
              "z": 1.151
            },
            "gtin": "4023300910301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eb2",
            "leftCorner": {
              "x": -14.031,
              "y": -36.117,
              "z": 1.151
            },
            "rightCorner": {
              "x": -14.076,
              "y": -36.117,
              "z": 1.151
            },
            "gtin": "4028712301310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eb3",
            "leftCorner": {
              "x": -14.076,
              "y": -36.112,
              "z": 1.151
            },
            "rightCorner": {
              "x": -14.154,
              "y": -36.111,
              "z": 1.151
            },
            "gtin": "4028712301310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eb4",
            "leftCorner": {
              "x": -14.154,
              "y": -36.117,
              "z": 1.151
            },
            "rightCorner": {
              "x": -14.232,
              "y": -36.118,
              "z": 1.151
            },
            "gtin": "4028712301327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eb5",
            "leftCorner": {
              "x": -14.232,
              "y": -36.12,
              "z": 1.151
            },
            "rightCorner": {
              "x": -14.369,
              "y": -36.121,
              "z": 1.151
            },
            "gtin": "4028712301303",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "84a",
    "rightNeighborShelfId": "84c"
  },
  {
    "id": "84c",
    "name": "84c",
    "x": -14.33,
    "y": -36.14,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 0.0029234
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d068",
        "height": 0.52932,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5eda",
            "leftCorner": {
              "x": -14.33,
              "y": -36.094,
              "z": 0.433
            },
            "rightCorner": {
              "x": -14.534,
              "y": -36.096,
              "z": 0.433
            },
            "gtin": "4011800081003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5edc",
            "leftCorner": {
              "x": -14.534,
              "y": -36.136,
              "z": 0.433
            },
            "rightCorner": {
              "x": -14.663,
              "y": -36.137,
              "z": 0.433
            },
            "gtin": "8710573341555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5edd",
            "leftCorner": {
              "x": -14.663,
              "y": -36.136,
              "z": 0.433
            },
            "rightCorner": {
              "x": -14.787,
              "y": -36.136,
              "z": 0.433
            },
            "gtin": "4067987001112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ede",
            "leftCorner": {
              "x": -14.787,
              "y": -36.135,
              "z": 0.433
            },
            "rightCorner": {
              "x": -14.963,
              "y": -36.136,
              "z": 0.433
            },
            "gtin": "4067987001099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5edf",
            "leftCorner": {
              "x": -14.963,
              "y": -36.14,
              "z": 0.433
            },
            "rightCorner": {
              "x": -15.15,
              "y": -36.142,
              "z": 0.433
            },
            "gtin": "4002575639773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ee0",
            "leftCorner": {
              "x": -15.15,
              "y": -36.139,
              "z": 0.433
            },
            "rightCorner": {
              "x": -15.297,
              "y": -36.14,
              "z": 0.433
            },
            "gtin": "3608580101932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ee1",
            "leftCorner": {
              "x": -15.297,
              "y": -36.14,
              "z": 0.433
            },
            "rightCorner": {
              "x": -15.433,
              "y": -36.141,
              "z": 0.433
            },
            "gtin": "4018087009331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5edb",
            "leftCorner": {
              "x": -15.433,
              "y": -36.138,
              "z": 0.433
            },
            "rightCorner": {
              "x": -15.58,
              "y": -36.139,
              "z": 0.433
            },
            "gtin": "7622201127206",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d069",
        "height": 0.82947,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5ee2",
            "leftCorner": {
              "x": -14.33,
              "y": -36.094,
              "z": 0.679
            },
            "rightCorner": {
              "x": -14.582,
              "y": -36.095,
              "z": 0.679
            },
            "gtin": "8710573693319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ee4",
            "leftCorner": {
              "x": -14.581,
              "y": -36.135,
              "z": 0.679
            },
            "rightCorner": {
              "x": -14.73,
              "y": -36.136,
              "z": 0.679
            },
            "gtin": "8710573541559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ee5",
            "leftCorner": {
              "x": -14.73,
              "y": -36.135,
              "z": 0.679
            },
            "rightCorner": {
              "x": -14.876,
              "y": -36.136,
              "z": 0.679
            },
            "gtin": "8710573492318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ee6",
            "leftCorner": {
              "x": -14.876,
              "y": -36.138,
              "z": 0.679
            },
            "rightCorner": {
              "x": -15.062,
              "y": -36.138,
              "z": 0.679
            },
            "gtin": "8693887003169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ee7",
            "leftCorner": {
              "x": -15.063,
              "y": -36.14,
              "z": 0.679
            },
            "rightCorner": {
              "x": -15.239,
              "y": -36.142,
              "z": 0.679
            },
            "gtin": "4054600030536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ee8",
            "leftCorner": {
              "x": -15.239,
              "y": -36.142,
              "z": 0.679
            },
            "rightCorner": {
              "x": -15.388,
              "y": -36.143,
              "z": 0.679
            },
            "gtin": "4054600029738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ee3",
            "leftCorner": {
              "x": -15.388,
              "y": -36.135,
              "z": 0.679
            },
            "rightCorner": {
              "x": -15.58,
              "y": -36.137,
              "z": 0.679
            },
            "gtin": "4054600030338",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d067",
        "height": 1.1596,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5ec9",
            "leftCorner": {
              "x": -14.358,
              "y": -36.123,
              "z": 0.949
            },
            "rightCorner": {
              "x": -14.505,
              "y": -36.123,
              "z": 0.949
            },
            "gtin": "80809180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eca",
            "leftCorner": {
              "x": -14.506,
              "y": -36.13,
              "z": 0.949
            },
            "rightCorner": {
              "x": -14.672,
              "y": -36.131,
              "z": 0.949
            },
            "gtin": "4002575610659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ecb",
            "leftCorner": {
              "x": -14.672,
              "y": -36.132,
              "z": 0.949
            },
            "rightCorner": {
              "x": -14.842,
              "y": -36.132,
              "z": 0.949
            },
            "gtin": "4002575610635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ecc",
            "leftCorner": {
              "x": -14.842,
              "y": -36.138,
              "z": 0.949
            },
            "rightCorner": {
              "x": -14.9,
              "y": -36.138,
              "z": 0.949
            },
            "gtin": "4104420177673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ecd",
            "leftCorner": {
              "x": -14.9,
              "y": -36.135,
              "z": 0.949
            },
            "rightCorner": {
              "x": -14.989,
              "y": -36.136,
              "z": 0.949
            },
            "gtin": "4104420179721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ece",
            "leftCorner": {
              "x": -14.989,
              "y": -36.134,
              "z": 0.949
            },
            "rightCorner": {
              "x": -15.074,
              "y": -36.135,
              "z": 0.949
            },
            "gtin": "4104420258433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ecf",
            "leftCorner": {
              "x": -15.074,
              "y": -36.136,
              "z": 0.949
            },
            "rightCorner": {
              "x": -15.149,
              "y": -36.136,
              "z": 0.949
            },
            "gtin": "4104420021242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ed0",
            "leftCorner": {
              "x": -15.15,
              "y": -36.139,
              "z": 0.949
            },
            "rightCorner": {
              "x": -15.228,
              "y": -36.14,
              "z": 0.949
            },
            "gtin": "4104420258402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ed1",
            "leftCorner": {
              "x": -15.228,
              "y": -36.135,
              "z": 0.949
            },
            "rightCorner": {
              "x": -15.391,
              "y": -36.136,
              "z": 0.949
            },
            "gtin": "4250780307370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ec1",
            "leftCorner": {
              "x": -15.391,
              "y": -36.135,
              "z": 0.949
            },
            "rightCorner": {
              "x": -15.58,
              "y": -36.136,
              "z": 0.949
            },
            "gtin": "4006040007999",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d066",
        "height": 1.4114,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5eb6",
            "leftCorner": {
              "x": -14.369,
              "y": -36.112,
              "z": 1.155
            },
            "rightCorner": {
              "x": -14.499,
              "y": -36.112,
              "z": 1.155
            },
            "gtin": "4008314177759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eb7",
            "leftCorner": {
              "x": -14.498,
              "y": -36.118,
              "z": 1.155
            },
            "rightCorner": {
              "x": -14.651,
              "y": -36.119,
              "z": 1.155
            },
            "gtin": "4008314177766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eb8",
            "leftCorner": {
              "x": -14.651,
              "y": -36.118,
              "z": 1.155
            },
            "rightCorner": {
              "x": -14.81,
              "y": -36.118,
              "z": 1.155
            },
            "gtin": "4030387760606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eb9",
            "leftCorner": {
              "x": -14.81,
              "y": -36.116,
              "z": 1.155
            },
            "rightCorner": {
              "x": -15.126,
              "y": -36.119,
              "z": 1.155
            },
            "gtin": "4030387760590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5eba",
            "leftCorner": {
              "x": -15.126,
              "y": -36.126,
              "z": 1.155
            },
            "rightCorner": {
              "x": -15.266,
              "y": -36.127,
              "z": 1.155
            },
            "gtin": "5410126726947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ebb",
            "leftCorner": {
              "x": -15.266,
              "y": -36.129,
              "z": 1.155
            },
            "rightCorner": {
              "x": -15.411,
              "y": -36.13,
              "z": 1.155
            },
            "gtin": "5410126726954",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ea7",
            "leftCorner": {
              "x": -15.411,
              "y": -36.127,
              "z": 1.155
            },
            "rightCorner": {
              "x": -15.58,
              "y": -36.129,
              "z": 1.155
            },
            "gtin": "7612100909591",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "84b"
  },
  {
    "id": "84d",
    "name": "84d",
    "x": -12.431,
    "y": -40.137,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70987,
      "w": 0.70434
    },
    "layers": [],

    "rightNeighborShelfId": "84e"
  },
  {
    "id": "84e",
    "name": "84e",
    "x": -12.435,
    "y": -39.512,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70987,
      "w": 0.70434
    },
    "layers": [],
    "leftNeighborShelfId": "84d"
  },
  {
    "id": "84f",
    "name": "84f",
    "x": -16.226,
    "y": -38.952,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70871,
      "w": 0.7055
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 8,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d67f",
        "height": 1.3246,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8662",
            "leftCorner": {
              "x": -16.168,
              "y": -39.193,
              "z": 1.084
            },
            "rightCorner": {
              "x": -16.17,
              "y": -39.888,
              "z": 1.084
            },
            "gtin": "4000521041977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8663",
            "leftCorner": {
              "x": -16.175,
              "y": -39.888,
              "z": 1.084
            },
            "rightCorner": {
              "x": -16.176,
              "y": -40.092,
              "z": 1.084
            },
            "gtin": "4000521041977",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d680",
        "height": 1.6282,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8664",
            "leftCorner": {
              "x": -16.209,
              "y": -38.952,
              "z": 1.332
            },
            "rightCorner": {
              "x": -16.21,
              "y": -39.114,
              "z": 1.332
            },
            "gtin": "2000439121350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8669",
            "leftCorner": {
              "x": -16.171,
              "y": -39.115,
              "z": 1.332
            },
            "rightCorner": {
              "x": -16.173,
              "y": -39.668,
              "z": 1.332
            },
            "gtin": "4013752019103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8665",
            "leftCorner": {
              "x": -16.173,
              "y": -39.668,
              "z": 1.332
            },
            "rightCorner": {
              "x": -16.173,
              "y": -39.802,
              "z": 1.332
            },
            "gtin": "8445291494466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8666",
            "leftCorner": {
              "x": -16.173,
              "y": -39.802,
              "z": 1.332
            },
            "rightCorner": {
              "x": -16.173,
              "y": -39.935,
              "z": 1.332
            },
            "gtin": "8445291494466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8667",
            "leftCorner": {
              "x": -16.173,
              "y": -39.935,
              "z": 1.332
            },
            "rightCorner": {
              "x": -16.174,
              "y": -40.069,
              "z": 1.332
            },
            "gtin": "8445291494466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8668",
            "leftCorner": {
              "x": -16.174,
              "y": -40.069,
              "z": 1.332
            },
            "rightCorner": {
              "x": -16.175,
              "y": -40.203,
              "z": 1.332
            },
            "gtin": "8445291494466",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "850",
    "name": "850",
    "x": -14.297,
    "y": -38.961,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99996,
      "w": 0.0088836
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d687",
        "height": 0.17104,
        "facings": [
          {
            "id": "270fd06301958cb08b8b6fef",
            "leftCorner": {
              "x": -14.297,
              "y": -38.98,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.37,
              "y": -38.981,
              "z": 0.14
            },
            "gtin": "8445290464095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9915095fdc20f4a4dca307bb",
            "leftCorner": {
              "x": -14.37,
              "y": -38.981,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.554,
              "y": -38.985,
              "z": 0.14
            },
            "gtin": "4017100450518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "33ad03fc1ab9eb9786b79ce2",
            "leftCorner": {
              "x": -14.554,
              "y": -38.985,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.741,
              "y": -38.988,
              "z": 0.14
            },
            "gtin": "4000521042141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d172982085e24952e60f5972",
            "leftCorner": {
              "x": -14.741,
              "y": -38.988,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.931,
              "y": -38.991,
              "z": 0.14
            },
            "gtin": "4017100450013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f7180dd65b078ee0e0c2b93e",
            "leftCorner": {
              "x": -14.931,
              "y": -38.991,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.132,
              "y": -38.995,
              "z": 0.14
            },
            "gtin": "7622400004483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3eabea3f1624268c00d6872c",
            "leftCorner": {
              "x": -15.132,
              "y": -38.995,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.345,
              "y": -38.999,
              "z": 0.14
            },
            "gtin": "4017100450211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aca354ad55435710b3dd2709",
            "leftCorner": {
              "x": -15.345,
              "y": -38.999,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.546,
              "y": -39.002,
              "z": 0.14
            },
            "gtin": "7622400004483",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d682",
        "height": 0.45674,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f80",
            "leftCorner": {
              "x": -14.431,
              "y": -39.069,
              "z": 0.374
            },
            "rightCorner": {
              "x": -14.584,
              "y": -39.071,
              "z": 0.374
            },
            "gtin": "9002859033766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f81",
            "leftCorner": {
              "x": -14.584,
              "y": -39.072,
              "z": 0.374
            },
            "rightCorner": {
              "x": -14.871,
              "y": -39.078,
              "z": 0.374
            },
            "gtin": "4004363000338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f82",
            "leftCorner": {
              "x": -14.871,
              "y": -39.076,
              "z": 0.374
            },
            "rightCorner": {
              "x": -15.069,
              "y": -39.079,
              "z": 0.374
            },
            "gtin": "4017100450518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f83",
            "leftCorner": {
              "x": -15.069,
              "y": -39.08,
              "z": 0.374
            },
            "rightCorner": {
              "x": -15.273,
              "y": -39.084,
              "z": 0.374
            },
            "gtin": "4017100450211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f84",
            "leftCorner": {
              "x": -15.273,
              "y": -39.088,
              "z": 0.374
            },
            "rightCorner": {
              "x": -15.454,
              "y": -39.092,
              "z": 0.374
            },
            "gtin": "4017100450013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f7a",
            "leftCorner": {
              "x": -15.454,
              "y": -39.093,
              "z": 0.374
            },
            "rightCorner": {
              "x": -15.545,
              "y": -39.094,
              "z": 0.374
            },
            "gtin": "4000521042592",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d683",
        "height": 0.75551,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f8c",
            "leftCorner": {
              "x": -14.477,
              "y": -39.076,
              "z": 0.618
            },
            "rightCorner": {
              "x": -14.683,
              "y": -39.08,
              "z": 0.618
            },
            "gtin": "7622210396334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f8d",
            "leftCorner": {
              "x": -14.683,
              "y": -39.077,
              "z": 0.618
            },
            "rightCorner": {
              "x": -14.948,
              "y": -39.082,
              "z": 0.618
            },
            "gtin": "7622300784751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f8e",
            "leftCorner": {
              "x": -14.948,
              "y": -39.079,
              "z": 0.618
            },
            "rightCorner": {
              "x": -15.234,
              "y": -39.085,
              "z": 0.618
            },
            "gtin": "4000521042943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f8f",
            "leftCorner": {
              "x": -15.234,
              "y": -39.086,
              "z": 0.618
            },
            "rightCorner": {
              "x": -15.434,
              "y": -39.089,
              "z": 0.618
            },
            "gtin": "4000521042141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f86",
            "leftCorner": {
              "x": -15.434,
              "y": -39.087,
              "z": 0.618
            },
            "rightCorner": {
              "x": -15.545,
              "y": -39.089,
              "z": 0.618
            },
            "gtin": "4000521030292",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d684",
        "height": 1.0589,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f74",
            "leftCorner": {
              "x": -14.524,
              "y": -39.082,
              "z": 0.866
            },
            "rightCorner": {
              "x": -14.775,
              "y": -39.087,
              "z": 0.866
            },
            "gtin": "4000242046138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3bcdb9a464dfe0788553f628",
            "leftCorner": {
              "x": -14.295,
              "y": -39.03,
              "z": 0.866
            },
            "rightCorner": {
              "x": -14.506,
              "y": -39.034,
              "z": 0.866
            },
            "gtin": "4306188034735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f75",
            "leftCorner": {
              "x": -14.775,
              "y": -39.08,
              "z": 0.866
            },
            "rightCorner": {
              "x": -14.985,
              "y": -39.084,
              "z": 0.866
            },
            "gtin": "4306188034735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f76",
            "leftCorner": {
              "x": -14.985,
              "y": -39.083,
              "z": 0.866
            },
            "rightCorner": {
              "x": -15.211,
              "y": -39.087,
              "z": 0.866
            },
            "gtin": "7622201734428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f77",
            "leftCorner": {
              "x": -15.211,
              "y": -39.086,
              "z": 0.866
            },
            "rightCorner": {
              "x": -15.406,
              "y": -39.089,
              "z": 0.866
            },
            "gtin": "7622400004483",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f78",
            "leftCorner": {
              "x": -15.406,
              "y": -39.09,
              "z": 0.866
            },
            "rightCorner": {
              "x": -15.52,
              "y": -39.092,
              "z": 0.866
            },
            "gtin": "8445290464095",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d686",
        "height": 1.7313,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f6a",
            "leftCorner": {
              "x": -14.477,
              "y": -39.237,
              "z": 1.417
            },
            "rightCorner": {
              "x": -14.768,
              "y": -39.243,
              "z": 1.417
            },
            "gtin": "4009176483200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f6b",
            "leftCorner": {
              "x": -14.77,
              "y": -39.08,
              "z": 1.417
            },
            "rightCorner": {
              "x": -15.149,
              "y": -39.087,
              "z": 1.417
            },
            "gtin": "4009176483224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f6c",
            "leftCorner": {
              "x": -15.149,
              "y": -39.079,
              "z": 1.417
            },
            "rightCorner": {
              "x": -15.457,
              "y": -39.085,
              "z": 1.417
            },
            "gtin": "4058077785456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f66",
            "leftCorner": {
              "x": -15.457,
              "y": -39.086,
              "z": 1.417
            },
            "rightCorner": {
              "x": -15.545,
              "y": -39.087,
              "z": 1.417
            },
            "gtin": "4058077785470",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "857"
  },
  {
    "id": "853",
    "name": "853",
    "x": -13.654,
    "y": -40.175,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0057596,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 2,
      "shelfCategory": "EGGS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d089",
        "height": 0.16041,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5fa2",
            "leftCorner": {
              "x": -13.653,
              "y": -40.268,
              "z": 0.131
            },
            "rightCorner": {
              "x": -13.401,
              "y": -40.265,
              "z": 0.131
            },
            "gtin": "4018631105915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fa3",
            "leftCorner": {
              "x": -13.401,
              "y": -40.226,
              "z": 0.131
            },
            "rightCorner": {
              "x": -13.024,
              "y": -40.221,
              "z": 0.131
            },
            "gtin": "4018631105915",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "854"
  },
  {
    "id": "854",
    "name": "854",
    "x": -14.279,
    "y": -40.183,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0057596,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 5,
      "unknownStockCount": 1
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d088",
        "height": 1.1102,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f9c",
            "leftCorner": {
              "x": -13.907,
              "y": -40.202,
              "z": 0.908
            },
            "rightCorner": {
              "x": -13.649,
              "y": -40.199,
              "z": 0.908
            },
            "gtin": "4030156110038",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "fa2185fe8eda764d79a22c9a",
            "leftCorner": {
              "x": -14.278,
              "y": -40.246,
              "z": 0.908
            },
            "rightCorner": {
              "x": -14.025,
              "y": -40.243,
              "z": 0.908
            },
            "gtin": "4030156110038",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d087",
        "height": 1.4114,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f9e",
            "leftCorner": {
              "x": -14.055,
              "y": -40.209,
              "z": 1.155
            },
            "rightCorner": {
              "x": -13.732,
              "y": -40.205,
              "z": 1.155
            },
            "gtin": "4030156106024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f9d",
            "leftCorner": {
              "x": -13.732,
              "y": -40.204,
              "z": 1.155
            },
            "rightCorner": {
              "x": -13.649,
              "y": -40.203,
              "z": 1.155
            },
            "gtin": "4030156110021",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "b9818d18982695ec5f9cca26",
            "leftCorner": {
              "x": -14.278,
              "y": -40.252,
              "z": 1.155
            },
            "rightCorner": {
              "x": -14.192,
              "y": -40.251,
              "z": 1.155
            },
            "gtin": "4030156110021",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "b8bbf13a8963cb57458518a2",
            "leftCorner": {
              "x": -14.192,
              "y": -40.251,
              "z": 1.155
            },
            "rightCorner": {
              "x": -14.105,
              "y": -40.25,
              "z": 1.155
            },
            "gtin": "4030156110021",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "855",
    "rightNeighborShelfId": "853"
  },
  {
    "id": "855",
    "name": "855",
    "x": -14.904,
    "y": -40.19,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0057596,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 2,
      "shelfCategory": "EGGS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d086",
        "height": 0.81104,
        "facings": []
      },
      {
        "id": "68d8d3ff55f889d41539d084",
        "height": 1.1095,
        "facings": [
          {
            "id": "2a7b8b91e9c9dd71df2af6d2",
            "leftCorner": {
              "x": -14.903,
              "y": -40.247,
              "z": 0.908
            },
            "rightCorner": {
              "x": -14.376,
              "y": -40.241,
              "z": 0.908
            },
            "gtin": "4306188034797",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d085",
        "height": 1.4086,
        "facings": [
          {
            "id": "557d30ffa12ef5895a4d8be6",
            "leftCorner": {
              "x": -14.903,
              "y": -40.252,
              "z": 1.152
            },
            "rightCorner": {
              "x": -14.376,
              "y": -40.246,
              "z": 1.152
            },
            "gtin": "4306188034797",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "856",
    "rightNeighborShelfId": "854"
  },
  {
    "id": "856",
    "name": "856",
    "x": -15.529,
    "y": -40.197,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0057596,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 1,
      "shelfCategory": "EGGS"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d688",
        "height": 0.50381,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d866a",
            "leftCorner": {
              "x": -15.529,
              "y": -40.18,
              "z": 0.412
            },
            "rightCorner": {
              "x": -14.908,
              "y": -40.173,
              "z": 0.412
            },
            "gtin": "4306188034797",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "855"
  },
  {
    "id": "857",
    "name": "857",
    "x": -13.047,
    "y": -38.939,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99996,
      "w": 0.0088836
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 29
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d083",
        "height": 0.17081,
        "facings": [
          {
            "id": "d7bb7ec76fceb7fd8934ea66",
            "leftCorner": {
              "x": -13.049,
              "y": -38.848,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.153,
              "y": -38.85,
              "z": 0.14
            },
            "gtin": "7622210635396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "34fc017009f0c2a7e1ae86d3",
            "leftCorner": {
              "x": -13.153,
              "y": -38.85,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.265,
              "y": -38.852,
              "z": 0.14
            },
            "gtin": "7622201513764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8b6169fcc44e1119dfa6e97b",
            "leftCorner": {
              "x": -13.265,
              "y": -38.852,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.39,
              "y": -38.854,
              "z": 0.14
            },
            "gtin": "4018087002578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dc53337cb89b2126e6851364",
            "leftCorner": {
              "x": -13.39,
              "y": -38.854,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.518,
              "y": -38.856,
              "z": 0.14
            },
            "gtin": "4006952002204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "93d55fa900af4162a6d0c064",
            "leftCorner": {
              "x": -13.518,
              "y": -38.856,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.702,
              "y": -38.86,
              "z": 0.14
            },
            "gtin": "4004363410120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9138dc23d7f0874ac5ae2040",
            "leftCorner": {
              "x": -13.702,
              "y": -38.86,
              "z": 0.14
            },
            "rightCorner": {
              "x": -13.892,
              "y": -38.863,
              "z": 0.14
            },
            "gtin": "4000242041805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "722b27fa0ff91ec80330de69",
            "leftCorner": {
              "x": -13.892,
              "y": -38.863,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.098,
              "y": -38.867,
              "z": 0.14
            },
            "gtin": "4306188021995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d69bcddc8c03f3e5d5a8246f",
            "leftCorner": {
              "x": -14.098,
              "y": -38.867,
              "z": 0.14
            },
            "rightCorner": {
              "x": -14.289,
              "y": -38.87,
              "z": 0.14
            },
            "gtin": "4000242041805",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d081",
        "height": 0.45962,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f79",
            "leftCorner": {
              "x": -13.048,
              "y": -38.893,
              "z": 0.376
            },
            "rightCorner": {
              "x": -13.277,
              "y": -38.897,
              "z": 0.376
            },
            "gtin": "4018087002578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "82e2a208232e8b3d45a1aa3e",
            "leftCorner": {
              "x": -13.68,
              "y": -38.904,
              "z": 0.376
            },
            "rightCorner": {
              "x": -13.805,
              "y": -38.906,
              "z": 0.376
            },
            "gtin": "4018087002578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f7b",
            "leftCorner": {
              "x": -13.276,
              "y": -38.936,
              "z": 0.376
            },
            "rightCorner": {
              "x": -13.466,
              "y": -38.939,
              "z": 0.376
            },
            "gtin": "4004363410120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f7c",
            "leftCorner": {
              "x": -13.466,
              "y": -38.94,
              "z": 0.376
            },
            "rightCorner": {
              "x": -13.679,
              "y": -38.944,
              "z": 0.376
            },
            "gtin": "5709152018011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f7e",
            "leftCorner": {
              "x": -13.852,
              "y": -38.945,
              "z": 0.376
            },
            "rightCorner": {
              "x": -14.042,
              "y": -38.948,
              "z": 0.376
            },
            "gtin": "4000242041805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f7f",
            "leftCorner": {
              "x": -14.042,
              "y": -38.951,
              "z": 0.376
            },
            "rightCorner": {
              "x": -14.434,
              "y": -38.958,
              "z": 0.376
            },
            "gtin": "4000242041829",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d082",
        "height": 0.75734,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f85",
            "leftCorner": {
              "x": -13.048,
              "y": -38.893,
              "z": 0.62
            },
            "rightCorner": {
              "x": -13.279,
              "y": -38.897,
              "z": 0.62
            },
            "gtin": "8007380150402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f87",
            "leftCorner": {
              "x": -13.279,
              "y": -38.938,
              "z": 0.62
            },
            "rightCorner": {
              "x": -13.491,
              "y": -38.942,
              "z": 0.62
            },
            "gtin": "5709152014549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f88",
            "leftCorner": {
              "x": -13.491,
              "y": -38.941,
              "z": 0.62
            },
            "rightCorner": {
              "x": -13.783,
              "y": -38.946,
              "z": 0.62
            },
            "gtin": "4101540702013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f89",
            "leftCorner": {
              "x": -13.783,
              "y": -38.943,
              "z": 0.62
            },
            "rightCorner": {
              "x": -14.079,
              "y": -38.948,
              "z": 0.62
            },
            "gtin": "4101540702006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f8a",
            "leftCorner": {
              "x": -14.079,
              "y": -38.953,
              "z": 0.62
            },
            "rightCorner": {
              "x": -14.188,
              "y": -38.955,
              "z": 0.62
            },
            "gtin": "7622201513764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f8b",
            "leftCorner": {
              "x": -14.188,
              "y": -38.953,
              "z": 0.62
            },
            "rightCorner": {
              "x": -14.479,
              "y": -38.958,
              "z": 0.62
            },
            "gtin": "7622210635396",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d080",
        "height": 1.061,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f6d",
            "leftCorner": {
              "x": -13.048,
              "y": -38.895,
              "z": 0.868
            },
            "rightCorner": {
              "x": -13.285,
              "y": -38.899,
              "z": 0.868
            },
            "gtin": "4006952002204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "06251e6a7a9b80ee349b1ff2",
            "leftCorner": {
              "x": -14.006,
              "y": -38.912,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.134,
              "y": -38.914,
              "z": 0.868
            },
            "gtin": "4006952002204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f6e",
            "leftCorner": {
              "x": -13.285,
              "y": -38.939,
              "z": 0.868
            },
            "rightCorner": {
              "x": -13.519,
              "y": -38.944,
              "z": 0.868
            },
            "gtin": "4006894570700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f6f",
            "leftCorner": {
              "x": -13.519,
              "y": -38.942,
              "z": 0.868
            },
            "rightCorner": {
              "x": -13.769,
              "y": -38.946,
              "z": 0.868
            },
            "gtin": "4006894581607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f70",
            "leftCorner": {
              "x": -13.769,
              "y": -38.946,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.005,
              "y": -38.951,
              "z": 0.868
            },
            "gtin": "4006894585704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f72",
            "leftCorner": {
              "x": -14.18,
              "y": -38.957,
              "z": 0.868
            },
            "rightCorner": {
              "x": -14.297,
              "y": -38.959,
              "z": 0.868
            },
            "gtin": "4101540717567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f73",
            "leftCorner": {
              "x": -14.209,
              "y": -38.952,
              "z": 0.866
            },
            "rightCorner": {
              "x": -14.438,
              "y": -38.956,
              "z": 0.866
            },
            "gtin": "4101540717567",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d07f",
        "height": 1.7265,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5f65",
            "leftCorner": {
              "x": -13.047,
              "y": -38.979,
              "z": 1.413
            },
            "rightCorner": {
              "x": -13.502,
              "y": -38.988,
              "z": 1.413
            },
            "gtin": "4058077785449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f67",
            "leftCorner": {
              "x": -13.502,
              "y": -39.0,
              "z": 1.413
            },
            "rightCorner": {
              "x": -13.771,
              "y": -39.005,
              "z": 1.413
            },
            "gtin": "4017086123451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5f68",
            "leftCorner": {
              "x": -13.77,
              "y": -39.061,
              "z": 1.413
            },
            "rightCorner": {
              "x": -14.085,
              "y": -39.066,
              "z": 1.413
            },
            "gtin": "4306188021964",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d5f69",
            "leftCorner": {
              "x": -14.085,
              "y": -39.069,
              "z": 1.413
            },
            "rightCorner": {
              "x": -14.48,
              "y": -39.076,
              "z": 1.413
            },
            "gtin": "4306188021995",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "850"
  },
  {
    "id": "858",
    "name": "858",
    "x": -15.616,
    "y": -42.578,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.00514
    },
    "layers": [],

    "rightNeighborShelfId": "859"
  },
  {
    "id": "859",
    "name": "859",
    "x": -16.616,
    "y": -42.588,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99999,
      "w": 0.00514
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d68d",
        "height": 0.15343,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d867a",
            "leftCorner": {
              "x": -17.279,
              "y": -42.648,
              "z": 0.126
            },
            "rightCorner": {
              "x": -17.865,
              "y": -42.654,
              "z": 0.126
            },
            "gtin": "4009097021413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "456646298ad2bf5e3a910256",
            "leftCorner": {
              "x": -16.616,
              "y": -42.602,
              "z": 0.126
            },
            "rightCorner": {
              "x": -16.755,
              "y": -42.603,
              "z": 0.126
            },
            "gtin": "4071800058740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "695c819490142824e994503c",
            "leftCorner": {
              "x": -16.755,
              "y": -42.603,
              "z": 0.126
            },
            "rightCorner": {
              "x": -16.9,
              "y": -42.605,
              "z": 0.126
            },
            "gtin": "4071800034812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "56e9a4bb2484a415030a1275",
            "leftCorner": {
              "x": -16.9,
              "y": -42.605,
              "z": 0.126
            },
            "rightCorner": {
              "x": -17.077,
              "y": -42.607,
              "z": 0.126
            },
            "gtin": "4071800034805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "db8439ad9e0862d3a3d6a7af",
            "leftCorner": {
              "x": -17.077,
              "y": -42.607,
              "z": 0.126
            },
            "rightCorner": {
              "x": -17.278,
              "y": -42.609,
              "z": 0.126
            },
            "gtin": "4071800060637",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d68b",
        "height": 0.51523,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8675",
            "leftCorner": {
              "x": -16.615,
              "y": -42.646,
              "z": 0.422
            },
            "rightCorner": {
              "x": -16.944,
              "y": -42.649,
              "z": 0.422
            },
            "gtin": "4306188037361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8676",
            "leftCorner": {
              "x": -16.944,
              "y": -42.689,
              "z": 0.422
            },
            "rightCorner": {
              "x": -17.865,
              "y": -42.698,
              "z": 0.422
            },
            "gtin": "4306188037361",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d68c",
        "height": 0.84978,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8677",
            "leftCorner": {
              "x": -16.615,
              "y": -42.65,
              "z": 0.695
            },
            "rightCorner": {
              "x": -17.406,
              "y": -42.658,
              "z": 0.695
            },
            "gtin": "4306188043058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8678",
            "leftCorner": {
              "x": -17.406,
              "y": -42.691,
              "z": 0.695
            },
            "rightCorner": {
              "x": -17.865,
              "y": -42.696,
              "z": 0.695
            },
            "gtin": "4306188039211",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d68a",
        "height": 1.2034,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8671",
            "leftCorner": {
              "x": -16.615,
              "y": -42.638,
              "z": 0.985
            },
            "rightCorner": {
              "x": -16.884,
              "y": -42.641,
              "z": 0.985
            },
            "gtin": "4009097010301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8672",
            "leftCorner": {
              "x": -16.884,
              "y": -42.641,
              "z": 0.985
            },
            "rightCorner": {
              "x": -17.153,
              "y": -42.644,
              "z": 0.985
            },
            "gtin": "4009097010301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8674",
            "leftCorner": {
              "x": -17.153,
              "y": -42.683,
              "z": 0.985
            },
            "rightCorner": {
              "x": -17.491,
              "y": -42.686,
              "z": 0.985
            },
            "gtin": "4306188032793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8673",
            "leftCorner": {
              "x": -17.491,
              "y": -42.684,
              "z": 0.985
            },
            "rightCorner": {
              "x": -17.865,
              "y": -42.688,
              "z": 0.985
            },
            "gtin": "4306188032809",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d689",
        "height": 1.5549,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d866b",
            "leftCorner": {
              "x": -16.616,
              "y": -42.629,
              "z": 1.272
            },
            "rightCorner": {
              "x": -16.928,
              "y": -42.632,
              "z": 1.272
            },
            "gtin": "4071800057637",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d866d",
            "leftCorner": {
              "x": -16.927,
              "y": -42.68,
              "z": 1.272
            },
            "rightCorner": {
              "x": -17.062,
              "y": -42.682,
              "z": 1.272
            },
            "gtin": "4071800034812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d866e",
            "leftCorner": {
              "x": -17.062,
              "y": -42.682,
              "z": 1.272
            },
            "rightCorner": {
              "x": -17.227,
              "y": -42.683,
              "z": 1.272
            },
            "gtin": "4071800034805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d866f",
            "leftCorner": {
              "x": -17.227,
              "y": -42.671,
              "z": 1.272
            },
            "rightCorner": {
              "x": -17.373,
              "y": -42.672,
              "z": 1.272
            },
            "gtin": "4071800058740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8670",
            "leftCorner": {
              "x": -17.373,
              "y": -42.671,
              "z": 1.272
            },
            "rightCorner": {
              "x": -17.661,
              "y": -42.674,
              "z": 1.272
            },
            "gtin": "4071800061115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d866c",
            "leftCorner": {
              "x": -17.661,
              "y": -42.666,
              "z": 1.272
            },
            "rightCorner": {
              "x": -17.865,
              "y": -42.668,
              "z": 1.272
            },
            "gtin": "4071800060637",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "858"
  },
  {
    "id": "85a",
    "name": "85a",
    "x": -17.904,
    "y": -42.585,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70723,
      "w": 0.70698
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 13
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d68f",
        "height": 0.15006,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d867b",
            "leftCorner": {
              "x": -17.808,
              "y": -42.585,
              "z": 0.123
            },
            "rightCorner": {
              "x": -17.809,
              "y": -42.193,
              "z": 0.123
            },
            "gtin": "4306188428169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d867c",
            "leftCorner": {
              "x": -17.809,
              "y": -42.193,
              "z": 0.123
            },
            "rightCorner": {
              "x": -17.808,
              "y": -41.802,
              "z": 0.123
            },
            "gtin": "4306188428169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d867d",
            "leftCorner": {
              "x": -17.844,
              "y": -41.802,
              "z": 0.123
            },
            "rightCorner": {
              "x": -17.844,
              "y": -41.585,
              "z": 0.123
            },
            "gtin": "4306188382355",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d692",
        "height": 0.51665,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8680",
            "leftCorner": {
              "x": -17.856,
              "y": -42.585,
              "z": 0.423
            },
            "rightCorner": {
              "x": -17.856,
              "y": -41.869,
              "z": 0.423
            },
            "gtin": "4012263001409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8681",
            "leftCorner": {
              "x": -17.897,
              "y": -41.869,
              "z": 0.423
            },
            "rightCorner": {
              "x": -17.897,
              "y": -41.585,
              "z": 0.423
            },
            "gtin": "4044808791070",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d691",
        "height": 0.86653,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d867e",
            "leftCorner": {
              "x": -17.859,
              "y": -42.585,
              "z": 0.709
            },
            "rightCorner": {
              "x": -17.86,
              "y": -41.981,
              "z": 0.709
            },
            "gtin": "4012263025566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d867f",
            "leftCorner": {
              "x": -17.899,
              "y": -41.981,
              "z": 0.709
            },
            "rightCorner": {
              "x": -17.899,
              "y": -41.585,
              "z": 0.709
            },
            "gtin": "4000242094047",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d690",
        "height": 1.2076,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6172",
            "leftCorner": {
              "x": -17.87,
              "y": -42.585,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.87,
              "y": -41.957,
              "z": 0.988
            },
            "gtin": "4009249040071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6174",
            "leftCorner": {
              "x": -17.91,
              "y": -41.957,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.91,
              "y": -41.659,
              "z": 0.988
            },
            "gtin": "4044808108007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6175",
            "leftCorner": {
              "x": -17.903,
              "y": -41.659,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.903,
              "y": -41.391,
              "z": 0.988
            },
            "gtin": "4000446016807",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d68e",
        "height": 1.5084,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6166",
            "leftCorner": {
              "x": -17.862,
              "y": -42.585,
              "z": 1.234
            },
            "rightCorner": {
              "x": -17.862,
              "y": -42.119,
              "z": 1.234
            },
            "gtin": "4009249040033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6168",
            "leftCorner": {
              "x": -17.908,
              "y": -42.119,
              "z": 1.234
            },
            "rightCorner": {
              "x": -17.908,
              "y": -41.84,
              "z": 1.234
            },
            "gtin": "4009097010615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6169",
            "leftCorner": {
              "x": -17.896,
              "y": -41.84,
              "z": 1.234
            },
            "rightCorner": {
              "x": -17.896,
              "y": -41.32,
              "z": 1.234
            },
            "gtin": "4009097010349",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "85b"
  },
  {
    "id": "85b",
    "name": "85b",
    "x": -17.904,
    "y": -41.585,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70723,
      "w": 0.70698
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d696",
        "height": 0.16159,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d617c",
            "leftCorner": {
              "x": -17.799,
              "y": -41.585,
              "z": 0.132
            },
            "rightCorner": {
              "x": -17.799,
              "y": -41.145,
              "z": 0.132
            },
            "gtin": "4012263016809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d617d",
            "leftCorner": {
              "x": -17.799,
              "y": -41.145,
              "z": 0.132
            },
            "rightCorner": {
              "x": -17.8,
              "y": -40.705,
              "z": 0.132
            },
            "gtin": "4012263016809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d617f",
            "leftCorner": {
              "x": -17.841,
              "y": -40.704,
              "z": 0.132
            },
            "rightCorner": {
              "x": -17.84,
              "y": -40.149,
              "z": 0.132
            },
            "gtin": "4012263021261",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d697",
        "height": 0.5035,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6189",
            "leftCorner": {
              "x": -17.858,
              "y": -41.585,
              "z": 0.412
            },
            "rightCorner": {
              "x": -17.859,
              "y": -40.866,
              "z": 0.412
            },
            "gtin": "4012263013907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d618c",
            "leftCorner": {
              "x": -17.899,
              "y": -40.866,
              "z": 0.412
            },
            "rightCorner": {
              "x": -17.899,
              "y": -40.57,
              "z": 0.412
            },
            "gtin": "4012263019428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d618d",
            "leftCorner": {
              "x": -17.899,
              "y": -40.57,
              "z": 0.412
            },
            "rightCorner": {
              "x": -17.899,
              "y": -40.275,
              "z": 0.412
            },
            "gtin": "4012263019428",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d695",
        "height": 0.85366,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6182",
            "leftCorner": {
              "x": -17.861,
              "y": -41.585,
              "z": 0.698
            },
            "rightCorner": {
              "x": -17.86,
              "y": -41.239,
              "z": 0.698
            },
            "gtin": "4000242094108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6184",
            "leftCorner": {
              "x": -17.9,
              "y": -41.239,
              "z": 0.698
            },
            "rightCorner": {
              "x": -17.901,
              "y": -40.905,
              "z": 0.698
            },
            "gtin": "4058077763157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6185",
            "leftCorner": {
              "x": -17.901,
              "y": -40.905,
              "z": 0.698
            },
            "rightCorner": {
              "x": -17.9,
              "y": -40.571,
              "z": 0.698
            },
            "gtin": "4058077763157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6186",
            "leftCorner": {
              "x": -17.902,
              "y": -40.571,
              "z": 0.698
            },
            "rightCorner": {
              "x": -17.901,
              "y": -40.335,
              "z": 0.698
            },
            "gtin": "4058077763164",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d693",
        "height": 1.2079,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6176",
            "leftCorner": {
              "x": -17.898,
              "y": -41.391,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.898,
              "y": -41.097,
              "z": 0.988
            },
            "gtin": "4260152941439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6177",
            "leftCorner": {
              "x": -17.905,
              "y": -41.097,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.905,
              "y": -40.634,
              "z": 0.988
            },
            "gtin": "4020982008401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6178",
            "leftCorner": {
              "x": -17.905,
              "y": -40.634,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.905,
              "y": -40.335,
              "z": 0.988
            },
            "gtin": "5900864781181",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d694",
        "height": 1.5097,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d616a",
            "leftCorner": {
              "x": -17.892,
              "y": -41.321,
              "z": 1.235
            },
            "rightCorner": {
              "x": -17.892,
              "y": -41.07,
              "z": 1.235
            },
            "gtin": "8437011503077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e5db322ca9c107f6ea7eefba",
            "leftCorner": {
              "x": -17.856,
              "y": -41.585,
              "z": 1.235
            },
            "rightCorner": {
              "x": -17.856,
              "y": -41.33,
              "z": 1.235
            },
            "gtin": "5708209002515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d616b",
            "leftCorner": {
              "x": -17.896,
              "y": -41.07,
              "z": 1.235
            },
            "rightCorner": {
              "x": -17.896,
              "y": -40.815,
              "z": 1.235
            },
            "gtin": "5708209002515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d616c",
            "leftCorner": {
              "x": -17.897,
              "y": -40.815,
              "z": 1.235
            },
            "rightCorner": {
              "x": -17.897,
              "y": -40.527,
              "z": 1.235
            },
            "gtin": "8717853273537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d616d",
            "leftCorner": {
              "x": -17.901,
              "y": -40.527,
              "z": 1.235
            },
            "rightCorner": {
              "x": -17.901,
              "y": -40.335,
              "z": 1.235
            },
            "gtin": "4058077713817",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "85a",
    "rightNeighborShelfId": "85c"
  },
  {
    "id": "85c",
    "name": "85c",
    "x": -17.905,
    "y": -40.335,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70723,
      "w": 0.70698
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0cc",
        "height": 0.15808,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6180",
            "leftCorner": {
              "x": -17.84,
              "y": -40.151,
              "z": 0.129
            },
            "rightCorner": {
              "x": -17.84,
              "y": -39.785,
              "z": 0.129
            },
            "gtin": "4012263014041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6181",
            "leftCorner": {
              "x": -17.836,
              "y": -39.785,
              "z": 0.129
            },
            "rightCorner": {
              "x": -17.835,
              "y": -39.466,
              "z": 0.129
            },
            "gtin": "7622202009808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d617e",
            "leftCorner": {
              "x": -17.837,
              "y": -39.466,
              "z": 0.129
            },
            "rightCorner": {
              "x": -17.837,
              "y": -39.086,
              "z": 0.129
            },
            "gtin": "7622202010231",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ce",
        "height": 0.50492,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d618e",
            "leftCorner": {
              "x": -17.899,
              "y": -40.275,
              "z": 0.413
            },
            "rightCorner": {
              "x": -17.901,
              "y": -39.82,
              "z": 0.413
            },
            "gtin": "4012263013617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d618f",
            "leftCorner": {
              "x": -17.901,
              "y": -39.82,
              "z": 0.413
            },
            "rightCorner": {
              "x": -17.901,
              "y": -39.364,
              "z": 0.413
            },
            "gtin": "4012263013617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d618a",
            "leftCorner": {
              "x": -17.902,
              "y": -39.364,
              "z": 0.413
            },
            "rightCorner": {
              "x": -17.901,
              "y": -39.225,
              "z": 0.413
            },
            "gtin": "4012263015406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d618b",
            "leftCorner": {
              "x": -17.901,
              "y": -39.225,
              "z": 0.413
            },
            "rightCorner": {
              "x": -17.901,
              "y": -39.085,
              "z": 0.413
            },
            "gtin": "4012263015406",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0cd",
        "height": 0.8567,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6187",
            "leftCorner": {
              "x": -17.901,
              "y": -40.335,
              "z": 0.701
            },
            "rightCorner": {
              "x": -17.893,
              "y": -39.913,
              "z": 0.701
            },
            "gtin": "4058077763133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6188",
            "leftCorner": {
              "x": -17.899,
              "y": -39.913,
              "z": 0.701
            },
            "rightCorner": {
              "x": -17.9,
              "y": -39.369,
              "z": 0.701
            },
            "gtin": "4058077763133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6183",
            "leftCorner": {
              "x": -17.903,
              "y": -39.37,
              "z": 0.701
            },
            "rightCorner": {
              "x": -17.903,
              "y": -39.085,
              "z": 0.701
            },
            "gtin": "4058077763140",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0cb",
        "height": 1.2089,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6179",
            "leftCorner": {
              "x": -17.904,
              "y": -40.335,
              "z": 0.989
            },
            "rightCorner": {
              "x": -17.901,
              "y": -40.179,
              "z": 0.989
            },
            "gtin": "5900864771366",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d617a",
            "leftCorner": {
              "x": -17.903,
              "y": -40.179,
              "z": 0.989
            },
            "rightCorner": {
              "x": -17.903,
              "y": -39.802,
              "z": 0.989
            },
            "gtin": "5900864771366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d617b",
            "leftCorner": {
              "x": -17.901,
              "y": -39.802,
              "z": 0.989
            },
            "rightCorner": {
              "x": -17.901,
              "y": -39.329,
              "z": 0.989
            },
            "gtin": "4058077771671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6173",
            "leftCorner": {
              "x": -17.906,
              "y": -39.329,
              "z": 0.989
            },
            "rightCorner": {
              "x": -17.906,
              "y": -39.085,
              "z": 0.989
            },
            "gtin": "4071800058764",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ca",
        "height": 1.5111,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d616e",
            "leftCorner": {
              "x": -17.904,
              "y": -40.335,
              "z": 1.236
            },
            "rightCorner": {
              "x": -17.902,
              "y": -40.208,
              "z": 1.236
            },
            "gtin": "4071800058900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d616f",
            "leftCorner": {
              "x": -17.899,
              "y": -40.208,
              "z": 1.236
            },
            "rightCorner": {
              "x": -17.899,
              "y": -39.701,
              "z": 1.236
            },
            "gtin": "4071800058900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6170",
            "leftCorner": {
              "x": -17.897,
              "y": -39.701,
              "z": 1.236
            },
            "rightCorner": {
              "x": -17.897,
              "y": -39.475,
              "z": 1.236
            },
            "gtin": "4071800038612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6171",
            "leftCorner": {
              "x": -17.901,
              "y": -39.475,
              "z": 1.236
            },
            "rightCorner": {
              "x": -17.9,
              "y": -39.29,
              "z": 1.236
            },
            "gtin": "4071800038605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6167",
            "leftCorner": {
              "x": -17.904,
              "y": -39.29,
              "z": 1.236
            },
            "rightCorner": {
              "x": -17.904,
              "y": -39.085,
              "z": 1.236
            },
            "gtin": "4071800038599",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "85b",
    "rightNeighborShelfId": "85d"
  },
  {
    "id": "85d",
    "name": "85d",
    "x": -17.905,
    "y": -39.085,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70723,
      "w": 0.70698
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 34
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0d4",
        "height": 0.17454,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61c9",
            "leftCorner": {
              "x": -17.835,
              "y": -38.176,
              "z": 0.143
            },
            "rightCorner": {
              "x": -17.836,
              "y": -37.747,
              "z": 0.143
            },
            "gtin": "7300400129640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7bed0c58a79afdd10300573b",
            "leftCorner": {
              "x": -17.804,
              "y": -39.085,
              "z": 0.143
            },
            "rightCorner": {
              "x": -17.804,
              "y": -38.985,
              "z": 0.143
            },
            "gtin": "7300400129640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d6a0617eddf659c6dae859b9",
            "leftCorner": {
              "x": -17.804,
              "y": -38.985,
              "z": 0.143
            },
            "rightCorner": {
              "x": -17.804,
              "y": -38.885,
              "z": 0.143
            },
            "gtin": "7300400129640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b57553f6c1de1f7c10b8f18d",
            "leftCorner": {
              "x": -17.804,
              "y": -38.885,
              "z": 0.143
            },
            "rightCorner": {
              "x": -17.804,
              "y": -38.785,
              "z": 0.143
            },
            "gtin": "7300400129640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "44f7c6c656ccb2b62c5dbcfb",
            "leftCorner": {
              "x": -17.804,
              "y": -38.785,
              "z": 0.143
            },
            "rightCorner": {
              "x": -17.804,
              "y": -38.685,
              "z": 0.143
            },
            "gtin": "7300400129640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a9d137a3383312a925854242",
            "leftCorner": {
              "x": -17.804,
              "y": -38.685,
              "z": 0.143
            },
            "rightCorner": {
              "x": -17.804,
              "y": -38.584,
              "z": 0.143
            },
            "gtin": "7300400129640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f0b6818a52d3ef20fa3988fb",
            "leftCorner": {
              "x": -17.804,
              "y": -38.584,
              "z": 0.143
            },
            "rightCorner": {
              "x": -17.804,
              "y": -38.484,
              "z": 0.143
            },
            "gtin": "7300400129640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9371855f30b501b64a0025ca",
            "leftCorner": {
              "x": -17.804,
              "y": -38.484,
              "z": 0.143
            },
            "rightCorner": {
              "x": -17.804,
              "y": -38.384,
              "z": 0.143
            },
            "gtin": "7300400129640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "053bd080ce61aada203f6657",
            "leftCorner": {
              "x": -17.804,
              "y": -38.384,
              "z": 0.143
            },
            "rightCorner": {
              "x": -17.804,
              "y": -38.284,
              "z": 0.143
            },
            "gtin": "7300400129640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "63be0c81dfebba1c9b7ac441",
            "leftCorner": {
              "x": -17.804,
              "y": -38.284,
              "z": 0.143
            },
            "rightCorner": {
              "x": -17.804,
              "y": -38.184,
              "z": 0.143
            },
            "gtin": "7300400129640",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0cf",
        "height": 0.41318,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6190",
            "leftCorner": {
              "x": -17.858,
              "y": -39.085,
              "z": 0.338
            },
            "rightCorner": {
              "x": -17.859,
              "y": -38.777,
              "z": 0.338
            },
            "gtin": "7300400129169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6192",
            "leftCorner": {
              "x": -17.896,
              "y": -38.777,
              "z": 0.338
            },
            "rightCorner": {
              "x": -17.896,
              "y": -38.696,
              "z": 0.338
            },
            "gtin": "7300400482172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6193",
            "leftCorner": {
              "x": -17.896,
              "y": -38.696,
              "z": 0.338
            },
            "rightCorner": {
              "x": -17.895,
              "y": -38.614,
              "z": 0.338
            },
            "gtin": "7300400482172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6194",
            "leftCorner": {
              "x": -17.895,
              "y": -38.614,
              "z": 0.338
            },
            "rightCorner": {
              "x": -17.896,
              "y": -38.532,
              "z": 0.338
            },
            "gtin": "7300400482172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6195",
            "leftCorner": {
              "x": -17.896,
              "y": -38.532,
              "z": 0.338
            },
            "rightCorner": {
              "x": -17.895,
              "y": -38.45,
              "z": 0.338
            },
            "gtin": "7300400482172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6191",
            "leftCorner": {
              "x": -17.9,
              "y": -38.45,
              "z": 0.338
            },
            "rightCorner": {
              "x": -17.901,
              "y": -38.086,
              "z": 0.338
            },
            "gtin": "7300400482905",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0d3",
        "height": 0.72422,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61be",
            "leftCorner": {
              "x": -17.844,
              "y": -39.085,
              "z": 0.593
            },
            "rightCorner": {
              "x": -17.844,
              "y": -38.669,
              "z": 0.593
            },
            "gtin": "4104420056244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61c0",
            "leftCorner": {
              "x": -17.879,
              "y": -38.669,
              "z": 0.593
            },
            "rightCorner": {
              "x": -17.88,
              "y": -38.532,
              "z": 0.593
            },
            "gtin": "4012970013863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61c1",
            "leftCorner": {
              "x": -17.884,
              "y": -38.533,
              "z": 0.593
            },
            "rightCorner": {
              "x": -17.884,
              "y": -38.347,
              "z": 0.593
            },
            "gtin": "4012970011173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61c2",
            "leftCorner": {
              "x": -17.884,
              "y": -38.347,
              "z": 0.593
            },
            "rightCorner": {
              "x": -17.885,
              "y": -38.085,
              "z": 0.593
            },
            "gtin": "4044808610173",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0d1",
        "height": 1.0155,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61a6",
            "leftCorner": {
              "x": -17.852,
              "y": -39.085,
              "z": 0.831
            },
            "rightCorner": {
              "x": -17.853,
              "y": -38.764,
              "z": 0.831
            },
            "gtin": "7300400481830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61a8",
            "leftCorner": {
              "x": -17.891,
              "y": -38.764,
              "z": 0.831
            },
            "rightCorner": {
              "x": -17.891,
              "y": -38.384,
              "z": 0.831
            },
            "gtin": "7300400481823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61a9",
            "leftCorner": {
              "x": -17.895,
              "y": -38.384,
              "z": 0.831
            },
            "rightCorner": {
              "x": -17.894,
              "y": -38.168,
              "z": 0.831
            },
            "gtin": "7300400317801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61aa",
            "leftCorner": {
              "x": -17.891,
              "y": -38.169,
              "z": 0.831
            },
            "rightCorner": {
              "x": -17.892,
              "y": -37.989,
              "z": 0.831
            },
            "gtin": "4008404001001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61ab",
            "leftCorner": {
              "x": -17.892,
              "y": -37.989,
              "z": 0.831
            },
            "rightCorner": {
              "x": -17.892,
              "y": -37.809,
              "z": 0.831
            },
            "gtin": "4008404001001",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0d0",
        "height": 1.3161,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6196",
            "leftCorner": {
              "x": -17.852,
              "y": -39.085,
              "z": 1.077
            },
            "rightCorner": {
              "x": -17.852,
              "y": -38.775,
              "z": 1.077
            },
            "gtin": "6410500090014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6198",
            "leftCorner": {
              "x": -17.862,
              "y": -38.775,
              "z": 1.077
            },
            "rightCorner": {
              "x": -17.861,
              "y": -38.641,
              "z": 1.077
            },
            "gtin": "6437005078866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6199",
            "leftCorner": {
              "x": -17.892,
              "y": -38.642,
              "z": 1.077
            },
            "rightCorner": {
              "x": -17.892,
              "y": -38.331,
              "z": 1.077
            },
            "gtin": "7300400126205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d619a",
            "leftCorner": {
              "x": -17.9,
              "y": -38.331,
              "z": 1.077
            },
            "rightCorner": {
              "x": -17.899,
              "y": -38.086,
              "z": 1.077
            },
            "gtin": "7300400482851",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0d2",
        "height": 1.57,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61b4",
            "leftCorner": {
              "x": -17.851,
              "y": -39.085,
              "z": 1.285
            },
            "rightCorner": {
              "x": -17.851,
              "y": -38.744,
              "z": 1.285
            },
            "gtin": "7300400482561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61b6",
            "leftCorner": {
              "x": -17.891,
              "y": -38.744,
              "z": 1.285
            },
            "rightCorner": {
              "x": -17.89,
              "y": -38.562,
              "z": 1.285
            },
            "gtin": "7300400129206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61b7",
            "leftCorner": {
              "x": -17.891,
              "y": -38.562,
              "z": 1.285
            },
            "rightCorner": {
              "x": -17.891,
              "y": -38.359,
              "z": 1.285
            },
            "gtin": "7300400482202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61b8",
            "leftCorner": {
              "x": -17.893,
              "y": -38.359,
              "z": 1.285
            },
            "rightCorner": {
              "x": -17.894,
              "y": -38.15,
              "z": 1.285
            },
            "gtin": "7300400482219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61b9",
            "leftCorner": {
              "x": -17.889,
              "y": -38.15,
              "z": 1.285
            },
            "rightCorner": {
              "x": -17.89,
              "y": -37.828,
              "z": 1.285
            },
            "gtin": "4104420217973",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "85c",
    "rightNeighborShelfId": "85e"
  },
  {
    "id": "85e",
    "name": "85e",
    "x": -17.906,
    "y": -38.085,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70723,
      "w": 0.70698
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0da",
        "height": 0.17846,
        "facings": [
          {
            "id": "8fdc32ae3b0060eb713400fe",
            "leftCorner": {
              "x": -17.812,
              "y": -38.085,
              "z": 0.146
            },
            "rightCorner": {
              "x": -17.812,
              "y": -38.032,
              "z": 0.146
            },
            "gtin": "7300400127448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "53728a4dcf7c9660dba2f628",
            "leftCorner": {
              "x": -17.812,
              "y": -38.032,
              "z": 0.146
            },
            "rightCorner": {
              "x": -17.812,
              "y": -37.946,
              "z": 0.146
            },
            "gtin": "4104420145962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fbb3bd51c911fadf90455159",
            "leftCorner": {
              "x": -17.812,
              "y": -37.946,
              "z": 0.146
            },
            "rightCorner": {
              "x": -17.812,
              "y": -37.818,
              "z": 0.146
            },
            "gtin": "7300400122702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f49d2f33f5fcb32a440f9b8a",
            "leftCorner": {
              "x": -17.812,
              "y": -37.818,
              "z": 0.146
            },
            "rightCorner": {
              "x": -17.812,
              "y": -37.662,
              "z": 0.146
            },
            "gtin": "7300400127387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d95e4c89562dd0259102aee5",
            "leftCorner": {
              "x": -17.812,
              "y": -37.662,
              "z": 0.146
            },
            "rightCorner": {
              "x": -17.812,
              "y": -37.501,
              "z": 0.146
            },
            "gtin": "7300400483155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ebc2dfcfd628a20217857463",
            "leftCorner": {
              "x": -17.812,
              "y": -37.501,
              "z": 0.146
            },
            "rightCorner": {
              "x": -17.812,
              "y": -37.287,
              "z": 0.146
            },
            "gtin": "4008404001018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "41cc85874a046fa4f38b13a6",
            "leftCorner": {
              "x": -17.812,
              "y": -37.287,
              "z": 0.146
            },
            "rightCorner": {
              "x": -17.812,
              "y": -37.117,
              "z": 0.146
            },
            "gtin": "7300400126229",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0d9",
        "height": 0.42402,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61cd",
            "leftCorner": {
              "x": -17.85,
              "y": -38.085,
              "z": 0.347
            },
            "rightCorner": {
              "x": -17.851,
              "y": -37.431,
              "z": 0.347
            },
            "gtin": "7300400114714",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d61ce",
            "leftCorner": {
              "x": -17.891,
              "y": -37.431,
              "z": 0.347
            },
            "rightCorner": {
              "x": -17.891,
              "y": -37.085,
              "z": 0.347
            },
            "gtin": "7300400114745",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0d8",
        "height": 0.72444,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61c3",
            "leftCorner": {
              "x": -17.886,
              "y": -38.085,
              "z": 0.593
            },
            "rightCorner": {
              "x": -17.884,
              "y": -38.04,
              "z": 0.593
            },
            "gtin": "3226980052502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61c4",
            "leftCorner": {
              "x": -17.883,
              "y": -38.04,
              "z": 0.593
            },
            "rightCorner": {
              "x": -17.883,
              "y": -37.703,
              "z": 0.593
            },
            "gtin": "3226980052502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61c5",
            "leftCorner": {
              "x": -17.884,
              "y": -37.703,
              "z": 0.593
            },
            "rightCorner": {
              "x": -17.884,
              "y": -37.347,
              "z": 0.593
            },
            "gtin": "4001518006450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61bf",
            "leftCorner": {
              "x": -17.887,
              "y": -37.347,
              "z": 0.593
            },
            "rightCorner": {
              "x": -17.887,
              "y": -37.085,
              "z": 0.593
            },
            "gtin": "4001518104064",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0d7",
        "height": 1.0156,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61ac",
            "leftCorner": {
              "x": -17.894,
              "y": -37.808,
              "z": 0.831
            },
            "rightCorner": {
              "x": -17.895,
              "y": -37.377,
              "z": 0.831
            },
            "gtin": "4008404001018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ff1518acff2557211cfd15ed",
            "leftCorner": {
              "x": -17.858,
              "y": -38.085,
              "z": 0.831
            },
            "rightCorner": {
              "x": -17.858,
              "y": -37.988,
              "z": 0.831
            },
            "gtin": "4104420145986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e6bd848dfa710e30afca89c2",
            "leftCorner": {
              "x": -17.858,
              "y": -37.988,
              "z": 0.831
            },
            "rightCorner": {
              "x": -17.858,
              "y": -37.875,
              "z": 0.831
            },
            "gtin": "4104420254893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61ad",
            "leftCorner": {
              "x": -17.9,
              "y": -37.377,
              "z": 0.831
            },
            "rightCorner": {
              "x": -17.9,
              "y": -37.293,
              "z": 0.831
            },
            "gtin": "4104420145962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61ae",
            "leftCorner": {
              "x": -17.897,
              "y": -37.293,
              "z": 0.831
            },
            "rightCorner": {
              "x": -17.897,
              "y": -37.199,
              "z": 0.831
            },
            "gtin": "4104420145986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61af",
            "leftCorner": {
              "x": -17.898,
              "y": -37.199,
              "z": 0.831
            },
            "rightCorner": {
              "x": -17.898,
              "y": -37.047,
              "z": 0.831
            },
            "gtin": "4104420254893",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0d5",
        "height": 1.3191,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d619b",
            "leftCorner": {
              "x": -17.906,
              "y": -38.085,
              "z": 1.079
            },
            "rightCorner": {
              "x": -17.902,
              "y": -37.974,
              "z": 1.079
            },
            "gtin": "7300400126229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d619c",
            "leftCorner": {
              "x": -17.897,
              "y": -37.974,
              "z": 1.079
            },
            "rightCorner": {
              "x": -17.897,
              "y": -37.734,
              "z": 1.079
            },
            "gtin": "7300400126229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d619d",
            "leftCorner": {
              "x": -17.894,
              "y": -37.734,
              "z": 1.079
            },
            "rightCorner": {
              "x": -17.895,
              "y": -37.42,
              "z": 1.079
            },
            "gtin": "7300400483155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d619e",
            "leftCorner": {
              "x": -17.9,
              "y": -37.421,
              "z": 1.079
            },
            "rightCorner": {
              "x": -17.9,
              "y": -37.266,
              "z": 1.079
            },
            "gtin": "7300400127387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d619f",
            "leftCorner": {
              "x": -17.902,
              "y": -37.266,
              "z": 1.079
            },
            "rightCorner": {
              "x": -17.902,
              "y": -37.14,
              "z": 1.079
            },
            "gtin": "7300400122702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61a0",
            "leftCorner": {
              "x": -17.901,
              "y": -37.14,
              "z": 1.079
            },
            "rightCorner": {
              "x": -17.901,
              "y": -37.033,
              "z": 1.079
            },
            "gtin": "7300400127448",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0d6",
        "height": 1.5702,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61ba",
            "leftCorner": {
              "x": -17.888,
              "y": -37.828,
              "z": 1.285
            },
            "rightCorner": {
              "x": -17.888,
              "y": -37.598,
              "z": 1.285
            },
            "gtin": "4104420248120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "21e7df571bbec491b4288d47",
            "leftCorner": {
              "x": -17.851,
              "y": -38.085,
              "z": 1.285
            },
            "rightCorner": {
              "x": -17.851,
              "y": -37.85,
              "z": 1.285
            },
            "gtin": "4104420231658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61bb",
            "leftCorner": {
              "x": -17.891,
              "y": -37.598,
              "z": 1.285
            },
            "rightCorner": {
              "x": -17.891,
              "y": -37.322,
              "z": 1.285
            },
            "gtin": "4104420217997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61bc",
            "leftCorner": {
              "x": -17.894,
              "y": -37.323,
              "z": 1.285
            },
            "rightCorner": {
              "x": -17.894,
              "y": -37.054,
              "z": 1.285
            },
            "gtin": "4104420231658",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "85d",
    "rightNeighborShelfId": "85f"
  },
  {
    "id": "85f",
    "name": "85f",
    "x": -17.906,
    "y": -37.085,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70723,
      "w": 0.70698
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0df",
        "height": 0.17622,
        "facings": [
          {
            "id": "94f3eceb160d940f3e0e2915",
            "leftCorner": {
              "x": -17.816,
              "y": -37.084,
              "z": 0.144
            },
            "rightCorner": {
              "x": -17.816,
              "y": -36.919,
              "z": 0.144
            },
            "gtin": "4104420053069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e1c886598e0b3b93e1593ca3",
            "leftCorner": {
              "x": -17.816,
              "y": -36.919,
              "z": 0.144
            },
            "rightCorner": {
              "x": -17.816,
              "y": -36.747,
              "z": 0.144
            },
            "gtin": "4013752040541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e6d6a7143f55948ace74d1cf",
            "leftCorner": {
              "x": -17.816,
              "y": -36.747,
              "z": 0.144
            },
            "rightCorner": {
              "x": -17.816,
              "y": -36.573,
              "z": 0.144
            },
            "gtin": "4013752078742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0c67ebb73836b8752c3e2162",
            "leftCorner": {
              "x": -17.816,
              "y": -36.573,
              "z": 0.144
            },
            "rightCorner": {
              "x": -17.816,
              "y": -36.39,
              "z": 0.144
            },
            "gtin": "4013752080905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dac226e0d9c0a18d3896e0c3",
            "leftCorner": {
              "x": -17.816,
              "y": -36.39,
              "z": 0.144
            },
            "rightCorner": {
              "x": -17.816,
              "y": -36.204,
              "z": 0.144
            },
            "gtin": "4013752040046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "33e1f8a9ad94d97564b88646",
            "leftCorner": {
              "x": -17.816,
              "y": -36.204,
              "z": 0.144
            },
            "rightCorner": {
              "x": -17.816,
              "y": -36.012,
              "z": 0.144
            },
            "gtin": "4013752080943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "db78d3cb62c1cedb733e64d2",
            "leftCorner": {
              "x": -17.816,
              "y": -36.012,
              "z": 0.144
            },
            "rightCorner": {
              "x": -17.816,
              "y": -35.838,
              "z": 0.144
            },
            "gtin": "4013752078742",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0dd",
        "height": 0.5336,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61cf",
            "leftCorner": {
              "x": -17.873,
              "y": -37.085,
              "z": 0.437
            },
            "rightCorner": {
              "x": -17.873,
              "y": -36.794,
              "z": 0.437
            },
            "gtin": "4104420056343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61d1",
            "leftCorner": {
              "x": -17.907,
              "y": -36.794,
              "z": 0.437
            },
            "rightCorner": {
              "x": -17.906,
              "y": -36.599,
              "z": 0.437
            },
            "gtin": "4306188050988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61d2",
            "leftCorner": {
              "x": -17.913,
              "y": -36.599,
              "z": 0.437
            },
            "rightCorner": {
              "x": -17.914,
              "y": -36.119,
              "z": 0.437
            },
            "gtin": "4306188356493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61d0",
            "leftCorner": {
              "x": -17.919,
              "y": -36.119,
              "z": 0.437
            },
            "rightCorner": {
              "x": -17.919,
              "y": -35.835,
              "z": 0.437
            },
            "gtin": "4306188356523",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0db",
        "height": 1.0132,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61b0",
            "leftCorner": {
              "x": -17.903,
              "y": -37.046,
              "z": 0.829
            },
            "rightCorner": {
              "x": -17.903,
              "y": -36.891,
              "z": 0.829
            },
            "gtin": "4104420053069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61b1",
            "leftCorner": {
              "x": -17.908,
              "y": -36.891,
              "z": 0.829
            },
            "rightCorner": {
              "x": -17.909,
              "y": -36.717,
              "z": 0.829
            },
            "gtin": "4013752040541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61b2",
            "leftCorner": {
              "x": -17.912,
              "y": -36.717,
              "z": 0.829
            },
            "rightCorner": {
              "x": -17.912,
              "y": -36.414,
              "z": 0.829
            },
            "gtin": "4013752019646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61b3",
            "leftCorner": {
              "x": -17.912,
              "y": -36.414,
              "z": 0.829
            },
            "rightCorner": {
              "x": -17.912,
              "y": -36.127,
              "z": 0.829
            },
            "gtin": "4013752019141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61a7",
            "leftCorner": {
              "x": -17.92,
              "y": -36.127,
              "z": 0.829
            },
            "rightCorner": {
              "x": -17.92,
              "y": -35.835,
              "z": 0.829
            },
            "gtin": "4013752027405",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0dc",
        "height": 1.3195,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61a1",
            "leftCorner": {
              "x": -17.903,
              "y": -37.032,
              "z": 1.08
            },
            "rightCorner": {
              "x": -17.904,
              "y": -36.797,
              "z": 1.08
            },
            "gtin": "4013752082046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61a2",
            "leftCorner": {
              "x": -17.909,
              "y": -36.797,
              "z": 1.08
            },
            "rightCorner": {
              "x": -17.909,
              "y": -36.619,
              "z": 1.08
            },
            "gtin": "4013752040046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61a3",
            "leftCorner": {
              "x": -17.906,
              "y": -36.619,
              "z": 1.08
            },
            "rightCorner": {
              "x": -17.906,
              "y": -36.402,
              "z": 1.08
            },
            "gtin": "4013752040244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61a4",
            "leftCorner": {
              "x": -17.906,
              "y": -36.402,
              "z": 1.08
            },
            "rightCorner": {
              "x": -17.905,
              "y": -36.228,
              "z": 1.08
            },
            "gtin": "4013752078742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61a5",
            "leftCorner": {
              "x": -17.913,
              "y": -36.228,
              "z": 1.08
            },
            "rightCorner": {
              "x": -17.913,
              "y": -36.044,
              "z": 1.08
            },
            "gtin": "4013752080905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6197",
            "leftCorner": {
              "x": -17.913,
              "y": -36.044,
              "z": 1.08
            },
            "rightCorner": {
              "x": -17.914,
              "y": -35.835,
              "z": 1.08
            },
            "gtin": "4013752080943",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0de",
        "height": 1.5674,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61bd",
            "leftCorner": {
              "x": -17.901,
              "y": -37.053,
              "z": 1.282
            },
            "rightCorner": {
              "x": -17.902,
              "y": -36.676,
              "z": 1.282
            },
            "gtin": "8000270705195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61b5",
            "leftCorner": {
              "x": -17.91,
              "y": -36.676,
              "z": 1.282
            },
            "rightCorner": {
              "x": -17.911,
              "y": -35.835,
              "z": 1.282
            },
            "gtin": "4006529001012",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "85e"
  },
  {
    "id": "864",
    "name": "864",
    "x": -18.305,
    "y": -19.288,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71191,
      "w": 0.70227
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 8,
      "unknownStockCount": 39,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d114",
        "height": 0.17624,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61fe",
            "leftCorner": {
              "x": -18.267,
              "y": -18.108,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.267,
              "y": -18.037,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e6e93c15833c14b444de2c3c",
            "leftCorner": {
              "x": -18.219,
              "y": -19.287,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.22,
              "y": -19.231,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "80fd4c8a3af11582e28eabe2",
            "leftCorner": {
              "x": -18.22,
              "y": -19.231,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.221,
              "y": -19.174,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6b5ea962b5016d07c82f1a3b",
            "leftCorner": {
              "x": -18.221,
              "y": -19.174,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.221,
              "y": -19.108,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6b96c158e3271918efa3857d",
            "leftCorner": {
              "x": -18.221,
              "y": -19.108,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.222,
              "y": -19.041,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f501925084f1d47df237d2f3",
            "leftCorner": {
              "x": -18.222,
              "y": -19.041,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.223,
              "y": -18.975,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4c17ea231e9fed5947ceba95",
            "leftCorner": {
              "x": -18.223,
              "y": -18.975,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.224,
              "y": -18.909,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "994c6820802a16fceb81f14f",
            "leftCorner": {
              "x": -18.224,
              "y": -18.909,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.225,
              "y": -18.842,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c935b0848dbc23ed40e238d9",
            "leftCorner": {
              "x": -18.225,
              "y": -18.842,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.226,
              "y": -18.776,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fb998aaa1261febc68db54b8",
            "leftCorner": {
              "x": -18.226,
              "y": -18.776,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.227,
              "y": -18.71,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3bcc9979f951fdecef3a4c61",
            "leftCorner": {
              "x": -18.227,
              "y": -18.71,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.228,
              "y": -18.643,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bfc0222644f0b5a970c9f54c",
            "leftCorner": {
              "x": -18.228,
              "y": -18.643,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.229,
              "y": -18.577,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e1b9c3fbcf44bdc4364a0a95",
            "leftCorner": {
              "x": -18.229,
              "y": -18.577,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.23,
              "y": -18.511,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "884f6c70f322228e081f13c7",
            "leftCorner": {
              "x": -18.23,
              "y": -18.511,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.23,
              "y": -18.444,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f03e06531864ec7849c07f96",
            "leftCorner": {
              "x": -18.23,
              "y": -18.444,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.231,
              "y": -18.378,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c054c204d2e0d84eb8147f3b",
            "leftCorner": {
              "x": -18.231,
              "y": -18.378,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.232,
              "y": -18.312,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3a0f734c08c2974264a89aa2",
            "leftCorner": {
              "x": -18.232,
              "y": -18.312,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.233,
              "y": -18.245,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "58134028bf046347e41d6ee9",
            "leftCorner": {
              "x": -18.233,
              "y": -18.245,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.234,
              "y": -18.179,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cf856b5af21d01955976fde3",
            "leftCorner": {
              "x": -18.234,
              "y": -18.179,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.235,
              "y": -18.113,
              "z": 0.144
            },
            "gtin": "2000439121312",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d113",
        "height": 0.77856,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62c2",
            "leftCorner": {
              "x": -18.302,
              "y": -19.197,
              "z": 0.637
            },
            "rightCorner": {
              "x": -18.305,
              "y": -18.953,
              "z": 0.637
            },
            "gtin": "4031386199466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62c3",
            "leftCorner": {
              "x": -18.311,
              "y": -18.953,
              "z": 0.637
            },
            "rightCorner": {
              "x": -18.316,
              "y": -18.569,
              "z": 0.637
            },
            "gtin": "4031386199459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62c4",
            "leftCorner": {
              "x": -18.319,
              "y": -18.569,
              "z": 0.637
            },
            "rightCorner": {
              "x": -18.322,
              "y": -18.396,
              "z": 0.637
            },
            "gtin": "4031386166499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62c5",
            "leftCorner": {
              "x": -18.322,
              "y": -18.396,
              "z": 0.637
            },
            "rightCorner": {
              "x": -18.324,
              "y": -18.238,
              "z": 0.637
            },
            "gtin": "4031386240120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62ad",
            "leftCorner": {
              "x": -18.322,
              "y": -18.238,
              "z": 0.637
            },
            "rightCorner": {
              "x": -18.324,
              "y": -18.038,
              "z": 0.637
            },
            "gtin": "4031386240113",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d111",
        "height": 1.0576,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d626b",
            "leftCorner": {
              "x": -18.309,
              "y": -19.235,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.311,
              "y": -19.081,
              "z": 0.865
            },
            "gtin": "4031386199428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d626c",
            "leftCorner": {
              "x": -18.306,
              "y": -19.081,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.309,
              "y": -18.927,
              "z": 0.865
            },
            "gtin": "4031386199435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d626d",
            "leftCorner": {
              "x": -18.316,
              "y": -18.927,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.318,
              "y": -18.76,
              "z": 0.865
            },
            "gtin": "4031386199442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d626e",
            "leftCorner": {
              "x": -18.32,
              "y": -18.76,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.322,
              "y": -18.663,
              "z": 0.865
            },
            "gtin": "4031386016299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d626f",
            "leftCorner": {
              "x": -18.321,
              "y": -18.663,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.322,
              "y": -18.556,
              "z": 0.865
            },
            "gtin": "4031386165928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6270",
            "leftCorner": {
              "x": -18.32,
              "y": -18.556,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.323,
              "y": -18.387,
              "z": 0.865
            },
            "gtin": "4031386197394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6271",
            "leftCorner": {
              "x": -18.324,
              "y": -18.387,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.325,
              "y": -18.248,
              "z": 0.865
            },
            "gtin": "4031386199985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6252",
            "leftCorner": {
              "x": -18.323,
              "y": -18.248,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.326,
              "y": -18.038,
              "z": 0.865
            },
            "gtin": "4031386199978",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d112",
        "height": 1.3638,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d628d",
            "leftCorner": {
              "x": -18.304,
              "y": -19.224,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.307,
              "y": -19.039,
              "z": 1.116
            },
            "gtin": "4031386014707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d628e",
            "leftCorner": {
              "x": -18.3,
              "y": -19.039,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.302,
              "y": -18.94,
              "z": 1.116
            },
            "gtin": "4031386015414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d628f",
            "leftCorner": {
              "x": -18.309,
              "y": -18.94,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.312,
              "y": -18.741,
              "z": 1.116
            },
            "gtin": "4031386015421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6290",
            "leftCorner": {
              "x": -18.316,
              "y": -18.741,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.317,
              "y": -18.588,
              "z": 1.116
            },
            "gtin": "4031386166543",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6291",
            "leftCorner": {
              "x": -18.315,
              "y": -18.588,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.319,
              "y": -18.405,
              "z": 1.116
            },
            "gtin": "4031386165911",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6292",
            "leftCorner": {
              "x": -18.315,
              "y": -18.405,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.316,
              "y": -18.281,
              "z": 1.116
            },
            "gtin": "4031386166512",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6293",
            "leftCorner": {
              "x": -18.317,
              "y": -18.281,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.319,
              "y": -18.137,
              "z": 1.116
            },
            "gtin": "4031386199862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6273",
            "leftCorner": {
              "x": -18.316,
              "y": -18.137,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.317,
              "y": -18.038,
              "z": 1.116
            },
            "gtin": "4031386199879",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d110",
        "height": 1.636,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d624c",
            "leftCorner": {
              "x": -18.304,
              "y": -19.136,
              "z": 1.339
            },
            "rightCorner": {
              "x": -18.306,
              "y": -19.053,
              "z": 1.339
            },
            "gtin": "4031386166536",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d624d",
            "leftCorner": {
              "x": -18.304,
              "y": -19.053,
              "z": 1.339
            },
            "rightCorner": {
              "x": -18.308,
              "y": -18.759,
              "z": 1.339
            },
            "gtin": "4031386162583",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d624e",
            "leftCorner": {
              "x": -18.318,
              "y": -18.759,
              "z": 1.339
            },
            "rightCorner": {
              "x": -18.32,
              "y": -18.591,
              "z": 1.339
            },
            "gtin": "4031386162514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d624f",
            "leftCorner": {
              "x": -18.317,
              "y": -18.591,
              "z": 1.339
            },
            "rightCorner": {
              "x": -18.32,
              "y": -18.439,
              "z": 1.339
            },
            "gtin": "4031386164426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6250",
            "leftCorner": {
              "x": -18.317,
              "y": -18.439,
              "z": 1.339
            },
            "rightCorner": {
              "x": -18.319,
              "y": -18.29,
              "z": 1.339
            },
            "gtin": "4031386190876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6235",
            "leftCorner": {
              "x": -18.319,
              "y": -18.29,
              "z": 1.339
            },
            "rightCorner": {
              "x": -18.322,
              "y": -18.038,
              "z": 1.339
            },
            "gtin": "4031386199534",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "11a147e69e75b8248504cc63",
            "leftCorner": {
              "x": -18.265,
              "y": -19.287,
              "z": 1.339
            },
            "rightCorner": {
              "x": -18.267,
              "y": -19.137,
              "z": 1.339
            },
            "gtin": "4031386190876",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "865"
  },
  {
    "id": "865",
    "name": "865",
    "x": -18.288,
    "y": -20.537,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71191,
      "w": 0.70227
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 27
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d10f",
        "height": 0.17333,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6221",
            "leftCorner": {
              "x": -18.243,
              "y": -19.518,
              "z": 0.142
            },
            "rightCorner": {
              "x": -18.248,
              "y": -19.155,
              "z": 0.142
            },
            "gtin": "4008728043602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9cf8af6f5f0c90891cdf70cb",
            "leftCorner": {
              "x": -18.199,
              "y": -20.535,
              "z": 0.142
            },
            "rightCorner": {
              "x": -18.202,
              "y": -20.339,
              "z": 0.142
            },
            "gtin": "5400265020037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bbf2c8684958353a8b4cf6c4",
            "leftCorner": {
              "x": -18.202,
              "y": -20.339,
              "z": 0.142
            },
            "rightCorner": {
              "x": -18.205,
              "y": -20.13,
              "z": 0.142
            },
            "gtin": "4306188035060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4172458b7ed3b32084a38fbf",
            "leftCorner": {
              "x": -18.205,
              "y": -20.13,
              "z": 0.142
            },
            "rightCorner": {
              "x": -18.208,
              "y": -19.899,
              "z": 0.142
            },
            "gtin": "4306188030201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9810ffdd9d751c2b40bdf9c2",
            "leftCorner": {
              "x": -18.208,
              "y": -19.899,
              "z": 0.142
            },
            "rightCorner": {
              "x": -18.211,
              "y": -19.657,
              "z": 0.142
            },
            "gtin": "5412746006546",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d10e",
        "height": 0.48034,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62a9",
            "leftCorner": {
              "x": -18.28,
              "y": -20.537,
              "z": 0.393
            },
            "rightCorner": {
              "x": -18.287,
              "y": -20.123,
              "z": 0.393
            },
            "gtin": "4250426200584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62aa",
            "leftCorner": {
              "x": -18.28,
              "y": -20.123,
              "z": 0.393
            },
            "rightCorner": {
              "x": -18.284,
              "y": -19.837,
              "z": 0.393
            },
            "gtin": "4250426200584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62ab",
            "leftCorner": {
              "x": -18.297,
              "y": -19.837,
              "z": 0.393
            },
            "rightCorner": {
              "x": -18.305,
              "y": -19.228,
              "z": 0.393
            },
            "gtin": "4250426200577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6295",
            "leftCorner": {
              "x": -18.316,
              "y": -19.228,
              "z": 0.393
            },
            "rightCorner": {
              "x": -18.316,
              "y": -19.168,
              "z": 0.393
            },
            "gtin": "8000500426449",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d10b",
        "height": 0.77762,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62bd",
            "leftCorner": {
              "x": -18.282,
              "y": -20.537,
              "z": 0.636
            },
            "rightCorner": {
              "x": -18.285,
              "y": -20.345,
              "z": 0.636
            },
            "gtin": "4044808116002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62be",
            "leftCorner": {
              "x": -18.283,
              "y": -20.345,
              "z": 0.636
            },
            "rightCorner": {
              "x": -18.287,
              "y": -20.061,
              "z": 0.636
            },
            "gtin": "4044808116002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62bf",
            "leftCorner": {
              "x": -18.289,
              "y": -20.061,
              "z": 0.636
            },
            "rightCorner": {
              "x": -18.293,
              "y": -19.824,
              "z": 0.636
            },
            "gtin": "4306188030201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62c0",
            "leftCorner": {
              "x": -18.295,
              "y": -19.824,
              "z": 0.636
            },
            "rightCorner": {
              "x": -18.299,
              "y": -19.551,
              "z": 0.636
            },
            "gtin": "4008728020023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62c1",
            "leftCorner": {
              "x": -18.303,
              "y": -19.551,
              "z": 0.636
            },
            "rightCorner": {
              "x": -18.308,
              "y": -19.196,
              "z": 0.636
            },
            "gtin": "4008728020078",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d10c",
        "height": 1.057,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6266",
            "leftCorner": {
              "x": -18.277,
              "y": -20.471,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.281,
              "y": -20.226,
              "z": 0.865
            },
            "gtin": "8710667010985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6267",
            "leftCorner": {
              "x": -18.283,
              "y": -20.226,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.287,
              "y": -19.97,
              "z": 0.865
            },
            "gtin": "8713621430447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6268",
            "leftCorner": {
              "x": -18.29,
              "y": -19.97,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.293,
              "y": -19.725,
              "z": 0.865
            },
            "gtin": "5412746006560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6269",
            "leftCorner": {
              "x": -18.298,
              "y": -19.725,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.301,
              "y": -19.484,
              "z": 0.865
            },
            "gtin": "5412746006546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d626a",
            "leftCorner": {
              "x": -18.303,
              "y": -19.484,
              "z": 0.865
            },
            "rightCorner": {
              "x": -18.307,
              "y": -19.234,
              "z": 0.865
            },
            "gtin": "5400265020037",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d10d",
        "height": 1.3628,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d628a",
            "leftCorner": {
              "x": -18.273,
              "y": -20.212,
              "z": 1.115
            },
            "rightCorner": {
              "x": -18.276,
              "y": -19.923,
              "z": 1.115
            },
            "gtin": "8710434511554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e08d52aecc6f19ca6dff6435",
            "leftCorner": {
              "x": -18.237,
              "y": -20.536,
              "z": 1.115
            },
            "rightCorner": {
              "x": -18.241,
              "y": -20.253,
              "z": 1.115
            },
            "gtin": "8710434511554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d628b",
            "leftCorner": {
              "x": -18.285,
              "y": -19.923,
              "z": 1.115
            },
            "rightCorner": {
              "x": -18.289,
              "y": -19.639,
              "z": 1.115
            },
            "gtin": "5453001001654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d628c",
            "leftCorner": {
              "x": -18.294,
              "y": -19.639,
              "z": 1.115
            },
            "rightCorner": {
              "x": -18.3,
              "y": -19.223,
              "z": 1.115
            },
            "gtin": "4008728039483",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d10a",
        "height": 1.6374,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6248",
            "leftCorner": {
              "x": -18.28,
              "y": -20.537,
              "z": 1.34
            },
            "rightCorner": {
              "x": -18.284,
              "y": -20.294,
              "z": 1.34
            },
            "gtin": "4035637270058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6249",
            "leftCorner": {
              "x": -18.279,
              "y": -20.294,
              "z": 1.34
            },
            "rightCorner": {
              "x": -18.283,
              "y": -19.988,
              "z": 1.34
            },
            "gtin": "4035637270058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d624a",
            "leftCorner": {
              "x": -18.287,
              "y": -19.988,
              "z": 1.34
            },
            "rightCorner": {
              "x": -18.294,
              "y": -19.496,
              "z": 1.34
            },
            "gtin": "4306188035091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d624b",
            "leftCorner": {
              "x": -18.301,
              "y": -19.496,
              "z": 1.34
            },
            "rightCorner": {
              "x": -18.306,
              "y": -19.135,
              "z": 1.34
            },
            "gtin": "4306188035060",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "866",
    "rightNeighborShelfId": "864"
  },
  {
    "id": "866",
    "name": "866",
    "x": -18.271,
    "y": -21.787,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71191,
      "w": 0.70227
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d109",
        "height": 0.17419,
        "facings": [
          {
            "id": "ac92a8171121c9133918e643",
            "leftCorner": {
              "x": -18.188,
              "y": -21.786,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.19,
              "y": -21.657,
              "z": 0.143
            },
            "gtin": "5411823866905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6fd2b54dc8814a2ff47fa24d",
            "leftCorner": {
              "x": -18.19,
              "y": -21.657,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.192,
              "y": -21.5,
              "z": 0.143
            },
            "gtin": "4250426201192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "04fa9716f743613ba4eaade4",
            "leftCorner": {
              "x": -18.192,
              "y": -21.5,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.194,
              "y": -21.33,
              "z": 0.143
            },
            "gtin": "8000105001713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e91cde731a049ecd50205e1f",
            "leftCorner": {
              "x": -18.194,
              "y": -21.33,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.197,
              "y": -21.137,
              "z": 0.143
            },
            "gtin": "8713621402451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f29dec47762dca70b4578b45",
            "leftCorner": {
              "x": -18.197,
              "y": -21.137,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.2,
              "y": -20.937,
              "z": 0.143
            },
            "gtin": "4104420247031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0ea7fbcb07dd5f063dfa76ec",
            "leftCorner": {
              "x": -18.2,
              "y": -20.937,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.202,
              "y": -20.725,
              "z": 0.143
            }
          },
          {
            "id": "bc5152648b37722be9bb62e2",
            "leftCorner": {
              "x": -18.202,
              "y": -20.725,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.205,
              "y": -20.555,
              "z": 0.143
            },
            "gtin": "8000105001713",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d106",
        "height": 0.47861,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62a4",
            "leftCorner": {
              "x": -18.257,
              "y": -21.554,
              "z": 0.392
            },
            "rightCorner": {
              "x": -18.258,
              "y": -21.444,
              "z": 0.392
            },
            "gtin": "9000331607207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f58657a4b7e3e2a36e0b78a8",
            "leftCorner": {
              "x": -18.219,
              "y": -21.786,
              "z": 0.392
            },
            "rightCorner": {
              "x": -18.222,
              "y": -21.575,
              "z": 0.392
            },
            "gtin": "4009176158603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62a5",
            "leftCorner": {
              "x": -18.263,
              "y": -21.444,
              "z": 0.392
            },
            "rightCorner": {
              "x": -18.266,
              "y": -21.23,
              "z": 0.392
            },
            "gtin": "4009176158603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62a6",
            "leftCorner": {
              "x": -18.274,
              "y": -21.23,
              "z": 0.392
            },
            "rightCorner": {
              "x": -18.277,
              "y": -20.977,
              "z": 0.392
            },
            "gtin": "4306188046998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62a7",
            "leftCorner": {
              "x": -18.272,
              "y": -20.977,
              "z": 0.392
            },
            "rightCorner": {
              "x": -18.275,
              "y": -20.704,
              "z": 0.392
            },
            "gtin": "4306188040316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62a8",
            "leftCorner": {
              "x": -18.272,
              "y": -20.704,
              "z": 0.392
            },
            "rightCorner": {
              "x": -18.275,
              "y": -20.537,
              "z": 0.392
            },
            "gtin": "4250426201192",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d108",
        "height": 0.7777,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62ba",
            "leftCorner": {
              "x": -18.262,
              "y": -21.727,
              "z": 0.636
            },
            "rightCorner": {
              "x": -18.267,
              "y": -21.275,
              "z": 0.636
            },
            "gtin": "4006529002132",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62bb",
            "leftCorner": {
              "x": -18.27,
              "y": -21.275,
              "z": 0.636
            },
            "rightCorner": {
              "x": -18.276,
              "y": -20.831,
              "z": 0.636
            },
            "gtin": "4006529002156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62bc",
            "leftCorner": {
              "x": -18.272,
              "y": -20.831,
              "z": 0.636
            },
            "rightCorner": {
              "x": -18.276,
              "y": -20.537,
              "z": 0.636
            },
            "gtin": "4006529002163",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d104",
        "height": 1.0562,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6261",
            "leftCorner": {
              "x": -18.251,
              "y": -21.626,
              "z": 0.864
            },
            "rightCorner": {
              "x": -18.253,
              "y": -21.429,
              "z": 0.864
            },
            "gtin": "4104420247031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "46a184f4d2eb6e8aca3fff16",
            "leftCorner": {
              "x": -18.221,
              "y": -21.786,
              "z": 0.864
            },
            "rightCorner": {
              "x": -18.223,
              "y": -21.631,
              "z": 0.864
            },
            "gtin": "8710291003919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6262",
            "leftCorner": {
              "x": -18.26,
              "y": -21.429,
              "z": 0.864
            },
            "rightCorner": {
              "x": -18.264,
              "y": -21.235,
              "z": 0.864
            },
            "gtin": "8713621402451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6263",
            "leftCorner": {
              "x": -18.27,
              "y": -21.235,
              "z": 0.864
            },
            "rightCorner": {
              "x": -18.274,
              "y": -20.953,
              "z": 0.864
            },
            "gtin": "8710571001062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6264",
            "leftCorner": {
              "x": -18.273,
              "y": -20.953,
              "z": 0.864
            },
            "rightCorner": {
              "x": -18.276,
              "y": -20.704,
              "z": 0.864
            },
            "gtin": "8710571001208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6265",
            "leftCorner": {
              "x": -18.275,
              "y": -20.704,
              "z": 0.864
            },
            "rightCorner": {
              "x": -18.278,
              "y": -20.47,
              "z": 0.864
            },
            "gtin": "8710291003919",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d105",
        "height": 1.3611,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6284",
            "leftCorner": {
              "x": -18.254,
              "y": -21.737,
              "z": 1.114
            },
            "rightCorner": {
              "x": -18.256,
              "y": -21.576,
              "z": 1.114
            },
            "gtin": "8000105001713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6285",
            "leftCorner": {
              "x": -18.242,
              "y": -21.576,
              "z": 1.114
            },
            "rightCorner": {
              "x": -18.245,
              "y": -21.274,
              "z": 1.114
            },
            "gtin": "8710476805529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6286",
            "leftCorner": {
              "x": -18.259,
              "y": -21.274,
              "z": 1.114
            },
            "rightCorner": {
              "x": -18.263,
              "y": -20.965,
              "z": 1.114
            },
            "gtin": "5400265003924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6287",
            "leftCorner": {
              "x": -18.265,
              "y": -20.965,
              "z": 1.114
            },
            "rightCorner": {
              "x": -18.271,
              "y": -20.61,
              "z": 1.114
            },
            "gtin": "4260459410027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6288",
            "leftCorner": {
              "x": -18.272,
              "y": -20.61,
              "z": 1.114
            },
            "rightCorner": {
              "x": -18.273,
              "y": -20.537,
              "z": 1.114
            },
            "gtin": "8711592129209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6289",
            "leftCorner": {
              "x": -18.277,
              "y": -20.563,
              "z": 1.115
            },
            "rightCorner": {
              "x": -18.282,
              "y": -20.238,
              "z": 1.115
            },
            "gtin": "8711592129209",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d107",
        "height": 1.6341,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6244",
            "leftCorner": {
              "x": -18.252,
              "y": -21.688,
              "z": 1.337
            },
            "rightCorner": {
              "x": -18.256,
              "y": -21.495,
              "z": 1.337
            }
          },
          {
            "id": "68d8e50ae1820c81800d6245",
            "leftCorner": {
              "x": -18.253,
              "y": -21.495,
              "z": 1.337
            },
            "rightCorner": {
              "x": -18.26,
              "y": -21.015,
              "z": 1.337
            },
            "gtin": "4306188035039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6246",
            "leftCorner": {
              "x": -18.27,
              "y": -21.015,
              "z": 1.337
            },
            "rightCorner": {
              "x": -18.274,
              "y": -20.675,
              "z": 1.337
            },
            "gtin": "5411823866899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6247",
            "leftCorner": {
              "x": -18.272,
              "y": -20.675,
              "z": 1.337
            },
            "rightCorner": {
              "x": -18.274,
              "y": -20.537,
              "z": 1.337
            },
            "gtin": "5411823866905",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "867",
    "rightNeighborShelfId": "865"
  },
  {
    "id": "867",
    "name": "867",
    "x": -18.254,
    "y": -23.037,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71191,
      "w": 0.70227
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d103",
        "height": 0.17423,
        "facings": [
          {
            "id": "ff6d2b6d171b739eca2ecb6c",
            "leftCorner": {
              "x": -18.174,
              "y": -23.035,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.175,
              "y": -22.927,
              "z": 0.143
            },
            "gtin": "8000105001706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ad28feef7452832962411baa",
            "leftCorner": {
              "x": -18.175,
              "y": -22.927,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.177,
              "y": -22.788,
              "z": 0.143
            },
            "gtin": "9000331607948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b178bbc6c049e55df1360c6a",
            "leftCorner": {
              "x": -18.177,
              "y": -22.788,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.179,
              "y": -22.635,
              "z": 0.143
            },
            "gtin": "2000445007174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ad41eeacebde402b78a4161f",
            "leftCorner": {
              "x": -18.179,
              "y": -22.635,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.182,
              "y": -22.454,
              "z": 0.143
            },
            "gtin": "4044808110178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "989530fa07a598a11ff150bd",
            "leftCorner": {
              "x": -18.182,
              "y": -22.454,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.185,
              "y": -22.254,
              "z": 0.143
            },
            "gtin": "4006952008169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dd48579d0fa84f1dc523f47e",
            "leftCorner": {
              "x": -18.185,
              "y": -22.254,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.187,
              "y": -22.049,
              "z": 0.143
            },
            "gtin": "4006952008152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee2b5be8561657d44f09df0a",
            "leftCorner": {
              "x": -18.187,
              "y": -22.049,
              "z": 0.143
            },
            "rightCorner": {
              "x": -18.191,
              "y": -21.792,
              "z": 0.143
            },
            "gtin": "8710508601235",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0fe",
        "height": 0.48311,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d629e",
            "leftCorner": {
              "x": -18.239,
              "y": -22.846,
              "z": 0.395
            },
            "rightCorner": {
              "x": -18.243,
              "y": -22.642,
              "z": 0.395
            },
            "gtin": "4001518000335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "03d57b04c7cee7b12a090d13",
            "leftCorner": {
              "x": -18.216,
              "y": -23.037,
              "z": 0.395
            },
            "rightCorner": {
              "x": -18.218,
              "y": -22.895,
              "z": 0.395
            },
            "gtin": "9000331607948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "739f10aed9b03d73ab1b20a5",
            "leftCorner": {
              "x": -18.224,
              "y": -22.443,
              "z": 0.395
            },
            "rightCorner": {
              "x": -18.228,
              "y": -22.139,
              "z": 0.395
            },
            "gtin": "9000331607719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d629f",
            "leftCorner": {
              "x": -18.249,
              "y": -22.642,
              "z": 0.395
            },
            "rightCorner": {
              "x": -18.251,
              "y": -22.443,
              "z": 0.395
            },
            "gtin": "4001518117866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62a2",
            "leftCorner": {
              "x": -18.268,
              "y": -22.135,
              "z": 0.395
            },
            "rightCorner": {
              "x": -18.271,
              "y": -21.859,
              "z": 0.395
            },
            "gtin": "9000331607719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62a3",
            "leftCorner": {
              "x": -18.269,
              "y": -21.859,
              "z": 0.395
            },
            "rightCorner": {
              "x": -18.274,
              "y": -21.553,
              "z": 0.395
            },
            "gtin": "9000331607917",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d102",
        "height": 0.78102,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62b7",
            "leftCorner": {
              "x": -18.242,
              "y": -22.988,
              "z": 0.639
            },
            "rightCorner": {
              "x": -18.248,
              "y": -22.539,
              "z": 0.639
            },
            "gtin": "4006529002217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62b8",
            "leftCorner": {
              "x": -18.259,
              "y": -22.539,
              "z": 0.639
            },
            "rightCorner": {
              "x": -18.266,
              "y": -22.031,
              "z": 0.639
            },
            "gtin": "4006529002200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62b9",
            "leftCorner": {
              "x": -18.266,
              "y": -22.031,
              "z": 0.639
            },
            "rightCorner": {
              "x": -18.27,
              "y": -21.728,
              "z": 0.639
            },
            "gtin": "4006529002149",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ff",
        "height": 1.0581,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d625c",
            "leftCorner": {
              "x": -18.238,
              "y": -22.987,
              "z": 0.866
            },
            "rightCorner": {
              "x": -18.241,
              "y": -22.784,
              "z": 0.866
            },
            "gtin": "4006952006950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d625d",
            "leftCorner": {
              "x": -18.239,
              "y": -22.784,
              "z": 0.866
            },
            "rightCorner": {
              "x": -18.243,
              "y": -22.571,
              "z": 0.866
            },
            "gtin": "4006952006912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d625e",
            "leftCorner": {
              "x": -18.252,
              "y": -22.571,
              "z": 0.866
            },
            "rightCorner": {
              "x": -18.256,
              "y": -22.266,
              "z": 0.866
            },
            "gtin": "4306188038252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d625f",
            "leftCorner": {
              "x": -18.264,
              "y": -22.266,
              "z": 0.866
            },
            "rightCorner": {
              "x": -18.268,
              "y": -21.934,
              "z": 0.866
            },
            "gtin": "4101040050867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6260",
            "leftCorner": {
              "x": -18.265,
              "y": -21.934,
              "z": 0.866
            },
            "rightCorner": {
              "x": -18.269,
              "y": -21.626,
              "z": 0.866
            },
            "gtin": "2000445007174",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d101",
        "height": 1.3617,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d627e",
            "leftCorner": {
              "x": -18.232,
              "y": -22.988,
              "z": 1.114
            },
            "rightCorner": {
              "x": -18.235,
              "y": -22.739,
              "z": 1.114
            },
            "gtin": "4006952008114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d627f",
            "leftCorner": {
              "x": -18.236,
              "y": -22.739,
              "z": 1.114
            },
            "rightCorner": {
              "x": -18.239,
              "y": -22.535,
              "z": 1.114
            },
            "gtin": "4006952008169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6280",
            "leftCorner": {
              "x": -18.254,
              "y": -22.535,
              "z": 1.114
            },
            "rightCorner": {
              "x": -18.257,
              "y": -22.33,
              "z": 1.114
            },
            "gtin": "4006952008152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6281",
            "leftCorner": {
              "x": -18.258,
              "y": -22.33,
              "z": 1.114
            },
            "rightCorner": {
              "x": -18.261,
              "y": -22.116,
              "z": 1.114
            },
            "gtin": "4006952008138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6282",
            "leftCorner": {
              "x": -18.26,
              "y": -22.115,
              "z": 1.114
            },
            "rightCorner": {
              "x": -18.264,
              "y": -21.869,
              "z": 1.114
            },
            "gtin": "4006952008145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6283",
            "leftCorner": {
              "x": -18.257,
              "y": -21.868,
              "z": 1.114
            },
            "rightCorner": {
              "x": -18.259,
              "y": -21.737,
              "z": 1.114
            },
            "gtin": "8000105001706",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d100",
        "height": 1.6358,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d623f",
            "leftCorner": {
              "x": -18.236,
              "y": -23.014,
              "z": 1.338
            },
            "rightCorner": {
              "x": -18.24,
              "y": -22.757,
              "z": 1.338
            },
            "gtin": "8710508770856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6240",
            "leftCorner": {
              "x": -18.239,
              "y": -22.757,
              "z": 1.338
            },
            "rightCorner": {
              "x": -18.242,
              "y": -22.495,
              "z": 1.338
            },
            "gtin": "8710508601235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6241",
            "leftCorner": {
              "x": -18.257,
              "y": -22.495,
              "z": 1.338
            },
            "rightCorner": {
              "x": -18.262,
              "y": -22.216,
              "z": 1.338
            },
            "gtin": "8710508770863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6242",
            "leftCorner": {
              "x": -18.264,
              "y": -22.216,
              "z": 1.338
            },
            "rightCorner": {
              "x": -18.268,
              "y": -21.93,
              "z": 1.338
            },
            "gtin": "4044808410094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6243",
            "leftCorner": {
              "x": -18.262,
              "y": -21.93,
              "z": 1.338
            },
            "rightCorner": {
              "x": -18.265,
              "y": -21.689,
              "z": 1.338
            },
            "gtin": "4044808110178",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "868",
    "rightNeighborShelfId": "866"
  },
  {
    "id": "868",
    "name": "868",
    "x": -18.237,
    "y": -24.287,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7119,
      "w": 0.70228
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0fd",
        "height": 0.17764,
        "facings": [
          {
            "id": "22054b3810238ed09997c593",
            "leftCorner": {
              "x": -18.15,
              "y": -24.286,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.153,
              "y": -24.076,
              "z": 0.145
            },
            "gtin": "4006952008145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f49103dd20dc2c5ce1a5627c",
            "leftCorner": {
              "x": -18.153,
              "y": -24.076,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.154,
              "y": -23.967,
              "z": 0.145
            },
            "gtin": "4306188003052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d730b96912c807abc6c0d122",
            "leftCorner": {
              "x": -18.154,
              "y": -23.967,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.156,
              "y": -23.853,
              "z": 0.145
            },
            "gtin": "4006952008121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1fa52a1668cb1bcd7b225c1a",
            "leftCorner": {
              "x": -18.156,
              "y": -23.853,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.158,
              "y": -23.732,
              "z": 0.145
            },
            "gtin": "4006952006943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4d83a404baadec550a5a3203",
            "leftCorner": {
              "x": -18.158,
              "y": -23.732,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.159,
              "y": -23.594,
              "z": 0.145
            },
            "gtin": "7622300479008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8713533e252a4210bfa6a672",
            "leftCorner": {
              "x": -18.159,
              "y": -23.594,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.162,
              "y": -23.419,
              "z": 0.145
            },
            "gtin": "4017100298905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "29180af57f8a2aa8d3bc3ae0",
            "leftCorner": {
              "x": -18.162,
              "y": -23.419,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.164,
              "y": -23.234,
              "z": 0.145
            },
            "gtin": "5410126726244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b129a069a1a42db09cfea1c9",
            "leftCorner": {
              "x": -18.164,
              "y": -23.234,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.167,
              "y": -23.042,
              "z": 0.145
            },
            "gtin": "4306188003021",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0f8",
        "height": 0.4832,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6299",
            "leftCorner": {
              "x": -18.224,
              "y": -24.173,
              "z": 0.395
            },
            "rightCorner": {
              "x": -18.228,
              "y": -23.867,
              "z": 0.395
            },
            "gtin": "8717185470406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8a9adde9cdd60a30bbc4189c",
            "leftCorner": {
              "x": -18.185,
              "y": -24.287,
              "z": 0.395
            },
            "rightCorner": {
              "x": -18.186,
              "y": -24.178,
              "z": 0.395
            },
            "gtin": "4306188003052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d629a",
            "leftCorner": {
              "x": -18.238,
              "y": -23.867,
              "z": 0.395
            },
            "rightCorner": {
              "x": -18.241,
              "y": -23.625,
              "z": 0.395
            },
            "gtin": "8717185470437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d629b",
            "leftCorner": {
              "x": -18.234,
              "y": -23.625,
              "z": 0.395
            },
            "rightCorner": {
              "x": -18.237,
              "y": -23.431,
              "z": 0.395
            },
            "gtin": "4306188003083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d629c",
            "leftCorner": {
              "x": -18.237,
              "y": -23.431,
              "z": 0.395
            },
            "rightCorner": {
              "x": -18.239,
              "y": -23.246,
              "z": 0.395
            },
            "gtin": "4306188003021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d629d",
            "leftCorner": {
              "x": -18.24,
              "y": -23.246,
              "z": 0.395
            },
            "rightCorner": {
              "x": -18.246,
              "y": -22.847,
              "z": 0.395
            },
            "gtin": "4306188003052",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0fb",
        "height": 0.78343,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62b3",
            "leftCorner": {
              "x": -18.228,
              "y": -24.072,
              "z": 0.641
            },
            "rightCorner": {
              "x": -18.232,
              "y": -23.805,
              "z": 0.641
            }
          },
          {
            "id": "8a2dadb813a7f3f7052cf45f",
            "leftCorner": {
              "x": -18.187,
              "y": -24.287,
              "z": 0.641
            },
            "rightCorner": {
              "x": -18.19,
              "y": -24.101,
              "z": 0.641
            },
            "gtin": "5410126726244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62b4",
            "leftCorner": {
              "x": -18.24,
              "y": -23.805,
              "z": 0.641
            },
            "rightCorner": {
              "x": -18.244,
              "y": -23.492,
              "z": 0.641
            },
            "gtin": "4001518112847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62b5",
            "leftCorner": {
              "x": -18.237,
              "y": -23.492,
              "z": 0.641
            },
            "rightCorner": {
              "x": -18.24,
              "y": -23.243,
              "z": 0.641
            },
            "gtin": "4001518116999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62b6",
            "leftCorner": {
              "x": -18.241,
              "y": -23.243,
              "z": 0.641
            },
            "rightCorner": {
              "x": -18.244,
              "y": -22.989,
              "z": 0.641
            },
            "gtin": "4001518117019",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0fc",
        "height": 1.0611,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6257",
            "leftCorner": {
              "x": -18.218,
              "y": -24.263,
              "z": 0.868
            },
            "rightCorner": {
              "x": -18.225,
              "y": -23.816,
              "z": 0.868
            },
            "gtin": "4002652000717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6258",
            "leftCorner": {
              "x": -18.24,
              "y": -23.816,
              "z": 0.868
            },
            "rightCorner": {
              "x": -18.244,
              "y": -23.543,
              "z": 0.868
            },
            "gtin": "4002652000748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6259",
            "leftCorner": {
              "x": -18.234,
              "y": -23.543,
              "z": 0.868
            },
            "rightCorner": {
              "x": -18.236,
              "y": -23.338,
              "z": 0.868
            },
            "gtin": "4006952006929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d625a",
            "leftCorner": {
              "x": -18.238,
              "y": -23.338,
              "z": 0.868
            },
            "rightCorner": {
              "x": -18.24,
              "y": -23.162,
              "z": 0.868
            },
            "gtin": "4006952006936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d625b",
            "leftCorner": {
              "x": -18.235,
              "y": -23.162,
              "z": 0.868
            },
            "rightCorner": {
              "x": -18.237,
              "y": -22.988,
              "z": 0.868
            },
            "gtin": "4006952006943",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0fa",
        "height": 1.3638,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6279",
            "leftCorner": {
              "x": -18.222,
              "y": -24.198,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.225,
              "y": -23.994,
              "z": 1.116
            },
            "gtin": "7622300479008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d627a",
            "leftCorner": {
              "x": -18.234,
              "y": -23.994,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.237,
              "y": -23.736,
              "z": 1.116
            },
            "gtin": "7622300476175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d627b",
            "leftCorner": {
              "x": -18.235,
              "y": -23.736,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.236,
              "y": -23.564,
              "z": 1.116
            },
            "gtin": "4017100298905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d627c",
            "leftCorner": {
              "x": -18.232,
              "y": -23.564,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.235,
              "y": -23.338,
              "z": 1.116
            },
            "gtin": "4006894574203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d627d",
            "leftCorner": {
              "x": -18.233,
              "y": -23.338,
              "z": 1.116
            },
            "rightCorner": {
              "x": -18.237,
              "y": -22.989,
              "z": 1.116
            },
            "gtin": "4006952008121",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0f9",
        "height": 1.6382,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d623a",
            "leftCorner": {
              "x": -18.22,
              "y": -24.287,
              "z": 1.34
            },
            "rightCorner": {
              "x": -18.225,
              "y": -24.088,
              "z": 1.34
            },
            "gtin": "8008560001521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d623b",
            "leftCorner": {
              "x": -18.227,
              "y": -24.088,
              "z": 1.34
            },
            "rightCorner": {
              "x": -18.228,
              "y": -23.911,
              "z": 1.34
            },
            "gtin": "8008560001521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d623c",
            "leftCorner": {
              "x": -18.229,
              "y": -23.911,
              "z": 1.34
            },
            "rightCorner": {
              "x": -18.235,
              "y": -23.529,
              "z": 1.34
            },
            "gtin": "4250426200515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d623d",
            "leftCorner": {
              "x": -18.232,
              "y": -23.529,
              "z": 1.34
            },
            "rightCorner": {
              "x": -18.236,
              "y": -23.254,
              "z": 1.34
            },
            "gtin": "4006952003089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d623e",
            "leftCorner": {
              "x": -18.238,
              "y": -23.254,
              "z": 1.34
            },
            "rightCorner": {
              "x": -18.241,
              "y": -23.015,
              "z": 1.34
            },
            "gtin": "4006952003072",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "869",
    "rightNeighborShelfId": "867"
  },
  {
    "id": "869",
    "name": "869",
    "x": -18.22,
    "y": -25.537,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7119,
      "w": 0.70228
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0f7",
        "height": 0.16963,
        "facings": [
          {
            "id": "ffa88bf3e8bb3a0fd491b7fe",
            "leftCorner": {
              "x": -18.149,
              "y": -25.536,
              "z": 0.139
            },
            "rightCorner": {
              "x": -18.152,
              "y": -25.323,
              "z": 0.139
            },
            "gtin": "8717185470437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "63d0e7ec26d1b283f636aac1",
            "leftCorner": {
              "x": -18.152,
              "y": -25.323,
              "z": 0.139
            },
            "rightCorner": {
              "x": -18.155,
              "y": -25.095,
              "z": 0.139
            },
            "gtin": "8717185470406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fbc5ac58f0fae13c55eda582",
            "leftCorner": {
              "x": -18.155,
              "y": -25.095,
              "z": 0.139
            },
            "rightCorner": {
              "x": -18.158,
              "y": -24.861,
              "z": 0.139
            },
            "gtin": "4306188363804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c059e7f113074d47a5d6bec9",
            "leftCorner": {
              "x": -18.158,
              "y": -24.861,
              "z": 0.139
            },
            "rightCorner": {
              "x": -18.16,
              "y": -24.732,
              "z": 0.139
            },
            "gtin": "7622201823733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "582fa5ff9554574f1b992cc1",
            "leftCorner": {
              "x": -18.16,
              "y": -24.732,
              "z": 0.139
            },
            "rightCorner": {
              "x": -18.162,
              "y": -24.573,
              "z": 0.139
            },
            "gtin": "8003655252550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "59924f45cfad3af2c0b381da",
            "leftCorner": {
              "x": -18.162,
              "y": -24.573,
              "z": 0.139
            },
            "rightCorner": {
              "x": -18.166,
              "y": -24.287,
              "z": 0.139
            },
            "gtin": "8000500227848",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0f5",
        "height": 0.47951,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6294",
            "leftCorner": {
              "x": -18.176,
              "y": -25.536,
              "z": 0.392
            },
            "rightCorner": {
              "x": -18.179,
              "y": -25.264,
              "z": 0.392
            },
            "gtin": "8000500269169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6296",
            "leftCorner": {
              "x": -18.218,
              "y": -25.265,
              "z": 0.392
            },
            "rightCorner": {
              "x": -18.222,
              "y": -25.012,
              "z": 0.392
            },
            "gtin": "8000500385807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6297",
            "leftCorner": {
              "x": -18.224,
              "y": -25.012,
              "z": 0.392
            },
            "rightCorner": {
              "x": -18.227,
              "y": -24.754,
              "z": 0.392
            },
            "gtin": "8000500227848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6298",
            "leftCorner": {
              "x": -18.227,
              "y": -24.754,
              "z": 0.392
            },
            "rightCorner": {
              "x": -18.235,
              "y": -24.173,
              "z": 0.392
            },
            "gtin": "8000500310427",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0f6",
        "height": 0.7797,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62ac",
            "leftCorner": {
              "x": -18.176,
              "y": -25.536,
              "z": 0.638
            },
            "rightCorner": {
              "x": -18.18,
              "y": -25.235,
              "z": 0.638
            },
            "gtin": "4001518116517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62ae",
            "leftCorner": {
              "x": -18.22,
              "y": -25.235,
              "z": 0.638
            },
            "rightCorner": {
              "x": -18.224,
              "y": -24.99,
              "z": 0.638
            },
            "gtin": "4306188043690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62af",
            "leftCorner": {
              "x": -18.224,
              "y": -24.99,
              "z": 0.638
            },
            "rightCorner": {
              "x": -18.227,
              "y": -24.717,
              "z": 0.638
            },
            "gtin": "4306188045274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62b0",
            "leftCorner": {
              "x": -18.228,
              "y": -24.717,
              "z": 0.638
            },
            "rightCorner": {
              "x": -18.231,
              "y": -24.517,
              "z": 0.638
            },
            "gtin": "5410126006360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62b1",
            "leftCorner": {
              "x": -18.225,
              "y": -24.517,
              "z": 0.638
            },
            "rightCorner": {
              "x": -18.229,
              "y": -24.283,
              "z": 0.638
            },
            "gtin": "5410126016079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62b2",
            "leftCorner": {
              "x": -18.21,
              "y": -24.3,
              "z": 0.641
            },
            "rightCorner": {
              "x": -18.213,
              "y": -24.085,
              "z": 0.641
            },
            "gtin": "5410126726244",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0f3",
        "height": 1.0561,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6251",
            "leftCorner": {
              "x": -18.173,
              "y": -25.536,
              "z": 0.864
            },
            "rightCorner": {
              "x": -18.176,
              "y": -25.3,
              "z": 0.864
            },
            "gtin": "8410000810004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6253",
            "leftCorner": {
              "x": -18.214,
              "y": -25.301,
              "z": 0.864
            },
            "rightCorner": {
              "x": -18.217,
              "y": -25.083,
              "z": 0.864
            },
            "gtin": "7622201148676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6254",
            "leftCorner": {
              "x": -18.218,
              "y": -25.083,
              "z": 0.864
            },
            "rightCorner": {
              "x": -18.22,
              "y": -24.861,
              "z": 0.864
            },
            "gtin": "7622210419972",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6255",
            "leftCorner": {
              "x": -18.225,
              "y": -24.861,
              "z": 0.864
            },
            "rightCorner": {
              "x": -18.229,
              "y": -24.561,
              "z": 0.864
            },
            "gtin": "8000500426449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6256",
            "leftCorner": {
              "x": -18.227,
              "y": -24.561,
              "z": 0.864
            },
            "rightCorner": {
              "x": -18.232,
              "y": -24.262,
              "z": 0.864
            },
            "gtin": "4306188031956",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0f4",
        "height": 1.3588,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6272",
            "leftCorner": {
              "x": -18.17,
              "y": -25.536,
              "z": 1.112
            },
            "rightCorner": {
              "x": -18.173,
              "y": -25.284,
              "z": 1.112
            },
            "gtin": "7622210836687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6274",
            "leftCorner": {
              "x": -18.211,
              "y": -25.284,
              "z": 1.112
            },
            "rightCorner": {
              "x": -18.215,
              "y": -25.016,
              "z": 1.112
            },
            "gtin": "7622210984678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6275",
            "leftCorner": {
              "x": -18.217,
              "y": -25.016,
              "z": 1.112
            },
            "rightCorner": {
              "x": -18.22,
              "y": -24.807,
              "z": 1.112
            },
            "gtin": "7622300356767",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6276",
            "leftCorner": {
              "x": -18.223,
              "y": -24.807,
              "z": 1.112
            },
            "rightCorner": {
              "x": -18.225,
              "y": -24.581,
              "z": 1.112
            },
            "gtin": "7622300292522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6277",
            "leftCorner": {
              "x": -18.224,
              "y": -24.581,
              "z": 1.112
            },
            "rightCorner": {
              "x": -18.225,
              "y": -24.459,
              "z": 1.112
            },
            "gtin": "7622201823733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6278",
            "leftCorner": {
              "x": -18.221,
              "y": -24.459,
              "z": 1.112
            },
            "rightCorner": {
              "x": -18.225,
              "y": -24.198,
              "z": 1.112
            },
            "gtin": "7622300476144",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0f2",
        "height": 1.6351,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6234",
            "leftCorner": {
              "x": -18.166,
              "y": -25.536,
              "z": 1.338
            },
            "rightCorner": {
              "x": -18.168,
              "y": -25.322,
              "z": 1.338
            },
            "gtin": "7314710400504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6236",
            "leftCorner": {
              "x": -18.208,
              "y": -25.322,
              "z": 1.338
            },
            "rightCorner": {
              "x": -18.213,
              "y": -25.026,
              "z": 1.338
            },
            "gtin": "4006894133103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6237",
            "leftCorner": {
              "x": -18.213,
              "y": -25.026,
              "z": 1.338
            },
            "rightCorner": {
              "x": -18.217,
              "y": -24.722,
              "z": 1.338
            },
            "gtin": "4001518110454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6238",
            "leftCorner": {
              "x": -18.22,
              "y": -24.722,
              "z": 1.338
            },
            "rightCorner": {
              "x": -18.224,
              "y": -24.434,
              "z": 1.338
            },
            "gtin": "8032755322542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6239",
            "leftCorner": {
              "x": -18.217,
              "y": -24.434,
              "z": 1.338
            },
            "rightCorner": {
              "x": -18.22,
              "y": -24.287,
              "z": 1.338
            },
            "gtin": "8003655252550",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "86a",
    "rightNeighborShelfId": "868"
  },
  {
    "id": "86a",
    "name": "86a",
    "x": -18.181,
    "y": -26.504,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.72071,
      "w": 0.69324
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0f1",
        "height": 0.16689,
        "facings": [
          {
            "id": "4fe398662cfefa48706676ae",
            "leftCorner": {
              "x": -18.091,
              "y": -26.501,
              "z": 0.137
            },
            "rightCorner": {
              "x": -18.111,
              "y": -25.976,
              "z": 0.137
            },
            "gtin": "8000500310427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "23de3e0b63d37705a822b611",
            "leftCorner": {
              "x": -18.111,
              "y": -25.976,
              "z": 0.137
            },
            "rightCorner": {
              "x": -18.119,
              "y": -25.79,
              "z": 0.137
            },
            "gtin": "4009176103818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "60bceef76cf05bca98a2c4d1",
            "leftCorner": {
              "x": -18.119,
              "y": -25.79,
              "z": 0.137
            },
            "rightCorner": {
              "x": -18.127,
              "y": -25.573,
              "z": 0.137
            },
            "gtin": "7622210137258",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ec",
        "height": 0.45583,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d622f",
            "leftCorner": {
              "x": -18.164,
              "y": -26.504,
              "z": 0.373
            },
            "rightCorner": {
              "x": -18.174,
              "y": -26.069,
              "z": 0.373
            },
            "gtin": "4306188056409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6230",
            "leftCorner": {
              "x": -18.193,
              "y": -26.069,
              "z": 0.373
            },
            "rightCorner": {
              "x": -18.203,
              "y": -25.83,
              "z": 0.373
            },
            "gtin": "4306188056409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d622a",
            "leftCorner": {
              "x": -18.199,
              "y": -25.83,
              "z": 0.373
            },
            "rightCorner": {
              "x": -18.211,
              "y": -25.504,
              "z": 0.373
            },
            "gtin": "8000500391228",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ef",
        "height": 0.76626,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6231",
            "leftCorner": {
              "x": -18.128,
              "y": -26.503,
              "z": 0.627
            },
            "rightCorner": {
              "x": -18.152,
              "y": -25.892,
              "z": 0.627
            },
            "gtin": "4009176103818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6233",
            "leftCorner": {
              "x": -18.192,
              "y": -25.893,
              "z": 0.627
            },
            "rightCorner": {
              "x": -18.198,
              "y": -25.72,
              "z": 0.627
            },
            "gtin": "4306188363835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6232",
            "leftCorner": {
              "x": -18.191,
              "y": -25.72,
              "z": 0.627
            },
            "rightCorner": {
              "x": -18.199,
              "y": -25.504,
              "z": 0.627
            },
            "gtin": "4306188363804",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ee",
        "height": 1.0268,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61de",
            "leftCorner": {
              "x": -18.161,
              "y": -26.503,
              "z": 0.84
            },
            "rightCorner": {
              "x": -18.165,
              "y": -26.308,
              "z": 0.84
            },
            "gtin": "4008210262009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61df",
            "leftCorner": {
              "x": -18.165,
              "y": -26.308,
              "z": 0.84
            },
            "rightCorner": {
              "x": -18.17,
              "y": -26.112,
              "z": 0.84
            },
            "gtin": "4008210262009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61e0",
            "leftCorner": {
              "x": -18.187,
              "y": -26.113,
              "z": 0.84
            },
            "rightCorner": {
              "x": -18.194,
              "y": -25.932,
              "z": 0.84
            },
            "gtin": "4008210262009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61d4",
            "leftCorner": {
              "x": -18.195,
              "y": -25.932,
              "z": 0.84
            },
            "rightCorner": {
              "x": -18.212,
              "y": -25.504,
              "z": 0.84
            },
            "gtin": "7622210137258",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0f0",
        "height": 1.3329,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61ea",
            "leftCorner": {
              "x": -18.174,
              "y": -26.504,
              "z": 1.091
            },
            "rightCorner": {
              "x": -18.186,
              "y": -25.95,
              "z": 1.091
            },
            "gtin": "7622300336738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61eb",
            "leftCorner": {
              "x": -18.2,
              "y": -25.95,
              "z": 1.091
            },
            "rightCorner": {
              "x": -18.207,
              "y": -25.785,
              "z": 1.091
            },
            "gtin": "7622300336738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61e2",
            "leftCorner": {
              "x": -18.201,
              "y": -25.785,
              "z": 1.091
            },
            "rightCorner": {
              "x": -18.211,
              "y": -25.504,
              "z": 1.091
            },
            "gtin": "7622210977434",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ed",
        "height": 1.6079,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61f6",
            "leftCorner": {
              "x": -18.179,
              "y": -26.504,
              "z": 1.316
            },
            "rightCorner": {
              "x": -18.19,
              "y": -26.038,
              "z": 1.316
            },
            "gtin": "4306188035008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61ed",
            "leftCorner": {
              "x": -18.203,
              "y": -26.038,
              "z": 1.316
            },
            "rightCorner": {
              "x": -18.223,
              "y": -25.506,
              "z": 1.316
            },
            "gtin": "4306188035008",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "86b",
    "rightNeighborShelfId": "869"
  },
  {
    "id": "86b",
    "name": "86b",
    "x": -18.151,
    "y": -27.597,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71464,
      "w": 0.69949
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0eb",
        "height": 0.17628,
        "facings": [
          {
            "id": "a4b148cf6b7d7e6a2f3127fc",
            "leftCorner": {
              "x": -18.059,
              "y": -27.595,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.063,
              "y": -27.432,
              "z": 0.144
            },
            "gtin": "4017100143748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0a30d93d3dfd0456c4109f3f",
            "leftCorner": {
              "x": -18.063,
              "y": -27.432,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.066,
              "y": -27.278,
              "z": 0.144
            },
            "gtin": "4306188021902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f2aec2bd847a3eaf82e699ae",
            "leftCorner": {
              "x": -18.066,
              "y": -27.278,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.069,
              "y": -27.115,
              "z": 0.144
            },
            "gtin": "4017100143748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f2adc0541422339fcea6fae1",
            "leftCorner": {
              "x": -18.069,
              "y": -27.115,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.073,
              "y": -26.949,
              "z": 0.144
            },
            "gtin": "4006894518702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "47c624813fad0f3ee13f6551",
            "leftCorner": {
              "x": -18.073,
              "y": -26.949,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.077,
              "y": -26.74,
              "z": 0.144
            },
            "gtin": "4006894532104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f9a80694a6f2efcf957718da",
            "leftCorner": {
              "x": -18.077,
              "y": -26.74,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.082,
              "y": -26.525,
              "z": 0.144
            },
            "gtin": "4306188414964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cbe04917872dea6bc3bf2146",
            "leftCorner": {
              "x": -18.082,
              "y": -26.525,
              "z": 0.144
            },
            "rightCorner": {
              "x": -18.085,
              "y": -26.36,
              "z": 0.144
            },
            "gtin": "4006894518702",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0e8",
        "height": 0.45761,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6229",
            "leftCorner": {
              "x": -18.104,
              "y": -27.596,
              "z": 0.374
            },
            "rightCorner": {
              "x": -18.114,
              "y": -27.137,
              "z": 0.374
            },
            "gtin": "4306188056409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d622b",
            "leftCorner": {
              "x": -18.157,
              "y": -27.137,
              "z": 0.374
            },
            "rightCorner": {
              "x": -18.161,
              "y": -26.983,
              "z": 0.374
            },
            "gtin": "4306188021902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d622c",
            "leftCorner": {
              "x": -18.157,
              "y": -26.983,
              "z": 0.374
            },
            "rightCorner": {
              "x": -18.162,
              "y": -26.745,
              "z": 0.374
            },
            "gtin": "4306188353447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d622d",
            "leftCorner": {
              "x": -18.159,
              "y": -26.745,
              "z": 0.374
            },
            "rightCorner": {
              "x": -18.163,
              "y": -26.526,
              "z": 0.374
            },
            "gtin": "4306188414964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d622e",
            "leftCorner": {
              "x": -18.157,
              "y": -26.526,
              "z": 0.374
            },
            "rightCorner": {
              "x": -18.161,
              "y": -26.347,
              "z": 0.374
            },
            "gtin": "4306188353416",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0e6",
        "height": 0.75537,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6224",
            "leftCorner": {
              "x": -18.106,
              "y": -27.596,
              "z": 0.618
            },
            "rightCorner": {
              "x": -18.111,
              "y": -27.354,
              "z": 0.618
            },
            "gtin": "4017100287022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6226",
            "leftCorner": {
              "x": -18.155,
              "y": -27.354,
              "z": 0.618
            },
            "rightCorner": {
              "x": -18.159,
              "y": -27.146,
              "z": 0.618
            },
            "gtin": "4104420209640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6227",
            "leftCorner": {
              "x": -18.158,
              "y": -27.146,
              "z": 0.618
            },
            "rightCorner": {
              "x": -18.163,
              "y": -26.919,
              "z": 0.618
            },
            "gtin": "4104420053960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6228",
            "leftCorner": {
              "x": -18.158,
              "y": -26.919,
              "z": 0.618
            },
            "rightCorner": {
              "x": -18.164,
              "y": -26.638,
              "z": 0.618
            },
            "gtin": "4104420209527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6225",
            "leftCorner": {
              "x": -18.158,
              "y": -26.638,
              "z": 0.618
            },
            "rightCorner": {
              "x": -18.165,
              "y": -26.347,
              "z": 0.618
            }
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0e7",
        "height": 1.0318,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61da",
            "leftCorner": {
              "x": -18.155,
              "y": -27.368,
              "z": 0.844
            },
            "rightCorner": {
              "x": -18.158,
              "y": -27.184,
              "z": 0.844
            },
            "gtin": "4017100134012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "814c19e62f8960479318f0b9",
            "leftCorner": {
              "x": -18.103,
              "y": -27.596,
              "z": 0.844
            },
            "rightCorner": {
              "x": -18.107,
              "y": -27.389,
              "z": 0.844
            },
            "gtin": "4017100134012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61db",
            "leftCorner": {
              "x": -18.156,
              "y": -27.184,
              "z": 0.844
            },
            "rightCorner": {
              "x": -18.162,
              "y": -26.892,
              "z": 0.844
            },
            "gtin": "4017100131004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61dc",
            "leftCorner": {
              "x": -18.153,
              "y": -26.892,
              "z": 0.844
            },
            "rightCorner": {
              "x": -18.16,
              "y": -26.588,
              "z": 0.844
            },
            "gtin": "4306188038221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61dd",
            "leftCorner": {
              "x": -18.153,
              "y": -26.588,
              "z": 0.844
            },
            "rightCorner": {
              "x": -18.158,
              "y": -26.347,
              "z": 0.844
            },
            "gtin": "4306188393757",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ea",
        "height": 1.335,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61e6",
            "leftCorner": {
              "x": -18.148,
              "y": -27.519,
              "z": 1.092
            },
            "rightCorner": {
              "x": -18.153,
              "y": -27.27,
              "z": 1.092
            },
            "gtin": "4017100193927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61e7",
            "leftCorner": {
              "x": -18.155,
              "y": -27.27,
              "z": 1.092
            },
            "rightCorner": {
              "x": -18.161,
              "y": -26.974,
              "z": 1.092
            },
            "gtin": "4017100250026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61e8",
            "leftCorner": {
              "x": -18.159,
              "y": -26.974,
              "z": 1.092
            },
            "rightCorner": {
              "x": -18.165,
              "y": -26.721,
              "z": 1.092
            },
            "gtin": "4008728014947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61e9",
            "leftCorner": {
              "x": -18.164,
              "y": -26.721,
              "z": 1.092
            },
            "rightCorner": {
              "x": -18.172,
              "y": -26.347,
              "z": 1.092
            },
            "gtin": "4013392081058",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0e9",
        "height": 1.611,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61f2",
            "leftCorner": {
              "x": -18.152,
              "y": -27.341,
              "z": 1.318
            },
            "rightCorner": {
              "x": -18.16,
              "y": -27.004,
              "z": 1.318
            },
            "gtin": "4006952099518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b2febd458ad11755047097df",
            "leftCorner": {
              "x": -18.101,
              "y": -27.596,
              "z": 1.318
            },
            "rightCorner": {
              "x": -18.105,
              "y": -27.4,
              "z": 1.318
            },
            "gtin": "4017100165009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61f3",
            "leftCorner": {
              "x": -18.159,
              "y": -27.004,
              "z": 1.318
            },
            "rightCorner": {
              "x": -18.164,
              "y": -26.786,
              "z": 1.318
            },
            "gtin": "4006894532104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61f4",
            "leftCorner": {
              "x": -18.153,
              "y": -26.786,
              "z": 1.318
            },
            "rightCorner": {
              "x": -18.156,
              "y": -26.618,
              "z": 1.318
            },
            "gtin": "4006894518702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61f5",
            "leftCorner": {
              "x": -18.157,
              "y": -26.618,
              "z": 1.318
            },
            "rightCorner": {
              "x": -18.163,
              "y": -26.347,
              "z": 1.318
            },
            "gtin": "4006894512205",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "86c",
    "rightNeighborShelfId": "86a"
  },
  {
    "id": "86c",
    "name": "86c",
    "x": -18.163,
    "y": -28.602,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7117,
      "w": 0.70248
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0e5",
        "height": 0.1772,
        "facings": [
          {
            "id": "def9cce8cd875a8c0ea01aaf",
            "leftCorner": {
              "x": -18.08,
              "y": -28.601,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.084,
              "y": -28.297,
              "z": 0.145
            },
            "gtin": "4017100146015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "897166b9a636214aa84f5079",
            "leftCorner": {
              "x": -18.084,
              "y": -28.297,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.086,
              "y": -28.163,
              "z": 0.145
            },
            "gtin": "4017100133121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5f5eabb623a796a38b86257c",
            "leftCorner": {
              "x": -18.086,
              "y": -28.163,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.088,
              "y": -27.98,
              "z": 0.145
            },
            "gtin": "4017100101007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "25cad74f74869394c063dac0",
            "leftCorner": {
              "x": -18.088,
              "y": -27.98,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.091,
              "y": -27.793,
              "z": 0.145
            },
            "gtin": "4017100206009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0f3e6ddd67eee14f78754330",
            "leftCorner": {
              "x": -18.091,
              "y": -27.793,
              "z": 0.145
            },
            "rightCorner": {
              "x": -18.093,
              "y": -27.606,
              "z": 0.145
            },
            "gtin": "4017100206009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0e4",
        "height": 0.47046,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61fa",
            "leftCorner": {
              "x": -18.104,
              "y": -28.601,
              "z": 0.385
            },
            "rightCorner": {
              "x": -18.112,
              "y": -28.023,
              "z": 0.385
            },
            "gtin": "4017100138010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61fc",
            "leftCorner": {
              "x": -18.151,
              "y": -28.023,
              "z": 0.385
            },
            "rightCorner": {
              "x": -18.154,
              "y": -27.743,
              "z": 0.385
            },
            "gtin": "4017100138126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61fb",
            "leftCorner": {
              "x": -18.156,
              "y": -27.743,
              "z": 0.385
            },
            "rightCorner": {
              "x": -18.158,
              "y": -27.602,
              "z": 0.385
            },
            "gtin": "4017100133121",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0e3",
        "height": 0.77027,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61f7",
            "leftCorner": {
              "x": -18.107,
              "y": -28.601,
              "z": 0.63
            },
            "rightCorner": {
              "x": -18.113,
              "y": -28.124,
              "z": 0.63
            },
            "gtin": "4017100290008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61f9",
            "leftCorner": {
              "x": -18.153,
              "y": -28.125,
              "z": 0.63
            },
            "rightCorner": {
              "x": -18.156,
              "y": -27.876,
              "z": 0.63
            },
            "gtin": "4017100291005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61f8",
            "leftCorner": {
              "x": -18.156,
              "y": -27.876,
              "z": 0.63
            },
            "rightCorner": {
              "x": -18.16,
              "y": -27.602,
              "z": 0.63
            },
            "gtin": "4017100136009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0e0",
        "height": 1.033,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61d3",
            "leftCorner": {
              "x": -18.113,
              "y": -28.601,
              "z": 0.845
            },
            "rightCorner": {
              "x": -18.116,
              "y": -28.389,
              "z": 0.845
            },
            "gtin": "4017100365416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61d5",
            "leftCorner": {
              "x": -18.157,
              "y": -28.389,
              "z": 0.845
            },
            "rightCorner": {
              "x": -18.159,
              "y": -28.192,
              "z": 0.845
            },
            "gtin": "4017100360015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61d6",
            "leftCorner": {
              "x": -18.159,
              "y": -28.192,
              "z": 0.845
            },
            "rightCorner": {
              "x": -18.161,
              "y": -28.019,
              "z": 0.845
            },
            "gtin": "4017100206009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61d7",
            "leftCorner": {
              "x": -18.159,
              "y": -28.019,
              "z": 0.845
            },
            "rightCorner": {
              "x": -18.161,
              "y": -27.828,
              "z": 0.845
            },
            "gtin": "4017100101007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61d8",
            "leftCorner": {
              "x": -18.161,
              "y": -27.828,
              "z": 0.845
            },
            "rightCorner": {
              "x": -18.164,
              "y": -27.597,
              "z": 0.845
            },
            "gtin": "4017100225611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61d9",
            "leftCorner": {
              "x": -18.17,
              "y": -27.597,
              "z": 0.845
            },
            "rightCorner": {
              "x": -18.172,
              "y": -27.374,
              "z": 0.845
            },
            "gtin": "4017100143748",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0e1",
        "height": 1.3379,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61e1",
            "leftCorner": {
              "x": -18.108,
              "y": -28.601,
              "z": 1.095
            },
            "rightCorner": {
              "x": -18.111,
              "y": -28.338,
              "z": 1.095
            },
            "gtin": "4017100345005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61e3",
            "leftCorner": {
              "x": -18.154,
              "y": -28.339,
              "z": 1.095
            },
            "rightCorner": {
              "x": -18.158,
              "y": -28.101,
              "z": 1.095
            },
            "gtin": "4017100179006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61e4",
            "leftCorner": {
              "x": -18.155,
              "y": -28.101,
              "z": 1.095
            },
            "rightCorner": {
              "x": -18.158,
              "y": -27.821,
              "z": 1.095
            },
            "gtin": "4017100376108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61e5",
            "leftCorner": {
              "x": -18.155,
              "y": -27.821,
              "z": 1.095
            },
            "rightCorner": {
              "x": -18.16,
              "y": -27.524,
              "z": 1.095
            },
            "gtin": "4017100140921",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0e2",
        "height": 1.6124,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d61ec",
            "leftCorner": {
              "x": -18.106,
              "y": -28.601,
              "z": 1.319
            },
            "rightCorner": {
              "x": -18.109,
              "y": -28.325,
              "z": 1.319
            },
            "gtin": "4017100219900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61ee",
            "leftCorner": {
              "x": -18.152,
              "y": -28.326,
              "z": 1.319
            },
            "rightCorner": {
              "x": -18.155,
              "y": -28.108,
              "z": 1.319
            },
            "gtin": "4017100264900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61ef",
            "leftCorner": {
              "x": -18.153,
              "y": -28.108,
              "z": 1.319
            },
            "rightCorner": {
              "x": -18.156,
              "y": -27.857,
              "z": 1.319
            },
            "gtin": "4017100211003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61f0",
            "leftCorner": {
              "x": -18.155,
              "y": -27.857,
              "z": 1.319
            },
            "rightCorner": {
              "x": -18.159,
              "y": -27.598,
              "z": 1.319
            },
            "gtin": "4017100405518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d61f1",
            "leftCorner": {
              "x": -18.165,
              "y": -27.598,
              "z": 1.319
            },
            "rightCorner": {
              "x": -18.168,
              "y": -27.346,
              "z": 1.319
            },
            "gtin": "4017100165009",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "86b"
  },
  {
    "id": "87c",
    "name": "87c",
    "x": -18.472,
    "y": -16.58,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71225,
      "w": 0.70192
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 21,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d115",
        "height": 0.24924,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62c6",
            "leftCorner": {
              "x": -18.273,
              "y": -16.576,
              "z": 0.204
            },
            "rightCorner": {
              "x": -18.279,
              "y": -16.15,
              "z": 0.204
            },
            "gtin": "7613287110688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62c7",
            "leftCorner": {
              "x": -18.271,
              "y": -16.15,
              "z": 0.204
            },
            "rightCorner": {
              "x": -18.283,
              "y": -15.327,
              "z": 0.204
            },
            "gtin": "4306188408277",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d116",
        "height": 0.53506,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62c8",
            "leftCorner": {
              "x": -18.31,
              "y": -16.577,
              "z": 0.438
            },
            "rightCorner": {
              "x": -18.314,
              "y": -16.28,
              "z": 0.438
            },
            "gtin": "42395041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62ca",
            "leftCorner": {
              "x": -18.396,
              "y": -16.281,
              "z": 0.438
            },
            "rightCorner": {
              "x": -18.399,
              "y": -16.084,
              "z": 0.438
            },
            "gtin": "40345512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62cb",
            "leftCorner": {
              "x": -18.306,
              "y": -16.083,
              "z": 0.438
            },
            "rightCorner": {
              "x": -18.309,
              "y": -15.914,
              "z": 0.438
            },
            "gtin": "7613287899590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62c9",
            "leftCorner": {
              "x": -18.227,
              "y": -15.912,
              "z": 0.438
            },
            "rightCorner": {
              "x": -18.236,
              "y": -15.326,
              "z": 0.438
            },
            "gtin": "4250426217766",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d11a",
        "height": 0.76057,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62d6",
            "leftCorner": {
              "x": -18.355,
              "y": -16.578,
              "z": 0.622
            },
            "rightCorner": {
              "x": -18.36,
              "y": -16.283,
              "z": 0.622
            },
            "gtin": "4013900504499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62d8",
            "leftCorner": {
              "x": -18.395,
              "y": -16.284,
              "z": 0.622
            },
            "rightCorner": {
              "x": -18.399,
              "y": -16.086,
              "z": 0.622
            },
            "gtin": "4000843045004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62d7",
            "leftCorner": {
              "x": -18.307,
              "y": -16.084,
              "z": 0.622
            },
            "rightCorner": {
              "x": -18.317,
              "y": -15.327,
              "z": 0.622
            },
            "gtin": "4306188034971",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d11b",
        "height": 0.98643,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62d9",
            "leftCorner": {
              "x": -18.326,
              "y": -16.577,
              "z": 0.807
            },
            "rightCorner": {
              "x": -18.334,
              "y": -16.076,
              "z": 0.807
            },
            "gtin": "4014400933642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62da",
            "leftCorner": {
              "x": -18.297,
              "y": -16.075,
              "z": 0.807
            },
            "rightCorner": {
              "x": -18.308,
              "y": -15.327,
              "z": 0.807
            },
            "gtin": "4014400933659",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d117",
        "height": 1.2151,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62cc",
            "leftCorner": {
              "x": -18.305,
              "y": -16.577,
              "z": 0.994
            },
            "rightCorner": {
              "x": -18.311,
              "y": -16.17,
              "z": 0.994
            },
            "gtin": "4000281348514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62ce",
            "leftCorner": {
              "x": -18.346,
              "y": -16.171,
              "z": 0.994
            },
            "rightCorner": {
              "x": -18.35,
              "y": -15.939,
              "z": 0.994
            },
            "gtin": "4000281312508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62cd",
            "leftCorner": {
              "x": -18.244,
              "y": -15.937,
              "z": 0.994
            },
            "rightCorner": {
              "x": -18.253,
              "y": -15.327,
              "z": 0.994
            },
            "gtin": "4000281349504",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d119",
        "height": 1.4433,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62d2",
            "leftCorner": {
              "x": -18.328,
              "y": -16.578,
              "z": 1.181
            },
            "rightCorner": {
              "x": -18.331,
              "y": -16.296,
              "z": 1.181
            },
            "gtin": "5000159571586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62d4",
            "leftCorner": {
              "x": -18.397,
              "y": -16.296,
              "z": 1.181
            },
            "rightCorner": {
              "x": -18.4,
              "y": -16.167,
              "z": 1.181
            },
            "gtin": "5000159571548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62d5",
            "leftCorner": {
              "x": -18.34,
              "y": -16.166,
              "z": 1.181
            },
            "rightCorner": {
              "x": -18.343,
              "y": -15.958,
              "z": 1.181
            },
            "gtin": "5000159454346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62d3",
            "leftCorner": {
              "x": -18.245,
              "y": -15.957,
              "z": 1.181
            },
            "rightCorner": {
              "x": -18.253,
              "y": -15.326,
              "z": 1.181
            },
            "gtin": "5000159561723",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d118",
        "height": 1.692,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62cf",
            "leftCorner": {
              "x": -18.299,
              "y": -16.577,
              "z": 1.384
            },
            "rightCorner": {
              "x": -18.305,
              "y": -16.153,
              "z": 1.384
            },
            "gtin": "4014400934045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62d1",
            "leftCorner": {
              "x": -18.34,
              "y": -16.154,
              "z": 1.384
            },
            "rightCorner": {
              "x": -18.344,
              "y": -15.953,
              "z": 1.384
            },
            "gtin": "8000500289877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62d0",
            "leftCorner": {
              "x": -18.25,
              "y": -15.952,
              "z": 1.384
            },
            "rightCorner": {
              "x": -18.258,
              "y": -15.326,
              "z": 1.384
            },
            "gtin": "4008400621920",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "87d",
    "name": "87d",
    "x": -18.588,
    "y": -13.725,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70648,
      "w": 0.70774
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 43,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d121",
        "height": 0.24313,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6303",
            "leftCorner": {
              "x": -18.477,
              "y": -13.725,
              "z": 0.199
            },
            "rightCorner": {
              "x": -18.476,
              "y": -13.125,
              "z": 0.199
            },
            "gtin": "80310891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6305",
            "leftCorner": {
              "x": -18.509,
              "y": -13.126,
              "z": 0.199
            },
            "rightCorner": {
              "x": -18.509,
              "y": -12.776,
              "z": 0.199
            },
            "gtin": "5996071682755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6304",
            "leftCorner": {
              "x": -18.522,
              "y": -12.776,
              "z": 0.199
            },
            "rightCorner": {
              "x": -18.521,
              "y": -12.475,
              "z": 0.199
            },
            "gtin": "4021155179737",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d11c",
        "height": 0.50353,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62db",
            "leftCorner": {
              "x": -18.529,
              "y": -13.725,
              "z": 0.412
            },
            "rightCorner": {
              "x": -18.529,
              "y": -13.551,
              "z": 0.412
            },
            "gtin": "3587361049802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62dd",
            "leftCorner": {
              "x": -18.562,
              "y": -13.552,
              "z": 0.412
            },
            "rightCorner": {
              "x": -18.561,
              "y": -13.369,
              "z": 0.412
            },
            "gtin": "5996071707700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62de",
            "leftCorner": {
              "x": -18.563,
              "y": -13.369,
              "z": 0.412
            },
            "rightCorner": {
              "x": -18.564,
              "y": -13.233,
              "z": 0.412
            },
            "gtin": "4260519037027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62df",
            "leftCorner": {
              "x": -18.568,
              "y": -13.233,
              "z": 0.412
            },
            "rightCorner": {
              "x": -18.567,
              "y": -13.105,
              "z": 0.412
            },
            "gtin": "4260519037010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62e0",
            "leftCorner": {
              "x": -18.568,
              "y": -13.105,
              "z": 0.412
            },
            "rightCorner": {
              "x": -18.568,
              "y": -12.949,
              "z": 0.412
            },
            "gtin": "3116740015536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62e1",
            "leftCorner": {
              "x": -18.57,
              "y": -12.949,
              "z": 0.412
            },
            "rightCorner": {
              "x": -18.57,
              "y": -12.818,
              "z": 0.412
            },
            "gtin": "4012340000011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62e2",
            "leftCorner": {
              "x": -18.572,
              "y": -12.818,
              "z": 0.412
            },
            "rightCorner": {
              "x": -18.572,
              "y": -12.648,
              "z": 0.412
            },
            "gtin": "9002859048128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62dc",
            "leftCorner": {
              "x": -18.58,
              "y": -12.648,
              "z": 0.412
            },
            "rightCorner": {
              "x": -18.579,
              "y": -12.475,
              "z": 0.412
            },
            "gtin": "6939495522886",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d11f",
        "height": 0.80394,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62f4",
            "leftCorner": {
              "x": -18.532,
              "y": -13.725,
              "z": 0.658
            },
            "rightCorner": {
              "x": -18.532,
              "y": -13.492,
              "z": 0.658
            },
            "gtin": "8713763523496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62f6",
            "leftCorner": {
              "x": -18.563,
              "y": -13.492,
              "z": 0.658
            },
            "rightCorner": {
              "x": -18.562,
              "y": -13.315,
              "z": 0.658
            },
            "gtin": "8410031953893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62f7",
            "leftCorner": {
              "x": -18.566,
              "y": -13.315,
              "z": 0.658
            },
            "rightCorner": {
              "x": -18.566,
              "y": -13.201,
              "z": 0.658
            },
            "gtin": "9001643201633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62f8",
            "leftCorner": {
              "x": -18.567,
              "y": -13.201,
              "z": 0.658
            },
            "rightCorner": {
              "x": -18.567,
              "y": -13.049,
              "z": 0.658
            },
            "gtin": "5011061170415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62f9",
            "leftCorner": {
              "x": -18.57,
              "y": -13.049,
              "z": 0.658
            },
            "rightCorner": {
              "x": -18.571,
              "y": -12.892,
              "z": 0.658
            },
            "gtin": "5011061115737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62fa",
            "leftCorner": {
              "x": -18.575,
              "y": -12.892,
              "z": 0.658
            },
            "rightCorner": {
              "x": -18.575,
              "y": -12.754,
              "z": 0.658
            },
            "gtin": "5011061115768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62fb",
            "leftCorner": {
              "x": -18.577,
              "y": -12.754,
              "z": 0.658
            },
            "rightCorner": {
              "x": -18.576,
              "y": -12.611,
              "z": 0.658
            },
            "gtin": "5011061115751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62f5",
            "leftCorner": {
              "x": -18.581,
              "y": -12.611,
              "z": 0.658
            },
            "rightCorner": {
              "x": -18.58,
              "y": -12.475,
              "z": 0.658
            },
            "gtin": "5011061115720",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d120",
        "height": 1.0796,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62fc",
            "leftCorner": {
              "x": -18.53,
              "y": -13.725,
              "z": 0.883
            },
            "rightCorner": {
              "x": -18.53,
              "y": -13.416,
              "z": 0.883
            },
            "gtin": "5011061105011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62fe",
            "leftCorner": {
              "x": -18.564,
              "y": -13.417,
              "z": 0.883
            },
            "rightCorner": {
              "x": -18.563,
              "y": -13.292,
              "z": 0.883
            },
            "gtin": "84196842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62ff",
            "leftCorner": {
              "x": -18.567,
              "y": -13.292,
              "z": 0.883
            },
            "rightCorner": {
              "x": -18.567,
              "y": -13.155,
              "z": 0.883
            },
            "gtin": "84460554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6300",
            "leftCorner": {
              "x": -18.57,
              "y": -13.155,
              "z": 0.883
            },
            "rightCorner": {
              "x": -18.57,
              "y": -13.033,
              "z": 0.883
            },
            "gtin": "5011061105042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6301",
            "leftCorner": {
              "x": -18.568,
              "y": -13.033,
              "z": 0.883
            },
            "rightCorner": {
              "x": -18.568,
              "y": -12.782,
              "z": 0.883
            },
            "gtin": "5011061105066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6302",
            "leftCorner": {
              "x": -18.574,
              "y": -12.782,
              "z": 0.883
            },
            "rightCorner": {
              "x": -18.574,
              "y": -12.643,
              "z": 0.883
            },
            "gtin": "8713763523601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62fd",
            "leftCorner": {
              "x": -18.58,
              "y": -12.643,
              "z": 0.883
            },
            "rightCorner": {
              "x": -18.579,
              "y": -12.475,
              "z": 0.883
            },
            "gtin": "5996071643725",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d11d",
        "height": 1.4096,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62e3",
            "leftCorner": {
              "x": -18.526,
              "y": -13.725,
              "z": 1.153
            },
            "rightCorner": {
              "x": -18.526,
              "y": -13.553,
              "z": 1.153
            },
            "gtin": "5011053025891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62e5",
            "leftCorner": {
              "x": -18.554,
              "y": -13.553,
              "z": 1.153
            },
            "rightCorner": {
              "x": -18.554,
              "y": -13.409,
              "z": 1.153
            },
            "gtin": "5011053022272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62e6",
            "leftCorner": {
              "x": -18.557,
              "y": -13.409,
              "z": 1.153
            },
            "rightCorner": {
              "x": -18.557,
              "y": -13.358,
              "z": 1.153
            },
            "gtin": "5011053013591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62e7",
            "leftCorner": {
              "x": -18.557,
              "y": -13.358,
              "z": 1.153
            },
            "rightCorner": {
              "x": -18.556,
              "y": -13.306,
              "z": 1.153
            },
            "gtin": "5011053013591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62e8",
            "leftCorner": {
              "x": -18.556,
              "y": -13.306,
              "z": 1.153
            },
            "rightCorner": {
              "x": -18.556,
              "y": -13.255,
              "z": 1.153
            },
            "gtin": "5011053013591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62e9",
            "leftCorner": {
              "x": -18.561,
              "y": -13.256,
              "z": 1.153
            },
            "rightCorner": {
              "x": -18.561,
              "y": -13.098,
              "z": 1.153
            },
            "gtin": "4004641021017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62ea",
            "leftCorner": {
              "x": -18.565,
              "y": -13.099,
              "z": 1.153
            },
            "rightCorner": {
              "x": -18.565,
              "y": -12.954,
              "z": 1.153
            },
            "gtin": "5011061106063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62eb",
            "leftCorner": {
              "x": -18.569,
              "y": -12.954,
              "z": 1.153
            },
            "rightCorner": {
              "x": -18.569,
              "y": -12.813,
              "z": 1.153
            },
            "gtin": "8713763543722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62ec",
            "leftCorner": {
              "x": -18.571,
              "y": -12.813,
              "z": 1.153
            },
            "rightCorner": {
              "x": -18.57,
              "y": -12.657,
              "z": 1.153
            },
            "gtin": "6939495514218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62e4",
            "leftCorner": {
              "x": -18.579,
              "y": -12.657,
              "z": 1.153
            },
            "rightCorner": {
              "x": -18.579,
              "y": -12.475,
              "z": 1.153
            },
            "gtin": "3587361043176",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d11e",
        "height": 1.6836,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d62ed",
            "leftCorner": {
              "x": -18.533,
              "y": -13.725,
              "z": 1.378
            },
            "rightCorner": {
              "x": -18.533,
              "y": -13.49,
              "z": 1.378
            },
            "gtin": "5011061192523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62ef",
            "leftCorner": {
              "x": -18.556,
              "y": -13.49,
              "z": 1.378
            },
            "rightCorner": {
              "x": -18.555,
              "y": -13.221,
              "z": 1.378
            },
            "gtin": "8435124855052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62f0",
            "leftCorner": {
              "x": -18.566,
              "y": -13.221,
              "z": 1.378
            },
            "rightCorner": {
              "x": -18.565,
              "y": -13.077,
              "z": 1.378
            },
            "gtin": "5011061106049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62f1",
            "leftCorner": {
              "x": -18.569,
              "y": -13.077,
              "z": 1.378
            },
            "rightCorner": {
              "x": -18.569,
              "y": -12.918,
              "z": 1.378
            },
            "gtin": "6939495514157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62f2",
            "leftCorner": {
              "x": -18.574,
              "y": -12.918,
              "z": 1.378
            },
            "rightCorner": {
              "x": -18.574,
              "y": -12.763,
              "z": 1.378
            },
            "gtin": "6939495509740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62f3",
            "leftCorner": {
              "x": -18.58,
              "y": -12.763,
              "z": 1.378
            },
            "rightCorner": {
              "x": -18.579,
              "y": -12.639,
              "z": 1.378
            },
            "gtin": "3587361049796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d62ee",
            "leftCorner": {
              "x": -18.585,
              "y": -12.639,
              "z": 1.378
            },
            "rightCorner": {
              "x": -18.584,
              "y": -12.475,
              "z": 1.378
            },
            "gtin": "4004641021154",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "87e",
    "name": "87e",
    "x": -18.642,
    "y": -10.504,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70955,
      "w": 0.70465
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 17,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d122",
        "height": 0.52361,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6306",
            "leftCorner": {
              "x": -18.592,
              "y": -10.505,
              "z": 0.428
            },
            "rightCorner": {
              "x": -18.593,
              "y": -10.27,
              "z": 0.428
            },
            "gtin": "4014400933642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6307",
            "leftCorner": {
              "x": -18.593,
              "y": -10.27,
              "z": 0.428
            },
            "rightCorner": {
              "x": -18.595,
              "y": -10.035,
              "z": 0.428
            },
            "gtin": "4014400933642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6308",
            "leftCorner": {
              "x": -18.595,
              "y": -10.035,
              "z": 0.428
            },
            "rightCorner": {
              "x": -18.596,
              "y": -9.8,
              "z": 0.428
            },
            "gtin": "4014400933642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6309",
            "leftCorner": {
              "x": -18.636,
              "y": -9.801,
              "z": 0.428
            },
            "rightCorner": {
              "x": -18.639,
              "y": -9.528,
              "z": 0.428
            },
            "gtin": "4014400934045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d630a",
            "leftCorner": {
              "x": -18.639,
              "y": -9.528,
              "z": 0.428
            },
            "rightCorner": {
              "x": -18.641,
              "y": -9.254,
              "z": 0.428
            },
            "gtin": "4014400934045",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d125",
        "height": 0.83097,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d630f",
            "leftCorner": {
              "x": -18.589,
              "y": -10.505,
              "z": 0.68
            },
            "rightCorner": {
              "x": -18.594,
              "y": -9.777,
              "z": 0.68
            },
            "gtin": "8445290339492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6310",
            "leftCorner": {
              "x": -18.634,
              "y": -9.777,
              "z": 0.68
            },
            "rightCorner": {
              "x": -18.638,
              "y": -9.254,
              "z": 0.68
            },
            "gtin": "7613287633354",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d123",
        "height": 1.135,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d630b",
            "leftCorner": {
              "x": -18.587,
              "y": -10.505,
              "z": 0.929
            },
            "rightCorner": {
              "x": -18.591,
              "y": -9.953,
              "z": 0.929
            },
            "gtin": "5000159571586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d630c",
            "leftCorner": {
              "x": -18.63,
              "y": -9.953,
              "z": 0.929
            },
            "rightCorner": {
              "x": -18.636,
              "y": -9.254,
              "z": 0.929
            },
            "gtin": "5000159571586",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d124",
        "height": 1.4167,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d630d",
            "leftCorner": {
              "x": -18.584,
              "y": -10.504,
              "z": 1.159
            },
            "rightCorner": {
              "x": -18.586,
              "y": -10.288,
              "z": 1.159
            },
            "gtin": "4008400163826",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d630e",
            "leftCorner": {
              "x": -18.626,
              "y": -10.288,
              "z": 1.159
            },
            "rightCorner": {
              "x": -18.633,
              "y": -9.254,
              "z": 1.159
            },
            "gtin": "4008400163826",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d126",
        "height": 1.6829,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6313",
            "leftCorner": {
              "x": -18.643,
              "y": -9.461,
              "z": 1.377
            },
            "rightCorner": {
              "x": -18.645,
              "y": -9.255,
              "z": 1.377
            },
            "gtin": "4008400221021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3f108321c08d29937fd4c146",
            "leftCorner": {
              "x": -18.595,
              "y": -10.505,
              "z": 1.377
            },
            "rightCorner": {
              "x": -18.596,
              "y": -10.304,
              "z": 1.377
            },
            "gtin": "4008400221021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3d9910f16addb911845cf69d",
            "leftCorner": {
              "x": -18.596,
              "y": -10.304,
              "z": 1.377
            },
            "rightCorner": {
              "x": -18.598,
              "y": -10.104,
              "z": 1.377
            },
            "gtin": "4008400221021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4874494a1c95451f3f1a6114",
            "leftCorner": {
              "x": -18.598,
              "y": -10.104,
              "z": 1.377
            },
            "rightCorner": {
              "x": -18.599,
              "y": -9.903,
              "z": 1.377
            },
            "gtin": "4008400221021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d95cf27a519e0503ea65c476",
            "leftCorner": {
              "x": -18.599,
              "y": -9.903,
              "z": 1.377
            },
            "rightCorner": {
              "x": -18.601,
              "y": -9.703,
              "z": 1.377
            },
            "gtin": "4008400221021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "87e7997d334f5cd43f5dbc7f",
            "leftCorner": {
              "x": -18.601,
              "y": -9.703,
              "z": 1.377
            },
            "rightCorner": {
              "x": -18.602,
              "y": -9.502,
              "z": 1.377
            },
            "gtin": "4008400221021",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "87f",
    "name": "87f",
    "x": -20.636,
    "y": -45.073,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70744,
      "w": 0.70677
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 35
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d69d",
        "height": 0.16745,
        "facings": [
          {
            "id": "3e6882b0a6c716472100ea6e",
            "leftCorner": {
              "x": -20.552,
              "y": -45.073,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.552,
              "y": -44.97,
              "z": 0.137
            },
            "gtin": "8008698031018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bcd313666a12b2239338a9c8",
            "leftCorner": {
              "x": -20.552,
              "y": -44.97,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.552,
              "y": -44.865,
              "z": 0.137
            },
            "gtin": "8008698040966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "130349bbf567d290197dc3e2",
            "leftCorner": {
              "x": -20.552,
              "y": -44.865,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.552,
              "y": -44.758,
              "z": 0.137
            },
            "gtin": "8008698027400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b39a368f56f2d506ef23f031",
            "leftCorner": {
              "x": -20.552,
              "y": -44.758,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.552,
              "y": -44.63,
              "z": 0.137
            },
            "gtin": "8008698003152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ba062e1e87b07a3e9d89b7d4",
            "leftCorner": {
              "x": -20.552,
              "y": -44.63,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.552,
              "y": -44.499,
              "z": 0.137
            },
            "gtin": "8008698040126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "10ca95742295105385860af8",
            "leftCorner": {
              "x": -20.552,
              "y": -44.499,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.553,
              "y": -44.368,
              "z": 0.137
            },
            "gtin": "8008698004548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8fcf662fc2ff3b423fa28e36",
            "leftCorner": {
              "x": -20.553,
              "y": -44.368,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.553,
              "y": -44.236,
              "z": 0.137
            },
            "gtin": "8008698038543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9e2dcca1043b8c986e5a4f01",
            "leftCorner": {
              "x": -20.553,
              "y": -44.236,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.553,
              "y": -44.077,
              "z": 0.137
            },
            "gtin": "8008698003213",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d69b",
        "height": 0.48424,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d60a7",
            "leftCorner": {
              "x": -20.615,
              "y": -44.878,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.616,
              "y": -44.709,
              "z": 0.396
            },
            "gtin": "8008698004586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60a8",
            "leftCorner": {
              "x": -20.624,
              "y": -44.709,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.624,
              "y": -44.414,
              "z": 0.396
            },
            "gtin": "8008698011683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60a9",
            "leftCorner": {
              "x": -20.626,
              "y": -44.414,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.627,
              "y": -44.311,
              "z": 0.396
            },
            "gtin": "8008698031018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60aa",
            "leftCorner": {
              "x": -20.629,
              "y": -44.311,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.628,
              "y": -44.204,
              "z": 0.396
            },
            "gtin": "8008698040966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d609a",
            "leftCorner": {
              "x": -20.63,
              "y": -44.204,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.631,
              "y": -44.073,
              "z": 0.396
            },
            "gtin": "8008698004548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4c65285fb7168641fe8d3f24",
            "leftCorner": {
              "x": -20.586,
              "y": -45.073,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.586,
              "y": -44.902,
              "z": 0.396
            },
            "gtin": "8008698004586",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d69c",
        "height": 0.79682,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6092",
            "leftCorner": {
              "x": -20.624,
              "y": -44.981,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.623,
              "y": -44.81,
              "z": 0.652
            },
            "gtin": "8008698009024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6093",
            "leftCorner": {
              "x": -20.629,
              "y": -44.81,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.629,
              "y": -44.553,
              "z": 0.652
            },
            "gtin": "8008698005491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6094",
            "leftCorner": {
              "x": -20.635,
              "y": -44.553,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.635,
              "y": -44.409,
              "z": 0.652
            },
            "gtin": "8008698004630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6095",
            "leftCorner": {
              "x": -20.637,
              "y": -44.409,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.638,
              "y": -44.279,
              "z": 0.652
            },
            "gtin": "8008698040126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6096",
            "leftCorner": {
              "x": -20.641,
              "y": -44.279,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.641,
              "y": -44.129,
              "z": 0.652
            },
            "gtin": "8008698005286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6082",
            "leftCorner": {
              "x": -20.642,
              "y": -44.129,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.643,
              "y": -44.073,
              "z": 0.652
            },
            "gtin": "8008698026281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a792afc33d3948eea9fba3d1",
            "leftCorner": {
              "x": -20.596,
              "y": -45.073,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.596,
              "y": -45.021,
              "z": 0.652
            },
            "gtin": "8008698026281",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d699",
        "height": 1.0974,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6036",
            "leftCorner": {
              "x": -20.625,
              "y": -44.904,
              "z": 0.898
            },
            "rightCorner": {
              "x": -20.625,
              "y": -44.481,
              "z": 0.898
            },
            "gtin": "8008698004838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6021",
            "leftCorner": {
              "x": -20.633,
              "y": -44.481,
              "z": 0.898
            },
            "rightCorner": {
              "x": -20.634,
              "y": -44.073,
              "z": 0.898
            },
            "gtin": "8008698004869",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d69a",
        "height": 1.3522,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d607e",
            "leftCorner": {
              "x": -20.62,
              "y": -44.883,
              "z": 1.106
            },
            "rightCorner": {
              "x": -20.62,
              "y": -44.698,
              "z": 1.106
            },
            "gtin": "8008698047736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d607f",
            "leftCorner": {
              "x": -20.628,
              "y": -44.698,
              "z": 1.106
            },
            "rightCorner": {
              "x": -20.628,
              "y": -44.534,
              "z": 1.106
            },
            "gtin": "8008698022214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6080",
            "leftCorner": {
              "x": -20.629,
              "y": -44.534,
              "z": 1.106
            },
            "rightCorner": {
              "x": -20.63,
              "y": -44.282,
              "z": 1.106
            },
            "gtin": "8008698028315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6063",
            "leftCorner": {
              "x": -20.631,
              "y": -44.282,
              "z": 1.106
            },
            "rightCorner": {
              "x": -20.631,
              "y": -44.073,
              "z": 1.106
            },
            "gtin": "8008698043479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d1e2e20ed5420d088329ad98",
            "leftCorner": {
              "x": -20.588,
              "y": -45.073,
              "z": 1.106
            },
            "rightCorner": {
              "x": -20.588,
              "y": -44.891,
              "z": 1.106
            },
            "gtin": "8008698047736",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d698",
        "height": 1.6021,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d605b",
            "leftCorner": {
              "x": -20.617,
              "y": -45.044,
              "z": 1.311
            },
            "rightCorner": {
              "x": -20.617,
              "y": -44.917,
              "z": 1.311
            },
            "gtin": "8008698027400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1eb1945934342e4d56e06560",
            "leftCorner": {
              "x": -20.591,
              "y": -44.196,
              "z": 1.311
            },
            "rightCorner": {
              "x": -20.591,
              "y": -44.089,
              "z": 1.311
            },
            "gtin": "8008698027400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d605c",
            "leftCorner": {
              "x": -20.618,
              "y": -44.917,
              "z": 1.311
            },
            "rightCorner": {
              "x": -20.618,
              "y": -44.797,
              "z": 1.311
            },
            "gtin": "8008698027424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d605d",
            "leftCorner": {
              "x": -20.625,
              "y": -44.797,
              "z": 1.311
            },
            "rightCorner": {
              "x": -20.624,
              "y": -44.648,
              "z": 1.311
            },
            "gtin": "8008698003213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d605e",
            "leftCorner": {
              "x": -20.627,
              "y": -44.648,
              "z": 1.311
            },
            "rightCorner": {
              "x": -20.627,
              "y": -44.525,
              "z": 1.311
            },
            "gtin": "8008698003152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d605f",
            "leftCorner": {
              "x": -20.63,
              "y": -44.525,
              "z": 1.311
            },
            "rightCorner": {
              "x": -20.631,
              "y": -44.327,
              "z": 1.311
            },
            "gtin": "8008698010259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6060",
            "leftCorner": {
              "x": -20.634,
              "y": -44.327,
              "z": 1.311
            },
            "rightCorner": {
              "x": -20.635,
              "y": -44.196,
              "z": 1.311
            },
            "gtin": "8008698038543",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "880"
  },
  {
    "id": "880",
    "name": "880",
    "x": -20.636,
    "y": -46.073,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70744,
      "w": 0.70677
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 35
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0b5",
        "height": 0.1677,
        "facings": [
          {
            "id": "fbaa20be5a7d897588ff266a",
            "leftCorner": {
              "x": -20.553,
              "y": -46.072,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.553,
              "y": -45.983,
              "z": 0.137
            },
            "gtin": "4002971355802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "010143c7270556f21b4adbe6",
            "leftCorner": {
              "x": -20.553,
              "y": -45.983,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.553,
              "y": -45.911,
              "z": 0.137
            },
            "gtin": "8008698007303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "60e2857aecc799dc127366ea",
            "leftCorner": {
              "x": -20.553,
              "y": -45.911,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.553,
              "y": -45.827,
              "z": 0.137
            },
            "gtin": "4002971356809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a9660936929073d569e48a06",
            "leftCorner": {
              "x": -20.553,
              "y": -45.827,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.553,
              "y": -45.738,
              "z": 0.137
            },
            "gtin": "4002971355802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "87756235400e860887724c3d",
            "leftCorner": {
              "x": -20.553,
              "y": -45.738,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.553,
              "y": -45.64,
              "z": 0.137
            },
            "gtin": "9019100675101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "746fcf4c982b6b18c82a6783",
            "leftCorner": {
              "x": -20.553,
              "y": -45.64,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.554,
              "y": -45.532,
              "z": 0.137
            },
            "gtin": "8008698012857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e53a760b3d3e2f2dec481cec",
            "leftCorner": {
              "x": -20.554,
              "y": -45.532,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.554,
              "y": -45.424,
              "z": 0.137
            },
            "gtin": "4002971356601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "801d002e543540313c8c0da5",
            "leftCorner": {
              "x": -20.554,
              "y": -45.424,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.554,
              "y": -45.296,
              "z": 0.137
            },
            "gtin": "5060495114847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a164a8f645963ffce24e1a31",
            "leftCorner": {
              "x": -20.554,
              "y": -45.296,
              "z": 0.137
            },
            "rightCorner": {
              "x": -20.554,
              "y": -45.097,
              "z": 0.137
            },
            "gtin": "4012712010402",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0b3",
        "height": 0.48436,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d60a2",
            "leftCorner": {
              "x": -20.608,
              "y": -46.017,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.608,
              "y": -45.906,
              "z": 0.396
            },
            "gtin": "4012712010921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60a3",
            "leftCorner": {
              "x": -20.608,
              "y": -45.906,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.608,
              "y": -45.794,
              "z": 0.396
            },
            "gtin": "4012712010921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60a4",
            "leftCorner": {
              "x": -20.605,
              "y": -45.795,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.605,
              "y": -45.628,
              "z": 0.396
            },
            "gtin": "4012712010303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60a5",
            "leftCorner": {
              "x": -20.608,
              "y": -45.628,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.609,
              "y": -45.427,
              "z": 0.396
            },
            "gtin": "4012712010402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60a6",
            "leftCorner": {
              "x": -20.613,
              "y": -45.427,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.614,
              "y": -44.878,
              "z": 0.396
            },
            "gtin": "8076809545440",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0b4",
        "height": 0.79492,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d608d",
            "leftCorner": {
              "x": -20.619,
              "y": -46.011,
              "z": 0.65
            },
            "rightCorner": {
              "x": -20.619,
              "y": -45.839,
              "z": 0.65
            },
            "gtin": "4002971320305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d608e",
            "leftCorner": {
              "x": -20.619,
              "y": -45.839,
              "z": 0.65
            },
            "rightCorner": {
              "x": -20.62,
              "y": -45.569,
              "z": 0.65
            },
            "gtin": "4002971320503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d608f",
            "leftCorner": {
              "x": -20.62,
              "y": -45.569,
              "z": 0.65
            },
            "rightCorner": {
              "x": -20.619,
              "y": -45.469,
              "z": 0.65
            },
            "gtin": "9019100675101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6090",
            "leftCorner": {
              "x": -20.624,
              "y": -45.469,
              "z": 0.65
            },
            "rightCorner": {
              "x": -20.625,
              "y": -45.356,
              "z": 0.65
            },
            "gtin": "8008698012857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6091",
            "leftCorner": {
              "x": -20.627,
              "y": -45.356,
              "z": 0.65
            },
            "rightCorner": {
              "x": -20.628,
              "y": -44.981,
              "z": 0.65
            },
            "gtin": "8008698023723",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0b2",
        "height": 1.0976,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6030",
            "leftCorner": {
              "x": -20.614,
              "y": -45.872,
              "z": 0.898
            },
            "rightCorner": {
              "x": -20.614,
              "y": -45.776,
              "z": 0.898
            },
            "gtin": "4002971356809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "df671ee602b3cffc69b23006",
            "leftCorner": {
              "x": -20.578,
              "y": -46.073,
              "z": 0.898
            },
            "rightCorner": {
              "x": -20.578,
              "y": -45.955,
              "z": 0.898
            },
            "gtin": "8008698013113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2e67c1711d27d579ab2e68ed",
            "leftCorner": {
              "x": -20.578,
              "y": -45.664,
              "z": 0.898
            },
            "rightCorner": {
              "x": -20.578,
              "y": -45.545,
              "z": 0.898
            },
            "gtin": "8008698013113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6031",
            "leftCorner": {
              "x": -20.613,
              "y": -45.776,
              "z": 0.898
            },
            "rightCorner": {
              "x": -20.613,
              "y": -45.664,
              "z": 0.898
            },
            "gtin": "4002971356601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6034",
            "leftCorner": {
              "x": -20.624,
              "y": -45.487,
              "z": 0.898
            },
            "rightCorner": {
              "x": -20.624,
              "y": -45.186,
              "z": 0.898
            },
            "gtin": "8008698004753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6035",
            "leftCorner": {
              "x": -20.626,
              "y": -45.186,
              "z": 0.898
            },
            "rightCorner": {
              "x": -20.626,
              "y": -44.905,
              "z": 0.898
            },
            "gtin": "8008698013113",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0b1",
        "height": 1.3507,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6078",
            "leftCorner": {
              "x": -20.61,
              "y": -46.045,
              "z": 1.105
            },
            "rightCorner": {
              "x": -20.61,
              "y": -45.901,
              "z": 1.105
            },
            "gtin": "4260556635491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6079",
            "leftCorner": {
              "x": -20.612,
              "y": -45.902,
              "z": 1.105
            },
            "rightCorner": {
              "x": -20.612,
              "y": -45.76,
              "z": 1.105
            },
            "gtin": "4260556635521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d607a",
            "leftCorner": {
              "x": -20.609,
              "y": -45.76,
              "z": 1.105
            },
            "rightCorner": {
              "x": -20.609,
              "y": -45.612,
              "z": 1.105
            },
            "gtin": "4260556635583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d607b",
            "leftCorner": {
              "x": -20.613,
              "y": -45.611,
              "z": 1.105
            },
            "rightCorner": {
              "x": -20.613,
              "y": -45.468,
              "z": 1.105
            },
            "gtin": "4260556635439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d607c",
            "leftCorner": {
              "x": -20.615,
              "y": -45.469,
              "z": 1.105
            },
            "rightCorner": {
              "x": -20.616,
              "y": -45.135,
              "z": 1.105
            },
            "gtin": "8008698011294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d607d",
            "leftCorner": {
              "x": -20.624,
              "y": -45.136,
              "z": 1.105
            },
            "rightCorner": {
              "x": -20.624,
              "y": -44.883,
              "z": 1.105
            },
            "gtin": "8008698007303",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0b0",
        "height": 1.6002,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6055",
            "leftCorner": {
              "x": -20.613,
              "y": -45.962,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.613,
              "y": -45.841,
              "z": 1.309
            },
            "gtin": "5060495114847",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "86327898d1c65d82ecb74bc6",
            "leftCorner": {
              "x": -20.578,
              "y": -45.361,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.578,
              "y": -45.221,
              "z": 1.309
            },
            "gtin": "8008698029060",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6056",
            "leftCorner": {
              "x": -20.621,
              "y": -45.841,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.621,
              "y": -45.695,
              "z": 1.309
            },
            "gtin": "5060495114830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6057",
            "leftCorner": {
              "x": -20.611,
              "y": -45.695,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.611,
              "y": -45.545,
              "z": 1.309
            },
            "gtin": "5060495114854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6058",
            "leftCorner": {
              "x": -20.612,
              "y": -45.545,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.613,
              "y": -45.361,
              "z": 1.309
            },
            "gtin": "8008698039397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d605a",
            "leftCorner": {
              "x": -20.622,
              "y": -45.221,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.623,
              "y": -45.045,
              "z": 1.309
            },
            "gtin": "8008698029060",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "881",
    "rightNeighborShelfId": "87f"
  },
  {
    "id": "881",
    "name": "881",
    "x": -20.635,
    "y": -47.073,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70744,
      "w": 0.70677
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0af",
        "height": 0.16679,
        "facings": [
          {
            "id": "50529a727f636f03f8a40772",
            "leftCorner": {
              "x": -20.55,
              "y": -47.074,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.55,
              "y": -46.993,
              "z": 0.136
            },
            "gtin": "4104420222533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4cd04773e0d8a1e1120afa46",
            "leftCorner": {
              "x": -20.55,
              "y": -46.993,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.55,
              "y": -46.899,
              "z": 0.136
            },
            "gtin": "4104420222441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6ba2919b4eddde8ed2f9899f",
            "leftCorner": {
              "x": -20.55,
              "y": -46.899,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.55,
              "y": -46.803,
              "z": 0.136
            },
            "gtin": "4012712010280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2e7eeb44f354fc9df49c241f",
            "leftCorner": {
              "x": -20.55,
              "y": -46.803,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.55,
              "y": -46.688,
              "z": 0.136
            },
            "gtin": "3800233781236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0233de85d42c2277a7061f5f",
            "leftCorner": {
              "x": -20.55,
              "y": -46.688,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.55,
              "y": -46.567,
              "z": 0.136
            },
            "gtin": "4260556635460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c9687784bb09826b97796150",
            "leftCorner": {
              "x": -20.55,
              "y": -46.567,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.551,
              "y": -46.443,
              "z": 0.136
            },
            "gtin": "4260556636948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2d50e614e2bd930ff297b219",
            "leftCorner": {
              "x": -20.551,
              "y": -46.443,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.551,
              "y": -46.317,
              "z": 0.136
            },
            "gtin": "4260556635644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "214a67cbc8475bbc78605a2e",
            "leftCorner": {
              "x": -20.551,
              "y": -46.317,
              "z": 0.136
            },
            "rightCorner": {
              "x": -20.551,
              "y": -46.09,
              "z": 0.136
            },
            "gtin": "4002971320206",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ad",
        "height": 0.48391,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d609c",
            "leftCorner": {
              "x": -20.606,
              "y": -47.013,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.607,
              "y": -46.838,
              "z": 0.396
            },
            "gtin": "8606018701421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d609d",
            "leftCorner": {
              "x": -20.608,
              "y": -46.838,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.608,
              "y": -46.668,
              "z": 0.396
            },
            "gtin": "4012712010129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d609e",
            "leftCorner": {
              "x": -20.605,
              "y": -46.668,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.606,
              "y": -46.497,
              "z": 0.396
            },
            "gtin": "4012712010648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d609f",
            "leftCorner": {
              "x": -20.603,
              "y": -46.497,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.602,
              "y": -46.333,
              "z": 0.396
            },
            "gtin": "4012712011188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60a0",
            "leftCorner": {
              "x": -20.607,
              "y": -46.333,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.608,
              "y": -46.169,
              "z": 0.396
            },
            "gtin": "4012712010952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60a1",
            "leftCorner": {
              "x": -20.61,
              "y": -46.169,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.609,
              "y": -46.018,
              "z": 0.396
            },
            "gtin": "4012712010280",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ae",
        "height": 0.79486,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6088",
            "leftCorner": {
              "x": -20.62,
              "y": -47.033,
              "z": 0.65
            },
            "rightCorner": {
              "x": -20.621,
              "y": -46.916,
              "z": 0.65
            },
            "gtin": "4104420057326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6089",
            "leftCorner": {
              "x": -20.627,
              "y": -46.916,
              "z": 0.65
            },
            "rightCorner": {
              "x": -20.627,
              "y": -46.766,
              "z": 0.65
            },
            "gtin": "4104420056268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d608a",
            "leftCorner": {
              "x": -20.624,
              "y": -46.766,
              "z": 0.65
            },
            "rightCorner": {
              "x": -20.624,
              "y": -46.447,
              "z": 0.65
            },
            "gtin": "4104420056220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d608b",
            "leftCorner": {
              "x": -20.617,
              "y": -46.447,
              "z": 0.65
            },
            "rightCorner": {
              "x": -20.618,
              "y": -46.232,
              "z": 0.65
            },
            "gtin": "4002971320206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d608c",
            "leftCorner": {
              "x": -20.622,
              "y": -46.232,
              "z": 0.65
            },
            "rightCorner": {
              "x": -20.621,
              "y": -46.011,
              "z": 0.65
            },
            "gtin": "4002971320404",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ac",
        "height": 1.0996,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d602a",
            "leftCorner": {
              "x": -20.617,
              "y": -47.055,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.617,
              "y": -46.883,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d602b",
            "leftCorner": {
              "x": -20.62,
              "y": -46.883,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.62,
              "y": -46.735,
              "z": 0.9
            },
            "gtin": "4025500295035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d602c",
            "leftCorner": {
              "x": -20.615,
              "y": -46.735,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.616,
              "y": -46.561,
              "z": 0.9
            },
            "gtin": "4025500295073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d602e",
            "leftCorner": {
              "x": -20.614,
              "y": -46.441,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.614,
              "y": -46.066,
              "z": 0.9
            },
            "gtin": "4025500295059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d602f",
            "leftCorner": {
              "x": -20.616,
              "y": -46.066,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.616,
              "y": -45.872,
              "z": 0.9
            },
            "gtin": "4002971355802",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ab",
        "height": 1.3488,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6071",
            "leftCorner": {
              "x": -20.614,
              "y": -47.04,
              "z": 1.104
            },
            "rightCorner": {
              "x": -20.615,
              "y": -46.892,
              "z": 1.104
            },
            "gtin": "3800233781250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6072",
            "leftCorner": {
              "x": -20.612,
              "y": -46.892,
              "z": 1.104
            },
            "rightCorner": {
              "x": -20.611,
              "y": -46.773,
              "z": 1.104
            },
            "gtin": "3800233781236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6073",
            "leftCorner": {
              "x": -20.61,
              "y": -46.773,
              "z": 1.104
            },
            "rightCorner": {
              "x": -20.61,
              "y": -46.59,
              "z": 1.104
            },
            "gtin": "4260556632490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6074",
            "leftCorner": {
              "x": -20.607,
              "y": -46.59,
              "z": 1.104
            },
            "rightCorner": {
              "x": -20.607,
              "y": -46.463,
              "z": 1.104
            },
            "gtin": "4260556635644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6075",
            "leftCorner": {
              "x": -20.607,
              "y": -46.463,
              "z": 1.104
            },
            "rightCorner": {
              "x": -20.606,
              "y": -46.341,
              "z": 1.104
            },
            "gtin": "4260556635675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6076",
            "leftCorner": {
              "x": -20.607,
              "y": -46.341,
              "z": 1.104
            },
            "rightCorner": {
              "x": -20.607,
              "y": -46.204,
              "z": 1.104
            },
            "gtin": "4260556635613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6077",
            "leftCorner": {
              "x": -20.616,
              "y": -46.204,
              "z": 1.104
            },
            "rightCorner": {
              "x": -20.615,
              "y": -46.046,
              "z": 1.104
            },
            "gtin": "4260556635460",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0aa",
        "height": 1.6001,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d604d",
            "leftCorner": {
              "x": -20.613,
              "y": -47.044,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.612,
              "y": -46.965,
              "z": 1.309
            },
            "gtin": "4104420222533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fac53c08a47f51b9b1b1816b",
            "leftCorner": {
              "x": -20.566,
              "y": -47.073,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.566,
              "y": -47.051,
              "z": 1.309
            },
            "gtin": "5060495118210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d604e",
            "leftCorner": {
              "x": -20.613,
              "y": -46.965,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.614,
              "y": -46.876,
              "z": 1.309
            },
            "gtin": "4104420222441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d604f",
            "leftCorner": {
              "x": -20.61,
              "y": -46.876,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.61,
              "y": -46.709,
              "z": 1.309
            },
            "gtin": "4260556632506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6050",
            "leftCorner": {
              "x": -20.606,
              "y": -46.709,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.606,
              "y": -46.645,
              "z": 1.309
            },
            "gtin": "4260556636962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6051",
            "leftCorner": {
              "x": -20.606,
              "y": -46.645,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.607,
              "y": -46.58,
              "z": 1.309
            },
            "gtin": "4260556636962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6052",
            "leftCorner": {
              "x": -20.603,
              "y": -46.58,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.603,
              "y": -46.455,
              "z": 1.309
            },
            "gtin": "4260556636948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6053",
            "leftCorner": {
              "x": -20.605,
              "y": -46.455,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.605,
              "y": -46.103,
              "z": 1.309
            },
            "gtin": "4260556636955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6054",
            "leftCorner": {
              "x": -20.61,
              "y": -46.103,
              "z": 1.309
            },
            "rightCorner": {
              "x": -20.611,
              "y": -45.962,
              "z": 1.309
            },
            "gtin": "5060495118210",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "882",
    "rightNeighborShelfId": "880"
  },
  {
    "id": "882",
    "name": "882",
    "x": -20.634,
    "y": -48.073,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70744,
      "w": 0.70677
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 47,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0a9",
        "height": 0.16455,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d60b3",
            "leftCorner": {
              "x": -20.569,
              "y": -47.906,
              "z": 0.135
            },
            "rightCorner": {
              "x": -20.569,
              "y": -47.62,
              "z": 0.135
            },
            "gtin": "4260562940664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e55855e8ebd15fe1f1906316",
            "leftCorner": {
              "x": -20.53,
              "y": -47.432,
              "z": 0.135
            },
            "rightCorner": {
              "x": -20.53,
              "y": -47.258,
              "z": 0.135
            },
            "gtin": "4260562940671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "516cb7eae877b14c18c8fb36",
            "leftCorner": {
              "x": -20.53,
              "y": -47.258,
              "z": 0.135
            },
            "rightCorner": {
              "x": -20.53,
              "y": -47.084,
              "z": 0.135
            },
            "gtin": "4260562940671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60b4",
            "leftCorner": {
              "x": -20.566,
              "y": -47.62,
              "z": 0.135
            },
            "rightCorner": {
              "x": -20.566,
              "y": -47.432,
              "z": 0.135
            },
            "gtin": "4260562940671",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0a8",
        "height": 0.48459,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6097",
            "leftCorner": {
              "x": -20.572,
              "y": -48.073,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.572,
              "y": -47.859,
              "z": 0.396
            },
            "gtin": "4104420239425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6098",
            "leftCorner": {
              "x": -20.572,
              "y": -47.859,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.573,
              "y": -47.645,
              "z": 0.396
            },
            "gtin": "4104420239425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6099",
            "leftCorner": {
              "x": -20.573,
              "y": -47.645,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.573,
              "y": -47.431,
              "z": 0.396
            },
            "gtin": "4104420239425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d609b",
            "leftCorner": {
              "x": -20.613,
              "y": -47.431,
              "z": 0.396
            },
            "rightCorner": {
              "x": -20.614,
              "y": -47.013,
              "z": 0.396
            },
            "gtin": "8606018701384",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0a7",
        "height": 0.79669,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6081",
            "leftCorner": {
              "x": -20.583,
              "y": -48.073,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.584,
              "y": -47.898,
              "z": 0.652
            },
            "gtin": "4104420225770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6083",
            "leftCorner": {
              "x": -20.628,
              "y": -47.898,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.628,
              "y": -47.787,
              "z": 0.652
            },
            "gtin": "4104420209466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6084",
            "leftCorner": {
              "x": -20.622,
              "y": -47.787,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.622,
              "y": -47.644,
              "z": 0.652
            },
            "gtin": "4104420225800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6085",
            "leftCorner": {
              "x": -20.622,
              "y": -47.644,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.622,
              "y": -47.487,
              "z": 0.652
            },
            "gtin": "4104420225961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6086",
            "leftCorner": {
              "x": -20.624,
              "y": -47.487,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.624,
              "y": -47.339,
              "z": 0.652
            },
            "gtin": "4104420221833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6087",
            "leftCorner": {
              "x": -20.626,
              "y": -47.339,
              "z": 0.652
            },
            "rightCorner": {
              "x": -20.626,
              "y": -47.033,
              "z": 0.652
            },
            "gtin": "4104420221796",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0a4",
        "height": 1.1006,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6026",
            "leftCorner": {
              "x": -20.625,
              "y": -47.948,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.625,
              "y": -47.718,
              "z": 0.9
            },
            "gtin": "4062432003727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9e1da0c39fe5bab035b9807e",
            "leftCorner": {
              "x": -20.58,
              "y": -48.073,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -48.064,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "404aaf3b3e737361e5125ab1",
            "leftCorner": {
              "x": -20.58,
              "y": -48.064,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -48.055,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b73dcd71ef36ead4c665c746",
            "leftCorner": {
              "x": -20.58,
              "y": -48.055,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -48.046,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4d65c4f27cf0f78b5c97ed9a",
            "leftCorner": {
              "x": -20.58,
              "y": -48.046,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -48.036,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9f9146b2aa898ba1aaf743b3",
            "leftCorner": {
              "x": -20.58,
              "y": -48.036,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -48.027,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5da3a72770de553463ea70a3",
            "leftCorner": {
              "x": -20.58,
              "y": -48.027,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -48.018,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3fbd3678799fe579311d603f",
            "leftCorner": {
              "x": -20.58,
              "y": -48.018,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -48.009,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "448975eb4053b9b237006d20",
            "leftCorner": {
              "x": -20.58,
              "y": -48.009,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -48.0,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bcc685f50fbe9c0436dbf6dc",
            "leftCorner": {
              "x": -20.58,
              "y": -48.0,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -47.991,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0902bdd097d8573049ff16c0",
            "leftCorner": {
              "x": -20.58,
              "y": -47.991,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -47.982,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "760881043acea104b0ae8833",
            "leftCorner": {
              "x": -20.58,
              "y": -47.982,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -47.972,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c0736105c4e168cbb85e2492",
            "leftCorner": {
              "x": -20.58,
              "y": -47.972,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -47.963,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ecc1de61b8a45264980f2060",
            "leftCorner": {
              "x": -20.58,
              "y": -47.963,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.58,
              "y": -47.954,
              "z": 0.9
            },
            "gtin": "4000194910891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6027",
            "leftCorner": {
              "x": -20.625,
              "y": -47.718,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.626,
              "y": -47.487,
              "z": 0.9
            },
            "gtin": "4062432003727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6028",
            "leftCorner": {
              "x": -20.619,
              "y": -47.487,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.619,
              "y": -47.2,
              "z": 0.9
            },
            "gtin": "4260562940770",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6029",
            "leftCorner": {
              "x": -20.621,
              "y": -47.2,
              "z": 0.9
            },
            "rightCorner": {
              "x": -20.621,
              "y": -47.055,
              "z": 0.9
            },
            "gtin": "9120085631201",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0a6",
        "height": 1.3538,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d606b",
            "leftCorner": {
              "x": -20.622,
              "y": -48.045,
              "z": 1.108
            },
            "rightCorner": {
              "x": -20.622,
              "y": -47.905,
              "z": 1.108
            },
            "gtin": "5060811382493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d606c",
            "leftCorner": {
              "x": -20.622,
              "y": -47.905,
              "z": 1.108
            },
            "rightCorner": {
              "x": -20.622,
              "y": -47.777,
              "z": 1.108
            },
            "gtin": "5060221206754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d606d",
            "leftCorner": {
              "x": -20.618,
              "y": -47.777,
              "z": 1.108
            },
            "rightCorner": {
              "x": -20.618,
              "y": -47.603,
              "z": 1.108
            },
            "gtin": "5060811383278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d606e",
            "leftCorner": {
              "x": -20.616,
              "y": -47.603,
              "z": 1.108
            },
            "rightCorner": {
              "x": -20.616,
              "y": -47.312,
              "z": 1.108
            },
            "gtin": "9120085630013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d606f",
            "leftCorner": {
              "x": -20.613,
              "y": -47.312,
              "z": 1.108
            },
            "rightCorner": {
              "x": -20.613,
              "y": -47.19,
              "z": 1.108
            },
            "gtin": "9120085630020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6070",
            "leftCorner": {
              "x": -20.615,
              "y": -47.19,
              "z": 1.108
            },
            "rightCorner": {
              "x": -20.615,
              "y": -47.04,
              "z": 1.108
            },
            "gtin": "4000194901257",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0a5",
        "height": 1.6035,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6042",
            "leftCorner": {
              "x": -20.623,
              "y": -48.045,
              "z": 1.312
            },
            "rightCorner": {
              "x": -20.623,
              "y": -47.952,
              "z": 1.312
            },
            "gtin": "4000194240448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6043",
            "leftCorner": {
              "x": -20.619,
              "y": -47.952,
              "z": 1.312
            },
            "rightCorner": {
              "x": -20.619,
              "y": -47.868,
              "z": 1.312
            },
            "gtin": "4000194240431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6044",
            "leftCorner": {
              "x": -20.619,
              "y": -47.868,
              "z": 1.312
            },
            "rightCorner": {
              "x": -20.619,
              "y": -47.766,
              "z": 1.312
            },
            "gtin": "4000194240394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6045",
            "leftCorner": {
              "x": -20.621,
              "y": -47.766,
              "z": 1.312
            },
            "rightCorner": {
              "x": -20.621,
              "y": -47.679,
              "z": 1.312
            },
            "gtin": "4000194240387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6046",
            "leftCorner": {
              "x": -20.617,
              "y": -47.679,
              "z": 1.312
            },
            "rightCorner": {
              "x": -20.617,
              "y": -47.581,
              "z": 1.312
            },
            "gtin": "4000194240332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6047",
            "leftCorner": {
              "x": -20.618,
              "y": -47.581,
              "z": 1.312
            },
            "rightCorner": {
              "x": -20.618,
              "y": -47.478,
              "z": 1.312
            },
            "gtin": "4000194240295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6048",
            "leftCorner": {
              "x": -20.616,
              "y": -47.478,
              "z": 1.312
            },
            "rightCorner": {
              "x": -20.616,
              "y": -47.396,
              "z": 1.312
            },
            "gtin": "4000194240455",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6049",
            "leftCorner": {
              "x": -20.617,
              "y": -47.396,
              "z": 1.312
            },
            "rightCorner": {
              "x": -20.617,
              "y": -47.315,
              "z": 1.312
            },
            "gtin": "4104420222687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d604a",
            "leftCorner": {
              "x": -20.617,
              "y": -47.315,
              "z": 1.312
            },
            "rightCorner": {
              "x": -20.617,
              "y": -47.232,
              "z": 1.312
            },
            "gtin": "4104420220515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d604b",
            "leftCorner": {
              "x": -20.617,
              "y": -47.232,
              "z": 1.312
            },
            "rightCorner": {
              "x": -20.618,
              "y": -47.145,
              "z": 1.312
            },
            "gtin": "4104420222472",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d604c",
            "leftCorner": {
              "x": -20.613,
              "y": -47.145,
              "z": 1.312
            },
            "rightCorner": {
              "x": -20.613,
              "y": -47.044,
              "z": 1.312
            },
            "gtin": "4104420246546",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "883",
    "rightNeighborShelfId": "881"
  },
  {
    "id": "883",
    "name": "883",
    "x": -20.636,
    "y": -49.329,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70514,
      "w": 0.70907
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 54
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6a5",
        "height": 0.1707,
        "facings": [
          {
            "id": "a09894a2e353af8175c01237",
            "leftCorner": {
              "x": -20.574,
              "y": -49.329,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.573,
              "y": -49.234,
              "z": 0.14
            },
            "gtin": "3981964260464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f2c45f25cba5ace61a1de41d",
            "leftCorner": {
              "x": -20.573,
              "y": -49.234,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.573,
              "y": -49.145,
              "z": 0.14
            },
            "gtin": "4013320098691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0613a89e6eb308e57bb433e5",
            "leftCorner": {
              "x": -20.573,
              "y": -49.145,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.572,
              "y": -49.054,
              "z": 0.14
            },
            "gtin": "4000194331450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f3f5df93588b95357ab9c0e7",
            "leftCorner": {
              "x": -20.572,
              "y": -49.054,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.572,
              "y": -48.961,
              "z": 0.14
            },
            "gtin": "4013320098912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b75b9e3150b3bc11f194a9c0",
            "leftCorner": {
              "x": -20.572,
              "y": -48.961,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.571,
              "y": -48.866,
              "z": 0.14
            },
            "gtin": "4013320098998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4c4c7e38f119a96298423701",
            "leftCorner": {
              "x": -20.571,
              "y": -48.866,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.571,
              "y": -48.771,
              "z": 0.14
            },
            "gtin": "3981964260464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9fa325e989384330717b97a5",
            "leftCorner": {
              "x": -20.571,
              "y": -48.771,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.57,
              "y": -48.67,
              "z": 0.14
            },
            "gtin": "4260044268026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ae1e482c426e977bdea49e38",
            "leftCorner": {
              "x": -20.57,
              "y": -48.67,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.57,
              "y": -48.561,
              "z": 0.14
            },
            "gtin": "4013320098578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4e31829f044d414dadf31058",
            "leftCorner": {
              "x": -20.57,
              "y": -48.561,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.569,
              "y": -48.45,
              "z": 0.14
            },
            "gtin": "4260562940268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f2fe860d5b130354c1c1ca3f",
            "leftCorner": {
              "x": -20.569,
              "y": -48.45,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.568,
              "y": -48.336,
              "z": 0.14
            },
            "gtin": "4250031354740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b6c10a89a424303cb0f4fb41",
            "leftCorner": {
              "x": -20.568,
              "y": -48.336,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.567,
              "y": -48.095,
              "z": 0.14
            },
            "gtin": "4260545850041",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6a3",
        "height": 0.45073,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8690",
            "leftCorner": {
              "x": -20.606,
              "y": -49.329,
              "z": 0.369
            },
            "rightCorner": {
              "x": -20.603,
              "y": -48.689,
              "z": 0.369
            },
            "gtin": "4260044267159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8692",
            "leftCorner": {
              "x": -20.634,
              "y": -48.689,
              "z": 0.369
            },
            "rightCorner": {
              "x": -20.632,
              "y": -48.515,
              "z": 0.369
            },
            "gtin": "4250519646534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8693",
            "leftCorner": {
              "x": -20.639,
              "y": -48.515,
              "z": 0.369
            },
            "rightCorner": {
              "x": -20.639,
              "y": -48.349,
              "z": 0.369
            },
            "gtin": "4250519646527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8694",
            "leftCorner": {
              "x": -20.644,
              "y": -48.349,
              "z": 0.369
            },
            "rightCorner": {
              "x": -20.643,
              "y": -48.198,
              "z": 0.369
            },
            "gtin": "4250519647890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8691",
            "leftCorner": {
              "x": -20.642,
              "y": -48.198,
              "z": 0.369
            },
            "rightCorner": {
              "x": -20.641,
              "y": -48.079,
              "z": 0.369
            },
            "gtin": "4250519646510",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6a4",
        "height": 0.55973,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8695",
            "leftCorner": {
              "x": -20.879,
              "y": -49.328,
              "z": 0.458
            },
            "rightCorner": {
              "x": -20.874,
              "y": -48.248,
              "z": 0.458
            }
          },
          {
            "id": "68d8e50ee1820c81800d8696",
            "leftCorner": {
              "x": -20.895,
              "y": -48.248,
              "z": 0.458
            },
            "rightCorner": {
              "x": -20.893,
              "y": -48.077,
              "z": 0.458
            }
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d69f",
        "height": 0.6753,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8682",
            "leftCorner": {
              "x": -20.6,
              "y": -49.33,
              "z": 0.553
            },
            "rightCorner": {
              "x": -20.599,
              "y": -49.123,
              "z": 0.553
            },
            "gtin": "4260044265131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8684",
            "leftCorner": {
              "x": -20.642,
              "y": -49.122,
              "z": 0.553
            },
            "rightCorner": {
              "x": -20.641,
              "y": -48.972,
              "z": 0.553
            },
            "gtin": "4260044265018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8685",
            "leftCorner": {
              "x": -20.64,
              "y": -48.972,
              "z": 0.553
            },
            "rightCorner": {
              "x": -20.64,
              "y": -48.817,
              "z": 0.553
            },
            "gtin": "4260044260471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8686",
            "leftCorner": {
              "x": -20.638,
              "y": -48.817,
              "z": 0.553
            },
            "rightCorner": {
              "x": -20.637,
              "y": -48.703,
              "z": 0.553
            },
            "gtin": "4260044268026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8687",
            "leftCorner": {
              "x": -20.63,
              "y": -48.703,
              "z": 0.553
            },
            "rightCorner": {
              "x": -20.629,
              "y": -48.555,
              "z": 0.553
            },
            "gtin": "4260044268040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8688",
            "leftCorner": {
              "x": -20.631,
              "y": -48.555,
              "z": 0.553
            },
            "rightCorner": {
              "x": -20.63,
              "y": -48.419,
              "z": 0.553
            },
            "gtin": "4260044266923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8689",
            "leftCorner": {
              "x": -20.635,
              "y": -48.419,
              "z": 0.553
            },
            "rightCorner": {
              "x": -20.634,
              "y": -48.203,
              "z": 0.553
            },
            "gtin": "4260044260402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8683",
            "leftCorner": {
              "x": -20.631,
              "y": -48.203,
              "z": 0.553
            },
            "rightCorner": {
              "x": -20.63,
              "y": -48.079,
              "z": 0.553
            },
            "gtin": "4260044260228",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6a0",
        "height": 0.90095,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d868a",
            "leftCorner": {
              "x": -20.601,
              "y": -49.33,
              "z": 0.737
            },
            "rightCorner": {
              "x": -20.6,
              "y": -49.114,
              "z": 0.737
            },
            "gtin": "4029679995727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d868c",
            "leftCorner": {
              "x": -20.646,
              "y": -49.115,
              "z": 0.737
            },
            "rightCorner": {
              "x": -20.645,
              "y": -48.903,
              "z": 0.737
            },
            "gtin": "4029679995741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d868d",
            "leftCorner": {
              "x": -20.644,
              "y": -48.903,
              "z": 0.737
            },
            "rightCorner": {
              "x": -20.643,
              "y": -48.741,
              "z": 0.737
            },
            "gtin": "4029679997011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d868e",
            "leftCorner": {
              "x": -20.628,
              "y": -48.741,
              "z": 0.737
            },
            "rightCorner": {
              "x": -20.626,
              "y": -48.403,
              "z": 0.737
            },
            "gtin": "4029679996984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d868f",
            "leftCorner": {
              "x": -20.636,
              "y": -48.403,
              "z": 0.737
            },
            "rightCorner": {
              "x": -20.635,
              "y": -48.227,
              "z": 0.737
            },
            "gtin": "4061289007162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d868b",
            "leftCorner": {
              "x": -20.633,
              "y": -48.227,
              "z": 0.737
            },
            "rightCorner": {
              "x": -20.632,
              "y": -48.079,
              "z": 0.737
            },
            "gtin": "4061289008688",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6a2",
        "height": 1.1026,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6020",
            "leftCorner": {
              "x": -20.593,
              "y": -49.33,
              "z": 0.902
            },
            "rightCorner": {
              "x": -20.592,
              "y": -49.021,
              "z": 0.902
            },
            "gtin": "5000159516198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6022",
            "leftCorner": {
              "x": -20.642,
              "y": -49.02,
              "z": 0.902
            },
            "rightCorner": {
              "x": -20.641,
              "y": -48.781,
              "z": 0.902
            },
            "gtin": "5000159516211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6023",
            "leftCorner": {
              "x": -20.63,
              "y": -48.781,
              "z": 0.902
            },
            "rightCorner": {
              "x": -20.629,
              "y": -48.65,
              "z": 0.902
            },
            "gtin": "4260562940275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6024",
            "leftCorner": {
              "x": -20.627,
              "y": -48.65,
              "z": 0.902
            },
            "rightCorner": {
              "x": -20.627,
              "y": -48.537,
              "z": 0.902
            },
            "gtin": "4260562940268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6025",
            "leftCorner": {
              "x": -20.629,
              "y": -48.537,
              "z": 0.902
            },
            "rightCorner": {
              "x": -20.625,
              "y": -47.953,
              "z": 0.902
            },
            "gtin": "4260562940237",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6a1",
        "height": 1.359,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6062",
            "leftCorner": {
              "x": -20.59,
              "y": -49.33,
              "z": 1.112
            },
            "rightCorner": {
              "x": -20.589,
              "y": -49.133,
              "z": 1.112
            },
            "gtin": "4011800596620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "91582b3e2b53e7066bcf6471",
            "leftCorner": {
              "x": -20.589,
              "y": -49.133,
              "z": 1.112
            },
            "rightCorner": {
              "x": -20.588,
              "y": -48.995,
              "z": 1.112
            },
            "gtin": "4260545850140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6065",
            "leftCorner": {
              "x": -20.632,
              "y": -48.994,
              "z": 1.112
            },
            "rightCorner": {
              "x": -20.631,
              "y": -48.876,
              "z": 1.112
            },
            "gtin": "4011800584726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6066",
            "leftCorner": {
              "x": -20.628,
              "y": -48.876,
              "z": 1.112
            },
            "rightCorner": {
              "x": -20.627,
              "y": -48.725,
              "z": 1.112
            },
            "gtin": "4011800596323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6067",
            "leftCorner": {
              "x": -20.62,
              "y": -48.725,
              "z": 1.112
            },
            "rightCorner": {
              "x": -20.619,
              "y": -48.595,
              "z": 1.112
            },
            "gtin": "4260545852960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6068",
            "leftCorner": {
              "x": -20.62,
              "y": -48.595,
              "z": 1.112
            },
            "rightCorner": {
              "x": -20.619,
              "y": -48.455,
              "z": 1.112
            },
            "gtin": "4260545850140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6069",
            "leftCorner": {
              "x": -20.623,
              "y": -48.455,
              "z": 1.112
            },
            "rightCorner": {
              "x": -20.623,
              "y": -48.314,
              "z": 1.112
            },
            "gtin": "4260545850027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d606a",
            "leftCorner": {
              "x": -20.624,
              "y": -48.314,
              "z": 1.112
            },
            "rightCorner": {
              "x": -20.623,
              "y": -48.05,
              "z": 1.112
            },
            "gtin": "4260545850041",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d69e",
        "height": 1.606,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6037",
            "leftCorner": {
              "x": -20.595,
              "y": -49.33,
              "z": 1.314
            },
            "rightCorner": {
              "x": -20.594,
              "y": -49.18,
              "z": 1.314
            },
            "gtin": "4250031354726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f8567546e06f5d6601506e0b",
            "leftCorner": {
              "x": -20.593,
              "y": -48.902,
              "z": 1.314
            },
            "rightCorner": {
              "x": -20.592,
              "y": -48.757,
              "z": 1.314
            },
            "gtin": "4250031354726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "00dff9bd6ad71383a0a3d728",
            "leftCorner": {
              "x": -20.592,
              "y": -48.757,
              "z": 1.314
            },
            "rightCorner": {
              "x": -20.591,
              "y": -48.664,
              "z": 1.314
            },
            "gtin": "4013320098912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6039",
            "leftCorner": {
              "x": -20.642,
              "y": -49.18,
              "z": 1.314
            },
            "rightCorner": {
              "x": -20.641,
              "y": -49.064,
              "z": 1.314
            },
            "gtin": "4250031354740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d603a",
            "leftCorner": {
              "x": -20.64,
              "y": -49.064,
              "z": 1.314
            },
            "rightCorner": {
              "x": -20.64,
              "y": -48.902,
              "z": 1.314
            },
            "gtin": "4250031354733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d603c",
            "leftCorner": {
              "x": -20.624,
              "y": -48.663,
              "z": 1.314
            },
            "rightCorner": {
              "x": -20.624,
              "y": -48.572,
              "z": 1.314
            },
            "gtin": "4013320098912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d603d",
            "leftCorner": {
              "x": -20.624,
              "y": -48.572,
              "z": 1.314
            },
            "rightCorner": {
              "x": -20.624,
              "y": -48.474,
              "z": 1.314
            },
            "gtin": "4013320098998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d603e",
            "leftCorner": {
              "x": -20.63,
              "y": -48.474,
              "z": 1.314
            },
            "rightCorner": {
              "x": -20.629,
              "y": -48.385,
              "z": 1.314
            },
            "gtin": "4013320098691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d603f",
            "leftCorner": {
              "x": -20.629,
              "y": -48.385,
              "z": 1.314
            },
            "rightCorner": {
              "x": -20.629,
              "y": -48.285,
              "z": 1.314
            },
            "gtin": "4013320098578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6040",
            "leftCorner": {
              "x": -20.626,
              "y": -48.284,
              "z": 1.314
            },
            "rightCorner": {
              "x": -20.625,
              "y": -48.157,
              "z": 1.314
            },
            "gtin": "4000194332242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6041",
            "leftCorner": {
              "x": -20.623,
              "y": -48.157,
              "z": 1.314
            },
            "rightCorner": {
              "x": -20.623,
              "y": -48.051,
              "z": 1.314
            },
            "gtin": "4000194331450",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "882"
  },
  {
    "id": "884",
    "name": "884",
    "x": -20.528,
    "y": -43.927,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0079412,
      "w": 0.99997
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 55
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6ab",
        "height": 0.14796,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6105",
            "leftCorner": {
              "x": -20.357,
              "y": -43.98,
              "z": 0.121
            },
            "rightCorner": {
              "x": -20.247,
              "y": -43.982,
              "z": 0.121
            },
            "gtin": "4104420184497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c7548169e0d0345e3f7ce4a5",
            "leftCorner": {
              "x": -20.529,
              "y": -44.015,
              "z": 0.121
            },
            "rightCorner": {
              "x": -20.362,
              "y": -44.018,
              "z": 0.121
            },
            "gtin": "4104420219403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6106",
            "leftCorner": {
              "x": -20.247,
              "y": -43.979,
              "z": 0.121
            },
            "rightCorner": {
              "x": -20.16,
              "y": -43.981,
              "z": 0.121
            },
            "gtin": "4104420253346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6107",
            "leftCorner": {
              "x": -20.16,
              "y": -43.981,
              "z": 0.121
            },
            "rightCorner": {
              "x": -20.066,
              "y": -43.982,
              "z": 0.121
            },
            "gtin": "4104420022089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6108",
            "leftCorner": {
              "x": -20.066,
              "y": -43.974,
              "z": 0.121
            },
            "rightCorner": {
              "x": -19.937,
              "y": -43.976,
              "z": 0.121
            },
            "gtin": "4104420214040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6109",
            "leftCorner": {
              "x": -19.937,
              "y": -43.987,
              "z": 0.121
            },
            "rightCorner": {
              "x": -19.746,
              "y": -43.99,
              "z": 0.121
            },
            "gtin": "4104420140646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d610a",
            "leftCorner": {
              "x": -19.746,
              "y": -43.989,
              "z": 0.121
            },
            "rightCorner": {
              "x": -19.575,
              "y": -43.992,
              "z": 0.121
            },
            "gtin": "4104420219403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d610b",
            "leftCorner": {
              "x": -19.575,
              "y": -43.987,
              "z": 0.121
            },
            "rightCorner": {
              "x": -19.476,
              "y": -43.988,
              "z": 0.121
            },
            "gtin": "4104420022720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d610c",
            "leftCorner": {
              "x": -19.475,
              "y": -43.993,
              "z": 0.121
            },
            "rightCorner": {
              "x": -19.384,
              "y": -43.995,
              "z": 0.121
            },
            "gtin": "4104420207554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d610d",
            "leftCorner": {
              "x": -19.384,
              "y": -43.998,
              "z": 0.121
            },
            "rightCorner": {
              "x": -19.247,
              "y": -43.999,
              "z": 0.121
            },
            "gtin": "4104420010628",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6a6",
        "height": 0.47189,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8697",
            "leftCorner": {
              "x": -20.529,
              "y": -43.969,
              "z": 0.386
            },
            "rightCorner": {
              "x": -20.318,
              "y": -43.972,
              "z": 0.386
            },
            "gtin": "4104420215313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8699",
            "leftCorner": {
              "x": -20.317,
              "y": -43.925,
              "z": 0.386
            },
            "rightCorner": {
              "x": -20.229,
              "y": -43.927,
              "z": 0.386
            },
            "gtin": "4104420241565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d869a",
            "leftCorner": {
              "x": -20.229,
              "y": -43.928,
              "z": 0.386
            },
            "rightCorner": {
              "x": -20.03,
              "y": -43.931,
              "z": 0.386
            },
            "gtin": "4104420014459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d869b",
            "leftCorner": {
              "x": -20.03,
              "y": -43.936,
              "z": 0.386
            },
            "rightCorner": {
              "x": -19.939,
              "y": -43.937,
              "z": 0.386
            },
            "gtin": "4104420016781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d869c",
            "leftCorner": {
              "x": -19.939,
              "y": -43.938,
              "z": 0.386
            },
            "rightCorner": {
              "x": -19.835,
              "y": -43.94,
              "z": 0.386
            },
            "gtin": "4104420230934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d869d",
            "leftCorner": {
              "x": -19.835,
              "y": -43.941,
              "z": 0.386
            },
            "rightCorner": {
              "x": -19.701,
              "y": -43.943,
              "z": 0.386
            },
            "gtin": "4104420022287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d869e",
            "leftCorner": {
              "x": -19.701,
              "y": -43.948,
              "z": 0.386
            },
            "rightCorner": {
              "x": -19.563,
              "y": -43.951,
              "z": 0.386
            },
            "gtin": "4104420237254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d869f",
            "leftCorner": {
              "x": -19.563,
              "y": -43.951,
              "z": 0.386
            },
            "rightCorner": {
              "x": -19.426,
              "y": -43.953,
              "z": 0.386
            },
            "gtin": "4104420237254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8698",
            "leftCorner": {
              "x": -19.426,
              "y": -43.954,
              "z": 0.386
            },
            "rightCorner": {
              "x": -19.278,
              "y": -43.955,
              "z": 0.386
            },
            "gtin": "4104420218352",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6a7",
        "height": 0.79592,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86a0",
            "leftCorner": {
              "x": -20.529,
              "y": -43.968,
              "z": 0.651
            },
            "rightCorner": {
              "x": -20.405,
              "y": -43.97,
              "z": 0.651
            },
            "gtin": "4104420249967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86a2",
            "leftCorner": {
              "x": -20.404,
              "y": -43.928,
              "z": 0.651
            },
            "rightCorner": {
              "x": -20.26,
              "y": -43.931,
              "z": 0.651
            },
            "gtin": "4104420011908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86a3",
            "leftCorner": {
              "x": -20.26,
              "y": -43.926,
              "z": 0.651
            },
            "rightCorner": {
              "x": -20.156,
              "y": -43.928,
              "z": 0.651
            },
            "gtin": "4104420186057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86a4",
            "leftCorner": {
              "x": -20.156,
              "y": -43.929,
              "z": 0.651
            },
            "rightCorner": {
              "x": -19.992,
              "y": -43.931,
              "z": 0.651
            },
            "gtin": "4104420241923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86a5",
            "leftCorner": {
              "x": -19.992,
              "y": -43.933,
              "z": 0.651
            },
            "rightCorner": {
              "x": -19.89,
              "y": -43.935,
              "z": 0.651
            },
            "gtin": "4104420016828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86a6",
            "leftCorner": {
              "x": -19.89,
              "y": -43.943,
              "z": 0.651
            },
            "rightCorner": {
              "x": -19.78,
              "y": -43.944,
              "z": 0.651
            },
            "gtin": "4104420241886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86a7",
            "leftCorner": {
              "x": -19.78,
              "y": -43.948,
              "z": 0.651
            },
            "rightCorner": {
              "x": -19.646,
              "y": -43.951,
              "z": 0.651
            },
            "gtin": "4104420241848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86a8",
            "leftCorner": {
              "x": -19.646,
              "y": -43.952,
              "z": 0.651
            },
            "rightCorner": {
              "x": -19.457,
              "y": -43.955,
              "z": 0.651
            },
            "gtin": "4104420216709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86a1",
            "leftCorner": {
              "x": -19.457,
              "y": -43.955,
              "z": 0.651
            },
            "rightCorner": {
              "x": -19.278,
              "y": -43.957,
              "z": 0.651
            },
            "gtin": "4104420181380",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6aa",
        "height": 1.0988,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86b2",
            "leftCorner": {
              "x": -20.529,
              "y": -43.976,
              "z": 0.899
            },
            "rightCorner": {
              "x": -20.347,
              "y": -43.98,
              "z": 0.899
            },
            "gtin": "4104420226685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86b4",
            "leftCorner": {
              "x": -20.346,
              "y": -43.932,
              "z": 0.899
            },
            "rightCorner": {
              "x": -20.242,
              "y": -43.933,
              "z": 0.899
            },
            "gtin": "4104420140660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86b5",
            "leftCorner": {
              "x": -20.242,
              "y": -43.932,
              "z": 0.899
            },
            "rightCorner": {
              "x": -20.138,
              "y": -43.933,
              "z": 0.899
            },
            "gtin": "4104420011625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86b6",
            "leftCorner": {
              "x": -20.138,
              "y": -43.933,
              "z": 0.899
            },
            "rightCorner": {
              "x": -20.034,
              "y": -43.935,
              "z": 0.899
            },
            "gtin": "4104420011625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86b7",
            "leftCorner": {
              "x": -20.034,
              "y": -43.937,
              "z": 0.899
            },
            "rightCorner": {
              "x": -19.934,
              "y": -43.938,
              "z": 0.899
            },
            "gtin": "4104420232198",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86b8",
            "leftCorner": {
              "x": -19.934,
              "y": -43.944,
              "z": 0.899
            },
            "rightCorner": {
              "x": -19.826,
              "y": -43.946,
              "z": 0.899
            },
            "gtin": "4104420253285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86b9",
            "leftCorner": {
              "x": -19.826,
              "y": -43.949,
              "z": 0.899
            },
            "rightCorner": {
              "x": -19.74,
              "y": -43.951,
              "z": 0.899
            },
            "gtin": "4104420247543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86ba",
            "leftCorner": {
              "x": -19.74,
              "y": -43.956,
              "z": 0.899
            },
            "rightCorner": {
              "x": -19.616,
              "y": -43.959,
              "z": 0.899
            },
            "gtin": "4104420182240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86bb",
            "leftCorner": {
              "x": -19.616,
              "y": -43.955,
              "z": 0.899
            },
            "rightCorner": {
              "x": -19.405,
              "y": -43.958,
              "z": 0.899
            },
            "gtin": "4104420241671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86b3",
            "leftCorner": {
              "x": -19.405,
              "y": -43.96,
              "z": 0.899
            },
            "rightCorner": {
              "x": -19.278,
              "y": -43.962,
              "z": 0.899
            },
            "gtin": "4104420248632",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6a9",
        "height": 1.3516,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86a9",
            "leftCorner": {
              "x": -20.529,
              "y": -43.98,
              "z": 1.106
            },
            "rightCorner": {
              "x": -20.305,
              "y": -43.984,
              "z": 1.106
            },
            "gtin": "4250073462571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86ab",
            "leftCorner": {
              "x": -20.305,
              "y": -43.937,
              "z": 1.106
            },
            "rightCorner": {
              "x": -20.117,
              "y": -43.941,
              "z": 1.106
            },
            "gtin": "4250073462533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86ac",
            "leftCorner": {
              "x": -20.118,
              "y": -43.979,
              "z": 1.106
            },
            "rightCorner": {
              "x": -20.016,
              "y": -43.98,
              "z": 1.106
            },
            "gtin": "4250073462557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86ad",
            "leftCorner": {
              "x": -20.016,
              "y": -43.939,
              "z": 1.106
            },
            "rightCorner": {
              "x": -19.913,
              "y": -43.941,
              "z": 1.106
            },
            "gtin": "4104420094864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86ae",
            "leftCorner": {
              "x": -19.913,
              "y": -43.947,
              "z": 1.106
            },
            "rightCorner": {
              "x": -19.82,
              "y": -43.948,
              "z": 1.106
            },
            "gtin": "4104420094840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86af",
            "leftCorner": {
              "x": -19.82,
              "y": -43.951,
              "z": 1.106
            },
            "rightCorner": {
              "x": -19.711,
              "y": -43.953,
              "z": 1.106
            },
            "gtin": "4104420077621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86b0",
            "leftCorner": {
              "x": -19.712,
              "y": -43.958,
              "z": 1.106
            },
            "rightCorner": {
              "x": -19.564,
              "y": -43.96,
              "z": 1.106
            },
            "gtin": "4019339641187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86b1",
            "leftCorner": {
              "x": -19.564,
              "y": -43.967,
              "z": 1.106
            },
            "rightCorner": {
              "x": -19.409,
              "y": -43.969,
              "z": 1.106
            },
            "gtin": "4019339641262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86aa",
            "leftCorner": {
              "x": -19.409,
              "y": -43.969,
              "z": 1.106
            },
            "rightCorner": {
              "x": -19.279,
              "y": -43.971,
              "z": 1.106
            },
            "gtin": "4019339641170",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6a8",
        "height": 1.5992,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d60cd",
            "leftCorner": {
              "x": -20.53,
              "y": -43.988,
              "z": 1.308
            },
            "rightCorner": {
              "x": -20.347,
              "y": -43.991,
              "z": 1.308
            },
            "gtin": "4251725803186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60d0",
            "leftCorner": {
              "x": -20.346,
              "y": -43.945,
              "z": 1.308
            },
            "rightCorner": {
              "x": -20.127,
              "y": -43.948,
              "z": 1.308
            },
            "gtin": "4251725803209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60d1",
            "leftCorner": {
              "x": -20.127,
              "y": -43.945,
              "z": 1.308
            },
            "rightCorner": {
              "x": -19.997,
              "y": -43.947,
              "z": 1.308
            },
            "gtin": "4260237451068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60d2",
            "leftCorner": {
              "x": -19.998,
              "y": -43.957,
              "z": 1.308
            },
            "rightCorner": {
              "x": -19.882,
              "y": -43.959,
              "z": 1.308
            },
            "gtin": "4260237453598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60d3",
            "leftCorner": {
              "x": -19.882,
              "y": -43.957,
              "z": 1.308
            },
            "rightCorner": {
              "x": -19.747,
              "y": -43.959,
              "z": 1.308
            },
            "gtin": "4260237453581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60d4",
            "leftCorner": {
              "x": -19.747,
              "y": -43.965,
              "z": 1.308
            },
            "rightCorner": {
              "x": -19.561,
              "y": -43.968,
              "z": 1.308
            },
            "gtin": "4260237451495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60d5",
            "leftCorner": {
              "x": -19.561,
              "y": -43.968,
              "z": 1.308
            },
            "rightCorner": {
              "x": -19.368,
              "y": -43.971,
              "z": 1.308
            },
            "gtin": "4104420239999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60d6",
            "leftCorner": {
              "x": -19.368,
              "y": -43.975,
              "z": 1.308
            },
            "rightCorner": {
              "x": -19.246,
              "y": -43.977,
              "z": 1.308
            },
            "gtin": "4104420020443",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "885"
  },
  {
    "id": "885",
    "name": "885",
    "x": -19.279,
    "y": -43.947,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0079412,
      "w": 0.99997
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 72
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0bb",
        "height": 0.15274,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d610e",
            "leftCorner": {
              "x": -19.248,
              "y": -44.015,
              "z": 0.125
            },
            "rightCorner": {
              "x": -19.092,
              "y": -44.017,
              "z": 0.125
            },
            "gtin": "4260604186166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d610f",
            "leftCorner": {
              "x": -19.092,
              "y": -44.014,
              "z": 0.125
            },
            "rightCorner": {
              "x": -18.949,
              "y": -44.017,
              "z": 0.125
            },
            "gtin": "4013182020892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6110",
            "leftCorner": {
              "x": -18.949,
              "y": -44.022,
              "z": 0.125
            },
            "rightCorner": {
              "x": -18.822,
              "y": -44.023,
              "z": 0.125
            },
            "gtin": "4013182020885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6111",
            "leftCorner": {
              "x": -18.822,
              "y": -44.025,
              "z": 0.125
            },
            "rightCorner": {
              "x": -18.684,
              "y": -44.027,
              "z": 0.125
            },
            "gtin": "4013182023824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6112",
            "leftCorner": {
              "x": -18.683,
              "y": -44.025,
              "z": 0.125
            },
            "rightCorner": {
              "x": -18.562,
              "y": -44.027,
              "z": 0.125
            },
            "gtin": "4013182023831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6113",
            "leftCorner": {
              "x": -18.562,
              "y": -44.027,
              "z": 0.125
            },
            "rightCorner": {
              "x": -18.44,
              "y": -44.029,
              "z": 0.125
            },
            "gtin": "4013182023831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6114",
            "leftCorner": {
              "x": -18.44,
              "y": -44.019,
              "z": 0.125
            },
            "rightCorner": {
              "x": -18.162,
              "y": -44.024,
              "z": 0.125
            },
            "gtin": "4013182024012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6104",
            "leftCorner": {
              "x": -18.162,
              "y": -44.032,
              "z": 0.125
            },
            "rightCorner": {
              "x": -18.03,
              "y": -44.034,
              "z": 0.125
            },
            "gtin": "4013182024203",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0b8",
        "height": 0.44536,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d60ea",
            "leftCorner": {
              "x": -19.28,
              "y": -43.995,
              "z": 0.364
            },
            "rightCorner": {
              "x": -19.181,
              "y": -43.997,
              "z": 0.364
            },
            "gtin": "4013182024234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2df0ac052efdbde6493e85bb",
            "leftCorner": {
              "x": -18.52,
              "y": -44.007,
              "z": 0.364
            },
            "rightCorner": {
              "x": -18.376,
              "y": -44.009,
              "z": 0.364
            },
            "gtin": "4013182022179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60eb",
            "leftCorner": {
              "x": -19.181,
              "y": -43.997,
              "z": 0.364
            },
            "rightCorner": {
              "x": -19.082,
              "y": -43.998,
              "z": 0.364
            },
            "gtin": "4013182024234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60ed",
            "leftCorner": {
              "x": -19.081,
              "y": -43.954,
              "z": 0.364
            },
            "rightCorner": {
              "x": -18.946,
              "y": -43.956,
              "z": 0.364
            },
            "gtin": "4013182024227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60ee",
            "leftCorner": {
              "x": -18.946,
              "y": -43.958,
              "z": 0.364
            },
            "rightCorner": {
              "x": -18.81,
              "y": -43.96,
              "z": 0.364
            },
            "gtin": "4013182024210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60ef",
            "leftCorner": {
              "x": -18.81,
              "y": -43.963,
              "z": 0.364
            },
            "rightCorner": {
              "x": -18.687,
              "y": -43.965,
              "z": 0.364
            },
            "gtin": "4013182020717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60f0",
            "leftCorner": {
              "x": -18.687,
              "y": -43.96,
              "z": 0.364
            },
            "rightCorner": {
              "x": -18.519,
              "y": -43.963,
              "z": 0.364
            },
            "gtin": "4013182020724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60f2",
            "leftCorner": {
              "x": -18.374,
              "y": -43.973,
              "z": 0.364
            },
            "rightCorner": {
              "x": -18.226,
              "y": -43.975,
              "z": 0.364
            },
            "gtin": "4013182022179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60f3",
            "leftCorner": {
              "x": -18.226,
              "y": -43.978,
              "z": 0.364
            },
            "rightCorner": {
              "x": -18.119,
              "y": -43.98,
              "z": 0.364
            },
            "gtin": "4013182023848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60ec",
            "leftCorner": {
              "x": -18.119,
              "y": -43.983,
              "z": 0.364
            },
            "rightCorner": {
              "x": -18.029,
              "y": -43.985,
              "z": 0.364
            },
            "gtin": "4104420028708",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0b6",
        "height": 0.64516,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d60c2",
            "leftCorner": {
              "x": -19.28,
              "y": -44.004,
              "z": 0.528
            },
            "rightCorner": {
              "x": -19.122,
              "y": -44.006,
              "z": 0.528
            },
            "gtin": "4005009101327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60c4",
            "leftCorner": {
              "x": -19.122,
              "y": -43.968,
              "z": 0.528
            },
            "rightCorner": {
              "x": -19.007,
              "y": -43.97,
              "z": 0.528
            },
            "gtin": "4005009100863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60c5",
            "leftCorner": {
              "x": -19.007,
              "y": -43.969,
              "z": 0.528
            },
            "rightCorner": {
              "x": -18.9,
              "y": -43.97,
              "z": 0.528
            },
            "gtin": "4005009101334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60c6",
            "leftCorner": {
              "x": -18.9,
              "y": -43.973,
              "z": 0.528
            },
            "rightCorner": {
              "x": -18.798,
              "y": -43.974,
              "z": 0.528
            },
            "gtin": "4005009106711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60c7",
            "leftCorner": {
              "x": -18.798,
              "y": -43.972,
              "z": 0.528
            },
            "rightCorner": {
              "x": -18.694,
              "y": -43.974,
              "z": 0.528
            },
            "gtin": "4005009100870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60c8",
            "leftCorner": {
              "x": -18.694,
              "y": -43.968,
              "z": 0.528
            },
            "rightCorner": {
              "x": -18.582,
              "y": -43.969,
              "z": 0.528
            },
            "gtin": "4013200257491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60c9",
            "leftCorner": {
              "x": -18.582,
              "y": -43.967,
              "z": 0.528
            },
            "rightCorner": {
              "x": -18.489,
              "y": -43.969,
              "z": 0.528
            },
            "gtin": "4013200257446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60ca",
            "leftCorner": {
              "x": -18.489,
              "y": -43.975,
              "z": 0.528
            },
            "rightCorner": {
              "x": -18.379,
              "y": -43.976,
              "z": 0.528
            },
            "gtin": "4013200257477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60cb",
            "leftCorner": {
              "x": -18.379,
              "y": -43.974,
              "z": 0.528
            },
            "rightCorner": {
              "x": -18.254,
              "y": -43.976,
              "z": 0.528
            },
            "gtin": "4013200257408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60cc",
            "leftCorner": {
              "x": -18.255,
              "y": -43.983,
              "z": 0.528
            },
            "rightCorner": {
              "x": -18.139,
              "y": -43.984,
              "z": 0.528
            },
            "gtin": "4013200257453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60c3",
            "leftCorner": {
              "x": -18.138,
              "y": -43.982,
              "z": 0.528
            },
            "rightCorner": {
              "x": -18.029,
              "y": -43.984,
              "z": 0.528
            },
            "gtin": "4013200257460",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0bc",
        "height": 0.81826,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6115",
            "leftCorner": {
              "x": -19.28,
              "y": -44.0,
              "z": 0.669
            },
            "rightCorner": {
              "x": -19.061,
              "y": -44.003,
              "z": 0.669
            },
            "gtin": "4104420249097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6117",
            "leftCorner": {
              "x": -19.06,
              "y": -43.962,
              "z": 0.669
            },
            "rightCorner": {
              "x": -18.936,
              "y": -43.965,
              "z": 0.669
            },
            "gtin": "4104420247895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6118",
            "leftCorner": {
              "x": -18.936,
              "y": -43.965,
              "z": 0.669
            },
            "rightCorner": {
              "x": -18.84,
              "y": -43.967,
              "z": 0.669
            },
            "gtin": "4104420238893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6119",
            "leftCorner": {
              "x": -18.84,
              "y": -43.967,
              "z": 0.669
            },
            "rightCorner": {
              "x": -18.744,
              "y": -43.969,
              "z": 0.669
            },
            "gtin": "4104420238893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d611a",
            "leftCorner": {
              "x": -18.744,
              "y": -43.967,
              "z": 0.669
            },
            "rightCorner": {
              "x": -18.668,
              "y": -43.967,
              "z": 0.669
            },
            "gtin": "4104420238978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d611b",
            "leftCorner": {
              "x": -18.668,
              "y": -43.967,
              "z": 0.669
            },
            "rightCorner": {
              "x": -18.593,
              "y": -43.969,
              "z": 0.669
            },
            "gtin": "4104420238978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d611c",
            "leftCorner": {
              "x": -18.593,
              "y": -43.969,
              "z": 0.669
            },
            "rightCorner": {
              "x": -18.519,
              "y": -43.971,
              "z": 0.669
            },
            "gtin": "4104420238930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d611d",
            "leftCorner": {
              "x": -18.519,
              "y": -43.971,
              "z": 0.669
            },
            "rightCorner": {
              "x": -18.445,
              "y": -43.971,
              "z": 0.669
            },
            "gtin": "4104420238930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d611e",
            "leftCorner": {
              "x": -18.445,
              "y": -43.976,
              "z": 0.669
            },
            "rightCorner": {
              "x": -18.306,
              "y": -43.979,
              "z": 0.669
            },
            "gtin": "4104420239098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d611f",
            "leftCorner": {
              "x": -18.306,
              "y": -43.981,
              "z": 0.669
            },
            "rightCorner": {
              "x": -18.16,
              "y": -43.983,
              "z": 0.669
            },
            "gtin": "4104420239012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6116",
            "leftCorner": {
              "x": -18.161,
              "y": -43.985,
              "z": 0.669
            },
            "rightCorner": {
              "x": -18.03,
              "y": -43.988,
              "z": 0.669
            },
            "gtin": "4104420238855",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0b9",
        "height": 0.99646,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d60f4",
            "leftCorner": {
              "x": -19.28,
              "y": -44.009,
              "z": 0.815
            },
            "rightCorner": {
              "x": -19.075,
              "y": -44.012,
              "z": 0.815
            },
            "gtin": "8710573526099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60f6",
            "leftCorner": {
              "x": -19.074,
              "y": -43.973,
              "z": 0.815
            },
            "rightCorner": {
              "x": -18.963,
              "y": -43.974,
              "z": 0.815
            },
            "gtin": "4104420249059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60f7",
            "leftCorner": {
              "x": -18.963,
              "y": -43.974,
              "z": 0.815
            },
            "rightCorner": {
              "x": -18.767,
              "y": -43.977,
              "z": 0.815
            },
            "gtin": "4104420229648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60f8",
            "leftCorner": {
              "x": -18.766,
              "y": -43.973,
              "z": 0.815
            },
            "rightCorner": {
              "x": -18.611,
              "y": -43.977,
              "z": 0.815
            },
            "gtin": "4104420237773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60f9",
            "leftCorner": {
              "x": -18.611,
              "y": -43.975,
              "z": 0.815
            },
            "rightCorner": {
              "x": -18.472,
              "y": -43.976,
              "z": 0.815
            },
            "gtin": "4104420229822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60fa",
            "leftCorner": {
              "x": -18.473,
              "y": -43.981,
              "z": 0.815
            },
            "rightCorner": {
              "x": -18.314,
              "y": -43.985,
              "z": 0.815
            },
            "gtin": "4104420224957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60fb",
            "leftCorner": {
              "x": -18.313,
              "y": -43.981,
              "z": 0.815
            },
            "rightCorner": {
              "x": -18.153,
              "y": -43.983,
              "z": 0.815
            },
            "gtin": "4104420229761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60f5",
            "leftCorner": {
              "x": -18.154,
              "y": -43.99,
              "z": 0.815
            },
            "rightCorner": {
              "x": -18.03,
              "y": -43.992,
              "z": 0.815
            },
            "gtin": "4104420229792",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0ba",
        "height": 1.2222,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d60fc",
            "leftCorner": {
              "x": -19.28,
              "y": -44.004,
              "z": 1.0
            },
            "rightCorner": {
              "x": -19.082,
              "y": -44.007,
              "z": 1.0
            },
            "gtin": "8710573426092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60fe",
            "leftCorner": {
              "x": -19.081,
              "y": -43.967,
              "z": 1.0
            },
            "rightCorner": {
              "x": -18.928,
              "y": -43.97,
              "z": 1.0
            },
            "gtin": "4260655550190",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60ff",
            "leftCorner": {
              "x": -18.928,
              "y": -43.97,
              "z": 1.0
            },
            "rightCorner": {
              "x": -18.775,
              "y": -43.972,
              "z": 1.0
            },
            "gtin": "4260655550206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6100",
            "leftCorner": {
              "x": -18.775,
              "y": -43.971,
              "z": 1.0
            },
            "rightCorner": {
              "x": -18.424,
              "y": -43.976,
              "z": 1.0
            },
            "gtin": "4250073462199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6101",
            "leftCorner": {
              "x": -18.424,
              "y": -43.977,
              "z": 1.0
            },
            "rightCorner": {
              "x": -18.302,
              "y": -43.98,
              "z": 1.0
            },
            "gtin": "4250073461673",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6102",
            "leftCorner": {
              "x": -18.302,
              "y": -43.981,
              "z": 1.0
            },
            "rightCorner": {
              "x": -18.174,
              "y": -43.984,
              "z": 1.0
            },
            "gtin": "4250073460348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60fd",
            "leftCorner": {
              "x": -18.174,
              "y": -43.986,
              "z": 1.0
            },
            "rightCorner": {
              "x": -18.03,
              "y": -43.989,
              "z": 1.0
            },
            "gtin": "4260655551265",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0bd",
        "height": 1.4255,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6120",
            "leftCorner": {
              "x": -19.28,
              "y": -44.014,
              "z": 1.166
            },
            "rightCorner": {
              "x": -19.138,
              "y": -44.016,
              "z": 1.166
            },
            "gtin": "4104420037526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a0ca3be0e4e602e9798f3e02",
            "leftCorner": {
              "x": -18.997,
              "y": -44.018,
              "z": 1.166
            },
            "rightCorner": {
              "x": -18.906,
              "y": -44.02,
              "z": 1.166
            },
            "gtin": "4104420037526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6121",
            "leftCorner": {
              "x": -19.138,
              "y": -44.016,
              "z": 1.166
            },
            "rightCorner": {
              "x": -18.997,
              "y": -44.018,
              "z": 1.166
            },
            "gtin": "4104420037526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6124",
            "leftCorner": {
              "x": -18.865,
              "y": -43.98,
              "z": 1.166
            },
            "rightCorner": {
              "x": -18.537,
              "y": -43.985,
              "z": 1.166
            },
            "gtin": "4104420035768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6125",
            "leftCorner": {
              "x": -18.537,
              "y": -43.987,
              "z": 1.166
            },
            "rightCorner": {
              "x": -18.382,
              "y": -43.99,
              "z": 1.166
            },
            "gtin": "4104420177505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6126",
            "leftCorner": {
              "x": -18.382,
              "y": -43.986,
              "z": 1.166
            },
            "rightCorner": {
              "x": -18.165,
              "y": -43.99,
              "z": 1.166
            },
            "gtin": "4104420177543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6122",
            "leftCorner": {
              "x": -18.165,
              "y": -43.996,
              "z": 1.166
            },
            "rightCorner": {
              "x": -18.03,
              "y": -43.999,
              "z": 1.166
            },
            "gtin": "4104420143944",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0b7",
        "height": 1.5987,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d60d7",
            "leftCorner": {
              "x": -19.246,
              "y": -43.983,
              "z": 1.308
            },
            "rightCorner": {
              "x": -19.096,
              "y": -43.985,
              "z": 1.308
            },
            "gtin": "4104420173392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60d8",
            "leftCorner": {
              "x": -19.096,
              "y": -43.981,
              "z": 1.308
            },
            "rightCorner": {
              "x": -18.95,
              "y": -43.984,
              "z": 1.308
            },
            "gtin": "4104420173514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60d9",
            "leftCorner": {
              "x": -18.95,
              "y": -43.983,
              "z": 1.308
            },
            "rightCorner": {
              "x": -18.824,
              "y": -43.985,
              "z": 1.308
            },
            "gtin": "4005514063240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60da",
            "leftCorner": {
              "x": -18.824,
              "y": -43.984,
              "z": 1.308
            },
            "rightCorner": {
              "x": -18.678,
              "y": -43.986,
              "z": 1.308
            },
            "gtin": "4005514051759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60db",
            "leftCorner": {
              "x": -18.678,
              "y": -43.981,
              "z": 1.308
            },
            "rightCorner": {
              "x": -18.537,
              "y": -43.984,
              "z": 1.308
            },
            "gtin": "4005514040968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60dc",
            "leftCorner": {
              "x": -18.537,
              "y": -43.983,
              "z": 1.308
            },
            "rightCorner": {
              "x": -18.386,
              "y": -43.985,
              "z": 1.308
            },
            "gtin": "4005514040975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60dd",
            "leftCorner": {
              "x": -18.386,
              "y": -43.987,
              "z": 1.308
            },
            "rightCorner": {
              "x": -18.22,
              "y": -43.99,
              "z": 1.308
            },
            "gtin": "4005514051759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60de",
            "leftCorner": {
              "x": -18.22,
              "y": -43.996,
              "z": 1.308
            },
            "rightCorner": {
              "x": -18.139,
              "y": -43.997,
              "z": 1.308
            },
            "gtin": "4005514081657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60df",
            "leftCorner": {
              "x": -18.139,
              "y": -43.997,
              "z": 1.308
            },
            "rightCorner": {
              "x": -18.057,
              "y": -43.998,
              "z": 1.308
            },
            "gtin": "4005514081657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60e0",
            "leftCorner": {
              "x": -18.057,
              "y": -43.998,
              "z": 1.308
            },
            "rightCorner": {
              "x": -17.975,
              "y": -44.0,
              "z": 1.308
            },
            "gtin": "4005514081657",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "884",
    "rightNeighborShelfId": "886"
  },
  {
    "id": "886",
    "name": "886",
    "x": -18.029,
    "y": -43.967,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0079412,
      "w": 0.99997
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0c2",
        "height": 0.52462,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d614a",
            "leftCorner": {
              "x": -18.029,
              "y": -44.022,
              "z": 0.429
            },
            "rightCorner": {
              "x": -17.602,
              "y": -44.028,
              "z": 0.429
            },
            "gtin": "4260335837351",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d614c",
            "leftCorner": {
              "x": -17.601,
              "y": -43.987,
              "z": 0.429
            },
            "rightCorner": {
              "x": -17.326,
              "y": -43.992,
              "z": 0.429
            },
            "gtin": "4260654785746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d614d",
            "leftCorner": {
              "x": -17.326,
              "y": -43.992,
              "z": 0.429
            },
            "rightCorner": {
              "x": -17.051,
              "y": -43.996,
              "z": 0.429
            },
            "gtin": "4260654785746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d614b",
            "leftCorner": {
              "x": -17.051,
              "y": -43.998,
              "z": 0.429
            },
            "rightCorner": {
              "x": -16.779,
              "y": -44.003,
              "z": 0.429
            },
            "gtin": "4260718290018",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0c0",
        "height": 0.87372,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6137",
            "leftCorner": {
              "x": -18.029,
              "y": -44.023,
              "z": 0.715
            },
            "rightCorner": {
              "x": -17.899,
              "y": -44.025,
              "z": 0.715
            },
            "gtin": "4260654783476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6139",
            "leftCorner": {
              "x": -17.898,
              "y": -43.986,
              "z": 0.715
            },
            "rightCorner": {
              "x": -17.786,
              "y": -43.988,
              "z": 0.715
            },
            "gtin": "4260718295372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d613a",
            "leftCorner": {
              "x": -17.786,
              "y": -43.986,
              "z": 0.715
            },
            "rightCorner": {
              "x": -17.635,
              "y": -43.988,
              "z": 0.715
            },
            "gtin": "4260654781939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d613b",
            "leftCorner": {
              "x": -17.635,
              "y": -43.986,
              "z": 0.715
            },
            "rightCorner": {
              "x": -17.492,
              "y": -43.988,
              "z": 0.715
            },
            "gtin": "4260654781922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d613c",
            "leftCorner": {
              "x": -17.492,
              "y": -43.988,
              "z": 0.715
            },
            "rightCorner": {
              "x": -17.332,
              "y": -43.991,
              "z": 0.715
            },
            "gtin": "4260654789119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d613d",
            "leftCorner": {
              "x": -17.332,
              "y": -43.996,
              "z": 0.715
            },
            "rightCorner": {
              "x": -17.048,
              "y": -44.0,
              "z": 0.715
            },
            "gtin": "4260718295884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6138",
            "leftCorner": {
              "x": -17.048,
              "y": -43.999,
              "z": 0.715
            },
            "rightCorner": {
              "x": -16.779,
              "y": -44.004,
              "z": 0.715
            },
            "gtin": "4255582800487",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0bf",
        "height": 1.0999,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6127",
            "leftCorner": {
              "x": -18.03,
              "y": -44.024,
              "z": 0.9
            },
            "rightCorner": {
              "x": -17.836,
              "y": -44.027,
              "z": 0.9
            },
            "gtin": "4260718292487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6129",
            "leftCorner": {
              "x": -17.835,
              "y": -43.987,
              "z": 0.9
            },
            "rightCorner": {
              "x": -17.692,
              "y": -43.989,
              "z": 0.9
            },
            "gtin": "4255582808377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d612a",
            "leftCorner": {
              "x": -17.692,
              "y": -43.985,
              "z": 0.9
            },
            "rightCorner": {
              "x": -17.527,
              "y": -43.988,
              "z": 0.9
            },
            "gtin": "4255582805512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d612b",
            "leftCorner": {
              "x": -17.527,
              "y": -43.99,
              "z": 0.9
            },
            "rightCorner": {
              "x": -17.39,
              "y": -43.992,
              "z": 0.9
            },
            "gtin": "4255582805505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d612c",
            "leftCorner": {
              "x": -17.39,
              "y": -43.998,
              "z": 0.9
            },
            "rightCorner": {
              "x": -17.267,
              "y": -44.0,
              "z": 0.9
            },
            "gtin": "4260654789898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d612d",
            "leftCorner": {
              "x": -17.267,
              "y": -43.999,
              "z": 0.9
            },
            "rightCorner": {
              "x": -16.995,
              "y": -44.003,
              "z": 0.9
            },
            "gtin": "4255582809879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d612e",
            "leftCorner": {
              "x": -16.995,
              "y": -44.001,
              "z": 0.9
            },
            "rightCorner": {
              "x": -16.876,
              "y": -44.004,
              "z": 0.9
            },
            "gtin": "4260654782776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d612f",
            "leftCorner": {
              "x": -16.876,
              "y": -44.004,
              "z": 0.9
            },
            "rightCorner": {
              "x": -16.73,
              "y": -44.007,
              "z": 0.9
            },
            "gtin": "4260654782752",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0c1",
        "height": 1.3505,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d613e",
            "leftCorner": {
              "x": -18.03,
              "y": -44.027,
              "z": 1.105
            },
            "rightCorner": {
              "x": -17.91,
              "y": -44.029,
              "z": 1.105
            },
            "gtin": "4255582803303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d613f",
            "leftCorner": {
              "x": -17.91,
              "y": -44.029,
              "z": 1.105
            },
            "rightCorner": {
              "x": -17.791,
              "y": -44.03,
              "z": 1.105
            },
            "gtin": "4255582803303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6141",
            "leftCorner": {
              "x": -17.79,
              "y": -43.989,
              "z": 1.105
            },
            "rightCorner": {
              "x": -17.146,
              "y": -43.999,
              "z": 1.105
            },
            "gtin": "4260654781366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6142",
            "leftCorner": {
              "x": -17.146,
              "y": -44.004,
              "z": 1.105
            },
            "rightCorner": {
              "x": -16.936,
              "y": -44.007,
              "z": 1.105
            },
            "gtin": "4260335839355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6143",
            "leftCorner": {
              "x": -16.936,
              "y": -44.004,
              "z": 1.105
            },
            "rightCorner": {
              "x": -16.696,
              "y": -44.009,
              "z": 1.105
            },
            "gtin": "4260654783421",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0be",
        "height": 1.6003,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d60e1",
            "leftCorner": {
              "x": -17.975,
              "y": -43.996,
              "z": 1.309
            },
            "rightCorner": {
              "x": -17.833,
              "y": -43.998,
              "z": 1.309
            },
            "gtin": "4260654785234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60e2",
            "leftCorner": {
              "x": -17.833,
              "y": -43.993,
              "z": 1.309
            },
            "rightCorner": {
              "x": -17.686,
              "y": -43.995,
              "z": 1.309
            },
            "gtin": "4260335839560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60e3",
            "leftCorner": {
              "x": -17.686,
              "y": -43.988,
              "z": 1.309
            },
            "rightCorner": {
              "x": -17.351,
              "y": -43.993,
              "z": 1.309
            },
            "gtin": "4260335836804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60e4",
            "leftCorner": {
              "x": -17.351,
              "y": -44.007,
              "z": 1.309
            },
            "rightCorner": {
              "x": -17.064,
              "y": -44.012,
              "z": 1.309
            },
            "gtin": "4260335833841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60e5",
            "leftCorner": {
              "x": -17.064,
              "y": -44.005,
              "z": 1.309
            },
            "rightCorner": {
              "x": -16.615,
              "y": -44.013,
              "z": 1.309
            },
            "gtin": "4260335837511",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "885",
    "rightNeighborShelfId": "887"
  },
  {
    "id": "887",
    "name": "887",
    "x": -16.779,
    "y": -43.987,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0079412,
      "w": 0.99997
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 46
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0c9",
        "height": 0.17054,
        "facings": [
          {
            "id": "be29e8f60257a63f3044d830",
            "leftCorner": {
              "x": -16.781,
              "y": -44.081,
              "z": 0.14
            },
            "rightCorner": {
              "x": -16.673,
              "y": -44.083,
              "z": 0.14
            },
            "gtin": "4009790007912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "da70fdf3be6f9493721adc66",
            "leftCorner": {
              "x": -16.673,
              "y": -44.083,
              "z": 0.14
            },
            "rightCorner": {
              "x": -16.562,
              "y": -44.084,
              "z": 0.14
            },
            "gtin": "4009790008193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "74bcefc120f9ebd216f070ef",
            "leftCorner": {
              "x": -16.562,
              "y": -44.084,
              "z": 0.14
            },
            "rightCorner": {
              "x": -16.451,
              "y": -44.086,
              "z": 0.14
            },
            "gtin": "4009790008209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "83ad3ad62bc610b6e68b7713",
            "leftCorner": {
              "x": -16.451,
              "y": -44.086,
              "z": 0.14
            },
            "rightCorner": {
              "x": -16.336,
              "y": -44.088,
              "z": 0.14
            },
            "gtin": "4009790009008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f4aa90582c83a1a84d75571a",
            "leftCorner": {
              "x": -16.336,
              "y": -44.088,
              "z": 0.14
            },
            "rightCorner": {
              "x": -16.215,
              "y": -44.09,
              "z": 0.14
            },
            "gtin": "4009790008650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f9250eef25972eaf489d228a",
            "leftCorner": {
              "x": -16.215,
              "y": -44.09,
              "z": 0.14
            },
            "rightCorner": {
              "x": -16.09,
              "y": -44.092,
              "z": 0.14
            },
            "gtin": "4009790008186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "01139319e77078b6697db5e4",
            "leftCorner": {
              "x": -16.09,
              "y": -44.092,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.961,
              "y": -44.094,
              "z": 0.14
            },
            "gtin": "4009790007189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a78899eb23e0d24aed88aab4",
            "leftCorner": {
              "x": -15.961,
              "y": -44.094,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.823,
              "y": -44.096,
              "z": 0.14
            },
            "gtin": "4009790007202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e94307610eeb67984c685181",
            "leftCorner": {
              "x": -15.823,
              "y": -44.096,
              "z": 0.14
            },
            "rightCorner": {
              "x": -15.555,
              "y": -44.101,
              "z": 0.14
            },
            "gtin": "4009790007127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0c3",
        "height": 0.47619,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d614e",
            "leftCorner": {
              "x": -16.78,
              "y": -44.034,
              "z": 0.39
            },
            "rightCorner": {
              "x": -16.603,
              "y": -44.036,
              "z": 0.39
            },
            "gtin": "4260453440228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d614f",
            "leftCorner": {
              "x": -16.603,
              "y": -44.036,
              "z": 0.39
            },
            "rightCorner": {
              "x": -16.427,
              "y": -44.039,
              "z": 0.39
            },
            "gtin": "4260453440228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6153",
            "leftCorner": {
              "x": -16.427,
              "y": -44.002,
              "z": 0.39
            },
            "rightCorner": {
              "x": -16.299,
              "y": -44.004,
              "z": 0.39
            },
            "gtin": "4260453440365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6154",
            "leftCorner": {
              "x": -16.299,
              "y": -44.0,
              "z": 0.39
            },
            "rightCorner": {
              "x": -16.135,
              "y": -44.002,
              "z": 0.39
            },
            "gtin": "4260269060351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6155",
            "leftCorner": {
              "x": -16.135,
              "y": -43.998,
              "z": 0.39
            },
            "rightCorner": {
              "x": -15.958,
              "y": -44.001,
              "z": 0.39
            },
            "gtin": "4260269060399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6150",
            "leftCorner": {
              "x": -15.958,
              "y": -44.007,
              "z": 0.39
            },
            "rightCorner": {
              "x": -15.816,
              "y": -44.009,
              "z": 0.39
            },
            "gtin": "4260269060184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6151",
            "leftCorner": {
              "x": -15.816,
              "y": -44.009,
              "z": 0.39
            },
            "rightCorner": {
              "x": -15.673,
              "y": -44.011,
              "z": 0.39
            },
            "gtin": "4260269060184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6152",
            "leftCorner": {
              "x": -15.673,
              "y": -44.011,
              "z": 0.39
            },
            "rightCorner": {
              "x": -15.529,
              "y": -44.013,
              "z": 0.39
            },
            "gtin": "4260269060184",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0c6",
        "height": 0.7989,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6156",
            "leftCorner": {
              "x": -16.78,
              "y": -44.03,
              "z": 0.654
            },
            "rightCorner": {
              "x": -16.399,
              "y": -44.035,
              "z": 0.654
            },
            "gtin": "4104420024762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6158",
            "leftCorner": {
              "x": -16.399,
              "y": -44.0,
              "z": 0.654
            },
            "rightCorner": {
              "x": -16.282,
              "y": -44.003,
              "z": 0.654
            },
            "gtin": "4009790008650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6159",
            "leftCorner": {
              "x": -16.282,
              "y": -44.0,
              "z": 0.654
            },
            "rightCorner": {
              "x": -16.098,
              "y": -44.002,
              "z": 0.654
            },
            "gtin": "4009790008704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d615a",
            "leftCorner": {
              "x": -16.098,
              "y": -43.998,
              "z": 0.654
            },
            "rightCorner": {
              "x": -16.004,
              "y": -43.999,
              "z": 0.654
            },
            "gtin": "4009790007912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d615b",
            "leftCorner": {
              "x": -15.984,
              "y": -44.001,
              "z": 0.654
            },
            "rightCorner": {
              "x": -15.758,
              "y": -44.005,
              "z": 0.654
            },
            "gtin": "4009790007929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d615c",
            "leftCorner": {
              "x": -15.758,
              "y": -44.008,
              "z": 0.654
            },
            "rightCorner": {
              "x": -15.653,
              "y": -44.009,
              "z": 0.654
            },
            "gtin": "4009790008186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6157",
            "leftCorner": {
              "x": -15.653,
              "y": -44.006,
              "z": 0.654
            },
            "rightCorner": {
              "x": -15.53,
              "y": -44.008,
              "z": 0.654
            },
            "gtin": "4009790008193",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0c7",
        "height": 1.1012,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6130",
            "leftCorner": {
              "x": -16.73,
              "y": -44.002,
              "z": 0.901
            },
            "rightCorner": {
              "x": -16.616,
              "y": -44.005,
              "z": 0.901
            },
            "gtin": "4009790007141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6131",
            "leftCorner": {
              "x": -16.616,
              "y": -44.005,
              "z": 0.901
            },
            "rightCorner": {
              "x": -16.502,
              "y": -44.006,
              "z": 0.901
            },
            "gtin": "4009790007141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6132",
            "leftCorner": {
              "x": -16.502,
              "y": -44.006,
              "z": 0.901
            },
            "rightCorner": {
              "x": -16.388,
              "y": -44.008,
              "z": 0.901
            },
            "gtin": "4009790007141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6133",
            "leftCorner": {
              "x": -16.388,
              "y": -44.004,
              "z": 0.901
            },
            "rightCorner": {
              "x": -16.244,
              "y": -44.006,
              "z": 0.901
            },
            "gtin": "4009790007202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6134",
            "leftCorner": {
              "x": -16.244,
              "y": -44.0,
              "z": 0.901
            },
            "rightCorner": {
              "x": -16.1,
              "y": -44.002,
              "z": 0.901
            },
            "gtin": "4009790007233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6135",
            "leftCorner": {
              "x": -16.1,
              "y": -43.996,
              "z": 0.901
            },
            "rightCorner": {
              "x": -15.936,
              "y": -43.998,
              "z": 0.901
            },
            "gtin": "4009790007103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6136",
            "leftCorner": {
              "x": -15.937,
              "y": -44.002,
              "z": 0.901
            },
            "rightCorner": {
              "x": -15.673,
              "y": -44.006,
              "z": 0.901
            },
            "gtin": "4009790007127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6128",
            "leftCorner": {
              "x": -15.673,
              "y": -44.007,
              "z": 0.901
            },
            "rightCorner": {
              "x": -15.53,
              "y": -44.01,
              "z": 0.901
            },
            "gtin": "4009790007189",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0c5",
        "height": 1.3559,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6144",
            "leftCorner": {
              "x": -16.697,
              "y": -44.009,
              "z": 1.109
            },
            "rightCorner": {
              "x": -16.531,
              "y": -44.011,
              "z": 1.109
            },
            "gtin": "4009790007981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6145",
            "leftCorner": {
              "x": -16.531,
              "y": -44.01,
              "z": 1.109
            },
            "rightCorner": {
              "x": -16.396,
              "y": -44.012,
              "z": 1.109
            },
            "gtin": "4009790007974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6146",
            "leftCorner": {
              "x": -16.396,
              "y": -44.007,
              "z": 1.109
            },
            "rightCorner": {
              "x": -16.29,
              "y": -44.009,
              "z": 1.109
            },
            "gtin": "4009790008209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6147",
            "leftCorner": {
              "x": -16.29,
              "y": -44.009,
              "z": 1.109
            },
            "rightCorner": {
              "x": -16.144,
              "y": -44.012,
              "z": 1.109
            },
            "gtin": "4009790007639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6148",
            "leftCorner": {
              "x": -16.144,
              "y": -44.005,
              "z": 1.109
            },
            "rightCorner": {
              "x": -15.927,
              "y": -44.008,
              "z": 1.109
            },
            "gtin": "4009790007622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6149",
            "leftCorner": {
              "x": -15.927,
              "y": -44.013,
              "z": 1.109
            },
            "rightCorner": {
              "x": -15.767,
              "y": -44.016,
              "z": 1.109
            },
            "gtin": "4009790007400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6140",
            "leftCorner": {
              "x": -15.768,
              "y": -44.008,
              "z": 1.109
            },
            "rightCorner": {
              "x": -15.529,
              "y": -44.011,
              "z": 1.109
            },
            "gtin": "4009790008797",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0c4",
        "height": 1.6022,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d60e6",
            "leftCorner": {
              "x": -16.616,
              "y": -44.014,
              "z": 1.311
            },
            "rightCorner": {
              "x": -16.517,
              "y": -44.015,
              "z": 1.311
            },
            "gtin": "4009790009008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60e7",
            "leftCorner": {
              "x": -16.517,
              "y": -44.012,
              "z": 1.311
            },
            "rightCorner": {
              "x": -16.163,
              "y": -44.018,
              "z": 1.311
            },
            "gtin": "4009790009053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60e8",
            "leftCorner": {
              "x": -16.164,
              "y": -44.003,
              "z": 1.311
            },
            "rightCorner": {
              "x": -15.916,
              "y": -44.007,
              "z": 1.311
            },
            "gtin": "4009790009152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60e9",
            "leftCorner": {
              "x": -15.916,
              "y": -44.008,
              "z": 1.311
            },
            "rightCorner": {
              "x": -15.796,
              "y": -44.01,
              "z": 1.311
            },
            "gtin": "4009790008940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60ce",
            "leftCorner": {
              "x": -15.796,
              "y": -44.011,
              "z": 1.311
            },
            "rightCorner": {
              "x": -15.662,
              "y": -44.013,
              "z": 1.311
            },
            "gtin": "4009790008957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8b0e172e4e505c693a6042c6",
            "leftCorner": {
              "x": -16.78,
              "y": -44.036,
              "z": 1.311
            },
            "rightCorner": {
              "x": -16.655,
              "y": -44.038,
              "z": 1.311
            },
            "gtin": "4009790008940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d60cf",
            "leftCorner": {
              "x": -15.662,
              "y": -44.013,
              "z": 1.311
            },
            "rightCorner": {
              "x": -15.529,
              "y": -44.015,
              "z": 1.311
            },
            "gtin": "4009790008957",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "886"
  },
  {
    "id": "888",
    "name": "888",
    "x": -14.97,
    "y": -43.682,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70277,
      "w": 0.71141
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 27
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6b1",
        "height": 0.23649,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86d3",
            "leftCorner": {
              "x": -15.116,
              "y": -43.68,
              "z": 0.193
            },
            "rightCorner": {
              "x": -15.114,
              "y": -43.553,
              "z": 0.193
            },
            "gtin": "4038877020049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fd591060d27019bf662705cc",
            "leftCorner": {
              "x": -15.107,
              "y": -42.947,
              "z": 0.193
            },
            "rightCorner": {
              "x": -15.103,
              "y": -42.635,
              "z": 0.193
            },
            "gtin": "4038877000171",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "236f0d39880198df56a8477c",
            "leftCorner": {
              "x": -15.103,
              "y": -42.635,
              "z": 0.193
            },
            "rightCorner": {
              "x": -15.101,
              "y": -42.445,
              "z": 0.193
            },
            "gtin": "4038877000195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86d5",
            "leftCorner": {
              "x": -15.219,
              "y": -43.552,
              "z": 0.193
            },
            "rightCorner": {
              "x": -15.217,
              "y": -43.342,
              "z": 0.193
            },
            "gtin": "4038877000317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86d6",
            "leftCorner": {
              "x": -15.063,
              "y": -43.344,
              "z": 0.193
            },
            "rightCorner": {
              "x": -15.059,
              "y": -43.095,
              "z": 0.193
            },
            "gtin": "4038877000515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86d7",
            "leftCorner": {
              "x": -15.184,
              "y": -43.093,
              "z": 0.193
            },
            "rightCorner": {
              "x": -15.182,
              "y": -42.946,
              "z": 0.193
            },
            "gtin": "4038877000799",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6af",
        "height": 0.53458,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86c9",
            "leftCorner": {
              "x": -15.034,
              "y": -43.682,
              "z": 0.437
            },
            "rightCorner": {
              "x": -15.032,
              "y": -43.49,
              "z": 0.437
            },
            "gtin": "4038877000126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d0b0a849d3091ae81ef78880",
            "leftCorner": {
              "x": -15.023,
              "y": -42.762,
              "z": 0.437
            },
            "rightCorner": {
              "x": -15.02,
              "y": -42.526,
              "z": 0.437
            },
            "gtin": "4038877000089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86cb",
            "leftCorner": {
              "x": -15.051,
              "y": -43.489,
              "z": 0.437
            },
            "rightCorner": {
              "x": -15.048,
              "y": -43.223,
              "z": 0.437
            },
            "gtin": "4038877000133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86cc",
            "leftCorner": {
              "x": -15.062,
              "y": -43.222,
              "z": 0.437
            },
            "rightCorner": {
              "x": -15.06,
              "y": -42.986,
              "z": 0.437
            },
            "gtin": "4038877000089",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86cd",
            "leftCorner": {
              "x": -15.07,
              "y": -42.986,
              "z": 0.437
            },
            "rightCorner": {
              "x": -15.068,
              "y": -42.762,
              "z": 0.437
            },
            "gtin": "4038877000270",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6b0",
        "height": 0.84732,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86cf",
            "leftCorner": {
              "x": -15.024,
              "y": -43.681,
              "z": 0.693
            },
            "rightCorner": {
              "x": -15.02,
              "y": -43.403,
              "z": 0.693
            },
            "gtin": "4038877000652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86d1",
            "leftCorner": {
              "x": -15.055,
              "y": -43.403,
              "z": 0.693
            },
            "rightCorner": {
              "x": -15.053,
              "y": -43.214,
              "z": 0.693
            },
            "gtin": "4038877000195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86d2",
            "leftCorner": {
              "x": -15.062,
              "y": -43.214,
              "z": 0.693
            },
            "rightCorner": {
              "x": -15.056,
              "y": -42.785,
              "z": 0.693
            },
            "gtin": "4038877000522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86d0",
            "leftCorner": {
              "x": -15.073,
              "y": -42.784,
              "z": 0.693
            },
            "rightCorner": {
              "x": -15.069,
              "y": -42.431,
              "z": 0.693
            },
            "gtin": "4038877000614",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6ad",
        "height": 1.1502,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86bc",
            "leftCorner": {
              "x": -15.033,
              "y": -43.682,
              "z": 0.941
            },
            "rightCorner": {
              "x": -15.032,
              "y": -43.571,
              "z": 0.941
            },
            "gtin": "4038877000102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86be",
            "leftCorner": {
              "x": -15.03,
              "y": -43.57,
              "z": 0.941
            },
            "rightCorner": {
              "x": -15.029,
              "y": -43.483,
              "z": 0.941
            },
            "gtin": "4038877000188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86bf",
            "leftCorner": {
              "x": -15.052,
              "y": -43.483,
              "z": 0.941
            },
            "rightCorner": {
              "x": -15.05,
              "y": -43.366,
              "z": 0.941
            },
            "gtin": "4038877001130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86c0",
            "leftCorner": {
              "x": -15.06,
              "y": -43.366,
              "z": 0.941
            },
            "rightCorner": {
              "x": -15.056,
              "y": -43.039,
              "z": 0.941
            },
            "gtin": "4038877000560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86c1",
            "leftCorner": {
              "x": -15.064,
              "y": -43.039,
              "z": 0.941
            },
            "rightCorner": {
              "x": -15.062,
              "y": -42.901,
              "z": 0.941
            },
            "gtin": "4038877000546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86c2",
            "leftCorner": {
              "x": -15.071,
              "y": -42.901,
              "z": 0.941
            },
            "rightCorner": {
              "x": -15.07,
              "y": -42.805,
              "z": 0.941
            },
            "gtin": "4038877000041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86c3",
            "leftCorner": {
              "x": -15.072,
              "y": -42.805,
              "z": 0.941
            },
            "rightCorner": {
              "x": -15.072,
              "y": -42.749,
              "z": 0.941
            },
            "gtin": "4038877000058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86bd",
            "leftCorner": {
              "x": -15.078,
              "y": -42.678,
              "z": 0.941
            },
            "rightCorner": {
              "x": -15.075,
              "y": -42.431,
              "z": 0.941
            },
            "gtin": "4038877001611",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6ae",
        "height": 1.479,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86c5",
            "leftCorner": {
              "x": -15.024,
              "y": -43.681,
              "z": 1.21
            },
            "rightCorner": {
              "x": -15.022,
              "y": -43.515,
              "z": 1.21
            },
            "gtin": "4038578000104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86c7",
            "leftCorner": {
              "x": -15.043,
              "y": -43.516,
              "z": 1.21
            },
            "rightCorner": {
              "x": -15.041,
              "y": -43.242,
              "z": 1.21
            },
            "gtin": "4038578000005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86c8",
            "leftCorner": {
              "x": -15.058,
              "y": -43.241,
              "z": 1.21
            },
            "rightCorner": {
              "x": -15.055,
              "y": -42.973,
              "z": 1.21
            },
            "gtin": "4038877000010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86c6",
            "leftCorner": {
              "x": -15.06,
              "y": -42.973,
              "z": 1.21
            },
            "rightCorner": {
              "x": -15.053,
              "y": -42.432,
              "z": 1.21
            },
            "gtin": "4038877000065",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "889",
    "name": "889",
    "x": -19.109,
    "y": -46.239,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70462,
      "w": 0.70958
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d095",
        "height": 0.16951,
        "facings": [
          {
            "id": "7edeedfd7070b07d8ef9b8a8",
            "leftCorner": {
              "x": -19.179,
              "y": -46.239,
              "z": 0.139
            },
            "rightCorner": {
              "x": -19.178,
              "y": -46.377,
              "z": 0.139
            },
            "gtin": "4250208801909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3dbc099ce417f70d771ef886",
            "leftCorner": {
              "x": -19.178,
              "y": -46.377,
              "z": 0.139
            },
            "rightCorner": {
              "x": -19.177,
              "y": -46.515,
              "z": 0.139
            },
            "gtin": "4250208801930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d3f07ce740fc1a854ed29bb2",
            "leftCorner": {
              "x": -19.177,
              "y": -46.515,
              "z": 0.139
            },
            "rightCorner": {
              "x": -19.176,
              "y": -46.67,
              "z": 0.139
            },
            "gtin": "4250208801947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2b74a6163c650c5eed410ca2",
            "leftCorner": {
              "x": -19.176,
              "y": -46.67,
              "z": 0.139
            },
            "rightCorner": {
              "x": -19.175,
              "y": -46.878,
              "z": 0.139
            },
            "gtin": "4250208801879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f1b8d3a89022b4dbefa97a2c",
            "leftCorner": {
              "x": -19.175,
              "y": -46.878,
              "z": 0.139
            },
            "rightCorner": {
              "x": -19.173,
              "y": -47.094,
              "z": 0.139
            },
            "gtin": "4250208801893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9e5682e3984da7ba77918c11",
            "leftCorner": {
              "x": -19.173,
              "y": -47.094,
              "z": 0.139
            },
            "rightCorner": {
              "x": -19.172,
              "y": -47.232,
              "z": 0.139
            },
            "gtin": "4250208801930",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d090",
        "height": 0.56728,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5fc5",
            "leftCorner": {
              "x": -19.162,
              "y": -46.24,
              "z": 0.464
            },
            "rightCorner": {
              "x": -19.161,
              "y": -46.376,
              "z": 0.464
            },
            "gtin": "4250208801930",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d5fc7",
            "leftCorner": {
              "x": -19.121,
              "y": -46.376,
              "z": 0.464
            },
            "rightCorner": {
              "x": -19.121,
              "y": -46.577,
              "z": 0.464
            },
            "gtin": "4250208801916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fc9",
            "leftCorner": {
              "x": -19.119,
              "y": -46.608,
              "z": 0.464
            },
            "rightCorner": {
              "x": -19.116,
              "y": -46.886,
              "z": 0.464
            },
            "gtin": "4250208801923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fca",
            "leftCorner": {
              "x": -19.12,
              "y": -46.886,
              "z": 0.464
            },
            "rightCorner": {
              "x": -19.117,
              "y": -47.288,
              "z": 0.464
            },
            "gtin": "4250208871117",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d092",
        "height": 0.90555,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5fde",
            "leftCorner": {
              "x": -19.108,
              "y": -46.602,
              "z": 0.741
            },
            "rightCorner": {
              "x": -19.106,
              "y": -46.868,
              "z": 0.741
            },
            "gtin": "4250208801954",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "f7acd5edd5d3a491a0412d21",
            "leftCorner": {
              "x": -19.151,
              "y": -46.24,
              "z": 0.741
            },
            "rightCorner": {
              "x": -19.149,
              "y": -46.516,
              "z": 0.741
            },
            "gtin": "4250208801954",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d5fdf",
            "leftCorner": {
              "x": -19.108,
              "y": -46.868,
              "z": 0.741
            },
            "rightCorner": {
              "x": -19.105,
              "y": -47.297,
              "z": 0.741
            },
            "gtin": "4250208800025",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d091",
        "height": 1.2833,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5fd1",
            "leftCorner": {
              "x": -19.149,
              "y": -46.24,
              "z": 1.05
            },
            "rightCorner": {
              "x": -19.148,
              "y": -46.381,
              "z": 1.05
            },
            "gtin": "4250208801909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fd3",
            "leftCorner": {
              "x": -19.108,
              "y": -46.38,
              "z": 1.05
            },
            "rightCorner": {
              "x": -19.107,
              "y": -46.538,
              "z": 1.05
            },
            "gtin": "4250208801947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fd4",
            "leftCorner": {
              "x": -19.108,
              "y": -46.538,
              "z": 1.05
            },
            "rightCorner": {
              "x": -19.106,
              "y": -46.801,
              "z": 1.05
            },
            "gtin": "4250208801961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fd5",
            "leftCorner": {
              "x": -19.105,
              "y": -46.801,
              "z": 1.05
            },
            "rightCorner": {
              "x": -19.103,
              "y": -47.022,
              "z": 1.05
            },
            "gtin": "4250208801893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fd6",
            "leftCorner": {
              "x": -18.844,
              "y": -47.02,
              "z": 1.05
            },
            "rightCorner": {
              "x": -18.842,
              "y": -47.279,
              "z": 1.05
            },
            "gtin": "4250208801879",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "88a"
  },
  {
    "id": "88a",
    "name": "88a",
    "x": -19.102,
    "y": -47.239,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70462,
      "w": 0.70958
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d099",
        "height": 0.16886,
        "facings": [
          {
            "id": "f69b1d3ab30d4e17323c2b3f",
            "leftCorner": {
              "x": -19.202,
              "y": -47.239,
              "z": 0.138
            },
            "rightCorner": {
              "x": -19.201,
              "y": -47.323,
              "z": 0.138
            },
            "gtin": "4015537001099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a5380ef7216899cc83811fd0",
            "leftCorner": {
              "x": -19.201,
              "y": -47.323,
              "z": 0.138
            },
            "rightCorner": {
              "x": -19.201,
              "y": -47.41,
              "z": 0.138
            },
            "gtin": "4015537001075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3dd8a7181808fcdfdf7a0299",
            "leftCorner": {
              "x": -19.201,
              "y": -47.41,
              "z": 0.138
            },
            "rightCorner": {
              "x": -19.2,
              "y": -47.503,
              "z": 0.138
            },
            "gtin": "4015537001082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b68b0225b385660476dc0c7c",
            "leftCorner": {
              "x": -19.2,
              "y": -47.503,
              "z": 0.138
            },
            "rightCorner": {
              "x": -19.199,
              "y": -47.61,
              "z": 0.138
            },
            "gtin": "4015537442328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "177181577d8273181a20e2ca",
            "leftCorner": {
              "x": -19.199,
              "y": -47.61,
              "z": 0.138
            },
            "rightCorner": {
              "x": -19.199,
              "y": -47.718,
              "z": 0.138
            },
            "gtin": "4015537475029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c477efdf745918988f898993",
            "leftCorner": {
              "x": -19.199,
              "y": -47.718,
              "z": 0.138
            },
            "rightCorner": {
              "x": -19.198,
              "y": -47.826,
              "z": 0.138
            },
            "gtin": "4015537002010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ebc9baec7e5feef9aa606116",
            "leftCorner": {
              "x": -19.198,
              "y": -47.826,
              "z": 0.138
            },
            "rightCorner": {
              "x": -19.197,
              "y": -47.936,
              "z": 0.138
            },
            "gtin": "4015537001235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a31e0d69367e3bf4b75ca64a",
            "leftCorner": {
              "x": -19.197,
              "y": -47.936,
              "z": 0.138
            },
            "rightCorner": {
              "x": -19.196,
              "y": -48.063,
              "z": 0.138
            },
            "gtin": "4015537410426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "eb0b8bfbbf34229ab0c83626",
            "leftCorner": {
              "x": -19.196,
              "y": -48.063,
              "z": 0.138
            },
            "rightCorner": {
              "x": -19.195,
              "y": -48.196,
              "z": 0.138
            },
            "gtin": "4015537002416",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d096",
        "height": 0.56789,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5fcb",
            "leftCorner": {
              "x": -18.886,
              "y": -47.286,
              "z": 0.465
            },
            "rightCorner": {
              "x": -18.886,
              "y": -47.392,
              "z": 0.465
            },
            "gtin": "4015537001235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fcc",
            "leftCorner": {
              "x": -19.121,
              "y": -47.393,
              "z": 0.465
            },
            "rightCorner": {
              "x": -19.12,
              "y": -47.498,
              "z": 0.465
            },
            "gtin": "4015537002010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fcd",
            "leftCorner": {
              "x": -19.117,
              "y": -47.498,
              "z": 0.465
            },
            "rightCorner": {
              "x": -19.117,
              "y": -47.634,
              "z": 0.465
            },
            "gtin": "4015537002737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fce",
            "leftCorner": {
              "x": -19.115,
              "y": -47.635,
              "z": 0.465
            },
            "rightCorner": {
              "x": -19.113,
              "y": -47.97,
              "z": 0.465
            },
            "gtin": "4015537002720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fcf",
            "leftCorner": {
              "x": -19.111,
              "y": -47.97,
              "z": 0.465
            },
            "rightCorner": {
              "x": -19.11,
              "y": -48.049,
              "z": 0.465
            },
            "gtin": "4015537001082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fd0",
            "leftCorner": {
              "x": -19.109,
              "y": -48.049,
              "z": 0.465
            },
            "rightCorner": {
              "x": -19.108,
              "y": -48.133,
              "z": 0.465
            },
            "gtin": "4015537001075",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fc6",
            "leftCorner": {
              "x": -19.105,
              "y": -48.133,
              "z": 0.465
            },
            "rightCorner": {
              "x": -19.105,
              "y": -48.239,
              "z": 0.465
            },
            "gtin": "4015537001099",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d098",
        "height": 0.908,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5fe0",
            "leftCorner": {
              "x": -19.108,
              "y": -47.297,
              "z": 0.743
            },
            "rightCorner": {
              "x": -19.105,
              "y": -47.677,
              "z": 0.743
            },
            "gtin": "4015537002942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fe1",
            "leftCorner": {
              "x": -19.101,
              "y": -47.677,
              "z": 0.743
            },
            "rightCorner": {
              "x": -19.1,
              "y": -47.9,
              "z": 0.743
            },
            "gtin": "4015537002812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fe2",
            "leftCorner": {
              "x": -19.104,
              "y": -47.9,
              "z": 0.743
            },
            "rightCorner": {
              "x": -19.103,
              "y": -48.017,
              "z": 0.743
            },
            "gtin": "4015537002416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fdd",
            "leftCorner": {
              "x": -19.095,
              "y": -48.017,
              "z": 0.743
            },
            "rightCorner": {
              "x": -19.094,
              "y": -48.239,
              "z": 0.743
            },
            "gtin": "4015537000771",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d097",
        "height": 1.2853,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5fd7",
            "leftCorner": {
              "x": -19.104,
              "y": -47.281,
              "z": 1.052
            },
            "rightCorner": {
              "x": -19.103,
              "y": -47.387,
              "z": 1.052
            },
            "gtin": "4015537475029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fd8",
            "leftCorner": {
              "x": -19.103,
              "y": -47.387,
              "z": 1.052
            },
            "rightCorner": {
              "x": -19.102,
              "y": -47.505,
              "z": 1.052
            },
            "gtin": "4015537410426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fd9",
            "leftCorner": {
              "x": -19.102,
              "y": -47.505,
              "z": 1.052
            },
            "rightCorner": {
              "x": -19.1,
              "y": -47.714,
              "z": 1.052
            },
            "gtin": "4015537443325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fda",
            "leftCorner": {
              "x": -19.099,
              "y": -47.714,
              "z": 1.052
            },
            "rightCorner": {
              "x": -19.097,
              "y": -47.93,
              "z": 1.052
            },
            "gtin": "4015537001044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fdb",
            "leftCorner": {
              "x": -19.1,
              "y": -47.93,
              "z": 1.052
            },
            "rightCorner": {
              "x": -19.099,
              "y": -48.001,
              "z": 1.052
            },
            "gtin": "4015537442328",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d5fd2",
            "leftCorner": {
              "x": -19.093,
              "y": -48.001,
              "z": 1.052
            },
            "rightCorner": {
              "x": -19.091,
              "y": -48.239,
              "z": 1.052
            },
            "gtin": "4015537002799",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "889"
  },
  {
    "id": "88b",
    "name": "88b",
    "x": -17.868,
    "y": -48.242,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71111,
      "w": 0.70308
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 26
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d09e",
        "height": 0.17176,
        "facings": [
          {
            "id": "3b563987d5025bef1e7a96f2",
            "leftCorner": {
              "x": -17.793,
              "y": -48.241,
              "z": 0.141
            },
            "rightCorner": {
              "x": -17.795,
              "y": -48.031,
              "z": 0.141
            },
            "gtin": "4008258292013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "56db4c95df911e153d7a3de2",
            "leftCorner": {
              "x": -17.795,
              "y": -48.031,
              "z": 0.141
            },
            "rightCorner": {
              "x": -17.798,
              "y": -47.812,
              "z": 0.141
            },
            "gtin": "4008258462003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e8bfdd2a54ca27e8d2f04920",
            "leftCorner": {
              "x": -17.798,
              "y": -47.812,
              "z": 0.141
            },
            "rightCorner": {
              "x": -17.8,
              "y": -47.591,
              "z": 0.141
            },
            "gtin": "4008258021026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a4a6cc967eb5de35d5a4f4ed",
            "leftCorner": {
              "x": -17.8,
              "y": -47.591,
              "z": 0.141
            },
            "rightCorner": {
              "x": -17.802,
              "y": -47.479,
              "z": 0.141
            },
            "gtin": "4008258130018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b996ae924919c08439e58b0b",
            "leftCorner": {
              "x": -17.802,
              "y": -47.479,
              "z": 0.141
            },
            "rightCorner": {
              "x": -17.804,
              "y": -47.251,
              "z": 0.141
            },
            "gtin": "4008258419014",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d09c",
        "height": 0.46564,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6001",
            "leftCorner": {
              "x": -17.813,
              "y": -48.241,
              "z": 0.381
            },
            "rightCorner": {
              "x": -17.816,
              "y": -47.946,
              "z": 0.381
            },
            "gtin": "4008258021064",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6003",
            "leftCorner": {
              "x": -17.856,
              "y": -47.947,
              "z": 0.381
            },
            "rightCorner": {
              "x": -17.858,
              "y": -47.782,
              "z": 0.381
            },
            "gtin": "4008258014004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6004",
            "leftCorner": {
              "x": -17.858,
              "y": -47.782,
              "z": 0.381
            },
            "rightCorner": {
              "x": -17.86,
              "y": -47.617,
              "z": 0.381
            },
            "gtin": "4008258155004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6005",
            "leftCorner": {
              "x": -17.862,
              "y": -47.617,
              "z": 0.381
            },
            "rightCorner": {
              "x": -17.865,
              "y": -47.329,
              "z": 0.381
            },
            "gtin": "4008258100011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6006",
            "leftCorner": {
              "x": -17.866,
              "y": -47.329,
              "z": 0.381
            },
            "rightCorner": {
              "x": -17.867,
              "y": -47.181,
              "z": 0.381
            },
            "gtin": "4008258038000",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d09a",
        "height": 0.70252,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5feb",
            "leftCorner": {
              "x": -17.824,
              "y": -48.241,
              "z": 0.575
            },
            "rightCorner": {
              "x": -17.827,
              "y": -48.017,
              "z": 0.575
            },
            "gtin": "4008258358047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fed",
            "leftCorner": {
              "x": -17.866,
              "y": -48.017,
              "z": 0.575
            },
            "rightCorner": {
              "x": -17.867,
              "y": -47.864,
              "z": 0.575
            },
            "gtin": "4008258185001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fee",
            "leftCorner": {
              "x": -17.867,
              "y": -47.864,
              "z": 0.575
            },
            "rightCorner": {
              "x": -17.87,
              "y": -47.623,
              "z": 0.575
            },
            "gtin": "4008258419014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fef",
            "leftCorner": {
              "x": -17.874,
              "y": -47.623,
              "z": 0.575
            },
            "rightCorner": {
              "x": -17.876,
              "y": -47.463,
              "z": 0.575
            },
            "gtin": "4008258403020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ff0",
            "leftCorner": {
              "x": -17.873,
              "y": -47.463,
              "z": 0.575
            },
            "rightCorner": {
              "x": -17.875,
              "y": -47.308,
              "z": 0.575
            },
            "gtin": "4008258274019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ff1",
            "leftCorner": {
              "x": -17.878,
              "y": -47.308,
              "z": 0.575
            },
            "rightCorner": {
              "x": -17.879,
              "y": -47.197,
              "z": 0.575
            },
            "gtin": "4008258171011",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d09d",
        "height": 0.95853,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d600c",
            "leftCorner": {
              "x": -17.826,
              "y": -48.242,
              "z": 0.784
            },
            "rightCorner": {
              "x": -17.829,
              "y": -47.967,
              "z": 0.784
            },
            "gtin": "4008258074008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5cfddb89a1acc66120be7abc",
            "leftCorner": {
              "x": -17.829,
              "y": -47.967,
              "z": 0.784
            },
            "rightCorner": {
              "x": -17.831,
              "y": -47.774,
              "z": 0.784
            },
            "gtin": "4008258074008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e028254d8d2b263e6b7dc258",
            "leftCorner": {
              "x": -17.831,
              "y": -47.774,
              "z": 0.784
            },
            "rightCorner": {
              "x": -17.833,
              "y": -47.662,
              "z": 0.784
            },
            "gtin": "4008258130018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d600f",
            "leftCorner": {
              "x": -17.873,
              "y": -47.622,
              "z": 0.784
            },
            "rightCorner": {
              "x": -17.877,
              "y": -47.258,
              "z": 0.784
            },
            "gtin": "4008258046005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6010",
            "leftCorner": {
              "x": -17.88,
              "y": -47.258,
              "z": 0.784
            },
            "rightCorner": {
              "x": -17.881,
              "y": -47.168,
              "z": 0.784
            },
            "gtin": "4008258130018",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d09b",
        "height": 1.2078,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5ff8",
            "leftCorner": {
              "x": -17.864,
              "y": -48.028,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.866,
              "y": -47.853,
              "z": 0.988
            },
            "gtin": "4008258507025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d4662f4408c77b1845f5dc31",
            "leftCorner": {
              "x": -17.825,
              "y": -48.242,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.827,
              "y": -48.056,
              "z": 0.988
            },
            "gtin": "4008258507025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ff9",
            "leftCorner": {
              "x": -17.868,
              "y": -47.853,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.871,
              "y": -47.673,
              "z": 0.988
            },
            "gtin": "4008258052006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ffa",
            "leftCorner": {
              "x": -17.872,
              "y": -47.673,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.873,
              "y": -47.541,
              "z": 0.988
            },
            "gtin": "4008258045039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ffb",
            "leftCorner": {
              "x": -17.87,
              "y": -47.541,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.872,
              "y": -47.397,
              "z": 0.988
            },
            "gtin": "4008258144008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ffc",
            "leftCorner": {
              "x": -17.875,
              "y": -47.397,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.878,
              "y": -47.116,
              "z": 0.988
            },
            "gtin": "4008258048047",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "88c"
  },
  {
    "id": "88c",
    "name": "88c",
    "x": -17.88,
    "y": -47.243,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71111,
      "w": 0.70308
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 30
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d0a3",
        "height": 0.17307,
        "facings": [
          {
            "id": "1b0509fd57eb711c3bead958",
            "leftCorner": {
              "x": -17.79,
              "y": -47.242,
              "z": 0.142
            },
            "rightCorner": {
              "x": -17.79,
              "y": -47.215,
              "z": 0.142
            },
            "gtin": "4008258157008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ddaeb8db507b65d2d24d4e5e",
            "leftCorner": {
              "x": -17.79,
              "y": -47.215,
              "z": 0.142
            },
            "rightCorner": {
              "x": -17.791,
              "y": -47.11,
              "z": 0.142
            },
            "gtin": "4008258276006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "45fad0ac1e1a2d6c86c58dd0",
            "leftCorner": {
              "x": -17.791,
              "y": -47.11,
              "z": 0.142
            },
            "rightCorner": {
              "x": -17.793,
              "y": -46.985,
              "z": 0.142
            },
            "gtin": "4008258041116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c61368c5e790b4e2cf71c02e",
            "leftCorner": {
              "x": -17.793,
              "y": -46.985,
              "z": 0.142
            },
            "rightCorner": {
              "x": -17.794,
              "y": -46.855,
              "z": 0.142
            },
            "gtin": "4008258107010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1b7b9ccfe785043522ee7f8a",
            "leftCorner": {
              "x": -17.794,
              "y": -46.855,
              "z": 0.142
            },
            "rightCorner": {
              "x": -17.796,
              "y": -46.724,
              "z": 0.142
            },
            "gtin": "4008258252017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b708a287e2fb88c5c5924c80",
            "leftCorner": {
              "x": -17.796,
              "y": -46.724,
              "z": 0.142
            },
            "rightCorner": {
              "x": -17.798,
              "y": -46.582,
              "z": 0.142
            },
            "gtin": "4008258154229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f70f68b695c16ed03a27f8fb",
            "leftCorner": {
              "x": -17.798,
              "y": -46.582,
              "z": 0.142
            },
            "rightCorner": {
              "x": -17.799,
              "y": -46.439,
              "z": 0.142
            },
            "gtin": "4008258016008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0bdbfc96abd96005498a38d0",
            "leftCorner": {
              "x": -17.799,
              "y": -46.439,
              "z": 0.142
            },
            "rightCorner": {
              "x": -17.801,
              "y": -46.252,
              "z": 0.142
            },
            "gtin": "4008258065013",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0a0",
        "height": 0.46462,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6007",
            "leftCorner": {
              "x": -17.867,
              "y": -47.194,
              "z": 0.38
            },
            "rightCorner": {
              "x": -17.869,
              "y": -47.064,
              "z": 0.38
            },
            "gtin": "4008258041116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6008",
            "leftCorner": {
              "x": -17.861,
              "y": -47.064,
              "z": 0.38
            },
            "rightCorner": {
              "x": -17.863,
              "y": -46.919,
              "z": 0.38
            },
            "gtin": "4008258157008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6009",
            "leftCorner": {
              "x": -17.86,
              "y": -46.919,
              "z": 0.38
            },
            "rightCorner": {
              "x": -17.863,
              "y": -46.775,
              "z": 0.38
            },
            "gtin": "4008258028001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d600a",
            "leftCorner": {
              "x": -17.864,
              "y": -46.775,
              "z": 0.38
            },
            "rightCorner": {
              "x": -17.865,
              "y": -46.579,
              "z": 0.38
            },
            "gtin": "4008258065013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d600b",
            "leftCorner": {
              "x": -17.862,
              "y": -46.579,
              "z": 0.38
            },
            "rightCorner": {
              "x": -17.864,
              "y": -46.382,
              "z": 0.38
            },
            "gtin": "4008258073049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6002",
            "leftCorner": {
              "x": -17.868,
              "y": -46.382,
              "z": 0.38
            },
            "rightCorner": {
              "x": -17.87,
              "y": -46.243,
              "z": 0.38
            },
            "gtin": "4008258016008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a44055a3e408c4826d4e0655",
            "leftCorner": {
              "x": -17.818,
              "y": -47.242,
              "z": 0.38
            },
            "rightCorner": {
              "x": -17.818,
              "y": -47.215,
              "z": 0.38
            },
            "gtin": "4008258157008",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0a1",
        "height": 0.7028,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5ff2",
            "leftCorner": {
              "x": -17.881,
              "y": -47.207,
              "z": 0.575
            },
            "rightCorner": {
              "x": -17.885,
              "y": -46.909,
              "z": 0.575
            },
            "gtin": "4008258290019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ff3",
            "leftCorner": {
              "x": -17.87,
              "y": -46.909,
              "z": 0.575
            },
            "rightCorner": {
              "x": -17.873,
              "y": -46.673,
              "z": 0.575
            },
            "gtin": "4008258252024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ff4",
            "leftCorner": {
              "x": -17.877,
              "y": -46.673,
              "z": 0.575
            },
            "rightCorner": {
              "x": -17.878,
              "y": -46.538,
              "z": 0.575
            },
            "gtin": "4008258252017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ff5",
            "leftCorner": {
              "x": -17.875,
              "y": -46.538,
              "z": 0.575
            },
            "rightCorner": {
              "x": -17.877,
              "y": -46.338,
              "z": 0.575
            },
            "gtin": "4008258293003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fec",
            "leftCorner": {
              "x": -17.876,
              "y": -46.338,
              "z": 0.575
            },
            "rightCorner": {
              "x": -17.877,
              "y": -46.243,
              "z": 0.575
            },
            "gtin": "4008258276006",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d0a2",
        "height": 0.95654,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6011",
            "leftCorner": {
              "x": -17.875,
              "y": -47.184,
              "z": 0.783
            },
            "rightCorner": {
              "x": -17.879,
              "y": -46.877,
              "z": 0.783
            },
            "gtin": "4008258150092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6012",
            "leftCorner": {
              "x": -17.869,
              "y": -46.877,
              "z": 0.783
            },
            "rightCorner": {
              "x": -17.871,
              "y": -46.705,
              "z": 0.783
            },
            "gtin": "4008258156001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6013",
            "leftCorner": {
              "x": -17.871,
              "y": -46.705,
              "z": 0.783
            },
            "rightCorner": {
              "x": -17.873,
              "y": -46.532,
              "z": 0.783
            },
            "gtin": "4008258156001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6014",
            "leftCorner": {
              "x": -17.877,
              "y": -46.532,
              "z": 0.783
            },
            "rightCorner": {
              "x": -17.878,
              "y": -46.393,
              "z": 0.783
            },
            "gtin": "4008258154229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d600d",
            "leftCorner": {
              "x": -17.88,
              "y": -46.393,
              "z": 0.783
            },
            "rightCorner": {
              "x": -17.883,
              "y": -46.243,
              "z": 0.783
            },
            "gtin": "4008258154236",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d09f",
        "height": 1.2078,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5ffd",
            "leftCorner": {
              "x": -17.875,
              "y": -47.142,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.877,
              "y": -46.979,
              "z": 0.988
            },
            "gtin": "4008258048030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ffe",
            "leftCorner": {
              "x": -17.873,
              "y": -46.979,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.874,
              "y": -46.817,
              "z": 0.988
            },
            "gtin": "4008258121016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fff",
            "leftCorner": {
              "x": -17.872,
              "y": -46.817,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.873,
              "y": -46.686,
              "z": 0.988
            },
            "gtin": "4008258107010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6000",
            "leftCorner": {
              "x": -17.874,
              "y": -46.686,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.877,
              "y": -46.54,
              "z": 0.988
            },
            "gtin": "4008258423011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5ff7",
            "leftCorner": {
              "x": -17.878,
              "y": -46.54,
              "z": 0.988
            },
            "rightCorner": {
              "x": -17.881,
              "y": -46.243,
              "z": 0.988
            },
            "gtin": "4008258150108",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "88b"
  },
  {
    "id": "88d",
    "name": "88d",
    "x": -4.9465,
    "y": -26.533,
    "width": 1.25,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 5.5697E-4,
      "y": 5.4474E-4,
      "z": 0.92712,
      "w": 0.37477
    },
    "layers": [],

    "rightNeighborShelfId": "a87"
  },
  {
    "id": "88f",
    "name": "88f",
    "x": -5.8454,
    "y": -25.664,
    "width": 1.25,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 5.5697E-4,
      "y": 5.4474E-4,
      "z": 0.92712,
      "w": 0.37478
    },
    "layers": []
  },
  {
    "id": "890",
    "name": "890",
    "x": -7.9613,
    "y": -25.97,
    "width": 1.25,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -4.5945E-4,
      "y": 5.1635E-4,
      "z": -0.37584,
      "w": 0.92668
    },
    "layers": [],

    "rightNeighborShelfId": "891"
  },
  {
    "id": "891",
    "name": "891",
    "x": -7.0644,
    "y": -26.841,
    "width": 1.25,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -4.5945E-4,
      "y": 5.1635E-4,
      "z": -0.37584,
      "w": 0.92668
    },
    "layers": [],
    "leftNeighborShelfId": "890"
  },
  {
    "id": "892",
    "name": "892",
    "x": -5.5341,
    "y": -28.252,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -5.5568E-4,
      "y": 3.6783E-4,
      "z": 0.37871,
      "w": 0.92551
    },
    "layers": [],

    "rightNeighborShelfId": "893"
  },
  {
    "id": "893",
    "name": "893",
    "x": -4.8209,
    "y": -27.551,
    "width": 0.8,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -5.5568E-4,
      "y": 3.6783E-4,
      "z": 0.37871,
      "w": 0.92551
    },
    "layers": [],
    "leftNeighborShelfId": "892"
  },
  {
    "id": "894",
    "name": "894",
    "x": -7.31,
    "y": -24.163,
    "width": 1.0,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 7.588E-4,
      "y": -3.6997E-5,
      "z": 0.92035,
      "w": -0.39109
    },
    "layers": [],

    "rightNeighborShelfId": "895"
  },
  {
    "id": "895",
    "name": "895",
    "x": -8.0146,
    "y": -24.881,
    "width": 0.8,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 7.2508E-4,
      "y": -4.5219E-5,
      "z": 0.92346,
      "w": -0.38368
    },
    "layers": [],
    "leftNeighborShelfId": "894"
  },
  {
    "id": "970",
    "name": "970",
    "x": -9.191,
    "y": -2.121,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71166,
      "w": 0.70253
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 58
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d54d",
        "height": 0.62299,
        "facings": [
          {
            "id": "68d8e50de1820c81800d81c7",
            "leftCorner": {
              "x": -9.276,
              "y": -2.122,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.278,
              "y": -1.967,
              "z": 0.51
            },
            "gtin": "4250426224405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81c9",
            "leftCorner": {
              "x": -9.299,
              "y": -1.967,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.3,
              "y": -1.821,
              "z": 0.51
            },
            "gtin": "4051009005493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81ca",
            "leftCorner": {
              "x": -9.269,
              "y": -1.821,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.271,
              "y": -1.709,
              "z": 0.51
            },
            "gtin": "4051009040999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81cb",
            "leftCorner": {
              "x": -9.316,
              "y": -1.71,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.317,
              "y": -1.59,
              "z": 0.51
            },
            "gtin": "4051009034950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81cc",
            "leftCorner": {
              "x": -9.321,
              "y": -1.59,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.322,
              "y": -1.464,
              "z": 0.51
            },
            "gtin": "4041384000145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81cd",
            "leftCorner": {
              "x": -9.328,
              "y": -1.464,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.329,
              "y": -1.343,
              "z": 0.51
            },
            "gtin": "4041384000503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81ce",
            "leftCorner": {
              "x": -9.331,
              "y": -1.343,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.332,
              "y": -1.241,
              "z": 0.51
            },
            "gtin": "4041384000381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81cf",
            "leftCorner": {
              "x": -9.334,
              "y": -1.241,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.335,
              "y": -1.165,
              "z": 0.51
            },
            "gtin": "4041384000442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81d0",
            "leftCorner": {
              "x": -9.335,
              "y": -1.165,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.336,
              "y": -1.089,
              "z": 0.51
            },
            "gtin": "4041384000442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81d1",
            "leftCorner": {
              "x": -9.332,
              "y": -1.089,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.334,
              "y": -0.948,
              "z": 0.51
            },
            "gtin": "4041384000268",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d81d2",
            "leftCorner": {
              "x": -9.333,
              "y": -0.948,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.335,
              "y": -0.82,
              "z": 0.51
            },
            "gtin": "4045800460254",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d54e",
        "height": 0.93386,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8176",
            "leftCorner": {
              "x": -9.306,
              "y": -2.02,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.307,
              "y": -1.972,
              "z": 0.764
            },
            "gtin": "4021900006561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "841cc39dbac8e8ca0ff65638",
            "leftCorner": {
              "x": -9.263,
              "y": -2.122,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.264,
              "y": -2.045,
              "z": 0.764
            },
            "gtin": "4013276161098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8177",
            "leftCorner": {
              "x": -9.301,
              "y": -1.972,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.302,
              "y": -1.889,
              "z": 0.764
            },
            "gtin": "4002239229005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8178",
            "leftCorner": {
              "x": -9.305,
              "y": -1.889,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.306,
              "y": -1.791,
              "z": 0.764
            },
            "gtin": "4051009003116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8179",
            "leftCorner": {
              "x": -9.305,
              "y": -1.791,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.307,
              "y": -1.68,
              "z": 0.764
            },
            "gtin": "4051009034837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d817a",
            "leftCorner": {
              "x": -9.313,
              "y": -1.681,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.315,
              "y": -1.575,
              "z": 0.764
            },
            "gtin": "4051009034851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d817b",
            "leftCorner": {
              "x": -9.321,
              "y": -1.575,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.322,
              "y": -1.496,
              "z": 0.764
            },
            "gtin": "4051009034592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d817c",
            "leftCorner": {
              "x": -9.279,
              "y": -1.496,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.28,
              "y": -1.407,
              "z": 0.764
            },
            "gtin": "4051009034615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d817d",
            "leftCorner": {
              "x": -9.243,
              "y": -1.406,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.244,
              "y": -1.316,
              "z": 0.764
            },
            "gtin": "4051009034691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d817e",
            "leftCorner": {
              "x": -9.323,
              "y": -1.317,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.324,
              "y": -1.225,
              "z": 0.764
            },
            "gtin": "4051009034714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d817f",
            "leftCorner": {
              "x": -9.328,
              "y": -1.225,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.329,
              "y": -1.128,
              "z": 0.764
            },
            "gtin": "4051009034738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8180",
            "leftCorner": {
              "x": -9.285,
              "y": -1.127,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.286,
              "y": -1.03,
              "z": 0.764
            },
            "gtin": "8710506083651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8181",
            "leftCorner": {
              "x": -9.322,
              "y": -1.03,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.323,
              "y": -0.942,
              "z": 0.764
            },
            "gtin": "8710506084047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8182",
            "leftCorner": {
              "x": -9.248,
              "y": -0.941,
              "z": 0.764
            },
            "rightCorner": {
              "x": -9.25,
              "y": -0.818,
              "z": 0.764
            },
            "gtin": "8710506084016",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d54c",
        "height": 1.2302,
        "facings": [
          {
            "id": "68d8e50de1820c81800d810b",
            "leftCorner": {
              "x": -9.31,
              "y": -2.018,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.311,
              "y": -1.932,
              "z": 1.007
            },
            "gtin": "4051009034790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "86cbd4fdbc06a9c9f4b8f842",
            "leftCorner": {
              "x": -9.272,
              "y": -2.122,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.274,
              "y": -2.023,
              "z": 1.007
            },
            "gtin": "4051009024906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d11d4f0ecd0154ba59c994b6",
            "leftCorner": {
              "x": -9.285,
              "y": -1.15,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.286,
              "y": -1.035,
              "z": 1.007
            },
            "gtin": "4045800770759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d810c",
            "leftCorner": {
              "x": -9.31,
              "y": -1.932,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.312,
              "y": -1.82,
              "z": 1.007
            },
            "gtin": "4051009024906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d810d",
            "leftCorner": {
              "x": -9.316,
              "y": -1.82,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.318,
              "y": -1.67,
              "z": 1.007
            },
            "gtin": "4045800201222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d810e",
            "leftCorner": {
              "x": -9.321,
              "y": -1.67,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.322,
              "y": -1.556,
              "z": 1.007
            },
            "gtin": "4045800301229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d810f",
            "leftCorner": {
              "x": -9.24,
              "y": -1.555,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.241,
              "y": -1.419,
              "z": 1.007
            },
            "gtin": "4045800125610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8110",
            "leftCorner": {
              "x": -9.245,
              "y": -1.419,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.246,
              "y": -1.347,
              "z": 1.007
            },
            "gtin": "4051009034677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8111",
            "leftCorner": {
              "x": -9.29,
              "y": -1.348,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.291,
              "y": -1.256,
              "z": 1.007
            },
            "gtin": "4024698464964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8112",
            "leftCorner": {
              "x": -9.331,
              "y": -1.257,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.332,
              "y": -1.151,
              "z": 1.007
            },
            "gtin": "4024698464988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8115",
            "leftCorner": {
              "x": -9.337,
              "y": -1.031,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.338,
              "y": -0.915,
              "z": 1.007
            },
            "gtin": "4045800770841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8116",
            "leftCorner": {
              "x": -9.34,
              "y": -0.915,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.341,
              "y": -0.808,
              "z": 1.007
            },
            "gtin": "4030800067381",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d54f",
        "height": 1.5344,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8136",
            "leftCorner": {
              "x": -9.309,
              "y": -2.498,
              "z": 1.254
            },
            "rightCorner": {
              "x": -9.318,
              "y": -2.002,
              "z": 1.254
            },
            "gtin": "4009457381591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8138",
            "leftCorner": {
              "x": -9.259,
              "y": -1.98,
              "z": 1.255
            },
            "rightCorner": {
              "x": -9.26,
              "y": -1.894,
              "z": 1.255
            },
            "gtin": "4024698462229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8139",
            "leftCorner": {
              "x": -9.302,
              "y": -1.894,
              "z": 1.255
            },
            "rightCorner": {
              "x": -9.303,
              "y": -1.805,
              "z": 1.255
            },
            "gtin": "4024698462229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d813a",
            "leftCorner": {
              "x": -9.304,
              "y": -1.805,
              "z": 1.255
            },
            "rightCorner": {
              "x": -9.305,
              "y": -1.706,
              "z": 1.255
            },
            "gtin": "4024698462953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d813b",
            "leftCorner": {
              "x": -9.309,
              "y": -1.706,
              "z": 1.255
            },
            "rightCorner": {
              "x": -9.31,
              "y": -1.616,
              "z": 1.255
            },
            "gtin": "4045800213386",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d813c",
            "leftCorner": {
              "x": -9.313,
              "y": -1.616,
              "z": 1.255
            },
            "rightCorner": {
              "x": -9.314,
              "y": -1.53,
              "z": 1.255
            },
            "gtin": "4045800217261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d813d",
            "leftCorner": {
              "x": -9.315,
              "y": -1.53,
              "z": 1.255
            },
            "rightCorner": {
              "x": -9.316,
              "y": -1.432,
              "z": 1.255
            },
            "gtin": "4045800571264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d813e",
            "leftCorner": {
              "x": -9.32,
              "y": -1.432,
              "z": 1.255
            },
            "rightCorner": {
              "x": -9.321,
              "y": -1.341,
              "z": 1.255
            },
            "gtin": "4045800522266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d813f",
            "leftCorner": {
              "x": -9.322,
              "y": -1.341,
              "z": 1.255
            },
            "rightCorner": {
              "x": -9.324,
              "y": -1.241,
              "z": 1.255
            },
            "gtin": "4045800302264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8140",
            "leftCorner": {
              "x": -9.325,
              "y": -1.241,
              "z": 1.255
            },
            "rightCorner": {
              "x": -9.326,
              "y": -1.154,
              "z": 1.255
            },
            "gtin": "4045800771558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8141",
            "leftCorner": {
              "x": -9.327,
              "y": -1.154,
              "z": 1.255
            },
            "rightCorner": {
              "x": -9.328,
              "y": -1.066,
              "z": 1.255
            },
            "gtin": "4045800771015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8142",
            "leftCorner": {
              "x": -9.328,
              "y": -1.066,
              "z": 1.255
            },
            "rightCorner": {
              "x": -9.329,
              "y": -0.966,
              "z": 1.255
            },
            "gtin": "4045800230666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8143",
            "leftCorner": {
              "x": -9.324,
              "y": -0.966,
              "z": 1.255
            },
            "rightCorner": {
              "x": -9.326,
              "y": -0.834,
              "z": 1.255
            },
            "gtin": "4045800230475",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d550",
        "height": 1.831,
        "facings": [
          {
            "id": "68d8e50de1820c81800d81a4",
            "leftCorner": {
              "x": -9.271,
              "y": -2.122,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.276,
              "y": -1.893,
              "z": 1.498
            },
            "gtin": "4009457783098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81a5",
            "leftCorner": {
              "x": -9.311,
              "y": -1.894,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.313,
              "y": -1.703,
              "z": 1.498
            },
            "gtin": "4009457783098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81a6",
            "leftCorner": {
              "x": -9.318,
              "y": -1.703,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.319,
              "y": -1.602,
              "z": 1.498
            },
            "gtin": "4009457782596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81a7",
            "leftCorner": {
              "x": -9.244,
              "y": -1.601,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.245,
              "y": -1.528,
              "z": 1.498
            },
            "gtin": "4009457788512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81a8",
            "leftCorner": {
              "x": -9.241,
              "y": -1.528,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.242,
              "y": -1.403,
              "z": 1.498
            },
            "gtin": "4045800503265",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d81a9",
            "leftCorner": {
              "x": -9.329,
              "y": -1.404,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.331,
              "y": -1.238,
              "z": 1.498
            },
            "gtin": "4045800213263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81aa",
            "leftCorner": {
              "x": -9.246,
              "y": -1.237,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.248,
              "y": -1.144,
              "z": 1.498
            },
            "gtin": "4045800229264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81ab",
            "leftCorner": {
              "x": -9.486,
              "y": -1.147,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.487,
              "y": -1.039,
              "z": 1.498
            },
            "gtin": "4045800402261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81ac",
            "leftCorner": {
              "x": -9.247,
              "y": -1.036,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.248,
              "y": -0.904,
              "z": 1.498
            },
            "gtin": "4045800496260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81ad",
            "leftCorner": {
              "x": -9.338,
              "y": -0.906,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.339,
              "y": -0.801,
              "z": 1.498
            },
            "gtin": "4051009007572",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "76c",
    "rightNeighborShelfId": "971"
  },
  {
    "id": "971",
    "name": "971",
    "x": -9.207,
    "y": -0.872,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71166,
      "w": 0.70253
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 53
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d553",
        "height": 0.63075,
        "facings": [
          {
            "id": "68d8e50de1820c81800d81d5",
            "leftCorner": {
              "x": -9.327,
              "y": -0.687,
              "z": 0.516
            },
            "rightCorner": {
              "x": -9.329,
              "y": -0.524,
              "z": 0.516
            },
            "gtin": "4045800445497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5476411ff606dbcbe68b05e8",
            "leftCorner": {
              "x": -9.28,
              "y": -0.873,
              "z": 0.516
            },
            "rightCorner": {
              "x": -9.282,
              "y": -0.74,
              "z": 0.516
            },
            "gtin": "4045800700459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4c44232fd6dbcb9ef8ccad51",
            "leftCorner": {
              "x": -9.282,
              "y": -0.74,
              "z": 0.516
            },
            "rightCorner": {
              "x": -9.282,
              "y": -0.689,
              "z": 0.516
            },
            "gtin": "4306188038955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81d6",
            "leftCorner": {
              "x": -9.336,
              "y": -0.525,
              "z": 0.516
            },
            "rightCorner": {
              "x": -9.337,
              "y": -0.414,
              "z": 0.516
            },
            "gtin": "4045800451191",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81d7",
            "leftCorner": {
              "x": -9.34,
              "y": -0.414,
              "z": 0.516
            },
            "rightCorner": {
              "x": -9.342,
              "y": -0.262,
              "z": 0.516
            },
            "gtin": "4045800700442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81d8",
            "leftCorner": {
              "x": -9.345,
              "y": -0.262,
              "z": 0.516
            },
            "rightCorner": {
              "x": -9.346,
              "y": -0.147,
              "z": 0.516
            },
            "gtin": "4045800460278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81d9",
            "leftCorner": {
              "x": -9.329,
              "y": -0.147,
              "z": 0.516
            },
            "rightCorner": {
              "x": -9.33,
              "y": -0.054,
              "z": 0.516
            },
            "gtin": "4260172690010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81da",
            "leftCorner": {
              "x": -9.327,
              "y": -0.054,
              "z": 0.516
            },
            "rightCorner": {
              "x": -9.328,
              "y": 0.027,
              "z": 0.516
            },
            "gtin": "4260172690034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81db",
            "leftCorner": {
              "x": -9.329,
              "y": 0.027,
              "z": 0.516
            },
            "rightCorner": {
              "x": -9.33,
              "y": 0.112,
              "z": 0.516
            },
            "gtin": "40466156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81dc",
            "leftCorner": {
              "x": -9.332,
              "y": 0.112,
              "z": 0.516
            },
            "rightCorner": {
              "x": -9.333,
              "y": 0.199,
              "z": 0.516
            },
            "gtin": "40466309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81dd",
            "leftCorner": {
              "x": -9.334,
              "y": 0.199,
              "z": 0.516
            },
            "rightCorner": {
              "x": -9.336,
              "y": 0.322,
              "z": 0.516
            },
            "gtin": "4000832860502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81de",
            "leftCorner": {
              "x": -9.342,
              "y": 0.321,
              "z": 0.516
            },
            "rightCorner": {
              "x": -9.343,
              "y": 0.393,
              "z": 0.516
            },
            "gtin": "4306188038955",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d554",
        "height": 0.9313,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8183",
            "leftCorner": {
              "x": -9.25,
              "y": -0.819,
              "z": 0.762
            },
            "rightCorner": {
              "x": -9.251,
              "y": -0.719,
              "z": 0.762
            },
            "gtin": "8710506084221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "55dcc3df39110f094519da6c",
            "leftCorner": {
              "x": -9.283,
              "y": -0.873,
              "z": 0.762
            },
            "rightCorner": {
              "x": -9.284,
              "y": -0.828,
              "z": 0.762
            },
            "gtin": "4260152949398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8184",
            "leftCorner": {
              "x": -9.326,
              "y": -0.72,
              "z": 0.762
            },
            "rightCorner": {
              "x": -9.327,
              "y": -0.578,
              "z": 0.762
            },
            "gtin": "4045800475210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8185",
            "leftCorner": {
              "x": -9.256,
              "y": -0.577,
              "z": 0.762
            },
            "rightCorner": {
              "x": -9.258,
              "y": -0.445,
              "z": 0.762
            },
            "gtin": "4045800475197",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8186",
            "leftCorner": {
              "x": -9.259,
              "y": -0.445,
              "z": 0.762
            },
            "rightCorner": {
              "x": -9.26,
              "y": -0.334,
              "z": 0.762
            },
            "gtin": "4045800460216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8187",
            "leftCorner": {
              "x": -9.255,
              "y": -0.334,
              "z": 0.762
            },
            "rightCorner": {
              "x": -9.256,
              "y": -0.253,
              "z": 0.762
            },
            "gtin": "4045800770964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8188",
            "leftCorner": {
              "x": -9.304,
              "y": -0.254,
              "z": 0.762
            },
            "rightCorner": {
              "x": -9.306,
              "y": -0.137,
              "z": 0.762
            },
            "gtin": "4045800771305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8189",
            "leftCorner": {
              "x": -9.335,
              "y": -0.138,
              "z": 0.762
            },
            "rightCorner": {
              "x": -9.336,
              "y": -0.054,
              "z": 0.762
            },
            "gtin": "4004820800617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d818a",
            "leftCorner": {
              "x": -9.335,
              "y": -0.054,
              "z": 0.762
            },
            "rightCorner": {
              "x": -9.337,
              "y": 0.1,
              "z": 0.762
            },
            "gtin": "4004820800464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d818b",
            "leftCorner": {
              "x": -9.335,
              "y": 0.1,
              "z": 0.762
            },
            "rightCorner": {
              "x": -9.337,
              "y": 0.222,
              "z": 0.762
            },
            "gtin": "4004820197021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d818c",
            "leftCorner": {
              "x": -9.338,
              "y": 0.222,
              "z": 0.762
            },
            "rightCorner": {
              "x": -9.339,
              "y": 0.328,
              "z": 0.762
            },
            "gtin": "4004820800266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d818d",
            "leftCorner": {
              "x": -9.346,
              "y": 0.328,
              "z": 0.762
            },
            "rightCorner": {
              "x": -9.348,
              "y": 0.488,
              "z": 0.762
            },
            "gtin": "4260152949398",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d552",
        "height": 1.2288,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8117",
            "leftCorner": {
              "x": -9.331,
              "y": -0.808,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.332,
              "y": -0.724,
              "z": 1.005
            },
            "gtin": "4045800202281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "da40046004fa72da0404db47",
            "leftCorner": {
              "x": -9.297,
              "y": -0.873,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.298,
              "y": -0.808,
              "z": 1.005
            },
            "gtin": "4045800771282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8118",
            "leftCorner": {
              "x": -9.334,
              "y": -0.724,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.335,
              "y": -0.639,
              "z": 1.005
            },
            "gtin": "4045800236255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8119",
            "leftCorner": {
              "x": -9.341,
              "y": -0.639,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.342,
              "y": -0.554,
              "z": 1.005
            },
            "gtin": "4045800202250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d811a",
            "leftCorner": {
              "x": -9.342,
              "y": -0.554,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.343,
              "y": -0.466,
              "z": 1.005
            },
            "gtin": "4045800235258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d811b",
            "leftCorner": {
              "x": -9.35,
              "y": -0.466,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.351,
              "y": -0.381,
              "z": 1.005
            },
            "gtin": "4045800770803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d811c",
            "leftCorner": {
              "x": -9.35,
              "y": -0.381,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.353,
              "y": -0.17,
              "z": 1.005
            },
            "gtin": "4045800770940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d811d",
            "leftCorner": {
              "x": -9.247,
              "y": -0.169,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.247,
              "y": -0.108,
              "z": 1.005
            },
            "gtin": "4045800771282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d811e",
            "leftCorner": {
              "x": -9.263,
              "y": -0.108,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.264,
              "y": -0.045,
              "z": 1.005
            },
            "gtin": "4058094300113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d811f",
            "leftCorner": {
              "x": -9.347,
              "y": -0.046,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.348,
              "y": 0.05,
              "z": 1.005
            },
            "gtin": "4058094310013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8120",
            "leftCorner": {
              "x": -9.345,
              "y": 0.05,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.347,
              "y": 0.21,
              "z": 1.005
            },
            "gtin": "4020300961159",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d8121",
            "leftCorner": {
              "x": -9.351,
              "y": 0.21,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.352,
              "y": 0.307,
              "z": 1.005
            },
            "gtin": "4004820197113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8122",
            "leftCorner": {
              "x": -9.353,
              "y": 0.307,
              "z": 1.005
            },
            "rightCorner": {
              "x": -9.355,
              "y": 0.408,
              "z": 1.005
            },
            "gtin": "4004820197144",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d551",
        "height": 1.5308,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8144",
            "leftCorner": {
              "x": -9.283,
              "y": -0.834,
              "z": 1.252
            },
            "rightCorner": {
              "x": -9.284,
              "y": -0.73,
              "z": 1.252
            },
            "gtin": "4260728291517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8145",
            "leftCorner": {
              "x": -9.327,
              "y": -0.73,
              "z": 1.252
            },
            "rightCorner": {
              "x": -9.329,
              "y": -0.622,
              "z": 1.252
            },
            "gtin": "4260728291562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8146",
            "leftCorner": {
              "x": -9.337,
              "y": -0.622,
              "z": 1.252
            },
            "rightCorner": {
              "x": -9.338,
              "y": -0.51,
              "z": 1.252
            },
            "gtin": "4260728291555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8147",
            "leftCorner": {
              "x": -9.34,
              "y": -0.51,
              "z": 1.252
            },
            "rightCorner": {
              "x": -9.342,
              "y": -0.408,
              "z": 1.252
            },
            "gtin": "4260728291579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8148",
            "leftCorner": {
              "x": -9.341,
              "y": -0.408,
              "z": 1.252
            },
            "rightCorner": {
              "x": -9.342,
              "y": -0.326,
              "z": 1.252
            },
            "gtin": "4260728291524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8149",
            "leftCorner": {
              "x": -9.256,
              "y": -0.325,
              "z": 1.252
            },
            "rightCorner": {
              "x": -9.258,
              "y": -0.177,
              "z": 1.252
            },
            "gtin": "4260728291548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d814a",
            "leftCorner": {
              "x": -9.247,
              "y": -0.177,
              "z": 1.252
            },
            "rightCorner": {
              "x": -9.248,
              "y": -0.06,
              "z": 1.252
            },
            "gtin": "4260728291500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d814b",
            "leftCorner": {
              "x": -9.342,
              "y": -0.061,
              "z": 1.252
            },
            "rightCorner": {
              "x": -9.343,
              "y": 0.074,
              "z": 1.252
            },
            "gtin": "4260728291586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d814c",
            "leftCorner": {
              "x": -9.337,
              "y": 0.074,
              "z": 1.252
            },
            "rightCorner": {
              "x": -9.339,
              "y": 0.222,
              "z": 1.252
            },
            "gtin": "4260030322015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d814d",
            "leftCorner": {
              "x": -9.337,
              "y": 0.222,
              "z": 1.252
            },
            "rightCorner": {
              "x": -9.338,
              "y": 0.314,
              "z": 1.252
            },
            "gtin": "8410422775363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d814e",
            "leftCorner": {
              "x": -9.343,
              "y": 0.314,
              "z": 1.252
            },
            "rightCorner": {
              "x": -9.345,
              "y": 0.478,
              "z": 1.252
            },
            "gtin": "8410422000670",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d555",
        "height": 1.8356,
        "facings": [
          {
            "id": "68d8e50de1820c81800d81ae",
            "leftCorner": {
              "x": -9.245,
              "y": -0.8,
              "z": 1.502
            },
            "rightCorner": {
              "x": -9.247,
              "y": -0.67,
              "z": 1.502
            },
            "gtin": "4051009026733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "99d2e2c122d293ce42a2330d",
            "leftCorner": {
              "x": -9.299,
              "y": -0.409,
              "z": 1.502
            },
            "rightCorner": {
              "x": -9.3,
              "y": -0.322,
              "z": 1.502
            },
            "gtin": "8001665727525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81af",
            "leftCorner": {
              "x": -9.336,
              "y": -0.672,
              "z": 1.502
            },
            "rightCorner": {
              "x": -9.337,
              "y": -0.557,
              "z": 1.502
            },
            "gtin": "4051009041941",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d81b0",
            "leftCorner": {
              "x": -9.339,
              "y": -0.557,
              "z": 1.502
            },
            "rightCorner": {
              "x": -9.341,
              "y": -0.41,
              "z": 1.502
            },
            "gtin": "4051009017762",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d81b2",
            "leftCorner": {
              "x": -9.342,
              "y": -0.322,
              "z": 1.502
            },
            "rightCorner": {
              "x": -9.343,
              "y": -0.206,
              "z": 1.502
            },
            "gtin": "4045800719512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81b3",
            "leftCorner": {
              "x": -9.248,
              "y": -0.204,
              "z": 1.502
            },
            "rightCorner": {
              "x": -9.25,
              "y": -0.071,
              "z": 1.502
            },
            "gtin": "4045800719505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81b4",
            "leftCorner": {
              "x": -9.295,
              "y": -0.071,
              "z": 1.502
            },
            "rightCorner": {
              "x": -9.296,
              "y": 0.029,
              "z": 1.502
            },
            "gtin": "4251540700714",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d81b5",
            "leftCorner": {
              "x": -9.339,
              "y": 0.028,
              "z": 1.502
            },
            "rightCorner": {
              "x": -9.342,
              "y": 0.287,
              "z": 1.502
            },
            "gtin": "8001665720373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81b6",
            "leftCorner": {
              "x": -9.348,
              "y": 0.287,
              "z": 1.502
            },
            "rightCorner": {
              "x": -9.35,
              "y": 0.435,
              "z": 1.502
            },
            "gtin": "8001665727525",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "970",
    "rightNeighborShelfId": "972"
  },
  {
    "id": "972",
    "name": "972",
    "x": -9.223,
    "y": 0.378,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71166,
      "w": 0.70253
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 44
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d556",
        "height": 0.62949,
        "facings": [
          {
            "id": "68d8e50de1820c81800d81df",
            "leftCorner": {
              "x": -9.329,
              "y": 0.393,
              "z": 0.515
            },
            "rightCorner": {
              "x": -9.33,
              "y": 0.487,
              "z": 0.515
            },
            "gtin": "4009286110560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81e0",
            "leftCorner": {
              "x": -9.336,
              "y": 0.487,
              "z": 0.515
            },
            "rightCorner": {
              "x": -9.337,
              "y": 0.588,
              "z": 0.515
            },
            "gtin": "4009286110607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81e1",
            "leftCorner": {
              "x": -9.343,
              "y": 0.588,
              "z": 0.515
            },
            "rightCorner": {
              "x": -9.344,
              "y": 0.676,
              "z": 0.515
            },
            "gtin": "4009286110676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81e2",
            "leftCorner": {
              "x": -9.345,
              "y": 0.676,
              "z": 0.515
            },
            "rightCorner": {
              "x": -9.346,
              "y": 0.769,
              "z": 0.515
            },
            "gtin": "4045800767520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81e3",
            "leftCorner": {
              "x": -9.35,
              "y": 0.769,
              "z": 0.515
            },
            "rightCorner": {
              "x": -9.351,
              "y": 0.88,
              "z": 0.515
            },
            "gtin": "4045800767537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81e4",
            "leftCorner": {
              "x": -9.356,
              "y": 0.88,
              "z": 0.515
            },
            "rightCorner": {
              "x": -9.357,
              "y": 0.996,
              "z": 0.515
            },
            "gtin": "4260634273874",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d81e5",
            "leftCorner": {
              "x": -9.357,
              "y": 0.996,
              "z": 0.515
            },
            "rightCorner": {
              "x": -9.361,
              "y": 1.296,
              "z": 0.515
            },
            "gtin": "4009337863834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81e6",
            "leftCorner": {
              "x": -9.354,
              "y": 1.296,
              "z": 0.515
            },
            "rightCorner": {
              "x": -9.355,
              "y": 1.389,
              "z": 0.515
            },
            "gtin": "4015271001065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81e7",
            "leftCorner": {
              "x": -9.353,
              "y": 1.389,
              "z": 0.515
            },
            "rightCorner": {
              "x": -9.355,
              "y": 1.533,
              "z": 0.515
            },
            "gtin": "4015271001027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81e8",
            "leftCorner": {
              "x": -9.352,
              "y": 1.533,
              "z": 0.515
            },
            "rightCorner": {
              "x": -9.353,
              "y": 1.626,
              "z": 0.515
            },
            "gtin": "4015271001270",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d558",
        "height": 0.92801,
        "facings": [
          {
            "id": "68d8e50de1820c81800d818e",
            "leftCorner": {
              "x": -9.336,
              "y": 0.488,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.338,
              "y": 0.691,
              "z": 0.759
            },
            "gtin": "4260152949374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fbb4c892a15d8e876926bb49",
            "leftCorner": {
              "x": -9.305,
              "y": 0.377,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.307,
              "y": 0.479,
              "z": 0.759
            },
            "gtin": "4260634275113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d818f",
            "leftCorner": {
              "x": -9.346,
              "y": 0.69,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.348,
              "y": 0.837,
              "z": 0.759
            },
            "gtin": "4260152949602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8190",
            "leftCorner": {
              "x": -9.356,
              "y": 0.837,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.357,
              "y": 0.95,
              "z": 0.759
            },
            "gtin": "4260634272747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8191",
            "leftCorner": {
              "x": -9.36,
              "y": 0.95,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.361,
              "y": 1.05,
              "z": 0.759
            },
            "gtin": "4260634275113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8192",
            "leftCorner": {
              "x": -9.354,
              "y": 1.05,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.356,
              "y": 1.258,
              "z": 0.759
            },
            "gtin": "4009337904575",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d8193",
            "leftCorner": {
              "x": -9.357,
              "y": 1.258,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.36,
              "y": 1.506,
              "z": 0.759
            },
            "gtin": "4306188407997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8194",
            "leftCorner": {
              "x": -9.324,
              "y": 1.507,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.326,
              "y": 1.675,
              "z": 0.759
            },
            "gtin": "4306188407966",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d559",
        "height": 1.2363,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8123",
            "leftCorner": {
              "x": -9.344,
              "y": 0.408,
              "z": 1.012
            },
            "rightCorner": {
              "x": -9.346,
              "y": 0.609,
              "z": 1.012
            },
            "gtin": "4306188050247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "82c5fc6a254b74e2396b94a1",
            "leftCorner": {
              "x": -9.306,
              "y": 0.377,
              "z": 1.012
            },
            "rightCorner": {
              "x": -9.306,
              "y": 0.384,
              "z": 1.012
            },
            "gtin": "4009337855082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "96fa28afdb4fc6b0b187f180",
            "leftCorner": {
              "x": -9.306,
              "y": 0.384,
              "z": 1.012
            },
            "rightCorner": {
              "x": -9.306,
              "y": 0.39,
              "z": 1.012
            },
            "gtin": "4009337855082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b9efcaa4640c2770f1fbfb8b",
            "leftCorner": {
              "x": -9.306,
              "y": 0.39,
              "z": 1.012
            },
            "rightCorner": {
              "x": -9.307,
              "y": 0.397,
              "z": 1.012
            },
            "gtin": "4009337855082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "22b09b7ad45cb75629164488",
            "leftCorner": {
              "x": -9.307,
              "y": 0.397,
              "z": 1.012
            },
            "rightCorner": {
              "x": -9.307,
              "y": 0.404,
              "z": 1.012
            },
            "gtin": "4009337855082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8124",
            "leftCorner": {
              "x": -9.349,
              "y": 0.609,
              "z": 1.012
            },
            "rightCorner": {
              "x": -9.351,
              "y": 0.759,
              "z": 1.012
            },
            "gtin": "4306188047513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8125",
            "leftCorner": {
              "x": -9.351,
              "y": 0.759,
              "z": 1.012
            },
            "rightCorner": {
              "x": -9.356,
              "y": 1.121,
              "z": 1.012
            },
            "gtin": "4306188385110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8126",
            "leftCorner": {
              "x": -9.358,
              "y": 1.121,
              "z": 1.012
            },
            "rightCorner": {
              "x": -9.36,
              "y": 1.306,
              "z": 1.012
            },
            "gtin": "4075600055039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8127",
            "leftCorner": {
              "x": -9.356,
              "y": 1.306,
              "z": 1.012
            },
            "rightCorner": {
              "x": -9.358,
              "y": 1.473,
              "z": 1.012
            },
            "gtin": "4075600058177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8128",
            "leftCorner": {
              "x": -9.36,
              "y": 1.473,
              "z": 1.012
            },
            "rightCorner": {
              "x": -9.364,
              "y": 1.765,
              "z": 1.012
            },
            "gtin": "4009337847339",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d557",
        "height": 1.5319,
        "facings": [
          {
            "id": "68d8e50de1820c81800d814f",
            "leftCorner": {
              "x": -9.338,
              "y": 0.478,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.341,
              "y": 0.648,
              "z": 1.253
            },
            "gtin": "4001163000599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f28756dbba1569f1a5ff35af",
            "leftCorner": {
              "x": -9.299,
              "y": 0.377,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.299,
              "y": 0.4,
              "z": 1.253
            },
            "gtin": "4001163134263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "64f5a1c558775f26a1a9442f",
            "leftCorner": {
              "x": -9.299,
              "y": 0.4,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.299,
              "y": 0.423,
              "z": 1.253
            },
            "gtin": "4001163134263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b65f0294382b7164304938da",
            "leftCorner": {
              "x": -9.299,
              "y": 0.423,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.299,
              "y": 0.446,
              "z": 1.253
            },
            "gtin": "4001163134263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a678e308a7c5536884e23200",
            "leftCorner": {
              "x": -9.299,
              "y": 0.446,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.3,
              "y": 0.469,
              "z": 1.253
            },
            "gtin": "4001163134263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8150",
            "leftCorner": {
              "x": -9.344,
              "y": 0.648,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.347,
              "y": 0.847,
              "z": 1.253
            },
            "gtin": "4001163134201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8151",
            "leftCorner": {
              "x": -9.35,
              "y": 0.847,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.353,
              "y": 1.049,
              "z": 1.253
            },
            "gtin": "4001163134218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8152",
            "leftCorner": {
              "x": -9.347,
              "y": 1.049,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.349,
              "y": 1.242,
              "z": 1.253
            },
            "gtin": "4001163000506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8153",
            "leftCorner": {
              "x": -9.35,
              "y": 1.242,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.352,
              "y": 1.424,
              "z": 1.253
            },
            "gtin": "4001163154858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8154",
            "leftCorner": {
              "x": -9.352,
              "y": 1.424,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.354,
              "y": 1.591,
              "z": 1.253
            },
            "gtin": "4016287035440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8155",
            "leftCorner": {
              "x": -9.358,
              "y": 1.591,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.361,
              "y": 1.757,
              "z": 1.253
            },
            "gtin": "4001163134263",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d55a",
        "height": 1.831,
        "facings": [
          {
            "id": "68d8e50de1820c81800d81b7",
            "leftCorner": {
              "x": -9.337,
              "y": 0.436,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.339,
              "y": 0.584,
              "z": 1.498
            },
            "gtin": "8001665727471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9f56d8dc9978a80f78184996",
            "leftCorner": {
              "x": -9.302,
              "y": 0.377,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.303,
              "y": 0.421,
              "z": 1.498
            },
            "gtin": "4001163110502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81b8",
            "leftCorner": {
              "x": -9.342,
              "y": 0.584,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.345,
              "y": 0.787,
              "z": 1.498
            },
            "gtin": "8001665727464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81b9",
            "leftCorner": {
              "x": -9.348,
              "y": 0.787,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.35,
              "y": 0.949,
              "z": 1.498
            },
            "gtin": "8001665727549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81ba",
            "leftCorner": {
              "x": -9.352,
              "y": 0.949,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.354,
              "y": 1.119,
              "z": 1.498
            },
            "gtin": "4009337844031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81bb",
            "leftCorner": {
              "x": -9.352,
              "y": 1.119,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.354,
              "y": 1.267,
              "z": 1.498
            },
            "gtin": "4009337842839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81bc",
            "leftCorner": {
              "x": -9.351,
              "y": 1.267,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.356,
              "y": 1.626,
              "z": 1.498
            },
            "gtin": "4009337843034",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "971",
    "rightNeighborShelfId": "973"
  },
  {
    "id": "973",
    "name": "973",
    "x": -9.239,
    "y": 1.628,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71166,
      "w": 0.70253
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d55f",
        "height": 0.62566,
        "facings": [
          {
            "id": "68d8e50de1820c81800d81e9",
            "leftCorner": {
              "x": -9.361,
              "y": 1.626,
              "z": 0.512
            },
            "rightCorner": {
              "x": -9.364,
              "y": 1.829,
              "z": 0.512
            },
            "gtin": "4009286220009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81ea",
            "leftCorner": {
              "x": -9.359,
              "y": 1.829,
              "z": 0.512
            },
            "rightCorner": {
              "x": -9.361,
              "y": 1.976,
              "z": 0.512
            },
            "gtin": "4009286220009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81eb",
            "leftCorner": {
              "x": -9.371,
              "y": 1.975,
              "z": 0.512
            },
            "rightCorner": {
              "x": -9.373,
              "y": 2.198,
              "z": 0.512
            },
            "gtin": "4009286155189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81ec",
            "leftCorner": {
              "x": -9.374,
              "y": 2.198,
              "z": 0.512
            },
            "rightCorner": {
              "x": -9.375,
              "y": 2.29,
              "z": 0.512
            },
            "gtin": "4306188407935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81ed",
            "leftCorner": {
              "x": -9.296,
              "y": 2.291,
              "z": 0.512
            },
            "rightCorner": {
              "x": -9.297,
              "y": 2.419,
              "z": 0.512
            },
            "gtin": "9120003418655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81ee",
            "leftCorner": {
              "x": -9.376,
              "y": 2.418,
              "z": 0.512
            },
            "rightCorner": {
              "x": -9.378,
              "y": 2.569,
              "z": 0.512
            },
            "gtin": "9120003416217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81ef",
            "leftCorner": {
              "x": -9.374,
              "y": 2.569,
              "z": 0.512
            },
            "rightCorner": {
              "x": -9.376,
              "y": 2.664,
              "z": 0.512
            },
            "gtin": "9120003412240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81f0",
            "leftCorner": {
              "x": -9.379,
              "y": 2.664,
              "z": 0.512
            },
            "rightCorner": {
              "x": -9.381,
              "y": 2.777,
              "z": 0.512
            },
            "gtin": "9120003414640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81c8",
            "leftCorner": {
              "x": -9.378,
              "y": 2.777,
              "z": 0.512
            },
            "rightCorner": {
              "x": -9.379,
              "y": 2.876,
              "z": 0.512
            },
            "gtin": "4306188054702",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d55d",
        "height": 0.9296,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8195",
            "leftCorner": {
              "x": -9.29,
              "y": 1.676,
              "z": 0.761
            },
            "rightCorner": {
              "x": -9.292,
              "y": 1.79,
              "z": 0.761
            },
            "gtin": "9120003416989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8196",
            "leftCorner": {
              "x": -9.365,
              "y": 1.789,
              "z": 0.761
            },
            "rightCorner": {
              "x": -9.369,
              "y": 2.047,
              "z": 0.761
            },
            "gtin": "4001163135857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8197",
            "leftCorner": {
              "x": -9.369,
              "y": 2.047,
              "z": 0.761
            },
            "rightCorner": {
              "x": -9.371,
              "y": 2.181,
              "z": 0.761
            },
            "gtin": "9120003418761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8198",
            "leftCorner": {
              "x": -9.372,
              "y": 2.181,
              "z": 0.761
            },
            "rightCorner": {
              "x": -9.373,
              "y": 2.305,
              "z": 0.761
            },
            "gtin": "4001163158207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8199",
            "leftCorner": {
              "x": -9.285,
              "y": 2.307,
              "z": 0.761
            },
            "rightCorner": {
              "x": -9.286,
              "y": 2.414,
              "z": 0.761
            },
            "gtin": "4001163131552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d819a",
            "leftCorner": {
              "x": -9.291,
              "y": 2.414,
              "z": 0.761
            },
            "rightCorner": {
              "x": -9.294,
              "y": 2.584,
              "z": 0.761
            },
            "gtin": "4016287008512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d819b",
            "leftCorner": {
              "x": -9.383,
              "y": 2.583,
              "z": 0.761
            },
            "rightCorner": {
              "x": -9.385,
              "y": 2.77,
              "z": 0.761
            },
            "gtin": "4016287009656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8169",
            "leftCorner": {
              "x": -9.379,
              "y": 2.771,
              "z": 0.761
            },
            "rightCorner": {
              "x": -9.38,
              "y": 2.876,
              "z": 0.761
            },
            "gtin": "4016287009663",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d55c",
        "height": 1.2299,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8129",
            "leftCorner": {
              "x": -9.369,
              "y": 1.765,
              "z": 1.006
            },
            "rightCorner": {
              "x": -9.371,
              "y": 1.931,
              "z": 1.006
            },
            "gtin": "4009337855099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d812a",
            "leftCorner": {
              "x": -9.376,
              "y": 1.931,
              "z": 1.006
            },
            "rightCorner": {
              "x": -9.378,
              "y": 2.099,
              "z": 1.006
            },
            "gtin": "4009337846332",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d812b",
            "leftCorner": {
              "x": -9.379,
              "y": 2.099,
              "z": 1.006
            },
            "rightCorner": {
              "x": -9.383,
              "y": 2.393,
              "z": 1.006
            },
            "gtin": "9120003412776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d812c",
            "leftCorner": {
              "x": -9.381,
              "y": 2.393,
              "z": 1.006
            },
            "rightCorner": {
              "x": -9.382,
              "y": 2.516,
              "z": 1.006
            },
            "gtin": "3392590205369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d812d",
            "leftCorner": {
              "x": -9.385,
              "y": 2.515,
              "z": 1.006
            },
            "rightCorner": {
              "x": -9.386,
              "y": 2.585,
              "z": 1.006
            },
            "gtin": "3392590205376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d812e",
            "leftCorner": {
              "x": -9.383,
              "y": 2.585,
              "z": 1.006
            },
            "rightCorner": {
              "x": -9.385,
              "y": 2.694,
              "z": 1.006
            },
            "gtin": "3392590205642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d812f",
            "leftCorner": {
              "x": -9.39,
              "y": 2.694,
              "z": 1.006
            },
            "rightCorner": {
              "x": -9.391,
              "y": 2.808,
              "z": 1.006
            },
            "gtin": "3392590202344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8101",
            "leftCorner": {
              "x": -9.389,
              "y": 2.808,
              "z": 1.006
            },
            "rightCorner": {
              "x": -9.39,
              "y": 2.876,
              "z": 1.006
            },
            "gtin": "3392590201477",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "ee656d57dbd0fdf7dceae378",
            "leftCorner": {
              "x": -9.332,
              "y": 1.627,
              "z": 1.006
            },
            "rightCorner": {
              "x": -9.334,
              "y": 1.742,
              "z": 1.006
            },
            "gtin": "3392590202344",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d55b",
        "height": 1.5317,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8156",
            "leftCorner": {
              "x": -9.358,
              "y": 1.757,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.36,
              "y": 1.947,
              "z": 1.253
            },
            "gtin": "4001163134249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8157",
            "leftCorner": {
              "x": -9.362,
              "y": 1.947,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.365,
              "y": 2.106,
              "z": 1.253
            },
            "gtin": "4001163000148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8158",
            "leftCorner": {
              "x": -9.359,
              "y": 2.106,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.362,
              "y": 2.313,
              "z": 1.253
            },
            "gtin": "4306188378273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8159",
            "leftCorner": {
              "x": -9.279,
              "y": 2.314,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.282,
              "y": 2.545,
              "z": 1.253
            },
            "gtin": "4306188037965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d815a",
            "leftCorner": {
              "x": -9.29,
              "y": 2.545,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.292,
              "y": 2.702,
              "z": 1.253
            },
            "gtin": "4003082140301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d815b",
            "leftCorner": {
              "x": -9.367,
              "y": 2.701,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.369,
              "y": 2.8,
              "z": 1.253
            },
            "gtin": "4003082140103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8131",
            "leftCorner": {
              "x": -9.367,
              "y": 2.8,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.368,
              "y": 2.876,
              "z": 1.253
            },
            "gtin": "4003082140400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a332afe4371b94f24447e8a4",
            "leftCorner": {
              "x": -9.313,
              "y": 1.627,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.314,
              "y": 1.731,
              "z": 1.253
            },
            "gtin": "4003082140103",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d55e",
        "height": 1.8285,
        "facings": [
          {
            "id": "68d8e50de1820c81800d81bd",
            "leftCorner": {
              "x": -9.36,
              "y": 1.626,
              "z": 1.496
            },
            "rightCorner": {
              "x": -9.363,
              "y": 1.801,
              "z": 1.496
            },
            "gtin": "4001163134157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81be",
            "leftCorner": {
              "x": -9.363,
              "y": 1.801,
              "z": 1.496
            },
            "rightCorner": {
              "x": -9.365,
              "y": 1.955,
              "z": 1.496
            },
            "gtin": "4001163134157",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d81bf",
            "leftCorner": {
              "x": -9.367,
              "y": 1.955,
              "z": 1.496
            },
            "rightCorner": {
              "x": -9.369,
              "y": 2.108,
              "z": 1.496
            },
            "gtin": "4045800780727",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81c0",
            "leftCorner": {
              "x": -9.37,
              "y": 2.108,
              "z": 1.496
            },
            "rightCorner": {
              "x": -9.372,
              "y": 2.244,
              "z": 1.496
            },
            "gtin": "4006034227778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81c1",
            "leftCorner": {
              "x": -9.286,
              "y": 2.245,
              "z": 1.496
            },
            "rightCorner": {
              "x": -9.288,
              "y": 2.389,
              "z": 1.496
            },
            "gtin": "4045800760651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81c2",
            "leftCorner": {
              "x": -9.372,
              "y": 2.388,
              "z": 1.496
            },
            "rightCorner": {
              "x": -9.374,
              "y": 2.534,
              "z": 1.496
            },
            "gtin": "4045800760583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81c3",
            "leftCorner": {
              "x": -9.376,
              "y": 2.534,
              "z": 1.496
            },
            "rightCorner": {
              "x": -9.377,
              "y": 2.661,
              "z": 1.496
            },
            "gtin": "4045800760576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d81c4",
            "leftCorner": {
              "x": -9.378,
              "y": 2.661,
              "z": 1.496
            },
            "rightCorner": {
              "x": -9.38,
              "y": 2.788,
              "z": 1.496
            },
            "gtin": "4003082141001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d819d",
            "leftCorner": {
              "x": -9.378,
              "y": 2.788,
              "z": 1.496
            },
            "rightCorner": {
              "x": -9.379,
              "y": 2.876,
              "z": 1.496
            },
            "gtin": "4003082141018",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "972"
  },
  {
    "id": "974",
    "name": "974",
    "x": -6.976,
    "y": 3.849,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69417,
      "w": 0.71981
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 58
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4e8",
        "height": 0.62846,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7de9",
            "leftCorner": {
              "x": -6.894,
              "y": 3.852,
              "z": 0.514
            },
            "rightCorner": {
              "x": -6.888,
              "y": 3.694,
              "z": 0.514
            },
            "gtin": "4306188429722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7deb",
            "leftCorner": {
              "x": -6.842,
              "y": 3.695,
              "z": 0.514
            },
            "rightCorner": {
              "x": -6.839,
              "y": 3.59,
              "z": 0.514
            },
            "gtin": "4306188429692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dec",
            "leftCorner": {
              "x": -6.842,
              "y": 3.59,
              "z": 0.514
            },
            "rightCorner": {
              "x": -6.839,
              "y": 3.497,
              "z": 0.514
            },
            "gtin": "8000430133035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ded",
            "leftCorner": {
              "x": -6.841,
              "y": 3.497,
              "z": 0.514
            },
            "rightCorner": {
              "x": -6.837,
              "y": 3.37,
              "z": 0.514
            },
            "gtin": "4014500520834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dee",
            "leftCorner": {
              "x": -6.838,
              "y": 3.37,
              "z": 0.514
            },
            "rightCorner": {
              "x": -6.835,
              "y": 3.282,
              "z": 0.514
            },
            "gtin": "4014500520827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7def",
            "leftCorner": {
              "x": -6.832,
              "y": 3.282,
              "z": 0.514
            },
            "rightCorner": {
              "x": -6.829,
              "y": 3.198,
              "z": 0.514
            },
            "gtin": "4014500521046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7df0",
            "leftCorner": {
              "x": -6.833,
              "y": 3.198,
              "z": 0.514
            },
            "rightCorner": {
              "x": -6.83,
              "y": 3.099,
              "z": 0.514
            },
            "gtin": "4014500520896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7df1",
            "leftCorner": {
              "x": -6.829,
              "y": 3.099,
              "z": 0.514
            },
            "rightCorner": {
              "x": -6.823,
              "y": 2.939,
              "z": 0.514
            },
            "gtin": "4036300152718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7df2",
            "leftCorner": {
              "x": -6.818,
              "y": 2.939,
              "z": 0.514
            },
            "rightCorner": {
              "x": -6.814,
              "y": 2.825,
              "z": 0.514
            },
            "gtin": "4036300152701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7df3",
            "leftCorner": {
              "x": -6.818,
              "y": 2.825,
              "z": 0.514
            },
            "rightCorner": {
              "x": -6.81,
              "y": 2.604,
              "z": 0.514
            },
            "gtin": "4036300220820",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4ec",
        "height": 0.87888,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e2c",
            "leftCorner": {
              "x": -6.887,
              "y": 3.852,
              "z": 0.719
            },
            "rightCorner": {
              "x": -6.881,
              "y": 3.677,
              "z": 0.719
            },
            "gtin": "8000430135060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e2e",
            "leftCorner": {
              "x": -6.84,
              "y": 3.678,
              "z": 0.719
            },
            "rightCorner": {
              "x": -6.836,
              "y": 3.57,
              "z": 0.719
            },
            "gtin": "4104420145665",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7e2f",
            "leftCorner": {
              "x": -6.834,
              "y": 3.57,
              "z": 0.719
            },
            "rightCorner": {
              "x": -6.829,
              "y": 3.446,
              "z": 0.719
            },
            "gtin": "8024659072234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e30",
            "leftCorner": {
              "x": -6.829,
              "y": 3.446,
              "z": 0.719
            },
            "rightCorner": {
              "x": -6.825,
              "y": 3.329,
              "z": 0.719
            },
            "gtin": "8003518106013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e31",
            "leftCorner": {
              "x": -6.828,
              "y": 3.329,
              "z": 0.719
            },
            "rightCorner": {
              "x": -6.823,
              "y": 3.2,
              "z": 0.719
            },
            "gtin": "8001230000787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e32",
            "leftCorner": {
              "x": -6.827,
              "y": 3.2,
              "z": 0.719
            },
            "rightCorner": {
              "x": -6.822,
              "y": 3.054,
              "z": 0.719
            },
            "gtin": "8010721001509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e33",
            "leftCorner": {
              "x": -6.82,
              "y": 3.054,
              "z": 0.719
            },
            "rightCorner": {
              "x": -6.815,
              "y": 2.915,
              "z": 0.719
            },
            "gtin": "8003518100981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e34",
            "leftCorner": {
              "x": -6.817,
              "y": 2.915,
              "z": 0.719
            },
            "rightCorner": {
              "x": -6.813,
              "y": 2.806,
              "z": 0.719
            },
            "gtin": "8003518100219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e35",
            "leftCorner": {
              "x": -6.81,
              "y": 2.806,
              "z": 0.719
            },
            "rightCorner": {
              "x": -6.805,
              "y": 2.694,
              "z": 0.719
            },
            "gtin": "4002566010765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e2d",
            "leftCorner": {
              "x": -6.803,
              "y": 2.694,
              "z": 0.719
            },
            "rightCorner": {
              "x": -6.8,
              "y": 2.604,
              "z": 0.719
            },
            "gtin": "4002566010710",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4e7",
        "height": 1.1311,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7de0",
            "leftCorner": {
              "x": -6.842,
              "y": 3.811,
              "z": 0.925
            },
            "rightCorner": {
              "x": -6.839,
              "y": 3.729,
              "z": 0.925
            },
            "gtin": "4005096027418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7de1",
            "leftCorner": {
              "x": -6.841,
              "y": 3.729,
              "z": 0.925
            },
            "rightCorner": {
              "x": -6.837,
              "y": 3.638,
              "z": 0.925
            },
            "gtin": "4260444961268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7de2",
            "leftCorner": {
              "x": -6.837,
              "y": 3.639,
              "z": 0.925
            },
            "rightCorner": {
              "x": -6.832,
              "y": 3.523,
              "z": 0.925
            },
            "gtin": "4306188403562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7de3",
            "leftCorner": {
              "x": -6.831,
              "y": 3.523,
              "z": 0.925
            },
            "rightCorner": {
              "x": -6.826,
              "y": 3.383,
              "z": 0.925
            },
            "gtin": "5202258025896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7de4",
            "leftCorner": {
              "x": -6.83,
              "y": 3.383,
              "z": 0.925
            },
            "rightCorner": {
              "x": -6.826,
              "y": 3.289,
              "z": 0.925
            },
            "gtin": "5202258226156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7de5",
            "leftCorner": {
              "x": -6.829,
              "y": 3.289,
              "z": 0.925
            },
            "rightCorner": {
              "x": -6.824,
              "y": 3.148,
              "z": 0.925
            },
            "gtin": "3482015035470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7de6",
            "leftCorner": {
              "x": -6.822,
              "y": 3.148,
              "z": 0.925
            },
            "rightCorner": {
              "x": -6.818,
              "y": 3.04,
              "z": 0.925
            },
            "gtin": "3023260033424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7de7",
            "leftCorner": {
              "x": -6.818,
              "y": 3.04,
              "z": 0.925
            },
            "rightCorner": {
              "x": -6.813,
              "y": 2.902,
              "z": 0.925
            },
            "gtin": "4306188134039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7de8",
            "leftCorner": {
              "x": -6.811,
              "y": 2.902,
              "z": 0.925
            },
            "rightCorner": {
              "x": -6.808,
              "y": 2.803,
              "z": 0.925
            },
            "gtin": "8000430392562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dd6",
            "leftCorner": {
              "x": -6.813,
              "y": 2.803,
              "z": 0.925
            },
            "rightCorner": {
              "x": -6.805,
              "y": 2.604,
              "z": 0.925
            },
            "gtin": "4306188134046",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4e9",
        "height": 1.383,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e0f",
            "leftCorner": {
              "x": -6.896,
              "y": 3.852,
              "z": 1.132
            },
            "rightCorner": {
              "x": -6.888,
              "y": 3.639,
              "z": 1.132
            },
            "gtin": "4306188394457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e11",
            "leftCorner": {
              "x": -6.84,
              "y": 3.64,
              "z": 1.132
            },
            "rightCorner": {
              "x": -6.836,
              "y": 3.528,
              "z": 1.132
            },
            "gtin": "4306188354208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e12",
            "leftCorner": {
              "x": -6.84,
              "y": 3.528,
              "z": 1.132
            },
            "rightCorner": {
              "x": -6.836,
              "y": 3.418,
              "z": 1.132
            },
            "gtin": "4002671151353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e13",
            "leftCorner": {
              "x": -6.84,
              "y": 3.418,
              "z": 1.132
            },
            "rightCorner": {
              "x": -6.836,
              "y": 3.306,
              "z": 1.132
            },
            "gtin": "4002671104021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e14",
            "leftCorner": {
              "x": -6.837,
              "y": 3.306,
              "z": 1.132
            },
            "rightCorner": {
              "x": -6.827,
              "y": 3.033,
              "z": 1.132
            },
            "gtin": "4002671123701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e15",
            "leftCorner": {
              "x": -6.827,
              "y": 3.033,
              "z": 1.132
            },
            "rightCorner": {
              "x": -6.821,
              "y": 2.876,
              "z": 1.132
            },
            "gtin": "8710243909139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e16",
            "leftCorner": {
              "x": -6.825,
              "y": 2.876,
              "z": 1.132
            },
            "rightCorner": {
              "x": -6.819,
              "y": 2.72,
              "z": 1.132
            },
            "gtin": "4306188432845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e10",
            "leftCorner": {
              "x": -6.808,
              "y": 2.72,
              "z": 1.132
            },
            "rightCorner": {
              "x": -6.804,
              "y": 2.604,
              "z": 1.132
            },
            "gtin": "4306188432876",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4ea",
        "height": 1.6328,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e17",
            "leftCorner": {
              "x": -6.888,
              "y": 3.852,
              "z": 1.336
            },
            "rightCorner": {
              "x": -6.881,
              "y": 3.633,
              "z": 1.336
            },
            "gtin": "4306188037323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f4b1d26ccf18a73598b97a51",
            "leftCorner": {
              "x": -6.854,
              "y": 2.889,
              "z": 1.336
            },
            "rightCorner": {
              "x": -6.85,
              "y": 2.801,
              "z": 1.336
            },
            "gtin": "4008960221912",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e19",
            "leftCorner": {
              "x": -6.834,
              "y": 3.634,
              "z": 1.336
            },
            "rightCorner": {
              "x": -6.83,
              "y": 3.55,
              "z": 1.336
            },
            "gtin": "4008960005758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e1a",
            "leftCorner": {
              "x": -6.837,
              "y": 3.55,
              "z": 1.336
            },
            "rightCorner": {
              "x": -6.832,
              "y": 3.42,
              "z": 1.336
            },
            "gtin": "4002566005051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e1b",
            "leftCorner": {
              "x": -6.833,
              "y": 3.42,
              "z": 1.336
            },
            "rightCorner": {
              "x": -6.828,
              "y": 3.276,
              "z": 1.336
            },
            "gtin": "4002671145369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e1c",
            "leftCorner": {
              "x": -6.823,
              "y": 3.276,
              "z": 1.336
            },
            "rightCorner": {
              "x": -6.818,
              "y": 3.141,
              "z": 1.336
            },
            "gtin": "4002671145246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e1d",
            "leftCorner": {
              "x": -6.826,
              "y": 3.14,
              "z": 1.336
            },
            "rightCorner": {
              "x": -6.822,
              "y": 3.026,
              "z": 1.336
            },
            "gtin": "4002671145277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e1e",
            "leftCorner": {
              "x": -6.82,
              "y": 3.026,
              "z": 1.336
            },
            "rightCorner": {
              "x": -6.816,
              "y": 2.917,
              "z": 1.336
            },
            "gtin": "4002671149138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e1f",
            "leftCorner": {
              "x": -6.812,
              "y": 2.917,
              "z": 1.336
            },
            "rightCorner": {
              "x": -6.811,
              "y": 2.891,
              "z": 1.336
            },
            "gtin": "4306188023951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e21",
            "leftCorner": {
              "x": -6.814,
              "y": 2.798,
              "z": 1.336
            },
            "rightCorner": {
              "x": -6.81,
              "y": 2.709,
              "z": 1.336
            },
            "gtin": "4306188045656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e18",
            "leftCorner": {
              "x": -6.806,
              "y": 2.709,
              "z": 1.336
            },
            "rightCorner": {
              "x": -6.802,
              "y": 2.604,
              "z": 1.336
            },
            "gtin": "4008960221912",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4eb",
        "height": 1.878,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e22",
            "leftCorner": {
              "x": -6.892,
              "y": 3.852,
              "z": 1.537
            },
            "rightCorner": {
              "x": -6.886,
              "y": 3.689,
              "z": 1.537
            },
            "gtin": "4104420076907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e24",
            "leftCorner": {
              "x": -6.844,
              "y": 3.691,
              "z": 1.537
            },
            "rightCorner": {
              "x": -6.84,
              "y": 3.583,
              "z": 1.537
            },
            "gtin": "4104420231498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e25",
            "leftCorner": {
              "x": -6.84,
              "y": 3.583,
              "z": 1.537
            },
            "rightCorner": {
              "x": -6.835,
              "y": 3.454,
              "z": 1.537
            },
            "gtin": "4250426228076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e26",
            "leftCorner": {
              "x": -6.838,
              "y": 3.453,
              "z": 1.537
            },
            "rightCorner": {
              "x": -6.833,
              "y": 3.334,
              "z": 1.537
            },
            "gtin": "4008960221301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e27",
            "leftCorner": {
              "x": -6.837,
              "y": 3.334,
              "z": 1.537
            },
            "rightCorner": {
              "x": -6.834,
              "y": 3.232,
              "z": 1.537
            },
            "gtin": "4008960003723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e28",
            "leftCorner": {
              "x": -6.833,
              "y": 3.232,
              "z": 1.537
            },
            "rightCorner": {
              "x": -6.829,
              "y": 3.101,
              "z": 1.537
            },
            "gtin": "4008960003648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e29",
            "leftCorner": {
              "x": -6.828,
              "y": 3.101,
              "z": 1.537
            },
            "rightCorner": {
              "x": -6.822,
              "y": 2.937,
              "z": 1.537
            },
            "gtin": "4008960221561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e2a",
            "leftCorner": {
              "x": -6.816,
              "y": 2.937,
              "z": 1.537
            },
            "rightCorner": {
              "x": -6.813,
              "y": 2.841,
              "z": 1.537
            },
            "gtin": "4002566002548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e2b",
            "leftCorner": {
              "x": -6.816,
              "y": 2.841,
              "z": 1.537
            },
            "rightCorner": {
              "x": -6.811,
              "y": 2.697,
              "z": 1.537
            },
            "gtin": "4003751060169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e23",
            "leftCorner": {
              "x": -6.811,
              "y": 2.697,
              "z": 1.537
            },
            "rightCorner": {
              "x": -6.808,
              "y": 2.604,
              "z": 1.537
            },
            "gtin": "4005096008561",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "7a8",
    "rightNeighborShelfId": "975"
  },
  {
    "id": "975",
    "name": "975",
    "x": -6.931,
    "y": 2.6,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69417,
      "w": 0.71981
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 44
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4ed",
        "height": 0.62726,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7df4",
            "leftCorner": {
              "x": -6.814,
              "y": 2.604,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.809,
              "y": 2.486,
              "z": 0.513
            },
            "gtin": "4104420079229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7df5",
            "leftCorner": {
              "x": -6.812,
              "y": 2.486,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.804,
              "y": 2.281,
              "z": 0.513
            },
            "gtin": "4104420079229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7df6",
            "leftCorner": {
              "x": -6.804,
              "y": 2.281,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.798,
              "y": 2.129,
              "z": 0.513
            },
            "gtin": "4104420079205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7df7",
            "leftCorner": {
              "x": -6.796,
              "y": 2.129,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.79,
              "y": 1.971,
              "z": 0.513
            },
            "gtin": "4306188035961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7df8",
            "leftCorner": {
              "x": -6.789,
              "y": 1.971,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.783,
              "y": 1.813,
              "z": 0.513
            },
            "gtin": "4306188035992",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7df9",
            "leftCorner": {
              "x": -6.784,
              "y": 1.813,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.779,
              "y": 1.691,
              "z": 0.513
            },
            "gtin": "4250426228113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dfa",
            "leftCorner": {
              "x": -6.78,
              "y": 1.691,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.776,
              "y": 1.572,
              "z": 0.513
            },
            "gtin": "4306188042280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dfb",
            "leftCorner": {
              "x": -6.777,
              "y": 1.572,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.773,
              "y": 1.463,
              "z": 0.513
            },
            "gtin": "4306188012849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dfc",
            "leftCorner": {
              "x": -6.768,
              "y": 1.463,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.765,
              "y": 1.378,
              "z": 0.513
            },
            "gtin": "4306188012788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dfd",
            "leftCorner": {
              "x": -6.852,
              "y": 1.375,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.847,
              "y": 1.249,
              "z": 0.513
            },
            "gtin": "4002468193474",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4ef",
        "height": 0.9277,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e4f",
            "leftCorner": {
              "x": -6.85,
              "y": 2.603,
              "z": 0.759
            },
            "rightCorner": {
              "x": -6.845,
              "y": 2.446,
              "z": 0.759
            },
            "gtin": "4002566010703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e51",
            "leftCorner": {
              "x": -6.798,
              "y": 2.447,
              "z": 0.759
            },
            "rightCorner": {
              "x": -6.792,
              "y": 2.29,
              "z": 0.759
            },
            "gtin": "4008960220960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e52",
            "leftCorner": {
              "x": -6.843,
              "y": 2.288,
              "z": 0.759
            },
            "rightCorner": {
              "x": -6.838,
              "y": 2.159,
              "z": 0.759
            },
            "gtin": "5711953063244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e53",
            "leftCorner": {
              "x": -6.797,
              "y": 2.161,
              "z": 0.759
            },
            "rightCorner": {
              "x": -6.792,
              "y": 2.022,
              "z": 0.759
            },
            "gtin": "5760466751162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e54",
            "leftCorner": {
              "x": -6.789,
              "y": 2.023,
              "z": 0.759
            },
            "rightCorner": {
              "x": -6.783,
              "y": 1.864,
              "z": 0.759
            },
            "gtin": "5760466896467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e55",
            "leftCorner": {
              "x": -6.784,
              "y": 1.864,
              "z": 0.759
            },
            "rightCorner": {
              "x": -6.778,
              "y": 1.697,
              "z": 0.759
            },
            "gtin": "5760466896481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e56",
            "leftCorner": {
              "x": -6.775,
              "y": 1.697,
              "z": 0.759
            },
            "rightCorner": {
              "x": -6.77,
              "y": 1.562,
              "z": 0.759
            },
            "gtin": "4001954304073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e57",
            "leftCorner": {
              "x": -6.773,
              "y": 1.562,
              "z": 0.759
            },
            "rightCorner": {
              "x": -6.769,
              "y": 1.44,
              "z": 0.759
            },
            "gtin": "4001954304257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e58",
            "leftCorner": {
              "x": -6.764,
              "y": 1.441,
              "z": 0.759
            },
            "rightCorner": {
              "x": -6.76,
              "y": 1.317,
              "z": 0.759
            },
            "gtin": "4260444962807",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4ee",
        "height": 1.2353,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e36",
            "leftCorner": {
              "x": -6.85,
              "y": 2.603,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.844,
              "y": 2.44,
              "z": 1.011
            },
            "gtin": "8010721002032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e38",
            "leftCorner": {
              "x": -6.806,
              "y": 2.441,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.802,
              "y": 2.341,
              "z": 1.011
            },
            "gtin": "8001230001302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e39",
            "leftCorner": {
              "x": -6.801,
              "y": 2.341,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.796,
              "y": 2.205,
              "z": 1.011
            },
            "gtin": "8003518108000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e3a",
            "leftCorner": {
              "x": -6.796,
              "y": 2.205,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.79,
              "y": 2.032,
              "z": 1.011
            },
            "gtin": "3090291386041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e3b",
            "leftCorner": {
              "x": -6.784,
              "y": 2.032,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.776,
              "y": 1.835,
              "z": 1.011
            },
            "gtin": "3090291386690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e3c",
            "leftCorner": {
              "x": -6.782,
              "y": 1.835,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.775,
              "y": 1.642,
              "z": 1.011
            },
            "gtin": "3090291122809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e3d",
            "leftCorner": {
              "x": -6.77,
              "y": 1.643,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.764,
              "y": 1.472,
              "z": 1.011
            },
            "gtin": "4002468228862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e3e",
            "leftCorner": {
              "x": -6.763,
              "y": 1.472,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.755,
              "y": 1.24,
              "z": 1.011
            },
            "gtin": "4002468228893",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4f1",
        "height": 1.5395,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e85",
            "leftCorner": {
              "x": -6.859,
              "y": 2.603,
              "z": 1.26
            },
            "rightCorner": {
              "x": -6.85,
              "y": 2.376,
              "z": 1.26
            },
            "gtin": "4008960221868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e87",
            "leftCorner": {
              "x": -6.811,
              "y": 2.378,
              "z": 1.26
            },
            "rightCorner": {
              "x": -6.804,
              "y": 2.172,
              "z": 1.26
            },
            "gtin": "3228023130024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e88",
            "leftCorner": {
              "x": -6.805,
              "y": 2.172,
              "z": 1.26
            },
            "rightCorner": {
              "x": -6.798,
              "y": 1.986,
              "z": 1.26
            },
            "gtin": "4306188431299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e89",
            "leftCorner": {
              "x": -6.873,
              "y": 1.984,
              "z": 1.26
            },
            "rightCorner": {
              "x": -6.867,
              "y": 1.836,
              "z": 1.26
            },
            "gtin": "4306188358510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e8a",
            "leftCorner": {
              "x": -6.789,
              "y": 1.839,
              "z": 1.26
            },
            "rightCorner": {
              "x": -6.784,
              "y": 1.689,
              "z": 1.26
            },
            "gtin": "4306188038467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e8b",
            "leftCorner": {
              "x": -6.784,
              "y": 1.689,
              "z": 1.26
            },
            "rightCorner": {
              "x": -6.778,
              "y": 1.535,
              "z": 1.26
            },
            "gtin": "4306188037293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e8c",
            "leftCorner": {
              "x": -6.777,
              "y": 1.535,
              "z": 1.26
            },
            "rightCorner": {
              "x": -6.771,
              "y": 1.371,
              "z": 1.26
            },
            "gtin": "4002468210454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e8d",
            "leftCorner": {
              "x": -6.769,
              "y": 1.371,
              "z": 1.26
            },
            "rightCorner": {
              "x": -6.765,
              "y": 1.276,
              "z": 1.26
            },
            "gtin": "4002468228855",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4f0",
        "height": 1.8314,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e6c",
            "leftCorner": {
              "x": -6.854,
              "y": 2.603,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.85,
              "y": 2.486,
              "z": 1.498
            },
            "gtin": "4000504173138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e6e",
            "leftCorner": {
              "x": -6.81,
              "y": 2.488,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.804,
              "y": 2.325,
              "z": 1.498
            },
            "gtin": "4000504174432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e6f",
            "leftCorner": {
              "x": -6.806,
              "y": 2.325,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.799,
              "y": 2.131,
              "z": 1.498
            },
            "gtin": "4000504173237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e70",
            "leftCorner": {
              "x": -6.795,
              "y": 2.131,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.79,
              "y": 1.988,
              "z": 1.498
            },
            "gtin": "4000504174739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e71",
            "leftCorner": {
              "x": -6.789,
              "y": 1.988,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.783,
              "y": 1.828,
              "z": 1.498
            },
            "gtin": "4000504176030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e72",
            "leftCorner": {
              "x": -6.784,
              "y": 1.828,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.778,
              "y": 1.672,
              "z": 1.498
            },
            "gtin": "4000504177525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e73",
            "leftCorner": {
              "x": -6.862,
              "y": 1.669,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.856,
              "y": 1.489,
              "z": 1.498
            },
            "gtin": "4000504176627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e74",
            "leftCorner": {
              "x": -6.857,
              "y": 1.489,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.854,
              "y": 1.385,
              "z": 1.498
            },
            "gtin": "4000504176528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e75",
            "leftCorner": {
              "x": -6.849,
              "y": 1.385,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.846,
              "y": 1.294,
              "z": 1.498
            },
            "gtin": "4000504171622",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "974",
    "rightNeighborShelfId": "976"
  },
  {
    "id": "976",
    "name": "976",
    "x": -6.886,
    "y": 1.351,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69417,
      "w": 0.71981
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 47
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4f2",
        "height": 0.62929,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7dfe",
            "leftCorner": {
              "x": -6.761,
              "y": 1.252,
              "z": 0.515
            },
            "rightCorner": {
              "x": -6.755,
              "y": 1.081,
              "z": 0.515
            },
            "gtin": "4002468193412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1d9226cacdb126c3eacc5ba5",
            "leftCorner": {
              "x": -6.807,
              "y": 1.354,
              "z": 0.515
            },
            "rightCorner": {
              "x": -6.803,
              "y": 1.251,
              "z": 0.515
            },
            "gtin": "4306188334927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dff",
            "leftCorner": {
              "x": -6.754,
              "y": 1.081,
              "z": 0.515
            },
            "rightCorner": {
              "x": -6.75,
              "y": 0.987,
              "z": 0.515
            },
            "gtin": "4002468193283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e00",
            "leftCorner": {
              "x": -6.754,
              "y": 0.987,
              "z": 0.515
            },
            "rightCorner": {
              "x": -6.749,
              "y": 0.847,
              "z": 0.515
            },
            "gtin": "4002468193443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e01",
            "leftCorner": {
              "x": -6.748,
              "y": 0.847,
              "z": 0.515
            },
            "rightCorner": {
              "x": -6.739,
              "y": 0.58,
              "z": 0.515
            },
            "gtin": "4002468229128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e02",
            "leftCorner": {
              "x": -6.737,
              "y": 0.58,
              "z": 0.515
            },
            "rightCorner": {
              "x": -6.733,
              "y": 0.476,
              "z": 0.515
            },
            "gtin": "4306188334927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e03",
            "leftCorner": {
              "x": -6.742,
              "y": 0.476,
              "z": 0.515
            },
            "rightCorner": {
              "x": -6.738,
              "y": 0.369,
              "z": 0.515
            },
            "gtin": "4306188407447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e04",
            "leftCorner": {
              "x": -6.74,
              "y": 0.369,
              "z": 0.515
            },
            "rightCorner": {
              "x": -6.735,
              "y": 0.221,
              "z": 0.515
            },
            "gtin": "4000436509562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e05",
            "leftCorner": {
              "x": -6.733,
              "y": 0.221,
              "z": 0.515
            },
            "rightCorner": {
              "x": -6.729,
              "y": 0.106,
              "z": 0.515
            },
            "gtin": "4000436519646",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4f4",
        "height": 0.93182,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e59",
            "leftCorner": {
              "x": -6.846,
              "y": 1.314,
              "z": 0.762
            },
            "rightCorner": {
              "x": -6.843,
              "y": 1.224,
              "z": 0.762
            },
            "gtin": "4014500509747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5ec37a0b531d0114b92933ee",
            "leftCorner": {
              "x": -6.777,
              "y": 0.485,
              "z": 0.762
            },
            "rightCorner": {
              "x": -6.774,
              "y": 0.4,
              "z": 0.762
            },
            "gtin": "4014500509747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e5a",
            "leftCorner": {
              "x": -6.759,
              "y": 1.227,
              "z": 0.762
            },
            "rightCorner": {
              "x": -6.755,
              "y": 1.102,
              "z": 0.762
            },
            "gtin": "4008432042229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e5b",
            "leftCorner": {
              "x": -6.835,
              "y": 1.099,
              "z": 0.762
            },
            "rightCorner": {
              "x": -6.83,
              "y": 0.955,
              "z": 0.762
            },
            "gtin": "4008432086421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e5c",
            "leftCorner": {
              "x": -6.832,
              "y": 0.955,
              "z": 0.762
            },
            "rightCorner": {
              "x": -6.827,
              "y": 0.819,
              "z": 0.762
            },
            "gtin": "4056924002206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e5d",
            "leftCorner": {
              "x": -6.747,
              "y": 0.822,
              "z": 0.762
            },
            "rightCorner": {
              "x": -6.743,
              "y": 0.685,
              "z": 0.762
            },
            "gtin": "4056924000530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e5e",
            "leftCorner": {
              "x": -6.78,
              "y": 0.684,
              "z": 0.762
            },
            "rightCorner": {
              "x": -6.774,
              "y": 0.528,
              "z": 0.762
            },
            "gtin": "4250426228090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e5f",
            "leftCorner": {
              "x": -6.817,
              "y": 0.526,
              "z": 0.762
            },
            "rightCorner": {
              "x": -6.815,
              "y": 0.483,
              "z": 0.762
            },
            "gtin": "4002334118952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e61",
            "leftCorner": {
              "x": -6.734,
              "y": 0.394,
              "z": 0.762
            },
            "rightCorner": {
              "x": -6.729,
              "y": 0.252,
              "z": 0.762
            },
            "gtin": "4002334118938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e62",
            "leftCorner": {
              "x": -6.729,
              "y": 0.252,
              "z": 0.762
            },
            "rightCorner": {
              "x": -6.723,
              "y": 0.106,
              "z": 0.762
            },
            "gtin": "4002334118945",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4f3",
        "height": 1.2354,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e3f",
            "leftCorner": {
              "x": -6.756,
              "y": 1.24,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.753,
              "y": 1.157,
              "z": 1.011
            },
            "gtin": "5011069173081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c2b7ac89bbfe93bdc2614257",
            "leftCorner": {
              "x": -6.8,
              "y": 1.354,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.796,
              "y": 1.268,
              "z": 1.011
            },
            "gtin": "4002468228886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e40",
            "leftCorner": {
              "x": -6.752,
              "y": 1.157,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.747,
              "y": 1.014,
              "z": 1.011
            },
            "gtin": "5011069173913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e41",
            "leftCorner": {
              "x": -6.746,
              "y": 1.014,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.743,
              "y": 0.912,
              "z": 1.011
            },
            "gtin": "4306188035626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e42",
            "leftCorner": {
              "x": -6.743,
              "y": 0.912,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.734,
              "y": 0.657,
              "z": 1.011
            },
            "gtin": "4306188035657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e43",
            "leftCorner": {
              "x": -6.737,
              "y": 0.657,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.732,
              "y": 0.508,
              "z": 1.011
            },
            "gtin": "4002468209717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e44",
            "leftCorner": {
              "x": -6.731,
              "y": 0.508,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.727,
              "y": 0.39,
              "z": 1.011
            },
            "gtin": "8721800406220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e45",
            "leftCorner": {
              "x": -6.731,
              "y": 0.39,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.723,
              "y": 0.168,
              "z": 1.011
            },
            "gtin": "8721800405889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e46",
            "leftCorner": {
              "x": -6.727,
              "y": 0.168,
              "z": 1.011
            },
            "rightCorner": {
              "x": -6.725,
              "y": 0.106,
              "z": 1.011
            },
            "gtin": "8721800405865",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4f5",
        "height": 1.5366,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e8e",
            "leftCorner": {
              "x": -6.845,
              "y": 1.274,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.838,
              "y": 1.069,
              "z": 1.257
            },
            "gtin": "4002468210478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bb6b092c3ab2703a9daa7a21",
            "leftCorner": {
              "x": -6.811,
              "y": 1.354,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.809,
              "y": 1.31,
              "z": 1.257
            },
            "gtin": "8721800405353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "be224a547ae7846785dad41f",
            "leftCorner": {
              "x": -6.809,
              "y": 1.31,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.808,
              "y": 1.288,
              "z": 1.257
            },
            "gtin": "8721800405353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e8f",
            "leftCorner": {
              "x": -6.756,
              "y": 1.072,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.749,
              "y": 0.87,
              "z": 1.257
            },
            "gtin": "3090291124650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e90",
            "leftCorner": {
              "x": -6.749,
              "y": 0.87,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.743,
              "y": 0.705,
              "z": 1.257
            },
            "gtin": "3090291116044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e91",
            "leftCorner": {
              "x": -6.79,
              "y": 0.703,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.786,
              "y": 0.601,
              "z": 1.257
            },
            "gtin": "3090291276076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e92",
            "leftCorner": {
              "x": -6.74,
              "y": 0.602,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.734,
              "y": 0.443,
              "z": 1.257
            },
            "gtin": "4260444962982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e93",
            "leftCorner": {
              "x": -6.742,
              "y": 0.442,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.737,
              "y": 0.307,
              "z": 1.257
            },
            "gtin": "8721800409863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e94",
            "leftCorner": {
              "x": -6.736,
              "y": 0.307,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.73,
              "y": 0.156,
              "z": 1.257
            },
            "gtin": "8721800405377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e95",
            "leftCorner": {
              "x": -6.737,
              "y": 0.156,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.736,
              "y": 0.106,
              "z": 1.257
            },
            "gtin": "8721800405353",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4f6",
        "height": 1.8364,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e76",
            "leftCorner": {
              "x": -6.76,
              "y": 1.298,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.755,
              "y": 1.145,
              "z": 1.503
            },
            "gtin": "4000504171134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9160d72a0f5e980dfc19fa8f",
            "leftCorner": {
              "x": -6.811,
              "y": 1.354,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.809,
              "y": 1.307,
              "z": 1.503
            },
            "gtin": "3073780815079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e77",
            "leftCorner": {
              "x": -6.838,
              "y": 1.142,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.832,
              "y": 0.998,
              "z": 1.503
            },
            "gtin": "4013557044379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e78",
            "leftCorner": {
              "x": -6.755,
              "y": 1.0,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.75,
              "y": 0.866,
              "z": 1.503
            },
            "gtin": "4013557082630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e79",
            "leftCorner": {
              "x": -6.833,
              "y": 0.863,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.827,
              "y": 0.703,
              "z": 1.503
            },
            "gtin": "4013557044775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e7a",
            "leftCorner": {
              "x": -6.827,
              "y": 0.703,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.822,
              "y": 0.566,
              "z": 1.503
            },
            "gtin": "4008960217311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e7b",
            "leftCorner": {
              "x": -6.738,
              "y": 0.569,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.733,
              "y": 0.42,
              "z": 1.503
            },
            "gtin": "4013557082470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e7c",
            "leftCorner": {
              "x": -6.735,
              "y": 0.42,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.73,
              "y": 0.281,
              "z": 1.503
            },
            "gtin": "8710243909962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e7d",
            "leftCorner": {
              "x": -6.732,
              "y": 0.281,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.722,
              "y": -0.003,
              "z": 1.503
            },
            "gtin": "8710243909900",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "975",
    "rightNeighborShelfId": "977"
  },
  {
    "id": "977",
    "name": "977",
    "x": -6.84,
    "y": 0.101,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69417,
      "w": 0.71981
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 46
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4f8",
        "height": 0.63021,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e06",
            "leftCorner": {
              "x": -6.739,
              "y": 0.105,
              "z": 0.516
            },
            "rightCorner": {
              "x": -6.737,
              "y": 0.073,
              "z": 0.516
            },
            "gtin": "4000436505267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e07",
            "leftCorner": {
              "x": -6.739,
              "y": 0.073,
              "z": 0.516
            },
            "rightCorner": {
              "x": -6.735,
              "y": -0.062,
              "z": 0.516
            },
            "gtin": "4000436505267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e08",
            "leftCorner": {
              "x": -6.727,
              "y": -0.062,
              "z": 0.516
            },
            "rightCorner": {
              "x": -6.722,
              "y": -0.198,
              "z": 0.516
            },
            "gtin": "4000436503669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e09",
            "leftCorner": {
              "x": -6.721,
              "y": -0.198,
              "z": 0.516
            },
            "rightCorner": {
              "x": -6.716,
              "y": -0.327,
              "z": 0.516
            },
            "gtin": "4000436514054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e0a",
            "leftCorner": {
              "x": -6.712,
              "y": -0.326,
              "z": 0.516
            },
            "rightCorner": {
              "x": -6.706,
              "y": -0.491,
              "z": 0.516
            },
            "gtin": "4250426203899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e0b",
            "leftCorner": {
              "x": -6.704,
              "y": -0.491,
              "z": 0.516
            },
            "rightCorner": {
              "x": -6.699,
              "y": -0.644,
              "z": 0.516
            },
            "gtin": "4250426206777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e0c",
            "leftCorner": {
              "x": -6.71,
              "y": -0.645,
              "z": 0.516
            },
            "rightCorner": {
              "x": -6.704,
              "y": -0.801,
              "z": 0.516
            },
            "gtin": "4250426207552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e0d",
            "leftCorner": {
              "x": -6.701,
              "y": -0.801,
              "z": 0.516
            },
            "rightCorner": {
              "x": -6.696,
              "y": -0.921,
              "z": 0.516
            },
            "gtin": "4250426207613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e0e",
            "leftCorner": {
              "x": -6.691,
              "y": -0.921,
              "z": 0.516
            },
            "rightCorner": {
              "x": -6.686,
              "y": -1.061,
              "z": 0.516
            },
            "gtin": "4250426205442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dea",
            "leftCorner": {
              "x": -6.686,
              "y": -1.061,
              "z": 0.516
            },
            "rightCorner": {
              "x": -6.683,
              "y": -1.144,
              "z": 0.516
            },
            "gtin": "4250426207590",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4f9",
        "height": 0.93369,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e63",
            "leftCorner": {
              "x": -6.729,
              "y": 0.105,
              "z": 0.764
            },
            "rightCorner": {
              "x": -6.727,
              "y": 0.075,
              "z": 0.764
            },
            "gtin": "4006402046192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e64",
            "leftCorner": {
              "x": -6.736,
              "y": 0.075,
              "z": 0.764
            },
            "rightCorner": {
              "x": -6.731,
              "y": -0.083,
              "z": 0.764
            },
            "gtin": "4006402046192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e65",
            "leftCorner": {
              "x": -6.727,
              "y": -0.082,
              "z": 0.764
            },
            "rightCorner": {
              "x": -6.721,
              "y": -0.24,
              "z": 0.764
            },
            "gtin": "4006402049193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e66",
            "leftCorner": {
              "x": -6.717,
              "y": -0.24,
              "z": 0.764
            },
            "rightCorner": {
              "x": -6.711,
              "y": -0.385,
              "z": 0.764
            },
            "gtin": "4250780325015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e67",
            "leftCorner": {
              "x": -6.709,
              "y": -0.385,
              "z": 0.764
            },
            "rightCorner": {
              "x": -6.703,
              "y": -0.523,
              "z": 0.764
            },
            "gtin": "4250780325039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e68",
            "leftCorner": {
              "x": -6.703,
              "y": -0.523,
              "z": 0.764
            },
            "rightCorner": {
              "x": -6.698,
              "y": -0.652,
              "z": 0.764
            },
            "gtin": "4104420138926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e69",
            "leftCorner": {
              "x": -6.705,
              "y": -0.652,
              "z": 0.764
            },
            "rightCorner": {
              "x": -6.699,
              "y": -0.805,
              "z": 0.764
            },
            "gtin": "4104420138865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e6a",
            "leftCorner": {
              "x": -6.696,
              "y": -0.805,
              "z": 0.764
            },
            "rightCorner": {
              "x": -6.691,
              "y": -0.952,
              "z": 0.764
            },
            "gtin": "4104420138889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e6b",
            "leftCorner": {
              "x": -6.69,
              "y": -0.952,
              "z": 0.764
            },
            "rightCorner": {
              "x": -6.685,
              "y": -1.091,
              "z": 0.764
            },
            "gtin": "4104420138827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e50",
            "leftCorner": {
              "x": -6.679,
              "y": -1.091,
              "z": 0.764
            },
            "rightCorner": {
              "x": -6.677,
              "y": -1.144,
              "z": 0.764
            },
            "gtin": "4104420138841",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4fb",
        "height": 1.2344,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e47",
            "leftCorner": {
              "x": -6.735,
              "y": 0.105,
              "z": 1.01
            },
            "rightCorner": {
              "x": -6.732,
              "y": 0.034,
              "z": 1.01
            },
            "gtin": "8721800401737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e48",
            "leftCorner": {
              "x": -6.727,
              "y": 0.034,
              "z": 1.01
            },
            "rightCorner": {
              "x": -6.721,
              "y": -0.138,
              "z": 1.01
            },
            "gtin": "8721800401737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e49",
            "leftCorner": {
              "x": -6.802,
              "y": -0.141,
              "z": 1.01
            },
            "rightCorner": {
              "x": -6.795,
              "y": -0.314,
              "z": 1.01
            },
            "gtin": "8721800401676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e4a",
            "leftCorner": {
              "x": -6.708,
              "y": -0.311,
              "z": 1.01
            },
            "rightCorner": {
              "x": -6.703,
              "y": -0.43,
              "z": 1.01
            },
            "gtin": "8721800401553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e4b",
            "leftCorner": {
              "x": -6.702,
              "y": -0.43,
              "z": 1.01
            },
            "rightCorner": {
              "x": -6.696,
              "y": -0.607,
              "z": 1.01
            },
            "gtin": "4036300155702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e4c",
            "leftCorner": {
              "x": -6.707,
              "y": -0.608,
              "z": 1.01
            },
            "rightCorner": {
              "x": -6.702,
              "y": -0.744,
              "z": 1.01
            },
            "gtin": "4036300150837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e4d",
            "leftCorner": {
              "x": -6.696,
              "y": -0.744,
              "z": 1.01
            },
            "rightCorner": {
              "x": -6.691,
              "y": -0.889,
              "z": 1.01
            },
            "gtin": "4036300135933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e4e",
            "leftCorner": {
              "x": -6.689,
              "y": -0.889,
              "z": 1.01
            },
            "rightCorner": {
              "x": -6.683,
              "y": -1.051,
              "z": 1.01
            },
            "gtin": "4036300003294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e37",
            "leftCorner": {
              "x": -6.679,
              "y": -1.051,
              "z": 1.01
            },
            "rightCorner": {
              "x": -6.676,
              "y": -1.144,
              "z": 1.01
            },
            "gtin": "4036300005304",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4f7",
        "height": 1.5369,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e96",
            "leftCorner": {
              "x": -6.743,
              "y": 0.105,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.738,
              "y": 0.002,
              "z": 1.257
            },
            "gtin": "8721800405360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e97",
            "leftCorner": {
              "x": -6.73,
              "y": 0.002,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.724,
              "y": -0.162,
              "z": 1.257
            },
            "gtin": "8721800405360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e98",
            "leftCorner": {
              "x": -6.722,
              "y": -0.162,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.717,
              "y": -0.312,
              "z": 1.257
            },
            "gtin": "8721800405346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e99",
            "leftCorner": {
              "x": -6.714,
              "y": -0.312,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.708,
              "y": -0.473,
              "z": 1.257
            },
            "gtin": "8721800401317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e9a",
            "leftCorner": {
              "x": -6.71,
              "y": -0.473,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.705,
              "y": -0.613,
              "z": 1.257
            },
            "gtin": "4036300107756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e9b",
            "leftCorner": {
              "x": -6.708,
              "y": -0.613,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.703,
              "y": -0.76,
              "z": 1.257
            },
            "gtin": "4036300005281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e9c",
            "leftCorner": {
              "x": -6.703,
              "y": -0.76,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.698,
              "y": -0.918,
              "z": 1.257
            },
            "gtin": "4036300005298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e9d",
            "leftCorner": {
              "x": -6.695,
              "y": -0.917,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.69,
              "y": -1.068,
              "z": 1.257
            },
            "gtin": "4036300005090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e86",
            "leftCorner": {
              "x": -6.686,
              "y": -1.067,
              "z": 1.257
            },
            "rightCorner": {
              "x": -6.683,
              "y": -1.144,
              "z": 1.257
            },
            "gtin": "4036300005311",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4fa",
        "height": 1.8369,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e7e",
            "leftCorner": {
              "x": -6.729,
              "y": -0.004,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.725,
              "y": -0.114,
              "z": 1.503
            },
            "gtin": "5711953204739",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7e7f",
            "leftCorner": {
              "x": -6.724,
              "y": -0.114,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.719,
              "y": -0.25,
              "z": 1.503
            },
            "gtin": "5760466925570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e80",
            "leftCorner": {
              "x": -6.718,
              "y": -0.25,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.712,
              "y": -0.417,
              "z": 1.503
            },
            "gtin": "4306188053880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e81",
            "leftCorner": {
              "x": -6.71,
              "y": -0.417,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.704,
              "y": -0.566,
              "z": 1.503
            },
            "gtin": "4306188038665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e82",
            "leftCorner": {
              "x": -6.704,
              "y": -0.566,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.697,
              "y": -0.737,
              "z": 1.503
            },
            "gtin": "3176582001821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e83",
            "leftCorner": {
              "x": -6.7,
              "y": -0.737,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.695,
              "y": -0.881,
              "z": 1.503
            },
            "gtin": "4001954000517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e84",
            "leftCorner": {
              "x": -6.695,
              "y": -0.881,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.688,
              "y": -1.079,
              "z": 1.503
            },
            "gtin": "4001954000425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7e6d",
            "leftCorner": {
              "x": -6.682,
              "y": -1.079,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.68,
              "y": -1.144,
              "z": 1.503
            },
            "gtin": "4001954000586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bb2465549ea8104183be7ab3",
            "leftCorner": {
              "x": -6.77,
              "y": 0.104,
              "z": 1.503
            },
            "rightCorner": {
              "x": -6.767,
              "y": 0.024,
              "z": 1.503
            },
            "gtin": "4001954000586",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "976"
  },
  {
    "id": "978",
    "name": "978",
    "x": -17.091,
    "y": 4.88,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0093025,
      "w": 0.99996
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4c5",
        "height": 0.16883,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7cba",
            "leftCorner": {
              "x": -17.035,
              "y": 4.834,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.912,
              "y": 4.836,
              "z": 0.138
            },
            "gtin": "4003301012099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cbb",
            "leftCorner": {
              "x": -16.912,
              "y": 4.837,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.785,
              "y": 4.84,
              "z": 0.138
            },
            "gtin": "4006542075212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cbc",
            "leftCorner": {
              "x": -16.787,
              "y": 4.916,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.623,
              "y": 4.919,
              "z": 0.138
            },
            "gtin": "4006861990265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cbd",
            "leftCorner": {
              "x": -16.621,
              "y": 4.843,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.494,
              "y": 4.846,
              "z": 0.138
            },
            "gtin": "4022229301627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cbe",
            "leftCorner": {
              "x": -16.494,
              "y": 4.848,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.414,
              "y": 4.85,
              "z": 0.138
            },
            "gtin": "4008005046012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cbf",
            "leftCorner": {
              "x": -16.414,
              "y": 4.85,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.334,
              "y": 4.851,
              "z": 0.138
            },
            "gtin": "4008005046012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cc0",
            "leftCorner": {
              "x": -16.334,
              "y": 4.851,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.196,
              "y": 4.853,
              "z": 0.138
            },
            "gtin": "4306188008163",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cc1",
            "leftCorner": {
              "x": -16.196,
              "y": 4.855,
              "z": 0.138
            },
            "rightCorner": {
              "x": -16.074,
              "y": 4.857,
              "z": 0.138
            },
            "gtin": "5601129033099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cc2",
            "leftCorner": {
              "x": -16.074,
              "y": 4.857,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.979,
              "y": 4.859,
              "z": 0.138
            },
            "gtin": "4006542078244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cae",
            "leftCorner": {
              "x": -15.979,
              "y": 4.861,
              "z": 0.138
            },
            "rightCorner": {
              "x": -15.841,
              "y": 4.864,
              "z": 0.138
            },
            "gtin": "8008530008994",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4c4",
        "height": 0.56057,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ca7",
            "leftCorner": {
              "x": -17.034,
              "y": 4.826,
              "z": 0.459
            },
            "rightCorner": {
              "x": -16.797,
              "y": 4.83,
              "z": 0.459
            },
            "gtin": "5601012011500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ca8",
            "leftCorner": {
              "x": -16.797,
              "y": 4.832,
              "z": 0.459
            },
            "rightCorner": {
              "x": -16.639,
              "y": 4.835,
              "z": 0.459
            },
            "gtin": "4001432021232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ca9",
            "leftCorner": {
              "x": -16.639,
              "y": 4.835,
              "z": 0.459
            },
            "rightCorner": {
              "x": -16.447,
              "y": 4.839,
              "z": 0.459
            },
            "gtin": "3263286354121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7caa",
            "leftCorner": {
              "x": -16.447,
              "y": 4.842,
              "z": 0.459
            },
            "rightCorner": {
              "x": -16.291,
              "y": 4.845,
              "z": 0.459
            },
            "gtin": "3263280102179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cab",
            "leftCorner": {
              "x": -16.291,
              "y": 4.847,
              "z": 0.459
            },
            "rightCorner": {
              "x": -16.147,
              "y": 4.85,
              "z": 0.459
            },
            "gtin": "5942084507080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cac",
            "leftCorner": {
              "x": -16.147,
              "y": 4.851,
              "z": 0.459
            },
            "rightCorner": {
              "x": -15.963,
              "y": 4.854,
              "z": 0.459
            },
            "gtin": "4006975020810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c92",
            "leftCorner": {
              "x": -15.963,
              "y": 4.853,
              "z": 0.459
            },
            "rightCorner": {
              "x": -15.84,
              "y": 4.856,
              "z": 0.459
            },
            "gtin": "4006310717108",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4c6",
        "height": 0.95002,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c87",
            "leftCorner": {
              "x": -17.031,
              "y": 4.835,
              "z": 0.777
            },
            "rightCorner": {
              "x": -16.882,
              "y": 4.838,
              "z": 0.777
            },
            "gtin": "3211200108756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c88",
            "leftCorner": {
              "x": -16.882,
              "y": 4.842,
              "z": 0.777
            },
            "rightCorner": {
              "x": -16.806,
              "y": 4.843,
              "z": 0.777
            },
            "gtin": "4001432059037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c89",
            "leftCorner": {
              "x": -16.806,
              "y": 4.843,
              "z": 0.777
            },
            "rightCorner": {
              "x": -16.731,
              "y": 4.845,
              "z": 0.777
            },
            "gtin": "4001432059037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c8a",
            "leftCorner": {
              "x": -16.731,
              "y": 4.842,
              "z": 0.777
            },
            "rightCorner": {
              "x": -16.59,
              "y": 4.844,
              "z": 0.777
            },
            "gtin": "4049366003986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c8b",
            "leftCorner": {
              "x": -16.59,
              "y": 4.85,
              "z": 0.777
            },
            "rightCorner": {
              "x": -16.441,
              "y": 4.852,
              "z": 0.777
            },
            "gtin": "4006861900202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c8c",
            "leftCorner": {
              "x": -16.441,
              "y": 4.857,
              "z": 0.777
            },
            "rightCorner": {
              "x": -16.286,
              "y": 4.86,
              "z": 0.777
            },
            "gtin": "4003301086991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c8d",
            "leftCorner": {
              "x": -16.286,
              "y": 4.859,
              "z": 0.777
            },
            "rightCorner": {
              "x": -16.138,
              "y": 4.862,
              "z": 0.777
            },
            "gtin": "4003301035968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c8e",
            "leftCorner": {
              "x": -16.138,
              "y": 4.863,
              "z": 0.777
            },
            "rightCorner": {
              "x": -15.971,
              "y": 4.866,
              "z": 0.777
            },
            "gtin": "4007649711409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c6d",
            "leftCorner": {
              "x": -15.971,
              "y": 4.867,
              "z": 0.777
            },
            "rightCorner": {
              "x": -15.841,
              "y": 4.87,
              "z": 0.777
            },
            "gtin": "4007649712406",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4c3",
        "height": 1.3534,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c64",
            "leftCorner": {
              "x": -17.02,
              "y": 4.838,
              "z": 1.107
            },
            "rightCorner": {
              "x": -16.891,
              "y": 4.841,
              "z": 1.107
            },
            "gtin": "8410406311006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c65",
            "leftCorner": {
              "x": -16.891,
              "y": 4.844,
              "z": 1.107
            },
            "rightCorner": {
              "x": -16.751,
              "y": 4.847,
              "z": 1.107
            },
            "gtin": "8410406611007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c66",
            "leftCorner": {
              "x": -16.751,
              "y": 4.848,
              "z": 1.107
            },
            "rightCorner": {
              "x": -16.588,
              "y": 4.851,
              "z": 1.107
            },
            "gtin": "4002958333519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c69",
            "leftCorner": {
              "x": -16.403,
              "y": 4.857,
              "z": 1.107
            },
            "rightCorner": {
              "x": -16.279,
              "y": 4.859,
              "z": 1.107
            },
            "gtin": "4306188020493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c6a",
            "leftCorner": {
              "x": -16.28,
              "y": 4.86,
              "z": 1.107
            },
            "rightCorner": {
              "x": -16.098,
              "y": 4.863,
              "z": 1.107
            },
            "gtin": "8410384004761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c6b",
            "leftCorner": {
              "x": -16.098,
              "y": 4.867,
              "z": 1.107
            },
            "rightCorner": {
              "x": -15.987,
              "y": 4.869,
              "z": 1.107
            },
            "gtin": "8410384001128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c4b",
            "leftCorner": {
              "x": -15.987,
              "y": 4.864,
              "z": 1.107
            },
            "rightCorner": {
              "x": -15.841,
              "y": 4.867,
              "z": 1.107
            },
            "gtin": "8410384048055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f675b4c99befd3243f05aa26",
            "leftCorner": {
              "x": -17.09,
              "y": 4.804,
              "z": 1.107
            },
            "rightCorner": {
              "x": -17.021,
              "y": 4.805,
              "z": 1.107
            },
            "gtin": "4002958333519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1321ae4141b69a57c3967ea6",
            "leftCorner": {
              "x": -16.588,
              "y": 4.813,
              "z": 1.107
            },
            "rightCorner": {
              "x": -16.41,
              "y": 4.816,
              "z": 1.107
            },
            "gtin": "8410384004761",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4c2",
        "height": 1.7253,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7c43",
            "leftCorner": {
              "x": -16.979,
              "y": 4.831,
              "z": 1.412
            },
            "rightCorner": {
              "x": -16.818,
              "y": 4.834,
              "z": 1.412
            }
          },
          {
            "id": "68d8e50de1820c81800d7c44",
            "leftCorner": {
              "x": -16.818,
              "y": 4.839,
              "z": 1.412
            },
            "rightCorner": {
              "x": -16.685,
              "y": 4.841,
              "z": 1.412
            },
            "gtin": "4006975209963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c45",
            "leftCorner": {
              "x": -16.685,
              "y": 4.839,
              "z": 1.412
            },
            "rightCorner": {
              "x": -16.544,
              "y": 4.842,
              "z": 1.412
            },
            "gtin": "4006311992269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c46",
            "leftCorner": {
              "x": -16.544,
              "y": 4.847,
              "z": 1.412
            },
            "rightCorner": {
              "x": -16.403,
              "y": 4.85,
              "z": 1.412
            },
            "gtin": "8051566562855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c47",
            "leftCorner": {
              "x": -16.403,
              "y": 4.85,
              "z": 1.412
            },
            "rightCorner": {
              "x": -16.256,
              "y": 4.853,
              "z": 1.412
            },
            "gtin": "8002793018684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c48",
            "leftCorner": {
              "x": -16.256,
              "y": 4.855,
              "z": 1.412
            },
            "rightCorner": {
              "x": -16.091,
              "y": 4.858,
              "z": 1.412
            },
            "gtin": "4002859121130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c49",
            "leftCorner": {
              "x": -16.091,
              "y": 4.86,
              "z": 1.412
            },
            "rightCorner": {
              "x": -15.976,
              "y": 4.863,
              "z": 1.412
            },
            "gtin": "4006542073423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7c2b",
            "leftCorner": {
              "x": -15.975,
              "y": 4.861,
              "z": 1.412
            },
            "rightCorner": {
              "x": -15.841,
              "y": 4.864,
              "z": 1.412
            }
          },
          {
            "id": "a1b3260ac83d71644178de00",
            "leftCorner": {
              "x": -17.09,
              "y": 4.797,
              "z": 1.412
            },
            "rightCorner": {
              "x": -16.982,
              "y": 4.799,
              "z": 1.412
            },
            "gtin": "4006975209963",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "79f",
    "rightNeighborShelfId": "979"
  },
  {
    "id": "979",
    "name": "979",
    "x": -15.841,
    "y": 4.903,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0093025,
      "w": 0.99996
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4c9",
        "height": 0.63133,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7cc3",
            "leftCorner": {
              "x": -15.843,
              "y": 4.989,
              "z": 0.517
            },
            "rightCorner": {
              "x": -15.741,
              "y": 4.991,
              "z": 0.517
            },
            "gtin": "4250426230420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ae2b76fef037826752cde563",
            "leftCorner": {
              "x": -15.705,
              "y": 4.992,
              "z": 0.517
            },
            "rightCorner": {
              "x": -15.589,
              "y": 4.994,
              "z": 0.517
            },
            "gtin": "4260334162201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cc5",
            "leftCorner": {
              "x": -15.741,
              "y": 4.956,
              "z": 0.517
            },
            "rightCorner": {
              "x": -15.704,
              "y": 4.957,
              "z": 0.517
            },
            "gtin": "4250426207217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cc8",
            "leftCorner": {
              "x": -15.585,
              "y": 5.026,
              "z": 0.517
            },
            "rightCorner": {
              "x": -15.44,
              "y": 5.029,
              "z": 0.517
            },
            "gtin": "4005790328057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cc9",
            "leftCorner": {
              "x": -15.44,
              "y": 5.033,
              "z": 0.517
            },
            "rightCorner": {
              "x": -15.306,
              "y": 5.036,
              "z": 0.517
            },
            "gtin": "29087167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cca",
            "leftCorner": {
              "x": -15.306,
              "y": 5.037,
              "z": 0.517
            },
            "rightCorner": {
              "x": -15.176,
              "y": 5.04,
              "z": 0.517
            },
            "gtin": "4005790332429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ccb",
            "leftCorner": {
              "x": -15.176,
              "y": 5.032,
              "z": 0.517
            },
            "rightCorner": {
              "x": -15.065,
              "y": 5.034,
              "z": 0.517
            },
            "gtin": "4005790331200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ccc",
            "leftCorner": {
              "x": -15.065,
              "y": 5.046,
              "z": 0.517
            },
            "rightCorner": {
              "x": -14.961,
              "y": 5.048,
              "z": 0.517
            },
            "gtin": "4002049024807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ccd",
            "leftCorner": {
              "x": -14.961,
              "y": 5.048,
              "z": 0.517
            },
            "rightCorner": {
              "x": -14.859,
              "y": 5.05,
              "z": 0.517
            },
            "gtin": "4306188048169",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cce",
            "leftCorner": {
              "x": -14.859,
              "y": 5.053,
              "z": 0.517
            },
            "rightCorner": {
              "x": -14.72,
              "y": 5.055,
              "z": 0.517
            },
            "gtin": "4000930511054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ccf",
            "leftCorner": {
              "x": -14.72,
              "y": 5.055,
              "z": 0.517
            },
            "rightCorner": {
              "x": -14.636,
              "y": 5.057,
              "z": 0.517
            },
            "gtin": "4260334162201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cd0",
            "leftCorner": {
              "x": -14.636,
              "y": 5.056,
              "z": 0.517
            },
            "rightCorner": {
              "x": -14.48,
              "y": 5.059,
              "z": 0.517
            },
            "gtin": "4260334165158",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4cb",
        "height": 0.92596,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d3a",
            "leftCorner": {
              "x": -15.843,
              "y": 4.988,
              "z": 0.758
            },
            "rightCorner": {
              "x": -15.693,
              "y": 4.991,
              "z": 0.758
            },
            "gtin": "4250426220551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d3c",
            "leftCorner": {
              "x": -15.693,
              "y": 5.03,
              "z": 0.758
            },
            "rightCorner": {
              "x": -15.547,
              "y": 5.033,
              "z": 0.758
            },
            "gtin": "4250426209785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d3d",
            "leftCorner": {
              "x": -15.547,
              "y": 5.033,
              "z": 0.758
            },
            "rightCorner": {
              "x": -15.421,
              "y": 5.035,
              "z": 0.758
            },
            "gtin": "4306188032663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d3e",
            "leftCorner": {
              "x": -15.421,
              "y": 5.04,
              "z": 0.758
            },
            "rightCorner": {
              "x": -15.284,
              "y": 5.043,
              "z": 0.758
            },
            "gtin": "4306188382454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d3f",
            "leftCorner": {
              "x": -15.284,
              "y": 5.039,
              "z": 0.758
            },
            "rightCorner": {
              "x": -15.181,
              "y": 5.041,
              "z": 0.758
            },
            "gtin": "4250426209808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d40",
            "leftCorner": {
              "x": -15.181,
              "y": 5.036,
              "z": 0.758
            },
            "rightCorner": {
              "x": -15.052,
              "y": 5.039,
              "z": 0.758
            },
            "gtin": "4005790334003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d41",
            "leftCorner": {
              "x": -15.053,
              "y": 5.041,
              "z": 0.758
            },
            "rightCorner": {
              "x": -14.935,
              "y": 5.043,
              "z": 0.758
            },
            "gtin": "4250426203776",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d42",
            "leftCorner": {
              "x": -14.935,
              "y": 5.047,
              "z": 0.758
            },
            "rightCorner": {
              "x": -14.832,
              "y": 5.049,
              "z": 0.758
            },
            "gtin": "4250426224023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d43",
            "leftCorner": {
              "x": -14.832,
              "y": 5.053,
              "z": 0.758
            },
            "rightCorner": {
              "x": -14.644,
              "y": 5.056,
              "z": 0.758
            },
            "gtin": "4000503280004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d44",
            "leftCorner": {
              "x": -14.644,
              "y": 5.06,
              "z": 0.758
            },
            "rightCorner": {
              "x": -14.48,
              "y": 5.063,
              "z": 0.758
            },
            "gtin": "4000503281902",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4cd",
        "height": 1.2291,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7da7",
            "leftCorner": {
              "x": -15.843,
              "y": 4.993,
              "z": 1.006
            },
            "rightCorner": {
              "x": -15.553,
              "y": 4.999,
              "z": 1.006
            },
            "gtin": "4005790401217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7da9",
            "leftCorner": {
              "x": -15.553,
              "y": 5.038,
              "z": 1.006
            },
            "rightCorner": {
              "x": -15.384,
              "y": 5.041,
              "z": 1.006
            },
            "gtin": "4005790401507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7daa",
            "leftCorner": {
              "x": -15.382,
              "y": 4.958,
              "z": 1.006
            },
            "rightCorner": {
              "x": -15.003,
              "y": 4.965,
              "z": 1.006
            },
            "gtin": "4005790401125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dab",
            "leftCorner": {
              "x": -15.005,
              "y": 5.046,
              "z": 1.006
            },
            "rightCorner": {
              "x": -14.87,
              "y": 5.049,
              "z": 1.006
            },
            "gtin": "4019467467000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dac",
            "leftCorner": {
              "x": -14.87,
              "y": 5.051,
              "z": 1.006
            },
            "rightCorner": {
              "x": -14.699,
              "y": 5.054,
              "z": 1.006
            },
            "gtin": "4000503281001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dad",
            "leftCorner": {
              "x": -14.699,
              "y": 5.058,
              "z": 1.006
            },
            "rightCorner": {
              "x": -14.589,
              "y": 5.06,
              "z": 1.006
            },
            "gtin": "4000503282008",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4ca",
        "height": 1.5323,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7cfd",
            "leftCorner": {
              "x": -15.842,
              "y": 4.983,
              "z": 1.254
            },
            "rightCorner": {
              "x": -15.693,
              "y": 4.986,
              "z": 1.254
            },
            "gtin": "4000503290805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cff",
            "leftCorner": {
              "x": -15.694,
              "y": 5.024,
              "z": 1.254
            },
            "rightCorner": {
              "x": -15.57,
              "y": 5.026,
              "z": 1.254
            },
            "gtin": "4000503290904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d00",
            "leftCorner": {
              "x": -15.57,
              "y": 5.028,
              "z": 1.254
            },
            "rightCorner": {
              "x": -15.452,
              "y": 5.031,
              "z": 1.254
            },
            "gtin": "4000503243504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d01",
            "leftCorner": {
              "x": -15.452,
              "y": 5.031,
              "z": 1.254
            },
            "rightCorner": {
              "x": -15.33,
              "y": 5.033,
              "z": 1.254
            },
            "gtin": "4000503243801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d02",
            "leftCorner": {
              "x": -15.33,
              "y": 5.032,
              "z": 1.254
            },
            "rightCorner": {
              "x": -15.177,
              "y": 5.035,
              "z": 1.254
            },
            "gtin": "4000503243405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d03",
            "leftCorner": {
              "x": -15.177,
              "y": 5.032,
              "z": 1.254
            },
            "rightCorner": {
              "x": -15.028,
              "y": 5.034,
              "z": 1.254
            },
            "gtin": "4005790260746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d04",
            "leftCorner": {
              "x": -15.028,
              "y": 5.039,
              "z": 1.254
            },
            "rightCorner": {
              "x": -14.8,
              "y": 5.043,
              "z": 1.254
            },
            "gtin": "4005790260371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d05",
            "leftCorner": {
              "x": -14.8,
              "y": 5.045,
              "z": 1.254
            },
            "rightCorner": {
              "x": -14.684,
              "y": 5.047,
              "z": 1.254
            },
            "gtin": "4010198030518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d06",
            "leftCorner": {
              "x": -14.683,
              "y": 4.976,
              "z": 1.254
            },
            "rightCorner": {
              "x": -14.575,
              "y": 4.978,
              "z": 1.254
            },
            "gtin": "4010198052718",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4cc",
        "height": 1.8311,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d75",
            "leftCorner": {
              "x": -15.843,
              "y": 4.987,
              "z": 1.498
            },
            "rightCorner": {
              "x": -15.677,
              "y": 4.99,
              "z": 1.498
            },
            "gtin": "4001929545593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d77",
            "leftCorner": {
              "x": -15.678,
              "y": 5.029,
              "z": 1.498
            },
            "rightCorner": {
              "x": -15.544,
              "y": 5.031,
              "z": 1.498
            },
            "gtin": "4001929013580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d78",
            "leftCorner": {
              "x": -15.544,
              "y": 5.033,
              "z": 1.498
            },
            "rightCorner": {
              "x": -15.413,
              "y": 5.035,
              "z": 1.498
            },
            "gtin": "4001929013900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d79",
            "leftCorner": {
              "x": -15.413,
              "y": 5.037,
              "z": 1.498
            },
            "rightCorner": {
              "x": -15.292,
              "y": 5.039,
              "z": 1.498
            },
            "gtin": "4001929013719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d7a",
            "leftCorner": {
              "x": -15.292,
              "y": 5.039,
              "z": 1.498
            },
            "rightCorner": {
              "x": -15.144,
              "y": 5.041,
              "z": 1.498
            },
            "gtin": "3181450100964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d7b",
            "leftCorner": {
              "x": -15.144,
              "y": 5.039,
              "z": 1.498
            },
            "rightCorner": {
              "x": -15.015,
              "y": 5.042,
              "z": 1.498
            },
            "gtin": "4008460243025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d7c",
            "leftCorner": {
              "x": -15.015,
              "y": 5.042,
              "z": 1.498
            },
            "rightCorner": {
              "x": -14.657,
              "y": 5.049,
              "z": 1.498
            },
            "gtin": "4002993071100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d7d",
            "leftCorner": {
              "x": -14.655,
              "y": 4.987,
              "z": 1.498
            },
            "rightCorner": {
              "x": -14.44,
              "y": 4.991,
              "z": 1.498
            },
            "gtin": "4099498000230",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "978",
    "rightNeighborShelfId": "97a"
  },
  {
    "id": "97a",
    "name": "97a",
    "x": -14.591,
    "y": 4.926,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0093025,
      "w": 0.99996
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 53
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4ce",
        "height": 0.62252,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7cd1",
            "leftCorner": {
              "x": -14.48,
              "y": 5.051,
              "z": 0.509
            },
            "rightCorner": {
              "x": -14.358,
              "y": 5.054,
              "z": 0.509
            },
            "gtin": "4260334165042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "007779b3a86bc031990ebb09",
            "leftCorner": {
              "x": -14.593,
              "y": 5.002,
              "z": 0.509
            },
            "rightCorner": {
              "x": -14.483,
              "y": 5.004,
              "z": 0.509
            },
            "gtin": "8713354168051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cd2",
            "leftCorner": {
              "x": -14.358,
              "y": 5.053,
              "z": 0.509
            },
            "rightCorner": {
              "x": -14.25,
              "y": 5.055,
              "z": 0.509
            },
            "gtin": "8713354168051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cd3",
            "leftCorner": {
              "x": -14.249,
              "y": 5.048,
              "z": 0.509
            },
            "rightCorner": {
              "x": -14.097,
              "y": 5.051,
              "z": 0.509
            },
            "gtin": "8713354006674",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cd4",
            "leftCorner": {
              "x": -14.097,
              "y": 5.054,
              "z": 0.509
            },
            "rightCorner": {
              "x": -13.995,
              "y": 5.056,
              "z": 0.509
            },
            "gtin": "4306188430582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cd5",
            "leftCorner": {
              "x": -13.994,
              "y": 5.051,
              "z": 0.509
            },
            "rightCorner": {
              "x": -13.906,
              "y": 5.052,
              "z": 0.509
            },
            "gtin": "42274285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cd6",
            "leftCorner": {
              "x": -13.905,
              "y": 5.034,
              "z": 0.509
            },
            "rightCorner": {
              "x": -13.787,
              "y": 5.036,
              "z": 0.509
            },
            "gtin": "4306188052098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cd7",
            "leftCorner": {
              "x": -13.787,
              "y": 5.043,
              "z": 0.509
            },
            "rightCorner": {
              "x": -13.668,
              "y": 5.045,
              "z": 0.509
            },
            "gtin": "4306188052128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cd8",
            "leftCorner": {
              "x": -13.668,
              "y": 5.049,
              "z": 0.509
            },
            "rightCorner": {
              "x": -13.512,
              "y": 5.052,
              "z": 0.509
            },
            "gtin": "7613036915076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cd9",
            "leftCorner": {
              "x": -13.514,
              "y": 5.07,
              "z": 0.509
            },
            "rightCorner": {
              "x": -13.411,
              "y": 5.072,
              "z": 0.509
            },
            "gtin": "7613038419176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cda",
            "leftCorner": {
              "x": -13.411,
              "y": 5.075,
              "z": 0.509
            },
            "rightCorner": {
              "x": -13.244,
              "y": 5.078,
              "z": 0.509
            },
            "gtin": "7290109359021",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4d0",
        "height": 0.92557,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d45",
            "leftCorner": {
              "x": -14.48,
              "y": 5.053,
              "z": 0.757
            },
            "rightCorner": {
              "x": -14.362,
              "y": 5.055,
              "z": 0.757
            },
            "gtin": "4104420181250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "79879c1637b6db3ef55b9a53",
            "leftCorner": {
              "x": -14.593,
              "y": 5.005,
              "z": 0.757
            },
            "rightCorner": {
              "x": -14.566,
              "y": 5.005,
              "z": 0.757
            },
            "gtin": "4260380665015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f39361479cbeb1abdf2fd757",
            "leftCorner": {
              "x": -14.566,
              "y": 5.005,
              "z": 0.757
            },
            "rightCorner": {
              "x": -14.538,
              "y": 5.006,
              "z": 0.757
            },
            "gtin": "4260380665015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7fe2d4b6459255bcb9044fb4",
            "leftCorner": {
              "x": -14.538,
              "y": 5.006,
              "z": 0.757
            },
            "rightCorner": {
              "x": -14.511,
              "y": 5.006,
              "z": 0.757
            },
            "gtin": "4260380665015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a657cdbfcc92d40c7282fc3e",
            "leftCorner": {
              "x": -14.511,
              "y": 5.006,
              "z": 0.757
            },
            "rightCorner": {
              "x": -14.484,
              "y": 5.007,
              "z": 0.757
            },
            "gtin": "4260380665015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d46",
            "leftCorner": {
              "x": -14.362,
              "y": 5.05,
              "z": 0.757
            },
            "rightCorner": {
              "x": -14.205,
              "y": 5.053,
              "z": 0.757
            },
            "gtin": "4104420257016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d47",
            "leftCorner": {
              "x": -14.205,
              "y": 5.06,
              "z": 0.757
            },
            "rightCorner": {
              "x": -14.082,
              "y": 5.062,
              "z": 0.757
            },
            "gtin": "8710912064725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d48",
            "leftCorner": {
              "x": -14.082,
              "y": 5.054,
              "z": 0.757
            },
            "rightCorner": {
              "x": -13.948,
              "y": 5.056,
              "z": 0.757
            },
            "gtin": "8710912064749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d49",
            "leftCorner": {
              "x": -13.947,
              "y": 5.029,
              "z": 0.757
            },
            "rightCorner": {
              "x": -13.81,
              "y": 5.032,
              "z": 0.757
            },
            "gtin": "4104420228184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d4a",
            "leftCorner": {
              "x": -13.811,
              "y": 5.044,
              "z": 0.757
            },
            "rightCorner": {
              "x": -13.674,
              "y": 5.047,
              "z": 0.757
            },
            "gtin": "4004790103251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d4b",
            "leftCorner": {
              "x": -13.674,
              "y": 5.05,
              "z": 0.757
            },
            "rightCorner": {
              "x": -13.498,
              "y": 5.053,
              "z": 0.757
            },
            "gtin": "4260380665053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d4c",
            "leftCorner": {
              "x": -13.499,
              "y": 5.065,
              "z": 0.757
            },
            "rightCorner": {
              "x": -13.234,
              "y": 5.07,
              "z": 0.757
            },
            "gtin": "4260380665039",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4cf",
        "height": 1.2292,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7dae",
            "leftCorner": {
              "x": -14.59,
              "y": 5.052,
              "z": 1.006
            },
            "rightCorner": {
              "x": -14.493,
              "y": 5.053,
              "z": 1.006
            },
            "gtin": "4250426219845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7daf",
            "leftCorner": {
              "x": -14.493,
              "y": 5.051,
              "z": 1.006
            },
            "rightCorner": {
              "x": -14.392,
              "y": 5.053,
              "z": 1.006
            },
            "gtin": "4000405002612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7db0",
            "leftCorner": {
              "x": -14.392,
              "y": 5.057,
              "z": 1.006
            },
            "rightCorner": {
              "x": -14.26,
              "y": 5.06,
              "z": 1.006
            },
            "gtin": "4000405002605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7db1",
            "leftCorner": {
              "x": -14.259,
              "y": 4.974,
              "z": 1.006
            },
            "rightCorner": {
              "x": -14.141,
              "y": 4.976,
              "z": 1.006
            },
            "gtin": "4000405001783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7db2",
            "leftCorner": {
              "x": -14.142,
              "y": 5.065,
              "z": 1.006
            },
            "rightCorner": {
              "x": -14.018,
              "y": 5.068,
              "z": 1.006
            },
            "gtin": "4000405001752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7db3",
            "leftCorner": {
              "x": -14.018,
              "y": 5.066,
              "z": 1.006
            },
            "rightCorner": {
              "x": -13.892,
              "y": 5.068,
              "z": 1.006
            },
            "gtin": "4000405001523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7db4",
            "leftCorner": {
              "x": -13.891,
              "y": 5.04,
              "z": 1.006
            },
            "rightCorner": {
              "x": -13.753,
              "y": 5.043,
              "z": 1.006
            },
            "gtin": "4000405002414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7db5",
            "leftCorner": {
              "x": -13.753,
              "y": 5.052,
              "z": 1.006
            },
            "rightCorner": {
              "x": -13.596,
              "y": 5.055,
              "z": 1.006
            },
            "gtin": "4000405005217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7db6",
            "leftCorner": {
              "x": -13.596,
              "y": 5.07,
              "z": 1.006
            },
            "rightCorner": {
              "x": -13.466,
              "y": 5.072,
              "z": 1.006
            },
            "gtin": "4000405001868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7db7",
            "leftCorner": {
              "x": -13.466,
              "y": 5.077,
              "z": 1.006
            },
            "rightCorner": {
              "x": -13.329,
              "y": 5.08,
              "z": 1.006
            },
            "gtin": "4000405001851",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4d2",
        "height": 1.5322,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d07",
            "leftCorner": {
              "x": -14.576,
              "y": 5.003,
              "z": 1.254
            },
            "rightCorner": {
              "x": -14.495,
              "y": 5.004,
              "z": 1.254
            },
            "gtin": "4039081221857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d08",
            "leftCorner": {
              "x": -14.495,
              "y": 5.045,
              "z": 1.254
            },
            "rightCorner": {
              "x": -14.353,
              "y": 5.048,
              "z": 1.254
            },
            "gtin": "4039081802476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d09",
            "leftCorner": {
              "x": -14.354,
              "y": 5.051,
              "z": 1.254
            },
            "rightCorner": {
              "x": -14.173,
              "y": 5.054,
              "z": 1.254
            },
            "gtin": "4000405001585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d0a",
            "leftCorner": {
              "x": -14.173,
              "y": 5.057,
              "z": 1.254
            },
            "rightCorner": {
              "x": -14.048,
              "y": 5.06,
              "z": 1.254
            },
            "gtin": "4000405003466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d0b",
            "leftCorner": {
              "x": -14.048,
              "y": 5.052,
              "z": 1.254
            },
            "rightCorner": {
              "x": -13.955,
              "y": 5.054,
              "z": 1.254
            },
            "gtin": "4000405005026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d0c",
            "leftCorner": {
              "x": -13.954,
              "y": 5.025,
              "z": 1.254
            },
            "rightCorner": {
              "x": -13.851,
              "y": 5.027,
              "z": 1.254
            },
            "gtin": "4000405002308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d0d",
            "leftCorner": {
              "x": -13.851,
              "y": 5.036,
              "z": 1.254
            },
            "rightCorner": {
              "x": -13.732,
              "y": 5.038,
              "z": 1.254
            },
            "gtin": "4000405001684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d0e",
            "leftCorner": {
              "x": -13.732,
              "y": 5.04,
              "z": 1.254
            },
            "rightCorner": {
              "x": -13.615,
              "y": 5.043,
              "z": 1.254
            },
            "gtin": "4099498000322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d0f",
            "leftCorner": {
              "x": -13.616,
              "y": 5.058,
              "z": 1.254
            },
            "rightCorner": {
              "x": -13.47,
              "y": 5.061,
              "z": 1.254
            },
            "gtin": "4099498000087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d10",
            "leftCorner": {
              "x": -13.47,
              "y": 5.068,
              "z": 1.254
            },
            "rightCorner": {
              "x": -13.387,
              "y": 5.07,
              "z": 1.254
            },
            "gtin": "4000405002704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d11",
            "leftCorner": {
              "x": -13.387,
              "y": 5.069,
              "z": 1.254
            },
            "rightCorner": {
              "x": -13.283,
              "y": 5.071,
              "z": 1.254
            },
            "gtin": "4000405001394",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4d1",
        "height": 1.8296,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d7e",
            "leftCorner": {
              "x": -14.442,
              "y": 5.051,
              "z": 1.497
            },
            "rightCorner": {
              "x": -14.295,
              "y": 5.053,
              "z": 1.497
            },
            "gtin": "4099498000308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4453429f953f2b0f56a426fb",
            "leftCorner": {
              "x": -14.593,
              "y": 5.005,
              "z": 1.497
            },
            "rightCorner": {
              "x": -14.45,
              "y": 5.008,
              "z": 1.497
            },
            "gtin": "4099498000308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d7f",
            "leftCorner": {
              "x": -14.295,
              "y": 5.054,
              "z": 1.497
            },
            "rightCorner": {
              "x": -14.157,
              "y": 5.057,
              "z": 1.497
            },
            "gtin": "4099498000049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d80",
            "leftCorner": {
              "x": -14.157,
              "y": 5.054,
              "z": 1.497
            },
            "rightCorner": {
              "x": -14.027,
              "y": 5.057,
              "z": 1.497
            },
            "gtin": "4099498000407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d81",
            "leftCorner": {
              "x": -14.027,
              "y": 5.054,
              "z": 1.497
            },
            "rightCorner": {
              "x": -13.897,
              "y": 5.057,
              "z": 1.497
            },
            "gtin": "4099498000018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d82",
            "leftCorner": {
              "x": -13.896,
              "y": 5.037,
              "z": 1.497
            },
            "rightCorner": {
              "x": -13.762,
              "y": 5.039,
              "z": 1.497
            },
            "gtin": "4000405002834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d83",
            "leftCorner": {
              "x": -13.762,
              "y": 5.049,
              "z": 1.497
            },
            "rightCorner": {
              "x": -13.625,
              "y": 5.052,
              "z": 1.497
            },
            "gtin": "4000405002476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d84",
            "leftCorner": {
              "x": -13.624,
              "y": 5.016,
              "z": 1.497
            },
            "rightCorner": {
              "x": -13.509,
              "y": 5.018,
              "z": 1.497
            },
            "gtin": "4000405005316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d85",
            "leftCorner": {
              "x": -13.51,
              "y": 5.073,
              "z": 1.497
            },
            "rightCorner": {
              "x": -13.217,
              "y": 5.079,
              "z": 1.497
            },
            "gtin": "4000405004982",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "979",
    "rightNeighborShelfId": "97b"
  },
  {
    "id": "97b",
    "name": "97b",
    "x": -13.342,
    "y": 4.95,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0093025,
      "w": 0.99996
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 47
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4d3",
        "height": 0.6238,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7cdb",
            "leftCorner": {
              "x": -13.245,
              "y": 5.08,
              "z": 0.51
            },
            "rightCorner": {
              "x": -13.128,
              "y": 5.082,
              "z": 0.51
            },
            "gtin": "7613287424600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4e71785671e99d10ba8e64bc",
            "leftCorner": {
              "x": -13.344,
              "y": 5.032,
              "z": 0.51
            },
            "rightCorner": {
              "x": -13.248,
              "y": 5.034,
              "z": 0.51
            },
            "gtin": "4250426216998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cdc",
            "leftCorner": {
              "x": -13.128,
              "y": 5.089,
              "z": 0.51
            },
            "rightCorner": {
              "x": -12.996,
              "y": 5.091,
              "z": 0.51
            },
            "gtin": "4099498000209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cdd",
            "leftCorner": {
              "x": -12.995,
              "y": 5.055,
              "z": 0.51
            },
            "rightCorner": {
              "x": -12.833,
              "y": 5.058,
              "z": 0.51
            },
            "gtin": "4099498000391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cde",
            "leftCorner": {
              "x": -12.834,
              "y": 5.098,
              "z": 0.51
            },
            "rightCorner": {
              "x": -12.698,
              "y": 5.1,
              "z": 0.51
            },
            "gtin": "4099498000421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cdf",
            "leftCorner": {
              "x": -12.698,
              "y": 5.098,
              "z": 0.51
            },
            "rightCorner": {
              "x": -12.556,
              "y": 5.1,
              "z": 0.51
            },
            "gtin": "4099498000384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ce0",
            "leftCorner": {
              "x": -12.554,
              "y": 5.017,
              "z": 0.51
            },
            "rightCorner": {
              "x": -12.416,
              "y": 5.019,
              "z": 0.51
            },
            "gtin": "4006229019041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ce1",
            "leftCorner": {
              "x": -12.416,
              "y": 5.012,
              "z": 0.51
            },
            "rightCorner": {
              "x": -12.291,
              "y": 5.014,
              "z": 0.51
            },
            "gtin": "4009238002066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ce2",
            "leftCorner": {
              "x": -12.292,
              "y": 5.086,
              "z": 0.51
            },
            "rightCorner": {
              "x": -12.197,
              "y": 5.088,
              "z": 0.51
            },
            "gtin": "4250426216998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ce3",
            "leftCorner": {
              "x": -12.197,
              "y": 5.093,
              "z": 0.51
            },
            "rightCorner": {
              "x": -12.022,
              "y": 5.097,
              "z": 0.51
            },
            "gtin": "4250426216950",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4d7",
        "height": 0.92734,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d4d",
            "leftCorner": {
              "x": -13.235,
              "y": 5.082,
              "z": 0.759
            },
            "rightCorner": {
              "x": -13.094,
              "y": 5.085,
              "z": 0.759
            },
            "gtin": "4260322211362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4a91c9aadb483591c50dd329",
            "leftCorner": {
              "x": -13.344,
              "y": 5.042,
              "z": 0.759
            },
            "rightCorner": {
              "x": -13.289,
              "y": 5.043,
              "z": 0.759
            },
            "gtin": "4306188419372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f168fd47d0fb586bd31f08c8",
            "leftCorner": {
              "x": -13.289,
              "y": 5.043,
              "z": 0.759
            },
            "rightCorner": {
              "x": -13.237,
              "y": 5.044,
              "z": 0.759
            },
            "gtin": "4306188419372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d4e",
            "leftCorner": {
              "x": -13.094,
              "y": 5.088,
              "z": 0.759
            },
            "rightCorner": {
              "x": -12.939,
              "y": 5.091,
              "z": 0.759
            },
            "gtin": "7290010739820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d4f",
            "leftCorner": {
              "x": -12.939,
              "y": 5.093,
              "z": 0.759
            },
            "rightCorner": {
              "x": -12.787,
              "y": 5.096,
              "z": 0.759
            },
            "gtin": "4003171036379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d50",
            "leftCorner": {
              "x": -12.787,
              "y": 5.094,
              "z": 0.759
            },
            "rightCorner": {
              "x": -12.579,
              "y": 5.098,
              "z": 0.759
            },
            "gtin": "4001956315817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d51",
            "leftCorner": {
              "x": -12.577,
              "y": 5.014,
              "z": 0.759
            },
            "rightCorner": {
              "x": -12.419,
              "y": 5.016,
              "z": 0.759
            },
            "gtin": "4001956315886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d52",
            "leftCorner": {
              "x": -12.42,
              "y": 5.099,
              "z": 0.759
            },
            "rightCorner": {
              "x": -12.325,
              "y": 5.101,
              "z": 0.759
            },
            "gtin": "4001956451119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d53",
            "leftCorner": {
              "x": -12.325,
              "y": 5.088,
              "z": 0.759
            },
            "rightCorner": {
              "x": -12.193,
              "y": 5.09,
              "z": 0.759
            },
            "gtin": "4001956451515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d54",
            "leftCorner": {
              "x": -12.193,
              "y": 5.093,
              "z": 0.759
            },
            "rightCorner": {
              "x": -12.095,
              "y": 5.095,
              "z": 0.759
            },
            "gtin": "4306188419372",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4d4",
        "height": 1.2314,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7db8",
            "leftCorner": {
              "x": -13.33,
              "y": 5.08,
              "z": 1.008
            },
            "rightCorner": {
              "x": -13.205,
              "y": 5.082,
              "z": 1.008
            },
            "gtin": "4000405005033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7db9",
            "leftCorner": {
              "x": -13.205,
              "y": 5.084,
              "z": 1.008
            },
            "rightCorner": {
              "x": -12.932,
              "y": 5.09,
              "z": 1.008
            },
            "gtin": "4000405005002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dba",
            "leftCorner": {
              "x": -12.932,
              "y": 5.097,
              "z": 1.008
            },
            "rightCorner": {
              "x": -12.798,
              "y": 5.1,
              "z": 1.008
            },
            "gtin": "4250426226911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dbb",
            "leftCorner": {
              "x": -12.797,
              "y": 5.034,
              "z": 1.008
            },
            "rightCorner": {
              "x": -12.651,
              "y": 5.037,
              "z": 1.008
            },
            "gtin": "4260047762071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dbc",
            "leftCorner": {
              "x": -12.651,
              "y": 5.031,
              "z": 1.008
            },
            "rightCorner": {
              "x": -12.508,
              "y": 5.033,
              "z": 1.008
            },
            "gtin": "4250426226874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dbd",
            "leftCorner": {
              "x": -12.509,
              "y": 5.088,
              "z": 1.008
            },
            "rightCorner": {
              "x": -12.382,
              "y": 5.09,
              "z": 1.008
            },
            "gtin": "4250426226850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dbe",
            "leftCorner": {
              "x": -12.382,
              "y": 5.095,
              "z": 1.008
            },
            "rightCorner": {
              "x": -12.242,
              "y": 5.097,
              "z": 1.008
            },
            "gtin": "4250426226898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dbf",
            "leftCorner": {
              "x": -12.242,
              "y": 5.093,
              "z": 1.008
            },
            "rightCorner": {
              "x": -12.068,
              "y": 5.097,
              "z": 1.008
            },
            "gtin": "4000405003602",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4d5",
        "height": 1.5338,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d12",
            "leftCorner": {
              "x": -13.284,
              "y": 5.073,
              "z": 1.255
            },
            "rightCorner": {
              "x": -13.2,
              "y": 5.074,
              "z": 1.255
            },
            "gtin": "4000405001714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "29687625129725e9e8de6726",
            "leftCorner": {
              "x": -13.344,
              "y": 5.033,
              "z": 1.255
            },
            "rightCorner": {
              "x": -13.322,
              "y": 5.033,
              "z": 1.255
            },
            "gtin": "4000405003435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "05cd1c234826f09b131bb2f9",
            "leftCorner": {
              "x": -13.322,
              "y": 5.033,
              "z": 1.255
            },
            "rightCorner": {
              "x": -13.3,
              "y": 5.033,
              "z": 1.255
            },
            "gtin": "4000405003435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d13",
            "leftCorner": {
              "x": -13.2,
              "y": 5.075,
              "z": 1.255
            },
            "rightCorner": {
              "x": -13.037,
              "y": 5.078,
              "z": 1.255
            },
            "gtin": "4000405002360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d14",
            "leftCorner": {
              "x": -13.037,
              "y": 5.084,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.831,
              "y": 5.088,
              "z": 1.255
            },
            "gtin": "4001956315879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d15",
            "leftCorner": {
              "x": -12.831,
              "y": 5.093,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.642,
              "y": 5.097,
              "z": 1.255
            },
            "gtin": "4001956215414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d16",
            "leftCorner": {
              "x": -12.641,
              "y": 5.012,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.423,
              "y": 5.016,
              "z": 1.255
            },
            "gtin": "4001956215339",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d17",
            "leftCorner": {
              "x": -12.425,
              "y": 5.09,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.145,
              "y": 5.095,
              "z": 1.255
            },
            "gtin": "4001956315916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d18",
            "leftCorner": {
              "x": -12.145,
              "y": 5.093,
              "z": 1.255
            },
            "rightCorner": {
              "x": -12.017,
              "y": 5.095,
              "z": 1.255
            },
            "gtin": "4000405003435",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4d6",
        "height": 1.8317,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d86",
            "leftCorner": {
              "x": -13.218,
              "y": 5.078,
              "z": 1.499
            },
            "rightCorner": {
              "x": -13.097,
              "y": 5.081,
              "z": 1.499
            },
            "gtin": "4000405004593",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0bf497fe90136d1f347a1b7a",
            "leftCorner": {
              "x": -13.344,
              "y": 5.037,
              "z": 1.499
            },
            "rightCorner": {
              "x": -13.22,
              "y": 5.039,
              "z": 1.499
            },
            "gtin": "4019467483505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d87",
            "leftCorner": {
              "x": -13.096,
              "y": 4.999,
              "z": 1.499
            },
            "rightCorner": {
              "x": -12.984,
              "y": 5.001,
              "z": 1.499
            },
            "gtin": "4000405004968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d88",
            "leftCorner": {
              "x": -12.986,
              "y": 5.086,
              "z": 1.499
            },
            "rightCorner": {
              "x": -12.859,
              "y": 5.089,
              "z": 1.499
            },
            "gtin": "4000405001738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d89",
            "leftCorner": {
              "x": -12.859,
              "y": 5.09,
              "z": 1.499
            },
            "rightCorner": {
              "x": -12.694,
              "y": 5.093,
              "z": 1.499
            },
            "gtin": "4000405001745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d8a",
            "leftCorner": {
              "x": -12.694,
              "y": 5.094,
              "z": 1.499
            },
            "rightCorner": {
              "x": -12.578,
              "y": 5.096,
              "z": 1.499
            },
            "gtin": "4250426215557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d8b",
            "leftCorner": {
              "x": -12.578,
              "y": 5.091,
              "z": 1.499
            },
            "rightCorner": {
              "x": -12.448,
              "y": 5.094,
              "z": 1.499
            },
            "gtin": "4019467483505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d8c",
            "leftCorner": {
              "x": -12.447,
              "y": 5.048,
              "z": 1.499
            },
            "rightCorner": {
              "x": -12.307,
              "y": 5.05,
              "z": 1.499
            },
            "gtin": "4019467470604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d8d",
            "leftCorner": {
              "x": -12.309,
              "y": 5.083,
              "z": 1.499
            },
            "rightCorner": {
              "x": -12.178,
              "y": 5.085,
              "z": 1.499
            },
            "gtin": "4019467438208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d8e",
            "leftCorner": {
              "x": -12.177,
              "y": 5.005,
              "z": 1.499
            },
            "rightCorner": {
              "x": -12.014,
              "y": 5.008,
              "z": 1.499
            },
            "gtin": "4019467437904",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "97a",
    "rightNeighborShelfId": "97c"
  },
  {
    "id": "97c",
    "name": "97c",
    "x": -12.092,
    "y": 4.973,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0093025,
      "w": 0.99996
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 57
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4da",
        "height": 0.62365,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ce4",
            "leftCorner": {
              "x": -12.021,
              "y": 5.093,
              "z": 0.51
            },
            "rightCorner": {
              "x": -11.911,
              "y": 5.095,
              "z": 0.51
            },
            "gtin": "4250426216936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f2b754575f52ef55995093eb",
            "leftCorner": {
              "x": -12.093,
              "y": 5.053,
              "z": 0.51
            },
            "rightCorner": {
              "x": -12.021,
              "y": 5.055,
              "z": 0.51
            },
            "gtin": "4250426217841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ce5",
            "leftCorner": {
              "x": -11.911,
              "y": 5.099,
              "z": 0.51
            },
            "rightCorner": {
              "x": -11.801,
              "y": 5.101,
              "z": 0.51
            },
            "gtin": "4250426216974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ce6",
            "leftCorner": {
              "x": -11.801,
              "y": 5.1,
              "z": 0.51
            },
            "rightCorner": {
              "x": -11.64,
              "y": 5.103,
              "z": 0.51
            },
            "gtin": "4306188340867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ce7",
            "leftCorner": {
              "x": -11.64,
              "y": 5.105,
              "z": 0.51
            },
            "rightCorner": {
              "x": -11.497,
              "y": 5.107,
              "z": 0.51
            },
            "gtin": "4306188038863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ce8",
            "leftCorner": {
              "x": -11.497,
              "y": 5.11,
              "z": 0.51
            },
            "rightCorner": {
              "x": -11.385,
              "y": 5.112,
              "z": 0.51
            },
            "gtin": "4306188038832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ce9",
            "leftCorner": {
              "x": -11.384,
              "y": 5.102,
              "z": 0.51
            },
            "rightCorner": {
              "x": -11.297,
              "y": 5.104,
              "z": 0.51
            },
            "gtin": "4004787051640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cea",
            "leftCorner": {
              "x": -11.297,
              "y": 5.1,
              "z": 0.51
            },
            "rightCorner": {
              "x": -11.21,
              "y": 5.102,
              "z": 0.51
            },
            "gtin": "4004787050469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ceb",
            "leftCorner": {
              "x": -11.21,
              "y": 5.104,
              "z": 0.51
            },
            "rightCorner": {
              "x": -11.106,
              "y": 5.106,
              "z": 0.51
            },
            "gtin": "4250426217889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cec",
            "leftCorner": {
              "x": -11.106,
              "y": 5.111,
              "z": 0.51
            },
            "rightCorner": {
              "x": -10.935,
              "y": 5.114,
              "z": 0.51
            },
            "gtin": "4250426217926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ced",
            "leftCorner": {
              "x": -10.934,
              "y": 5.111,
              "z": 0.51
            },
            "rightCorner": {
              "x": -10.844,
              "y": 5.113,
              "z": 0.51
            },
            "gtin": "4250426217841",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4dc",
        "height": 0.92483,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d55",
            "leftCorner": {
              "x": -12.093,
              "y": 5.044,
              "z": 0.757
            },
            "rightCorner": {
              "x": -12.009,
              "y": 5.046,
              "z": 0.757
            },
            "gtin": "4006639127763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d56",
            "leftCorner": {
              "x": -12.008,
              "y": 5.013,
              "z": 0.757
            },
            "rightCorner": {
              "x": -11.775,
              "y": 5.017,
              "z": 0.757
            },
            "gtin": "4006639127763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d57",
            "leftCorner": {
              "x": -11.776,
              "y": 5.02,
              "z": 0.757
            },
            "rightCorner": {
              "x": -11.453,
              "y": 5.026,
              "z": 0.757
            },
            "gtin": "4003171003692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d58",
            "leftCorner": {
              "x": -11.453,
              "y": 5.022,
              "z": 0.757
            },
            "rightCorner": {
              "x": -11.192,
              "y": 5.027,
              "z": 0.757
            },
            "gtin": "4000582244690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d59",
            "leftCorner": {
              "x": -11.194,
              "y": 5.115,
              "z": 0.757
            },
            "rightCorner": {
              "x": -10.961,
              "y": 5.12,
              "z": 0.757
            },
            "gtin": "4000582244799",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d5a",
            "leftCorner": {
              "x": -10.961,
              "y": 5.115,
              "z": 0.757
            },
            "rightCorner": {
              "x": -10.882,
              "y": 5.117,
              "z": 0.757
            },
            "gtin": "4250426226775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d5b",
            "leftCorner": {
              "x": -10.881,
              "y": 5.045,
              "z": 0.757
            },
            "rightCorner": {
              "x": -10.746,
              "y": 5.048,
              "z": 0.757
            },
            "gtin": "4250426223880",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4d8",
        "height": 1.2308,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7dc0",
            "leftCorner": {
              "x": -12.067,
              "y": 5.096,
              "z": 1.007
            },
            "rightCorner": {
              "x": -11.934,
              "y": 5.099,
              "z": 1.007
            },
            "gtin": "4000405003787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8b96e88148fb30c988d3e5a2",
            "leftCorner": {
              "x": -12.092,
              "y": 5.015,
              "z": 1.007
            },
            "rightCorner": {
              "x": -12.09,
              "y": 5.015,
              "z": 1.007
            },
            "gtin": "4000582370399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e6434ecf9a0f327b0750d754",
            "leftCorner": {
              "x": -12.09,
              "y": 5.015,
              "z": 1.007
            },
            "rightCorner": {
              "x": -12.088,
              "y": 5.015,
              "z": 1.007
            },
            "gtin": "4000582370399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5607ca6d64cdf7d939df5a00",
            "leftCorner": {
              "x": -12.088,
              "y": 5.015,
              "z": 1.007
            },
            "rightCorner": {
              "x": -12.085,
              "y": 5.015,
              "z": 1.007
            },
            "gtin": "4000582370399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3223a2177ef642db576b936e",
            "leftCorner": {
              "x": -12.085,
              "y": 5.015,
              "z": 1.007
            },
            "rightCorner": {
              "x": -12.083,
              "y": 5.015,
              "z": 1.007
            },
            "gtin": "4000582370399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8974598080b109698a080208",
            "leftCorner": {
              "x": -12.083,
              "y": 5.015,
              "z": 1.007
            },
            "rightCorner": {
              "x": -12.08,
              "y": 5.015,
              "z": 1.007
            },
            "gtin": "4000582370399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5cef804c382d213b1ec2a1ce",
            "leftCorner": {
              "x": -12.08,
              "y": 5.015,
              "z": 1.007
            },
            "rightCorner": {
              "x": -12.078,
              "y": 5.015,
              "z": 1.007
            },
            "gtin": "4000582370399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c534e5bb937e2df16d31ef76",
            "leftCorner": {
              "x": -12.078,
              "y": 5.015,
              "z": 1.007
            },
            "rightCorner": {
              "x": -12.076,
              "y": 5.015,
              "z": 1.007
            },
            "gtin": "4000582370399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b46d425c2ed8378e534553f1",
            "leftCorner": {
              "x": -12.076,
              "y": 5.015,
              "z": 1.007
            },
            "rightCorner": {
              "x": -12.073,
              "y": 5.015,
              "z": 1.007
            },
            "gtin": "4000582370399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f531a951c1bd0a77a199e65c",
            "leftCorner": {
              "x": -12.073,
              "y": 5.015,
              "z": 1.007
            },
            "rightCorner": {
              "x": -12.071,
              "y": 5.015,
              "z": 1.007
            },
            "gtin": "4000582370399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "762faf34cabda73fc1cd325c",
            "leftCorner": {
              "x": -12.071,
              "y": 5.015,
              "z": 1.007
            },
            "rightCorner": {
              "x": -12.069,
              "y": 5.015,
              "z": 1.007
            },
            "gtin": "4000582370399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dc1",
            "leftCorner": {
              "x": -11.934,
              "y": 5.101,
              "z": 1.007
            },
            "rightCorner": {
              "x": -11.837,
              "y": 5.103,
              "z": 1.007
            },
            "gtin": "4063761540051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dc2",
            "leftCorner": {
              "x": -11.837,
              "y": 5.102,
              "z": 1.007
            },
            "rightCorner": {
              "x": -11.729,
              "y": 5.104,
              "z": 1.007
            },
            "gtin": "4063761540068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dc3",
            "leftCorner": {
              "x": -11.729,
              "y": 5.104,
              "z": 1.007
            },
            "rightCorner": {
              "x": -11.611,
              "y": 5.106,
              "z": 1.007
            },
            "gtin": "4000405003145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dc4",
            "leftCorner": {
              "x": -11.61,
              "y": 5.021,
              "z": 1.007
            },
            "rightCorner": {
              "x": -11.33,
              "y": 5.026,
              "z": 1.007
            },
            "gtin": "4000405003084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dc5",
            "leftCorner": {
              "x": -11.33,
              "y": 5.025,
              "z": 1.007
            },
            "rightCorner": {
              "x": -11.135,
              "y": 5.029,
              "z": 1.007
            },
            "gtin": "4027061296551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dc6",
            "leftCorner": {
              "x": -11.135,
              "y": 5.03,
              "z": 1.007
            },
            "rightCorner": {
              "x": -10.854,
              "y": 5.035,
              "z": 1.007
            },
            "gtin": "4019467438000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dc7",
            "leftCorner": {
              "x": -10.855,
              "y": 5.117,
              "z": 1.007
            },
            "rightCorner": {
              "x": -10.73,
              "y": 5.119,
              "z": 1.007
            },
            "gtin": "4000582370399",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4d9",
        "height": 1.5319,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d19",
            "leftCorner": {
              "x": -12.013,
              "y": 5.008,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.923,
              "y": 5.009,
              "z": 1.253
            },
            "gtin": "4000405003411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c4d0463e3bab21f318ce0e5a",
            "leftCorner": {
              "x": -12.093,
              "y": 5.046,
              "z": 1.253
            },
            "rightCorner": {
              "x": -12.056,
              "y": 5.047,
              "z": 1.253
            },
            "gtin": "4000405003411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "58bf9ef29fddb0f732bcff7d",
            "leftCorner": {
              "x": -12.056,
              "y": 5.047,
              "z": 1.253
            },
            "rightCorner": {
              "x": -12.019,
              "y": 5.047,
              "z": 1.253
            },
            "gtin": "4000405003411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d1a",
            "leftCorner": {
              "x": -11.925,
              "y": 5.092,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.859,
              "y": 5.093,
              "z": 1.253
            },
            "gtin": "4000405002070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d1b",
            "leftCorner": {
              "x": -11.859,
              "y": 5.09,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.773,
              "y": 5.092,
              "z": 1.253
            },
            "gtin": "4000405002018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d1c",
            "leftCorner": {
              "x": -11.773,
              "y": 5.092,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.688,
              "y": 5.094,
              "z": 1.253
            },
            "gtin": "4000405002001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d1d",
            "leftCorner": {
              "x": -11.688,
              "y": 5.094,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.599,
              "y": 5.095,
              "z": 1.253
            },
            "gtin": "4000405002087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d1e",
            "leftCorner": {
              "x": -11.599,
              "y": 5.095,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.448,
              "y": 5.098,
              "z": 1.253
            },
            "gtin": "4000405002063",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d1f",
            "leftCorner": {
              "x": -11.448,
              "y": 5.098,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.319,
              "y": 5.1,
              "z": 1.253
            },
            "gtin": "4001956401541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d20",
            "leftCorner": {
              "x": -11.319,
              "y": 5.105,
              "z": 1.253
            },
            "rightCorner": {
              "x": -11.114,
              "y": 5.109,
              "z": 1.253
            },
            "gtin": "4000405002735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d21",
            "leftCorner": {
              "x": -11.114,
              "y": 5.108,
              "z": 1.253
            },
            "rightCorner": {
              "x": -10.974,
              "y": 5.111,
              "z": 1.253
            },
            "gtin": "4000405002742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d22",
            "leftCorner": {
              "x": -10.974,
              "y": 5.105,
              "z": 1.253
            },
            "rightCorner": {
              "x": -10.792,
              "y": 5.109,
              "z": 1.253
            },
            "gtin": "4000582309795",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4db",
        "height": 1.8304,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d8f",
            "leftCorner": {
              "x": -12.014,
              "y": 5.091,
              "z": 1.498
            },
            "rightCorner": {
              "x": -11.869,
              "y": 5.094,
              "z": 1.498
            },
            "gtin": "4019467470703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d90",
            "leftCorner": {
              "x": -11.869,
              "y": 5.096,
              "z": 1.498
            },
            "rightCorner": {
              "x": -11.694,
              "y": 5.099,
              "z": 1.498
            },
            "gtin": "4001956544019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d91",
            "leftCorner": {
              "x": -11.694,
              "y": 5.098,
              "z": 1.498
            },
            "rightCorner": {
              "x": -11.529,
              "y": 5.101,
              "z": 1.498
            },
            "gtin": "4001956548222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d92",
            "leftCorner": {
              "x": -11.529,
              "y": 5.101,
              "z": 1.498
            },
            "rightCorner": {
              "x": -11.425,
              "y": 5.103,
              "z": 1.498
            },
            "gtin": "4000930534077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d93",
            "leftCorner": {
              "x": -11.425,
              "y": 5.1,
              "z": 1.498
            },
            "rightCorner": {
              "x": -11.295,
              "y": 5.103,
              "z": 1.498
            },
            "gtin": "4000930532769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d94",
            "leftCorner": {
              "x": -11.295,
              "y": 5.106,
              "z": 1.498
            },
            "rightCorner": {
              "x": -11.172,
              "y": 5.108,
              "z": 1.498
            },
            "gtin": "4009337300353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d95",
            "leftCorner": {
              "x": -11.172,
              "y": 5.107,
              "z": 1.498
            },
            "rightCorner": {
              "x": -11.004,
              "y": 5.11,
              "z": 1.498
            },
            "gtin": "4004176100539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d96",
            "leftCorner": {
              "x": -11.004,
              "y": 5.105,
              "z": 1.498
            },
            "rightCorner": {
              "x": -10.848,
              "y": 5.108,
              "z": 1.498
            },
            "gtin": "4008128077009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d97",
            "leftCorner": {
              "x": -10.848,
              "y": 5.11,
              "z": 1.498
            },
            "rightCorner": {
              "x": -10.682,
              "y": 5.113,
              "z": 1.498
            },
            "gtin": "8410060282001",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "97b",
    "rightNeighborShelfId": "97d"
  },
  {
    "id": "97d",
    "name": "97d",
    "x": -10.842,
    "y": 4.996,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0093025,
      "w": 0.99996
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4dd",
        "height": 0.62481,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7cee",
            "leftCorner": {
              "x": -10.845,
              "y": 5.112,
              "z": 0.511
            },
            "rightCorner": {
              "x": -10.809,
              "y": 5.111,
              "z": 0.511
            },
            "gtin": "4250426223866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cef",
            "leftCorner": {
              "x": -10.807,
              "y": 5.032,
              "z": 0.511
            },
            "rightCorner": {
              "x": -10.66,
              "y": 5.034,
              "z": 0.511
            },
            "gtin": "4250426223866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cf0",
            "leftCorner": {
              "x": -10.662,
              "y": 5.122,
              "z": 0.511
            },
            "rightCorner": {
              "x": -10.521,
              "y": 5.125,
              "z": 0.511
            },
            "gtin": "4250426223941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cf1",
            "leftCorner": {
              "x": -10.521,
              "y": 5.121,
              "z": 0.511
            },
            "rightCorner": {
              "x": -10.357,
              "y": 5.124,
              "z": 0.511
            },
            "gtin": "4250426224849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cf2",
            "leftCorner": {
              "x": -10.357,
              "y": 5.119,
              "z": 0.511
            },
            "rightCorner": {
              "x": -10.128,
              "y": 5.123,
              "z": 0.511
            },
            "gtin": "4306188044239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cf3",
            "leftCorner": {
              "x": -10.128,
              "y": 5.126,
              "z": 0.511
            },
            "rightCorner": {
              "x": -9.96,
              "y": 5.129,
              "z": 0.511
            },
            "gtin": "4034167730278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cf4",
            "leftCorner": {
              "x": -9.96,
              "y": 5.133,
              "z": 0.511
            },
            "rightCorner": {
              "x": -9.8,
              "y": 5.136,
              "z": 0.511
            },
            "gtin": "4006229690219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cf5",
            "leftCorner": {
              "x": -9.8,
              "y": 5.136,
              "z": 0.511
            },
            "rightCorner": {
              "x": -9.595,
              "y": 5.14,
              "z": 0.511
            },
            "gtin": "4006229691216",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4e1",
        "height": 0.92716,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d5c",
            "leftCorner": {
              "x": -10.748,
              "y": 5.121,
              "z": 0.759
            },
            "rightCorner": {
              "x": -10.608,
              "y": 5.124,
              "z": 0.759
            },
            "gtin": "4250426223965",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d5d",
            "leftCorner": {
              "x": -10.608,
              "y": 5.124,
              "z": 0.759
            },
            "rightCorner": {
              "x": -10.489,
              "y": 5.126,
              "z": 0.759
            },
            "gtin": "4250426214765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d5e",
            "leftCorner": {
              "x": -10.489,
              "y": 5.124,
              "z": 0.759
            },
            "rightCorner": {
              "x": -10.343,
              "y": 5.127,
              "z": 0.759
            },
            "gtin": "4005097670743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d5f",
            "leftCorner": {
              "x": -10.343,
              "y": 5.126,
              "z": 0.759
            },
            "rightCorner": {
              "x": -10.161,
              "y": 5.129,
              "z": 0.759
            },
            "gtin": "4005097670736",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d60",
            "leftCorner": {
              "x": -10.161,
              "y": 5.132,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.992,
              "y": 5.135,
              "z": 0.759
            },
            "gtin": "4003171002855",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d61",
            "leftCorner": {
              "x": -9.992,
              "y": 5.137,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.851,
              "y": 5.139,
              "z": 0.759
            },
            "gtin": "4003171096175",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d62",
            "leftCorner": {
              "x": -9.851,
              "y": 5.14,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.704,
              "y": 5.143,
              "z": 0.759
            },
            "gtin": "4003171020057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d63",
            "leftCorner": {
              "x": -9.704,
              "y": 5.144,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.595,
              "y": 5.146,
              "z": 0.759
            },
            "gtin": "4003171002992",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4de",
        "height": 1.2311,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7dc8",
            "leftCorner": {
              "x": -10.731,
              "y": 5.121,
              "z": 1.007
            },
            "rightCorner": {
              "x": -10.588,
              "y": 5.124,
              "z": 1.007
            },
            "gtin": "4000582189892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e874c037eeeaa9b10d0dbbc4",
            "leftCorner": {
              "x": -10.844,
              "y": 5.081,
              "z": 1.007
            },
            "rightCorner": {
              "x": -10.73,
              "y": 5.083,
              "z": 1.007
            },
            "gtin": "4000582370399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dc9",
            "leftCorner": {
              "x": -10.588,
              "y": 5.123,
              "z": 1.007
            },
            "rightCorner": {
              "x": -10.447,
              "y": 5.126,
              "z": 1.007
            },
            "gtin": "4000582370696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dca",
            "leftCorner": {
              "x": -10.447,
              "y": 5.126,
              "z": 1.007
            },
            "rightCorner": {
              "x": -10.325,
              "y": 5.128,
              "z": 1.007
            },
            "gtin": "4000582188093",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dcb",
            "leftCorner": {
              "x": -10.325,
              "y": 5.124,
              "z": 1.007
            },
            "rightCorner": {
              "x": -10.138,
              "y": 5.128,
              "z": 1.007
            },
            "gtin": "4000582185290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dcc",
            "leftCorner": {
              "x": -10.138,
              "y": 5.143,
              "z": 1.007
            },
            "rightCorner": {
              "x": -10.02,
              "y": 5.145,
              "z": 1.007
            },
            "gtin": "4000582185399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dcd",
            "leftCorner": {
              "x": -10.02,
              "y": 5.137,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.886,
              "y": 5.14,
              "z": 1.007
            },
            "gtin": "4000582370597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dce",
            "leftCorner": {
              "x": -9.886,
              "y": 5.14,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.74,
              "y": 5.143,
              "z": 1.007
            },
            "gtin": "4250426223804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dcf",
            "leftCorner": {
              "x": -9.74,
              "y": 5.146,
              "z": 1.007
            },
            "rightCorner": {
              "x": -9.483,
              "y": 5.151,
              "z": 1.007
            },
            "gtin": "4250426223842",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4df",
        "height": 1.5329,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d23",
            "leftCorner": {
              "x": -10.793,
              "y": 5.109,
              "z": 1.254
            },
            "rightCorner": {
              "x": -10.612,
              "y": 5.113,
              "z": 1.254
            },
            "gtin": "4000582309993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d24",
            "leftCorner": {
              "x": -10.612,
              "y": 5.113,
              "z": 1.254
            },
            "rightCorner": {
              "x": -10.399,
              "y": 5.117,
              "z": 1.254
            },
            "gtin": "9002668509865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d25",
            "leftCorner": {
              "x": -10.398,
              "y": 5.114,
              "z": 1.254
            },
            "rightCorner": {
              "x": -10.148,
              "y": 5.119,
              "z": 1.254
            },
            "gtin": "9002668524516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d26",
            "leftCorner": {
              "x": -10.148,
              "y": 5.13,
              "z": 1.254
            },
            "rightCorner": {
              "x": -9.954,
              "y": 5.133,
              "z": 1.254
            },
            "gtin": "9002668513213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d27",
            "leftCorner": {
              "x": -9.954,
              "y": 5.129,
              "z": 1.254
            },
            "rightCorner": {
              "x": -9.711,
              "y": 5.133,
              "z": 1.254
            },
            "gtin": "9002668509964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d28",
            "leftCorner": {
              "x": -9.711,
              "y": 5.142,
              "z": 1.254
            },
            "rightCorner": {
              "x": -9.595,
              "y": 5.144,
              "z": 1.254
            },
            "gtin": "9002668524325",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4e0",
        "height": 1.8309,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d98",
            "leftCorner": {
              "x": -10.684,
              "y": 5.112,
              "z": 1.498
            },
            "rightCorner": {
              "x": -10.45,
              "y": 5.116,
              "z": 1.498
            },
            "gtin": "4002039171313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "396b82c0572eaed0b8270072",
            "leftCorner": {
              "x": -10.844,
              "y": 5.068,
              "z": 1.498
            },
            "rightCorner": {
              "x": -10.7,
              "y": 5.07,
              "z": 1.498
            },
            "gtin": "8410060282001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d99",
            "leftCorner": {
              "x": -10.45,
              "y": 5.118,
              "z": 1.498
            },
            "rightCorner": {
              "x": -10.293,
              "y": 5.121,
              "z": 1.498
            },
            "gtin": "4005855460302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d9a",
            "leftCorner": {
              "x": -10.293,
              "y": 5.117,
              "z": 1.498
            },
            "rightCorner": {
              "x": -10.042,
              "y": 5.121,
              "z": 1.498
            },
            "gtin": "4003436019208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d9b",
            "leftCorner": {
              "x": -10.043,
              "y": 5.129,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.918,
              "y": 5.131,
              "z": 1.498
            },
            "gtin": "4034167715633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d9c",
            "leftCorner": {
              "x": -9.916,
              "y": 5.049,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.802,
              "y": 5.051,
              "z": 1.498
            },
            "gtin": "4034167707553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d9d",
            "leftCorner": {
              "x": -9.802,
              "y": 5.055,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.671,
              "y": 5.057,
              "z": 1.498
            },
            "gtin": "4006431706135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d9e",
            "leftCorner": {
              "x": -9.672,
              "y": 5.139,
              "z": 1.498
            },
            "rightCorner": {
              "x": -9.595,
              "y": 5.141,
              "z": 1.498
            },
            "gtin": "4006431706029",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "97c",
    "rightNeighborShelfId": "97e"
  },
  {
    "id": "97e",
    "name": "97e",
    "x": -9.592,
    "y": 5.019,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0093025,
      "w": 0.99996
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 40
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d4e4",
        "height": 0.6239,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7cf6",
            "leftCorner": {
              "x": -9.594,
              "y": 5.146,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.418,
              "y": 5.15,
              "z": 0.51
            },
            "gtin": "4250426217070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cf7",
            "leftCorner": {
              "x": -9.418,
              "y": 5.148,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.263,
              "y": 5.151,
              "z": 0.51
            },
            "gtin": "4250426217070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cf8",
            "leftCorner": {
              "x": -9.263,
              "y": 5.155,
              "z": 0.51
            },
            "rightCorner": {
              "x": -9.112,
              "y": 5.157,
              "z": 0.51
            },
            "gtin": "4306188357414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cf9",
            "leftCorner": {
              "x": -9.112,
              "y": 5.16,
              "z": 0.51
            },
            "rightCorner": {
              "x": -8.877,
              "y": 5.165,
              "z": 0.51
            },
            "gtin": "4306188375661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cfa",
            "leftCorner": {
              "x": -8.877,
              "y": 5.163,
              "z": 0.51
            },
            "rightCorner": {
              "x": -8.707,
              "y": 5.166,
              "z": 0.51
            },
            "gtin": "4306188357445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cfb",
            "leftCorner": {
              "x": -8.707,
              "y": 5.158,
              "z": 0.51
            },
            "rightCorner": {
              "x": -8.552,
              "y": 5.16,
              "z": 0.51
            },
            "gtin": "4006639034900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cfc",
            "leftCorner": {
              "x": -8.552,
              "y": 5.162,
              "z": 0.51
            },
            "rightCorner": {
              "x": -8.451,
              "y": 5.164,
              "z": 0.51
            },
            "gtin": "4006639124182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cc4",
            "leftCorner": {
              "x": -8.45,
              "y": 5.156,
              "z": 0.51
            },
            "rightCorner": {
              "x": -8.344,
              "y": 5.158,
              "z": 0.51
            },
            "gtin": "4006639124083",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4e6",
        "height": 0.92751,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d64",
            "leftCorner": {
              "x": -9.595,
              "y": 5.153,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.545,
              "y": 5.154,
              "z": 0.759
            },
            "gtin": "4306188013792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d65",
            "leftCorner": {
              "x": -9.545,
              "y": 5.145,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.383,
              "y": 5.148,
              "z": 0.759
            },
            "gtin": "4306188013792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d66",
            "leftCorner": {
              "x": -9.383,
              "y": 5.151,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.207,
              "y": 5.154,
              "z": 0.759
            },
            "gtin": "4306188049340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d67",
            "leftCorner": {
              "x": -9.207,
              "y": 5.158,
              "z": 0.759
            },
            "rightCorner": {
              "x": -9.042,
              "y": 5.161,
              "z": 0.759
            },
            "gtin": "4250426230437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d68",
            "leftCorner": {
              "x": -9.042,
              "y": 5.16,
              "z": 0.759
            },
            "rightCorner": {
              "x": -8.846,
              "y": 5.164,
              "z": 0.759
            },
            "gtin": "4250426215571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d69",
            "leftCorner": {
              "x": -8.846,
              "y": 5.164,
              "z": 0.759
            },
            "rightCorner": {
              "x": -8.642,
              "y": 5.167,
              "z": 0.759
            },
            "gtin": "4250426215595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d6a",
            "leftCorner": {
              "x": -8.642,
              "y": 5.157,
              "z": 0.759
            },
            "rightCorner": {
              "x": -8.433,
              "y": 5.161,
              "z": 0.759
            },
            "gtin": "4250426203318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d6b",
            "leftCorner": {
              "x": -8.431,
              "y": 5.079,
              "z": 0.759
            },
            "rightCorner": {
              "x": -8.246,
              "y": 5.083,
              "z": 0.759
            },
            "gtin": "4250426203295",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4e2",
        "height": 1.2314,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7dd0",
            "leftCorner": {
              "x": -9.482,
              "y": 5.144,
              "z": 1.008
            },
            "rightCorner": {
              "x": -9.218,
              "y": 5.149,
              "z": 1.008
            },
            "gtin": "4250426213614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dd1",
            "leftCorner": {
              "x": -9.218,
              "y": 5.163,
              "z": 1.008
            },
            "rightCorner": {
              "x": -9.063,
              "y": 5.165,
              "z": 1.008
            },
            "gtin": "4250426227130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dd2",
            "leftCorner": {
              "x": -9.062,
              "y": 5.121,
              "z": 1.008
            },
            "rightCorner": {
              "x": -8.871,
              "y": 5.124,
              "z": 1.008
            },
            "gtin": "4250426222883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dd3",
            "leftCorner": {
              "x": -8.872,
              "y": 5.162,
              "z": 1.008
            },
            "rightCorner": {
              "x": -8.682,
              "y": 5.166,
              "z": 1.008
            },
            "gtin": "4250426230451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7dd4",
            "leftCorner": {
              "x": -8.682,
              "y": 5.168,
              "z": 1.008
            },
            "rightCorner": {
              "x": -8.513,
              "y": 5.171,
              "z": 1.008
            },
            "gtin": "4001956215872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7da8",
            "leftCorner": {
              "x": -8.513,
              "y": 5.168,
              "z": 1.008
            },
            "rightCorner": {
              "x": -8.345,
              "y": 5.171,
              "z": 1.008
            },
            "gtin": "4001956213410",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4e3",
        "height": 1.5316,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d29",
            "leftCorner": {
              "x": -9.594,
              "y": 5.149,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.558,
              "y": 5.15,
              "z": 1.253
            },
            "gtin": "4019467470109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d2a",
            "leftCorner": {
              "x": -9.558,
              "y": 5.138,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.459,
              "y": 5.14,
              "z": 1.253
            },
            "gtin": "4019467470109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d2b",
            "leftCorner": {
              "x": -9.459,
              "y": 5.141,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.365,
              "y": 5.143,
              "z": 1.253
            },
            "gtin": "8002469511112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d2c",
            "leftCorner": {
              "x": -9.365,
              "y": 5.145,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.213,
              "y": 5.148,
              "z": 1.253
            },
            "gtin": "4003171047146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d2d",
            "leftCorner": {
              "x": -9.213,
              "y": 5.151,
              "z": 1.253
            },
            "rightCorner": {
              "x": -9.01,
              "y": 5.154,
              "z": 1.253
            },
            "gtin": "4306188348924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d2e",
            "leftCorner": {
              "x": -9.01,
              "y": 5.114,
              "z": 1.253
            },
            "rightCorner": {
              "x": -8.838,
              "y": 5.117,
              "z": 1.253
            },
            "gtin": "4001956218811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d2f",
            "leftCorner": {
              "x": -8.839,
              "y": 5.157,
              "z": 1.253
            },
            "rightCorner": {
              "x": -8.64,
              "y": 5.161,
              "z": 1.253
            },
            "gtin": "4001956211317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d30",
            "leftCorner": {
              "x": -8.639,
              "y": 5.111,
              "z": 1.253
            },
            "rightCorner": {
              "x": -8.434,
              "y": 5.115,
              "z": 1.253
            },
            "gtin": "4001956211218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d31",
            "leftCorner": {
              "x": -8.435,
              "y": 5.157,
              "z": 1.253
            },
            "rightCorner": {
              "x": -8.197,
              "y": 5.161,
              "z": 1.253
            },
            "gtin": "4001956211911",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4e5",
        "height": 1.8319,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d9f",
            "leftCorner": {
              "x": -9.594,
              "y": 5.151,
              "z": 1.499
            },
            "rightCorner": {
              "x": -9.39,
              "y": 5.155,
              "z": 1.499
            },
            "gtin": "4034167702725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7da0",
            "leftCorner": {
              "x": -9.389,
              "y": 5.144,
              "z": 1.499
            },
            "rightCorner": {
              "x": -9.28,
              "y": 5.147,
              "z": 1.499
            },
            "gtin": "4034167702725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7da1",
            "leftCorner": {
              "x": -9.28,
              "y": 5.151,
              "z": 1.499
            },
            "rightCorner": {
              "x": -9.162,
              "y": 5.153,
              "z": 1.499
            },
            "gtin": "4250426218466",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7da2",
            "leftCorner": {
              "x": -9.162,
              "y": 5.151,
              "z": 1.499
            },
            "rightCorner": {
              "x": -9.008,
              "y": 5.154,
              "z": 1.499
            },
            "gtin": "4250426218442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7da3",
            "leftCorner": {
              "x": -9.008,
              "y": 5.156,
              "z": 1.499
            },
            "rightCorner": {
              "x": -8.838,
              "y": 5.159,
              "z": 1.499
            },
            "gtin": "4306188367659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7da4",
            "leftCorner": {
              "x": -8.838,
              "y": 5.154,
              "z": 1.499
            },
            "rightCorner": {
              "x": -8.677,
              "y": 5.157,
              "z": 1.499
            },
            "gtin": "4306188367628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7da5",
            "leftCorner": {
              "x": -8.676,
              "y": 5.113,
              "z": 1.499
            },
            "rightCorner": {
              "x": -8.506,
              "y": 5.116,
              "z": 1.499
            },
            "gtin": "4006229701212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7da6",
            "leftCorner": {
              "x": -8.507,
              "y": 5.157,
              "z": 1.499
            },
            "rightCorner": {
              "x": -8.386,
              "y": 5.16,
              "z": 1.499
            },
            "gtin": "4006229016941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d76",
            "leftCorner": {
              "x": -8.386,
              "y": 5.159,
              "z": 1.499
            },
            "rightCorner": {
              "x": -8.344,
              "y": 5.16,
              "z": 1.499
            },
            "gtin": "4008460243056",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "97d",
    "rightNeighborShelfId": "97f"
  },
  {
    "id": "97f",
    "name": "97f",
    "x": -8.343,
    "y": 5.043,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0093025,
      "w": 0.99996
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 75
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7eb",
        "height": 0.37799,
        "facings": [
          {
            "id": "664580b4f9bb326b313503dd",
            "leftCorner": {
              "x": -8.343,
              "y": 5.066,
              "z": 0.309
            },
            "rightCorner": {
              "x": -8.297,
              "y": 5.067,
              "z": 0.309
            },
            "gtin": "4045357010841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cc6648d671f2936fbcd06d6d",
            "leftCorner": {
              "x": -8.297,
              "y": 5.067,
              "z": 0.309
            },
            "rightCorner": {
              "x": -8.246,
              "y": 5.068,
              "z": 0.309
            },
            "gtin": "4002468180825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "034dc748c98be95f90694924",
            "leftCorner": {
              "x": -8.246,
              "y": 5.068,
              "z": 0.309
            },
            "rightCorner": {
              "x": -8.181,
              "y": 5.069,
              "z": 0.309
            },
            "gtin": "4019300005208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6c68e6fab45d7f2dbb7c138d",
            "leftCorner": {
              "x": -8.181,
              "y": 5.069,
              "z": 0.309
            },
            "rightCorner": {
              "x": -8.098,
              "y": 5.071,
              "z": 0.309
            },
            "gtin": "4045357099136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0f7a8bbdd3b74089dd279049",
            "leftCorner": {
              "x": -8.098,
              "y": 5.071,
              "z": 0.309
            },
            "rightCorner": {
              "x": -8.013,
              "y": 5.072,
              "z": 0.309
            },
            "gtin": "3073781190366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "337fecfe4dcb1e755b02a874",
            "leftCorner": {
              "x": -8.013,
              "y": 5.072,
              "z": 0.309
            },
            "rightCorner": {
              "x": -7.926,
              "y": 5.074,
              "z": 0.309
            },
            "gtin": "4045357001986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8dda2572262adfd23d2c6879",
            "leftCorner": {
              "x": -7.926,
              "y": 5.074,
              "z": 0.309
            },
            "rightCorner": {
              "x": -7.837,
              "y": 5.076,
              "z": 0.309
            },
            "gtin": "4019300172351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9ade1136e467b9a4d1a3a2db",
            "leftCorner": {
              "x": -7.837,
              "y": 5.076,
              "z": 0.309
            },
            "rightCorner": {
              "x": -7.749,
              "y": 5.077,
              "z": 0.309
            },
            "gtin": "4000400008732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0de504d6741a5e306260b214",
            "leftCorner": {
              "x": -7.749,
              "y": 5.077,
              "z": 0.309
            },
            "rightCorner": {
              "x": -7.659,
              "y": 5.079,
              "z": 0.309
            },
            "gtin": "40193090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9f7cf32075b0a0972cd6c903",
            "leftCorner": {
              "x": -7.659,
              "y": 5.079,
              "z": 0.309
            },
            "rightCorner": {
              "x": -7.57,
              "y": 5.081,
              "z": 0.309
            },
            "gtin": "3073781109382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "16411afd509c7c13191eb9dd",
            "leftCorner": {
              "x": -7.57,
              "y": 5.081,
              "z": 0.309
            },
            "rightCorner": {
              "x": -7.478,
              "y": 5.082,
              "z": 0.309
            },
            "gtin": "3073781109375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "efa2943dcb68d9f54f24995f",
            "leftCorner": {
              "x": -7.478,
              "y": 5.082,
              "z": 0.309
            },
            "rightCorner": {
              "x": -7.384,
              "y": 5.084,
              "z": 0.309
            },
            "gtin": "4019300158034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1e531c50c9b2b89dc89f7faa",
            "leftCorner": {
              "x": -7.384,
              "y": 5.084,
              "z": 0.309
            },
            "rightCorner": {
              "x": -7.142,
              "y": 5.089,
              "z": 0.309
            },
            "gtin": "4045357012173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5de1d5febeb513d781e52a32",
            "leftCorner": {
              "x": -7.142,
              "y": 5.089,
              "z": 0.309
            },
            "rightCorner": {
              "x": -7.095,
              "y": 5.089,
              "z": 0.309
            },
            "gtin": "4045357010841",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7e9",
        "height": 0.7237,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c2a",
            "leftCorner": {
              "x": -8.345,
              "y": 5.136,
              "z": 0.592
            },
            "rightCorner": {
              "x": -8.086,
              "y": 5.141,
              "z": 0.592
            },
            "gtin": "4045357007391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c2c",
            "leftCorner": {
              "x": -8.087,
              "y": 5.179,
              "z": 0.592
            },
            "rightCorner": {
              "x": -7.956,
              "y": 5.181,
              "z": 0.592
            },
            "gtin": "9009301005951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c2d",
            "leftCorner": {
              "x": -7.956,
              "y": 5.182,
              "z": 0.592
            },
            "rightCorner": {
              "x": -7.828,
              "y": 5.185,
              "z": 0.592
            },
            "gtin": "4019300173815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c2e",
            "leftCorner": {
              "x": -7.828,
              "y": 5.185,
              "z": 0.592
            },
            "rightCorner": {
              "x": -7.735,
              "y": 5.187,
              "z": 0.592
            },
            "gtin": "4019300162130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c2f",
            "leftCorner": {
              "x": -7.735,
              "y": 5.189,
              "z": 0.592
            },
            "rightCorner": {
              "x": -7.588,
              "y": 5.192,
              "z": 0.592
            },
            "gtin": "4019300005154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c30",
            "leftCorner": {
              "x": -7.588,
              "y": 5.192,
              "z": 0.592
            },
            "rightCorner": {
              "x": -7.458,
              "y": 5.195,
              "z": 0.592
            },
            "gtin": "4019300157716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c31",
            "leftCorner": {
              "x": -7.457,
              "y": 5.119,
              "z": 0.592
            },
            "rightCorner": {
              "x": -7.301,
              "y": 5.122,
              "z": 0.592
            },
            "gtin": "4019300005307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c32",
            "leftCorner": {
              "x": -7.303,
              "y": 5.194,
              "z": 0.592
            },
            "rightCorner": {
              "x": -7.157,
              "y": 5.196,
              "z": 0.592
            },
            "gtin": "4019300005260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c2b",
            "leftCorner": {
              "x": -7.157,
              "y": 5.194,
              "z": 0.592
            },
            "rightCorner": {
              "x": -7.096,
              "y": 5.195,
              "z": 0.592
            },
            "gtin": "4019300005208",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7e7",
        "height": 0.92532,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d6c",
            "leftCorner": {
              "x": -8.246,
              "y": 5.089,
              "z": 0.757
            },
            "rightCorner": {
              "x": -8.171,
              "y": 5.09,
              "z": 0.757
            },
            "gtin": "4045357011978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d6d",
            "leftCorner": {
              "x": -8.172,
              "y": 5.175,
              "z": 0.757
            },
            "rightCorner": {
              "x": -8.066,
              "y": 5.177,
              "z": 0.757
            },
            "gtin": "4045357011916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d6e",
            "leftCorner": {
              "x": -8.065,
              "y": 5.137,
              "z": 0.757
            },
            "rightCorner": {
              "x": -7.973,
              "y": 5.138,
              "z": 0.757
            },
            "gtin": "4045357011947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d6f",
            "leftCorner": {
              "x": -7.974,
              "y": 5.181,
              "z": 0.757
            },
            "rightCorner": {
              "x": -7.843,
              "y": 5.183,
              "z": 0.757
            },
            "gtin": "4045357012005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d70",
            "leftCorner": {
              "x": -7.843,
              "y": 5.185,
              "z": 0.757
            },
            "rightCorner": {
              "x": -7.729,
              "y": 5.187,
              "z": 0.757
            },
            "gtin": "4019300005161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d71",
            "leftCorner": {
              "x": -7.729,
              "y": 5.191,
              "z": 0.757
            },
            "rightCorner": {
              "x": -7.589,
              "y": 5.194,
              "z": 0.757
            },
            "gtin": "4019300090006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d72",
            "leftCorner": {
              "x": -7.589,
              "y": 5.191,
              "z": 0.757
            },
            "rightCorner": {
              "x": -7.427,
              "y": 5.194,
              "z": 0.757
            },
            "gtin": "4019300164486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d73",
            "leftCorner": {
              "x": -7.427,
              "y": 5.19,
              "z": 0.757
            },
            "rightCorner": {
              "x": -7.291,
              "y": 5.192,
              "z": 0.757
            },
            "gtin": "40193182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d74",
            "leftCorner": {
              "x": -7.291,
              "y": 5.193,
              "z": 0.757
            },
            "rightCorner": {
              "x": -7.158,
              "y": 5.196,
              "z": 0.757
            },
            "gtin": "40193168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d3b",
            "leftCorner": {
              "x": -7.158,
              "y": 5.193,
              "z": 0.757
            },
            "rightCorner": {
              "x": -7.096,
              "y": 5.194,
              "z": 0.757
            },
            "gtin": "40193151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c21a9d344162406957e6c789",
            "leftCorner": {
              "x": -8.345,
              "y": 5.135,
              "z": 0.757
            },
            "rightCorner": {
              "x": -8.285,
              "y": 5.136,
              "z": 0.757
            },
            "gtin": "40193151",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7e6",
        "height": 1.1291,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c16",
            "leftCorner": {
              "x": -8.345,
              "y": 5.137,
              "z": 0.924
            },
            "rightCorner": {
              "x": -8.168,
              "y": 5.14,
              "z": 0.924
            },
            "gtin": "3073781160741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c17",
            "leftCorner": {
              "x": -8.168,
              "y": 5.175,
              "z": 0.924
            },
            "rightCorner": {
              "x": -8.079,
              "y": 5.177,
              "z": 0.924
            },
            "gtin": "3073781056358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c18",
            "leftCorner": {
              "x": -8.079,
              "y": 5.178,
              "z": 0.924
            },
            "rightCorner": {
              "x": -7.998,
              "y": 5.18,
              "z": 0.924
            },
            "gtin": "3073781109382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c19",
            "leftCorner": {
              "x": -7.998,
              "y": 5.179,
              "z": 0.924
            },
            "rightCorner": {
              "x": -7.905,
              "y": 5.181,
              "z": 0.924
            },
            "gtin": "3073781109375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c1a",
            "leftCorner": {
              "x": -7.905,
              "y": 5.183,
              "z": 0.924
            },
            "rightCorner": {
              "x": -7.804,
              "y": 5.185,
              "z": 0.924
            },
            "gtin": "3073781190458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c1b",
            "leftCorner": {
              "x": -7.804,
              "y": 5.189,
              "z": 0.924
            },
            "rightCorner": {
              "x": -7.728,
              "y": 5.19,
              "z": 0.924
            },
            "gtin": "3073781190366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c1c",
            "leftCorner": {
              "x": -7.728,
              "y": 5.195,
              "z": 0.924
            },
            "rightCorner": {
              "x": -7.616,
              "y": 5.197,
              "z": 0.924
            },
            "gtin": "4003751002848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c1d",
            "leftCorner": {
              "x": -7.616,
              "y": 5.191,
              "z": 0.924
            },
            "rightCorner": {
              "x": -7.528,
              "y": 5.193,
              "z": 0.924
            },
            "gtin": "4019300172351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c1e",
            "leftCorner": {
              "x": -7.528,
              "y": 5.192,
              "z": 0.924
            },
            "rightCorner": {
              "x": -7.428,
              "y": 5.194,
              "z": 0.924
            },
            "gtin": "4019300158034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c1f",
            "leftCorner": {
              "x": -7.428,
              "y": 5.19,
              "z": 0.924
            },
            "rightCorner": {
              "x": -7.314,
              "y": 5.192,
              "z": 0.924
            },
            "gtin": "40193083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c20",
            "leftCorner": {
              "x": -7.314,
              "y": 5.195,
              "z": 0.924
            },
            "rightCorner": {
              "x": -7.208,
              "y": 5.197,
              "z": 0.924
            },
            "gtin": "40193052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c21",
            "leftCorner": {
              "x": -7.208,
              "y": 5.197,
              "z": 0.924
            },
            "rightCorner": {
              "x": -7.122,
              "y": 5.199,
              "z": 0.924
            },
            "gtin": "40193090",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7e4",
        "height": 1.3318,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c0b",
            "leftCorner": {
              "x": -8.345,
              "y": 5.125,
              "z": 1.09
            },
            "rightCorner": {
              "x": -8.199,
              "y": 5.128,
              "z": 1.09
            },
            "gtin": "41002728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c0d",
            "leftCorner": {
              "x": -8.2,
              "y": 5.168,
              "z": 1.09
            },
            "rightCorner": {
              "x": -8.093,
              "y": 5.17,
              "z": 1.09
            },
            "gtin": "3480347121007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c0e",
            "leftCorner": {
              "x": -8.093,
              "y": 5.167,
              "z": 1.09
            },
            "rightCorner": {
              "x": -8.0,
              "y": 5.168,
              "z": 1.09
            },
            "gtin": "4002970002141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c0f",
            "leftCorner": {
              "x": -8.0,
              "y": 5.17,
              "z": 1.09
            },
            "rightCorner": {
              "x": -7.915,
              "y": 5.171,
              "z": 1.09
            },
            "gtin": "4045357001986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c10",
            "leftCorner": {
              "x": -7.915,
              "y": 5.17,
              "z": 1.09
            },
            "rightCorner": {
              "x": -7.831,
              "y": 5.172,
              "z": 1.09
            },
            "gtin": "4000400008732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c11",
            "leftCorner": {
              "x": -7.831,
              "y": 5.172,
              "z": 1.09
            },
            "rightCorner": {
              "x": -7.641,
              "y": 5.175,
              "z": 1.09
            },
            "gtin": "4045357099136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c12",
            "leftCorner": {
              "x": -7.641,
              "y": 5.178,
              "z": 1.09
            },
            "rightCorner": {
              "x": -7.523,
              "y": 5.18,
              "z": 1.09
            },
            "gtin": "4000400008053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c13",
            "leftCorner": {
              "x": -7.523,
              "y": 5.191,
              "z": 1.09
            },
            "rightCorner": {
              "x": -7.438,
              "y": 5.192,
              "z": 1.09
            },
            "gtin": "4000400008633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c14",
            "leftCorner": {
              "x": -7.438,
              "y": 5.183,
              "z": 1.09
            },
            "rightCorner": {
              "x": -7.297,
              "y": 5.185,
              "z": 1.09
            },
            "gtin": "4045357000934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c15",
            "leftCorner": {
              "x": -7.297,
              "y": 5.192,
              "z": 1.09
            },
            "rightCorner": {
              "x": -7.141,
              "y": 5.194,
              "z": 1.09
            },
            "gtin": "4002468084000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c0c",
            "leftCorner": {
              "x": -7.14,
              "y": 5.185,
              "z": 1.09
            },
            "rightCorner": {
              "x": -7.095,
              "y": 5.186,
              "z": 1.09
            },
            "gtin": "4002468084017",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7e5",
        "height": 1.5323,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7d32",
            "leftCorner": {
              "x": -8.198,
              "y": 5.165,
              "z": 1.254
            },
            "rightCorner": {
              "x": -8.074,
              "y": 5.168,
              "z": 1.254
            },
            "gtin": "3272770092326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d33",
            "leftCorner": {
              "x": -8.074,
              "y": 5.173,
              "z": 1.254
            },
            "rightCorner": {
              "x": -7.96,
              "y": 5.175,
              "z": 1.254
            },
            "gtin": "4306188037262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d34",
            "leftCorner": {
              "x": -7.96,
              "y": 5.175,
              "z": 1.254
            },
            "rightCorner": {
              "x": -7.818,
              "y": 5.178,
              "z": 1.254
            },
            "gtin": "4306188037231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d35",
            "leftCorner": {
              "x": -7.818,
              "y": 5.181,
              "z": 1.254
            },
            "rightCorner": {
              "x": -7.716,
              "y": 5.183,
              "z": 1.254
            },
            "gtin": "4062800005124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d36",
            "leftCorner": {
              "x": -7.716,
              "y": 5.188,
              "z": 1.254
            },
            "rightCorner": {
              "x": -7.602,
              "y": 5.19,
              "z": 1.254
            },
            "gtin": "4104420182127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d37",
            "leftCorner": {
              "x": -7.602,
              "y": 5.192,
              "z": 1.254
            },
            "rightCorner": {
              "x": -7.4,
              "y": 5.196,
              "z": 1.254
            },
            "gtin": "4104420182080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d38",
            "leftCorner": {
              "x": -7.4,
              "y": 5.187,
              "z": 1.254
            },
            "rightCorner": {
              "x": -7.284,
              "y": 5.189,
              "z": 1.254
            },
            "gtin": "5760466771337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7d39",
            "leftCorner": {
              "x": -7.284,
              "y": 5.187,
              "z": 1.254
            },
            "rightCorner": {
              "x": -7.147,
              "y": 5.19,
              "z": 1.254
            },
            "gtin": "5760466872102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7cfe",
            "leftCorner": {
              "x": -7.147,
              "y": 5.187,
              "z": 1.254
            },
            "rightCorner": {
              "x": -7.095,
              "y": 5.188,
              "z": 1.254
            },
            "gtin": "4002468180825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68739941f21486cbd1b0e221",
            "leftCorner": {
              "x": -8.345,
              "y": 5.13,
              "z": 1.254
            },
            "rightCorner": {
              "x": -8.202,
              "y": 5.132,
              "z": 1.254
            },
            "gtin": "4306188037231",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7e8",
        "height": 1.7304,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c22",
            "leftCorner": {
              "x": -8.345,
              "y": 5.132,
              "z": 1.416
            },
            "rightCorner": {
              "x": -8.095,
              "y": 5.137,
              "z": 1.416
            },
            "gtin": "4045357012173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c24",
            "leftCorner": {
              "x": -8.096,
              "y": 5.174,
              "z": 1.416
            },
            "rightCorner": {
              "x": -7.945,
              "y": 5.177,
              "z": 1.416
            },
            "gtin": "4045357012203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c25",
            "leftCorner": {
              "x": -7.945,
              "y": 5.179,
              "z": 1.416
            },
            "rightCorner": {
              "x": -7.797,
              "y": 5.182,
              "z": 1.416
            },
            "gtin": "4045357010636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c26",
            "leftCorner": {
              "x": -7.797,
              "y": 5.184,
              "z": 1.416
            },
            "rightCorner": {
              "x": -7.638,
              "y": 5.187,
              "z": 1.416
            },
            "gtin": "4045357010605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c27",
            "leftCorner": {
              "x": -7.638,
              "y": 5.187,
              "z": 1.416
            },
            "rightCorner": {
              "x": -7.478,
              "y": 5.19,
              "z": 1.416
            },
            "gtin": "4045357010605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c28",
            "leftCorner": {
              "x": -7.478,
              "y": 5.188,
              "z": 1.416
            },
            "rightCorner": {
              "x": -7.343,
              "y": 5.191,
              "z": 1.416
            },
            "gtin": "4045357010698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c29",
            "leftCorner": {
              "x": -7.343,
              "y": 5.191,
              "z": 1.416
            },
            "rightCorner": {
              "x": -7.142,
              "y": 5.194,
              "z": 1.416
            },
            "gtin": "4045357010759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c23",
            "leftCorner": {
              "x": -7.141,
              "y": 5.188,
              "z": 1.416
            },
            "rightCorner": {
              "x": -7.095,
              "y": 5.189,
              "z": 1.416
            },
            "gtin": "4045357010841",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "97e"
  },
  {
    "id": "a02",
    "name": "a02",
    "x": -31.002,
    "y": -29.51,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 7.6093E-4,
      "y": 4.4735E-5,
      "z": -0.99994,
      "w": 0.010639
    },
    "layers": []
  },
  {
    "id": "a03",
    "name": "a03",
    "x": -32.005,
    "y": -29.53,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -7.6152E-4,
      "y": 5.2527E-6,
      "z": 0.99997,
      "w": -0.0081519
    },
    "layers": []
  },
  {
    "id": "a04",
    "name": "a04",
    "x": -30.006,
    "y": -29.479,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -7.5914E-4,
      "y": -7.5064E-5,
      "z": 0.99976,
      "w": -0.022012
    },
    "layers": []
  },
  {
    "id": "a05",
    "name": "a05",
    "x": -28.994,
    "y": -29.418,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -7.5724E-4,
      "y": 9.5497E-5,
      "z": 0.99986,
      "w": -0.016962
    },
    "layers": []
  },
  {
    "id": "a06",
    "name": "a06",
    "x": -29.969,
    "y": -31.396,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 7.1444E-5,
      "y": -7.6125E-4,
      "z": 0.013551,
      "w": 0.99991
    },
    "layers": []
  },
  {
    "id": "a07",
    "name": "a07",
    "x": -30.952,
    "y": -31.44,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 4.5669E-7,
      "y": -7.9478E-4,
      "z": 0.011655,
      "w": 0.99993
    },
    "layers": []
  },
  {
    "id": "a08",
    "name": "a08",
    "x": -31.984,
    "y": -31.472,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 1.3573E-4,
      "y": -7.4697E-4,
      "z": 0.0090142,
      "w": 0.99996
    },
    "layers": []
  },
  {
    "id": "a09",
    "name": "a09",
    "x": -33.015,
    "y": -31.479,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 2.6247E-5,
      "y": -7.5971E-4,
      "z": 4.6798E-4,
      "w": 1.0
    },
    "layers": []
  },
  {
    "id": "a0a",
    "name": "a0a",
    "x": -28.164,
    "y": -31.273,
    "width": 0.3125,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -4.2067E-4,
      "y": -5.1156E-4,
      "z": 0.71357,
      "w": 0.70059
    },
    "layers": []
  },
  {
    "id": "a0c",
    "name": "a0c",
    "x": -32.956,
    "y": -27.673,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 3.7479E-4,
      "y": -6.5099E-4,
      "z": 0.0046181,
      "w": 0.99999
    },
    "layers": []
  },
  {
    "id": "a11",
    "name": "a11",
    "x": -31.938,
    "y": -27.639,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 2.1687E-4,
      "y": -6.1724E-4,
      "z": 0.0091939,
      "w": 0.99996
    },
    "layers": []
  },
  {
    "id": "a12",
    "name": "a12",
    "x": -30.947,
    "y": -27.581,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 1.9568E-4,
      "y": -6.1729E-4,
      "z": 0.0020166,
      "w": 1.0
    },
    "layers": []
  },
  {
    "id": "a13",
    "name": "a13",
    "x": -29.947,
    "y": -27.577,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 1.9568E-4,
      "y": -6.1729E-4,
      "z": 0.0020165,
      "w": 1.0
    },
    "layers": []
  },
  {
    "id": "a14",
    "name": "a14",
    "x": -28.987,
    "y": -25.71,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.1837E-4,
      "y": -1.2101E-4,
      "z": 1.0,
      "w": -0.0012462
    },
    "layers": []
  },
  {
    "id": "a15",
    "name": "a15",
    "x": -29.986,
    "y": -25.752,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.2647E-4,
      "y": -5.2059E-5,
      "z": 0.99978,
      "w": -0.020965
    },
    "layers": []
  },
  {
    "id": "a17",
    "name": "a17",
    "x": -30.984,
    "y": -25.848,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.2005E-4,
      "y": -8.9112E-5,
      "z": 0.99999,
      "w": -0.0052865
    },
    "layers": []
  },
  {
    "id": "a18",
    "name": "a18",
    "x": -31.984,
    "y": -25.858,
    "width": 0.5,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.2005E-4,
      "y": -8.9112E-5,
      "z": 0.99999,
      "w": -0.0052865
    },
    "layers": []
  },
  {
    "id": "a1d",
    "name": "a1d",
    "x": -28.175,
    "y": -30.648,
    "width": 0.3125,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -4.2067E-4,
      "y": -5.1156E-4,
      "z": 0.71357,
      "w": 0.70059
    },
    "layers": []
  },
  {
    "id": "a1e",
    "name": "a1e",
    "x": -28.187,
    "y": -30.023,
    "width": 0.3125,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -4.2067E-4,
      "y": -5.1156E-4,
      "z": 0.71357,
      "w": 0.70059
    },
    "layers": []
  },
  {
    "id": "a1f",
    "name": "a1f",
    "x": -28.252,
    "y": -27.555,
    "width": 0.3125,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.3657E-4,
      "y": -1.7814E-4,
      "z": 0.70929,
      "w": 0.70492
    },
    "layers": []
  },
  {
    "id": "a20",
    "name": "a20",
    "x": -28.256,
    "y": -26.93,
    "width": 0.3125,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.3657E-4,
      "y": -1.7814E-4,
      "z": 0.70929,
      "w": 0.70492
    },
    "layers": []
  },
  {
    "id": "a21",
    "name": "a21",
    "x": -28.259,
    "y": -26.305,
    "width": 0.3125,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": -6.3657E-4,
      "y": -1.7814E-4,
      "z": 0.70929,
      "w": 0.70492
    },
    "layers": []
  },
  {
    "id": "a6a",
    "name": "a6a",
    "x": -31.219,
    "y": -8.211,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0070773,
      "w": 0.99997
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 43,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3e7",
        "height": 0.15406,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d73e3",
            "leftCorner": {
              "x": -31.158,
              "y": -8.277,
              "z": 0.126
            },
            "rightCorner": {
              "x": -30.91,
              "y": -8.273,
              "z": 0.126
            },
            "gtin": "4306188040040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73e4",
            "leftCorner": {
              "x": -30.91,
              "y": -8.273,
              "z": 0.126
            },
            "rightCorner": {
              "x": -30.661,
              "y": -8.27,
              "z": 0.126
            },
            "gtin": "4306188040040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73e5",
            "leftCorner": {
              "x": -30.661,
              "y": -8.27,
              "z": 0.126
            },
            "rightCorner": {
              "x": -30.413,
              "y": -8.266,
              "z": 0.126
            },
            "gtin": "4306188040040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73d6",
            "leftCorner": {
              "x": -30.413,
              "y": -8.26,
              "z": 0.126
            },
            "rightCorner": {
              "x": -30.339,
              "y": -8.259,
              "z": 0.126
            },
            "gtin": "4306188428374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73d7",
            "leftCorner": {
              "x": -30.339,
              "y": -8.259,
              "z": 0.126
            },
            "rightCorner": {
              "x": -30.264,
              "y": -8.258,
              "z": 0.126
            },
            "gtin": "4306188428374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73d8",
            "leftCorner": {
              "x": -30.264,
              "y": -8.258,
              "z": 0.126
            },
            "rightCorner": {
              "x": -30.19,
              "y": -8.256,
              "z": 0.126
            },
            "gtin": "4306188428374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73d9",
            "leftCorner": {
              "x": -30.19,
              "y": -8.256,
              "z": 0.126
            },
            "rightCorner": {
              "x": -30.116,
              "y": -8.255,
              "z": 0.126
            },
            "gtin": "4306188428374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73da",
            "leftCorner": {
              "x": -30.116,
              "y": -8.255,
              "z": 0.126
            },
            "rightCorner": {
              "x": -30.042,
              "y": -8.254,
              "z": 0.126
            },
            "gtin": "4306188428374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73db",
            "leftCorner": {
              "x": -30.042,
              "y": -8.254,
              "z": 0.126
            },
            "rightCorner": {
              "x": -29.967,
              "y": -8.253,
              "z": 0.126
            },
            "gtin": "4306188428374",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3e6",
        "height": 0.53744,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7371",
            "leftCorner": {
              "x": -31.158,
              "y": -8.298,
              "z": 0.44
            },
            "rightCorner": {
              "x": -30.871,
              "y": -8.294,
              "z": 0.44
            },
            "gtin": "9006900014025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7372",
            "leftCorner": {
              "x": -30.871,
              "y": -8.29,
              "z": 0.44
            },
            "rightCorner": {
              "x": -30.593,
              "y": -8.286,
              "z": 0.44
            },
            "gtin": "9006900014292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7373",
            "leftCorner": {
              "x": -30.593,
              "y": -8.279,
              "z": 0.44
            },
            "rightCorner": {
              "x": -30.452,
              "y": -8.277,
              "z": 0.44
            },
            "gtin": "4105550045603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7374",
            "leftCorner": {
              "x": -30.452,
              "y": -8.277,
              "z": 0.44
            },
            "rightCorner": {
              "x": -30.311,
              "y": -8.275,
              "z": 0.44
            },
            "gtin": "4105550045603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7375",
            "leftCorner": {
              "x": -30.311,
              "y": -8.275,
              "z": 0.44
            },
            "rightCorner": {
              "x": -30.17,
              "y": -8.273,
              "z": 0.44
            },
            "gtin": "4105550045603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d735e",
            "leftCorner": {
              "x": -30.17,
              "y": -8.292,
              "z": 0.44
            },
            "rightCorner": {
              "x": -29.967,
              "y": -8.289,
              "z": 0.44
            },
            "gtin": "4001497531004",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3e5",
        "height": 0.9007,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d73ca",
            "leftCorner": {
              "x": -31.179,
              "y": -8.291,
              "z": 0.737
            },
            "rightCorner": {
              "x": -31.041,
              "y": -8.289,
              "z": 0.737
            },
            "gtin": "9006900017538",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73cb",
            "leftCorner": {
              "x": -31.041,
              "y": -8.283,
              "z": 0.737
            },
            "rightCorner": {
              "x": -30.924,
              "y": -8.282,
              "z": 0.737
            },
            "gtin": "9006900207007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73cc",
            "leftCorner": {
              "x": -30.924,
              "y": -8.279,
              "z": 0.737
            },
            "rightCorner": {
              "x": -30.801,
              "y": -8.277,
              "z": 0.737
            },
            "gtin": "9006900227173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73cd",
            "leftCorner": {
              "x": -30.801,
              "y": -8.277,
              "z": 0.737
            },
            "rightCorner": {
              "x": -30.677,
              "y": -8.275,
              "z": 0.737
            },
            "gtin": "9006900227173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73ce",
            "leftCorner": {
              "x": -30.677,
              "y": -8.274,
              "z": 0.737
            },
            "rightCorner": {
              "x": -30.582,
              "y": -8.272,
              "z": 0.737
            },
            "gtin": "4100060035298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73cf",
            "leftCorner": {
              "x": -30.582,
              "y": -8.271,
              "z": 0.737
            },
            "rightCorner": {
              "x": -30.521,
              "y": -8.27,
              "z": 0.737
            },
            "gtin": "4100060035311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73d0",
            "leftCorner": {
              "x": -30.521,
              "y": -8.27,
              "z": 0.737
            },
            "rightCorner": {
              "x": -30.46,
              "y": -8.269,
              "z": 0.737
            },
            "gtin": "4100060035311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73d1",
            "leftCorner": {
              "x": -30.46,
              "y": -8.269,
              "z": 0.737
            },
            "rightCorner": {
              "x": -30.398,
              "y": -8.269,
              "z": 0.737
            },
            "gtin": "4100060035311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73d2",
            "leftCorner": {
              "x": -30.398,
              "y": -8.269,
              "z": 0.737
            },
            "rightCorner": {
              "x": -30.337,
              "y": -8.268,
              "z": 0.737
            },
            "gtin": "4100060035311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73d3",
            "leftCorner": {
              "x": -30.337,
              "y": -8.268,
              "z": 0.737
            },
            "rightCorner": {
              "x": -30.276,
              "y": -8.267,
              "z": 0.737
            },
            "gtin": "4100060035311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73d4",
            "leftCorner": {
              "x": -30.276,
              "y": -8.27,
              "z": 0.737
            },
            "rightCorner": {
              "x": -30.093,
              "y": -8.268,
              "z": 0.737
            },
            "gtin": "4100060035335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73b3",
            "leftCorner": {
              "x": -30.093,
              "y": -8.278,
              "z": 0.737
            },
            "rightCorner": {
              "x": -29.967,
              "y": -8.277,
              "z": 0.737
            },
            "gtin": "4100060035274",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3e3",
        "height": 1.2536,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7390",
            "leftCorner": {
              "x": -31.157,
              "y": -8.289,
              "z": 1.026
            },
            "rightCorner": {
              "x": -31.015,
              "y": -8.287,
              "z": 1.026
            },
            "gtin": "9006900205690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7391",
            "leftCorner": {
              "x": -31.015,
              "y": -8.282,
              "z": 1.026
            },
            "rightCorner": {
              "x": -30.861,
              "y": -8.28,
              "z": 1.026
            },
            "gtin": "9006900218751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7392",
            "leftCorner": {
              "x": -30.861,
              "y": -8.28,
              "z": 1.026
            },
            "rightCorner": {
              "x": -30.706,
              "y": -8.278,
              "z": 1.026
            },
            "gtin": "9006900218751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7393",
            "leftCorner": {
              "x": -30.706,
              "y": -8.275,
              "z": 1.026
            },
            "rightCorner": {
              "x": -30.556,
              "y": -8.273,
              "z": 1.026
            },
            "gtin": "4100060018512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7394",
            "leftCorner": {
              "x": -30.556,
              "y": -8.27,
              "z": 1.026
            },
            "rightCorner": {
              "x": -30.406,
              "y": -8.267,
              "z": 1.026
            },
            "gtin": "4100060035397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7395",
            "leftCorner": {
              "x": -30.406,
              "y": -8.267,
              "z": 1.026
            },
            "rightCorner": {
              "x": -30.255,
              "y": -8.265,
              "z": 1.026
            },
            "gtin": "4100060035397",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d737b",
            "leftCorner": {
              "x": -30.255,
              "y": -8.272,
              "z": 1.026
            },
            "rightCorner": {
              "x": -29.967,
              "y": -8.268,
              "z": 1.026
            },
            "gtin": "4100060035199",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3e4",
        "height": 1.7294,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d73a8",
            "leftCorner": {
              "x": -31.134,
              "y": -8.287,
              "z": 1.415
            },
            "rightCorner": {
              "x": -31.001,
              "y": -8.285,
              "z": 1.415
            },
            "gtin": "90169298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "caf5b4e1301342917cf45a1c",
            "leftCorner": {
              "x": -31.217,
              "y": -8.322,
              "z": 1.415
            },
            "rightCorner": {
              "x": -31.134,
              "y": -8.321,
              "z": 1.415
            },
            "gtin": "4009491088616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9c871a4269d164d36cdfbb6d",
            "leftCorner": {
              "x": -30.152,
              "y": -8.307,
              "z": 1.415
            },
            "rightCorner": {
              "x": -29.973,
              "y": -8.304,
              "z": 1.415
            },
            "gtin": "4105550301600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73a9",
            "leftCorner": {
              "x": -31.001,
              "y": -8.283,
              "z": 1.415
            },
            "rightCorner": {
              "x": -30.861,
              "y": -8.281,
              "z": 1.415
            },
            "gtin": "90169250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73aa",
            "leftCorner": {
              "x": -30.861,
              "y": -8.277,
              "z": 1.415
            },
            "rightCorner": {
              "x": -30.738,
              "y": -8.275,
              "z": 1.415
            },
            "gtin": "4104420072121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73ab",
            "leftCorner": {
              "x": -30.738,
              "y": -8.274,
              "z": 1.415
            },
            "rightCorner": {
              "x": -30.653,
              "y": -8.273,
              "z": 1.415
            },
            "gtin": "4009491088616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73ac",
            "leftCorner": {
              "x": -30.653,
              "y": -8.273,
              "z": 1.415
            },
            "rightCorner": {
              "x": -30.569,
              "y": -8.272,
              "z": 1.415
            },
            "gtin": "4009491088616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73ad",
            "leftCorner": {
              "x": -30.569,
              "y": -8.272,
              "z": 1.415
            },
            "rightCorner": {
              "x": -30.412,
              "y": -8.27,
              "z": 1.415
            },
            "gtin": "5410188802047",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d73ae",
            "leftCorner": {
              "x": -30.412,
              "y": -8.27,
              "z": 1.415
            },
            "rightCorner": {
              "x": -30.24,
              "y": -8.268,
              "z": 1.415
            },
            "gtin": "4105550301600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73af",
            "leftCorner": {
              "x": -30.24,
              "y": -8.272,
              "z": 1.415
            },
            "rightCorner": {
              "x": -30.152,
              "y": -8.271,
              "z": 1.415
            },
            "gtin": "4250239120338",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c4b"
  },
  {
    "id": "a6b",
    "name": "a6b",
    "x": -29.963,
    "y": -6.598,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": 0.0012217
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 29,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d43c",
        "height": 0.15175,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77d3",
            "leftCorner": {
              "x": -29.963,
              "y": -6.528,
              "z": 0.124
            },
            "rightCorner": {
              "x": -30.246,
              "y": -6.527,
              "z": 0.124
            },
            "gtin": "9006900014858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77d5",
            "leftCorner": {
              "x": -30.247,
              "y": -6.569,
              "z": 0.124
            },
            "rightCorner": {
              "x": -30.568,
              "y": -6.568,
              "z": 0.124
            },
            "gtin": "9006900212131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77d6",
            "leftCorner": {
              "x": -30.568,
              "y": -6.566,
              "z": 0.124
            },
            "rightCorner": {
              "x": -30.705,
              "y": -6.566,
              "z": 0.124
            },
            "gtin": "9006900226589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77d7",
            "leftCorner": {
              "x": -30.705,
              "y": -6.566,
              "z": 0.124
            },
            "rightCorner": {
              "x": -30.841,
              "y": -6.565,
              "z": 0.124
            },
            "gtin": "9006900226589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77d8",
            "leftCorner": {
              "x": -30.841,
              "y": -6.561,
              "z": 0.124
            },
            "rightCorner": {
              "x": -31.05,
              "y": -6.561,
              "z": 0.124
            },
            "gtin": "9006900207182",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77d9",
            "leftCorner": {
              "x": -31.05,
              "y": -6.561,
              "z": 0.124
            },
            "rightCorner": {
              "x": -31.259,
              "y": -6.56,
              "z": 0.124
            },
            "gtin": "9006900207182",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d43b",
        "height": 0.50356,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77cc",
            "leftCorner": {
              "x": -29.963,
              "y": -6.523,
              "z": 0.412
            },
            "rightCorner": {
              "x": -30.12,
              "y": -6.522,
              "z": 0.412
            },
            "gtin": "9006900011529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77cd",
            "leftCorner": {
              "x": -30.12,
              "y": -6.522,
              "z": 0.412
            },
            "rightCorner": {
              "x": -30.277,
              "y": -6.522,
              "z": 0.412
            },
            "gtin": "9006900011529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77cf",
            "leftCorner": {
              "x": -30.277,
              "y": -6.562,
              "z": 0.412
            },
            "rightCorner": {
              "x": -30.408,
              "y": -6.562,
              "z": 0.412
            },
            "gtin": "9006900011512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77d0",
            "leftCorner": {
              "x": -30.408,
              "y": -6.562,
              "z": 0.412
            },
            "rightCorner": {
              "x": -30.539,
              "y": -6.562,
              "z": 0.412
            },
            "gtin": "9006900011512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77d1",
            "leftCorner": {
              "x": -30.539,
              "y": -6.561,
              "z": 0.412
            },
            "rightCorner": {
              "x": -30.709,
              "y": -6.561,
              "z": 0.412
            },
            "gtin": "9006900014803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77d2",
            "leftCorner": {
              "x": -30.709,
              "y": -6.561,
              "z": 0.412
            },
            "rightCorner": {
              "x": -30.879,
              "y": -6.56,
              "z": 0.412
            },
            "gtin": "9006900014803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77ce",
            "leftCorner": {
              "x": -30.88,
              "y": -6.559,
              "z": 0.412
            },
            "rightCorner": {
              "x": -31.213,
              "y": -6.558,
              "z": 0.412
            },
            "gtin": "9006900014810",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d43d",
        "height": 0.87561,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77df",
            "leftCorner": {
              "x": -29.963,
              "y": -6.53,
              "z": 0.716
            },
            "rightCorner": {
              "x": -30.899,
              "y": -6.528,
              "z": 0.716
            },
            "gtin": "5000112641851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77e2",
            "leftCorner": {
              "x": -30.9,
              "y": -6.566,
              "z": 0.716
            },
            "rightCorner": {
              "x": -31.028,
              "y": -6.566,
              "z": 0.716
            },
            "gtin": "5449000294784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77e3",
            "leftCorner": {
              "x": -31.028,
              "y": -6.566,
              "z": 0.716
            },
            "rightCorner": {
              "x": -31.156,
              "y": -6.566,
              "z": 0.716
            },
            "gtin": "5449000294784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77e4",
            "leftCorner": {
              "x": -31.156,
              "y": -6.566,
              "z": 0.716
            },
            "rightCorner": {
              "x": -31.284,
              "y": -6.565,
              "z": 0.716
            },
            "gtin": "5449000294784",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d43a",
        "height": 1.2836,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77bd",
            "leftCorner": {
              "x": -29.963,
              "y": -6.529,
              "z": 1.05
            },
            "rightCorner": {
              "x": -30.179,
              "y": -6.529,
              "z": 1.05
            },
            "gtin": "5000112641868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77be",
            "leftCorner": {
              "x": -30.179,
              "y": -6.529,
              "z": 1.05
            },
            "rightCorner": {
              "x": -30.395,
              "y": -6.528,
              "z": 1.05
            },
            "gtin": "5000112641868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77bf",
            "leftCorner": {
              "x": -30.395,
              "y": -6.528,
              "z": 1.05
            },
            "rightCorner": {
              "x": -30.612,
              "y": -6.527,
              "z": 1.05
            },
            "gtin": "5000112641868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77c1",
            "leftCorner": {
              "x": -30.612,
              "y": -6.576,
              "z": 1.05
            },
            "rightCorner": {
              "x": -30.939,
              "y": -6.575,
              "z": 1.05
            },
            "gtin": "5000112666533",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d77c2",
            "leftCorner": {
              "x": -30.939,
              "y": -6.568,
              "z": 1.05
            },
            "rightCorner": {
              "x": -31.107,
              "y": -6.568,
              "z": 1.05
            },
            "gtin": "5000112567946",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d77c3",
            "leftCorner": {
              "x": -31.106,
              "y": -6.555,
              "z": 1.05
            },
            "rightCorner": {
              "x": -31.213,
              "y": -6.554,
              "z": 1.05
            },
            "gtin": "4062139009954",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d439",
        "height": 1.7341,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77a5",
            "leftCorner": {
              "x": -29.963,
              "y": -6.537,
              "z": 1.419
            },
            "rightCorner": {
              "x": -30.236,
              "y": -6.536,
              "z": 1.419
            },
            "gtin": "9006900227524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77a7",
            "leftCorner": {
              "x": -30.237,
              "y": -6.576,
              "z": 1.419
            },
            "rightCorner": {
              "x": -30.349,
              "y": -6.576,
              "z": 1.419
            },
            "gtin": "9006900227531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77a8",
            "leftCorner": {
              "x": -30.349,
              "y": -6.576,
              "z": 1.419
            },
            "rightCorner": {
              "x": -30.46,
              "y": -6.576,
              "z": 1.419
            },
            "gtin": "9006900227531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77a9",
            "leftCorner": {
              "x": -30.46,
              "y": -6.576,
              "z": 1.419
            },
            "rightCorner": {
              "x": -30.572,
              "y": -6.575,
              "z": 1.419
            },
            "gtin": "9006900227531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77aa",
            "leftCorner": {
              "x": -30.572,
              "y": -6.579,
              "z": 1.419
            },
            "rightCorner": {
              "x": -30.707,
              "y": -6.578,
              "z": 1.419
            },
            "gtin": "9006900227548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77ab",
            "leftCorner": {
              "x": -30.707,
              "y": -6.579,
              "z": 1.419
            },
            "rightCorner": {
              "x": -30.895,
              "y": -6.579,
              "z": 1.419
            },
            "gtin": "3057640518058",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77ac",
            "leftCorner": {
              "x": -30.895,
              "y": -6.575,
              "z": 1.419
            },
            "rightCorner": {
              "x": -31.026,
              "y": -6.574,
              "z": 1.419
            },
            "gtin": "3057640461033",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d77ad",
            "leftCorner": {
              "x": -31.026,
              "y": -6.567,
              "z": 1.419
            },
            "rightCorner": {
              "x": -31.134,
              "y": -6.567,
              "z": 1.419
            },
            "gtin": "5000112667417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77ae",
            "leftCorner": {
              "x": -31.134,
              "y": -6.567,
              "z": 1.419
            },
            "rightCorner": {
              "x": -31.241,
              "y": -6.566,
              "z": 1.419
            },
            "gtin": "5000112667417",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "a6c"
  },
  {
    "id": "a6c",
    "name": "a6c",
    "x": -31.213,
    "y": -6.595,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": 0.0012217
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 40,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d442",
        "height": 0.15636,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77da",
            "leftCorner": {
              "x": -31.259,
              "y": -6.558,
              "z": 0.128
            },
            "rightCorner": {
              "x": -31.361,
              "y": -6.558,
              "z": 0.128
            },
            "gtin": "4048517780127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77db",
            "leftCorner": {
              "x": -31.361,
              "y": -6.561,
              "z": 0.128
            },
            "rightCorner": {
              "x": -31.474,
              "y": -6.56,
              "z": 0.128
            },
            "gtin": "4048517779961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77dc",
            "leftCorner": {
              "x": -31.474,
              "y": -6.564,
              "z": 0.128
            },
            "rightCorner": {
              "x": -31.836,
              "y": -6.563,
              "z": 0.128
            },
            "gtin": "9008700201018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77dd",
            "leftCorner": {
              "x": -31.836,
              "y": -6.559,
              "z": 0.128
            },
            "rightCorner": {
              "x": -31.972,
              "y": -6.559,
              "z": 0.128
            },
            "gtin": "4306188050803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77de",
            "leftCorner": {
              "x": -31.972,
              "y": -6.559,
              "z": 0.128
            },
            "rightCorner": {
              "x": -32.108,
              "y": -6.559,
              "z": 0.128
            },
            "gtin": "4306188050803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77d4",
            "leftCorner": {
              "x": -32.108,
              "y": -6.558,
              "z": 0.128
            },
            "rightCorner": {
              "x": -32.463,
              "y": -6.557,
              "z": 0.128
            },
            "gtin": "4306188050827",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d440",
        "height": 0.49338,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77e8",
            "leftCorner": {
              "x": -31.213,
              "y": -6.514,
              "z": 0.404
            },
            "rightCorner": {
              "x": -31.313,
              "y": -6.514,
              "z": 0.404
            },
            "gtin": "9008700204279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77e9",
            "leftCorner": {
              "x": -31.313,
              "y": -6.514,
              "z": 0.404
            },
            "rightCorner": {
              "x": -31.414,
              "y": -6.514,
              "z": 0.404
            },
            "gtin": "9008700204279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77ea",
            "leftCorner": {
              "x": -31.414,
              "y": -6.514,
              "z": 0.404
            },
            "rightCorner": {
              "x": -31.514,
              "y": -6.514,
              "z": 0.404
            },
            "gtin": "9008700204279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77ef",
            "leftCorner": {
              "x": -31.514,
              "y": -6.557,
              "z": 0.404
            },
            "rightCorner": {
              "x": -31.759,
              "y": -6.556,
              "z": 0.404
            },
            "gtin": "9008700204316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77f0",
            "leftCorner": {
              "x": -31.759,
              "y": -6.553,
              "z": 0.404
            },
            "rightCorner": {
              "x": -31.818,
              "y": -6.553,
              "z": 0.404
            },
            "gtin": "9008700204255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77f1",
            "leftCorner": {
              "x": -31.818,
              "y": -6.553,
              "z": 0.404
            },
            "rightCorner": {
              "x": -31.877,
              "y": -6.553,
              "z": 0.404
            },
            "gtin": "9008700204255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77f2",
            "leftCorner": {
              "x": -31.877,
              "y": -6.553,
              "z": 0.404
            },
            "rightCorner": {
              "x": -31.936,
              "y": -6.553,
              "z": 0.404
            },
            "gtin": "9008700204255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77f3",
            "leftCorner": {
              "x": -31.936,
              "y": -6.552,
              "z": 0.404
            },
            "rightCorner": {
              "x": -32.077,
              "y": -6.552,
              "z": 0.404
            },
            "gtin": "9008700238380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77f4",
            "leftCorner": {
              "x": -32.077,
              "y": -6.552,
              "z": 0.404
            },
            "rightCorner": {
              "x": -32.218,
              "y": -6.552,
              "z": 0.404
            },
            "gtin": "9008700238380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77eb",
            "leftCorner": {
              "x": -32.218,
              "y": -6.55,
              "z": 0.404
            },
            "rightCorner": {
              "x": -32.279,
              "y": -6.55,
              "z": 0.404
            },
            "gtin": "9008700204293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77ec",
            "leftCorner": {
              "x": -32.279,
              "y": -6.55,
              "z": 0.404
            },
            "rightCorner": {
              "x": -32.341,
              "y": -6.549,
              "z": 0.404
            },
            "gtin": "9008700204293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77ed",
            "leftCorner": {
              "x": -32.341,
              "y": -6.549,
              "z": 0.404
            },
            "rightCorner": {
              "x": -32.402,
              "y": -6.549,
              "z": 0.404
            },
            "gtin": "9008700204293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77ee",
            "leftCorner": {
              "x": -32.402,
              "y": -6.549,
              "z": 0.404
            },
            "rightCorner": {
              "x": -32.463,
              "y": -6.549,
              "z": 0.404
            },
            "gtin": "9008700204293",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d43f",
        "height": 0.88369,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77e5",
            "leftCorner": {
              "x": -31.284,
              "y": -6.558,
              "z": 0.723
            },
            "rightCorner": {
              "x": -31.554,
              "y": -6.557,
              "z": 0.723
            },
            "gtin": "3057640376498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77e6",
            "leftCorner": {
              "x": -31.554,
              "y": -6.557,
              "z": 0.723
            },
            "rightCorner": {
              "x": -31.823,
              "y": -6.557,
              "z": 0.723
            },
            "gtin": "3057640376498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77e7",
            "leftCorner": {
              "x": -31.823,
              "y": -6.559,
              "z": 0.723
            },
            "rightCorner": {
              "x": -32.147,
              "y": -6.558,
              "z": 0.723
            },
            "gtin": "4005720000862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77e0",
            "leftCorner": {
              "x": -32.147,
              "y": -6.555,
              "z": 0.723
            },
            "rightCorner": {
              "x": -32.305,
              "y": -6.554,
              "z": 0.723
            },
            "gtin": "9008700207942",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77e1",
            "leftCorner": {
              "x": -32.305,
              "y": -6.554,
              "z": 0.723
            },
            "rightCorner": {
              "x": -32.463,
              "y": -6.554,
              "z": 0.723
            },
            "gtin": "9008700207942",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d441",
        "height": 1.2873,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77c4",
            "leftCorner": {
              "x": -31.213,
              "y": -6.55,
              "z": 1.053
            },
            "rightCorner": {
              "x": -31.381,
              "y": -6.552,
              "z": 1.053
            },
            "gtin": "4062139009916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77c5",
            "leftCorner": {
              "x": -31.381,
              "y": -6.564,
              "z": 1.053
            },
            "rightCorner": {
              "x": -31.505,
              "y": -6.564,
              "z": 1.053
            },
            "gtin": "4062139009916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77c6",
            "leftCorner": {
              "x": -31.505,
              "y": -6.564,
              "z": 1.053
            },
            "rightCorner": {
              "x": -31.63,
              "y": -6.563,
              "z": 1.053
            },
            "gtin": "4062139009916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77c7",
            "leftCorner": {
              "x": -31.63,
              "y": -6.567,
              "z": 1.053
            },
            "rightCorner": {
              "x": -31.802,
              "y": -6.567,
              "z": 1.053
            },
            "gtin": "4062139009930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77c8",
            "leftCorner": {
              "x": -31.802,
              "y": -6.567,
              "z": 1.053
            },
            "rightCorner": {
              "x": -31.973,
              "y": -6.567,
              "z": 1.053
            },
            "gtin": "4062139009930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77c9",
            "leftCorner": {
              "x": -31.973,
              "y": -6.557,
              "z": 1.053
            },
            "rightCorner": {
              "x": -32.202,
              "y": -6.557,
              "z": 1.053
            },
            "gtin": "4062139009978",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77ca",
            "leftCorner": {
              "x": -32.202,
              "y": -6.559,
              "z": 1.053
            },
            "rightCorner": {
              "x": -32.293,
              "y": -6.559,
              "z": 1.053
            },
            "gtin": "9008700193634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77cb",
            "leftCorner": {
              "x": -32.293,
              "y": -6.556,
              "z": 1.053
            },
            "rightCorner": {
              "x": -32.387,
              "y": -6.556,
              "z": 1.053
            },
            "gtin": "90167744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77c0",
            "leftCorner": {
              "x": -32.387,
              "y": -6.553,
              "z": 1.053
            },
            "rightCorner": {
              "x": -32.463,
              "y": -6.553,
              "z": 1.053
            },
            "gtin": "90167591",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d43e",
        "height": 1.7374,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77af",
            "leftCorner": {
              "x": -31.24,
              "y": -6.559,
              "z": 1.422
            },
            "rightCorner": {
              "x": -31.334,
              "y": -6.559,
              "z": 1.422
            },
            "gtin": "42116455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77b0",
            "leftCorner": {
              "x": -31.334,
              "y": -6.559,
              "z": 1.422
            },
            "rightCorner": {
              "x": -31.428,
              "y": -6.559,
              "z": 1.422
            },
            "gtin": "42116455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77b1",
            "leftCorner": {
              "x": -31.428,
              "y": -6.565,
              "z": 1.422
            },
            "rightCorner": {
              "x": -31.539,
              "y": -6.565,
              "z": 1.422
            },
            "gtin": "4062139025015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77b2",
            "leftCorner": {
              "x": -31.539,
              "y": -6.565,
              "z": 1.422
            },
            "rightCorner": {
              "x": -31.651,
              "y": -6.565,
              "z": 1.422
            },
            "gtin": "4062139025015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77b3",
            "leftCorner": {
              "x": -31.651,
              "y": -6.568,
              "z": 1.422
            },
            "rightCorner": {
              "x": -31.878,
              "y": -6.567,
              "z": 1.422
            },
            "gtin": "4062139025077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77b4",
            "leftCorner": {
              "x": -31.878,
              "y": -6.561,
              "z": 1.422
            },
            "rightCorner": {
              "x": -32.131,
              "y": -6.56,
              "z": 1.422
            },
            "gtin": "4062139025039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77b5",
            "leftCorner": {
              "x": -32.131,
              "y": -6.554,
              "z": 1.422
            },
            "rightCorner": {
              "x": -32.371,
              "y": -6.554,
              "z": 1.422
            },
            "gtin": "9008700200523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77b6",
            "leftCorner": {
              "x": -32.371,
              "y": -6.552,
              "z": 1.422
            },
            "rightCorner": {
              "x": -32.605,
              "y": -6.552,
              "z": 1.422
            },
            "gtin": "9008700230162",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6b",
    "rightNeighborShelfId": "a6d"
  },
  {
    "id": "a6d",
    "name": "a6d",
    "x": -32.463,
    "y": -6.592,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": 0.0012217
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 8,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d443",
        "height": 1.7368,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77b7",
            "leftCorner": {
              "x": -32.605,
              "y": -6.536,
              "z": 1.421
            },
            "rightCorner": {
              "x": -32.715,
              "y": -6.536,
              "z": 1.421
            },
            "gtin": "9008700207966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ce922955c5347b86b7f88942",
            "leftCorner": {
              "x": -32.463,
              "y": -6.502,
              "z": 1.421
            },
            "rightCorner": {
              "x": -32.604,
              "y": -6.501,
              "z": 1.421
            },
            "gtin": "4100060007400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6abcb457646b6912ff9ddef7",
            "leftCorner": {
              "x": -33.567,
              "y": -6.499,
              "z": 1.421
            },
            "rightCorner": {
              "x": -33.71,
              "y": -6.499,
              "z": 1.421
            },
            "gtin": "4306188404613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77b8",
            "leftCorner": {
              "x": -32.715,
              "y": -6.54,
              "z": 1.421
            },
            "rightCorner": {
              "x": -32.868,
              "y": -6.54,
              "z": 1.421
            },
            "gtin": "4306188404613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77b9",
            "leftCorner": {
              "x": -32.868,
              "y": -6.535,
              "z": 1.421
            },
            "rightCorner": {
              "x": -33.129,
              "y": -6.534,
              "z": 1.421
            },
            "gtin": "9008700200585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77ba",
            "leftCorner": {
              "x": -33.129,
              "y": -6.54,
              "z": 1.421
            },
            "rightCorner": {
              "x": -33.283,
              "y": -6.539,
              "z": 1.421
            },
            "gtin": "9008700238748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77bb",
            "leftCorner": {
              "x": -33.283,
              "y": -6.543,
              "z": 1.421
            },
            "rightCorner": {
              "x": -33.422,
              "y": -6.542,
              "z": 1.421
            },
            "gtin": "4100060007400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77bc",
            "leftCorner": {
              "x": -33.422,
              "y": -6.548,
              "z": 1.421
            },
            "rightCorner": {
              "x": -33.567,
              "y": -6.548,
              "z": 1.421
            },
            "gtin": "4306188404644",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "a6c"
  },
  {
    "id": "a6e",
    "name": "a6e",
    "x": -29.415,
    "y": -8.063,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70427,
      "w": 0.70993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 26,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d435",
        "height": 0.20827,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7792",
            "leftCorner": {
              "x": -29.443,
              "y": -8.063,
              "z": 0.17
            },
            "rightCorner": {
              "x": -29.439,
              "y": -7.517,
              "z": 0.17
            },
            "gtin": "4048517742040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7794",
            "leftCorner": {
              "x": -29.34,
              "y": -7.518,
              "z": 0.17
            },
            "rightCorner": {
              "x": -29.337,
              "y": -7.118,
              "z": 0.17
            },
            "gtin": "4048517742125",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d7795",
            "leftCorner": {
              "x": -29.481,
              "y": -7.117,
              "z": 0.17
            },
            "rightCorner": {
              "x": -29.479,
              "y": -6.974,
              "z": 0.17
            },
            "gtin": "4048517751851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7793",
            "leftCorner": {
              "x": -29.469,
              "y": -6.964,
              "z": 0.17
            },
            "rightCorner": {
              "x": -29.468,
              "y": -6.813,
              "z": 0.17
            },
            "gtin": "4048517741807",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d434",
        "height": 0.99275,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7789",
            "leftCorner": {
              "x": -29.347,
              "y": -8.064,
              "z": 0.812
            },
            "rightCorner": {
              "x": -29.347,
              "y": -7.99,
              "z": 0.812
            },
            "gtin": "4260705333612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d778a",
            "leftCorner": {
              "x": -29.347,
              "y": -7.99,
              "z": 0.812
            },
            "rightCorner": {
              "x": -29.347,
              "y": -7.916,
              "z": 0.812
            },
            "gtin": "4260705333612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d778d",
            "leftCorner": {
              "x": -29.384,
              "y": -7.916,
              "z": 0.812
            },
            "rightCorner": {
              "x": -29.383,
              "y": -7.772,
              "z": 0.812
            },
            "gtin": "4260705333599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d778e",
            "leftCorner": {
              "x": -29.385,
              "y": -7.772,
              "z": 0.812
            },
            "rightCorner": {
              "x": -29.383,
              "y": -7.523,
              "z": 0.812
            },
            "gtin": "4260705333582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d778f",
            "leftCorner": {
              "x": -29.379,
              "y": -7.524,
              "z": 0.812
            },
            "rightCorner": {
              "x": -29.378,
              "y": -7.377,
              "z": 0.812
            },
            "gtin": "5000112604467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7790",
            "leftCorner": {
              "x": -29.378,
              "y": -7.377,
              "z": 0.812
            },
            "rightCorner": {
              "x": -29.377,
              "y": -7.231,
              "z": 0.812
            },
            "gtin": "5000112604467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7791",
            "leftCorner": {
              "x": -29.383,
              "y": -7.231,
              "z": 0.812
            },
            "rightCorner": {
              "x": -29.382,
              "y": -7.094,
              "z": 0.812
            },
            "gtin": "5000112684667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d778b",
            "leftCorner": {
              "x": -29.38,
              "y": -7.094,
              "z": 0.812
            },
            "rightCorner": {
              "x": -29.378,
              "y": -6.953,
              "z": 0.812
            },
            "gtin": "5449000294760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d778c",
            "leftCorner": {
              "x": -29.378,
              "y": -6.953,
              "z": 0.812
            },
            "rightCorner": {
              "x": -29.377,
              "y": -6.813,
              "z": 0.812
            },
            "gtin": "5449000294760",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d437",
        "height": 1.3204,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d779e",
            "leftCorner": {
              "x": -29.347,
              "y": -8.064,
              "z": 1.08
            },
            "rightCorner": {
              "x": -29.346,
              "y": -7.885,
              "z": 1.08
            },
            "gtin": "9008700204279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d779f",
            "leftCorner": {
              "x": -29.346,
              "y": -7.885,
              "z": 1.08
            },
            "rightCorner": {
              "x": -29.344,
              "y": -7.707,
              "z": 1.08
            },
            "gtin": "9008700204279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77a1",
            "leftCorner": {
              "x": -29.381,
              "y": -7.707,
              "z": 1.08
            },
            "rightCorner": {
              "x": -29.379,
              "y": -7.536,
              "z": 1.08
            },
            "gtin": "9008700204255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77a2",
            "leftCorner": {
              "x": -29.379,
              "y": -7.536,
              "z": 1.08
            },
            "rightCorner": {
              "x": -29.378,
              "y": -7.364,
              "z": 1.08
            },
            "gtin": "9008700204255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77a3",
            "leftCorner": {
              "x": -29.378,
              "y": -7.364,
              "z": 1.08
            },
            "rightCorner": {
              "x": -29.377,
              "y": -7.193,
              "z": 1.08
            },
            "gtin": "9008700204255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77a4",
            "leftCorner": {
              "x": -29.383,
              "y": -7.193,
              "z": 1.08
            },
            "rightCorner": {
              "x": -29.381,
              "y": -6.978,
              "z": 1.08
            },
            "gtin": "4005906007227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77a0",
            "leftCorner": {
              "x": -29.544,
              "y": -6.976,
              "z": 1.08
            },
            "rightCorner": {
              "x": -29.543,
              "y": -6.812,
              "z": 1.08
            },
            "gtin": "4005906007210",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d436",
        "height": 1.6937,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7796",
            "leftCorner": {
              "x": -29.342,
              "y": -8.064,
              "z": 1.386
            },
            "rightCorner": {
              "x": -29.341,
              "y": -8.006,
              "z": 1.386
            },
            "gtin": "2000439121718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7798",
            "leftCorner": {
              "x": -29.377,
              "y": -8.006,
              "z": 1.386
            },
            "rightCorner": {
              "x": -29.376,
              "y": -7.941,
              "z": 1.386
            },
            "gtin": "9311493004507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7799",
            "leftCorner": {
              "x": -29.377,
              "y": -7.941,
              "z": 1.386
            },
            "rightCorner": {
              "x": -29.377,
              "y": -7.845,
              "z": 1.386
            },
            "gtin": "9311493004491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d779a",
            "leftCorner": {
              "x": -29.377,
              "y": -7.845,
              "z": 1.386
            },
            "rightCorner": {
              "x": -29.376,
              "y": -7.749,
              "z": 1.386
            },
            "gtin": "9311493004491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d779b",
            "leftCorner": {
              "x": -29.376,
              "y": -7.749,
              "z": 1.386
            },
            "rightCorner": {
              "x": -29.374,
              "y": -7.653,
              "z": 1.386
            },
            "gtin": "9311493004491",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d779c",
            "leftCorner": {
              "x": -29.377,
              "y": -7.653,
              "z": 1.386
            },
            "rightCorner": {
              "x": -29.376,
              "y": -7.507,
              "z": 1.386
            },
            "gtin": "9311493004514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d779d",
            "leftCorner": {
              "x": -29.378,
              "y": -7.507,
              "z": 1.386
            },
            "rightCorner": {
              "x": -29.377,
              "y": -7.253,
              "z": 1.386
            },
            "gtin": "9008700228039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7797",
            "leftCorner": {
              "x": -29.38,
              "y": -7.253,
              "z": 1.386
            },
            "rightCorner": {
              "x": -29.377,
              "y": -6.813,
              "z": 1.386
            },
            "gtin": "4100060007417",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "a6f",
    "name": "a6f",
    "x": -34.446,
    "y": -6.844,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70276,
      "w": 0.71143
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 42,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7bc",
        "height": 0.5368,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b47",
            "leftCorner": {
              "x": -34.264,
              "y": -6.842,
              "z": 0.439
            },
            "rightCorner": {
              "x": -34.261,
              "y": -7.096,
              "z": 0.439
            },
            "gtin": "4250426223309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "36490143335986a39fa6bce4",
            "leftCorner": {
              "x": -34.261,
              "y": -7.096,
              "z": 0.439
            },
            "rightCorner": {
              "x": -34.26,
              "y": -7.195,
              "z": 0.439
            },
            "gtin": "4260384490026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b49",
            "leftCorner": {
              "x": -34.226,
              "y": -7.202,
              "z": 0.439
            },
            "rightCorner": {
              "x": -34.225,
              "y": -7.266,
              "z": 0.439
            },
            "gtin": "4014472280095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b4a",
            "leftCorner": {
              "x": -34.22,
              "y": -7.266,
              "z": 0.439
            },
            "rightCorner": {
              "x": -34.219,
              "y": -7.347,
              "z": 0.439
            },
            "gtin": "4250426223286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b4b",
            "leftCorner": {
              "x": -34.219,
              "y": -7.347,
              "z": 0.439
            },
            "rightCorner": {
              "x": -34.219,
              "y": -7.386,
              "z": 0.439
            },
            "gtin": "4014472002512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b4c",
            "leftCorner": {
              "x": -34.221,
              "y": -7.386,
              "z": 0.439
            },
            "rightCorner": {
              "x": -34.22,
              "y": -7.437,
              "z": 0.439
            },
            "gtin": "4250426223262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b4d",
            "leftCorner": {
              "x": -34.216,
              "y": -7.437,
              "z": 0.439
            },
            "rightCorner": {
              "x": -34.214,
              "y": -7.612,
              "z": 0.439
            },
            "gtin": "4260384490026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b4e",
            "leftCorner": {
              "x": -34.211,
              "y": -7.612,
              "z": 0.439
            },
            "rightCorner": {
              "x": -34.21,
              "y": -7.651,
              "z": 0.439
            },
            "gtin": "4260384490033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b4f",
            "leftCorner": {
              "x": -34.21,
              "y": -7.651,
              "z": 0.439
            },
            "rightCorner": {
              "x": -34.208,
              "y": -7.787,
              "z": 0.439
            },
            "gtin": "4260384490033",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50fe1820c81800d8b50",
            "leftCorner": {
              "x": -34.204,
              "y": -7.787,
              "z": 0.439
            },
            "rightCorner": {
              "x": -34.203,
              "y": -7.876,
              "z": 0.439
            },
            "gtin": "4260384490064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b51",
            "leftCorner": {
              "x": -34.202,
              "y": -7.876,
              "z": 0.439
            },
            "rightCorner": {
              "x": -34.201,
              "y": -8.001,
              "z": 0.439
            },
            "gtin": "4260107220015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b52",
            "leftCorner": {
              "x": -34.2,
              "y": -8.001,
              "z": 0.439
            },
            "rightCorner": {
              "x": -34.199,
              "y": -8.085,
              "z": 0.439
            },
            "gtin": "4260384490088",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7bd",
        "height": 0.83065,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b53",
            "leftCorner": {
              "x": -34.266,
              "y": -6.842,
              "z": 0.68
            },
            "rightCorner": {
              "x": -34.264,
              "y": -7.015,
              "z": 0.68
            },
            "gtin": "5060108450263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b54",
            "leftCorner": {
              "x": -34.264,
              "y": -7.015,
              "z": 0.68
            },
            "rightCorner": {
              "x": -34.261,
              "y": -7.188,
              "z": 0.68
            },
            "gtin": "5060108450263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b55",
            "leftCorner": {
              "x": -34.225,
              "y": -7.188,
              "z": 0.68
            },
            "rightCorner": {
              "x": -34.224,
              "y": -7.258,
              "z": 0.68
            },
            "gtin": "5060108455329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b56",
            "leftCorner": {
              "x": -34.224,
              "y": -7.258,
              "z": 0.68
            },
            "rightCorner": {
              "x": -34.224,
              "y": -7.328,
              "z": 0.68
            },
            "gtin": "5060108455329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b57",
            "leftCorner": {
              "x": -34.223,
              "y": -7.328,
              "z": 0.68
            },
            "rightCorner": {
              "x": -34.22,
              "y": -7.481,
              "z": 0.68
            },
            "gtin": "5060108450546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b58",
            "leftCorner": {
              "x": -34.214,
              "y": -7.481,
              "z": 0.68
            },
            "rightCorner": {
              "x": -34.212,
              "y": -7.667,
              "z": 0.68
            },
            "gtin": "9311493003531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b59",
            "leftCorner": {
              "x": -34.214,
              "y": -7.667,
              "z": 0.68
            },
            "rightCorner": {
              "x": -34.211,
              "y": -7.828,
              "z": 0.68
            },
            "gtin": "9311493003692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b5a",
            "leftCorner": {
              "x": -34.205,
              "y": -7.828,
              "z": 0.68
            },
            "rightCorner": {
              "x": -34.204,
              "y": -8.013,
              "z": 0.68
            },
            "gtin": "9311493002985",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50fe1820c81800d8b5b",
            "leftCorner": {
              "x": -34.2,
              "y": -8.013,
              "z": 0.68
            },
            "rightCorner": {
              "x": -34.199,
              "y": -8.087,
              "z": 0.68
            },
            "gtin": "4002846034757",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7ba",
        "height": 1.1342,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b36",
            "leftCorner": {
              "x": -34.267,
              "y": -6.842,
              "z": 0.928
            },
            "rightCorner": {
              "x": -34.265,
              "y": -7.024,
              "z": 0.928
            },
            "gtin": "4002846034894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b37",
            "leftCorner": {
              "x": -34.265,
              "y": -7.024,
              "z": 0.928
            },
            "rightCorner": {
              "x": -34.262,
              "y": -7.207,
              "z": 0.928
            },
            "gtin": "4002846034894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b38",
            "leftCorner": {
              "x": -34.224,
              "y": -7.206,
              "z": 0.928
            },
            "rightCorner": {
              "x": -34.222,
              "y": -7.383,
              "z": 0.928
            },
            "gtin": "4002846034887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b39",
            "leftCorner": {
              "x": -34.221,
              "y": -7.383,
              "z": 0.928
            },
            "rightCorner": {
              "x": -34.219,
              "y": -7.48,
              "z": 0.928
            },
            "gtin": "4002846034962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b3a",
            "leftCorner": {
              "x": -34.219,
              "y": -7.48,
              "z": 0.928
            },
            "rightCorner": {
              "x": -34.218,
              "y": -7.577,
              "z": 0.928
            },
            "gtin": "4002846034962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b3b",
            "leftCorner": {
              "x": -34.218,
              "y": -7.577,
              "z": 0.928
            },
            "rightCorner": {
              "x": -34.217,
              "y": -7.719,
              "z": 0.928
            },
            "gtin": "4002846034702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b3c",
            "leftCorner": {
              "x": -34.215,
              "y": -7.719,
              "z": 0.928
            },
            "rightCorner": {
              "x": -34.213,
              "y": -7.862,
              "z": 0.928
            },
            "gtin": "4002846034603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b3d",
            "leftCorner": {
              "x": -34.207,
              "y": -7.862,
              "z": 0.928
            },
            "rightCorner": {
              "x": -34.206,
              "y": -7.915,
              "z": 0.928
            },
            "gtin": "4002846034306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b3e",
            "leftCorner": {
              "x": -34.206,
              "y": -7.915,
              "z": 0.928
            },
            "rightCorner": {
              "x": -34.206,
              "y": -7.968,
              "z": 0.928
            },
            "gtin": "4002846034306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b3f",
            "leftCorner": {
              "x": -34.204,
              "y": -7.968,
              "z": 0.928
            },
            "rightCorner": {
              "x": -34.203,
              "y": -8.074,
              "z": 0.928
            },
            "gtin": "4002846034504",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7bb",
        "height": 1.4132,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b40",
            "leftCorner": {
              "x": -34.274,
              "y": -6.842,
              "z": 1.156
            },
            "rightCorner": {
              "x": -34.269,
              "y": -7.218,
              "z": 1.156
            },
            "gtin": "5449000121172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b42",
            "leftCorner": {
              "x": -34.23,
              "y": -7.218,
              "z": 1.156
            },
            "rightCorner": {
              "x": -34.228,
              "y": -7.393,
              "z": 1.156
            },
            "gtin": "5449000143129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b43",
            "leftCorner": {
              "x": -34.228,
              "y": -7.393,
              "z": 1.156
            },
            "rightCorner": {
              "x": -34.226,
              "y": -7.543,
              "z": 1.156
            },
            "gtin": "5449000187390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b44",
            "leftCorner": {
              "x": -34.225,
              "y": -7.543,
              "z": 1.156
            },
            "rightCorner": {
              "x": -34.223,
              "y": -7.657,
              "z": 1.156
            },
            "gtin": "42487364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b45",
            "leftCorner": {
              "x": -34.223,
              "y": -7.657,
              "z": 1.156
            },
            "rightCorner": {
              "x": -34.221,
              "y": -7.771,
              "z": 1.156
            },
            "gtin": "42487364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b46",
            "leftCorner": {
              "x": -34.217,
              "y": -7.771,
              "z": 1.156
            },
            "rightCorner": {
              "x": -34.215,
              "y": -7.961,
              "z": 1.156
            },
            "gtin": "42487388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b41",
            "leftCorner": {
              "x": -34.212,
              "y": -7.961,
              "z": 1.156
            },
            "rightCorner": {
              "x": -34.211,
              "y": -8.091,
              "z": 1.156
            },
            "gtin": "42487371",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7b9",
        "height": 1.7604,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b30",
            "leftCorner": {
              "x": -34.271,
              "y": -6.842,
              "z": 1.44
            },
            "rightCorner": {
              "x": -34.267,
              "y": -7.184,
              "z": 1.44
            },
            "gtin": "5449000260697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b31",
            "leftCorner": {
              "x": -34.23,
              "y": -7.183,
              "z": 1.44
            },
            "rightCorner": {
              "x": -34.229,
              "y": -7.355,
              "z": 1.44
            },
            "gtin": "5449000263810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b32",
            "leftCorner": {
              "x": -34.226,
              "y": -7.355,
              "z": 1.44
            },
            "rightCorner": {
              "x": -34.223,
              "y": -7.533,
              "z": 1.44
            },
            "gtin": "5449000665928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b33",
            "leftCorner": {
              "x": -34.219,
              "y": -7.533,
              "z": 1.44
            },
            "rightCorner": {
              "x": -34.217,
              "y": -7.7,
              "z": 1.44
            },
            "gtin": "5449000138170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b34",
            "leftCorner": {
              "x": -34.219,
              "y": -7.7,
              "z": 1.44
            },
            "rightCorner": {
              "x": -34.217,
              "y": -7.848,
              "z": 1.44
            },
            "gtin": "5449000017901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b35",
            "leftCorner": {
              "x": -34.212,
              "y": -7.848,
              "z": 1.44
            },
            "rightCorner": {
              "x": -34.21,
              "y": -8.071,
              "z": 1.44
            },
            "gtin": "5449000101549",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "a70",
    "name": "a70",
    "x": -33.018,
    "y": -12.952,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.98253,
      "w": 0.1861
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 44
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7c3",
        "height": 0.26317,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b7e",
            "leftCorner": {
              "x": -32.977,
              "y": -13.054,
              "z": 0.215
            },
            "rightCorner": {
              "x": -33.059,
              "y": -13.085,
              "z": 0.215
            },
            "gtin": "4065331000330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b80",
            "leftCorner": {
              "x": -33.038,
              "y": -13.139,
              "z": 0.215
            },
            "rightCorner": {
              "x": -33.132,
              "y": -13.177,
              "z": 0.215
            },
            "gtin": "4065331000064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b81",
            "leftCorner": {
              "x": -33.135,
              "y": -13.169,
              "z": 0.215
            },
            "rightCorner": {
              "x": -33.19,
              "y": -13.19,
              "z": 0.215
            },
            "gtin": "4065331000026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b82",
            "leftCorner": {
              "x": -33.191,
              "y": -13.185,
              "z": 0.215
            },
            "rightCorner": {
              "x": -33.243,
              "y": -13.205,
              "z": 0.215
            },
            "gtin": "4065331000019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b83",
            "leftCorner": {
              "x": -33.245,
              "y": -13.202,
              "z": 0.215
            },
            "rightCorner": {
              "x": -33.299,
              "y": -13.224,
              "z": 0.215
            },
            "gtin": "4001638523165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b84",
            "leftCorner": {
              "x": -33.3,
              "y": -13.222,
              "z": 0.215
            },
            "rightCorner": {
              "x": -33.347,
              "y": -13.24,
              "z": 0.215
            },
            "gtin": "4001638523127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b85",
            "leftCorner": {
              "x": -33.347,
              "y": -13.24,
              "z": 0.215
            },
            "rightCorner": {
              "x": -33.491,
              "y": -13.296,
              "z": 0.215
            },
            "gtin": "4000576050146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b86",
            "leftCorner": {
              "x": -33.491,
              "y": -13.296,
              "z": 0.215
            },
            "rightCorner": {
              "x": -33.635,
              "y": -13.353,
              "z": 0.215
            },
            "gtin": "4000576050146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b7f",
            "leftCorner": {
              "x": -33.643,
              "y": -13.332,
              "z": 0.215
            },
            "rightCorner": {
              "x": -33.903,
              "y": -13.433,
              "z": 0.215
            },
            "gtin": "40623474",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7c1",
        "height": 0.59852,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b67",
            "leftCorner": {
              "x": -32.982,
              "y": -13.041,
              "z": 0.49
            },
            "rightCorner": {
              "x": -33.095,
              "y": -13.085,
              "z": 0.49
            },
            "gtin": "4062300419377",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b69",
            "leftCorner": {
              "x": -33.077,
              "y": -13.132,
              "z": 0.49
            },
            "rightCorner": {
              "x": -33.151,
              "y": -13.161,
              "z": 0.49
            },
            "gtin": "42241287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b6a",
            "leftCorner": {
              "x": -33.151,
              "y": -13.162,
              "z": 0.49
            },
            "rightCorner": {
              "x": -33.232,
              "y": -13.193,
              "z": 0.49
            },
            "gtin": "4002448140160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b6b",
            "leftCorner": {
              "x": -33.234,
              "y": -13.188,
              "z": 0.49
            },
            "rightCorner": {
              "x": -33.325,
              "y": -13.225,
              "z": 0.49
            },
            "gtin": "3574661444123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b6c",
            "leftCorner": {
              "x": -33.325,
              "y": -13.225,
              "z": 0.49
            },
            "rightCorner": {
              "x": -33.407,
              "y": -13.257,
              "z": 0.49
            },
            "gtin": "3574661727073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b6d",
            "leftCorner": {
              "x": -33.41,
              "y": -13.251,
              "z": 0.49
            },
            "rightCorner": {
              "x": -33.485,
              "y": -13.281,
              "z": 0.49
            },
            "gtin": "3574661474915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b6e",
            "leftCorner": {
              "x": -33.486,
              "y": -13.278,
              "z": 0.49
            },
            "rightCorner": {
              "x": -33.549,
              "y": -13.303,
              "z": 0.49
            },
            "gtin": "3574661500553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b6f",
            "leftCorner": {
              "x": -33.55,
              "y": -13.3,
              "z": 0.49
            },
            "rightCorner": {
              "x": -33.62,
              "y": -13.328,
              "z": 0.49
            },
            "gtin": "3574661643014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b70",
            "leftCorner": {
              "x": -33.624,
              "y": -13.319,
              "z": 0.49
            },
            "rightCorner": {
              "x": -33.756,
              "y": -13.371,
              "z": 0.49
            },
            "gtin": "3574661821337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b68",
            "leftCorner": {
              "x": -33.76,
              "y": -13.36,
              "z": 0.49
            },
            "rightCorner": {
              "x": -33.909,
              "y": -13.418,
              "z": 0.49
            },
            "gtin": "4011448001104",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7bf",
        "height": 0.84824,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b5c",
            "leftCorner": {
              "x": -32.981,
              "y": -13.045,
              "z": 0.694
            },
            "rightCorner": {
              "x": -33.076,
              "y": -13.082,
              "z": 0.694
            },
            "gtin": "4065331001085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b5d",
            "leftCorner": {
              "x": -33.076,
              "y": -13.082,
              "z": 0.694
            },
            "rightCorner": {
              "x": -33.172,
              "y": -13.12,
              "z": 0.694
            },
            "gtin": "4065331001085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b5f",
            "leftCorner": {
              "x": -33.156,
              "y": -13.162,
              "z": 0.694
            },
            "rightCorner": {
              "x": -33.193,
              "y": -13.176,
              "z": 0.694
            },
            "gtin": "4065331002792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b60",
            "leftCorner": {
              "x": -33.192,
              "y": -13.178,
              "z": 0.694
            },
            "rightCorner": {
              "x": -33.254,
              "y": -13.202,
              "z": 0.694
            },
            "gtin": "4065331002815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b61",
            "leftCorner": {
              "x": -33.255,
              "y": -13.198,
              "z": 0.694
            },
            "rightCorner": {
              "x": -33.332,
              "y": -13.228,
              "z": 0.694
            },
            "gtin": "4065331001207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b62",
            "leftCorner": {
              "x": -33.333,
              "y": -13.227,
              "z": 0.694
            },
            "rightCorner": {
              "x": -33.399,
              "y": -13.252,
              "z": 0.694
            },
            "gtin": "4005900936011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b63",
            "leftCorner": {
              "x": -33.4,
              "y": -13.25,
              "z": 0.694
            },
            "rightCorner": {
              "x": -33.467,
              "y": -13.277,
              "z": 0.694
            },
            "gtin": "4005900936059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b64",
            "leftCorner": {
              "x": -33.468,
              "y": -13.273,
              "z": 0.694
            },
            "rightCorner": {
              "x": -33.542,
              "y": -13.302,
              "z": 0.694
            },
            "gtin": "3600542460392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b65",
            "leftCorner": {
              "x": -33.544,
              "y": -13.299,
              "z": 0.694
            },
            "rightCorner": {
              "x": -33.614,
              "y": -13.327,
              "z": 0.694
            },
            "gtin": "4006000028262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b66",
            "leftCorner": {
              "x": -33.614,
              "y": -13.327,
              "z": 0.694
            },
            "rightCorner": {
              "x": -33.683,
              "y": -13.354,
              "z": 0.694
            },
            "gtin": "4006000028262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b5e",
            "leftCorner": {
              "x": -33.688,
              "y": -13.341,
              "z": 0.694
            },
            "rightCorner": {
              "x": -33.905,
              "y": -13.427,
              "z": 0.694
            },
            "gtin": "41029671",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7c4",
        "height": 1.0774,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b87",
            "leftCorner": {
              "x": -32.985,
              "y": -13.033,
              "z": 0.882
            },
            "rightCorner": {
              "x": -33.206,
              "y": -13.119,
              "z": 0.882
            },
            "gtin": "4030651046047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b88",
            "leftCorner": {
              "x": -33.206,
              "y": -13.119,
              "z": 0.882
            },
            "rightCorner": {
              "x": -33.426,
              "y": -13.206,
              "z": 0.882
            },
            "gtin": "4030651046047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b8a",
            "leftCorner": {
              "x": -33.409,
              "y": -13.251,
              "z": 0.882
            },
            "rightCorner": {
              "x": -33.604,
              "y": -13.328,
              "z": 0.882
            },
            "gtin": "4065331002839",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b89",
            "leftCorner": {
              "x": -33.611,
              "y": -13.311,
              "z": 0.882
            },
            "rightCorner": {
              "x": -33.905,
              "y": -13.427,
              "z": 0.882
            },
            "gtin": "4059779050934",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7c2",
        "height": 1.5311,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b72",
            "leftCorner": {
              "x": -32.922,
              "y": -13.221,
              "z": 1.253
            },
            "rightCorner": {
              "x": -32.985,
              "y": -13.246,
              "z": 1.253
            },
            "gtin": "9001616824623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b73",
            "leftCorner": {
              "x": -33.006,
              "y": -13.247,
              "z": 1.253
            },
            "rightCorner": {
              "x": -33.048,
              "y": -13.263,
              "z": 1.253
            },
            "gtin": "9001616827501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b74",
            "leftCorner": {
              "x": -33.097,
              "y": -13.138,
              "z": 1.253
            },
            "rightCorner": {
              "x": -33.14,
              "y": -13.156,
              "z": 1.253
            },
            "gtin": "9001616827501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b75",
            "leftCorner": {
              "x": -33.161,
              "y": -13.162,
              "z": 1.253
            },
            "rightCorner": {
              "x": -33.211,
              "y": -13.181,
              "z": 1.253
            },
            "gtin": "9001616809354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b76",
            "leftCorner": {
              "x": -33.231,
              "y": -13.184,
              "z": 1.253
            },
            "rightCorner": {
              "x": -33.289,
              "y": -13.207,
              "z": 1.253
            },
            "gtin": "4008600356547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b77",
            "leftCorner": {
              "x": -33.249,
              "y": -13.337,
              "z": 1.253
            },
            "rightCorner": {
              "x": -33.326,
              "y": -13.368,
              "z": 1.253
            },
            "gtin": "4008600382201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b78",
            "leftCorner": {
              "x": -33.324,
              "y": -13.373,
              "z": 1.253
            },
            "rightCorner": {
              "x": -33.359,
              "y": -13.387,
              "z": 1.253
            },
            "gtin": "4008600159797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b79",
            "leftCorner": {
              "x": -33.411,
              "y": -13.252,
              "z": 1.253
            },
            "rightCorner": {
              "x": -33.474,
              "y": -13.277,
              "z": 1.253
            },
            "gtin": "4008600350743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b7a",
            "leftCorner": {
              "x": -33.41,
              "y": -13.441,
              "z": 1.253
            },
            "rightCorner": {
              "x": -33.438,
              "y": -13.453,
              "z": 1.253
            },
            "gtin": "4008600251101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b7b",
            "leftCorner": {
              "x": -33.506,
              "y": -13.28,
              "z": 1.253
            },
            "rightCorner": {
              "x": -33.55,
              "y": -13.297,
              "z": 1.253
            },
            "gtin": "4008600307914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b7c",
            "leftCorner": {
              "x": -33.57,
              "y": -13.296,
              "z": 1.253
            },
            "rightCorner": {
              "x": -33.643,
              "y": -13.325,
              "z": 1.253
            },
            "gtin": "4008600382232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b7d",
            "leftCorner": {
              "x": -33.651,
              "y": -13.322,
              "z": 1.253
            },
            "rightCorner": {
              "x": -33.734,
              "y": -13.354,
              "z": 1.253
            },
            "gtin": "4008600356530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b71",
            "leftCorner": {
              "x": -33.742,
              "y": -13.352,
              "z": 1.253
            },
            "rightCorner": {
              "x": -33.909,
              "y": -13.418,
              "z": 1.253
            },
            "gtin": "9001616838705",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "a71",
    "name": "a71",
    "x": -32.159,
    "y": -13.351,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.82433,
      "w": 0.56611
    },
    "layers": []
  },
  {
    "id": "a72",
    "name": "a72",
    "x": -32.608,
    "y": -14.217,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.17812,
      "w": 0.98401
    },
    "layers": []
  },
  {
    "id": "a73",
    "name": "a73",
    "x": -33.443,
    "y": -13.907,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.56098,
      "w": 0.82783
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 72
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7ca",
        "height": 0.31224,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8bcc",
            "leftCorner": {
              "x": -33.353,
              "y": -13.871,
              "z": 0.255
            },
            "rightCorner": {
              "x": -33.311,
              "y": -13.976,
              "z": 0.255
            },
            "gtin": "4003583222179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bcd",
            "leftCorner": {
              "x": -33.311,
              "y": -13.976,
              "z": 0.255
            },
            "rightCorner": {
              "x": -33.269,
              "y": -14.082,
              "z": 0.255
            },
            "gtin": "4003583222179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bcf",
            "leftCorner": {
              "x": -33.219,
              "y": -14.062,
              "z": 0.255
            },
            "rightCorner": {
              "x": -33.163,
              "y": -14.204,
              "z": 0.255
            },
            "gtin": "4003583222193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bd0",
            "leftCorner": {
              "x": -33.177,
              "y": -14.209,
              "z": 0.255
            },
            "rightCorner": {
              "x": -33.137,
              "y": -14.306,
              "z": 0.255
            },
            "gtin": "4003583222292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bd1",
            "leftCorner": {
              "x": -33.128,
              "y": -14.301,
              "z": 0.255
            },
            "rightCorner": {
              "x": -33.082,
              "y": -14.417,
              "z": 0.255
            },
            "gtin": "4006000130873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bd2",
            "leftCorner": {
              "x": -33.095,
              "y": -14.422,
              "z": 0.255
            },
            "rightCorner": {
              "x": -33.045,
              "y": -14.547,
              "z": 0.255
            },
            "gtin": "4006000139449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bce",
            "leftCorner": {
              "x": -33.05,
              "y": -14.55,
              "z": 0.255
            },
            "rightCorner": {
              "x": -32.954,
              "y": -14.788,
              "z": 0.255
            },
            "gtin": "4006000131030",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7c8",
        "height": 0.55909,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8bb6",
            "leftCorner": {
              "x": -33.374,
              "y": -13.879,
              "z": 0.457
            },
            "rightCorner": {
              "x": -33.323,
              "y": -14.007,
              "z": 0.457
            },
            "gtin": "3600542520300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bb8",
            "leftCorner": {
              "x": -33.278,
              "y": -13.988,
              "z": 0.457
            },
            "rightCorner": {
              "x": -33.232,
              "y": -14.105,
              "z": 0.457
            },
            "gtin": "5099821001070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bb9",
            "leftCorner": {
              "x": -33.236,
              "y": -14.107,
              "z": 0.457
            },
            "rightCorner": {
              "x": -33.211,
              "y": -14.168,
              "z": 0.457
            },
            "gtin": "4005900691774",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bba",
            "leftCorner": {
              "x": -33.21,
              "y": -14.167,
              "z": 0.457
            },
            "rightCorner": {
              "x": -33.194,
              "y": -14.209,
              "z": 0.457
            },
            "gtin": "4006000131078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bbb",
            "leftCorner": {
              "x": -33.197,
              "y": -14.211,
              "z": 0.457
            },
            "rightCorner": {
              "x": -33.161,
              "y": -14.301,
              "z": 0.457
            },
            "gtin": "4006000130651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bbc",
            "leftCorner": {
              "x": -33.156,
              "y": -14.299,
              "z": 0.457
            },
            "rightCorner": {
              "x": -33.109,
              "y": -14.418,
              "z": 0.457
            },
            "gtin": "4006000130750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bbd",
            "leftCorner": {
              "x": -33.115,
              "y": -14.421,
              "z": 0.457
            },
            "rightCorner": {
              "x": -33.094,
              "y": -14.472,
              "z": 0.457
            },
            "gtin": "4006000136264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bbe",
            "leftCorner": {
              "x": -33.1,
              "y": -14.474,
              "z": 0.457
            },
            "rightCorner": {
              "x": -33.073,
              "y": -14.543,
              "z": 0.457
            },
            "gtin": "4006000139319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bbf",
            "leftCorner": {
              "x": -33.074,
              "y": -14.544,
              "z": 0.457
            },
            "rightCorner": {
              "x": -33.05,
              "y": -14.606,
              "z": 0.457
            },
            "gtin": "42417941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bc0",
            "leftCorner": {
              "x": -33.053,
              "y": -14.607,
              "z": 0.457
            },
            "rightCorner": {
              "x": -33.03,
              "y": -14.665,
              "z": 0.457
            },
            "gtin": "42360698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bc1",
            "leftCorner": {
              "x": -33.033,
              "y": -14.666,
              "z": 0.457
            },
            "rightCorner": {
              "x": -33.017,
              "y": -14.71,
              "z": 0.457
            },
            "gtin": "4005900475626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bb7",
            "leftCorner": {
              "x": -33.013,
              "y": -14.709,
              "z": 0.457
            },
            "rightCorner": {
              "x": -32.978,
              "y": -14.798,
              "z": 0.457
            },
            "gtin": "4005900599100",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7c9",
        "height": 0.79727,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8bc2",
            "leftCorner": {
              "x": -33.358,
              "y": -13.873,
              "z": 0.652
            },
            "rightCorner": {
              "x": -33.343,
              "y": -13.911,
              "z": 0.652
            },
            "gtin": "4005800278563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bc4",
            "leftCorner": {
              "x": -33.296,
              "y": -13.892,
              "z": 0.652
            },
            "rightCorner": {
              "x": -33.27,
              "y": -13.956,
              "z": 0.652
            },
            "gtin": "4005800278549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bc5",
            "leftCorner": {
              "x": -33.271,
              "y": -13.956,
              "z": 0.652
            },
            "rightCorner": {
              "x": -33.238,
              "y": -14.038,
              "z": 0.652
            },
            "gtin": "4005800280689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bc6",
            "leftCorner": {
              "x": -33.244,
              "y": -14.04,
              "z": 0.652
            },
            "rightCorner": {
              "x": -33.212,
              "y": -14.121,
              "z": 0.652
            },
            "gtin": "4005800279119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bc7",
            "leftCorner": {
              "x": -33.214,
              "y": -14.122,
              "z": 0.652
            },
            "rightCorner": {
              "x": -33.179,
              "y": -14.209,
              "z": 0.652
            },
            "gtin": "4005800279133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bc8",
            "leftCorner": {
              "x": -33.181,
              "y": -14.209,
              "z": 0.652
            },
            "rightCorner": {
              "x": -33.15,
              "y": -14.289,
              "z": 0.652
            },
            "gtin": "4005800283888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bc9",
            "leftCorner": {
              "x": -33.15,
              "y": -14.289,
              "z": 0.652
            },
            "rightCorner": {
              "x": -33.113,
              "y": -14.382,
              "z": 0.652
            },
            "gtin": "4005800280023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bca",
            "leftCorner": {
              "x": -33.116,
              "y": -14.383,
              "z": 0.652
            },
            "rightCorner": {
              "x": -33.084,
              "y": -14.462,
              "z": 0.652
            },
            "gtin": "4005800278501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bcb",
            "leftCorner": {
              "x": -33.094,
              "y": -14.466,
              "z": 0.652
            },
            "rightCorner": {
              "x": -33.015,
              "y": -14.664,
              "z": 0.652
            },
            "gtin": "4306188373162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bc3",
            "leftCorner": {
              "x": -33.019,
              "y": -14.665,
              "z": 0.652
            },
            "rightCorner": {
              "x": -32.968,
              "y": -14.794,
              "z": 0.652
            },
            "gtin": "4306188373247",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7c6",
        "height": 1.0462,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b97",
            "leftCorner": {
              "x": -33.361,
              "y": -13.874,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.346,
              "y": -13.915,
              "z": 0.856
            },
            "gtin": "5000204093681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b99",
            "leftCorner": {
              "x": -33.294,
              "y": -13.893,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.276,
              "y": -13.939,
              "z": 0.856
            },
            "gtin": "5000204094015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b9a",
            "leftCorner": {
              "x": -33.279,
              "y": -13.941,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.259,
              "y": -13.99,
              "z": 0.856
            },
            "gtin": "5000204093957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b9b",
            "leftCorner": {
              "x": -33.262,
              "y": -13.991,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.238,
              "y": -14.049,
              "z": 0.856
            },
            "gtin": "4001669090018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b9c",
            "leftCorner": {
              "x": -33.241,
              "y": -14.05,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.222,
              "y": -14.099,
              "z": 0.856
            },
            "gtin": "4015600522315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b9d",
            "leftCorner": {
              "x": -33.224,
              "y": -14.1,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.204,
              "y": -14.15,
              "z": 0.856
            },
            "gtin": "4260457778433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b9e",
            "leftCorner": {
              "x": -33.205,
              "y": -14.151,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.168,
              "y": -14.246,
              "z": 0.856
            },
            "gtin": "4044571240232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b9f",
            "leftCorner": {
              "x": -33.169,
              "y": -14.246,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.141,
              "y": -14.319,
              "z": 0.856
            },
            "gtin": "4044571221248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8ba0",
            "leftCorner": {
              "x": -33.142,
              "y": -14.319,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.109,
              "y": -14.403,
              "z": 0.856
            },
            "gtin": "4044571221217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8ba1",
            "leftCorner": {
              "x": -33.114,
              "y": -14.406,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.087,
              "y": -14.473,
              "z": 0.856
            },
            "gtin": "4044571095009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8ba2",
            "leftCorner": {
              "x": -33.09,
              "y": -14.474,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.07,
              "y": -14.526,
              "z": 0.856
            },
            "gtin": "4260751330016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8ba3",
            "leftCorner": {
              "x": -33.075,
              "y": -14.528,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.052,
              "y": -14.584,
              "z": 0.856
            },
            "gtin": "4005800402982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8ba4",
            "leftCorner": {
              "x": -33.046,
              "y": -14.581,
              "z": 0.856
            },
            "rightCorner": {
              "x": -33.012,
              "y": -14.667,
              "z": 0.856
            },
            "gtin": "4005800279096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b98",
            "leftCorner": {
              "x": -33.02,
              "y": -14.67,
              "z": 0.856
            },
            "rightCorner": {
              "x": -32.971,
              "y": -14.795,
              "z": 0.856
            },
            "gtin": "4005800279782",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7c7",
        "height": 1.2998,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8ba5",
            "leftCorner": {
              "x": -33.363,
              "y": -13.875,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.33,
              "y": -13.958,
              "z": 1.063
            },
            "gtin": "4003626908114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8ba7",
            "leftCorner": {
              "x": -33.277,
              "y": -13.936,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.259,
              "y": -13.98,
              "z": 1.063
            },
            "gtin": "4103040909787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8ba8",
            "leftCorner": {
              "x": -33.264,
              "y": -13.982,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.24,
              "y": -14.043,
              "z": 1.063
            },
            "gtin": "4008890005286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8ba9",
            "leftCorner": {
              "x": -33.241,
              "y": -14.043,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.225,
              "y": -14.085,
              "z": 1.063
            },
            "gtin": "5038483498347",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8baa",
            "leftCorner": {
              "x": -33.228,
              "y": -14.086,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.212,
              "y": -14.124,
              "z": 1.063
            },
            "gtin": "5038483502662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bab",
            "leftCorner": {
              "x": -33.213,
              "y": -14.124,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.198,
              "y": -14.164,
              "z": 1.063
            },
            "gtin": "4002448134107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bac",
            "leftCorner": {
              "x": -33.2,
              "y": -14.165,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.18,
              "y": -14.216,
              "z": 1.063
            },
            "gtin": "5038483253908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bad",
            "leftCorner": {
              "x": -33.181,
              "y": -14.217,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.15,
              "y": -14.297,
              "z": 1.063
            },
            "gtin": "4036581540327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bae",
            "leftCorner": {
              "x": -33.151,
              "y": -14.298,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.131,
              "y": -14.349,
              "z": 1.063
            },
            "gtin": "4009737306931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8baf",
            "leftCorner": {
              "x": -33.134,
              "y": -14.35,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.114,
              "y": -14.402,
              "z": 1.063
            },
            "gtin": "4009737306924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bb0",
            "leftCorner": {
              "x": -33.113,
              "y": -14.401,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.092,
              "y": -14.456,
              "z": 1.063
            },
            "gtin": "4009737306979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bb1",
            "leftCorner": {
              "x": -33.103,
              "y": -14.46,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.087,
              "y": -14.5,
              "z": 1.063
            },
            "gtin": "4009737306948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bb2",
            "leftCorner": {
              "x": -33.09,
              "y": -14.501,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.073,
              "y": -14.545,
              "z": 1.063
            },
            "gtin": "4009737306986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bb3",
            "leftCorner": {
              "x": -33.071,
              "y": -14.544,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.052,
              "y": -14.591,
              "z": 1.063
            },
            "gtin": "4009737306955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bb4",
            "leftCorner": {
              "x": -33.053,
              "y": -14.591,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.041,
              "y": -14.623,
              "z": 1.063
            },
            "gtin": "4009737306962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bb5",
            "leftCorner": {
              "x": -33.044,
              "y": -14.624,
              "z": 1.063
            },
            "rightCorner": {
              "x": -33.015,
              "y": -14.699,
              "z": 1.063
            },
            "gtin": "4009737306993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8ba6",
            "leftCorner": {
              "x": -33.017,
              "y": -14.699,
              "z": 1.063
            },
            "rightCorner": {
              "x": -32.978,
              "y": -14.798,
              "z": 1.063
            },
            "gtin": "4009737800385",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7c5",
        "height": 1.5508,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b8b",
            "leftCorner": {
              "x": -33.365,
              "y": -13.875,
              "z": 1.269
            },
            "rightCorner": {
              "x": -33.323,
              "y": -13.98,
              "z": 1.269
            },
            "gtin": "4006293038320",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b8d",
            "leftCorner": {
              "x": -33.273,
              "y": -13.96,
              "z": 1.269
            },
            "rightCorner": {
              "x": -33.245,
              "y": -14.032,
              "z": 1.269
            },
            "gtin": "4006293043324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b8e",
            "leftCorner": {
              "x": -33.25,
              "y": -14.034,
              "z": 1.269
            },
            "rightCorner": {
              "x": -33.226,
              "y": -14.093,
              "z": 1.269
            },
            "gtin": "4006293736462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b8f",
            "leftCorner": {
              "x": -33.228,
              "y": -14.094,
              "z": 1.269
            },
            "rightCorner": {
              "x": -33.199,
              "y": -14.165,
              "z": 1.269
            },
            "gtin": "4006293096344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b90",
            "leftCorner": {
              "x": -33.202,
              "y": -14.167,
              "z": 1.269
            },
            "rightCorner": {
              "x": -33.183,
              "y": -14.216,
              "z": 1.269
            },
            "gtin": "4006293197744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b91",
            "leftCorner": {
              "x": -33.185,
              "y": -14.217,
              "z": 1.269
            },
            "rightCorner": {
              "x": -33.152,
              "y": -14.302,
              "z": 1.269
            },
            "gtin": "4005800486005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b92",
            "leftCorner": {
              "x": -33.151,
              "y": -14.301,
              "z": 1.269
            },
            "rightCorner": {
              "x": -33.12,
              "y": -14.381,
              "z": 1.269
            },
            "gtin": "4006671036115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b93",
            "leftCorner": {
              "x": -33.13,
              "y": -14.384,
              "z": 1.269
            },
            "rightCorner": {
              "x": -33.1,
              "y": -14.459,
              "z": 1.269
            },
            "gtin": "5056585803036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b94",
            "leftCorner": {
              "x": -33.106,
              "y": -14.461,
              "z": 1.269
            },
            "rightCorner": {
              "x": -33.075,
              "y": -14.539,
              "z": 1.269
            },
            "gtin": "5056585803661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b95",
            "leftCorner": {
              "x": -33.075,
              "y": -14.539,
              "z": 1.269
            },
            "rightCorner": {
              "x": -33.045,
              "y": -14.613,
              "z": 1.269
            },
            "gtin": "4006671031011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b96",
            "leftCorner": {
              "x": -33.048,
              "y": -14.615,
              "z": 1.269
            },
            "rightCorner": {
              "x": -33.021,
              "y": -14.68,
              "z": 1.269
            },
            "gtin": "4006671002011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b8c",
            "leftCorner": {
              "x": -33.025,
              "y": -14.682,
              "z": 1.269
            },
            "rightCorner": {
              "x": -32.979,
              "y": -14.798,
              "z": 1.269
            },
            "gtin": "5704947015121",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "a87",
    "name": "a87",
    "x": -5.8454,
    "y": -25.664,
    "width": 1.25,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 5.5697E-4,
      "y": 5.4474E-4,
      "z": 0.92712,
      "w": 0.37478
    },
    "layers": [],
    "leftNeighborShelfId": "88d"
  },
  {
    "id": "ab2",
    "name": "ab2",
    "x": -29.607,
    "y": -23.672,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061522,
      "w": 0.99998
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d386",
        "height": 0.45629,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d381",
        "height": 0.68226,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d382",
        "height": 0.96029,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d383",
        "height": 1.266,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d384",
        "height": 1.5147,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d385",
        "height": 1.8171,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "ab3"
  },
  {
    "id": "ab3",
    "name": "ab3",
    "x": -30.407,
    "y": -23.682,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061522,
      "w": 0.99998
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d37e",
        "height": 0.44986,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d37a",
        "height": 0.73502,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d380",
        "height": 0.99495,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d37b",
        "height": 1.2855,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d37c",
        "height": 1.5647,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d379",
        "height": 1.8398,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "ab4",
    "rightNeighborShelfId": "ab2"
  },
  {
    "id": "ab4",
    "name": "ab4",
    "x": -31.207,
    "y": -23.692,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061522,
      "w": 0.99998
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d376",
        "height": 0.45112,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d378",
        "height": 0.738,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d372",
        "height": 0.99562,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d373",
        "height": 1.294,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d371",
        "height": 1.5717,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d370",
        "height": 1.8511,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "ab5",
    "rightNeighborShelfId": "ab3"
  },
  {
    "id": "ab5",
    "name": "ab5",
    "x": -32.007,
    "y": -23.702,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061522,
      "w": 0.99998
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d367",
        "height": 0.45351,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d36b",
        "height": 0.65543,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d36d",
        "height": 0.8866,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d366",
        "height": 1.1098,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d369",
        "height": 1.3216,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d368",
        "height": 1.5644,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d36a",
        "height": 1.8329,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "ab6",
    "rightNeighborShelfId": "ab4"
  },
  {
    "id": "ab6",
    "name": "ab6",
    "x": -32.807,
    "y": -23.712,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061522,
      "w": 0.99998
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d364",
        "height": 0.44688,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d35f",
        "height": 0.8039,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d360",
        "height": 1.1127,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d362",
        "height": 1.3133,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d361",
        "height": 1.5673,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d363",
        "height": 1.8374,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "ab7",
    "rightNeighborShelfId": "ab5"
  },
  {
    "id": "ab7",
    "name": "ab7",
    "x": -33.607,
    "y": -23.721,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061522,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d359",
        "height": 0.44963,
        "facings": [
          {
            "id": "de56b06e739285be99925bcb",
            "leftCorner": {
              "x": -33.608,
              "y": -23.664,
              "z": 0.368
            },
            "rightCorner": {
              "x": -33.384,
              "y": -23.661,
              "z": 0.368
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "eafc5e5884f6ead370534093",
            "leftCorner": {
              "x": -33.384,
              "y": -23.661,
              "z": 0.368
            },
            "rightCorner": {
              "x": -33.16,
              "y": -23.658,
              "z": 0.368
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f18ee50538a8d9828e6d273d",
            "leftCorner": {
              "x": -33.16,
              "y": -23.658,
              "z": 0.368
            },
            "rightCorner": {
              "x": -32.936,
              "y": -23.656,
              "z": 0.368
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d356",
        "height": 0.80106,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6fae",
            "leftCorner": {
              "x": -33.038,
              "y": -23.595,
              "z": 0.655
            },
            "rightCorner": {
              "x": -32.815,
              "y": -23.592,
              "z": 0.655
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "51be4de60804789ffa055732",
            "leftCorner": {
              "x": -33.608,
              "y": -23.63,
              "z": 0.655
            },
            "rightCorner": {
              "x": -33.384,
              "y": -23.627,
              "z": 0.655
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d90963e7dc97ef3e147daa0f",
            "leftCorner": {
              "x": -33.384,
              "y": -23.627,
              "z": 0.655
            },
            "rightCorner": {
              "x": -33.16,
              "y": -23.624,
              "z": 0.655
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d35a",
        "height": 1.1043,
        "facings": [
          {
            "id": "4244b2cec2fc9bc60cc39f4a",
            "leftCorner": {
              "x": -33.608,
              "y": -23.637,
              "z": 0.904
            },
            "rightCorner": {
              "x": -33.384,
              "y": -23.634,
              "z": 0.904
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2df6da408254105a5d3bfa7a",
            "leftCorner": {
              "x": -33.384,
              "y": -23.634,
              "z": 0.904
            },
            "rightCorner": {
              "x": -33.16,
              "y": -23.631,
              "z": 0.904
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b460fa845cd202df2f7c71f6",
            "leftCorner": {
              "x": -33.16,
              "y": -23.631,
              "z": 0.904
            },
            "rightCorner": {
              "x": -32.936,
              "y": -23.629,
              "z": 0.904
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d35b",
        "height": 1.2743,
        "facings": [
          {
            "id": "f9a207d2882eb9037dbcf288",
            "leftCorner": {
              "x": -33.608,
              "y": -23.642,
              "z": 1.043
            },
            "rightCorner": {
              "x": -33.384,
              "y": -23.639,
              "z": 1.043
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5da35a7542e99fc2d3dbbe9e",
            "leftCorner": {
              "x": -33.384,
              "y": -23.639,
              "z": 1.043
            },
            "rightCorner": {
              "x": -33.16,
              "y": -23.636,
              "z": 1.043
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8b09116b7b2a17a257dbf661",
            "leftCorner": {
              "x": -33.16,
              "y": -23.636,
              "z": 1.043
            },
            "rightCorner": {
              "x": -32.935,
              "y": -23.634,
              "z": 1.043
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d357",
        "height": 1.5662,
        "facings": [
          {
            "id": "de996aced9da3e6297421b49",
            "leftCorner": {
              "x": -33.609,
              "y": -23.615,
              "z": 1.281
            },
            "rightCorner": {
              "x": -33.385,
              "y": -23.612,
              "z": 1.281
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "95b485178a2ab040afccd081",
            "leftCorner": {
              "x": -33.385,
              "y": -23.612,
              "z": 1.281
            },
            "rightCorner": {
              "x": -33.161,
              "y": -23.609,
              "z": 1.281
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "971297986bdf2ab6fdc23e8a",
            "leftCorner": {
              "x": -33.161,
              "y": -23.609,
              "z": 1.281
            },
            "rightCorner": {
              "x": -32.937,
              "y": -23.607,
              "z": 1.281
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d35c",
        "height": 1.8324,
        "facings": [
          {
            "id": "8bfbb228348a303b879f354a",
            "leftCorner": {
              "x": -33.608,
              "y": -23.631,
              "z": 1.499
            },
            "rightCorner": {
              "x": -33.384,
              "y": -23.628,
              "z": 1.499
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9d90d98ae4e0a0d0327b93b6",
            "leftCorner": {
              "x": -33.384,
              "y": -23.628,
              "z": 1.499
            },
            "rightCorner": {
              "x": -33.16,
              "y": -23.625,
              "z": 1.499
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5229abaa5bc020ce6743ea9a",
            "leftCorner": {
              "x": -33.16,
              "y": -23.625,
              "z": 1.499
            },
            "rightCorner": {
              "x": -32.936,
              "y": -23.623,
              "z": 1.499
            },
            "gtin": "4012481536493",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ab8",
    "rightNeighborShelfId": "ab6"
  },
  {
    "id": "ab8",
    "name": "ab8",
    "x": -34.407,
    "y": -23.731,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061522,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 33
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d350",
        "height": 0.46298,
        "facings": [
          {
            "id": "3a8d69be755aad9d75183e69",
            "leftCorner": {
              "x": -34.408,
              "y": -23.623,
              "z": 0.379
            },
            "rightCorner": {
              "x": -34.299,
              "y": -23.622,
              "z": 0.379
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3377c2764f31b73fdd83fb78",
            "leftCorner": {
              "x": -34.299,
              "y": -23.622,
              "z": 0.379
            },
            "rightCorner": {
              "x": -34.19,
              "y": -23.62,
              "z": 0.379
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ae9c87302494666767003df9",
            "leftCorner": {
              "x": -34.19,
              "y": -23.62,
              "z": 0.379
            },
            "rightCorner": {
              "x": -34.081,
              "y": -23.619,
              "z": 0.379
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9e0d3154a2bd890ac78d4342",
            "leftCorner": {
              "x": -34.081,
              "y": -23.619,
              "z": 0.379
            },
            "rightCorner": {
              "x": -33.972,
              "y": -23.618,
              "z": 0.379
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c599cc818155247c1b5dd01d",
            "leftCorner": {
              "x": -33.972,
              "y": -23.618,
              "z": 0.379
            },
            "rightCorner": {
              "x": -33.863,
              "y": -23.616,
              "z": 0.379
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3fe5b24d015dfd2f99e1e70a",
            "leftCorner": {
              "x": -33.863,
              "y": -23.616,
              "z": 0.379
            },
            "rightCorner": {
              "x": -33.754,
              "y": -23.615,
              "z": 0.379
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c6f19b88dff01916ccf93048",
            "leftCorner": {
              "x": -33.754,
              "y": -23.615,
              "z": 0.379
            },
            "rightCorner": {
              "x": -33.645,
              "y": -23.614,
              "z": 0.379
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d34f",
        "height": 0.80374,
        "facings": [
          {
            "id": "2d0e231323f4d93e09ed04a4",
            "leftCorner": {
              "x": -34.408,
              "y": -23.645,
              "z": 0.658
            },
            "rightCorner": {
              "x": -34.299,
              "y": -23.644,
              "z": 0.658
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "051d7f95f5490680e656a768",
            "leftCorner": {
              "x": -34.299,
              "y": -23.644,
              "z": 0.658
            },
            "rightCorner": {
              "x": -34.19,
              "y": -23.642,
              "z": 0.658
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1816b7d8d5eb8821fe16939c",
            "leftCorner": {
              "x": -34.19,
              "y": -23.642,
              "z": 0.658
            },
            "rightCorner": {
              "x": -34.081,
              "y": -23.641,
              "z": 0.658
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "552be8b54b2d1fdab2368de5",
            "leftCorner": {
              "x": -34.081,
              "y": -23.641,
              "z": 0.658
            },
            "rightCorner": {
              "x": -33.971,
              "y": -23.64,
              "z": 0.658
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5b5cec7101b572990eb9a913",
            "leftCorner": {
              "x": -33.971,
              "y": -23.64,
              "z": 0.658
            },
            "rightCorner": {
              "x": -33.862,
              "y": -23.638,
              "z": 0.658
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b34fc0c3a09a68fb079d7d12",
            "leftCorner": {
              "x": -33.862,
              "y": -23.638,
              "z": 0.658
            },
            "rightCorner": {
              "x": -33.753,
              "y": -23.637,
              "z": 0.658
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dac02bcd3b1ab5d558ea8476",
            "leftCorner": {
              "x": -33.753,
              "y": -23.637,
              "z": 0.658
            },
            "rightCorner": {
              "x": -33.644,
              "y": -23.636,
              "z": 0.658
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d351",
        "height": 1.1309,
        "facings": [
          {
            "id": "4b30a76ea390bf06daae7895",
            "leftCorner": {
              "x": -34.408,
              "y": -23.622,
              "z": 0.925
            },
            "rightCorner": {
              "x": -34.299,
              "y": -23.621,
              "z": 0.925
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "29bb36ec35e70710a182d2fa",
            "leftCorner": {
              "x": -34.299,
              "y": -23.621,
              "z": 0.925
            },
            "rightCorner": {
              "x": -34.19,
              "y": -23.619,
              "z": 0.925
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5f74cbf8f2fd64f6b26c5fd1",
            "leftCorner": {
              "x": -34.19,
              "y": -23.619,
              "z": 0.925
            },
            "rightCorner": {
              "x": -34.081,
              "y": -23.618,
              "z": 0.925
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e0060bfeea2c8ab58aa61961",
            "leftCorner": {
              "x": -34.081,
              "y": -23.618,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.972,
              "y": -23.617,
              "z": 0.925
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2291e2b3281769424b54dae3",
            "leftCorner": {
              "x": -33.972,
              "y": -23.617,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.863,
              "y": -23.615,
              "z": 0.925
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5f2090e71ded7a8db9a61900",
            "leftCorner": {
              "x": -33.863,
              "y": -23.615,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.754,
              "y": -23.614,
              "z": 0.925
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1f9c4f120dc2c4e00eaadc5c",
            "leftCorner": {
              "x": -33.754,
              "y": -23.614,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.645,
              "y": -23.613,
              "z": 0.925
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d352",
        "height": 1.4354,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6fbb",
            "leftCorner": {
              "x": -34.326,
              "y": -23.615,
              "z": 1.174
            },
            "rightCorner": {
              "x": -34.05,
              "y": -23.612,
              "z": 1.174
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "24c7ac3a086e6ef52d95554b",
            "leftCorner": {
              "x": -34.051,
              "y": -23.57,
              "z": 1.174
            },
            "rightCorner": {
              "x": -33.942,
              "y": -23.568,
              "z": 1.174
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1266d9dd10dc5c0a2197b41f",
            "leftCorner": {
              "x": -33.942,
              "y": -23.568,
              "z": 1.174
            },
            "rightCorner": {
              "x": -33.833,
              "y": -23.567,
              "z": 1.174
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fe863f02d4573292e27bebfc",
            "leftCorner": {
              "x": -33.833,
              "y": -23.567,
              "z": 1.174
            },
            "rightCorner": {
              "x": -33.724,
              "y": -23.566,
              "z": 1.174
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2ed4367b310563631fb4802c",
            "leftCorner": {
              "x": -33.724,
              "y": -23.566,
              "z": 1.174
            },
            "rightCorner": {
              "x": -33.615,
              "y": -23.564,
              "z": 1.174
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d34e",
        "height": 1.7577,
        "facings": [
          {
            "id": "d0f33c4c048f36010a76a975",
            "leftCorner": {
              "x": -34.407,
              "y": -23.66,
              "z": 1.438
            },
            "rightCorner": {
              "x": -34.298,
              "y": -23.659,
              "z": 1.438
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9d4398717799967afbc0a31b",
            "leftCorner": {
              "x": -34.298,
              "y": -23.659,
              "z": 1.438
            },
            "rightCorner": {
              "x": -34.189,
              "y": -23.657,
              "z": 1.438
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4fb09248bdfb971b23a050af",
            "leftCorner": {
              "x": -34.189,
              "y": -23.657,
              "z": 1.438
            },
            "rightCorner": {
              "x": -34.08,
              "y": -23.656,
              "z": 1.438
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d6d3f5c01ecf3b380fc351fa",
            "leftCorner": {
              "x": -34.08,
              "y": -23.656,
              "z": 1.438
            },
            "rightCorner": {
              "x": -33.971,
              "y": -23.655,
              "z": 1.438
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b56e21fdb3e22439e558e3d1",
            "leftCorner": {
              "x": -33.971,
              "y": -23.655,
              "z": 1.438
            },
            "rightCorner": {
              "x": -33.862,
              "y": -23.653,
              "z": 1.438
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e812f36c5039cecb484bf480",
            "leftCorner": {
              "x": -33.862,
              "y": -23.653,
              "z": 1.438
            },
            "rightCorner": {
              "x": -33.753,
              "y": -23.652,
              "z": 1.438
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8cb91d0e5e4e1cd019d30dfd",
            "leftCorner": {
              "x": -33.753,
              "y": -23.652,
              "z": 1.438
            },
            "rightCorner": {
              "x": -33.644,
              "y": -23.651,
              "z": 1.438
            },
            "gtin": "8710438035636",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ab9",
    "rightNeighborShelfId": "ab7"
  },
  {
    "id": "ab9",
    "name": "ab9",
    "x": -35.206,
    "y": -23.741,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061522,
      "w": 0.99998
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7d1",
        "height": 0.44904,
        "facings": []
      },
      {
        "id": "68d8d40255f889d41539d7d8",
        "height": 0.77111,
        "facings": []
      },
      {
        "id": "68d8d40255f889d41539d7d9",
        "height": 1.1066,
        "facings": []
      },
      {
        "id": "68d8d40255f889d41539d7d5",
        "height": 1.4362,
        "facings": []
      },
      {
        "id": "68d8d40255f889d41539d7d7",
        "height": 1.7572,
        "facings": []
      }
    ],

    "rightNeighborShelfId": "ab8"
  },
  {
    "id": "aba",
    "name": "aba",
    "x": -35.174,
    "y": -24.586,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70994,
      "w": 0.70426
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 24
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7e0",
        "height": 0.44056,
        "facings": [
          {
            "id": "baab303d963483ac0597d0f3",
            "leftCorner": {
              "x": -35.268,
              "y": -24.587,
              "z": 0.36
            },
            "rightCorner": {
              "x": -35.269,
              "y": -24.449,
              "z": 0.36
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f3e2e97c9608a4596a02f4d5",
            "leftCorner": {
              "x": -35.269,
              "y": -24.449,
              "z": 0.36
            },
            "rightCorner": {
              "x": -35.27,
              "y": -24.31,
              "z": 0.36
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "53df774bdd6a4b36224bc84c",
            "leftCorner": {
              "x": -35.27,
              "y": -24.31,
              "z": 0.36
            },
            "rightCorner": {
              "x": -35.271,
              "y": -24.172,
              "z": 0.36
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b2de1bf5b76e9656be1dbc57",
            "leftCorner": {
              "x": -35.271,
              "y": -24.172,
              "z": 0.36
            },
            "rightCorner": {
              "x": -35.273,
              "y": -24.034,
              "z": 0.36
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a34bbf2c348eb49b130444c8",
            "leftCorner": {
              "x": -35.273,
              "y": -24.034,
              "z": 0.36
            },
            "rightCorner": {
              "x": -35.274,
              "y": -23.896,
              "z": 0.36
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7db",
        "height": 0.80732,
        "facings": [
          {
            "id": "037491a1921984c67145823f",
            "leftCorner": {
              "x": -35.274,
              "y": -24.587,
              "z": 0.661
            },
            "rightCorner": {
              "x": -35.275,
              "y": -24.449,
              "z": 0.661
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8135fef51c8d51aa1fca740c",
            "leftCorner": {
              "x": -35.275,
              "y": -24.449,
              "z": 0.661
            },
            "rightCorner": {
              "x": -35.276,
              "y": -24.311,
              "z": 0.661
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "386fa2b4e3c26586f4ec3463",
            "leftCorner": {
              "x": -35.276,
              "y": -24.311,
              "z": 0.661
            },
            "rightCorner": {
              "x": -35.277,
              "y": -24.173,
              "z": 0.661
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9fcb05a7856600853b43d48a",
            "leftCorner": {
              "x": -35.277,
              "y": -24.173,
              "z": 0.661
            },
            "rightCorner": {
              "x": -35.279,
              "y": -24.034,
              "z": 0.661
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6c3ed0ed26fb03ad17099c7f",
            "leftCorner": {
              "x": -35.279,
              "y": -24.034,
              "z": 0.661
            },
            "rightCorner": {
              "x": -35.28,
              "y": -23.896,
              "z": 0.661
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7df",
        "height": 1.1303,
        "facings": [
          {
            "id": "e0871fb890c36b8e30b35237",
            "leftCorner": {
              "x": -35.284,
              "y": -24.588,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.285,
              "y": -24.449,
              "z": 0.925
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0f1509d349bc4456b81bfbe4",
            "leftCorner": {
              "x": -35.285,
              "y": -24.449,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.286,
              "y": -24.311,
              "z": 0.925
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d1037da67ba8b57193368b53",
            "leftCorner": {
              "x": -35.286,
              "y": -24.311,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.287,
              "y": -24.173,
              "z": 0.925
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "69b7755b6cfc81b1e91b7b3f",
            "leftCorner": {
              "x": -35.287,
              "y": -24.173,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.289,
              "y": -24.035,
              "z": 0.925
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e35ad6a50f2e2839dd6eec26",
            "leftCorner": {
              "x": -35.289,
              "y": -24.035,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.29,
              "y": -23.897,
              "z": 0.925
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7de",
        "height": 1.4394,
        "facings": [
          {
            "id": "98374d81d6e1fb7546963160",
            "leftCorner": {
              "x": -35.278,
              "y": -24.587,
              "z": 1.178
            },
            "rightCorner": {
              "x": -35.279,
              "y": -24.449,
              "z": 1.178
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6467c060ecf748b498d62eb3",
            "leftCorner": {
              "x": -35.279,
              "y": -24.449,
              "z": 1.178
            },
            "rightCorner": {
              "x": -35.28,
              "y": -24.311,
              "z": 1.178
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4523e464101160c2c41753f7",
            "leftCorner": {
              "x": -35.28,
              "y": -24.311,
              "z": 1.178
            },
            "rightCorner": {
              "x": -35.281,
              "y": -24.173,
              "z": 1.178
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cd9ad11f9359b1e88939e144",
            "leftCorner": {
              "x": -35.281,
              "y": -24.173,
              "z": 1.178
            },
            "rightCorner": {
              "x": -35.283,
              "y": -24.034,
              "z": 1.178
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fb42fbf54fa034c57a581949",
            "leftCorner": {
              "x": -35.283,
              "y": -24.034,
              "z": 1.178
            },
            "rightCorner": {
              "x": -35.284,
              "y": -23.896,
              "z": 1.178
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7da",
        "height": 1.7603,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8bff",
            "leftCorner": {
              "x": -35.263,
              "y": -24.588,
              "z": 1.44
            },
            "rightCorner": {
              "x": -35.265,
              "y": -24.303,
              "z": 1.44
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "04aabc1d52edabab7041090b",
            "leftCorner": {
              "x": -35.265,
              "y": -24.303,
              "z": 1.44
            },
            "rightCorner": {
              "x": -35.266,
              "y": -24.165,
              "z": 1.44
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bfe1d2fc932bd28a71d1d2e8",
            "leftCorner": {
              "x": -35.266,
              "y": -24.165,
              "z": 1.44
            },
            "rightCorner": {
              "x": -35.268,
              "y": -24.027,
              "z": 1.44
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ca56840f6c8c24eca0d89cc3",
            "leftCorner": {
              "x": -35.268,
              "y": -24.027,
              "z": 1.44
            },
            "rightCorner": {
              "x": -35.269,
              "y": -23.889,
              "z": 1.44
            },
            "gtin": "8710438121636",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "abb"
  },
  {
    "id": "abb",
    "name": "abb",
    "x": -35.168,
    "y": -25.386,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70994,
      "w": 0.70426
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d34c",
        "height": 0.44551,
        "facings": [
          {
            "id": "8d595fbf83a885472491c279",
            "leftCorner": {
              "x": -35.238,
              "y": -25.386,
              "z": 0.365
            },
            "rightCorner": {
              "x": -35.239,
              "y": -25.258,
              "z": 0.365
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "772961293536b58350d7daf7",
            "leftCorner": {
              "x": -35.239,
              "y": -25.258,
              "z": 0.365
            },
            "rightCorner": {
              "x": -35.24,
              "y": -25.131,
              "z": 0.365
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "51bf397f57893fa298d1c188",
            "leftCorner": {
              "x": -35.24,
              "y": -25.131,
              "z": 0.365
            },
            "rightCorner": {
              "x": -35.241,
              "y": -25.003,
              "z": 0.365
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8a3c26b13138fb498307e098",
            "leftCorner": {
              "x": -35.241,
              "y": -25.003,
              "z": 0.365
            },
            "rightCorner": {
              "x": -35.242,
              "y": -24.875,
              "z": 0.365
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ea0aed96650289b18cfaa1b8",
            "leftCorner": {
              "x": -35.242,
              "y": -24.875,
              "z": 0.365
            },
            "rightCorner": {
              "x": -35.243,
              "y": -24.747,
              "z": 0.365
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "91f0fb0fb5bb36794e19cbc5",
            "leftCorner": {
              "x": -35.243,
              "y": -24.747,
              "z": 0.365
            },
            "rightCorner": {
              "x": -35.244,
              "y": -24.62,
              "z": 0.365
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d346",
        "height": 0.65249,
        "facings": [
          {
            "id": "bef5d9258e248ca4514c1e52",
            "leftCorner": {
              "x": -35.269,
              "y": -25.387,
              "z": 0.534
            },
            "rightCorner": {
              "x": -35.27,
              "y": -25.259,
              "z": 0.534
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2e9be4c51e06e4125fdecfd0",
            "leftCorner": {
              "x": -35.27,
              "y": -25.259,
              "z": 0.534
            },
            "rightCorner": {
              "x": -35.271,
              "y": -25.132,
              "z": 0.534
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "acfcf6602ff30b4753a5aae5",
            "leftCorner": {
              "x": -35.271,
              "y": -25.132,
              "z": 0.534
            },
            "rightCorner": {
              "x": -35.272,
              "y": -25.004,
              "z": 0.534
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "309d246f5d1c9946f8c5ba02",
            "leftCorner": {
              "x": -35.272,
              "y": -25.004,
              "z": 0.534
            },
            "rightCorner": {
              "x": -35.273,
              "y": -24.876,
              "z": 0.534
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "807eb8b7f57f5ef8a487be92",
            "leftCorner": {
              "x": -35.273,
              "y": -24.876,
              "z": 0.534
            },
            "rightCorner": {
              "x": -35.274,
              "y": -24.748,
              "z": 0.534
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6152a5e8b5884c6b388074e4",
            "leftCorner": {
              "x": -35.274,
              "y": -24.748,
              "z": 0.534
            },
            "rightCorner": {
              "x": -35.275,
              "y": -24.621,
              "z": 0.534
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d345",
        "height": 0.85887,
        "facings": [
          {
            "id": "d9f873d4800d2a1917bd63f9",
            "leftCorner": {
              "x": -35.266,
              "y": -25.387,
              "z": 0.703
            },
            "rightCorner": {
              "x": -35.267,
              "y": -25.259,
              "z": 0.703
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e8e5fc80c20869efb8bb375b",
            "leftCorner": {
              "x": -35.267,
              "y": -25.259,
              "z": 0.703
            },
            "rightCorner": {
              "x": -35.268,
              "y": -25.131,
              "z": 0.703
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8366756b24f33abdd9f9dc32",
            "leftCorner": {
              "x": -35.268,
              "y": -25.131,
              "z": 0.703
            },
            "rightCorner": {
              "x": -35.269,
              "y": -25.004,
              "z": 0.703
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d8aa89ca54a29c2f19629720",
            "leftCorner": {
              "x": -35.269,
              "y": -25.004,
              "z": 0.703
            },
            "rightCorner": {
              "x": -35.27,
              "y": -24.876,
              "z": 0.703
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "abfdd7b3eada05ed175a0be8",
            "leftCorner": {
              "x": -35.27,
              "y": -24.876,
              "z": 0.703
            },
            "rightCorner": {
              "x": -35.271,
              "y": -24.748,
              "z": 0.703
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "26f9c07b8b60877ec8500429",
            "leftCorner": {
              "x": -35.271,
              "y": -24.748,
              "z": 0.703
            },
            "rightCorner": {
              "x": -35.272,
              "y": -24.62,
              "z": 0.703
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d349",
        "height": 1.1304,
        "facings": [
          {
            "id": "675ba4bfdc69da863783beb6",
            "leftCorner": {
              "x": -35.271,
              "y": -25.387,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.272,
              "y": -25.259,
              "z": 0.925
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "59df2f0c98ce87b7b566f442",
            "leftCorner": {
              "x": -35.272,
              "y": -25.259,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.273,
              "y": -25.132,
              "z": 0.925
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0a3adfdb786497ad92c9fd07",
            "leftCorner": {
              "x": -35.273,
              "y": -25.132,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.274,
              "y": -25.004,
              "z": 0.925
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a916d314ba90e3358480cd3f",
            "leftCorner": {
              "x": -35.274,
              "y": -25.004,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.275,
              "y": -24.876,
              "z": 0.925
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d5ee41abfc3c8c471caaacd3",
            "leftCorner": {
              "x": -35.275,
              "y": -24.876,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.276,
              "y": -24.749,
              "z": 0.925
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2a0548ee4381f0bfe3d0c803",
            "leftCorner": {
              "x": -35.276,
              "y": -24.749,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.277,
              "y": -24.621,
              "z": 0.925
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d34d",
        "height": 1.3729,
        "facings": [
          {
            "id": "50d15e827c6301fb2323f27b",
            "leftCorner": {
              "x": -35.191,
              "y": -25.386,
              "z": 1.123
            },
            "rightCorner": {
              "x": -35.192,
              "y": -25.259,
              "z": 1.123
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4951fed13577fcdef1f44d90",
            "leftCorner": {
              "x": -35.192,
              "y": -25.259,
              "z": 1.123
            },
            "rightCorner": {
              "x": -35.193,
              "y": -25.131,
              "z": 1.123
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ef31e9f6c5bb339c669236ed",
            "leftCorner": {
              "x": -35.193,
              "y": -25.131,
              "z": 1.123
            },
            "rightCorner": {
              "x": -35.194,
              "y": -25.003,
              "z": 1.123
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c4add9cda3d7564c2eca031c",
            "leftCorner": {
              "x": -35.194,
              "y": -25.003,
              "z": 1.123
            },
            "rightCorner": {
              "x": -35.195,
              "y": -24.876,
              "z": 1.123
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "90730b82eabaa0f4a1cea205",
            "leftCorner": {
              "x": -35.195,
              "y": -24.876,
              "z": 1.123
            },
            "rightCorner": {
              "x": -35.196,
              "y": -24.748,
              "z": 1.123
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ad5917b27b9c3c36a713e025",
            "leftCorner": {
              "x": -35.196,
              "y": -24.748,
              "z": 1.123
            },
            "rightCorner": {
              "x": -35.197,
              "y": -24.62,
              "z": 1.123
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d34b",
        "height": 1.6342,
        "facings": [
          {
            "id": "9474bf13f49ca14a612ce030",
            "leftCorner": {
              "x": -35.258,
              "y": -25.386,
              "z": 1.337
            },
            "rightCorner": {
              "x": -35.259,
              "y": -25.259,
              "z": 1.337
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c0f312831226639c8ca6b5ea",
            "leftCorner": {
              "x": -35.259,
              "y": -25.259,
              "z": 1.337
            },
            "rightCorner": {
              "x": -35.26,
              "y": -25.131,
              "z": 1.337
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9dfc64c3544c0e4c9cd77182",
            "leftCorner": {
              "x": -35.26,
              "y": -25.131,
              "z": 1.337
            },
            "rightCorner": {
              "x": -35.261,
              "y": -25.003,
              "z": 1.337
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4e4a3322ab03b902ace5f1d2",
            "leftCorner": {
              "x": -35.261,
              "y": -25.003,
              "z": 1.337
            },
            "rightCorner": {
              "x": -35.262,
              "y": -24.875,
              "z": 1.337
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fb4b3ff5979565d97bf88404",
            "leftCorner": {
              "x": -35.262,
              "y": -24.875,
              "z": 1.337
            },
            "rightCorner": {
              "x": -35.263,
              "y": -24.748,
              "z": 1.337
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2c4fdc1466c32961dff622df",
            "leftCorner": {
              "x": -35.263,
              "y": -24.748,
              "z": 1.337
            },
            "rightCorner": {
              "x": -35.264,
              "y": -24.62,
              "z": 1.337
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d34a",
        "height": 1.8609,
        "facings": [
          {
            "id": "55ad4b88c009c08e8c0ae683",
            "leftCorner": {
              "x": -35.286,
              "y": -25.387,
              "z": 1.523
            },
            "rightCorner": {
              "x": -35.287,
              "y": -25.259,
              "z": 1.523
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee120cd871e90eea88635c11",
            "leftCorner": {
              "x": -35.287,
              "y": -25.259,
              "z": 1.523
            },
            "rightCorner": {
              "x": -35.288,
              "y": -25.132,
              "z": 1.523
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8c234a896add3079aa437c41",
            "leftCorner": {
              "x": -35.288,
              "y": -25.132,
              "z": 1.523
            },
            "rightCorner": {
              "x": -35.289,
              "y": -25.004,
              "z": 1.523
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6af4a20ef1823cb72439600a",
            "leftCorner": {
              "x": -35.289,
              "y": -25.004,
              "z": 1.523
            },
            "rightCorner": {
              "x": -35.29,
              "y": -24.876,
              "z": 1.523
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "acdd6be773a0a8634d7b29d0",
            "leftCorner": {
              "x": -35.29,
              "y": -24.876,
              "z": 1.523
            },
            "rightCorner": {
              "x": -35.291,
              "y": -24.748,
              "z": 1.523
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cf2bb79305ca73be176f2154",
            "leftCorner": {
              "x": -35.291,
              "y": -24.748,
              "z": 1.523
            },
            "rightCorner": {
              "x": -35.292,
              "y": -24.621,
              "z": 1.523
            },
            "gtin": "4250241202886",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "abc",
    "rightNeighborShelfId": "aba"
  },
  {
    "id": "abc",
    "name": "abc",
    "x": -35.162,
    "y": -26.186,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70994,
      "w": 0.70426
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 28
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d342",
        "height": 0.45057,
        "facings": [
          {
            "id": "578991e28fa9e4f75b1bc875",
            "leftCorner": {
              "x": -35.231,
              "y": -26.187,
              "z": 0.369
            },
            "rightCorner": {
              "x": -35.232,
              "y": -26.014,
              "z": 0.369
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fc9badca1c5574b9229601f3",
            "leftCorner": {
              "x": -35.232,
              "y": -26.014,
              "z": 0.369
            },
            "rightCorner": {
              "x": -35.234,
              "y": -25.84,
              "z": 0.369
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8bcd7f18744a6508dd68bb07",
            "leftCorner": {
              "x": -35.234,
              "y": -25.84,
              "z": 0.369
            },
            "rightCorner": {
              "x": -35.235,
              "y": -25.667,
              "z": 0.369
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "427de02fedcf8df090439fae",
            "leftCorner": {
              "x": -35.235,
              "y": -25.667,
              "z": 0.369
            },
            "rightCorner": {
              "x": -35.237,
              "y": -25.494,
              "z": 0.369
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d33f",
        "height": 0.65702,
        "facings": [
          {
            "id": "cacd9d634d5bc4040ce76e65",
            "leftCorner": {
              "x": -35.259,
              "y": -26.187,
              "z": 0.538
            },
            "rightCorner": {
              "x": -35.26,
              "y": -26.014,
              "z": 0.538
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "16063f06141fabd930921a32",
            "leftCorner": {
              "x": -35.26,
              "y": -26.014,
              "z": 0.538
            },
            "rightCorner": {
              "x": -35.262,
              "y": -25.841,
              "z": 0.538
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "98ac4732be4080f5ac085ddb",
            "leftCorner": {
              "x": -35.262,
              "y": -25.841,
              "z": 0.538
            },
            "rightCorner": {
              "x": -35.263,
              "y": -25.667,
              "z": 0.538
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "954aa219c2ff690039201e93",
            "leftCorner": {
              "x": -35.263,
              "y": -25.667,
              "z": 0.538
            },
            "rightCorner": {
              "x": -35.265,
              "y": -25.494,
              "z": 0.538
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d33e",
        "height": 0.90715,
        "facings": [
          {
            "id": "d12a9466fd2944d4b44c1f2c",
            "leftCorner": {
              "x": -35.167,
              "y": -26.186,
              "z": 0.742
            },
            "rightCorner": {
              "x": -35.168,
              "y": -26.013,
              "z": 0.742
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9f8260f1de5e79677e642768",
            "leftCorner": {
              "x": -35.168,
              "y": -26.013,
              "z": 0.742
            },
            "rightCorner": {
              "x": -35.17,
              "y": -25.839,
              "z": 0.742
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1cc0aefe856486fb53e29651",
            "leftCorner": {
              "x": -35.17,
              "y": -25.839,
              "z": 0.742
            },
            "rightCorner": {
              "x": -35.171,
              "y": -25.666,
              "z": 0.742
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c0ec6b59603aeee5d23a728b",
            "leftCorner": {
              "x": -35.171,
              "y": -25.666,
              "z": 0.742
            },
            "rightCorner": {
              "x": -35.173,
              "y": -25.493,
              "z": 0.742
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d33c",
        "height": 1.1368,
        "facings": [
          {
            "id": "e807499fd482aa373be8f144",
            "leftCorner": {
              "x": -35.257,
              "y": -26.187,
              "z": 0.93
            },
            "rightCorner": {
              "x": -35.258,
              "y": -26.014,
              "z": 0.93
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e480dac9ed6bcfabaaa18640",
            "leftCorner": {
              "x": -35.258,
              "y": -26.014,
              "z": 0.93
            },
            "rightCorner": {
              "x": -35.26,
              "y": -25.841,
              "z": 0.93
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "07fac71e1a0d311fd1d59cab",
            "leftCorner": {
              "x": -35.26,
              "y": -25.841,
              "z": 0.93
            },
            "rightCorner": {
              "x": -35.261,
              "y": -25.667,
              "z": 0.93
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3918ec8ad934b17634fbf9ee",
            "leftCorner": {
              "x": -35.261,
              "y": -25.667,
              "z": 0.93
            },
            "rightCorner": {
              "x": -35.263,
              "y": -25.494,
              "z": 0.93
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d33b",
        "height": 1.3891,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6f8f",
            "leftCorner": {
              "x": -35.284,
              "y": -25.609,
              "z": 1.137
            },
            "rightCorner": {
              "x": -35.286,
              "y": -25.387,
              "z": 1.137
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "93135113e6c0d8ac578dab74",
            "leftCorner": {
              "x": -35.238,
              "y": -26.187,
              "z": 1.137
            },
            "rightCorner": {
              "x": -35.239,
              "y": -26.014,
              "z": 1.137
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7a9c400a8b71c919d2672280",
            "leftCorner": {
              "x": -35.239,
              "y": -26.014,
              "z": 1.137
            },
            "rightCorner": {
              "x": -35.241,
              "y": -25.84,
              "z": 1.137
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cc16ddfea64990e52e13a762",
            "leftCorner": {
              "x": -35.241,
              "y": -25.84,
              "z": 1.137
            },
            "rightCorner": {
              "x": -35.242,
              "y": -25.667,
              "z": 1.137
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d340",
        "height": 1.6394,
        "facings": [
          {
            "id": "cf30c67c8592f40a39c3f932",
            "leftCorner": {
              "x": -35.251,
              "y": -26.187,
              "z": 1.341
            },
            "rightCorner": {
              "x": -35.252,
              "y": -26.014,
              "z": 1.341
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "71b17e5e433cfd4023fb1ec7",
            "leftCorner": {
              "x": -35.252,
              "y": -26.014,
              "z": 1.341
            },
            "rightCorner": {
              "x": -35.254,
              "y": -25.84,
              "z": 1.341
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5467de0b140088cc3b19b951",
            "leftCorner": {
              "x": -35.254,
              "y": -25.84,
              "z": 1.341
            },
            "rightCorner": {
              "x": -35.255,
              "y": -25.667,
              "z": 1.341
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c4d18a403218600e135aa5fd",
            "leftCorner": {
              "x": -35.255,
              "y": -25.667,
              "z": 1.341
            },
            "rightCorner": {
              "x": -35.257,
              "y": -25.494,
              "z": 1.341
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d33d",
        "height": 1.8596,
        "facings": [
          {
            "id": "dd8d32f8e8f0a97fb8890322",
            "leftCorner": {
              "x": -35.249,
              "y": -26.187,
              "z": 1.521
            },
            "rightCorner": {
              "x": -35.25,
              "y": -26.014,
              "z": 1.521
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c20b24be61071409e5097f82",
            "leftCorner": {
              "x": -35.25,
              "y": -26.014,
              "z": 1.521
            },
            "rightCorner": {
              "x": -35.252,
              "y": -25.84,
              "z": 1.521
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c9ac3b3be06a8e212821cf83",
            "leftCorner": {
              "x": -35.252,
              "y": -25.84,
              "z": 1.521
            },
            "rightCorner": {
              "x": -35.253,
              "y": -25.667,
              "z": 1.521
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "97e77fdc38df7348e7744fa3",
            "leftCorner": {
              "x": -35.253,
              "y": -25.667,
              "z": 1.521
            },
            "rightCorner": {
              "x": -35.255,
              "y": -25.494,
              "z": 1.521
            },
            "gtin": "4250241208642",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "abd",
    "rightNeighborShelfId": "abb"
  },
  {
    "id": "abd",
    "name": "abd",
    "x": -35.155,
    "y": -26.985,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70994,
      "w": 0.70426
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d335",
        "height": 0.45188,
        "facings": [
          {
            "id": "e447b22cc31ad26e26ee7549",
            "leftCorner": {
              "x": -35.214,
              "y": -26.986,
              "z": 0.37
            },
            "rightCorner": {
              "x": -35.215,
              "y": -26.833,
              "z": 0.37
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f7a648f49704d5d3608c607d",
            "leftCorner": {
              "x": -35.215,
              "y": -26.833,
              "z": 0.37
            },
            "rightCorner": {
              "x": -35.216,
              "y": -26.68,
              "z": 0.37
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d71bf92b9d7cbfb9e9a8ae65",
            "leftCorner": {
              "x": -35.216,
              "y": -26.68,
              "z": 0.37
            },
            "rightCorner": {
              "x": -35.218,
              "y": -26.521,
              "z": 0.37
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "027125f1e54e7d8915675820",
            "leftCorner": {
              "x": -35.218,
              "y": -26.521,
              "z": 0.37
            },
            "rightCorner": {
              "x": -35.219,
              "y": -26.369,
              "z": 0.37
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5ae6ca832ffc582232d12185",
            "leftCorner": {
              "x": -35.219,
              "y": -26.369,
              "z": 0.37
            },
            "rightCorner": {
              "x": -35.22,
              "y": -26.21,
              "z": 0.37
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d337",
        "height": 0.65974,
        "facings": [
          {
            "id": "ffd0e1905f6c23bfba71650f",
            "leftCorner": {
              "x": -35.242,
              "y": -26.986,
              "z": 0.54
            },
            "rightCorner": {
              "x": -35.243,
              "y": -26.833,
              "z": 0.54
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "25cd929da62b53b62b17dfa2",
            "leftCorner": {
              "x": -35.243,
              "y": -26.833,
              "z": 0.54
            },
            "rightCorner": {
              "x": -35.244,
              "y": -26.674,
              "z": 0.54
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d2e13d124cacbe5a752ac178",
            "leftCorner": {
              "x": -35.244,
              "y": -26.674,
              "z": 0.54
            },
            "rightCorner": {
              "x": -35.246,
              "y": -26.522,
              "z": 0.54
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f67d8884c602bfb414e2a7cf",
            "leftCorner": {
              "x": -35.246,
              "y": -26.522,
              "z": 0.54
            },
            "rightCorner": {
              "x": -35.247,
              "y": -26.363,
              "z": 0.54
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0151c939d63f3219e09cccbc",
            "leftCorner": {
              "x": -35.247,
              "y": -26.363,
              "z": 0.54
            },
            "rightCorner": {
              "x": -35.248,
              "y": -26.204,
              "z": 0.54
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d336",
        "height": 0.9068,
        "facings": [
          {
            "id": "452761741586c64f15e6bc23",
            "leftCorner": {
              "x": -35.15,
              "y": -26.985,
              "z": 0.742
            },
            "rightCorner": {
              "x": -35.153,
              "y": -26.643,
              "z": 0.742
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cb16b2c329857bbf34dc5c1d",
            "leftCorner": {
              "x": -35.153,
              "y": -26.643,
              "z": 0.742
            },
            "rightCorner": {
              "x": -35.155,
              "y": -26.302,
              "z": 0.742
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "446adbe5d331fd38cb715ea3",
            "leftCorner": {
              "x": -35.155,
              "y": -26.302,
              "z": 0.742
            },
            "rightCorner": {
              "x": -35.156,
              "y": -26.225,
              "z": 0.742
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d338",
        "height": 1.1318,
        "facings": [
          {
            "id": "b0cdb1778d86e702e1ea768b",
            "leftCorner": {
              "x": -35.237,
              "y": -26.986,
              "z": 0.926
            },
            "rightCorner": {
              "x": -35.238,
              "y": -26.833,
              "z": 0.926
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "218175b49f0f57a95da88526",
            "leftCorner": {
              "x": -35.238,
              "y": -26.833,
              "z": 0.926
            },
            "rightCorner": {
              "x": -35.239,
              "y": -26.681,
              "z": 0.926
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "28f104a484cd42ce792fa71d",
            "leftCorner": {
              "x": -35.239,
              "y": -26.681,
              "z": 0.926
            },
            "rightCorner": {
              "x": -35.241,
              "y": -26.522,
              "z": 0.926
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0e2996d903376ba096d1a753",
            "leftCorner": {
              "x": -35.241,
              "y": -26.522,
              "z": 0.926
            },
            "rightCorner": {
              "x": -35.242,
              "y": -26.369,
              "z": 0.926
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0ca0aad8bb38099cc437a492",
            "leftCorner": {
              "x": -35.242,
              "y": -26.369,
              "z": 0.926
            },
            "rightCorner": {
              "x": -35.243,
              "y": -26.21,
              "z": 0.926
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d339",
        "height": 1.3909,
        "facings": [
          {
            "id": "c0a1b813986540694ca08961",
            "leftCorner": {
              "x": -35.22,
              "y": -26.986,
              "z": 1.138
            },
            "rightCorner": {
              "x": -35.221,
              "y": -26.833,
              "z": 1.138
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bb194c34466333c139042eaf",
            "leftCorner": {
              "x": -35.221,
              "y": -26.833,
              "z": 1.138
            },
            "rightCorner": {
              "x": -35.222,
              "y": -26.674,
              "z": 1.138
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "55449a82cdb9f8af19d83df8",
            "leftCorner": {
              "x": -35.222,
              "y": -26.674,
              "z": 1.138
            },
            "rightCorner": {
              "x": -35.224,
              "y": -26.521,
              "z": 1.138
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f22708a997a67b76f6b6ff00",
            "leftCorner": {
              "x": -35.224,
              "y": -26.521,
              "z": 1.138
            },
            "rightCorner": {
              "x": -35.225,
              "y": -26.362,
              "z": 1.138
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "03088a11dc49a353632fda26",
            "leftCorner": {
              "x": -35.225,
              "y": -26.362,
              "z": 1.138
            },
            "rightCorner": {
              "x": -35.226,
              "y": -26.203,
              "z": 1.138
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d333",
        "height": 1.6295,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6f50",
            "leftCorner": {
              "x": -35.27,
              "y": -26.356,
              "z": 1.333
            },
            "rightCorner": {
              "x": -35.271,
              "y": -26.187,
              "z": 1.333
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9d44e8c36da936a32180278a",
            "leftCorner": {
              "x": -35.231,
              "y": -26.986,
              "z": 1.333
            },
            "rightCorner": {
              "x": -35.232,
              "y": -26.833,
              "z": 1.333
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "47a738cef73dc4555bb13c71",
            "leftCorner": {
              "x": -35.232,
              "y": -26.833,
              "z": 1.333
            },
            "rightCorner": {
              "x": -35.233,
              "y": -26.681,
              "z": 1.333
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ba0ff2527a894430c9a73bf3",
            "leftCorner": {
              "x": -35.233,
              "y": -26.681,
              "z": 1.333
            },
            "rightCorner": {
              "x": -35.235,
              "y": -26.528,
              "z": 1.333
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c9e3c09f3b4a9d9a62c05561",
            "leftCorner": {
              "x": -35.235,
              "y": -26.528,
              "z": 1.333
            },
            "rightCorner": {
              "x": -35.236,
              "y": -26.375,
              "z": 1.333
            },
            "gtin": "4004155020278",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d334",
        "height": 1.8623,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6f5b",
            "leftCorner": {
              "x": -35.263,
              "y": -26.604,
              "z": 1.524
            },
            "rightCorner": {
              "x": -35.264,
              "y": -26.463,
              "z": 1.524
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c45f45c709e65efab7bddc1a",
            "leftCorner": {
              "x": -35.234,
              "y": -26.986,
              "z": 1.524
            },
            "rightCorner": {
              "x": -35.235,
              "y": -26.827,
              "z": 1.524
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "48c6d6272225b550eb1e96f4",
            "leftCorner": {
              "x": -35.235,
              "y": -26.827,
              "z": 1.524
            },
            "rightCorner": {
              "x": -35.237,
              "y": -26.668,
              "z": 1.524
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f43b415c1729ab1bd32ca152",
            "leftCorner": {
              "x": -35.238,
              "y": -26.463,
              "z": 1.524
            },
            "rightCorner": {
              "x": -35.239,
              "y": -26.304,
              "z": 1.524
            },
            "gtin": "4008366003303",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "abe",
    "rightNeighborShelfId": "abc"
  },
  {
    "id": "abe",
    "name": "abe",
    "x": -35.149,
    "y": -27.785,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70994,
      "w": 0.70426
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d32f",
        "height": 0.4469,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d32d",
        "height": 0.77367,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d32c",
        "height": 1.0045,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d332",
        "height": 1.4411,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d32b",
        "height": 1.8036,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "abf",
    "rightNeighborShelfId": "abd"
  },
  {
    "id": "abf",
    "name": "abf",
    "x": -35.142,
    "y": -28.585,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70994,
      "w": 0.70426
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d323",
        "height": 0.44322,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d327",
        "height": 0.67587,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d324",
        "height": 0.89465,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d325",
        "height": 1.1597,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d328",
        "height": 1.4767,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d329",
        "height": 1.7921,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "ac0",
    "rightNeighborShelfId": "abe"
  },
  {
    "id": "ac0",
    "name": "ac0",
    "x": -35.136,
    "y": -29.385,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70994,
      "w": 0.70426
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d31d",
        "height": 0.44412,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d31b",
        "height": 0.82225,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d31e",
        "height": 1.1462,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d31c",
        "height": 1.4525,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d31f",
        "height": 1.7786,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "ac1",
    "rightNeighborShelfId": "abf"
  },
  {
    "id": "ac1",
    "name": "ac1",
    "x": -35.13,
    "y": -30.185,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70994,
      "w": 0.70426
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 89
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d315",
        "height": 0.45778,
        "facings": [
          {
            "id": "7aa5bb30087dcaa3adca4cf7",
            "leftCorner": {
              "x": -35.24,
              "y": -30.185,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.24,
              "y": -30.142,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6ae1a7838c225843e0449071",
            "leftCorner": {
              "x": -35.24,
              "y": -30.142,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.241,
              "y": -30.099,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cc49c83602c9c85162ad77f0",
            "leftCorner": {
              "x": -35.241,
              "y": -30.099,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.241,
              "y": -30.056,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f0be009d50eea54fa31d9b7d",
            "leftCorner": {
              "x": -35.241,
              "y": -30.056,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.241,
              "y": -30.013,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "37548325dd1cb93380536ea1",
            "leftCorner": {
              "x": -35.241,
              "y": -30.013,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.242,
              "y": -29.97,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c45512e939a00ef40bb46f5d",
            "leftCorner": {
              "x": -35.242,
              "y": -29.97,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.242,
              "y": -29.927,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4e829372b3f6588a242485db",
            "leftCorner": {
              "x": -35.242,
              "y": -29.927,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.242,
              "y": -29.884,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "78552c7e657043b803322db8",
            "leftCorner": {
              "x": -35.242,
              "y": -29.884,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.243,
              "y": -29.841,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e4a06361f5fad685079dc859",
            "leftCorner": {
              "x": -35.243,
              "y": -29.841,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.243,
              "y": -29.798,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a5a9aa2f32a2fd298c006843",
            "leftCorner": {
              "x": -35.243,
              "y": -29.798,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.243,
              "y": -29.755,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "513e2f1a86315e654307c0c1",
            "leftCorner": {
              "x": -35.243,
              "y": -29.755,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.244,
              "y": -29.712,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "afe0e3321c67efa3fc13abd7",
            "leftCorner": {
              "x": -35.244,
              "y": -29.712,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.244,
              "y": -29.669,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c1398587c8537eb818a71180",
            "leftCorner": {
              "x": -35.244,
              "y": -29.669,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.244,
              "y": -29.626,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "94bf00a16d6144dbeea9a1bd",
            "leftCorner": {
              "x": -35.244,
              "y": -29.626,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.245,
              "y": -29.583,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c844b78f7c5386920355522b",
            "leftCorner": {
              "x": -35.245,
              "y": -29.583,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.245,
              "y": -29.54,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2e4785f7636f6aa0064b689f",
            "leftCorner": {
              "x": -35.245,
              "y": -29.54,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.246,
              "y": -29.497,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9b2fba64d4bfad4637e85e30",
            "leftCorner": {
              "x": -35.246,
              "y": -29.497,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.246,
              "y": -29.454,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e9579a243b1bd53c6ee713cb",
            "leftCorner": {
              "x": -35.246,
              "y": -29.454,
              "z": 0.375
            },
            "rightCorner": {
              "x": -35.246,
              "y": -29.411,
              "z": 0.375
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d314",
        "height": 0.82415,
        "facings": [
          {
            "id": "a142690cce32aeafc4989254",
            "leftCorner": {
              "x": -35.22,
              "y": -30.185,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.22,
              "y": -30.142,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "95b5334f93cb043bb806b36a",
            "leftCorner": {
              "x": -35.22,
              "y": -30.142,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.221,
              "y": -30.099,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "448c24b0327f4f93c649dcca",
            "leftCorner": {
              "x": -35.221,
              "y": -30.099,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.221,
              "y": -30.056,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4a09324b6d3ab26bf361b2fd",
            "leftCorner": {
              "x": -35.221,
              "y": -30.056,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.221,
              "y": -30.013,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8b7ff6b84fcb7980f2a6e04c",
            "leftCorner": {
              "x": -35.221,
              "y": -30.013,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.222,
              "y": -29.97,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ad417564703d4be1a2747b3b",
            "leftCorner": {
              "x": -35.222,
              "y": -29.97,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.222,
              "y": -29.927,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f75c153e30d2b89f12f85f2f",
            "leftCorner": {
              "x": -35.222,
              "y": -29.927,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.222,
              "y": -29.884,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0bddf4f19a60c8dbd4bf47cb",
            "leftCorner": {
              "x": -35.222,
              "y": -29.884,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.223,
              "y": -29.841,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2e1711d0541b857a356fbb19",
            "leftCorner": {
              "x": -35.223,
              "y": -29.841,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.223,
              "y": -29.798,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ac14a2127d6e44d2b4467382",
            "leftCorner": {
              "x": -35.223,
              "y": -29.798,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.223,
              "y": -29.755,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2ebe4ea182bda1847d22ecb0",
            "leftCorner": {
              "x": -35.223,
              "y": -29.755,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.224,
              "y": -29.712,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6e925a119c1c072a28e0ef50",
            "leftCorner": {
              "x": -35.224,
              "y": -29.712,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.224,
              "y": -29.669,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "94809fa84b159385c4fef946",
            "leftCorner": {
              "x": -35.224,
              "y": -29.669,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.224,
              "y": -29.626,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1f4b7f3e6e063480f1c40d4b",
            "leftCorner": {
              "x": -35.224,
              "y": -29.626,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.225,
              "y": -29.583,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3a2704288e02aca751b49a82",
            "leftCorner": {
              "x": -35.225,
              "y": -29.583,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.225,
              "y": -29.54,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c0c092d86d3c71cbf079c9f0",
            "leftCorner": {
              "x": -35.225,
              "y": -29.54,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.226,
              "y": -29.497,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6a3b9183b3fb032388352e6f",
            "leftCorner": {
              "x": -35.226,
              "y": -29.497,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.226,
              "y": -29.454,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "753b598fe69fd1b27a351300",
            "leftCorner": {
              "x": -35.226,
              "y": -29.454,
              "z": 0.674
            },
            "rightCorner": {
              "x": -35.226,
              "y": -29.411,
              "z": 0.674
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d313",
        "height": 1.1507,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6efa",
            "leftCorner": {
              "x": -35.261,
              "y": -29.545,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.261,
              "y": -29.487,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e2c18d90c1f86d2848de4567",
            "leftCorner": {
              "x": -35.225,
              "y": -30.185,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.225,
              "y": -30.142,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ff7bf23be85edd5accc7547a",
            "leftCorner": {
              "x": -35.225,
              "y": -30.142,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.226,
              "y": -30.099,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2f83fd95831ea9daedf6bb09",
            "leftCorner": {
              "x": -35.226,
              "y": -30.099,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.226,
              "y": -30.056,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "23d7531d5129f41c9fac2b02",
            "leftCorner": {
              "x": -35.226,
              "y": -30.056,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.226,
              "y": -30.013,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "447b555ec71d4e6b2468d831",
            "leftCorner": {
              "x": -35.226,
              "y": -30.013,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.227,
              "y": -29.97,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ca53067af63290b83fd9b5d7",
            "leftCorner": {
              "x": -35.227,
              "y": -29.97,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.227,
              "y": -29.927,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "96e43ead358a993fdc479023",
            "leftCorner": {
              "x": -35.227,
              "y": -29.927,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.227,
              "y": -29.884,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dcd5731aa39b15bff69fe781",
            "leftCorner": {
              "x": -35.227,
              "y": -29.884,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.228,
              "y": -29.841,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6d618282e15bd7cedccc3a33",
            "leftCorner": {
              "x": -35.228,
              "y": -29.841,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.228,
              "y": -29.798,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9bfbdf4b7db2dd6744ad1bd4",
            "leftCorner": {
              "x": -35.228,
              "y": -29.798,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.228,
              "y": -29.755,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d1da5139988324a8d1da9008",
            "leftCorner": {
              "x": -35.228,
              "y": -29.755,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.229,
              "y": -29.712,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "19981afc420a748202245740",
            "leftCorner": {
              "x": -35.229,
              "y": -29.712,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.229,
              "y": -29.669,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a3f84cbfb5dd9ebda041eaea",
            "leftCorner": {
              "x": -35.229,
              "y": -29.669,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.229,
              "y": -29.626,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4edd147a6e58f7e1df781e3d",
            "leftCorner": {
              "x": -35.229,
              "y": -29.626,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.23,
              "y": -29.583,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8f54fb8903c3d27dfab13d35",
            "leftCorner": {
              "x": -35.231,
              "y": -29.487,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.231,
              "y": -29.444,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "178c7edb9c577f67741cf4bd",
            "leftCorner": {
              "x": -35.231,
              "y": -29.444,
              "z": 0.941
            },
            "rightCorner": {
              "x": -35.231,
              "y": -29.401,
              "z": 0.941
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d317",
        "height": 1.4591,
        "facings": [
          {
            "id": "1119f898a73c83fc10f3177c",
            "leftCorner": {
              "x": -35.277,
              "y": -30.186,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.277,
              "y": -30.143,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "93c34cc4c868b084bb7bca2e",
            "leftCorner": {
              "x": -35.277,
              "y": -30.143,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.278,
              "y": -30.1,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5bb02d1a92047f8621eaa30a",
            "leftCorner": {
              "x": -35.278,
              "y": -30.1,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.278,
              "y": -30.057,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "42091da0dc7c72bbcbcf1f0c",
            "leftCorner": {
              "x": -35.278,
              "y": -30.057,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.278,
              "y": -30.014,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "84e7da09af55e0ff94b2ee09",
            "leftCorner": {
              "x": -35.278,
              "y": -30.014,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.279,
              "y": -29.971,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "de4fbd2768cbe1e6cb0b8a06",
            "leftCorner": {
              "x": -35.279,
              "y": -29.971,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.279,
              "y": -29.928,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f2c279ed90485e1d0b693f3a",
            "leftCorner": {
              "x": -35.279,
              "y": -29.928,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.279,
              "y": -29.885,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2f138d81ed25d917b119a2fb",
            "leftCorner": {
              "x": -35.279,
              "y": -29.885,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.28,
              "y": -29.842,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "565af608154a13a641b7255c",
            "leftCorner": {
              "x": -35.28,
              "y": -29.842,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.28,
              "y": -29.799,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6f264a23123c3e99b19ddacc",
            "leftCorner": {
              "x": -35.28,
              "y": -29.799,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.28,
              "y": -29.756,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "123abb43f78ca4ea5f214d9c",
            "leftCorner": {
              "x": -35.28,
              "y": -29.756,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.281,
              "y": -29.713,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9b4b7d638c23eca48ab8796a",
            "leftCorner": {
              "x": -35.281,
              "y": -29.713,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.281,
              "y": -29.67,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "63446f87489c4577aa1a75a7",
            "leftCorner": {
              "x": -35.281,
              "y": -29.67,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.281,
              "y": -29.627,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6edf822c87a916b730cfe16a",
            "leftCorner": {
              "x": -35.281,
              "y": -29.627,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.282,
              "y": -29.584,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6e2a9b752175d99a67bfbea6",
            "leftCorner": {
              "x": -35.282,
              "y": -29.584,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.282,
              "y": -29.541,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c90c0fe5cf2ba55072ab6284",
            "leftCorner": {
              "x": -35.282,
              "y": -29.541,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.283,
              "y": -29.498,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b02b344ce919551899a148fc",
            "leftCorner": {
              "x": -35.283,
              "y": -29.498,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.283,
              "y": -29.455,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "510ce9d50eaa831e5874face",
            "leftCorner": {
              "x": -35.283,
              "y": -29.455,
              "z": 1.194
            },
            "rightCorner": {
              "x": -35.283,
              "y": -29.412,
              "z": 1.194
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d318",
        "height": 1.7829,
        "facings": [
          {
            "id": "b88fc7d4aeee4834b4e50630",
            "leftCorner": {
              "x": -35.247,
              "y": -30.185,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.247,
              "y": -30.142,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ab2fdf75cc816f845b21e8e3",
            "leftCorner": {
              "x": -35.247,
              "y": -30.142,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.248,
              "y": -30.099,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c048ac930ba8f4aa830ec655",
            "leftCorner": {
              "x": -35.248,
              "y": -30.099,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.248,
              "y": -30.056,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "56112fc2120d3542fdb9c165",
            "leftCorner": {
              "x": -35.248,
              "y": -30.056,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.248,
              "y": -30.013,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "52c2174ed9a5728a62c16436",
            "leftCorner": {
              "x": -35.248,
              "y": -30.013,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.249,
              "y": -29.97,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a69a10ae8b7b3b26cadad859",
            "leftCorner": {
              "x": -35.249,
              "y": -29.97,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.249,
              "y": -29.927,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d4ecc043a0aed7f522b88e67",
            "leftCorner": {
              "x": -35.249,
              "y": -29.927,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.249,
              "y": -29.884,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1d2ab12e78990a6c44443ef0",
            "leftCorner": {
              "x": -35.249,
              "y": -29.884,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.25,
              "y": -29.841,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a7b9a03324d60a2380794874",
            "leftCorner": {
              "x": -35.25,
              "y": -29.841,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.25,
              "y": -29.798,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "79f5c624c0d7dd0ef9133194",
            "leftCorner": {
              "x": -35.25,
              "y": -29.798,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.25,
              "y": -29.755,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dd3a832bab7d3f6b23f830c6",
            "leftCorner": {
              "x": -35.25,
              "y": -29.755,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.251,
              "y": -29.712,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b2c72a699b46f17c1c24044e",
            "leftCorner": {
              "x": -35.251,
              "y": -29.712,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.251,
              "y": -29.669,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b1f029d0c69d2f2d5addafdb",
            "leftCorner": {
              "x": -35.251,
              "y": -29.669,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.251,
              "y": -29.626,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "73f20ae748c07405b4f899cd",
            "leftCorner": {
              "x": -35.251,
              "y": -29.626,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.252,
              "y": -29.583,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1e9a25762471e34ea46522ed",
            "leftCorner": {
              "x": -35.252,
              "y": -29.583,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.252,
              "y": -29.54,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7967bec6fc9f8eb3b07f71dd",
            "leftCorner": {
              "x": -35.252,
              "y": -29.54,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.253,
              "y": -29.497,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3c6f920746a6ef0b5c4632d3",
            "leftCorner": {
              "x": -35.253,
              "y": -29.497,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.253,
              "y": -29.454,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "789088a949135f1a8a34732b",
            "leftCorner": {
              "x": -35.253,
              "y": -29.454,
              "z": 1.459
            },
            "rightCorner": {
              "x": -35.253,
              "y": -29.411,
              "z": 1.459
            },
            "gtin": "4008577006223",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ac2",
    "rightNeighborShelfId": "ac0"
  },
  {
    "id": "ac2",
    "name": "ac2",
    "x": -35.123,
    "y": -30.985,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70994,
      "w": 0.70426
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d30e",
        "height": 0.44885,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d30d",
        "height": 0.7449,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d311",
        "height": 1.0488,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d30f",
        "height": 1.3608,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d310",
        "height": 1.6035,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d312",
        "height": 1.8528,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "ac3",
    "rightNeighborShelfId": "ac1"
  },
  {
    "id": "ac3",
    "name": "ac3",
    "x": -35.117,
    "y": -31.785,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70994,
      "w": 0.70426
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 55
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d308",
        "height": 0.44871,
        "facings": [
          {
            "id": "f3a4c9197f859f2aff518ace",
            "leftCorner": {
              "x": -35.194,
              "y": -31.785,
              "z": 0.367
            },
            "rightCorner": {
              "x": -35.195,
              "y": -31.709,
              "z": 0.367
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "43883a08f13a67c514606ae4",
            "leftCorner": {
              "x": -35.195,
              "y": -31.709,
              "z": 0.367
            },
            "rightCorner": {
              "x": -35.195,
              "y": -31.632,
              "z": 0.367
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2c3c7d8cbc2c1edef5014f88",
            "leftCorner": {
              "x": -35.195,
              "y": -31.632,
              "z": 0.367
            },
            "rightCorner": {
              "x": -35.196,
              "y": -31.556,
              "z": 0.367
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d6be20f5cbe6b996d5c5053e",
            "leftCorner": {
              "x": -35.196,
              "y": -31.556,
              "z": 0.367
            },
            "rightCorner": {
              "x": -35.196,
              "y": -31.479,
              "z": 0.367
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f47c9e4d6941a9c4d27c0698",
            "leftCorner": {
              "x": -35.196,
              "y": -31.479,
              "z": 0.367
            },
            "rightCorner": {
              "x": -35.197,
              "y": -31.403,
              "z": 0.367
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ab4e8e64a89a1dd27d13231a",
            "leftCorner": {
              "x": -35.197,
              "y": -31.403,
              "z": 0.367
            },
            "rightCorner": {
              "x": -35.198,
              "y": -31.326,
              "z": 0.367
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a4c6a23a8cea664ad9933066",
            "leftCorner": {
              "x": -35.198,
              "y": -31.326,
              "z": 0.367
            },
            "rightCorner": {
              "x": -35.198,
              "y": -31.25,
              "z": 0.367
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b03148134f99436eb266c3d1",
            "leftCorner": {
              "x": -35.198,
              "y": -31.25,
              "z": 0.367
            },
            "rightCorner": {
              "x": -35.199,
              "y": -31.173,
              "z": 0.367
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7c57f186d6367ebd4ae26e4e",
            "leftCorner": {
              "x": -35.199,
              "y": -31.173,
              "z": 0.367
            },
            "rightCorner": {
              "x": -35.2,
              "y": -31.097,
              "z": 0.367
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "91a8b5e2f07bd327006aac41",
            "leftCorner": {
              "x": -35.2,
              "y": -31.097,
              "z": 0.367
            },
            "rightCorner": {
              "x": -35.2,
              "y": -31.02,
              "z": 0.367
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d30a",
        "height": 0.72543,
        "facings": [
          {
            "id": "f6ae024c46acdbf366727faf",
            "leftCorner": {
              "x": -35.12,
              "y": -31.785,
              "z": 0.594
            },
            "rightCorner": {
              "x": -35.121,
              "y": -31.709,
              "z": 0.594
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7034adffbfd05e149c15a69d",
            "leftCorner": {
              "x": -35.121,
              "y": -31.709,
              "z": 0.594
            },
            "rightCorner": {
              "x": -35.121,
              "y": -31.632,
              "z": 0.594
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3c3b604ff7b6c7bcfc680b40",
            "leftCorner": {
              "x": -35.121,
              "y": -31.632,
              "z": 0.594
            },
            "rightCorner": {
              "x": -35.122,
              "y": -31.556,
              "z": 0.594
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d7a7ebec01bbc62cd48167f9",
            "leftCorner": {
              "x": -35.122,
              "y": -31.556,
              "z": 0.594
            },
            "rightCorner": {
              "x": -35.122,
              "y": -31.479,
              "z": 0.594
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ffbb861afb354a403f8e7789",
            "leftCorner": {
              "x": -35.122,
              "y": -31.479,
              "z": 0.594
            },
            "rightCorner": {
              "x": -35.123,
              "y": -31.403,
              "z": 0.594
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8bd9ce3990e8e77168cc74dc",
            "leftCorner": {
              "x": -35.123,
              "y": -31.403,
              "z": 0.594
            },
            "rightCorner": {
              "x": -35.124,
              "y": -31.326,
              "z": 0.594
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e7e9dd1033c4765bdf41ab26",
            "leftCorner": {
              "x": -35.124,
              "y": -31.326,
              "z": 0.594
            },
            "rightCorner": {
              "x": -35.124,
              "y": -31.25,
              "z": 0.594
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f24e98e7f7380cc707d9c881",
            "leftCorner": {
              "x": -35.124,
              "y": -31.25,
              "z": 0.594
            },
            "rightCorner": {
              "x": -35.125,
              "y": -31.173,
              "z": 0.594
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e9719260c854eb5b63157298",
            "leftCorner": {
              "x": -35.125,
              "y": -31.173,
              "z": 0.594
            },
            "rightCorner": {
              "x": -35.126,
              "y": -31.097,
              "z": 0.594
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "796479a8978db22800a623c7",
            "leftCorner": {
              "x": -35.126,
              "y": -31.097,
              "z": 0.594
            },
            "rightCorner": {
              "x": -35.126,
              "y": -31.02,
              "z": 0.594
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d309",
        "height": 1.0464,
        "facings": [
          {
            "id": "e40718bafedef0721e245633",
            "leftCorner": {
              "x": -35.202,
              "y": -31.785,
              "z": 0.856
            },
            "rightCorner": {
              "x": -35.203,
              "y": -31.627,
              "z": 0.856
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4ee73f4239ce32ed11716063",
            "leftCorner": {
              "x": -35.203,
              "y": -31.627,
              "z": 0.856
            },
            "rightCorner": {
              "x": -35.205,
              "y": -31.47,
              "z": 0.856
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e8ca2ff9d93a71035e4c2b70",
            "leftCorner": {
              "x": -35.205,
              "y": -31.47,
              "z": 0.856
            },
            "rightCorner": {
              "x": -35.206,
              "y": -31.312,
              "z": 0.856
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "88b6555755cb6317be7130c7",
            "leftCorner": {
              "x": -35.206,
              "y": -31.312,
              "z": 0.856
            },
            "rightCorner": {
              "x": -35.207,
              "y": -31.154,
              "z": 0.856
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d5ebd5274059932c7605e203",
            "leftCorner": {
              "x": -35.207,
              "y": -31.154,
              "z": 0.856
            },
            "rightCorner": {
              "x": -35.208,
              "y": -30.996,
              "z": 0.856
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d305",
        "height": 1.3532,
        "facings": [
          {
            "id": "826958354352d78c1916b884",
            "leftCorner": {
              "x": -35.214,
              "y": -31.785,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.215,
              "y": -31.709,
              "z": 1.107
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f6416c4f4af33ba5ea23d914",
            "leftCorner": {
              "x": -35.215,
              "y": -31.709,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.215,
              "y": -31.632,
              "z": 1.107
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c9152832d7571c8f081da120",
            "leftCorner": {
              "x": -35.215,
              "y": -31.632,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.216,
              "y": -31.556,
              "z": 1.107
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c4e3e26c87e06733cd9d1f4e",
            "leftCorner": {
              "x": -35.216,
              "y": -31.556,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.216,
              "y": -31.479,
              "z": 1.107
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ed8e7abc5ce55dae03a71bf7",
            "leftCorner": {
              "x": -35.216,
              "y": -31.479,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.217,
              "y": -31.403,
              "z": 1.107
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0019916159c6f24d109573e5",
            "leftCorner": {
              "x": -35.217,
              "y": -31.403,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.218,
              "y": -31.326,
              "z": 1.107
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "59b9bd6933444f8ad7645c9f",
            "leftCorner": {
              "x": -35.218,
              "y": -31.326,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.218,
              "y": -31.25,
              "z": 1.107
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3c3fea78cf3ed78a20fdba2b",
            "leftCorner": {
              "x": -35.218,
              "y": -31.25,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.219,
              "y": -31.173,
              "z": 1.107
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "13855f2bf232eab6a388eec6",
            "leftCorner": {
              "x": -35.219,
              "y": -31.173,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.22,
              "y": -31.097,
              "z": 1.107
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "00fff7b885b9498ca96978c4",
            "leftCorner": {
              "x": -35.22,
              "y": -31.097,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.22,
              "y": -31.02,
              "z": 1.107
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d304",
        "height": 1.6006,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6eb3",
            "leftCorner": {
              "x": -35.243,
              "y": -31.08,
              "z": 1.31
            },
            "rightCorner": {
              "x": -35.247,
              "y": -30.646,
              "z": 1.31
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3eabe1c101daacbbdc0c5f73",
            "leftCorner": {
              "x": -35.221,
              "y": -31.785,
              "z": 1.31
            },
            "rightCorner": {
              "x": -35.222,
              "y": -31.709,
              "z": 1.31
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ad8e6fda0144c00eb92c901f",
            "leftCorner": {
              "x": -35.222,
              "y": -31.709,
              "z": 1.31
            },
            "rightCorner": {
              "x": -35.222,
              "y": -31.632,
              "z": 1.31
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "757205ed0f6107fd72a5e016",
            "leftCorner": {
              "x": -35.222,
              "y": -31.632,
              "z": 1.31
            },
            "rightCorner": {
              "x": -35.223,
              "y": -31.556,
              "z": 1.31
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7fa3cdfb123429d89fd2ba1c",
            "leftCorner": {
              "x": -35.223,
              "y": -31.556,
              "z": 1.31
            },
            "rightCorner": {
              "x": -35.223,
              "y": -31.479,
              "z": 1.31
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7924a194779c1e7ae197a12f",
            "leftCorner": {
              "x": -35.223,
              "y": -31.479,
              "z": 1.31
            },
            "rightCorner": {
              "x": -35.224,
              "y": -31.403,
              "z": 1.31
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "82078660fef41e5793bc31f0",
            "leftCorner": {
              "x": -35.224,
              "y": -31.403,
              "z": 1.31
            },
            "rightCorner": {
              "x": -35.225,
              "y": -31.326,
              "z": 1.31
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "688e1f126ca26135d9862624",
            "leftCorner": {
              "x": -35.225,
              "y": -31.326,
              "z": 1.31
            },
            "rightCorner": {
              "x": -35.225,
              "y": -31.25,
              "z": 1.31
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7450657fb8bafe5eb5acc986",
            "leftCorner": {
              "x": -35.225,
              "y": -31.25,
              "z": 1.31
            },
            "rightCorner": {
              "x": -35.226,
              "y": -31.173,
              "z": 1.31
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e7872a7629c339409b7781de",
            "leftCorner": {
              "x": -35.226,
              "y": -31.173,
              "z": 1.31
            },
            "rightCorner": {
              "x": -35.227,
              "y": -31.097,
              "z": 1.31
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d30c",
        "height": 1.8491,
        "facings": [
          {
            "id": "bbd2da39454916554643427f",
            "leftCorner": {
              "x": -35.163,
              "y": -31.785,
              "z": 1.513
            },
            "rightCorner": {
              "x": -35.164,
              "y": -31.709,
              "z": 1.513
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e79900d472be1df75fd6aafd",
            "leftCorner": {
              "x": -35.164,
              "y": -31.709,
              "z": 1.513
            },
            "rightCorner": {
              "x": -35.164,
              "y": -31.632,
              "z": 1.513
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a11f20ac85a3d8b4256700eb",
            "leftCorner": {
              "x": -35.164,
              "y": -31.632,
              "z": 1.513
            },
            "rightCorner": {
              "x": -35.165,
              "y": -31.556,
              "z": 1.513
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cf0ec245c8294dfbd1844e3e",
            "leftCorner": {
              "x": -35.165,
              "y": -31.556,
              "z": 1.513
            },
            "rightCorner": {
              "x": -35.165,
              "y": -31.479,
              "z": 1.513
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "71297562b49b048882cd705a",
            "leftCorner": {
              "x": -35.165,
              "y": -31.479,
              "z": 1.513
            },
            "rightCorner": {
              "x": -35.166,
              "y": -31.403,
              "z": 1.513
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "be49635f1dcfbfef24d2a5e3",
            "leftCorner": {
              "x": -35.166,
              "y": -31.403,
              "z": 1.513
            },
            "rightCorner": {
              "x": -35.167,
              "y": -31.326,
              "z": 1.513
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6c84937522da78eb36ba2515",
            "leftCorner": {
              "x": -35.167,
              "y": -31.326,
              "z": 1.513
            },
            "rightCorner": {
              "x": -35.167,
              "y": -31.25,
              "z": 1.513
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "668ceff2781469e6733babe9",
            "leftCorner": {
              "x": -35.167,
              "y": -31.25,
              "z": 1.513
            },
            "rightCorner": {
              "x": -35.168,
              "y": -31.173,
              "z": 1.513
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "82558c4bcddf5636597baad2",
            "leftCorner": {
              "x": -35.168,
              "y": -31.173,
              "z": 1.513
            },
            "rightCorner": {
              "x": -35.169,
              "y": -31.097,
              "z": 1.513
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f6e7f67b1e316032d5dec9ff",
            "leftCorner": {
              "x": -35.169,
              "y": -31.097,
              "z": 1.513
            },
            "rightCorner": {
              "x": -35.169,
              "y": -31.02,
              "z": 1.513
            },
            "gtin": "4008211002086",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ac4",
    "rightNeighborShelfId": "ac2"
  },
  {
    "id": "ac4",
    "name": "ac4",
    "x": -35.11,
    "y": -32.585,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70993,
      "w": 0.70427
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d2fb",
        "height": 0.437,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d302",
        "height": 0.74325,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d2fe",
        "height": 1.0509,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d2fc",
        "height": 1.3541,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d2ff",
        "height": 1.6017,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "ac5",
    "rightNeighborShelfId": "ac3"
  },
  {
    "id": "ac5",
    "name": "ac5",
    "x": -35.104,
    "y": -33.385,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70993,
      "w": 0.70427
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 65
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d2f2",
        "height": 0.44411,
        "facings": [
          {
            "id": "b7b494b74d7b21af21d229ca",
            "leftCorner": {
              "x": -35.216,
              "y": -33.386,
              "z": 0.363
            },
            "rightCorner": {
              "x": -35.217,
              "y": -33.316,
              "z": 0.363
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "19cff00adbac1b8b8de1309f",
            "leftCorner": {
              "x": -35.217,
              "y": -33.316,
              "z": 0.363
            },
            "rightCorner": {
              "x": -35.217,
              "y": -33.246,
              "z": 0.363
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a67233fc1c851ecd2f9660c3",
            "leftCorner": {
              "x": -35.217,
              "y": -33.246,
              "z": 0.363
            },
            "rightCorner": {
              "x": -35.218,
              "y": -33.176,
              "z": 0.363
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7eef996dde8dc9a8ab04aa4e",
            "leftCorner": {
              "x": -35.218,
              "y": -33.176,
              "z": 0.363
            },
            "rightCorner": {
              "x": -35.218,
              "y": -33.105,
              "z": 0.363
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4382ac1cb14d0e42584b2577",
            "leftCorner": {
              "x": -35.218,
              "y": -33.105,
              "z": 0.363
            },
            "rightCorner": {
              "x": -35.219,
              "y": -33.035,
              "z": 0.363
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "213ee66f8e669d0cdb1f4701",
            "leftCorner": {
              "x": -35.219,
              "y": -33.035,
              "z": 0.363
            },
            "rightCorner": {
              "x": -35.219,
              "y": -32.965,
              "z": 0.363
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "874263ad7a72d7d187305f5f",
            "leftCorner": {
              "x": -35.219,
              "y": -32.965,
              "z": 0.363
            },
            "rightCorner": {
              "x": -35.22,
              "y": -32.895,
              "z": 0.363
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "19039fef393e78236185acac",
            "leftCorner": {
              "x": -35.22,
              "y": -32.895,
              "z": 0.363
            },
            "rightCorner": {
              "x": -35.22,
              "y": -32.825,
              "z": 0.363
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0ab3d71f46039708c7959c7a",
            "leftCorner": {
              "x": -35.22,
              "y": -32.825,
              "z": 0.363
            },
            "rightCorner": {
              "x": -35.221,
              "y": -32.755,
              "z": 0.363
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "be0cf367c4ff39749bf92b1f",
            "leftCorner": {
              "x": -35.221,
              "y": -32.755,
              "z": 0.363
            },
            "rightCorner": {
              "x": -35.222,
              "y": -32.685,
              "z": 0.363
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f8d988255053fd4a3f5a4f9d",
            "leftCorner": {
              "x": -35.222,
              "y": -32.685,
              "z": 0.363
            },
            "rightCorner": {
              "x": -35.222,
              "y": -32.615,
              "z": 0.363
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2f0",
        "height": 0.73484,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6ee4",
            "leftCorner": {
              "x": -35.229,
              "y": -32.756,
              "z": 0.601
            },
            "rightCorner": {
              "x": -35.232,
              "y": -32.316,
              "z": 0.601
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ccb6086288f42caa47cfc818",
            "leftCorner": {
              "x": -35.184,
              "y": -33.386,
              "z": 0.601
            },
            "rightCorner": {
              "x": -35.185,
              "y": -33.316,
              "z": 0.601
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c6728fdb8beaf596df815227",
            "leftCorner": {
              "x": -35.185,
              "y": -33.316,
              "z": 0.601
            },
            "rightCorner": {
              "x": -35.185,
              "y": -33.246,
              "z": 0.601
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d9ba1fd7ccd9053845dee487",
            "leftCorner": {
              "x": -35.185,
              "y": -33.246,
              "z": 0.601
            },
            "rightCorner": {
              "x": -35.186,
              "y": -33.176,
              "z": 0.601
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "47a24831fbae01b98ebc4463",
            "leftCorner": {
              "x": -35.186,
              "y": -33.176,
              "z": 0.601
            },
            "rightCorner": {
              "x": -35.186,
              "y": -33.106,
              "z": 0.601
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d39386d44d1d42d783e6bdc6",
            "leftCorner": {
              "x": -35.186,
              "y": -33.106,
              "z": 0.601
            },
            "rightCorner": {
              "x": -35.187,
              "y": -33.036,
              "z": 0.601
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "019fac3e6040254724693daa",
            "leftCorner": {
              "x": -35.187,
              "y": -33.036,
              "z": 0.601
            },
            "rightCorner": {
              "x": -35.187,
              "y": -32.966,
              "z": 0.601
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f461d486a0a405724989c877",
            "leftCorner": {
              "x": -35.187,
              "y": -32.966,
              "z": 0.601
            },
            "rightCorner": {
              "x": -35.188,
              "y": -32.896,
              "z": 0.601
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0cb13dfa6a0af02f8408d7d0",
            "leftCorner": {
              "x": -35.188,
              "y": -32.896,
              "z": 0.601
            },
            "rightCorner": {
              "x": -35.188,
              "y": -32.825,
              "z": 0.601
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3f27ec5c217169a401f07838",
            "leftCorner": {
              "x": -35.188,
              "y": -32.825,
              "z": 0.601
            },
            "rightCorner": {
              "x": -35.189,
              "y": -32.755,
              "z": 0.601
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2f4",
        "height": 1.0521,
        "facings": [
          {
            "id": "ae37ce2c4c164cabe222a4d9",
            "leftCorner": {
              "x": -35.234,
              "y": -33.387,
              "z": 0.861
            },
            "rightCorner": {
              "x": -35.235,
              "y": -33.316,
              "z": 0.861
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d4f8a6731f5153bbbef65299",
            "leftCorner": {
              "x": -35.235,
              "y": -33.316,
              "z": 0.861
            },
            "rightCorner": {
              "x": -35.235,
              "y": -33.246,
              "z": 0.861
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e6fdb05b22986a0945113d57",
            "leftCorner": {
              "x": -35.235,
              "y": -33.246,
              "z": 0.861
            },
            "rightCorner": {
              "x": -35.236,
              "y": -33.176,
              "z": 0.861
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e52d5cb2005f07f339fa0512",
            "leftCorner": {
              "x": -35.236,
              "y": -33.176,
              "z": 0.861
            },
            "rightCorner": {
              "x": -35.236,
              "y": -33.106,
              "z": 0.861
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f3d88517c39f4e45493609cd",
            "leftCorner": {
              "x": -35.236,
              "y": -33.106,
              "z": 0.861
            },
            "rightCorner": {
              "x": -35.237,
              "y": -33.036,
              "z": 0.861
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7e1336705ba9bae4e7b5ca9d",
            "leftCorner": {
              "x": -35.237,
              "y": -33.036,
              "z": 0.861
            },
            "rightCorner": {
              "x": -35.237,
              "y": -32.966,
              "z": 0.861
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7905f069cda4b0c55916f4be",
            "leftCorner": {
              "x": -35.237,
              "y": -32.966,
              "z": 0.861
            },
            "rightCorner": {
              "x": -35.238,
              "y": -32.896,
              "z": 0.861
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "06d847beb99a99df46685ae7",
            "leftCorner": {
              "x": -35.238,
              "y": -32.896,
              "z": 0.861
            },
            "rightCorner": {
              "x": -35.238,
              "y": -32.826,
              "z": 0.861
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "581202e77feb4b986be1ba51",
            "leftCorner": {
              "x": -35.238,
              "y": -32.826,
              "z": 0.861
            },
            "rightCorner": {
              "x": -35.239,
              "y": -32.756,
              "z": 0.861
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a31320fe6aa990f16ac13a00",
            "leftCorner": {
              "x": -35.239,
              "y": -32.756,
              "z": 0.861
            },
            "rightCorner": {
              "x": -35.24,
              "y": -32.686,
              "z": 0.861
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e4b28d1ee1db01ff19a0b0f7",
            "leftCorner": {
              "x": -35.24,
              "y": -32.686,
              "z": 0.861
            },
            "rightCorner": {
              "x": -35.24,
              "y": -32.616,
              "z": 0.861
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2f5",
        "height": 1.3569,
        "facings": [
          {
            "id": "902402f9eeecdd40acb44dff",
            "leftCorner": {
              "x": -35.213,
              "y": -33.386,
              "z": 1.11
            },
            "rightCorner": {
              "x": -35.214,
              "y": -33.316,
              "z": 1.11
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9cd9d01d5b6b3315f6a1d194",
            "leftCorner": {
              "x": -35.214,
              "y": -33.316,
              "z": 1.11
            },
            "rightCorner": {
              "x": -35.214,
              "y": -33.246,
              "z": 1.11
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f0ad29b76ac8a2f8aeee6f93",
            "leftCorner": {
              "x": -35.214,
              "y": -33.246,
              "z": 1.11
            },
            "rightCorner": {
              "x": -35.215,
              "y": -33.176,
              "z": 1.11
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d44f7e50a0de6ad3147d06ca",
            "leftCorner": {
              "x": -35.215,
              "y": -33.176,
              "z": 1.11
            },
            "rightCorner": {
              "x": -35.215,
              "y": -33.105,
              "z": 1.11
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f11557f95cd58ec07cb2804d",
            "leftCorner": {
              "x": -35.215,
              "y": -33.105,
              "z": 1.11
            },
            "rightCorner": {
              "x": -35.216,
              "y": -33.035,
              "z": 1.11
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "898a135d4780d5367e5f648b",
            "leftCorner": {
              "x": -35.216,
              "y": -33.035,
              "z": 1.11
            },
            "rightCorner": {
              "x": -35.216,
              "y": -32.965,
              "z": 1.11
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "35de85d0ccd87673158801de",
            "leftCorner": {
              "x": -35.216,
              "y": -32.965,
              "z": 1.11
            },
            "rightCorner": {
              "x": -35.217,
              "y": -32.895,
              "z": 1.11
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "591d2b07c87647efae7b8830",
            "leftCorner": {
              "x": -35.217,
              "y": -32.895,
              "z": 1.11
            },
            "rightCorner": {
              "x": -35.217,
              "y": -32.825,
              "z": 1.11
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ba9f809eaaff1f31d41496ed",
            "leftCorner": {
              "x": -35.217,
              "y": -32.825,
              "z": 1.11
            },
            "rightCorner": {
              "x": -35.218,
              "y": -32.755,
              "z": 1.11
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e6b4939c220a04191e617672",
            "leftCorner": {
              "x": -35.218,
              "y": -32.755,
              "z": 1.11
            },
            "rightCorner": {
              "x": -35.219,
              "y": -32.685,
              "z": 1.11
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "023161dcb374e7ff51564d23",
            "leftCorner": {
              "x": -35.219,
              "y": -32.685,
              "z": 1.11
            },
            "rightCorner": {
              "x": -35.219,
              "y": -32.615,
              "z": 1.11
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2f3",
        "height": 1.6074,
        "facings": [
          {
            "id": "9d3173f737053010bc68cc27",
            "leftCorner": {
              "x": -35.201,
              "y": -33.386,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.202,
              "y": -33.316,
              "z": 1.315
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "be083a07b828b182a69daa12",
            "leftCorner": {
              "x": -35.202,
              "y": -33.316,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.202,
              "y": -33.246,
              "z": 1.315
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b8c18edb6084aaad2c90f8e1",
            "leftCorner": {
              "x": -35.202,
              "y": -33.246,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.203,
              "y": -33.176,
              "z": 1.315
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1e3bcbd528d12c0b51e51614",
            "leftCorner": {
              "x": -35.203,
              "y": -33.176,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.203,
              "y": -33.106,
              "z": 1.315
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6fc98045f1c8ffa85ce0ac63",
            "leftCorner": {
              "x": -35.203,
              "y": -33.106,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.204,
              "y": -33.036,
              "z": 1.315
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9b12592ab87dfeaaae15432c",
            "leftCorner": {
              "x": -35.204,
              "y": -33.036,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.204,
              "y": -32.965,
              "z": 1.315
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "43a990e84ea5587173ce094c",
            "leftCorner": {
              "x": -35.204,
              "y": -32.965,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.205,
              "y": -32.895,
              "z": 1.315
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "11cadadcdba7d3e28313bdff",
            "leftCorner": {
              "x": -35.205,
              "y": -32.895,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.205,
              "y": -32.825,
              "z": 1.315
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "27831d46776d7cfed0480e2c",
            "leftCorner": {
              "x": -35.205,
              "y": -32.825,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.206,
              "y": -32.755,
              "z": 1.315
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68c19f03e4e3491a4070a597",
            "leftCorner": {
              "x": -35.206,
              "y": -32.755,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.207,
              "y": -32.685,
              "z": 1.315
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6b9896a136da677563f63e05",
            "leftCorner": {
              "x": -35.207,
              "y": -32.685,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.207,
              "y": -32.615,
              "z": 1.315
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2fa",
        "height": 1.8603,
        "facings": [
          {
            "id": "3a8901f560335e256be62053",
            "leftCorner": {
              "x": -35.263,
              "y": -33.386,
              "z": 1.522
            },
            "rightCorner": {
              "x": -35.264,
              "y": -33.316,
              "z": 1.522
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "517639e83a986e3ba349edfd",
            "leftCorner": {
              "x": -35.264,
              "y": -33.316,
              "z": 1.522
            },
            "rightCorner": {
              "x": -35.264,
              "y": -33.246,
              "z": 1.522
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8c3f149196004918872ae1f6",
            "leftCorner": {
              "x": -35.264,
              "y": -33.246,
              "z": 1.522
            },
            "rightCorner": {
              "x": -35.265,
              "y": -33.176,
              "z": 1.522
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e3436c90604a0e80c19d5ff0",
            "leftCorner": {
              "x": -35.265,
              "y": -33.176,
              "z": 1.522
            },
            "rightCorner": {
              "x": -35.265,
              "y": -33.106,
              "z": 1.522
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "02c604fdd6b5886a5714e7cc",
            "leftCorner": {
              "x": -35.265,
              "y": -33.106,
              "z": 1.522
            },
            "rightCorner": {
              "x": -35.266,
              "y": -33.036,
              "z": 1.522
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "85b33724e136584a8d6d02f0",
            "leftCorner": {
              "x": -35.266,
              "y": -33.036,
              "z": 1.522
            },
            "rightCorner": {
              "x": -35.266,
              "y": -32.966,
              "z": 1.522
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6cc51f2bfe78549143169e21",
            "leftCorner": {
              "x": -35.266,
              "y": -32.966,
              "z": 1.522
            },
            "rightCorner": {
              "x": -35.267,
              "y": -32.896,
              "z": 1.522
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a05332c01f32dda0d2a5d8b0",
            "leftCorner": {
              "x": -35.267,
              "y": -32.896,
              "z": 1.522
            },
            "rightCorner": {
              "x": -35.267,
              "y": -32.826,
              "z": 1.522
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5808594953ca4289adf87b70",
            "leftCorner": {
              "x": -35.267,
              "y": -32.826,
              "z": 1.522
            },
            "rightCorner": {
              "x": -35.268,
              "y": -32.756,
              "z": 1.522
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "73c43e37a3d5bed87009fe35",
            "leftCorner": {
              "x": -35.268,
              "y": -32.756,
              "z": 1.522
            },
            "rightCorner": {
              "x": -35.269,
              "y": -32.686,
              "z": 1.522
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "84c5c95bb23e36eb9ade3530",
            "leftCorner": {
              "x": -35.269,
              "y": -32.686,
              "z": 1.522
            },
            "rightCorner": {
              "x": -35.269,
              "y": -32.616,
              "z": 1.522
            },
            "gtin": "7613035844773",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ac6",
    "rightNeighborShelfId": "ac4"
  },
  {
    "id": "ac6",
    "name": "ac6",
    "x": -35.097,
    "y": -34.185,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70993,
      "w": 0.70427
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d2e6",
        "height": 0.43692,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d2e9",
        "height": 0.75319,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d2e8",
        "height": 1.0527,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d2ea",
        "height": 1.3606,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d2e5",
        "height": 1.6068,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d2e7",
        "height": 1.8564,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "ac7",
    "rightNeighborShelfId": "ac5"
  },
  {
    "id": "ac7",
    "name": "ac7",
    "x": -35.091,
    "y": -34.985,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70993,
      "w": 0.70427
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d2df",
        "height": 1.0346,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e81",
            "leftCorner": {
              "x": -35.147,
              "y": -34.457,
              "z": 0.846
            },
            "rightCorner": {
              "x": -35.148,
              "y": -34.308,
              "z": 0.846
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7b4e77582f4f7a92bd52318a",
            "leftCorner": {
              "x": -35.103,
              "y": -34.985,
              "z": 0.846
            },
            "rightCorner": {
              "x": -35.104,
              "y": -34.829,
              "z": 0.846
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "af85f8877df5a0128a83f074",
            "leftCorner": {
              "x": -35.104,
              "y": -34.829,
              "z": 0.846
            },
            "rightCorner": {
              "x": -35.105,
              "y": -34.673,
              "z": 0.846
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "71aabcaafd94dfbf79231045",
            "leftCorner": {
              "x": -35.105,
              "y": -34.673,
              "z": 0.846
            },
            "rightCorner": {
              "x": -35.107,
              "y": -34.517,
              "z": 0.846
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2e0",
        "height": 1.358,
        "facings": [
          {
            "id": "dc9e23488e9aea380b7fbeb5",
            "leftCorner": {
              "x": -35.175,
              "y": -34.986,
              "z": 1.111
            },
            "rightCorner": {
              "x": -35.176,
              "y": -34.83,
              "z": 1.111
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "402980f2684a057f0f93d171",
            "leftCorner": {
              "x": -35.176,
              "y": -34.83,
              "z": 1.111
            },
            "rightCorner": {
              "x": -35.178,
              "y": -34.674,
              "z": 1.111
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f99f215c6f285ba29c57ac36",
            "leftCorner": {
              "x": -35.178,
              "y": -34.674,
              "z": 1.111
            },
            "rightCorner": {
              "x": -35.179,
              "y": -34.518,
              "z": 1.111
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dd373b7c8f0795aa8ca7f58f",
            "leftCorner": {
              "x": -35.179,
              "y": -34.518,
              "z": 1.111
            },
            "rightCorner": {
              "x": -35.18,
              "y": -34.362,
              "z": 1.111
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "11b4aa92d877ebb7337a2d92",
            "leftCorner": {
              "x": -35.18,
              "y": -34.362,
              "z": 1.111
            },
            "rightCorner": {
              "x": -35.181,
              "y": -34.206,
              "z": 1.111
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2e1",
        "height": 1.6072,
        "facings": [
          {
            "id": "ff89e34211c723c7f9bf4e03",
            "leftCorner": {
              "x": -35.179,
              "y": -34.986,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.18,
              "y": -34.83,
              "z": 1.315
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "939232c86a39503ef7bb21fb",
            "leftCorner": {
              "x": -35.18,
              "y": -34.83,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.182,
              "y": -34.674,
              "z": 1.315
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8b541298ff567b077bcd0689",
            "leftCorner": {
              "x": -35.182,
              "y": -34.674,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.183,
              "y": -34.518,
              "z": 1.315
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "54c568926e03c4af1354e844",
            "leftCorner": {
              "x": -35.183,
              "y": -34.518,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.184,
              "y": -34.362,
              "z": 1.315
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3e5e9a4822e8b5a1147234ab",
            "leftCorner": {
              "x": -35.184,
              "y": -34.362,
              "z": 1.315
            },
            "rightCorner": {
              "x": -35.185,
              "y": -34.206,
              "z": 1.315
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2e3",
        "height": 1.8511,
        "facings": [
          {
            "id": "d2c29f0872de5ae90453ccf7",
            "leftCorner": {
              "x": -35.178,
              "y": -34.986,
              "z": 1.515
            },
            "rightCorner": {
              "x": -35.179,
              "y": -34.83,
              "z": 1.515
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "37348121d108675278a7a667",
            "leftCorner": {
              "x": -35.179,
              "y": -34.83,
              "z": 1.515
            },
            "rightCorner": {
              "x": -35.181,
              "y": -34.674,
              "z": 1.515
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e06aed518074912dbe650ff5",
            "leftCorner": {
              "x": -35.181,
              "y": -34.674,
              "z": 1.515
            },
            "rightCorner": {
              "x": -35.182,
              "y": -34.518,
              "z": 1.515
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a1b52e4e4ab9aef9dc77a4a9",
            "leftCorner": {
              "x": -35.182,
              "y": -34.518,
              "z": 1.515
            },
            "rightCorner": {
              "x": -35.183,
              "y": -34.362,
              "z": 1.515
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fb07fefb279954e14f30ec8e",
            "leftCorner": {
              "x": -35.183,
              "y": -34.362,
              "z": 1.515
            },
            "rightCorner": {
              "x": -35.184,
              "y": -34.206,
              "z": 1.515
            },
            "gtin": "4260031990176",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "acc",
    "rightNeighborShelfId": "ac6"
  },
  {
    "id": "acc",
    "name": "acc",
    "x": -35.08,
    "y": -36.247,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7102,
      "w": 0.704
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 46,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d2db",
        "height": 0.66161,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e78",
            "leftCorner": {
              "x": -35.154,
              "y": -36.247,
              "z": 0.541
            },
            "rightCorner": {
              "x": -35.157,
              "y": -35.886,
              "z": 0.541
            },
            "gtin": "90448638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e7b",
            "leftCorner": {
              "x": -35.197,
              "y": -35.887,
              "z": 0.541
            },
            "rightCorner": {
              "x": -35.199,
              "y": -35.648,
              "z": 0.541
            },
            "gtin": "90376603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e7c",
            "leftCorner": {
              "x": -35.199,
              "y": -35.648,
              "z": 0.541
            },
            "rightCorner": {
              "x": -35.202,
              "y": -35.41,
              "z": 0.541
            },
            "gtin": "90376603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e7d",
            "leftCorner": {
              "x": -35.201,
              "y": -35.41,
              "z": 0.541
            },
            "rightCorner": {
              "x": -35.204,
              "y": -35.132,
              "z": 0.541
            },
            "gtin": "90415722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e79",
            "leftCorner": {
              "x": -35.201,
              "y": -35.132,
              "z": 0.541
            },
            "rightCorner": {
              "x": -35.202,
              "y": -35.065,
              "z": 0.541
            },
            "gtin": "4306188242284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e7a",
            "leftCorner": {
              "x": -35.202,
              "y": -35.065,
              "z": 0.541
            },
            "rightCorner": {
              "x": -35.202,
              "y": -34.998,
              "z": 0.541
            },
            "gtin": "4306188242284",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2dd",
        "height": 0.93547,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e60",
            "leftCorner": {
              "x": -35.201,
              "y": -36.248,
              "z": 0.765
            },
            "rightCorner": {
              "x": -35.201,
              "y": -36.175,
              "z": 0.765
            },
            "gtin": "90162565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e61",
            "leftCorner": {
              "x": -35.112,
              "y": -36.175,
              "z": 0.765
            },
            "rightCorner": {
              "x": -35.114,
              "y": -35.926,
              "z": 0.765
            },
            "gtin": "90162565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e62",
            "leftCorner": {
              "x": -35.199,
              "y": -35.927,
              "z": 0.765
            },
            "rightCorner": {
              "x": -35.201,
              "y": -35.79,
              "z": 0.765
            },
            "gtin": "90433627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e63",
            "leftCorner": {
              "x": -35.201,
              "y": -35.79,
              "z": 0.765
            },
            "rightCorner": {
              "x": -35.201,
              "y": -35.653,
              "z": 0.765
            },
            "gtin": "90433627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e64",
            "leftCorner": {
              "x": -35.195,
              "y": -35.653,
              "z": 0.765
            },
            "rightCorner": {
              "x": -35.197,
              "y": -35.39,
              "z": 0.765
            },
            "gtin": "90453885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e65",
            "leftCorner": {
              "x": -35.204,
              "y": -35.39,
              "z": 0.765
            },
            "rightCorner": {
              "x": -35.207,
              "y": -35.083,
              "z": 0.765
            },
            "gtin": "90474514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e5b",
            "leftCorner": {
              "x": -35.202,
              "y": -35.084,
              "z": 0.765
            },
            "rightCorner": {
              "x": -35.203,
              "y": -34.998,
              "z": 0.765
            },
            "gtin": "90446832",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2d7",
        "height": 1.1594,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e46",
            "leftCorner": {
              "x": -35.2,
              "y": -36.248,
              "z": 0.949
            },
            "rightCorner": {
              "x": -35.203,
              "y": -36.054,
              "z": 0.949
            },
            "gtin": "5060337500401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e47",
            "leftCorner": {
              "x": -35.202,
              "y": -36.054,
              "z": 0.949
            },
            "rightCorner": {
              "x": -35.204,
              "y": -35.87,
              "z": 0.949
            },
            "gtin": "5060337500401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e48",
            "leftCorner": {
              "x": -35.204,
              "y": -35.87,
              "z": 0.949
            },
            "rightCorner": {
              "x": -35.208,
              "y": -35.339,
              "z": 0.949
            },
            "gtin": "5056784901359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e49",
            "leftCorner": {
              "x": -35.209,
              "y": -35.338,
              "z": 0.949
            },
            "rightCorner": {
              "x": -35.209,
              "y": -35.215,
              "z": 0.949
            },
            "gtin": "4260456730395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e4a",
            "leftCorner": {
              "x": -35.209,
              "y": -35.215,
              "z": 0.949
            },
            "rightCorner": {
              "x": -35.21,
              "y": -35.085,
              "z": 0.949
            },
            "gtin": "4260456730388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e40",
            "leftCorner": {
              "x": -35.212,
              "y": -35.085,
              "z": 0.949
            },
            "rightCorner": {
              "x": -35.212,
              "y": -34.998,
              "z": 0.949
            },
            "gtin": "4260456730401",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2da",
        "height": 1.3876,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e50",
            "leftCorner": {
              "x": -35.194,
              "y": -36.248,
              "z": 1.135
            },
            "rightCorner": {
              "x": -35.195,
              "y": -36.177,
              "z": 1.135
            },
            "gtin": "5060335635228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e51",
            "leftCorner": {
              "x": -35.111,
              "y": -36.177,
              "z": 1.135
            },
            "rightCorner": {
              "x": -35.113,
              "y": -35.966,
              "z": 1.135
            },
            "gtin": "5060335635228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e52",
            "leftCorner": {
              "x": -35.197,
              "y": -35.967,
              "z": 1.135
            },
            "rightCorner": {
              "x": -35.198,
              "y": -35.811,
              "z": 1.135
            },
            "gtin": "5060639126682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e53",
            "leftCorner": {
              "x": -35.198,
              "y": -35.811,
              "z": 1.135
            },
            "rightCorner": {
              "x": -35.2,
              "y": -35.63,
              "z": 1.135
            },
            "gtin": "5060517888510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e54",
            "leftCorner": {
              "x": -35.203,
              "y": -35.63,
              "z": 1.135
            },
            "rightCorner": {
              "x": -35.205,
              "y": -35.495,
              "z": 1.135
            },
            "gtin": "5060337507608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e55",
            "leftCorner": {
              "x": -35.113,
              "y": -35.495,
              "z": 1.135
            },
            "rightCorner": {
              "x": -35.114,
              "y": -35.417,
              "z": 1.135
            },
            "gtin": "5060517883607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e56",
            "leftCorner": {
              "x": -35.114,
              "y": -35.417,
              "z": 1.135
            },
            "rightCorner": {
              "x": -35.114,
              "y": -35.34,
              "z": 1.135
            },
            "gtin": "5060517883607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e57",
            "leftCorner": {
              "x": -35.2,
              "y": -35.341,
              "z": 1.135
            },
            "rightCorner": {
              "x": -35.201,
              "y": -35.224,
              "z": 1.135
            },
            "gtin": "5060335635266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e58",
            "leftCorner": {
              "x": -35.197,
              "y": -35.224,
              "z": 1.135
            },
            "rightCorner": {
              "x": -35.198,
              "y": -35.131,
              "z": 1.135
            },
            "gtin": "5061013944809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e4c",
            "leftCorner": {
              "x": -35.189,
              "y": -35.131,
              "z": 1.135
            },
            "rightCorner": {
              "x": -35.189,
              "y": -34.998,
              "z": 1.135
            },
            "gtin": "5056784902264",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2dc",
        "height": 1.6093,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e70",
            "leftCorner": {
              "x": -35.193,
              "y": -36.248,
              "z": 1.317
            },
            "rightCorner": {
              "x": -35.194,
              "y": -36.168,
              "z": 1.317
            },
            "gtin": "4008287948400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e71",
            "leftCorner": {
              "x": -35.064,
              "y": -36.166,
              "z": 1.317
            },
            "rightCorner": {
              "x": -35.065,
              "y": -36.078,
              "z": 1.317
            },
            "gtin": "4008287948400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e72",
            "leftCorner": {
              "x": -35.065,
              "y": -36.078,
              "z": 1.317
            },
            "rightCorner": {
              "x": -35.066,
              "y": -35.989,
              "z": 1.317
            },
            "gtin": "4008287948400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e73",
            "leftCorner": {
              "x": -35.066,
              "y": -35.989,
              "z": 1.317
            },
            "rightCorner": {
              "x": -35.067,
              "y": -35.901,
              "z": 1.317
            },
            "gtin": "4008287948400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e74",
            "leftCorner": {
              "x": -35.196,
              "y": -35.902,
              "z": 1.317
            },
            "rightCorner": {
              "x": -35.198,
              "y": -35.763,
              "z": 1.317
            },
            "gtin": "4008287072938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e75",
            "leftCorner": {
              "x": -35.198,
              "y": -35.763,
              "z": 1.317
            },
            "rightCorner": {
              "x": -35.199,
              "y": -35.624,
              "z": 1.317
            },
            "gtin": "4008287072938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e76",
            "leftCorner": {
              "x": -35.199,
              "y": -35.624,
              "z": 1.317
            },
            "rightCorner": {
              "x": -35.2,
              "y": -35.382,
              "z": 1.317
            },
            "gtin": "4008287050134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e77",
            "leftCorner": {
              "x": -35.2,
              "y": -35.382,
              "z": 1.317
            },
            "rightCorner": {
              "x": -35.203,
              "y": -35.14,
              "z": 1.317
            },
            "gtin": "4008287050134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e69",
            "leftCorner": {
              "x": -35.201,
              "y": -35.14,
              "z": 1.317
            },
            "rightCorner": {
              "x": -35.202,
              "y": -34.998,
              "z": 1.317
            },
            "gtin": "4053400250106",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d2d9",
        "height": 1.8286,
        "facings": [
          {
            "id": "68d8e50be1820c81800d6e38",
            "leftCorner": {
              "x": -35.19,
              "y": -36.248,
              "z": 1.496
            },
            "rightCorner": {
              "x": -35.192,
              "y": -36.121,
              "z": 1.496
            },
            "gtin": "4014086093647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e39",
            "leftCorner": {
              "x": -35.193,
              "y": -36.121,
              "z": 1.496
            },
            "rightCorner": {
              "x": -35.194,
              "y": -35.999,
              "z": 1.496
            },
            "gtin": "4014086093647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e3a",
            "leftCorner": {
              "x": -35.196,
              "y": -35.999,
              "z": 1.496
            },
            "rightCorner": {
              "x": -35.2,
              "y": -35.596,
              "z": 1.496
            },
            "gtin": "5099873026076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e3b",
            "leftCorner": {
              "x": -35.197,
              "y": -35.596,
              "z": 1.496
            },
            "rightCorner": {
              "x": -35.199,
              "y": -35.399,
              "z": 1.496
            },
            "gtin": "4005971394307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e3c",
            "leftCorner": {
              "x": -35.202,
              "y": -35.399,
              "z": 1.496
            },
            "rightCorner": {
              "x": -35.203,
              "y": -35.247,
              "z": 1.496
            },
            "gtin": "5000267190044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e3d",
            "leftCorner": {
              "x": -35.198,
              "y": -35.246,
              "z": 1.496
            },
            "rightCorner": {
              "x": -35.198,
              "y": -35.173,
              "z": 1.496
            },
            "gtin": "4003310014800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e3e",
            "leftCorner": {
              "x": -35.198,
              "y": -35.173,
              "z": 1.496
            },
            "rightCorner": {
              "x": -35.199,
              "y": -35.1,
              "z": 1.496
            },
            "gtin": "4003310014800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50be1820c81800d6e30",
            "leftCorner": {
              "x": -35.198,
              "y": -35.1,
              "z": 1.496
            },
            "rightCorner": {
              "x": -35.199,
              "y": -34.998,
              "z": 1.496
            },
            "gtin": "40535104",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "4df",
    "rightNeighborShelfId": "ac7"
  },
  {
    "id": "ae7",
    "name": "ae7",
    "x": -6.618,
    "y": -6.225,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69989,
      "w": 0.71425
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 58
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d50e",
        "height": 0.62669,
        "facings": [
          {
            "id": "68d8e50de1820c81800d803d",
            "leftCorner": {
              "x": -6.506,
              "y": -6.291,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.501,
              "y": -6.496,
              "z": 0.513
            },
            "gtin": "4009700050649",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "787c2810ed09d1fccc7744fb",
            "leftCorner": {
              "x": -6.541,
              "y": -6.223,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.54,
              "y": -6.272,
              "z": 0.513
            },
            "gtin": "4306188048350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d803e",
            "leftCorner": {
              "x": -6.501,
              "y": -6.496,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.497,
              "y": -6.669,
              "z": 0.513
            },
            "gtin": "4009700050403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d803f",
            "leftCorner": {
              "x": -6.496,
              "y": -6.669,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.494,
              "y": -6.792,
              "z": 0.513
            },
            "gtin": "4023600008715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8040",
            "leftCorner": {
              "x": -6.484,
              "y": -6.792,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.48,
              "y": -6.999,
              "z": 0.513
            },
            "gtin": "4023600008746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8041",
            "leftCorner": {
              "x": -6.559,
              "y": -7.001,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.555,
              "y": -7.221,
              "z": 0.513
            },
            "gtin": "4067517001896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8042",
            "leftCorner": {
              "x": -6.473,
              "y": -7.219,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.47,
              "y": -7.358,
              "z": 0.513
            },
            "gtin": "4306188048350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8043",
            "leftCorner": {
              "x": -6.47,
              "y": -7.358,
              "z": 0.513
            },
            "rightCorner": {
              "x": -6.466,
              "y": -7.549,
              "z": 0.513
            },
            "gtin": "2000442306065",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d50f",
        "height": 0.90355,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8060",
            "leftCorner": {
              "x": -6.502,
              "y": -6.274,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.497,
              "y": -6.489,
              "z": 0.739
            },
            "gtin": "4036500004831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8061",
            "leftCorner": {
              "x": -6.494,
              "y": -6.489,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.491,
              "y": -6.649,
              "z": 0.739
            },
            "gtin": "4036500004848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8062",
            "leftCorner": {
              "x": -6.49,
              "y": -6.649,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.488,
              "y": -6.744,
              "z": 0.739
            },
            "gtin": "4002334115791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8063",
            "leftCorner": {
              "x": -6.516,
              "y": -6.745,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.513,
              "y": -6.878,
              "z": 0.739
            },
            "gtin": "4002334115821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8064",
            "leftCorner": {
              "x": -6.485,
              "y": -6.878,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.482,
              "y": -7.044,
              "z": 0.739
            },
            "gtin": "4000980539312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8065",
            "leftCorner": {
              "x": -6.474,
              "y": -7.044,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.472,
              "y": -7.133,
              "z": 0.739
            },
            "gtin": "4009700046000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8066",
            "leftCorner": {
              "x": -6.476,
              "y": -7.133,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.474,
              "y": -7.248,
              "z": 0.739
            },
            "gtin": "4009700046185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8067",
            "leftCorner": {
              "x": -6.466,
              "y": -7.247,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.464,
              "y": -7.333,
              "z": 0.739
            },
            "gtin": "4770299402606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8068",
            "leftCorner": {
              "x": -6.462,
              "y": -7.333,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.461,
              "y": -7.399,
              "z": 0.739
            },
            "gtin": "4770299402569",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d804f",
            "leftCorner": {
              "x": -6.46,
              "y": -7.399,
              "z": 0.739
            },
            "rightCorner": {
              "x": -6.459,
              "y": -7.472,
              "z": 0.739
            },
            "gtin": "4770299402583",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d50c",
        "height": 1.1579,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f0c",
            "leftCorner": {
              "x": -6.498,
              "y": -6.304,
              "z": 0.947
            },
            "rightCorner": {
              "x": -6.495,
              "y": -6.44,
              "z": 0.947
            },
            "gtin": "4000980357428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5533bb042532981b8dd3b011",
            "leftCorner": {
              "x": -6.539,
              "y": -6.223,
              "z": 0.947
            },
            "rightCorner": {
              "x": -6.538,
              "y": -6.286,
              "z": 0.947
            },
            "gtin": "4025500294366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f0d",
            "leftCorner": {
              "x": -6.495,
              "y": -6.44,
              "z": 0.947
            },
            "rightCorner": {
              "x": -6.493,
              "y": -6.529,
              "z": 0.947
            },
            "gtin": "4067517001766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f0e",
            "leftCorner": {
              "x": -6.492,
              "y": -6.529,
              "z": 0.947
            },
            "rightCorner": {
              "x": -6.49,
              "y": -6.628,
              "z": 0.947
            },
            "gtin": "4067517001759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f0f",
            "leftCorner": {
              "x": -6.492,
              "y": -6.628,
              "z": 0.947
            },
            "rightCorner": {
              "x": -6.489,
              "y": -6.764,
              "z": 0.947
            },
            "gtin": "4067517001957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f10",
            "leftCorner": {
              "x": -6.573,
              "y": -6.765,
              "z": 0.947
            },
            "rightCorner": {
              "x": -6.57,
              "y": -6.913,
              "z": 0.947
            },
            "gtin": "4025500300319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f11",
            "leftCorner": {
              "x": -6.566,
              "y": -6.913,
              "z": 0.947
            },
            "rightCorner": {
              "x": -6.565,
              "y": -6.996,
              "z": 0.947
            },
            "gtin": "4025500294366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f12",
            "leftCorner": {
              "x": -6.477,
              "y": -6.995,
              "z": 0.947
            },
            "rightCorner": {
              "x": -6.475,
              "y": -7.104,
              "z": 0.947
            },
            "gtin": "4025500294342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f13",
            "leftCorner": {
              "x": -6.474,
              "y": -7.104,
              "z": 0.947
            },
            "rightCorner": {
              "x": -6.469,
              "y": -7.349,
              "z": 0.947
            },
            "gtin": "4025500299156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f14",
            "leftCorner": {
              "x": -6.465,
              "y": -7.349,
              "z": 0.947
            },
            "rightCorner": {
              "x": -6.461,
              "y": -7.515,
              "z": 0.947
            },
            "gtin": "4025500293291",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d50b",
        "height": 1.3814,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7eb1",
            "leftCorner": {
              "x": -6.515,
              "y": -6.271,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.512,
              "y": -6.425,
              "z": 1.13
            },
            "gtin": "4023600011807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eb2",
            "leftCorner": {
              "x": -6.505,
              "y": -6.424,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.502,
              "y": -6.539,
              "z": 1.13
            },
            "gtin": "4000521593506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eb3",
            "leftCorner": {
              "x": -6.496,
              "y": -6.539,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.494,
              "y": -6.663,
              "z": 1.13
            },
            "gtin": "40236643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eb4",
            "leftCorner": {
              "x": -6.492,
              "y": -6.663,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.489,
              "y": -6.781,
              "z": 1.13
            },
            "gtin": "40236605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eb5",
            "leftCorner": {
              "x": -6.492,
              "y": -6.781,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.489,
              "y": -6.93,
              "z": 1.13
            },
            "gtin": "4002334116903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eb6",
            "leftCorner": {
              "x": -6.49,
              "y": -6.93,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.487,
              "y": -7.081,
              "z": 1.13
            },
            "gtin": "4002334116897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eb7",
            "leftCorner": {
              "x": -6.478,
              "y": -7.081,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.473,
              "y": -7.31,
              "z": 1.13
            },
            "gtin": "4028900010000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eb8",
            "leftCorner": {
              "x": -6.469,
              "y": -7.31,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.467,
              "y": -7.396,
              "z": 1.13
            },
            "gtin": "4023600017946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eb9",
            "leftCorner": {
              "x": -6.463,
              "y": -7.396,
              "z": 1.13
            },
            "rightCorner": {
              "x": -6.46,
              "y": -7.553,
              "z": 1.13
            },
            "gtin": "4023600017144",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d50a",
        "height": 1.6067,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7fde",
            "leftCorner": {
              "x": -6.507,
              "y": -6.271,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.506,
              "y": -6.345,
              "z": 1.315
            },
            "gtin": "40236285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "340e4894c00c99fa704ab106",
            "leftCorner": {
              "x": -6.54,
              "y": -6.223,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.539,
              "y": -6.255,
              "z": 1.315
            },
            "gtin": "4002334111588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fb3de20fe27f55b60f7b31a9",
            "leftCorner": {
              "x": -6.516,
              "y": -7.388,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.514,
              "y": -7.464,
              "z": 1.315
            },
            "gtin": "40236285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fdf",
            "leftCorner": {
              "x": -6.503,
              "y": -6.345,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.501,
              "y": -6.443,
              "z": 1.315
            },
            "gtin": "40236896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fe0",
            "leftCorner": {
              "x": -6.499,
              "y": -6.443,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.498,
              "y": -6.531,
              "z": 1.315
            },
            "gtin": "8711399013107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fe1",
            "leftCorner": {
              "x": -6.497,
              "y": -6.53,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.496,
              "y": -6.621,
              "z": 1.315
            },
            "gtin": "8711399012278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fe2",
            "leftCorner": {
              "x": -6.494,
              "y": -6.621,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.492,
              "y": -6.726,
              "z": 1.315
            },
            "gtin": "4002334117917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fe3",
            "leftCorner": {
              "x": -6.49,
              "y": -6.726,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.488,
              "y": -6.819,
              "z": 1.315
            },
            "gtin": "4002334111618",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fe4",
            "leftCorner": {
              "x": -6.484,
              "y": -6.819,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.482,
              "y": -6.928,
              "z": 1.315
            },
            "gtin": "4002334111588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fe5",
            "leftCorner": {
              "x": -6.483,
              "y": -6.928,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.481,
              "y": -7.025,
              "z": 1.315
            },
            "gtin": "4002334117924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fe6",
            "leftCorner": {
              "x": -6.478,
              "y": -7.025,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.475,
              "y": -7.138,
              "z": 1.315
            },
            "gtin": "4260054653621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fe7",
            "leftCorner": {
              "x": -6.477,
              "y": -7.138,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.475,
              "y": -7.254,
              "z": 1.315
            },
            "gtin": "4260054653614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fe8",
            "leftCorner": {
              "x": -6.478,
              "y": -7.254,
              "z": 1.315
            },
            "rightCorner": {
              "x": -6.475,
              "y": -7.388,
              "z": 1.315
            },
            "gtin": "4025500143312",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d50d",
        "height": 1.831,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f68",
            "leftCorner": {
              "x": -6.504,
              "y": -6.287,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.501,
              "y": -6.414,
              "z": 1.498
            },
            "gtin": "3023290202111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f69",
            "leftCorner": {
              "x": -6.498,
              "y": -6.414,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.496,
              "y": -6.505,
              "z": 1.498
            },
            "gtin": "4002971200607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f6a",
            "leftCorner": {
              "x": -6.496,
              "y": -6.505,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.493,
              "y": -6.689,
              "z": 1.498
            },
            "gtin": "4002971200409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f6b",
            "leftCorner": {
              "x": -6.489,
              "y": -6.689,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.485,
              "y": -6.921,
              "z": 1.498
            },
            "gtin": "2000439330417",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f6c",
            "leftCorner": {
              "x": -6.482,
              "y": -6.921,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.479,
              "y": -7.073,
              "z": 1.498
            },
            "gtin": "4000521597108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f6d",
            "leftCorner": {
              "x": -6.475,
              "y": -7.073,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.472,
              "y": -7.236,
              "z": 1.498
            },
            "gtin": "4023600014389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f6e",
            "leftCorner": {
              "x": -6.474,
              "y": -7.236,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.471,
              "y": -7.389,
              "z": 1.498
            },
            "gtin": "4000521597009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f6f",
            "leftCorner": {
              "x": -6.473,
              "y": -7.389,
              "z": 1.498
            },
            "rightCorner": {
              "x": -6.47,
              "y": -7.549,
              "z": 1.498
            },
            "gtin": "4023600203233",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ae8",
    "rightNeighborShelfId": "4d6"
  },
  {
    "id": "ae8",
    "name": "ae8",
    "x": -6.631,
    "y": -5.6,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69989,
      "w": 0.71425
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d505",
        "height": 0.6241,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8037",
            "leftCorner": {
              "x": -6.516,
              "y": -5.673,
              "z": 0.511
            },
            "rightCorner": {
              "x": -6.514,
              "y": -5.763,
              "z": 0.511
            },
            "gtin": "4002971253207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "793ebcfc56b35482d0701ab0",
            "leftCorner": {
              "x": -6.561,
              "y": -5.599,
              "z": 0.511
            },
            "rightCorner": {
              "x": -6.559,
              "y": -5.666,
              "z": 0.511
            },
            "gtin": "4002971254006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8038",
            "leftCorner": {
              "x": -6.509,
              "y": -5.762,
              "z": 0.511
            },
            "rightCorner": {
              "x": -6.507,
              "y": -5.857,
              "z": 0.511
            },
            "gtin": "4002971253603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8039",
            "leftCorner": {
              "x": -6.514,
              "y": -5.857,
              "z": 0.511
            },
            "rightCorner": {
              "x": -6.513,
              "y": -5.945,
              "z": 0.511
            },
            "gtin": "4002971253504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d803a",
            "leftCorner": {
              "x": -6.515,
              "y": -5.945,
              "z": 0.511
            },
            "rightCorner": {
              "x": -6.513,
              "y": -6.046,
              "z": 0.511
            },
            "gtin": "4002971253702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d803b",
            "leftCorner": {
              "x": -6.514,
              "y": -6.046,
              "z": 0.511
            },
            "rightCorner": {
              "x": -6.512,
              "y": -6.155,
              "z": 0.511
            },
            "gtin": "4002971295702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d803c",
            "leftCorner": {
              "x": -6.508,
              "y": -6.155,
              "z": 0.511
            },
            "rightCorner": {
              "x": -6.506,
              "y": -6.296,
              "z": 0.511
            },
            "gtin": "4002971254006",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d507",
        "height": 0.89853,
        "facings": [
          {
            "id": "68d8e50de1820c81800d8059",
            "leftCorner": {
              "x": -6.592,
              "y": -5.632,
              "z": 0.735
            },
            "rightCorner": {
              "x": -6.591,
              "y": -5.706,
              "z": 0.735
            },
            "gtin": "4002971253900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d805a",
            "leftCorner": {
              "x": -6.51,
              "y": -5.704,
              "z": 0.735
            },
            "rightCorner": {
              "x": -6.509,
              "y": -5.763,
              "z": 0.735
            },
            "gtin": "4002971253108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d805b",
            "leftCorner": {
              "x": -6.509,
              "y": -5.763,
              "z": 0.735
            },
            "rightCorner": {
              "x": -6.508,
              "y": -5.822,
              "z": 0.735
            },
            "gtin": "4002971253108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d805c",
            "leftCorner": {
              "x": -6.508,
              "y": -5.822,
              "z": 0.735
            },
            "rightCorner": {
              "x": -6.507,
              "y": -5.881,
              "z": 0.735
            },
            "gtin": "4002971253108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d805d",
            "leftCorner": {
              "x": -6.521,
              "y": -5.881,
              "z": 0.735
            },
            "rightCorner": {
              "x": -6.519,
              "y": -5.978,
              "z": 0.735
            },
            "gtin": "4002971270907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d805e",
            "leftCorner": {
              "x": -6.513,
              "y": -5.978,
              "z": 0.735
            },
            "rightCorner": {
              "x": -6.51,
              "y": -6.106,
              "z": 0.735
            },
            "gtin": "4002971295603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d805f",
            "leftCorner": {
              "x": -6.508,
              "y": -6.106,
              "z": 0.735
            },
            "rightCorner": {
              "x": -6.505,
              "y": -6.279,
              "z": 0.735
            },
            "gtin": "4002971253009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d508",
        "height": 1.1496,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f07",
            "leftCorner": {
              "x": -6.508,
              "y": -5.68,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.506,
              "y": -5.785,
              "z": 0.941
            },
            "gtin": "4009700071170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f64431f10a7fc527c8a3b510",
            "leftCorner": {
              "x": -6.56,
              "y": -5.599,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.559,
              "y": -5.637,
              "z": 0.941
            },
            "gtin": "4002971277500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b4adb43b504a5b1ab3314ae8",
            "leftCorner": {
              "x": -6.559,
              "y": -5.637,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.558,
              "y": -5.676,
              "z": 0.941
            },
            "gtin": "4002971277500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f08",
            "leftCorner": {
              "x": -6.509,
              "y": -5.785,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.505,
              "y": -5.956,
              "z": 0.941
            },
            "gtin": "4002971453201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f09",
            "leftCorner": {
              "x": -6.515,
              "y": -5.956,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.513,
              "y": -6.065,
              "z": 0.941
            },
            "gtin": "4002971340402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f0a",
            "leftCorner": {
              "x": -6.51,
              "y": -6.065,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.508,
              "y": -6.18,
              "z": 0.941
            },
            "gtin": "4002971340303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f0b",
            "leftCorner": {
              "x": -6.502,
              "y": -6.18,
              "z": 0.941
            },
            "rightCorner": {
              "x": -6.499,
              "y": -6.31,
              "z": 0.941
            },
            "gtin": "4002971277500",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d506",
        "height": 1.3739,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ea8",
            "leftCorner": {
              "x": -6.597,
              "y": -5.646,
              "z": 1.124
            },
            "rightCorner": {
              "x": -6.596,
              "y": -5.711,
              "z": 1.124
            },
            "gtin": "4002971247503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a292d91fd732198c0de7b227",
            "leftCorner": {
              "x": -6.568,
              "y": -5.599,
              "z": 1.124
            },
            "rightCorner": {
              "x": -6.567,
              "y": -5.638,
              "z": 1.124
            },
            "gtin": "4002971247503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fccabf20de876d25beb6a027",
            "leftCorner": {
              "x": -6.565,
              "y": -5.736,
              "z": 1.124
            },
            "rightCorner": {
              "x": -6.565,
              "y": -5.775,
              "z": 1.124
            },
            "gtin": "4002971247503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ea9",
            "leftCorner": {
              "x": -6.522,
              "y": -5.709,
              "z": 1.124
            },
            "rightCorner": {
              "x": -6.522,
              "y": -5.735,
              "z": 1.124
            },
            "gtin": "4002971275902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eab",
            "leftCorner": {
              "x": -6.523,
              "y": -5.793,
              "z": 1.124
            },
            "rightCorner": {
              "x": -6.521,
              "y": -5.884,
              "z": 1.124
            },
            "gtin": "4002971244403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eac",
            "leftCorner": {
              "x": -6.522,
              "y": -5.884,
              "z": 1.124
            },
            "rightCorner": {
              "x": -6.521,
              "y": -5.974,
              "z": 1.124
            },
            "gtin": "4002971282108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ead",
            "leftCorner": {
              "x": -6.529,
              "y": -5.974,
              "z": 1.124
            },
            "rightCorner": {
              "x": -6.527,
              "y": -6.067,
              "z": 1.124
            },
            "gtin": "4002971247909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eae",
            "leftCorner": {
              "x": -6.527,
              "y": -6.067,
              "z": 1.124
            },
            "rightCorner": {
              "x": -6.526,
              "y": -6.094,
              "z": 1.124
            },
            "gtin": "4002971454703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eaf",
            "leftCorner": {
              "x": -6.491,
              "y": -6.093,
              "z": 1.124
            },
            "rightCorner": {
              "x": -6.489,
              "y": -6.151,
              "z": 1.124
            },
            "gtin": "4002971454703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eb0",
            "leftCorner": {
              "x": -6.524,
              "y": -6.152,
              "z": 1.124
            },
            "rightCorner": {
              "x": -6.522,
              "y": -6.276,
              "z": 1.124
            },
            "gtin": "4002971244502",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d503",
        "height": 1.6057,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7fd8",
            "leftCorner": {
              "x": -6.512,
              "y": -5.699,
              "z": 1.314
            },
            "rightCorner": {
              "x": -6.51,
              "y": -5.804,
              "z": 1.314
            },
            "gtin": "4002971283808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aa2396468d1401c817204b51",
            "leftCorner": {
              "x": -6.566,
              "y": -5.599,
              "z": 1.314
            },
            "rightCorner": {
              "x": -6.564,
              "y": -5.695,
              "z": 1.314
            },
            "gtin": "4002971243901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fd9",
            "leftCorner": {
              "x": -6.504,
              "y": -5.804,
              "z": 1.314
            },
            "rightCorner": {
              "x": -6.502,
              "y": -5.892,
              "z": 1.314
            },
            "gtin": "4002971283907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fda",
            "leftCorner": {
              "x": -6.521,
              "y": -5.892,
              "z": 1.314
            },
            "rightCorner": {
              "x": -6.519,
              "y": -5.987,
              "z": 1.314
            },
            "gtin": "4002971243901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fdb",
            "leftCorner": {
              "x": -6.518,
              "y": -5.987,
              "z": 1.314
            },
            "rightCorner": {
              "x": -6.516,
              "y": -6.069,
              "z": 1.314
            },
            "gtin": "4002971280906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fdc",
            "leftCorner": {
              "x": -6.517,
              "y": -6.069,
              "z": 1.314
            },
            "rightCorner": {
              "x": -6.515,
              "y": -6.153,
              "z": 1.314
            },
            "gtin": "4002971243802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fdd",
            "leftCorner": {
              "x": -6.513,
              "y": -6.153,
              "z": 1.314
            },
            "rightCorner": {
              "x": -6.511,
              "y": -6.276,
              "z": 1.314
            },
            "gtin": "4002971243703",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d504",
        "height": 1.8265,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f62",
            "leftCorner": {
              "x": -6.516,
              "y": -5.726,
              "z": 1.494
            },
            "rightCorner": {
              "x": -6.514,
              "y": -5.829,
              "z": 1.494
            },
            "gtin": "8711399020747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dcbb9fea4e3e6bd28339a407",
            "leftCorner": {
              "x": -6.563,
              "y": -5.599,
              "z": 1.494
            },
            "rightCorner": {
              "x": -6.561,
              "y": -5.706,
              "z": 1.494
            },
            "gtin": "8711399020747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "73489057bb27d62b5672851d",
            "leftCorner": {
              "x": -6.561,
              "y": -5.706,
              "z": 1.494
            },
            "rightCorner": {
              "x": -6.56,
              "y": -5.727,
              "z": 1.494
            },
            "gtin": "4023600017236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f63",
            "leftCorner": {
              "x": -6.519,
              "y": -5.829,
              "z": 1.494
            },
            "rightCorner": {
              "x": -6.517,
              "y": -5.92,
              "z": 1.494
            },
            "gtin": "4023600013474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f64",
            "leftCorner": {
              "x": -6.519,
              "y": -5.92,
              "z": 1.494
            },
            "rightCorner": {
              "x": -6.517,
              "y": -6.01,
              "z": 1.494
            },
            "gtin": "4023600013511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f65",
            "leftCorner": {
              "x": -6.515,
              "y": -6.01,
              "z": 1.494
            },
            "rightCorner": {
              "x": -6.514,
              "y": -6.091,
              "z": 1.494
            },
            "gtin": "4023600013498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f66",
            "leftCorner": {
              "x": -6.513,
              "y": -6.091,
              "z": 1.494
            },
            "rightCorner": {
              "x": -6.511,
              "y": -6.184,
              "z": 1.494
            },
            "gtin": "4023600015195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f67",
            "leftCorner": {
              "x": -6.507,
              "y": -6.184,
              "z": 1.494
            },
            "rightCorner": {
              "x": -6.505,
              "y": -6.293,
              "z": 1.494
            },
            "gtin": "4023600017236",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ae9",
    "rightNeighborShelfId": "ae7"
  },
  {
    "id": "ae9",
    "name": "ae9",
    "x": -6.666,
    "y": -4.347,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.69797,
      "w": 0.71613
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 55
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d500",
        "height": 0.62583,
        "facings": [
          {
            "id": "68d8e50de1820c81800d802d",
            "leftCorner": {
              "x": -6.592,
              "y": -4.345,
              "z": 0.512
            },
            "rightCorner": {
              "x": -6.587,
              "y": -4.551,
              "z": 0.512
            },
            "gtin": "4306188041306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d802f",
            "leftCorner": {
              "x": -6.541,
              "y": -4.55,
              "z": 0.512
            },
            "rightCorner": {
              "x": -6.537,
              "y": -4.703,
              "z": 0.512
            },
            "gtin": "4306188041344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8030",
            "leftCorner": {
              "x": -6.611,
              "y": -4.705,
              "z": 0.512
            },
            "rightCorner": {
              "x": -6.608,
              "y": -4.819,
              "z": 0.512
            },
            "gtin": "3228021000084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8031",
            "leftCorner": {
              "x": -6.608,
              "y": -4.819,
              "z": 0.512
            },
            "rightCorner": {
              "x": -6.605,
              "y": -4.933,
              "z": 0.512
            },
            "gtin": "3228021000084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8032",
            "leftCorner": {
              "x": -6.605,
              "y": -4.933,
              "z": 0.512
            },
            "rightCorner": {
              "x": -6.602,
              "y": -5.048,
              "z": 0.512
            },
            "gtin": "3228021000084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8033",
            "leftCorner": {
              "x": -6.522,
              "y": -5.045,
              "z": 0.512
            },
            "rightCorner": {
              "x": -6.517,
              "y": -5.249,
              "z": 0.512
            },
            "gtin": "5025878004849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8034",
            "leftCorner": {
              "x": -6.529,
              "y": -5.249,
              "z": 0.512
            },
            "rightCorner": {
              "x": -6.525,
              "y": -5.416,
              "z": 0.512
            },
            "gtin": "4250365902273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8035",
            "leftCorner": {
              "x": -6.529,
              "y": -5.416,
              "z": 0.512
            },
            "rightCorner": {
              "x": -6.526,
              "y": -5.538,
              "z": 0.512
            },
            "gtin": "4000436152508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8036",
            "leftCorner": {
              "x": -6.521,
              "y": -5.538,
              "z": 0.512
            },
            "rightCorner": {
              "x": -6.518,
              "y": -5.669,
              "z": 0.512
            },
            "gtin": "4002971274301",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d501",
        "height": 0.89963,
        "facings": [
          {
            "id": "68d8e50de1820c81800d804e",
            "leftCorner": {
              "x": -6.604,
              "y": -4.345,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.602,
              "y": -4.442,
              "z": 0.736
            },
            "gtin": "4001954165513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee9f169ca79d6e694fb44053",
            "leftCorner": {
              "x": -6.601,
              "y": -4.442,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.601,
              "y": -4.463,
              "z": 0.736
            },
            "gtin": "4002971253900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0894c48cad6a1330d35d8ee6",
            "leftCorner": {
              "x": -6.601,
              "y": -4.463,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.6,
              "y": -4.484,
              "z": 0.736
            },
            "gtin": "4002971253900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8051",
            "leftCorner": {
              "x": -6.541,
              "y": -4.497,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.538,
              "y": -4.615,
              "z": 0.736
            },
            "gtin": "4001954165018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8052",
            "leftCorner": {
              "x": -6.534,
              "y": -4.615,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.531,
              "y": -4.709,
              "z": 0.736
            },
            "gtin": "4001954166053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8053",
            "leftCorner": {
              "x": -6.608,
              "y": -4.711,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.603,
              "y": -4.935,
              "z": 0.736
            },
            "gtin": "4001954161904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8054",
            "leftCorner": {
              "x": -6.565,
              "y": -4.934,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.561,
              "y": -5.092,
              "z": 0.736
            },
            "gtin": "4001954165803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8055",
            "leftCorner": {
              "x": -6.561,
              "y": -5.092,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.557,
              "y": -5.25,
              "z": 0.736
            },
            "gtin": "4001954165803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8056",
            "leftCorner": {
              "x": -6.522,
              "y": -5.249,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.519,
              "y": -5.352,
              "z": 0.736
            },
            "gtin": "4001954165834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8057",
            "leftCorner": {
              "x": -6.595,
              "y": -5.354,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.593,
              "y": -5.461,
              "z": 0.736
            },
            "gtin": "4001954161294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d8058",
            "leftCorner": {
              "x": -6.52,
              "y": -5.459,
              "z": 0.736
            },
            "rightCorner": {
              "x": -6.515,
              "y": -5.626,
              "z": 0.736
            },
            "gtin": "4001954000050",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4fd",
        "height": 1.1535,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7efc",
            "leftCorner": {
              "x": -6.581,
              "y": -4.345,
              "z": 0.944
            },
            "rightCorner": {
              "x": -6.579,
              "y": -4.418,
              "z": 0.944
            },
            "gtin": "4100290068639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7efd",
            "leftCorner": {
              "x": -6.579,
              "y": -4.418,
              "z": 0.944
            },
            "rightCorner": {
              "x": -6.577,
              "y": -4.491,
              "z": 0.944
            },
            "gtin": "4100290068639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7eff",
            "leftCorner": {
              "x": -6.538,
              "y": -4.49,
              "z": 0.944
            },
            "rightCorner": {
              "x": -6.535,
              "y": -4.629,
              "z": 0.944
            },
            "gtin": "4100290068608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f00",
            "leftCorner": {
              "x": -6.53,
              "y": -4.629,
              "z": 0.944
            },
            "rightCorner": {
              "x": -6.527,
              "y": -4.752,
              "z": 0.944
            },
            "gtin": "4100290068615",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7f01",
            "leftCorner": {
              "x": -6.526,
              "y": -4.752,
              "z": 0.944
            },
            "rightCorner": {
              "x": -6.52,
              "y": -4.963,
              "z": 0.944
            },
            "gtin": "5711953127779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f02",
            "leftCorner": {
              "x": -6.522,
              "y": -4.963,
              "z": 0.944
            },
            "rightCorner": {
              "x": -6.516,
              "y": -5.188,
              "z": 0.944
            },
            "gtin": "4008452010222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f03",
            "leftCorner": {
              "x": -6.52,
              "y": -5.188,
              "z": 0.944
            },
            "rightCorner": {
              "x": -6.516,
              "y": -5.334,
              "z": 0.944
            },
            "gtin": "4067517000349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f04",
            "leftCorner": {
              "x": -6.518,
              "y": -5.334,
              "z": 0.944
            },
            "rightCorner": {
              "x": -6.515,
              "y": -5.432,
              "z": 0.944
            },
            "gtin": "4250017300914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f05",
            "leftCorner": {
              "x": -6.518,
              "y": -5.432,
              "z": 0.944
            },
            "rightCorner": {
              "x": -6.515,
              "y": -5.537,
              "z": 0.944
            },
            "gtin": "4046700009338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f06",
            "leftCorner": {
              "x": -6.507,
              "y": -5.537,
              "z": 0.944
            },
            "rightCorner": {
              "x": -6.503,
              "y": -5.675,
              "z": 0.944
            },
            "gtin": "4009700050410",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4fc",
        "height": 1.3772,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7e9e",
            "leftCorner": {
              "x": -6.591,
              "y": -4.345,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.589,
              "y": -4.446,
              "z": 1.127
            },
            "gtin": "4034900008411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ea1",
            "leftCorner": {
              "x": -6.547,
              "y": -4.472,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.544,
              "y": -4.583,
              "z": 1.127
            },
            "gtin": "8719200203440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ea2",
            "leftCorner": {
              "x": -6.548,
              "y": -4.583,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.543,
              "y": -4.768,
              "z": 1.127
            },
            "gtin": "4034900008145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ea3",
            "leftCorner": {
              "x": -6.533,
              "y": -4.768,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.525,
              "y": -5.084,
              "z": 1.127
            },
            "gtin": "40349558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ea4",
            "leftCorner": {
              "x": -6.532,
              "y": -5.084,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.529,
              "y": -5.191,
              "z": 1.127
            },
            "gtin": "4067517000806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ea5",
            "leftCorner": {
              "x": -6.529,
              "y": -5.191,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.527,
              "y": -5.281,
              "z": 1.127
            },
            "gtin": "4008452036130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ea6",
            "leftCorner": {
              "x": -6.528,
              "y": -5.281,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.523,
              "y": -5.465,
              "z": 1.127
            },
            "gtin": "4001954000036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ea7",
            "leftCorner": {
              "x": -6.523,
              "y": -5.465,
              "z": 1.127
            },
            "rightCorner": {
              "x": -6.519,
              "y": -5.64,
              "z": 1.127
            },
            "gtin": "42230281",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4ff",
        "height": 1.6047,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7fcc",
            "leftCorner": {
              "x": -6.585,
              "y": -4.345,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.581,
              "y": -4.481,
              "z": 1.313
            },
            "gtin": "5410093162090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fce",
            "leftCorner": {
              "x": -6.548,
              "y": -4.48,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.544,
              "y": -4.611,
              "z": 1.313
            },
            "gtin": "4250426214154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fcf",
            "leftCorner": {
              "x": -6.538,
              "y": -4.611,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.535,
              "y": -4.723,
              "z": 1.313
            },
            "gtin": "40349343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fd0",
            "leftCorner": {
              "x": -6.53,
              "y": -4.723,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.528,
              "y": -4.793,
              "z": 1.313
            },
            "gtin": "4034900006103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fd1",
            "leftCorner": {
              "x": -6.528,
              "y": -4.793,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.526,
              "y": -4.879,
              "z": 1.313
            },
            "gtin": "4034900006172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fd2",
            "leftCorner": {
              "x": -6.53,
              "y": -4.879,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.526,
              "y": -5.032,
              "z": 1.313
            },
            "gtin": "40349275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fd3",
            "leftCorner": {
              "x": -6.525,
              "y": -5.032,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.52,
              "y": -5.224,
              "z": 1.313
            },
            "gtin": "4034900011213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fd4",
            "leftCorner": {
              "x": -6.522,
              "y": -5.224,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.52,
              "y": -5.308,
              "z": 1.313
            },
            "gtin": "4034900011244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fd5",
            "leftCorner": {
              "x": -6.528,
              "y": -5.308,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.524,
              "y": -5.434,
              "z": 1.313
            },
            "gtin": "40349251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fd6",
            "leftCorner": {
              "x": -6.608,
              "y": -5.436,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.605,
              "y": -5.566,
              "z": 1.313
            },
            "gtin": "4034900006141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7fd7",
            "leftCorner": {
              "x": -6.605,
              "y": -5.566,
              "z": 1.313
            },
            "rightCorner": {
              "x": -6.602,
              "y": -5.697,
              "z": 1.313
            },
            "gtin": "4034900006141",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d4fe",
        "height": 1.8247,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7f5a",
            "leftCorner": {
              "x": -6.586,
              "y": -4.345,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.582,
              "y": -4.484,
              "z": 1.493
            },
            "gtin": "8719200262300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f5c",
            "leftCorner": {
              "x": -6.542,
              "y": -4.483,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.539,
              "y": -4.612,
              "z": 1.493
            },
            "gtin": "8719200233539",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f5d",
            "leftCorner": {
              "x": -6.538,
              "y": -4.612,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.532,
              "y": -4.823,
              "z": 1.493
            },
            "gtin": "8719200233744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f5e",
            "leftCorner": {
              "x": -6.531,
              "y": -4.823,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.525,
              "y": -5.034,
              "z": 1.493
            },
            "gtin": "8719200233508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f5f",
            "leftCorner": {
              "x": -6.528,
              "y": -5.034,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.523,
              "y": -5.219,
              "z": 1.493
            },
            "gtin": "4002724000775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f60",
            "leftCorner": {
              "x": -6.524,
              "y": -5.219,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.518,
              "y": -5.455,
              "z": 1.493
            },
            "gtin": "4002724000997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7f61",
            "leftCorner": {
              "x": -6.519,
              "y": -5.455,
              "z": 1.493
            },
            "rightCorner": {
              "x": -6.512,
              "y": -5.721,
              "z": 1.493
            },
            "gtin": "40309057",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "ae8"
  },
  {
    "id": "c15",
    "name": "c15",
    "x": -28.351,
    "y": -23.617,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71609,
      "w": 0.698
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 4
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d771",
        "height": 0.15607,
        "facings": [
          {
            "id": "2620a5c8b5b5cdd84e81522e",
            "leftCorner": {
              "x": -28.328,
              "y": -23.616,
              "z": 0.128
            },
            "rightCorner": {
              "x": -28.34,
              "y": -23.163,
              "z": 0.128
            },
            "gtin": "8004260454162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "82067f2779417f5321688ba1",
            "leftCorner": {
              "x": -28.34,
              "y": -23.163,
              "z": 0.128
            },
            "rightCorner": {
              "x": -28.354,
              "y": -22.616,
              "z": 0.128
            },
            "gtin": "4000139902608",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d770",
        "height": 1.6323,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8936",
            "leftCorner": {
              "x": -28.432,
              "y": -23.619,
              "z": 1.335
            },
            "rightCorner": {
              "x": -28.447,
              "y": -23.032,
              "z": 1.335
            },
            "gtin": "4000139902608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8937",
            "leftCorner": {
              "x": -28.487,
              "y": -23.033,
              "z": 1.335
            },
            "rightCorner": {
              "x": -28.498,
              "y": -22.62,
              "z": 1.335
            },
            "gtin": "8004260454162",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "c16"
  },
  {
    "id": "c16",
    "name": "c16",
    "x": -28.376,
    "y": -22.617,
    "width": 0.63,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71609,
      "w": 0.698
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 2
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d38b",
        "height": 0.4484,
        "facings": []
      },
      {
        "id": "68d8d40055f889d41539d38a",
        "height": 1.6076,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7039",
            "leftCorner": {
              "x": -28.339,
              "y": -22.615,
              "z": 1.315
            },
            "rightCorner": {
              "x": -28.351,
              "y": -22.155,
              "z": 1.315
            },
            "gtin": "4262419330451",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d703a",
            "leftCorner": {
              "x": -28.391,
              "y": -22.156,
              "z": 1.315
            },
            "rightCorner": {
              "x": -28.395,
              "y": -21.987,
              "z": 1.315
            },
            "gtin": "7322541458960",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c15"
  },
  {
    "id": "c17",
    "name": "c17",
    "x": -29.074,
    "y": -22.141,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 0.002522
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 99
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d777",
        "height": 0.17388,
        "facings": [
          {
            "id": "4521891555a94fa7546206a9",
            "leftCorner": {
              "x": -29.074,
              "y": -22.163,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.113,
              "y": -22.163,
              "z": 0.142
            },
            "gtin": "4006000192345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "734fc8839a1f6ddfa179b5a4",
            "leftCorner": {
              "x": -29.113,
              "y": -22.163,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.166,
              "y": -22.163,
              "z": 0.142
            },
            "gtin": "8700216170260",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4cf5fba5f8d89d23ddddc367",
            "leftCorner": {
              "x": -29.166,
              "y": -22.163,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.22,
              "y": -22.164,
              "z": 0.142
            },
            "gtin": "8700216557689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bd216742abd8fafa3b172460",
            "leftCorner": {
              "x": -29.22,
              "y": -22.164,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.28,
              "y": -22.164,
              "z": 0.142
            },
            "gtin": "5037156288544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "757be27c4392566ea4e51ab8",
            "leftCorner": {
              "x": -29.28,
              "y": -22.164,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.34,
              "y": -22.164,
              "z": 0.142
            },
            "gtin": "8001090094384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4acc61cdec067fe508b31e49",
            "leftCorner": {
              "x": -29.34,
              "y": -22.164,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.4,
              "y": -22.165,
              "z": 0.142
            },
            "gtin": "8006540430880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "64f92991dee26dbb29ceb094",
            "leftCorner": {
              "x": -29.4,
              "y": -22.165,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.462,
              "y": -22.165,
              "z": 0.142
            },
            "gtin": "4005900910141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6e2bf59319c6338a6d2082d5",
            "leftCorner": {
              "x": -29.462,
              "y": -22.165,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.524,
              "y": -22.165,
              "z": 0.142
            },
            "gtin": "4006000192307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cfa04bb02adbddb4956ac657",
            "leftCorner": {
              "x": -29.524,
              "y": -22.165,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.587,
              "y": -22.166,
              "z": 0.142
            },
            "gtin": "5037156388534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a7bfdbc4f153ea4d43cd7453",
            "leftCorner": {
              "x": -29.587,
              "y": -22.166,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.654,
              "y": -22.166,
              "z": 0.142
            },
            "gtin": "5037156278125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f35dab647d80729307389855",
            "leftCorner": {
              "x": -29.654,
              "y": -22.166,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.727,
              "y": -22.166,
              "z": 0.142
            },
            "gtin": "4015100813395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6757a359dd06ef40733d1f1b",
            "leftCorner": {
              "x": -29.727,
              "y": -22.166,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.804,
              "y": -22.167,
              "z": 0.142
            },
            "gtin": "5037156388527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "77cde0277069f120bd4c6b55",
            "leftCorner": {
              "x": -29.804,
              "y": -22.167,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.889,
              "y": -22.167,
              "z": 0.142
            },
            "gtin": "8001090633323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2891ce4aabcceee8958593d9",
            "leftCorner": {
              "x": -29.889,
              "y": -22.167,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.974,
              "y": -22.168,
              "z": 0.142
            },
            "gtin": "4015100812435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c7013e0aae05fbe0e2f3302a",
            "leftCorner": {
              "x": -29.974,
              "y": -22.168,
              "z": 0.142
            },
            "rightCorner": {
              "x": -30.06,
              "y": -22.168,
              "z": 0.142
            },
            "gtin": "4015100812275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "65a4e6bcb069be2ed2bab1b9",
            "leftCorner": {
              "x": -30.06,
              "y": -22.168,
              "z": 0.142
            },
            "rightCorner": {
              "x": -30.195,
              "y": -22.169,
              "z": 0.142
            },
            "gtin": "4005900917744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "eeb0ee39951159be1c71958d",
            "leftCorner": {
              "x": -30.195,
              "y": -22.169,
              "z": 0.142
            },
            "rightCorner": {
              "x": -30.302,
              "y": -22.169,
              "z": 0.142
            },
            "gtin": "8700216151535",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d772",
        "height": 0.46729,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d893a",
            "leftCorner": {
              "x": -29.074,
              "y": -22.178,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.167,
              "y": -22.179,
              "z": 0.382
            },
            "gtin": "4006000193991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d893f",
            "leftCorner": {
              "x": -29.167,
              "y": -22.203,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.221,
              "y": -22.203,
              "z": 0.382
            },
            "gtin": "4006000193991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8940",
            "leftCorner": {
              "x": -29.221,
              "y": -22.205,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.283,
              "y": -22.205,
              "z": 0.382
            },
            "gtin": "4006000029702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8941",
            "leftCorner": {
              "x": -29.283,
              "y": -22.207,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.33,
              "y": -22.207,
              "z": 0.382
            },
            "gtin": "4005900917867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8942",
            "leftCorner": {
              "x": -29.33,
              "y": -22.208,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.392,
              "y": -22.209,
              "z": 0.382
            },
            "gtin": "4005900917904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8943",
            "leftCorner": {
              "x": -29.392,
              "y": -22.214,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.493,
              "y": -22.214,
              "z": 0.382
            },
            "gtin": "4005900910226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8944",
            "leftCorner": {
              "x": -29.493,
              "y": -22.217,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.577,
              "y": -22.218,
              "z": 0.382
            },
            "gtin": "4005900910349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8945",
            "leftCorner": {
              "x": -29.577,
              "y": -22.221,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.648,
              "y": -22.221,
              "z": 0.382
            },
            "gtin": "4005900917959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8946",
            "leftCorner": {
              "x": -29.648,
              "y": -22.223,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.689,
              "y": -22.223,
              "z": 0.382
            },
            "gtin": "4005900910301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8947",
            "leftCorner": {
              "x": -29.689,
              "y": -22.222,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.736,
              "y": -22.223,
              "z": 0.382
            },
            "gtin": "4005900917669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8948",
            "leftCorner": {
              "x": -29.736,
              "y": -22.222,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.826,
              "y": -22.222,
              "z": 0.382
            },
            "gtin": "4005900917706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8949",
            "leftCorner": {
              "x": -29.826,
              "y": -22.226,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.899,
              "y": -22.227,
              "z": 0.382
            },
            "gtin": "4008666271389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d894a",
            "leftCorner": {
              "x": -29.899,
              "y": -22.229,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.955,
              "y": -22.229,
              "z": 0.382
            },
            "gtin": "4008666210517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d894b",
            "leftCorner": {
              "x": -29.955,
              "y": -22.231,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.03,
              "y": -22.231,
              "z": 0.382
            },
            "gtin": "4008666203663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d893b",
            "leftCorner": {
              "x": -30.03,
              "y": -22.222,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.104,
              "y": -22.223,
              "z": 0.382
            },
            "gtin": "4008666213921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d893c",
            "leftCorner": {
              "x": -30.104,
              "y": -22.223,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.177,
              "y": -22.223,
              "z": 0.382
            },
            "gtin": "4008666213921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d893d",
            "leftCorner": {
              "x": -30.177,
              "y": -22.223,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.251,
              "y": -22.223,
              "z": 0.382
            },
            "gtin": "4008666213921",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d893e",
            "leftCorner": {
              "x": -30.251,
              "y": -22.223,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.324,
              "y": -22.224,
              "z": 0.382
            },
            "gtin": "4008666213921",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d776",
        "height": 0.76772,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d897e",
            "leftCorner": {
              "x": -29.074,
              "y": -22.176,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.169,
              "y": -22.177,
              "z": 0.628
            },
            "gtin": "8001090369437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8980",
            "leftCorner": {
              "x": -29.169,
              "y": -22.204,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.246,
              "y": -22.204,
              "z": 0.628
            },
            "gtin": "8700216558136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8981",
            "leftCorner": {
              "x": -29.246,
              "y": -22.203,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.296,
              "y": -22.203,
              "z": 0.628
            },
            "gtin": "8700216422437",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8982",
            "leftCorner": {
              "x": -29.296,
              "y": -22.206,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.41,
              "y": -22.207,
              "z": 0.628
            },
            "gtin": "8700216422413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8983",
            "leftCorner": {
              "x": -29.41,
              "y": -22.194,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.502,
              "y": -22.194,
              "z": 0.628
            },
            "gtin": "8700216422116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8984",
            "leftCorner": {
              "x": -29.513,
              "y": -22.222,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.66,
              "y": -22.223,
              "z": 0.628
            },
            "gtin": "8700216502672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8985",
            "leftCorner": {
              "x": -29.66,
              "y": -22.22,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.7,
              "y": -22.22,
              "z": 0.628
            },
            "gtin": "8700216558174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8986",
            "leftCorner": {
              "x": -29.7,
              "y": -22.219,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.75,
              "y": -22.22,
              "z": 0.628
            },
            "gtin": "8700216558471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8987",
            "leftCorner": {
              "x": -29.75,
              "y": -22.221,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.789,
              "y": -22.221,
              "z": 0.628
            },
            "gtin": "8700216558761",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8988",
            "leftCorner": {
              "x": -29.789,
              "y": -22.22,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.868,
              "y": -22.22,
              "z": 0.628
            },
            "gtin": "8001090094353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8989",
            "leftCorner": {
              "x": -29.868,
              "y": -22.225,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.928,
              "y": -22.226,
              "z": 0.628
            },
            "gtin": "8006540849316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d898a",
            "leftCorner": {
              "x": -29.928,
              "y": -22.226,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.986,
              "y": -22.226,
              "z": 0.628
            },
            "gtin": "8006540849354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d898b",
            "leftCorner": {
              "x": -29.986,
              "y": -22.228,
              "z": 0.628
            },
            "rightCorner": {
              "x": -30.032,
              "y": -22.228,
              "z": 0.628
            },
            "gtin": "8700216558037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d897f",
            "leftCorner": {
              "x": -30.032,
              "y": -22.205,
              "z": 0.628
            },
            "rightCorner": {
              "x": -30.324,
              "y": -22.207,
              "z": 0.628
            },
            "gtin": "8700216558730",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d775",
        "height": 1.0552,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d896b",
            "leftCorner": {
              "x": -29.074,
              "y": -22.18,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.146,
              "y": -22.18,
              "z": 0.863
            },
            "gtin": "8700216173476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d896f",
            "leftCorner": {
              "x": -29.146,
              "y": -22.206,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.198,
              "y": -22.207,
              "z": 0.863
            },
            "gtin": "8700216170239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8970",
            "leftCorner": {
              "x": -29.198,
              "y": -22.207,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.255,
              "y": -22.207,
              "z": 0.863
            },
            "gtin": "8700216151344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8971",
            "leftCorner": {
              "x": -29.255,
              "y": -22.209,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.322,
              "y": -22.209,
              "z": 0.863
            },
            "gtin": "8700216170321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8972",
            "leftCorner": {
              "x": -29.322,
              "y": -22.211,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.372,
              "y": -22.212,
              "z": 0.863
            },
            "gtin": "8700216151443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8973",
            "leftCorner": {
              "x": -29.372,
              "y": -22.214,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.427,
              "y": -22.214,
              "z": 0.863
            },
            "gtin": "8700216178402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8974",
            "leftCorner": {
              "x": -29.427,
              "y": -22.218,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.483,
              "y": -22.218,
              "z": 0.863
            },
            "gtin": "8700216170345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8975",
            "leftCorner": {
              "x": -29.483,
              "y": -22.221,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.592,
              "y": -22.222,
              "z": 0.863
            },
            "gtin": "8700216151412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8976",
            "leftCorner": {
              "x": -29.592,
              "y": -22.223,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.66,
              "y": -22.223,
              "z": 0.863
            },
            "gtin": "8700216173261",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8977",
            "leftCorner": {
              "x": -29.66,
              "y": -22.222,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.706,
              "y": -22.222,
              "z": 0.863
            },
            "gtin": "8700216181556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8978",
            "leftCorner": {
              "x": -29.706,
              "y": -22.225,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.743,
              "y": -22.226,
              "z": 0.863
            },
            "gtin": "8700216170390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8979",
            "leftCorner": {
              "x": -29.743,
              "y": -22.226,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.798,
              "y": -22.226,
              "z": 0.863
            },
            "gtin": "8700216151382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d897a",
            "leftCorner": {
              "x": -29.798,
              "y": -22.225,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.88,
              "y": -22.225,
              "z": 0.863
            },
            "gtin": "8700216173315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d897b",
            "leftCorner": {
              "x": -29.88,
              "y": -22.227,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.947,
              "y": -22.228,
              "z": 0.863
            },
            "gtin": "8700216170291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d897c",
            "leftCorner": {
              "x": -29.947,
              "y": -22.231,
              "z": 0.863
            },
            "rightCorner": {
              "x": -29.996,
              "y": -22.231,
              "z": 0.863
            },
            "gtin": "8700216151504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d897d",
            "leftCorner": {
              "x": -29.996,
              "y": -22.23,
              "z": 0.863
            },
            "rightCorner": {
              "x": -30.056,
              "y": -22.23,
              "z": 0.863
            },
            "gtin": "8700216173254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d896c",
            "leftCorner": {
              "x": -30.056,
              "y": -22.225,
              "z": 0.863
            },
            "rightCorner": {
              "x": -30.145,
              "y": -22.226,
              "z": 0.863
            },
            "gtin": "4084500084971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d896d",
            "leftCorner": {
              "x": -30.145,
              "y": -22.226,
              "z": 0.863
            },
            "rightCorner": {
              "x": -30.235,
              "y": -22.226,
              "z": 0.863
            },
            "gtin": "4084500084971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d896e",
            "leftCorner": {
              "x": -30.235,
              "y": -22.226,
              "z": 0.863
            },
            "rightCorner": {
              "x": -30.324,
              "y": -22.227,
              "z": 0.863
            },
            "gtin": "4084500084971",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d774",
        "height": 1.3581,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d895c",
            "leftCorner": {
              "x": -29.074,
              "y": -22.176,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.166,
              "y": -22.176,
              "z": 1.111
            },
            "gtin": "4015100814095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d895e",
            "leftCorner": {
              "x": -29.166,
              "y": -22.201,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.22,
              "y": -22.201,
              "z": 1.111
            },
            "gtin": "4015100814118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d895f",
            "leftCorner": {
              "x": -29.22,
              "y": -22.202,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.273,
              "y": -22.202,
              "z": 1.111
            },
            "gtin": "4015100813890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8960",
            "leftCorner": {
              "x": -29.273,
              "y": -22.204,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.334,
              "y": -22.204,
              "z": 1.111
            },
            "gtin": "4015100813470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8961",
            "leftCorner": {
              "x": -29.334,
              "y": -22.206,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.447,
              "y": -22.207,
              "z": 1.111
            },
            "gtin": "4015100814019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8962",
            "leftCorner": {
              "x": -29.447,
              "y": -22.217,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.518,
              "y": -22.217,
              "z": 1.111
            },
            "gtin": "4015100813517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8963",
            "leftCorner": {
              "x": -29.518,
              "y": -22.217,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.589,
              "y": -22.218,
              "z": 1.111
            },
            "gtin": "4015100813517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8964",
            "leftCorner": {
              "x": -29.589,
              "y": -22.218,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.649,
              "y": -22.218,
              "z": 1.111
            },
            "gtin": "4015100812398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8965",
            "leftCorner": {
              "x": -29.649,
              "y": -22.214,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.69,
              "y": -22.214,
              "z": 1.111
            },
            "gtin": "4015100812251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8966",
            "leftCorner": {
              "x": -29.69,
              "y": -22.216,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.748,
              "y": -22.217,
              "z": 1.111
            },
            "gtin": "4015100813418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8967",
            "leftCorner": {
              "x": -29.748,
              "y": -22.224,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.848,
              "y": -22.224,
              "z": 1.111
            },
            "gtin": "4015100814071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8968",
            "leftCorner": {
              "x": -29.848,
              "y": -22.223,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.897,
              "y": -22.224,
              "z": 1.111
            },
            "gtin": "4015100813791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8969",
            "leftCorner": {
              "x": -29.897,
              "y": -22.224,
              "z": 1.111
            },
            "rightCorner": {
              "x": -29.958,
              "y": -22.224,
              "z": 1.111
            },
            "gtin": "4015100813876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d896a",
            "leftCorner": {
              "x": -29.958,
              "y": -22.224,
              "z": 1.111
            },
            "rightCorner": {
              "x": -30.007,
              "y": -22.224,
              "z": 1.111
            },
            "gtin": "4015100813111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d895d",
            "leftCorner": {
              "x": -30.007,
              "y": -22.225,
              "z": 1.111
            },
            "rightCorner": {
              "x": -30.324,
              "y": -22.227,
              "z": 1.111
            },
            "gtin": "4015100812350",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d773",
        "height": 1.7072,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d894c",
            "leftCorner": {
              "x": -29.074,
              "y": -22.172,
              "z": 1.397
            },
            "rightCorner": {
              "x": -29.154,
              "y": -22.172,
              "z": 1.397
            },
            "gtin": "5037156225488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8950",
            "leftCorner": {
              "x": -29.154,
              "y": -22.202,
              "z": 1.397
            },
            "rightCorner": {
              "x": -29.212,
              "y": -22.203,
              "z": 1.397
            },
            "gtin": "5037156225495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8951",
            "leftCorner": {
              "x": -29.212,
              "y": -22.199,
              "z": 1.397
            },
            "rightCorner": {
              "x": -29.277,
              "y": -22.199,
              "z": 1.397
            },
            "gtin": "5037156225525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8952",
            "leftCorner": {
              "x": -29.277,
              "y": -22.203,
              "z": 1.397
            },
            "rightCorner": {
              "x": -29.366,
              "y": -22.204,
              "z": 1.397
            },
            "gtin": "5037156225518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8953",
            "leftCorner": {
              "x": -29.366,
              "y": -22.207,
              "z": 1.397
            },
            "rightCorner": {
              "x": -29.477,
              "y": -22.207,
              "z": 1.397
            },
            "gtin": "5037156254273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8954",
            "leftCorner": {
              "x": -29.477,
              "y": -22.212,
              "z": 1.397
            },
            "rightCorner": {
              "x": -29.579,
              "y": -22.212,
              "z": 1.397
            },
            "gtin": "5037156225587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8955",
            "leftCorner": {
              "x": -29.579,
              "y": -22.214,
              "z": 1.397
            },
            "rightCorner": {
              "x": -29.637,
              "y": -22.214,
              "z": 1.397
            },
            "gtin": "5037156225440",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8956",
            "leftCorner": {
              "x": -29.637,
              "y": -22.214,
              "z": 1.397
            },
            "rightCorner": {
              "x": -29.678,
              "y": -22.214,
              "z": 1.397
            },
            "gtin": "5037156225457",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8957",
            "leftCorner": {
              "x": -29.678,
              "y": -22.216,
              "z": 1.397
            },
            "rightCorner": {
              "x": -29.727,
              "y": -22.217,
              "z": 1.397
            },
            "gtin": "5037156225471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8958",
            "leftCorner": {
              "x": -29.727,
              "y": -22.216,
              "z": 1.397
            },
            "rightCorner": {
              "x": -29.791,
              "y": -22.216,
              "z": 1.397
            },
            "gtin": "5037156225464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8959",
            "leftCorner": {
              "x": -29.791,
              "y": -22.219,
              "z": 1.397
            },
            "rightCorner": {
              "x": -29.865,
              "y": -22.219,
              "z": 1.397
            },
            "gtin": "5037156275292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d895a",
            "leftCorner": {
              "x": -29.865,
              "y": -22.22,
              "z": 1.397
            },
            "rightCorner": {
              "x": -29.954,
              "y": -22.221,
              "z": 1.397
            },
            "gtin": "5037156267907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d895b",
            "leftCorner": {
              "x": -29.954,
              "y": -22.223,
              "z": 1.397
            },
            "rightCorner": {
              "x": -30.026,
              "y": -22.223,
              "z": 1.397
            },
            "gtin": "5037156225044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d894d",
            "leftCorner": {
              "x": -30.026,
              "y": -22.219,
              "z": 1.397
            },
            "rightCorner": {
              "x": -30.126,
              "y": -22.22,
              "z": 1.397
            },
            "gtin": "5037156225051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d894e",
            "leftCorner": {
              "x": -30.126,
              "y": -22.22,
              "z": 1.397
            },
            "rightCorner": {
              "x": -30.225,
              "y": -22.22,
              "z": 1.397
            },
            "gtin": "5037156225051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d894f",
            "leftCorner": {
              "x": -30.225,
              "y": -22.22,
              "z": 1.397
            },
            "rightCorner": {
              "x": -30.324,
              "y": -22.221,
              "z": 1.397
            },
            "gtin": "5037156225051",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "c19"
  },
  {
    "id": "c19",
    "name": "c19",
    "x": -30.324,
    "y": -22.147,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 0.002522
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 107
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d392",
        "height": 0.1724,
        "facings": [
          {
            "id": "a065d85f2fa38b2ffcd8eb26",
            "leftCorner": {
              "x": -30.324,
              "y": -22.072,
              "z": 0.141
            },
            "rightCorner": {
              "x": -30.382,
              "y": -22.072,
              "z": 0.141
            },
            "gtin": "3600524128500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d2ea1dd4ed5a2f4bc6156418",
            "leftCorner": {
              "x": -30.382,
              "y": -22.072,
              "z": 0.141
            },
            "rightCorner": {
              "x": -30.441,
              "y": -22.073,
              "z": 0.141
            },
            "gtin": "3600524075576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "93a54bac7bf683de9f7a7aaa",
            "leftCorner": {
              "x": -30.441,
              "y": -22.073,
              "z": 0.141
            },
            "rightCorner": {
              "x": -30.502,
              "y": -22.073,
              "z": 0.141
            },
            "gtin": "3600524105563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2919a0368e4227abb2eba14e",
            "leftCorner": {
              "x": -30.502,
              "y": -22.073,
              "z": 0.141
            },
            "rightCorner": {
              "x": -30.562,
              "y": -22.073,
              "z": 0.141
            },
            "gtin": "4015100813999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "769259a2f3a3453db3f59d00",
            "leftCorner": {
              "x": -30.562,
              "y": -22.073,
              "z": 0.141
            },
            "rightCorner": {
              "x": -30.624,
              "y": -22.073,
              "z": 0.141
            },
            "gtin": "8006540903346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "045e800f8daa00fa4e9b197d",
            "leftCorner": {
              "x": -30.624,
              "y": -22.073,
              "z": 0.141
            },
            "rightCorner": {
              "x": -30.691,
              "y": -22.074,
              "z": 0.141
            },
            "gtin": "8001090895349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "87eb78048dd2b1f201803805",
            "leftCorner": {
              "x": -30.691,
              "y": -22.074,
              "z": 0.141
            },
            "rightCorner": {
              "x": -30.721,
              "y": -22.074,
              "z": 0.141
            },
            "gtin": "4008666211217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2fc2e4cb66ccbb440f298965",
            "leftCorner": {
              "x": -30.721,
              "y": -22.074,
              "z": 0.141
            },
            "rightCorner": {
              "x": -30.759,
              "y": -22.074,
              "z": 0.141
            },
            "gtin": "3600542462327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b40d8e933a6923e7b36a102b",
            "leftCorner": {
              "x": -30.759,
              "y": -22.074,
              "z": 0.141
            },
            "rightCorner": {
              "x": -30.803,
              "y": -22.074,
              "z": 0.141
            },
            "gtin": "8001841890012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f879bd86206a39cf5bf9ade3",
            "leftCorner": {
              "x": -30.803,
              "y": -22.074,
              "z": 0.141
            },
            "rightCorner": {
              "x": -30.849,
              "y": -22.075,
              "z": 0.141
            },
            "gtin": "4015100813357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3f6df38f0072fdd78c889e82",
            "leftCorner": {
              "x": -30.849,
              "y": -22.075,
              "z": 0.141
            },
            "rightCorner": {
              "x": -30.9,
              "y": -22.075,
              "z": 0.141
            },
            "gtin": "4015100816747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5ffec9a0b45bd8c0b0fc5415",
            "leftCorner": {
              "x": -30.9,
              "y": -22.075,
              "z": 0.141
            },
            "rightCorner": {
              "x": -30.959,
              "y": -22.075,
              "z": 0.141
            },
            "gtin": "3600524128500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8875b441899fd1ca9a6f90dc",
            "leftCorner": {
              "x": -30.959,
              "y": -22.075,
              "z": 0.141
            },
            "rightCorner": {
              "x": -31.018,
              "y": -22.075,
              "z": 0.141
            },
            "gtin": "3600524075576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9b8686e1ca8c50c724a23871",
            "leftCorner": {
              "x": -31.018,
              "y": -22.075,
              "z": 0.141
            },
            "rightCorner": {
              "x": -31.078,
              "y": -22.076,
              "z": 0.141
            },
            "gtin": "4015100812312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "af8b9e04e26a6761452455b2",
            "leftCorner": {
              "x": -31.078,
              "y": -22.076,
              "z": 0.141
            },
            "rightCorner": {
              "x": -31.138,
              "y": -22.076,
              "z": 0.141
            },
            "gtin": "3600524105563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5488c66674bc97c3822bba2e",
            "leftCorner": {
              "x": -31.138,
              "y": -22.076,
              "z": 0.141
            },
            "rightCorner": {
              "x": -31.198,
              "y": -22.076,
              "z": 0.141
            },
            "gtin": "3600523682874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e474a74d31b995644c3d3d10",
            "leftCorner": {
              "x": -31.198,
              "y": -22.076,
              "z": 0.141
            },
            "rightCorner": {
              "x": -31.259,
              "y": -22.077,
              "z": 0.141
            },
            "gtin": "4015100813999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6183ec7fa093d496d01b5861",
            "leftCorner": {
              "x": -31.259,
              "y": -22.077,
              "z": 0.141
            },
            "rightCorner": {
              "x": -31.32,
              "y": -22.077,
              "z": 0.141
            },
            "gtin": "4015100812374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a3273349e4a5e61fb69b72f1",
            "leftCorner": {
              "x": -31.32,
              "y": -22.077,
              "z": 0.141
            },
            "rightCorner": {
              "x": -31.456,
              "y": -22.078,
              "z": 0.141
            },
            "gtin": "8001090894878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a23b2149d8ec3b2f9d4e3bc0",
            "leftCorner": {
              "x": -31.456,
              "y": -22.078,
              "z": 0.141
            },
            "rightCorner": {
              "x": -31.561,
              "y": -22.078,
              "z": 0.141
            },
            "gtin": "3600542510127",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d38f",
        "height": 0.46736,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d708c",
            "leftCorner": {
              "x": -30.324,
              "y": -22.092,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.381,
              "y": -22.092,
              "z": 0.382
            },
            "gtin": "4008666211217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d708e",
            "leftCorner": {
              "x": -30.381,
              "y": -22.121,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.52,
              "y": -22.122,
              "z": 0.382
            },
            "gtin": "4008666209016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d708f",
            "leftCorner": {
              "x": -30.52,
              "y": -22.12,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.563,
              "y": -22.12,
              "z": 0.382
            },
            "gtin": "4008666218001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7090",
            "leftCorner": {
              "x": -30.563,
              "y": -22.12,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.635,
              "y": -22.12,
              "z": 0.382
            },
            "gtin": "4008666218001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7091",
            "leftCorner": {
              "x": -30.635,
              "y": -22.127,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.713,
              "y": -22.128,
              "z": 0.382
            },
            "gtin": "4008666212016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7092",
            "leftCorner": {
              "x": -30.713,
              "y": -22.133,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.795,
              "y": -22.134,
              "z": 0.382
            },
            "gtin": "4008666203137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7093",
            "leftCorner": {
              "x": -30.794,
              "y": -22.147,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.897,
              "y": -22.147,
              "z": 0.382
            },
            "gtin": "4015100447507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7094",
            "leftCorner": {
              "x": -30.897,
              "y": -22.147,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.966,
              "y": -22.148,
              "z": 0.382
            },
            "gtin": "8700216328623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7095",
            "leftCorner": {
              "x": -30.966,
              "y": -22.146,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.027,
              "y": -22.147,
              "z": 0.382
            },
            "gtin": "8700216328807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7096",
            "leftCorner": {
              "x": -31.027,
              "y": -22.143,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.08,
              "y": -22.144,
              "z": 0.382
            },
            "gtin": "8700216328661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7097",
            "leftCorner": {
              "x": -31.08,
              "y": -22.142,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.148,
              "y": -22.143,
              "z": 0.382
            },
            "gtin": "8700216328661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7098",
            "leftCorner": {
              "x": -31.148,
              "y": -22.142,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.212,
              "y": -22.142,
              "z": 0.382
            },
            "gtin": "8700216328760",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7099",
            "leftCorner": {
              "x": -31.212,
              "y": -22.137,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.271,
              "y": -22.137,
              "z": 0.382
            },
            "gtin": "8700216328692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d709a",
            "leftCorner": {
              "x": -31.271,
              "y": -22.136,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.34,
              "y": -22.136,
              "z": 0.382
            },
            "gtin": "8001090890054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d709b",
            "leftCorner": {
              "x": -31.34,
              "y": -22.134,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.473,
              "y": -22.135,
              "z": 0.382
            },
            "gtin": "8001090894878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d709c",
            "leftCorner": {
              "x": -31.473,
              "y": -22.133,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.527,
              "y": -22.133,
              "z": 0.382
            },
            "gtin": "8001090941848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d709d",
            "leftCorner": {
              "x": -31.527,
              "y": -22.125,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.593,
              "y": -22.125,
              "z": 0.382
            },
            "gtin": "8001090941848",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d391",
        "height": 0.62747,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d70cf",
            "leftCorner": {
              "x": -30.323,
              "y": -22.404,
              "z": 0.513
            },
            "rightCorner": {
              "x": -30.605,
              "y": -22.406,
              "z": 0.513
            },
            "gtin": "3600524128005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70d0",
            "leftCorner": {
              "x": -30.605,
              "y": -22.446,
              "z": 0.513
            },
            "rightCorner": {
              "x": -31.572,
              "y": -22.45,
              "z": 0.513
            },
            "gtin": "3600524128005",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d38e",
        "height": 0.75601,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d707c",
            "leftCorner": {
              "x": -30.324,
              "y": -22.099,
              "z": 0.619
            },
            "rightCorner": {
              "x": -30.475,
              "y": -22.099,
              "z": 0.619
            },
            "gtin": "3600524074654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d707d",
            "leftCorner": {
              "x": -30.474,
              "y": -22.123,
              "z": 0.619
            },
            "rightCorner": {
              "x": -30.529,
              "y": -22.124,
              "z": 0.619
            },
            "gtin": "3600524074654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d707e",
            "leftCorner": {
              "x": -30.53,
              "y": -22.132,
              "z": 0.619
            },
            "rightCorner": {
              "x": -30.612,
              "y": -22.132,
              "z": 0.619
            },
            "gtin": "3600524074791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d707f",
            "leftCorner": {
              "x": -30.612,
              "y": -22.139,
              "z": 0.619
            },
            "rightCorner": {
              "x": -30.654,
              "y": -22.14,
              "z": 0.619
            },
            "gtin": "3600524144036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7080",
            "leftCorner": {
              "x": -30.654,
              "y": -22.137,
              "z": 0.619
            },
            "rightCorner": {
              "x": -30.724,
              "y": -22.138,
              "z": 0.619
            },
            "gtin": "3600524144036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7081",
            "leftCorner": {
              "x": -30.724,
              "y": -22.142,
              "z": 0.619
            },
            "rightCorner": {
              "x": -30.774,
              "y": -22.142,
              "z": 0.619
            },
            "gtin": "3600524135430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7082",
            "leftCorner": {
              "x": -30.774,
              "y": -22.148,
              "z": 0.619
            },
            "rightCorner": {
              "x": -30.844,
              "y": -22.149,
              "z": 0.619
            },
            "gtin": "3600524135430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7083",
            "leftCorner": {
              "x": -30.845,
              "y": -22.157,
              "z": 0.619
            },
            "rightCorner": {
              "x": -30.914,
              "y": -22.157,
              "z": 0.619
            },
            "gtin": "3600523682775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7084",
            "leftCorner": {
              "x": -30.914,
              "y": -22.157,
              "z": 0.619
            },
            "rightCorner": {
              "x": -30.973,
              "y": -22.157,
              "z": 0.619
            },
            "gtin": "3600523682874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7085",
            "leftCorner": {
              "x": -30.972,
              "y": -22.152,
              "z": 0.619
            },
            "rightCorner": {
              "x": -31.044,
              "y": -22.152,
              "z": 0.619
            },
            "gtin": "3600524137465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7086",
            "leftCorner": {
              "x": -31.044,
              "y": -22.15,
              "z": 0.619
            },
            "rightCorner": {
              "x": -31.104,
              "y": -22.15,
              "z": 0.619
            },
            "gtin": "3600524142612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7087",
            "leftCorner": {
              "x": -31.104,
              "y": -22.146,
              "z": 0.619
            },
            "rightCorner": {
              "x": -31.162,
              "y": -22.146,
              "z": 0.619
            },
            "gtin": "3600524030780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7088",
            "leftCorner": {
              "x": -31.162,
              "y": -22.148,
              "z": 0.619
            },
            "rightCorner": {
              "x": -31.251,
              "y": -22.149,
              "z": 0.619
            },
            "gtin": "3600524030780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7089",
            "leftCorner": {
              "x": -31.252,
              "y": -22.141,
              "z": 0.619
            },
            "rightCorner": {
              "x": -31.335,
              "y": -22.141,
              "z": 0.619
            },
            "gtin": "3600524140069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d708a",
            "leftCorner": {
              "x": -31.335,
              "y": -22.132,
              "z": 0.619
            },
            "rightCorner": {
              "x": -31.383,
              "y": -22.132,
              "z": 0.619
            },
            "gtin": "3600524138530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d708b",
            "leftCorner": {
              "x": -31.383,
              "y": -22.131,
              "z": 0.619
            },
            "rightCorner": {
              "x": -31.554,
              "y": -22.131,
              "z": 0.619
            },
            "gtin": "3600524138530",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d38d",
        "height": 1.0542,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d705d",
            "leftCorner": {
              "x": -30.324,
              "y": -22.094,
              "z": 0.863
            },
            "rightCorner": {
              "x": -30.36,
              "y": -22.094,
              "z": 0.863
            },
            "gtin": "4084500085350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d705e",
            "leftCorner": {
              "x": -30.36,
              "y": -22.131,
              "z": 0.863
            },
            "rightCorner": {
              "x": -30.39,
              "y": -22.131,
              "z": 0.863
            },
            "gtin": "8001841890012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d705f",
            "leftCorner": {
              "x": -30.389,
              "y": -22.119,
              "z": 0.863
            },
            "rightCorner": {
              "x": -30.464,
              "y": -22.12,
              "z": 0.863
            },
            "gtin": "3600542461511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7060",
            "leftCorner": {
              "x": -30.464,
              "y": -22.122,
              "z": 0.863
            },
            "rightCorner": {
              "x": -30.563,
              "y": -22.122,
              "z": 0.863
            },
            "gtin": "3600542461481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7061",
            "leftCorner": {
              "x": -30.563,
              "y": -22.124,
              "z": 0.863
            },
            "rightCorner": {
              "x": -30.687,
              "y": -22.125,
              "z": 0.863
            },
            "gtin": "3600542509428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7062",
            "leftCorner": {
              "x": -30.688,
              "y": -22.13,
              "z": 0.863
            },
            "rightCorner": {
              "x": -30.788,
              "y": -22.131,
              "z": 0.863
            },
            "gtin": "3600542460712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7063",
            "leftCorner": {
              "x": -30.787,
              "y": -22.153,
              "z": 0.863
            },
            "rightCorner": {
              "x": -30.869,
              "y": -22.153,
              "z": 0.863
            },
            "gtin": "3600542461085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7064",
            "leftCorner": {
              "x": -30.869,
              "y": -22.15,
              "z": 0.863
            },
            "rightCorner": {
              "x": -30.977,
              "y": -22.15,
              "z": 0.863
            },
            "gtin": "3600542510127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7065",
            "leftCorner": {
              "x": -30.977,
              "y": -22.149,
              "z": 0.863
            },
            "rightCorner": {
              "x": -31.064,
              "y": -22.149,
              "z": 0.863
            },
            "gtin": "3600542572064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7066",
            "leftCorner": {
              "x": -31.065,
              "y": -22.144,
              "z": 0.863
            },
            "rightCorner": {
              "x": -31.143,
              "y": -22.145,
              "z": 0.863
            },
            "gtin": "3600542572187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7067",
            "leftCorner": {
              "x": -31.143,
              "y": -22.142,
              "z": 0.863
            },
            "rightCorner": {
              "x": -31.231,
              "y": -22.142,
              "z": 0.863
            },
            "gtin": "3600542571586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7068",
            "leftCorner": {
              "x": -31.231,
              "y": -22.138,
              "z": 0.863
            },
            "rightCorner": {
              "x": -31.318,
              "y": -22.139,
              "z": 0.863
            },
            "gtin": "3600542461177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7069",
            "leftCorner": {
              "x": -31.318,
              "y": -22.139,
              "z": 0.863
            },
            "rightCorner": {
              "x": -31.406,
              "y": -22.139,
              "z": 0.863
            },
            "gtin": "3600542461122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d706a",
            "leftCorner": {
              "x": -31.407,
              "y": -22.132,
              "z": 0.863
            },
            "rightCorner": {
              "x": -31.467,
              "y": -22.132,
              "z": 0.863
            },
            "gtin": "3600542509572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d706b",
            "leftCorner": {
              "x": -31.467,
              "y": -22.133,
              "z": 0.863
            },
            "rightCorner": {
              "x": -31.559,
              "y": -22.133,
              "z": 0.863
            },
            "gtin": "3600542462402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d706c",
            "leftCorner": {
              "x": -31.56,
              "y": -22.126,
              "z": 0.863
            },
            "rightCorner": {
              "x": -31.632,
              "y": -22.127,
              "z": 0.863
            },
            "gtin": "3600542462327",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d390",
        "height": 1.3555,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d70ad",
            "leftCorner": {
              "x": -30.342,
              "y": -22.142,
              "z": 1.109
            },
            "rightCorner": {
              "x": -30.397,
              "y": -22.143,
              "z": 1.109
            },
            "gtin": "4015100816747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70ae",
            "leftCorner": {
              "x": -30.396,
              "y": -22.125,
              "z": 1.109
            },
            "rightCorner": {
              "x": -30.508,
              "y": -22.125,
              "z": 1.109
            },
            "gtin": "4015100814033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70af",
            "leftCorner": {
              "x": -30.508,
              "y": -22.115,
              "z": 1.109
            },
            "rightCorner": {
              "x": -30.543,
              "y": -22.115,
              "z": 1.109
            },
            "gtin": "4015100813913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70b0",
            "leftCorner": {
              "x": -30.543,
              "y": -22.115,
              "z": 1.109
            },
            "rightCorner": {
              "x": -30.578,
              "y": -22.116,
              "z": 1.109
            },
            "gtin": "4015100813913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70b1",
            "leftCorner": {
              "x": -30.578,
              "y": -22.116,
              "z": 1.109
            },
            "rightCorner": {
              "x": -30.613,
              "y": -22.116,
              "z": 1.109
            },
            "gtin": "4015100813913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70b2",
            "leftCorner": {
              "x": -30.613,
              "y": -22.124,
              "z": 1.109
            },
            "rightCorner": {
              "x": -30.686,
              "y": -22.125,
              "z": 1.109
            },
            "gtin": "4015100812374",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d70b3",
            "leftCorner": {
              "x": -30.687,
              "y": -22.123,
              "z": 1.109
            },
            "rightCorner": {
              "x": -30.79,
              "y": -22.123,
              "z": 1.109
            },
            "gtin": "4015100812237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70b4",
            "leftCorner": {
              "x": -30.79,
              "y": -22.144,
              "z": 1.109
            },
            "rightCorner": {
              "x": -30.853,
              "y": -22.144,
              "z": 1.109
            },
            "gtin": "4015100814057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70b5",
            "leftCorner": {
              "x": -30.853,
              "y": -22.142,
              "z": 1.109
            },
            "rightCorner": {
              "x": -30.913,
              "y": -22.143,
              "z": 1.109
            },
            "gtin": "4015100813494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70b6",
            "leftCorner": {
              "x": -30.913,
              "y": -22.146,
              "z": 1.109
            },
            "rightCorner": {
              "x": -31.029,
              "y": -22.146,
              "z": 1.109
            },
            "gtin": "4015100813579",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70b7",
            "leftCorner": {
              "x": -31.029,
              "y": -22.138,
              "z": 1.109
            },
            "rightCorner": {
              "x": -31.085,
              "y": -22.139,
              "z": 1.109
            },
            "gtin": "4015100812510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70b8",
            "leftCorner": {
              "x": -31.085,
              "y": -22.14,
              "z": 1.109
            },
            "rightCorner": {
              "x": -31.153,
              "y": -22.14,
              "z": 1.109
            },
            "gtin": "4015100812510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70b9",
            "leftCorner": {
              "x": -31.153,
              "y": -22.139,
              "z": 1.109
            },
            "rightCorner": {
              "x": -31.213,
              "y": -22.139,
              "z": 1.109
            },
            "gtin": "4015100812312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70ba",
            "leftCorner": {
              "x": -31.213,
              "y": -22.135,
              "z": 1.109
            },
            "rightCorner": {
              "x": -31.264,
              "y": -22.135,
              "z": 1.109
            },
            "gtin": "4015100813135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70bb",
            "leftCorner": {
              "x": -31.264,
              "y": -22.132,
              "z": 1.109
            },
            "rightCorner": {
              "x": -31.329,
              "y": -22.133,
              "z": 1.109
            },
            "gtin": "4015100813135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70bc",
            "leftCorner": {
              "x": -31.329,
              "y": -22.131,
              "z": 1.109
            },
            "rightCorner": {
              "x": -31.392,
              "y": -22.131,
              "z": 1.109
            },
            "gtin": "4015100812336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70bd",
            "leftCorner": {
              "x": -31.392,
              "y": -22.129,
              "z": 1.109
            },
            "rightCorner": {
              "x": -31.439,
              "y": -22.13,
              "z": 1.109
            },
            "gtin": "4015100813838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70be",
            "leftCorner": {
              "x": -31.439,
              "y": -22.129,
              "z": 1.109
            },
            "rightCorner": {
              "x": -31.475,
              "y": -22.129,
              "z": 1.109
            },
            "gtin": "4015100813357",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70bf",
            "leftCorner": {
              "x": -31.475,
              "y": -22.126,
              "z": 1.109
            },
            "rightCorner": {
              "x": -31.529,
              "y": -22.126,
              "z": 1.109
            },
            "gtin": "4015100813838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70c0",
            "leftCorner": {
              "x": -31.529,
              "y": -22.124,
              "z": 1.109
            },
            "rightCorner": {
              "x": -31.614,
              "y": -22.124,
              "z": 1.109
            },
            "gtin": "4015100812596",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d38c",
        "height": 1.7052,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d703e",
            "leftCorner": {
              "x": -30.348,
              "y": -22.119,
              "z": 1.395
            },
            "rightCorner": {
              "x": -30.425,
              "y": -22.119,
              "z": 1.395
            },
            "gtin": "3574661799438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d703f",
            "leftCorner": {
              "x": -30.426,
              "y": -22.115,
              "z": 1.395
            },
            "rightCorner": {
              "x": -30.504,
              "y": -22.114,
              "z": 1.395
            },
            "gtin": "3574661799162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7040",
            "leftCorner": {
              "x": -30.504,
              "y": -22.114,
              "z": 1.395
            },
            "rightCorner": {
              "x": -30.577,
              "y": -22.115,
              "z": 1.395
            },
            "gtin": "3574661563312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7041",
            "leftCorner": {
              "x": -30.576,
              "y": -22.118,
              "z": 1.395
            },
            "rightCorner": {
              "x": -30.69,
              "y": -22.119,
              "z": 1.395
            },
            "gtin": "3574661800202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7042",
            "leftCorner": {
              "x": -30.69,
              "y": -22.124,
              "z": 1.395
            },
            "rightCorner": {
              "x": -30.802,
              "y": -22.123,
              "z": 1.395
            },
            "gtin": "3574661799506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7043",
            "leftCorner": {
              "x": -30.801,
              "y": -22.145,
              "z": 1.395
            },
            "rightCorner": {
              "x": -30.87,
              "y": -22.146,
              "z": 1.395
            },
            "gtin": "4072600701201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7044",
            "leftCorner": {
              "x": -30.87,
              "y": -22.143,
              "z": 1.395
            },
            "rightCorner": {
              "x": -30.944,
              "y": -22.143,
              "z": 1.395
            },
            "gtin": "4072600701218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7045",
            "leftCorner": {
              "x": -30.944,
              "y": -22.147,
              "z": 1.395
            },
            "rightCorner": {
              "x": -31.032,
              "y": -22.147,
              "z": 1.395
            },
            "gtin": "4072600282250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7046",
            "leftCorner": {
              "x": -31.033,
              "y": -22.14,
              "z": 1.395
            },
            "rightCorner": {
              "x": -31.098,
              "y": -22.14,
              "z": 1.395
            },
            "gtin": "4072600282267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7047",
            "leftCorner": {
              "x": -31.098,
              "y": -22.14,
              "z": 1.395
            },
            "rightCorner": {
              "x": -31.169,
              "y": -22.141,
              "z": 1.395
            },
            "gtin": "4072600282281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7048",
            "leftCorner": {
              "x": -31.169,
              "y": -22.137,
              "z": 1.395
            },
            "rightCorner": {
              "x": -31.235,
              "y": -22.137,
              "z": 1.395
            },
            "gtin": "4072600282298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7049",
            "leftCorner": {
              "x": -31.235,
              "y": -22.135,
              "z": 1.395
            },
            "rightCorner": {
              "x": -31.314,
              "y": -22.135,
              "z": 1.395
            },
            "gtin": "4072600282274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d704a",
            "leftCorner": {
              "x": -31.314,
              "y": -22.132,
              "z": 1.395
            },
            "rightCorner": {
              "x": -31.393,
              "y": -22.132,
              "z": 1.395
            },
            "gtin": "4072600282427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d704b",
            "leftCorner": {
              "x": -31.394,
              "y": -22.13,
              "z": 1.395
            },
            "rightCorner": {
              "x": -31.462,
              "y": -22.13,
              "z": 1.395
            },
            "gtin": "4072600283172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d704c",
            "leftCorner": {
              "x": -31.462,
              "y": -22.129,
              "z": 1.395
            },
            "rightCorner": {
              "x": -31.527,
              "y": -22.129,
              "z": 1.395
            },
            "gtin": "4072600282199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d704d",
            "leftCorner": {
              "x": -31.527,
              "y": -22.119,
              "z": 1.395
            },
            "rightCorner": {
              "x": -31.603,
              "y": -22.12,
              "z": 1.395
            },
            "gtin": "4072600282205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d704e",
            "leftCorner": {
              "x": -31.603,
              "y": -22.12,
              "z": 1.395
            },
            "rightCorner": {
              "x": -31.68,
              "y": -22.119,
              "z": 1.395
            },
            "gtin": "4072600282205",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c17",
    "rightNeighborShelfId": "c1a"
  },
  {
    "id": "c1a",
    "name": "c1a",
    "x": -31.574,
    "y": -22.153,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 0.002522
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 93
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d398",
        "height": 0.17131,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d70dc",
            "leftCorner": {
              "x": -31.574,
              "y": -22.08,
              "z": 0.14
            },
            "rightCorner": {
              "x": -31.692,
              "y": -22.085,
              "z": 0.14
            },
            "gtin": "4015100860382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70dd",
            "leftCorner": {
              "x": -31.692,
              "y": -22.092,
              "z": 0.14
            },
            "rightCorner": {
              "x": -31.728,
              "y": -22.092,
              "z": 0.14
            },
            "gtin": "4015100860986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70de",
            "leftCorner": {
              "x": -31.728,
              "y": -22.093,
              "z": 0.14
            },
            "rightCorner": {
              "x": -31.788,
              "y": -22.093,
              "z": 0.14
            },
            "gtin": "4015100860986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70df",
            "leftCorner": {
              "x": -31.788,
              "y": -22.097,
              "z": 0.14
            },
            "rightCorner": {
              "x": -31.874,
              "y": -22.098,
              "z": 0.14
            },
            "gtin": "4015100860481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70e0",
            "leftCorner": {
              "x": -31.874,
              "y": -22.1,
              "z": 0.14
            },
            "rightCorner": {
              "x": -31.951,
              "y": -22.1,
              "z": 0.14
            },
            "gtin": "4015100860443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70e1",
            "leftCorner": {
              "x": -31.951,
              "y": -22.103,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.017,
              "y": -22.104,
              "z": 0.14
            },
            "gtin": "4306188063896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70e2",
            "leftCorner": {
              "x": -32.017,
              "y": -22.103,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.081,
              "y": -22.103,
              "z": 0.14
            },
            "gtin": "4306188001898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70e3",
            "leftCorner": {
              "x": -32.081,
              "y": -22.097,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.158,
              "y": -22.098,
              "z": 0.14
            },
            "gtin": "4306188063926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70e4",
            "leftCorner": {
              "x": -32.158,
              "y": -22.091,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.224,
              "y": -22.091,
              "z": 0.14
            },
            "gtin": "4306188063889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70e5",
            "leftCorner": {
              "x": -32.224,
              "y": -22.087,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.319,
              "y": -22.088,
              "z": 0.14
            },
            "gtin": "4306188063766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70e6",
            "leftCorner": {
              "x": -32.319,
              "y": -22.089,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.382,
              "y": -22.089,
              "z": 0.14
            },
            "gtin": "4306188063773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70e7",
            "leftCorner": {
              "x": -32.382,
              "y": -22.09,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.471,
              "y": -22.091,
              "z": 0.14
            },
            "gtin": "4306188063780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70d2",
            "leftCorner": {
              "x": -32.471,
              "y": -22.093,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.574,
              "y": -22.093,
              "z": 0.14
            },
            "gtin": "4015100810363",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d393",
        "height": 0.46872,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d709e",
            "leftCorner": {
              "x": -31.593,
              "y": -22.127,
              "z": 0.384
            },
            "rightCorner": {
              "x": -31.689,
              "y": -22.128,
              "z": 0.384
            },
            "gtin": "8001090891334",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d709f",
            "leftCorner": {
              "x": -31.689,
              "y": -22.13,
              "z": 0.384
            },
            "rightCorner": {
              "x": -31.759,
              "y": -22.13,
              "z": 0.384
            },
            "gtin": "8001090894366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70a0",
            "leftCorner": {
              "x": -31.759,
              "y": -22.132,
              "z": 0.384
            },
            "rightCorner": {
              "x": -31.836,
              "y": -22.133,
              "z": 0.384
            },
            "gtin": "8700216158879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70a1",
            "leftCorner": {
              "x": -31.836,
              "y": -22.135,
              "z": 0.384
            },
            "rightCorner": {
              "x": -31.912,
              "y": -22.135,
              "z": 0.384
            },
            "gtin": "8001090894991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70a2",
            "leftCorner": {
              "x": -31.912,
              "y": -22.139,
              "z": 0.384
            },
            "rightCorner": {
              "x": -31.978,
              "y": -22.14,
              "z": 0.384
            },
            "gtin": "8001090895806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70a3",
            "leftCorner": {
              "x": -31.978,
              "y": -22.141,
              "z": 0.384
            },
            "rightCorner": {
              "x": -32.051,
              "y": -22.141,
              "z": 0.384
            },
            "gtin": "8001090896315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70a4",
            "leftCorner": {
              "x": -32.051,
              "y": -22.144,
              "z": 0.384
            },
            "rightCorner": {
              "x": -32.127,
              "y": -22.144,
              "z": 0.384
            },
            "gtin": "8001090896049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70a5",
            "leftCorner": {
              "x": -32.127,
              "y": -22.14,
              "z": 0.384
            },
            "rightCorner": {
              "x": -32.202,
              "y": -22.141,
              "z": 0.384
            },
            "gtin": "8001090896216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70a6",
            "leftCorner": {
              "x": -32.202,
              "y": -22.135,
              "z": 0.384
            },
            "rightCorner": {
              "x": -32.28,
              "y": -22.135,
              "z": 0.384
            },
            "gtin": "8001090896735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70a7",
            "leftCorner": {
              "x": -32.28,
              "y": -22.128,
              "z": 0.384
            },
            "rightCorner": {
              "x": -32.352,
              "y": -22.129,
              "z": 0.384
            },
            "gtin": "8700216517669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70a8",
            "leftCorner": {
              "x": -32.352,
              "y": -22.128,
              "z": 0.384
            },
            "rightCorner": {
              "x": -32.428,
              "y": -22.128,
              "z": 0.384
            },
            "gtin": "8001090896599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70a9",
            "leftCorner": {
              "x": -32.428,
              "y": -22.129,
              "z": 0.384
            },
            "rightCorner": {
              "x": -32.476,
              "y": -22.13,
              "z": 0.384
            },
            "gtin": "4015100815627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70aa",
            "leftCorner": {
              "x": -32.476,
              "y": -22.133,
              "z": 0.384
            },
            "rightCorner": {
              "x": -32.504,
              "y": -22.133,
              "z": 0.384
            },
            "gtin": "4015100810387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70ab",
            "leftCorner": {
              "x": -32.504,
              "y": -22.134,
              "z": 0.384
            },
            "rightCorner": {
              "x": -32.539,
              "y": -22.134,
              "z": 0.384
            },
            "gtin": "4015100815627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d708d",
            "leftCorner": {
              "x": -32.539,
              "y": -22.133,
              "z": 0.384
            },
            "rightCorner": {
              "x": -32.574,
              "y": -22.133,
              "z": 0.384
            },
            "gtin": "4015100810400",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d397",
        "height": 0.76892,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d70e8",
            "leftCorner": {
              "x": -31.574,
              "y": -22.093,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.626,
              "y": -22.093,
              "z": 0.629
            },
            "gtin": "3600524137564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70e9",
            "leftCorner": {
              "x": -31.626,
              "y": -22.093,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.679,
              "y": -22.094,
              "z": 0.629
            },
            "gtin": "3600524137564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70ea",
            "leftCorner": {
              "x": -31.679,
              "y": -22.094,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.731,
              "y": -22.094,
              "z": 0.629
            },
            "gtin": "3600524137564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70eb",
            "leftCorner": {
              "x": -31.731,
              "y": -22.13,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.808,
              "y": -22.13,
              "z": 0.629
            },
            "gtin": "3600524142087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70ec",
            "leftCorner": {
              "x": -31.808,
              "y": -22.134,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.89,
              "y": -22.135,
              "z": 0.629
            },
            "gtin": "4037900021503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70ed",
            "leftCorner": {
              "x": -31.89,
              "y": -22.138,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.972,
              "y": -22.137,
              "z": 0.629
            },
            "gtin": "3600523610068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70ee",
            "leftCorner": {
              "x": -31.972,
              "y": -22.14,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.041,
              "y": -22.141,
              "z": 0.629
            },
            "gtin": "3600524137960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70ef",
            "leftCorner": {
              "x": -32.041,
              "y": -22.143,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.114,
              "y": -22.143,
              "z": 0.629
            },
            "gtin": "3600524141899",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70f0",
            "leftCorner": {
              "x": -32.114,
              "y": -22.147,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.18,
              "y": -22.148,
              "z": 0.629
            },
            "gtin": "3600524034160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70f1",
            "leftCorner": {
              "x": -32.18,
              "y": -22.146,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.242,
              "y": -22.146,
              "z": 0.629
            },
            "gtin": "3600523472628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70f2",
            "leftCorner": {
              "x": -32.242,
              "y": -22.132,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.297,
              "y": -22.133,
              "z": 0.629
            },
            "gtin": "3600523733088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70f3",
            "leftCorner": {
              "x": -32.297,
              "y": -22.131,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.338,
              "y": -22.131,
              "z": 0.629
            },
            "gtin": "3600524160470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70f4",
            "leftCorner": {
              "x": -32.338,
              "y": -22.132,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.419,
              "y": -22.131,
              "z": 0.629
            },
            "gtin": "3600524160470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70f5",
            "leftCorner": {
              "x": -32.419,
              "y": -22.132,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.487,
              "y": -22.133,
              "z": 0.629
            },
            "gtin": "3600524142681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70f6",
            "leftCorner": {
              "x": -32.487,
              "y": -22.134,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.542,
              "y": -22.134,
              "z": 0.629
            },
            "gtin": "3600524142988",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d396",
        "height": 1.057,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d706d",
            "leftCorner": {
              "x": -31.632,
              "y": -22.134,
              "z": 0.865
            },
            "rightCorner": {
              "x": -31.745,
              "y": -22.134,
              "z": 0.865
            },
            "gtin": "3600542462143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "65f58cc7fcf983c48befc1aa",
            "leftCorner": {
              "x": -31.574,
              "y": -22.101,
              "z": 0.865
            },
            "rightCorner": {
              "x": -31.619,
              "y": -22.101,
              "z": 0.865
            },
            "gtin": "5016155119806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4ad58bd958c02a496a58323c",
            "leftCorner": {
              "x": -32.539,
              "y": -22.106,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.566,
              "y": -22.106,
              "z": 0.865
            },
            "gtin": "5016155264568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d706e",
            "leftCorner": {
              "x": -31.745,
              "y": -22.138,
              "z": 0.865
            },
            "rightCorner": {
              "x": -31.827,
              "y": -22.139,
              "z": 0.865
            },
            "gtin": "3600542462594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d706f",
            "leftCorner": {
              "x": -31.827,
              "y": -22.143,
              "z": 0.865
            },
            "rightCorner": {
              "x": -31.924,
              "y": -22.143,
              "z": 0.865
            },
            "gtin": "3600542461542",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7070",
            "leftCorner": {
              "x": -31.924,
              "y": -22.148,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.007,
              "y": -22.149,
              "z": 0.865
            },
            "gtin": "3600542461429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7071",
            "leftCorner": {
              "x": -32.007,
              "y": -22.152,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.05,
              "y": -22.152,
              "z": 0.865
            },
            "gtin": "4072600701805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7072",
            "leftCorner": {
              "x": -32.05,
              "y": -22.151,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.098,
              "y": -22.151,
              "z": 0.865
            },
            "gtin": "4072600721704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7073",
            "leftCorner": {
              "x": -32.098,
              "y": -22.149,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.143,
              "y": -22.15,
              "z": 0.865
            },
            "gtin": "4072600701805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7074",
            "leftCorner": {
              "x": -32.143,
              "y": -22.153,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.19,
              "y": -22.153,
              "z": 0.865
            },
            "gtin": "4005900952967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7075",
            "leftCorner": {
              "x": -32.19,
              "y": -22.143,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.23,
              "y": -22.143,
              "z": 0.865
            },
            "gtin": "4005900756015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7076",
            "leftCorner": {
              "x": -32.23,
              "y": -22.144,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.283,
              "y": -22.144,
              "z": 0.865
            },
            "gtin": "4005900755971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7077",
            "leftCorner": {
              "x": -32.283,
              "y": -22.138,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.328,
              "y": -22.139,
              "z": 0.865
            },
            "gtin": "5016155119905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7078",
            "leftCorner": {
              "x": -32.328,
              "y": -22.139,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.375,
              "y": -22.139,
              "z": 0.865
            },
            "gtin": "5016155128518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7079",
            "leftCorner": {
              "x": -32.375,
              "y": -22.141,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.471,
              "y": -22.142,
              "z": 0.865
            },
            "gtin": "5016155250950",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d707a",
            "leftCorner": {
              "x": -32.471,
              "y": -22.143,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.503,
              "y": -22.142,
              "z": 0.865
            },
            "gtin": "4104260045712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d707b",
            "leftCorner": {
              "x": -32.503,
              "y": -22.144,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.539,
              "y": -22.144,
              "z": 0.865
            },
            "gtin": "5016155264568",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d395",
        "height": 1.3597,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d70c1",
            "leftCorner": {
              "x": -31.614,
              "y": -22.138,
              "z": 1.112
            },
            "rightCorner": {
              "x": -31.675,
              "y": -22.139,
              "z": 1.112
            },
            "gtin": "4015100812558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70c2",
            "leftCorner": {
              "x": -31.675,
              "y": -22.129,
              "z": 1.112
            },
            "rightCorner": {
              "x": -31.735,
              "y": -22.129,
              "z": 1.112
            },
            "gtin": "4015100812473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70c3",
            "leftCorner": {
              "x": -31.735,
              "y": -22.131,
              "z": 1.112
            },
            "rightCorner": {
              "x": -31.775,
              "y": -22.131,
              "z": 1.112
            },
            "gtin": "4015100812572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70c4",
            "leftCorner": {
              "x": -31.775,
              "y": -22.131,
              "z": 1.112
            },
            "rightCorner": {
              "x": -31.876,
              "y": -22.132,
              "z": 1.112
            },
            "gtin": "4015100812572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70c5",
            "leftCorner": {
              "x": -31.876,
              "y": -22.141,
              "z": 1.112
            },
            "rightCorner": {
              "x": -31.925,
              "y": -22.141,
              "z": 1.112
            },
            "gtin": "4015100813814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70c6",
            "leftCorner": {
              "x": -31.925,
              "y": -22.14,
              "z": 1.112
            },
            "rightCorner": {
              "x": -31.972,
              "y": -22.14,
              "z": 1.112
            },
            "gtin": "4015100813432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70c7",
            "leftCorner": {
              "x": -31.972,
              "y": -22.145,
              "z": 1.112
            },
            "rightCorner": {
              "x": -32.031,
              "y": -22.146,
              "z": 1.112
            },
            "gtin": "4015100813814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70c8",
            "leftCorner": {
              "x": -32.031,
              "y": -22.11,
              "z": 1.112
            },
            "rightCorner": {
              "x": -32.101,
              "y": -22.11,
              "z": 1.112
            },
            "gtin": "8700216212748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70c9",
            "leftCorner": {
              "x": -32.101,
              "y": -22.154,
              "z": 1.112
            },
            "rightCorner": {
              "x": -32.161,
              "y": -22.155,
              "z": 1.112
            },
            "gtin": "8700216210508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70ca",
            "leftCorner": {
              "x": -32.161,
              "y": -22.145,
              "z": 1.112
            },
            "rightCorner": {
              "x": -32.24,
              "y": -22.145,
              "z": 1.112
            },
            "gtin": "8700216212724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70cb",
            "leftCorner": {
              "x": -32.24,
              "y": -22.142,
              "z": 1.112
            },
            "rightCorner": {
              "x": -32.302,
              "y": -22.143,
              "z": 1.112
            },
            "gtin": "8700216212847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70cc",
            "leftCorner": {
              "x": -32.302,
              "y": -22.139,
              "z": 1.112
            },
            "rightCorner": {
              "x": -32.374,
              "y": -22.139,
              "z": 1.112
            },
            "gtin": "8700216210607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70cd",
            "leftCorner": {
              "x": -32.374,
              "y": -22.138,
              "z": 1.112
            },
            "rightCorner": {
              "x": -32.45,
              "y": -22.138,
              "z": 1.112
            },
            "gtin": "8700216227018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70ce",
            "leftCorner": {
              "x": -32.45,
              "y": -22.139,
              "z": 1.112
            },
            "rightCorner": {
              "x": -32.523,
              "y": -22.14,
              "z": 1.112
            },
            "gtin": "8700216212786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70ac",
            "leftCorner": {
              "x": -32.523,
              "y": -22.143,
              "z": 1.112
            },
            "rightCorner": {
              "x": -32.574,
              "y": -22.143,
              "z": 1.112
            },
            "gtin": "8700216212786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9f743501a95995c97e67ed25",
            "leftCorner": {
              "x": -31.574,
              "y": -22.097,
              "z": 1.112
            },
            "rightCorner": {
              "x": -31.612,
              "y": -22.097,
              "z": 1.112
            },
            "gtin": "4015100813371",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d394",
        "height": 1.7096,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d704f",
            "leftCorner": {
              "x": -31.68,
              "y": -22.128,
              "z": 1.399
            },
            "rightCorner": {
              "x": -31.74,
              "y": -22.128,
              "z": 1.399
            },
            "gtin": "4072600282373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7050",
            "leftCorner": {
              "x": -31.74,
              "y": -22.13,
              "z": 1.399
            },
            "rightCorner": {
              "x": -31.8,
              "y": -22.13,
              "z": 1.399
            },
            "gtin": "4072600282380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7051",
            "leftCorner": {
              "x": -31.8,
              "y": -22.134,
              "z": 1.399
            },
            "rightCorner": {
              "x": -31.855,
              "y": -22.135,
              "z": 1.399
            },
            "gtin": "4072600282458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7052",
            "leftCorner": {
              "x": -31.855,
              "y": -22.137,
              "z": 1.399
            },
            "rightCorner": {
              "x": -31.923,
              "y": -22.137,
              "z": 1.399
            },
            "gtin": "4072600282458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7053",
            "leftCorner": {
              "x": -31.923,
              "y": -22.141,
              "z": 1.399
            },
            "rightCorner": {
              "x": -31.99,
              "y": -22.142,
              "z": 1.399
            },
            "gtin": "4072600282465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7054",
            "leftCorner": {
              "x": -31.99,
              "y": -22.147,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.07,
              "y": -22.147,
              "z": 1.399
            },
            "gtin": "4072600720219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7055",
            "leftCorner": {
              "x": -32.07,
              "y": -22.148,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.124,
              "y": -22.148,
              "z": 1.399
            },
            "gtin": "4072600720295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7056",
            "leftCorner": {
              "x": -32.124,
              "y": -22.143,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.174,
              "y": -22.144,
              "z": 1.399
            },
            "gtin": "4072600720080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7057",
            "leftCorner": {
              "x": -32.174,
              "y": -22.14,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.237,
              "y": -22.14,
              "z": 1.399
            },
            "gtin": "4072600720080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7058",
            "leftCorner": {
              "x": -32.237,
              "y": -22.135,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.289,
              "y": -22.135,
              "z": 1.399
            },
            "gtin": "4260602128403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7059",
            "leftCorner": {
              "x": -32.289,
              "y": -22.135,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.335,
              "y": -22.136,
              "z": 1.399
            },
            "gtin": "4260602128427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d705a",
            "leftCorner": {
              "x": -32.335,
              "y": -22.135,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.394,
              "y": -22.135,
              "z": 1.399
            },
            "gtin": "4260602128403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d705b",
            "leftCorner": {
              "x": -32.394,
              "y": -22.137,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.441,
              "y": -22.137,
              "z": 1.399
            },
            "gtin": "4260702181179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d705c",
            "leftCorner": {
              "x": -32.441,
              "y": -22.138,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.484,
              "y": -22.139,
              "z": 1.399
            },
            "gtin": "4262401735295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d703d",
            "leftCorner": {
              "x": -32.484,
              "y": -22.14,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.574,
              "y": -22.14,
              "z": 1.399
            },
            "gtin": "4260602128663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f6fba8933a641bb8d7186e1b",
            "leftCorner": {
              "x": -31.574,
              "y": -22.094,
              "z": 1.399
            },
            "rightCorner": {
              "x": -31.631,
              "y": -22.094,
              "z": 1.399
            },
            "gtin": "4072600731505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a2c122c89572de5a0bcb6ff8",
            "leftCorner": {
              "x": -31.631,
              "y": -22.094,
              "z": 1.399
            },
            "rightCorner": {
              "x": -31.673,
              "y": -22.094,
              "z": 1.399
            },
            "gtin": "4262401735295",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c19",
    "rightNeighborShelfId": "c1b"
  },
  {
    "id": "c1b",
    "name": "c1b",
    "x": -32.56,
    "y": -22.152,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99442,
      "w": 0.10554
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 108
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d39f",
        "height": 0.16703,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d715f",
            "leftCorner": {
              "x": -33.134,
              "y": -21.983,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.255,
              "y": -21.956,
              "z": 0.137
            },
            "gtin": "4015100810561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7160",
            "leftCorner": {
              "x": -33.253,
              "y": -21.953,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.317,
              "y": -21.939,
              "z": 0.137
            },
            "gtin": "4015100810486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7161",
            "leftCorner": {
              "x": -33.316,
              "y": -21.93,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.402,
              "y": -21.912,
              "z": 0.137
            },
            "gtin": "4015100810462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7162",
            "leftCorner": {
              "x": -33.401,
              "y": -21.91,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.51,
              "y": -21.887,
              "z": 0.137
            },
            "gtin": "4015100810585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7163",
            "leftCorner": {
              "x": -33.509,
              "y": -21.883,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.669,
              "y": -21.85,
              "z": 0.137
            },
            "gtin": "4015100810066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d715c",
            "leftCorner": {
              "x": -33.667,
              "y": -21.838,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.716,
              "y": -21.827,
              "z": 0.137
            },
            "gtin": "4015100810240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8cd11fadae5427f7bbbd7e62",
            "leftCorner": {
              "x": -32.541,
              "y": -22.062,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.649,
              "y": -22.038,
              "z": 0.137
            },
            "gtin": "4015100810448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c8cb77ebd48cb199d330fa5e",
            "leftCorner": {
              "x": -32.649,
              "y": -22.038,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.776,
              "y": -22.011,
              "z": 0.137
            },
            "gtin": "4015100810547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8335904a3984f5cdf6c45544",
            "leftCorner": {
              "x": -32.776,
              "y": -22.011,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.831,
              "y": -21.999,
              "z": 0.137
            },
            "gtin": "4015100810066",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d3883f7c8689b2d18a0d9fad",
            "leftCorner": {
              "x": -32.831,
              "y": -21.999,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.958,
              "y": -21.972,
              "z": 0.137
            },
            "gtin": "4015100810547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ca926f368867abff9d6a6bf1",
            "leftCorner": {
              "x": -32.958,
              "y": -21.972,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.084,
              "y": -21.945,
              "z": 0.137
            },
            "gtin": "4015100810561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d715d",
            "leftCorner": {
              "x": -33.716,
              "y": -21.827,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.767,
              "y": -21.816,
              "z": 0.137
            },
            "gtin": "4015100810240",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d39a",
        "height": 0.46731,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d70f7",
            "leftCorner": {
              "x": -32.549,
              "y": -22.1,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.604,
              "y": -22.088,
              "z": 0.382
            },
            "gtin": "4015100810264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70f9",
            "leftCorner": {
              "x": -32.61,
              "y": -22.12,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.658,
              "y": -22.111,
              "z": 0.382
            },
            "gtin": "4015100810349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70fa",
            "leftCorner": {
              "x": -32.658,
              "y": -22.111,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.707,
              "y": -22.1,
              "z": 0.382
            },
            "gtin": "4015100810226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70fb",
            "leftCorner": {
              "x": -32.709,
              "y": -22.107,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.773,
              "y": -22.092,
              "z": 0.382
            },
            "gtin": "4015100810028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70fc",
            "leftCorner": {
              "x": -32.773,
              "y": -22.094,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.836,
              "y": -22.081,
              "z": 0.382
            },
            "gtin": "4015100810004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70fd",
            "leftCorner": {
              "x": -32.836,
              "y": -22.084,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.893,
              "y": -22.072,
              "z": 0.382
            },
            "gtin": "4015100809985",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70fe",
            "leftCorner": {
              "x": -32.893,
              "y": -22.071,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.936,
              "y": -22.063,
              "z": 0.382
            },
            "gtin": "4015100810103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70ff",
            "leftCorner": {
              "x": -32.936,
              "y": -22.063,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.987,
              "y": -22.052,
              "z": 0.382
            },
            "gtin": "4015100810080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7100",
            "leftCorner": {
              "x": -32.987,
              "y": -22.051,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.028,
              "y": -22.041,
              "z": 0.382
            },
            "gtin": "4015100810202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7101",
            "leftCorner": {
              "x": -33.028,
              "y": -22.043,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.073,
              "y": -22.034,
              "z": 0.382
            },
            "gtin": "4015100809961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7102",
            "leftCorner": {
              "x": -33.073,
              "y": -22.035,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.183,
              "y": -22.012,
              "z": 0.382
            },
            "gtin": "4005900749840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7103",
            "leftCorner": {
              "x": -33.181,
              "y": -22.003,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.298,
              "y": -21.978,
              "z": 0.382
            },
            "gtin": "4005900749642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7104",
            "leftCorner": {
              "x": -33.298,
              "y": -21.982,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.333,
              "y": -21.975,
              "z": 0.382
            },
            "gtin": "4005900749604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7105",
            "leftCorner": {
              "x": -33.332,
              "y": -21.973,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.376,
              "y": -21.964,
              "z": 0.382
            },
            "gtin": "4005900749529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7106",
            "leftCorner": {
              "x": -33.376,
              "y": -21.964,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.425,
              "y": -21.953,
              "z": 0.382
            },
            "gtin": "4005900749604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7107",
            "leftCorner": {
              "x": -33.423,
              "y": -21.951,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.477,
              "y": -21.94,
              "z": 0.382
            },
            "gtin": "4005900981530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7108",
            "leftCorner": {
              "x": -33.476,
              "y": -21.938,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.519,
              "y": -21.928,
              "z": 0.382
            },
            "gtin": "4005900751065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7109",
            "leftCorner": {
              "x": -33.519,
              "y": -21.93,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.566,
              "y": -21.919,
              "z": 0.382
            },
            "gtin": "4005900981530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d710a",
            "leftCorner": {
              "x": -33.566,
              "y": -21.915,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.608,
              "y": -21.906,
              "z": 0.382
            },
            "gtin": "4005900751065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d710b",
            "leftCorner": {
              "x": -33.608,
              "y": -21.905,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.655,
              "y": -21.895,
              "z": 0.382
            },
            "gtin": "4005900749765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d710c",
            "leftCorner": {
              "x": -33.654,
              "y": -21.891,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.703,
              "y": -21.881,
              "z": 0.382
            },
            "gtin": "4005900749680",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d70f8",
            "leftCorner": {
              "x": -33.703,
              "y": -21.884,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.778,
              "y": -21.867,
              "z": 0.382
            },
            "gtin": "4005900749369",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d39e",
        "height": 0.76716,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7145",
            "leftCorner": {
              "x": -32.549,
              "y": -22.103,
              "z": 0.628
            },
            "rightCorner": {
              "x": -32.637,
              "y": -22.084,
              "z": 0.628
            },
            "gtin": "4037900021534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7146",
            "leftCorner": {
              "x": -32.644,
              "y": -22.117,
              "z": 0.628
            },
            "rightCorner": {
              "x": -32.711,
              "y": -22.103,
              "z": 0.628
            },
            "gtin": "3600524140069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7147",
            "leftCorner": {
              "x": -32.713,
              "y": -22.107,
              "z": 0.628
            },
            "rightCorner": {
              "x": -32.789,
              "y": -22.09,
              "z": 0.628
            },
            "gtin": "8710908832192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7148",
            "leftCorner": {
              "x": -32.79,
              "y": -22.093,
              "z": 0.628
            },
            "rightCorner": {
              "x": -32.881,
              "y": -22.073,
              "z": 0.628
            },
            "gtin": "8006540346853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7149",
            "leftCorner": {
              "x": -32.881,
              "y": -22.073,
              "z": 0.628
            },
            "rightCorner": {
              "x": -32.974,
              "y": -22.053,
              "z": 0.628
            },
            "gtin": "8006540346853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d714a",
            "leftCorner": {
              "x": -32.974,
              "y": -22.052,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.075,
              "y": -22.031,
              "z": 0.628
            },
            "gtin": "7610099050423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d714b",
            "leftCorner": {
              "x": -33.077,
              "y": -22.037,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.124,
              "y": -22.026,
              "z": 0.628
            },
            "gtin": "3600524164614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d714c",
            "leftCorner": {
              "x": -33.124,
              "y": -22.027,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.175,
              "y": -22.016,
              "z": 0.628
            },
            "gtin": "3600524163785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d714d",
            "leftCorner": {
              "x": -33.175,
              "y": -22.018,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.227,
              "y": -22.006,
              "z": 0.628
            },
            "gtin": "3600521575543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d714e",
            "leftCorner": {
              "x": -33.226,
              "y": -22.002,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.283,
              "y": -21.99,
              "z": 0.628
            },
            "gtin": "3600521575543",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d714f",
            "leftCorner": {
              "x": -33.283,
              "y": -21.99,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.324,
              "y": -21.981,
              "z": 0.628
            },
            "gtin": "3600521108864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7150",
            "leftCorner": {
              "x": -33.323,
              "y": -21.979,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.368,
              "y": -21.969,
              "z": 0.628
            },
            "gtin": "3600522910015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7151",
            "leftCorner": {
              "x": -33.367,
              "y": -21.967,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.414,
              "y": -21.956,
              "z": 0.628
            },
            "gtin": "3600521108864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7152",
            "leftCorner": {
              "x": -33.414,
              "y": -21.954,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.485,
              "y": -21.939,
              "z": 0.628
            },
            "gtin": "4072600282243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7153",
            "leftCorner": {
              "x": -33.484,
              "y": -21.936,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.54,
              "y": -21.924,
              "z": 0.628
            },
            "gtin": "4013162033447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7154",
            "leftCorner": {
              "x": -33.54,
              "y": -21.924,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.609,
              "y": -21.91,
              "z": 0.628
            },
            "gtin": "4013162033447",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7155",
            "leftCorner": {
              "x": -33.608,
              "y": -21.905,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.665,
              "y": -21.893,
              "z": 0.628
            },
            "gtin": "4002753283057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7156",
            "leftCorner": {
              "x": -33.665,
              "y": -21.892,
              "z": 0.628
            },
            "rightCorner": {
              "x": -33.744,
              "y": -21.875,
              "z": 0.628
            },
            "gtin": "4002753283057",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d39b",
        "height": 1.0574,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d710d",
            "leftCorner": {
              "x": -32.552,
              "y": -22.113,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.603,
              "y": -22.102,
              "z": 0.865
            },
            "gtin": "4260702188239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d710e",
            "leftCorner": {
              "x": -32.609,
              "y": -22.131,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.661,
              "y": -22.119,
              "z": 0.865
            },
            "gtin": "4015100810288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d710f",
            "leftCorner": {
              "x": -32.662,
              "y": -22.123,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.714,
              "y": -22.112,
              "z": 0.865
            },
            "gtin": "4015100800227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7110",
            "leftCorner": {
              "x": -32.715,
              "y": -22.115,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.776,
              "y": -22.101,
              "z": 0.865
            },
            "gtin": "4015100800203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7111",
            "leftCorner": {
              "x": -32.776,
              "y": -22.103,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.828,
              "y": -22.093,
              "z": 0.865
            },
            "gtin": "4015100812176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7112",
            "leftCorner": {
              "x": -32.828,
              "y": -22.095,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.9,
              "y": -22.079,
              "z": 0.865
            },
            "gtin": "4015100812176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7113",
            "leftCorner": {
              "x": -32.9,
              "y": -22.081,
              "z": 0.865
            },
            "rightCorner": {
              "x": -32.973,
              "y": -22.065,
              "z": 0.865
            },
            "gtin": "4015100800180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7114",
            "leftCorner": {
              "x": -32.973,
              "y": -22.064,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.024,
              "y": -22.054,
              "z": 0.865
            },
            "gtin": "4015100800463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7115",
            "leftCorner": {
              "x": -33.024,
              "y": -22.055,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.08,
              "y": -22.043,
              "z": 0.865
            },
            "gtin": "4015100800463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7116",
            "leftCorner": {
              "x": -33.081,
              "y": -22.045,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.14,
              "y": -22.032,
              "z": 0.865
            },
            "gtin": "4015100800609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7117",
            "leftCorner": {
              "x": -33.14,
              "y": -22.034,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.214,
              "y": -22.018,
              "z": 0.865
            },
            "gtin": "4015100800388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7118",
            "leftCorner": {
              "x": -33.214,
              "y": -22.018,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.246,
              "y": -22.011,
              "z": 0.865
            },
            "gtin": "4015100800326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7119",
            "leftCorner": {
              "x": -33.246,
              "y": -22.011,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.279,
              "y": -22.004,
              "z": 0.865
            },
            "gtin": "4015100800326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d711a",
            "leftCorner": {
              "x": -33.279,
              "y": -22.004,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.347,
              "y": -21.989,
              "z": 0.865
            },
            "gtin": "4015100800265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d711b",
            "leftCorner": {
              "x": -33.346,
              "y": -21.985,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.4,
              "y": -21.973,
              "z": 0.865
            },
            "gtin": "4015100800562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d711c",
            "leftCorner": {
              "x": -33.399,
              "y": -21.97,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.439,
              "y": -21.962,
              "z": 0.865
            },
            "gtin": "4015100800487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d711d",
            "leftCorner": {
              "x": -33.439,
              "y": -21.958,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.5,
              "y": -21.945,
              "z": 0.865
            },
            "gtin": "4015100800487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d711e",
            "leftCorner": {
              "x": -33.5,
              "y": -21.945,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.558,
              "y": -21.932,
              "z": 0.865
            },
            "gtin": "4015100811698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d711f",
            "leftCorner": {
              "x": -33.558,
              "y": -21.931,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.619,
              "y": -21.918,
              "z": 0.865
            },
            "gtin": "4015100800524",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7120",
            "leftCorner": {
              "x": -33.619,
              "y": -21.916,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.698,
              "y": -21.899,
              "z": 0.865
            },
            "gtin": "4015100800548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7121",
            "leftCorner": {
              "x": -33.698,
              "y": -21.897,
              "z": 0.865
            },
            "rightCorner": {
              "x": -33.756,
              "y": -21.884,
              "z": 0.865
            },
            "gtin": "4015100800500",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d39c",
        "height": 1.3616,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7122",
            "leftCorner": {
              "x": -32.553,
              "y": -22.117,
              "z": 1.114
            },
            "rightCorner": {
              "x": -32.631,
              "y": -22.1,
              "z": 1.114
            },
            "gtin": "8700216309653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7124",
            "leftCorner": {
              "x": -32.638,
              "y": -22.132,
              "z": 1.114
            },
            "rightCorner": {
              "x": -32.713,
              "y": -22.117,
              "z": 1.114
            },
            "gtin": "8700216309677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7125",
            "leftCorner": {
              "x": -32.713,
              "y": -22.121,
              "z": 1.114
            },
            "rightCorner": {
              "x": -32.89,
              "y": -22.082,
              "z": 1.114
            },
            "gtin": "810006943450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7126",
            "leftCorner": {
              "x": -32.891,
              "y": -22.087,
              "z": 1.114
            },
            "rightCorner": {
              "x": -32.961,
              "y": -22.073,
              "z": 1.114
            },
            "gtin": "856017000126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7127",
            "leftCorner": {
              "x": -32.961,
              "y": -22.071,
              "z": 1.114
            },
            "rightCorner": {
              "x": -33.018,
              "y": -22.059,
              "z": 1.114
            },
            "gtin": "810006943429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7128",
            "leftCorner": {
              "x": -33.018,
              "y": -22.058,
              "z": 1.114
            },
            "rightCorner": {
              "x": -33.099,
              "y": -22.041,
              "z": 1.114
            },
            "gtin": "810006943412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7129",
            "leftCorner": {
              "x": -33.102,
              "y": -22.047,
              "z": 1.114
            },
            "rightCorner": {
              "x": -33.155,
              "y": -22.035,
              "z": 1.114
            },
            "gtin": "810006943481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d712a",
            "leftCorner": {
              "x": -33.155,
              "y": -22.034,
              "z": 1.114
            },
            "rightCorner": {
              "x": -33.207,
              "y": -22.023,
              "z": 1.114
            },
            "gtin": "3600542571739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d712b",
            "leftCorner": {
              "x": -33.207,
              "y": -22.022,
              "z": 1.114
            },
            "rightCorner": {
              "x": -33.262,
              "y": -22.01,
              "z": 1.114
            },
            "gtin": "3600542571739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d712c",
            "leftCorner": {
              "x": -33.262,
              "y": -22.007,
              "z": 1.114
            },
            "rightCorner": {
              "x": -33.351,
              "y": -21.988,
              "z": 1.114
            },
            "gtin": "3600542590631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d712d",
            "leftCorner": {
              "x": -33.348,
              "y": -21.977,
              "z": 1.114
            },
            "rightCorner": {
              "x": -33.399,
              "y": -21.966,
              "z": 1.114
            },
            "gtin": "3600542430432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d712e",
            "leftCorner": {
              "x": -33.4,
              "y": -21.973,
              "z": 1.114
            },
            "rightCorner": {
              "x": -33.473,
              "y": -21.958,
              "z": 1.114
            },
            "gtin": "3600542430432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d712f",
            "leftCorner": {
              "x": -33.473,
              "y": -21.954,
              "z": 1.114
            },
            "rightCorner": {
              "x": -33.547,
              "y": -21.938,
              "z": 1.114
            },
            "gtin": "4003573025018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7130",
            "leftCorner": {
              "x": -33.547,
              "y": -21.937,
              "z": 1.114
            },
            "rightCorner": {
              "x": -33.613,
              "y": -21.923,
              "z": 1.114
            },
            "gtin": "4003573025001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7131",
            "leftCorner": {
              "x": -33.611,
              "y": -21.917,
              "z": 1.114
            },
            "rightCorner": {
              "x": -33.688,
              "y": -21.901,
              "z": 1.114
            },
            "gtin": "4003573025025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7123",
            "leftCorner": {
              "x": -33.688,
              "y": -21.901,
              "z": 1.114
            },
            "rightCorner": {
              "x": -33.78,
              "y": -21.882,
              "z": 1.114
            },
            "gtin": "4045612009221",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d39d",
        "height": 1.7099,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7132",
            "leftCorner": {
              "x": -32.553,
              "y": -22.115,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.608,
              "y": -22.103,
              "z": 1.399
            },
            "gtin": "4260702185672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7134",
            "leftCorner": {
              "x": -32.613,
              "y": -22.128,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.668,
              "y": -22.116,
              "z": 1.399
            },
            "gtin": "4260702185696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7135",
            "leftCorner": {
              "x": -32.668,
              "y": -22.116,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.721,
              "y": -22.105,
              "z": 1.399
            },
            "gtin": "4260702185696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7136",
            "leftCorner": {
              "x": -32.724,
              "y": -22.114,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.805,
              "y": -22.097,
              "z": 1.399
            },
            "gtin": "4260702186747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7137",
            "leftCorner": {
              "x": -32.805,
              "y": -22.099,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.885,
              "y": -22.083,
              "z": 1.399
            },
            "gtin": "4260702186723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7138",
            "leftCorner": {
              "x": -32.886,
              "y": -22.085,
              "z": 1.399
            },
            "rightCorner": {
              "x": -32.969,
              "y": -22.067,
              "z": 1.399
            },
            "gtin": "4262401737848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7139",
            "leftCorner": {
              "x": -32.969,
              "y": -22.067,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.029,
              "y": -22.054,
              "z": 1.399
            },
            "gtin": "4021457655113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d713a",
            "leftCorner": {
              "x": -33.03,
              "y": -22.055,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.086,
              "y": -22.043,
              "z": 1.399
            },
            "gtin": "4021457655120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d713b",
            "leftCorner": {
              "x": -33.087,
              "y": -22.047,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.148,
              "y": -22.034,
              "z": 1.399
            },
            "gtin": "4021457655106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d713c",
            "leftCorner": {
              "x": -33.148,
              "y": -22.035,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.196,
              "y": -22.025,
              "z": 1.399
            },
            "gtin": "4260370437608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d713d",
            "leftCorner": {
              "x": -33.196,
              "y": -22.025,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.24,
              "y": -22.015,
              "z": 1.399
            },
            "gtin": "4260370437523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d713e",
            "leftCorner": {
              "x": -33.24,
              "y": -22.012,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.293,
              "y": -22.0,
              "z": 1.399
            },
            "gtin": "4260370437523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d713f",
            "leftCorner": {
              "x": -33.293,
              "y": -21.999,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.339,
              "y": -21.99,
              "z": 1.399
            },
            "gtin": "4260370437561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7140",
            "leftCorner": {
              "x": -33.339,
              "y": -21.989,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.393,
              "y": -21.977,
              "z": 1.399
            },
            "gtin": "4260370437585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7141",
            "leftCorner": {
              "x": -33.393,
              "y": -21.976,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.445,
              "y": -21.965,
              "z": 1.399
            },
            "gtin": "4008890006429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7142",
            "leftCorner": {
              "x": -33.445,
              "y": -21.962,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.525,
              "y": -21.944,
              "z": 1.399
            },
            "gtin": "4008890006429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7143",
            "leftCorner": {
              "x": -33.525,
              "y": -21.944,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.595,
              "y": -21.928,
              "z": 1.399
            },
            "gtin": "4008890006405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7144",
            "leftCorner": {
              "x": -33.595,
              "y": -21.927,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.724,
              "y": -21.9,
              "z": 1.399
            },
            "gtin": "4103040051653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7133",
            "leftCorner": {
              "x": -33.722,
              "y": -21.893,
              "z": 1.399
            },
            "rightCorner": {
              "x": -33.78,
              "y": -21.881,
              "z": 1.399
            },
            "gtin": "4103040048448",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c1a",
    "rightNeighborShelfId": "c1c"
  },
  {
    "id": "c1c",
    "name": "c1c",
    "x": -33.766,
    "y": -21.906,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.94552,
      "w": 0.32555
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 91
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3a5",
        "height": 0.16904,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d71b6",
            "leftCorner": {
              "x": -33.7,
              "y": -21.821,
              "z": 0.138
            },
            "rightCorner": {
              "x": -33.807,
              "y": -21.737,
              "z": 0.138
            },
            "gtin": "4015100810127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71b8",
            "leftCorner": {
              "x": -33.832,
              "y": -21.77,
              "z": 0.138
            },
            "rightCorner": {
              "x": -33.869,
              "y": -21.741,
              "z": 0.138
            },
            "gtin": "4015100810165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71b9",
            "leftCorner": {
              "x": -33.869,
              "y": -21.741,
              "z": 0.138
            },
            "rightCorner": {
              "x": -33.906,
              "y": -21.712,
              "z": 0.138
            },
            "gtin": "4015100810165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71ba",
            "leftCorner": {
              "x": -33.912,
              "y": -21.719,
              "z": 0.138
            },
            "rightCorner": {
              "x": -34.008,
              "y": -21.644,
              "z": 0.138
            },
            "gtin": "4015100810189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71bb",
            "leftCorner": {
              "x": -34.004,
              "y": -21.639,
              "z": 0.138
            },
            "rightCorner": {
              "x": -34.083,
              "y": -21.578,
              "z": 0.138
            },
            "gtin": "4015100810141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71bc",
            "leftCorner": {
              "x": -34.082,
              "y": -21.576,
              "z": 0.138
            },
            "rightCorner": {
              "x": -34.217,
              "y": -21.469,
              "z": 0.138
            },
            "gtin": "4015100860023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71bd",
            "leftCorner": {
              "x": -34.216,
              "y": -21.468,
              "z": 0.138
            },
            "rightCorner": {
              "x": -34.269,
              "y": -21.428,
              "z": 0.138
            },
            "gtin": "4015100817843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71be",
            "leftCorner": {
              "x": -34.268,
              "y": -21.427,
              "z": 0.138
            },
            "rightCorner": {
              "x": -34.357,
              "y": -21.357,
              "z": 0.138
            },
            "gtin": "4015100817867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71bf",
            "leftCorner": {
              "x": -34.357,
              "y": -21.356,
              "z": 0.138
            },
            "rightCorner": {
              "x": -34.463,
              "y": -21.273,
              "z": 0.138
            },
            "gtin": "4015100817904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71c0",
            "leftCorner": {
              "x": -34.462,
              "y": -21.271,
              "z": 0.138
            },
            "rightCorner": {
              "x": -34.5,
              "y": -21.242,
              "z": 0.138
            },
            "gtin": "4015100817881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71c1",
            "leftCorner": {
              "x": -34.502,
              "y": -21.244,
              "z": 0.138
            },
            "rightCorner": {
              "x": -34.54,
              "y": -21.213,
              "z": 0.138
            },
            "gtin": "4015100860085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71c2",
            "leftCorner": {
              "x": -34.54,
              "y": -21.213,
              "z": 0.138
            },
            "rightCorner": {
              "x": -34.607,
              "y": -21.162,
              "z": 0.138
            },
            "gtin": "4015100802139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71b7",
            "leftCorner": {
              "x": -34.611,
              "y": -21.166,
              "z": 0.138
            },
            "rightCorner": {
              "x": -34.712,
              "y": -21.086,
              "z": 0.138
            },
            "gtin": "4000576056124",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3a0",
        "height": 0.46747,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7164",
            "leftCorner": {
              "x": -33.731,
              "y": -21.862,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.78,
              "y": -21.822,
              "z": 0.382
            },
            "gtin": "4064666594613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7166",
            "leftCorner": {
              "x": -33.8,
              "y": -21.847,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.836,
              "y": -21.819,
              "z": 0.382
            },
            "gtin": "4064666847955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7167",
            "leftCorner": {
              "x": -33.838,
              "y": -21.822,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.867,
              "y": -21.8,
              "z": 0.382
            },
            "gtin": "4064666045177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7168",
            "leftCorner": {
              "x": -33.867,
              "y": -21.8,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.919,
              "y": -21.76,
              "z": 0.382
            },
            "gtin": "4064666847894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7169",
            "leftCorner": {
              "x": -33.928,
              "y": -21.77,
              "z": 0.382
            },
            "rightCorner": {
              "x": -33.976,
              "y": -21.732,
              "z": 0.382
            },
            "gtin": "4064666847948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d716a",
            "leftCorner": {
              "x": -33.97,
              "y": -21.724,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.019,
              "y": -21.687,
              "z": 0.382
            },
            "gtin": "4064666847900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d716b",
            "leftCorner": {
              "x": -34.019,
              "y": -21.686,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.064,
              "y": -21.651,
              "z": 0.382
            },
            "gtin": "4064666847870",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d716c",
            "leftCorner": {
              "x": -34.064,
              "y": -21.652,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.107,
              "y": -21.618,
              "z": 0.382
            },
            "gtin": "4064666847917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d716d",
            "leftCorner": {
              "x": -34.107,
              "y": -21.616,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.149,
              "y": -21.583,
              "z": 0.382
            },
            "gtin": "4064666847924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d716e",
            "leftCorner": {
              "x": -34.148,
              "y": -21.582,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.186,
              "y": -21.552,
              "z": 0.382
            },
            "gtin": "4064666045245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d716f",
            "leftCorner": {
              "x": -34.187,
              "y": -21.553,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.222,
              "y": -21.526,
              "z": 0.382
            },
            "gtin": "4064666847924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7170",
            "leftCorner": {
              "x": -34.221,
              "y": -21.524,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.26,
              "y": -21.494,
              "z": 0.382
            },
            "gtin": "4064666045245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7171",
            "leftCorner": {
              "x": -34.262,
              "y": -21.497,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.294,
              "y": -21.471,
              "z": 0.382
            },
            "gtin": "4064666847887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7172",
            "leftCorner": {
              "x": -34.294,
              "y": -21.471,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.329,
              "y": -21.445,
              "z": 0.382
            },
            "gtin": "4064666045207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7173",
            "leftCorner": {
              "x": -34.331,
              "y": -21.447,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.363,
              "y": -21.422,
              "z": 0.382
            },
            "gtin": "4064666045184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7174",
            "leftCorner": {
              "x": -34.363,
              "y": -21.422,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.394,
              "y": -21.399,
              "z": 0.382
            },
            "gtin": "4064666847863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7175",
            "leftCorner": {
              "x": -34.398,
              "y": -21.403,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.427,
              "y": -21.38,
              "z": 0.382
            },
            "gtin": "4064666847931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7176",
            "leftCorner": {
              "x": -34.422,
              "y": -21.374,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.452,
              "y": -21.351,
              "z": 0.382
            },
            "gtin": "42447603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7177",
            "leftCorner": {
              "x": -34.454,
              "y": -21.354,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.495,
              "y": -21.323,
              "z": 0.382
            },
            "gtin": "42447597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7178",
            "leftCorner": {
              "x": -34.497,
              "y": -21.326,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.562,
              "y": -21.276,
              "z": 0.382
            },
            "gtin": "42447559",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d7165",
            "leftCorner": {
              "x": -34.563,
              "y": -21.278,
              "z": 0.382
            },
            "rightCorner": {
              "x": -34.747,
              "y": -21.133,
              "z": 0.382
            },
            "gtin": "4306188051664",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3a4",
        "height": 0.77114,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d71a9",
            "leftCorner": {
              "x": -33.73,
              "y": -21.86,
              "z": 0.631
            },
            "rightCorner": {
              "x": -33.785,
              "y": -21.816,
              "z": 0.631
            },
            "gtin": "4015100810684",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d71ab",
            "leftCorner": {
              "x": -33.811,
              "y": -21.848,
              "z": 0.631
            },
            "rightCorner": {
              "x": -33.871,
              "y": -21.8,
              "z": 0.631
            },
            "gtin": "4015100811063",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d71ac",
            "leftCorner": {
              "x": -33.878,
              "y": -21.807,
              "z": 0.631
            },
            "rightCorner": {
              "x": -33.936,
              "y": -21.762,
              "z": 0.631
            },
            "gtin": "4015100810905",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d71ad",
            "leftCorner": {
              "x": -33.936,
              "y": -21.762,
              "z": 0.631
            },
            "rightCorner": {
              "x": -34.003,
              "y": -21.71,
              "z": 0.631
            },
            "gtin": "4015100811001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71ae",
            "leftCorner": {
              "x": -33.999,
              "y": -21.704,
              "z": 0.631
            },
            "rightCorner": {
              "x": -34.068,
              "y": -21.65,
              "z": 0.631
            },
            "gtin": "4015100810943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71af",
            "leftCorner": {
              "x": -34.068,
              "y": -21.649,
              "z": 0.631
            },
            "rightCorner": {
              "x": -34.124,
              "y": -21.604,
              "z": 0.631
            },
            "gtin": "4015100810820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71b0",
            "leftCorner": {
              "x": -34.123,
              "y": -21.602,
              "z": 0.631
            },
            "rightCorner": {
              "x": -34.182,
              "y": -21.556,
              "z": 0.631
            },
            "gtin": "4015100810981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71b1",
            "leftCorner": {
              "x": -34.182,
              "y": -21.556,
              "z": 0.631
            },
            "rightCorner": {
              "x": -34.249,
              "y": -21.504,
              "z": 0.631
            },
            "gtin": "4015100810882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71b2",
            "leftCorner": {
              "x": -34.249,
              "y": -21.504,
              "z": 0.631
            },
            "rightCorner": {
              "x": -34.308,
              "y": -21.457,
              "z": 0.631
            },
            "gtin": "4015100811049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71b3",
            "leftCorner": {
              "x": -34.309,
              "y": -21.458,
              "z": 0.631
            },
            "rightCorner": {
              "x": -34.379,
              "y": -21.403,
              "z": 0.631
            },
            "gtin": "4015100810967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71b4",
            "leftCorner": {
              "x": -34.377,
              "y": -21.401,
              "z": 0.631
            },
            "rightCorner": {
              "x": -34.437,
              "y": -21.355,
              "z": 0.631
            },
            "gtin": "4015100811025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71b5",
            "leftCorner": {
              "x": -34.434,
              "y": -21.351,
              "z": 0.631
            },
            "rightCorner": {
              "x": -34.501,
              "y": -21.298,
              "z": 0.631
            },
            "gtin": "4015100810844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71aa",
            "leftCorner": {
              "x": -34.503,
              "y": -21.3,
              "z": 0.631
            },
            "rightCorner": {
              "x": -34.737,
              "y": -21.119,
              "z": 0.631
            },
            "gtin": "4064666587479",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3a3",
        "height": 1.0596,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7198",
            "leftCorner": {
              "x": -33.737,
              "y": -21.869,
              "z": 0.867
            },
            "rightCorner": {
              "x": -33.791,
              "y": -21.826,
              "z": 0.867
            },
            "gtin": "4015100800081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d719a",
            "leftCorner": {
              "x": -33.817,
              "y": -21.859,
              "z": 0.867
            },
            "rightCorner": {
              "x": -33.871,
              "y": -21.816,
              "z": 0.867
            },
            "gtin": "4015100800128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d719b",
            "leftCorner": {
              "x": -33.873,
              "y": -21.819,
              "z": 0.867
            },
            "rightCorner": {
              "x": -33.941,
              "y": -21.767,
              "z": 0.867
            },
            "gtin": "4015100743098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d719c",
            "leftCorner": {
              "x": -33.944,
              "y": -21.771,
              "z": 0.867
            },
            "rightCorner": {
              "x": -33.996,
              "y": -21.73,
              "z": 0.867
            },
            "gtin": "3614226254283",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d719d",
            "leftCorner": {
              "x": -33.989,
              "y": -21.722,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.057,
              "y": -21.669,
              "z": 0.867
            },
            "gtin": "4015100190526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d719e",
            "leftCorner": {
              "x": -34.06,
              "y": -21.673,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.133,
              "y": -21.616,
              "z": 0.867
            },
            "gtin": "4005900137432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d719f",
            "leftCorner": {
              "x": -34.13,
              "y": -21.613,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.183,
              "y": -21.572,
              "z": 0.867
            },
            "gtin": "4005900183828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71a0",
            "leftCorner": {
              "x": -34.182,
              "y": -21.571,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.231,
              "y": -21.533,
              "z": 0.867
            },
            "gtin": "3600522471684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71a1",
            "leftCorner": {
              "x": -34.231,
              "y": -21.534,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.278,
              "y": -21.497,
              "z": 0.867
            },
            "gtin": "3600522471806",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71a2",
            "leftCorner": {
              "x": -34.276,
              "y": -21.495,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.327,
              "y": -21.455,
              "z": 0.867
            },
            "gtin": "3600522471714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71a3",
            "leftCorner": {
              "x": -34.329,
              "y": -21.458,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.378,
              "y": -21.419,
              "z": 0.867
            },
            "gtin": "3600522471691",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71a4",
            "leftCorner": {
              "x": -34.379,
              "y": -21.42,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.438,
              "y": -21.374,
              "z": 0.867
            },
            "gtin": "4013162032815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71a5",
            "leftCorner": {
              "x": -34.433,
              "y": -21.369,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.486,
              "y": -21.328,
              "z": 0.867
            },
            "gtin": "4104260064508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71a6",
            "leftCorner": {
              "x": -34.486,
              "y": -21.328,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.55,
              "y": -21.277,
              "z": 0.867
            },
            "gtin": "4104260064492",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71a7",
            "leftCorner": {
              "x": -34.55,
              "y": -21.278,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.624,
              "y": -21.221,
              "z": 0.867
            },
            "gtin": "4306188393603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71a8",
            "leftCorner": {
              "x": -34.624,
              "y": -21.221,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.698,
              "y": -21.163,
              "z": 0.867
            },
            "gtin": "4306188393603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7199",
            "leftCorner": {
              "x": -34.7,
              "y": -21.166,
              "z": 0.867
            },
            "rightCorner": {
              "x": -34.745,
              "y": -21.13,
              "z": 0.867
            },
            "gtin": "5014697020307",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3a1",
        "height": 1.3654,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7179",
            "leftCorner": {
              "x": -33.735,
              "y": -21.867,
              "z": 1.117
            },
            "rightCorner": {
              "x": -33.822,
              "y": -21.799,
              "z": 1.117
            },
            "gtin": "4045612009214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d717b",
            "leftCorner": {
              "x": -33.852,
              "y": -21.836,
              "z": 1.117
            },
            "rightCorner": {
              "x": -33.907,
              "y": -21.792,
              "z": 1.117
            },
            "gtin": "4104260076501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d717c",
            "leftCorner": {
              "x": -33.91,
              "y": -21.795,
              "z": 1.117
            },
            "rightCorner": {
              "x": -33.965,
              "y": -21.751,
              "z": 1.117
            },
            "gtin": "4104260074804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d717d",
            "leftCorner": {
              "x": -33.963,
              "y": -21.749,
              "z": 1.117
            },
            "rightCorner": {
              "x": -34.02,
              "y": -21.704,
              "z": 1.117
            },
            "gtin": "4104260074811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d717e",
            "leftCorner": {
              "x": -34.02,
              "y": -21.704,
              "z": 1.117
            },
            "rightCorner": {
              "x": -34.071,
              "y": -21.666,
              "z": 1.117
            },
            "gtin": "4104260074866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d717f",
            "leftCorner": {
              "x": -34.068,
              "y": -21.662,
              "z": 1.117
            },
            "rightCorner": {
              "x": -34.123,
              "y": -21.618,
              "z": 1.117
            },
            "gtin": "4104260073500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7180",
            "leftCorner": {
              "x": -34.123,
              "y": -21.616,
              "z": 1.117
            },
            "rightCorner": {
              "x": -34.174,
              "y": -21.576,
              "z": 1.117
            },
            "gtin": "4104260070936",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7181",
            "leftCorner": {
              "x": -34.174,
              "y": -21.575,
              "z": 1.117
            },
            "rightCorner": {
              "x": -34.237,
              "y": -21.527,
              "z": 1.117
            },
            "gtin": "42071389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7182",
            "leftCorner": {
              "x": -34.236,
              "y": -21.526,
              "z": 1.117
            },
            "rightCorner": {
              "x": -34.293,
              "y": -21.481,
              "z": 1.117
            },
            "gtin": "41042632",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7183",
            "leftCorner": {
              "x": -34.293,
              "y": -21.48,
              "z": 1.117
            },
            "rightCorner": {
              "x": -34.357,
              "y": -21.43,
              "z": 1.117
            },
            "gtin": "4104260073005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7184",
            "leftCorner": {
              "x": -34.358,
              "y": -21.431,
              "z": 1.117
            },
            "rightCorner": {
              "x": -34.42,
              "y": -21.383,
              "z": 1.117
            },
            "gtin": "41042656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7185",
            "leftCorner": {
              "x": -34.419,
              "y": -21.382,
              "z": 1.117
            },
            "rightCorner": {
              "x": -34.49,
              "y": -21.328,
              "z": 1.117
            },
            "gtin": "42070771",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7186",
            "leftCorner": {
              "x": -34.488,
              "y": -21.325,
              "z": 1.117
            },
            "rightCorner": {
              "x": -34.546,
              "y": -21.28,
              "z": 1.117
            },
            "gtin": "42104308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d717a",
            "leftCorner": {
              "x": -34.546,
              "y": -21.279,
              "z": 1.117
            },
            "rightCorner": {
              "x": -34.742,
              "y": -21.126,
              "z": 1.117
            },
            "gtin": "5029053039695",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3a2",
        "height": 1.7128,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7187",
            "leftCorner": {
              "x": -33.734,
              "y": -21.866,
              "z": 1.401
            },
            "rightCorner": {
              "x": -33.792,
              "y": -21.82,
              "z": 1.401
            },
            "gtin": "4103040048943",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7189",
            "leftCorner": {
              "x": -33.821,
              "y": -21.858,
              "z": 1.401
            },
            "rightCorner": {
              "x": -33.901,
              "y": -21.794,
              "z": 1.401
            },
            "gtin": "4103040048967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d718a",
            "leftCorner": {
              "x": -33.905,
              "y": -21.798,
              "z": 1.401
            },
            "rightCorner": {
              "x": -33.965,
              "y": -21.751,
              "z": 1.401
            },
            "gtin": "4103040048882",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d718b",
            "leftCorner": {
              "x": -33.961,
              "y": -21.747,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.046,
              "y": -21.681,
              "z": 1.401
            },
            "gtin": "4103040048905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d718c",
            "leftCorner": {
              "x": -34.047,
              "y": -21.682,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.11,
              "y": -21.632,
              "z": 1.401
            },
            "gtin": "4103040051677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d718d",
            "leftCorner": {
              "x": -34.107,
              "y": -21.628,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.16,
              "y": -21.588,
              "z": 1.401
            },
            "gtin": "4008666707567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d718e",
            "leftCorner": {
              "x": -34.16,
              "y": -21.587,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.199,
              "y": -21.556,
              "z": 1.401
            },
            "gtin": "4008666704207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d718f",
            "leftCorner": {
              "x": -34.199,
              "y": -21.555,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.243,
              "y": -21.522,
              "z": 1.401
            },
            "gtin": "4008666709547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7190",
            "leftCorner": {
              "x": -34.243,
              "y": -21.522,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.286,
              "y": -21.487,
              "z": 1.401
            },
            "gtin": "4008666704962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7191",
            "leftCorner": {
              "x": -34.285,
              "y": -21.486,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.346,
              "y": -21.439,
              "z": 1.401
            },
            "gtin": "4008666704962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7192",
            "leftCorner": {
              "x": -34.346,
              "y": -21.439,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.387,
              "y": -21.406,
              "z": 1.401
            },
            "gtin": "4008666700209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7193",
            "leftCorner": {
              "x": -34.386,
              "y": -21.405,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.418,
              "y": -21.38,
              "z": 1.401
            },
            "gtin": "4008666701701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7194",
            "leftCorner": {
              "x": -34.416,
              "y": -21.378,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.455,
              "y": -21.348,
              "z": 1.401
            },
            "gtin": "4008666700209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7195",
            "leftCorner": {
              "x": -34.455,
              "y": -21.348,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.498,
              "y": -21.315,
              "z": 1.401
            },
            "gtin": "4008666701701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7196",
            "leftCorner": {
              "x": -34.498,
              "y": -21.315,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.536,
              "y": -21.286,
              "z": 1.401
            },
            "gtin": "4008666750303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7197",
            "leftCorner": {
              "x": -34.533,
              "y": -21.282,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.581,
              "y": -21.245,
              "z": 1.401
            },
            "gtin": "4008666750303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7188",
            "leftCorner": {
              "x": -34.584,
              "y": -21.249,
              "z": 1.401
            },
            "rightCorner": {
              "x": -34.741,
              "y": -21.125,
              "z": 1.401
            },
            "gtin": "4051089815029",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c1b",
    "rightNeighborShelfId": "c1d"
  },
  {
    "id": "c1d",
    "name": "c1d",
    "x": -34.764,
    "y": -21.13,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.88712,
      "w": 0.46155
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 58
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3ac",
        "height": 0.1679,
        "facings": [
          {
            "id": "b945ea3926db6f78ba3e2ac8",
            "leftCorner": {
              "x": -34.697,
              "y": -21.082,
              "z": 0.137
            },
            "rightCorner": {
              "x": -34.733,
              "y": -21.031,
              "z": 0.137
            },
            "gtin": "3574661577869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "725de1eda45b59e7d5448a5d",
            "leftCorner": {
              "x": -34.733,
              "y": -21.031,
              "z": 0.137
            },
            "rightCorner": {
              "x": -34.764,
              "y": -20.987,
              "z": 0.137
            },
            "gtin": "5010934004598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6bebac6a93d2148606e0fa70",
            "leftCorner": {
              "x": -34.764,
              "y": -20.987,
              "z": 0.137
            },
            "rightCorner": {
              "x": -34.8,
              "y": -20.936,
              "z": 0.137
            },
            "gtin": "3574661577869",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "55efa1f9b8583db64059c1ea",
            "leftCorner": {
              "x": -34.8,
              "y": -20.936,
              "z": 0.137
            },
            "rightCorner": {
              "x": -34.842,
              "y": -20.876,
              "z": 0.137
            },
            "gtin": "3574661776729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "80fcae97914e3a84889c0fe0",
            "leftCorner": {
              "x": -34.842,
              "y": -20.876,
              "z": 0.137
            },
            "rightCorner": {
              "x": -34.884,
              "y": -20.815,
              "z": 0.137
            },
            "gtin": "5010934003591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "74867901e4e8e4d542293876",
            "leftCorner": {
              "x": -34.884,
              "y": -20.815,
              "z": 0.137
            },
            "rightCorner": {
              "x": -34.928,
              "y": -20.753,
              "z": 0.137
            },
            "gtin": "4005900216878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b17645142e4ffdcc6f1f5464",
            "leftCorner": {
              "x": -34.928,
              "y": -20.753,
              "z": 0.137
            },
            "rightCorner": {
              "x": -34.974,
              "y": -20.688,
              "z": 0.137
            },
            "gtin": "8700216213837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "47236a9d7373c594d1d954a2",
            "leftCorner": {
              "x": -34.974,
              "y": -20.688,
              "z": 0.137
            },
            "rightCorner": {
              "x": -35.021,
              "y": -20.62,
              "z": 0.137
            },
            "gtin": "8001841733050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fee3bffd9011dc1aeec43942",
            "leftCorner": {
              "x": -35.021,
              "y": -20.62,
              "z": 0.137
            },
            "rightCorner": {
              "x": -35.068,
              "y": -20.553,
              "z": 0.137
            },
            "gtin": "3574661776699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fd218ae28a77feeed0dd0338",
            "leftCorner": {
              "x": -35.068,
              "y": -20.553,
              "z": 0.137
            },
            "rightCorner": {
              "x": -35.116,
              "y": -20.485,
              "z": 0.137
            },
            "gtin": "3574661582481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "daf7e8ea5a2bfb3199a652c1",
            "leftCorner": {
              "x": -35.116,
              "y": -20.485,
              "z": 0.137
            },
            "rightCorner": {
              "x": -35.165,
              "y": -20.414,
              "z": 0.137
            },
            "gtin": "3574661776644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "113c7031bbe6b031497e5ee7",
            "leftCorner": {
              "x": -35.165,
              "y": -20.414,
              "z": 0.137
            },
            "rightCorner": {
              "x": -35.218,
              "y": -20.339,
              "z": 0.137
            },
            "gtin": "3574661567310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d719244e411249c5f667a1dc",
            "leftCorner": {
              "x": -35.218,
              "y": -20.339,
              "z": 0.137
            },
            "rightCorner": {
              "x": -35.272,
              "y": -20.262,
              "z": 0.137
            },
            "gtin": "4045612009139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8d8897f2bc2538d052127bac",
            "leftCorner": {
              "x": -35.272,
              "y": -20.262,
              "z": 0.137
            },
            "rightCorner": {
              "x": -35.41,
              "y": -20.065,
              "z": 0.137
            },
            "gtin": "8006540452189",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3ab",
        "height": 0.51739,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d71eb",
            "leftCorner": {
              "x": -34.715,
              "y": -21.096,
              "z": 0.423
            },
            "rightCorner": {
              "x": -34.945,
              "y": -20.767,
              "z": 0.423
            },
            "gtin": "5029053585932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71ed",
            "leftCorner": {
              "x": -34.983,
              "y": -20.793,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.192,
              "y": -20.494,
              "z": 0.423
            },
            "gtin": "5029053585949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71ee",
            "leftCorner": {
              "x": -35.188,
              "y": -20.491,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.323,
              "y": -20.298,
              "z": 0.423
            },
            "gtin": "4000576560164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71ef",
            "leftCorner": {
              "x": -35.321,
              "y": -20.297,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.408,
              "y": -20.173,
              "z": 0.423
            },
            "gtin": "4000576550226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71ec",
            "leftCorner": {
              "x": -35.407,
              "y": -20.172,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.462,
              "y": -20.093,
              "z": 0.423
            },
            "gtin": "4000576058579",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3aa",
        "height": 0.81951,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d71e5",
            "leftCorner": {
              "x": -34.718,
              "y": -21.097,
              "z": 0.671
            },
            "rightCorner": {
              "x": -34.857,
              "y": -20.898,
              "z": 0.671
            },
            "gtin": "5029053585925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71e7",
            "leftCorner": {
              "x": -34.896,
              "y": -20.925,
              "z": 0.671
            },
            "rightCorner": {
              "x": -35.052,
              "y": -20.704,
              "z": 0.671
            },
            "gtin": "8006540530832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71e8",
            "leftCorner": {
              "x": -35.046,
              "y": -20.699,
              "z": 0.671
            },
            "rightCorner": {
              "x": -35.164,
              "y": -20.53,
              "z": 0.671
            },
            "gtin": "8006540460016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71e9",
            "leftCorner": {
              "x": -35.163,
              "y": -20.529,
              "z": 0.671
            },
            "rightCorner": {
              "x": -35.285,
              "y": -20.355,
              "z": 0.671
            },
            "gtin": "8006540451991",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71ea",
            "leftCorner": {
              "x": -35.285,
              "y": -20.356,
              "z": 0.671
            },
            "rightCorner": {
              "x": -35.428,
              "y": -20.152,
              "z": 0.671
            },
            "gtin": "8006540452189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71e6",
            "leftCorner": {
              "x": -35.428,
              "y": -20.152,
              "z": 0.671
            },
            "rightCorner": {
              "x": -35.466,
              "y": -20.096,
              "z": 0.671
            },
            "gtin": "8001841733050",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3a9",
        "height": 1.1095,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d71db",
            "leftCorner": {
              "x": -34.727,
              "y": -21.103,
              "z": 0.908
            },
            "rightCorner": {
              "x": -34.757,
              "y": -21.06,
              "z": 0.908
            },
            "gtin": "8006530017633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71dc",
            "leftCorner": {
              "x": -34.757,
              "y": -21.06,
              "z": 0.908
            },
            "rightCorner": {
              "x": -34.788,
              "y": -21.017,
              "z": 0.908
            },
            "gtin": "8006530017633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71dd",
            "leftCorner": {
              "x": -34.788,
              "y": -21.017,
              "z": 0.908
            },
            "rightCorner": {
              "x": -34.818,
              "y": -20.973,
              "z": 0.908
            },
            "gtin": "8006530017633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71de",
            "leftCorner": {
              "x": -34.818,
              "y": -20.973,
              "z": 0.908
            },
            "rightCorner": {
              "x": -34.849,
              "y": -20.93,
              "z": 0.908
            },
            "gtin": "8006530017633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71e0",
            "leftCorner": {
              "x": -34.885,
              "y": -20.955,
              "z": 0.908
            },
            "rightCorner": {
              "x": -34.998,
              "y": -20.793,
              "z": 0.908
            },
            "gtin": "8700216637640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71e1",
            "leftCorner": {
              "x": -34.998,
              "y": -20.794,
              "z": 0.908
            },
            "rightCorner": {
              "x": -35.116,
              "y": -20.627,
              "z": 0.908
            },
            "gtin": "8700216637831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71e2",
            "leftCorner": {
              "x": -35.11,
              "y": -20.623,
              "z": 0.908
            },
            "rightCorner": {
              "x": -35.246,
              "y": -20.428,
              "z": 0.908
            },
            "gtin": "8700216638050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71e3",
            "leftCorner": {
              "x": -35.248,
              "y": -20.429,
              "z": 0.908
            },
            "rightCorner": {
              "x": -35.373,
              "y": -20.251,
              "z": 0.908
            },
            "gtin": "8006530017862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71e4",
            "leftCorner": {
              "x": -35.371,
              "y": -20.249,
              "z": 0.908
            },
            "rightCorner": {
              "x": -35.439,
              "y": -20.153,
              "z": 0.908
            },
            "gtin": "8700216638210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71df",
            "leftCorner": {
              "x": -35.438,
              "y": -20.152,
              "z": 0.908
            },
            "rightCorner": {
              "x": -35.474,
              "y": -20.101,
              "z": 0.908
            },
            "gtin": "8700216213837",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3a8",
        "height": 1.4113,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d71cf",
            "leftCorner": {
              "x": -34.727,
              "y": -21.103,
              "z": 1.155
            },
            "rightCorner": {
              "x": -34.813,
              "y": -20.979,
              "z": 1.155
            },
            "gtin": "9120116169642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71d1",
            "leftCorner": {
              "x": -34.851,
              "y": -21.005,
              "z": 1.155
            },
            "rightCorner": {
              "x": -34.902,
              "y": -20.932,
              "z": 1.155
            },
            "gtin": "3574661776644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71d2",
            "leftCorner": {
              "x": -34.901,
              "y": -20.932,
              "z": 1.155
            },
            "rightCorner": {
              "x": -34.949,
              "y": -20.862,
              "z": 1.155
            },
            "gtin": "3574661776699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71d3",
            "leftCorner": {
              "x": -34.947,
              "y": -20.861,
              "z": 1.155
            },
            "rightCorner": {
              "x": -34.988,
              "y": -20.805,
              "z": 1.155
            },
            "gtin": "3574661776729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71d4",
            "leftCorner": {
              "x": -34.99,
              "y": -20.806,
              "z": 1.155
            },
            "rightCorner": {
              "x": -35.039,
              "y": -20.736,
              "z": 1.155
            },
            "gtin": "3574661582481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71d5",
            "leftCorner": {
              "x": -35.035,
              "y": -20.733,
              "z": 1.155
            },
            "rightCorner": {
              "x": -35.087,
              "y": -20.658,
              "z": 1.155
            },
            "gtin": "3574661567310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71d6",
            "leftCorner": {
              "x": -35.087,
              "y": -20.658,
              "z": 1.155
            },
            "rightCorner": {
              "x": -35.163,
              "y": -20.55,
              "z": 1.155
            },
            "gtin": "3574661582474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71d7",
            "leftCorner": {
              "x": -35.16,
              "y": -20.548,
              "z": 1.155
            },
            "rightCorner": {
              "x": -35.223,
              "y": -20.457,
              "z": 1.155
            },
            "gtin": "3574661577845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71d8",
            "leftCorner": {
              "x": -35.225,
              "y": -20.459,
              "z": 1.155
            },
            "rightCorner": {
              "x": -35.305,
              "y": -20.344,
              "z": 1.155
            },
            "gtin": "3574661567327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71d9",
            "leftCorner": {
              "x": -35.304,
              "y": -20.343,
              "z": 1.155
            },
            "rightCorner": {
              "x": -35.375,
              "y": -20.243,
              "z": 1.155
            },
            "gtin": "3574661577852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71da",
            "leftCorner": {
              "x": -35.374,
              "y": -20.243,
              "z": 1.155
            },
            "rightCorner": {
              "x": -35.446,
              "y": -20.14,
              "z": 1.155
            },
            "gtin": "3574661582467",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3a7",
        "height": 1.7103,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d71c3",
            "leftCorner": {
              "x": -34.732,
              "y": -21.107,
              "z": 1.399
            },
            "rightCorner": {
              "x": -34.787,
              "y": -21.028,
              "z": 1.399
            },
            "gtin": "4051089878024",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71c5",
            "leftCorner": {
              "x": -34.823,
              "y": -21.052,
              "z": 1.399
            },
            "rightCorner": {
              "x": -34.869,
              "y": -20.985,
              "z": 1.399
            },
            "gtin": "4005900216878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71c6",
            "leftCorner": {
              "x": -34.869,
              "y": -20.985,
              "z": 1.399
            },
            "rightCorner": {
              "x": -34.926,
              "y": -20.904,
              "z": 1.399
            },
            "gtin": "4045612009139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71c7",
            "leftCorner": {
              "x": -34.926,
              "y": -20.904,
              "z": 1.399
            },
            "rightCorner": {
              "x": -34.955,
              "y": -20.862,
              "z": 1.399
            },
            "gtin": "5010934004598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71c8",
            "leftCorner": {
              "x": -34.954,
              "y": -20.862,
              "z": 1.399
            },
            "rightCorner": {
              "x": -34.997,
              "y": -20.802,
              "z": 1.399
            },
            "gtin": "5010934003591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71c9",
            "leftCorner": {
              "x": -34.999,
              "y": -20.803,
              "z": 1.399
            },
            "rightCorner": {
              "x": -35.057,
              "y": -20.72,
              "z": 1.399
            },
            "gtin": "3574660235982",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71ca",
            "leftCorner": {
              "x": -35.052,
              "y": -20.717,
              "z": 1.399
            },
            "rightCorner": {
              "x": -35.153,
              "y": -20.572,
              "z": 1.399
            },
            "gtin": "3574661587134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71cb",
            "leftCorner": {
              "x": -35.15,
              "y": -20.57,
              "z": 1.399
            },
            "rightCorner": {
              "x": -35.211,
              "y": -20.482,
              "z": 1.399
            },
            "gtin": "3574660235951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71cc",
            "leftCorner": {
              "x": -35.213,
              "y": -20.483,
              "z": 1.399
            },
            "rightCorner": {
              "x": -35.269,
              "y": -20.403,
              "z": 1.399
            },
            "gtin": "3574661654614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71cd",
            "leftCorner": {
              "x": -35.27,
              "y": -20.404,
              "z": 1.399
            },
            "rightCorner": {
              "x": -35.355,
              "y": -20.283,
              "z": 1.399
            },
            "gtin": "3574661654638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71ce",
            "leftCorner": {
              "x": -35.353,
              "y": -20.282,
              "z": 1.399
            },
            "rightCorner": {
              "x": -35.432,
              "y": -20.169,
              "z": 1.399
            },
            "gtin": "4306188011620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71c4",
            "leftCorner": {
              "x": -35.431,
              "y": -20.168,
              "z": 1.399
            },
            "rightCorner": {
              "x": -35.477,
              "y": -20.103,
              "z": 1.399
            },
            "gtin": "4306188011590",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c1c",
    "rightNeighborShelfId": "c1e"
  },
  {
    "id": "c1e",
    "name": "c1e",
    "x": -35.462,
    "y": -20.101,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.78309,
      "w": 0.62191
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3b2",
        "height": 0.16912,
        "facings": [
          {
            "id": "3e62b3e452d610ff0322e557",
            "leftCorner": {
              "x": -35.369,
              "y": -20.08,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.387,
              "y": -20.001,
              "z": 0.138
            },
            "gtin": "8700216472807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bd83e08e90b2d8d2a02e3cf2",
            "leftCorner": {
              "x": -35.387,
              "y": -20.001,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.416,
              "y": -19.876,
              "z": 0.138
            },
            "gtin": "8700216473101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "738c36f8a5eaa5357b3bff9d",
            "leftCorner": {
              "x": -35.416,
              "y": -19.876,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.449,
              "y": -19.738,
              "z": 0.138
            },
            "gtin": "8006540689233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "93f1c0165d4b899f5187eaaa",
            "leftCorner": {
              "x": -35.449,
              "y": -19.738,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.481,
              "y": -19.598,
              "z": 0.138
            },
            "gtin": "8006540689158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "237d440dd5cc94c016de90a5",
            "leftCorner": {
              "x": -35.481,
              "y": -19.598,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.513,
              "y": -19.459,
              "z": 0.138
            },
            "gtin": "4000576017033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a7f8db3735b862ecb69452b6",
            "leftCorner": {
              "x": -35.513,
              "y": -19.459,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.547,
              "y": -19.313,
              "z": 0.138
            },
            "gtin": "3574661486307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3748c5268d52c476c312b813",
            "leftCorner": {
              "x": -35.547,
              "y": -19.313,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.581,
              "y": -19.167,
              "z": 0.138
            },
            "gtin": "3574661486321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "29b3a5d2004cc3b815bacc74",
            "leftCorner": {
              "x": -35.581,
              "y": -19.167,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.615,
              "y": -19.02,
              "z": 0.138
            },
            "gtin": "8006540689271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "53e1a2829fca959d8a98b739",
            "leftCorner": {
              "x": -35.615,
              "y": -19.02,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.652,
              "y": -18.863,
              "z": 0.138
            },
            "gtin": "3574661487311",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3ae",
        "height": 0.51896,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d71fa",
            "leftCorner": {
              "x": -35.403,
              "y": -20.088,
              "z": 0.425
            },
            "rightCorner": {
              "x": -35.451,
              "y": -19.885,
              "z": 0.425
            },
            "gtin": "4000576576141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71fc",
            "leftCorner": {
              "x": -35.487,
              "y": -19.894,
              "z": 0.425
            },
            "rightCorner": {
              "x": -35.537,
              "y": -19.681,
              "z": 0.425
            },
            "gtin": "4000576572167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71fd",
            "leftCorner": {
              "x": -35.539,
              "y": -19.682,
              "z": 0.425
            },
            "rightCorner": {
              "x": -35.572,
              "y": -19.538,
              "z": 0.425
            },
            "gtin": "4000576017033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71fe",
            "leftCorner": {
              "x": -35.574,
              "y": -19.538,
              "z": 0.425
            },
            "rightCorner": {
              "x": -35.618,
              "y": -19.345,
              "z": 0.425
            },
            "gtin": "4000576021528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71ff",
            "leftCorner": {
              "x": -35.621,
              "y": -19.346,
              "z": 0.425
            },
            "rightCorner": {
              "x": -35.659,
              "y": -19.183,
              "z": 0.425
            },
            "gtin": "4000576047801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7200",
            "leftCorner": {
              "x": -35.659,
              "y": -19.183,
              "z": 0.425
            },
            "rightCorner": {
              "x": -35.697,
              "y": -19.021,
              "z": 0.425
            },
            "gtin": "4000576047801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71fb",
            "leftCorner": {
              "x": -35.685,
              "y": -19.017,
              "z": 0.425
            },
            "rightCorner": {
              "x": -35.717,
              "y": -18.877,
              "z": 0.425
            },
            "gtin": "4000576047825",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3b1",
        "height": 0.82153,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d720e",
            "leftCorner": {
              "x": -35.398,
              "y": -20.087,
              "z": 0.672
            },
            "rightCorner": {
              "x": -35.459,
              "y": -19.826,
              "z": 0.672
            },
            "gtin": "8006540688939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7210",
            "leftCorner": {
              "x": -35.493,
              "y": -19.834,
              "z": 0.672
            },
            "rightCorner": {
              "x": -35.598,
              "y": -19.385,
              "z": 0.672
            },
            "gtin": "8006540688892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7211",
            "leftCorner": {
              "x": -35.606,
              "y": -19.387,
              "z": 0.672
            },
            "rightCorner": {
              "x": -35.674,
              "y": -19.091,
              "z": 0.672
            },
            "gtin": "8006540689011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7212",
            "leftCorner": {
              "x": -35.67,
              "y": -19.091,
              "z": 0.672
            },
            "rightCorner": {
              "x": -35.7,
              "y": -18.964,
              "z": 0.672
            },
            "gtin": "8700216473101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d720f",
            "leftCorner": {
              "x": -35.695,
              "y": -18.963,
              "z": 0.672
            },
            "rightCorner": {
              "x": -35.714,
              "y": -18.877,
              "z": 0.672
            },
            "gtin": "8700216472807",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3b0",
        "height": 1.1121,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7208",
            "leftCorner": {
              "x": -35.411,
              "y": -20.089,
              "z": 0.91
            },
            "rightCorner": {
              "x": -35.495,
              "y": -19.723,
              "z": 0.91
            },
            "gtin": "8006540689196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d720a",
            "leftCorner": {
              "x": -35.533,
              "y": -19.732,
              "z": 0.91
            },
            "rightCorner": {
              "x": -35.567,
              "y": -19.584,
              "z": 0.91
            },
            "gtin": "8006540689271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d720b",
            "leftCorner": {
              "x": -35.569,
              "y": -19.585,
              "z": 0.91
            },
            "rightCorner": {
              "x": -35.638,
              "y": -19.29,
              "z": 0.91
            },
            "gtin": "8006540689110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d720c",
            "leftCorner": {
              "x": -35.646,
              "y": -19.292,
              "z": 0.91
            },
            "rightCorner": {
              "x": -35.676,
              "y": -19.164,
              "z": 0.91
            },
            "gtin": "8006540689158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d720d",
            "leftCorner": {
              "x": -35.669,
              "y": -19.162,
              "z": 0.91
            },
            "rightCorner": {
              "x": -35.702,
              "y": -19.022,
              "z": 0.91
            },
            "gtin": "8006540689233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7209",
            "leftCorner": {
              "x": -35.694,
              "y": -19.021,
              "z": 0.91
            },
            "rightCorner": {
              "x": -35.727,
              "y": -18.88,
              "z": 0.91
            },
            "gtin": "4000576942809",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3af",
        "height": 1.4156,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7201",
            "leftCorner": {
              "x": -35.406,
              "y": -20.088,
              "z": 1.158
            },
            "rightCorner": {
              "x": -35.441,
              "y": -19.934,
              "z": 1.158
            },
            "gtin": "3574661661957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7203",
            "leftCorner": {
              "x": -35.475,
              "y": -19.941,
              "z": 1.158
            },
            "rightCorner": {
              "x": -35.514,
              "y": -19.769,
              "z": 1.158
            },
            "gtin": "3574661487311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7204",
            "leftCorner": {
              "x": -35.516,
              "y": -19.77,
              "z": 1.158
            },
            "rightCorner": {
              "x": -35.55,
              "y": -19.627,
              "z": 1.158
            },
            "gtin": "3574661486307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7205",
            "leftCorner": {
              "x": -35.554,
              "y": -19.627,
              "z": 1.158
            },
            "rightCorner": {
              "x": -35.589,
              "y": -19.476,
              "z": 1.158
            },
            "gtin": "3574661482187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7206",
            "leftCorner": {
              "x": -35.594,
              "y": -19.477,
              "z": 1.158
            },
            "rightCorner": {
              "x": -35.646,
              "y": -19.253,
              "z": 1.158
            },
            "gtin": "3574661486314",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7207",
            "leftCorner": {
              "x": -35.645,
              "y": -19.253,
              "z": 1.158
            },
            "rightCorner": {
              "x": -35.674,
              "y": -19.126,
              "z": 1.158
            },
            "gtin": "3574661486321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7202",
            "leftCorner": {
              "x": -35.671,
              "y": -19.125,
              "z": 1.158
            },
            "rightCorner": {
              "x": -35.727,
              "y": -18.88,
              "z": 1.158
            },
            "gtin": "3574661482194",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3ad",
        "height": 1.7125,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d71f5",
            "leftCorner": {
              "x": -35.411,
              "y": -20.089,
              "z": 1.401
            },
            "rightCorner": {
              "x": -35.443,
              "y": -19.948,
              "z": 1.401
            },
            "gtin": "4306188047353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71f7",
            "leftCorner": {
              "x": -35.479,
              "y": -19.956,
              "z": 1.401
            },
            "rightCorner": {
              "x": -35.515,
              "y": -19.798,
              "z": 1.401
            },
            "gtin": "3574661661988",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71f8",
            "leftCorner": {
              "x": -35.514,
              "y": -19.798,
              "z": 1.401
            },
            "rightCorner": {
              "x": -35.584,
              "y": -19.501,
              "z": 1.401
            },
            "gtin": "3574661661995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71f9",
            "leftCorner": {
              "x": -35.593,
              "y": -19.502,
              "z": 1.401
            },
            "rightCorner": {
              "x": -35.662,
              "y": -19.2,
              "z": 1.401
            },
            "gtin": "3574661661940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d71f6",
            "leftCorner": {
              "x": -35.663,
              "y": -19.201,
              "z": 1.401
            },
            "rightCorner": {
              "x": -35.737,
              "y": -18.882,
              "z": 1.401
            },
            "gtin": "3574661500324",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c1d",
    "rightNeighborShelfId": "c1f"
  },
  {
    "id": "c1f",
    "name": "c1f",
    "x": -35.751,
    "y": -18.874,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.72794,
      "w": 0.68564
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3b8",
        "height": 0.17605,
        "facings": [
          {
            "id": "6289899143c0a9256f78d41d",
            "leftCorner": {
              "x": -35.666,
              "y": -18.868,
              "z": 0.144
            },
            "rightCorner": {
              "x": -35.672,
              "y": -18.767,
              "z": 0.144
            },
            "gtin": "8700216179348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c8f932e9c44839b77754d85d",
            "leftCorner": {
              "x": -35.672,
              "y": -18.767,
              "z": 0.144
            },
            "rightCorner": {
              "x": -35.679,
              "y": -18.661,
              "z": 0.144
            },
            "gtin": "7322540770841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7de70980818a677a3a780a05",
            "leftCorner": {
              "x": -35.679,
              "y": -18.661,
              "z": 0.144
            },
            "rightCorner": {
              "x": -35.687,
              "y": -18.516,
              "z": 0.144
            },
            "gtin": "7322541497501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6c98e28b0b817dfc8b25d77d",
            "leftCorner": {
              "x": -35.687,
              "y": -18.516,
              "z": 0.144
            },
            "rightCorner": {
              "x": -35.698,
              "y": -18.345,
              "z": 0.144
            },
            "gtin": "8700216179041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dfadb7d523eaf166e72e5ff7",
            "leftCorner": {
              "x": -35.698,
              "y": -18.345,
              "z": 0.144
            },
            "rightCorner": {
              "x": -35.708,
              "y": -18.172,
              "z": 0.144
            },
            "gtin": "7322541079677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bb2f33341be1e1ceef297c93",
            "leftCorner": {
              "x": -35.708,
              "y": -18.172,
              "z": 0.144
            },
            "rightCorner": {
              "x": -35.718,
              "y": -17.996,
              "z": 0.144
            },
            "gtin": "7322540887624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "85b3a1b4177f260877948252",
            "leftCorner": {
              "x": -35.718,
              "y": -17.996,
              "z": 0.144
            },
            "rightCorner": {
              "x": -35.729,
              "y": -17.813,
              "z": 0.144
            },
            "gtin": "7322541085227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "734bd5895cf860ae7d49845e",
            "leftCorner": {
              "x": -35.729,
              "y": -17.813,
              "z": 0.144
            },
            "rightCorner": {
              "x": -35.741,
              "y": -17.626,
              "z": 0.144
            },
            "gtin": "8700216664547",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3b3",
        "height": 0.51847,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7219",
            "leftCorner": {
              "x": -35.686,
              "y": -18.869,
              "z": 0.424
            },
            "rightCorner": {
              "x": -35.699,
              "y": -18.66,
              "z": 0.424
            },
            "gtin": "4000576441067",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d721c",
            "leftCorner": {
              "x": -35.745,
              "y": -18.662,
              "z": 0.424
            },
            "rightCorner": {
              "x": -35.763,
              "y": -18.357,
              "z": 0.424
            },
            "gtin": "4000576440060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d721d",
            "leftCorner": {
              "x": -35.754,
              "y": -18.356,
              "z": 0.424
            },
            "rightCorner": {
              "x": -35.776,
              "y": -17.987,
              "z": 0.424
            },
            "gtin": "7322542285398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d721a",
            "leftCorner": {
              "x": -35.778,
              "y": -17.987,
              "z": 0.424
            },
            "rightCorner": {
              "x": -35.789,
              "y": -17.805,
              "z": 0.424
            },
            "gtin": "7322542285589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d721b",
            "leftCorner": {
              "x": -35.789,
              "y": -17.805,
              "z": 0.424
            },
            "rightCorner": {
              "x": -35.8,
              "y": -17.624,
              "z": 0.424
            },
            "gtin": "7322542285589",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3b6",
        "height": 0.8118,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7232",
            "leftCorner": {
              "x": -35.696,
              "y": -18.87,
              "z": 0.664
            },
            "rightCorner": {
              "x": -35.711,
              "y": -18.643,
              "z": 0.664
            },
            "gtin": "8700216179577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7234",
            "leftCorner": {
              "x": -35.753,
              "y": -18.646,
              "z": 0.664
            },
            "rightCorner": {
              "x": -35.76,
              "y": -18.546,
              "z": 0.664
            },
            "gtin": "8700216179348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7235",
            "leftCorner": {
              "x": -35.755,
              "y": -18.546,
              "z": 0.664
            },
            "rightCorner": {
              "x": -35.765,
              "y": -18.374,
              "z": 0.664
            },
            "gtin": "8700216179041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7236",
            "leftCorner": {
              "x": -35.763,
              "y": -18.374,
              "z": 0.664
            },
            "rightCorner": {
              "x": -35.788,
              "y": -17.949,
              "z": 0.664
            },
            "gtin": "8700216224918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7233",
            "leftCorner": {
              "x": -35.792,
              "y": -17.949,
              "z": 0.664
            },
            "rightCorner": {
              "x": -35.812,
              "y": -17.625,
              "z": 0.664
            },
            "gtin": "8700216224970",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3b7",
        "height": 1.1132,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7237",
            "leftCorner": {
              "x": -35.693,
              "y": -18.87,
              "z": 0.911
            },
            "rightCorner": {
              "x": -35.704,
              "y": -18.692,
              "z": 0.911
            },
            "gtin": "7322541067780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7238",
            "leftCorner": {
              "x": -35.704,
              "y": -18.692,
              "z": 0.911
            },
            "rightCorner": {
              "x": -35.715,
              "y": -18.514,
              "z": 0.911
            },
            "gtin": "7322541067780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d723a",
            "leftCorner": {
              "x": -35.754,
              "y": -18.517,
              "z": 0.911
            },
            "rightCorner": {
              "x": -35.768,
              "y": -18.31,
              "z": 0.911
            },
            "gtin": "7322541067278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d723b",
            "leftCorner": {
              "x": -35.767,
              "y": -18.31,
              "z": 0.911
            },
            "rightCorner": {
              "x": -35.788,
              "y": -17.951,
              "z": 0.911
            },
            "gtin": "7322541068039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d723c",
            "leftCorner": {
              "x": -35.791,
              "y": -17.951,
              "z": 0.911
            },
            "rightCorner": {
              "x": -35.805,
              "y": -17.728,
              "z": 0.911
            },
            "gtin": "7322541091174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7239",
            "leftCorner": {
              "x": -35.801,
              "y": -17.727,
              "z": 0.911
            },
            "rightCorner": {
              "x": -35.806,
              "y": -17.625,
              "z": 0.911
            },
            "gtin": "7322540770841",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3b4",
        "height": 1.4173,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d721e",
            "leftCorner": {
              "x": -35.692,
              "y": -18.87,
              "z": 1.16
            },
            "rightCorner": {
              "x": -35.705,
              "y": -18.654,
              "z": 1.16
            },
            "gtin": "7322541343686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7220",
            "leftCorner": {
              "x": -35.746,
              "y": -18.656,
              "z": 1.16
            },
            "rightCorner": {
              "x": -35.756,
              "y": -18.483,
              "z": 1.16
            },
            "gtin": "7322541079677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7221",
            "leftCorner": {
              "x": -35.751,
              "y": -18.482,
              "z": 1.16
            },
            "rightCorner": {
              "x": -35.763,
              "y": -18.294,
              "z": 1.16
            },
            "gtin": "7322541079967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7222",
            "leftCorner": {
              "x": -35.764,
              "y": -18.294,
              "z": 1.16
            },
            "rightCorner": {
              "x": -35.769,
              "y": -18.199,
              "z": 1.16
            },
            "gtin": "7322541086194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7223",
            "leftCorner": {
              "x": -35.769,
              "y": -18.199,
              "z": 1.16
            },
            "rightCorner": {
              "x": -35.775,
              "y": -18.104,
              "z": 1.16
            },
            "gtin": "7322541086194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7224",
            "leftCorner": {
              "x": -35.775,
              "y": -18.104,
              "z": 1.16
            },
            "rightCorner": {
              "x": -35.78,
              "y": -18.009,
              "z": 1.16
            },
            "gtin": "7322541086194",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7225",
            "leftCorner": {
              "x": -35.785,
              "y": -18.01,
              "z": 1.16
            },
            "rightCorner": {
              "x": -35.798,
              "y": -17.804,
              "z": 1.16
            },
            "gtin": "7322541688442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d721f",
            "leftCorner": {
              "x": -35.796,
              "y": -17.804,
              "z": 1.16
            },
            "rightCorner": {
              "x": -35.807,
              "y": -17.625,
              "z": 1.16
            },
            "gtin": "7322541085227",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3b5",
        "height": 1.7149,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7226",
            "leftCorner": {
              "x": -35.696,
              "y": -18.87,
              "z": 1.403
            },
            "rightCorner": {
              "x": -35.707,
              "y": -18.696,
              "z": 1.403
            },
            "gtin": "7322541497426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7227",
            "leftCorner": {
              "x": -35.707,
              "y": -18.696,
              "z": 1.403
            },
            "rightCorner": {
              "x": -35.717,
              "y": -18.522,
              "z": 1.403
            },
            "gtin": "7322541497426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7229",
            "leftCorner": {
              "x": -35.757,
              "y": -18.524,
              "z": 1.403
            },
            "rightCorner": {
              "x": -35.766,
              "y": -18.376,
              "z": 1.403
            },
            "gtin": "7322541497501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d722a",
            "leftCorner": {
              "x": -35.766,
              "y": -18.376,
              "z": 1.403
            },
            "rightCorner": {
              "x": -35.777,
              "y": -18.201,
              "z": 1.403
            },
            "gtin": "7322540887624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d722b",
            "leftCorner": {
              "x": -35.777,
              "y": -18.201,
              "z": 1.403
            },
            "rightCorner": {
              "x": -35.8,
              "y": -17.809,
              "z": 1.403
            },
            "gtin": "7322540887648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d722c",
            "leftCorner": {
              "x": -35.802,
              "y": -17.809,
              "z": 1.403
            },
            "rightCorner": {
              "x": -35.816,
              "y": -17.576,
              "z": 1.403
            },
            "gtin": "8700216664547",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c1e",
    "rightNeighborShelfId": "43c"
  },
  {
    "id": "c26",
    "name": "c26",
    "x": -35.874,
    "y": -12.369,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71139,
      "w": 0.7028
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 74,
      "shelfCategory": "BABY_FOOD"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3cc",
        "height": 0.16833,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d725c",
            "leftCorner": {
              "x": -35.812,
              "y": -12.057,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.813,
              "y": -11.989,
              "z": 0.138
            },
            "gtin": "4062300345317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d725d",
            "leftCorner": {
              "x": -35.816,
              "y": -11.989,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.817,
              "y": -11.915,
              "z": 0.138
            },
            "gtin": "4062300392915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d725e",
            "leftCorner": {
              "x": -35.811,
              "y": -11.915,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.812,
              "y": -11.823,
              "z": 0.138
            },
            "gtin": "4062300393639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d725f",
            "leftCorner": {
              "x": -35.815,
              "y": -11.824,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.816,
              "y": -11.767,
              "z": 0.138
            },
            "gtin": "4062300345287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7260",
            "leftCorner": {
              "x": -35.813,
              "y": -11.767,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.813,
              "y": -11.7,
              "z": 0.138
            },
            "gtin": "4062300345287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7261",
            "leftCorner": {
              "x": -35.813,
              "y": -11.7,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.814,
              "y": -11.637,
              "z": 0.138
            },
            "gtin": "4018852032762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7262",
            "leftCorner": {
              "x": -35.819,
              "y": -11.637,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.82,
              "y": -11.564,
              "z": 0.138
            },
            "gtin": "4018852032786",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7263",
            "leftCorner": {
              "x": -35.817,
              "y": -11.564,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.818,
              "y": -11.49,
              "z": 0.138
            },
            "gtin": "4018852032779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7264",
            "leftCorner": {
              "x": -35.82,
              "y": -11.49,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.822,
              "y": -11.333,
              "z": 0.138
            },
            "gtin": "4018852032755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7265",
            "leftCorner": {
              "x": -35.82,
              "y": -11.333,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.821,
              "y": -11.263,
              "z": 0.138
            },
            "gtin": "4062300236424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d723e",
            "leftCorner": {
              "x": -35.817,
              "y": -11.263,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.819,
              "y": -11.118,
              "z": 0.138
            },
            "gtin": "4018852033974",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d48d906be84f0997a88de5c9",
            "leftCorner": {
              "x": -35.768,
              "y": -12.368,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.77,
              "y": -12.213,
              "z": 0.138
            },
            "gtin": "4018852032755",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2e1c4a64aae620340b5a1c97",
            "leftCorner": {
              "x": -35.77,
              "y": -12.213,
              "z": 0.138
            },
            "rightCorner": {
              "x": -35.771,
              "y": -12.105,
              "z": 0.138
            },
            "gtin": "4018852033974",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3cb",
        "height": 0.5176,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d72bf",
            "leftCorner": {
              "x": -35.85,
              "y": -12.337,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.851,
              "y": -12.238,
              "z": 0.423
            },
            "gtin": "4062300457652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72c0",
            "leftCorner": {
              "x": -35.851,
              "y": -12.238,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.853,
              "y": -12.094,
              "z": 0.423
            },
            "gtin": "4062300457683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72c1",
            "leftCorner": {
              "x": -35.854,
              "y": -12.094,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.856,
              "y": -11.934,
              "z": 0.423
            },
            "gtin": "4104420145467",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72c2",
            "leftCorner": {
              "x": -35.854,
              "y": -11.934,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.857,
              "y": -11.731,
              "z": 0.423
            },
            "gtin": "4104420237452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72c3",
            "leftCorner": {
              "x": -35.859,
              "y": -11.731,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.86,
              "y": -11.645,
              "z": 0.423
            },
            "gtin": "4104420082069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72c4",
            "leftCorner": {
              "x": -35.859,
              "y": -11.645,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.86,
              "y": -11.539,
              "z": 0.423
            },
            "gtin": "4104420225497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72c5",
            "leftCorner": {
              "x": -35.86,
              "y": -11.539,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.861,
              "y": -11.406,
              "z": 0.423
            },
            "gtin": "4018852035640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72c6",
            "leftCorner": {
              "x": -35.863,
              "y": -11.406,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.864,
              "y": -11.248,
              "z": 0.423
            },
            "gtin": "4018852036029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72c7",
            "leftCorner": {
              "x": -35.866,
              "y": -11.248,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.867,
              "y": -11.137,
              "z": 0.423
            },
            "gtin": "4018852029878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72c8",
            "leftCorner": {
              "x": -35.867,
              "y": -11.137,
              "z": 0.423
            },
            "rightCorner": {
              "x": -35.869,
              "y": -11.026,
              "z": 0.423
            },
            "gtin": "4018852029878",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3cd",
        "height": 0.75398,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d72df",
            "leftCorner": {
              "x": -35.863,
              "y": -12.341,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.864,
              "y": -12.248,
              "z": 0.617
            },
            "gtin": "4062300463011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72e0",
            "leftCorner": {
              "x": -35.86,
              "y": -12.248,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.862,
              "y": -12.128,
              "z": 0.617
            },
            "gtin": "4062300463646",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72e1",
            "leftCorner": {
              "x": -35.863,
              "y": -12.128,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.865,
              "y": -12.002,
              "z": 0.617
            },
            "gtin": "4104420137844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72e2",
            "leftCorner": {
              "x": -35.866,
              "y": -12.002,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.867,
              "y": -11.884,
              "z": 0.617
            },
            "gtin": "4104420082441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72e3",
            "leftCorner": {
              "x": -35.867,
              "y": -11.884,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.869,
              "y": -11.752,
              "z": 0.617
            },
            "gtin": "4104420206366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72e4",
            "leftCorner": {
              "x": -35.87,
              "y": -11.752,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.872,
              "y": -11.62,
              "z": 0.617
            },
            "gtin": "4104420168794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72e5",
            "leftCorner": {
              "x": -35.873,
              "y": -11.62,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.875,
              "y": -11.489,
              "z": 0.617
            },
            "gtin": "4018852035824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72e6",
            "leftCorner": {
              "x": -35.874,
              "y": -11.489,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.875,
              "y": -11.37,
              "z": 0.617
            },
            "gtin": "4018852035619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72e7",
            "leftCorner": {
              "x": -35.876,
              "y": -11.37,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.877,
              "y": -11.221,
              "z": 0.617
            },
            "gtin": "4018852035732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72d8",
            "leftCorner": {
              "x": -35.879,
              "y": -11.221,
              "z": 0.617
            },
            "rightCorner": {
              "x": -35.88,
              "y": -11.119,
              "z": 0.617
            },
            "gtin": "4018852035978",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3d2",
        "height": 0.93176,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7323",
            "leftCorner": {
              "x": -35.857,
              "y": -12.332,
              "z": 0.762
            },
            "rightCorner": {
              "x": -35.859,
              "y": -12.208,
              "z": 0.762
            },
            "gtin": "4104420082427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7324",
            "leftCorner": {
              "x": -35.861,
              "y": -12.208,
              "z": 0.762
            },
            "rightCorner": {
              "x": -35.863,
              "y": -12.095,
              "z": 0.762
            },
            "gtin": "4104420083721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7325",
            "leftCorner": {
              "x": -35.863,
              "y": -12.095,
              "z": 0.762
            },
            "rightCorner": {
              "x": -35.865,
              "y": -11.964,
              "z": 0.762
            },
            "gtin": "4104420141285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7326",
            "leftCorner": {
              "x": -35.87,
              "y": -11.964,
              "z": 0.762
            },
            "rightCorner": {
              "x": -35.871,
              "y": -11.829,
              "z": 0.762
            },
            "gtin": "4104420133402",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7327",
            "leftCorner": {
              "x": -35.868,
              "y": -11.829,
              "z": 0.762
            },
            "rightCorner": {
              "x": -35.87,
              "y": -11.638,
              "z": 0.762
            },
            "gtin": "4104420083349",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7328",
            "leftCorner": {
              "x": -35.873,
              "y": -11.638,
              "z": 0.762
            },
            "rightCorner": {
              "x": -35.877,
              "y": -11.318,
              "z": 0.762
            },
            "gtin": "4018852035374",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d731b",
            "leftCorner": {
              "x": -35.879,
              "y": -11.318,
              "z": 0.762
            },
            "rightCorner": {
              "x": -35.881,
              "y": -11.119,
              "z": 0.762
            },
            "gtin": "4018852035466",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3d1",
        "height": 1.1342,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d729c",
            "leftCorner": {
              "x": -35.857,
              "y": -12.337,
              "z": 0.928
            },
            "rightCorner": {
              "x": -35.861,
              "y": -12.084,
              "z": 0.928
            },
            "gtin": "4062300437517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d729d",
            "leftCorner": {
              "x": -35.866,
              "y": -12.085,
              "z": 0.928
            },
            "rightCorner": {
              "x": -35.869,
              "y": -11.904,
              "z": 0.928
            },
            "gtin": "4062300439665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d729e",
            "leftCorner": {
              "x": -35.869,
              "y": -11.904,
              "z": 0.928
            },
            "rightCorner": {
              "x": -35.871,
              "y": -11.734,
              "z": 0.928
            },
            "gtin": "4018852035589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d729f",
            "leftCorner": {
              "x": -35.873,
              "y": -11.734,
              "z": 0.928
            },
            "rightCorner": {
              "x": -35.874,
              "y": -11.619,
              "z": 0.928
            },
            "gtin": "4018852029984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72a0",
            "leftCorner": {
              "x": -35.876,
              "y": -11.619,
              "z": 0.928
            },
            "rightCorner": {
              "x": -35.877,
              "y": -11.484,
              "z": 0.928
            },
            "gtin": "4018852035558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72a1",
            "leftCorner": {
              "x": -35.876,
              "y": -11.484,
              "z": 0.928
            },
            "rightCorner": {
              "x": -35.879,
              "y": -11.228,
              "z": 0.928
            },
            "gtin": "4018852035497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7284",
            "leftCorner": {
              "x": -35.885,
              "y": -11.228,
              "z": 0.928
            },
            "rightCorner": {
              "x": -35.886,
              "y": -11.119,
              "z": 0.928
            },
            "gtin": "4018852035527",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3d0",
        "height": 1.3113,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d72a9",
            "leftCorner": {
              "x": -35.863,
              "y": -12.211,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.864,
              "y": -12.09,
              "z": 1.073
            },
            "gtin": "4104420186866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72aa",
            "leftCorner": {
              "x": -35.865,
              "y": -12.09,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.867,
              "y": -11.952,
              "z": 1.073
            },
            "gtin": "4018852035671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ab",
            "leftCorner": {
              "x": -35.868,
              "y": -11.952,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.87,
              "y": -11.834,
              "z": 1.073
            },
            "gtin": "4018852033295",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ac",
            "leftCorner": {
              "x": -35.873,
              "y": -11.834,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.874,
              "y": -11.692,
              "z": 1.073
            },
            "gtin": "4018852035794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ad",
            "leftCorner": {
              "x": -35.872,
              "y": -11.692,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.874,
              "y": -11.499,
              "z": 1.073
            },
            "gtin": "4018852035886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ae",
            "leftCorner": {
              "x": -35.878,
              "y": -11.499,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.88,
              "y": -11.31,
              "z": 1.073
            },
            "gtin": "4018852036173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72a3",
            "leftCorner": {
              "x": -35.881,
              "y": -11.31,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.883,
              "y": -11.119,
              "z": 1.073
            },
            "gtin": "4018852036456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bdf81ef99a95e57ca1491074",
            "leftCorner": {
              "x": -35.824,
              "y": -12.368,
              "z": 1.073
            },
            "rightCorner": {
              "x": -35.826,
              "y": -12.23,
              "z": 1.073
            },
            "gtin": "4018852035671",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3cf",
        "height": 1.4873,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7312",
            "leftCorner": {
              "x": -35.851,
              "y": -12.343,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.852,
              "y": -12.241,
              "z": 1.217
            },
            "gtin": "4104420146600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7313",
            "leftCorner": {
              "x": -35.852,
              "y": -12.241,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.853,
              "y": -12.128,
              "z": 1.217
            },
            "gtin": "4104420213852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7314",
            "leftCorner": {
              "x": -35.856,
              "y": -12.128,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.857,
              "y": -11.995,
              "z": 1.217
            },
            "gtin": "4104420258037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7315",
            "leftCorner": {
              "x": -35.858,
              "y": -11.995,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.86,
              "y": -11.865,
              "z": 1.217
            },
            "gtin": "4104420168756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7316",
            "leftCorner": {
              "x": -35.861,
              "y": -11.865,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.862,
              "y": -11.746,
              "z": 1.217
            },
            "gtin": "4104420215696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7317",
            "leftCorner": {
              "x": -35.865,
              "y": -11.746,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.866,
              "y": -11.617,
              "z": 1.217
            },
            "gtin": "4104420204706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7318",
            "leftCorner": {
              "x": -35.868,
              "y": -11.617,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.869,
              "y": -11.481,
              "z": 1.217
            },
            "gtin": "4104420081147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7319",
            "leftCorner": {
              "x": -35.869,
              "y": -11.481,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.872,
              "y": -11.243,
              "z": 1.217
            },
            "gtin": "4018852029243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d730a",
            "leftCorner": {
              "x": -35.873,
              "y": -11.243,
              "z": 1.217
            },
            "rightCorner": {
              "x": -35.875,
              "y": -11.119,
              "z": 1.217
            },
            "gtin": "4018852008521",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3ce",
        "height": 1.7356,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7300",
            "leftCorner": {
              "x": -35.858,
              "y": -12.336,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.859,
              "y": -12.252,
              "z": 1.42
            },
            "gtin": "4104420083707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7301",
            "leftCorner": {
              "x": -35.861,
              "y": -12.252,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.862,
              "y": -12.119,
              "z": 1.42
            },
            "gtin": "4104420083325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7302",
            "leftCorner": {
              "x": -35.867,
              "y": -12.119,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.869,
              "y": -11.972,
              "z": 1.42
            },
            "gtin": "4104420083400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7303",
            "leftCorner": {
              "x": -35.869,
              "y": -11.972,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.87,
              "y": -11.856,
              "z": 1.42
            },
            "gtin": "4104420083387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7304",
            "leftCorner": {
              "x": -35.87,
              "y": -11.856,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.872,
              "y": -11.72,
              "z": 1.42
            },
            "gtin": "4104420143685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7305",
            "leftCorner": {
              "x": -35.871,
              "y": -11.72,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.873,
              "y": -11.603,
              "z": 1.42
            },
            "gtin": "4104420253445",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7306",
            "leftCorner": {
              "x": -35.873,
              "y": -11.603,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.874,
              "y": -11.472,
              "z": 1.42
            },
            "gtin": "4018852036128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7307",
            "leftCorner": {
              "x": -35.874,
              "y": -11.472,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.876,
              "y": -11.346,
              "z": 1.42
            },
            "gtin": "4018852036487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7308",
            "leftCorner": {
              "x": -35.877,
              "y": -11.346,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.878,
              "y": -11.216,
              "z": 1.42
            },
            "gtin": "4018852036395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72e9",
            "leftCorner": {
              "x": -35.881,
              "y": -11.216,
              "z": 1.42
            },
            "rightCorner": {
              "x": -35.883,
              "y": -11.119,
              "z": 1.42
            },
            "gtin": "4018852036425",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "440",
    "rightNeighborShelfId": "c27"
  },
  {
    "id": "c27",
    "name": "c27",
    "x": -35.904,
    "y": -11.11,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71323,
      "w": 0.70093
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 36,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3d7",
        "height": 0.15271,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7355",
            "leftCorner": {
              "x": -35.797,
              "y": -11.108,
              "z": 0.125
            },
            "rightCorner": {
              "x": -35.799,
              "y": -11.021,
              "z": 0.125
            },
            "gtin": "2000439121756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7357",
            "leftCorner": {
              "x": -35.838,
              "y": -11.022,
              "z": 0.125
            },
            "rightCorner": {
              "x": -35.841,
              "y": -10.842,
              "z": 0.125
            },
            "gtin": "4000177170717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7358",
            "leftCorner": {
              "x": -35.836,
              "y": -10.842,
              "z": 0.125
            },
            "rightCorner": {
              "x": -35.841,
              "y": -10.56,
              "z": 0.125
            },
            "gtin": "4000177026700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7359",
            "leftCorner": {
              "x": -35.85,
              "y": -10.561,
              "z": 0.125
            },
            "rightCorner": {
              "x": -35.854,
              "y": -10.31,
              "z": 0.125
            },
            "gtin": "4000177032749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d735a",
            "leftCorner": {
              "x": -35.85,
              "y": -10.309,
              "z": 0.125
            },
            "rightCorner": {
              "x": -35.856,
              "y": -10.003,
              "z": 0.125
            },
            "gtin": "4000177997000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7356",
            "leftCorner": {
              "x": -35.856,
              "y": -10.003,
              "z": 0.125
            },
            "rightCorner": {
              "x": -35.859,
              "y": -9.859,
              "z": 0.125
            },
            "gtin": "4000177035634",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3d4",
        "height": 0.52616,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d72c9",
            "leftCorner": {
              "x": -35.893,
              "y": -11.017,
              "z": 0.43
            },
            "rightCorner": {
              "x": -35.896,
              "y": -10.862,
              "z": 0.43
            },
            "gtin": "4043922458548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "33469783b76b4ea3aeb40a5a",
            "leftCorner": {
              "x": -35.856,
              "y": -11.109,
              "z": 0.43
            },
            "rightCorner": {
              "x": -35.857,
              "y": -11.04,
              "z": 0.43
            },
            "gtin": "4019313014181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ca",
            "leftCorner": {
              "x": -35.897,
              "y": -10.862,
              "z": 0.43
            },
            "rightCorner": {
              "x": -35.902,
              "y": -10.607,
              "z": 0.43
            },
            "gtin": "4043922498506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72cb",
            "leftCorner": {
              "x": -35.905,
              "y": -10.607,
              "z": 0.43
            },
            "rightCorner": {
              "x": -35.91,
              "y": -10.329,
              "z": 0.43
            },
            "gtin": "4043922468547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72cc",
            "leftCorner": {
              "x": -35.909,
              "y": -10.329,
              "z": 0.43
            },
            "rightCorner": {
              "x": -35.911,
              "y": -10.224,
              "z": 0.43
            },
            "gtin": "4043922488545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72cd",
            "leftCorner": {
              "x": -35.911,
              "y": -10.224,
              "z": 0.43
            },
            "rightCorner": {
              "x": -35.912,
              "y": -10.119,
              "z": 0.43
            },
            "gtin": "4043922488545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72ce",
            "leftCorner": {
              "x": -35.917,
              "y": -10.119,
              "z": 0.43
            },
            "rightCorner": {
              "x": -35.919,
              "y": -10.005,
              "z": 0.43
            },
            "gtin": "4019313014143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72cf",
            "leftCorner": {
              "x": -35.918,
              "y": -10.005,
              "z": 0.43
            },
            "rightCorner": {
              "x": -35.92,
              "y": -9.87,
              "z": 0.43
            },
            "gtin": "4019313014181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72d0",
            "leftCorner": {
              "x": -35.92,
              "y": -9.87,
              "z": 0.43
            },
            "rightCorner": {
              "x": -35.922,
              "y": -9.735,
              "z": 0.43
            },
            "gtin": "4019313014181",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3d6",
        "height": 0.90553,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d734a",
            "leftCorner": {
              "x": -35.858,
              "y": -11.109,
              "z": 0.741
            },
            "rightCorner": {
              "x": -35.862,
              "y": -10.868,
              "z": 0.741
            },
            "gtin": "4000177033708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d734c",
            "leftCorner": {
              "x": -35.9,
              "y": -10.869,
              "z": 0.741
            },
            "rightCorner": {
              "x": -35.903,
              "y": -10.677,
              "z": 0.741
            },
            "gtin": "4000177035399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d734d",
            "leftCorner": {
              "x": -35.904,
              "y": -10.677,
              "z": 0.741
            },
            "rightCorner": {
              "x": -35.91,
              "y": -10.389,
              "z": 0.741
            },
            "gtin": "4000177172629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d734e",
            "leftCorner": {
              "x": -35.91,
              "y": -10.389,
              "z": 0.741
            },
            "rightCorner": {
              "x": -35.913,
              "y": -10.213,
              "z": 0.741
            },
            "gtin": "4000177155417",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d734f",
            "leftCorner": {
              "x": -35.917,
              "y": -10.213,
              "z": 0.741
            },
            "rightCorner": {
              "x": -35.921,
              "y": -9.948,
              "z": 0.741
            },
            "gtin": "4000177172650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7350",
            "leftCorner": {
              "x": -35.921,
              "y": -9.948,
              "z": 0.741
            },
            "rightCorner": {
              "x": -35.926,
              "y": -9.683,
              "z": 0.741
            },
            "gtin": "4000177172650",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3d3",
        "height": 1.2579,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7329",
            "leftCorner": {
              "x": -35.862,
              "y": -11.109,
              "z": 1.029
            },
            "rightCorner": {
              "x": -35.866,
              "y": -10.903,
              "z": 1.029
            },
            "gtin": "4048517667589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d732b",
            "leftCorner": {
              "x": -35.9,
              "y": -10.903,
              "z": 1.029
            },
            "rightCorner": {
              "x": -35.903,
              "y": -10.737,
              "z": 1.029
            },
            "gtin": "4048517667503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d732c",
            "leftCorner": {
              "x": -35.906,
              "y": -10.737,
              "z": 1.029
            },
            "rightCorner": {
              "x": -35.908,
              "y": -10.601,
              "z": 1.029
            },
            "gtin": "4048517709722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d732d",
            "leftCorner": {
              "x": -35.911,
              "y": -10.601,
              "z": 1.029
            },
            "rightCorner": {
              "x": -35.915,
              "y": -10.383,
              "z": 1.029
            },
            "gtin": "4100060035090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d732e",
            "leftCorner": {
              "x": -35.914,
              "y": -10.383,
              "z": 1.029
            },
            "rightCorner": {
              "x": -35.919,
              "y": -10.157,
              "z": 1.029
            },
            "gtin": "4100060035076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d732f",
            "leftCorner": {
              "x": -35.921,
              "y": -10.158,
              "z": 1.029
            },
            "rightCorner": {
              "x": -35.924,
              "y": -9.973,
              "z": 1.029
            },
            "gtin": "4100060035014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7330",
            "leftCorner": {
              "x": -35.925,
              "y": -9.973,
              "z": 1.029
            },
            "rightCorner": {
              "x": -35.929,
              "y": -9.784,
              "z": 1.029
            },
            "gtin": "4002221002630",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3d5",
        "height": 1.6104,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7335",
            "leftCorner": {
              "x": -35.858,
              "y": -11.109,
              "z": 1.318
            },
            "rightCorner": {
              "x": -35.86,
              "y": -11.025,
              "z": 1.318
            },
            "gtin": "4048517689802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7336",
            "leftCorner": {
              "x": -35.86,
              "y": -11.025,
              "z": 1.318
            },
            "rightCorner": {
              "x": -35.861,
              "y": -10.941,
              "z": 1.318
            },
            "gtin": "4048517689802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7337",
            "leftCorner": {
              "x": -35.861,
              "y": -10.941,
              "z": 1.318
            },
            "rightCorner": {
              "x": -35.863,
              "y": -10.857,
              "z": 1.318
            },
            "gtin": "4048517689802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7338",
            "leftCorner": {
              "x": -35.901,
              "y": -10.857,
              "z": 1.318
            },
            "rightCorner": {
              "x": -35.904,
              "y": -10.676,
              "z": 1.318
            },
            "gtin": "9008700192415",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d7339",
            "leftCorner": {
              "x": -35.905,
              "y": -10.676,
              "z": 1.318
            },
            "rightCorner": {
              "x": -35.907,
              "y": -10.581,
              "z": 1.318
            },
            "gtin": "9008700175920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d733a",
            "leftCorner": {
              "x": -35.908,
              "y": -10.581,
              "z": 1.318
            },
            "rightCorner": {
              "x": -35.91,
              "y": -10.435,
              "z": 1.318
            },
            "gtin": "9008700176248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d733b",
            "leftCorner": {
              "x": -35.909,
              "y": -10.435,
              "z": 1.318
            },
            "rightCorner": {
              "x": -35.911,
              "y": -10.329,
              "z": 1.318
            },
            "gtin": "9008700230223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d733c",
            "leftCorner": {
              "x": -35.913,
              "y": -10.329,
              "z": 1.318
            },
            "rightCorner": {
              "x": -35.915,
              "y": -10.196,
              "z": 1.318
            },
            "gtin": "9008700230186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d733d",
            "leftCorner": {
              "x": -35.919,
              "y": -10.197,
              "z": 1.318
            },
            "rightCorner": {
              "x": -35.924,
              "y": -9.963,
              "z": 1.318
            },
            "gtin": "4009491020128",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d733e",
            "leftCorner": {
              "x": -35.922,
              "y": -9.963,
              "z": 1.318
            },
            "rightCorner": {
              "x": -35.924,
              "y": -9.857,
              "z": 1.318
            },
            "gtin": "4009491020135",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d733f",
            "leftCorner": {
              "x": -35.922,
              "y": -9.857,
              "z": 1.318
            },
            "rightCorner": {
              "x": -35.924,
              "y": -9.727,
              "z": 1.318
            },
            "gtin": "3052911606717",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c26",
    "rightNeighborShelfId": "c28"
  },
  {
    "id": "c28",
    "name": "c28",
    "x": -35.922,
    "y": -9.847,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71372,
      "w": 0.70044
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 40,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d77c",
        "height": 0.17058,
        "facings": [
          {
            "id": "ff4de83105ff6ab2fe98ed3c",
            "leftCorner": {
              "x": -35.863,
              "y": -9.846,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.864,
              "y": -9.772,
              "z": 0.14
            },
            "gtin": "3052911606724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e25e8c91267ababbad4c6f6f",
            "leftCorner": {
              "x": -35.864,
              "y": -9.772,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.866,
              "y": -9.697,
              "z": 0.14
            },
            "gtin": "3052911606717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fe4e98159e0e3a7c7198941c",
            "leftCorner": {
              "x": -35.866,
              "y": -9.697,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.867,
              "y": -9.611,
              "z": 0.14
            },
            "gtin": "4000177031292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "31c5a54de3015452bded1061",
            "leftCorner": {
              "x": -35.867,
              "y": -9.611,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.869,
              "y": -9.52,
              "z": 0.14
            },
            "gtin": "3052911607059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2c7b9107d37fdce031c3aff4",
            "leftCorner": {
              "x": -35.869,
              "y": -9.52,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.871,
              "y": -9.428,
              "z": 0.14
            },
            "gtin": "3052911607035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d1c6930d2fe55b4e48ce5da5",
            "leftCorner": {
              "x": -35.871,
              "y": -9.428,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.873,
              "y": -9.334,
              "z": 0.14
            },
            "gtin": "3052911606571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "97a9f03124f68833f3932c08",
            "leftCorner": {
              "x": -35.873,
              "y": -9.334,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.874,
              "y": -9.235,
              "z": 0.14
            },
            "gtin": "3052911607004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e792a09112b565a309400cb8",
            "leftCorner": {
              "x": -35.874,
              "y": -9.235,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.876,
              "y": -9.134,
              "z": 0.14
            },
            "gtin": "3052911606694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "584edb1070338400204887b9",
            "leftCorner": {
              "x": -35.876,
              "y": -9.134,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.878,
              "y": -9.031,
              "z": 0.14
            },
            "gtin": "4019313014167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ec2525b2f34c20aa53edf407",
            "leftCorner": {
              "x": -35.878,
              "y": -9.031,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.88,
              "y": -8.926,
              "z": 0.14
            },
            "gtin": "3052911606656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8922a833effc3b954b213e03",
            "leftCorner": {
              "x": -35.88,
              "y": -8.926,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.882,
              "y": -8.818,
              "z": 0.14
            },
            "gtin": "4019313014228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c0a11e31d817dfc6ab5fe53e",
            "leftCorner": {
              "x": -35.882,
              "y": -8.818,
              "z": 0.14
            },
            "rightCorner": {
              "x": -35.886,
              "y": -8.602,
              "z": 0.14
            },
            "gtin": "4000177035016",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d778",
        "height": 0.52917,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d72d1",
            "leftCorner": {
              "x": -35.96,
              "y": -9.723,
              "z": 0.433
            },
            "rightCorner": {
              "x": -35.962,
              "y": -9.619,
              "z": 0.433
            },
            "gtin": "4019313014167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72d2",
            "leftCorner": {
              "x": -35.965,
              "y": -9.619,
              "z": 0.433
            },
            "rightCorner": {
              "x": -35.967,
              "y": -9.511,
              "z": 0.433
            },
            "gtin": "4019313014228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72d3",
            "leftCorner": {
              "x": -35.967,
              "y": -9.511,
              "z": 0.433
            },
            "rightCorner": {
              "x": -35.971,
              "y": -9.315,
              "z": 0.433
            },
            "gtin": "9001400108229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72d4",
            "leftCorner": {
              "x": -35.972,
              "y": -9.315,
              "z": 0.433
            },
            "rightCorner": {
              "x": -35.974,
              "y": -9.195,
              "z": 0.433
            },
            "gtin": "9001400108960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72d5",
            "leftCorner": {
              "x": -35.972,
              "y": -9.195,
              "z": 0.433
            },
            "rightCorner": {
              "x": -35.974,
              "y": -9.079,
              "z": 0.433
            },
            "gtin": "4048517720918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72d6",
            "leftCorner": {
              "x": -35.975,
              "y": -9.079,
              "z": 0.433
            },
            "rightCorner": {
              "x": -35.979,
              "y": -8.829,
              "z": 0.433
            },
            "gtin": "4048517720949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d72b0",
            "leftCorner": {
              "x": -35.973,
              "y": -8.829,
              "z": 0.433
            },
            "rightCorner": {
              "x": -35.978,
              "y": -8.598,
              "z": 0.433
            },
            "gtin": "4000177035016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "542807ecfb413142cdeb1a89",
            "leftCorner": {
              "x": -35.92,
              "y": -9.847,
              "z": 0.433
            },
            "rightCorner": {
              "x": -35.922,
              "y": -9.729,
              "z": 0.433
            },
            "gtin": "4048517720918",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d77b",
        "height": 0.90922,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7351",
            "leftCorner": {
              "x": -35.962,
              "y": -9.671,
              "z": 0.744
            },
            "rightCorner": {
              "x": -35.963,
              "y": -9.583,
              "z": 0.744
            },
            "gtin": "4000177031292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7352",
            "leftCorner": {
              "x": -35.962,
              "y": -9.583,
              "z": 0.744
            },
            "rightCorner": {
              "x": -35.964,
              "y": -9.473,
              "z": 0.744
            },
            "gtin": "4000177033326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7353",
            "leftCorner": {
              "x": -35.97,
              "y": -9.473,
              "z": 0.744
            },
            "rightCorner": {
              "x": -35.977,
              "y": -9.086,
              "z": 0.744
            },
            "gtin": "4306188034384",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d7354",
            "leftCorner": {
              "x": -35.981,
              "y": -9.086,
              "z": 0.744
            },
            "rightCorner": {
              "x": -35.989,
              "y": -8.688,
              "z": 0.744
            },
            "gtin": "4306188034421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d734b",
            "leftCorner": {
              "x": -35.988,
              "y": -8.688,
              "z": 0.744
            },
            "rightCorner": {
              "x": -35.99,
              "y": -8.598,
              "z": 0.744
            },
            "gtin": "4008300004311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8590f6e8ea53f0ac9a50ba94",
            "leftCorner": {
              "x": -35.921,
              "y": -9.847,
              "z": 0.744
            },
            "rightCorner": {
              "x": -35.923,
              "y": -9.729,
              "z": 0.744
            },
            "gtin": "4008300004311",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d77a",
        "height": 1.2642,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7331",
            "leftCorner": {
              "x": -35.96,
              "y": -9.772,
              "z": 1.034
            },
            "rightCorner": {
              "x": -35.963,
              "y": -9.66,
              "z": 1.034
            },
            "gtin": "4002221002616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7332",
            "leftCorner": {
              "x": -35.967,
              "y": -9.66,
              "z": 1.034
            },
            "rightCorner": {
              "x": -35.969,
              "y": -9.521,
              "z": 1.034
            },
            "gtin": "4260313467006",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d7333",
            "leftCorner": {
              "x": -35.973,
              "y": -9.521,
              "z": 1.034
            },
            "rightCorner": {
              "x": -35.978,
              "y": -9.26,
              "z": 1.034
            },
            "gtin": "42279877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7334",
            "leftCorner": {
              "x": -35.977,
              "y": -9.26,
              "z": 1.034
            },
            "rightCorner": {
              "x": -35.983,
              "y": -8.941,
              "z": 1.034
            },
            "gtin": "4100060033430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d732a",
            "leftCorner": {
              "x": -35.979,
              "y": -8.941,
              "z": 1.034
            },
            "rightCorner": {
              "x": -35.987,
              "y": -8.598,
              "z": 1.034
            },
            "gtin": "4100060033416",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d779",
        "height": 1.6144,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7340",
            "leftCorner": {
              "x": -35.96,
              "y": -9.714,
              "z": 1.321
            },
            "rightCorner": {
              "x": -35.962,
              "y": -9.612,
              "z": 1.321
            },
            "gtin": "3052911606694",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "36abd67334398a902e36232c",
            "leftCorner": {
              "x": -35.924,
              "y": -9.847,
              "z": 1.321
            },
            "rightCorner": {
              "x": -35.925,
              "y": -9.769,
              "z": 1.321
            },
            "gtin": "3052911606717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7341",
            "leftCorner": {
              "x": -35.966,
              "y": -9.612,
              "z": 1.321
            },
            "rightCorner": {
              "x": -35.97,
              "y": -9.429,
              "z": 1.321
            },
            "gtin": "3052911607059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7342",
            "leftCorner": {
              "x": -35.975,
              "y": -9.429,
              "z": 1.321
            },
            "rightCorner": {
              "x": -35.977,
              "y": -9.304,
              "z": 1.321
            },
            "gtin": "3052911606588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7343",
            "leftCorner": {
              "x": -35.977,
              "y": -9.304,
              "z": 1.321
            },
            "rightCorner": {
              "x": -35.98,
              "y": -9.159,
              "z": 1.321
            },
            "gtin": "3052911606625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7344",
            "leftCorner": {
              "x": -35.98,
              "y": -9.159,
              "z": 1.321
            },
            "rightCorner": {
              "x": -35.982,
              "y": -9.07,
              "z": 1.321
            },
            "gtin": "3052911607035",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7345",
            "leftCorner": {
              "x": -35.984,
              "y": -9.07,
              "z": 1.321
            },
            "rightCorner": {
              "x": -35.985,
              "y": -8.978,
              "z": 1.321
            },
            "gtin": "3052911607004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7346",
            "leftCorner": {
              "x": -35.98,
              "y": -8.978,
              "z": 1.321
            },
            "rightCorner": {
              "x": -35.982,
              "y": -8.871,
              "z": 1.321
            },
            "gtin": "3052911606656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7347",
            "leftCorner": {
              "x": -35.981,
              "y": -8.871,
              "z": 1.321
            },
            "rightCorner": {
              "x": -35.983,
              "y": -8.776,
              "z": 1.321
            },
            "gtin": "3052911606571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7348",
            "leftCorner": {
              "x": -35.984,
              "y": -8.776,
              "z": 1.321
            },
            "rightCorner": {
              "x": -35.986,
              "y": -8.692,
              "z": 1.321
            },
            "gtin": "3052911606724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7349",
            "leftCorner": {
              "x": -35.989,
              "y": -8.692,
              "z": 1.321
            },
            "rightCorner": {
              "x": -35.99,
              "y": -8.608,
              "z": 1.321
            },
            "gtin": "3052911708015",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c27"
  },
  {
    "id": "c29",
    "name": "c29",
    "x": -32.193,
    "y": -20.178,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.16964,
      "w": 0.98551
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 87
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d427",
        "height": 0.16839,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d774f",
            "leftCorner": {
              "x": -32.163,
              "y": -20.262,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.094,
              "y": -20.238,
              "z": 0.138
            },
            "gtin": "4008617121664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fd441bb50486a6960e1352d2",
            "leftCorner": {
              "x": -31.39,
              "y": -19.988,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.321,
              "y": -19.963,
              "z": 0.138
            },
            "gtin": "4008617121664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "37118a922563dfd33c587a77",
            "leftCorner": {
              "x": -31.321,
              "y": -19.963,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.246,
              "y": -19.937,
              "z": 0.138
            },
            "gtin": "4009932133462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5b7005c7c0131f90ac39bd66",
            "leftCorner": {
              "x": -31.246,
              "y": -19.937,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.022,
              "y": -19.857,
              "z": 0.138
            },
            "gtin": "4008233010946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7751",
            "leftCorner": {
              "x": -32.109,
              "y": -20.196,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.003,
              "y": -20.159,
              "z": 0.138
            },
            "gtin": "4008491117449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7752",
            "leftCorner": {
              "x": -32.003,
              "y": -20.16,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.925,
              "y": -20.133,
              "z": 0.138
            },
            "gtin": "4009932138535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7753",
            "leftCorner": {
              "x": -31.924,
              "y": -20.136,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.823,
              "y": -20.099,
              "z": 0.138
            },
            "gtin": "4009932133462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7754",
            "leftCorner": {
              "x": -31.824,
              "y": -20.097,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.767,
              "y": -20.077,
              "z": 0.138
            },
            "gtin": "4009932132069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7755",
            "leftCorner": {
              "x": -31.764,
              "y": -20.085,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.684,
              "y": -20.057,
              "z": 0.138
            },
            "gtin": "4008491109406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7756",
            "leftCorner": {
              "x": -31.683,
              "y": -20.057,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.607,
              "y": -20.029,
              "z": 0.138
            },
            "gtin": "4008491104159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7757",
            "leftCorner": {
              "x": -31.608,
              "y": -20.026,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.552,
              "y": -20.006,
              "z": 0.138
            },
            "gtin": "4008233046631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7758",
            "leftCorner": {
              "x": -31.553,
              "y": -20.004,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.496,
              "y": -19.984,
              "z": 0.138
            },
            "gtin": "4008233103495",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7759",
            "leftCorner": {
              "x": -31.498,
              "y": -19.981,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.405,
              "y": -19.947,
              "z": 0.138
            },
            "gtin": "4008233010946",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d422",
        "height": 0.46735,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7695",
            "leftCorner": {
              "x": -32.163,
              "y": -20.179,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.081,
              "y": -20.15,
              "z": 0.382
            },
            "gtin": "4003087400158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "08501a64aa6126793c74cc81",
            "leftCorner": {
              "x": -32.176,
              "y": -20.225,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.166,
              "y": -20.221,
              "z": 0.382
            },
            "gtin": "4003573488509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "81497cb20e9293b43d552baa",
            "leftCorner": {
              "x": -32.166,
              "y": -20.221,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.155,
              "y": -20.218,
              "z": 0.382
            },
            "gtin": "4003573488509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aa8e7bc7c95ce42d33a6a8f0",
            "leftCorner": {
              "x": -32.068,
              "y": -20.187,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.057,
              "y": -20.183,
              "z": 0.382
            },
            "gtin": "4003573488509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2d723b87bde7b4ac4a345cc8",
            "leftCorner": {
              "x": -32.057,
              "y": -20.183,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.046,
              "y": -20.179,
              "z": 0.382
            },
            "gtin": "4003573488509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1b1e18bfcd21b60e6751fac2",
            "leftCorner": {
              "x": -32.046,
              "y": -20.179,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.025,
              "y": -20.171,
              "z": 0.382
            },
            "gtin": "4003573488509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7697",
            "leftCorner": {
              "x": -32.063,
              "y": -20.046,
              "z": 0.382
            },
            "rightCorner": {
              "x": -32.007,
              "y": -20.026,
              "z": 0.382
            },
            "gtin": "4003087400059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7698",
            "leftCorner": {
              "x": -31.979,
              "y": -20.107,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.896,
              "y": -20.079,
              "z": 0.382
            },
            "gtin": "4005120202019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7699",
            "leftCorner": {
              "x": -31.896,
              "y": -20.078,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.852,
              "y": -20.062,
              "z": 0.382
            },
            "gtin": "4306188029700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d769a",
            "leftCorner": {
              "x": -31.851,
              "y": -20.064,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.738,
              "y": -20.024,
              "z": 0.382
            },
            "gtin": "4306188009627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d769b",
            "leftCorner": {
              "x": -31.735,
              "y": -20.031,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.646,
              "y": -19.999,
              "z": 0.382
            },
            "gtin": "4003573800219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d769c",
            "leftCorner": {
              "x": -31.647,
              "y": -19.995,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.587,
              "y": -19.973,
              "z": 0.382
            },
            "gtin": "4008491108997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d769d",
            "leftCorner": {
              "x": -31.587,
              "y": -19.974,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.505,
              "y": -19.945,
              "z": 0.382
            },
            "gtin": "4009932137217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d769e",
            "leftCorner": {
              "x": -31.505,
              "y": -19.944,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.432,
              "y": -19.918,
              "z": 0.382
            },
            "gtin": "4008491121002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d769f",
            "leftCorner": {
              "x": -31.433,
              "y": -19.917,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.343,
              "y": -19.886,
              "z": 0.382
            },
            "gtin": "4008491108287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76a0",
            "leftCorner": {
              "x": -31.342,
              "y": -19.888,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.257,
              "y": -19.857,
              "z": 0.382
            },
            "gtin": "4009932136272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76a1",
            "leftCorner": {
              "x": -31.254,
              "y": -19.864,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.17,
              "y": -19.834,
              "z": 0.382
            },
            "gtin": "4009932004908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76a2",
            "leftCorner": {
              "x": -31.169,
              "y": -19.835,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.093,
              "y": -19.807,
              "z": 0.382
            },
            "gtin": "4009932133769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76a3",
            "leftCorner": {
              "x": -31.09,
              "y": -19.813,
              "z": 0.382
            },
            "rightCorner": {
              "x": -31.01,
              "y": -19.785,
              "z": 0.382
            },
            "gtin": "4009932131703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76a4",
            "leftCorner": {
              "x": -31.01,
              "y": -19.784,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.827,
              "y": -19.719,
              "z": 0.382
            },
            "gtin": "4003573488509",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d425",
        "height": 0.71583,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7705",
            "leftCorner": {
              "x": -32.177,
              "y": -20.222,
              "z": 0.586
            },
            "rightCorner": {
              "x": -32.027,
              "y": -20.169,
              "z": 0.586
            },
            "gtin": "4009932002546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7706",
            "leftCorner": {
              "x": -32.041,
              "y": -20.13,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.965,
              "y": -20.102,
              "z": 0.586
            },
            "gtin": "4008617011668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7707",
            "leftCorner": {
              "x": -31.965,
              "y": -20.101,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.881,
              "y": -20.072,
              "z": 0.586
            },
            "gtin": "4011932228284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7708",
            "leftCorner": {
              "x": -31.881,
              "y": -20.072,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.789,
              "y": -20.039,
              "z": 0.586
            },
            "gtin": "4011932229335",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7709",
            "leftCorner": {
              "x": -31.785,
              "y": -20.052,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.691,
              "y": -20.019,
              "z": 0.586
            },
            "gtin": "4011932236012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d770a",
            "leftCorner": {
              "x": -31.693,
              "y": -20.012,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.64,
              "y": -19.993,
              "z": 0.586
            },
            "gtin": "4306188359944",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d770b",
            "leftCorner": {
              "x": -31.639,
              "y": -19.994,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.592,
              "y": -19.977,
              "z": 0.586
            },
            "gtin": "4036581420001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d770c",
            "leftCorner": {
              "x": -31.594,
              "y": -19.972,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.528,
              "y": -19.949,
              "z": 0.586
            },
            "gtin": "4036581420124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d770d",
            "leftCorner": {
              "x": -31.529,
              "y": -19.946,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.418,
              "y": -19.907,
              "z": 0.586
            },
            "gtin": "4103040030597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d770e",
            "leftCorner": {
              "x": -31.418,
              "y": -19.908,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.334,
              "y": -19.879,
              "z": 0.586
            },
            "gtin": "4103040897411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d770f",
            "leftCorner": {
              "x": -31.333,
              "y": -19.882,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.239,
              "y": -19.848,
              "z": 0.586
            },
            "gtin": "4008491119740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7710",
            "leftCorner": {
              "x": -31.238,
              "y": -19.851,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.182,
              "y": -19.832,
              "z": 0.586
            },
            "gtin": "9421023628001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7711",
            "leftCorner": {
              "x": -31.182,
              "y": -19.833,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.108,
              "y": -19.806,
              "z": 0.586
            },
            "gtin": "4002448189138",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7712",
            "leftCorner": {
              "x": -31.107,
              "y": -19.808,
              "z": 0.586
            },
            "rightCorner": {
              "x": -31.011,
              "y": -19.775,
              "z": 0.586
            },
            "gtin": "4009932132380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7713",
            "leftCorner": {
              "x": -31.008,
              "y": -19.784,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.925,
              "y": -19.754,
              "z": 0.586
            },
            "gtin": "4009932004465",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d424",
        "height": 0.95673,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d76e1",
            "leftCorner": {
              "x": -32.182,
              "y": -20.21,
              "z": 0.783
            },
            "rightCorner": {
              "x": -32.129,
              "y": -20.191,
              "z": 0.783
            },
            "gtin": "4008491115612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76e2",
            "leftCorner": {
              "x": -32.142,
              "y": -20.155,
              "z": 0.783
            },
            "rightCorner": {
              "x": -32.053,
              "y": -20.124,
              "z": 0.783
            },
            "gtin": "4008617134220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76e3",
            "leftCorner": {
              "x": -32.053,
              "y": -20.123,
              "z": 0.783
            },
            "rightCorner": {
              "x": -31.911,
              "y": -20.073,
              "z": 0.783
            },
            "gtin": "4008491111928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76e4",
            "leftCorner": {
              "x": -31.912,
              "y": -20.069,
              "z": 0.783
            },
            "rightCorner": {
              "x": -31.452,
              "y": -19.905,
              "z": 0.783
            },
            "gtin": "4009932002317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76e5",
            "leftCorner": {
              "x": -31.452,
              "y": -19.907,
              "z": 0.783
            },
            "rightCorner": {
              "x": -31.385,
              "y": -19.883,
              "z": 0.783
            },
            "gtin": "4008617148951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76e6",
            "leftCorner": {
              "x": -31.383,
              "y": -19.887,
              "z": 0.783
            },
            "rightCorner": {
              "x": -31.304,
              "y": -19.858,
              "z": 0.783
            },
            "gtin": "4008491216494",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76e7",
            "leftCorner": {
              "x": -31.305,
              "y": -19.857,
              "z": 0.783
            },
            "rightCorner": {
              "x": -31.227,
              "y": -19.829,
              "z": 0.783
            },
            "gtin": "4008617148005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76e8",
            "leftCorner": {
              "x": -31.226,
              "y": -19.832,
              "z": 0.783
            },
            "rightCorner": {
              "x": -31.148,
              "y": -19.805,
              "z": 0.783
            },
            "gtin": "4008617148012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76e9",
            "leftCorner": {
              "x": -31.147,
              "y": -19.809,
              "z": 0.783
            },
            "rightCorner": {
              "x": -31.103,
              "y": -19.793,
              "z": 0.783
            },
            "gtin": "4008617141297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76ea",
            "leftCorner": {
              "x": -31.1,
              "y": -19.802,
              "z": 0.783
            },
            "rightCorner": {
              "x": -31.012,
              "y": -19.771,
              "z": 0.783
            },
            "gtin": "4008617141211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76eb",
            "leftCorner": {
              "x": -31.014,
              "y": -19.764,
              "z": 0.783
            },
            "rightCorner": {
              "x": -30.956,
              "y": -19.743,
              "z": 0.783
            },
            "gtin": "4008491116527",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d426",
        "height": 1.2106,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d772c",
            "leftCorner": {
              "x": -32.182,
              "y": -20.208,
              "z": 0.99
            },
            "rightCorner": {
              "x": -32.019,
              "y": -20.15,
              "z": 0.99
            },
            "gtin": "4008491116121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d772d",
            "leftCorner": {
              "x": -32.033,
              "y": -20.112,
              "z": 0.99
            },
            "rightCorner": {
              "x": -31.955,
              "y": -20.084,
              "z": 0.99
            },
            "gtin": "4008491312622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d772e",
            "leftCorner": {
              "x": -31.955,
              "y": -20.084,
              "z": 0.99
            },
            "rightCorner": {
              "x": -31.861,
              "y": -20.051,
              "z": 0.99
            },
            "gtin": "4008491261708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d772f",
            "leftCorner": {
              "x": -31.861,
              "y": -20.05,
              "z": 0.99
            },
            "rightCorner": {
              "x": -31.801,
              "y": -20.029,
              "z": 0.99
            },
            "gtin": "4008491115933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7730",
            "leftCorner": {
              "x": -31.799,
              "y": -20.035,
              "z": 0.99
            },
            "rightCorner": {
              "x": -31.739,
              "y": -20.014,
              "z": 0.99
            },
            "gtin": "4008491223362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7731",
            "leftCorner": {
              "x": -31.739,
              "y": -20.014,
              "z": 0.99
            },
            "rightCorner": {
              "x": -31.661,
              "y": -19.985,
              "z": 0.99
            },
            "gtin": "4008491115759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7732",
            "leftCorner": {
              "x": -31.662,
              "y": -19.982,
              "z": 0.99
            },
            "rightCorner": {
              "x": -31.589,
              "y": -19.955,
              "z": 0.99
            },
            "gtin": "4008491224567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7733",
            "leftCorner": {
              "x": -31.589,
              "y": -19.955,
              "z": 0.99
            },
            "rightCorner": {
              "x": -31.499,
              "y": -19.923,
              "z": 0.99
            },
            "gtin": "4009932002966",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7734",
            "leftCorner": {
              "x": -31.499,
              "y": -19.923,
              "z": 0.99
            },
            "rightCorner": {
              "x": -31.409,
              "y": -19.89,
              "z": 0.99
            },
            "gtin": "4306188360582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7735",
            "leftCorner": {
              "x": -31.409,
              "y": -19.89,
              "z": 0.99
            },
            "rightCorner": {
              "x": -31.328,
              "y": -19.862,
              "z": 0.99
            },
            "gtin": "4002448089773",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7736",
            "leftCorner": {
              "x": -31.326,
              "y": -19.867,
              "z": 0.99
            },
            "rightCorner": {
              "x": -31.253,
              "y": -19.84,
              "z": 0.99
            },
            "gtin": "4002448089797",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7737",
            "leftCorner": {
              "x": -31.251,
              "y": -19.846,
              "z": 0.99
            },
            "rightCorner": {
              "x": -31.172,
              "y": -19.818,
              "z": 0.99
            },
            "gtin": "4002448089735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7738",
            "leftCorner": {
              "x": -31.171,
              "y": -19.82,
              "z": 0.99
            },
            "rightCorner": {
              "x": -31.099,
              "y": -19.793,
              "z": 0.99
            },
            "gtin": "4008617007975",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7739",
            "leftCorner": {
              "x": -31.098,
              "y": -19.795,
              "z": 0.99
            },
            "rightCorner": {
              "x": -30.992,
              "y": -19.757,
              "z": 0.99
            },
            "gtin": "4008491119771",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d423",
        "height": 1.4623,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d76ba",
            "leftCorner": {
              "x": -32.179,
              "y": -20.219,
              "z": 1.196
            },
            "rightCorner": {
              "x": -32.13,
              "y": -20.201,
              "z": 1.196
            },
            "gtin": "4008491112581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76bb",
            "leftCorner": {
              "x": -32.144,
              "y": -20.164,
              "z": 1.196
            },
            "rightCorner": {
              "x": -32.096,
              "y": -20.148,
              "z": 1.196
            },
            "gtin": "4008491112499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76bc",
            "leftCorner": {
              "x": -32.096,
              "y": -20.149,
              "z": 1.196
            },
            "rightCorner": {
              "x": -32.059,
              "y": -20.135,
              "z": 1.196
            },
            "gtin": "4008491112642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76bd",
            "leftCorner": {
              "x": -32.059,
              "y": -20.136,
              "z": 1.196
            },
            "rightCorner": {
              "x": -31.991,
              "y": -20.111,
              "z": 1.196
            },
            "gtin": "4008491107716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76be",
            "leftCorner": {
              "x": -31.992,
              "y": -20.108,
              "z": 1.196
            },
            "rightCorner": {
              "x": -31.903,
              "y": -20.077,
              "z": 1.196
            },
            "gtin": "4306188432753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76bf",
            "leftCorner": {
              "x": -31.904,
              "y": -20.076,
              "z": 1.196
            },
            "rightCorner": {
              "x": -31.867,
              "y": -20.063,
              "z": 1.196
            },
            "gtin": "4306188432784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76c0",
            "leftCorner": {
              "x": -31.866,
              "y": -20.065,
              "z": 1.196
            },
            "rightCorner": {
              "x": -31.788,
              "y": -20.037,
              "z": 1.196
            },
            "gtin": "4306188000853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76c1",
            "leftCorner": {
              "x": -31.788,
              "y": -20.037,
              "z": 1.196
            },
            "rightCorner": {
              "x": -31.709,
              "y": -20.009,
              "z": 1.196
            },
            "gtin": "4306188000853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76c2",
            "leftCorner": {
              "x": -31.709,
              "y": -20.009,
              "z": 1.196
            },
            "rightCorner": {
              "x": -31.63,
              "y": -19.981,
              "z": 1.196
            },
            "gtin": "4306188000853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76c3",
            "leftCorner": {
              "x": -31.63,
              "y": -19.981,
              "z": 1.196
            },
            "rightCorner": {
              "x": -31.551,
              "y": -19.953,
              "z": 1.196
            },
            "gtin": "4306188000853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76c4",
            "leftCorner": {
              "x": -31.552,
              "y": -19.95,
              "z": 1.196
            },
            "rightCorner": {
              "x": -31.391,
              "y": -19.894,
              "z": 1.196
            },
            "gtin": "4009932002317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76c5",
            "leftCorner": {
              "x": -31.39,
              "y": -19.899,
              "z": 1.196
            },
            "rightCorner": {
              "x": -31.296,
              "y": -19.865,
              "z": 1.196
            },
            "gtin": "4009932007886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76c6",
            "leftCorner": {
              "x": -31.296,
              "y": -19.865,
              "z": 1.196
            },
            "rightCorner": {
              "x": -31.185,
              "y": -19.826,
              "z": 1.196
            },
            "gtin": "4009932007756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76c7",
            "leftCorner": {
              "x": -31.185,
              "y": -19.827,
              "z": 1.196
            },
            "rightCorner": {
              "x": -31.103,
              "y": -19.798,
              "z": 1.196
            },
            "gtin": "4003087410850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76c8",
            "leftCorner": {
              "x": -31.101,
              "y": -19.804,
              "z": 1.196
            },
            "rightCorner": {
              "x": -31.006,
              "y": -19.77,
              "z": 1.196
            },
            "gtin": "4008617023470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76c9",
            "leftCorner": {
              "x": -31.007,
              "y": -19.768,
              "z": 1.196
            },
            "rightCorner": {
              "x": -30.895,
              "y": -19.728,
              "z": 1.196
            },
            "gtin": "4009932001037",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "c2c"
  },
  {
    "id": "c2c",
    "name": "c2c",
    "x": -31.015,
    "y": -19.76,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.16964,
      "w": 0.98551
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 79
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d42f",
        "height": 0.16936,
        "facings": [
          {
            "id": "7a5694e5aeb0a97f18c0e6b1",
            "leftCorner": {
              "x": -30.989,
              "y": -19.836,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.951,
              "y": -19.822,
              "z": 0.139
            },
            "gtin": "4009932133110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e9bbd1fe579a36f221187960",
            "leftCorner": {
              "x": -30.951,
              "y": -19.822,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.893,
              "y": -19.802,
              "z": 0.139
            },
            "gtin": "4003573289052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ccb205dfe91490135b14bb41",
            "leftCorner": {
              "x": -30.893,
              "y": -19.802,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.791,
              "y": -19.766,
              "z": 0.139
            },
            "gtin": "4009932001037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "38057e1a59b68b1fb06f86ef",
            "leftCorner": {
              "x": -30.791,
              "y": -19.766,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.756,
              "y": -19.753,
              "z": 0.139
            },
            "gtin": "4036581252589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "16cf31df72b201b4f84be521",
            "leftCorner": {
              "x": -30.756,
              "y": -19.753,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.718,
              "y": -19.74,
              "z": 0.139
            },
            "gtin": "4009932133110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7890e29bcbb321c06e1a2a43",
            "leftCorner": {
              "x": -30.718,
              "y": -19.74,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.674,
              "y": -19.724,
              "z": 0.139
            },
            "gtin": "4043027007887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "575664d9fa1ab068415523e1",
            "leftCorner": {
              "x": -30.674,
              "y": -19.724,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.629,
              "y": -19.708,
              "z": 0.139
            },
            "gtin": "4008137002153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aa9117aed84bfa71ed1ddbf4",
            "leftCorner": {
              "x": -30.629,
              "y": -19.708,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.575,
              "y": -19.689,
              "z": 0.139
            },
            "gtin": "4008233175324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9083daaff0bbdde4dac7c8f0",
            "leftCorner": {
              "x": -30.575,
              "y": -19.689,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.517,
              "y": -19.669,
              "z": 0.139
            },
            "gtin": "4003573289052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3544bb83f476631fcdd63190",
            "leftCorner": {
              "x": -30.517,
              "y": -19.669,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.458,
              "y": -19.648,
              "z": 0.139
            },
            "gtin": "4009932132281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fd78b89ecd22e19d8a14aba1",
            "leftCorner": {
              "x": -30.458,
              "y": -19.648,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.397,
              "y": -19.626,
              "z": 0.139
            },
            "gtin": "4036581252473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0187fc776bc404730d37b126",
            "leftCorner": {
              "x": -30.397,
              "y": -19.626,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.333,
              "y": -19.603,
              "z": 0.139
            },
            "gtin": "4043027007436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "41a1556c9bfd550c0be8693f",
            "leftCorner": {
              "x": -30.333,
              "y": -19.603,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.269,
              "y": -19.581,
              "z": 0.139
            },
            "gtin": "4003087441953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7bc9a9a169c212f6795f5df0",
            "leftCorner": {
              "x": -30.269,
              "y": -19.581,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.202,
              "y": -19.557,
              "z": 0.139
            },
            "gtin": "4003087433453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "436e923613367d9c86f20a70",
            "leftCorner": {
              "x": -30.202,
              "y": -19.557,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.133,
              "y": -19.532,
              "z": 0.139
            },
            "gtin": "4003087433057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a63e91d516f04712edbed447",
            "leftCorner": {
              "x": -30.133,
              "y": -19.532,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.064,
              "y": -19.508,
              "z": 0.139
            },
            "gtin": "4009932004465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d4a5fbe3c094a2b26893dfe3",
            "leftCorner": {
              "x": -30.064,
              "y": -19.508,
              "z": 0.139
            },
            "rightCorner": {
              "x": -29.867,
              "y": -19.438,
              "z": 0.139
            },
            "gtin": "4306188361381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "21a4000e0514c4f07033e180",
            "leftCorner": {
              "x": -29.867,
              "y": -19.438,
              "z": 0.139
            },
            "rightCorner": {
              "x": -29.813,
              "y": -19.419,
              "z": 0.139
            },
            "gtin": "4008233175324",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d42b",
        "height": 0.46703,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d76a5",
            "leftCorner": {
              "x": -30.828,
              "y": -19.717,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.748,
              "y": -19.689,
              "z": 0.382
            },
            "gtin": "4009932137606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a8e64306be6d9a4cef60398d",
            "leftCorner": {
              "x": -30.994,
              "y": -19.82,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.821,
              "y": -19.759,
              "z": 0.382
            },
            "gtin": "4034900007001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c2e06b4d71f4cc5e23ae79e5",
            "leftCorner": {
              "x": -29.986,
              "y": -19.462,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.834,
              "y": -19.409,
              "z": 0.382
            },
            "gtin": "4003573488509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76a6",
            "leftCorner": {
              "x": -30.748,
              "y": -19.691,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.658,
              "y": -19.659,
              "z": 0.382
            },
            "gtin": "4009932134117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76a7",
            "leftCorner": {
              "x": -30.657,
              "y": -19.661,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.559,
              "y": -19.625,
              "z": 0.382
            },
            "gtin": "4009932003215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76a8",
            "leftCorner": {
              "x": -30.559,
              "y": -19.625,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.443,
              "y": -19.584,
              "z": 0.382
            },
            "gtin": "4009932135459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76a9",
            "leftCorner": {
              "x": -30.444,
              "y": -19.581,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.354,
              "y": -19.548,
              "z": 0.382
            },
            "gtin": "4009932004526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76aa",
            "leftCorner": {
              "x": -30.354,
              "y": -19.548,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.218,
              "y": -19.501,
              "z": 0.382
            },
            "gtin": "4043027007245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76ab",
            "leftCorner": {
              "x": -30.217,
              "y": -19.503,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.107,
              "y": -19.464,
              "z": 0.382
            },
            "gtin": "4043027007344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76ac",
            "leftCorner": {
              "x": -30.108,
              "y": -19.462,
              "z": 0.382
            },
            "rightCorner": {
              "x": -30.046,
              "y": -19.439,
              "z": 0.382
            },
            "gtin": "4043027007436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76ad",
            "leftCorner": {
              "x": -30.046,
              "y": -19.441,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.999,
              "y": -19.425,
              "z": 0.382
            },
            "gtin": "4043027007887",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d42e",
        "height": 0.71571,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7714",
            "leftCorner": {
              "x": -30.927,
              "y": -19.749,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.797,
              "y": -19.703,
              "z": 0.586
            },
            "gtin": "4036581526970",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "f34d71cf26c4632bcf2cfebe",
            "leftCorner": {
              "x": -30.996,
              "y": -19.815,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.927,
              "y": -19.79,
              "z": 0.586
            },
            "gtin": "4009932004465",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "f5390da0a7adf1c232514777",
            "leftCorner": {
              "x": -29.945,
              "y": -19.442,
              "z": 0.586
            },
            "rightCorner": {
              "x": -29.825,
              "y": -19.4,
              "z": 0.586
            },
            "gtin": "4036581526970",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d7715",
            "leftCorner": {
              "x": -30.796,
              "y": -19.707,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.709,
              "y": -19.677,
              "z": 0.586
            },
            "gtin": "4009932134513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7716",
            "leftCorner": {
              "x": -30.71,
              "y": -19.673,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.625,
              "y": -19.644,
              "z": 0.586
            },
            "gtin": "4008455037615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7717",
            "leftCorner": {
              "x": -30.626,
              "y": -19.642,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.554,
              "y": -19.616,
              "z": 0.586
            },
            "gtin": "4003087433453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7718",
            "leftCorner": {
              "x": -30.554,
              "y": -19.617,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.477,
              "y": -19.59,
              "z": 0.586
            },
            "gtin": "4003087432456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7719",
            "leftCorner": {
              "x": -30.477,
              "y": -19.59,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.409,
              "y": -19.566,
              "z": 0.586
            },
            "gtin": "4003087441953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d771a",
            "leftCorner": {
              "x": -30.41,
              "y": -19.565,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.35,
              "y": -19.544,
              "z": 0.586
            },
            "gtin": "4003087446057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d771b",
            "leftCorner": {
              "x": -30.351,
              "y": -19.542,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.257,
              "y": -19.509,
              "z": 0.586
            },
            "gtin": "4003087433057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d771c",
            "leftCorner": {
              "x": -30.257,
              "y": -19.509,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.193,
              "y": -19.486,
              "z": 0.586
            },
            "gtin": "4003087432050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d771d",
            "leftCorner": {
              "x": -30.192,
              "y": -19.488,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.115,
              "y": -19.461,
              "z": 0.586
            },
            "gtin": "4003087447504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d771e",
            "leftCorner": {
              "x": -30.115,
              "y": -19.463,
              "z": 0.586
            },
            "rightCorner": {
              "x": -30.032,
              "y": -19.433,
              "z": 0.586
            },
            "gtin": "4003087445807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d771f",
            "leftCorner": {
              "x": -30.034,
              "y": -19.43,
              "z": 0.586
            },
            "rightCorner": {
              "x": -29.959,
              "y": -19.403,
              "z": 0.586
            },
            "gtin": "4260729421517",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d42c",
        "height": 0.95623,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d76ec",
            "leftCorner": {
              "x": -30.954,
              "y": -19.748,
              "z": 0.782
            },
            "rightCorner": {
              "x": -30.895,
              "y": -19.727,
              "z": 0.782
            },
            "gtin": "4009932132281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9bdcf8962adacdaca2a995e2",
            "leftCorner": {
              "x": -31.0,
              "y": -19.805,
              "z": 0.782
            },
            "rightCorner": {
              "x": -30.958,
              "y": -19.79,
              "z": 0.782
            },
            "gtin": "4008491116527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "186eb6aed80697d1a60507d4",
            "leftCorner": {
              "x": -29.857,
              "y": -19.4,
              "z": 0.782
            },
            "rightCorner": {
              "x": -29.823,
              "y": -19.387,
              "z": 0.782
            },
            "gtin": "4036581252589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76ed",
            "leftCorner": {
              "x": -30.896,
              "y": -19.727,
              "z": 0.782
            },
            "rightCorner": {
              "x": -30.796,
              "y": -19.691,
              "z": 0.782
            },
            "gtin": "4008233175324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76ee",
            "leftCorner": {
              "x": -30.797,
              "y": -19.69,
              "z": 0.782
            },
            "rightCorner": {
              "x": -30.664,
              "y": -19.643,
              "z": 0.782
            },
            "gtin": "4036581252589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76ef",
            "leftCorner": {
              "x": -30.661,
              "y": -19.652,
              "z": 0.782
            },
            "rightCorner": {
              "x": -30.583,
              "y": -19.623,
              "z": 0.782
            },
            "gtin": "4036581251902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76f0",
            "leftCorner": {
              "x": -30.585,
              "y": -19.618,
              "z": 0.782
            },
            "rightCorner": {
              "x": -30.497,
              "y": -19.587,
              "z": 0.782
            },
            "gtin": "4036581251186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76f1",
            "leftCorner": {
              "x": -30.498,
              "y": -19.583,
              "z": 0.782
            },
            "rightCorner": {
              "x": -30.436,
              "y": -19.561,
              "z": 0.782
            },
            "gtin": "4036581252473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76f2",
            "leftCorner": {
              "x": -30.436,
              "y": -19.56,
              "z": 0.782
            },
            "rightCorner": {
              "x": -30.36,
              "y": -19.533,
              "z": 0.782
            },
            "gtin": "4036581252442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76f3",
            "leftCorner": {
              "x": -30.358,
              "y": -19.538,
              "z": 0.782
            },
            "rightCorner": {
              "x": -30.284,
              "y": -19.511,
              "z": 0.782
            },
            "gtin": "4003087442059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76f4",
            "leftCorner": {
              "x": -30.286,
              "y": -19.507,
              "z": 0.782
            },
            "rightCorner": {
              "x": -30.191,
              "y": -19.473,
              "z": 0.782
            },
            "gtin": "4003087440659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76f5",
            "leftCorner": {
              "x": -30.191,
              "y": -19.472,
              "z": 0.782
            },
            "rightCorner": {
              "x": -30.111,
              "y": -19.444,
              "z": 0.782
            },
            "gtin": "4003087433255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76f6",
            "leftCorner": {
              "x": -30.11,
              "y": -19.446,
              "z": 0.782
            },
            "rightCorner": {
              "x": -30.041,
              "y": -19.42,
              "z": 0.782
            },
            "gtin": "4005120170400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76f7",
            "leftCorner": {
              "x": -30.04,
              "y": -19.424,
              "z": 0.782
            },
            "rightCorner": {
              "x": -29.946,
              "y": -19.391,
              "z": 0.782
            },
            "gtin": "4005120170318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76f8",
            "leftCorner": {
              "x": -29.946,
              "y": -19.39,
              "z": 0.782
            },
            "rightCorner": {
              "x": -29.87,
              "y": -19.363,
              "z": 0.782
            },
            "gtin": "4009932137149",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d42d",
        "height": 1.2085,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d773a",
            "leftCorner": {
              "x": -30.993,
              "y": -19.751,
              "z": 0.989
            },
            "rightCorner": {
              "x": -30.943,
              "y": -19.734,
              "z": 0.989
            },
            "gtin": "4008491112116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2d4076d919e67c7a0b38ef2d",
            "leftCorner": {
              "x": -29.88,
              "y": -19.408,
              "z": 0.989
            },
            "rightCorner": {
              "x": -29.829,
              "y": -19.389,
              "z": 0.989
            },
            "gtin": "4008491112116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d773b",
            "leftCorner": {
              "x": -30.941,
              "y": -19.74,
              "z": 0.989
            },
            "rightCorner": {
              "x": -30.745,
              "y": -19.67,
              "z": 0.989
            },
            "gtin": "4306188361381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d773c",
            "leftCorner": {
              "x": -30.744,
              "y": -19.673,
              "z": 0.989
            },
            "rightCorner": {
              "x": -30.598,
              "y": -19.62,
              "z": 0.989
            },
            "gtin": "4008491110211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d773d",
            "leftCorner": {
              "x": -30.598,
              "y": -19.62,
              "z": 0.989
            },
            "rightCorner": {
              "x": -30.524,
              "y": -19.594,
              "z": 0.989
            },
            "gtin": "4009932136586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d773e",
            "leftCorner": {
              "x": -30.524,
              "y": -19.593,
              "z": 0.989
            },
            "rightCorner": {
              "x": -30.383,
              "y": -19.544,
              "z": 0.989
            },
            "gtin": "4036581583546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d773f",
            "leftCorner": {
              "x": -30.382,
              "y": -19.544,
              "z": 0.989
            },
            "rightCorner": {
              "x": -30.212,
              "y": -19.484,
              "z": 0.989
            },
            "gtin": "4008491104098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7740",
            "leftCorner": {
              "x": -30.213,
              "y": -19.481,
              "z": 0.989
            },
            "rightCorner": {
              "x": -30.126,
              "y": -19.451,
              "z": 0.989
            },
            "gtin": "4008233172156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7741",
            "leftCorner": {
              "x": -30.126,
              "y": -19.45,
              "z": 0.989
            },
            "rightCorner": {
              "x": -30.049,
              "y": -19.422,
              "z": 0.989
            },
            "gtin": "4008233125824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7742",
            "leftCorner": {
              "x": -30.049,
              "y": -19.424,
              "z": 0.989
            },
            "rightCorner": {
              "x": -29.893,
              "y": -19.37,
              "z": 0.989
            },
            "gtin": "4009932135923",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d42a",
        "height": 1.4597,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d76ca",
            "leftCorner": {
              "x": -30.895,
              "y": -19.729,
              "z": 1.194
            },
            "rightCorner": {
              "x": -30.817,
              "y": -19.701,
              "z": 1.194
            },
            "gtin": "4009932003307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d94f1ac59fc6d4231527c60a",
            "leftCorner": {
              "x": -30.998,
              "y": -19.809,
              "z": 1.194
            },
            "rightCorner": {
              "x": -30.952,
              "y": -19.793,
              "z": 1.194
            },
            "gtin": "4008137002252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "afa35129f3cb2e7eaebe4e4b",
            "leftCorner": {
              "x": -30.952,
              "y": -19.793,
              "z": 1.194
            },
            "rightCorner": {
              "x": -30.887,
              "y": -19.77,
              "z": 1.194
            },
            "gtin": "4008137002207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76cb",
            "leftCorner": {
              "x": -30.816,
              "y": -19.705,
              "z": 1.194
            },
            "rightCorner": {
              "x": -30.721,
              "y": -19.671,
              "z": 1.194
            },
            "gtin": "4003573289021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76cc",
            "leftCorner": {
              "x": -30.721,
              "y": -19.672,
              "z": 1.194
            },
            "rightCorner": {
              "x": -30.641,
              "y": -19.644,
              "z": 1.194
            },
            "gtin": "4009932004700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76cd",
            "leftCorner": {
              "x": -30.641,
              "y": -19.644,
              "z": 1.194
            },
            "rightCorner": {
              "x": -30.55,
              "y": -19.61,
              "z": 1.194
            },
            "gtin": "4009932137187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76ce",
            "leftCorner": {
              "x": -30.55,
              "y": -19.609,
              "z": 1.194
            },
            "rightCorner": {
              "x": -30.473,
              "y": -19.582,
              "z": 1.194
            },
            "gtin": "4008233124384",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76cf",
            "leftCorner": {
              "x": -30.474,
              "y": -19.579,
              "z": 1.194
            },
            "rightCorner": {
              "x": -30.365,
              "y": -19.541,
              "z": 1.194
            },
            "gtin": "4008137002511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76d0",
            "leftCorner": {
              "x": -30.364,
              "y": -19.543,
              "z": 1.194
            },
            "rightCorner": {
              "x": -30.255,
              "y": -19.504,
              "z": 1.194
            },
            "gtin": "4008137002306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76d1",
            "leftCorner": {
              "x": -30.256,
              "y": -19.503,
              "z": 1.194
            },
            "rightCorner": {
              "x": -30.193,
              "y": -19.481,
              "z": 1.194
            },
            "gtin": "4008137002207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76d2",
            "leftCorner": {
              "x": -30.195,
              "y": -19.477,
              "z": 1.194
            },
            "rightCorner": {
              "x": -30.141,
              "y": -19.459,
              "z": 1.194
            },
            "gtin": "4008137002603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76d3",
            "leftCorner": {
              "x": -30.14,
              "y": -19.462,
              "z": 1.194
            },
            "rightCorner": {
              "x": -30.037,
              "y": -19.425,
              "z": 1.194
            },
            "gtin": "4008137002603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76d4",
            "leftCorner": {
              "x": -30.037,
              "y": -19.425,
              "z": 1.194
            },
            "rightCorner": {
              "x": -29.864,
              "y": -19.365,
              "z": 1.194
            },
            "gtin": "4008137002955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76d5",
            "leftCorner": {
              "x": -29.864,
              "y": -19.366,
              "z": 1.194
            },
            "rightCorner": {
              "x": -29.672,
              "y": -19.298,
              "z": 1.194
            },
            "gtin": "4008137002153",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c29",
    "rightNeighborShelfId": "c2d"
  },
  {
    "id": "c2d",
    "name": "c2d",
    "x": -29.837,
    "y": -19.342,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.16964,
      "w": 0.98551
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 76
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d782",
        "height": 0.17339,
        "facings": [
          {
            "id": "11f9ee3bafa69035f7301b7f",
            "leftCorner": {
              "x": -29.788,
              "y": -19.481,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.623,
              "y": -19.423,
              "z": 0.142
            },
            "gtin": "4009932134346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "41f6adddd777b575119d2b7b",
            "leftCorner": {
              "x": -29.623,
              "y": -19.423,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.578,
              "y": -19.407,
              "z": 0.142
            },
            "gtin": "4009932132007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2731a0b825a2bcf63edd955d",
            "leftCorner": {
              "x": -29.578,
              "y": -19.407,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.523,
              "y": -19.387,
              "z": 0.142
            },
            "gtin": "4003087446552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9969599bf486ecce3ffec14a",
            "leftCorner": {
              "x": -29.523,
              "y": -19.387,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.466,
              "y": -19.367,
              "z": 0.142
            },
            "gtin": "4008137002658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fb4992314f166546fa2fee8e",
            "leftCorner": {
              "x": -29.466,
              "y": -19.367,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.407,
              "y": -19.346,
              "z": 0.142
            },
            "gtin": "4008491102957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3c9d23233d3a81d7cab6cc65",
            "leftCorner": {
              "x": -29.407,
              "y": -19.346,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.339,
              "y": -19.322,
              "z": 0.142
            },
            "gtin": "4009932138382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8712d8bbb2b50936d2d17673",
            "leftCorner": {
              "x": -29.339,
              "y": -19.322,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.269,
              "y": -19.297,
              "z": 0.142
            },
            "gtin": "4003087441151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6d4f3b0f9af4f42374188941",
            "leftCorner": {
              "x": -29.269,
              "y": -19.297,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.198,
              "y": -19.272,
              "z": 0.142
            },
            "gtin": "4008491129541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a2fa41774492dfd225baf297",
            "leftCorner": {
              "x": -29.198,
              "y": -19.272,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.128,
              "y": -19.247,
              "z": 0.142
            },
            "gtin": "4008617001096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6451b081406343149d135b8f",
            "leftCorner": {
              "x": -29.128,
              "y": -19.247,
              "z": 0.142
            },
            "rightCorner": {
              "x": -29.056,
              "y": -19.221,
              "z": 0.142
            },
            "gtin": "4003087440758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3dbb8e2f80767963dbcb1342",
            "leftCorner": {
              "x": -29.056,
              "y": -19.221,
              "z": 0.142
            },
            "rightCorner": {
              "x": -28.982,
              "y": -19.195,
              "z": 0.142
            },
            "gtin": "4009932008463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5590c42ad11a80244601b24d",
            "leftCorner": {
              "x": -28.982,
              "y": -19.195,
              "z": 0.142
            },
            "rightCorner": {
              "x": -28.907,
              "y": -19.169,
              "z": 0.142
            },
            "gtin": "4009932007084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f74bddf3fe92cd47c873df09",
            "leftCorner": {
              "x": -28.907,
              "y": -19.169,
              "z": 0.142
            },
            "rightCorner": {
              "x": -28.831,
              "y": -19.142,
              "z": 0.142
            },
            "gtin": "4009932001990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a33fe6602d62da82d317019f",
            "leftCorner": {
              "x": -28.831,
              "y": -19.142,
              "z": 0.142
            },
            "rightCorner": {
              "x": -28.661,
              "y": -19.082,
              "z": 0.142
            },
            "gtin": "4008491277297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8e75eb61c3656077f41f1b53",
            "leftCorner": {
              "x": -28.661,
              "y": -19.082,
              "z": 0.142
            },
            "rightCorner": {
              "x": -28.616,
              "y": -19.066,
              "z": 0.142
            },
            "gtin": "4009932132007",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d77e",
        "height": 0.45798,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d76ae",
            "leftCorner": {
              "x": -29.853,
              "y": -19.43,
              "z": 0.382
            },
            "rightCorner": {
              "x": -29.523,
              "y": -19.308,
              "z": 0.382
            },
            "gtin": "4009932131253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76af",
            "leftCorner": {
              "x": -29.655,
              "y": -19.337,
              "z": 0.375
            },
            "rightCorner": {
              "x": -29.583,
              "y": -19.312,
              "z": 0.375
            },
            "gtin": "4009932007084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76b0",
            "leftCorner": {
              "x": -29.58,
              "y": -19.32,
              "z": 0.375
            },
            "rightCorner": {
              "x": -29.508,
              "y": -19.294,
              "z": 0.375
            },
            "gtin": "4009932131253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76b1",
            "leftCorner": {
              "x": -29.508,
              "y": -19.295,
              "z": 0.375
            },
            "rightCorner": {
              "x": -29.414,
              "y": -19.262,
              "z": 0.375
            },
            "gtin": "4009932005554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76b2",
            "leftCorner": {
              "x": -29.416,
              "y": -19.257,
              "z": 0.375
            },
            "rightCorner": {
              "x": -29.308,
              "y": -19.218,
              "z": 0.375
            },
            "gtin": "4009932002454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76b3",
            "leftCorner": {
              "x": -29.307,
              "y": -19.219,
              "z": 0.375
            },
            "rightCorner": {
              "x": -29.226,
              "y": -19.191,
              "z": 0.375
            },
            "gtin": "4008491105187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76b4",
            "leftCorner": {
              "x": -29.228,
              "y": -19.187,
              "z": 0.375
            },
            "rightCorner": {
              "x": -29.147,
              "y": -19.157,
              "z": 0.375
            },
            "gtin": "4008491129541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76b5",
            "leftCorner": {
              "x": -29.148,
              "y": -19.153,
              "z": 0.375
            },
            "rightCorner": {
              "x": -29.048,
              "y": -19.118,
              "z": 0.375
            },
            "gtin": "4008491276290",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76b6",
            "leftCorner": {
              "x": -29.047,
              "y": -19.121,
              "z": 0.375
            },
            "rightCorner": {
              "x": -28.953,
              "y": -19.088,
              "z": 0.375
            },
            "gtin": "4008491102995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76b7",
            "leftCorner": {
              "x": -28.952,
              "y": -19.091,
              "z": 0.375
            },
            "rightCorner": {
              "x": -28.783,
              "y": -19.032,
              "z": 0.375
            },
            "gtin": "4008491277297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76b8",
            "leftCorner": {
              "x": -28.782,
              "y": -19.037,
              "z": 0.375
            },
            "rightCorner": {
              "x": -28.714,
              "y": -19.013,
              "z": 0.375
            },
            "gtin": "4008491105224",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76b9",
            "leftCorner": {
              "x": -28.714,
              "y": -19.014,
              "z": 0.375
            },
            "rightCorner": {
              "x": -28.624,
              "y": -18.981,
              "z": 0.375
            },
            "gtin": "4008491102957",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d780",
        "height": 0.7155,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7720",
            "leftCorner": {
              "x": -29.816,
              "y": -19.404,
              "z": 0.586
            },
            "rightCorner": {
              "x": -29.513,
              "y": -19.291,
              "z": 0.586
            },
            "gtin": "4009932136616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0b84df392882d5db12d3820f",
            "leftCorner": {
              "x": -28.912,
              "y": -19.133,
              "z": 0.585
            },
            "rightCorner": {
              "x": -28.748,
              "y": -19.074,
              "z": 0.585
            },
            "gtin": "4009932134346",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7721",
            "leftCorner": {
              "x": -29.638,
              "y": -19.342,
              "z": 0.585
            },
            "rightCorner": {
              "x": -29.554,
              "y": -19.312,
              "z": 0.585
            },
            "gtin": "4009932136616",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d7722",
            "leftCorner": {
              "x": -29.549,
              "y": -19.326,
              "z": 0.585
            },
            "rightCorner": {
              "x": -29.464,
              "y": -19.296,
              "z": 0.585
            },
            "gtin": "4009932008999",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7723",
            "leftCorner": {
              "x": -29.466,
              "y": -19.29,
              "z": 0.585
            },
            "rightCorner": {
              "x": -29.379,
              "y": -19.259,
              "z": 0.585
            },
            "gtin": "4009932004533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7724",
            "leftCorner": {
              "x": -29.38,
              "y": -19.255,
              "z": 0.585
            },
            "rightCorner": {
              "x": -29.291,
              "y": -19.224,
              "z": 0.585
            },
            "gtin": "4009932007312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7725",
            "leftCorner": {
              "x": -29.29,
              "y": -19.227,
              "z": 0.585
            },
            "rightCorner": {
              "x": -29.21,
              "y": -19.199,
              "z": 0.585
            },
            "gtin": "4009932133431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7726",
            "leftCorner": {
              "x": -29.213,
              "y": -19.19,
              "z": 0.585
            },
            "rightCorner": {
              "x": -29.105,
              "y": -19.152,
              "z": 0.585
            },
            "gtin": "4009932131888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7727",
            "leftCorner": {
              "x": -29.105,
              "y": -19.149,
              "z": 0.585
            },
            "rightCorner": {
              "x": -29.025,
              "y": -19.121,
              "z": 0.585
            },
            "gtin": "4009932133394",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7728",
            "leftCorner": {
              "x": -29.023,
              "y": -19.128,
              "z": 0.585
            },
            "rightCorner": {
              "x": -28.926,
              "y": -19.094,
              "z": 0.585
            },
            "gtin": "4009932135565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d772a",
            "leftCorner": {
              "x": -28.739,
              "y": -19.091,
              "z": 0.585
            },
            "rightCorner": {
              "x": -28.672,
              "y": -19.067,
              "z": 0.585
            },
            "gtin": "4009932138382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d772b",
            "leftCorner": {
              "x": -28.689,
              "y": -19.017,
              "z": 0.585
            },
            "rightCorner": {
              "x": -28.625,
              "y": -18.994,
              "z": 0.585
            },
            "gtin": "4009932132007",
            "stockLevel": "NO_STOCK"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d781",
        "height": 0.9585,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d76f9",
            "leftCorner": {
              "x": -29.727,
              "y": -19.363,
              "z": 0.782
            },
            "rightCorner": {
              "x": -29.503,
              "y": -19.281,
              "z": 0.782
            },
            "gtin": "4009932133059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bfb92119feddde13c0273383",
            "leftCorner": {
              "x": -29.803,
              "y": -19.434,
              "z": 0.784
            },
            "rightCorner": {
              "x": -29.715,
              "y": -19.403,
              "z": 0.784
            },
            "gtin": "4009932004731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76fa",
            "leftCorner": {
              "x": -29.629,
              "y": -19.328,
              "z": 0.784
            },
            "rightCorner": {
              "x": -29.556,
              "y": -19.302,
              "z": 0.784
            },
            "gtin": "4009932133059",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76fb",
            "leftCorner": {
              "x": -29.555,
              "y": -19.308,
              "z": 0.784
            },
            "rightCorner": {
              "x": -29.479,
              "y": -19.281,
              "z": 0.784
            },
            "gtin": "4009932001945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76fc",
            "leftCorner": {
              "x": -29.48,
              "y": -19.278,
              "z": 0.784
            },
            "rightCorner": {
              "x": -29.378,
              "y": -19.242,
              "z": 0.784
            },
            "gtin": "4009932002560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76fd",
            "leftCorner": {
              "x": -29.378,
              "y": -19.242,
              "z": 0.784
            },
            "rightCorner": {
              "x": -29.278,
              "y": -19.207,
              "z": 0.784
            },
            "gtin": "4009932004731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76fe",
            "leftCorner": {
              "x": -29.279,
              "y": -19.204,
              "z": 0.784
            },
            "rightCorner": {
              "x": -29.188,
              "y": -19.173,
              "z": 0.784
            },
            "gtin": "4009932001990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76ff",
            "leftCorner": {
              "x": -29.188,
              "y": -19.173,
              "z": 0.784
            },
            "rightCorner": {
              "x": -29.113,
              "y": -19.147,
              "z": 0.784
            },
            "gtin": "4009932008463",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7700",
            "leftCorner": {
              "x": -29.115,
              "y": -19.143,
              "z": 0.784
            },
            "rightCorner": {
              "x": -28.949,
              "y": -19.085,
              "z": 0.784
            },
            "gtin": "4009932137026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7701",
            "leftCorner": {
              "x": -28.949,
              "y": -19.087,
              "z": 0.784
            },
            "rightCorner": {
              "x": -28.865,
              "y": -19.056,
              "z": 0.784
            },
            "gtin": "4009932001983",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7702",
            "leftCorner": {
              "x": -28.861,
              "y": -19.066,
              "z": 0.784
            },
            "rightCorner": {
              "x": -28.755,
              "y": -19.028,
              "z": 0.784
            },
            "gtin": "4009932131376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7703",
            "leftCorner": {
              "x": -28.755,
              "y": -19.03,
              "z": 0.784
            },
            "rightCorner": {
              "x": -28.676,
              "y": -19.002,
              "z": 0.784
            },
            "gtin": "4009932134100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7704",
            "leftCorner": {
              "x": -28.675,
              "y": -19.003,
              "z": 0.784
            },
            "rightCorner": {
              "x": -28.618,
              "y": -18.983,
              "z": 0.784
            },
            "gtin": "4009932131925",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d77d",
        "height": 1.2103,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7743",
            "leftCorner": {
              "x": -29.75,
              "y": -19.371,
              "z": 0.989
            },
            "rightCorner": {
              "x": -29.682,
              "y": -19.345,
              "z": 0.989
            },
            "gtin": "4036581537754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3827d9cec6558b58697507b9",
            "leftCorner": {
              "x": -29.803,
              "y": -19.435,
              "z": 0.99
            },
            "rightCorner": {
              "x": -29.773,
              "y": -19.424,
              "z": 0.99
            },
            "gtin": "4008617027751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b369a572c6d2e9cba8ad57f0",
            "leftCorner": {
              "x": -29.773,
              "y": -19.424,
              "z": 0.99
            },
            "rightCorner": {
              "x": -29.742,
              "y": -19.414,
              "z": 0.99
            },
            "gtin": "4008617027751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7744",
            "leftCorner": {
              "x": -29.682,
              "y": -19.345,
              "z": 0.989
            },
            "rightCorner": {
              "x": -29.614,
              "y": -19.32,
              "z": 0.989
            },
            "gtin": "4036581537754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7746",
            "leftCorner": {
              "x": -29.674,
              "y": -19.339,
              "z": 0.99
            },
            "rightCorner": {
              "x": -29.589,
              "y": -19.309,
              "z": 0.99
            },
            "gtin": "4036581537754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7745",
            "leftCorner": {
              "x": -29.614,
              "y": -19.32,
              "z": 0.989
            },
            "rightCorner": {
              "x": -29.547,
              "y": -19.295,
              "z": 0.989
            },
            "gtin": "4036581537754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7747",
            "leftCorner": {
              "x": -29.585,
              "y": -19.318,
              "z": 0.99
            },
            "rightCorner": {
              "x": -29.493,
              "y": -19.285,
              "z": 0.99
            },
            "gtin": "4008233177007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7748",
            "leftCorner": {
              "x": -29.492,
              "y": -19.286,
              "z": 0.99
            },
            "rightCorner": {
              "x": -29.307,
              "y": -19.221,
              "z": 0.99
            },
            "gtin": "4009932001891",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7749",
            "leftCorner": {
              "x": -29.308,
              "y": -19.218,
              "z": 0.99
            },
            "rightCorner": {
              "x": -29.14,
              "y": -19.158,
              "z": 0.99
            },
            "gtin": "4008491117777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d774a",
            "leftCorner": {
              "x": -29.142,
              "y": -19.152,
              "z": 0.99
            },
            "rightCorner": {
              "x": -29.036,
              "y": -19.114,
              "z": 0.99
            },
            "gtin": "4008617173960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d774b",
            "leftCorner": {
              "x": -29.035,
              "y": -19.119,
              "z": 0.99
            },
            "rightCorner": {
              "x": -28.948,
              "y": -19.088,
              "z": 0.99
            },
            "gtin": "4008617040644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d774c",
            "leftCorner": {
              "x": -28.947,
              "y": -19.089,
              "z": 0.99
            },
            "rightCorner": {
              "x": -28.856,
              "y": -19.056,
              "z": 0.99
            },
            "gtin": "4008491111317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d774d",
            "leftCorner": {
              "x": -28.853,
              "y": -19.064,
              "z": 0.99
            },
            "rightCorner": {
              "x": -28.683,
              "y": -19.003,
              "z": 0.99
            },
            "gtin": "4008617041887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d774e",
            "leftCorner": {
              "x": -28.683,
              "y": -19.005,
              "z": 0.99
            },
            "rightCorner": {
              "x": -28.614,
              "y": -18.981,
              "z": 0.99
            },
            "gtin": "4008617027751",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d77f",
        "height": 1.4626,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d76d6",
            "leftCorner": {
              "x": -29.654,
              "y": -19.348,
              "z": 1.197
            },
            "rightCorner": {
              "x": -29.445,
              "y": -19.273,
              "z": 1.197
            },
            "gtin": "4008137002658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ad4a35a7ac1a7e254237256e",
            "leftCorner": {
              "x": -29.801,
              "y": -19.44,
              "z": 1.197
            },
            "rightCorner": {
              "x": -29.683,
              "y": -19.398,
              "z": 1.197
            },
            "gtin": "4003087410157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76d7",
            "leftCorner": {
              "x": -29.446,
              "y": -19.271,
              "z": 1.197
            },
            "rightCorner": {
              "x": -29.346,
              "y": -19.237,
              "z": 1.197
            },
            "gtin": "4003087447252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76d8",
            "leftCorner": {
              "x": -29.346,
              "y": -19.237,
              "z": 1.197
            },
            "rightCorner": {
              "x": -29.245,
              "y": -19.201,
              "z": 1.197
            },
            "gtin": "4003087447252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76d9",
            "leftCorner": {
              "x": -29.246,
              "y": -19.199,
              "z": 1.197
            },
            "rightCorner": {
              "x": -29.182,
              "y": -19.176,
              "z": 1.197
            },
            "gtin": "4003087446552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76da",
            "leftCorner": {
              "x": -29.183,
              "y": -19.172,
              "z": 1.197
            },
            "rightCorner": {
              "x": -29.11,
              "y": -19.147,
              "z": 1.197
            },
            "gtin": "4003087440758",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76db",
            "leftCorner": {
              "x": -29.11,
              "y": -19.147,
              "z": 1.197
            },
            "rightCorner": {
              "x": -29.018,
              "y": -19.114,
              "z": 1.197
            },
            "gtin": "4003087410652",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76dc",
            "leftCorner": {
              "x": -29.017,
              "y": -19.117,
              "z": 1.197
            },
            "rightCorner": {
              "x": -28.938,
              "y": -19.089,
              "z": 1.197
            },
            "gtin": "4003087422150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76dd",
            "leftCorner": {
              "x": -28.937,
              "y": -19.093,
              "z": 1.197
            },
            "rightCorner": {
              "x": -28.817,
              "y": -19.051,
              "z": 1.197
            },
            "gtin": "4003087410157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76de",
            "leftCorner": {
              "x": -28.815,
              "y": -19.059,
              "z": 1.197
            },
            "rightCorner": {
              "x": -28.748,
              "y": -19.035,
              "z": 1.197
            },
            "gtin": "4003087441151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76df",
            "leftCorner": {
              "x": -28.747,
              "y": -19.035,
              "z": 1.197
            },
            "rightCorner": {
              "x": -28.679,
              "y": -19.011,
              "z": 1.197
            },
            "gtin": "4008617001096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d76e0",
            "leftCorner": {
              "x": -28.679,
              "y": -19.011,
              "z": 1.197
            },
            "rightCorner": {
              "x": -28.617,
              "y": -18.989,
              "z": 1.197
            },
            "gtin": "4008617001072",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c2c"
  },
  {
    "id": "c2e",
    "name": "c2e",
    "x": -29.049,
    "y": -17.829,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.98395,
      "w": 0.17846
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 73
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d41b",
        "height": 0.16775,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7664",
            "leftCorner": {
              "x": -29.077,
              "y": -17.756,
              "z": 0.137
            },
            "rightCorner": {
              "x": -29.211,
              "y": -17.806,
              "z": 0.137
            },
            "gtin": "8700216615303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "77cc232055e6260d03382636",
            "leftCorner": {
              "x": -29.707,
              "y": -17.992,
              "z": 0.137
            },
            "rightCorner": {
              "x": -29.835,
              "y": -18.04,
              "z": 0.137
            },
            "gtin": "5054563193414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ec68b405c1cb783238556893",
            "leftCorner": {
              "x": -29.985,
              "y": -18.096,
              "z": 0.137
            },
            "rightCorner": {
              "x": -30.125,
              "y": -18.149,
              "z": 0.137
            },
            "gtin": "8700216615303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ddbb93d4c8e0965847cbce19",
            "leftCorner": {
              "x": -30.125,
              "y": -18.149,
              "z": 0.137
            },
            "rightCorner": {
              "x": -30.243,
              "y": -18.193,
              "z": 0.137
            },
            "gtin": "8006540772409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7665",
            "leftCorner": {
              "x": -29.197,
              "y": -17.843,
              "z": 0.137
            },
            "rightCorner": {
              "x": -29.273,
              "y": -17.871,
              "z": 0.137
            },
            "gtin": "4210201446392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7666",
            "leftCorner": {
              "x": -29.272,
              "y": -17.872,
              "z": 0.137
            },
            "rightCorner": {
              "x": -29.367,
              "y": -17.908,
              "z": 0.137
            },
            "gtin": "8006540772768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7667",
            "leftCorner": {
              "x": -29.369,
              "y": -17.903,
              "z": 0.137
            },
            "rightCorner": {
              "x": -29.495,
              "y": -17.949,
              "z": 0.137
            },
            "gtin": "8006540772409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7668",
            "leftCorner": {
              "x": -29.497,
              "y": -17.944,
              "z": 0.137
            },
            "rightCorner": {
              "x": -29.697,
              "y": -18.02,
              "z": 0.137
            },
            "gtin": "8700216423410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d766a",
            "leftCorner": {
              "x": -29.842,
              "y": -18.077,
              "z": 0.137
            },
            "rightCorner": {
              "x": -29.974,
              "y": -18.126,
              "z": 0.137
            },
            "gtin": "5054563193445",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d418",
        "height": 0.73626,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d763e",
            "leftCorner": {
              "x": -29.004,
              "y": -17.952,
              "z": 0.602
            },
            "rightCorner": {
              "x": -29.207,
              "y": -18.028,
              "z": 0.602
            },
            "gtin": "4103330012166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7640",
            "leftCorner": {
              "x": -29.197,
              "y": -18.055,
              "z": 0.602
            },
            "rightCorner": {
              "x": -29.389,
              "y": -18.126,
              "z": 0.602
            },
            "gtin": "4210201293873",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7641",
            "leftCorner": {
              "x": -29.394,
              "y": -18.112,
              "z": 0.602
            },
            "rightCorner": {
              "x": -29.462,
              "y": -18.137,
              "z": 0.602
            },
            "gtin": "8006540805879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7642",
            "leftCorner": {
              "x": -29.464,
              "y": -18.131,
              "z": 0.602
            },
            "rightCorner": {
              "x": -29.52,
              "y": -18.153,
              "z": 0.602
            },
            "gtin": "8006540861073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7643",
            "leftCorner": {
              "x": -29.508,
              "y": -18.184,
              "z": 0.602
            },
            "rightCorner": {
              "x": -29.592,
              "y": -18.215,
              "z": 0.602
            },
            "gtin": "8006540860939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7644",
            "leftCorner": {
              "x": -29.568,
              "y": -18.279,
              "z": 0.602
            },
            "rightCorner": {
              "x": -29.627,
              "y": -18.302,
              "z": 0.602
            },
            "gtin": "8006540860380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7645",
            "leftCorner": {
              "x": -29.63,
              "y": -18.294,
              "z": 0.602
            },
            "rightCorner": {
              "x": -29.719,
              "y": -18.327,
              "z": 0.602
            },
            "gtin": "8006540860885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7646",
            "leftCorner": {
              "x": -29.694,
              "y": -18.392,
              "z": 0.602
            },
            "rightCorner": {
              "x": -29.759,
              "y": -18.416,
              "z": 0.602
            },
            "gtin": "4210201319832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7647",
            "leftCorner": {
              "x": -29.762,
              "y": -18.407,
              "z": 0.602
            },
            "rightCorner": {
              "x": -29.823,
              "y": -18.429,
              "z": 0.602
            },
            "gtin": "8006540860809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7648",
            "leftCorner": {
              "x": -29.841,
              "y": -18.38,
              "z": 0.602
            },
            "rightCorner": {
              "x": -29.913,
              "y": -18.406,
              "z": 0.602
            },
            "gtin": "8006540860717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7649",
            "leftCorner": {
              "x": -29.948,
              "y": -18.312,
              "z": 0.602
            },
            "rightCorner": {
              "x": -30.006,
              "y": -18.334,
              "z": 0.602
            },
            "gtin": "4022551324370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d764a",
            "leftCorner": {
              "x": -29.995,
              "y": -18.365,
              "z": 0.602
            },
            "rightCorner": {
              "x": -30.074,
              "y": -18.394,
              "z": 0.602
            },
            "gtin": "4260633190196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d764b",
            "leftCorner": {
              "x": -30.083,
              "y": -18.373,
              "z": 0.602
            },
            "rightCorner": {
              "x": -30.2,
              "y": -18.417,
              "z": 0.602
            },
            "gtin": "7350075691782",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d419",
        "height": 1.0705,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7653",
            "leftCorner": {
              "x": -29.0,
              "y": -17.961,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.068,
              "y": -17.986,
              "z": 0.876
            },
            "gtin": "4101160130500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7655",
            "leftCorner": {
              "x": -29.062,
              "y": -18.0,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.144,
              "y": -18.031,
              "z": 0.876
            },
            "gtin": "4260457772042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7656",
            "leftCorner": {
              "x": -29.145,
              "y": -18.028,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.223,
              "y": -18.058,
              "z": 0.876
            },
            "gtin": "4260457770666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7657",
            "leftCorner": {
              "x": -29.179,
              "y": -18.177,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.271,
              "y": -18.211,
              "z": 0.876
            },
            "gtin": "4306188345251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7658",
            "leftCorner": {
              "x": -29.311,
              "y": -18.103,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.348,
              "y": -18.117,
              "z": 0.876
            },
            "gtin": "4007965116407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7659",
            "leftCorner": {
              "x": -29.357,
              "y": -18.096,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.424,
              "y": -18.121,
              "z": 0.876
            },
            "gtin": "4007965111006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d765a",
            "leftCorner": {
              "x": -29.423,
              "y": -18.125,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.455,
              "y": -18.138,
              "z": 0.876
            },
            "gtin": "7610108049363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d765b",
            "leftCorner": {
              "x": -29.455,
              "y": -18.139,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.531,
              "y": -18.168,
              "z": 0.876
            },
            "gtin": "3014260103385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d765c",
            "leftCorner": {
              "x": -29.534,
              "y": -18.16,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.591,
              "y": -18.182,
              "z": 0.876
            },
            "gtin": "8714789086477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d765d",
            "leftCorner": {
              "x": -29.583,
              "y": -18.202,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.642,
              "y": -18.224,
              "z": 0.876
            },
            "gtin": "5054563200181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d765e",
            "leftCorner": {
              "x": -29.624,
              "y": -18.273,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.685,
              "y": -18.296,
              "z": 0.876
            },
            "gtin": "5054563201867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d765f",
            "leftCorner": {
              "x": -29.679,
              "y": -18.313,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.738,
              "y": -18.335,
              "z": 0.876
            },
            "gtin": "8720181502828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7660",
            "leftCorner": {
              "x": -29.747,
              "y": -18.312,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.798,
              "y": -18.331,
              "z": 0.876
            },
            "gtin": "5054563117519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7661",
            "leftCorner": {
              "x": -29.8,
              "y": -18.326,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.872,
              "y": -18.353,
              "z": 0.876
            },
            "gtin": "8720181502835",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7662",
            "leftCorner": {
              "x": -29.873,
              "y": -18.352,
              "z": 0.876
            },
            "rightCorner": {
              "x": -29.971,
              "y": -18.388,
              "z": 0.876
            },
            "gtin": "5054563122872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7663",
            "leftCorner": {
              "x": -29.972,
              "y": -18.384,
              "z": 0.876
            },
            "rightCorner": {
              "x": -30.064,
              "y": -18.419,
              "z": 0.876
            },
            "gtin": "7350075690426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7654",
            "leftCorner": {
              "x": -30.075,
              "y": -18.39,
              "z": 0.876
            },
            "rightCorner": {
              "x": -30.161,
              "y": -18.423,
              "z": 0.876
            },
            "gtin": "7350075690365",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d417",
        "height": 1.4,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d762d",
            "leftCorner": {
              "x": -29.008,
              "y": -17.94,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.083,
              "y": -17.968,
              "z": 1.145
            },
            "gtin": "5054563122810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d762f",
            "leftCorner": {
              "x": -29.07,
              "y": -18.002,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.125,
              "y": -18.022,
              "z": 1.145
            },
            "gtin": "5054563122834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7630",
            "leftCorner": {
              "x": -29.127,
              "y": -18.016,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.178,
              "y": -18.036,
              "z": 1.145
            },
            "gtin": "5054563924537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7631",
            "leftCorner": {
              "x": -29.151,
              "y": -18.107,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.216,
              "y": -18.131,
              "z": 1.145
            },
            "gtin": "5054563924476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7632",
            "leftCorner": {
              "x": -29.239,
              "y": -18.068,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.299,
              "y": -18.091,
              "z": 1.145
            },
            "gtin": "5054563924513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7633",
            "leftCorner": {
              "x": -29.3,
              "y": -18.088,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.362,
              "y": -18.112,
              "z": 1.145
            },
            "gtin": "5054563127389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7634",
            "leftCorner": {
              "x": -29.355,
              "y": -18.133,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.39,
              "y": -18.146,
              "z": 1.145
            },
            "gtin": "5054563925503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7635",
            "leftCorner": {
              "x": -29.401,
              "y": -18.118,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.518,
              "y": -18.162,
              "z": 1.145
            },
            "gtin": "5054563925534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7636",
            "leftCorner": {
              "x": -29.518,
              "y": -18.163,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.572,
              "y": -18.183,
              "z": 1.145
            },
            "gtin": "5054563924667",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7637",
            "leftCorner": {
              "x": -29.573,
              "y": -18.18,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.629,
              "y": -18.202,
              "z": 1.145
            },
            "gtin": "5054563925381",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7638",
            "leftCorner": {
              "x": -29.628,
              "y": -18.205,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.683,
              "y": -18.226,
              "z": 1.145
            },
            "gtin": "5054563924841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7639",
            "leftCorner": {
              "x": -29.674,
              "y": -18.251,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.743,
              "y": -18.277,
              "z": 1.145
            },
            "gtin": "5054563924933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d763a",
            "leftCorner": {
              "x": -29.732,
              "y": -18.305,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.783,
              "y": -18.323,
              "z": 1.145
            },
            "gtin": "5054563924995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d763b",
            "leftCorner": {
              "x": -29.791,
              "y": -18.299,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.846,
              "y": -18.32,
              "z": 1.145
            },
            "gtin": "5054563924759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d763c",
            "leftCorner": {
              "x": -29.839,
              "y": -18.336,
              "z": 1.145
            },
            "rightCorner": {
              "x": -29.948,
              "y": -18.377,
              "z": 1.145
            },
            "gtin": "5054563925145",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d763d",
            "leftCorner": {
              "x": -29.962,
              "y": -18.341,
              "z": 1.145
            },
            "rightCorner": {
              "x": -30.093,
              "y": -18.39,
              "z": 1.145
            },
            "gtin": "5054563925084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d762e",
            "leftCorner": {
              "x": -30.103,
              "y": -18.364,
              "z": 1.145
            },
            "rightCorner": {
              "x": -30.174,
              "y": -18.39,
              "z": 1.145
            },
            "gtin": "5054563924872",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d416",
        "height": 1.7063,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d761b",
            "leftCorner": {
              "x": -29.01,
              "y": -17.933,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.108,
              "y": -17.97,
              "z": 1.396
            },
            "gtin": "4306188345343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d761d",
            "leftCorner": {
              "x": -29.096,
              "y": -18.003,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.161,
              "y": -18.028,
              "z": 1.396
            },
            "gtin": "4306188345312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d761e",
            "leftCorner": {
              "x": -29.159,
              "y": -18.032,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.205,
              "y": -18.049,
              "z": 1.396
            },
            "gtin": "8700216441858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d761f",
            "leftCorner": {
              "x": -29.205,
              "y": -18.048,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.273,
              "y": -18.074,
              "z": 1.396
            },
            "gtin": "8700216445573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7620",
            "leftCorner": {
              "x": -29.273,
              "y": -18.075,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.325,
              "y": -18.095,
              "z": 1.396
            },
            "gtin": "8700216106351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7621",
            "leftCorner": {
              "x": -29.323,
              "y": -18.102,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.364,
              "y": -18.118,
              "z": 1.396
            },
            "gtin": "8700216449410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7622",
            "leftCorner": {
              "x": -29.367,
              "y": -18.11,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.438,
              "y": -18.136,
              "z": 1.396
            },
            "gtin": "8718951658905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7623",
            "leftCorner": {
              "x": -29.438,
              "y": -18.134,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.489,
              "y": -18.153,
              "z": 1.396
            },
            "gtin": "8718951705531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7624",
            "leftCorner": {
              "x": -29.49,
              "y": -18.15,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.544,
              "y": -18.171,
              "z": 1.396
            },
            "gtin": "8718951707603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7625",
            "leftCorner": {
              "x": -29.544,
              "y": -18.173,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.595,
              "y": -18.192,
              "z": 1.396
            },
            "gtin": "7610108052387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7626",
            "leftCorner": {
              "x": -29.594,
              "y": -18.196,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.658,
              "y": -18.22,
              "z": 1.396
            },
            "gtin": "8718951707764",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7627",
            "leftCorner": {
              "x": -29.658,
              "y": -18.22,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.713,
              "y": -18.241,
              "z": 1.396
            },
            "gtin": "7610108057276",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7628",
            "leftCorner": {
              "x": -29.714,
              "y": -18.237,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.788,
              "y": -18.264,
              "z": 1.396
            },
            "gtin": "8718951705319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7629",
            "leftCorner": {
              "x": -29.779,
              "y": -18.29,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.837,
              "y": -18.312,
              "z": 1.396
            },
            "gtin": "8700216106542",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d762a",
            "leftCorner": {
              "x": -29.834,
              "y": -18.32,
              "z": 1.396
            },
            "rightCorner": {
              "x": -29.9,
              "y": -18.344,
              "z": 1.396
            },
            "gtin": "8714789973852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d762b",
            "leftCorner": {
              "x": -29.919,
              "y": -18.295,
              "z": 1.396
            },
            "rightCorner": {
              "x": -30.006,
              "y": -18.327,
              "z": 1.396
            },
            "gtin": "8714789365152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d762c",
            "leftCorner": {
              "x": -30.004,
              "y": -18.332,
              "z": 1.396
            },
            "rightCorner": {
              "x": -30.101,
              "y": -18.369,
              "z": 1.396
            },
            "gtin": "8714789447018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d761c",
            "leftCorner": {
              "x": -30.098,
              "y": -18.377,
              "z": 1.396
            },
            "rightCorner": {
              "x": -30.169,
              "y": -18.403,
              "z": 1.396
            },
            "gtin": "4260457779737",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "c32"
  },
  {
    "id": "c31",
    "name": "c31",
    "x": -28.036,
    "y": -18.791,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.8301,
      "w": 0.55761
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 4,
      "unknownStockCount": 19
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d786",
        "height": 0.23874,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d899d",
            "leftCorner": {
              "x": -27.902,
              "y": -18.735,
              "z": 0.195
            },
            "rightCorner": {
              "x": -28.009,
              "y": -18.472,
              "z": 0.195
            },
            "gtin": "8720294048831",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d89a0",
            "leftCorner": {
              "x": -28.045,
              "y": -18.487,
              "z": 0.195
            },
            "rightCorner": {
              "x": -28.086,
              "y": -18.385,
              "z": 0.195
            },
            "gtin": "8720294055792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89a1",
            "leftCorner": {
              "x": -28.094,
              "y": -18.388,
              "z": 0.195
            },
            "rightCorner": {
              "x": -28.149,
              "y": -18.256,
              "z": 0.195
            },
            "gtin": "8720294056102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89a2",
            "leftCorner": {
              "x": -28.136,
              "y": -18.251,
              "z": 0.195
            },
            "rightCorner": {
              "x": -28.192,
              "y": -18.113,
              "z": 0.195
            },
            "gtin": "8711269987828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89a3",
            "leftCorner": {
              "x": -28.192,
              "y": -18.113,
              "z": 0.195
            },
            "rightCorner": {
              "x": -28.249,
              "y": -17.974,
              "z": 0.195
            },
            "gtin": "8711269987828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d899e",
            "leftCorner": {
              "x": -28.253,
              "y": -17.976,
              "z": 0.195
            },
            "rightCorner": {
              "x": -28.331,
              "y": -17.785,
              "z": 0.195
            },
            "gtin": "4002942703953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d899f",
            "leftCorner": {
              "x": -28.331,
              "y": -17.785,
              "z": 0.195
            },
            "rightCorner": {
              "x": -28.41,
              "y": -17.593,
              "z": 0.195
            },
            "gtin": "4002942703953",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d787",
        "height": 0.50314,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d89a4",
            "leftCorner": {
              "x": -27.951,
              "y": -18.755,
              "z": 0.412
            },
            "rightCorner": {
              "x": -28.096,
              "y": -18.399,
              "z": 0.412
            },
            "gtin": "4008110229300",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d89a6",
            "leftCorner": {
              "x": -28.132,
              "y": -18.414,
              "z": 0.412
            },
            "rightCorner": {
              "x": -28.185,
              "y": -18.286,
              "z": 0.412
            },
            "gtin": "4005401250302",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d89a7",
            "leftCorner": {
              "x": -28.184,
              "y": -18.286,
              "z": 0.412
            },
            "rightCorner": {
              "x": -28.218,
              "y": -18.203,
              "z": 0.412
            },
            "gtin": "4005401816003",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d89a8",
            "leftCorner": {
              "x": -28.22,
              "y": -18.204,
              "z": 0.412
            },
            "rightCorner": {
              "x": -28.283,
              "y": -18.053,
              "z": 0.412
            },
            "gtin": "3154140286002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89a9",
            "leftCorner": {
              "x": -28.278,
              "y": -18.051,
              "z": 0.412
            },
            "rightCorner": {
              "x": -28.359,
              "y": -17.85,
              "z": 0.412
            },
            "gtin": "4064997201815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89a5",
            "leftCorner": {
              "x": -28.362,
              "y": -17.851,
              "z": 0.412
            },
            "rightCorner": {
              "x": -28.46,
              "y": -17.613,
              "z": 0.412
            },
            "gtin": "4064997201266",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d783",
        "height": 0.82841,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8997",
            "leftCorner": {
              "x": -27.957,
              "y": -18.758,
              "z": 0.678
            },
            "rightCorner": {
              "x": -28.09,
              "y": -18.433,
              "z": 0.678
            },
            "gtin": "4033866207951",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8999",
            "leftCorner": {
              "x": -28.128,
              "y": -18.448,
              "z": 0.678
            },
            "rightCorner": {
              "x": -28.3,
              "y": -18.025,
              "z": 0.678
            },
            "gtin": "4009803010564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8998",
            "leftCorner": {
              "x": -28.29,
              "y": -18.021,
              "z": 0.678
            },
            "rightCorner": {
              "x": -28.457,
              "y": -17.612,
              "z": 0.678
            },
            "gtin": "4008789714725",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d785",
        "height": 1.2331,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d899a",
            "leftCorner": {
              "x": -27.955,
              "y": -18.757,
              "z": 1.009
            },
            "rightCorner": {
              "x": -28.204,
              "y": -18.149,
              "z": 1.009
            },
            "gtin": "5702017592695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d899c",
            "leftCorner": {
              "x": -28.239,
              "y": -18.164,
              "z": 1.009
            },
            "rightCorner": {
              "x": -28.322,
              "y": -17.962,
              "z": 1.009
            },
            "gtin": "4008789717603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d899b",
            "leftCorner": {
              "x": -28.32,
              "y": -17.962,
              "z": 1.009
            },
            "rightCorner": {
              "x": -28.462,
              "y": -17.614,
              "z": 1.009
            },
            "gtin": "4005556236961",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d788",
        "height": 1.533,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d89aa",
            "leftCorner": {
              "x": -27.945,
              "y": -18.753,
              "z": 1.254
            },
            "rightCorner": {
              "x": -28.105,
              "y": -18.36,
              "z": 1.254
            },
            "gtin": "5050293867328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89ab",
            "leftCorner": {
              "x": -28.105,
              "y": -18.36,
              "z": 1.254
            },
            "rightCorner": {
              "x": -28.266,
              "y": -17.966,
              "z": 1.254
            },
            "gtin": "5050293867328",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89ad",
            "leftCorner": {
              "x": -28.301,
              "y": -17.981,
              "z": 1.254
            },
            "rightCorner": {
              "x": -28.381,
              "y": -17.787,
              "z": 1.254
            },
            "gtin": "5050293861302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89ac",
            "leftCorner": {
              "x": -28.376,
              "y": -17.785,
              "z": 1.254
            },
            "rightCorner": {
              "x": -28.448,
              "y": -17.609,
              "z": 1.254
            },
            "gtin": "4250786280158",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "c32",
    "name": "c32",
    "x": -30.219,
    "y": -18.268,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.98395,
      "w": 0.17846
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 49
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d421",
        "height": 0.17138,
        "facings": [
          {
            "id": "55596bc9d8eb948e62e76326",
            "leftCorner": {
              "x": -30.255,
              "y": -18.171,
              "z": 0.14
            },
            "rightCorner": {
              "x": -30.298,
              "y": -18.188,
              "z": 0.14
            },
            "gtin": "8718951453395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dfcd4c865ce720628f23630a",
            "leftCorner": {
              "x": -30.298,
              "y": -18.188,
              "z": 0.14
            },
            "rightCorner": {
              "x": -30.341,
              "y": -18.204,
              "z": 0.14
            },
            "gtin": "8718951453395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7b05f63d255389b25b8fbb00",
            "leftCorner": {
              "x": -30.341,
              "y": -18.204,
              "z": 0.14
            },
            "rightCorner": {
              "x": -30.422,
              "y": -18.234,
              "z": 0.14
            },
            "gtin": "8006540945162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee6e362cb8ca84fb0a3f3abe",
            "leftCorner": {
              "x": -30.422,
              "y": -18.234,
              "z": 0.14
            },
            "rightCorner": {
              "x": -30.511,
              "y": -18.268,
              "z": 0.14
            },
            "gtin": "5054563207326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9b8639b72c6f75527724ac58",
            "leftCorner": {
              "x": -30.511,
              "y": -18.268,
              "z": 0.14
            },
            "rightCorner": {
              "x": -30.623,
              "y": -18.309,
              "z": 0.14
            },
            "gtin": "4026600015127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d3db0e594e7950e89ed02edb",
            "leftCorner": {
              "x": -30.623,
              "y": -18.309,
              "z": 0.14
            },
            "rightCorner": {
              "x": -30.745,
              "y": -18.355,
              "z": 0.14
            },
            "gtin": "8006540947203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a2df43aa71c4ae7078d85183",
            "leftCorner": {
              "x": -30.745,
              "y": -18.355,
              "z": 0.14
            },
            "rightCorner": {
              "x": -30.868,
              "y": -18.401,
              "z": 0.14
            },
            "gtin": "8718951314535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c53188ee092e81e62553c2d2",
            "leftCorner": {
              "x": -30.868,
              "y": -18.401,
              "z": 0.14
            },
            "rightCorner": {
              "x": -30.991,
              "y": -18.447,
              "z": 0.14
            },
            "gtin": "8718951031876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8293ae930e3695c8f7c161f8",
            "leftCorner": {
              "x": -30.991,
              "y": -18.447,
              "z": 0.14
            },
            "rightCorner": {
              "x": -31.119,
              "y": -18.495,
              "z": 0.14
            },
            "gtin": "5054563202277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8aaceaa063a0d681d3bdaefb",
            "leftCorner": {
              "x": -31.119,
              "y": -18.495,
              "z": 0.14
            },
            "rightCorner": {
              "x": -31.249,
              "y": -18.544,
              "z": 0.14
            },
            "gtin": "8006540006313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1da440f71e3105e1a46444d7",
            "leftCorner": {
              "x": -31.249,
              "y": -18.544,
              "z": 0.14
            },
            "rightCorner": {
              "x": -31.423,
              "y": -18.61,
              "z": 0.14
            },
            "gtin": "8700216666619",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d41c",
        "height": 0.4682,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7677",
            "leftCorner": {
              "x": -30.24,
              "y": -18.21,
              "z": 0.383
            },
            "rightCorner": {
              "x": -30.436,
              "y": -18.283,
              "z": 0.383
            },
            "gtin": "4008666811783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7679",
            "leftCorner": {
              "x": -30.419,
              "y": -18.326,
              "z": 0.383
            },
            "rightCorner": {
              "x": -30.551,
              "y": -18.376,
              "z": 0.383
            },
            "gtin": "5054563202277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d767a",
            "leftCorner": {
              "x": -30.553,
              "y": -18.37,
              "z": 0.383
            },
            "rightCorner": {
              "x": -30.655,
              "y": -18.409,
              "z": 0.383
            },
            "gtin": "4026600015127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d767b",
            "leftCorner": {
              "x": -30.655,
              "y": -18.409,
              "z": 0.383
            },
            "rightCorner": {
              "x": -30.775,
              "y": -18.454,
              "z": 0.383
            },
            "gtin": "8006540947203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d767c",
            "leftCorner": {
              "x": -30.779,
              "y": -18.441,
              "z": 0.383
            },
            "rightCorner": {
              "x": -30.862,
              "y": -18.472,
              "z": 0.383
            },
            "gtin": "8006540945162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d767d",
            "leftCorner": {
              "x": -30.863,
              "y": -18.47,
              "z": 0.383
            },
            "rightCorner": {
              "x": -31.041,
              "y": -18.537,
              "z": 0.383
            },
            "gtin": "8718951035461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d767e",
            "leftCorner": {
              "x": -31.038,
              "y": -18.546,
              "z": 0.383
            },
            "rightCorner": {
              "x": -31.266,
              "y": -18.631,
              "z": 0.383
            },
            "gtin": "8718951035430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7678",
            "leftCorner": {
              "x": -31.261,
              "y": -18.643,
              "z": 0.383
            },
            "rightCorner": {
              "x": -31.394,
              "y": -18.693,
              "z": 0.383
            },
            "gtin": "8718951031876",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d41d",
        "height": 0.74136,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d764c",
            "leftCorner": {
              "x": -30.254,
              "y": -18.269,
              "z": 0.607
            },
            "rightCorner": {
              "x": -30.364,
              "y": -18.311,
              "z": 0.607
            },
            "gtin": "5054563159090",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d764d",
            "leftCorner": {
              "x": -30.368,
              "y": -18.303,
              "z": 0.607
            },
            "rightCorner": {
              "x": -30.452,
              "y": -18.335,
              "z": 0.607
            },
            "gtin": "5054563207326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d764e",
            "leftCorner": {
              "x": -30.454,
              "y": -18.331,
              "z": 0.607
            },
            "rightCorner": {
              "x": -30.627,
              "y": -18.396,
              "z": 0.607
            },
            "gtin": "5054563104144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d764f",
            "leftCorner": {
              "x": -30.629,
              "y": -18.39,
              "z": 0.607
            },
            "rightCorner": {
              "x": -30.78,
              "y": -18.448,
              "z": 0.607
            },
            "gtin": "5054563240828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7650",
            "leftCorner": {
              "x": -30.784,
              "y": -18.435,
              "z": 0.607
            },
            "rightCorner": {
              "x": -30.958,
              "y": -18.499,
              "z": 0.607
            },
            "gtin": "5054563085863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7651",
            "leftCorner": {
              "x": -30.956,
              "y": -18.505,
              "z": 0.607
            },
            "rightCorner": {
              "x": -31.09,
              "y": -18.556,
              "z": 0.607
            },
            "gtin": "5054563209177",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7652",
            "leftCorner": {
              "x": -31.085,
              "y": -18.569,
              "z": 0.607
            },
            "rightCorner": {
              "x": -31.256,
              "y": -18.632,
              "z": 0.607
            },
            "gtin": "5054563206558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d763f",
            "leftCorner": {
              "x": -31.253,
              "y": -18.639,
              "z": 0.607
            },
            "rightCorner": {
              "x": -31.395,
              "y": -18.692,
              "z": 0.607
            },
            "gtin": "8718951314535",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d41f",
        "height": 0.98464,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7687",
            "leftCorner": {
              "x": -30.237,
              "y": -18.22,
              "z": 0.806
            },
            "rightCorner": {
              "x": -30.443,
              "y": -18.297,
              "z": 0.806
            },
            "gtin": "8006530040976",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7689",
            "leftCorner": {
              "x": -30.426,
              "y": -18.344,
              "z": 0.806
            },
            "rightCorner": {
              "x": -30.586,
              "y": -18.404,
              "z": 0.806
            },
            "gtin": "8700216666619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d768a",
            "leftCorner": {
              "x": -30.589,
              "y": -18.395,
              "z": 0.806
            },
            "rightCorner": {
              "x": -30.758,
              "y": -18.458,
              "z": 0.806
            },
            "gtin": "5054563186188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d768b",
            "leftCorner": {
              "x": -30.76,
              "y": -18.455,
              "z": 0.806
            },
            "rightCorner": {
              "x": -30.894,
              "y": -18.506,
              "z": 0.806
            },
            "gtin": "5054563209207",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d768c",
            "leftCorner": {
              "x": -30.896,
              "y": -18.497,
              "z": 0.806
            },
            "rightCorner": {
              "x": -31.059,
              "y": -18.558,
              "z": 0.806
            },
            "gtin": "5054563099587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d768d",
            "leftCorner": {
              "x": -31.054,
              "y": -18.57,
              "z": 0.806
            },
            "rightCorner": {
              "x": -31.204,
              "y": -18.626,
              "z": 0.806
            },
            "gtin": "5054563209238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7688",
            "leftCorner": {
              "x": -31.201,
              "y": -18.633,
              "z": 0.806
            },
            "rightCorner": {
              "x": -31.391,
              "y": -18.704,
              "z": 0.806
            },
            "gtin": "5054563209269",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d41e",
        "height": 1.2374,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d767f",
            "leftCorner": {
              "x": -30.237,
              "y": -18.221,
              "z": 1.012
            },
            "rightCorner": {
              "x": -30.427,
              "y": -18.293,
              "z": 1.012
            },
            "gtin": "8700216666503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8c85361212948eeae3dd497a",
            "leftCorner": {
              "x": -31.362,
              "y": -18.643,
              "z": 1.012
            },
            "rightCorner": {
              "x": -31.405,
              "y": -18.659,
              "z": 1.012
            },
            "gtin": "8718951453395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7681",
            "leftCorner": {
              "x": -30.41,
              "y": -18.338,
              "z": 1.012
            },
            "rightCorner": {
              "x": -30.541,
              "y": -18.388,
              "z": 1.012
            },
            "gtin": "8006540006313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7682",
            "leftCorner": {
              "x": -30.544,
              "y": -18.379,
              "z": 1.012
            },
            "rightCorner": {
              "x": -30.723,
              "y": -18.445,
              "z": 1.012
            },
            "gtin": "7610108056316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7683",
            "leftCorner": {
              "x": -30.723,
              "y": -18.445,
              "z": 1.012
            },
            "rightCorner": {
              "x": -30.869,
              "y": -18.501,
              "z": 1.012
            },
            "gtin": "4007965015007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7684",
            "leftCorner": {
              "x": -30.873,
              "y": -18.488,
              "z": 1.012
            },
            "rightCorner": {
              "x": -31.034,
              "y": -18.548,
              "z": 1.012
            },
            "gtin": "7610108059249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7685",
            "leftCorner": {
              "x": -31.031,
              "y": -18.556,
              "z": 1.012
            },
            "rightCorner": {
              "x": -31.187,
              "y": -18.614,
              "z": 1.012
            },
            "gtin": "7610108047536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7686",
            "leftCorner": {
              "x": -31.182,
              "y": -18.628,
              "z": 1.012
            },
            "rightCorner": {
              "x": -31.344,
              "y": -18.689,
              "z": 1.012
            },
            "gtin": "8718951080041",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d420",
        "height": 1.5124,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d768e",
            "leftCorner": {
              "x": -30.239,
              "y": -18.213,
              "z": 1.237
            },
            "rightCorner": {
              "x": -30.487,
              "y": -18.305,
              "z": 1.237
            },
            "gtin": "7610108059461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d768f",
            "leftCorner": {
              "x": -30.471,
              "y": -18.35,
              "z": 1.237
            },
            "rightCorner": {
              "x": -30.631,
              "y": -18.41,
              "z": 1.237
            },
            "gtin": "8714789921006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7690",
            "leftCorner": {
              "x": -30.634,
              "y": -18.404,
              "z": 1.237
            },
            "rightCorner": {
              "x": -30.779,
              "y": -18.458,
              "z": 1.237
            },
            "gtin": "8718951115446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7691",
            "leftCorner": {
              "x": -30.783,
              "y": -18.448,
              "z": 1.237
            },
            "rightCorner": {
              "x": -30.93,
              "y": -18.503,
              "z": 1.237
            },
            "gtin": "8718951032644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7692",
            "leftCorner": {
              "x": -30.929,
              "y": -18.506,
              "z": 1.237
            },
            "rightCorner": {
              "x": -31.061,
              "y": -18.556,
              "z": 1.237
            },
            "gtin": "4008666831125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7693",
            "leftCorner": {
              "x": -31.058,
              "y": -18.564,
              "z": 1.237
            },
            "rightCorner": {
              "x": -31.233,
              "y": -18.629,
              "z": 1.237
            },
            "gtin": "4008666831170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7694",
            "leftCorner": {
              "x": -31.228,
              "y": -18.64,
              "z": 1.237
            },
            "rightCorner": {
              "x": -31.4,
              "y": -18.704,
              "z": 1.237
            },
            "gtin": "4016369461495",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c2e",
    "rightNeighborShelfId": "c33"
  },
  {
    "id": "c33",
    "name": "c33",
    "x": -31.39,
    "y": -18.707,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.98395,
      "w": 0.17846
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d78d",
        "height": 0.16906,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d89cc",
            "leftCorner": {
              "x": -31.341,
              "y": -18.836,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.511,
              "y": -18.9,
              "z": 0.138
            },
            "gtin": "8718951483729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e1fbcf737121cb3dd671dd4c",
            "leftCorner": {
              "x": -31.948,
              "y": -19.064,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.048,
              "y": -19.102,
              "z": 0.138
            },
            "gtin": "3574661731001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3e4937105f9d74d0d10843b1",
            "leftCorner": {
              "x": -32.048,
              "y": -19.102,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.497,
              "y": -19.27,
              "z": 0.138
            },
            "gtin": "3574661731025",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89ce",
            "leftCorner": {
              "x": -31.501,
              "y": -18.922,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.561,
              "y": -18.945,
              "z": 0.138
            },
            "gtin": "8718951483668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89cf",
            "leftCorner": {
              "x": -31.561,
              "y": -18.945,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.734,
              "y": -19.01,
              "z": 0.138
            },
            "gtin": "3574661747200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89d0",
            "leftCorner": {
              "x": -31.732,
              "y": -19.015,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.832,
              "y": -19.052,
              "z": 0.138
            },
            "gtin": "3574661730967",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89d1",
            "leftCorner": {
              "x": -31.828,
              "y": -19.061,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.935,
              "y": -19.1,
              "z": 0.138
            },
            "gtin": "3574661731124",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d78e",
        "height": 0.46848,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d89d4",
            "leftCorner": {
              "x": -31.331,
              "y": -18.864,
              "z": 0.383
            },
            "rightCorner": {
              "x": -31.506,
              "y": -18.93,
              "z": 0.383
            },
            "gtin": "4016471054134",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "3496f9b21b610c5f210a79cf",
            "leftCorner": {
              "x": -32.28,
              "y": -19.22,
              "z": 0.383
            },
            "rightCorner": {
              "x": -32.321,
              "y": -19.235,
              "z": 0.383
            },
            "gtin": "4026600111256",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d89d6",
            "leftCorner": {
              "x": -31.492,
              "y": -18.968,
              "z": 0.383
            },
            "rightCorner": {
              "x": -31.527,
              "y": -18.982,
              "z": 0.383
            },
            "gtin": "42019343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89d7",
            "leftCorner": {
              "x": -31.528,
              "y": -18.981,
              "z": 0.383
            },
            "rightCorner": {
              "x": -31.588,
              "y": -19.004,
              "z": 0.383
            },
            "gtin": "5054563125217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89d8",
            "leftCorner": {
              "x": -31.587,
              "y": -19.007,
              "z": 0.383
            },
            "rightCorner": {
              "x": -31.861,
              "y": -19.109,
              "z": 0.383
            },
            "gtin": "42023722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89d9",
            "leftCorner": {
              "x": -31.86,
              "y": -19.11,
              "z": 0.383
            },
            "rightCorner": {
              "x": -31.977,
              "y": -19.154,
              "z": 0.383
            },
            "gtin": "7610108059317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89da",
            "leftCorner": {
              "x": -31.978,
              "y": -19.15,
              "z": 0.383
            },
            "rightCorner": {
              "x": -32.126,
              "y": -19.205,
              "z": 0.383
            },
            "gtin": "7610108060252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89db",
            "leftCorner": {
              "x": -32.128,
              "y": -19.198,
              "z": 0.383
            },
            "rightCorner": {
              "x": -32.201,
              "y": -19.225,
              "z": 0.383
            },
            "gtin": "5054563129598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89dc",
            "leftCorner": {
              "x": -32.203,
              "y": -19.222,
              "z": 0.383
            },
            "rightCorner": {
              "x": -32.27,
              "y": -19.247,
              "z": 0.383
            },
            "gtin": "5054563271358",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89d5",
            "leftCorner": {
              "x": -32.332,
              "y": -19.269,
              "z": 0.383
            },
            "rightCorner": {
              "x": -32.492,
              "y": -19.329,
              "z": 0.383
            },
            "gtin": "5054563123893",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d78c",
        "height": 0.74222,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d89c4",
            "leftCorner": {
              "x": -31.332,
              "y": -18.861,
              "z": 0.607
            },
            "rightCorner": {
              "x": -31.609,
              "y": -18.966,
              "z": 0.607
            },
            "gtin": "8718951227262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89c6",
            "leftCorner": {
              "x": -31.594,
              "y": -19.005,
              "z": 0.607
            },
            "rightCorner": {
              "x": -31.77,
              "y": -19.071,
              "z": 0.607
            },
            "gtin": "8718951227323",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89c7",
            "leftCorner": {
              "x": -31.768,
              "y": -19.077,
              "z": 0.607
            },
            "rightCorner": {
              "x": -31.963,
              "y": -19.15,
              "z": 0.607
            },
            "gtin": "8718951312432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89c8",
            "leftCorner": {
              "x": -31.966,
              "y": -19.142,
              "z": 0.607
            },
            "rightCorner": {
              "x": -32.116,
              "y": -19.197,
              "z": 0.607
            },
            "gtin": "8001090573049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89c9",
            "leftCorner": {
              "x": -32.116,
              "y": -19.197,
              "z": 0.607
            },
            "rightCorner": {
              "x": -32.178,
              "y": -19.22,
              "z": 0.607
            },
            "gtin": "8712561437370",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89ca",
            "leftCorner": {
              "x": -32.179,
              "y": -19.218,
              "z": 0.607
            },
            "rightCorner": {
              "x": -32.27,
              "y": -19.251,
              "z": 0.607
            },
            "gtin": "4015100185294",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89cb",
            "leftCorner": {
              "x": -32.27,
              "y": -19.25,
              "z": 0.607
            },
            "rightCorner": {
              "x": -32.412,
              "y": -19.304,
              "z": 0.607
            },
            "gtin": "4068101000042",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89c5",
            "leftCorner": {
              "x": -32.413,
              "y": -19.3,
              "z": 0.607
            },
            "rightCorner": {
              "x": -32.492,
              "y": -19.329,
              "z": 0.607
            },
            "gtin": "5010724002674",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d78b",
        "height": 0.98285,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d89be",
            "leftCorner": {
              "x": -31.328,
              "y": -18.871,
              "z": 0.804
            },
            "rightCorner": {
              "x": -31.577,
              "y": -18.964,
              "z": 0.804
            },
            "gtin": "5054563949363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89c0",
            "leftCorner": {
              "x": -31.56,
              "y": -19.008,
              "z": 0.804
            },
            "rightCorner": {
              "x": -31.729,
              "y": -19.071,
              "z": 0.804
            },
            "gtin": "5054563949424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89c1",
            "leftCorner": {
              "x": -31.727,
              "y": -19.077,
              "z": 0.804
            },
            "rightCorner": {
              "x": -32.102,
              "y": -19.217,
              "z": 0.804
            },
            "gtin": "5054563261021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89c2",
            "leftCorner": {
              "x": -32.108,
              "y": -19.205,
              "z": 0.804
            },
            "rightCorner": {
              "x": -32.277,
              "y": -19.268,
              "z": 0.804
            },
            "gtin": "8006540883365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89c3",
            "leftCorner": {
              "x": -32.279,
              "y": -19.264,
              "z": 0.804
            },
            "rightCorner": {
              "x": -32.387,
              "y": -19.304,
              "z": 0.804
            },
            "gtin": "4021457652297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89bf",
            "leftCorner": {
              "x": -32.387,
              "y": -19.305,
              "z": 0.804
            },
            "rightCorner": {
              "x": -32.487,
              "y": -19.342,
              "z": 0.804
            },
            "gtin": "8720181283437",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d78a",
        "height": 1.2361,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d89b7",
            "leftCorner": {
              "x": -31.326,
              "y": -18.879,
              "z": 1.011
            },
            "rightCorner": {
              "x": -31.542,
              "y": -18.96,
              "z": 1.011
            },
            "gtin": "8718951570412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89b9",
            "leftCorner": {
              "x": -31.527,
              "y": -18.999,
              "z": 1.011
            },
            "rightCorner": {
              "x": -31.689,
              "y": -19.06,
              "z": 1.011
            },
            "gtin": "4009903011119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89ba",
            "leftCorner": {
              "x": -31.687,
              "y": -19.065,
              "z": 1.011
            },
            "rightCorner": {
              "x": -31.837,
              "y": -19.121,
              "z": 1.011
            },
            "gtin": "5054563230119",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89bb",
            "leftCorner": {
              "x": -31.837,
              "y": -19.121,
              "z": 1.011
            },
            "rightCorner": {
              "x": -32.009,
              "y": -19.185,
              "z": 1.011
            },
            "gtin": "8700216623711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89bc",
            "leftCorner": {
              "x": -32.012,
              "y": -19.177,
              "z": 1.011
            },
            "rightCorner": {
              "x": -32.193,
              "y": -19.244,
              "z": 1.011
            },
            "gtin": "8700216623650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89bd",
            "leftCorner": {
              "x": -32.196,
              "y": -19.236,
              "z": 1.011
            },
            "rightCorner": {
              "x": -32.32,
              "y": -19.282,
              "z": 1.011
            },
            "gtin": "8700216623711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89b8",
            "leftCorner": {
              "x": -32.32,
              "y": -19.282,
              "z": 1.011
            },
            "rightCorner": {
              "x": -32.486,
              "y": -19.344,
              "z": 1.011
            },
            "gtin": "4009932002171",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d789",
        "height": 1.512,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d89ae",
            "leftCorner": {
              "x": -31.327,
              "y": -18.874,
              "z": 1.237
            },
            "rightCorner": {
              "x": -31.52,
              "y": -18.947,
              "z": 1.237
            },
            "gtin": "4260457770710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89b0",
            "leftCorner": {
              "x": -31.505,
              "y": -18.985,
              "z": 1.237
            },
            "rightCorner": {
              "x": -31.584,
              "y": -19.014,
              "z": 1.237
            },
            "gtin": "4008890008928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89b1",
            "leftCorner": {
              "x": -31.584,
              "y": -19.014,
              "z": 1.237
            },
            "rightCorner": {
              "x": -31.768,
              "y": -19.082,
              "z": 1.237
            },
            "gtin": "4045612007500",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89b2",
            "leftCorner": {
              "x": -31.766,
              "y": -19.088,
              "z": 1.237
            },
            "rightCorner": {
              "x": -31.847,
              "y": -19.118,
              "z": 1.237
            },
            "gtin": "4002448014287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89b3",
            "leftCorner": {
              "x": -31.847,
              "y": -19.119,
              "z": 1.237
            },
            "rightCorner": {
              "x": -31.947,
              "y": -19.157,
              "z": 1.237
            },
            "gtin": "4026600851503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89b4",
            "leftCorner": {
              "x": -31.949,
              "y": -19.151,
              "z": 1.237
            },
            "rightCorner": {
              "x": -32.055,
              "y": -19.191,
              "z": 1.237
            },
            "gtin": "5054563091970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89b5",
            "leftCorner": {
              "x": -32.057,
              "y": -19.187,
              "z": 1.237
            },
            "rightCorner": {
              "x": -32.294,
              "y": -19.276,
              "z": 1.237
            },
            "gtin": "4002448213536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89b6",
            "leftCorner": {
              "x": -32.298,
              "y": -19.264,
              "z": 1.237
            },
            "rightCorner": {
              "x": -32.38,
              "y": -19.295,
              "z": 1.237
            },
            "gtin": "4002448038900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89af",
            "leftCorner": {
              "x": -32.378,
              "y": -19.297,
              "z": 1.237
            },
            "rightCorner": {
              "x": -32.488,
              "y": -19.338,
              "z": 1.237
            },
            "gtin": "4002448039105",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c32"
  },
  {
    "id": "c34",
    "name": "c34",
    "x": -33.105,
    "y": -19.294,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.56869,
      "w": 0.82255
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 70
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d795",
        "height": 0.24175,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a1b",
            "leftCorner": {
              "x": -32.878,
              "y": -19.646,
              "z": 0.198
            },
            "rightCorner": {
              "x": -32.827,
              "y": -19.782,
              "z": 0.198
            },
            "gtin": "3600541043015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a1c",
            "leftCorner": {
              "x": -32.824,
              "y": -19.781,
              "z": 0.198
            },
            "rightCorner": {
              "x": -32.789,
              "y": -19.872,
              "z": 0.198
            },
            "gtin": "4002441020056",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a1d",
            "leftCorner": {
              "x": -32.783,
              "y": -19.87,
              "z": 0.198
            },
            "rightCorner": {
              "x": -32.757,
              "y": -19.94,
              "z": 0.198
            },
            "gtin": "4015100816068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a1e",
            "leftCorner": {
              "x": -32.762,
              "y": -19.941,
              "z": 0.198
            },
            "rightCorner": {
              "x": -32.739,
              "y": -20.001,
              "z": 0.198
            },
            "gtin": "4015100816167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a1f",
            "leftCorner": {
              "x": -32.746,
              "y": -20.003,
              "z": 0.198
            },
            "rightCorner": {
              "x": -32.715,
              "y": -20.084,
              "z": 0.198
            },
            "gtin": "4015100816204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a20",
            "leftCorner": {
              "x": -32.715,
              "y": -20.084,
              "z": 0.198
            },
            "rightCorner": {
              "x": -32.685,
              "y": -20.166,
              "z": 0.198
            },
            "gtin": "4015100815887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a21",
            "leftCorner": {
              "x": -32.68,
              "y": -20.164,
              "z": 0.198
            },
            "rightCorner": {
              "x": -32.648,
              "y": -20.25,
              "z": 0.198
            },
            "gtin": "4015100815900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a22",
            "leftCorner": {
              "x": -32.648,
              "y": -20.249,
              "z": 0.198
            },
            "rightCorner": {
              "x": -32.612,
              "y": -20.345,
              "z": 0.198
            },
            "gtin": "4015100816327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a19",
            "leftCorner": {
              "x": -32.609,
              "y": -20.344,
              "z": 0.198
            },
            "rightCorner": {
              "x": -32.577,
              "y": -20.43,
              "z": 0.198
            },
            "gtin": "4015100816129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6fce43d5e7f72058275bb235",
            "leftCorner": {
              "x": -33.057,
              "y": -19.275,
              "z": 0.198
            },
            "rightCorner": {
              "x": -33.005,
              "y": -19.413,
              "z": 0.198
            },
            "gtin": "3600540244901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "199946c8138dba521f588377",
            "leftCorner": {
              "x": -33.005,
              "y": -19.413,
              "z": 0.198
            },
            "rightCorner": {
              "x": -32.953,
              "y": -19.552,
              "z": 0.198
            },
            "gtin": "3600540244901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "85f509eaccfac070011f0b67",
            "leftCorner": {
              "x": -32.953,
              "y": -19.552,
              "z": 0.198
            },
            "rightCorner": {
              "x": -32.913,
              "y": -19.658,
              "z": 0.198
            },
            "gtin": "3600541043015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d791",
        "height": 0.52992,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d89e9",
            "leftCorner": {
              "x": -33.018,
              "y": -19.261,
              "z": 0.434
            },
            "rightCorner": {
              "x": -32.944,
              "y": -19.459,
              "z": 0.434
            },
            "gtin": "4002441020193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89ea",
            "leftCorner": {
              "x": -32.916,
              "y": -19.448,
              "z": 0.434
            },
            "rightCorner": {
              "x": -32.877,
              "y": -19.551,
              "z": 0.434
            },
            "gtin": "3600541901759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89eb",
            "leftCorner": {
              "x": -32.872,
              "y": -19.549,
              "z": 0.434
            },
            "rightCorner": {
              "x": -32.832,
              "y": -19.657,
              "z": 0.434
            },
            "gtin": "4002441020278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89ec",
            "leftCorner": {
              "x": -32.832,
              "y": -19.657,
              "z": 0.434
            },
            "rightCorner": {
              "x": -32.783,
              "y": -19.786,
              "z": 0.434
            },
            "gtin": "3600541900141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89ed",
            "leftCorner": {
              "x": -32.777,
              "y": -19.784,
              "z": 0.434
            },
            "rightCorner": {
              "x": -32.735,
              "y": -19.897,
              "z": 0.434
            },
            "gtin": "4002441020292",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89ee",
            "leftCorner": {
              "x": -32.728,
              "y": -19.893,
              "z": 0.434
            },
            "rightCorner": {
              "x": -32.711,
              "y": -19.937,
              "z": 0.434
            },
            "gtin": "4015100815849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89ef",
            "leftCorner": {
              "x": -32.719,
              "y": -19.94,
              "z": 0.434
            },
            "rightCorner": {
              "x": -32.699,
              "y": -19.994,
              "z": 0.434
            },
            "gtin": "4015100816105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89f0",
            "leftCorner": {
              "x": -32.701,
              "y": -19.995,
              "z": 0.434
            },
            "rightCorner": {
              "x": -32.67,
              "y": -20.077,
              "z": 0.434
            },
            "gtin": "4015100816242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89f1",
            "leftCorner": {
              "x": -32.67,
              "y": -20.077,
              "z": 0.434
            },
            "rightCorner": {
              "x": -32.637,
              "y": -20.164,
              "z": 0.434
            },
            "gtin": "4015100815825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89f2",
            "leftCorner": {
              "x": -32.635,
              "y": -20.163,
              "z": 0.434
            },
            "rightCorner": {
              "x": -32.603,
              "y": -20.249,
              "z": 0.434
            },
            "gtin": "4015100816280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89f3",
            "leftCorner": {
              "x": -32.602,
              "y": -20.249,
              "z": 0.434
            },
            "rightCorner": {
              "x": -32.563,
              "y": -20.349,
              "z": 0.434
            },
            "gtin": "4015100816501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89f4",
            "leftCorner": {
              "x": -32.563,
              "y": -20.349,
              "z": 0.434
            },
            "rightCorner": {
              "x": -32.535,
              "y": -20.422,
              "z": 0.434
            },
            "gtin": "4015100816181",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d794",
        "height": 0.77808,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a0d",
            "leftCorner": {
              "x": -33.017,
              "y": -19.261,
              "z": 0.637
            },
            "rightCorner": {
              "x": -32.943,
              "y": -19.46,
              "z": 0.637
            },
            "gtin": "3600523714490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a0e",
            "leftCorner": {
              "x": -32.908,
              "y": -19.447,
              "z": 0.637
            },
            "rightCorner": {
              "x": -32.86,
              "y": -19.575,
              "z": 0.637
            },
            "gtin": "3600523714476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a0f",
            "leftCorner": {
              "x": -32.858,
              "y": -19.574,
              "z": 0.637
            },
            "rightCorner": {
              "x": -32.82,
              "y": -19.674,
              "z": 0.637
            },
            "gtin": "3600523714544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a10",
            "leftCorner": {
              "x": -32.821,
              "y": -19.674,
              "z": 0.637
            },
            "rightCorner": {
              "x": -32.773,
              "y": -19.802,
              "z": 0.637
            },
            "gtin": "4015100311174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a11",
            "leftCorner": {
              "x": -32.765,
              "y": -19.8,
              "z": 0.637
            },
            "rightCorner": {
              "x": -32.727,
              "y": -19.9,
              "z": 0.637
            },
            "gtin": "4015100339895",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a12",
            "leftCorner": {
              "x": -32.726,
              "y": -19.9,
              "z": 0.637
            },
            "rightCorner": {
              "x": -32.706,
              "y": -19.952,
              "z": 0.637
            },
            "gtin": "4015100311150",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a13",
            "leftCorner": {
              "x": -32.707,
              "y": -19.974,
              "z": 0.637
            },
            "rightCorner": {
              "x": -32.679,
              "y": -20.048,
              "z": 0.637
            },
            "gtin": "4015100817805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a14",
            "leftCorner": {
              "x": -32.68,
              "y": -20.048,
              "z": 0.637
            },
            "rightCorner": {
              "x": -32.656,
              "y": -20.11,
              "z": 0.637
            },
            "gtin": "4015100324068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a15",
            "leftCorner": {
              "x": -32.658,
              "y": -20.111,
              "z": 0.637
            },
            "rightCorner": {
              "x": -32.626,
              "y": -20.197,
              "z": 0.637
            },
            "gtin": "4015100817782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a16",
            "leftCorner": {
              "x": -32.621,
              "y": -20.195,
              "z": 0.637
            },
            "rightCorner": {
              "x": -32.579,
              "y": -20.305,
              "z": 0.637
            },
            "gtin": "4015000529136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a17",
            "leftCorner": {
              "x": -32.58,
              "y": -20.306,
              "z": 0.637
            },
            "rightCorner": {
              "x": -32.546,
              "y": -20.393,
              "z": 0.637
            },
            "gtin": "4015000529150",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d793",
        "height": 1.0048,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a01",
            "leftCorner": {
              "x": -33.005,
              "y": -19.256,
              "z": 0.822
            },
            "rightCorner": {
              "x": -32.949,
              "y": -19.405,
              "z": 0.822
            },
            "gtin": "3600523738106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a02",
            "leftCorner": {
              "x": -32.912,
              "y": -19.391,
              "z": 0.822
            },
            "rightCorner": {
              "x": -32.878,
              "y": -19.48,
              "z": 0.822
            },
            "gtin": "3600523941162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a03",
            "leftCorner": {
              "x": -32.881,
              "y": -19.481,
              "z": 0.822
            },
            "rightCorner": {
              "x": -32.837,
              "y": -19.596,
              "z": 0.822
            },
            "gtin": "3600523714414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a04",
            "leftCorner": {
              "x": -32.836,
              "y": -19.596,
              "z": 0.822
            },
            "rightCorner": {
              "x": -32.79,
              "y": -19.719,
              "z": 0.822
            },
            "gtin": "3600523714407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a05",
            "leftCorner": {
              "x": -32.79,
              "y": -19.719,
              "z": 0.822
            },
            "rightCorner": {
              "x": -32.745,
              "y": -19.838,
              "z": 0.822
            },
            "gtin": "4015100310917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a06",
            "leftCorner": {
              "x": -32.733,
              "y": -19.832,
              "z": 0.822
            },
            "rightCorner": {
              "x": -32.698,
              "y": -19.925,
              "z": 0.822
            },
            "gtin": "4015100311136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a07",
            "leftCorner": {
              "x": -32.7,
              "y": -19.951,
              "z": 0.822
            },
            "rightCorner": {
              "x": -32.671,
              "y": -20.028,
              "z": 0.822
            },
            "gtin": "4015100817669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a08",
            "leftCorner": {
              "x": -32.674,
              "y": -20.029,
              "z": 0.822
            },
            "rightCorner": {
              "x": -32.646,
              "y": -20.102,
              "z": 0.822
            },
            "gtin": "4015100817645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a09",
            "leftCorner": {
              "x": -32.646,
              "y": -20.102,
              "z": 0.822
            },
            "rightCorner": {
              "x": -32.623,
              "y": -20.163,
              "z": 0.822
            },
            "gtin": "4015100817423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a0a",
            "leftCorner": {
              "x": -32.622,
              "y": -20.163,
              "z": 0.822
            },
            "rightCorner": {
              "x": -32.596,
              "y": -20.23,
              "z": 0.822
            },
            "gtin": "4015100323986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a0b",
            "leftCorner": {
              "x": -32.594,
              "y": -20.23,
              "z": 0.822
            },
            "rightCorner": {
              "x": -32.556,
              "y": -20.328,
              "z": 0.822
            },
            "gtin": "4015100817522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a0c",
            "leftCorner": {
              "x": -32.557,
              "y": -20.328,
              "z": 0.822
            },
            "rightCorner": {
              "x": -32.529,
              "y": -20.401,
              "z": 0.822
            },
            "gtin": "4015100816341",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d792",
        "height": 1.2332,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d89f5",
            "leftCorner": {
              "x": -33.002,
              "y": -19.254,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.936,
              "y": -19.429,
              "z": 1.009
            },
            "gtin": "3600541250604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89f6",
            "leftCorner": {
              "x": -32.902,
              "y": -19.417,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.865,
              "y": -19.515,
              "z": 1.009
            },
            "gtin": "3600542222693",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89f7",
            "leftCorner": {
              "x": -32.867,
              "y": -19.516,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.818,
              "y": -19.646,
              "z": 1.009
            },
            "gtin": "3600541250406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89f8",
            "leftCorner": {
              "x": -32.818,
              "y": -19.646,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.764,
              "y": -19.787,
              "z": 1.009
            },
            "gtin": "3600541250253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89f9",
            "leftCorner": {
              "x": -32.756,
              "y": -19.784,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.724,
              "y": -19.866,
              "z": 1.009
            },
            "gtin": "3600541250154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89fa",
            "leftCorner": {
              "x": -32.724,
              "y": -19.866,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.705,
              "y": -19.919,
              "z": 1.009
            },
            "gtin": "4015100802948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89fb",
            "leftCorner": {
              "x": -32.7,
              "y": -19.917,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.678,
              "y": -19.975,
              "z": 1.009
            },
            "gtin": "4015100432336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89fc",
            "leftCorner": {
              "x": -32.689,
              "y": -19.979,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.657,
              "y": -20.061,
              "z": 1.009
            },
            "gtin": "4015100441512",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89fd",
            "leftCorner": {
              "x": -32.661,
              "y": -20.063,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.63,
              "y": -20.147,
              "z": 1.009
            },
            "gtin": "4015100441697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89fe",
            "leftCorner": {
              "x": -32.626,
              "y": -20.145,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.594,
              "y": -20.229,
              "z": 1.009
            },
            "gtin": "4015100441659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89ff",
            "leftCorner": {
              "x": -32.591,
              "y": -20.228,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.552,
              "y": -20.332,
              "z": 1.009
            },
            "gtin": "4015100441710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a00",
            "leftCorner": {
              "x": -32.555,
              "y": -20.333,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.526,
              "y": -20.412,
              "z": 1.009
            },
            "gtin": "4015100441673",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d790",
        "height": 1.4837,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d89de",
            "leftCorner": {
              "x": -33.012,
              "y": -19.259,
              "z": 1.214
            },
            "rightCorner": {
              "x": -32.951,
              "y": -19.418,
              "z": 1.214
            },
            "gtin": "3600541251007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89e0",
            "leftCorner": {
              "x": -32.918,
              "y": -19.406,
              "z": 1.214
            },
            "rightCorner": {
              "x": -32.878,
              "y": -19.514,
              "z": 1.214
            },
            "gtin": "3600541910812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89e1",
            "leftCorner": {
              "x": -32.879,
              "y": -19.514,
              "z": 1.214
            },
            "rightCorner": {
              "x": -32.839,
              "y": -19.619,
              "z": 1.214
            },
            "gtin": "3600541251052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89e2",
            "leftCorner": {
              "x": -32.836,
              "y": -19.618,
              "z": 1.214
            },
            "rightCorner": {
              "x": -32.787,
              "y": -19.748,
              "z": 1.214
            },
            "gtin": "3600541250857",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89e3",
            "leftCorner": {
              "x": -32.785,
              "y": -19.747,
              "z": 1.214
            },
            "rightCorner": {
              "x": -32.749,
              "y": -19.845,
              "z": 1.214
            },
            "gtin": "3600541250703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89e4",
            "leftCorner": {
              "x": -32.743,
              "y": -19.843,
              "z": 1.214
            },
            "rightCorner": {
              "x": -32.707,
              "y": -19.936,
              "z": 1.214
            },
            "gtin": "3600541250505",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89e5",
            "leftCorner": {
              "x": -32.705,
              "y": -19.935,
              "z": 1.214
            },
            "rightCorner": {
              "x": -32.66,
              "y": -20.055,
              "z": 1.214
            },
            "gtin": "4015100441321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89e6",
            "leftCorner": {
              "x": -32.666,
              "y": -20.057,
              "z": 1.214
            },
            "rightCorner": {
              "x": -32.632,
              "y": -20.146,
              "z": 1.214
            },
            "gtin": "4015100441369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89e7",
            "leftCorner": {
              "x": -32.636,
              "y": -20.147,
              "z": 1.214
            },
            "rightCorner": {
              "x": -32.602,
              "y": -20.24,
              "z": 1.214
            },
            "gtin": "4015100441475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89e8",
            "leftCorner": {
              "x": -32.597,
              "y": -20.237,
              "z": 1.214
            },
            "rightCorner": {
              "x": -32.56,
              "y": -20.335,
              "z": 1.214
            },
            "gtin": "4015100441499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d89df",
            "leftCorner": {
              "x": -32.564,
              "y": -20.336,
              "z": 1.214
            },
            "rightCorner": {
              "x": -32.535,
              "y": -20.415,
              "z": 1.214
            },
            "gtin": "4015100811933",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "c35",
    "name": "c35",
    "x": -33.376,
    "y": -17.736,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.19373,
      "w": 0.98106
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 82
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d408",
        "height": 0.16716,
        "facings": [
          {
            "id": "23b463f0aeca9f1af0cfd1cf",
            "leftCorner": {
              "x": -33.346,
              "y": -17.809,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.306,
              "y": -17.793,
              "z": 0.137
            },
            "gtin": "4104260286108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "52fc85aac7372c69b248acf4",
            "leftCorner": {
              "x": -33.306,
              "y": -17.793,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.284,
              "y": -17.784,
              "z": 0.137
            },
            "gtin": "4006000080925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "deba831048ba16373ed10667",
            "leftCorner": {
              "x": -33.284,
              "y": -17.784,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.243,
              "y": -17.767,
              "z": 0.137
            },
            "gtin": "4104260286108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f76a438d5603e77e3ee9c588",
            "leftCorner": {
              "x": -33.243,
              "y": -17.767,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.201,
              "y": -17.75,
              "z": 0.137
            },
            "gtin": "3600524071004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0b2b1ac175005ba7d89522d6",
            "leftCorner": {
              "x": -33.201,
              "y": -17.75,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.154,
              "y": -17.73,
              "z": 0.137
            },
            "gtin": "4027800439935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7696138400fbb553e8fb19ae",
            "leftCorner": {
              "x": -33.154,
              "y": -17.73,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.105,
              "y": -17.71,
              "z": 0.137
            },
            "gtin": "4006000072685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8dffde7eb09b4601efad5a97",
            "leftCorner": {
              "x": -33.105,
              "y": -17.71,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.055,
              "y": -17.689,
              "z": 0.137
            },
            "gtin": "5060144647788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6150bbbd2c527304fc584d3f",
            "leftCorner": {
              "x": -33.055,
              "y": -17.689,
              "z": 0.137
            },
            "rightCorner": {
              "x": -33.003,
              "y": -17.668,
              "z": 0.137
            },
            "gtin": "4005900778796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cd77f6b34177c998f2aeed5b",
            "leftCorner": {
              "x": -33.003,
              "y": -17.668,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.942,
              "y": -17.643,
              "z": 0.137
            },
            "gtin": "4104260280069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "81826f5944dc47d1dfe18bb7",
            "leftCorner": {
              "x": -32.942,
              "y": -17.643,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.876,
              "y": -17.616,
              "z": 0.137
            },
            "gtin": "4002448203001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e3f142674c80ae2844f70624",
            "leftCorner": {
              "x": -32.876,
              "y": -17.616,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.807,
              "y": -17.587,
              "z": 0.137
            },
            "gtin": "4002448101185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6554b8b3d92fa6e00902e58b",
            "leftCorner": {
              "x": -32.807,
              "y": -17.587,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.73,
              "y": -17.556,
              "z": 0.137
            },
            "gtin": "4005900107305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dde58c658e15e6a4d097cd25",
            "leftCorner": {
              "x": -32.73,
              "y": -17.556,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.649,
              "y": -17.523,
              "z": 0.137
            },
            "gtin": "7702018401055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bc4b022767a87c4ea8809d32",
            "leftCorner": {
              "x": -32.649,
              "y": -17.523,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.567,
              "y": -17.489,
              "z": 0.137
            },
            "gtin": "8700216187497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "482ad918c79a587b05e270e6",
            "leftCorner": {
              "x": -32.567,
              "y": -17.489,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.484,
              "y": -17.455,
              "z": 0.137
            },
            "gtin": "4002448090656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2369a202689a4eaf36fb6ef3",
            "leftCorner": {
              "x": -32.484,
              "y": -17.455,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.398,
              "y": -17.42,
              "z": 0.137
            },
            "gtin": "8001090598455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1791ca13a7941b27ea69cefc",
            "leftCorner": {
              "x": -32.398,
              "y": -17.42,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.253,
              "y": -17.36,
              "z": 0.137
            },
            "gtin": "8001090594730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b4509fc27b539af140406247",
            "leftCorner": {
              "x": -32.253,
              "y": -17.36,
              "z": 0.137
            },
            "rightCorner": {
              "x": -32.192,
              "y": -17.335,
              "z": 0.137
            },
            "gtin": "4104260280069",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d403",
        "height": 0.48926,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7566",
            "leftCorner": {
              "x": -33.356,
              "y": -17.785,
              "z": 0.4
            },
            "rightCorner": {
              "x": -33.317,
              "y": -17.769,
              "z": 0.4
            },
            "gtin": "8006540768914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7567",
            "leftCorner": {
              "x": -33.317,
              "y": -17.769,
              "z": 0.4
            },
            "rightCorner": {
              "x": -33.278,
              "y": -17.753,
              "z": 0.4
            },
            "gtin": "8006540768914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7568",
            "leftCorner": {
              "x": -33.278,
              "y": -17.753,
              "z": 0.4
            },
            "rightCorner": {
              "x": -33.239,
              "y": -17.737,
              "z": 0.4
            },
            "gtin": "8006540768914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d756a",
            "leftCorner": {
              "x": -33.252,
              "y": -17.705,
              "z": 0.4
            },
            "rightCorner": {
              "x": -33.146,
              "y": -17.662,
              "z": 0.4
            },
            "gtin": "8006540768808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d756b",
            "leftCorner": {
              "x": -33.149,
              "y": -17.654,
              "z": 0.4
            },
            "rightCorner": {
              "x": -33.036,
              "y": -17.608,
              "z": 0.4
            },
            "gtin": "7702018621293",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d756c",
            "leftCorner": {
              "x": -33.035,
              "y": -17.61,
              "z": 0.4
            },
            "rightCorner": {
              "x": -32.973,
              "y": -17.584,
              "z": 0.4
            },
            "gtin": "8714789849164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d756d",
            "leftCorner": {
              "x": -32.973,
              "y": -17.584,
              "z": 0.4
            },
            "rightCorner": {
              "x": -32.91,
              "y": -17.558,
              "z": 0.4
            },
            "gtin": "8714789849164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d756e",
            "leftCorner": {
              "x": -32.909,
              "y": -17.562,
              "z": 0.4
            },
            "rightCorner": {
              "x": -32.814,
              "y": -17.523,
              "z": 0.4
            },
            "gtin": "4006000169019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d756f",
            "leftCorner": {
              "x": -32.816,
              "y": -17.518,
              "z": 0.4
            },
            "rightCorner": {
              "x": -32.709,
              "y": -17.474,
              "z": 0.4
            },
            "gtin": "4006000170091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7570",
            "leftCorner": {
              "x": -32.71,
              "y": -17.47,
              "z": 0.4
            },
            "rightCorner": {
              "x": -32.663,
              "y": -17.45,
              "z": 0.4
            },
            "gtin": "5060144647788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7571",
            "leftCorner": {
              "x": -32.663,
              "y": -17.451,
              "z": 0.4
            },
            "rightCorner": {
              "x": -32.552,
              "y": -17.407,
              "z": 0.4
            },
            "gtin": "7702018603947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7572",
            "leftCorner": {
              "x": -32.55,
              "y": -17.411,
              "z": 0.4
            },
            "rightCorner": {
              "x": -32.455,
              "y": -17.371,
              "z": 0.4
            },
            "gtin": "7702018622016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7573",
            "leftCorner": {
              "x": -32.455,
              "y": -17.372,
              "z": 0.4
            },
            "rightCorner": {
              "x": -32.358,
              "y": -17.333,
              "z": 0.4
            },
            "gtin": "7702018620371",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7574",
            "leftCorner": {
              "x": -32.356,
              "y": -17.339,
              "z": 0.4
            },
            "rightCorner": {
              "x": -32.252,
              "y": -17.296,
              "z": 0.4
            },
            "gtin": "7702018621255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7575",
            "leftCorner": {
              "x": -32.252,
              "y": -17.295,
              "z": 0.4
            },
            "rightCorner": {
              "x": -32.184,
              "y": -17.267,
              "z": 0.4
            },
            "gtin": "4005900918628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7576",
            "leftCorner": {
              "x": -32.184,
              "y": -17.267,
              "z": 0.4
            },
            "rightCorner": {
              "x": -32.115,
              "y": -17.238,
              "z": 0.4
            },
            "gtin": "4005900918628",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d407",
        "height": 0.76455,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d75cf",
            "leftCorner": {
              "x": -33.338,
              "y": -17.749,
              "z": 0.626
            },
            "rightCorner": {
              "x": -33.296,
              "y": -17.732,
              "z": 0.626
            },
            "gtin": "4104260286122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d6af52ca587ed27cf9b53277",
            "leftCorner": {
              "x": -33.356,
              "y": -17.784,
              "z": 0.626
            },
            "rightCorner": {
              "x": -33.334,
              "y": -17.775,
              "z": 0.626
            },
            "gtin": "4006000080925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75d0",
            "leftCorner": {
              "x": -33.3,
              "y": -17.725,
              "z": 0.626
            },
            "rightCorner": {
              "x": -33.24,
              "y": -17.702,
              "z": 0.626
            },
            "gtin": "4104260280069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75d1",
            "leftCorner": {
              "x": -33.241,
              "y": -17.7,
              "z": 0.626
            },
            "rightCorner": {
              "x": -33.175,
              "y": -17.672,
              "z": 0.626
            },
            "gtin": "4002448101185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75d2",
            "leftCorner": {
              "x": -33.175,
              "y": -17.669,
              "z": 0.626
            },
            "rightCorner": {
              "x": -33.111,
              "y": -17.643,
              "z": 0.626
            },
            "gtin": "4002448203001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75d3",
            "leftCorner": {
              "x": -33.114,
              "y": -17.638,
              "z": 0.626
            },
            "rightCorner": {
              "x": -33.03,
              "y": -17.603,
              "z": 0.626
            },
            "gtin": "4002448101123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75d4",
            "leftCorner": {
              "x": -33.033,
              "y": -17.597,
              "z": 0.626
            },
            "rightCorner": {
              "x": -32.942,
              "y": -17.559,
              "z": 0.626
            },
            "gtin": "4002448090656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75d5",
            "leftCorner": {
              "x": -32.937,
              "y": -17.57,
              "z": 0.626
            },
            "rightCorner": {
              "x": -32.878,
              "y": -17.545,
              "z": 0.626
            },
            "gtin": "8002340018266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75d6",
            "leftCorner": {
              "x": -32.878,
              "y": -17.545,
              "z": 0.626
            },
            "rightCorner": {
              "x": -32.819,
              "y": -17.521,
              "z": 0.626
            },
            "gtin": "8002340018266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75d7",
            "leftCorner": {
              "x": -32.819,
              "y": -17.519,
              "z": 0.626
            },
            "rightCorner": {
              "x": -32.772,
              "y": -17.5,
              "z": 0.626
            },
            "gtin": "3600524071004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75d8",
            "leftCorner": {
              "x": -32.775,
              "y": -17.493,
              "z": 0.626
            },
            "rightCorner": {
              "x": -32.641,
              "y": -17.439,
              "z": 0.626
            },
            "gtin": "3600524070762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75d9",
            "leftCorner": {
              "x": -32.637,
              "y": -17.446,
              "z": 0.626
            },
            "rightCorner": {
              "x": -32.528,
              "y": -17.4,
              "z": 0.626
            },
            "gtin": "3600523979233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75da",
            "leftCorner": {
              "x": -32.527,
              "y": -17.403,
              "z": 0.626
            },
            "rightCorner": {
              "x": -32.458,
              "y": -17.374,
              "z": 0.626
            },
            "gtin": "4005900107305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75db",
            "leftCorner": {
              "x": -32.459,
              "y": -17.371,
              "z": 0.626
            },
            "rightCorner": {
              "x": -32.405,
              "y": -17.348,
              "z": 0.626
            },
            "gtin": "4005900778796",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75dc",
            "leftCorner": {
              "x": -32.403,
              "y": -17.354,
              "z": 0.626
            },
            "rightCorner": {
              "x": -32.353,
              "y": -17.333,
              "z": 0.626
            },
            "gtin": "4006000072685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75dd",
            "leftCorner": {
              "x": -32.351,
              "y": -17.338,
              "z": 0.626
            },
            "rightCorner": {
              "x": -32.289,
              "y": -17.312,
              "z": 0.626
            },
            "gtin": "4005900877932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75de",
            "leftCorner": {
              "x": -32.289,
              "y": -17.312,
              "z": 0.626
            },
            "rightCorner": {
              "x": -32.228,
              "y": -17.287,
              "z": 0.626
            },
            "gtin": "4005900877932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75df",
            "leftCorner": {
              "x": -32.23,
              "y": -17.283,
              "z": 0.626
            },
            "rightCorner": {
              "x": -32.189,
              "y": -17.266,
              "z": 0.626
            },
            "gtin": "4006000080925",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d406",
        "height": 1.2291,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d75b4",
            "leftCorner": {
              "x": -33.471,
              "y": -17.504,
              "z": 1.006
            },
            "rightCorner": {
              "x": -33.319,
              "y": -17.442,
              "z": 1.006
            },
            "gtin": "4027800114702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75b6",
            "leftCorner": {
              "x": -33.343,
              "y": -17.384,
              "z": 1.006
            },
            "rightCorner": {
              "x": -33.137,
              "y": -17.299,
              "z": 1.006
            },
            "gtin": "4027800967018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75b7",
            "leftCorner": {
              "x": -33.081,
              "y": -17.438,
              "z": 1.006
            },
            "rightCorner": {
              "x": -32.859,
              "y": -17.347,
              "z": 1.006
            },
            "gtin": "4027800407002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75b8",
            "leftCorner": {
              "x": -32.914,
              "y": -17.215,
              "z": 1.006
            },
            "rightCorner": {
              "x": -32.801,
              "y": -17.167,
              "z": 1.006
            },
            "gtin": "4027800081158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75b9",
            "leftCorner": {
              "x": -32.741,
              "y": -17.314,
              "z": 1.006
            },
            "rightCorner": {
              "x": -32.589,
              "y": -17.253,
              "z": 1.006
            },
            "gtin": "8001090594730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75ba",
            "leftCorner": {
              "x": -32.64,
              "y": -17.129,
              "z": 1.006
            },
            "rightCorner": {
              "x": -32.533,
              "y": -17.086,
              "z": 1.006
            },
            "gtin": "8001090599049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75bb",
            "leftCorner": {
              "x": -32.541,
              "y": -17.069,
              "z": 1.006
            },
            "rightCorner": {
              "x": -32.392,
              "y": -17.008,
              "z": 1.006
            },
            "gtin": "4027800020157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75bc",
            "leftCorner": {
              "x": -32.392,
              "y": -17.008,
              "z": 1.006
            },
            "rightCorner": {
              "x": -32.3,
              "y": -16.97,
              "z": 1.006
            },
            "gtin": "4027800402502",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d405",
        "height": 1.4296,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d759f",
            "leftCorner": {
              "x": -33.433,
              "y": -17.598,
              "z": 1.17
            },
            "rightCorner": {
              "x": -33.291,
              "y": -17.54,
              "z": 1.17
            },
            "gtin": "4027800114306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75a1",
            "leftCorner": {
              "x": -33.306,
              "y": -17.503,
              "z": 1.17
            },
            "rightCorner": {
              "x": -33.199,
              "y": -17.46,
              "z": 1.17
            },
            "gtin": "4027800968015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75a2",
            "leftCorner": {
              "x": -33.19,
              "y": -17.479,
              "z": 1.17
            },
            "rightCorner": {
              "x": -33.054,
              "y": -17.423,
              "z": 1.17
            },
            "gtin": "4027800006434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75a3",
            "leftCorner": {
              "x": -33.067,
              "y": -17.391,
              "z": 1.17
            },
            "rightCorner": {
              "x": -32.971,
              "y": -17.352,
              "z": 1.17
            },
            "gtin": "4027800407101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75a4",
            "leftCorner": {
              "x": -32.964,
              "y": -17.368,
              "z": 1.17
            },
            "rightCorner": {
              "x": -32.855,
              "y": -17.323,
              "z": 1.17
            },
            "gtin": "8001090596734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75a5",
            "leftCorner": {
              "x": -32.867,
              "y": -17.295,
              "z": 1.17
            },
            "rightCorner": {
              "x": -32.77,
              "y": -17.255,
              "z": 1.17
            },
            "gtin": "8700216187497",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75a6",
            "leftCorner": {
              "x": -32.758,
              "y": -17.281,
              "z": 1.17
            },
            "rightCorner": {
              "x": -32.66,
              "y": -17.241,
              "z": 1.17
            },
            "gtin": "8001090594204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75a7",
            "leftCorner": {
              "x": -32.662,
              "y": -17.237,
              "z": 1.17
            },
            "rightCorner": {
              "x": -32.558,
              "y": -17.194,
              "z": 1.17
            },
            "gtin": "8001090596246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75a8",
            "leftCorner": {
              "x": -32.557,
              "y": -17.195,
              "z": 1.17
            },
            "rightCorner": {
              "x": -32.458,
              "y": -17.155,
              "z": 1.17
            },
            "gtin": "8001090598455",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75a9",
            "leftCorner": {
              "x": -32.456,
              "y": -17.161,
              "z": 1.17
            },
            "rightCorner": {
              "x": -32.374,
              "y": -17.127,
              "z": 1.17
            },
            "gtin": "5060144646361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75aa",
            "leftCorner": {
              "x": -32.352,
              "y": -17.178,
              "z": 1.17
            },
            "rightCorner": {
              "x": -32.147,
              "y": -17.093,
              "z": 1.17
            },
            "gtin": "4027800513109",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d404",
        "height": 1.6998,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d758c",
            "leftCorner": {
              "x": -33.284,
              "y": -17.567,
              "z": 1.391
            },
            "rightCorner": {
              "x": -33.165,
              "y": -17.519,
              "z": 1.391
            },
            "gtin": "4027800970018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e48425ad9b090ac04a85d3ad",
            "leftCorner": {
              "x": -33.415,
              "y": -17.641,
              "z": 1.391
            },
            "rightCorner": {
              "x": -33.287,
              "y": -17.589,
              "z": 1.391
            },
            "gtin": "7702018545827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d758d",
            "leftCorner": {
              "x": -33.175,
              "y": -17.494,
              "z": 1.391
            },
            "rightCorner": {
              "x": -33.064,
              "y": -17.448,
              "z": 1.391
            },
            "gtin": "4027800656103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d758e",
            "leftCorner": {
              "x": -33.074,
              "y": -17.425,
              "z": 1.391
            },
            "rightCorner": {
              "x": -32.961,
              "y": -17.378,
              "z": 1.391
            },
            "gtin": "4027800122509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d758f",
            "leftCorner": {
              "x": -32.953,
              "y": -17.397,
              "z": 1.391
            },
            "rightCorner": {
              "x": -32.849,
              "y": -17.355,
              "z": 1.391
            },
            "gtin": "7702018401055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7590",
            "leftCorner": {
              "x": -32.845,
              "y": -17.364,
              "z": 1.391
            },
            "rightCorner": {
              "x": -32.73,
              "y": -17.316,
              "z": 1.391
            },
            "gtin": "8700216187220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7591",
            "leftCorner": {
              "x": -32.731,
              "y": -17.315,
              "z": 1.391
            },
            "rightCorner": {
              "x": -32.629,
              "y": -17.273,
              "z": 1.391
            },
            "gtin": "3014260285425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7592",
            "leftCorner": {
              "x": -32.623,
              "y": -17.288,
              "z": 1.391
            },
            "rightCorner": {
              "x": -32.535,
              "y": -17.251,
              "z": 1.391
            },
            "gtin": "7702018583805",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7593",
            "leftCorner": {
              "x": -32.538,
              "y": -17.244,
              "z": 1.391
            },
            "rightCorner": {
              "x": -32.447,
              "y": -17.207,
              "z": 1.391
            },
            "gtin": "7702018322862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7594",
            "leftCorner": {
              "x": -32.447,
              "y": -17.206,
              "z": 1.391
            },
            "rightCorner": {
              "x": -32.306,
              "y": -17.148,
              "z": 1.391
            },
            "gtin": "7702018545827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7595",
            "leftCorner": {
              "x": -32.309,
              "y": -17.141,
              "z": 1.391
            },
            "rightCorner": {
              "x": -32.131,
              "y": -17.068,
              "z": 1.391
            },
            "gtin": "4027800439935",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "c9b"
  },
  {
    "id": "c3c",
    "name": "c3c",
    "x": -32.613,
    "y": -16.3,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.98513,
      "w": 0.17181
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 102
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d402",
        "height": 0.16512,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d74b8",
            "leftCorner": {
              "x": -33.485,
              "y": -16.576,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.548,
              "y": -16.598,
              "z": 0.135
            },
            "gtin": "3574661690544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74b9",
            "leftCorner": {
              "x": -33.549,
              "y": -16.595,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.615,
              "y": -16.619,
              "z": 0.135
            },
            "gtin": "3574661690513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74ba",
            "leftCorner": {
              "x": -33.616,
              "y": -16.619,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.656,
              "y": -16.633,
              "z": 0.135
            },
            "gtin": "3574661690537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74bb",
            "leftCorner": {
              "x": -33.655,
              "y": -16.637,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.68,
              "y": -16.645,
              "z": 0.135
            },
            "gtin": "3574661593050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74bc",
            "leftCorner": {
              "x": -33.685,
              "y": -16.633,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.724,
              "y": -16.648,
              "z": 0.135
            },
            "gtin": "3574661593050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74a6",
            "leftCorner": {
              "x": -33.725,
              "y": -16.645,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.807,
              "y": -16.673,
              "z": 0.135
            },
            "gtin": "3574661592916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "44559ed3bfcdd9f7a0f62e16",
            "leftCorner": {
              "x": -32.639,
              "y": -16.228,
              "z": 0.135
            },
            "rightCorner": {
              "x": -32.662,
              "y": -16.237,
              "z": 0.135
            },
            "gtin": "3574661593814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a58d6d5c4f233730f6e1f67f",
            "leftCorner": {
              "x": -32.662,
              "y": -16.237,
              "z": 0.135
            },
            "rightCorner": {
              "x": -32.823,
              "y": -16.294,
              "z": 0.135
            },
            "gtin": "3574661592916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "05c84c9ae176f059b73644f9",
            "leftCorner": {
              "x": -32.823,
              "y": -16.294,
              "z": 0.135
            },
            "rightCorner": {
              "x": -32.846,
              "y": -16.303,
              "z": 0.135
            },
            "gtin": "3574661593814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "17234a1b5efbb43f2615d84d",
            "leftCorner": {
              "x": -32.846,
              "y": -16.303,
              "z": 0.135
            },
            "rightCorner": {
              "x": -32.919,
              "y": -16.329,
              "z": 0.135
            },
            "gtin": "3574661690513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4978412e53da712e8df7b7fa",
            "leftCorner": {
              "x": -32.919,
              "y": -16.329,
              "z": 0.135
            },
            "rightCorner": {
              "x": -32.943,
              "y": -16.338,
              "z": 0.135
            },
            "gtin": "3574661593814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c070e89171142f6a093a27ae",
            "leftCorner": {
              "x": -32.943,
              "y": -16.338,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.003,
              "y": -16.359,
              "z": 0.135
            },
            "gtin": "3574661593050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6e66dd2c8d1cb1e4cba44612",
            "leftCorner": {
              "x": -33.003,
              "y": -16.359,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.076,
              "y": -16.386,
              "z": 0.135
            },
            "gtin": "3574661690513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1730ba53a9398e1aa3d687cc",
            "leftCorner": {
              "x": -33.076,
              "y": -16.386,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.1,
              "y": -16.394,
              "z": 0.135
            },
            "gtin": "3574661593814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0a2f023acc512120c0ea877f",
            "leftCorner": {
              "x": -33.1,
              "y": -16.394,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.161,
              "y": -16.416,
              "z": 0.135
            },
            "gtin": "3574661593050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b17c005f73c93d09a724061e",
            "leftCorner": {
              "x": -33.161,
              "y": -16.416,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.233,
              "y": -16.442,
              "z": 0.135
            },
            "gtin": "3574661690513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "81551bee2fb892e455474c99",
            "leftCorner": {
              "x": -33.233,
              "y": -16.442,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.306,
              "y": -16.468,
              "z": 0.135
            },
            "gtin": "3574661690513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1224a70101a3e262464326e6",
            "leftCorner": {
              "x": -33.306,
              "y": -16.468,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.367,
              "y": -16.49,
              "z": 0.135
            },
            "gtin": "3574661593050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1c22833e6b8f46f194493019",
            "leftCorner": {
              "x": -33.367,
              "y": -16.49,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.391,
              "y": -16.499,
              "z": 0.135
            },
            "gtin": "3574661593814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5db8d110641b9e5517a84963",
            "leftCorner": {
              "x": -33.391,
              "y": -16.499,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.463,
              "y": -16.525,
              "z": 0.135
            },
            "gtin": "3574661690513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "98563218afee7160535caaa7",
            "leftCorner": {
              "x": -33.463,
              "y": -16.525,
              "z": 0.135
            },
            "rightCorner": {
              "x": -33.487,
              "y": -16.533,
              "z": 0.135
            },
            "gtin": "3574661593814",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3fd",
        "height": 0.41959,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d74d6",
            "leftCorner": {
              "x": -32.583,
              "y": -16.291,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.726,
              "y": -16.344,
              "z": 0.343
            },
            "gtin": "3574661450902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74d7",
            "leftCorner": {
              "x": -32.684,
              "y": -16.322,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.715,
              "y": -16.333,
              "z": 0.343
            },
            "gtin": "3574661450902",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74d8",
            "leftCorner": {
              "x": -32.715,
              "y": -16.333,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.776,
              "y": -16.354,
              "z": 0.343
            },
            "gtin": "3574661320700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74d9",
            "leftCorner": {
              "x": -32.776,
              "y": -16.353,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.908,
              "y": -16.4,
              "z": 0.343
            },
            "gtin": "3574661554280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74da",
            "leftCorner": {
              "x": -32.906,
              "y": -16.408,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.035,
              "y": -16.454,
              "z": 0.343
            },
            "gtin": "3574661554297",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74db",
            "leftCorner": {
              "x": -33.03,
              "y": -16.471,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.083,
              "y": -16.49,
              "z": 0.343
            },
            "gtin": "3574661525556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74dc",
            "leftCorner": {
              "x": -33.09,
              "y": -16.471,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.192,
              "y": -16.508,
              "z": 0.343
            },
            "gtin": "3574661525556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74dd",
            "leftCorner": {
              "x": -33.192,
              "y": -16.51,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.245,
              "y": -16.53,
              "z": 0.343
            },
            "gtin": "3574661546544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74de",
            "leftCorner": {
              "x": -33.24,
              "y": -16.545,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.289,
              "y": -16.562,
              "z": 0.343
            },
            "gtin": "3574661332628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74df",
            "leftCorner": {
              "x": -33.287,
              "y": -16.566,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.336,
              "y": -16.584,
              "z": 0.343
            },
            "gtin": "3574661332574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74e0",
            "leftCorner": {
              "x": -33.339,
              "y": -16.576,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.397,
              "y": -16.596,
              "z": 0.343
            },
            "gtin": "3574661332574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74e1",
            "leftCorner": {
              "x": -33.398,
              "y": -16.592,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.452,
              "y": -16.611,
              "z": 0.343
            },
            "gtin": "3574661333625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74e2",
            "leftCorner": {
              "x": -33.451,
              "y": -16.613,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.505,
              "y": -16.633,
              "z": 0.343
            },
            "gtin": "3574661336640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74e3",
            "leftCorner": {
              "x": -33.499,
              "y": -16.65,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.56,
              "y": -16.672,
              "z": 0.343
            },
            "gtin": "3574661657387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74e4",
            "leftCorner": {
              "x": -33.564,
              "y": -16.661,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.624,
              "y": -16.683,
              "z": 0.343
            },
            "gtin": "3574661656083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74e5",
            "leftCorner": {
              "x": -33.626,
              "y": -16.677,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.667,
              "y": -16.691,
              "z": 0.343
            },
            "gtin": "3574661651675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74e6",
            "leftCorner": {
              "x": -33.667,
              "y": -16.689,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.707,
              "y": -16.703,
              "z": 0.343
            },
            "gtin": "3574661651699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74c5",
            "leftCorner": {
              "x": -33.705,
              "y": -16.708,
              "z": 0.343
            },
            "rightCorner": {
              "x": -33.785,
              "y": -16.737,
              "z": 0.343
            },
            "gtin": "3600541875630",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3fe",
        "height": 0.62669,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d74fc",
            "leftCorner": {
              "x": -32.739,
              "y": -16.338,
              "z": 0.513
            },
            "rightCorner": {
              "x": -32.803,
              "y": -16.361,
              "z": 0.513
            },
            "gtin": "4063528013620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74fd",
            "leftCorner": {
              "x": -32.804,
              "y": -16.358,
              "z": 0.513
            },
            "rightCorner": {
              "x": -32.854,
              "y": -16.377,
              "z": 0.513
            },
            "gtin": "3600542317016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74fe",
            "leftCorner": {
              "x": -32.852,
              "y": -16.381,
              "z": 0.513
            },
            "rightCorner": {
              "x": -32.947,
              "y": -16.415,
              "z": 0.513
            },
            "gtin": "3600542317016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74ff",
            "leftCorner": {
              "x": -32.947,
              "y": -16.415,
              "z": 0.513
            },
            "rightCorner": {
              "x": -33.041,
              "y": -16.448,
              "z": 0.513
            },
            "gtin": "3600542317016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7500",
            "leftCorner": {
              "x": -33.039,
              "y": -16.454,
              "z": 0.513
            },
            "rightCorner": {
              "x": -33.092,
              "y": -16.473,
              "z": 0.513
            },
            "gtin": "3600541744554",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7501",
            "leftCorner": {
              "x": -33.09,
              "y": -16.478,
              "z": 0.513
            },
            "rightCorner": {
              "x": -33.142,
              "y": -16.496,
              "z": 0.513
            },
            "gtin": "3600541594838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7502",
            "leftCorner": {
              "x": -33.143,
              "y": -16.494,
              "z": 0.513
            },
            "rightCorner": {
              "x": -33.211,
              "y": -16.519,
              "z": 0.513
            },
            "gtin": "3600541594838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7503",
            "leftCorner": {
              "x": -33.209,
              "y": -16.525,
              "z": 0.513
            },
            "rightCorner": {
              "x": -33.289,
              "y": -16.553,
              "z": 0.513
            },
            "gtin": "3600542048477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7504",
            "leftCorner": {
              "x": -33.29,
              "y": -16.551,
              "z": 0.513
            },
            "rightCorner": {
              "x": -33.349,
              "y": -16.573,
              "z": 0.513
            },
            "gtin": "4084200772901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7505",
            "leftCorner": {
              "x": -33.348,
              "y": -16.578,
              "z": 0.513
            },
            "rightCorner": {
              "x": -33.39,
              "y": -16.593,
              "z": 0.513
            },
            "gtin": "4084200771904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7506",
            "leftCorner": {
              "x": -33.39,
              "y": -16.593,
              "z": 0.513
            },
            "rightCorner": {
              "x": -33.432,
              "y": -16.607,
              "z": 0.513
            },
            "gtin": "4084200771904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7507",
            "leftCorner": {
              "x": -33.432,
              "y": -16.607,
              "z": 0.513
            },
            "rightCorner": {
              "x": -33.474,
              "y": -16.623,
              "z": 0.513
            },
            "gtin": "4084200771904",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7508",
            "leftCorner": {
              "x": -33.472,
              "y": -16.627,
              "z": 0.513
            },
            "rightCorner": {
              "x": -33.593,
              "y": -16.671,
              "z": 0.513
            },
            "gtin": "3600541698475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7509",
            "leftCorner": {
              "x": -33.594,
              "y": -16.669,
              "z": 0.513
            },
            "rightCorner": {
              "x": -33.677,
              "y": -16.698,
              "z": 0.513
            },
            "gtin": "3600542380591",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74e8",
            "leftCorner": {
              "x": -33.682,
              "y": -16.686,
              "z": 0.513
            },
            "rightCorner": {
              "x": -33.789,
              "y": -16.725,
              "z": 0.513
            },
            "gtin": "4084200550202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "96a86904c6520997e95f40ee",
            "leftCorner": {
              "x": -32.625,
              "y": -16.267,
              "z": 0.513
            },
            "rightCorner": {
              "x": -32.692,
              "y": -16.291,
              "z": 0.513
            },
            "gtin": "4063528005274",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "40d9b210a2ab28bb420725b9",
            "leftCorner": {
              "x": -32.692,
              "y": -16.291,
              "z": 0.513
            },
            "rightCorner": {
              "x": -32.748,
              "y": -16.311,
              "z": 0.513
            },
            "gtin": "3600541698482",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d400",
        "height": 0.87933,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7559",
            "leftCorner": {
              "x": -32.682,
              "y": -16.322,
              "z": 0.719
            },
            "rightCorner": {
              "x": -32.757,
              "y": -16.349,
              "z": 0.719
            },
            "gtin": "4006000128221",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d755a",
            "leftCorner": {
              "x": -32.758,
              "y": -16.345,
              "z": 0.719
            },
            "rightCorner": {
              "x": -32.807,
              "y": -16.362,
              "z": 0.719
            },
            "gtin": "4005900481597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d755b",
            "leftCorner": {
              "x": -32.808,
              "y": -16.359,
              "z": 0.719
            },
            "rightCorner": {
              "x": -32.88,
              "y": -16.385,
              "z": 0.719
            },
            "gtin": "4006000068237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d755c",
            "leftCorner": {
              "x": -32.879,
              "y": -16.389,
              "z": 0.719
            },
            "rightCorner": {
              "x": -32.927,
              "y": -16.406,
              "z": 0.719
            },
            "gtin": "5017634270964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d755d",
            "leftCorner": {
              "x": -32.927,
              "y": -16.406,
              "z": 0.719
            },
            "rightCorner": {
              "x": -32.982,
              "y": -16.426,
              "z": 0.719
            },
            "gtin": "5017634270964",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d755e",
            "leftCorner": {
              "x": -32.981,
              "y": -16.429,
              "z": 0.719
            },
            "rightCorner": {
              "x": -33.03,
              "y": -16.446,
              "z": 0.719
            },
            "gtin": "5017634280116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d755f",
            "leftCorner": {
              "x": -33.029,
              "y": -16.45,
              "z": 0.719
            },
            "rightCorner": {
              "x": -33.109,
              "y": -16.479,
              "z": 0.719
            },
            "gtin": "5017634280116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7560",
            "leftCorner": {
              "x": -33.107,
              "y": -16.485,
              "z": 0.719
            },
            "rightCorner": {
              "x": -33.157,
              "y": -16.502,
              "z": 0.719
            },
            "gtin": "4005900108548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7561",
            "leftCorner": {
              "x": -33.156,
              "y": -16.504,
              "z": 0.719
            },
            "rightCorner": {
              "x": -33.289,
              "y": -16.551,
              "z": 0.719
            },
            "gtin": "4005900108548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7562",
            "leftCorner": {
              "x": -33.289,
              "y": -16.553,
              "z": 0.719
            },
            "rightCorner": {
              "x": -33.399,
              "y": -16.593,
              "z": 0.719
            },
            "gtin": "4005900108586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7563",
            "leftCorner": {
              "x": -33.396,
              "y": -16.602,
              "z": 0.719
            },
            "rightCorner": {
              "x": -33.443,
              "y": -16.618,
              "z": 0.719
            },
            "gtin": "3600542415095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7564",
            "leftCorner": {
              "x": -33.444,
              "y": -16.616,
              "z": 0.719
            },
            "rightCorner": {
              "x": -33.497,
              "y": -16.636,
              "z": 0.719
            },
            "gtin": "3600542415095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7565",
            "leftCorner": {
              "x": -33.496,
              "y": -16.637,
              "z": 0.719
            },
            "rightCorner": {
              "x": -33.598,
              "y": -16.674,
              "z": 0.719
            },
            "gtin": "3600541163645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7548",
            "leftCorner": {
              "x": -33.597,
              "y": -16.675,
              "z": 0.719
            },
            "rightCorner": {
              "x": -33.783,
              "y": -16.742,
              "z": 0.719
            },
            "gtin": "4084200774905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0d80d45ef2f1366e764df54c",
            "leftCorner": {
              "x": -32.624,
              "y": -16.269,
              "z": 0.719
            },
            "rightCorner": {
              "x": -32.686,
              "y": -16.291,
              "z": 0.719
            },
            "gtin": "4005900108302",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3ff",
        "height": 1.1305,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7538",
            "leftCorner": {
              "x": -32.74,
              "y": -16.332,
              "z": 0.925
            },
            "rightCorner": {
              "x": -32.825,
              "y": -16.363,
              "z": 0.925
            },
            "gtin": "4003573022000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7539",
            "leftCorner": {
              "x": -32.822,
              "y": -16.37,
              "z": 0.925
            },
            "rightCorner": {
              "x": -32.903,
              "y": -16.398,
              "z": 0.925
            },
            "gtin": "4003573022130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d753a",
            "leftCorner": {
              "x": -32.904,
              "y": -16.397,
              "z": 0.925
            },
            "rightCorner": {
              "x": -32.972,
              "y": -16.422,
              "z": 0.925
            },
            "gtin": "4003573022154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d753b",
            "leftCorner": {
              "x": -32.971,
              "y": -16.424,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.097,
              "y": -16.469,
              "z": 0.925
            },
            "gtin": "4008890006825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d753c",
            "leftCorner": {
              "x": -33.093,
              "y": -16.479,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.162,
              "y": -16.503,
              "z": 0.925
            },
            "gtin": "4008890004036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d753d",
            "leftCorner": {
              "x": -33.161,
              "y": -16.504,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.245,
              "y": -16.534,
              "z": 0.925
            },
            "gtin": "3600542184687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d753e",
            "leftCorner": {
              "x": -33.244,
              "y": -16.538,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.283,
              "y": -16.552,
              "z": 0.925
            },
            "gtin": "4260370432269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d753f",
            "leftCorner": {
              "x": -33.283,
              "y": -16.551,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.357,
              "y": -16.578,
              "z": 0.925
            },
            "gtin": "4260370432269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7540",
            "leftCorner": {
              "x": -33.355,
              "y": -16.583,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.404,
              "y": -16.6,
              "z": 0.925
            },
            "gtin": "4260370437424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7541",
            "leftCorner": {
              "x": -33.403,
              "y": -16.602,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.456,
              "y": -16.621,
              "z": 0.925
            },
            "gtin": "4260370437387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7542",
            "leftCorner": {
              "x": -33.456,
              "y": -16.622,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.522,
              "y": -16.645,
              "z": 0.925
            },
            "gtin": "4260370437387",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7543",
            "leftCorner": {
              "x": -33.523,
              "y": -16.643,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.572,
              "y": -16.66,
              "z": 0.925
            },
            "gtin": "4260370437363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7544",
            "leftCorner": {
              "x": -33.572,
              "y": -16.661,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.631,
              "y": -16.683,
              "z": 0.925
            },
            "gtin": "4260370437363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7545",
            "leftCorner": {
              "x": -33.635,
              "y": -16.672,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.685,
              "y": -16.689,
              "z": 0.925
            },
            "gtin": "4260370436922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7546",
            "leftCorner": {
              "x": -33.685,
              "y": -16.689,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.733,
              "y": -16.707,
              "z": 0.925
            },
            "gtin": "4260370436946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7526",
            "leftCorner": {
              "x": -33.728,
              "y": -16.72,
              "z": 0.925
            },
            "rightCorner": {
              "x": -33.784,
              "y": -16.74,
              "z": 0.925
            },
            "gtin": "4260370436946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d9352855bc5c9823fca296a1",
            "leftCorner": {
              "x": -32.624,
              "y": -16.269,
              "z": 0.925
            },
            "rightCorner": {
              "x": -32.686,
              "y": -16.291,
              "z": 0.925
            },
            "gtin": "4003573022109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4a89f1dfb11fa104104e3970",
            "leftCorner": {
              "x": -32.686,
              "y": -16.291,
              "z": 0.925
            },
            "rightCorner": {
              "x": -32.739,
              "y": -16.311,
              "z": 0.925
            },
            "gtin": "4260370437226",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d401",
        "height": 1.3588,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7518",
            "leftCorner": {
              "x": -32.672,
              "y": -16.306,
              "z": 1.112
            },
            "rightCorner": {
              "x": -32.815,
              "y": -16.358,
              "z": 1.112
            },
            "gtin": "4021457639588",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7519",
            "leftCorner": {
              "x": -32.814,
              "y": -16.362,
              "z": 1.112
            },
            "rightCorner": {
              "x": -32.919,
              "y": -16.4,
              "z": 1.112
            },
            "gtin": "4021457650033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d751a",
            "leftCorner": {
              "x": -32.921,
              "y": -16.395,
              "z": 1.112
            },
            "rightCorner": {
              "x": -33.017,
              "y": -16.429,
              "z": 1.112
            },
            "gtin": "4021457650064",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d751b",
            "leftCorner": {
              "x": -33.013,
              "y": -16.438,
              "z": 1.112
            },
            "rightCorner": {
              "x": -33.102,
              "y": -16.47,
              "z": 1.112
            },
            "gtin": "4021457650095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d751c",
            "leftCorner": {
              "x": -33.101,
              "y": -16.475,
              "z": 1.112
            },
            "rightCorner": {
              "x": -33.165,
              "y": -16.498,
              "z": 1.112
            },
            "gtin": "4021457638307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d751d",
            "leftCorner": {
              "x": -33.165,
              "y": -16.498,
              "z": 1.112
            },
            "rightCorner": {
              "x": -33.229,
              "y": -16.521,
              "z": 1.112
            },
            "gtin": "4021457638338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d751e",
            "leftCorner": {
              "x": -33.227,
              "y": -16.527,
              "z": 1.112
            },
            "rightCorner": {
              "x": -33.285,
              "y": -16.547,
              "z": 1.112
            },
            "gtin": "4021457638369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d751f",
            "leftCorner": {
              "x": -33.285,
              "y": -16.547,
              "z": 1.112
            },
            "rightCorner": {
              "x": -33.324,
              "y": -16.561,
              "z": 1.112
            },
            "gtin": "4021457649204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7520",
            "leftCorner": {
              "x": -33.324,
              "y": -16.561,
              "z": 1.112
            },
            "rightCorner": {
              "x": -33.383,
              "y": -16.583,
              "z": 1.112
            },
            "gtin": "4021457649204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7521",
            "leftCorner": {
              "x": -33.383,
              "y": -16.583,
              "z": 1.112
            },
            "rightCorner": {
              "x": -33.433,
              "y": -16.601,
              "z": 1.112
            },
            "gtin": "4021457658268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7522",
            "leftCorner": {
              "x": -33.432,
              "y": -16.604,
              "z": 1.112
            },
            "rightCorner": {
              "x": -33.493,
              "y": -16.626,
              "z": 1.112
            },
            "gtin": "4021457658268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7523",
            "leftCorner": {
              "x": -33.492,
              "y": -16.628,
              "z": 1.112
            },
            "rightCorner": {
              "x": -33.583,
              "y": -16.66,
              "z": 1.112
            },
            "gtin": "4021457641567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7524",
            "leftCorner": {
              "x": -33.585,
              "y": -16.657,
              "z": 1.112
            },
            "rightCorner": {
              "x": -33.67,
              "y": -16.687,
              "z": 1.112
            },
            "gtin": "4021457639557",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d750b",
            "leftCorner": {
              "x": -33.673,
              "y": -16.678,
              "z": 1.112
            },
            "rightCorner": {
              "x": -33.791,
              "y": -16.72,
              "z": 1.112
            },
            "gtin": "4103040019899",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "b5ca2d4642dc87b28c98f58a",
            "leftCorner": {
              "x": -32.625,
              "y": -16.267,
              "z": 1.112
            },
            "rightCorner": {
              "x": -32.671,
              "y": -16.283,
              "z": 1.112
            },
            "gtin": "4021457649174",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c3d"
  },
  {
    "id": "c3d",
    "name": "c3d",
    "x": -31.436,
    "y": -15.877,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.98513,
      "w": 0.17181
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 102
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3fb",
        "height": 0.16841,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d74a8",
            "leftCorner": {
              "x": -31.54,
              "y": -15.826,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.589,
              "y": -15.844,
              "z": 0.138
            },
            "gtin": "4009737306559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "188caa911115db237837ba59",
            "leftCorner": {
              "x": -31.475,
              "y": -15.771,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.545,
              "y": -15.796,
              "z": 0.138
            },
            "gtin": "4005900841520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0dd4a84243141dabb374d708",
            "leftCorner": {
              "x": -31.932,
              "y": -15.935,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.986,
              "y": -15.955,
              "z": 0.138
            },
            "gtin": "4009737306566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c69241539c447b629f58a486",
            "leftCorner": {
              "x": -31.986,
              "y": -15.955,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.042,
              "y": -15.975,
              "z": 0.138
            },
            "gtin": "4084200499600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a6121740f41ffed2657a7df4",
            "leftCorner": {
              "x": -32.042,
              "y": -15.975,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.097,
              "y": -15.995,
              "z": 0.138
            },
            "gtin": "4009737306566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2605871b50df20ce2d46fc96",
            "leftCorner": {
              "x": -32.097,
              "y": -15.995,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.153,
              "y": -16.015,
              "z": 0.138
            },
            "gtin": "4084200499600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c9b0b0677ef365594484711d",
            "leftCorner": {
              "x": -32.153,
              "y": -16.015,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.211,
              "y": -16.036,
              "z": 0.138
            },
            "gtin": "4005900841520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "df45d8aa0f4361e71d166002",
            "leftCorner": {
              "x": -32.211,
              "y": -16.036,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.266,
              "y": -16.056,
              "z": 0.138
            },
            "gtin": "4009737306566",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d0bd3e2793c61a13cab8b2",
            "leftCorner": {
              "x": -32.266,
              "y": -16.056,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.322,
              "y": -16.076,
              "z": 0.138
            },
            "gtin": "4084200499600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0cc00994cea178f6a514feb2",
            "leftCorner": {
              "x": -32.322,
              "y": -16.076,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.381,
              "y": -16.097,
              "z": 0.138
            },
            "gtin": "4005900841520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0b77ccf887f91fe663b1f58d",
            "leftCorner": {
              "x": -32.381,
              "y": -16.097,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.534,
              "y": -16.152,
              "z": 0.138
            },
            "gtin": "42182634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "85ffbb50fae9cf4ce3ec47ad",
            "leftCorner": {
              "x": -32.534,
              "y": -16.152,
              "z": 0.138
            },
            "rightCorner": {
              "x": -32.614,
              "y": -16.181,
              "z": 0.138
            },
            "gtin": "4009737306559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74a9",
            "leftCorner": {
              "x": -31.588,
              "y": -15.846,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.674,
              "y": -15.877,
              "z": 0.138
            },
            "gtin": "4009737306559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74aa",
            "leftCorner": {
              "x": -31.671,
              "y": -15.884,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.723,
              "y": -15.901,
              "z": 0.138
            },
            "gtin": "42182634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74ab",
            "leftCorner": {
              "x": -31.724,
              "y": -15.899,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.859,
              "y": -15.948,
              "z": 0.138
            },
            "gtin": "42182634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74ac",
            "leftCorner": {
              "x": -31.861,
              "y": -15.942,
              "z": 0.138
            },
            "rightCorner": {
              "x": -31.921,
              "y": -15.964,
              "z": 0.138
            },
            "gtin": "4084200499709",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3f7",
        "height": 0.41969,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d74c4",
            "leftCorner": {
              "x": -31.454,
              "y": -15.827,
              "z": 0.343
            },
            "rightCorner": {
              "x": -31.507,
              "y": -15.846,
              "z": 0.343
            },
            "gtin": "4005900973962",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7bd47a170b30c2c6aa3164f4",
            "leftCorner": {
              "x": -32.556,
              "y": -16.223,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.614,
              "y": -16.244,
              "z": 0.343
            },
            "gtin": "4005900841643",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74c6",
            "leftCorner": {
              "x": -31.502,
              "y": -15.86,
              "z": 0.343
            },
            "rightCorner": {
              "x": -31.557,
              "y": -15.88,
              "z": 0.343
            },
            "gtin": "4005900975317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74c7",
            "leftCorner": {
              "x": -31.552,
              "y": -15.895,
              "z": 0.343
            },
            "rightCorner": {
              "x": -31.634,
              "y": -15.925,
              "z": 0.343
            },
            "gtin": "4005900973887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74c8",
            "leftCorner": {
              "x": -31.632,
              "y": -15.929,
              "z": 0.343
            },
            "rightCorner": {
              "x": -31.676,
              "y": -15.945,
              "z": 0.343
            },
            "gtin": "4006000061887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74c9",
            "leftCorner": {
              "x": -31.676,
              "y": -15.945,
              "z": 0.343
            },
            "rightCorner": {
              "x": -31.712,
              "y": -15.957,
              "z": 0.343
            },
            "gtin": "4005900973924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74ca",
            "leftCorner": {
              "x": -31.712,
              "y": -15.957,
              "z": 0.343
            },
            "rightCorner": {
              "x": -31.769,
              "y": -15.978,
              "z": 0.343
            },
            "gtin": "4006000019178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74cb",
            "leftCorner": {
              "x": -31.766,
              "y": -15.984,
              "z": 0.343
            },
            "rightCorner": {
              "x": -31.84,
              "y": -16.011,
              "z": 0.343
            },
            "gtin": "4006000019215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74cc",
            "leftCorner": {
              "x": -31.842,
              "y": -16.007,
              "z": 0.343
            },
            "rightCorner": {
              "x": -31.9,
              "y": -16.028,
              "z": 0.343
            },
            "gtin": "4005900801609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74cd",
            "leftCorner": {
              "x": -31.901,
              "y": -16.025,
              "z": 0.343
            },
            "rightCorner": {
              "x": -31.969,
              "y": -16.05,
              "z": 0.343
            },
            "gtin": "4005900805829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74ce",
            "leftCorner": {
              "x": -31.967,
              "y": -16.054,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.071,
              "y": -16.092,
              "z": 0.343
            },
            "gtin": "4006000068275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74cf",
            "leftCorner": {
              "x": -32.069,
              "y": -16.097,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.133,
              "y": -16.12,
              "z": 0.343
            },
            "gtin": "4006000019963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74d0",
            "leftCorner": {
              "x": -32.134,
              "y": -16.119,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.199,
              "y": -16.141,
              "z": 0.343
            },
            "gtin": "4005900758415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74d1",
            "leftCorner": {
              "x": -32.201,
              "y": -16.136,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.26,
              "y": -16.158,
              "z": 0.343
            },
            "gtin": "4006000004433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74d2",
            "leftCorner": {
              "x": -32.26,
              "y": -16.158,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.306,
              "y": -16.175,
              "z": 0.343
            },
            "gtin": "4005900788573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74d3",
            "leftCorner": {
              "x": -32.305,
              "y": -16.177,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.405,
              "y": -16.213,
              "z": 0.343
            },
            "gtin": "4005900788573",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74d4",
            "leftCorner": {
              "x": -32.403,
              "y": -16.217,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.478,
              "y": -16.244,
              "z": 0.343
            },
            "gtin": "4005808195862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74d5",
            "leftCorner": {
              "x": -32.478,
              "y": -16.243,
              "z": 0.343
            },
            "rightCorner": {
              "x": -32.541,
              "y": -16.266,
              "z": 0.343
            },
            "gtin": "4005900841674",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3f8",
        "height": 0.62921,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d74e7",
            "leftCorner": {
              "x": -31.454,
              "y": -15.827,
              "z": 0.515
            },
            "rightCorner": {
              "x": -31.521,
              "y": -15.851,
              "z": 0.515
            },
            "gtin": "4006000085166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74e9",
            "leftCorner": {
              "x": -31.507,
              "y": -15.888,
              "z": 0.515
            },
            "rightCorner": {
              "x": -31.579,
              "y": -15.914,
              "z": 0.515
            },
            "gtin": "4006000085241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74ea",
            "leftCorner": {
              "x": -31.58,
              "y": -15.91,
              "z": 0.515
            },
            "rightCorner": {
              "x": -31.616,
              "y": -15.923,
              "z": 0.515
            },
            "gtin": "4006000085074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74eb",
            "leftCorner": {
              "x": -31.615,
              "y": -15.925,
              "z": 0.515
            },
            "rightCorner": {
              "x": -31.682,
              "y": -15.95,
              "z": 0.515
            },
            "gtin": "4006000085074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74ec",
            "leftCorner": {
              "x": -31.682,
              "y": -15.953,
              "z": 0.515
            },
            "rightCorner": {
              "x": -31.745,
              "y": -15.974,
              "z": 0.515
            },
            "gtin": "4005900546234",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74ed",
            "leftCorner": {
              "x": -31.744,
              "y": -15.975,
              "z": 0.515
            },
            "rightCorner": {
              "x": -31.784,
              "y": -15.99,
              "z": 0.515
            },
            "gtin": "4005900891617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74ee",
            "leftCorner": {
              "x": -31.787,
              "y": -15.985,
              "z": 0.515
            },
            "rightCorner": {
              "x": -31.826,
              "y": -15.999,
              "z": 0.515
            },
            "gtin": "4005900546111",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74ef",
            "leftCorner": {
              "x": -31.827,
              "y": -15.999,
              "z": 0.515
            },
            "rightCorner": {
              "x": -31.911,
              "y": -16.029,
              "z": 0.515
            },
            "gtin": "4006000085517",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74f0",
            "leftCorner": {
              "x": -31.911,
              "y": -16.03,
              "z": 0.515
            },
            "rightCorner": {
              "x": -31.981,
              "y": -16.056,
              "z": 0.515
            },
            "gtin": "4006000085036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74f1",
            "leftCorner": {
              "x": -31.98,
              "y": -16.057,
              "z": 0.515
            },
            "rightCorner": {
              "x": -32.062,
              "y": -16.087,
              "z": 0.515
            },
            "gtin": "4005900776808",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74f2",
            "leftCorner": {
              "x": -32.063,
              "y": -16.084,
              "z": 0.515
            },
            "rightCorner": {
              "x": -32.164,
              "y": -16.12,
              "z": 0.515
            },
            "gtin": "4006000085128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74f3",
            "leftCorner": {
              "x": -32.16,
              "y": -16.13,
              "z": 0.515
            },
            "rightCorner": {
              "x": -32.218,
              "y": -16.15,
              "z": 0.515
            },
            "gtin": "4005900935342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74f4",
            "leftCorner": {
              "x": -32.221,
              "y": -16.144,
              "z": 0.515
            },
            "rightCorner": {
              "x": -32.288,
              "y": -16.168,
              "z": 0.515
            },
            "gtin": "4005900935304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74f5",
            "leftCorner": {
              "x": -32.285,
              "y": -16.175,
              "z": 0.515
            },
            "rightCorner": {
              "x": -32.353,
              "y": -16.199,
              "z": 0.515
            },
            "gtin": "4005900803238",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74f6",
            "leftCorner": {
              "x": -32.353,
              "y": -16.199,
              "z": 0.515
            },
            "rightCorner": {
              "x": -32.398,
              "y": -16.215,
              "z": 0.515
            },
            "gtin": "4005900935540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74f7",
            "leftCorner": {
              "x": -32.399,
              "y": -16.212,
              "z": 0.515
            },
            "rightCorner": {
              "x": -32.44,
              "y": -16.227,
              "z": 0.515
            },
            "gtin": "4005900935267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74f8",
            "leftCorner": {
              "x": -32.44,
              "y": -16.228,
              "z": 0.515
            },
            "rightCorner": {
              "x": -32.493,
              "y": -16.247,
              "z": 0.515
            },
            "gtin": "4005900935465",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74f9",
            "leftCorner": {
              "x": -32.491,
              "y": -16.254,
              "z": 0.515
            },
            "rightCorner": {
              "x": -32.549,
              "y": -16.275,
              "z": 0.515
            },
            "gtin": "4005900935427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74fa",
            "leftCorner": {
              "x": -32.55,
              "y": -16.273,
              "z": 0.515
            },
            "rightCorner": {
              "x": -32.621,
              "y": -16.299,
              "z": 0.515
            },
            "gtin": "4005900935502",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74fb",
            "leftCorner": {
              "x": -32.619,
              "y": -16.305,
              "z": 0.515
            },
            "rightCorner": {
              "x": -32.735,
              "y": -16.346,
              "z": 0.515
            },
            "gtin": "4063528008930",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3fc",
        "height": 0.88093,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7547",
            "leftCorner": {
              "x": -31.454,
              "y": -15.827,
              "z": 0.721
            },
            "rightCorner": {
              "x": -31.508,
              "y": -15.847,
              "z": 0.721
            },
            "gtin": "4005900823441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7549",
            "leftCorner": {
              "x": -31.497,
              "y": -15.876,
              "z": 0.721
            },
            "rightCorner": {
              "x": -31.542,
              "y": -15.892,
              "z": 0.721
            },
            "gtin": "4005900823441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d754a",
            "leftCorner": {
              "x": -31.541,
              "y": -15.894,
              "z": 0.721
            },
            "rightCorner": {
              "x": -31.594,
              "y": -15.913,
              "z": 0.721
            },
            "gtin": "4005900825278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d754b",
            "leftCorner": {
              "x": -31.594,
              "y": -15.915,
              "z": 0.721
            },
            "rightCorner": {
              "x": -31.729,
              "y": -15.963,
              "z": 0.721
            },
            "gtin": "4005900700933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d754c",
            "leftCorner": {
              "x": -31.728,
              "y": -15.967,
              "z": 0.721
            },
            "rightCorner": {
              "x": -31.86,
              "y": -16.015,
              "z": 0.721
            },
            "gtin": "4005900880208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d754d",
            "leftCorner": {
              "x": -31.86,
              "y": -16.015,
              "z": 0.721
            },
            "rightCorner": {
              "x": -31.931,
              "y": -16.04,
              "z": 0.721
            },
            "gtin": "4006000002255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d754e",
            "leftCorner": {
              "x": -31.933,
              "y": -16.034,
              "z": 0.721
            },
            "rightCorner": {
              "x": -32.023,
              "y": -16.067,
              "z": 0.721
            },
            "gtin": "4006000066226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d754f",
            "leftCorner": {
              "x": -32.023,
              "y": -16.067,
              "z": 0.721
            },
            "rightCorner": {
              "x": -32.108,
              "y": -16.098,
              "z": 0.721
            },
            "gtin": "4006000043128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7550",
            "leftCorner": {
              "x": -32.107,
              "y": -16.103,
              "z": 0.721
            },
            "rightCorner": {
              "x": -32.182,
              "y": -16.13,
              "z": 0.721
            },
            "gtin": "4006000043241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7551",
            "leftCorner": {
              "x": -32.182,
              "y": -16.133,
              "z": 0.721
            },
            "rightCorner": {
              "x": -32.267,
              "y": -16.162,
              "z": 0.721
            },
            "gtin": "4006000043289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7552",
            "leftCorner": {
              "x": -32.267,
              "y": -16.163,
              "z": 0.721
            },
            "rightCorner": {
              "x": -32.334,
              "y": -16.188,
              "z": 0.721
            },
            "gtin": "4006000043364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7553",
            "leftCorner": {
              "x": -32.332,
              "y": -16.192,
              "z": 0.721
            },
            "rightCorner": {
              "x": -32.391,
              "y": -16.213,
              "z": 0.721
            },
            "gtin": "4006000054858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7554",
            "leftCorner": {
              "x": -32.391,
              "y": -16.213,
              "z": 0.721
            },
            "rightCorner": {
              "x": -32.434,
              "y": -16.229,
              "z": 0.721
            },
            "gtin": "4006000043401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7555",
            "leftCorner": {
              "x": -32.435,
              "y": -16.227,
              "z": 0.721
            },
            "rightCorner": {
              "x": -32.49,
              "y": -16.247,
              "z": 0.721
            },
            "gtin": "4005900909671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7556",
            "leftCorner": {
              "x": -32.489,
              "y": -16.249,
              "z": 0.721
            },
            "rightCorner": {
              "x": -32.536,
              "y": -16.266,
              "z": 0.721
            },
            "gtin": "4005900998200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7557",
            "leftCorner": {
              "x": -32.536,
              "y": -16.266,
              "z": 0.721
            },
            "rightCorner": {
              "x": -32.572,
              "y": -16.279,
              "z": 0.721
            },
            "gtin": "4006000103624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7558",
            "leftCorner": {
              "x": -32.573,
              "y": -16.278,
              "z": 0.721
            },
            "rightCorner": {
              "x": -32.682,
              "y": -16.318,
              "z": 0.721
            },
            "gtin": "4006000061887",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3fa",
        "height": 1.1333,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7525",
            "leftCorner": {
              "x": -31.454,
              "y": -15.827,
              "z": 0.927
            },
            "rightCorner": {
              "x": -31.506,
              "y": -15.846,
              "z": 0.927
            },
            "gtin": "4005900897305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7527",
            "leftCorner": {
              "x": -31.495,
              "y": -15.876,
              "z": 0.927
            },
            "rightCorner": {
              "x": -31.531,
              "y": -15.889,
              "z": 0.927
            },
            "gtin": "4005900897305",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7528",
            "leftCorner": {
              "x": -31.529,
              "y": -15.894,
              "z": 0.927
            },
            "rightCorner": {
              "x": -31.576,
              "y": -15.911,
              "z": 0.927
            },
            "gtin": "4005900853578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7529",
            "leftCorner": {
              "x": -31.577,
              "y": -15.91,
              "z": 0.927
            },
            "rightCorner": {
              "x": -31.667,
              "y": -15.943,
              "z": 0.927
            },
            "gtin": "4005900853615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d752a",
            "leftCorner": {
              "x": -31.666,
              "y": -15.948,
              "z": 0.927
            },
            "rightCorner": {
              "x": -31.77,
              "y": -15.985,
              "z": 0.927
            },
            "gtin": "4005900938763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d752b",
            "leftCorner": {
              "x": -31.771,
              "y": -15.981,
              "z": 0.927
            },
            "rightCorner": {
              "x": -31.85,
              "y": -16.009,
              "z": 0.927
            },
            "gtin": "4005900853660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d752c",
            "leftCorner": {
              "x": -31.849,
              "y": -16.011,
              "z": 0.927
            },
            "rightCorner": {
              "x": -31.891,
              "y": -16.026,
              "z": 0.927
            },
            "gtin": "4005900998088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d752d",
            "leftCorner": {
              "x": -31.891,
              "y": -16.024,
              "z": 0.927
            },
            "rightCorner": {
              "x": -31.938,
              "y": -16.041,
              "z": 0.927
            },
            "gtin": "4005900914750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d752e",
            "leftCorner": {
              "x": -31.939,
              "y": -16.037,
              "z": 0.927
            },
            "rightCorner": {
              "x": -32.019,
              "y": -16.066,
              "z": 0.927
            },
            "gtin": "4005900914798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d752f",
            "leftCorner": {
              "x": -32.02,
              "y": -16.063,
              "z": 0.927
            },
            "rightCorner": {
              "x": -32.101,
              "y": -16.093,
              "z": 0.927
            },
            "gtin": "4005900954763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7530",
            "leftCorner": {
              "x": -32.099,
              "y": -16.098,
              "z": 0.927
            },
            "rightCorner": {
              "x": -32.196,
              "y": -16.133,
              "z": 0.927
            },
            "gtin": "4005900954800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7531",
            "leftCorner": {
              "x": -32.194,
              "y": -16.14,
              "z": 0.927
            },
            "rightCorner": {
              "x": -32.309,
              "y": -16.181,
              "z": 0.927
            },
            "gtin": "4005900933522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7532",
            "leftCorner": {
              "x": -32.308,
              "y": -16.183,
              "z": 0.927
            },
            "rightCorner": {
              "x": -32.37,
              "y": -16.206,
              "z": 0.927
            },
            "gtin": "4005900933560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7533",
            "leftCorner": {
              "x": -32.37,
              "y": -16.205,
              "z": 0.927
            },
            "rightCorner": {
              "x": -32.419,
              "y": -16.222,
              "z": 0.927
            },
            "gtin": "4006000112695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7534",
            "leftCorner": {
              "x": -32.419,
              "y": -16.222,
              "z": 0.927
            },
            "rightCorner": {
              "x": -32.47,
              "y": -16.241,
              "z": 0.927
            },
            "gtin": "4006000019390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7535",
            "leftCorner": {
              "x": -32.471,
              "y": -16.24,
              "z": 0.927
            },
            "rightCorner": {
              "x": -32.567,
              "y": -16.275,
              "z": 0.927
            },
            "gtin": "4006000130170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7536",
            "leftCorner": {
              "x": -32.566,
              "y": -16.278,
              "z": 0.927
            },
            "rightCorner": {
              "x": -32.615,
              "y": -16.296,
              "z": 0.927
            },
            "gtin": "4005900884152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7537",
            "leftCorner": {
              "x": -32.614,
              "y": -16.299,
              "z": 0.927
            },
            "rightCorner": {
              "x": -32.735,
              "y": -16.342,
              "z": 0.927
            },
            "gtin": "4003573022109",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3f9",
        "height": 1.3608,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d750a",
            "leftCorner": {
              "x": -31.455,
              "y": -15.824,
              "z": 1.113
            },
            "rightCorner": {
              "x": -31.551,
              "y": -15.859,
              "z": 1.113
            },
            "gtin": "3600523363278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d750c",
            "leftCorner": {
              "x": -31.539,
              "y": -15.892,
              "z": 1.113
            },
            "rightCorner": {
              "x": -31.58,
              "y": -15.906,
              "z": 1.113
            },
            "gtin": "3600523965762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d750d",
            "leftCorner": {
              "x": -31.579,
              "y": -15.909,
              "z": 1.113
            },
            "rightCorner": {
              "x": -31.619,
              "y": -15.923,
              "z": 1.113
            },
            "gtin": "3600523363254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d750e",
            "leftCorner": {
              "x": -31.62,
              "y": -15.921,
              "z": 1.113
            },
            "rightCorner": {
              "x": -31.678,
              "y": -15.942,
              "z": 1.113
            },
            "gtin": "3600523965687",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d750f",
            "leftCorner": {
              "x": -31.678,
              "y": -15.944,
              "z": 1.113
            },
            "rightCorner": {
              "x": -31.748,
              "y": -15.968,
              "z": 1.113
            },
            "gtin": "3600521719541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7510",
            "leftCorner": {
              "x": -31.747,
              "y": -15.971,
              "z": 1.113
            },
            "rightCorner": {
              "x": -31.878,
              "y": -16.019,
              "z": 1.113
            },
            "gtin": "3600523183739",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7511",
            "leftCorner": {
              "x": -31.88,
              "y": -16.014,
              "z": 1.113
            },
            "rightCorner": {
              "x": -31.947,
              "y": -16.039,
              "z": 1.113
            },
            "gtin": "3600523183746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7512",
            "leftCorner": {
              "x": -31.945,
              "y": -16.042,
              "z": 1.113
            },
            "rightCorner": {
              "x": -32.037,
              "y": -16.075,
              "z": 1.113
            },
            "gtin": "3600523183753",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7513",
            "leftCorner": {
              "x": -32.036,
              "y": -16.076,
              "z": 1.113
            },
            "rightCorner": {
              "x": -32.132,
              "y": -16.111,
              "z": 1.113
            },
            "gtin": "3600523350186",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7514",
            "leftCorner": {
              "x": -32.131,
              "y": -16.115,
              "z": 1.113
            },
            "rightCorner": {
              "x": -32.287,
              "y": -16.17,
              "z": 1.113
            },
            "gtin": "3600523428052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7515",
            "leftCorner": {
              "x": -32.288,
              "y": -16.168,
              "z": 1.113
            },
            "rightCorner": {
              "x": -32.427,
              "y": -16.218,
              "z": 1.113
            },
            "gtin": "3600523428045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7516",
            "leftCorner": {
              "x": -32.427,
              "y": -16.218,
              "z": 1.113
            },
            "rightCorner": {
              "x": -32.486,
              "y": -16.24,
              "z": 1.113
            },
            "gtin": "3600523970827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7517",
            "leftCorner": {
              "x": -32.485,
              "y": -16.243,
              "z": 1.113
            },
            "rightCorner": {
              "x": -32.671,
              "y": -16.31,
              "z": 1.113
            },
            "gtin": "3600523970834",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c3e",
    "rightNeighborShelfId": "c3c"
  },
  {
    "id": "c3e",
    "name": "c3e",
    "x": -30.26,
    "y": -15.454,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.98513,
      "w": 0.17181
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 12
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3f4",
        "height": 0.15979,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d74a5",
            "leftCorner": {
              "x": -30.297,
              "y": -15.35,
              "z": 0.131
            },
            "rightCorner": {
              "x": -31.416,
              "y": -15.752,
              "z": 0.131
            },
            "gtin": "4260712960306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d74a7",
            "leftCorner": {
              "x": -31.404,
              "y": -15.787,
              "z": 0.131
            },
            "rightCorner": {
              "x": -31.537,
              "y": -15.835,
              "z": 0.131
            },
            "gtin": "4005900841551",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3f5",
        "height": 1.0903,
        "facings": [
          {
            "id": "faedcf6df5112128e15eb074",
            "leftCorner": {
              "x": -30.217,
              "y": -15.574,
              "z": 0.892
            },
            "rightCorner": {
              "x": -30.265,
              "y": -15.591,
              "z": 0.892
            },
            "gtin": "4005900841551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f11aa604b1964b7924c70900",
            "leftCorner": {
              "x": -30.265,
              "y": -15.591,
              "z": 0.892
            },
            "rightCorner": {
              "x": -30.64,
              "y": -15.726,
              "z": 0.892
            },
            "gtin": "4260712960306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "615d67959287110005fab586",
            "leftCorner": {
              "x": -30.64,
              "y": -15.726,
              "z": 0.892
            },
            "rightCorner": {
              "x": -30.688,
              "y": -15.743,
              "z": 0.892
            },
            "gtin": "4005900841551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "080b1f57d770a9ee8e108259",
            "leftCorner": {
              "x": -30.688,
              "y": -15.743,
              "z": 0.892
            },
            "rightCorner": {
              "x": -31.063,
              "y": -15.878,
              "z": 0.892
            },
            "gtin": "4260712960306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a2a8873e0774d1b3aac343dd",
            "leftCorner": {
              "x": -31.063,
              "y": -15.878,
              "z": 0.892
            },
            "rightCorner": {
              "x": -31.111,
              "y": -15.895,
              "z": 0.892
            },
            "gtin": "4005900841551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d93e95d3a19b40a81547f7e7",
            "leftCorner": {
              "x": -31.111,
              "y": -15.895,
              "z": 0.892
            },
            "rightCorner": {
              "x": -31.159,
              "y": -15.913,
              "z": 0.892
            },
            "gtin": "4005900841551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "85e7b59f035e8a99d3ced79d",
            "leftCorner": {
              "x": -31.159,
              "y": -15.913,
              "z": 0.892
            },
            "rightCorner": {
              "x": -31.207,
              "y": -15.93,
              "z": 0.892
            },
            "gtin": "4005900841551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ae973f2342e5c8e085a3d3c1",
            "leftCorner": {
              "x": -31.207,
              "y": -15.93,
              "z": 0.892
            },
            "rightCorner": {
              "x": -31.255,
              "y": -15.947,
              "z": 0.892
            },
            "gtin": "4005900841551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a8697ff32241e8391e8128a7",
            "leftCorner": {
              "x": -31.255,
              "y": -15.947,
              "z": 0.892
            },
            "rightCorner": {
              "x": -31.303,
              "y": -15.964,
              "z": 0.892
            },
            "gtin": "4005900841551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "132987232c21ad2889f736e1",
            "leftCorner": {
              "x": -31.303,
              "y": -15.964,
              "z": 0.892
            },
            "rightCorner": {
              "x": -31.351,
              "y": -15.982,
              "z": 0.892
            },
            "gtin": "4005900841551",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3f6",
        "height": 1.6256,
        "facings": []
      }
    ],
    "leftNeighborShelfId": "c9e",
    "rightNeighborShelfId": "c3d"
  },
  {
    "id": "c40",
    "name": "c40",
    "x": -28.338,
    "y": -15.885,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.83409,
      "w": 0.55162
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 35
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d79a",
        "height": 0.4911,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a44",
            "leftCorner": {
              "x": -28.229,
              "y": -15.839,
              "z": 0.402
            },
            "rightCorner": {
              "x": -28.429,
              "y": -15.368,
              "z": 0.402
            },
            "gtin": "8721201973604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a46",
            "leftCorner": {
              "x": -28.477,
              "y": -15.388,
              "z": 0.402
            },
            "rightCorner": {
              "x": -28.549,
              "y": -15.217,
              "z": 0.402
            },
            "gtin": "8700216942034",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a47",
            "leftCorner": {
              "x": -28.536,
              "y": -15.212,
              "z": 0.402
            },
            "rightCorner": {
              "x": -28.577,
              "y": -15.115,
              "z": 0.402
            },
            "gtin": "8700216941914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a45",
            "leftCorner": {
              "x": -28.574,
              "y": -15.113,
              "z": 0.402
            },
            "rightCorner": {
              "x": -28.749,
              "y": -14.702,
              "z": 0.402
            },
            "gtin": "4008233175058",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d798",
        "height": 0.75428,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a36",
            "leftCorner": {
              "x": -28.246,
              "y": -15.846,
              "z": 0.617
            },
            "rightCorner": {
              "x": -28.297,
              "y": -15.729,
              "z": 0.617
            },
            "gtin": "3616306722156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a37",
            "leftCorner": {
              "x": -28.297,
              "y": -15.729,
              "z": 0.617
            },
            "rightCorner": {
              "x": -28.346,
              "y": -15.611,
              "z": 0.617
            },
            "gtin": "3616306722156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a38",
            "leftCorner": {
              "x": -28.346,
              "y": -15.611,
              "z": 0.617
            },
            "rightCorner": {
              "x": -28.397,
              "y": -15.494,
              "z": 0.617
            },
            "gtin": "3616306722156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a39",
            "leftCorner": {
              "x": -28.397,
              "y": -15.494,
              "z": 0.617
            },
            "rightCorner": {
              "x": -28.446,
              "y": -15.376,
              "z": 0.617
            },
            "gtin": "3616306722156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a3b",
            "leftCorner": {
              "x": -28.491,
              "y": -15.396,
              "z": 0.617
            },
            "rightCorner": {
              "x": -28.543,
              "y": -15.272,
              "z": 0.617
            },
            "gtin": "8721201977152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a3c",
            "leftCorner": {
              "x": -28.534,
              "y": -15.269,
              "z": 0.617
            },
            "rightCorner": {
              "x": -28.605,
              "y": -15.103,
              "z": 0.617
            },
            "gtin": "8721201977176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a3d",
            "leftCorner": {
              "x": -28.594,
              "y": -15.098,
              "z": 0.617
            },
            "rightCorner": {
              "x": -28.645,
              "y": -14.98,
              "z": 0.617
            },
            "gtin": "8721201973130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a3a",
            "leftCorner": {
              "x": -28.639,
              "y": -14.977,
              "z": 0.617
            },
            "rightCorner": {
              "x": -28.755,
              "y": -14.704,
              "z": 0.617
            },
            "gtin": "3616305827326",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d799",
        "height": 1.0178,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a3e",
            "leftCorner": {
              "x": -28.236,
              "y": -15.842,
              "z": 0.833
            },
            "rightCorner": {
              "x": -28.328,
              "y": -15.625,
              "z": 0.833
            },
            "gtin": "5021769827719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "29f3a64c91c1590e52d51339",
            "leftCorner": {
              "x": -28.392,
              "y": -15.473,
              "z": 0.833
            },
            "rightCorner": {
              "x": -28.437,
              "y": -15.369,
              "z": 0.833
            },
            "gtin": "4897097266398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5833fa2506565fe9e70bfe7b",
            "leftCorner": {
              "x": -28.52,
              "y": -15.174,
              "z": 0.833
            },
            "rightCorner": {
              "x": -28.566,
              "y": -15.066,
              "z": 0.833
            },
            "gtin": "5021769827719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a40",
            "leftCorner": {
              "x": -28.377,
              "y": -15.644,
              "z": 0.833
            },
            "rightCorner": {
              "x": -28.441,
              "y": -15.493,
              "z": 0.833
            },
            "gtin": "5021769827696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a42",
            "leftCorner": {
              "x": -28.746,
              "y": -15.402,
              "z": 0.833
            },
            "rightCorner": {
              "x": -28.793,
              "y": -15.29,
              "z": 0.833
            },
            "gtin": "5021769827702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a3f",
            "leftCorner": {
              "x": -28.597,
              "y": -15.054,
              "z": 0.833
            },
            "rightCorner": {
              "x": -28.747,
              "y": -14.701,
              "z": 0.833
            },
            "gtin": "4006000158860",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d796",
        "height": 1.2569,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a23",
            "leftCorner": {
              "x": -28.254,
              "y": -15.849,
              "z": 1.028
            },
            "rightCorner": {
              "x": -28.271,
              "y": -15.811,
              "z": 1.028
            },
            "gtin": "4013162030712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a24",
            "leftCorner": {
              "x": -28.271,
              "y": -15.811,
              "z": 1.028
            },
            "rightCorner": {
              "x": -28.287,
              "y": -15.773,
              "z": 1.028
            },
            "gtin": "4013162030712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a25",
            "leftCorner": {
              "x": -28.287,
              "y": -15.773,
              "z": 1.028
            },
            "rightCorner": {
              "x": -28.303,
              "y": -15.736,
              "z": 1.028
            },
            "gtin": "4013162030712",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a27",
            "leftCorner": {
              "x": -28.355,
              "y": -15.758,
              "z": 1.028
            },
            "rightCorner": {
              "x": -28.386,
              "y": -15.687,
              "z": 1.028
            },
            "gtin": "8700216631730",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a28",
            "leftCorner": {
              "x": -28.378,
              "y": -15.683,
              "z": 1.028
            },
            "rightCorner": {
              "x": -28.407,
              "y": -15.616,
              "z": 1.028
            },
            "gtin": "8700216631662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a29",
            "leftCorner": {
              "x": -28.405,
              "y": -15.615,
              "z": 1.028
            },
            "rightCorner": {
              "x": -28.439,
              "y": -15.533,
              "z": 1.028
            },
            "gtin": "8700216212847",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a2a",
            "leftCorner": {
              "x": -28.435,
              "y": -15.532,
              "z": 1.028
            },
            "rightCorner": {
              "x": -28.459,
              "y": -15.476,
              "z": 1.028
            },
            "gtin": "8700216210607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a2b",
            "leftCorner": {
              "x": -28.455,
              "y": -15.474,
              "z": 1.028
            },
            "rightCorner": {
              "x": -28.493,
              "y": -15.385,
              "z": 1.028
            },
            "gtin": "4015100864915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a2c",
            "leftCorner": {
              "x": -28.493,
              "y": -15.385,
              "z": 1.028
            },
            "rightCorner": {
              "x": -28.531,
              "y": -15.295,
              "z": 1.028
            },
            "gtin": "4015100864915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a2d",
            "leftCorner": {
              "x": -28.526,
              "y": -15.293,
              "z": 1.028
            },
            "rightCorner": {
              "x": -28.649,
              "y": -15.002,
              "z": 1.028
            },
            "gtin": "4015100865073",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a2e",
            "leftCorner": {
              "x": -28.629,
              "y": -14.992,
              "z": 1.028
            },
            "rightCorner": {
              "x": -28.674,
              "y": -14.888,
              "z": 1.028
            },
            "gtin": "4015100864953",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d8a26",
            "leftCorner": {
              "x": -28.682,
              "y": -14.892,
              "z": 1.028
            },
            "rightCorner": {
              "x": -28.761,
              "y": -14.707,
              "z": 1.028
            },
            "gtin": "4015100864915",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d797",
        "height": 1.5579,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a2f",
            "leftCorner": {
              "x": -28.245,
              "y": -15.846,
              "z": 1.275
            },
            "rightCorner": {
              "x": -28.331,
              "y": -15.644,
              "z": 1.275
            },
            "gtin": "8721201973369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a31",
            "leftCorner": {
              "x": -28.381,
              "y": -15.664,
              "z": 1.275
            },
            "rightCorner": {
              "x": -28.45,
              "y": -15.501,
              "z": 1.275
            },
            "gtin": "4006000188690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a32",
            "leftCorner": {
              "x": -28.441,
              "y": -15.497,
              "z": 1.275
            },
            "rightCorner": {
              "x": -28.499,
              "y": -15.359,
              "z": 1.275
            },
            "gtin": "4006000188287",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a33",
            "leftCorner": {
              "x": -28.496,
              "y": -15.358,
              "z": 1.275
            },
            "rightCorner": {
              "x": -28.549,
              "y": -15.235,
              "z": 1.275
            },
            "gtin": "4008233174310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a34",
            "leftCorner": {
              "x": -28.549,
              "y": -15.235,
              "z": 1.275
            },
            "rightCorner": {
              "x": -28.601,
              "y": -15.113,
              "z": 1.275
            },
            "gtin": "4008233174310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a35",
            "leftCorner": {
              "x": -28.585,
              "y": -15.106,
              "z": 1.275
            },
            "rightCorner": {
              "x": -28.654,
              "y": -14.944,
              "z": 1.275
            },
            "gtin": "4008233174303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a30",
            "leftCorner": {
              "x": -28.65,
              "y": -14.943,
              "z": 1.275
            },
            "rightCorner": {
              "x": -28.753,
              "y": -14.703,
              "z": 1.275
            },
            "gtin": "8721201973284",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ]
  },
  {
    "id": "c41",
    "name": "c41",
    "x": -34.26,
    "y": -16.841,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.54711,
      "w": 0.83706
    },
    "layers": []
  },
  {
    "id": "c42",
    "name": "c42",
    "x": -33.412,
    "y": -10.941,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.011449,
      "w": 0.99993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 82
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7a2",
        "height": 0.17067,
        "facings": [
          {
            "id": "68d21f3bd12891efb383835b",
            "leftCorner": {
              "x": -33.408,
              "y": -11.083,
              "z": 0.14
            },
            "rightCorner": {
              "x": -33.169,
              "y": -11.077,
              "z": 0.14
            },
            "gtin": "4008491103251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9209d2a878e868300ebc4f7b",
            "leftCorner": {
              "x": -33.169,
              "y": -11.077,
              "z": 0.14
            },
            "rightCorner": {
              "x": -33.129,
              "y": -11.077,
              "z": 0.14
            },
            "gtin": "4021457637416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cb37d8397dc288a914e7610e",
            "leftCorner": {
              "x": -33.129,
              "y": -11.077,
              "z": 0.14
            },
            "rightCorner": {
              "x": -33.086,
              "y": -11.076,
              "z": 0.14
            },
            "gtin": "8720181414282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1d6c9db2646e2d4eeb0141bb",
            "leftCorner": {
              "x": -33.086,
              "y": -11.076,
              "z": 0.14
            },
            "rightCorner": {
              "x": -33.042,
              "y": -11.075,
              "z": 0.14
            },
            "gtin": "4051089815203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3be4557c94f359b544c01eaf",
            "leftCorner": {
              "x": -33.042,
              "y": -11.075,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.993,
              "y": -11.073,
              "z": 0.14
            },
            "gtin": "4008491112154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "40e02da4690325fd9645fd79",
            "leftCorner": {
              "x": -32.993,
              "y": -11.073,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.939,
              "y": -11.072,
              "z": 0.14
            },
            "gtin": "4008233174587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ce08c62fa0f00e467af21905",
            "leftCorner": {
              "x": -32.939,
              "y": -11.072,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.881,
              "y": -11.071,
              "z": 0.14
            },
            "gtin": "4008491107754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "54a409e69d62d61fdf4f3656",
            "leftCorner": {
              "x": -32.881,
              "y": -11.071,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.821,
              "y": -11.07,
              "z": 0.14
            },
            "gtin": "4008233165745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6cc75229c554b4a2aba73a60",
            "leftCorner": {
              "x": -32.821,
              "y": -11.07,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.759,
              "y": -11.068,
              "z": 0.14
            },
            "gtin": "4021457644513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7528d841bbd270be1111d459",
            "leftCorner": {
              "x": -32.759,
              "y": -11.068,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.696,
              "y": -11.067,
              "z": 0.14
            },
            "gtin": "4006000039435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "45a21d5ba5ee0e511936f604",
            "leftCorner": {
              "x": -32.696,
              "y": -11.067,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.631,
              "y": -11.065,
              "z": 0.14
            },
            "gtin": "8720181380006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f8418bb250319235463293f1",
            "leftCorner": {
              "x": -32.631,
              "y": -11.065,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.564,
              "y": -11.064,
              "z": 0.14
            },
            "gtin": "4008233109121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fa7fb1ead3d4b83f65f159d7",
            "leftCorner": {
              "x": -32.564,
              "y": -11.064,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.497,
              "y": -11.062,
              "z": 0.14
            },
            "gtin": "4008233052250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "45351a62d7fc993590f8985c",
            "leftCorner": {
              "x": -32.497,
              "y": -11.062,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.429,
              "y": -11.061,
              "z": 0.14
            },
            "gtin": "4021457637454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fb401afc1ac67517eefbe2e1",
            "leftCorner": {
              "x": -32.429,
              "y": -11.061,
              "z": 0.14
            },
            "rightCorner": {
              "x": -32.159,
              "y": -11.054,
              "z": 0.14
            },
            "gtin": "3574661785318",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d79d",
        "height": 0.51212,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a48",
            "leftCorner": {
              "x": -33.408,
              "y": -11.07,
              "z": 0.419
            },
            "rightCorner": {
              "x": -33.166,
              "y": -11.064,
              "z": 0.419
            },
            "gtin": "4008890006504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a4c",
            "leftCorner": {
              "x": -33.168,
              "y": -11.022,
              "z": 0.419
            },
            "rightCorner": {
              "x": -33.101,
              "y": -11.02,
              "z": 0.419
            },
            "gtin": "4008233052250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a4d",
            "leftCorner": {
              "x": -33.101,
              "y": -11.024,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.997,
              "y": -11.021,
              "z": 0.419
            },
            "gtin": "4008233038438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a4e",
            "leftCorner": {
              "x": -32.997,
              "y": -11.024,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.931,
              "y": -11.023,
              "z": 0.419
            },
            "gtin": "4008491119405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a4f",
            "leftCorner": {
              "x": -32.931,
              "y": -11.021,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.891,
              "y": -11.02,
              "z": 0.419
            },
            "gtin": "4008491112154",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a50",
            "leftCorner": {
              "x": -32.891,
              "y": -11.018,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.81,
              "y": -11.016,
              "z": 0.419
            },
            "gtin": "4008233165233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a51",
            "leftCorner": {
              "x": -32.81,
              "y": -11.015,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.745,
              "y": -11.014,
              "z": 0.419
            },
            "gtin": "4008233109121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a52",
            "leftCorner": {
              "x": -32.745,
              "y": -11.013,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.642,
              "y": -11.011,
              "z": 0.419
            },
            "gtin": "4008233104003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a53",
            "leftCorner": {
              "x": -32.642,
              "y": -11.022,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.514,
              "y": -11.019,
              "z": 0.419
            },
            "gtin": "4008233158211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a54",
            "leftCorner": {
              "x": -32.514,
              "y": -11.015,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.445,
              "y": -11.013,
              "z": 0.419
            },
            "gtin": "4008233168685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a55",
            "leftCorner": {
              "x": -32.445,
              "y": -11.013,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.376,
              "y": -11.012,
              "z": 0.419
            },
            "gtin": "4008233168685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a56",
            "leftCorner": {
              "x": -32.376,
              "y": -11.012,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.316,
              "y": -11.01,
              "z": 0.419
            },
            "gtin": "4008233165745",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a49",
            "leftCorner": {
              "x": -32.316,
              "y": -11.006,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.264,
              "y": -11.005,
              "z": 0.419
            },
            "gtin": "4008233176635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a4a",
            "leftCorner": {
              "x": -32.264,
              "y": -11.005,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.212,
              "y": -11.004,
              "z": 0.419
            },
            "gtin": "4008233176635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a4b",
            "leftCorner": {
              "x": -32.212,
              "y": -11.004,
              "z": 0.419
            },
            "rightCorner": {
              "x": -32.16,
              "y": -11.002,
              "z": 0.419
            },
            "gtin": "4008233176635",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7a1",
        "height": 0.81266,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a81",
            "leftCorner": {
              "x": -33.169,
              "y": -11.021,
              "z": 0.665
            },
            "rightCorner": {
              "x": -33.08,
              "y": -11.02,
              "z": 0.665
            },
            "gtin": "4008491480420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "224e87798ee33e1a3b87200d",
            "leftCorner": {
              "x": -33.408,
              "y": -11.069,
              "z": 0.665
            },
            "rightCorner": {
              "x": -33.169,
              "y": -11.063,
              "z": 0.665
            },
            "gtin": "4008491103251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a82",
            "leftCorner": {
              "x": -33.08,
              "y": -11.024,
              "z": 0.665
            },
            "rightCorner": {
              "x": -33.009,
              "y": -11.022,
              "z": 0.665
            },
            "gtin": "4008491106993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a83",
            "leftCorner": {
              "x": -33.009,
              "y": -11.023,
              "z": 0.665
            },
            "rightCorner": {
              "x": -32.899,
              "y": -11.02,
              "z": 0.665
            },
            "gtin": "4008491103213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a84",
            "leftCorner": {
              "x": -32.899,
              "y": -11.017,
              "z": 0.665
            },
            "rightCorner": {
              "x": -32.803,
              "y": -11.015,
              "z": 0.665
            },
            "gtin": "4008491480697",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a85",
            "leftCorner": {
              "x": -32.803,
              "y": -11.015,
              "z": 0.665
            },
            "rightCorner": {
              "x": -32.709,
              "y": -11.014,
              "z": 0.665
            },
            "gtin": "4008491105927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a86",
            "leftCorner": {
              "x": -32.709,
              "y": -11.014,
              "z": 0.665
            },
            "rightCorner": {
              "x": -32.669,
              "y": -11.013,
              "z": 0.665
            },
            "gtin": "4008491103435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a87",
            "leftCorner": {
              "x": -32.669,
              "y": -11.016,
              "z": 0.665
            },
            "rightCorner": {
              "x": -32.596,
              "y": -11.014,
              "z": 0.665
            },
            "gtin": "4008491107754",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a88",
            "leftCorner": {
              "x": -32.595,
              "y": -11.015,
              "z": 0.665
            },
            "rightCorner": {
              "x": -32.492,
              "y": -11.013,
              "z": 0.665
            },
            "gtin": "4008233128009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a89",
            "leftCorner": {
              "x": -32.492,
              "y": -11.019,
              "z": 0.665
            },
            "rightCorner": {
              "x": -32.396,
              "y": -11.016,
              "z": 0.665
            },
            "gtin": "4008491106993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a8a",
            "leftCorner": {
              "x": -32.396,
              "y": -11.015,
              "z": 0.665
            },
            "rightCorner": {
              "x": -32.301,
              "y": -11.013,
              "z": 0.665
            },
            "gtin": "4008233153544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a8b",
            "leftCorner": {
              "x": -32.301,
              "y": -11.007,
              "z": 0.665
            },
            "rightCorner": {
              "x": -32.201,
              "y": -11.006,
              "z": 0.665
            },
            "gtin": "4008233172439",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7a0",
        "height": 1.1017,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a74",
            "leftCorner": {
              "x": -33.408,
              "y": -11.057,
              "z": 0.901
            },
            "rightCorner": {
              "x": -33.144,
              "y": -11.05,
              "z": 0.901
            },
            "gtin": "4306188049715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a75",
            "leftCorner": {
              "x": -33.144,
              "y": -11.01,
              "z": 0.901
            },
            "rightCorner": {
              "x": -33.049,
              "y": -11.008,
              "z": 0.901
            },
            "gtin": "4008268002817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a76",
            "leftCorner": {
              "x": -33.049,
              "y": -11.012,
              "z": 0.901
            },
            "rightCorner": {
              "x": -32.97,
              "y": -11.01,
              "z": 0.901
            },
            "gtin": "4013162025534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a77",
            "leftCorner": {
              "x": -32.97,
              "y": -11.011,
              "z": 0.901
            },
            "rightCorner": {
              "x": -32.894,
              "y": -11.009,
              "z": 0.901
            },
            "gtin": "4013162026050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a78",
            "leftCorner": {
              "x": -32.894,
              "y": -11.006,
              "z": 0.901
            },
            "rightCorner": {
              "x": -32.754,
              "y": -11.002,
              "z": 0.901
            },
            "gtin": "3574661687841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a79",
            "leftCorner": {
              "x": -32.754,
              "y": -11.001,
              "z": 0.901
            },
            "rightCorner": {
              "x": -32.692,
              "y": -11.0,
              "z": 0.901
            },
            "gtin": "4006000083810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a7a",
            "leftCorner": {
              "x": -32.692,
              "y": -11.0,
              "z": 0.901
            },
            "rightCorner": {
              "x": -32.579,
              "y": -10.997,
              "z": 0.901
            },
            "gtin": "4006000147598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a7b",
            "leftCorner": {
              "x": -32.579,
              "y": -11.006,
              "z": 0.901
            },
            "rightCorner": {
              "x": -32.487,
              "y": -11.004,
              "z": 0.901
            },
            "gtin": "4006000083353",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a7c",
            "leftCorner": {
              "x": -32.487,
              "y": -11.006,
              "z": 0.901
            },
            "rightCorner": {
              "x": -32.406,
              "y": -11.004,
              "z": 0.901
            },
            "gtin": "4005900669865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a7d",
            "leftCorner": {
              "x": -32.406,
              "y": -11.004,
              "z": 0.901
            },
            "rightCorner": {
              "x": -32.325,
              "y": -11.001,
              "z": 0.901
            },
            "gtin": "4006000083391",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a7e",
            "leftCorner": {
              "x": -32.325,
              "y": -10.996,
              "z": 0.901
            },
            "rightCorner": {
              "x": -32.18,
              "y": -10.994,
              "z": 0.901
            },
            "gtin": "4006000083315",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d79f",
        "height": 1.4045,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a66",
            "leftCorner": {
              "x": -33.408,
              "y": -11.068,
              "z": 1.149
            },
            "rightCorner": {
              "x": -33.152,
              "y": -11.062,
              "z": 1.149
            },
            "gtin": "3574661785318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a68",
            "leftCorner": {
              "x": -33.153,
              "y": -11.014,
              "z": 1.149
            },
            "rightCorner": {
              "x": -33.084,
              "y": -11.012,
              "z": 1.149
            },
            "gtin": "3574661783390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a69",
            "leftCorner": {
              "x": -33.084,
              "y": -11.021,
              "z": 1.149
            },
            "rightCorner": {
              "x": -33.011,
              "y": -11.019,
              "z": 1.149
            },
            "gtin": "3574661751337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a6a",
            "leftCorner": {
              "x": -33.011,
              "y": -11.019,
              "z": 1.149
            },
            "rightCorner": {
              "x": -32.92,
              "y": -11.016,
              "z": 1.149
            },
            "gtin": "3574661751368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a6b",
            "leftCorner": {
              "x": -32.92,
              "y": -11.014,
              "z": 1.149
            },
            "rightCorner": {
              "x": -32.822,
              "y": -11.013,
              "z": 1.149
            },
            "gtin": "3600551033082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a6c",
            "leftCorner": {
              "x": -32.822,
              "y": -11.013,
              "z": 1.149
            },
            "rightCorner": {
              "x": -32.712,
              "y": -11.011,
              "z": 1.149
            },
            "gtin": "3600541334458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a6d",
            "leftCorner": {
              "x": -32.712,
              "y": -11.012,
              "z": 1.149
            },
            "rightCorner": {
              "x": -32.657,
              "y": -11.01,
              "z": 1.149
            },
            "gtin": "3600541334496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a6e",
            "leftCorner": {
              "x": -32.657,
              "y": -11.022,
              "z": 1.149
            },
            "rightCorner": {
              "x": -32.572,
              "y": -11.02,
              "z": 1.149
            },
            "gtin": "4008233174570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a6f",
            "leftCorner": {
              "x": -32.572,
              "y": -11.015,
              "z": 1.149
            },
            "rightCorner": {
              "x": -32.512,
              "y": -11.013,
              "z": 1.149
            },
            "gtin": "4008233174587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a70",
            "leftCorner": {
              "x": -32.512,
              "y": -11.016,
              "z": 1.149
            },
            "rightCorner": {
              "x": -32.438,
              "y": -11.014,
              "z": 1.149
            },
            "gtin": "8720181380006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a71",
            "leftCorner": {
              "x": -32.438,
              "y": -11.013,
              "z": 1.149
            },
            "rightCorner": {
              "x": -32.369,
              "y": -11.011,
              "z": 1.149
            },
            "gtin": "8720181085642",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a72",
            "leftCorner": {
              "x": -32.369,
              "y": -11.006,
              "z": 1.149
            },
            "rightCorner": {
              "x": -32.314,
              "y": -11.004,
              "z": 1.149
            },
            "gtin": "8720181085659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a73",
            "leftCorner": {
              "x": -32.314,
              "y": -11.005,
              "z": 1.149
            },
            "rightCorner": {
              "x": -32.242,
              "y": -11.003,
              "z": 1.149
            },
            "gtin": "8720181085666",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a67",
            "leftCorner": {
              "x": -32.242,
              "y": -10.999,
              "z": 1.149
            },
            "rightCorner": {
              "x": -32.16,
              "y": -10.997,
              "z": 1.149
            },
            "gtin": "8720181414282",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d79e",
        "height": 1.7043,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a57",
            "leftCorner": {
              "x": -33.408,
              "y": -11.064,
              "z": 1.394
            },
            "rightCorner": {
              "x": -33.227,
              "y": -11.06,
              "z": 1.394
            },
            "gtin": "2000439121817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a59",
            "leftCorner": {
              "x": -33.228,
              "y": -11.011,
              "z": 1.394
            },
            "rightCorner": {
              "x": -33.19,
              "y": -11.009,
              "z": 1.394
            },
            "gtin": "6001159111375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a5a",
            "leftCorner": {
              "x": -33.19,
              "y": -11.011,
              "z": 1.394
            },
            "rightCorner": {
              "x": -33.137,
              "y": -11.01,
              "z": 1.394
            },
            "gtin": "6001159111375",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a5b",
            "leftCorner": {
              "x": -33.137,
              "y": -11.012,
              "z": 1.394
            },
            "rightCorner": {
              "x": -33.086,
              "y": -11.011,
              "z": 1.394
            },
            "gtin": "4006000039435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a5c",
            "leftCorner": {
              "x": -33.086,
              "y": -11.017,
              "z": 1.394
            },
            "rightCorner": {
              "x": -32.994,
              "y": -11.014,
              "z": 1.394
            },
            "gtin": "4260370432504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a5d",
            "leftCorner": {
              "x": -32.994,
              "y": -11.016,
              "z": 1.394
            },
            "rightCorner": {
              "x": -32.918,
              "y": -11.014,
              "z": 1.394
            },
            "gtin": "4260370437509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a5e",
            "leftCorner": {
              "x": -32.918,
              "y": -11.014,
              "z": 1.394
            },
            "rightCorner": {
              "x": -32.842,
              "y": -11.012,
              "z": 1.394
            },
            "gtin": "4260370437509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a5f",
            "leftCorner": {
              "x": -32.842,
              "y": -11.01,
              "z": 1.394
            },
            "rightCorner": {
              "x": -32.769,
              "y": -11.009,
              "z": 1.394
            },
            "gtin": "4051089815098",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a60",
            "leftCorner": {
              "x": -32.769,
              "y": -11.01,
              "z": 1.394
            },
            "rightCorner": {
              "x": -32.699,
              "y": -11.008,
              "z": 1.394
            },
            "gtin": "4051089815203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a61",
            "leftCorner": {
              "x": -32.699,
              "y": -11.007,
              "z": 1.394
            },
            "rightCorner": {
              "x": -32.655,
              "y": -11.007,
              "z": 1.394
            },
            "gtin": "4021457644513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a62",
            "leftCorner": {
              "x": -32.655,
              "y": -11.011,
              "z": 1.394
            },
            "rightCorner": {
              "x": -32.53,
              "y": -11.008,
              "z": 1.394
            },
            "gtin": "4021457637423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a63",
            "leftCorner": {
              "x": -32.53,
              "y": -11.016,
              "z": 1.394
            },
            "rightCorner": {
              "x": -32.464,
              "y": -11.014,
              "z": 1.394
            },
            "gtin": "4021457637454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a64",
            "leftCorner": {
              "x": -32.464,
              "y": -11.015,
              "z": 1.394
            },
            "rightCorner": {
              "x": -32.426,
              "y": -11.014,
              "z": 1.394
            },
            "gtin": "4021457637416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a65",
            "leftCorner": {
              "x": -32.426,
              "y": -11.016,
              "z": 1.394
            },
            "rightCorner": {
              "x": -32.319,
              "y": -11.013,
              "z": 1.394
            },
            "gtin": "4008890006443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a58",
            "leftCorner": {
              "x": -32.319,
              "y": -11.005,
              "z": 1.394
            },
            "rightCorner": {
              "x": -32.16,
              "y": -11.001,
              "z": 1.394
            },
            "gtin": "4103040104601",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "c43"
  },
  {
    "id": "c43",
    "name": "c43",
    "x": -32.162,
    "y": -10.912,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.011449,
      "w": 0.99993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 105
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3f3",
        "height": 0.16942,
        "facings": [
          {
            "id": "9a013fc2b57cc47f24e9f761",
            "leftCorner": {
              "x": -32.161,
              "y": -10.993,
              "z": 0.139
            },
            "rightCorner": {
              "x": -32.114,
              "y": -10.992,
              "z": 0.139
            },
            "gtin": "4008233126326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dde735c6684f2135dbcf02b3",
            "leftCorner": {
              "x": -32.114,
              "y": -10.992,
              "z": 0.139
            },
            "rightCorner": {
              "x": -32.058,
              "y": -10.991,
              "z": 0.139
            },
            "gtin": "4045612010210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee8f4c0d0dee693185f62713",
            "leftCorner": {
              "x": -32.058,
              "y": -10.991,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.997,
              "y": -10.989,
              "z": 0.139
            },
            "gtin": "4006000170428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "28d5f03e388ca220ea1be62b",
            "leftCorner": {
              "x": -31.997,
              "y": -10.989,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.951,
              "y": -10.988,
              "z": 0.139
            },
            "gtin": "4008233126326",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fef9722e413a8df09063650b",
            "leftCorner": {
              "x": -31.951,
              "y": -10.988,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.899,
              "y": -10.987,
              "z": 0.139
            },
            "gtin": "4013162019250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a55b984a23a90d8ca6aaf87d",
            "leftCorner": {
              "x": -31.899,
              "y": -10.987,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.843,
              "y": -10.986,
              "z": 0.139
            },
            "gtin": "4045612010210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "14ed744c2567c87f7e862158",
            "leftCorner": {
              "x": -31.843,
              "y": -10.986,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.782,
              "y": -10.984,
              "z": 0.139
            },
            "gtin": "8714789732923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6309b8743fab46a63cdc683f",
            "leftCorner": {
              "x": -31.782,
              "y": -10.984,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.721,
              "y": -10.983,
              "z": 0.139
            },
            "gtin": "4021457648412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7778475554ce30e11be0d8da",
            "leftCorner": {
              "x": -31.721,
              "y": -10.983,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.66,
              "y": -10.982,
              "z": 0.139
            },
            "gtin": "4006000170428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e731a5bfb11fedf3172873db",
            "leftCorner": {
              "x": -31.66,
              "y": -10.982,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.598,
              "y": -10.98,
              "z": 0.139
            },
            "gtin": "4013162035267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "35ea77ead00bbe5b70a62791",
            "leftCorner": {
              "x": -31.598,
              "y": -10.98,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.535,
              "y": -10.979,
              "z": 0.139
            },
            "gtin": "8718951076228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "18c37ed433ec18c667dc620b",
            "leftCorner": {
              "x": -31.535,
              "y": -10.979,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.472,
              "y": -10.977,
              "z": 0.139
            },
            "gtin": "4008268003159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "19766f4b72c0d75f29f4066a",
            "leftCorner": {
              "x": -31.472,
              "y": -10.977,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.409,
              "y": -10.976,
              "z": 0.139
            },
            "gtin": "4008233042541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fe1ca90cba9851865f9b533c",
            "leftCorner": {
              "x": -31.409,
              "y": -10.976,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.345,
              "y": -10.974,
              "z": 0.139
            },
            "gtin": "8720181334016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "556284ef5e05a533d254cbfd",
            "leftCorner": {
              "x": -31.345,
              "y": -10.974,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.28,
              "y": -10.973,
              "z": 0.139
            },
            "gtin": "8720181334139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7f2254cc29146641735226c1",
            "leftCorner": {
              "x": -31.28,
              "y": -10.973,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.215,
              "y": -10.971,
              "z": 0.139
            },
            "gtin": "8008970056609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8cb93873cf76a7dec9f0663f",
            "leftCorner": {
              "x": -31.215,
              "y": -10.971,
              "z": 0.139
            },
            "rightCorner": {
              "x": -31.052,
              "y": -10.968,
              "z": 0.139
            },
            "gtin": "4006000137827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "63a001fb2237b98c4ecc64e9",
            "leftCorner": {
              "x": -31.052,
              "y": -10.968,
              "z": 0.139
            },
            "rightCorner": {
              "x": -30.912,
              "y": -10.964,
              "z": 0.139
            },
            "gtin": "8720181702242",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3f0",
        "height": 0.46262,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d746f",
            "leftCorner": {
              "x": -32.161,
              "y": -10.969,
              "z": 0.379
            },
            "rightCorner": {
              "x": -32.1,
              "y": -10.967,
              "z": 0.379
            },
            "gtin": "8720181334030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7470",
            "leftCorner": {
              "x": -32.1,
              "y": -10.967,
              "z": 0.379
            },
            "rightCorner": {
              "x": -32.039,
              "y": -10.966,
              "z": 0.379
            },
            "gtin": "8720181334030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7471",
            "leftCorner": {
              "x": -32.039,
              "y": -10.966,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.977,
              "y": -10.965,
              "z": 0.379
            },
            "gtin": "8720181334030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7473",
            "leftCorner": {
              "x": -31.979,
              "y": -10.924,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.909,
              "y": -10.922,
              "z": 0.379
            },
            "gtin": "8720181334108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7474",
            "leftCorner": {
              "x": -31.909,
              "y": -10.922,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.83,
              "y": -10.92,
              "z": 0.379
            },
            "gtin": "8720181400254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7475",
            "leftCorner": {
              "x": -31.83,
              "y": -10.92,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.767,
              "y": -10.919,
              "z": 0.379
            },
            "gtin": "8720181334016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7476",
            "leftCorner": {
              "x": -31.767,
              "y": -10.916,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.695,
              "y": -10.914,
              "z": 0.379
            },
            "gtin": "8720181400247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7477",
            "leftCorner": {
              "x": -31.695,
              "y": -10.919,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.625,
              "y": -10.917,
              "z": 0.379
            },
            "gtin": "8720181685880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7478",
            "leftCorner": {
              "x": -31.625,
              "y": -10.918,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.561,
              "y": -10.917,
              "z": 0.379
            },
            "gtin": "8720181334139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7479",
            "leftCorner": {
              "x": -31.561,
              "y": -10.916,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.485,
              "y": -10.915,
              "z": 0.379
            },
            "gtin": "8720181334061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d747a",
            "leftCorner": {
              "x": -31.485,
              "y": -10.914,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.408,
              "y": -10.912,
              "z": 0.379
            },
            "gtin": "8714789732916",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d747b",
            "leftCorner": {
              "x": -31.408,
              "y": -10.911,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.33,
              "y": -10.91,
              "z": 0.379
            },
            "gtin": "8714789732886",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d747c",
            "leftCorner": {
              "x": -31.33,
              "y": -10.909,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.248,
              "y": -10.908,
              "z": 0.379
            },
            "gtin": "8714789732893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d747d",
            "leftCorner": {
              "x": -31.248,
              "y": -10.907,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.176,
              "y": -10.906,
              "z": 0.379
            },
            "gtin": "8714789732947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d747e",
            "leftCorner": {
              "x": -31.176,
              "y": -10.906,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.117,
              "y": -10.905,
              "z": 0.379
            },
            "gtin": "8714789732923",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d747f",
            "leftCorner": {
              "x": -31.116,
              "y": -10.909,
              "z": 0.379
            },
            "rightCorner": {
              "x": -31.032,
              "y": -10.907,
              "z": 0.379
            },
            "gtin": "8718951593442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7480",
            "leftCorner": {
              "x": -31.032,
              "y": -10.905,
              "z": 0.379
            },
            "rightCorner": {
              "x": -30.97,
              "y": -10.903,
              "z": 0.379
            },
            "gtin": "8718951076228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7472",
            "leftCorner": {
              "x": -30.97,
              "y": -10.903,
              "z": 0.379
            },
            "rightCorner": {
              "x": -30.912,
              "y": -10.902,
              "z": 0.379
            },
            "gtin": "8718951076181",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3ed",
        "height": 0.70957,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7443",
            "leftCorner": {
              "x": -32.161,
              "y": -10.973,
              "z": 0.581
            },
            "rightCorner": {
              "x": -32.042,
              "y": -10.971,
              "z": 0.581
            },
            "gtin": "8720181466373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7445",
            "leftCorner": {
              "x": -32.043,
              "y": -10.93,
              "z": 0.581
            },
            "rightCorner": {
              "x": -31.947,
              "y": -10.928,
              "z": 0.581
            },
            "gtin": "8720181657504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7446",
            "leftCorner": {
              "x": -31.947,
              "y": -10.925,
              "z": 0.581
            },
            "rightCorner": {
              "x": -31.875,
              "y": -10.924,
              "z": 0.581
            },
            "gtin": "8720181466526",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7447",
            "leftCorner": {
              "x": -31.875,
              "y": -10.926,
              "z": 0.581
            },
            "rightCorner": {
              "x": -31.792,
              "y": -10.925,
              "z": 0.581
            },
            "gtin": "8720181471629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7448",
            "leftCorner": {
              "x": -31.792,
              "y": -10.927,
              "z": 0.581
            },
            "rightCorner": {
              "x": -31.724,
              "y": -10.925,
              "z": 0.581
            },
            "gtin": "8720181468520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7449",
            "leftCorner": {
              "x": -31.724,
              "y": -10.928,
              "z": 0.581
            },
            "rightCorner": {
              "x": -31.586,
              "y": -10.925,
              "z": 0.581
            },
            "gtin": "8720181702242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d744a",
            "leftCorner": {
              "x": -31.586,
              "y": -10.92,
              "z": 0.581
            },
            "rightCorner": {
              "x": -31.508,
              "y": -10.918,
              "z": 0.581
            },
            "gtin": "8720181443459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d744b",
            "leftCorner": {
              "x": -31.508,
              "y": -10.92,
              "z": 0.581
            },
            "rightCorner": {
              "x": -31.425,
              "y": -10.919,
              "z": 0.581
            },
            "gtin": "8720181460029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d744c",
            "leftCorner": {
              "x": -31.425,
              "y": -10.914,
              "z": 0.581
            },
            "rightCorner": {
              "x": -31.348,
              "y": -10.911,
              "z": 0.581
            },
            "gtin": "8720181491948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d744d",
            "leftCorner": {
              "x": -31.348,
              "y": -10.913,
              "z": 0.581
            },
            "rightCorner": {
              "x": -31.259,
              "y": -10.911,
              "z": 0.581
            },
            "gtin": "8720181608278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d744e",
            "leftCorner": {
              "x": -31.259,
              "y": -10.91,
              "z": 0.581
            },
            "rightCorner": {
              "x": -31.184,
              "y": -10.909,
              "z": 0.581
            },
            "gtin": "8710447217054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d744f",
            "leftCorner": {
              "x": -31.184,
              "y": -10.912,
              "z": 0.581
            },
            "rightCorner": {
              "x": -31.095,
              "y": -10.91,
              "z": 0.581
            },
            "gtin": "8720181507281",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7450",
            "leftCorner": {
              "x": -31.095,
              "y": -10.917,
              "z": 0.581
            },
            "rightCorner": {
              "x": -31.038,
              "y": -10.916,
              "z": 0.581
            },
            "gtin": "4008268003159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7444",
            "leftCorner": {
              "x": -31.038,
              "y": -10.916,
              "z": 0.581
            },
            "rightCorner": {
              "x": -30.912,
              "y": -10.913,
              "z": 0.581
            },
            "gtin": "4008268002800",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3f2",
        "height": 0.95127,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d748e",
            "leftCorner": {
              "x": -32.161,
              "y": -10.963,
              "z": 0.778
            },
            "rightCorner": {
              "x": -32.011,
              "y": -10.959,
              "z": 0.778
            },
            "gtin": "4005808808243",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7490",
            "leftCorner": {
              "x": -32.013,
              "y": -10.925,
              "z": 0.778
            },
            "rightCorner": {
              "x": -31.931,
              "y": -10.922,
              "z": 0.778
            },
            "gtin": "4006000137513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7491",
            "leftCorner": {
              "x": -31.931,
              "y": -10.917,
              "z": 0.778
            },
            "rightCorner": {
              "x": -31.771,
              "y": -10.913,
              "z": 0.778
            },
            "gtin": "4006000137827",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7492",
            "leftCorner": {
              "x": -31.771,
              "y": -10.911,
              "z": 0.778
            },
            "rightCorner": {
              "x": -31.695,
              "y": -10.909,
              "z": 0.778
            },
            "gtin": "4006000143910",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7493",
            "leftCorner": {
              "x": -31.695,
              "y": -10.911,
              "z": 0.778
            },
            "rightCorner": {
              "x": -31.613,
              "y": -10.91,
              "z": 0.778
            },
            "gtin": "4006000137780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7494",
            "leftCorner": {
              "x": -31.613,
              "y": -10.912,
              "z": 0.778
            },
            "rightCorner": {
              "x": -31.56,
              "y": -10.911,
              "z": 0.778
            },
            "gtin": "4006000137476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7495",
            "leftCorner": {
              "x": -31.56,
              "y": -10.914,
              "z": 0.778
            },
            "rightCorner": {
              "x": -31.412,
              "y": -10.911,
              "z": 0.778
            },
            "gtin": "4006000137476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7496",
            "leftCorner": {
              "x": -31.412,
              "y": -10.902,
              "z": 0.778
            },
            "rightCorner": {
              "x": -31.322,
              "y": -10.901,
              "z": 0.778
            },
            "gtin": "4006000137599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7497",
            "leftCorner": {
              "x": -31.322,
              "y": -10.901,
              "z": 0.778
            },
            "rightCorner": {
              "x": -31.231,
              "y": -10.898,
              "z": 0.778
            },
            "gtin": "4006000137599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7498",
            "leftCorner": {
              "x": -31.231,
              "y": -10.899,
              "z": 0.778
            },
            "rightCorner": {
              "x": -31.086,
              "y": -10.896,
              "z": 0.778
            },
            "gtin": "4006000137865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7499",
            "leftCorner": {
              "x": -31.086,
              "y": -10.899,
              "z": 0.778
            },
            "rightCorner": {
              "x": -31.006,
              "y": -10.898,
              "z": 0.778
            },
            "gtin": "4006000081045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d748f",
            "leftCorner": {
              "x": -31.006,
              "y": -10.896,
              "z": 0.778
            },
            "rightCorner": {
              "x": -30.912,
              "y": -10.894,
              "z": 0.778
            },
            "gtin": "4006000137551",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3f1",
        "height": 1.2015,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7481",
            "leftCorner": {
              "x": -32.161,
              "y": -10.963,
              "z": 0.983
            },
            "rightCorner": {
              "x": -32.015,
              "y": -10.96,
              "z": 0.983
            },
            "gtin": "4001499943980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7482",
            "leftCorner": {
              "x": -32.015,
              "y": -10.96,
              "z": 0.983
            },
            "rightCorner": {
              "x": -31.868,
              "y": -10.956,
              "z": 0.983
            },
            "gtin": "4001499943980",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7485",
            "leftCorner": {
              "x": -31.869,
              "y": -10.916,
              "z": 0.983
            },
            "rightCorner": {
              "x": -31.755,
              "y": -10.913,
              "z": 0.983
            },
            "gtin": "4001499959837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7486",
            "leftCorner": {
              "x": -31.755,
              "y": -10.912,
              "z": 0.983
            },
            "rightCorner": {
              "x": -31.642,
              "y": -10.91,
              "z": 0.983
            },
            "gtin": "4001499943973",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7487",
            "leftCorner": {
              "x": -31.642,
              "y": -10.911,
              "z": 0.983
            },
            "rightCorner": {
              "x": -31.541,
              "y": -10.91,
              "z": 0.983
            },
            "gtin": "4001499949180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7488",
            "leftCorner": {
              "x": -31.541,
              "y": -10.912,
              "z": 0.983
            },
            "rightCorner": {
              "x": -31.452,
              "y": -10.909,
              "z": 0.983
            },
            "gtin": "4001499964824",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7489",
            "leftCorner": {
              "x": -31.452,
              "y": -10.906,
              "z": 0.983
            },
            "rightCorner": {
              "x": -31.389,
              "y": -10.904,
              "z": 0.983
            },
            "gtin": "4013162035267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d748a",
            "leftCorner": {
              "x": -31.389,
              "y": -10.907,
              "z": 0.983
            },
            "rightCorner": {
              "x": -31.334,
              "y": -10.905,
              "z": 0.983
            },
            "gtin": "4013162019250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d748b",
            "leftCorner": {
              "x": -31.334,
              "y": -10.905,
              "z": 0.983
            },
            "rightCorner": {
              "x": -31.244,
              "y": -10.904,
              "z": 0.983
            },
            "gtin": "4013162019236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d748c",
            "leftCorner": {
              "x": -31.244,
              "y": -10.904,
              "z": 0.983
            },
            "rightCorner": {
              "x": -31.167,
              "y": -10.902,
              "z": 0.983
            },
            "gtin": "4013162025473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d748d",
            "leftCorner": {
              "x": -31.167,
              "y": -10.902,
              "z": 0.983
            },
            "rightCorner": {
              "x": -31.09,
              "y": -10.9,
              "z": 0.983
            },
            "gtin": "4013162025473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7483",
            "leftCorner": {
              "x": -31.09,
              "y": -10.898,
              "z": 0.983
            },
            "rightCorner": {
              "x": -31.001,
              "y": -10.897,
              "z": 0.983
            },
            "gtin": "3574661384382",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7484",
            "leftCorner": {
              "x": -31.001,
              "y": -10.897,
              "z": 0.983
            },
            "rightCorner": {
              "x": -30.912,
              "y": -10.894,
              "z": 0.983
            },
            "gtin": "3574661384382",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3ef",
        "height": 1.4527,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7462",
            "leftCorner": {
              "x": -32.161,
              "y": -10.974,
              "z": 1.189
            },
            "rightCorner": {
              "x": -32.072,
              "y": -10.973,
              "z": 1.189
            },
            "gtin": "8008970060446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7463",
            "leftCorner": {
              "x": -32.073,
              "y": -10.929,
              "z": 1.189
            },
            "rightCorner": {
              "x": -32.002,
              "y": -10.927,
              "z": 1.189
            },
            "gtin": "8008970058252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7464",
            "leftCorner": {
              "x": -32.002,
              "y": -10.927,
              "z": 1.189
            },
            "rightCorner": {
              "x": -31.93,
              "y": -10.926,
              "z": 1.189
            },
            "gtin": "8008970056609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7465",
            "leftCorner": {
              "x": -31.93,
              "y": -10.926,
              "z": 1.189
            },
            "rightCorner": {
              "x": -31.833,
              "y": -10.923,
              "z": 1.189
            },
            "gtin": "8008970056586",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7466",
            "leftCorner": {
              "x": -31.833,
              "y": -10.923,
              "z": 1.189
            },
            "rightCorner": {
              "x": -31.762,
              "y": -10.921,
              "z": 1.189
            },
            "gtin": "4008233114781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7467",
            "leftCorner": {
              "x": -31.762,
              "y": -10.921,
              "z": 1.189
            },
            "rightCorner": {
              "x": -31.691,
              "y": -10.92,
              "z": 1.189
            },
            "gtin": "4008233114781",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7468",
            "leftCorner": {
              "x": -31.691,
              "y": -10.925,
              "z": 1.189
            },
            "rightCorner": {
              "x": -31.621,
              "y": -10.923,
              "z": 1.189
            },
            "gtin": "4008233171791",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7469",
            "leftCorner": {
              "x": -31.621,
              "y": -10.924,
              "z": 1.189
            },
            "rightCorner": {
              "x": -31.46,
              "y": -10.92,
              "z": 1.189
            },
            "gtin": "4008233165523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d746a",
            "leftCorner": {
              "x": -31.46,
              "y": -10.918,
              "z": 1.189
            },
            "rightCorner": {
              "x": -31.297,
              "y": -10.915,
              "z": 1.189
            },
            "gtin": "4008233114804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d746b",
            "leftCorner": {
              "x": -31.297,
              "y": -10.915,
              "z": 1.189
            },
            "rightCorner": {
              "x": -31.216,
              "y": -10.913,
              "z": 1.189
            },
            "gtin": "4008233143583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d746c",
            "leftCorner": {
              "x": -31.216,
              "y": -10.912,
              "z": 1.189
            },
            "rightCorner": {
              "x": -31.085,
              "y": -10.91,
              "z": 1.189
            },
            "gtin": "4008233042541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d746d",
            "leftCorner": {
              "x": -31.085,
              "y": -10.909,
              "z": 1.189
            },
            "rightCorner": {
              "x": -31.0,
              "y": -10.907,
              "z": 1.189
            },
            "gtin": "4045612010685",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d746e",
            "leftCorner": {
              "x": -31.0,
              "y": -10.908,
              "z": 1.189
            },
            "rightCorner": {
              "x": -30.945,
              "y": -10.907,
              "z": 1.189
            },
            "gtin": "4045612010692",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3ee",
        "height": 1.7015,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7451",
            "leftCorner": {
              "x": -32.161,
              "y": -10.974,
              "z": 1.392
            },
            "rightCorner": {
              "x": -32.106,
              "y": -10.973,
              "z": 1.392
            },
            "gtin": "7611916124501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7452",
            "leftCorner": {
              "x": -32.106,
              "y": -10.973,
              "z": 1.392
            },
            "rightCorner": {
              "x": -32.051,
              "y": -10.971,
              "z": 1.392
            },
            "gtin": "7611916124501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7453",
            "leftCorner": {
              "x": -32.051,
              "y": -10.971,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.996,
              "y": -10.97,
              "z": 1.392
            },
            "gtin": "7611916124501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7454",
            "leftCorner": {
              "x": -31.997,
              "y": -10.927,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.896,
              "y": -10.926,
              "z": 1.392
            },
            "gtin": "7611916124518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7455",
            "leftCorner": {
              "x": -31.896,
              "y": -10.926,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.828,
              "y": -10.923,
              "z": 1.392
            },
            "gtin": "7611916125720",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7456",
            "leftCorner": {
              "x": -31.828,
              "y": -10.924,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.766,
              "y": -10.923,
              "z": 1.392
            },
            "gtin": "4021457648412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7457",
            "leftCorner": {
              "x": -31.766,
              "y": -10.92,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.696,
              "y": -10.918,
              "z": 1.392
            },
            "gtin": "4021457648443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7458",
            "leftCorner": {
              "x": -31.696,
              "y": -10.922,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.645,
              "y": -10.92,
              "z": 1.392
            },
            "gtin": "4260370437486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7459",
            "leftCorner": {
              "x": -31.645,
              "y": -10.923,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.584,
              "y": -10.921,
              "z": 1.392
            },
            "gtin": "4260370437486",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d745a",
            "leftCorner": {
              "x": -31.584,
              "y": -10.924,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.525,
              "y": -10.923,
              "z": 1.392
            },
            "gtin": "4260602122715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d745b",
            "leftCorner": {
              "x": -31.525,
              "y": -10.921,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.451,
              "y": -10.919,
              "z": 1.392
            },
            "gtin": "4260602122715",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d745c",
            "leftCorner": {
              "x": -31.451,
              "y": -10.919,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.375,
              "y": -10.917,
              "z": 1.392
            },
            "gtin": "4260602128366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d745d",
            "leftCorner": {
              "x": -31.375,
              "y": -10.916,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.284,
              "y": -10.913,
              "z": 1.392
            },
            "gtin": "4260602128359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d745e",
            "leftCorner": {
              "x": -31.284,
              "y": -10.913,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.227,
              "y": -10.911,
              "z": 1.392
            },
            "gtin": "4262401730139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d745f",
            "leftCorner": {
              "x": -31.227,
              "y": -10.912,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.14,
              "y": -10.911,
              "z": 1.392
            },
            "gtin": "4008890007013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7460",
            "leftCorner": {
              "x": -31.14,
              "y": -10.913,
              "z": 1.392
            },
            "rightCorner": {
              "x": -31.048,
              "y": -10.91,
              "z": 1.392
            },
            "gtin": "4008890007686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7461",
            "leftCorner": {
              "x": -31.048,
              "y": -10.91,
              "z": 1.392
            },
            "rightCorner": {
              "x": -30.942,
              "y": -10.908,
              "z": 1.392
            },
            "gtin": "4103040341013",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c42",
    "rightNeighborShelfId": "c44"
  },
  {
    "id": "c44",
    "name": "c44",
    "x": -30.912,
    "y": -10.884,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.011449,
      "w": 0.99993
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 108
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7a9",
        "height": 0.16907,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8aea",
            "leftCorner": {
              "x": -30.909,
              "y": -11.038,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.864,
              "y": -11.037,
              "z": 0.138
            },
            "gtin": "4015100863970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "812531c95283a8458a042b4a",
            "leftCorner": {
              "x": -30.599,
              "y": -11.031,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.559,
              "y": -11.03,
              "z": 0.138
            },
            "gtin": "4008233129518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c967b858849bb34acbb65b90",
            "leftCorner": {
              "x": -30.559,
              "y": -11.03,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.495,
              "y": -11.028,
              "z": 0.138
            },
            "gtin": "8006540838945",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e22a7b47297149a8224bf43b",
            "leftCorner": {
              "x": -30.495,
              "y": -11.028,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.464,
              "y": -11.028,
              "z": 0.138
            },
            "gtin": "4008268042905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ae0fa951ca7ae686146fbc83",
            "leftCorner": {
              "x": -30.464,
              "y": -11.028,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.424,
              "y": -11.027,
              "z": 0.138
            },
            "gtin": "4008233129518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8916ec357351b3c1b1468cea",
            "leftCorner": {
              "x": -30.424,
              "y": -11.027,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.381,
              "y": -11.026,
              "z": 0.138
            },
            "gtin": "8720181573545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "89cec3aace740ad184fac03c",
            "leftCorner": {
              "x": -30.381,
              "y": -11.026,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.333,
              "y": -11.025,
              "z": 0.138
            },
            "gtin": "8720181334153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "10689e2bfb30dfd204c56146",
            "leftCorner": {
              "x": -30.333,
              "y": -11.025,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.285,
              "y": -11.024,
              "z": 0.138
            },
            "gtin": "8720181302336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d4e6d219b0ab4592361c3508",
            "leftCorner": {
              "x": -30.285,
              "y": -11.024,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.234,
              "y": -11.022,
              "z": 0.138
            },
            "gtin": "3616305448477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e4ca425285b26910ec552e89",
            "leftCorner": {
              "x": -30.234,
              "y": -11.022,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.183,
              "y": -11.021,
              "z": 0.138
            },
            "gtin": "8720181334597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a3653b2ce50c3b42e0f15676",
            "leftCorner": {
              "x": -30.183,
              "y": -11.021,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.13,
              "y": -11.02,
              "z": 0.138
            },
            "gtin": "4006000081083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3a65ba6b17dc4e6c5ca3ccbc",
            "leftCorner": {
              "x": -30.13,
              "y": -11.02,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.07,
              "y": -11.019,
              "z": 0.138
            },
            "gtin": "3616305263254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "648e669b16ef289f3e9e2c64",
            "leftCorner": {
              "x": -30.07,
              "y": -11.019,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.008,
              "y": -11.017,
              "z": 0.138
            },
            "gtin": "4006000158785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6e804660a02c2ad93172f93a",
            "leftCorner": {
              "x": -30.008,
              "y": -11.017,
              "z": 0.138
            },
            "rightCorner": {
              "x": -29.946,
              "y": -11.016,
              "z": 0.138
            },
            "gtin": "8720181442896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "53659b3b75fabd6f2bdf0f6a",
            "leftCorner": {
              "x": -29.946,
              "y": -11.016,
              "z": 0.138
            },
            "rightCorner": {
              "x": -29.778,
              "y": -11.012,
              "z": 0.138
            },
            "gtin": "8700216747592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7c9a41a33f7b1e5d6de26147",
            "leftCorner": {
              "x": -29.778,
              "y": -11.012,
              "z": 0.138
            },
            "rightCorner": {
              "x": -29.662,
              "y": -11.009,
              "z": 0.138
            },
            "gtin": "8700216752589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8aeb",
            "leftCorner": {
              "x": -30.864,
              "y": -11.037,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.82,
              "y": -11.036,
              "z": 0.138
            },
            "gtin": "4015100863970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8aec",
            "leftCorner": {
              "x": -30.82,
              "y": -11.036,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.776,
              "y": -11.035,
              "z": 0.138
            },
            "gtin": "4015100863970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8aed",
            "leftCorner": {
              "x": -30.776,
              "y": -11.035,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.732,
              "y": -11.034,
              "z": 0.138
            },
            "gtin": "4015100863970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8aee",
            "leftCorner": {
              "x": -30.732,
              "y": -11.034,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.687,
              "y": -11.033,
              "z": 0.138
            },
            "gtin": "4015100863970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8aef",
            "leftCorner": {
              "x": -30.687,
              "y": -11.033,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.643,
              "y": -11.031,
              "z": 0.138
            },
            "gtin": "4015100863970",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8af0",
            "leftCorner": {
              "x": -30.643,
              "y": -11.031,
              "z": 0.138
            },
            "rightCorner": {
              "x": -30.599,
              "y": -11.03,
              "z": 0.138
            },
            "gtin": "4015100863970",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7a6",
        "height": 0.46063,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8abe",
            "leftCorner": {
              "x": -30.909,
              "y": -11.002,
              "z": 0.377
            },
            "rightCorner": {
              "x": -30.836,
              "y": -11.0,
              "z": 0.377
            },
            "gtin": "8718951424647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8abf",
            "leftCorner": {
              "x": -30.836,
              "y": -11.0,
              "z": 0.377
            },
            "rightCorner": {
              "x": -30.763,
              "y": -10.998,
              "z": 0.377
            },
            "gtin": "8718951424647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ac1",
            "leftCorner": {
              "x": -30.764,
              "y": -10.913,
              "z": 0.377
            },
            "rightCorner": {
              "x": -30.69,
              "y": -10.912,
              "z": 0.377
            },
            "gtin": "8718951427471",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ac2",
            "leftCorner": {
              "x": -30.689,
              "y": -10.921,
              "z": 0.377
            },
            "rightCorner": {
              "x": -30.624,
              "y": -10.92,
              "z": 0.377
            },
            "gtin": "3616305263254",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ac3",
            "leftCorner": {
              "x": -30.624,
              "y": -10.928,
              "z": 0.377
            },
            "rightCorner": {
              "x": -30.556,
              "y": -10.927,
              "z": 0.377
            },
            "gtin": "3616305263247",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ac4",
            "leftCorner": {
              "x": -30.556,
              "y": -10.934,
              "z": 0.377
            },
            "rightCorner": {
              "x": -30.481,
              "y": -10.932,
              "z": 0.377
            },
            "gtin": "3616305824868",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ac5",
            "leftCorner": {
              "x": -30.48,
              "y": -10.941,
              "z": 0.377
            },
            "rightCorner": {
              "x": -30.4,
              "y": -10.939,
              "z": 0.377
            },
            "gtin": "3616303458881",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ac6",
            "leftCorner": {
              "x": -30.4,
              "y": -10.946,
              "z": 0.377
            },
            "rightCorner": {
              "x": -30.326,
              "y": -10.944,
              "z": 0.377
            },
            "gtin": "3616303458959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ac7",
            "leftCorner": {
              "x": -30.326,
              "y": -10.952,
              "z": 0.377
            },
            "rightCorner": {
              "x": -30.175,
              "y": -10.949,
              "z": 0.377
            },
            "gtin": "8720181334597",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ac8",
            "leftCorner": {
              "x": -30.175,
              "y": -10.972,
              "z": 0.377
            },
            "rightCorner": {
              "x": -30.098,
              "y": -10.97,
              "z": 0.377
            },
            "gtin": "8720181798474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ac9",
            "leftCorner": {
              "x": -30.097,
              "y": -10.98,
              "z": 0.377
            },
            "rightCorner": {
              "x": -30.028,
              "y": -10.978,
              "z": 0.377
            },
            "gtin": "8720181334580",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aca",
            "leftCorner": {
              "x": -30.027,
              "y": -10.983,
              "z": 0.377
            },
            "rightCorner": {
              "x": -29.872,
              "y": -10.98,
              "z": 0.377
            },
            "gtin": "8720181333996",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8acb",
            "leftCorner": {
              "x": -29.873,
              "y": -10.995,
              "z": 0.377
            },
            "rightCorner": {
              "x": -29.787,
              "y": -10.993,
              "z": 0.377
            },
            "gtin": "8720181325380",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8acc",
            "leftCorner": {
              "x": -29.787,
              "y": -11.003,
              "z": 0.377
            },
            "rightCorner": {
              "x": -29.719,
              "y": -11.002,
              "z": 0.377
            },
            "gtin": "8720181334153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ac0",
            "leftCorner": {
              "x": -29.718,
              "y": -11.008,
              "z": 0.377
            },
            "rightCorner": {
              "x": -29.659,
              "y": -11.008,
              "z": 0.377
            },
            "gtin": "8720181685880",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7a8",
        "height": 0.70878,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8ade",
            "leftCorner": {
              "x": -30.909,
              "y": -11.016,
              "z": 0.58
            },
            "rightCorner": {
              "x": -30.7,
              "y": -11.011,
              "z": 0.58
            },
            "gtin": "4008268042905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ce6f33a95407447b72379e21",
            "leftCorner": {
              "x": -29.803,
              "y": -10.99,
              "z": 0.58
            },
            "rightCorner": {
              "x": -29.772,
              "y": -10.99,
              "z": 0.58
            },
            "gtin": "4008268042905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8adf",
            "leftCorner": {
              "x": -30.702,
              "y": -10.93,
              "z": 0.58
            },
            "rightCorner": {
              "x": -30.628,
              "y": -10.928,
              "z": 0.58
            },
            "gtin": "4008268043759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ae0",
            "leftCorner": {
              "x": -30.628,
              "y": -10.936,
              "z": 0.58
            },
            "rightCorner": {
              "x": -30.535,
              "y": -10.935,
              "z": 0.58
            },
            "gtin": "4008268043605",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ae1",
            "leftCorner": {
              "x": -30.535,
              "y": -10.947,
              "z": 0.58
            },
            "rightCorner": {
              "x": -30.449,
              "y": -10.944,
              "z": 0.58
            },
            "gtin": "4008268044459",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ae2",
            "leftCorner": {
              "x": -30.448,
              "y": -10.952,
              "z": 0.58
            },
            "rightCorner": {
              "x": -30.351,
              "y": -10.95,
              "z": 0.58
            },
            "gtin": "4008268043780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ae3",
            "leftCorner": {
              "x": -30.351,
              "y": -10.954,
              "z": 0.58
            },
            "rightCorner": {
              "x": -30.186,
              "y": -10.951,
              "z": 0.58
            },
            "gtin": "8006540944561",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ae4",
            "leftCorner": {
              "x": -30.16,
              "y": -10.972,
              "z": 0.58
            },
            "rightCorner": {
              "x": -30.084,
              "y": -10.97,
              "z": 0.58
            },
            "gtin": "8006540842409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ae5",
            "leftCorner": {
              "x": -30.084,
              "y": -10.991,
              "z": 0.58
            },
            "rightCorner": {
              "x": -29.974,
              "y": -10.989,
              "z": 0.58
            },
            "gtin": "8700216752589",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ae6",
            "leftCorner": {
              "x": -29.973,
              "y": -10.998,
              "z": 0.58
            },
            "rightCorner": {
              "x": -29.803,
              "y": -10.994,
              "z": 0.58
            },
            "gtin": "8700216747592",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ae8",
            "leftCorner": {
              "x": -29.755,
              "y": -11.004,
              "z": 0.58
            },
            "rightCorner": {
              "x": -29.698,
              "y": -11.003,
              "z": 0.58
            },
            "gtin": "4260380015421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ae9",
            "leftCorner": {
              "x": -29.698,
              "y": -11.009,
              "z": 0.58
            },
            "rightCorner": {
              "x": -29.642,
              "y": -11.008,
              "z": 0.58
            },
            "gtin": "4260380014615",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7a7",
        "height": 0.94889,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8acd",
            "leftCorner": {
              "x": -30.909,
              "y": -10.999,
              "z": 0.776
            },
            "rightCorner": {
              "x": -30.799,
              "y": -10.995,
              "z": 0.776
            },
            "gtin": "4006000081083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ace",
            "leftCorner": {
              "x": -30.801,
              "y": -10.902,
              "z": 0.776
            },
            "rightCorner": {
              "x": -30.733,
              "y": -10.901,
              "z": 0.776
            },
            "gtin": "4006000081120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8acf",
            "leftCorner": {
              "x": -30.732,
              "y": -10.906,
              "z": 0.776
            },
            "rightCorner": {
              "x": -30.643,
              "y": -10.904,
              "z": 0.776
            },
            "gtin": "4005900972750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ad0",
            "leftCorner": {
              "x": -30.643,
              "y": -10.917,
              "z": 0.776
            },
            "rightCorner": {
              "x": -30.577,
              "y": -10.916,
              "z": 0.776
            },
            "gtin": "4006000158747",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ad1",
            "leftCorner": {
              "x": -30.577,
              "y": -10.921,
              "z": 0.776
            },
            "rightCorner": {
              "x": -30.484,
              "y": -10.919,
              "z": 0.776
            },
            "gtin": "4006000063713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ad2",
            "leftCorner": {
              "x": -30.484,
              "y": -10.932,
              "z": 0.776
            },
            "rightCorner": {
              "x": -30.42,
              "y": -10.931,
              "z": 0.776
            },
            "gtin": "4006000158785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ad3",
            "leftCorner": {
              "x": -30.421,
              "y": -10.937,
              "z": 0.776
            },
            "rightCorner": {
              "x": -30.375,
              "y": -10.936,
              "z": 0.776
            },
            "gtin": "4006000063836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ad4",
            "leftCorner": {
              "x": -30.375,
              "y": -10.936,
              "z": 0.776
            },
            "rightCorner": {
              "x": -30.329,
              "y": -10.935,
              "z": 0.776
            },
            "gtin": "4006000063836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ad5",
            "leftCorner": {
              "x": -30.33,
              "y": -10.942,
              "z": 0.776
            },
            "rightCorner": {
              "x": -30.264,
              "y": -10.94,
              "z": 0.776
            },
            "gtin": "4006000063676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ad6",
            "leftCorner": {
              "x": -30.264,
              "y": -10.948,
              "z": 0.776
            },
            "rightCorner": {
              "x": -30.198,
              "y": -10.946,
              "z": 0.776
            },
            "gtin": "4006000063553",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ad7",
            "leftCorner": {
              "x": -30.197,
              "y": -10.962,
              "z": 0.776
            },
            "rightCorner": {
              "x": -30.114,
              "y": -10.959,
              "z": 0.776
            },
            "gtin": "4006000063911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ad8",
            "leftCorner": {
              "x": -30.113,
              "y": -10.975,
              "z": 0.776
            },
            "rightCorner": {
              "x": -30.042,
              "y": -10.974,
              "z": 0.776
            },
            "gtin": "8720181302039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ad9",
            "leftCorner": {
              "x": -30.041,
              "y": -10.98,
              "z": 0.776
            },
            "rightCorner": {
              "x": -29.96,
              "y": -10.978,
              "z": 0.776
            },
            "gtin": "8720181301995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ada",
            "leftCorner": {
              "x": -29.959,
              "y": -10.983,
              "z": 0.776
            },
            "rightCorner": {
              "x": -29.879,
              "y": -10.981,
              "z": 0.776
            },
            "gtin": "8720181573545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8adb",
            "leftCorner": {
              "x": -29.878,
              "y": -10.99,
              "z": 0.776
            },
            "rightCorner": {
              "x": -29.807,
              "y": -10.988,
              "z": 0.776
            },
            "gtin": "8720181302015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8adc",
            "leftCorner": {
              "x": -29.807,
              "y": -10.998,
              "z": 0.776
            },
            "rightCorner": {
              "x": -29.731,
              "y": -10.995,
              "z": 0.776
            },
            "gtin": "8720181302336",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8add",
            "leftCorner": {
              "x": -29.731,
              "y": -11.003,
              "z": 0.776
            },
            "rightCorner": {
              "x": -29.657,
              "y": -11.001,
              "z": 0.776
            },
            "gtin": "8720181302053",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7a5",
        "height": 1.2005,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8ab0",
            "leftCorner": {
              "x": -30.909,
              "y": -11.015,
              "z": 0.982
            },
            "rightCorner": {
              "x": -30.787,
              "y": -11.013,
              "z": 0.982
            },
            "gtin": "3574661384306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ab1",
            "leftCorner": {
              "x": -30.79,
              "y": -10.9,
              "z": 0.982
            },
            "rightCorner": {
              "x": -30.695,
              "y": -10.898,
              "z": 0.982
            },
            "gtin": "3600524036638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ab2",
            "leftCorner": {
              "x": -30.695,
              "y": -10.917,
              "z": 0.982
            },
            "rightCorner": {
              "x": -30.601,
              "y": -10.915,
              "z": 0.982
            },
            "gtin": "8710447284100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ab3",
            "leftCorner": {
              "x": -30.601,
              "y": -10.925,
              "z": 0.982
            },
            "rightCorner": {
              "x": -30.521,
              "y": -10.923,
              "z": 0.982
            },
            "gtin": "8710447284094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ab4",
            "leftCorner": {
              "x": -30.52,
              "y": -10.929,
              "z": 0.982
            },
            "rightCorner": {
              "x": -30.418,
              "y": -10.926,
              "z": 0.982
            },
            "gtin": "8710447284117",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ee1820c81800d8ab5",
            "leftCorner": {
              "x": -30.417,
              "y": -10.938,
              "z": 0.982
            },
            "rightCorner": {
              "x": -30.269,
              "y": -10.935,
              "z": 0.982
            },
            "gtin": "8710447276594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ab6",
            "leftCorner": {
              "x": -30.269,
              "y": -10.954,
              "z": 0.982
            },
            "rightCorner": {
              "x": -30.202,
              "y": -10.953,
              "z": 0.982
            },
            "gtin": "8710447276570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ab7",
            "leftCorner": {
              "x": -30.202,
              "y": -10.965,
              "z": 0.982
            },
            "rightCorner": {
              "x": -30.124,
              "y": -10.963,
              "z": 0.982
            },
            "gtin": "8710447276587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ab8",
            "leftCorner": {
              "x": -30.123,
              "y": -10.976,
              "z": 0.982
            },
            "rightCorner": {
              "x": -30.04,
              "y": -10.975,
              "z": 0.982
            },
            "gtin": "8720181208096",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8ab9",
            "leftCorner": {
              "x": -30.039,
              "y": -10.969,
              "z": 0.982
            },
            "rightCorner": {
              "x": -29.966,
              "y": -10.967,
              "z": 0.982
            },
            "gtin": "8710447276600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aba",
            "leftCorner": {
              "x": -29.965,
              "y": -10.984,
              "z": 0.982
            },
            "rightCorner": {
              "x": -29.887,
              "y": -10.982,
              "z": 0.982
            },
            "gtin": "8720181204081",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8abb",
            "leftCorner": {
              "x": -29.886,
              "y": -10.991,
              "z": 0.982
            },
            "rightCorner": {
              "x": -29.801,
              "y": -10.99,
              "z": 0.982
            },
            "gtin": "8717163648681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8abc",
            "leftCorner": {
              "x": -29.802,
              "y": -10.998,
              "z": 0.982
            },
            "rightCorner": {
              "x": -29.72,
              "y": -10.995,
              "z": 0.982
            },
            "gtin": "8720181442896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8abd",
            "leftCorner": {
              "x": -29.72,
              "y": -11.003,
              "z": 0.982
            },
            "rightCorner": {
              "x": -29.648,
              "y": -11.002,
              "z": 0.982
            },
            "gtin": "8720181601972",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7a3",
        "height": 1.4512,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8a93",
            "leftCorner": {
              "x": -30.909,
              "y": -11.008,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.867,
              "y": -11.007,
              "z": 1.187
            },
            "gtin": "4008890007013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a94",
            "leftCorner": {
              "x": -30.867,
              "y": -11.007,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.824,
              "y": -11.005,
              "z": 1.187
            },
            "gtin": "4008890007013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a95",
            "leftCorner": {
              "x": -30.824,
              "y": -11.005,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.782,
              "y": -11.005,
              "z": 1.187
            },
            "gtin": "4008890007013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a96",
            "leftCorner": {
              "x": -30.782,
              "y": -11.005,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.74,
              "y": -11.004,
              "z": 1.187
            },
            "gtin": "4008890007013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a97",
            "leftCorner": {
              "x": -30.742,
              "y": -10.922,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.702,
              "y": -10.921,
              "z": 1.187
            },
            "gtin": "4008890007013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a98",
            "leftCorner": {
              "x": -30.703,
              "y": -10.926,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.576,
              "y": -10.923,
              "z": 1.187
            },
            "gtin": "4008233181660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a99",
            "leftCorner": {
              "x": -30.575,
              "y": -10.938,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.507,
              "y": -10.937,
              "z": 1.187
            },
            "gtin": "4008233171401",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a9a",
            "leftCorner": {
              "x": -30.507,
              "y": -10.944,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.418,
              "y": -10.942,
              "z": 1.187
            },
            "gtin": "4260702188710",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a9b",
            "leftCorner": {
              "x": -30.418,
              "y": -10.951,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.35,
              "y": -10.949,
              "z": 1.187
            },
            "gtin": "4260370435017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a9c",
            "leftCorner": {
              "x": -30.35,
              "y": -10.954,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.276,
              "y": -10.953,
              "z": 1.187
            },
            "gtin": "8008970061078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a9d",
            "leftCorner": {
              "x": -30.276,
              "y": -10.965,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.203,
              "y": -10.963,
              "z": 1.187
            },
            "gtin": "3616305886699",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a9e",
            "leftCorner": {
              "x": -30.203,
              "y": -10.973,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.119,
              "y": -10.972,
              "z": 1.187
            },
            "gtin": "3616305448286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8a9f",
            "leftCorner": {
              "x": -30.119,
              "y": -10.972,
              "z": 1.187
            },
            "rightCorner": {
              "x": -30.034,
              "y": -10.969,
              "z": 1.187
            },
            "gtin": "3616305448286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aa0",
            "leftCorner": {
              "x": -30.034,
              "y": -10.988,
              "z": 1.187
            },
            "rightCorner": {
              "x": -29.979,
              "y": -10.987,
              "z": 1.187
            },
            "gtin": "3616304696091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aa1",
            "leftCorner": {
              "x": -29.98,
              "y": -10.993,
              "z": 1.187
            },
            "rightCorner": {
              "x": -29.882,
              "y": -10.991,
              "z": 1.187
            },
            "gtin": "3616304696091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aa2",
            "leftCorner": {
              "x": -29.882,
              "y": -11.002,
              "z": 1.187
            },
            "rightCorner": {
              "x": -29.797,
              "y": -10.999,
              "z": 1.187
            },
            "gtin": "3616305448422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aa3",
            "leftCorner": {
              "x": -29.797,
              "y": -11.008,
              "z": 1.187
            },
            "rightCorner": {
              "x": -29.731,
              "y": -11.006,
              "z": 1.187
            },
            "gtin": "3616305448477",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aa4",
            "leftCorner": {
              "x": -29.731,
              "y": -11.012,
              "z": 1.187
            },
            "rightCorner": {
              "x": -29.647,
              "y": -11.011,
              "z": 1.187
            },
            "gtin": "8720182523877",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7a4",
        "height": 1.7004,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8aa5",
            "leftCorner": {
              "x": -30.909,
              "y": -11.002,
              "z": 1.391
            },
            "rightCorner": {
              "x": -30.715,
              "y": -10.997,
              "z": 1.391
            },
            "gtin": "4103040041937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aa7",
            "leftCorner": {
              "x": -30.718,
              "y": -10.922,
              "z": 1.391
            },
            "rightCorner": {
              "x": -30.639,
              "y": -10.92,
              "z": 1.391
            },
            "gtin": "4103040102744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aa8",
            "leftCorner": {
              "x": -30.639,
              "y": -10.93,
              "z": 1.391
            },
            "rightCorner": {
              "x": -30.56,
              "y": -10.928,
              "z": 1.391
            },
            "gtin": "4103040797018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aa9",
            "leftCorner": {
              "x": -30.559,
              "y": -10.938,
              "z": 1.391
            },
            "rightCorner": {
              "x": -30.468,
              "y": -10.936,
              "z": 1.391
            },
            "gtin": "4103040184153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aaa",
            "leftCorner": {
              "x": -30.467,
              "y": -10.943,
              "z": 1.391
            },
            "rightCorner": {
              "x": -30.392,
              "y": -10.941,
              "z": 1.391
            },
            "gtin": "4103040908100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aab",
            "leftCorner": {
              "x": -30.392,
              "y": -10.949,
              "z": 1.391
            },
            "rightCorner": {
              "x": -30.281,
              "y": -10.947,
              "z": 1.391
            },
            "gtin": "4103040048189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aac",
            "leftCorner": {
              "x": -30.281,
              "y": -10.958,
              "z": 1.391
            },
            "rightCorner": {
              "x": -30.184,
              "y": -10.956,
              "z": 1.391
            },
            "gtin": "4103040048264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aad",
            "leftCorner": {
              "x": -30.183,
              "y": -10.971,
              "z": 1.391
            },
            "rightCorner": {
              "x": -30.102,
              "y": -10.969,
              "z": 1.391
            },
            "gtin": "4051089815012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aae",
            "leftCorner": {
              "x": -30.103,
              "y": -10.983,
              "z": 1.391
            },
            "rightCorner": {
              "x": -29.896,
              "y": -10.978,
              "z": 1.391
            },
            "gtin": "4051089815159",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aaf",
            "leftCorner": {
              "x": -29.896,
              "y": -10.997,
              "z": 1.391
            },
            "rightCorner": {
              "x": -29.77,
              "y": -10.994,
              "z": 1.391
            },
            "gtin": "4051089815036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8aa6",
            "leftCorner": {
              "x": -29.77,
              "y": -11.008,
              "z": 1.391
            },
            "rightCorner": {
              "x": -29.659,
              "y": -11.006,
              "z": 1.391
            },
            "gtin": "4051089815043",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c43"
  },
  {
    "id": "c45",
    "name": "c45",
    "x": -32.185,
    "y": -9.732,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0061435
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 31,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7ae",
        "height": 0.15586,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7442",
            "leftCorner": {
              "x": -32.185,
              "y": -9.677,
              "z": 0.128
            },
            "rightCorner": {
              "x": -32.969,
              "y": -9.691,
              "z": 0.128
            },
            "gtin": "4042600384599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d743e",
            "leftCorner": {
              "x": -32.969,
              "y": -9.686,
              "z": 0.128
            },
            "rightCorner": {
              "x": -33.435,
              "y": -9.692,
              "z": 0.128
            },
            "gtin": "4042600384599",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7ad",
        "height": 0.54173,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7437",
            "leftCorner": {
              "x": -32.243,
              "y": -9.752,
              "z": 0.443
            },
            "rightCorner": {
              "x": -32.477,
              "y": -9.755,
              "z": 0.443
            },
            "gtin": "4048517742125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7438",
            "leftCorner": {
              "x": -32.477,
              "y": -9.755,
              "z": 0.443
            },
            "rightCorner": {
              "x": -32.712,
              "y": -9.758,
              "z": 0.443
            },
            "gtin": "4048517742125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7439",
            "leftCorner": {
              "x": -32.714,
              "y": -9.663,
              "z": 0.443
            },
            "rightCorner": {
              "x": -32.845,
              "y": -9.665,
              "z": 0.443
            },
            "gtin": "4009491022023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d743a",
            "leftCorner": {
              "x": -32.845,
              "y": -9.665,
              "z": 0.443
            },
            "rightCorner": {
              "x": -32.976,
              "y": -9.666,
              "z": 0.443
            },
            "gtin": "4009491022023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d743b",
            "leftCorner": {
              "x": -32.976,
              "y": -9.67,
              "z": 0.443
            },
            "rightCorner": {
              "x": -33.334,
              "y": -9.674,
              "z": 0.443
            },
            "gtin": "4009491021989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7433",
            "leftCorner": {
              "x": -33.334,
              "y": -9.664,
              "z": 0.443
            },
            "rightCorner": {
              "x": -33.436,
              "y": -9.665,
              "z": 0.443
            },
            "gtin": "4009491022054",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7ac",
        "height": 0.90775,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7428",
            "leftCorner": {
              "x": -32.239,
              "y": -9.663,
              "z": 0.743
            },
            "rightCorner": {
              "x": -32.29,
              "y": -9.664,
              "z": 0.743
            },
            "gtin": "9008700228039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7429",
            "leftCorner": {
              "x": -32.29,
              "y": -9.664,
              "z": 0.743
            },
            "rightCorner": {
              "x": -32.34,
              "y": -9.664,
              "z": 0.743
            },
            "gtin": "9008700228039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d742a",
            "leftCorner": {
              "x": -32.34,
              "y": -9.664,
              "z": 0.743
            },
            "rightCorner": {
              "x": -32.391,
              "y": -9.665,
              "z": 0.743
            },
            "gtin": "9008700228039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d742b",
            "leftCorner": {
              "x": -32.391,
              "y": -9.671,
              "z": 0.743
            },
            "rightCorner": {
              "x": -32.477,
              "y": -9.672,
              "z": 0.743
            },
            "gtin": "9008700231237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d742c",
            "leftCorner": {
              "x": -32.477,
              "y": -9.672,
              "z": 0.743
            },
            "rightCorner": {
              "x": -32.562,
              "y": -9.673,
              "z": 0.743
            },
            "gtin": "9008700231237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d742d",
            "leftCorner": {
              "x": -32.561,
              "y": -9.678,
              "z": 0.743
            },
            "rightCorner": {
              "x": -32.703,
              "y": -9.68,
              "z": 0.743
            },
            "gtin": "9008700231275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d742e",
            "leftCorner": {
              "x": -32.703,
              "y": -9.68,
              "z": 0.743
            },
            "rightCorner": {
              "x": -32.921,
              "y": -9.683,
              "z": 0.743
            },
            "gtin": "4009491022047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d742f",
            "leftCorner": {
              "x": -32.921,
              "y": -9.683,
              "z": 0.743
            },
            "rightCorner": {
              "x": -33.139,
              "y": -9.685,
              "z": 0.743
            },
            "gtin": "4009491022047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7418",
            "leftCorner": {
              "x": -33.139,
              "y": -9.685,
              "z": 0.743
            },
            "rightCorner": {
              "x": -33.287,
              "y": -9.686,
              "z": 0.743
            },
            "gtin": "4009491022085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7419",
            "leftCorner": {
              "x": -33.287,
              "y": -9.686,
              "z": 0.743
            },
            "rightCorner": {
              "x": -33.435,
              "y": -9.688,
              "z": 0.743
            },
            "gtin": "4009491022085",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7aa",
        "height": 1.2602,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d73f8",
            "leftCorner": {
              "x": -32.186,
              "y": -9.668,
              "z": 1.031
            },
            "rightCorner": {
              "x": -32.331,
              "y": -9.671,
              "z": 1.031
            },
            "gtin": "4009491021354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73f9",
            "leftCorner": {
              "x": -32.331,
              "y": -9.669,
              "z": 1.031
            },
            "rightCorner": {
              "x": -32.469,
              "y": -9.671,
              "z": 1.031
            },
            "gtin": "4009491021354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73fa",
            "leftCorner": {
              "x": -32.469,
              "y": -9.671,
              "z": 1.031
            },
            "rightCorner": {
              "x": -32.606,
              "y": -9.672,
              "z": 1.031
            },
            "gtin": "4009491021354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73fb",
            "leftCorner": {
              "x": -32.605,
              "y": -9.678,
              "z": 1.031
            },
            "rightCorner": {
              "x": -32.761,
              "y": -9.68,
              "z": 1.031
            },
            "gtin": "4009491022108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73fc",
            "leftCorner": {
              "x": -32.761,
              "y": -9.68,
              "z": 1.031
            },
            "rightCorner": {
              "x": -32.918,
              "y": -9.682,
              "z": 1.031
            },
            "gtin": "4009491022108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73eb",
            "leftCorner": {
              "x": -32.918,
              "y": -9.69,
              "z": 1.031
            },
            "rightCorner": {
              "x": -33.435,
              "y": -9.696,
              "z": 1.031
            },
            "gtin": "4009491021965",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7ab",
        "height": 1.7358,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d740e",
            "leftCorner": {
              "x": -32.185,
              "y": -9.679,
              "z": 1.42
            },
            "rightCorner": {
              "x": -32.446,
              "y": -9.684,
              "z": 1.42
            },
            "gtin": "8720157468431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d740f",
            "leftCorner": {
              "x": -32.446,
              "y": -9.681,
              "z": 1.42
            },
            "rightCorner": {
              "x": -32.543,
              "y": -9.682,
              "z": 1.42
            },
            "gtin": "8720157468431",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7410",
            "leftCorner": {
              "x": -32.543,
              "y": -9.684,
              "z": 1.42
            },
            "rightCorner": {
              "x": -32.654,
              "y": -9.686,
              "z": 1.42
            },
            "gtin": "8720157468479",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7411",
            "leftCorner": {
              "x": -32.654,
              "y": -9.689,
              "z": 1.42
            },
            "rightCorner": {
              "x": -32.767,
              "y": -9.69,
              "z": 1.42
            },
            "gtin": "8720157468493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7412",
            "leftCorner": {
              "x": -32.767,
              "y": -9.692,
              "z": 1.42
            },
            "rightCorner": {
              "x": -32.963,
              "y": -9.694,
              "z": 1.42
            },
            "gtin": "8720157400981",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7413",
            "leftCorner": {
              "x": -32.963,
              "y": -9.698,
              "z": 1.42
            },
            "rightCorner": {
              "x": -33.249,
              "y": -9.701,
              "z": 1.42
            },
            "gtin": "4102380046015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73fe",
            "leftCorner": {
              "x": -33.249,
              "y": -9.689,
              "z": 1.42
            },
            "rightCorner": {
              "x": -33.435,
              "y": -9.692,
              "z": 1.42
            },
            "gtin": "4042600398381",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c46"
  },
  {
    "id": "c46",
    "name": "c46",
    "x": -30.935,
    "y": -9.716,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0061435
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 31,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3ec",
        "height": 0.16134,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7441",
            "leftCorner": {
              "x": -31.239,
              "y": -9.648,
              "z": 0.132
            },
            "rightCorner": {
              "x": -32.185,
              "y": -9.659,
              "z": 0.132
            },
            "gtin": "4306188048367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2dfa3e68029225f21724404f",
            "leftCorner": {
              "x": -30.936,
              "y": -9.604,
              "z": 0.132
            },
            "rightCorner": {
              "x": -31.232,
              "y": -9.608,
              "z": 0.132
            },
            "gtin": "4306188430711",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3eb",
        "height": 0.53397,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7430",
            "leftCorner": {
              "x": -30.936,
              "y": -9.606,
              "z": 0.437
            },
            "rightCorner": {
              "x": -31.049,
              "y": -9.607,
              "z": 0.437
            },
            "gtin": "4048517780844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7431",
            "leftCorner": {
              "x": -31.049,
              "y": -9.607,
              "z": 0.437
            },
            "rightCorner": {
              "x": -31.163,
              "y": -9.608,
              "z": 0.437
            },
            "gtin": "4048517780844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7432",
            "leftCorner": {
              "x": -31.163,
              "y": -9.608,
              "z": 0.437
            },
            "rightCorner": {
              "x": -31.276,
              "y": -9.61,
              "z": 0.437
            },
            "gtin": "4048517780844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7434",
            "leftCorner": {
              "x": -31.276,
              "y": -9.65,
              "z": 0.437
            },
            "rightCorner": {
              "x": -31.463,
              "y": -9.652,
              "z": 0.437
            },
            "gtin": "4048517741807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7435",
            "leftCorner": {
              "x": -31.463,
              "y": -9.652,
              "z": 0.437
            },
            "rightCorner": {
              "x": -31.651,
              "y": -9.655,
              "z": 0.437
            },
            "gtin": "4048517741807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7436",
            "leftCorner": {
              "x": -31.651,
              "y": -9.654,
              "z": 0.437
            },
            "rightCorner": {
              "x": -32.243,
              "y": -9.661,
              "z": 0.437
            },
            "gtin": "4048517702815",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3ea",
        "height": 0.90905,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7421",
            "leftCorner": {
              "x": -31.002,
              "y": -9.657,
              "z": 0.744
            },
            "rightCorner": {
              "x": -31.18,
              "y": -9.659,
              "z": 0.744
            },
            "gtin": "4048517780608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9c871cdd4f276a42b7f721b0",
            "leftCorner": {
              "x": -30.936,
              "y": -9.613,
              "z": 0.744
            },
            "rightCorner": {
              "x": -31.0,
              "y": -9.613,
              "z": 0.744
            },
            "gtin": "4048517742040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7422",
            "leftCorner": {
              "x": -31.18,
              "y": -9.658,
              "z": 0.744
            },
            "rightCorner": {
              "x": -31.317,
              "y": -9.66,
              "z": 0.744
            },
            "gtin": "4048517757303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7423",
            "leftCorner": {
              "x": -31.317,
              "y": -9.657,
              "z": 0.744
            },
            "rightCorner": {
              "x": -31.491,
              "y": -9.659,
              "z": 0.744
            },
            "gtin": "4048517757389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7424",
            "leftCorner": {
              "x": -31.491,
              "y": -9.654,
              "z": 0.744
            },
            "rightCorner": {
              "x": -31.649,
              "y": -9.656,
              "z": 0.744
            },
            "gtin": "4048517757228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7425",
            "leftCorner": {
              "x": -31.649,
              "y": -9.659,
              "z": 0.744
            },
            "rightCorner": {
              "x": -31.778,
              "y": -9.661,
              "z": 0.744
            },
            "gtin": "4048517742040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7426",
            "leftCorner": {
              "x": -31.778,
              "y": -9.661,
              "z": 0.744
            },
            "rightCorner": {
              "x": -31.906,
              "y": -9.662,
              "z": 0.744
            },
            "gtin": "4048517742040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7427",
            "leftCorner": {
              "x": -31.906,
              "y": -9.665,
              "z": 0.744
            },
            "rightCorner": {
              "x": -32.238,
              "y": -9.669,
              "z": 0.744
            },
            "gtin": "4048517751851",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3e8",
        "height": 1.2619,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d73f0",
            "leftCorner": {
              "x": -30.998,
              "y": -9.663,
              "z": 1.032
            },
            "rightCorner": {
              "x": -31.133,
              "y": -9.665,
              "z": 1.032
            },
            "gtin": "4048517762307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73f1",
            "leftCorner": {
              "x": -31.133,
              "y": -9.665,
              "z": 1.032
            },
            "rightCorner": {
              "x": -31.305,
              "y": -9.667,
              "z": 1.032
            },
            "gtin": "4048517702341",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73f2",
            "leftCorner": {
              "x": -31.305,
              "y": -9.659,
              "z": 1.032
            },
            "rightCorner": {
              "x": -31.492,
              "y": -9.662,
              "z": 1.032
            },
            "gtin": "4048517701818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73f3",
            "leftCorner": {
              "x": -31.492,
              "y": -9.661,
              "z": 1.032
            },
            "rightCorner": {
              "x": -31.592,
              "y": -9.662,
              "z": 1.032
            },
            "gtin": "4048517701924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73f4",
            "leftCorner": {
              "x": -31.592,
              "y": -9.662,
              "z": 1.032
            },
            "rightCorner": {
              "x": -31.691,
              "y": -9.663,
              "z": 1.032
            },
            "gtin": "4048517701924",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73f5",
            "leftCorner": {
              "x": -31.691,
              "y": -9.666,
              "z": 1.032
            },
            "rightCorner": {
              "x": -31.875,
              "y": -9.669,
              "z": 1.032
            },
            "gtin": "9008700231343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73f6",
            "leftCorner": {
              "x": -31.875,
              "y": -9.667,
              "z": 1.032
            },
            "rightCorner": {
              "x": -32.08,
              "y": -9.669,
              "z": 1.032
            },
            "gtin": "9008700231251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73f7",
            "leftCorner": {
              "x": -32.08,
              "y": -9.664,
              "z": 1.032
            },
            "rightCorner": {
              "x": -32.185,
              "y": -9.666,
              "z": 1.032
            },
            "gtin": "4009491021361",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3e9",
        "height": 1.7371,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7406",
            "leftCorner": {
              "x": -30.981,
              "y": -9.665,
              "z": 1.421
            },
            "rightCorner": {
              "x": -31.224,
              "y": -9.668,
              "z": 1.421
            },
            "gtin": "4306188430711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7407",
            "leftCorner": {
              "x": -31.224,
              "y": -9.666,
              "z": 1.421
            },
            "rightCorner": {
              "x": -31.397,
              "y": -9.668,
              "z": 1.421
            },
            "gtin": "4000269100363",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7408",
            "leftCorner": {
              "x": -31.397,
              "y": -9.669,
              "z": 1.421
            },
            "rightCorner": {
              "x": -31.531,
              "y": -9.671,
              "z": 1.421
            },
            "gtin": "4100060001101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7409",
            "leftCorner": {
              "x": -31.531,
              "y": -9.671,
              "z": 1.421
            },
            "rightCorner": {
              "x": -31.672,
              "y": -9.672,
              "z": 1.421
            },
            "gtin": "4048517742521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d740a",
            "leftCorner": {
              "x": -31.672,
              "y": -9.672,
              "z": 1.421
            },
            "rightCorner": {
              "x": -31.841,
              "y": -9.674,
              "z": 1.421
            },
            "gtin": "4048517679230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d740b",
            "leftCorner": {
              "x": -31.841,
              "y": -9.674,
              "z": 1.421
            },
            "rightCorner": {
              "x": -31.969,
              "y": -9.676,
              "z": 1.421
            },
            "gtin": "4048517714658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d740c",
            "leftCorner": {
              "x": -31.969,
              "y": -9.676,
              "z": 1.421
            },
            "rightCorner": {
              "x": -32.114,
              "y": -9.678,
              "z": 1.421
            },
            "gtin": "4048517733932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d740d",
            "leftCorner": {
              "x": -32.114,
              "y": -9.675,
              "z": 1.421
            },
            "rightCorner": {
              "x": -32.185,
              "y": -9.676,
              "z": 1.421
            },
            "gtin": "4048517779084",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c47",
    "rightNeighborShelfId": "c45"
  },
  {
    "id": "c47",
    "name": "c47",
    "x": -29.685,
    "y": -9.701,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99998,
      "w": 0.0061435
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 43,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7b3",
        "height": 0.17077,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d743c",
            "leftCorner": {
              "x": -29.686,
              "y": -9.599,
              "z": 0.14
            },
            "rightCorner": {
              "x": -29.923,
              "y": -9.602,
              "z": 0.14
            },
            "gtin": "4306188046196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d743d",
            "leftCorner": {
              "x": -29.923,
              "y": -9.602,
              "z": 0.14
            },
            "rightCorner": {
              "x": -30.159,
              "y": -9.605,
              "z": 0.14
            },
            "gtin": "4306188046196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d743f",
            "leftCorner": {
              "x": -30.158,
              "y": -9.648,
              "z": 0.14
            },
            "rightCorner": {
              "x": -30.428,
              "y": -9.651,
              "z": 0.14
            },
            "gtin": "4306188050155",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7440",
            "leftCorner": {
              "x": -30.428,
              "y": -9.645,
              "z": 0.14
            },
            "rightCorner": {
              "x": -31.239,
              "y": -9.655,
              "z": 0.14
            },
            "gtin": "4306188049807",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7b1",
        "height": 0.54444,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8af6",
            "leftCorner": {
              "x": -29.686,
              "y": -9.583,
              "z": 0.445
            },
            "rightCorner": {
              "x": -29.829,
              "y": -9.585,
              "z": 0.445
            },
            "gtin": "4048517746086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8af7",
            "leftCorner": {
              "x": -29.829,
              "y": -9.585,
              "z": 0.445
            },
            "rightCorner": {
              "x": -29.972,
              "y": -9.586,
              "z": 0.445
            },
            "gtin": "4048517746086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8af8",
            "leftCorner": {
              "x": -29.972,
              "y": -9.586,
              "z": 0.445
            },
            "rightCorner": {
              "x": -30.114,
              "y": -9.588,
              "z": 0.445
            },
            "gtin": "4048517746086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8afc",
            "leftCorner": {
              "x": -30.113,
              "y": -9.631,
              "z": 0.445
            },
            "rightCorner": {
              "x": -30.189,
              "y": -9.632,
              "z": 0.445
            },
            "gtin": "4048517746246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8afd",
            "leftCorner": {
              "x": -30.189,
              "y": -9.632,
              "z": 0.445
            },
            "rightCorner": {
              "x": -30.264,
              "y": -9.633,
              "z": 0.445
            },
            "gtin": "4048517746246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8afe",
            "leftCorner": {
              "x": -30.264,
              "y": -9.633,
              "z": 0.445
            },
            "rightCorner": {
              "x": -30.34,
              "y": -9.634,
              "z": 0.445
            },
            "gtin": "4048517746246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8aff",
            "leftCorner": {
              "x": -30.341,
              "y": -9.627,
              "z": 0.445
            },
            "rightCorner": {
              "x": -30.488,
              "y": -9.629,
              "z": 0.445
            },
            "gtin": "4048517743085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b00",
            "leftCorner": {
              "x": -30.488,
              "y": -9.629,
              "z": 0.445
            },
            "rightCorner": {
              "x": -30.634,
              "y": -9.631,
              "z": 0.445
            },
            "gtin": "4048517743085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8af9",
            "leftCorner": {
              "x": -30.634,
              "y": -9.634,
              "z": 0.445
            },
            "rightCorner": {
              "x": -30.734,
              "y": -9.635,
              "z": 0.445
            },
            "gtin": "4048517746482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8afa",
            "leftCorner": {
              "x": -30.734,
              "y": -9.635,
              "z": 0.445
            },
            "rightCorner": {
              "x": -30.835,
              "y": -9.637,
              "z": 0.445
            },
            "gtin": "4048517746482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8afb",
            "leftCorner": {
              "x": -30.835,
              "y": -9.637,
              "z": 0.445
            },
            "rightCorner": {
              "x": -30.935,
              "y": -9.638,
              "z": 0.445
            },
            "gtin": "4048517746482",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7b2",
        "height": 0.91,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7414",
            "leftCorner": {
              "x": -29.686,
              "y": -9.602,
              "z": 0.745
            },
            "rightCorner": {
              "x": -29.796,
              "y": -9.603,
              "z": 0.745
            },
            "gtin": "4048517701832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7415",
            "leftCorner": {
              "x": -29.796,
              "y": -9.603,
              "z": 0.745
            },
            "rightCorner": {
              "x": -29.906,
              "y": -9.605,
              "z": 0.745
            },
            "gtin": "4048517701832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7416",
            "leftCorner": {
              "x": -29.906,
              "y": -9.605,
              "z": 0.745
            },
            "rightCorner": {
              "x": -30.016,
              "y": -9.606,
              "z": 0.745
            },
            "gtin": "4048517701832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7417",
            "leftCorner": {
              "x": -30.016,
              "y": -9.606,
              "z": 0.745
            },
            "rightCorner": {
              "x": -30.126,
              "y": -9.607,
              "z": 0.745
            },
            "gtin": "4048517701832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d741a",
            "leftCorner": {
              "x": -30.125,
              "y": -9.649,
              "z": 0.745
            },
            "rightCorner": {
              "x": -30.26,
              "y": -9.65,
              "z": 0.745
            },
            "gtin": "4048517746161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d741b",
            "leftCorner": {
              "x": -30.26,
              "y": -9.65,
              "z": 0.745
            },
            "rightCorner": {
              "x": -30.396,
              "y": -9.652,
              "z": 0.745
            },
            "gtin": "4048517746161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d741c",
            "leftCorner": {
              "x": -30.396,
              "y": -9.652,
              "z": 0.745
            },
            "rightCorner": {
              "x": -30.531,
              "y": -9.654,
              "z": 0.745
            },
            "gtin": "4048517746161",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d741d",
            "leftCorner": {
              "x": -30.531,
              "y": -9.647,
              "z": 0.745
            },
            "rightCorner": {
              "x": -30.614,
              "y": -9.648,
              "z": 0.745
            },
            "gtin": "4048517742927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d741e",
            "leftCorner": {
              "x": -30.614,
              "y": -9.648,
              "z": 0.745
            },
            "rightCorner": {
              "x": -30.696,
              "y": -9.649,
              "z": 0.745
            },
            "gtin": "4048517742927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d741f",
            "leftCorner": {
              "x": -30.696,
              "y": -9.649,
              "z": 0.745
            },
            "rightCorner": {
              "x": -30.778,
              "y": -9.65,
              "z": 0.745
            },
            "gtin": "4048517742927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7420",
            "leftCorner": {
              "x": -30.778,
              "y": -9.655,
              "z": 0.745
            },
            "rightCorner": {
              "x": -31.002,
              "y": -9.657,
              "z": 0.745
            },
            "gtin": "4048517780684",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7b0",
        "height": 1.263,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d73e6",
            "leftCorner": {
              "x": -29.686,
              "y": -9.607,
              "z": 1.033
            },
            "rightCorner": {
              "x": -29.759,
              "y": -9.608,
              "z": 1.033
            },
            "gtin": "4048517743009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73e7",
            "leftCorner": {
              "x": -29.759,
              "y": -9.608,
              "z": 1.033
            },
            "rightCorner": {
              "x": -29.833,
              "y": -9.609,
              "z": 1.033
            },
            "gtin": "4048517743009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73e8",
            "leftCorner": {
              "x": -29.833,
              "y": -9.609,
              "z": 1.033
            },
            "rightCorner": {
              "x": -29.906,
              "y": -9.61,
              "z": 1.033
            },
            "gtin": "4048517743009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73e9",
            "leftCorner": {
              "x": -29.906,
              "y": -9.61,
              "z": 1.033
            },
            "rightCorner": {
              "x": -29.979,
              "y": -9.611,
              "z": 1.033
            },
            "gtin": "4048517743009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73ea",
            "leftCorner": {
              "x": -29.979,
              "y": -9.611,
              "z": 1.033
            },
            "rightCorner": {
              "x": -30.053,
              "y": -9.612,
              "z": 1.033
            },
            "gtin": "4048517743009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73ec",
            "leftCorner": {
              "x": -30.051,
              "y": -9.655,
              "z": 1.033
            },
            "rightCorner": {
              "x": -30.42,
              "y": -9.659,
              "z": 1.033
            },
            "gtin": "4048517701955",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73ed",
            "leftCorner": {
              "x": -30.421,
              "y": -9.653,
              "z": 1.033
            },
            "rightCorner": {
              "x": -30.589,
              "y": -9.655,
              "z": 1.033
            },
            "gtin": "4048517701986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73ee",
            "leftCorner": {
              "x": -30.589,
              "y": -9.655,
              "z": 1.033
            },
            "rightCorner": {
              "x": -30.757,
              "y": -9.657,
              "z": 1.033
            },
            "gtin": "4048517701986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73ef",
            "leftCorner": {
              "x": -30.757,
              "y": -9.66,
              "z": 1.033
            },
            "rightCorner": {
              "x": -30.997,
              "y": -9.663,
              "z": 1.033
            },
            "gtin": "4048517780769",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7af",
        "height": 1.7379,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d73fd",
            "leftCorner": {
              "x": -29.686,
              "y": -9.616,
              "z": 1.422
            },
            "rightCorner": {
              "x": -29.785,
              "y": -9.617,
              "z": 1.422
            },
            "gtin": "4306188430742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73ff",
            "leftCorner": {
              "x": -29.783,
              "y": -9.653,
              "z": 1.422
            },
            "rightCorner": {
              "x": -29.922,
              "y": -9.654,
              "z": 1.422
            },
            "gtin": "4105550302201",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7400",
            "leftCorner": {
              "x": -29.922,
              "y": -9.659,
              "z": 1.422
            },
            "rightCorner": {
              "x": -30.128,
              "y": -9.661,
              "z": 1.422
            },
            "gtin": "4105550302102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7401",
            "leftCorner": {
              "x": -30.128,
              "y": -9.663,
              "z": 1.422
            },
            "rightCorner": {
              "x": -30.289,
              "y": -9.665,
              "z": 1.422
            },
            "gtin": "4306188047841",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7402",
            "leftCorner": {
              "x": -30.289,
              "y": -9.666,
              "z": 1.422
            },
            "rightCorner": {
              "x": -30.438,
              "y": -9.667,
              "z": 1.422
            },
            "gtin": "4306188430865",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7403",
            "leftCorner": {
              "x": -30.439,
              "y": -9.655,
              "z": 1.422
            },
            "rightCorner": {
              "x": -30.626,
              "y": -9.657,
              "z": 1.422
            },
            "gtin": "4306188430834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7404",
            "leftCorner": {
              "x": -30.626,
              "y": -9.664,
              "z": 1.422
            },
            "rightCorner": {
              "x": -30.793,
              "y": -9.666,
              "z": 1.422
            },
            "gtin": "4306188430650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7405",
            "leftCorner": {
              "x": -30.793,
              "y": -9.669,
              "z": 1.422
            },
            "rightCorner": {
              "x": -30.98,
              "y": -9.672,
              "z": 1.422
            },
            "gtin": "4306188430681",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "c46"
  },
  {
    "id": "c48",
    "name": "c48",
    "x": -34.025,
    "y": -9.802,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70634,
      "w": 0.70788
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 45,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7b8",
        "height": 0.25246,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b2d",
            "leftCorner": {
              "x": -33.895,
              "y": -9.802,
              "z": 0.207
            },
            "rightCorner": {
              "x": -33.893,
              "y": -10.648,
              "z": 0.207
            },
            "gtin": "8719128118352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b2f",
            "leftCorner": {
              "x": -33.853,
              "y": -10.649,
              "z": 0.207
            },
            "rightCorner": {
              "x": -33.853,
              "y": -10.829,
              "z": 0.207
            },
            "gtin": "7290113761315",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b2e",
            "leftCorner": {
              "x": -33.854,
              "y": -10.829,
              "z": 0.207
            },
            "rightCorner": {
              "x": -33.853,
              "y": -11.052,
              "z": 0.207
            },
            "gtin": "7290113761308",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7b6",
        "height": 0.82764,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b18",
            "leftCorner": {
              "x": -33.9,
              "y": -9.802,
              "z": 0.677
            },
            "rightCorner": {
              "x": -33.899,
              "y": -10.09,
              "z": 0.677
            },
            "gtin": "4006387122003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b1a",
            "leftCorner": {
              "x": -33.856,
              "y": -10.09,
              "z": 0.677
            },
            "rightCorner": {
              "x": -33.856,
              "y": -10.373,
              "z": 0.677
            },
            "gtin": "4006387125219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b1b",
            "leftCorner": {
              "x": -33.86,
              "y": -10.373,
              "z": 0.677
            },
            "rightCorner": {
              "x": -33.859,
              "y": -10.527,
              "z": 0.677
            },
            "gtin": "4000270586507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b1c",
            "leftCorner": {
              "x": -33.86,
              "y": -10.527,
              "z": 0.677
            },
            "rightCorner": {
              "x": -33.86,
              "y": -10.635,
              "z": 0.677
            },
            "gtin": "7640108090027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b1d",
            "leftCorner": {
              "x": -33.858,
              "y": -10.635,
              "z": 0.677
            },
            "rightCorner": {
              "x": -33.858,
              "y": -10.813,
              "z": 0.677
            },
            "gtin": "8719128112756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b1e",
            "leftCorner": {
              "x": -33.857,
              "y": -10.813,
              "z": 0.677
            },
            "rightCorner": {
              "x": -33.857,
              "y": -10.982,
              "z": 0.677
            },
            "gtin": "8719128112749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b19",
            "leftCorner": {
              "x": -33.854,
              "y": -10.982,
              "z": 0.677
            },
            "rightCorner": {
              "x": -33.853,
              "y": -11.052,
              "z": 0.677
            },
            "gtin": "8719128118369",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7b4",
        "height": 1.1819,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b01",
            "leftCorner": {
              "x": -33.898,
              "y": -9.802,
              "z": 0.967
            },
            "rightCorner": {
              "x": -33.898,
              "y": -9.989,
              "z": 0.967
            },
            "gtin": "4270004194906",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50fe1820c81800d8b03",
            "leftCorner": {
              "x": -33.857,
              "y": -9.989,
              "z": 0.967
            },
            "rightCorner": {
              "x": -33.857,
              "y": -10.061,
              "z": 0.967
            },
            "gtin": "4262471230140",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b04",
            "leftCorner": {
              "x": -33.852,
              "y": -10.061,
              "z": 0.967
            },
            "rightCorner": {
              "x": -33.852,
              "y": -10.125,
              "z": 0.967
            },
            "gtin": "4270004194944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b05",
            "leftCorner": {
              "x": -33.854,
              "y": -10.125,
              "z": 0.967
            },
            "rightCorner": {
              "x": -33.853,
              "y": -10.249,
              "z": 0.967
            },
            "gtin": "4262471230331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b06",
            "leftCorner": {
              "x": -33.852,
              "y": -10.249,
              "z": 0.967
            },
            "rightCorner": {
              "x": -33.852,
              "y": -10.377,
              "z": 0.967
            },
            "gtin": "4262471230133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b07",
            "leftCorner": {
              "x": -33.858,
              "y": -10.377,
              "z": 0.967
            },
            "rightCorner": {
              "x": -33.857,
              "y": -10.501,
              "z": 0.967
            },
            "gtin": "4262471230348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b08",
            "leftCorner": {
              "x": -33.859,
              "y": -10.501,
              "z": 0.967
            },
            "rightCorner": {
              "x": -33.858,
              "y": -10.566,
              "z": 0.967
            },
            "gtin": "4270004194937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b09",
            "leftCorner": {
              "x": -33.859,
              "y": -10.566,
              "z": 0.967
            },
            "rightCorner": {
              "x": -33.859,
              "y": -10.766,
              "z": 0.967
            },
            "gtin": "4262458421998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b0a",
            "leftCorner": {
              "x": -33.858,
              "y": -10.766,
              "z": 0.967
            },
            "rightCorner": {
              "x": -33.857,
              "y": -10.957,
              "z": 0.967
            },
            "gtin": "4262458422001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b02",
            "leftCorner": {
              "x": -33.852,
              "y": -10.957,
              "z": 0.967
            },
            "rightCorner": {
              "x": -33.852,
              "y": -11.052,
              "z": 0.967
            },
            "gtin": "7290116741857",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7b5",
        "height": 1.5337,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b0b",
            "leftCorner": {
              "x": -33.904,
              "y": -9.802,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.904,
              "y": -10.004,
              "z": 1.255
            },
            "gtin": "7290113762473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b0c",
            "leftCorner": {
              "x": -33.867,
              "y": -10.004,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.866,
              "y": -10.086,
              "z": 1.255
            },
            "gtin": "7290113763166",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b0d",
            "leftCorner": {
              "x": -33.863,
              "y": -10.086,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.864,
              "y": -10.152,
              "z": 1.255
            },
            "gtin": "7290113762480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b0e",
            "leftCorner": {
              "x": -33.863,
              "y": -10.152,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.863,
              "y": -10.218,
              "z": 1.255
            },
            "gtin": "7290113762572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b0f",
            "leftCorner": {
              "x": -33.863,
              "y": -10.218,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.862,
              "y": -10.283,
              "z": 1.255
            },
            "gtin": "7290113762572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b10",
            "leftCorner": {
              "x": -33.862,
              "y": -10.283,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.862,
              "y": -10.366,
              "z": 1.255
            },
            "gtin": "7290113763043",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b11",
            "leftCorner": {
              "x": -33.862,
              "y": -10.366,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.862,
              "y": -10.437,
              "z": 1.255
            },
            "gtin": "7290113762626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b12",
            "leftCorner": {
              "x": -33.865,
              "y": -10.437,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.864,
              "y": -10.512,
              "z": 1.255
            },
            "gtin": "8719128117485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b13",
            "leftCorner": {
              "x": -33.865,
              "y": -10.512,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.865,
              "y": -10.619,
              "z": 1.255
            },
            "gtin": "7290113762725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b14",
            "leftCorner": {
              "x": -33.864,
              "y": -10.619,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.864,
              "y": -10.695,
              "z": 1.255
            },
            "gtin": "7290113763173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b15",
            "leftCorner": {
              "x": -33.863,
              "y": -10.695,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.862,
              "y": -10.793,
              "z": 1.255
            },
            "gtin": "7290113762749",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b16",
            "leftCorner": {
              "x": -33.861,
              "y": -10.793,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.861,
              "y": -10.884,
              "z": 1.255
            },
            "gtin": "7290113762695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b17",
            "leftCorner": {
              "x": -33.858,
              "y": -10.884,
              "z": 1.255
            },
            "rightCorner": {
              "x": -33.858,
              "y": -11.026,
              "z": 1.255
            },
            "gtin": "7290113762701",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7b7",
        "height": 1.8075,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8b1f",
            "leftCorner": {
              "x": -33.902,
              "y": -9.802,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.902,
              "y": -10.028,
              "z": 1.479
            },
            "gtin": "7290113762619",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50fe1820c81800d8b20",
            "leftCorner": {
              "x": -33.863,
              "y": -10.028,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.863,
              "y": -10.112,
              "z": 1.479
            },
            "gtin": "8718692615779",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b21",
            "leftCorner": {
              "x": -33.862,
              "y": -10.112,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.862,
              "y": -10.193,
              "z": 1.479
            },
            "gtin": "8719128117874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b22",
            "leftCorner": {
              "x": -33.86,
              "y": -10.193,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.86,
              "y": -10.266,
              "z": 1.479
            },
            "gtin": "7290113762671",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b23",
            "leftCorner": {
              "x": -33.86,
              "y": -10.266,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.859,
              "y": -10.33,
              "z": 1.479
            },
            "gtin": "8719128117867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b24",
            "leftCorner": {
              "x": -33.859,
              "y": -10.33,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.859,
              "y": -10.414,
              "z": 1.479
            },
            "gtin": "7290113762343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b25",
            "leftCorner": {
              "x": -33.863,
              "y": -10.414,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.863,
              "y": -10.483,
              "z": 1.479
            },
            "gtin": "7290113762350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b26",
            "leftCorner": {
              "x": -33.863,
              "y": -10.483,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.863,
              "y": -10.557,
              "z": 1.479
            },
            "gtin": "8719128117331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b27",
            "leftCorner": {
              "x": -33.863,
              "y": -10.557,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.863,
              "y": -10.632,
              "z": 1.479
            },
            "gtin": "8719128117331",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b28",
            "leftCorner": {
              "x": -33.86,
              "y": -10.632,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.861,
              "y": -10.709,
              "z": 1.479
            },
            "gtin": "8719128117263",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b29",
            "leftCorner": {
              "x": -33.862,
              "y": -10.709,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.862,
              "y": -10.789,
              "z": 1.479
            },
            "gtin": "8719128117843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b2a",
            "leftCorner": {
              "x": -33.862,
              "y": -10.789,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.86,
              "y": -10.872,
              "z": 1.479
            },
            "gtin": "8719128117836",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b2b",
            "leftCorner": {
              "x": -33.852,
              "y": -10.872,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.853,
              "y": -10.941,
              "z": 1.479
            },
            "gtin": "7290113762541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8b2c",
            "leftCorner": {
              "x": -33.856,
              "y": -10.941,
              "z": 1.479
            },
            "rightCorner": {
              "x": -33.856,
              "y": -11.017,
              "z": 1.479
            },
            "gtin": "8719128117249",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "c49",
    "name": "c49",
    "x": -28.933,
    "y": -10.907,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70818,
      "w": 0.70603
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 27,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d432",
        "height": 1.0101,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7775",
            "leftCorner": {
              "x": -28.817,
              "y": -10.907,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.817,
              "y": -10.852,
              "z": 0.826
            },
            "gtin": "4002184726611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7777",
            "leftCorner": {
              "x": -28.855,
              "y": -10.852,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.855,
              "y": -10.749,
              "z": 0.826
            },
            "gtin": "4002184020023",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7778",
            "leftCorner": {
              "x": -28.851,
              "y": -10.746,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.851,
              "y": -10.646,
              "z": 0.826
            },
            "gtin": "4002184033610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7779",
            "leftCorner": {
              "x": -28.854,
              "y": -10.646,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.854,
              "y": -10.572,
              "z": 0.826
            },
            "gtin": "4002184032613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d777a",
            "leftCorner": {
              "x": -28.861,
              "y": -10.572,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.861,
              "y": -10.449,
              "z": 0.826
            },
            "gtin": "4002184034617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d777b",
            "leftCorner": {
              "x": -28.857,
              "y": -10.449,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.858,
              "y": -10.314,
              "z": 0.826
            },
            "gtin": "2000422150275",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d777c",
            "leftCorner": {
              "x": -28.868,
              "y": -10.314,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.868,
              "y": -10.262,
              "z": 0.826
            },
            "gtin": "4002184052017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d777d",
            "leftCorner": {
              "x": -28.859,
              "y": -10.262,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.859,
              "y": -10.174,
              "z": 0.826
            },
            "gtin": "4002184020610",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d777e",
            "leftCorner": {
              "x": -28.871,
              "y": -10.174,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.871,
              "y": -10.053,
              "z": 0.826
            },
            "gtin": "4002184023611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d777f",
            "leftCorner": {
              "x": -28.863,
              "y": -10.053,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.864,
              "y": -9.959,
              "z": 0.826
            },
            "gtin": "4002184010611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7780",
            "leftCorner": {
              "x": -28.876,
              "y": -9.96,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.877,
              "y": -9.855,
              "z": 0.826
            },
            "gtin": "4002184735019",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7781",
            "leftCorner": {
              "x": -28.871,
              "y": -9.855,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.871,
              "y": -9.774,
              "z": 0.826
            },
            "gtin": "4002184020634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7776",
            "leftCorner": {
              "x": -28.881,
              "y": -9.774,
              "z": 0.826
            },
            "rightCorner": {
              "x": -28.882,
              "y": -9.657,
              "z": 0.826
            },
            "gtin": "4002184041615",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d431",
        "height": 1.4148,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d776e",
            "leftCorner": {
              "x": -28.801,
              "y": -10.907,
              "z": 1.158
            },
            "rightCorner": {
              "x": -28.802,
              "y": -10.713,
              "z": 1.158
            },
            "gtin": "4001716014721",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7770",
            "leftCorner": {
              "x": -28.834,
              "y": -10.712,
              "z": 1.158
            },
            "rightCorner": {
              "x": -28.835,
              "y": -10.539,
              "z": 1.158
            },
            "gtin": "4001716016527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7771",
            "leftCorner": {
              "x": -28.838,
              "y": -10.539,
              "z": 1.158
            },
            "rightCorner": {
              "x": -28.838,
              "y": -10.353,
              "z": 1.158
            },
            "gtin": "4001716017623",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7772",
            "leftCorner": {
              "x": -28.841,
              "y": -10.353,
              "z": 1.158
            },
            "rightCorner": {
              "x": -28.842,
              "y": -10.178,
              "z": 1.158
            },
            "gtin": "4001716017920",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7773",
            "leftCorner": {
              "x": -28.845,
              "y": -10.178,
              "z": 1.158
            },
            "rightCorner": {
              "x": -28.846,
              "y": -9.994,
              "z": 1.158
            },
            "gtin": "4001716015520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7774",
            "leftCorner": {
              "x": -28.849,
              "y": -9.994,
              "z": 1.158
            },
            "rightCorner": {
              "x": -28.85,
              "y": -9.824,
              "z": 1.158
            },
            "gtin": "4001716011126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d776f",
            "leftCorner": {
              "x": -28.856,
              "y": -9.824,
              "z": 1.158
            },
            "rightCorner": {
              "x": -28.856,
              "y": -9.657,
              "z": 1.158
            },
            "gtin": "4001716014622",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d433",
        "height": 1.749,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7782",
            "leftCorner": {
              "x": -28.817,
              "y": -10.907,
              "z": 1.431
            },
            "rightCorner": {
              "x": -28.817,
              "y": -10.686,
              "z": 1.431
            },
            "gtin": "4005695055430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7784",
            "leftCorner": {
              "x": -28.85,
              "y": -10.686,
              "z": 1.431
            },
            "rightCorner": {
              "x": -28.851,
              "y": -10.508,
              "z": 1.431
            },
            "gtin": "4005695055423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7785",
            "leftCorner": {
              "x": -28.853,
              "y": -10.508,
              "z": 1.431
            },
            "rightCorner": {
              "x": -28.854,
              "y": -10.317,
              "z": 1.431
            },
            "gtin": "4005695055409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7786",
            "leftCorner": {
              "x": -28.857,
              "y": -10.317,
              "z": 1.431
            },
            "rightCorner": {
              "x": -28.858,
              "y": -10.136,
              "z": 1.431
            },
            "gtin": "4005695055416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7787",
            "leftCorner": {
              "x": -28.861,
              "y": -10.136,
              "z": 1.431
            },
            "rightCorner": {
              "x": -28.861,
              "y": -9.985,
              "z": 1.431
            },
            "gtin": "4001716011423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7788",
            "leftCorner": {
              "x": -28.864,
              "y": -9.985,
              "z": 1.431
            },
            "rightCorner": {
              "x": -28.865,
              "y": -9.819,
              "z": 1.431
            },
            "gtin": "4001716017425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7783",
            "leftCorner": {
              "x": -28.871,
              "y": -9.819,
              "z": 1.431
            },
            "rightCorner": {
              "x": -28.871,
              "y": -9.657,
              "z": 1.431
            },
            "gtin": "4001716014028",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "c4a",
    "name": "c4a",
    "x": -33.733,
    "y": -8.189,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.013482,
      "w": 0.99991
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 50,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3dc",
        "height": 0.15737,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d73d5",
            "leftCorner": {
              "x": -33.731,
              "y": -8.27,
              "z": 0.129
            },
            "rightCorner": {
              "x": -33.49,
              "y": -8.263,
              "z": 0.129
            },
            "gtin": "4001716082423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d0b10ca005e9fedaebbc1996",
            "leftCorner": {
              "x": -33.49,
              "y": -8.263,
              "z": 0.129
            },
            "rightCorner": {
              "x": -33.249,
              "y": -8.257,
              "z": 0.129
            },
            "gtin": "4001716082423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73dd",
            "leftCorner": {
              "x": -33.235,
              "y": -8.214,
              "z": 0.129
            },
            "rightCorner": {
              "x": -33.063,
              "y": -8.21,
              "z": 0.129
            },
            "gtin": "4001716084724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73de",
            "leftCorner": {
              "x": -33.063,
              "y": -8.215,
              "z": 0.129
            },
            "rightCorner": {
              "x": -32.724,
              "y": -8.206,
              "z": 0.129
            },
            "gtin": "4001716082522",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73df",
            "leftCorner": {
              "x": -32.724,
              "y": -8.232,
              "z": 0.129
            },
            "rightCorner": {
              "x": -32.698,
              "y": -8.231,
              "z": 0.129
            },
            "gtin": "4306188063476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73e0",
            "leftCorner": {
              "x": -32.707,
              "y": -7.91,
              "z": 0.129
            },
            "rightCorner": {
              "x": -32.491,
              "y": -7.905,
              "z": 0.129
            },
            "gtin": "4306188063476",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3d8",
        "height": 0.52843,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d735b",
            "leftCorner": {
              "x": -33.731,
              "y": -8.274,
              "z": 0.432
            },
            "rightCorner": {
              "x": -33.676,
              "y": -8.273,
              "z": 0.432
            },
            "gtin": "4001716084625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d735c",
            "leftCorner": {
              "x": -33.676,
              "y": -8.273,
              "z": 0.432
            },
            "rightCorner": {
              "x": -33.621,
              "y": -8.271,
              "z": 0.432
            },
            "gtin": "4001716084625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d735d",
            "leftCorner": {
              "x": -33.621,
              "y": -8.271,
              "z": 0.432
            },
            "rightCorner": {
              "x": -33.565,
              "y": -8.27,
              "z": 0.432
            },
            "gtin": "4001716084625",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d735f",
            "leftCorner": {
              "x": -33.566,
              "y": -8.224,
              "z": 0.432
            },
            "rightCorner": {
              "x": -33.379,
              "y": -8.218,
              "z": 0.432
            },
            "gtin": "4005517004172",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7360",
            "leftCorner": {
              "x": -33.378,
              "y": -8.224,
              "z": 0.432
            },
            "rightCorner": {
              "x": -33.218,
              "y": -8.22,
              "z": 0.432
            },
            "gtin": "4005517004127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7361",
            "leftCorner": {
              "x": -33.218,
              "y": -8.22,
              "z": 0.432
            },
            "rightCorner": {
              "x": -33.076,
              "y": -8.216,
              "z": 0.432
            },
            "gtin": "4005517016014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7362",
            "leftCorner": {
              "x": -33.076,
              "y": -8.217,
              "z": 0.432
            },
            "rightCorner": {
              "x": -33.027,
              "y": -8.216,
              "z": 0.432
            },
            "gtin": "4005517004141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7363",
            "leftCorner": {
              "x": -33.027,
              "y": -8.216,
              "z": 0.432
            },
            "rightCorner": {
              "x": -32.979,
              "y": -8.214,
              "z": 0.432
            },
            "gtin": "4005517004141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7364",
            "leftCorner": {
              "x": -32.979,
              "y": -8.214,
              "z": 0.432
            },
            "rightCorner": {
              "x": -32.93,
              "y": -8.213,
              "z": 0.432
            },
            "gtin": "4005517004141",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7365",
            "leftCorner": {
              "x": -32.93,
              "y": -8.222,
              "z": 0.432
            },
            "rightCorner": {
              "x": -32.618,
              "y": -8.214,
              "z": 0.432
            },
            "gtin": "4005517004103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7366",
            "leftCorner": {
              "x": -32.617,
              "y": -8.238,
              "z": 0.432
            },
            "rightCorner": {
              "x": -32.482,
              "y": -8.234,
              "z": 0.432
            },
            "gtin": "4005517016021",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3db",
        "height": 0.90564,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d73b1",
            "leftCorner": {
              "x": -33.731,
              "y": -8.274,
              "z": 0.741
            },
            "rightCorner": {
              "x": -33.632,
              "y": -8.271,
              "z": 0.741
            },
            "gtin": "4001716082027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73b2",
            "leftCorner": {
              "x": -33.632,
              "y": -8.271,
              "z": 0.741
            },
            "rightCorner": {
              "x": -33.532,
              "y": -8.268,
              "z": 0.741
            },
            "gtin": "4001716082027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73b4",
            "leftCorner": {
              "x": -33.533,
              "y": -8.22,
              "z": 0.741
            },
            "rightCorner": {
              "x": -33.341,
              "y": -8.215,
              "z": 0.741
            },
            "gtin": "4001716084021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73b5",
            "leftCorner": {
              "x": -33.342,
              "y": -8.223,
              "z": 0.741
            },
            "rightCorner": {
              "x": -33.215,
              "y": -8.22,
              "z": 0.741
            },
            "gtin": "4005517020127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73b6",
            "leftCorner": {
              "x": -33.215,
              "y": -8.219,
              "z": 0.741
            },
            "rightCorner": {
              "x": -33.054,
              "y": -8.215,
              "z": 0.741
            },
            "gtin": "4005517004097",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73b7",
            "leftCorner": {
              "x": -33.054,
              "y": -8.215,
              "z": 0.741
            },
            "rightCorner": {
              "x": -32.907,
              "y": -8.211,
              "z": 0.741
            },
            "gtin": "4005517004028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73b8",
            "leftCorner": {
              "x": -32.908,
              "y": -8.222,
              "z": 0.741
            },
            "rightCorner": {
              "x": -32.803,
              "y": -8.22,
              "z": 0.741
            },
            "gtin": "4005517016113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73b9",
            "leftCorner": {
              "x": -32.803,
              "y": -8.223,
              "z": 0.741
            },
            "rightCorner": {
              "x": -32.741,
              "y": -8.221,
              "z": 0.741
            },
            "gtin": "9008700139793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73ba",
            "leftCorner": {
              "x": -32.741,
              "y": -8.221,
              "z": 0.741
            },
            "rightCorner": {
              "x": -32.679,
              "y": -8.22,
              "z": 0.741
            },
            "gtin": "9008700139793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73bb",
            "leftCorner": {
              "x": -32.679,
              "y": -8.22,
              "z": 0.741
            },
            "rightCorner": {
              "x": -32.618,
              "y": -8.218,
              "z": 0.741
            },
            "gtin": "9008700139793",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73bc",
            "leftCorner": {
              "x": -32.618,
              "y": -8.236,
              "z": 0.741
            },
            "rightCorner": {
              "x": -32.482,
              "y": -8.232,
              "z": 0.741
            },
            "gtin": "90087271",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3d9",
        "height": 1.2586,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7376",
            "leftCorner": {
              "x": -33.731,
              "y": -8.271,
              "z": 1.03
            },
            "rightCorner": {
              "x": -33.677,
              "y": -8.27,
              "z": 1.03
            },
            "gtin": "4001716081327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7377",
            "leftCorner": {
              "x": -33.677,
              "y": -8.27,
              "z": 1.03
            },
            "rightCorner": {
              "x": -33.622,
              "y": -8.268,
              "z": 1.03
            },
            "gtin": "4001716081327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7378",
            "leftCorner": {
              "x": -33.622,
              "y": -8.268,
              "z": 1.03
            },
            "rightCorner": {
              "x": -33.567,
              "y": -8.267,
              "z": 1.03
            },
            "gtin": "4001716081327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7379",
            "leftCorner": {
              "x": -33.567,
              "y": -8.267,
              "z": 1.03
            },
            "rightCorner": {
              "x": -33.513,
              "y": -8.265,
              "z": 1.03
            },
            "gtin": "4001716081327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d737a",
            "leftCorner": {
              "x": -33.513,
              "y": -8.265,
              "z": 1.03
            },
            "rightCorner": {
              "x": -33.458,
              "y": -8.264,
              "z": 1.03
            },
            "gtin": "4001716081327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d737c",
            "leftCorner": {
              "x": -33.459,
              "y": -8.218,
              "z": 1.03
            },
            "rightCorner": {
              "x": -33.292,
              "y": -8.213,
              "z": 1.03
            },
            "gtin": "4005517004158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d737d",
            "leftCorner": {
              "x": -33.293,
              "y": -8.22,
              "z": 1.03
            },
            "rightCorner": {
              "x": -33.184,
              "y": -8.217,
              "z": 1.03
            },
            "gtin": "4005517016007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d737e",
            "leftCorner": {
              "x": -33.184,
              "y": -8.214,
              "z": 1.03
            },
            "rightCorner": {
              "x": -33.097,
              "y": -8.212,
              "z": 1.03
            },
            "gtin": "4005517016038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d737f",
            "leftCorner": {
              "x": -33.097,
              "y": -8.212,
              "z": 1.03
            },
            "rightCorner": {
              "x": -33.01,
              "y": -8.209,
              "z": 1.03
            },
            "gtin": "4005517016038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7380",
            "leftCorner": {
              "x": -33.009,
              "y": -8.217,
              "z": 1.03
            },
            "rightCorner": {
              "x": -32.835,
              "y": -8.212,
              "z": 1.03
            },
            "gtin": "90087493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7381",
            "leftCorner": {
              "x": -32.835,
              "y": -8.224,
              "z": 1.03
            },
            "rightCorner": {
              "x": -32.749,
              "y": -8.221,
              "z": 1.03
            },
            "gtin": "9008700215152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7382",
            "leftCorner": {
              "x": -32.749,
              "y": -8.221,
              "z": 1.03
            },
            "rightCorner": {
              "x": -32.664,
              "y": -8.219,
              "z": 1.03
            },
            "gtin": "9008700215152",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7383",
            "leftCorner": {
              "x": -32.664,
              "y": -8.236,
              "z": 1.03
            },
            "rightCorner": {
              "x": -32.555,
              "y": -8.233,
              "z": 1.03
            },
            "gtin": "9008700134460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7384",
            "leftCorner": {
              "x": -32.555,
              "y": -8.238,
              "z": 1.03
            },
            "rightCorner": {
              "x": -32.482,
              "y": -8.236,
              "z": 1.03
            },
            "gtin": "9008700155458",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3da",
        "height": 1.7345,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7398",
            "leftCorner": {
              "x": -33.528,
              "y": -8.218,
              "z": 1.419
            },
            "rightCorner": {
              "x": -33.35,
              "y": -8.214,
              "z": 1.419
            },
            "gtin": "4001716081426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "268e2c0f68eeec990c37e8e7",
            "leftCorner": {
              "x": -33.731,
              "y": -8.271,
              "z": 1.419
            },
            "rightCorner": {
              "x": -33.534,
              "y": -8.266,
              "z": 1.419
            },
            "gtin": "4005517004004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7399",
            "leftCorner": {
              "x": -33.351,
              "y": -8.221,
              "z": 1.419
            },
            "rightCorner": {
              "x": -33.209,
              "y": -8.217,
              "z": 1.419
            },
            "gtin": "4005517020103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d739a",
            "leftCorner": {
              "x": -33.209,
              "y": -8.213,
              "z": 1.419
            },
            "rightCorner": {
              "x": -33.05,
              "y": -8.209,
              "z": 1.419
            },
            "gtin": "4005517004080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d739b",
            "leftCorner": {
              "x": -33.05,
              "y": -8.214,
              "z": 1.419
            },
            "rightCorner": {
              "x": -32.865,
              "y": -8.209,
              "z": 1.419
            },
            "gtin": "4005517004004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d739c",
            "leftCorner": {
              "x": -32.865,
              "y": -8.22,
              "z": 1.419
            },
            "rightCorner": {
              "x": -32.68,
              "y": -8.215,
              "z": 1.419
            },
            "gtin": "4005517004011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d739d",
            "leftCorner": {
              "x": -32.68,
              "y": -8.234,
              "z": 1.419
            },
            "rightCorner": {
              "x": -32.543,
              "y": -8.23,
              "z": 1.419
            },
            "gtin": "4005517004134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d739e",
            "leftCorner": {
              "x": -32.543,
              "y": -8.235,
              "z": 1.419
            },
            "rightCorner": {
              "x": -32.482,
              "y": -8.234,
              "z": 1.419
            },
            "gtin": "4104420231214",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "c4b"
  },
  {
    "id": "c4b",
    "name": "c4b",
    "x": -32.469,
    "y": -8.228,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0070773,
      "w": 0.99997
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 45,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d3e2",
        "height": 0.15544,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d73e1",
            "leftCorner": {
              "x": -32.472,
              "y": -8.004,
              "z": 0.127
            },
            "rightCorner": {
              "x": -31.897,
              "y": -7.989,
              "z": 0.127
            },
            "gtin": "4306188063469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73e2",
            "leftCorner": {
              "x": -31.893,
              "y": -8.287,
              "z": 0.127
            },
            "rightCorner": {
              "x": -31.159,
              "y": -8.277,
              "z": 0.127
            },
            "gtin": "4306188063469",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3de",
        "height": 0.52775,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7367",
            "leftCorner": {
              "x": -32.468,
              "y": -8.34,
              "z": 0.432
            },
            "rightCorner": {
              "x": -32.382,
              "y": -8.338,
              "z": 0.432
            },
            "gtin": "4005517005131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7368",
            "leftCorner": {
              "x": -32.382,
              "y": -8.338,
              "z": 0.432
            },
            "rightCorner": {
              "x": -32.297,
              "y": -8.336,
              "z": 0.432
            },
            "gtin": "4005517005131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7369",
            "leftCorner": {
              "x": -32.298,
              "y": -8.303,
              "z": 0.432
            },
            "rightCorner": {
              "x": -32.215,
              "y": -8.302,
              "z": 0.432
            },
            "gtin": "4005517005131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d736a",
            "leftCorner": {
              "x": -32.215,
              "y": -8.302,
              "z": 0.432
            },
            "rightCorner": {
              "x": -32.131,
              "y": -8.3,
              "z": 0.432
            },
            "gtin": "4005517005131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d736b",
            "leftCorner": {
              "x": -32.131,
              "y": -8.3,
              "z": 0.432
            },
            "rightCorner": {
              "x": -32.032,
              "y": -8.299,
              "z": 0.432
            },
            "gtin": "4005517016076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d736c",
            "leftCorner": {
              "x": -32.032,
              "y": -8.299,
              "z": 0.432
            },
            "rightCorner": {
              "x": -31.933,
              "y": -8.297,
              "z": 0.432
            },
            "gtin": "4005517016076",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d736d",
            "leftCorner": {
              "x": -31.933,
              "y": -8.296,
              "z": 0.432
            },
            "rightCorner": {
              "x": -31.753,
              "y": -8.294,
              "z": 0.432
            },
            "gtin": "4048517631450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d736e",
            "leftCorner": {
              "x": -31.753,
              "y": -8.298,
              "z": 0.432
            },
            "rightCorner": {
              "x": -31.524,
              "y": -8.295,
              "z": 0.432
            },
            "gtin": "4048517708602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d736f",
            "leftCorner": {
              "x": -31.524,
              "y": -8.297,
              "z": 0.432
            },
            "rightCorner": {
              "x": -31.319,
              "y": -8.294,
              "z": 0.432
            },
            "gtin": "4048517709647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7370",
            "leftCorner": {
              "x": -31.319,
              "y": -8.293,
              "z": 0.432
            },
            "rightCorner": {
              "x": -31.159,
              "y": -8.291,
              "z": 0.432
            },
            "gtin": "9006900205652",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3e0",
        "height": 0.90542,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d73bd",
            "leftCorner": {
              "x": -32.468,
              "y": -8.34,
              "z": 0.741
            },
            "rightCorner": {
              "x": -32.41,
              "y": -8.339,
              "z": 0.741
            },
            "gtin": "9008700120258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "722d6af6ddbf9230cfadae3c",
            "leftCorner": {
              "x": -31.58,
              "y": -8.335,
              "z": 0.741
            },
            "rightCorner": {
              "x": -31.507,
              "y": -8.334,
              "z": 0.741
            },
            "gtin": "9006900218775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73be",
            "leftCorner": {
              "x": -32.412,
              "y": -8.307,
              "z": 0.741
            },
            "rightCorner": {
              "x": -32.286,
              "y": -8.305,
              "z": 0.741
            },
            "gtin": "9008700120258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73bf",
            "leftCorner": {
              "x": -32.286,
              "y": -8.304,
              "z": 0.741
            },
            "rightCorner": {
              "x": -32.198,
              "y": -8.302,
              "z": 0.741
            },
            "gtin": "9008700132572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73c0",
            "leftCorner": {
              "x": -32.198,
              "y": -8.302,
              "z": 0.741
            },
            "rightCorner": {
              "x": -32.11,
              "y": -8.301,
              "z": 0.741
            },
            "gtin": "9008700132572",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73c1",
            "leftCorner": {
              "x": -32.11,
              "y": -8.301,
              "z": 0.741
            },
            "rightCorner": {
              "x": -32.023,
              "y": -8.299,
              "z": 0.741
            },
            "gtin": "90087769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73c2",
            "leftCorner": {
              "x": -32.023,
              "y": -8.299,
              "z": 0.741
            },
            "rightCorner": {
              "x": -31.935,
              "y": -8.298,
              "z": 0.741
            },
            "gtin": "90087769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73c3",
            "leftCorner": {
              "x": -31.935,
              "y": -8.298,
              "z": 0.741
            },
            "rightCorner": {
              "x": -31.822,
              "y": -8.296,
              "z": 0.741
            },
            "gtin": "9008700128971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73c4",
            "leftCorner": {
              "x": -31.822,
              "y": -8.297,
              "z": 0.741
            },
            "rightCorner": {
              "x": -31.713,
              "y": -8.295,
              "z": 0.741
            },
            "gtin": "9006900208929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73c5",
            "leftCorner": {
              "x": -31.713,
              "y": -8.298,
              "z": 0.741
            },
            "rightCorner": {
              "x": -31.647,
              "y": -8.297,
              "z": 0.741
            },
            "gtin": "9006900017729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73c6",
            "leftCorner": {
              "x": -31.647,
              "y": -8.297,
              "z": 0.741
            },
            "rightCorner": {
              "x": -31.58,
              "y": -8.296,
              "z": 0.741
            },
            "gtin": "9006900017729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73c8",
            "leftCorner": {
              "x": -31.506,
              "y": -8.299,
              "z": 0.741
            },
            "rightCorner": {
              "x": -31.352,
              "y": -8.297,
              "z": 0.741
            },
            "gtin": "9006900218775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73c9",
            "leftCorner": {
              "x": -31.352,
              "y": -8.295,
              "z": 0.741
            },
            "rightCorner": {
              "x": -31.18,
              "y": -8.293,
              "z": 0.741
            },
            "gtin": "9006900213152",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3df",
        "height": 1.2574,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7385",
            "leftCorner": {
              "x": -32.468,
              "y": -8.347,
              "z": 1.029
            },
            "rightCorner": {
              "x": -32.382,
              "y": -8.345,
              "z": 1.029
            },
            "gtin": "9008700108829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7386",
            "leftCorner": {
              "x": -32.382,
              "y": -8.305,
              "z": 1.029
            },
            "rightCorner": {
              "x": -32.27,
              "y": -8.304,
              "z": 1.029
            },
            "gtin": "9008700108829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7387",
            "leftCorner": {
              "x": -32.27,
              "y": -8.305,
              "z": 1.029
            },
            "rightCorner": {
              "x": -32.169,
              "y": -8.303,
              "z": 1.029
            },
            "gtin": "9008700128575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7388",
            "leftCorner": {
              "x": -32.169,
              "y": -8.303,
              "z": 1.029
            },
            "rightCorner": {
              "x": -32.067,
              "y": -8.302,
              "z": 1.029
            },
            "gtin": "9008700128575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7389",
            "leftCorner": {
              "x": -32.067,
              "y": -8.302,
              "z": 1.029
            },
            "rightCorner": {
              "x": -31.966,
              "y": -8.3,
              "z": 1.029
            },
            "gtin": "9008700128575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d738a",
            "leftCorner": {
              "x": -31.966,
              "y": -8.301,
              "z": 1.029
            },
            "rightCorner": {
              "x": -31.811,
              "y": -8.298,
              "z": 1.029
            },
            "gtin": "9008700239356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d738b",
            "leftCorner": {
              "x": -31.811,
              "y": -8.295,
              "z": 1.029
            },
            "rightCorner": {
              "x": -31.633,
              "y": -8.293,
              "z": 1.029
            },
            "gtin": "9008700111546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d738c",
            "leftCorner": {
              "x": -31.633,
              "y": -8.299,
              "z": 1.029
            },
            "rightCorner": {
              "x": -31.475,
              "y": -8.297,
              "z": 1.029
            },
            "gtin": "9008700150095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d738d",
            "leftCorner": {
              "x": -31.475,
              "y": -8.296,
              "z": 1.029
            },
            "rightCorner": {
              "x": -31.343,
              "y": -8.295,
              "z": 1.029
            },
            "gtin": "9006900213091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d738e",
            "leftCorner": {
              "x": -31.343,
              "y": -8.295,
              "z": 1.029
            },
            "rightCorner": {
              "x": -31.25,
              "y": -8.293,
              "z": 1.029
            },
            "gtin": "9006900207717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d738f",
            "leftCorner": {
              "x": -31.25,
              "y": -8.293,
              "z": 1.029
            },
            "rightCorner": {
              "x": -31.158,
              "y": -8.292,
              "z": 1.029
            },
            "gtin": "9006900207717",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d3e1",
        "height": 1.7323,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d739f",
            "leftCorner": {
              "x": -32.468,
              "y": -8.343,
              "z": 1.417
            },
            "rightCorner": {
              "x": -32.276,
              "y": -8.338,
              "z": 1.417
            },
            "gtin": "4104420213296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73a0",
            "leftCorner": {
              "x": -32.277,
              "y": -8.304,
              "z": 1.417
            },
            "rightCorner": {
              "x": -32.13,
              "y": -8.302,
              "z": 1.417
            },
            "gtin": "4104420213296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73a1",
            "leftCorner": {
              "x": -32.13,
              "y": -8.301,
              "z": 1.417
            },
            "rightCorner": {
              "x": -31.977,
              "y": -8.299,
              "z": 1.417
            },
            "gtin": "4104420072787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73a2",
            "leftCorner": {
              "x": -31.977,
              "y": -8.297,
              "z": 1.417
            },
            "rightCorner": {
              "x": -31.793,
              "y": -8.295,
              "z": 1.417
            },
            "gtin": "4104420133648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73a3",
            "leftCorner": {
              "x": -31.793,
              "y": -8.295,
              "z": 1.417
            },
            "rightCorner": {
              "x": -31.555,
              "y": -8.292,
              "z": 1.417
            },
            "gtin": "8936146201587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73a4",
            "leftCorner": {
              "x": -31.554,
              "y": -8.3,
              "z": 1.417
            },
            "rightCorner": {
              "x": -31.437,
              "y": -8.299,
              "z": 1.417
            },
            "gtin": "4104420133365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73a5",
            "leftCorner": {
              "x": -31.437,
              "y": -8.295,
              "z": 1.417
            },
            "rightCorner": {
              "x": -31.29,
              "y": -8.293,
              "z": 1.417
            },
            "gtin": "4104420070189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73a6",
            "leftCorner": {
              "x": -31.29,
              "y": -8.295,
              "z": 1.417
            },
            "rightCorner": {
              "x": -31.212,
              "y": -8.293,
              "z": 1.417
            },
            "gtin": "4104420070202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d73a7",
            "leftCorner": {
              "x": -31.212,
              "y": -8.293,
              "z": 1.417
            },
            "rightCorner": {
              "x": -31.135,
              "y": -8.292,
              "z": 1.417
            },
            "gtin": "4104420070202",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c4a",
    "rightNeighborShelfId": "a6a"
  },
  {
    "id": "c9b",
    "name": "c9b",
    "x": -32.22,
    "y": -17.26,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.19373,
      "w": 0.98106
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 82
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d40f",
        "height": 0.17465,
        "facings": [
          {
            "id": "35fac0440064e7693f6bab8b",
            "leftCorner": {
              "x": -32.188,
              "y": -17.337,
              "z": 0.143
            },
            "rightCorner": {
              "x": -32.148,
              "y": -17.32,
              "z": 0.143
            },
            "gtin": "4006000002255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1bfbc308f422dee0306d293d",
            "leftCorner": {
              "x": -32.148,
              "y": -17.32,
              "z": 0.143
            },
            "rightCorner": {
              "x": -32.085,
              "y": -17.294,
              "z": 0.143
            },
            "gtin": "5060144644732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "38352c582c91d13d2463f3e3",
            "leftCorner": {
              "x": -32.085,
              "y": -17.294,
              "z": 0.143
            },
            "rightCorner": {
              "x": -32.058,
              "y": -17.283,
              "z": 0.143
            },
            "gtin": "8001090876416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5a53896dd421d48ae27a1749",
            "leftCorner": {
              "x": -32.058,
              "y": -17.283,
              "z": 0.143
            },
            "rightCorner": {
              "x": -32.028,
              "y": -17.271,
              "z": 0.143
            },
            "gtin": "4006000020068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f96ec9eae15b82bdedefe00d",
            "leftCorner": {
              "x": -32.028,
              "y": -17.271,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.989,
              "y": -17.255,
              "z": 0.143
            },
            "gtin": "5060896573571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "367d10a0392c8cf055cfda29",
            "leftCorner": {
              "x": -31.989,
              "y": -17.255,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.949,
              "y": -17.239,
              "z": 0.143
            },
            "gtin": "4006000002255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1f7e4011767fc2f73eef2e3c",
            "leftCorner": {
              "x": -31.949,
              "y": -17.239,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.905,
              "y": -17.22,
              "z": 0.143
            },
            "gtin": "4005900613516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bac63d167b9c06e1a6fd321b",
            "leftCorner": {
              "x": -31.905,
              "y": -17.22,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.857,
              "y": -17.201,
              "z": 0.143
            },
            "gtin": "4006000160498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "581dfe71bf2ba8cd122abb72",
            "leftCorner": {
              "x": -31.857,
              "y": -17.201,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.807,
              "y": -17.18,
              "z": 0.143
            },
            "gtin": "4006000002415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8c5b9c3fe8d5dfb977e9d625",
            "leftCorner": {
              "x": -31.807,
              "y": -17.18,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.756,
              "y": -17.159,
              "z": 0.143
            },
            "gtin": "3600524062651",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "da678f6981830b51db0e842c",
            "leftCorner": {
              "x": -31.756,
              "y": -17.159,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.705,
              "y": -17.138,
              "z": 0.143
            },
            "gtin": "3600523526109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "adae8b543c11f0b7b8819152",
            "leftCorner": {
              "x": -31.705,
              "y": -17.138,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.651,
              "y": -17.116,
              "z": 0.143
            },
            "gtin": "3600523816262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "86f0ec0c7be99d3f93df385b",
            "leftCorner": {
              "x": -31.651,
              "y": -17.116,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.598,
              "y": -17.094,
              "z": 0.143
            },
            "gtin": "5060896573595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bb4728d9d0b4af373e7d6aa3",
            "leftCorner": {
              "x": -31.598,
              "y": -17.094,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.543,
              "y": -17.072,
              "z": 0.143
            },
            "gtin": "4006000107585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fcaf54c2e1ae77c48079a0f2",
            "leftCorner": {
              "x": -31.543,
              "y": -17.072,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.487,
              "y": -17.049,
              "z": 0.143
            },
            "gtin": "4005900681874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "56ae6c9be767919388ccc659",
            "leftCorner": {
              "x": -31.487,
              "y": -17.049,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.431,
              "y": -17.026,
              "z": 0.143
            },
            "gtin": "4005900612663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ccd6e0f58803ad1165a970dc",
            "leftCorner": {
              "x": -31.431,
              "y": -17.026,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.372,
              "y": -17.001,
              "z": 0.143
            },
            "gtin": "4260380010662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2babc70bb0026b1d5c1354fd",
            "leftCorner": {
              "x": -31.372,
              "y": -17.001,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.312,
              "y": -16.977,
              "z": 0.143
            },
            "gtin": "4260380010655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fdd8f980e5cd3960255e593d",
            "leftCorner": {
              "x": -31.312,
              "y": -16.977,
              "z": 0.143
            },
            "rightCorner": {
              "x": -31.036,
              "y": -16.863,
              "z": 0.143
            },
            "gtin": "3015810608817",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d40b",
        "height": 0.49507,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7577",
            "leftCorner": {
              "x": -32.119,
              "y": -17.23,
              "z": 0.405
            },
            "rightCorner": {
              "x": -32.041,
              "y": -17.199,
              "z": 0.405
            },
            "gtin": "8001090876416",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a8e00b31afc88383a8e5847c",
            "leftCorner": {
              "x": -32.197,
              "y": -17.317,
              "z": 0.405
            },
            "rightCorner": {
              "x": -32.107,
              "y": -17.28,
              "z": 0.405
            },
            "gtin": "4005900918628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7578",
            "leftCorner": {
              "x": -32.039,
              "y": -17.205,
              "z": 0.405
            },
            "rightCorner": {
              "x": -31.988,
              "y": -17.184,
              "z": 0.405
            },
            "gtin": "4005900613516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7579",
            "leftCorner": {
              "x": -31.987,
              "y": -17.185,
              "z": 0.405
            },
            "rightCorner": {
              "x": -31.703,
              "y": -17.068,
              "z": 0.405
            },
            "gtin": "3015810608817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d757a",
            "leftCorner": {
              "x": -31.702,
              "y": -17.071,
              "z": 0.405
            },
            "rightCorner": {
              "x": -31.612,
              "y": -17.034,
              "z": 0.405
            },
            "gtin": "8001090978714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d757b",
            "leftCorner": {
              "x": -31.609,
              "y": -17.04,
              "z": 0.405
            },
            "rightCorner": {
              "x": -31.498,
              "y": -16.995,
              "z": 0.405
            },
            "gtin": "8720181343452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d757c",
            "leftCorner": {
              "x": -31.497,
              "y": -16.998,
              "z": 0.405
            },
            "rightCorner": {
              "x": -31.442,
              "y": -16.976,
              "z": 0.405
            },
            "gtin": "8720181343469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d757d",
            "leftCorner": {
              "x": -31.445,
              "y": -16.969,
              "z": 0.405
            },
            "rightCorner": {
              "x": -31.379,
              "y": -16.941,
              "z": 0.405
            },
            "gtin": "8720181343476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d757e",
            "leftCorner": {
              "x": -31.379,
              "y": -16.94,
              "z": 0.405
            },
            "rightCorner": {
              "x": -31.321,
              "y": -16.916,
              "z": 0.405
            },
            "gtin": "4005900612663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d757f",
            "leftCorner": {
              "x": -31.322,
              "y": -16.914,
              "z": 0.405
            },
            "rightCorner": {
              "x": -31.198,
              "y": -16.863,
              "z": 0.405
            },
            "gtin": "4006000079356",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7580",
            "leftCorner": {
              "x": -31.198,
              "y": -16.862,
              "z": 0.405
            },
            "rightCorner": {
              "x": -31.135,
              "y": -16.837,
              "z": 0.405
            },
            "gtin": "8001841694054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7581",
            "leftCorner": {
              "x": -31.136,
              "y": -16.836,
              "z": 0.405
            },
            "rightCorner": {
              "x": -31.034,
              "y": -16.793,
              "z": 0.405
            },
            "gtin": "4027800479832",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d409",
        "height": 0.76901,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d75e0",
            "leftCorner": {
              "x": -32.19,
              "y": -17.262,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.126,
              "y": -17.236,
              "z": 0.629
            },
            "gtin": "4006000107585",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3b8bb3591e5d948964af0202",
            "leftCorner": {
              "x": -32.197,
              "y": -17.315,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.175,
              "y": -17.306,
              "z": 0.629
            },
            "gtin": "8714789939681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "008a576bedda5d49de63202e",
            "leftCorner": {
              "x": -31.518,
              "y": -17.036,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.473,
              "y": -17.018,
              "z": 0.629
            },
            "gtin": "4006000002217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75e1",
            "leftCorner": {
              "x": -32.126,
              "y": -17.237,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.071,
              "y": -17.214,
              "z": 0.629
            },
            "gtin": "4005900681874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75e2",
            "leftCorner": {
              "x": -32.07,
              "y": -17.215,
              "z": 0.629
            },
            "rightCorner": {
              "x": -32.003,
              "y": -17.187,
              "z": 0.629
            },
            "gtin": "4005900622181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75e3",
            "leftCorner": {
              "x": -32.002,
              "y": -17.189,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.933,
              "y": -17.161,
              "z": 0.629
            },
            "gtin": "4006000002330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75e4",
            "leftCorner": {
              "x": -31.932,
              "y": -17.162,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.886,
              "y": -17.143,
              "z": 0.629
            },
            "gtin": "4006000160498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75e5",
            "leftCorner": {
              "x": -31.886,
              "y": -17.144,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.836,
              "y": -17.125,
              "z": 0.629
            },
            "gtin": "4006000002415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75e6",
            "leftCorner": {
              "x": -31.838,
              "y": -17.123,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.776,
              "y": -17.097,
              "z": 0.629
            },
            "gtin": "4006000024929",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75e7",
            "leftCorner": {
              "x": -31.776,
              "y": -17.098,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.737,
              "y": -17.082,
              "z": 0.629
            },
            "gtin": "4006000002217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75e8",
            "leftCorner": {
              "x": -31.732,
              "y": -17.094,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.688,
              "y": -17.075,
              "z": 0.629
            },
            "gtin": "4006000020068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75e9",
            "leftCorner": {
              "x": -31.688,
              "y": -17.075,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.649,
              "y": -17.059,
              "z": 0.629
            },
            "gtin": "4006000002217",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75ea",
            "leftCorner": {
              "x": -31.649,
              "y": -17.058,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.592,
              "y": -17.035,
              "z": 0.629
            },
            "gtin": "5060144644701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75eb",
            "leftCorner": {
              "x": -31.592,
              "y": -17.034,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.529,
              "y": -17.008,
              "z": 0.629
            },
            "gtin": "4260380014134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75ed",
            "leftCorner": {
              "x": -31.483,
              "y": -16.991,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.428,
              "y": -16.969,
              "z": 0.629
            },
            "gtin": "5060896573595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75ee",
            "leftCorner": {
              "x": -31.43,
              "y": -16.963,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.384,
              "y": -16.945,
              "z": 0.629
            },
            "gtin": "5060896573571",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75ef",
            "leftCorner": {
              "x": -31.386,
              "y": -16.943,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.327,
              "y": -16.92,
              "z": 0.629
            },
            "gtin": "4260380010662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75f0",
            "leftCorner": {
              "x": -31.328,
              "y": -16.918,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.27,
              "y": -16.895,
              "z": 0.629
            },
            "gtin": "4260380010655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75f1",
            "leftCorner": {
              "x": -31.271,
              "y": -16.892,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.216,
              "y": -16.869,
              "z": 0.629
            },
            "gtin": "3600523816262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75f2",
            "leftCorner": {
              "x": -31.216,
              "y": -16.868,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.163,
              "y": -16.846,
              "z": 0.629
            },
            "gtin": "3600523526109",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75f3",
            "leftCorner": {
              "x": -31.163,
              "y": -16.848,
              "z": 0.629
            },
            "rightCorner": {
              "x": -31.03,
              "y": -16.793,
              "z": 0.629
            },
            "gtin": "3600524062651",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d40d",
        "height": 1.2329,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d75bd",
            "leftCorner": {
              "x": -32.308,
              "y": -16.95,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.156,
              "y": -16.888,
              "z": 1.009
            },
            "gtin": "4027800013302",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f7d0230ac27e3ee658e3d7b0",
            "leftCorner": {
              "x": -32.311,
              "y": -17.039,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.284,
              "y": -17.028,
              "z": 1.009
            },
            "gtin": "4260682671189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75be",
            "leftCorner": {
              "x": -32.141,
              "y": -16.925,
              "z": 1.009
            },
            "rightCorner": {
              "x": -32.067,
              "y": -16.895,
              "z": 1.009
            },
            "gtin": "4027800103607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75bf",
            "leftCorner": {
              "x": -32.071,
              "y": -16.883,
              "z": 1.009
            },
            "rightCorner": {
              "x": -31.958,
              "y": -16.837,
              "z": 1.009
            },
            "gtin": "4027800799404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75c0",
            "leftCorner": {
              "x": -31.922,
              "y": -16.922,
              "z": 1.009
            },
            "rightCorner": {
              "x": -31.813,
              "y": -16.878,
              "z": 1.009
            },
            "gtin": "8001090422859",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75c1",
            "leftCorner": {
              "x": -31.786,
              "y": -16.944,
              "z": 1.009
            },
            "rightCorner": {
              "x": -31.677,
              "y": -16.899,
              "z": 1.009
            },
            "gtin": "7702018417759",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75c2",
            "leftCorner": {
              "x": -31.744,
              "y": -16.738,
              "z": 1.009
            },
            "rightCorner": {
              "x": -31.642,
              "y": -16.696,
              "z": 1.009
            },
            "gtin": "8001090418913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75c3",
            "leftCorner": {
              "x": -31.599,
              "y": -16.804,
              "z": 1.009
            },
            "rightCorner": {
              "x": -31.43,
              "y": -16.735,
              "z": 1.009
            },
            "gtin": "8001090456434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75c4",
            "leftCorner": {
              "x": -31.469,
              "y": -16.637,
              "z": 1.009
            },
            "rightCorner": {
              "x": -31.335,
              "y": -16.583,
              "z": 1.009
            },
            "gtin": "8001090419750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75c5",
            "leftCorner": {
              "x": -31.332,
              "y": -16.589,
              "z": 1.009
            },
            "rightCorner": {
              "x": -31.15,
              "y": -16.514,
              "z": 1.009
            },
            "gtin": "4027800551101",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d40a",
        "height": 1.4331,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d75ab",
            "leftCorner": {
              "x": -32.163,
              "y": -17.054,
              "z": 1.173
            },
            "rightCorner": {
              "x": -32.032,
              "y": -17.0,
              "z": 1.173
            },
            "gtin": "4027800892266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75ac",
            "leftCorner": {
              "x": -32.018,
              "y": -17.034,
              "z": 1.173
            },
            "rightCorner": {
              "x": -31.909,
              "y": -16.99,
              "z": 1.173
            },
            "gtin": "4027800011506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75ad",
            "leftCorner": {
              "x": -31.92,
              "y": -16.962,
              "z": 1.173
            },
            "rightCorner": {
              "x": -31.798,
              "y": -16.913,
              "z": 1.173
            },
            "gtin": "8001090422484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75ae",
            "leftCorner": {
              "x": -31.792,
              "y": -16.926,
              "z": 1.173
            },
            "rightCorner": {
              "x": -31.674,
              "y": -16.877,
              "z": 1.173
            },
            "gtin": "8001090561893",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75af",
            "leftCorner": {
              "x": -31.67,
              "y": -16.888,
              "z": 1.173
            },
            "rightCorner": {
              "x": -31.581,
              "y": -16.85,
              "z": 1.173
            },
            "gtin": "8001090418296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75b0",
            "leftCorner": {
              "x": -31.592,
              "y": -16.823,
              "z": 1.173
            },
            "rightCorner": {
              "x": -31.501,
              "y": -16.786,
              "z": 1.173
            },
            "gtin": "8001090456366",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75b1",
            "leftCorner": {
              "x": -31.484,
              "y": -16.83,
              "z": 1.173
            },
            "rightCorner": {
              "x": -31.4,
              "y": -16.796,
              "z": 1.173
            },
            "gtin": "8001090419354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75b2",
            "leftCorner": {
              "x": -31.407,
              "y": -16.776,
              "z": 1.173
            },
            "rightCorner": {
              "x": -31.299,
              "y": -16.733,
              "z": 1.173
            },
            "gtin": "8700216478762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75b3",
            "leftCorner": {
              "x": -31.309,
              "y": -16.708,
              "z": 1.173
            },
            "rightCorner": {
              "x": -31.212,
              "y": -16.668,
              "z": 1.173
            },
            "gtin": "8700216036894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75a0",
            "leftCorner": {
              "x": -31.228,
              "y": -16.629,
              "z": 1.173
            },
            "rightCorner": {
              "x": -31.143,
              "y": -16.594,
              "z": 1.173
            },
            "gtin": "8001090272126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d821a411b9275bf96711d8b1",
            "leftCorner": {
              "x": -32.26,
              "y": -17.161,
              "z": 1.173
            },
            "rightCorner": {
              "x": -32.145,
              "y": -17.114,
              "z": 1.173
            },
            "gtin": "4027800011506",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d40c",
        "height": 1.6971,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7596",
            "leftCorner": {
              "x": -32.127,
              "y": -17.078,
              "z": 1.389
            },
            "rightCorner": {
              "x": -32.024,
              "y": -17.035,
              "z": 1.389
            },
            "gtin": "4027800373307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7597",
            "leftCorner": {
              "x": -32.019,
              "y": -17.047,
              "z": 1.389
            },
            "rightCorner": {
              "x": -31.899,
              "y": -16.998,
              "z": 1.389
            },
            "gtin": "4027800015504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7598",
            "leftCorner": {
              "x": -31.909,
              "y": -16.974,
              "z": 1.389
            },
            "rightCorner": {
              "x": -31.795,
              "y": -16.927,
              "z": 1.389
            },
            "gtin": "8001090442819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7599",
            "leftCorner": {
              "x": -31.793,
              "y": -16.933,
              "z": 1.389
            },
            "rightCorner": {
              "x": -31.679,
              "y": -16.886,
              "z": 1.389
            },
            "gtin": "8001090616289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d759a",
            "leftCorner": {
              "x": -31.668,
              "y": -16.912,
              "z": 1.389
            },
            "rightCorner": {
              "x": -31.583,
              "y": -16.877,
              "z": 1.389
            },
            "gtin": "8001090420831",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d759b",
            "leftCorner": {
              "x": -31.592,
              "y": -16.857,
              "z": 1.389
            },
            "rightCorner": {
              "x": -31.49,
              "y": -16.815,
              "z": 1.389
            },
            "gtin": "8001090445780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d759c",
            "leftCorner": {
              "x": -31.486,
              "y": -16.826,
              "z": 1.389
            },
            "rightCorner": {
              "x": -31.392,
              "y": -16.787,
              "z": 1.389
            },
            "gtin": "8700216465946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d759d",
            "leftCorner": {
              "x": -31.394,
              "y": -16.783,
              "z": 1.389
            },
            "rightCorner": {
              "x": -31.302,
              "y": -16.745,
              "z": 1.389
            },
            "gtin": "8001090420879",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d759e",
            "leftCorner": {
              "x": -31.306,
              "y": -16.738,
              "z": 1.389
            },
            "rightCorner": {
              "x": -31.204,
              "y": -16.696,
              "z": 1.389
            },
            "gtin": "8700216036658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d758b",
            "leftCorner": {
              "x": -31.201,
              "y": -16.702,
              "z": 1.389
            },
            "rightCorner": {
              "x": -31.113,
              "y": -16.666,
              "z": 1.389
            },
            "gtin": "8001090269232",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "59c578b42f10bb663570634c",
            "leftCorner": {
              "x": -32.256,
              "y": -17.173,
              "z": 1.389
            },
            "rightCorner": {
              "x": -32.142,
              "y": -17.126,
              "z": 1.389
            },
            "gtin": "8001090442819",
            "stockLevel": "NO_STOCK"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c35",
    "rightNeighborShelfId": "c9c"
  },
  {
    "id": "c9c",
    "name": "c9c",
    "x": -31.064,
    "y": -16.785,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.19373,
      "w": 0.98106
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 57
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d415",
        "height": 0.16563,
        "facings": [
          {
            "id": "4b5cf1429485730eaaf771de",
            "leftCorner": {
              "x": -31.039,
              "y": -16.848,
              "z": 0.136
            },
            "rightCorner": {
              "x": -30.981,
              "y": -16.825,
              "z": 0.136
            },
            "gtin": "4260702180813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1351a777994cb6ddcf75e250",
            "leftCorner": {
              "x": -30.981,
              "y": -16.825,
              "z": 0.136
            },
            "rightCorner": {
              "x": -30.912,
              "y": -16.796,
              "z": 0.136
            },
            "gtin": "4001499967412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "64a0827922ebe6b9924fad3d",
            "leftCorner": {
              "x": -30.912,
              "y": -16.796,
              "z": 0.136
            },
            "rightCorner": {
              "x": -30.837,
              "y": -16.765,
              "z": 0.136
            },
            "gtin": "4002448101635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "13e32556ecec31cecb07557d",
            "leftCorner": {
              "x": -30.837,
              "y": -16.765,
              "z": 0.136
            },
            "rightCorner": {
              "x": -30.762,
              "y": -16.735,
              "z": 0.136
            },
            "gtin": "4251758405562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "32f7b83793b892b930a38fa1",
            "leftCorner": {
              "x": -30.762,
              "y": -16.735,
              "z": 0.136
            },
            "rightCorner": {
              "x": -30.682,
              "y": -16.701,
              "z": 0.136
            },
            "gtin": "7090025533969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9b715a6b54a0207c644c6baa",
            "leftCorner": {
              "x": -30.682,
              "y": -16.701,
              "z": 0.136
            },
            "rightCorner": {
              "x": -30.599,
              "y": -16.667,
              "z": 0.136
            },
            "gtin": "4260682671189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "586eafe09256f24e1c255475",
            "leftCorner": {
              "x": -30.599,
              "y": -16.667,
              "z": 0.136
            },
            "rightCorner": {
              "x": -30.507,
              "y": -16.63,
              "z": 0.136
            },
            "gtin": "4001499967450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2f055e58d411b4ee6f6b58f1",
            "leftCorner": {
              "x": -30.507,
              "y": -16.63,
              "z": 0.136
            },
            "rightCorner": {
              "x": -30.41,
              "y": -16.59,
              "z": 0.136
            },
            "gtin": "4001499967429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5615771cb76bfef0c7728f09",
            "leftCorner": {
              "x": -30.41,
              "y": -16.59,
              "z": 0.136
            },
            "rightCorner": {
              "x": -30.309,
              "y": -16.548,
              "z": 0.136
            },
            "gtin": "4251758417787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bb00b5e6a56918958df79f0a",
            "leftCorner": {
              "x": -30.309,
              "y": -16.548,
              "z": 0.136
            },
            "rightCorner": {
              "x": -30.207,
              "y": -16.506,
              "z": 0.136
            },
            "gtin": "4010054007609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a8f6f63ea41408aba4937b22",
            "leftCorner": {
              "x": -30.207,
              "y": -16.506,
              "z": 0.136
            },
            "rightCorner": {
              "x": -30.104,
              "y": -16.464,
              "z": 0.136
            },
            "gtin": "4021457632947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "38d6bd04e4377b314cb87763",
            "leftCorner": {
              "x": -30.104,
              "y": -16.464,
              "z": 0.136
            },
            "rightCorner": {
              "x": -29.887,
              "y": -16.375,
              "z": 0.136
            },
            "gtin": "4002448122883",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d410",
        "height": 0.49147,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7582",
            "leftCorner": {
              "x": -31.035,
              "y": -16.792,
              "z": 0.402
            },
            "rightCorner": {
              "x": -30.815,
              "y": -16.701,
              "z": 0.402
            },
            "gtin": "4103040048264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7583",
            "leftCorner": {
              "x": -30.814,
              "y": -16.702,
              "z": 0.402
            },
            "rightCorner": {
              "x": -30.703,
              "y": -16.657,
              "z": 0.402
            },
            "gtin": "4051089810369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7584",
            "leftCorner": {
              "x": -30.703,
              "y": -16.658,
              "z": 0.402
            },
            "rightCorner": {
              "x": -30.585,
              "y": -16.609,
              "z": 0.402
            },
            "gtin": "4260380014615",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7585",
            "leftCorner": {
              "x": -30.585,
              "y": -16.611,
              "z": 0.402
            },
            "rightCorner": {
              "x": -30.469,
              "y": -16.564,
              "z": 0.402
            },
            "gtin": "4008233172385",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7586",
            "leftCorner": {
              "x": -30.47,
              "y": -16.56,
              "z": 0.402
            },
            "rightCorner": {
              "x": -30.385,
              "y": -16.526,
              "z": 0.402
            },
            "gtin": "4000388179004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7587",
            "leftCorner": {
              "x": -30.385,
              "y": -16.526,
              "z": 0.402
            },
            "rightCorner": {
              "x": -30.302,
              "y": -16.49,
              "z": 0.402
            },
            "gtin": "4000388179004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7588",
            "leftCorner": {
              "x": -30.303,
              "y": -16.486,
              "z": 0.402
            },
            "rightCorner": {
              "x": -30.104,
              "y": -16.404,
              "z": 0.402
            },
            "gtin": "4005808807017",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7589",
            "leftCorner": {
              "x": -30.104,
              "y": -16.404,
              "z": 0.402
            },
            "rightCorner": {
              "x": -29.952,
              "y": -16.342,
              "z": 0.402
            },
            "gtin": "4005808807000",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d414",
        "height": 0.76696,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d75f4",
            "leftCorner": {
              "x": -31.033,
              "y": -16.786,
              "z": 0.628
            },
            "rightCorner": {
              "x": -30.855,
              "y": -16.713,
              "z": 0.628
            },
            "gtin": "8714789939681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75f5",
            "leftCorner": {
              "x": -30.854,
              "y": -16.715,
              "z": 0.628
            },
            "rightCorner": {
              "x": -30.689,
              "y": -16.647,
              "z": 0.628
            },
            "gtin": "8714789673653",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75f6",
            "leftCorner": {
              "x": -30.689,
              "y": -16.646,
              "z": 0.628
            },
            "rightCorner": {
              "x": -30.497,
              "y": -16.567,
              "z": 0.628
            },
            "gtin": "8003520013040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75f7",
            "leftCorner": {
              "x": -30.496,
              "y": -16.569,
              "z": 0.628
            },
            "rightCorner": {
              "x": -30.304,
              "y": -16.49,
              "z": 0.628
            },
            "gtin": "8003520012944",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75f8",
            "leftCorner": {
              "x": -30.305,
              "y": -16.486,
              "z": 0.628
            },
            "rightCorner": {
              "x": -30.114,
              "y": -16.408,
              "z": 0.628
            },
            "gtin": "4260702187003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75f9",
            "leftCorner": {
              "x": -30.114,
              "y": -16.408,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.962,
              "y": -16.346,
              "z": 0.628
            },
            "gtin": "4260372933740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75ce",
            "leftCorner": {
              "x": -29.962,
              "y": -16.346,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.903,
              "y": -16.322,
              "z": 0.628
            },
            "gtin": "4260702180813",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d413",
        "height": 0.98426,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7610",
            "leftCorner": {
              "x": -31.045,
              "y": -16.83,
              "z": 0.805
            },
            "rightCorner": {
              "x": -30.93,
              "y": -16.783,
              "z": 0.805
            },
            "gtin": "4002448101659",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7612",
            "leftCorner": {
              "x": -30.947,
              "y": -16.743,
              "z": 0.805
            },
            "rightCorner": {
              "x": -30.864,
              "y": -16.709,
              "z": 0.805
            },
            "gtin": "4002448101635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7613",
            "leftCorner": {
              "x": -30.863,
              "y": -16.713,
              "z": 0.805
            },
            "rightCorner": {
              "x": -30.743,
              "y": -16.665,
              "z": 0.805
            },
            "gtin": "4001499967443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7614",
            "leftCorner": {
              "x": -30.742,
              "y": -16.666,
              "z": 0.805
            },
            "rightCorner": {
              "x": -30.663,
              "y": -16.634,
              "z": 0.805
            },
            "gtin": "4001499967450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7615",
            "leftCorner": {
              "x": -30.664,
              "y": -16.63,
              "z": 0.805
            },
            "rightCorner": {
              "x": -30.562,
              "y": -16.588,
              "z": 0.805
            },
            "gtin": "4001499967429",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7616",
            "leftCorner": {
              "x": -30.561,
              "y": -16.592,
              "z": 0.805
            },
            "rightCorner": {
              "x": -30.496,
              "y": -16.566,
              "z": 0.805
            },
            "gtin": "4001499967412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7617",
            "leftCorner": {
              "x": -30.497,
              "y": -16.563,
              "z": 0.805
            },
            "rightCorner": {
              "x": -30.351,
              "y": -16.503,
              "z": 0.805
            },
            "gtin": "4001499967979",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7618",
            "leftCorner": {
              "x": -30.352,
              "y": -16.5,
              "z": 0.805
            },
            "rightCorner": {
              "x": -30.238,
              "y": -16.454,
              "z": 0.805
            },
            "gtin": "4251758417763",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7619",
            "leftCorner": {
              "x": -30.239,
              "y": -16.45,
              "z": 0.805
            },
            "rightCorner": {
              "x": -30.143,
              "y": -16.411,
              "z": 0.805
            },
            "gtin": "4251758417787",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d761a",
            "leftCorner": {
              "x": -30.141,
              "y": -16.417,
              "z": 0.805
            },
            "rightCorner": {
              "x": -30.036,
              "y": -16.374,
              "z": 0.805
            },
            "gtin": "4021457632947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7611",
            "leftCorner": {
              "x": -30.038,
              "y": -16.368,
              "z": 0.805
            },
            "rightCorner": {
              "x": -29.906,
              "y": -16.314,
              "z": 0.805
            },
            "gtin": "4021457632855",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d411",
        "height": 1.2335,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d75c6",
            "leftCorner": {
              "x": -31.041,
              "y": -16.782,
              "z": 1.009
            },
            "rightCorner": {
              "x": -30.962,
              "y": -16.75,
              "z": 1.009
            },
            "gtin": "4260682671189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75c7",
            "leftCorner": {
              "x": -30.963,
              "y": -16.748,
              "z": 1.009
            },
            "rightCorner": {
              "x": -30.866,
              "y": -16.708,
              "z": 1.009
            },
            "gtin": "4260682671240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75c8",
            "leftCorner": {
              "x": -30.866,
              "y": -16.708,
              "z": 1.009
            },
            "rightCorner": {
              "x": -30.768,
              "y": -16.668,
              "z": 1.009
            },
            "gtin": "4260682671240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75c9",
            "leftCorner": {
              "x": -30.766,
              "y": -16.673,
              "z": 1.009
            },
            "rightCorner": {
              "x": -30.638,
              "y": -16.62,
              "z": 1.009
            },
            "gtin": "8008970051604",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75ca",
            "leftCorner": {
              "x": -30.639,
              "y": -16.617,
              "z": 1.009
            },
            "rightCorner": {
              "x": -30.493,
              "y": -16.558,
              "z": 1.009
            },
            "gtin": "7072463113316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75cb",
            "leftCorner": {
              "x": -30.493,
              "y": -16.558,
              "z": 1.009
            },
            "rightCorner": {
              "x": -30.376,
              "y": -16.509,
              "z": 1.009
            },
            "gtin": "4002448099871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75cc",
            "leftCorner": {
              "x": -30.376,
              "y": -16.507,
              "z": 1.009
            },
            "rightCorner": {
              "x": -30.189,
              "y": -16.43,
              "z": 1.009
            },
            "gtin": "4002448101901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75cd",
            "leftCorner": {
              "x": -30.188,
              "y": -16.433,
              "z": 1.009
            },
            "rightCorner": {
              "x": -30.02,
              "y": -16.364,
              "z": 1.009
            },
            "gtin": "7090025533969",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d75b5",
            "leftCorner": {
              "x": -30.019,
              "y": -16.365,
              "z": 1.009
            },
            "rightCorner": {
              "x": -29.904,
              "y": -16.318,
              "z": 1.009
            },
            "gtin": "7090025533600",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d412",
        "height": 1.4847,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7606",
            "leftCorner": {
              "x": -31.044,
              "y": -16.833,
              "z": 1.215
            },
            "rightCorner": {
              "x": -30.952,
              "y": -16.795,
              "z": 1.215
            },
            "gtin": "4251758435026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7607",
            "leftCorner": {
              "x": -30.952,
              "y": -16.795,
              "z": 1.215
            },
            "rightCorner": {
              "x": -30.859,
              "y": -16.757,
              "z": 1.215
            },
            "gtin": "4251758435026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7608",
            "leftCorner": {
              "x": -30.859,
              "y": -16.757,
              "z": 1.215
            },
            "rightCorner": {
              "x": -30.766,
              "y": -16.718,
              "z": 1.215
            },
            "gtin": "4251758435026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7609",
            "leftCorner": {
              "x": -30.766,
              "y": -16.718,
              "z": 1.215
            },
            "rightCorner": {
              "x": -30.674,
              "y": -16.681,
              "z": 1.215
            },
            "gtin": "4251758435026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d760b",
            "leftCorner": {
              "x": -30.689,
              "y": -16.644,
              "z": 1.215
            },
            "rightCorner": {
              "x": -30.545,
              "y": -16.585,
              "z": 1.215
            },
            "gtin": "4002448100027",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d760c",
            "leftCorner": {
              "x": -30.544,
              "y": -16.588,
              "z": 1.215
            },
            "rightCorner": {
              "x": -30.326,
              "y": -16.497,
              "z": 1.215
            },
            "gtin": "4002448122883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d760d",
            "leftCorner": {
              "x": -30.328,
              "y": -16.491,
              "z": 1.215
            },
            "rightCorner": {
              "x": -30.26,
              "y": -16.464,
              "z": 1.215
            },
            "gtin": "4251758405562",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d760e",
            "leftCorner": {
              "x": -30.259,
              "y": -16.467,
              "z": 1.215
            },
            "rightCorner": {
              "x": -30.124,
              "y": -16.41,
              "z": 1.215
            },
            "gtin": "4251758416926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d760f",
            "leftCorner": {
              "x": -30.123,
              "y": -16.413,
              "z": 1.215
            },
            "rightCorner": {
              "x": -30.011,
              "y": -16.367,
              "z": 1.215
            },
            "gtin": "4010054007609",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d760a",
            "leftCorner": {
              "x": -30.011,
              "y": -16.368,
              "z": 1.215
            },
            "rightCorner": {
              "x": -29.902,
              "y": -16.324,
              "z": 1.215
            },
            "gtin": "4010054009733",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c9b",
    "rightNeighborShelfId": "c9d"
  },
  {
    "id": "c9d",
    "name": "c9d",
    "x": -29.908,
    "y": -16.31,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.19373,
      "w": 0.98106
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 62
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d804",
        "height": 0.1652,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c95",
            "leftCorner": {
              "x": -29.8,
              "y": -16.573,
              "z": 0.135
            },
            "rightCorner": {
              "x": -29.666,
              "y": -16.517,
              "z": 0.135
            },
            "gtin": "4306188063971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c96",
            "leftCorner": {
              "x": -29.666,
              "y": -16.517,
              "z": 0.135
            },
            "rightCorner": {
              "x": -29.532,
              "y": -16.462,
              "z": 0.135
            },
            "gtin": "4306188063971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c97",
            "leftCorner": {
              "x": -29.532,
              "y": -16.462,
              "z": 0.135
            },
            "rightCorner": {
              "x": -29.398,
              "y": -16.407,
              "z": 0.135
            },
            "gtin": "4306188063971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c98",
            "leftCorner": {
              "x": -29.398,
              "y": -16.407,
              "z": 0.135
            },
            "rightCorner": {
              "x": -29.263,
              "y": -16.352,
              "z": 0.135
            },
            "gtin": "4306188063971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c99",
            "leftCorner": {
              "x": -29.263,
              "y": -16.352,
              "z": 0.135
            },
            "rightCorner": {
              "x": -29.13,
              "y": -16.296,
              "z": 0.135
            },
            "gtin": "4306188063971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c9b",
            "leftCorner": {
              "x": -29.145,
              "y": -16.261,
              "z": 0.135
            },
            "rightCorner": {
              "x": -29.026,
              "y": -16.213,
              "z": 0.135
            },
            "gtin": "5907620100071",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c9a",
            "leftCorner": {
              "x": -29.024,
              "y": -16.218,
              "z": 0.135
            },
            "rightCorner": {
              "x": -28.888,
              "y": -16.161,
              "z": 0.135
            },
            "gtin": "6974246460048",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d803",
        "height": 0.49216,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c8f",
            "leftCorner": {
              "x": -29.82,
              "y": -16.523,
              "z": 0.403
            },
            "rightCorner": {
              "x": -29.679,
              "y": -16.464,
              "z": 0.403
            },
            "gtin": "8714789700045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c90",
            "leftCorner": {
              "x": -29.679,
              "y": -16.464,
              "z": 0.403
            },
            "rightCorner": {
              "x": -29.538,
              "y": -16.406,
              "z": 0.403
            },
            "gtin": "8714789700045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c91",
            "leftCorner": {
              "x": -29.538,
              "y": -16.406,
              "z": 0.403
            },
            "rightCorner": {
              "x": -29.396,
              "y": -16.349,
              "z": 0.403
            },
            "gtin": "8714789700045",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c93",
            "leftCorner": {
              "x": -29.417,
              "y": -16.299,
              "z": 0.403
            },
            "rightCorner": {
              "x": -29.217,
              "y": -16.217,
              "z": 0.403
            },
            "gtin": "8714789700069",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c94",
            "leftCorner": {
              "x": -29.207,
              "y": -16.241,
              "z": 0.403
            },
            "rightCorner": {
              "x": -29.026,
              "y": -16.167,
              "z": 0.403
            },
            "gtin": "4005900939616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c92",
            "leftCorner": {
              "x": -29.023,
              "y": -16.175,
              "z": 0.403
            },
            "rightCorner": {
              "x": -28.902,
              "y": -16.126,
              "z": 0.403
            },
            "gtin": "8720182264664",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d801",
        "height": 0.76731,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c7f",
            "leftCorner": {
              "x": -29.824,
              "y": -16.513,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.567,
              "y": -16.408,
              "z": 0.628
            },
            "gtin": "4103040051639",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c81",
            "leftCorner": {
              "x": -29.582,
              "y": -16.372,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.509,
              "y": -16.342,
              "z": 0.628
            },
            "gtin": "4012758305258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c82",
            "leftCorner": {
              "x": -29.514,
              "y": -16.332,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.442,
              "y": -16.302,
              "z": 0.628
            },
            "gtin": "4012758301021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c83",
            "leftCorner": {
              "x": -29.44,
              "y": -16.307,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.313,
              "y": -16.255,
              "z": 0.628
            },
            "gtin": "4012758301410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c84",
            "leftCorner": {
              "x": -29.313,
              "y": -16.255,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.184,
              "y": -16.202,
              "z": 0.628
            },
            "gtin": "4012758301410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c85",
            "leftCorner": {
              "x": -29.173,
              "y": -16.229,
              "z": 0.628
            },
            "rightCorner": {
              "x": -29.035,
              "y": -16.172,
              "z": 0.628
            },
            "gtin": "4009800004603",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50fe1820c81800d8c80",
            "leftCorner": {
              "x": -29.032,
              "y": -16.18,
              "z": 0.628
            },
            "rightCorner": {
              "x": -28.902,
              "y": -16.126,
              "z": 0.628
            },
            "gtin": "4045612009412",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d802",
        "height": 0.97969,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c86",
            "leftCorner": {
              "x": -29.828,
              "y": -16.506,
              "z": 0.802
            },
            "rightCorner": {
              "x": -29.659,
              "y": -16.437,
              "z": 0.802
            },
            "gtin": "4306188038801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c87",
            "leftCorner": {
              "x": -29.659,
              "y": -16.437,
              "z": 0.802
            },
            "rightCorner": {
              "x": -29.491,
              "y": -16.367,
              "z": 0.802
            },
            "gtin": "4306188038801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c89",
            "leftCorner": {
              "x": -29.51,
              "y": -16.322,
              "z": 0.802
            },
            "rightCorner": {
              "x": -29.461,
              "y": -16.302,
              "z": 0.802
            },
            "gtin": "4051089815173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c8a",
            "leftCorner": {
              "x": -29.461,
              "y": -16.302,
              "z": 0.802
            },
            "rightCorner": {
              "x": -29.412,
              "y": -16.282,
              "z": 0.802
            },
            "gtin": "4051089815173",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c8b",
            "leftCorner": {
              "x": -29.409,
              "y": -16.291,
              "z": 0.802
            },
            "rightCorner": {
              "x": -29.287,
              "y": -16.24,
              "z": 0.802
            },
            "gtin": "4000196031099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c8c",
            "leftCorner": {
              "x": -29.281,
              "y": -16.253,
              "z": 0.802
            },
            "rightCorner": {
              "x": -29.215,
              "y": -16.226,
              "z": 0.802
            },
            "gtin": "4013718021898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c8d",
            "leftCorner": {
              "x": -29.215,
              "y": -16.226,
              "z": 0.802
            },
            "rightCorner": {
              "x": -29.149,
              "y": -16.2,
              "z": 0.802
            },
            "gtin": "4013718021898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c8e",
            "leftCorner": {
              "x": -29.149,
              "y": -16.2,
              "z": 0.802
            },
            "rightCorner": {
              "x": -29.084,
              "y": -16.173,
              "z": 0.802
            },
            "gtin": "4013718021898",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c88",
            "leftCorner": {
              "x": -29.077,
              "y": -16.186,
              "z": 0.802
            },
            "rightCorner": {
              "x": -28.906,
              "y": -16.115,
              "z": 0.802
            },
            "gtin": "4003383050071",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d800",
        "height": 1.2318,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c74",
            "leftCorner": {
              "x": -29.821,
              "y": -16.52,
              "z": 1.008
            },
            "rightCorner": {
              "x": -29.598,
              "y": -16.428,
              "z": 1.008
            },
            "gtin": "4260372938271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c76",
            "leftCorner": {
              "x": -29.619,
              "y": -16.379,
              "z": 1.008
            },
            "rightCorner": {
              "x": -29.573,
              "y": -16.361,
              "z": 1.008
            },
            "gtin": "4008890006054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c77",
            "leftCorner": {
              "x": -29.575,
              "y": -16.357,
              "z": 1.008
            },
            "rightCorner": {
              "x": -29.5,
              "y": -16.327,
              "z": 1.008
            },
            "gtin": "4008890006054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c78",
            "leftCorner": {
              "x": -29.504,
              "y": -16.317,
              "z": 1.008
            },
            "rightCorner": {
              "x": -29.41,
              "y": -16.279,
              "z": 1.008
            },
            "gtin": "3574661687049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c79",
            "leftCorner": {
              "x": -29.401,
              "y": -16.3,
              "z": 1.008
            },
            "rightCorner": {
              "x": -29.321,
              "y": -16.267,
              "z": 1.008
            },
            "gtin": "3574661685977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c7a",
            "leftCorner": {
              "x": -29.318,
              "y": -16.275,
              "z": 1.008
            },
            "rightCorner": {
              "x": -29.227,
              "y": -16.237,
              "z": 1.008
            },
            "gtin": "3574661687018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c7b",
            "leftCorner": {
              "x": -29.226,
              "y": -16.24,
              "z": 1.008
            },
            "rightCorner": {
              "x": -29.123,
              "y": -16.198,
              "z": 1.008
            },
            "gtin": "42420187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c7c",
            "leftCorner": {
              "x": -29.121,
              "y": -16.203,
              "z": 1.008
            },
            "rightCorner": {
              "x": -29.068,
              "y": -16.18,
              "z": 1.008
            },
            "gtin": "42417521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c7d",
            "leftCorner": {
              "x": -29.067,
              "y": -16.181,
              "z": 1.008
            },
            "rightCorner": {
              "x": -29.005,
              "y": -16.157,
              "z": 1.008
            },
            "gtin": "42419792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c7e",
            "leftCorner": {
              "x": -29.004,
              "y": -16.159,
              "z": 1.008
            },
            "rightCorner": {
              "x": -28.963,
              "y": -16.142,
              "z": 1.008
            },
            "gtin": "42417514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c75",
            "leftCorner": {
              "x": -28.963,
              "y": -16.142,
              "z": 1.008
            },
            "rightCorner": {
              "x": -28.905,
              "y": -16.118,
              "z": 1.008
            },
            "gtin": "42417514",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7ff",
        "height": 1.483,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8c6b",
            "leftCorner": {
              "x": -29.819,
              "y": -16.527,
              "z": 1.213
            },
            "rightCorner": {
              "x": -29.623,
              "y": -16.446,
              "z": 1.213
            },
            "gtin": "4036581536306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c6c",
            "leftCorner": {
              "x": -29.644,
              "y": -16.394,
              "z": 1.213
            },
            "rightCorner": {
              "x": -29.586,
              "y": -16.37,
              "z": 1.213
            },
            "gtin": "4036581536337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c6d",
            "leftCorner": {
              "x": -29.586,
              "y": -16.37,
              "z": 1.213
            },
            "rightCorner": {
              "x": -29.47,
              "y": -16.323,
              "z": 1.213
            },
            "gtin": "4036581536535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c6e",
            "leftCorner": {
              "x": -29.474,
              "y": -16.313,
              "z": 1.213
            },
            "rightCorner": {
              "x": -29.367,
              "y": -16.269,
              "z": 1.213
            },
            "gtin": "4036581536504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c6f",
            "leftCorner": {
              "x": -29.357,
              "y": -16.293,
              "z": 1.213
            },
            "rightCorner": {
              "x": -29.269,
              "y": -16.257,
              "z": 1.213
            },
            "gtin": "4010054007104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c70",
            "leftCorner": {
              "x": -29.267,
              "y": -16.263,
              "z": 1.213
            },
            "rightCorner": {
              "x": -29.173,
              "y": -16.225,
              "z": 1.213
            },
            "gtin": "4000196031051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c71",
            "leftCorner": {
              "x": -29.173,
              "y": -16.226,
              "z": 1.213
            },
            "rightCorner": {
              "x": -29.09,
              "y": -16.192,
              "z": 1.213
            },
            "gtin": "4000196031136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c72",
            "leftCorner": {
              "x": -29.086,
              "y": -16.202,
              "z": 1.213
            },
            "rightCorner": {
              "x": -29.011,
              "y": -16.17,
              "z": 1.213
            },
            "gtin": "4008233149288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8c73",
            "leftCorner": {
              "x": -29.011,
              "y": -16.171,
              "z": 1.213
            },
            "rightCorner": {
              "x": -28.919,
              "y": -16.133,
              "z": 1.213
            },
            "gtin": "4260370432443",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d805",
        "height": 1.6251,
        "facings": [
          {
            "id": "9511f6097a2cfbd2e3d9c1ea",
            "leftCorner": {
              "x": -29.86,
              "y": -16.427,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.815,
              "y": -16.409,
              "z": 1.33
            },
            "gtin": "42398165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b89fb6beca9c5ced244d9feb",
            "leftCorner": {
              "x": -29.815,
              "y": -16.409,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.767,
              "y": -16.39,
              "z": 1.33
            },
            "gtin": "4045612001348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e59bd8a718cbcf0b270b540a",
            "leftCorner": {
              "x": -29.767,
              "y": -16.39,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.723,
              "y": -16.371,
              "z": 1.33
            },
            "gtin": "42398165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4ec8265a4cd093dad103d1aa",
            "leftCorner": {
              "x": -29.723,
              "y": -16.371,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.675,
              "y": -16.352,
              "z": 1.33
            },
            "gtin": "4045612001348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9f69eb7529cfc44aba162958",
            "leftCorner": {
              "x": -29.675,
              "y": -16.352,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.624,
              "y": -16.331,
              "z": 1.33
            },
            "gtin": "42420187",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f32e743b1f4d129710083664",
            "leftCorner": {
              "x": -29.624,
              "y": -16.331,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.572,
              "y": -16.309,
              "z": 1.33
            },
            "gtin": "4036581536504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "077b24f7ddac44358a65c69c",
            "leftCorner": {
              "x": -29.572,
              "y": -16.309,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.517,
              "y": -16.287,
              "z": 1.33
            },
            "gtin": "42417521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7654dfcbcf81d579e95e8914",
            "leftCorner": {
              "x": -29.517,
              "y": -16.287,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.459,
              "y": -16.263,
              "z": 1.33
            },
            "gtin": "4036581536337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "67ecca0f99ae40c37117b744",
            "leftCorner": {
              "x": -29.459,
              "y": -16.263,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.398,
              "y": -16.238,
              "z": 1.33
            },
            "gtin": "42419792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "71212831e1af02a327091c6c",
            "leftCorner": {
              "x": -29.398,
              "y": -16.238,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.33,
              "y": -16.21,
              "z": 1.33
            },
            "gtin": "4012758301021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d03990a667422ababb8daee9",
            "leftCorner": {
              "x": -29.33,
              "y": -16.21,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.257,
              "y": -16.18,
              "z": 1.33
            },
            "gtin": "4008233149288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3762c7a17b5389124b5a0e03",
            "leftCorner": {
              "x": -29.257,
              "y": -16.18,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.18,
              "y": -16.148,
              "z": 1.33
            },
            "gtin": "3574661685977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "23eae0d9108bf398e5f3f00a",
            "leftCorner": {
              "x": -29.18,
              "y": -16.148,
              "z": 1.33
            },
            "rightCorner": {
              "x": -29.096,
              "y": -16.114,
              "z": 1.33
            },
            "gtin": "4000196031136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ede0575a22947ce24cc98b74",
            "leftCorner": {
              "x": -29.096,
              "y": -16.114,
              "z": 1.33
            },
            "rightCorner": {
              "x": -28.957,
              "y": -16.057,
              "z": 1.33
            },
            "gtin": "4009800004603",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "c9c"
  },
  {
    "id": "c9e",
    "name": "c9e",
    "x": -29.311,
    "y": -15.106,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.98446,
      "w": 0.17562
    },
    "layers": [],

    "rightNeighborShelfId": "c3e"
  },
  {
    "id": "e6d",
    "name": "e6d",
    "x": -21.867,
    "y": -4.711,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0033161,
      "w": 0.99999
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 33,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d7cf",
        "height": 0.15908,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8bea",
            "leftCorner": {
              "x": -21.867,
              "y": -4.717,
              "z": 0.13
            },
            "rightCorner": {
              "x": -20.95,
              "y": -4.723,
              "z": 0.13
            },
            "gtin": "4018588003289",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8beb",
            "leftCorner": {
              "x": -20.949,
              "y": -4.678,
              "z": 0.13
            },
            "rightCorner": {
              "x": -20.871,
              "y": -4.678,
              "z": 0.13
            },
            "gtin": "4082100005044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bec",
            "leftCorner": {
              "x": -20.871,
              "y": -4.678,
              "z": 0.13
            },
            "rightCorner": {
              "x": -20.793,
              "y": -4.679,
              "z": 0.13
            },
            "gtin": "4082100005044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bed",
            "leftCorner": {
              "x": -20.793,
              "y": -4.679,
              "z": 0.13
            },
            "rightCorner": {
              "x": -20.714,
              "y": -4.679,
              "z": 0.13
            },
            "gtin": "4082100005044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bee",
            "leftCorner": {
              "x": -20.714,
              "y": -4.679,
              "z": 0.13
            },
            "rightCorner": {
              "x": -20.636,
              "y": -4.68,
              "z": 0.13
            },
            "gtin": "4082100005044",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7cd",
        "height": 0.57646,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8bd9",
            "leftCorner": {
              "x": -21.867,
              "y": -4.671,
              "z": 0.472
            },
            "rightCorner": {
              "x": -21.629,
              "y": -4.672,
              "z": 0.472
            },
            "gtin": "40173832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bda",
            "leftCorner": {
              "x": -21.629,
              "y": -4.672,
              "z": 0.472
            },
            "rightCorner": {
              "x": -21.39,
              "y": -4.674,
              "z": 0.472
            },
            "gtin": "40173832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bdb",
            "leftCorner": {
              "x": -21.39,
              "y": -4.674,
              "z": 0.472
            },
            "rightCorner": {
              "x": -21.152,
              "y": -4.676,
              "z": 0.472
            },
            "gtin": "40173832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bdc",
            "leftCorner": {
              "x": -21.152,
              "y": -4.636,
              "z": 0.472
            },
            "rightCorner": {
              "x": -21.088,
              "y": -4.636,
              "z": 0.472
            },
            "gtin": "40173351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bdd",
            "leftCorner": {
              "x": -21.088,
              "y": -4.636,
              "z": 0.472
            },
            "rightCorner": {
              "x": -21.023,
              "y": -4.637,
              "z": 0.472
            },
            "gtin": "40173351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bde",
            "leftCorner": {
              "x": -21.023,
              "y": -4.637,
              "z": 0.472
            },
            "rightCorner": {
              "x": -20.958,
              "y": -4.637,
              "z": 0.472
            },
            "gtin": "40173351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bdf",
            "leftCorner": {
              "x": -20.958,
              "y": -4.637,
              "z": 0.472
            },
            "rightCorner": {
              "x": -20.893,
              "y": -4.637,
              "z": 0.472
            },
            "gtin": "40173351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8be0",
            "leftCorner": {
              "x": -20.893,
              "y": -4.629,
              "z": 0.472
            },
            "rightCorner": {
              "x": -20.812,
              "y": -4.629,
              "z": 0.472
            },
            "gtin": "4003669016203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8be1",
            "leftCorner": {
              "x": -20.812,
              "y": -4.629,
              "z": 0.472
            },
            "rightCorner": {
              "x": -20.731,
              "y": -4.63,
              "z": 0.472
            },
            "gtin": "4003669016203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8be2",
            "leftCorner": {
              "x": -20.731,
              "y": -4.63,
              "z": 0.472
            },
            "rightCorner": {
              "x": -20.65,
              "y": -4.63,
              "z": 0.472
            },
            "gtin": "4003669016203",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7ce",
        "height": 0.97758,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8be3",
            "leftCorner": {
              "x": -21.867,
              "y": -4.665,
              "z": 0.8
            },
            "rightCorner": {
              "x": -21.137,
              "y": -4.67,
              "z": 0.8
            },
            "gtin": "4105250024007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8be5",
            "leftCorner": {
              "x": -21.136,
              "y": -4.63,
              "z": 0.8
            },
            "rightCorner": {
              "x": -21.042,
              "y": -4.631,
              "z": 0.8
            },
            "gtin": "4013024000419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8be6",
            "leftCorner": {
              "x": -21.042,
              "y": -4.631,
              "z": 0.8
            },
            "rightCorner": {
              "x": -20.947,
              "y": -4.631,
              "z": 0.8
            },
            "gtin": "4013024000419",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8be7",
            "leftCorner": {
              "x": -20.947,
              "y": -4.629,
              "z": 0.8
            },
            "rightCorner": {
              "x": -20.855,
              "y": -4.63,
              "z": 0.8
            },
            "gtin": "4022396000026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8be8",
            "leftCorner": {
              "x": -20.855,
              "y": -4.63,
              "z": 0.8
            },
            "rightCorner": {
              "x": -20.763,
              "y": -4.63,
              "z": 0.8
            },
            "gtin": "4022396000026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8be9",
            "leftCorner": {
              "x": -20.763,
              "y": -4.63,
              "z": 0.8
            },
            "rightCorner": {
              "x": -20.67,
              "y": -4.631,
              "z": 0.8
            },
            "gtin": "4022396000026",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8be4",
            "leftCorner": {
              "x": -20.67,
              "y": -4.62,
              "z": 0.8
            },
            "rightCorner": {
              "x": -20.616,
              "y": -4.621,
              "z": 0.8
            },
            "gtin": "4005154011243",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7d0",
        "height": 1.3533,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8bef",
            "leftCorner": {
              "x": -21.867,
              "y": -4.667,
              "z": 1.107
            },
            "rightCorner": {
              "x": -21.498,
              "y": -4.67,
              "z": 1.107
            },
            "gtin": "4005686001361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bf0",
            "leftCorner": {
              "x": -21.498,
              "y": -4.67,
              "z": 1.107
            },
            "rightCorner": {
              "x": -21.127,
              "y": -4.672,
              "z": 1.107
            },
            "gtin": "4005686001361",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bf1",
            "leftCorner": {
              "x": -21.128,
              "y": -4.635,
              "z": 1.107
            },
            "rightCorner": {
              "x": -20.964,
              "y": -4.636,
              "z": 1.107
            },
            "gtin": "4103210206722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bf2",
            "leftCorner": {
              "x": -20.964,
              "y": -4.633,
              "z": 1.107
            },
            "rightCorner": {
              "x": -20.88,
              "y": -4.634,
              "z": 1.107
            },
            "gtin": "40173894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bf3",
            "leftCorner": {
              "x": -20.88,
              "y": -4.634,
              "z": 1.107
            },
            "rightCorner": {
              "x": -20.796,
              "y": -4.634,
              "z": 1.107
            },
            "gtin": "40173894",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bf4",
            "leftCorner": {
              "x": -20.795,
              "y": -4.625,
              "z": 1.107
            },
            "rightCorner": {
              "x": -20.619,
              "y": -4.626,
              "z": 1.107
            },
            "gtin": "4103210001297",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d7cb",
        "height": 1.7041,
        "facings": [
          {
            "id": "68d8e50fe1820c81800d8bd3",
            "leftCorner": {
              "x": -21.867,
              "y": -4.666,
              "z": 1.394
            },
            "rightCorner": {
              "x": -21.186,
              "y": -4.671,
              "z": 1.394
            },
            "gtin": "4027732101825",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50fe1820c81800d8bd5",
            "leftCorner": {
              "x": -21.187,
              "y": -4.634,
              "z": 1.394
            },
            "rightCorner": {
              "x": -21.106,
              "y": -4.634,
              "z": 1.394
            },
            "gtin": "4027732111268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bd6",
            "leftCorner": {
              "x": -21.106,
              "y": -4.634,
              "z": 1.394
            },
            "rightCorner": {
              "x": -21.025,
              "y": -4.635,
              "z": 1.394
            },
            "gtin": "4027732111268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bd7",
            "leftCorner": {
              "x": -21.025,
              "y": -4.635,
              "z": 1.394
            },
            "rightCorner": {
              "x": -20.945,
              "y": -4.635,
              "z": 1.394
            },
            "gtin": "4027732111268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bd8",
            "leftCorner": {
              "x": -20.944,
              "y": -4.629,
              "z": 1.394
            },
            "rightCorner": {
              "x": -20.785,
              "y": -4.63,
              "z": 1.394
            },
            "gtin": "4022789912448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50fe1820c81800d8bd4",
            "leftCorner": {
              "x": -20.785,
              "y": -4.627,
              "z": 1.394
            },
            "rightCorner": {
              "x": -20.616,
              "y": -4.629,
              "z": 1.394
            },
            "gtin": "4014807202044",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "e71",
    "name": "e71",
    "x": -10.426,
    "y": -20.112,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71173,
      "w": 0.70245
    },
    "layers": []
  },
  {
    "id": "e76",
    "name": "e76",
    "x": -17.889,
    "y": -45.764,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -1.0,
      "w": 1.3963E-4
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 39
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d08f",
        "height": 0.22323,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5fc4",
            "leftCorner": {
              "x": -19.002,
              "y": -45.692,
              "z": 0.183
            },
            "rightCorner": {
              "x": -19.138,
              "y": -45.692,
              "z": 0.183
            },
            "gtin": "4104420174788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d665e7f6ef0c09bd94d9535a",
            "leftCorner": {
              "x": -17.889,
              "y": -45.653,
              "z": 0.183
            },
            "rightCorner": {
              "x": -18.021,
              "y": -45.653,
              "z": 0.183
            },
            "gtin": "4104420174788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "677c32a2d32b155bbeaaf445",
            "leftCorner": {
              "x": -18.021,
              "y": -45.653,
              "z": 0.183
            },
            "rightCorner": {
              "x": -18.154,
              "y": -45.653,
              "z": 0.183
            },
            "gtin": "4104420174788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a2b03875c02e51a4db36b6f4",
            "leftCorner": {
              "x": -18.154,
              "y": -45.653,
              "z": 0.183
            },
            "rightCorner": {
              "x": -18.287,
              "y": -45.653,
              "z": 0.183
            },
            "gtin": "4104420174788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "772b28b142782505953f53ce",
            "leftCorner": {
              "x": -18.287,
              "y": -45.653,
              "z": 0.183
            },
            "rightCorner": {
              "x": -18.42,
              "y": -45.653,
              "z": 0.183
            },
            "gtin": "4104420174788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "21f4d564729e0f3ca35f5405",
            "leftCorner": {
              "x": -18.42,
              "y": -45.653,
              "z": 0.183
            },
            "rightCorner": {
              "x": -18.552,
              "y": -45.653,
              "z": 0.183
            },
            "gtin": "4104420174788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "53fc62adf0251cdfb3368f5a",
            "leftCorner": {
              "x": -18.552,
              "y": -45.653,
              "z": 0.183
            },
            "rightCorner": {
              "x": -18.685,
              "y": -45.653,
              "z": 0.183
            },
            "gtin": "4104420174788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e243fee91a00caed87155935",
            "leftCorner": {
              "x": -18.685,
              "y": -45.653,
              "z": 0.183
            },
            "rightCorner": {
              "x": -18.818,
              "y": -45.653,
              "z": 0.183
            },
            "gtin": "4104420174788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e62056749a637ebb4c4d6e00",
            "leftCorner": {
              "x": -18.818,
              "y": -45.653,
              "z": 0.183
            },
            "rightCorner": {
              "x": -18.951,
              "y": -45.653,
              "z": 0.183
            },
            "gtin": "4104420174788",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d08b",
        "height": 0.45752,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5fb0",
            "leftCorner": {
              "x": -17.888,
              "y": -45.719,
              "z": 0.374
            },
            "rightCorner": {
              "x": -18.169,
              "y": -45.719,
              "z": 0.374
            },
            "gtin": "4250780319373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fb2",
            "leftCorner": {
              "x": -18.169,
              "y": -45.756,
              "z": 0.374
            },
            "rightCorner": {
              "x": -18.312,
              "y": -45.755,
              "z": 0.374
            },
            "gtin": "4306188024880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fb3",
            "leftCorner": {
              "x": -18.312,
              "y": -45.762,
              "z": 0.374
            },
            "rightCorner": {
              "x": -18.586,
              "y": -45.762,
              "z": 0.374
            },
            "gtin": "4306188051299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fb4",
            "leftCorner": {
              "x": -18.586,
              "y": -45.759,
              "z": 0.374
            },
            "rightCorner": {
              "x": -18.911,
              "y": -45.759,
              "z": 0.374
            },
            "gtin": "4306188051329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fb5",
            "leftCorner": {
              "x": -18.911,
              "y": -45.762,
              "z": 0.374
            },
            "rightCorner": {
              "x": -18.977,
              "y": -45.763,
              "z": 0.374
            },
            "gtin": "7640143671120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fb6",
            "leftCorner": {
              "x": -18.977,
              "y": -45.752,
              "z": 0.374
            },
            "rightCorner": {
              "x": -19.036,
              "y": -45.752,
              "z": 0.374
            },
            "gtin": "7640143671168",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fb1",
            "leftCorner": {
              "x": -19.036,
              "y": -45.75,
              "z": 0.374
            },
            "rightCorner": {
              "x": -19.139,
              "y": -45.751,
              "z": 0.374
            },
            "gtin": "7640143671182",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d08d",
        "height": 0.69065,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5fc0",
            "leftCorner": {
              "x": -17.888,
              "y": -45.713,
              "z": 0.565
            },
            "rightCorner": {
              "x": -18.858,
              "y": -45.713,
              "z": 0.565
            },
            "gtin": "4250780319335",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d5fc2",
            "leftCorner": {
              "x": -18.859,
              "y": -45.753,
              "z": 0.565
            },
            "rightCorner": {
              "x": -19.065,
              "y": -45.754,
              "z": 0.565
            },
            "gtin": "4250780319434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fc1",
            "leftCorner": {
              "x": -19.065,
              "y": -45.745,
              "z": 0.565
            },
            "rightCorner": {
              "x": -19.139,
              "y": -45.745,
              "z": 0.565
            },
            "gtin": "4250780319946",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d08c",
        "height": 0.94719,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5fb7",
            "leftCorner": {
              "x": -17.888,
              "y": -45.717,
              "z": 0.775
            },
            "rightCorner": {
              "x": -17.991,
              "y": -45.717,
              "z": 0.775
            },
            "gtin": "4015533054181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fb8",
            "leftCorner": {
              "x": -17.991,
              "y": -45.717,
              "z": 0.775
            },
            "rightCorner": {
              "x": -18.093,
              "y": -45.717,
              "z": 0.775
            },
            "gtin": "4015533054181",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fba",
            "leftCorner": {
              "x": -18.094,
              "y": -45.745,
              "z": 0.775
            },
            "rightCorner": {
              "x": -18.275,
              "y": -45.745,
              "z": 0.775
            },
            "gtin": "4015533054129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fbb",
            "leftCorner": {
              "x": -18.275,
              "y": -45.757,
              "z": 0.775
            },
            "rightCorner": {
              "x": -18.408,
              "y": -45.757,
              "z": 0.775
            },
            "gtin": "4015533053528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fbc",
            "leftCorner": {
              "x": -18.408,
              "y": -45.76,
              "z": 0.775
            },
            "rightCorner": {
              "x": -18.566,
              "y": -45.761,
              "z": 0.775
            },
            "gtin": "4015533058684",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fbd",
            "leftCorner": {
              "x": -18.566,
              "y": -45.758,
              "z": 0.775
            },
            "rightCorner": {
              "x": -18.641,
              "y": -45.759,
              "z": 0.775
            },
            "gtin": "4015533056888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fbe",
            "leftCorner": {
              "x": -18.641,
              "y": -45.757,
              "z": 0.775
            },
            "rightCorner": {
              "x": -18.888,
              "y": -45.757,
              "z": 0.775
            },
            "gtin": "4015533051029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fbf",
            "leftCorner": {
              "x": -18.888,
              "y": -46.012,
              "z": 0.775
            },
            "rightCorner": {
              "x": -18.999,
              "y": -46.012,
              "z": 0.775
            },
            "gtin": "4260551830068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fb9",
            "leftCorner": {
              "x": -19.0,
              "y": -45.752,
              "z": 0.775
            },
            "rightCorner": {
              "x": -19.139,
              "y": -45.752,
              "z": 0.775
            },
            "gtin": "4260551830198",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d08a",
        "height": 1.2725,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d5fa4",
            "leftCorner": {
              "x": -17.888,
              "y": -45.708,
              "z": 1.041
            },
            "rightCorner": {
              "x": -18.102,
              "y": -45.708,
              "z": 1.041
            },
            "gtin": "4015533054167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fa7",
            "leftCorner": {
              "x": -18.103,
              "y": -45.739,
              "z": 1.041
            },
            "rightCorner": {
              "x": -18.19,
              "y": -45.739,
              "z": 1.041
            },
            "gtin": "4015533053863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fa8",
            "leftCorner": {
              "x": -18.19,
              "y": -45.739,
              "z": 1.041
            },
            "rightCorner": {
              "x": -18.277,
              "y": -45.739,
              "z": 1.041
            },
            "gtin": "4015533053863",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fa9",
            "leftCorner": {
              "x": -18.276,
              "y": -45.749,
              "z": 1.041
            },
            "rightCorner": {
              "x": -18.443,
              "y": -45.749,
              "z": 1.041
            },
            "gtin": "4015533053849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5faa",
            "leftCorner": {
              "x": -18.443,
              "y": -45.754,
              "z": 1.041
            },
            "rightCorner": {
              "x": -18.517,
              "y": -45.755,
              "z": 1.041
            },
            "gtin": "4015533053887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fab",
            "leftCorner": {
              "x": -18.517,
              "y": -45.755,
              "z": 1.041
            },
            "rightCorner": {
              "x": -18.591,
              "y": -45.755,
              "z": 1.041
            },
            "gtin": "4015533053887",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fac",
            "leftCorner": {
              "x": -18.592,
              "y": -45.747,
              "z": 1.041
            },
            "rightCorner": {
              "x": -18.67,
              "y": -45.747,
              "z": 1.041
            },
            "gtin": "4015533056062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fad",
            "leftCorner": {
              "x": -18.67,
              "y": -45.747,
              "z": 1.041
            },
            "rightCorner": {
              "x": -18.748,
              "y": -45.746,
              "z": 1.041
            },
            "gtin": "4015533056062",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fae",
            "leftCorner": {
              "x": -18.747,
              "y": -45.755,
              "z": 1.041
            },
            "rightCorner": {
              "x": -18.855,
              "y": -45.755,
              "z": 1.041
            },
            "gtin": "4015533053948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5faf",
            "leftCorner": {
              "x": -18.855,
              "y": -45.755,
              "z": 1.041
            },
            "rightCorner": {
              "x": -18.964,
              "y": -45.755,
              "z": 1.041
            },
            "gtin": "4015533053948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fa5",
            "leftCorner": {
              "x": -18.964,
              "y": -45.745,
              "z": 1.041
            },
            "rightCorner": {
              "x": -19.051,
              "y": -45.745,
              "z": 1.041
            },
            "gtin": "4015533054525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d5fa6",
            "leftCorner": {
              "x": -19.051,
              "y": -45.745,
              "z": 1.041
            },
            "rightCorner": {
              "x": -19.139,
              "y": -45.745,
              "z": 1.041
            },
            "gtin": "4015533054525",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "e77",
    "name": "e77",
    "x": -19.095,
    "y": -48.711,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061784,
      "w": 0.99998
    },
    "layers": []
  },
  {
    "id": "e78",
    "name": "e78",
    "x": -5.7968,
    "y": -44.17,
    "width": 1.25,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 1.0365E-4,
      "y": 0.0014282,
      "z": -0.534,
      "w": 0.84548
    },
    "layers": [],

    "rightNeighborShelfId": "e79"
  },
  {
    "id": "e79",
    "name": "e79",
    "x": -5.2597,
    "y": -45.299,
    "width": 1.25,
    "height": 1.6,
    "depth": 0.448,
    "rotation": {
      "x": 1.0365E-4,
      "y": 0.0014282,
      "z": -0.534,
      "w": 0.84548
    },
    "layers": [],
    "leftNeighborShelfId": "e78"
  },
  {
    "id": "e9e",
    "name": "e9e",
    "x": -21.718,
    "y": -2.781,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70583,
      "w": 0.70838
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 70,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d491",
        "height": 0.16035,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a36",
            "leftCorner": {
              "x": -21.797,
              "y": -2.838,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.796,
              "y": -2.961,
              "z": 0.131
            },
            "gtin": "4005249000596",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a37",
            "leftCorner": {
              "x": -21.798,
              "y": -2.961,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.797,
              "y": -3.062,
              "z": 0.131
            },
            "gtin": "4014086093333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a38",
            "leftCorner": {
              "x": -21.797,
              "y": -3.062,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.797,
              "y": -3.164,
              "z": 0.131
            },
            "gtin": "4014086093333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a39",
            "leftCorner": {
              "x": -21.797,
              "y": -3.164,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.796,
              "y": -3.266,
              "z": 0.131
            },
            "gtin": "4014086093333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a3a",
            "leftCorner": {
              "x": -21.787,
              "y": -3.266,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.788,
              "y": -3.358,
              "z": 0.131
            },
            "gtin": "4014086093319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a3b",
            "leftCorner": {
              "x": -21.788,
              "y": -3.358,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.787,
              "y": -3.451,
              "z": 0.131
            },
            "gtin": "4014086093319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a3c",
            "leftCorner": {
              "x": -21.787,
              "y": -3.451,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.787,
              "y": -3.543,
              "z": 0.131
            },
            "gtin": "4014086093319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a3d",
            "leftCorner": {
              "x": -21.785,
              "y": -3.543,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.784,
              "y": -3.663,
              "z": 0.131
            },
            "gtin": "4014086093364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a3e",
            "leftCorner": {
              "x": -21.784,
              "y": -3.663,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.784,
              "y": -3.782,
              "z": 0.131
            },
            "gtin": "4014086093364",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a09",
            "leftCorner": {
              "x": -21.786,
              "y": -3.782,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.787,
              "y": -3.813,
              "z": 0.131
            },
            "gtin": "4306188024521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a0a",
            "leftCorner": {
              "x": -21.787,
              "y": -3.813,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.787,
              "y": -3.844,
              "z": 0.131
            },
            "gtin": "4306188024521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a0b",
            "leftCorner": {
              "x": -21.787,
              "y": -3.844,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.787,
              "y": -3.876,
              "z": 0.131
            },
            "gtin": "4306188024521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a0c",
            "leftCorner": {
              "x": -21.787,
              "y": -3.876,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.786,
              "y": -3.907,
              "z": 0.131
            },
            "gtin": "4306188024521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a0d",
            "leftCorner": {
              "x": -21.786,
              "y": -3.907,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.786,
              "y": -3.938,
              "z": 0.131
            },
            "gtin": "4306188024521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a0e",
            "leftCorner": {
              "x": -21.786,
              "y": -3.938,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.786,
              "y": -3.969,
              "z": 0.131
            },
            "gtin": "4306188024521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a0f",
            "leftCorner": {
              "x": -21.786,
              "y": -3.969,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.786,
              "y": -4.0,
              "z": 0.131
            },
            "gtin": "4306188024521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a10",
            "leftCorner": {
              "x": -21.786,
              "y": -4.0,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.785,
              "y": -4.031,
              "z": 0.131
            },
            "gtin": "4306188024521",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d494",
        "height": 0.54394,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7adf",
            "leftCorner": {
              "x": -21.843,
              "y": -2.781,
              "z": 0.445
            },
            "rightCorner": {
              "x": -21.843,
              "y": -2.867,
              "z": 0.445
            },
            "gtin": "5740600510350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ae0",
            "leftCorner": {
              "x": -21.843,
              "y": -2.867,
              "z": 0.445
            },
            "rightCorner": {
              "x": -21.843,
              "y": -2.953,
              "z": 0.445
            },
            "gtin": "5740600510350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ae1",
            "leftCorner": {
              "x": -21.843,
              "y": -2.953,
              "z": 0.445
            },
            "rightCorner": {
              "x": -21.842,
              "y": -3.039,
              "z": 0.445
            },
            "gtin": "5740600510350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ae2",
            "leftCorner": {
              "x": -21.842,
              "y": -3.039,
              "z": 0.445
            },
            "rightCorner": {
              "x": -21.842,
              "y": -3.125,
              "z": 0.445
            },
            "gtin": "5740600510350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ae3",
            "leftCorner": {
              "x": -21.842,
              "y": -3.125,
              "z": 0.445
            },
            "rightCorner": {
              "x": -21.842,
              "y": -3.211,
              "z": 0.445
            },
            "gtin": "5740600510350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ae5",
            "leftCorner": {
              "x": -21.804,
              "y": -3.211,
              "z": 0.445
            },
            "rightCorner": {
              "x": -21.803,
              "y": -3.356,
              "z": 0.445
            },
            "gtin": "8716700016372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ae6",
            "leftCorner": {
              "x": -21.803,
              "y": -3.356,
              "z": 0.445
            },
            "rightCorner": {
              "x": -21.802,
              "y": -3.501,
              "z": 0.445
            },
            "gtin": "8716700016372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ae7",
            "leftCorner": {
              "x": -21.798,
              "y": -3.502,
              "z": 0.445
            },
            "rightCorner": {
              "x": -21.798,
              "y": -3.7,
              "z": 0.445
            },
            "gtin": "5741000122853",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ae8",
            "leftCorner": {
              "x": -21.799,
              "y": -3.7,
              "z": 0.445
            },
            "rightCorner": {
              "x": -21.798,
              "y": -3.83,
              "z": 0.445
            },
            "gtin": "5741000122549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ae9",
            "leftCorner": {
              "x": -21.798,
              "y": -3.83,
              "z": 0.445
            },
            "rightCorner": {
              "x": -21.798,
              "y": -3.961,
              "z": 0.445
            },
            "gtin": "5741000122549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ae4",
            "leftCorner": {
              "x": -21.803,
              "y": -3.961,
              "z": 0.445
            },
            "rightCorner": {
              "x": -21.802,
              "y": -4.031,
              "z": 0.445
            },
            "gtin": "5000213009420",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d492",
        "height": 0.8206,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7aca",
            "leftCorner": {
              "x": -21.81,
              "y": -3.013,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.81,
              "y": -3.076,
              "z": 0.671
            },
            "gtin": "4008287072938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7acb",
            "leftCorner": {
              "x": -21.81,
              "y": -3.076,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.809,
              "y": -3.139,
              "z": 0.671
            },
            "gtin": "4008287072938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7acc",
            "leftCorner": {
              "x": -21.809,
              "y": -3.139,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.809,
              "y": -3.202,
              "z": 0.671
            },
            "gtin": "4008287072938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7acd",
            "leftCorner": {
              "x": -21.809,
              "y": -3.202,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.809,
              "y": -3.265,
              "z": 0.671
            },
            "gtin": "4008287072938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ace",
            "leftCorner": {
              "x": -21.802,
              "y": -3.265,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.802,
              "y": -3.349,
              "z": 0.671
            },
            "gtin": "4008287050134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7acf",
            "leftCorner": {
              "x": -21.802,
              "y": -3.349,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.801,
              "y": -3.433,
              "z": 0.671
            },
            "gtin": "4008287050134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ad0",
            "leftCorner": {
              "x": -21.801,
              "y": -3.433,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.801,
              "y": -3.517,
              "z": 0.671
            },
            "gtin": "4008287050134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ad1",
            "leftCorner": {
              "x": -21.8,
              "y": -3.517,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.799,
              "y": -3.814,
              "z": 0.671
            },
            "gtin": "4008287922493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ab1",
            "leftCorner": {
              "x": -21.801,
              "y": -3.814,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.8,
              "y": -3.923,
              "z": 0.671
            },
            "gtin": "42178170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b7d23f6005613929c1fe7f73",
            "leftCorner": {
              "x": -21.844,
              "y": -2.781,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.844,
              "y": -2.87,
              "z": 0.671
            },
            "gtin": "4008287922493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0919bbae6da4f3fdeefefd2d",
            "leftCorner": {
              "x": -21.844,
              "y": -2.87,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.843,
              "y": -2.958,
              "z": 0.671
            },
            "gtin": "4008287922493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d26123c0de13435b82bf16ee",
            "leftCorner": {
              "x": -21.843,
              "y": -2.958,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.843,
              "y": -3.007,
              "z": 0.671
            },
            "gtin": "4008287922493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ab2",
            "leftCorner": {
              "x": -21.8,
              "y": -3.923,
              "z": 0.671
            },
            "rightCorner": {
              "x": -21.8,
              "y": -4.031,
              "z": 0.671
            },
            "gtin": "42178170",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d495",
        "height": 1.1114,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79d5",
            "leftCorner": {
              "x": -21.798,
              "y": -3.039,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.797,
              "y": -3.296,
              "z": 0.909
            },
            "gtin": "4053400257501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79d6",
            "leftCorner": {
              "x": -21.788,
              "y": -3.296,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.787,
              "y": -3.525,
              "z": 0.909
            },
            "gtin": "4053400205496",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79d7",
            "leftCorner": {
              "x": -21.784,
              "y": -3.525,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.784,
              "y": -3.66,
              "z": 0.909
            },
            "gtin": "4005249001142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79d8",
            "leftCorner": {
              "x": -21.784,
              "y": -3.66,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.783,
              "y": -3.795,
              "z": 0.909
            },
            "gtin": "4005249001142",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79a7",
            "leftCorner": {
              "x": -21.787,
              "y": -3.795,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.786,
              "y": -4.031,
              "z": 0.909
            },
            "gtin": "4000856003688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8b940ba63c36378bfc098738",
            "leftCorner": {
              "x": -21.83,
              "y": -2.781,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.829,
              "y": -3.021,
              "z": 0.909
            },
            "gtin": "4053400250106",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d490",
        "height": 1.4155,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a04",
            "leftCorner": {
              "x": -21.802,
              "y": -2.975,
              "z": 1.158
            },
            "rightCorner": {
              "x": -21.801,
              "y": -3.114,
              "z": 1.158
            },
            "gtin": "4005249001272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a05",
            "leftCorner": {
              "x": -21.801,
              "y": -3.114,
              "z": 1.158
            },
            "rightCorner": {
              "x": -21.8,
              "y": -3.254,
              "z": 1.158
            },
            "gtin": "4005249001272",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a06",
            "leftCorner": {
              "x": -21.794,
              "y": -3.254,
              "z": 1.158
            },
            "rightCorner": {
              "x": -21.793,
              "y": -3.548,
              "z": 1.158
            },
            "gtin": "4005249001296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a07",
            "leftCorner": {
              "x": -21.792,
              "y": -3.548,
              "z": 1.158
            },
            "rightCorner": {
              "x": -21.791,
              "y": -3.829,
              "z": 1.158
            },
            "gtin": "4025127014866",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79db",
            "leftCorner": {
              "x": -21.793,
              "y": -3.829,
              "z": 1.158
            },
            "rightCorner": {
              "x": -21.792,
              "y": -3.897,
              "z": 1.158
            },
            "gtin": "3119780251889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "571cb95360a1a95b47710a5d",
            "leftCorner": {
              "x": -21.837,
              "y": -2.781,
              "z": 1.158
            },
            "rightCorner": {
              "x": -21.837,
              "y": -2.903,
              "z": 1.158
            },
            "gtin": "4005249001296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6fb5e5d2495c7181921358c1",
            "leftCorner": {
              "x": -21.837,
              "y": -2.903,
              "z": 1.158
            },
            "rightCorner": {
              "x": -21.836,
              "y": -2.97,
              "z": 1.158
            },
            "gtin": "3119780251889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79dc",
            "leftCorner": {
              "x": -21.792,
              "y": -3.897,
              "z": 1.158
            },
            "rightCorner": {
              "x": -21.793,
              "y": -3.964,
              "z": 1.158
            },
            "gtin": "3119780251889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79dd",
            "leftCorner": {
              "x": -21.793,
              "y": -3.964,
              "z": 1.158
            },
            "rightCorner": {
              "x": -21.792,
              "y": -4.031,
              "z": 1.158
            },
            "gtin": "3119780251889",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d493",
        "height": 1.7362,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a6e",
            "leftCorner": {
              "x": -21.792,
              "y": -2.876,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.793,
              "y": -2.938,
              "z": 1.421
            },
            "gtin": "4014086093654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a6f",
            "leftCorner": {
              "x": -21.793,
              "y": -2.938,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.792,
              "y": -2.999,
              "z": 1.421
            },
            "gtin": "4014086093654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a70",
            "leftCorner": {
              "x": -21.791,
              "y": -2.999,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.792,
              "y": -3.095,
              "z": 1.421
            },
            "gtin": "5000281073309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a71",
            "leftCorner": {
              "x": -21.794,
              "y": -3.095,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.793,
              "y": -3.199,
              "z": 1.421
            },
            "gtin": "5099873017746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a72",
            "leftCorner": {
              "x": -21.788,
              "y": -3.199,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.788,
              "y": -3.301,
              "z": 1.421
            },
            "gtin": "4000269003350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a73",
            "leftCorner": {
              "x": -21.783,
              "y": -3.301,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.782,
              "y": -3.413,
              "z": 1.421
            },
            "gtin": "5000281073286",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a74",
            "leftCorner": {
              "x": -21.781,
              "y": -3.413,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.781,
              "y": -3.468,
              "z": 1.421
            },
            "gtin": "5410316958622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a75",
            "leftCorner": {
              "x": -21.781,
              "y": -3.468,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.78,
              "y": -3.524,
              "z": 1.421
            },
            "gtin": "5410316958622",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a76",
            "leftCorner": {
              "x": -21.779,
              "y": -3.524,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.778,
              "y": -3.639,
              "z": 1.421
            },
            "gtin": "4003310014800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a77",
            "leftCorner": {
              "x": -21.778,
              "y": -3.639,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.778,
              "y": -3.742,
              "z": 1.421
            },
            "gtin": "4003310020146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a78",
            "leftCorner": {
              "x": -21.785,
              "y": -3.742,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.784,
              "y": -3.865,
              "z": 1.421
            },
            "gtin": "4007675333309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a79",
            "leftCorner": {
              "x": -21.782,
              "y": -3.865,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.782,
              "y": -3.969,
              "z": 1.421
            },
            "gtin": "4007675323300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a48",
            "leftCorner": {
              "x": -21.777,
              "y": -3.969,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.776,
              "y": -4.031,
              "z": 1.421
            },
            "gtin": "4007675393303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "07c780946c4e92f7bd93b0b4",
            "leftCorner": {
              "x": -21.826,
              "y": -2.781,
              "z": 1.421
            },
            "rightCorner": {
              "x": -21.826,
              "y": -2.873,
              "z": 1.421
            },
            "gtin": "5000281073309",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "e9f"
  },
  {
    "id": "e9f",
    "name": "e9f",
    "x": -21.723,
    "y": -1.531,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70583,
      "w": 0.70838
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 70,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d48b",
        "height": 0.15945,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a2e",
            "leftCorner": {
              "x": -21.797,
              "y": -1.6,
              "z": 0.13
            },
            "rightCorner": {
              "x": -21.796,
              "y": -1.663,
              "z": 0.13
            },
            "gtin": "2000437924724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8d06a88916468a99a60f33d7",
            "leftCorner": {
              "x": -21.837,
              "y": -1.531,
              "z": 0.13
            },
            "rightCorner": {
              "x": -21.837,
              "y": -1.589,
              "z": 0.13
            },
            "gtin": "4001568702050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a2f",
            "leftCorner": {
              "x": -21.796,
              "y": -1.663,
              "z": 0.13
            },
            "rightCorner": {
              "x": -21.795,
              "y": -1.725,
              "z": 0.13
            },
            "gtin": "2000437924724",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a30",
            "leftCorner": {
              "x": -21.794,
              "y": -1.725,
              "z": 0.13
            },
            "rightCorner": {
              "x": -21.794,
              "y": -1.881,
              "z": 0.13
            },
            "gtin": "4001568703699",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7a31",
            "leftCorner": {
              "x": -21.796,
              "y": -1.881,
              "z": 0.13
            },
            "rightCorner": {
              "x": -21.795,
              "y": -2.158,
              "z": 0.13
            },
            "gtin": "4001568702050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a32",
            "leftCorner": {
              "x": -21.794,
              "y": -2.158,
              "z": 0.13
            },
            "rightCorner": {
              "x": -21.793,
              "y": -2.429,
              "z": 0.13
            },
            "gtin": "4008287959192",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a33",
            "leftCorner": {
              "x": -21.798,
              "y": -2.429,
              "z": 0.13
            },
            "rightCorner": {
              "x": -21.798,
              "y": -2.539,
              "z": 0.13
            },
            "gtin": "4008287032031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a34",
            "leftCorner": {
              "x": -21.798,
              "y": -2.539,
              "z": 0.13
            },
            "rightCorner": {
              "x": -21.796,
              "y": -2.648,
              "z": 0.13
            },
            "gtin": "4008287032031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a35",
            "leftCorner": {
              "x": -21.793,
              "y": -2.648,
              "z": 0.13
            },
            "rightCorner": {
              "x": -21.792,
              "y": -2.838,
              "z": 0.13
            },
            "gtin": "8712000025649",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d48f",
        "height": 0.53251,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ad2",
            "leftCorner": {
              "x": -21.84,
              "y": -1.531,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.84,
              "y": -1.614,
              "z": 0.436
            },
            "gtin": "4000856084014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ad3",
            "leftCorner": {
              "x": -21.84,
              "y": -1.614,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.839,
              "y": -1.696,
              "z": 0.436
            },
            "gtin": "4000856084014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ad4",
            "leftCorner": {
              "x": -21.839,
              "y": -1.696,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.839,
              "y": -1.778,
              "z": 0.436
            },
            "gtin": "4000856084014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ad5",
            "leftCorner": {
              "x": -21.839,
              "y": -1.778,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.838,
              "y": -1.861,
              "z": 0.436
            },
            "gtin": "4000856084014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ad8",
            "leftCorner": {
              "x": -21.801,
              "y": -1.861,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.8,
              "y": -2.099,
              "z": 0.436
            },
            "gtin": "42140818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ad9",
            "leftCorner": {
              "x": -21.794,
              "y": -2.099,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.795,
              "y": -2.164,
              "z": 0.436
            },
            "gtin": "42150206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ada",
            "leftCorner": {
              "x": -21.795,
              "y": -2.164,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.794,
              "y": -2.229,
              "z": 0.436
            },
            "gtin": "42150206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7adb",
            "leftCorner": {
              "x": -21.794,
              "y": -2.229,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.794,
              "y": -2.294,
              "z": 0.436
            },
            "gtin": "42150206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7adc",
            "leftCorner": {
              "x": -21.794,
              "y": -2.294,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.793,
              "y": -2.359,
              "z": 0.436
            },
            "gtin": "42150206",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7add",
            "leftCorner": {
              "x": -21.797,
              "y": -2.359,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.797,
              "y": -2.5,
              "z": 0.436
            },
            "gtin": "4066600301110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ade",
            "leftCorner": {
              "x": -21.797,
              "y": -2.5,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.796,
              "y": -2.642,
              "z": 0.436
            },
            "gtin": "4066600301110",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ad6",
            "leftCorner": {
              "x": -21.795,
              "y": -2.642,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.796,
              "y": -2.711,
              "z": 0.436
            },
            "gtin": "4066600201922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ad7",
            "leftCorner": {
              "x": -21.796,
              "y": -2.711,
              "z": 0.436
            },
            "rightCorner": {
              "x": -21.795,
              "y": -2.781,
              "z": 0.436
            },
            "gtin": "4066600201922",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d48a",
        "height": 0.81772,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7ab9",
            "leftCorner": {
              "x": -21.806,
              "y": -1.57,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.806,
              "y": -1.643,
              "z": 0.669
            },
            "gtin": "9028800638590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f056659b53f79b8bc0bf470d",
            "leftCorner": {
              "x": -21.848,
              "y": -1.531,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.848,
              "y": -1.563,
              "z": 0.669
            },
            "gtin": "9028800638590",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aba",
            "leftCorner": {
              "x": -21.808,
              "y": -1.643,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.808,
              "y": -1.743,
              "z": 0.669
            },
            "gtin": "9028800638644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7abb",
            "leftCorner": {
              "x": -21.808,
              "y": -1.743,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.807,
              "y": -1.843,
              "z": 0.669
            },
            "gtin": "9028800638644",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7abc",
            "leftCorner": {
              "x": -21.803,
              "y": -1.844,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.803,
              "y": -1.913,
              "z": 0.669
            },
            "gtin": "4014086093227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7abd",
            "leftCorner": {
              "x": -21.803,
              "y": -1.913,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.802,
              "y": -1.982,
              "z": 0.669
            },
            "gtin": "4014086093227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7abe",
            "leftCorner": {
              "x": -21.802,
              "y": -1.982,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.803,
              "y": -2.052,
              "z": 0.669
            },
            "gtin": "4014086093227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7abf",
            "leftCorner": {
              "x": -21.803,
              "y": -2.052,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.802,
              "y": -2.121,
              "z": 0.669
            },
            "gtin": "4014086093227",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ac0",
            "leftCorner": {
              "x": -21.806,
              "y": -2.121,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.806,
              "y": -2.247,
              "z": 0.669
            },
            "gtin": "4008287052930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ac1",
            "leftCorner": {
              "x": -21.806,
              "y": -2.247,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.805,
              "y": -2.374,
              "z": 0.669
            },
            "gtin": "4008287052930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ac2",
            "leftCorner": {
              "x": -21.804,
              "y": -2.374,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.804,
              "y": -2.483,
              "z": 0.669
            },
            "gtin": "4008287962079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ac3",
            "leftCorner": {
              "x": -21.804,
              "y": -2.483,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.803,
              "y": -2.593,
              "z": 0.669
            },
            "gtin": "4008287962079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ac4",
            "leftCorner": {
              "x": -21.803,
              "y": -2.593,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.803,
              "y": -2.702,
              "z": 0.669
            },
            "gtin": "4008287962079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ac5",
            "leftCorner": {
              "x": -21.802,
              "y": -2.702,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.802,
              "y": -2.764,
              "z": 0.669
            },
            "gtin": "4008287948400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ac6",
            "leftCorner": {
              "x": -21.802,
              "y": -2.764,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.802,
              "y": -2.827,
              "z": 0.669
            },
            "gtin": "4008287948400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ac7",
            "leftCorner": {
              "x": -21.802,
              "y": -2.827,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.801,
              "y": -2.889,
              "z": 0.669
            },
            "gtin": "4008287948400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ac8",
            "leftCorner": {
              "x": -21.801,
              "y": -2.889,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.802,
              "y": -2.951,
              "z": 0.669
            },
            "gtin": "4008287948400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ac9",
            "leftCorner": {
              "x": -21.802,
              "y": -2.951,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.801,
              "y": -3.013,
              "z": 0.669
            },
            "gtin": "4008287948400",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d48d",
        "height": 1.1097,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79c8",
            "leftCorner": {
              "x": -21.794,
              "y": -1.6,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.793,
              "y": -1.706,
              "z": 0.908
            },
            "gtin": "42278184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c01b5e8b35ea7c4ed22c5aa0",
            "leftCorner": {
              "x": -21.835,
              "y": -1.531,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.835,
              "y": -1.6,
              "z": 0.908
            },
            "gtin": "4008287910926",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79c9",
            "leftCorner": {
              "x": -21.793,
              "y": -1.706,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.793,
              "y": -1.813,
              "z": 0.908
            },
            "gtin": "42278184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79ca",
            "leftCorner": {
              "x": -21.792,
              "y": -1.813,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.792,
              "y": -1.865,
              "z": 0.908
            },
            "gtin": "42440871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79cb",
            "leftCorner": {
              "x": -21.792,
              "y": -1.865,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.792,
              "y": -1.917,
              "z": 0.908
            },
            "gtin": "42440871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79cc",
            "leftCorner": {
              "x": -21.792,
              "y": -1.917,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.791,
              "y": -1.969,
              "z": 0.908
            },
            "gtin": "42440871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79cd",
            "leftCorner": {
              "x": -21.791,
              "y": -1.969,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.791,
              "y": -2.022,
              "z": 0.908
            },
            "gtin": "42440871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79ce",
            "leftCorner": {
              "x": -21.791,
              "y": -2.022,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.791,
              "y": -2.074,
              "z": 0.908
            },
            "gtin": "42440871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79cf",
            "leftCorner": {
              "x": -21.793,
              "y": -2.074,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.792,
              "y": -2.409,
              "z": 0.908
            },
            "gtin": "4005249063546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79d0",
            "leftCorner": {
              "x": -21.795,
              "y": -2.409,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.794,
              "y": -2.486,
              "z": 0.908
            },
            "gtin": "87120462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79d1",
            "leftCorner": {
              "x": -21.794,
              "y": -2.486,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.794,
              "y": -2.563,
              "z": 0.908
            },
            "gtin": "87120462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79d2",
            "leftCorner": {
              "x": -21.794,
              "y": -2.563,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.794,
              "y": -2.639,
              "z": 0.908
            },
            "gtin": "87120462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79d3",
            "leftCorner": {
              "x": -21.794,
              "y": -2.639,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.794,
              "y": -2.716,
              "z": 0.908
            },
            "gtin": "87120462",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79d4",
            "leftCorner": {
              "x": -21.792,
              "y": -2.716,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.791,
              "y": -3.039,
              "z": 0.908
            },
            "gtin": "4008287910926",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d48e",
        "height": 1.4134,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79fd",
            "leftCorner": {
              "x": -21.804,
              "y": -1.568,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.803,
              "y": -1.684,
              "z": 1.156
            },
            "gtin": "5099873026083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79fe",
            "leftCorner": {
              "x": -21.803,
              "y": -1.684,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.803,
              "y": -1.8,
              "z": 1.156
            },
            "gtin": "5099873026083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79ff",
            "leftCorner": {
              "x": -21.796,
              "y": -1.8,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.795,
              "y": -1.99,
              "z": 1.156
            },
            "gtin": "5099873015148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a00",
            "leftCorner": {
              "x": -21.798,
              "y": -1.99,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.798,
              "y": -2.146,
              "z": 1.156
            },
            "gtin": "5099873010280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a01",
            "leftCorner": {
              "x": -21.795,
              "y": -2.146,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.794,
              "y": -2.425,
              "z": 1.156
            },
            "gtin": "4006714103972",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7a02",
            "leftCorner": {
              "x": -21.797,
              "y": -2.425,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.796,
              "y": -2.681,
              "z": 1.156
            },
            "gtin": "42140849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a03",
            "leftCorner": {
              "x": -21.795,
              "y": -2.681,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.794,
              "y": -2.975,
              "z": 1.156
            },
            "gtin": "4002631028114",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d48c",
        "height": 1.734,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a64",
            "leftCorner": {
              "x": -21.791,
              "y": -1.582,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.791,
              "y": -1.784,
              "z": 1.419
            },
            "gtin": "4005971394307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "656a0c0033774466a2d82335",
            "leftCorner": {
              "x": -21.831,
              "y": -1.531,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.831,
              "y": -1.564,
              "z": 1.419
            },
            "gtin": "4014086093647",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a65",
            "leftCorner": {
              "x": -21.79,
              "y": -1.784,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.789,
              "y": -1.977,
              "z": 1.419
            },
            "gtin": "5060045580986",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a66",
            "leftCorner": {
              "x": -21.787,
              "y": -1.977,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.787,
              "y": -2.126,
              "z": 1.419
            },
            "gtin": "5060045587213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a67",
            "leftCorner": {
              "x": -21.788,
              "y": -2.126,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.788,
              "y": -2.21,
              "z": 1.419
            },
            "gtin": "5000289936583",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a68",
            "leftCorner": {
              "x": -21.789,
              "y": -2.21,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.789,
              "y": -2.298,
              "z": 1.419
            },
            "gtin": "5000289936576",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a69",
            "leftCorner": {
              "x": -21.789,
              "y": -2.298,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.788,
              "y": -2.387,
              "z": 1.419
            },
            "gtin": "7640175742485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a6a",
            "leftCorner": {
              "x": -21.789,
              "y": -2.387,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.789,
              "y": -2.498,
              "z": 1.419
            },
            "gtin": "40535678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a6b",
            "leftCorner": {
              "x": -21.79,
              "y": -2.498,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.79,
              "y": -2.579,
              "z": 1.419
            },
            "gtin": "5010278104619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a6c",
            "leftCorner": {
              "x": -21.79,
              "y": -2.579,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.79,
              "y": -2.708,
              "z": 1.419
            },
            "gtin": "5010278104633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a6d",
            "leftCorner": {
              "x": -21.783,
              "y": -2.708,
              "z": 1.419
            },
            "rightCorner": {
              "x": -21.783,
              "y": -2.876,
              "z": 1.419
            },
            "gtin": "4014086093647",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ea0",
    "rightNeighborShelfId": "e9e"
  },
  {
    "id": "ea0",
    "name": "ea0",
    "x": -21.727,
    "y": -0.281,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70583,
      "w": 0.70838
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 44,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d488",
        "height": 0.15978,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a28",
            "leftCorner": {
              "x": -21.798,
              "y": -0.335,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.796,
              "y": -0.723,
              "z": 0.131
            },
            "gtin": "4005695062162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a29",
            "leftCorner": {
              "x": -21.795,
              "y": -0.723,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.794,
              "y": -0.896,
              "z": 0.131
            },
            "gtin": "4072700006480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a2a",
            "leftCorner": {
              "x": -21.792,
              "y": -0.896,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.792,
              "y": -1.032,
              "z": 0.131
            },
            "gtin": "4102430012410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a2b",
            "leftCorner": {
              "x": -21.792,
              "y": -1.032,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.792,
              "y": -1.167,
              "z": 0.131
            },
            "gtin": "4102430012410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a2c",
            "leftCorner": {
              "x": -21.795,
              "y": -1.167,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.794,
              "y": -1.384,
              "z": 0.131
            },
            "gtin": "4102430072766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a2d",
            "leftCorner": {
              "x": -21.794,
              "y": -1.384,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.793,
              "y": -1.6,
              "z": 0.131
            },
            "gtin": "4102430072766",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d487",
        "height": 0.49184,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7aa2",
            "leftCorner": {
              "x": -21.85,
              "y": -0.281,
              "z": 0.402
            },
            "rightCorner": {
              "x": -21.85,
              "y": -0.343,
              "z": 0.402
            },
            "gtin": "4008948130007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aa3",
            "leftCorner": {
              "x": -21.85,
              "y": -0.343,
              "z": 0.402
            },
            "rightCorner": {
              "x": -21.849,
              "y": -0.405,
              "z": 0.402
            },
            "gtin": "4008948130007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aa4",
            "leftCorner": {
              "x": -21.849,
              "y": -0.405,
              "z": 0.402
            },
            "rightCorner": {
              "x": -21.849,
              "y": -0.467,
              "z": 0.402
            },
            "gtin": "4008948130007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aa5",
            "leftCorner": {
              "x": -21.849,
              "y": -0.467,
              "z": 0.402
            },
            "rightCorner": {
              "x": -21.849,
              "y": -0.529,
              "z": 0.402
            },
            "gtin": "4008948130007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aa6",
            "leftCorner": {
              "x": -21.849,
              "y": -0.529,
              "z": 0.402
            },
            "rightCorner": {
              "x": -21.849,
              "y": -0.59,
              "z": 0.402
            },
            "gtin": "4008948130007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aa7",
            "leftCorner": {
              "x": -21.849,
              "y": -0.59,
              "z": 0.402
            },
            "rightCorner": {
              "x": -21.848,
              "y": -0.652,
              "z": 0.402
            },
            "gtin": "4008948130007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aa8",
            "leftCorner": {
              "x": -21.848,
              "y": -0.652,
              "z": 0.402
            },
            "rightCorner": {
              "x": -21.848,
              "y": -0.714,
              "z": 0.402
            },
            "gtin": "4008948130007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aaa",
            "leftCorner": {
              "x": -21.809,
              "y": -0.714,
              "z": 0.402
            },
            "rightCorner": {
              "x": -21.809,
              "y": -0.934,
              "z": 0.402
            },
            "gtin": "4103080050425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aab",
            "leftCorner": {
              "x": -21.806,
              "y": -0.934,
              "z": 0.402
            },
            "rightCorner": {
              "x": -21.805,
              "y": -1.183,
              "z": 0.402
            },
            "gtin": "4103080062039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aa9",
            "leftCorner": {
              "x": -21.807,
              "y": -1.183,
              "z": 0.402
            },
            "rightCorner": {
              "x": -21.805,
              "y": -1.531,
              "z": 0.402
            },
            "gtin": "4103080050463",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d489",
        "height": 0.81815,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7aac",
            "leftCorner": {
              "x": -21.851,
              "y": -0.281,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.85,
              "y": -0.444,
              "z": 0.669
            },
            "gtin": "4008287055160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aad",
            "leftCorner": {
              "x": -21.85,
              "y": -0.444,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.85,
              "y": -0.607,
              "z": 0.669
            },
            "gtin": "4008287055160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aae",
            "leftCorner": {
              "x": -21.85,
              "y": -0.607,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.849,
              "y": -0.769,
              "z": 0.669
            },
            "gtin": "4008287055160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aaf",
            "leftCorner": {
              "x": -21.849,
              "y": -0.769,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.849,
              "y": -0.932,
              "z": 0.669
            },
            "gtin": "4008287055160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ab0",
            "leftCorner": {
              "x": -21.849,
              "y": -0.932,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.848,
              "y": -1.094,
              "z": 0.669
            },
            "gtin": "4008287055160",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ab3",
            "leftCorner": {
              "x": -21.81,
              "y": -1.094,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.809,
              "y": -1.145,
              "z": 0.669
            },
            "gtin": "4008287957723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ab4",
            "leftCorner": {
              "x": -21.809,
              "y": -1.145,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.809,
              "y": -1.196,
              "z": 0.669
            },
            "gtin": "4008287957723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ab5",
            "leftCorner": {
              "x": -21.809,
              "y": -1.196,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.809,
              "y": -1.248,
              "z": 0.669
            },
            "gtin": "4008287957723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ab6",
            "leftCorner": {
              "x": -21.809,
              "y": -1.248,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.809,
              "y": -1.299,
              "z": 0.669
            },
            "gtin": "4008287957723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ab7",
            "leftCorner": {
              "x": -21.809,
              "y": -1.299,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.809,
              "y": -1.35,
              "z": 0.669
            },
            "gtin": "4008287957723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7ab8",
            "leftCorner": {
              "x": -21.806,
              "y": -1.35,
              "z": 0.669
            },
            "rightCorner": {
              "x": -21.805,
              "y": -1.57,
              "z": 0.669
            },
            "gtin": "4008287924244",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d486",
        "height": 1.1088,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79c3",
            "leftCorner": {
              "x": -21.808,
              "y": -0.327,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.806,
              "y": -0.689,
              "z": 0.907
            },
            "gtin": "4100130012990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79c4",
            "leftCorner": {
              "x": -21.796,
              "y": -0.689,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.796,
              "y": -0.875,
              "z": 0.907
            },
            "gtin": "4100130900563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79c5",
            "leftCorner": {
              "x": -21.796,
              "y": -0.875,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.795,
              "y": -1.061,
              "z": 0.907
            },
            "gtin": "4100130900563",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79c6",
            "leftCorner": {
              "x": -21.797,
              "y": -1.061,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.796,
              "y": -1.331,
              "z": 0.907
            },
            "gtin": "4100130900167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79c7",
            "leftCorner": {
              "x": -21.796,
              "y": -1.331,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.795,
              "y": -1.6,
              "z": 0.907
            },
            "gtin": "4100130900167",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d484",
        "height": 1.4121,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79f9",
            "leftCorner": {
              "x": -21.805,
              "y": -0.346,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.803,
              "y": -0.703,
              "z": 1.155
            },
            "gtin": "4005249000343",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79fa",
            "leftCorner": {
              "x": -21.796,
              "y": -0.703,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.795,
              "y": -1.031,
              "z": 1.155
            },
            "gtin": "4005249061733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79fb",
            "leftCorner": {
              "x": -21.795,
              "y": -1.031,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.794,
              "y": -1.359,
              "z": 1.155
            },
            "gtin": "4005249061733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79fc",
            "leftCorner": {
              "x": -21.796,
              "y": -1.359,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.795,
              "y": -1.568,
              "z": 1.155
            },
            "gtin": "5099873026076",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d485",
        "height": 1.7336,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a5d",
            "leftCorner": {
              "x": -21.8,
              "y": -0.356,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.8,
              "y": -0.575,
              "z": 1.418
            },
            "gtin": "4067800007277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b061ae2a7a4c7d78b4b8856a",
            "leftCorner": {
              "x": -21.833,
              "y": -0.281,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.833,
              "y": -0.355,
              "z": 1.418
            },
            "gtin": "7610113014752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a5e",
            "leftCorner": {
              "x": -21.795,
              "y": -0.575,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.794,
              "y": -0.757,
              "z": 1.418
            },
            "gtin": "4100130913310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a5f",
            "leftCorner": {
              "x": -21.792,
              "y": -0.757,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.791,
              "y": -1.091,
              "z": 1.418
            },
            "gtin": "4052197005210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a60",
            "leftCorner": {
              "x": -21.79,
              "y": -1.091,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.79,
              "y": -1.191,
              "z": 1.418
            },
            "gtin": "7610113018170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a61",
            "leftCorner": {
              "x": -21.79,
              "y": -1.191,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.789,
              "y": -1.291,
              "z": 1.418
            },
            "gtin": "7610113018170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a62",
            "leftCorner": {
              "x": -21.789,
              "y": -1.291,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.788,
              "y": -1.391,
              "z": 1.418
            },
            "gtin": "7610113014752",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a63",
            "leftCorner": {
              "x": -21.787,
              "y": -1.391,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.787,
              "y": -1.582,
              "z": 1.418
            },
            "gtin": "5000112682861",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ea1",
    "rightNeighborShelfId": "e9f"
  },
  {
    "id": "ea1",
    "name": "ea1",
    "x": -21.732,
    "y": 0.969,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70583,
      "w": 0.70838
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 3,
      "unknownStockCount": 42
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6b9",
        "height": 0.16716,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a23",
            "leftCorner": {
              "x": -21.813,
              "y": 0.969,
              "z": 0.137
            },
            "rightCorner": {
              "x": -21.813,
              "y": 0.876,
              "z": 0.137
            },
            "gtin": "4100770003105",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "d7ac07500de1c4148ed86225",
            "leftCorner": {
              "x": -21.85,
              "y": 0.388,
              "z": 0.137
            },
            "rightCorner": {
              "x": -21.849,
              "y": 0.189,
              "z": 0.137
            },
            "gtin": "4014807210698",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7a24",
            "leftCorner": {
              "x": -21.811,
              "y": 0.876,
              "z": 0.137
            },
            "rightCorner": {
              "x": -21.809,
              "y": 0.389,
              "z": 0.137
            },
            "gtin": "4100770003105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a26",
            "leftCorner": {
              "x": -21.811,
              "y": 0.089,
              "z": 0.137
            },
            "rightCorner": {
              "x": -21.81,
              "y": -0.109,
              "z": 0.137
            },
            "gtin": "4014807210698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a27",
            "leftCorner": {
              "x": -21.809,
              "y": -0.109,
              "z": 0.137
            },
            "rightCorner": {
              "x": -21.808,
              "y": -0.335,
              "z": 0.137
            },
            "gtin": "4014807602943",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6b4",
        "height": 0.47925,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86d9",
            "leftCorner": {
              "x": -21.85,
              "y": 0.969,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.849,
              "y": 0.742,
              "z": 0.392
            },
            "gtin": "8594403417128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86db",
            "leftCorner": {
              "x": -21.815,
              "y": 0.742,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.813,
              "y": 0.499,
              "z": 0.392
            },
            "gtin": "4008287910551",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86dc",
            "leftCorner": {
              "x": -21.804,
              "y": 0.499,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.804,
              "y": 0.348,
              "z": 0.392
            },
            "gtin": "5901359164441",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86dd",
            "leftCorner": {
              "x": -21.808,
              "y": 0.348,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.807,
              "y": 0.135,
              "z": 0.392
            },
            "gtin": "8410655006388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86de",
            "leftCorner": {
              "x": -21.812,
              "y": 0.135,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.811,
              "y": -0.019,
              "z": 0.392
            },
            "gtin": "5740600514204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86da",
            "leftCorner": {
              "x": -21.805,
              "y": -0.019,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.804,
              "y": -0.281,
              "z": 0.392
            },
            "gtin": "4100770018994",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6b8",
        "height": 0.80596,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86df",
            "leftCorner": {
              "x": -21.851,
              "y": 0.968,
              "z": 0.659
            },
            "rightCorner": {
              "x": -21.851,
              "y": 0.756,
              "z": 0.659
            },
            "gtin": "4008287910698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86e0",
            "leftCorner": {
              "x": -21.851,
              "y": 0.756,
              "z": 0.659
            },
            "rightCorner": {
              "x": -21.849,
              "y": 0.542,
              "z": 0.659
            },
            "gtin": "4008287910698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86e2",
            "leftCorner": {
              "x": -21.81,
              "y": 0.543,
              "z": 0.659
            },
            "rightCorner": {
              "x": -21.81,
              "y": 0.36,
              "z": 0.659
            },
            "gtin": "4005249063744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86e3",
            "leftCorner": {
              "x": -21.809,
              "y": 0.36,
              "z": 0.659
            },
            "rightCorner": {
              "x": -21.808,
              "y": 0.241,
              "z": 0.659
            },
            "gtin": "8712000029296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86e4",
            "leftCorner": {
              "x": -21.808,
              "y": 0.241,
              "z": 0.659
            },
            "rightCorner": {
              "x": -21.808,
              "y": 0.123,
              "z": 0.659
            },
            "gtin": "8712000029296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86e5",
            "leftCorner": {
              "x": -21.808,
              "y": 0.123,
              "z": 0.659
            },
            "rightCorner": {
              "x": -21.808,
              "y": 0.004,
              "z": 0.659
            },
            "gtin": "8712000029296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86e1",
            "leftCorner": {
              "x": -21.807,
              "y": 0.004,
              "z": 0.659
            },
            "rightCorner": {
              "x": -21.805,
              "y": -0.281,
              "z": 0.659
            },
            "gtin": "8712000050122",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6b7",
        "height": 1.1085,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79b9",
            "leftCorner": {
              "x": -21.807,
              "y": 0.908,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.808,
              "y": 0.74,
              "z": 0.907
            },
            "gtin": "4053400011424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79ba",
            "leftCorner": {
              "x": -21.808,
              "y": 0.74,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.807,
              "y": 0.573,
              "z": 0.907
            },
            "gtin": "4053400011424",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79bb",
            "leftCorner": {
              "x": -21.807,
              "y": 0.573,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.806,
              "y": 0.397,
              "z": 0.907
            },
            "gtin": "4003304168601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79bc",
            "leftCorner": {
              "x": -21.806,
              "y": 0.397,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.806,
              "y": 0.306,
              "z": 0.907
            },
            "gtin": "4014964111616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79bd",
            "leftCorner": {
              "x": -21.806,
              "y": 0.306,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.806,
              "y": 0.215,
              "z": 0.907
            },
            "gtin": "4014964111616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79be",
            "leftCorner": {
              "x": -21.806,
              "y": 0.215,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.805,
              "y": 0.124,
              "z": 0.907
            },
            "gtin": "4014964111616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79bf",
            "leftCorner": {
              "x": -21.805,
              "y": 0.124,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.805,
              "y": 0.033,
              "z": 0.907
            },
            "gtin": "4014964111616",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79c0",
            "leftCorner": {
              "x": -21.804,
              "y": 0.033,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.804,
              "y": -0.087,
              "z": 0.907
            },
            "gtin": "4260332480116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79c1",
            "leftCorner": {
              "x": -21.804,
              "y": -0.087,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.804,
              "y": -0.207,
              "z": 0.907
            },
            "gtin": "4260332480116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79c2",
            "leftCorner": {
              "x": -21.804,
              "y": -0.207,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.803,
              "y": -0.327,
              "z": 0.907
            },
            "gtin": "4260332480116",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6b5",
        "height": 1.4113,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79ef",
            "leftCorner": {
              "x": -21.813,
              "y": 0.969,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.813,
              "y": 0.905,
              "z": 1.155
            },
            "gtin": "4002631016722",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d79f0",
            "leftCorner": {
              "x": -21.814,
              "y": 0.905,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.814,
              "y": 0.76,
              "z": 1.155
            },
            "gtin": "4002631016722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79f1",
            "leftCorner": {
              "x": -21.817,
              "y": 0.76,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.816,
              "y": 0.478,
              "z": 1.155
            },
            "gtin": "4002631015626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79f2",
            "leftCorner": {
              "x": -21.807,
              "y": 0.478,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.806,
              "y": 0.374,
              "z": 1.155
            },
            "gtin": "4001479285529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79f3",
            "leftCorner": {
              "x": -21.81,
              "y": 0.374,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.81,
              "y": 0.193,
              "z": 1.155
            },
            "gtin": "4260332480147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79f4",
            "leftCorner": {
              "x": -21.815,
              "y": 0.193,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.814,
              "y": 0.02,
              "z": 1.155
            },
            "gtin": "4260332480079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79f5",
            "leftCorner": {
              "x": -21.808,
              "y": 0.02,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.808,
              "y": -0.072,
              "z": 1.155
            },
            "gtin": "4000856105436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79f6",
            "leftCorner": {
              "x": -21.808,
              "y": -0.072,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.807,
              "y": -0.163,
              "z": 1.155
            },
            "gtin": "4000856105436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79f7",
            "leftCorner": {
              "x": -21.807,
              "y": -0.163,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.807,
              "y": -0.255,
              "z": 1.155
            },
            "gtin": "4000856105436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79f8",
            "leftCorner": {
              "x": -21.807,
              "y": -0.255,
              "z": 1.155
            },
            "rightCorner": {
              "x": -21.807,
              "y": -0.347,
              "z": 1.155
            },
            "gtin": "4000856105436",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6b6",
        "height": 1.7327,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a56",
            "leftCorner": {
              "x": -21.811,
              "y": 0.969,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.812,
              "y": 0.899,
              "z": 1.418
            },
            "gtin": "4260197093001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a57",
            "leftCorner": {
              "x": -21.806,
              "y": 0.899,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.805,
              "y": 0.722,
              "z": 1.418
            },
            "gtin": "4260197093001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a58",
            "leftCorner": {
              "x": -21.809,
              "y": 0.722,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.808,
              "y": 0.51,
              "z": 1.418
            },
            "gtin": "8712000061104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a59",
            "leftCorner": {
              "x": -21.8,
              "y": 0.51,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.799,
              "y": 0.293,
              "z": 1.418
            },
            "gtin": "8712000055790",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a5a",
            "leftCorner": {
              "x": -21.8,
              "y": 0.293,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.8,
              "y": 0.072,
              "z": 1.418
            },
            "gtin": "4101010013212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a5b",
            "leftCorner": {
              "x": -21.803,
              "y": 0.072,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.802,
              "y": -0.111,
              "z": 1.418
            },
            "gtin": "4101010012635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a5c",
            "leftCorner": {
              "x": -21.798,
              "y": -0.111,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.797,
              "y": -0.356,
              "z": 1.418
            },
            "gtin": "4067800007260",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ea2",
    "rightNeighborShelfId": "ea0"
  },
  {
    "id": "ea2",
    "name": "ea2",
    "x": -21.736,
    "y": 2.219,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70583,
      "w": 0.70838
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d480",
        "height": 0.16135,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a1f",
            "leftCorner": {
              "x": -21.807,
              "y": 2.143,
              "z": 0.132
            },
            "rightCorner": {
              "x": -21.806,
              "y": 1.842,
              "z": 0.132
            },
            "gtin": "4100130019692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a20",
            "leftCorner": {
              "x": -21.811,
              "y": 1.842,
              "z": 0.132
            },
            "rightCorner": {
              "x": -21.81,
              "y": 1.486,
              "z": 0.132
            },
            "gtin": "4100130900273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a21",
            "leftCorner": {
              "x": -21.808,
              "y": 1.486,
              "z": 0.132
            },
            "rightCorner": {
              "x": -21.807,
              "y": 1.129,
              "z": 0.132
            },
            "gtin": "4100130009822",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a22",
            "leftCorner": {
              "x": -21.809,
              "y": 1.129,
              "z": 0.132
            },
            "rightCorner": {
              "x": -21.808,
              "y": 0.969,
              "z": 0.132
            },
            "gtin": "4079600222163",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d47e",
        "height": 0.48956,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a9b",
            "leftCorner": {
              "x": -21.821,
              "y": 2.151,
              "z": 0.401
            },
            "rightCorner": {
              "x": -21.82,
              "y": 1.942,
              "z": 0.401
            },
            "gtin": "4103080050449",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a9c",
            "leftCorner": {
              "x": -21.821,
              "y": 1.942,
              "z": 0.401
            },
            "rightCorner": {
              "x": -21.821,
              "y": 1.838,
              "z": 0.401
            },
            "gtin": "4100130900266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a9d",
            "leftCorner": {
              "x": -21.821,
              "y": 1.838,
              "z": 0.401
            },
            "rightCorner": {
              "x": -21.821,
              "y": 1.734,
              "z": 0.401
            },
            "gtin": "4100130900266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a9e",
            "leftCorner": {
              "x": -21.821,
              "y": 1.734,
              "z": 0.401
            },
            "rightCorner": {
              "x": -21.82,
              "y": 1.63,
              "z": 0.401
            },
            "gtin": "4100130900266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a9f",
            "leftCorner": {
              "x": -21.826,
              "y": 1.63,
              "z": 0.401
            },
            "rightCorner": {
              "x": -21.826,
              "y": 1.465,
              "z": 0.401
            },
            "gtin": "4100130900389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aa0",
            "leftCorner": {
              "x": -21.826,
              "y": 1.465,
              "z": 0.401
            },
            "rightCorner": {
              "x": -21.826,
              "y": 1.301,
              "z": 0.401
            },
            "gtin": "4100130900389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7aa1",
            "leftCorner": {
              "x": -21.826,
              "y": 1.301,
              "z": 0.401
            },
            "rightCorner": {
              "x": -21.825,
              "y": 1.136,
              "z": 0.401
            },
            "gtin": "4100130900389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a92",
            "leftCorner": {
              "x": -21.827,
              "y": 1.136,
              "z": 0.401
            },
            "rightCorner": {
              "x": -21.826,
              "y": 0.969,
              "z": 0.401
            },
            "gtin": "4005249003382",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d481",
        "height": 0.817,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a88",
            "leftCorner": {
              "x": -21.82,
              "y": 2.15,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.82,
              "y": 2.043,
              "z": 0.668
            },
            "gtin": "4008287052664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a89",
            "leftCorner": {
              "x": -21.82,
              "y": 2.043,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.82,
              "y": 1.937,
              "z": 0.668
            },
            "gtin": "4008287052664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a8a",
            "leftCorner": {
              "x": -21.82,
              "y": 1.937,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.819,
              "y": 1.83,
              "z": 0.668
            },
            "gtin": "4008287052664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a8b",
            "leftCorner": {
              "x": -21.819,
              "y": 1.83,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.819,
              "y": 1.724,
              "z": 0.668
            },
            "gtin": "4008287052664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a8c",
            "leftCorner": {
              "x": -21.819,
              "y": 1.724,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.818,
              "y": 1.617,
              "z": 0.668
            },
            "gtin": "4008287052664",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a8d",
            "leftCorner": {
              "x": -21.515,
              "y": 1.618,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.515,
              "y": 1.535,
              "z": 0.668
            },
            "gtin": "4008287956306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a8e",
            "leftCorner": {
              "x": -21.825,
              "y": 1.534,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.824,
              "y": 1.467,
              "z": 0.668
            },
            "gtin": "4008287956306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a8f",
            "leftCorner": {
              "x": -21.824,
              "y": 1.467,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.824,
              "y": 1.401,
              "z": 0.668
            },
            "gtin": "4008287956306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a90",
            "leftCorner": {
              "x": -21.829,
              "y": 1.401,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.829,
              "y": 1.134,
              "z": 0.668
            },
            "gtin": "4008287941012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a7b",
            "leftCorner": {
              "x": -21.825,
              "y": 1.134,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.824,
              "y": 0.969,
              "z": 0.668
            },
            "gtin": "4008287941050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ab83f025b371c4259935ed38",
            "leftCorner": {
              "x": -21.868,
              "y": 2.219,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.868,
              "y": 2.168,
              "z": 0.668
            },
            "gtin": "4008287941050",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d47d",
        "height": 1.1081,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79b2",
            "leftCorner": {
              "x": -21.812,
              "y": 2.17,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.812,
              "y": 2.023,
              "z": 0.907
            },
            "gtin": "9028800656990",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79b3",
            "leftCorner": {
              "x": -21.812,
              "y": 2.023,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.811,
              "y": 1.816,
              "z": 0.907
            },
            "gtin": "4008287073669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79b4",
            "leftCorner": {
              "x": -21.811,
              "y": 1.816,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.811,
              "y": 1.609,
              "z": 0.907
            },
            "gtin": "4008287073669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79b5",
            "leftCorner": {
              "x": -21.811,
              "y": 1.609,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.81,
              "y": 1.402,
              "z": 0.907
            },
            "gtin": "4008287073669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79b6",
            "leftCorner": {
              "x": -21.813,
              "y": 1.402,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.813,
              "y": 1.237,
              "z": 0.907
            },
            "gtin": "4101010003398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79b7",
            "leftCorner": {
              "x": -21.813,
              "y": 1.237,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.812,
              "y": 1.073,
              "z": 0.907
            },
            "gtin": "4101010003398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79b8",
            "leftCorner": {
              "x": -21.812,
              "y": 1.073,
              "z": 0.907
            },
            "rightCorner": {
              "x": -21.812,
              "y": 0.908,
              "z": 0.907
            },
            "gtin": "4101010003398",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d482",
        "height": 1.4164,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79e9",
            "leftCorner": {
              "x": -21.815,
              "y": 2.145,
              "z": 1.159
            },
            "rightCorner": {
              "x": -21.815,
              "y": 1.892,
              "z": 1.159
            },
            "gtin": "4008287072365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79ea",
            "leftCorner": {
              "x": -21.815,
              "y": 1.892,
              "z": 1.159
            },
            "rightCorner": {
              "x": -21.814,
              "y": 1.64,
              "z": 1.159
            },
            "gtin": "4008287072365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79eb",
            "leftCorner": {
              "x": -21.814,
              "y": 1.64,
              "z": 1.159
            },
            "rightCorner": {
              "x": -21.812,
              "y": 1.387,
              "z": 1.159
            },
            "gtin": "4008287072365",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79ec",
            "leftCorner": {
              "x": -21.825,
              "y": 1.387,
              "z": 1.159
            },
            "rightCorner": {
              "x": -21.825,
              "y": 1.248,
              "z": 1.159
            },
            "gtin": "4101010007426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79ed",
            "leftCorner": {
              "x": -21.825,
              "y": 1.248,
              "z": 1.159
            },
            "rightCorner": {
              "x": -21.824,
              "y": 1.108,
              "z": 1.159
            },
            "gtin": "4101010007426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79ee",
            "leftCorner": {
              "x": -21.824,
              "y": 1.108,
              "z": 1.159
            },
            "rightCorner": {
              "x": -21.824,
              "y": 0.969,
              "z": 1.159
            },
            "gtin": "4101010007426",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d47f",
        "height": 1.7327,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a52",
            "leftCorner": {
              "x": -21.81,
              "y": 1.837,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.809,
              "y": 1.69,
              "z": 1.418
            },
            "gtin": "4005249005737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "608bf233ceb4201286ea3e4c",
            "leftCorner": {
              "x": -21.851,
              "y": 2.219,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.85,
              "y": 2.043,
              "z": 1.418
            },
            "gtin": "3155930006633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6b030c66b4ee5bcfcc402061",
            "leftCorner": {
              "x": -21.85,
              "y": 2.043,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.85,
              "y": 1.866,
              "z": 1.418
            },
            "gtin": "3155930006633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a53",
            "leftCorner": {
              "x": -21.809,
              "y": 1.69,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.809,
              "y": 1.542,
              "z": 1.418
            },
            "gtin": "4005249005737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a54",
            "leftCorner": {
              "x": -21.809,
              "y": 1.542,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.807,
              "y": 1.216,
              "z": 1.418
            },
            "gtin": "4025127014262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a55",
            "leftCorner": {
              "x": -21.816,
              "y": 1.216,
              "z": 1.418
            },
            "rightCorner": {
              "x": -21.816,
              "y": 0.969,
              "z": 1.418
            },
            "gtin": "4002631040505",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ea3",
    "rightNeighborShelfId": "ea1"
  },
  {
    "id": "ea3",
    "name": "ea3",
    "x": -21.741,
    "y": 3.469,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70583,
      "w": 0.70838
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d47c",
        "height": 0.15973,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a19",
            "leftCorner": {
              "x": -21.823,
              "y": 3.405,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.821,
              "y": 2.927,
              "z": 0.131
            },
            "gtin": "4072700002291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "578fbf2eef5fc70965128f6a",
            "leftCorner": {
              "x": -21.846,
              "y": 2.691,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.845,
              "y": 2.436,
              "z": 0.131
            },
            "gtin": "4072700002291",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a1a",
            "leftCorner": {
              "x": -21.814,
              "y": 2.927,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.812,
              "y": 2.691,
              "z": 0.131
            },
            "gtin": "4066600614319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a1e",
            "leftCorner": {
              "x": -21.806,
              "y": 2.43,
              "z": 0.131
            },
            "rightCorner": {
              "x": -21.805,
              "y": 2.143,
              "z": 0.131
            },
            "gtin": "4100770005109",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d478",
        "height": 0.47962,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a91",
            "leftCorner": {
              "x": -21.864,
              "y": 3.469,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.864,
              "y": 3.256,
              "z": 0.392
            },
            "gtin": "9028800638606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a93",
            "leftCorner": {
              "x": -21.827,
              "y": 3.256,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.826,
              "y": 3.049,
              "z": 0.392
            },
            "gtin": "4100130900327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a94",
            "leftCorner": {
              "x": -21.826,
              "y": 3.049,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.825,
              "y": 2.842,
              "z": 0.392
            },
            "gtin": "4100130900327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a95",
            "leftCorner": {
              "x": -21.822,
              "y": 2.842,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.822,
              "y": 2.638,
              "z": 0.392
            },
            "gtin": "4053400078830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a96",
            "leftCorner": {
              "x": -21.822,
              "y": 2.638,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.821,
              "y": 2.541,
              "z": 0.392
            },
            "gtin": "4103080064125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a97",
            "leftCorner": {
              "x": -21.821,
              "y": 2.541,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.821,
              "y": 2.443,
              "z": 0.392
            },
            "gtin": "4103080064125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a98",
            "leftCorner": {
              "x": -21.821,
              "y": 2.443,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.821,
              "y": 2.346,
              "z": 0.392
            },
            "gtin": "4103080064125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a99",
            "leftCorner": {
              "x": -21.821,
              "y": 2.346,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.82,
              "y": 2.248,
              "z": 0.392
            },
            "gtin": "4103080064125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a9a",
            "leftCorner": {
              "x": -21.82,
              "y": 2.248,
              "z": 0.392
            },
            "rightCorner": {
              "x": -21.82,
              "y": 2.151,
              "z": 0.392
            },
            "gtin": "4103080064125",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d47b",
        "height": 0.81523,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a81",
            "leftCorner": {
              "x": -21.845,
              "y": 3.432,
              "z": 0.667
            },
            "rightCorner": {
              "x": -21.845,
              "y": 3.243,
              "z": 0.667
            },
            "gtin": "4008948192012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a82",
            "leftCorner": {
              "x": -21.845,
              "y": 3.243,
              "z": 0.667
            },
            "rightCorner": {
              "x": -21.844,
              "y": 3.055,
              "z": 0.667
            },
            "gtin": "4008948192012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a83",
            "leftCorner": {
              "x": -21.844,
              "y": 3.055,
              "z": 0.667
            },
            "rightCorner": {
              "x": -21.844,
              "y": 2.866,
              "z": 0.667
            },
            "gtin": "4008948192012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a84",
            "leftCorner": {
              "x": -21.833,
              "y": 2.866,
              "z": 0.667
            },
            "rightCorner": {
              "x": -21.833,
              "y": 2.759,
              "z": 0.667
            },
            "gtin": "4053400006611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a85",
            "leftCorner": {
              "x": -21.833,
              "y": 2.759,
              "z": 0.667
            },
            "rightCorner": {
              "x": -21.832,
              "y": 2.652,
              "z": 0.667
            },
            "gtin": "4053400006611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a86",
            "leftCorner": {
              "x": -21.832,
              "y": 2.652,
              "z": 0.667
            },
            "rightCorner": {
              "x": -21.832,
              "y": 2.545,
              "z": 0.667
            },
            "gtin": "4053400006611",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a87",
            "leftCorner": {
              "x": -21.83,
              "y": 2.546,
              "z": 0.667
            },
            "rightCorner": {
              "x": -21.828,
              "y": 2.15,
              "z": 0.667
            },
            "gtin": "4000856108130",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d47a",
        "height": 1.1069,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79ad",
            "leftCorner": {
              "x": -21.833,
              "y": 3.391,
              "z": 0.906
            },
            "rightCorner": {
              "x": -21.832,
              "y": 3.144,
              "z": 0.906
            },
            "gtin": "4053400001692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79ae",
            "leftCorner": {
              "x": -21.832,
              "y": 3.144,
              "z": 0.906
            },
            "rightCorner": {
              "x": -21.831,
              "y": 2.897,
              "z": 0.906
            },
            "gtin": "4053400001692",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79af",
            "leftCorner": {
              "x": -21.82,
              "y": 2.897,
              "z": 0.906
            },
            "rightCorner": {
              "x": -21.82,
              "y": 2.763,
              "z": 0.906
            },
            "gtin": "4053400006635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79b0",
            "leftCorner": {
              "x": -21.822,
              "y": 2.763,
              "z": 0.906
            },
            "rightCorner": {
              "x": -21.821,
              "y": 2.59,
              "z": 0.906
            },
            "gtin": "4053400078823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79b1",
            "leftCorner": {
              "x": -21.817,
              "y": 2.59,
              "z": 0.906
            },
            "rightCorner": {
              "x": -21.815,
              "y": 2.17,
              "z": 0.906
            },
            "gtin": "4005249008875",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d477",
        "height": 1.4109,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79e1",
            "leftCorner": {
              "x": -21.839,
              "y": 3.403,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.838,
              "y": 3.255,
              "z": 1.154
            },
            "gtin": "4053400081830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0448e8eb9b3c4e671c79ebe3",
            "leftCorner": {
              "x": -21.867,
              "y": 3.468,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.867,
              "y": 3.408,
              "z": 1.154
            },
            "gtin": "4053400002552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79e2",
            "leftCorner": {
              "x": -21.836,
              "y": 3.255,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.835,
              "y": 3.125,
              "z": 1.154
            },
            "gtin": "4053400058528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79e3",
            "leftCorner": {
              "x": -21.835,
              "y": 3.125,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.835,
              "y": 2.995,
              "z": 1.154
            },
            "gtin": "4053400058528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79e4",
            "leftCorner": {
              "x": -21.835,
              "y": 2.995,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.834,
              "y": 2.865,
              "z": 1.154
            },
            "gtin": "4053400058528",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79e5",
            "leftCorner": {
              "x": -21.825,
              "y": 2.865,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.824,
              "y": 2.704,
              "z": 1.154
            },
            "gtin": "4053400002552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79e6",
            "leftCorner": {
              "x": -21.824,
              "y": 2.704,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.823,
              "y": 2.487,
              "z": 1.154
            },
            "gtin": "4053400007533",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79e7",
            "leftCorner": {
              "x": -21.818,
              "y": 2.487,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.818,
              "y": 2.316,
              "z": 1.154
            },
            "gtin": "4005249062792",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79e8",
            "leftCorner": {
              "x": -21.818,
              "y": 2.316,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.817,
              "y": 2.145,
              "z": 1.154
            },
            "gtin": "4005249062792",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d479",
        "height": 1.7322,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a4e",
            "leftCorner": {
              "x": -21.837,
              "y": 3.405,
              "z": 1.417
            },
            "rightCorner": {
              "x": -21.836,
              "y": 3.146,
              "z": 1.417
            },
            "gtin": "4072700001409",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a4f",
            "leftCorner": {
              "x": -21.826,
              "y": 3.146,
              "z": 1.417
            },
            "rightCorner": {
              "x": -21.826,
              "y": 2.779,
              "z": 1.417
            },
            "gtin": "4005249063300",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a50",
            "leftCorner": {
              "x": -21.821,
              "y": 2.779,
              "z": 1.417
            },
            "rightCorner": {
              "x": -21.819,
              "y": 2.414,
              "z": 1.417
            },
            "gtin": "4005249062501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a51",
            "leftCorner": {
              "x": -21.81,
              "y": 2.414,
              "z": 1.417
            },
            "rightCorner": {
              "x": -21.808,
              "y": 1.837,
              "z": 1.417
            },
            "gtin": "4005249005393",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ea4",
    "rightNeighborShelfId": "ea2"
  },
  {
    "id": "ea4",
    "name": "ea4",
    "x": -21.745,
    "y": 4.719,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70583,
      "w": 0.70838
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 45
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d473",
        "height": 0.16336,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a11",
            "leftCorner": {
              "x": -21.809,
              "y": 4.463,
              "z": 0.134
            },
            "rightCorner": {
              "x": -21.808,
              "y": 4.393,
              "z": 0.134
            },
            "gtin": "4008287064360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8b6d76cb51863d5ba4e94a09",
            "leftCorner": {
              "x": -21.859,
              "y": 4.719,
              "z": 0.134
            },
            "rightCorner": {
              "x": -21.859,
              "y": 4.584,
              "z": 0.134
            },
            "gtin": "4082100003415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "937291927f06383b16d5786c",
            "leftCorner": {
              "x": -21.859,
              "y": 4.584,
              "z": 0.134
            },
            "rightCorner": {
              "x": -21.858,
              "y": 4.489,
              "z": 0.134
            },
            "gtin": "4082100004153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a12",
            "leftCorner": {
              "x": -21.808,
              "y": 4.393,
              "z": 0.134
            },
            "rightCorner": {
              "x": -21.808,
              "y": 4.323,
              "z": 0.134
            },
            "gtin": "4008287064360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a13",
            "leftCorner": {
              "x": -21.808,
              "y": 4.323,
              "z": 0.134
            },
            "rightCorner": {
              "x": -21.808,
              "y": 4.252,
              "z": 0.134
            },
            "gtin": "4008287064360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a14",
            "leftCorner": {
              "x": -21.808,
              "y": 4.252,
              "z": 0.134
            },
            "rightCorner": {
              "x": -21.808,
              "y": 4.182,
              "z": 0.134
            },
            "gtin": "4008287064360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a15",
            "leftCorner": {
              "x": -21.816,
              "y": 4.182,
              "z": 0.134
            },
            "rightCorner": {
              "x": -21.815,
              "y": 4.053,
              "z": 0.134
            },
            "gtin": "4082100003415",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a16",
            "leftCorner": {
              "x": -21.817,
              "y": 4.053,
              "z": 0.134
            },
            "rightCorner": {
              "x": -21.817,
              "y": 3.695,
              "z": 0.134
            },
            "gtin": "4082100004146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a17",
            "leftCorner": {
              "x": -21.817,
              "y": 3.695,
              "z": 0.134
            },
            "rightCorner": {
              "x": -21.816,
              "y": 3.602,
              "z": 0.134
            },
            "gtin": "4082100004153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a18",
            "leftCorner": {
              "x": -21.819,
              "y": 3.602,
              "z": 0.134
            },
            "rightCorner": {
              "x": -21.818,
              "y": 3.405,
              "z": 0.134
            },
            "gtin": "4082100004139",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d474",
        "height": 0.49248,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a3f",
            "leftCorner": {
              "x": -21.868,
              "y": 4.719,
              "z": 0.403
            },
            "rightCorner": {
              "x": -21.867,
              "y": 4.314,
              "z": 0.403
            },
            "gtin": "4008287919769",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a42",
            "leftCorner": {
              "x": -21.822,
              "y": 4.314,
              "z": 0.403
            },
            "rightCorner": {
              "x": -21.821,
              "y": 4.223,
              "z": 0.403
            },
            "gtin": "4008287950311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a43",
            "leftCorner": {
              "x": -21.821,
              "y": 4.223,
              "z": 0.403
            },
            "rightCorner": {
              "x": -21.82,
              "y": 4.133,
              "z": 0.403
            },
            "gtin": "4008287950311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a44",
            "leftCorner": {
              "x": -21.826,
              "y": 4.132,
              "z": 0.403
            },
            "rightCorner": {
              "x": -21.825,
              "y": 3.998,
              "z": 0.403
            },
            "gtin": "4102430036928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a45",
            "leftCorner": {
              "x": -21.825,
              "y": 3.998,
              "z": 0.403
            },
            "rightCorner": {
              "x": -21.825,
              "y": 3.863,
              "z": 0.403
            },
            "gtin": "4102430036928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a46",
            "leftCorner": {
              "x": -21.825,
              "y": 3.863,
              "z": 0.403
            },
            "rightCorner": {
              "x": -21.825,
              "y": 3.728,
              "z": 0.403
            },
            "gtin": "4102430036928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a40",
            "leftCorner": {
              "x": -21.826,
              "y": 3.728,
              "z": 0.403
            },
            "rightCorner": {
              "x": -21.826,
              "y": 3.598,
              "z": 0.403
            },
            "gtin": "4102430312411",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a41",
            "leftCorner": {
              "x": -21.826,
              "y": 3.598,
              "z": 0.403
            },
            "rightCorner": {
              "x": -21.826,
              "y": 3.469,
              "z": 0.403
            },
            "gtin": "4102430312411",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d476",
        "height": 0.81675,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a7a",
            "leftCorner": {
              "x": -21.869,
              "y": 4.719,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.868,
              "y": 4.323,
              "z": 0.668
            },
            "gtin": "4072700011637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a7c",
            "leftCorner": {
              "x": -21.827,
              "y": 4.323,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.826,
              "y": 4.187,
              "z": 0.668
            },
            "gtin": "4000856107133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a7d",
            "leftCorner": {
              "x": -21.826,
              "y": 4.187,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.825,
              "y": 4.05,
              "z": 0.668
            },
            "gtin": "4000856107133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a7e",
            "leftCorner": {
              "x": -21.825,
              "y": 4.05,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.825,
              "y": 3.913,
              "z": 0.668
            },
            "gtin": "4000856107133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a7f",
            "leftCorner": {
              "x": -21.825,
              "y": 3.913,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.824,
              "y": 3.777,
              "z": 0.668
            },
            "gtin": "4000856107133",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a80",
            "leftCorner": {
              "x": -21.827,
              "y": 3.777,
              "z": 0.668
            },
            "rightCorner": {
              "x": -21.826,
              "y": 3.432,
              "z": 0.668
            },
            "gtin": "4000856108260",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d471",
        "height": 1.1106,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79a3",
            "leftCorner": {
              "x": -21.863,
              "y": 4.719,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.863,
              "y": 4.576,
              "z": 0.909
            },
            "gtin": "4008287914504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79a4",
            "leftCorner": {
              "x": -21.863,
              "y": 4.576,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.862,
              "y": 4.433,
              "z": 0.909
            },
            "gtin": "4008287914504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79a5",
            "leftCorner": {
              "x": -21.862,
              "y": 4.433,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.862,
              "y": 4.29,
              "z": 0.909
            },
            "gtin": "4008287914504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79a6",
            "leftCorner": {
              "x": -21.862,
              "y": 4.29,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.861,
              "y": 4.147,
              "z": 0.909
            },
            "gtin": "4008287914504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79a8",
            "leftCorner": {
              "x": -21.821,
              "y": 4.147,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.821,
              "y": 3.958,
              "z": 0.909
            },
            "gtin": "4005249003832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79a9",
            "leftCorner": {
              "x": -21.821,
              "y": 3.958,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.82,
              "y": 3.769,
              "z": 0.909
            },
            "gtin": "4005249003832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79aa",
            "leftCorner": {
              "x": -21.82,
              "y": 3.769,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.82,
              "y": 3.643,
              "z": 0.909
            },
            "gtin": "4005249064529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79ab",
            "leftCorner": {
              "x": -21.82,
              "y": 3.643,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.82,
              "y": 3.517,
              "z": 0.909
            },
            "gtin": "4005249064529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79ac",
            "leftCorner": {
              "x": -21.82,
              "y": 3.517,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.82,
              "y": 3.391,
              "z": 0.909
            },
            "gtin": "4005249064529",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d472",
        "height": 1.4136,
        "facings": [
          {
            "id": "68d8e50de1820c81800d79d9",
            "leftCorner": {
              "x": -21.863,
              "y": 4.719,
              "z": 1.157
            },
            "rightCorner": {
              "x": -21.863,
              "y": 4.59,
              "z": 1.157
            },
            "gtin": "4102430088552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79da",
            "leftCorner": {
              "x": -21.863,
              "y": 4.59,
              "z": 1.157
            },
            "rightCorner": {
              "x": -21.863,
              "y": 4.462,
              "z": 1.157
            },
            "gtin": "4102430088552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79de",
            "leftCorner": {
              "x": -21.818,
              "y": 4.463,
              "z": 1.157
            },
            "rightCorner": {
              "x": -21.818,
              "y": 4.319,
              "z": 1.157
            },
            "gtin": "4102430088620",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79df",
            "leftCorner": {
              "x": -21.826,
              "y": 4.319,
              "z": 1.157
            },
            "rightCorner": {
              "x": -21.825,
              "y": 4.041,
              "z": 1.157
            },
            "gtin": "4260332480741",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79e0",
            "leftCorner": {
              "x": -21.829,
              "y": 4.041,
              "z": 1.157
            },
            "rightCorner": {
              "x": -21.827,
              "y": 3.403,
              "z": 1.157
            },
            "gtin": "4005249002378",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d475",
        "height": 1.7386,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7a49",
            "leftCorner": {
              "x": -21.819,
              "y": 4.303,
              "z": 1.422
            },
            "rightCorner": {
              "x": -21.818,
              "y": 3.983,
              "z": 1.422
            },
            "gtin": "4066600145271",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fbbcb7a6b59bc2bc6dc98fc5",
            "leftCorner": {
              "x": -21.861,
              "y": 4.719,
              "z": 1.422
            },
            "rightCorner": {
              "x": -21.86,
              "y": 4.535,
              "z": 1.422
            },
            "gtin": "4072700001454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3e11c9c34dece497bace690c",
            "leftCorner": {
              "x": -21.86,
              "y": 4.535,
              "z": 1.422
            },
            "rightCorner": {
              "x": -21.86,
              "y": 4.352,
              "z": 1.422
            },
            "gtin": "4072700001454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a4a",
            "leftCorner": {
              "x": -21.819,
              "y": 3.983,
              "z": 1.422
            },
            "rightCorner": {
              "x": -21.819,
              "y": 3.874,
              "z": 1.422
            },
            "gtin": "4066600545255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a4b",
            "leftCorner": {
              "x": -21.819,
              "y": 3.874,
              "z": 1.422
            },
            "rightCorner": {
              "x": -21.819,
              "y": 3.765,
              "z": 1.422
            },
            "gtin": "4066600545255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a4c",
            "leftCorner": {
              "x": -21.819,
              "y": 3.765,
              "z": 1.422
            },
            "rightCorner": {
              "x": -21.818,
              "y": 3.656,
              "z": 1.422
            },
            "gtin": "4066600545255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7a4d",
            "leftCorner": {
              "x": -21.817,
              "y": 3.656,
              "z": 1.422
            },
            "rightCorner": {
              "x": -21.817,
              "y": 3.405,
              "z": 1.422
            },
            "gtin": "4072700001454",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "ea3"
  },
  {
    "id": "ea5",
    "name": "ea5",
    "x": -25.131,
    "y": 4.801,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061784,
      "w": 0.99998
    },
    "layers": [],
    "leftNeighborShelfId": "ea6"
  },
  {
    "id": "ea6",
    "name": "ea6",
    "x": -26.381,
    "y": 4.786,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061784,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 16
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6bb",
        "height": 1.4064,
        "facings": [
          {
            "id": "68d8e50de1820c81800d799a",
            "leftCorner": {
              "x": -26.299,
              "y": 4.743,
              "z": 1.151
            },
            "rightCorner": {
              "x": -26.178,
              "y": 4.744,
              "z": 1.151
            },
            "gtin": "4008287901719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d799b",
            "leftCorner": {
              "x": -26.178,
              "y": 4.744,
              "z": 1.151
            },
            "rightCorner": {
              "x": -26.057,
              "y": 4.746,
              "z": 1.151
            },
            "gtin": "4008287901719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d799d",
            "leftCorner": {
              "x": -25.996,
              "y": 4.75,
              "z": 1.151
            },
            "rightCorner": {
              "x": -25.907,
              "y": 4.751,
              "z": 1.151
            },
            "gtin": "4014086611575",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d799e",
            "leftCorner": {
              "x": -25.907,
              "y": 4.752,
              "z": 1.151
            },
            "rightCorner": {
              "x": -25.825,
              "y": 4.753,
              "z": 1.151
            },
            "gtin": "4066600103400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d799f",
            "leftCorner": {
              "x": -25.825,
              "y": 4.76,
              "z": 1.151
            },
            "rightCorner": {
              "x": -25.634,
              "y": 4.762,
              "z": 1.151
            },
            "gtin": "4014086611568",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79a0",
            "leftCorner": {
              "x": -25.634,
              "y": 4.768,
              "z": 1.151
            },
            "rightCorner": {
              "x": -25.527,
              "y": 4.769,
              "z": 1.151
            },
            "gtin": "4001568100535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d79a2",
            "leftCorner": {
              "x": -25.225,
              "y": 4.781,
              "z": 1.151
            },
            "rightCorner": {
              "x": -25.176,
              "y": 4.781,
              "z": 1.151
            },
            "gtin": "4001568000521",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d798f",
            "leftCorner": {
              "x": -25.176,
              "y": 4.779,
              "z": 1.151
            },
            "rightCorner": {
              "x": -25.131,
              "y": 4.78,
              "z": 1.151
            },
            "gtin": "4001568703668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "429109154e97b2837b33017e",
            "leftCorner": {
              "x": -26.38,
              "y": 4.713,
              "z": 1.151
            },
            "rightCorner": {
              "x": -26.312,
              "y": 4.714,
              "z": 1.151
            },
            "gtin": "4082100009080",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b50e318e4e03990d839caf28",
            "leftCorner": {
              "x": -25.526,
              "y": 4.724,
              "z": 1.151
            },
            "rightCorner": {
              "x": -25.426,
              "y": 4.725,
              "z": 1.151
            },
            "gtin": "4001568100535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d82e15ab946dedc3bab89c",
            "leftCorner": {
              "x": -25.426,
              "y": 4.725,
              "z": 1.151
            },
            "rightCorner": {
              "x": -25.343,
              "y": 4.726,
              "z": 1.151
            },
            "gtin": "4066600103400",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "526236da179d4c2f01985abb",
            "leftCorner": {
              "x": -25.343,
              "y": 4.726,
              "z": 1.151
            },
            "rightCorner": {
              "x": -25.266,
              "y": 4.727,
              "z": 1.151
            },
            "gtin": "4014086611575",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6ba",
        "height": 1.7239,
        "facings": [
          {
            "id": "68d8e50de1820c81800d797a",
            "leftCorner": {
              "x": -26.265,
              "y": 4.74,
              "z": 1.41
            },
            "rightCorner": {
              "x": -26.103,
              "y": 4.743,
              "z": 1.41
            },
            "gtin": "4008287941388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d797b",
            "leftCorner": {
              "x": -26.103,
              "y": 4.744,
              "z": 1.41
            },
            "rightCorner": {
              "x": -25.916,
              "y": 4.746,
              "z": 1.41
            },
            "gtin": "4066600404309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d797c",
            "leftCorner": {
              "x": -25.917,
              "y": 4.752,
              "z": 1.41
            },
            "rightCorner": {
              "x": -25.62,
              "y": 4.755,
              "z": 1.41
            },
            "gtin": "4066600303305",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d797d",
            "leftCorner": {
              "x": -25.62,
              "y": 4.766,
              "z": 1.41
            },
            "rightCorner": {
              "x": -25.414,
              "y": 4.769,
              "z": 1.41
            },
            "gtin": "4066600203803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d797e",
            "leftCorner": {
              "x": -25.414,
              "y": 4.775,
              "z": 1.41
            },
            "rightCorner": {
              "x": -25.248,
              "y": 4.777,
              "z": 1.41
            },
            "gtin": "4066600203704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7953",
            "leftCorner": {
              "x": -25.248,
              "y": 4.779,
              "z": 1.41
            },
            "rightCorner": {
              "x": -25.131,
              "y": 4.78,
              "z": 1.41
            },
            "gtin": "4008287949049",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ea7",
    "rightNeighborShelfId": "ea5"
  },
  {
    "id": "ea7",
    "name": "ea7",
    "x": -27.631,
    "y": 4.77,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061784,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d46f",
        "height": 1.4049,
        "facings": [
          {
            "id": "68d8e50de1820c81800d798d",
            "leftCorner": {
              "x": -27.63,
              "y": 4.678,
              "z": 1.149
            },
            "rightCorner": {
              "x": -27.531,
              "y": 4.68,
              "z": 1.149
            },
            "gtin": "4005249061252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d798e",
            "leftCorner": {
              "x": -27.531,
              "y": 4.68,
              "z": 1.149
            },
            "rightCorner": {
              "x": -27.432,
              "y": 4.681,
              "z": 1.149
            },
            "gtin": "4005249061252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7990",
            "leftCorner": {
              "x": -27.421,
              "y": 4.725,
              "z": 1.149
            },
            "rightCorner": {
              "x": -27.246,
              "y": 4.727,
              "z": 1.149
            },
            "gtin": "4005249002668",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7991",
            "leftCorner": {
              "x": -27.246,
              "y": 4.726,
              "z": 1.149
            },
            "rightCorner": {
              "x": -27.092,
              "y": 4.728,
              "z": 1.149
            },
            "gtin": "4005249063188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7992",
            "leftCorner": {
              "x": -27.091,
              "y": 4.721,
              "z": 1.149
            },
            "rightCorner": {
              "x": -27.035,
              "y": 4.722,
              "z": 1.149
            },
            "gtin": "4018588093303",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7993",
            "leftCorner": {
              "x": -27.035,
              "y": 4.726,
              "z": 1.149
            },
            "rightCorner": {
              "x": -26.966,
              "y": 4.727,
              "z": 1.149
            },
            "gtin": "4008287901757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7994",
            "leftCorner": {
              "x": -26.966,
              "y": 4.727,
              "z": 1.149
            },
            "rightCorner": {
              "x": -26.897,
              "y": 4.728,
              "z": 1.149
            },
            "gtin": "4008287901757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7995",
            "leftCorner": {
              "x": -26.896,
              "y": 4.717,
              "z": 1.149
            },
            "rightCorner": {
              "x": -26.738,
              "y": 4.719,
              "z": 1.149
            },
            "gtin": "4082100003408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7996",
            "leftCorner": {
              "x": -26.738,
              "y": 4.721,
              "z": 1.149
            },
            "rightCorner": {
              "x": -26.594,
              "y": 4.722,
              "z": 1.149
            },
            "gtin": "4008287935547",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7997",
            "leftCorner": {
              "x": -26.575,
              "y": 4.724,
              "z": 1.149
            },
            "rightCorner": {
              "x": -26.483,
              "y": 4.725,
              "z": 1.149
            },
            "gtin": "4008287910360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7998",
            "leftCorner": {
              "x": -26.483,
              "y": 4.725,
              "z": 1.149
            },
            "rightCorner": {
              "x": -26.392,
              "y": 4.727,
              "z": 1.149
            },
            "gtin": "4008287910360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7999",
            "leftCorner": {
              "x": -26.392,
              "y": 4.727,
              "z": 1.149
            },
            "rightCorner": {
              "x": -26.3,
              "y": 4.728,
              "z": 1.149
            },
            "gtin": "4008287910360",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d470",
        "height": 1.72,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7974",
            "leftCorner": {
              "x": -27.59,
              "y": 4.716,
              "z": 1.407
            },
            "rightCorner": {
              "x": -27.291,
              "y": 4.72,
              "z": 1.407
            },
            "gtin": "4008287924695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7975",
            "leftCorner": {
              "x": -27.291,
              "y": 4.726,
              "z": 1.407
            },
            "rightCorner": {
              "x": -26.94,
              "y": 4.73,
              "z": 1.407
            },
            "gtin": "4008287924695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7976",
            "leftCorner": {
              "x": -26.94,
              "y": 4.725,
              "z": 1.407
            },
            "rightCorner": {
              "x": -26.641,
              "y": 4.728,
              "z": 1.407
            },
            "gtin": "4008287905427",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7977",
            "leftCorner": {
              "x": -26.641,
              "y": 4.724,
              "z": 1.407
            },
            "rightCorner": {
              "x": -26.516,
              "y": 4.726,
              "z": 1.407
            },
            "gtin": "4008287916225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7978",
            "leftCorner": {
              "x": -26.516,
              "y": 4.726,
              "z": 1.407
            },
            "rightCorner": {
              "x": -26.391,
              "y": 4.727,
              "z": 1.407
            },
            "gtin": "4008287916225",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7979",
            "leftCorner": {
              "x": -26.391,
              "y": 4.727,
              "z": 1.407
            },
            "rightCorner": {
              "x": -26.266,
              "y": 4.729,
              "z": 1.407
            },
            "gtin": "4008287916225",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ea8",
    "rightNeighborShelfId": "ea6"
  },
  {
    "id": "ea8",
    "name": "ea8",
    "x": -28.881,
    "y": 4.755,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061784,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 8,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d46d",
        "height": 1.7261,
        "facings": [
          {
            "id": "68d8e50de1820c81800d796a",
            "leftCorner": {
              "x": -28.836,
              "y": 4.705,
              "z": 1.412
            },
            "rightCorner": {
              "x": -28.809,
              "y": 4.705,
              "z": 1.412
            },
            "gtin": "4306188034650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d796b",
            "leftCorner": {
              "x": -28.809,
              "y": 4.699,
              "z": 1.412
            },
            "rightCorner": {
              "x": -28.699,
              "y": 4.7,
              "z": 1.412
            },
            "gtin": "4306188034650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d796c",
            "leftCorner": {
              "x": -28.699,
              "y": 4.7,
              "z": 1.412
            },
            "rightCorner": {
              "x": -28.646,
              "y": 4.701,
              "z": 1.412
            },
            "gtin": "4306188034612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d796d",
            "leftCorner": {
              "x": -28.647,
              "y": 4.711,
              "z": 1.412
            },
            "rightCorner": {
              "x": -28.569,
              "y": 4.712,
              "z": 1.412
            },
            "gtin": "4306188034612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d796e",
            "leftCorner": {
              "x": -28.569,
              "y": 4.712,
              "z": 1.412
            },
            "rightCorner": {
              "x": -28.491,
              "y": 4.713,
              "z": 1.412
            },
            "gtin": "4306188034612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d796f",
            "leftCorner": {
              "x": -28.491,
              "y": 4.713,
              "z": 1.412
            },
            "rightCorner": {
              "x": -28.413,
              "y": 4.714,
              "z": 1.412
            },
            "gtin": "4306188034612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7970",
            "leftCorner": {
              "x": -28.413,
              "y": 4.717,
              "z": 1.412
            },
            "rightCorner": {
              "x": -28.139,
              "y": 4.721,
              "z": 1.412
            },
            "gtin": "4306188034629",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50de1820c81800d7971",
            "leftCorner": {
              "x": -28.123,
              "y": 4.714,
              "z": 1.412
            },
            "rightCorner": {
              "x": -27.982,
              "y": 4.716,
              "z": 1.412
            },
            "gtin": "4306188034698",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7972",
            "leftCorner": {
              "x": -27.979,
              "y": 4.714,
              "z": 1.412
            },
            "rightCorner": {
              "x": -27.63,
              "y": 4.718,
              "z": 1.412
            },
            "gtin": "4005249002620",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ea9",
    "rightNeighborShelfId": "ea7"
  },
  {
    "id": "ea9",
    "name": "ea9",
    "x": -30.131,
    "y": 4.74,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061784,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 19,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d46a",
        "height": 1.4119,
        "facings": [
          {
            "id": "68d8e50de1820c81800d797f",
            "leftCorner": {
              "x": -30.13,
              "y": 4.637,
              "z": 1.155
            },
            "rightCorner": {
              "x": -29.963,
              "y": 4.64,
              "z": 1.155
            },
            "gtin": "4042600352185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "89c3bc262b9f6238717197b5",
            "leftCorner": {
              "x": -28.917,
              "y": 4.652,
              "z": 1.155
            },
            "rightCorner": {
              "x": -28.885,
              "y": 4.653,
              "z": 1.155
            },
            "gtin": "4042600352055",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7981",
            "leftCorner": {
              "x": -29.964,
              "y": 4.675,
              "z": 1.155
            },
            "rightCorner": {
              "x": -29.917,
              "y": 4.676,
              "z": 1.155
            },
            "gtin": "4042600352253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7982",
            "leftCorner": {
              "x": -29.917,
              "y": 4.686,
              "z": 1.155
            },
            "rightCorner": {
              "x": -29.841,
              "y": 4.687,
              "z": 1.155
            },
            "gtin": "4042600352253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7983",
            "leftCorner": {
              "x": -29.841,
              "y": 4.687,
              "z": 1.155
            },
            "rightCorner": {
              "x": -29.766,
              "y": 4.688,
              "z": 1.155
            },
            "gtin": "4042600352253",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7984",
            "leftCorner": {
              "x": -29.766,
              "y": 4.683,
              "z": 1.155
            },
            "rightCorner": {
              "x": -29.663,
              "y": 4.685,
              "z": 1.155
            },
            "gtin": "4027109819360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7985",
            "leftCorner": {
              "x": -29.663,
              "y": 4.685,
              "z": 1.155
            },
            "rightCorner": {
              "x": -29.56,
              "y": 4.686,
              "z": 1.155
            },
            "gtin": "4027109819360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7986",
            "leftCorner": {
              "x": -29.56,
              "y": 4.686,
              "z": 1.155
            },
            "rightCorner": {
              "x": -29.457,
              "y": 4.687,
              "z": 1.155
            },
            "gtin": "4027109819360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7987",
            "leftCorner": {
              "x": -29.457,
              "y": 4.695,
              "z": 1.155
            },
            "rightCorner": {
              "x": -29.38,
              "y": 4.696,
              "z": 1.155
            },
            "gtin": "41005941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7988",
            "leftCorner": {
              "x": -29.38,
              "y": 4.688,
              "z": 1.155
            },
            "rightCorner": {
              "x": -29.283,
              "y": 4.689,
              "z": 1.155
            },
            "gtin": "4042600352086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7989",
            "leftCorner": {
              "x": -29.283,
              "y": 4.687,
              "z": 1.155
            },
            "rightCorner": {
              "x": -29.251,
              "y": 4.687,
              "z": 1.155
            },
            "gtin": "41005958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d798a",
            "leftCorner": {
              "x": -29.252,
              "y": 4.701,
              "z": 1.155
            },
            "rightCorner": {
              "x": -29.146,
              "y": 4.702,
              "z": 1.155
            },
            "gtin": "41005958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d798b",
            "leftCorner": {
              "x": -29.146,
              "y": 4.702,
              "z": 1.155
            },
            "rightCorner": {
              "x": -29.04,
              "y": 4.703,
              "z": 1.155
            },
            "gtin": "41005958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d798c",
            "leftCorner": {
              "x": -29.04,
              "y": 4.695,
              "z": 1.155
            },
            "rightCorner": {
              "x": -28.917,
              "y": 4.696,
              "z": 1.155
            },
            "gtin": "4001513005830",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d469",
        "height": 1.7226,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7965",
            "leftCorner": {
              "x": -30.13,
              "y": 4.682,
              "z": 1.409
            },
            "rightCorner": {
              "x": -30.002,
              "y": 4.683,
              "z": 1.409
            },
            "gtin": "4001513009708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7966",
            "leftCorner": {
              "x": -30.002,
              "y": 4.68,
              "z": 1.409
            },
            "rightCorner": {
              "x": -29.812,
              "y": 4.682,
              "z": 1.409
            },
            "gtin": "4001513009708",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7967",
            "leftCorner": {
              "x": -29.812,
              "y": 4.684,
              "z": 1.409
            },
            "rightCorner": {
              "x": -29.603,
              "y": 4.686,
              "z": 1.409
            },
            "gtin": "4001513009722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7968",
            "leftCorner": {
              "x": -29.603,
              "y": 4.688,
              "z": 1.409
            },
            "rightCorner": {
              "x": -29.306,
              "y": 4.692,
              "z": 1.409
            },
            "gtin": "4001513004208",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7969",
            "leftCorner": {
              "x": -29.306,
              "y": 4.69,
              "z": 1.409
            },
            "rightCorner": {
              "x": -28.836,
              "y": 4.696,
              "z": 1.409
            },
            "gtin": "4001513004161",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "eaa",
    "rightNeighborShelfId": "ea8"
  },
  {
    "id": "eaa",
    "name": "eaa",
    "x": -31.381,
    "y": 4.724,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061784,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6be",
        "height": 1.2545,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86e6",
            "leftCorner": {
              "x": -31.38,
              "y": 4.575,
              "z": 1.026
            },
            "rightCorner": {
              "x": -31.287,
              "y": 4.576,
              "z": 1.026
            },
            "gtin": "4104450005878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86e8",
            "leftCorner": {
              "x": -31.27,
              "y": 4.624,
              "z": 1.026
            },
            "rightCorner": {
              "x": -31.198,
              "y": 4.625,
              "z": 1.026
            },
            "gtin": "3057640186158",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86e9",
            "leftCorner": {
              "x": -31.198,
              "y": 4.617,
              "z": 1.026
            },
            "rightCorner": {
              "x": -31.093,
              "y": 4.618,
              "z": 1.026
            },
            "gtin": "4104450065889",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86ea",
            "leftCorner": {
              "x": -31.093,
              "y": 4.625,
              "z": 1.026
            },
            "rightCorner": {
              "x": -31.061,
              "y": 4.626,
              "z": 1.026
            },
            "gtin": "3057640186233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86eb",
            "leftCorner": {
              "x": -31.061,
              "y": 4.618,
              "z": 1.026
            },
            "rightCorner": {
              "x": -30.951,
              "y": 4.619,
              "z": 1.026
            },
            "gtin": "4104450005885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86ec",
            "leftCorner": {
              "x": -30.933,
              "y": 4.621,
              "z": 1.026
            },
            "rightCorner": {
              "x": -30.846,
              "y": 4.622,
              "z": 1.026
            },
            "gtin": "4104450005595",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86ed",
            "leftCorner": {
              "x": -30.846,
              "y": 4.618,
              "z": 1.026
            },
            "rightCorner": {
              "x": -30.757,
              "y": 4.619,
              "z": 1.026
            },
            "gtin": "4104450005892",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86ee",
            "leftCorner": {
              "x": -30.757,
              "y": 4.621,
              "z": 1.026
            },
            "rightCorner": {
              "x": -30.525,
              "y": 4.623,
              "z": 1.026
            },
            "gtin": "4104450065896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86ef",
            "leftCorner": {
              "x": -30.525,
              "y": 4.629,
              "z": 1.026
            },
            "rightCorner": {
              "x": -30.444,
              "y": 4.63,
              "z": 1.026
            },
            "gtin": "4027109908880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86e7",
            "leftCorner": {
              "x": -30.44,
              "y": 4.761,
              "z": 1.026
            },
            "rightCorner": {
              "x": -30.131,
              "y": 4.765,
              "z": 1.026
            },
            "gtin": "4027109908897",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6c0",
        "height": 1.3831,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86f1",
            "leftCorner": {
              "x": -30.732,
              "y": 4.957,
              "z": 1.132
            },
            "rightCorner": {
              "x": -30.134,
              "y": 4.965,
              "z": 1.132
            },
            "gtin": "4027109908989",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "00426b172be6e8d22dedbdac",
            "leftCorner": {
              "x": -31.384,
              "y": 4.909,
              "z": 1.132
            },
            "rightCorner": {
              "x": -30.988,
              "y": 4.914,
              "z": 1.132
            },
            "gtin": "4027109908897",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6bf",
        "height": 1.7209,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7961",
            "leftCorner": {
              "x": -31.038,
              "y": 4.618,
              "z": 1.408
            },
            "rightCorner": {
              "x": -30.878,
              "y": 4.621,
              "z": 1.408
            },
            "gtin": "4104450065575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1b21efd8f29369fc21854a8f",
            "leftCorner": {
              "x": -31.38,
              "y": 4.576,
              "z": 1.408
            },
            "rightCorner": {
              "x": -31.219,
              "y": 4.578,
              "z": 1.408
            },
            "gtin": "4104450065575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "86115b712e32a877caf2bb94",
            "leftCorner": {
              "x": -31.219,
              "y": 4.578,
              "z": 1.408
            },
            "rightCorner": {
              "x": -31.057,
              "y": 4.58,
              "z": 1.408
            },
            "gtin": "4104450065575",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7962",
            "leftCorner": {
              "x": -30.878,
              "y": 4.618,
              "z": 1.408
            },
            "rightCorner": {
              "x": -30.639,
              "y": 4.621,
              "z": 1.408
            },
            "gtin": "4104450065582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7963",
            "leftCorner": {
              "x": -30.639,
              "y": 4.621,
              "z": 1.408
            },
            "rightCorner": {
              "x": -30.401,
              "y": 4.624,
              "z": 1.408
            },
            "gtin": "4104450065582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7964",
            "leftCorner": {
              "x": -30.401,
              "y": 4.63,
              "z": 1.408
            },
            "rightCorner": {
              "x": -30.13,
              "y": 4.633,
              "z": 1.408
            },
            "gtin": "4104450005595",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "eab",
    "rightNeighborShelfId": "ea9"
  },
  {
    "id": "eab",
    "name": "eab",
    "x": -32.631,
    "y": 4.709,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0061784,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 24,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6c3",
        "height": 1.3015,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86f2",
            "leftCorner": {
              "x": -32.629,
              "y": 4.56,
              "z": 1.065
            },
            "rightCorner": {
              "x": -32.516,
              "y": 4.562,
              "z": 1.065
            },
            "gtin": "4104450005403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86f4",
            "leftCorner": {
              "x": -32.516,
              "y": 4.571,
              "z": 1.065
            },
            "rightCorner": {
              "x": -32.375,
              "y": 4.573,
              "z": 1.065
            },
            "gtin": "4306188043379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86f5",
            "leftCorner": {
              "x": -32.375,
              "y": 4.584,
              "z": 1.065
            },
            "rightCorner": {
              "x": -32.262,
              "y": 4.585,
              "z": 1.065
            },
            "gtin": "4306188043362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86f6",
            "leftCorner": {
              "x": -32.262,
              "y": 4.585,
              "z": 1.065
            },
            "rightCorner": {
              "x": -32.149,
              "y": 4.586,
              "z": 1.065
            },
            "gtin": "4306188043362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86f7",
            "leftCorner": {
              "x": -32.149,
              "y": 4.586,
              "z": 1.065
            },
            "rightCorner": {
              "x": -32.036,
              "y": 4.588,
              "z": 1.065
            },
            "gtin": "4306188043362",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86f8",
            "leftCorner": {
              "x": -32.037,
              "y": 4.607,
              "z": 1.065
            },
            "rightCorner": {
              "x": -31.961,
              "y": 4.608,
              "z": 1.065
            },
            "gtin": "4001513000880",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86f9",
            "leftCorner": {
              "x": -31.961,
              "y": 4.6,
              "z": 1.065
            },
            "rightCorner": {
              "x": -31.9,
              "y": 4.601,
              "z": 1.065
            },
            "gtin": "4306188043393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86fa",
            "leftCorner": {
              "x": -31.9,
              "y": 4.61,
              "z": 1.065
            },
            "rightCorner": {
              "x": -31.785,
              "y": 4.611,
              "z": 1.065
            },
            "gtin": "4104450004567",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86fb",
            "leftCorner": {
              "x": -31.785,
              "y": 4.613,
              "z": 1.065
            },
            "rightCorner": {
              "x": -31.636,
              "y": 4.615,
              "z": 1.065
            },
            "gtin": "42150237",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86fc",
            "leftCorner": {
              "x": -31.636,
              "y": 4.616,
              "z": 1.065
            },
            "rightCorner": {
              "x": -31.545,
              "y": 4.617,
              "z": 1.065
            },
            "gtin": "3057640185403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86f3",
            "leftCorner": {
              "x": -31.545,
              "y": 4.612,
              "z": 1.065
            },
            "rightCorner": {
              "x": -31.38,
              "y": 4.614,
              "z": 1.065
            },
            "gtin": "3057640183843",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6c4",
        "height": 1.7186,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7951",
            "leftCorner": {
              "x": -32.629,
              "y": 4.551,
              "z": 1.406
            },
            "rightCorner": {
              "x": -32.545,
              "y": 4.552,
              "z": 1.406
            },
            "gtin": "4104450005977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7952",
            "leftCorner": {
              "x": -32.545,
              "y": 4.552,
              "z": 1.406
            },
            "rightCorner": {
              "x": -32.461,
              "y": 4.553,
              "z": 1.406
            },
            "gtin": "4104450005977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7954",
            "leftCorner": {
              "x": -32.461,
              "y": 4.572,
              "z": 1.406
            },
            "rightCorner": {
              "x": -32.407,
              "y": 4.572,
              "z": 1.406
            },
            "gtin": "4104450065971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7955",
            "leftCorner": {
              "x": -32.407,
              "y": 4.572,
              "z": 1.406
            },
            "rightCorner": {
              "x": -32.354,
              "y": 4.573,
              "z": 1.406
            },
            "gtin": "4104450065971",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7956",
            "leftCorner": {
              "x": -32.354,
              "y": 4.588,
              "z": 1.406
            },
            "rightCorner": {
              "x": -32.266,
              "y": 4.589,
              "z": 1.406
            },
            "gtin": "4104450005953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7957",
            "leftCorner": {
              "x": -32.266,
              "y": 4.589,
              "z": 1.406
            },
            "rightCorner": {
              "x": -32.179,
              "y": 4.59,
              "z": 1.406
            },
            "gtin": "4104450005953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7958",
            "leftCorner": {
              "x": -32.179,
              "y": 4.594,
              "z": 1.406
            },
            "rightCorner": {
              "x": -32.117,
              "y": 4.594,
              "z": 1.406
            },
            "gtin": "4104450005984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7959",
            "leftCorner": {
              "x": -32.117,
              "y": 4.594,
              "z": 1.406
            },
            "rightCorner": {
              "x": -32.055,
              "y": 4.595,
              "z": 1.406
            },
            "gtin": "4104450005984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d795a",
            "leftCorner": {
              "x": -32.056,
              "y": 4.598,
              "z": 1.406
            },
            "rightCorner": {
              "x": -31.904,
              "y": 4.6,
              "z": 1.406
            },
            "gtin": "4104450005199",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d795b",
            "leftCorner": {
              "x": -31.904,
              "y": 4.601,
              "z": 1.406
            },
            "rightCorner": {
              "x": -31.719,
              "y": 4.604,
              "z": 1.406
            },
            "gtin": "4104450005298",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d795c",
            "leftCorner": {
              "x": -31.719,
              "y": 4.606,
              "z": 1.406
            },
            "rightCorner": {
              "x": -31.557,
              "y": 4.608,
              "z": 1.406
            },
            "gtin": "4104450004499",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d795d",
            "leftCorner": {
              "x": -31.557,
              "y": 4.606,
              "z": 1.406
            },
            "rightCorner": {
              "x": -31.436,
              "y": 4.608,
              "z": 1.406
            },
            "gtin": "4104450004475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d795e",
            "leftCorner": {
              "x": -31.436,
              "y": 4.607,
              "z": 1.406
            },
            "rightCorner": {
              "x": -31.38,
              "y": 4.607,
              "z": 1.406
            },
            "gtin": "4104450004512",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "eaa"
  },
  {
    "id": "eac",
    "name": "eac",
    "x": -35.85,
    "y": 4.646,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0069551,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 39,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6c5",
        "height": 0.15392,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7922",
            "leftCorner": {
              "x": -35.848,
              "y": 4.543,
              "z": 0.126
            },
            "rightCorner": {
              "x": -35.65,
              "y": 4.546,
              "z": 0.126
            },
            "gtin": "4027109908149",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7929",
            "leftCorner": {
              "x": -35.651,
              "y": 4.584,
              "z": 0.126
            },
            "rightCorner": {
              "x": -35.488,
              "y": 4.586,
              "z": 0.126
            },
            "gtin": "4027109908101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d792a",
            "leftCorner": {
              "x": -35.488,
              "y": 4.586,
              "z": 0.126
            },
            "rightCorner": {
              "x": -35.324,
              "y": 4.588,
              "z": 0.126
            },
            "gtin": "4027109908101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d792b",
            "leftCorner": {
              "x": -35.324,
              "y": 4.588,
              "z": 0.126
            },
            "rightCorner": {
              "x": -35.16,
              "y": 4.59,
              "z": 0.126
            },
            "gtin": "4027109908101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d792c",
            "leftCorner": {
              "x": -35.16,
              "y": 4.591,
              "z": 0.126
            },
            "rightCorner": {
              "x": -34.965,
              "y": 4.593,
              "z": 0.126
            },
            "gtin": "4027109908255",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d792d",
            "leftCorner": {
              "x": -34.964,
              "y": 4.591,
              "z": 0.126
            },
            "rightCorner": {
              "x": -34.871,
              "y": 4.592,
              "z": 0.126
            },
            "gtin": "4027109908248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d792e",
            "leftCorner": {
              "x": -34.871,
              "y": 4.592,
              "z": 0.126
            },
            "rightCorner": {
              "x": -34.777,
              "y": 4.593,
              "z": 0.126
            },
            "gtin": "4027109908248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d792f",
            "leftCorner": {
              "x": -34.777,
              "y": 4.593,
              "z": 0.126
            },
            "rightCorner": {
              "x": -34.684,
              "y": 4.595,
              "z": 0.126
            },
            "gtin": "4027109908248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7930",
            "leftCorner": {
              "x": -34.684,
              "y": 4.595,
              "z": 0.126
            },
            "rightCorner": {
              "x": -34.59,
              "y": 4.596,
              "z": 0.126
            },
            "gtin": "4027109908248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7931",
            "leftCorner": {
              "x": -34.59,
              "y": 4.596,
              "z": 0.126
            },
            "rightCorner": {
              "x": -34.497,
              "y": 4.597,
              "z": 0.126
            },
            "gtin": "4027109908248",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6c6",
        "height": 0.54706,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7933",
            "leftCorner": {
              "x": -35.848,
              "y": 4.541,
              "z": 0.448
            },
            "rightCorner": {
              "x": -35.666,
              "y": 4.544,
              "z": 0.448
            },
            "gtin": "3057640533068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0158afe42cdead67199c40c5",
            "leftCorner": {
              "x": -35.281,
              "y": 4.549,
              "z": 0.448
            },
            "rightCorner": {
              "x": -35.166,
              "y": 4.551,
              "z": 0.448
            },
            "gtin": "4005720000756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7936",
            "leftCorner": {
              "x": -35.667,
              "y": 4.583,
              "z": 0.448
            },
            "rightCorner": {
              "x": -35.507,
              "y": 4.585,
              "z": 0.448
            },
            "gtin": "3057640365928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7937",
            "leftCorner": {
              "x": -35.507,
              "y": 4.585,
              "z": 0.448
            },
            "rightCorner": {
              "x": -35.347,
              "y": 4.588,
              "z": 0.448
            },
            "gtin": "3057640365928",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7938",
            "leftCorner": {
              "x": -35.346,
              "y": 4.572,
              "z": 0.448
            },
            "rightCorner": {
              "x": -35.281,
              "y": 4.573,
              "z": 0.448
            },
            "gtin": "4005720000756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d793a",
            "leftCorner": {
              "x": -35.116,
              "y": 4.59,
              "z": 0.448
            },
            "rightCorner": {
              "x": -34.964,
              "y": 4.592,
              "z": 0.448
            },
            "gtin": "3057640428203",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d793b",
            "leftCorner": {
              "x": -34.964,
              "y": 4.592,
              "z": 0.448
            },
            "rightCorner": {
              "x": -34.813,
              "y": 4.594,
              "z": 0.448
            },
            "gtin": "3057640428203",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6c8",
        "height": 0.94758,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7914",
            "leftCorner": {
              "x": -35.848,
              "y": 4.543,
              "z": 0.775
            },
            "rightCorner": {
              "x": -35.546,
              "y": 4.547,
              "z": 0.775
            },
            "gtin": "4102380029094",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7917",
            "leftCorner": {
              "x": -35.546,
              "y": 4.585,
              "z": 0.775
            },
            "rightCorner": {
              "x": -35.393,
              "y": 4.587,
              "z": 0.775
            },
            "gtin": "4102380027861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7918",
            "leftCorner": {
              "x": -35.392,
              "y": 4.589,
              "z": 0.775
            },
            "rightCorner": {
              "x": -35.249,
              "y": 4.591,
              "z": 0.775
            },
            "gtin": "4102380026031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7919",
            "leftCorner": {
              "x": -35.249,
              "y": 4.591,
              "z": 0.775
            },
            "rightCorner": {
              "x": -35.106,
              "y": 4.593,
              "z": 0.775
            },
            "gtin": "4102380026031",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d791a",
            "leftCorner": {
              "x": -35.106,
              "y": 4.591,
              "z": 0.775
            },
            "rightCorner": {
              "x": -35.019,
              "y": 4.592,
              "z": 0.775
            },
            "gtin": "4102380026147",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d791b",
            "leftCorner": {
              "x": -35.019,
              "y": 4.585,
              "z": 0.775
            },
            "rightCorner": {
              "x": -34.794,
              "y": 4.588,
              "z": 0.775
            },
            "gtin": "4102380026154",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6c9",
        "height": 1.3531,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7942",
            "leftCorner": {
              "x": -35.848,
              "y": 4.544,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.604,
              "y": 4.547,
              "z": 1.107
            },
            "gtin": "4102380038430",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7944",
            "leftCorner": {
              "x": -35.604,
              "y": 4.583,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.478,
              "y": 4.584,
              "z": 1.107
            },
            "gtin": "4102380029131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7945",
            "leftCorner": {
              "x": -35.478,
              "y": 4.584,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.352,
              "y": 4.586,
              "z": 1.107
            },
            "gtin": "4102380029131",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7946",
            "leftCorner": {
              "x": -35.352,
              "y": 4.601,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.238,
              "y": 4.602,
              "z": 1.107
            },
            "gtin": "4102380031998",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7947",
            "leftCorner": {
              "x": -35.237,
              "y": 4.593,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.145,
              "y": 4.595,
              "z": 1.107
            },
            "gtin": "4102380027144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7948",
            "leftCorner": {
              "x": -35.145,
              "y": 4.595,
              "z": 1.107
            },
            "rightCorner": {
              "x": -35.052,
              "y": 4.596,
              "z": 1.107
            },
            "gtin": "4102380027144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7949",
            "leftCorner": {
              "x": -35.052,
              "y": 4.591,
              "z": 1.107
            },
            "rightCorner": {
              "x": -34.92,
              "y": 4.593,
              "z": 1.107
            },
            "gtin": "4102380027052",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d794a",
            "leftCorner": {
              "x": -34.92,
              "y": 4.593,
              "z": 1.107
            },
            "rightCorner": {
              "x": -34.788,
              "y": 4.595,
              "z": 1.107
            },
            "gtin": "4102380027052",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6c7",
        "height": 1.7254,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7907",
            "leftCorner": {
              "x": -35.848,
              "y": 4.542,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.695,
              "y": 4.544,
              "z": 1.412
            },
            "gtin": "4005906274599",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7909",
            "leftCorner": {
              "x": -35.696,
              "y": 4.579,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.507,
              "y": 4.582,
              "z": 1.412
            },
            "gtin": "4005906274650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d790a",
            "leftCorner": {
              "x": -35.507,
              "y": 4.589,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.382,
              "y": 4.591,
              "z": 1.412
            },
            "gtin": "4005906274629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d790b",
            "leftCorner": {
              "x": -35.382,
              "y": 4.591,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.285,
              "y": 4.592,
              "z": 1.412
            },
            "gtin": "4005906004103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d790c",
            "leftCorner": {
              "x": -35.285,
              "y": 4.592,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.189,
              "y": 4.594,
              "z": 1.412
            },
            "gtin": "4005906004103",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d790d",
            "leftCorner": {
              "x": -35.189,
              "y": 4.591,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.085,
              "y": 4.593,
              "z": 1.412
            },
            "gtin": "4005906005162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d790e",
            "leftCorner": {
              "x": -35.085,
              "y": 4.587,
              "z": 1.412
            },
            "rightCorner": {
              "x": -34.95,
              "y": 4.589,
              "z": 1.412
            },
            "gtin": "4005906274704",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d790f",
            "leftCorner": {
              "x": -34.95,
              "y": 4.592,
              "z": 1.412
            },
            "rightCorner": {
              "x": -34.807,
              "y": 4.594,
              "z": 1.412
            },
            "gtin": "4005906004585",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "eaf"
  },
  {
    "id": "eaf",
    "name": "eaf",
    "x": -34.85,
    "y": 4.66,
    "width": 1.0,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0069551,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 35,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d465",
        "height": 0.15201,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7932",
            "leftCorner": {
              "x": -34.497,
              "y": 4.599,
              "z": 0.124
            },
            "rightCorner": {
              "x": -34.205,
              "y": 4.603,
              "z": 0.124
            },
            "gtin": "4027109908354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7923",
            "leftCorner": {
              "x": -34.205,
              "y": 4.607,
              "z": 0.124
            },
            "rightCorner": {
              "x": -34.146,
              "y": 4.608,
              "z": 0.124
            },
            "gtin": "4027109908125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "76173f7f8d0f0deb85387101",
            "leftCorner": {
              "x": -34.848,
              "y": 4.556,
              "z": 0.124
            },
            "rightCorner": {
              "x": -34.534,
              "y": 4.561,
              "z": 0.124
            },
            "gtin": "4027109908354",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7924",
            "leftCorner": {
              "x": -34.146,
              "y": 4.608,
              "z": 0.124
            },
            "rightCorner": {
              "x": -34.087,
              "y": 4.609,
              "z": 0.124
            },
            "gtin": "4027109908125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7925",
            "leftCorner": {
              "x": -34.087,
              "y": 4.609,
              "z": 0.124
            },
            "rightCorner": {
              "x": -34.027,
              "y": 4.61,
              "z": 0.124
            },
            "gtin": "4027109908125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7926",
            "leftCorner": {
              "x": -34.027,
              "y": 4.61,
              "z": 0.124
            },
            "rightCorner": {
              "x": -33.968,
              "y": 4.611,
              "z": 0.124
            },
            "gtin": "4027109908125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7927",
            "leftCorner": {
              "x": -33.968,
              "y": 4.611,
              "z": 0.124
            },
            "rightCorner": {
              "x": -33.908,
              "y": 4.611,
              "z": 0.124
            },
            "gtin": "4027109908125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7928",
            "leftCorner": {
              "x": -33.908,
              "y": 4.611,
              "z": 0.124
            },
            "rightCorner": {
              "x": -33.849,
              "y": 4.612,
              "z": 0.124
            },
            "gtin": "4027109908125",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d466",
        "height": 0.54524,
        "facings": [
          {
            "id": "68d8e50de1820c81800d793c",
            "leftCorner": {
              "x": -34.813,
              "y": 4.59,
              "z": 0.446
            },
            "rightCorner": {
              "x": -34.691,
              "y": 4.592,
              "z": 0.446
            },
            "gtin": "4027109908934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d793d",
            "leftCorner": {
              "x": -34.691,
              "y": 4.592,
              "z": 0.446
            },
            "rightCorner": {
              "x": -34.569,
              "y": 4.593,
              "z": 0.446
            },
            "gtin": "4027109908934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d793e",
            "leftCorner": {
              "x": -34.569,
              "y": 4.593,
              "z": 0.446
            },
            "rightCorner": {
              "x": -34.447,
              "y": 4.595,
              "z": 0.446
            },
            "gtin": "4027109908934",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d793f",
            "leftCorner": {
              "x": -34.447,
              "y": 4.601,
              "z": 0.446
            },
            "rightCorner": {
              "x": -34.356,
              "y": 4.602,
              "z": 0.446
            },
            "gtin": "4027109909030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7940",
            "leftCorner": {
              "x": -34.356,
              "y": 4.602,
              "z": 0.446
            },
            "rightCorner": {
              "x": -34.264,
              "y": 4.603,
              "z": 0.446
            },
            "gtin": "4027109909030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7941",
            "leftCorner": {
              "x": -34.264,
              "y": 4.603,
              "z": 0.446
            },
            "rightCorner": {
              "x": -34.173,
              "y": 4.605,
              "z": 0.446
            },
            "gtin": "4027109909030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7934",
            "leftCorner": {
              "x": -34.173,
              "y": 4.607,
              "z": 0.446
            },
            "rightCorner": {
              "x": -34.011,
              "y": 4.609,
              "z": 0.446
            },
            "gtin": "4027109908927",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7935",
            "leftCorner": {
              "x": -34.011,
              "y": 4.609,
              "z": 0.446
            },
            "rightCorner": {
              "x": -33.849,
              "y": 4.611,
              "z": 0.446
            },
            "gtin": "4027109908927",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d464",
        "height": 0.94807,
        "facings": [
          {
            "id": "68d8e50de1820c81800d791c",
            "leftCorner": {
              "x": -34.794,
              "y": 4.595,
              "z": 0.776
            },
            "rightCorner": {
              "x": -34.575,
              "y": 4.598,
              "z": 0.776
            },
            "gtin": "3057640429613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d791d",
            "leftCorner": {
              "x": -34.575,
              "y": 4.601,
              "z": 0.776
            },
            "rightCorner": {
              "x": -34.436,
              "y": 4.603,
              "z": 0.776
            },
            "gtin": "4027109908309",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d791e",
            "leftCorner": {
              "x": -34.436,
              "y": 4.603,
              "z": 0.776
            },
            "rightCorner": {
              "x": -34.323,
              "y": 4.604,
              "z": 0.776
            },
            "gtin": "4027109908316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d791f",
            "leftCorner": {
              "x": -34.323,
              "y": 4.604,
              "z": 0.776
            },
            "rightCorner": {
              "x": -34.211,
              "y": 4.606,
              "z": 0.776
            },
            "gtin": "4027109908316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7915",
            "leftCorner": {
              "x": -33.981,
              "y": 4.611,
              "z": 0.776
            },
            "rightCorner": {
              "x": -33.915,
              "y": 4.612,
              "z": 0.776
            },
            "gtin": "4027109988325",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "afc45797e829506523ebe801",
            "leftCorner": {
              "x": -34.21,
              "y": 4.567,
              "z": 0.776
            },
            "rightCorner": {
              "x": -33.994,
              "y": 4.57,
              "z": 0.776
            },
            "gtin": "3057640429613",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7916",
            "leftCorner": {
              "x": -33.915,
              "y": 4.612,
              "z": 0.776
            },
            "rightCorner": {
              "x": -33.849,
              "y": 4.613,
              "z": 0.776
            },
            "gtin": "4027109988325",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d467",
        "height": 1.3533,
        "facings": [
          {
            "id": "68d8e50de1820c81800d794b",
            "leftCorner": {
              "x": -34.788,
              "y": 4.597,
              "z": 1.107
            },
            "rightCorner": {
              "x": -34.692,
              "y": 4.599,
              "z": 1.107
            },
            "gtin": "4102380027823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d794c",
            "leftCorner": {
              "x": -34.692,
              "y": 4.599,
              "z": 1.107
            },
            "rightCorner": {
              "x": -34.596,
              "y": 4.6,
              "z": 1.107
            },
            "gtin": "4102380027823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d794d",
            "leftCorner": {
              "x": -34.598,
              "y": 4.802,
              "z": 1.107
            },
            "rightCorner": {
              "x": -34.316,
              "y": 4.806,
              "z": 1.107
            },
            "gtin": "4102380027083",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d794e",
            "leftCorner": {
              "x": -34.314,
              "y": 4.607,
              "z": 1.107
            },
            "rightCorner": {
              "x": -34.212,
              "y": 4.608,
              "z": 1.107
            },
            "gtin": "3057640598913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d794f",
            "leftCorner": {
              "x": -34.212,
              "y": 4.608,
              "z": 1.107
            },
            "rightCorner": {
              "x": -34.109,
              "y": 4.61,
              "z": 1.107
            },
            "gtin": "3057640598913",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7950",
            "leftCorner": {
              "x": -34.109,
              "y": 4.607,
              "z": 1.107
            },
            "rightCorner": {
              "x": -33.952,
              "y": 4.609,
              "z": 1.107
            },
            "gtin": "3057640598333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7943",
            "leftCorner": {
              "x": -33.952,
              "y": 4.608,
              "z": 1.107
            },
            "rightCorner": {
              "x": -33.849,
              "y": 4.61,
              "z": 1.107
            },
            "gtin": "3057640598678",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d462",
        "height": 1.7253,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7910",
            "leftCorner": {
              "x": -34.806,
              "y": 4.595,
              "z": 1.412
            },
            "rightCorner": {
              "x": -34.662,
              "y": 4.597,
              "z": 1.412
            },
            "gtin": "4005906274742",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7911",
            "leftCorner": {
              "x": -34.662,
              "y": 4.599,
              "z": 1.412
            },
            "rightCorner": {
              "x": -34.522,
              "y": 4.601,
              "z": 1.412
            },
            "gtin": "54013933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7912",
            "leftCorner": {
              "x": -34.522,
              "y": 4.605,
              "z": 1.412
            },
            "rightCorner": {
              "x": -34.311,
              "y": 4.608,
              "z": 1.412
            },
            "gtin": "54013940",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7913",
            "leftCorner": {
              "x": -34.311,
              "y": 4.608,
              "z": 1.412
            },
            "rightCorner": {
              "x": -34.105,
              "y": 4.611,
              "z": 1.412
            },
            "gtin": "3057640448423",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7908",
            "leftCorner": {
              "x": -34.104,
              "y": 4.609,
              "z": 1.412
            },
            "rightCorner": {
              "x": -33.849,
              "y": 4.612,
              "z": 1.412
            },
            "gtin": "3057640447853",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "eac"
  },
  {
    "id": "eb0",
    "name": "eb0",
    "x": -35.896,
    "y": 3.354,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7139,
      "w": 0.70025
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 42,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6cd",
        "height": 0.1492,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78d7",
            "leftCorner": {
              "x": -35.845,
              "y": 3.725,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.848,
              "y": 3.878,
              "z": 0.122
            },
            "gtin": "8722200964785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78d8",
            "leftCorner": {
              "x": -35.848,
              "y": 3.878,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.851,
              "y": 4.031,
              "z": 0.122
            },
            "gtin": "8722200964785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78d9",
            "leftCorner": {
              "x": -35.853,
              "y": 4.031,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.854,
              "y": 4.139,
              "z": 0.122
            },
            "gtin": "8722200964259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78da",
            "leftCorner": {
              "x": -35.854,
              "y": 4.139,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.857,
              "y": 4.247,
              "z": 0.122
            },
            "gtin": "8722200964259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78db",
            "leftCorner": {
              "x": -35.857,
              "y": 4.247,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.859,
              "y": 4.354,
              "z": 0.122
            },
            "gtin": "8722200964259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78c4",
            "leftCorner": {
              "x": -35.86,
              "y": 4.354,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.861,
              "y": 4.438,
              "z": 0.122
            },
            "gtin": "8722200961838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1bc08fb54adf79b1aaa04c44",
            "leftCorner": {
              "x": -35.8,
              "y": 3.356,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.802,
              "y": 3.457,
              "z": 0.122
            },
            "gtin": "8722200964785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "58b980e9a6d6226ddd169d7c",
            "leftCorner": {
              "x": -35.802,
              "y": 3.457,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.807,
              "y": 3.72,
              "z": 0.122
            },
            "gtin": "8722200961838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78c5",
            "leftCorner": {
              "x": -35.861,
              "y": 4.438,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.863,
              "y": 4.521,
              "z": 0.122
            },
            "gtin": "8722200961838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78c6",
            "leftCorner": {
              "x": -35.863,
              "y": 4.521,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.865,
              "y": 4.605,
              "z": 0.122
            },
            "gtin": "8722200961838",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6ce",
        "height": 0.51915,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d86fd",
            "leftCorner": {
              "x": -35.798,
              "y": 3.356,
              "z": 0.425
            },
            "rightCorner": {
              "x": -35.803,
              "y": 3.615,
              "z": 0.425
            },
            "gtin": "4000140710612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86fe",
            "leftCorner": {
              "x": -35.803,
              "y": 3.615,
              "z": 0.425
            },
            "rightCorner": {
              "x": -35.807,
              "y": 3.875,
              "z": 0.425
            },
            "gtin": "4000140710612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8701",
            "leftCorner": {
              "x": -35.848,
              "y": 3.874,
              "z": 0.425
            },
            "rightCorner": {
              "x": -35.857,
              "y": 4.246,
              "z": 0.425
            },
            "gtin": "4000140710582",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d86ff",
            "leftCorner": {
              "x": -35.853,
              "y": 4.246,
              "z": 0.425
            },
            "rightCorner": {
              "x": -35.856,
              "y": 4.425,
              "z": 0.425
            },
            "gtin": "4000140700118",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8700",
            "leftCorner": {
              "x": -35.856,
              "y": 4.425,
              "z": 0.425
            },
            "rightCorner": {
              "x": -35.86,
              "y": 4.605,
              "z": 0.425
            },
            "gtin": "4000140700118",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6cb",
        "height": 0.92124,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78ec",
            "leftCorner": {
              "x": -35.828,
              "y": 3.414,
              "z": 0.754
            },
            "rightCorner": {
              "x": -35.833,
              "y": 3.654,
              "z": 0.754
            },
            "gtin": "4000140719028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78ed",
            "leftCorner": {
              "x": -35.838,
              "y": 3.654,
              "z": 0.754
            },
            "rightCorner": {
              "x": -35.841,
              "y": 3.86,
              "z": 0.754
            },
            "gtin": "4000140721373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78ee",
            "leftCorner": {
              "x": -35.841,
              "y": 3.86,
              "z": 0.754
            },
            "rightCorner": {
              "x": -35.846,
              "y": 4.065,
              "z": 0.754
            },
            "gtin": "4000140721373",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78ef",
            "leftCorner": {
              "x": -35.848,
              "y": 4.065,
              "z": 0.754
            },
            "rightCorner": {
              "x": -35.849,
              "y": 4.169,
              "z": 0.754
            },
            "gtin": "4014472648123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78f0",
            "leftCorner": {
              "x": -35.849,
              "y": 4.169,
              "z": 0.754
            },
            "rightCorner": {
              "x": -35.852,
              "y": 4.272,
              "z": 0.754
            },
            "gtin": "4014472648123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78f1",
            "leftCorner": {
              "x": -35.852,
              "y": 4.272,
              "z": 0.754
            },
            "rightCorner": {
              "x": -35.856,
              "y": 4.538,
              "z": 0.754
            },
            "gtin": "4014472648116",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78de",
            "leftCorner": {
              "x": -35.848,
              "y": 4.538,
              "z": 0.754
            },
            "rightCorner": {
              "x": -35.851,
              "y": 4.605,
              "z": 0.754
            },
            "gtin": "4014472648130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5fe16e9ce523cf1ced6029a0",
            "leftCorner": {
              "x": -35.794,
              "y": 3.356,
              "z": 0.754
            },
            "rightCorner": {
              "x": -35.795,
              "y": 3.414,
              "z": 0.754
            },
            "gtin": "4014472648130",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6ca",
        "height": 1.3242,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7894",
            "leftCorner": {
              "x": -35.827,
              "y": 3.504,
              "z": 1.083
            },
            "rightCorner": {
              "x": -35.831,
              "y": 3.703,
              "z": 1.083
            },
            "gtin": "4000140708268",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7895",
            "leftCorner": {
              "x": -35.84,
              "y": 3.703,
              "z": 1.083
            },
            "rightCorner": {
              "x": -35.842,
              "y": 3.854,
              "z": 1.083
            },
            "gtin": "4045145295108",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7896",
            "leftCorner": {
              "x": -35.847,
              "y": 3.854,
              "z": 1.083
            },
            "rightCorner": {
              "x": -35.85,
              "y": 3.989,
              "z": 1.083
            },
            "gtin": "4048517758508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7897",
            "leftCorner": {
              "x": -35.85,
              "y": 3.989,
              "z": 1.083
            },
            "rightCorner": {
              "x": -35.853,
              "y": 4.123,
              "z": 1.083
            },
            "gtin": "4048517758508",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7898",
            "leftCorner": {
              "x": -35.85,
              "y": 4.123,
              "z": 1.083
            },
            "rightCorner": {
              "x": -35.851,
              "y": 4.208,
              "z": 1.083
            },
            "gtin": "4048517742682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7899",
            "leftCorner": {
              "x": -35.851,
              "y": 4.208,
              "z": 1.083
            },
            "rightCorner": {
              "x": -35.854,
              "y": 4.293,
              "z": 1.083
            },
            "gtin": "4048517742682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d789a",
            "leftCorner": {
              "x": -35.854,
              "y": 4.293,
              "z": 1.083
            },
            "rightCorner": {
              "x": -35.855,
              "y": 4.378,
              "z": 1.083
            },
            "gtin": "4048517742682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d787e",
            "leftCorner": {
              "x": -35.855,
              "y": 4.378,
              "z": 1.083
            },
            "rightCorner": {
              "x": -35.857,
              "y": 4.491,
              "z": 1.083
            },
            "gtin": "4048517783265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2c1e4ce8de362314c7a63841",
            "leftCorner": {
              "x": -35.796,
              "y": 3.356,
              "z": 1.083
            },
            "rightCorner": {
              "x": -35.798,
              "y": 3.467,
              "z": 1.083
            },
            "gtin": "4048517779640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d787f",
            "leftCorner": {
              "x": -35.857,
              "y": 4.491,
              "z": 1.083
            },
            "rightCorner": {
              "x": -35.86,
              "y": 4.605,
              "z": 1.083
            },
            "gtin": "4048517783265",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6cc",
        "height": 1.7219,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78ba",
            "leftCorner": {
              "x": -35.826,
              "y": 3.407,
              "z": 1.409
            },
            "rightCorner": {
              "x": -35.833,
              "y": 3.749,
              "z": 1.409
            },
            "gtin": "5449000122995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78bb",
            "leftCorner": {
              "x": -35.841,
              "y": 3.749,
              "z": 1.409
            },
            "rightCorner": {
              "x": -35.843,
              "y": 3.858,
              "z": 1.409
            },
            "gtin": "4104450004574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78bc",
            "leftCorner": {
              "x": -35.846,
              "y": 3.858,
              "z": 1.409
            },
            "rightCorner": {
              "x": -35.849,
              "y": 3.987,
              "z": 1.409
            },
            "gtin": "4104450004628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78bd",
            "leftCorner": {
              "x": -35.85,
              "y": 3.987,
              "z": 1.409
            },
            "rightCorner": {
              "x": -35.852,
              "y": 4.116,
              "z": 1.409
            },
            "gtin": "4104450004635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78be",
            "leftCorner": {
              "x": -35.849,
              "y": 4.116,
              "z": 1.409
            },
            "rightCorner": {
              "x": -35.85,
              "y": 4.177,
              "z": 1.409
            },
            "gtin": "4104450004819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78bf",
            "leftCorner": {
              "x": -35.85,
              "y": 4.177,
              "z": 1.409
            },
            "rightCorner": {
              "x": -35.852,
              "y": 4.239,
              "z": 1.409
            },
            "gtin": "4104450004819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78a3",
            "leftCorner": {
              "x": -35.85,
              "y": 4.239,
              "z": 1.409
            },
            "rightCorner": {
              "x": -35.853,
              "y": 4.422,
              "z": 1.409
            },
            "gtin": "4104450004765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "145a8e01b857be225428ec29",
            "leftCorner": {
              "x": -35.795,
              "y": 3.356,
              "z": 1.409
            },
            "rightCorner": {
              "x": -35.796,
              "y": 3.404,
              "z": 1.409
            },
            "gtin": "4104450004635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78a4",
            "leftCorner": {
              "x": -35.853,
              "y": 4.422,
              "z": 1.409
            },
            "rightCorner": {
              "x": -35.857,
              "y": 4.605,
              "z": 1.409
            },
            "gtin": "4104450004765",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ebf"
  },
  {
    "id": "ebf",
    "name": "ebf",
    "x": -35.872,
    "y": 2.104,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7139,
      "w": 0.70025
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 29,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d45e",
        "height": 0.14849,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78cf",
            "leftCorner": {
              "x": -35.811,
              "y": 2.199,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.815,
              "y": 2.438,
              "z": 0.121
            },
            "gtin": "4042600359481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a673f266134273ad5f9f972b",
            "leftCorner": {
              "x": -35.767,
              "y": 2.106,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.768,
              "y": 2.182,
              "z": 0.121
            },
            "gtin": "4042600359481",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78d0",
            "leftCorner": {
              "x": -35.811,
              "y": 2.438,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.815,
              "y": 2.65,
              "z": 0.121
            },
            "gtin": "4042600359450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78d1",
            "leftCorner": {
              "x": -35.815,
              "y": 2.65,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.819,
              "y": 2.862,
              "z": 0.121
            },
            "gtin": "4042600359450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78d2",
            "leftCorner": {
              "x": -35.819,
              "y": 2.862,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.823,
              "y": 3.074,
              "z": 0.121
            },
            "gtin": "4042600359450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78d3",
            "leftCorner": {
              "x": -35.827,
              "y": 3.074,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.835,
              "y": 3.511,
              "z": 0.121
            },
            "gtin": "4042600359559",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d45f",
        "height": 0.53235,
        "facings": [
          {
            "id": "68d8e50de1820c81800d7900",
            "leftCorner": {
              "x": -35.793,
              "y": 2.174,
              "z": 0.436
            },
            "rightCorner": {
              "x": -35.795,
              "y": 2.28,
              "z": 0.436
            },
            "gtin": "4000140700170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7901",
            "leftCorner": {
              "x": -35.795,
              "y": 2.28,
              "z": 0.436
            },
            "rightCorner": {
              "x": -35.797,
              "y": 2.387,
              "z": 0.436
            },
            "gtin": "4000140700170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7902",
            "leftCorner": {
              "x": -35.797,
              "y": 2.387,
              "z": 0.436
            },
            "rightCorner": {
              "x": -35.799,
              "y": 2.493,
              "z": 0.436
            },
            "gtin": "4000140700170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7903",
            "leftCorner": {
              "x": -35.795,
              "y": 2.493,
              "z": 0.436
            },
            "rightCorner": {
              "x": -35.796,
              "y": 2.59,
              "z": 0.436
            },
            "gtin": "4000140714931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7904",
            "leftCorner": {
              "x": -35.796,
              "y": 2.59,
              "z": 0.436
            },
            "rightCorner": {
              "x": -35.798,
              "y": 2.687,
              "z": 0.436
            },
            "gtin": "4000140714931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7905",
            "leftCorner": {
              "x": -35.798,
              "y": 2.687,
              "z": 0.436
            },
            "rightCorner": {
              "x": -35.801,
              "y": 2.783,
              "z": 0.436
            },
            "gtin": "4000140714931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d7906",
            "leftCorner": {
              "x": -35.804,
              "y": 2.783,
              "z": 0.436
            },
            "rightCorner": {
              "x": -35.808,
              "y": 3.011,
              "z": 0.436
            },
            "gtin": "4000140714900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d78fb",
            "leftCorner": {
              "x": -35.808,
              "y": 3.011,
              "z": 0.436
            },
            "rightCorner": {
              "x": -35.815,
              "y": 3.355,
              "z": 0.436
            },
            "gtin": "4000140700149",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d45d",
        "height": 0.9228,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78e8",
            "leftCorner": {
              "x": -35.802,
              "y": 2.168,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.806,
              "y": 2.326,
              "z": 0.755
            },
            "gtin": "5000112626070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78e9",
            "leftCorner": {
              "x": -35.803,
              "y": 2.326,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.808,
              "y": 2.604,
              "z": 0.755
            },
            "gtin": "4000140700637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78ea",
            "leftCorner": {
              "x": -35.808,
              "y": 2.604,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.813,
              "y": 2.882,
              "z": 0.755
            },
            "gtin": "4000140700637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78eb",
            "leftCorner": {
              "x": -35.81,
              "y": 2.882,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.821,
              "y": 3.414,
              "z": 0.755
            },
            "gtin": "4000140713392",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d460",
        "height": 1.3256,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d788f",
            "leftCorner": {
              "x": -35.806,
              "y": 2.163,
              "z": 1.085
            },
            "rightCorner": {
              "x": -35.809,
              "y": 2.351,
              "z": 1.085
            },
            "gtin": "5000112562446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7890",
            "leftCorner": {
              "x": -35.809,
              "y": 2.351,
              "z": 1.085
            },
            "rightCorner": {
              "x": -35.813,
              "y": 2.539,
              "z": 1.085
            },
            "gtin": "5000112562446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7891",
            "leftCorner": {
              "x": -35.806,
              "y": 2.539,
              "z": 1.085
            },
            "rightCorner": {
              "x": -35.81,
              "y": 2.768,
              "z": 1.085
            },
            "gtin": "5000112683004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7892",
            "leftCorner": {
              "x": -36.028,
              "y": 2.764,
              "z": 1.085
            },
            "rightCorner": {
              "x": -36.038,
              "y": 3.269,
              "z": 1.085
            },
            "gtin": "5000112547825",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7893",
            "leftCorner": {
              "x": -35.82,
              "y": 3.273,
              "z": 1.085
            },
            "rightCorner": {
              "x": -35.825,
              "y": 3.504,
              "z": 1.085
            },
            "gtin": "9006900216788",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d45c",
        "height": 1.7259,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78b4",
            "leftCorner": {
              "x": -35.798,
              "y": 2.136,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.801,
              "y": 2.312,
              "z": 1.412
            },
            "gtin": "4260228340128",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78b5",
            "leftCorner": {
              "x": -35.801,
              "y": 2.312,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.805,
              "y": 2.501,
              "z": 1.412
            },
            "gtin": "4102610509723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78b6",
            "leftCorner": {
              "x": -35.802,
              "y": 2.501,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.807,
              "y": 2.777,
              "z": 1.412
            },
            "gtin": "4051454000012",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78b7",
            "leftCorner": {
              "x": -35.81,
              "y": 2.777,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.814,
              "y": 3.023,
              "z": 1.412
            },
            "gtin": "4262505160009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78b8",
            "leftCorner": {
              "x": -35.816,
              "y": 3.023,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.82,
              "y": 3.213,
              "z": 1.412
            },
            "gtin": "4000140721540",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78b9",
            "leftCorner": {
              "x": -35.82,
              "y": 3.213,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.823,
              "y": 3.407,
              "z": 1.412
            },
            "gtin": "4000140721632",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ec0",
    "rightNeighborShelfId": "eb0"
  },
  {
    "id": "ec0",
    "name": "ec0",
    "x": -35.848,
    "y": 0.855,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7139,
      "w": 0.70025
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 30,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d45a",
        "height": 0.15407,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78ca",
            "leftCorner": {
              "x": -35.783,
              "y": 0.919,
              "z": 0.126
            },
            "rightCorner": {
              "x": -35.786,
              "y": 1.058,
              "z": 0.126
            },
            "gtin": "5000112682946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78cb",
            "leftCorner": {
              "x": -35.786,
              "y": 1.058,
              "z": 0.126
            },
            "rightCorner": {
              "x": -35.788,
              "y": 1.198,
              "z": 0.126
            },
            "gtin": "5000112682946",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78cc",
            "leftCorner": {
              "x": -35.786,
              "y": 1.198,
              "z": 0.126
            },
            "rightCorner": {
              "x": -35.794,
              "y": 1.64,
              "z": 0.126
            },
            "gtin": "5000112552218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78cd",
            "leftCorner": {
              "x": -35.798,
              "y": 1.64,
              "z": 0.126
            },
            "rightCorner": {
              "x": -35.804,
              "y": 1.92,
              "z": 0.126
            },
            "gtin": "4042600359689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78ce",
            "leftCorner": {
              "x": -35.804,
              "y": 1.92,
              "z": 0.126
            },
            "rightCorner": {
              "x": -35.809,
              "y": 2.199,
              "z": 0.126
            },
            "gtin": "4042600359689",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d45b",
        "height": 0.53476,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78f9",
            "leftCorner": {
              "x": -35.722,
              "y": 0.857,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.729,
              "y": 1.231,
              "z": 0.438
            },
            "gtin": "4062139025473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78fa",
            "leftCorner": {
              "x": -35.729,
              "y": 1.231,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.736,
              "y": 1.605,
              "z": 0.438
            },
            "gtin": "4062139025473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d78fc",
            "leftCorner": {
              "x": -35.778,
              "y": 1.604,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.783,
              "y": 1.83,
              "z": 0.438
            },
            "gtin": "4062139025435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d78fd",
            "leftCorner": {
              "x": -35.78,
              "y": 1.83,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.782,
              "y": 1.945,
              "z": 0.438
            },
            "gtin": "4000140711947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d78fe",
            "leftCorner": {
              "x": -35.782,
              "y": 1.945,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.784,
              "y": 2.06,
              "z": 0.438
            },
            "gtin": "4000140711947",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50de1820c81800d78ff",
            "leftCorner": {
              "x": -35.784,
              "y": 2.06,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.787,
              "y": 2.175,
              "z": 0.438
            },
            "gtin": "4000140711947",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d459",
        "height": 0.923,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78e3",
            "leftCorner": {
              "x": -35.779,
              "y": 0.91,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.783,
              "y": 1.098,
              "z": 0.755
            },
            "gtin": "5000112547498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78e4",
            "leftCorner": {
              "x": -35.78,
              "y": 1.098,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.782,
              "y": 1.219,
              "z": 0.755
            },
            "gtin": "5000112682960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78e5",
            "leftCorner": {
              "x": -35.782,
              "y": 1.219,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.784,
              "y": 1.34,
              "z": 0.755
            },
            "gtin": "5000112682960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78e6",
            "leftCorner": {
              "x": -35.784,
              "y": 1.34,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.795,
              "y": 1.91,
              "z": 0.755
            },
            "gtin": "5000112547849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78e7",
            "leftCorner": {
              "x": -35.798,
              "y": 1.91,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.803,
              "y": 2.169,
              "z": 0.755
            },
            "gtin": "5000112562439",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d457",
        "height": 1.3255,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7887",
            "leftCorner": {
              "x": -35.785,
              "y": 0.964,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.789,
              "y": 1.127,
              "z": 1.084
            },
            "gtin": "4008287949544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9e413a1e3f45da2900c02193",
            "leftCorner": {
              "x": -35.74,
              "y": 0.857,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.742,
              "y": 0.954,
              "z": 1.084
            },
            "gtin": "4018715002840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7888",
            "leftCorner": {
              "x": -35.789,
              "y": 1.127,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.791,
              "y": 1.29,
              "z": 1.084
            },
            "gtin": "4008287949544",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7889",
            "leftCorner": {
              "x": -35.785,
              "y": 1.29,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.787,
              "y": 1.377,
              "z": 1.084
            },
            "gtin": "4000140702785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d788a",
            "leftCorner": {
              "x": -35.787,
              "y": 1.377,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.789,
              "y": 1.465,
              "z": 1.084
            },
            "gtin": "4000140702785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d788b",
            "leftCorner": {
              "x": -35.791,
              "y": 1.464,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.794,
              "y": 1.661,
              "z": 1.084
            },
            "gtin": "4018715002840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d788c",
            "leftCorner": {
              "x": -35.796,
              "y": 1.661,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.799,
              "y": 1.796,
              "z": 1.084
            },
            "gtin": "4018715004844",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d788d",
            "leftCorner": {
              "x": -35.799,
              "y": 1.796,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.802,
              "y": 1.927,
              "z": 1.084
            },
            "gtin": "4018715002864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d788e",
            "leftCorner": {
              "x": -35.8,
              "y": 1.927,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.805,
              "y": 2.164,
              "z": 1.084
            },
            "gtin": "4018715002833",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d458",
        "height": 1.7277,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78af",
            "leftCorner": {
              "x": -35.778,
              "y": 0.891,
              "z": 1.414
            },
            "rightCorner": {
              "x": -35.782,
              "y": 1.036,
              "z": 1.414
            },
            "gtin": "8050327350014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78b0",
            "leftCorner": {
              "x": -35.779,
              "y": 1.037,
              "z": 1.414
            },
            "rightCorner": {
              "x": -35.783,
              "y": 1.306,
              "z": 1.414
            },
            "gtin": "8050327350007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78b1",
            "leftCorner": {
              "x": -35.783,
              "y": 1.306,
              "z": 1.414
            },
            "rightCorner": {
              "x": -35.787,
              "y": 1.527,
              "z": 1.414
            },
            "gtin": "8050327350021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78b2",
            "leftCorner": {
              "x": -35.792,
              "y": 1.527,
              "z": 1.414
            },
            "rightCorner": {
              "x": -35.798,
              "y": 1.807,
              "z": 1.414
            },
            "gtin": "4000140702501",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78b3",
            "leftCorner": {
              "x": -35.798,
              "y": 1.807,
              "z": 1.414
            },
            "rightCorner": {
              "x": -35.805,
              "y": 2.137,
              "z": 1.414
            },
            "gtin": "4000140702846",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ec1",
    "rightNeighborShelfId": "ebf"
  },
  {
    "id": "ec1",
    "name": "ec1",
    "x": -35.824,
    "y": -0.395,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7139,
      "w": 0.70025
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 46,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d454",
        "height": 0.14837,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78c0",
            "leftCorner": {
              "x": -35.734,
              "y": -0.393,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.737,
              "y": -0.296,
              "z": 0.121
            },
            "gtin": "5000112682977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78c1",
            "leftCorner": {
              "x": -35.737,
              "y": -0.296,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.738,
              "y": -0.199,
              "z": 0.121
            },
            "gtin": "5000112682977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78c2",
            "leftCorner": {
              "x": -35.738,
              "y": -0.199,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.74,
              "y": -0.103,
              "z": 0.121
            },
            "gtin": "5000112682977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78c3",
            "leftCorner": {
              "x": -35.74,
              "y": -0.103,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.742,
              "y": -0.006,
              "z": 0.121
            },
            "gtin": "5000112682977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78c7",
            "leftCorner": {
              "x": -35.779,
              "y": -0.006,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.785,
              "y": 0.302,
              "z": 0.121
            },
            "gtin": "5000112547412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78c8",
            "leftCorner": {
              "x": -35.785,
              "y": 0.302,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.791,
              "y": 0.611,
              "z": 0.121
            },
            "gtin": "5000112547412",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78c9",
            "leftCorner": {
              "x": -35.791,
              "y": 0.611,
              "z": 0.121
            },
            "rightCorner": {
              "x": -35.797,
              "y": 0.919,
              "z": 0.121
            },
            "gtin": "5000112547412",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d456",
        "height": 0.52153,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78f2",
            "leftCorner": {
              "x": -35.728,
              "y": -0.393,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.731,
              "y": -0.255,
              "z": 0.427
            },
            "gtin": "5000112547788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78f3",
            "leftCorner": {
              "x": -35.731,
              "y": -0.255,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.734,
              "y": -0.118,
              "z": 0.427
            },
            "gtin": "5000112547788",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78f5",
            "leftCorner": {
              "x": -35.777,
              "y": -0.119,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.779,
              "y": -0.03,
              "z": 0.427
            },
            "gtin": "4062139025848",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78f6",
            "leftCorner": {
              "x": -35.777,
              "y": -0.029,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.779,
              "y": 0.092,
              "z": 0.427
            },
            "gtin": "4062139002214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78f7",
            "leftCorner": {
              "x": -35.777,
              "y": 0.092,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.78,
              "y": 0.272,
              "z": 0.427
            },
            "gtin": "4060800150677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78f8",
            "leftCorner": {
              "x": -35.774,
              "y": 0.272,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.784,
              "y": 0.771,
              "z": 0.427
            },
            "gtin": "4062139025251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78f4",
            "leftCorner": {
              "x": -35.783,
              "y": 0.771,
              "z": 0.427
            },
            "rightCorner": {
              "x": -35.784,
              "y": 0.856,
              "z": 0.427
            },
            "gtin": "4062139025299",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d455",
        "height": 0.92218,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d78dc",
            "leftCorner": {
              "x": -35.728,
              "y": -0.393,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.732,
              "y": -0.173,
              "z": 0.755
            },
            "gtin": "5000112594041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78dd",
            "leftCorner": {
              "x": -35.732,
              "y": -0.173,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.736,
              "y": 0.047,
              "z": 0.755
            },
            "gtin": "5000112594041",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78df",
            "leftCorner": {
              "x": -35.78,
              "y": 0.046,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.783,
              "y": 0.184,
              "z": 0.755
            },
            "gtin": "5000112683028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78e0",
            "leftCorner": {
              "x": -35.783,
              "y": 0.184,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.785,
              "y": 0.321,
              "z": 0.755
            },
            "gtin": "5000112683028",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78e1",
            "leftCorner": {
              "x": -35.777,
              "y": 0.321,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.785,
              "y": 0.731,
              "z": 0.755
            },
            "gtin": "5000112547801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78e2",
            "leftCorner": {
              "x": -35.781,
              "y": 0.731,
              "z": 0.755
            },
            "rightCorner": {
              "x": -35.785,
              "y": 0.909,
              "z": 0.755
            },
            "gtin": "5000112562453",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d452",
        "height": 1.3253,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d787b",
            "leftCorner": {
              "x": -35.734,
              "y": -0.393,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.735,
              "y": -0.28,
              "z": 1.084
            },
            "gtin": "4066600103448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d787c",
            "leftCorner": {
              "x": -35.735,
              "y": -0.28,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.738,
              "y": -0.166,
              "z": 1.084
            },
            "gtin": "4066600103448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d787d",
            "leftCorner": {
              "x": -35.738,
              "y": -0.166,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.74,
              "y": -0.052,
              "z": 1.084
            },
            "gtin": "4066600103448",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7880",
            "leftCorner": {
              "x": -35.781,
              "y": -0.053,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.786,
              "y": 0.199,
              "z": 1.084
            },
            "gtin": "4066600204435",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7881",
            "leftCorner": {
              "x": -35.785,
              "y": 0.199,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.787,
              "y": 0.291,
              "z": 1.084
            },
            "gtin": "4066600300458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7882",
            "leftCorner": {
              "x": -35.787,
              "y": 0.291,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.788,
              "y": 0.383,
              "z": 1.084
            },
            "gtin": "4066600300458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7883",
            "leftCorner": {
              "x": -35.788,
              "y": 0.383,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.79,
              "y": 0.474,
              "z": 1.084
            },
            "gtin": "4066600300458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7884",
            "leftCorner": {
              "x": -35.782,
              "y": 0.474,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.788,
              "y": 0.766,
              "z": 1.084
            },
            "gtin": "4066600203735",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7885",
            "leftCorner": {
              "x": -35.788,
              "y": 0.766,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.789,
              "y": 0.865,
              "z": 1.084
            },
            "gtin": "4066600203834",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7886",
            "leftCorner": {
              "x": -35.789,
              "y": 0.865,
              "z": 1.084
            },
            "rightCorner": {
              "x": -35.791,
              "y": 0.964,
              "z": 1.084
            },
            "gtin": "4066600203834",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d453",
        "height": 1.7244,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d789b",
            "leftCorner": {
              "x": -35.726,
              "y": -0.393,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.726,
              "y": -0.36,
              "z": 1.411
            },
            "gtin": "4004019073068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d789c",
            "leftCorner": {
              "x": -35.726,
              "y": -0.36,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.727,
              "y": -0.328,
              "z": 1.411
            },
            "gtin": "4004019073068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d789d",
            "leftCorner": {
              "x": -35.727,
              "y": -0.328,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.728,
              "y": -0.295,
              "z": 1.411
            },
            "gtin": "4004019073068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d789e",
            "leftCorner": {
              "x": -35.728,
              "y": -0.295,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.728,
              "y": -0.263,
              "z": 1.411
            },
            "gtin": "4004019073068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d789f",
            "leftCorner": {
              "x": -35.728,
              "y": -0.263,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.729,
              "y": -0.23,
              "z": 1.411
            },
            "gtin": "4004019073068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78a0",
            "leftCorner": {
              "x": -35.729,
              "y": -0.23,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.73,
              "y": -0.198,
              "z": 1.411
            },
            "gtin": "4004019073068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78a1",
            "leftCorner": {
              "x": -35.73,
              "y": -0.198,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.731,
              "y": -0.165,
              "z": 1.411
            },
            "gtin": "4004019073068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78a2",
            "leftCorner": {
              "x": -35.731,
              "y": -0.165,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.731,
              "y": -0.132,
              "z": 1.411
            },
            "gtin": "4004019073068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78a5",
            "leftCorner": {
              "x": -35.779,
              "y": -0.133,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.782,
              "y": -0.029,
              "z": 1.411
            },
            "gtin": "4260231227676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78a6",
            "leftCorner": {
              "x": -35.782,
              "y": -0.029,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.785,
              "y": 0.104,
              "z": 1.411
            },
            "gtin": "4260231227850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78a7",
            "leftCorner": {
              "x": -35.779,
              "y": 0.104,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.78,
              "y": 0.189,
              "z": 1.411
            },
            "gtin": "4260231222725",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d78a8",
            "leftCorner": {
              "x": -35.777,
              "y": 0.189,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.779,
              "y": 0.275,
              "z": 1.411
            },
            "gtin": "4260231223258",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d78a9",
            "leftCorner": {
              "x": -35.778,
              "y": 0.275,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.779,
              "y": 0.327,
              "z": 1.411
            },
            "gtin": "4260231220202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78aa",
            "leftCorner": {
              "x": -35.779,
              "y": 0.327,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.781,
              "y": 0.379,
              "z": 1.411
            },
            "gtin": "4260231220202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78ab",
            "leftCorner": {
              "x": -35.781,
              "y": 0.379,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.782,
              "y": 0.43,
              "z": 1.411
            },
            "gtin": "4260231220202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78ac",
            "leftCorner": {
              "x": -35.781,
              "y": 0.43,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.783,
              "y": 0.584,
              "z": 1.411
            },
            "gtin": "4260231224958",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78ad",
            "leftCorner": {
              "x": -35.782,
              "y": 0.584,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.784,
              "y": 0.716,
              "z": 1.411
            },
            "gtin": "4260231220578",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d78ae",
            "leftCorner": {
              "x": -35.784,
              "y": 0.716,
              "z": 1.411
            },
            "rightCorner": {
              "x": -35.788,
              "y": 0.891,
              "z": 1.411
            },
            "gtin": "4260231227553",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ec2",
    "rightNeighborShelfId": "ec0"
  },
  {
    "id": "ec2",
    "name": "ec2",
    "x": -35.816,
    "y": -1.651,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.7061,
      "w": 0.70811
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 8,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d451",
        "height": 1.6845,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7873",
            "leftCorner": {
              "x": -35.724,
              "y": -1.651,
              "z": 1.378
            },
            "rightCorner": {
              "x": -35.724,
              "y": -1.582,
              "z": 1.378
            },
            "gtin": "5000112547726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7875",
            "leftCorner": {
              "x": -35.767,
              "y": -1.582,
              "z": 1.378
            },
            "rightCorner": {
              "x": -35.765,
              "y": -1.324,
              "z": 1.378
            },
            "gtin": "9002490278984",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7876",
            "leftCorner": {
              "x": -35.769,
              "y": -1.324,
              "z": 1.378
            },
            "rightCorner": {
              "x": -35.77,
              "y": -1.091,
              "z": 1.378
            },
            "gtin": "9002490278960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7877",
            "leftCorner": {
              "x": -35.77,
              "y": -1.091,
              "z": 1.378
            },
            "rightCorner": {
              "x": -35.769,
              "y": -0.949,
              "z": 1.378
            },
            "gtin": "9002490278953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7878",
            "leftCorner": {
              "x": -35.761,
              "y": -0.949,
              "z": 1.378
            },
            "rightCorner": {
              "x": -35.761,
              "y": -0.852,
              "z": 1.378
            },
            "gtin": "5000112552195",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7879",
            "leftCorner": {
              "x": -35.769,
              "y": -0.852,
              "z": 1.378
            },
            "rightCorner": {
              "x": -35.768,
              "y": -0.613,
              "z": 1.378
            },
            "gtin": "9002490278977",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d787a",
            "leftCorner": {
              "x": -35.763,
              "y": -0.613,
              "z": 1.378
            },
            "rightCorner": {
              "x": -35.762,
              "y": -0.481,
              "z": 1.378
            },
            "gtin": "4004019073013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7874",
            "leftCorner": {
              "x": -35.763,
              "y": -0.481,
              "z": 1.378
            },
            "rightCorner": {
              "x": -35.763,
              "y": -0.401,
              "z": 1.378
            },
            "gtin": "4004019073051",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ec3",
    "rightNeighborShelfId": "ec1"
  },
  {
    "id": "ec3",
    "name": "ec3",
    "x": -35.812,
    "y": -2.902,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70723,
      "w": 0.70698
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 34,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d44d",
        "height": 0.14907,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d784c",
            "leftCorner": {
              "x": -35.745,
              "y": -2.773,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.745,
              "y": -2.634,
              "z": 0.122
            },
            "gtin": "5065015569060",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d784d",
            "leftCorner": {
              "x": -35.748,
              "y": -2.634,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.748,
              "y": -2.519,
              "z": 0.122
            },
            "gtin": "5065015569022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d784e",
            "leftCorner": {
              "x": -35.753,
              "y": -2.519,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.753,
              "y": -2.362,
              "z": 0.122
            },
            "gtin": "5065015569084",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d784f",
            "leftCorner": {
              "x": -35.759,
              "y": -2.362,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.759,
              "y": -2.009,
              "z": 0.122
            },
            "gtin": "5000112612288",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7850",
            "leftCorner": {
              "x": -35.768,
              "y": -2.009,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.768,
              "y": -1.861,
              "z": 0.122
            },
            "gtin": "5449000302403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7835",
            "leftCorner": {
              "x": -35.77,
              "y": -1.861,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.771,
              "y": -1.652,
              "z": 0.122
            },
            "gtin": "5449000292810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "627a7398947631c531f79f44",
            "leftCorner": {
              "x": -35.716,
              "y": -2.902,
              "z": 0.122
            },
            "rightCorner": {
              "x": -35.716,
              "y": -2.787,
              "z": 0.122
            },
            "gtin": "5065015569022",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d44e",
        "height": 0.47414,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7867",
            "leftCorner": {
              "x": -35.715,
              "y": -2.902,
              "z": 0.388
            },
            "rightCorner": {
              "x": -35.715,
              "y": -2.672,
              "z": 0.388
            },
            "gtin": "5000112548204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7869",
            "leftCorner": {
              "x": -35.745,
              "y": -2.672,
              "z": 0.388
            },
            "rightCorner": {
              "x": -35.745,
              "y": -2.554,
              "z": 0.388
            },
            "gtin": "4260231226549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d786a",
            "leftCorner": {
              "x": -35.749,
              "y": -2.554,
              "z": 0.388
            },
            "rightCorner": {
              "x": -35.749,
              "y": -2.343,
              "z": 0.388
            },
            "gtin": "5000112639407",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d786b",
            "leftCorner": {
              "x": -35.756,
              "y": -2.343,
              "z": 0.388
            },
            "rightCorner": {
              "x": -35.756,
              "y": -2.043,
              "z": 0.388
            },
            "gtin": "5000112548167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d786c",
            "leftCorner": {
              "x": -35.763,
              "y": -2.043,
              "z": 0.388
            },
            "rightCorner": {
              "x": -35.763,
              "y": -1.825,
              "z": 0.388
            },
            "gtin": "5000112548129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7868",
            "leftCorner": {
              "x": -35.769,
              "y": -1.825,
              "z": 0.388
            },
            "rightCorner": {
              "x": -35.769,
              "y": -1.652,
              "z": 0.388
            },
            "gtin": "87222388",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d44f",
        "height": 0.79946,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d786d",
            "leftCorner": {
              "x": -35.718,
              "y": -2.902,
              "z": 0.654
            },
            "rightCorner": {
              "x": -35.718,
              "y": -2.728,
              "z": 0.654
            },
            "gtin": "5000112552232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d786e",
            "leftCorner": {
              "x": -35.718,
              "y": -2.728,
              "z": 0.654
            },
            "rightCorner": {
              "x": -35.718,
              "y": -2.554,
              "z": 0.654
            },
            "gtin": "5000112552232",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7870",
            "leftCorner": {
              "x": -35.748,
              "y": -2.554,
              "z": 0.654
            },
            "rightCorner": {
              "x": -35.748,
              "y": -2.355,
              "z": 0.654
            },
            "gtin": "5000112548082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7871",
            "leftCorner": {
              "x": -35.754,
              "y": -2.355,
              "z": 0.654
            },
            "rightCorner": {
              "x": -35.754,
              "y": -2.124,
              "z": 0.654
            },
            "gtin": "90370960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7872",
            "leftCorner": {
              "x": -35.764,
              "y": -2.123,
              "z": 0.654
            },
            "rightCorner": {
              "x": -35.764,
              "y": -1.911,
              "z": 0.654
            },
            "gtin": "54493438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d786f",
            "leftCorner": {
              "x": -35.762,
              "y": -1.911,
              "z": 0.654
            },
            "rightCorner": {
              "x": -35.762,
              "y": -1.652,
              "z": 0.654
            },
            "gtin": "5000112548068",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d44a",
        "height": 1.1511,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7862",
            "leftCorner": {
              "x": -35.715,
              "y": -2.902,
              "z": 0.942
            },
            "rightCorner": {
              "x": -35.714,
              "y": -2.613,
              "z": 0.942
            },
            "gtin": "5000112602029",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d7864",
            "leftCorner": {
              "x": -35.744,
              "y": -2.613,
              "z": 0.942
            },
            "rightCorner": {
              "x": -35.745,
              "y": -2.396,
              "z": 0.942
            },
            "gtin": "5000112604450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7865",
            "leftCorner": {
              "x": -35.751,
              "y": -2.396,
              "z": 0.942
            },
            "rightCorner": {
              "x": -35.752,
              "y": -2.128,
              "z": 0.942
            },
            "gtin": "5000112604627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7866",
            "leftCorner": {
              "x": -35.759,
              "y": -2.128,
              "z": 0.942
            },
            "rightCorner": {
              "x": -35.759,
              "y": -1.904,
              "z": 0.942
            },
            "gtin": "5000112682205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7863",
            "leftCorner": {
              "x": -35.76,
              "y": -1.904,
              "z": 0.942
            },
            "rightCorner": {
              "x": -35.76,
              "y": -1.652,
              "z": 0.942
            },
            "gtin": "5000112604467",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d44c",
        "height": 1.4293,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7830",
            "leftCorner": {
              "x": -35.73,
              "y": -2.868,
              "z": 1.169
            },
            "rightCorner": {
              "x": -35.73,
              "y": -2.589,
              "z": 1.169
            },
            "gtin": "5000112604696",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7831",
            "leftCorner": {
              "x": -35.738,
              "y": -2.589,
              "z": 1.169
            },
            "rightCorner": {
              "x": -35.739,
              "y": -2.335,
              "z": 1.169
            },
            "gtin": "5000112604726",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7832",
            "leftCorner": {
              "x": -35.748,
              "y": -2.335,
              "z": 1.169
            },
            "rightCorner": {
              "x": -35.749,
              "y": -2.128,
              "z": 1.169
            },
            "gtin": "5000112668766",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7833",
            "leftCorner": {
              "x": -35.752,
              "y": -2.128,
              "z": 1.169
            },
            "rightCorner": {
              "x": -35.752,
              "y": -1.861,
              "z": 1.169
            },
            "gtin": "5000112672077",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ce1820c81800d7823",
            "leftCorner": {
              "x": -35.754,
              "y": -1.861,
              "z": 1.169
            },
            "rightCorner": {
              "x": -35.754,
              "y": -1.652,
              "z": 1.169
            },
            "gtin": "5000112514124",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d44b",
        "height": 1.7261,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d781b",
            "leftCorner": {
              "x": -35.733,
              "y": -2.846,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.734,
              "y": -2.767,
              "z": 1.412
            },
            "gtin": "5056784901359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d781c",
            "leftCorner": {
              "x": -35.734,
              "y": -2.767,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.734,
              "y": -2.688,
              "z": 1.412
            },
            "gtin": "5056784901359",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d781d",
            "leftCorner": {
              "x": -35.731,
              "y": -2.688,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.731,
              "y": -2.462,
              "z": 1.412
            },
            "gtin": "5449000247872",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d781e",
            "leftCorner": {
              "x": -35.743,
              "y": -2.462,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.743,
              "y": -2.197,
              "z": 1.412
            },
            "gtin": "5000112680546",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d781f",
            "leftCorner": {
              "x": -35.752,
              "y": -2.197,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.752,
              "y": -2.032,
              "z": 1.412
            },
            "gtin": "5000112510379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7820",
            "leftCorner": {
              "x": -35.752,
              "y": -2.032,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.752,
              "y": -1.792,
              "z": 1.412
            },
            "gtin": "5000112636420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7810",
            "leftCorner": {
              "x": -35.758,
              "y": -1.792,
              "z": 1.412
            },
            "rightCorner": {
              "x": -35.758,
              "y": -1.652,
              "z": 1.412
            },
            "gtin": "5000112604740",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ec6",
    "rightNeighborShelfId": "ec2"
  },
  {
    "id": "ec6",
    "name": "ec6",
    "x": -35.811,
    "y": -4.152,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70723,
      "w": 0.70698
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 48,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6d4",
        "height": 0.15051,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d783d",
            "leftCorner": {
              "x": -35.763,
              "y": -4.1,
              "z": 0.123
            },
            "rightCorner": {
              "x": -35.763,
              "y": -4.018,
              "z": 0.123
            },
            "gtin": "8722200963511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e561c1b06475e5b90fe2a325",
            "leftCorner": {
              "x": -35.725,
              "y": -3.276,
              "z": 0.123
            },
            "rightCorner": {
              "x": -35.725,
              "y": -3.125,
              "z": 0.123
            },
            "gtin": "4100060040711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2e9ff8b10bcd906feb99990a",
            "leftCorner": {
              "x": -35.725,
              "y": -3.125,
              "z": 0.123
            },
            "rightCorner": {
              "x": -35.725,
              "y": -3.003,
              "z": 0.123
            },
            "gtin": "4100060040650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d783e",
            "leftCorner": {
              "x": -35.763,
              "y": -4.018,
              "z": 0.123
            },
            "rightCorner": {
              "x": -35.763,
              "y": -3.937,
              "z": 0.123
            },
            "gtin": "8722200963511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d783f",
            "leftCorner": {
              "x": -35.763,
              "y": -3.937,
              "z": 0.123
            },
            "rightCorner": {
              "x": -35.764,
              "y": -3.856,
              "z": 0.123
            },
            "gtin": "8722200963511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7840",
            "leftCorner": {
              "x": -35.764,
              "y": -3.856,
              "z": 0.123
            },
            "rightCorner": {
              "x": -35.764,
              "y": -3.774,
              "z": 0.123
            },
            "gtin": "8722200963511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7841",
            "leftCorner": {
              "x": -35.764,
              "y": -3.774,
              "z": 0.123
            },
            "rightCorner": {
              "x": -35.764,
              "y": -3.693,
              "z": 0.123
            },
            "gtin": "8722200963511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7842",
            "leftCorner": {
              "x": -35.765,
              "y": -3.693,
              "z": 0.123
            },
            "rightCorner": {
              "x": -35.764,
              "y": -3.569,
              "z": 0.123
            },
            "gtin": "4100060040650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7843",
            "leftCorner": {
              "x": -35.765,
              "y": -3.569,
              "z": 0.123
            },
            "rightCorner": {
              "x": -35.765,
              "y": -3.48,
              "z": 0.123
            },
            "gtin": "4100060040681",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7844",
            "leftCorner": {
              "x": -35.765,
              "y": -3.48,
              "z": 0.123
            },
            "rightCorner": {
              "x": -35.766,
              "y": -3.394,
              "z": 0.123
            },
            "gtin": "4100060040629",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7845",
            "leftCorner": {
              "x": -35.764,
              "y": -3.394,
              "z": 0.123
            },
            "rightCorner": {
              "x": -35.764,
              "y": -3.276,
              "z": 0.123
            },
            "gtin": "4100060040711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d784b",
            "leftCorner": {
              "x": -35.774,
              "y": -2.994,
              "z": 0.123
            },
            "rightCorner": {
              "x": -35.774,
              "y": -2.773,
              "z": 0.123
            },
            "gtin": "4102610507422",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6d2",
        "height": 0.52624,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7859",
            "leftCorner": {
              "x": -35.761,
              "y": -4.12,
              "z": 0.431
            },
            "rightCorner": {
              "x": -35.761,
              "y": -4.03,
              "z": 0.431
            },
            "gtin": "90357367",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d785a",
            "leftCorner": {
              "x": -35.761,
              "y": -4.03,
              "z": 0.431
            },
            "rightCorner": {
              "x": -35.76,
              "y": -3.931,
              "z": 0.431
            },
            "gtin": "5000112681994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d785b",
            "leftCorner": {
              "x": -35.756,
              "y": -3.931,
              "z": 0.431
            },
            "rightCorner": {
              "x": -35.756,
              "y": -3.832,
              "z": 0.431
            },
            "gtin": "5000112512656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d785c",
            "leftCorner": {
              "x": -35.758,
              "y": -3.832,
              "z": 0.431
            },
            "rightCorner": {
              "x": -35.758,
              "y": -3.76,
              "z": 0.431
            },
            "gtin": "54013933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d785d",
            "leftCorner": {
              "x": -35.758,
              "y": -3.76,
              "z": 0.431
            },
            "rightCorner": {
              "x": -35.759,
              "y": -3.689,
              "z": 0.431
            },
            "gtin": "54013933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d785e",
            "leftCorner": {
              "x": -35.764,
              "y": -3.689,
              "z": 0.431
            },
            "rightCorner": {
              "x": -35.763,
              "y": -3.548,
              "z": 0.431
            },
            "gtin": "5000112673555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d785f",
            "leftCorner": {
              "x": -35.762,
              "y": -3.548,
              "z": 0.431
            },
            "rightCorner": {
              "x": -35.762,
              "y": -3.324,
              "z": 0.431
            },
            "gtin": "90357350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7860",
            "leftCorner": {
              "x": -35.765,
              "y": -3.324,
              "z": 0.431
            },
            "rightCorner": {
              "x": -35.766,
              "y": -3.206,
              "z": 0.431
            },
            "gtin": "42469162",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7861",
            "leftCorner": {
              "x": -35.766,
              "y": -3.206,
              "z": 0.431
            },
            "rightCorner": {
              "x": -35.766,
              "y": -3.013,
              "z": 0.431
            },
            "gtin": "8722200964938",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7852",
            "leftCorner": {
              "x": -35.773,
              "y": -3.013,
              "z": 0.431
            },
            "rightCorner": {
              "x": -35.772,
              "y": -2.902,
              "z": 0.431
            },
            "gtin": "87222050",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6d0",
        "height": 0.82809,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77fd",
            "leftCorner": {
              "x": -35.76,
              "y": -4.112,
              "z": 0.678
            },
            "rightCorner": {
              "x": -35.759,
              "y": -3.935,
              "z": 0.678
            },
            "gtin": "4062139004454",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77fe",
            "leftCorner": {
              "x": -35.757,
              "y": -3.935,
              "z": 0.678
            },
            "rightCorner": {
              "x": -35.758,
              "y": -3.736,
              "z": 0.678
            },
            "gtin": "4060800160126",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77ff",
            "leftCorner": {
              "x": -35.759,
              "y": -3.736,
              "z": 0.678
            },
            "rightCorner": {
              "x": -35.759,
              "y": -3.545,
              "z": 0.678
            },
            "gtin": "5061013944809",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7800",
            "leftCorner": {
              "x": -35.761,
              "y": -3.545,
              "z": 0.678
            },
            "rightCorner": {
              "x": -35.76,
              "y": -3.326,
              "z": 0.678
            },
            "gtin": "5060896625829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7801",
            "leftCorner": {
              "x": -35.763,
              "y": -3.326,
              "z": 0.678
            },
            "rightCorner": {
              "x": -35.763,
              "y": -3.207,
              "z": 0.678
            },
            "gtin": "5060751216520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7802",
            "leftCorner": {
              "x": -35.763,
              "y": -3.207,
              "z": 0.678
            },
            "rightCorner": {
              "x": -35.763,
              "y": -3.087,
              "z": 0.678
            },
            "gtin": "5060751216520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77f8",
            "leftCorner": {
              "x": -35.769,
              "y": -3.088,
              "z": 0.678
            },
            "rightCorner": {
              "x": -35.769,
              "y": -2.902,
              "z": 0.678
            },
            "gtin": "5060639126682",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6d3",
        "height": 1.1308,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d780a",
            "leftCorner": {
              "x": -35.764,
              "y": -4.121,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.763,
              "y": -3.911,
              "z": 0.925
            },
            "gtin": "5060335635242",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d780b",
            "leftCorner": {
              "x": -35.763,
              "y": -3.911,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.762,
              "y": -3.769,
              "z": 0.925
            },
            "gtin": "5060751212393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d780c",
            "leftCorner": {
              "x": -35.762,
              "y": -3.769,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.763,
              "y": -3.627,
              "z": 0.925
            },
            "gtin": "5060751212393",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d780d",
            "leftCorner": {
              "x": -35.762,
              "y": -3.627,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.762,
              "y": -3.426,
              "z": 0.925
            },
            "gtin": "5060335635235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d780e",
            "leftCorner": {
              "x": -35.759,
              "y": -3.426,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.76,
              "y": -3.145,
              "z": 0.925
            },
            "gtin": "4250616685351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7804",
            "leftCorner": {
              "x": -35.767,
              "y": -3.145,
              "z": 0.925
            },
            "rightCorner": {
              "x": -35.767,
              "y": -2.902,
              "z": 0.925
            },
            "gtin": "4250616685320",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6d1",
        "height": 1.4342,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7829",
            "leftCorner": {
              "x": -35.758,
              "y": -4.12,
              "z": 1.173
            },
            "rightCorner": {
              "x": -35.758,
              "y": -3.99,
              "z": 1.173
            },
            "gtin": "5060517888510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d782a",
            "leftCorner": {
              "x": -35.758,
              "y": -3.99,
              "z": 1.173
            },
            "rightCorner": {
              "x": -35.758,
              "y": -3.86,
              "z": 1.173
            },
            "gtin": "5060517888510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d782b",
            "leftCorner": {
              "x": -35.756,
              "y": -3.86,
              "z": 1.173
            },
            "rightCorner": {
              "x": -35.756,
              "y": -3.657,
              "z": 1.173
            },
            "gtin": "5056784902264",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d782c",
            "leftCorner": {
              "x": -35.758,
              "y": -3.657,
              "z": 1.173
            },
            "rightCorner": {
              "x": -35.758,
              "y": -3.458,
              "z": 1.173
            },
            "gtin": "5060751212249",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d782d",
            "leftCorner": {
              "x": -35.754,
              "y": -3.458,
              "z": 1.173
            },
            "rightCorner": {
              "x": -35.754,
              "y": -3.272,
              "z": 1.173
            },
            "gtin": "5060639126897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d782e",
            "leftCorner": {
              "x": -35.758,
              "y": -3.272,
              "z": 1.173
            },
            "rightCorner": {
              "x": -35.758,
              "y": -3.045,
              "z": 1.173
            },
            "gtin": "5060947541153",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d782f",
            "leftCorner": {
              "x": -35.764,
              "y": -3.045,
              "z": 1.173
            },
            "rightCorner": {
              "x": -35.764,
              "y": -2.868,
              "z": 1.173
            },
            "gtin": "5061013941815",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6cf",
        "height": 1.7299,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7816",
            "leftCorner": {
              "x": -35.758,
              "y": -3.978,
              "z": 1.415
            },
            "rightCorner": {
              "x": -35.759,
              "y": -3.77,
              "z": 1.415
            },
            "gtin": "90415296",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2c01ba7533a6010ed97f256d",
            "leftCorner": {
              "x": -35.718,
              "y": -4.152,
              "z": 1.415
            },
            "rightCorner": {
              "x": -35.718,
              "y": -4.004,
              "z": 1.415
            },
            "gtin": "5060947549555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7817",
            "leftCorner": {
              "x": -35.758,
              "y": -3.77,
              "z": 1.415
            },
            "rightCorner": {
              "x": -35.758,
              "y": -3.527,
              "z": 1.415
            },
            "gtin": "4260231227911",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7818",
            "leftCorner": {
              "x": -35.757,
              "y": -3.527,
              "z": 1.415
            },
            "rightCorner": {
              "x": -35.757,
              "y": -3.26,
              "z": 1.415
            },
            "gtin": "5060335635228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7819",
            "leftCorner": {
              "x": -35.761,
              "y": -3.26,
              "z": 1.415
            },
            "rightCorner": {
              "x": -35.761,
              "y": -3.061,
              "z": 1.415
            },
            "gtin": "5060947549555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d781a",
            "leftCorner": {
              "x": -35.767,
              "y": -3.061,
              "z": 1.415
            },
            "rightCorner": {
              "x": -35.768,
              "y": -2.846,
              "z": 1.415
            },
            "gtin": "5060337500401",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ec8",
    "rightNeighborShelfId": "ec3"
  },
  {
    "id": "ec8",
    "name": "ec8",
    "x": -35.811,
    "y": -5.402,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70723,
      "w": 0.70698
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 41,
      "shelfCategory": "BEVERAGES"
    },
    "layers": [
      {
        "id": "68d8d40155f889d41539d448",
        "height": 0.15126,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7834",
            "leftCorner": {
              "x": -35.731,
              "y": -5.402,
              "z": 0.124
            },
            "rightCorner": {
              "x": -35.731,
              "y": -5.298,
              "z": 0.124
            },
            "gtin": "2000439121695",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7836",
            "leftCorner": {
              "x": -35.772,
              "y": -5.298,
              "z": 0.124
            },
            "rightCorner": {
              "x": -35.772,
              "y": -5.207,
              "z": 0.124
            },
            "gtin": "4306188242284",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7837",
            "leftCorner": {
              "x": -35.772,
              "y": -5.207,
              "z": 0.124
            },
            "rightCorner": {
              "x": -35.772,
              "y": -5.113,
              "z": 0.124
            },
            "gtin": "4306188037453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7838",
            "leftCorner": {
              "x": -35.771,
              "y": -5.113,
              "z": 0.124
            },
            "rightCorner": {
              "x": -35.77,
              "y": -4.725,
              "z": 0.124
            },
            "gtin": "4306188351139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7839",
            "leftCorner": {
              "x": -35.772,
              "y": -4.725,
              "z": 0.124
            },
            "rightCorner": {
              "x": -35.772,
              "y": -4.589,
              "z": 0.124
            },
            "gtin": "8722200965935",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d783a",
            "leftCorner": {
              "x": -35.767,
              "y": -4.589,
              "z": 0.124
            },
            "rightCorner": {
              "x": -35.767,
              "y": -4.438,
              "z": 0.124
            },
            "gtin": "4002846005009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d783b",
            "leftCorner": {
              "x": -35.767,
              "y": -4.438,
              "z": 0.124
            },
            "rightCorner": {
              "x": -35.767,
              "y": -4.287,
              "z": 0.124
            },
            "gtin": "4002846005009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d783c",
            "leftCorner": {
              "x": -35.77,
              "y": -4.287,
              "z": 0.124
            },
            "rightCorner": {
              "x": -35.77,
              "y": -4.1,
              "z": 0.124
            },
            "gtin": "4002846903886",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d449",
        "height": 0.53565,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7851",
            "leftCorner": {
              "x": -35.717,
              "y": -5.402,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.717,
              "y": -5.154,
              "z": 0.438
            },
            "gtin": "4021155100564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7853",
            "leftCorner": {
              "x": -35.76,
              "y": -5.154,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.76,
              "y": -4.908,
              "z": 0.438
            },
            "gtin": "4021155202299",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7854",
            "leftCorner": {
              "x": -35.76,
              "y": -4.908,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.76,
              "y": -4.718,
              "z": 0.438
            },
            "gtin": "4021155160230",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7855",
            "leftCorner": {
              "x": -35.757,
              "y": -4.718,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.757,
              "y": -4.525,
              "z": 0.438
            },
            "gtin": "4021155160179",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7856",
            "leftCorner": {
              "x": -35.754,
              "y": -4.525,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.753,
              "y": -4.361,
              "z": 0.438
            },
            "gtin": "4003840001707",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7857",
            "leftCorner": {
              "x": -35.756,
              "y": -4.361,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.757,
              "y": -4.24,
              "z": 0.438
            },
            "gtin": "4260228340968",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7858",
            "leftCorner": {
              "x": -35.757,
              "y": -4.24,
              "z": 0.438
            },
            "rightCorner": {
              "x": -35.756,
              "y": -4.12,
              "z": 0.438
            },
            "gtin": "4260228340968",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d444",
        "height": 0.82502,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d77f5",
            "leftCorner": {
              "x": -35.731,
              "y": -5.402,
              "z": 0.675
            },
            "rightCorner": {
              "x": -35.731,
              "y": -5.304,
              "z": 0.675
            },
            "gtin": "4260456730388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77f6",
            "leftCorner": {
              "x": -35.731,
              "y": -5.304,
              "z": 0.675
            },
            "rightCorner": {
              "x": -35.731,
              "y": -5.205,
              "z": 0.675
            },
            "gtin": "4260456730388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77f7",
            "leftCorner": {
              "x": -35.731,
              "y": -5.205,
              "z": 0.675
            },
            "rightCorner": {
              "x": -35.73,
              "y": -5.107,
              "z": 0.675
            },
            "gtin": "4260456730388",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77f9",
            "leftCorner": {
              "x": -35.771,
              "y": -5.107,
              "z": 0.675
            },
            "rightCorner": {
              "x": -35.772,
              "y": -4.836,
              "z": 0.675
            },
            "gtin": "4260456730395",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77fa",
            "leftCorner": {
              "x": -35.772,
              "y": -4.836,
              "z": 0.675
            },
            "rightCorner": {
              "x": -35.772,
              "y": -4.575,
              "z": 0.675
            },
            "gtin": "4025127020997",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77fb",
            "leftCorner": {
              "x": -35.77,
              "y": -4.575,
              "z": 0.675
            },
            "rightCorner": {
              "x": -35.77,
              "y": -4.356,
              "z": 0.675
            },
            "gtin": "4025127020683",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d77fc",
            "leftCorner": {
              "x": -35.77,
              "y": -4.356,
              "z": 0.675
            },
            "rightCorner": {
              "x": -35.77,
              "y": -4.112,
              "z": 0.675
            },
            "gtin": "4260160950010",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d445",
        "height": 1.1277,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7803",
            "leftCorner": {
              "x": -35.731,
              "y": -5.402,
              "z": 0.923
            },
            "rightCorner": {
              "x": -35.731,
              "y": -5.175,
              "z": 0.923
            },
            "gtin": "90456220",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7805",
            "leftCorner": {
              "x": -35.772,
              "y": -5.175,
              "z": 0.923
            },
            "rightCorner": {
              "x": -35.772,
              "y": -4.944,
              "z": 0.923
            },
            "gtin": "90376603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7806",
            "leftCorner": {
              "x": -35.771,
              "y": -4.944,
              "z": 0.923
            },
            "rightCorner": {
              "x": -35.771,
              "y": -4.722,
              "z": 0.923
            },
            "gtin": "90448638",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7807",
            "leftCorner": {
              "x": -35.771,
              "y": -4.722,
              "z": 0.923
            },
            "rightCorner": {
              "x": -35.771,
              "y": -4.52,
              "z": 0.923
            },
            "gtin": "5060337507608",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7808",
            "leftCorner": {
              "x": -35.766,
              "y": -4.52,
              "z": 0.923
            },
            "rightCorner": {
              "x": -35.766,
              "y": -4.326,
              "z": 0.923
            },
            "gtin": "5060517883607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7809",
            "leftCorner": {
              "x": -35.768,
              "y": -4.326,
              "z": 0.923
            },
            "rightCorner": {
              "x": -35.769,
              "y": -4.121,
              "z": 0.923
            },
            "gtin": "5060335635266",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d447",
        "height": 1.4311,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d7821",
            "leftCorner": {
              "x": -35.722,
              "y": -5.402,
              "z": 1.171
            },
            "rightCorner": {
              "x": -35.721,
              "y": -5.287,
              "z": 1.171
            },
            "gtin": "90446832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7822",
            "leftCorner": {
              "x": -35.721,
              "y": -5.287,
              "z": 1.171
            },
            "rightCorner": {
              "x": -35.722,
              "y": -5.173,
              "z": 1.171
            },
            "gtin": "90446832",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7824",
            "leftCorner": {
              "x": -35.766,
              "y": -5.173,
              "z": 1.171
            },
            "rightCorner": {
              "x": -35.766,
              "y": -4.934,
              "z": 1.171
            },
            "gtin": "90415722",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7825",
            "leftCorner": {
              "x": -35.762,
              "y": -4.934,
              "z": 1.171
            },
            "rightCorner": {
              "x": -35.762,
              "y": -4.713,
              "z": 1.171
            },
            "gtin": "90474514",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7826",
            "leftCorner": {
              "x": -35.762,
              "y": -4.713,
              "z": 1.171
            },
            "rightCorner": {
              "x": -35.762,
              "y": -4.498,
              "z": 1.171
            },
            "gtin": "90453885",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7827",
            "leftCorner": {
              "x": -35.759,
              "y": -4.498,
              "z": 1.171
            },
            "rightCorner": {
              "x": -35.759,
              "y": -4.283,
              "z": 1.171
            },
            "gtin": "90433627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7828",
            "leftCorner": {
              "x": -35.762,
              "y": -4.283,
              "z": 1.171
            },
            "rightCorner": {
              "x": -35.763,
              "y": -4.12,
              "z": 1.171
            },
            "gtin": "5060896624877",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40155f889d41539d446",
        "height": 1.7265,
        "facings": [
          {
            "id": "68d8e50ce1820c81800d780f",
            "leftCorner": {
              "x": -35.727,
              "y": -5.402,
              "z": 1.413
            },
            "rightCorner": {
              "x": -35.727,
              "y": -5.102,
              "z": 1.413
            },
            "gtin": "90376139",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7811",
            "leftCorner": {
              "x": -35.769,
              "y": -5.102,
              "z": 1.413
            },
            "rightCorner": {
              "x": -35.769,
              "y": -4.885,
              "z": 1.413
            },
            "gtin": "9002490206840",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7812",
            "leftCorner": {
              "x": -35.77,
              "y": -4.885,
              "z": 1.413
            },
            "rightCorner": {
              "x": -35.77,
              "y": -4.598,
              "z": 1.413
            },
            "gtin": "90162565",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7813",
            "leftCorner": {
              "x": -35.765,
              "y": -4.598,
              "z": 1.413
            },
            "rightCorner": {
              "x": -35.766,
              "y": -4.456,
              "z": 1.413
            },
            "gtin": "9002490203658",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7814",
            "leftCorner": {
              "x": -35.765,
              "y": -4.457,
              "z": 1.413
            },
            "rightCorner": {
              "x": -35.765,
              "y": -4.241,
              "z": 1.413
            },
            "gtin": "9002490210304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ce1820c81800d7815",
            "leftCorner": {
              "x": -35.769,
              "y": -4.241,
              "z": 1.413
            },
            "rightCorner": {
              "x": -35.768,
              "y": -3.978,
              "z": 1.413
            },
            "gtin": "90162480",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "ec6"
  },
  {
    "id": "ec9",
    "name": "ec9",
    "x": -32.232,
    "y": -4.814,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70913,
      "w": 0.70507
    },
    "layers": [],

    "rightNeighborShelfId": "ecb"
  },
  {
    "id": "ecb",
    "name": "ecb",
    "x": -32.24,
    "y": -3.564,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70913,
      "w": 0.70507
    },
    "layers": [],
    "leftNeighborShelfId": "ec9",
    "rightNeighborShelfId": "ecc"
  },
  {
    "id": "ecc",
    "name": "ecc",
    "x": -32.247,
    "y": -2.314,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70913,
      "w": 0.70507
    },
    "layers": [],
    "leftNeighborShelfId": "ecb",
    "rightNeighborShelfId": "ecd"
  },
  {
    "id": "ecd",
    "name": "ecd",
    "x": -32.254,
    "y": -1.064,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70913,
      "w": 0.70507
    },
    "layers": [],
    "leftNeighborShelfId": "ecc",
    "rightNeighborShelfId": "ece"
  },
  {
    "id": "ece",
    "name": "ece",
    "x": -32.261,
    "y": 0.186,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70913,
      "w": 0.70507
    },
    "layers": [],
    "leftNeighborShelfId": "ecd",
    "rightNeighborShelfId": "ecf"
  },
  {
    "id": "ecf",
    "name": "ecf",
    "x": -32.268,
    "y": 1.436,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70913,
      "w": 0.70507
    },
    "layers": [],
    "leftNeighborShelfId": "ece"
  },
  {
    "id": "ed0",
    "name": "ed0",
    "x": -34.378,
    "y": 2.784,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70433,
      "w": 0.70987
    },
    "layers": [],

    "rightNeighborShelfId": "ed1"
  },
  {
    "id": "ed1",
    "name": "ed1",
    "x": -34.369,
    "y": 1.534,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70433,
      "w": 0.70987
    },
    "layers": [],
    "leftNeighborShelfId": "ed0",
    "rightNeighborShelfId": "ed2"
  },
  {
    "id": "ed2",
    "name": "ed2",
    "x": -34.359,
    "y": 0.284,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70433,
      "w": 0.70987
    },
    "layers": [],
    "leftNeighborShelfId": "ed1",
    "rightNeighborShelfId": "ed3"
  },
  {
    "id": "ed3",
    "name": "ed3",
    "x": -34.349,
    "y": -0.966,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70433,
      "w": 0.70987
    },
    "layers": [],
    "leftNeighborShelfId": "ed2",
    "rightNeighborShelfId": "ed4"
  },
  {
    "id": "ed4",
    "name": "ed4",
    "x": -34.339,
    "y": -2.216,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70433,
      "w": 0.70987
    },
    "layers": [],
    "leftNeighborShelfId": "ed3",
    "rightNeighborShelfId": "ed5"
  },
  {
    "id": "ed5",
    "name": "ed5",
    "x": -34.329,
    "y": -3.465,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70433,
      "w": 0.70987
    },
    "layers": [],
    "leftNeighborShelfId": "ed4"
  },
  {
    "id": "ed6",
    "name": "ed6",
    "x": -24.137,
    "y": -4.559,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70927,
      "w": 0.70494
    },
    "layers": [],

    "rightNeighborShelfId": "ed9"
  },
  {
    "id": "ed9",
    "name": "ed9",
    "x": -24.145,
    "y": -3.309,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70927,
      "w": 0.70494
    },
    "layers": [],
    "leftNeighborShelfId": "ed6",
    "rightNeighborShelfId": "eda"
  },
  {
    "id": "eda",
    "name": "eda",
    "x": -24.152,
    "y": -2.059,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70927,
      "w": 0.70494
    },
    "layers": [],
    "leftNeighborShelfId": "ed9",
    "rightNeighborShelfId": "edb"
  },
  {
    "id": "edb",
    "name": "edb",
    "x": -24.16,
    "y": -0.809,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70927,
      "w": 0.70494
    },
    "layers": [],
    "leftNeighborShelfId": "eda",
    "rightNeighborShelfId": "edc"
  },
  {
    "id": "edc",
    "name": "edc",
    "x": -24.168,
    "y": 0.441,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70927,
      "w": 0.70494
    },
    "layers": [],
    "leftNeighborShelfId": "edb",
    "rightNeighborShelfId": "edd"
  },
  {
    "id": "edd",
    "name": "edd",
    "x": -24.175,
    "y": 1.691,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70927,
      "w": 0.70494
    },
    "layers": [],
    "leftNeighborShelfId": "edc"
  },
  {
    "id": "ede",
    "name": "ede",
    "x": -26.622,
    "y": 2.875,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70651,
      "w": 0.70771
    },
    "layers": [],

    "rightNeighborShelfId": "edf"
  },
  {
    "id": "edf",
    "name": "edf",
    "x": -26.62,
    "y": 1.625,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70651,
      "w": 0.70771
    },
    "layers": [],
    "leftNeighborShelfId": "ede",
    "rightNeighborShelfId": "ee0"
  },
  {
    "id": "ee0",
    "name": "ee0",
    "x": -26.617,
    "y": 0.373,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70318,
      "w": 0.71101
    },
    "layers": [],
    "leftNeighborShelfId": "edf",
    "rightNeighborShelfId": "ee1"
  },
  {
    "id": "ee1",
    "name": "ee1",
    "x": -26.603,
    "y": -0.877,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70318,
      "w": 0.71101
    },
    "layers": [],
    "leftNeighborShelfId": "ee0",
    "rightNeighborShelfId": "ee2"
  },
  {
    "id": "ee2",
    "name": "ee2",
    "x": -26.59,
    "y": -2.127,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70318,
      "w": 0.71101
    },
    "layers": [],
    "leftNeighborShelfId": "ee1",
    "rightNeighborShelfId": "ee3"
  },
  {
    "id": "ee3",
    "name": "ee3",
    "x": -26.576,
    "y": -3.377,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70318,
      "w": 0.71101
    },
    "layers": [],
    "leftNeighborShelfId": "ee2"
  },
  {
    "id": "ee4",
    "name": "ee4",
    "x": -28.218,
    "y": 1.972,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71058,
      "w": 0.70362
    },
    "layers": [],
    "leftNeighborShelfId": "ef1"
  },
  {
    "id": "eea",
    "name": "eea",
    "x": -30.664,
    "y": 3.262,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70632,
      "w": 0.7079
    },
    "layers": [],

    "rightNeighborShelfId": "eeb"
  },
  {
    "id": "eeb",
    "name": "eeb",
    "x": -30.661,
    "y": 2.012,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70632,
      "w": 0.7079
    },
    "layers": [],
    "leftNeighborShelfId": "eea",
    "rightNeighborShelfId": "eec"
  },
  {
    "id": "eec",
    "name": "eec",
    "x": -30.658,
    "y": 0.762,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70632,
      "w": 0.7079
    },
    "layers": [],
    "leftNeighborShelfId": "eeb",
    "rightNeighborShelfId": "eed"
  },
  {
    "id": "eed",
    "name": "eed",
    "x": -30.655,
    "y": -0.488,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70632,
      "w": 0.7079
    },
    "layers": [],
    "leftNeighborShelfId": "eec",
    "rightNeighborShelfId": "eee"
  },
  {
    "id": "eee",
    "name": "eee",
    "x": -30.653,
    "y": -1.738,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70632,
      "w": 0.7079
    },
    "layers": [],
    "leftNeighborShelfId": "eed",
    "rightNeighborShelfId": "eef"
  },
  {
    "id": "eef",
    "name": "eef",
    "x": -30.65,
    "y": -2.988,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70632,
      "w": 0.7079
    },
    "layers": [],
    "leftNeighborShelfId": "eee",
    "rightNeighborShelfId": "ef0"
  },
  {
    "id": "ef0",
    "name": "ef0",
    "x": -30.644,
    "y": -3.795,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70764,
      "w": 0.70657
    },
    "layers": [],
    "leftNeighborShelfId": "eef"
  },
  {
    "id": "ef1",
    "name": "ef1",
    "x": -28.206,
    "y": 0.722,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71058,
      "w": 0.70362
    },
    "layers": [],
    "leftNeighborShelfId": "ef2",
    "rightNeighborShelfId": "ee4"
  },
  {
    "id": "ef2",
    "name": "ef2",
    "x": -28.193,
    "y": -0.528,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71058,
      "w": 0.70362
    },
    "layers": [],
    "leftNeighborShelfId": "ef3",
    "rightNeighborShelfId": "ef1"
  },
  {
    "id": "ef3",
    "name": "ef3",
    "x": -28.181,
    "y": -1.778,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71058,
      "w": 0.70362
    },
    "layers": [],
    "leftNeighborShelfId": "ef4",
    "rightNeighborShelfId": "ef2"
  },
  {
    "id": "ef4",
    "name": "ef4",
    "x": -28.169,
    "y": -3.028,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.71058,
      "w": 0.70362
    },
    "layers": [],
    "leftNeighborShelfId": "ef5",
    "rightNeighborShelfId": "ef3"
  },
  {
    "id": "ef5",
    "name": "ef5",
    "x": -28.179,
    "y": -3.851,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70521,
      "w": 0.709
    },
    "layers": [],
    "leftNeighborShelfId": "ef7",
    "rightNeighborShelfId": "ef4"
  },
  {
    "id": "ef7",
    "name": "ef7",
    "x": -28.183,
    "y": -4.651,
    "width": 0.8,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.70521,
      "w": 0.709
    },
    "layers": [],

    "rightNeighborShelfId": "ef5"
  },
  {
    "id": "ef8",
    "name": "ef8",
    "x": -19.234,
    "y": -9.282,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": 0.002906
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 31
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d12d",
        "height": 0.17467,
        "facings": [
          {
            "id": "c78de59d07dee4975b217a36",
            "leftCorner": {
              "x": -19.234,
              "y": -9.216,
              "z": 0.143
            },
            "rightCorner": {
              "x": -19.91,
              "y": -9.212,
              "z": 0.143
            },
            "gtin": "4306188351184",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5e2f467e53b632783809e1ce",
            "leftCorner": {
              "x": -19.91,
              "y": -9.212,
              "z": 0.143
            },
            "rightCorner": {
              "x": -19.928,
              "y": -9.212,
              "z": 0.143
            },
            "gtin": "4003786904506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f92149de9dce656d6b318901",
            "leftCorner": {
              "x": -19.928,
              "y": -9.212,
              "z": 0.143
            },
            "rightCorner": {
              "x": -20.038,
              "y": -9.211,
              "z": 0.143
            },
            "gtin": "4001242108574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "edfa63bd808d2b140d3ad8e3",
            "leftCorner": {
              "x": -20.038,
              "y": -9.211,
              "z": 0.143
            },
            "rightCorner": {
              "x": -20.152,
              "y": -9.211,
              "z": 0.143
            },
            "gtin": "4001242108581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5d2e5682af1bf3de61281601",
            "leftCorner": {
              "x": -20.152,
              "y": -9.211,
              "z": 0.143
            },
            "rightCorner": {
              "x": -20.276,
              "y": -9.21,
              "z": 0.143
            },
            "gtin": "4004980534001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "12ad881258aaec4ca5e6e9d2",
            "leftCorner": {
              "x": -20.276,
              "y": -9.21,
              "z": 0.143
            },
            "rightCorner": {
              "x": -20.464,
              "y": -9.209,
              "z": 0.143
            },
            "gtin": "4018077010682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "047387e794a053f7e73b7cb6",
            "leftCorner": {
              "x": -20.464,
              "y": -9.209,
              "z": 0.143
            },
            "rightCorner": {
              "x": -20.482,
              "y": -9.209,
              "z": 0.143
            },
            "gtin": "4003786904506",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d12b",
        "height": 0.50872,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6348",
            "leftCorner": {
              "x": -19.234,
              "y": -9.247,
              "z": 0.416
            },
            "rightCorner": {
              "x": -19.717,
              "y": -9.244,
              "z": 0.416
            },
            "gtin": "4306188399476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d634a",
            "leftCorner": {
              "x": -19.717,
              "y": -9.299,
              "z": 0.416
            },
            "rightCorner": {
              "x": -19.984,
              "y": -9.297,
              "z": 0.416
            },
            "gtin": "4306188427896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d634b",
            "leftCorner": {
              "x": -19.983,
              "y": -9.282,
              "z": 0.416
            },
            "rightCorner": {
              "x": -20.319,
              "y": -9.281,
              "z": 0.416
            },
            "gtin": "4306188361961",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d634c",
            "leftCorner": {
              "x": -20.32,
              "y": -9.274,
              "z": 0.416
            },
            "rightCorner": {
              "x": -20.588,
              "y": -9.273,
              "z": 0.416
            },
            "gtin": "4306188053910",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d12a",
        "height": 0.80669,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6338",
            "leftCorner": {
              "x": -19.234,
              "y": -9.242,
              "z": 0.66
            },
            "rightCorner": {
              "x": -19.671,
              "y": -9.24,
              "z": 0.66
            },
            "gtin": "4014400925319",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d633a",
            "leftCorner": {
              "x": -19.672,
              "y": -9.283,
              "z": 0.66
            },
            "rightCorner": {
              "x": -19.815,
              "y": -9.282,
              "z": 0.66
            },
            "gtin": "4018077771750",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d633b",
            "leftCorner": {
              "x": -19.815,
              "y": -9.279,
              "z": 0.66
            },
            "rightCorner": {
              "x": -19.936,
              "y": -9.278,
              "z": 0.66
            },
            "gtin": "4004980539600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d633c",
            "leftCorner": {
              "x": -19.936,
              "y": -9.278,
              "z": 0.66
            },
            "rightCorner": {
              "x": -20.073,
              "y": -9.277,
              "z": 0.66
            },
            "gtin": "4004980560307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d633d",
            "leftCorner": {
              "x": -20.073,
              "y": -9.277,
              "z": 0.66
            },
            "rightCorner": {
              "x": -20.201,
              "y": -9.276,
              "z": 0.66
            },
            "gtin": "4004980534001",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d633e",
            "leftCorner": {
              "x": -20.201,
              "y": -9.276,
              "z": 0.66
            },
            "rightCorner": {
              "x": -20.347,
              "y": -9.275,
              "z": 0.66
            },
            "gtin": "4004980536807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d633f",
            "leftCorner": {
              "x": -20.347,
              "y": -9.271,
              "z": 0.66
            },
            "rightCorner": {
              "x": -20.543,
              "y": -9.27,
              "z": 0.66
            },
            "gtin": "4004980530508",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d128",
        "height": 1.1092,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6314",
            "leftCorner": {
              "x": -19.234,
              "y": -9.244,
              "z": 0.908
            },
            "rightCorner": {
              "x": -19.56,
              "y": -9.242,
              "z": 0.908
            },
            "gtin": "4001242003626",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6316",
            "leftCorner": {
              "x": -19.56,
              "y": -9.283,
              "z": 0.908
            },
            "rightCorner": {
              "x": -19.864,
              "y": -9.281,
              "z": 0.908
            },
            "gtin": "4001242003633",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6317",
            "leftCorner": {
              "x": -19.864,
              "y": -9.28,
              "z": 0.908
            },
            "rightCorner": {
              "x": -19.978,
              "y": -9.279,
              "z": 0.908
            },
            "gtin": "4001242108581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6318",
            "leftCorner": {
              "x": -19.978,
              "y": -9.279,
              "z": 0.908
            },
            "rightCorner": {
              "x": -20.088,
              "y": -9.279,
              "z": 0.908
            },
            "gtin": "4001242108574",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6319",
            "leftCorner": {
              "x": -20.088,
              "y": -9.279,
              "z": 0.908
            },
            "rightCorner": {
              "x": -20.333,
              "y": -9.277,
              "z": 0.908
            },
            "gtin": "4018077692482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d631a",
            "leftCorner": {
              "x": -20.333,
              "y": -9.271,
              "z": 0.908
            },
            "rightCorner": {
              "x": -20.808,
              "y": -9.268,
              "z": 0.908
            },
            "gtin": "4004980400504",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d129",
        "height": 1.414,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6329",
            "leftCorner": {
              "x": -19.234,
              "y": -9.236,
              "z": 1.157
            },
            "rightCorner": {
              "x": -19.673,
              "y": -9.234,
              "z": 1.157
            },
            "gtin": "4018077004896",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d632b",
            "leftCorner": {
              "x": -19.673,
              "y": -9.273,
              "z": 1.157
            },
            "rightCorner": {
              "x": -19.891,
              "y": -9.272,
              "z": 1.157
            },
            "gtin": "4018077764011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d632c",
            "leftCorner": {
              "x": -19.891,
              "y": -9.276,
              "z": 1.157
            },
            "rightCorner": {
              "x": -20.075,
              "y": -9.275,
              "z": 1.157
            },
            "gtin": "4018077010682",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d632d",
            "leftCorner": {
              "x": -20.074,
              "y": -9.269,
              "z": 1.157
            },
            "rightCorner": {
              "x": -20.469,
              "y": -9.267,
              "z": 1.157
            },
            "gtin": "4018077007095",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d632e",
            "leftCorner": {
              "x": -20.469,
              "y": -9.255,
              "z": 1.157
            },
            "rightCorner": {
              "x": -20.593,
              "y": -9.255,
              "z": 1.157
            },
            "gtin": "4003786904506",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d12c",
        "height": 1.6878,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6350",
            "leftCorner": {
              "x": -19.234,
              "y": -9.232,
              "z": 1.381
            },
            "rightCorner": {
              "x": -20.377,
              "y": -9.225,
              "z": 1.381
            },
            "gtin": "4306188052029",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6352",
            "leftCorner": {
              "x": -20.376,
              "y": -9.265,
              "z": 1.381
            },
            "rightCorner": {
              "x": -20.683,
              "y": -9.263,
              "z": 1.381
            },
            "gtin": "4306188036913",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "efa"
  },
  {
    "id": "efa",
    "name": "efa",
    "x": -20.484,
    "y": -9.274,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": 0.002906
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 43
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d134",
        "height": 0.17418,
        "facings": [
          {
            "id": "27e4b11087a555eda460d767",
            "leftCorner": {
              "x": -20.483,
              "y": -9.179,
              "z": 0.143
            },
            "rightCorner": {
              "x": -20.617,
              "y": -9.179,
              "z": 0.143
            },
            "gtin": "4008088184038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7516cc9335151c20f04d4ea5",
            "leftCorner": {
              "x": -20.617,
              "y": -9.179,
              "z": 0.143
            },
            "rightCorner": {
              "x": -20.641,
              "y": -9.178,
              "z": 0.143
            },
            "gtin": "4104420056046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "165dc62e00409ead0f375aff",
            "leftCorner": {
              "x": -20.641,
              "y": -9.178,
              "z": 0.143
            },
            "rightCorner": {
              "x": -20.697,
              "y": -9.178,
              "z": 0.143
            },
            "gtin": "4018356009222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0e408592d714cad2c6ec7cc3",
            "leftCorner": {
              "x": -20.697,
              "y": -9.178,
              "z": 0.143
            },
            "rightCorner": {
              "x": -20.814,
              "y": -9.177,
              "z": 0.143
            },
            "gtin": "4004980409507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9bebb1348cdb9fcffc8f5a80",
            "leftCorner": {
              "x": -20.814,
              "y": -9.177,
              "z": 0.143
            },
            "rightCorner": {
              "x": -20.935,
              "y": -9.177,
              "z": 0.143
            },
            "gtin": "4004980409705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "49309e5551f10d565fefcb90",
            "leftCorner": {
              "x": -20.935,
              "y": -9.177,
              "z": 0.143
            },
            "rightCorner": {
              "x": -21.068,
              "y": -9.176,
              "z": 0.143
            },
            "gtin": "4008088184038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "663c3e57ffdab09d6b16d66a",
            "leftCorner": {
              "x": -21.068,
              "y": -9.176,
              "z": 0.143
            },
            "rightCorner": {
              "x": -21.215,
              "y": -9.175,
              "z": 0.143
            },
            "gtin": "4018077779930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee869afb4c6248aaf5dbf6cd",
            "leftCorner": {
              "x": -21.215,
              "y": -9.175,
              "z": 0.143
            },
            "rightCorner": {
              "x": -21.401,
              "y": -9.174,
              "z": 0.143
            },
            "gtin": "4003786602259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7a9ef57cca76a872d0a97373",
            "leftCorner": {
              "x": -21.401,
              "y": -9.174,
              "z": 0.143
            },
            "rightCorner": {
              "x": -21.588,
              "y": -9.173,
              "z": 0.143
            },
            "gtin": "4004980409606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d2f35e8b156357900f38d2fc",
            "leftCorner": {
              "x": -21.588,
              "y": -9.173,
              "z": 0.143
            },
            "rightCorner": {
              "x": -21.721,
              "y": -9.172,
              "z": 0.143
            },
            "gtin": "4008088184038",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d12f",
        "height": 0.50578,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d634d",
            "leftCorner": {
              "x": -20.588,
              "y": -9.27,
              "z": 0.414
            },
            "rightCorner": {
              "x": -20.826,
              "y": -9.269,
              "z": 0.414
            },
            "gtin": "4306188041405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d634e",
            "leftCorner": {
              "x": -20.826,
              "y": -9.269,
              "z": 0.414
            },
            "rightCorner": {
              "x": -21.064,
              "y": -9.267,
              "z": 0.414
            },
            "gtin": "4306188041405",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d634f",
            "leftCorner": {
              "x": -21.063,
              "y": -9.273,
              "z": 0.414
            },
            "rightCorner": {
              "x": -22.214,
              "y": -9.266,
              "z": 0.414
            },
            "gtin": "4018077690105",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d131",
        "height": 0.80614,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6340",
            "leftCorner": {
              "x": -20.542,
              "y": -9.273,
              "z": 0.66
            },
            "rightCorner": {
              "x": -20.66,
              "y": -9.272,
              "z": 0.66
            },
            "gtin": "4004980409705",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6341",
            "leftCorner": {
              "x": -20.66,
              "y": -9.272,
              "z": 0.66
            },
            "rightCorner": {
              "x": -20.788,
              "y": -9.271,
              "z": 0.66
            },
            "gtin": "4004980409507",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6342",
            "leftCorner": {
              "x": -20.788,
              "y": -9.272,
              "z": 0.66
            },
            "rightCorner": {
              "x": -20.983,
              "y": -9.271,
              "z": 0.66
            },
            "gtin": "4004980409606",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6343",
            "leftCorner": {
              "x": -20.983,
              "y": -9.273,
              "z": 0.66
            },
            "rightCorner": {
              "x": -21.586,
              "y": -9.27,
              "z": 0.66
            },
            "gtin": "4018077895074",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6344",
            "leftCorner": {
              "x": -21.587,
              "y": -9.26,
              "z": 0.66
            },
            "rightCorner": {
              "x": -22.15,
              "y": -9.256,
              "z": 0.66
            },
            "gtin": "4018077779930",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d132",
        "height": 1.1096,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d631b",
            "leftCorner": {
              "x": -20.808,
              "y": -9.271,
              "z": 0.908
            },
            "rightCorner": {
              "x": -20.985,
              "y": -9.27,
              "z": 0.908
            },
            "gtin": "4004980513006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ba323f45bff097c6d76fd309",
            "leftCorner": {
              "x": -20.484,
              "y": -9.234,
              "z": 0.908
            },
            "rightCorner": {
              "x": -20.732,
              "y": -9.232,
              "z": 0.908
            },
            "gtin": "4004980400504",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d631c",
            "leftCorner": {
              "x": -20.985,
              "y": -9.273,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.125,
              "y": -9.272,
              "z": 0.908
            },
            "gtin": "4004980404007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d631d",
            "leftCorner": {
              "x": -21.125,
              "y": -9.272,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.264,
              "y": -9.271,
              "z": 0.908
            },
            "gtin": "4004980404007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d631e",
            "leftCorner": {
              "x": -21.264,
              "y": -9.269,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.358,
              "y": -9.268,
              "z": 0.908
            },
            "gtin": "4004980401907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d631f",
            "leftCorner": {
              "x": -21.358,
              "y": -9.268,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.451,
              "y": -9.268,
              "z": 0.908
            },
            "gtin": "4004980401907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6320",
            "leftCorner": {
              "x": -21.451,
              "y": -9.268,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.545,
              "y": -9.267,
              "z": 0.908
            },
            "gtin": "4004980401907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6321",
            "leftCorner": {
              "x": -21.545,
              "y": -9.267,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.638,
              "y": -9.267,
              "z": 0.908
            },
            "gtin": "4004980401907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6322",
            "leftCorner": {
              "x": -21.638,
              "y": -9.267,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.732,
              "y": -9.266,
              "z": 0.908
            },
            "gtin": "4004980401907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6323",
            "leftCorner": {
              "x": -21.732,
              "y": -9.266,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.825,
              "y": -9.266,
              "z": 0.908
            },
            "gtin": "4004980401907",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d12e",
        "height": 1.411,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d632f",
            "leftCorner": {
              "x": -20.594,
              "y": -9.264,
              "z": 1.154
            },
            "rightCorner": {
              "x": -20.721,
              "y": -9.263,
              "z": 1.154
            },
            "gtin": "4003786903516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "722f734375533fae00fb237d",
            "leftCorner": {
              "x": -20.484,
              "y": -9.226,
              "z": 1.154
            },
            "rightCorner": {
              "x": -20.59,
              "y": -9.225,
              "z": 1.154
            },
            "gtin": "4003786903516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6330",
            "leftCorner": {
              "x": -20.721,
              "y": -9.264,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.086,
              "y": -9.262,
              "z": 1.154
            },
            "gtin": "4003786912259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6331",
            "leftCorner": {
              "x": -21.086,
              "y": -9.265,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.3,
              "y": -9.263,
              "z": 1.154
            },
            "gtin": "4003786942607",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6332",
            "leftCorner": {
              "x": -21.3,
              "y": -9.262,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.51,
              "y": -9.261,
              "z": 1.154
            },
            "gtin": "4003786958509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6333",
            "leftCorner": {
              "x": -21.51,
              "y": -9.256,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.711,
              "y": -9.255,
              "z": 1.154
            },
            "gtin": "4003786923002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6334",
            "leftCorner": {
              "x": -21.711,
              "y": -9.252,
              "z": 1.154
            },
            "rightCorner": {
              "x": -21.91,
              "y": -9.251,
              "z": 1.154
            },
            "gtin": "4104420056046",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d130",
        "height": 1.6831,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6353",
            "leftCorner": {
              "x": -20.682,
              "y": -9.266,
              "z": 1.377
            },
            "rightCorner": {
              "x": -20.925,
              "y": -9.265,
              "z": 1.377
            },
            "gtin": "4306188052050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "38ad08eb96c07858d67afb58",
            "leftCorner": {
              "x": -20.484,
              "y": -9.232,
              "z": 1.377
            },
            "rightCorner": {
              "x": -20.652,
              "y": -9.231,
              "z": 1.377
            },
            "gtin": "4003786651509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3fd4347cba38a62fbf34271d",
            "leftCorner": {
              "x": -21.249,
              "y": -9.227,
              "z": 1.377
            },
            "rightCorner": {
              "x": -21.305,
              "y": -9.227,
              "z": 1.377
            },
            "gtin": "4018356009222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fadb389b1071a373d5e42299",
            "leftCorner": {
              "x": -21.305,
              "y": -9.227,
              "z": 1.377
            },
            "rightCorner": {
              "x": -21.36,
              "y": -9.227,
              "z": 1.377
            },
            "gtin": "4018356009222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6354",
            "leftCorner": {
              "x": -20.925,
              "y": -9.269,
              "z": 1.377
            },
            "rightCorner": {
              "x": -21.062,
              "y": -9.269,
              "z": 1.377
            },
            "gtin": "4008088919821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6355",
            "leftCorner": {
              "x": -21.062,
              "y": -9.269,
              "z": 1.377
            },
            "rightCorner": {
              "x": -21.249,
              "y": -9.268,
              "z": 1.377
            },
            "gtin": "4003786602259",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6357",
            "leftCorner": {
              "x": -21.408,
              "y": -9.263,
              "z": 1.377
            },
            "rightCorner": {
              "x": -21.678,
              "y": -9.261,
              "z": 1.377
            },
            "gtin": "4003786612258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6358",
            "leftCorner": {
              "x": -21.678,
              "y": -9.254,
              "z": 1.377
            },
            "rightCorner": {
              "x": -21.903,
              "y": -9.252,
              "z": 1.377
            },
            "gtin": "4018356009222",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "ef8",
    "rightNeighborShelfId": "efb"
  },
  {
    "id": "efb",
    "name": "efb",
    "x": -21.734,
    "y": -9.267,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": 0.002906
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 29
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d13a",
        "height": 0.17124,
        "facings": [
          {
            "id": "5ca00561027d6cea46f78dc3",
            "leftCorner": {
              "x": -21.734,
              "y": -9.218,
              "z": 0.14
            },
            "rightCorner": {
              "x": -21.848,
              "y": -9.217,
              "z": 0.14
            },
            "gtin": "4018077683015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ad022851791f9a48963e5800",
            "leftCorner": {
              "x": -21.848,
              "y": -9.217,
              "z": 0.14
            },
            "rightCorner": {
              "x": -22.028,
              "y": -9.216,
              "z": 0.14
            },
            "gtin": "4104420052345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ff3d64885fab49973e379a96",
            "leftCorner": {
              "x": -22.028,
              "y": -9.216,
              "z": 0.14
            },
            "rightCorner": {
              "x": -22.213,
              "y": -9.215,
              "z": 0.14
            },
            "gtin": "4104420053861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "af176cd0996263f22c4e92d6",
            "leftCorner": {
              "x": -22.213,
              "y": -9.215,
              "z": 0.14
            },
            "rightCorner": {
              "x": -22.407,
              "y": -9.214,
              "z": 0.14
            },
            "gtin": "4306188047414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "14a0270a78783297662015cc",
            "leftCorner": {
              "x": -22.407,
              "y": -9.214,
              "z": 0.14
            },
            "rightCorner": {
              "x": -22.607,
              "y": -9.213,
              "z": 0.14
            },
            "gtin": "4104420053342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "114392050461883d0d1b26a9",
            "leftCorner": {
              "x": -22.607,
              "y": -9.213,
              "z": 0.14
            },
            "rightCorner": {
              "x": -22.814,
              "y": -9.211,
              "z": 0.14
            },
            "gtin": "4018356009215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "825a49d2c0358cab35b54f21",
            "leftCorner": {
              "x": -22.814,
              "y": -9.211,
              "z": 0.14
            },
            "rightCorner": {
              "x": -22.928,
              "y": -9.211,
              "z": 0.14
            },
            "gtin": "4018077683015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d139",
        "height": 0.50375,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6349",
            "leftCorner": {
              "x": -22.215,
              "y": -9.257,
              "z": 0.412
            },
            "rightCorner": {
              "x": -22.984,
              "y": -9.252,
              "z": 0.412
            },
            "gtin": "4018077010316",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "41f2cee439368df8ef847e50",
            "leftCorner": {
              "x": -21.734,
              "y": -9.22,
              "z": 0.412
            },
            "rightCorner": {
              "x": -22.205,
              "y": -9.217,
              "z": 0.412
            },
            "gtin": "4018077010316",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d138",
        "height": 0.80109,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6345",
            "leftCorner": {
              "x": -22.15,
              "y": -9.257,
              "z": 0.655
            },
            "rightCorner": {
              "x": -22.417,
              "y": -9.255,
              "z": 0.655
            },
            "gtin": "4017100706004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6346",
            "leftCorner": {
              "x": -22.417,
              "y": -9.255,
              "z": 0.655
            },
            "rightCorner": {
              "x": -22.683,
              "y": -9.254,
              "z": 0.655
            },
            "gtin": "4017100706004",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6347",
            "leftCorner": {
              "x": -22.682,
              "y": -9.259,
              "z": 0.655
            },
            "rightCorner": {
              "x": -22.863,
              "y": -9.257,
              "z": 0.655
            },
            "gtin": "4018077686719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6339",
            "leftCorner": {
              "x": -22.863,
              "y": -9.261,
              "z": 0.655
            },
            "rightCorner": {
              "x": -22.984,
              "y": -9.26,
              "z": 0.655
            },
            "gtin": "4018077683015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c366213ba71c34376ef3fb06",
            "leftCorner": {
              "x": -21.735,
              "y": -9.224,
              "z": 0.655
            },
            "rightCorner": {
              "x": -21.916,
              "y": -9.223,
              "z": 0.655
            },
            "gtin": "4018077686719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "54b412cbef77e5a7e11ba097",
            "leftCorner": {
              "x": -21.916,
              "y": -9.223,
              "z": 0.655
            },
            "rightCorner": {
              "x": -22.098,
              "y": -9.222,
              "z": 0.655
            },
            "gtin": "4018077686719",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d137",
        "height": 1.1048,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6324",
            "leftCorner": {
              "x": -21.827,
              "y": -9.254,
              "z": 0.904
            },
            "rightCorner": {
              "x": -21.979,
              "y": -9.253,
              "z": 0.904
            },
            "gtin": "4004980514003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6325",
            "leftCorner": {
              "x": -21.979,
              "y": -9.253,
              "z": 0.904
            },
            "rightCorner": {
              "x": -22.132,
              "y": -9.252,
              "z": 0.904
            },
            "gtin": "4004980514003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6326",
            "leftCorner": {
              "x": -22.132,
              "y": -9.255,
              "z": 0.904
            },
            "rightCorner": {
              "x": -22.322,
              "y": -9.254,
              "z": 0.904
            },
            "gtin": "4104420053861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6327",
            "leftCorner": {
              "x": -22.322,
              "y": -9.255,
              "z": 0.904
            },
            "rightCorner": {
              "x": -22.498,
              "y": -9.254,
              "z": 0.904
            },
            "gtin": "4104420052345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6328",
            "leftCorner": {
              "x": -22.498,
              "y": -9.257,
              "z": 0.904
            },
            "rightCorner": {
              "x": -22.788,
              "y": -9.255,
              "z": 0.904
            },
            "gtin": "4104420052321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6315",
            "leftCorner": {
              "x": -22.788,
              "y": -9.26,
              "z": 0.904
            },
            "rightCorner": {
              "x": -22.984,
              "y": -9.259,
              "z": 0.904
            },
            "gtin": "4104420053342",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d136",
        "height": 1.4092,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6335",
            "leftCorner": {
              "x": -21.91,
              "y": -9.258,
              "z": 1.153
            },
            "rightCorner": {
              "x": -22.205,
              "y": -9.256,
              "z": 1.153
            },
            "gtin": "4104420055360",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6336",
            "leftCorner": {
              "x": -22.205,
              "y": -9.255,
              "z": 1.153
            },
            "rightCorner": {
              "x": -22.487,
              "y": -9.254,
              "z": 1.153
            },
            "gtin": "4000522060038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6337",
            "leftCorner": {
              "x": -22.487,
              "y": -9.257,
              "z": 1.153
            },
            "rightCorner": {
              "x": -22.773,
              "y": -9.256,
              "z": 1.153
            },
            "gtin": "4003586006714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d632a",
            "leftCorner": {
              "x": -22.773,
              "y": -9.258,
              "z": 1.153
            },
            "rightCorner": {
              "x": -22.984,
              "y": -9.256,
              "z": 1.153
            },
            "gtin": "4003586006660",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d135",
        "height": 1.6817,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6359",
            "leftCorner": {
              "x": -21.904,
              "y": -9.254,
              "z": 1.376
            },
            "rightCorner": {
              "x": -22.124,
              "y": -9.253,
              "z": 1.376
            },
            "gtin": "4018356009215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d635a",
            "leftCorner": {
              "x": -22.124,
              "y": -9.254,
              "z": 1.376
            },
            "rightCorner": {
              "x": -22.479,
              "y": -9.252,
              "z": 1.376
            },
            "gtin": "4018356008157",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d635b",
            "leftCorner": {
              "x": -22.479,
              "y": -9.254,
              "z": 1.376
            },
            "rightCorner": {
              "x": -22.795,
              "y": -9.252,
              "z": 1.376
            },
            "gtin": "4306188047421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6351",
            "leftCorner": {
              "x": -22.795,
              "y": -9.257,
              "z": 1.376
            },
            "rightCorner": {
              "x": -22.984,
              "y": -9.256,
              "z": 1.376
            },
            "gtin": "4306188047414",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "efa"
  },
  {
    "id": "efc",
    "name": "efc",
    "x": -22.953,
    "y": -10.76,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0016232,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 32
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6da",
        "height": 0.1555,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6396",
            "leftCorner": {
              "x": -22.953,
              "y": -10.756,
              "z": 0.127
            },
            "rightCorner": {
              "x": -22.5,
              "y": -10.755,
              "z": 0.127
            },
            "gtin": "4306188035282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2471969445ef8c11ec984bd6",
            "leftCorner": {
              "x": -22.073,
              "y": -10.753,
              "z": 0.127
            },
            "rightCorner": {
              "x": -22.059,
              "y": -10.753,
              "z": 0.127
            },
            "gtin": "4306188046516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "888fb904fb1b79928633bf17",
            "leftCorner": {
              "x": -22.059,
              "y": -10.753,
              "z": 0.127
            },
            "rightCorner": {
              "x": -21.821,
              "y": -10.752,
              "z": 0.127
            },
            "gtin": "4306188035282",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bd96ca3f0d76c0f1ea6d547a",
            "leftCorner": {
              "x": -21.821,
              "y": -10.752,
              "z": 0.127
            },
            "rightCorner": {
              "x": -21.806,
              "y": -10.752,
              "z": 0.127
            },
            "gtin": "4306188046516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "943b2b44e1ede4c3bf18009d",
            "leftCorner": {
              "x": -21.806,
              "y": -10.752,
              "z": 0.127
            },
            "rightCorner": {
              "x": -21.792,
              "y": -10.752,
              "z": 0.127
            },
            "gtin": "4306188046516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6fdde9990deaa83baa836d45",
            "leftCorner": {
              "x": -21.792,
              "y": -10.752,
              "z": 0.127
            },
            "rightCorner": {
              "x": -21.777,
              "y": -10.752,
              "z": 0.127
            },
            "gtin": "4306188046516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "206277bf7fa4d3171235fc8c",
            "leftCorner": {
              "x": -21.777,
              "y": -10.752,
              "z": 0.127
            },
            "rightCorner": {
              "x": -21.762,
              "y": -10.752,
              "z": 0.127
            },
            "gtin": "4306188046516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3e8a982c9d8ad34988ab1300",
            "leftCorner": {
              "x": -21.762,
              "y": -10.752,
              "z": 0.127
            },
            "rightCorner": {
              "x": -21.747,
              "y": -10.752,
              "z": 0.127
            },
            "gtin": "4306188046516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6398",
            "leftCorner": {
              "x": -22.5,
              "y": -10.726,
              "z": 0.127
            },
            "rightCorner": {
              "x": -22.073,
              "y": -10.724,
              "z": 0.127
            },
            "gtin": "4306188432906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d639a",
            "leftCorner": {
              "x": -21.746,
              "y": -10.694,
              "z": 0.127
            },
            "rightCorner": {
              "x": -21.703,
              "y": -10.694,
              "z": 0.127
            },
            "gtin": "4306188046516",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6d7",
        "height": 0.52451,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6376",
            "leftCorner": {
              "x": -22.953,
              "y": -10.765,
              "z": 0.429
            },
            "rightCorner": {
              "x": -22.711,
              "y": -10.765,
              "z": 0.429
            },
            "gtin": "8412600047484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6377",
            "leftCorner": {
              "x": -22.711,
              "y": -10.765,
              "z": 0.429
            },
            "rightCorner": {
              "x": -22.469,
              "y": -10.763,
              "z": 0.429
            },
            "gtin": "8412600047484",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d637a",
            "leftCorner": {
              "x": -22.468,
              "y": -10.728,
              "z": 0.429
            },
            "rightCorner": {
              "x": -22.278,
              "y": -10.728,
              "z": 0.429
            },
            "gtin": "8412600019689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d637b",
            "leftCorner": {
              "x": -22.278,
              "y": -10.719,
              "z": 0.429
            },
            "rightCorner": {
              "x": -21.931,
              "y": -10.717,
              "z": 0.429
            },
            "gtin": "8412600019672",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d637c",
            "leftCorner": {
              "x": -21.932,
              "y": -10.699,
              "z": 0.429
            },
            "rightCorner": {
              "x": -21.703,
              "y": -10.698,
              "z": 0.429
            },
            "gtin": "4031446402611",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6d8",
        "height": 0.82807,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d638c",
            "leftCorner": {
              "x": -22.953,
              "y": -10.759,
              "z": 0.678
            },
            "rightCorner": {
              "x": -22.674,
              "y": -10.758,
              "z": 0.678
            },
            "gtin": "5000396021202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d638d",
            "leftCorner": {
              "x": -22.674,
              "y": -10.758,
              "z": 0.678
            },
            "rightCorner": {
              "x": -22.395,
              "y": -10.757,
              "z": 0.678
            },
            "gtin": "5000396021202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d638f",
            "leftCorner": {
              "x": -22.394,
              "y": -10.722,
              "z": 0.678
            },
            "rightCorner": {
              "x": -22.157,
              "y": -10.722,
              "z": 0.678
            },
            "gtin": "4018077620003",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6390",
            "leftCorner": {
              "x": -22.158,
              "y": -10.712,
              "z": 0.678
            },
            "rightCorner": {
              "x": -21.897,
              "y": -10.712,
              "z": 0.678
            },
            "gtin": "4018077009587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6391",
            "leftCorner": {
              "x": -21.896,
              "y": -10.696,
              "z": 0.678
            },
            "rightCorner": {
              "x": -21.703,
              "y": -10.696,
              "z": 0.678
            },
            "gtin": "4018077619458",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6d5",
        "height": 1.1306,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6383",
            "leftCorner": {
              "x": -22.953,
              "y": -10.764,
              "z": 0.925
            },
            "rightCorner": {
              "x": -22.58,
              "y": -10.763,
              "z": 0.925
            },
            "gtin": "5410041001204",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6385",
            "leftCorner": {
              "x": -22.58,
              "y": -10.729,
              "z": 0.925
            },
            "rightCorner": {
              "x": -22.25,
              "y": -10.727,
              "z": 0.925
            },
            "gtin": "7622210641434",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6386",
            "leftCorner": {
              "x": -22.25,
              "y": -10.716,
              "z": 0.925
            },
            "rightCorner": {
              "x": -21.904,
              "y": -10.716,
              "z": 0.925
            },
            "gtin": "5410041066005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6387",
            "leftCorner": {
              "x": -21.905,
              "y": -10.699,
              "z": 0.925
            },
            "rightCorner": {
              "x": -21.703,
              "y": -10.698,
              "z": 0.925
            },
            "gtin": "7622210641403",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6d6",
        "height": 1.4337,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d636d",
            "leftCorner": {
              "x": -22.953,
              "y": -10.767,
              "z": 1.173
            },
            "rightCorner": {
              "x": -22.596,
              "y": -10.766,
              "z": 1.173
            },
            "gtin": "4018077895036",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d636f",
            "leftCorner": {
              "x": -22.596,
              "y": -10.732,
              "z": 1.173
            },
            "rightCorner": {
              "x": -22.157,
              "y": -10.731,
              "z": 1.173
            },
            "gtin": "4018077888038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6370",
            "leftCorner": {
              "x": -22.157,
              "y": -10.718,
              "z": 1.173
            },
            "rightCorner": {
              "x": -21.918,
              "y": -10.718,
              "z": 1.173
            },
            "gtin": "7622202253102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6371",
            "leftCorner": {
              "x": -21.919,
              "y": -10.704,
              "z": 1.173
            },
            "rightCorner": {
              "x": -21.703,
              "y": -10.703,
              "z": 1.173
            },
            "gtin": "7622202040900",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6d9",
        "height": 1.7318,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6362",
            "leftCorner": {
              "x": -22.602,
              "y": -10.728,
              "z": 1.417
            },
            "rightCorner": {
              "x": -22.291,
              "y": -10.727,
              "z": 1.417
            },
            "gtin": "4003586006202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "459f08c62db4e17d58b196ec",
            "leftCorner": {
              "x": -22.953,
              "y": -10.764,
              "z": 1.417
            },
            "rightCorner": {
              "x": -22.678,
              "y": -10.763,
              "z": 1.417
            },
            "gtin": "4003586105196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6363",
            "leftCorner": {
              "x": -22.292,
              "y": -10.718,
              "z": 1.417
            },
            "rightCorner": {
              "x": -21.999,
              "y": -10.717,
              "z": 1.417
            },
            "gtin": "4003586102713",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6364",
            "leftCorner": {
              "x": -22.0,
              "y": -10.705,
              "z": 1.417
            },
            "rightCorner": {
              "x": -21.703,
              "y": -10.704,
              "z": 1.417
            },
            "gtin": "4003586105196",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "efd"
  },
  {
    "id": "efd",
    "name": "efd",
    "x": -21.703,
    "y": -10.756,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0016232,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 29
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d140",
        "height": 0.15715,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d639b",
            "leftCorner": {
              "x": -21.702,
              "y": -10.816,
              "z": 0.129
            },
            "rightCorner": {
              "x": -21.624,
              "y": -10.818,
              "z": 0.129
            },
            "gtin": "4306188046523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d639c",
            "leftCorner": {
              "x": -21.624,
              "y": -10.828,
              "z": 0.129
            },
            "rightCorner": {
              "x": -21.011,
              "y": -10.827,
              "z": 0.129
            },
            "gtin": "4306188046523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d639d",
            "leftCorner": {
              "x": -21.011,
              "y": -10.831,
              "z": 0.129
            },
            "rightCorner": {
              "x": -20.742,
              "y": -10.83,
              "z": 0.129
            },
            "gtin": "4306188408901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d639e",
            "leftCorner": {
              "x": -20.742,
              "y": -10.832,
              "z": 0.129
            },
            "rightCorner": {
              "x": -20.324,
              "y": -10.831,
              "z": 0.129
            },
            "gtin": "4306188005537",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d13d",
        "height": 0.52764,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d637d",
            "leftCorner": {
              "x": -21.703,
              "y": -10.808,
              "z": 0.432
            },
            "rightCorner": {
              "x": -21.65,
              "y": -10.81,
              "z": 0.432
            },
            "gtin": "5701397024734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d637e",
            "leftCorner": {
              "x": -21.65,
              "y": -10.827,
              "z": 0.432
            },
            "rightCorner": {
              "x": -21.391,
              "y": -10.827,
              "z": 0.432
            },
            "gtin": "5701397024734",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d637f",
            "leftCorner": {
              "x": -21.391,
              "y": -10.828,
              "z": 0.432
            },
            "rightCorner": {
              "x": -21.095,
              "y": -10.826,
              "z": 0.432
            },
            "gtin": "4306188348016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6380",
            "leftCorner": {
              "x": -21.095,
              "y": -10.829,
              "z": 0.432
            },
            "rightCorner": {
              "x": -20.749,
              "y": -10.828,
              "z": 0.432
            },
            "gtin": "4306188028871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6381",
            "leftCorner": {
              "x": -20.749,
              "y": -10.831,
              "z": 0.432
            },
            "rightCorner": {
              "x": -20.155,
              "y": -10.829,
              "z": 0.432
            },
            "gtin": "4000522105227",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d13f",
        "height": 0.83296,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6392",
            "leftCorner": {
              "x": -21.703,
              "y": -10.81,
              "z": 0.682
            },
            "rightCorner": {
              "x": -21.644,
              "y": -10.811,
              "z": 0.682
            },
            "gtin": "4018077619236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "844c260f9cf7191b09d30d49",
            "leftCorner": {
              "x": -20.74,
              "y": -10.866,
              "z": 0.682
            },
            "rightCorner": {
              "x": -20.454,
              "y": -10.865,
              "z": 0.682
            },
            "gtin": "4018077619236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6393",
            "leftCorner": {
              "x": -21.644,
              "y": -10.826,
              "z": 0.682
            },
            "rightCorner": {
              "x": -21.386,
              "y": -10.826,
              "z": 0.682
            },
            "gtin": "4018077619236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6394",
            "leftCorner": {
              "x": -21.386,
              "y": -10.826,
              "z": 0.682
            },
            "rightCorner": {
              "x": -21.128,
              "y": -10.825,
              "z": 0.682
            },
            "gtin": "4018077619236",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6395",
            "leftCorner": {
              "x": -21.127,
              "y": -10.827,
              "z": 0.682
            },
            "rightCorner": {
              "x": -20.74,
              "y": -10.825,
              "z": 0.682
            },
            "gtin": "4062139009831",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d13e",
        "height": 1.1324,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6388",
            "leftCorner": {
              "x": -21.703,
              "y": -10.805,
              "z": 0.927
            },
            "rightCorner": {
              "x": -21.638,
              "y": -10.806,
              "z": 0.927
            },
            "gtin": "5410041030006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6389",
            "leftCorner": {
              "x": -21.637,
              "y": -10.824,
              "z": 0.927
            },
            "rightCorner": {
              "x": -21.337,
              "y": -10.823,
              "z": 0.927
            },
            "gtin": "5410041030006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d638a",
            "leftCorner": {
              "x": -21.337,
              "y": -10.826,
              "z": 0.927
            },
            "rightCorner": {
              "x": -21.045,
              "y": -10.824,
              "z": 0.927
            },
            "gtin": "4003586105714",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d638b",
            "leftCorner": {
              "x": -21.045,
              "y": -10.824,
              "z": 0.927
            },
            "rightCorner": {
              "x": -20.752,
              "y": -10.823,
              "z": 0.927
            },
            "gtin": "4003586105738",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6384",
            "leftCorner": {
              "x": -20.752,
              "y": -10.829,
              "z": 0.927
            },
            "rightCorner": {
              "x": -20.452,
              "y": -10.828,
              "z": 0.927
            },
            "gtin": "4003586105721",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d13c",
        "height": 1.435,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6372",
            "leftCorner": {
              "x": -21.703,
              "y": -10.811,
              "z": 1.174
            },
            "rightCorner": {
              "x": -21.651,
              "y": -10.813,
              "z": 1.174
            },
            "gtin": "5201360660520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6373",
            "leftCorner": {
              "x": -21.651,
              "y": -10.829,
              "z": 1.174
            },
            "rightCorner": {
              "x": -21.406,
              "y": -10.829,
              "z": 1.174
            },
            "gtin": "5201360660520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6374",
            "leftCorner": {
              "x": -21.406,
              "y": -10.83,
              "z": 1.174
            },
            "rightCorner": {
              "x": -21.135,
              "y": -10.829,
              "z": 1.174
            },
            "gtin": "5201360660728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6375",
            "leftCorner": {
              "x": -21.135,
              "y": -10.824,
              "z": 1.174
            },
            "rightCorner": {
              "x": -20.736,
              "y": -10.823,
              "z": 1.174
            },
            "gtin": "5201360660223",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d636e",
            "leftCorner": {
              "x": -20.736,
              "y": -10.833,
              "z": 1.174
            },
            "rightCorner": {
              "x": -20.452,
              "y": -10.831,
              "z": 1.174
            },
            "gtin": "5201360660773",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d13b",
        "height": 1.7319,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6365",
            "leftCorner": {
              "x": -21.703,
              "y": -10.808,
              "z": 1.417
            },
            "rightCorner": {
              "x": -21.635,
              "y": -10.809,
              "z": 1.417
            },
            "gtin": "4003586102676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6366",
            "leftCorner": {
              "x": -21.634,
              "y": -10.823,
              "z": 1.417
            },
            "rightCorner": {
              "x": -21.396,
              "y": -10.823,
              "z": 1.417
            },
            "gtin": "4003586102676",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6367",
            "leftCorner": {
              "x": -21.396,
              "y": -10.823,
              "z": 1.417
            },
            "rightCorner": {
              "x": -21.107,
              "y": -10.822,
              "z": 1.417
            },
            "gtin": "4003586103185",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6368",
            "leftCorner": {
              "x": -21.107,
              "y": -10.818,
              "z": 1.417
            },
            "rightCorner": {
              "x": -20.77,
              "y": -10.817,
              "z": 1.417
            },
            "gtin": "4003586003324",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6369",
            "leftCorner": {
              "x": -20.77,
              "y": -10.827,
              "z": 1.417
            },
            "rightCorner": {
              "x": -20.416,
              "y": -10.826,
              "z": 1.417
            },
            "gtin": "7622201497392",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "efc",
    "rightNeighborShelfId": "efe"
  },
  {
    "id": "efe",
    "name": "efe",
    "x": -20.453,
    "y": -10.752,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0016232,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 14
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d142",
        "height": 0.15508,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6397",
            "leftCorner": {
              "x": -20.324,
              "y": -10.816,
              "z": 0.127
            },
            "rightCorner": {
              "x": -19.203,
              "y": -10.813,
              "z": 0.127
            },
            "gtin": "4306188046530",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d144",
        "height": 0.53034,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6382",
            "leftCorner": {
              "x": -20.156,
              "y": -10.808,
              "z": 0.434
            },
            "rightCorner": {
              "x": -19.804,
              "y": -10.808,
              "z": 0.434
            },
            "gtin": "4000522105210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6378",
            "leftCorner": {
              "x": -19.805,
              "y": -10.801,
              "z": 0.434
            },
            "rightCorner": {
              "x": -19.503,
              "y": -10.8,
              "z": 0.434
            },
            "gtin": "4000522105265",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6379",
            "leftCorner": {
              "x": -19.503,
              "y": -10.8,
              "z": 0.434
            },
            "rightCorner": {
              "x": -19.203,
              "y": -10.799,
              "z": 0.434
            },
            "gtin": "4000522105265",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d141",
        "height": 0.9335,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d639f",
            "leftCorner": {
              "x": -20.452,
              "y": -10.844,
              "z": 0.764
            },
            "rightCorner": {
              "x": -19.701,
              "y": -10.841,
              "z": 0.764
            },
            "gtin": "4018077006258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63a0",
            "leftCorner": {
              "x": -19.701,
              "y": -10.791,
              "z": 0.764
            },
            "rightCorner": {
              "x": -19.203,
              "y": -10.79,
              "z": 0.764
            },
            "gtin": "4018077006203",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d145",
        "height": 1.3129,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63a1",
            "leftCorner": {
              "x": -20.453,
              "y": -10.834,
              "z": 1.074
            },
            "rightCorner": {
              "x": -20.092,
              "y": -10.833,
              "z": 1.074
            },
            "gtin": "4018077006425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63a3",
            "leftCorner": {
              "x": -20.092,
              "y": -10.802,
              "z": 1.074
            },
            "rightCorner": {
              "x": -19.767,
              "y": -10.801,
              "z": 1.074
            },
            "gtin": "4018077006340",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63a4",
            "leftCorner": {
              "x": -19.767,
              "y": -10.792,
              "z": 1.074
            },
            "rightCorner": {
              "x": -19.494,
              "y": -10.791,
              "z": 1.074
            },
            "gtin": "4003586107862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63a2",
            "leftCorner": {
              "x": -19.494,
              "y": -10.784,
              "z": 1.074
            },
            "rightCorner": {
              "x": -19.203,
              "y": -10.783,
              "z": 1.074
            },
            "gtin": "4003586107855",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d143",
        "height": 1.738,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d636a",
            "leftCorner": {
              "x": -20.417,
              "y": -10.815,
              "z": 1.422
            },
            "rightCorner": {
              "x": -20.155,
              "y": -10.813,
              "z": 1.422
            },
            "gtin": "4000522107092",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d636b",
            "leftCorner": {
              "x": -20.156,
              "y": -10.804,
              "z": 1.422
            },
            "rightCorner": {
              "x": -19.793,
              "y": -10.803,
              "z": 1.422
            },
            "gtin": "4000522137082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6361",
            "leftCorner": {
              "x": -19.516,
              "y": -10.784,
              "z": 1.422
            },
            "rightCorner": {
              "x": -19.203,
              "y": -10.783,
              "z": 1.422
            },
            "gtin": "4003586106995",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c7274e5733a40a4fb223b0f8",
            "leftCorner": {
              "x": -19.793,
              "y": -10.836,
              "z": 1.422
            },
            "rightCorner": {
              "x": -19.531,
              "y": -10.835,
              "z": 1.422
            },
            "gtin": "4000522107092",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "efd"
  },
  {
    "id": "eff",
    "name": "eff",
    "x": -19.159,
    "y": -12.248,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99999,
      "w": 0.0046077
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d14a",
        "height": 0.16953,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63ea",
            "leftCorner": {
              "x": -19.157,
              "y": -12.145,
              "z": 0.139
            },
            "rightCorner": {
              "x": -19.796,
              "y": -12.138,
              "z": 0.139
            },
            "gtin": "4306188031765",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63eb",
            "leftCorner": {
              "x": -19.797,
              "y": -12.178,
              "z": 0.139
            },
            "rightCorner": {
              "x": -20.408,
              "y": -12.173,
              "z": 0.139
            },
            "gtin": "4306188041047",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d146",
        "height": 0.53587,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63a5",
            "leftCorner": {
              "x": -19.157,
              "y": -12.152,
              "z": 0.438
            },
            "rightCorner": {
              "x": -19.283,
              "y": -12.151,
              "z": 0.438
            },
            "gtin": "4306188032267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63a6",
            "leftCorner": {
              "x": -19.283,
              "y": -12.151,
              "z": 0.438
            },
            "rightCorner": {
              "x": -19.408,
              "y": -12.15,
              "z": 0.438
            },
            "gtin": "4306188032267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63a7",
            "leftCorner": {
              "x": -19.408,
              "y": -12.15,
              "z": 0.438
            },
            "rightCorner": {
              "x": -19.533,
              "y": -12.149,
              "z": 0.438
            },
            "gtin": "4306188032267",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63aa",
            "leftCorner": {
              "x": -19.534,
              "y": -12.193,
              "z": 0.438
            },
            "rightCorner": {
              "x": -19.829,
              "y": -12.19,
              "z": 0.438
            },
            "gtin": "4306188055853",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d63ab",
            "leftCorner": {
              "x": -19.829,
              "y": -12.181,
              "z": 0.438
            },
            "rightCorner": {
              "x": -20.122,
              "y": -12.178,
              "z": 0.438
            },
            "gtin": "4306188014164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63ac",
            "leftCorner": {
              "x": -20.122,
              "y": -12.179,
              "z": 0.438
            },
            "rightCorner": {
              "x": -20.45,
              "y": -12.176,
              "z": 0.438
            },
            "gtin": "4306188014133",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d149",
        "height": 0.93917,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63d9",
            "leftCorner": {
              "x": -19.157,
              "y": -12.153,
              "z": 0.768
            },
            "rightCorner": {
              "x": -19.473,
              "y": -12.15,
              "z": 0.768
            },
            "gtin": "4306188414711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63da",
            "leftCorner": {
              "x": -19.473,
              "y": -12.15,
              "z": 0.768
            },
            "rightCorner": {
              "x": -19.789,
              "y": -12.147,
              "z": 0.768
            },
            "gtin": "4306188414711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63dc",
            "leftCorner": {
              "x": -19.789,
              "y": -12.186,
              "z": 0.768
            },
            "rightCorner": {
              "x": -20.511,
              "y": -12.18,
              "z": 0.768
            },
            "gtin": "4306188414681",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d148",
        "height": 1.3183,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63c9",
            "leftCorner": {
              "x": -19.157,
              "y": -12.154,
              "z": 1.079
            },
            "rightCorner": {
              "x": -19.733,
              "y": -12.148,
              "z": 1.079
            },
            "gtin": "4250221395843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63cb",
            "leftCorner": {
              "x": -19.733,
              "y": -12.188,
              "z": 1.079
            },
            "rightCorner": {
              "x": -20.471,
              "y": -12.181,
              "z": 1.079
            },
            "gtin": "4250221394143",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d147",
        "height": 1.7409,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63b7",
            "leftCorner": {
              "x": -19.157,
              "y": -12.154,
              "z": 1.424
            },
            "rightCorner": {
              "x": -19.467,
              "y": -12.151,
              "z": 1.424
            },
            "gtin": "4306188419532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63b9",
            "leftCorner": {
              "x": -19.468,
              "y": -12.2,
              "z": 1.424
            },
            "rightCorner": {
              "x": -19.68,
              "y": -12.197,
              "z": 1.424
            },
            "gtin": "4306188040552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63ba",
            "leftCorner": {
              "x": -19.68,
              "y": -12.199,
              "z": 1.424
            },
            "rightCorner": {
              "x": -19.867,
              "y": -12.197,
              "z": 1.424
            },
            "gtin": "4001242108239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63bb",
            "leftCorner": {
              "x": -19.867,
              "y": -12.187,
              "z": 1.424
            },
            "rightCorner": {
              "x": -20.051,
              "y": -12.185,
              "z": 1.424
            },
            "gtin": "4001242108215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63bc",
            "leftCorner": {
              "x": -20.051,
              "y": -12.185,
              "z": 1.424
            },
            "rightCorner": {
              "x": -20.229,
              "y": -12.183,
              "z": 1.424
            },
            "gtin": "4001242108222",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63bd",
            "leftCorner": {
              "x": -20.229,
              "y": -12.18,
              "z": 1.424
            },
            "rightCorner": {
              "x": -20.537,
              "y": -12.177,
              "z": 1.424
            },
            "gtin": "4001242105900",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "f00"
  },
  {
    "id": "f00",
    "name": "f00",
    "x": -20.409,
    "y": -12.237,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99999,
      "w": 0.0046077
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 17
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d14e",
        "height": 0.1565,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63ec",
            "leftCorner": {
              "x": -20.408,
              "y": -12.139,
              "z": 0.128
            },
            "rightCorner": {
              "x": -20.612,
              "y": -12.137,
              "z": 0.128
            },
            "gtin": "4062139005888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63ed",
            "leftCorner": {
              "x": -20.612,
              "y": -12.137,
              "z": 0.128
            },
            "rightCorner": {
              "x": -20.815,
              "y": -12.136,
              "z": 0.128
            },
            "gtin": "4062139005888",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63ef",
            "leftCorner": {
              "x": -20.815,
              "y": -12.178,
              "z": 0.128
            },
            "rightCorner": {
              "x": -21.014,
              "y": -12.176,
              "z": 0.128
            },
            "gtin": "4062139005864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63f0",
            "leftCorner": {
              "x": -21.015,
              "y": -12.171,
              "z": 0.128
            },
            "rightCorner": {
              "x": -21.846,
              "y": -12.164,
              "z": 0.128
            },
            "gtin": "4018077004377",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d14f",
        "height": 0.53089,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63ad",
            "leftCorner": {
              "x": -20.45,
              "y": -12.177,
              "z": 0.434
            },
            "rightCorner": {
              "x": -21.089,
              "y": -12.171,
              "z": 0.434
            },
            "gtin": "4062139007677",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63ae",
            "leftCorner": {
              "x": -21.089,
              "y": -12.171,
              "z": 0.434
            },
            "rightCorner": {
              "x": -21.34,
              "y": -12.169,
              "z": 0.434
            },
            "gtin": "4018077009266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63af",
            "leftCorner": {
              "x": -21.34,
              "y": -12.17,
              "z": 0.434
            },
            "rightCorner": {
              "x": -21.756,
              "y": -12.167,
              "z": 0.434
            },
            "gtin": "4018077011467",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d14c",
        "height": 0.93407,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63dd",
            "leftCorner": {
              "x": -20.511,
              "y": -12.18,
              "z": 0.764
            },
            "rightCorner": {
              "x": -21.115,
              "y": -12.174,
              "z": 0.764
            },
            "gtin": "4306188414650",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63de",
            "leftCorner": {
              "x": -21.114,
              "y": -12.175,
              "z": 0.764
            },
            "rightCorner": {
              "x": -21.421,
              "y": -12.172,
              "z": 0.764
            },
            "gtin": "4104420056909",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63df",
            "leftCorner": {
              "x": -21.42,
              "y": -12.17,
              "z": 0.764
            },
            "rightCorner": {
              "x": -21.724,
              "y": -12.167,
              "z": 0.764
            },
            "gtin": "4003586105158",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d14d",
        "height": 1.313,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63cc",
            "leftCorner": {
              "x": -20.471,
              "y": -12.183,
              "z": 1.074
            },
            "rightCorner": {
              "x": -20.637,
              "y": -12.182,
              "z": 1.074
            },
            "gtin": "4260257870061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63cd",
            "leftCorner": {
              "x": -20.638,
              "y": -12.186,
              "z": 1.074
            },
            "rightCorner": {
              "x": -20.938,
              "y": -12.183,
              "z": 1.074
            },
            "gtin": "4260257870085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63ce",
            "leftCorner": {
              "x": -20.938,
              "y": -12.181,
              "z": 1.074
            },
            "rightCorner": {
              "x": -21.497,
              "y": -12.175,
              "z": 1.074
            },
            "gtin": "4260257870078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63cf",
            "leftCorner": {
              "x": -21.497,
              "y": -12.17,
              "z": 1.074
            },
            "rightCorner": {
              "x": -21.804,
              "y": -12.167,
              "z": 1.074
            },
            "gtin": "4018077714016",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d14b",
        "height": 1.7376,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63be",
            "leftCorner": {
              "x": -20.538,
              "y": -12.186,
              "z": 1.422
            },
            "rightCorner": {
              "x": -20.84,
              "y": -12.183,
              "z": 1.422
            },
            "gtin": "4001242105917",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63bf",
            "leftCorner": {
              "x": -20.84,
              "y": -12.185,
              "z": 1.422
            },
            "rightCorner": {
              "x": -21.132,
              "y": -12.182,
              "z": 1.422
            },
            "gtin": "4001242105931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63c0",
            "leftCorner": {
              "x": -21.132,
              "y": -12.176,
              "z": 1.422
            },
            "rightCorner": {
              "x": -21.77,
              "y": -12.171,
              "z": 1.422
            },
            "gtin": "4001242106297",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "eff",
    "rightNeighborShelfId": "f02"
  },
  {
    "id": "f02",
    "name": "f02",
    "x": -21.66,
    "y": -12.244,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99996,
      "w": 0.0084211
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d152",
        "height": 0.155,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63f1",
            "leftCorner": {
              "x": -21.849,
              "y": -12.208,
              "z": 0.127
            },
            "rightCorner": {
              "x": -22.124,
              "y": -12.213,
              "z": 0.127
            },
            "gtin": "4018077004285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63f2",
            "leftCorner": {
              "x": -22.125,
              "y": -12.201,
              "z": 0.127
            },
            "rightCorner": {
              "x": -22.669,
              "y": -12.21,
              "z": 0.127
            },
            "gtin": "4018077004193",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63f3",
            "leftCorner": {
              "x": -22.67,
              "y": -12.192,
              "z": 0.127
            },
            "rightCorner": {
              "x": -23.26,
              "y": -12.202,
              "z": 0.127
            },
            "gtin": "4018077004117",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d153",
        "height": 0.52999,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63b0",
            "leftCorner": {
              "x": -21.758,
              "y": -12.205,
              "z": 0.434
            },
            "rightCorner": {
              "x": -22.006,
              "y": -12.209,
              "z": 0.434
            },
            "gtin": "4018077012280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63b1",
            "leftCorner": {
              "x": -22.007,
              "y": -12.2,
              "z": 0.434
            },
            "rightCorner": {
              "x": -22.331,
              "y": -12.205,
              "z": 0.434
            },
            "gtin": "4018077822018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63b2",
            "leftCorner": {
              "x": -22.332,
              "y": -12.197,
              "z": 0.434
            },
            "rightCorner": {
              "x": -22.624,
              "y": -12.202,
              "z": 0.434
            },
            "gtin": "4018077006883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63b3",
            "leftCorner": {
              "x": -22.625,
              "y": -12.19,
              "z": 0.434
            },
            "rightCorner": {
              "x": -22.976,
              "y": -12.195,
              "z": 0.434
            },
            "gtin": "4018077004469",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d154",
        "height": 0.93184,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63e0",
            "leftCorner": {
              "x": -21.727,
              "y": -12.208,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.036,
              "y": -12.213,
              "z": 0.762
            },
            "gtin": "4003586105165",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63e1",
            "leftCorner": {
              "x": -22.036,
              "y": -12.2,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.642,
              "y": -12.21,
              "z": 0.762
            },
            "gtin": "4003586102072",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63e2",
            "leftCorner": {
              "x": -22.642,
              "y": -12.195,
              "z": 0.762
            },
            "rightCorner": {
              "x": -22.95,
              "y": -12.2,
              "z": 0.762
            },
            "gtin": "4003586102089",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d151",
        "height": 1.3107,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63d0",
            "leftCorner": {
              "x": -21.806,
              "y": -12.209,
              "z": 1.072
            },
            "rightCorner": {
              "x": -22.068,
              "y": -12.214,
              "z": 1.072
            },
            "gtin": "4018077714313",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63d1",
            "leftCorner": {
              "x": -22.068,
              "y": -12.204,
              "z": 1.072
            },
            "rightCorner": {
              "x": -22.406,
              "y": -12.21,
              "z": 1.072
            },
            "gtin": "4018077714054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63d2",
            "leftCorner": {
              "x": -22.406,
              "y": -12.2,
              "z": 1.072
            },
            "rightCorner": {
              "x": -22.678,
              "y": -12.205,
              "z": 1.072
            },
            "gtin": "4018077714351",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63d3",
            "leftCorner": {
              "x": -22.679,
              "y": -12.194,
              "z": 1.072
            },
            "rightCorner": {
              "x": -22.977,
              "y": -12.198,
              "z": 1.072
            },
            "gtin": "4003586100795",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d150",
        "height": 1.7336,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63c1",
            "leftCorner": {
              "x": -21.772,
              "y": -12.208,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.016,
              "y": -12.212,
              "z": 1.418
            },
            "gtin": "4000522108433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63c2",
            "leftCorner": {
              "x": -22.016,
              "y": -12.201,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.252,
              "y": -12.206,
              "z": 1.418
            },
            "gtin": "4000522108426",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63c3",
            "leftCorner": {
              "x": -22.252,
              "y": -12.203,
              "z": 1.418
            },
            "rightCorner": {
              "x": -22.746,
              "y": -12.212,
              "z": 1.418
            },
            "gtin": "4306188033783",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63c4",
            "leftCorner": {
              "x": -22.746,
              "y": -12.194,
              "z": 1.418
            },
            "rightCorner": {
              "x": -23.01,
              "y": -12.198,
              "z": 1.418
            },
            "gtin": "4306188040965",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f00",
    "rightNeighborShelfId": "f03"
  },
  {
    "id": "f03",
    "name": "f03",
    "x": -22.91,
    "y": -12.265,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.99996,
      "w": 0.0084211
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 18
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d159",
        "height": 0.16241,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63f4",
            "leftCorner": {
              "x": -23.261,
              "y": -12.196,
              "z": 0.133
            },
            "rightCorner": {
              "x": -23.596,
              "y": -12.202,
              "z": 0.133
            },
            "gtin": "4003586104120",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6705931b7e56632b52c0c734",
            "leftCorner": {
              "x": -22.912,
              "y": -12.155,
              "z": 0.133
            },
            "rightCorner": {
              "x": -23.162,
              "y": -12.159,
              "z": 0.133
            },
            "gtin": "4003586104038",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63f5",
            "leftCorner": {
              "x": -23.596,
              "y": -12.206,
              "z": 0.133
            },
            "rightCorner": {
              "x": -23.916,
              "y": -12.212,
              "z": 0.133
            },
            "gtin": "4003586104007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63f6",
            "leftCorner": {
              "x": -23.916,
              "y": -12.218,
              "z": 0.133
            },
            "rightCorner": {
              "x": -24.162,
              "y": -12.221,
              "z": 0.133
            },
            "gtin": "4003586104038",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d157",
        "height": 0.53552,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63b4",
            "leftCorner": {
              "x": -22.976,
              "y": -12.19,
              "z": 0.438
            },
            "rightCorner": {
              "x": -23.265,
              "y": -12.194,
              "z": 0.438
            },
            "gtin": "4250426223446",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63b5",
            "leftCorner": {
              "x": -23.265,
              "y": -12.192,
              "z": 0.438
            },
            "rightCorner": {
              "x": -23.575,
              "y": -12.197,
              "z": 0.438
            },
            "gtin": "4250426223460",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63b6",
            "leftCorner": {
              "x": -23.575,
              "y": -12.203,
              "z": 0.438
            },
            "rightCorner": {
              "x": -23.868,
              "y": -12.208,
              "z": 0.438
            },
            "gtin": "4250426223408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63a8",
            "leftCorner": {
              "x": -23.868,
              "y": -12.213,
              "z": 0.438
            },
            "rightCorner": {
              "x": -24.015,
              "y": -12.216,
              "z": 0.438
            },
            "gtin": "4250426223422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63a9",
            "leftCorner": {
              "x": -24.015,
              "y": -12.216,
              "z": 0.438
            },
            "rightCorner": {
              "x": -24.162,
              "y": -12.218,
              "z": 0.438
            },
            "gtin": "4250426223422",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d156",
        "height": 0.93689,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63e3",
            "leftCorner": {
              "x": -22.951,
              "y": -12.185,
              "z": 0.767
            },
            "rightCorner": {
              "x": -23.204,
              "y": -12.19,
              "z": 0.767
            },
            "gtin": "4003586102317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63e4",
            "leftCorner": {
              "x": -23.204,
              "y": -12.19,
              "z": 0.767
            },
            "rightCorner": {
              "x": -23.527,
              "y": -12.196,
              "z": 0.767
            },
            "gtin": "4003586108630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63e5",
            "leftCorner": {
              "x": -23.527,
              "y": -12.202,
              "z": 0.767
            },
            "rightCorner": {
              "x": -24.162,
              "y": -12.212,
              "z": 0.767
            },
            "gtin": "4003586101723",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d158",
        "height": 1.3158,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63d4",
            "leftCorner": {
              "x": -22.978,
              "y": -12.199,
              "z": 1.077
            },
            "rightCorner": {
              "x": -23.257,
              "y": -12.204,
              "z": 1.077
            },
            "gtin": "4003586002914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63d5",
            "leftCorner": {
              "x": -23.257,
              "y": -12.202,
              "z": 1.077
            },
            "rightCorner": {
              "x": -23.863,
              "y": -12.212,
              "z": 1.077
            },
            "gtin": "4003586100252",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63d6",
            "leftCorner": {
              "x": -23.862,
              "y": -12.224,
              "z": 1.077
            },
            "rightCorner": {
              "x": -24.16,
              "y": -12.229,
              "z": 1.077
            },
            "gtin": "4003586100306",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d155",
        "height": 1.7379,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63c5",
            "leftCorner": {
              "x": -23.011,
              "y": -12.2,
              "z": 1.422
            },
            "rightCorner": {
              "x": -23.278,
              "y": -12.205,
              "z": 1.422
            },
            "gtin": "4003586101082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63c6",
            "leftCorner": {
              "x": -23.278,
              "y": -12.202,
              "z": 1.422
            },
            "rightCorner": {
              "x": -23.906,
              "y": -12.213,
              "z": 1.422
            },
            "gtin": "4003586101389",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63c7",
            "leftCorner": {
              "x": -23.905,
              "y": -12.226,
              "z": 1.422
            },
            "rightCorner": {
              "x": -24.212,
              "y": -12.231,
              "z": 1.422
            },
            "gtin": "4003586107503",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f02",
    "rightNeighborShelfId": "f04"
  },
  {
    "id": "f04",
    "name": "f04",
    "x": -24.157,
    "y": -12.286,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 1.0,
      "w": 0.0028798
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 23
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d15c",
        "height": 0.16445,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63f7",
            "leftCorner": {
              "x": -24.156,
              "y": -12.222,
              "z": 0.135
            },
            "rightCorner": {
              "x": -24.25,
              "y": -12.22,
              "z": 0.135
            },
            "gtin": "5053990127740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63f8",
            "leftCorner": {
              "x": -24.25,
              "y": -12.222,
              "z": 0.135
            },
            "rightCorner": {
              "x": -24.513,
              "y": -12.221,
              "z": 0.135
            },
            "gtin": "5053990127740",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63f9",
            "leftCorner": {
              "x": -24.513,
              "y": -12.221,
              "z": 0.135
            },
            "rightCorner": {
              "x": -24.81,
              "y": -12.218,
              "z": 0.135
            },
            "gtin": "5053990175123",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63fa",
            "leftCorner": {
              "x": -24.81,
              "y": -12.212,
              "z": 0.135
            },
            "rightCorner": {
              "x": -25.142,
              "y": -12.211,
              "z": 0.135
            },
            "gtin": "5053990162413",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63ee",
            "leftCorner": {
              "x": -25.142,
              "y": -12.211,
              "z": 0.135
            },
            "rightCorner": {
              "x": -25.406,
              "y": -12.209,
              "z": 0.135
            },
            "gtin": "5053990127726",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d15a",
        "height": 0.54828,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63fb",
            "leftCorner": {
              "x": -24.156,
              "y": -12.18,
              "z": 0.449
            },
            "rightCorner": {
              "x": -24.281,
              "y": -12.179,
              "z": 0.449
            },
            "gtin": "5053990127665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63fc",
            "leftCorner": {
              "x": -24.281,
              "y": -12.179,
              "z": 0.449
            },
            "rightCorner": {
              "x": -24.406,
              "y": -12.179,
              "z": 0.449
            },
            "gtin": "5053990127665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63fd",
            "leftCorner": {
              "x": -24.406,
              "y": -12.179,
              "z": 0.449
            },
            "rightCorner": {
              "x": -24.531,
              "y": -12.178,
              "z": 0.449
            },
            "gtin": "5053990127665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63ff",
            "leftCorner": {
              "x": -24.531,
              "y": -12.219,
              "z": 0.449
            },
            "rightCorner": {
              "x": -24.657,
              "y": -12.218,
              "z": 0.449
            },
            "gtin": "5053990182077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6400",
            "leftCorner": {
              "x": -24.657,
              "y": -12.218,
              "z": 0.449
            },
            "rightCorner": {
              "x": -24.783,
              "y": -12.217,
              "z": 0.449
            },
            "gtin": "5053990182077",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6401",
            "leftCorner": {
              "x": -24.783,
              "y": -12.216,
              "z": 0.449
            },
            "rightCorner": {
              "x": -24.952,
              "y": -12.216,
              "z": 0.449
            },
            "gtin": "5053990121922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6402",
            "leftCorner": {
              "x": -24.952,
              "y": -12.216,
              "z": 0.449
            },
            "rightCorner": {
              "x": -25.121,
              "y": -12.214,
              "z": 0.449
            },
            "gtin": "5053990121922",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63fe",
            "leftCorner": {
              "x": -25.121,
              "y": -12.208,
              "z": 0.449
            },
            "rightCorner": {
              "x": -25.406,
              "y": -12.206,
              "z": 0.449
            },
            "gtin": "5053990161966",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d15d",
        "height": 0.93608,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63e6",
            "leftCorner": {
              "x": -24.156,
              "y": -12.226,
              "z": 0.766
            },
            "rightCorner": {
              "x": -24.223,
              "y": -12.224,
              "z": 0.766
            },
            "gtin": "4003586108456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63e7",
            "leftCorner": {
              "x": -24.223,
              "y": -12.223,
              "z": 0.766
            },
            "rightCorner": {
              "x": -24.544,
              "y": -12.221,
              "z": 0.766
            },
            "gtin": "4003586108456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63e8",
            "leftCorner": {
              "x": -24.544,
              "y": -12.221,
              "z": 0.766
            },
            "rightCorner": {
              "x": -24.821,
              "y": -12.219,
              "z": 0.766
            },
            "gtin": "4003586107350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63e9",
            "leftCorner": {
              "x": -24.821,
              "y": -12.219,
              "z": 0.766
            },
            "rightCorner": {
              "x": -25.167,
              "y": -12.217,
              "z": 0.766
            },
            "gtin": "4003586000330",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63db",
            "leftCorner": {
              "x": -25.167,
              "y": -12.212,
              "z": 0.766
            },
            "rightCorner": {
              "x": -25.406,
              "y": -12.21,
              "z": 0.766
            },
            "gtin": "4003586000347",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d15b",
        "height": 1.3155,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63d7",
            "leftCorner": {
              "x": -24.156,
              "y": -12.23,
              "z": 1.076
            },
            "rightCorner": {
              "x": -24.468,
              "y": -12.222,
              "z": 1.076
            },
            "gtin": "4003586100399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63d8",
            "leftCorner": {
              "x": -24.468,
              "y": -12.226,
              "z": 1.076
            },
            "rightCorner": {
              "x": -25.051,
              "y": -12.223,
              "z": 1.076
            },
            "gtin": "4003586100399",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63ca",
            "leftCorner": {
              "x": -25.051,
              "y": -12.215,
              "z": 1.076
            },
            "rightCorner": {
              "x": -25.406,
              "y": -12.212,
              "z": 1.076
            },
            "gtin": "4003586107510",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d15e",
        "height": 1.7387,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d63c8",
            "leftCorner": {
              "x": -24.208,
              "y": -12.224,
              "z": 1.423
            },
            "rightCorner": {
              "x": -24.835,
              "y": -12.22,
              "z": 1.423
            },
            "gtin": "4003586101310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d63b8",
            "leftCorner": {
              "x": -24.835,
              "y": -12.218,
              "z": 1.423
            },
            "rightCorner": {
              "x": -25.406,
              "y": -12.215,
              "z": 1.423
            },
            "gtin": "4003586101358",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f03"
  },
  {
    "id": "f05",
    "name": "f05",
    "x": -25.36,
    "y": -13.765,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0013875,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 31,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d16b",
        "height": 0.15695,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64c4",
            "leftCorner": {
              "x": -25.36,
              "y": -13.862,
              "z": 0.128
            },
            "rightCorner": {
              "x": -24.942,
              "y": -13.863,
              "z": 0.128
            },
            "gtin": "4306188027485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64c6",
            "leftCorner": {
              "x": -24.942,
              "y": -13.822,
              "z": 0.128
            },
            "rightCorner": {
              "x": -24.686,
              "y": -13.823,
              "z": 0.128
            },
            "gtin": "4250231162480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64c7",
            "leftCorner": {
              "x": -24.686,
              "y": -13.824,
              "z": 0.128
            },
            "rightCorner": {
              "x": -24.306,
              "y": -13.825,
              "z": 0.128
            },
            "gtin": "4033500649482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64c5",
            "leftCorner": {
              "x": -24.306,
              "y": -13.836,
              "z": 0.128
            },
            "rightCorner": {
              "x": -24.111,
              "y": -13.836,
              "z": 0.128
            },
            "gtin": "4033500032529",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d168",
        "height": 0.45263,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6478",
            "leftCorner": {
              "x": -25.361,
              "y": -13.805,
              "z": 0.37
            },
            "rightCorner": {
              "x": -25.051,
              "y": -13.806,
              "z": 0.37
            },
            "gtin": "4014400905878",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d647a",
            "leftCorner": {
              "x": -25.05,
              "y": -13.76,
              "z": 0.37
            },
            "rightCorner": {
              "x": -24.758,
              "y": -13.761,
              "z": 0.37
            },
            "gtin": "4014400904277",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d647b",
            "leftCorner": {
              "x": -24.757,
              "y": -13.766,
              "z": 0.37
            },
            "rightCorner": {
              "x": -24.477,
              "y": -13.767,
              "z": 0.37
            },
            "gtin": "4014400904352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d647c",
            "leftCorner": {
              "x": -24.477,
              "y": -13.771,
              "z": 0.37
            },
            "rightCorner": {
              "x": -24.059,
              "y": -13.772,
              "z": 0.37
            },
            "gtin": "4014400918229",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d16a",
        "height": 0.75027,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64ab",
            "leftCorner": {
              "x": -25.361,
              "y": -13.807,
              "z": 0.614
            },
            "rightCorner": {
              "x": -25.029,
              "y": -13.808,
              "z": 0.614
            },
            "gtin": "4014400904369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64ad",
            "leftCorner": {
              "x": -25.029,
              "y": -13.767,
              "z": 0.614
            },
            "rightCorner": {
              "x": -24.777,
              "y": -13.768,
              "z": 0.614
            },
            "gtin": "4014400904390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64ae",
            "leftCorner": {
              "x": -24.777,
              "y": -13.769,
              "z": 0.614
            },
            "rightCorner": {
              "x": -24.498,
              "y": -13.769,
              "z": 0.614
            },
            "gtin": "4014400904307",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64af",
            "leftCorner": {
              "x": -24.497,
              "y": -13.77,
              "z": 0.614
            },
            "rightCorner": {
              "x": -24.225,
              "y": -13.772,
              "z": 0.614
            },
            "gtin": "4014400925678",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64b0",
            "leftCorner": {
              "x": -24.226,
              "y": -13.782,
              "z": 0.614
            },
            "rightCorner": {
              "x": -24.11,
              "y": -13.782,
              "z": 0.614
            },
            "gtin": "4014400930009",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d169",
        "height": 1.0529,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6493",
            "leftCorner": {
              "x": -25.36,
              "y": -13.809,
              "z": 0.861
            },
            "rightCorner": {
              "x": -25.051,
              "y": -13.81,
              "z": 0.861
            },
            "gtin": "4014400904376",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6495",
            "leftCorner": {
              "x": -25.051,
              "y": -13.77,
              "z": 0.861
            },
            "rightCorner": {
              "x": -24.779,
              "y": -13.771,
              "z": 0.861
            },
            "gtin": "4014400904321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6496",
            "leftCorner": {
              "x": -24.779,
              "y": -13.771,
              "z": 0.861
            },
            "rightCorner": {
              "x": -24.488,
              "y": -13.772,
              "z": 0.861
            },
            "gtin": "4014400904406",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6497",
            "leftCorner": {
              "x": -24.489,
              "y": -13.776,
              "z": 0.861
            },
            "rightCorner": {
              "x": -24.202,
              "y": -13.777,
              "z": 0.861
            },
            "gtin": "4014400918212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6498",
            "leftCorner": {
              "x": -24.203,
              "y": -13.787,
              "z": 0.861
            },
            "rightCorner": {
              "x": -24.111,
              "y": -13.787,
              "z": 0.861
            },
            "gtin": "4014400917789",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d167",
        "height": 1.3555,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6454",
            "leftCorner": {
              "x": -25.36,
              "y": -13.81,
              "z": 1.109
            },
            "rightCorner": {
              "x": -25.092,
              "y": -13.811,
              "z": 1.109
            },
            "gtin": "4014400908602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6456",
            "leftCorner": {
              "x": -25.092,
              "y": -13.769,
              "z": 1.109
            },
            "rightCorner": {
              "x": -24.802,
              "y": -13.77,
              "z": 1.109
            },
            "gtin": "4014400924008",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6457",
            "leftCorner": {
              "x": -24.802,
              "y": -13.768,
              "z": 1.109
            },
            "rightCorner": {
              "x": -24.521,
              "y": -13.769,
              "z": 1.109
            },
            "gtin": "4014400917772",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6458",
            "leftCorner": {
              "x": -24.522,
              "y": -13.774,
              "z": 1.109
            },
            "rightCorner": {
              "x": -24.263,
              "y": -13.775,
              "z": 1.109
            },
            "gtin": "4014400917994",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6459",
            "leftCorner": {
              "x": -24.263,
              "y": -13.787,
              "z": 1.109
            },
            "rightCorner": {
              "x": -23.995,
              "y": -13.787,
              "z": 1.109
            },
            "gtin": "4014400931785",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d166",
        "height": 1.6573,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d642d",
            "leftCorner": {
              "x": -25.36,
              "y": -13.812,
              "z": 1.356
            },
            "rightCorner": {
              "x": -25.228,
              "y": -13.813,
              "z": 1.356
            },
            "gtin": "4014400907636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d642e",
            "leftCorner": {
              "x": -25.228,
              "y": -13.813,
              "z": 1.356
            },
            "rightCorner": {
              "x": -25.095,
              "y": -13.813,
              "z": 1.356
            },
            "gtin": "4014400907636",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d642f",
            "leftCorner": {
              "x": -25.095,
              "y": -13.772,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.926,
              "y": -13.772,
              "z": 1.356
            },
            "gtin": "4014400908930",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6430",
            "leftCorner": {
              "x": -24.926,
              "y": -13.768,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.757,
              "y": -13.769,
              "z": 1.356
            },
            "gtin": "4014400909906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6431",
            "leftCorner": {
              "x": -24.757,
              "y": -13.773,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.517,
              "y": -13.773,
              "z": 1.356
            },
            "gtin": "4014400932485",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6432",
            "leftCorner": {
              "x": -24.516,
              "y": -13.775,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.364,
              "y": -13.776,
              "z": 1.356
            },
            "gtin": "4004363620130",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6433",
            "leftCorner": {
              "x": -24.364,
              "y": -13.785,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.232,
              "y": -13.785,
              "z": 1.356
            },
            "gtin": "4020400697422",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6434",
            "leftCorner": {
              "x": -24.231,
              "y": -13.787,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.076,
              "y": -13.789,
              "z": 1.356
            },
            "gtin": "4020400877008",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "f06"
  },
  {
    "id": "f06",
    "name": "f06",
    "x": -24.11,
    "y": -13.769,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0013875,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d171",
        "height": 0.16997,
        "facings": [
          {
            "id": "cddb211e765bab11de136fcd",
            "leftCorner": {
              "x": -24.11,
              "y": -13.855,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.997,
              "y": -13.855,
              "z": 0.139
            },
            "gtin": "4001686502396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "55eaecd908217d12ff980b17",
            "leftCorner": {
              "x": -23.997,
              "y": -13.855,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.884,
              "y": -13.856,
              "z": 0.139
            },
            "gtin": "4003840004258",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "30e05b65beb325191757961a",
            "leftCorner": {
              "x": -23.884,
              "y": -13.856,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.771,
              "y": -13.856,
              "z": 0.139
            },
            "gtin": "4001686502396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2e18b47490ceb325296ec72b",
            "leftCorner": {
              "x": -23.771,
              "y": -13.856,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.649,
              "y": -13.856,
              "z": 0.139
            },
            "gtin": "4009077020511",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "937547c756ad4b7c327b3975",
            "leftCorner": {
              "x": -23.649,
              "y": -13.856,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.522,
              "y": -13.857,
              "z": 0.139
            },
            "gtin": "4007482912100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5d8b1d5ecadf1a6b6e69b69b",
            "leftCorner": {
              "x": -23.522,
              "y": -13.857,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.394,
              "y": -13.857,
              "z": 0.139
            },
            "gtin": "4100250006312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "92c449b5edb0abb25c4cd072",
            "leftCorner": {
              "x": -23.394,
              "y": -13.857,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.259,
              "y": -13.857,
              "z": 0.139
            },
            "gtin": "4000843037016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "758c8e6f9a45c432142de7b7",
            "leftCorner": {
              "x": -23.259,
              "y": -13.857,
              "z": 0.139
            },
            "rightCorner": {
              "x": -23.12,
              "y": -13.858,
              "z": 0.139
            },
            "gtin": "4009077031333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "33a570aa1b714965627ab1bc",
            "leftCorner": {
              "x": -23.12,
              "y": -13.858,
              "z": 0.139
            },
            "rightCorner": {
              "x": -22.862,
              "y": -13.858,
              "z": 0.139
            },
            "gtin": "4001686505021",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d16d",
        "height": 0.44986,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d647d",
            "leftCorner": {
              "x": -24.058,
              "y": -13.783,
              "z": 0.368
            },
            "rightCorner": {
              "x": -23.897,
              "y": -13.784,
              "z": 0.368
            },
            "gtin": "4014400918021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d647e",
            "leftCorner": {
              "x": -23.897,
              "y": -13.777,
              "z": 0.368
            },
            "rightCorner": {
              "x": -23.673,
              "y": -13.778,
              "z": 0.368
            },
            "gtin": "4001686510032",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d647f",
            "leftCorner": {
              "x": -23.673,
              "y": -13.779,
              "z": 0.368
            },
            "rightCorner": {
              "x": -23.416,
              "y": -13.779,
              "z": 0.368
            },
            "gtin": "4001686505021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6480",
            "leftCorner": {
              "x": -23.416,
              "y": -13.778,
              "z": 0.368
            },
            "rightCorner": {
              "x": -23.164,
              "y": -13.779,
              "z": 0.368
            },
            "gtin": "4001686502082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6481",
            "leftCorner": {
              "x": -23.164,
              "y": -13.775,
              "z": 0.368
            },
            "rightCorner": {
              "x": -22.816,
              "y": -13.777,
              "z": 0.368
            },
            "gtin": "4001686536025",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d16f",
        "height": 0.74791,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64b1",
            "leftCorner": {
              "x": -24.11,
              "y": -13.789,
              "z": 0.612
            },
            "rightCorner": {
              "x": -23.883,
              "y": -13.78,
              "z": 0.612
            },
            "gtin": "4014400937480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64b2",
            "leftCorner": {
              "x": -23.883,
              "y": -13.778,
              "z": 0.612
            },
            "rightCorner": {
              "x": -23.623,
              "y": -13.779,
              "z": 0.612
            },
            "gtin": "4014400937480",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64b3",
            "leftCorner": {
              "x": -23.623,
              "y": -13.78,
              "z": 0.612
            },
            "rightCorner": {
              "x": -23.353,
              "y": -13.78,
              "z": 0.612
            },
            "gtin": "4014400937473",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64b4",
            "leftCorner": {
              "x": -23.353,
              "y": -13.778,
              "z": 0.612
            },
            "rightCorner": {
              "x": -23.062,
              "y": -13.778,
              "z": 0.612
            },
            "gtin": "4014400926279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64b5",
            "leftCorner": {
              "x": -23.062,
              "y": -13.778,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.771,
              "y": -13.78,
              "z": 0.612
            },
            "gtin": "4014400926279",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d170",
        "height": 1.0516,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6499",
            "leftCorner": {
              "x": -24.11,
              "y": -13.795,
              "z": 0.86
            },
            "rightCorner": {
              "x": -23.889,
              "y": -13.786,
              "z": 0.86
            },
            "gtin": "40144993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d649a",
            "leftCorner": {
              "x": -23.889,
              "y": -13.784,
              "z": 0.86
            },
            "rightCorner": {
              "x": -23.704,
              "y": -13.785,
              "z": 0.86
            },
            "gtin": "40144993",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d649b",
            "leftCorner": {
              "x": -23.704,
              "y": -13.782,
              "z": 0.86
            },
            "rightCorner": {
              "x": -23.447,
              "y": -13.782,
              "z": 0.86
            },
            "gtin": "4000607000010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d649c",
            "leftCorner": {
              "x": -23.447,
              "y": -13.783,
              "z": 0.86
            },
            "rightCorner": {
              "x": -23.286,
              "y": -13.784,
              "z": 0.86
            },
            "gtin": "4014400926545",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d649d",
            "leftCorner": {
              "x": -23.286,
              "y": -13.78,
              "z": 0.86
            },
            "rightCorner": {
              "x": -23.142,
              "y": -13.779,
              "z": 0.86
            },
            "gtin": "4014400928532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d649e",
            "leftCorner": {
              "x": -23.142,
              "y": -13.777,
              "z": 0.86
            },
            "rightCorner": {
              "x": -22.813,
              "y": -13.779,
              "z": 0.86
            },
            "gtin": "4014400937008",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d16c",
        "height": 1.3549,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d645a",
            "leftCorner": {
              "x": -23.995,
              "y": -13.786,
              "z": 1.109
            },
            "rightCorner": {
              "x": -23.708,
              "y": -13.788,
              "z": 1.109
            },
            "gtin": "4014400929614",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d645b",
            "leftCorner": {
              "x": -23.708,
              "y": -13.783,
              "z": 1.109
            },
            "rightCorner": {
              "x": -23.542,
              "y": -13.782,
              "z": 1.109
            },
            "gtin": "4007482908301",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d645c",
            "leftCorner": {
              "x": -23.542,
              "y": -13.781,
              "z": 1.109
            },
            "rightCorner": {
              "x": -23.413,
              "y": -13.782,
              "z": 1.109
            },
            "gtin": "4007482912100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d645d",
            "leftCorner": {
              "x": -23.413,
              "y": -13.784,
              "z": 1.109
            },
            "rightCorner": {
              "x": -23.273,
              "y": -13.784,
              "z": 1.109
            },
            "gtin": "4009077031333",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d645e",
            "leftCorner": {
              "x": -23.273,
              "y": -13.785,
              "z": 1.109
            },
            "rightCorner": {
              "x": -23.14,
              "y": -13.785,
              "z": 1.109
            },
            "gtin": "4000843037016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d645f",
            "leftCorner": {
              "x": -23.14,
              "y": -13.783,
              "z": 1.109
            },
            "rightCorner": {
              "x": -22.985,
              "y": -13.784,
              "z": 1.109
            },
            "gtin": "4000843037009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6460",
            "leftCorner": {
              "x": -22.985,
              "y": -13.782,
              "z": 1.109
            },
            "rightCorner": {
              "x": -22.818,
              "y": -13.783,
              "z": 1.109
            },
            "gtin": "4009077020511",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d16e",
        "height": 1.6545,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6435",
            "leftCorner": {
              "x": -24.076,
              "y": -13.79,
              "z": 1.354
            },
            "rightCorner": {
              "x": -23.907,
              "y": -13.79,
              "z": 1.354
            },
            "gtin": "4037400409474",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6436",
            "leftCorner": {
              "x": -23.907,
              "y": -13.785,
              "z": 1.354
            },
            "rightCorner": {
              "x": -23.73,
              "y": -13.786,
              "z": 1.354
            },
            "gtin": "4100250006541",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6437",
            "leftCorner": {
              "x": -23.73,
              "y": -13.786,
              "z": 1.354
            },
            "rightCorner": {
              "x": -23.591,
              "y": -13.786,
              "z": 1.354
            },
            "gtin": "4100250006534",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6438",
            "leftCorner": {
              "x": -23.591,
              "y": -13.784,
              "z": 1.354
            },
            "rightCorner": {
              "x": -23.461,
              "y": -13.785,
              "z": 1.354
            },
            "gtin": "4100250006312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6439",
            "leftCorner": {
              "x": -23.461,
              "y": -13.785,
              "z": 1.354
            },
            "rightCorner": {
              "x": -22.978,
              "y": -13.787,
              "z": 1.354
            },
            "gtin": "4100250006558",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d643a",
            "leftCorner": {
              "x": -22.978,
              "y": -13.779,
              "z": 1.354
            },
            "rightCorner": {
              "x": -22.712,
              "y": -13.78,
              "z": 1.354
            },
            "gtin": "4003840004258",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f05",
    "rightNeighborShelfId": "f07"
  },
  {
    "id": "f07",
    "name": "f07",
    "x": -22.86,
    "y": -13.772,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0013875,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 84,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d176",
        "height": 0.1573,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64cd",
            "leftCorner": {
              "x": -22.861,
              "y": -13.883,
              "z": 0.129
            },
            "rightCorner": {
              "x": -22.653,
              "y": -13.883,
              "z": 0.129
            },
            "gtin": "4020400893022",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64cf",
            "leftCorner": {
              "x": -22.652,
              "y": -13.838,
              "z": 0.129
            },
            "rightCorner": {
              "x": -22.493,
              "y": -13.838,
              "z": 0.129
            },
            "gtin": "4020400893091",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64d0",
            "leftCorner": {
              "x": -22.493,
              "y": -13.841,
              "z": 0.129
            },
            "rightCorner": {
              "x": -22.348,
              "y": -13.842,
              "z": 0.129
            },
            "gtin": "4020400893039",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64d1",
            "leftCorner": {
              "x": -22.348,
              "y": -13.845,
              "z": 0.129
            },
            "rightCorner": {
              "x": -22.202,
              "y": -13.846,
              "z": 0.129
            },
            "gtin": "4020400893046",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64d2",
            "leftCorner": {
              "x": -22.202,
              "y": -13.844,
              "z": 0.129
            },
            "rightCorner": {
              "x": -22.069,
              "y": -13.844,
              "z": 0.129
            },
            "gtin": "4020400893015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64d3",
            "leftCorner": {
              "x": -22.069,
              "y": -13.845,
              "z": 0.129
            },
            "rightCorner": {
              "x": -21.765,
              "y": -13.846,
              "z": 0.129
            },
            "gtin": "5410358451068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64ce",
            "leftCorner": {
              "x": -21.765,
              "y": -13.849,
              "z": 0.129
            },
            "rightCorner": {
              "x": -21.611,
              "y": -13.85,
              "z": 0.129
            },
            "gtin": "5410358459880",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d173",
        "height": 0.45256,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6482",
            "leftCorner": {
              "x": -22.817,
              "y": -13.778,
              "z": 0.37
            },
            "rightCorner": {
              "x": -22.666,
              "y": -13.778,
              "z": 0.37
            },
            "gtin": "4001686502396",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "29136e46a64166b5f7474f04",
            "leftCorner": {
              "x": -22.861,
              "y": -13.818,
              "z": 0.37
            },
            "rightCorner": {
              "x": -22.82,
              "y": -13.818,
              "z": 0.37
            },
            "gtin": "5010478548718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6483",
            "leftCorner": {
              "x": -22.666,
              "y": -13.775,
              "z": 0.37
            },
            "rightCorner": {
              "x": -22.522,
              "y": -13.775,
              "z": 0.37
            },
            "gtin": "4001686579176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6484",
            "leftCorner": {
              "x": -22.522,
              "y": -13.777,
              "z": 0.37
            },
            "rightCorner": {
              "x": -22.391,
              "y": -13.777,
              "z": 0.37
            },
            "gtin": "4003840003800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6485",
            "leftCorner": {
              "x": -22.391,
              "y": -13.779,
              "z": 0.37
            },
            "rightCorner": {
              "x": -22.266,
              "y": -13.78,
              "z": 0.37
            },
            "gtin": "4030300002660",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6486",
            "leftCorner": {
              "x": -22.266,
              "y": -13.783,
              "z": 0.37
            },
            "rightCorner": {
              "x": -21.961,
              "y": -13.784,
              "z": 0.37
            },
            "gtin": "4009077024601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6487",
            "leftCorner": {
              "x": -21.961,
              "y": -13.783,
              "z": 0.37
            },
            "rightCorner": {
              "x": -21.664,
              "y": -13.783,
              "z": 0.37
            },
            "gtin": "4009077024106",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6488",
            "leftCorner": {
              "x": -21.664,
              "y": -13.785,
              "z": 0.37
            },
            "rightCorner": {
              "x": -21.413,
              "y": -13.786,
              "z": 0.37
            },
            "gtin": "5010478548718",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d177",
        "height": 0.74826,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64b6",
            "leftCorner": {
              "x": -22.771,
              "y": -13.78,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.55,
              "y": -13.78,
              "z": 0.612
            },
            "gtin": "4009077024656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e40f66853254c73730282af1",
            "leftCorner": {
              "x": -22.861,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.858,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7555bb2999306dd20f8fa4c8",
            "leftCorner": {
              "x": -22.858,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.856,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a10508a979c67d706fe07e99",
            "leftCorner": {
              "x": -22.856,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.853,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9dd0c8fe6963e916f9404ae2",
            "leftCorner": {
              "x": -22.853,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.851,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "675c74ae03a4b8d67698e40c",
            "leftCorner": {
              "x": -22.851,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.848,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c61a8d6639a5fb0980a8cc64",
            "leftCorner": {
              "x": -22.848,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.846,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "aa756e6f97c4bca9d11aef64",
            "leftCorner": {
              "x": -22.846,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.844,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a6a4fc190d03910a0afd046a",
            "leftCorner": {
              "x": -22.844,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.841,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "71e1e9dabadbe179d22bc7f3",
            "leftCorner": {
              "x": -22.841,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.839,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "df735afc12603db685809c94",
            "leftCorner": {
              "x": -22.839,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.836,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9f27a722cb6fac9552530f7a",
            "leftCorner": {
              "x": -22.836,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.834,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6f854c20a9e010a3b02e8a4a",
            "leftCorner": {
              "x": -22.834,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.831,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b0cf8d3e2a3105eb7f77aafc",
            "leftCorner": {
              "x": -22.831,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.829,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "50ccf8e1eda11430a895c650",
            "leftCorner": {
              "x": -22.829,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.826,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "131dfa7777c09949d94c8e26",
            "leftCorner": {
              "x": -22.826,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.824,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "881f26718fc36164c35cc1a5",
            "leftCorner": {
              "x": -22.824,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.821,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "091771a998b7a7a452da9de3",
            "leftCorner": {
              "x": -22.821,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.819,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "031bf29f2de368123d917f51",
            "leftCorner": {
              "x": -22.819,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.816,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "1db652bc290d11151ce74e5f",
            "leftCorner": {
              "x": -22.816,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.814,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "feb778b337e366996a37fd48",
            "leftCorner": {
              "x": -22.814,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.812,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d90cb863b40bf1f9c3d836ed",
            "leftCorner": {
              "x": -22.812,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.809,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "38fb212ee0b4efea3db2c1ad",
            "leftCorner": {
              "x": -22.809,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.807,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "61f7bf78e895fa35daf0b504",
            "leftCorner": {
              "x": -22.807,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.804,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a6e45d31d352984eb8bf3c33",
            "leftCorner": {
              "x": -22.804,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.802,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b74a8f0e3d09f273601f2dc6",
            "leftCorner": {
              "x": -22.802,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.799,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "913f58076f539578922d96a3",
            "leftCorner": {
              "x": -22.799,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.797,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f096b5116501a5e18ab5723d",
            "leftCorner": {
              "x": -22.797,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.794,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "66b6648ca1dfa0b83fe6de90",
            "leftCorner": {
              "x": -22.794,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.792,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d405d1348bfd9ab5d8fc3172",
            "leftCorner": {
              "x": -22.792,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.789,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "32a9132d4994b1dd7e8ea891",
            "leftCorner": {
              "x": -22.789,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.787,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "568e467ac3e3a792289dfd58",
            "leftCorner": {
              "x": -22.787,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.785,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3672bd1354fbcbd96842c3c0",
            "leftCorner": {
              "x": -22.785,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.782,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "be0656137fb9d24edd21a3e4",
            "leftCorner": {
              "x": -22.782,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.78,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "19913e7137c9c5d67d0c3e34",
            "leftCorner": {
              "x": -22.78,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.777,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e39e73c533cd94c4d762a8d3",
            "leftCorner": {
              "x": -22.777,
              "y": -13.824,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.775,
              "y": -13.824,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64b7",
            "leftCorner": {
              "x": -22.55,
              "y": -13.782,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.393,
              "y": -13.782,
              "z": 0.612
            },
            "gtin": "4009077024007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64b8",
            "leftCorner": {
              "x": -22.393,
              "y": -13.782,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.235,
              "y": -13.783,
              "z": 0.612
            },
            "gtin": "4009077024007",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64b9",
            "leftCorner": {
              "x": -22.235,
              "y": -13.786,
              "z": 0.612
            },
            "rightCorner": {
              "x": -22.075,
              "y": -13.786,
              "z": 0.612
            },
            "gtin": "4009077024458",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64ba",
            "leftCorner": {
              "x": -22.075,
              "y": -13.787,
              "z": 0.612
            },
            "rightCorner": {
              "x": -21.921,
              "y": -13.787,
              "z": 0.612
            },
            "gtin": "4009077024762",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64bb",
            "leftCorner": {
              "x": -21.921,
              "y": -13.789,
              "z": 0.612
            },
            "rightCorner": {
              "x": -21.776,
              "y": -13.79,
              "z": 0.612
            },
            "gtin": "4009077026049",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64bc",
            "leftCorner": {
              "x": -21.776,
              "y": -13.79,
              "z": 0.612
            },
            "rightCorner": {
              "x": -21.612,
              "y": -13.79,
              "z": 0.612
            },
            "gtin": "4009077026087",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64bd",
            "leftCorner": {
              "x": -21.612,
              "y": -13.787,
              "z": 0.612
            },
            "rightCorner": {
              "x": -21.43,
              "y": -13.787,
              "z": 0.612
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d172",
        "height": 1.0513,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d649f",
            "leftCorner": {
              "x": -22.813,
              "y": -13.784,
              "z": 0.86
            },
            "rightCorner": {
              "x": -22.639,
              "y": -13.783,
              "z": 0.86
            },
            "gtin": "4009077024151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64a0",
            "leftCorner": {
              "x": -22.639,
              "y": -13.782,
              "z": 0.86
            },
            "rightCorner": {
              "x": -22.488,
              "y": -13.783,
              "z": 0.86
            },
            "gtin": "4009077024304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64a1",
            "leftCorner": {
              "x": -22.488,
              "y": -13.785,
              "z": 0.86
            },
            "rightCorner": {
              "x": -22.32,
              "y": -13.786,
              "z": 0.86
            },
            "gtin": "4009077024205",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64a2",
            "leftCorner": {
              "x": -22.32,
              "y": -13.787,
              "z": 0.86
            },
            "rightCorner": {
              "x": -21.986,
              "y": -13.788,
              "z": 0.86
            },
            "gtin": "4009077026018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64a3",
            "leftCorner": {
              "x": -21.986,
              "y": -13.792,
              "z": 0.86
            },
            "rightCorner": {
              "x": -21.837,
              "y": -13.792,
              "z": 0.86
            },
            "gtin": "4009077026070",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64a4",
            "leftCorner": {
              "x": -21.837,
              "y": -13.79,
              "z": 0.86
            },
            "rightCorner": {
              "x": -21.719,
              "y": -13.791,
              "z": 0.86
            },
            "gtin": "4009077026117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64a5",
            "leftCorner": {
              "x": -21.719,
              "y": -13.79,
              "z": 0.86
            },
            "rightCorner": {
              "x": -21.533,
              "y": -13.79,
              "z": 0.86
            },
            "gtin": "4009077026094",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d175",
        "height": 1.3554,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6461",
            "leftCorner": {
              "x": -22.817,
              "y": -13.784,
              "z": 1.109
            },
            "rightCorner": {
              "x": -22.697,
              "y": -13.785,
              "z": 1.109
            },
            "gtin": "4001686271278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6462",
            "leftCorner": {
              "x": -22.698,
              "y": -13.79,
              "z": 1.109
            },
            "rightCorner": {
              "x": -22.579,
              "y": -13.79,
              "z": 1.109
            },
            "gtin": "4009077020122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6463",
            "leftCorner": {
              "x": -22.579,
              "y": -13.789,
              "z": 1.109
            },
            "rightCorner": {
              "x": -22.473,
              "y": -13.79,
              "z": 1.109
            },
            "gtin": "4009077020559",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6464",
            "leftCorner": {
              "x": -22.473,
              "y": -13.79,
              "z": 1.109
            },
            "rightCorner": {
              "x": -22.325,
              "y": -13.791,
              "z": 1.109
            },
            "gtin": "4030300573115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6465",
            "leftCorner": {
              "x": -22.326,
              "y": -13.797,
              "z": 1.109
            },
            "rightCorner": {
              "x": -22.208,
              "y": -13.796,
              "z": 1.109
            },
            "gtin": "4030300573146",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6466",
            "leftCorner": {
              "x": -22.208,
              "y": -13.792,
              "z": 1.109
            },
            "rightCorner": {
              "x": -22.066,
              "y": -13.793,
              "z": 1.109
            },
            "gtin": "4030300022033",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6467",
            "leftCorner": {
              "x": -22.066,
              "y": -13.794,
              "z": 1.109
            },
            "rightCorner": {
              "x": -21.928,
              "y": -13.795,
              "z": 1.109
            },
            "gtin": "4030300022088",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6468",
            "leftCorner": {
              "x": -21.928,
              "y": -13.798,
              "z": 1.109
            },
            "rightCorner": {
              "x": -21.805,
              "y": -13.798,
              "z": 1.109
            },
            "gtin": "4030300573436",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6469",
            "leftCorner": {
              "x": -21.805,
              "y": -13.8,
              "z": 1.109
            },
            "rightCorner": {
              "x": -21.674,
              "y": -13.8,
              "z": 1.109
            },
            "gtin": "4030300022057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d646a",
            "leftCorner": {
              "x": -21.674,
              "y": -13.795,
              "z": 1.109
            },
            "rightCorner": {
              "x": -21.537,
              "y": -13.796,
              "z": 1.109
            },
            "gtin": "4030300573092",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d174",
        "height": 1.6547,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d643b",
            "leftCorner": {
              "x": -22.712,
              "y": -13.784,
              "z": 1.354
            },
            "rightCorner": {
              "x": -22.587,
              "y": -13.784,
              "z": 1.354
            },
            "gtin": "745092015456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d2bca262951854e7a236f215",
            "leftCorner": {
              "x": -22.861,
              "y": -13.826,
              "z": 1.354
            },
            "rightCorner": {
              "x": -22.713,
              "y": -13.826,
              "z": 1.354
            },
            "gtin": "7610369422189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d643c",
            "leftCorner": {
              "x": -22.588,
              "y": -13.783,
              "z": 1.354
            },
            "rightCorner": {
              "x": -22.441,
              "y": -13.784,
              "z": 1.354
            },
            "gtin": "7610369422189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d643d",
            "leftCorner": {
              "x": -22.441,
              "y": -13.787,
              "z": 1.354
            },
            "rightCorner": {
              "x": -22.299,
              "y": -13.787,
              "z": 1.354
            },
            "gtin": "7610369422226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d643e",
            "leftCorner": {
              "x": -22.299,
              "y": -13.786,
              "z": 1.354
            },
            "rightCorner": {
              "x": -22.152,
              "y": -13.787,
              "z": 1.354
            },
            "gtin": "7610369422219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d643f",
            "leftCorner": {
              "x": -22.152,
              "y": -13.786,
              "z": 1.354
            },
            "rightCorner": {
              "x": -22.009,
              "y": -13.787,
              "z": 1.354
            },
            "gtin": "7610369422233",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6440",
            "leftCorner": {
              "x": -22.009,
              "y": -13.79,
              "z": 1.354
            },
            "rightCorner": {
              "x": -21.863,
              "y": -13.79,
              "z": 1.354
            },
            "gtin": "7610700018675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6441",
            "leftCorner": {
              "x": -21.863,
              "y": -13.8,
              "z": 1.354
            },
            "rightCorner": {
              "x": -21.743,
              "y": -13.8,
              "z": 1.354
            },
            "gtin": "7610700017890",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6442",
            "leftCorner": {
              "x": -21.743,
              "y": -13.799,
              "z": 1.354
            },
            "rightCorner": {
              "x": -21.597,
              "y": -13.8,
              "z": 1.354
            },
            "gtin": "7610700014189",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f06",
    "rightNeighborShelfId": "f08"
  },
  {
    "id": "f08",
    "name": "f08",
    "x": -21.61,
    "y": -13.776,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0013875,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 45,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d17d",
        "height": 0.17051,
        "facings": [
          {
            "id": "412fea263410d2f51e94dc28",
            "leftCorner": {
              "x": -21.61,
              "y": -13.872,
              "z": 0.14
            },
            "rightCorner": {
              "x": -21.429,
              "y": -13.873,
              "z": 0.14
            },
            "gtin": "4000512365082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3ec16621372089344154b008",
            "leftCorner": {
              "x": -21.429,
              "y": -13.873,
              "z": 0.14
            },
            "rightCorner": {
              "x": -21.347,
              "y": -13.873,
              "z": 0.14
            },
            "gtin": "4002590140933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fa489353569039c17db8a4f3",
            "leftCorner": {
              "x": -21.347,
              "y": -13.873,
              "z": 0.14
            },
            "rightCorner": {
              "x": -21.256,
              "y": -13.873,
              "z": 0.14
            },
            "gtin": "4002590140124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "586e8ffe58a3f833c0728652",
            "leftCorner": {
              "x": -21.256,
              "y": -13.873,
              "z": 0.14
            },
            "rightCorner": {
              "x": -21.164,
              "y": -13.873,
              "z": 0.14
            },
            "gtin": "5010478749122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "75a3685805a93c10a050af44",
            "leftCorner": {
              "x": -21.164,
              "y": -13.873,
              "z": 0.14
            },
            "rightCorner": {
              "x": -21.066,
              "y": -13.874,
              "z": 0.14
            },
            "gtin": "4030300002851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c1d11e48101b5ac262fd23a6",
            "leftCorner": {
              "x": -21.066,
              "y": -13.874,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.959,
              "y": -13.874,
              "z": 0.14
            },
            "gtin": "5010478877535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f6e41c7757b285a635e94386",
            "leftCorner": {
              "x": -20.959,
              "y": -13.874,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.841,
              "y": -13.874,
              "z": 0.14
            },
            "gtin": "9044400841000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "64c7e1456b9ca08cf90753ce",
            "leftCorner": {
              "x": -20.841,
              "y": -13.874,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.718,
              "y": -13.875,
              "z": 0.14
            },
            "gtin": "8723400798453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6ba3893323af1451dcca0481",
            "leftCorner": {
              "x": -20.718,
              "y": -13.875,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.588,
              "y": -13.875,
              "z": 0.14
            },
            "gtin": "9044400231009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7f736c72d6c5e23e490b9216",
            "leftCorner": {
              "x": -20.588,
              "y": -13.875,
              "z": 0.14
            },
            "rightCorner": {
              "x": -20.389,
              "y": -13.875,
              "z": 0.14
            },
            "gtin": "4030300572316",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d178",
        "height": 0.44997,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6489",
            "leftCorner": {
              "x": -21.411,
              "y": -13.783,
              "z": 0.368
            },
            "rightCorner": {
              "x": -21.107,
              "y": -13.784,
              "z": 0.368
            },
            "gtin": "4033500101577",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3490495aa7ee5196d334134e",
            "leftCorner": {
              "x": -21.609,
              "y": -13.824,
              "z": 0.368
            },
            "rightCorner": {
              "x": -21.448,
              "y": -13.824,
              "z": 0.368
            },
            "gtin": "8710497964151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d648a",
            "leftCorner": {
              "x": -21.107,
              "y": -13.784,
              "z": 0.368
            },
            "rightCorner": {
              "x": -20.826,
              "y": -13.785,
              "z": 0.368
            },
            "gtin": "4003840003800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d648b",
            "leftCorner": {
              "x": -20.826,
              "y": -13.788,
              "z": 0.368
            },
            "rightCorner": {
              "x": -20.541,
              "y": -13.789,
              "z": 0.368
            },
            "gtin": "4100250005612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d648c",
            "leftCorner": {
              "x": -20.541,
              "y": -13.79,
              "z": 0.368
            },
            "rightCorner": {
              "x": -20.291,
              "y": -13.79,
              "z": 0.368
            },
            "gtin": "8710497964151",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d17b",
        "height": 0.74763,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64be",
            "leftCorner": {
              "x": -21.429,
              "y": -13.786,
              "z": 0.612
            },
            "rightCorner": {
              "x": -21.292,
              "y": -13.786,
              "z": 0.612
            },
            "gtin": "4014437132537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64bf",
            "leftCorner": {
              "x": -21.292,
              "y": -13.787,
              "z": 0.612
            },
            "rightCorner": {
              "x": -21.094,
              "y": -13.788,
              "z": 0.612
            },
            "gtin": "4014437332531",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64c0",
            "leftCorner": {
              "x": -21.094,
              "y": -13.79,
              "z": 0.612
            },
            "rightCorner": {
              "x": -20.854,
              "y": -13.791,
              "z": 0.612
            },
            "gtin": "4033500101959",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64c1",
            "leftCorner": {
              "x": -20.854,
              "y": -13.792,
              "z": 0.612
            },
            "rightCorner": {
              "x": -20.71,
              "y": -13.793,
              "z": 0.612
            },
            "gtin": "4000843038006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64c2",
            "leftCorner": {
              "x": -20.71,
              "y": -13.793,
              "z": 0.612
            },
            "rightCorner": {
              "x": -20.616,
              "y": -13.792,
              "z": 0.612
            },
            "gtin": "5010478749122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64c3",
            "leftCorner": {
              "x": -20.616,
              "y": -13.794,
              "z": 0.612
            },
            "rightCorner": {
              "x": -20.511,
              "y": -13.795,
              "z": 0.612
            },
            "gtin": "5010478877535",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64ac",
            "leftCorner": {
              "x": -20.511,
              "y": -13.795,
              "z": 0.612
            },
            "rightCorner": {
              "x": -20.36,
              "y": -13.795,
              "z": 0.612
            },
            "gtin": "4004363300018",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "57cec79a0668b8d7ec507bdc",
            "leftCorner": {
              "x": -21.61,
              "y": -13.83,
              "z": 0.612
            },
            "rightCorner": {
              "x": -21.458,
              "y": -13.83,
              "z": 0.612
            },
            "gtin": "4004363300018",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d17c",
        "height": 1.0497,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64a6",
            "leftCorner": {
              "x": -21.532,
              "y": -13.789,
              "z": 0.859
            },
            "rightCorner": {
              "x": -21.292,
              "y": -13.789,
              "z": 0.859
            },
            "gtin": "4014400930078",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64a7",
            "leftCorner": {
              "x": -21.292,
              "y": -13.79,
              "z": 0.859
            },
            "rightCorner": {
              "x": -21.118,
              "y": -13.791,
              "z": 0.859
            },
            "gtin": "8410031132519",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64a8",
            "leftCorner": {
              "x": -21.118,
              "y": -13.791,
              "z": 0.859
            },
            "rightCorner": {
              "x": -20.967,
              "y": -13.791,
              "z": 0.859
            },
            "gtin": "8410031990584",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64a9",
            "leftCorner": {
              "x": -20.967,
              "y": -13.792,
              "z": 0.859
            },
            "rightCorner": {
              "x": -20.799,
              "y": -13.793,
              "z": 0.859
            },
            "gtin": "8410031972337",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64aa",
            "leftCorner": {
              "x": -20.799,
              "y": -13.795,
              "z": 0.859
            },
            "rightCorner": {
              "x": -20.503,
              "y": -13.796,
              "z": 0.859
            },
            "gtin": "6921211116127",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6494",
            "leftCorner": {
              "x": -20.503,
              "y": -13.796,
              "z": 0.859
            },
            "rightCorner": {
              "x": -20.36,
              "y": -13.796,
              "z": 0.859
            },
            "gtin": "4003840004302",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d17a",
        "height": 1.3539,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d646b",
            "leftCorner": {
              "x": -21.536,
              "y": -13.789,
              "z": 1.108
            },
            "rightCorner": {
              "x": -21.445,
              "y": -13.789,
              "z": 1.108
            },
            "gtin": "4002590140124",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d646c",
            "leftCorner": {
              "x": -21.445,
              "y": -13.793,
              "z": 1.108
            },
            "rightCorner": {
              "x": -21.362,
              "y": -13.793,
              "z": 1.108
            },
            "gtin": "4002590140933",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d646d",
            "leftCorner": {
              "x": -21.362,
              "y": -13.793,
              "z": 1.108
            },
            "rightCorner": {
              "x": -21.231,
              "y": -13.793,
              "z": 1.108
            },
            "gtin": "8723400798453",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d646e",
            "leftCorner": {
              "x": -21.231,
              "y": -13.797,
              "z": 1.108
            },
            "rightCorner": {
              "x": -21.094,
              "y": -13.798,
              "z": 1.108
            },
            "gtin": "4002318001010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d646f",
            "leftCorner": {
              "x": -21.094,
              "y": -13.794,
              "z": 1.108
            },
            "rightCorner": {
              "x": -20.901,
              "y": -13.795,
              "z": 1.108
            },
            "gtin": "4000211055000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6470",
            "leftCorner": {
              "x": -20.901,
              "y": -13.799,
              "z": 1.108
            },
            "rightCorner": {
              "x": -20.731,
              "y": -13.799,
              "z": 1.108
            },
            "gtin": "4009077555235",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6471",
            "leftCorner": {
              "x": -20.731,
              "y": -13.803,
              "z": 1.108
            },
            "rightCorner": {
              "x": -20.47,
              "y": -13.804,
              "z": 1.108
            },
            "gtin": "9044400231009",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6472",
            "leftCorner": {
              "x": -20.47,
              "y": -13.805,
              "z": 1.108
            },
            "rightCorner": {
              "x": -20.202,
              "y": -13.805,
              "z": 1.108
            },
            "gtin": "9044400841000",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d179",
        "height": 1.6529,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6443",
            "leftCorner": {
              "x": -21.596,
              "y": -13.791,
              "z": 1.352
            },
            "rightCorner": {
              "x": -21.442,
              "y": -13.791,
              "z": 1.352
            },
            "gtin": "4030300002851",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6444",
            "leftCorner": {
              "x": -21.442,
              "y": -13.79,
              "z": 1.352
            },
            "rightCorner": {
              "x": -21.344,
              "y": -13.79,
              "z": 1.352
            },
            "gtin": "4030300573306",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6445",
            "leftCorner": {
              "x": -21.344,
              "y": -13.789,
              "z": 1.352
            },
            "rightCorner": {
              "x": -21.215,
              "y": -13.79,
              "z": 1.352
            },
            "gtin": "4030300022811",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6446",
            "leftCorner": {
              "x": -21.215,
              "y": -13.791,
              "z": 1.352
            },
            "rightCorner": {
              "x": -21.061,
              "y": -13.791,
              "z": 1.352
            },
            "gtin": "4030300004350",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6447",
            "leftCorner": {
              "x": -21.061,
              "y": -13.793,
              "z": 1.352
            },
            "rightCorner": {
              "x": -20.924,
              "y": -13.793,
              "z": 1.352
            },
            "gtin": "4030300001656",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6448",
            "leftCorner": {
              "x": -20.924,
              "y": -13.795,
              "z": 1.352
            },
            "rightCorner": {
              "x": -20.734,
              "y": -13.796,
              "z": 1.352
            },
            "gtin": "4030300572057",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6449",
            "leftCorner": {
              "x": -20.734,
              "y": -13.798,
              "z": 1.352
            },
            "rightCorner": {
              "x": -20.57,
              "y": -13.799,
              "z": 1.352
            },
            "gtin": "4030300572040",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d644a",
            "leftCorner": {
              "x": -20.57,
              "y": -13.801,
              "z": 1.352
            },
            "rightCorner": {
              "x": -20.315,
              "y": -13.801,
              "z": 1.352
            },
            "gtin": "4030300572316",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f07",
    "rightNeighborShelfId": "f09"
  },
  {
    "id": "f09",
    "name": "f09",
    "x": -20.36,
    "y": -13.779,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.0013875,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 52,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6e1",
        "height": 0.15787,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d871a",
            "leftCorner": {
              "x": -20.36,
              "y": -13.644,
              "z": 0.129
            },
            "rightCorner": {
              "x": -20.007,
              "y": -13.645,
              "z": 0.129
            },
            "gtin": "4018356070246",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d871c",
            "leftCorner": {
              "x": -20.007,
              "y": -13.618,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.784,
              "y": -13.619,
              "z": 0.129
            },
            "gtin": "8002267002270",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d871d",
            "leftCorner": {
              "x": -19.784,
              "y": -13.607,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.541,
              "y": -13.608,
              "z": 0.129
            },
            "gtin": "4262518327000",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d871e",
            "leftCorner": {
              "x": -19.541,
              "y": -13.607,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.253,
              "y": -13.607,
              "z": 0.129
            },
            "gtin": "4003840004005",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d871b",
            "leftCorner": {
              "x": -19.253,
              "y": -13.608,
              "z": 0.129
            },
            "rightCorner": {
              "x": -19.109,
              "y": -13.609,
              "z": 0.129
            },
            "gtin": "4003840003992",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6dc",
        "height": 0.45039,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d648d",
            "leftCorner": {
              "x": -20.291,
              "y": -13.566,
              "z": 0.369
            },
            "rightCorner": {
              "x": -20.148,
              "y": -13.567,
              "z": 0.369
            },
            "gtin": "87108729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d648e",
            "leftCorner": {
              "x": -20.148,
              "y": -13.561,
              "z": 0.369
            },
            "rightCorner": {
              "x": -19.983,
              "y": -13.561,
              "z": 0.369
            },
            "gtin": "87108743",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d648f",
            "leftCorner": {
              "x": -19.983,
              "y": -13.556,
              "z": 0.369
            },
            "rightCorner": {
              "x": -19.636,
              "y": -13.556,
              "z": 0.369
            },
            "gtin": "8723400829751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6490",
            "leftCorner": {
              "x": -19.636,
              "y": -13.551,
              "z": 0.369
            },
            "rightCorner": {
              "x": -19.457,
              "y": -13.551,
              "z": 0.369
            },
            "gtin": "87108675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6491",
            "leftCorner": {
              "x": -19.457,
              "y": -13.547,
              "z": 0.369
            },
            "rightCorner": {
              "x": -19.322,
              "y": -13.548,
              "z": 0.369
            },
            "gtin": "8723400758518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6492",
            "leftCorner": {
              "x": -19.322,
              "y": -13.553,
              "z": 0.369
            },
            "rightCorner": {
              "x": -19.166,
              "y": -13.553,
              "z": 0.369
            },
            "gtin": "8723400769828",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6479",
            "leftCorner": {
              "x": -19.166,
              "y": -13.552,
              "z": 0.369
            },
            "rightCorner": {
              "x": -19.11,
              "y": -13.551,
              "z": 0.369
            },
            "gtin": "8723400795780",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "244df54d1255a124b82d3474",
            "leftCorner": {
              "x": -20.359,
              "y": -13.589,
              "z": 0.369
            },
            "rightCorner": {
              "x": -20.312,
              "y": -13.589,
              "z": 0.369
            },
            "gtin": "8723400795780",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6df",
        "height": 0.67436,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d870a",
            "leftCorner": {
              "x": -20.359,
              "y": -13.591,
              "z": 0.552
            },
            "rightCorner": {
              "x": -20.035,
              "y": -13.592,
              "z": 0.552
            },
            "gtin": "8000500153475",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d870c",
            "leftCorner": {
              "x": -20.036,
              "y": -13.563,
              "z": 0.552
            },
            "rightCorner": {
              "x": -19.915,
              "y": -13.564,
              "z": 0.552
            },
            "gtin": "8000500153383",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d870d",
            "leftCorner": {
              "x": -19.914,
              "y": -13.557,
              "z": 0.552
            },
            "rightCorner": {
              "x": -19.797,
              "y": -13.557,
              "z": 0.552
            },
            "gtin": "5000357100137",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d870e",
            "leftCorner": {
              "x": -19.797,
              "y": -13.554,
              "z": 0.552
            },
            "rightCorner": {
              "x": -19.676,
              "y": -13.554,
              "z": 0.552
            },
            "gtin": "5000357104777",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d870f",
            "leftCorner": {
              "x": -19.676,
              "y": -13.557,
              "z": 0.552
            },
            "rightCorner": {
              "x": -19.536,
              "y": -13.557,
              "z": 0.552
            },
            "gtin": "4020400899079",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8710",
            "leftCorner": {
              "x": -19.536,
              "y": -13.553,
              "z": 0.552
            },
            "rightCorner": {
              "x": -19.428,
              "y": -13.553,
              "z": 0.552
            },
            "gtin": "4020400001113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8711",
            "leftCorner": {
              "x": -19.428,
              "y": -13.554,
              "z": 0.552
            },
            "rightCorner": {
              "x": -19.319,
              "y": -13.554,
              "z": 0.552
            },
            "gtin": "4020400699273",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8712",
            "leftCorner": {
              "x": -19.319,
              "y": -13.555,
              "z": 0.552
            },
            "rightCorner": {
              "x": -19.177,
              "y": -13.555,
              "z": 0.552
            },
            "gtin": "8710559000148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d870b",
            "leftCorner": {
              "x": -19.177,
              "y": -13.553,
              "z": 0.552
            },
            "rightCorner": {
              "x": -19.11,
              "y": -13.553,
              "z": 0.552
            },
            "gtin": "4009371246013",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6e0",
        "height": 0.95098,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8713",
            "leftCorner": {
              "x": -20.359,
              "y": -13.594,
              "z": 0.778
            },
            "rightCorner": {
              "x": -20.02,
              "y": -13.595,
              "z": 0.778
            },
            "gtin": "4009900360937",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8715",
            "leftCorner": {
              "x": -20.021,
              "y": -13.562,
              "z": 0.778
            },
            "rightCorner": {
              "x": -19.861,
              "y": -13.563,
              "z": 0.778
            },
            "gtin": "4009900376600",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8716",
            "leftCorner": {
              "x": -19.861,
              "y": -13.557,
              "z": 0.778
            },
            "rightCorner": {
              "x": -19.733,
              "y": -13.557,
              "z": 0.778
            },
            "gtin": "4009900398640",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8717",
            "leftCorner": {
              "x": -19.733,
              "y": -13.563,
              "z": 0.778
            },
            "rightCorner": {
              "x": -19.53,
              "y": -13.564,
              "z": 0.778
            },
            "gtin": "4008429162510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8718",
            "leftCorner": {
              "x": -19.53,
              "y": -13.557,
              "z": 0.778
            },
            "rightCorner": {
              "x": -19.396,
              "y": -13.557,
              "z": 0.778
            },
            "gtin": "8410031950908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8719",
            "leftCorner": {
              "x": -19.396,
              "y": -13.559,
              "z": 0.778
            },
            "rightCorner": {
              "x": -19.226,
              "y": -13.558,
              "z": 0.778
            },
            "gtin": "8003440992654",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8714",
            "leftCorner": {
              "x": -19.226,
              "y": -13.559,
              "z": 0.778
            },
            "rightCorner": {
              "x": -19.11,
              "y": -13.559,
              "z": 0.778
            },
            "gtin": "4004641211982",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6dd",
        "height": 1.154,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d8702",
            "leftCorner": {
              "x": -20.359,
              "y": -13.597,
              "z": 0.944
            },
            "rightCorner": {
              "x": -20.144,
              "y": -13.597,
              "z": 0.944
            },
            "gtin": "4009900544368",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8704",
            "leftCorner": {
              "x": -20.145,
              "y": -13.57,
              "z": 0.944
            },
            "rightCorner": {
              "x": -20.009,
              "y": -13.571,
              "z": 0.944
            },
            "gtin": "4009900544030",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8705",
            "leftCorner": {
              "x": -20.009,
              "y": -13.561,
              "z": 0.944
            },
            "rightCorner": {
              "x": -19.862,
              "y": -13.562,
              "z": 0.944
            },
            "gtin": "4009900544122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8706",
            "leftCorner": {
              "x": -19.862,
              "y": -13.557,
              "z": 0.944
            },
            "rightCorner": {
              "x": -19.712,
              "y": -13.558,
              "z": 0.944
            },
            "gtin": "4009900543903",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8707",
            "leftCorner": {
              "x": -19.712,
              "y": -13.561,
              "z": 0.944
            },
            "rightCorner": {
              "x": -19.535,
              "y": -13.562,
              "z": 0.944
            },
            "gtin": "4009900379564",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8708",
            "leftCorner": {
              "x": -19.535,
              "y": -13.558,
              "z": 0.944
            },
            "rightCorner": {
              "x": -19.368,
              "y": -13.558,
              "z": 0.944
            },
            "gtin": "4009900381352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8709",
            "leftCorner": {
              "x": -19.368,
              "y": -13.559,
              "z": 0.944
            },
            "rightCorner": {
              "x": -19.187,
              "y": -13.559,
              "z": 0.944
            },
            "gtin": "4009900406918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8703",
            "leftCorner": {
              "x": -19.187,
              "y": -13.556,
              "z": 0.944
            },
            "rightCorner": {
              "x": -19.11,
              "y": -13.556,
              "z": 0.944
            },
            "gtin": "4009900476812",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6db",
        "height": 1.3576,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6473",
            "leftCorner": {
              "x": -20.202,
              "y": -13.579,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.977,
              "y": -13.579,
              "z": 1.111
            },
            "gtin": "5997591100262",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6474",
            "leftCorner": {
              "x": -19.977,
              "y": -13.568,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.758,
              "y": -13.568,
              "z": 1.111
            },
            "gtin": "4038448016327",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6475",
            "leftCorner": {
              "x": -19.758,
              "y": -13.562,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.591,
              "y": -13.563,
              "z": 1.111
            },
            "gtin": "8713600053452",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6476",
            "leftCorner": {
              "x": -19.591,
              "y": -13.562,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.427,
              "y": -13.563,
              "z": 1.111
            },
            "gtin": "4000266110105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6477",
            "leftCorner": {
              "x": -19.427,
              "y": -13.566,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.166,
              "y": -13.567,
              "z": 1.111
            },
            "gtin": "5010478428102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6455",
            "leftCorner": {
              "x": -19.166,
              "y": -13.566,
              "z": 1.111
            },
            "rightCorner": {
              "x": -19.11,
              "y": -13.565,
              "z": 1.111
            },
            "gtin": "40335711",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3ef5203861ed7a6bd66f4e9d",
            "leftCorner": {
              "x": -20.359,
              "y": -13.602,
              "z": 1.111
            },
            "rightCorner": {
              "x": -20.212,
              "y": -13.602,
              "z": 1.111
            },
            "gtin": "8713600053452",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6de",
        "height": 1.6541,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d644b",
            "leftCorner": {
              "x": -20.315,
              "y": -13.581,
              "z": 1.353
            },
            "rightCorner": {
              "x": -20.12,
              "y": -13.581,
              "z": 1.353
            },
            "gtin": "40468679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d644d",
            "leftCorner": {
              "x": -20.08,
              "y": -13.571,
              "z": 1.353
            },
            "rightCorner": {
              "x": -19.975,
              "y": -13.571,
              "z": 1.353
            },
            "gtin": "40468266",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d644e",
            "leftCorner": {
              "x": -19.975,
              "y": -13.569,
              "z": 1.353
            },
            "rightCorner": {
              "x": -19.867,
              "y": -13.569,
              "z": 1.353
            },
            "gtin": "42369318",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d644f",
            "leftCorner": {
              "x": -19.866,
              "y": -13.589,
              "z": 1.353
            },
            "rightCorner": {
              "x": -19.778,
              "y": -13.59,
              "z": 1.353
            },
            "gtin": "42214663",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6450",
            "leftCorner": {
              "x": -19.779,
              "y": -13.564,
              "z": 1.353
            },
            "rightCorner": {
              "x": -19.598,
              "y": -13.564,
              "z": 1.353
            },
            "gtin": "7610369421915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6451",
            "leftCorner": {
              "x": -19.598,
              "y": -13.564,
              "z": 1.353
            },
            "rightCorner": {
              "x": -19.506,
              "y": -13.564,
              "z": 1.353
            },
            "gtin": "7610369415778",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6452",
            "leftCorner": {
              "x": -19.506,
              "y": -13.563,
              "z": 1.353
            },
            "rightCorner": {
              "x": -19.318,
              "y": -13.563,
              "z": 1.353
            },
            "gtin": "4033500101768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6453",
            "leftCorner": {
              "x": -19.318,
              "y": -13.565,
              "z": 1.353
            },
            "rightCorner": {
              "x": -19.138,
              "y": -13.566,
              "z": 1.353
            },
            "gtin": "40335759",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f08"
  },
  {
    "id": "f0a",
    "name": "f0a",
    "x": -19.069,
    "y": -15.348,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99994,
      "w": 0.010943
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 70,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d183",
        "height": 0.17836,
        "facings": [
          {
            "id": "3670e4f25b29a14eba8a077a",
            "leftCorner": {
              "x": -19.067,
              "y": -15.265,
              "z": 0.146
            },
            "rightCorner": {
              "x": -19.124,
              "y": -15.264,
              "z": 0.146
            },
            "gtin": "8712514929051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d88cb399caaa80f946601314",
            "leftCorner": {
              "x": -19.124,
              "y": -15.264,
              "z": 0.146
            },
            "rightCorner": {
              "x": -19.315,
              "y": -15.26,
              "z": 0.146
            },
            "gtin": "4000843054877",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5fcaa7ae3200a1b7a8a93a4b",
            "leftCorner": {
              "x": -19.315,
              "y": -15.26,
              "z": 0.146
            },
            "rightCorner": {
              "x": -19.372,
              "y": -15.258,
              "z": 0.146
            },
            "gtin": "8712514929051",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "078a118d6c821887f834c20d",
            "leftCorner": {
              "x": -19.372,
              "y": -15.258,
              "z": 0.146
            },
            "rightCorner": {
              "x": -19.43,
              "y": -15.257,
              "z": 0.146
            },
            "gtin": "8712514929105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "92f910201d49039741b68f56",
            "leftCorner": {
              "x": -19.43,
              "y": -15.257,
              "z": 0.146
            },
            "rightCorner": {
              "x": -19.489,
              "y": -15.256,
              "z": 0.146
            },
            "gtin": "8712514929167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3a98742eab23150935ef11fa",
            "leftCorner": {
              "x": -19.489,
              "y": -15.256,
              "z": 0.146
            },
            "rightCorner": {
              "x": -19.551,
              "y": -15.254,
              "z": 0.146
            },
            "gtin": "8712514929525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "67c1e3bce2285b09ecec6ec6",
            "leftCorner": {
              "x": -19.551,
              "y": -15.254,
              "z": 0.146
            },
            "rightCorner": {
              "x": -19.613,
              "y": -15.253,
              "z": 0.146
            },
            "gtin": "8712514996732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "131ae6ea4b49b08df5f1f3d0",
            "leftCorner": {
              "x": -19.613,
              "y": -15.253,
              "z": 0.146
            },
            "rightCorner": {
              "x": -19.677,
              "y": -15.252,
              "z": 0.146
            },
            "gtin": "8712514929648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2acc48ec0d94f7d1f977fdb1",
            "leftCorner": {
              "x": -19.677,
              "y": -15.252,
              "z": 0.146
            },
            "rightCorner": {
              "x": -19.745,
              "y": -15.25,
              "z": 0.146
            },
            "gtin": "8712514929044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "71ae0c5eabdc924fe3061980",
            "leftCorner": {
              "x": -19.745,
              "y": -15.25,
              "z": 0.146
            },
            "rightCorner": {
              "x": -19.814,
              "y": -15.249,
              "z": 0.146
            },
            "gtin": "8712514929013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f23946954381d806901c6672",
            "leftCorner": {
              "x": -19.814,
              "y": -15.249,
              "z": 0.146
            },
            "rightCorner": {
              "x": -19.886,
              "y": -15.247,
              "z": 0.146
            },
            "gtin": "8712514929617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "278f53779484998b4c84bcff",
            "leftCorner": {
              "x": -19.886,
              "y": -15.247,
              "z": 0.146
            },
            "rightCorner": {
              "x": -19.958,
              "y": -15.245,
              "z": 0.146
            },
            "gtin": "8712514996756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6654d01b03e60d3c2c9b1843",
            "leftCorner": {
              "x": -19.958,
              "y": -15.245,
              "z": 0.146
            },
            "rightCorner": {
              "x": -20.033,
              "y": -15.244,
              "z": 0.146
            },
            "gtin": "8712514929228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c41f03fb17583ff5454cecc7",
            "leftCorner": {
              "x": -20.033,
              "y": -15.244,
              "z": 0.146
            },
            "rightCorner": {
              "x": -20.229,
              "y": -15.24,
              "z": 0.146
            },
            "gtin": "4000843054679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d417babb390022c956f118c0",
            "leftCorner": {
              "x": -20.229,
              "y": -15.24,
              "z": 0.146
            },
            "rightCorner": {
              "x": -20.317,
              "y": -15.238,
              "z": 0.146
            },
            "gtin": "8712514929594",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d17f",
        "height": 0.51006,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64fa",
            "leftCorner": {
              "x": -19.068,
              "y": -15.304,
              "z": 0.417
            },
            "rightCorner": {
              "x": -19.251,
              "y": -15.3,
              "z": 0.417
            },
            "gtin": "4000843054723",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64fc",
            "leftCorner": {
              "x": -19.252,
              "y": -15.341,
              "z": 0.417
            },
            "rightCorner": {
              "x": -19.349,
              "y": -15.339,
              "z": 0.417
            },
            "gtin": "4000843015953",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64fd",
            "leftCorner": {
              "x": -19.349,
              "y": -15.338,
              "z": 0.417
            },
            "rightCorner": {
              "x": -19.446,
              "y": -15.336,
              "z": 0.417
            },
            "gtin": "4000843054655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64fe",
            "leftCorner": {
              "x": -19.446,
              "y": -15.336,
              "z": 0.417
            },
            "rightCorner": {
              "x": -19.541,
              "y": -15.334,
              "z": 0.417
            },
            "gtin": "4000843055607",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d64ff",
            "leftCorner": {
              "x": -19.541,
              "y": -15.334,
              "z": 0.417
            },
            "rightCorner": {
              "x": -19.725,
              "y": -15.33,
              "z": 0.417
            },
            "gtin": "4000843055683",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6500",
            "leftCorner": {
              "x": -19.725,
              "y": -15.322,
              "z": 0.417
            },
            "rightCorner": {
              "x": -19.916,
              "y": -15.318,
              "z": 0.417
            },
            "gtin": "4000843054716",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6501",
            "leftCorner": {
              "x": -19.916,
              "y": -15.314,
              "z": 0.417
            },
            "rightCorner": {
              "x": -20.044,
              "y": -15.311,
              "z": 0.417
            },
            "gtin": "4000843015939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6502",
            "leftCorner": {
              "x": -20.044,
              "y": -15.311,
              "z": 0.417
            },
            "rightCorner": {
              "x": -20.171,
              "y": -15.308,
              "z": 0.417
            },
            "gtin": "4000843015939",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6503",
            "leftCorner": {
              "x": -20.171,
              "y": -15.311,
              "z": 0.417
            },
            "rightCorner": {
              "x": -20.38,
              "y": -15.308,
              "z": 0.417
            },
            "gtin": "4000512363729",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d182",
        "height": 0.81103,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d656c",
            "leftCorner": {
              "x": -19.068,
              "y": -15.305,
              "z": 0.664
            },
            "rightCorner": {
              "x": -19.248,
              "y": -15.301,
              "z": 0.664
            },
            "gtin": "4000843054686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d656e",
            "leftCorner": {
              "x": -19.249,
              "y": -15.346,
              "z": 0.664
            },
            "rightCorner": {
              "x": -19.345,
              "y": -15.344,
              "z": 0.664
            },
            "gtin": "4000843054525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d656f",
            "leftCorner": {
              "x": -19.345,
              "y": -15.344,
              "z": 0.664
            },
            "rightCorner": {
              "x": -19.442,
              "y": -15.342,
              "z": 0.664
            },
            "gtin": "4000843054525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6570",
            "leftCorner": {
              "x": -19.442,
              "y": -15.338,
              "z": 0.664
            },
            "rightCorner": {
              "x": -19.635,
              "y": -15.334,
              "z": 0.664
            },
            "gtin": "4000843054679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6571",
            "leftCorner": {
              "x": -19.635,
              "y": -15.331,
              "z": 0.664
            },
            "rightCorner": {
              "x": -19.824,
              "y": -15.327,
              "z": 0.664
            },
            "gtin": "4000843053900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6572",
            "leftCorner": {
              "x": -19.823,
              "y": -15.318,
              "z": 0.664
            },
            "rightCorner": {
              "x": -20.022,
              "y": -15.314,
              "z": 0.664
            },
            "gtin": "4000843054709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6573",
            "leftCorner": {
              "x": -20.022,
              "y": -15.314,
              "z": 0.664
            },
            "rightCorner": {
              "x": -20.222,
              "y": -15.309,
              "z": 0.664
            },
            "gtin": "4000843054709",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6574",
            "leftCorner": {
              "x": -20.223,
              "y": -15.313,
              "z": 0.664
            },
            "rightCorner": {
              "x": -20.361,
              "y": -15.31,
              "z": 0.664
            },
            "gtin": "4000843055553",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d180",
        "height": 1.1143,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d651b",
            "leftCorner": {
              "x": -19.068,
              "y": -15.3,
              "z": 0.912
            },
            "rightCorner": {
              "x": -19.193,
              "y": -15.298,
              "z": 0.912
            },
            "gtin": "8712514091901",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d651d",
            "leftCorner": {
              "x": -19.194,
              "y": -15.347,
              "z": 0.912
            },
            "rightCorner": {
              "x": -19.294,
              "y": -15.344,
              "z": 0.912
            },
            "gtin": "8712514092304",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d651e",
            "leftCorner": {
              "x": -19.294,
              "y": -15.344,
              "z": 0.912
            },
            "rightCorner": {
              "x": -19.456,
              "y": -15.341,
              "z": 0.912
            },
            "gtin": "8712514092342",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d651f",
            "leftCorner": {
              "x": -19.456,
              "y": -15.344,
              "z": 0.912
            },
            "rightCorner": {
              "x": -19.748,
              "y": -15.337,
              "z": 0.912
            },
            "gtin": "8712514091918",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6520",
            "leftCorner": {
              "x": -19.748,
              "y": -15.325,
              "z": 0.912
            },
            "rightCorner": {
              "x": -19.862,
              "y": -15.322,
              "z": 0.912
            },
            "gtin": "8712514091949",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6521",
            "leftCorner": {
              "x": -19.862,
              "y": -15.322,
              "z": 0.912
            },
            "rightCorner": {
              "x": -19.95,
              "y": -15.321,
              "z": 0.912
            },
            "gtin": "8712514996718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6522",
            "leftCorner": {
              "x": -19.95,
              "y": -15.319,
              "z": 0.912
            },
            "rightCorner": {
              "x": -20.019,
              "y": -15.318,
              "z": 0.912
            },
            "gtin": "8712514996756",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6523",
            "leftCorner": {
              "x": -20.019,
              "y": -15.319,
              "z": 0.912
            },
            "rightCorner": {
              "x": -20.075,
              "y": -15.317,
              "z": 0.912
            },
            "gtin": "8712514996732",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6524",
            "leftCorner": {
              "x": -20.075,
              "y": -15.317,
              "z": 0.912
            },
            "rightCorner": {
              "x": -20.179,
              "y": -15.315,
              "z": 0.912
            },
            "gtin": "8712514996725",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6525",
            "leftCorner": {
              "x": -20.179,
              "y": -15.317,
              "z": 0.912
            },
            "rightCorner": {
              "x": -20.351,
              "y": -15.313,
              "z": 0.912
            },
            "gtin": "8712514996749",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d181",
        "height": 1.4187,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6541",
            "leftCorner": {
              "x": -19.068,
              "y": -15.305,
              "z": 1.161
            },
            "rightCorner": {
              "x": -19.163,
              "y": -15.303,
              "z": 1.161
            },
            "gtin": "8712514929020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e16a4b30b458e7b7d3ae3718",
            "leftCorner": {
              "x": -19.832,
              "y": -15.288,
              "z": 1.161
            },
            "rightCorner": {
              "x": -19.891,
              "y": -15.287,
              "z": 1.161
            },
            "gtin": "8712514929167",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6543",
            "leftCorner": {
              "x": -19.164,
              "y": -15.348,
              "z": 1.161
            },
            "rightCorner": {
              "x": -19.235,
              "y": -15.347,
              "z": 1.161
            },
            "gtin": "8712514929228",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6544",
            "leftCorner": {
              "x": -19.235,
              "y": -15.344,
              "z": 1.161
            },
            "rightCorner": {
              "x": -19.288,
              "y": -15.343,
              "z": 1.161
            },
            "gtin": "8712514929105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6545",
            "leftCorner": {
              "x": -19.288,
              "y": -15.345,
              "z": 1.161
            },
            "rightCorner": {
              "x": -19.353,
              "y": -15.343,
              "z": 1.161
            },
            "gtin": "8712514929013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6546",
            "leftCorner": {
              "x": -19.353,
              "y": -15.341,
              "z": 1.161
            },
            "rightCorner": {
              "x": -19.44,
              "y": -15.339,
              "z": 1.161
            },
            "gtin": "8712514929037",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6547",
            "leftCorner": {
              "x": -19.44,
              "y": -15.338,
              "z": 1.161
            },
            "rightCorner": {
              "x": -19.514,
              "y": -15.336,
              "z": 1.161
            },
            "gtin": "8712514929143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6548",
            "leftCorner": {
              "x": -19.514,
              "y": -15.336,
              "z": 1.161
            },
            "rightCorner": {
              "x": -19.595,
              "y": -15.335,
              "z": 1.161
            },
            "gtin": "8712514929068",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6549",
            "leftCorner": {
              "x": -19.595,
              "y": -15.336,
              "z": 1.161
            },
            "rightCorner": {
              "x": -19.667,
              "y": -15.334,
              "z": 1.161
            },
            "gtin": "8712514929044",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d654a",
            "leftCorner": {
              "x": -19.667,
              "y": -15.331,
              "z": 1.161
            },
            "rightCorner": {
              "x": -19.743,
              "y": -15.329,
              "z": 1.161
            },
            "gtin": "8712514929099",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d654b",
            "leftCorner": {
              "x": -19.744,
              "y": -15.323,
              "z": 1.161
            },
            "rightCorner": {
              "x": -19.833,
              "y": -15.321,
              "z": 1.161
            },
            "gtin": "8712514929112",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d654d",
            "leftCorner": {
              "x": -19.892,
              "y": -15.316,
              "z": 1.161
            },
            "rightCorner": {
              "x": -19.969,
              "y": -15.314,
              "z": 1.161
            },
            "gtin": "8712514929082",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d654e",
            "leftCorner": {
              "x": -19.969,
              "y": -15.312,
              "z": 1.161
            },
            "rightCorner": {
              "x": -20.165,
              "y": -15.308,
              "z": 1.161
            },
            "gtin": "8712514929129",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d654f",
            "leftCorner": {
              "x": -20.165,
              "y": -15.309,
              "z": 1.161
            },
            "rightCorner": {
              "x": -20.255,
              "y": -15.307,
              "z": 1.161
            },
            "gtin": "8712514929136",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6550",
            "leftCorner": {
              "x": -20.255,
              "y": -15.307,
              "z": 1.161
            },
            "rightCorner": {
              "x": -20.381,
              "y": -15.304,
              "z": 1.161
            },
            "gtin": "8712514929167",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d17e",
        "height": 1.7178,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64d8",
            "leftCorner": {
              "x": -19.068,
              "y": -15.308,
              "z": 1.405
            },
            "rightCorner": {
              "x": -19.174,
              "y": -15.306,
              "z": 1.405
            },
            "gtin": "8712514929594",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64db",
            "leftCorner": {
              "x": -19.176,
              "y": -15.349,
              "z": 1.405
            },
            "rightCorner": {
              "x": -19.225,
              "y": -15.348,
              "z": 1.405
            },
            "gtin": "8712514929624",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64dc",
            "leftCorner": {
              "x": -19.225,
              "y": -15.352,
              "z": 1.405
            },
            "rightCorner": {
              "x": -19.31,
              "y": -15.35,
              "z": 1.405
            },
            "gtin": "8712514929686",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64dd",
            "leftCorner": {
              "x": -19.31,
              "y": -15.349,
              "z": 1.405
            },
            "rightCorner": {
              "x": -19.388,
              "y": -15.347,
              "z": 1.405
            },
            "gtin": "8712514929662",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64de",
            "leftCorner": {
              "x": -19.388,
              "y": -15.347,
              "z": 1.405
            },
            "rightCorner": {
              "x": -19.468,
              "y": -15.346,
              "z": 1.405
            },
            "gtin": "8712514929570",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64df",
            "leftCorner": {
              "x": -19.468,
              "y": -15.345,
              "z": 1.405
            },
            "rightCorner": {
              "x": -19.545,
              "y": -15.344,
              "z": 1.405
            },
            "gtin": "8712514929587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64e0",
            "leftCorner": {
              "x": -19.545,
              "y": -15.344,
              "z": 1.405
            },
            "rightCorner": {
              "x": -19.64,
              "y": -15.342,
              "z": 1.405
            },
            "gtin": "8712514929518",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64e1",
            "leftCorner": {
              "x": -19.64,
              "y": -15.338,
              "z": 1.405
            },
            "rightCorner": {
              "x": -19.7,
              "y": -15.336,
              "z": 1.405
            },
            "gtin": "8712514929525",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64e2",
            "leftCorner": {
              "x": -19.7,
              "y": -15.331,
              "z": 1.405
            },
            "rightCorner": {
              "x": -19.775,
              "y": -15.33,
              "z": 1.405
            },
            "gtin": "8712514929631",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64e3",
            "leftCorner": {
              "x": -19.775,
              "y": -15.327,
              "z": 1.405
            },
            "rightCorner": {
              "x": -19.856,
              "y": -15.326,
              "z": 1.405
            },
            "gtin": "8712514929655",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64e4",
            "leftCorner": {
              "x": -19.856,
              "y": -15.322,
              "z": 1.405
            },
            "rightCorner": {
              "x": -19.934,
              "y": -15.32,
              "z": 1.405
            },
            "gtin": "8712514929549",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64e5",
            "leftCorner": {
              "x": -19.934,
              "y": -15.319,
              "z": 1.405
            },
            "rightCorner": {
              "x": -20.01,
              "y": -15.318,
              "z": 1.405
            },
            "gtin": "8712514929617",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64e6",
            "leftCorner": {
              "x": -20.01,
              "y": -15.317,
              "z": 1.405
            },
            "rightCorner": {
              "x": -20.083,
              "y": -15.316,
              "z": 1.405
            },
            "gtin": "8712514929556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64e7",
            "leftCorner": {
              "x": -20.083,
              "y": -15.315,
              "z": 1.405
            },
            "rightCorner": {
              "x": -20.181,
              "y": -15.313,
              "z": 1.405
            },
            "gtin": "8712514929679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64e8",
            "leftCorner": {
              "x": -20.181,
              "y": -15.315,
              "z": 1.405
            },
            "rightCorner": {
              "x": -20.377,
              "y": -15.311,
              "z": 1.405
            },
            "gtin": "8712514929648",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "f0b"
  },
  {
    "id": "f0b",
    "name": "f0b",
    "x": -20.318,
    "y": -15.321,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99994,
      "w": 0.010943
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 38,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d189",
        "height": 0.17413,
        "facings": [
          {
            "id": "dfdf2c69e93ea05fc7b484cf",
            "leftCorner": {
              "x": -20.316,
              "y": -15.238,
              "z": 0.142
            },
            "rightCorner": {
              "x": -20.429,
              "y": -15.236,
              "z": 0.142
            },
            "gtin": "4014400936308",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d0d315c13864b9fd2ccff3aa",
            "leftCorner": {
              "x": -20.429,
              "y": -15.236,
              "z": 0.142
            },
            "rightCorner": {
              "x": -20.574,
              "y": -15.232,
              "z": 0.142
            },
            "gtin": "4250426224047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9868e19dd4bdca1689ab403a",
            "leftCorner": {
              "x": -20.574,
              "y": -15.232,
              "z": 0.142
            },
            "rightCorner": {
              "x": -20.733,
              "y": -15.229,
              "z": 0.142
            },
            "gtin": "4037400344621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a3294dd7e829a4d3d9a7f891",
            "leftCorner": {
              "x": -20.733,
              "y": -15.229,
              "z": 0.142
            },
            "rightCorner": {
              "x": -20.893,
              "y": -15.225,
              "z": 0.142
            },
            "gtin": "4037400345635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6fb47e2e8e202a0118755569",
            "leftCorner": {
              "x": -20.893,
              "y": -15.225,
              "z": 0.142
            },
            "rightCorner": {
              "x": -21.057,
              "y": -15.222,
              "z": 0.142
            },
            "gtin": "8713800102837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b3464ae376c5a3f621bbc3f8",
            "leftCorner": {
              "x": -21.057,
              "y": -15.222,
              "z": 0.142
            },
            "rightCorner": {
              "x": -21.223,
              "y": -15.218,
              "z": 0.142
            },
            "gtin": "8713800102813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3da6ad9ceed8765de0f7c1b6",
            "leftCorner": {
              "x": -21.223,
              "y": -15.218,
              "z": 0.142
            },
            "rightCorner": {
              "x": -21.392,
              "y": -15.214,
              "z": 0.142
            },
            "gtin": "4000512463634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "a6aef40680576bf89b21b260",
            "leftCorner": {
              "x": -21.392,
              "y": -15.214,
              "z": 0.142
            },
            "rightCorner": {
              "x": -21.565,
              "y": -15.211,
              "z": 0.142
            },
            "gtin": "4250426224108",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d187",
        "height": 0.50643,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6504",
            "leftCorner": {
              "x": -20.381,
              "y": -15.313,
              "z": 0.414
            },
            "rightCorner": {
              "x": -20.628,
              "y": -15.308,
              "z": 0.414
            },
            "gtin": "4000512004905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6505",
            "leftCorner": {
              "x": -20.627,
              "y": -15.31,
              "z": 0.414
            },
            "rightCorner": {
              "x": -20.795,
              "y": -15.307,
              "z": 0.414
            },
            "gtin": "4000512463634",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6506",
            "leftCorner": {
              "x": -20.795,
              "y": -15.309,
              "z": 0.414
            },
            "rightCorner": {
              "x": -20.975,
              "y": -15.304,
              "z": 0.414
            },
            "gtin": "4000512463689",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6507",
            "leftCorner": {
              "x": -20.975,
              "y": -15.305,
              "z": 0.414
            },
            "rightCorner": {
              "x": -21.172,
              "y": -15.302,
              "z": 0.414
            },
            "gtin": "4000512463665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6508",
            "leftCorner": {
              "x": -21.172,
              "y": -15.301,
              "z": 0.414
            },
            "rightCorner": {
              "x": -21.358,
              "y": -15.297,
              "z": 0.414
            },
            "gtin": "4000512463443",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6509",
            "leftCorner": {
              "x": -21.358,
              "y": -15.292,
              "z": 0.414
            },
            "rightCorner": {
              "x": -21.597,
              "y": -15.286,
              "z": 0.414
            },
            "gtin": "4000512463429",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d188",
        "height": 0.80767,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6575",
            "leftCorner": {
              "x": -20.361,
              "y": -15.313,
              "z": 0.661
            },
            "rightCorner": {
              "x": -20.525,
              "y": -15.31,
              "z": 0.661
            },
            "gtin": "4250426224108",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "2aa94eabd17bc4210ea2fcb0",
            "leftCorner": {
              "x": -20.524,
              "y": -15.271,
              "z": 0.661
            },
            "rightCorner": {
              "x": -20.697,
              "y": -15.268,
              "z": 0.661
            },
            "gtin": "4250426224108",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6577",
            "leftCorner": {
              "x": -20.701,
              "y": -15.307,
              "z": 0.661
            },
            "rightCorner": {
              "x": -20.913,
              "y": -15.302,
              "z": 0.661
            },
            "gtin": "4250426224085",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6578",
            "leftCorner": {
              "x": -20.913,
              "y": -15.303,
              "z": 0.661
            },
            "rightCorner": {
              "x": -21.061,
              "y": -15.3,
              "z": 0.661
            },
            "gtin": "4250426224047",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6579",
            "leftCorner": {
              "x": -21.061,
              "y": -15.304,
              "z": 0.661
            },
            "rightCorner": {
              "x": -21.26,
              "y": -15.3,
              "z": 0.661
            },
            "gtin": "4037400345628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d657a",
            "leftCorner": {
              "x": -21.26,
              "y": -15.298,
              "z": 0.661
            },
            "rightCorner": {
              "x": -21.414,
              "y": -15.294,
              "z": 0.661
            },
            "gtin": "4037400345635",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d657b",
            "leftCorner": {
              "x": -21.413,
              "y": -15.283,
              "z": 0.661
            },
            "rightCorner": {
              "x": -21.662,
              "y": -15.277,
              "z": 0.661
            },
            "gtin": "4037400344621",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d184",
        "height": 1.1098,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6526",
            "leftCorner": {
              "x": -20.351,
              "y": -15.313,
              "z": 0.908
            },
            "rightCorner": {
              "x": -20.507,
              "y": -15.308,
              "z": 0.908
            },
            "gtin": "8713800102837",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6527",
            "leftCorner": {
              "x": -20.506,
              "y": -15.311,
              "z": 0.908
            },
            "rightCorner": {
              "x": -20.667,
              "y": -15.307,
              "z": 0.908
            },
            "gtin": "8713800102813",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6528",
            "leftCorner": {
              "x": -20.667,
              "y": -15.309,
              "z": 0.908
            },
            "rightCorner": {
              "x": -20.874,
              "y": -15.305,
              "z": 0.908
            },
            "gtin": "8713800111464",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6529",
            "leftCorner": {
              "x": -20.874,
              "y": -15.306,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.103,
              "y": -15.301,
              "z": 0.908
            },
            "gtin": "4037400344737",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d652a",
            "leftCorner": {
              "x": -21.103,
              "y": -15.301,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.281,
              "y": -15.297,
              "z": 0.908
            },
            "gtin": "4037400345550",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d652b",
            "leftCorner": {
              "x": -21.281,
              "y": -15.292,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.461,
              "y": -15.289,
              "z": 0.908
            },
            "gtin": "4037400344829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d652c",
            "leftCorner": {
              "x": -21.46,
              "y": -15.281,
              "z": 0.908
            },
            "rightCorner": {
              "x": -21.682,
              "y": -15.276,
              "z": 0.908
            },
            "gtin": "4014400936308",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d185",
        "height": 1.4129,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6551",
            "leftCorner": {
              "x": -20.38,
              "y": -15.306,
              "z": 1.156
            },
            "rightCorner": {
              "x": -20.546,
              "y": -15.303,
              "z": 1.156
            },
            "gtin": "8713800114748",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8645eac1e114005ef006ffa8",
            "leftCorner": {
              "x": -20.317,
              "y": -15.266,
              "z": 1.156
            },
            "rightCorner": {
              "x": -20.376,
              "y": -15.265,
              "z": 1.156
            },
            "gtin": "4037400344850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6552",
            "leftCorner": {
              "x": -20.546,
              "y": -15.302,
              "z": 1.156
            },
            "rightCorner": {
              "x": -20.926,
              "y": -15.293,
              "z": 1.156
            },
            "gtin": "8713800102875",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6553",
            "leftCorner": {
              "x": -20.926,
              "y": -15.297,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.121,
              "y": -15.293,
              "z": 1.156
            },
            "gtin": "4037400344843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6554",
            "leftCorner": {
              "x": -21.121,
              "y": -15.289,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.312,
              "y": -15.285,
              "z": 1.156
            },
            "gtin": "4037400344645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6555",
            "leftCorner": {
              "x": -21.312,
              "y": -15.283,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.497,
              "y": -15.279,
              "z": 1.156
            },
            "gtin": "4037400344867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6556",
            "leftCorner": {
              "x": -21.497,
              "y": -15.27,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.705,
              "y": -15.264,
              "z": 1.156
            },
            "gtin": "4037400344850",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d186",
        "height": 1.7113,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64e9",
            "leftCorner": {
              "x": -20.377,
              "y": -15.309,
              "z": 1.4
            },
            "rightCorner": {
              "x": -20.582,
              "y": -15.305,
              "z": 1.4
            },
            "gtin": "8713800120718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64ea",
            "leftCorner": {
              "x": -20.582,
              "y": -15.307,
              "z": 1.4
            },
            "rightCorner": {
              "x": -20.794,
              "y": -15.303,
              "z": 1.4
            },
            "gtin": "4004641101269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64eb",
            "leftCorner": {
              "x": -20.794,
              "y": -15.306,
              "z": 1.4
            },
            "rightCorner": {
              "x": -21.076,
              "y": -15.3,
              "z": 1.4
            },
            "gtin": "4000512015345",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64ec",
            "leftCorner": {
              "x": -21.076,
              "y": -15.301,
              "z": 1.4
            },
            "rightCorner": {
              "x": -21.295,
              "y": -15.296,
              "z": 1.4
            },
            "gtin": "4000512446125",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64ed",
            "leftCorner": {
              "x": -21.295,
              "y": -15.293,
              "z": 1.4
            },
            "rightCorner": {
              "x": -21.685,
              "y": -15.284,
              "z": 1.4
            },
            "gtin": "4000512446309",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f0a",
    "rightNeighborShelfId": "f0c"
  },
  {
    "id": "f0c",
    "name": "f0c",
    "x": -21.572,
    "y": -15.293,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99999,
      "w": 0.0034208
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 38,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d18f",
        "height": 0.17353,
        "facings": [
          {
            "id": "4bc137be9106bfe4fd97e29a",
            "leftCorner": {
              "x": -21.572,
              "y": -15.197,
              "z": 0.142
            },
            "rightCorner": {
              "x": -21.705,
              "y": -15.196,
              "z": 0.142
            },
            "gtin": "4001686327456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "77ba9d1cf275ad04ce8aa5c9",
            "leftCorner": {
              "x": -21.705,
              "y": -15.196,
              "z": 0.142
            },
            "rightCorner": {
              "x": -21.845,
              "y": -15.195,
              "z": 0.142
            },
            "gtin": "4001686347621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cf3abf165bab1fb59772fc72",
            "leftCorner": {
              "x": -21.845,
              "y": -15.195,
              "z": 0.142
            },
            "rightCorner": {
              "x": -22.005,
              "y": -15.194,
              "z": 0.142
            },
            "gtin": "9002975378956",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "67fae656cf00722f24a27449",
            "leftCorner": {
              "x": -22.005,
              "y": -15.194,
              "z": 0.142
            },
            "rightCorner": {
              "x": -22.166,
              "y": -15.193,
              "z": 0.142
            },
            "gtin": "4014400934144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0f75464694f72ca80a33bff7",
            "leftCorner": {
              "x": -22.166,
              "y": -15.193,
              "z": 0.142
            },
            "rightCorner": {
              "x": -22.328,
              "y": -15.192,
              "z": 0.142
            },
            "gtin": "4037400344782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8594b52ad7e75af5392fdc69",
            "leftCorner": {
              "x": -22.328,
              "y": -15.192,
              "z": 0.142
            },
            "rightCorner": {
              "x": -22.49,
              "y": -15.191,
              "z": 0.142
            },
            "gtin": "4037400344775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f912af3a856ae422674cfaba",
            "leftCorner": {
              "x": -22.49,
              "y": -15.191,
              "z": 0.142
            },
            "rightCorner": {
              "x": -22.655,
              "y": -15.19,
              "z": 0.142
            },
            "gtin": "4000512463801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "34fb8b3d8e5a62eb8e7f9059",
            "leftCorner": {
              "x": -22.655,
              "y": -15.19,
              "z": 0.142
            },
            "rightCorner": {
              "x": -22.821,
              "y": -15.188,
              "z": 0.142
            },
            "gtin": "4014400936612",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d18d",
        "height": 0.50375,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d650a",
            "leftCorner": {
              "x": -21.602,
              "y": -15.277,
              "z": 0.412
            },
            "rightCorner": {
              "x": -21.776,
              "y": -15.276,
              "z": 0.412
            },
            "gtin": "4000512463801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d650b",
            "leftCorner": {
              "x": -21.776,
              "y": -15.276,
              "z": 0.412
            },
            "rightCorner": {
              "x": -21.968,
              "y": -15.275,
              "z": 0.412
            },
            "gtin": "4014400920390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d650c",
            "leftCorner": {
              "x": -21.968,
              "y": -15.269,
              "z": 0.412
            },
            "rightCorner": {
              "x": -22.154,
              "y": -15.268,
              "z": 0.412
            },
            "gtin": "4014400916867",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d650d",
            "leftCorner": {
              "x": -22.154,
              "y": -15.272,
              "z": 0.412
            },
            "rightCorner": {
              "x": -22.325,
              "y": -15.271,
              "z": 0.412
            },
            "gtin": "4014400922493",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d650e",
            "leftCorner": {
              "x": -22.325,
              "y": -15.272,
              "z": 0.412
            },
            "rightCorner": {
              "x": -22.512,
              "y": -15.271,
              "z": 0.412
            },
            "gtin": "4014400931914",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d650f",
            "leftCorner": {
              "x": -22.512,
              "y": -15.271,
              "z": 0.412
            },
            "rightCorner": {
              "x": -22.669,
              "y": -15.27,
              "z": 0.412
            },
            "gtin": "4014400934144",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6510",
            "leftCorner": {
              "x": -22.669,
              "y": -15.272,
              "z": 0.412
            },
            "rightCorner": {
              "x": -22.823,
              "y": -15.27,
              "z": 0.412
            },
            "gtin": "9002975378956",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d18e",
        "height": 0.80437,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d657c",
            "leftCorner": {
              "x": -21.668,
              "y": -15.279,
              "z": 0.658
            },
            "rightCorner": {
              "x": -21.898,
              "y": -15.278,
              "z": 0.658
            },
            "gtin": "4014400936285",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d657d",
            "leftCorner": {
              "x": -21.898,
              "y": -15.268,
              "z": 0.658
            },
            "rightCorner": {
              "x": -22.066,
              "y": -15.267,
              "z": 0.658
            },
            "gtin": "4014400936322",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d657e",
            "leftCorner": {
              "x": -22.066,
              "y": -15.272,
              "z": 0.658
            },
            "rightCorner": {
              "x": -22.228,
              "y": -15.271,
              "z": 0.658
            },
            "gtin": "4014400936506",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d657f",
            "leftCorner": {
              "x": -22.228,
              "y": -15.274,
              "z": 0.658
            },
            "rightCorner": {
              "x": -22.42,
              "y": -15.273,
              "z": 0.658
            },
            "gtin": "4014400936438",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6580",
            "leftCorner": {
              "x": -22.42,
              "y": -15.271,
              "z": 0.658
            },
            "rightCorner": {
              "x": -22.593,
              "y": -15.27,
              "z": 0.658
            },
            "gtin": "4014400936414",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6581",
            "leftCorner": {
              "x": -22.593,
              "y": -15.271,
              "z": 0.658
            },
            "rightCorner": {
              "x": -22.843,
              "y": -15.27,
              "z": 0.658
            },
            "gtin": "4014400931914",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d18a",
        "height": 1.1074,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d652d",
            "leftCorner": {
              "x": -21.688,
              "y": -15.271,
              "z": 0.906
            },
            "rightCorner": {
              "x": -21.875,
              "y": -15.269,
              "z": 0.906
            },
            "gtin": "4014400936612",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3c974c4dd143efc4c72e2305",
            "leftCorner": {
              "x": -21.572,
              "y": -15.234,
              "z": 0.906
            },
            "rightCorner": {
              "x": -21.679,
              "y": -15.233,
              "z": 0.906
            },
            "gtin": "4001686102701",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d652e",
            "leftCorner": {
              "x": -21.875,
              "y": -15.269,
              "z": 0.906
            },
            "rightCorner": {
              "x": -22.09,
              "y": -15.267,
              "z": 0.906
            },
            "gtin": "4014400916850",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d652f",
            "leftCorner": {
              "x": -22.09,
              "y": -15.269,
              "z": 0.906
            },
            "rightCorner": {
              "x": -22.267,
              "y": -15.269,
              "z": 0.906
            },
            "gtin": "4014400936278",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6530",
            "leftCorner": {
              "x": -22.267,
              "y": -15.275,
              "z": 0.906
            },
            "rightCorner": {
              "x": -22.453,
              "y": -15.272,
              "z": 0.906
            },
            "gtin": "4014400936476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6531",
            "leftCorner": {
              "x": -22.453,
              "y": -15.267,
              "z": 0.906
            },
            "rightCorner": {
              "x": -22.585,
              "y": -15.266,
              "z": 0.906
            },
            "gtin": "4001686347621",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6532",
            "leftCorner": {
              "x": -22.585,
              "y": -15.267,
              "z": 0.906
            },
            "rightCorner": {
              "x": -22.719,
              "y": -15.266,
              "z": 0.906
            },
            "gtin": "4001686327456",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6533",
            "leftCorner": {
              "x": -22.718,
              "y": -15.27,
              "z": 0.906
            },
            "rightCorner": {
              "x": -22.823,
              "y": -15.269,
              "z": 0.906
            },
            "gtin": "4001686102701",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d18c",
        "height": 1.4132,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6557",
            "leftCorner": {
              "x": -21.709,
              "y": -15.267,
              "z": 1.156
            },
            "rightCorner": {
              "x": -21.927,
              "y": -15.265,
              "z": 1.156
            },
            "gtin": "4037400344874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6558",
            "leftCorner": {
              "x": -21.927,
              "y": -15.26,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.081,
              "y": -15.259,
              "z": 1.156
            },
            "gtin": "4037400344775",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6559",
            "leftCorner": {
              "x": -22.081,
              "y": -15.264,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.266,
              "y": -15.262,
              "z": 1.156
            },
            "gtin": "4037400345338",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d655a",
            "leftCorner": {
              "x": -22.267,
              "y": -15.266,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.474,
              "y": -15.264,
              "z": 1.156
            },
            "gtin": "4037400345321",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d655b",
            "leftCorner": {
              "x": -22.474,
              "y": -15.262,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.666,
              "y": -15.261,
              "z": 1.156
            },
            "gtin": "4037400344768",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d655c",
            "leftCorner": {
              "x": -22.666,
              "y": -15.264,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.823,
              "y": -15.262,
              "z": 1.156
            },
            "gtin": "4037400344782",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d18b",
        "height": 1.7079,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64ee",
            "leftCorner": {
              "x": -21.689,
              "y": -15.267,
              "z": 1.397
            },
            "rightCorner": {
              "x": -21.904,
              "y": -15.266,
              "z": 1.397
            },
            "gtin": "4000512994244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64ef",
            "leftCorner": {
              "x": -21.904,
              "y": -15.263,
              "z": 1.397
            },
            "rightCorner": {
              "x": -22.241,
              "y": -15.26,
              "z": 1.397
            },
            "gtin": "4000512994121",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64f0",
            "leftCorner": {
              "x": -22.241,
              "y": -15.27,
              "z": 1.397
            },
            "rightCorner": {
              "x": -22.636,
              "y": -15.267,
              "z": 1.397
            },
            "gtin": "4000512994329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64f1",
            "leftCorner": {
              "x": -22.636,
              "y": -15.267,
              "z": 1.397
            },
            "rightCorner": {
              "x": -22.823,
              "y": -15.266,
              "z": 1.397
            },
            "gtin": "4001686407066",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f0b",
    "rightNeighborShelfId": "f0d"
  },
  {
    "id": "f0d",
    "name": "f0d",
    "x": -22.822,
    "y": -15.284,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99999,
      "w": 0.0034208
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 44,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d195",
        "height": 0.17416,
        "facings": [
          {
            "id": "447cc0e03dc4104aaa79f4b2",
            "leftCorner": {
              "x": -22.821,
              "y": -15.188,
              "z": 0.142
            },
            "rightCorner": {
              "x": -22.909,
              "y": -15.187,
              "z": 0.142
            },
            "gtin": "4001686322871",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8a2b09d538622879b4605f78",
            "leftCorner": {
              "x": -22.909,
              "y": -15.187,
              "z": 0.142
            },
            "rightCorner": {
              "x": -23.022,
              "y": -15.187,
              "z": 0.142
            },
            "gtin": "4001686327425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3bc9d4266ffb643c3cf15607",
            "leftCorner": {
              "x": -23.022,
              "y": -15.187,
              "z": 0.142
            },
            "rightCorner": {
              "x": -23.144,
              "y": -15.186,
              "z": 0.142
            },
            "gtin": "4001686327845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "67e239b63849d99ec5d9391b",
            "leftCorner": {
              "x": -23.144,
              "y": -15.186,
              "z": 0.142
            },
            "rightCorner": {
              "x": -23.266,
              "y": -15.185,
              "z": 0.142
            },
            "gtin": "4003840008690",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c19edb057c3940718c444cc7",
            "leftCorner": {
              "x": -23.266,
              "y": -15.185,
              "z": 0.142
            },
            "rightCorner": {
              "x": -23.392,
              "y": -15.184,
              "z": 0.142
            },
            "gtin": "4001686329849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0aec3b458d18a9790b0a56f1",
            "leftCorner": {
              "x": -23.392,
              "y": -15.184,
              "z": 0.142
            },
            "rightCorner": {
              "x": -23.529,
              "y": -15.183,
              "z": 0.142
            },
            "gtin": "8426617119461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "03a19e4bcee053d208547d9e",
            "leftCorner": {
              "x": -23.529,
              "y": -15.183,
              "z": 0.142
            },
            "rightCorner": {
              "x": -23.672,
              "y": -15.182,
              "z": 0.142
            },
            "gtin": "4003840008751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c919734fb9d2ebd70ef22b61",
            "leftCorner": {
              "x": -23.672,
              "y": -15.182,
              "z": 0.142
            },
            "rightCorner": {
              "x": -23.817,
              "y": -15.181,
              "z": 0.142
            },
            "gtin": "8426617119478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "3baed9dcd3148fb24091295a",
            "leftCorner": {
              "x": -23.817,
              "y": -15.181,
              "z": 0.142
            },
            "rightCorner": {
              "x": -24.061,
              "y": -15.18,
              "z": 0.142
            },
            "gtin": "4001686151105",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d192",
        "height": 0.50537,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6511",
            "leftCorner": {
              "x": -22.822,
              "y": -15.277,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.003,
              "y": -15.277,
              "z": 0.413
            },
            "gtin": "9002975002516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6512",
            "leftCorner": {
              "x": -23.003,
              "y": -15.271,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.333,
              "y": -15.268,
              "z": 0.413
            },
            "gtin": "9002975002516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6513",
            "leftCorner": {
              "x": -23.333,
              "y": -15.272,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.544,
              "y": -15.271,
              "z": 0.413
            },
            "gtin": "4001686009420",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6514",
            "leftCorner": {
              "x": -23.544,
              "y": -15.272,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.7,
              "y": -15.27,
              "z": 0.413
            },
            "gtin": "4001686376829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6515",
            "leftCorner": {
              "x": -23.7,
              "y": -15.271,
              "z": 0.413
            },
            "rightCorner": {
              "x": -23.874,
              "y": -15.27,
              "z": 0.413
            },
            "gtin": "4001686009703",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6516",
            "leftCorner": {
              "x": -23.874,
              "y": -15.265,
              "z": 0.413
            },
            "rightCorner": {
              "x": -24.192,
              "y": -15.264,
              "z": 0.413
            },
            "gtin": "4001686327692",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d191",
        "height": 0.80492,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6582",
            "leftCorner": {
              "x": -22.843,
              "y": -15.271,
              "z": 0.659
            },
            "rightCorner": {
              "x": -22.966,
              "y": -15.271,
              "z": 0.659
            },
            "gtin": "4001686329849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6583",
            "leftCorner": {
              "x": -22.966,
              "y": -15.271,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.097,
              "y": -15.269,
              "z": 0.659
            },
            "gtin": "4001686327845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6584",
            "leftCorner": {
              "x": -23.097,
              "y": -15.27,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.373,
              "y": -15.268,
              "z": 0.659
            },
            "gtin": "4001686014516",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6585",
            "leftCorner": {
              "x": -23.373,
              "y": -15.275,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.555,
              "y": -15.274,
              "z": 0.659
            },
            "gtin": "9002975378925",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6586",
            "leftCorner": {
              "x": -23.555,
              "y": -15.277,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.714,
              "y": -15.275,
              "z": 0.659
            },
            "gtin": "4001686322932",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6587",
            "leftCorner": {
              "x": -23.715,
              "y": -15.27,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.83,
              "y": -15.269,
              "z": 0.659
            },
            "gtin": "4001686327425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6588",
            "leftCorner": {
              "x": -23.83,
              "y": -15.273,
              "z": 0.659
            },
            "rightCorner": {
              "x": -23.988,
              "y": -15.271,
              "z": 0.659
            },
            "gtin": "4001686322536",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6589",
            "leftCorner": {
              "x": -23.988,
              "y": -15.254,
              "z": 0.659
            },
            "rightCorner": {
              "x": -24.157,
              "y": -15.253,
              "z": 0.659
            },
            "gtin": "4001686322871",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d193",
        "height": 1.1084,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6534",
            "leftCorner": {
              "x": -22.822,
              "y": -15.279,
              "z": 0.907
            },
            "rightCorner": {
              "x": -22.873,
              "y": -15.279,
              "z": 0.907
            },
            "gtin": "4001686327630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6535",
            "leftCorner": {
              "x": -22.873,
              "y": -15.267,
              "z": 0.907
            },
            "rightCorner": {
              "x": -23.032,
              "y": -15.265,
              "z": 0.907
            },
            "gtin": "4001686327630",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6536",
            "leftCorner": {
              "x": -23.032,
              "y": -15.264,
              "z": 0.907
            },
            "rightCorner": {
              "x": -23.186,
              "y": -15.264,
              "z": 0.907
            },
            "gtin": "4001686327784",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6537",
            "leftCorner": {
              "x": -23.186,
              "y": -15.27,
              "z": 0.907
            },
            "rightCorner": {
              "x": -23.346,
              "y": -15.268,
              "z": 0.907
            },
            "gtin": "4001686331729",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6538",
            "leftCorner": {
              "x": -23.346,
              "y": -15.271,
              "z": 0.907
            },
            "rightCorner": {
              "x": -23.501,
              "y": -15.269,
              "z": 0.907
            },
            "gtin": "4001686103241",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6539",
            "leftCorner": {
              "x": -23.501,
              "y": -15.272,
              "z": 0.907
            },
            "rightCorner": {
              "x": -23.65,
              "y": -15.271,
              "z": 0.907
            },
            "gtin": "4001686103180",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d653a",
            "leftCorner": {
              "x": -23.65,
              "y": -15.271,
              "z": 0.907
            },
            "rightCorner": {
              "x": -23.824,
              "y": -15.269,
              "z": 0.907
            },
            "gtin": "4001686327548",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d653b",
            "leftCorner": {
              "x": -23.824,
              "y": -15.272,
              "z": 0.907
            },
            "rightCorner": {
              "x": -24.084,
              "y": -15.271,
              "z": 0.907
            },
            "gtin": "4001686151105",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d653c",
            "leftCorner": {
              "x": -24.084,
              "y": -15.268,
              "z": 0.907
            },
            "rightCorner": {
              "x": -24.215,
              "y": -15.267,
              "z": 0.907
            },
            "gtin": "4001686120279",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d194",
        "height": 1.4124,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d655d",
            "leftCorner": {
              "x": -22.822,
              "y": -15.275,
              "z": 1.156
            },
            "rightCorner": {
              "x": -22.849,
              "y": -15.276,
              "z": 1.156
            },
            "gtin": "4250018925086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d655e",
            "leftCorner": {
              "x": -22.849,
              "y": -15.26,
              "z": 1.156
            },
            "rightCorner": {
              "x": -23.065,
              "y": -15.258,
              "z": 1.156
            },
            "gtin": "4250018925086",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d655f",
            "leftCorner": {
              "x": -23.065,
              "y": -15.263,
              "z": 1.156
            },
            "rightCorner": {
              "x": -23.216,
              "y": -15.261,
              "z": 1.156
            },
            "gtin": "4001686335246",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6560",
            "leftCorner": {
              "x": -23.216,
              "y": -15.264,
              "z": 1.156
            },
            "rightCorner": {
              "x": -23.365,
              "y": -15.263,
              "z": 1.156
            },
            "gtin": "4001686006245",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6561",
            "leftCorner": {
              "x": -23.365,
              "y": -15.267,
              "z": 1.156
            },
            "rightCorner": {
              "x": -23.512,
              "y": -15.265,
              "z": 1.156
            },
            "gtin": "4001686102862",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6562",
            "leftCorner": {
              "x": -23.512,
              "y": -15.268,
              "z": 1.156
            },
            "rightCorner": {
              "x": -23.652,
              "y": -15.267,
              "z": 1.156
            },
            "gtin": "8426617119461",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6563",
            "leftCorner": {
              "x": -23.652,
              "y": -15.269,
              "z": 1.156
            },
            "rightCorner": {
              "x": -23.8,
              "y": -15.267,
              "z": 1.156
            },
            "gtin": "8426617119478",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6564",
            "leftCorner": {
              "x": -23.8,
              "y": -15.266,
              "z": 1.156
            },
            "rightCorner": {
              "x": -23.943,
              "y": -15.266,
              "z": 1.156
            },
            "gtin": "4003840008751",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6565",
            "leftCorner": {
              "x": -23.943,
              "y": -15.266,
              "z": 1.156
            },
            "rightCorner": {
              "x": -24.123,
              "y": -15.265,
              "z": 1.156
            },
            "gtin": "4003840008690",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d190",
        "height": 1.7074,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64f2",
            "leftCorner": {
              "x": -22.822,
              "y": -15.275,
              "z": 1.397
            },
            "rightCorner": {
              "x": -22.95,
              "y": -15.275,
              "z": 1.397
            },
            "gtin": "4001686343050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64f3",
            "leftCorner": {
              "x": -22.951,
              "y": -15.262,
              "z": 1.397
            },
            "rightCorner": {
              "x": -23.155,
              "y": -15.26,
              "z": 1.397
            },
            "gtin": "4001686343050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64f4",
            "leftCorner": {
              "x": -23.155,
              "y": -15.26,
              "z": 1.397
            },
            "rightCorner": {
              "x": -23.359,
              "y": -15.259,
              "z": 1.397
            },
            "gtin": "4001686343050",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64f5",
            "leftCorner": {
              "x": -23.359,
              "y": -15.268,
              "z": 1.397
            },
            "rightCorner": {
              "x": -23.708,
              "y": -15.265,
              "z": 1.397
            },
            "gtin": "4001686003398",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64f6",
            "leftCorner": {
              "x": -23.708,
              "y": -15.269,
              "z": 1.397
            },
            "rightCorner": {
              "x": -24.119,
              "y": -15.266,
              "z": 1.397
            },
            "gtin": "4001686002551",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f0c",
    "rightNeighborShelfId": "f0e"
  },
  {
    "id": "f0e",
    "name": "f0e",
    "x": -24.072,
    "y": -15.276,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.99999,
      "w": 0.0034208
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 38,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6e7",
        "height": 0.1745,
        "facings": [
          {
            "id": "466455d1f4938491fe2a24e8",
            "leftCorner": {
              "x": -24.071,
              "y": -15.175,
              "z": 0.143
            },
            "rightCorner": {
              "x": -24.17,
              "y": -15.174,
              "z": 0.143
            },
            "gtin": "5010478311176",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9412bf879f3c865b35813768",
            "leftCorner": {
              "x": -24.17,
              "y": -15.174,
              "z": 0.143
            },
            "rightCorner": {
              "x": -24.295,
              "y": -15.173,
              "z": 0.143
            },
            "gtin": "4001686120279",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d7e3715ec59e43e0f79da3ff",
            "leftCorner": {
              "x": -24.295,
              "y": -15.173,
              "z": 0.143
            },
            "rightCorner": {
              "x": -24.424,
              "y": -15.173,
              "z": 0.143
            },
            "gtin": "4001686331842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "e9f62e51dd14f610bf3c6e54",
            "leftCorner": {
              "x": -24.424,
              "y": -15.173,
              "z": 0.143
            },
            "rightCorner": {
              "x": -24.562,
              "y": -15.172,
              "z": 0.143
            },
            "gtin": "4001686013854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ee4adb67f420c8754ba2ec0b",
            "leftCorner": {
              "x": -24.562,
              "y": -15.172,
              "z": 0.143
            },
            "rightCorner": {
              "x": -24.707,
              "y": -15.171,
              "z": 0.143
            },
            "gtin": "4003840008843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "470c0930df102687b5749010",
            "leftCorner": {
              "x": -24.707,
              "y": -15.171,
              "z": 0.143
            },
            "rightCorner": {
              "x": -24.853,
              "y": -15.17,
              "z": 0.143
            },
            "gtin": "4003840008317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7f4219970fc6d368642b2a49",
            "leftCorner": {
              "x": -24.853,
              "y": -15.17,
              "z": 0.143
            },
            "rightCorner": {
              "x": -25.0,
              "y": -15.169,
              "z": 0.143
            },
            "gtin": "4001686328941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "907f4c9a763a6a1df394fd46",
            "leftCorner": {
              "x": -25.0,
              "y": -15.169,
              "z": 0.143
            },
            "rightCorner": {
              "x": -25.164,
              "y": -15.168,
              "z": 0.143
            },
            "gtin": "4003840009178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5d9bf5f675b956a3dcc806d2",
            "leftCorner": {
              "x": -25.164,
              "y": -15.168,
              "z": 0.143
            },
            "rightCorner": {
              "x": -25.311,
              "y": -15.167,
              "z": 0.143
            },
            "gtin": "4001686328941",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6e2",
        "height": 0.5046,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6517",
            "leftCorner": {
              "x": -24.192,
              "y": -15.269,
              "z": 0.413
            },
            "rightCorner": {
              "x": -24.326,
              "y": -15.269,
              "z": 0.413
            },
            "gtin": "4001686013854",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6518",
            "leftCorner": {
              "x": -24.326,
              "y": -15.263,
              "z": 0.413
            },
            "rightCorner": {
              "x": -24.625,
              "y": -15.26,
              "z": 0.413
            },
            "gtin": "4001686335833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6519",
            "leftCorner": {
              "x": -24.626,
              "y": -15.257,
              "z": 0.413
            },
            "rightCorner": {
              "x": -24.733,
              "y": -15.256,
              "z": 0.413
            },
            "gtin": "4001686322628",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d651a",
            "leftCorner": {
              "x": -24.733,
              "y": -15.253,
              "z": 0.413
            },
            "rightCorner": {
              "x": -25.117,
              "y": -15.251,
              "z": 0.413
            },
            "gtin": "4001686014530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64fb",
            "leftCorner": {
              "x": -25.117,
              "y": -15.244,
              "z": 0.413
            },
            "rightCorner": {
              "x": -25.322,
              "y": -15.243,
              "z": 0.413
            },
            "gtin": "4001686327487",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ba61ef8500b1f7534c9b5d50",
            "leftCorner": {
              "x": -24.071,
              "y": -15.221,
              "z": 0.413
            },
            "rightCorner": {
              "x": -24.183,
              "y": -15.22,
              "z": 0.413
            },
            "gtin": "4001686322628",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6e5",
        "height": 0.8058,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d658a",
            "leftCorner": {
              "x": -24.157,
              "y": -15.268,
              "z": 0.659
            },
            "rightCorner": {
              "x": -24.339,
              "y": -15.267,
              "z": 0.659
            },
            "gtin": "4001686013960",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d658b",
            "leftCorner": {
              "x": -24.339,
              "y": -15.264,
              "z": 0.659
            },
            "rightCorner": {
              "x": -24.618,
              "y": -15.262,
              "z": 0.659
            },
            "gtin": "4001686335390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d658c",
            "leftCorner": {
              "x": -24.618,
              "y": -15.261,
              "z": 0.659
            },
            "rightCorner": {
              "x": -24.782,
              "y": -15.26,
              "z": 0.659
            },
            "gtin": "4001686013908",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d658d",
            "leftCorner": {
              "x": -24.783,
              "y": -15.254,
              "z": 0.659
            },
            "rightCorner": {
              "x": -25.091,
              "y": -15.252,
              "z": 0.659
            },
            "gtin": "4001686335864",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d656d",
            "leftCorner": {
              "x": -25.09,
              "y": -15.236,
              "z": 0.659
            },
            "rightCorner": {
              "x": -25.321,
              "y": -15.233,
              "z": 0.659
            },
            "gtin": "4001686335772",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6e3",
        "height": 1.1076,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d653d",
            "leftCorner": {
              "x": -24.215,
              "y": -15.262,
              "z": 0.906
            },
            "rightCorner": {
              "x": -24.5,
              "y": -15.26,
              "z": 0.906
            },
            "gtin": "4001686335802",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d653e",
            "leftCorner": {
              "x": -24.5,
              "y": -15.263,
              "z": 0.906
            },
            "rightCorner": {
              "x": -24.628,
              "y": -15.262,
              "z": 0.906
            },
            "gtin": "4001686331842",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d653f",
            "leftCorner": {
              "x": -24.628,
              "y": -15.26,
              "z": 0.906
            },
            "rightCorner": {
              "x": -24.775,
              "y": -15.259,
              "z": 0.906
            },
            "gtin": "4001686328941",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6540",
            "leftCorner": {
              "x": -24.775,
              "y": -15.253,
              "z": 0.906
            },
            "rightCorner": {
              "x": -25.109,
              "y": -15.25,
              "z": 0.906
            },
            "gtin": "4001686002421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d651c",
            "leftCorner": {
              "x": -25.108,
              "y": -15.243,
              "z": 0.906
            },
            "rightCorner": {
              "x": -25.322,
              "y": -15.242,
              "z": 0.906
            },
            "gtin": "4001686372852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cffb70caf9e51a19b6f54572",
            "leftCorner": {
              "x": -24.071,
              "y": -15.223,
              "z": 0.906
            },
            "rightCorner": {
              "x": -24.196,
              "y": -15.222,
              "z": 0.906
            },
            "gtin": "4001686120279",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6e4",
        "height": 1.411,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6566",
            "leftCorner": {
              "x": -24.123,
              "y": -15.267,
              "z": 1.154
            },
            "rightCorner": {
              "x": -24.264,
              "y": -15.267,
              "z": 1.154
            },
            "gtin": "4003840008843",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6567",
            "leftCorner": {
              "x": -24.264,
              "y": -15.265,
              "z": 1.154
            },
            "rightCorner": {
              "x": -24.41,
              "y": -15.264,
              "z": 1.154
            },
            "gtin": "4003840008317",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6568",
            "leftCorner": {
              "x": -24.41,
              "y": -15.262,
              "z": 1.154
            },
            "rightCorner": {
              "x": -24.697,
              "y": -15.26,
              "z": 1.154
            },
            "gtin": "4003840008874",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6569",
            "leftCorner": {
              "x": -24.697,
              "y": -15.256,
              "z": 1.154
            },
            "rightCorner": {
              "x": -24.849,
              "y": -15.255,
              "z": 1.154
            },
            "gtin": "4003840009178",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d656a",
            "leftCorner": {
              "x": -24.849,
              "y": -15.253,
              "z": 1.154
            },
            "rightCorner": {
              "x": -25.031,
              "y": -15.252,
              "z": 1.154
            },
            "gtin": "4003840008188",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d656b",
            "leftCorner": {
              "x": -25.03,
              "y": -15.243,
              "z": 1.154
            },
            "rightCorner": {
              "x": -25.222,
              "y": -15.241,
              "z": 1.154
            },
            "gtin": "8720618786906",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6542",
            "leftCorner": {
              "x": -25.223,
              "y": -15.237,
              "z": 1.154
            },
            "rightCorner": {
              "x": -25.321,
              "y": -15.237,
              "z": 1.154
            },
            "gtin": "5010478311176",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6e6",
        "height": 1.7091,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d64f7",
            "leftCorner": {
              "x": -24.119,
              "y": -15.268,
              "z": 1.398
            },
            "rightCorner": {
              "x": -24.428,
              "y": -15.266,
              "z": 1.398
            },
            "gtin": "4001686002537",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64f8",
            "leftCorner": {
              "x": -24.428,
              "y": -15.263,
              "z": 1.398
            },
            "rightCorner": {
              "x": -24.726,
              "y": -15.261,
              "z": 1.398
            },
            "gtin": "4001686002490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64f9",
            "leftCorner": {
              "x": -24.726,
              "y": -15.261,
              "z": 1.398
            },
            "rightCorner": {
              "x": -25.023,
              "y": -15.259,
              "z": 1.398
            },
            "gtin": "4001686002490",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64d9",
            "leftCorner": {
              "x": -25.024,
              "y": -15.246,
              "z": 1.398
            },
            "rightCorner": {
              "x": -25.173,
              "y": -15.245,
              "z": 1.398
            },
            "gtin": "4001686002513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d64da",
            "leftCorner": {
              "x": -25.173,
              "y": -15.245,
              "z": 1.398
            },
            "rightCorner": {
              "x": -25.322,
              "y": -15.244,
              "z": 1.398
            },
            "gtin": "4001686002513",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f0d"
  },
  {
    "id": "f0f",
    "name": "f0f",
    "x": -25.307,
    "y": -16.491,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.005585,
      "w": 0.99998
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 5,
      "unknownStockCount": 47,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40255f889d41539d6ee",
        "height": 0.17044,
        "facings": [
          {
            "id": "ab03d69ba903ee0e732c6b05",
            "leftCorner": {
              "x": -25.308,
              "y": -16.536,
              "z": 0.139
            },
            "rightCorner": {
              "x": -25.24,
              "y": -16.537,
              "z": 0.139
            },
            "gtin": "7622202257209",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "37475282763da6f31084b651",
            "leftCorner": {
              "x": -25.24,
              "y": -16.537,
              "z": 0.139
            },
            "rightCorner": {
              "x": -25.156,
              "y": -16.538,
              "z": 0.139
            },
            "gtin": "7622202257148",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "eee5d138632f944426c307fe",
            "leftCorner": {
              "x": -25.156,
              "y": -16.538,
              "z": 0.139
            },
            "rightCorner": {
              "x": -25.061,
              "y": -16.539,
              "z": 0.139
            },
            "gtin": "7622210277503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "2523cddfc777be48813f1cb8",
            "leftCorner": {
              "x": -25.061,
              "y": -16.539,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.959,
              "y": -16.54,
              "z": 0.139
            },
            "gtin": "7622300134532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "69afaed760a187f405004c43",
            "leftCorner": {
              "x": -24.959,
              "y": -16.54,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.852,
              "y": -16.541,
              "z": 0.139
            },
            "gtin": "7622210690876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "715824283a435e45a88a5741",
            "leftCorner": {
              "x": -24.852,
              "y": -16.541,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.743,
              "y": -16.542,
              "z": 0.139
            },
            "gtin": "7622210653215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f448b6eddef133ce81f112a2",
            "leftCorner": {
              "x": -24.743,
              "y": -16.542,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.625,
              "y": -16.544,
              "z": 0.139
            },
            "gtin": "7622210690845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9021bf681eb175d270f45509",
            "leftCorner": {
              "x": -24.625,
              "y": -16.544,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.498,
              "y": -16.545,
              "z": 0.139
            },
            "gtin": "7622202295164",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9cd922fa740f4e6a5312b754",
            "leftCorner": {
              "x": -24.498,
              "y": -16.545,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.35,
              "y": -16.547,
              "z": 0.139
            },
            "gtin": "7622210820310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "7504c6654849b70b3ccb8323",
            "leftCorner": {
              "x": -24.35,
              "y": -16.547,
              "z": 0.139
            },
            "rightCorner": {
              "x": -24.065,
              "y": -16.55,
              "z": 0.139
            },
            "gtin": "7622202257520",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6eb",
        "height": 0.40674,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65fe",
            "leftCorner": {
              "x": -25.307,
              "y": -16.485,
              "z": 0.333
            },
            "rightCorner": {
              "x": -24.994,
              "y": -16.489,
              "z": 0.333
            },
            "gtin": "4025700001450",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6600",
            "leftCorner": {
              "x": -24.994,
              "y": -16.457,
              "z": 0.333
            },
            "rightCorner": {
              "x": -24.795,
              "y": -16.459,
              "z": 0.333
            },
            "gtin": "7622300291785",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6601",
            "leftCorner": {
              "x": -24.795,
              "y": -16.451,
              "z": 0.333
            },
            "rightCorner": {
              "x": -24.552,
              "y": -16.454,
              "z": 0.333
            },
            "gtin": "7622400719066",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6602",
            "leftCorner": {
              "x": -24.552,
              "y": -16.44,
              "z": 0.333
            },
            "rightCorner": {
              "x": -24.374,
              "y": -16.442,
              "z": 0.333
            },
            "gtin": "7622210349675",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6603",
            "leftCorner": {
              "x": -24.375,
              "y": -16.43,
              "z": 0.333
            },
            "rightCorner": {
              "x": -24.088,
              "y": -16.434,
              "z": 0.333
            },
            "gtin": "7622202257520",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6604",
            "leftCorner": {
              "x": -24.089,
              "y": -16.418,
              "z": 0.333
            },
            "rightCorner": {
              "x": -23.822,
              "y": -16.42,
              "z": 0.333
            },
            "gtin": "4008400204222",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6ea",
        "height": 0.63078,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65c6",
            "leftCorner": {
              "x": -25.307,
              "y": -16.48,
              "z": 0.516
            },
            "rightCorner": {
              "x": -25.012,
              "y": -16.484,
              "z": 0.516
            },
            "gtin": "7622300617820",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "55aee025a22523773fd1c1ff",
            "leftCorner": {
              "x": -24.381,
              "y": -16.49,
              "z": 0.516
            },
            "rightCorner": {
              "x": -24.232,
              "y": -16.492,
              "z": 0.516
            },
            "gtin": "7622210820310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65c8",
            "leftCorner": {
              "x": -25.011,
              "y": -16.467,
              "z": 0.516
            },
            "rightCorner": {
              "x": -24.812,
              "y": -16.469,
              "z": 0.516
            },
            "gtin": "7622201120931",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65c9",
            "leftCorner": {
              "x": -24.812,
              "y": -16.46,
              "z": 0.516
            },
            "rightCorner": {
              "x": -24.606,
              "y": -16.462,
              "z": 0.516
            },
            "gtin": "7622210826251",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65ca",
            "leftCorner": {
              "x": -24.606,
              "y": -16.448,
              "z": 0.516
            },
            "rightCorner": {
              "x": -24.434,
              "y": -16.45,
              "z": 0.516
            },
            "gtin": "7622210007476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65cb",
            "leftCorner": {
              "x": -24.434,
              "y": -16.439,
              "z": 0.516
            },
            "rightCorner": {
              "x": -24.38,
              "y": -16.439,
              "z": 0.516
            },
            "gtin": "7622210007469",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65cd",
            "leftCorner": {
              "x": -24.224,
              "y": -16.434,
              "z": 0.516
            },
            "rightCorner": {
              "x": -23.875,
              "y": -16.439,
              "z": 0.516
            },
            "gtin": "7622210820310",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6ed",
        "height": 0.82939,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d661c",
            "leftCorner": {
              "x": -25.307,
              "y": -16.485,
              "z": 0.679
            },
            "rightCorner": {
              "x": -24.992,
              "y": -16.489,
              "z": 0.679
            },
            "gtin": "7622202257506",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d661e",
            "leftCorner": {
              "x": -24.991,
              "y": -16.465,
              "z": 0.679
            },
            "rightCorner": {
              "x": -24.793,
              "y": -16.467,
              "z": 0.679
            },
            "gtin": "7622202265648",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d661f",
            "leftCorner": {
              "x": -24.793,
              "y": -16.459,
              "z": 0.679
            },
            "rightCorner": {
              "x": -24.565,
              "y": -16.462,
              "z": 0.679
            },
            "gtin": "7622202257803",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6620",
            "leftCorner": {
              "x": -24.565,
              "y": -16.446,
              "z": 0.679
            },
            "rightCorner": {
              "x": -24.38,
              "y": -16.448,
              "z": 0.679
            },
            "gtin": "7622210055439",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6621",
            "leftCorner": {
              "x": -24.38,
              "y": -16.437,
              "z": 0.679
            },
            "rightCorner": {
              "x": -24.178,
              "y": -16.44,
              "z": 0.679
            },
            "gtin": "7622300185015",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6622",
            "leftCorner": {
              "x": -24.179,
              "y": -16.429,
              "z": 0.679
            },
            "rightCorner": {
              "x": -24.063,
              "y": -16.429,
              "z": 0.679
            },
            "gtin": "7622202257209",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6e8",
        "height": 1.0819,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6610",
            "leftCorner": {
              "x": -25.307,
              "y": -16.493,
              "z": 0.885
            },
            "rightCorner": {
              "x": -24.97,
              "y": -16.497,
              "z": 0.885
            },
            "gtin": "7622202257124",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6612",
            "leftCorner": {
              "x": -24.97,
              "y": -16.465,
              "z": 0.885
            },
            "rightCorner": {
              "x": -24.77,
              "y": -16.467,
              "z": 0.885
            },
            "gtin": "7622201813598",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6613",
            "leftCorner": {
              "x": -24.769,
              "y": -16.46,
              "z": 0.885
            },
            "rightCorner": {
              "x": -24.539,
              "y": -16.462,
              "z": 0.885
            },
            "gtin": "7622201753009",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6614",
            "leftCorner": {
              "x": -24.538,
              "y": -16.443,
              "z": 0.885
            },
            "rightCorner": {
              "x": -24.349,
              "y": -16.445,
              "z": 0.885
            },
            "gtin": "7622202257599",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6615",
            "leftCorner": {
              "x": -24.348,
              "y": -16.436,
              "z": 0.885
            },
            "rightCorner": {
              "x": -24.154,
              "y": -16.438,
              "z": 0.885
            },
            "gtin": "7622202257421",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6616",
            "leftCorner": {
              "x": -24.154,
              "y": -16.425,
              "z": 0.885
            },
            "rightCorner": {
              "x": -24.059,
              "y": -16.426,
              "z": 0.885
            },
            "gtin": "7622202257148",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6e9",
        "height": 1.3703,
        "facings": [
          {
            "id": "68d8e50ee1820c81800d871f",
            "leftCorner": {
              "x": -25.307,
              "y": -16.503,
              "z": 1.121
            },
            "rightCorner": {
              "x": -25.111,
              "y": -16.505,
              "z": 1.121
            },
            "gtin": "7622202287688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8720",
            "leftCorner": {
              "x": -25.111,
              "y": -16.505,
              "z": 1.121
            },
            "rightCorner": {
              "x": -24.915,
              "y": -16.507,
              "z": 1.121
            },
            "gtin": "7622202287688",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8722",
            "leftCorner": {
              "x": -24.914,
              "y": -16.477,
              "z": 1.121
            },
            "rightCorner": {
              "x": -24.708,
              "y": -16.479,
              "z": 1.121
            },
            "gtin": "7622202287657",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8723",
            "leftCorner": {
              "x": -24.708,
              "y": -16.469,
              "z": 1.121
            },
            "rightCorner": {
              "x": -24.608,
              "y": -16.471,
              "z": 1.121
            },
            "gtin": "7622202254369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8724",
            "leftCorner": {
              "x": -24.608,
              "y": -16.471,
              "z": 1.121
            },
            "rightCorner": {
              "x": -24.508,
              "y": -16.472,
              "z": 1.121
            },
            "gtin": "7622202254369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8725",
            "leftCorner": {
              "x": -24.508,
              "y": -16.472,
              "z": 1.121
            },
            "rightCorner": {
              "x": -24.408,
              "y": -16.473,
              "z": 1.121
            },
            "gtin": "7622202254369",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8726",
            "leftCorner": {
              "x": -24.408,
              "y": -16.452,
              "z": 1.121
            },
            "rightCorner": {
              "x": -24.219,
              "y": -16.454,
              "z": 1.121
            },
            "gtin": "7622202296239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ee1820c81800d8721",
            "leftCorner": {
              "x": -24.219,
              "y": -16.447,
              "z": 1.121
            },
            "rightCorner": {
              "x": -24.056,
              "y": -16.448,
              "z": 1.121
            },
            "gtin": "7622202295164",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40255f889d41539d6ec",
        "height": 1.6577,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65d9",
            "leftCorner": {
              "x": -25.307,
              "y": -16.487,
              "z": 1.356
            },
            "rightCorner": {
              "x": -25.009,
              "y": -16.491,
              "z": 1.356
            },
            "gtin": "7622210690883",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65db",
            "leftCorner": {
              "x": -25.008,
              "y": -16.468,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.904,
              "y": -16.47,
              "z": 1.356
            },
            "gtin": "7622210690876",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65dc",
            "leftCorner": {
              "x": -24.904,
              "y": -16.466,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.715,
              "y": -16.468,
              "z": 1.356
            },
            "gtin": "7622201638948",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65dd",
            "leftCorner": {
              "x": -24.715,
              "y": -16.459,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.605,
              "y": -16.46,
              "z": 1.356
            },
            "gtin": "7622210690845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65de",
            "leftCorner": {
              "x": -24.605,
              "y": -16.45,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.406,
              "y": -16.453,
              "z": 1.356
            },
            "gtin": "7622210609830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65df",
            "leftCorner": {
              "x": -24.406,
              "y": -16.438,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.303,
              "y": -16.439,
              "z": 1.356
            },
            "gtin": "7622300134532",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65e0",
            "leftCorner": {
              "x": -24.303,
              "y": -16.437,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.184,
              "y": -16.438,
              "z": 1.356
            },
            "gtin": "7622210653215",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65e1",
            "leftCorner": {
              "x": -24.185,
              "y": -16.431,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.097,
              "y": -16.432,
              "z": 1.356
            },
            "gtin": "7622210277503",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65e2",
            "leftCorner": {
              "x": -24.097,
              "y": -16.425,
              "z": 1.356
            },
            "rightCorner": {
              "x": -24.049,
              "y": -16.425,
              "z": 1.356
            },
            "gtin": "7622200009084",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],

    "rightNeighborShelfId": "f11"
  },
  {
    "id": "f11",
    "name": "f11",
    "x": -24.059,
    "y": -16.508,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 5,
      "unknownStockCount": 59,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1a2",
        "height": 0.17185,
        "facings": [
          {
            "id": "67e1bfda8157b998300bf36c",
            "leftCorner": {
              "x": -24.059,
              "y": -16.604,
              "z": 0.141
            },
            "rightCorner": {
              "x": -23.847,
              "y": -16.604,
              "z": 0.141
            },
            "gtin": "6514230002122",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c4bcb7a5f5bb7662180c4f7b",
            "leftCorner": {
              "x": -23.847,
              "y": -16.604,
              "z": 0.141
            },
            "rightCorner": {
              "x": -23.758,
              "y": -16.604,
              "z": 0.141
            },
            "gtin": "4000417101006",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "ed3ceb1370e52781112c70ac",
            "leftCorner": {
              "x": -23.758,
              "y": -16.604,
              "z": 0.141
            },
            "rightCorner": {
              "x": -23.667,
              "y": -16.604,
              "z": 0.141
            },
            "gtin": "4000417106100",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9e54cd49d8622bd3041a5009",
            "leftCorner": {
              "x": -23.667,
              "y": -16.604,
              "z": 0.141
            },
            "rightCorner": {
              "x": -23.567,
              "y": -16.604,
              "z": 0.141
            },
            "gtin": "4000417622211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "539dd0a64b16370820a58a1d",
            "leftCorner": {
              "x": -23.567,
              "y": -16.604,
              "z": 0.141
            },
            "rightCorner": {
              "x": -23.466,
              "y": -16.604,
              "z": 0.141
            },
            "gtin": "4000417602510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4ad16f9d2ab4bd2c08176898",
            "leftCorner": {
              "x": -23.466,
              "y": -16.604,
              "z": 0.141
            },
            "rightCorner": {
              "x": -23.364,
              "y": -16.604,
              "z": 0.141
            },
            "gtin": "4000417670717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "5cf0e70c52f599907648a9c3",
            "leftCorner": {
              "x": -23.364,
              "y": -16.604,
              "z": 0.141
            },
            "rightCorner": {
              "x": -23.256,
              "y": -16.604,
              "z": 0.141
            },
            "gtin": "4000417629814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "6272ad5a0b8d2abc23e2363d",
            "leftCorner": {
              "x": -23.256,
              "y": -16.604,
              "z": 0.141
            },
            "rightCorner": {
              "x": -23.146,
              "y": -16.604,
              "z": 0.141
            },
            "gtin": "4000417670311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fe0083dd319ba42e411a5fd2",
            "leftCorner": {
              "x": -23.146,
              "y": -16.604,
              "z": 0.141
            },
            "rightCorner": {
              "x": -23.036,
              "y": -16.604,
              "z": 0.141
            },
            "gtin": "4000417670212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "9e7e72c60889cb37de5fb73a",
            "leftCorner": {
              "x": -23.036,
              "y": -16.604,
              "z": 0.141
            },
            "rightCorner": {
              "x": -22.818,
              "y": -16.604,
              "z": 0.141
            },
            "gtin": "4000417628312",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d19e",
        "height": 0.40861,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6605",
            "leftCorner": {
              "x": -23.824,
              "y": -16.511,
              "z": 0.334
            },
            "rightCorner": {
              "x": -23.61,
              "y": -16.512,
              "z": 0.334
            },
            "gtin": "8000500111581",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0e80100b61bd0612e27a181e",
            "leftCorner": {
              "x": -24.059,
              "y": -16.549,
              "z": 0.334
            },
            "rightCorner": {
              "x": -23.963,
              "y": -16.549,
              "z": 0.334
            },
            "gtin": "40084527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "359b960b9106c4f79274c312",
            "leftCorner": {
              "x": -23.963,
              "y": -16.549,
              "z": 0.334
            },
            "rightCorner": {
              "x": -23.867,
              "y": -16.549,
              "z": 0.334
            },
            "gtin": "40084527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6606",
            "leftCorner": {
              "x": -23.61,
              "y": -16.509,
              "z": 0.334
            },
            "rightCorner": {
              "x": -23.267,
              "y": -16.509,
              "z": 0.334
            },
            "gtin": "4008400208527",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6607",
            "leftCorner": {
              "x": -23.267,
              "y": -16.504,
              "z": 0.334
            },
            "rightCorner": {
              "x": -22.909,
              "y": -16.505,
              "z": 0.334
            },
            "gtin": "40084244",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6608",
            "leftCorner": {
              "x": -22.91,
              "y": -16.296,
              "z": 0.334
            },
            "rightCorner": {
              "x": -22.784,
              "y": -16.295,
              "z": 0.334
            },
            "gtin": "40084527",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d19c",
        "height": 0.63008,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65ce",
            "leftCorner": {
              "x": -23.878,
              "y": -16.517,
              "z": 0.516
            },
            "rightCorner": {
              "x": -23.454,
              "y": -16.517,
              "z": 0.516
            },
            "gtin": "7310510001804",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "70cdf872ece8d40fe0db424a",
            "leftCorner": {
              "x": -24.06,
              "y": -16.57,
              "z": 0.516
            },
            "rightCorner": {
              "x": -23.994,
              "y": -16.57,
              "z": 0.516
            },
            "gtin": "4014400916744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bfd77cecb7d35dd2f5513f46",
            "leftCorner": {
              "x": -23.994,
              "y": -16.57,
              "z": 0.516
            },
            "rightCorner": {
              "x": -23.928,
              "y": -16.57,
              "z": 0.516
            },
            "gtin": "4014400916744",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65cf",
            "leftCorner": {
              "x": -23.454,
              "y": -16.513,
              "z": 0.516
            },
            "rightCorner": {
              "x": -23.252,
              "y": -16.513,
              "z": 0.516
            },
            "gtin": "7622201727352",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65d0",
            "leftCorner": {
              "x": -23.252,
              "y": -16.542,
              "z": 0.516
            },
            "rightCorner": {
              "x": -23.047,
              "y": -16.542,
              "z": 0.516
            },
            "gtin": "4014400914245",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65d1",
            "leftCorner": {
              "x": -23.047,
              "y": -16.544,
              "z": 0.516
            },
            "rightCorner": {
              "x": -22.882,
              "y": -16.545,
              "z": 0.516
            },
            "gtin": "4014400914269",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65d2",
            "leftCorner": {
              "x": -22.882,
              "y": -16.508,
              "z": 0.516
            },
            "rightCorner": {
              "x": -22.707,
              "y": -16.508,
              "z": 0.516
            },
            "gtin": "4014400916744",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1a0",
        "height": 0.83301,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6623",
            "leftCorner": {
              "x": -24.065,
              "y": -16.518,
              "z": 0.682
            },
            "rightCorner": {
              "x": -23.963,
              "y": -16.518,
              "z": 0.682
            },
            "gtin": "4000417601810",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6624",
            "leftCorner": {
              "x": -23.963,
              "y": -16.527,
              "z": 0.682
            },
            "rightCorner": {
              "x": -23.811,
              "y": -16.527,
              "z": 0.682
            },
            "gtin": "4000417602114",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6625",
            "leftCorner": {
              "x": -23.812,
              "y": -16.519,
              "z": 0.682
            },
            "rightCorner": {
              "x": -23.695,
              "y": -16.519,
              "z": 0.682
            },
            "gtin": "4000417602015",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d6626",
            "leftCorner": {
              "x": -23.695,
              "y": -16.52,
              "z": 0.682
            },
            "rightCorner": {
              "x": -23.586,
              "y": -16.52,
              "z": 0.682
            },
            "gtin": "4000417602510",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6627",
            "leftCorner": {
              "x": -23.586,
              "y": -16.518,
              "z": 0.682
            },
            "rightCorner": {
              "x": -23.469,
              "y": -16.518,
              "z": 0.682
            },
            "gtin": "4000417602817",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6628",
            "leftCorner": {
              "x": -23.469,
              "y": -16.514,
              "z": 0.682
            },
            "rightCorner": {
              "x": -23.362,
              "y": -16.514,
              "z": 0.682
            },
            "gtin": "4000417629814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6629",
            "leftCorner": {
              "x": -23.363,
              "y": -16.51,
              "z": 0.682
            },
            "rightCorner": {
              "x": -23.168,
              "y": -16.51,
              "z": 0.682
            },
            "gtin": "4000417602619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d661d",
            "leftCorner": {
              "x": -23.168,
              "y": -16.511,
              "z": 0.682
            },
            "rightCorner": {
              "x": -22.809,
              "y": -16.511,
              "z": 0.682
            },
            "gtin": "4000417113207",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d19f",
        "height": 1.0878,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6617",
            "leftCorner": {
              "x": -24.061,
              "y": -16.522,
              "z": 0.89
            },
            "rightCorner": {
              "x": -23.71,
              "y": -16.522,
              "z": 0.89
            },
            "gtin": "4000417622013",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6618",
            "leftCorner": {
              "x": -23.71,
              "y": -16.523,
              "z": 0.89
            },
            "rightCorner": {
              "x": -23.597,
              "y": -16.523,
              "z": 0.89
            },
            "gtin": "4000417601117",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6619",
            "leftCorner": {
              "x": -23.597,
              "y": -16.519,
              "z": 0.89
            },
            "rightCorner": {
              "x": -23.487,
              "y": -16.519,
              "z": 0.89
            },
            "gtin": "4000417629210",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d661a",
            "leftCorner": {
              "x": -23.487,
              "y": -16.514,
              "z": 0.89
            },
            "rightCorner": {
              "x": -23.272,
              "y": -16.514,
              "z": 0.89
            },
            "gtin": "4000417601513",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d661b",
            "leftCorner": {
              "x": -23.272,
              "y": -16.506,
              "z": 0.89
            },
            "rightCorner": {
              "x": -23.018,
              "y": -16.507,
              "z": 0.89
            },
            "gtin": "4000417602718",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6611",
            "leftCorner": {
              "x": -23.018,
              "y": -16.508,
              "z": 0.89
            },
            "rightCorner": {
              "x": -22.809,
              "y": -16.508,
              "z": 0.89
            },
            "gtin": "7614500010013",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d19a",
        "height": 1.2625,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65b2",
            "leftCorner": {
              "x": -24.059,
              "y": -16.552,
              "z": 1.033
            },
            "rightCorner": {
              "x": -23.92,
              "y": -16.551,
              "z": 1.033
            },
            "gtin": "4000417601216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65b4",
            "leftCorner": {
              "x": -23.92,
              "y": -16.515,
              "z": 1.033
            },
            "rightCorner": {
              "x": -23.806,
              "y": -16.516,
              "z": 1.033
            },
            "gtin": "4000417602213",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65b5",
            "leftCorner": {
              "x": -23.806,
              "y": -16.518,
              "z": 1.033
            },
            "rightCorner": {
              "x": -23.7,
              "y": -16.518,
              "z": 1.033
            },
            "gtin": "4000417622211",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65b6",
            "leftCorner": {
              "x": -23.7,
              "y": -16.518,
              "z": 1.033
            },
            "rightCorner": {
              "x": -23.464,
              "y": -16.517,
              "z": 1.033
            },
            "gtin": "4000417601919",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65b7",
            "leftCorner": {
              "x": -23.464,
              "y": -16.509,
              "z": 1.033
            },
            "rightCorner": {
              "x": -23.251,
              "y": -16.509,
              "z": 1.033
            },
            "gtin": "4000417628312",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65b8",
            "leftCorner": {
              "x": -23.251,
              "y": -16.512,
              "z": 1.033
            },
            "rightCorner": {
              "x": -23.121,
              "y": -16.512,
              "z": 1.033
            },
            "gtin": "4000417108104",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65b9",
            "leftCorner": {
              "x": -23.121,
              "y": -16.508,
              "z": 1.033
            },
            "rightCorner": {
              "x": -23.007,
              "y": -16.507,
              "z": 1.033
            },
            "gtin": "4000417610515",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65ba",
            "leftCorner": {
              "x": -23.007,
              "y": -16.506,
              "z": 1.033
            },
            "rightCorner": {
              "x": -22.899,
              "y": -16.506,
              "z": 1.033
            },
            "gtin": "4000417107107",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65b3",
            "leftCorner": {
              "x": -22.899,
              "y": -16.506,
              "z": 1.033
            },
            "rightCorner": {
              "x": -22.809,
              "y": -16.506,
              "z": 1.033
            },
            "gtin": "4000417106100",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d19b",
        "height": 1.4639,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65bb",
            "leftCorner": {
              "x": -24.06,
              "y": -16.558,
              "z": 1.198
            },
            "rightCorner": {
              "x": -23.93,
              "y": -16.558,
              "z": 1.198
            },
            "gtin": "4000417670014",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65bd",
            "leftCorner": {
              "x": -23.929,
              "y": -16.523,
              "z": 1.198
            },
            "rightCorner": {
              "x": -23.811,
              "y": -16.524,
              "z": 1.198
            },
            "gtin": "4000417670113",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65be",
            "leftCorner": {
              "x": -23.811,
              "y": -16.529,
              "z": 1.198
            },
            "rightCorner": {
              "x": -23.696,
              "y": -16.529,
              "z": 1.198
            },
            "gtin": "4000417670212",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65bf",
            "leftCorner": {
              "x": -23.696,
              "y": -16.525,
              "z": 1.198
            },
            "rightCorner": {
              "x": -23.58,
              "y": -16.525,
              "z": 1.198
            },
            "gtin": "4000417670311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65c0",
            "leftCorner": {
              "x": -23.58,
              "y": -16.522,
              "z": 1.198
            },
            "rightCorner": {
              "x": -23.457,
              "y": -16.522,
              "z": 1.198
            },
            "gtin": "4000417670410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65c1",
            "leftCorner": {
              "x": -23.457,
              "y": -16.518,
              "z": 1.198
            },
            "rightCorner": {
              "x": -23.351,
              "y": -16.518,
              "z": 1.198
            },
            "gtin": "4000417670717",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65c2",
            "leftCorner": {
              "x": -23.351,
              "y": -16.513,
              "z": 1.198
            },
            "rightCorner": {
              "x": -23.241,
              "y": -16.513,
              "z": 1.198
            },
            "gtin": "4000417670915",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65c3",
            "leftCorner": {
              "x": -23.241,
              "y": -16.512,
              "z": 1.198
            },
            "rightCorner": {
              "x": -23.12,
              "y": -16.513,
              "z": 1.198
            },
            "gtin": "4000417693310",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65c4",
            "leftCorner": {
              "x": -23.12,
              "y": -16.515,
              "z": 1.198
            },
            "rightCorner": {
              "x": -23.006,
              "y": -16.515,
              "z": 1.198
            },
            "gtin": "4000417693815",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d65c5",
            "leftCorner": {
              "x": -23.006,
              "y": -16.514,
              "z": 1.198
            },
            "rightCorner": {
              "x": -22.9,
              "y": -16.514,
              "z": 1.198
            },
            "gtin": "4000417102003",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d65bc",
            "leftCorner": {
              "x": -22.9,
              "y": -16.514,
              "z": 1.198
            },
            "rightCorner": {
              "x": -22.809,
              "y": -16.514,
              "z": 1.198
            },
            "gtin": "4000417101006",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d19d",
        "height": 1.6639,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65e3",
            "leftCorner": {
              "x": -24.051,
              "y": -16.519,
              "z": 1.361
            },
            "rightCorner": {
              "x": -23.879,
              "y": -16.519,
              "z": 1.361
            },
            "gtin": "4000417663016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65e4",
            "leftCorner": {
              "x": -23.879,
              "y": -16.525,
              "z": 1.361
            },
            "rightCorner": {
              "x": -23.723,
              "y": -16.525,
              "z": 1.361
            },
            "gtin": "4000417663115",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65e5",
            "leftCorner": {
              "x": -23.723,
              "y": -16.517,
              "z": 1.361
            },
            "rightCorner": {
              "x": -23.368,
              "y": -16.518,
              "z": 1.361
            },
            "gtin": "4000417663214",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65e6",
            "leftCorner": {
              "x": -23.368,
              "y": -16.508,
              "z": 1.361
            },
            "rightCorner": {
              "x": -23.251,
              "y": -16.508,
              "z": 1.361
            },
            "gtin": "4000417660312",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d65e7",
            "leftCorner": {
              "x": -23.251,
              "y": -16.511,
              "z": 1.361
            },
            "rightCorner": {
              "x": -23.079,
              "y": -16.512,
              "z": 1.361
            },
            "gtin": "4000417660114",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d65e8",
            "leftCorner": {
              "x": -23.079,
              "y": -16.508,
              "z": 1.361
            },
            "rightCorner": {
              "x": -22.928,
              "y": -16.508,
              "z": 1.361
            },
            "gtin": "4000417660619",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65e9",
            "leftCorner": {
              "x": -22.928,
              "y": -16.509,
              "z": 1.361
            },
            "rightCorner": {
              "x": -22.764,
              "y": -16.508,
              "z": 1.361
            },
            "gtin": "4000417661319",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f0f",
    "rightNeighborShelfId": "f13"
  },
  {
    "id": "f13",
    "name": "f13",
    "x": -22.809,
    "y": -16.508,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 60,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1a9",
        "height": 0.15765,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6660",
            "leftCorner": {
              "x": -22.809,
              "y": -16.62,
              "z": 0.129
            },
            "rightCorner": {
              "x": -22.579,
              "y": -16.621,
              "z": 0.129
            },
            "gtin": "4306188377498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6662",
            "leftCorner": {
              "x": -22.58,
              "y": -16.582,
              "z": 0.129
            },
            "rightCorner": {
              "x": -22.374,
              "y": -16.582,
              "z": 0.129
            },
            "gtin": "4001743016170",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6663",
            "leftCorner": {
              "x": -22.373,
              "y": -16.579,
              "z": 0.129
            },
            "rightCorner": {
              "x": -22.145,
              "y": -16.579,
              "z": 0.129
            },
            "gtin": "4012362999669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6664",
            "leftCorner": {
              "x": -22.145,
              "y": -16.58,
              "z": 0.129
            },
            "rightCorner": {
              "x": -21.991,
              "y": -16.579,
              "z": 0.129
            },
            "gtin": "4021700903053",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6665",
            "leftCorner": {
              "x": -21.991,
              "y": -16.578,
              "z": 0.129
            },
            "rightCorner": {
              "x": -21.847,
              "y": -16.579,
              "z": 0.129
            },
            "gtin": "4020486035002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6666",
            "leftCorner": {
              "x": -21.847,
              "y": -16.586,
              "z": 0.129
            },
            "rightCorner": {
              "x": -21.689,
              "y": -16.586,
              "z": 0.129
            },
            "gtin": "4030387760637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6661",
            "leftCorner": {
              "x": -21.689,
              "y": -16.583,
              "z": 0.129
            },
            "rightCorner": {
              "x": -21.559,
              "y": -16.583,
              "z": 0.129
            },
            "gtin": "4030387760644",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1a7",
        "height": 0.40861,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6609",
            "leftCorner": {
              "x": -22.784,
              "y": -16.512,
              "z": 0.334
            },
            "rightCorner": {
              "x": -22.606,
              "y": -16.512,
              "z": 0.334
            },
            "gtin": "4001743760189",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d660a",
            "leftCorner": {
              "x": -22.606,
              "y": -16.514,
              "z": 0.334
            },
            "rightCorner": {
              "x": -22.471,
              "y": -16.513,
              "z": 0.334
            },
            "gtin": "4001743760196",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d660b",
            "leftCorner": {
              "x": -22.471,
              "y": -16.515,
              "z": 0.334
            },
            "rightCorner": {
              "x": -22.312,
              "y": -16.515,
              "z": 0.334
            },
            "gtin": "4001743760219",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d660c",
            "leftCorner": {
              "x": -22.312,
              "y": -16.513,
              "z": 0.334
            },
            "rightCorner": {
              "x": -22.157,
              "y": -16.513,
              "z": 0.334
            },
            "gtin": "4001743760257",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d660d",
            "leftCorner": {
              "x": -22.157,
              "y": -16.51,
              "z": 0.334
            },
            "rightCorner": {
              "x": -21.991,
              "y": -16.51,
              "z": 0.334
            },
            "gtin": "4001743760240",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d660e",
            "leftCorner": {
              "x": -21.992,
              "y": -16.515,
              "z": 0.334
            },
            "rightCorner": {
              "x": -21.842,
              "y": -16.515,
              "z": 0.334
            },
            "gtin": "4001743760202",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d660f",
            "leftCorner": {
              "x": -21.842,
              "y": -16.516,
              "z": 0.334
            },
            "rightCorner": {
              "x": -21.737,
              "y": -16.516,
              "z": 0.334
            },
            "gtin": "4001743760226",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65ff",
            "leftCorner": {
              "x": -21.736,
              "y": -16.521,
              "z": 0.334
            },
            "rightCorner": {
              "x": -21.56,
              "y": -16.521,
              "z": 0.334
            },
            "gtin": "4001743760271",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1a4",
        "height": 0.63185,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65d3",
            "leftCorner": {
              "x": -22.706,
              "y": -16.517,
              "z": 0.517
            },
            "rightCorner": {
              "x": -22.545,
              "y": -16.517,
              "z": 0.517
            },
            "gtin": "4000607151002",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65d4",
            "leftCorner": {
              "x": -22.544,
              "y": -16.522,
              "z": 0.517
            },
            "rightCorner": {
              "x": -22.383,
              "y": -16.522,
              "z": 0.517
            },
            "gtin": "4000607151200",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65d5",
            "leftCorner": {
              "x": -22.383,
              "y": -16.518,
              "z": 0.517
            },
            "rightCorner": {
              "x": -22.203,
              "y": -16.518,
              "z": 0.517
            },
            "gtin": "4000607162602",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65d6",
            "leftCorner": {
              "x": -22.203,
              "y": -16.519,
              "z": 0.517
            },
            "rightCorner": {
              "x": -22.028,
              "y": -16.519,
              "z": 0.517
            },
            "gtin": "4000607151101",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65d7",
            "leftCorner": {
              "x": -22.028,
              "y": -16.521,
              "z": 0.517
            },
            "rightCorner": {
              "x": -21.866,
              "y": -16.521,
              "z": 0.517
            },
            "gtin": "4000607777905",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65d8",
            "leftCorner": {
              "x": -21.866,
              "y": -16.522,
              "z": 0.517
            },
            "rightCorner": {
              "x": -21.71,
              "y": -16.522,
              "z": 0.517
            },
            "gtin": "4000607831706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65c7",
            "leftCorner": {
              "x": -21.71,
              "y": -16.525,
              "z": 0.517
            },
            "rightCorner": {
              "x": -21.559,
              "y": -16.525,
              "z": 0.517
            },
            "gtin": "4000607164002",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1a8",
        "height": 0.85847,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6656",
            "leftCorner": {
              "x": -22.809,
              "y": -16.555,
              "z": 0.702
            },
            "rightCorner": {
              "x": -22.588,
              "y": -16.556,
              "z": 0.702
            },
            "gtin": "4000607055102",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6658",
            "leftCorner": {
              "x": -22.587,
              "y": -16.517,
              "z": 0.702
            },
            "rightCorner": {
              "x": -22.502,
              "y": -16.516,
              "z": 0.702
            },
            "gtin": "8000300431216",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6659",
            "leftCorner": {
              "x": -22.502,
              "y": -16.515,
              "z": 0.702
            },
            "rightCorner": {
              "x": -22.443,
              "y": -16.515,
              "z": 0.702
            },
            "gtin": "7610815012858",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d665a",
            "leftCorner": {
              "x": -22.443,
              "y": -16.515,
              "z": 0.702
            },
            "rightCorner": {
              "x": -22.193,
              "y": -16.515,
              "z": 0.702
            },
            "gtin": "4000607730900",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d665b",
            "leftCorner": {
              "x": -22.193,
              "y": -16.515,
              "z": 0.702
            },
            "rightCorner": {
              "x": -22.118,
              "y": -16.516,
              "z": 0.702
            },
            "gtin": "4000607164408",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d665c",
            "leftCorner": {
              "x": -22.118,
              "y": -16.519,
              "z": 0.702
            },
            "rightCorner": {
              "x": -22.034,
              "y": -16.519,
              "z": 0.702
            },
            "gtin": "4000607849404",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d665d",
            "leftCorner": {
              "x": -22.034,
              "y": -16.514,
              "z": 0.702
            },
            "rightCorner": {
              "x": -21.953,
              "y": -16.514,
              "z": 0.702
            },
            "gtin": "4000607849800",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d665e",
            "leftCorner": {
              "x": -21.953,
              "y": -16.515,
              "z": 0.702
            },
            "rightCorner": {
              "x": -21.809,
              "y": -16.515,
              "z": 0.702
            },
            "gtin": "4000607850011",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d665f",
            "leftCorner": {
              "x": -21.809,
              "y": -16.519,
              "z": 0.702
            },
            "rightCorner": {
              "x": -21.653,
              "y": -16.519,
              "z": 0.702
            },
            "gtin": "4000607167706",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6657",
            "leftCorner": {
              "x": -21.653,
              "y": -16.519,
              "z": 0.702
            },
            "rightCorner": {
              "x": -21.56,
              "y": -16.52,
              "z": 0.702
            },
            "gtin": "4000607029004",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1a6",
        "height": 1.111,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d664f",
            "leftCorner": {
              "x": -22.809,
              "y": -16.555,
              "z": 0.909
            },
            "rightCorner": {
              "x": -22.504,
              "y": -16.555,
              "z": 0.909
            },
            "gtin": "8720701145719",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6651",
            "leftCorner": {
              "x": -22.504,
              "y": -16.513,
              "z": 0.909
            },
            "rightCorner": {
              "x": -22.392,
              "y": -16.513,
              "z": 0.909
            },
            "gtin": "8720701145733",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6652",
            "leftCorner": {
              "x": -22.392,
              "y": -16.513,
              "z": 0.909
            },
            "rightCorner": {
              "x": -22.226,
              "y": -16.512,
              "z": 0.909
            },
            "gtin": "8720701145757",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6653",
            "leftCorner": {
              "x": -22.226,
              "y": -16.515,
              "z": 0.909
            },
            "rightCorner": {
              "x": -22.038,
              "y": -16.515,
              "z": 0.909
            },
            "gtin": "8717677338054",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6654",
            "leftCorner": {
              "x": -22.038,
              "y": -16.517,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.876,
              "y": -16.516,
              "z": 0.909
            },
            "gtin": "8717677338016",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6655",
            "leftCorner": {
              "x": -21.876,
              "y": -16.52,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.699,
              "y": -16.521,
              "z": 0.909
            },
            "gtin": "8717677339143",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6650",
            "leftCorner": {
              "x": -21.699,
              "y": -16.521,
              "z": 0.909
            },
            "rightCorner": {
              "x": -21.56,
              "y": -16.52,
              "z": 0.909
            },
            "gtin": "8717677337996",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1a3",
        "height": 1.3654,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6637",
            "leftCorner": {
              "x": -22.809,
              "y": -16.56,
              "z": 1.117
            },
            "rightCorner": {
              "x": -22.687,
              "y": -16.56,
              "z": 1.117
            },
            "gtin": "4001757016425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6639",
            "leftCorner": {
              "x": -22.687,
              "y": -16.518,
              "z": 1.117
            },
            "rightCorner": {
              "x": -22.576,
              "y": -16.518,
              "z": 1.117
            },
            "gtin": "4001757016418",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d663a",
            "leftCorner": {
              "x": -22.576,
              "y": -16.516,
              "z": 1.117
            },
            "rightCorner": {
              "x": -22.478,
              "y": -16.516,
              "z": 1.117
            },
            "gtin": "4001757016432",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d663b",
            "leftCorner": {
              "x": -22.478,
              "y": -16.515,
              "z": 1.117
            },
            "rightCorner": {
              "x": -22.391,
              "y": -16.515,
              "z": 1.117
            },
            "gtin": "4044889004403",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d663c",
            "leftCorner": {
              "x": -22.391,
              "y": -16.518,
              "z": 1.117
            },
            "rightCorner": {
              "x": -22.302,
              "y": -16.518,
              "z": 1.117
            },
            "gtin": "4044889004410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d663d",
            "leftCorner": {
              "x": -22.302,
              "y": -16.517,
              "z": 1.117
            },
            "rightCorner": {
              "x": -22.217,
              "y": -16.518,
              "z": 1.117
            },
            "gtin": "4044889000498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d663e",
            "leftCorner": {
              "x": -22.216,
              "y": -16.521,
              "z": 1.117
            },
            "rightCorner": {
              "x": -22.114,
              "y": -16.521,
              "z": 1.117
            },
            "gtin": "4044889002669",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d663f",
            "leftCorner": {
              "x": -22.114,
              "y": -16.52,
              "z": 1.117
            },
            "rightCorner": {
              "x": -22.028,
              "y": -16.52,
              "z": 1.117
            }
          },
          {
            "id": "68d8e50ae1820c81800d6640",
            "leftCorner": {
              "x": -22.028,
              "y": -16.522,
              "z": 1.117
            },
            "rightCorner": {
              "x": -21.929,
              "y": -16.522,
              "z": 1.117
            }
          },
          {
            "id": "68d8e50ae1820c81800d6641",
            "leftCorner": {
              "x": -21.929,
              "y": -16.52,
              "z": 1.117
            },
            "rightCorner": {
              "x": -21.754,
              "y": -16.52,
              "z": 1.117
            },
            "gtin": "6942836724061",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6642",
            "leftCorner": {
              "x": -21.753,
              "y": -16.523,
              "z": 1.117
            },
            "rightCorner": {
              "x": -21.666,
              "y": -16.523,
              "z": 1.117
            },
            "gtin": "6942836723392",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6643",
            "leftCorner": {
              "x": -21.666,
              "y": -16.524,
              "z": 1.117
            },
            "rightCorner": {
              "x": -21.534,
              "y": -16.524,
              "z": 1.117
            },
            "gtin": "6942836724047",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1a5",
        "height": 1.6633,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65ea",
            "leftCorner": {
              "x": -22.764,
              "y": -16.51,
              "z": 1.361
            },
            "rightCorner": {
              "x": -22.691,
              "y": -16.51,
              "z": 1.361
            },
            "gtin": "8000500359556",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65eb",
            "leftCorner": {
              "x": -22.691,
              "y": -16.509,
              "z": 1.361
            },
            "rightCorner": {
              "x": -22.618,
              "y": -16.508,
              "z": 1.361
            },
            "gtin": "8000500359488",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65ec",
            "leftCorner": {
              "x": -22.618,
              "y": -16.509,
              "z": 1.361
            },
            "rightCorner": {
              "x": -22.532,
              "y": -16.51,
              "z": 1.361
            },
            "gtin": "8000500359815",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65ed",
            "leftCorner": {
              "x": -22.532,
              "y": -16.511,
              "z": 1.361
            },
            "rightCorner": {
              "x": -22.442,
              "y": -16.51,
              "z": 1.361
            },
            "gtin": "8000500359884",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65ee",
            "leftCorner": {
              "x": -22.442,
              "y": -16.51,
              "z": 1.361
            },
            "rightCorner": {
              "x": -22.36,
              "y": -16.509,
              "z": 1.361
            },
            "gtin": "3046920021807",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65ef",
            "leftCorner": {
              "x": -22.36,
              "y": -16.508,
              "z": 1.361
            },
            "rightCorner": {
              "x": -22.192,
              "y": -16.509,
              "z": 1.361
            },
            "gtin": "3046920021814",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65f0",
            "leftCorner": {
              "x": -22.192,
              "y": -16.508,
              "z": 1.361
            },
            "rightCorner": {
              "x": -22.024,
              "y": -16.508,
              "z": 1.361
            },
            "gtin": "3046920021838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65f1",
            "leftCorner": {
              "x": -22.024,
              "y": -16.508,
              "z": 1.361
            },
            "rightCorner": {
              "x": -21.869,
              "y": -16.509,
              "z": 1.361
            },
            "gtin": "3046920021845",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65f2",
            "leftCorner": {
              "x": -21.869,
              "y": -16.513,
              "z": 1.361
            },
            "rightCorner": {
              "x": -21.715,
              "y": -16.513,
              "z": 1.361
            },
            "gtin": "3046920021555",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65f3",
            "leftCorner": {
              "x": -21.716,
              "y": -16.517,
              "z": 1.361
            },
            "rightCorner": {
              "x": -21.649,
              "y": -16.517,
              "z": 1.361
            },
            "gtin": "3046920021821",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65f4",
            "leftCorner": {
              "x": -21.649,
              "y": -16.517,
              "z": 1.361
            },
            "rightCorner": {
              "x": -21.364,
              "y": -16.516,
              "z": 1.361
            },
            "gtin": "8000500273449",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f11",
    "rightNeighborShelfId": "f14"
  },
  {
    "id": "f14",
    "name": "f14",
    "x": -21.559,
    "y": -16.508,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 2,
      "unknownStockCount": 34,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1af",
        "height": 0.17384,
        "facings": [
          {
            "id": "7ffdb8af1f6b7cb9034b52e0",
            "leftCorner": {
              "x": -21.559,
              "y": -16.575,
              "z": 0.142
            },
            "rightCorner": {
              "x": -21.453,
              "y": -16.575,
              "z": 0.142
            },
            "gtin": "5900951311390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f0026b32cf00b14dcacc05e3",
            "leftCorner": {
              "x": -21.453,
              "y": -16.575,
              "z": 0.142
            },
            "rightCorner": {
              "x": -21.314,
              "y": -16.575,
              "z": 0.142
            },
            "gtin": "4008400308425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "00075fde8ff95c21b8cb9181",
            "leftCorner": {
              "x": -21.314,
              "y": -16.575,
              "z": 0.142
            },
            "rightCorner": {
              "x": -21.157,
              "y": -16.575,
              "z": 0.142
            },
            "gtin": "5900951310560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c4662f11947e4252c8051eaa",
            "leftCorner": {
              "x": -21.157,
              "y": -16.575,
              "z": 0.142
            },
            "rightCorner": {
              "x": -20.996,
              "y": -16.575,
              "z": 0.142
            },
            "gtin": "4306188049746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "8953b2f4dfa7fba0835898b4",
            "leftCorner": {
              "x": -20.996,
              "y": -16.575,
              "z": 0.142
            },
            "rightCorner": {
              "x": -20.82,
              "y": -16.575,
              "z": 0.142
            },
            "gtin": "8000500423523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "56778b56a258ae148db1e2b5",
            "leftCorner": {
              "x": -20.82,
              "y": -16.575,
              "z": 0.142
            },
            "rightCorner": {
              "x": -20.63,
              "y": -16.575,
              "z": 0.142
            },
            "gtin": "4014400929065",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cd990fac61ff6f57fc744df3",
            "leftCorner": {
              "x": -20.63,
              "y": -16.575,
              "z": 0.142
            },
            "rightCorner": {
              "x": -20.435,
              "y": -16.575,
              "z": 0.142
            },
            "gtin": "4014400929379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "77052fb71e9deb3de2f01b93",
            "leftCorner": {
              "x": -20.435,
              "y": -16.575,
              "z": 0.142
            },
            "rightCorner": {
              "x": -20.329,
              "y": -16.575,
              "z": 0.142
            },
            "gtin": "5900951311390",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1ae",
        "height": 0.45816,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d667d",
            "leftCorner": {
              "x": -21.559,
              "y": -16.556,
              "z": 0.375
            },
            "rightCorner": {
              "x": -21.241,
              "y": -16.556,
              "z": 0.375
            },
            "gtin": "4014400929010",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d667f",
            "leftCorner": {
              "x": -21.241,
              "y": -16.52,
              "z": 0.375
            },
            "rightCorner": {
              "x": -20.988,
              "y": -16.52,
              "z": 0.375
            },
            "gtin": "4014400928952",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6680",
            "leftCorner": {
              "x": -20.988,
              "y": -16.517,
              "z": 0.375
            },
            "rightCorner": {
              "x": -20.674,
              "y": -16.518,
              "z": 0.375
            },
            "gtin": "4014400928907",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6681",
            "leftCorner": {
              "x": -20.674,
              "y": -16.515,
              "z": 0.375
            },
            "rightCorner": {
              "x": -20.489,
              "y": -16.515,
              "z": 0.375
            },
            "gtin": "4014400929379",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d667e",
            "leftCorner": {
              "x": -20.489,
              "y": -16.512,
              "z": 0.375
            },
            "rightCorner": {
              "x": -20.309,
              "y": -16.512,
              "z": 0.375
            },
            "gtin": "4014400929065",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1ab",
        "height": 0.75649,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6667",
            "leftCorner": {
              "x": -21.559,
              "y": -16.553,
              "z": 0.619
            },
            "rightCorner": {
              "x": -21.396,
              "y": -16.553,
              "z": 0.619
            },
            "gtin": "4306188049746",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6669",
            "leftCorner": {
              "x": -21.396,
              "y": -16.522,
              "z": 0.619
            },
            "rightCorner": {
              "x": -21.121,
              "y": -16.522,
              "z": 0.619
            },
            "gtin": "8000500272442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d666a",
            "leftCorner": {
              "x": -21.121,
              "y": -16.517,
              "z": 0.619
            },
            "rightCorner": {
              "x": -20.765,
              "y": -16.518,
              "z": 0.619
            },
            "gtin": "4008400352329",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d666b",
            "leftCorner": {
              "x": -20.765,
              "y": -16.513,
              "z": 0.619
            },
            "rightCorner": {
              "x": -20.553,
              "y": -16.513,
              "z": 0.619
            },
            "gtin": "5000159560498",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d666c",
            "leftCorner": {
              "x": -20.553,
              "y": -16.513,
              "z": 0.619
            },
            "rightCorner": {
              "x": -20.463,
              "y": -16.513,
              "z": 0.619
            },
            "gtin": "5900951311390",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d666d",
            "leftCorner": {
              "x": -20.463,
              "y": -16.513,
              "z": 0.619
            },
            "rightCorner": {
              "x": -20.301,
              "y": -16.513,
              "z": 0.619
            },
            "gtin": "5900951310560",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d666e",
            "leftCorner": {
              "x": -20.301,
              "y": -16.52,
              "z": 0.619
            },
            "rightCorner": {
              "x": -20.214,
              "y": -16.52,
              "z": 0.619
            },
            "gtin": "5000159556897",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1ad",
        "height": 1.0598,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6673",
            "leftCorner": {
              "x": -21.559,
              "y": -16.556,
              "z": 0.867
            },
            "rightCorner": {
              "x": -21.262,
              "y": -16.556,
              "z": 0.867
            },
            "gtin": "4008400671529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6675",
            "leftCorner": {
              "x": -21.262,
              "y": -16.517,
              "z": 0.867
            },
            "rightCorner": {
              "x": -20.972,
              "y": -16.517,
              "z": 0.867
            },
            "gtin": "8000500276679",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6676",
            "leftCorner": {
              "x": -20.972,
              "y": -16.516,
              "z": 0.867
            },
            "rightCorner": {
              "x": -20.709,
              "y": -16.517,
              "z": 0.867
            },
            "gtin": "4008400301020",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6677",
            "leftCorner": {
              "x": -20.709,
              "y": -16.51,
              "z": 0.867
            },
            "rightCorner": {
              "x": -20.411,
              "y": -16.509,
              "z": 0.867
            },
            "gtin": "4008400302829",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6678",
            "leftCorner": {
              "x": -20.411,
              "y": -16.517,
              "z": 0.867
            },
            "rightCorner": {
              "x": -20.253,
              "y": -16.517,
              "z": 0.867
            },
            "gtin": "8593893769687",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1aa",
        "height": 1.3654,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6644",
            "leftCorner": {
              "x": -21.533,
              "y": -16.523,
              "z": 1.117
            },
            "rightCorner": {
              "x": -21.253,
              "y": -16.522,
              "z": 1.117
            },
            "gtin": "4008400322728",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6645",
            "leftCorner": {
              "x": -21.253,
              "y": -16.521,
              "z": 1.117
            },
            "rightCorner": {
              "x": -20.953,
              "y": -16.52,
              "z": 1.117
            },
            "gtin": "8000500273470",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6646",
            "leftCorner": {
              "x": -20.953,
              "y": -16.515,
              "z": 1.117
            },
            "rightCorner": {
              "x": -20.637,
              "y": -16.516,
              "z": 1.117
            },
            "gtin": "4008400221021",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6647",
            "leftCorner": {
              "x": -20.637,
              "y": -16.513,
              "z": 1.117
            },
            "rightCorner": {
              "x": -20.411,
              "y": -16.513,
              "z": 1.117
            },
            "gtin": "4008400221823",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6648",
            "leftCorner": {
              "x": -20.411,
              "y": -16.519,
              "z": 1.117
            },
            "rightCorner": {
              "x": -20.255,
              "y": -16.519,
              "z": 1.117
            },
            "gtin": "7613287109514",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1ac",
        "height": 1.6641,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65f5",
            "leftCorner": {
              "x": -21.364,
              "y": -16.518,
              "z": 1.362
            },
            "rightCorner": {
              "x": -21.069,
              "y": -16.518,
              "z": 1.362
            },
            "gtin": "8000500241707",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "3e629a42dba26d5219e34aeb",
            "leftCorner": {
              "x": -21.559,
              "y": -16.553,
              "z": 1.362
            },
            "rightCorner": {
              "x": -21.368,
              "y": -16.553,
              "z": 1.362
            },
            "gtin": "8000500423530",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d65f6",
            "leftCorner": {
              "x": -21.069,
              "y": -16.516,
              "z": 1.362
            },
            "rightCorner": {
              "x": -20.88,
              "y": -16.516,
              "z": 1.362
            },
            "gtin": "8000500423530",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65f7",
            "leftCorner": {
              "x": -20.88,
              "y": -16.513,
              "z": 1.362
            },
            "rightCorner": {
              "x": -20.705,
              "y": -16.513,
              "z": 1.362
            },
            "gtin": "8000500423523",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65f8",
            "leftCorner": {
              "x": -20.705,
              "y": -16.511,
              "z": 1.362
            },
            "rightCorner": {
              "x": -20.448,
              "y": -16.511,
              "z": 1.362
            },
            "gtin": "8000500384794",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65f9",
            "leftCorner": {
              "x": -20.448,
              "y": -16.511,
              "z": 1.362
            },
            "rightCorner": {
              "x": -20.192,
              "y": -16.511,
              "z": 1.362
            },
            "gtin": "4008400308425",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f13",
    "rightNeighborShelfId": "f15"
  },
  {
    "id": "f15",
    "name": "f15",
    "x": -20.309,
    "y": -16.508,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": 0.0,
      "w": 1.0
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 37,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d1b5",
        "height": 0.17362,
        "facings": [
          {
            "id": "6388ceabba02b528c4092a3f",
            "leftCorner": {
              "x": -20.309,
              "y": -16.588,
              "z": 0.142
            },
            "rightCorner": {
              "x": -20.14,
              "y": -16.588,
              "z": 0.142
            },
            "gtin": "5000159556897",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dcb96350cf9ade1685b337a9",
            "leftCorner": {
              "x": -20.14,
              "y": -16.588,
              "z": 0.142
            },
            "rightCorner": {
              "x": -19.926,
              "y": -16.588,
              "z": 0.142
            },
            "gtin": "7310511802509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "700211cb3e06652f6f603b22",
            "leftCorner": {
              "x": -19.926,
              "y": -16.588,
              "z": 0.142
            },
            "rightCorner": {
              "x": -19.874,
              "y": -16.588,
              "z": 0.142
            },
            "gtin": "4021700800529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "dd188d1b7ace18f7ab471d53",
            "leftCorner": {
              "x": -19.874,
              "y": -16.588,
              "z": 0.142
            },
            "rightCorner": {
              "x": -19.76,
              "y": -16.588,
              "z": 0.142
            },
            "gtin": "5000159550963",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "12074fadc9e76aeb308fd50b",
            "leftCorner": {
              "x": -19.76,
              "y": -16.588,
              "z": 0.142
            },
            "rightCorner": {
              "x": -19.626,
              "y": -16.588,
              "z": 0.142
            },
            "gtin": "8445291425156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c42bf120eb1579859f8e57c3",
            "leftCorner": {
              "x": -19.626,
              "y": -16.588,
              "z": 0.142
            },
            "rightCorner": {
              "x": -19.485,
              "y": -16.588,
              "z": 0.142
            },
            "gtin": "7622210696861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "d921e11c7738f1cba6ca7798",
            "leftCorner": {
              "x": -19.485,
              "y": -16.588,
              "z": 0.142
            },
            "rightCorner": {
              "x": -19.34,
              "y": -16.588,
              "z": 0.142
            },
            "gtin": "4306188045311",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "b29fcb87c00490d4f9da92e7",
            "leftCorner": {
              "x": -19.34,
              "y": -16.588,
              "z": 0.142
            },
            "rightCorner": {
              "x": -19.063,
              "y": -16.588,
              "z": 0.142
            },
            "gtin": "7622201405731",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1b2",
        "height": 0.47254,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d668a",
            "leftCorner": {
              "x": -20.309,
              "y": -16.561,
              "z": 0.387
            },
            "rightCorner": {
              "x": -19.826,
              "y": -16.56,
              "z": 0.387
            },
            "gtin": "4014400931280",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d668c",
            "leftCorner": {
              "x": -19.826,
              "y": -16.523,
              "z": 0.387
            },
            "rightCorner": {
              "x": -19.58,
              "y": -16.523,
              "z": 0.387
            },
            "gtin": "4014400929355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d668d",
            "leftCorner": {
              "x": -19.58,
              "y": -16.517,
              "z": 0.387
            },
            "rightCorner": {
              "x": -19.289,
              "y": -16.517,
              "z": 0.387
            },
            "gtin": "5000159556637",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d668b",
            "leftCorner": {
              "x": -19.289,
              "y": -16.51,
              "z": 0.387
            },
            "rightCorner": {
              "x": -19.059,
              "y": -16.511,
              "z": 0.387
            },
            "gtin": "5000159550963",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1b4",
        "height": 0.75651,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d666f",
            "leftCorner": {
              "x": -20.214,
              "y": -16.522,
              "z": 0.619
            },
            "rightCorner": {
              "x": -19.969,
              "y": -16.522,
              "z": 0.619
            },
            "gtin": "5000159557344",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6670",
            "leftCorner": {
              "x": -19.969,
              "y": -16.518,
              "z": 0.619
            },
            "rightCorner": {
              "x": -19.714,
              "y": -16.518,
              "z": 0.619
            },
            "gtin": "5000159557702",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6671",
            "leftCorner": {
              "x": -19.714,
              "y": -16.511,
              "z": 0.619
            },
            "rightCorner": {
              "x": -19.477,
              "y": -16.511,
              "z": 0.619
            },
            "gtin": "5000159472852",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6672",
            "leftCorner": {
              "x": -19.477,
              "y": -16.506,
              "z": 0.619
            },
            "rightCorner": {
              "x": -19.243,
              "y": -16.506,
              "z": 0.619
            },
            "gtin": "5000159474856",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6668",
            "leftCorner": {
              "x": -19.243,
              "y": -16.498,
              "z": 0.619
            },
            "rightCorner": {
              "x": -19.059,
              "y": -16.499,
              "z": 0.619
            },
            "gtin": "5000159474818",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "f8a4a5b8b626ae6902640830",
            "leftCorner": {
              "x": -20.309,
              "y": -16.549,
              "z": 0.619
            },
            "rightCorner": {
              "x": -20.247,
              "y": -16.549,
              "z": 0.619
            },
            "gtin": "5000159474818",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1b3",
        "height": 1.0609,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6679",
            "leftCorner": {
              "x": -20.253,
              "y": -16.515,
              "z": 0.868
            },
            "rightCorner": {
              "x": -19.964,
              "y": -16.515,
              "z": 0.868
            },
            "gtin": "7613287202833",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d667a",
            "leftCorner": {
              "x": -19.964,
              "y": -16.519,
              "z": 0.868
            },
            "rightCorner": {
              "x": -19.769,
              "y": -16.518,
              "z": 0.868
            },
            "gtin": "3800020411957",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d667b",
            "leftCorner": {
              "x": -19.769,
              "y": -16.514,
              "z": 0.868
            },
            "rightCorner": {
              "x": -19.627,
              "y": -16.515,
              "z": 0.868
            },
            "gtin": "7613038427782",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d667c",
            "leftCorner": {
              "x": -19.627,
              "y": -16.509,
              "z": 0.868
            },
            "rightCorner": {
              "x": -19.316,
              "y": -16.508,
              "z": 0.868
            },
            "gtin": "4306188045151",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6674",
            "leftCorner": {
              "x": -19.316,
              "y": -16.501,
              "z": 0.868
            },
            "rightCorner": {
              "x": -19.059,
              "y": -16.502,
              "z": 0.868
            },
            "gtin": "4306188045311",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1b1",
        "height": 1.3676,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6649",
            "leftCorner": {
              "x": -20.255,
              "y": -16.525,
              "z": 1.119
            },
            "rightCorner": {
              "x": -20.164,
              "y": -16.524,
              "z": 1.119
            },
            "gtin": "7613287109552",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d664a",
            "leftCorner": {
              "x": -20.164,
              "y": -16.524,
              "z": 1.119
            },
            "rightCorner": {
              "x": -20.036,
              "y": -16.525,
              "z": 1.119
            },
            "gtin": "8445291425156",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d664b",
            "leftCorner": {
              "x": -20.036,
              "y": -16.524,
              "z": 1.119
            },
            "rightCorner": {
              "x": -19.79,
              "y": -16.524,
              "z": 1.119
            },
            "gtin": "7622201790509",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d664d",
            "leftCorner": {
              "x": -19.607,
              "y": -16.512,
              "z": 1.119
            },
            "rightCorner": {
              "x": -19.367,
              "y": -16.513,
              "z": 1.119
            },
            "gtin": "7622201405731",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d664e",
            "leftCorner": {
              "x": -19.367,
              "y": -16.509,
              "z": 1.119
            },
            "rightCorner": {
              "x": -19.217,
              "y": -16.508,
              "z": 1.119
            },
            "gtin": "7622210696861",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6638",
            "leftCorner": {
              "x": -19.217,
              "y": -16.509,
              "z": 1.119
            },
            "rightCorner": {
              "x": -19.059,
              "y": -16.51,
              "z": 1.119
            },
            "gtin": "4021700800529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "32d305d76d7f73525a35b840",
            "leftCorner": {
              "x": -20.309,
              "y": -16.553,
              "z": 1.119
            },
            "rightCorner": {
              "x": -20.256,
              "y": -16.553,
              "z": 1.119
            },
            "gtin": "4021700800529",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "bdcfc137ae089dbba9ee3373",
            "leftCorner": {
              "x": -19.79,
              "y": -16.553,
              "z": 1.119
            },
            "rightCorner": {
              "x": -19.623,
              "y": -16.553,
              "z": 1.119
            },
            "gtin": "7613287109552",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d1b0",
        "height": 1.6634,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65fa",
            "leftCorner": {
              "x": -20.192,
              "y": -16.522,
              "z": 1.361
            },
            "rightCorner": {
              "x": -19.997,
              "y": -16.522,
              "z": 1.361
            },
            "gtin": "8000500331798",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65fb",
            "leftCorner": {
              "x": -19.997,
              "y": -16.521,
              "z": 1.361
            },
            "rightCorner": {
              "x": -19.748,
              "y": -16.521,
              "z": 1.361
            },
            "gtin": "4017100282812",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65fc",
            "leftCorner": {
              "x": -19.748,
              "y": -16.512,
              "z": 1.361
            },
            "rightCorner": {
              "x": -19.505,
              "y": -16.512,
              "z": 1.361
            },
            "gtin": "4017100254819",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65fd",
            "leftCorner": {
              "x": -19.505,
              "y": -16.506,
              "z": 1.361
            },
            "rightCorner": {
              "x": -19.292,
              "y": -16.506,
              "z": 1.361
            },
            "gtin": "4017100284410",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65da",
            "leftCorner": {
              "x": -19.292,
              "y": -16.5,
              "z": 1.361
            },
            "rightCorner": {
              "x": -19.059,
              "y": -16.501,
              "z": 1.361
            },
            "gtin": "4017100406218",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "25fc51c46e0089fda89b7807",
            "leftCorner": {
              "x": -20.309,
              "y": -16.552,
              "z": 1.361
            },
            "rightCorner": {
              "x": -20.201,
              "y": -16.552,
              "z": 1.361
            },
            "gtin": "4017100406218",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ],
    "leftNeighborShelfId": "f14"
  },
  {
    "id": "f16",
    "name": "f16",
    "x": -25.919,
    "y": -12.45,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70104,
      "w": 0.71312
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 0,
      "unknownStockCount": 41,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d3ff55f889d41539d165",
        "height": 0.25641,
        "facings": [
          {
            "id": "c31d4341ffc1507aeeb59da3",
            "leftCorner": {
              "x": -25.983,
              "y": -12.452,
              "z": 0.21
            },
            "rightCorner": {
              "x": -25.982,
              "y": -12.519,
              "z": 0.21
            }
          },
          {
            "id": "683841a323620c9151f1d328",
            "leftCorner": {
              "x": -25.982,
              "y": -12.519,
              "z": 0.21
            },
            "rightCorner": {
              "x": -25.98,
              "y": -12.622,
              "z": 0.21
            },
            "gtin": "8000500418482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "154d2642d5438f5fb35d7b2d",
            "leftCorner": {
              "x": -25.98,
              "y": -12.622,
              "z": 0.21
            },
            "rightCorner": {
              "x": -25.979,
              "y": -12.687,
              "z": 0.21
            },
            "gtin": "4260688123231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "0a3be0511f206491240c4a9b",
            "leftCorner": {
              "x": -25.979,
              "y": -12.687,
              "z": 0.21
            },
            "rightCorner": {
              "x": -25.978,
              "y": -12.755,
              "z": 0.21
            }
          },
          {
            "id": "edbf452a1ab4fb7ff3d1f3b2",
            "leftCorner": {
              "x": -25.978,
              "y": -12.755,
              "z": 0.21
            },
            "rightCorner": {
              "x": -25.976,
              "y": -12.856,
              "z": 0.21
            },
            "gtin": "4260688126355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "c0a7206b045227cf893cd79d",
            "leftCorner": {
              "x": -25.976,
              "y": -12.856,
              "z": 0.21
            },
            "rightCorner": {
              "x": -25.974,
              "y": -12.959,
              "z": 0.21
            },
            "gtin": "8000500418482",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "4e11bbb7e4d6ff4d703fd15c",
            "leftCorner": {
              "x": -25.974,
              "y": -12.959,
              "z": 0.21
            },
            "rightCorner": {
              "x": -25.973,
              "y": -13.065,
              "z": 0.21
            },
            "gtin": "8718868063700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "953d079612c038231d53a68f",
            "leftCorner": {
              "x": -25.973,
              "y": -13.065,
              "z": 0.21
            },
            "rightCorner": {
              "x": -25.971,
              "y": -13.171,
              "z": 0.21
            },
            "gtin": "8721042680587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "cc61ab0bacbc0bff6f1667ca",
            "leftCorner": {
              "x": -25.971,
              "y": -13.171,
              "z": 0.21
            },
            "rightCorner": {
              "x": -25.969,
              "y": -13.282,
              "z": 0.21
            },
            "gtin": "4260688123248",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "fd921f7c5a4abc21da51e13a",
            "leftCorner": {
              "x": -25.969,
              "y": -13.282,
              "z": 0.21
            },
            "rightCorner": {
              "x": -25.967,
              "y": -13.398,
              "z": 0.21
            },
            "gtin": "8902433003134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "edd04776ad05421825312534",
            "leftCorner": {
              "x": -25.967,
              "y": -13.398,
              "z": 0.21
            },
            "rightCorner": {
              "x": -25.962,
              "y": -13.687,
              "z": 0.21
            },
            "gtin": "781231003250",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d15f",
        "height": 0.50586,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6403",
            "leftCorner": {
              "x": -25.987,
              "y": -12.452,
              "z": 0.414
            },
            "rightCorner": {
              "x": -25.985,
              "y": -12.589,
              "z": 0.414
            },
            "gtin": "8718868063700",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6405",
            "leftCorner": {
              "x": -25.945,
              "y": -12.588,
              "z": 0.414
            },
            "rightCorner": {
              "x": -25.943,
              "y": -12.733,
              "z": 0.414
            },
            "gtin": "8718868063601",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6406",
            "leftCorner": {
              "x": -25.94,
              "y": -12.733,
              "z": 0.414
            },
            "rightCorner": {
              "x": -25.935,
              "y": -13.013,
              "z": 0.414
            },
            "gtin": "8718868063830",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6407",
            "leftCorner": {
              "x": -25.936,
              "y": -13.013,
              "z": 0.414
            },
            "rightCorner": {
              "x": -25.934,
              "y": -13.137,
              "z": 0.414
            },
            "gtin": "8934680033442",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6408",
            "leftCorner": {
              "x": -25.935,
              "y": -13.137,
              "z": 0.414
            },
            "rightCorner": {
              "x": -25.933,
              "y": -13.28,
              "z": 0.414
            },
            "gtin": "8934680033428",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6409",
            "leftCorner": {
              "x": -25.932,
              "y": -13.28,
              "z": 0.414
            },
            "rightCorner": {
              "x": -25.93,
              "y": -13.435,
              "z": 0.414
            }
          },
          {
            "id": "68d8e50ae1820c81800d640a",
            "leftCorner": {
              "x": -25.943,
              "y": -13.435,
              "z": 0.414
            },
            "rightCorner": {
              "x": -25.94,
              "y": -13.576,
              "z": 0.414
            }
          },
          {
            "id": "68d8e50ae1820c81800d6404",
            "leftCorner": {
              "x": -25.934,
              "y": -13.576,
              "z": 0.414
            },
            "rightCorner": {
              "x": -25.933,
              "y": -13.701,
              "z": 0.414
            }
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d161",
        "height": 0.78293,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6413",
            "leftCorner": {
              "x": -25.983,
              "y": -12.452,
              "z": 0.641
            },
            "rightCorner": {
              "x": -25.981,
              "y": -12.505,
              "z": 0.641
            },
            "gtin": "4260688126645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6414",
            "leftCorner": {
              "x": -25.981,
              "y": -12.505,
              "z": 0.641
            },
            "rightCorner": {
              "x": -25.98,
              "y": -12.558,
              "z": 0.641
            },
            "gtin": "4260688126645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6415",
            "leftCorner": {
              "x": -25.98,
              "y": -12.558,
              "z": 0.641
            },
            "rightCorner": {
              "x": -25.98,
              "y": -12.611,
              "z": 0.641
            },
            "gtin": "4260688126645",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6417",
            "leftCorner": {
              "x": -25.933,
              "y": -12.61,
              "z": 0.641
            },
            "rightCorner": {
              "x": -25.93,
              "y": -12.765,
              "z": 0.641
            },
            "gtin": "4260688124627",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6418",
            "leftCorner": {
              "x": -25.934,
              "y": -12.765,
              "z": 0.641
            },
            "rightCorner": {
              "x": -25.931,
              "y": -12.929,
              "z": 0.641
            },
            "gtin": "4260688124603",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6419",
            "leftCorner": {
              "x": -25.933,
              "y": -12.929,
              "z": 0.641
            },
            "rightCorner": {
              "x": -25.93,
              "y": -13.089,
              "z": 0.641
            }
          },
          {
            "id": "68d8e50ae1820c81800d641a",
            "leftCorner": {
              "x": -25.931,
              "y": -13.089,
              "z": 0.641
            },
            "rightCorner": {
              "x": -25.929,
              "y": -13.238,
              "z": 0.641
            },
            "gtin": "8721042680372",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d641b",
            "leftCorner": {
              "x": -25.931,
              "y": -13.238,
              "z": 0.641
            },
            "rightCorner": {
              "x": -25.928,
              "y": -13.372,
              "z": 0.641
            },
            "gtin": "8721042680587",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d641c",
            "leftCorner": {
              "x": -25.937,
              "y": -13.372,
              "z": 0.641
            },
            "rightCorner": {
              "x": -25.934,
              "y": -13.552,
              "z": 0.641
            },
            "gtin": "8721042680433",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6416",
            "leftCorner": {
              "x": -25.939,
              "y": -13.552,
              "z": 0.641
            },
            "rightCorner": {
              "x": -25.937,
              "y": -13.701,
              "z": 0.641
            },
            "gtin": "8721042680648",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d160",
        "height": 1.0857,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d640b",
            "leftCorner": {
              "x": -25.983,
              "y": -12.452,
              "z": 0.888
            },
            "rightCorner": {
              "x": -25.98,
              "y": -12.639,
              "z": 0.888
            }
          },
          {
            "id": "68d8e50ae1820c81800d640d",
            "leftCorner": {
              "x": -25.934,
              "y": -12.638,
              "z": 0.888
            },
            "rightCorner": {
              "x": -25.931,
              "y": -12.815,
              "z": 0.888
            },
            "gtin": "4260688122661",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d640e",
            "leftCorner": {
              "x": -25.934,
              "y": -12.815,
              "z": 0.888
            },
            "rightCorner": {
              "x": -25.932,
              "y": -12.959,
              "z": 0.888
            },
            "gtin": "4260688125174",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d640f",
            "leftCorner": {
              "x": -25.932,
              "y": -12.959,
              "z": 0.888
            },
            "rightCorner": {
              "x": -25.929,
              "y": -13.159,
              "z": 0.888
            },
            "gtin": "4260688122838",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6410",
            "leftCorner": {
              "x": -25.932,
              "y": -13.159,
              "z": 0.888
            },
            "rightCorner": {
              "x": -25.928,
              "y": -13.34,
              "z": 0.888
            },
            "gtin": "4260688122425",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6411",
            "leftCorner": {
              "x": -25.929,
              "y": -13.34,
              "z": 0.888
            },
            "rightCorner": {
              "x": -25.927,
              "y": -13.442,
              "z": 0.888
            },
            "gtin": "4260688123231",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6412",
            "leftCorner": {
              "x": -25.94,
              "y": -13.442,
              "z": 0.888
            },
            "rightCorner": {
              "x": -25.936,
              "y": -13.6,
              "z": 0.888
            },
            "gtin": "4260688121992",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d640c",
            "leftCorner": {
              "x": -25.936,
              "y": -13.6,
              "z": 0.888
            },
            "rightCorner": {
              "x": -25.935,
              "y": -13.701,
              "z": 0.888
            },
            "gtin": "4260688123248",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d162",
        "height": 1.3595,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d641d",
            "leftCorner": {
              "x": -25.982,
              "y": -12.452,
              "z": 1.112
            },
            "rightCorner": {
              "x": -25.978,
              "y": -12.726,
              "z": 1.112
            },
            "gtin": "4262393721801",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6420",
            "leftCorner": {
              "x": -25.937,
              "y": -12.726,
              "z": 1.112
            },
            "rightCorner": {
              "x": -25.934,
              "y": -12.862,
              "z": 1.112
            }
          },
          {
            "id": "68d8e50ae1820c81800d6421",
            "leftCorner": {
              "x": -25.932,
              "y": -12.862,
              "z": 1.112
            },
            "rightCorner": {
              "x": -25.93,
              "y": -13.005,
              "z": 1.112
            }
          },
          {
            "id": "68d8e50ae1820c81800d6422",
            "leftCorner": {
              "x": -25.934,
              "y": -13.005,
              "z": 1.112
            },
            "rightCorner": {
              "x": -25.932,
              "y": -13.115,
              "z": 1.112
            },
            "gtin": "8902433003134",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d641e",
            "leftCorner": {
              "x": -25.935,
              "y": -13.115,
              "z": 1.112
            },
            "rightCorner": {
              "x": -25.93,
              "y": -13.408,
              "z": 1.112
            },
            "gtin": "4260688124849",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d641f",
            "leftCorner": {
              "x": -25.93,
              "y": -13.408,
              "z": 1.112
            },
            "rightCorner": {
              "x": -25.926,
              "y": -13.701,
              "z": 1.112
            },
            "gtin": "4260688124849",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d164",
        "height": 1.4968,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d642a",
            "leftCorner": {
              "x": -25.611,
              "y": -13.124,
              "z": 1.225
            },
            "rightCorner": {
              "x": -25.602,
              "y": -13.695,
              "z": 1.225
            },
            "gtin": "4260688124849",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d3ff55f889d41539d163",
        "height": 1.7103,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d6423",
            "leftCorner": {
              "x": -25.985,
              "y": -12.452,
              "z": 1.399
            },
            "rightCorner": {
              "x": -25.98,
              "y": -12.752,
              "z": 1.399
            },
            "gtin": "781231003229",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6425",
            "leftCorner": {
              "x": -25.935,
              "y": -12.752,
              "z": 1.399
            },
            "rightCorner": {
              "x": -25.93,
              "y": -13.058,
              "z": 1.399
            },
            "gtin": "781231003250",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6426",
            "leftCorner": {
              "x": -25.933,
              "y": -13.058,
              "z": 1.399
            },
            "rightCorner": {
              "x": -25.931,
              "y": -13.192,
              "z": 1.399
            },
            "gtin": "4260688126348",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6427",
            "leftCorner": {
              "x": -25.934,
              "y": -13.192,
              "z": 1.399
            },
            "rightCorner": {
              "x": -25.932,
              "y": -13.292,
              "z": 1.399
            },
            "gtin": "4260688126355",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6428",
            "leftCorner": {
              "x": -25.931,
              "y": -13.292,
              "z": 1.399
            },
            "rightCorner": {
              "x": -25.928,
              "y": -13.456,
              "z": 1.399
            },
            "gtin": "4260764612239",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d6424",
            "leftCorner": {
              "x": -25.942,
              "y": -13.457,
              "z": 1.399
            },
            "rightCorner": {
              "x": -25.938,
              "y": -13.701,
              "z": 1.399
            },
            "gtin": "4260688126638",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  },
  {
    "id": "f17",
    "name": "f17",
    "x": -26.088,
    "y": -15.257,
    "width": 1.25,
    "height": 2.0,
    "depth": 0.45,
    "rotation": {
      "x": 0.0,
      "y": 0.0,
      "z": -0.70609,
      "w": 0.70812
    },
    "statistics": {
      "hasStockCount": 0,
      "noStockCount": 1,
      "unknownStockCount": 7,
      "shelfCategory": "SWEETS"
    },
    "layers": [
      {
        "id": "68d8d40055f889d41539d199",
        "height": 0.25295,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65b0",
            "leftCorner": {
              "x": -26.198,
              "y": -15.257,
              "z": 0.207
            },
            "rightCorner": {
              "x": -26.198,
              "y": -15.367,
              "z": 0.207
            },
            "gtin": "4014400937015",
            "stockLevel": "NO_STOCK"
          },
          {
            "id": "68d8e50ae1820c81800d65b1",
            "leftCorner": {
              "x": -26.158,
              "y": -15.367,
              "z": 0.207
            },
            "rightCorner": {
              "x": -26.155,
              "y": -16.508,
              "z": 0.207
            },
            "gtin": "4014400937015",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d197",
        "height": 0.64092,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65ac",
            "leftCorner": {
              "x": -26.14,
              "y": -15.257,
              "z": 0.524
            },
            "rightCorner": {
              "x": -26.136,
              "y": -16.354,
              "z": 0.524
            },
            "gtin": "4014400936438",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65ad",
            "leftCorner": {
              "x": -26.099,
              "y": -16.354,
              "z": 0.524
            },
            "rightCorner": {
              "x": -26.099,
              "y": -16.507,
              "z": 0.524
            },
            "gtin": "4014400920390",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d198",
        "height": 0.87742,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65ae",
            "leftCorner": {
              "x": -26.134,
              "y": -15.257,
              "z": 0.718
            },
            "rightCorner": {
              "x": -26.131,
              "y": -16.058,
              "z": 0.718
            },
            "gtin": "4014400936476",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65af",
            "leftCorner": {
              "x": -26.092,
              "y": -16.058,
              "z": 0.718
            },
            "rightCorner": {
              "x": -26.091,
              "y": -16.507,
              "z": 0.718
            },
            "gtin": "4014400916850",
            "stockLevel": "UNKNOWN"
          }
        ]
      },
      {
        "id": "68d8d40055f889d41539d196",
        "height": 1.2575,
        "facings": [
          {
            "id": "68d8e50ae1820c81800d65aa",
            "leftCorner": {
              "x": -26.137,
              "y": -15.257,
              "z": 1.029
            },
            "rightCorner": {
              "x": -26.136,
              "y": -15.519,
              "z": 1.029
            },
            "gtin": "4000512463665",
            "stockLevel": "UNKNOWN"
          },
          {
            "id": "68d8e50ae1820c81800d65ab",
            "leftCorner": {
              "x": -26.097,
              "y": -15.519,
              "z": 1.029
            },
            "rightCorner": {
              "x": -26.094,
              "y": -16.507,
              "z": 1.029
            },
            "gtin": "4000512463429",
            "stockLevel": "UNKNOWN"
          }
        ]
      }
    ]
  }
]
